
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("fuCaZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $772c97ac80e7a641$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");

var $VVnlL = parcelRequire("VVnlL");

var $aWB2j = parcelRequire("aWB2j");
// Yes, this is a kind of re-export, yes they're bad - however we need a separate asset to act as a "jump asset"
// to allow us to apply the `unstable_forceSkipWrappedAssets` optimisation to the route map. If it was the entry
// point of the bundle this wouldn't work, we still need a wrapped entry point.
const $772c97ac80e7a641$var$getSpaRoutesAsync = ()=>{
    return (0, $4R6GH.fg)('rollout-codegen-spa-route-map') ? (0, $aWB2j.getCodegenSpaRoutes)() : (0, $VVnlL.getSpaRoutes)();
};
var $772c97ac80e7a641$export$2e2bcd8739ae039 = $772c97ac80e7a641$var$getSpaRoutesAsync;

});
parcelRegister("VVnlL", function(module, exports) {

$parcel$export(module.exports, "getSpaRoutes", () => $ef6e862e848d08e0$export$10439de9ce871f28);

var $aNke7 = parcelRequire("aNke7");

var $Dkaoj = parcelRequire("Dkaoj");

var $fMVEG = parcelRequire("fMVEG");

var $4BdYV = parcelRequire("4BdYV");

var $laDqO = parcelRequire("laDqO");

var $2pvey = parcelRequire("2pvey");

var $lgfw1 = parcelRequire("lgfw1");

var $4x45G = parcelRequire("4x45G");

var $3rBGh = parcelRequire("3rBGh");

var $4PsEV = parcelRequire("4PsEV");

var $jWVY2 = parcelRequire("jWVY2");

var $dTwSZ = parcelRequire("dTwSZ");

var $ktEDA = parcelRequire("ktEDA");

var $caoz4 = parcelRequire("caoz4");

var $5BlCA = parcelRequire("5BlCA");

var $3Hflx = parcelRequire("3Hflx");

var $bUOZo = parcelRequire("bUOZo");

var $bC98V = parcelRequire("bC98V");

var $1mByb = parcelRequire("1mByb");

var $ew7DI = parcelRequire("ew7DI");

var $gCfQs = parcelRequire("gCfQs");

var $2UvYl = parcelRequire("2UvYl");

var $81ZCL = parcelRequire("81ZCL");

var $izUuJ = parcelRequire("izUuJ");

var $ipR0U = parcelRequire("ipR0U");

var $jovMq = parcelRequire("jovMq");

var $a4nP2 = parcelRequire("a4nP2");

var $h0ilo = parcelRequire("h0ilo");

var $k1TyW = parcelRequire("k1TyW");

var $hH7Cb = parcelRequire("hH7Cb");

var $dtLGm = parcelRequire("dtLGm");

var $f6OBR = parcelRequire("f6OBR");

var $5uMDF = parcelRequire("5uMDF");

var $3RvJ0 = parcelRequire("3RvJ0");

var $fpGzf = parcelRequire("fpGzf");

var $aVGYm = parcelRequire("aVGYm");

var $2DH60 = parcelRequire("2DH60");

var $a5XVU = parcelRequire("a5XVU");

var $lUhpq = parcelRequire("lUhpq");

var $43Rln = parcelRequire("43Rln");

var $6Z4jF = parcelRequire("6Z4jF");

var $eLT92 = parcelRequire("eLT92");

var $cgOe5 = parcelRequire("cgOe5");

var $2d9QY = parcelRequire("2d9QY");

var $jj70V = parcelRequire("jj70V");

var $4AqA1 = parcelRequire("4AqA1");

var $2FVZu = parcelRequire("2FVZu");

var $lGnoq = parcelRequire("lGnoq");

var $6cMQO = parcelRequire("6cMQO");

var $lxXtu = parcelRequire("lxXtu");

var $2l6sh = parcelRequire("2l6sh");

var $1C9Ha = parcelRequire("1C9Ha");

var $cChHY = parcelRequire("cChHY");

var $d1sI7 = parcelRequire("d1sI7");

var $gksya = parcelRequire("gksya");

var $l0UsI = parcelRequire("l0UsI");

var $bdHl5 = parcelRequire("bdHl5");

var $1oew5 = parcelRequire("1oew5");

var $5hvg3 = parcelRequire("5hvg3");

var $6oWts = parcelRequire("6oWts");

var $76RJj = parcelRequire("76RJj");

var $ikfu9 = parcelRequire("ikfu9");

var $g7fao = parcelRequire("g7fao");

var $8s6qp = parcelRequire("8s6qp");

var $qruNQ = parcelRequire("qruNQ");

var $4chTT = parcelRequire("4chTT");

var $5qx9W = parcelRequire("5qx9W");

var $5dqn2 = parcelRequire("5dqn2");

var $7gypr = parcelRequire("7gypr");

var $cwKGx = parcelRequire("cwKGx");

var $dfdSu = parcelRequire("dfdSu");

var $ieqGd = parcelRequire("ieqGd");

var $JQ5Vt = parcelRequire("JQ5Vt");

var $eOPb5 = parcelRequire("eOPb5");

var $vDjHk = parcelRequire("vDjHk");

var $jZMnM = parcelRequire("jZMnM");

var $5nA0V = parcelRequire("5nA0V");

var $bQ0RK = parcelRequire("bQ0RK");

var $7UDCM = parcelRequire("7UDCM");

var $hDCtq = parcelRequire("hDCtq");

var $9CxHM = parcelRequire("9CxHM");

var $eaKG5 = parcelRequire("eaKG5");

var $9wv3p = parcelRequire("9wv3p");

var $6DvyY = parcelRequire("6DvyY");

var $lGElM = parcelRequire("lGElM");

var $3bc6l = parcelRequire("3bc6l");

var $hHcn9 = parcelRequire("hHcn9");

var $igqAf = parcelRequire("igqAf");

var $gm7fA = parcelRequire("gm7fA");

var $gbj7F = parcelRequire("gbj7F");

var $8gEiV = parcelRequire("8gEiV");

var $dhiyM = parcelRequire("dhiyM");

var $21AP4 = parcelRequire("21AP4");

var $infHq = parcelRequire("infHq");

var $ilKWG = parcelRequire("ilKWG");

var $dUuHj = parcelRequire("dUuHj");

var $eiK9n = parcelRequire("eiK9n");

var $4KinX = parcelRequire("4KinX");

var $6IB0N = parcelRequire("6IB0N");

var $1sFpf = parcelRequire("1sFpf");

var $a2wNz = parcelRequire("a2wNz");

var $eghTD = parcelRequire("eghTD");

var $ajYJ1 = parcelRequire("ajYJ1");

var $huQRU = parcelRequire("huQRU");

var $47CVY = parcelRequire("47CVY");

var $hfeIi = parcelRequire("hfeIi");

var $hF0nU = parcelRequire("hF0nU");

var $ejDmq = parcelRequire("ejDmq");

var $9yqzH = parcelRequire("9yqzH");

var $gxVJf = parcelRequire("gxVJf");

var $c1v6Y = parcelRequire("c1v6Y");

var $bZEI9 = parcelRequire("bZEI9");

var $1EihZ = parcelRequire("1EihZ");

var $2IdR0 = parcelRequire("2IdR0");

var $cZPPs = parcelRequire("cZPPs");

var $frUin = parcelRequire("frUin");

var $difFp = parcelRequire("difFp");

var $dH2Tp = parcelRequire("dH2Tp");

var $6xRe5 = parcelRequire("6xRe5");

var $5eLaE = parcelRequire("5eLaE");

var $gnGkU = parcelRequire("gnGkU");

var $c74Xp = parcelRequire("c74Xp");

var $4Zw1h = parcelRequire("4Zw1h");

var $iLmKH = parcelRequire("iLmKH");

var $dqjth = parcelRequire("dqjth");

var $2fNbh = parcelRequire("2fNbh");

var $56moC = parcelRequire("56moC");

var $hfMX7 = parcelRequire("hfMX7");

var $1zhx7 = parcelRequire("1zhx7");

var $dxMNj = parcelRequire("dxMNj");

var $eTL4x = parcelRequire("eTL4x");

var $3av4N = parcelRequire("3av4N");

var $hwgIz = parcelRequire("hwgIz");

var $3ss0y = parcelRequire("3ss0y");

var $bNtXI = parcelRequire("bNtXI");

var $aNsRz = parcelRequire("aNsRz");

var $cmvi5 = parcelRequire("cmvi5");

var $8fgeg = parcelRequire("8fgeg");

var $f7gaE = parcelRequire("f7gaE");

var $pRrpu = parcelRequire("pRrpu");

var $cmIyb = parcelRequire("cmIyb");

var $fQyGL = parcelRequire("fQyGL");

var $ifEj3 = parcelRequire("ifEj3");

var $4CGuj = parcelRequire("4CGuj");

var $6VvYi = parcelRequire("6VvYi");

var $dSrOC = parcelRequire("dSrOC");

var $dTkCg = parcelRequire("dTkCg");

var $hs0Ni = parcelRequire("hs0Ni");

var $8m0RN = parcelRequire("8m0RN");

var $dt3ZS = parcelRequire("dt3ZS");

var $i27Sx = parcelRequire("i27Sx");

var $qjJTn = parcelRequire("qjJTn");

var $5xt55 = parcelRequire("5xt55");

var $GJOha = parcelRequire("GJOha");

var $hDU7Y = parcelRequire("hDU7Y");

var $dHqTd = parcelRequire("dHqTd");

var $9KhdI = parcelRequire("9KhdI");

var $7LUIt = parcelRequire("7LUIt");

var $3EMmS = parcelRequire("3EMmS");

var $6q1hh = parcelRequire("6q1hh");

var $q3duL = parcelRequire("q3duL");

var $4Ykyz = parcelRequire("4Ykyz");

var $dYoht = parcelRequire("dYoht");

var $75Ues = parcelRequire("75Ues");

var $4Yh3B = parcelRequire("4Yh3B");

var $4iFpq = parcelRequire("4iFpq");

var $kvJxs = parcelRequire("kvJxs");

var $kxvlX = parcelRequire("kxvlX");

var $0e4yJ = parcelRequire("0e4yJ");

var $4mhUQ = parcelRequire("4mhUQ");

var $lcAQi = parcelRequire("lcAQi");

var $68ycU = parcelRequire("68ycU");

var $4BuRo = parcelRequire("4BuRo");

var $6SWMv = parcelRequire("6SWMv");

var $jFY66 = parcelRequire("jFY66");

var $jPXYO = parcelRequire("jPXYO");

var $ktYro = parcelRequire("ktYro");

var $5H5Rm = parcelRequire("5H5Rm");

var $jAB8i = parcelRequire("jAB8i");

var $5KvQp = parcelRequire("5KvQp");

var $3Yng9 = parcelRequire("3Yng9");

var $2B61u = parcelRequire("2B61u");

var $e04XT = parcelRequire("e04XT");

var $hGFnn = parcelRequire("hGFnn");

var $iTGOF = parcelRequire("iTGOF");

var $adI0E = parcelRequire("adI0E");

var $dQtRM = parcelRequire("dQtRM");

var $iDxTp = parcelRequire("iDxTp");

var $bAN0d = parcelRequire("bAN0d");

var $cLm5J = parcelRequire("cLm5J");

var $dbAmH = parcelRequire("dbAmH");

var $4Xzif = parcelRequire("4Xzif");

var $7mf3n = parcelRequire("7mf3n");

var $jPcas = parcelRequire("jPcas");

var $k7VEf = parcelRequire("k7VEf");

var $4yINJ = parcelRequire("4yINJ");

var $bubms = parcelRequire("bubms");

var $fOrUU = parcelRequire("fOrUU");

var $g6Mf9 = parcelRequire("g6Mf9");

var $9bLSq = parcelRequire("9bLSq");

var $V3Ey7 = parcelRequire("V3Ey7");

var $01Za6 = parcelRequire("01Za6");

var $5fBQK = parcelRequire("5fBQK");

var $hxYI0 = parcelRequire("hxYI0");

var $dzSy7 = parcelRequire("dzSy7");

var $eKguf = parcelRequire("eKguf");

var $7vXQn = parcelRequire("7vXQn");

var $kCn5T = parcelRequire("kCn5T");

var $WsHyA = parcelRequire("WsHyA");

var $3GuHG = parcelRequire("3GuHG");

var $90Rrp = parcelRequire("90Rrp");

var $86qmt = parcelRequire("86qmt");

var $hxK6L = parcelRequire("hxK6L");

var $9jp5b = parcelRequire("9jp5b");

var $427L2 = parcelRequire("427L2");

var $dRexn = parcelRequire("dRexn");

var $6pwY1 = parcelRequire("6pwY1");

var $gQABM = parcelRequire("gQABM");

var $9sgxL = parcelRequire("9sgxL");

var $8wIny = parcelRequire("8wIny");

var $2krv1 = parcelRequire("2krv1");

var $alZMU = parcelRequire("alZMU");

var $6u3qv = parcelRequire("6u3qv");

var $j2SDi = parcelRequire("j2SDi");

var $e48vl = parcelRequire("e48vl");

var $jSJ1v = parcelRequire("jSJ1v");

var $fdHNd = parcelRequire("fdHNd");

var $guURi = parcelRequire("guURi");

var $6RCDC = parcelRequire("6RCDC");

var $avQ9D = parcelRequire("avQ9D");

var $f7vKZ = parcelRequire("f7vKZ");

var $k826a = parcelRequire("k826a");

var $9aEQn = parcelRequire("9aEQn");

var $gZQLD = parcelRequire("gZQLD");

var $kzcqd = parcelRequire("kzcqd");

var $lDuCa = parcelRequire("lDuCa");

var $duVOn = parcelRequire("duVOn");

var $lVyEk = parcelRequire("lVyEk");

var $h82Z7 = parcelRequire("h82Z7");

var $9qXuz = parcelRequire("9qXuz");

var $9MSQj = parcelRequire("9MSQj");

var $3HGg1 = parcelRequire("3HGg1");

var $hkNW0 = parcelRequire("hkNW0");

var $1B0QU = parcelRequire("1B0QU");

var $6HuHg = parcelRequire("6HuHg");

var $4nXyN = parcelRequire("4nXyN");

var $jrl3R = parcelRequire("jrl3R");

var $3B53X = parcelRequire("3B53X");

var $bvhAI = parcelRequire("bvhAI");

var $glkO2 = parcelRequire("glkO2");

var $anGpc = parcelRequire("anGpc");

var $04Vlk = parcelRequire("04Vlk");

var $flsjf = parcelRequire("flsjf");

var $aI01j = parcelRequire("aI01j");

var $4Aamz = parcelRequire("4Aamz");

var $1hbMK = parcelRequire("1hbMK");

var $c2KPY = parcelRequire("c2KPY");

var $ghGCX = parcelRequire("ghGCX");

var $7MpwB = parcelRequire("7MpwB");

var $lLZ8x = parcelRequire("lLZ8x");

var $g5rwu = parcelRequire("g5rwu");

var $1XAMa = parcelRequire("1XAMa");

var $1kSIj = parcelRequire("1kSIj");

var $dBV2a = parcelRequire("dBV2a");

var $ickyX = parcelRequire("ickyX");

var $cQer4 = parcelRequire("cQer4");

var $eL5iv = parcelRequire("eL5iv");

var $7MlOX = parcelRequire("7MlOX");

var $jK6bT = parcelRequire("jK6bT");

var $hvbE3 = parcelRequire("hvbE3");

var $glwG4 = parcelRequire("glwG4");

var $lcFGc = parcelRequire("lcFGc");

var $056cU = parcelRequire("056cU");

var $6p9ik = parcelRequire("6p9ik");

var $SvIen = parcelRequire("SvIen");

var $frn0U = parcelRequire("frn0U");

var $fH16o = parcelRequire("fH16o");

var $5YggO = parcelRequire("5YggO");

var $g3kqr = parcelRequire("g3kqr");

var $d4tTc = parcelRequire("d4tTc");

var $lPLcB = parcelRequire("lPLcB");

var $3L1EU = parcelRequire("3L1EU");

var $g5olQ = parcelRequire("g5olQ");

var $ecUH3 = parcelRequire("ecUH3");

var $6okEU = parcelRequire("6okEU");

var $6ElYx = parcelRequire("6ElYx");

var $9YDUs = parcelRequire("9YDUs");

var $gAq9g = parcelRequire("gAq9g");

var $64Fhf = parcelRequire("64Fhf");

var $h3JFI = parcelRequire("h3JFI");

var $tdrXl = parcelRequire("tdrXl");

var $5EloX = parcelRequire("5EloX");

var $7p4oW = parcelRequire("7p4oW");

var $GIsnE = parcelRequire("GIsnE");

var $MSc9t = parcelRequire("MSc9t");

var $bpbCg = parcelRequire("bpbCg");

var $5X0aC = parcelRequire("5X0aC");

var $fkWQj = parcelRequire("fkWQj");

var $7NO6v = parcelRequire("7NO6v");

var $gtJvE = parcelRequire("gtJvE");

var $hMqu9 = parcelRequire("hMqu9");

var $7YRoH = parcelRequire("7YRoH");

var $i0b8q = parcelRequire("i0b8q");

var $jKCJe = parcelRequire("jKCJe");

var $iJIU8 = parcelRequire("iJIU8");

var $d6K18 = parcelRequire("d6K18");

var $lIfPP = parcelRequire("lIfPP");

var $1rMUU = parcelRequire("1rMUU");

var $36qRE = parcelRequire("36qRE");

var $2LfmF = parcelRequire("2LfmF");

var $gzdNI = parcelRequire("gzdNI");

var $64qpc = parcelRequire("64qpc");

var $87aC7 = parcelRequire("87aC7");

var $hPrN5 = parcelRequire("hPrN5");

var $kKEWZ = parcelRequire("kKEWZ");

var $ljItG = parcelRequire("ljItG");

var $6JQwt = parcelRequire("6JQwt");

var $dRm2C = parcelRequire("dRm2C");

var $1Ps9S = parcelRequire("1Ps9S");

var $bRRmd = parcelRequire("bRRmd");

var $jr7ke = parcelRequire("jr7ke");

var $gtcNN = parcelRequire("gtcNN");

var $gMkpP = parcelRequire("gMkpP");

var $8VY8F = parcelRequire("8VY8F");

var $aApqk = parcelRequire("aApqk");

var $6mo9H = parcelRequire("6mo9H");

var $cJoBA = parcelRequire("cJoBA");

var $SBgrM = parcelRequire("SBgrM");

var $7kGnZ = parcelRequire("7kGnZ");

var $6fdEz = parcelRequire("6fdEz");

var $8WMR9 = parcelRequire("8WMR9");

var $hSl7U = parcelRequire("hSl7U");

var $9F4ID = parcelRequire("9F4ID");

var $9CT95 = parcelRequire("9CT95");

var $gktyQ = parcelRequire("gktyQ");

var $elyxq = parcelRequire("elyxq");

var $3T2Ye = parcelRequire("3T2Ye");

var $cVgRQ = parcelRequire("cVgRQ");

var $8XfJX = parcelRequire("8XfJX");

var $5o5UE = parcelRequire("5o5UE");

var $2OBp2 = parcelRequire("2OBp2");

var $29XA4 = parcelRequire("29XA4");

var $aNc7A = parcelRequire("aNc7A");

var $4e4nJ = parcelRequire("4e4nJ");

var $5nU8P = parcelRequire("5nU8P");

var $kHVIE = parcelRequire("kHVIE");

var $eHeAh = parcelRequire("eHeAh");

var $9R3is = parcelRequire("9R3is");

var $lKkaY = parcelRequire("lKkaY");

var $brWuf = parcelRequire("brWuf");

var $iXsus = parcelRequire("iXsus");

var $xwXfC = parcelRequire("xwXfC");

var $3lpLH = parcelRequire("3lpLH");

var $kNZj9 = parcelRequire("kNZj9");

var $aw22a = parcelRequire("aw22a");

var $yVbxa = parcelRequire("yVbxa");

var $dCGUp = parcelRequire("dCGUp");

var $4KLVz = parcelRequire("4KLVz");

var $j0BAb = parcelRequire("j0BAb");

var $lYrmE = parcelRequire("lYrmE");

var $awOZa = parcelRequire("awOZa");

var $eoIQt = parcelRequire("eoIQt");

var $kTgg2 = parcelRequire("kTgg2");

var $agsO7 = parcelRequire("agsO7");

var $9y8sW = parcelRequire("9y8sW");

var $825dq = parcelRequire("825dq");

var $h8swE = parcelRequire("h8swE");

var $gGQIR = parcelRequire("gGQIR");

var $01hnS = parcelRequire("01hnS");

var $8jDeK = parcelRequire("8jDeK");

var $64Uyh = parcelRequire("64Uyh");

var $1T4J3 = parcelRequire("1T4J3");

var $8hATp = parcelRequire("8hATp");

var $lrPAp = parcelRequire("lrPAp");

var $ZVu1m = parcelRequire("ZVu1m");

var $l1PfI = parcelRequire("l1PfI");

var $iuWOh = parcelRequire("iuWOh");

var $cvYE5 = parcelRequire("cvYE5");

var $2cpS3 = parcelRequire("2cpS3");

var $c0JOH = parcelRequire("c0JOH");

var $iYfXI = parcelRequire("iYfXI");

var $dAmDY = parcelRequire("dAmDY");

var $3MI0Z = parcelRequire("3MI0Z");

var $8brgy = parcelRequire("8brgy");

var $3kqBW = parcelRequire("3kqBW");

var $79qCU = parcelRequire("79qCU");

var $lYzgn = parcelRequire("lYzgn");

var $6YHWn = parcelRequire("6YHWn");

var $aAIWh = parcelRequire("aAIWh");

var $5fOtJ = parcelRequire("5fOtJ");

var $gfz2f = parcelRequire("gfz2f");

var $gfW60 = parcelRequire("gfW60");

var $h51Kg = parcelRequire("h51Kg");

var $rsO8k = parcelRequire("rsO8k");

var $5JkxV = parcelRequire("5JkxV");

var $jIBei = parcelRequire("jIBei");

var $3oSi6 = parcelRequire("3oSi6");

var $96BnX = parcelRequire("96BnX");

var $fP1EY = parcelRequire("fP1EY");

var $lzLcy = parcelRequire("lzLcy");

var $kZgpC = parcelRequire("kZgpC");

var $auP5Z = parcelRequire("auP5Z");

var $6un8I = parcelRequire("6un8I");

var $c97hk = parcelRequire("c97hk");

var $7sSEm = parcelRequire("7sSEm");

var $eaXgt = parcelRequire("eaXgt");

var $moUwl = parcelRequire("moUwl");

var $7D3Yv = parcelRequire("7D3Yv");

var $dgneZ = parcelRequire("dgneZ");

var $hRN7l = parcelRequire("hRN7l");

var $cU5zd = parcelRequire("cU5zd");

var $fSktp = parcelRequire("fSktp");

var $5TKdO = parcelRequire("5TKdO");

var $4zSYf = parcelRequire("4zSYf");

var $j175z = parcelRequire("j175z");

var $gQWOR = parcelRequire("gQWOR");

var $zaQdk = parcelRequire("zaQdk");

var $4UU5H = parcelRequire("4UU5H");

var $izdjx = parcelRequire("izdjx");

var $eWSeK = parcelRequire("eWSeK");

var $16Svt = parcelRequire("16Svt");

var $7m5aN = parcelRequire("7m5aN");

var $kDimk = parcelRequire("kDimk");

var $fQCGk = parcelRequire("fQCGk");

var $1EVpW = parcelRequire("1EVpW");

var $azyVo = parcelRequire("azyVo");

var $7wXr4 = parcelRequire("7wXr4");

var $kutfD = parcelRequire("kutfD");

var $2z6Z2 = parcelRequire("2z6Z2");

var $jvZP3 = parcelRequire("jvZP3");

var $03taV = parcelRequire("03taV");

var $6KvsG = parcelRequire("6KvsG");

var $kg7GL = parcelRequire("kg7GL");

var $i0tax = parcelRequire("i0tax");

var $aviVh = parcelRequire("aviVh");

var $dl9zj = parcelRequire("dl9zj");

var $3gU47 = parcelRequire("3gU47");

var $iQsfj = parcelRequire("iQsfj");

var $8Yag1 = parcelRequire("8Yag1");

var $2toxI = parcelRequire("2toxI");

var $5xsFH = parcelRequire("5xsFH");

var $eFYGV = parcelRequire("eFYGV");

var $kxlGk = parcelRequire("kxlGk");

var $cyZLC = parcelRequire("cyZLC");

var $9EGBH = parcelRequire("9EGBH");

var $45nsl = parcelRequire("45nsl");

var $jejF3 = parcelRequire("jejF3");

var $eKEYN = parcelRequire("eKEYN");

var $fwjnc = parcelRequire("fwjnc");

var $1KC4N = parcelRequire("1KC4N");

var $7ApVe = parcelRequire("7ApVe");

var $2vUs2 = parcelRequire("2vUs2");

var $bCHhM = parcelRequire("bCHhM");

var $hjvN4 = parcelRequire("hjvN4");

var $03CAy = parcelRequire("03CAy");

var $heIfC = parcelRequire("heIfC");

var $cjFCA = parcelRequire("cjFCA");

var $hu1w9 = parcelRequire("hu1w9");

var $akFeA = parcelRequire("akFeA");

var $djlm6 = parcelRequire("djlm6");

var $3J8Cl = parcelRequire("3J8Cl");

var $bhft0 = parcelRequire("bhft0");

var $6FBN4 = parcelRequire("6FBN4");

var $1iYkP = parcelRequire("1iYkP");

var $CY8KI = parcelRequire("CY8KI");

var $3Jvzv = parcelRequire("3Jvzv");

var $kYzjv = parcelRequire("kYzjv");

var $lHzMh = parcelRequire("lHzMh");

var $711QI = parcelRequire("711QI");

var $gcVUu = parcelRequire("gcVUu");

var $dG6DF = parcelRequire("dG6DF");

var $efYyQ = parcelRequire("efYyQ");

var $kQjkp = parcelRequire("kQjkp");

var $1IhKQ = parcelRequire("1IhKQ");

var $iwgxt = parcelRequire("iwgxt");

var $e99fJ = parcelRequire("e99fJ");

var $hUUCw = parcelRequire("hUUCw");

var $knZRG = parcelRequire("knZRG");

var $7dbQR = parcelRequire("7dbQR");

var $jbAAG = parcelRequire("jbAAG");

var $58Cy7 = parcelRequire("58Cy7");

var $2XQq2 = parcelRequire("2XQq2");

var $4t69d = parcelRequire("4t69d");

var $e1cjg = parcelRequire("e1cjg");

var $4XUsE = parcelRequire("4XUsE");

var $jqbKy = parcelRequire("jqbKy");

var $e7GI8 = parcelRequire("e7GI8");

var $bbDvZ = parcelRequire("bbDvZ");

var $dR9Nr = parcelRequire("dR9Nr");

var $goreX = parcelRequire("goreX");

var $3eN7Y = parcelRequire("3eN7Y");

var $aA0rC = parcelRequire("aA0rC");

var $jss6V = parcelRequire("jss6V");

var $6B4GJ = parcelRequire("6B4GJ");

var $fMbaV = parcelRequire("fMbaV");

var $bi9fZ = parcelRequire("bi9fZ");

var $7Db7a = parcelRequire("7Db7a");

var $hjVS0 = parcelRequire("hjVS0");

var $aAF0I = parcelRequire("aAF0I");

var $4Mj46 = parcelRequire("4Mj46");

var $3I1TD = parcelRequire("3I1TD");

var $41tjC = parcelRequire("41tjC");

var $eAw5v = parcelRequire("eAw5v");

var $wwgc5 = parcelRequire("wwgc5");

var $iz3gR = parcelRequire("iz3gR");

var $icwb1 = parcelRequire("icwb1");

var $egxSq = parcelRequire("egxSq");

var $lhZGg = parcelRequire("lhZGg");

var $jr5gb = parcelRequire("jr5gb");

var $7lZOe = parcelRequire("7lZOe");

var $9rVvQ = parcelRequire("9rVvQ");

var $au6vg = parcelRequire("au6vg");

var $cLamq = parcelRequire("cLamq");

var $2vHPs = parcelRequire("2vHPs");

var $hztdR = parcelRequire("hztdR");

var $6cSNh = parcelRequire("6cSNh");

var $lIPtt = parcelRequire("lIPtt");

var $cWKD0 = parcelRequire("cWKD0");

var $d0eOH = parcelRequire("d0eOH");

var $bxg3m = parcelRequire("bxg3m");

var $e6Vbw = parcelRequire("e6Vbw");

var $7LwJB = parcelRequire("7LwJB");

var $66HfJ = parcelRequire("66HfJ");

var $aDZxG = parcelRequire("aDZxG");

var $anDMO = parcelRequire("anDMO");

var $dYbYB = parcelRequire("dYbYB");

var $ffFBX = parcelRequire("ffFBX");

var $1IKX7 = parcelRequire("1IKX7");

var $1K27j = parcelRequire("1K27j");

var $8DQ40 = parcelRequire("8DQ40");

var $hdWS0 = parcelRequire("hdWS0");

var $9MTKv = parcelRequire("9MTKv");

var $d2uL5 = parcelRequire("d2uL5");

var $2ubrr = parcelRequire("2ubrr");

var $d7mi1 = parcelRequire("d7mi1");

var $5HfC7 = parcelRequire("5HfC7");

var $7QAza = parcelRequire("7QAza");

var $5MiVl = parcelRequire("5MiVl");

var $ee5pi = parcelRequire("ee5pi");

var $3SReJ = parcelRequire("3SReJ");

var $aLuho = parcelRequire("aLuho");

var $3YX4q = parcelRequire("3YX4q");

var $kEFGH = parcelRequire("kEFGH");

var $kwWQ0 = parcelRequire("kwWQ0");

var $7F7I9 = parcelRequire("7F7I9");

var $2OQWG = parcelRequire("2OQWG");

var $4eRSO = parcelRequire("4eRSO");

var $b9Dpn = parcelRequire("b9Dpn");

var $eitw0 = parcelRequire("eitw0");

var $14ooS = parcelRequire("14ooS");

var $lWR9T = parcelRequire("lWR9T");

var $6DlqX = parcelRequire("6DlqX");

var $jCfr4 = parcelRequire("jCfr4");

var $kRn5i = parcelRequire("kRn5i");

var $3NIY8 = parcelRequire("3NIY8");

var $fjYA2 = parcelRequire("fjYA2");

var $qdq3O = parcelRequire("qdq3O");

var $aY70k = parcelRequire("aY70k");

var $2wF9u = parcelRequire("2wF9u");

var $feDOq = parcelRequire("feDOq");

var $cqk4B = parcelRequire("cqk4B");

var $d66ag = parcelRequire("d66ag");

var $84EwA = parcelRequire("84EwA");

var $7dYbE = parcelRequire("7dYbE");

var $ghTLp = parcelRequire("ghTLp");

var $jjqkz = parcelRequire("jjqkz");

var $7xqQs = parcelRequire("7xqQs");

var $peO7W = parcelRequire("peO7W");

var $f1JiD = parcelRequire("f1JiD");

var $138gn = parcelRequire("138gn");

var $fCX78 = parcelRequire("fCX78");

var $6NqDk = parcelRequire("6NqDk");

var $hWZAC = parcelRequire("hWZAC");

var $2kXpo = parcelRequire("2kXpo");

var $fhlje = parcelRequire("fhlje");

var $8to5X = parcelRequire("8to5X");

var $7B6VF = parcelRequire("7B6VF");

var $dyGLN = parcelRequire("dyGLN");

var $gwCoT = parcelRequire("gwCoT");

var $bbdey = parcelRequire("bbdey");

var $drVWM = parcelRequire("drVWM");

var $t2WaR = parcelRequire("t2WaR");

var $72XXS = parcelRequire("72XXS");

var $yVmHw = parcelRequire("yVmHw");

var $ljDIh = parcelRequire("ljDIh");

var $lAnjX = parcelRequire("lAnjX");

var $cONlw = parcelRequire("cONlw");

var $28AFT = parcelRequire("28AFT");

var $gsEXA = parcelRequire("gsEXA");

var $g3Gvc = parcelRequire("g3Gvc");

var $dseRA = parcelRequire("dseRA");

var $627LR = parcelRequire("627LR");

var $3wbIE = parcelRequire("3wbIE");

var $1XqXD = parcelRequire("1XqXD");

var $dDzIU = parcelRequire("dDzIU");

var $1aB8Z = parcelRequire("1aB8Z");

var $3M4hq = parcelRequire("3M4hq");

var $a2PeW = parcelRequire("a2PeW");

var $gXApH = parcelRequire("gXApH");

var $amBHA = parcelRequire("amBHA");

var $6agOS = parcelRequire("6agOS");

var $7fwfr = parcelRequire("7fwfr");

var $gUdrp = parcelRequire("gUdrp");

var $bERWs = parcelRequire("bERWs");

var $80PF8 = parcelRequire("80PF8");

var $2r2Gu = parcelRequire("2r2Gu");

var $hRMW9 = parcelRequire("hRMW9");

var $9eiXm = parcelRequire("9eiXm");

var $D5QBq = parcelRequire("D5QBq");

var $4eKYR = parcelRequire("4eKYR");

var $5W0wg = parcelRequire("5W0wg");

var $aQ85T = parcelRequire("aQ85T");

var $6kvQ5 = parcelRequire("6kvQ5");

var $bCnWj = parcelRequire("bCnWj");

var $kci7Q = parcelRequire("kci7Q");

var $9Dd5o = parcelRequire("9Dd5o");

var $h4Pr8 = parcelRequire("h4Pr8");

var $5XbrB = parcelRequire("5XbrB");

var $1ods3 = parcelRequire("1ods3");

var $gpVZm = parcelRequire("gpVZm");

var $i8buc = parcelRequire("i8buc");

var $hqIff = parcelRequire("hqIff");

var $1Y5eu = parcelRequire("1Y5eu");

var $kkXdG = parcelRequire("kkXdG");

var $gPxpf = parcelRequire("gPxpf");

var $3FG4O = parcelRequire("3FG4O");

var $bl8cB = parcelRequire("bl8cB");

var $fLbia = parcelRequire("fLbia");

var $ceMKm = parcelRequire("ceMKm");

var $UuOK7 = parcelRequire("UuOK7");

var $eAlzO = parcelRequire("eAlzO");

var $3KtPD = parcelRequire("3KtPD");

var $h3WYk = parcelRequire("h3WYk");

var $gjuAo = parcelRequire("gjuAo");

var $9z1Wd = parcelRequire("9z1Wd");

var $6fHM1 = parcelRequire("6fHM1");

var $1GAqb = parcelRequire("1GAqb");

var $2ytxj = parcelRequire("2ytxj");

var $7PtTb = parcelRequire("7PtTb");

var $8E1dI = parcelRequire("8E1dI");

var $2yO8h = parcelRequire("2yO8h");

var $fEAJ2 = parcelRequire("fEAJ2");

var $18W8Q = parcelRequire("18W8Q");

var $4VMm4 = parcelRequire("4VMm4");

var $bFlFq = parcelRequire("bFlFq");

var $eyDhF = parcelRequire("eyDhF");

var $lkwO5 = parcelRequire("lkwO5");

var $3Ro2a = parcelRequire("3Ro2a");

var $b952b = parcelRequire("b952b");

var $aZXhs = parcelRequire("aZXhs");

var $69iY3 = parcelRequire("69iY3");

var $ca1Zm = parcelRequire("ca1Zm");

var $6GNmk = parcelRequire("6GNmk");

var $734Wz = parcelRequire("734Wz");
const $ef6e862e848d08e0$export$10439de9ce871f28 = ()=>[
        (0, $c74Xp.connectGeneralServiceDeskProjectRouteEntry),
        (0, $gnGkU.connectGeneralRouteEntry),
        (0, $5eLaE.connectGeneralInvalidRouteEntry),
        (0, $4Zw1h.connectProjectRouteEntry),
        (0, $hxYI0.forgeAdminSettingsRouteEntry),
        (0, $5fBQK.forgeAdminRouteEntry),
        (0, $kCn5T.forgeProjectRouteEntry),
        (0, $90Rrp.forgeProjectServicedeskRouteEntry),
        (0, $86qmt.forgeServicedeskQueueRouteEntry),
        (0, $dzSy7.forgeFieldContextualConfigurationRouteEntry),
        (0, $eKguf.forgeGlobalRouteEntry),
        (0, $7vXQn.forgePersonalSettingsRouteEntry),
        (0, $3I1TD.softwareViewNotFoundRouteEntry),
        (0, $41tjC.softwareViewNotFoundClassicRouteEntry),
        (0, $eAw5v.softwareBoardViewNotFoundRouteEntry),
        (0, $wwgc5.softwareBoardViewNotFoundClassicRouteEntry),
        (0, $azyVo.softwareBoardEmbedRouteEntry),
        (0, $7wXr4.softwareBoardRouteEntry),
        (0, $fQCGk.softwareBacklogEmbedRouteEntry),
        (0, $1EVpW.softwareBacklogRouteEntry),
        (0, $03taV.softwareFormBuilderRouteEntry),
        (0, $6KvsG.softwareFormRouteEntry),
        (0, $i0tax.softwareFormSubmitRouteEntry),
        (0, $b952b.globalSettingsOptimizeFieldConfigurationSchemeRouteEntry),
        (0, $aZXhs.globalSettingsOptimizeWorkTypeSchemeRouteEntry),
        (0, $kg7GL.softwareFormSubmitEmbedRouteEntry),
        (0, $aviVh.softwareFormSubmitPublicRouteEntry),
        (0, $dl9zj.softwareGoalsRouteEntry),
        (0, $cQer4.softwareReportsBurnupRouteEntry),
        (0, $lcFGc.softwareReportsVelocityRouteEntry),
        (0, $8E1dI.cmpVelocityRouteEntry),
        (0, $7MlOX.softwareReportsCumulativeRouteEntry),
        (0, $ickyX.softwareReportsBurndownRouteEntry),
        (0, $jK6bT.softwareReportsCycleTimeRouteEntry),
        (0, $hvbE3.softwareReportsDeploymentFrequencyRouteEntry),
        (0, $eL5iv.softwareReportsControlRouteEntry),
        (0, $glwG4.softwareReportsRouteEntry),
        (0, $dBV2a.softwareNextgenRedirectRouteEntry),
        (0, $1kSIj.softwareCodeRouteEntry),
        (0, $cyZLC.softwareSecurityNextGenRouteEntry),
        (0, $45nsl.softwareSummaryEmbedRouteEntry),
        (0, $9EGBH.softwareSummaryRouteEntry),
        (0, $jvZP3.softwareDeploymentsNextGenRouteEntry),
        (0, $eFYGV.softwarePeriscopeNextGenRouteEntry),
        (0, $eKEYN.softwareVersionDetailEmbedRouteEntry),
        (0, $7ApVe.softwareVersionDetailRouteEntry),
        (0, $1KC4N.softwareVersionDetailNoTabPathRedirectRouteEntry),
        (0, $fwjnc.softwareVersionDetailLegacyRedirectRouteEntry),
        (0, $jejF3.softwareTimelineRouteEntry),
        (0, $kxlGk.softwareRoadmapRouteEntry),
        (0, $kutfD.softwareCalendarEmbedRouteEntry),
        (0, $2z6Z2.softwareCalendarRouteEntry),
        (0, $8Yag1.softwareListEmbedRouteEntry),
        (0, $2toxI.softwareListRouteEntry),
        (0, $056cU.softwareRoadmapRedirectRouteEntry),
        (0, $9MSQj.softwareIncidentsNextGenRouteEntry),
        (0, $7PtTb.softwareStaffingRouteEntry),
        (0, $3L1EU.polarisCollectionsRouteEntry),
        (0, $g5olQ.polarisIdeasRouteEntry),
        (0, $ecUH3.polarisOnboardingRouteEntry),
        (0, $6okEU.polarisSettingsAccessRouteEntry),
        (0, $6ElYx.polarisSettingsViewBlueprintsRouteEntry),
        (0, $9YDUs.polarisSettingsGlobalFieldsRouteEntry),
        (0, $64Fhf.polarisSettingsFinancialYearRouteEntry),
        (0, $gAq9g.polarisSettingsEarlyAccessFeaturesRouteEntry),
        (0, $h3JFI.polarisUnlicensedRouteEntry),
        (0, $5xsFH.softwareOnboardingRouteEntry),
        (0, $03CAy.softwareRoadmapClassicRouteEntry),
        (0, $heIfC.softwareTimelineClassicRouteEntry),
        (0, $cjFCA.classicSoftwareBoardSettingsRouteEntry),
        (0, $hu1w9.classicSoftwareBoardSettingsInsightsRapidboardBacklogRouteEntry),
        (0, $akFeA.classicSoftwareBoardSettingsInsightsRapidboardBoardRouteEntry),
        (0, $djlm6.softwareCalendarClassicEmbedRouteEntry),
        (0, $3J8Cl.softwareCalendarClassicRouteEntry),
        (0, $bhft0.softwareListEmbedClassicRouteEntry),
        (0, $6FBN4.softwareListClassicRouteEntry),
        (0, $jbAAG.softwareReportsDeploymentFrequencyClassicBoardRouteEntry),
        (0, $lHzMh.softwareReportsCycleTimeClassicBoardRouteEntry),
        (0, $1iYkP.rapidboardReportRouteEntry),
        (0, $kYzjv.softwareReportsCycleTimeClassicRouteEntry),
        (0, $CY8KI.softwareReportsOverviewRouteEntry),
        (0, $3Jvzv.softwareReportsOverviewBoardlessRouteEntry),
        (0, $711QI.softwareFormBuilderClassicRouteEntry),
        (0, $gcVUu.softwareFormSubmitClassicRouteEntry),
        (0, $dG6DF.softwareFormSubmitEmbedClassicRouteEntry),
        (0, $efYyQ.softwareFormSubmitClassicPublicRouteEntry),
        (0, $kQjkp.softwareFormClassicRouteEntry),
        (0, $1IhKQ.softwareGoalsClassicRouteEntry),
        (0, $e99fJ.softwareSummaryEmbedClassicRouteEntry),
        (0, $iwgxt.softwareSummaryClassicRouteEntry),
        (0, $hUUCw.softwareClassicProformaIssueFormsDirectRouteEntry),
        (0, $knZRG.softwareClassicProformaIssueFormsDirectEmbedRouteEntry),
        (0, $7dbQR.softwareReportsDeploymentFrequencyClassicRouteEntry),
        (0, $2XQq2.classicSoftwareBacklogEmbedRouteEntry),
        (0, $58Cy7.classicSoftwareBacklogRouteEntry),
        (0, $e1cjg.classicSoftwareBoardEmbedRouteEntry),
        (0, $4t69d.classicSoftwareBoardRouteEntry),
        (0, $4XUsE.rapidboardUserBacklogRouteEntry),
        (0, $jqbKy.userBoardVelocityRouteEntry),
        (0, $bbDvZ.rapidboardUserReportRouteEntry),
        (0, $3eN7Y.userBoardViewNotFoundRouteEntry),
        (0, $dR9Nr.userBoardRouteEntry),
        (0, $e7GI8.rapidboardUserReportsOverviewRouteEntry),
        (0, $goreX.userBoardSettingsRouteEntry),
        (0, $aA0rC.rapidboardBacklog1RouteEntry),
        (0, $jss6V.rapidboardReport1RouteEntry),
        (0, $iz3gR.legacyRapidBoardRouteEntry),
        (0, $6B4GJ.softwareCodeClassicRouteEntry),
        (0, $fMbaV.softwareSecurityClassicRouteEntry),
        (0, $bi9fZ.softwareDeploymentsClassicRouteEntry),
        (0, $7Db7a.softwarePeriscopeClassicRouteEntry),
        (0, $hjVS0.rapidboardLastVisitedProjectRedirectRouteEntry),
        (0, $aAF0I.projectDirectoryRedirectRouteEntry),
        (0, $4Mj46.softwareIncidentsClassicRouteEntry),
        (0, $3gU47.softwareInboxNextGenRouteEntry),
        (0, $iQsfj.softwareInboxClassicRouteEntry),
        /*
	 *************************************************** ATTENTION PROJECT SETTINGS ROUTES ***************************************************
	 * Take special care with any redirect components you render. For legacy routes they should redirect to the legacy URL,
	 * and for product routes the should redirect to the product URL.
	 */ (0, $kRn5i.projectSettingsSoftwareIssuetypesRouteEntry),
        (0, $3NIY8.projectSettingsSoftwareIssuetypesWorkflowRouteEntry),
        (0, $3YX4q.projectSettingsSoftwareAppsFieldsRouteEntry),
        (0, $kEFGH.projectSettingsSoftwareAppsRouteEntry),
        (0, $6DlqX.projectSettingsSoftwareDetailsRouteEntry),
        (0, $jCfr4.projectSettingsSoftwareFieldsRouteEntry),
        (0, $aLuho.projectSettingsSoftwareAccessRouteEntry),
        (0, $3SReJ.projectSettingsSoftwareAccessRedirectRouteEntry),
        (0, $d66ag.projectSettingsSoftwareProformaProjectFormsRouteEntry),
        (0, $cqk4B.projectSettingsSoftwareProformaJiraFormBuilderRouteEntry),
        (0, $5HfC7.projectSettingsAutomationRouteEntry),
        (0, $lWR9T.projectSettingsSoftwareDataClassificationsRouteEntry),
        (0, $anDMO.classicProjectSettingsDetailsRouteEntry),
        (0, $fjYA2.projectSettingsSoftwareNextGenFeaturesRouteEntry),
        (0, $feDOq.projectSettingsSoftwareNotificationsRouteEntry),
        (0, $2wF9u.projectSettingsSoftwareNotificationsIssueLogsRouteEntry),
        (0, $ee5pi.projectSettingsOpsgenieRouteEntry),
        (0, $ffFBX.classicProjectSettingsOpsgenieRouteEntry),
        (0, $7dYbE.projectSettingsToolchainRouteEntry),
        (0, $9MTKv.classicProjectSettingsToolchainRouteEntry),
        (0, $dYbYB.classicProjectSettingsFeaturesRouteEntry),
        (0, $1IKX7.classicProjectSettingsSoftwareNotificationsIssueLogsRouteEntry),
        (0, $qdq3O.projectSettingsSoftwareNotificationEmailCRouteEntry),
        (0, $aY70k.projectSettingsSoftwareNotificationEmailRouteEntry),
        (0, $2ubrr.legacyProjectReleasesNoteRouteEntry),
        (0, $d2uL5.legacyProjectReleasesNoteConfigRouteEntry),
        (0, $ghTLp.softwareReleaseNotesRouteEntry),
        (0, $kwWQ0.projectSettingsSoftwareAutomationRouteEntry),
        (0, $8DQ40.classicProjectSettingsSoftwareProformaFormsRouteEntry),
        (0, $1K27j.classicProjectSettingsSoftwareProformaEditFormsRouteEntry),
        (0, $b9Dpn.projectSettingsSoftwareBoardsRedirectRouteEntry),
        (0, $2OQWG.projectSettingsSoftwareBoardsCsmRouteEntry),
        (0, $4eRSO.projectSettingsSoftwareBoardsCustomFiltersRouteEntry),
        (0, $7F7I9.projectSettingsSoftwareBoardsCardRouteEntry),
        (0, $eitw0.projectSettingsSoftwareBoardsRoadmapRouteEntry),
        (0, $14ooS.projectSettingsSoftwareBoardsTimelineRouteEntry),
        (0, $d7mi1.projectSettingsAutomationCRouteEntry),
        (0, $5MiVl.projectSettingsForgeAppsRouteEntry),
        (0, $7QAza.projectSettingsForgeAppsNextgenRouteEntry),
        (0, $84EwA.projectSettingsSoftwareRedirectRouteEntry),
        (0, $hdWS0.classicProjectSettingsSoftwareRedirectRouteEntry),
        (0, $jjqkz.projectSettingsServicedeskClassicAppsRouteEntry),
        (0, $f1JiD.projectSettingsServicedeskIssuetypesRouteEntry),
        (0, $138gn.projectSettingsServicedeskIssuetypesWorkflowRouteEntry),
        (0, $peO7W.projectSettingsServicedeskFieldsRouteEntry),
        (0, $fhlje.projectSettingsServicedeskAppsFieldsRouteEntry),
        (0, $8to5X.projectSettingsServicedeskAppsRouteEntry),
        (0, $7xqQs.projectSettingsServicedeskDetailsRouteEntry),
        (0, $2kXpo.projectSettingsServicedeskAccessRouteEntry),
        (0, $hWZAC.projectSettingsServicedeskAccessRedirectRouteEntry),
        (0, $6NqDk.projectSettingsServicedeskProformaProjectFormsRouteEntry),
        (0, $fCX78.projectSettingsServicedeskProformaJiraFormBuilderRouteEntry),
        (0, $7B6VF.projectSettingsServicedeskAutomationRouteEntry),
        (0, $dyGLN.projectSettingsServicedeskDataClassificationsRouteEntry),
        (0, $hqIff.projectSettingsServicedeskKbRouteEntry),
        (0, $1Y5eu.projectSettingsServicedeskUnassignedTicketTypeFieldsRouteEntry),
        (0, $kkXdG.projectSettingsServicedeskItsmTicketTypeFieldsRouteEntry),
        (0, $gPxpf.projectSettingsServicedeskTicketTypeFieldsRouteEntry),
        (0, $3FG4O.projectSettingsServicedeskUnassignedTicketTypesConfigRouteEntry),
        (0, $bl8cB.projectSettingsServicedeskItsmTicketTypesConfigRouteEntry),
        (0, $fLbia.projectSettingsServicedeskTicketTypesConfigRouteEntry),
        (0, $hRMW9.projectSettingsServicedeskAutomationEditRuleRouteEntry),
        (0, $9eiXm.projectSettingsServicedeskAutomationCopyRuleRouteEntry),
        (0, $D5QBq.projectSettingsServicedeskAutomationCreateRouteEntry),
        (0, $4eKYR.projectSettingsServicedeskAutomationViewLogRouteEntry),
        (0, $5W0wg.projectSettingsServicedeskAutomationSummaryRouteEntry),
        (0, $aQ85T.projectSettingsServicedeskLegacyAutomationRedirectCreateRouteEntry),
        (0, $6kvQ5.projectSettingsServicedeskLegacyAutomationRedirectEditRouteEntry),
        (0, $bCnWj.projectSettingsServicedeskLegacyAutomationRedirectCopyRouteEntry),
        (0, $kci7Q.projectSettingsServicedeskLegacyAutomationRedirectViewLogRouteEntry),
        (0, $9Dd5o.projectSettingsServicedeskLegacyAutomationRedirectSummaryRouteEntry),
        (0, $h4Pr8.projectSettingsServicedeskCustomerNotificationsRouteEntry),
        (0, $5XbrB.projectSettingsServicedeskNotificationsCustomerNotificationsRouteEntry),
        (0, $ceMKm.landingPageRouteEntry),
        (0, $3KtPD.browseIntentsRouteEntry),
        (0, $6fHM1.viewIntentRouteEntry),
        (0, $h3WYk.browseStandardFlowsRouteEntry),
        (0, $1GAqb.viewStandardFlowRouteEntry),
        (0, $eAlzO.browseConversationsRouteEntry),
        (0, $9z1Wd.settingsRouteEntry),
        (0, $UuOK7.aiAnswersRouteEntry),
        (0, $gjuAo.performanceRouteEntry),
        (0, $80PF8.servicedeskPlaybooksListRouteEntry),
        (0, $2r2Gu.servicedeskPlaybooksEditRouteEntry),
        (0, $lkwO5.projectSettingsCustomerServiceFeaturesRouteEntry),
        (0, $1ods3.projectSettingsServicedeskJourneysRouteEntry),
        (0, $gpVZm.projectSettingsServicedeskJourneyConfigurationRouteEntry),
        (0, $i8buc.projectSettingsServicedeskJourneyConfigurationEditRouteEntry),
        (0, $2ytxj.servicedeskWorkflowConfigRouteEntry),
        (0, $gwCoT.projectSettingsServicedeskItsmFeaturesRouteEntry),
        (0, $bbdey.projectSettingsServicedeskNotificationsInternalNotificationsRouteEntry),
        (0, $drVWM.projectSettingsServicedeskInternalNotificationsNextGenRouteEntry),
        (0, $t2WaR.projectSettingsServicedeskNotificationsNotificationEmailRouteEntry),
        (0, $72XXS.projectSettingsServicedeskNotificationsEmailRouteEntry),
        (0, $yVmHw.projectSettingsServicedeskNotificationsRouteEntry),
        (0, $ljDIh.projectSettingsServicedeskLanguageKeyRouteEntry),
        (0, $lAnjX.projectSettingsServicedeskLanguageRouteEntry),
        (0, $cONlw.projectSettingsServicedeskChannelsPermissionsNextGenRouteEntry),
        (0, $28AFT.projectSettingsServicedeskCustomerPermissionsRouteEntry),
        (0, $gsEXA.projectSettingsServicedeskChannelsEmailNextGenRouteEntry),
        (0, $g3Gvc.projectSettingsServicedeskEmailRouteEntry),
        (0, $dseRA.projectSettingsServicedeskPortalSettingsRouteEntry),
        (0, $627LR.projectSettingsServicedeskChannelsPortalRouteEntry),
        (0, $3wbIE.projectSettingsServicedeskExternalLinksRouteEntry),
        (0, $1XqXD.projectSettingsServicedeskChannelsWidgetRouteEntry),
        (0, $dDzIU.projectSettingsServicedeskWidgetRouteEntry),
        (0, $1aB8Z.projectSettingsServicedeskChangeManagementRouteEntry),
        (0, $3M4hq.projectSettingsServicedeskIncidentManagementRouteEntry),
        (0, $a2PeW.projectSettingsServicedeskChannelsChatRouteEntry),
        (0, $gXApH.projectSettingsServicedeskChatRouteEntry),
        (0, $amBHA.projectSettingsServicedeskChannelsRouteEntry),
        (0, $6agOS.servicedeskSlaSettingsRouteEntry),
        (0, $7fwfr.projectSettingsServicedeskFeedbackRouteEntry),
        (0, $gUdrp.projectSettingsServicedeskForgeAppsRouteEntry),
        (0, $bERWs.projectSettingsServicedeskRedirectRouteEntry),
        (0, $cWKD0.projectSettingsCoreIssueTypesRouteEntry),
        (0, $6cSNh.projectSettingsCoreFieldsRouteEntry),
        (0, $d0eOH.projectSettingsCoreIssueTypesWorkflowRouteEntry),
        (0, $jr5gb.projectSettingsCoreAppsFieldsRouteEntry),
        (0, $7lZOe.projectSettingsCoreAppsRouteEntry),
        (0, $hztdR.projectSettingsCoreDetailsRouteEntry),
        (0, $egxSq.projectSettingsCoreAccessRouteEntry),
        (0, $icwb1.projectSettingsCoreAccessRedirectRouteEntry),
        (0, $aDZxG.projectSettingsCoreProformaProjectFormsRouteEntry),
        (0, $66HfJ.projectSettingsCoreProformaJiraFormBuilderRouteEntry),
        (0, $au6vg.projectSettingsCoreAutomationV2RouteEntry),
        (0, $cLamq.projectSettingsCoreDataClassificationsRouteEntry),
        (0, $9rVvQ.projectSettingsCoreAutomationRouteEntry),
        (0, $7LwJB.projectSettingsCoreNotificationsRouteEntry),
        (0, $e6Vbw.projectSettingsCoreNotificationsIssueLogsRouteEntry),
        (0, $bxg3m.projectSettingsCoreNotificationsEmailRouteEntry),
        (0, $lIPtt.projectSettingsCoreForgeAppsRouteEntry),
        (0, $lhZGg.projectSettingsCoreApprovalsRouteEntry),
        (0, $2vHPs.projectSettingsCoreDefaultRedirectRouteEntry),
        (0, $ejDmq.classicBusinessProjectViewNotFoundRouteEntry),
        (0, $2IdR0.jiraBusinessSummaryRouteEntry),
        (0, $gbj7F.jiraBusinessBoardEmbedRouteEntry),
        (0, $8gEiV.jiraBusinessBoardCustomEmbedRouteEntry),
        (0, $dhiyM.jiraBusinessBoardRouteEntry),
        (0, $21AP4.jiraBusinessCalendarEmbedRouteEntry),
        (0, $infHq.jiraBusinessCalendarRouteEntry),
        (0, $ilKWG.jiraBusinessReportsOverviewRouteEntry),
        (0, $hF0nU.classicBusinessProjectShortcutRouteEntry),
        (0, $gxVJf.jiraBusinessListRouteEntry),
        (0, $a2wNz.classicBusinessProjectFormRouteEntry),
        (0, $ajYJ1.classicBusinessProjectFormSubmitRouteEntry),
        (0, $1sFpf.classicBusinessProjectFormBuilderRouteEntry),
        (0, $huQRU.classicBusinessProjectFormSubmitPublicRouteEntry),
        (0, $frUin.jiraBusinessTimelineRouteEntry),
        (0, $6IB0N.classicBusinessProjectApprovalsRouteEntry),
        (0, $47CVY.classicBusinessProjectPagesRouteEntry),
        (0, $gm7fA.jiraBusinessAttachmentsRouteEntry),
        (0, $cZPPs.jiraBusinessTimelineEmbedRouteEntry),
        (0, $9yqzH.jiraBusinessListEmbedRouteEntry),
        (0, $eghTD.classicBusinessProjectFormSubmitEmbedRouteEntry),
        (0, $1EihZ.jiraBusinessSummaryEmbedRouteEntry),
        (0, $hfeIi.classicBusinessProjectSampleOnboardingRouteEntry),
        (0, $4KinX.classicBusinessOverviewTimelineRouteEntry),
        (0, $dUuHj.classicBusinessOverviewCalendarRouteEntry),
        (0, $eiK9n.classicBusinessOverviewSummaryRouteEntry),
        (0, $bZEI9.jiraBusinessProjectRedirectRouteEntry),
        (0, $c1v6Y.jiraBusinessOverviewRedirectRouteEntry),
        (0, $jovMq.globalSettingsIssueFieldScreensRouteEntry),
        (0, $ipR0U.globalSettingsIssueFieldSchemesRouteEntry),
        (0, $a4nP2.globalSettingsIssueTypesScreenSchemesRouteEntry),
        (0, $f6OBR.globalSettingsIssueWorkflowEditRouteEntry),
        (0, $dtLGm.globalSettingsIssueWorkflow1RouteEntry),
        (0, $2pvey.globalSettingsIssueHierarchyRouteEntry),
        (0, $laDqO.globalSettingsIssueHierarchyRedirectRouteEntry),
        (0, $lgfw1.globalSettingsIssueTypesRouteEntry),
        (0, $4x45G.globalSettingsIssueTypesSchemesRouteEntry),
        (0, $aNke7.globalSettingsContactAdministratorRouteEntry),
        (0, $hH7Cb.globalSettingsSystemUiAnnouncementBannerRouteEntry),
        (0, $4PsEV.productsJsmCustomerAccessRouteEntry),
        (0, $3rBGh.productsJsmAuthenticationSettingsRouteEntry),
        (0, $dTwSZ.globalSettingsSystemBulkMailRouteEntry),
        (0, $1mByb.globalSettingsEditPermissionSchemesRouteEntry),
        (0, $ew7DI.globalSettingsPermissionSchemesRouteEntry),
        (0, $izUuJ.globalSettingsFormDataConnectionsRouteEntry),
        (0, $jWVY2.globalSettingsIssuesNewIssueSearchRouteEntry),
        (0, $3Hflx.globalSettingsPerformanceOverviewRouteEntry),
        (0, $5BlCA.globalSettingsPerformanceMetricDetailRouteEntry),
        (0, $bUOZo.globalSettingsPerformanceProjectCleanupRouteEntry),
        (0, $ktEDA.globalSettingsPerformanceCustomFieldRouteEntry),
        (0, $caoz4.globalSettingsPerformanceIssueArchivalRouteEntry),
        (0, $bC98V.globalSettingsPerformanceProjectRoleActorRouteEntry),
        (0, $2UvYl.globalSettingsIssueFieldsManagementRouteEntry),
        (0, $69iY3.globalSettingsIssueFieldConfigurationSchemesRouteEntry),
        (0, $gCfQs.globalSettingsIssuesPrioritiesRouteEntry),
        (0, $81ZCL.globalSettingsIssuesPrioritySchemesRouteEntry),
        (0, $4BdYV.globalSettingsGlobalPermissionsRouteEntry),
        (0, $k1TyW.systemConfigurationRouteEntry),
        (0, $h0ilo.systemConfigurationRedirectRouteEntry),
        (0, $fMVEG.externalImportRouteEntry),
        (0, $Dkaoj.emailNotificationsLogAccessRouteEntry),
        (0, $hHcn9.archivedIssuesRedirectRouteEntry),
        (0, $lGElM.archivedWorkItemsJswRouteEntry),
        (0, $6DvyY.archivedWorkItemsJswCompanyRouteEntry),
        (0, $9wv3p.archivedWorkItemsJsmRouteEntry),
        (0, $3bc6l.archivedWorkItemsJwmRouteEntry),
        (0, $3HGg1.issueCreateEmbedRouteEntry),
        (0, $eyDhF.piCreateIssueEmbedRouteEntry),
        (0, $bFlFq.piEditIssueEmbedRouteEntry),
        (0, $glkO2.issueNavigatorProjectClassicRouteEntry),
        (0, $anGpc.issueNavigatorProjectClassicEmbedRouteEntry),
        (0, $flsjf.issueNavigatorProjectSoftwareRouteEntry),
        (0, $aI01j.issueNavigatorProjectSoftwareEmbedRouteEntry),
        (0, $04Vlk.issueNavigatorProjectServicedeskRouteEntry),
        (0, $3B53X.issueNavigatorProjectBusinessRouteEntry),
        (0, $bvhAI.issueNavigatorProjectBusinessEmbedRouteEntry),
        (0, $jrl3R.issueNavigatorGlobalRouteEntry),
        (0, $4nXyN.issueNavigatorGlobalJiraRouteEntry),
        (0, $4Aamz.projectIssueNavigatorRouteEntry),
        (0, $6HuHg.globalIssueNavigatorBrowseIssueRedirectRouteEntry),
        (0, $lLZ8x.appRequestsRouteEntry),
        (0, $1XAMa.promotionsRouteEntry),
        (0, $g5rwu.findAppsRouteEntry),
        (0, $jKCJe.proformaExportRouteEntry),
        (0, $iJIU8.proformaIssueFormsGeneralRouteEntry),
        (0, $36qRE.servicedeskProformaIssueFormsDirectRouteEntry),
        (0, $1rMUU.servicedeskProformaIssueFormsDirectEmbedRouteEntry),
        (0, $lIfPP.classicBusinessProformaIssueFormsDirectRouteEntry),
        (0, $d6K18.classicBusinessProformaIssueFormsDirectEmbedRouteEntry),
        (0, $gzdNI.softwareProformaIssueFormsDirectRouteEntry),
        (0, $2LfmF.softwareProformaIssueFormsDirectEmbedRouteEntry),
        (0, $hkNW0.browseIssueEmbedRouteEntry),
        (0, $1B0QU.browseIssueRouteEntry),
        (0, $6xRe5.compassProductSettingsRouteEntry),
        (0, $1hbMK.jiraHomeRouteEntry),
        (0, $c2KPY.jiraSearchRouteEntry),
        (0, $9qXuz.homeRedirectRouteEntry),
        (0, $h82Z7.homeOnboardingRedirectRouteEntry),
        (0, $hwgIz.devopsConnectedProjectRouteEntry),
        (0, $frn0U.peopleProfilesRouteEntry),
        (0, $2vUs2.trashProjectsDirectoryRedirectRouteEntry),
        (0, $16Svt.settingsAutomationRouteEntry),
        (0, $bCHhM.trashProjectsDirectoryRouteEntry),
        (0, $eaKG5.archivedProjectsDirectoryRouteEntry),
        (0, $6VvYi.projectsDirectoryRedirectRouteEntry),
        (0, $fQyGL.projectsDirectoryLegacyPathRedirectRouteEntry),
        (0, $dSrOC.projectsDirectoryRouteEntry),
        (0, $ifEj3.projectsDirectoryManageRedirectRouteEntry),
        (0, $pRrpu.manageProjectsDirectoryRouteEntry),
        (0, $4CGuj.projectsDirectoryManageRootRedirectRouteEntry),
        (0, $dH2Tp.classicProjectSettingsIssueLayoutRouteEntry),
        (0, $difFp.classicProjectSettingsDataClassificationsRouteEntry),
        (0, $64qpc.projectComponentsRedirectRouteEntry),
        (0, $87aC7.projectComponentsRouteEntry),
        (0, $6JQwt.projectSettingsComponentsRouteEntry),
        (0, $bRRmd.projectVersionsRouteEntry),
        (0, $dqjth.createProjectRouteEntry),
        (0, $dRm2C.projectSettingsVersionsRouteEntry),
        (0, $kKEWZ.projectPagesLegacyRouteEntry),
        (0, $ljItG.projectPagesRouteEntry),
        (0, $6p9ik.opsgenieScheduleRedirectRouteEntry),
        (0, $SvIen.opsgenieScheduleRouteEntry),
        (0, $2fNbh.dashboardEditRouteEntry),
        (0, $dxMNj.dashboardWallboardRouteEntry),
        (0, $1zhx7.dashboardViewRouteEntry),
        (0, $hfMX7.dashboardViewEmbedRouteEntry),
        (0, $aNsRz.dashboardsDirectoryRedirectRouteEntry),
        (0, $cmvi5.dashboardsDirectoryRouteEntry),
        (0, $3ss0y.boardsDirectoryRedirectRouteEntry),
        (0, $bNtXI.boardsDirectoryRouteEntry),
        (0, $8fgeg.filtersDirectoryRedirectRouteEntry),
        (0, $f7gaE.filtersDirectoryRouteEntry),
        (0, $dTkCg.secureFiltersDirectoryRedirectRouteEntry),
        (0, $lPLcB.personalSettingsRouteEntry),
        (0, $fH16o.generalPersonalSettingsRouteEntry),
        (0, $5YggO.notificationsPersonalSettingsRouteEntry),
        (0, $d4tTc.digestsNotificationsPersonalSettingsRouteEntry),
        (0, $g3kqr.opsNotificationsPersonalSettingsRouteEntry),
        (0, $aw22a.customerServiceEscalationsRouteEntry),
        (0, $yVbxa.customerServiceProductsRouteEntry),
        (0, $vDjHk.archivedPlansRouteEntry),
        (0, $hDCtq.trashPlansRouteEntry),
        (0, $7UDCM.trashedPlanDirectLinkRouteEntry),
        (0, $jZMnM.arjSettingsFinancialYearPageRouteEntry),
        (0, $5nA0V.planIncrementRouteEntry),
        (0, $bQ0RK.planIncrementsRouteEntry),
        (0, $9jp5b.globalSettingsCustomFieldsRouteEntry),
        (0, $427L2.globalSettingsIssuesExplicitFieldAssociationRouteEntry),
        (0, $dRexn.globalSettingsLegacyFieldLayoutRouteEntry),
        (0, $7m5aN.settingsCmdbFieldConfigRouteEntry),
        (0, $kDimk.settingsOauthCredentialsRouteEntry),
        (0, $1Ps9S.projectsRedirectRouteEntry),
        (0, $igqAf.browseProjectRedirectRouteEntry),
        (0, $7YRoH.productsJswConfigurationRouteEntry),
        (0, $i0b8q.productsJswStorageManagementRouteEntry),
        (0, $hMqu9.productsJsmOrganizationsRouteEntry),
        (0, $gtJvE.productsJsmOrganizationsDetailsRouteEntry),
        (0, $7p4oW.productsJsmConfigurationRouteEntry),
        (0, $5EloX.productsJsmComplianceRouteEntry),
        (0, $7NO6v.productsJsmKbPermissionsRouteEntry),
        (0, $GIsnE.productsJsmEmailRequestsRouteEntry),
        (0, $5uMDF.productsJcsCustomerAccessRouteEntry),
        (0, $3RvJ0.productsJcsFormFieldsRouteEntry),
        (0, $fOrUU.eocTeamCustomerLogsRouteEntry),
        (0, $bubms.eocTeamCustomerLogsDownloadRouteEntry),
        (0, $GJOha.eocApiKeyManagementRouteEntry),
        (0, $hxK6L.globalMailSettingsRouteEntry),
        (0, $fkWQj.productsJsmIncidentManagementToolsRouteEntry),
        (0, $MSc9t.productsJsmFeatureUsageRouteEntry),
        (0, $64Uyh.knowledgeHubLandingRouteEntry),
        (0, $9y8sW.knowledgeHubBrowseAllArticlesRouteEntry),
        (0, $8jDeK.knowledgeHubDraftsRouteEntry),
        (0, $825dq.knowledgeHubBrowseAllCategoriesRouteEntry),
        (0, $lrPAp.knowledgeHubSuggestedArticlesRouteEntry),
        (0, $h8swE.knowledgeHubBrowseViewArticleRouteEntry),
        (0, $kTgg2.knowledgeHubArticleEmbedEditorRouteEntry),
        (0, $eoIQt.knowledgeHubAllArticlesRouteEntry),
        (0, $agsO7.knowledgeHubArticleInCategoryRouteEntry),
        (0, $gGQIR.knowledgeHubCategoryPageRouteEntry),
        (0, $01hnS.knowledgeHubCategoryRouteEntry),
        (0, $1T4J3.knowledgeHubSearchRouteEntry),
        (0, $8hATp.knowledgeHubSetupRouteEntry),
        (0, $c97hk.servicedeskReports1RouteEntry),
        (0, $lzLcy.servicedeskAtlassianAnalyticsRouteEntry),
        (0, $4zSYf.servicedeskReportsWorkloadRouteEntry),
        (0, $cU5zd.servicedeskReportsSatisfactionIssueRouteEntry),
        (0, $fSktp.servicedeskReportsSatisfactionTimeScaleRouteEntry),
        (0, $hRN7l.servicedeskReportsSatisfaction2RouteEntry),
        (0, $auP5Z.servicedeskKbRequestsReportsIssueRouteEntry),
        (0, $6un8I.servicedeskKbRequestsReportsTimeScaleRouteEntry),
        (0, $kZgpC.servicedeskKbRequestsReports2RouteEntry),
        (0, $moUwl.servicedeskReportsCustomEditRouteEntry),
        (0, $eaXgt.servicedeskReportsCustomCreateRouteEntry),
        (0, $7D3Yv.servicedeskReportsCustomIssueRouteEntry),
        (0, $dgneZ.servicedeskReportsCustomTimeScaleRouteEntry),
        (0, $7sSEm.servicedeskReportsCustom4RouteEntry),
        (0, $5TKdO.servicedeskReportsTypeRouteEntry),
        (0, $6YHWn.servicedeskIssueRouteEntry),
        (0, $3oSi6.servicedeskQueuesLandingRouteEntry),
        (0, $fP1EY.servicedeskQueuesNewRouteEntry),
        (0, $2yO8h.servicedeskQueuesViewsConfigRouteEntry),
        (0, $fEAJ2.servicedeskPracticeViewsConfigRouteEntry),
        (0, $5JkxV.servicedeskQueuesEditRouteEntry),
        (0, $3MI0Z.customPracticeQueueCalendarRouteEntry),
        (0, $dAmDY.customPracticeQueueBoardRouteEntry),
        (0, $79qCU.customQueueCalendarRouteEntry),
        (0, $3kqBW.customQueueBoardRouteEntry),
        (0, $8brgy.customQueueRouteEntry),
        (0, $lYzgn.customIssueRouteEntry),
        (0, $jIBei.servicedeskQueuesIssueRouteEntry),
        (0, $96BnX.servicedeskQueuesManageViewRouteEntry),
        (0, $rsO8k.servicedeskQueuesAddonRouteEntry),
        (0, $gfz2f.servicedeskPracticeLandingRouteEntry),
        (0, $h51Kg.servicedeskPracticeNewRouteEntry),
        (0, $gfW60.servicedeskPracticeManageViewRouteEntry),
        (0, $aAIWh.servicedeskPracticeEditRouteEntry),
        (0, $iYfXI.customPracticeQueueRouteEntry),
        (0, $5fOtJ.servicedeskPracticeIssueRouteEntry),
        (0, $6mo9H.jsmBoardRouteEntry),
        (0, $lYrmE.servicedeskGettingStartedRouteEntry),
        (0, $izdjx.servicedeskServicesRouteEntry),
        (0, $j175z.servicedeskServiceDetailsRouteEntry),
        (0, $eWSeK.serviceDeskServicesWithoutProjectRouteEntry),
        (0, $gQWOR.serviceDeskServiceDetailsWithoutProjectRouteEntry),
        (0, $4UU5H.servicedeskServiceModalNewRouteEntry),
        (0, $zaQdk.servicedeskServiceModalEditRouteEntry),
        (0, $dCGUp.servicedeskCustomerDetailsRouteEntry),
        (0, $4KLVz.servicedeskCustomersV2RouteEntry),
        (0, $cvYE5.servicedeskOrganizationDetailsRouteEntry),
        (0, $2cpS3.servicedeskOrganizationsRouteEntry),
        (0, $iuWOh.servicedeskOrganizationV2RouteEntry),
        (0, $l1PfI.servicedeskOncallScheduleRouteEntry),
        (0, $SBgrM.servicedeskChangeCalendarRouteEntry),
        (0, $cJoBA.servicedeskCalendarRouteEntry),
        (0, $c0JOH.servicedeskProjectSummaryRouteEntry),
        // /jira/communications/stakeholders routes
        (0, $WsHyA.communicationsStakeholdersRouteEntry),
        (0, $3GuHG.communicationsStakeholderGroupsRouteEntry),
        // /jira/assets/* routes
        (0, $7kGnZ.assetsRouteEntry),
        (0, $6fdEz.assetsReportsRouteEntry),
        (0, $8WMR9.assetsReportsTemplateRouteEntry),
        (0, $hSl7U.assetsReportsUnsubscribeRouteEntry),
        (0, $9F4ID.assetsSchemaRouteEntry),
        (0, $9CT95.assetsObjectTypeConfigurationRouteEntry),
        (0, $gktyQ.assetsConfigurationRouteEntry),
        (0, $elyxq.assetsSchemaConfigurationRouteEntry),
        (0, $3T2Ye.assetsObjectRouteEntry),
        (0, $18W8Q.assetsSearchRouteEntry),
        (0, $ca1Zm.assetsDataManagerGettingStartedRouteEntry),
        (0, $6GNmk.assetsDataManagerObjectClassesRouteEntry),
        // /jira/servicedesk/assets/* routes
        (0, $kHVIE.servicedeskCmdbAssetsSchemasRouteEntry),
        (0, $aNc7A.servicedeskCmdbAssetsReportsRouteEntry),
        (0, $4e4nJ.servicedeskCmdbAssetsReportsTemplateRouteEntry),
        (0, $5nU8P.servicedeskCmdbAssetsReportsUnsubscribeRouteEntry),
        (0, $2OBp2.servicedeskCmdbAssetsObjectSchemaRouteEntry),
        (0, $29XA4.servicedeskCmdbAssetsObjectTypeConfigurationRouteEntry),
        (0, $cVgRQ.servicedeskCmdbAssetsGlobalConfigurationRouteEntry),
        (0, $5o5UE.servicedeskCmdbAssetsObjectSchemaConfigurationRouteEntry),
        (0, $8XfJX.servicedeskCmdbAssetsObjectRouteEntry),
        // /jira/servicedesk/insight/* routes
        (0, $3lpLH.servicedeskCmdbInsightRouteEntry),
        (0, $iXsus.servicedeskCmdbInsightObjectSchemaRouteEntry),
        (0, $xwXfC.servicedeskCmdbInsightObjectTypeConfigurationRouteEntry),
        (0, $eHeAh.servicedeskCmdbInsightConfigureGlobalRouteEntry),
        (0, $brWuf.servicedeskCmdbInsightObjectSchemaConfigurationRouteEntry),
        (0, $9R3is.servicedeskCmdbInsightConfigureRouteEntry),
        (0, $lKkaY.servicedeskCmdbInsightObject4RouteEntry),
        (0, $ZVu1m.notificationLogsRouteEntry),
        (0, $iLmKH.servicedeskConnectProjectRouteEntry),
        (0, $j0BAb.projectServiceDeskRouteEntry),
        (0, $awOZa.servicedeskItsmSampleSpaceRouteEntry),
        (0, $kNZj9.servicedeskCreateProjectRouteEntry),
        (0, $9CxHM.archivedProjectDirectLinkRouteEntry),
        (0, $eTL4x.selectedDashboardRouteEntry),
        (0, $56moC.dashboardRouteEntry),
        (0, $3av4N.systemDashboardEditRouteEntry),
        (0, $cwKGx.arjSettingsDependenciesRouteEntry),
        (0, $7gypr.arjSettingsDependenciesLegacyRedirectRouteEntry),
        (0, $ieqGd.arjSettingsLoadingLimitsRouteEntry),
        (0, $dfdSu.arjSettingsLoadingLimitsLegacyRedirectRouteEntry),
        (0, $JQ5Vt.arjSettingsPermissionsRouteEntry),
        (0, $eOPb5.arjSettingsPermissionsRouteLegacyRedirectRouteEntry),
        (0, $fpGzf.arjCalendarEmbedRouteEntry),
        (0, $aVGYm.arjDependenciesEmbedRouteEntry),
        (0, $2DH60.arjIncrementEmbedRouteEntry),
        (0, $a5XVU.arjSummaryEmbedRouteEntry),
        (0, $lUhpq.arjTimelineEmbedRouteEntry),
        (0, $6cMQO.softwarePlanDependenciesRouteEntry),
        (0, $8s6qp.softwarePlanSummaryRouteEntry),
        (0, $lGnoq.softwarePlanCalendarRouteEntry),
        (0, $lxXtu.softwarePlanReleasesRouteEntry),
        (0, $4chTT.softwarePlanTimelineRouteEntry),
        (0, $l0UsI.softwarePlanSettingsPermissionsRouteEntry),
        (0, $76RJj.softwarePlanSettingsSavedViewsRouteEntry),
        (0, $bdHl5.softwarePlanSettingsPlanInfoRouteEntry),
        (0, $1oew5.softwarePlanSettingsFeaturesRouteEntry),
        (0, $5hvg3.softwarePlanSettingsProgramBoardsRouteEntry),
        (0, $g7fao.softwarePlanSettingsSchedulingRouteEntry),
        (0, $ikfu9.softwarePlanSettingsScenariosRouteEntry),
        (0, $2l6sh.softwarePlanSettingsAutoSchedulerRouteEntry),
        (0, $1C9Ha.softwarePlanSettingsCustomFieldsRouteEntry),
        (0, $cChHY.softwarePlanSettingsExclusionRulesRouteEntry),
        (0, $gksya.softwarePlanSettingsIssueSourcesRouteEntry),
        (0, $d1sI7.softwarePlanSettingsFindYourIssueRouteEntry),
        (0, $6oWts.softwarePlanSettingsRemovedIssuesRouteEntry),
        (0, $qruNQ.softwarePlanTeamsRouteEntry),
        (0, $5dqn2.planViewNotFoundRouteEntry),
        (0, $5qx9W.planUpsellRouteEntry),
        (0, $2FVZu.softwareAdvancedRoadmapsGettingStartedRedirectRouteEntry),
        (0, $4AqA1.planSetupPageRouteEntry),
        (0, $eLT92.planExportPageRouteEntry),
        (0, $cgOe5.planPageRouteEntry),
        (0, $2d9QY.planPageWithoutScenarioIdRouteEntry),
        (0, $43Rln.legacyPlanPageRedirectRouteEntry),
        (0, $jj70V.planReportPageRouteEntry),
        (0, $6Z4jF.legacyPlanReportPageRedirectRouteEntry),
        (0, $cmIyb.plansDirectoryRouteEntry),
        (0, $jPcas.eocScheduleGlobalRouteEntry),
        (0, $7LUIt.eocGlobalAlertListRouteEntry),
        (0, $3EMmS.eocGlobalAlertsDetailRouteEntry),
        (0, $6q1hh.eocGlobalAlertListRedirectRouteEntry),
        (0, $4yINJ.eocTeamAlertListRouteEntry),
        (0, $k7VEf.eocTeamAlertDetailRouteEntry),
        (0, $4Ykyz.eocGlobalGroupDetailRouteEntry),
        (0, $dYoht.eocTeamGroupDetailRouteEntry),
        (0, $7mf3n.roleBasedNotificationsRouteEntry),
        (0, $4Xzif.roleBasedNotificationDetailRouteEntry),
        (0, $kvJxs.globalIncomingCallRouteEntry),
        (0, $4iFpq.globalIncomingCallDetailRouteEntry),
        (0, $g6Mf9.unlockOperationsRouteEntry),
        (0, $9bLSq.eocUserNotificationsRouteEntry),
        (0, $ktYro.teamIntegrationsRouteEntry),
        (0, $jFY66.teamIntegrationListRouteEntry),
        (0, $4BuRo.teamIntegrationCreateRouteEntry),
        (0, $6SWMv.teamIntegrationDetailRouteEntry),
        (0, $jPXYO.teamIntegrationLogRouteEntry),
        (0, $68ycU.globalIntegrationsRouteEntry),
        (0, $4mhUQ.globalIntegrationListRouteEntry),
        (0, $kxvlX.globalIntegrationCreateRouteEntry),
        (0, $0e4yJ.globalIntegrationDetailRouteEntry),
        (0, $lcAQi.globalIntegrationLogRouteEntry),
        (0, $iTGOF.alertPoliciesRouteEntry),
        (0, $adI0E.globalPoliciesRouteEntry),
        (0, $q3duL.globalEscalationsRouteEntry),
        (0, $e04XT.eocOverviewRouteEntry),
        (0, $2B61u.eocOverviewAllTeamsRouteEntry),
        (0, $75Ues.eocHeartbeatsRouteEntry),
        (0, $4Yh3B.eocGlobalHeartbeatsRouteEntry),
        (0, $jAB8i.eocMaintenanceRouteEntry),
        (0, $5H5Rm.eocGlobalMaintenanceRouteEntry),
        (0, $5KvQp.eocOnCallRedirectRouteEntry),
        (0, $3Yng9.eocOnCallRouteEntry),
        (0, $V3Ey7.whoIsOnCallRouteEntry),
        (0, $hGFnn.eocPermissionsRouteEntry),
        (0, $dHqTd.eocAutomationsRouteEntry),
        (0, $5xt55.eocTeamAlertIssueSyncingRouteEntry),
        (0, $i27Sx.eocTeamAlertIssueSyncingCreateRouteEntry),
        (0, $qjJTn.eocTeamAlertIssueSyncingDetailRouteEntry),
        (0, $dt3ZS.eocAlertIssueSyncingRouteEntry),
        (0, $hs0Ni.eocAlertIssueSyncingCreateRouteEntry),
        (0, $8m0RN.eocAlertIssueSyncingDetailRouteEntry),
        (0, $bAN0d.eocReportsTeamRedirectRouteEntry),
        (0, $dbAmH.eocReportsUnsubscribeRouteEntry),
        (0, $dQtRM.eocGlobalReportsHomePageNav4RouteEntry),
        (0, $iDxTp.eocGlobalReportsNav4RouteEntry),
        (0, $cLm5J.eocReportsTeamRouteEntry),
        (0, $9KhdI.eocCustomRolesRouteEntry),
        (0, $hDU7Y.eocAssignCustomRolesRouteEntry),
        (0, $5X0aC.productsJsmGlobalOpsReportsRouteEntry),
        (0, $bpbCg.productsJsmGlobalOpsReportsRedirectRouteEntry),
        (0, $tdrXl.productsJsmChatopsAndVideosToolsRouteEntry),
        (0, $jr7ke.sandboxBundlerRouteEntry),
        (0, $gtcNN.sandboxBundlerBifrostRLLRouteEntry),
        (0, $gMkpP.sandboxBundlerBifrostEntrypointsRouteEntry),
        (0, $8VY8F.sandboxRelayEchoPageUsingRLLRouteEntry),
        (0, $aApqk.sandboxRelayJiraPageRouteEntry),
        (0, $hPrN5.projectNotFoundRouteEntry),
        (0, $01Za6.errorsNotFoundRouteEntry),
        (0, $7MpwB.loginEmbedRouteEntry),
        (0, $2krv1.helpCenterSettingsAgentStudioActionsRouteEntry),
        (0, $8wIny.helpCenterSettingsAgentStudioChatSimulatorRouteEntry),
        (0, $6pwY1.helpCenterSettingsAgentStudioConversationReviewRouteEntry),
        (0, $gQABM.helpCenterSettingsAgentStudioHandoffRouteEntry),
        (0, $9sgxL.helpCenterSettingsAgentStudioKnowledgeRouteEntry),
        (0, $alZMU.helpCenterSettingsAgentStudioRouteEntry),
        (0, $6u3qv.helpCenterSettingsArticlesRouteEntry),
        (0, $j2SDi.helpCenterSettingsArticlesViewArticleRouteEntry),
        (0, $e48vl.helpCenterSettingsCreateArticleRouteEntry),
        (0, $kzcqd.helpCenterSettingsKbRouteEntry),
        (0, $fdHNd.helpCenterSettingsCustomerNotificationsRouteEntry),
        (0, $jSJ1v.helpCenterSettingsCustomerAccessRouteEntry),
        (0, $guURi.helpCenterSettingsDetailsRouteEntry),
        (0, $6RCDC.helpCenterSettingsEmailRouteEntry),
        (0, $avQ9D.helpCenterSettingsSupportWebsiteRouteEntry),
        (0, $f7vKZ.helpCenterSettingsSupportWebsiteOverviewRouteEntry),
        (0, $k826a.helpCenterSettingsSupportWebsitePagesRouteEntry),
        (0, $gZQLD.helpCenterSettingsFormsRouteEntry),
        (0, $9aEQn.helpCenterSettingsFormEditRouteEntry),
        (0, $lVyEk.helpCenterSettingsAnalyticsRouteEntry),
        (0, $lDuCa.helpCenterSettingsServiceHubsRouteEntry),
        (0, $duVOn.helpCenterSettingsNotFoundRouteEntry),
        (0, $hjvN4.userSegmentationRouteEntry),
        (0, $4VMm4.rovoSearchRouteEntry),
        (0, $3Ro2a.applinksExtraAuthHealthcheckRouteEntry),
        (0, $734Wz.productsOnboardingHubRouteEntry),
        // [WARNING]: This route should be the last route.
        // This route redirects to the monolith for all routes we cannot match.
        // It is purposefully missing a path so it always matches and therefore needs to be last.
        // [WARNING]: Please don't add a new route below this. If you want to add, please contact the package owner team.
        (0, $ghGCX.legacyRedirectRouteEntry)
    ];

});
parcelRegister("aNke7", function(module, exports) {

$parcel$export(module.exports, "globalSettingsContactAdministratorRouteEntry", () => $2f78657934c6661f$export$d213125be8246eea);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $emDul = parcelRequire("emDul");

var $ksIuv = parcelRequire("ksIuv");
const $2f78657934c6661f$export$d213125be8246eea = (0, $7NszV.createEntry)((0, $emDul.globalSettingsContactAdministratorRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.contact-administrator',
        component: (0, $ksIuv.default),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ksIuv.LazyContactAdministratorPage)
        ]
    }));

});
parcelRegister("ffza4", function(module, exports) {

$parcel$export(module.exports, "LazyAtlassianNavigation", () => $772c987a24839dcf$export$4caed23aa0274abb);

var $fDtbf = parcelRequire("fDtbf");

var $2SVPM = parcelRequire("2SVPM");

var $kxZPA = parcelRequire("kxZPA");

const $772c987a24839dcf$export$4caed23aa0274abb = (0, $kxZPA.lazyForPaint)(()=>{
    const bundleReady = Promise.resolve((parcelRequire("9DfkH"))).then(({ AtlassianNavigation: AtlassianNavigation })=>AtlassianNavigation);
    if (!false) bundleReady.then(()=>{
        (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.bundle-ready', 'jira-spa.js:eval-stop');
        const resources = performance.getEntriesByType('mark');
        for(let i = resources.length - 1; i >= 0; i -= 1)if ((resources[i].name.startsWith('async-navigation') || resources[i].name.startsWith('async-atlassian-navigation')) && resources[i].name.endsWith((0, $fDtbf.JS_EVAL_START))) {
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.eval', resources[i].name);
            break;
        }
    });
    return bundleReady;
}, {
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/index.tsx"
});

});

parcelRegister("emDul", function(module, exports) {

$parcel$export(module.exports, "globalSettingsContactAdministratorRoute", () => $f70c16094aab0919$export$146910ddc36bf151);
const $f70c16094aab0919$export$146910ddc36bf151 = {
    name: 'global-settings-contact-administrator',
    path: '/jira/contact-administrator'
};

});

parcelRegister("ksIuv", function(module, exports) {

$parcel$export(module.exports, "LazyContactAdministratorPage", () => $817988e9accf1b9b$export$bf75747a931b9a2b);
$parcel$export(module.exports, "default", () => $817988e9accf1b9b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $817988e9accf1b9b$export$bf75747a931b9a2b = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("1kc0A"))), {
    moduleId: "./src/packages/admin-pages/contact-administrator/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$817988e9accf1b9b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $817988e9accf1b9b$export$bf75747a931b9a2b,
        pageId: "jira-admin-pages-contact-administrator",
        shouldShowSpinner: true
    });

});
parcelRegister("7yO8g", function(module, exports) {

$parcel$export(module.exports, "markAsProductBundleReady", () => $beda9c6123873bbb$export$ff83c57004505abd);

var $2SVPM = parcelRequire("2SVPM");
const $beda9c6123873bbb$export$ff83c57004505abd = (importedBundle)=>{
    if (!false) importedBundle.then(()=>{
        (0, $2SVPM.setProductBundleReadyForInitialRender)();
    });
    return importedBundle;
};

});

parcelRegister("5j7Th", function(module, exports) {

$parcel$export(module.exports, "LazyPage", () => $63937a96c08aaddb$export$a18c9c3dd309b8e6);

var $5uXOq = parcelRequire("5uXOq");

var $kb4zh = parcelRequire("kb4zh");

var $2YZCu = parcelRequire("2YZCu");

var $lfTZh = parcelRequire("lfTZh");

var $6jY6G = parcelRequire("6jY6G");

var $7LpuY = parcelRequire("7LpuY");

var $dZw8H = parcelRequire("dZw8H");

var $4R6GH = parcelRequire("4R6GH");

var $egPYN = parcelRequire("egPYN");
const $63937a96c08aaddb$var$LOCATION = 'lazy-page';
const $63937a96c08aaddb$export$fb85bbdbfb3e6869 = ()=>null;
const $63937a96c08aaddb$export$a18c9c3dd309b8e6 = ({ pageId: pageId, Page: Page, shouldShowSpinner: shouldShowSpinner = true })=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const Skeleton = route.skeleton || (shouldShowSpinner ? (0, $kb4zh.default) : $63937a96c08aaddb$export$fb85bbdbfb3e6869);
    (0, $5uXOq.useEffect)(()=>{
        if (route.isRedirect) (0, $2YZCu.default).safeWarnWithoutCustomerData($63937a96c08aaddb$var$LOCATION, `LazyPage was used inside a redirect component: ${route.name}`);
    }, [
        route.isRedirect,
        route.name
    ]);
    const fallback = (0, $4R6GH.fg)('jfp_magma_jira-ssr-fail-detection') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Skeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $egPYN.ReportSSRFailOnUse), {
        pageId: pageId
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Skeleton, null);
    const page = (0, $4R6GH.fg)('jfp_magma_jira-ssr-fail-detection') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $egPYN.DisableSSRFailDetection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Page, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Page, null);
    return route.isRedirect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "lazy_page_redirect",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Page, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7LpuY.default), {
        pageId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStateContainer), {
        isGlobal: true,
        appId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStateAppStartWithMatchCheck), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "lazy_page",
        fallback: fallback
    }, page)));
};

});

parcelRegister("1kc0A", function(module, exports) {

let $0f70f94fa98dc7bf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0f70f94fa98dc7bf$var$load("6hbnn").then(()=>parcelRequire('dnrkU'));

});



parcelRegister("Dkaoj", function(module, exports) {

$parcel$export(module.exports, "emailNotificationsLogAccessRouteEntry", () => $9945f9dd9a251453$export$4d57b993ce36e7b2);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $dmx0y = parcelRequire("dmx0y");

var $jsJ7J = parcelRequire("jsJ7J");

var $hBziA = parcelRequire("hBziA");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $5pSYQ = parcelRequire("5pSYQ");
const $9945f9dd9a251453$var$emailNotificationsLogEntryPointPage = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $hBziA.notificationLogsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).SETTINGS
});

const $9945f9dd9a251453$var$LazyNotificationLogsType = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("fGezR"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/notification-logs/src/index.tsx"
});
const $9945f9dd9a251453$var$NotificationLogs = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9945f9dd9a251453$var$LazyNotificationLogsType,
        pageId: "Notification Logs",
        shouldShowSpinner: false
    });
const $9945f9dd9a251453$export$4d57b993ce36e7b2 = (0, $7NszV.createEntry)((0, $jsJ7J.emailNotificationsLogAccessRoute), ()=>({
        group: 'global-settings',
        component: $9945f9dd9a251453$var$NotificationLogs,
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $dmx0y.systemConfigurationGeneralResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $9945f9dd9a251453$var$LazyNotificationLogsType
        ],
        pageId: 'admin-settings-email-notifications-log',
        entryPoint () {
            return $9945f9dd9a251453$var$emailNotificationsLogEntryPointPage;
        }
    }));

});
parcelRegister("lkFvK", function(module, exports) {

$parcel$export(module.exports, "createChromelessEntryPoint", () => $6a0b20679c309df7$export$56ea489e9d4bfa04);
$parcel$export(module.exports, "createPageEntryPoint", () => $6a0b20679c309df7$export$955a7619d2679b4c);

var $adY3A = parcelRequire("adY3A");


var $3HwlS = parcelRequire("3HwlS");

var $4R6GH = parcelRequire("4R6GH");
const $6a0b20679c309df7$export$56ea489e9d4bfa04 = (page)=>({
        root: page.main.root,
        getPreloadProps: (entryPointParams)=>({
                entryPoints: {
                    [(0, $6d6ccf8a2b2c5b3c$export$900ddb492c628f48)]: {
                        entryPoint: page.main,
                        entryPointParams: entryPointParams
                    }
                }
            }),
        toString: ()=>'ChromelessEntryPoint'
    });
const $6a0b20679c309df7$export$955a7619d2679b4c = (page)=>({
        root: page.main.root,
        getPreloadProps: (entryPointParams)=>({
                entryPoints: {
                    [(0, $6d6ccf8a2b2c5b3c$export$900ddb492c628f48)]: {
                        entryPoint: page.main,
                        entryPointParams: entryPointParams
                    },
                    [(0, $6d6ccf8a2b2c5b3c$export$bec6dca2e63de4ae)]: {
                        entryPoint: (0, $adY3A.topNavigationEntryPoint),
                        entryPointParams: {
                            menuId: page.topNavigationMenuId
                        }
                    },
                    ...page.leftSidebar && (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route') ? {
                        [(0, $6d6ccf8a2b2c5b3c$export$50ea883ba6f28ff5)]: {
                            entryPoint: page.leftSidebar.sidebar,
                            entryPointParams: {
                                ...entryPointParams,
                                entryPoints: {
                                    ...page.leftSidebar.entryPoints ? $6a0b20679c309df7$var$injectEntryPointParams(page.leftSidebar.entryPoints, entryPointParams) : undefined
                                },
                                isAppsExpanded: page.leftSidebar.isAppsExpanded ?? false,
                                isFiltersExpanded: page.leftSidebar.isFiltersExpanded ?? false,
                                isPlansExpanded: page.leftSidebar.isPlansExpanded ?? false,
                                isProjectsExpanded: page.leftSidebar.isProjectsExpanded ?? false,
                                isOperationsExpanded: page.leftSidebar.isOperationsExpanded ?? false,
                                isOverviewsExpanded: page.leftSidebar.isOverviewsExpanded ?? false
                            }
                        }
                    } : undefined,
                    ...page.horizontalNavigation && (0, $3HwlS.getWillShowNav4)() ? {
                        [(0, $6d6ccf8a2b2c5b3c$export$948d4d345566aed3)]: {
                            entryPoint: page.horizontalNavigation,
                            entryPointParams: {
                                ...entryPointParams,
                                fallback: page.horizontalNavigationFallback
                            }
                        }
                    } : undefined,
                    ...page.rightSidebar ? {
                        [(0, $6d6ccf8a2b2c5b3c$export$7bf43119a6b49ddb)]: {
                            entryPoint: page.rightSidebar,
                            entryPointParams: {
                                ...entryPointParams,
                                fallback: page.rightSidebarFallback
                            }
                        }
                    } : undefined
                }
            }),
        toString: ()=>'PageEntryPoint'
    });
function $6a0b20679c309df7$var$injectEntryPointParams(obj, entryPointParams) {
    const newParams = {};
    // https://stackoverflow.com/a/16735184
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) newParams[prop] = {
        entryPoint: obj[prop].entryPoint,
        entryPointParams: entryPointParams
    };
    return newParams;
}

});
const $6d6ccf8a2b2c5b3c$export$948d4d345566aed3 = '__pageLayoutHorizontalNavigation';
const $6d6ccf8a2b2c5b3c$export$50ea883ba6f28ff5 = '__pageLayoutLeftSidebar';
const $6d6ccf8a2b2c5b3c$export$900ddb492c628f48 = '__pageLayoutMainContent';
const $6d6ccf8a2b2c5b3c$export$bec6dca2e63de4ae = '__pageLayoutTopNavigation';
const $6d6ccf8a2b2c5b3c$export$7bf43119a6b49ddb = '__pageLayoutRightSidebar';


parcelRegister("dmx0y", function(module, exports) {

$parcel$export(module.exports, "systemConfigurationGeneralResource", () => $3e822b05b84662f2$export$b622f7400bfafd0d);

var $2M1hQ = parcelRequire("2M1hQ");


const $3e822b05b84662f2$export$b622f7400bfafd0d = (0, $2M1hQ.createResource)({
    type: (0, $3d90c62269ed88a0$export$e780b172f774b673),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("6HjLU"))
});

});
const $3d90c62269ed88a0$export$e780b172f774b673 = 'RESOURCE_TYPE_SYSTEM_CONFIGURATION_GENERAL';

parcelRegister("6HjLU", function(module, exports) {

let $4e06187d5534f5d2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4e06187d5534f5d2$var$load("al8If").then(()=>parcelRequire('khTCh'));

});


parcelRegister("jsJ7J", function(module, exports) {

$parcel$export(module.exports, "emailNotificationsLogAccessRoute", () => $acdb6757893e541c$export$aed294a4a292b909);
const $acdb6757893e541c$export$aed294a4a292b909 = {
    name: 'global-admin-helper-email-notifications-log',
    path: '/jira/settings/system/notification-logs',
    exact: true
};

});

parcelRegister("hBziA", function(module, exports) {

$parcel$export(module.exports, "notificationLogsEntryPoint", () => $e96cd1acff95af13$export$818d841e00bb3749);

var $aGYm3 = parcelRequire("aGYm3");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $e96cd1acff95af13$export$818d841e00bb3749 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("fGezR")), {
        moduleId: "d533cc53"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                notificationLogs: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $aGYm3.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectIds: context?.query?.projectId,
                        notificationType: 'INTERNAL_NOTIFICATION',
                        notificationActionType: 'USER_INVITE',
                        recipientId: ''
                    }
                }
            },
            extraProps: {
                accountId: tenantContext.atlassianAccountId
            }
        })
});

});
parcelRegister("aGYm3", function(module, exports) {

$parcel$export(module.exports, "default", () => $25a34f05175c2102$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6106f34f1da05e19191cff41bffd4296>>
 * @relayHash 1d90cf309bc3da9c32297c3b1e952819
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 71e1f26fd67e2af410f2d8354171d8867b0efd6546709fc85bec1419f20e5b6d
const $25a34f05175c2102$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "71e1f26fd67e2af410f2d8354171d8867b0efd6546709fc85bec1419f20e5b6d",
        "metadata": {},
        "name": "uiNotificationLogsPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $25a34f05175c2102$export$2e2bcd8739ae039 = $25a34f05175c2102$var$node;

});

parcelRegister("fGezR", function(module, exports) {

let $b6a6160a5664c85f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b6a6160a5664c85f$var$load("jTCUX").then(()=>parcelRequire('ktpmL'));

});



parcelRegister("fMVEG", function(module, exports) {

$parcel$export(module.exports, "externalImportRouteEntry", () => $88a6b2c74571ee4b$export$d55ce647d8216437);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $4j39S = parcelRequire("4j39S");

var $5pSYQ = parcelRequire("5pSYQ");

var $5ZnBW = parcelRequire("5ZnBW");
const $88a6b2c74571ee4b$export$d55ce647d8216437 = (0, $7NszV.createEntry)((0, $4j39S.externalImportRoute), ()=>({
        group: 'global-settings',
        component: (0, $5ZnBW.default),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("4j39S", function(module, exports) {

$parcel$export(module.exports, "externalImportRoute", () => $105ac7e3a2002ccc$export$17c79100fc4c65a1);
const $105ac7e3a2002ccc$export$17c79100fc4c65a1 = {
    name: 'external-import',
    path: '/jira/settings/system/external-import'
};

});

parcelRegister("5ZnBW", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b72a6c6c5d8947e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7b72a6c6c5d8947e$var$LazyExternalImport = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("1UROs")), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/admin-pages/external-import/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7b72a6c6c5d8947e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $7b72a6c6c5d8947e$var$LazyExternalImport,
        pageId: "external-import-general",
        shouldShowSpinner: false
    });

});
parcelRegister("1UROs", function(module, exports) {

let $1654c37d289b9485$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1654c37d289b9485$var$load("kVX56"),
    $1654c37d289b9485$var$load("76n7a"),
    $1654c37d289b9485$var$load("l253H"),
    $1654c37d289b9485$var$load("3yAl4"),
    $1654c37d289b9485$var$load("ffQaD"),
    $1654c37d289b9485$var$load("kvRbA"),
    $1654c37d289b9485$var$load("8iRhF")
]).then(()=>parcelRequire('lBo8Z'));

});



parcelRegister("4BdYV", function(module, exports) {

$parcel$export(module.exports, "globalSettingsGlobalPermissionsRouteEntry", () => $29ac5183332fb76e$export$34203273711b537f);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $kiD5R = parcelRequire("kiD5R");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $1U35o = parcelRequire("1U35o");

var $5lsNZ = parcelRequire("5lsNZ");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $5pSYQ = parcelRequire("5pSYQ");

const $29ac5183332fb76e$var$LazyGlobalPermissions = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("jk5Cq"))), {
    moduleId: "./src/packages/permissions-administration/pages/global-permissions/src/index.tsx"
});
const $29ac5183332fb76e$var$LazyGlobalPermissionsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $29ac5183332fb76e$var$LazyGlobalPermissions,
        pageId: "jira-global-permissions",
        shouldShowSpinner: true
    });
const $29ac5183332fb76e$export$34203273711b537f = (0, $7NszV.createEntry)((0, $1U35o.globalSettingsGlobalPermissionsRoute), ()=>({
        group: 'global-settings',
        component: (0, $cSD7y.componentWithFG)('olympus-global-permissions-fe-modernisation', $29ac5183332fb76e$var$LazyGlobalPermissionsPage, (0, $5lsNZ.default)),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $kiD5R.globalPermissionsResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        canTransitionIn: ()=>(0, $4R6GH.fg)('olympus-global-permissions-fe-modernisation'),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $29ac5183332fb76e$var$LazyGlobalPermissions
        ],
        meta: {
            reporting: {
                id: 'GlobalPermissions',
                packageName: 'jiraAdminPagesGlobalPermissions',
                teamName: 'gordian'
            }
        }
    }));

});
parcelRegister("ibkIl", function(module, exports) {

$parcel$export(module.exports, "globalSettingsLayout", () => $3eb51436f6201a33$export$e6aef6083548e882);

var $2BrOV = parcelRequire("2BrOV");

var $aPfsS = parcelRequire("aPfsS");
const $3eb51436f6201a33$export$e6aef6083548e882 = (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout));

});

parcelRegister("kiD5R", function(module, exports) {

$parcel$export(module.exports, "globalPermissionsResource", () => $896d1d986bb0ea74$export$9a5d1bc1ff678482);

var $ao2h1 = parcelRequire("ao2h1");

var $5Uo2r = parcelRequire("5Uo2r");
const $896d1d986bb0ea74$var$RESOURCE_TYPE_GLOBAL_PERMISSIONS = 'GLOBAL_PERMISSIONS';
const $896d1d986bb0ea74$export$9a5d1bc1ff678482 = (0, $ao2h1.createRelayResource)({
    type: $896d1d986bb0ea74$var$RESOURCE_TYPE_GLOBAL_PERMISSIONS,
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $5Uo2r.default),
            variables: {
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("5Uo2r", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed1cca93794a5156$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5f014b4044459efb94c4edb99f926dd1>>
 * @relayHash 402a674bdd82767605c36953e2732f07
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5b2ad70438dbcc77ff45c7608ecd4e7382a18aa895a82fd26e83279a282b7ab6
const $ed1cca93794a5156$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "main_globalPermissionsAndGrantsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "globalPermissionsAndGrants",
                                    "args": v1 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "getGlobalPermissionsAndGrants",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "globalPermissionsTable_globalPermissions"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "grantPermissionDialog_globalPermissions"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.globalPermissionsAndGrants"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "main_globalPermissionsAndGrantsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "globalPermissionsAndGrants",
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "getGlobalPermissionsAndGrants",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraGlobalPermissionGrants",
                                            "kind": "LinkedField",
                                            "name": "globalPermissionGrants",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraGlobalPermission",
                                                    "kind": "LinkedField",
                                                    "name": "permission",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isManagedByJira"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraGroup",
                                                    "kind": "LinkedField",
                                                    "name": "groups",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "groupId"
                                                        },
                                                        v2 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraGlobalPermissionGrantsList"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5b2ad70438dbcc77ff45c7608ecd4e7382a18aa895a82fd26e83279a282b7ab6",
            "metadata": {},
            "name": "main_globalPermissionsAndGrantsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ed1cca93794a5156$var$node.hash = "9f1b7eb98b606c41655e4fa1f200a351";
var $ed1cca93794a5156$export$2e2bcd8739ae039 = $ed1cca93794a5156$var$node;

});


parcelRegister("1U35o", function(module, exports) {

$parcel$export(module.exports, "globalSettingsGlobalPermissionsRoute", () => $efa019df4aa72b9f$export$236ce89eb737f752);
const $efa019df4aa72b9f$export$236ce89eb737f752 = {
    name: 'global-settings-global-permissions',
    path: '/secure/admin/global-permissions'
};

});

parcelRegister("5lsNZ", function(module, exports) {

$parcel$export(module.exports, "LazyNotFoundErrorPage", () => $5ed1828a3f7dd5a7$export$57c5c0b5a0cdb5b7);
$parcel$export(module.exports, "default", () => $5ed1828a3f7dd5a7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $5ed1828a3f7dd5a7$export$57c5c0b5a0cdb5b7 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("aLClV")), {
    moduleId: "./src/packages/spa-apps/error-pages/not-found/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5ed1828a3f7dd5a7$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $5ed1828a3f7dd5a7$export$57c5c0b5a0cdb5b7,
        pageId: "errors-404",
        shouldShowSpinner: false
    });

});
parcelRegister("aLClV", function(module, exports) {

let $7d6c0b3350f37fc7$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $7d6c0b3350f37fc7$var$load("7mIf9"),
    $7d6c0b3350f37fc7$var$load("jXweD"),
    $7d6c0b3350f37fc7$var$load("jbxE1"),
    $7d6c0b3350f37fc7$var$load("7imUH"),
    $7d6c0b3350f37fc7$var$load("kVX56"),
    $7d6c0b3350f37fc7$var$load("76n7a"),
    $7d6c0b3350f37fc7$var$load("l253H"),
    $7d6c0b3350f37fc7$var$load("ffQaD"),
    $7d6c0b3350f37fc7$var$load("kvRbA"),
    $7d6c0b3350f37fc7$var$load("kNFvF"),
    $7d6c0b3350f37fc7$var$load("lCGtA")
]).then(()=>parcelRequire('6iSaB'));

});


parcelRegister("jk5Cq", function(module, exports) {

let $e1143e525b0b7144$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e1143e525b0b7144$var$load("2F9b6").then(()=>parcelRequire('csGky'));

});


parcelRegister("laDqO", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueHierarchyRedirectRouteEntry", () => $7b04b3e8e151f1c0$export$ce3302d254f9c0b4);

var $5uXOq = parcelRequire("5uXOq");

var $g87MG = parcelRequire("g87MG");

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $gTOS3 = parcelRequire("gTOS3");

var $ds5qV = parcelRequire("ds5qV");

var $dKJVX = parcelRequire("dKJVX");
const $7b04b3e8e151f1c0$export$ce3302d254f9c0b4 = (0, $7NszV.createEntry)((0, $gTOS3.globalSettingsIssueHierarchyRedirectRoute), ()=>({
        group: 'global-settings',
        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
                to: "/jira/settings/issues/issue-hierarchy"
            }),
        isRedirect: true,
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $g87MG.issueHierarchyPageResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $dKJVX.LazyIssueHierarchyDirectory)
        ]
    }));

});
parcelRegister("g87MG", function(module, exports) {

$parcel$export(module.exports, "issueHierarchyPageResource", () => $6f06dee5876402c3$export$98d50a2e19509817);

var $ao2h1 = parcelRequire("ao2h1");

var $7a4aR = parcelRequire("7a4aR");
const $6f06dee5876402c3$export$98d50a2e19509817 = (0, $ao2h1.createRelayResource)({
    type: 'RESOURCE1',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $7a4aR.default),
            variables: {
                cloudId: tenantContext.cloudId
            }
        })
});

});
parcelRegister("7a4aR", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ea8bf05e90a48f8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8302ec971b0cf37e40bca801469af6c9>>
 * @relayHash 6acb7af1e94f5345e9b36a8cd44c4bee
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b990d47758e2cd9b24e5dbee104f873a7f1b2aead336e44568500c9564afe54b
const $0ea8bf05e90a48f8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "level"
    }, v4 = [
        {
            "concreteType": "JiraIssueTypeHierarchyLevel",
            "kind": "LinkedField",
            "name": "hierarchyLevel",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ]
        },
        {
            "concreteType": "JiraIssueTypeConnection",
            "kind": "LinkedField",
            "name": "cmpIssueTypes",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "issueTypeId"
                                },
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                    "kind": "LinkedField",
                                    "name": "hierarchy",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "small"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v5 = {
        "concreteType": "JiraHierarchyConfigError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "code"
            },
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v6 = {
        "args": v1 /*: any*/ ,
        "concreteType": "JiraIssueHierarchyConfigurationQuery",
        "kind": "LinkedField",
        "name": "issueHierarchyConfig",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueHierarchyConfigData",
                "kind": "LinkedField",
                "name": "data",
                "plural": true,
                "selections": v4 /*: any*/ 
            },
            {
                "kind": "ScalarField",
                "name": "success"
            },
            v5 /*: any*/ 
        ]
    }, v7 = {
        "args": v1 /*: any*/ ,
        "concreteType": "JiraIssueHierarchyLimits",
        "kind": "LinkedField",
        "name": "issueHierarchyLimits",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "maxLevels"
            },
            {
                "kind": "ScalarField",
                "name": "nameLength"
            }
        ]
    }, v8 = {
        "args": v1 /*: any*/ ,
        "kind": "ScalarField",
        "name": "lockedIssueTypeIds"
    }, v9 = {
        "concreteType": "JiraIssueHierarchyConfigData",
        "kind": "LinkedField",
        "name": "issueHierarchyConfig",
        "plural": true,
        "selections": v4 /*: any*/ 
    }, v10 = {
        "concreteType": "JiraLongRunningTaskProgress",
        "kind": "LinkedField",
        "name": "taskProgress",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "status"
            },
            {
                "kind": "ScalarField",
                "name": "progress"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainIssueHierarchyQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraHierarchyConfigTask",
                            "kind": "LinkedField",
                            "name": "issueHierarchyConfigUpdateTask",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "kind": "FragmentSpread",
                                    "name": "saveButton_adminPagesIssueHierarchyDirectory"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "saveDialog_adminPagesIssueHierarchyDirectory"
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainIssueHierarchyQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraHierarchyConfigTask",
                            "kind": "LinkedField",
                            "name": "issueHierarchyConfigUpdateTask",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b990d47758e2cd9b24e5dbee104f873a7f1b2aead336e44568500c9564afe54b",
            "metadata": {},
            "name": "mainIssueHierarchyQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0ea8bf05e90a48f8$var$node.hash = "e780e64aedcd2278004df68a042f1343";
var $0ea8bf05e90a48f8$export$2e2bcd8739ae039 = $0ea8bf05e90a48f8$var$node;

});


parcelRegister("78U7j", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f593a4193eb44f7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

const $4f593a4193eb44f7$var$LazyGlobalIssuesSettingsSidebar = (0, $kxZPA.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("5V3sW")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-issues/src/index.tsx"
});
const $4f593a4193eb44f7$var$GlobalIssuesSettingsSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "globalIssuesSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4f593a4193eb44f7$var$LazyGlobalIssuesSettingsSidebar, null)));
var $4f593a4193eb44f7$export$2e2bcd8739ae039 = $4f593a4193eb44f7$var$GlobalIssuesSettingsSidebar;

});
parcelRegister("5V3sW", function(module, exports) {

let $44f4f6de07080a55$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $44f4f6de07080a55$var$load("ffQaD"),
    $44f4f6de07080a55$var$load("kvRbA"),
    $44f4f6de07080a55$var$load("76n7a"),
    $44f4f6de07080a55$var$load("l253H"),
    $44f4f6de07080a55$var$load("59e6p")
]).then(()=>parcelRequire('dZptX'));

});


parcelRegister("gTOS3", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueHierarchyRedirectRoute", () => $68115cd41df3c3dd$export$6236a41e09bb858a);
const $68115cd41df3c3dd$export$6236a41e09bb858a = {
    name: 'global-settings-issues-hierarchy-redirect',
    path: '/secure/PortfolioHierarchy.jspa'
};

});

parcelRegister("ds5qV", function(module, exports) {

$parcel$export(module.exports, "ScreenRedirect", () => $7599a608c0c710a3$export$fdd3e60cd227c2f7);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $bVDE5 = parcelRequire("bVDE5");

var $7tQej = parcelRequire("7tQej");
var $doZTA = parcelRequire("doZTA");
const $7599a608c0c710a3$export$fdd3e60cd227c2f7 = ({ to: to, persistSearchParams: persistSearchParams = true })=>{
    const [{ route: route, location: location, query: query }] = (0, $doZTA.useRouter)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ isInitialRender: isInitial }] = (0, $bVDE5.useSpaStateTransition)();
    const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
    (0, $5uXOq.useEffect)(()=>{
        if (!route || !eventRef.current) return;
        (0, $8zOmE.fireUIAnalytics)(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        route,
        isInitial
    ]);
    if (Array.isArray(persistSearchParams)) {
        const persistParams = Object.keys(query) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((result, currentKey)=>{
            const shouldPersist = persistSearchParams.some((persistKey)=>currentKey.includes(persistKey));
            if (shouldPersist) result.push(`${currentKey}=${query[currentKey]}`);
            return result;
        }, []).join('&');
        if (persistParams !== '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: `${to}?${persistParams}`
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: to
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `${to}${persistSearchParams ? location.search : ''}`
    });
};

});

parcelRegister("dKJVX", function(module, exports) {

$parcel$export(module.exports, "LazyIssueHierarchyDirectory", () => $1c0ab549b6b1a06b$export$1ff7255ab4f7a2dd);
$parcel$export(module.exports, "default", () => $1c0ab549b6b1a06b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $1c0ab549b6b1a06b$export$1ff7255ab4f7a2dd = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("d3AjZ"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/issue-types/issue-hierarchy-directory/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1c0ab549b6b1a06b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $1c0ab549b6b1a06b$export$1ff7255ab4f7a2dd,
        pageId: "jira-admin-pages-issue-hierarchy-directory",
        shouldShowSpinner: true
    });

});
parcelRegister("d3AjZ", function(module, exports) {

let $9817bad84dd9ca33$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9817bad84dd9ca33$var$load("W0knM").then(()=>parcelRequire('7PW51'));

});



parcelRegister("2pvey", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueHierarchyRouteEntry", () => $7693e36a7d632143$export$119e5b48edcee4ff);

var $g87MG = parcelRequire("g87MG");

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $hrUKH = parcelRequire("hrUKH");

var $5pSYQ = parcelRequire("5pSYQ");

var $dKJVX = parcelRequire("dKJVX");
const $7693e36a7d632143$export$119e5b48edcee4ff = (0, $7NszV.createEntry)((0, $hrUKH.globalSettingsIssueHierarchyRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.issue-hierarchy-config',
        component: (0, $dKJVX.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $g87MG.issueHierarchyPageResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $dKJVX.LazyIssueHierarchyDirectory)
        ]
    }));

});
parcelRegister("hrUKH", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueHierarchyRoute", () => $b0028908d5aa290a$export$2c220ed11ae62e14);
const $b0028908d5aa290a$export$2c220ed11ae62e14 = {
    name: 'global-settings-issues-hierarchy-view',
    path: '/jira/settings/issues/issue-hierarchy'
};

});


parcelRegister("lgfw1", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueTypesRouteEntry", () => $c4b1c133efa61697$export$680243b058188dc0);

var $hjmEZ = parcelRequire("hjmEZ");

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $doDFU = parcelRequire("doDFU");

var $5pSYQ = parcelRequire("5pSYQ");

var $d9kjz = parcelRequire("d9kjz");
const $c4b1c133efa61697$export$680243b058188dc0 = (0, $7NszV.createEntry)((0, $doDFU.globalSettingsIssueTypesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.issue-types',
        component: (0, $d9kjz.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $hjmEZ.issueTypesResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $d9kjz.LazyIssueTypesDirectory)
        ]
    }));

});
parcelRegister("hjmEZ", function(module, exports) {

$parcel$export(module.exports, "issueTypesResource", () => $0c72c798ed369d5b$export$614e9d897c1ef917);

var $ebyGx = parcelRequire("ebyGx");

var $2M1hQ = parcelRequire("2M1hQ");

var $kXy4X = parcelRequire("kXy4X");
const $0c72c798ed369d5b$export$614e9d897c1ef917 = (0, $2M1hQ.createResource)({
    type: 'GLOBAL_ADMIN_ISSUE_TYPES_DIRECTORY',
    getKey: ()=>'issue types',
    getData: async ({ query: query })=>(0, $kXy4X.getIssueTypes)((0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(query))
});

});
parcelRegister("kXy4X", function(module, exports) {

$parcel$export(module.exports, "getIssueTypes", () => $8b29c26e18cf4514$export$4cf4b24b88599615);

var $ebyGx = parcelRequire("ebyGx");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");


var $6tPCs = parcelRequire("6tPCs");
const $8b29c26e18cf4514$export$4cf4b24b88599615 = async (qs)=>{
    const filter = (0, $6tPCs.fromUrlTransformer)((0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(qs));
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify((0, $6tPCs.toApiUrlTransformer)(filter));
    try {
        return await (0, $7f4tk.default)(`/rest/internal/3/issuetype/search?${query}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'getIssueTypesRequest',
                packageName: (0, $f4edca700b2e0273$export$4adfbb237b083187),
                teamName: 'morphinecake'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
const $f4edca700b2e0273$export$4adfbb237b083187 = 'jiraAdminPagesIssueTypesResources';

parcelRegister("6tPCs", function(module, exports) {

$parcel$export(module.exports, "toUrlTransformer", () => $ddf87573da5ca99a$export$5b9f8ed2c34be88a);
$parcel$export(module.exports, "fromUrlTransformer", () => $ddf87573da5ca99a$export$bec67ef860c0d0e1);
$parcel$export(module.exports, "toSearchFilterQsTransformer", () => $ddf87573da5ca99a$export$bcd1ab210547e2f5);
$parcel$export(module.exports, "toSortFieldFilterQsTransformer", () => $ddf87573da5ca99a$export$c114848fa733e5c4);
$parcel$export(module.exports, "toSortDirectionFilterQsTransformer", () => $ddf87573da5ca99a$export$c5d2609f8b4048d3);
$parcel$export(module.exports, "toApiUrlTransformer", () => $ddf87573da5ca99a$export$fb15afa686993f11);

var $dfl35 = parcelRequire("dfl35");

var $ebyGx = parcelRequire("ebyGx");



var $aud83 = parcelRequire("aud83");

var $eou7E = parcelRequire("eou7E");

var $iPfOK = parcelRequire("iPfOK");
const $ddf87573da5ca99a$var$sortDirectionMap = {
    [(0, $2a9e000a443b1a95$export$1dee026a19752d6b).toLowerCase()]: (0, $2a9e000a443b1a95$export$1dee026a19752d6b),
    [(0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65).toLowerCase()]: (0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65)
};
const $ddf87573da5ca99a$var$sortFieldMap = {
    [(0, $b140ee73c9ccd026$export$3c5e605ca7ade9f2).toLowerCase()]: (0, $b140ee73c9ccd026$export$3c5e605ca7ade9f2),
    [(0, $b140ee73c9ccd026$export$7673664bdc3ae979).toLowerCase()]: (0, $b140ee73c9ccd026$export$7673664bdc3ae979)
};
const $ddf87573da5ca99a$export$5b9f8ed2c34be88a = (filter)=>filter ? {
        page: filter.page !== undefined && filter.page >= 1 ? String(filter.page) : undefined,
        sortDirection: (0, $eou7E.fieldToParam)(filter.sortDirection),
        sortField: (0, $eou7E.fieldToParam)(filter.sortField),
        searchFilter: (0, $eou7E.trimSearchFilter)(filter.searchFilter)
    } : {};
const $ddf87573da5ca99a$export$bec67ef860c0d0e1 = (params)=>({
        page: Math.floor(Number((0, $aud83.number).parse(params.page))) || undefined,
        searchFilter: (0, $eou7E.trimSearchFilter)(params.searchFilter),
        sortDirection: (0, $eou7E.fieldFromParam)($ddf87573da5ca99a$var$sortDirectionMap, params.sortDirection),
        sortField: (0, $eou7E.fieldFromParam)($ddf87573da5ca99a$var$sortFieldMap, params.sortField)
    });
const $ddf87573da5ca99a$export$bcd1ab210547e2f5 = (qs)=>{
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(qs);
    return parsed.searchFilter ? parsed.searchFilter : '';
};
const $ddf87573da5ca99a$export$c114848fa733e5c4 = (qs)=>{
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(qs);
    return parsed.sortField && parsed.sortField === 'name' ? (0, $b140ee73c9ccd026$export$3c5e605ca7ade9f2) : (0, $b140ee73c9ccd026$export$7673664bdc3ae979);
};
const $ddf87573da5ca99a$export$c5d2609f8b4048d3 = (qs)=>{
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(qs);
    return parsed.sortDirection && parsed.sortDirection === 'asc' ? (0, $2a9e000a443b1a95$export$1dee026a19752d6b) : (0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65);
};
const $ddf87573da5ca99a$var$apiSortByMap = {
    [(0, $2a9e000a443b1a95$export$1dee026a19752d6b)]: '',
    [(0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65)]: '-'
};
const $ddf87573da5ca99a$export$fb15afa686993f11 = (filter)=>{
    const fullFilter = (0, (/*@__PURE__*/$parcel$interopDefault($dfl35)))({}, filter, (0, $iPfOK.DEFAULT_FILTER));
    // this additional mapping here is needed because the BE issue type search API already supports sorting by hierarchy level using the "type" parameter. It was decided to add mapping on frontend. More details here https://atlassian.slack.com/archives/C02HN05MC8K/p1680683395059279
    const sortFieldMapping = fullFilter.sortField === 'hierarchy-level' ? 'type' : fullFilter.sortField;
    return {
        maxResults: (0, $iPfOK.MAX_RESULTS),
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        startAt: (fullFilter.page - 1) * (0, $iPfOK.MAX_RESULTS),
        query: (0, $eou7E.trimSearchFilter)(fullFilter.searchFilter),
        // @ts-expect-error - TS2538 - Type 'undefined' cannot be used as an index type.
        orderBy: `${$ddf87573da5ca99a$var$apiSortByMap[fullFilter.sortDirection]}${sortFieldMapping}`
    };
};

});
parcelRegister("dfl35", function(module, exports) {

var $g7i7g = parcelRequire("g7i7g");

var $dGT4U = parcelRequire("dGT4U");

var $4rDUz = parcelRequire("4rDUz");

var $lbyKY = parcelRequire("lbyKY");
/** Used for built-in method references. */ var $9a4d00e997b9e158$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9a4d00e997b9e158$var$hasOwnProperty = $9a4d00e997b9e158$var$objectProto.hasOwnProperty;
/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */ var $9a4d00e997b9e158$var$defaults = $g7i7g(function(object, sources) {
    object = Object(object);
    var index = -1;
    var length = sources.length;
    var guard = length > 2 ? sources[2] : undefined;
    if (guard && $4rDUz(sources[0], sources[1], guard)) length = 1;
    while(++index < length){
        var source = sources[index];
        var props = $lbyKY(source);
        var propsIndex = -1;
        var propsLength = props.length;
        while(++propsIndex < propsLength){
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined || $dGT4U(value, $9a4d00e997b9e158$var$objectProto[key]) && !$9a4d00e997b9e158$var$hasOwnProperty.call(object, key)) object[key] = source[key];
        }
    }
    return object;
});
module.exports = $9a4d00e997b9e158$var$defaults;

});

// data field names
const $b140ee73c9ccd026$export$3c5e605ca7ade9f2 = 'name';
const $b140ee73c9ccd026$export$d44826c816b5619b = 'description';
const $b140ee73c9ccd026$export$b87f371cbc396fcf = 'type';
const $b140ee73c9ccd026$export$7673664bdc3ae979 = 'hierarchy-level';
const $b140ee73c9ccd026$export$68e97ee499f7c743 = 'related-schemes';
const $b140ee73c9ccd026$export$92a1a3b7554e9387 = 'actions';
const $b140ee73c9ccd026$export$23ba45d5f8d54fed = 'level-number';
const $b140ee73c9ccd026$export$1dc71bc9f1a3749a = 'arrow';
const $b140ee73c9ccd026$export$8be5a31a21d0c723 = 'level-name';
const $b140ee73c9ccd026$export$6ad51af4785d6548 = 'jira-issue-types';
const $b140ee73c9ccd026$export$20068afc6f8c1737 = 'label-space';

const $2a9e000a443b1a95$export$1dee026a19752d6b = 'ASC';
const $2a9e000a443b1a95$export$b6abcf7fa1d94f65 = 'DESC';

parcelRegister("aud83", function(module, exports) {

$parcel$export(module.exports, "string", () => $b7c0843f761cef5f$export$22b082955e083ec3);
$parcel$export(module.exports, "bool", () => $b7c0843f761cef5f$export$87b259aa03e3d267);
$parcel$export(module.exports, "array", () => $b7c0843f761cef5f$export$2f23118c22fb2630);
$parcel$export(module.exports, "multiple", () => $b7c0843f761cef5f$export$939ddaa3205df08e);
$parcel$export(module.exports, "number", () => $b7c0843f761cef5f$export$98e628dec113755e);

var $etyzk = parcelRequire("etyzk");
const $b7c0843f761cef5f$export$22b082955e083ec3 = {
    stringify: (0, (/*@__PURE__*/$parcel$interopDefault($etyzk))),
    parse: (0, (/*@__PURE__*/$parcel$interopDefault($etyzk)))
};
const $b7c0843f761cef5f$export$87b259aa03e3d267 = {
    stringify: (value)=>String(value),
    parse: (value)=>{
        if (value === 'true') return true;
        if (value === 'false') return false;
        return undefined;
    }
};
const $b7c0843f761cef5f$export$2f23118c22fb2630 = {
    stringify: (value)=>value && Array.isArray(value) ? value.join(',') : undefined,
    parse: (value)=>typeof value === 'string' ? value?.split(',') : undefined
};
const $b7c0843f761cef5f$export$939ddaa3205df08e = {
    stringify: (value)=>{
        if (!value || !Array.isArray(value)) return undefined;
        return value.length === 1 ? value[0] : value;
    },
    parse: (value)=>value && Array.isArray(value) ? value : [
            String(value)
        ]
};
const $b7c0843f761cef5f$export$98e628dec113755e = {
    stringify: (value)=>`${value}`,
    parse: (value)=>Number(value)
};

});

parcelRegister("eou7E", function(module, exports) {

$parcel$export(module.exports, "fieldToParam", () => $56517d5895d07b39$export$7341f299e7b93e87);
$parcel$export(module.exports, "fieldFromParam", () => $56517d5895d07b39$export$c876451e094c0060);
$parcel$export(module.exports, "trimSearchFilter", () => $56517d5895d07b39$export$ed1722f41c23aaaf);
const $56517d5895d07b39$export$7341f299e7b93e87 = (field)=>field !== undefined ? field.toLowerCase() : undefined;
const $56517d5895d07b39$export$c876451e094c0060 = (map, param)=>map[param] !== undefined ? map[param] : undefined;
const $56517d5895d07b39$export$ed1722f41c23aaaf = (searchFilter)=>{
    if (searchFilter === undefined) return undefined;
    return searchFilter.trim() || undefined;
};

});

parcelRegister("iPfOK", function(module, exports) {

$parcel$export(module.exports, "MAX_RESULTS", () => $68af332912f0171f$export$f6b2881bc1090cea);
$parcel$export(module.exports, "DEFAULT_FILTER", () => $68af332912f0171f$export$6deee0e4f2fb784e);


const $68af332912f0171f$export$f6b2881bc1090cea = 15;
const $68af332912f0171f$export$6deee0e4f2fb784e = {
    page: 1,
    sortDirection: (0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65),
    sortField: (0, $b140ee73c9ccd026$export$7673664bdc3ae979)
};

});




parcelRegister("doDFU", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueTypesRoute", () => $eae4c8452b1a9d87$export$7358263a3bbb38b1);
const $eae4c8452b1a9d87$export$7358263a3bbb38b1 = {
    name: 'global-settings-issues-types-view',
    path: '/jira/settings/issues/issue-types'
};

});

parcelRegister("d9kjz", function(module, exports) {

$parcel$export(module.exports, "LazyIssueTypesDirectory", () => $3e26a0063e6eb003$export$661e1bf38bb82270);
$parcel$export(module.exports, "default", () => $3e26a0063e6eb003$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $3e26a0063e6eb003$export$661e1bf38bb82270 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("bs3AH"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/issue-types/issue-types-directory/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3e26a0063e6eb003$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3e26a0063e6eb003$export$661e1bf38bb82270,
        pageId: "jira-admin-pages-issue-types-directory",
        shouldShowSpinner: true
    });

});
parcelRegister("bs3AH", function(module, exports) {

let $85651850da03ef75$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $85651850da03ef75$var$load("ffQaD"),
    $85651850da03ef75$var$load("kvRbA"),
    $85651850da03ef75$var$load("2GJWD")
]).then(()=>parcelRequire('g8Lpc'));

});



parcelRegister("4x45G", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueTypesSchemesRouteEntry", () => $50729a11180c681f$export$8f940be66a7e7324);

var $6oOqs = parcelRequire("6oOqs");

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $fZtiC = parcelRequire("fZtiC");

var $5pSYQ = parcelRequire("5pSYQ");

var $eISHy = parcelRequire("eISHy");
const $50729a11180c681f$export$8f940be66a7e7324 = (0, $7NszV.createEntry)((0, $fZtiC.globalSettingsIssueTypesSchemesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.view-issue-type-schemes',
        component: (0, $eISHy.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $6oOqs.default),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $eISHy.LazyIssueTypeSchemesDirectory)
        ]
    }));

});
parcelRegister("6oOqs", function(module, exports) {

$parcel$export(module.exports, "default", () => $b64e685bc951c633$export$2e2bcd8739ae039);

var $ebyGx = parcelRequire("ebyGx");

var $2M1hQ = parcelRequire("2M1hQ");

var $8yNp1 = parcelRequire("8yNp1");

const $b64e685bc951c633$var$issueTypeSchemeResource = (0, $2M1hQ.createResource)({
    type: (0, $e899d40884b470a8$export$1d678052bb5ae54d),
    getKey: ({ query: query })=>`${0, $e899d40884b470a8$export$41cf50ee50d5da20}-${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(query)}`,
    maxAge: 0,
    getData: async ({ query: query })=>(0, $8yNp1.getIssueTypeSchemes)((0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(query))
});
var $b64e685bc951c633$export$2e2bcd8739ae039 = $b64e685bc951c633$var$issueTypeSchemeResource;

});
parcelRegister("8yNp1", function(module, exports) {

$parcel$export(module.exports, "getIssueTypeSchemes", () => $b3d43746aaf616dc$export$2844cac611eecaa7);

var $ebyGx = parcelRequire("ebyGx");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $7vF3l = parcelRequire("7vF3l");

var $bLpq9 = parcelRequire("bLpq9");
const $b3d43746aaf616dc$export$2844cac611eecaa7 = async (qs)=>{
    const filter = (0, $bLpq9.fromUrlTransformer)((0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(qs));
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify((0, $bLpq9.toApiUrlTransformer)(filter));
    try {
        return await (0, $eusud.performGetRequest)(`/rest/api/3/issuetypescheme?${query}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'getIssueTypesRequest',
                packageName: (0, $7vF3l.PACKAGE_NAME),
                teamName: 'morphinecake'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
parcelRegister("7vF3l", function(module, exports) {

$parcel$export(module.exports, "SOURCE_NAME", () => $72a1bf464873d379$export$a3821bc63538b210);
$parcel$export(module.exports, "ISSUE_TYPE_SCHEMES_TABLE", () => $72a1bf464873d379$export$91570d508c93485d);
$parcel$export(module.exports, "ORDER", () => $72a1bf464873d379$export$11e75bce9f7ea886);
$parcel$export(module.exports, "MAX_RESULTS", () => $72a1bf464873d379$export$f6b2881bc1090cea);
$parcel$export(module.exports, "defaultIssueTypeSchemesFilter", () => $72a1bf464873d379$export$625de46796f967ae);
$parcel$export(module.exports, "EMPTY_PROJECTS_PAGE", () => $72a1bf464873d379$export$81a0343467d0e9a9);
$parcel$export(module.exports, "PACKAGE_NAME", () => $72a1bf464873d379$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "FILTER_CHANGE_ANALYTICS", () => $72a1bf464873d379$export$9ac56b2484c2d4e9);
// analytics constants

const $72a1bf464873d379$export$a3821bc63538b210 = 'issueTypeSchemeDirectory';
const $72a1bf464873d379$export$91570d508c93485d = 'issueTypeSchemesTable';
const $72a1bf464873d379$export$11e75bce9f7ea886 = Object.freeze({
    ASC: 'asc',
    DESC: 'desc'
});
const $72a1bf464873d379$export$f6b2881bc1090cea = 10;
const $72a1bf464873d379$export$625de46796f967ae = {
    pageNumber: 1,
    pageSize: $72a1bf464873d379$export$f6b2881bc1090cea,
    expand: [
        'projects',
        'issueTypes'
    ],
    orderBy: 'name',
    sortDirection: (0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65)
};
const $72a1bf464873d379$export$81a0343467d0e9a9 = {
    startAt: 0,
    maxResults: 10,
    values: [],
    total: 0,
    isLast: true
};
const $72a1bf464873d379$export$b8b9d90f9e5bd72b = 'jiraAdminPagesIssueTypeSchemesDirectory';
const $72a1bf464873d379$export$9ac56b2484c2d4e9 = Object.freeze({
    ACTION: 'changed',
    ACTION_SUBJECT: 'filterSearch'
});

});

parcelRegister("bLpq9", function(module, exports) {

$parcel$export(module.exports, "toUrlTransformer", () => $90d499beb7e9cb88$export$5b9f8ed2c34be88a);
$parcel$export(module.exports, "fromUrlTransformer", () => $90d499beb7e9cb88$export$bec67ef860c0d0e1);
$parcel$export(module.exports, "toApiUrlTransformer", () => $90d499beb7e9cb88$export$fb15afa686993f11);

var $dfl35 = parcelRequire("dfl35");

var $aud83 = parcelRequire("aud83");

var $7vF3l = parcelRequire("7vF3l");

var $lL6pH = parcelRequire("lL6pH");
const $90d499beb7e9cb88$export$5b9f8ed2c34be88a = (filter)=>{
    const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy } = filter || {};
    return {
        pageNumber: pageNumber,
        searchFilter: searchFilter,
        orderBy: orderBy
    };
};
const $90d499beb7e9cb88$export$bec67ef860c0d0e1 = (params)=>{
    const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy } = params;
    const parsedNumber = Number.isNaN((0, $aud83.number).parse(pageNumber)) ? (0, $7vF3l.defaultIssueTypeSchemesFilter).pageNumber : (0, $aud83.number).parse(pageNumber);
    const parsedOrderBy = orderBy === 'name' || orderBy === '-name' ? orderBy : undefined;
    return {
        ...(0, $7vF3l.defaultIssueTypeSchemesFilter),
        pageNumber: parsedNumber != null ? Number(parsedNumber) : undefined,
        searchFilter: searchFilter,
        orderBy: parsedOrderBy
    };
};
const $90d499beb7e9cb88$export$fb15afa686993f11 = (filter)=>{
    const fullFilter = (0, (/*@__PURE__*/$parcel$interopDefault($dfl35)))({}, filter, (0, $7vF3l.defaultIssueTypeSchemesFilter));
    let requestParams = {
        maxResults: (0, $7vF3l.MAX_RESULTS),
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        startAt: (fullFilter.pageNumber - 1) * (0, $7vF3l.MAX_RESULTS),
        orderBy: fullFilter.orderBy,
        queryString: (0, $lL6pH.trimSearchFilter)(fullFilter.searchFilter)
    };
    if (fullFilter.expand != null) // @ts-expect-error - TS2322 - Type '{ expand: string; maxResults: number; startAt: number; orderBy: IssueTypeOrderBy | undefined; queryString: string | undefined; }' is not assignable to type '{ maxResults: number; startAt: number; orderBy: IssueTypeOrderBy | undefined; queryString: string | undefined; }'.
    requestParams = {
        ...requestParams,
        expand: fullFilter.expand.join(',')
    };
    return requestParams;
};

});
parcelRegister("lL6pH", function(module, exports) {

$parcel$export(module.exports, "trimSearchFilter", () => $8bfdbd5ef20cefa5$export$ed1722f41c23aaaf);
const $8bfdbd5ef20cefa5$export$ed1722f41c23aaaf = (searchFilter)=>{
    if (searchFilter === undefined) return undefined;
    return searchFilter.trim() || undefined;
};

});



const $e899d40884b470a8$export$1d678052bb5ae54d = 'ISSUE_TYPE_SCHEME_TABLE';
const $e899d40884b470a8$export$41cf50ee50d5da20 = 'ISSUE_TYPE_SCHEME_TABLE_KEY';


parcelRegister("fZtiC", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueTypesSchemesRoute", () => $2bc2621ba9f684f5$export$2aba97aa663f43b3);
const $2bc2621ba9f684f5$export$2aba97aa663f43b3 = {
    name: 'global-settings-issues-types-schemes-manage',
    path: '/jira/settings/issues/issue-type-schemes'
};

});

parcelRegister("eISHy", function(module, exports) {

$parcel$export(module.exports, "LazyIssueTypeSchemesDirectory", () => $651db9488b9701c8$export$611728a54ba37830);
$parcel$export(module.exports, "default", () => $651db9488b9701c8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $651db9488b9701c8$export$611728a54ba37830 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("EaBXJ"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/issue-types/issue-type-schemes-directory/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$651db9488b9701c8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $651db9488b9701c8$export$611728a54ba37830,
        pageId: "jira-admin-pages-issue-type-schemes-directory",
        shouldShowSpinner: true
    });

});
parcelRegister("EaBXJ", function(module, exports) {

let $078bf7b95f75c715$var$load = (parcelRequire("28QjX"))(4);
module.exports = $078bf7b95f75c715$var$load("lblbO").then(()=>parcelRequire('1dsYb'));

});



parcelRegister("3rBGh", function(module, exports) {

$parcel$export(module.exports, "productsJsmAuthenticationSettingsRouteEntry", () => $9cff46e3a47cb509$export$de5cc5a334946074);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $jKASa = parcelRequire("jKASa");

var $3RJkv = parcelRequire("3RJkv");

var $5ANfe = parcelRequire("5ANfe");

var $1xsZo = parcelRequire("1xsZo");
const $9cff46e3a47cb509$export$de5cc5a334946074 = (0, $7NszV.createEntry)((0, $5ANfe.productsJsmAuthenticationSettingsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-authentication-settings',
        component: (0, $1xsZo.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $jKASa.jsmCustomerAuthenticationSettingsResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $1xsZo.LazyAuthenticationSettings)
        ]
    }));

});
parcelRegister("2Fj5v", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9ddf603830cf6c5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

const $a9ddf603830cf6c5$var$LazyGlobalProductsSettingsSidebar = (0, $kxZPA.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("1DM5p")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-products/src/index.tsx"
});
const $a9ddf603830cf6c5$var$GlobalProductsSettingsSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "globalProductsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a9ddf603830cf6c5$var$LazyGlobalProductsSettingsSidebar, null)));
$a9ddf603830cf6c5$var$GlobalProductsSettingsSidebar.displayName = 'GlobalProductsSettingsSidebar';
var $a9ddf603830cf6c5$export$2e2bcd8739ae039 = $a9ddf603830cf6c5$var$GlobalProductsSettingsSidebar;

});
parcelRegister("1DM5p", function(module, exports) {

let $131ebbe0f4c244ca$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $131ebbe0f4c244ca$var$load("kVX56"),
    $131ebbe0f4c244ca$var$load("ffQaD"),
    $131ebbe0f4c244ca$var$load("kvRbA"),
    $131ebbe0f4c244ca$var$load("76n7a"),
    $131ebbe0f4c244ca$var$load("l253H"),
    $131ebbe0f4c244ca$var$load("1WuYN")
]).then(()=>parcelRequire('hTSvC'));

});


parcelRegister("jKASa", function(module, exports) {

$parcel$export(module.exports, "jsmCustomerAuthenticationSettingsResource", () => $3f20045f00d71d00$export$73134c05a3c27bd);

var $2M1hQ = parcelRequire("2M1hQ");

var $8Pbm3 = parcelRequire("8Pbm3");

const $3f20045f00d71d00$export$73134c05a3c27bd = (0, $2M1hQ.createResource)({
    type: (0, $8Pbm3.RESOURCE_TYPE_JSM_CUSTOMER_AUTHENTICATION_SETTINGS),
    getKey: ()=>'settings',
    getDataLoader: ()=>(parcelRequire("k8U7S")),
    maxAge: (0, $8Pbm3.ONE_DAY_IN_MILLIS)
});

});
parcelRegister("8Pbm3", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_JSM_CUSTOMER_AUTHENTICATION_SETTINGS", () => $bbe3b013803e2d85$export$6a2799d78d98b915);
$parcel$export(module.exports, "ONE_DAY_IN_MILLIS", () => $bbe3b013803e2d85$export$5a00268156ea5027);
const $bbe3b013803e2d85$export$6a2799d78d98b915 = 'JSM_CUSTOMER_AUTHENTICATION_SETTINGS';
const $bbe3b013803e2d85$export$5a00268156ea5027 = 86400000;

});

parcelRegister("k8U7S", function(module, exports) {

let $eaa0177cc709c1d9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eaa0177cc709c1d9$var$load("lSS91").then(()=>parcelRequire('7xEnC'));

});


parcelRegister("5ANfe", function(module, exports) {

$parcel$export(module.exports, "productsJsmAuthenticationSettingsRoute", () => $a5162dfcc59db4dc$export$6395086ce7e72e37);
const $a5162dfcc59db4dc$export$6395086ce7e72e37 = {
    name: 'products-jsm-authentication-settings',
    path: '/jira/settings/products/servicedesk/authentication',
    exact: true
};

});

parcelRegister("1xsZo", function(module, exports) {

$parcel$export(module.exports, "LazyAuthenticationSettings", () => $a330db909964048e$export$6cd59b0135f3fe86);
$parcel$export(module.exports, "default", () => $a330db909964048e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $a330db909964048e$export$6cd59b0135f3fe86 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("9M0Zf"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/product-jsm-authentication-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a330db909964048e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $a330db909964048e$export$6cd59b0135f3fe86,
        pageId: "spa-apps/admin-pages/jsm-authentication-settings",
        shouldShowSpinner: false
    });

});
parcelRegister("9M0Zf", function(module, exports) {

let $71d95cb8467af4c8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $71d95cb8467af4c8$var$load("bo2dV").then(()=>parcelRequire('8YmLU'));

});



parcelRegister("4PsEV", function(module, exports) {

$parcel$export(module.exports, "productsJsmCustomerAccessRouteEntry", () => $1b073120d1b5fb73$export$d014f5ba2dec6c16);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $6IgbX = parcelRequire("6IgbX");

var $cuwqc = parcelRequire("cuwqc");

var $3RJkv = parcelRequire("3RJkv");

var $kMtnK = parcelRequire("kMtnK");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $1b073120d1b5fb73$var$LazyCustomerAccess = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("7zpPj"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/customer-access/src/index.tsx"
});
const $1b073120d1b5fb73$var$ServiceDeskCustomerAccess = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $1b073120d1b5fb73$var$LazyCustomerAccess,
        pageId: "spa-apps/admin-pages/customer-access",
        shouldShowSpinner: false
    });
const $1b073120d1b5fb73$export$d014f5ba2dec6c16 = (0, $7NszV.createEntry)((0, $kMtnK.productsJsmCustomerAccessRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-customer-access',
        component: $1b073120d1b5fb73$var$ServiceDeskCustomerAccess,
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $cuwqc.jsmGlobalCustomerAccessSettingsResource),
            (0, $6IgbX.jsmGlobalCustomerAccessAffectedProjectsResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $1b073120d1b5fb73$var$LazyCustomerAccess
        ]
    }));

});
parcelRegister("6IgbX", function(module, exports) {

$parcel$export(module.exports, "jsmGlobalCustomerAccessAffectedProjectsResource", () => $da9f8bab48dab68f$export$f27acbd4701f5dfe);

var $2M1hQ = parcelRequire("2M1hQ");

const $da9f8bab48dab68f$var$ONE_DAY_IN_MILLIS = 86400000;

const $da9f8bab48dab68f$export$f27acbd4701f5dfe = (0, $2M1hQ.createResource)({
    type: (0, $700dba149c7972be$export$341f26dde034af5b),
    getKey: ()=>'affected-projects',
    getDataLoader: ()=>(parcelRequire("2hpwE")),
    maxAge: $da9f8bab48dab68f$var$ONE_DAY_IN_MILLIS
});

});
const $700dba149c7972be$export$341f26dde034af5b = 'JSM_CUSTOMER_ACCESS_AFFECTED_PROJECTS';
const $700dba149c7972be$export$eb7818fb178a80b4 = 'JSM_GLOBAL_CUSTOMER_ACCESS_SETTINGS';

parcelRegister("2hpwE", function(module, exports) {

let $1a90f822bfab362c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1a90f822bfab362c$var$load("aRUIJ").then(()=>parcelRequire('8QdIc'));

});


parcelRegister("cuwqc", function(module, exports) {

$parcel$export(module.exports, "jsmGlobalCustomerAccessSettingsResource", () => $ab848c99e9d2daf7$export$b1a50ad717b4ca61);

var $2M1hQ = parcelRequire("2M1hQ");

const $ab848c99e9d2daf7$var$ONE_DAY_IN_MILLIS = 86400000;

const $ab848c99e9d2daf7$export$b1a50ad717b4ca61 = (0, $2M1hQ.createResource)({
    type: (0, $700dba149c7972be$export$eb7818fb178a80b4),
    getKey: ()=>'settings',
    getDataLoader: ()=>(parcelRequire("fmDBD")),
    maxAge: $ab848c99e9d2daf7$var$ONE_DAY_IN_MILLIS
});

});
parcelRegister("fmDBD", function(module, exports) {

let $b2f7a1fe5c3e4783$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b2f7a1fe5c3e4783$var$load("6RmSY").then(()=>parcelRequire('4pG8m'));

});


parcelRegister("kMtnK", function(module, exports) {

$parcel$export(module.exports, "productsJsmCustomerAccessRoute", () => $3ca187dfdc0607c8$export$b97e3b6231be8149);
const $3ca187dfdc0607c8$export$b97e3b6231be8149 = {
    name: 'products-jsm-customer-access',
    path: '/jira/settings/products/servicedesk/customer-access',
    exact: true
};

});

parcelRegister("7zpPj", function(module, exports) {

let $582fd5e624987f0f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $582fd5e624987f0f$var$load("gOcFK").then(()=>parcelRequire('faXQs'));

});


parcelRegister("jWVY2", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNewIssueSearchRouteEntry", () => $d3d6f049267991fe$export$ecfeb067cb61f7f7);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $5AJNe = parcelRequire("5AJNe");

var $5pSYQ = parcelRequire("5pSYQ");

var $2FG9c = parcelRequire("2FG9c");
const $d3d6f049267991fe$export$ecfeb067cb61f7f7 = (0, $7NszV.createEntry)((0, $5AJNe.globalSettingsIssuesNewIssueSearchRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.new-issue-search-transition',
        component: (0, $2FG9c.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $2FG9c.LazyNewIssueSearchTransition)
        ],
        canTransitionIn: ()=>true
    }));

});
parcelRegister("5AJNe", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNewIssueSearchRoute", () => $2c4dc81da03ffb36$export$774dc60e785b8ae8);
const $2c4dc81da03ffb36$export$774dc60e785b8ae8 = {
    name: 'global-settings-issues-new-issue-search',
    path: '/jira/settings/issues/new-issue-search-transition'
};

});

parcelRegister("2FG9c", function(module, exports) {

$parcel$export(module.exports, "LazyNewIssueSearchTransition", () => $4f134f463ddf0416$export$aa5e318abd957ad);
$parcel$export(module.exports, "default", () => $4f134f463ddf0416$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $4f134f463ddf0416$export$aa5e318abd957ad = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("5Nkif"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/new-issue-search-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4f134f463ddf0416$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $4f134f463ddf0416$export$aa5e318abd957ad,
        pageId: "jira-admin-pages-new-issue-search-transition",
        shouldShowSpinner: true
    });

});
parcelRegister("5Nkif", function(module, exports) {

let $4381452d39908d94$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4381452d39908d94$var$load("blxz1").then(()=>parcelRequire('7sYTD'));

});



parcelRegister("dTwSZ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemBulkMailRouteEntry", () => $afbfb00c133db3e2$export$f1e14d1857713e35);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $d8FBC = parcelRequire("d8FBC");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $gRmqY = parcelRequire("gRmqY");

var $5FGTk = parcelRequire("5FGTk");
const $afbfb00c133db3e2$export$f1e14d1857713e35 = (0, $7NszV.createEntry)((0, $gRmqY.globalSettingsSystemBulkMailRoute), ()=>({
        group: 'global-settings',
        component: (0, $5FGTk.default),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $d8FBC.SidebarGlobalSettingsSystem)
        },
        layout: (0, $ibkIl.globalSettingsLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5FGTk.LazyBulkEmail)
        ]
    }));

});
parcelRegister("d8FBC", function(module, exports) {

$parcel$export(module.exports, "SidebarGlobalSettingsSystem", () => $6ea6596802956a9d$export$52af3150b9f64726);

var $5uXOq = parcelRequire("5uXOq");

var $fobme = parcelRequire("fobme");

var $acDan = parcelRequire("acDan");

var $hcbSm = parcelRequire("hcbSm");
const $6ea6596802956a9d$export$52af3150b9f64726 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $acDan.SidebarRenderStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hcbSm.Menu), null), !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $acDan.SidebarReady), {
        id: (0, $fobme.SIDEBAR_ID).GLOBAL_SETTINGS_SYSTEM
    }));

});
parcelRegister("fobme", function(module, exports) {

$parcel$export(module.exports, "SIDEBAR_ID", () => $4b9be639c0c7f77b$export$adf978edbdfaf080);
const $4b9be639c0c7f77b$export$adf978edbdfaf080 = {
    CONNECT: 'CONNECT',
    CORE: 'CORE',
    FILTERS: 'FILTERS',
    FILTERS_GLOBAL: 'FILTERS_GLOBAL',
    FORGE_GLOBAL_PAGE: 'FORGE_GLOBAL_PAGE',
    GLOBAL_SETTINGS_APPS: 'GLOBAL_SETTINGS_APPS',
    GLOBAL_SETTINGS_ISSUES: 'GLOBAL_SETTINGS_ISSUES',
    GLOBAL_SETTINGS_PRODUCTS: 'GLOBAL_SETTINGS_PRODUCTS',
    GLOBAL_SETTINGS_PROJECTS: 'GLOBAL_SETTINGS_PROJECTS',
    GLOBAL_SETTINGS_SYSTEM: 'GLOBAL_SETTINGS_SYSTEM',
    JSM: 'JSM',
    JSW_CLASSIC: 'JSW_CLASSIC',
    JSW_NEXT_GEN: 'JSW_NEXT_GEN',
    PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
    EOC_OPERATIONS: 'EOC_OPERATIONS',
    POLARIS: 'POLARIS',
    USER: 'USER',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS'
};

});

parcelRegister("hcbSm", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $e261d6c9e28d2ed4$export$d9b273488cd8ce6f);

var $5uXOq = parcelRequire("5uXOq");

var $g2EiV = parcelRequire("g2EiV");
var $9btdk = parcelRequire("9btdk");
var $gZEU1 = parcelRequire("gZEU1");
var $bWqXX = parcelRequire("bWqXX");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $3OGaE = parcelRequire("3OGaE");

var $juTur = parcelRequire("juTur");

var $17bH5 = parcelRequire("17bH5");

var $4OCke = parcelRequire("4OCke");

var $3tHFY = parcelRequire("3tHFY");

var $6jY6G = parcelRequire("6jY6G");

var $eaZ4X = parcelRequire("eaZ4X");

var $jMBA3 = parcelRequire("jMBA3");

var $aVTmi = parcelRequire("aVTmi");

var $cip1u = parcelRequire("cip1u");

var $8wyB3 = parcelRequire("8wyB3");

var $230Wm = parcelRequire("230Wm");

var $je2KE = parcelRequire("je2KE");

var $iAlf2 = parcelRequire("iAlf2");

var $fwlYA = parcelRequire("fwlYA");

var $9O5DC = parcelRequire("9O5DC");

var $1y2CG = parcelRequire("1y2CG");

var $71ORT = parcelRequire("71ORT");

var $3jrxv = parcelRequire("3jrxv");
const $e261d6c9e28d2ed4$var$calculateStack = (route)=>{
    const routeName = route && route.name;
    if ([
        'global-settings-performance-metric-detail',
        'global-settings-performance-overview',
        'global-settings-performance-project-cleanup',
        'global-settings-performance-project-role-actor',
        'global-settings-performance-custom-field',
        'global-settings-performance-issue'
    ].includes(routeName)) return [
        (0, $eaZ4X.SECTION_ID).PERFORMANCE_AND_SCALE
    ];
    return [];
};
const $e261d6c9e28d2ed4$export$d9b273488cd8ce6f = ()=>{
    const { data: features } = (0, $jMBA3.useFeatures)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const { data: connectItems } = (0, $jMBA3.useGlobalSettingsSystemConnectItems)();
    const [stack, setStack] = (0, $5uXOq.useState)($e261d6c9e28d2ed4$var$calculateStack(route));
    (0, $5uXOq.useEffect)(()=>{
        setStack($e261d6c9e28d2ed4$var$calculateStack(route));
    }, [
        route
    ]);
    const navigationPath = (0, $5uXOq.useMemo)(()=>(0, $17bH5.getSystemNavigationPaths)(), []);
    const generalConfigurationPath = navigationPath.generalConfiguration;
    if (features == null || connectItems == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    const navigationContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, features.hasGeneralConfiguration && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'general-configuration'
        },
        href: generalConfigurationPath,
        selectedOn: (0, $3jrxv.isGeneralConfigurationSelected)
    }, formatMessage((0, $iAlf2.default).generalConfiguration)), features.hasDarkFeatures && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'dark-features'
        },
        href: navigationPath.darkFeatures,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $iAlf2.default).darkFeatures)), features.hasTroubleshootingAndSupportSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1y2CG.TroubleshootingAndSupportSection), null), features.hasSecuritySection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fwlYA.SecuritySection), null), features.hasCollectors && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'collectors'
        },
        href: navigationPath.issueCollectors,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $iAlf2.default).issueCollectorsIssueTermRefresh : (0, $iAlf2.default).issueCollectors)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8wyB3.AutomationSection), null), features.hasUserInterfaceSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $71ORT.UserInterfaceSection), null), features.hasImportExportSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $230Wm.ImportExportSection), null), features.hasMailSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $je2KE.MailSection), null), features.hasAdminHelperSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aVTmi.AdminHelperSection), null), features.hasSharedSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9O5DC.SharedSection), null), features.hasAdvancedSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cip1u.AdvancedSection), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3tHFY.ConnectMenu), {
        items: connectItems,
        overrides: {
            BackMenuItem: {
                href: '/jira/settings/system/general-configuration',
                title: formatMessage((0, $iAlf2.default).systemGroup)
            }
        }
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juTur.ContextualAnalyticsData), {
        menuId: "global-settings/system",
        stack: stack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZEU1.default), {
        label: formatMessage((0, $iAlf2.default).globalSettingsSystemSidebarLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g2EiV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OGaE.TitleHeader), null, formatMessage((0, $iAlf2.default).systemGroup))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9btdk.default), {
        stack: stack,
        onChange: setStack
    }, navigationContent)));
};

});
parcelRegister("g2EiV", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8d4c6f37fa43791$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
const $f8d4c6f37fa43791$var$styles = {
    navigationFooter: "_1e0c1ule _85i5u2gc _1q511ejb _y4tiu2gc _bozgu2gc"
};
/**
 * __Navigation header__
 *
 * Allows for customisation of the header.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $f8d4c6f37fa43791$var$NavigationHeader = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $f8d4c6f37fa43791$var$styles.navigationFooter,
        "data-navheader": true,
        children: children
    });
};
var $f8d4c6f37fa43791$export$2e2bcd8739ae039 = $f8d4c6f37fa43791$var$NavigationHeader;

});

parcelRegister("9btdk", function(module, exports) {

$parcel$export(module.exports, "ROOT_ID", () => $1598986e4d07c239$export$ec71a3379b43ae5c);
$parcel$export(module.exports, "default", () => $1598986e4d07c239$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $35XSW = parcelRequire("35XSW");

var $VSDnB = parcelRequire("VSDnB");

var $6XySk = parcelRequire("6XySk");

var $8UO8z = parcelRequire("8UO8z");

var $9zCCP = parcelRequire("9zCCP");

var $j9VTE = parcelRequire("j9VTE");

var $cfT4M = parcelRequire("cfT4M");
const $1598986e4d07c239$export$ec71a3379b43ae5c = 'ATLASKIT_NESTED_ROOT';
const $1598986e4d07c239$var$nestableNavigationContentStyles = null;
const $1598986e4d07c239$var$nestingRootStyles = null;
/**
 * __Nestable navigation content__
 *
 * The container for navigation items with nested views
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#nested-navigation)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $1598986e4d07c239$var$NestableNavigationContent = (props)=>{
    const containerRef = (0, $5uXOq.useRef)(null);
    const { children: children, testId: testId, overrides: overrides, initialStack: initialStack, onChange: onChange, onUnknownNest: onUnknownNest, stack: stack, showTopScrollIndicator: showTopScrollIndicator, isDefaultFocusControl: isDefaultFocusControl = true } = props;
    const goBackButtonRef = (0, $5uXOq.useRef)(null);
    const [committedStack, setCommittedStack] = (0, $5uXOq.useState)(stack || initialStack || []);
    const controlledStack = stack || undefined;
    const currentStackId = committedStack[committedStack.length - 1] || $1598986e4d07c239$export$ec71a3379b43ae5c;
    const [transition, setTransition] = (0, $5uXOq.useState)('nesting');
    const backTestId = testId && `${testId}--go-back-item`;
    const [activeParentId, setActiveParentId] = (0, $5uXOq.useState)('');
    const [focusGoBackButton, setFocusGoBackButton] = (0, $5uXOq.useState)(false);
    const shouldFocus = isDefaultFocusControl && (0, $VSDnB.fg)('platform-side-navigation-keyboard-focus');
    const renderGoBackItem = overrides && overrides.GoBackItem && overrides.GoBackItem.render ? overrides.GoBackItem.render : (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $6XySk.default), {
            ...props,
            children: "Go back"
        });
    const { childIdsRef: childIdsRef } = (0, $9zCCP.useChildIds)(currentStackId, committedStack, onUnknownNest);
    const onNestHandler = (0, $5uXOq.useCallback)((layerId)=>{
        onChange && onChange(committedStack.concat(layerId));
        setFocusGoBackButton(true);
        if (controlledStack) // We are in controlled mode - ignore the steps.
        return;
        // We need to split the state update into to parts.
        // First: Updating the direction of the motions.
        // Second: Actually updating the stack (which will cause elements to enter & leave).
        setTransition('nesting');
        requestAnimationFrame(()=>{
            setCommittedStack((prev)=>{
                const newStack = prev.concat(layerId);
                return newStack;
            });
        });
    }, [
        controlledStack,
        onChange,
        committedStack
    ]);
    const onUnNestHandler = (0, $5uXOq.useCallback)(()=>{
        onChange && onChange(committedStack.slice(0, committedStack.length - 1));
        setActiveParentId(currentStackId);
        setFocusGoBackButton(false);
        if (controlledStack) // We are in controlled mode - ignore the steps.
        return;
        // We need to split the state update into to parts.
        // First: Updating the direction of the motions.
        // Second: Actually updating the stack (which will cause elements to enter & leave).
        setTransition('unnesting');
        requestAnimationFrame(()=>{
            setCommittedStack((prev)=>{
                const newStack = prev.slice(0, prev.length - 1);
                return newStack;
            });
        });
    }, [
        controlledStack,
        onChange,
        committedStack,
        setActiveParentId,
        currentStackId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!controlledStack) // We aren't in controlled mode - bail out.
        return;
        if (JSON.stringify(committedStack) === JSON.stringify(controlledStack)) // stacks are equal - do nothing!
        return;
        // Controlled prop updated, let's figure out if we're nesting or unnesting.
        if (controlledStack.length < committedStack.length) // We are unnesting (removing from the stack)
        setTransition('unnesting');
        else // We are nesting (adding to the stack)
        setTransition('nesting');
        requestAnimationFrame(()=>{
            setCommittedStack(controlledStack);
        });
    }, [
        committedStack,
        controlledStack
    ]);
    const backButton = renderGoBackItem({
        onClick: onUnNestHandler,
        testId: backTestId,
        ref: shouldFocus ? goBackButtonRef : null
    });
    const context = (0, $5uXOq.useMemo)(()=>({
            currentStackId: currentStackId,
            backButton: backButton,
            stack: committedStack,
            onNest: onNestHandler,
            onUnNest: onUnNestHandler,
            parentId: $1598986e4d07c239$export$ec71a3379b43ae5c,
            childIds: childIdsRef,
            forceShowTopScrollIndicator: showTopScrollIndicator,
            activeParentId: activeParentId,
            goBackButtonRef: goBackButtonRef,
            isDefaultFocusControl: isDefaultFocusControl,
            focusGoBackButton: focusGoBackButton
        }), [
        currentStackId,
        backButton,
        committedStack,
        onNestHandler,
        onUnNestHandler,
        childIdsRef,
        showTopScrollIndicator,
        activeParentId,
        goBackButtonRef,
        isDefaultFocusControl,
        focusGoBackButton
    ]);
    const manageFocus = (event)=>{
        const triggeredByKeyboard = event.nativeEvent.detail === 0;
        if (triggeredByKeyboard) containerRef.current && containerRef.current.focus();
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": testId,
            ref: containerRef,
            tabIndex: -1,
            onClick: manageFocus,
            className: (0, $bwpsq.default)([
                "_12ji1r31 _1qu2glyw _12y31o36 _4t3i1osq _kqswh2mm"
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $35XSW.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cfT4M.NestingMotion), {
                    enterFrom: transition === 'nesting' ? 'right' : 'left',
                    exitTo: transition === 'nesting' ? 'left' : 'right',
                    testId: testId && `${testId}-anim`,
                    children: (motion)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            ...motion,
                            className: (0, $bwpsq.default)([
                                "_1e0c1txw _1bsb1osq _4t3i1osq _kqswstnw _2lx21bp4",
                                motion.className
                            ]),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j9VTE.NestedContext).Provider, {
                                // This provider is inside the NestingMotion to ensure it keeps a stale
                                // reference to the previous value.
                                value: context,
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8UO8z.default), {
                                    title: "",
                                    id: $1598986e4d07c239$export$ec71a3379b43ae5c,
                                    children: children
                                })
                            })
                        })
                }, currentStackId)
            })
        })
    });
};
var $1598986e4d07c239$export$2e2bcd8739ae039 = $1598986e4d07c239$var$NestableNavigationContent;

});
parcelRegister("6XySk", function(module, exports) {

$parcel$export(module.exports, "default", () => $acf862f964b3fe45$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $d2gYe = parcelRequire("d2gYe");


var $ayWDM = parcelRequire("ayWDM");
/**
 * __Go back item__
 *
 * A go back item is used to provide a customized "go back" button in nested
 * navigations.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#go-back-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $acf862f964b3fe45$var$GoBackItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ className: className, iconBefore: iconBefore = /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d2gYe))), {
    color: "currentColor",
    LEGACY_secondaryColor: `var(--ds-surface, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
    label: ""
}), onClick: onClick, isSelected: isSelected, ...rest }, ref)=>{
    const [isInteracted, setIsInteracted] = (0, $5uXOq.useState)(false);
    const onClickHandler = (0, $5uXOq.useCallback)((e)=>{
        if (isInteracted) return;
        setIsInteracted(true);
        onClick && onClick(e);
    }, [
        onClick,
        isInteracted
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ayWDM.default), {
        isSelected: isSelected,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        iconBefore: iconBefore,
        onClick: onClickHandler,
        ref: ref,
        ...rest
    });
});
var $acf862f964b3fe45$export$2e2bcd8739ae039 = $acf862f964b3fe45$var$GoBackItem;

});
parcelRegister("d2gYe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::19a10e1149a5b84d93e6a05c6f1be0d9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $97d8a03a9ac2bd8e$var$_react = $97d8a03a9ac2bd8e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $97d8a03a9ac2bd8e$var$_arrowLeft = $97d8a03a9ac2bd8e$var$_interopRequireDefault((parcelRequire("ctqwA")));

var $97d8a03a9ac2bd8e$var$_arrowLeftCircle = $97d8a03a9ac2bd8e$var$_interopRequireDefault((parcelRequire("g9uZe")));
function $97d8a03a9ac2bd8e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowLeftIcon.
 * This component is ArrowLeftIcon, with `UNSAFE_fallbackIcon` set to "ArrowLeftCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $97d8a03a9ac2bd8e$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $97d8a03a9ac2bd8e$var$_react.default.createElement($97d8a03a9ac2bd8e$var$_arrowLeft.default, Object.assign({
        LEGACY_fallbackIcon: $97d8a03a9ac2bd8e$var$_arrowLeftCircle.default
    }, props));
$97d8a03a9ac2bd8e$var$ArrowLeftIcon.Name = 'ArrowLeftIconMigration';
var $97d8a03a9ac2bd8e$var$_default = module.exports.default = $97d8a03a9ac2bd8e$var$ArrowLeftIcon;

});
parcelRegister("ctqwA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::efa63c6a59a6ee993a0458e40fc93a18>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $914cc4b222e651e0$var$_react = $914cc4b222e651e0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $914cc4b222e651e0$var$_baseNew = $914cc4b222e651e0$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $914cc4b222e651e0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $914cc4b222e651e0$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $914cc4b222e651e0$var$_react.default.createElement($914cc4b222e651e0$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 7.47 5-5 1.06 1.06-3.72 3.72H15v1.5H3.56l3.72 3.72-1.06 1.06-5-5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$914cc4b222e651e0$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $914cc4b222e651e0$var$_default = module.exports.default = $914cc4b222e651e0$var$ArrowLeftIcon;

});

parcelRegister("g9uZe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bc2585eb44f99538$var$_react = $bc2585eb44f99538$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $bc2585eb44f99538$var$_arrowLeft = $bc2585eb44f99538$var$_interopRequireDefault((parcelRequire("ctqwA")));
function $bc2585eb44f99538$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bc2585eb44f99538$var$ArrowLeftCircleIcon = (props)=>/*#__PURE__*/ $bc2585eb44f99538$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M16 10.995h-5.586l1.272-1.279a1.01 1.01 0 0 0 0-1.421.996.996 0 0 0-1.415 0l-2.978 2.994a1.01 1.01 0 0 0 0 1.423l2.978 2.993a1 1 0 0 0 1.415 0 1.01 1.01 0 0 0 0-1.421l-1.272-1.279H16c.552 0 1-.45 1-1.005s-.448-1.005-1-1.005"/></svg>`
    }, props, {
        newIcon: $bc2585eb44f99538$var$_arrowLeft.default
    }));
$bc2585eb44f99538$var$ArrowLeftCircleIcon.displayName = 'ArrowLeftCircleIcon';
var $bc2585eb44f99538$var$_default = module.exports.default = $bc2585eb44f99538$var$ArrowLeftCircleIcon;

});


var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';

parcelRegister("ayWDM", function(module, exports) {

$parcel$export(module.exports, "default", () => $860cc941614c9e62$export$2e2bcd8739ae039);
/* button-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kJpBP = parcelRequire("kJpBP");

var $j9VTE = parcelRequire("j9VTE");
const $860cc941614c9e62$var$styles = {
    root: "_2rko1sit _1rjcu2gc _18zru2gc _bfhk1w7a _1a391k8s _racp1k8s _30l3jjyb _irr314ae _ppn2dud1 _183j1l7b",
    selectedStyles: "_bfhkbal5 _syaz1ldt _10531ldt _irr31gf2 _30l31pwi _1di61elt _9h8h1ldt"
};
/**
 * __Button item__
 *
 * A button item renders an item wrapped in a button tag, used primarily when an
 * action does something other than changing routes.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#button-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $860cc941614c9e62$var$ButtonItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(// Type needed on props to extract types with extract react types.
({ className: className, ...props }, ref)=>{
    const { shouldRender: shouldRender } = (0, $j9VTE.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kJpBP.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $860cc941614c9e62$var$styles.root,
            props.isSelected && $860cc941614c9e62$var$styles.selectedStyles,
            className
        ]),
        ...props
    });
});
var $860cc941614c9e62$export$2e2bcd8739ae039 = $860cc941614c9e62$var$ButtonItem;

});


parcelRegister("8UO8z", function(module, exports) {

$parcel$export(module.exports, "default", () => $0599b2a9b08db47e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $bh9nY = parcelRequire("bh9nY");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");


var $ayWDM = parcelRequire("ayWDM");
var $jSfqD = parcelRequire("jSfqD");
var $kzjuk = parcelRequire("kzjuk");

var $9btdk = parcelRequire("9btdk");

var $j9VTE = parcelRequire("j9VTE");

var $9zCCP = parcelRequire("9zCCP");
const $0599b2a9b08db47e$var$styles = {
    iconContainer: "_1e0c1nu9",
    nestingItem: "_udl3glyw _kqsfglyw _udrwglyw _13qvglyw _9mqr1kw7 _povs1kw7 _uv2d1kw7 _atks1kw7",
    nestingItemDisabled: "_1c06idpf _udl3glyw"
};
/**
 * NestingItem will render itself differently depending in what context it is rendered in.
 * When not open - it will render itself as an item.
 * When open - it will render its children.
 */ const $0599b2a9b08db47e$var$NestingItem = (props)=>{
    const { children: children, iconAfter: iconAfter, title: title, onClick: onClick, className: className, isDisabled: isDisabled, isSelected: isSelected, id: id, component: component, testId: testId, ...rest } = props;
    const { currentStackId: currentStackId, onNest: onNest, onUnNest: onUnNest, backButton: contextualBackButton, stack: stack, childIds: childIds, forceShowTopScrollIndicator: forceShowTopScrollIndicator, activeParentId: activeParentId, goBackButtonRef: goBackButtonRef, isDefaultFocusControl: isDefaultFocusControl, focusGoBackButton: focusGoBackButton } = (0, $j9VTE.useNestedContext)();
    const [isInteracted, setIsInteracted] = (0, $5uXOq.useState)(false);
    const parentItemRef = (0, $5uXOq.useRef)(null);
    // To avoid error we need to make sure that the component is wrapped in ForwardRef
    const isForwardRefCheck = (component)=>{
        if (component?.prototype?.isReactComponent) return false;
        return component?.$$typeof === Symbol.for('react.forward_ref');
    };
    const shouldFocus = isDefaultFocusControl && (0, $VSDnB.fg)('platform-side-navigation-keyboard-focus');
    const backButtonRef = shouldFocus ? goBackButtonRef : null;
    const activeParentRef = shouldFocus ? parentItemRef : null;
    (0, $5uXOq.useEffect)(()=>{
        if (shouldFocus) {
            if (activeParentId === id) parentItemRef?.current?.focus();
            if (focusGoBackButton) goBackButtonRef?.current?.focus();
        }
    }, [
        activeParentId,
        id,
        goBackButtonRef,
        focusGoBackButton,
        isDefaultFocusControl,
        shouldFocus
    ]);
    const backButton = props.overrides && props.overrides.GoBackItem && props.overrides.GoBackItem.render && props.overrides.GoBackItem.render({
        onClick: onUnNest,
        testId: testId && `${testId}--go-back-item`,
        ref: backButtonRef
    }) || contextualBackButton;
    const context = (0, $5uXOq.useMemo)(()=>({
            stack: stack,
            currentStackId: currentStackId,
            onNest: onNest,
            onUnNest: onUnNest,
            backButton: backButton,
            parentId: id,
            childIds: childIds,
            forceShowTopScrollIndicator: forceShowTopScrollIndicator,
            activeParentId: activeParentId,
            goBackButtonRef: goBackButtonRef,
            isDefaultFocusControl: isDefaultFocusControl,
            focusGoBackButton: focusGoBackButton
        }), [
        stack,
        currentStackId,
        onNest,
        onUnNest,
        backButton,
        id,
        childIds,
        forceShowTopScrollIndicator,
        activeParentId,
        goBackButtonRef,
        isDefaultFocusControl,
        focusGoBackButton
    ]);
    (0, $9zCCP.useChildIdsEffect)(childIds, id);
    const isNormalClick = (e)=>!(e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
    /**
   * We want both the on nest handler and the onclick handler to be called.
   * We create a wrapper function to call both.
   */ const onClickHandler = (0, $5uXOq.useCallback)((e)=>{
        if (isInteracted) // We return early if this has been interacted with because its assumed
        // this will be already exiting - so we don't want to double up the click.
        return;
        // Avoid a nesting transition if a modifier key is detected during click.
        // @ts-expect-error - Argument of type 'MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>' is not assignable to parameter of type 'MouseEvent'
        if (isNormalClick(e)) {
            setIsInteracted(true);
            onNest(id);
        }
        onClick && onClick(e);
    }, [
        isInteracted,
        onClick,
        onNest,
        id
    ]);
    if (currentStackId === id) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $j9VTE.NestedContext).Provider, {
        value: context,
        children: [
            stack.length >= 1 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                paddingBlock: "space.075",
                paddingInline: "space.100",
                children: backButton
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kzjuk.default), {
                testId: testId,
                showTopScrollIndicator: forceShowTopScrollIndicator || stack.length >= 1,
                children: children
            })
        ]
    });
    if ([
        (0, $9btdk.ROOT_ID),
        ...stack
    ].includes(id)) return children;
    const componentProps = {
        iconAfter: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
            children: [
                iconAfter ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    xcss: $0599b2a9b08db47e$var$styles.iconContainer,
                    "data-custom-icon": true,
                    as: "span",
                    children: iconAfter
                }) : null,
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    "data-right-arrow": true,
                    xcss: $0599b2a9b08db47e$var$styles.iconContainer,
                    as: "span",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bh9nY))), {
                        testId: testId && `${testId}--item--right-arrow`,
                        color: "currentColor",
                        LEGACY_secondaryColor: `var(--ds-surface, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
                        label: ""
                    })
                })
            ]
        }),
        onClick: onClickHandler,
        isSelected: isSelected,
        isDisabled: isDisabled,
        testId: testId && `${testId}--item`,
        ...rest,
        children: title
    };
    if (component) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jSfqD.default), {
        ref: isForwardRefCheck(component) ? parentItemRef : null,
        ...componentProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $0599b2a9b08db47e$var$styles.nestingItem,
            isDisabled && $0599b2a9b08db47e$var$styles.nestingItemDisabled,
            className
        ]),
        //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
        component: component
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ayWDM.default), {
        ref: activeParentRef,
        ...componentProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $0599b2a9b08db47e$var$styles.nestingItem,
            isDisabled && $0599b2a9b08db47e$var$styles.nestingItemDisabled,
            className
        ])
    });
};
var $0599b2a9b08db47e$export$2e2bcd8739ae039 = $0599b2a9b08db47e$var$NestingItem;

});
parcelRegister("bh9nY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dbc8100b1314a43ce0868b8331a89007>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $835890081946c47e$var$_react = $835890081946c47e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $835890081946c47e$var$_arrowRight = $835890081946c47e$var$_interopRequireDefault((parcelRequire("h1TKi")));

var $835890081946c47e$var$_arrowRightCircle = $835890081946c47e$var$_interopRequireDefault((parcelRequire("1zw66")));
function $835890081946c47e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowRightIcon.
 * This component is ArrowRightIcon, with `UNSAFE_fallbackIcon` set to "ArrowRightCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $835890081946c47e$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $835890081946c47e$var$_react.default.createElement($835890081946c47e$var$_arrowRight.default, Object.assign({
        LEGACY_fallbackIcon: $835890081946c47e$var$_arrowRightCircle.default
    }, props));
$835890081946c47e$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
var $835890081946c47e$var$_default = module.exports.default = $835890081946c47e$var$ArrowRightIcon;

});
parcelRegister("h1TKi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11b8e18b02050eefbe32dafc654ee453>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c65dc59efb96b35a$var$_react = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c65dc59efb96b35a$var$_baseNew = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $c65dc59efb96b35a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c65dc59efb96b35a$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $c65dc59efb96b35a$var$_react.default.createElement($c65dc59efb96b35a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$c65dc59efb96b35a$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $c65dc59efb96b35a$var$_default = module.exports.default = $c65dc59efb96b35a$var$ArrowRightIcon;

});

parcelRegister("1zw66", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1251f532550be707$var$_react = $1251f532550be707$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $1251f532550be707$var$_arrowRight = $1251f532550be707$var$_interopRequireDefault((parcelRequire("h1TKi")));
function $1251f532550be707$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1251f532550be707$var$ArrowRightCircleIcon = (props)=>/*#__PURE__*/ $1251f532550be707$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor" fill-rule="nonzero"/><path fill="inherit" d="M12.314 8.294a1.01 1.01 0 0 0 0 1.422l1.271 1.279H8c-.553 0-1.001.45-1.001 1.005S7.447 13.005 8 13.005h5.585l-1.271 1.279a1.01 1.01 0 0 0 0 1.422 1 1 0 0 0 1.415 0l2.978-2.995a1.01 1.01 0 0 0 0-1.422l-2.978-2.995a1 1 0 0 0-1.415 0"/></g></svg>`
    }, props, {
        newIcon: $1251f532550be707$var$_arrowRight.default
    }));
$1251f532550be707$var$ArrowRightCircleIcon.displayName = 'ArrowRightCircleIcon';
var $1251f532550be707$var$_default = module.exports.default = $1251f532550be707$var$ArrowRightCircleIcon;

});


parcelRegister("jSfqD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e63733262ea805c$export$2e2bcd8739ae039);
/* custom-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1aogK = parcelRequire("1aogK");

var $j9VTE = parcelRequire("j9VTE");
const $0e63733262ea805c$var$styles = {
    root: "_2rko1sit _1rjcu2gc _18zru2gc _bfhk1w7a _1a391k8s _racp1k8s _30l3jjyb _irr314ae _ppn2dud1 _183j1l7b",
    selectedStyles: "_bfhkbal5 _syaz1ldt _10531ldt _irr31gf2 _30l31pwi _1di61elt _9h8h1ldt"
};
/**
 * Used to support any custom items needed by products alongside the Header and Footer patterns.
 * Specific implementation of headers and footers are provided in the examples folder.
 */ const $0e63733262ea805c$var$CustomItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(// Type needed on props to extract types with extract react types.
({ className: className, ...props }, ref)=>{
    const { shouldRender: shouldRender } = (0, $j9VTE.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1aogK.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $0e63733262ea805c$var$styles.root,
            props.isSelected && $0e63733262ea805c$var$styles.selectedStyles,
            className
        ]),
        ...props
    });
});
var $0e63733262ea805c$export$2e2bcd8739ae039 = $0e63733262ea805c$var$CustomItem;

});

parcelRegister("kzjuk", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfdf97ddffeccb81$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cw1vL = parcelRequire("cw1vL");

var $j9VTE = parcelRequire("j9VTE");
const $dfdf97ddffeccb81$var$outerContainerCSS = null;
const $dfdf97ddffeccb81$var$innerContainerCSS = {
    basic: "_1reo1wug _18m91wug _1e0c1txw _vchhusvi _1bsb1osq _kqswh2mm _2lx21bp4 _14mjgqwt _1ywu1ule _1qdgyh40 _18poh2mm _1bqqcs5v _tua5idpf _1hfk1q2g _aetrb3bt _3mxo1wug",
    topScrollIndicator: "_rfx3gqwt _cfu11ule _kfgtyh40 _1cs8stnw _1g0vcs5v _1rus1q2g _1kt9b3bt _1enwidpf _z5wtidpf"
};
const $dfdf97ddffeccb81$var$containerCSS = {
    basic: "_kqswh2mm _12l2u2gc _ahbqu2gc _1pfhidpf _1p3h12x7 _1l6bpxbi _auo4rdoj _hp2110yn",
    marginBlockStart: "_1pfhv77o"
};
/**
 * __Navigation content__
 *
 * A navigation content is used as the container for navigation items.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#content)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $dfdf97ddffeccb81$var$NavigationContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { showTopScrollIndicator: showTopScrollIndicator, children: children, testId: testId } = props;
    const { shouldRender: shouldRender } = (0, $j9VTE.useShouldNestedElementRender)();
    const scrollbar = (0, $cw1vL.default)();
    if (!shouldRender) return children;
    const typedRef = ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: typedRef,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _4t3i1osq _kqswh2mm _rfx3gqwt _cfu11ule _kfgtyh40 _1cs8stnw _1g0vkb7n _1rus1p09 _1kt9b3bt _1enwftgi _z5wtu2gc _14mjgqwt _1ywu1ule _1qdgyh40 _18postnw _1bqqkb7n _tua5idpf _1hfk1p09 _aetrb3bt _1gufidpf _1czdftgi _g0nfu2gc"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            ref: scrollbar.ref,
            className: (0, $bwpsq.default)([
                $dfdf97ddffeccb81$var$innerContainerCSS.basic,
                !showTopScrollIndicator && $dfdf97ddffeccb81$var$innerContainerCSS.topScrollIndicator
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    $dfdf97ddffeccb81$var$containerCSS.basic,
                    showTopScrollIndicator && $dfdf97ddffeccb81$var$containerCSS.marginBlockStart
                ]),
                children: children
            })
        })
    });
});
var $dfdf97ddffeccb81$export$2e2bcd8739ae039 = $dfdf97ddffeccb81$var$NavigationContent;

});
parcelRegister("cw1vL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a03f8a420074f68d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $a03f8a420074f68d$export$2e2bcd8739ae039() {
    const [scrollbarWidth, setScrollbarWidth] = (0, $5uXOq.useState)(0);
    const elementRef = (0, $5uXOq.useRef)(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $5uXOq.useEffect)(()=>{
        if (!elementRef.current) return;
        const width = elementRef.current.offsetWidth - elementRef.current.scrollWidth;
        if (width === scrollbarWidth) return;
        setScrollbarWidth(width);
    });
    return {
        width: scrollbarWidth,
        ref: elementRef
    };
}

});


parcelRegister("9zCCP", function(module, exports) {

$parcel$export(module.exports, "useChildIds", () => $edc749a9b64f215e$export$61b3ef4f009a9474);
$parcel$export(module.exports, "useChildIdsEffect", () => $edc749a9b64f215e$export$ea18c2b5f0e24612);

var $5uXOq = parcelRequire("5uXOq");

var $9btdk = parcelRequire("9btdk");
const $edc749a9b64f215e$export$61b3ef4f009a9474 = (currentStackId, committedStack, onUnknownNest)=>{
    const childIdsRef = (0, $5uXOq.useRef)(new Set());
    (0, $5uXOq.useEffect)(()=>{
        // we are holding navigation item IDs in childIdsRef
        // check if the current displayed nav item (currentStackId) is in childIdsRef. if it's not, this means it's undefined
        if (currentStackId === (0, $9btdk.ROOT_ID) || !childIdsRef.current.size || childIdsRef.current.has(currentStackId) || !onUnknownNest) return;
        onUnknownNest(committedStack || [
            currentStackId
        ]);
    }, [
        currentStackId,
        committedStack,
        onUnknownNest
    ]);
    return {
        childIdsRef: childIdsRef
    };
};
const $edc749a9b64f215e$export$ea18c2b5f0e24612 = (childIds, id)=>{
    (0, $5uXOq.useEffect)(()=>{
        if (!childIds || !childIds.current) return;
        if (!childIds.current.has(id)) childIds.current.add(id);
        return ()=>{
            // eslint-disable-next-line react-hooks/exhaustive-deps
            childIds.current.delete(id);
        };
    // childIds shouldn't change as it's a ref
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        id
    ]);
};

});


parcelRegister("cfT4M", function(module, exports) {

$parcel$export(module.exports, "NestingMotion", () => $0051a7791f96d83a$export$9e743a8c2a6b450e);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8Sbj3 = parcelRequire("8Sbj3");
const $0051a7791f96d83a$export$9e743a8c2a6b450e = (props)=>{
    const { children: children, enterFrom: enterFrom, exitTo: exitTo, testId: testId } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Sbj3.default), {
        exitTo: exitTo,
        enterFrom: enterFrom,
        animationTimingFunction: "ease-out",
        children: (innerProps, direction)=>children({
                'data-enter-from': enterFrom,
                'data-exit-to': exitTo,
                'data-testid': testId && `${testId}-${direction}`,
                ...innerProps
            })
    });
};

});


parcelRegister("gZEU1", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb2dd47d2fa741f7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $j7LBE = parcelRequire("j7LBE");
const $eb2dd47d2fa741f7$var$sidebarMinWidth = '240px';
const $eb2dd47d2fa741f7$var$sideNavStyles = null;
/**
 * __Side navigation__
 *
 * A highly composable side navigation component that supports nested views.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 * - [Usage](https://atlassian.design/components/side-navigation/usage)
 */ const $eb2dd47d2fa741f7$var$SideNavigation = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, label: label, isServer: isServer = false, isSSRPlaceholderEnabled: isSSRPlaceholderEnabled = false } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("nav", {
        ref: ref,
        "data-testid": testId,
        "aria-label": label,
        "data-vc": `side-navigation${isServer ? '-ssr' : ''}`,
        ...isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder': 'side-navigation-placeholder'
        },
        ...!isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder-replace': 'side-navigation-placeholder'
        },
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _1bsb1osq _1ul9p3fh _4t3i1osq _kqswh2mm _2lx21bp4 _bfhkw70a _syazjjyb"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j7LBE.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "notch",
            children: children
        })
    });
});
var $eb2dd47d2fa741f7$export$2e2bcd8739ae039 = $eb2dd47d2fa741f7$var$SideNavigation;

});

parcelRegister("k0ZZ2", function(module, exports) {

$parcel$export(module.exports, "MenuItem", () => $5e6269ab5deb76fb$export$2ce376c2cc3355c8);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aZsz6 = parcelRequire("aZsz6");

var $jSfqD = parcelRequire("jSfqD");

var $hjSul = parcelRequire("hjSul");
var $doZTA = parcelRequire("doZTA");

var $fpoBX = parcelRequire("fpoBX");

var $jvqf4 = parcelRequire("jvqf4");
const $5e6269ab5deb76fb$var$cssVarPrefix = '--sidebar-menu-item';
const $5e6269ab5deb76fb$var$bgColorCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-bg-color`;
const $5e6269ab5deb76fb$var$bgColorHoverCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-bg-color-hover`;
const $5e6269ab5deb76fb$var$bgColorActiveCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-bg-color-active`;
const $5e6269ab5deb76fb$var$colorCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-color`;
const $5e6269ab5deb76fb$var$colorHoverCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-color-hover`;
const $5e6269ab5deb76fb$var$colorActiveCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-color-active`;
const $5e6269ab5deb76fb$var$boxShadowCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-box-shadow`;
const $5e6269ab5deb76fb$var$iconSecondaryColorHoverCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-icon-secondary-color-hover`;
const $5e6269ab5deb76fb$var$styles = {
    root: "_ow0718uv _vwjz18uv _el8t18uv _17rj1kw7 _1f981kw7 _12pi1kw7 _1iqunqa1 _6xf7nqa1 _1lwpnqa1 _144v1r31 _3m4d1r31 _epv21r31 _chl4glyw _1bblglyw _1xhsglyw _1txwidpf _fg45idpf _gmaiidpf _10fu1oxo _iozn1cd0 _1vzi1w2z _davf29yu _1lfucjiy _s3s5tlke _12pzh2mm",
    selected: "_1cmdaqb7",
    themeColorDefault: "_1w905hvc _zelm5hvc _1f1j5hvc _1cmd5hvc",
    themeColorHover: "_1fh1smn3",
    themeColorActive: "_1l5a14t4 _1gdc14t4 _g8mu14t4 _434t14t4",
    themeBgColorDefault: "_16hgrn9c",
    themeBgColorHover: "_u1mb58tq",
    themeBgColorActive: "_1lg618j6",
    themeIconSecondaryColorHover: "_1k5811db"
};
const $5e6269ab5deb76fb$var$WrapperComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, className: className, legacyClassName: legacyClassName, href: href, to: to, target: target, useButtonLink: // @ts-expect-error - TS2339 - Property 'useButtonLink' does not exist on type 'CustomItemComponentProps & AnchorHTMLAttributes<HTMLAnchorElement> & { children: ReactNode; ... 10 more ...; prefetch?: false | ... 2 more ... | undefined; } & { ...; }'.
useButtonLink, ...props }, ref)=>{
    const commonProps = {
        ...props,
        children: children,
        className: `${className ?? ''} ${legacyClassName ?? ''}`
    };
    return href != null || to != null ? /*#__PURE__*/ $5uXOq.createElement((0, $hjSul.Link), {
        ...commonProps,
        href: href,
        to: to,
        target: target,
        ref: ref,
        type: useButtonLink ? 'button' : 'a'
    }) : // @ts-expect-error Type 'HTMLAnchorElement | HTMLButtonElement | null' is not assignable to type 'HTMLButtonElement | null'
    /*#__PURE__*/ $5uXOq.createElement($5e6269ab5deb76fb$var$ButtonItem, {
        ...commonProps,
        type: "button",
        ref: ref
    });
});
const $5e6269ab5deb76fb$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ analytics: analytics, href: href, onClick: onClick, overrides: overrides, selectedOn: selectedOn, className: className, useButtonLink: useButtonLink = false, ...rest }, ref)=>{
    const onClickHandler = (0, $jvqf4.useOnClick)({
        onClick: onClick,
        analytics: analytics
    });
    const [{ route: route, query: query, location: location }] = (0, $doZTA.useRouter)();
    let isSelected;
    // Currently, because the CMP project settings are not part of the SPA, the whole sidebar reloads everytime a menu item
    // is clicked -> As part of the Lunar Project Settings improvements, we're scrolling selected items into view once the
    // page reloads.
    //
    // We're setting a timeout to wait for the event loop to complete prior to scrolling.
    (0, $5uXOq.useEffect)(()=>{
        // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
        if (isSelected && ref?.current != null) setTimeout(()=>{
            // using ref?.current doesn't seem to work specifically here
            // Flow complianed about this part here specifically :/
            ref && // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
            ref.current != null && // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
            ref.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        });
    }, [
        selectedOn,
        ref,
        // @ts-expect-error - Variable 'isSelected' is used before being assigned.
        isSelected
    ]);
    if (typeof selectedOn === 'function') isSelected = route != null && // @ts-expect-error - Property 'search' is missing in type 'URLParse' but required in type 'MatcherLocation'.
    selectedOn({
        ...location,
        query: query
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(href || '/', true));
    else isSelected = Boolean(selectedOn) && route != null && selectedOn != null && selectedOn.includes(route.name);
    const theme = (0, $fpoBX.useSidebarTheme)();
    const itemTheme = theme?.navigation?.item;
    const iconTheme = theme?.navigation?.icon;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const customProps = {
        ...rest,
        component: $5e6269ab5deb76fb$var$WrapperComponent,
        href: href,
        isSelected: isSelected,
        onClick: onClickHandler,
        overrides: overrides,
        ref: ref,
        useButtonLink: useButtonLink,
        'aria-current': isSelected ? 'page' : undefined,
        style: {
            [$5e6269ab5deb76fb$var$bgColorCssVar]: itemTheme?.background?.default ?? undefined,
            [$5e6269ab5deb76fb$var$bgColorHoverCssVar]: itemTheme?.background?.hover ?? undefined,
            [$5e6269ab5deb76fb$var$bgColorActiveCssVar]: itemTheme?.background?.active ?? undefined,
            [$5e6269ab5deb76fb$var$colorCssVar]: itemTheme?.color?.default ?? undefined,
            [$5e6269ab5deb76fb$var$colorHoverCssVar]: itemTheme?.color?.hover ?? undefined,
            [$5e6269ab5deb76fb$var$colorActiveCssVar]: itemTheme?.color?.active ?? undefined,
            [$5e6269ab5deb76fb$var$boxShadowCssVar]: itemTheme?.color?.active != null ? `${itemTheme?.color?.active} 0 0 0 2px inset` : `${"var(--ds-border-focused, #388BFF)"} 0 0 0 2px inset`,
            [$5e6269ab5deb76fb$var$iconSecondaryColorHoverCssVar]: iconTheme?.secondary?.color?.hover ?? undefined
        }
    };
    if (overrides?.CustomItem?.render) return overrides?.CustomItem?.render({
        ...customProps,
        className: (0, $bwpsq.default)([
            (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.root
            ]),
            isSelected && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.selected
            ]),
            itemTheme?.color?.default && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeColorDefault
            ]),
            itemTheme?.background?.default && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeBgColorDefault
            ]),
            itemTheme?.background?.hover && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeBgColorHover
            ]),
            itemTheme?.background?.active && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeBgColorActive
            ]),
            itemTheme?.color?.hover && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeColorHover
            ]),
            itemTheme?.color?.active && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeColorActive
            ]),
            iconTheme?.secondary?.color?.hover && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeIconSecondaryColorHover
            ]),
            className
        ])
    });
    return /*#__PURE__*/ $5uXOq.createElement((0, $jSfqD.default), {
        ...customProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $bwpsq.default)([
            $5e6269ab5deb76fb$var$styles.root,
            isSelected && $5e6269ab5deb76fb$var$styles.selected,
            itemTheme?.color?.default && $5e6269ab5deb76fb$var$styles.themeColorDefault,
            itemTheme?.background?.default && $5e6269ab5deb76fb$var$styles.themeBgColorDefault,
            itemTheme?.background?.hover && $5e6269ab5deb76fb$var$styles.themeBgColorHover,
            itemTheme?.background?.active && $5e6269ab5deb76fb$var$styles.themeBgColorActive,
            itemTheme?.color?.hover && $5e6269ab5deb76fb$var$styles.themeColorHover,
            itemTheme?.color?.active && $5e6269ab5deb76fb$var$styles.themeColorActive,
            iconTheme?.secondary?.color?.hover && $5e6269ab5deb76fb$var$styles.themeIconSecondaryColorHover,
            className
        ])
    });
});
// this should be same as ButtonItem in '@atlaskit/menu'
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5e6269ab5deb76fb$var$ButtonItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhk18uv _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fpoBX", function(module, exports) {

$parcel$export(module.exports, "SidebarThemeProvider", () => $c9116269ddc1accc$export$92cd68117b68bf5f);
$parcel$export(module.exports, "useSidebarTheme", () => $c9116269ddc1accc$export$b1a81b4626bc52c3);

var $5uXOq = parcelRequire("5uXOq");
const $c9116269ddc1accc$var$ThemeContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $c9116269ddc1accc$export$92cd68117b68bf5f = ({ theme: theme, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c9116269ddc1accc$var$ThemeContext.Provider, {
        value: theme
    }, children);
const $c9116269ddc1accc$export$b1a81b4626bc52c3 = ()=>(0, $5uXOq.useContext)($c9116269ddc1accc$var$ThemeContext);

});

parcelRegister("jvqf4", function(module, exports) {

$parcel$export(module.exports, "useOnClick", () => $568e03d72b926f2a$export$a81c45382e7253ac);

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $568e03d72b926f2a$export$a81c45382e7253ac = ({ analytics: analytics, onClick: onClick } = {})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        });
        if (analytics) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'sidebar', analytics);
        else (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'sidebar');
        onClick && onClick(event);
    };
};

});


parcelRegister("3OGaE", function(module, exports) {

$parcel$export(module.exports, "TitleHeader", () => $09f1bcc415909488$export$de3705f3d2162955);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fJoTF = parcelRequire("fJoTF");
const $09f1bcc415909488$var$overrideStyles = null;
const $09f1bcc415909488$export$de3705f3d2162955 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fJoTF.CustomHeader), {
        testId: "navigation-apps-sidebar-common.common.ui.title-header",
        className: (0, $bwpsq.default)([
            "_dqi54jg8 _1lfu4jg8"
        ])
    }, children);
};

});
parcelRegister("fJoTF", function(module, exports) {

$parcel$export(module.exports, "CustomHeader", () => $d2408f7c0923c3e9$export$a231a61d189ef09a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jSfqD = parcelRequire("jSfqD");

var $fpoBX = parcelRequire("fpoBX");
const $d2408f7c0923c3e9$var$bgColorCssVar = '--header-bg-color';
const $d2408f7c0923c3e9$var$textColorCssVar = '--header-text-color';
const $d2408f7c0923c3e9$var$containerStyles = null;
const $d2408f7c0923c3e9$var$bgColorThemeStyles = null;
const $d2408f7c0923c3e9$var$colorThemeStyles = null;
const $d2408f7c0923c3e9$export$1e86fd0e1db89578 = ({ className: className, ...props })=>{
    const theme = (0, $fpoBX.useSidebarTheme)();
    const item = theme?.navigation?.item;
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_syaz1jnk _kqswh2mm _uizt1wug _vrjt140y _1cmdleuv _jl2n73ad _1v6j1fxt",
            item?.background?.default && "_bfhk1im0",
            item?.color?.default && "_syaz1jnk _i9a11jnk",
            className
        ]),
        // eslint-disable-next-line jira/react/no-style-attribute
        style: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {
            [$d2408f7c0923c3e9$var$bgColorCssVar]: item?.background?.default,
            [$d2408f7c0923c3e9$var$textColorCssVar]: item?.color?.default
        },
        ...props
    });
};
const $d2408f7c0923c3e9$export$a231a61d189ef09a = ({ iconBefore: iconBefore, iconAfter: iconAfter, children: children, ...rest })=>{
    return /*#__PURE__*/ $5uXOq.createElement((0, $jSfqD.default), {
        ...rest,
        component: $d2408f7c0923c3e9$export$1e86fd0e1db89578,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isTitleHeading: true
    }, children);
};

});


parcelRegister("3tHFY", function(module, exports) {

$parcel$export(module.exports, "ConnectMenu", () => $1b0be5b9936240ae$export$19d0925d424b864a);

var $5uXOq = parcelRequire("5uXOq");

var $au6nA = parcelRequire("au6nA");

var $fh2pW = parcelRequire("fh2pW");
const $1b0be5b9936240ae$export$19d0925d424b864a = ({ items: items, overrides: overrides, showIcons: showIcons = false, shouldFilter: shouldFilter = true, submenuId: submenuId = '' })=>{
    const filteredItems = (0, $au6nA.useFilteredItems)(items || null, shouldFilter);
    if (filteredItems == null || !filteredItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, filteredItems.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fh2pW.ConnectItem), {
            item: item,
            key: item.id,
            index: index,
            overrides: overrides,
            showIcons: showIcons,
            submenuId: submenuId
        })));
};

});
parcelRegister("au6nA", function(module, exports) {

$parcel$export(module.exports, "useFilteredItems", () => $cb371d7d8e582719$export$79762159776e61da);

var $5uXOq = parcelRequire("5uXOq");

var $kvHKs = parcelRequire("kvHKs");
const $cb371d7d8e582719$export$79762159776e61da = (items, shouldFilter = true)=>(0, $5uXOq.useMemo)(()=>{
        if (!shouldFilter) return items || [];
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"services" | "collectors" | "attachments" | "eventtypes" | "webhooks-admin" | "greenhopper-lexorank-manage" | "admin-helper-admin-section" | "advanced_section" | "dark_features" | ... 74 more ... | "com.codebarrel.addons.automation__cb-automation" | "com.codebarrel.addons.automation.moderate__cb-automation"'.
        return items?.filter((item)=>!(0, $kvHKs.staticLegacyIds).includes(item.id)) || [];
    }, [
        items,
        shouldFilter
    ]);

});

parcelRegister("fh2pW", function(module, exports) {

$parcel$export(module.exports, "ConnectItem", () => $f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8vDvO = parcelRequire("8vDvO");

var $gjTBi = parcelRequire("gjTBi");

var $3TzYp = parcelRequire("3TzYp");

var $iUo88 = parcelRequire("iUo88");

var $jjUR3 = parcelRequire("jjUR3");

var $hrlU6 = parcelRequire("hrlU6");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $eYDk7 = parcelRequire("eYDk7");

var $3OGaE = parcelRequire("3OGaE");

var $kZj7F = parcelRequire("kZj7F");

var $4OCke = parcelRequire("4OCke");
const $f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea = ({ index: index, item: item, overrides: overrides, showIcons: showIcons, submenuId: submenuId = '', isNested: isNested = false })=>{
    const { addNew: addNew } = (0, $jjUR3.useConnectItemClickHistory)();
    const isDialog = item.styleClass && (0, $hrlU6.isConnectDialogWebItem)(item.styleClass);
    const webItemRef = (0, $5uXOq.useRef)(null);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const BackMenuItem = {
        ...overrides.BackMenuItem,
        onClick: (ev)=>{
            // Due to CMP project settings not being part to the SPA, we have to set / get the state of the
            // Expandable menu items from cookies - this is because the page does a complete refresh upon clicking a menuitem link.
            // This is to satisfy a requirement for open expandable menus to remain open
            // when users return to the project settings menu
            if (submenuId != null) {
                const cookieData = (0, $3TzYp.getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
                let parsedCookieData = null;
                try {
                    // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
                    parsedCookieData = JSON.parse(cookieData);
                } catch  {
                    // Rather than throw an error - just set the default state
                    parsedCookieData = {
                        submenuActive: false,
                        expanded: false
                    };
                }
                const newCookieData = {
                    ...parsedCookieData,
                    submenuActive: false
                };
                (0, $iUo88.setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify(newCookieData));
            }
            // Setting navigateOnBackMenuItemClick to true will allow backToProject link to take user to the default project page
            if (overrides?.navigateOnBackMenuItemClick !== true) ev.preventDefault();
            overrides.BackMenuItem?.onClick?.(ev);
        }
    };
    const icon = (0, $5uXOq.useMemo)(()=>{
        if (showIcons !== true) return null;
        return item.iconUrl != null && item.iconUrl.trim().length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f2bd062d7c8c5e44$var$ConnectIcon, {
            src: item.iconUrl,
            alt: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8vDvO))), {
            spacing: "spacious",
            label: ""
        });
    }, [
        showIcons,
        item.iconUrl
    ]);
    const onItemClick = (0, $5uXOq.useCallback)((event)=>{
        // We need to check we're clicking an item inside a nested menu for a connect item.
        // if we are deep linking to a nested connect item -> we need to maintain the hiding of nav-modules
        // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        if (overrides?.ParentMenuItem?.onClick && isNested) // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        overrides.ParentMenuItem.onClick(event);
        if (isDialog) (0, $hrlU6.withConnectHost)((connectHost)=>{
            if (webItemRef.current && item.styleClass && item.url) connectHost.triggerWebItem(webItemRef.current, item.styleClass, item.url);
        });
        else item.url != null && addNew(item.url);
    }, [
        addNew,
        isDialog,
        isNested,
        item.styleClass,
        item.url,
        overrides
    ]);
    const onNestedMenuItemClick = (0, $5uXOq.useCallback)((event)=>{
        // Due to CMP project settings not being part to the SPA, we have to set / get the state of the
        // Expandable menu items from cookies - this is because the page does a complete refresh upon clicking a menuitem link.
        // This is to satisfy a requirement for open expandable menus to remain open
        // when users return to the project settings menu
        if (submenuId != null) {
            const cookieData = (0, $3TzYp.getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
            if (cookieData != null) (0, $iUo88.setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify({
                ...JSON.parse(cookieData),
                submenuActive: true
            }));
        }
        // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        if (overrides?.ParentMenuItem?.onClick) // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        overrides.ParentMenuItem.onClick(event);
        return ()=>null;
    }, [
        overrides,
        submenuId
    ]);
    if (item.section === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: item.name,
        hasSeparator: Boolean(index)
    }, (item.items || []).map((si, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea, {
            key: si.id,
            item: si,
            overrides: {
                ...overrides,
                BackMenuItem: BackMenuItem
            },
            index: idx,
            isNested: isNested
        })));
    if (item.items) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        id: item.id,
        analytics: {
            itemId: item.id
        },
        iconBefore: icon,
        overrides: {
            ...overrides,
            BackMenuItem: BackMenuItem
        },
        title: item.name,
        onClick: onNestedMenuItemClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eYDk7.NavigationContentWrapper), {
        submenuActive: true,
        nestedMenuOpen: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OGaE.TitleHeader), null, item.name), (item.items || []).map((si, nestIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea, {
            key: si.id,
            item: si,
            index: nestIndex,
            overrides: {
                ...overrides,
                BackMenuItem: {
                    href: item.url,
                    title: si.name,
                    onClick: (ev)=>ev.preventDefault()
                }
            },
            isNested: true
        })))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: item.id
        },
        selectedOn: (0, $4OCke.matchUrlExact)(),
        iconBefore: icon,
        href: isDialog ? undefined : item.url,
        onClick: onItemClick,
        ref: webItemRef
    }, item.name);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f2bd062d7c8c5e44$var$ConnectIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbgktf _4t3igktf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iUo88", function(module, exports) {

$parcel$export(module.exports, "setStrictlyNecessaryCookie", () => $89b5b8a4b358ad27$export$93509ff9a62ee022);

var $7RRGT = parcelRequire("7RRGT");
const $89b5b8a4b358ad27$export$93509ff9a62ee022 = (key, value, attributes)=>{
    (0, $7RRGT.setStrictlyNecessaryCookie)(key, value, attributes);
};

});

parcelRegister("eYDk7", function(module, exports) {

$parcel$export(module.exports, "NavigationHeaderWrapper", () => $eea5dc8ebf00d36e$export$bae9b35e967353d5);
$parcel$export(module.exports, "NavigationExpandableContentWrapper", () => $eea5dc8ebf00d36e$export$4e88508e6904469e);
$parcel$export(module.exports, "NavigationContentWrapper", () => $eea5dc8ebf00d36e$export$e7d691a5a9258e1b);
$parcel$export(module.exports, "NextGenIssueTypesWrapper", () => $eea5dc8ebf00d36e$export$f094f7aad76e4268);
$parcel$export(module.exports, "ExpandableProjectSettingsWrapper", () => $eea5dc8ebf00d36e$export$e38bb288d890ec2f);
$parcel$export(module.exports, "ShortCutsAndAppsWrapper", () => $eea5dc8ebf00d36e$export$337add4342ee7986);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $gwIPs = parcelRequire("gwIPs");
const $eea5dc8ebf00d36e$export$bae9b35e967353d5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NavigationHeaderWrapperContainer, null, props.children);
const $eea5dc8ebf00d36e$export$4e88508e6904469e = (props)=>{
    const { nestedAppOpen: nestedAppOpen, submenuActive: submenuActive, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NavigationExpandableContentWrapperContainer, {
        nestedAppOpen: nestedAppOpen,
        submenuActive: submenuActive
    }, children);
};
const $eea5dc8ebf00d36e$export$e7d691a5a9258e1b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NavigationContentWrapperContainer, {
        submenuActive: props.submenuActive,
        nestedMenuOpen: props.nestedMenuOpen,
        "data-component-selector": "NavigationContentWrapperContainer"
    }, props.children);
const $eea5dc8ebf00d36e$export$f094f7aad76e4268 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NextGenIssueTypesWrapperContainer, null, props.children);
const $eea5dc8ebf00d36e$export$e38bb288d890ec2f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$ExpandableProjectContainer, null, props.children);
const $eea5dc8ebf00d36e$export$337add4342ee7986 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$ShortCutsAndAppsContainer, null, props.children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $eea5dc8ebf00d36e$var$NavigationHeaderWrapperContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc _1s541012 _1lfu1012",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$NavigationExpandableContentWrapperContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { submenuActive: submenuActive, nestedAppOpen: nestedAppOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ykp9lh": (0, $lD23V.default)(__cmplp.nestedAppOpen ? 'auto' : '100%'),
            "--_1qrlsbv": (0, $lD23V.default)(Math.round((0, $gwIPs.borderRadius) * 1.333), "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc _1q1o54a6 _1dul54a6 _ofxb54a6 _179m54a6 _vnu9l52n _19iyl52n _t6kll52n _shi3l52n _15sk1v6z _178k1v6z _18pc1v6z _1bc71v6z _yugv5oil _83u65oil _1ern5oil _rjkj5oil",
            __cmplp.submenuActive && "_4t3i1qw7",
            __cmplp.submenuActive ? "_bq2uyjp0 _1n80yjp0 _di7gyjp0 _1lozyjp0" : "_bq2u1d7o _1n801d7o _di7g1d7o _1loz1d7o",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$NavigationContentWrapperContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { submenuActive: submenuActive, nestedMenuOpen: nestedMenuOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_6w8gix": (0, $lD23V.default)(__cmplp.nestedMenuOpen ? 0 : 7.5 * (0, $gwIPs.gridSize), "px"),
            "--_1qrlsbv": (0, $lD23V.default)(Math.round((0, $gwIPs.borderRadius) * 1.333), "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_yugv5oil _83u65oil _1ern5oil _rjkj5oil",
            __cmplp.submenuActive ? "_4t3iu4z3" : "_4t3i1wug",
            __cmplp.submenuActive ? "_vnu91tcg _19iy1tcg _t6kl1tcg _shi31tcg" : "_vnu9l52n _19iyl52n _t6kll52n _shi3l52n",
            __cmplp.nestedMenuOpen && "_1reo1wug _18m91wug _14tk183y",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$NextGenIssueTypesWrapperContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _vpnr1ejb _14tk72c6 _cb62utpp _1wtp1txs _l9o61txs _f6zi1txs",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$ExpandableProjectContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4t3i1osq _1wtppxbi _df5vpxbi",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$ShortCutsAndAppsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _14tk72c6 _t3zc183y _1so41gjq _1thc1skh _a6avqslr _dnyv1skh",
            __cmplp.className
        ])
    });
});

});

parcelRegister("kZj7F", function(module, exports) {

$parcel$export(module.exports, "NestingMenuItem", () => $2fbfde7c900477f4$export$4c594f24f8e4128a);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $d2gYe = parcelRequire("d2gYe");

var $8UO8z = parcelRequire("8UO8z");

var $5Hj3V = parcelRequire("5Hj3V");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $fpoBX = parcelRequire("fpoBX");

var $kavsL = parcelRequire("kavsL");
const $2fbfde7c900477f4$var$iconSecondaryColorCssVar = '--nesting-menu-item-icon-secondary-color';
const $2fbfde7c900477f4$var$styles = {
    backButtonThemeOverrides: "_18ljulk5 _ksbyulk5",
    customItem: "_4t3i1ady _vl7qglyw _slhpglyw _7upw1txw _1nrm18uv _1a3b18uv _1ydc18uv _c2wa1kw7 _4fpr1kw7 _1x281kw7 _1iohnqa1 _5goinqa1 _1726nqa1 _1q5t1r31 _nt751r31 _9nxe1r31 _1ohyglyw _49pcglyw _tpgfglyw _1r9xidpf _1hvwidpf _12gridpf"
};
const $2fbfde7c900477f4$var$WrappingLinkComponent = (props)=>/*#__PURE__*/ $5uXOq.createElement("a", props, props.children);
const $2fbfde7c900477f4$export$4c594f24f8e4128a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, id: id, reloadOnNavigationToNesting: reloadOnNavigationToNesting, overrides: overrides = {}, title: title, ...rest }, ref)=>{
    const theme = (0, $fpoBX.useSidebarTheme)();
    const iconSecondaryColor = theme?.navigation?.icon?.secondary?.color?.default;
    const { BackMenuItem: BackMenuItem = {} } = overrides;
    const { title: backTitle = 'Back', wrapper: WrapperComponent = (0, $5uXOq.Fragment), ...backItemProps } = BackMenuItem; // eslint-disable-line @typescript-eslint/consistent-type-assertions
    const renderBackItem = (0, $5uXOq.useCallback)(({ onClick: onClick })=>/*#__PURE__*/ $5uXOq.createElement(WrapperComponent, null, /*#__PURE__*/ $5uXOq.createElement((0, $k0ZZ2.MenuItem), {
            ...backItemProps,
            analytics: {
                itemId: 'back'
            },
            iconBefore: /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($d2gYe))), {
                spacing: "spacious",
                label: ""
            }),
            onClick: (ev)=>{
                if ((0, $kavsL.isNormalClick)(ev)) {
                    onClick();
                    backItemProps.onClick?.(ev);
                }
            },
            // eslint-disable-next-line jira/react/no-style-attribute, @typescript-eslint/consistent-type-assertions
            style: {
                [$2fbfde7c900477f4$var$iconSecondaryColorCssVar]: iconSecondaryColor ?? undefined
            },
            className: (0, $bwpsq.default)([
                iconSecondaryColor && $2fbfde7c900477f4$var$styles.backButtonThemeOverrides
            ])
        }, backTitle)), [
        WrapperComponent,
        backItemProps,
        backTitle,
        iconSecondaryColor
    ]);
    const renderCustomItem = (0, $5uXOq.useCallback)(({ children: itemTitle, onClick: onClick, className: className, ...props })=>/*#__PURE__*/ $5uXOq.createElement((0, $8UO8z.default), {
            ...props,
            id: id,
            component: reloadOnNavigationToNesting ? $2fbfde7c900477f4$var$WrappingLinkComponent : props.component,
            onClick: (ev)=>{
                // if nesting item already selected do not trigger route change
                if (props.isSelected === true) ev.preventDefault();
                onClick && onClick(ev);
            },
            // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
            overrides: {
                GoBackItem: {
                    render: renderBackItem
                }
            },
            title: itemTitle,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
            className: (0, $bwpsq.default)([
                $2fbfde7c900477f4$var$styles.customItem,
                className
            ])
        }, /*#__PURE__*/ $5uXOq.createElement((0, $5Hj3V.SidebarErrorBoundary), {
            id: `${id}Nesting`,
            packageName: "jiraSpaAppsSidebarCommon"
        }, children)), [
        children,
        id,
        reloadOnNavigationToNesting,
        renderBackItem
    ]);
    return /*#__PURE__*/ $5uXOq.createElement((0, $k0ZZ2.MenuItem), {
        ...rest,
        ref: ref,
        overrides: {
            CustomItem: {
                render: renderCustomItem
            }
        }
    }, title);
});

});



parcelRegister("eaZ4X", function(module, exports) {

$parcel$export(module.exports, "SECTION_ID", () => $b36275c07d465a0e$export$501955bd67991a25);
const $b36275c07d465a0e$export$501955bd67991a25 = {
    MIGRATE_TO_CLOUD_SITE: 'migrate-to-cloud-site',
    PERFORMANCE_AND_SCALE: 'performance-and-scale'
};

});

parcelRegister("jMBA3", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $4023bf6b28a8dc58$export$4a39035bacc4ed76);
$parcel$export(module.exports, "useGlobalSettingsSystemConnectItems", () => $4023bf6b28a8dc58$export$f601efaceb0636f4);

var $5uXOq = parcelRequire("5uXOq");

var $aUDLa = parcelRequire("aUDLa");

var $7OqB4 = parcelRequire("7OqB4");

var $awp39 = parcelRequire("awp39");

var $9OXo1 = parcelRequire("9OXo1");

var $gJkov = parcelRequire("gJkov");
const $4023bf6b28a8dc58$export$4a39035bacc4ed76 = (0, $7OqB4.withThrowOnError)(()=>{
    const { data: data, loading: loading, error: error } = (0, $aUDLa.useNavigationGlobalResource)();
    const { isDevMode: isDevMode, isAdmin: isAdmin } = (0, $9OXo1.useTenantContext)();
    const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, $gJkov.extractData)(data, isDevMode, isAdmin), [
        data,
        isDevMode,
        isAdmin
    ]);
    return {
        data: extractedData,
        loading: loading,
        error: error
    };
});
const $4023bf6b28a8dc58$export$f601efaceb0636f4 = (0, $7OqB4.withThrowOnError)((0, $awp39.useGlobalSettingsSystemConnectItems));

});
parcelRegister("7OqB4", function(module, exports) {

$parcel$export(module.exports, "withThrowOnError", () => $f0eadb98e9fdd0d1$export$a018832f2ec4dc91);
/* eslint-disable jira/react-magnetic-di/no-unneeded */ 
var $gKZoD = parcelRequire("gKZoD");
const $f0eadb98e9fdd0d1$var$isDataEmpty = (data)=>data == null;
function $f0eadb98e9fdd0d1$export$a018832f2ec4dc91(theHook) {
    return (...args)=>{
        // tests like src/packages/navigation-apps/horizontal-nav/tabs/board-scoped-tab/src/test.tsx do not work without this line
        (0, $gKZoD.di)(theHook);
        const result = theHook(...args);
        // escalate .error if condition is met (by throwing a runtime exception from it; to be caught and logged by the nearest ErrorBoundary for example).
        if (!false && $f0eadb98e9fdd0d1$var$isDataEmpty(result.data) && !result.loading && result.error) throw result.error;
        return result;
    };
}

});

parcelRegister("gJkov", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $63e1d07edc3ef769$export$9df5fa0a366163d2);

var $83mn0 = parcelRequire("83mn0");
const $63e1d07edc3ef769$export$9df5fa0a366163d2 = (data, isDevMode, isAdmin)=>({
        hasGeneralConfiguration: isAdmin,
        hasDarkFeatures: (0, $83mn0.hasItemInSidebar)(data, 'dark_features'),
        hasTroubleshootingAndSupportSection: isAdmin,
        hasViewAuditing: isAdmin,
        hasPluginViewer: isDevMode && isAdmin,
        hasModulesViewer: isDevMode && isAdmin,
        hasSystemInfo: (0, $83mn0.hasItemInSidebar)(data, 'system_info'),
        hasIntegrityChecker: (0, $83mn0.hasItemInSidebar)(data, 'integrity_checker'),
        hasLoggingProfiling: (0, $83mn0.hasItemInSidebar)(data, 'logging_profiling'),
        hasSchedulerDetails: (0, $83mn0.hasItemInSidebar)(data, 'scheduler_details'),
        hasSecuritySection: isAdmin,
        hasProjectRoles: isAdmin,
        hasGlobalPermissions: isAdmin,
        hasCollectors: isAdmin,
        hasUserInterfaceSection: isAdmin,
        hasUserDefaults: isAdmin,
        hasEditDefaultDashboard: isAdmin,
        hasLookAndFeel: isAdmin,
        hasPasAdmin: (0, $83mn0.hasItemInSidebar)(data, 'com.atlassian.pas:pas-admin-link-jira'),
        hasImportExportSection: isAdmin,
        hasBackupManager: isAdmin,
        hasExternalImport: isAdmin,
        hasRestoreSystem: (0, $83mn0.hasItemInSidebar)(data, 'vertigo_import'),
        hasCloudImport: (0, $83mn0.hasItemInSidebar)(data, 'vertigo_import_jira_cloud'),
        hasServerImport: (0, $83mn0.hasItemInSidebar)(data, 'vertigo_import_jira_server'),
        hasMailSection: isAdmin,
        hasGlobalMailSettings: isAdmin,
        hasOutgoingMail: isAdmin,
        hasIncomingMail: isAdmin,
        hasSendMail: isAdmin,
        hasAdminHelperSection: isAdmin,
        hasPermissionHelper: isAdmin,
        hasSharedSection: isAdmin,
        hasManageDashboards: isAdmin,
        hasManageFilters: isAdmin,
        // advanced
        hasAdvancedSection: isAdmin,
        hasAttachments: isAdmin,
        hasEvents: isAdmin,
        hasWebHooks: isAdmin,
        hasServices: isAdmin,
        hasLexoRankManagement: (0, $83mn0.hasItemInSidebar)(data, 'greenhopper-lexorank-manage')
    });

});


parcelRegister("aVTmi", function(module, exports) {

$parcel$export(module.exports, "AdminHelperSection", () => $f6a1ba8c0486741e$export$4855b2d78f0d666a);

var $5uXOq = parcelRequire("5uXOq");

var $jZ4fr = parcelRequire("jZ4fr");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gjTBi = parcelRequire("gjTBi");
var $bWqXX = parcelRequire("bWqXX");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $17bH5 = parcelRequire("17bH5");

var $4OCke = parcelRequire("4OCke");

var $jMBA3 = parcelRequire("jMBA3");

var $3B8mV = parcelRequire("3B8mV");
const $f6a1ba8c0486741e$var$BLOCKING_INVITATIONS_LOG_SPOTLIGHT_KEY = 'blocking-invitations-log-spotlight';
const $f6a1ba8c0486741e$export$4855b2d78f0d666a = ()=>{
    const { data: features } = (0, $jMBA3.useFeatures)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const navigationPath = (0, $5uXOq.useMemo)(()=>(0, $17bH5.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: formatMessage((0, $3B8mV.default).adminHelper)
    }, features.hasPermissionHelper && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'permission-helper'
        },
        href: navigationPath.adminHelperPermissionHelper,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $3B8mV.default).permissionHelper)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: $f6a1ba8c0486741e$var$BLOCKING_INVITATIONS_LOG_SPOTLIGHT_KEY
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'email-notifications-log'
        },
        href: navigationPath.adminHelperEmailNotificationsLogHelper,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $f6a1ba8c0486741e$var$emailNotificationsLogContainerStyles
    }, formatMessage((0, $3B8mV.default).adminEmailAuditNotificationsLog))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
        engagementId: $f6a1ba8c0486741e$var$BLOCKING_INVITATIONS_LOG_SPOTLIGHT_KEY
    })));
};
const $f6a1ba8c0486741e$var$emailNotificationsLogContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    justifyContent: 'space-between'
});

});
parcelRegister("3B8mV", function(module, exports) {

$parcel$export(module.exports, "default", () => $82b0a510e0e13823$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $82b0a510e0e13823$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    adminHelper: {
        "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.admin-helper",
        "defaultMessage": "Admin helper"
    },
    permissionHelper: {
        "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.permission-helper",
        "defaultMessage": "Permission helper"
    },
    adminEmailAuditNotificationsLog: {
        "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.admin-email-audit-notifications-log",
        "defaultMessage": "Admin email audit"
    }
});

});


parcelRegister("cip1u", function(module, exports) {

$parcel$export(module.exports, "AdvancedSection", () => $55fa8f6cf375a533$export$32bea920eaad7efb);

var $5uXOq = parcelRequire("5uXOq");

var $gjTBi = parcelRequire("gjTBi");
var $bWqXX = parcelRequire("bWqXX");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $17bH5 = parcelRequire("17bH5");

var $4OCke = parcelRequire("4OCke");

var $jMBA3 = parcelRequire("jMBA3");

var $68MUk = parcelRequire("68MUk");
const $55fa8f6cf375a533$export$32bea920eaad7efb = ()=>{
    const { data: features } = (0, $jMBA3.useFeatures)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const navigationPath = (0, $5uXOq.useMemo)(()=>(0, $17bH5.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: formatMessage((0, $68MUk.default).advanced)
    }, features.hasAttachments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'attachments'
        },
        href: navigationPath.advancedSectionAttachments,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $68MUk.default).attachments)), features.hasEvents && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'events'
        },
        href: navigationPath.advancedSectionEvents,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $68MUk.default).events)), features.hasWebHooks && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'webhooks'
        },
        href: navigationPath.advancedSectionWebHooks,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $68MUk.default).webhooks)), features.hasLexoRankManagement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'lexorank-management'
        },
        href: navigationPath.advancedLexoRankManagement,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $68MUk.default).lexorankManagement)));
};

});
parcelRegister("68MUk", function(module, exports) {

$parcel$export(module.exports, "default", () => $24a7ac619834e463$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $24a7ac619834e463$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    advanced: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.advanced",
        "defaultMessage": "Advanced"
    },
    attachments: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.attachments",
        "defaultMessage": "Attachments"
    },
    events: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.events",
        "defaultMessage": "Events"
    },
    webhooks: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.webhooks",
        "defaultMessage": "WebHooks"
    },
    lexorankManagement: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.lexorank-management",
        "defaultMessage": "LexoRank management"
    }
});

});


parcelRegister("8wyB3", function(module, exports) {

$parcel$export(module.exports, "AutomationSection", () => $ae233f5e809ec072$export$5fa01e4d25d8e6ec);

var $5uXOq = parcelRequire("5uXOq");

var $gjTBi = parcelRequire("gjTBi");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $17bH5 = parcelRequire("17bH5");

var $6tKa8 = parcelRequire("6tKa8");
const $ae233f5e809ec072$export$5fa01e4d25d8e6ec = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const navigationPath = (0, $5uXOq.useMemo)(()=>(0, $17bH5.getSystemNavigationPaths)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: formatMessage((0, $6tKa8.default).automationGroup)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'automation'
        },
        href: navigationPath.globalAutomation,
        selectedOn: [
            'global-automation'
        ]
    }, formatMessage((0, $6tKa8.default).globalAutomation)));
};

});
parcelRegister("6tKa8", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1b0e49ecb7c48dd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b1b0e49ecb7c48dd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    automationGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.automation.automation-group",
        "defaultMessage": "Automation"
    },
    globalAutomation: {
        "id": "spa-apps-sidebar-global-settings-system.menu.automation.global-automation",
        "defaultMessage": "Global automation"
    }
});

});


parcelRegister("230Wm", function(module, exports) {

$parcel$export(module.exports, "ImportExportSection", () => $45f1c30d97953942$export$2e4cb1dc5b398447);

var $5uXOq = parcelRequire("5uXOq");

var $gjTBi = parcelRequire("gjTBi");
var $bWqXX = parcelRequire("bWqXX");

var $2vSU6 = parcelRequire("2vSU6");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $17bH5 = parcelRequire("17bH5");

var $4OCke = parcelRequire("4OCke");

var $9OXo1 = parcelRequire("9OXo1");

var $jMBA3 = parcelRequire("jMBA3");

var $8136S = parcelRequire("8136S");
const $45f1c30d97953942$export$2e4cb1dc5b398447 = ()=>{
    const { data: features } = (0, $jMBA3.useFeatures)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { licensedProducts: licensedProducts } = (0, $9OXo1.useTenantContext)();
    const navigationPath = (0, $5uXOq.useMemo)(()=>(0, $17bH5.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    const hasSupportedLicense = licensedProducts[(0, $2vSU6.projectTypeToCanonicalId)((0, $2vSU6.SOFTWARE_PROJECT))] || licensedProducts[(0, $2vSU6.projectTypeToCanonicalId)((0, $2vSU6.CORE_PROJECT))];
    const showNewExternalImport = hasSupportedLicense;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: formatMessage((0, $8136S.default).importExportGroup)
    }, features.hasBackupManager && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'cloud-export'
        },
        href: navigationPath.importSectionBackupManager,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $8136S.default).backupManager)), features.hasExternalImport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'external-import'
        },
        href: showNewExternalImport ? navigationPath.importSectionExternalImportNew : navigationPath.importSectionExternalImport,
        selectedOn: (currentLocation, itemLocation)=>(0, $4OCke.matchUrlExact)()(currentLocation, itemLocation) || showNewExternalImport && currentLocation.pathname.includes(navigationPath.importSectionExternalImport)
    }, formatMessage((0, $8136S.default).externalImport)), features.hasCloudImport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'cloud-import'
        },
        href: navigationPath.importSectionCloudImport,
        selectedOn: (0, $4OCke.matchUrlExact)()
    }, formatMessage((0, $8136S.default).importJiraCloud)), features.hasServerImport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'server-import'
        },
        href: navigationPath.importSectionServerImport,
        selectedOn: (0, $4OCke.matchUrlExact)()
    }, formatMessage((0, $8136S.default).importJiraServer)));
};

});
parcelRegister("8136S", function(module, exports) {

$parcel$export(module.exports, "default", () => $e31be53e6f399aac$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e31be53e6f399aac$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    importExportGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.import-export-group",
        "defaultMessage": "Import and export"
    },
    backupManager: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.backup-manager",
        "defaultMessage": "Backup manager"
    },
    externalImport: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.external-import",
        "defaultMessage": "External System Import"
    },
    restoreSystem: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.restore-system",
        "defaultMessage": "Restore system"
    },
    importJiraCloud: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.import-jira-cloud",
        "defaultMessage": "Import Jira Cloud"
    },
    importJiraServer: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.import-jira-server",
        "defaultMessage": "Import Jira Server"
    }
});

});


parcelRegister("je2KE", function(module, exports) {

$parcel$export(module.exports, "MailSection", () => $6a76fa07c85a01a9$export$6e0cda39522c0aa7);

var $5uXOq = parcelRequire("5uXOq");

var $gjTBi = parcelRequire("gjTBi");
var $bWqXX = parcelRequire("bWqXX");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $17bH5 = parcelRequire("17bH5");

var $4OCke = parcelRequire("4OCke");

var $jMBA3 = parcelRequire("jMBA3");

var $1c6JR = parcelRequire("1c6JR");

var $gb7H7 = parcelRequire("gb7H7");
const $6a76fa07c85a01a9$export$6e0cda39522c0aa7 = ()=>{
    const { data: features } = (0, $jMBA3.useFeatures)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const navigationPath = (0, $5uXOq.useMemo)(()=>(0, $17bH5.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: formatMessage((0, $1c6JR.default).mailGroup)
    }, features.hasGlobalMailSettings && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'global-mail-settings'
        },
        href: navigationPath.mailSectionGlobalMailSettings,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $1c6JR.default).globalMailSettings)), features.hasOutgoingMail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'outgoing-mail'
        },
        href: navigationPath.mailSectionOutgoingMail,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $1c6JR.default).outgoingMail)), features.hasIncomingMail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'incoming-mail'
        },
        href: navigationPath.mailSectionIncomingMail,
        selectedOn: (0, $gb7H7.isIncomingMailSelected)
    }, formatMessage((0, $1c6JR.default).incomingMail)), features.hasSendMail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'send-email'
        },
        href: navigationPath.mailSectionSendMail,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $1c6JR.default).sendEmail)));
};

});
parcelRegister("1c6JR", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa5900167b5101d6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fa5900167b5101d6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    mailGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.mail-group",
        "defaultMessage": "Mail"
    },
    globalMailSettings: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.global-mail-settings",
        "defaultMessage": "Global Mail Settings"
    },
    outgoingMail: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.outgoing-mail",
        "defaultMessage": "Outgoing Mail"
    },
    incomingMail: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.incoming-mail",
        "defaultMessage": "Incoming Mail"
    },
    sendEmail: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.send-email",
        "defaultMessage": "Send email"
    }
});

});

parcelRegister("gb7H7", function(module, exports) {

$parcel$export(module.exports, "isIncomingMailSelected", () => $d695081436bd6a1d$export$3f53f72603975cb0);

var $4OCke = parcelRequire("4OCke");
const $d695081436bd6a1d$var$INCOMING_MAIL_PATH_REGEXP = /\/admin\/(\w+)Pop(Mail)?Server/i;
const $d695081436bd6a1d$export$3f53f72603975cb0 = (currentLocation, itemLocation)=>(0, $4OCke.matchUrlExact)()(currentLocation, itemLocation) || $d695081436bd6a1d$var$INCOMING_MAIL_PATH_REGEXP.test(currentLocation.pathname);

});


parcelRegister("iAlf2", function(module, exports) {

$parcel$export(module.exports, "default", () => $979d16a4bf22949b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $979d16a4bf22949b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    systemGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.system-group",
        "defaultMessage": "System settings"
    },
    generalConfiguration: {
        "id": "spa-apps-sidebar-global-settings-system.menu.general-configuration",
        "defaultMessage": "General configuration"
    },
    darkFeatures: {
        "id": "spa-apps-sidebar-global-settings-system.menu.dark-features",
        "defaultMessage": "Dark features"
    },
    issueCollectors: {
        "id": "spa-apps-sidebar-global-settings-system.menu.issue-collectors",
        "defaultMessage": "Issue collectors"
    },
    globalSettingsSystemSidebarLabel: {
        "id": "spa-apps-sidebar-global-settings-system.menu.global-settings-system-sidebar-label",
        "defaultMessage": "Sidebar"
    },
    issueCollectorsIssueTermRefresh: {
        "id": "spa-apps-sidebar-global-settings-system.menu.issue-collectors-issue-term-refresh",
        "defaultMessage": "Work item collectors"
    }
});

});

parcelRegister("fwlYA", function(module, exports) {

$parcel$export(module.exports, "SecuritySection", () => $76b3d515542acad4$export$4f16aec1633bed7d);

var $5uXOq = parcelRequire("5uXOq");

var $gjTBi = parcelRequire("gjTBi");
var $bWqXX = parcelRequire("bWqXX");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $17bH5 = parcelRequire("17bH5");

var $4OCke = parcelRequire("4OCke");

var $jMBA3 = parcelRequire("jMBA3");

var $eTPZ8 = parcelRequire("eTPZ8");

var $icmgW = parcelRequire("icmgW");
const $76b3d515542acad4$export$4f16aec1633bed7d = ()=>{
    const { data: features } = (0, $jMBA3.useFeatures)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const navigationPath = (0, $5uXOq.useMemo)(()=>(0, $17bH5.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    const globalPermissionsPath = navigationPath.securityGlobalPermissions;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: formatMessage((0, $eTPZ8.default).securityGroup)
    }, features.hasProjectRoles && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'project-roles'
        },
        href: navigationPath.securityProjectRoles,
        selectedOn: (0, $icmgW.isProjectRolesSelected)
    }, formatMessage((0, $eTPZ8.default).projectRoles)), features.hasGlobalPermissions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'global-permissions'
        },
        href: globalPermissionsPath,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $eTPZ8.default).globalPermissions)));
};

});
parcelRegister("eTPZ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $db51b59205472bbf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $db51b59205472bbf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    securityGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.security.security-group",
        "defaultMessage": "Security"
    },
    projectRoles: {
        "id": "spa-apps-sidebar-global-settings-system.menu.security.project-roles",
        "defaultMessage": "Project roles"
    },
    globalPermissions: {
        "id": "spa-apps-sidebar-global-settings-system.menu.security.global-permissions",
        "defaultMessage": "Global permissions"
    }
});

});

parcelRegister("icmgW", function(module, exports) {

$parcel$export(module.exports, "isProjectRolesSelected", () => $f6a84fa88243c239$export$ca9501e7fedfce90);

var $4OCke = parcelRequire("4OCke");
const $f6a84fa88243c239$var$PROJECT_ROLES_PATH_REGEXP = /\/project\/(\w+)ProjectRole/i;
const $f6a84fa88243c239$export$ca9501e7fedfce90 = (currentLocation, itemLocation)=>(0, $4OCke.matchUrlExact)()(currentLocation, itemLocation) || $f6a84fa88243c239$var$PROJECT_ROLES_PATH_REGEXP.test(currentLocation.pathname);

});


parcelRegister("9O5DC", function(module, exports) {

$parcel$export(module.exports, "SharedSection", () => $440640fab2704f98$export$230e518497f06fdc);

var $5uXOq = parcelRequire("5uXOq");

var $gjTBi = parcelRequire("gjTBi");
var $bWqXX = parcelRequire("bWqXX");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $17bH5 = parcelRequire("17bH5");

var $4OCke = parcelRequire("4OCke");

var $jMBA3 = parcelRequire("jMBA3");

var $hw0ew = parcelRequire("hw0ew");
const $440640fab2704f98$export$230e518497f06fdc = ()=>{
    const { data: features } = (0, $jMBA3.useFeatures)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const navigationPath = (0, $5uXOq.useMemo)(()=>(0, $17bH5.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: formatMessage((0, $hw0ew.default).sharedItems)
    }, features.hasManageFilters && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'manage-filters'
        },
        href: navigationPath.sharedSectionManageFilters,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $hw0ew.default).filters)), features.hasManageDashboards && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'manage-dashboards'
        },
        href: navigationPath.sharedManageDashboards,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $hw0ew.default).dashboards)));
};

});
parcelRegister("hw0ew", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a51482729945d2e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4a51482729945d2e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    sharedItems: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.shared-items",
        "defaultMessage": "Shared Items"
    },
    sharedFilters: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.shared-filters",
        "defaultMessage": "Shared filters"
    },
    sharedDashboards: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.shared-dashboards",
        "defaultMessage": "Shared dashboards"
    },
    filters: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.filters",
        "defaultMessage": "Filters"
    },
    dashboards: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.dashboards",
        "defaultMessage": "Dashboards"
    }
});

});


parcelRegister("1y2CG", function(module, exports) {

$parcel$export(module.exports, "TroubleshootingAndSupportSection", () => $5fd448f06aadda25$export$dad01649916e6a2d);

var $5uXOq = parcelRequire("5uXOq");

var $gjTBi = parcelRequire("gjTBi");
var $bWqXX = parcelRequire("bWqXX");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $fRwoF = parcelRequire("fRwoF");

var $17bH5 = parcelRequire("17bH5");

var $4OCke = parcelRequire("4OCke");

var $jMBA3 = parcelRequire("jMBA3");

var $4oL80 = parcelRequire("4oL80");

var $81Iv5 = parcelRequire("81Iv5");

var $ie4oV = parcelRequire("ie4oV");
const $5fd448f06aadda25$export$dad01649916e6a2d = ()=>{
    const { data: features } = (0, $jMBA3.useFeatures)();
    const { hasSiteOptimizerEntitlement: hasSiteOptimizerEntitlement } = (0, $fRwoF.useSiteOptimizerCheck)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const navigationPath = (0, $5uXOq.useMemo)(()=>(0, $17bH5.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: formatMessage((0, $4oL80.default).troubleshootingGroup)
    }, features.hasViewAuditing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'view-auditing'
        },
        href: navigationPath.troubleshootingAuditLog,
        selectedOn: (0, $ie4oV.isViewAuditingSelected)
    }, formatMessage((0, $4oL80.default).auditLog)), features.hasPluginViewer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'plugin-viewer'
        },
        href: navigationPath.troubleshootingPluginViewer,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $4oL80.default).pluginViewer)), features.hasModulesViewer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'modules-viewer'
        },
        href: navigationPath.troubleshootingModulesViewer,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $4oL80.default).modulesViewer)), features.hasSystemInfo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'system-info'
        },
        href: navigationPath.troubleshootingSystemInfo,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $4oL80.default).systemInfo)), features.hasIntegrityChecker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'integrity-checker'
        },
        href: navigationPath.troubleshootingIntegrityChecker,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $4oL80.default).integrityChecker)), features.hasLoggingProfiling && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'logging-profiling'
        },
        href: navigationPath.troubleshootingLoggingProfiling,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $4oL80.default).loggingProfiling)), features.hasSchedulerDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'scheduler-details'
        },
        href: navigationPath.troubleshootingSchedulerDetails,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $4oL80.default).schedulerDetails)), hasSiteOptimizerEntitlement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $81Iv5.PerformanceMenuItem), null));
};

});
parcelRegister("fRwoF", function(module, exports) {

$parcel$export(module.exports, "useSiteOptimizerCheck", () => $31e8f2ad3b3f051f$export$7df80afc329cd61);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");
const $31e8f2ad3b3f051f$export$e9921a980669184 = ()=>(0, $eusud.performGetRequest)('/rest/internal/psi/latest/licence/check');
const $31e8f2ad3b3f051f$export$7df80afc329cd61 = ()=>{
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const [hasEntitlement, setHasEntitlement] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)();
    const fetch = async ()=>{
        try {
            setLoading(true);
            setError(undefined);
            if ((0, $4R6GH.fg)('override-enable-performance-and-scale-admin-menu')) setHasEntitlement(true);
            else {
                const data = await $31e8f2ad3b3f051f$export$e9921a980669184();
                setHasEntitlement(data?.isVisible ?? false);
            }
            setLoading(false);
        } catch (apiError) {
            setLoading(false);
            setError(apiError);
        }
    };
    (0, $5uXOq.useEffect)(()=>{
        fetch();
    }, []);
    return {
        loading: loading,
        hasSiteOptimizerEntitlement: hasEntitlement,
        error: error
    };
};

});

parcelRegister("4oL80", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ca98bc392d099f0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9ca98bc392d099f0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    troubleshootingGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.troubleshooting-group",
        "defaultMessage": "Troubleshooting and Support"
    },
    auditLog: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.audit-log",
        "defaultMessage": "Audit Log"
    },
    pluginViewer: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.plugin-viewer",
        "defaultMessage": "Plugin Viewer"
    },
    modulesViewer: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.modules-viewer",
        "defaultMessage": "Modules Viewer"
    },
    systemInfo: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.system-info",
        "defaultMessage": "System info"
    },
    integrityChecker: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.integrity-checker",
        "defaultMessage": "Integrity checker"
    },
    loggingProfiling: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.logging-profiling",
        "defaultMessage": "Logging profiling"
    },
    schedulerDetails: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.scheduler-details",
        "defaultMessage": "Scheduler details"
    }
});

});

parcelRegister("81Iv5", function(module, exports) {

$parcel$export(module.exports, "PerformanceMenuItem", () => $ca611bfc0be59ae0$export$b4e98631ff0b3fb5);

var $5uXOq = parcelRequire("5uXOq");

var $aYAc3 = parcelRequire("aYAc3");

var $imZsD = parcelRequire("imZsD");
var $5Fk4Z = parcelRequire("5Fk4Z");
var $1QiBP = parcelRequire("1QiBP");

var $MHKc7 = parcelRequire("MHKc7");
var $bUmQV = parcelRequire("bUmQV");

var $koVbs = parcelRequire("koVbs");

var $kZj7F = parcelRequire("kZj7F");

var $17bH5 = parcelRequire("17bH5");

var $8zOmE = parcelRequire("8zOmE");

var $ehdJY = parcelRequire("ehdJY");

var $90yGq = parcelRequire("90yGq");

var $eaZ4X = parcelRequire("eaZ4X");

var $1ssva = parcelRequire("1ssva");

var $iWjQg = parcelRequire("iWjQg");

var $fM231 = parcelRequire("fM231");
const $ca611bfc0be59ae0$export$b4e98631ff0b3fb5 = ()=>{
    const accountId = (0, $90yGq.useAccountId)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOptimiserSpotlightActive, setIsOptimiserSpotlightActive] = (0, $5uXOq.useState)(false);
    const navigationPath = (0, $5uXOq.useMemo)(()=>(0, $17bH5.getSystemNavigationPaths)(), []);
    const BackMenuItem = {
        href: '/jira/settings/system/general-configuration',
        title: formatMessage((0, $1ssva.default).itemBack)
    };
    const fetchSpotlightState = (0, $5uXOq.useCallback)(async ()=>{
        if (accountId != null) {
            const response = await (0, $fM231.hasSeenSiteOptimiserSpotlight)(accountId);
            setIsOptimiserSpotlightActive(!response);
        }
    }, [
        accountId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        fetchSpotlightState();
    }, [
        fetchSpotlightState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "site-optimiser-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        analytics: {
            itemId: 'performance-and-scale'
        },
        href: navigationPath.troubleshootingPerformanceAndScale,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
            gap: "space.050",
            justifyContent: "start",
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), null, formatMessage((0, $1ssva.default).performanceAndScale)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
            appearance: "new"
        }, formatMessage((0, $1ssva.default).beta))),
        overrides: {
            BackMenuItem: BackMenuItem
        },
        id: (0, $eaZ4X.SECTION_ID).PERFORMANCE_AND_SCALE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iWjQg.PerformanceAndScaleMenu), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, isOptimiserSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        actions: [
            {
                onClick: (_, analyticsEvent)=>{
                    setIsOptimiserSpotlightActive(false);
                    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'performanceMenuItemSpotlightComplete');
                },
                text: formatMessage((0, $1ssva.default).spotlightAction)
            }
        ],
        heading: formatMessage((0, $1ssva.default).spotlightHeading),
        target: "site-optimiser-spotlight",
        key: "site-optimiser-spotlight",
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        dialogPlacement: "right top",
        messageId: "navigation-apps-sidebar-global-settings-system.ui.menu.troubleshooting-and-support.performance-menu-item.jira-spotlight.site-optimiser-spotlight",
        messageType: "engagement"
    }, formatMessage((0, $1ssva.default).spotlightBody))));
};

});
parcelRegister("1ssva", function(module, exports) {

$parcel$export(module.exports, "default", () => $46da0b37092f9f6a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $46da0b37092f9f6a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    performanceAndScale: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale",
        "defaultMessage": "Site optimizer"
    },
    itemBack: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.item-back",
        "defaultMessage": "Back to system"
    },
    spotlightHeading: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.spotlight-heading",
        "defaultMessage": "Clean up your site"
    },
    spotlightBody: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.spotlight-body",
        "defaultMessage": "Remove old data that might be slowing down your site in a few clicks."
    },
    spotlightAction: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.spotlight-action",
        "defaultMessage": "Ok"
    },
    beta: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.beta",
        "defaultMessage": "Beta"
    }
});

});

parcelRegister("iWjQg", function(module, exports) {

$parcel$export(module.exports, "PerformanceAndScaleMenu", () => $4bb22b80a7726eba$export$442d4ccb0d25fc50);

var $5uXOq = parcelRequire("5uXOq");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $gjTBi = parcelRequire("gjTBi");

var $lzUDm = parcelRequire("lzUDm");

var $fgWYz = parcelRequire("fgWYz");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $3OGaE = parcelRequire("3OGaE");

var $4OCke = parcelRequire("4OCke");

var $etuUp = parcelRequire("etuUp");

var $jWIOc = parcelRequire("jWIOc");
const $4bb22b80a7726eba$export$442d4ccb0d25fc50 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const basePerformanceUrl = '/jira/settings/system/performance';
    const allVisibleMetrics = (0, $fgWYz.getAllVisibleMetrics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OGaE.TitleHeader), null, formatMessage((0, $etuUp.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'performance-overview'
        },
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        href: `${basePerformanceUrl}/overview`
    }, formatMessage((0, $etuUp.default).overview))), allVisibleMetrics.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: formatMessage((0, $etuUp.default).allReports)
    }, allVisibleMetrics.map((metric)=>{
        if (metric.key === (0, $lzUDm.PROJECT_CLEANUP_KEY)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
            key: "project-cleanup-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
            name: (0, $jWIOc.PROJECT_CLEANUP_SPOTLIGHT_NAME)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
            analytics: {
                itemId: `performance-metric-${metric.key}`
            },
            href: `${basePerformanceUrl}/metrics/${metric.key}`,
            selectedOn: (0, $4OCke.matchUrlPathname)(),
            key: metric.key
        }, formatMessage(metric.name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jWIOc.ProjectCleanupSpotlight), null));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
            analytics: {
                itemId: `performance-metric-${metric.key}`
            },
            href: `${basePerformanceUrl}/metrics/${metric.key}`,
            selectedOn: (0, $4OCke.matchUrlPathname)(),
            key: metric.key
        }, formatMessage(metric.name));
    })));
};

});
parcelRegister("lzUDm", function(module, exports) {

$parcel$export(module.exports, "PROJECT_CLEANUP_KEY", () => $3bfe695ee69b7be4$export$4e9bf1d386c2f0c);
$parcel$export(module.exports, "PROJECT_CLEANUP", () => $3bfe695ee69b7be4$export$761acf34bef3a717);

var $iHO6d = parcelRequire("iHO6d");
const $3bfe695ee69b7be4$export$4e9bf1d386c2f0c = 'projectcleanup';
const $3bfe695ee69b7be4$export$761acf34bef3a717 = {
    key: $3bfe695ee69b7be4$export$4e9bf1d386c2f0c,
    visible: true,
    name: (0, $iHO6d.default).nameNonFinal,
    description: (0, $iHO6d.default).descriptionNonFinal,
    tabLabels: [
        (0, $iHO6d.default).analysisNonFinal,
        (0, $iHO6d.default).activityLogNonFinal
    ],
    warningMessage: (0, $iHO6d.default).warningNonFinal,
    exceededMessage: (0, $iHO6d.default).exceededNonFinal,
    risks: [],
    mitigations: [],
    currentValueLabel: (0, $iHO6d.default).currentValueLabel,
    cleanupValueLabel: (0, $iHO6d.default).cleanupValueLabel,
    graphHeader: (0, $iHO6d.default).graphHeader,
    recommendationUrl: 'https://support.atlassian.com/jira-cloud-administration/docs/optimize-the-number-of-projects-in-your-site/',
    recommendationUrlText: (0, $iHO6d.default).recommendationUrlText
};

});
parcelRegister("iHO6d", function(module, exports) {

$parcel$export(module.exports, "default", () => $622f291bdb5f6890$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
// The following are the description for the translators for the different text that we need translating.
// Unfortunately, this needs to copied to individual files because the i18n text extraction tool needs
// to be able to resolve variables statically. This duplication is OK.
const $622f291bdb5f6890$var$NAME_DESC = 'Name of the site optimizer metric that will be used as the title on the page and menu item.';
const $622f291bdb5f6890$var$DESCRIPTION_DESC = 'Description of the site optimizer metric.';
const $622f291bdb5f6890$var$WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
const $622f291bdb5f6890$var$EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
const $622f291bdb5f6890$var$CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
const $622f291bdb5f6890$var$CLEANUP_VALUE_LABEL_DESC = 'Label to be shown next to the cleanup value of the metric.';
const $622f291bdb5f6890$var$RECOMMENDATION_URL_TEXT_DESC = 'Text to be shown on the hypertext link to additional documentation.';
const $622f291bdb5f6890$var$GRAPH_HEADER_DESC = 'Text to be shown on the header of the metric graph.';
var $622f291bdb5f6890$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    nameNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.name-non-final",
        "defaultMessage": "Projects"
    },
    descriptionNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.description-non-final",
        "defaultMessage": "Below, we\u2019ve identified company-managed and team-managed projects in your site that can be archived or trashed because they contain no issues. Removing these projects can improve site performance and stability."
    },
    recommendationUrlText: {
        "id": "admin-pages-performance.common.assets.project-cleanup.recommendation-url-text",
        "defaultMessage": "See how we identify these projects."
    },
    analysisNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.analysis-non-final",
        "defaultMessage": "Analysis"
    },
    activityLogNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.activity-log-non-final",
        "defaultMessage": "Activity log"
    },
    graphHeader: {
        "id": "admin-pages-performance.common.assets.project-role-actor.graph-header",
        "defaultMessage": "Projects over time"
    },
    // Since we don't have a threshold, these messages below will be unused - keeping them purely to satisfy the Metric type
    // We should make this type more flexible in the future
    warningNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.warning-non-final",
        "defaultMessage": "The number of projects is nearing our recommended threshold."
    },
    exceededNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.exceeded-non-final",
        "defaultMessage": "There are some project..."
    },
    currentValueLabel: {
        "id": "admin-pages-performance.common.assets.project-cleanup.current-value-label",
        "defaultMessage": "Projects in your site"
    },
    cleanupValueLabel: {
        "id": "admin-pages-performance.common.assets.project-cleanup.cleanup-value-label",
        "defaultMessage": "Recommended for cleanup"
    }
});

});


parcelRegister("fgWYz", function(module, exports) {

$parcel$export(module.exports, "getAllVisibleMetrics", () => $2cc6642f29a0adee$export$e6140fda06493d18);
$parcel$export(module.exports, "getMetric", () => $2cc6642f29a0adee$export$ed0dc1178a679c67);
$parcel$export(module.exports, "getAllVisibleMetricKeys", () => $2cc6642f29a0adee$export$1f2abf3e170d35d2);
$parcel$export(module.exports, "assertNever", () => $2cc6642f29a0adee$export$cbadc5a7223772a8);
$parcel$export(module.exports, "TooltipMap", () => $2cc6642f29a0adee$export$9bd9f2d76c500145);

var $4R6GH = parcelRequire("4R6GH");

var $a4FfD = parcelRequire("a4FfD");

var $8MHQY = parcelRequire("8MHQY");

var $cOrKR = parcelRequire("cOrKR");

var $lzUDm = parcelRequire("lzUDm");

var $3AEMX = parcelRequire("3AEMX");

var $gtb9f = parcelRequire("gtb9f");
class $2cc6642f29a0adee$export$9419457073a1750 {
    constructor(metrics){
        this.metrics = metrics;
    }
    getMetric(key) {
        return this.metrics.find((m)=>m.key === key);
    }
    getAllVisibleMetrics() {
        return this.metrics.filter((metric)=>metric.visible && $2cc6642f29a0adee$var$mitigationEnabled(metric.key));
    }
    getAllVisibleMetricsKeys() {
        return $2cc6642f29a0adee$export$e6140fda06493d18().map((m)=>m.key);
    }
}
/**
 * Metric registry singleton. We should not be creating another registry.
 */ const $2cc6642f29a0adee$var$REGISTRY = new $2cc6642f29a0adee$export$9419457073a1750((0, $gtb9f.METRICS));
const $2cc6642f29a0adee$export$ed0dc1178a679c67 = $2cc6642f29a0adee$var$REGISTRY.getMetric.bind($2cc6642f29a0adee$var$REGISTRY);
const $2cc6642f29a0adee$export$e6140fda06493d18 = $2cc6642f29a0adee$var$REGISTRY.getAllVisibleMetrics.bind($2cc6642f29a0adee$var$REGISTRY);
const $2cc6642f29a0adee$export$1f2abf3e170d35d2 = $2cc6642f29a0adee$var$REGISTRY.getAllVisibleMetricsKeys.bind($2cc6642f29a0adee$var$REGISTRY);
const $2cc6642f29a0adee$var$mitigationEnabled = (metricKey)=>{
    switch(metricKey){
        case 0, $lzUDm.PROJECT_CLEANUP_KEY:
            return (0, $4R6GH.fg)('site-optimizer-project-cleanup');
        case 0, $3AEMX.PROJECT_ROLE_ACTOR_KEY:
        case 0, $8MHQY.CUSTOM_FIELDS_KEY:
        case 0, $cOrKR.ISSUE_KEY:
            return true;
        default:
            return false;
    }
};
const $2cc6642f29a0adee$export$cbadc5a7223772a8 = (_, message)=>{
    throw new Error(message);
};
const $2cc6642f29a0adee$export$9bd9f2d76c500145 = {
    [(0, $8MHQY.CUSTOM_FIELDS_KEY)]: (0, $a4FfD.CustomFieldsTooltip)
};

});
parcelRegister("a4FfD", function(module, exports) {

$parcel$export(module.exports, "CustomFieldsTooltip", () => $dcdb15fd0fe38e4b$export$9a2f1f96cf156e26);

var $l5IZ6 = parcelRequire("l5IZ6");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $3JT92 = parcelRequire("3JT92");

var $MHKc7 = parcelRequire("MHKc7");

var $3bDjY = parcelRequire("3bDjY");
var $btzsC = parcelRequire("btzsC");

var $koVbs = parcelRequire("koVbs");

var $9TSwz = parcelRequire("9TSwz");
const $dcdb15fd0fe38e4b$var$CustomTooltip = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, ...rest }, ref)=>{
    return /*#__PURE__*/ $5uXOq.createElement((0, $btzsC.default), {
        ...rest,
        ref: ref,
        className: (0, $bwpsq.default)([
            $dcdb15fd0fe38e4b$var$styles.tooltipStyles
        ])
    }, children);
});
const $dcdb15fd0fe38e4b$export$9a2f1f96cf156e26 = ({ children: children, dataRef: dataRef, metricState: metricState })=>{
    const { resourceUsageMetricV2: metricUsageData } = (0, $8Uumt.useFragment)((0, $l5IZ6.default), dataRef);
    if (metricUsageData === null || metricUsageData === undefined) return null;
    const customFieldsCount = {
        globalScopedCustomFieldsCount: metricUsageData.globalScopedCustomFieldsCount,
        projectScopedCustomFieldsCount: metricUsageData.projectScopedCustomFieldsCount
    };
    const customFieldsCountLabels = {
        globalScopedCustomFieldsCountLabel: (0, $9TSwz.default).globalScopedCustomFieldsCountLabel,
        projectScopedCustomFieldsCountLabel: (0, $9TSwz.default).projectScopedCustomFieldsCountLabel,
        globalScopedCustomFieldsCountAriaLabel: (0, $9TSwz.default).globalScopedCustomFieldsCountAriaLabel,
        projectScopedCustomFieldsCountArialLabel: (0, $9TSwz.default).projectScopedCustomFieldsCountAriaLabel
    };
    return /*#__PURE__*/ $5uXOq.createElement((0, $3bDjY.default), {
        content: /*#__PURE__*/ $5uXOq.createElement($dcdb15fd0fe38e4b$var$CustomFieldsTooltipContent, {
            customFieldsCount: customFieldsCount,
            customFieldsCountLabels: customFieldsCountLabels,
            metricState: metricState
        }),
        component: $dcdb15fd0fe38e4b$var$CustomTooltip
    }, children);
};
const $dcdb15fd0fe38e4b$var$CustomFieldsTooltipContent = ({ customFieldsCount: customFieldsCount, customFieldsCountLabels: customFieldsCountLabels, metricState: metricState })=>{
    const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, $koVbs.default)();
    const { globalScopedCustomFieldsCount: globalScopedCustomFieldsCount, projectScopedCustomFieldsCount: projectScopedCustomFieldsCount } = customFieldsCount;
    const { globalScopedCustomFieldsCountLabel: globalScopedCustomFieldsCountLabel, projectScopedCustomFieldsCountLabel: projectScopedCustomFieldsCountLabel, globalScopedCustomFieldsCountAriaLabel: globalScopedCustomFieldsCountAriaLabel, projectScopedCustomFieldsCountArialLabel: projectScopedCustomFieldsCountArialLabel } = customFieldsCountLabels;
    return /*#__PURE__*/ $5uXOq.createElement((0, $MHKc7.default), {
        xcss: $dcdb15fd0fe38e4b$var$styles.numbersContainer
    }, globalScopedCustomFieldsCount != null && globalScopedCustomFieldsCountLabel && /*#__PURE__*/ $5uXOq.createElement((0, $MHKc7.default), {
        xcss: $dcdb15fd0fe38e4b$var$styles.numberContainer,
        tabIndex: 0,
        "aria-label": globalScopedCustomFieldsCountAriaLabel ? formatMessage(globalScopedCustomFieldsCountAriaLabel, {
            number: formatNumber(globalScopedCustomFieldsCount)
        }) : undefined
    }, /*#__PURE__*/ $5uXOq.createElement((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)(metricState === 'none' && $dcdb15fd0fe38e4b$var$styles.successNumber, metricState === 'warning' && $dcdb15fd0fe38e4b$var$styles.warningNumber, metricState === 'exceeded' && $dcdb15fd0fe38e4b$var$styles.errorNumber, $dcdb15fd0fe38e4b$var$styles.fontWeightStyles),
        "aria-describedby": "global-scoped-custom-fields-count-desc"
    }, formatNumber(globalScopedCustomFieldsCount)), /*#__PURE__*/ $5uXOq.createElement((0, $MHKc7.default), {
        xcss: $dcdb15fd0fe38e4b$var$styles.textContainer
    }, /*#__PURE__*/ $5uXOq.createElement("small", {
        id: "global-scoped-custom-fields-count-desc"
    }, formatMessage(globalScopedCustomFieldsCountLabel)))), projectScopedCustomFieldsCount != null && projectScopedCustomFieldsCountLabel && /*#__PURE__*/ $5uXOq.createElement((0, $MHKc7.default), {
        xcss: $dcdb15fd0fe38e4b$var$styles.numberContainer,
        tabIndex: 0,
        "aria-label": projectScopedCustomFieldsCountArialLabel ? formatMessage(projectScopedCustomFieldsCountArialLabel, {
            number: formatNumber(projectScopedCustomFieldsCount)
        }) : undefined
    }, /*#__PURE__*/ $5uXOq.createElement((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)(metricState === 'none' && $dcdb15fd0fe38e4b$var$styles.successNumber, metricState === 'warning' && $dcdb15fd0fe38e4b$var$styles.warningNumber, metricState === 'exceeded' && $dcdb15fd0fe38e4b$var$styles.errorNumber, $dcdb15fd0fe38e4b$var$styles.fontWeightStyles),
        "aria-describedby": "project-scoped-custom-fields-count-desc"
    }, formatNumber(projectScopedCustomFieldsCount)), /*#__PURE__*/ $5uXOq.createElement((0, $MHKc7.default), {
        xcss: $dcdb15fd0fe38e4b$var$styles.textContainer
    }, /*#__PURE__*/ $5uXOq.createElement("small", {
        id: "project-scoped-custom-fields-count-desc"
    }, formatMessage(projectScopedCustomFieldsCountLabel)))));
};
const $dcdb15fd0fe38e4b$var$styles = {
    numbersContainer: "_1e0c1txw _y3gn1h6o _1bsb1mjv _1bah1yb4 _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o",
    numberContainer: "_16jlidpf _1o9zidpf _i0dl1wug",
    successNumber: "_11c8nf1z _syazaqb7",
    warningNumber: "_11c8nf1z _syaz1q28",
    errorNumber: "_11c8nf1z _syaz9lu1",
    fontWeightStyles: "_k48p1pd9",
    textContainer: "_p12f1lit",
    tooltipStyles: "_2rkoiti9 _bfhk1j9a _syaz15cr _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _16qszucj"
};

});
parcelRegister("l5IZ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $51f76bd051a38e39$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7720db90ecfa6c4681831e9e06d103aa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $51f76bd051a38e39$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "metricKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "tooltipEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "tooltip_adminPagesPerformance_CustomFieldsTooltip",
    "selections": [
        {
            "condition": "tooltipEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "metricKey",
                            "variableName": "metricKey"
                        }
                    ],
                    "kind": "LinkedField",
                    "name": "resourceUsageMetricV2",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "globalScopedCustomFieldsCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectScopedCustomFieldsCount"
                                }
                            ],
                            "type": "JiraCustomFieldUsageMetric"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraQuery"
};
$51f76bd051a38e39$var$node.hash = "e6113bc43303a707291b62cbe6c2b46f";
var $51f76bd051a38e39$export$2e2bcd8739ae039 = $51f76bd051a38e39$var$node;

});

parcelRegister("9TSwz", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb4cda92a9b67081$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
// The following are the description for the translators for the different text that we need translating.
// Unfortunately, this needs to copied to individual files because the i18n text extraction tool needs
// to be able to resolve variables statically. This duplication is OK.
const $eb4cda92a9b67081$var$NAME_DESC = 'Name of the site optimizer metric that will be used as the title on the page and menu item.';
const $eb4cda92a9b67081$var$DESCRIPTON_DESC = 'Description of the site optimizer metric.';
const $eb4cda92a9b67081$var$CHART_DESC = 'A tab label of Custom Field Tabs, to show custom fields chart';
const $eb4cda92a9b67081$var$REVIEW_AND_ANALYZE_DESC = 'A tab label of Custom Field Tabs, to show custom fields review and analyze';
const $eb4cda92a9b67081$var$WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
const $eb4cda92a9b67081$var$EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
const $eb4cda92a9b67081$var$RISK_DESC = 'One of the risks when this metric exceeded the threshold.';
const $eb4cda92a9b67081$var$MITIGATION_DESC = 'One of the mitigation options when this metric exceeded the threshold.';
const $eb4cda92a9b67081$var$CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
const $eb4cda92a9b67081$var$THRESHOLD_VALUE_LABEL_DESC = 'Label to be shown next to the threshold value of the metric.';
const $eb4cda92a9b67081$var$RECOMMENDATION_URL_TEXT_DESC = 'Text to be shown on the hypertext link to additional documentation.';
const $eb4cda92a9b67081$var$GRAPH_HEADER_DESC = 'Text to be shown on the header of the metric graph.';
var $eb4cda92a9b67081$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    name: {
        "id": "admin-pages-performance.common.assets.custom-fields.name",
        "defaultMessage": "Custom fields"
    },
    description: {
        "id": "admin-pages-performance.common.assets.custom-fields.description",
        "defaultMessage": "Here are the custom fields in your site, including ones we think can be removed because they\u2019re not used. Removing unused fields could improve site performance and stability."
    },
    chart: {
        "id": "admin-pages-performance.common.assets.custom-fields.chart",
        "defaultMessage": "Overview"
    },
    reviewAndAnalyze: {
        "id": "admin-pages-performance.common.assets.custom-fields.review-and-analyze",
        "defaultMessage": "Analysis"
    },
    warning: {
        "id": "admin-pages-performance.common.assets.custom-fields.warning",
        "defaultMessage": "The number of custom fields is nearing our recommended threshold."
    },
    exceeded: {
        "id": "admin-pages-performance.common.assets.custom-fields.exceeded",
        "defaultMessage": "There are more custom fields than our recommended threshold."
    },
    risk1: {
        "id": "admin-pages-performance.common.assets.custom-fields.risk-1",
        "defaultMessage": "Custom fields can make searching for issues (JQL and boards) and creating issues slow."
    },
    mitigation1: {
        "id": "admin-pages-performance.common.assets.custom-fields.mitigation-1",
        "defaultMessage": "Edit the context for the custom field to make it visible only for specific projects."
    },
    mitigation2: {
        "id": "admin-pages-performance.common.assets.custom-fields.mitigation-2",
        "defaultMessage": "Limit the number of custom fields across all projects and use the same custom field in multiple projects."
    },
    currentValueLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.current-value-label",
        "defaultMessage": "Custom fields in your site"
    },
    thresholdValueLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.threshold-value-label",
        "defaultMessage": "Recommended maximum number of custom fields"
    },
    globalScopedCustomFieldsCountLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.global-scoped-custom-fields-count-label",
        "defaultMessage": "CMP custom fields count"
    },
    projectScopedCustomFieldsCountLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.project-scoped-custom-fields-count-label",
        "defaultMessage": "TMP custom fields count"
    },
    currentValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.current-value-aria-label",
        "defaultMessage": "{number} custom fields in your site"
    },
    thresholdValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.threshold-value-aria-label",
        "defaultMessage": "{number} recommended maximum number of custom fields"
    },
    globalScopedCustomFieldsCountAriaLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.global-scoped-custom-fields-count-aria-label",
        "defaultMessage": "{number} {number, plural, one {global scoped custom field} other {global scoped custom fields}}"
    },
    projectScopedCustomFieldsCountAriaLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.project-scoped-custom-fields-count-aria-label",
        "defaultMessage": "{number} {number, plural, one {project scoped custom field} other {global scoped custom fields}}"
    },
    recommendationUrlText: {
        "id": "admin-pages-performance.common.assets.custom-fields.recommendation-url-text",
        "defaultMessage": "See how we identify these fields."
    },
    graphHeader: {
        "id": "admin-pages-performance.common.assets.custom-fields.graph-header",
        "defaultMessage": "Custom fields over time"
    },
    risk1IssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.custom-fields.risk-1-issue-term-refresh",
        "defaultMessage": "Custom fields can make searching (JQL and boards) and creating work items slow."
    }
});

});


parcelRegister("8MHQY", function(module, exports) {

$parcel$export(module.exports, "CUSTOM_FIELDS_KEY", () => $1dd393ebccb36050$export$d214286a7039b004);
$parcel$export(module.exports, "CUSTOM_FIELDS", () => $1dd393ebccb36050$export$459112111ad5b136);

var $9TSwz = parcelRequire("9TSwz");
const $1dd393ebccb36050$export$d214286a7039b004 = 'customField';
const $1dd393ebccb36050$export$459112111ad5b136 = {
    key: $1dd393ebccb36050$export$d214286a7039b004,
    visible: true,
    name: (0, $9TSwz.default).name,
    description: (0, $9TSwz.default).description,
    tabLabels: [
        (0, $9TSwz.default).chart,
        (0, $9TSwz.default).reviewAndAnalyze
    ],
    warningMessage: (0, $9TSwz.default).warning,
    exceededMessage: (0, $9TSwz.default).exceeded,
    risks: [
        (0, $9TSwz.default).risk1
    ],
    mitigations: [],
    currentValueLabel: (0, $9TSwz.default).currentValueLabel,
    currentValueAriaLabel: (0, $9TSwz.default).currentValueAriaLabel,
    thresholdValueLabel: (0, $9TSwz.default).thresholdValueLabel,
    thresholdValueAriaLabel: (0, $9TSwz.default).thresholdValueAriaLabel,
    recommendationUrl: 'https://support.atlassian.com/jira-cloud-administration/docs/optimize-your-custom-fields/',
    recommendationUrlText: (0, $9TSwz.default).recommendationUrlText,
    graphHeader: (0, $9TSwz.default).graphHeader,
    showTooltip: true
};

});

parcelRegister("cOrKR", function(module, exports) {

$parcel$export(module.exports, "ISSUE_KEY", () => $a0748d951ae09b9b$export$5daa28d10e23592);
$parcel$export(module.exports, "ISSUE", () => $a0748d951ae09b9b$export$76a449e52fa0e1e8);

var $jWT6h = parcelRequire("jWT6h");
const $a0748d951ae09b9b$export$5daa28d10e23592 = 'issue';
const $a0748d951ae09b9b$export$76a449e52fa0e1e8 = {
    key: $a0748d951ae09b9b$export$5daa28d10e23592,
    visible: true,
    name: (0, $jWT6h.default).name,
    description: (0, $jWT6h.default).description,
    tabLabels: [
        (0, $jWT6h.default).reviewAndAnalyze,
        (0, $jWT6h.default).activityLog
    ],
    warningMessage: (0, $jWT6h.default).warning,
    exceededMessage: (0, $jWT6h.default).exceeded,
    risks: [
        (0, $jWT6h.default).risk1
    ],
    mitigations: [
        (0, $jWT6h.default).mitigation1,
        (0, $jWT6h.default).mitigation2,
        (0, $jWT6h.default).mitigation3
    ],
    currentValueLabel: (0, $jWT6h.default).currentValueLabel,
    currentValueAriaLabel: (0, $jWT6h.default).currentValueAriaLabel,
    thresholdValueLabel: (0, $jWT6h.default).thresholdValueLabel,
    thresholdValueAriaLabel: (0, $jWT6h.default).thresholdValueAriaLabel,
    graphHeader: (0, $jWT6h.default).graphHeader
};

});
parcelRegister("jWT6h", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5991724b8695ea5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
// The following are the description for the translators for the different text that we need translating.
// Unfortunately, this needs to copied to individual files because the i18n text extraction tool needs
// to be able to resolve variables statically. This duplication is OK.
const $a5991724b8695ea5$var$NAME_DESC = 'Name of the site optimizer metric that will be used as the title on the page and menu item.';
const $a5991724b8695ea5$var$DESCRIPTON_DESC = 'Description of the site optimizer metric.';
const $a5991724b8695ea5$var$CHART_DESC = 'A tab label of Issue Tabs, to show Issue chart';
const $a5991724b8695ea5$var$REVIEW_AND_ANALYZE_DESC = 'A tab label of Issue Tabs, to show issue review and analyze';
const $a5991724b8695ea5$var$WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
const $a5991724b8695ea5$var$EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
const $a5991724b8695ea5$var$RISK_DESC = 'One of the risks when this metric exceeded the threshold.';
const $a5991724b8695ea5$var$MITIGATION_DESC = 'One of the mitigation options when this metric exceeded the threshold.';
const $a5991724b8695ea5$var$CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
const $a5991724b8695ea5$var$THRESHOLD_VALUE_LABEL_DESC = 'Label to be shown next to the threshold value of the metric.';
const $a5991724b8695ea5$var$ACTIVITY_LOG_DESC = 'A tab label of Activity Log Tabs, to show Issue Archival past operations';
const $a5991724b8695ea5$var$GRAPH_HEADER_DESC = 'Text to be shown on the header of the metric graph.';
var $a5991724b8695ea5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    name: {
        "id": "admin-pages-performance.common.assets.issue.name",
        "defaultMessage": "Issues"
    },
    description: {
        "id": "admin-pages-performance.common.assets.issue.description",
        "defaultMessage": "Here\u2019s a quick snapshot of the total number of issues in your site, including some that we think can be archived. Archiving unused issues can improve performance and stability of your site."
    },
    chart: {
        "id": "admin-pages-performance.common.assets.issue.chart",
        "defaultMessage": "Overview"
    },
    reviewAndAnalyze: {
        "id": "admin-pages-performance.common.assets.issue.review-and-analyze",
        "defaultMessage": "Analysis"
    },
    activityLog: {
        "id": "admin-pages-performance.common.assets.issue.activity-log",
        "defaultMessage": "Activity log"
    },
    warning: {
        "id": "admin-pages-performance.common.assets.issue.warning",
        "defaultMessage": "The number of issues in the system is nearing our recommended threshold."
    },
    exceeded: {
        "id": "admin-pages-performance.common.assets.issue.exceeded",
        "defaultMessage": "There are more issues in the system than our recommended threshold."
    },
    risk1: {
        "id": "admin-pages-performance.common.assets.issue.risk-1",
        "defaultMessage": "If you have too many issues you may find searches, automations, and workflow rules are slower than usual."
    },
    mitigation1: {
        "id": "admin-pages-performance.common.assets.issue.mitigation-1",
        "defaultMessage": "Delete any projects that are no longer required."
    },
    mitigation2: {
        "id": "admin-pages-performance.common.assets.issue.mitigation-2",
        "defaultMessage": "Disable Jira integrations that create issues you don't need."
    },
    mitigation3: {
        "id": "admin-pages-performance.common.assets.issue.mitigation-3",
        "defaultMessage": "Delete old issues that are no longer required. Use a JQL query to find issues older than a year (\u201Ccreated < -365d order by created DESC\u201C)."
    },
    currentValueLabel: {
        "id": "admin-pages-performance.common.assets.issue.current-value-label",
        "defaultMessage": "Total current issues in your site"
    },
    thresholdValueLabel: {
        "id": "admin-pages-performance.common.assets.issue.threshold-value-label",
        "defaultMessage": "Recommended maximum number of issues"
    },
    currentValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.issue.current-value-aria-label",
        "defaultMessage": "{number} total current issues in your site"
    },
    thresholdValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.issue.threshold-value-aria-label",
        "defaultMessage": "{number} recommended maximum number of issues"
    },
    graphHeader: {
        "id": "admin-pages-performance.common.assets.issue.graph-header",
        "defaultMessage": "Issues over time"
    },
    nameIssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.issue.name-issue-term-refresh",
        "defaultMessage": "Work items"
    },
    warningIssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.issue.warning-issue-term-refresh",
        "defaultMessage": "The number of work items in the system is nearing our recommended threshold."
    },
    exceededIssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.issue.exceeded-issue-term-refresh",
        "defaultMessage": "There are more work items in the system than our recommended threshold."
    },
    risk1IssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.issue.risk-1-issue-term-refresh",
        "defaultMessage": "If you have too many work items you may find searches, automations, and workflow rules are slower than usual."
    },
    mitigation2IssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.issue.mitigation-2-issue-term-refresh",
        "defaultMessage": "Disable Jira integrations that create work items you don't need"
    },
    mitigation3IssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.issue.mitigation-3-issue-term-refresh",
        "defaultMessage": "Delete old work items that are no longer required. Use a JQL query to find work items older than a year (\u201Ccreated < -365d order by created DESC\u201C)."
    },
    currentValueLabelIssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.issue.current-value-label-issue-term-refresh",
        "defaultMessage": "Total current work items in your site"
    },
    thresholdValueLabelIssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.issue.threshold-value-label-issue-term-refresh",
        "defaultMessage": "Recommended maximum number of work items"
    },
    currentValueAriaLabelIssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.issue.current-value-aria-label-issue-term-refresh",
        "defaultMessage": "{number} total current work items in your site"
    },
    thresholdValueAriaLabelIssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.issue.threshold-value-aria-label-issue-term-refresh",
        "defaultMessage": "{number} recommended maximum number of work items"
    },
    graphHeaderIssueTermRefresh: {
        "id": "admin-pages-performance.common.assets.issue.graph-header-issue-term-refresh",
        "defaultMessage": "Work items over time"
    }
});

});


parcelRegister("3AEMX", function(module, exports) {

$parcel$export(module.exports, "PROJECT_ROLE_ACTOR_KEY", () => $c7627c0e6530f4b1$export$a570ca3f6cc5e280);
$parcel$export(module.exports, "PROJECT_ROLE_ACTOR", () => $c7627c0e6530f4b1$export$fc3d2ee6c3fb3908);

var $j0D55 = parcelRequire("j0D55");
const $c7627c0e6530f4b1$export$a570ca3f6cc5e280 = 'projectroleactor';
const $c7627c0e6530f4b1$export$fc3d2ee6c3fb3908 = {
    key: $c7627c0e6530f4b1$export$a570ca3f6cc5e280,
    visible: true,
    name: (0, $j0D55.default).name,
    description: (0, $j0D55.default).description,
    tabLabels: [
        (0, $j0D55.default).analysis,
        (0, $j0D55.default).activityLog
    ],
    warningMessage: (0, $j0D55.default).warning,
    exceededMessage: (0, $j0D55.default).exceeded,
    risks: [
        (0, $j0D55.default).risk1
    ],
    mitigations: [
        (0, $j0D55.default).mitigation1,
        (0, $j0D55.default).mitigation2,
        (0, $j0D55.default).mitigation3
    ],
    currentValueLabel: (0, $j0D55.default).currentValueLabel,
    currentValueAriaLabel: (0, $j0D55.default).currentValueAriaLabel,
    thresholdValueLabel: (0, $j0D55.default).thresholdValueLabel,
    thresholdValueAriaLabel: (0, $j0D55.default).thresholdValueAriaLabel,
    recommendationUrl: 'https://support.atlassian.com/jira-cloud-administration/docs/optimize-your-number-of-project-role-memberships/',
    recommendationUrlText: (0, $j0D55.default).recommendationUrlText,
    graphHeader: (0, $j0D55.default).graphHeader
};

});
parcelRegister("j0D55", function(module, exports) {

$parcel$export(module.exports, "default", () => $6549fa32a8352dcb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
// The following are the description for the translators for the different text that we need translating.
// Unfortunately, this needs to copied to individual files because the i18n text extraction tool needs
// to be able to resolve variables statically.
const $6549fa32a8352dcb$var$NAME_DESC = 'Name of the site optimizer metric that will be used as the title on the page and menu item.';
const $6549fa32a8352dcb$var$DESCRIPTON_DESC = 'Description of the site optimizer metric.';
const $6549fa32a8352dcb$var$WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
const $6549fa32a8352dcb$var$EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
const $6549fa32a8352dcb$var$RISK_DESC = 'One of the risks when this metric exceeded the threshold.';
const $6549fa32a8352dcb$var$MITIGATION_DESC = 'One of the mitigation options when this metric exceeded the threshold.';
const $6549fa32a8352dcb$var$CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
const $6549fa32a8352dcb$var$THRESHOLD_VALUE_LABEL_DESC = 'Label to be shown next to the threshold value of the metric.';
const $6549fa32a8352dcb$var$RECOMMENDATION_URL_TEXT_DESC = 'Text to be shown on the hypertext link to additional documentation.';
const $6549fa32a8352dcb$var$GRAPH_HEADER_DESC = 'Text to be shown on the header of the metric graph.';
var $6549fa32a8352dcb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    name: {
        "id": "admin-pages-performance.common.assets.project-role-actor.name",
        "defaultMessage": "Project role permissions"
    },
    description: {
        "id": "admin-pages-performance.common.assets.project-role-actor.description",
        "defaultMessage": "Here's a quick snapshot of the total number of project role permissions across your site."
    },
    analysis: {
        "id": "admin-pages-performance.common.assets.project-role-actor.analysis",
        "defaultMessage": "Analysis"
    },
    activityLog: {
        "id": "admin-pages-performance.common.assets.project-role-actor.activity-log",
        "defaultMessage": "Activity log"
    },
    warning: {
        "id": "admin-pages-performance.common.assets.project-role-actor.warning",
        "defaultMessage": "Your number of project role memberships is nearing the recommended threshold."
    },
    exceeded: {
        "id": "admin-pages-performance.common.assets.project-role-actor.exceeded",
        "defaultMessage": "Your number of project role memberships is over the recommended threshold."
    },
    risk1: {
        "id": "admin-pages-performance.common.assets.project-role-actor.risk-1",
        "defaultMessage": "When the number of project role memberships (users or groups) increases, viewing, searching, and creating issues becomes slower."
    },
    mitigation1: {
        "id": "admin-pages-performance.common.assets.project-role-actor.mitigation-1",
        "defaultMessage": "Remove users who no longer need access to your site rather than only suspending them. Suspending users removes their permission but not their project role membership."
    },
    mitigation2: {
        "id": "admin-pages-performance.common.assets.project-role-actor.mitigation-2",
        "defaultMessage": "Give memberships to groups of users instead of individual users. Granting membership to a group of 50 users count as 1 membership whereas granting memberships to 50 single users counts as 50 memberships."
    },
    mitigation3: {
        "id": "admin-pages-performance.common.assets.project-role-actor.mitigation-3",
        "defaultMessage": "Use the default project role members in your permission scheme."
    },
    currentValueLabel: {
        "id": "admin-pages-performance.common.assets.project-role-actor.current-value-label",
        "defaultMessage": "Current project role permissions in your site"
    },
    thresholdValueLabel: {
        "id": "admin-pages-performance.common.assets.project-role-actor.threshold-value-label",
        "defaultMessage": "Recommended maximum number of permissions"
    },
    currentValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.project-role-actor.current-value-aria-label",
        "defaultMessage": "{number} current project role permissions in your site"
    },
    thresholdValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.project-role-actor.threshold-value-aria-label",
        "defaultMessage": "{number} recommended maximum number of permissions"
    },
    recommendationUrlText: {
        "id": "admin-pages-performance.common.assets.project-role-actor.recommendation-url-text",
        "defaultMessage": "Learn more about optimizing your project role memberships."
    },
    graphHeader: {
        "id": "admin-pages-performance.common.assets.project-role-actor.graph-header",
        "defaultMessage": "Project role permissions over time"
    }
});

});


parcelRegister("gtb9f", function(module, exports) {

$parcel$export(module.exports, "METRICS", () => $713364f722667f6e$export$3f0e99ae6e0ec541);
$parcel$export(module.exports, "RUN_ANALYSIS", () => $713364f722667f6e$export$769b1a9477352cf9);
$parcel$export(module.exports, "DELETE_RECOMMENDATIONS", () => $713364f722667f6e$export$e7e31b14c32e055a);
$parcel$export(module.exports, "DELETE_RECOMMENDATIONS_DROPDOWN", () => $713364f722667f6e$export$d96fe00ff2b38bae);
$parcel$export(module.exports, "DELETE_RECOMMENDATIONS_CONFIRM", () => $713364f722667f6e$export$3d4bb5f187c6844e);
$parcel$export(module.exports, "DELETE_RECOMMENDATIONS_CANCEL", () => $713364f722667f6e$export$5c1079e323f5d5bd);
$parcel$export(module.exports, "TAB_CLICKED", () => $713364f722667f6e$export$d358fc12daa9f606);
$parcel$export(module.exports, "RECOMMENDATIONS_LOADED", () => $713364f722667f6e$export$60cc0c61c99a5b81);
$parcel$export(module.exports, "METRIC_CARD_CLICKED", () => $713364f722667f6e$export$71794f4d197278dc);
$parcel$export(module.exports, "PROJECT_ROLE_ACTOR_FILTER_BY_PROJECT", () => $713364f722667f6e$export$9e34afbf86922b4a);
$parcel$export(module.exports, "projectRoleActorAttributes", () => $713364f722667f6e$export$d6761557c91eea50);
$parcel$export(module.exports, "ARCHIVE_ISSUES_CONFIRM", () => $713364f722667f6e$export$4e4b9391f7936ba2);
$parcel$export(module.exports, "RESTORE_ARCHIVE_ISSUES", () => $713364f722667f6e$export$70525d18051240f4);
$parcel$export(module.exports, "RESTORE_ARCHIVE_ISSUES_CANCEL", () => $713364f722667f6e$export$4951e0e034b50b9c);
$parcel$export(module.exports, "RESTORE_ARCHIVE_ISSUES_TRY_AGAIN", () => $713364f722667f6e$export$108288df7758f60c);
$parcel$export(module.exports, "VIEW_ISSUES", () => $713364f722667f6e$export$972d5a8da0d9f4c3);
$parcel$export(module.exports, "STOP_ISSUE_ARCHIVAL", () => $713364f722667f6e$export$b920363d50bcf753);
$parcel$export(module.exports, "ISSUE_UNARCHIVAL_COMPLETED", () => $713364f722667f6e$export$a84a5210fbad774);
$parcel$export(module.exports, "JQL_SEARCH", () => $713364f722667f6e$export$5c2df36fdd8476f7);
$parcel$export(module.exports, "DEFAULT_QUERY_SELECTED", () => $713364f722667f6e$export$77f23f1b921d5321);
$parcel$export(module.exports, "issueAnalyticsAttributes", () => $713364f722667f6e$export$c62a52f3f7d80ec3);
$parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_TRASH", () => $713364f722667f6e$export$8daffc99348bf555);
$parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_TRASH_CONFIRM", () => $713364f722667f6e$export$20f13a04bc3e5d74);
$parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_TRASH_CANCEL", () => $713364f722667f6e$export$ed285e0e924b673c);
$parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_SUCCEEDED", () => $713364f722667f6e$export$26f5d7eae10db511);
$parcel$export(module.exports, "customFieldAttributes", () => $713364f722667f6e$export$33989f74b6ba0674);
$parcel$export(module.exports, "METRICS_SPOTLIGHT_STARTED", () => $713364f722667f6e$export$d39b24a650c6c79d);
$parcel$export(module.exports, "METRICS_SPOTLIGHT_DISMISSED", () => $713364f722667f6e$export$eca4028936acf763);
$parcel$export(module.exports, "METRICS_SPOTLIGHT_COMPLETED", () => $713364f722667f6e$export$9ba0a5caedb0ff37);
$parcel$export(module.exports, "RESTORE_ACTIVITY_LOG", () => $713364f722667f6e$export$7b6bf63452d40db8);
$parcel$export(module.exports, "DOWNLOAD_CSV", () => $713364f722667f6e$export$efdb93c7210090d1);
$parcel$export(module.exports, "PROJECT_CLEANUP_FILTERS_CLEARED", () => $713364f722667f6e$export$6c650be5c2b4774f);
$parcel$export(module.exports, "PROJECT_CLEANUP_FILTER_BY_PROJECT", () => $713364f722667f6e$export$6493dd0e190d3f58);
$parcel$export(module.exports, "PROJECT_CLEANUP_FILTER_BY_STALE", () => $713364f722667f6e$export$422673ba1cec4aed);
$parcel$export(module.exports, "PROJECT_CLEAN_UP", () => $713364f722667f6e$export$3a7186fc63c9e188);
$parcel$export(module.exports, "PROJECT_CLEANUP_COMPLETED", () => $713364f722667f6e$export$8e0b8859a3cbd9e6);
$parcel$export(module.exports, "ACTION_TRASH", () => $713364f722667f6e$export$342d8b9804e407c7);
$parcel$export(module.exports, "ACTION_ARCHIVE", () => $713364f722667f6e$export$b685f2109baf2b4f);
$parcel$export(module.exports, "ACTION_UNARCHIVE", () => $713364f722667f6e$export$3ac60b381ed426ca);

var $8MHQY = parcelRequire("8MHQY");

var $cOrKR = parcelRequire("cOrKR");

var $lzUDm = parcelRequire("lzUDm");

var $3AEMX = parcelRequire("3AEMX");
const $713364f722667f6e$export$3f0e99ae6e0ec541 = [
    // Inclusion of issues in metrics is dependent on improving mitigation strategies for issues.
    // Inclusion of issue links in metrics is dependent on improving mitigation strategies for issue links.
    // ISSUE_LINKS,
    // CUSTOM_FIELD_OPTIONS,
    (0, $8MHQY.CUSTOM_FIELDS),
    (0, $cOrKR.ISSUE),
    (0, $3AEMX.PROJECT_ROLE_ACTOR),
    // Inclusion of file attachments in metrics is dependent on improving mitigation strategies for file attachments.
    // FILE_ATTACHMENTS,
    (0, $lzUDm.PROJECT_CLEANUP)
];
const $713364f722667f6e$export$769b1a9477352cf9 = 'runAnalysis';
const $713364f722667f6e$export$e7e31b14c32e055a = 'deleteRecommendations';
const $713364f722667f6e$export$d96fe00ff2b38bae = 'deleteRecommendationsDropdown';
const $713364f722667f6e$export$3d4bb5f187c6844e = 'deleteRecommendationsConfirm';
const $713364f722667f6e$export$5c1079e323f5d5bd = 'deleteRecommendationsCancel';
const $713364f722667f6e$export$d358fc12daa9f606 = 'psiTab';
const $713364f722667f6e$export$60cc0c61c99a5b81 = 'recommendations loaded';
const $713364f722667f6e$export$71794f4d197278dc = 'mitigationMetricCard';
const $713364f722667f6e$export$9e34afbf86922b4a = 'projectRoleActorFilterByProject';
const $713364f722667f6e$export$d6761557c91eea50 = {
    metric: (0, $3AEMX.PROJECT_ROLE_ACTOR_KEY)
};
const $713364f722667f6e$export$4e4b9391f7936ba2 = 'archiveIssuesConfirm';
const $713364f722667f6e$export$70525d18051240f4 = 'restoreIssueArchival';
const $713364f722667f6e$export$4951e0e034b50b9c = 'restoreIssueCancel';
const $713364f722667f6e$export$108288df7758f60c = 'restoreIssueTryAgain';
const $713364f722667f6e$export$972d5a8da0d9f4c3 = 'viewIssues';
const $713364f722667f6e$export$b920363d50bcf753 = 'stopIssueArchival';
const $713364f722667f6e$export$a84a5210fbad774 = 'restoreIssueArchival completed';
const $713364f722667f6e$export$5c2df36fdd8476f7 = 'jqlSearch';
const $713364f722667f6e$export$77f23f1b921d5321 = 'defaultQuerySelected';
const $713364f722667f6e$export$c62a52f3f7d80ec3 = {
    metric: (0, $cOrKR.ISSUE_KEY)
};
const $713364f722667f6e$export$8daffc99348bf555 = 'customFieldMoveToTrash';
const $713364f722667f6e$export$20f13a04bc3e5d74 = 'customFieldMoveToTrashConfirm';
const $713364f722667f6e$export$ed285e0e924b673c = 'customFieldMoveToTrashCancel';
const $713364f722667f6e$export$26f5d7eae10db511 = 'customFieldMoveToTrash succeeded';
const $713364f722667f6e$export$33989f74b6ba0674 = {
    metric: (0, $8MHQY.CUSTOM_FIELDS).key
};
const $713364f722667f6e$export$d39b24a650c6c79d = 'metricPerformanceSpotlight started';
const $713364f722667f6e$export$eca4028936acf763 = 'metricPerformanceSpotlightDismissed';
const $713364f722667f6e$export$9ba0a5caedb0ff37 = 'metricPerformanceSpotlight completed';
const $713364f722667f6e$export$7b6bf63452d40db8 = 'restoreActivityLog';
const $713364f722667f6e$export$efdb93c7210090d1 = 'downloadActivityLogCsv';
const $713364f722667f6e$export$6c650be5c2b4774f = 'projectCleanupFiltersCleared';
const $713364f722667f6e$export$6493dd0e190d3f58 = 'projectCleanupFilterByProjectState';
const $713364f722667f6e$export$422673ba1cec4aed = 'projectCleanupFilterByStale';
const $713364f722667f6e$export$3a7186fc63c9e188 = 'projectCleanUp';
const $713364f722667f6e$export$8e0b8859a3cbd9e6 = 'projectCleanup completed';
const $713364f722667f6e$export$342d8b9804e407c7 = 'TRASH';
const $713364f722667f6e$export$b685f2109baf2b4f = 'ARCHIVE';
const $713364f722667f6e$export$3ac60b381ed426ca = 'UNARCHIVE';

});


parcelRegister("etuUp", function(module, exports) {

$parcel$export(module.exports, "default", () => $df7d950b94f108ee$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $df7d950b94f108ee$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.title",
        "defaultMessage": "Site optimizer"
    },
    overview: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.overview",
        "defaultMessage": "Overview"
    },
    allReports: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.all-reports",
        "defaultMessage": "All reports"
    }
});

});

parcelRegister("jWIOc", function(module, exports) {

$parcel$export(module.exports, "PROJECT_CLEANUP_SPOTLIGHT_NAME", () => $fa0cf627da3f1f38$export$4150c6a7c9be0102);
$parcel$export(module.exports, "ProjectCleanupSpotlight", () => $fa0cf627da3f1f38$export$6dc8afd0c00f9525);

var $5uXOq = parcelRequire("5uXOq");

var $1QiBP = parcelRequire("1QiBP");

var $koVbs = parcelRequire("koVbs");

var $ehdJY = parcelRequire("ehdJY");

var $k43Y2 = parcelRequire("k43Y2");

var $8881D = parcelRequire("8881D");
const $fa0cf627da3f1f38$export$4150c6a7c9be0102 = 'site-optimiser-project-cleanup-spotlight-nav';
const $fa0cf627da3f1f38$export$6dc8afd0c00f9525 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isProjectCleanupSpotlightActive, setIsProjectCleanupSpotlightActive] = (0, $k43Y2.useProjectCleanupSpotlight)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, isProjectCleanupSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        actions: [
            {
                onClick: ()=>setIsProjectCleanupSpotlightActive(false),
                text: formatMessage((0, $8881D.default).spotlightAction)
            }
        ],
        heading: formatMessage((0, $8881D.default).spotlightHeading),
        target: $fa0cf627da3f1f38$export$4150c6a7c9be0102,
        key: $fa0cf627da3f1f38$export$4150c6a7c9be0102,
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        dialogPlacement: "right top",
        messageId: "navigation-apps-sidebar-global-settings-system.ui.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.jira-spotlight",
        messageType: "engagement"
    }, formatMessage((0, $8881D.default).spotlightDescription)));
});

});
parcelRegister("k43Y2", function(module, exports) {

$parcel$export(module.exports, "useProjectCleanupSpotlight", () => $249ebdaf0c0fc22c$export$780bcf6e3ebf2d12);

var $5uXOq = parcelRequire("5uXOq");

var $iyJxC = parcelRequire("iyJxC");

var $90yGq = parcelRequire("90yGq");
// Ensure this key matches the key in the old nav in navigation-apps/sidebar package
const $249ebdaf0c0fc22c$var$PROPERTY_KEY = 'jira.user.settings.system.project-cleanup-onboarding-spotlight';
const $249ebdaf0c0fc22c$export$780bcf6e3ebf2d12 = ()=>{
    const accountId = (0, $90yGq.useAccountId)();
    const [isProjectCleanupSpotlightActive, setIsProjectCleanupSpotlightActive] = (0, $5uXOq.useState)(false);
    const getHasSeenProjectCleanupSpotlight = async (id)=>{
        const response = await (0, $iyJxC.getUserProperty)({
            accountId: id,
            propertyKey: $249ebdaf0c0fc22c$var$PROPERTY_KEY,
            defaultValue: false
        });
        // If they have not seen the spotlight, return true and mark as shown
        if (!response.value) {
            await (0, $iyJxC.setUserProperty)({
                accountId: id,
                propertyKey: $249ebdaf0c0fc22c$var$PROPERTY_KEY,
                propertyValue: true
            });
            return false;
        }
        return true;
    };
    const fetchSpotlightState = (0, $5uXOq.useCallback)(async ()=>{
        if (accountId !== null) {
            const response = await getHasSeenProjectCleanupSpotlight(accountId);
            setIsProjectCleanupSpotlightActive(!response);
        }
    }, [
        accountId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        fetchSpotlightState();
    }, [
        fetchSpotlightState
    ]);
    return [
        isProjectCleanupSpotlightActive,
        setIsProjectCleanupSpotlightActive
    ];
};

});
parcelRegister("iyJxC", function(module, exports) {

$parcel$export(module.exports, "getUserProperty", () => $5455121d227e33bb$export$b3126db2ef6e34ed);
$parcel$export(module.exports, "setUserProperty", () => $5455121d227e33bb$export$ba821ce5e177c7ef);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $5455121d227e33bb$var$getUserUrl = (accountId, propertyKey)=>`/rest/api/3/user/properties/${propertyKey}?accountId=${accountId}`;
const $5455121d227e33bb$export$b3126db2ef6e34ed = async ({ accountId: accountId, propertyKey: propertyKey, defaultValue: defaultValue })=>{
    const url = $5455121d227e33bb$var$getUserUrl(accountId, propertyKey);
    try {
        const response = await fetch(url, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        // The API deliberately returns 404 if user property is not found - we will return default value
        if (response.status === 404) return {
            key: propertyKey,
            value: defaultValue
        };
        if (response.ok) return await response.json();
        throw new Error(`Fetching ${propertyKey} user property failed.`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'getUserProperty',
                packageName: 'jiraAdminPagesPerformance',
                teamName: 'cherenkov'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            key: propertyKey,
            value: defaultValue
        };
    }
};
const $5455121d227e33bb$export$ba821ce5e177c7ef = async ({ accountId: accountId, propertyKey: propertyKey, propertyValue: propertyValue })=>{
    const url = $5455121d227e33bb$var$getUserUrl(accountId, propertyKey);
    try {
        await (0, $eusud.performPutRequest)(url, {
            body: JSON.stringify(propertyValue)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'setUserProperty',
                packageName: 'jiraAdminPagesPerformance',
                teamName: 'cherenkov'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});


parcelRegister("8881D", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d0877c08ff02be$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $86d0877c08ff02be$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    spotlightHeading: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.spotlight-heading",
        "defaultMessage": "Clean out unused projects"
    },
    spotlightDescription: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.spotlight-description",
        "defaultMessage": "Quickly remove inactive or empty projects to improve your site\u2019s performance. "
    },
    spotlightAction: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.spotlight-action",
        "defaultMessage": "Ok"
    }
});

});



parcelRegister("fM231", function(module, exports) {

$parcel$export(module.exports, "hasSeenSiteOptimiserSpotlight", () => $879944d685aae4de$export$3ed4e8541d8ba40);

var $iyJxC = parcelRequire("iyJxC");
const $879944d685aae4de$var$PROPERTY_KEY = 'jira.user.settings.system.site-optimizer-spotlight';
const $879944d685aae4de$export$3ed4e8541d8ba40 = async (accountId)=>{
    const response = await (0, $iyJxC.getUserProperty)({
        accountId: accountId,
        propertyKey: $879944d685aae4de$var$PROPERTY_KEY,
        defaultValue: false
    });
    // If they have not seen the spotlight, return true and mark as shown
    if (!response.value) {
        await (0, $iyJxC.setUserProperty)({
            accountId: accountId,
            propertyKey: $879944d685aae4de$var$PROPERTY_KEY,
            propertyValue: true
        });
        return false;
    }
    return true;
};

});


parcelRegister("ie4oV", function(module, exports) {

$parcel$export(module.exports, "isViewAuditingSelected", () => $84aa4044b145a05a$export$6da8ca04904513f9);

var $4OCke = parcelRequire("4OCke");
const $84aa4044b145a05a$var$VIEW_AUDITING_PATH_REGEXP = /\/auditing\/(\w+)/i;
const $84aa4044b145a05a$export$6da8ca04904513f9 = (currentLocation, itemLocation)=>(0, $4OCke.matchUrlExact)()(currentLocation, itemLocation) || $84aa4044b145a05a$var$VIEW_AUDITING_PATH_REGEXP.test(currentLocation.pathname);

});


parcelRegister("71ORT", function(module, exports) {

$parcel$export(module.exports, "UserInterfaceSection", () => $4dae17d9419cb38f$export$c4128359313d3f58);

var $5uXOq = parcelRequire("5uXOq");

var $gjTBi = parcelRequire("gjTBi");
var $bWqXX = parcelRequire("bWqXX");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $17bH5 = parcelRequire("17bH5");

var $4OCke = parcelRequire("4OCke");

var $itmJb = parcelRequire("itmJb");

var $jMBA3 = parcelRequire("jMBA3");

var $jDUf4 = parcelRequire("jDUf4");
const $4dae17d9419cb38f$export$c4128359313d3f58 = ()=>{
    const isJiraAdmin = (0, $itmJb.useIsAdmin)();
    const { data: features } = (0, $jMBA3.useFeatures)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const navigationPath = (0, $5uXOq.useMemo)(()=>(0, $17bH5.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWqXX.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        title: formatMessage((0, $jDUf4.default).userInterface)
    }, features.hasUserDefaults && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'user-defaults'
        },
        href: navigationPath.userInterfacesUserDefaults,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $jDUf4.default).userDefaults)), features.hasEditDefaultDashboard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'edit-default-dashboard'
        },
        href: navigationPath.userInterfacesEditDefaultDashboard,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $jDUf4.default).systemDashboard)), features.hasLookAndFeel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'look-and-feel'
        },
        href: navigationPath.userInterfacesLookAndFeel,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $jDUf4.default).lookAndFeel)), features.hasPasAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'pas-admin-link-jira'
        },
        href: navigationPath.userInterfacesPasAdmin,
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $jDUf4.default).pasAdmin)), isJiraAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'announcement-banner'
        },
        href: navigationPath.userInterfacesSiteAdmin,
        selectedOn: [
            'global-settings-system-ui-announcement-banner'
        ]
    }, formatMessage((0, $jDUf4.default).announcementBanner)));
};

});
parcelRegister("jDUf4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f12d9a643fcf4ed$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6f12d9a643fcf4ed$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    userInterface: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.user-interface",
        "defaultMessage": "User Interface"
    },
    userDefaults: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.user-defaults",
        "defaultMessage": "Default user preferences"
    },
    systemDashboard: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.system-dashboard",
        "defaultMessage": "Default dashboard"
    },
    lookAndFeel: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.look-and-feel",
        "defaultMessage": "Look and feel"
    },
    pasAdmin: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.pas-admin",
        "defaultMessage": "Public Announcement Service"
    },
    announcementBanner: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.announcement-banner",
        "defaultMessage": "Announcement banner"
    }
});

});


parcelRegister("3jrxv", function(module, exports) {

$parcel$export(module.exports, "isGeneralConfigurationSelected", () => $e6139421bb00cae6$export$ba31cfa97c56eefd);

var $4OCke = parcelRequire("4OCke");
const $e6139421bb00cae6$var$APPLICATION_PROPERTIES_PATH_REGEXP = /\/admin\/(\w+)ApplicationProperties/i;
const $e6139421bb00cae6$export$ba31cfa97c56eefd = (currentLocation, itemLocation)=>(0, $4OCke.matchUrlExact)()(currentLocation, itemLocation) || $e6139421bb00cae6$var$APPLICATION_PROPERTIES_PATH_REGEXP.test(currentLocation.pathname);

});



parcelRegister("gRmqY", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemBulkMailRoute", () => $47674b1aa9d0fa81$export$2b269dcf51f5a4d3);
const $47674b1aa9d0fa81$export$2b269dcf51f5a4d3 = {
    name: 'global-settings-system-bulk-mail',
    path: '/jira/settings/system/send-email'
};

});

parcelRegister("5FGTk", function(module, exports) {

$parcel$export(module.exports, "LazyBulkEmail", () => $0240d4f2c2b35825$export$416f8039fbf50bea);
$parcel$export(module.exports, "default", () => $0240d4f2c2b35825$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $0240d4f2c2b35825$export$416f8039fbf50bea = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("iBdIG"))), {
    moduleId: "./src/packages/admin-pages/bulk-email/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0240d4f2c2b35825$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $0240d4f2c2b35825$export$416f8039fbf50bea,
        pageId: "jira-admin-pages-bulk-email",
        shouldShowSpinner: true
    });

});
parcelRegister("iBdIG", function(module, exports) {

let $d8a6532580e1bcb8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d8a6532580e1bcb8$var$load("8z6OY").then(()=>parcelRequire('8Z6uP'));

});



parcelRegister("ktEDA", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceCustomFieldRouteEntry", () => $082dced0cf5c2e43$export$8cc68908e4ed5a16);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $b51sv = parcelRequire("b51sv");

var $6kCEi = parcelRequire("6kCEi");
const $082dced0cf5c2e43$export$8cc68908e4ed5a16 = (0, $7NszV.createEntry)((0, $b51sv.globalSettingsPerformanceCustomFieldRoute), ()=>({
        group: 'global-settings',
        component: (0, $6kCEi.CustomFieldMetricDetail),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6kCEi.LazyCustomFieldDetail)
        ]
    }));

});
parcelRegister("b51sv", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceCustomFieldRoute", () => $43a348db022c66e4$export$198b0dea5bcb104d);
const $43a348db022c66e4$export$198b0dea5bcb104d = {
    name: 'global-settings-performance-custom-field',
    path: '/jira/settings/system/performance/metrics/customfield'
};

});

parcelRegister("6kCEi", function(module, exports) {

$parcel$export(module.exports, "LazyCustomFieldDetail", () => $416b07e85e5902e2$export$d323aa888b5be0c2);
$parcel$export(module.exports, "CustomFieldMetricDetail", () => $416b07e85e5902e2$export$446bf9be075b3cb);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $416b07e85e5902e2$export$d323aa888b5be0c2 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("ipUdf"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-custom-field/src/index.tsx"
});
const $416b07e85e5902e2$export$446bf9be075b3cb = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $416b07e85e5902e2$export$d323aa888b5be0c2,
        pageId: "system-performance-metric-detail-custom-field",
        shouldShowSpinner: true
    });

});
parcelRegister("ipUdf", function(module, exports) {

let $d6862a761c67ec00$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d6862a761c67ec00$var$load("ffQaD"),
    $d6862a761c67ec00$var$load("kvRbA"),
    $d6862a761c67ec00$var$load("76n7a"),
    $d6862a761c67ec00$var$load("l253H"),
    $d6862a761c67ec00$var$load("fliVL"),
    $d6862a761c67ec00$var$load("dVhXY")
]).then(()=>parcelRequire('PZuxA'));

});



parcelRegister("caoz4", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceIssueArchivalRouteEntry", () => $bf0d17e8163c3686$export$6f8a930d1f2f4103);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $46SKm = parcelRequire("46SKm");

var $2vX6Y = parcelRequire("2vX6Y");
const $bf0d17e8163c3686$export$6f8a930d1f2f4103 = (0, $7NszV.createEntry)((0, $46SKm.globalSettingsPerformanceIssueArchivalRoute), ()=>({
        group: 'global-settings',
        component: (0, $2vX6Y.IssueMetricDetail),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $2vX6Y.LazyIssueDetail)
        ]
    }));

});
parcelRegister("46SKm", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceIssueArchivalRoute", () => $cad08cbdd7ac177a$export$a615b79ae9fb06e5);
const $cad08cbdd7ac177a$export$a615b79ae9fb06e5 = {
    name: 'global-settings-performance-issue',
    path: '/jira/settings/system/performance/metrics/issue'
};

});

parcelRegister("2vX6Y", function(module, exports) {

$parcel$export(module.exports, "LazyIssueDetail", () => $cc878f5a65037830$export$e44cbefb7c57e031);
$parcel$export(module.exports, "IssueMetricDetail", () => $cc878f5a65037830$export$30b22d5292fcd86f);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $cc878f5a65037830$export$e44cbefb7c57e031 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("9iDKV"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-issue/src/index.tsx"
});
const $cc878f5a65037830$export$30b22d5292fcd86f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cc878f5a65037830$export$e44cbefb7c57e031,
        pageId: "system-performance-metric-detail-issue",
        shouldShowSpinner: true
    });

});
parcelRegister("9iDKV", function(module, exports) {

let $6c54a232408bd9ca$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6c54a232408bd9ca$var$load("ffQaD"),
    $6c54a232408bd9ca$var$load("kvRbA"),
    $6c54a232408bd9ca$var$load("76n7a"),
    $6c54a232408bd9ca$var$load("l253H"),
    $6c54a232408bd9ca$var$load("fliVL"),
    $6c54a232408bd9ca$var$load("gMbKk")
]).then(()=>parcelRequire('9HctW'));

});



parcelRegister("5BlCA", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceMetricDetailRouteEntry", () => $233fa7d3de1e95a8$export$4b547a5bd165bd83);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $vq7VV = parcelRequire("vq7VV");

var $gq1Xn = parcelRequire("gq1Xn");
const $233fa7d3de1e95a8$export$4b547a5bd165bd83 = (0, $7NszV.createEntry)((0, $vq7VV.globalSettingsPerformanceMetricDetailRoute), ()=>({
        group: 'global-settings',
        component: (0, $gq1Xn.RedirectToExactMetricRoutes),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("vq7VV", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceMetricDetailRoute", () => $cd34eae2613f8100$export$d4f7a24791f8b506);
const $cd34eae2613f8100$export$d4f7a24791f8b506 = {
    name: 'global-settings-performance-metric-detail',
    path: '/jira/settings/system/performance/metric/:metricKey'
};

});

parcelRegister("gq1Xn", function(module, exports) {

$parcel$export(module.exports, "RedirectToExactMetricRoutes", () => $a9257ec476fbe8e1$export$dda90f06f8afe9ec);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $8zOmE = parcelRequire("8zOmE");

var $ds5qV = parcelRequire("ds5qV");

var $doZTA = parcelRequire("doZTA");
const $a9257ec476fbe8e1$export$dda90f06f8afe9ec = ()=>{
    const [{ match: match }] = (0, $doZTA.useRouter)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        // If we have a metric key in the URL, we know the user has accessed the old route
        // and we should fire an operational analytics event.
        // Once the frequency of this event is 0, we can consider removing the redirect.
        if (match?.params?.metricKey) (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'old-metric-detail-route visited', {
            metricKey: match.params.metricKey
        });
    }, [
        match?.params?.metricKey,
        createAnalyticsEvent
    ]);
    if (match == null || match.params == null || match.params.metricKey == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: "/jira/settings/system/performance/overview"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: `/jira/settings/system/performance/metrics/${match.params.metricKey}`
    });
};

});


parcelRegister("3Hflx", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceOverviewRouteEntry", () => $13d7b69aa99de9b5$export$6f957aade53e2c17);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $clE6J = parcelRequire("clE6J");

var $btX5r = parcelRequire("btX5r");

var $408O8 = parcelRequire("408O8");
const $13d7b69aa99de9b5$export$6f957aade53e2c17 = (0, $7NszV.createEntry)((0, $btX5r.globalSettingsPerformanceOverviewRoute), ()=>({
        group: 'global-settings',
        component: (0, $408O8.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $clE6J.metricsOverviewPageResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $408O8.LazyOverview)
        ]
    }));

});
parcelRegister("clE6J", function(module, exports) {

$parcel$export(module.exports, "metricsOverviewPageResource", () => $624fad9c7a7951b4$export$ac0b4ef4ec4987ae);

var $4R6GH = parcelRequire("4R6GH");

var $ao2h1 = parcelRequire("ao2h1");

var $hOOQr = parcelRequire("hOOQr");
const $624fad9c7a7951b4$export$ac0b4ef4ec4987ae = (0, $ao2h1.createRelayResource)({
    type: 'ADMIN_PAGES_PERFORMANCE_OVERVIEW',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $hOOQr.default),
            variables: {
                cloudId: tenantContext.cloudId,
                schemaMigrationEnabled: (0, $4R6GH.fg)('site_optimiser_schema_migration')
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("hOOQr", function(module, exports) {

$parcel$export(module.exports, "default", () => $69a9f121a9ac63a8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<669304670c931d09af8646f09ee71460>>
 * @relayHash 3b0412c013eb910bffa938b54599e765
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 589c5cc207a17b7fcd72acde1a46f074a3ac0a2e82da10793f61efb4fb0a786e
const $69a9f121a9ac63a8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "schemaMigrationEnabled"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "key"
    }, v3 = {
        "kind": "ScalarField",
        "name": "currentValue"
    }, v4 = {
        "kind": "ScalarField",
        "name": "warningValue"
    }, v5 = {
        "kind": "ScalarField",
        "name": "thresholdValue"
    }, v6 = {
        "kind": "ScalarField",
        "name": "cleanupValue"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "main_adminPagesPerformance_Overview_Query",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "condition": "schemaMigrationEnabled",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v1 /*: any*/ ,
                                            "concreteType": "JiraResourceUsageMetricConnection",
                                            "kind": "LinkedField",
                                            "name": "resourceUsageMetrics",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "main_adminPagesPerformance_OverviewPage"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.resourceUsageMetrics"
                                    }
                                ]
                            },
                            {
                                "condition": "schemaMigrationEnabled",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v1 /*: any*/ ,
                                            "concreteType": "JiraResourceUsageMetricConnectionV2",
                                            "kind": "LinkedField",
                                            "name": "resourceUsageMetricsV2",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "main_adminPagesPerformance_OverviewPageV2"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.resourceUsageMetricsV2"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "main_adminPagesPerformance_Overview_Query",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "schemaMigrationEnabled",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraResourceUsageMetricConnection",
                                    "kind": "LinkedField",
                                    "name": "resourceUsageMetrics",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraResourceUsageMetric",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "schemaMigrationEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraResourceUsageMetricConnectionV2",
                                    "kind": "LinkedField",
                                    "name": "resourceUsageMetricsV2",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "589c5cc207a17b7fcd72acde1a46f074a3ac0a2e82da10793f61efb4fb0a786e",
            "metadata": {},
            "name": "main_adminPagesPerformance_Overview_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$69a9f121a9ac63a8$var$node.hash = "f41d000bf8612aeb0ad7a3bfa4b9b2cb";
var $69a9f121a9ac63a8$export$2e2bcd8739ae039 = $69a9f121a9ac63a8$var$node;

});


parcelRegister("btX5r", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceOverviewRoute", () => $895fc96119706708$export$677fc3a2086479d2);
const $895fc96119706708$export$677fc3a2086479d2 = {
    name: 'global-settings-performance-overview',
    path: '/jira/settings/system/performance/overview'
};

});

parcelRegister("408O8", function(module, exports) {

$parcel$export(module.exports, "LazyOverview", () => $53afac4f83d10b4d$export$17b4d4eaede5f445);
$parcel$export(module.exports, "default", () => $53afac4f83d10b4d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $53afac4f83d10b4d$export$17b4d4eaede5f445 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("8uOVv"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/overview/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$53afac4f83d10b4d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $53afac4f83d10b4d$export$17b4d4eaede5f445,
        pageId: "system-performance-overview",
        shouldShowSpinner: true
    });

});
parcelRegister("8uOVv", function(module, exports) {

let $62f8a10319be2fb2$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $62f8a10319be2fb2$var$load("ffQaD"),
    $62f8a10319be2fb2$var$load("kvRbA"),
    $62f8a10319be2fb2$var$load("9Xdwe")
]).then(()=>parcelRequire('aJlr3'));

});



parcelRegister("bUOZo", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceProjectCleanupRouteEntry", () => $5db1194ddce6c383$export$7048705fd224d040);

var $ffza4 = parcelRequire("ffza4");

var $cSD7y = parcelRequire("cSD7y");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $66tAT = parcelRequire("66tAT");

var $5lsNZ = parcelRequire("5lsNZ");

var $kxXsG = parcelRequire("kxXsG");
const $5db1194ddce6c383$export$7048705fd224d040 = (0, $7NszV.createEntry)((0, $66tAT.globalSettingsPerformanceProjectCleanupRoute), ()=>({
        group: 'global-settings',
        // On FF cleanup of site-optimizer-project-cleanup replace with ProjectCleanupMetricDetail
        component: (0, $cSD7y.componentWithFG)('site-optimizer-project-cleanup', (0, $kxXsG.ProjectCleanupMetricDetail), (0, $5lsNZ.default)),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kxXsG.LazyProjectCleanupDetail)
        ]
    }));

});
parcelRegister("66tAT", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceProjectCleanupRoute", () => $2cfd8d591a3d3df9$export$c0d3487a9dc79ff3);
const $2cfd8d591a3d3df9$export$c0d3487a9dc79ff3 = {
    name: 'global-settings-performance-project-cleanup',
    path: '/jira/settings/system/performance/metrics/projectCleanup'
};

});

parcelRegister("kxXsG", function(module, exports) {

$parcel$export(module.exports, "LazyProjectCleanupDetail", () => $a4333be24d8fdde0$export$a02cb3bfa11d0dc0);
$parcel$export(module.exports, "ProjectCleanupMetricDetail", () => $a4333be24d8fdde0$export$2adb5abd6651c182);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $a4333be24d8fdde0$export$a02cb3bfa11d0dc0 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("iWx5k"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-project-cleanup/src/index.tsx"
});
const $a4333be24d8fdde0$export$2adb5abd6651c182 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $a4333be24d8fdde0$export$a02cb3bfa11d0dc0,
        pageId: "system-performance-metric-detail-project-cleanup",
        shouldShowSpinner: true
    });

});
parcelRegister("iWx5k", function(module, exports) {

let $dca74ebb7f99dc18$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $dca74ebb7f99dc18$var$load("ffQaD"),
    $dca74ebb7f99dc18$var$load("kvRbA"),
    $dca74ebb7f99dc18$var$load("76n7a"),
    $dca74ebb7f99dc18$var$load("l253H"),
    $dca74ebb7f99dc18$var$load("fliVL"),
    $dca74ebb7f99dc18$var$load("eBa2B")
]).then(()=>parcelRequire('fJoHG'));

});



parcelRegister("bC98V", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceProjectRoleActorRouteEntry", () => $b0ecc0767e5528eb$export$a37cab737d8b474a);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $lG365 = parcelRequire("lG365");

var $7BrHr = parcelRequire("7BrHr");
const $b0ecc0767e5528eb$export$a37cab737d8b474a = (0, $7NszV.createEntry)((0, $lG365.globalSettingsPerformanceProjectRoleActorRoute), ()=>({
        group: 'global-settings',
        component: (0, $7BrHr.ProjectRoleActorMetricDetail),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7BrHr.LazyProjectRoleActorDetail)
        ]
    }));

});
parcelRegister("lG365", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPerformanceProjectRoleActorRoute", () => $a0135d88210046c6$export$c81695f590e65a42);
const $a0135d88210046c6$export$c81695f590e65a42 = {
    name: 'global-settings-performance-project-role-actor',
    path: '/jira/settings/system/performance/metrics/projectroleactor'
};

});

parcelRegister("7BrHr", function(module, exports) {

$parcel$export(module.exports, "LazyProjectRoleActorDetail", () => $e00517ee35b4ce44$export$41ecfa31d3d81e1c);
$parcel$export(module.exports, "ProjectRoleActorMetricDetail", () => $e00517ee35b4ce44$export$3c58376b89706313);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $e00517ee35b4ce44$export$41ecfa31d3d81e1c = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("90DZG"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-project-role-actor/src/index.tsx"
});
const $e00517ee35b4ce44$export$3c58376b89706313 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e00517ee35b4ce44$export$41ecfa31d3d81e1c,
        pageId: "system-performance-metric-detail-project-role-actor",
        shouldShowSpinner: true
    });

});
parcelRegister("90DZG", function(module, exports) {

let $01b157469d23daa3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $01b157469d23daa3$var$load("ffQaD"),
    $01b157469d23daa3$var$load("kvRbA"),
    $01b157469d23daa3$var$load("76n7a"),
    $01b157469d23daa3$var$load("l253H"),
    $01b157469d23daa3$var$load("fliVL"),
    $01b157469d23daa3$var$load("6B7Dl")
]).then(()=>parcelRequire('eQgAh'));

});



parcelRegister("1mByb", function(module, exports) {

$parcel$export(module.exports, "globalSettingsEditPermissionSchemesRouteEntry", () => $28d525b59d36751f$export$25dca167915e813c);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $1Sn7L = parcelRequire("1Sn7L");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $j15ln = parcelRequire("j15ln");

var $aVbhY = parcelRequire("aVbhY");
const $28d525b59d36751f$export$25dca167915e813c = (0, $7NszV.createEntry)((0, $j15ln.globalSettingsEditPermissionSchemesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.configure-permission-scheme',
        component: (0, $aVbhY.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $1Sn7L.editPermissionSchemePageResource)
        ],
        canTransitionIn: ()=>true,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aVbhY.LazyEditPermissionSchemePage)
        ],
        meta: {
            reporting: {
                id: 'EditPermissionScheme',
                packageName: 'jiraAdminPagesEditPermissionScheme',
                teamName: 'gordian'
            }
        }
    }));

});
parcelRegister("1Sn7L", function(module, exports) {

$parcel$export(module.exports, "editPermissionSchemePageResource", () => $c133ac01577799ff$export$2b6bb2f543863b53);

var $ao2h1 = parcelRequire("ao2h1");

var $eZzoq = parcelRequire("eZzoq");
const $c133ac01577799ff$var$RESOURCE_TYPE_EDIT_PERMISSION_SCHEME_PAGE = 'EDIT_PERMISSION_SCHEME_PAGE';
const $c133ac01577799ff$export$2b6bb2f543863b53 = (0, $ao2h1.createRelayResource)({
    type: $c133ac01577799ff$var$RESOURCE_TYPE_EDIT_PERMISSION_SCHEME_PAGE,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $eZzoq.default),
            variables: {
                // To Do: use ari-typescript library once it is approved
                // https://hello.atlassian.net/wiki/spaces/TGR/pages/1374189554/Dependency+review+atlassian+ari
                schemeId: `ari:cloud:jira:${tenantContext.cloudId}:permission-scheme/activation/${tenantContext.activationId}/${String(match.params.schemeId)}`,
                first: 50
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("eZzoq", function(module, exports) {

$parcel$export(module.exports, "default", () => $95d709337e778f61$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3e6d2609b22da674852d0d8a556caee0>>
 * @relayHash a8302edc7839549073bdffce737596f9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8c97cc5e281ea579c44e87ac7f80e5f399b27b3ac304b7267d4210b282a7a4b1
const $95d709337e778f61$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "schemeId"
    }, v2 = {
        "kind": "Variable",
        "name": "schemeId",
        "variableName": "schemeId"
    }, v3 = [
        v2 /*: any*/ 
    ], v4 = {
        "kind": "ScalarField",
        "name": "isEditable"
    }, v5 = {
        "concreteType": "JiraPermissionSchemeConfiguration",
        "kind": "LinkedField",
        "name": "configuration",
        "plural": false,
        "selections": [
            v4 /*: any*/ 
        ]
    }, v6 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v2 /*: any*/ 
    ], v7 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "key"
    }, v11 = {
        "kind": "ScalarField",
        "name": "description"
    }, v12 = {
        "kind": "ScalarField",
        "name": "text"
    }, v13 = {
        "kind": "ScalarField",
        "name": "id"
    }, v14 = [
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        v13 /*: any*/ 
    ], v15 = [
        v9 /*: any*/ ,
        v13 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v3 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "viewPermissionScheme",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "PermissionCategories"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "header_editPermissionScheme"
                                            },
                                            v5 /*: any*/ 
                                        ],
                                        "type": "JiraPermissionSchemeView"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.viewPermissionScheme"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v6 /*: any*/ ,
                                "concreteType": "JiraProjectConnection",
                                "kind": "LinkedField",
                                "name": "getProjectsByPermissionScheme",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JiraProject",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v7 /*: any*/ ,
                                                                "action": "LOG",
                                                                "path": "jira.getProjectsByPermissionScheme.edges.node.projectId"
                                                            }
                                                        ]
                                                    },
                                                    "action": "LOG",
                                                    "path": "jira.getProjectsByPermissionScheme.edges.node"
                                                }
                                            ]
                                        },
                                        "action": "LOG",
                                        "path": "jira.getProjectsByPermissionScheme.edges"
                                    }
                                ]
                            },
                            "action": "LOG",
                            "path": "jira.getProjectsByPermissionScheme"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "viewPermissionScheme",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraPermissionSchemeGrantGroup",
                                            "kind": "LinkedField",
                                            "name": "grantGroups",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProjectPermissionCategory",
                                                    "kind": "LinkedField",
                                                    "name": "category",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraPermissionGrantHolder",
                                                    "kind": "LinkedField",
                                                    "name": "grantHolders",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraProjectPermission",
                                                            "kind": "LinkedField",
                                                            "name": "permission",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                v11 /*: any*/ ,
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraPermissionConfiguration",
                                                            "kind": "LinkedField",
                                                            "name": "configuration",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "tag"
                                                                },
                                                                {
                                                                    "concreteType": "JiraPermissionMessageExtension",
                                                                    "kind": "LinkedField",
                                                                    "name": "message",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "type"
                                                                        },
                                                                        v12 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraPermissionDocumentationExtension",
                                                                    "kind": "LinkedField",
                                                                    "name": "documentation",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v12 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ]
                                                                },
                                                                v4 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraPermissionGrants",
                                                            "kind": "LinkedField",
                                                            "name": "grants",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraGrantTypeKey",
                                                                    "kind": "LinkedField",
                                                                    "name": "grantType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        v9 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraPermissionGrantValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "grantValues",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "value",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v9 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraDefaultGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": v14 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraUserGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraGroup",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "group",
                                                                                            "plural": false,
                                                                                            "selections": v15 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraGroupGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraRole",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "role",
                                                                                            "plural": false,
                                                                                            "selections": v15 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraProjectRoleGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "field",
                                                                                            "plural": false,
                                                                                            "selections": v14 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueFieldGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v13 /*: any*/ 
                                                                                    ],
                                                                                    "type": "Node",
                                                                                    "abstractKey": "__isNode"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v13 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "totalCount"
                                                                },
                                                                v8 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__id"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraPermissionScheme",
                                            "kind": "LinkedField",
                                            "name": "scheme",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v13 /*: any*/ 
                                            ]
                                        },
                                        v5 /*: any*/ 
                                    ],
                                    "type": "JiraPermissionSchemeView"
                                }
                            ]
                        },
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "getProjectsByPermissionScheme",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v13 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8c97cc5e281ea579c44e87ac7f80e5f399b27b3ac304b7267d4210b282a7a4b1",
            "metadata": {},
            "name": "mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$95d709337e778f61$var$node.hash = "9e1e7326d79aae057f4943753d3cd309";
var $95d709337e778f61$export$2e2bcd8739ae039 = $95d709337e778f61$var$node;

});


parcelRegister("j15ln", function(module, exports) {

$parcel$export(module.exports, "globalSettingsEditPermissionSchemesRoute", () => $b0eb7fc8ea8a5934$export$d57f448badd0561f);
const $b0eb7fc8ea8a5934$export$d57f448badd0561f = {
    name: 'global-settings-issues-edit-permissions-schemes',
    path: '/jira/settings/issues/permission-schemes/:schemeId'
};

});

parcelRegister("aVbhY", function(module, exports) {

$parcel$export(module.exports, "LazyEditPermissionSchemePage", () => $9fc866887d4bbe6b$export$4549705b02900c32);
$parcel$export(module.exports, "default", () => $9fc866887d4bbe6b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $9fc866887d4bbe6b$export$4549705b02900c32 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("lIELi"))), {
    moduleId: "./src/packages/permissions-administration/pages/edit-permission-scheme/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9fc866887d4bbe6b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9fc866887d4bbe6b$export$4549705b02900c32,
        pageId: "jira-edit-permission-scheme",
        shouldShowSpinner: true
    });

});
parcelRegister("lIELi", function(module, exports) {

let $fcfd537bad6c9550$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fcfd537bad6c9550$var$load("68z6o").then(()=>parcelRequire('hZT3b'));

});



parcelRegister("ew7DI", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPermissionSchemesRouteEntry", () => $1a723dff8ec4c1fb$export$85d07cd59d004b5b);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $bFrLw = parcelRequire("bFrLw");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $f7vTI = parcelRequire("f7vTI");

var $j8IEt = parcelRequire("j8IEt");
const $1a723dff8ec4c1fb$export$85d07cd59d004b5b = (0, $7NszV.createEntry)((0, $f7vTI.globalSettingsPermissionSchemesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.configure-permission-scheme',
        component: (0, $j8IEt.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $bFrLw.permissionSchemePageResource)
        ],
        canTransitionIn: ()=>true,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $j8IEt.LazyPermissionSchemePage)
        ],
        meta: {
            reporting: {
                id: 'PermissionScheme',
                packageName: 'jiraAdminPagesPermissionScheme',
                teamName: 'gordian'
            }
        }
    }));

});
parcelRegister("bFrLw", function(module, exports) {

$parcel$export(module.exports, "permissionSchemePageResource", () => $b39d37deff00f918$export$58d9013f694fc9d0);

var $ao2h1 = parcelRequire("ao2h1");

var $kf7Zr = parcelRequire("kf7Zr");
const $b39d37deff00f918$var$RESOURCE_TYPE_PERMISSION_SCHEME_PAGE = 'PERMISSION_SCHEME_PAGE';
const $b39d37deff00f918$export$58d9013f694fc9d0 = (0, $ao2h1.createRelayResource)({
    type: $b39d37deff00f918$var$RESOURCE_TYPE_PERMISSION_SCHEME_PAGE,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $kf7Zr.default),
            variables: {
                // To Do: use ari-typescript library once it is approved
                // https://hello.atlassian.net/wiki/spaces/TGR/pages/1374189554/Dependency+review+atlassian+ari
                schemeId: `ari:cloud:jira:${tenantContext.cloudId}:permission-scheme/activation/${tenantContext.activationId}/${String(match.params.schemeId)}`
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("kf7Zr", function(module, exports) {

$parcel$export(module.exports, "default", () => $667e2dd268ebb83a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bf59478679f84bf44b49fd41a2544ee4>>
 * @relayHash 0250f6408e8d8064d7cc97a77e2f5386
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5642572e212db64091380e916543cde0402cdfaa01db716befcdd494efd5feb
const $667e2dd268ebb83a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "schemeId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "schemeId",
            "variableName": "schemeId"
        }
    ], v2 = {
        "concreteType": "JiraPermissionSchemeConfiguration",
        "kind": "LinkedField",
        "name": "configuration",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            }
        ]
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "description"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "key"
    }, v8 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        v6 /*: any*/ 
    ], v9 = [
        v4 /*: any*/ ,
        v6 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v1 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "viewPermissionScheme",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "header_permissionScheme"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "PermissionsTable"
                                            },
                                            v2 /*: any*/ 
                                        ],
                                        "type": "JiraPermissionSchemeView"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.viewPermissionScheme"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "viewPermissionScheme",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraPermissionScheme",
                                            "kind": "LinkedField",
                                            "name": "scheme",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraPermissionSchemeGrantGroup",
                                            "kind": "LinkedField",
                                            "name": "grantGroups",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProjectPermissionCategory",
                                                    "kind": "LinkedField",
                                                    "name": "category",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraPermissionGrantHolder",
                                                    "kind": "LinkedField",
                                                    "name": "grantHolders",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraProjectPermission",
                                                            "kind": "LinkedField",
                                                            "name": "permission",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraPermissionGrants",
                                                            "kind": "LinkedField",
                                                            "name": "grants",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraGrantTypeKey",
                                                                    "kind": "LinkedField",
                                                                    "name": "grantType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        v4 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraPermissionGrantValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "grantValues",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "value",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v3 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        v4 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraDefaultGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": v8 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraUserGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraGroup",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "group",
                                                                                            "plural": false,
                                                                                            "selections": v9 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraGroupGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "field",
                                                                                            "plural": false,
                                                                                            "selections": v8 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueFieldGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraRole",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "role",
                                                                                            "plural": false,
                                                                                            "selections": v9 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraProjectRoleGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ 
                                                                                    ],
                                                                                    "type": "Node",
                                                                                    "abstractKey": "__isNode"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v6 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v2 /*: any*/ 
                                    ],
                                    "type": "JiraPermissionSchemeView"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b5642572e212db64091380e916543cde0402cdfaa01db716befcdd494efd5feb",
            "metadata": {},
            "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$667e2dd268ebb83a$var$node.hash = "41dd09a71a35c8ed416631b02fa73316";
var $667e2dd268ebb83a$export$2e2bcd8739ae039 = $667e2dd268ebb83a$var$node;

});


parcelRegister("f7vTI", function(module, exports) {

$parcel$export(module.exports, "globalSettingsPermissionSchemesRoute", () => $1ed22cbad427b1e6$export$ceade8e040291782);
const $1ed22cbad427b1e6$export$ceade8e040291782 = {
    name: 'global-settings-permissions-schemes',
    path: '/jira/settings/issues/permission-schemes-new/:schemeId'
};

});

parcelRegister("j8IEt", function(module, exports) {

$parcel$export(module.exports, "LazyPermissionSchemePage", () => $d6d274858940e39c$export$f7fcf8304eb17dda);
$parcel$export(module.exports, "default", () => $d6d274858940e39c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $d6d274858940e39c$export$f7fcf8304eb17dda = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("i4hbn"))), {
    moduleId: "./src/packages/permissions-administration/pages/permission-scheme/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d6d274858940e39c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d6d274858940e39c$export$f7fcf8304eb17dda,
        pageId: "jira-permission-scheme",
        shouldShowSpinner: true
    });

});
parcelRegister("i4hbn", function(module, exports) {

let $0364ffb4daeaad28$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0364ffb4daeaad28$var$load("gqVlZ").then(()=>parcelRequire('cHxvv'));

});



parcelRegister("gCfQs", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesRouteEntry", () => $90f1ccdb6a2bda75$export$63a56a096ab0d260);

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $72PKZ = parcelRequire("72PKZ");

var $5pSYQ = parcelRequire("5pSYQ");

var $jE90b = parcelRequire("jE90b");
const $90f1ccdb6a2bda75$export$63a56a096ab0d260 = (0, $7NszV.createEntry)((0, $72PKZ.globalSettingsIssuesPrioritiesRoute), ()=>({
        group: 'global-settings',
        component: (0, $jE90b.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $jE90b.LazyPrioritiesPage)
        ]
    }));

});
parcelRegister("72PKZ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesRoute", () => $20f25386b191950e$export$518516cdf6b7cd83);
const $20f25386b191950e$export$518516cdf6b7cd83 = {
    name: 'global-settings-issues-priorities',
    path: '/jira/settings/issues/priorities'
};

});

parcelRegister("jE90b", function(module, exports) {

$parcel$export(module.exports, "LazyPrioritiesPage", () => $bf15af7ed924092e$export$2b5843205130631c);
$parcel$export(module.exports, "default", () => $bf15af7ed924092e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $bf15af7ed924092e$export$2b5843205130631c = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("eBYAB"))), {
    moduleId: "./src/packages/admin-pages/priorities/src/index.tsx"
});
const $bf15af7ed924092e$var$PrioritiesPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $bf15af7ed924092e$export$2b5843205130631c,
        pageId: "jira-admin-pages-priorities",
        shouldShowSpinner: true
    });
var $bf15af7ed924092e$export$2e2bcd8739ae039 = $bf15af7ed924092e$var$PrioritiesPage;

});
parcelRegister("eBYAB", function(module, exports) {

let $aa33853364f8ec32$var$load = (parcelRequire("28QjX"))(4);
module.exports = $aa33853364f8ec32$var$load("avk8f").then(()=>parcelRequire('7oC7C'));

});



parcelRegister("2UvYl", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldsManagementRouteEntry", () => $f3cfe226a311fac7$export$b0811d27c1832ea1);

var $lkFvK = parcelRequire("lkFvK");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $lKiq6 = parcelRequire("lKiq6");

var $eLOu4 = parcelRequire("eLOu4");

var $5lsNZ = parcelRequire("5lsNZ");

var $5pSYQ = parcelRequire("5pSYQ");

var $6s1PB = parcelRequire("6s1PB");
const $f3cfe226a311fac7$var$globalSettingsIssueFieldsManagementEntryPointPage = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $eLOu4.globalSettingsIssueFieldsManagementRouteEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).SETTINGS
});
const $f3cfe226a311fac7$export$b0811d27c1832ea1 = (0, $7NszV.createEntry)((0, $lKiq6.globalSettingsIssueFieldsManagementRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.fields',
        component: (0, $5lsNZ.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        canTransitionIn: ()=>(0, $6s1PB.expValEquals)('jira-admin-pages-centralised-fields-m1-experiment', 'isEnabled', true, false),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint () {
            if ((0, $6s1PB.expValEquals)('jira-admin-pages-centralised-fields-m1-experiment', 'isEnabled', true, false)) return $f3cfe226a311fac7$var$globalSettingsIssueFieldsManagementEntryPointPage;
        }
    }));

});
parcelRegister("lKiq6", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldsManagementRoute", () => $4325708462413ccd$export$6e571c84819449f5);
const $4325708462413ccd$export$6e571c84819449f5 = {
    name: 'global-settings-issues-fields-management-view',
    path: '/jira/settings/issues/fields'
};

});

parcelRegister("eLOu4", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldsManagementRouteEntryPoint", () => $8a6c936f0a349e84$export$b2a8ea978923a786);
// entrypoint.tsx

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $3EuEv = parcelRequire("3EuEv");
// Backwards compatibility with old URL params
const $8a6c936f0a349e84$var$CustomFieldStatus = {
    TRASHED: 'trashed',
    ACTIVE: 'active'
};

const $8a6c936f0a349e84$export$b2a8ea978923a786 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("7w1Wc")), {
        moduleId: "6660b54c"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId }, context: { query: query } })=>{
        const initialTab = query.customFieldStatus?.toLowerCase() === $8a6c936f0a349e84$var$CustomFieldStatus.TRASHED ? 'deleted' : 'active';
        return {
            queries: {
                globalFields: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $3EuEv.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            },
            extraProps: {
                initialTab: initialTab
            }
        };
    }
});

});
parcelRegister("3EuEv", function(module, exports) {

$parcel$export(module.exports, "default", () => $06d1a8ee4ac7e20f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2561f5a1e950a8f8003b3a0221235814>>
 * @relayHash b436b53cb8f9c7dd92de1adf248fbfbd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fa48c858d7e6d800540ea1b17fa5fc60e0a1ac832f26a5f72595c45706b09c26
const $06d1a8ee4ac7e20f$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "fa48c858d7e6d800540ea1b17fa5fc60e0a1ac832f26a5f72595c45706b09c26",
        "metadata": {},
        "name": "uiAdminPagesFieldsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $06d1a8ee4ac7e20f$export$2e2bcd8739ae039 = $06d1a8ee4ac7e20f$var$node;

});

parcelRegister("7w1Wc", function(module, exports) {

let $578d065bd28f60d8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $578d065bd28f60d8$var$load("hn8O3").then(()=>parcelRequire('1hPWF'));

});



parcelRegister("81ZCL", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritySchemesRouteEntry", () => $e7cda76e463e35e5$export$a5ac2a64ed09e754);

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $fZEim = parcelRequire("fZEim");

var $5pSYQ = parcelRequire("5pSYQ");

var $3qE1A = parcelRequire("3qE1A");
const $e7cda76e463e35e5$export$a5ac2a64ed09e754 = (0, $7NszV.createEntry)((0, $fZEim.globalSettingsIssuesPrioritySchemesRoute), ()=>({
        group: 'global-settings',
        component: (0, $3qE1A.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $3qE1A.LazyPrioritySchemes)
        ]
    }));

});
parcelRegister("fZEim", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritySchemesRoute", () => $9dde78a6f0fc7878$export$185af30f53271c10);
const $9dde78a6f0fc7878$export$185af30f53271c10 = {
    name: 'global-settings-issues-priority-schemes',
    path: '/jira/settings/issues/priority-schemes'
};

});

parcelRegister("3qE1A", function(module, exports) {

$parcel$export(module.exports, "LazyPrioritySchemes", () => $a7002d7e57e81458$export$20bb8a3b40a3add4);
$parcel$export(module.exports, "default", () => $a7002d7e57e81458$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $a7002d7e57e81458$export$20bb8a3b40a3add4 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("2TRVo"))), {
    moduleId: "./src/packages/admin-pages/priority-schemes/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a7002d7e57e81458$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $a7002d7e57e81458$export$20bb8a3b40a3add4,
        pageId: "jira-admin-pages-priority-schemes",
        shouldShowSpinner: true
    });

});
parcelRegister("2TRVo", function(module, exports) {

let $21ca8c264d79823e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $21ca8c264d79823e$var$load("l1o0A").then(()=>parcelRequire('4bg9b'));

});



parcelRegister("izUuJ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsFormDataConnectionsRouteEntry", () => $3bc9e61b7154fc39$export$d975ee3e4df0b4d2);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $cL7r8 = parcelRequire("cL7r8");

var $dwY5M = parcelRequire("dwY5M");

var $lkFvK = parcelRequire("lkFvK");

var $6MVyv = parcelRequire("6MVyv");
const $3bc9e61b7154fc39$var$jiraAdminProformaDataConnectionsPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $dwY5M.default),
    topNavigationMenuId: (0, $lmyls.MENU_ID).SETTINGS
});
const $3bc9e61b7154fc39$export$d975ee3e4df0b4d2 = (0, $7NszV.createEntry)((0, $cL7r8.globalSettingsFormDataConnectionsRoute), ()=>({
        group: 'global-settings',
        component: (0, $6MVyv.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6MVyv.LazyProformaJiraDataConnectionsPage)
        ],
        entryPoint () {
            return $3bc9e61b7154fc39$var$jiraAdminProformaDataConnectionsPageEntryPoint;
        }
    }));

});
parcelRegister("cL7r8", function(module, exports) {

$parcel$export(module.exports, "globalSettingsFormDataConnectionsRoute", () => $e95abb1b467ec66d$export$6633247975d81f28);
const $e95abb1b467ec66d$export$6633247975d81f28 = {
    name: 'global-settings-issues-form-data-connections',
    path: '/jira/settings/forms/data-connections'
};

});

parcelRegister("dwY5M", function(module, exports) {

$parcel$export(module.exports, "default", () => $86888a626e8a4290$export$2e2bcd8739ae039);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $86888a626e8a4290$var$JiraAdminProformaDataConnectionsEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("5mTGn")), {
        moduleId: "606040fa"
    }),
    getPreloadProps: ()=>({})
});
var $86888a626e8a4290$export$2e2bcd8739ae039 = $86888a626e8a4290$var$JiraAdminProformaDataConnectionsEntryPoint;

});
parcelRegister("5mTGn", function(module, exports) {

let $3e8a333750974ea5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3e8a333750974ea5$var$load("imNNE").then(()=>parcelRequire('5syWw'));

});


parcelRegister("6MVyv", function(module, exports) {

$parcel$export(module.exports, "LazyProformaJiraDataConnectionsPage", () => $013d0419ad26989f$export$a81885366284dc75);
$parcel$export(module.exports, "default", () => $013d0419ad26989f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $013d0419ad26989f$export$a81885366284dc75 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("dI2ND"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/proforma/data-connections/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$013d0419ad26989f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $013d0419ad26989f$export$a81885366284dc75,
        pageId: "jira-admin-pages-forms-data-connections",
        shouldShowSpinner: true
    });

});
parcelRegister("dI2ND", function(module, exports) {

let $9fb18e5711d55c55$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9fb18e5711d55c55$var$load("5nxrg").then(()=>parcelRequire('jSKfU'));

});



parcelRegister("ipR0U", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldSchemesRouteEntry", () => $040da6ab68bb362d$export$d76b41f577aeeba5);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $g0QAg = parcelRequire("g0QAg");

var $5pSYQ = parcelRequire("5pSYQ");

var $MjvHI = parcelRequire("MjvHI");
const $040da6ab68bb362d$export$d76b41f577aeeba5 = (0, $7NszV.createEntry)((0, $g0QAg.globalSettingsIssueFieldSchemesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.screen-schemes',
        component: (0, $MjvHI.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $MjvHI.LazyScreenSchemesPage)
        ]
    }));

});
parcelRegister("g0QAg", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldSchemesRoute", () => $f7a16e4417c90525$export$3c5a0cf6ecc1bdf1);
const $f7a16e4417c90525$export$3c5a0cf6ecc1bdf1 = {
    name: 'global-settings-issues-field-schemes-view',
    path: '/jira/settings/issues/screen-schemes'
};

});

parcelRegister("MjvHI", function(module, exports) {

$parcel$export(module.exports, "LazyScreenSchemesPage", () => $3b08a72bf07c6137$export$342ae41503f611f1);
$parcel$export(module.exports, "default", () => $3b08a72bf07c6137$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $3b08a72bf07c6137$export$342ae41503f611f1 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("fkxj7"))), {
    moduleId: "./src/packages/admin-pages/screens/screen-schemes-page/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3b08a72bf07c6137$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3b08a72bf07c6137$export$342ae41503f611f1,
        pageId: "jira-admin-pages-screen-schemes-page",
        shouldShowSpinner: true
    });

});
parcelRegister("fkxj7", function(module, exports) {

let $b2928f6be49ecd54$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $b2928f6be49ecd54$var$load("ffQaD"),
    $b2928f6be49ecd54$var$load("kvRbA"),
    $b2928f6be49ecd54$var$load("aIqr8")
]).then(()=>parcelRequire('bwE6o'));

});



parcelRegister("jovMq", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldScreensRouteEntry", () => $39823af69179fb5e$export$ea08b1064c32ddb2);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $eHWkH = parcelRequire("eHWkH");

var $5pSYQ = parcelRequire("5pSYQ");

var $P0dqS = parcelRequire("P0dqS");
const $39823af69179fb5e$export$ea08b1064c32ddb2 = (0, $7NszV.createEntry)((0, $eHWkH.globalSettingsIssueFieldScreensRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.screens',
        component: (0, $P0dqS.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $P0dqS.LazyScreensPage)
        ]
    }));

});
parcelRegister("eHWkH", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldScreensRoute", () => $d6c79c93cf657eb0$export$197fd5d0ee709ca4);
const $d6c79c93cf657eb0$export$197fd5d0ee709ca4 = {
    name: 'global-settings-issues-field-screens',
    path: '/jira/settings/issues/screens'
};

});

parcelRegister("P0dqS", function(module, exports) {

$parcel$export(module.exports, "LazyScreensPage", () => $38a54f3b8a5e1e01$export$f4e6d546d7f2894c);
$parcel$export(module.exports, "default", () => $38a54f3b8a5e1e01$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $38a54f3b8a5e1e01$export$f4e6d546d7f2894c = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("gizO6"))), {
    moduleId: "./src/packages/admin-pages/screens/screens-page/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$38a54f3b8a5e1e01$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $38a54f3b8a5e1e01$export$f4e6d546d7f2894c,
        pageId: "jira-admin-pages-screens-page",
        shouldShowSpinner: true
    });

});
parcelRegister("gizO6", function(module, exports) {

let $bdda1a5a3c7a26c2$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $bdda1a5a3c7a26c2$var$load("ffQaD"),
    $bdda1a5a3c7a26c2$var$load("kvRbA"),
    $bdda1a5a3c7a26c2$var$load("1ev3J")
]).then(()=>parcelRequire('lgmh3'));

});



parcelRegister("a4nP2", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueTypesScreenSchemesRouteEntry", () => $3911900520b0c6a8$export$e2c2c1569887e684);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $4gtHC = parcelRequire("4gtHC");

var $5pSYQ = parcelRequire("5pSYQ");

var $kMjOg = parcelRequire("kMjOg");
const $3911900520b0c6a8$export$e2c2c1569887e684 = (0, $7NszV.createEntry)((0, $4gtHC.globalSettingsIssueTypesScreenSchemesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.issue-type-screen-schemes',
        component: (0, $kMjOg.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kMjOg.LazyIssueTypeScreenSchemesPage)
        ]
    }));

});
parcelRegister("4gtHC", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueTypesScreenSchemesRoute", () => $2245c71c2bdfe600$export$df93a4addc359237);
const $2245c71c2bdfe600$export$df93a4addc359237 = {
    name: 'global-settings-issues-types-screen-schemes-view',
    path: '/jira/settings/issues/issue-type-screen-schemes'
};

});

parcelRegister("kMjOg", function(module, exports) {

$parcel$export(module.exports, "LazyIssueTypeScreenSchemesPage", () => $73b6b725092289e9$export$350edfb57b335a57);
$parcel$export(module.exports, "default", () => $73b6b725092289e9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $73b6b725092289e9$export$350edfb57b335a57 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("eLHDP"))), {
    moduleId: "./src/packages/admin-pages/screens/issue-type-screen-schemes-page/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$73b6b725092289e9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $73b6b725092289e9$export$350edfb57b335a57,
        pageId: "jira-admin-pages-issue-type-screen-schemes-page",
        shouldShowSpinner: true
    });

});
parcelRegister("eLHDP", function(module, exports) {

let $ac074ebeee0539ef$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ac074ebeee0539ef$var$load("ffQaD"),
    $ac074ebeee0539ef$var$load("kvRbA"),
    $ac074ebeee0539ef$var$load("jvJLL")
]).then(()=>parcelRequire('5K98P'));

});



parcelRegister("h0ilo", function(module, exports) {

$parcel$export(module.exports, "systemConfigurationRedirectRouteEntry", () => $8e2136bf66ce50f4$export$7c2e1ea4fc4a192f);

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $dmx0y = parcelRequire("dmx0y");

var $4TSoB = parcelRequire("4TSoB");

var $j2LKP = parcelRequire("j2LKP");
const $8e2136bf66ce50f4$export$7c2e1ea4fc4a192f = (0, $7NszV.createEntry)((0, $4TSoB.systemConfigurationRedirectRoute), ()=>({
        group: 'global-settings',
        component: (0, $j2LKP.default),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $dmx0y.systemConfigurationGeneralResource)
        ]
    }));

});
parcelRegister("4TSoB", function(module, exports) {

$parcel$export(module.exports, "systemConfigurationRedirectRoute", () => $3fbd0d392c74d663$export$fe4807c49c838619);
const $3fbd0d392c74d663$export$fe4807c49c838619 = {
    name: 'system-configuration-general-redirect',
    path: '/secure/admin/ViewApplicationProperties.jspa',
    exact: true
};

});

parcelRegister("j2LKP", function(module, exports) {

$parcel$export(module.exports, "default", () => $71a705d1d999c26b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ds5qV = parcelRequire("ds5qV");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$71a705d1d999c26b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: "/jira/settings/system/general-configuration"
    });

});


parcelRegister("k1TyW", function(module, exports) {

$parcel$export(module.exports, "systemConfigurationRouteEntry", () => $1805c641c87a2931$export$360a82088f35f2f);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $dmx0y = parcelRequire("dmx0y");

var $99CoR = parcelRequire("99CoR");

var $5pSYQ = parcelRequire("5pSYQ");

var $k7R2k = parcelRequire("k7R2k");
const $1805c641c87a2931$export$360a82088f35f2f = (0, $7NszV.createEntry)((0, $99CoR.systemConfigurationRoute), ()=>({
        group: 'global-settings',
        component: (0, $k7R2k.default),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $dmx0y.systemConfigurationGeneralResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $k7R2k.LazySystemConfigurationGeneral)
        ]
    }));

});
parcelRegister("99CoR", function(module, exports) {

$parcel$export(module.exports, "systemConfigurationRoute", () => $6c77a2c05982af00$export$6823cb5626e61bc7);
const $6c77a2c05982af00$export$6823cb5626e61bc7 = {
    name: 'system-configuration-general',
    path: '/jira/settings/system/general-configuration',
    exact: true
};

});

parcelRegister("k7R2k", function(module, exports) {

$parcel$export(module.exports, "LazySystemConfigurationGeneral", () => $ece5afb522908971$export$c452a8c622781ccd);
$parcel$export(module.exports, "default", () => $ece5afb522908971$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $ece5afb522908971$export$c452a8c622781ccd = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("8IOnj"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/system-configuration-general/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ece5afb522908971$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ece5afb522908971$export$c452a8c622781ccd,
        pageId: "system-configuration-general",
        shouldShowSpinner: false
    });

});
parcelRegister("8IOnj", function(module, exports) {

let $6599823703e8bc99$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6599823703e8bc99$var$load("9dEqa").then(()=>parcelRequire('7S4i0'));

});



parcelRegister("hH7Cb", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemUiAnnouncementBannerRouteEntry", () => $375c8c577ca5ebf6$export$416d225883781012);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $49jFu = parcelRequire("49jFu");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $5pSYQ = parcelRequire("5pSYQ");

const $375c8c577ca5ebf6$var$LazyAnnouncementBanner = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("2Na7r"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/system/ui/announcement-banner/src/index.tsx"
});
const $375c8c577ca5ebf6$var$AnnouncementBanner = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $375c8c577ca5ebf6$var$LazyAnnouncementBanner,
        pageId: "admin-pages-system-ui-announcement-banner",
        shouldShowSpinner: true
    });
const $375c8c577ca5ebf6$export$416d225883781012 = (0, $7NszV.createEntry)((0, $49jFu.globalSettingsSystemUiAnnouncementBannerRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.system.ui.announcement-banner',
        component: $375c8c577ca5ebf6$var$AnnouncementBanner,
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $375c8c577ca5ebf6$var$LazyAnnouncementBanner
        ]
    }));

});
parcelRegister("49jFu", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemUiAnnouncementBannerRoute", () => $0f7678f7ab7e2ce6$export$20631ff3b13dafc0);
const $0f7678f7ab7e2ce6$export$20631ff3b13dafc0 = {
    name: 'global-settings-system-ui-announcement-banner',
    path: '/jira/settings/system/ui/announcement-banner'
};

});

parcelRegister("2Na7r", function(module, exports) {

let $208801cd8670537d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $208801cd8670537d$var$load("ffQaD"),
    $208801cd8670537d$var$load("kvRbA"),
    $208801cd8670537d$var$load("fliVL"),
    $208801cd8670537d$var$load("gydgg")
]).then(()=>parcelRequire('e7RG2'));

});


parcelRegister("dtLGm", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueWorkflow1RouteEntry", () => $68897fd2bacb1927$export$55e4c1d21a9b75e6);

var $3aIZg = parcelRequire("3aIZg");

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $cPrje = parcelRequire("cPrje");

var $5pSYQ = parcelRequire("5pSYQ");

var $i6RvY = parcelRequire("i6RvY");
const $68897fd2bacb1927$export$55e4c1d21a9b75e6 = (0, $7NszV.createEntry)((0, $cPrje.globalSettingsIssueWorkflow1Route), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.view-workflows',
        component: (0, $i6RvY.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $3aIZg.default),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $i6RvY.LazyListWorkflows)
        ]
    }));

});
parcelRegister("3aIZg", function(module, exports) {

$parcel$export(module.exports, "default", () => $9146315a1662307e$export$2e2bcd8739ae039);

var $ebyGx = parcelRequire("ebyGx");

var $2M1hQ = parcelRequire("2M1hQ");

var $AdkCT = parcelRequire("AdkCT");

const $9146315a1662307e$var$workFlowsResource = (0, $2M1hQ.createResource)({
    type: (0, $5c95bdf76715894f$export$b11854972ecaecc7),
    getKey: ({ query: query })=>`${0, $5c95bdf76715894f$export$6602c5404301813f}-${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(query)}`,
    maxAge: 0,
    getData: async ({ query: query })=>(0, $AdkCT.getListWorkFlows)((0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(query))
});
var $9146315a1662307e$export$2e2bcd8739ae039 = $9146315a1662307e$var$workFlowsResource;

});
parcelRegister("AdkCT", function(module, exports) {

$parcel$export(module.exports, "getListWorkFlows", () => $bd8703d90d89a06c$export$952f5d693c3c0d4e);

var $ebyGx = parcelRequire("ebyGx");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $lNKJm = parcelRequire("lNKJm");

var $9KDge = parcelRequire("9KDge");
const $bd8703d90d89a06c$export$952f5d693c3c0d4e = async (qs)=>{
    const filter = (0, $9KDge.fromUrlTransformer)((0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(qs));
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify((0, $9KDge.toApiUrlTransformer)(filter));
    try {
        return await (0, $eusud.performGetRequest)(`/rest/api/3/workflow/search?${query}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'getWorkflowsSearchAPI',
                packageName: (0, $lNKJm.PACKAGE_NAME),
                teamName: 'helix'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
parcelRegister("lNKJm", function(module, exports) {

$parcel$export(module.exports, "SOURCE_NAME", () => $51adf94ab22e1863$export$a3821bc63538b210);
$parcel$export(module.exports, "WORKFLOW_NAME", () => $51adf94ab22e1863$export$a69699c3acbd94ca);
$parcel$export(module.exports, "PACKAGE_NAME", () => $51adf94ab22e1863$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "WORKFLOWS_ACTIONS", () => $51adf94ab22e1863$export$f3ab46ae5f3c01ad);
$parcel$export(module.exports, "WORKFLOWS_SCHEME", () => $51adf94ab22e1863$export$81c9aaf617cb2f01);
$parcel$export(module.exports, "SYSTEM_WORKFLOW_JIRA_NAME", () => $51adf94ab22e1863$export$615f1d8b29794ae);
$parcel$export(module.exports, "SYSTEM_WORKFLOW_BUILDS_WORKFLOWS_NAME", () => $51adf94ab22e1863$export$fccd4c1ce5f0896f);
$parcel$export(module.exports, "DEFAULT_PAGE_SIZE", () => $51adf94ab22e1863$export$5716e8bcb003888d);
$parcel$export(module.exports, "defaultListWorkFlowsFilter", () => $51adf94ab22e1863$export$dc5aae53031515c);
$parcel$export(module.exports, "ORDER", () => $51adf94ab22e1863$export$11e75bce9f7ea886);
$parcel$export(module.exports, "FILTER_CHANGE_ANALYTICS", () => $51adf94ab22e1863$export$9ac56b2484c2d4e9);
$parcel$export(module.exports, "PAGE_SIZE_CHANGE_ANALYTICS", () => $51adf94ab22e1863$export$e6613a3c77896936);
$parcel$export(module.exports, "API_PREFIX", () => $51adf94ab22e1863$export$a3f6840410eb0571);

const $51adf94ab22e1863$export$a3821bc63538b210 = 'listWorkflows';
const $51adf94ab22e1863$export$a69699c3acbd94ca = 'workflowName';
const $51adf94ab22e1863$export$b8b9d90f9e5bd72b = 'jira-admin-pages-list-workflows';
const $51adf94ab22e1863$export$f3ab46ae5f3c01ad = 'workflowsActions';
const $51adf94ab22e1863$export$81c9aaf617cb2f01 = 'workflowScheme';
const $51adf94ab22e1863$export$615f1d8b29794ae = 'jira';
const $51adf94ab22e1863$export$fccd4c1ce5f0896f = 'Builds Workflow';
const $51adf94ab22e1863$export$5716e8bcb003888d = 10;
const $51adf94ab22e1863$export$dc5aae53031515c = {
    pageNumber: 1,
    pageSize: $51adf94ab22e1863$export$5716e8bcb003888d,
    expand: [
        'default',
        'hasDraftWorkflow',
        'schemes',
        'operations',
        'projects'
    ],
    orderBy: 'name',
    sortDirection: (0, $2a9e000a443b1a95$export$1dee026a19752d6b),
    isActive: true
};
const $51adf94ab22e1863$export$11e75bce9f7ea886 = Object.freeze({
    ASC: 'asc',
    DESC: 'desc'
});
const $51adf94ab22e1863$export$9ac56b2484c2d4e9 = Object.freeze({
    ACTION: 'changed',
    ACTION_SUBJECT: 'filterSearch'
});
const $51adf94ab22e1863$export$e6613a3c77896936 = Object.freeze({
    ACTION: 'changed',
    ACTION_SUBJECT: 'pageSize'
});
const $51adf94ab22e1863$export$a3f6840410eb0571 = 'gateway/api/jira/project-configuration';

});

parcelRegister("9KDge", function(module, exports) {

$parcel$export(module.exports, "toUrlTransformer", () => $f0642d0f1e447d39$export$5b9f8ed2c34be88a);
$parcel$export(module.exports, "fromUrlTransformer", () => $f0642d0f1e447d39$export$bec67ef860c0d0e1);
$parcel$export(module.exports, "toApiUrlTransformer", () => $f0642d0f1e447d39$export$fb15afa686993f11);

var $aud83 = parcelRequire("aud83");

var $lNKJm = parcelRequire("lNKJm");

var $lgmUP = parcelRequire("lgmUP");
const $f0642d0f1e447d39$export$5b9f8ed2c34be88a = (filter)=>{
    const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy, isActive: isActive, pageSize: pageSize } = filter || {};
    return {
        pageNumber: pageNumber,
        searchFilter: searchFilter,
        orderBy: orderBy,
        isActive: isActive,
        pageSize: pageSize
    };
};
const $f0642d0f1e447d39$export$bec67ef860c0d0e1 = (params)=>{
    const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy, isActive: isActive, pageSize: pageSize } = params;
    const parsedNumber = Number.isNaN((0, $aud83.number).parse(pageNumber)) ? (0, $lNKJm.defaultListWorkFlowsFilter).pageNumber : (0, $aud83.number).parse(pageNumber);
    const parsedSize = Number.isNaN((0, $aud83.number).parse(pageSize)) ? (0, $lNKJm.defaultListWorkFlowsFilter).pageSize : (0, $aud83.number).parse(pageSize);
    const parsedOrderBy = orderBy === 'name' || orderBy === '-name' || orderBy === 'updated' || orderBy === '-updated' ? orderBy : undefined;
    const isActiveFinal = isActive != null ? isActive === 'true' : (0, $lNKJm.defaultListWorkFlowsFilter).isActive;
    return {
        ...(0, $lNKJm.defaultListWorkFlowsFilter),
        pageNumber: parsedNumber != null ? Number(parsedNumber) : undefined,
        pageSize: parsedSize != null ? Number(parsedSize) : undefined,
        searchFilter: searchFilter,
        orderBy: parsedOrderBy,
        isActive: isActiveFinal
    };
};
const $f0642d0f1e447d39$export$fb15afa686993f11 = (filter)=>{
    const fullFilter = {
        ...(0, $lNKJm.defaultListWorkFlowsFilter),
        ...filter
    };
    const { pageNumber: pageNumber = 1, pageSize: pageSize = (0, $lNKJm.DEFAULT_PAGE_SIZE) } = fullFilter;
    let requestParams = {
        maxResults: pageSize,
        startAt: (pageNumber - 1) * pageSize,
        orderBy: fullFilter.orderBy,
        queryString: (0, $lgmUP.trimSearchFilter)(fullFilter.searchFilter),
        isActive: fullFilter.isActive
    };
    if (fullFilter.expand != null) // @ts-expect-error - TS2322 - Type '{ expand: string; maxResults: number; startAt: number; orderBy: WorkflowOrderBy | undefined; queryString: string | undefined; isActive: boolean; }' is not assignable to type '{ maxResults: number; startAt: number; orderBy: WorkflowOrderBy | undefined; queryString: string | undefined; isActive: boolean; }'.
    requestParams = {
        ...requestParams,
        expand: fullFilter.expand.join(',')
    };
    return requestParams;
};

});
parcelRegister("lgmUP", function(module, exports) {

$parcel$export(module.exports, "trimSearchFilter", () => $d92ccc09aa62d68e$export$ed1722f41c23aaaf);
const $d92ccc09aa62d68e$export$7341f299e7b93e87 = (field)=>field !== undefined ? field.toLowerCase() : undefined;
const $d92ccc09aa62d68e$export$c876451e094c0060 = (map, param)=>map[param] !== undefined ? map[param] : undefined;
const $d92ccc09aa62d68e$export$ed1722f41c23aaaf = (searchFilter)=>{
    if (searchFilter === undefined) return undefined;
    return searchFilter.trim() || undefined;
};

});



const $5c95bdf76715894f$export$b11854972ecaecc7 = 'WORKFLOWS_TABLE';
const $5c95bdf76715894f$export$6602c5404301813f = 'WORKFLOWS_TABLE_KEY';


parcelRegister("cPrje", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueWorkflow1Route", () => $416b12e52ba65191$export$f8f2a617a2f4d53);
const $416b12e52ba65191$export$f8f2a617a2f4d53 = {
    name: 'global-settings-issues-workflows-pages',
    path: '/jira/settings/issues/workflows'
};

});

parcelRegister("i6RvY", function(module, exports) {

$parcel$export(module.exports, "LazyListWorkflows", () => $fe432a8ece476800$export$4c64b4f1ecf22fc8);
$parcel$export(module.exports, "default", () => $fe432a8ece476800$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $fe432a8ece476800$export$4c64b4f1ecf22fc8 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hrUJD"))), {
    moduleId: "./src/packages/admin-pages/workflows/list-workflows/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fe432a8ece476800$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $fe432a8ece476800$export$4c64b4f1ecf22fc8,
        pageId: "jira-admin-pages-list-workflows",
        shouldShowSpinner: true
    });

});
parcelRegister("hrUJD", function(module, exports) {

let $cb40f7b453330308$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cb40f7b453330308$var$load("5fPPA").then(()=>parcelRequire('b9R9h'));

});



parcelRegister("f6OBR", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueWorkflowEditRouteEntry", () => $e62e629a6fa746d6$export$d2b3121978e344e);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $3P1Nf = parcelRequire("3P1Nf");

var $5pSYQ = parcelRequire("5pSYQ");

var $c7jVr = parcelRequire("c7jVr");
const $e62e629a6fa746d6$export$d2b3121978e344e = (0, $7NszV.createEntry)((0, $3P1Nf.globalSettingsIssueWorkflowEditRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.edit-workflow',
        component: (0, $c7jVr.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $c7jVr.LazyEditWorkflow)
        ]
    }));

});
parcelRegister("3P1Nf", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueWorkflowEditRoute", () => $69ca7ef2aafafa96$export$9d533f08a4447cc);
const $69ca7ef2aafafa96$export$9d533f08a4447cc = {
    name: 'global-settings-issues-workflow-edit',
    path: '/jira/settings/issues/workflows/:workflowId'
};

});

parcelRegister("c7jVr", function(module, exports) {

$parcel$export(module.exports, "LazyEditWorkflow", () => $793ac7f9af5a2945$export$cb79ebb337a95317);
$parcel$export(module.exports, "default", () => $793ac7f9af5a2945$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $793ac7f9af5a2945$export$cb79ebb337a95317 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("20QWy"))), {
    moduleId: "./src/packages/admin-pages/workflows/edit-workflow/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$793ac7f9af5a2945$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $793ac7f9af5a2945$export$cb79ebb337a95317,
        pageId: "jira-admin-pages-edit-workflow",
        shouldShowSpinner: true
    });

});
parcelRegister("20QWy", function(module, exports) {

let $1774a656cce5346c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1774a656cce5346c$var$load("kNFvF"),
    $1774a656cce5346c$var$load("76n7a"),
    $1774a656cce5346c$var$load("l253H"),
    $1774a656cce5346c$var$load("0s8QH")
]).then(()=>parcelRequire('c8ahc'));

});



parcelRegister("5uMDF", function(module, exports) {

$parcel$export(module.exports, "productsJcsCustomerAccessRouteEntry", () => $896a9842aa03470c$export$487fd1bbb9f3684e);

var $4R6GH = parcelRequire("4R6GH");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $jGT6h = parcelRequire("jGT6h");

var $8xIbV = parcelRequire("8xIbV");

var $5lsNZ = parcelRequire("5lsNZ");

var $6IgbX = parcelRequire("6IgbX");

var $cuwqc = parcelRequire("cuwqc");
const $896a9842aa03470c$var$productsJcsCustomerAccessEntryPointPage = (0, $lkFvK.createPageEntryPoint)({
    main: $8xIbV.productsJcsCustomerAccessEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).SETTINGS
});
const $896a9842aa03470c$export$487fd1bbb9f3684e = (0, $7NszV.createEntry)((0, $jGT6h.productsJcsCustomerAccessRoute), ()=>({
        group: 'global-settings',
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('jcs_master_flag') ? $896a9842aa03470c$var$productsJcsCustomerAccessEntryPointPage : undefined;
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $cuwqc.jsmGlobalCustomerAccessSettingsResource),
            (0, $6IgbX.jsmGlobalCustomerAccessAffectedProjectsResource)
        ]
    }));

});
parcelRegister("jGT6h", function(module, exports) {

$parcel$export(module.exports, "productsJcsCustomerAccessRoute", () => $810d264c2a8581fd$export$db5278559525ffee);
const $810d264c2a8581fd$export$db5278559525ffee = {
    name: 'products-jcs-customer-access',
    path: '/jira/settings/products/customerservice/customer-access',
    exact: true
};

});

parcelRegister("8xIbV", function(module, exports) {

$parcel$export(module.exports, "productsJcsCustomerAccessEntryPoint", () => $2f553626bc230951$export$a10305920ea7bd7);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $2f553626bc230951$export$a10305920ea7bd7 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("6nuR6")), {
        moduleId: "d1f6773e"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("6nuR6", function(module, exports) {

let $4a4cd34ff38c3020$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4a4cd34ff38c3020$var$load("462n9").then(()=>parcelRequire('8f4JT'));

});



parcelRegister("3RvJ0", function(module, exports) {

$parcel$export(module.exports, "productsJcsFormFieldsRouteEntry", () => $5e479a4488e4cc4e$export$ce43ae01ccf4d9b6);

var $4R6GH = parcelRequire("4R6GH");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $3niDA = parcelRequire("3niDA");

var $ftS5c = parcelRequire("ftS5c");

var $5lsNZ = parcelRequire("5lsNZ");

var $4oU7e = parcelRequire("4oU7e");
const $5e479a4488e4cc4e$var$productsJcsFormFieldsEntryPointPage = (0, $lkFvK.createPageEntryPoint)({
    main: $ftS5c.productsJcsFormFieldsEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).SETTINGS
});
const $5e479a4488e4cc4e$export$ce43ae01ccf4d9b6 = (0, $7NszV.createEntry)((0, $3niDA.productsJcsFormFieldsRoute), ()=>({
        group: 'global-settings',
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('jcs_forms_resiliency_fast_follows') ? $5e479a4488e4cc4e$var$productsJcsFormFieldsEntryPointPage : undefined;
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $4oU7e.formFieldsResource)
        ]
    }));

});
parcelRegister("3niDA", function(module, exports) {

$parcel$export(module.exports, "productsJcsFormFieldsRoute", () => $29928e55102e185a$export$ace810399baa80ca);
const $29928e55102e185a$export$ace810399baa80ca = {
    name: 'products-jcs-form-fields',
    path: '/jira/settings/products/customerservice/form-fields',
    exact: true
};

});

parcelRegister("ftS5c", function(module, exports) {

$parcel$export(module.exports, "productsJcsFormFieldsEntryPoint", () => $18c73624925e2d30$export$4afec7b2100b3396);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $18c73624925e2d30$export$4afec7b2100b3396 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("jMzD4")), {
        moduleId: "b263f162"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("jMzD4", function(module, exports) {

let $e66e23346554f4fa$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e66e23346554f4fa$var$load("kkDPU").then(()=>parcelRequire('kL0fx'));

});


parcelRegister("4oU7e", function(module, exports) {

$parcel$export(module.exports, "setSearchFieldsFormQuery", () => $5806ca2e66378d57$export$52917d9e09f11230);
$parcel$export(module.exports, "formFieldsResource", () => $5806ca2e66378d57$export$cf387af041de8a73);

var $2M1hQ = parcelRequire("2M1hQ");

var $7f4tk = parcelRequire("7f4tk");

var $1m4nn = parcelRequire("1m4nn");
const $5806ca2e66378d57$export$2345ec6675b232f1 = {};
const $5806ca2e66378d57$export$52917d9e09f11230 = (query)=>{
    $5806ca2e66378d57$export$2345ec6675b232f1.query = query;
};
const $5806ca2e66378d57$export$cf387af041de8a73 = (0, $2M1hQ.createResource)({
    type: 'FORM_FIELDS_RESOURCE',
    // The query.page in getData() is cached, and only changes if getKey() returns a new value
    getKey: ({ query: query })=>`form-fields${query?.page || 1}`,
    getData: async ({ query: query })=>(0, $7f4tk.default)((0, $1m4nn.getUrl)(query?.page, $5806ca2e66378d57$export$2345ec6675b232f1.query)),
    maxAge: 0
});

});
parcelRegister("1m4nn", function(module, exports) {

$parcel$export(module.exports, "PAGE_SIZE", () => $1f5621e396d56d5b$export$8ec3d08588d2eeda);
$parcel$export(module.exports, "getUrl", () => $1f5621e396d56d5b$export$94df0e59ebebf4a7);
const $1f5621e396d56d5b$export$8ec3d08588d2eeda = 50;
const $1f5621e396d56d5b$var$getStartAt = (page)=>{
    const pageNum = Number(page);
    if (!page || Number.isNaN(pageNum)) return 0;
    return (pageNum - 1) * $1f5621e396d56d5b$export$8ec3d08588d2eeda;
};
const $1f5621e396d56d5b$export$94df0e59ebebf4a7 = (page, query)=>`/rest/jcs/admin/v1/request-intake/global-fields?startAt=${$1f5621e396d56d5b$var$getStartAt(page)}${query ? `&query=${query}` : ''}`;

});



parcelRegister("fpGzf", function(module, exports) {

$parcel$export(module.exports, "arjCalendarEmbedRouteEntry", () => $e45e5c76e61613b2$export$309ed92381819b04);

var $5uXOq = parcelRequire("5uXOq");


var $87OsA = parcelRequire("87OsA");

var $lkFvK = parcelRequire("lkFvK");

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $2Ql51 = parcelRequire("2Ql51");

var $6vwaX = parcelRequire("6vwaX");

var $5lsNZ = parcelRequire("5lsNZ");

var $kZOse = parcelRequire("kZOse");

var $02tNK = parcelRequire("02tNK");
const $e45e5c76e61613b2$var$planCalendarEmbedRouteEntry = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $02tNK.calendarEntryPoint)
});
const $e45e5c76e61613b2$export$309ed92381819b04 = (0, $7NszV.createEntry)((0, $6vwaX.arjCalendarEmbedRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-calendar-embed',
        // Remove 'component' when cleanup 'smart_links_for_plans' FG
        component: (0, $5lsNZ.default),
        skeleton: ()=>{
            if ((0, $4R6GH.fg)('smart_links_for_plans')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZOse.CalendarSkeleton), null);
            return undefined;
        },
        entryPoint () {
            if ((0, $4R6GH.fg)('smart_links_for_plans')) {
                (0, $87OsA.setCapability)((0, $281cbd47ba46dd7d$export$f999749ac7a2cd1));
                return $e45e5c76e61613b2$var$planCalendarEmbedRouteEntry;
            }
            return undefined;
        },
        layout: (0, $aPfsS.createLayout)({
            isChromeless: true
        }),
        resources: [
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource),
            (0, $2Ql51.themePreferenceResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$f999749ac7a2cd1)
        },
        forPaint: []
    }));

});
const $281cbd47ba46dd7d$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $281cbd47ba46dd7d$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $281cbd47ba46dd7d$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $281cbd47ba46dd7d$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $281cbd47ba46dd7d$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $281cbd47ba46dd7d$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $281cbd47ba46dd7d$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $281cbd47ba46dd7d$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $281cbd47ba46dd7d$export$4695c1a423ffe431 = 'DASHBOARD';
const $281cbd47ba46dd7d$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
const $281cbd47ba46dd7d$export$9a80695e72849f84 = 'X-Atlassian-Capability';

parcelRegister("c3WQb", function(module, exports) {

$parcel$export(module.exports, "advancedRoadmapsReduxStoreStateResource", () => $20c66b93015d9910$export$6ca262338f199e4b);
$parcel$export(module.exports, "advancedRoadmapsScenarioIdResource", () => $20c66b93015d9910$export$aec847b4ce72891);
$parcel$export(module.exports, "advancedRoadmapsPlanPageInitialChecksResource", () => $20c66b93015d9910$export$7431e46c7ad56c3d);
$parcel$export(module.exports, "advancedRoadmapsPlanReportPageInitialChecksResource", () => $20c66b93015d9910$export$bf0c5395c73cc255);
$parcel$export(module.exports, "advancedRoadmapsLastVisitedProgramBoardIdResource", () => $20c66b93015d9910$export$f5b159e1fb19e04e);

var $hGgHi = parcelRequire("hGgHi");

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");

const $20c66b93015d9910$export$6ca262338f199e4b = (0, $2M1hQ.createResource)({
    type: 'ADVANCED_ROADMAPS_REDUX_STORE_STATE',
    getKey: ({ match: match })=>{
        const { params: params, query: query } = match;
        if (params.planId != null && params.scenarioId != null) return `${params.planId}:${params.scenarioId}`;
        if (params.reportId != null) return params.reportId;
        if (query.r != null) return query.r;
        throw new Error('Unable to get resource key for ADVANCED_ROADMAPS_REDUX_STORE_STATE.');
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getData: async ()=>undefined,
    isBrowserOnly: true,
    // Invalidation is implemented here: src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});
const $20c66b93015d9910$export$aec847b4ce72891 = (0, $2M1hQ.createResource)({
    type: (0, $025c2a539475c8ec$export$a0893d695ebee984),
    getKey: ({ query: query })=>`scenarioId_${query.id}`,
    getData: async ({ query: query })=>{
        const planId = query.id;
        const { id: id } = await (0, $eusud.performGetRequest)(`/rest/jpo/1.0/scenarios/${planId}`);
        return {
            scenarioId: id
        };
    },
    maxAge: 0
});
const $20c66b93015d9910$export$7431e46c7ad56c3d = (0, $2M1hQ.createResource)({
    type: (0, $025c2a539475c8ec$export$68390102872336b6),
    getKey: ({ match: match })=>{
        const { planId: planId, scenarioId: scenarioId } = match.params;
        return `planPageInitialChecks_${planId != null ? planId : ''}_${scenarioId != null ? scenarioId : ''}`;
    },
    getData: async ({ match: match })=>{
        const { planId: planId, scenarioId: scenarioId } = match.params;
        // @ts-expect-error - TS2367 - This condition will always return 'false' since the types '"null"' and '"undefined"' have no overlap.
        if (planId == null || planId === 'null' && planId === 'undefined' && planId === '') throw new Error('Plan cannot be loaded without a planId');
        let url = `/rest/jpo/1.0/plans/${planId}/checks`;
        if (scenarioId != null && scenarioId !== 'null' && scenarioId !== 'undefined' && scenarioId !== '') url = `${url}?sid=${scenarioId}`;
        const response = await (0, $eusud.performGetRequest)(url);
        return response;
    },
    // Invalidation is implemented here: src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});
const $20c66b93015d9910$export$bf0c5395c73cc255 = (0, $2M1hQ.createResource)({
    type: (0, $025c2a539475c8ec$export$a00e869cafd63140),
    getKey: ({ match: match })=>`planReportPageInitialChecks_${match.params.reportId == null ? '' : match.params.reportId}`,
    getData: async ({ match: match })=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const initialPlanChecksPromise = window.__ARJ_INITIAL_PLAN_REPORT_CHECKS_PROMISE__;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        delete window.__ARJ_INITIAL_PLAN_REPORT_CHECKS_PROMISE__;
        if (initialPlanChecksPromise) {
            const response = await initialPlanChecksPromise;
            return response;
        }
        const { reportId: reportId } = match.params;
        const response = await (0, $eusud.performGetRequest)(`/rest/jpo/1.0/reportinfo/generic/${reportId == null ? '' : reportId}/checks`);
        return response;
    },
    // Invalidation is implemented here: src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});
const $20c66b93015d9910$export$f5b159e1fb19e04e = (0, $2M1hQ.createResource)({
    type: (0, $025c2a539475c8ec$export$179a0d35e95a4d61),
    getKey: ({ query: query, match: match })=>`lastVisitedProgramBoardId_${query.id}_${match.params.planId}_${match.params.scenarioId}`,
    getData: async ({ match: match })=>{
        // Sometimes currentPlanId isn't yet ready - we retry a few times to check if it has loaded in before making the request
        const RETRIES = 3;
        const DELAY = 500;
        const attemptFetch = async (remainingRetries)=>{
            const currentPlanId = match.params.planId;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(currentPlanId)) {
                const defaultBoardIdResponse = await (0, $eusud.performGetRequest)(`/rest/jpo/2.0/plans/${currentPlanId}/increments/default`);
                if (defaultBoardIdResponse === null) return {
                    boardId: null
                };
                const { id: id } = defaultBoardIdResponse;
                return {
                    boardId: id
                };
            }
            if (remainingRetries > 0) {
                await new Promise((resolve)=>setTimeout(resolve, DELAY));
                return attemptFetch(remainingRetries - 1);
            }
            throw new Error('Attempted to get the last visited program board of a plan without a plan id after multiple retries.');
        };
        return attemptFetch(RETRIES);
    },
    // Invalidation is implemented here: src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});

});
const $025c2a539475c8ec$export$68390102872336b6 = 'ADVANCED_ROADMAPS_PLAN_INITIAL_CHECKS';
const $025c2a539475c8ec$export$a00e869cafd63140 = 'ADVANCED_ROADMAPS_REPORT_INITIAL_CHECKS';
const $025c2a539475c8ec$export$a0893d695ebee984 = 'ADVANCED_ROADMAPS_SCENARIO_ID';
const $025c2a539475c8ec$export$179a0d35e95a4d61 = 'ADVANCED_ROADMAPS_LAST_VISITED_PROGRAM_BOARD_ID';


parcelRegister("6vwaX", function(module, exports) {

$parcel$export(module.exports, "arjCalendarEmbedRoute", () => $6f41180defbce930$export$30779cab3c860456);
const $6f41180defbce930$export$30779cab3c860456 = {
    name: 'software-plan-calendar-embed',
    path: '/jira/plans/:planId/scenarios/:scenarioId/calendar/embed'
};

});

parcelRegister("kZOse", function(module, exports) {

$parcel$export(module.exports, "CalendarSkeleton", () => $7999bdaf81f7939b$export$ebc7c47cc535837e);
$parcel$export(module.exports, "CalendarEmbedSkeleton", () => $7999bdaf81f7939b$export$bf543fe31d33292e);
$parcel$export(module.exports, "CalendarNoHeaderSkeleton", () => $7999bdaf81f7939b$export$504e7b05f3c54bf2);
/* CalendarSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $9AxEw = parcelRequire("9AxEw");

var $34brI = parcelRequire("34brI");

var $lxEy8 = parcelRequire("lxEy8");
const $7999bdaf81f7939b$var$customCssStyles = null;
const $7999bdaf81f7939b$export$ebc7c47cc535837e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9AxEw)))
    });
const $7999bdaf81f7939b$export$bf543fe31d33292e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($34brI)))
    });
const $7999bdaf81f7939b$export$504e7b05f3c54bf2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lxEy8))),
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("hCy6k", function(module, exports) {

$parcel$export(module.exports, "AppSkeletonImage", () => $a2cd0a6153845fd0$export$45b107c5dc7b51a5);
/* AppSkeletonImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fNobW = parcelRequire("fNobW");


var $koVbs = parcelRequire("koVbs");

var $d0Ozr = parcelRequire("d0Ozr");
const $a2cd0a6153845fd0$var$skeletonImageStyles = null;
const $a2cd0a6153845fd0$export$45b107c5dc7b51a5 = /*#__PURE__*/ (0, $5uXOq.memo)(({ src: src, className: className, containerStyles: containerStyles, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "app-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a2cd0a6153845fd0$var$SkeletonWrapper // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: src,
        "data-testid": testId,
        alt: `${formatMessage((0, $d0Ozr.default).loading)}...`,
        className: (0, $bwpsq.default)([
            "_1dqonqa1 _1h6d3acm _1e0c1ule _vchhusvi _1bsb1osq _t6vd1ylp _hr4j1ylp _l82tgktf _j7o0gktf",
            className
        ])
    })));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a2cd0a6153845fd0$var$SkeletonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bsb1osq _4t3i1osq _yksp1ssb _1b421ssb _s8ks18ws _u1wz1nty",
            __cmplp.className
        ])
    });
});

});
parcelRegister("d0Ozr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6abc81adadf77f72$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6abc81adadf77f72$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    loading: {
        "id": "skeletons.common.loading",
        "defaultMessage": "Loading"
    }
});

});


parcelRegister("9AxEw", function(module, exports) {
module.exports = new URL("calendar-app-skeleton.tpl.77b09222.svg", import.meta.url).toString();

});

parcelRegister("34brI", function(module, exports) {
module.exports = new URL("calendar-embed-app-skeleton.tpl.29c9a641.svg", import.meta.url).toString();

});

parcelRegister("lxEy8", function(module, exports) {
module.exports = new URL("calendar-no-header-skeleton.tpl.d6779107.svg", import.meta.url).toString();

});


parcelRegister("02tNK", function(module, exports) {

$parcel$export(module.exports, "calendarEntryPoint", () => $8623df52c8647276$export$19cf4b398f638dc6);

var $4R6GH = parcelRequire("4R6GH");

var $7JhZX = parcelRequire("7JhZX");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");
const $8623df52c8647276$var$ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR_EMBED = 'software-plan-calendar-embed';
const $8623df52c8647276$var$SETTINGS_STORAGE_KEY = 'plans_calendar_view_settings';
function $8623df52c8647276$var$getViewSettings(key) {
    try {
        const serializedValue = globalThis.localStorage?.getItem(key);
        return serializedValue !== null ? JSON.parse(serializedValue) : undefined;
    } catch  {
        return undefined;
    }
}
function $8623df52c8647276$var$toPlanScenarioAri({ siteId: siteId, activationId: activationId, planId: planId, scenarioId: scenarioId }) {
    return `ari:cloud:jira:${siteId}:plan-scenario/activation/${activationId}/${planId}/scenario/${scenarioId}`;
}
function $8623df52c8647276$var$getStorageKeyFromScope(context) {
    const { match: { params: { planId: planId, scenarioId: scenarioId } } } = context;
    const LOCALSTORAGE_KEY_PREFIX = 'persist:calendar';
    return `${LOCALSTORAGE_KEY_PREFIX}/plan/${planId}/scenario/${scenarioId}`;
}
function $8623df52c8647276$var$getStorageValueFromScope(key) {
    const storedData = globalThis.localStorage?.getItem(key) || '';
    return storedData;
}
function $8623df52c8647276$var$toMidnightUTCString(date) {
    const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return new Date(utcMilliseconds).toISOString();
}
function $8623df52c8647276$var$toDate(date) {
    if (!date) return new Date();
    try {
        const _date = new Date(date);
        return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
    } catch (e) {
        return new Date();
    }
}
function $8623df52c8647276$var$createScope({ context: context, tenantContext: tenantContext }) {
    const { match: { params: { planId: planId, scenarioId: scenarioId } } } = context;
    const { cloudId: cloudId, activationId: activationId } = tenantContext;
    const planScenarioAri = $8623df52c8647276$var$toPlanScenarioAri({
        siteId: cloudId,
        activationId: activationId,
        planId: String(planId),
        scenarioId: String(scenarioId)
    });
    return {
        type: 'plan',
        ids: [
            planScenarioAri
        ]
    };
}
function $8623df52c8647276$var$buildScopeInput(scope) {
    return {
        ids: scope.ids
    };
}
function $8623df52c8647276$var$buildViewId(scope) {
    // plan scenario ARI is the view id
    return scope.ids?.[0] ?? '';
}
function $8623df52c8647276$var$toViewMode(mode) {
    switch(mode){
        case 'week':
            return 'WEEK';
        case 'day':
            return 'DAY';
        default:
            return 'MONTH';
    }
}
function $8623df52c8647276$var$toWeekStart(weekStart) {
    switch(weekStart){
        case 'monday':
            return 'MONDAY';
        case 'saturday':
            return 'SATURDAY';
        default:
            return 'SUNDAY';
    }
}
function $8623df52c8647276$var$toCalendarWeekStart(weekStart) {
    switch(weekStart){
        case 'sunday':
            return 'sunday';
        case 'saturday':
            return 'saturday';
        default:
            return 'monday';
    }
}
function $8623df52c8647276$var$toCalendarColorBy(colorBy) {
    switch(colorBy){
        case 'none':
            return 'none';
        case 'status':
            return 'status';
        default:
            return 'status';
    }
}
function $8623df52c8647276$var$toCalendarViewRange(view) {
    switch(view){
        case 'week':
            return 'week';
        default:
            return 'month';
    }
}
function $8623df52c8647276$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField, viewId: viewId }) {
    return {
        date: $8623df52c8647276$var$toMidnightUTCString(selectedDate),
        mode: $8623df52c8647276$var$toViewMode(viewRange),
        weekStart: $8623df52c8647276$var$toWeekStart(weekStartsOn),
        ...(0, $4R6GH.fg)('jira_calendar_load_more_pagination') ? {
            startDateField: startDateField,
            endDateField: endDateField
        } : {},
        viewId: viewId
    };
}
function $8623df52c8647276$var$buildIssuesSearchInput(storageKey, // remove optional attribute when cleaning up fg smart_links_for_plans
filter, isEmbed) {
    if ((0, $4R6GH.fg)('smart_links_for_plans')) return {
        additionalFilterQuery: isEmbed === true ? filter ?? '' : filter || $8623df52c8647276$var$getStorageValueFromScope(storageKey)
    };
    return {
        additionalFilterQuery: $8623df52c8647276$var$getStorageValueFromScope(storageKey)
    };
}
function $8623df52c8647276$var$buildUnscheduledIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $8623df52c8647276$var$buildVersionsSearchInput() {
    return {
        versionStatuses: [
            'RELEASED',
            'UNRELEASED'
        ]
    };
}
function $8623df52c8647276$var$buildCalendarCrossProjectVersionsInput() {
    return {
        statuses: [
            'RELEASED',
            'UNRELEASED'
        ]
    };
}
function $8623df52c8647276$var$buildSprintsSearchInput() {
    return {
        sprintStates: [
            'ACTIVE',
            'FUTURE',
            'CLOSED'
        ]
    };
}
function $8623df52c8647276$var$buildSettingsParams(hideWeekends, hideSprints, hideVersions, hideIssues, hideIssueKey, weekStartsOnQueryParam, colorBy, viewRange) {
    if (hideWeekends || hideSprints || hideVersions || hideIssues || hideIssueKey || weekStartsOnQueryParam || colorBy || viewRange) return {
        hideWeekends: hideWeekends === 'true' || undefined,
        hideSprints: hideSprints === 'true' || undefined,
        hideVersions: hideVersions === 'true' || undefined,
        hideIssues: hideIssues === 'true' || undefined,
        hideIssueKey: hideIssueKey === 'true' || undefined,
        weekStartsOn: $8623df52c8647276$var$toCalendarWeekStart(weekStartsOnQueryParam),
        colorBy: $8623df52c8647276$var$toCalendarColorBy(colorBy),
        viewRange: $8623df52c8647276$var$toCalendarViewRange(viewRange)
    };
    return undefined;
}

const $8623df52c8647276$export$19cf4b398f638dc6 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("jashH")), {
        moduleId: "53aec496"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        const { cloudId: cloudId } = tenantContext;
        const scope = $8623df52c8647276$var$createScope(entryPointRouteParams);
        const scopeInput = $8623df52c8647276$var$buildScopeInput(scope);
        const { date: date, filter: filter, hideWeekends: hideWeekends, hideSprints: hideSprints, hideVersions: hideVersions, hideIssues: hideIssues, hideIssueKey: hideIssueKey, weekStartsOn: weekStartsOnQueryParam, colorBy: colorByQueryParam, viewRange: viewRangeParam } = context.query;
        const selectedDate = $8623df52c8647276$var$toDate(date);
        const hasFilterQueryParam = (0, $4R6GH.fg)('smart_links_for_plans') ? Boolean(filter) : false;
        const routeName = (0, $4R6GH.fg)('smart_links_for_plans') ? context.route.name : '';
        const settingsQueryParams = (0, $4R6GH.fg)('smart_links_for_plans') ? $8623df52c8647276$var$buildSettingsParams(hideWeekends, hideSprints, hideVersions, hideIssues, hideIssueKey, weekStartsOnQueryParam, colorByQueryParam, viewRangeParam) : {};
        const isEmbed = (0, $4R6GH.fg)('smart_links_for_plans') ? routeName === $8623df52c8647276$var$ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR_EMBED : false;
        const settings = (0, $4R6GH.fg)('jira_calendar_load_more_pagination') ? $8623df52c8647276$var$getViewSettings($8623df52c8647276$var$SETTINGS_STORAGE_KEY) : undefined;
        const viewRange = (0, $4R6GH.fg)('enable_week_mode_in_plan_calendar') ? settingsQueryParams?.viewRange ?? settings?.viewRange ?? 'month' : 'month';
        const weekStartsOn = (0, $4R6GH.fg)('jira_calendar_load_more_pagination') ? settingsQueryParams?.weekStartsOn ?? settings?.weekStartsOn ?? 'monday' : 'monday';
        const startDateField = 'startdate';
        const endDateField = 'duedate';
        const issueEventFields = {
            startDateField: startDateField,
            endDateField: endDateField
        };
        const storageKey = $8623df52c8647276$var$getStorageKeyFromScope(context);
        const viewId = $8623df52c8647276$var$buildViewId(scope);
        const filterQuery = (0, $4R6GH.fg)('smart_links_for_plans') ? $8623df52c8647276$var$buildIssuesSearchInput(storageKey, filter, isEmbed) : $8623df52c8647276$var$buildIssuesSearchInput(storageKey);
        return {
            queries: {
                calendarData: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $7JhZX.default,
                    variables: {
                        cloudId: cloudId,
                        scopeInput: scopeInput,
                        configurationInput: $8623df52c8647276$var$buildConfigurationInput({
                            selectedDate: selectedDate,
                            viewRange: viewRange,
                            weekStartsOn: weekStartsOn,
                            startDateField: startDateField,
                            endDateField: endDateField,
                            viewId: viewId
                        }),
                        issuesPageSize: 50,
                        issuesSearchInput: filterQuery,
                        unscheduledIssuesSearchInput: $8623df52c8647276$var$buildUnscheduledIssuesSearchInput(),
                        versionsSearchInput: $8623df52c8647276$var$buildVersionsSearchInput(),
                        sprintsSearchInput: $8623df52c8647276$var$buildSprintsSearchInput(),
                        crossProjectVersionsSearchInput: $8623df52c8647276$var$buildCalendarCrossProjectVersionsInput(),
                        viewId: viewId,
                        skipSprintSearch: false,
                        skipPanelIssueSearch: true,
                        skipCrossProjectVersionSearch: false,
                        schedulePermissionsEnabled: (0, $4R6GH.fg)('calendar_schedule_issue_permissions_check'),
                        pageLoadMoreEnabled: (0, $4R6GH.fg)('jira_calendar_load_more_pagination'),
                        skipVersionsV1Search: (0, $4R6GH.fg)('plan-calendar-versions-v2-adoption'),
                        skipVersionsV2Search: !(0, $4R6GH.fg)('plan-calendar-versions-v2-adoption'),
                        includeRecurrenceIndicator: false,
                        pageLoadMoreEnabledViewSettings: (0, $4R6GH.fg)('jira_calendar_load_more_pagination_view_settings')
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                scope: scope,
                selectedDate: selectedDate,
                viewRange: viewRange,
                weekStartsOn: weekStartsOn,
                issueEventFields: issueEventFields,
                storageKey: storageKey,
                hasFilterQueryParam: hasFilterQueryParam,
                routeName: routeName,
                settingsQueryParams: settingsQueryParams,
                filterQuery: (0, $4R6GH.fg)('smart_links_for_plans') ? filterQuery.additionalFilterQuery : undefined
            }
        };
    }
});

});
parcelRegister("7JhZX", function(module, exports) {

$parcel$export(module.exports, "default", () => $122674b135b0c50b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d885ae30433602c86d069d6faefc88bb>>
 * @relayHash 049de4ae3c6fdd9cf38242148ced5df6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7b05b902b1f5bbf48ae4756c58d4841b930fd1b552e2d2cd45a05d7e5aded3e8

var $jczjB = parcelRequire("jczjB");
const $122674b135b0c50b$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "7b05b902b1f5bbf48ae4756c58d4841b930fd1b552e2d2cd45a05d7e5aded3e8",
        "metadata": {},
        "name": "ui_jiraCalendarQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcisjiracalendarreleaseflyoutlazyloadingenabledrelayprovider": (0, $jczjB.default)
        }
    }
};
var $122674b135b0c50b$export$2e2bcd8739ae039 = $122674b135b0c50b$var$node;

});
parcelRegister("jczjB", function(module, exports) {

$parcel$export(module.exports, "default", () => $51b693d306308748$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");
var $51b693d306308748$export$2e2bcd8739ae039 = {
    get () {
        return (0, $6s1PB.expVal)('jira_calendar_release_flyout_lazy_loading', 'isEnabled', false);
    }
};

});


parcelRegister("jashH", function(module, exports) {

let $df44e438f299f540$var$load = (parcelRequire("28QjX"))(4);




module.exports = Promise.all([
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $df44e438f299f540$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $df44e438f299f540$var$load("7B2gt")
        ]);
    }),
    $df44e438f299f540$var$load("7mIf9"),
    $df44e438f299f540$var$load("jXweD"),
    $df44e438f299f540$var$load("ffQaD"),
    $df44e438f299f540$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("gLm90"), 4)),
    $df44e438f299f540$var$load("fliVL"),
    $df44e438f299f540$var$load("76n7a"),
    $df44e438f299f540$var$load("l253H"),
    $df44e438f299f540$var$load("kE8pT")
]).then(()=>parcelRequire('5zu1k'));

});
parcelRegister("avM1e", function(module, exports) {
"use strict";
module.exports = function(cond, ifTrue, ifFalse) {
    return globalThis.__MCOND && globalThis.__MCOND(cond) ? ifTrue() : ifFalse();
};

});

parcelRegister("aMHR6", function(module, exports) {
"use strict";

var $g1Pp8 = parcelRequire("g1Pp8");
module.exports = $g1Pp8(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        let existingLinks = document.getElementsByTagName('link');
        if ([].concat(existingLinks).some(function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("g1Pp8", function(module, exports) {
"use strict";
let $bab49d2fea43af49$var$cachedBundles = {};
let $bab49d2fea43af49$var$cachedPreloads = {};
let $bab49d2fea43af49$var$cachedPrefetches = {};
function $bab49d2fea43af49$var$getCache(type) {
    switch(type){
        case 'preload':
            return $bab49d2fea43af49$var$cachedPreloads;
        case 'prefetch':
            return $bab49d2fea43af49$var$cachedPrefetches;
        default:
            return $bab49d2fea43af49$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        let cache = $bab49d2fea43af49$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});





parcelRegister("aVGYm", function(module, exports) {

$parcel$export(module.exports, "arjDependenciesEmbedRouteEntry", () => $b6a501a17ba8d16b$export$2506a377ba649c46);

var $cSD7y = parcelRequire("cSD7y");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $2Ql51 = parcelRequire("2Ql51");

var $2NIIP = parcelRequire("2NIIP");

var $5lsNZ = parcelRequire("5lsNZ");

var $4R6GH = parcelRequire("4R6GH");

var $lkFvK = parcelRequire("lkFvK");

var $1zjAp = parcelRequire("1zjAp");

var $k7MTs = parcelRequire("k7MTs");
const $b6a501a17ba8d16b$var$planDependenciesReportEmbedRouteEntry = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $1zjAp.planDependenciesReportEntryPoint)
});
const $b6a501a17ba8d16b$export$2506a377ba649c46 = (0, $7NszV.createEntry)((0, $2NIIP.arjDependenciesEmbedRoute), ()=>({
        group: 'software',
        component: (0, $cSD7y.componentWithFG)('smart_links_for_plans', (0, $k7MTs.PlanDependenciesReportEmbedPage), (0, $5lsNZ.default)),
        entryPoint: ()=>(0, $4R6GH.fg)('migrate_plans_to_entrypoints') ? $b6a501a17ba8d16b$var$planDependenciesReportEmbedRouteEntry : undefined,
        layout: (0, $aPfsS.createLayout)({
            isChromeless: true
        }),
        resources: [
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource),
            (0, $2Ql51.themePreferenceResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        forPaint: [
            (0, $k7MTs.LazyPlanDependenciesReportEmbed)
        ]
    }));

});
parcelRegister("2NIIP", function(module, exports) {

$parcel$export(module.exports, "arjDependenciesEmbedRoute", () => $994711b55bffb4b7$export$96aaf89753980215);
const $994711b55bffb4b7$export$96aaf89753980215 = {
    name: 'software-plan-dependencies-embed',
    path: '/jira/plans/:planId/scenarios/:scenarioId/dependencies/embed'
};

});

parcelRegister("1zjAp", function(module, exports) {

$parcel$export(module.exports, "planDependenciesReportEntryPoint", () => $d023c1f5bac3e782$export$e4ba4cc5a2304191);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $d023c1f5bac3e782$export$e4ba4cc5a2304191 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        if (!false) return (parcelRequire("l1Brb"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "1a1a3500"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("l1Brb", function(module, exports) {

let $f4e6bb3e8d456a76$var$load = (parcelRequire("28QjX"))(4);




module.exports = Promise.all([
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $f4e6bb3e8d456a76$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $f4e6bb3e8d456a76$var$load("7B2gt")
        ]);
    }),
    $f4e6bb3e8d456a76$var$load("7mIf9"),
    $f4e6bb3e8d456a76$var$load("jXweD"),
    $f4e6bb3e8d456a76$var$load("76n7a"),
    $f4e6bb3e8d456a76$var$load("l253H"),
    $f4e6bb3e8d456a76$var$load("ffQaD"),
    $f4e6bb3e8d456a76$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("lIVmo"), 4)),
    $f4e6bb3e8d456a76$var$load("fliVL"),
    $f4e6bb3e8d456a76$var$load("j4ifu")
]).then(()=>parcelRequire('9WfFd'));

});


parcelRegister("k7MTs", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSummaryEmbed", () => $39df6cea3ba994f5$export$b0feb6e650be3c8c);
$parcel$export(module.exports, "PlanSummaryEmbedPage", () => $39df6cea3ba994f5$export$a37f296d90476a73);
$parcel$export(module.exports, "LazyPlanDependenciesReportEmbed", () => $39df6cea3ba994f5$export$48681ab0b4246654);
$parcel$export(module.exports, "PlanDependenciesReportEmbedPage", () => $39df6cea3ba994f5$export$4ece7fb6c15037f9);
$parcel$export(module.exports, "LazyPlanIncrementEmbed", () => $39df6cea3ba994f5$export$51f2083dff1ee684);
$parcel$export(module.exports, "PlanIncrementEmbedPage", () => $39df6cea3ba994f5$export$a2ae011b90c17927);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $39df6cea3ba994f5$export$b0feb6e650be3c8c = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("irZA1"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-summary/index.tsx"
});
const $39df6cea3ba994f5$export$a37f296d90476a73 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $39df6cea3ba994f5$export$b0feb6e650be3c8c,
        pageId: "plan-summary-embed-old",
        shouldShowSpinner: true
    });

const $39df6cea3ba994f5$export$48681ab0b4246654 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("fu64C")).then(({ PlanDependenciesReportWithoutPageHeader: PlanDependenciesReportWithoutPageHeader })=>PlanDependenciesReportWithoutPageHeader)), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-dependencies-report/index-old.tsx"
});
const $39df6cea3ba994f5$export$4ece7fb6c15037f9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $39df6cea3ba994f5$export$48681ab0b4246654,
        pageId: "plan-dependencies-report-embed-old",
        shouldShowSpinner: true
    });

const $39df6cea3ba994f5$export$51f2083dff1ee684 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("eDGY6")).then(({ PlanIncrementWithoutPageHeader: PlanIncrementWithoutPageHeader })=>PlanIncrementWithoutPageHeader)), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-increment/index-old.tsx"
});
const $39df6cea3ba994f5$export$a2ae011b90c17927 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $39df6cea3ba994f5$export$51f2083dff1ee684,
        pageId: "plan-increment-embed-old",
        shouldShowSpinner: true
    });

});
parcelRegister("irZA1", function(module, exports) {

let $d6ea841ee58a5501$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $d6ea841ee58a5501$var$load("ffQaD"),
    $d6ea841ee58a5501$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("603yk"), 4)),
    $d6ea841ee58a5501$var$load("bDfzP")
]).then(()=>parcelRequire('3Wpua'));

});

parcelRegister("fu64C", function(module, exports) {

let $b45e5e6efc80c07d$var$load = (parcelRequire("28QjX"))(4);




module.exports = Promise.all([
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $b45e5e6efc80c07d$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $b45e5e6efc80c07d$var$load("7B2gt")
        ]);
    }),
    $b45e5e6efc80c07d$var$load("7mIf9"),
    $b45e5e6efc80c07d$var$load("jXweD"),
    $b45e5e6efc80c07d$var$load("76n7a"),
    $b45e5e6efc80c07d$var$load("l253H"),
    $b45e5e6efc80c07d$var$load("ffQaD"),
    $b45e5e6efc80c07d$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("4eYMq"), 4)),
    $b45e5e6efc80c07d$var$load("fliVL"),
    $b45e5e6efc80c07d$var$load("9ECEW")
]).then(()=>parcelRequire('kTf8P'));

});

parcelRegister("eDGY6", function(module, exports) {

let $aa8609dbaa2f2612$var$load = (parcelRequire("28QjX"))(4);




module.exports = Promise.all([
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $aa8609dbaa2f2612$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $aa8609dbaa2f2612$var$load("7B2gt")
        ]);
    }),
    $aa8609dbaa2f2612$var$load("7mIf9"),
    $aa8609dbaa2f2612$var$load("jXweD"),
    $aa8609dbaa2f2612$var$load("kNFvF"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("hzlTj"), 4)),
    $aa8609dbaa2f2612$var$load("ffQaD"),
    $aa8609dbaa2f2612$var$load("kvRbA"),
    $aa8609dbaa2f2612$var$load("76n7a"),
    $aa8609dbaa2f2612$var$load("l253H"),
    $aa8609dbaa2f2612$var$load("fliVL"),
    $aa8609dbaa2f2612$var$load("65L5Z")
]).then(()=>parcelRequire('fgv4D'));

});



parcelRegister("2DH60", function(module, exports) {

$parcel$export(module.exports, "arjIncrementEmbedRouteEntry", () => $ddc531e0f3e9c8bc$export$3feed0b4da010c52);

var $cSD7y = parcelRequire("cSD7y");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $2Ql51 = parcelRequire("2Ql51");

var $ddtN3 = parcelRequire("ddtN3");

var $5lsNZ = parcelRequire("5lsNZ");

var $4R6GH = parcelRequire("4R6GH");

var $lkFvK = parcelRequire("lkFvK");

var $8tlKP = parcelRequire("8tlKP");

var $k7MTs = parcelRequire("k7MTs");
const $ddc531e0f3e9c8bc$var$planProgramEmbedRouteEntry = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $8tlKP.planIncrementEntryPoint)
});
const $ddc531e0f3e9c8bc$export$3feed0b4da010c52 = (0, $7NszV.createEntry)((0, $ddtN3.arjIncrementEmbedRoute), ()=>({
        group: 'software',
        component: (0, $cSD7y.componentWithFG)('smart_links_for_plans', (0, $k7MTs.PlanIncrementEmbedPage), (0, $5lsNZ.default)),
        entryPoint: ()=>(0, $4R6GH.fg)('migrate_plans_to_entrypoints') ? $ddc531e0f3e9c8bc$var$planProgramEmbedRouteEntry : undefined,
        layout: (0, $aPfsS.createLayout)({
            isChromeless: true
        }),
        resources: [
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource),
            (0, $2Ql51.themePreferenceResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        forPaint: [
            (0, $k7MTs.LazyPlanIncrementEmbed)
        ]
    }));

});
parcelRegister("ddtN3", function(module, exports) {

$parcel$export(module.exports, "arjIncrementEmbedRoute", () => $0b961407c2693247$export$88913ef2dfa37bc1);
const $0b961407c2693247$export$88913ef2dfa37bc1 = {
    name: 'software-plan-increment-embed',
    path: '/jira/plans/:planId/scenarios/:scenarioId/program/:incrementId/embed'
};

});

parcelRegister("8tlKP", function(module, exports) {

$parcel$export(module.exports, "planIncrementEntryPoint", () => $fe259e4b6c6f1cb0$export$72cc8a7d91a08ace);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $fe259e4b6c6f1cb0$export$72cc8a7d91a08ace = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        if (!false) return (parcelRequire("4fIYO"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "6d0a9b0d"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4fIYO", function(module, exports) {

let $318b743776eb809f$var$load = (parcelRequire("28QjX"))(4);




module.exports = Promise.all([
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $318b743776eb809f$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $318b743776eb809f$var$load("7B2gt")
        ]);
    }),
    $318b743776eb809f$var$load("7mIf9"),
    $318b743776eb809f$var$load("jXweD"),
    $318b743776eb809f$var$load("kNFvF"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("7XSFG"), 4)),
    $318b743776eb809f$var$load("ffQaD"),
    $318b743776eb809f$var$load("kvRbA"),
    $318b743776eb809f$var$load("76n7a"),
    $318b743776eb809f$var$load("l253H"),
    $318b743776eb809f$var$load("fliVL"),
    $318b743776eb809f$var$load("7nF5c")
]).then(()=>parcelRequire('f3Kyg'));

});



parcelRegister("a5XVU", function(module, exports) {

$parcel$export(module.exports, "arjSummaryEmbedRouteEntry", () => $6fb04257162ebb90$export$bdc2c75e02c29d7);

var $cSD7y = parcelRequire("cSD7y");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $lv9xW = parcelRequire("lv9xW");

var $3RJkv = parcelRequire("3RJkv");

var $2Ql51 = parcelRequire("2Ql51");

var $7BjJ7 = parcelRequire("7BjJ7");

var $5lsNZ = parcelRequire("5lsNZ");

var $4R6GH = parcelRequire("4R6GH");

var $lkFvK = parcelRequire("lkFvK");

var $739vE = parcelRequire("739vE");

var $k7MTs = parcelRequire("k7MTs");
const $6fb04257162ebb90$var$planSummaryEmbedRouteEntry = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $739vE.planSummaryEntryPoint)
});
const $6fb04257162ebb90$export$bdc2c75e02c29d7 = (0, $7NszV.createEntry)((0, $7BjJ7.arjSummaryEmbedRoute), ()=>({
        group: 'software',
        component: (0, $cSD7y.componentWithFG)('smart_links_for_plans', (0, $k7MTs.PlanSummaryEmbedPage), (0, $5lsNZ.default)),
        entryPoint: ()=>(0, $4R6GH.fg)('migrate_plans_to_entrypoints') ? $6fb04257162ebb90$var$planSummaryEmbedRouteEntry : undefined,
        layout: (0, $aPfsS.createLayout)({
            isChromeless: true
        }),
        resources: [
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $lv9xW.advancedRoadmapsSummaryDataResource),
            (0, $2Ql51.themePreferenceResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        forPaint: [
            (0, $k7MTs.LazyPlanSummaryEmbed)
        ]
    }));

});
parcelRegister("lv9xW", function(module, exports) {

$parcel$export(module.exports, "advancedRoadmapsSummaryDataResource", () => $f87ae7e2901ac155$export$f9061628830b5175);
$parcel$export(module.exports, "fetchAdvancedRoadmapsSummaryData", () => $f87ae7e2901ac155$export$2dfe99460dae6bc6);

var $4R6GH = parcelRequire("4R6GH");

var $7f4tk = parcelRequire("7f4tk");

var $2M1hQ = parcelRequire("2M1hQ");

var $5m5rT = parcelRequire("5m5rT");

var $iz4dr = parcelRequire("iz4dr");
// we have to use location.search as we want to get params dynamically and rrr doesn't support it
// more info: https://atlassian-labs.github.io/react-resource-router/#/resources/usage?id=accessing-resource-state-for-another-route-or-url
const $f87ae7e2901ac155$var$getQueryParams = (routerQuery)=>{
    if (typeof window !== 'undefined') return Object.fromEntries(new URLSearchParams(window.location.search));
    return routerQuery;
};
const $f87ae7e2901ac155$export$f9061628830b5175 = (0, $2M1hQ.createResource)({
    type: 'ADVANCED_ROADMAPS_SUMMARY_DATA',
    getKey: ({ match: match })=>{
        const { params: params } = match;
        if (params.planId != null && params.scenarioId != null) return `${params.planId}:${params.scenarioId}`;
        // Just return fallback string if on a page that doesn't have a planId or scenarioId
        return 'none';
    },
    getData: async ({ match: match, query: query })=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (window.__ARJ_SUMMARY_PAGE_PROMISE__) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const response = window.__ARJ_SUMMARY_PAGE_PROMISE__;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.__ARJ_SUMMARY_PAGE_PROMISE__ = null;
            return response;
        }
        const { params: params } = match;
        return $f87ae7e2901ac155$export$2dfe99460dae6bc6(params, query, (0, $5m5rT.AVAILABLE_CHARTS));
    },
    maxAge: Infinity,
    isBrowserOnly: true
});
const $f87ae7e2901ac155$export$2dfe99460dae6bc6 = async (params, query, chartTypes)=>{
    if (params.planId == null) throw new Error('Unable to get fetch data for ADVANCED_ROADMAPS_SUMMARY_DATA. planId is not defined');
    if ((0, $4R6GH.fg)('smart_links_for_plans')) {
        const dateRange = (0, $iz4dr.validateDateRange)((0, $iz4dr.parseDateRange)($f87ae7e2901ac155$var$getQueryParams(query)));
        const data = await (0, $7f4tk.default)('/rest/jpo/1.0/summary/data', {
            method: 'POST',
            body: JSON.stringify({
                planId: params.planId,
                scenarioId: params.scenarioId,
                chartTypes: chartTypes,
                ...dateRange ? {
                    dateRange: dateRange
                } : {}
            })
        });
        return dateRange ? {
            ...data,
            customDateRange: dateRange
        } : data;
    }
    const { startDate: startDate, endDate: endDate } = $f87ae7e2901ac155$var$getQueryParams(query);
    const customDateRangeParams = startDate && endDate ? {
        startDate: startDate,
        endDate: endDate
    } : {};
    const data = await (0, $7f4tk.default)('/rest/jpo/1.0/summary/data', {
        method: 'POST',
        body: JSON.stringify({
            planId: params.planId,
            scenarioId: params.scenarioId,
            chartTypes: chartTypes,
            ...customDateRangeParams
        })
    });
    return data;
};

});
parcelRegister("5m5rT", function(module, exports) {

$parcel$export(module.exports, "CHART_TYPES", () => $d315f648a94f47c0$export$3251435144ca69e2);
$parcel$export(module.exports, "AVAILABLE_CHARTS", () => $d315f648a94f47c0$export$79cf9c14f738d70b);
$parcel$export(module.exports, "SCHEDULING_MODES", () => $d315f648a94f47c0$export$92daf59e30346cd2);
$parcel$export(module.exports, "CAPACITY_UNIT", () => $d315f648a94f47c0$export$494e761f17fc60a9);
$parcel$export(module.exports, "SPRINT_STATE", () => $d315f648a94f47c0$export$38e437924c2adbda);
const $d315f648a94f47c0$export$3251435144ca69e2 = {
    statusCategory: 'STATUS_CATEGORY',
    issueProgress: 'ISSUE_PROGRESS',
    teamProgress: 'TEAM_PROGRESS',
    teamCapacity: 'TEAM_CAPACITY',
    blockers: 'BLOCKERS',
    highestPriority: 'HIGHEST_PRIORITY',
    unassignedIssues: 'UNASSIGNED_ISSUES',
    overlappingBlockers: 'OVERLAPPING_BLOCKERS',
    overdue: 'OVERDUE'
};
const $d315f648a94f47c0$export$79cf9c14f738d70b = [
    $d315f648a94f47c0$export$3251435144ca69e2.statusCategory,
    $d315f648a94f47c0$export$3251435144ca69e2.issueProgress,
    $d315f648a94f47c0$export$3251435144ca69e2.teamProgress,
    $d315f648a94f47c0$export$3251435144ca69e2.teamCapacity,
    $d315f648a94f47c0$export$3251435144ca69e2.blockers,
    $d315f648a94f47c0$export$3251435144ca69e2.highestPriority,
    $d315f648a94f47c0$export$3251435144ca69e2.unassignedIssues,
    $d315f648a94f47c0$export$3251435144ca69e2.overlappingBlockers,
    $d315f648a94f47c0$export$3251435144ca69e2.overdue
];
const $d315f648a94f47c0$export$92daf59e30346cd2 = {
    SCRUM: 'Scrum',
    KANBAN: 'Kanban'
};
const $d315f648a94f47c0$export$494e761f17fc60a9 = {
    HOURS: 'HOURS',
    POINTS: 'STORY_POINTS',
    DAYS: 'DAYS'
};
const $d315f648a94f47c0$export$38e437924c2adbda = {
    CLOSED: 'CLOSED',
    ACTIVE: 'ACTIVE',
    FUTURE: 'FUTURE'
};

});

parcelRegister("iz4dr", function(module, exports) {

$parcel$export(module.exports, "parseDateRange", () => $8d575024c745c5c9$export$1cd7060bc72a318c);
$parcel$export(module.exports, "validateDateRange", () => $8d575024c745c5c9$export$b3e10550232e39db);
/**
 * Most of the code here is duplicated from `@atlassian/portfolio-3-summary-page`. We do not want to depend on all
 * the code from that package, but we want to parse and validate the date range before sending to the backend.
 */ 
var $gZ6zR = parcelRequire("gZ6zR");
const $8d575024c745c5c9$export$637d8b0948b783c7 = {
    [(0, $gZ6zR.DATE_UNITS).DAYS]: 3650,
    [(0, $gZ6zR.DATE_UNITS).WEEKS]: 520,
    [(0, $gZ6zR.DATE_UNITS).MONTHS]: 120
};
const $8d575024c745c5c9$export$cf70eebe96d0cb07 = (type)=>{
    switch(type){
        case (0, $gZ6zR.CUSTOM_TIME_RANGE_TYPES).FIXED:
        case (0, $gZ6zR.CUSTOM_TIME_RANGE_TYPES).RELATIVE:
            return type;
        default:
            return undefined;
    }
};
const $8d575024c745c5c9$export$6bf0e8cf8e1d780d = (value)=>{
    if (value === undefined) return undefined;
    const parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? undefined : parsed;
};
const $8d575024c745c5c9$export$c777dd44ece05114 = (unit)=>{
    switch(unit){
        case (0, $gZ6zR.DATE_UNITS).DAYS:
        case (0, $gZ6zR.DATE_UNITS).WEEKS:
        case (0, $gZ6zR.DATE_UNITS).MONTHS:
            return unit;
        default:
            return undefined;
    }
};
const $8d575024c745c5c9$export$1cd7060bc72a318c = (query)=>{
    const { fromDate: fromDate, toDate: toDate, toNow: toNow, fromNow: fromNow, toNowUnit: toNowUnit, fromNowUnit: fromNowUnit, dateRangeType: dateRangeType } = query;
    return {
        typeOfCustomDateRange: $8d575024c745c5c9$export$cf70eebe96d0cb07(dateRangeType),
        fromDate: $8d575024c745c5c9$export$6bf0e8cf8e1d780d(fromDate),
        toDate: $8d575024c745c5c9$export$6bf0e8cf8e1d780d(toDate),
        fromNowUnitCount: $8d575024c745c5c9$export$6bf0e8cf8e1d780d(fromNow),
        toNowUnitCount: $8d575024c745c5c9$export$6bf0e8cf8e1d780d(toNow),
        fromNowUnit: $8d575024c745c5c9$export$c777dd44ece05114(fromNowUnit),
        toNowUnit: $8d575024c745c5c9$export$c777dd44ece05114(toNowUnit)
    };
};
const $8d575024c745c5c9$export$68346777682e262 = (count, unit)=>{
    if (count === undefined || unit === undefined) return false;
    return count >= 0 && count <= $8d575024c745c5c9$export$637d8b0948b783c7[unit];
};
const $8d575024c745c5c9$export$1ba31c57b50b4374 = (timestamp)=>{
    if (timestamp === undefined) return false;
    const date = new Date(timestamp);
    return !Number.isNaN(date.getTime());
};
const $8d575024c745c5c9$export$b3e10550232e39db = (dateRange)=>{
    const { fromDate: fromDate, toDate: toDate, toNowUnitCount: toNowUnitCount, toNowUnit: toNowUnit, fromNowUnitCount: fromNowUnitCount, fromNowUnit: fromNowUnit, typeOfCustomDateRange: typeOfCustomDateRange } = dateRange;
    if (typeOfCustomDateRange === (0, $gZ6zR.CUSTOM_TIME_RANGE_TYPES).RELATIVE && $8d575024c745c5c9$export$68346777682e262(toNowUnitCount, toNowUnit) && $8d575024c745c5c9$export$68346777682e262(fromNowUnitCount, fromNowUnit)) return {
        toNowUnitCount: toNowUnitCount,
        toNowUnit: toNowUnit,
        fromNowUnitCount: fromNowUnitCount,
        fromNowUnit: fromNowUnit,
        typeOfCustomDateRange: typeOfCustomDateRange
    };
    if (typeOfCustomDateRange === (0, $gZ6zR.CUSTOM_TIME_RANGE_TYPES).FIXED && $8d575024c745c5c9$export$1ba31c57b50b4374(fromDate) && $8d575024c745c5c9$export$1ba31c57b50b4374(toDate)) return {
        fromDate: fromDate,
        toDate: toDate,
        typeOfCustomDateRange: typeOfCustomDateRange
    };
    return undefined;
};

});
parcelRegister("gZ6zR", function(module, exports) {

$parcel$export(module.exports, "CUSTOM_TIME_RANGE_TYPES", () => $ad83cd0410dc011b$export$78e07fecfaf51c7b);
$parcel$export(module.exports, "DATE_UNITS", () => $ad83cd0410dc011b$export$c99d20cdba4a5739);
$parcel$export(module.exports, "IssueStatus", () => $ad83cd0410dc011b$export$559eb15a98685419);
$parcel$export(module.exports, "BlockType", () => $ad83cd0410dc011b$export$48808c686fe495c4);
const $ad83cd0410dc011b$export$78e07fecfaf51c7b = {
    FIXED: 'fixed',
    RELATIVE: 'relative'
};
const $ad83cd0410dc011b$export$c99d20cdba4a5739 = {
    DAYS: 'days',
    MONTHS: 'months',
    WEEKS: 'weeks'
};
const $ad83cd0410dc011b$export$559eb15a98685419 = {
    TODO: 'TODO',
    IN_PROGRESS: 'IN_PROGRESS',
    DONE: 'DONE'
};
const $ad83cd0410dc011b$export$de194318c6dccbc1 = {
    INITIATIVE: 'INITIATIVE',
    EPIC: 'EPIC'
};
const $ad83cd0410dc011b$export$48808c686fe495c4 = {
    DELAY_WORK: 'DELAY_WORK',
    CRITICAL_PATH: 'CRITICAL_PATH',
    BLOCK_WORK: 'BLOCK_WORK'
};

});



parcelRegister("7BjJ7", function(module, exports) {

$parcel$export(module.exports, "arjSummaryEmbedRoute", () => $426fb5656e35864d$export$126053e8fb441b66);
const $426fb5656e35864d$export$126053e8fb441b66 = {
    name: 'software-plan-summary-embed',
    path: '/jira/plans/:planId/scenarios/:scenarioId/summary/embed'
};

});

parcelRegister("739vE", function(module, exports) {

$parcel$export(module.exports, "planSummaryEntryPoint", () => $dd4685bcee1d8b30$export$82d8368ec1a526b);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $dd4685bcee1d8b30$export$82d8368ec1a526b = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        if (!false) return (parcelRequire("irZA1"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "c48db9c0"
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("lUhpq", function(module, exports) {

$parcel$export(module.exports, "arjTimelineEmbedRouteEntry", () => $f243e346f149e756$export$a977d398db1904ff);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $2Ql51 = parcelRequire("2Ql51");

var $in8iE = parcelRequire("in8iE");

var $5lsNZ = parcelRequire("5lsNZ");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $lkFvK = parcelRequire("lkFvK");

var $4Xa0b = parcelRequire("4Xa0b");
const $f243e346f149e756$var$planTimelineEmbedRouteEntry = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $4Xa0b.planTimelineEntryPoint)
});

// Update to default import when cleaning getWillShowNav4
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f243e346f149e756$var$LazyPlanTimelineEmbed = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("ayUhG")).then(({ PlanTimelineWithoutHeader: PlanTimelineWithoutHeader })=>PlanTimelineWithoutHeader)), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-timeline/index-old.tsx"
});
const $f243e346f149e756$var$PlanTimelineEmbedPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f243e346f149e756$var$LazyPlanTimelineEmbed,
        pageId: "plan-timeline-embed",
        shouldShowSpinner: true
    });
const $f243e346f149e756$export$a977d398db1904ff = (0, $7NszV.createEntry)((0, $in8iE.arjTimelineEmbedRoute), ()=>({
        group: 'software',
        component: (0, $cSD7y.componentWithFG)('smart_links_for_plans', $f243e346f149e756$var$PlanTimelineEmbedPage, (0, $5lsNZ.default)),
        entryPoint: ()=>(0, $4R6GH.fg)('migrate_plans_to_entrypoints') ? $f243e346f149e756$var$planTimelineEmbedRouteEntry : undefined,
        layout: (0, $aPfsS.createLayout)({
            isChromeless: true
        }),
        resources: [
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource),
            (0, $2Ql51.themePreferenceResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        forPaint: [
            $f243e346f149e756$var$LazyPlanTimelineEmbed
        ]
    }));

});
parcelRegister("in8iE", function(module, exports) {

$parcel$export(module.exports, "arjTimelineEmbedRoute", () => $2ec71a69a22a9944$export$aadc28402ef87b84);
const $2ec71a69a22a9944$export$aadc28402ef87b84 = {
    name: 'software-advanced-roadmaps-embed',
    path: '/jira/plans/:planId/scenarios/:scenarioId/timeline/embed'
};

});

parcelRegister("4Xa0b", function(module, exports) {

$parcel$export(module.exports, "planTimelineEntryPoint", () => $dfb41ee95126f54b$export$a36e3fca8afefb5b);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $dfb41ee95126f54b$export$a36e3fca8afefb5b = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        if (!false) return (parcelRequire("7fXh6"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "0b69767e"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("7fXh6", function(module, exports) {

let $5487e9e12deacfcc$var$load = (parcelRequire("28QjX"))(4);




module.exports = Promise.all([
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $5487e9e12deacfcc$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $5487e9e12deacfcc$var$load("7B2gt")
        ]);
    }),
    $5487e9e12deacfcc$var$load("7mIf9"),
    $5487e9e12deacfcc$var$load("jXweD"),
    $5487e9e12deacfcc$var$load("76n7a"),
    $5487e9e12deacfcc$var$load("l253H"),
    $5487e9e12deacfcc$var$load("ffQaD"),
    $5487e9e12deacfcc$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("hm7Q6"), 4)),
    $5487e9e12deacfcc$var$load("fliVL"),
    $5487e9e12deacfcc$var$load("d57pj")
]).then(()=>parcelRequire('iL9n8'));

});


parcelRegister("ayUhG", function(module, exports) {

let $7b08bd40768b6aaf$var$load = (parcelRequire("28QjX"))(4);




module.exports = Promise.all([
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $7b08bd40768b6aaf$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $7b08bd40768b6aaf$var$load("7B2gt")
        ]);
    }),
    $7b08bd40768b6aaf$var$load("7mIf9"),
    $7b08bd40768b6aaf$var$load("jXweD"),
    $7b08bd40768b6aaf$var$load("76n7a"),
    $7b08bd40768b6aaf$var$load("l253H"),
    $7b08bd40768b6aaf$var$load("ffQaD"),
    $7b08bd40768b6aaf$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("l8ypy"), 4)),
    $7b08bd40768b6aaf$var$load("fliVL"),
    $7b08bd40768b6aaf$var$load("ia8V8")
]).then(()=>parcelRequire('aT9Sm'));

});


parcelRegister("43Rln", function(module, exports) {

$parcel$export(module.exports, "legacyPlanPageRedirectRouteEntry", () => $10eae15c25a3521c$export$e9cfdb950d40e917);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $4e0eu = parcelRequire("4e0eu");

var $3ibi7 = parcelRequire("3ibi7");

var $g6wgl = parcelRequire("g6wgl");
const $10eae15c25a3521c$export$e9cfdb950d40e917 = (0, $7NszV.createEntry)((0, $4e0eu.legacyPlanPageRedirectRoute), ()=>({
        group: 'software',
        component: (0, $3ibi7.RedirectLegacyPlanPage),
        isRedirect: true,
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $c3WQb.advancedRoadmapsScenarioIdResource)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $g6wgl.LazyPlanTimeline)
        ]
    }));

});
parcelRegister("4e0eu", function(module, exports) {

$parcel$export(module.exports, "legacyPlanPageRedirectRoute", () => $72e984bd321d5543$export$1e324bd9675918a8);
const $72e984bd321d5543$export$1e324bd9675918a8 = {
    name: 'software-advanced-roadmaps-redirect',
    path: '/secure/PortfolioPlanView.jspa'
};

});

parcelRegister("3ibi7", function(module, exports) {

$parcel$export(module.exports, "RedirectLegacyPlanPage", () => $3e6624904a2f18eb$export$c3e4fda2290a52bf);
$parcel$export(module.exports, "RedirectPlanPageWithoutScenarioId", () => $3e6624904a2f18eb$export$ff420400c9900835);
$parcel$export(module.exports, "RedirectPlanPageWithoutScenarioIdLoadQuery", () => $3e6624904a2f18eb$export$e57364775e9e9634);

var $697YZ = parcelRequire("697YZ");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $kb4zh = parcelRequire("kb4zh");

var $c3WQb = parcelRequire("c3WQb");

var $ds5qV = parcelRequire("ds5qV");

var $5W2CW = parcelRequire("5W2CW");

var $2YP9W = parcelRequire("2YP9W");
var $doZTA = parcelRequire("doZTA");

var $697YZ = parcelRequire("697YZ");

var $9OXo1 = parcelRequire("9OXo1");
const $3e6624904a2f18eb$var$PERSIST_SEARCH_PARAMS = [
    'search'
];
const $3e6624904a2f18eb$var$RedirectLegacyPlanPageWithoutScenarioId = ()=>{
    const [{ query: query }] = (0, $doZTA.useRouter)();
    const { data: data, loading: loading } = (0, $2YP9W.useResource)((0, $c3WQb.advancedRoadmapsScenarioIdResource));
    if (loading || data === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: `/jira/plans/${query.id}/scenarios/${data.scenarioId}`,
        persistSearchParams: $3e6624904a2f18eb$var$PERSIST_SEARCH_PARAMS
    });
};
const $3e6624904a2f18eb$export$c3e4fda2290a52bf = ()=>{
    const [{ query: query }] = (0, $doZTA.useRouter)();
    const { id: id, sid: sid } = query;
    if (Number.isNaN(Number.parseFloat(sid))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3e6624904a2f18eb$var$RedirectLegacyPlanPageWithoutScenarioId, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: `/jira/plans/${id}/scenarios/${sid}`,
        persistSearchParams: $3e6624904a2f18eb$var$PERSIST_SEARCH_PARAMS
    });
};
const $3e6624904a2f18eb$export$ff420400c9900835 = ()=>{
    const [{ match: match }] = (0, $doZTA.useRouter)();
    const { planId: planId } = match.params;
    if (planId === null || planId === undefined || Number.isNaN(Number.parseFloat(planId))) throw new Error('Plan cannot be loaded without planId');
    const { data: data, loading: loading } = (0, $2YP9W.useResource)((0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource));
    if (loading || data === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null);
    if (!data.success) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5W2CW.ErrorScreen), {
        errorMessage: data.errorMessage
    });
    if (data.scenarioId === null || data.scenarioId === undefined || typeof data.scenarioId === 'string' && Number.isNaN(Number.parseFloat(data.scenarioId))) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: `/jira/plans/${planId}/scenarios/${data.scenarioId}`,
        persistSearchParams: $3e6624904a2f18eb$var$PERSIST_SEARCH_PARAMS
    });
};
const $3e6624904a2f18eb$export$b2194d886d9f3b64 = ({ queryRef: queryRef, planId: planId })=>{
    const gqlData = (0, $8Uumt.usePreloadedQuery)((0, $697YZ.default), queryRef);
    const { data: data, loading: loading } = (0, $2YP9W.useResource)((0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource));
    const defaultTabUrl = gqlData?.jira?.planById?.defaultNavigationItem?.url;
    if (defaultTabUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: defaultTabUrl,
        persistSearchParams: $3e6624904a2f18eb$var$PERSIST_SEARCH_PARAMS
    });
    // Fallback if can not get defaultTabUrl
    if (loading || data === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null);
    if (!data.success) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5W2CW.ErrorScreen), {
        errorMessage: data.errorMessage
    });
    if (data.scenarioId === null || data.scenarioId === undefined || typeof data.scenarioId === 'string' && Number.isNaN(Number.parseFloat(data.scenarioId))) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: `/jira/plans/${planId}/scenarios/${data.scenarioId}`,
        persistSearchParams: $3e6624904a2f18eb$var$PERSIST_SEARCH_PARAMS
    });
};
const $3e6624904a2f18eb$export$e57364775e9e9634 = ()=>{
    const [{ match: match }] = (0, $doZTA.useRouter)();
    const { planId: planId } = match.params;
    if (planId === null || planId === undefined || Number.isNaN(Number.parseFloat(planId))) throw new Error('Plan cannot be loaded without planId');
    const { cloudId: cloudId, activationId: activationId } = (0, $9OXo1.useTenantContext)();
    const [queryRef, loadQuery, disposeQuery] = (0, $8Uumt.useQueryLoader)((0, $697YZ.default));
    (0, $5uXOq.useEffect)(()=>{
        loadQuery({
            planId: `ari:cloud:jira:${cloudId}:plan/activation/${activationId}/${planId}`
        }, {
            fetchPolicy: 'store-or-network'
        });
        return disposeQuery;
    }, [
        loadQuery,
        disposeQuery,
        cloudId,
        activationId,
        planId
    ]);
    return queryRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3e6624904a2f18eb$export$b2194d886d9f3b64, {
        queryRef: queryRef,
        planId: planId
    }) : null;
};

});
parcelRegister("697YZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $da05f469fe76f276$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<513d91abcf431d67cd831934eb3cdd81>>
 * @relayHash c7ba33b8e7695997c7bbf9e29b42c7ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7b22213e57ba6874b345876f3c35d0dda118f459e6007f6c559d80ba94b6d1fe
const $da05f469fe76f276$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "planId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "planId"
        }
    ], v2 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "JiraNavigationItem",
        "abstractKey": "__isJiraNavigationItem"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "planNoScenarioQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraPlan",
                            "kind": "LinkedField",
                            "name": "planById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "LinkedField",
                                        "name": "defaultNavigationItem",
                                        "plural": false,
                                        "selections": [
                                            v2 /*: any*/ 
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.planById.defaultNavigationItem"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "planNoScenarioQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraPlan",
                            "kind": "LinkedField",
                            "name": "planById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "defaultNavigationItem",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ 
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7b22213e57ba6874b345876f3c35d0dda118f459e6007f6c559d80ba94b6d1fe",
            "metadata": {},
            "name": "planNoScenarioQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$da05f469fe76f276$var$node.hash = "7791279196ac8025a83cda3fc2b29b08";
var $da05f469fe76f276$export$2e2bcd8739ae039 = $da05f469fe76f276$var$node;

});

parcelRegister("5W2CW", function(module, exports) {

$parcel$export(module.exports, "ErrorScreen", () => $50454f3b2d1014d6$export$42f84e610f279c31);

var $5uXOq = parcelRequire("5uXOq");

var $38Y30 = parcelRequire("38Y30");


var $6AaZy = parcelRequire("6AaZy");

var $1v2QX = parcelRequire("1v2QX");

var $jMY1T = parcelRequire("jMY1T");
const $50454f3b2d1014d6$export$42f84e610f279c31 = ({ errorMessage: errorMessage, isEmbedded: isEmbedded = false, planId: planId })=>{
    /**
	 * Clearing the early-preload promises here otherwise they get carried on to the following plan loads.
	 *
	 * The SPA app renders the ErrorScreen instead of the PlanApp when the validation fails,
	 * hence the early-preload promises did not get cleaned up.
	 */ // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    delete window.__ARJ_BACKLOG_PROMISE__;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    delete window.__ARJ_INFO_METADATA_PROMISE__;
    switch(errorMessage){
        case 0, $b31dd89598859846$export$aa64437890e7b596:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38Y30.RedirectToLoginPage), null);
        case 0, $b31dd89598859846$export$3fe2400c9d24940d:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6AaZy.AsyncLicenseViolationErrorPage), {
                isEmbedded: isEmbedded
            });
        case 0, $b31dd89598859846$export$4589763db20bfd7f:
        case 0, $b31dd89598859846$export$7e6358a0c21dff8c:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jMY1T.AsyncNotFoundErrorPage), {
                entity: (0, $b31dd89598859846$export$c303e491e026ebc6),
                isEmbedded: isEmbedded
            });
        case 0, $b31dd89598859846$export$6519152a5f0e081:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jMY1T.AsyncNotFoundErrorPage), {
                entity: (0, $b31dd89598859846$export$9b928fc5e710e864),
                isEmbedded: isEmbedded,
                planId: planId
            });
        case 0, $b31dd89598859846$export$6128dc888243fa0a:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1v2QX.AsyncNoPlanPermissionErrorPage), {
                isEmbedded: isEmbedded
            });
        default:
            return null;
    }
};

});
parcelRegister("38Y30", function(module, exports) {

$parcel$export(module.exports, "RedirectToLoginPage", () => $08f8c3f776d557a9$export$938182bd3fddc3a8);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
var $ieDtd = parcelRequire("ieDtd");
var $doZTA = parcelRequire("doZTA");
const $08f8c3f776d557a9$export$3da29de62ed7a388 = ({ to: to })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("script", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `window.location.assign("${to}")`
        }
    });
$08f8c3f776d557a9$export$3da29de62ed7a388.displayName = 'InlineRedirect';
const $08f8c3f776d557a9$export$938182bd3fddc3a8 = ()=>{
    const [{ location: { pathname: pathname, search: search } }] = (0, $doZTA.useRouter)();
    const redirectUrl = pathname + search;
    const encodedRedirectUrl = encodeURIComponent(redirectUrl);
    let path = `/login.jsp?os_destination=${encodedRedirectUrl}`;
    const parentProductQueryName = 'parentProduct';
    const [parentProduct] = (0, $ieDtd.useQueryParam)(parentProductQueryName);
    if (pathname.endsWith('/embed')) {
        const searchParams = new URLSearchParams(search);
        // We need to remove parentProduct param as it is only used in embed urls
        searchParams.delete(parentProductQueryName);
        /**
		 * encodedLink is the link to the non embedded version of the embed url.
		 * So, we strip out the /embed suffix from path
		 */ let encodedLink = encodeURIComponent(`${pathname.slice(0, -6)}?${searchParams}`);
        /**
		 * this is the specific case for create issue embed, where we need to redirect
		 * user to your-work page with create issue as true to open GIC by default.
		 * We will remove this when we FPIC exp implemented for GIC
		 */ if (pathname.includes('/issues/create')) encodedLink = encodeURIComponent('/jira/your-work?createissue=true');
        const encodedParentProduct = encodeURIComponent(parentProduct || '');
        path = `/jira-login/embed?destination=${encodedRedirectUrl}&link=${encodedLink}&parentProduct=${encodedParentProduct}`;
    }
    return false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08f8c3f776d557a9$export$3da29de62ed7a388, {
        to: path
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: path
    });
};

});

const $b31dd89598859846$export$aa64437890e7b596 = 'permission-violation';
const $b31dd89598859846$export$3fe2400c9d24940d = 'license-violation';
const $b31dd89598859846$export$4589763db20bfd7f = 'plan-not-found';
const $b31dd89598859846$export$6519152a5f0e081 = 'scenario-not-found';
const $b31dd89598859846$export$7e6358a0c21dff8c = 'report-not-found';
const $b31dd89598859846$export$6128dc888243fa0a = 'no-plan-permission';
const $b31dd89598859846$export$c303e491e026ebc6 = 'PLAN';
const $b31dd89598859846$export$9b928fc5e710e864 = 'SCENARIO';

parcelRegister("6AaZy", function(module, exports) {

$parcel$export(module.exports, "AsyncLicenseViolationErrorPage", () => $05d56fdddce8137e$export$f5d9764f07badc4d);

var $5uXOq = parcelRequire("5uXOq");

var $kb4zh = parcelRequire("kb4zh");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $05d56fdddce8137e$var$LazyLicenseViolationErrorPage = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("9aruW")), {
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/error-screens/license-violation/index.tsx"
});
const $05d56fdddce8137e$export$f5d9764f07badc4d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "arj-license-violation-page",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($05d56fdddce8137e$var$LazyLicenseViolationErrorPage, props));

});
parcelRegister("9aruW", function(module, exports) {

let $6aca60c16208ee3b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6aca60c16208ee3b$var$load("dk1NB").then(()=>parcelRequire('cGdIS'));

});


parcelRegister("1v2QX", function(module, exports) {

$parcel$export(module.exports, "AsyncNoPlanPermissionErrorPage", () => $d08fb773ac6c1816$export$e595d2c5dfcb1d5a);

var $5uXOq = parcelRequire("5uXOq");

var $kb4zh = parcelRequire("kb4zh");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $d08fb773ac6c1816$var$LazyNoPlanPermissionErrorPage = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("PK1Hc")), {
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/error-screens/no-plan-permission/index.tsx"
});
const $d08fb773ac6c1816$export$e595d2c5dfcb1d5a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "arj-no-plan-permission",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d08fb773ac6c1816$var$LazyNoPlanPermissionErrorPage, props));

});
parcelRegister("PK1Hc", function(module, exports) {

let $09b87768e2a44421$var$load = (parcelRequire("28QjX"))(4);
module.exports = $09b87768e2a44421$var$load("gqZrF").then(()=>parcelRequire('dycHB'));

});


parcelRegister("jMY1T", function(module, exports) {

$parcel$export(module.exports, "AsyncNotFoundErrorPage", () => $900bf2ccc30cc7be$export$8f6c907860218fdc);

var $5uXOq = parcelRequire("5uXOq");

var $kb4zh = parcelRequire("kb4zh");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $900bf2ccc30cc7be$var$LazyNotFoundErrorPage = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("cddga")), {
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/error-screens/not-found/index.tsx"
});
const $900bf2ccc30cc7be$export$8f6c907860218fdc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "arj-not-found-page",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($900bf2ccc30cc7be$var$LazyNotFoundErrorPage, props));

});
parcelRegister("cddga", function(module, exports) {

let $8e40fc0c9dd886fa$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8e40fc0c9dd886fa$var$load("2kKFX").then(()=>parcelRequire('3jte6'));

});




parcelRegister("g6wgl", function(module, exports) {

$parcel$export(module.exports, "LazyPlanTimeline", () => $c8bd5810f2180a4a$export$bf48e5f1529ddaeb);
$parcel$export(module.exports, "default", () => $c8bd5810f2180a4a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $c8bd5810f2180a4a$export$bf48e5f1529ddaeb = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("ayUhG"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-timeline/index-old.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c8bd5810f2180a4a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $c8bd5810f2180a4a$export$bf48e5f1529ddaeb,
        pageId: "plan-timeline",
        shouldShowSpinner: true
    });

});


parcelRegister("6Z4jF", function(module, exports) {

$parcel$export(module.exports, "legacyPlanReportPageRedirectRouteEntry", () => $be1254c729965d54$export$c2a4c5c6576a704c);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $j5aum = parcelRequire("j5aum");

var $5WheG = parcelRequire("5WheG");

var $g6wgl = parcelRequire("g6wgl");
const $be1254c729965d54$export$c2a4c5c6576a704c = (0, $7NszV.createEntry)((0, $j5aum.legacyPlanReportPageRedirectRoute), ()=>({
        group: 'software',
        component: (0, $5WheG.default),
        isRedirect: true,
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $g6wgl.LazyPlanTimeline)
        ]
    }));

});
parcelRegister("j5aum", function(module, exports) {

$parcel$export(module.exports, "legacyPlanReportPageRedirectRoute", () => $c3430a8e44cc7ca2$export$7747547e845a016c);
const $c3430a8e44cc7ca2$export$7747547e845a016c = {
    name: 'software-advanced-roadmaps-redirect',
    path: '/secure/PortfolioReportView.jspa'
};

});

parcelRegister("5WheG", function(module, exports) {

$parcel$export(module.exports, "default", () => $135d7141d14abe41$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ds5qV = parcelRequire("ds5qV");

var $doZTA = parcelRequire("doZTA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$135d7141d14abe41$export$2e2bcd8739ae039 = ()=>{
    const [{ query: query }] = (0, $doZTA.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: `/jira/plans/reports/${query.r}`,
        persistSearchParams: false
    });
};

});


parcelRegister("eLT92", function(module, exports) {

$parcel$export(module.exports, "planExportPageRouteEntry", () => $e17ef7a70aea4a64$export$d751e3552b21c604);

var $5uXOq = parcelRequire("5uXOq");

var $7NszV = parcelRequire("7NszV");

var $c3WQb = parcelRequire("c3WQb");

var $dht4a = parcelRequire("dht4a");

var $5j7Th = parcelRequire("5j7Th");

var $hGLha = parcelRequire("hGLha");

var $g6wgl = parcelRequire("g6wgl");
/**
 * Export Page
 */ const $e17ef7a70aea4a64$var$ExportPageComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hGLha.LazyAdvancedRoadmapsPlanExport), null);
const $e17ef7a70aea4a64$var$ExportPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e17ef7a70aea4a64$var$ExportPageComponent,
        pageId: "advanced-roadmap",
        shouldShowSpinner: true
    });
const $e17ef7a70aea4a64$export$d751e3552b21c604 = (0, $7NszV.createEntry)((0, $dht4a.planExportPageRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-scenario-export',
        component: $e17ef7a70aea4a64$var$ExportPage,
        layout: {
            isChromeless: true,
            globalComponents: [],
            rightSidebars: []
        },
        resources: [
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource)
        ],
        forPaint: [
            (0, $g6wgl.LazyPlanTimeline)
        ]
    }));

});
parcelRegister("dht4a", function(module, exports) {

$parcel$export(module.exports, "planExportPageRoute", () => $76c19eff2b41ddc4$export$2ca5fe6f9ab466c1);
const $76c19eff2b41ddc4$export$2ca5fe6f9ab466c1 = {
    name: 'software-advanced-roadmaps',
    path: '/jira/plans/:planId/scenarios/:scenarioId/export'
};

});

parcelRegister("hGLha", function(module, exports) {

$parcel$export(module.exports, "LazyAdvancedRoadmapsPlanExport", () => $b6ed3ac1658c948e$export$890fb5003e472449);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $b6ed3ac1658c948e$export$890fb5003e472449 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("8Q4YM"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b6ed3ac1658c948e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $b6ed3ac1658c948e$export$890fb5003e472449,
        pageId: "advanced-roadmaps-plan",
        shouldShowSpinner: true
    });

});
parcelRegister("8Q4YM", function(module, exports) {

let $66f70ad9ff451f35$var$load = (parcelRequire("28QjX"))(4);




module.exports = Promise.all([
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $66f70ad9ff451f35$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $66f70ad9ff451f35$var$load("7B2gt")
        ]);
    }),
    $66f70ad9ff451f35$var$load("7mIf9"),
    $66f70ad9ff451f35$var$load("jXweD"),
    $66f70ad9ff451f35$var$load("76n7a"),
    $66f70ad9ff451f35$var$load("l253H"),
    $66f70ad9ff451f35$var$load("ffQaD"),
    $66f70ad9ff451f35$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("fqYxj"), 4)),
    $66f70ad9ff451f35$var$load("fliVL"),
    $66f70ad9ff451f35$var$load("jdjwS")
]).then(()=>parcelRequire('ecw8s'));

});



parcelRegister("cgOe5", function(module, exports) {

$parcel$export(module.exports, "planPageRouteEntry", () => $877bd5b2a7f04d5c$export$f85a75f1604118ff);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $eG65S = parcelRequire("eG65S");

var $aPfsS = parcelRequire("aPfsS");

var $451ix = parcelRequire("451ix");

var $g6wgl = parcelRequire("g6wgl");

var $caKhF = parcelRequire("caKhF");
// This redirect is required to support legacy routes, it should never be deleted
const $877bd5b2a7f04d5c$var$planPageRedirect = (0, $caKhF.withRedirection)((0, $g6wgl.default), {
    to: '/timeline',
    redirectCondition: ()=>true
});
const $877bd5b2a7f04d5c$export$f85a75f1604118ff = (0, $7NszV.createEntry)((0, $eG65S.planPageRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-scenario',
        component: $877bd5b2a7f04d5c$var$planPageRedirect,
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource),
            (0, $c3WQb.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $g6wgl.LazyPlanTimeline)
        ]
    }));

});
parcelRegister("eG65S", function(module, exports) {

$parcel$export(module.exports, "planPageRoute", () => $39ce5190353a5838$export$26495e043d80cccc);
const $39ce5190353a5838$export$26495e043d80cccc = {
    name: 'software-advanced-roadmaps',
    path: '/jira/plans/:planId/scenarios/:scenarioId'
};

});

parcelRegister("451ix", function(module, exports) {

$parcel$export(module.exports, "planLayout", () => $fa12faadb00e7e4f$export$94e1d79bf65579e2);

var $aPfsS = parcelRequire("aPfsS");

var $kxZPA = parcelRequire("kxZPA");

const $fa12faadb00e7e4f$export$b6292b5f7e5b5fad = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("j7JIq")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx"
});
const $fa12faadb00e7e4f$export$94e1d79bf65579e2 = (0, $aPfsS.createLayout)({
    globalComponents: [
        $fa12faadb00e7e4f$export$b6292b5f7e5b5fad
    ]
});

});
parcelRegister("j7JIq", function(module, exports) {

let $dec221ec5c09d66c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dec221ec5c09d66c$var$load("a9fOo").then(()=>parcelRequire('ikoZN'));

});


parcelRegister("caKhF", function(module, exports) {

$parcel$export(module.exports, "withRedirection", () => $25bed75d5ee084fd$export$2c9e4550ef8bdea9);

var $5uXOq = parcelRequire("5uXOq");

var $ds5qV = parcelRequire("ds5qV");

var $doZTA = parcelRequire("doZTA");
function $25bed75d5ee084fd$export$2c9e4550ef8bdea9(Component, { to: to, redirectCondition: redirectCondition }) {
    return ()=>{
        const [{ match: match }] = (0, $doZTA.useRouter)();
        if (match == null || match.params == null || match.params.planId == null || match.params.scenarioId == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
            to: "/jira/plans"
        });
        if (!redirectCondition()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
            to: `/jira/plans/${match.params.planId}/scenarios/${match.params.scenarioId}${to}`
        });
    };
}

});


parcelRegister("2d9QY", function(module, exports) {

$parcel$export(module.exports, "planPageWithoutScenarioIdRouteEntry", () => $c926071780746d94$export$9cbef73b51558ef);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $4qTS7 = parcelRequire("4qTS7");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $3ibi7 = parcelRequire("3ibi7");

var $g6wgl = parcelRequire("g6wgl");
const $c926071780746d94$export$9cbef73b51558ef = (0, $7NszV.createEntry)((0, $4qTS7.planPageWithoutScenarioIdRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-plan',
        component: (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('plan-nav4-fix-plan-listing-redirection') ? (0, $3ibi7.RedirectPlanPageWithoutScenarioIdLoadQuery) : (0, $3ibi7.RedirectPlanPageWithoutScenarioId),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $g6wgl.LazyPlanTimeline)
        ]
    }));

});
parcelRegister("4qTS7", function(module, exports) {

$parcel$export(module.exports, "planPageWithoutScenarioIdRoute", () => $d753ed11fe1ac80a$export$610e14c9c89d0afb);
const $d753ed11fe1ac80a$export$610e14c9c89d0afb = {
    name: 'software-advanced-roadmaps',
    path: '/jira/plans/:planId(\\d+)'
};

});


parcelRegister("jj70V", function(module, exports) {

$parcel$export(module.exports, "planReportPageRouteEntry", () => $7a323ef2c1a2c74a$export$e71031acce6d7e47);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $aZkeA = parcelRequire("aZkeA");

var $3bZgP = parcelRequire("3bZgP");
const $7a323ef2c1a2c74a$export$e71031acce6d7e47 = (0, $7NszV.createEntry)((0, $aZkeA.planReportPageRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-report',
        component: (0, $3bZgP.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $c3WQb.advancedRoadmapsPlanReportPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource),
            (0, $c3WQb.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3bZgP.LazyPlanReport)
        ]
    }));

});
parcelRegister("aZkeA", function(module, exports) {

$parcel$export(module.exports, "planReportPageRoute", () => $082ad5157a706ae9$export$7c8c0761b1ba57bb);
const $082ad5157a706ae9$export$7c8c0761b1ba57bb = {
    name: 'software-advanced-roadmaps',
    path: '/jira/plans/reports/:reportId'
};

});

parcelRegister("3bZgP", function(module, exports) {

$parcel$export(module.exports, "LazyPlanReport", () => $620253f0b511b587$export$fe1fc08f511671db);
$parcel$export(module.exports, "default", () => $620253f0b511b587$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $620253f0b511b587$export$fe1fc08f511671db = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("iU9PP"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-report/index.tsx"
});
const $620253f0b511b587$var$PlanReport = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $620253f0b511b587$export$fe1fc08f511671db,
        pageId: "plan-report",
        shouldShowSpinner: true
    });
var $620253f0b511b587$export$2e2bcd8739ae039 = $620253f0b511b587$var$PlanReport;

});
parcelRegister("iU9PP", function(module, exports) {

let $dc3515f70beb36c4$var$load = (parcelRequire("28QjX"))(4);




module.exports = Promise.all([
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $dc3515f70beb36c4$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $dc3515f70beb36c4$var$load("7B2gt")
        ]);
    }),
    $dc3515f70beb36c4$var$load("7mIf9"),
    $dc3515f70beb36c4$var$load("jXweD"),
    $dc3515f70beb36c4$var$load("76n7a"),
    $dc3515f70beb36c4$var$load("l253H"),
    $dc3515f70beb36c4$var$load("ffQaD"),
    $dc3515f70beb36c4$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("kRzLE"), 4)),
    $dc3515f70beb36c4$var$load("fliVL"),
    $dc3515f70beb36c4$var$load("l8YRe")
]).then(()=>parcelRequire('9UXSF'));

});



parcelRegister("4AqA1", function(module, exports) {

$parcel$export(module.exports, "planSetupPageRouteEntry", () => $3d84c56e2a698202$export$2a24acea4e628148);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $2wBti = parcelRequire("2wBti");

var $2RtMw = parcelRequire("2RtMw");
const $3d84c56e2a698202$export$2a24acea4e628148 = (0, $7NszV.createEntry)((0, $2wBti.planSetupPageRoute), ()=>({
        group: 'software',
        component: (0, $2RtMw.default),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $2RtMw.LazyAdvancedRoadmapsSetup)
        ]
    }));

});
parcelRegister("2wBti", function(module, exports) {

$parcel$export(module.exports, "planSetupPageRoute", () => $08361bcde105abef$export$4815756bb523904e);
const $08361bcde105abef$export$4815756bb523904e = {
    name: 'software-advanced-roadmaps-setup',
    path: '/jira/plans/:planId/setup'
};

});

parcelRegister("2RtMw", function(module, exports) {

$parcel$export(module.exports, "LazyAdvancedRoadmapsSetup", () => $360fed07fa6fa9e9$export$46bb3a1779d7815b);
$parcel$export(module.exports, "default", () => $360fed07fa6fa9e9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $360fed07fa6fa9e9$export$46bb3a1779d7815b = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("iN8tI"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/setup/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$360fed07fa6fa9e9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $360fed07fa6fa9e9$export$46bb3a1779d7815b,
        pageId: "advanced-roadmaps-setup",
        shouldShowSpinner: true
    });

});
parcelRegister("iN8tI", function(module, exports) {

let $dae3613548c045cc$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $dae3613548c045cc$var$load("ffQaD"),
    $dae3613548c045cc$var$load("kvRbA"),
    $dae3613548c045cc$var$load("gtmRO")
]).then(()=>parcelRequire('bF4NR'));

});



parcelRegister("2FVZu", function(module, exports) {

$parcel$export(module.exports, "softwareAdvancedRoadmapsGettingStartedRedirectRouteEntry", () => $c59b8ec61d58752b$export$4652a26319dca4d0);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $cSxBV = parcelRequire("cSxBV");

var $ds5qV = parcelRequire("ds5qV");

var $g6wgl = parcelRequire("g6wgl");
const $c59b8ec61d58752b$export$4652a26319dca4d0 = (0, $7NszV.createEntry)((0, $cSxBV.softwareAdvancedRoadmapsGettingStartedRedirectRoute), ()=>({
        group: 'software',
        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
                to: "/jira/plans?create-sample-plan=true"
            }),
        isRedirect: true,
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $g6wgl.LazyPlanTimeline)
        ]
    }));

});
parcelRegister("cSxBV", function(module, exports) {

$parcel$export(module.exports, "softwareAdvancedRoadmapsGettingStartedRedirectRoute", () => $c9008f0cd6cfcbbf$export$38c76ea9ddc85b3);
const $c9008f0cd6cfcbbf$export$38c76ea9ddc85b3 = {
    name: 'software-advanced-roadmaps-getting-started-redirect',
    path: '/secure/PortfolioGettingStarted.jspa'
};

});


parcelRegister("lGnoq", function(module, exports) {

$parcel$export(module.exports, "softwarePlanCalendarRouteEntry", () => $4711dd8590f23118$export$67c64fea9be584ed);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");


var $87OsA = parcelRequire("87OsA");

var $2BrOV = parcelRequire("2BrOV");

var $8iyFV = parcelRequire("8iyFV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $8JbXO = parcelRequire("8JbXO");

var $kZOse = parcelRequire("kZOse");

var $4R6GH = parcelRequire("4R6GH");

var $bscjm = parcelRequire("bscjm");
const $4711dd8590f23118$export$67c64fea9be584ed = (0, $7NszV.createEntry)((0, $8JbXO.softwarePlanCalendarRoute), ()=>({
        group: 'software',
        ufoName: 'software-advanced-roadmaps-calendar',
        skeleton: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZOse.CalendarSkeleton), null),
        entryPoint () {
            (0, $87OsA.setCapability)((0, $281cbd47ba46dd7d$export$f999749ac7a2cd1));
            return (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? (0, $bscjm.planCalendarPageEntryPoint) : (0, $bscjm.planCalendarPageEntryPointWithoutHorizontalNavigation);
        },
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource),
            (0, $c3WQb.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default),
            horizontal: (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? undefined : (0, $8iyFV.AsyncHorizontalNavPlans),
            onlyShowHorizontalOnNav4: true
        },
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$f999749ac7a2cd1)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("8JbXO", function(module, exports) {

$parcel$export(module.exports, "softwarePlanCalendarRoute", () => $56322e0cc9119168$export$ca4c39d60ec156a2);
const $56322e0cc9119168$export$ca4c39d60ec156a2 = {
    name: 'software-plan-calendar',
    path: '/jira/plans/:planId/scenarios/:scenarioId/calendar'
};

});

parcelRegister("bscjm", function(module, exports) {

$parcel$export(module.exports, "planCalendarPageEntryPoint", () => $49df381ba8f49311$export$6e8a1c5de1f63c61);
$parcel$export(module.exports, "planCalendarPageEntryPointWithoutHorizontalNavigation", () => $49df381ba8f49311$export$71d7feb91869903);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $02tNK = parcelRequire("02tNK");

var $57oLc = parcelRequire("57oLc");
const $49df381ba8f49311$export$6e8a1c5de1f63c61 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $02tNK.calendarEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS,
    horizontalNavigation: (0, $57oLc.plansHorizontalNavigationEntryPoint)
});
const $49df381ba8f49311$export$71d7feb91869903 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $02tNK.calendarEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});

});
parcelRegister("57oLc", function(module, exports) {

$parcel$export(module.exports, "plansHorizontalNavigationEntryPoint", () => $9252b8e5bbb4c32e$export$172a11f0d118de01);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $fEDBv = parcelRequire("fEDBv");

var $2OZhN = parcelRequire("2OZhN");

var $6LB8G = parcelRequire("6LB8G");

var $ktofH = parcelRequire("ktofH");
function $9252b8e5bbb4c32e$var$toPlanScenarioAri({ siteId: siteId, activationId: activationId, planId: planId, scenarioId: scenarioId }) {
    return `ari:cloud:jira:${siteId}:plan-scenario/activation/${activationId}/${planId}/scenario/${scenarioId}`;
}

const $9252b8e5bbb4c32e$export$172a11f0d118de01 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("6ganA")), {
        moduleId: "8c821489",
        moduleName: "HorizontalNavPlans"
    }),
    getPreloadProps: ({ context: { match: match }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        const planId = match.params.planId;
        const scenarioId = match.params.scenarioId;
        if (!planId) throw new Error('Plan Id is missing');
        if (!scenarioId) throw new Error('Scenario Id is missing');
        const planScenarioAri = $9252b8e5bbb4c32e$var$toPlanScenarioAri({
            siteId: cloudId,
            activationId: activationId,
            planId: planId,
            scenarioId: scenarioId
        });
        return {
            queries: {
                horizontalNavPlansQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $6LB8G.default,
                    variables: {
                        first: (0, $ktofH.NAVIGATION_ITEMS_PAGE_SIZE),
                        cloudId: cloudId,
                        containerNavigationInput: {
                            scopeId: planScenarioAri
                        }
                    }
                }
            }
        };
    }
});

});
parcelRegister("6LB8G", function(module, exports) {

$parcel$export(module.exports, "default", () => $de2da6d338535497$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<579d50b31430815e25d91a9a65380319>>
 * @relayHash 164c48c3824ef2f0755f6d70fb373e5c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5ae63d79ee56070a78fcd0f81b3991516463430dbed3ae6bcd427e7e0f13d71c
const $de2da6d338535497$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "5ae63d79ee56070a78fcd0f81b3991516463430dbed3ae6bcd427e7e0f13d71c",
        "metadata": {},
        "name": "HorizontalNavPlansQuery",
        "operationKind": "query",
        "text": null
    }
};
var $de2da6d338535497$export$2e2bcd8739ae039 = $de2da6d338535497$var$node;

});

parcelRegister("ktofH", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_ITEMS_PAGE_SIZE", () => $e6d4097fc653a273$export$4653cda61a4943d6);
$parcel$export(module.exports, "TAB_UNDERLINE_HEIGHT", () => $e6d4097fc653a273$export$d1b9ea3245b6a5de);
$parcel$export(module.exports, "TAB_HEIGHT", () => $e6d4097fc653a273$export$d07bba395c9390f1);
$parcel$export(module.exports, "TAB_GAP", () => $e6d4097fc653a273$export$b61e6f89a9db76de);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports


const $e6d4097fc653a273$export$4653cda61a4943d6 = 75;
const $e6d4097fc653a273$export$d1b9ea3245b6a5de = 2;
const $e6d4097fc653a273$export$d07bba395c9390f1 = 36;
const $e6d4097fc653a273$export$29911ec08ab2ca2d = 5;
const $e6d4097fc653a273$export$b61e6f89a9db76de = 12;
const $e6d4097fc653a273$export$7fd2e391116c6ef5 = 9;
const $e6d4097fc653a273$export$e1633e494d305bfb = 'MORE';

});

parcelRegister("6ganA", function(module, exports) {

let $48ec49db7bb4f064$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $48ec49db7bb4f064$var$load("ffQaD"),
    $48ec49db7bb4f064$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("deI1u"), 4)),
    $48ec49db7bb4f064$var$load("fliVL"),
    $48ec49db7bb4f064$var$load("gNkmV")
]).then(()=>parcelRequire('2NXnj'));

});




parcelRegister("6cMQO", function(module, exports) {

$parcel$export(module.exports, "softwarePlanDependenciesRouteEntry", () => $35d5ce46f5d8e5a8$export$103062f08086fba0);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $8iyFV = parcelRequire("8iyFV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $4twOY = parcelRequire("4twOY");

var $4R6GH = parcelRequire("4R6GH");

var $fq8uf = parcelRequire("fq8uf");

var $4xae4 = parcelRequire("4xae4");
const $35d5ce46f5d8e5a8$export$103062f08086fba0 = (0, $7NszV.createEntry)((0, $4twOY.softwarePlanDependenciesRoute), ()=>({
        group: 'software',
        entryPoint: ()=>// eslint-disable-next-line no-nested-ternary
            (0, $4R6GH.fg)('migrate_plans_to_entrypoints') ? (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? (0, $4xae4.planDependenciesReportPageEntryPoint) : (0, $4xae4.planDependenciesReportPageEntryPointWithoutHorizontalNavigation) : undefined,
        component: (0, $fq8uf.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource),
            (0, $c3WQb.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default),
            horizontal: (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? undefined : (0, $8iyFV.AsyncHorizontalNavPlans),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fq8uf.LazyPlanDependenciesReport)
        ]
    }));

});
parcelRegister("4twOY", function(module, exports) {

$parcel$export(module.exports, "softwarePlanDependenciesRoute", () => $a253d414fb5970e7$export$ad8296aa5394f696);
const $a253d414fb5970e7$export$ad8296aa5394f696 = {
    name: 'software-plan-dependencies',
    path: '/jira/plans/:planId/scenarios/:scenarioId/dependencies'
};

});

parcelRegister("fq8uf", function(module, exports) {

$parcel$export(module.exports, "LazyPlanDependenciesReport", () => $bba44615f3e187dc$export$d4669c7a2f17c261);
$parcel$export(module.exports, "default", () => $bba44615f3e187dc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $bba44615f3e187dc$export$d4669c7a2f17c261 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("fu64C"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-dependencies-report/index-old.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bba44615f3e187dc$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $bba44615f3e187dc$export$d4669c7a2f17c261,
        pageId: "plan-dependencies-report",
        shouldShowSpinner: true
    });

});

parcelRegister("4xae4", function(module, exports) {

$parcel$export(module.exports, "planDependenciesReportPageEntryPoint", () => $49c9e6a9627b668c$export$1d873335adb647af);
$parcel$export(module.exports, "planDependenciesReportPageEntryPointWithoutHorizontalNavigation", () => $49c9e6a9627b668c$export$5d979b028f8d2115);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $1zjAp = parcelRequire("1zjAp");

var $57oLc = parcelRequire("57oLc");
const $49c9e6a9627b668c$export$1d873335adb647af = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1zjAp.planDependenciesReportEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS,
    horizontalNavigation: (0, $57oLc.plansHorizontalNavigationEntryPoint)
});
const $49c9e6a9627b668c$export$5d979b028f8d2115 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1zjAp.planDependenciesReportEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});

});


parcelRegister("lxXtu", function(module, exports) {

$parcel$export(module.exports, "softwarePlanReleasesRouteEntry", () => $4095f2c0ec8f50cf$export$b874fabd66f10ff4);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $8iyFV = parcelRequire("8iyFV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $4doUI = parcelRequire("4doUI");

var $4R6GH = parcelRequire("4R6GH");

var $gbVLg = parcelRequire("gbVLg");

var $iSVrv = parcelRequire("iSVrv");
const $4095f2c0ec8f50cf$export$b874fabd66f10ff4 = (0, $7NszV.createEntry)((0, $4doUI.softwarePlanReleasesRoute), ()=>({
        group: 'software',
        entryPoint: ()=>// eslint-disable-next-line no-nested-ternary
            (0, $4R6GH.fg)('migrate_plans_to_entrypoints') ? (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? (0, $iSVrv.planReleasesPageEntryPoint) : (0, $iSVrv.planReleasesPageEntryPointWithoutHorizontalNavigation) : undefined,
        component: (0, $gbVLg.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource),
            (0, $c3WQb.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default),
            horizontal: (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? undefined : (0, $8iyFV.AsyncHorizontalNavPlans),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gbVLg.LazyPlanReleases)
        ]
    }));

});
parcelRegister("4doUI", function(module, exports) {

$parcel$export(module.exports, "softwarePlanReleasesRoute", () => $f06c9277915d7c48$export$850236b64b0aa28b);
const $f06c9277915d7c48$export$850236b64b0aa28b = {
    name: 'software-plan-releases',
    path: '/jira/plans/:planId/scenarios/:scenarioId/releases'
};

});

parcelRegister("gbVLg", function(module, exports) {

$parcel$export(module.exports, "LazyPlanReleases", () => $17bd378321c97c37$export$749f5d2513e04ec0);
$parcel$export(module.exports, "default", () => $17bd378321c97c37$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $17bd378321c97c37$export$749f5d2513e04ec0 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("7qFnj"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-releases/index-old.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$17bd378321c97c37$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $17bd378321c97c37$export$749f5d2513e04ec0,
        pageId: "plan-releases",
        shouldShowSpinner: true
    });

});
parcelRegister("7qFnj", function(module, exports) {

let $568b0e580154058c$var$load = (parcelRequire("28QjX"))(4);




module.exports = Promise.all([
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $568b0e580154058c$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $568b0e580154058c$var$load("7B2gt")
        ]);
    }),
    $568b0e580154058c$var$load("7mIf9"),
    $568b0e580154058c$var$load("jXweD"),
    $568b0e580154058c$var$load("76n7a"),
    $568b0e580154058c$var$load("l253H"),
    $568b0e580154058c$var$load("ffQaD"),
    $568b0e580154058c$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("6FDky"), 4)),
    $568b0e580154058c$var$load("fliVL"),
    $568b0e580154058c$var$load("bFT3g")
]).then(()=>parcelRequire('jRZ9A'));

});


parcelRegister("iSVrv", function(module, exports) {

$parcel$export(module.exports, "planReleasesPageEntryPoint", () => $dc2ebda85f38ad5d$export$accb0033190d648e);
$parcel$export(module.exports, "planReleasesPageEntryPointWithoutHorizontalNavigation", () => $dc2ebda85f38ad5d$export$10abe27e6c5044b);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $a3dKc = parcelRequire("a3dKc");

var $57oLc = parcelRequire("57oLc");
const $dc2ebda85f38ad5d$export$accb0033190d648e = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $a3dKc.planReleasesEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS,
    horizontalNavigation: (0, $57oLc.plansHorizontalNavigationEntryPoint)
});
const $dc2ebda85f38ad5d$export$10abe27e6c5044b = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $a3dKc.planReleasesEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});

});
parcelRegister("a3dKc", function(module, exports) {

$parcel$export(module.exports, "planReleasesEntryPoint", () => $68da7936f39bec4e$export$4e18896acd7f3236);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $68da7936f39bec4e$export$4e18896acd7f3236 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        if (!false) return (parcelRequire("6mOi7"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "e3e1145d"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("6mOi7", function(module, exports) {

let $4a2bcef58328aa0c$var$load = (parcelRequire("28QjX"))(4);




module.exports = Promise.all([
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $4a2bcef58328aa0c$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $4a2bcef58328aa0c$var$load("7B2gt")
        ]);
    }),
    $4a2bcef58328aa0c$var$load("7mIf9"),
    $4a2bcef58328aa0c$var$load("jXweD"),
    $4a2bcef58328aa0c$var$load("76n7a"),
    $4a2bcef58328aa0c$var$load("l253H"),
    $4a2bcef58328aa0c$var$load("ffQaD"),
    $4a2bcef58328aa0c$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("dINId"), 4)),
    $4a2bcef58328aa0c$var$load("fliVL"),
    $4a2bcef58328aa0c$var$load("8KTk8")
]).then(()=>parcelRequire('1rmO9'));

});




parcelRegister("2l6sh", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsAutoSchedulerRouteEntry", () => $78ac61c21ed5f382$export$fc7007717398c727);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $4AnBP = parcelRequire("4AnBP");

var $gicWA = parcelRequire("gicWA");
const $78ac61c21ed5f382$export$fc7007717398c727 = (0, $7NszV.createEntry)((0, $4AnBP.softwarePlanSettingsAutoSchedulerRoute), ()=>({
        group: 'software',
        component: (0, $gicWA.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gicWA.LazyPlanSettingsAutoScheduler)
        ]
    }));

});
parcelRegister("4AnBP", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsAutoSchedulerRoute", () => $4586083606b00135$export$e44088b2cc0206cf);
const $4586083606b00135$export$e44088b2cc0206cf = {
    name: 'plan-settings-auto-scheduler',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/auto-scheduler'
};

});

parcelRegister("gicWA", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsAutoScheduler", () => $632fd0e21b8de9c8$export$8bcf7155849993f5);
$parcel$export(module.exports, "default", () => $632fd0e21b8de9c8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $632fd0e21b8de9c8$export$8bcf7155849993f5 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("e6wJ7"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/auto-scheduler/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$632fd0e21b8de9c8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $632fd0e21b8de9c8$export$8bcf7155849993f5,
        pageId: "plan-settings-auto-scheduler",
        shouldShowSpinner: true
    });

});
parcelRegister("e6wJ7", function(module, exports) {

let $a44b030f9854c046$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("aoPiL"), 4)),
    $a44b030f9854c046$var$load("veUgl")
]).then(()=>parcelRequire('9U7wJ'));

});



parcelRegister("1C9Ha", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsCustomFieldsRouteEntry", () => $e3235a40cee1f9ea$export$89472d9db6946668);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $6UGjg = parcelRequire("6UGjg");

var $eNKly = parcelRequire("eNKly");
const $e3235a40cee1f9ea$export$89472d9db6946668 = (0, $7NszV.createEntry)((0, $6UGjg.softwarePlanSettingsCustomFieldsRoute), ()=>({
        group: 'software',
        component: (0, $eNKly.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $eNKly.LazyPlanSettingsCustomFields)
        ]
    }));

});
parcelRegister("6UGjg", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsCustomFieldsRoute", () => $8173736a5bf38da1$export$2634cd63c73f7a35);
const $8173736a5bf38da1$export$2634cd63c73f7a35 = {
    name: 'plan-settings-custom-fields',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/custom-fields'
};

});

parcelRegister("eNKly", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsCustomFields", () => $7a181f322c9e7d25$export$72bf44dbae2383e5);
$parcel$export(module.exports, "default", () => $7a181f322c9e7d25$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $7a181f322c9e7d25$export$72bf44dbae2383e5 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("ljZcC"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/custom-fields/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7a181f322c9e7d25$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $7a181f322c9e7d25$export$72bf44dbae2383e5,
        pageId: "plan-settings-custom-fields",
        shouldShowSpinner: true
    });

});
parcelRegister("ljZcC", function(module, exports) {

let $f85ad8d8ffc398ff$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $f85ad8d8ffc398ff$var$load("ffQaD"),
    $f85ad8d8ffc398ff$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("exBDB"), 4)),
    $f85ad8d8ffc398ff$var$load("62GDd")
]).then(()=>parcelRequire('j09X0'));

});



parcelRegister("cChHY", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsExclusionRulesRouteEntry", () => $8d454372873657bb$export$cd1b612d0c014154);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $47gJb = parcelRequire("47gJb");

var $e3mpc = parcelRequire("e3mpc");
const $8d454372873657bb$export$cd1b612d0c014154 = (0, $7NszV.createEntry)((0, $47gJb.softwarePlanSettingsExclusionRulesRoute), ()=>({
        group: 'software',
        component: (0, $e3mpc.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $e3mpc.LazyPlanSettingsExclusionRules)
        ]
    }));

});
parcelRegister("47gJb", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsExclusionRulesRoute", () => $520050550cd1f444$export$358b0ca69a4bd731);
const $520050550cd1f444$export$358b0ca69a4bd731 = {
    name: 'plan-settings-exclusion-rules',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/exclusion-rules'
};

});

parcelRegister("e3mpc", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsExclusionRules", () => $9ac014b7d5fdabc4$export$78f61b03c267e6d9);
$parcel$export(module.exports, "default", () => $9ac014b7d5fdabc4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $9ac014b7d5fdabc4$export$78f61b03c267e6d9 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hxLO9"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/exclusion-rules/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9ac014b7d5fdabc4$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9ac014b7d5fdabc4$export$78f61b03c267e6d9,
        pageId: "plan-settings-exclusion-rules",
        shouldShowSpinner: true
    });

});
parcelRegister("hxLO9", function(module, exports) {

let $cc5a9a676b6716ba$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $cc5a9a676b6716ba$var$load("ffQaD"),
    $cc5a9a676b6716ba$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("l1Bcq"), 4)),
    $cc5a9a676b6716ba$var$load("dAVXW")
]).then(()=>parcelRequire('8InOA'));

});



parcelRegister("d1sI7", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsFindYourIssueRouteEntry", () => $e49a66463b867d46$export$2f975c505121e139);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $7sttJ = parcelRequire("7sttJ");

var $4tFWF = parcelRequire("4tFWF");
const $e49a66463b867d46$export$2f975c505121e139 = (0, $7NszV.createEntry)((0, $7sttJ.softwarePlanSettingsFindYourIssueRoute), ()=>({
        group: 'software',
        component: (0, $4tFWF.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4tFWF.LazyPlanSettingsFindYourIssue)
        ]
    }));

});
parcelRegister("7sttJ", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsFindYourIssueRoute", () => $bcf3aac3d05c5191$export$ab61883f74eb27c2);
const $bcf3aac3d05c5191$export$ab61883f74eb27c2 = {
    name: 'plan-settings-find-your-issue',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/find-your-issue'
};

});

parcelRegister("4tFWF", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsFindYourIssue", () => $428ba58b4dd0959f$export$731998664b7d5e72);
$parcel$export(module.exports, "default", () => $428ba58b4dd0959f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $428ba58b4dd0959f$export$731998664b7d5e72 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("20Tq1"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/find-your-issue/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$428ba58b4dd0959f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $428ba58b4dd0959f$export$731998664b7d5e72,
        pageId: "plan-settings-find-your-issue",
        shouldShowSpinner: true
    });

});
parcelRegister("20Tq1", function(module, exports) {

let $177691e1cb78197a$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("bxHwH"), 4)),
    $177691e1cb78197a$var$load("ivbLk")
]).then(()=>parcelRequire('ZLjUl'));

});



parcelRegister("gksya", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsIssueSourcesRouteEntry", () => $c2b7559ef928e7c4$export$f0b7e9788ab79be0);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $ewGjs = parcelRequire("ewGjs");

var $f4F08 = parcelRequire("f4F08");
const $c2b7559ef928e7c4$export$f0b7e9788ab79be0 = (0, $7NszV.createEntry)((0, $ewGjs.softwarePlanSettingsIssueSourcesRoute), ()=>({
        group: 'software',
        component: (0, $f4F08.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $f4F08.LazyPlanSettingsIssueSources)
        ]
    }));

});
parcelRegister("ewGjs", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsIssueSourcesRoute", () => $da9ac2a12ec5cdcc$export$fa18324265e4400c);
const $da9ac2a12ec5cdcc$export$fa18324265e4400c = {
    name: 'plan-settings-issue-sources',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/issue-sources'
};

});

parcelRegister("f4F08", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsIssueSources", () => $b7fcbd3d5b96d4a9$export$7ba4b487efcedeb3);
$parcel$export(module.exports, "default", () => $b7fcbd3d5b96d4a9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $b7fcbd3d5b96d4a9$export$7ba4b487efcedeb3 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("bpHcx"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/issue-sources/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b7fcbd3d5b96d4a9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $b7fcbd3d5b96d4a9$export$7ba4b487efcedeb3,
        pageId: "plan-settings-issue-sources",
        shouldShowSpinner: !(0, $4R6GH.fg)('plan_settings_refresh')
    });

});
parcelRegister("bpHcx", function(module, exports) {

let $84f38a59d2f80b78$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $84f38a59d2f80b78$var$load("ffQaD"),
    $84f38a59d2f80b78$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("dsOKO"), 4)),
    $84f38a59d2f80b78$var$load("eRlku")
]).then(()=>parcelRequire('1GCm8'));

});



parcelRegister("l0UsI", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsPermissionsRouteEntry", () => $d78d9c80df28a675$export$1afc7a9efa99340);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $gofRF = parcelRequire("gofRF");

var $9X2gP = parcelRequire("9X2gP");
const $d78d9c80df28a675$export$1afc7a9efa99340 = (0, $7NszV.createEntry)((0, $gofRF.softwarePlanSettingsPermissionsRoute), ()=>({
        group: 'software',
        component: (0, $9X2gP.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $9X2gP.LazyPlanSettingsPermissions)
        ]
    }));

});
parcelRegister("gofRF", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsPermissionsRoute", () => $c8e4ae667061a76b$export$6734c29372722a5e);
const $c8e4ae667061a76b$export$6734c29372722a5e = {
    name: 'plan-settings-permissions',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/permissions'
};

});

parcelRegister("9X2gP", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsPermissions", () => $8e8c7a9f7faf5b90$export$49f5b76ad5c06a42);
$parcel$export(module.exports, "default", () => $8e8c7a9f7faf5b90$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $8e8c7a9f7faf5b90$export$49f5b76ad5c06a42 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("4qz9P"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/permissions/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8e8c7a9f7faf5b90$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8e8c7a9f7faf5b90$export$49f5b76ad5c06a42,
        pageId: "plan-settings-permissions",
        shouldShowSpinner: true
    });

});
parcelRegister("4qz9P", function(module, exports) {

let $3394dcb581b6b5a0$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("EG3aS"), 4)),
    $3394dcb581b6b5a0$var$load("9Jw7b")
]).then(()=>parcelRequire('dx76p'));

});



parcelRegister("bdHl5", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsPlanInfoRouteEntry", () => $d7dc38a99726fee2$export$1d6300da0c837e02);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $91wHh = parcelRequire("91wHh");

var $l3vqO = parcelRequire("l3vqO");
const $d7dc38a99726fee2$export$1d6300da0c837e02 = (0, $7NszV.createEntry)((0, $91wHh.softwarePlanSettingsPlanInfoRoute), ()=>({
        group: 'software',
        component: (0, $l3vqO.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $l3vqO.LazyPlanSettingsPlanInfo)
        ]
    }));

});
parcelRegister("91wHh", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsPlanInfoRoute", () => $6fdc9140d3fd71a2$export$76e6bdc959f6fa97);
const $6fdc9140d3fd71a2$export$76e6bdc959f6fa97 = {
    name: 'plan-settings-plan-info',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/plan-info'
};

});

parcelRegister("l3vqO", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsPlanInfo", () => $891dc4fe265590fb$export$c1344fd7d24991b3);
$parcel$export(module.exports, "default", () => $891dc4fe265590fb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $4R6GH = parcelRequire("4R6GH");

const $891dc4fe265590fb$export$c1344fd7d24991b3 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("3N39D"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/plan-info/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$891dc4fe265590fb$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $891dc4fe265590fb$export$c1344fd7d24991b3,
        pageId: "plan-settings-plan-info",
        shouldShowSpinner: !(0, $4R6GH.fg)('plan_settings_refresh')
    });

});
parcelRegister("3N39D", function(module, exports) {

let $2c28651b85adb9e6$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("2snPh"), 4)),
    $2c28651b85adb9e6$var$load("k4CBp")
]).then(()=>parcelRequire('8aOgd'));

});



parcelRegister("1oew5", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsFeaturesRouteEntry", () => $4837f30fa1f1d2ac$export$591e778de9bccacd);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $6s1PB = parcelRequire("6s1PB");

var $5M6NY = parcelRequire("5M6NY");

var $YTuky = parcelRequire("YTuky");
const $4837f30fa1f1d2ac$export$591e778de9bccacd = (0, $7NszV.createEntry)((0, $5M6NY.softwarePlanSettingsFeaturesRoute), ()=>({
        group: 'software',
        entryPoint: ()=>(0, $6s1PB.expValEquals)('m1_features_page_experiment', 'cohort', 'variation') ? (0, $YTuky.planSettingsFeaturesRouteEntry) : undefined,
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("5M6NY", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsFeaturesRoute", () => $858c2043fb3d5ae0$export$2e79af7413eb4921);
const $858c2043fb3d5ae0$export$2e79af7413eb4921 = {
    name: 'plan-settings-features',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/features'
};

});

parcelRegister("YTuky", function(module, exports) {

$parcel$export(module.exports, "planSettingsFeaturesRouteEntry", () => $d035cdee6bee40d9$export$2cf26c8369ef29cd);

var $lkFvK = parcelRequire("lkFvK");

var $i91HP = parcelRequire("i91HP");

var $lmyls = parcelRequire("lmyls");
const $d035cdee6bee40d9$export$2cf26c8369ef29cd = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $i91HP.planSettingsFeaturesEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});

});
parcelRegister("i91HP", function(module, exports) {

$parcel$export(module.exports, "planSettingsFeaturesEntryPoint", () => $d303a29161d5fb6f$export$ae1839f07bffa153);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $gXbDA = parcelRequire("gXbDA");

const $d303a29161d5fb6f$export$ae1839f07bffa153 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("f3jAf")), {
        moduleId: "3d5245c7"
    }),
    getPreloadProps: (entryPointParams)=>{
        return {
            entryPoints: {
                preLoadFeaturesEntryPoint: {
                    entryPoint: (0, $gXbDA.featuresEntryPoint),
                    entryPointParams: entryPointParams
                }
            }
        };
    }
});

});
parcelRegister("gXbDA", function(module, exports) {

$parcel$export(module.exports, "featuresEntryPoint", () => $fad526df981ee212$export$e283e7092d12783d);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $ep7p9 = parcelRequire("ep7p9");

var $4R6GH = parcelRequire("4R6GH");
const $fad526df981ee212$var$toPlanAri = ({ siteId: siteId, activationId: activationId, planId: planId })=>{
    return `ari:cloud:jira:${siteId}:plan/activation/${activationId}/${planId}`;
};

const $fad526df981ee212$export$e283e7092d12783d = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("7s8oM")), {
        moduleId: "2bffebe5"
    }),
    getPreloadProps: ({ context: { match: match }, tenantContext: tenantContext })=>{
        return {
            queries: {
                plan: {
                    variables: {
                        planId: $fad526df981ee212$var$toPlanAri({
                            siteId: tenantContext.cloudId,
                            activationId: tenantContext.activationId,
                            planId: String(match.params.planId)
                        }),
                        releasesFeatureGateEnabled: (0, $4R6GH.fg)('simple-plans-m2-release-feature-toggle')
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $ep7p9.default
                }
            }
        };
    }
});

});
parcelRegister("ep7p9", function(module, exports) {

$parcel$export(module.exports, "default", () => $32ff4e592db83849$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d21ee8dc5aa2c565a13c4e936f53c411>>
 * @relayHash c213325523fa8093ca0c60c9ebfa9aef
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d573c6a12c5fe8fdf2fa662d95c209d47ee53599c80980cea146a8c377e17c70
const $32ff4e592db83849$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "d573c6a12c5fe8fdf2fa662d95c209d47ee53599c80980cea146a8c377e17c70",
        "metadata": {},
        "name": "uiFeaturesPlansSettingsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $32ff4e592db83849$export$2e2bcd8739ae039 = $32ff4e592db83849$var$node;

});

parcelRegister("7s8oM", function(module, exports) {

let $56d1a9be3d1ec2ea$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("kjz94"), 4)),
    $56d1a9be3d1ec2ea$var$load("8mnby")
]).then(()=>parcelRequire('3CODU'));

});


parcelRegister("f3jAf", function(module, exports) {

let $af5653b7497b597d$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("16B2y"), 4)),
    $af5653b7497b597d$var$load("adOUk")
]).then(()=>parcelRequire('3DDDy'));

});




parcelRegister("5hvg3", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsProgramBoardsRouteEntry", () => $6183d6997fcdbcf0$export$be96222796ad98f0);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $4jvUD = parcelRequire("4jvUD");

var $jMgFt = parcelRequire("jMgFt");
const $6183d6997fcdbcf0$export$be96222796ad98f0 = (0, $7NszV.createEntry)((0, $4jvUD.softwarePlanSettingsProgramBoardsRoute), ()=>({
        group: 'software',
        component: (0, $jMgFt.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jMgFt.LazyPlanSettingsProgramBoards)
        ]
    }));

});
parcelRegister("4jvUD", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsProgramBoardsRoute", () => $8498ace38f0217d4$export$3d54c48a91a178c0);
const $8498ace38f0217d4$export$3d54c48a91a178c0 = {
    name: 'plan-settings-program-boards',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/program-boards'
};

});

parcelRegister("jMgFt", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsProgramBoards", () => $fc0346cc52c0eaa1$export$ffdec728a47c437c);
$parcel$export(module.exports, "default", () => $fc0346cc52c0eaa1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $fc0346cc52c0eaa1$export$ffdec728a47c437c = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hcBYn"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/program-boards/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fc0346cc52c0eaa1$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $fc0346cc52c0eaa1$export$ffdec728a47c437c,
        pageId: "plan-settings-program-boards",
        shouldShowSpinner: true
    });

});
parcelRegister("hcBYn", function(module, exports) {

let $c861034a11507f97$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("9J6CZ"), 4)),
    $c861034a11507f97$var$load("egdrc")
]).then(()=>parcelRequire('cckoo'));

});



parcelRegister("6oWts", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsRemovedIssuesRouteEntry", () => $304853a89d046ccf$export$53a9ea0e0b05ceb5);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $12t4Y = parcelRequire("12t4Y");

var $4a0AK = parcelRequire("4a0AK");
const $304853a89d046ccf$export$53a9ea0e0b05ceb5 = (0, $7NszV.createEntry)((0, $12t4Y.softwarePlanSettingsRemovedIssuesRoute), ()=>({
        group: 'software',
        component: (0, $4a0AK.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4a0AK.LazyPlanSettingsRemovedIssues)
        ]
    }));

});
parcelRegister("12t4Y", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsRemovedIssuesRoute", () => $1a8d996cecbe9939$export$8b77532ba9798e64);
const $1a8d996cecbe9939$export$8b77532ba9798e64 = {
    name: 'plan-settings-removed-issues',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/removed-issues'
};

});

parcelRegister("4a0AK", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsRemovedIssues", () => $1ba44a18046961e4$export$759df6301ec72119);
$parcel$export(module.exports, "default", () => $1ba44a18046961e4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $1ba44a18046961e4$export$759df6301ec72119 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("kXvOT"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/removed-issues/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1ba44a18046961e4$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $1ba44a18046961e4$export$759df6301ec72119,
        pageId: "plan-settings-removed-issues",
        shouldShowSpinner: true
    });

});
parcelRegister("kXvOT", function(module, exports) {

let $f422001ecf4c6569$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $f422001ecf4c6569$var$load("ffQaD"),
    $f422001ecf4c6569$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("5xzb8"), 4)),
    $f422001ecf4c6569$var$load("2zaD5")
]).then(()=>parcelRequire('mRA5P'));

});



parcelRegister("76RJj", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsSavedViewsRouteEntry", () => $cbe1aa5484552af9$export$64d5b46da2e58194);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $gEyvh = parcelRequire("gEyvh");

var $lY1iq = parcelRequire("lY1iq");
const $cbe1aa5484552af9$export$64d5b46da2e58194 = (0, $7NszV.createEntry)((0, $gEyvh.softwarePlanSettingsSavedViewsRoute), ()=>({
        group: 'software',
        component: (0, $lY1iq.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $lY1iq.LazyPlanSettingsSavedViews)
        ]
    }));

});
parcelRegister("gEyvh", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsSavedViewsRoute", () => $606c26c5c4fe38cc$export$a0fec30f475e8756);
const $606c26c5c4fe38cc$export$a0fec30f475e8756 = {
    name: 'plan-settings-saved-views',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/saved-views'
};

});

parcelRegister("lY1iq", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsSavedViews", () => $9469a9a95c6fd42f$export$a5398542699d356a);
$parcel$export(module.exports, "default", () => $9469a9a95c6fd42f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $9469a9a95c6fd42f$export$a5398542699d356a = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("f7V6o"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/saved-views/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9469a9a95c6fd42f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9469a9a95c6fd42f$export$a5398542699d356a,
        pageId: "plan-settings-saved-views",
        shouldShowSpinner: true
    });

});
parcelRegister("f7V6o", function(module, exports) {

let $b033cdc13aecd8b9$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("f4Oqf"), 4)),
    $b033cdc13aecd8b9$var$load("j1a8y")
]).then(()=>parcelRequire('k5TsF'));

});



parcelRegister("ikfu9", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsScenariosRouteEntry", () => $9368211e7352bb42$export$9b6e6b5d471b90f);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $4a5PZ = parcelRequire("4a5PZ");

var $6o8sS = parcelRequire("6o8sS");
const $9368211e7352bb42$export$9b6e6b5d471b90f = (0, $7NszV.createEntry)((0, $4a5PZ.softwarePlanSettingsScenariosRoute), ()=>({
        group: 'software',
        component: (0, $6o8sS.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6o8sS.LazyPlanSettingsScenarios)
        ]
    }));

});
parcelRegister("4a5PZ", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsScenariosRoute", () => $56e039c24697690f$export$d32efeefb944c6b7);
const $56e039c24697690f$export$d32efeefb944c6b7 = {
    name: 'plan-settings-scenarios',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/scenarios'
};

});

parcelRegister("6o8sS", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsScenarios", () => $3744eed80f080771$export$94104fcc1a6f460f);
$parcel$export(module.exports, "default", () => $3744eed80f080771$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $3744eed80f080771$export$94104fcc1a6f460f = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("8ZV6c"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/scenarios/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3744eed80f080771$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3744eed80f080771$export$94104fcc1a6f460f,
        pageId: "plan-settings-scenarios",
        shouldShowSpinner: true
    });

});
parcelRegister("8ZV6c", function(module, exports) {

let $68d04fe3208557cf$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("flByN"), 4)),
    $68d04fe3208557cf$var$load("jZz7i")
]).then(()=>parcelRequire('iF2yt'));

});



parcelRegister("g7fao", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsSchedulingRouteEntry", () => $cf0e25b45377825b$export$c1319dec79812860);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $eLpuR = parcelRequire("eLpuR");

var $TAgAs = parcelRequire("TAgAs");
const $cf0e25b45377825b$export$c1319dec79812860 = (0, $7NszV.createEntry)((0, $eLpuR.softwarePlanSettingsSchedulingRoute), ()=>({
        group: 'software',
        component: (0, $TAgAs.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PLAN_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $TAgAs.LazyPlanSettingsScheduling)
        ]
    }));

});
parcelRegister("eLpuR", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSettingsSchedulingRoute", () => $e1fdd34e8b323da3$export$a215ef374dd2a8a9);
const $e1fdd34e8b323da3$export$a215ef374dd2a8a9 = {
    name: 'plan-settings-scheduling',
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/scheduling'
};

});

parcelRegister("TAgAs", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSettingsScheduling", () => $5e451d261b446f20$export$3bf11db1bbeae73e);
$parcel$export(module.exports, "default", () => $5e451d261b446f20$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $4R6GH = parcelRequire("4R6GH");

var $kxZPA = parcelRequire("kxZPA");

const $5e451d261b446f20$export$3bf11db1bbeae73e = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("lshue"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/scheduling/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5e451d261b446f20$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $5e451d261b446f20$export$3bf11db1bbeae73e,
        pageId: "plan-settings-scheduling",
        shouldShowSpinner: !(0, $4R6GH.fg)('plan_settings_refresh')
    });

});
parcelRegister("lshue", function(module, exports) {

let $f9e9c6fd948ca5f6$var$load = (parcelRequire("28QjX"))(4);




module.exports = Promise.all([
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $f9e9c6fd948ca5f6$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $f9e9c6fd948ca5f6$var$load("7B2gt")
        ]);
    }),
    $f9e9c6fd948ca5f6$var$load("7mIf9"),
    $f9e9c6fd948ca5f6$var$load("jXweD"),
    $f9e9c6fd948ca5f6$var$load("76n7a"),
    $f9e9c6fd948ca5f6$var$load("l253H"),
    $f9e9c6fd948ca5f6$var$load("ffQaD"),
    $f9e9c6fd948ca5f6$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("flj7g"), 4)),
    $f9e9c6fd948ca5f6$var$load("fliVL"),
    $f9e9c6fd948ca5f6$var$load("9AO6b")
]).then(()=>parcelRequire('j3U5Q'));

});



parcelRegister("8s6qp", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSummaryRouteEntry", () => $e2353036f7312b49$export$4bc10767887a84cc);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $8iyFV = parcelRequire("8iyFV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $lv9xW = parcelRequire("lv9xW");

var $3RJkv = parcelRequire("3RJkv");

var $jUoVn = parcelRequire("jUoVn");

var $4R6GH = parcelRequire("4R6GH");

var $35bOg = parcelRequire("35bOg");

var $3v1Zf = parcelRequire("3v1Zf");
const $e2353036f7312b49$export$4bc10767887a84cc = (0, $7NszV.createEntry)((0, $jUoVn.softwarePlanSummaryRoute), ()=>({
        group: 'software',
        entryPoint: ()=>// eslint-disable-next-line no-nested-ternary
            (0, $4R6GH.fg)('migrate_plans_to_entrypoints') ? (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? (0, $3v1Zf.planSummaryPageEntryPoint) : (0, $3v1Zf.planSummaryPageEntryPointWithoutHorizontalNavigation) : undefined,
        ufoName: 'software-advanced-roadmaps-summary',
        component: (0, $35bOg.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $lv9xW.advancedRoadmapsSummaryDataResource),
            (0, $c3WQb.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default),
            horizontal: (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? undefined : (0, $8iyFV.AsyncHorizontalNavPlans),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $35bOg.LazyPlanSummary)
        ]
    }));

});
parcelRegister("jUoVn", function(module, exports) {

$parcel$export(module.exports, "softwarePlanSummaryRoute", () => $ad2d61946557db6b$export$25a8cf27557a612d);
const $ad2d61946557db6b$export$25a8cf27557a612d = {
    name: 'software-plan-summary',
    path: '/jira/plans/:planId/scenarios/:scenarioId/summary'
};

});

parcelRegister("35bOg", function(module, exports) {

$parcel$export(module.exports, "LazyPlanSummary", () => $d70e7ef12abe6465$export$c717f0d9d7f11b49);
$parcel$export(module.exports, "default", () => $d70e7ef12abe6465$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $d70e7ef12abe6465$export$c717f0d9d7f11b49 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("irZA1"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-summary/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d70e7ef12abe6465$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d70e7ef12abe6465$export$c717f0d9d7f11b49,
        pageId: "plan-summary",
        shouldShowSpinner: true
    });

});

parcelRegister("3v1Zf", function(module, exports) {

$parcel$export(module.exports, "planSummaryPageEntryPoint", () => $2ab6a879960150e5$export$a3858cce1e973f19);
$parcel$export(module.exports, "planSummaryPageEntryPointWithoutHorizontalNavigation", () => $2ab6a879960150e5$export$581542c1c5ef42f8);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $739vE = parcelRequire("739vE");

var $57oLc = parcelRequire("57oLc");
const $2ab6a879960150e5$export$a3858cce1e973f19 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $739vE.planSummaryEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS,
    horizontalNavigation: (0, $57oLc.plansHorizontalNavigationEntryPoint)
});
const $2ab6a879960150e5$export$581542c1c5ef42f8 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $739vE.planSummaryEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});

});


parcelRegister("qruNQ", function(module, exports) {

$parcel$export(module.exports, "softwarePlanTeamsRouteEntry", () => $ed7f2a4db7ff0a01$export$cc5b7d3f8546a313);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $8iyFV = parcelRequire("8iyFV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $fFiNA = parcelRequire("fFiNA");

var $4R6GH = parcelRequire("4R6GH");

var $44giz = parcelRequire("44giz");

var $40ny3 = parcelRequire("40ny3");
const $ed7f2a4db7ff0a01$export$cc5b7d3f8546a313 = (0, $7NszV.createEntry)((0, $fFiNA.softwarePlanTeamsRoute), ()=>({
        group: 'software',
        entryPoint: ()=>// eslint-disable-next-line no-nested-ternary
            (0, $4R6GH.fg)('migrate_plans_to_entrypoints') ? (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? (0, $40ny3.planTeamsPageEntryPoint) : (0, $40ny3.planTeamsPageEntryPointWithoutHorizontalNavigation) : undefined,
        component: (0, $44giz.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default),
            horizontal: (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? undefined : (0, $8iyFV.AsyncHorizontalNavPlans),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $44giz.LazyPlanTeams)
        ]
    }));

});
parcelRegister("fFiNA", function(module, exports) {

$parcel$export(module.exports, "softwarePlanTeamsRoute", () => $132f449f27d99391$export$fc66f5c0de18ddc7);
const $132f449f27d99391$export$fc66f5c0de18ddc7 = {
    name: 'software-plan-teams',
    path: '/jira/plans/:planId/scenarios/:scenarioId/teams'
};

});

parcelRegister("44giz", function(module, exports) {

$parcel$export(module.exports, "LazyPlanTeams", () => $243c6380c0240648$export$f85952f98f28fed0);
$parcel$export(module.exports, "default", () => $243c6380c0240648$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $243c6380c0240648$export$f85952f98f28fed0 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("lrmdn"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-teams/index-old.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$243c6380c0240648$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $243c6380c0240648$export$f85952f98f28fed0,
        pageId: "plan-teams",
        shouldShowSpinner: true
    });

});
parcelRegister("lrmdn", function(module, exports) {

let $f9bd59f8be1aeaba$var$load = (parcelRequire("28QjX"))(4);




module.exports = Promise.all([
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $f9bd59f8be1aeaba$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $f9bd59f8be1aeaba$var$load("7B2gt")
        ]);
    }),
    $f9bd59f8be1aeaba$var$load("7mIf9"),
    $f9bd59f8be1aeaba$var$load("jXweD"),
    $f9bd59f8be1aeaba$var$load("76n7a"),
    $f9bd59f8be1aeaba$var$load("l253H"),
    $f9bd59f8be1aeaba$var$load("ffQaD"),
    $f9bd59f8be1aeaba$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("koUPy"), 4)),
    $f9bd59f8be1aeaba$var$load("fliVL"),
    $f9bd59f8be1aeaba$var$load("5fkxK")
]).then(()=>parcelRequire('gEN7m'));

});


parcelRegister("40ny3", function(module, exports) {

$parcel$export(module.exports, "planTeamsPageEntryPoint", () => $7b0bfdd4f2079663$export$e75b3c6626974862);
$parcel$export(module.exports, "planTeamsPageEntryPointWithoutHorizontalNavigation", () => $7b0bfdd4f2079663$export$16a85e75293f1984);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $dhgMR = parcelRequire("dhgMR");

var $57oLc = parcelRequire("57oLc");
const $7b0bfdd4f2079663$export$e75b3c6626974862 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $dhgMR.planTeamsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS,
    horizontalNavigation: (0, $57oLc.plansHorizontalNavigationEntryPoint)
});
const $7b0bfdd4f2079663$export$16a85e75293f1984 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $dhgMR.planTeamsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});

});
parcelRegister("dhgMR", function(module, exports) {

$parcel$export(module.exports, "planTeamsEntryPoint", () => $1ae70864b1d134b4$export$afd1c95955e9abac);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $1ae70864b1d134b4$export$afd1c95955e9abac = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        if (!false) return (parcelRequire("kq5YV"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "8c4bf459"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("kq5YV", function(module, exports) {

let $eddae033f6f7f4b6$var$load = (parcelRequire("28QjX"))(4);




module.exports = Promise.all([
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $eddae033f6f7f4b6$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $eddae033f6f7f4b6$var$load("7B2gt")
        ]);
    }),
    $eddae033f6f7f4b6$var$load("7mIf9"),
    $eddae033f6f7f4b6$var$load("jXweD"),
    $eddae033f6f7f4b6$var$load("76n7a"),
    $eddae033f6f7f4b6$var$load("l253H"),
    $eddae033f6f7f4b6$var$load("ffQaD"),
    $eddae033f6f7f4b6$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("1ygtG"), 4)),
    $eddae033f6f7f4b6$var$load("fliVL"),
    $eddae033f6f7f4b6$var$load("3dqFA")
]).then(()=>parcelRequire('j7IwW'));

});




parcelRegister("4chTT", function(module, exports) {

$parcel$export(module.exports, "softwarePlanTimelineRouteEntry", () => $970ae3ae6d33a9e3$export$c5b46ecd4d9a8abd);

var $ffza4 = parcelRequire("ffza4");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $8iyFV = parcelRequire("8iyFV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $2oTRI = parcelRequire("2oTRI");

var $g6wgl = parcelRequire("g6wgl");

var $cnLXu = parcelRequire("cnLXu");
const $970ae3ae6d33a9e3$export$c5b46ecd4d9a8abd = (0, $7NszV.createEntry)((0, $2oTRI.softwarePlanTimelineRoute), ()=>({
        group: 'software',
        entryPoint: ()=>// eslint-disable-next-line no-nested-ternary
            (0, $4R6GH.fg)('migrate_plans_to_entrypoints') ? (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? (0, $cnLXu.planTimelinePageEntryPoint) : (0, $cnLXu.planTimelinePageEntryPointWithoutHorizontalNavigation) : undefined,
        component: (0, $g6wgl.default),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource),
            (0, $c3WQb.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default),
            horizontal: (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? undefined : (0, $8iyFV.AsyncHorizontalNavPlans),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $g6wgl.LazyPlanTimeline)
        ]
    }));

});
parcelRegister("cnLXu", function(module, exports) {

$parcel$export(module.exports, "planTimelinePageEntryPoint", () => $1450d939edbc2ee3$export$7ee5b399f9530a72);
$parcel$export(module.exports, "planTimelinePageEntryPointWithoutHorizontalNavigation", () => $1450d939edbc2ee3$export$2476bbde953fbfc0);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $4Xa0b = parcelRequire("4Xa0b");

var $57oLc = parcelRequire("57oLc");
const $1450d939edbc2ee3$export$7ee5b399f9530a72 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $4Xa0b.planTimelineEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS,
    horizontalNavigation: (0, $57oLc.plansHorizontalNavigationEntryPoint)
});
const $1450d939edbc2ee3$export$2476bbde953fbfc0 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $4Xa0b.planTimelineEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});

});


parcelRegister("5qx9W", function(module, exports) {

$parcel$export(module.exports, "planUpsellRouteEntry", () => $7ff38098f11bff34$export$363894d991872cbf);

var $7NszV = parcelRequire("7NszV");

var $eCT4E = parcelRequire("eCT4E");

var $lmyls = parcelRequire("lmyls");

var $2BrOV = parcelRequire("2BrOV");

var $3RJkv = parcelRequire("3RJkv");

var $eeeSt = parcelRequire("eeeSt");
const $7ff38098f11bff34$export$363894d991872cbf = (0, $7NszV.createEntry)((0, $eCT4E.planUpsellRoute), ()=>({
        group: 'software',
        entryPoint () {
            return 0, $eeeSt.planUpsellPageEntryPoint;
        },
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS
        }
    }));

});
parcelRegister("eeeSt", function(module, exports) {

$parcel$export(module.exports, "planUpsellPageEntryPoint", () => $8fee77540cc4840f$export$7551fe27e3c0a4bf);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $fzr0K = parcelRequire("fzr0K");
const $8fee77540cc4840f$export$7551fe27e3c0a4bf = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $fzr0K.planUpsellEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});

});


parcelRegister("5dqn2", function(module, exports) {

$parcel$export(module.exports, "planViewNotFoundRouteEntry", () => $e166e971b74a927b$export$19c7bb0eeda48c06);

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $NONdU = parcelRequire("NONdU");

var $aPfsS = parcelRequire("aPfsS");

var $2BrOV = parcelRequire("2BrOV");

var $451ix = parcelRequire("451ix");

var $937TY = parcelRequire("937TY");

var $lEqGO = parcelRequire("lEqGO");
const $e166e971b74a927b$export$19c7bb0eeda48c06 = (0, $7NszV.createEntry)((0, $NONdU.planViewNotFoundRoute), ()=>({
        group: 'software',
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default),
            horizontal: undefined,
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)()
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        entryPoint: ()=>(0, $lEqGO.planViewNotFoundPageEntrypoint)
    }));

});
parcelRegister("NONdU", function(module, exports) {

$parcel$export(module.exports, "planViewNotFoundRoute", () => $81b3aac8927596c6$export$f2531e319f8b4274);
const $81b3aac8927596c6$export$f2531e319f8b4274 = {
    name: 'plan-view-not-found',
    path: '/jira/plans/:planId/scenarios/:scenarioId/not-found'
};

});

parcelRegister("lEqGO", function(module, exports) {

$parcel$export(module.exports, "planViewNotFoundPageEntrypoint", () => $5fbb9e47837eed67$export$18e8a0d930f394a2);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $1RGLt = parcelRequire("1RGLt");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $57oLc = parcelRequire("57oLc");

const $5fbb9e47837eed67$var$main = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("7RUUm")), {
        moduleId: "f2ea0209",
        moduleName: "PlanViewNotFound"
    }),
    getPreloadProps: ({ context: { match: match }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        const planId = match.params.planId;
        if (!planId) throw new Error('Plan Id is missing');
        return {
            queries: {
                mainQuery: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $1RGLt.default,
                    variables: {
                        planId: `ari:cloud:jira:${cloudId}:plan/activation/${activationId}/${planId}`
                    }
                }
            }
        };
    }
});
const $5fbb9e47837eed67$export$18e8a0d930f394a2 = (0, $lkFvK.createPageEntryPoint)({
    main: $5fbb9e47837eed67$var$main,
    horizontalNavigation: (0, $57oLc.plansHorizontalNavigationEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});

});
parcelRegister("1RGLt", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e981f11ecdd6cbe$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f97e78ab59091e8012bd8a05696ce789>>
 * @relayHash c51281360f2d7bd5387e9bb058f11f6d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 29dd5915a4af58bbd22d79842971790506a1f3ab87507ab96eca150acfd91229
const $5e981f11ecdd6cbe$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "29dd5915a4af58bbd22d79842971790506a1f3ab87507ab96eca150acfd91229",
        "metadata": {},
        "name": "PlanViewNotFoundQuery",
        "operationKind": "query",
        "text": null
    }
};
var $5e981f11ecdd6cbe$export$2e2bcd8739ae039 = $5e981f11ecdd6cbe$var$node;

});

parcelRegister("7RUUm", function(module, exports) {

let $5ba9a0650a3e27d5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5ba9a0650a3e27d5$var$load("1vYQA").then(()=>parcelRequire('eIJQP'));

});



parcelRegister("7gypr", function(module, exports) {

$parcel$export(module.exports, "arjSettingsDependenciesLegacyRedirectRouteEntry", () => $3678ca52b1bdf235$export$804f2d81dfbdd5c9);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3DNgf = parcelRequire("3DNgf");

var $3RJkv = parcelRequire("3RJkv");

var $6i7U6 = parcelRequire("6i7U6");

var $a9hcp = parcelRequire("a9hcp");

var $i8IhR = parcelRequire("i8IhR");
const $3678ca52b1bdf235$export$804f2d81dfbdd5c9 = (0, $7NszV.createEntry)((0, $6i7U6.arjSettingsDependenciesLegacyRedirectRoute), ()=>({
        group: 'software',
        component: (0, $i8IhR.redirectTo)('/jira/plans/settings/dependencies'),
        isRedirect: true,
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $3DNgf.issueLinkInformationResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a9hcp.LazyArjSettingsDependencies)
        ]
    }));

});
parcelRegister("3DNgf", function(module, exports) {

$parcel$export(module.exports, "issueLinkInformationResource", () => $8163e55c16e335dc$export$8d8544ca08d98837);

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");
const $8163e55c16e335dc$var$body = {
    providers: [
        'issueLinks',
        'dependencySettings'
    ]
};
const $8163e55c16e335dc$var$url = '/rest/jpo/1.0/info/query';
const $8163e55c16e335dc$var$fetchIssueLinkInformation = ()=>(0, $eusud.performPostRequest)($8163e55c16e335dc$var$url, {
        body: JSON.stringify($8163e55c16e335dc$var$body)
    });
const $8163e55c16e335dc$export$8d8544ca08d98837 = (0, $2M1hQ.createResource)({
    type: 'ISSUE_LINK_INFORMATION',
    getKey: ()=>'issue-link-information',
    getData: async ()=>$8163e55c16e335dc$var$fetchIssueLinkInformation(),
    maxAge: 0
});

});

parcelRegister("6i7U6", function(module, exports) {

$parcel$export(module.exports, "arjSettingsDependenciesLegacyRedirectRoute", () => $461a54dd9cfd2345$export$f96bfb0a2b0ad0f4);
const $461a54dd9cfd2345$export$f96bfb0a2b0ad0f4 = {
    name: 'arj-settings-dependencies-redirect',
    path: '/secure/PortfolioDependencySettings.jspa'
};

});

parcelRegister("a9hcp", function(module, exports) {

$parcel$export(module.exports, "LazyArjSettingsDependencies", () => $8f893c79e2990b05$export$4fcc3c0f6e792efc);
$parcel$export(module.exports, "ArjSettingsDependencies", () => $8f893c79e2990b05$export$d6f045c7c1aaff50);
$parcel$export(module.exports, "LazyArjSettingsLoadingLimits", () => $8f893c79e2990b05$export$64761ea1912fdcd9);
$parcel$export(module.exports, "ArjSettingsLoadingLimits", () => $8f893c79e2990b05$export$7bb4c0f22b467385);
$parcel$export(module.exports, "LazyArjSettingsPermissions", () => $8f893c79e2990b05$export$edb4ae7e85c7908d);
$parcel$export(module.exports, "ArjSettingsPermissions", () => $8f893c79e2990b05$export$fa852ea42b98d3de);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $8f893c79e2990b05$export$4fcc3c0f6e792efc = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("clW64"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/dependencies/index.tsx"
});
const $8f893c79e2990b05$export$d6f045c7c1aaff50 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8f893c79e2990b05$export$4fcc3c0f6e792efc,
        pageId: "arj-settings-dependencies",
        shouldShowSpinner: true
    });

const $8f893c79e2990b05$export$64761ea1912fdcd9 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("lUhjW"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/loading-limits/index.tsx"
});
const $8f893c79e2990b05$export$7bb4c0f22b467385 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8f893c79e2990b05$export$64761ea1912fdcd9,
        pageId: "arj-settings-loading-limits",
        shouldShowSpinner: true
    });

const $8f893c79e2990b05$export$edb4ae7e85c7908d = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("lrggS"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/permissions/index.tsx"
});
const $8f893c79e2990b05$export$fa852ea42b98d3de = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8f893c79e2990b05$export$edb4ae7e85c7908d,
        pageId: "arj-settings-permissions",
        shouldShowSpinner: true
    });

});
parcelRegister("clW64", function(module, exports) {

let $8fe48307b43daa98$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8fe48307b43daa98$var$load("4fVgK").then(()=>parcelRequire('1Ba8D'));

});

parcelRegister("lUhjW", function(module, exports) {

let $ff2c43795f2e9c53$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("egMUS"), 4)),
    $ff2c43795f2e9c53$var$load("adoLY")
]).then(()=>parcelRequire('ieFCi'));

});

parcelRegister("lrggS", function(module, exports) {

let $f9b8bdb52f210df3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f9b8bdb52f210df3$var$load("izFXj").then(()=>parcelRequire('luimD'));

});


parcelRegister("i8IhR", function(module, exports) {

$parcel$export(module.exports, "redirectTo", () => $cf0b6f0a8f874806$export$2d47ce6f15e624e5);

var $5uXOq = parcelRequire("5uXOq");

var $ds5qV = parcelRequire("ds5qV");
const $cf0b6f0a8f874806$export$2d47ce6f15e624e5 = (redirectUrl)=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
            to: redirectUrl
        });

});


parcelRegister("cwKGx", function(module, exports) {

$parcel$export(module.exports, "arjSettingsDependenciesRouteEntry", () => $98e5774d92d39cbd$export$70386609aff5ba12);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3DNgf = parcelRequire("3DNgf");

var $3RJkv = parcelRequire("3RJkv");

var $3NV88 = parcelRequire("3NV88");

var $a9hcp = parcelRequire("a9hcp");
const $98e5774d92d39cbd$export$70386609aff5ba12 = (0, $7NszV.createEntry)((0, $3NV88.arjSettingsDependenciesRoute), ()=>({
        group: 'software',
        component: (0, $a9hcp.ArjSettingsDependencies),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $3DNgf.issueLinkInformationResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a9hcp.LazyArjSettingsDependencies)
        ]
    }));

});
parcelRegister("3NV88", function(module, exports) {

$parcel$export(module.exports, "arjSettingsDependenciesRoute", () => $2117b55ed774a2be$export$ff9b90f9d680e34);
const $2117b55ed774a2be$export$ff9b90f9d680e34 = {
    name: 'arj-settings-dependencies',
    path: '/jira/plans/settings/dependencies'
};

});


parcelRegister("dfdSu", function(module, exports) {

$parcel$export(module.exports, "arjSettingsLoadingLimitsLegacyRedirectRouteEntry", () => $99f00cddc0758136$export$9f80102c0f64ad9b);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $44HQw = parcelRequire("44HQw");

var $a9hcp = parcelRequire("a9hcp");

var $i8IhR = parcelRequire("i8IhR");
const $99f00cddc0758136$export$9f80102c0f64ad9b = (0, $7NszV.createEntry)((0, $44HQw.arjSettingsLoadingLimitsLegacyRedirectRoute), ()=>({
        group: 'software',
        component: (0, $i8IhR.redirectTo)('/jira/plans/settings/loading-limits'),
        isRedirect: true,
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a9hcp.LazyArjSettingsLoadingLimits)
        ]
    }));

});
parcelRegister("44HQw", function(module, exports) {

$parcel$export(module.exports, "arjSettingsLoadingLimitsLegacyRedirectRoute", () => $abfe17fb063fcb4e$export$7c71e235d628daf5);
const $abfe17fb063fcb4e$export$7c71e235d628daf5 = {
    name: 'arj-settings-loading-limits-redirect',
    path: '/secure/PortfolioLoadingLimits.jspa'
};

});


parcelRegister("ieqGd", function(module, exports) {

$parcel$export(module.exports, "arjSettingsLoadingLimitsRouteEntry", () => $f2c5f02fe8472718$export$6786257309f86d8c);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $azWKH = parcelRequire("azWKH");

var $3RJkv = parcelRequire("3RJkv");

var $hTLqB = parcelRequire("hTLqB");

var $a9hcp = parcelRequire("a9hcp");
const $f2c5f02fe8472718$export$6786257309f86d8c = (0, $7NszV.createEntry)((0, $hTLqB.arjSettingsLoadingLimitsRoute), ()=>({
        group: 'software',
        component: (0, $a9hcp.ArjSettingsLoadingLimits),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $azWKH.arjSettingsLoadingLimitsResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a9hcp.LazyArjSettingsLoadingLimits)
        ]
    }));

});
parcelRegister("azWKH", function(module, exports) {

$parcel$export(module.exports, "arjSettingsLoadingLimitsResource", () => $a9399ce8867d02dc$export$c9e47fa9b57975f5);

var $7f4tk = parcelRequire("7f4tk");

var $2M1hQ = parcelRequire("2M1hQ");

const $a9399ce8867d02dc$export$c9e47fa9b57975f5 = (0, $2M1hQ.createResource)({
    type: (0, $a9d74ae4a12ce55b$export$cd7bb91dd2e30684),
    getKey: ()=>'loading-limits-information',
    getData: async ()=>(0, $7f4tk.default)('/rest/jpo/1.0/configuration'),
    maxAge: 0
});

});
const $a9d74ae4a12ce55b$export$cd7bb91dd2e30684 = 'RESOURCE_TYPE_ARJ_SETTINGS_LOADING_LIMITS';


parcelRegister("hTLqB", function(module, exports) {

$parcel$export(module.exports, "arjSettingsLoadingLimitsRoute", () => $46a780a2a2e80d5e$export$f90dc3a45fadc1e2);
const $46a780a2a2e80d5e$export$f90dc3a45fadc1e2 = {
    name: 'arj-settings-loading-limits',
    path: '/jira/plans/settings/loading-limits'
};

});


parcelRegister("JQ5Vt", function(module, exports) {

$parcel$export(module.exports, "arjSettingsPermissionsRouteEntry", () => $c52f49db3f216f46$export$4e97658a5cc15eaa);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $1aR84 = parcelRequire("1aR84");

var $3RJkv = parcelRequire("3RJkv");

var $a8ttb = parcelRequire("a8ttb");

var $a9hcp = parcelRequire("a9hcp");
const $c52f49db3f216f46$export$4e97658a5cc15eaa = (0, $7NszV.createEntry)((0, $a8ttb.arjSettingsPermissionsRoute), ()=>({
        group: 'software',
        component: (0, $a9hcp.ArjSettingsPermissions),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $1aR84.getGlobalPermissionPageResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a9hcp.LazyArjSettingsPermissions)
        ]
    }));

});
parcelRegister("1aR84", function(module, exports) {

$parcel$export(module.exports, "grantedPermissionsResource", () => $d675e556a71c706a$export$aa3daf3280e2a2d7);
$parcel$export(module.exports, "permissionGroupsResource", () => $d675e556a71c706a$export$950060d83722e3bd);
$parcel$export(module.exports, "getGlobalPermissionPageResources", () => $d675e556a71c706a$export$a09a91246a866817);

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");
const $d675e556a71c706a$var$fetchGrantedPermissions = ()=>(0, $eusud.performPostRequest)('/rest/roadmaps/1.0/info/query', {
        body: JSON.stringify({
            providers: [
                'permissions'
            ]
        })
    });
const $d675e556a71c706a$var$fetchPermissionGroups = ()=>(0, $eusud.performPostRequest)('/rest/jpo/1.0/groupsandusers', {
        body: JSON.stringify({
            includeUsers: false,
            excludedGroups: [],
            excludedUsers: [],
            query: ''
        })
    });
const $d675e556a71c706a$export$aa3daf3280e2a2d7 = (0, $2M1hQ.createResource)({
    type: 'ARJ_GLOBAL_PERMISSIONS_GRANTED',
    getKey: ()=>'arj-granted-permissions',
    getData: async ()=>$d675e556a71c706a$var$fetchGrantedPermissions(),
    maxAge: 0
});
const $d675e556a71c706a$export$950060d83722e3bd = (0, $2M1hQ.createResource)({
    type: 'ARJ_GLOBAL_PERMISSIONS_GROUPS',
    getKey: ()=>'arj-permission-groups',
    getData: async ()=>$d675e556a71c706a$var$fetchPermissionGroups(),
    maxAge: 0
});
const $d675e556a71c706a$export$a09a91246a866817 = ()=>[
        $d675e556a71c706a$export$aa3daf3280e2a2d7,
        $d675e556a71c706a$export$950060d83722e3bd
    ];

});

parcelRegister("a8ttb", function(module, exports) {

$parcel$export(module.exports, "arjSettingsPermissionsRoute", () => $b264455695405ab2$export$4501213a8b1d3a10);
const $b264455695405ab2$export$4501213a8b1d3a10 = {
    name: 'arj-settings-permissions',
    path: '/jira/plans/settings/permissions'
};

});


parcelRegister("eOPb5", function(module, exports) {

$parcel$export(module.exports, "arjSettingsPermissionsRouteLegacyRedirectRouteEntry", () => $75e3fe7119ee0518$export$949c8177281fcc39);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $1aR84 = parcelRequire("1aR84");

var $3RJkv = parcelRequire("3RJkv");

var $dl4rj = parcelRequire("dl4rj");

var $a9hcp = parcelRequire("a9hcp");

var $i8IhR = parcelRequire("i8IhR");
const $75e3fe7119ee0518$export$949c8177281fcc39 = (0, $7NszV.createEntry)((0, $dl4rj.arjSettingsPermissionsRouteLegacyRedirectRoute), ()=>({
        group: 'software',
        component: (0, $i8IhR.redirectTo)('/jira/plans/settings/permissions'),
        isRedirect: true,
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $1aR84.getGlobalPermissionPageResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a9hcp.LazyArjSettingsPermissions)
        ]
    }));

});
parcelRegister("dl4rj", function(module, exports) {

$parcel$export(module.exports, "arjSettingsPermissionsRouteLegacyRedirectRoute", () => $a53440ab81155fb2$export$24bf73f2d1dbf0db);
const $a53440ab81155fb2$export$24bf73f2d1dbf0db = {
    name: 'arj-settings-permissions-redirect',
    path: '/secure/PortfolioPermissions.jspa'
};

});


parcelRegister("vDjHk", function(module, exports) {

$parcel$export(module.exports, "archivedPlansRouteEntry", () => $2934b1049cdc0b54$export$b9921058a8a65710);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $ixtmm = parcelRequire("ixtmm");

var $7kSGc = parcelRequire("7kSGc");
const $2934b1049cdc0b54$export$b9921058a8a65710 = (0, $7NszV.createEntry)((0, $ixtmm.archivedPlansRoute), ()=>({
        group: 'global-settings',
        component: (0, $7kSGc.ArchivedPlansDirectory),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7kSGc.LazyArchivedPlans)
        ]
    }));

});
parcelRegister("ixtmm", function(module, exports) {

$parcel$export(module.exports, "archivedPlansRoute", () => $8d4bd95d29fd1b87$export$29647353386ad146);
const $8d4bd95d29fd1b87$export$29647353386ad146 = {
    name: 'archived-plans-directory',
    path: '/jira/plans/settings/archive',
    exact: true
};

});

parcelRegister("7kSGc", function(module, exports) {

$parcel$export(module.exports, "LazyArchivedPlans", () => $e8a09ac95de555a1$export$cf676f47aba10db8);
$parcel$export(module.exports, "ArchivedPlansDirectory", () => $e8a09ac95de555a1$export$ed59bbc59461c00f);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $e8a09ac95de555a1$export$cf676f47aba10db8 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("jrnuK")).then((module)=>module.ArchivedPlans)), {
    moduleId: "./src/packages/spa-apps/admin-pages/archived-plans/src/index.tsx"
});
const $e8a09ac95de555a1$export$ed59bbc59461c00f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e8a09ac95de555a1$export$cf676f47aba10db8,
        pageId: "archived-plans",
        shouldShowSpinner: true
    });

});
parcelRegister("jrnuK", function(module, exports) {

let $e272c38651aa7997$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e272c38651aa7997$var$load("kLYDM").then(()=>parcelRequire('14EEk'));

});



parcelRegister("jZMnM", function(module, exports) {

$parcel$export(module.exports, "arjSettingsFinancialYearPageRouteEntry", () => $a36cb3f650c3074c$export$b6bba25826e621b9);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $7j3uW = parcelRequire("7j3uW");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $avmE3 = parcelRequire("avmE3");

var $Jhp2x = parcelRequire("Jhp2x");
const $a36cb3f650c3074c$export$b6bba25826e621b9 = (0, $7NszV.createEntry)((0, $avmE3.arjSettingsFinancialYearPageRoute), ()=>({
        group: 'software',
        component: (0, $Jhp2x.ArjSettingsFinancialYear),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $7j3uW.arjSettingsFinancialYearResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $Jhp2x.LazyArjSettingsFinancialYear)
        ]
    }));

});
parcelRegister("7j3uW", function(module, exports) {

$parcel$export(module.exports, "arjSettingsFinancialYearResource", () => $59a235170c0d382a$export$da45020eede4a793);

var $7f4tk = parcelRequire("7f4tk");

var $2M1hQ = parcelRequire("2M1hQ");

const $59a235170c0d382a$export$da45020eede4a793 = (0, $2M1hQ.createResource)({
    type: (0, $b242b5aa0787944c$export$e8e0384e95388aa3),
    getKey: ()=>'financial-year-information',
    getData: async ()=>(0, $7f4tk.default)('/rest/jpo/1.0/fiscalYear'),
    maxAge: 0
});

});
const $b242b5aa0787944c$export$e8e0384e95388aa3 = 'RESOURCE_TYPE_ARJ_SETTINGS_FINANCIAL_YEAR';


parcelRegister("avmE3", function(module, exports) {

$parcel$export(module.exports, "arjSettingsFinancialYearPageRoute", () => $7565a345f1dea2b4$export$7208300f00a36a5f);
const $7565a345f1dea2b4$export$7208300f00a36a5f = {
    name: 'arj-settings-financial-year',
    path: '/jira/plans/settings/financial-year',
    exact: true
};

});

parcelRegister("Jhp2x", function(module, exports) {

$parcel$export(module.exports, "LazyArjSettingsFinancialYear", () => $b5d39848dc9e7ba6$export$dd67c2f01a58231e);
$parcel$export(module.exports, "ArjSettingsFinancialYear", () => $b5d39848dc9e7ba6$export$785180185eba7ed9);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $b5d39848dc9e7ba6$export$dd67c2f01a58231e = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("f12PB")).then((module)=>module.ArjSettingsFinancialYear)), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/financial-year/index.tsx"
});
const $b5d39848dc9e7ba6$export$785180185eba7ed9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $b5d39848dc9e7ba6$export$dd67c2f01a58231e,
        pageId: "arj-settings-financial-year",
        shouldShowSpinner: true
    });

});
parcelRegister("f12PB", function(module, exports) {

let $aee92543390ff07d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $aee92543390ff07d$var$load("fFgLm").then(()=>parcelRequire('7bDNN'));

});



parcelRegister("5nA0V", function(module, exports) {

$parcel$export(module.exports, "planIncrementRouteEntry", () => $13d9e6b7582fbfc8$export$a26fa5cabff8bc7c);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $8iyFV = parcelRequire("8iyFV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $czMjG = parcelRequire("czMjG");

var $4R6GH = parcelRequire("4R6GH");

var $eCdAs = parcelRequire("eCdAs");

var $8iKh5 = parcelRequire("8iKh5");
const $13d9e6b7582fbfc8$export$a26fa5cabff8bc7c = (0, $7NszV.createEntry)((0, $czMjG.planIncrementRoute), ()=>({
        group: 'software',
        entryPoint: ()=>// eslint-disable-next-line no-nested-ternary
            (0, $4R6GH.fg)('migrate_plans_to_entrypoints') ? (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? (0, $eCdAs.planIncrementPageEntryPoint) : (0, $eCdAs.planIncrementPageEntryPointWithoutHorizontalNavigation) : undefined,
        component: (0, $8iKh5.PlanIncrement),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default),
            horizontal: (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? undefined : (0, $8iyFV.AsyncHorizontalNavPlans),
            onlyShowHorizontalOnNav4: true
        },
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8iKh5.LazyPlanIncrement)
        ]
    }));

});
parcelRegister("czMjG", function(module, exports) {

$parcel$export(module.exports, "planIncrementRoute", () => $1f9e3780cba4a3e0$export$ef33a75556fde209);
const $1f9e3780cba4a3e0$export$ef33a75556fde209 = {
    name: 'software-plan-increment',
    path: '/jira/plans/:planId/scenarios/:scenarioId/program/:incrementId',
    exact: true
};

});

parcelRegister("eCdAs", function(module, exports) {

$parcel$export(module.exports, "planIncrementPageEntryPoint", () => $fd8b21deba1fc1a8$export$a87dd3f7b0d2f7c2);
$parcel$export(module.exports, "planIncrementPageEntryPointWithoutHorizontalNavigation", () => $fd8b21deba1fc1a8$export$1d20f43e7336cbe6);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $8tlKP = parcelRequire("8tlKP");

var $57oLc = parcelRequire("57oLc");
const $fd8b21deba1fc1a8$export$a87dd3f7b0d2f7c2 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $8tlKP.planIncrementEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS,
    horizontalNavigation: (0, $57oLc.plansHorizontalNavigationEntryPoint)
});
const $fd8b21deba1fc1a8$export$1d20f43e7336cbe6 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $8tlKP.planIncrementEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});

});

parcelRegister("8iKh5", function(module, exports) {

$parcel$export(module.exports, "LazyPlanIncrement", () => $e45281955bb769d7$export$e7b9f83d442bac51);
$parcel$export(module.exports, "PlanIncrement", () => $e45281955bb769d7$export$5e1035d0876d64db);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $e45281955bb769d7$export$e7b9f83d442bac51 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("eDGY6"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-increment/index-old.tsx"
});
const $e45281955bb769d7$export$5e1035d0876d64db = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e45281955bb769d7$export$e7b9f83d442bac51,
        pageId: "plan-increment",
        shouldShowSpinner: true
    });

});


parcelRegister("bQ0RK", function(module, exports) {

$parcel$export(module.exports, "planIncrementsRouteEntry", () => $38c9ffd9e7c2e0a9$export$f7abc47036ff7dd9);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $8iyFV = parcelRequire("8iyFV");

var $lmyls = parcelRequire("lmyls");

var $937TY = parcelRequire("937TY");

var $451ix = parcelRequire("451ix");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $c3WQb = parcelRequire("c3WQb");

var $3RJkv = parcelRequire("3RJkv");

var $f3F6W = parcelRequire("f3F6W");

var $4R6GH = parcelRequire("4R6GH");

var $iHuPr = parcelRequire("iHuPr");

var $fw6rG = parcelRequire("fw6rG");
const $38c9ffd9e7c2e0a9$export$f7abc47036ff7dd9 = (0, $7NszV.createEntry)((0, $f3F6W.planIncrementsRoute), ()=>({
        group: 'software',
        entryPoint: ()=>// eslint-disable-next-line no-nested-ternary
            (0, $4R6GH.fg)('migrate_plans_to_entrypoints') ? (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? (0, $fw6rG.planProgramPageEntryPoint) : (0, $fw6rG.planProgramPageEntryPointWithoutHorizontalNavigation) : undefined,
        component: (0, $iHuPr.PlanProgram),
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $451ix.planLayout)),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS,
            sidebar: (0, $937TY.default),
            horizontal: (0, $4R6GH.fg)('migrate_plans_navigation_to_relay') ? undefined : (0, $8iyFV.AsyncHorizontalNavPlans),
            onlyShowHorizontalOnNav4: true
        },
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarPlanResources)(),
            (0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $c3WQb.advancedRoadmapsReduxStoreStateResource),
            (0, $c3WQb.advancedRoadmapsLastVisitedProgramBoardIdResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $iHuPr.LazyPlanProgram)
        ]
    }));

});
parcelRegister("f3F6W", function(module, exports) {

$parcel$export(module.exports, "planIncrementsRoute", () => $1fae537885c9da25$export$d0986e4bd9568b30);
const $1fae537885c9da25$export$d0986e4bd9568b30 = {
    name: 'software-plan-increments',
    path: '/jira/plans/:planId/scenarios/:scenarioId/program',
    exact: true
};

});

parcelRegister("iHuPr", function(module, exports) {

$parcel$export(module.exports, "LazyPlanProgram", () => $ad7f54b0993adadc$export$9da4d4d5c4d7f749);
$parcel$export(module.exports, "PlanProgram", () => $ad7f54b0993adadc$export$fb30c2b19a4f5d59);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $ad7f54b0993adadc$export$9da4d4d5c4d7f749 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("7tZ8j"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-program/index-old.tsx"
});
const $ad7f54b0993adadc$export$fb30c2b19a4f5d59 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ad7f54b0993adadc$export$9da4d4d5c4d7f749,
        pageId: "plan-program",
        shouldShowSpinner: true
    });

});
parcelRegister("7tZ8j", function(module, exports) {

let $572aa99a7b7a4523$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("fRF2W"), 4)),
    $572aa99a7b7a4523$var$load("foI4g")
]).then(()=>parcelRequire('hWHTd'));

});


parcelRegister("fw6rG", function(module, exports) {

$parcel$export(module.exports, "planProgramPageEntryPoint", () => $d0d482e714f6dec6$export$cb6ac90e8faddaeb);
$parcel$export(module.exports, "planProgramPageEntryPointWithoutHorizontalNavigation", () => $d0d482e714f6dec6$export$4d1acef570d425d5);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $avgZu = parcelRequire("avgZu");

var $57oLc = parcelRequire("57oLc");
const $d0d482e714f6dec6$export$cb6ac90e8faddaeb = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $avgZu.planProgramEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS,
    horizontalNavigation: (0, $57oLc.plansHorizontalNavigationEntryPoint)
});
const $d0d482e714f6dec6$export$4d1acef570d425d5 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $avgZu.planProgramEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PLANS
});

});
parcelRegister("avgZu", function(module, exports) {

$parcel$export(module.exports, "planProgramEntryPoint", () => $9e8c359432edc7ee$export$da91c765d9841bae);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $9e8c359432edc7ee$export$da91c765d9841bae = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        if (!false) return (parcelRequire("5HXqS"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "1b761aac"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("5HXqS", function(module, exports) {

let $427f11f3aa36e392$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("6uYTH"), 4)),
    $427f11f3aa36e392$var$load("lPt5E")
]).then(()=>parcelRequire('laRNy'));

});




parcelRegister("7UDCM", function(module, exports) {

$parcel$export(module.exports, "trashedPlanDirectLinkRouteEntry", () => $5f2b7d10b2a973db$export$dbcd0bd16f12397d);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $3V9Zd = parcelRequire("3V9Zd");

var $7Knxu = parcelRequire("7Knxu");
const $5f2b7d10b2a973db$export$dbcd0bd16f12397d = (0, $7NszV.createEntry)((0, $3V9Zd.trashedPlanDirectLinkRoute), ()=>({
        group: 'software',
        component: (0, $7Knxu.TrashedPlanDirectLink),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7Knxu.LazyTrashedPlanDirectLink)
        ],
        ufoName: 'plan-trashed'
    }));

});
parcelRegister("3V9Zd", function(module, exports) {

$parcel$export(module.exports, "trashedPlanDirectLinkRoute", () => $378d003abbed757a$export$1a9edb72cd49ca79);
const $378d003abbed757a$export$1a9edb72cd49ca79 = {
    name: 'trashed-plan-direct-link',
    path: '/jira/plans/plan-trashed',
    exact: true
};

});

parcelRegister("7Knxu", function(module, exports) {

$parcel$export(module.exports, "LazyTrashedPlanDirectLink", () => $1e04fb6816f8b0a0$export$20a71ac28e6a3c8f);
$parcel$export(module.exports, "TrashedPlanDirectLink", () => $1e04fb6816f8b0a0$export$38f3a061bb1fceee);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $1e04fb6816f8b0a0$export$20a71ac28e6a3c8f = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hAIat"))), {
    moduleId: "./src/packages/portfolio-3/plan-trashed-direct-link/src/index.tsx"
});
const $1e04fb6816f8b0a0$export$38f3a061bb1fceee = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $1e04fb6816f8b0a0$export$20a71ac28e6a3c8f,
        pageId: "trashed-plan-direct-link",
        shouldShowSpinner: false
    });

});
parcelRegister("hAIat", function(module, exports) {

let $cce80f468b7d02e6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cce80f468b7d02e6$var$load("51g3z").then(()=>parcelRequire('kIqMQ'));

});



parcelRegister("hDCtq", function(module, exports) {

$parcel$export(module.exports, "trashPlansRouteEntry", () => $2d67b465f26d4e76$export$eabcbe4dd6fc9f1f);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $711SD = parcelRequire("711SD");

var $cm0sO = parcelRequire("cm0sO");
const $2d67b465f26d4e76$export$eabcbe4dd6fc9f1f = (0, $7NszV.createEntry)((0, $711SD.trashPlansRoute), ()=>({
        group: 'software',
        component: (0, $cm0sO.TrashedPlansDirectory),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cm0sO.LazyTrashedPlans)
        ]
    }));

});
parcelRegister("711SD", function(module, exports) {

$parcel$export(module.exports, "trashPlansRoute", () => $83fe99f2cd6e2d28$export$6f5b50c5dc090fd1);
const $83fe99f2cd6e2d28$export$6f5b50c5dc090fd1 = {
    name: 'trash-plans-directory',
    path: '/jira/plans/settings/trash',
    exact: true
};

});

parcelRegister("cm0sO", function(module, exports) {

$parcel$export(module.exports, "LazyTrashedPlans", () => $87393f1bbf5aac77$export$6ac18b311b7e51a1);
$parcel$export(module.exports, "TrashedPlansDirectory", () => $87393f1bbf5aac77$export$b145fa65818ff157);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $87393f1bbf5aac77$export$6ac18b311b7e51a1 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("kw1bf")).then((module)=>module.TrashedPlans)), {
    moduleId: "./src/packages/spa-apps/admin-pages/trashed-plans/src/index.tsx"
});
const $87393f1bbf5aac77$export$b145fa65818ff157 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $87393f1bbf5aac77$export$6ac18b311b7e51a1,
        pageId: "trashed-plans",
        shouldShowSpinner: true
    });

});
parcelRegister("kw1bf", function(module, exports) {

let $eef7b6332fe7069b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eef7b6332fe7069b$var$load("7JPyq").then(()=>parcelRequire('95BjK'));

});



parcelRegister("9CxHM", function(module, exports) {

$parcel$export(module.exports, "archivedProjectDirectLinkRouteEntry", () => $83811b47cb2e3e0c$export$45e68d450757a753);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $lQihQ = parcelRequire("lQihQ");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $83811b47cb2e3e0c$var$LazyArchivedDirectLink = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("eChrF"))), {
    moduleId: "./src/packages/project-pages/project-archive/project-archived-direct-link/src/index.tsx"
});
const $83811b47cb2e3e0c$var$ArchivedProjectDirectLink = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $83811b47cb2e3e0c$var$LazyArchivedDirectLink,
        pageId: "archived-project-direct-link",
        shouldShowSpinner: false
    });
const $83811b47cb2e3e0c$export$45e68d450757a753 = (0, $7NszV.createEntry)((0, $lQihQ.archivedProjectDirectLinkRoute), ()=>({
        group: 'redirects',
        component: $83811b47cb2e3e0c$var$ArchivedProjectDirectLink,
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $83811b47cb2e3e0c$var$LazyArchivedDirectLink
        ],
        ufoName: 'project-archived'
    }));

});
parcelRegister("lQihQ", function(module, exports) {

$parcel$export(module.exports, "archivedProjectDirectLinkRoute", () => $fcb9d046350a5535$export$cd3fc26cf9f696e6);
const $fcb9d046350a5535$export$cd3fc26cf9f696e6 = {
    name: 'archived-project-direct-link',
    path: '/jira/errors/project-archived',
    exact: true
};

});

parcelRegister("eChrF", function(module, exports) {

let $aa42259292dabe0f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $aa42259292dabe0f$var$load("kjQ1f").then(()=>parcelRequire('hCnfn'));

});


parcelRegister("eaKG5", function(module, exports) {

$parcel$export(module.exports, "archivedProjectsDirectoryRouteEntry", () => $e0db3e001ba4740c$export$dc5f9e3c3931cc36);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $4jMkc = parcelRequire("4jMkc");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $hxN3x = parcelRequire("hxN3x");

var $5I9ar = parcelRequire("5I9ar");
const $e0db3e001ba4740c$export$dc5f9e3c3931cc36 = (0, $7NszV.createEntry)((0, $hxN3x.archivedProjectsDirectoryRoute), ()=>({
        group: 'global-settings',
        component: (0, $5I9ar.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $4jMkc.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5I9ar.LazyArchivedProjectsAdmin)
        ],
        ufoName: 'admin.archived-projects'
    }));

});
parcelRegister("4jMkc", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb7b1354cffbd527$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

const $bb7b1354cffbd527$var$LazyGlobalProjectsSettingsSidebar = (0, $kxZPA.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("d3AdC")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-projects/src/index.tsx"
});
const $bb7b1354cffbd527$var$GlobalProjectsSettingsSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "globalProjectsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb7b1354cffbd527$var$LazyGlobalProjectsSettingsSidebar, null)));
$bb7b1354cffbd527$var$GlobalProjectsSettingsSidebar.displayName = 'GlobalProjectsSettingsSidebar';
var $bb7b1354cffbd527$export$2e2bcd8739ae039 = $bb7b1354cffbd527$var$GlobalProjectsSettingsSidebar;

});
parcelRegister("d3AdC", function(module, exports) {

let $9817a66fb94471fb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9817a66fb94471fb$var$load("kMEyC").then(()=>parcelRequire('1tunp'));

});


parcelRegister("hxN3x", function(module, exports) {

$parcel$export(module.exports, "archivedProjectsDirectoryRoute", () => $cdb39a82bf3cd9b0$export$b60634d0fa43f719);
const $cdb39a82bf3cd9b0$export$b60634d0fa43f719 = {
    name: 'archived-projects-directory',
    path: '/jira/settings/projects/archive',
    exact: true
};

});

parcelRegister("5I9ar", function(module, exports) {

$parcel$export(module.exports, "LazyArchivedProjectsAdmin", () => $7076addc4fa02bdc$export$b220ffb582ee39aa);
$parcel$export(module.exports, "default", () => $7076addc4fa02bdc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $7076addc4fa02bdc$export$b220ffb582ee39aa = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("jNGTv"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/archived-projects/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7076addc4fa02bdc$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $7076addc4fa02bdc$export$b220ffb582ee39aa,
        pageId: "archived-projects",
        shouldShowSpinner: true
    });

});
parcelRegister("jNGTv", function(module, exports) {

let $e6a3ddd469e432b7$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e6a3ddd469e432b7$var$load("fliVL"),
    $e6a3ddd469e432b7$var$load("hPxUI")
]).then(()=>parcelRequire('jOclj'));

});



parcelRegister("9wv3p", function(module, exports) {

$parcel$export(module.exports, "archivedWorkItemsJsmRouteEntry", () => $0ef8f8fd7220fcba$export$cdfe13bfc51ce940);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $7547l = parcelRequire("7547l");

var $6Z2mh = parcelRequire("6Z2mh");

var $gDHR4 = parcelRequire("gDHR4");
const $0ef8f8fd7220fcba$export$cdfe13bfc51ce940 = (0, $7NszV.createEntry)((0, $7547l.archivedWorkItemsJsmRoute), ()=>({
        group: 'archived-work-items',
        // Refer: issueNavigatorProjectServicedeskRoute from issue-navigator
        layout: (0, $6Z2mh.serviceProjectLayout),
        entryPoint: ()=>(0, $gDHR4.archivedIssuesWithoutHorizontalNavPageEntryPoint),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ]
    }));

});
parcelRegister("iEUaw", function(module, exports) {

$parcel$export(module.exports, "staticSidebarShortcutsResource", () => $681ca3c44ff39b04$export$4847c29b4786b3b4);

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");

var $bskkv = parcelRequire("bskkv");
const $681ca3c44ff39b04$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $681ca3c44ff39b04$export$4847c29b4786b3b4 = (0, $2M1hQ.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_SHORTCUTS',
    getKey: ({ match: match, query: query })=>$681ca3c44ff39b04$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $681ca3c44ff39b04$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const shortcuts = await (0, $bskkv.fetchShortcuts)(projectKeyOrId);
        return shortcuts;
    },
    maxAge: 300000
});

});
parcelRegister("bskkv", function(module, exports) {

$parcel$export(module.exports, "fetchShortcuts", () => $b1e90e13aab5fe84$export$49d696bf2525d700);

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");
const $b1e90e13aab5fe84$export$49d696bf2525d700 = (projectKeyOrId)=>{
    try {
        return (0, $7f4tk.default)(`/rest/projects/1.0/project/${projectKeyOrId}/shortcut`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.trackFetchErrors)({
            error: error,
            id: 'fetchProjectShortcuts',
            packageName: 'jiraNavigationAppsResources'
        });
        throw error;
    }
};

});


parcelRegister("7GnDe", function(module, exports) {

$parcel$export(module.exports, "incidentsInitialPageChecksResource", () => $08a008dcde68e650$export$b2b94ce8ba590cc8);
$parcel$export(module.exports, "incidentsCustomFieldIdResource", () => $08a008dcde68e650$export$e81d7afef87ae597);
$parcel$export(module.exports, "incidentExperimentTraitResource", () => $08a008dcde68e650$export$31c6945718067be3);
$parcel$export(module.exports, "incidentExperimentTraitResourceOnNav3Only", () => $08a008dcde68e650$export$6fc19cf1d90e9453);
$parcel$export(module.exports, "incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes", () => $08a008dcde68e650$export$2e6b9e6402ff1d9b);

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");


const $08a008dcde68e650$export$b2b94ce8ba590cc8 = (0, $2M1hQ.createResource)({
    type: (0, $0ec4f2aa733ae93d$export$9018fdf9116edd9b),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("eA3vK"))
});

const $08a008dcde68e650$export$e81d7afef87ae597 = (0, $2M1hQ.createResource)({
    type: (0, $0ec4f2aa733ae93d$export$508a7d8e5c6b1bf),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("2QXl3"))
});

const $08a008dcde68e650$export$31c6945718067be3 = (0, $2M1hQ.createResource)({
    type: (0, $0ec4f2aa733ae93d$export$1d954e05e596a51e),
    getKey: ()=>'incident_experiment_traits',
    getDataLoader: ()=>(parcelRequire("1tPE5")),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $08a008dcde68e650$export$6fc19cf1d90e9453 = (0, $gNStA.resourceWithCondition2)(()=>!((0, $3HwlS.getWillShowNav4)() && ((0, $4R6GH.fg)('perf-push-big-components-remove-incidents-resource') || (0, $4R6GH.fg)('perf-push-big-components-nav-remove-resources'))), $08a008dcde68e650$export$31c6945718067be3);
const $08a008dcde68e650$export$2e6b9e6402ff1d9b = (0, $gNStA.resourceWithCondition2)(()=>!((0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('blu-5573-remove-incident-resouce')), $08a008dcde68e650$export$31c6945718067be3);

});
const $0ec4f2aa733ae93d$export$9018fdf9116edd9b = 'INCIDENTS_PAGE_INITIAL_CHECKS';
const $0ec4f2aa733ae93d$export$508a7d8e5c6b1bf = 'INCIDENTS_PAGE_CUSTOM_FIELD_ID';
const $0ec4f2aa733ae93d$export$1d954e05e596a51e = 'INCIDENT_EXPERIMENT_TRAITS';

parcelRegister("eA3vK", function(module, exports) {

let $a9d726b5ee8125b7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a9d726b5ee8125b7$var$load("g5RXm").then(()=>parcelRequire('8lQN4'));

});

parcelRegister("2QXl3", function(module, exports) {

let $213e777c9e548445$var$load = (parcelRequire("28QjX"))(4);
module.exports = $213e777c9e548445$var$load("aq0V6").then(()=>parcelRequire('i0mY9'));

});

parcelRegister("1tPE5", function(module, exports) {

let $11408f9e8be4e3bd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $11408f9e8be4e3bd$var$load("7YGJS").then(()=>parcelRequire('iwLnj'));

});


parcelRegister("7547l", function(module, exports) {

$parcel$export(module.exports, "archivedWorkItemsJsmRoute", () => $ae80b44a428c958a$export$36e9c9de963d9a4f);
const $ae80b44a428c958a$export$36e9c9de963d9a4f = {
    name: 'servicedesk-archived-work-items',
    path: '/jira/servicedesk/projects/:projectKey/archived-work-items',
    exact: true
};

});

parcelRegister("6Z2mh", function(module, exports) {

$parcel$export(module.exports, "serviceProjectLayout", () => $0836cf39cca1e468$export$e321cb31c875d1ba);
$parcel$export(module.exports, "rightSidebarsLayout", () => $0836cf39cca1e468$export$820f9bb834280408);

var $2vSU6 = parcelRequire("2vSU6");

var $2BrOV = parcelRequire("2BrOV");

var $i90UH = parcelRequire("i90UH");

var $1Du13 = parcelRequire("1Du13");

var $aPfsS = parcelRequire("aPfsS");

var $ln7rs = parcelRequire("ln7rs");

var $kxZPA = parcelRequire("kxZPA");
// TODO Remove this whenever all service project route paths are no longer ambiguous
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0836cf39cca1e468$var$withServiceProjectContext = (Component)=>(0, $aPfsS.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $2vSU6.SERVICE_DESK_PROJECT)
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0836cf39cca1e468$var$ProjectBuilder = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("hKk8D")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/project-builder/ProjectBuilderWithQueryParam.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0836cf39cca1e468$var$Onboarding = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("3keC1")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/onboarding/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0836cf39cca1e468$var$RightSidebars = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("b0uMO")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/right-sidebars/RightSidebars.tsx"
});
const $0836cf39cca1e468$export$e321cb31c875d1ba = (0, $aPfsS.composeLayouts)((0, $1Du13.projectLayout), {
    globalComponents: [
        $0836cf39cca1e468$var$withServiceProjectContext($0836cf39cca1e468$var$Onboarding),
        ...(0, $ln7rs.serviceProjectFirstImpressionsLayout).globalComponents.map($0836cf39cca1e468$var$withServiceProjectContext),
        $0836cf39cca1e468$var$withServiceProjectContext((0, $i90UH.AsyncJsmCustomDomainChangeBoardingFlag)),
        $0836cf39cca1e468$var$ProjectBuilder
    ],
    rightSidebars: [
        $0836cf39cca1e468$var$withServiceProjectContext($0836cf39cca1e468$var$RightSidebars),
        ...(0, $ln7rs.serviceProjectFirstImpressionsLayout).rightSidebars.map($0836cf39cca1e468$var$withServiceProjectContext)
    ]
});
const $0836cf39cca1e468$export$820f9bb834280408 = (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), {
    rightSidebars: [
        $0836cf39cca1e468$var$RightSidebars
    ]
});

});
parcelRegister("i90UH", function(module, exports) {

$parcel$export(module.exports, "AsyncJsmCustomDomainChangeBoardingFlag", () => $3ba5f01428db990d$export$b1ef5e3da6e1959d);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3ba5f01428db990d$var$LazyJsmCustomDomainChangeBoardingFlag = (0, $kxZPA.lazy)(()=>(parcelRequire("lMgFf")), {
    moduleId: "./src/packages/servicedesk/custom-domain-change-boarding/src/ui/index.tsx"
});
const $3ba5f01428db990d$export$b1ef5e3da6e1959d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async-jsm-custom-domain-change-boarding-flag",
        packageName: "jira-help-center-custom-domain-change-boarding"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-custom-domain-change-boarding-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ba5f01428db990d$var$LazyJsmCustomDomainChangeBoardingFlag, null)));

});
parcelRegister("lMgFf", function(module, exports) {

let $fdab01deb3f0b2a6$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $fdab01deb3f0b2a6$var$load("ffQaD"),
    $fdab01deb3f0b2a6$var$load("kvRbA"),
    $fdab01deb3f0b2a6$var$load("6l1Sn")
]).then(()=>parcelRequire('9d42Z'));

});


parcelRegister("1Du13", function(module, exports) {

$parcel$export(module.exports, "projectLayout", () => $08491b76212b7395$export$204149bac601d20c);

var $fpzhz = parcelRequire("fpzhz");

var $aPfsS = parcelRequire("aPfsS");

var $kxZPA = parcelRequire("kxZPA");

var $hMrxB = parcelRequire("hMrxB");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $08491b76212b7395$var$withAnyProjectContext = (Component)=>(0, $aPfsS.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: 'any'
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $08491b76212b7395$var$ProjectTrackers = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("2bckt")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/project-layout/src/ui/trackers/index.tsx"
});
const $08491b76212b7395$var$ProjectFavicon = ()=>{
    (0, $hMrxB.useProjectFavicon)();
    return null;
};
const $08491b76212b7395$var$rightSidebars = ()=>[];
const $08491b76212b7395$var$globalComponents = [
    $08491b76212b7395$var$withAnyProjectContext($08491b76212b7395$var$ProjectFavicon),
    $08491b76212b7395$var$withAnyProjectContext($08491b76212b7395$var$ProjectTrackers),
    $08491b76212b7395$var$withAnyProjectContext((0, $fpzhz.ProjectRouteListener))
];
const $08491b76212b7395$export$204149bac601d20c = (0, $aPfsS.createLayout)({
    globalComponents: $08491b76212b7395$var$globalComponents,
    rightSidebars: $08491b76212b7395$var$rightSidebars()
});

});
parcelRegister("fpzhz", function(module, exports) {

$parcel$export(module.exports, "ProjectRouteListener", () => $a96b9050ddfb05f9$export$159f09d701320911);

var $5uXOq = parcelRequire("5uXOq");

var $dxCvy = parcelRequire("dxCvy");

var $itmJb = parcelRequire("itmJb");

var $2YP9W = parcelRequire("2YP9W");

var $hVf1M = parcelRequire("hVf1M");
const $a96b9050ddfb05f9$export$159f09d701320911 = ()=>{
    const isSiteAdmin = (0, $itmJb.useIsAdmin)();
    const { data: data, loading: loading } = (0, $2YP9W.useResource)((0, $dxCvy.projectContextResource));
    (0, $5uXOq.useEffect)(()=>{
        if (isSiteAdmin) (0, $hVf1M.setIsProjectAdmin)({
            loading: false,
            isProjectAdmin: true
        });
        else if (data != null) (0, $hVf1M.setIsProjectAdmin)({
            loading: false,
            isProjectAdmin: data.isProjectAdmin
        });
        else (0, $hVf1M.setIsProjectAdmin)({
            loading: loading,
            isProjectAdmin: null
        });
    }, [
        data,
        loading,
        isSiteAdmin
    ]);
    // Cleanup when component is unmounted. This means we are no longer in a project route
    (0, $5uXOq.useEffect)(()=>()=>(0, $hVf1M.setIsProjectAdmin)({
                loading: false,
                isProjectAdmin: null
            }), []);
    return null;
};

});

parcelRegister("hMrxB", function(module, exports) {

$parcel$export(module.exports, "useProjectFavicon", () => $6ee68e956a566e2d$export$32abcb1f939de016);

var $5uXOq = parcelRequire("5uXOq");

var $j8DrX = parcelRequire("j8DrX");

var $lpwtK = parcelRequire("lpwtK");

var $4R6GH = parcelRequire("4R6GH");
const $6ee68e956a566e2d$export$32abcb1f939de016 = false ? ()=>undefined : ()=>{
    const { data: project } = (0, $lpwtK.useProject)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const iconEle = document.querySelector("link[rel='shortcut icon']");
    // Keep a copy of the default favicon
    const defaultFavicon = (0, $5uXOq.useMemo)(()=>iconEle instanceof HTMLLinkElement ? iconEle.href : '', [
        iconEle
    ]);
    const enabled = (0, $5uXOq.useMemo)(()=>(0, $j8DrX.default)('ajs-favicon-use-projecticon') === 'true', []);
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $4R6GH.fg)('blu-7193-new-jira-favicons')) {
            const favicon = project ? project.avatarUrl : defaultFavicon;
            if (enabled && iconEle instanceof HTMLLinkElement) iconEle.href = favicon;
            // Switch back to default favicon
            return ()=>{
                if (enabled && iconEle instanceof HTMLLinkElement) iconEle.href = defaultFavicon;
            };
        }
    }, [
        project,
        iconEle,
        defaultFavicon,
        enabled
    ]);
};

});

parcelRegister("2bckt", function(module, exports) {

let $19662c29308a8340$var$load = (parcelRequire("28QjX"))(4);
module.exports = $19662c29308a8340$var$load("adefN").then(()=>parcelRequire('8DuT4'));

});


parcelRegister("ln7rs", function(module, exports) {

$parcel$export(module.exports, "serviceProjectFirstImpressionsLayout", () => $f6f2168537ade4c7$export$2562b2d784eadc10);

var $5uXOq = parcelRequire("5uXOq");

var $ctjgZ = parcelRequire("ctjgZ");

var $aPfsS = parcelRequire("aPfsS");

var $kxZPA = parcelRequire("kxZPA");
const $f6f2168537ade4c7$var$withServiceProjectAccess = (Component)=>{
    const ScopedComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctjgZ.default), {
            hasServiceDeskAccess: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, null));
    const name = (0, $aPfsS.coalesce)(Component.displayName) ?? (0, $aPfsS.coalesce)(Component.name) ?? 'Component';
    ScopedComponent.displayName = `withServiceProjectAccess(${name})`;
    return ScopedComponent;
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f6f2168537ade4c7$var$Onboarding = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("3wGaf")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-first-impressions-layout/src/ui/onboarding/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f6f2168537ade4c7$var$RightSidebars = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("2WJ1Q")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-first-impressions-layout/src/ui/right-sidebars/RightSidebars.tsx"
});
const $f6f2168537ade4c7$export$2562b2d784eadc10 = (0, $aPfsS.createLayout)({
    globalComponents: [
        $f6f2168537ade4c7$var$withServiceProjectAccess($f6f2168537ade4c7$var$Onboarding)
    ],
    rightSidebars: [
        $f6f2168537ade4c7$var$withServiceProjectAccess($f6f2168537ade4c7$var$RightSidebars)
    ]
});

});
parcelRegister("ctjgZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ead1b5a586c4cb4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9OXo1 = parcelRequire("9OXo1");

var $1Yett = parcelRequire("1Yett");
/**
 * Manages the visibility of child components based on user permissions within a multi-tenant environment.
 * It leverages the application's permission settings to determine access rights, ensuring components are only accessible to users with the appropriate permissions.
 * In development environments, it issues a warning when no access-related properties are provided, aiding in debug and development processes.
 */ const $4ead1b5a586c4cb4$var$AppPermissionsCheck = (props)=>{
    const { appPermissions: appPermissions } = (0, $9OXo1.useTenantContext)();
    if (props.hasServiceDeskAccess !== undefined && appPermissions.hasServiceDeskAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children);
    if (props.hasCoreAccess !== undefined && appPermissions.hasCoreAccess === props.hasCoreAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children);
    if (props.hasSoftwareAccess !== undefined && appPermissions.hasSoftwareAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children);
    if (props.hasServiceDeskAccess === undefined && props.hasCoreAccess === undefined && props.hasSoftwareAccess === undefined) {
        if ((0, $1Yett.isDevelopmentEnv)()) // eslint-disable-next-line no-console
        console.warn('AppPermissionsCheck should have defined at least one of access prop');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children);
    }
    return null;
};
$4ead1b5a586c4cb4$var$AppPermissionsCheck.defaultProps = {
    hasCoreAccess: undefined,
    hasSoftwareAccess: undefined,
    hasServiceDeskAccess: undefined
};
var $4ead1b5a586c4cb4$export$2e2bcd8739ae039 = $4ead1b5a586c4cb4$var$AppPermissionsCheck;

});
parcelRegister("1Yett", function(module, exports) {

$parcel$export(module.exports, "isDevelopmentEnv", () => $7b47955f7b675219$export$48e5fb80244b95c5);
const $7b47955f7b675219$export$48e5fb80244b95c5 = ()=>false;

});


parcelRegister("3wGaf", function(module, exports) {

let $291511380aa48c14$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $291511380aa48c14$var$load("kVX56"),
    $291511380aa48c14$var$load("76n7a"),
    $291511380aa48c14$var$load("l253H"),
    $291511380aa48c14$var$load("kGW3K")
]).then(()=>parcelRequire('fY1ne'));

});

parcelRegister("2WJ1Q", function(module, exports) {

let $2253ed54b080939a$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2253ed54b080939a$var$load("kVX56"),
    $2253ed54b080939a$var$load("76n7a"),
    $2253ed54b080939a$var$load("l253H"),
    $2253ed54b080939a$var$load("25kxa")
]).then(()=>parcelRequire('71Xxe'));

});


parcelRegister("hKk8D", function(module, exports) {

let $ceb65a9174daa7c7$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ceb65a9174daa7c7$var$load("kVX56"),
    $ceb65a9174daa7c7$var$load("dSxO1")
]).then(()=>parcelRequire('ekO4Z'));

});

parcelRegister("3keC1", function(module, exports) {

let $26be9310fa82205b$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $26be9310fa82205b$var$load("kVX56"),
    $26be9310fa82205b$var$load("ffQaD"),
    $26be9310fa82205b$var$load("kvRbA"),
    $26be9310fa82205b$var$load("76n7a"),
    $26be9310fa82205b$var$load("l253H"),
    $26be9310fa82205b$var$load("6iFUR")
]).then(()=>parcelRequire('dOvA3'));

});

parcelRegister("b0uMO", function(module, exports) {

let $803793501d5f35ba$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $803793501d5f35ba$var$load("kVX56"),
    $803793501d5f35ba$var$load("ffQaD"),
    $803793501d5f35ba$var$load("kvRbA"),
    $803793501d5f35ba$var$load("76n7a"),
    $803793501d5f35ba$var$load("l253H"),
    $803793501d5f35ba$var$load("7aqbD")
]).then(()=>parcelRequire('islsJ'));

});


parcelRegister("gDHR4", function(module, exports) {

$parcel$export(module.exports, "archivedIssuesPageEntryPoint", () => $64109391b810c516$export$e2fa7de87c15a81d);
$parcel$export(module.exports, "archivedIssuesWithoutHorizontalNavPageEntryPoint", () => $64109391b810c516$export$c001d316b1f89101);
$parcel$export(module.exports, "getCommonProjectLayout", () => $64109391b810c516$export$3dbe917a4c13b1e);

var $lkFvK = parcelRequire("lkFvK");

var $gyYxw = parcelRequire("gyYxw");

var $aPfsS = parcelRequire("aPfsS");

var $fo6b8 = parcelRequire("fo6b8");

var $lmyls = parcelRequire("lmyls");

var $1Qr8L = parcelRequire("1Qr8L");
const $64109391b810c516$export$e2fa7de87c15a81d = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1Qr8L.archivedIssuesEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $64109391b810c516$export$c001d316b1f89101 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1Qr8L.archivedIssuesEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $64109391b810c516$export$3dbe917a4c13b1e = ()=>(0, $aPfsS.createLayout)((0, $gyYxw.genericProjectLayout));

});
parcelRegister("gyYxw", function(module, exports) {

$parcel$export(module.exports, "genericProjectLayout", () => $177735c975452188$export$85dad8e9886563f6);

var $18N1t = parcelRequire("18N1t");

var $aPfsS = parcelRequire("aPfsS");

var $6Z2mh = parcelRequire("6Z2mh");

var $e7bC3 = parcelRequire("e7bC3");

var $9Y3Lc = parcelRequire("9Y3Lc");
const $177735c975452188$export$85dad8e9886563f6 = (0, $aPfsS.composeLayouts)((0, $e7bC3.classicSoftwareProjectLayout), (0, $18N1t.coreProjectLayout), (0, $6Z2mh.serviceProjectLayout), (0, $e7bC3.softwareProjectLayout), (0, $9Y3Lc.userBoardLayout));

});
parcelRegister("18N1t", function(module, exports) {

$parcel$export(module.exports, "coreProjectLayout", () => $32b20434a17da609$export$3c06ced9943ca671);

var $1Du13 = parcelRequire("1Du13");

var $aPfsS = parcelRequire("aPfsS");
const $32b20434a17da609$export$3c06ced9943ca671 = (0, $aPfsS.composeLayouts)((0, $1Du13.projectLayout));

});

parcelRegister("e7bC3", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareProjectLayout", () => $43d4c7537a1fee65$export$3791efdd32024063);
$parcel$export(module.exports, "softwareProjectLayout", () => $43d4c7537a1fee65$export$9a918616afa3328c);
$parcel$export(module.exports, "softwareProjectLayoutNoOnboarding", () => $43d4c7537a1fee65$export$ada52b1309832862);
$parcel$export(module.exports, "classicSoftwareProjectLayoutNoOnboarding", () => $43d4c7537a1fee65$export$6c1958653c44ba37);
$parcel$export(module.exports, "softwareProjectLayoutCode", () => $43d4c7537a1fee65$export$ab7e607e8441dc61);

var $2vSU6 = parcelRequire("2vSU6");

var $1Du13 = parcelRequire("1Du13");

var $aPfsS = parcelRequire("aPfsS");

var $kxZPA = parcelRequire("kxZPA");

var $cSD7y = parcelRequire("cSD7y");
// TODO Remove this whenever all software project route paths are no longer ambiguous
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $43d4c7537a1fee65$var$withAnySoftwareProjectContext = (Component)=>(0, $aPfsS.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $2vSU6.SOFTWARE_PROJECT)
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $43d4c7537a1fee65$var$OnboardingOld = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("2rCbT")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $43d4c7537a1fee65$var$OnboardingNew = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("2rCbT")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding/index.tsx"
});
const $43d4c7537a1fee65$var$Onboarding = (0, $cSD7y.componentWithFG)('onboarding-forpaint-migration-iv-llc', $43d4c7537a1fee65$var$OnboardingNew, $43d4c7537a1fee65$var$OnboardingOld);
$43d4c7537a1fee65$var$Onboarding.displayName = 'Lazy(ui/onboarding/index.tsx)';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $43d4c7537a1fee65$var$OnboardingCode = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("g5ffn")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding-code/OnboardingCode.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $43d4c7537a1fee65$var$RightSidebarsOld = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("a7AYY")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars/RightSidebars.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $43d4c7537a1fee65$var$RightSidebarsNew = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("a7AYY")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars/RightSidebars.tsx"
});
const $43d4c7537a1fee65$var$RightSidebars = (0, $cSD7y.componentWithFG)('onboarding-forpaint-migration-iv-llc', $43d4c7537a1fee65$var$RightSidebarsNew, $43d4c7537a1fee65$var$RightSidebarsOld);
$43d4c7537a1fee65$var$RightSidebars.displayName = 'Lazy(ui/right-sidebars/RightSidebars.tsx)';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $43d4c7537a1fee65$var$RightSidebarsCode = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("e4vG2")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars-code/RightSidebarsCode.tsx"
});
const $43d4c7537a1fee65$var$SoftWareOnboarding = $43d4c7537a1fee65$var$withAnySoftwareProjectContext($43d4c7537a1fee65$var$Onboarding);
const $43d4c7537a1fee65$var$SoftWareOnboardingCode = $43d4c7537a1fee65$var$withAnySoftwareProjectContext($43d4c7537a1fee65$var$OnboardingCode);
const $43d4c7537a1fee65$var$nonSettingsRightSidebars = [
    $43d4c7537a1fee65$var$withAnySoftwareProjectContext($43d4c7537a1fee65$var$RightSidebars)
];
const $43d4c7537a1fee65$var$nonSettingsRightSidebarsCode = [
    $43d4c7537a1fee65$var$withAnySoftwareProjectContext($43d4c7537a1fee65$var$RightSidebarsCode)
];
const $43d4c7537a1fee65$var$sharedSoftwareProjectLayout = (0, $aPfsS.composeLayouts)((0, $1Du13.projectLayout), {});
const $43d4c7537a1fee65$export$3791efdd32024063 = (0, $aPfsS.composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout, {
    rightSidebars: $43d4c7537a1fee65$var$nonSettingsRightSidebars,
    globalComponents: [
        $43d4c7537a1fee65$var$SoftWareOnboarding
    ]
});
const $43d4c7537a1fee65$export$9a918616afa3328c = (0, $aPfsS.composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout, {
    rightSidebars: $43d4c7537a1fee65$var$nonSettingsRightSidebars,
    globalComponents: [
        $43d4c7537a1fee65$var$SoftWareOnboarding
    ]
});
const $43d4c7537a1fee65$export$ada52b1309832862 = (0, $aPfsS.composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout);
const $43d4c7537a1fee65$export$6c1958653c44ba37 = (0, $aPfsS.composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout);
const $43d4c7537a1fee65$export$ab7e607e8441dc61 = (0, $aPfsS.composeLayouts)($43d4c7537a1fee65$var$sharedSoftwareProjectLayout, {
    rightSidebars: $43d4c7537a1fee65$var$nonSettingsRightSidebarsCode,
    globalComponents: [
        $43d4c7537a1fee65$var$SoftWareOnboardingCode
    ]
});

});
parcelRegister("2rCbT", function(module, exports) {

let $1c7bba4d940649cf$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1c7bba4d940649cf$var$load("kVX56"),
    $1c7bba4d940649cf$var$load("ffQaD"),
    $1c7bba4d940649cf$var$load("kvRbA"),
    $1c7bba4d940649cf$var$load("76n7a"),
    $1c7bba4d940649cf$var$load("l253H"),
    $1c7bba4d940649cf$var$load("2Op1P")
]).then(()=>parcelRequire('67mQl'));

});

parcelRegister("g5ffn", function(module, exports) {

let $bb58f0b5049ed1b8$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $bb58f0b5049ed1b8$var$load("kVX56"),
    $bb58f0b5049ed1b8$var$load("ffQaD"),
    $bb58f0b5049ed1b8$var$load("kvRbA"),
    $bb58f0b5049ed1b8$var$load("76n7a"),
    $bb58f0b5049ed1b8$var$load("l253H"),
    $bb58f0b5049ed1b8$var$load("jUiL7")
]).then(()=>parcelRequire('g03yq'));

});

parcelRegister("a7AYY", function(module, exports) {

let $75e73ec5cc4c018d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $75e73ec5cc4c018d$var$load("kVX56"),
    $75e73ec5cc4c018d$var$load("ffQaD"),
    $75e73ec5cc4c018d$var$load("kvRbA"),
    $75e73ec5cc4c018d$var$load("76n7a"),
    $75e73ec5cc4c018d$var$load("l253H"),
    $75e73ec5cc4c018d$var$load("6sXEe")
]).then(()=>parcelRequire('jorgl'));

});

parcelRegister("e4vG2", function(module, exports) {

let $a3ea02cd5e6a20fd$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a3ea02cd5e6a20fd$var$load("kVX56"),
    $a3ea02cd5e6a20fd$var$load("ffQaD"),
    $a3ea02cd5e6a20fd$var$load("kvRbA"),
    $a3ea02cd5e6a20fd$var$load("76n7a"),
    $a3ea02cd5e6a20fd$var$load("l253H"),
    $a3ea02cd5e6a20fd$var$load("3buPh")
]).then(()=>parcelRequire('egnL1'));

});


parcelRegister("9Y3Lc", function(module, exports) {

$parcel$export(module.exports, "userBoardLayout", () => $1760a1663e36faa5$export$7092b4ee86ae0b71);

var $aPfsS = parcelRequire("aPfsS");
const $1760a1663e36faa5$export$7092b4ee86ae0b71 = (0, $aPfsS.createLayout)();

});


parcelRegister("fo6b8", function(module, exports) {

$parcel$export(module.exports, "jiraHorizontalNavEntrypoint", () => $a30042c3f693dfff$export$e9ee9fa1097f370e);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $LjVkh = parcelRequire("LjVkh");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $kV9ss = parcelRequire("kV9ss");

var $1nb22 = parcelRequire("1nb22");

var $ktofH = parcelRequire("ktofH");

const $a30042c3f693dfff$export$e9ee9fa1097f370e = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("7GbVW")), {
        moduleId: "99477251",
        moduleName: "HorizontalNavJiraInner"
    }),
    getPreloadProps: ({ context: { match: match, query: query }, tenantContext: { cloudId: cloudId } })=>{
        const boardId = match.params.boardId;
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        const projectIdOrKey = projectId || projectKey;
        const isTMPBoardRoute = boardId ? match.url.includes('/software/projects/') : false;
        const boardAri = boardId ? `ari:cloud:jira-software:${cloudId}:board/${boardId}` : '';
        const projectAri = projectId ? (0, $kV9ss.JiraProjectAri).create({
            siteId: cloudId,
            projectId: projectId
        }).toString() : '';
        let containerNavigationInput;
        if (isTMPBoardRoute) containerNavigationInput = projectAri ? {
            scopeId: boardAri
        } : {
            projectKeyQuery: {
                cloudId: cloudId,
                projectKey: projectKey
            }
        };
        else containerNavigationInput = boardAri || projectAri ? {
            scopeId: boardAri || projectAri
        } : {
            projectKeyQuery: {
                cloudId: cloudId,
                projectKey: projectKey
            }
        };
        return {
            queries: {
                horizontalNavQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $LjVkh.default,
                    variables: {
                        cloudId: cloudId,
                        projectIdOrKey: projectIdOrKey,
                        withProject: Boolean(projectIdOrKey),
                        boardId: boardAri,
                        withBoard: Boolean(boardAri),
                        containerNavigationInput: containerNavigationInput,
                        isTMPBoardRoute: isTMPBoardRoute,
                        first: (0, $ktofH.NAVIGATION_ITEMS_PAGE_SIZE)
                    }
                }
            }
        };
    }
});

});
parcelRegister("LjVkh", function(module, exports) {

$parcel$export(module.exports, "default", () => $153fec52554cdddf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eda7ec1b2eef8645c888d7e277871f83>>
 * @relayHash 4319343e2b2a12f2cc6a6eebd766613c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6821c9bddb2120bb80e0d9c544583b48888446dacdacf3040322204379ee9c0a

var $58v9Y = parcelRequire("58v9Y");

var $i536Z = parcelRequire("i536Z");

var $9pmwJ = parcelRequire("9pmwJ");
const $153fec52554cdddf$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "6821c9bddb2120bb80e0d9c544583b48888446dacdacf3040322204379ee9c0a",
        "metadata": {},
        "name": "HorizontalNavJiraInnerQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider": (0, $58v9Y.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider": (0, $9pmwJ.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider": (0, $i536Z.default)
        }
    }
};
var $153fec52554cdddf$export$2e2bcd8739ae039 = $153fec52554cdddf$var$node;

});
parcelRegister("58v9Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a08f169582fc62e$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $2a08f169582fc62e$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jira_custom_templates_ux');
    }
};

});

parcelRegister("i536Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $68f76f028187f307$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");
const $68f76f028187f307$var$JiraTeamButtonTeamCountRelayProvider = {
    get () {
        return !(0, $4R6GH.fg)('team-bi-directional-container-connection-gate') || !(0, $6s1PB.expVal)('team-bi-directional-container-connection', 'isEnabled', false);
    }
};
var $68f76f028187f307$export$2e2bcd8739ae039 = $68f76f028187f307$var$JiraTeamButtonTeamCountRelayProvider;

});

parcelRegister("9pmwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $979d1b4861d86eeb$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");
const $979d1b4861d86eeb$var$JiraTeamButtonRelayProvider = {
    get () {
        return(// eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4R6GH.fg)('team-connection-visibility-in-jira') && (0, $6s1PB.expVal)('team_and_container_m1', 'isEnabled', false));
    }
};
var $979d1b4861d86eeb$export$2e2bcd8739ae039 = $979d1b4861d86eeb$var$JiraTeamButtonRelayProvider;

});


parcelRegister("7GbVW", function(module, exports) {

let $5975b6605b351c33$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $5975b6605b351c33$var$load("kNFvF"),
    $5975b6605b351c33$var$load("ffQaD"),
    $5975b6605b351c33$var$load("kvRbA"),
    $5975b6605b351c33$var$load("kVX56"),
    $5975b6605b351c33$var$load("76n7a"),
    $5975b6605b351c33$var$load("l253H"),
    $5975b6605b351c33$var$load("lON4s")
]).then(()=>parcelRequire('l7ScM'));

});


parcelRegister("1Qr8L", function(module, exports) {

$parcel$export(module.exports, "archivedIssuesEntrypoint", () => $c1768d5987ec2034$export$3f35189530920ce3);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $c1768d5987ec2034$export$3f35189530920ce3 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("2Mcut")), {
        moduleId: "c61780dd"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("2Mcut", function(module, exports) {

let $2059c0d19cef4e15$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2059c0d19cef4e15$var$load("BEB1L").then(()=>parcelRequire('f45ZV'));

});




parcelRegister("6DvyY", function(module, exports) {

$parcel$export(module.exports, "archivedWorkItemsJswCompanyRouteEntry", () => $63d198414831365c$export$5555f344b15f5187);

var $5f2bR = parcelRequire("5f2bR");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $4xUlD = parcelRequire("4xUlD");

var $gDHR4 = parcelRequire("gDHR4");
const $63d198414831365c$export$5555f344b15f5187 = (0, $7NszV.createEntry)((0, $4xUlD.archivedWorkItemsJswCompanyRoute), ()=>({
        group: 'archived-work-items',
        // Refer: issueNavigatorProjectClassicRoute from issue-navigator
        layout: (0, $gDHR4.getCommonProjectLayout)(),
        entryPoint: ()=>(0, $gDHR4.archivedIssuesPageEntryPoint),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ]
    }));

});
parcelRegister("4xUlD", function(module, exports) {

$parcel$export(module.exports, "archivedWorkItemsJswCompanyRoute", () => $de918103ba1f7179$export$d370de0c0b8dc61b);
const $de918103ba1f7179$export$d370de0c0b8dc61b = {
    name: 'software-archived-work-items-classic',
    path: '/jira/software/c/projects/:projectKey/archived-work-items',
    exact: true
};

});


parcelRegister("lGElM", function(module, exports) {

$parcel$export(module.exports, "archivedWorkItemsJswRouteEntry", () => $3663668a4efe06cf$export$2686cd22a3691dbf);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $iyeDq = parcelRequire("iyeDq");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $gDHR4 = parcelRequire("gDHR4");
const $3663668a4efe06cf$export$2686cd22a3691dbf = (0, $7NszV.createEntry)((0, $iyeDq.archivedWorkItemsJswRoute), ()=>({
        group: 'archived-work-items',
        // Refer: issueNavigatorProjectSoftwareRoute from issue-navigator
        layout: (0, $aPfsS.createLayout)((0, $e7bC3.softwareProjectLayoutNoOnboarding)),
        entryPoint: ()=>(0, $gDHR4.archivedIssuesPageEntryPoint),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ]
    }));

});
parcelRegister("iyeDq", function(module, exports) {

$parcel$export(module.exports, "archivedWorkItemsJswRoute", () => $55b26223cd3592ce$export$356fe8859732c01b);
const $55b26223cd3592ce$export$356fe8859732c01b = {
    name: 'software-archived-work-items',
    path: '/jira/software/projects/:projectKey/archived-work-items',
    exact: true
};

});


parcelRegister("3bc6l", function(module, exports) {

$parcel$export(module.exports, "archivedWorkItemsJwmRouteEntry", () => $139836b65d693ac3$export$a243ee53747084d5);

var $5f2bR = parcelRequire("5f2bR");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $7nQyj = parcelRequire("7nQyj");

var $gDHR4 = parcelRequire("gDHR4");
const $139836b65d693ac3$export$a243ee53747084d5 = (0, $7NszV.createEntry)((0, $7nQyj.archivedWorkItemsJwmRoute), ()=>({
        group: 'archived-work-items',
        // Refer: issueNavigatorProjectBusinessRoute from issue-navigator
        layout: (0, $gDHR4.getCommonProjectLayout)(),
        entryPoint: ()=>(0, $gDHR4.archivedIssuesPageEntryPoint),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $lNicp.getBusinessProjectResources)()
        ]
    }));

});
parcelRegister("lNicp", function(module, exports) {

$parcel$export(module.exports, "getBusinessProjectResources", () => $492115de1a4c9f28$export$20e8c2951e444b08);
$parcel$export(module.exports, "getProjectViewResources", () => $492115de1a4c9f28$export$fcbe882e18ee4a35);
$parcel$export(module.exports, "getOverviewViewResources", () => $492115de1a4c9f28$export$21c5527b459d56fe);

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $g4ZHz = parcelRequire("g4ZHz");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $1E3vT = parcelRequire("1E3vT");

var $iNzEe = parcelRequire("iNzEe");

var $jrO9m = parcelRequire("jrO9m");

var $gNStA = parcelRequire("gNStA");

var $l2N2a = parcelRequire("l2N2a");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $cSUZZ = parcelRequire("cSUZZ");

var $aFVvc = parcelRequire("aFVvc");

var $9V5k0 = parcelRequire("9V5k0");
const $492115de1a4c9f28$export$20e8c2951e444b08 = ()=>(0, $3HwlS.getWillShowNav4)() ? [
        // eslint-disable-next-line camelcase
        (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource),
        (0, $9V5k0.projectThemeResource)
    ] : [
        (0, $aFVvc.projectCreatePermissionsResource),
        (0, $iNzEe.navigationResource),
        // eslint-disable-next-line camelcase
        (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource),
        (0, $1E3vT.businessHorizontalNav3Resource),
        (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
        (0, $9V5k0.projectThemeResource)
    ];
const $492115de1a4c9f28$export$fcbe882e18ee4a35 = ()=>[
        ...$492115de1a4c9f28$export$20e8c2951e444b08(),
        ...(0, $3RJkv.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $dxCvy.projectContextResource),
        (0, $5bkvv.forgeProjectModuleResource),
        (0, $iEUaw.staticSidebarShortcutsResource),
        (0, $ggg5j.staticProjectSidebarNavigationResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        (0, $g4ZHz.fieldsResource)
    ];
const $492115de1a4c9f28$export$46471673e66df5c1 = ()=>[
        (0, $aFVvc.projectCreatePermissionsResource),
        (0, $iNzEe.navigationResource),
        (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
        (0, $jrO9m.overviewDetailsResource),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('overviews_theming_bugfix'), (0, $9V5k0.projectThemeResource))
    ];
const $492115de1a4c9f28$export$21c5527b459d56fe = ()=>[
        ...$492115de1a4c9f28$export$46471673e66df5c1(),
        ...(0, $3RJkv.getNavigationResources)(),
        (0, $g4ZHz.fieldsResource)
    ];

});
parcelRegister("g4ZHz", function(module, exports) {

$parcel$export(module.exports, "fieldsResource", () => $410efef54f79d33f$export$8bca6c1954ae9308);
$parcel$export(module.exports, "useFieldsResource", () => $410efef54f79d33f$export$c0cd85886917fe89);

var $7S1v3 = parcelRequire("7S1v3");

var $jlq4V = parcelRequire("jlq4V");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


var $ljySl = parcelRequire("ljySl");

var $kig09 = parcelRequire("kig09");
const $410efef54f79d33f$var$RESOURCE_TYPE_KEY = 'BUSINESS_FIELDS';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $410efef54f79d33f$var$handleProjectResponse = async (promise)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const response = await promise;
    if (response.data?.jira?.jqlBuilder?.fields?.edges == null) throw new (0, $jlq4V.GraphQLErrors)(response.errors);
    return (0, $kig09.transformData)(response.data?.jira?.jqlBuilder?.fields?.edges);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $410efef54f79d33f$var$handleOverviewResponse = async (promise)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const response = await promise;
    if (response.data?.jira?.jwmOverview?.fields?.edges == null) throw new (0, $jlq4V.GraphQLErrors)(response.errors);
    return (0, $kig09.transformData)(response.data?.jira?.jwmOverview?.fields?.edges);
};
const $410efef54f79d33f$export$8bca6c1954ae9308 = (0, $2M1hQ.createResource)({
    type: $410efef54f79d33f$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        if (matchedRoute.match.params.overviewId) return `${$410efef54f79d33f$var$RESOURCE_TYPE_KEY}_overview_${matchedRoute.match.params.overviewId}`;
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        const projectIdOrKey = projectKey || projectId;
        return `${$410efef54f79d33f$var$RESOURCE_TYPE_KEY}_project_${projectIdOrKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        if (match.params.overviewId) return (0, $ljySl.fetchFields)((0, $8441414a9e015afb$export$c378ca4a0e2c9fec), $410efef54f79d33f$var$handleOverviewResponse, {
            overviewAri: (0, $7S1v3.JiraProjectOverviewAri).create({
                siteId: cloudId,
                activationId: activationId,
                overviewId: match.params.overviewId
            }).toString()
        });
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        const projectIdOrKey = projectKey || projectId;
        return (0, $ljySl.fetchFields)((0, $8441414a9e015afb$export$4d41378da3f70f0f), $410efef54f79d33f$var$handleProjectResponse, {
            cloudId: cloudId,
            jqlContext: `project = '${projectIdOrKey}'`
        });
    },
    maxAge: 3600000
});
const $410efef54f79d33f$export$c0cd85886917fe89 = ()=>(0, $2YP9W.useResource)($410efef54f79d33f$export$8bca6c1954ae9308);

});
const $8441414a9e015afb$export$4d41378da3f70f0f = `
query JWMProjectFields($cloudId: ID!, $jqlContext: String!, $first: Int) {
  jira {
    jqlBuilder(cloudId: $cloudId) {
      fields (jqlContext: $jqlContext, forClause: WHERE, viewContext: JWM, first: $first) {
        ... on JiraJqlFieldConnection {
          edges {
            node {
              jqlTerm
              type
              displayName,
            }
          }
        }
      }
    }
  }
}`;
const $8441414a9e015afb$export$c378ca4a0e2c9fec = `
query JWMOverviewFields($overviewAri: ID!, $first: Int) {
  jira {
    jwmOverview(id: $overviewAri) {
      ... on JiraWorkManagementGiraOverview {
        fields (first: $first) {
          ... on JiraJqlFieldConnection {
            edges {
              node {
                jqlTerm
                type
                displayName,
              }
            }
          }
        }
      }
    }
  }
}`;

parcelRegister("ljySl", function(module, exports) {

$parcel$export(module.exports, "fetchFields", () => $90e7c5e5920e8507$export$f3ddd735c360919);

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $90e7c5e5920e8507$var$PAGE_SIZE = 100;
const $90e7c5e5920e8507$export$f3ddd735c360919 = async (query, handler, params)=>{
    try {
        const promise = (0, $eusud.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    first: $90e7c5e5920e8507$var$PAGE_SIZE,
                    ...params
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'JiraJqlBuilder'
            }
        });
        return await handler(promise);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessFields', 'Something went wrong while fetching fields');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $jcw0u.default)({
            meta: {
                id: 'fieldsResource',
                packageName: 'jiraRouterResourcesBusinessFields',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};

});

parcelRegister("kig09", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $3d209f684c72dca4$export$3ceb62baab058c6b);
const $3d209f684c72dca4$export$3ceb62baab058c6b = (data)=>data.map((edge)=>edge.node);

});


parcelRegister("1E3vT", function(module, exports) {

$parcel$export(module.exports, "businessHorizontalNav3Resource", () => $4f364072ed560b43$export$b3359003584ee2b0);

var $kV9ss = parcelRequire("kV9ss");

var $2YZCu = parcelRequire("2YZCu");

var $4R6GH = parcelRequire("4R6GH");

var $6YG83 = parcelRequire("6YG83");

var $ktofH = parcelRequire("ktofH");

var $ao2h1 = parcelRequire("ao2h1");

var $6SGt4 = parcelRequire("6SGt4");

var $1nb22 = parcelRequire("1nb22");
const $4f364072ed560b43$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_HORIZONTAL_NAVIGATION';
const $4f364072ed560b43$var$getProjectAri = (projectId, cloudId)=>{
    try {
        return projectId ? (0, $kV9ss.JiraProjectAri).create({
            siteId: cloudId,
            projectId: projectId
        }).toString() : '';
    } catch (err) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jiraRouterResourcesNavigationItems', 'Failed to get project ari');
        return '';
    }
};
const $4f364072ed560b43$export$b3359003584ee2b0 = (0, $6YG83.withGiraAggAnonSsrFix)((0, $ao2h1.createRelayResource)({
    type: $4f364072ed560b43$var$RESOURCE_TYPE_KEY,
    getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        const { cloudId: cloudId } = tenantContext;
        const projectIdOrKey = projectKey || projectId;
        const scopeId = $4f364072ed560b43$var$getProjectAri(projectId, cloudId);
        return {
            parameters: (0, $6SGt4.default),
            variables: {
                cloudId: cloudId,
                projectIdOrKey: projectIdOrKey,
                first: (0, $ktofH.NAVIGATION_ITEMS_PAGE_SIZE),
                isConsolidatedQuery: false,
                containerNavigationInput: scopeId ? {
                    scopeId: scopeId
                } : {
                    projectKeyQuery: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                useContainerNavigation: false,
                useNewProjectHeader: false,
                projectKey: projectKey,
                projectAri: scopeId,
                useProjectKey: Boolean(projectKey),
                isJiraCustomTemplatesUxEnabled: (0, $4R6GH.fg)('jira_custom_templates_ux')
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
}));

});
parcelRegister("6YG83", function(module, exports) {

$parcel$export(module.exports, "withGiraAggAnonSsrFix", () => $895edd6ed19f0aa8$export$f4b29e78f4c0a526);
const $895edd6ed19f0aa8$export$f4b29e78f4c0a526 = (resource)=>{
    if (!resource || !resource.getData) return resource;
    const originalGetData = resource.getData;
    // @ts-expect-error types in the relay resource don't allow null, but the react-resource-router types do
    // eslint-disable-next-line no-param-reassign
    resource.getData = (routerContext, customContext)=>{
        if (false && customContext.tenantContext.isAnonymous) return Promise.resolve(null);
        return originalGetData(routerContext, customContext);
    };
    return resource;
};

});

parcelRegister("6SGt4", function(module, exports) {

$parcel$export(module.exports, "default", () => $fed7f561d3a05da6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<820042db950ffe26b91d34ffe7050138>>
 * @relayHash bef16a6db03ecc4506e2c317ed3ec3dc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4c6a8fb0afe8804c6d8b040f3b4ccf6926f7a96b57ad873204c81c3a0ee4ada5
const $fed7f561d3a05da6$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isJiraCustomTemplatesUxEnabled"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectAri"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIdOrKey"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "useProjectKey"
    }, v7 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v8 = [
        v7 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v9 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "large"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v11 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v12 = {
        "kind": "ScalarField",
        "name": "name"
    }, v13 = {
        "alias": "canEditProjectConfig",
        "args": [
            {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
            }
        ],
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ],
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v14 = {
        "condition": "isJiraCustomTemplatesUxEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "customTemplateBusinessProjectBanner_businessHorizontalNav"
            }
        ]
    }, v15 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "projectAri"
        }
    ], v16 = [
        v7 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "projectIdOrKey",
            "variableName": "projectIdOrKey"
        }
    ], v17 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v18 = {
        "kind": "ScalarField",
        "name": "id"
    }, v19 = [
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        v11 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ ,
        {
            "condition": "isJiraCustomTemplatesUxEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isLiveTemplate"
                }
            ]
        },
        v18 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "projectNavigation_horizontalNavigationQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "tabs_businessHorizontalNav_TabsContent"
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "alias": "projectDataByKey",
                                        "args": v8 /*: any*/ ,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProjectByKey",
                                        "plural": false,
                                        "selections": [
                                            v9 /*: any*/ ,
                                            {
                                                "kind": "RequiredField",
                                                "field": v10 /*: any*/ ,
                                                "action": "THROW",
                                                "path": "jira.projectDataByKey.projectId"
                                            },
                                            v11 /*: any*/ ,
                                            v12 /*: any*/ ,
                                            v13 /*: any*/ ,
                                            v14 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "alias": "projectDataById",
                                        "args": v15 /*: any*/ ,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProject",
                                        "plural": false,
                                        "selections": [
                                            v9 /*: any*/ ,
                                            {
                                                "kind": "RequiredField",
                                                "field": v10 /*: any*/ ,
                                                "action": "THROW",
                                                "path": "jira.projectDataById.projectId"
                                            },
                                            v11 /*: any*/ ,
                                            v12 /*: any*/ ,
                                            v13 /*: any*/ ,
                                            v14 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                v6 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "projectNavigation_horizontalNavigationQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "navigationItems",
                            "args": v16 /*: any*/ ,
                            "concreteType": "JiraNavigationItemConnection",
                            "kind": "LinkedField",
                            "name": "jwmSavedViewsByProject",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraNavigationItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isDefault"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "typeKey"
                                                },
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isJiraNavigationItem"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "label"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canRemove"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canSetAsDefault"
                                                }
                                            ]
                                        },
                                        v17 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "QueryError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "navigationItems",
                            "args": v16 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "projectIdOrKey"
                            ],
                            "handle": "connection",
                            "key": "tabs_jiraNavigation__navigationItems",
                            "kind": "LinkedHandle",
                            "name": "jwmSavedViewsByProject"
                        },
                        {
                            "condition": "useProjectKey",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "projectDataByKey",
                                    "args": v8 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": v19 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "condition": "useProjectKey",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "projectDataById",
                                    "args": v15 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProject",
                                    "plural": false,
                                    "selections": v19 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4c6a8fb0afe8804c6d8b040f3b4ccf6926f7a96b57ad873204c81c3a0ee4ada5",
            "metadata": {},
            "name": "projectNavigation_horizontalNavigationQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$fed7f561d3a05da6$var$node.hash = "73d9509696eb943ac9eaa2deb0444981";
var $fed7f561d3a05da6$export$2e2bcd8739ae039 = $fed7f561d3a05da6$var$node;

});


parcelRegister("iNzEe", function(module, exports) {

$parcel$export(module.exports, "navigationResource", () => $6b942b0827824c4b$export$62940941ee574cdc);
$parcel$export(module.exports, "useNavigationResource", () => $6b942b0827824c4b$export$c17011c09e042a31);

var $gccSB = parcelRequire("gccSB");

var $kV9ss = parcelRequire("kV9ss");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


var $geiy6 = parcelRequire("geiy6");

const $6b942b0827824c4b$export$62940941ee574cdc = (0, $2M1hQ.createResource)({
    type: 'BUSINESS_NAVIGATION',
    getKey: ()=>'BUSINESS_NAVIGATION',
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return null;
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(projectKey)) return (0, $geiy6.fetchNavigation)((0, $77516b48757f52de$export$a40c5d12b8a53ba2), {
            cloudId: cloudId,
            projectKey: projectKey
        });
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(projectId)) return (0, $geiy6.fetchNavigation)((0, $77516b48757f52de$export$7c9197b656229b53), {
            cloudId: cloudId,
            projectId: (0, $kV9ss.JiraProjectAri).create({
                siteId: cloudId,
                projectId: projectId
            }).toString()
        });
        return (0, $geiy6.fetchNavigation)((0, $77516b48757f52de$export$c378ca4a0e2c9fec), {
            cloudId: cloudId
        });
    },
    maxAge: Infinity
});
const $6b942b0827824c4b$export$c17011c09e042a31 = ()=>(0, $2YP9W.useResource)($6b942b0827824c4b$export$62940941ee574cdc);

});
const $77516b48757f52de$var$ProjectFragment = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectStyle
  projectType
  isFavourite
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
  defaultView: jwmDefaultSavedView {
    ... on JiraNavigationItem {
      typeKey
    }
  }
}
`;
const $77516b48757f52de$var$ProjectConnectionFragment = `
fragment ProjectConnectionFragment on JiraProjectConnection {
  pageInfo {
    hasNextPage
  }
  edges {
    node {
      ...ProjectFragment
    }
  }
}
`;
const $77516b48757f52de$var$OverviewFragment = `
fragment OverviewFragment on JiraWorkManagementGiraOverview {
  id
  name
  theme
}
`;
const $77516b48757f52de$var$OverviewConnectionFragment = `
fragment OverviewConnectionFragment on JiraWorkManagementGiraOverviewConnection {
  pageInfo {
    hasNextPage
  }
  edges {
    node {
      ...OverviewFragment
    }
  }
}
`;
const $77516b48757f52de$var$NavigationDataFragment = `
fragment NavigationFragment on JiraWorkManagementNavigation {
  jwmLicensing {
    currentUserSeatEdition
  }
  recentProjects(first: $first) {
    ...ProjectConnectionFragment
  }
  favoriteProjects(first: $first) {
    ...ProjectConnectionFragment
  }
  overviews: jwmOverviews(cloudId: $cloudId, first: $first) @optIn(to: "JiraWorkManagementGiraOverviews") {
    __typename
    ... on JiraWorkManagementGiraOverviewConnection {
      ...OverviewConnectionFragment
    }
  }
}
`;
const $77516b48757f52de$export$7c9197b656229b53 = `
query JiraBusinessProjectNavigation($cloudId: ID!, $projectId: ID!, $first: Int!) {
  jira {
    navigation: jwmNavigationByProjectId(projectId: $projectId) {
      ...NavigationFragment
    }
  }
}
${$77516b48757f52de$var$ProjectFragment}
${$77516b48757f52de$var$ProjectConnectionFragment}
${$77516b48757f52de$var$NavigationDataFragment}
${$77516b48757f52de$var$OverviewFragment}
${$77516b48757f52de$var$OverviewConnectionFragment}
`;
const $77516b48757f52de$export$a40c5d12b8a53ba2 = `
query JiraBusinessProjectNavigation($cloudId: ID!, $projectKey: String!, $first: Int!) {
  jira {
    navigation: jwmNavigationByProjectKey(cloudId: $cloudId, projectKey: $projectKey) {
      ...NavigationFragment
    }
  }
}
${$77516b48757f52de$var$ProjectFragment}
${$77516b48757f52de$var$ProjectConnectionFragment}
${$77516b48757f52de$var$NavigationDataFragment}
${$77516b48757f52de$var$OverviewFragment}
${$77516b48757f52de$var$OverviewConnectionFragment}
`;
const $77516b48757f52de$export$c378ca4a0e2c9fec = `
query JiraBusinessOverviewNavigation($cloudId: ID!, $first: Int!) {
  jira {
    navigation: jwmNavigation(cloudId: $cloudId) {
      ...NavigationFragment
    }
  }
}
${$77516b48757f52de$var$ProjectFragment}
${$77516b48757f52de$var$ProjectConnectionFragment}
${$77516b48757f52de$var$NavigationDataFragment}
${$77516b48757f52de$var$OverviewFragment}
${$77516b48757f52de$var$OverviewConnectionFragment}
`;

parcelRegister("geiy6", function(module, exports) {

$parcel$export(module.exports, "fetchNavigation", () => $446f8b979bebb841$export$1fc5fff73d9a570c);

var $jlq4V = parcelRequire("jlq4V");

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");


var $ifwpM = parcelRequire("ifwpM");
const $446f8b979bebb841$var$EMPTY_RESPONSE = {
    recents: [],
    favorites: [],
    hasMoreFavorite: false,
    overviews: [],
    overviewsError: null,
    isPremiumUserSeat: false,
    shouldHideOverviews: false
};
const $446f8b979bebb841$export$1fc5fff73d9a570c = async (query, params)=>{
    try {
        const response = await (0, $eusud.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    first: (0, $4ee2cfa1c76e72ed$export$3349219a88ac77cd),
                    ...params
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'projectStyle'
            }
        });
        // checking only for undefined, as null is a valid value (not applicable)
        if (response.data?.jira?.navigation === undefined) throw new (0, $jlq4V.GraphQLErrors)(response.errors);
        let areOverviewsGone = false;
        if (Array.isArray(response.errors)) // Overviews have been migrated to plans and should no longer be shown to the user
        areOverviewsGone = response.errors.some((error)=>error.extensions?.statusCode === 410);
        return (0, $ifwpM.transformData)(response.data.jira.navigation, areOverviewsGone);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessNavigation', 'Something went wrong while fetching the navigation items');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $jcw0u.default)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesBusinessNavigation',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return $446f8b979bebb841$var$EMPTY_RESPONSE;
};

});
const $4ee2cfa1c76e72ed$export$3349219a88ac77cd = 10;
const $4ee2cfa1c76e72ed$export$e8958a6508ec5b71 = 'NOT_APPLICABLE';

parcelRegister("ifwpM", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $9031e5290b70d3d6$export$3ceb62baab058c6b);

var $6cG4N = parcelRequire("6cG4N");


var $027FQ = parcelRequire("027FQ");
const $9031e5290b70d3d6$var$SIMPLIFIED_PROJECT_STYLE = 'TEAM_MANAGED_PROJECT';
const $9031e5290b70d3d6$var$PREMIUM = 'PREMIUM';
const $9031e5290b70d3d6$var$mapProjectNode = (node)=>({
        key: node.key,
        id: Number(node.projectId),
        avatarUrl: node.avatar?.large ?? '',
        name: node.name,
        type: node.projectType.toLowerCase(),
        isSimplified: node.projectStyle === $9031e5290b70d3d6$var$SIMPLIFIED_PROJECT_STYLE,
        isFavorite: node.isFavourite,
        permissions: {
            viewIssues: node.viewIssues.canPerform
        },
        defaultView: node.defaultView?.typeKey?.toLowerCase()
    });
const $9031e5290b70d3d6$var$mapOverviewNode = (node)=>({
        id: node.id,
        name: node.name,
        theme: node?.theme ?? (0, $6cG4N.DEFAULT_BACKGROUND_CONFIG).name
    });
const $9031e5290b70d3d6$export$3ceb62baab058c6b = (navigation, areOverviewsGone)=>{
    if (navigation == null) // not a JWM context
    return 0, $4ee2cfa1c76e72ed$export$e8958a6508ec5b71;
    let overviews = [];
    let overviewsError = null;
    const isPremiumUserSeat = navigation.jwmLicensing?.currentUserSeatEdition === $9031e5290b70d3d6$var$PREMIUM;
    if (isPremiumUserSeat) {
        if (navigation.overviews?.__typename === (0, $027FQ.OVERVIEWS_SUCCESS_RESPONSE_TYPE)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        overviews = navigation.overviews.edges.map((edge)=>$9031e5290b70d3d6$var$mapOverviewNode(edge.node));
        else overviewsError = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        navigation.overviews ?? new Error('Unknown overviews error');
    }
    let recents = navigation.recentProjects?.edges?.map((edge)=>$9031e5290b70d3d6$var$mapProjectNode(edge.node)) ?? [];
    const favorites = navigation.favoriteProjects?.edges?.map((edge)=>$9031e5290b70d3d6$var$mapProjectNode(edge.node)) ?? [];
    // Remove favorited projects from the recent projects list
    recents = recents.filter((recentProject)=>!favorites.some((favProject)=>favProject.id === recentProject.id));
    return {
        recents: recents,
        favorites: favorites,
        hasMoreFavorite: navigation.favoriteProjects?.pageInfo?.hasNextPage ?? false,
        overviews: overviews,
        overviewsError: overviewsError,
        isPremiumUserSeat: isPremiumUserSeat,
        shouldHideOverviews: areOverviewsGone
    };
};

});
parcelRegister("027FQ", function(module, exports) {

$parcel$export(module.exports, "OVERVIEWS_SUCCESS_RESPONSE_TYPE", () => $fd4c320fd9ec6c35$export$ddf2fc82885279d);
const $fd4c320fd9ec6c35$export$ddf2fc82885279d = 'JiraWorkManagementGiraOverviewConnection';
const $fd4c320fd9ec6c35$export$39284f7325536558 = {
    ServiceDesk: 'SERVICE_DESK',
    Business: 'BUSINESS',
    Software: 'SOFTWARE'
};
const $fd4c320fd9ec6c35$export$1f66f9f05afa05a8 = {
    TeamManagedProject: 'TEAM_MANAGED_PROJECT',
    CompanyManagedProject: 'COMPANY_MANAGED_PROJECT'
};

});




parcelRegister("l2N2a", function(module, exports) {

$parcel$export(module.exports, "DEPRECATED_DO_NOT_USE_projectDetailsResource", () => $a72df1053ff3c9a0$export$ced53bf9d9551fef);
$parcel$export(module.exports, "useProject_DEPRECATED_DO_NOT_USE", () => $a72df1053ff3c9a0$export$97def3841413167f);
/* eslint-disable camelcase */ 
var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $8s4PA = parcelRequire("8s4PA");
const $a72df1053ff3c9a0$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_PROJECT_DETAILS';
const $a72df1053ff3c9a0$export$ced53bf9d9551fef = (0, $2M1hQ.createResource)({
    type: $a72df1053ff3c9a0$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        const projectIdOrKey = projectKey || projectId;
        return `${$a72df1053ff3c9a0$var$RESOURCE_TYPE_KEY}_${projectIdOrKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        return (0, $8s4PA.fetchProjectDetails)(cloudId, projectKey, projectId);
    },
    maxAge: 3600000
});
const $a72df1053ff3c9a0$export$97def3841413167f = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)($a72df1053ff3c9a0$export$ced53bf9d9551fef);
    return {
        data: data?.currentProject ?? null,
        loading: loading,
        error: error
    };
};

});
parcelRegister("8s4PA", function(module, exports) {

$parcel$export(module.exports, "fetchProjectDetails", () => $3400333a67b09775$export$78aa221476efa1c6);

var $kV9ss = parcelRequire("kV9ss");

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");


var $2D9kr = parcelRequire("2D9kr");
const $3400333a67b09775$var$EMPTY_VALUE = {};
const $3400333a67b09775$export$78aa221476efa1c6 = async (cloudId, projectKey, projectId)=>{
    const projectIdOrKey = projectId || projectKey;
    if (!projectIdOrKey) return null;
    try {
        const response = await (0, $eusud.performPostRequest)('/rest/gira/1/?operation=JiraBusinessProjectDetails', {
            body: JSON.stringify({
                query: (0, $7ceb2e31b4137f58$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId,
                    projectIdOrKey: projectIdOrKey,
                    usingProjectKey: projectId == null,
                    projectId: projectId != null ? (0, $kV9ss.JiraProjectAri).create({
                        siteId: cloudId,
                        projectId: projectId
                    }).toString() : ''
                }
            })
        });
        return (0, $2D9kr.transformData)(response.data, projectIdOrKey);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessProjectDetails', 'Something went wrong while fetching business project details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'projectDetailsResource',
                    packageName: 'jiraRouterResourcesBusinessProjectDetails',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return $3400333a67b09775$var$EMPTY_VALUE;
};

});
const $7ceb2e31b4137f58$var$PROJECT_FRAGMENT = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectType
  simplified
  favorite
  administerProject: action(type: EDIT_PROJECT_CONFIG) {
    canPerform
  }
  createIssues: action(type: CREATE_ISSUES) {
    canPerform
  }
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
}
`;
const $7ceb2e31b4137f58$export$2b91517d6d5b4365 = `
query JiraBusinessProjectDetails($cloudId: ID!, $projectIdOrKey: String!, $usingProjectKey: Boolean!, $projectId: ID!) {
  jwmSidebar(cloudId: $cloudId, projectIdOrKey: $projectIdOrKey) {
    jiraProjectByKey(cloudId: $cloudId, key: $projectIdOrKey) @include(if: $usingProjectKey) {
      ...ProjectFragment
    }
    jiraProjectById(id: $projectId) @skip(if: $usingProjectKey) {
      ...ProjectFragment
    }
  }
}
${$7ceb2e31b4137f58$var$PROJECT_FRAGMENT}
`;

parcelRegister("2D9kr", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $a9016a2d391e1663$export$3ceb62baab058c6b);
const $a9016a2d391e1663$var$mapProjectNode = (node)=>{
    if (node == null) return null;
    return {
        key: node.key,
        id: Number(node.projectId),
        avatarUrl: node.avatar?.large ?? '',
        name: node.name,
        type: node.projectType.toLowerCase(),
        isSimplified: node.simplified,
        isFavorite: node.favorite === true,
        permissions: {
            administerProject: node.administerProject.canPerform,
            createIssues: node.createIssues.canPerform,
            viewIssues: node.viewIssues.canPerform
        }
    };
};
const $a9016a2d391e1663$export$3ceb62baab058c6b = (data, projectIdOrKey)=>({
        currentProject: $a9016a2d391e1663$var$mapProjectNode(data?.jwmSidebar?.jiraProjectByKey) ?? $a9016a2d391e1663$var$mapProjectNode(data?.jwmSidebar?.jiraProjectById) ?? null,
        projectIdOrKey: projectIdOrKey
    });

});



parcelRegister("cSUZZ", function(module, exports) {

$parcel$export(module.exports, "licenseDetailsResource_DEPRECATED_DO_NOT_USE", () => $203c641f0a3380f5$export$92c4069b5349d086);
$parcel$export(module.exports, "useIsPremiumUserSeat", () => $203c641f0a3380f5$export$90749419e9042370);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


var $9dQKJ = parcelRequire("9dQKJ");
const $203c641f0a3380f5$export$92c4069b5349d086 = (0, $2M1hQ.createResource)({
    type: 'BUSINESS_LICENSE_DETAILS',
    getKey: ()=>'BUSINESS_LICENSE_DETAILS',
    getData: async (_routerContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return null;
        return (0, $9dQKJ.fetchLicenseDetails)((0, $2993c3eadd0dda3e$export$2b91517d6d5b4365), {
            cloudId: cloudId
        });
    },
    maxAge: Infinity
});
const $203c641f0a3380f5$export$90749419e9042370 = ()=>{
    const { data: data } = (0, $2YP9W.useResource)($203c641f0a3380f5$export$92c4069b5349d086);
    return Boolean(data?.isPremiumUserSeat);
};

});
const $2993c3eadd0dda3e$export$2b91517d6d5b4365 = `
query JiraBusinessLicenseDetails($cloudId:ID!) {
  jira {
    jwmLicensing(cloudId: $cloudId) {
      currentUserSeatEdition
    }
  }
}
`;

parcelRegister("9dQKJ", function(module, exports) {

$parcel$export(module.exports, "fetchLicenseDetails", () => $164a09ef89830ae9$export$ec058a82eccb31e);

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $164a09ef89830ae9$var$EMPTY_RESPONSE = {
    isPremiumUserSeat: false
};
const $164a09ef89830ae9$export$ec058a82eccb31e = async (query, { cloudId: cloudId })=>{
    try {
        const response = await (0, $eusud.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    cloudId: cloudId
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        return {
            isPremiumUserSeat: response.data?.jira?.jwmLicensing?.currentUserSeatEdition === 'PREMIUM'
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessLicenseDetails', 'Something went wrong while fetching the license details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $jcw0u.default)({
            meta: {
                id: 'licenseDetailsResource',
                packageName: 'jiraRouterResourcesBusinessLicenseDetails',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return $164a09ef89830ae9$var$EMPTY_RESPONSE;
};

});


parcelRegister("aFVvc", function(module, exports) {

$parcel$export(module.exports, "projectCreatePermissionsResource", () => $9880b75bed11d4d0$export$f6c05eaea53ab4ae);
$parcel$export(module.exports, "useProjectCreatePermissionsResource", () => $9880b75bed11d4d0$export$2bd0d3b374549a68);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


const $9880b75bed11d4d0$var$getDataLoader = ()=>(parcelRequire("5ohEm"));
const $9880b75bed11d4d0$export$f6c05eaea53ab4ae = (0, $2M1hQ.createResource)({
    type: (0, $acc15b1fbe2101c5$export$8bc44dee8c6d28f),
    getKey: ()=>'state',
    getDataLoader: $9880b75bed11d4d0$var$getDataLoader,
    maxAge: Infinity
});
const $9880b75bed11d4d0$export$2bd0d3b374549a68 = ()=>(0, $2YP9W.useResource)($9880b75bed11d4d0$export$f6c05eaea53ab4ae);

});
const $acc15b1fbe2101c5$export$8bc44dee8c6d28f = 'RESOURCE_TYPE_PROJECT_PERMISSIONS';

parcelRegister("5ohEm", function(module, exports) {

let $3ecce2897af0bd36$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3ecce2897af0bd36$var$load("aErQO").then(()=>parcelRequire('5Yzmr'));

});



parcelRegister("7nQyj", function(module, exports) {

$parcel$export(module.exports, "archivedWorkItemsJwmRoute", () => $3122019c54f6a6d1$export$1377e2cf39b3ae6a);
const $3122019c54f6a6d1$export$1377e2cf39b3ae6a = {
    name: 'classic-business-archived-work-items',
    path: '/jira/core/projects/:projectKey/archived-work-items',
    exact: true
};

});


parcelRegister("hHcn9", function(module, exports) {

$parcel$export(module.exports, "archivedIssuesRedirectRouteEntry", () => $eb7a8f12766dfa01$export$f7d3667678a21360);

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $bkxko = parcelRequire("bkxko");

var $gDHR4 = parcelRequire("gDHR4");
const $eb7a8f12766dfa01$export$f7d3667678a21360 = (0, $7NszV.createEntry)((0, $bkxko.archivedIssuesRedirectRoute), ()=>({
        group: 'archive-issues',
        layout: (0, $gyYxw.genericProjectLayout),
        entryPoint: ()=>(0, $gDHR4.archivedIssuesPageEntryPoint),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ]
    }));

});
parcelRegister("bkxko", function(module, exports) {

$parcel$export(module.exports, "archivedIssuesRedirectRoute", () => $65e0e6d0c8ec9fed$export$1bfee70ca366d995);
const $65e0e6d0c8ec9fed$export$1bfee70ca366d995 = {
    name: 'archived-issues-directory',
    path: '/jira/issues/archive',
    exact: true
};

});


parcelRegister("igqAf", function(module, exports) {

$parcel$export(module.exports, "browseProjectRedirectRouteEntry", () => $7846fd35a7cb282e$export$f9891419b34ab305);

var $ffza4 = parcelRequire("ffza4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $1WlLE = parcelRequire("1WlLE");

var $iN5FK = parcelRequire("iN5FK");

var $7MCPm = parcelRequire("7MCPm");
const $7846fd35a7cb282e$export$f9891419b34ab305 = (0, $7NszV.createEntry)((0, $iN5FK.browseProjectRedirectRoute), ()=>({
        group: 'redirects',
        isRedirect: true,
        component: (0, $7MCPm.RedirectToLastVisitedProjectPage),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $1WlLE.queuesNavigationItems),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
/**
 * @deprecated sharing routes between products leads to over-fetching resources. Please define
 * routes per-product and only define the resources + navigation components required for that product instead.
 */ const $0c2b5b2aa81ed54b$export$9ab1d1d726b36319 = 'GENERIC_PROJECT_HORIZONTAL_NAV';
const $0c2b5b2aa81ed54b$export$712453ef44fd2eba = 'GENERIC_BUSINESS_TRANSITIONAL_PROJECT_HORIZONTAL_NAV';

parcelRegister("1WlLE", function(module, exports) {

$parcel$export(module.exports, "queuesNavigationItems", () => $c68314f43531feff$export$4fed8be571897bef);
$parcel$export(module.exports, "priorityGroupResource", () => $c68314f43531feff$export$1f9ab301771fe42e);
$parcel$export(module.exports, "priorityGroupByProjectIdResource", () => $c68314f43531feff$export$f6133a181a1ec201);
$parcel$export(module.exports, "priorityGroupByProjectIdResourceSsr", () => $c68314f43531feff$export$b55fde45b61f13f4);
$parcel$export(module.exports, "issueListSsrResource", () => $c68314f43531feff$export$3d03cbaac8581e65);
$parcel$export(module.exports, "queueSidebarViewAllQueuesResource", () => $c68314f43531feff$export$5b6f88b653545aa1);
$parcel$export(module.exports, "queueNav4SidebarSelectionResource", () => $c68314f43531feff$export$dead630ba04fdfe4);
$parcel$export(module.exports, "queueSidebarQueuesCategoryStateResource", () => $c68314f43531feff$export$9e9033d678058efa);

var $9XE6b = parcelRequire("9XE6b");

var $jcw0u = parcelRequire("jcw0u");


var $jthxb = parcelRequire("jthxb");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");

var $89SaW = parcelRequire("89SaW");

var $8w6CZ = parcelRequire("8w6CZ");

var $fRrvi = parcelRequire("fRrvi");

const $c68314f43531feff$var$getDataLoader = ()=>(parcelRequire("a2czB"));

const $c68314f43531feff$var$getPriorityGroupDataLoader = ()=>(parcelRequire("dY0qY"));

const $c68314f43531feff$var$fetchIssueListDataLoader = ()=>(parcelRequire("jyyvg"));
const $c68314f43531feff$var$getCombinedProjectKeyAndQueueId = ({ match: match, query: query })=>`${(0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0]}-${(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.queueId', '')}`;
const $c68314f43531feff$var$getResourceKeyFromProjectKey = ({ match: match, query: query })=>`${(0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0]}`;
const $c68314f43531feff$export$4fed8be571897bef = (0, $2M1hQ.createResource)({
    type: (0, $8w6CZ.RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS),
    getKey: $c68314f43531feff$var$getResourceKeyFromProjectKey,
    getDataLoader: $c68314f43531feff$var$getDataLoader,
    maxAge: (0, $8w6CZ.ONE_DAY_IN_MILLIS)
});
const $c68314f43531feff$export$1f9ab301771fe42e = (0, $2M1hQ.createResource)({
    type: (0, $8w6CZ.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
    getKey: $c68314f43531feff$var$getResourceKeyFromProjectKey,
    getDataLoader: $c68314f43531feff$var$getPriorityGroupDataLoader,
    maxAge: (0, $8w6CZ.ONE_DAY_IN_MILLIS),
    /**
	 * This resource will not load in SSR. Because priority group data resides in the JSM Kukama microservice.
	 * If we wanna fetch this resource during SSR, the request we're making from Tesseract -> Kukama is S2S, where Tesseract needs to know cookies information.
	 * We initially skipped SSR for fetching this resource, because we couldn’t retrieve the request cookie from JFE.
	 * Iiuc, the Jira team doesnt doesnt support this due to security concerns (the info is from JSM Queues team).
	 */ isBrowserOnly: true
});
const $c68314f43531feff$var$priorityGroupByProjectIdResourcePayload = {
    type: (0, $8w6CZ.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
    getKey: $c68314f43531feff$var$getResourceKeyFromProjectKey,
    getData: async ({ match: match, query: query, dependencies: dependencies }, { tenantContext: { cloudId: cloudId } })=>{
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(match, query);
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const { projectId: projectId } = await (0, $jthxb.consumeDependency)(dependencies, (0, $0f463a88567f1621$export$80a60a092d9ab81));
            return (0, $fRrvi.getPriorityGroupDataByProjectId)(projectId, projectKey, cloudId);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetchProjectContextError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            return (0, $fRrvi.getPriorityGroupDataByProjectId)(undefined, projectKey, cloudId);
        }
    },
    maxAge: (0, $8w6CZ.ONE_DAY_IN_MILLIS),
    depends: [
        (0, $0f463a88567f1621$export$80a60a092d9ab81)
    ]
};
const $c68314f43531feff$export$f6133a181a1ec201 = (0, $2M1hQ.createResource)({
    ...$c68314f43531feff$var$priorityGroupByProjectIdResourcePayload,
    isBrowserOnly: true
});
const $c68314f43531feff$export$b55fde45b61f13f4 = (0, $2M1hQ.createResource)($c68314f43531feff$var$priorityGroupByProjectIdResourcePayload);
const $c68314f43531feff$export$3d03cbaac8581e65 = (0, $2M1hQ.createResource)({
    type: (0, $8w6CZ.RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR),
    getKey: $c68314f43531feff$var$getCombinedProjectKeyAndQueueId,
    getDataLoader: $c68314f43531feff$var$fetchIssueListDataLoader,
    maxAge: 0,
    // run this resource from server only
    skipBrowser: true
});
const $c68314f43531feff$export$5b6f88b653545aa1 = (0, $2M1hQ.createResource)({
    type: (0, $8w6CZ.SERVICEDESK_QUEUES_SIDEBAR_VIEW_ALL_QUEUES),
    getKey: $c68314f43531feff$var$getResourceKeyFromProjectKey,
    getData: async ({ match: match, query: query }, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>{
        const projectKey = $c68314f43531feff$var$getResourceKeyFromProjectKey({
            match: match,
            query: query
        });
        try {
            if (!atlassianAccountId) throw new Error('accountId is missing.');
            const response = await (0, $89SaW.getUserProperty)(atlassianAccountId, `jsm-all-queues-state_is-open-${projectKey}`);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetchJsmQueueSidebarViewAllQueuesResourceError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    },
    maxAge: (0, $8w6CZ.ONE_DAY_IN_MILLIS)
});
const $c68314f43531feff$export$dead630ba04fdfe4 = (0, $2M1hQ.createResource)({
    type: (0, $8w6CZ.SERVICEDESK_QUEUES_NAV_4_SIDEBAR_SELECTION),
    getKey: $c68314f43531feff$var$getResourceKeyFromProjectKey,
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>{
        try {
            if (!atlassianAccountId) throw new Error('accountId is missing.');
            const response = await (0, $89SaW.getUserProperty)(atlassianAccountId, (0, $8w6CZ.LOCAL_STORAGE_KEY_NAV_LOCATION));
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetchQueueNav4SidebarSelectionResourceError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    },
    maxAge: (0, $8w6CZ.ONE_DAY_IN_MILLIS)
});
const $c68314f43531feff$export$9e9033d678058efa = (0, $2M1hQ.createResource)({
    type: (0, $8w6CZ.SERVICEDESK_QUEUES_SIDEBAR_QUEUES_CATEGORY),
    getKey: $c68314f43531feff$var$getResourceKeyFromProjectKey,
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>{
        try {
            if (!atlassianAccountId) throw new Error('accountId is missing.');
            const response = await (0, $89SaW.getUserProperty)(atlassianAccountId, (0, $8w6CZ.LOCAL_STORAGE_KEY_CATEGORY));
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetchJsmQueueSidebarQueuesCategoryStateResourceError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    },
    maxAge: (0, $8w6CZ.ONE_DAY_IN_MILLIS)
});

});
const $0f463a88567f1621$export$80a60a092d9ab81 = 'PROJECT_CONTEXT';

parcelRegister("jthxb", function(module, exports) {

$parcel$export(module.exports, "consumeDependency", () => $c406e66b8b597668$export$a973ef9e17a326f);
async function $c406e66b8b597668$export$a973ef9e17a326f(dependencies, key) {
    // There is an inflight request, the response is source of truth
    if (dependencies[key]?.loading) return dependencies[key]?.promise;
    if (dependencies[key]?.error) // Our dependency errored out the last time it ran, we don't have the data
    throw dependencies[key]?.error;
    // Last response is what we want
    return dependencies[key]?.data;
}

});

parcelRegister("8w6CZ", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS", () => $a4c66eaf20e13a4d$export$a401e6d6b205c72b);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS", () => $a4c66eaf20e13a4d$export$2064262c540606ba);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR", () => $a4c66eaf20e13a4d$export$2733615da5b906f0);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_NAV3_QUEUE_GROUPS_STATE", () => $a4c66eaf20e13a4d$export$f510a6e9fec0630a);
$parcel$export(module.exports, "SERVICEDESK_QUEUES_SIDEBAR_VIEW_ALL_QUEUES", () => $a4c66eaf20e13a4d$export$94bda82b7db2173c);
$parcel$export(module.exports, "SERVICEDESK_QUEUES_NAV_4_SIDEBAR_SELECTION", () => $a4c66eaf20e13a4d$export$7e07da72de89b61c);
$parcel$export(module.exports, "SERVICEDESK_QUEUES_SIDEBAR_QUEUES_CATEGORY", () => $a4c66eaf20e13a4d$export$5b3a0c7c3b3456f);
$parcel$export(module.exports, "LOCAL_STORAGE_KEY_NAV_LOCATION", () => $a4c66eaf20e13a4d$export$3c59a089fdd2614a);
$parcel$export(module.exports, "LOCAL_STORAGE_KEY_CATEGORY", () => $a4c66eaf20e13a4d$export$9b99689db482a6bb);
$parcel$export(module.exports, "ONE_DAY_IN_MILLIS", () => $a4c66eaf20e13a4d$export$5a00268156ea5027);
const $a4c66eaf20e13a4d$export$a401e6d6b205c72b = 'SERVICEDESK_QUEUES_NAVIGATION_ITEMS';
const $a4c66eaf20e13a4d$export$2064262c540606ba = 'SERVICEDESK_QUEUES_PRIORITY_GROUPS';
const $a4c66eaf20e13a4d$export$2733615da5b906f0 = 'SERVICEDESK_QUEUES_ISSUE_LIST_SSR';
const $a4c66eaf20e13a4d$export$f510a6e9fec0630a = 'SERVICEDESK_NAV3_QUEUE_GROUPS_STATE';
const $a4c66eaf20e13a4d$export$94bda82b7db2173c = 'SERVICEDESK_QUEUES_SIDEBAR_VIEW_ALL_QUEUES';
const $a4c66eaf20e13a4d$export$7e07da72de89b61c = 'SERVICEDESK_QUEUES_NAV_4_SIDEBAR_SELECTION';
const $a4c66eaf20e13a4d$export$5b3a0c7c3b3456f = 'SERVICEDESK_QUEUES_SIDEBAR_QUEUES_CATEGORY';
const $a4c66eaf20e13a4d$export$3c59a089fdd2614a = 'queue-groups-nav-state';
const $a4c66eaf20e13a4d$export$9b99689db482a6bb = 'queues-category-state';
const $a4c66eaf20e13a4d$export$5a00268156ea5027 = 86400000;

});

parcelRegister("fRrvi", function(module, exports) {

$parcel$export(module.exports, "getPriorityGroupDataByProjectId", () => $2d01df2d1057a1ad$export$cf2bd2ec601ed920);

var $aymwz = parcelRequire("aymwz");

var $fn8B5 = parcelRequire("fn8B5");

var $8Uumt = parcelRequire("8Uumt");

var $bFU4G = parcelRequire("bFU4G");

var $5yJb9 = parcelRequire("5yJb9");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $4R6GH = parcelRequire("4R6GH");
const $2d01df2d1057a1ad$var$fetchGroupsByKey = async (projectKey, cloudId)=>{
    return (0, $7f4tk.default)(`/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/groups?projectIdOrKey=${projectKey}${(0, $4R6GH.fg)('add-operation-query-param-to-queues-endpoints') ? '&operation=fetchPriorityGroups' : ''}`);
};
const $2d01df2d1057a1ad$var$fetchGroupsById = async (projectId, cloudId)=>{
    return (0, $7f4tk.default)(`/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/groups?projectId=${projectId}${(0, $4R6GH.fg)('add-operation-query-param-to-queues-endpoints') ? '&operation=fetchPriorityGroupsByProjectId' : ''}`);
};
const $2d01df2d1057a1ad$var$fetchGroupsByIdGraphql = async (projectId, cloudId)=>{
    const projectAri = `ari:cloud:jira:${cloudId}:project/${projectId}`;
    const result = await (0, $8Uumt.fetchQuery)((0, $5yJb9.default)(), (0, $aymwz.default), {
        projectAri: projectAri
    }).toPromise();
    return {
        results: result?.queuesprioritygroups_priorityGroups?.results?.reduce((priorityGroups, priorityGroup)=>{
            // this mapping function is to make types happy
            if (priorityGroup && priorityGroup.id && priorityGroup.name && priorityGroup.category && priorityGroup.queueIds) priorityGroups.push({
                id: priorityGroup.id,
                name: priorityGroup.name,
                category: priorityGroup.category,
                queueIds: priorityGroup.queueIds.reduce((queueIds, queueId)=>{
                    if (queueId !== null && queueId !== undefined) queueIds.push(queueId);
                    return queueIds;
                // we need the below, otherwise reduce things the type is never[]
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                }, []),
                ...priorityGroup.version ? {
                    version: priorityGroup.version
                } : {},
                ...priorityGroup.creationMethod ? {
                    creationMethod: priorityGroup.creationMethod
                } : {}
            });
            return priorityGroups;
        }, // we need the below, otherwise reduce things the type is never[]
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        []) ?? []
    };
};
const $2d01df2d1057a1ad$export$cf2bd2ec601ed920 = async (projectId, projectKey, cloudId)=>{
    const fetchStartTime = performance.now();
    let data;
    if (projectId) {
        (0, $4R6GH.fg)('queues-prioritygroups-relay') ? data = await $2d01df2d1057a1ad$var$fetchGroupsByIdGraphql(projectId, cloudId) : data = await $2d01df2d1057a1ad$var$fetchGroupsById(projectId, cloudId);
        if (!(0, $4R6GH.fg)('add-operation-query-param-to-queues-endpoints')) (0, $bFU4G.addSpanToAll)('fetch', 'fetchPriorityGroupsByProjectId', [
            {
                name: 'network'
            }
        ], fetchStartTime, performance.now());
    } else {
        (0, $jcw0u.default)({
            meta: {
                id: 'fetchPriorityGroupsProjectIdUndefined',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        data = await $2d01df2d1057a1ad$var$fetchGroupsByKey(projectKey, cloudId);
        if (!(0, $4R6GH.fg)('add-operation-query-param-to-queues-endpoints')) (0, $bFU4G.addSpanToAll)('fetch', 'fetchPriorityGroups', [
            {
                name: 'network'
            }
        ], fetchStartTime, performance.now());
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const processedData = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(data.results.map((group)=>({
            ...group,
            queues: group.queueIds || []
        })), 'category');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return processedData;
};

});
parcelRegister("aymwz", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ee8e4029fc17578$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<509a54dc797b22dc5439dcc947ec5646>>
 * @relayHash aa856b961b835b1f9323042c281fa03b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a06f924d3b993614f20cc99cb824d0a15370bb2745568a6f165c081ee7493530
const $2ee8e4029fc17578$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "projectId",
                    "variableName": "projectAri"
                }
            ],
            "concreteType": "QueuesPriorityGroupsResults",
            "kind": "LinkedField",
            "name": "queuesprioritygroups_priorityGroups",
            "plural": false,
            "selections": [
                {
                    "concreteType": "QueuesPriorityGroupsResultsGroup",
                    "kind": "LinkedField",
                    "name": "results",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "category"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "queueIds"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "version"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "creationMethod"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "getPriorityGroupDataByProjectIdQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "getPriorityGroupDataByProjectIdQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "a06f924d3b993614f20cc99cb824d0a15370bb2745568a6f165c081ee7493530",
            "metadata": {},
            "name": "getPriorityGroupDataByProjectIdQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2ee8e4029fc17578$var$node.hash = "e99dcef5a507344c549819dcfbf09d31";
var $2ee8e4029fc17578$export$2e2bcd8739ae039 = $2ee8e4029fc17578$var$node;

});

parcelRegister("fn8B5", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $4CZTG = parcelRequire("4CZTG");
/** Used for built-in method references. */ var $b30fac385487af61$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b30fac385487af61$var$hasOwnProperty = $b30fac385487af61$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $b30fac385487af61$var$groupBy = $4CZTG(function(result, value, key) {
    if ($b30fac385487af61$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $1m3dq(result, key, [
        value
    ]);
});
module.exports = $b30fac385487af61$var$groupBy;

});


parcelRegister("a2czB", function(module, exports) {

let $74e3d816256db699$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $74e3d816256db699$var$load("kVX56"),
    $74e3d816256db699$var$load("aG1rf")
]).then(()=>parcelRequire('lini2'));

});

parcelRegister("dY0qY", function(module, exports) {

let $a2b13728cd2933bf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a2b13728cd2933bf$var$load("dg10h").then(()=>parcelRequire('etJR3'));

});

parcelRegister("jyyvg", function(module, exports) {

let $e3cbf4eb1d60bd0a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e3cbf4eb1d60bd0a$var$load("3pKue").then(()=>parcelRequire('bmzqI'));

});


parcelRegister("7MCPm", function(module, exports) {

$parcel$export(module.exports, "RedirectToLastVisitedProjectPage", () => $4c121c4cc7d1faa6$export$86041af020f4c959);

var $5uXOq = parcelRequire("5uXOq");

var $hqxtv = parcelRequire("hqxtv");
const $4c121c4cc7d1faa6$export$86041af020f4c959 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hqxtv.default), null);

});
parcelRegister("hqxtv", function(module, exports) {

$parcel$export(module.exports, "default", () => $bda9d95137e1a17a$export$2e2bcd8739ae039);

var $1bQGJ = parcelRequire("1bQGJ");

var $aNBa3 = parcelRequire("aNBa3");
var $bda9d95137e1a17a$export$2e2bcd8739ae039 = (0, $1bQGJ.withRouter)((0, $aNBa3.default));

});
parcelRegister("aNBa3", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d9c467899b3389b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $ebyGx = parcelRequire("ebyGx");

var $fNobW = parcelRequire("fNobW");

var $fDtbf = parcelRequire("fDtbf");

var $kUU4G = parcelRequire("kUU4G");

var $4Pf62 = parcelRequire("4Pf62");

var $2YZCu = parcelRequire("2YZCu");

var $7f4tk = parcelRequire("7f4tk");


var $ebbSc = parcelRequire("ebbSc");
const $8d9c467899b3389b$var$buildEndpoint = (projectKey, initialRedirect)=>`/rest/internal/2/projectlandingpage/${projectKey}${initialRedirect ? '?initialRedirect=true' : ''}`;
const $8d9c467899b3389b$var$allowListedSearchParams = [
    (0, $0592ef8772eedefd$export$29d3926e3d72cfb),
    (0, $0592ef8772eedefd$export$b3233b76460c1e7c)
];
const $8d9c467899b3389b$var$redirectForAnonymousUser = (projectKey, history, startTime)=>{
    const destination = `/projects/${projectKey}/issues/?filter=allissues`;
    history.replace(destination);
    // Log success
    (0, $2YZCu.default).safeInfoWithoutCustomerData((0, $0592ef8772eedefd$export$25a759e49d5049db), 'History replace correctly triggered for anonymous user', {
        requestTime: (0, $ebbSc.getNow)() - startTime,
        destination: destination
    });
};
const $8d9c467899b3389b$export$c79af62ad7a1fe8a = (query)=>Object.fromEntries(Object.entries(query).filter(([key])=>$8d9c467899b3389b$var$allowListedSearchParams.some((allowedParam)=>key === allowedParam) || key.includes((0, $0592ef8772eedefd$export$29d3926e3d72cfb))));
const $8d9c467899b3389b$export$283f1587d7a5369f = (searchQuery, queryInitializer)=>{
    const queryKeys = new URLSearchParams(searchQuery).toString();
    return queryKeys.length > 0 ? `${queryInitializer}${queryKeys}` : '';
};
class $8d9c467899b3389b$export$bf8d1fdc3b47a835 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { history: history, location: location, query: query, match: { params: params } } = this.props;
        // First time a project is created
        const { initial: initial } = query;
        // Clear the SSR Ready Mark if present
        (0, $kUU4G.default)((0, $fDtbf.SPA_SSR_RENDERED_MARK));
        const startTime = (0, $ebbSc.getNow)();
        const projectKey = // @ts-expect-error - TS2345 - Argument of type 'string | {}' is not assignable to parameter of type 'string'.
        params.projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(location, 'search', {})).projectKey;
        if (!params.projectKey) (0, $2YZCu.default).safeInfoWithoutCustomerData((0, $0592ef8772eedefd$export$25a759e49d5049db), 'queryString', {
            duration: (0, $ebbSc.getNow)() - startTime
        });
        if (projectKey) (0, $7f4tk.default)($8d9c467899b3389b$var$buildEndpoint(projectKey, !!initial)).then((response)=>{
            const endTime = (0, $ebbSc.getNow)();
            let searchQueryParams = '';
            const searchQuery = $8d9c467899b3389b$export$c79af62ad7a1fe8a(query);
            const queryInitializer = response.data.url.includes('?') ? '&' : '?';
            searchQueryParams = $8d9c467899b3389b$export$283f1587d7a5369f(searchQuery, queryInitializer);
            const destination = response.data.url + searchQueryParams;
            history.replace(destination);
            // Log success
            (0, $2YZCu.default).safeInfoWithoutCustomerData((0, $0592ef8772eedefd$export$25a759e49d5049db), 'History replace correctly triggered', {
                requestTime: endTime - startTime,
                destination: destination
            });
        }, (error)=>{
            const endTime = (0, $ebbSc.getNow)();
            if ((0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)().isAnonymous) $8d9c467899b3389b$var$redirectForAnonymousUser(projectKey, history, startTime);
            else // Log failures
            (0, $2YZCu.default).safeErrorWithoutCustomerData((0, $0592ef8772eedefd$export$25a759e49d5049db), `Error on request. Request time: ${endTime - startTime}`, error);
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
            name: "last-visited-project-page-redirect"
        });
    }
}
var $8d9c467899b3389b$export$2e2bcd8739ae039 = $8d9c467899b3389b$export$bf8d1fdc3b47a835;

});
const $0592ef8772eedefd$export$25a759e49d5049db = 'spa-apps.common.redirect.last-visited-project-page';
const $0592ef8772eedefd$export$29d3926e3d72cfb = 'search';
const $0592ef8772eedefd$export$b3233b76460c1e7c = 'showProjectBuilder';

parcelRegister("ebbSc", function(module, exports) {

$parcel$export(module.exports, "getNow", () => $fa5a995d36ebfbde$export$3991332aae1fc754);
const $fa5a995d36ebfbde$export$3991332aae1fc754 = ()=>Date.now();

});





parcelRegister("gm7fA", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessAttachmentsRouteEntry", () => $dfc0a30c9444e0ae$export$62c45d8ff658b6c2);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $bokkA = parcelRequire("bokkA");

var $6DXrm = parcelRequire("6DXrm");

var $lkFvK = parcelRequire("lkFvK");

var $fo6b8 = parcelRequire("fo6b8");
const $dfc0a30c9444e0ae$var$attachmentsPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $6DXrm.attachmentsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $dfc0a30c9444e0ae$export$62c45d8ff658b6c2 = (0, $7NszV.createEntry)((0, $bokkA.jiraBusinessAttachmentsRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.attachments-view',
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        entryPoint: ()=>$dfc0a30c9444e0ae$var$attachmentsPageEntryPoint,
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)()
    }));

});
parcelRegister("lRPBw", function(module, exports) {

$parcel$export(module.exports, "businessProjectLayout", () => $d0bc40d3dc70d875$export$dfb0c3e0348f4429);

var $2vSU6 = parcelRequire("2vSU6");

var $1Du13 = parcelRequire("1Du13");

var $aPfsS = parcelRequire("aPfsS");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d0bc40d3dc70d875$var$Onboarding = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("b8Tmv")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/business-project-layout/src/ui/onboarding/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d0bc40d3dc70d875$var$withAnyBusinessProjectContext = (Component)=>(0, $aPfsS.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $2vSU6.CORE_PROJECT)
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d0bc40d3dc70d875$var$RightSidebars = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("lgXhK")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/business-project-layout/src/ui/right-sidebars/index.tsx"
});
const $d0bc40d3dc70d875$var$BusinessOnboarding = $d0bc40d3dc70d875$var$withAnyBusinessProjectContext($d0bc40d3dc70d875$var$Onboarding);
const $d0bc40d3dc70d875$var$nonSettingsRightSidebars = [
    $d0bc40d3dc70d875$var$withAnyBusinessProjectContext($d0bc40d3dc70d875$var$RightSidebars)
];
const $d0bc40d3dc70d875$var$sharedBusinessProjectLayout = (0, $aPfsS.composeLayouts)((0, $1Du13.projectLayout));
const $d0bc40d3dc70d875$export$dfb0c3e0348f4429 = (0, $aPfsS.composeLayouts)($d0bc40d3dc70d875$var$sharedBusinessProjectLayout, {
    rightSidebars: $d0bc40d3dc70d875$var$nonSettingsRightSidebars,
    globalComponents: [
        $d0bc40d3dc70d875$var$BusinessOnboarding
    ]
});

});
parcelRegister("b8Tmv", function(module, exports) {

let $81cb62d0e10c7f6d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $81cb62d0e10c7f6d$var$load("bX0C0").then(()=>parcelRequire('3PxNF'));

});

parcelRegister("lgXhK", function(module, exports) {

let $f7c91463c7d493b3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f7c91463c7d493b3$var$load("cCg53").then(()=>parcelRequire('lktzL'));

});


parcelRegister("aVFIE", function(module, exports) {

$parcel$export(module.exports, "ThemedLazySkeleton", () => $136611be2ae39444$export$ddeb5d943c4f17e3);
/* ThemedLazySkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fNobW = parcelRequire("fNobW");

var $lob44 = parcelRequire("lob44");
const $136611be2ae39444$export$ddeb5d943c4f17e3 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($136611be2ae39444$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "themed-spinner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lob44.ThemedSpinner), null))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $136611be2ae39444$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1osq _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lob44", function(module, exports) {

$parcel$export(module.exports, "ThemedSpinner", () => $150e941eee16207a$export$271c7b154ad6c401);
/* ThemedSpinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");
const $150e941eee16207a$export$271c7b154ad6c401 = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($150e941eee16207a$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "large",
        ...props,
        testId: "project-theme-components.ui.themed-spinner"
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $150e941eee16207a$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1xjgvy9e",
            __cmplp.className
        ])
    });
});

});


parcelRegister("bokkA", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessAttachmentsRoute", () => $8ee02e904721e8ab$export$81237c0b791e592e);
const $8ee02e904721e8ab$export$81237c0b791e592e = {
    name: 'classic-business-attachments',
    path: '/jira/core/projects/:projectKey/attachments'
};

});

parcelRegister("6DXrm", function(module, exports) {

$parcel$export(module.exports, "attachmentsEntryPoint", () => $5488b7c894698968$export$d94bafd9d893ec98);

var $e31y9 = parcelRequire("e31y9");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $5488b7c894698968$export$d94bafd9d893ec98 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("fIEnV")), {
        moduleId: "26a1d436"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        // This entry point should only load in this route
        // once overview is supported by backend, we should have a different entry point for it
        const { projectKey: projectKey } = context.match.params;
        if (!projectKey) throw new Error('projectKey is required');
        return {
            queries: {
                jwmAttachmentsQuery: {
                    parameters: $e31y9.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: projectKey,
                        projectKeys: [
                            projectKey
                        ],
                        filters: {
                            fileName: '',
                            authorIds: [],
                            mimeTypes: [],
                            dateRange: {
                                before: undefined,
                                after: undefined
                            }
                        },
                        durationInSeconds: 900,
                        maxTokenLength: 65534,
                        attachmentCount: 100
                    },
                    options: {
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        fetchPolicy: 'network-only'
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        };
    }
});

});
parcelRegister("e31y9", function(module, exports) {

$parcel$export(module.exports, "default", () => $6955691f2f41efa8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<27cf8d4c8476b55ad0214615c4321597>>
 * @relayHash c6e9983b2d202d37d436585f73068bb1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9c2e6d7f1e46fae7f20940e5f2d25270db884f9c4ffb727bc5ca1be7cef02546
const $6955691f2f41efa8$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "9c2e6d7f1e46fae7f20940e5f2d25270db884f9c4ffb727bc5ca1be7cef02546",
        "metadata": {},
        "name": "src_jiraBusinessAttachmentsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $6955691f2f41efa8$export$2e2bcd8739ae039 = $6955691f2f41efa8$var$node;

});

parcelRegister("fIEnV", function(module, exports) {

let $b71a4aabd8d5e093$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $b71a4aabd8d5e093$var$load("ffQaD"),
    $b71a4aabd8d5e093$var$load("kvRbA"),
    $b71a4aabd8d5e093$var$load("3m9rR")
]).then(()=>parcelRequire('hLT0c'));

});



parcelRegister("gbj7F", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessBoardEmbedRouteEntry", () => $0142438b20a4e9a9$export$7a97e5e258f37b2a);

var $6e4Kt = parcelRequire("6e4Kt");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $d8VYe = parcelRequire("d8VYe");

var $lNicp = parcelRequire("lNicp");

var $0sAwf = parcelRequire("0sAwf");

var $93hm0 = parcelRequire("93hm0");
const $0142438b20a4e9a9$export$7a97e5e258f37b2a = (0, $7NszV.createEntry)((0, $0sAwf.jiraBusinessBoardEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.jwm-board-embed',
        layout: (0, $6e4Kt.chromelessLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        resources: [
            ...(0, $lNicp.getProjectViewResources)(),
            (0, $d8VYe.workflowIssuesResource)
        ],
        entryPoint: ()=>(0, $93hm0.boardEmbedPageEntryPoint)
    }));

});
parcelRegister("6e4Kt", function(module, exports) {

$parcel$export(module.exports, "chromelessLayout", () => $c3106f352857c22e$export$17e73ed8c35891cb);

var $aPfsS = parcelRequire("aPfsS");
const $c3106f352857c22e$export$17e73ed8c35891cb = (0, $aPfsS.createLayout)({
    isChromeless: true
});

});

parcelRegister("d8VYe", function(module, exports) {

$parcel$export(module.exports, "workflowIssuesResource", () => $6a9e21653771d63a$export$49027035af709702);
$parcel$export(module.exports, "useWorkflowIssues", () => $6a9e21653771d63a$export$86b7de71bf71360d);

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $9YrR3 = parcelRequire("9YrR3");
const $6a9e21653771d63a$var$RESOURCE_TYPE_KEY = 'BUSINESS_WORKFLOW_ISSUES';

const $6a9e21653771d63a$export$49027035af709702 = (0, $2M1hQ.createResource)({
    type: $6a9e21653771d63a$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        return `${$6a9e21653771d63a$var$RESOURCE_TYPE_KEY}_${projectKey}_${matchedRoute.match?.params?.itemId ?? 'default'}`;
    },
    getDataLoader: ()=>Promise.resolve((parcelRequire("9YrR3"))),
    getData: (0, $9YrR3.default),
    maxAge: 1000,
    isBrowserOnly: true
});
const $6a9e21653771d63a$export$86b7de71bf71360d = ()=>// forcing the return type due to react-resource-router's weird error types
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $2YP9W.useResource)($6a9e21653771d63a$export$49027035af709702);

});
parcelRegister("9YrR3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $465154b480a996b2$export$2e2bcd8739ae039);

var $7juH2 = parcelRequire("7juH2");

var $x9xyg = parcelRequire("x9xyg");

var $jJZqs = parcelRequire("jJZqs");

var $8PRuf = parcelRequire("8PRuf");

var $iR3GG = parcelRequire("iR3GG");
const $465154b480a996b2$var$EMPTY_DATA = {
    workflows: [],
    lastChangedTime: null
};
function $465154b480a996b2$var$getEarlyPreload() {
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__JIRA_BUSINESS_BOARD_WORKFLOWS_DATA_PROMISE__) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const earlyPreloadPromise = window.__JIRA_BUSINESS_BOARD_WORKFLOWS_DATA_PROMISE__;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__JIRA_BUSINESS_BOARD_WORKFLOWS_DATA_PROMISE__ = null;
        return earlyPreloadPromise.then((response)=>{
            if (!response.success) {
                if (response.error.status === 304) throw new (0, $7juH2.Unchanged)('Workflow issues have not changed since the last request');
                throw new (0, $jJZqs.default)(response.error.status);
            }
            return {
                workflows: response.workflows,
                lastChangedTime: null
            };
        });
    }
    return null;
}
function $465154b480a996b2$var$fetchData({ projectKey: projectKey, itemId: itemId }) {
    const earlyPreload = $465154b480a996b2$var$getEarlyPreload();
    if (earlyPreload !== null) return earlyPreload;
    return (0, $7juH2.fetchWorkflowIssues)({
        projectKey: projectKey,
        itemId: itemId
    });
}
async function $465154b480a996b2$export$2e2bcd8739ae039({ match: match }, { tenantContext: tenantContext }) {
    const { isAnonymous: isAnonymous } = tenantContext;
    if (isAnonymous) return $465154b480a996b2$var$EMPTY_DATA;
    try {
        (0, $x9xyg.setMark)((0, $8PRuf.prefetchApiStartMark));
        const workflows = await $465154b480a996b2$var$fetchData({
            projectKey: match.params.projectKey ?? '',
            itemId: match.params.itemId ?? undefined
        });
        (0, $x9xyg.setMark)((0, $8PRuf.prefetchApiReadyMark));
        return workflows;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $iR3GG.createResourceError)({
            component: 'spa.view.routes.business.board-workflows.getData',
            message: 'An error was thrown while prefetching board data',
            name: 'ResourceError'
        }, error);
    }
}

});
parcelRegister("7juH2", function(module, exports) {

$parcel$export(module.exports, "Unchanged", () => $16e71a1b1f979cb0$export$eccd6db33b8f6a89);
$parcel$export(module.exports, "fetchWorkflowIssues", () => $16e71a1b1f979cb0$export$17e2e8212d93f58d);

var $gKZoD = parcelRequire("gKZoD");


var $gN11a = parcelRequire("gN11a");

var $jJZqs = parcelRequire("jJZqs");

var $5HnTq = parcelRequire("5HnTq");
class $16e71a1b1f979cb0$export$eccd6db33b8f6a89 extends Error {
}
const $16e71a1b1f979cb0$export$17e2e8212d93f58d = async ({ projectKey: projectKey, itemId: itemId, ifChangedSince: ifChangedSince })=>{
    (0, $gKZoD.di)(fetch);
    try {
        (0, $gN11a.markViewMetric)('jwm-board', (0, $a286480ec63fa4c8$export$23e322eb7c526958));
        let url = `/rest/board-api/1/board/${projectKey}/workflows?excludeLabels=true`;
        if (itemId) url += `&viewItemId=${itemId}`;
        const defaultOptions = (0, $5HnTq.getDefaultOptions)(url);
        const response = await fetch(url, {
            ...defaultOptions,
            headers: {
                ...defaultOptions.headers,
                ...ifChangedSince ? {
                    'x-aif-changed-since': ifChangedSince
                } : undefined
            }
        });
        if (!response.ok) {
            if (response.status === 304) throw new $16e71a1b1f979cb0$export$eccd6db33b8f6a89('Workflow issues have not changed since the last request');
            throw new (0, $jJZqs.default)(response.status);
        }
        const lastChangedTime = response.headers.get('x-alast-changed-time');
        const workflows = await response.json();
        return {
            workflows: workflows.data,
            lastChangedTime: lastChangedTime
        };
    } finally{
        (0, $gN11a.markViewMetric)('jwm-board', (0, $a286480ec63fa4c8$export$83ca21a50372ea3b));
    }
};

});
const $a286480ec63fa4c8$export$747aad128920134d = 3000;
const $a286480ec63fa4c8$export$e4f8d353742c04ac = 4000;
const $a286480ec63fa4c8$export$540ffd289e5e0562 = 'timeWaitingForBackendData';
const $a286480ec63fa4c8$export$23e322eb7c526958 = 'REQUEST_START';
const $a286480ec63fa4c8$export$83ca21a50372ea3b = 'REQUEST_END';
const $a286480ec63fa4c8$export$821ca6ff41f300ec = 'jwm-availableFieldsQuery';
const $a286480ec63fa4c8$export$7b887ee35f2b465e = 'AVAILABLE_FIELDS_QUERY_START';
const $a286480ec63fa4c8$export$ac953882305d6102 = 'AVAILABLE_FIELDS_QUERY_END';
const $a286480ec63fa4c8$export$7f7f60b5526c5ee3 = 'jwm-ui-render-time';
const $a286480ec63fa4c8$export$b78f0bbf209e5f4 = 'UI_RENDER_START';
const $a286480ec63fa4c8$export$88ea1e280513690f = 'UI_RENDER_END';

parcelRegister("gN11a", function(module, exports) {

$parcel$export(module.exports, "pageLoadMetrics", () => $f9c6206c3cbbca63$export$2878bf482e539059);
$parcel$export(module.exports, "markViewMetric", () => $f9c6206c3cbbca63$export$8d15b4fb25f90514);

var $dGrdR = parcelRequire("dGrdR");

const $f9c6206c3cbbca63$var$slo = {
    fmp: {
        initial: {
            threshold: (0, $a286480ec63fa4c8$export$747aad128920134d)
        },
        transition: {
            threshold: (0, $a286480ec63fa4c8$export$747aad128920134d)
        }
    },
    tti: {
        initial: {
            threshold: (0, $a286480ec63fa4c8$export$e4f8d353742c04ac)
        },
        transition: {
            threshold: (0, $a286480ec63fa4c8$export$e4f8d353742c04ac)
        }
    }
};
const $f9c6206c3cbbca63$var$timings = [
    {
        key: (0, $a286480ec63fa4c8$export$540ffd289e5e0562),
        startMark: (0, $a286480ec63fa4c8$export$23e322eb7c526958),
        endMark: (0, $a286480ec63fa4c8$export$83ca21a50372ea3b)
    },
    {
        key: (0, $a286480ec63fa4c8$export$821ca6ff41f300ec),
        startMark: (0, $a286480ec63fa4c8$export$7b887ee35f2b465e),
        endMark: (0, $a286480ec63fa4c8$export$ac953882305d6102)
    },
    {
        key: (0, $a286480ec63fa4c8$export$7f7f60b5526c5ee3),
        startMark: (0, $a286480ec63fa4c8$export$b78f0bbf209e5f4),
        endMark: (0, $a286480ec63fa4c8$export$88ea1e280513690f)
    }
];
const $f9c6206c3cbbca63$export$2878bf482e539059 = {
    'approvals-view': (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.approvals-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    summary: (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.summary-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'summary-embed': (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.summary-view-embed',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    list: (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.list-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'list-embed': (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.list-embed-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'software-form-submit-embed': (0, $dGrdR.metrics).pageLoad({
        key: 'jsw.form-submit-embed',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'software-list': (0, $dGrdR.metrics).pageLoad({
        key: 'jsw.list-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'software-list-embed': (0, $dGrdR.metrics).pageLoad({
        key: 'jsw.list-view-embed',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    timeline: (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.timeline-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'timeline-embed': (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.timeline-embed-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    calendar: (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.calendar-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'calendar-embed': (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.calendar-embed-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    form: (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.form-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'form-submit': (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.form-submit-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'form-submit-embed': (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.form-submit-embed-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'form-submit-public': (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.form-submit-public-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'form-directory': (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.form-directory-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    board: (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.board-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'jwm-board': (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.jwm-board',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'jwm-board-embed': (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.jwm-board-embed',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    'jwm-pages': (0, $dGrdR.metrics).pageLoad({
        key: 'jwm.jwm-pages',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    }),
    // TODO: will be removed with sploverview-decouple-calendar-perf-metrics
    'software-plan-calendar': (0, $dGrdR.metrics).pageLoad({
        key: 'jsw.plan-calendar-view',
        slo: $f9c6206c3cbbca63$var$slo,
        timings: $f9c6206c3cbbca63$var$timings
    })
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f9c6206c3cbbca63$var$startedMarks = {};
const $f9c6206c3cbbca63$export$8d15b4fb25f90514 = (view, mark)=>{
    const markKey = `${view}-${mark}`;
    // prevent overriding marks when markViewMetric() is called many times with the same param
    if ($f9c6206c3cbbca63$var$startedMarks[markKey]) return;
    $f9c6206c3cbbca63$var$startedMarks[markKey] = true;
    const metric = $f9c6206c3cbbca63$export$2878bf482e539059[view];
    metric?.mark(mark);
};

});


parcelRegister("8PRuf", function(module, exports) {

$parcel$export(module.exports, "appBundleReadyMark", () => $0ec5205bf4957ca4$export$7e50945a65dd40e);
$parcel$export(module.exports, "prefetchApiReadyMark", () => $0ec5205bf4957ca4$export$17cbe723d23101d8);
$parcel$export(module.exports, "prefetchApiStartMark", () => $0ec5205bf4957ca4$export$887fadb22e7c7735);
$parcel$export(module.exports, "jswRenderStartMark", () => $0ec5205bf4957ca4$export$bd099c0a906f4b3f);
$parcel$export(module.exports, "jswCreateReduxStoreStartMark", () => $0ec5205bf4957ca4$export$d23ef9e7633e30e7);
$parcel$export(module.exports, "jswCreateReduxStoreEndMark", () => $0ec5205bf4957ca4$export$319da6d901948a6d);
$parcel$export(module.exports, "jswTransformCriticalDataStartMark", () => $0ec5205bf4957ca4$export$f0b6622cdc5c7e4f);
$parcel$export(module.exports, "jswTransformCriticalDataEndMark", () => $0ec5205bf4957ca4$export$37e82663aa1e79a8);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedStartMark", () => $0ec5205bf4957ca4$export$21146514eacceb12);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedEndMark", () => $0ec5205bf4957ca4$export$4eb8d44ddb14424a);


var $hXKq5 = parcelRequire("hXKq5");
const $0ec5205bf4957ca4$export$7e50945a65dd40e = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$ff834eccc35b9089));
const $0ec5205bf4957ca4$export$17cbe723d23101d8 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$86b05e34d462ead8));
const $0ec5205bf4957ca4$export$887fadb22e7c7735 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$d6a604a7d9a390fb));
const $0ec5205bf4957ca4$export$bd099c0a906f4b3f = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$3ae43cc1782d058f));
const $0ec5205bf4957ca4$export$d23ef9e7633e30e7 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$363f6703ffa600be));
const $0ec5205bf4957ca4$export$319da6d901948a6d = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$e87b74567b79c8));
const $0ec5205bf4957ca4$export$f0b6622cdc5c7e4f = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$99fe642459a8b02));
const $0ec5205bf4957ca4$export$37e82663aa1e79a8 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$ab1f5705fc8e0571));
const $0ec5205bf4957ca4$export$21146514eacceb12 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$8c3a9046da692c35));
const $0ec5205bf4957ca4$export$4eb8d44ddb14424a = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$5aa497d1efdcc5bf));

});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("iR3GG", function(module, exports) {

$parcel$export(module.exports, "createResourceError", () => $d895341acba1e817$export$13487d18466bc8a5);

var $2YZCu = parcelRequire("2YZCu");
class $d895341acba1e817$var$ResourceErrorClass extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message);
        this.name = options.name || 'ResourceError';
        this.skipSentry = options.skipSentry;
    }
}
const $d895341acba1e817$export$13487d18466bc8a5 = ({ name: name = 'ResourceError', message: message = '', component: component = '', skipSentry: skipSentry = false }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
errorOverride)=>{
    (0, $2YZCu.default).safeErrorWithoutCustomerData(component, message, errorOverride);
    if (errorOverride) return errorOverride;
    return new $d895341acba1e817$var$ResourceErrorClass(message, {
        name: name,
        skipSentry: skipSentry
    });
};

});



parcelRegister("0sAwf", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessBoardEmbedRoute", () => $143b8615692fbb7d$export$bd75a810572fe27d);
const $143b8615692fbb7d$export$bd75a810572fe27d = {
    name: 'classic-business-board-embed',
    path: '/jira/core/projects/:projectKey/board/embed',
    exact: true
};

});

parcelRegister("93hm0", function(module, exports) {

$parcel$export(module.exports, "boardEmbedPageEntryPoint", () => $b8780d447378502c$export$5046daadb8899791);

var $lkFvK = parcelRequire("lkFvK");

var $9715X = parcelRequire("9715X");
const $b8780d447378502c$export$5046daadb8899791 = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $9715X.boardEmbedEntryPoint)
});

});
parcelRegister("9715X", function(module, exports) {

$parcel$export(module.exports, "boardEmbedEntryPoint", () => $302c841aa900e4ab$export$416ba69e2e054935);

var $kCyK0 = parcelRequire("kCyK0");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $302c841aa900e4ab$export$416ba69e2e054935 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("3xH9w")), {
        moduleId: "c853cc44"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        const itemId = context.match.params.itemId ?? '';
        let filterJql = context.query?.filter;
        let groupBy = context.query?.groupBy;
        // if in a client environment, check whether the router url matches the current window pathname
        // if it does, use the filter and groupBy from the current window location instead of the router query
        // this avoids reloading the query without the overrides when a user hovers over prefetching links that don't include them
        if (typeof window !== 'undefined' && window.location.pathname === context.match.url) {
            const searchParams = new URLSearchParams(window.location.search);
            filterJql = searchParams.get('filter') ?? undefined;
            groupBy = searchParams.get('groupBy') ?? undefined;
        }
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                boardEmbedQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $kCyK0.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey,
                        viewInput: {
                            jiraBoardViewQueryInput: {
                                projectKeyAndItemIdQuery: {
                                    cloudId: cloudId,
                                    projectKey: projectKey,
                                    itemId: itemId
                                }
                            },
                            settings: {
                                filterJql: filterJql,
                                groupBy: groupBy
                            }
                        }
                    }
                }
            }
        };
    }
});

});
parcelRegister("kCyK0", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc9b07a0cf3a6615$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<860e2995496302c71ba8c0f688d69425>>
 * @relayHash 357c7820ead07a84327f26416069c9fa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dd86325ff592436e84040778a3e2a713bef073b87fa5fd230d1b1cb35876ead1

var $3K6QB = parcelRequire("3K6QB");

var $apYuT = parcelRequire("apYuT");
const $cc9b07a0cf3a6615$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "dd86325ff592436e84040778a3e2a713bef073b87fa5fd230d1b1cb35876ead1",
        "metadata": {},
        "name": "src_jiraBusinessBoardEmbedQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcallowstatusmappingonbusinessboardrelayprovider": (0, $3K6QB.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider": (0, $apYuT.default)
        }
    }
};
var $cc9b07a0cf3a6615$export$2e2bcd8739ae039 = $cc9b07a0cf3a6615$var$node;

});
parcelRegister("3K6QB", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a116c0c5e30cca9$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $4a116c0c5e30cca9$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('mbw-43-allow-status-mapping-on-business-board');
    }
};

});

parcelRegister("apYuT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4118540cc4c9ddd7$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");
const $4118540cc4c9ddd7$var$MergeBoardWorkflowsRelayProvider = {
    get () {
        return (0, $6s1PB.expVal)('merge_board_workflows', 'enabled', false);
    }
};
var $4118540cc4c9ddd7$export$2e2bcd8739ae039 = $4118540cc4c9ddd7$var$MergeBoardWorkflowsRelayProvider;

});


parcelRegister("3xH9w", function(module, exports) {

let $2945ed6316c4aa28$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2945ed6316c4aa28$var$load("ffQaD"),
    $2945ed6316c4aa28$var$load("kvRbA"),
    $2945ed6316c4aa28$var$load("fliVL"),
    $2945ed6316c4aa28$var$load("7TaZM")
]).then(()=>parcelRequire('azXNC'));

});




parcelRegister("8gEiV", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessBoardCustomEmbedRouteEntry", () => $8fc4c7c9ffb4bf6a$export$4622ad4c7294f3a7);

var $6e4Kt = parcelRequire("6e4Kt");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $d8VYe = parcelRequire("d8VYe");

var $lNicp = parcelRequire("lNicp");

var $5JXXx = parcelRequire("5JXXx");

var $93hm0 = parcelRequire("93hm0");
const $8fc4c7c9ffb4bf6a$export$4622ad4c7294f3a7 = (0, $7NszV.createEntry)((0, $5JXXx.jiraBusinessBoardCustomEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.jwm-board-embed',
        layout: (0, $6e4Kt.chromelessLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        resources: [
            ...(0, $lNicp.getProjectViewResources)(),
            (0, $d8VYe.workflowIssuesResource)
        ],
        entryPoint: ()=>(0, $93hm0.boardEmbedPageEntryPoint)
    }));

});
parcelRegister("5JXXx", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessBoardCustomEmbedRoute", () => $609d5e332788d2ad$export$7d977a74e9d9d32b);
const $609d5e332788d2ad$export$7d977a74e9d9d32b = {
    name: 'classic-business-board-custom-embed',
    path: '/jira/core/projects/:projectKey/board/:itemId/embed',
    exact: true
};

});


parcelRegister("dhiyM", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessBoardRouteEntry", () => $0eb25cb247c76465$export$c7fe0dd4417407a0);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $g5RGc = parcelRequire("g5RGc");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $d8VYe = parcelRequire("d8VYe");

var $lNicp = parcelRequire("lNicp");

var $g8BTw = parcelRequire("g8BTw");

var $gkbjZ = parcelRequire("gkbjZ");
const $0eb25cb247c76465$export$c7fe0dd4417407a0 = (0, $7NszV.createEntry)((0, $g8BTw.jiraBusinessBoardRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.jwm-board',
        layout: (0, $aPfsS.composeLayouts)((0, $lRPBw.businessProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $lNicp.getProjectViewResources)(),
            (0, $d8VYe.workflowIssuesResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'business-board-early-entry'
            ]
        },
        entryPoint: ()=>(0, $gkbjZ.boardPageEntryPoint)
    }));

});
parcelRegister("g5RGc", function(module, exports) {

$parcel$export(module.exports, "fullPageIssuePreloadLayout", () => $59d96d961d806fee$export$98e337c40eb151da);
$parcel$export(module.exports, "embeddedIssuePreloadLayoutBuilder", () => $59d96d961d806fee$export$7b113174a456921a);
$parcel$export(module.exports, "pageLoadIssuePreloadLayoutBuilder", () => $59d96d961d806fee$export$682dcbf7cc80ba11);

var $aPfsS = parcelRequire("aPfsS");

var $lGGIs = parcelRequire("lGGIs");

var $kxZPA = parcelRequire("kxZPA");

var $lODMY = parcelRequire("lODMY");
var $4sxG1 = parcelRequire("4sxG1");

var $l7Ytp = parcelRequire("l7Ytp");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $59d96d961d806fee$var$LazyIssuePage = (0, $kxZPA.lazyAfterPaint)(()=>(0, $lGGIs.markAsBentoBundleReady)((parcelRequire("kJXED"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/issue/src/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $59d96d961d806fee$var$AsyncIssueAppComponent = (0, $kxZPA.lazyAfterPaint)(()=>(0, $lGGIs.markAsBentoBundleReady)((parcelRequire("eLfPy"))), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $59d96d961d806fee$var$IssueModal = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("iR43Y")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/modal-issue-app.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $59d96d961d806fee$var$IssueModalContents = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("hxSa9")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-view.tsx"
});
const $59d96d961d806fee$var$imports = {
    fullPage: ()=>$59d96d961d806fee$var$LazyIssuePage.preload(),
    embedded: ()=>$59d96d961d806fee$var$AsyncIssueAppComponent.preload(),
    pageLoad: (viewModeToPreload)=>{
        // issue view that opens as a modal
        if (viewModeToPreload === 'MODAL' || viewModeToPreload === 'DEFAULT') {
            $59d96d961d806fee$var$IssueModal.preload();
            $59d96d961d806fee$var$IssueModalContents.preload();
        }
        // issue view that opens as a side panel
        if (viewModeToPreload === 'SIDEBAR') $59d96d961d806fee$var$AsyncIssueAppComponent.preload();
    }
};

const $59d96d961d806fee$var$PrefetchCBBResourcesComponent = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("hBQJM")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/prefetch-wrm-bundle/index.tsx"
});
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
if (!false && window.SPA_STATE?.serverIssuePreload) {
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly fullPage: () => Promise<typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/spa-apps/issue/src/index")>; readonly embedded: () => Promise<...>; }'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const importSupplier = $59d96d961d806fee$var$imports[window.SPA_STATE.serverIssuePreload];
    importSupplier && importSupplier();
}
const $59d96d961d806fee$var$ISSUE_PRELOAD_COMPONENT_MARK = 'IssuePreloadComponent:rendered';
const $59d96d961d806fee$var$useParamsSelector = (0, $lODMY.createRouterSelector)((state)=>({
        query: state.query,
        params: state.match.params
    }));
const $59d96d961d806fee$var$IssuePreloadComponentBuilder = (identifier, preloadSupplier, preloadContract)=>()=>{
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { query: query, params: params } = $59d96d961d806fee$var$useParamsSelector();
        if (// If we have an undefined contract, assume we want to preload
        !preloadContract || // Preload if we match the contract
        preloadContract.some((preloadingMatch)=>// Match query with router function
            // @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.
            (!preloadingMatch.query || (0, $4sxG1.default)(preloadingMatch.query, query)) && // Match path params with simple object structure, where if value is undefined
            // we assume we match all values
            (!preloadingMatch.params || preloadingMatch.params.every(({ key: key, value: value })=>params && params[key] !== undefined && (value === undefined || params[key] === value))))) {
            if (!false) preloadSupplier();
            if (false) (0, $l7Ytp.setServerEvaluatedIssuePreload)(identifier);
            else performance.mark($59d96d961d806fee$var$ISSUE_PRELOAD_COMPONENT_MARK);
        }
        return null;
    };
const $59d96d961d806fee$var$FullPageIssuePreloadComponent = $59d96d961d806fee$var$IssuePreloadComponentBuilder('fullPage', $59d96d961d806fee$var$imports.fullPage);
$59d96d961d806fee$var$FullPageIssuePreloadComponent.displayName = 'FullPageIssuePreloadComponent';
const $59d96d961d806fee$export$98e337c40eb151da = (0, $aPfsS.createLayout)({
    globalComponents: [
        $59d96d961d806fee$var$FullPageIssuePreloadComponent,
        $59d96d961d806fee$var$PrefetchCBBResourcesComponent
    ]
});
const $59d96d961d806fee$export$7b113174a456921a = (preloadContract)=>{
    const EmbeddedIssuePreloadComponent = $59d96d961d806fee$var$IssuePreloadComponentBuilder('embedded', $59d96d961d806fee$var$imports.embedded, preloadContract);
    EmbeddedIssuePreloadComponent.displayName = 'EmbeddedIssuePreloadComponent';
    return (0, $aPfsS.createLayout)({
        globalComponents: [
            EmbeddedIssuePreloadComponent
        ]
    });
};
const $59d96d961d806fee$export$682dcbf7cc80ba11 = (preloadContract, viewModeToPreload)=>{
    const PageLoadIssuePreloadComponent = $59d96d961d806fee$var$IssuePreloadComponentBuilder('pageLoad', ()=>$59d96d961d806fee$var$imports.pageLoad(viewModeToPreload || 'DEFAULT'), preloadContract);
    PageLoadIssuePreloadComponent.displayName = 'PageLoadIssuePreloadComponent';
    return (0, $aPfsS.createLayout)({
        globalComponents: [
            PageLoadIssuePreloadComponent
        ]
    });
};

});
parcelRegister("lGGIs", function(module, exports) {

$parcel$export(module.exports, "markAsBentoBundleReady", () => $7671cdebcdce4d73$export$d9ff0b3329728986);

var $fDtbf = parcelRequire("fDtbf");

var $2SVPM = parcelRequire("2SVPM");
let $7671cdebcdce4d73$var$reportedBentoBundleReady = false;
const $7671cdebcdce4d73$export$d9ff0b3329728986 = (importedBundle)=>{
    if (!false) importedBundle.then(()=>{
        // Mutex for reporter
        if ($7671cdebcdce4d73$var$reportedBentoBundleReady) return;
        $7671cdebcdce4d73$var$reportedBentoBundleReady = true;
        (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('bento.bundle-ready', 'jira-spa.js:eval-stop');
        const resources = performance.getEntriesByType('mark');
        for(let i = resources.length - 1; i >= 0; i -= 1)if (resources[i].name.startsWith('async-issue-app') && resources[i].name.endsWith((0, $fDtbf.JS_EVAL_START))) {
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('bento.eval', resources[i].name);
            break;
        }
    });
    return importedBundle;
};

});

parcelRegister("l7Ytp", function(module, exports) {

$parcel$export(module.exports, "setServerEvaluatedIssuePreload", () => $1e750e126dd1eeef$export$d2077b3b0eac1c19);
/* eslint-disable jira/filename-case */ // We can start the evaluation at module level if we ran the component in SSR
// This needs to be an empty string because the router breaks if it's null or undefined
let $1e750e126dd1eeef$var$serverIssuePreloadIdentifier = '';
const $1e750e126dd1eeef$export$d2077b3b0eac1c19 = (identifier)=>{
    $1e750e126dd1eeef$var$serverIssuePreloadIdentifier = identifier;
};
const $1e750e126dd1eeef$export$f55e6973062dc859 = ()=>$1e750e126dd1eeef$var$serverIssuePreloadIdentifier;

});

parcelRegister("kJXED", function(module, exports) {

let $f19648b7b54db5b1$var$load = (parcelRequire("28QjX"))(4);












module.exports = Promise.all([
    (parcelRequire("avM1e"))('redaction_onboarding_iv_llc', function() {
        return Promise.all([
            $f19648b7b54db5b1$var$load("czPin")
        ]);
    }, function() {
        return Promise.all([
            $f19648b7b54db5b1$var$load("iGvP4")
        ]);
    }),
    (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-media-nodes', function() {
        return Promise.all([
            $f19648b7b54db5b1$var$load("gXEyJ"),
            $f19648b7b54db5b1$var$load("l253H"),
            $f19648b7b54db5b1$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $f19648b7b54db5b1$var$load("hy7ba")
        ]);
    }),
    (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-small-nodes', function() {
        return Promise.all([
            $f19648b7b54db5b1$var$load("d5z58"),
            $f19648b7b54db5b1$var$load("kvRbA"),
            $f19648b7b54db5b1$var$load("ffQaD"),
            $f19648b7b54db5b1$var$load("l253H"),
            $f19648b7b54db5b1$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $f19648b7b54db5b1$var$load("f771T")
        ]);
    }),
    (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-card-nodes', function() {
        return Promise.all([
            $f19648b7b54db5b1$var$load("lh7CA"),
            $f19648b7b54db5b1$var$load("kNFvF"),
            $f19648b7b54db5b1$var$load("kvRbA"),
            $f19648b7b54db5b1$var$load("ffQaD"),
            $f19648b7b54db5b1$var$load("l253H"),
            $f19648b7b54db5b1$var$load("76n7a"),
            $f19648b7b54db5b1$var$load("fliVL")
        ]);
    }, function() {
        return Promise.all([
            $f19648b7b54db5b1$var$load("jrRVX")
        ]);
    }),
    (parcelRequire("avM1e"))('jira_amplitude_sr', function() {
        return Promise.all([
            $f19648b7b54db5b1$var$load("8EtZR"),
            $f19648b7b54db5b1$var$load("kVX56")
        ]);
    }, function() {
        return Promise.all([
            $f19648b7b54db5b1$var$load("6jOz3")
        ]);
    }),
    (parcelRequire("avM1e"))('details_loader_to_entrypoint_iv_llc_dev_panel', function() {
        return Promise.all([
            $f19648b7b54db5b1$var$load("84z1X")
        ]);
    }, function() {
        return Promise.all([
            $f19648b7b54db5b1$var$load("eBkr0")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $f19648b7b54db5b1$var$load("czifk"),
            $f19648b7b54db5b1$var$load("kvRbA"),
            $f19648b7b54db5b1$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $f19648b7b54db5b1$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $f19648b7b54db5b1$var$load("cTJTG"),
            $f19648b7b54db5b1$var$load("l253H"),
            $f19648b7b54db5b1$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $f19648b7b54db5b1$var$load("4Qxp7")
        ]);
    }),
    (parcelRequire("avM1e"))('fix_versions_component_perf_improvement_vc90', function() {
        return Promise.all([
            $f19648b7b54db5b1$var$load("6TXdv")
        ]);
    }, function() {
        return Promise.all([
            $f19648b7b54db5b1$var$load("4t8fr")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $f19648b7b54db5b1$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $f19648b7b54db5b1$var$load("7B2gt")
        ]);
    }),
    (parcelRequire("avM1e"))('improve_issue_view_comment_ai', function() {
        return Promise.all([
            $f19648b7b54db5b1$var$load("egvYO")
        ]);
    }, function() {
        return Promise.all([
            $f19648b7b54db5b1$var$load("hkt2G")
        ]);
    }),
    (parcelRequire("avM1e"))('link_paste_recommendations', function() {
        return Promise.all([]);
    }, function() {
        return Promise.all([
            $f19648b7b54db5b1$var$load("7ClEP")
        ]);
    }),
    $f19648b7b54db5b1$var$load("7mIf9"),
    $f19648b7b54db5b1$var$load("jXweD"),
    $f19648b7b54db5b1$var$load("kVX56"),
    $f19648b7b54db5b1$var$load("ffQaD"),
    $f19648b7b54db5b1$var$load("kvRbA"),
    $f19648b7b54db5b1$var$load("3yAl4"),
    $f19648b7b54db5b1$var$load("fliVL"),
    $f19648b7b54db5b1$var$load("76n7a"),
    $f19648b7b54db5b1$var$load("l253H"),
    $f19648b7b54db5b1$var$load("jbxE1"),
    $f19648b7b54db5b1$var$load("7imUH"),
    $f19648b7b54db5b1$var$load("kNFvF"),
    $f19648b7b54db5b1$var$load("70aLb")
]).then(()=>parcelRequire('kW74N'));

});

parcelRegister("eLfPy", function(module, exports) {

let $abf1bc1c927c8c99$var$load = (parcelRequire("28QjX"))(4);












module.exports = Promise.all([
    (parcelRequire("avM1e"))('redaction_onboarding_iv_llc', function() {
        return Promise.all([
            $abf1bc1c927c8c99$var$load("czPin")
        ]);
    }, function() {
        return Promise.all([
            $abf1bc1c927c8c99$var$load("iGvP4")
        ]);
    }),
    (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-media-nodes', function() {
        return Promise.all([
            $abf1bc1c927c8c99$var$load("gXEyJ"),
            $abf1bc1c927c8c99$var$load("l253H"),
            $abf1bc1c927c8c99$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $abf1bc1c927c8c99$var$load("hy7ba")
        ]);
    }),
    (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-small-nodes', function() {
        return Promise.all([
            $abf1bc1c927c8c99$var$load("d5z58"),
            $abf1bc1c927c8c99$var$load("kvRbA"),
            $abf1bc1c927c8c99$var$load("ffQaD"),
            $abf1bc1c927c8c99$var$load("l253H"),
            $abf1bc1c927c8c99$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $abf1bc1c927c8c99$var$load("f771T")
        ]);
    }),
    (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-card-nodes', function() {
        return Promise.all([
            $abf1bc1c927c8c99$var$load("lh7CA"),
            $abf1bc1c927c8c99$var$load("kNFvF"),
            $abf1bc1c927c8c99$var$load("kvRbA"),
            $abf1bc1c927c8c99$var$load("ffQaD"),
            $abf1bc1c927c8c99$var$load("l253H"),
            $abf1bc1c927c8c99$var$load("76n7a"),
            $abf1bc1c927c8c99$var$load("fliVL")
        ]);
    }, function() {
        return Promise.all([
            $abf1bc1c927c8c99$var$load("jrRVX")
        ]);
    }),
    (parcelRequire("avM1e"))('jira_amplitude_sr', function() {
        return Promise.all([
            $abf1bc1c927c8c99$var$load("8EtZR"),
            $abf1bc1c927c8c99$var$load("kVX56")
        ]);
    }, function() {
        return Promise.all([
            $abf1bc1c927c8c99$var$load("6jOz3")
        ]);
    }),
    (parcelRequire("avM1e"))('details_loader_to_entrypoint_iv_llc_dev_panel', function() {
        return Promise.all([
            $abf1bc1c927c8c99$var$load("84z1X")
        ]);
    }, function() {
        return Promise.all([
            $abf1bc1c927c8c99$var$load("eBkr0")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $abf1bc1c927c8c99$var$load("czifk"),
            $abf1bc1c927c8c99$var$load("kvRbA"),
            $abf1bc1c927c8c99$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $abf1bc1c927c8c99$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $abf1bc1c927c8c99$var$load("cTJTG"),
            $abf1bc1c927c8c99$var$load("l253H"),
            $abf1bc1c927c8c99$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $abf1bc1c927c8c99$var$load("4Qxp7")
        ]);
    }),
    (parcelRequire("avM1e"))('fix_versions_component_perf_improvement_vc90', function() {
        return Promise.all([
            $abf1bc1c927c8c99$var$load("6TXdv")
        ]);
    }, function() {
        return Promise.all([
            $abf1bc1c927c8c99$var$load("4t8fr")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $abf1bc1c927c8c99$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $abf1bc1c927c8c99$var$load("7B2gt")
        ]);
    }),
    (parcelRequire("avM1e"))('improve_issue_view_comment_ai', function() {
        return Promise.all([
            $abf1bc1c927c8c99$var$load("egvYO")
        ]);
    }, function() {
        return Promise.all([
            $abf1bc1c927c8c99$var$load("hkt2G")
        ]);
    }),
    (parcelRequire("avM1e"))('link_paste_recommendations', function() {
        return Promise.all([]);
    }, function() {
        return Promise.all([
            $abf1bc1c927c8c99$var$load("7ClEP")
        ]);
    }),
    $abf1bc1c927c8c99$var$load("3yAl4"),
    $abf1bc1c927c8c99$var$load("fliVL"),
    $abf1bc1c927c8c99$var$load("7mIf9"),
    $abf1bc1c927c8c99$var$load("jXweD"),
    $abf1bc1c927c8c99$var$load("jbxE1"),
    $abf1bc1c927c8c99$var$load("7imUH"),
    $abf1bc1c927c8c99$var$load("ffQaD"),
    $abf1bc1c927c8c99$var$load("kvRbA"),
    $abf1bc1c927c8c99$var$load("kVX56"),
    $abf1bc1c927c8c99$var$load("kNFvF"),
    $abf1bc1c927c8c99$var$load("76n7a"),
    $abf1bc1c927c8c99$var$load("l253H"),
    $abf1bc1c927c8c99$var$load("gaip1")
]).then(()=>parcelRequire('6qbjz'));

});

parcelRegister("iR43Y", function(module, exports) {

let $dba054175427c680$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $dba054175427c680$var$load("ffQaD"),
    $dba054175427c680$var$load("kvRbA"),
    $dba054175427c680$var$load("kNFvF"),
    $dba054175427c680$var$load("bWP0X")
]).then(()=>parcelRequire('2555l'));

});

parcelRegister("hxSa9", function(module, exports) {

let $cc5f8855c058c7e5$var$load = (parcelRequire("28QjX"))(4);












module.exports = Promise.all([
    (parcelRequire("avM1e"))('redaction_onboarding_iv_llc', function() {
        return Promise.all([
            $cc5f8855c058c7e5$var$load("czPin")
        ]);
    }, function() {
        return Promise.all([
            $cc5f8855c058c7e5$var$load("iGvP4")
        ]);
    }),
    (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-media-nodes', function() {
        return Promise.all([
            $cc5f8855c058c7e5$var$load("gXEyJ"),
            $cc5f8855c058c7e5$var$load("l253H"),
            $cc5f8855c058c7e5$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $cc5f8855c058c7e5$var$load("hy7ba")
        ]);
    }),
    (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-small-nodes', function() {
        return Promise.all([
            $cc5f8855c058c7e5$var$load("d5z58"),
            $cc5f8855c058c7e5$var$load("kvRbA"),
            $cc5f8855c058c7e5$var$load("ffQaD"),
            $cc5f8855c058c7e5$var$load("l253H"),
            $cc5f8855c058c7e5$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $cc5f8855c058c7e5$var$load("f771T")
        ]);
    }),
    (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-card-nodes', function() {
        return Promise.all([
            $cc5f8855c058c7e5$var$load("lh7CA"),
            $cc5f8855c058c7e5$var$load("kNFvF"),
            $cc5f8855c058c7e5$var$load("kvRbA"),
            $cc5f8855c058c7e5$var$load("ffQaD"),
            $cc5f8855c058c7e5$var$load("l253H"),
            $cc5f8855c058c7e5$var$load("76n7a"),
            $cc5f8855c058c7e5$var$load("fliVL")
        ]);
    }, function() {
        return Promise.all([
            $cc5f8855c058c7e5$var$load("jrRVX")
        ]);
    }),
    (parcelRequire("avM1e"))('jira_amplitude_sr', function() {
        return Promise.all([
            $cc5f8855c058c7e5$var$load("8EtZR"),
            $cc5f8855c058c7e5$var$load("kVX56")
        ]);
    }, function() {
        return Promise.all([
            $cc5f8855c058c7e5$var$load("6jOz3")
        ]);
    }),
    (parcelRequire("avM1e"))('details_loader_to_entrypoint_iv_llc_dev_panel', function() {
        return Promise.all([
            $cc5f8855c058c7e5$var$load("84z1X")
        ]);
    }, function() {
        return Promise.all([
            $cc5f8855c058c7e5$var$load("eBkr0")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $cc5f8855c058c7e5$var$load("czifk"),
            $cc5f8855c058c7e5$var$load("kvRbA"),
            $cc5f8855c058c7e5$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $cc5f8855c058c7e5$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $cc5f8855c058c7e5$var$load("cTJTG"),
            $cc5f8855c058c7e5$var$load("l253H"),
            $cc5f8855c058c7e5$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $cc5f8855c058c7e5$var$load("4Qxp7")
        ]);
    }),
    (parcelRequire("avM1e"))('fix_versions_component_perf_improvement_vc90', function() {
        return Promise.all([
            $cc5f8855c058c7e5$var$load("6TXdv")
        ]);
    }, function() {
        return Promise.all([
            $cc5f8855c058c7e5$var$load("4t8fr")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $cc5f8855c058c7e5$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $cc5f8855c058c7e5$var$load("7B2gt")
        ]);
    }),
    (parcelRequire("avM1e"))('improve_issue_view_comment_ai', function() {
        return Promise.all([
            $cc5f8855c058c7e5$var$load("egvYO")
        ]);
    }, function() {
        return Promise.all([
            $cc5f8855c058c7e5$var$load("hkt2G")
        ]);
    }),
    (parcelRequire("avM1e"))('link_paste_recommendations', function() {
        return Promise.all([]);
    }, function() {
        return Promise.all([
            $cc5f8855c058c7e5$var$load("7ClEP")
        ]);
    }),
    $cc5f8855c058c7e5$var$load("3yAl4"),
    $cc5f8855c058c7e5$var$load("fliVL"),
    $cc5f8855c058c7e5$var$load("7mIf9"),
    $cc5f8855c058c7e5$var$load("jXweD"),
    $cc5f8855c058c7e5$var$load("jbxE1"),
    $cc5f8855c058c7e5$var$load("7imUH"),
    $cc5f8855c058c7e5$var$load("kNFvF"),
    $cc5f8855c058c7e5$var$load("kVX56"),
    $cc5f8855c058c7e5$var$load("ffQaD"),
    $cc5f8855c058c7e5$var$load("kvRbA"),
    $cc5f8855c058c7e5$var$load("76n7a"),
    $cc5f8855c058c7e5$var$load("l253H"),
    $cc5f8855c058c7e5$var$load("l3N0m")
]).then(()=>parcelRequire('kMGHs'));

});

parcelRegister("hBQJM", function(module, exports) {

let $cd1eccf09b15948b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cd1eccf09b15948b$var$load("kcnqS").then(()=>parcelRequire('4n6tJ'));

});


parcelRegister("g8BTw", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessBoardRoute", () => $66846ddeea123664$export$14a5cbbd7e1e2dc2);
const $66846ddeea123664$export$14a5cbbd7e1e2dc2 = {
    name: 'classic-business-board',
    exact: true,
    path: '/jira/core/projects/:projectKey/board/:itemId?'
};

});

parcelRegister("gkbjZ", function(module, exports) {

$parcel$export(module.exports, "boardPageEntryPoint", () => $39c257a891cf9743$export$552f44bed039f041);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $7AGbN = parcelRequire("7AGbN");

var $fo6b8 = parcelRequire("fo6b8");
const $39c257a891cf9743$export$552f44bed039f041 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7AGbN.boardEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("7AGbN", function(module, exports) {

$parcel$export(module.exports, "boardEntryPoint", () => $a4aaf8c5264c4217$export$937ca5a4cdc1a12e);

var $lzufP = parcelRequire("lzufP");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $a4aaf8c5264c4217$export$937ca5a4cdc1a12e = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("c0LIk")), {
        moduleId: "8dcbcc62"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        const itemId = context.match.params.itemId ?? '';
        let filterJql = context.query?.filter;
        let groupBy = context.query?.groupBy;
        // if in a client environment, check whether the router url matches the current window pathname
        // if it does, use the filter and groupBy from the current window location instead of the router query
        // this avoids reloading the query without the overrides when a user hovers over prefetching links that don't include them
        if (typeof window !== 'undefined' && window.location.pathname === context.match.url) {
            const searchParams = new URLSearchParams(window.location.search);
            filterJql = searchParams.get('filter') ?? undefined;
            groupBy = searchParams.get('groupBy') ?? undefined;
        }
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                boardQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $lzufP.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey,
                        viewInput: {
                            jiraBoardViewQueryInput: {
                                projectKeyAndItemIdQuery: {
                                    cloudId: cloudId,
                                    projectKey: projectKey,
                                    itemId: itemId
                                }
                            },
                            settings: {
                                filterJql: filterJql,
                                groupBy: groupBy
                            }
                        }
                    }
                }
            }
        };
    }
});

});
parcelRegister("lzufP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e141afb773c5347$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d7dde042e8a042d4425ee817bed26efa>>
 * @relayHash 3946f2544ab585a4307b70dfae47fe22
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 449c8bd979f750c2e2f2235841cc3c2ec926e971171f24ac5316bfec6f32bbfe

var $3K6QB = parcelRequire("3K6QB");

var $apYuT = parcelRequire("apYuT");
const $5e141afb773c5347$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "449c8bd979f750c2e2f2235841cc3c2ec926e971171f24ac5316bfec6f32bbfe",
        "metadata": {},
        "name": "src_jiraBusinessBoardQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcallowstatusmappingonbusinessboardrelayprovider": (0, $3K6QB.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider": (0, $apYuT.default)
        }
    }
};
var $5e141afb773c5347$export$2e2bcd8739ae039 = $5e141afb773c5347$var$node;

});

parcelRegister("c0LIk", function(module, exports) {

let $8bea7f1e501feaf4$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $8bea7f1e501feaf4$var$load("ffQaD"),
    $8bea7f1e501feaf4$var$load("kvRbA"),
    $8bea7f1e501feaf4$var$load("fliVL"),
    $8bea7f1e501feaf4$var$load("4jU2d")
]).then(()=>parcelRequire('ac4Ca'));

});




parcelRegister("21AP4", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessCalendarEmbedRouteEntry", () => $600d33daee8526e1$export$d75a7b48d8838f92);

var $6e4Kt = parcelRequire("6e4Kt");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $d5vH1 = parcelRequire("d5vH1");

var $lkFvK = parcelRequire("lkFvK");

var $4wa6C = parcelRequire("4wa6C");
const $600d33daee8526e1$var$calendarEmbedPageEntrypoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $4wa6C.calendarEntryPoint)
});
const $600d33daee8526e1$export$d75a7b48d8838f92 = (0, $7NszV.createEntry)((0, $d5vH1.jiraBusinessCalendarEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.calendar-embed-view',
        entryPoint () {
            return $600d33daee8526e1$var$calendarEmbedPageEntrypoint;
        },
        layout: (0, $6e4Kt.chromelessLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        resources: (0, $lNicp.getProjectViewResources)()
    }));

});
parcelRegister("d5vH1", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessCalendarEmbedRoute", () => $085faca8e3760e1d$export$71a801c267234959);
const $085faca8e3760e1d$export$71a801c267234959 = {
    name: 'classic-business-calendar-embed',
    path: '/jira/core/projects/:projectKey/calendar/embed',
    exact: true
};

});

parcelRegister("4wa6C", function(module, exports) {

$parcel$export(module.exports, "calendarEntryPoint", () => $38193f9d05bd632a$export$19cf4b398f638dc6);

var $4R6GH = parcelRequire("4R6GH");

var $8s8gU = parcelRequire("8s8gU");

var $7JhZX = parcelRequire("7JhZX");

var $6s1PB = parcelRequire("6s1PB");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");
const $38193f9d05bd632a$var$SETTINGS_STORAGE_KEY = 'calendar:settings:business';
function $38193f9d05bd632a$var$getViewSettings(key) {
    try {
        const serializedValue = globalThis.localStorage?.getItem(key);
        return serializedValue !== null ? JSON.parse(serializedValue) : undefined;
    } catch  {
        return undefined;
    }
}
const $38193f9d05bd632a$var$and = (clauses)=>{
    return clauses.map((clause)=>clause.trim()).filter((clause)=>clause.length > 0).join(' AND ');
};
function $38193f9d05bd632a$var$toMidnightUTCString(date) {
    const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return new Date(utcMilliseconds).toISOString();
}
function $38193f9d05bd632a$var$toDate(date) {
    if (!date) return new Date();
    try {
        const _date = new Date(date);
        return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
    } catch (e) {
        return new Date();
    }
}
function $38193f9d05bd632a$var$createScope({ context: context }) {
    return {
        type: 'project',
        projectKeys: [
            String(context.match.params.projectKey)
        ]
    };
}
function $38193f9d05bd632a$var$buildScopeInput({ tenantContext: tenantContext }, scope) {
    const { cloudId: cloudId } = tenantContext;
    return {
        projectKeys: {
            cloudId: cloudId,
            keys: scope.projectKeys
        }
    };
}
function $38193f9d05bd632a$var$toViewMode(mode) {
    switch(mode){
        case 'week':
            return 'WEEK';
        case 'day':
            return 'DAY';
        default:
            return 'MONTH';
    }
}
function $38193f9d05bd632a$var$toWeekStart(weekStart) {
    switch(weekStart){
        case 'monday':
            return 'MONDAY';
        case 'saturday':
            return 'SATURDAY';
        default:
            return 'SUNDAY';
    }
}
function $38193f9d05bd632a$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField }) {
    return {
        date: $38193f9d05bd632a$var$toMidnightUTCString(selectedDate),
        mode: $38193f9d05bd632a$var$toViewMode(viewRange),
        weekStart: $38193f9d05bd632a$var$toWeekStart(weekStartsOn),
        startDateField: startDateField,
        endDateField: endDateField,
        viewId: null
    };
}
/** Extracted from business/shared/simpleSearch */ function $38193f9d05bd632a$var$jqlSearchText(text) {
    if (text === undefined || text.trim() === '') return '';
    const sanitize = (value)=>value.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/\t/g, ' ');
    const ISSUEKEY_REGEX = '([A-Z][A-Z0-9_]+-\\d+)';
    const issueKeyRegex = new RegExp(`^${ISSUEKEY_REGEX}$`);
    const japaneseAndChineseRegex = /[\p{Script_Extensions=Hiragana}\p{Script_Extensions=Katakana}\p{Script_Extensions=Han}]/u;
    let search = sanitize(text);
    if (issueKeyRegex.test(text)) return `(summary ~ '${search}*' OR description ~ '${search}*' OR key = '${search}')`;
    // if the text does not contain Chinese or Japanese characters (which are not tokenized),
    // and does not end with a space character
    // make it a wildcard search
    if (!japaneseAndChineseRegex.test(text) && !text.endsWith(' ')) search = `${search}*`;
    return `(summary ~ '${search}' OR description ~ '${search}')`;
}
function $38193f9d05bd632a$var$buildIssuesSearchInput(filter = '', text = '', hideDoneItems) {
    if (!(0, $4R6GH.fg)('jira_calendar_load_more_pagination')) return {
        additionalFilterQuery: ''
    };
    const hideDoneItemsQuery = "StatusCategory != 'Complete'";
    const search = $38193f9d05bd632a$var$jqlSearchText(text);
    return {
        additionalFilterQuery: $38193f9d05bd632a$var$and([
            search,
            filter,
            ...hideDoneItems ? [
                hideDoneItemsQuery
            ] : []
        ])
    };
}
function $38193f9d05bd632a$var$buildUnscheduledIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}

const $38193f9d05bd632a$export$19cf4b398f638dc6 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("Qsp1w")), {
        moduleId: "70b39bf1"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        const { cloudId: cloudId } = tenantContext;
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        const scope = $38193f9d05bd632a$var$createScope(entryPointRouteParams);
        const { date: date, filter: filter, hideDone: hideDone, text: text } = context.query;
        const selectedDate = $38193f9d05bd632a$var$toDate(date);
        const settings = (0, $4R6GH.fg)('jira_calendar_load_more_pagination') ? $38193f9d05bd632a$var$getViewSettings($38193f9d05bd632a$var$SETTINGS_STORAGE_KEY) : undefined;
        const viewRange = 'month';
        const hideDoneItems = hideDone && (0, $4R6GH.fg)('calendar-hide-done-query-param') ? true : settings?.hideDoneItems ?? false;
        const weekStartsOn = (0, $4R6GH.fg)('jira_calendar_load_more_pagination') ? settings?.weekStartsOn ?? 'sunday' : 'sunday';
        const startDateField = 'startdate';
        const endDateField = 'duedate';
        const issueEventFields = {
            startDateField: startDateField,
            endDateField: endDateField
        };
        return {
            queries: {
                calendarQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $8s8gU.default),
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                calendarData: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $7JhZX.default),
                    variables: {
                        cloudId: cloudId,
                        scopeInput: $38193f9d05bd632a$var$buildScopeInput(entryPointRouteParams, scope),
                        configurationInput: $38193f9d05bd632a$var$buildConfigurationInput({
                            selectedDate: selectedDate,
                            viewRange: viewRange,
                            weekStartsOn: weekStartsOn,
                            startDateField: startDateField,
                            endDateField: endDateField
                        }),
                        issuesPageSize: (0, $4R6GH.fg)('jira_calendar_lazy_load') ? 200 : 50,
                        issuesSearchInput: $38193f9d05bd632a$var$buildIssuesSearchInput(filter, text, hideDoneItems),
                        unscheduledIssuesSearchInput: $38193f9d05bd632a$var$buildUnscheduledIssuesSearchInput(),
                        versionsSearchInput: {
                            versionStatuses: [
                                'RELEASED',
                                'UNRELEASED'
                            ],
                            includeSharedReleases: true
                        },
                        sprintsSearchInput: null,
                        skipSprintSearch: true,
                        viewId: null,
                        schedulePermissionsEnabled: (0, $4R6GH.fg)('calendar_schedule_issue_permissions_check'),
                        pageLoadMoreEnabled: (0, $4R6GH.fg)('jira_calendar_load_more_pagination'),
                        skipVersionsV1Search: (0, $4R6GH.fg)('plan-calendar-versions-v2-adoption'),
                        skipVersionsV2Search: !(0, $4R6GH.fg)('plan-calendar-versions-v2-adoption'),
                        includeRecurrenceIndicator: (0, $6s1PB.expValEquals)('jira-recur-single-work-item-on-schedule', 'isRecurrenceCalendarViewEnabled', true),
                        pageLoadMoreEnabledViewSettings: (0, $4R6GH.fg)('jira_calendar_load_more_pagination_view_settings')
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                scope: scope,
                selectedDate: selectedDate,
                viewRange: viewRange,
                weekStartsOn: weekStartsOn,
                issueEventFields: issueEventFields,
                hasRecurrenceItemIndicator: (0, $6s1PB.expValEquals)('jira-recur-single-work-item-on-schedule', 'isRecurrenceCalendarViewEnabled', true)
            }
        };
    }
});

});
parcelRegister("8s8gU", function(module, exports) {

$parcel$export(module.exports, "default", () => $04b6b433e450264c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<620394e61554de6b4de7fc13153ce658>>
 * @relayHash e7f526a757abd5ec137c62e6d5d37fb3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 23ff8ebcf7d113448b039ee2b0b9d7d1d70d6a6af70115838ee65796d163a423
const $04b6b433e450264c$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "23ff8ebcf7d113448b039ee2b0b9d7d1d70d6a6af70115838ee65796d163a423",
        "metadata": {},
        "name": "src_jiraBusinessSharedCalendarQuery",
        "operationKind": "query",
        "text": null
    }
};
var $04b6b433e450264c$export$2e2bcd8739ae039 = $04b6b433e450264c$var$node;

});

parcelRegister("Qsp1w", function(module, exports) {

let $09dae39c06e24b27$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $09dae39c06e24b27$var$load("ffQaD"),
    $09dae39c06e24b27$var$load("kvRbA"),
    $09dae39c06e24b27$var$load("76n7a"),
    $09dae39c06e24b27$var$load("l253H"),
    $09dae39c06e24b27$var$load("9BiZd")
]).then(()=>parcelRequire('jJF0P'));

});



parcelRegister("infHq", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessCalendarRouteEntry", () => $2bf1458ced078f1f$export$b8f4785659c5349e);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $aMqk7 = parcelRequire("aMqk7");

var $lkFvK = parcelRequire("lkFvK");

var $4wa6C = parcelRequire("4wa6C");

var $fo6b8 = parcelRequire("fo6b8");
const $2bf1458ced078f1f$var$calendarPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $4wa6C.calendarEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $2bf1458ced078f1f$export$b8f4785659c5349e = (0, $7NszV.createEntry)((0, $aMqk7.jiraBusinessCalendarRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.calendar-view',
        entryPoint () {
            return $2bf1458ced078f1f$var$calendarPageEntrypoint;
        },
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)()
    }));

});
parcelRegister("aMqk7", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessCalendarRoute", () => $4cb3bab25d5027cf$export$3f1924073260dde6);
const $4cb3bab25d5027cf$export$3f1924073260dde6 = {
    name: 'classic-business-calendar',
    path: '/jira/core/projects/:projectKey/calendar',
    exact: true
};

});


parcelRegister("ilKWG", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessReportsOverviewRouteEntry", () => $c06ed3cb1d5f7aff$export$2cde310731fa9055);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $6e5qs = parcelRequire("6e5qs");

var $lkFvK = parcelRequire("lkFvK");

var $fo6b8 = parcelRequire("fo6b8");

var $fh5Sl = parcelRequire("fh5Sl");
const $c06ed3cb1d5f7aff$var$reportsOverviewPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $fh5Sl.reportsOverviewPageEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $c06ed3cb1d5f7aff$export$2cde310731fa9055 = (0, $7NszV.createEntry)((0, $6e5qs.jiraBusinessReportsOverviewRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.reports-overview',
        entryPoint () {
            return $c06ed3cb1d5f7aff$var$reportsOverviewPageEntryPoint;
        },
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)()
    }));

});
parcelRegister("6e5qs", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessReportsOverviewRoute", () => $4545a709b63712be$export$5881ca008f82b9d8);
const $4545a709b63712be$export$5881ca008f82b9d8 = {
    name: 'classic-business-reports-overview',
    path: '/jira/core/projects/:projectKey/reports',
    exact: true
};

});

parcelRegister("fh5Sl", function(module, exports) {

$parcel$export(module.exports, "reportsOverviewPageEntryPoint", () => $cb9d07f6a92b0ec7$export$9dfa968d9e20b359);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $6hHfS = parcelRequire("6hHfS");

const $cb9d07f6a92b0ec7$export$9dfa968d9e20b359 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("gbxdX")).then((mod)=>mod.ReportsOverviewPage), {
        moduleId: "b8514977"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const boardId = context.match.params.boardId ? String(context.match.params.boardId) : null;
        const projectKey = context.match.params.projectKey ? String(context.match.params.projectKey) : null;
        const isBoardContext = !!boardId;
        const isProjectContext = !!projectKey;
        const cloudId = tenantContext.cloudId;
        return {
            queries: {
                reportsOverviewPage: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $6hHfS.default,
                    variables: {
                        boardId: isBoardContext ? `ari:cloud:jira-software:${cloudId}:board/${boardId}` : '',
                        projectKey: !isBoardContext && isProjectContext ? projectKey : '',
                        cloudId: cloudId,
                        isBoardContext: isBoardContext
                    }
                }
            }
        };
    }
});

});
parcelRegister("6hHfS", function(module, exports) {

$parcel$export(module.exports, "default", () => $868a790b54436928$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d07eb7632c7c8519e83224e9ac018576>>
 * @relayHash 497df43b1252a8dc0b4f0ec9cd482e92
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fa621fa4bb6543d468797211342e1086ef2a6b35d10869637d74ad38c4e9685b
const $868a790b54436928$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isBoardContext"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "idOrKey",
            "variableName": "projectKey"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "concreteType": "JiraReportCategoryConnection",
        "kind": "LinkedField",
        "name": "reportCategories",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraReportCategoryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraReportCategoryNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v6 /*: any*/ ,
                            {
                                "concreteType": "JiraReportConnection",
                                "kind": "LinkedField",
                                "name": "reports",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraReportConnectionEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraReport",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v7 /*: any*/ ,
                                                    v6 /*: any*/ ,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "key"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "imageUrl"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "description"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "url"
                                                    },
                                                    v8 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            v8 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "srcReportsOverviewPageQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "reportCategories_reportsOverviewPage"
                },
                {
                    "condition": "isBoardContext",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v4 /*: any*/ ,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jira_projectByIdOrKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": v5 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "jira_projectByIdOrKey.projectType"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira_projectByIdOrKey"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "srcReportsOverviewPageQuery",
            "selections": [
                {
                    "condition": "isBoardContext",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jira_projectByIdOrKey",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v8 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "condition": "isBoardContext",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "boardId"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "jiraBoard",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v9 /*: any*/ 
                                            ],
                                            "type": "JiraBoard"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v8 /*: any*/ 
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fa621fa4bb6543d468797211342e1086ef2a6b35d10869637d74ad38c4e9685b",
            "metadata": {},
            "name": "srcReportsOverviewPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$868a790b54436928$var$node.hash = "48e488c0e3939efa5d53df92fe5fb373";
var $868a790b54436928$export$2e2bcd8739ae039 = $868a790b54436928$var$node;

});

parcelRegister("gbxdX", function(module, exports) {

let $bc8772047788bbd7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bc8772047788bbd7$var$load("3VKXz").then(()=>parcelRequire('b8Z4e'));

});



parcelRegister("dUuHj", function(module, exports) {

$parcel$export(module.exports, "classicBusinessOverviewCalendarRouteEntry", () => $8bbf45fcd3a87ffb$export$93f05037a457ce22);

var $l71WK = parcelRequire("l71WK");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $8bcrt = parcelRequire("8bcrt");

var $lkFvK = parcelRequire("lkFvK");

var $4tESa = parcelRequire("4tESa");
const $8bbf45fcd3a87ffb$var$overviewCalendarPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $4tESa.overviewCalendarEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $8bbf45fcd3a87ffb$export$93f05037a457ce22 = (0, $7NszV.createEntry)((0, $8bcrt.classicBusinessOverviewCalendarRoute), ()=>({
        group: 'classic-business',
        layout: (0, $2BrOV.globalLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $l71WK.AsyncHorizontalOverviewNav)
        },
        resources: (0, $lNicp.getOverviewViewResources)(),
        entryPoint: ()=>$8bbf45fcd3a87ffb$var$overviewCalendarPageEntrypoint
    }));

});
parcelRegister("8bcrt", function(module, exports) {

$parcel$export(module.exports, "classicBusinessOverviewCalendarRoute", () => $c0fa680257c9f3d1$export$61383e5418d2ffe3);
const $c0fa680257c9f3d1$export$61383e5418d2ffe3 = {
    name: 'classic-business-overview-calendar',
    path: '/jira/core/overviews/:overviewId/calendar',
    exact: true
};

});

parcelRegister("4tESa", function(module, exports) {

$parcel$export(module.exports, "overviewCalendarEntrypoint", () => $9344d5422559b8bf$export$b7094a9bdb66fbad);

var $2OZhN = parcelRequire("2OZhN");

var $dnOYu = parcelRequire("dnOYu");

var $fEDBv = parcelRequire("fEDBv");

const $9344d5422559b8bf$export$b7094a9bdb66fbad = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("3Aem8")), {
        moduleId: "a9cf6a8e"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId } })=>{
        return {
            queries: {
                overviewCalendarQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $dnOYu.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        };
    }
});

});
parcelRegister("dnOYu", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a44115091e7f597$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e514564c1688822aea8c6efba8699694>>
 * @relayHash 466f1e55c408e59be27b44b8156f9147
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 82d517df2c5a9cef088b63278282f98c94356907ff3ba4c909173bfd3d9477f7
const $7a44115091e7f597$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "82d517df2c5a9cef088b63278282f98c94356907ff3ba4c909173bfd3d9477f7",
        "metadata": {},
        "name": "src_jiraBusinessOverviewCalendarQuery",
        "operationKind": "query",
        "text": null
    }
};
var $7a44115091e7f597$export$2e2bcd8739ae039 = $7a44115091e7f597$var$node;

});

parcelRegister("3Aem8", function(module, exports) {

let $29bfdeb7ef8c97a3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $29bfdeb7ef8c97a3$var$load("ffQaD"),
    $29bfdeb7ef8c97a3$var$load("kvRbA"),
    $29bfdeb7ef8c97a3$var$load("76n7a"),
    $29bfdeb7ef8c97a3$var$load("l253H"),
    $29bfdeb7ef8c97a3$var$load("2qAni")
]).then(()=>parcelRequire('UcTEy'));

});



parcelRegister("eiK9n", function(module, exports) {

$parcel$export(module.exports, "classicBusinessOverviewSummaryRouteEntry", () => $e86d6c5f1551d7af$export$f8fd32e123428b9a);

var $l71WK = parcelRequire("l71WK");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $a8LXv = parcelRequire("a8LXv");

var $lkFvK = parcelRequire("lkFvK");

var $eQQpY = parcelRequire("eQQpY");
const $e86d6c5f1551d7af$var$overviewSummaryPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $eQQpY.overviewSummaryEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $e86d6c5f1551d7af$export$f8fd32e123428b9a = (0, $7NszV.createEntry)((0, $a8LXv.classicBusinessOverviewSummaryRoute), ()=>({
        group: 'classic-business',
        layout: (0, $2BrOV.globalLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $l71WK.AsyncHorizontalOverviewNav)
        },
        resources: (0, $lNicp.getOverviewViewResources)(),
        entryPoint: ()=>$e86d6c5f1551d7af$var$overviewSummaryPageEntrypoint
    }));

});
parcelRegister("a8LXv", function(module, exports) {

$parcel$export(module.exports, "classicBusinessOverviewSummaryRoute", () => $64a453e593a46414$export$4a86e6b12ce49af9);
const $64a453e593a46414$export$4a86e6b12ce49af9 = {
    name: 'classic-business-overview-summary',
    path: '/jira/core/overviews/:overviewId/summary',
    exact: true
};

});

parcelRegister("eQQpY", function(module, exports) {

$parcel$export(module.exports, "overviewSummaryEntrypoint", () => $d80730b6496fafc5$export$3793bbcc33b62692);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $d80730b6496fafc5$export$3793bbcc33b62692 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("9Z1NC")), {
        moduleId: "5d9f07b1"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9Z1NC", function(module, exports) {

let $744b34db6938105d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $744b34db6938105d$var$load("ffQaD"),
    $744b34db6938105d$var$load("kvRbA"),
    $744b34db6938105d$var$load("hxiOL")
]).then(()=>parcelRequire('6QJpB'));

});



parcelRegister("4KinX", function(module, exports) {

$parcel$export(module.exports, "classicBusinessOverviewTimelineRouteEntry", () => $068b485441948b61$export$9d9d562e489097b3);

var $l71WK = parcelRequire("l71WK");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $8s9V5 = parcelRequire("8s9V5");

var $lkFvK = parcelRequire("lkFvK");

var $bB7nn = parcelRequire("bB7nn");
const $068b485441948b61$var$overviewTimelinePageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $bB7nn.overviewTimelineEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $068b485441948b61$export$9d9d562e489097b3 = (0, $7NszV.createEntry)((0, $8s9V5.classicBusinessOverviewTimelineRoute), ()=>({
        group: 'classic-business',
        layout: (0, $2BrOV.globalLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $l71WK.AsyncHorizontalOverviewNav)
        },
        resources: (0, $lNicp.getOverviewViewResources)(),
        entryPoint: ()=>$068b485441948b61$var$overviewTimelinePageEntrypoint
    }));

});
parcelRegister("8s9V5", function(module, exports) {

$parcel$export(module.exports, "classicBusinessOverviewTimelineRoute", () => $2de2a62458dcdd8a$export$13f0c823ff3059c2);
const $2de2a62458dcdd8a$export$13f0c823ff3059c2 = {
    name: 'classic-business-overview-timeline',
    path: '/jira/core/overviews/:overviewId/timeline',
    exact: true
};

});

parcelRegister("bB7nn", function(module, exports) {

$parcel$export(module.exports, "overviewTimelineEntrypoint", () => $41c8e0eb43e05110$export$d00505893f9d5d11);

var $2OZhN = parcelRequire("2OZhN");

var $gfPQt = parcelRequire("gfPQt");

var $fEDBv = parcelRequire("fEDBv");

const $41c8e0eb43e05110$export$d00505893f9d5d11 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("7bTJJ")), {
        moduleId: "ae6650bb"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId } })=>{
        return {
            queries: {
                overviewTimelineQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $gfPQt.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        };
    }
});

});
parcelRegister("gfPQt", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a8e66778cabfaa5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eb4ae6aae065c938f532a846255332dc>>
 * @relayHash 007933a1073bb512097f0e95cf95622d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 554086782541cb72a7484650860ffea7ea940346b5eb77793d5681f9e287d807
const $0a8e66778cabfaa5$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "554086782541cb72a7484650860ffea7ea940346b5eb77793d5681f9e287d807",
        "metadata": {},
        "name": "src_jiraBusinessOverviewTimelineQuery",
        "operationKind": "query",
        "text": null
    }
};
var $0a8e66778cabfaa5$export$2e2bcd8739ae039 = $0a8e66778cabfaa5$var$node;

});

parcelRegister("7bTJJ", function(module, exports) {

let $53c4cb998bd718c1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $53c4cb998bd718c1$var$load("ffQaD"),
    $53c4cb998bd718c1$var$load("kvRbA"),
    $53c4cb998bd718c1$var$load("hpJtK")
]).then(()=>parcelRequire('ge8BQ'));

});



parcelRegister("6IB0N", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectApprovalsRouteEntry", () => $89b695e5f9f3673a$export$563b4fef899fe540);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $hsU7j = parcelRequire("hsU7j");

var $8roOm = parcelRequire("8roOm");
const $89b695e5f9f3673a$export$563b4fef899fe540 = (0, $7NszV.createEntry)((0, $hsU7j.classicBusinessProjectApprovalsRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.approvals-view',
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)(),
        entryPoint: ()=>(0, $8roOm.approvalsPageEntryPoint)
    }));

});
parcelRegister("hsU7j", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectApprovalsRoute", () => $5bb44f21c5956447$export$3109a183a442a02d);
const $5bb44f21c5956447$export$3109a183a442a02d = {
    name: 'classic-business-approvals',
    path: '/jira/core/projects/:projectKey/approvals',
    exact: true
};

});

parcelRegister("8roOm", function(module, exports) {

$parcel$export(module.exports, "approvalsPageEntryPoint", () => $09fa0192771673de$export$52c40d37705be5fa);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $4gsaJ = parcelRequire("4gsaJ");

var $fo6b8 = parcelRequire("fo6b8");
const $09fa0192771673de$export$52c40d37705be5fa = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $4gsaJ.approvalsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("4gsaJ", function(module, exports) {

$parcel$export(module.exports, "approvalsEntryPoint", () => $300bb28bd2b40101$export$25d4a03de93a440e);

var $dFopv = parcelRequire("dFopv");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $300bb28bd2b40101$export$25d4a03de93a440e = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("hfG9c")), {
        moduleId: "6a9ba200"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                approvalsQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $dFopv.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("dFopv", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cf737eba0cc3036$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fc6e2d903d7a5160ec3c02b7156848e4>>
 * @relayHash 2cc1b2be473185de0346970d79002539
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2a7b24f841e6d55f0b788183900c0f5208b596d9f5efe804ede9c194b19f5e8d
const $4cf737eba0cc3036$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "2a7b24f841e6d55f0b788183900c0f5208b596d9f5efe804ede9c194b19f5e8d",
        "metadata": {},
        "name": "src_jiraBusinessApprovalsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $4cf737eba0cc3036$export$2e2bcd8739ae039 = $4cf737eba0cc3036$var$node;

});

parcelRegister("hfG9c", function(module, exports) {

let $c8f487f94027b071$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c8f487f94027b071$var$load("gpVrA").then(()=>parcelRequire('iJtUd'));

});




parcelRegister("1sFpf", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormBuilderRouteEntry", () => $b4b68e41808a2055$export$9eb15893d080e73b);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $a2PcO = parcelRequire("a2PcO");

var $d9uEV = parcelRequire("d9uEV");
const $b4b68e41808a2055$export$9eb15893d080e73b = (0, $7NszV.createEntry)((0, $a2PcO.classicBusinessProjectFormBuilderRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.form-view',
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)(),
        entryPoint: ()=>(0, $d9uEV.formBuilderPageEntrypoint)
    }));

});
parcelRegister("a2PcO", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormBuilderRoute", () => $939973d6db7f74a6$export$5f684808e671de5);
const $939973d6db7f74a6$export$5f684808e671de5 = {
    name: 'classic-business-form-builder',
    path: '/jira/core/projects/:projectKey/form/:formId/builder',
    exact: true
};

});

parcelRegister("d9uEV", function(module, exports) {

$parcel$export(module.exports, "formBuilderPageEntrypoint", () => $69b26f1a607bfd2a$export$e0f4bcb9440be5eb);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $3SMwn = parcelRequire("3SMwn");

var $fo6b8 = parcelRequire("fo6b8");
const $69b26f1a607bfd2a$export$e0f4bcb9440be5eb = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $3SMwn.formBuilderEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("3SMwn", function(module, exports) {

$parcel$export(module.exports, "formBuilderEntrypoint", () => $5ed17fe91cd922c4$export$6d3c9fa7232f412c);

var $kNhf9 = parcelRequire("kNhf9");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $5ed17fe91cd922c4$export$6d3c9fa7232f412c = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        if (!false) return (parcelRequire("5dINZ"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "86254720"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                formBuilderQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $kNhf9.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("kNhf9", function(module, exports) {

$parcel$export(module.exports, "default", () => $8916cebd6c30ef65$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f4e5285cf738fae5658c117e04609239>>
 * @relayHash d97c7a633d846788784b53e47412dba2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4f1558c868f827e5a17035db5860c9c66151d5a49619d6606fa69856264023f5
const $8916cebd6c30ef65$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "4f1558c868f827e5a17035db5860c9c66151d5a49619d6606fa69856264023f5",
        "metadata": {},
        "name": "src_jiraBusinessFormBuilderQuery",
        "operationKind": "query",
        "text": null
    }
};
var $8916cebd6c30ef65$export$2e2bcd8739ae039 = $8916cebd6c30ef65$var$node;

});

parcelRegister("5dINZ", function(module, exports) {

let $3cd0ec0f432d0569$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $3cd0ec0f432d0569$var$load("ffQaD"),
    $3cd0ec0f432d0569$var$load("kvRbA"),
    $3cd0ec0f432d0569$var$load("kduUo")
]).then(()=>parcelRequire('fU1n9'));

});




parcelRegister("a2wNz", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormRouteEntry", () => $78b7bb0633a93217$export$4798edf139084d2e);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $aPjV2 = parcelRequire("aPjV2");

var $7VVhE = parcelRequire("7VVhE");
const $78b7bb0633a93217$export$4798edf139084d2e = (0, $7NszV.createEntry)((0, $aPjV2.classicBusinessProjectFormRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.form-directory-view',
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)(),
        entryPoint: ()=>(0, $7VVhE.formPageEntrypoint)
    }));

});
parcelRegister("aPjV2", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormRoute", () => $63fab73853b00f48$export$e98776bdf96c88ac);
const $63fab73853b00f48$export$e98776bdf96c88ac = {
    name: 'classic-business-form',
    path: '/jira/core/projects/:projectKey/form',
    exact: true
};

});

parcelRegister("7VVhE", function(module, exports) {

$parcel$export(module.exports, "formPageEntrypoint", () => $32842b78cbaba6f2$export$ebaf30a031a61671);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $13ZHy = parcelRequire("13ZHy");

var $fo6b8 = parcelRequire("fo6b8");
const $32842b78cbaba6f2$export$ebaf30a031a61671 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $13ZHy.formEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("13ZHy", function(module, exports) {

$parcel$export(module.exports, "formEntrypoint", () => $c30c690af04301b5$export$b931eb60522f687a);

var $41sHw = parcelRequire("41sHw");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $c30c690af04301b5$export$b931eb60522f687a = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("hWmwC")), {
        moduleId: "77eafb5a"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                formQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $41sHw.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("41sHw", function(module, exports) {

$parcel$export(module.exports, "default", () => $333e5c56ad243628$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f62e7b05d75adf93c826705d7992eb93>>
 * @relayHash 8e0b57fc78588fab5ce6e2ba76089a61
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 00dfb7b57058946faf78573ea5754789e6b3e2dd7eab0b5c0a813c3db15e260b
const $333e5c56ad243628$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "00dfb7b57058946faf78573ea5754789e6b3e2dd7eab0b5c0a813c3db15e260b",
        "metadata": {},
        "name": "src_jiraBusinessFormQuery",
        "operationKind": "query",
        "text": null
    }
};
var $333e5c56ad243628$export$2e2bcd8739ae039 = $333e5c56ad243628$var$node;

});

parcelRegister("hWmwC", function(module, exports) {

let $d0f953713a1b906d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d0f953713a1b906d$var$load("j09Vp").then(()=>parcelRequire('4qzdE'));

});




parcelRegister("eghTD", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormSubmitEmbedRouteEntry", () => $ea2f0b4ec45df3b4$export$c2f698be6eedea1a);

var $6e4Kt = parcelRequire("6e4Kt");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $4xJea = parcelRequire("4xJea");

var $MxpLn = parcelRequire("MxpLn");
const $ea2f0b4ec45df3b4$export$c2f698be6eedea1a = (0, $7NszV.createEntry)((0, $4xJea.classicBusinessProjectFormSubmitEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.form-submit-embed-view',
        layout: (0, $6e4Kt.chromelessLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        resources: (0, $lNicp.getProjectViewResources)(),
        entryPoint: ()=>(0, $MxpLn.formSubmitEmbedPageEntrypoint)
    }));

});
parcelRegister("4xJea", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormSubmitEmbedRoute", () => $bab948378ba6b470$export$7e8fd15fdfa29385);
const $bab948378ba6b470$export$7e8fd15fdfa29385 = {
    name: 'classic-business-form-submit-embed',
    path: '/jira/core/projects/:projectKey/form/:formId/embed',
    exact: true
};

});

parcelRegister("MxpLn", function(module, exports) {

$parcel$export(module.exports, "formSubmitEmbedPageEntrypoint", () => $7b75b9ef7f4c7083$export$93f08d580854f4a7);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $1XDMK = parcelRequire("1XDMK");

var $fo6b8 = parcelRequire("fo6b8");
const $7b75b9ef7f4c7083$export$93f08d580854f4a7 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1XDMK.formSubmitEmbedEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("1XDMK", function(module, exports) {

$parcel$export(module.exports, "formSubmitEmbedEntrypoint", () => $aa01aa42cf2471d0$export$4c748d8ca82fc24);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $aa01aa42cf2471d0$export$4c748d8ca82fc24 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("gbXRk")), {
        moduleId: "20838510"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("gbXRk", function(module, exports) {

let $bc9c1b30a662e316$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $bc9c1b30a662e316$var$load("ffQaD"),
    $bc9c1b30a662e316$var$load("kvRbA"),
    $bc9c1b30a662e316$var$load("dVS2w")
]).then(()=>parcelRequire('7H3bY'));

});




parcelRegister("ajYJ1", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormSubmitRouteEntry", () => $1ad0e25a3297ce2b$export$bd59a50eb595d1d5);

var $5f2bR = parcelRequire("5f2bR");

var $6e4Kt = parcelRequire("6e4Kt");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $5VxfF = parcelRequire("5VxfF");

var $kimPG = parcelRequire("kimPG");
const $1ad0e25a3297ce2b$export$bd59a50eb595d1d5 = (0, $7NszV.createEntry)((0, $5VxfF.classicBusinessProjectFormSubmitRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.form-submit-view',
        layout: (0, $6e4Kt.chromelessLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)(),
        entryPoint: ()=>(0, $kimPG.formSubmitPageEntrypoint)
    }));

});
parcelRegister("5VxfF", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormSubmitRoute", () => $6637feb602e2c6a2$export$3cd93ff55b29f07f);
const $6637feb602e2c6a2$export$3cd93ff55b29f07f = {
    name: 'classic-business-form-submit',
    path: '/jira/core/projects/:projectKey/form/:formId',
    exact: true
};

});

parcelRegister("kimPG", function(module, exports) {

$parcel$export(module.exports, "formSubmitPageEntrypoint", () => $86d107866af1a870$export$26755d0805847061);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $ap0Y4 = parcelRequire("ap0Y4");
const $86d107866af1a870$export$26755d0805847061 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $ap0Y4.formSubmitEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("ap0Y4", function(module, exports) {

$parcel$export(module.exports, "formSubmitEntrypoint", () => $b9d2e58129000f4b$export$d33b8db02e0a0cb5);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $b9d2e58129000f4b$export$d33b8db02e0a0cb5 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("kQ1kt")), {
        moduleId: "1cf8636b"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("kQ1kt", function(module, exports) {

let $f2b9b1efb1e82c76$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f2b9b1efb1e82c76$var$load("ffQaD"),
    $f2b9b1efb1e82c76$var$load("kvRbA"),
    $f2b9b1efb1e82c76$var$load("82xZj")
]).then(()=>parcelRequire('hcjUE'));

});




parcelRegister("huQRU", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormSubmitPublicRouteEntry", () => $8ba2931eff60855d$export$69d2365670c516de);

var $6e4Kt = parcelRequire("6e4Kt");

var $7NszV = parcelRequire("7NszV");

var $82Fi7 = parcelRequire("82Fi7");

var $6s1PB = parcelRequire("6s1PB");

var $6LsQE = parcelRequire("6LsQE");

var $2Ql51 = parcelRequire("2Ql51");

var $eRU3k = parcelRequire("eRU3k");
const $8ba2931eff60855d$export$69d2365670c516de = (0, $7NszV.createEntry)((0, $82Fi7.classicBusinessProjectFormSubmitPublicRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.form-submit-public-view',
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            (0, $2Ql51.themePreferenceResource)
        ],
        entryPoint: ()=>(0, $6s1PB.expVal)('jira_forms_public_access_experiment', 'isEnabled', 'false') ? (0, $eRU3k.formSubmitPageEntrypoint) : (0, $6LsQE.notFoundPageEntrypoint)
    }));

});
parcelRegister("82Fi7", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectFormSubmitPublicRoute", () => $93f319f0fd75fd27$export$865063615075df54);
const $93f319f0fd75fd27$export$865063615075df54 = {
    name: 'classic-business-form-submit-public',
    path: '/jira/core/form/:formUuid',
    exact: true
};

});

parcelRegister("6LsQE", function(module, exports) {

$parcel$export(module.exports, "notFoundPageEntrypoint", () => $8a0b47b5f1d82a69$export$eb748b014da0ac9a);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $6ApJI = parcelRequire("6ApJI");
const $8a0b47b5f1d82a69$export$eb748b014da0ac9a = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $6ApJI.notFoundEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).HOME
});

});
parcelRegister("6ApJI", function(module, exports) {

$parcel$export(module.exports, "notFoundEntrypoint", () => $04e61a5f550e74fe$export$7fdee4826a30b643);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $04e61a5f550e74fe$export$7fdee4826a30b643 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("aLClV")), {
        moduleId: "4e8af128"
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("eRU3k", function(module, exports) {

$parcel$export(module.exports, "formSubmitPageEntrypoint", () => $605ab26c97fbe982$export$26755d0805847061);

var $lkFvK = parcelRequire("lkFvK");

var $iGgme = parcelRequire("iGgme");
const $605ab26c97fbe982$export$26755d0805847061 = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $iGgme.formSubmitPublicEntrypoint)
});

});
parcelRegister("iGgme", function(module, exports) {

$parcel$export(module.exports, "formSubmitPublicEntrypoint", () => $ea12db6778cfe8c5$export$345530940ab03dbd);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $ea12db6778cfe8c5$export$345530940ab03dbd = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("omcVN")), {
        moduleId: "d418c43d"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("omcVN", function(module, exports) {

let $049377f751eb46ae$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $049377f751eb46ae$var$load("ffQaD"),
    $049377f751eb46ae$var$load("kvRbA"),
    $049377f751eb46ae$var$load("5Lh79")
]).then(()=>parcelRequire('hkafd'));

});




parcelRegister("47CVY", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectPagesRouteEntry", () => $64d1b6dc76e76b9d$export$7a55e12f93813823);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $a0g4h = parcelRequire("a0g4h");

var $cRzP7 = parcelRequire("cRzP7");
const $64d1b6dc76e76b9d$export$7a55e12f93813823 = (0, $7NszV.createEntry)((0, $a0g4h.classicBusinessProjectPagesRoute), ()=>({
        group: 'classic-business',
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource)
        ],
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        ufoName: 'jwm.jwm-pages',
        entryPoint: ()=>(0, $cRzP7.pagesPageEntrypoint)
    }));

});
parcelRegister("a0g4h", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectPagesRoute", () => $c3d7ad3cf5e0901f$export$573cc697c2d33124);
const $c3d7ad3cf5e0901f$export$573cc697c2d33124 = {
    name: 'project-pages',
    path: '/jira/core/projects/:projectKey/pages'
};

});

parcelRegister("cRzP7", function(module, exports) {

$parcel$export(module.exports, "pagesPageEntrypoint", () => $7e318392f3d5106d$export$4ce394de88f5b54a);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $i0f3c = parcelRequire("i0f3c");

var $fo6b8 = parcelRequire("fo6b8");
const $7e318392f3d5106d$export$4ce394de88f5b54a = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $i0f3c.pagesEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("i0f3c", function(module, exports) {

$parcel$export(module.exports, "pagesEntrypoint", () => $cc22f4626e458394$export$49834d404673808c);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $cc22f4626e458394$export$49834d404673808c = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("kz7Oe")), {
        moduleId: "671532d1"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("kz7Oe", function(module, exports) {

let $ef8d2247592f586f$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ef8d2247592f586f$var$load("76n7a"),
    $ef8d2247592f586f$var$load("l253H"),
    $ef8d2247592f586f$var$load("lDFU4")
]).then(()=>parcelRequire('719qB'));

});




parcelRegister("hfeIi", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectSampleOnboardingRouteEntry", () => $c7f4c7d963439815$export$d047e2b436470b0a);

var $6e4Kt = parcelRequire("6e4Kt");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $7Zyb9 = parcelRequire("7Zyb9");

var $7wcBz = parcelRequire("7wcBz");
const $c7f4c7d963439815$export$d047e2b436470b0a = (0, $7NszV.createEntry)((0, $7Zyb9.classicBusinessProjectSampleOnboardingRoute), ()=>({
        group: 'classic-business',
        component: (0, $7wcBz.default),
        layout: (0, $6e4Kt.chromelessLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        resources: (0, $3RJkv.getNavigationResources)(),
        forPaint: [
            (0, $7wcBz.LazySampleOnboardingView)
        ]
    }));

});
parcelRegister("7Zyb9", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectSampleOnboardingRoute", () => $cc13a94c19681f9f$export$cd9c218d7c968d2d);
const $cc13a94c19681f9f$export$cd9c218d7c968d2d = {
    name: 'classic-business-sample-onboarding',
    path: '/jira/core/sample/onboarding/:taskId',
    exact: true
};

});

parcelRegister("7wcBz", function(module, exports) {

$parcel$export(module.exports, "LazySampleOnboardingView", () => $d8c7c044abd4283c$export$e39375ab6521f3ef);
$parcel$export(module.exports, "default", () => $d8c7c044abd4283c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $d8c7c044abd4283c$export$e39375ab6521f3ef = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("cuqGY")), {
    moduleId: "./src/packages/spa-apps/business/sample-onboarding/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d8c7c044abd4283c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d8c7c044abd4283c$export$e39375ab6521f3ef,
        pageId: "async-business-sample-onboarding",
        shouldShowSpinner: true
    });

});
parcelRegister("cuqGY", function(module, exports) {

let $917cfde38c5eb029$var$load = (parcelRequire("28QjX"))(4);
module.exports = $917cfde38c5eb029$var$load("24tVE").then(()=>parcelRequire('ePHET'));

});



parcelRegister("hF0nU", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectShortcutRouteEntry", () => $4d5ae7b8b70c8e78$export$22248cc626626132);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $403gp = parcelRequire("403gp");

var $6JJeH = parcelRequire("6JJeH");
const $4d5ae7b8b70c8e78$export$22248cc626626132 = (0, $7NszV.createEntry)((0, $403gp.classicBusinessProjectShortcutRoute), ()=>({
        group: 'classic-business',
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)(),
        entryPoint: ()=>(0, $6JJeH.shortcutsPageEntrypoint)
    }));

});
parcelRegister("403gp", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectShortcutRoute", () => $60aa8b153682dfa1$export$2dd4e8a37d8ac978);
const $60aa8b153682dfa1$export$2dd4e8a37d8ac978 = {
    name: 'classic-business-shortcut',
    path: '/jira/core/projects/:projectKey/shortcuts',
    exact: true
};

});

parcelRegister("6JJeH", function(module, exports) {

$parcel$export(module.exports, "shortcutsPageEntrypoint", () => $19b2198152d557fa$export$57a2f1af23fcbb8b);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $8qyT8 = parcelRequire("8qyT8");

var $fo6b8 = parcelRequire("fo6b8");
const $19b2198152d557fa$export$57a2f1af23fcbb8b = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $8qyT8.shortcutsEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("8qyT8", function(module, exports) {

$parcel$export(module.exports, "shortcutsEntrypoint", () => $2c08d7e07e3e2760$export$212fd76838eeb6ad);

var $hSK0t = parcelRequire("hSK0t");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $2c08d7e07e3e2760$export$212fd76838eeb6ad = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("aGRYM")), {
        moduleId: "736f6fc2"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                shortcutsQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $hSK0t.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("hSK0t", function(module, exports) {

$parcel$export(module.exports, "default", () => $c56df58cb6ff2ae3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<571227a0b71f1eebd07db7bde4b71b10>>
 * @relayHash f251714abaead8d7f256f75b2cbcdd4e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1b84b6702f8ba5906f411cf39e6585519029e426840a702a9fe6d1e6e094c95e
const $c56df58cb6ff2ae3$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "1b84b6702f8ba5906f411cf39e6585519029e426840a702a9fe6d1e6e094c95e",
        "metadata": {},
        "name": "src_jiraBusinessShortcutsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $c56df58cb6ff2ae3$export$2e2bcd8739ae039 = $c56df58cb6ff2ae3$var$node;

});

parcelRegister("aGRYM", function(module, exports) {

let $7c87b2cbcf8c0cc9$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $7c87b2cbcf8c0cc9$var$load("fliVL"),
    $7c87b2cbcf8c0cc9$var$load("1ChkR")
]).then(()=>parcelRequire('7WItf'));

});




parcelRegister("ejDmq", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectViewNotFoundRouteEntry", () => $c521464132416e2d$export$e23e06ae81848c38);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $8RNDo = parcelRequire("8RNDo");

var $1g8oF = parcelRequire("1g8oF");
const $c521464132416e2d$export$e23e06ae81848c38 = (0, $7NszV.createEntry)((0, $8RNDo.classicBusinessProjectViewNotFoundRoute), ()=>({
        group: 'classic-business',
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)(),
        entryPoint: ()=>(0, $1g8oF.projectViewNotFoundPageEntrypoint)
    }));

});
parcelRegister("8RNDo", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProjectViewNotFoundRoute", () => $20583b3f5bf95ee3$export$1194a530fb12fc37);
const $20583b3f5bf95ee3$export$1194a530fb12fc37 = {
    name: 'classic-business-view-not-found',
    path: '/jira/core/projects/:projectKey/not-found',
    exact: true
};

});

parcelRegister("1g8oF", function(module, exports) {

$parcel$export(module.exports, "projectViewNotFoundPageEntrypoint", () => $cdbfface63bc99c3$export$31e63eef3cc009c6);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $bclj6 = parcelRequire("bclj6");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");

const $cdbfface63bc99c3$var$main = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("7sCoY")), {
        moduleId: "24c3dcc7",
        moduleName: "ProjectViewNotFound"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                mainQuery: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $bclj6.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});
const $cdbfface63bc99c3$export$31e63eef3cc009c6 = (0, $lkFvK.createPageEntryPoint)({
    main: $cdbfface63bc99c3$var$main,
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("bclj6", function(module, exports) {

$parcel$export(module.exports, "default", () => $70fb7cc296b150fc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c9a08656b81123b3a899ed443afd14f3>>
 * @relayHash 4f9cc1b4eefda38b80dcbc5247f75776
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4e080d38c866eb2caaf06903fd96c2653d506a6f20f6ba761d204c141a5466d9
const $70fb7cc296b150fc$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "4e080d38c866eb2caaf06903fd96c2653d506a6f20f6ba761d204c141a5466d9",
        "metadata": {},
        "name": "ProjectViewNotFoundQuery",
        "operationKind": "query",
        "text": null
    }
};
var $70fb7cc296b150fc$export$2e2bcd8739ae039 = $70fb7cc296b150fc$var$node;

});

parcelRegister("7sCoY", function(module, exports) {

let $56e8efb5f8244d2f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $56e8efb5f8244d2f$var$load("4pw2D").then(()=>parcelRequire('8HTcg'));

});



parcelRegister("9yqzH", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessListEmbedRouteEntry", () => $965e54647b28fbce$export$a6737d9a8c0f9d4f);

var $6e4Kt = parcelRequire("6e4Kt");

var $lkFvK = parcelRequire("lkFvK");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $jwVzG = parcelRequire("jwVzG");

var $dfTsw = parcelRequire("dfTsw");
const $965e54647b28fbce$var$listEmbedPageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $dfTsw.listEmbedEntryPoint)
});
const $965e54647b28fbce$export$a6737d9a8c0f9d4f = (0, $7NszV.createEntry)((0, $jwVzG.jiraBusinessListEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.list-embed-view',
        layout: (0, $6e4Kt.chromelessLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        entryPoint: ()=>$965e54647b28fbce$var$listEmbedPageEntryPoint,
        resources: (0, $lNicp.getProjectViewResources)()
    }));

});
parcelRegister("jwVzG", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessListEmbedRoute", () => $9db7312602117a3c$export$40306068630dfc2);
const $9db7312602117a3c$export$40306068630dfc2 = {
    name: 'classic-business-list-embed',
    path: '/jira/core/projects/:projectKey/list/embed',
    exact: true
};

});

parcelRegister("dfTsw", function(module, exports) {

$parcel$export(module.exports, "listEmbedEntryPoint", () => $4eb9b872b8483ed3$export$519bb55e1612f243);

var $EVQo4 = parcelRequire("EVQo4");

var $iptXe = parcelRequire("iptXe");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");
const $4eb9b872b8483ed3$var$FORMAT_RULES_FIRST = 20;

const $4eb9b872b8483ed3$export$519bb55e1612f243 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("iGkj4")), {
        moduleId: "543152bd"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                listEmbedQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $iptXe.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                formattingRulesQuery: {
                    parameters: (0, $EVQo4.default),
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        first: $4eb9b872b8483ed3$var$FORMAT_RULES_FIRST
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        };
    }
});

});
parcelRegister("EVQo4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fc143a99d34d8f4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5883fb1edc7ab15af020f0e2872a12f9>>
 * @relayHash fe655b1c8f3fbc00448359fc7bbdb4a2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 19617cae23dba3619feb6b7d7006b077c3444a7b0f92752732863a7b7f39d16b
const $6fc143a99d34d8f4$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "19617cae23dba3619feb6b7d7006b077c3444a7b0f92752732863a7b7f39d16b",
        "metadata": {},
        "name": "formatRulesQuery",
        "operationKind": "query",
        "text": null
    }
};
var $6fc143a99d34d8f4$export$2e2bcd8739ae039 = $6fc143a99d34d8f4$var$node;

});

parcelRegister("iptXe", function(module, exports) {

$parcel$export(module.exports, "default", () => $286e0bf23cd75683$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3fbad09b7a5f56fa90258f09408fcab9>>
 * @relayHash 09e2853d076a3827094f0b2a31a60cad
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e0425937923f1cfadd146be550944e5e36b0ec94fb0732af23a465a8c1c70cf5
const $286e0bf23cd75683$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e0425937923f1cfadd146be550944e5e36b0ec94fb0732af23a465a8c1c70cf5",
        "metadata": {},
        "name": "src_jiraBusinessListEmbedQuery",
        "operationKind": "query",
        "text": null
    }
};
var $286e0bf23cd75683$export$2e2bcd8739ae039 = $286e0bf23cd75683$var$node;

});

parcelRegister("iGkj4", function(module, exports) {

let $d99be6b2b7a85c2d$var$load = (parcelRequire("28QjX"))(4);


module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $d99be6b2b7a85c2d$var$load("cTJTG"),
            $d99be6b2b7a85c2d$var$load("l253H"),
            $d99be6b2b7a85c2d$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $d99be6b2b7a85c2d$var$load("4Qxp7")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $d99be6b2b7a85c2d$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $d99be6b2b7a85c2d$var$load("7B2gt")
        ]);
    }),
    $d99be6b2b7a85c2d$var$load("ffQaD"),
    $d99be6b2b7a85c2d$var$load("kvRbA"),
    $d99be6b2b7a85c2d$var$load("kHsBv")
]).then(()=>parcelRequire('ik71Z'));

});



parcelRegister("gxVJf", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessListRouteEntry", () => $ea798fc0f4203cc1$export$9ef24aa950399eaf);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $hCAN5 = parcelRequire("hCAN5");

var $2C7sQ = parcelRequire("2C7sQ");

var $fo6b8 = parcelRequire("fo6b8");
const $ea798fc0f4203cc1$var$listPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $2C7sQ.listEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $ea798fc0f4203cc1$export$9ef24aa950399eaf = (0, $7NszV.createEntry)((0, $hCAN5.jiraBusinessListRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.list-view',
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        entryPoint: ()=>$ea798fc0f4203cc1$var$listPageEntryPoint,
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)()
    }));

});
parcelRegister("hCAN5", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessListRoute", () => $257b3e3c032338e6$export$ea171f7670960cff);
const $257b3e3c032338e6$export$ea171f7670960cff = {
    name: 'classic-business-list',
    path: '/jira/core/projects/:projectKey/list',
    exact: true
};

});

parcelRegister("2C7sQ", function(module, exports) {

$parcel$export(module.exports, "listEntryPoint", () => $7b34153964734d60$export$6be4f10150ff6073);

var $EVQo4 = parcelRequire("EVQo4");

var $91hzp = parcelRequire("91hzp");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");
const $7b34153964734d60$var$FORMAT_RULES_FIRST = 20;

const $7b34153964734d60$export$6be4f10150ff6073 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("9tXgr")), {
        moduleId: "b03343a1"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                listQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $91hzp.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                formattingRulesQuery: {
                    parameters: (0, $EVQo4.default),
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        first: $7b34153964734d60$var$FORMAT_RULES_FIRST
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        };
    }
});

});
parcelRegister("91hzp", function(module, exports) {

$parcel$export(module.exports, "default", () => $169ed3aa08e6bba7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9516f6b957580a1dd0913ff88ae3e10d>>
 * @relayHash 8ab96395b697c5b81fab0afb4eebcfef
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e0cc007557fb53672f36f25ae9fd169cd95e4b69654d21b1f471f604abc11db8
const $169ed3aa08e6bba7$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e0cc007557fb53672f36f25ae9fd169cd95e4b69654d21b1f471f604abc11db8",
        "metadata": {},
        "name": "src_jiraBusinessListQuery",
        "operationKind": "query",
        "text": null
    }
};
var $169ed3aa08e6bba7$export$2e2bcd8739ae039 = $169ed3aa08e6bba7$var$node;

});

parcelRegister("9tXgr", function(module, exports) {

let $6e74cb24072f2c1e$var$load = (parcelRequire("28QjX"))(4);


module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $6e74cb24072f2c1e$var$load("cTJTG"),
            $6e74cb24072f2c1e$var$load("l253H"),
            $6e74cb24072f2c1e$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $6e74cb24072f2c1e$var$load("4Qxp7")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $6e74cb24072f2c1e$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $6e74cb24072f2c1e$var$load("7B2gt")
        ]);
    }),
    $6e74cb24072f2c1e$var$load("ffQaD"),
    $6e74cb24072f2c1e$var$load("kvRbA"),
    $6e74cb24072f2c1e$var$load("keT0w")
]).then(()=>parcelRequire('zU4ax'));

});



parcelRegister("c1v6Y", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessOverviewRedirectRouteEntry", () => $653443b3f7416d46$export$3aa9116f715693e1);

var $ffza4 = parcelRequire("ffza4");

var $l71WK = parcelRequire("l71WK");

var $lRPBw = parcelRequire("lRPBw");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $bG2it = parcelRequire("bG2it");

var $6475a = parcelRequire("6475a");
const $653443b3f7416d46$export$3aa9116f715693e1 = (0, $7NszV.createEntry)((0, $bG2it.jiraBusinessOverviewRedirectRoute), ()=>({
        group: 'classic-business',
        isRedirect: true,
        component: (0, $6475a.default),
        layout: (0, $lRPBw.businessProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $l71WK.AsyncHorizontalOverviewNav)
        },
        resources: (0, $lNicp.getOverviewViewResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("bG2it", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessOverviewRedirectRoute", () => $2d98eac94414a73a$export$5ab0e07528c31349);
const $2d98eac94414a73a$export$5ab0e07528c31349 = {
    name: 'classic-business-overview-redirect',
    path: '/jira/core/overviews/:overviewId',
    exact: true
};

});

parcelRegister("6475a", function(module, exports) {

$parcel$export(module.exports, "default", () => $31755126abaef7af$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ds5qV = parcelRequire("ds5qV");

var $bmKPg = parcelRequire("bmKPg");
const $31755126abaef7af$var$OverviewRedirect = ()=>{
    const [overviewId] = (0, $bmKPg.usePathParam)('overviewId');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: `/jira/core/overviews/${overviewId}/summary`
    });
};
var $31755126abaef7af$export$2e2bcd8739ae039 = $31755126abaef7af$var$OverviewRedirect;

});


parcelRegister("bZEI9", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessProjectRedirectRouteEntry", () => $8fd82d52927aa17f$export$766e305da4c78de5);

var $ffza4 = parcelRequire("ffza4");

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $hqguB = parcelRequire("hqguB");

var $7MCPm = parcelRequire("7MCPm");
const $8fd82d52927aa17f$export$766e305da4c78de5 = (0, $7NszV.createEntry)((0, $hqguB.jiraBusinessProjectRedirectRoute), ()=>({
        group: 'classic-business',
        isRedirect: true,
        component: (0, $7MCPm.RedirectToLastVisitedProjectPage),
        layout: (0, $lRPBw.businessProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});

parcelRegister("1EihZ", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessSummaryEmbedRouteEntry", () => $f7c860425219110c$export$2c37f93832ff9919);

var $6e4Kt = parcelRequire("6e4Kt");

var $lkFvK = parcelRequire("lkFvK");

var $6s1PB = parcelRequire("6s1PB");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $kqhaB = parcelRequire("kqhaB");

var $3zj3N = parcelRequire("3zj3N");

var $f1r4M = parcelRequire("f1r4M");

var $eASai = parcelRequire("eASai");

var $7yKXN = parcelRequire("7yKXN");

var $4R6GH = parcelRequire("4R6GH");
/**
 * @deprecated delete this entrypoint when cleaning up jwm-summary-page-migration experiment flag
 */ const $f7c860425219110c$var$summaryEmbedPageEntrypoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $eASai.summaryEmbedEntrypoint)
});
const $f7c860425219110c$var$summaryEmbedBusimessPageEntrypoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $7yKXN.summaryBusinessEmbedEntrypoint)
});
const $f7c860425219110c$var$getSummaryPageResource = ()=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jwm-summary-page-migration');
    const jwmSummaryPageMigrationEnabled = expConfig.get('isEnabled', false);
    return [
        ...jwmSummaryPageMigrationEnabled && (0, $4R6GH.fg)('helios_biz_project_remove_rrr') ? [] : [
            (0, $3zj3N.summaryDataResource)
        ],
        ...jwmSummaryPageMigrationEnabled && (0, $4R6GH.fg)('helios_biz_project_fast_activity_feed') ? [] : [
            (0, $kqhaB.activityFeedResource)
        ]
    ];
};
const $f7c860425219110c$export$2c37f93832ff9919 = (0, $7NszV.createEntry)((0, $f1r4M.jiraBusinessSummaryEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.summary-view-embed',
        layout: (0, $6e4Kt.chromelessLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        resources: [
            ...(0, $lNicp.getProjectViewResources)(),
            ...$f7c860425219110c$var$getSummaryPageResource()
        ],
        entryPoint: ()=>{
            if ((0, $6s1PB.expVal)('jwm-summary-page-migration', 'isEnabled', false)) return $f7c860425219110c$var$summaryEmbedBusimessPageEntrypoint;
            return $f7c860425219110c$var$summaryEmbedPageEntrypoint;
        }
    }));

});
parcelRegister("kqhaB", function(module, exports) {

$parcel$export(module.exports, "activityFeedResource", () => $1609d8a65ae37e85$export$928ea152e5c5de54);
$parcel$export(module.exports, "useActivityFeed", () => $1609d8a65ae37e85$export$ee1fe267047f502f);

var $4NbWL = parcelRequire("4NbWL");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");
const $1609d8a65ae37e85$var$RESOURCE_TYPE_KEY = 'BUSINESS_ACTIVITY_FEED';
const $1609d8a65ae37e85$var$EMPTY_DATA = {
    data: [],
    pageInfo: {
        hasNextPage: false,
        endCursor: ''
    }
};
const $1609d8a65ae37e85$export$928ea152e5c5de54 = (0, $2M1hQ.createResource)({
    type: $1609d8a65ae37e85$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        return `${$1609d8a65ae37e85$var$RESOURCE_TYPE_KEY}_${projectKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return $1609d8a65ae37e85$var$EMPTY_DATA;
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(match, query);
        return (0, $4NbWL.fetchActivityFeed)(null, projectKey);
    },
    maxAge: 5000,
    isBrowserOnly: true
});
const $1609d8a65ae37e85$export$ee1fe267047f502f = ()=>// forcing the return type due to react-resource-router's weird error types
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $2YP9W.useResource)($1609d8a65ae37e85$export$928ea152e5c5de54);

});
parcelRegister("4NbWL", function(module, exports) {

$parcel$export(module.exports, "fetchActivityFeed", () => $72e600639fed107e$export$967c92ed76f908b6);

var $gKZoD = parcelRequire("gKZoD");

var $jJZqs = parcelRequire("jJZqs");

var $a8I18 = parcelRequire("a8I18");
const $72e600639fed107e$var$PAGE_SIZE = 10;
const $72e600639fed107e$var$CONTENT_TYPE = 'application/atom+xml; charset=UTF-8';
const $72e600639fed107e$var$STREAM_PROVIDERS = 'thirdparty issues';
const $72e600639fed107e$export$967c92ed76f908b6 = (after, projectKey)=>{
    (0, $gKZoD.di)(fetch);
    const firstIndex = after != null ? Number(after) : 0;
    const maxResults = firstIndex + $72e600639fed107e$var$PAGE_SIZE;
    return fetch(// @ts-expect-error - TS2345: Types of property 'maxResults' are incompatible. Type 'number' is not assignable to type 'string'.
    `/plugins/servlet/streams?${new URLSearchParams({
        maxResults: maxResults,
        relativeLinks: true,
        streams: `key IS ${projectKey}`,
        providers: $72e600639fed107e$var$STREAM_PROVIDERS
    }).toString()}`, {
        headers: {
            'content-type': $72e600639fed107e$var$CONTENT_TYPE
        }
    }).then((response)=>{
        if (!response.ok) throw new (0, $jJZqs.default)(response.status, `Error server response: ${response.status}`);
        return response.text();
    }).then((rawResponse)=>{
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(rawResponse, 'application/xml');
        const entries = (0, $a8I18.transformData)(xmlDoc);
        return {
            data: entries,
            pageInfo: {
                hasNextPage: entries.length >= maxResults,
                endCursor: String(entries.length)
            }
        };
    });
};

});
parcelRegister("a8I18", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $26b06333cc6e5e1f$export$3ceb62baab058c6b);
const $26b06333cc6e5e1f$export$3ceb62baab058c6b = (xmlDoc)=>{
    // @ts-expect-error - TS2304 - Cannot find name 'ActivityFeedItem'.
    const result = [];
    // Typecheck with project references identifies this as error but existing typecheck is not so doesnt allow ts-expect-error, so used ts-ignore
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - Type 'NodeListOf<Element>' must have a '[Symbol.iterator]()' method that returns an iterator.
    for (const entry of xmlDoc.querySelectorAll('entry')){
        const id = entry.querySelector('id')?.textContent ?? '';
        const published = entry.querySelector('published')?.textContent ?? '';
        const name = entry.querySelector('author > name')?.textContent ?? '';
        const title = entry.querySelector('title')?.textContent ?? '';
        const iconUrl = entry.querySelector('[rel="http://streams.atlassian.com/syndication/icon"]')?.getAttribute('href') ?? '';
        const content = entry.querySelector('content')?.textContent;
        const feedItem = {
            id: id,
            author: {
                name: name,
                avatarUrl: ''
            },
            published: published,
            title: title,
            iconUrl: iconUrl,
            content: content
        };
        entry.querySelectorAll('author > link[rel=photo]').forEach((link)=>{
            if (link.getAttribute('media:height') === '48') feedItem.author.avatarUrl = link.getAttribute('href') ?? '';
        });
        result.push(feedItem);
    }
    return result;
};

});



parcelRegister("3zj3N", function(module, exports) {

$parcel$export(module.exports, "summaryDataResource", () => $acdbc5801b5f9bec$export$cdfee963587c1ea4);
$parcel$export(module.exports, "useSummaryData", () => $acdbc5801b5f9bec$export$c82acf736eaa253c);

var $aR4Ot = parcelRequire("aR4Ot");

var $iR3GG = parcelRequire("iR3GG");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");
const $acdbc5801b5f9bec$var$RESOURCE_TYPE_KEY = 'BUSINESS_SUMMARY_DATA';
const $acdbc5801b5f9bec$var$EMPTY_DATA = {
    overviewItems: null,
    issuesByStatus: null,
    issuesByPriority: null,
    issuesByAssignee: null,
    issuesByType: null,
    workflowsCount: null
};
const $acdbc5801b5f9bec$export$cdfee963587c1ea4 = (0, $2M1hQ.createResource)({
    type: $acdbc5801b5f9bec$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        return `${$acdbc5801b5f9bec$var$RESOURCE_TYPE_KEY}_${projectKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return $acdbc5801b5f9bec$var$EMPTY_DATA;
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(match, query);
        const jqlContext = `project = "${projectKey}"`;
        try {
            return await (0, $aR4Ot.fetchSummaryPageData)({
                cloudId: cloudId,
                jqlContext: jqlContext,
                projectKey: projectKey
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
            throw (0, $iR3GG.createResourceError)({
                component: 'spa.view.routes.business.summary-data.getData',
                message: `An error was thrown while prefetching the summary data. Status code: ${error?.statusCode}. Message: ${error?.message}`,
                name: 'ResourceError',
                skipSentry: isClientError
            });
        }
    },
    maxAge: 5000,
    isBrowserOnly: true
});
const $acdbc5801b5f9bec$export$c82acf736eaa253c = ()=>// forcing the return type due to react-resource-router's weird error types
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $2YP9W.useResource)($acdbc5801b5f9bec$export$cdfee963587c1ea4);

});
parcelRegister("aR4Ot", function(module, exports) {

$parcel$export(module.exports, "fetchSummaryPageData", () => $86d3799d8fb43b74$export$a3fa5b61d6f8cf86);

var $jlq4V = parcelRequire("jlq4V");

var $6s1PB = parcelRequire("6s1PB");

var $eusud = parcelRequire("eusud");


var $6FqTo = parcelRequire("6FqTo");

var $7P4vu = parcelRequire("7P4vu");
const $86d3799d8fb43b74$var$QUERY_NAME = 'SummaryPageData';
const $86d3799d8fb43b74$export$a3fa5b61d6f8cf86 = async ({ cloudId: cloudId, jqlContext: jqlContext, projectKey: projectKey })=>{
    // We must use UNSAFE_noExposureExp to check if experiment is enabled without actually firing exposure events
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expInlineStatusConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('business_summary_page_inline_status');
    const isExperimentSummaryPageInlineStatusEnabled = expInlineStatusConfig.get('isInlineStatusChangeEnabled', false);
    const response = await (0, $eusud.performPostRequest)(`/rest/gira/1/?operation=${$86d3799d8fb43b74$var$QUERY_NAME}`, {
        body: JSON.stringify({
            query: (0, $6s1PB.expVal)('jwm-summary-page-migration', 'isEnabled', false) ? (0, $6FqTo.SUMMARY_PAGE_DATA_QUERY) : (0, $6FqTo.SUMMARY_PAGE_DATA_QUERY_OLD),
            variables: {
                cloudId: cloudId,
                jqlContext: jqlContext,
                // unused variable for the new GQL query
                projectKey: (0, $6s1PB.expVal)('jwm-summary-page-migration', 'isEnabled', false) ? undefined : projectKey,
                doneThisWeekJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$d5aac1de7fafa2b0)}`,
                updatedThisWeekJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$b10a33c38cc20983)}`,
                createdThisWeekJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$48eb4b4c930c6378)}`,
                dueThisWeekJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$2573f5b8014b4068)}`,
                issuesByStatusJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$8cca17e1017ba894)}`,
                issuesByPriorityJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$c49e48bfa75ab23c)}`,
                issuesByAssigneeJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$c49e48bfa75ab23c)}`,
                issuesByTypeJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$c49e48bfa75ab23c)}`,
                pagedDataPageSize: (0, $cd053842fd66588d$export$c0ecd9bd08a86184),
                // unused variable for the new GQL query
                isWorkflowsCountEnabled: (0, $6s1PB.expVal)('jwm-summary-page-migration', 'isEnabled', false) ? undefined : isExperimentSummaryPageInlineStatusEnabled
            }
        })
    });
    if (response.errors != null) throw new (0, $jlq4V.GraphQLErrors)(response.errors);
    if (response.data == null) throw new Error('GraphQL response has no data');
    return (0, $7P4vu.transformData)(response.data);
};

});
const $cd053842fd66588d$export$d5aac1de7fafa2b0 = 'statusCategory = Done AND statusCategoryChangedDate >= -1w';
const $cd053842fd66588d$export$b10a33c38cc20983 = 'updatedDate >= -1w';
const $cd053842fd66588d$export$48eb4b4c930c6378 = 'createdDate >= -1w';
const $cd053842fd66588d$export$2573f5b8014b4068 = 'statusCategory != Done AND (duedate >= 0d AND duedate < 1w)';
const $cd053842fd66588d$export$8cca17e1017ba894 = '(statusCategory != Done OR (statusCategory = Done AND statusCategoryChangedDate >= -2w))';
const $cd053842fd66588d$export$c49e48bfa75ab23c = 'statusCategory != Done';
const $cd053842fd66588d$export$c0ecd9bd08a86184 = 8;
const $cd053842fd66588d$export$27f4fb65edc908d0 = `
  fragment IssuesByAssigneeFragment on JWMItemGroupConnection {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      field {
        ... on UserField {
          userValue {
            accountId,
            avatarUrl,
            displayName
          }
        }
      }
      id,
      totalCount
    }
  }
`;
const $cd053842fd66588d$export$5b2a5373659a0414 = `
  fragment IssuesByTypeFragment on JWMItemGroupConnection {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      field {
        ... on IssueTypeField {
              id
              name
              iconUrl
        }
      }
      id,
      totalCount
    }
  }
`;

parcelRegister("6FqTo", function(module, exports) {

$parcel$export(module.exports, "SUMMARY_PAGE_DATA_QUERY_OLD", () => $7511339abc68f96a$export$d825244d8ba23e54);
$parcel$export(module.exports, "SUMMARY_PAGE_DATA_QUERY", () => $7511339abc68f96a$export$7ea8f81ff5bf6361);

const $7511339abc68f96a$export$d825244d8ba23e54 = `
  query JiraBusinessSummaryPageData($cloudId: ID!, $jqlContext: String!, $doneThisWeekJql: String!, $updatedThisWeekJql: String!, $createdThisWeekJql: String!, $dueThisWeekJql: String!, $issuesByStatusJql: String!, $issuesByPriorityJql: String!, $issuesByAssigneeJql: String!, $issuesByTypeJql: String!, $pagedDataPageSize: Int!, $projectKey: String!, $isWorkflowsCountEnabled: Boolean!) {
    jira {
      jqlBuilder(cloudId: $cloudId) {
        status: fieldValues(
          jqlTerm: "status"
          jqlContext: $jqlContext
          viewContext: JWM
        ) {
          edges {
            node {
              jqlTerm
              displayName
            }
          }
        }
      }
      doneThisWeek: jwmViewItems(cloudId: $cloudId, jql: $doneThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      updatedThisWeek: jwmViewItems(cloudId: $cloudId, jql: $updatedThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      createdThisWeek: jwmViewItems(cloudId: $cloudId, jql: $createdThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      dueThisWeek: jwmViewItems(cloudId: $cloudId, jql: $dueThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      totalUnresolvedIssues: jwmViewItems(cloudId: $cloudId, jql: $issuesByAssigneeJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
    }
    issuesByStatus: jwmItemGroups(jql: $issuesByStatusJql, groupByFieldId: "status", fieldIds: [], first: 50) {
      nodes {
        id
        field {
          ...on StatusField {
              name
							statusId
              category {
                key
              }
          }
        }
        totalCount
      }
    }
    issuesByPriority: jwmItemGroups(jql: $issuesByPriorityJql, groupByFieldId: "priority", fieldIds: [], first: 50) {
      nodes {
        id
        field {
          ...on PriorityField {
            iconUrl
            name
          }
        }
        totalCount
      }
    }
    issuesByAssignee: jwmItemGroups(jql: $issuesByAssigneeJql, first: $pagedDataPageSize, fieldIds: [], groupByFieldId: "assignee", sortBy: {field: GROUP_COUNT, direction: DESC}) {
      ...IssuesByAssigneeFragment
    }
    issuesByType: jwmItemGroups(jql: $issuesByTypeJql, first: $pagedDataPageSize, fieldIds: [], groupByFieldId: "issuetype", sortBy: {field: GROUP_COUNT, direction: DESC}) {
      ...IssuesByTypeFragment
    }
    workflowsCount: jwmWorkflowWithIssueTypes(projectIdOrKey: $projectKey) @include(if: $isWorkflowsCountEnabled) {
      totalCount
    }
  }

  ${(0, $cd053842fd66588d$export$27f4fb65edc908d0)}
  ${(0, $cd053842fd66588d$export$5b2a5373659a0414)}
`;
const $7511339abc68f96a$export$7ea8f81ff5bf6361 = `
  query JiraBusinessSummaryPageData($cloudId: ID!, $jqlContext: String!, $doneThisWeekJql: String!, $updatedThisWeekJql: String!, $createdThisWeekJql: String!, $dueThisWeekJql: String!, $issuesByStatusJql: String!, $issuesByPriorityJql: String!, $issuesByAssigneeJql: String!, $issuesByTypeJql: String!, $pagedDataPageSize: Int!) {
    jira {
      jqlBuilder(cloudId: $cloudId) {
        status: fieldValues(
          jqlTerm: "status"
          jqlContext: $jqlContext
          viewContext: JWM
        ) {
          edges {
            node {
              jqlTerm
              displayName
            }
          }
        }
        priority: fieldValues(
          jqlTerm: "priority"
          jqlContext: $jqlContext
          viewContext: JWM
        ) {
          edges {
            node {
              jqlTerm
              displayName
            }
          }
        }
      }
      doneThisWeek: jwmViewItems(cloudId: $cloudId, jql: $doneThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      updatedThisWeek: jwmViewItems(cloudId: $cloudId, jql: $updatedThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      createdThisWeek: jwmViewItems(cloudId: $cloudId, jql: $createdThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      dueThisWeek: jwmViewItems(cloudId: $cloudId, jql: $dueThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      totalUnresolvedIssues: jwmViewItems(cloudId: $cloudId, jql: $issuesByAssigneeJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
    }
    issuesByStatus: jwmItemGroups(jql: $issuesByStatusJql, groupByFieldId: "status", fieldIds: [], first: 50) {
      nodes {
        id
        field {
          ...on StatusField {
              name
							statusId
              category {
                key
              }
          }
        }
        totalCount
      }
    }
    issuesByPriority: jwmItemGroups(jql: $issuesByPriorityJql, groupByFieldId: "priority", fieldIds: [], first: 50) {
      nodes {
        id
        field {
          ...on PriorityField {
            iconUrl
            name
          }
        }
        totalCount
      }
    }
    issuesByAssignee: jwmItemGroups(jql: $issuesByAssigneeJql, first: $pagedDataPageSize, fieldIds: [], groupByFieldId: "assignee", sortBy: {field: GROUP_COUNT, direction: DESC}) {
      ...IssuesByAssigneeFragment
    }
    issuesByType: jwmItemGroups(jql: $issuesByTypeJql, first: $pagedDataPageSize, fieldIds: [], groupByFieldId: "issuetype", sortBy: {field: GROUP_COUNT, direction: DESC}) {
      ...IssuesByTypeFragment
    }
  }

  ${(0, $cd053842fd66588d$export$27f4fb65edc908d0)}
  ${(0, $cd053842fd66588d$export$5b2a5373659a0414)}
`;

});

parcelRegister("7P4vu", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $583dacb5a6b553e9$export$3ceb62baab058c6b);

var $6s1PB = parcelRequire("6s1PB");

var $egekd = parcelRequire("egekd");
const $583dacb5a6b553e9$export$3ceb62baab058c6b = (data)=>{
    return {
        overviewItems: {
            doneThisWeek: data.jira.doneThisWeek?.totalCount ?? 0,
            updatedThisWeek: data.jira.updatedThisWeek?.totalCount ?? 0,
            createdThisWeek: data.jira.createdThisWeek?.totalCount ?? 0,
            dueThisWeek: data.jira.dueThisWeek?.totalCount ?? 0
        },
        issuesByStatus: // eslint-disable-next-line @typescript-eslint/no-explicit-any
        data.issuesByStatus?.nodes.map((node)=>({
                id: node.id,
                count: node.totalCount,
                status: {
                    name: node.field.name,
                    statusId: node.field.statusId,
                    jqlTerm: data.jira.jqlBuilder?.status.edges.find((status)=>status.node.displayName === node.field.name)?.node.jqlTerm,
                    category: {
                        key: node.field.category.key
                    }
                }
            })) ?? null,
        issuesByPriority: // eslint-disable-next-line @typescript-eslint/no-explicit-any
        data.issuesByPriority?.nodes.map((node)=>{
            const priorityJqlTerm = data.jira.jqlBuilder?.priority?.edges.find((priority)=>priority.node?.displayName === node.field.name)?.node?.jqlTerm;
            return {
                id: node.id,
                count: node.totalCount,
                priority: {
                    name: node.field.name,
                    iconUrl: node.field.iconUrl,
                    jqlTerm: priorityJqlTerm
                }
            };
        }) ?? null,
        issuesByAssignee: data.issuesByAssignee ? {
            ...(0, $egekd.transformIssuesByAssigneeData)(data.issuesByAssignee),
            totalUnresolvedIssues: data.jira.totalUnresolvedIssues?.totalCount ?? 0
        } : null,
        issuesByType: data.issuesByType ? {
            ...(0, $egekd.transformIssuesByTypeData)(data.issuesByType),
            totalUnresolvedIssues: data.jira.totalUnresolvedIssues?.totalCount ?? 0
        } : null,
        workflowsCount: (0, $6s1PB.expVal)('jwm-summary-page-migration', 'isEnabled', false) ? undefined : data?.workflowsCount?.totalCount ?? null
    };
};

});
parcelRegister("egekd", function(module, exports) {

$parcel$export(module.exports, "transformIssuesByAssigneeData", () => $0d59c4e7b34bf6f1$export$cef1c6c4edf3287b);
$parcel$export(module.exports, "transformIssuesByTypeData", () => $0d59c4e7b34bf6f1$export$bc7f7d59cba70a26);
const $0d59c4e7b34bf6f1$export$cef1c6c4edf3287b = (data)=>({
        pageInfo: {
            hasNextPage: data.pageInfo.hasNextPage,
            endCursor: data.pageInfo.endCursor
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        data: data.nodes.map((node)=>({
                id: node.id,
                user: node.field.userValue ? {
                    avatarUrl: node.field.userValue.avatarUrl ?? '',
                    displayName: node.field.userValue.displayName,
                    accountId: node.field.userValue.accountId
                } : null,
                count: node.totalCount
            }))
    });
const $0d59c4e7b34bf6f1$export$bc7f7d59cba70a26 = (data)=>({
        pageInfo: {
            hasNextPage: data.pageInfo.hasNextPage,
            endCursor: data.pageInfo.endCursor
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        data: data.nodes.map((node)=>({
                id: node.id,
                issueType: node.field ? {
                    iconUrl: node.field.iconUrl,
                    name: node.field.name,
                    id: node.field.id
                } : null,
                count: node.totalCount
            }))
    });

});




parcelRegister("f1r4M", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessSummaryEmbedRoute", () => $75bf41a31996f0a6$export$d4aa7e677d381961);
const $75bf41a31996f0a6$export$d4aa7e677d381961 = {
    name: 'classic-business-summary-embed',
    path: '/jira/core/projects/:projectKey/summary/embed',
    exact: true
};

});

parcelRegister("eASai", function(module, exports) {

$parcel$export(module.exports, "summaryEmbedEntrypoint", () => $99cc4adc5066587d$export$5a118ab60ce38554);

var $gIFn8 = parcelRequire("gIFn8");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $99cc4adc5066587d$export$5a118ab60ce38554 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("3eVaH")), {
        moduleId: "936313f5"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                summaryEmbedQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $gIFn8.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("gIFn8", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a7b94e3ffb3bd2f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1a20b087016d45df0229b06077572278>>
 * @relayHash 3820c91496cd6ed2417544137170dd18
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9c794c308a61b48d1203cad5842636c8f860239cf229202638ed7468403107c2
const $6a7b94e3ffb3bd2f$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "9c794c308a61b48d1203cad5842636c8f860239cf229202638ed7468403107c2",
        "metadata": {},
        "name": "src_jiraBusinessSummaryEmbedQuery",
        "operationKind": "query",
        "text": null
    }
};
var $6a7b94e3ffb3bd2f$export$2e2bcd8739ae039 = $6a7b94e3ffb3bd2f$var$node;

});

parcelRegister("3eVaH", function(module, exports) {

let $25bf06ff15a4cf4c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $25bf06ff15a4cf4c$var$load("ffQaD"),
    $25bf06ff15a4cf4c$var$load("kvRbA"),
    $25bf06ff15a4cf4c$var$load("75kUW")
]).then(()=>parcelRequire('kB5po'));

});


parcelRegister("7yKXN", function(module, exports) {

$parcel$export(module.exports, "summaryBusinessEmbedEntrypoint", () => $2cd94e1a653bd86e$export$a027511631595373);

var $3N2oG = parcelRequire("3N2oG");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $2cd94e1a653bd86e$export$a027511631595373 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("dqWTR")), {
        moduleId: "bfeee3c2"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                summaryQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $3N2oG.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("3N2oG", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dea5c0730559df4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2161716a6a9ddd596df65d397a277cb5>>
 * @relayHash 4f557a85d513d521d9088e7217fed3ad
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 15dd5fffb84db9cd2e32bf1439d87098cf295ac5f7e1bcaae80f031fdad2d763
const $9dea5c0730559df4$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "15dd5fffb84db9cd2e32bf1439d87098cf295ac5f7e1bcaae80f031fdad2d763",
        "metadata": {},
        "name": "src_jiraSummaryBusinessEmbedQuery",
        "operationKind": "query",
        "text": null
    }
};
var $9dea5c0730559df4$export$2e2bcd8739ae039 = $9dea5c0730559df4$var$node;

});

parcelRegister("dqWTR", function(module, exports) {

let $9c7b645f17b67811$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9c7b645f17b67811$var$load("fliVL"),
    $9c7b645f17b67811$var$load("67ZGv")
]).then(()=>parcelRequire('7biA2'));

});



parcelRegister("2IdR0", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessSummaryRouteEntry", () => $388a84b6edfc3b2f$export$66365c0c5e8430d2);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lkFvK = parcelRequire("lkFvK");

var $6s1PB = parcelRequire("6s1PB");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $kqhaB = parcelRequire("kqhaB");

var $3zj3N = parcelRequire("3zj3N");

var $3x7be = parcelRequire("3x7be");

var $7QgtY = parcelRequire("7QgtY");

var $3RnWB = parcelRequire("3RnWB");

var $fo6b8 = parcelRequire("fo6b8");

var $4R6GH = parcelRequire("4R6GH");
/**
 * @deprecated delete this entrypoint when cleaning up jwm-summary-page-migration experiment flag
 */ const $388a84b6edfc3b2f$var$summaryPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7QgtY.summaryEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $388a84b6edfc3b2f$var$summaryBusinessPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $3RnWB.summaryBusinessEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $388a84b6edfc3b2f$var$getSummaryPageResource = ()=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jwm-summary-page-migration');
    const jwmSummaryPageMigrationEnabled = expConfig.get('isEnabled', false);
    return [
        ...jwmSummaryPageMigrationEnabled && (0, $4R6GH.fg)('helios_biz_project_remove_rrr') ? [] : [
            (0, $3zj3N.summaryDataResource)
        ],
        ...jwmSummaryPageMigrationEnabled && (0, $4R6GH.fg)('helios_biz_project_fast_activity_feed') ? [] : [
            (0, $kqhaB.activityFeedResource)
        ]
    ];
};
const $388a84b6edfc3b2f$export$66365c0c5e8430d2 = (0, $7NszV.createEntry)((0, $3x7be.jiraBusinessSummaryRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.summary-view',
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $lNicp.getProjectViewResources)(),
            ...$388a84b6edfc3b2f$var$getSummaryPageResource()
        ],
        entryPoint: ()=>{
            if ((0, $6s1PB.expVal)('jwm-summary-page-migration', 'isEnabled', false)) return $388a84b6edfc3b2f$var$summaryBusinessPageEntrypoint;
            return $388a84b6edfc3b2f$var$summaryPageEntrypoint;
        }
    }));

});
parcelRegister("3x7be", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessSummaryRoute", () => $da1a77dee609f26a$export$ad0ce411d14c71d7);
const $da1a77dee609f26a$export$ad0ce411d14c71d7 = {
    name: 'classic-business-summary',
    path: '/jira/core/projects/:projectKey/summary',
    exact: true
};

});

parcelRegister("7QgtY", function(module, exports) {

$parcel$export(module.exports, "summaryEntrypoint", () => $e408b66321f42c9a$export$3d50a9cba1287544);

var $5o8fa = parcelRequire("5o8fa");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $e408b66321f42c9a$export$3d50a9cba1287544 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("cELt9")), {
        moduleId: "75fba772"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                summaryQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $5o8fa.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("5o8fa", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e3b5ebe8bc3ce2b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b98870a9a14cc3127b27958d6372112f>>
 * @relayHash c3f96584d95baf5fcb618835c22e3826
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2313ad2fdb6e791eef71a3a51657d606a68b9c66e72b580fa0b63e9475ba0787
const $8e3b5ebe8bc3ce2b$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "2313ad2fdb6e791eef71a3a51657d606a68b9c66e72b580fa0b63e9475ba0787",
        "metadata": {},
        "name": "src_jiraBusinessSummaryQuery",
        "operationKind": "query",
        "text": null
    }
};
var $8e3b5ebe8bc3ce2b$export$2e2bcd8739ae039 = $8e3b5ebe8bc3ce2b$var$node;

});

parcelRegister("cELt9", function(module, exports) {

let $936e0ad8578baa23$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $936e0ad8578baa23$var$load("ffQaD"),
    $936e0ad8578baa23$var$load("kvRbA"),
    $936e0ad8578baa23$var$load("abwKD")
]).then(()=>parcelRequire('j5uWP'));

});


parcelRegister("3RnWB", function(module, exports) {

$parcel$export(module.exports, "summaryBusinessEntrypoint", () => $52c89b30c31bd0d6$export$1655de4ea7d4bb73);

var $ixLIQ = parcelRequire("ixLIQ");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $52c89b30c31bd0d6$export$1655de4ea7d4bb73 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("kGncv")), {
        moduleId: "e788cf2e"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                summaryQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $ixLIQ.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("ixLIQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $27bcdcea8e0fdaf7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e999f38de92db02cb900ff3e39b1c9b5>>
 * @relayHash e1db5ab6de3c01b21716a8934a36cc9b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0b047866626fc08071e5717fa8caf4a6c7867aefae410e0168cbc01019589055
const $27bcdcea8e0fdaf7$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "0b047866626fc08071e5717fa8caf4a6c7867aefae410e0168cbc01019589055",
        "metadata": {},
        "name": "src_jiraSummaryBusinessQuery",
        "operationKind": "query",
        "text": null
    }
};
var $27bcdcea8e0fdaf7$export$2e2bcd8739ae039 = $27bcdcea8e0fdaf7$var$node;

});

parcelRegister("kGncv", function(module, exports) {

let $f0e9ba0d9702f528$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f0e9ba0d9702f528$var$load("fliVL"),
    $f0e9ba0d9702f528$var$load("8MzXB")
]).then(()=>parcelRequire('eGmqi'));

});



parcelRegister("cZPPs", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessTimelineEmbedRouteEntry", () => $1c46fc585f965612$export$ef65a62ced1a9df1);

var $6e4Kt = parcelRequire("6e4Kt");

var $lkFvK = parcelRequire("lkFvK");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $1kHS4 = parcelRequire("1kHS4");

var $2vlnX = parcelRequire("2vlnX");

var $1FhoW = parcelRequire("1FhoW");
const $1c46fc585f965612$var$timelineEmbedPageEntrypoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $1FhoW.timelineEntrypoint)
});
const $1c46fc585f965612$var$legacyimelineEmbedPageEntrypoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $2vlnX.timelineEmbedEntrypoint)
});
const $1c46fc585f965612$export$ef65a62ced1a9df1 = (0, $7NszV.createEntry)((0, $1kHS4.jiraBusinessTimelineEmbedRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.timeline-embed-view',
        layout: (0, $6e4Kt.chromelessLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        resources: (0, $lNicp.getProjectViewResources)(),
        entryPoint: ()=>/**
			 * IMPORTANT - we can't use `isJiraTimelineHarmonisationM1Enabled`
			 * here, as static route generation needs us to use `expValEquals`
			 * and `fg` directly. Any changes to this logic must be duplicated
			 * in `@atlassian/jira-business-timeline-rollout`
			 */ // eslint-disable-next-line jira/ff/no-preconditioning
            (0, $4R6GH.fg)('refactor_nin_to_jira_view_schema') && (0, $6s1PB.expValEquals)('jira_timeline_harmonisation_m1', 'isEnabled', true) ? $1c46fc585f965612$var$timelineEmbedPageEntrypoint : $1c46fc585f965612$var$legacyimelineEmbedPageEntrypoint
    }));

});
parcelRegister("1kHS4", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessTimelineEmbedRoute", () => $12b838a84c0952a0$export$d85fbccfa0ba559a);
const $12b838a84c0952a0$export$d85fbccfa0ba559a = {
    name: 'classic-business-timeline-embed',
    path: '/jira/core/projects/:projectKey/timeline/embed',
    exact: true
};

});

parcelRegister("2vlnX", function(module, exports) {

$parcel$export(module.exports, "timelineEmbedEntrypoint", () => $94157aa0ce3558d4$export$12a9d017aa53985f);

var $6orcY = parcelRequire("6orcY");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $94157aa0ce3558d4$export$12a9d017aa53985f = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("6LJkC")), {
        moduleId: "88bc99ab"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                timelineEmbedQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $6orcY.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("6orcY", function(module, exports) {

$parcel$export(module.exports, "default", () => $c96eaccedf3004ad$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c25e21ec05fd2b676e0b39f50f317308>>
 * @relayHash aaa779177ef49e606102f9e257279c2f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 52e90730f9edc63b8e9c272f467903f50d287b068a5e9571a6fd34719bb2539c
const $c96eaccedf3004ad$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "52e90730f9edc63b8e9c272f467903f50d287b068a5e9571a6fd34719bb2539c",
        "metadata": {},
        "name": "src_jiraBusinessTimelineEmbedQuery",
        "operationKind": "query",
        "text": null
    }
};
var $c96eaccedf3004ad$export$2e2bcd8739ae039 = $c96eaccedf3004ad$var$node;

});

parcelRegister("6LJkC", function(module, exports) {

let $4eda4bc353bb27bd$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $4eda4bc353bb27bd$var$load("ffQaD"),
    $4eda4bc353bb27bd$var$load("kvRbA"),
    $4eda4bc353bb27bd$var$load("egDkZ")
]).then(()=>parcelRequire('fm6i9'));

});


parcelRegister("1FhoW", function(module, exports) {

$parcel$export(module.exports, "timelineEntrypoint", () => $081fe9ef67594c5f$export$7586afa83216512a);

var $4R6GH = parcelRequire("4R6GH");

var $b8ALi = parcelRequire("b8ALi");

var $esiIm = parcelRequire("esiIm");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");
const $081fe9ef67594c5f$var$and = (clauses)=>{
    return clauses.map((clause)=>clause.trim()).filter((clause)=>clause.length > 0).join(' AND ');
};
const $081fe9ef67594c5f$var$getProjectJql = (projectKey)=>projectKey.length > 0 ? `project = '${projectKey}'` : '';
const $081fe9ef67594c5f$var$getSearchTextJql = (text)=>{
    if (text === undefined || text.trim() === '') return '';
    const sanitize = (value)=>value.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/\t/g, ' ');
    const issueKeyRegex = new RegExp('^([A-Z][A-Z0-9_]+-\\d+)$');
    const japaneseAndChineseRegex = /[\p{Script_Extensions=Hiragana}\p{Script_Extensions=Katakana}\p{Script_Extensions=Han}]/u;
    let search = sanitize(text);
    if (issueKeyRegex.test(text)) return `(summary ~ '${search}*' OR description ~ '${search}*' OR key = '${search}')`;
    // if the text does not contain Chinese or Japanese characters (which are not tokenized),
    // and does not end with a space character
    // make it a wildcard search
    if (!japaneseAndChineseRegex.test(text) && !text.endsWith(' ')) search = `${search}*`;
    return `(summary ~ '${search}' OR description ~ '${search}')`;
};
const $081fe9ef67594c5f$var$buildIssuesSearchInput = (filter = '', text = '', projectKey = '')=>{
    const search = $081fe9ef67594c5f$var$getSearchTextJql(text);
    const project = $081fe9ef67594c5f$var$getProjectJql(projectKey);
    return {
        jql: $081fe9ef67594c5f$var$and([
            search,
            filter,
            project
        ])
    };
};
// should be equivalent to the getToday function in jira/src/packages/software/roadmap/utils/src/utils/dates.tsx
const $081fe9ef67594c5f$var$getToday = ()=>{
    const now = new Date();
    const date = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0));
    return date.valueOf();
};

const $081fe9ef67594c5f$export$7586afa83216512a = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("iPRxy")), {
        moduleId: "ea9f2eb3"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const namespace = (0, $4R6GH.fg)('add_timeline_namespace_in_issue_search') ? 'TIMELINE' : 'ISSUE_NAVIGATOR';
        const projectKey = context.match.params.projectKey;
        const { filter: filter, text: text } = context.query;
        if (projectKey == null) throw new Error('Project key missing');
        const fieldSetIds = [
            'issuetype',
            'issuekey',
            'summary',
            'Start date[Date]',
            'duedate'
        ];
        return {
            extraProps: {
                today: $081fe9ef67594c5f$var$getToday()
            },
            queries: {
                businessTimelineQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $b8ALi.default),
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                timelineQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $esiIm.default),
                    variables: {
                        amountOfColumns: 500,
                        cloudId: cloudId,
                        fieldSetIds: fieldSetIds,
                        fieldSetsInput: {
                            fieldSetIds: fieldSetIds
                        },
                        filterId: null,
                        first: 50,
                        issueSearchInput: $081fe9ef67594c5f$var$buildIssuesSearchInput(filter, text, projectKey),
                        namespace: namespace,
                        projectKey: projectKey,
                        shouldQueryFieldSetsById: false,
                        shouldQueryHasChildren: true,
                        staticViewInput: {
                            isGroupingEnabled: false
                        },
                        viewConfigInput: {
                            viewInput: {
                                namespace: namespace
                            }
                        },
                        viewId: 'list_default'
                    }
                }
            }
        };
    }
});

});
parcelRegister("b8ALi", function(module, exports) {

$parcel$export(module.exports, "default", () => $9449fe427e3fdb1b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b44f9761057ed7ea0b277fcdeb998d61>>
 * @relayHash 91af7345571ae29b0bcaa8c35ba4c2fe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 937f60fcad28d0549884b2d0d71ae578315c0f9d27f22e844f8d3bf73d6dcd99
const $9449fe427e3fdb1b$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "937f60fcad28d0549884b2d0d71ae578315c0f9d27f22e844f8d3bf73d6dcd99",
        "metadata": {},
        "name": "src_jiraHarmonisedBusinessTimelineQuery",
        "operationKind": "query",
        "text": null
    }
};
var $9449fe427e3fdb1b$export$2e2bcd8739ae039 = $9449fe427e3fdb1b$var$node;

});

parcelRegister("esiIm", function(module, exports) {

$parcel$export(module.exports, "default", () => $29bb48365820fb9e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2e01c66f982ca968b9f7620acaab16d5>>
 * @relayHash ed0f17d2481ac218fb8430a6b87583fc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 91c0156b3319a4affe36d513d834ec62585b19a1155fd67615d9eecf4e01f4f9

var $fjldt = parcelRequire("fjldt");

var $gY76A = parcelRequire("gY76A");

var $5oQtH = parcelRequire("5oQtH");

var $5ykrX = parcelRequire("5ykrX");

var $ggSVP = parcelRequire("ggSVP");

var $5Bxi4 = parcelRequire("5Bxi4");

var $k3PJZ = parcelRequire("k3PJZ");

var $knfEI = parcelRequire("knfEI");

var $5qm7M = parcelRequire("5qm7M");

var $l8ssf = parcelRequire("l8ssf");

var $dttgK = parcelRequire("dttgK");

var $adKYy = parcelRequire("adKYy");

var $iLxt4 = parcelRequire("iLxt4");

var $hBvdF = parcelRequire("hBvdF");
const $29bb48365820fb9e$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "91c0156b3319a4affe36d513d834ec62585b19a1155fd67615d9eecf4e01f4f9",
        "metadata": {},
        "name": "src_timelineQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $gY76A.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": (0, $k3PJZ.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistcheckissuecreatepermissionsrelayprovider": (0, $5Bxi4.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": (0, $5oQtH.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $dttgK.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $adKYy.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $fjldt.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": (0, $iLxt4.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $l8ssf.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": (0, $5ykrX.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $ggSVP.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $knfEI.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default)
        }
    }
};
var $29bb48365820fb9e$export$2e2bcd8739ae039 = $29bb48365820fb9e$var$node;

});
parcelRegister("fjldt", function(module, exports) {

$parcel$export(module.exports, "default", () => $dad5d6a9d81ef63f$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");
var $dad5d6a9d81ef63f$export$2e2bcd8739ae039 = {
    get () {
        return (0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false);
    }
};

});

parcelRegister("gY76A", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b308b8f84a32bbf$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $5b308b8f84a32bbf$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jira_inline_field_config_gate');
    }
};

});

parcelRegister("5oQtH", function(module, exports) {

$parcel$export(module.exports, "default", () => $63783baa7e252f12$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");
var $63783baa7e252f12$export$2e2bcd8739ae039 = {
    get () {
        return (0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', true);
    }
};

});

parcelRegister("5ykrX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a88313492930423$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $5a88313492930423$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('render_jirawatchesfield_nin');
    }
};

});

parcelRegister("ggSVP", function(module, exports) {

$parcel$export(module.exports, "default", () => $67bb3d8089fa042c$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $67bb3d8089fa042c$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('single_line_row_height_collapsable_fields');
    }
};

});

parcelRegister("5Bxi4", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c80591faf091fb2$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $5c80591faf091fb2$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jira_list_check_issue_create_permissions');
    }
};

});

parcelRegister("k3PJZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3084fb4096ebf03f$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $3084fb4096ebf03f$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jsc_list_reparenting');
    }
};

});

parcelRegister("knfEI", function(module, exports) {

$parcel$export(module.exports, "default", () => $91f4d6b980265dc0$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $91f4d6b980265dc0$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('frontier-currency-field-formatconfig-query');
    }
};

});

parcelRegister("5qm7M", function(module, exports) {

$parcel$export(module.exports, "default", () => $124cec54bee44ed1$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $124cec54bee44ed1$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jsc_inline_editing_field_refactor');
    }
};

});

parcelRegister("l8ssf", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6503957c800342c$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $e6503957c800342c$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jsc_inline_editing_flag_fix');
    }
};

});

parcelRegister("dttgK", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7b98ab24c97dab4$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
const $c7b98ab24c97dab4$var$JscM2FeChangesRelayProvider = {
    get () {
        return (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes');
    }
};
var $c7b98ab24c97dab4$export$2e2bcd8739ae039 = $c7b98ab24c97dab4$var$JscM2FeChangesRelayProvider;

});

parcelRegister("adKYy", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff52f025ed33d5fc$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
const $ff52f025ed33d5fc$var$JscMergedColumnRelayProvider = {
    get () {
        return (0, $4R6GH.fg)('jira_list_merged_column_gate');
    }
};
var $ff52f025ed33d5fc$export$2e2bcd8739ae039 = $ff52f025ed33d5fc$var$JscMergedColumnRelayProvider;

});

parcelRegister("iLxt4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c35fdb8bdb84235d$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
const $c35fdb8bdb84235d$var$NinMultiGroupPickerCellRelayProvider = {
    get () {
        return (0, $4R6GH.fg)('nin_multi_group_picker_cell');
    }
};
var $c35fdb8bdb84235d$export$2e2bcd8739ae039 = $c35fdb8bdb84235d$var$NinMultiGroupPickerCellRelayProvider;

});

parcelRegister("hBvdF", function(module, exports) {

$parcel$export(module.exports, "default", () => $5de224b7b5e8adbe$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $5de224b7b5e8adbe$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('thor_colourful_single_select_milestone2_gate');
    }
};

});


parcelRegister("iPRxy", function(module, exports) {

let $db66855e55904c2f$var$load = (parcelRequire("28QjX"))(4);


module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $db66855e55904c2f$var$load("czifk"),
            $db66855e55904c2f$var$load("kvRbA"),
            $db66855e55904c2f$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $db66855e55904c2f$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $db66855e55904c2f$var$load("cTJTG"),
            $db66855e55904c2f$var$load("l253H"),
            $db66855e55904c2f$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $db66855e55904c2f$var$load("4Qxp7")
        ]);
    }),
    $db66855e55904c2f$var$load("kNFvF"),
    $db66855e55904c2f$var$load("ffQaD"),
    $db66855e55904c2f$var$load("kvRbA"),
    $db66855e55904c2f$var$load("fliVL"),
    $db66855e55904c2f$var$load("9F52l")
]).then(()=>parcelRequire('izPvq'));

});



parcelRegister("frUin", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessTimelineRouteEntry", () => $a1408a3d6b1a5eeb$export$5725375da49b5772);

var $5f2bR = parcelRequire("5f2bR");

var $lRPBw = parcelRequire("lRPBw");

var $lkFvK = parcelRequire("lkFvK");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $aVFIE = parcelRequire("aVFIE");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $54kZi = parcelRequire("54kZi");

var $bOakJ = parcelRequire("bOakJ");

var $1FhoW = parcelRequire("1FhoW");

var $fo6b8 = parcelRequire("fo6b8");
const $a1408a3d6b1a5eeb$var$timelinePageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1FhoW.timelineEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $a1408a3d6b1a5eeb$var$legacyTimelinePageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $bOakJ.timelineEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $a1408a3d6b1a5eeb$export$5725375da49b5772 = (0, $7NszV.createEntry)((0, $54kZi.jiraBusinessTimelineRoute), ()=>({
        group: 'classic-business',
        ufoName: 'jwm.timeline-view',
        layout: (0, $lRPBw.businessProjectLayout),
        skeleton: (0, $aVFIE.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: (0, $lNicp.getProjectViewResources)(),
        entryPoint: ()=>/**
		 * IMPORTANT - we can't use `isJiraTimelineHarmonisationM1Enabled`
		 * here, as static route generation needs us to use `expValEquals`
		 * and `fg` directly. Any changes to this logic must be duplicated
		 * in `@atlassian/jira-business-timeline-rollout`
		 */ // eslint-disable-next-line jira/ff/no-preconditioning
            (0, $4R6GH.fg)('refactor_nin_to_jira_view_schema') && (0, $6s1PB.expValEquals)('jira_timeline_harmonisation_m1', 'isEnabled', true) ? $a1408a3d6b1a5eeb$var$timelinePageEntrypoint : $a1408a3d6b1a5eeb$var$legacyTimelinePageEntrypoint
    }));

});
parcelRegister("54kZi", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessTimelineRoute", () => $d72294ad8bab4281$export$4c71cfbf61bf0bf3);
const $d72294ad8bab4281$export$4c71cfbf61bf0bf3 = {
    name: 'classic-business-timeline',
    path: '/jira/core/projects/:projectKey/timeline',
    exact: true
};

});

parcelRegister("bOakJ", function(module, exports) {

$parcel$export(module.exports, "timelineEntrypoint", () => $49d4c306324fda15$export$7586afa83216512a);

var $6T238 = parcelRequire("6T238");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $49d4c306324fda15$export$7586afa83216512a = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("jA2oL")), {
        moduleId: "cac371d1"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                timelineQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $6T238.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("6T238", function(module, exports) {

$parcel$export(module.exports, "default", () => $5232f385be868c01$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ec0d5db49437667573ca835bd84e9756>>
 * @relayHash 841436c7487840af84c959f83e5a4493
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4443dbc3773e515f952da0ae8f171c483657c4548c4768b6b9c144da0822a4f1
const $5232f385be868c01$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "4443dbc3773e515f952da0ae8f171c483657c4548c4768b6b9c144da0822a4f1",
        "metadata": {},
        "name": "src_jiraBusinessTimelineQuery",
        "operationKind": "query",
        "text": null
    }
};
var $5232f385be868c01$export$2e2bcd8739ae039 = $5232f385be868c01$var$node;

});

parcelRegister("jA2oL", function(module, exports) {

let $e4133d5fd3df4359$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e4133d5fd3df4359$var$load("ffQaD"),
    $e4133d5fd3df4359$var$load("kvRbA"),
    $e4133d5fd3df4359$var$load("aZ962")
]).then(()=>parcelRequire('2sFVY'));

});



parcelRegister("difFp", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsDataClassificationsRouteEntry", () => $72c99d901431c503$export$5b0670f37204a43d);

var $ffza4 = parcelRequire("ffza4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $cSUZZ = parcelRequire("cSUZZ");

var $7GnDe = parcelRequire("7GnDe");

var $gADc2 = parcelRequire("gADc2");

var $5H2aw = parcelRequire("5H2aw");
const $72c99d901431c503$export$5b0670f37204a43d = (0, $7NszV.createEntry)((0, $gADc2.classicProjectSettingsDataClassificationsRoute), ()=>({
        group: 'project-settings-classic',
        component: (0, $5H2aw.default),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5H2aw.LazyDataClassificationsSettings)
        ]
    }));

});
parcelRegister("gADc2", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsDataClassificationsRoute", () => $fa8df43e7f1ddeea$export$952eefa1907e877a);
const $fa8df43e7f1ddeea$export$952eefa1907e877a = {
    name: 'project-settings-classic-data-classifications',
    path: '/plugins/servlet/project-config/:projectKey/data-classifications',
    exact: true
};

});

parcelRegister("5H2aw", function(module, exports) {

$parcel$export(module.exports, "LazyDataClassificationsSettings", () => $b4450c735413409b$export$b8abcf8aa8f4df56);
$parcel$export(module.exports, "default", () => $b4450c735413409b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $b4450c735413409b$export$b8abcf8aa8f4df56 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("foQoc"))), {
    moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b4450c735413409b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $b4450c735413409b$export$b8abcf8aa8f4df56,
        pageId: "project-settings-data-classifications",
        shouldShowSpinner: false
    });

});
parcelRegister("foQoc", function(module, exports) {

let $b361bc58347a5ac8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b361bc58347a5ac8$var$load("iOlJ7").then(()=>parcelRequire('9iqsx'));

});



parcelRegister("dH2Tp", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsIssueLayoutRouteEntry", () => $72a8f02a914333fc$export$47b3bdf88a7d176b);

var $ffza4 = parcelRequire("ffza4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $cSUZZ = parcelRequire("cSUZZ");

var $58ViO = parcelRequire("58ViO");

var $33syc = parcelRequire("33syc");
const $72a8f02a914333fc$export$47b3bdf88a7d176b = (0, $7NszV.createEntry)((0, $58ViO.classicProjectSettingsIssueLayoutRoute), ()=>({
        group: 'project-settings-classic',
        ufoName: 'project-settings.issue-type.jsw-cmp',
        component: (0, $33syc.default),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $33syc.LazyIssueTypeSettings)
        ]
    }));

});
parcelRegister("58ViO", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsIssueLayoutRoute", () => $3beddbd9a85d45eb$export$c593179674352d0);
const $3beddbd9a85d45eb$export$c593179674352d0 = {
    name: 'project-settings-classic-issue-layout',
    path: '/plugins/servlet/project-config/:projectKey/issuelayout',
    query: [
        'screenId'
    ],
    exact: true
};

});

parcelRegister("33syc", function(module, exports) {

$parcel$export(module.exports, "LazyIssueTypeSettings", () => $f7c23974aa64ecd2$export$36dcfb52d47cb93a);
$parcel$export(module.exports, "default", () => $f7c23974aa64ecd2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $f7c23974aa64ecd2$export$36dcfb52d47cb93a = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("7a4qW"))), {
    moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f7c23974aa64ecd2$export$2e2bcd8739ae039 = ({ match: match })=>{
    const { issueTypeId: issueTypeId } = match.params;
    // unique pageId need to be set so that ApdexProvider would properly reset all the performance marks when switching between issue types
    const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f7c23974aa64ecd2$export$36dcfb52d47cb93a,
        pageId: pageId,
        shouldShowSpinner: false
    });
};

});
parcelRegister("7a4qW", function(module, exports) {

let $536ce7f60faeaae5$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $536ce7f60faeaae5$var$load("ffQaD"),
    $536ce7f60faeaae5$var$load("kvRbA"),
    $536ce7f60faeaae5$var$load("cA99w")
]).then(()=>parcelRequire('8SAZe'));

});



parcelRegister("6xRe5", function(module, exports) {

$parcel$export(module.exports, "compassProductSettingsRouteEntry", () => $8b91974ef292d61a$export$703b5090da478c9c);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $bTLzO = parcelRequire("bTLzO");

var $3RJkv = parcelRequire("3RJkv");

var $2g9Jq = parcelRequire("2g9Jq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $8b91974ef292d61a$var$LazyCompassProductSettingsPage = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("gQ7zj"))), {
    moduleId: "./src/packages/spa-apps/compass-product-settings/src/index.tsx"
});
const $8b91974ef292d61a$var$CompassProductSettingsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8b91974ef292d61a$var$LazyCompassProductSettingsPage,
        pageId: "async-compass-product-settings",
        shouldShowSpinner: true
    });
const $8b91974ef292d61a$export$703b5090da478c9c = (0, $7NszV.createEntry)((0, $2g9Jq.compassProductSettingsRoute), ()=>({
        group: 'global-settings',
        component: $8b91974ef292d61a$var$CompassProductSettingsComponent,
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $bTLzO.compassProductSettingsResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $8b91974ef292d61a$var$LazyCompassProductSettingsPage
        ]
    }));

});
parcelRegister("bTLzO", function(module, exports) {

$parcel$export(module.exports, "compassProductSettingsResource", () => $cfea6057f91373db$export$d18ff068d6c25455);
$parcel$export(module.exports, "useCompassProductSettingsResource", () => $cfea6057f91373db$export$6cbcbd11d26ae36f);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

const $cfea6057f91373db$export$d18ff068d6c25455 = (0, $2M1hQ.createResource)({
    type: (0, $0e2163be65099f64$export$6f0555de4f60e84e),
    getKey: ()=>'state',
    getData: async ()=>{
        try {
            const isCompassEnabledForNewProjects = await (0, $eusud.performGetRequest)(`/rest/api/3/application-properties?key=${(0, $0e2163be65099f64$export$5685d70c20140008)}`).then(({ value: value })=>value.toLowerCase().trim() === 'true');
            return {
                isCompassEnabledForNewProjects: isCompassEnabledForNewProjects
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error?.statusCode === 404) return {
                isCompassEnabledForNewProjects: true
            };
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'compassProductSettingsResource',
                    packageName: 'jiraRouterResourcesCompassProductSettings',
                    teamName: 'compass-lodestone'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
});
const $cfea6057f91373db$export$6cbcbd11d26ae36f = ()=>(0, $2YP9W.useResource)($cfea6057f91373db$export$d18ff068d6c25455);

});
const $0e2163be65099f64$export$6f0555de4f60e84e = 'RESOURCE_TYPE_COMPASS_PRODUCT_SETTINGS';
const $0e2163be65099f64$export$5685d70c20140008 = 'jira.admin.compass.is-enabled-for-new-project';


parcelRegister("2g9Jq", function(module, exports) {

$parcel$export(module.exports, "compassProductSettingsRoute", () => $b5f6af89eb99da17$export$48d633ce1d0d2a0e);
const $b5f6af89eb99da17$export$48d633ce1d0d2a0e = {
    name: 'compass-product-settings',
    path: '/jira/settings/products/compass',
    exact: true
};

});

parcelRegister("gQ7zj", function(module, exports) {

let $c4275fa1fd7d56b9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c4275fa1fd7d56b9$var$load("4kBZR").then(()=>parcelRequire('lIMc4'));

});


parcelRegister("5eLaE", function(module, exports) {

$parcel$export(module.exports, "connectGeneralInvalidRouteEntry", () => $eea4a938c8d518ff$export$d8088cb4e7cc7efd);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $evs4R = parcelRequire("evs4R");

var $cYYI7 = parcelRequire("cYYI7");

var $3wwwB = parcelRequire("3wwwB");
const $eea4a938c8d518ff$export$d8088cb4e7cc7efd = (0, $7NszV.createEntry)((0, $evs4R.connectGeneralInvalidRoute), ()=>({
        group: 'connect',
        layout: (0, $aPfsS.createLayout)(),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).ADDONS,
            sidebar: (0, $hBv66.genericConnectSidebars)
        },
        component: (0, $3wwwB.default),
        resources: (0, $cYYI7.getGeneralConnectRouteResources)(),
        canTransitionIn: (current, next)=>{
            const { query: query } = next.match;
            // must be in sync with com.atlassian.jira.web.filters.frontend.ConnectGeneralPagesFrontendRoute::matchesRequest
            // block transitions to mobile version
            if (query.mobile === 'true' || query.includeWebResources === 'true' || query.classifier === 'json') return false;
            // block transitions to marketplace app as it requires specialised Connect API -
            const emceeKeyRegex = /com\.atlassian\.(jira|confluence)\.emcee($|\.local|\.staging|\.development\..*)/g;
            const addonKey = next.match.params.addonKey || '';
            if (emceeKeyRegex.test(addonKey)) return false;
            return true;
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3wwwB.LazyGeneralConnect)
        ],
        ufoName: 'jira-connect'
    }));

});
parcelRegister("evs4R", function(module, exports) {

$parcel$export(module.exports, "connectGeneralInvalidRoute", () => $178b17cd972d15af$export$486ffffd0a2797a5);

var $3Ra5L = parcelRequire("3Ra5L");
const $178b17cd972d15af$export$486ffffd0a2797a5 = {
    name: 'connect-general-invalid',
    path: '/plugins/servlet/ac/:addonKey//:moduleKey',
    query: (0, $3Ra5L.CONNECT_GENERAL_QUERY_PARAMS)
};

});
parcelRegister("3Ra5L", function(module, exports) {

$parcel$export(module.exports, "CONNECT_GENERAL_QUERY_PARAMS", () => $0bf6b9f3f002a423$export$2fdb05fdbf78d595);
// must be in sync with com.atlassian.jira.web.filters.frontend.ConnectGeneralPagesFrontendRoute::matchesRequest
const $0bf6b9f3f002a423$export$2fdb05fdbf78d595 = [
    'mobile?!=true',
    'includeWebResources?!=true',
    'classifier?!=json',
    'project.key?',
    'project.id?'
];

});


parcelRegister("cYYI7", function(module, exports) {

$parcel$export(module.exports, "getGeneralConnectRouteResources", () => $7a1fe7edd9b898b4$export$2c86c2f79b80cf77);
$parcel$export(module.exports, "getProjectConnectRouteDefaultResources", () => $7a1fe7edd9b898b4$export$4c06110e7d14ab3c);

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $lNicp = parcelRequire("lNicp");

var $hz6Yb = parcelRequire("hz6Yb");

var $9UABi = parcelRequire("9UABi");

var $bHhiy = parcelRequire("bHhiy");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");
const $7a1fe7edd9b898b4$export$2c86c2f79b80cf77 = ()=>[
        ...(0, $lNicp.getBusinessProjectResources)(),
        ...(0, $3RJkv.getNavigationResources)(),
        (0, $atU1t.navigationSidebarGlobalResource),
        ...(0, $5bkvv.getNavigationSidebarGlobalSettingsResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $7GnDe.incidentExperimentTraitResource),
        (0, $dxCvy.projectContextResource),
        (0, $5bkvv.forgeProjectModuleResource),
        (0, $iEUaw.staticSidebarShortcutsResource),
        (0, $ggg5j.staticProjectSidebarNavigationResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
        (0, $hz6Yb.connectGeneralResources),
        (0, $bHhiy.getConsolidationStateResource)()
    ];
const $7a1fe7edd9b898b4$export$4c06110e7d14ab3c = ()=>[
        ...(0, $lNicp.getBusinessProjectResources)(),
        ...(0, $3RJkv.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $7GnDe.incidentExperimentTraitResource),
        (0, $dxCvy.projectContextResource),
        (0, $5bkvv.forgeProjectModuleResource),
        (0, $iEUaw.staticSidebarShortcutsResource),
        (0, $ggg5j.staticProjectSidebarNavigationResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
        (0, $9UABi.connectProjectResources)
    ];

});
parcelRegister("9UABi", function(module, exports) {

$parcel$export(module.exports, "connectProjectResources", () => $fce046ce7cfaa8c3$export$7d2d082a4b91a6c7);
// eslint-disable-next-line jira/import-whitelist

var $8Vh1q = parcelRequire("8Vh1q");

var $ggg5j = parcelRequire("ggg5j");

var $2M1hQ = parcelRequire("2M1hQ");


const $fce046ce7cfaa8c3$export$7d2d082a4b91a6c7 = (0, $2M1hQ.createResource)({
    type: (0, $35b0c7feb103121f$export$da32d27651782c3),
    getKey: ({ query: query })=>{
        const { addonKey: addonKey, moduleKey: moduleKey } = (0, $8Vh1q.transformUrlToAddonAndModuleKeys)(query);
        if (addonKey !== '' && moduleKey !== '') return `${addonKey}-${moduleKey}`;
        return 'state';
    },
    depends: [
        (0, $ggg5j.staticProjectSidebarNavigationResource).type
    ],
    getDataLoader: ()=>(parcelRequire("6ahyC"))
});

});
parcelRegister("8Vh1q", function(module, exports) {

$parcel$export(module.exports, "transformResponse", () => $beff5be7f4728df2$export$3361e9be8093ddcc);
$parcel$export(module.exports, "extractContext", () => $beff5be7f4728df2$export$efdbd45f3e77a161);
$parcel$export(module.exports, "transformQueryParams", () => $beff5be7f4728df2$export$9e3c3f47fc3ab3d0);
$parcel$export(module.exports, "transformUrlToAddonAndModuleKeys", () => $beff5be7f4728df2$export$752ef5ab3d7ab15f);

var $2YZCu = parcelRequire("2YZCu");

var $6VnTH = parcelRequire("6VnTH");

var $3HwlS = parcelRequire("3HwlS");

var $bsuuc = parcelRequire("bsuuc");
const $beff5be7f4728df2$export$3361e9be8093ddcc = (response)=>{
    try {
        const productContext = response.productCtx ? JSON.parse(response.productCtx) : {};
        let structuredContext = response.structuredContext ? JSON.parse(response.structuredContext) : {};
        structuredContext = {
            ...structuredContext,
            jira: {
                ...structuredContext.jira,
                horizontalNavigation: (0, $3HwlS.getWillShowNav4)()
            }
        };
        const context = {
            productContext: productContext,
            structuredContext: structuredContext,
            productCtx: productContext
        };
        return {
            ...response,
            ...context,
            isFullPage: response.general === '1',
            user: {
                timeZone: response.timeZone,
                uid: response.uid || undefined,
                ukey: response.ukey || undefined,
                fullName: response.fullName || undefined
            },
            targets: {
                env: {
                    resize: 'both'
                }
            },
            history: {
                state: ''
            },
            autoresize: true,
            ns: response.uniqueKey,
            containerId: `embedded-${response.uniqueKey}`,
            contextPath: response.cp,
            width: response.w || response.width,
            height: response.h || response.height
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const location = 'connect-iframe.transformer';
        (0, $2YZCu.default).safeErrorWithoutCustomerData(location, 'Failed to transform response', error);
        return {
            autoresize: true,
            productCtx: undefined,
            structuredContext: undefined,
            isFullPage: true,
            history: {
                state: ''
            },
            targets: {
                env: {
                    resize: 'both'
                }
            }
        };
    }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $beff5be7f4728df2$var$checkValueAndMapToNewName = (object, oldName, newName)=>{
    const newValue = object !== null && object[oldName] ? String(object[oldName]) : null;
    return newValue !== null ? {
        [newName]: newValue
    } : null;
};
const $beff5be7f4728df2$export$1f8eea5a5a32169f = (contextData)=>{
    const scope = contextData && contextData.scope || null;
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    const project = contextData && contextData.project || null;
    const projectId = $beff5be7f4728df2$var$checkValueAndMapToNewName(project, 'id', 'project.id');
    const projectKey = $beff5be7f4728df2$var$checkValueAndMapToNewName(project, 'key', 'project.key');
    const boardType = $beff5be7f4728df2$var$checkValueAndMapToNewName(scope, 'type', 'board.type');
    const boardId = $beff5be7f4728df2$var$checkValueAndMapToNewName(scope, 'id', 'board.id');
    return {
        ...projectId,
        ...projectKey,
        ...boardType,
        ...boardId
    };
};
const $beff5be7f4728df2$export$efdbd45f3e77a161 = (projectSidebarNavInfo)=>{
    const project = projectSidebarNavInfo && (0, $bsuuc.extractData)(projectSidebarNavInfo) || null;
    const board = projectSidebarNavInfo?.jiraSoftwareNavData && (0, $6VnTH.extractData)(projectSidebarNavInfo.jiraSoftwareNavData) || null;
    const projectId = $beff5be7f4728df2$var$checkValueAndMapToNewName(project, 'id', 'project.id');
    const projectKey = $beff5be7f4728df2$var$checkValueAndMapToNewName(project, 'key', 'project.key');
    const boardType = $beff5be7f4728df2$var$checkValueAndMapToNewName(board, 'type', 'board.type');
    const boardId = $beff5be7f4728df2$var$checkValueAndMapToNewName(board, 'id', 'board.id');
    return {
        ...projectId,
        ...projectKey,
        ...boardType,
        ...boardId
    };
};
const $beff5be7f4728df2$export$9e3c3f47fc3ab3d0 = (contextData, query)=>{
    const context = $beff5be7f4728df2$export$1f8eea5a5a32169f(contextData);
    return {
        ...query,
        ...context
    };
};
const $beff5be7f4728df2$export$752ef5ab3d7ab15f = (query)=>{
    const { selectedItem: selectedItem } = query;
    let addonKey = '';
    let moduleKey = '';
    if (selectedItem) {
        const urlPattern = selectedItem.includes('%3A') ? 'com.atlassian.plugins.atlassian-connect-plugin%3A' : 'com.atlassian.plugins.atlassian-connect-plugin:';
        [addonKey, moduleKey] = selectedItem.replace(urlPattern, '').split('__');
    }
    return {
        addonKey: addonKey,
        moduleKey: moduleKey
    };
};

});
parcelRegister("6VnTH", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $4d73b10ca351bbb3$export$9df5fa0a366163d2);
$parcel$export(module.exports, "extractUserBoard", () => $4d73b10ca351bbb3$export$67db9e2d1b6ed865);
const $4d73b10ca351bbb3$export$9df5fa0a366163d2 = (jiraSoftwareNavData)=>{
    if (jiraSoftwareNavData.boardInfo == null) return null;
    const { boardInfo: { id: id, type: type = 'scrum', name: name } } = jiraSoftwareNavData;
    return {
        id: id,
        type: type,
        name: name,
        isProjectBoard: true
    };
};
const $4d73b10ca351bbb3$export$67db9e2d1b6ed865 = (userBoardNavData)=>{
    const { boardInfo: { id: id, type: type = 'scrum', name: name } } = userBoardNavData;
    return {
        id: id,
        type: type,
        name: name,
        isProjectBoard: false
    };
};

});


const $35b0c7feb103121f$export$da32d27651782c3 = 'CONNECT_PROJECT';

parcelRegister("6ahyC", function(module, exports) {

let $47d14bc51cf614ea$var$load = (parcelRequire("28QjX"))(4);
module.exports = $47d14bc51cf614ea$var$load("gnfQV").then(()=>parcelRequire('4ECv0'));

});



parcelRegister("3wwwB", function(module, exports) {

$parcel$export(module.exports, "LazyGeneralConnect", () => $49a774cbbfe614f4$export$c33275abe6c1e577);
$parcel$export(module.exports, "default", () => $49a774cbbfe614f4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $49a774cbbfe614f4$export$c33275abe6c1e577 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("kMM32"))), {
    moduleId: "./src/packages/spa-apps/jira-connect/general-pages/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$49a774cbbfe614f4$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $49a774cbbfe614f4$export$c33275abe6c1e577,
        pageId: "connect",
        shouldShowSpinner: true
    });

});
parcelRegister("kMM32", function(module, exports) {

let $f21d8fa781f8f20b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f21d8fa781f8f20b$var$load("hHprL").then(()=>parcelRequire('crFp4'));

});



parcelRegister("gnGkU", function(module, exports) {

$parcel$export(module.exports, "connectGeneralRouteEntry", () => $a1bee888763609f4$export$46273ee39bcd958b);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $luBXp = parcelRequire("luBXp");

var $cYYI7 = parcelRequire("cYYI7");

var $3wwwB = parcelRequire("3wwwB");
const $a1bee888763609f4$export$46273ee39bcd958b = (0, $7NszV.createEntry)((0, $luBXp.connectGeneralRoute), ()=>({
        group: 'connect',
        layout: (0, $aPfsS.createLayout)(),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).ADDONS,
            sidebar: (0, $hBv66.genericConnectSidebars)
        },
        component: (0, $3wwwB.default),
        resources: (0, $cYYI7.getGeneralConnectRouteResources)(),
        canTransitionIn: (current, next)=>{
            const { query: query } = next.match;
            // must be in sync with com.atlassian.jira.web.filters.frontend.ConnectGeneralPagesFrontendRoute::matchesRequest
            // block transitions to mobile version
            if (query.mobile === 'true' || query.includeWebResources === 'true' || query.classifier === 'json') return false;
            // block transitions to marketplace app as it requires specialised Connect API -
            const emceeKeyRegex = /com\.atlassian\.(jira|confluence)\.emcee($|\.local|\.staging|\.development\..*)/g;
            const addonKey = next.match.params.addonKey || '';
            if (emceeKeyRegex.test(addonKey)) return false;
            return true;
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3wwwB.LazyGeneralConnect)
        ],
        ufoName: 'jira-connect'
    }));

});
parcelRegister("luBXp", function(module, exports) {

$parcel$export(module.exports, "connectGeneralRoute", () => $1153a77cb71c1b79$export$1fda4850b6314ff0);

var $3Ra5L = parcelRequire("3Ra5L");
const $1153a77cb71c1b79$export$1fda4850b6314ff0 = {
    name: 'connect-general',
    path: '/plugins/servlet/ac/:addonKey/:moduleKey',
    query: (0, $3Ra5L.CONNECT_GENERAL_QUERY_PARAMS)
};

});


parcelRegister("c74Xp", function(module, exports) {

$parcel$export(module.exports, "connectGeneralServiceDeskProjectRouteEntry", () => $70d164d9674a0900$export$487a360459ad1bea);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $fpjJX = parcelRequire("fpjJX");

var $k7Q6G = parcelRequire("k7Q6G");

var $cYYI7 = parcelRequire("cYYI7");

var $3wwwB = parcelRequire("3wwwB");
const $70d164d9674a0900$export$487a360459ad1bea = (0, $7NszV.createEntry)((0, $k7Q6G.connectGeneralServiceDeskProjectRoute), ()=>({
        group: 'connect',
        layout: (0, $aPfsS.createLayout)(),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).ADDONS,
            sidebar: (0, $hBv66.genericConnectSidebars)
        },
        component: (0, $3wwwB.default),
        resources: [
            ...(0, $cYYI7.getGeneralConnectRouteResources)(),
            ...(0, $fpjJX.getServiceDeskNavigationSingleResources)()
        ],
        canTransitionIn: (current, next)=>{
            const { query: query } = next.match;
            // must be in sync with com.atlassian.jira.web.filters.frontend.ConnectGeneralPagesFrontendRoute::matchesRequest
            // block transitions to mobile version
            if (query.mobile === 'true' || query.includeWebResources === 'true' || query.classifier === 'json') return false;
            // block transitions to marketplace app as it requires specialised Connect API -
            const emceeKeyRegex = /com\.atlassian\.(jira|confluence)\.emcee($|\.local|\.staging|\.development\..*)/g;
            const addonKey = next.match.params.addonKey || '';
            if (emceeKeyRegex.test(addonKey)) return false;
            return true;
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3wwwB.LazyGeneralConnect)
        ],
        ufoName: 'jira-connect'
    }));

});
parcelRegister("fpjJX", function(module, exports) {

$parcel$export(module.exports, "getServiceDeskNavigationResources", () => $491f4fde535ee8ab$export$bc0bd65e6da57c1f);
$parcel$export(module.exports, "getServiceDeskNavigationSingleResources", () => $491f4fde535ee8ab$export$41a9145ddbba28e5);
$parcel$export(module.exports, "getServiceDeskSharedNavigationSingleResources", () => $491f4fde535ee8ab$export$2c543d6accc1eb9b);
$parcel$export(module.exports, "getServiceDeskSettingsResources", () => $491f4fde535ee8ab$export$7bb3c4a2f6b127fb);
$parcel$export(module.exports, "getServicedeskPageContextResources", () => $491f4fde535ee8ab$export$a8b852f03a310dc0);
$parcel$export(module.exports, "getQueuesResources", () => $491f4fde535ee8ab$export$70b97995f4d5ef9f);
$parcel$export(module.exports, "getIssueListSsrResource", () => $491f4fde535ee8ab$export$e1016cce62543991);
$parcel$export(module.exports, "getKnowledgeBaseResources", () => $491f4fde535ee8ab$export$ed87d3b71544c4ef);
$parcel$export(module.exports, "getInsightResources", () => $491f4fde535ee8ab$export$9e0cf1fab0581096);
$parcel$export(module.exports, "getQueueConfigResource", () => $491f4fde535ee8ab$export$5f7bcaa978a3e51);
$parcel$export(module.exports, "getQueueViewConfigResource", () => $491f4fde535ee8ab$export$54079077c6768752);

var $c04PQ = parcelRequire("c04PQ");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $5bkvv = parcelRequire("5bkvv");

var $b2pl3 = parcelRequire("b2pl3");

var $gS5PF = parcelRequire("gS5PF");

var $jYeNO = parcelRequire("jYeNO");

var $6zFAI = parcelRequire("6zFAI");

var $gcI3W = parcelRequire("gcI3W");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $3HwlS = parcelRequire("3HwlS");

var $bjZiV = parcelRequire("bjZiV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $8H3A4 = parcelRequire("8H3A4");

var $cAofY = parcelRequire("cAofY");

var $aNLeB = parcelRequire("aNLeB");

var $eUvlM = parcelRequire("eUvlM");

var $lbaDt = parcelRequire("lbaDt");

var $1WlLE = parcelRequire("1WlLE");

var $2Zfed = parcelRequire("2Zfed");

var $2cxgG = parcelRequire("2cxgG");

var $6sNnq = parcelRequire("6sNnq");

var $7GnDe = parcelRequire("7GnDe");

var $gNStA = parcelRequire("gNStA");

var $gRzZD = parcelRequire("gRzZD");

var $6s1PB = parcelRequire("6s1PB");

var $lfnsv = parcelRequire("lfnsv");

var $f5kpo = parcelRequire("f5kpo");

var $f7Y15 = parcelRequire("f7Y15");

var $lJ1FP = parcelRequire("lJ1FP");
const $491f4fde535ee8ab$var$getPriorityGroupsResource = ()=>(0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_flash_priority_group_api_optimisation'), (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('queues-prioritygroups-relay'), (0, $1WlLE.priorityGroupByProjectIdResourceSsr), (0, $1WlLE.priorityGroupByProjectIdResource)), (0, $1WlLE.priorityGroupResource));
const $491f4fde535ee8ab$var$getProjectContextResource = ()=>(0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_flash_priority_group_api_optimisation'), (0, $dxCvy.projectContextResource));
const $491f4fde535ee8ab$var$getQueueSidebarViewAllQueuesResource = ()=>(0, $gNStA.resourceWithCondition2)(()=>!(0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('migrate_queue_sidebar_all_queues_expansion_to_be'), (0, $1WlLE.queueSidebarViewAllQueuesResource));
const $491f4fde535ee8ab$export$bc0bd65e6da57c1f = ()=>[
        ...(0, $3RJkv.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $7GnDe.incidentExperimentTraitResource),
        (0, $dxCvy.projectContextResource),
        (0, $5bkvv.forgeProjectModuleResource),
        (0, $iEUaw.staticSidebarShortcutsResource),
        (0, $ggg5j.staticProjectSidebarNavigationResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...$491f4fde535ee8ab$export$41a9145ddbba28e5()
    ];
const $491f4fde535ee8ab$export$41a9145ddbba28e5 = ()=>[
        // projectContextResource is a dependency to the priorityGroupsResource
        $491f4fde535ee8ab$var$getProjectContextResource(),
        $491f4fde535ee8ab$var$getQueueSidebarViewAllQueuesResource(),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('jsm_queue_nav4_sidebar_queue_selection_new_logic'), (0, $1WlLE.queueNav4SidebarSelectionResource)),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('jsm_queue_nav4_sidebar_queue_selection_new_logic'), (0, $1WlLE.queueSidebarQueuesCategoryStateResource)),
        ...$491f4fde535ee8ab$export$9c1c5e389bd00e56(),
        ...$491f4fde535ee8ab$export$2c543d6accc1eb9b()
    ];
const $491f4fde535ee8ab$var$isNav4ResourcesFixEnabled = ()=>(0, $3HwlS.getWillShowNav4)() && (0, $6s1PB.expVal)('hot-113350-ssr-jsm-project-menu-fix', 'isEnabled', false);
const $491f4fde535ee8ab$export$9c1c5e389bd00e56 = ()=>[
        $491f4fde535ee8ab$var$getPriorityGroupsResource(),
        (0, $6sNnq.featuresResource),
        (0, $gS5PF.staticSidebarJsmReportsResource),
        (0, $gNStA.resourceWithCondition2)($491f4fde535ee8ab$var$isNav4ResourcesFixEnabled, (0, $bHhiy.getConsolidationStateResource)()),
        (0, $gNStA.resourceWithCondition2)($491f4fde535ee8ab$var$isNav4ResourcesFixEnabled, (0, $aNLeB.servicedeskIsItsmProjectResource)),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('fe-move-nav3-selected-queue-fu'), (0, $2Zfed.nav3QueueGroupsStateResource))
    ];
const $491f4fde535ee8ab$export$2c543d6accc1eb9b = ()=>[
        (0, $1WlLE.queuesNavigationItems),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('ssr_nav4_queues_sidebar'), (0, $lbaDt.requiredProjectProperties)),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('ssr_nav4_queues_sidebar'), (0, $lbaDt.requiredFrontendProperties)),
        (0, $5bkvv.forgeServiceDeskQueueModuleResource),
        (0, $b2pl3.staticJSMProjectConnectAddonsNavigationResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource),
        // for Getting Started menu item
        // resourceWithCondition2(isNav4ResourcesFixEnabled, requiredFrontendProperties),
        (0, $gNStA.resourceWithCondition2)($491f4fde535ee8ab$var$isNav4ResourcesFixEnabled, (0, $dxCvy.projectContextResourceWithCache)),
        (0, $gNStA.resourceWithCondition2)($491f4fde535ee8ab$var$isNav4ResourcesFixEnabled, (0, $lbaDt.firstProjectResource))
    ];
const $491f4fde535ee8ab$export$7bb3c4a2f6b127fb = ()=>[
        ...(0, $3RJkv.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $7GnDe.incidentExperimentTraitResource),
        (0, $dxCvy.projectContextResource),
        (0, $5bkvv.forgeProjectModuleResource),
        (0, $iEUaw.staticSidebarShortcutsResource),
        (0, $ggg5j.staticProjectSidebarNavigationResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
        (0, $eUvlM.servicedeskPracticesResource),
        (0, $cAofY.serviceDeskContextResource),
        (0, $8H3A4.serviceDeskAnalyticsContextResource),
        (0, $gNStA.resourceWithCondition2)(()=>!(0, $c04PQ.isFedRamp)(), (0, $2cxgG.virtualAgentOnboardingResource)),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('fix_getting_started_panel_in_settings'), (0, $lbaDt.firstProjectResource))
    ];
const $491f4fde535ee8ab$export$a8b852f03a310dc0 = ()=>[
        (0, $dxCvy.projectContextResourceWithCache),
        (0, $cAofY.serviceDeskContextResource),
        (0, $8H3A4.serviceDeskAnalyticsContextResource)
    ];
const $491f4fde535ee8ab$export$70b97995f4d5ef9f = ()=>[
        ...$491f4fde535ee8ab$export$a8b852f03a310dc0(),
        ...$491f4fde535ee8ab$export$bc0bd65e6da57c1f(),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $co1wz.ff)('automation-templates-team-types-refactor-m1_isj0e'), (0, $eUvlM.servicedeskPracticesResource)),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('corcap-2944-add-jqlbuilder-to-jsm-queues'), (0, $jYeNO.getCalendarFilterFieldsResource)())
    ];
const $491f4fde535ee8ab$export$e1016cce62543991 = ()=>[
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('ssr_view_queues_issuelist'), (0, $1WlLE.issueListSsrResource))
    ];
const $491f4fde535ee8ab$export$ed87d3b71544c4ef = ()=>[
        (0, $bjZiV.kbConfluenceContextResource)
    ];
const $491f4fde535ee8ab$export$9e0cf1fab0581096 = ()=>[
        (0, $gRzZD.workspaceResource)
    ];
const $491f4fde535ee8ab$export$5f7bcaa978a3e51 = ()=>[
        (0, $gNStA.resourceWithCondition2)(()=>!(0, $4R6GH.fg)('jsm-views-inside-queues-fastfollow') && (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), $491f4fde535ee8ab$var$getPriorityGroupsResource()),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $dxCvy.projectContextResource))
    ];
const $491f4fde535ee8ab$export$54079077c6768752 = ()=>[
        (0, $gNStA.resourceWithCondition2)(()=>!(0, $4R6GH.fg)('jsm-views-inside-queues-fastfollow') && (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $f5kpo.getRapidBoardDataResource)()),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $lJ1FP.getEditModelResource)()),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $lfnsv.getBoardDetailsResource)()),
        (0, $gNStA.resourceWithCondition2)(()=>!(0, $4R6GH.fg)('jsm-views-inside-queues-fastfollow') && (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), $491f4fde535ee8ab$var$getPriorityGroupsResource()),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $dxCvy.projectContextResource)),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $f7Y15.uifBoardResource)),
        ...(0, $f5kpo.getRapidboardResources)().map((resource)=>(0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), resource))
    ];

});
parcelRegister("gS5PF", function(module, exports) {

$parcel$export(module.exports, "staticSidebarJsmReportsResource", () => $e7e607725980fdf6$export$ec28065a31cce4ce);

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");

var $cQGRH = parcelRequire("cQGRH");
const $e7e607725980fdf6$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $e7e607725980fdf6$export$ec28065a31cce4ce = (0, $2M1hQ.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_SERVICE_MANAGEMENT_REPORTS',
    getKey: ({ match: match, query: query })=>$e7e607725980fdf6$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $e7e607725980fdf6$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        return (0, $cQGRH.fetchJsmReportsSidebarNavInfo)(projectKeyOrId);
    },
    maxAge: 300000
});

});
parcelRegister("cQGRH", function(module, exports) {

$parcel$export(module.exports, "fetchJsmReportsSidebarNavInfo", () => $ed2ba0d649a8d8eb$export$c1dd51127051647d);

var $eusud = parcelRequire("eusud");
const $ed2ba0d649a8d8eb$export$c1dd51127051647d = (projectIdOrKey)=>{
    if (projectIdOrKey == null) throw new Error('invalid project id or key');
    return (0, $eusud.performGetRequest)(`/rest/navigation/4/servicedesk/project/${projectIdOrKey}/reports`);
};

});


parcelRegister("jYeNO", function(module, exports) {

$parcel$export(module.exports, "getCalendarFilterFieldsResource", () => $4dc70aab7904ddfa$export$5f02bf5f04197ed7);
$parcel$export(module.exports, "useCalendarFilterResource", () => $4dc70aab7904ddfa$export$70361b748d216408);

var $5uXOq = parcelRequire("5uXOq");

var $fZneA = parcelRequire("fZneA");

var $eusud = parcelRequire("eusud");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $4R6GH = parcelRequire("4R6GH");

var $3ezTL = parcelRequire("3ezTL");


var $30Hlr = parcelRequire("30Hlr");
const $4dc70aab7904ddfa$var$fetchFilterFields = async (cloudId, jqlContext)=>{
    try {
        const response = await (0, $eusud.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $8c2713286c62bdd7$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId,
                    contextFieldsFilter: (0, $4R6GH.fg)('corcap-3439-support-sdorigin-jqlbuilder-queue') ? {
                        jqlTerms: [
                            (0, $3ezTL.REQUEST_TYPE_FILTER),
                            (0, $3ezTL.SERVICE_DESK_ORIGIN_FILTER),
                            (0, $3ezTL.SERVICE_DESK_ORIGIN_DUPLICATE_FILTER)
                        ]
                    } : {
                        searchString: (0, $3ezTL.REQUEST_TYPE_FILTER)
                    },
                    jqlContext: jqlContext
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'JiraJqlBuilder'
            }
        });
        return (0, $30Hlr.transformAndReport)(response);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!(0, $fZneA.isHttpClientErrorResponse)(error)) (0, $30Hlr.reportError)(error);
        return 0, $3ezTL.DEFAULT_CALENDAR_FILTER_FIELDS;
    }
};
const $4dc70aab7904ddfa$var$filterFieldsResource = (0, $2M1hQ.createResource)({
    type: (0, $3ezTL.RESOURCE_TYPE_FILTER_FIELD),
    getKey: ({ match: match, query: query })=>{
        if ((0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag')) {
            const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
            const projectIdOrKey = projectKey || projectId;
            return (0, $3ezTL.RESOURCE_TYPE_FILTER_FIELD) + projectIdOrKey;
        }
        return 0, $3ezTL.RESOURCE_TYPE_FILTER_FIELD;
    },
    getData: ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        const projectIdOrKey = projectKey || projectId;
        const jqlContext = `project = '${projectIdOrKey}'`;
        return $4dc70aab7904ddfa$var$fetchFilterFields(cloudId, jqlContext);
    },
    maxAge: Infinity
});
const $4dc70aab7904ddfa$export$5f02bf5f04197ed7 = ()=>$4dc70aab7904ddfa$var$filterFieldsResource;
const $4dc70aab7904ddfa$export$70361b748d216408 = ({ isSimplified: isSimplified })=>{
    const resource = (0, $2YP9W.useResource)($4dc70aab7904ddfa$var$filterFieldsResource);
    (0, $5uXOq.useEffect)(()=>{
        if (// eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4R6GH.fg)('corcap-3439-support-sdorigin-jqlbuilder-queue') && !isSimplified && !resource.loading && !resource.error && !resource.data?.find((field)=>typeof field === 'object' && Object.values(field).includes((0, $30Hlr.TARGET_FILTER_TYPE)))) (0, $30Hlr.reportError)(new Error('Unable to prefetch request type'));
    }, [
        isSimplified,
        resource.data,
        resource.error,
        resource.loading
    ]);
    return resource;
};

});
parcelRegister("3ezTL", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_NAME", () => $2fdfca9bb2287268$export$186e93e8ef3f9358);
$parcel$export(module.exports, "PACKAGE_NAME", () => $2fdfca9bb2287268$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $2fdfca9bb2287268$export$d57b6b390e78d90f);
$parcel$export(module.exports, "REQUEST_TYPE_FILTER", () => $2fdfca9bb2287268$export$2c388650eabddf5e);
$parcel$export(module.exports, "SERVICE_DESK_ORIGIN_FILTER", () => $2fdfca9bb2287268$export$2fcf90614ee15858);
$parcel$export(module.exports, "SERVICE_DESK_ORIGIN_DUPLICATE_FILTER", () => $2fdfca9bb2287268$export$43482ff574598f59);
$parcel$export(module.exports, "RESOURCE_TYPE_FILTER_FIELD", () => $2fdfca9bb2287268$export$2019de80301f1da);
$parcel$export(module.exports, "DEFAULT_CALENDAR_FILTER_FIELDS", () => $2fdfca9bb2287268$export$2912f30d4328fc00);
const $2fdfca9bb2287268$export$186e93e8ef3f9358 = 'calendarFilterFieldResource';
const $2fdfca9bb2287268$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesServicedeskCalendar';
const $2fdfca9bb2287268$export$d57b6b390e78d90f = 'jsd-shield';
const $2fdfca9bb2287268$export$2c388650eabddf5e = 'request type';
const $2fdfca9bb2287268$export$2fcf90614ee15858 = 'service desk origin';
const $2fdfca9bb2287268$export$43482ff574598f59 = 'cf[10010]';
const $2fdfca9bb2287268$export$2019de80301f1da = 'RESOURCE_TYPE_FILTER_FIELD';
const $2fdfca9bb2287268$export$2912f30d4328fc00 = [
    'status',
    'assignee'
];

});

const $8c2713286c62bdd7$export$2b91517d6d5b4365 = `
query findRequestTypeCustomFieldQuery($cloudId: ID!, $contextFieldsFilter: JiraJQLContextFieldsFilter!, $jqlContext: String!) {
  jira {
    jqlBuilder(cloudId: $cloudId) {
        fields(jqlContextFieldsFilter: $contextFieldsFilter, jqlContext: $jqlContext) {
          ... on JiraJqlFieldConnection {
            __typename
            edges {
              node {
                jqlTerm
                displayName
                type
                searchTemplate {
                  key
                }
                operators
              }
            }
          }
          ... on QueryError {
            __typename
          }
        }
      }
  }
}
`;

parcelRegister("30Hlr", function(module, exports) {

$parcel$export(module.exports, "TARGET_FILTER_TYPE", () => $f86becf4a18b4f1f$export$64f54b13b7aea793);
$parcel$export(module.exports, "reportError", () => $f86becf4a18b4f1f$export$b33b857ad1d9900e);
$parcel$export(module.exports, "transformAndReport", () => $f86becf4a18b4f1f$export$af2aa11c88c551af);

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $3ezTL = parcelRequire("3ezTL");
const $f86becf4a18b4f1f$export$64f54b13b7aea793 = 'com.atlassian.servicedesk:vp-origin';
const $f86becf4a18b4f1f$var$TARGET_FILTER_SEARCH_TEMPLATE = 'com.atlassian.servicedesk:vp-origin-searcher';
const $f86becf4a18b4f1f$export$b33b857ad1d9900e = (error)=>{
    (0, $jcw0u.default)({
        error: error,
        sendToPrivacyUnsafeSplunk: true,
        meta: {
            id: (0, $3ezTL.RESOURCE_TYPE_NAME),
            packageName: (0, $3ezTL.PACKAGE_NAME),
            teamName: (0, $3ezTL.TEAM_NAME)
        }
    });
};
const $f86becf4a18b4f1f$export$af2aa11c88c551af = (response)=>{
    const edges = response.data?.jira?.jqlBuilder?.fields?.edges;
    // There may be ambigious custom fields with same name, so find the correct one and pass to JQLBuilder
    const requestType = edges?.find((edge)=>edge?.node?.type === $f86becf4a18b4f1f$export$64f54b13b7aea793 && edge?.node?.searchTemplate?.key === $f86becf4a18b4f1f$var$TARGET_FILTER_SEARCH_TEMPLATE)?.node;
    if (!requestType && !(0, $4R6GH.fg)('corcap-3439-support-sdorigin-jqlbuilder-queue')) $f86becf4a18b4f1f$export$b33b857ad1d9900e(new Error('Unable to prefetch request type'));
    // if requestType field found, add it to existing default calendar filter fields
    return requestType ? [
        {
            ...requestType,
            searchTemplate: requestType.searchTemplate.key,
            fieldType: requestType.type
        },
        ...(0, $3ezTL.DEFAULT_CALENDAR_FILTER_FIELDS)
    ] : (0, $3ezTL.DEFAULT_CALENDAR_FILTER_FIELDS);
};

});


parcelRegister("bjZiV", function(module, exports) {

$parcel$export(module.exports, "kbConfluenceContextResource", () => $450040dc63d5cc0e$export$8b58be1423986d17);

var $2M1hQ = parcelRequire("2M1hQ");


const $450040dc63d5cc0e$var$getDataLoader = ()=>(parcelRequire("kEPDU"));
const $450040dc63d5cc0e$export$8b58be1423986d17 = (0, $2M1hQ.createResource)({
    type: (0, $3139e13cdf89be01$export$54b5a0d1e8c78de6),
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: $450040dc63d5cc0e$var$getDataLoader,
    maxAge: Infinity
});

});
const $3139e13cdf89be01$export$54b5a0d1e8c78de6 = 'KB_CONFLUENCE_CONTEXT';

parcelRegister("kEPDU", function(module, exports) {

let $f09f9a3692f167b2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f09f9a3692f167b2$var$load("34Ulx").then(()=>parcelRequire('2SeLy'));

});


parcelRegister("cAofY", function(module, exports) {

$parcel$export(module.exports, "serviceDeskContextResource", () => $9c517de0cdc23225$export$5eaaf465969a9171);

var $dK8AG = parcelRequire("dK8AG");

var $2M1hQ = parcelRequire("2M1hQ");


const $9c517de0cdc23225$var$getDataLoader = ()=>(parcelRequire("2G0Nq"));
const $9c517de0cdc23225$export$5eaaf465969a9171 = (0, $2M1hQ.createResource)({
    type: (0, $4595635dbd9fca21$export$ac01662d5287bc5c),
    getKey: ({ match: match, query: query })=>(0, $dK8AG.getProjectKeyOrIdFromMatchAndQuery)({
            match: match,
            query: query
        }),
    getDataLoader: $9c517de0cdc23225$var$getDataLoader,
    maxAge: Infinity
});

});
const $4595635dbd9fca21$export$ac01662d5287bc5c = 'SERVICEDESK_CONTEXT';

parcelRegister("2G0Nq", function(module, exports) {

let $1f301f1e17d99558$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1f301f1e17d99558$var$load("5yC81").then(()=>parcelRequire('g4PUK'));

});


parcelRegister("aNLeB", function(module, exports) {

$parcel$export(module.exports, "servicedeskIsItsmProjectResource", () => $31e43d0718118496$export$920308cef4e291b1);
$parcel$export(module.exports, "useIsItsmTemplateProject", () => $31e43d0718118496$export$7bb46948fb84f164);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $dK8AG = parcelRequire("dK8AG");

var $2M1hQ = parcelRequire("2M1hQ");


const $31e43d0718118496$var$getDataLoader = ()=>(parcelRequire("9GeOA"));
const $31e43d0718118496$var$ONE_DAY_IN_MILLIS = 86400000;
const $31e43d0718118496$export$920308cef4e291b1 = (0, $2M1hQ.createResource)({
    type: (0, $6249ccfa4eeeb82a$export$543a8644640f4092),
    getKey: ({ match: match })=>(0, $dK8AG.getProjectKeyOrId)(match),
    getDataLoader: $31e43d0718118496$var$getDataLoader,
    maxAge: $31e43d0718118496$var$ONE_DAY_IN_MILLIS
});
const $31e43d0718118496$export$7bb46948fb84f164 = (projectKey)=>{
    const { data: data, loading: loading, error: error } = (0, $324W5.useResourceWithCustomRouterContext)($31e43d0718118496$export$920308cef4e291b1, projectKey ? {
        matchParams: {
            projectKey: projectKey
        }
    } : undefined, {
        shouldPrefetch: true
    });
    return (0, $5uXOq.useMemo)(()=>({
            data: data,
            loading: loading,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error
        }), [
        data,
        loading,
        error
    ]);
};

});
const $6249ccfa4eeeb82a$export$543a8644640f4092 = 'SERVICEDESK_IS_ITSM_PROJECT';

parcelRegister("9GeOA", function(module, exports) {

let $70c38737053f6be9$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $70c38737053f6be9$var$load("kVX56"),
    $70c38737053f6be9$var$load("ijWsV")
]).then(()=>parcelRequire('k9PUn'));

});


parcelRegister("eUvlM", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticesResource", () => $9479f477b801290f$export$2ae319305481e7de);
$parcel$export(module.exports, "useWorkCategoriesQueueSupported", () => $9479f477b801290f$export$a86ac771006f14b3);
$parcel$export(module.exports, "useWorkCategoriesAllSupported", () => $9479f477b801290f$export$fe081b1a59d3c818);
$parcel$export(module.exports, "useWorkCategoriesAllSupportedWithForceRefreshOnMount", () => $9479f477b801290f$export$4d46346ef0bdc6b9);

var $5uXOq = parcelRequire("5uXOq");

var $dK8AG = parcelRequire("dK8AG");

var $oCMSG = parcelRequire("oCMSG");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


const $9479f477b801290f$var$getDataLoader = ()=>(parcelRequire("1Sd5S"));
const $9479f477b801290f$var$ONE_DAY_IN_MILLIS = 86400000;
const $9479f477b801290f$export$2ae319305481e7de = (0, $2M1hQ.createResource)({
    type: (0, $990f0449915d93bf$export$45919c8f50bb1db5),
    getKey: ({ match: match })=>(0, $dK8AG.getProjectKeyOrId)(match),
    getDataLoader: $9479f477b801290f$var$getDataLoader,
    maxAge: $9479f477b801290f$var$ONE_DAY_IN_MILLIS
});
const $9479f477b801290f$var$queuesOrder = [
    ...(0, $oCMSG.WORK_CATEGORIES_QUEUE_SUPPORTED)
];
const $9479f477b801290f$var$workCategoryOrder = [
    ...$9479f477b801290f$var$queuesOrder,
    (0, $oCMSG.DEVELOPER_ESCALATION)
];
const $9479f477b801290f$var$transformItsmPracticesList = (data)=>{
    if (!data?.practices) return null;
    return $9479f477b801290f$var$queuesOrder.filter((practice)=>data.practices.some((practiceInData)=>practiceInData.key === practice));
};
const $9479f477b801290f$var$transformServiceDeskPracticesList = (data)=>{
    if (!data?.practices) return null;
    return $9479f477b801290f$var$workCategoryOrder.filter((practice)=>data.practices.some((practiceInData)=>practiceInData.key === practice));
};
const $9479f477b801290f$export$a86ac771006f14b3 = ()=>{
    const { data: data, loading: loading, ...resource } = (0, $2YP9W.useResource)($9479f477b801290f$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    return (0, $5uXOq.useMemo)(()=>({
            data: $9479f477b801290f$var$transformItsmPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};
const $9479f477b801290f$export$fe081b1a59d3c818 = ()=>{
    const { data: data, loading: loading, ...resource } = (0, $2YP9W.useResource)($9479f477b801290f$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    return (0, $5uXOq.useMemo)(()=>({
            data: $9479f477b801290f$var$transformServiceDeskPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};
const $9479f477b801290f$export$4d46346ef0bdc6b9 = ()=>{
    const { data: data, loading: loading, refresh: refreshPractices, ...resource } = (0, $2YP9W.useResource)($9479f477b801290f$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    (0, $5uXOq.useEffect)(()=>{
        if (!loading && !data && !error) refreshPractices();
    }, [
        data,
        error,
        loading,
        refreshPractices
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            data: $9479f477b801290f$var$transformServiceDeskPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};

});
const $990f0449915d93bf$export$45919c8f50bb1db5 = 'SERVICEDESK_PRACTICES';

parcelRegister("1Sd5S", function(module, exports) {

let $15d4fdbed587eaa7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $15d4fdbed587eaa7$var$load("e7Uqc").then(()=>parcelRequire('8khb6'));

});


parcelRegister("lbaDt", function(module, exports) {

$parcel$export(module.exports, "requiredProjectProperties", () => $3477ceb4f9b98b2e$export$fbeae45a65f4a5a6);
$parcel$export(module.exports, "requiredFrontendProperties", () => $3477ceb4f9b98b2e$export$47241956725e3029);
$parcel$export(module.exports, "firstProjectResource", () => $3477ceb4f9b98b2e$export$f620cebb7e8eeeae);

var $9XE6b = parcelRequire("9XE6b");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
const $3477ceb4f9b98b2e$var$getKey = ({ match: match, query: query })=>// projectKey from url path/query or browse/{issueKey}
    (0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0];

const $3477ceb4f9b98b2e$var$getRequiredProjectPropertiesDataLoader = ()=>(parcelRequire("1rucY"));
const $3477ceb4f9b98b2e$export$fbeae45a65f4a5a6 = (0, $2M1hQ.createResource)({
    type: 'SERVICEDESK_REQUIRED_PROJECT_PROPERTIES',
    getKey: $3477ceb4f9b98b2e$var$getKey,
    getDataLoader: $3477ceb4f9b98b2e$var$getRequiredProjectPropertiesDataLoader,
    maxAge: 300000
});

const $3477ceb4f9b98b2e$var$getRequiredFrontendPropertiesDataLoader = ()=>(parcelRequire("kKV8g"));
const $3477ceb4f9b98b2e$var$ONE_DAY_IN_MILLIS = 86400000;
const $3477ceb4f9b98b2e$export$47241956725e3029 = (0, $2M1hQ.createResource)({
    type: 'SERVICEDESK_REQUIRED_FRONTEND_PROPERTIES',
    getKey: $3477ceb4f9b98b2e$var$getKey,
    getDataLoader: $3477ceb4f9b98b2e$var$getRequiredFrontendPropertiesDataLoader,
    maxAge: $3477ceb4f9b98b2e$var$ONE_DAY_IN_MILLIS
});

const $3477ceb4f9b98b2e$var$getFirstProjectDataLoader = ()=>(parcelRequire("gOkZi"));
const $3477ceb4f9b98b2e$var$TWELVE_HOURS_IN_MILLIS = 43200000;
const $3477ceb4f9b98b2e$export$f620cebb7e8eeeae = (0, $2M1hQ.createResource)({
    type: 'JSM_FIRST_PROJECT_RESOURCE',
    // first project is the same for the tenantId (there is also no per-project arg in request url). Therefore, only 1 key value is used.
    getKey: ()=>'none',
    getDataLoader: $3477ceb4f9b98b2e$var$getFirstProjectDataLoader,
    maxAge: $3477ceb4f9b98b2e$var$TWELVE_HOURS_IN_MILLIS
});

});
parcelRegister("1rucY", function(module, exports) {

let $10cfbecfee1abb90$var$load = (parcelRequire("28QjX"))(4);
module.exports = $10cfbecfee1abb90$var$load("3tedP").then(()=>parcelRequire('d4USv'));

});

parcelRegister("kKV8g", function(module, exports) {

let $03e643cdaa37a894$var$load = (parcelRequire("28QjX"))(4);
module.exports = $03e643cdaa37a894$var$load("5zkTp").then(()=>parcelRequire('7UDgf'));

});

parcelRegister("gOkZi", function(module, exports) {

let $c3d1989583b4dc61$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c3d1989583b4dc61$var$load("j1TMu").then(()=>parcelRequire('KbkKO'));

});


parcelRegister("2Zfed", function(module, exports) {

$parcel$export(module.exports, "nav3QueueGroupsStateResource", () => $9aaf4a7b4f3d3895$export$53d0e5294221581);

var $9XE6b = parcelRequire("9XE6b");

var $2M1hQ = parcelRequire("2M1hQ");

var $jcw0u = parcelRequire("jcw0u");

var $1nb22 = parcelRequire("1nb22");

var $8w6CZ = parcelRequire("8w6CZ");

var $1FAuA = parcelRequire("1FAuA");
const $9aaf4a7b4f3d3895$var$getProjectKey = ({ match: match, query: query })=>// projectKey from url path or browse/{issueKey}
    (0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0];
const $9aaf4a7b4f3d3895$export$53d0e5294221581 = (0, $2M1hQ.createResource)({
    type: (0, $8w6CZ.RESOURCE_TYPE_SERVICEDESK_NAV3_QUEUE_GROUPS_STATE),
    getKey: $9aaf4a7b4f3d3895$var$getProjectKey,
    getData: async ({ match: match, query: query }, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>{
        if (!atlassianAccountId) return undefined;
        const projectKey = $9aaf4a7b4f3d3895$var$getProjectKey({
            match: match,
            query: query
        });
        try {
            return await (0, $1FAuA.getQueueGroupsStateFromUserProperty)(projectKey, atlassianAccountId);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'getQueueGroupsStateInUserPropertyResourceError'
                }
            });
            return undefined;
        }
    },
    maxAge: (0, $8w6CZ.ONE_DAY_IN_MILLIS)
});

});
parcelRegister("1FAuA", function(module, exports) {

$parcel$export(module.exports, "setQueueGroupsStateInUserProperty", () => $ebaf9bc45b7e52ed$export$e316bbc9b5e5100d);
$parcel$export(module.exports, "getQueueGroupsStateFromUserProperty", () => $ebaf9bc45b7e52ed$export$87bc602eb5671315);

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");
const $ebaf9bc45b7e52ed$export$bb10a02fc2feb574 = 'jsm-queue-groups-state-selected-group-id';
const $ebaf9bc45b7e52ed$export$e316bbc9b5e5100d = async (projectKey, value, accountId)=>{
    try {
        (0, $89SaW.setUserProperties)(accountId, `${$ebaf9bc45b7e52ed$export$bb10a02fc2feb574}_${projectKey}`, JSON.stringify(value));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'setQueueGroupsStateInUserPropertyError'
            }
        });
        throw error;
    }
};
const $ebaf9bc45b7e52ed$export$87bc602eb5671315 = async (projectKey, accountId)=>{
    try {
        return await (0, $89SaW.getUserProperty)(accountId, `${$ebaf9bc45b7e52ed$export$bb10a02fc2feb574}_${projectKey}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'getQueueGroupsStateFromUserPropertyError'
            }
        });
        throw error;
    }
};

});


parcelRegister("2cxgG", function(module, exports) {

$parcel$export(module.exports, "virtualAgentOnboardingResource", () => $e9d51fb7135f5412$export$d39827c053fda3aa);

var $4R6GH = parcelRequire("4R6GH");

var $ao2h1 = parcelRequire("ao2h1");

var $2j6fy = parcelRequire("2j6fy");
const $e9d51fb7135f5412$export$d39827c053fda3aa = (0, $ao2h1.createRelayResource)({
    type: 'SERVICEDESK_VIRTUAL_AGENT_ONBOARDING',
    isBrowserOnly: true,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $2j6fy.default),
            variables: {
                cloudId: tenantContext.cloudId,
                key: match.params.projectKey || '',
                checkForAiEnabledFF: (0, $4R6GH.fg)('require_ai_enabled_for_jsm_virtual_agent')
            }
        })
});

});
parcelRegister("2j6fy", function(module, exports) {

$parcel$export(module.exports, "default", () => $45b605658e5ce20d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8391836c727c96074b367b5cee339a0d>>
 * @relayHash a752dde009c93b4975b47e740db8b1bd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 43c453bca1e65ebbd87f7974bea4d6b5c78178b9b9507ff8b40972a4e4fe9ecf

var $7oHmH = parcelRequire("7oHmH");
const $45b605658e5ce20d$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "43c453bca1e65ebbd87f7974bea4d6b5c78178b9b9507ff8b40972a4e4fe9ecf",
        "metadata": {},
        "name": "mainVirtualAgentSidebarQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $7oHmH.default)
        }
    }
};
var $45b605658e5ce20d$export$2e2bcd8739ae039 = $45b605658e5ce20d$var$node;

});
parcelRegister("7oHmH", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f0ef421b1798a33$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $3f0ef421b1798a33$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('require_ai_enabled_for_jsm_virtual_agent');
    }
};

});



parcelRegister("6sNnq", function(module, exports) {

$parcel$export(module.exports, "featuresResource", () => $d0a02e466fb63798$export$16f81cc9da2c6c47);

var $9XE6b = parcelRequire("9XE6b");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");


const $d0a02e466fb63798$var$getDataLoader = ()=>Promise.resolve((parcelRequire("frQmB")));
const $d0a02e466fb63798$var$ONE_DAY_IN_MILLIS = 86400000;
const $d0a02e466fb63798$export$16f81cc9da2c6c47 = (0, $2M1hQ.createResource)({
    type: (0, $68b2e6d16c6e9952$export$3441b129810f29ed),
    getKey: ({ match: match, query: query })=>// projectKey from url path or browse/{issueKey}
        (0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0],
    getDataLoader: $d0a02e466fb63798$var$getDataLoader,
    maxAge: $d0a02e466fb63798$var$ONE_DAY_IN_MILLIS
});

});
const $68b2e6d16c6e9952$export$3441b129810f29ed = 'SERVICEDESK_FEATURES';


parcelRegister("lfnsv", function(module, exports) {

$parcel$export(module.exports, "boardDetailsResource", () => $d78990d38f225e07$export$6c6984c55b171c5d);
$parcel$export(module.exports, "getBoardDetailsResource", () => $d78990d38f225e07$export$b67eabcfc08e7c62);

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $7f4tk = parcelRequire("7f4tk");

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");

var $PK2Tm = parcelRequire("PK2Tm");
const $d78990d38f225e07$export$90ce361a5838e31e = async (boardId)=>{
    try {
        return await (0, $7f4tk.default)(`/rest/agile/1.0/board/${boardId}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'getBoardDetailsRequest',
                packageName: 'jiraRouterResourcesClassicProjects',
                teamName: 'a4t-pandora'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $d78990d38f225e07$export$6c6984c55b171c5d = (0, $2M1hQ.createResource)({
    type: 'CLASSIC_BOARD_SETTING_BOARD_DETAILS',
    getKey: (routerContext)=>(0, $PK2Tm.getConfigFromRouterContext)(routerContext) ? 'cmp-board-settings' : 'not-cmp-board-setting',
    getData: async (routerContext)=>{
        const boardId = routerContext.match.params?.boardId ?? '';
        if ((0, $PK2Tm.getConfigFromRouterContext)(routerContext)) return $d78990d38f225e07$export$90ce361a5838e31e(boardId);
        return null;
    }
});
const $d78990d38f225e07$export$b67eabcfc08e7c62 = ()=>(0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('simplified-boards-milestone-2_07hbk'), $d78990d38f225e07$export$6c6984c55b171c5d);

});
parcelRegister("PK2Tm", function(module, exports) {

$parcel$export(module.exports, "buildAllDataQueryParams", () => $df00ee708c57537c$export$487708debaea6de3);
$parcel$export(module.exports, "getInlineScriptData", () => $df00ee708c57537c$export$7bd4b867b9305f97);
$parcel$export(module.exports, "getRapidViewConfigFromRouteName", () => $df00ee708c57537c$export$62c86c4062215346);
$parcel$export(module.exports, "getRequiredResourceList", () => $df00ee708c57537c$export$7bff98a3d459b1b8);
$parcel$export(module.exports, "getConfigFromRouterContext", () => $df00ee708c57537c$export$1705c550e5b835bf);

var $4R6GH = parcelRequire("4R6GH");

var $1odlY = parcelRequire("1odlY");

var $9hNId = parcelRequire("9hNId");
const $df00ee708c57537c$export$487708debaea6de3 = (query, match)=>{
    const { rapidView: rapidView, quickFilter: quickFilter, projectKey: queryProjectKey, etag: etag } = query;
    const boardId = match.params.boardId || rapidView;
    const projectKey = match.params.projectKey || queryProjectKey;
    let activeQuickFilters = '';
    if (quickFilter) activeQuickFilters = Array.isArray(quickFilter) ? quickFilter.reduce((prevFilter, nextFilter)=>`${prevFilter}&activeQuickFilters=${nextFilter}`, activeQuickFilters) : `&activeQuickFilters=${quickFilter}`;
    const etagParam = etag ? `&etag=${etag}` : '';
    const projectKeyParam = projectKey ? `&selectedProjectKey=${projectKey}` : '';
    const { GH: GH } = window;
    const forceConsistency = '&forceConsistency=true';
    GH?.RapidBoard?.State?.setRapidViewIdForEventuallyConsistentBoard(undefined);
    return `rapidViewId=${boardId}${projectKeyParam}${activeQuickFilters}${etagParam}${forceConsistency}`;
};
const $df00ee708c57537c$var$cleanUpInlineScript = (dataName)=>{
    // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    delete window[dataName];
};
const $df00ee708c57537c$export$7bd4b867b9305f97 = (dataName)=>{
    // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const req = window[dataName];
    if (!req) return null;
    if (req.readyState === req.DONE && req.status !== 200) {
        $df00ee708c57537c$var$cleanUpInlineScript(dataName);
        return null;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new Promise((r)=>{
        if (req.readyState === req.DONE && req.status === 200) {
            $df00ee708c57537c$var$cleanUpInlineScript(dataName);
            r(JSON.parse(req.response));
        } else req.addEventListener('load', ()=>{
            $df00ee708c57537c$var$cleanUpInlineScript(dataName);
            r(JSON.parse(req.response));
        });
    });
};
const $df00ee708c57537c$export$62c86c4062215346 = (routeName)=>{
    for (const routeConfig of Object.values((0, $9hNId.RAPID_VIEW_ROUTE_CONFIG))){
        if (routeConfig.routes?.includes(routeName)) return routeConfig;
    }
    return (0, $9hNId.RAPID_VIEW_ROUTE_CONFIG).DEFAULT;
};
const $df00ee708c57537c$export$7bff98a3d459b1b8 = (view)=>{
    let rapidboardResources = (0, $1odlY.WRM_RESOURCES_ARRAY);
    if ((0, $4R6GH.fg)('reports-overview-page-migration')) {
        if (view) {
            const routeConfig = $df00ee708c57537c$export$62c86c4062215346(view);
            return [
                ...(0, $1odlY.WRM_HERITAGE_RESOURCES_FHD_ARRAY),
                ...routeConfig.resources
            ];
        }
        return [
            ...(0, $1odlY.WRM_HERITAGE_RESOURCES_FHD_ARRAY),
            ...(0, $9hNId.RAPID_VIEW_ROUTE_CONFIG).DEFAULT.resources
        ];
    }
    // eslint-disable-next-line default-case
    switch(view){
        case 'rapidboard-board':
        case 'rapidboard-board-embed':
        case 'rapidboard-user-board':
        case 'servicedesk-boards':
        case 'servicedesk-queues-custom-board':
        case 'servicedesk-queues-practice-custom-board':
            rapidboardResources = (0, $1odlY.WRM_BOARD_RESOURCES_FHD_ARRAY);
            break;
        case 'rapidboard-backlog':
        case 'rapidboard-user-backlog':
        case 'rapidboard-backlog-embed':
            rapidboardResources = (0, $1odlY.WRM_BACKLOG_RESOURCES_FHD_ARRAY);
            break;
    }
    return [
        ...(0, $1odlY.WRM_HERITAGE_RESOURCES_FHD_ARRAY),
        ...rapidboardResources
    ];
};
function $df00ee708c57537c$export$1705c550e5b835bf(routerContext) {
    return routerContext.match?.params.config || routerContext.query?.config || '';
}

});
parcelRegister("1odlY", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_BOARD_CONFIG", () => $fa7f7a1583a8dcf1$export$88e2a0b89be042c1);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA", () => $fa7f7a1583a8dcf1$export$ba075d0985968d1c);
$parcel$export(module.exports, "RESOURCE_TYPE_PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS", () => $fa7f7a1583a8dcf1$export$395f77888d07f2e0);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_RESOURCE", () => $fa7f7a1583a8dcf1$export$4f7c4e3508fd2a07);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_WRM_BUNDLE", () => $fa7f7a1583a8dcf1$export$3328c8e71fda97bb);
$parcel$export(module.exports, "WRM_RESOURCES_ARRAY", () => $fa7f7a1583a8dcf1$export$ef21257df3d71188);
$parcel$export(module.exports, "WRM_HERITAGE_RESOURCES_FHD_ARRAY", () => $fa7f7a1583a8dcf1$export$ccd0929652c235de);
$parcel$export(module.exports, "WRM_BOARD_RESOURCES_FHD_ARRAY", () => $fa7f7a1583a8dcf1$export$1d16bdcc94a40107);
$parcel$export(module.exports, "WRM_BACKLOG_RESOURCES_FHD_ARRAY", () => $fa7f7a1583a8dcf1$export$1f599d2eef0a7281);
const $fa7f7a1583a8dcf1$export$88e2a0b89be042c1 = 'RESOURCE_RAPIDBOARDS_BOARD_CONFIG';
const $fa7f7a1583a8dcf1$export$ba075d0985968d1c = 'RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA';
const $fa7f7a1583a8dcf1$export$395f77888d07f2e0 = 'PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS';
const $fa7f7a1583a8dcf1$export$4f7c4e3508fd2a07 = 'RESOURCE_TYPE_RAPIDBOARDS_RESOURCE';
const $fa7f7a1583a8dcf1$export$3328c8e71fda97bb = 'RESOURCE_RAPIDBOARDS_WRM_BUNDLE';
const $fa7f7a1583a8dcf1$export$ef21257df3d71188 = [
    '_super',
    'wrc!greenhopper-rapid-non-gadget',
    'wrc!gh-rapid',
    'wrc!jira.global',
    'wrc!jira.general',
    'wrc!atl.global',
    // Required to prevent an error on initial loading of reports
    'wrc!jira.webresources:header',
    // Required for Control Chart report page
    'wrc!jira.webresources:calendar',
    'wrc!jira.webresources:calendar-en',
    'wrc!jira.webresources:jira.webresources:calendar-localisation-moment',
    // Required for explicit usage of jQuery
    'wrc!com.atlassian.jira.project-templates-plugin:project-templates-plugin-resources',
    // Required for the styles of the toggle button when transitioning from reports to board settings
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-aui-toggle',
    // Required for the profile card in board settings, that doesn't really render because it has wrong
    // parameters and it has been broken for ages, but at least prevents noisy errors
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:profilecard',
    'wrc!gh-rapid-config',
    'wrc!gh-rapid-analytics',
    'wrc!gh-rapid-charts',
    'wrc!jira.webresources:mentions-feature',
    'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-dialog-resources-ctx'
];
const $fa7f7a1583a8dcf1$export$ccd0929652c235de = [];
const $fa7f7a1583a8dcf1$export$1d16bdcc94a40107 = [
    'wrc!gh-rapid-lwf-board-fhd',
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:feature-flags',
    'wrc!com.atlassian.auiplugin:aui-spinner',
    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
    'wrc!com.atlassian.analytics.analytics-client:js-events'
];
const $fa7f7a1583a8dcf1$export$1f599d2eef0a7281 = [
    'wrc!gh-rapid-backlog-fhd',
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:header',
    'wrc!jira.webresources:feature-flags',
    'wrc!com.atlassian.auiplugin:aui-spinner',
    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
    'wrc!com.atlassian.analytics.analytics-client:js-events'
];

});

parcelRegister("9hNId", function(module, exports) {

$parcel$export(module.exports, "RAPID_VIEW_ROUTE_CONFIG", () => $f34cebd5a04e9077$export$99d0df2f58f37dfe);

var $1odlY = parcelRequire("1odlY");
const $f34cebd5a04e9077$export$99d0df2f58f37dfe = {
    BOARD: {
        routes: [
            'rapidboard-board',
            'rapidboard-board-embed',
            'rapidboard-user-board',
            'servicedesk-boards',
            'servicedesk-queues-custom-board',
            'servicedesk-queues-practice-custom-board'
        ],
        resources: (0, $1odlY.WRM_BOARD_RESOURCES_FHD_ARRAY),
        stateKey: 'board-state'
    },
    BACKLOG: {
        routes: [
            'rapidboard-backlog',
            'rapidboard-user-backlog',
            'rapidboard-backlog-embed'
        ],
        resources: (0, $1odlY.WRM_BACKLOG_RESOURCES_FHD_ARRAY),
        stateKey: 'backlog-state'
    },
    DEFAULT: {
        resources: (0, $1odlY.WRM_RESOURCES_ARRAY),
        stateKey: 'report-state'
    }
};

});



parcelRegister("f5kpo", function(module, exports) {

$parcel$export(module.exports, "shouldLoadUIFBoardResources", () => $e96bf35f407138bb$export$d8d4641986a9ac7f);
$parcel$export(module.exports, "getRapidboardResources", () => $e96bf35f407138bb$export$3a5e56bd5231a56b);
$parcel$export(module.exports, "getRapidBoardDataResource", () => $e96bf35f407138bb$export$1c63de7f548f965f);
$parcel$export(module.exports, "getUIFBacklogDataResource", () => $e96bf35f407138bb$export$ee826506b3baa13a);

var $4R6GH = parcelRequire("4R6GH");

var $5Nutl = parcelRequire("5Nutl");

var $gNStA = parcelRequire("gNStA");

var $i6CNv = parcelRequire("i6CNv");

var $kdyVI = parcelRequire("kdyVI");

var $gQ2J4 = parcelRequire("gQ2J4");

var $fox5Q = parcelRequire("fox5Q");
const $e96bf35f407138bb$export$d8d4641986a9ac7f = ()=>!false;
const $e96bf35f407138bb$export$462ca08d6ce67848 = ()=>!$e96bf35f407138bb$export$d8d4641986a9ac7f();
const $e96bf35f407138bb$export$3a5e56bd5231a56b = ()=>[
        (0, $fox5Q.wrmBundleResource),
        (0, $gNStA.resourceWithCondition2)(()=>!(0, $4R6GH.fg)('tanuki-stop-load-of-config-json'), (0, $i6CNv.boardConfigApiResource)),
        (0, $gNStA.resourceWithCondition2)($e96bf35f407138bb$export$462ca08d6ce67848, (0, $gQ2J4.rapidboardResource))
    ];
const $e96bf35f407138bb$export$1c63de7f548f965f = ()=>(0, $kdyVI.boardDataResource);
const $e96bf35f407138bb$export$ee826506b3baa13a = ()=>[
        (0, $gNStA.resourceWithCondition2)(()=>$e96bf35f407138bb$export$d8d4641986a9ac7f() && (0, $4R6GH.fg)('jsw-backlog-preload-config-data') && !(0, $4R6GH.fg)('jsw-backlog-resource-data-combine'), (0, $5Nutl.backlogConfigResource)),
        (0, $gNStA.resourceWithCondition2)(()=>$e96bf35f407138bb$export$d8d4641986a9ac7f() && (0, $4R6GH.fg)('jsw-backlog-preload-config-data') && !(0, $4R6GH.fg)('jsw-backlog-resource-data-combine'), (0, $5Nutl.backlogGlobalConfigResource)),
        (0, $gNStA.resourceWithCondition2)(()=>$e96bf35f407138bb$export$d8d4641986a9ac7f() && !(0, $4R6GH.fg)('indexeddb_cache_for_backlog'), (0, $5Nutl.uifBacklogResourceOld)),
        (0, $gNStA.resourceWithCondition2)(()=>$e96bf35f407138bb$export$d8d4641986a9ac7f() && (0, $4R6GH.fg)('indexeddb_cache_for_backlog'), (0, $5Nutl.uifBacklogResource))
    ];

});
parcelRegister("5Nutl", function(module, exports) {

$parcel$export(module.exports, "uifBacklogResourceOld", () => $9905b3c28d313f7e$export$db83ef0443397b85);
$parcel$export(module.exports, "uifBacklogResource", () => $9905b3c28d313f7e$export$c182dffb98985208);
$parcel$export(module.exports, "backlogConfigResource", () => $9905b3c28d313f7e$export$f894eb38e7ada0d6);
$parcel$export(module.exports, "backlogGlobalConfigResource", () => $9905b3c28d313f7e$export$ee2927bb14d7fd87);

var $2M1hQ = parcelRequire("2M1hQ");


const $9905b3c28d313f7e$export$db83ef0443397b85 = (0, $2M1hQ.createResource)({
    type: (0, $2fdbe99f6cbea4f1$export$8f9824ba4409b537),
    getKey: ({ match: { params: { boardId: boardId } }, query: { config: config } })=>/*
            When navigating to and from the board settings page we need
            the data to get reloaded. So we are updating the key to force a refresh
        */ [
            'uif-backlog-data'
        ].concat(boardId ?? '').concat(config ? `config-${config}` : '').filter(Boolean).join('-'),
    getDataLoader: ()=>(parcelRequire("glMKd")),
    // Setting mexAge to 0 so it will get the data again after coming back from a config page
    maxAge: 0
});

const $9905b3c28d313f7e$export$c182dffb98985208 = (0, $2M1hQ.createResource)({
    type: (0, $2fdbe99f6cbea4f1$export$d15ce4feabd76ea),
    getKey: ({ match: { params: { boardId: boardId } }, query: { config: config } })=>/*
            When navigating to and from the board settings page we need
            the data to get reloaded. So we are updating the key to force a refresh
        */ [
            'uif-backlog-data'
        ].concat(boardId ?? '').concat(config ? `config-${config}` : '').filter(Boolean).join('-'),
    getDataLoader: ()=>(parcelRequire("5qsLS")),
    // Setting mexAge to 0 so it will get the data again after coming back from a config page
    maxAge: 0
});

const $9905b3c28d313f7e$export$f894eb38e7ada0d6 = (0, $2M1hQ.createResource)({
    type: (0, $2fdbe99f6cbea4f1$export$213e774bb8f521ee),
    getKey: ({ match: { params: { boardId: boardId } } })=>`backlog-config-data-${boardId ?? ''}`,
    getDataLoader: ()=>(parcelRequire("79Lit"))
});

const $9905b3c28d313f7e$export$ee2927bb14d7fd87 = (0, $2M1hQ.createResource)({
    type: (0, $2fdbe99f6cbea4f1$export$285d72b0274b22cc),
    getKey: ({ match: { params: { boardId: boardId } } })=>`backlog-global-config-data-${boardId ?? ''}`,
    getDataLoader: ()=>(parcelRequire("8WWzx"))
});

});
const $2fdbe99f6cbea4f1$export$d15ce4feabd76ea = 'NEXTGEN_BACKLOG_REST';
const $2fdbe99f6cbea4f1$export$8f9824ba4409b537 = 'NEXTGEN_BACKLOG_REST_OLD';
const $2fdbe99f6cbea4f1$export$213e774bb8f521ee = 'NEXTGEN_BACKLOG_CONFIG_DATA';
const $2fdbe99f6cbea4f1$export$285d72b0274b22cc = 'NEXTGEN_BACKLOG_GLOBAL_CONFIG_DATA';

parcelRegister("glMKd", function(module, exports) {

let $be746b218be133f7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $be746b218be133f7$var$load("dZxlR").then(()=>parcelRequire('gTjY8'));

});

parcelRegister("5qsLS", function(module, exports) {

let $3f35b2d6dd480d8c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3f35b2d6dd480d8c$var$load("5ODd0").then(()=>parcelRequire('cpSf8'));

});

parcelRegister("79Lit", function(module, exports) {

let $535e0fddfea28f43$var$load = (parcelRequire("28QjX"))(4);
module.exports = $535e0fddfea28f43$var$load("6KmpS").then(()=>parcelRequire('fARTX'));

});

parcelRegister("8WWzx", function(module, exports) {

let $68412cc082bcc378$var$load = (parcelRequire("28QjX"))(4);
module.exports = $68412cc082bcc378$var$load("1GxdS").then(()=>parcelRequire('sSRsi'));

});


parcelRegister("i6CNv", function(module, exports) {

$parcel$export(module.exports, "boardConfigApiResource", () => $8a55ba0bef7e0e2a$export$dd9dec064acb0c4e);
// eslint-disable-next-line jira/import-whitelist

var $6s1PB = parcelRequire("6s1PB");

var $2M1hQ = parcelRequire("2M1hQ");

var $1odlY = parcelRequire("1odlY");
const $8a55ba0bef7e0e2a$var$getMaxAge = ()=>false ? 0 : (0, $6s1PB.expVal)('jsw-classic-board-api-calls-config-cache-time', 'value', 0) * 1000;

const $8a55ba0bef7e0e2a$export$dd9dec064acb0c4e = (0, $2M1hQ.createResource)({
    type: (0, $1odlY.RESOURCE_TYPE_RAPIDBOARDS_BOARD_CONFIG),
    getKey: ({ match: match, query: query })=>{
        const boardId = match.params.boardId != null ? match.params.boardId : query.rapidView;
        return `rapidViewConfig-${boardId}`; // Should Also have a mode but for now lets use only id
    },
    getDataLoader: ()=>(parcelRequire("6Pdur")),
    maxAge: $8a55ba0bef7e0e2a$var$getMaxAge(),
    isBrowserOnly: true
});

});
parcelRegister("6Pdur", function(module, exports) {

let $4f81f859a98e0dfd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4f81f859a98e0dfd$var$load("4Iwhy").then(()=>parcelRequire('aCQV9'));

});


parcelRegister("kdyVI", function(module, exports) {

$parcel$export(module.exports, "boardDataResource", () => $18aa0ee73b651f62$export$138fa635416978f7);

var $2M1hQ = parcelRequire("2M1hQ");

var $1odlY = parcelRequire("1odlY");

var $9g2vH = parcelRequire("9g2vH");

const $18aa0ee73b651f62$export$138fa635416978f7 = (0, $2M1hQ.createResource)({
    type: (0, $1odlY.RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA),
    getKey: ({ match: match, query: query, route: route })=>{
        const { name: name = '' } = route || {};
        const boardId = match.params.boardId != null ? match.params.boardId : query.rapidView;
        const { config: config } = query;
        const hasConfig = Boolean(config);
        let key = 'rapidBoardData';
        if ((0, $9g2vH.isBoardRoute)(name)) key = `boardData-${boardId}::hasConfig=${hasConfig}`;
        else if ((0, $9g2vH.isBacklogRoute)(name)) key = `backlogData-${boardId}::hasConfig=${hasConfig}`;
        return key;
    },
    getDataLoader: ()=>(parcelRequire("66t2H")),
    maxAge: 0,
    isBrowserOnly: true
});

});
parcelRegister("9g2vH", function(module, exports) {

$parcel$export(module.exports, "isBoardRoute", () => $ccbac8c858ea0da2$export$437d4d6e25681588);
$parcel$export(module.exports, "isBacklogRoute", () => $ccbac8c858ea0da2$export$bcb853db5e3e8054);
const $ccbac8c858ea0da2$export$437d4d6e25681588 = (routeName)=>routeName === 'rapidboard-board' || routeName === 'rapidboard-board-embed' || routeName === 'rapidboard-board-settings' || routeName === 'rapidboard-user-board' || routeName === 'rapidboard-user-board-settings' || routeName === 'servicedesk-boards' || routeName === 'servicedesk-queues-custom-board' || routeName === 'servicedesk-queues-practice-custom-board';
const $ccbac8c858ea0da2$export$bcb853db5e3e8054 = (routeName)=>routeName === 'rapidboard-backlog' || routeName === 'rapidboard-user-backlog' || routeName === 'rapidboard-backlog-embed';

});

parcelRegister("66t2H", function(module, exports) {

let $4719d4de18488d94$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4719d4de18488d94$var$load("8SZ65").then(()=>parcelRequire('iW9CS'));

});


parcelRegister("gQ2J4", function(module, exports) {

$parcel$export(module.exports, "rapidboardResource", () => $b172ecb4db4f1d22$export$d0f42a55e7c5752c);

var $2M1hQ = parcelRequire("2M1hQ");

var $1odlY = parcelRequire("1odlY");

const $b172ecb4db4f1d22$export$d0f42a55e7c5752c = (0, $2M1hQ.createResource)({
    type: (0, $1odlY.RESOURCE_TYPE_RAPIDBOARDS_RESOURCE),
    getKey: ({ match: match })=>match.query.rapidView || '',
    getDataLoader: ()=>(parcelRequire("3B60s")),
    maxAge: Number.MAX_VALUE,
    isBrowserOnly: true
});

});
parcelRegister("3B60s", function(module, exports) {

let $29e97c844d21e36b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $29e97c844d21e36b$var$load("6irVr").then(()=>parcelRequire('LP66E'));

});


parcelRegister("fox5Q", function(module, exports) {

$parcel$export(module.exports, "wrmBundleResource", () => $bb15c3971b88e6fc$export$f199d15b7cd18df1);

var $2M1hQ = parcelRequire("2M1hQ");

var $4R6GH = parcelRequire("4R6GH");

var $1odlY = parcelRequire("1odlY");

var $PK2Tm = parcelRequire("PK2Tm");

const $bb15c3971b88e6fc$export$f199d15b7cd18df1 = (0, $2M1hQ.createResource)({
    type: (0, $1odlY.RESOURCE_TYPE_RAPIDBOARDS_WRM_BUNDLE),
    getKey: ({ route: route })=>{
        if ((0, $4R6GH.fg)('reports-overview-page-migration')) return (0, $PK2Tm.getRapidViewConfigFromRouteName)(route.name).stateKey;
        return 'state';
    },
    getDataLoader: ()=>(parcelRequire("4ntFd")),
    maxAge: Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});

});
parcelRegister("4ntFd", function(module, exports) {

let $33005208967f2911$var$load = (parcelRequire("28QjX"))(4);
module.exports = $33005208967f2911$var$load("iNwux").then(()=>parcelRequire('bdOyr'));

});



parcelRegister("f7Y15", function(module, exports) {

$parcel$export(module.exports, "uifBoardResource", () => $6f8724e78df4e830$export$b65bcbbccad354ac);

var $2M1hQ = parcelRequire("2M1hQ");


const $6f8724e78df4e830$export$b65bcbbccad354ac = (0, $2M1hQ.createResource)({
    type: (0, $16d4c226f5e6f5f8$export$cfae566ecf2855f8),
    getKey: ({ match: { params: { boardId: boardId } }, route: { name: routeName }, query: { config: config } })=>{
        if (config) return `uif-board::${routeName}::config`;
        if (boardId == null) return `uif-board::${routeName}::not-found`;
        return `uif-board::${routeName}::${boardId}`;
    },
    getDataLoader: ()=>(parcelRequire("jjilt")),
    maxAge: 0
});

});
const $16d4c226f5e6f5f8$export$cfae566ecf2855f8 = 'UIF_BOARD';

parcelRegister("jjilt", function(module, exports) {

let $e0ee05ab20857320$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e0ee05ab20857320$var$load("kAOBH").then(()=>parcelRequire('1HjYz'));

});


parcelRegister("lJ1FP", function(module, exports) {

$parcel$export(module.exports, "editModelResource", () => $16cc53c7df259df5$export$ab9a4786826fd2d);
$parcel$export(module.exports, "getEditModelResource", () => $16cc53c7df259df5$export$5b9bac2cc4bf4511);

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $7f4tk = parcelRequire("7f4tk");

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");

var $PK2Tm = parcelRequire("PK2Tm");
const $16cc53c7df259df5$export$ddbb511f9111736a = async (boardId)=>{
    try {
        return await (0, $7f4tk.default)(`/rest/greenhopper/1.0/rapidviewconfig/editmodel.json?cardLayoutConfig=false&rapidViewId=${boardId}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'getEditModelRequest',
                packageName: 'jiraRouterResourcesClassicProjects',
                teamName: 'a4t-pandora'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $16cc53c7df259df5$export$ab9a4786826fd2d = (0, $2M1hQ.createResource)({
    type: 'CLASSIC_BOARD_SETTING_EDIT_MODEL',
    getKey: (routerContext)=>(0, $PK2Tm.getConfigFromRouterContext)(routerContext) ? 'edit-model' : 'not-edit-model',
    getData: async (routerContext)=>{
        if ((0, $PK2Tm.getConfigFromRouterContext)(routerContext)) {
            const boardId = routerContext.match.params?.boardId ?? '';
            return $16cc53c7df259df5$export$ddbb511f9111736a(boardId);
        }
        return null;
    }
});
const $16cc53c7df259df5$export$5b9bac2cc4bf4511 = ()=>(0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('simplified-boards-milestone-2_07hbk') && !(0, $4R6GH.fg)('board-settings-graphql-refactor_cyvz9'), $16cc53c7df259df5$export$ab9a4786826fd2d);

});


parcelRegister("k7Q6G", function(module, exports) {

$parcel$export(module.exports, "connectGeneralServiceDeskProjectRoute", () => $d699769fc97b2ccd$export$e8a58aee75961b55);
const $d699769fc97b2ccd$export$e8a58aee75961b55 = {
    name: 'connect-general-service-desk-project',
    path: '/plugins/servlet/ac/:addonKey/:moduleKey',
    query: [
        'mobile?!=true',
        'includeWebResources?!=true',
        'classifier?!=json',
        'project.key?',
        'project.id?',
        'project.key',
        'servicedesk.serviceDeskId'
    ]
};

});


parcelRegister("4Zw1h", function(module, exports) {

$parcel$export(module.exports, "connectProjectRouteEntry", () => $88ce8816647240e1$export$96bdc57a01f2ee48);

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $dx5ZK = parcelRequire("dx5ZK");

var $cYYI7 = parcelRequire("cYYI7");

var $iTDbG = parcelRequire("iTDbG");
const $88ce8816647240e1$export$96bdc57a01f2ee48 = (0, $7NszV.createEntry)((0, $dx5ZK.connectProjectRoute), ()=>({
        group: 'connect',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        layout: (0, $gyYxw.genericProjectLayout),
        ufoName: 'jira-connect',
        // Match resources that are fetched for legacyConnectProjectRouteEntry
        // See src/packages/router-routes/legacy/connect-project/entries/src/index.tsx
        resources: [
            ...(0, $cYYI7.getProjectConnectRouteDefaultResources)(),
            ...(0, $fpjJX.getServiceDeskSharedNavigationSingleResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>(0, $iTDbG.connectProjectsPageEntrypoint)
    }));

});
parcelRegister("dx5ZK", function(module, exports) {

$parcel$export(module.exports, "connectProjectRoute", () => $e3a0435584f46760$export$27e7531864dfb704);

var $kUeZd = parcelRequire("kUeZd");
const $e3a0435584f46760$export$27e7531864dfb704 = {
    name: 'connect-project',
    path: '/projects/:projectKey',
    query: (0, $kUeZd.CONNECT_PROJECT_QUERY_PARAMS)
};

});
parcelRegister("kUeZd", function(module, exports) {

$parcel$export(module.exports, "CONNECT_PROJECT_QUERY_PARAMS", () => $e64562bb8c3fa371$export$9bb839aee83bf4d8);
const $e64562bb8c3fa371$export$9bb839aee83bf4d8 = [
    'selectedItem=(^com.atlassian.plugins.atlassian-connect-plugin.*)'
];

});


parcelRegister("iTDbG", function(module, exports) {

$parcel$export(module.exports, "connectProjectsPageEntrypoint", () => $c9a4402f23043c3c$export$d7105af2aa9527d0);
$parcel$export(module.exports, "connectProjectsWithoutHorizontalNavPageEntrypoint", () => $c9a4402f23043c3c$export$8df81c5e9c00a7b4);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $8vOSr = parcelRequire("8vOSr");

var $fo6b8 = parcelRequire("fo6b8");
const $c9a4402f23043c3c$export$d7105af2aa9527d0 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $8vOSr.connectProjectsEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $c9a4402f23043c3c$export$8df81c5e9c00a7b4 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $8vOSr.connectProjectsEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("8vOSr", function(module, exports) {

$parcel$export(module.exports, "connectProjectsEntrypoint", () => $b7bf9b62cbd74d5f$export$4ff832a017f5175c);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $b7bf9b62cbd74d5f$export$4ff832a017f5175c = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("TL3kb")), {
        moduleId: "2203c501"
    }),
    getPreloadProps: ({ context: context })=>({
            extraProps: {
                query: context.query
            }
        })
});

});
parcelRegister("TL3kb", function(module, exports) {

let $0a79a2d6e1ac8fa6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0a79a2d6e1ac8fa6$var$load("kmeN2").then(()=>parcelRequire('2GYK9'));

});




parcelRegister("iLmKH", function(module, exports) {

$parcel$export(module.exports, "servicedeskConnectProjectRouteEntry", () => $ec6bba63502dd6b2$export$72138a83eeba68eb);

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $4IAAz = parcelRequire("4IAAz");

var $6Z2mh = parcelRequire("6Z2mh");

var $cYYI7 = parcelRequire("cYYI7");

var $iTDbG = parcelRequire("iTDbG");
const $ec6bba63502dd6b2$export$72138a83eeba68eb = (0, $7NszV.createEntry)((0, $4IAAz.servicedeskConnectProjectRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $cYYI7.getProjectConnectRouteDefaultResources)(),
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        ufoName: 'jira-connect',
        entryPoint: ()=>(0, $iTDbG.connectProjectsWithoutHorizontalNavPageEntrypoint)
    }));

});
parcelRegister("4IAAz", function(module, exports) {

$parcel$export(module.exports, "servicedeskConnectProjectRoute", () => $03d8cdc4dcb18bd2$export$148fcbe26061b2c9);

var $kUeZd = parcelRequire("kUeZd");
const $03d8cdc4dcb18bd2$export$148fcbe26061b2c9 = {
    name: 'servicedesk-connect-project',
    path: '/jira/servicedesk/projects/:projectKey',
    query: (0, $kUeZd.CONNECT_PROJECT_QUERY_PARAMS),
    exact: true
};

});


parcelRegister("dqjth", function(module, exports) {

$parcel$export(module.exports, "createProjectRouteEntry", () => $7e202110676952db$export$28887e2da22c839a);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $gyYxw = parcelRequire("gyYxw");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $R0AuF = parcelRequire("R0AuF");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $7e202110676952db$var$LazyCreateProject = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("f75gk")), {
    moduleId: "./src/packages/spa-apps/create-project/src/index.tsx"
});
const $7e202110676952db$var$CreateProject = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $7e202110676952db$var$LazyCreateProject,
        pageId: "spa-apps/create-project",
        shouldShowSpinner: true
    });
const $7e202110676952db$export$28887e2da22c839a = (0, $7NszV.createEntry)((0, $R0AuF.createProjectRoute), ()=>({
        group: 'components',
        component: $7e202110676952db$var$CreateProject,
        layout: (0, $gyYxw.genericProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $7e202110676952db$var$LazyCreateProject
        ]
    }));

});
parcelRegister("R0AuF", function(module, exports) {

$parcel$export(module.exports, "createProjectRoute", () => $e9869d33b741028e$export$5ce9108542315ac8);
const $e9869d33b741028e$export$5ce9108542315ac8 = {
    name: 'create-project',
    path: '/jira/create-project',
    exact: true
};

});

parcelRegister("f75gk", function(module, exports) {

let $b00b976f963e900e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b00b976f963e900e$var$load("5Vt5L").then(()=>parcelRequire('6cT2s'));

});


parcelRegister("2fNbh", function(module, exports) {

$parcel$export(module.exports, "dashboardEditRouteEntry", () => $ff9c4f8f4f936d52$export$9b0fdfd6a51a17de);

var $j6woB = parcelRequire("j6woB");


var $e2ctp = parcelRequire("e2ctp");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $gh1hi = parcelRequire("gh1hi");

var $3RJkv = parcelRequire("3RJkv");

var $gCJaT = parcelRequire("gCJaT");

var $h4rc7 = parcelRequire("h4rc7");

var $irlpm = parcelRequire("irlpm");

var $lkFvK = parcelRequire("lkFvK");

var $fT58V = parcelRequire("fT58V");

var $ernoj = parcelRequire("ernoj");
const $ff9c4f8f4f936d52$export$9b0fdfd6a51a17de = (0, $7NszV.createEntry)((0, $gCJaT.dashboardEditRoute), ()=>({
        group: 'dashboard',
        entryPoint: ()=>$ff9c4f8f4f936d52$var$pageEntryPoint,
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $j6woB.dashboardBackgroundScriptsLayout)),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).DASHBOARDS,
            sidebarId: (0, $lmyls.SIDEBAR_ID).CONTENT
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $ernoj.dashboardResources)(),
            (0, $gh1hi.gadgetDirectoryResource)
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
        },
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));
// Page entrypoint, referred to above...
const $ff9c4f8f4f936d52$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $irlpm.dashboardEditEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).DASHBOARDS,
    leftSidebar: {
        sidebar: (0, $fT58V.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            dashboards: {
                entryPoint: (0, $h4rc7.nav4DashboardsContentEntryPoint)
            }
        }
    }
});

});
parcelRegister("j6woB", function(module, exports) {

$parcel$export(module.exports, "dashboardBackgroundScriptsLayout", () => $90a067693c09e346$export$f0a12e66953aa38a);

var $aPfsS = parcelRequire("aPfsS");

var $Xtn30 = parcelRequire("Xtn30");
const $90a067693c09e346$export$f0a12e66953aa38a = (0, $aPfsS.createLayout)({
    globalComponents: [
        (0, $Xtn30.DashboardBackgroundScripts)
    ]
});

});
parcelRegister("Xtn30", function(module, exports) {

$parcel$export(module.exports, "DashboardBackgroundScripts", () => $79510dabdd765f30$export$4095842bb2e8d712);

var $fZUl0 = parcelRequire("fZUl0");
const $79510dabdd765f30$export$4095842bb2e8d712 = (0, $fZUl0.LazyAfterPaintBackgroundScripts);
$79510dabdd765f30$export$4095842bb2e8d712.displayName = 'ConditionalDashboardBackgroundScripts';

});
parcelRegister("fZUl0", function(module, exports) {

$parcel$export(module.exports, "LazyAfterPaintBackgroundScripts", () => $f2fce09c535c3a19$export$d4768112536c9dc9);

var $kxZPA = parcelRequire("kxZPA");

const $f2fce09c535c3a19$export$d4768112536c9dc9 = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("heTtZ")), {
    ssr: false,
    moduleId: "./src/packages/global-pages/dashboard/background-scripts/src/ui/index.tsx"
});

});
parcelRegister("heTtZ", function(module, exports) {

let $c8cec82a098e213d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c8cec82a098e213d$var$load("jSyxJ").then(()=>parcelRequire('bjmK5'));

});




parcelRegister("e2ctp", function(module, exports) {

$parcel$export(module.exports, "NORMAL_EARLY_ASSET_STRATEGY", () => $f36666704bcc2bab$export$137d6d169f402a59);
$parcel$export(module.exports, "AGGRESSIVE_EARLY_ASSET_STRATEGY", () => $f36666704bcc2bab$export$ad16a91905cefb0a);
const $f36666704bcc2bab$var$COMMON_ASSET_REGEX = /.*\/commons(-entry|~[0-9a-z]*)?(\.[0-9a-z]*)?(\.[0-9])?\.js/;
const $f36666704bcc2bab$var$VENDOR_ASSET_REGEX = /.*\/vendor(-entry|~[0-9a-z]*)?(\.[0-9a-z]*)?(\.[0-9])?\.js/;
const $f36666704bcc2bab$var$PARCEL_COMMON_ASSET_REGEX = /.*\/shared~commons(~ar)?(\.[0-9a-z]*)\.js/;
const $f36666704bcc2bab$var$PARCEL_VENDOR_ASSET_REGEX = /.*\/shared~vendor(~ar)?(\.[0-9a-z]*)\.js/;
const $f36666704bcc2bab$export$137d6d169f402a59 = [
    $f36666704bcc2bab$var$VENDOR_ASSET_REGEX,
    $f36666704bcc2bab$var$PARCEL_VENDOR_ASSET_REGEX
];
const $f36666704bcc2bab$export$ad16a91905cefb0a = [
    $f36666704bcc2bab$var$VENDOR_ASSET_REGEX,
    $f36666704bcc2bab$var$COMMON_ASSET_REGEX,
    $f36666704bcc2bab$var$PARCEL_VENDOR_ASSET_REGEX,
    $f36666704bcc2bab$var$PARCEL_COMMON_ASSET_REGEX
];

});

parcelRegister("gh1hi", function(module, exports) {

$parcel$export(module.exports, "dashboardConfigAndWRMResource", () => $ca62b878c99c7128$export$2853c0e656e89346);
$parcel$export(module.exports, "useDashboardResource", () => $ca62b878c99c7128$export$e5e5b3f462d6a4cb);
$parcel$export(module.exports, "useMultiDashboardsResource", () => $ca62b878c99c7128$export$6a46406b05d8d13c);
$parcel$export(module.exports, "dashboardAMDModulesResource", () => $ca62b878c99c7128$export$ef3fa55626812fa4);
$parcel$export(module.exports, "useDashboardAMDModulesResource", () => $ca62b878c99c7128$export$efe0eb9a44e08d38);
$parcel$export(module.exports, "dashboardReactGadgetsResource", () => $ca62b878c99c7128$export$39804ce8cc42cd04);
$parcel$export(module.exports, "useDashboardReactGadgetsResource", () => $ca62b878c99c7128$export$31b430e01a1caab5);
$parcel$export(module.exports, "dashboardForgeResource", () => $ca62b878c99c7128$export$4e0719e53da01e93);
$parcel$export(module.exports, "gadgetDirectoryResource", () => $ca62b878c99c7128$export$36c9632be21fbb06);
$parcel$export(module.exports, "useGadgetDirectoryResource", () => $ca62b878c99c7128$export$27f4c12e781b4572);
$parcel$export(module.exports, "useDashboardForgeResource", () => $ca62b878c99c7128$export$75ca1b431898fd09);

var $k2DRb = parcelRequire("k2DRb");

var $iVaKa = parcelRequire("iVaKa");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $3Yd87 = parcelRequire("3Yd87");

var $abozY = parcelRequire("abozY");


var $04Brv = parcelRequire("04Brv");

var $3cb5I = parcelRequire("3cb5I");

var $aVFmC = parcelRequire("aVFmC");

var $3Zhqx = parcelRequire("3Zhqx");

var $8oOn8 = parcelRequire("8oOn8");
const $ca62b878c99c7128$export$2853c0e656e89346 = (0, $2M1hQ.createResource)({
    type: (0, $e03099b7bef7f4cd$export$ca03ff6cc792cc16),
    getKey: $abozY.getKey,
    getData: (0, $3cb5I.default),
    maxAge: Infinity
});
// the type signature of promise and update is different on the useDashboardResource and useMultiDashboardsResource hook
const $ca62b878c99c7128$var$extractFirstPromise = (promise)=>promise ? promise.then((configs)=>configs && configs[0]) : null;
const $ca62b878c99c7128$export$e5e5b3f462d6a4cb = ()=>{
    // the response will have different signature on update, promise and clear etc
    const resourceResponse = $ca62b878c99c7128$export$6a46406b05d8d13c();
    const { loading: loading, error: error, data: data, promise: promiseOfMultiConfigs, ...rest } = resourceResponse;
    const extractFirstUpdate = (getNewData)=>resourceResponse.update(([a])=>[
                getNewData(a)
            ]);
    // RouteResourceResponseLoading type
    if (loading) return {
        ...rest,
        error: null,
        data: null,
        promise: $ca62b878c99c7128$var$extractFirstPromise(promiseOfMultiConfigs),
        loading: true,
        update: extractFirstUpdate
    };
    // RouteResourceResponseError type
    if (error) return {
        ...rest,
        error: error,
        data: null,
        promise: $ca62b878c99c7128$var$extractFirstPromise(promiseOfMultiConfigs),
        loading: false,
        update: extractFirstUpdate
    };
    // RouteResourceResponseLoaded type
    if (data && !error) return {
        ...rest,
        loading: false,
        update: extractFirstUpdate,
        data: data[0],
        error: null,
        promise: $ca62b878c99c7128$var$extractFirstPromise(promiseOfMultiConfigs)
    };
    // RouteResourceResponseInitial type
    return {
        ...rest,
        loading: false,
        error: error,
        data: null,
        promise: null,
        update: extractFirstUpdate
    };
};
const $ca62b878c99c7128$export$6a46406b05d8d13c = ()=>(0, $2YP9W.useResource)($ca62b878c99c7128$export$2853c0e656e89346);
const $ca62b878c99c7128$export$ef3fa55626812fa4 = (0, $3Yd87.createDependentResource)({
    type: (0, $e03099b7bef7f4cd$export$e239393fd4e2bc85),
    getKey: $abozY.getKey,
    depends: [
        (0, $e03099b7bef7f4cd$export$ca03ff6cc792cc16)
    ],
    mapToSharedValue: (0, $3Yd87.withEitherDataOrError)((data)=>{
        const { gadgets: gadgets, preloadedModuleNames: preloadedModuleNames } = data.reduce((prev, curr)=>({
                gadgets: prev.gadgets.concat(curr.gadgets),
                preloadedModuleNames: prev.preloadedModuleNames.concat(curr.preloadedModuleNames)
            }), {
            gadgets: [],
            preloadedModuleNames: []
        });
        const moduleNames = (0, $8oOn8.gadgetsToUniqueSortedAmdModules)(gadgets);
        const isPreloaded = moduleNames.every((name)=>preloadedModuleNames.includes(name));
        return {
            moduleNames: moduleNames,
            isPreloaded: isPreloaded
        };
    }, (x)=>x),
    shouldUpdate: ({ sharedValue: a, amdModules: amdModules }, b)=>(0, $3Yd87.withEitherDataOrError)((prev, next)=>next.moduleNames.length > prev.moduleNames.length || next.moduleNames.some((name)=>amdModules?.[name] == null), ()=>true)(a, b),
    getData: (0, $04Brv.default),
    maxAge: Infinity,
    isBrowserOnly: true
});
const $ca62b878c99c7128$export$efe0eb9a44e08d38 = ()=>(0, $2YP9W.useResource)($ca62b878c99c7128$export$ef3fa55626812fa4);
const $ca62b878c99c7128$export$39804ce8cc42cd04 = (0, $3Yd87.createDependentResource)({
    type: (0, $e03099b7bef7f4cd$export$9e5db01432b13b67),
    getKey: $abozY.getKey,
    depends: [
        (0, $e03099b7bef7f4cd$export$ca03ff6cc792cc16)
    ],
    mapToSharedValue: (0, $3Yd87.withEitherDataOrError)((data)=>{
        const gadgets = data.flatMap((dashboard)=>dashboard.gadgets);
        return {
            reactGadgets: (0, $8oOn8.gadgetsToSortedReactGadgets)(gadgets)
        };
    }, (x)=>x),
    shouldUpdate: ({ sharedValue: a, reactGadgetsState: reactGadgetsState }, b)=>(0, $3Yd87.withEitherDataOrError)((prev, next)=>JSON.stringify(next.reactGadgets) !== JSON.stringify(prev.reactGadgets) || reactGadgetsState != null && Object.values(reactGadgetsState).some((v)=>!v), ()=>true)(a, b),
    getData: (0, $3Zhqx.default),
    maxAge: Infinity,
    isBrowserOnly: true
});
const $ca62b878c99c7128$export$31b430e01a1caab5 = ()=>(0, $2YP9W.useResource)($ca62b878c99c7128$export$39804ce8cc42cd04);
const $ca62b878c99c7128$export$4e0719e53da01e93 = (0, $2M1hQ.createResource)({
    type: (0, $e03099b7bef7f4cd$export$bce41807cc929d0f),
    getKey: $abozY.getKey,
    getData: async (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        const modules = await (0, $iVaKa.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $k2DRb.DASHBOARD_GADGET_MODULE),
                (0, $k2DRb.DASHBOARD_BACKGROUND_SCRIPT_MODULE)
            ],
            context: {},
            includeHidden: false,
            source: (0, $k2DRb.SOURCE_ROUTER)
        });
        return {
            gadgets: modules[0, $k2DRb.DASHBOARD_GADGET_MODULE],
            backgroundScripts: modules[0, $k2DRb.DASHBOARD_BACKGROUND_SCRIPT_MODULE]
        };
    },
    maxAge: Infinity
});
const $ca62b878c99c7128$export$36c9632be21fbb06 = (0, $2M1hQ.createResource)({
    type: (0, $e03099b7bef7f4cd$export$c07a25ebb6af1e84),
    getKey: ()=>'gadgetDirectoryItems',
    getData: (0, $aVFmC.default),
    maxAge: Infinity,
    isBrowserOnly: true
});
const $ca62b878c99c7128$export$27f4c12e781b4572 = ()=>(0, $2YP9W.useResource)($ca62b878c99c7128$export$36c9632be21fbb06);
const $ca62b878c99c7128$export$75ca1b431898fd09 = ()=>(0, $2YP9W.useResource)($ca62b878c99c7128$export$4e0719e53da01e93);

});
parcelRegister("3Yd87", function(module, exports) {

$parcel$export(module.exports, "withEitherDataOrError", () => $3e606a4e02c14aae$export$54e973088fdd59a1);
$parcel$export(module.exports, "createDependentResource", () => $3e606a4e02c14aae$export$7f8dd41bdfd85a47);
$parcel$export(module.exports, "SharedValueAggregateError", () => $3e606a4e02c14aae$export$36d5102d613df7c6);

var $2M1hQ = parcelRequire("2M1hQ");
var $htn2f = parcelRequire("htn2f");
const $3e606a4e02c14aae$export$54e973088fdd59a1 = (dataFn, errorFn)=>(...args)=>{
        const invalidArgs = args.filter((v)=>v == null || v instanceof Error);
        return invalidArgs.length ? errorFn(invalidArgs[0]) : dataFn(...args);
    };
const $3e606a4e02c14aae$export$fcdc85dfc621ec7a = (dependencies, type)=>{
    // the standard in react-resource-router is to fail getData() for dependency errors
    const { [type]: resourceSlice } = dependencies;
    if (!resourceSlice) throw new (0, $htn2f.ResourceDependencyError)(`Cannot decode dependency "${type}", it may be missing from resource depends field`);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return resourceSlice.data;
};
const $3e606a4e02c14aae$export$bee6a631bfb54474 = (dependencies, type)=>{
    // the standard in react-resource-router is to fail getData() for dependency errors
    const { [type]: resourceSlice } = dependencies;
    if (!resourceSlice) throw new Error(`Cannot decode dependency: "${type}" must be included in the resource depends field`);
    // prefer previous value rather than error
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { loading: loading, data: data, promise: promise, error: error } = resourceSlice;
    return loading && promise ? promise.then((v)=>v, (e)=>data ?? e) : data ?? error;
};
const $3e606a4e02c14aae$export$7f8dd41bdfd85a47 = ({ type: type, depends: depends, mapToSharedValue: mapToSharedValue, shouldUpdate: shouldUpdate, getData: getData, ...rest })=>(0, $2M1hQ.createResource)({
        ...rest,
        type: type,
        depends: [
            ...depends,
            type
        ],
        getData: (dataContext, storeContext)=>{
            const { dependencies: dependencies } = dataContext;
            const prevValue = $3e606a4e02c14aae$export$fcdc85dfc621ec7a(dependencies, type);
            const valuesOrPromises = depends.map((d)=>$3e606a4e02c14aae$export$bee6a631bfb54474(dependencies, d));
            const implementation = (depDataOrErrorOrNull)=>{
                const newShared = mapToSharedValue(...depDataOrErrorOrNull);
                return prevValue == null || prevValue instanceof Error || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                shouldUpdate(prevValue, newShared) ? getData(prevValue, newShared)(dataContext, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                storeContext) : prevValue;
            };
            return valuesOrPromises.some((v)=>v instanceof Promise) ? Promise.allSettled(valuesOrPromises).then((arr)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                arr.map((v)=>v.status === 'fulfilled' ? v.value : v.reason)).then(implementation) : implementation(valuesOrPromises);
        }
    });
class $3e606a4e02c14aae$export$36d5102d613df7c6 extends Error {
    constructor({ name: name, isPrefetch: isPrefetch, sharedValue: sharedValue }){
        super(`${name} is missing dependency, prefetch [${isPrefetch}] sharedValue [${sharedValue}]`);
        this.skipSentry = true;
    }
}

});

parcelRegister("abozY", function(module, exports) {

$parcel$export(module.exports, "getKey", () => $707c98c2b1b4b40d$export$a47fb462a08de82f);
// eslint-disable-next-line jira/import-whitelist

var $JIPqS = parcelRequire("JIPqS");
const $707c98c2b1b4b40d$export$a47fb462a08de82f = ({ route: route, query: query, match: { params: params } })=>{
    if (route.name === 'system-dashboard-edit') return 0, $JIPqS.SYSTEM_DASHBOARD_ID;
    if (route.name === 'dashboard-wallboard') // NOTE - Currently we will only load the first dashboard in the list
    return query.dashboardId?.split(',')[0];
    return params.dashboardId?.replace('last-visited', 'lastVisited') ?? query.selectPageId ?? 'lastVisited';
};

});
parcelRegister("JIPqS", function(module, exports) {

$parcel$export(module.exports, "GADGET_DISPLAY", () => $6c7fd970bbaee123$export$d7e1dfcefcde2410);
$parcel$export(module.exports, "MAXIMIZED_PARAM", () => $6c7fd970bbaee123$export$86eaa19ea940a4f5);
$parcel$export(module.exports, "CONNECT_ITEM_AMD_MODULE", () => $6c7fd970bbaee123$export$a1baea8b97610fd);
$parcel$export(module.exports, "WEB_RESOURCE_MAP", () => $6c7fd970bbaee123$export$c6d360a8456d120a);
$parcel$export(module.exports, "PRELOADED_GADGET_DATA_KEY", () => $6c7fd970bbaee123$export$30b970d16c2f5e0a);
$parcel$export(module.exports, "SYSTEM_DASHBOARD_ID", () => $6c7fd970bbaee123$export$50eac80bcbebc737);
$parcel$export(module.exports, "DASHBOARD_HEADER_HEIGHT", () => $6c7fd970bbaee123$export$e11ffd0409aa6522);
$parcel$export(module.exports, "FOOTER_MARGIN", () => $6c7fd970bbaee123$export$4d708f4c16ae3a73);
$parcel$export(module.exports, "STORAGE_PREFIX", () => $6c7fd970bbaee123$export$7cc65d02ca2e18ec);
$parcel$export(module.exports, "GADGET_LOCAL_STORAGE_NAME", () => $6c7fd970bbaee123$export$255117c9adec50a5);
$parcel$export(module.exports, "DASHBOARD_LOCAL_STORAGE_KEY_NAME", () => $6c7fd970bbaee123$export$e281465c09f561d4);
$parcel$export(module.exports, "GADGET_DEFAULT_HEIGHT", () => $6c7fd970bbaee123$export$46dd0168a7875b47);
$parcel$export(module.exports, "COLOR_MAP", () => $6c7fd970bbaee123$export$1468aefba37090f9);
$parcel$export(module.exports, "COLOR_NAME_MAP", () => $6c7fd970bbaee123$export$5d9e688e192a63ae);
$parcel$export(module.exports, "COLOR_CHECKMARK_MAP", () => $6c7fd970bbaee123$export$6906a4beef307ac4);
$parcel$export(module.exports, "MODAL_ID", () => $6c7fd970bbaee123$export$ebdd5a8e5b1c2de5);
$parcel$export(module.exports, "LAYOUTS", () => $6c7fd970bbaee123$export$87e50aced9c52ebb);
$parcel$export(module.exports, "GADGET_HEIGHT_UPDATE_WAIT_TIME", () => $6c7fd970bbaee123$export$b0234a47b1a4a515);
$parcel$export(module.exports, "GADGET_DRAG_CONTAINER_HEIGHT", () => $6c7fd970bbaee123$export$9674cd14c20d1c89);
$parcel$export(module.exports, "GADGET_METRICS_TYPE", () => $6c7fd970bbaee123$export$46b6c8eb53069613);
$parcel$export(module.exports, "PAGE_READY_METRIC_KEY", () => $6c7fd970bbaee123$export$464d2a6bcb398791);
$parcel$export(module.exports, "DELETE_DASHBOARD_EXPERIENCE", () => $6c7fd970bbaee123$export$4f74f1f13671c49d);
$parcel$export(module.exports, "COPY_DASHBOARD_EXPERIENCE", () => $6c7fd970bbaee123$export$3853fce65645c557);
$parcel$export(module.exports, "DASHBOARD_AUTOMATIC_REFRESH_EXPERIENCE", () => $6c7fd970bbaee123$export$c8c77659771c38b9);
$parcel$export(module.exports, "RENAME_OR_SHARE_DASHBOARD_EXPERIENCE", () => $6c7fd970bbaee123$export$707702c47e5b9648);
$parcel$export(module.exports, "CREATE_DASHBOARD_EXPERIENCE", () => $6c7fd970bbaee123$export$efbab4efa7252143);
$parcel$export(module.exports, "VIEW_DASHBOARD_EDITABLE_EXPERIENCE", () => $6c7fd970bbaee123$export$7b6f3ec1189de156);
$parcel$export(module.exports, "VIEW_DASHBOARD_READONLY_EXPERIENCE", () => $6c7fd970bbaee123$export$f0e105144716a420);
$parcel$export(module.exports, "VIEW_DASHBOARD_READONLY_EMBED_EXPERIENCE", () => $6c7fd970bbaee123$export$5ba84cd082269cd5);
$parcel$export(module.exports, "VIEW_DASHBOARD_WALLBOARD_READONLY_EXPERIENCE", () => $6c7fd970bbaee123$export$6c84c6099fed3c23);
$parcel$export(module.exports, "ADD_GADGET_EXPERIENCE", () => $6c7fd970bbaee123$export$3b17b4f7f722b1ae);
$parcel$export(module.exports, "SAVE_AMD_GADGET_CONFIG_PREFERENCES", () => $6c7fd970bbaee123$export$c8900d7e874d42ca);
$parcel$export(module.exports, "SAVE_FORGE_GADGET_CONFIG_PREFERENCES", () => $6c7fd970bbaee123$export$bac5a3e9d008da59);
$parcel$export(module.exports, "SAVE_CUSTOM_GADGET_TITLE_PREFERENCES", () => $6c7fd970bbaee123$export$18b54b2c53cf6acd);
$parcel$export(module.exports, "VIEW_WRM_GADGET_EXPERIENCE", () => $6c7fd970bbaee123$export$a3d5b76ea0c8f4ca);
$parcel$export(module.exports, "CHANGE_LAYOUT_EXPERIENCE", () => $6c7fd970bbaee123$export$7254246f25b4cbc8);
$parcel$export(module.exports, "DELETE_GADGET_EXPERIENCE", () => $6c7fd970bbaee123$export$40c4d345e57fce2d);
$parcel$export(module.exports, "VIEW_REACT_GADGET_EXPERIENCE", () => $6c7fd970bbaee123$export$43fb10a4d8374f1a);
$parcel$export(module.exports, "DASHBOARD_VIEW_SOURCENAME", () => $6c7fd970bbaee123$export$2f961c74af6d8735);
$parcel$export(module.exports, "DASHBOARD_VIEW_EMBED_SOURCENAME", () => $6c7fd970bbaee123$export$dab1096b356df1cc);
$parcel$export(module.exports, "DASHBOARD_EDIT_SOURCENAME", () => $6c7fd970bbaee123$export$32f0edca4eebb9c7);
$parcel$export(module.exports, "DASHBOARD_WALLBOARD_VIEW_SOURCENAME", () => $6c7fd970bbaee123$export$791f7067c41dc5b1);
$parcel$export(module.exports, "SYSTEM_DASHBOARD_EDIT_SOURCENAME", () => $6c7fd970bbaee123$export$eba1a497984af3ae);
$parcel$export(module.exports, "COPY_DASHBOARD", () => $6c7fd970bbaee123$export$3578044b625436f9);
$parcel$export(module.exports, "DASHBOARD_AUTOMATIC_REFRESH", () => $6c7fd970bbaee123$export$48bb59a846d62ea0);
$parcel$export(module.exports, "DELETE_DASHBOARD", () => $6c7fd970bbaee123$export$e7dfbcf33cf2b19a);
$parcel$export(module.exports, "DUPLICATE_GADGET_EXPERIENCE", () => $6c7fd970bbaee123$export$fabf79b25b44377f);
$parcel$export(module.exports, "RENAME_OR_SHARE_DASHBOARD", () => $6c7fd970bbaee123$export$abba919f32a1a776);
$parcel$export(module.exports, "GADGET_ERROR_TYPE", () => $6c7fd970bbaee123$export$768dad6811159849);
$parcel$export(module.exports, "DASHBOARD_REFRESH_LOAD_BUFFER_MS", () => $6c7fd970bbaee123$export$ada294d471e7dfc3);
$parcel$export(module.exports, "REFRESH_LABEL_UPDATE_INTERVAL", () => $6c7fd970bbaee123$export$f4280aaeba4d1d08);
$parcel$export(module.exports, "CONNECT_GADGET_REFRESH_REQUEST_EVENT", () => $6c7fd970bbaee123$export$685171fdf5112bc4);
$parcel$export(module.exports, "FORGE_JIRA_DASHBOARD_GADGET_REFRESH_EVENT", () => $6c7fd970bbaee123$export$4d8c12b9aaeac619);
$parcel$export(module.exports, "ISSUE_SEARCH_DEFAULT_COLUMNS", () => $6c7fd970bbaee123$export$f07dac7b8de3bda);


var $gwIPs = parcelRequire("gwIPs");

var $cKw8Y = parcelRequire("cKw8Y");
const $6c7fd970bbaee123$export$d7e1dfcefcde2410 = {
    MAXIMIZED: 'maximized',
    NORMAL: 'normal',
    HIDDEN: 'hidden'
};
const $6c7fd970bbaee123$export$86eaa19ea940a4f5 = 'maximized';
const $6c7fd970bbaee123$export$a1baea8b97610fd = 'atlassian-connect/connect-dashboard-item';
const $6c7fd970bbaee123$export$c6d360a8456d120a = {
    'jira-dashboard-items/assigned-to-me': 'com.atlassian.jira.gadgets:assigned-to-me-dashboard-item-resources',
    'jira-dashboard-items/filter-results': 'com.atlassian.jira.gadgets:filter-results-dashboard-item-resources',
    'jira-dashboard-items/createdvsresolved': 'com.atlassian.jira.gadgets:createdvsresolved-dashboard-item-resources',
    'jira-dashboard-items/favourite-filters': 'com.atlassian.jira.gadgets:favourite-filters-dashboard-item-resources',
    'jira-dashboard-items/in-progress': 'com.atlassian.jira.gadgets:in-progress-dashboard-item-resources',
    'jira-dashboard-items/stats': 'com.atlassian.jira.gadgets:stats-dashboard-item-resources',
    'jira-dashboard-items/watched': 'com.atlassian.jira.gadgets:watched-dashboard-item-resources',
    'jira-dashboard-items/labels': 'com.atlassian.jira.gadgets:labels-dashboard-item-resources',
    'jira-dashboard-items/bubble-chart-dashboard-item': 'com.atlassian.jira.gadgets:bubble-chart-dashboard-item-resources',
    'jira-dashboard-items/piechart': 'com.atlassian.jira.gadgets:piechart-dashboard-item-resources',
    'jira-dashboard-items/voted': 'com.atlassian.jira.gadgets:voted-dashboard-item-resources',
    'jira-dashboard-items/two-dimensional-stats': 'com.atlassian.jira.gadgets:two-dimensional-stats-dashboard-item-resources',
    'jira-dashboard-items/sprint-health': 'com.pyxis.greenhopper.jira:greenhopper-sprint-health-dashboard-item-resources',
    'jira-dashboard-items/sprint-days-remaining': 'com.pyxis.greenhopper.jira:greenhopper-days-remaining-dashboard-item-resources',
    'servicedesk/internal/dashboard-items/filter/filter-dashboard-item': 'com.atlassian.servicedesk.dashboard-items-plugin:spa-filter-dashboard-item-resources',
    'servicedesk/internal/reports/feature/custom-report-dashboard-item/custom-report-dashboard-item': 'com.atlassian.servicedesk.servicedesk-reports-plugin:custom-report-dashboard-item-resources-spa',
    'jira-dashboard-items/projects': 'com.atlassian.jira.gadgets:projects-dashboard-item-resources',
    'jira-dashboard-items/issuescalendar': 'com.atlassian.jira.ext.calendar:issues-calendar-dashboard-item-resources',
    'jira-dashboard-items/activitystream': 'com.atlassian.streams.streams-jira-plugin:activitystream-dashboard-item-resources',
    'jira-dashboard-items/recently-created': 'com.atlassian.jira.gadgets:recently-created-chart-dashboard-item-resources',
    'jira-dashboard-items/resolution-time': 'com.atlassian.jira.gadgets:resolution-time-dashboard-item-resources',
    'jira-dashboard-items/timesince': 'com.atlassian.jira.gadgets:timesince-dashboard-item-resources',
    'jira-dashboard-items/spacer': 'com.atlassian.jira.gadgets:spacer-dashboard-item-resources',
    'jira-dashboard-items/sprint-burndown': 'com.pyxis.greenhopper.jira:greenhopper-sprint-burndown-dashboard-item-resources',
    'jira-dashboard-items/workload-pie-chart': 'com.atlassian.jira.gadgets:workload-pie-chart-dashboard-item-resources',
    'jira-dashboard-items/roadmap': 'com.atlassian.jira.gadgets:roadmap-dashboard-item-resources',
    'jira-dashboard-items/average-age-chart': 'com.atlassian.jira.gadgets:average-age-chart-dashboard-item-resources',
    'jira-dashboard-items/average-time-in-status-chart': 'com.atlassian.jira.gadgets:average-time-in-status-chart-dashboard-item-resources',
    'jira-dashboard-items/average-number-of-times-in-status-chart': 'com.atlassian.jira.gadgets:average-number-of-times-in-status-chart-dashboard-item-resources',
    'jira-dashboard-items/heat-map': 'com.atlassian.jira.gadgets:heat-map-dashboard-item-resources',
    'jira-dashboard-items/time-to-first-response': 'com.atlassian.jira.gadgets:time-to-first-response-dashboard-item-resources',
    'jira-dashboard-items/rapid-view': 'com.pyxis.greenhopper.jira:greenhopper-rapid-view-dashboard-item-resources',
    'jira-dashboard-items/version-report': 'com.pyxis.greenhopper.jira:greenhopper-version-report-dashboard-item-resources'
};
const $6c7fd970bbaee123$export$30b970d16c2f5e0a = 'DASHBOARD_GADGET_PRELOADED_DATA';
const $6c7fd970bbaee123$export$50eac80bcbebc737 = '10000';
const $6c7fd970bbaee123$export$e11ffd0409aa6522 = (0, $gwIPs.gridSize) * 10;
const $6c7fd970bbaee123$export$4d708f4c16ae3a73 = (0, $gwIPs.gridSize) * 2;
const $6c7fd970bbaee123$export$7cc65d02ca2e18ec = 'dashboard';
const $6c7fd970bbaee123$export$255117c9adec50a5 = 'AG.congolmerate.cookie';
const $6c7fd970bbaee123$export$e281465c09f561d4 = 'dashboard-data';
const $6c7fd970bbaee123$export$46dd0168a7875b47 = 160;
const $6c7fd970bbaee123$var$COLOR_BLUE = '#2684ff';
const $6c7fd970bbaee123$var$COLOR_RED = '#ff5630';
const $6c7fd970bbaee123$var$COLOR_YELLOW = '#ffab00';
const $6c7fd970bbaee123$var$COLOR_GREEN = '#36b37e';
const $6c7fd970bbaee123$var$COLOR_TEAL = '#00b8d9';
const $6c7fd970bbaee123$var$COLOR_PURPLE = '#6554c0';
const $6c7fd970bbaee123$var$COLOR_GRAY = '#97a0af';
const $6c7fd970bbaee123$var$COLOR_WHITE = '#ffffff';
const $6c7fd970bbaee123$export$1468aefba37090f9 = {
    color1: $6c7fd970bbaee123$var$COLOR_BLUE,
    color2: $6c7fd970bbaee123$var$COLOR_RED,
    color3: $6c7fd970bbaee123$var$COLOR_YELLOW,
    color4: $6c7fd970bbaee123$var$COLOR_GREEN,
    color5: $6c7fd970bbaee123$var$COLOR_TEAL,
    color6: $6c7fd970bbaee123$var$COLOR_PURPLE,
    color7: $6c7fd970bbaee123$var$COLOR_GRAY,
    color8: $6c7fd970bbaee123$var$COLOR_WHITE
};
const $6c7fd970bbaee123$export$5d9e688e192a63ae = {
    [$6c7fd970bbaee123$var$COLOR_BLUE]: (0, $cKw8Y.default).blue,
    [$6c7fd970bbaee123$var$COLOR_RED]: (0, $cKw8Y.default).red,
    [$6c7fd970bbaee123$var$COLOR_YELLOW]: (0, $cKw8Y.default).yellow,
    [$6c7fd970bbaee123$var$COLOR_GREEN]: (0, $cKw8Y.default).green,
    [$6c7fd970bbaee123$var$COLOR_TEAL]: (0, $cKw8Y.default).teal,
    [$6c7fd970bbaee123$var$COLOR_PURPLE]: (0, $cKw8Y.default).purple,
    [$6c7fd970bbaee123$var$COLOR_GRAY]: (0, $cKw8Y.default).gray,
    [$6c7fd970bbaee123$var$COLOR_WHITE]: (0, $cKw8Y.default).white
};
const $6c7fd970bbaee123$export$6906a4beef307ac4 = {
    color1: (0, $829f609a65d26a98$exports).N10,
    color2: (0, $829f609a65d26a98$exports).N10,
    color3: (0, $829f609a65d26a98$exports).N500,
    color4: (0, $829f609a65d26a98$exports).N10,
    color5: (0, $829f609a65d26a98$exports).N500,
    color6: (0, $829f609a65d26a98$exports).N10,
    color7: (0, $829f609a65d26a98$exports).N10,
    color8: (0, $829f609a65d26a98$exports).N500
};
const $6c7fd970bbaee123$export$ebdd5a8e5b1c2de5 = {
    EDIT_LAYOUT: 'edit-layout',
    DASHBOARD_COPY: 'dashboard-copy',
    AUTOMATIC_REFRESH: 'dashboard-automatic-refresh',
    DASHBOARD_RENAME_OR_SHARE: 'dashboard-rename-or-share',
    DASHBOARD_DELETE: 'dashboard-delete',
    CONFIGURE_WALLBOARD: 'configure-wallboard',
    DASHBOARD_CREATE: 'dashboard-create-on-dashboard-page'
};
const $6c7fd970bbaee123$export$87e50aced9c52ebb = [
    'A',
    'AA',
    'AAA',
    'BA',
    'AB'
];
const $6c7fd970bbaee123$export$b0234a47b1a4a515 = 350;
const $6c7fd970bbaee123$export$9674cd14c20d1c89 = 250;
const $6c7fd970bbaee123$export$46b6c8eb53069613 = {
    REPORT: 'REPORT_GADGET_METRICS',
    TIMEOUT: 'TIMEOUT_GADGET_METRICS'
};
const $6c7fd970bbaee123$export$464d2a6bcb398791 = 'JIRA_SPA_PAGE_READY';
const $6c7fd970bbaee123$export$4f74f1f13671c49d = 'delete-dashboard';
const $6c7fd970bbaee123$export$3853fce65645c557 = 'copy-dashboard';
const $6c7fd970bbaee123$export$c8c77659771c38b9 = 'dashboard-automatic-refresh';
const $6c7fd970bbaee123$export$707702c47e5b9648 = 'rename-or-share-dashboard';
const $6c7fd970bbaee123$export$efbab4efa7252143 = 'create-dashboard';
const $6c7fd970bbaee123$export$7b6f3ec1189de156 = 'view-dashboard-editable';
const $6c7fd970bbaee123$export$f0e105144716a420 = 'view-dashboard-readonly';
const $6c7fd970bbaee123$export$5ba84cd082269cd5 = 'view-dashboard-readonly-embed';
const $6c7fd970bbaee123$export$6c84c6099fed3c23 = 'view-dashboard-wallboard-readonly';
const $6c7fd970bbaee123$export$3b17b4f7f722b1ae = 'add-gadget';
const $6c7fd970bbaee123$export$c8900d7e874d42ca = 'save-amd-gadget-config';
const $6c7fd970bbaee123$export$bac5a3e9d008da59 = 'save-forge-gadget-config';
const $6c7fd970bbaee123$export$18b54b2c53cf6acd = 'save-custom-gadget-title-config';
const $6c7fd970bbaee123$export$a3d5b76ea0c8f4ca = 'view-wrm-gadget';
const $6c7fd970bbaee123$export$7254246f25b4cbc8 = 'change-layout';
const $6c7fd970bbaee123$export$40c4d345e57fce2d = 'delete-gadget';
const $6c7fd970bbaee123$export$43fb10a4d8374f1a = 'view-react-gadget';
const $6c7fd970bbaee123$export$2f961c74af6d8735 = 'dashboardView';
const $6c7fd970bbaee123$export$dab1096b356df1cc = 'dashboardViewEmbed';
const $6c7fd970bbaee123$export$32f0edca4eebb9c7 = 'dashboardEdit';
const $6c7fd970bbaee123$export$791f7067c41dc5b1 = 'dashboardWallboardView';
const $6c7fd970bbaee123$export$eba1a497984af3ae = 'systemDashboardEdit';
const $6c7fd970bbaee123$export$3578044b625436f9 = 'copyDashboard';
const $6c7fd970bbaee123$export$48bb59a846d62ea0 = 'automaticRefresh';
const $6c7fd970bbaee123$export$e7dfbcf33cf2b19a = 'deleteDashboard';
const $6c7fd970bbaee123$export$fabf79b25b44377f = 'duplicateGadget';
const $6c7fd970bbaee123$export$abba919f32a1a776 = 'renameOrShareDashboard';
const $6c7fd970bbaee123$export$768dad6811159849 = {
    VIEW_ERROR: 'viewError',
    EDIT_ERROR: 'editError',
    CONFIG_ERROR: 'configError',
    NOT_SUPPORTED_ERROR: 'notSupportedError'
};
const $6c7fd970bbaee123$export$ada294d471e7dfc3 = 1000;
const $6c7fd970bbaee123$export$f4280aaeba4d1d08 = 30000;
const $6c7fd970bbaee123$export$685171fdf5112bc4 = 'jira_dashboard_item_refresh';
const $6c7fd970bbaee123$export$4d8c12b9aaeac619 = 'JIRA_DASHBOARD_GADGET_REFRESH';
const $6c7fd970bbaee123$export$f07dac7b8de3bda = [
    'issuetype',
    'issuekey',
    'summary',
    'priority'
];

});
parcelRegister("cKw8Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $81c05dd6e2dcad70$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $81c05dd6e2dcad70$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    blue: {
        "id": "dashboard-common.blue",
        "defaultMessage": "Blue"
    },
    red: {
        "id": "dashboard-common.red",
        "defaultMessage": "Red"
    },
    yellow: {
        "id": "dashboard-common.yellow",
        "defaultMessage": "Yellow"
    },
    green: {
        "id": "dashboard-common.green",
        "defaultMessage": "Green"
    },
    teal: {
        "id": "dashboard-common.teal",
        "defaultMessage": "Teal"
    },
    purple: {
        "id": "dashboard-common.purple",
        "defaultMessage": "Purple"
    },
    gray: {
        "id": "dashboard-common.gray",
        "defaultMessage": "Gray"
    },
    white: {
        "id": "dashboard-common.white",
        "defaultMessage": "White"
    }
});

});



const $e03099b7bef7f4cd$export$ca03ff6cc792cc16 = 'DASHBOARD_CONFIG_AND_WRM';
const $e03099b7bef7f4cd$export$e239393fd4e2bc85 = 'DASHBOARD_AMD_MODULES';
const $e03099b7bef7f4cd$export$9e5db01432b13b67 = 'DASHBOARD_REACT_GADGETS';
const $e03099b7bef7f4cd$export$bce41807cc929d0f = 'DASHBOARD_FORGE';
const $e03099b7bef7f4cd$export$c07a25ebb6af1e84 = 'DASHBOARD_GADGET_DIRECTORY';

parcelRegister("04Brv", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff7f8eda58c85578$export$2e2bcd8739ae039);

var $4su49 = parcelRequire("4su49");

var $3Yd87 = parcelRequire("3Yd87");

var $1IY2I = parcelRequire("1IY2I");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ff7f8eda58c85578$export$2e2bcd8739ae039 = (_maybePrevData, sharedValue)=>({ isPrefetch: isPrefetch })=>{
        if (!sharedValue || sharedValue instanceof Error) throw new (0, $3Yd87.SharedValueAggregateError)({
            sharedValue: sharedValue,
            isPrefetch: isPrefetch,
            name: 'AMD modules resource'
        });
        return (async ()=>{
            const { moduleNames: moduleNames, isPreloaded: isPreloaded } = sharedValue;
            const maybePromiseAmdModules = isPreloaded || await (0, $1IY2I.loadAmdModules)((0, $4su49.asyncWrmRequire), moduleNames) ? (0, $1IY2I.evalAmdModules)(moduleNames) : null;
            const amdModules = maybePromiseAmdModules instanceof Promise ? await maybePromiseAmdModules : maybePromiseAmdModules;
            return {
                sharedValue: sharedValue,
                amdModules: amdModules
            };
        })();
    };

});
parcelRegister("1IY2I", function(module, exports) {

$parcel$export(module.exports, "loadAmdModules", () => $d6efeb87a1192ef7$export$2c79895bd69a8d54);
$parcel$export(module.exports, "evalAmdModules", () => $d6efeb87a1192ef7$export$d74eab33af9baaea);

var $2YZCu = parcelRequire("2YZCu");

var $JIPqS = parcelRequire("JIPqS");
/**
 * Dummy implementation for a Connect gadget, as rendering and editing are
 * managed externally.
 */ class $d6efeb87a1192ef7$var$ConnectDashboardItem {
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    render() {}
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    renderEdit() {}
}
const $d6efeb87a1192ef7$export$3bf37adbbdcafcc8 = (moduleName, retries = 5)=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (typeof window.require !== 'function') throw new TypeError('window.require is not a function');
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return window.require(moduleName);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // amd module could throw a non-Error
        if (error instanceof Error && /^No \S+$|^\S+ missing \S+$/.test(error.message)) {
            // some AMD modules have define() inside a require() block in which case the module is not immediately ready to be window.require()'d
            // this is due to the 4ms timeout in requirejs' require(), we need a retry logic here to make sure the module is loaded.
            // see the comment section for https://jdog.jira-dev.com/browse/WRM-71
            if (retries > 0) return new Promise((r)=>setTimeout(r, 100)).then(()=>$d6efeb87a1192ef7$export$3bf37adbbdcafcc8(moduleName, retries - 1));
        }
        throw error;
    }
};
const $d6efeb87a1192ef7$export$2c79895bd69a8d54 = async (wrmRequire, moduleNames)=>{
    if (moduleNames.length === 0) return false;
    const prefixedAmdResources = moduleNames.map((amdModule)=>(0, $JIPqS.WEB_RESOURCE_MAP)[amdModule]).map((resourceName)=>`wrc!${resourceName}`);
    try {
        // no result from the promise only the side effect of having loaded the AMD module via WRM
        await wrmRequire(prefixedAmdResources);
        return true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.resource', `Failed to load web resources [${prefixedAmdResources.join(',')}]`, error);
        return false;
    }
};
const $d6efeb87a1192ef7$var$getSortedModuleNamesFromTuples = (tuples)=>tuples.map(([moduleName])=>moduleName).sort((a, b)=>a.localeCompare(b)).join(',');
const $d6efeb87a1192ef7$export$d74eab33af9baaea = (amdModuleNames)=>{
    const tuplesOrPromises = amdModuleNames.map((amdModuleName)=>{
        try {
            const module = amdModuleName === (0, $JIPqS.CONNECT_ITEM_AMD_MODULE) ? $d6efeb87a1192ef7$var$ConnectDashboardItem : $d6efeb87a1192ef7$export$3bf37adbbdcafcc8(amdModuleName);
            return module instanceof Promise ? module.then((v)=>[
                    amdModuleName,
                    v
                ]) : [
                amdModuleName,
                module
            ];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return Promise.reject(error);
        }
    });
    const hasPromise = tuplesOrPromises.some((entry)=>entry instanceof Promise);
    if (!hasPromise) {
        (0, $2YZCu.default).safeInfoWithoutCustomerData('spa-apps.dashboard.resource', 'Successful synchronous bulk eval AMD modules');
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Object.fromEntries(tuplesOrPromises);
    }
    return Promise.allSettled(tuplesOrPromises).then((results)=>{
        const tuples = results.map((result, i)=>{
            if (result.status === 'fulfilled') return result.value;
            const { reason: error } = result;
            const amdModuleName = amdModuleNames[i];
            const message = error instanceof Error ? error.message : String(error);
            (0, $2YZCu.default).safeErrorWithoutCustomerData('spa-apps.dashboard.resource', `Failed bulk eval AMD module [${amdModuleName}] with error [${message}]`, error);
            return [
                amdModuleName,
                null
            ];
        });
        const failedTuples = tuples.filter((module)=>module[1] === null);
        failedTuples.length > 0 ? (0, $2YZCu.default).safeErrorWithoutCustomerData('spa-apps.dashboard.resource', `Failed bulk eval AMD modules [${$d6efeb87a1192ef7$var$getSortedModuleNamesFromTuples(failedTuples)}]`) : (0, $2YZCu.default).safeInfoWithoutCustomerData('spa-apps.dashboard.resource', 'Successful asynchronous bulk eval AMD modules');
        return Object.fromEntries(tuples);
    });
};

});


parcelRegister("3cb5I", function(module, exports) {

$parcel$export(module.exports, "default", () => $f465c16c9ac91f45$export$2e2bcd8739ae039);

var $7RGnr = parcelRequire("7RGnr");

var $2YZCu = parcelRequire("2YZCu");

var $2j5ho = parcelRequire("2j5ho");

var $1LNzH = parcelRequire("1LNzH");

var $hoLk6 = parcelRequire("hoLk6");

var $6T8HZ = parcelRequire("6T8HZ");

var $abozY = parcelRequire("abozY");

var $8oOn8 = parcelRequire("8oOn8");
const $f465c16c9ac91f45$var$generateScriptTagAndPreloadedModuleNames = async (configs)=>{
    const gadgets = configs.flatMap((config)=>config.gadgets);
    const preloadedModuleNames = (0, $8oOn8.gadgetsToUniqueSortedAmdModules)(gadgets);
    const wrmBundleDescriptor = await (0, $1LNzH.default)(preloadedModuleNames);
    return configs.map((config)=>{
        const scriptTags = [
            wrmBundleDescriptor ? (0, $6T8HZ.default)(wrmBundleDescriptor) : null,
            (0, $hoLk6.default)(config)
        ].filter(Boolean).join('\n') || null;
        return {
            ...config,
            scriptTags: scriptTags,
            preloadedModuleNames: preloadedModuleNames
        };
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f465c16c9ac91f45$export$2e2bcd8739ae039 = async (context)=>{
    // this is either for single dashboard/wallboard or wallboard slide show with multiple dashboards
    try {
        const { route: route, query: query } = context;
        const originalConfigs = route.name === 'dashboard-wallboard' ? await (0, $2j5ho.getDashboardsConfig)(query.dashboardId) : [
            await (0, $2j5ho.default)((0, $abozY.getKey)(context))
        ];
        const configs = originalConfigs.map((config)=>({
                ...config,
                gadgets: (0, $7RGnr.mapToReactGadgets)(config.gadgets)
            }));
        if (!false) return configs.map((config)=>({
                ...config,
                preloadedModuleNames: []
            }));
        return $f465c16c9ac91f45$var$generateScriptTagAndPreloadedModuleNames(configs);
    } catch (error) {
        (0, $2YZCu.default).unsafeErrorWithCustomerData('spa-apps.dashboard.get-config-and-wrm-data', `Failed to get dashboard configuration and wrm data: route=[${context.route.name}], query=[${JSON.stringify(context.query)}]`, error instanceof Error ? error : undefined);
        throw error;
    }
};

});
parcelRegister("7RGnr", function(module, exports) {

$parcel$export(module.exports, "mapToReactGadgets", () => $119a071fe5fec8f8$export$c90615c5eb218d50);

var $4R6GH = parcelRequire("4R6GH");
const $119a071fe5fec8f8$export$c90615c5eb218d50 = (gadgets)=>{
    const gadgetMapping = {
        ...(0, $4R6GH.fg)('endeavour_nin_filter_results_gadget') ? {
            'jira-dashboard-items/filter-results': 'react/filter-results'
        } : {},
        'servicedesk/internal/reports/feature/custom-report-dashboard-item/custom-report-dashboard-item': 'react/custom-report',
        ...(0, $4R6GH.fg)('endeavour_nin_assigned_to_me_gadget') ? {
            'jira-dashboard-items/assigned-to-me': 'react/assigned-to-me'
        } : {},
        ...(0, $4R6GH.fg)('endeavour_nin_issues_in_progress_gadget') ? {
            'jira-dashboard-items/in-progress': 'react/issues-in-progress'
        } : {},
        ...(0, $4R6GH.fg)('endeavour_nin_voted_issues_gadget') ? {
            'jira-dashboard-items/voted': 'react/voted-issues'
        } : {},
        ...(0, $4R6GH.fg)('endeavour_nin_watched_issues_gadget') ? {
            'jira-dashboard-items/watched': 'react/watched-issues'
        } : {}
    }; // satisfies Record<string, ReactKey>; SSR image build Thread Loader doesn't understand 'satisfies'
    const isMapped = (module)=>module !== undefined && module in gadgetMapping;
    return gadgets.map((gadget)=>{
        if (isMapped(gadget.amdModule)) return {
            ...gadget,
            reactKey: gadgetMapping[gadget.amdModule],
            amdModule: undefined,
            configurable: false,
            inlineHtml: undefined
        };
        return gadget;
    });
};

});

parcelRegister("2j5ho", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ef874ace7c3cd69$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getDashboardsConfig", () => $3ef874ace7c3cd69$export$1264b6af3adf5084);

var $7f4tk = parcelRequire("7f4tk");

var $2YZCu = parcelRequire("2YZCu");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3ef874ace7c3cd69$export$2e2bcd8739ae039 = async (id)=>{
    try {
        return (0, $7f4tk.default)(`/rest/dashboards/1.0/${id}.json`);
    } catch (error) {
        (0, $2YZCu.default).unsafeErrorWithCustomerData('spa-apps.dashboard.fetch-dashboard-config', `Failed to get dashboard config json with id=[${id}]`, error instanceof Error ? error : undefined);
        throw error;
    }
};
const $3ef874ace7c3cd69$export$1264b6af3adf5084 = async (idsCsv)=>{
    try {
        return (0, $7f4tk.default)(`/rest/dashboards/1.0?dashboardId=${idsCsv}`);
    } catch (error) {
        (0, $2YZCu.default).unsafeErrorWithCustomerData('spa-apps.dashboard.fetch-dashboard-config', `Failed to get dashboard config with ids=[${idsCsv}]`, error instanceof Error ? error : undefined);
        throw error;
    }
};

});

parcelRegister("1LNzH", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e5794ac0c0d1780$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $JIPqS = parcelRequire("JIPqS");

var $7f4tk = parcelRequire("7f4tk");

var $2YZCu = parcelRequire("2YZCu");
const $1e5794ac0c0d1780$var$CRITICAL_DEPENDENCIES = [
    'jira.webresources:util',
    'jira.webresources:feature-flags',
    'com.atlassian.jira.jira-atlaskit-plugin:overrides-general'
];
const $1e5794ac0c0d1780$var$JIRA_HERITAGE_CRITICAL_BATCH = 'jira.heritage.critical';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1e5794ac0c0d1780$export$2e2bcd8739ae039 = async (moduleNames)=>{
    if (moduleNames.length === 0) return Promise.resolve(null);
    const contextsToRequire = moduleNames.map((amdModule)=>(0, $JIPqS.WEB_RESOURCE_MAP)[amdModule]);
    const payload = {
        r: [],
        c: [
            ...$1e5794ac0c0d1780$var$CRITICAL_DEPENDENCIES,
            ...contextsToRequire
        ],
        xc: [
            $1e5794ac0c0d1780$var$JIRA_HERITAGE_CRITICAL_BATCH
        ],
        xr: []
    };
    try {
        return (0, $7f4tk.default)('/rest/webResources/1.0/resources?operation=FetchWRMData', {
            method: 'POST',
            body: JSON.stringify(payload)
        });
    } catch (error) {
        (0, $2YZCu.default).unsafeErrorWithCustomerData('spa-apps.dashboard.wrm-bundle-descriptor', `Failed to fetch wrm bundle with contexts [${contextsToRequire.join(',')}]`, error instanceof Error ? error : undefined);
        throw error;
    }
};

});

parcelRegister("hoLk6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9b2d88076d11343$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $JIPqS = parcelRequire("JIPqS");

var $83oax = parcelRequire("83oax");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d9b2d88076d11343$export$2e2bcd8739ae039 = (dashboardConfig)=>{
    if (dashboardConfig.gadgets.length === 0) return null;
    const prefetches = (0, $83oax.getPrefetches)(dashboardConfig);
    const preloadLinks = prefetches.map((prefetch)=>`<link rel="preload" as="fetch" href="${prefetch.url}" crossorigin="anonymous" />`).join('\n') || null;
    const syncPrefetchUrls = prefetches.filter((prefetch)=>prefetch.isSyncLoadingSupported()).map((prefetch)=>prefetch.url);
    if (preloadLinks != null && syncPrefetchUrls.length > 0) {
        const fetchScript = `
            <script type="text/javascript" data-defer-skip>
                const preloadUrls = ${JSON.stringify(syncPrefetchUrls)};
                window['${(0, $JIPqS.PRELOADED_GADGET_DATA_KEY)}'] = {};

                preloadUrls.forEach((preloadUrl) => {
                    fetch(preloadUrl)
                        .then(res => res.json())
                        .then(data => {
                            window['${(0, $JIPqS.PRELOADED_GADGET_DATA_KEY)}'][preloadUrl] = data;
                        });
                });
            </script>
        `;
        return preloadLinks + fetchScript;
    }
    return preloadLinks;
};

});
parcelRegister("83oax", function(module, exports) {

$parcel$export(module.exports, "getPrefetches", () => $6e3ee08c53b7707c$export$3144db3718ad5e57);

var $bT0sh = parcelRequire("bT0sh");
const $6e3ee08c53b7707c$export$3144db3718ad5e57 = ({ gadgets: gadgets })=>{
    const lookup = (0, $bT0sh.getPrefetchDict)();
    return gadgets.flatMap((gadget)=>{
        const identifier = gadget.amdModule;
        const prefechProp = identifier != null ? lookup[identifier] : undefined;
        if (!prefechProp || !prefechProp.enabled) return [];
        const { func: func, priority: priority, isSyncLoadingSupported: isSyncLoadingSupported } = prefechProp;
        return func(gadget).map((url)=>({
                url: url,
                priority: priority,
                isSyncLoadingSupported: isSyncLoadingSupported
            }));
    });
};

});
parcelRegister("bT0sh", function(module, exports) {

$parcel$export(module.exports, "getPrefetchDict", () => $e3f3a590c57f26d7$export$244cea94cab19e07);

var $4R6GH = parcelRequire("4R6GH");

var $ltNbR = parcelRequire("ltNbR");

var $8lc67 = parcelRequire("8lc67");

var $cdUf4 = parcelRequire("cdUf4");
const $e3f3a590c57f26d7$export$244cea94cab19e07 = ()=>({
        'jira-dashboard-items/activitystream': {
            func: (0, $8lc67.getActivityStreamPrefetchLink),
            priority: (0, $ltNbR.LOADING_PRIORITY).HIGH,
            enabled: true,
            isSyncLoadingSupported: ()=>false
        },
        'jira-dashboard-items/filter-results': {
            func: (0, $cdUf4.getFilterResultsPrefetchLink),
            priority: (0, $ltNbR.LOADING_PRIORITY).LOW,
            enabled: !(0, $4R6GH.fg)('endeavour_nin_filter_results_gadget'),
            isSyncLoadingSupported: ()=>true
        }
    });

});
parcelRegister("ltNbR", function(module, exports) {

$parcel$export(module.exports, "LOADING_PRIORITY", () => $5a106311215627b2$export$cb9b1f2232733c1b);
const $5a106311215627b2$export$cb9b1f2232733c1b = {
    HIGH: 'preload',
    LOW: 'prefetch'
};

});

parcelRegister("8lc67", function(module, exports) {

$parcel$export(module.exports, "getActivityStreamPrefetchLink", () => $cadf517d0dd42b8b$export$360928f5bf059a9e);

var $ebyGx = parcelRequire("ebyGx");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $cadf517d0dd42b8b$var$replacer = (match, part1)=>String.fromCharCode(part1);
// IMPORTANT - The below code is copied from monolith streams plugin and modified to fit linting rules
// so any changes in here have to be synced with the monolith code as well.
// https://stash.atlassian.com/projects/jiracloud/repos/jira/browse/jira-components/jira-plugins/streams/streams-jira-plugin/src/main/resources/streams-jira-plugin/dashboarditem/activity-stream/js/activity-stream.js?at=64cdcf2e1660c3afeaf26d8795e8cb737286efe9#63-81
// @ts-expect-error - TS7006 - Parameter 'operatorLower' implicitly has an 'any' type.
const $cadf517d0dd42b8b$var$getDateValue = (dateValue, operatorLower)=>{
    // make sure we're dealing with a string so we can use indexOf and split without errors
    const dateStr = `${dateValue}`;
    const operator = operatorLower.toUpperCase();
    let dateArr;
    if (dateStr.indexOf(' ') !== -1) dateArr = dateStr.split(' ');
    else if (operator === 'BETWEEN') dateArr = [
        dateValue,
        dateValue
    ];
    else dateArr = [
        dateValue
    ];
    return dateArr.map((date, index)=>{
        // make sure we're adding numbers and not concatenating strings
        const dateInt = parseInt(date, 10);
        if (operator === 'AFTER' || operator === 'BETWEEN' && index === 1) return dateInt + 86400000 - 1; // Add 23 hours, 59 minutes, 59 seconds to get to end of day
        return dateInt;
    }).join(' ');
};
// IMPORTANT - The below code is copied from monolith streams plugin and modified to fit linting rules
// so any changes in here have to be synced with the monolith code as well.
// https://stash.atlassian.com/projects/jiracloud/repos/jira/browse/jira-components/jira-plugins/streams/streams-jira-plugin/src/main/resources/streams-jira-plugin/dashboarditem/activity-stream/js/activity-stream.js?at=64cdcf2e1660c3afeaf26d8795e8cb737286efe9#20
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $cadf517d0dd42b8b$var$handleSpecialCases = (rule)=>{
    let { value: value, operator: operator } = rule;
    const { type: type } = rule;
    if (Array.isArray(value)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const encodedValues = [];
        value.forEach((val)=>{
            // additional level of encoding for spaces because otherwise the spaces
            // will be mistaken for value delimiters (STRM-1857); escape space as "_"
            // and escape any existing "_" as "\_"
            encodedValues.push(val.replace(/_/g, '\\_').replace(/ /g, '_'));
        });
        value = encodedValues.join(' ');
    }
    if (type === 'date') {
        if (operator === 'is') // back end doesn't support "IS", we have to turn it into a between
        operator = 'between';
        value = $cadf517d0dd42b8b$var$getDateValue(value, operator);
        // We had some problems getting the date values
        // Return empty rule so it won't be included
        if (value.indexOf('NaN') !== -1) return {};
    } else if (type === 'list' || type === 'user') {
        // allow comma-separated values (in addition to space separated) for issue keys and usernames
        value = value.replace(/,/g, ' ');
        // escape underscores as "\_" (because "_" is used to escape spaces in lists)
        value = value.replace(/_/g, '\\_');
    }
    return {
        value: value,
        operator: operator
    };
};
// IMPORTANT - The below code is copied from monolith streams plugin and modified to fit linting rules
// so any changes in here have to be synced with the monolith code as well.
// https://stash.atlassian.com/projects/jiracloud/repos/jira/browse/jira-components/jira-plugins/streams/streams-jira-plugin/src/main/resources/streams-jira-plugin/dashboarditem/activity-stream/js/activity-stream.js?at=64cdcf2e1660c3afeaf26d8795e8cb737286efe9#651-683
const $cadf517d0dd42b8b$var$getParamsFromRules = (rules)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const params = {};
    const providers = JSON.parse(decodeURIComponent(rules.replace(/&#([0-9]+);/g, $cadf517d0dd42b8b$var$replacer)))?.providers || [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const enabledProviders = [];
    // @ts-expect-error - TS7006 - Parameter 'provider' implicitly has an 'any' type.
    providers.forEach((provider)=>{
        const providerKey = provider.provider;
        const { rules: providerRules } = provider;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const stringifiedRules = [];
        if (!provider.disabled) {
            if (providerKey !== 'streams') enabledProviders.push(providerKey);
            // @ts-expect-error - TS7006 - Parameter 'rule' implicitly has an 'any' type.
            providerRules.forEach((rule)=>{
                const modifiedRuleObj = $cadf517d0dd42b8b$var$handleSpecialCases(rule);
                const { operator: operator, value: value } = modifiedRuleObj;
                if (operator && value) stringifiedRules.push([
                    rule.rule,
                    operator.toUpperCase(),
                    value
                ].join(' '));
            });
            params[providerKey] = stringifiedRules;
        }
    });
    if (enabledProviders.length < providers.length - 1) params.providers = enabledProviders.join(' ');
    return params;
};
const $cadf517d0dd42b8b$export$3d7deb7cf8a9de04 = (gadget)=>{
    const prefs = Object.fromEntries(gadget.userPrefs?.fields.map((field)=>[
            field.name,
            field.value
        ]) ?? []);
    const params = {
        maxResults: prefs.numofentries ?? 25,
        relativeLinks: true,
        ...prefs.rules ? $cadf517d0dd42b8b$var$getParamsFromRules(prefs.rules) : {}
    };
    // Gadget encodes spaces as '+', rather than '%20'.  Need to replace here to match URL exactly.
    return (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(params).replace(/%20/g, '+');
};
const $cadf517d0dd42b8b$var$ACTIVITY_STREAM_REST_URL = 'plugins/servlet/streams';
const $cadf517d0dd42b8b$export$360928f5bf059a9e = (gadgetData)=>{
    const paramStr = $cadf517d0dd42b8b$export$3d7deb7cf8a9de04(gadgetData);
    return [
        `/${$cadf517d0dd42b8b$var$ACTIVITY_STREAM_REST_URL}?${paramStr}`
    ];
};

});

parcelRegister("cdUf4", function(module, exports) {

$parcel$export(module.exports, "getFilterResultsPrefetchLink", () => $7e69dbaeb4189994$export$947cd90004054337);

var $ebyGx = parcelRequire("ebyGx");
const $7e69dbaeb4189994$var$FILTER_RESULTS_REST_URL = 'rest/gadget/1.0/issueTable';
const $7e69dbaeb4189994$export$947cd90004054337 = (gadgetData)=>{
    const { properties: properties } = gadgetData.context.dashboardItem;
    const data = {
        num: properties.num,
        tableContext: 'jira.table.cols.dashboard',
        addDefault: false,
        columnNames: typeof properties.columnNames === 'string' ? properties.columnNames.split('|') : undefined,
        enableSorting: true,
        paging: true,
        showActions: true,
        filterId: undefined,
        jql: undefined,
        sortBy: String(properties.sortBy && properties.sortBy !== '' ? properties.sortBy : null),
        startIndex: properties.startIndex ? properties.startIndex : 0
    };
    let queryType = '';
    if (properties.filterId) {
        queryType = 'filter';
        Object.assign(data, {
            filterId: properties.filterId
        });
    } else if (properties.jql) {
        queryType = 'jql';
        Object.assign(data, {
            jql: properties.jql
        });
    }
    // IMPORTANT - type definitions are incorrect, sort is definitely an option
    // @see https://www.npmjs.com/package/query-string/v/5.1.0
    // @ts-expect-error - TS2345 - Argument of type '{ sort: boolean; }' is not assignable to parameter of type 'StringifyOptions'.
    const paramStr = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(data, {
        sort: false
    }).replace(/%20/g, '+');
    const preloadUrl = `/${$7e69dbaeb4189994$var$FILTER_RESULTS_REST_URL}/${queryType}?${paramStr}`;
    return [
        preloadUrl
    ];
};

});




parcelRegister("6T8HZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c547330881220e9$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8c547330881220e9$export$2e2bcd8739ae039 = (response)=>{
    let resourceHtml = `
        <script type="text/javascript" data-defer-skip>
            window.WRM=window.WRM||{};window.WRM._unparsedData=window.WRM._unparsedData||{};window.WRM._unparsedErrors=window.WRM._unparsedErrors||{};
            WRM._unparsedData = Object.assign({}, WRM._unparsedData, JSON.parse(${JSON.stringify(JSON.stringify(response.unparsedData))}));
            WRM._unparsedErrors = Object.assign({}, WRM._unparsedErrors, JSON.parse(${JSON.stringify(JSON.stringify(response.unparsedErrors))}));
            if(window.WRM._dataArrived)window.WRM._dataArrived();
        </script>
    `;
    response.resources.forEach((resource)=>{
        const { url: url, resourceType: resourceType, key: key } = resource;
        if (resourceType === 'CSS') {
            const cssResource = `<link
                href=${url}
                type="text/css"
                rel="stylesheet"
                media="all"
                data-wrm-key=${key}
                data-wrm-batch-type="context"
            />`;
            resourceHtml += cssResource;
        } else {
            const jsResource = `<div>
                <script
                    type="text/javascript"
                    data-initially-rendered
                    data-defer-skip
                    src=${url}
                    data-wrm-key=${key}
                    data-wrm-batch-type="context"
                ></script>
            </div>`;
            resourceHtml += jsResource;
        }
    });
    return resourceHtml;
};

});

parcelRegister("8oOn8", function(module, exports) {

$parcel$export(module.exports, "gadgetsToUniqueSortedAmdModules", () => $d83f51a78c4f458b$export$598e0ea2a7525181);
$parcel$export(module.exports, "gadgetsToSortedReactGadgets", () => $d83f51a78c4f458b$export$f98787198c197952);
// eslint-disable-next-line jira/import-whitelist

var $JIPqS = parcelRequire("JIPqS");

var $kspzT = parcelRequire("kspzT");
const $d83f51a78c4f458b$export$598e0ea2a7525181 = (gadgets)=>gadgets // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .map(({ amdModule: amdModule })=>amdModule) // validated below
    .filter(Boolean).filter((amdModule)=>amdModule in (0, $JIPqS.WEB_RESOURCE_MAP)).filter((v, i, a)=>a.indexOf(v) === i).sort() ?? [];
const $d83f51a78c4f458b$export$f98787198c197952 = (gadgets)=>gadgets.reduce((gadgetsAccumulator, gadget)=>{
        if (!(0, $kspzT.isReactKey)(gadget.reactKey)) return gadgetsAccumulator;
        gadgetsAccumulator.push({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            reactKey: gadget.reactKey,
            id: gadget.id,
            userPrefs: gadget.userPrefs
        });
        return gadgetsAccumulator;
    }, []).sort((a, b)=>a.id.localeCompare(b.id));

});
parcelRegister("kspzT", function(module, exports) {

$parcel$export(module.exports, "isReactKey", () => $7a81ea406ace6c08$export$6acd06c99f745b49);
$parcel$export(module.exports, "default", () => $7a81ea406ace6c08$export$2e2bcd8739ae039);

var $9zbBl = parcelRequire("9zbBl");

var $kvkwL = parcelRequire("kvkwL");

var $26UOd = parcelRequire("26UOd");
/** This is a gadgets definition file.  */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7a81ea406ace6c08$var$GADGETS_DEFINITION = {
    [(0, $26UOd.REACT_KEY).FILTER_RESULTS]: (0, $kvkwL.FILTER_RESULTS_DEFINITION),
    [(0, $26UOd.REACT_KEY).ASSIGNED_TO_ME]: (0, $kvkwL.ASSIGNED_TO_ME_DEFINITION),
    [(0, $26UOd.REACT_KEY).ISSUES_IN_PROGRESS]: (0, $kvkwL.ISSUES_IN_PROGRESS_DEFINITION),
    [(0, $26UOd.REACT_KEY).VOTED_ISSUES]: (0, $kvkwL.VOTED_ISSUES_DEFINITION),
    [(0, $26UOd.REACT_KEY).WATCHED_ISSUES]: (0, $kvkwL.WATCHED_ISSUES_DEFINITION),
    [(0, $26UOd.REACT_KEY).CUSTOM_REPORT]: (0, $9zbBl.default)
};
function $7a81ea406ace6c08$export$6acd06c99f745b49(key) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return !!(key && Object.values((0, $26UOd.REACT_KEY)).includes(key));
}
var $7a81ea406ace6c08$export$2e2bcd8739ae039 = $7a81ea406ace6c08$var$GADGETS_DEFINITION;

});
parcelRegister("9zbBl", function(module, exports) {

$parcel$export(module.exports, "default", () => $088534adc4ba7ffc$export$2e2bcd8739ae039);

var $cDOH2 = parcelRequire("cDOH2");

var $jUheV = parcelRequire("jUheV");

var $gM7kh = parcelRequire("gM7kh");
const $088534adc4ba7ffc$var$CUSTOM_REPORT_DEFINITION = {
    componentView: (0, $jUheV.LazyCustomReportGadgetView),
    componentEdit: (0, $cDOH2.LazyCustomReportGadgetEdit),
    getInitialState: $gM7kh.default,
    preload: $jUheV.preload
};
var $088534adc4ba7ffc$export$2e2bcd8739ae039 = $088534adc4ba7ffc$var$CUSTOM_REPORT_DEFINITION;

});
parcelRegister("cDOH2", function(module, exports) {

$parcel$export(module.exports, "LazyCustomReportGadgetEdit", () => $e8ab1a4d1d8a6eb4$export$475e4a6fb8f40116);

var $kxZPA = parcelRequire("kxZPA");

const $e8ab1a4d1d8a6eb4$export$475e4a6fb8f40116 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("g9rOr")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/custom-report-gadget/src/ui/edit/main.tsx"
});

});
parcelRegister("g9rOr", function(module, exports) {

let $bc230f973d976e94$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bc230f973d976e94$var$load("g1EA5").then(()=>parcelRequire('chhAm'));

});


parcelRegister("jUheV", function(module, exports) {

$parcel$export(module.exports, "LazyCustomReportGadgetView", () => $e43675722e4e42c6$export$27df795d4f3ff173);
$parcel$export(module.exports, "preload", () => $e43675722e4e42c6$export$513ccb98c53b8039);

var $kxZPA = parcelRequire("kxZPA");

const $e43675722e4e42c6$export$27df795d4f3ff173 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("5buDe")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/custom-report-gadget/src/ui/view/main.tsx"
});
const { preload: $e43675722e4e42c6$export$513ccb98c53b8039 } = $e43675722e4e42c6$export$27df795d4f3ff173;

});
parcelRegister("5buDe", function(module, exports) {

let $3c65bda4cdb9eab5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3c65bda4cdb9eab5$var$load("j2DU4").then(()=>parcelRequire('e2l8c'));

});


parcelRegister("gM7kh", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1132aa73a645b93$export$2e2bcd8739ae039);
const $d1132aa73a645b93$var$getInitialState = ()=>Promise.resolve({
        intervalValue: '1',
        isCustom: 'false',
        projectValue: '0',
        refresh: 'false',
        reportValue: '0',
        gadgetContentTitle: ''
    });
var $d1132aa73a645b93$export$2e2bcd8739ae039 = $d1132aa73a645b93$var$getInitialState;

});


parcelRegister("kvkwL", function(module, exports) {

$parcel$export(module.exports, "FILTER_RESULTS_DEFINITION", () => $676d00abfb59f2ab$export$3581891d04da6bb8);
$parcel$export(module.exports, "ASSIGNED_TO_ME_DEFINITION", () => $676d00abfb59f2ab$export$652d5a9cc2c18d2e);
$parcel$export(module.exports, "ISSUES_IN_PROGRESS_DEFINITION", () => $676d00abfb59f2ab$export$54b46348d1ed5d22);
$parcel$export(module.exports, "VOTED_ISSUES_DEFINITION", () => $676d00abfb59f2ab$export$ea96ce30d34ce354);
$parcel$export(module.exports, "WATCHED_ISSUES_DEFINITION", () => $676d00abfb59f2ab$export$5109728db227eae);

var $5uXOq = parcelRequire("5uXOq");

var $2egG3 = parcelRequire("2egG3");

var $eZ5lN = parcelRequire("eZ5lN");

var $kdIR9 = parcelRequire("kdIR9");

var $dzPNh = parcelRequire("dzPNh");

var $9KhHm = parcelRequire("9KhHm");

var $5ALJk = parcelRequire("5ALJk");

var $hfHPa = parcelRequire("hfHPa");
const $676d00abfb59f2ab$var$componentViewWithAdditionalState = (Component, additionalStateProps)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
            ...props,
            state: props.state ? {
                ...props.state,
                ...additionalStateProps
            } : null
        });
const $676d00abfb59f2ab$var$componentEditWithAdditionalState = (Component, additionalStateProps)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
            ...props,
            state: props.state ? {
                ...props.state,
                ...additionalStateProps
            } : null
        });
const $676d00abfb59f2ab$var$FILTER_RESULTS_CONFIG = {
    testId: 'react-issue-table-gadgets.filter-results.view'
};
const $676d00abfb59f2ab$export$3581891d04da6bb8 = {
    componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, $dzPNh.IssueTableGadgetView), $676d00abfb59f2ab$var$FILTER_RESULTS_CONFIG),
    componentEdit: (0, $eZ5lN.FilterResultsGadgetEdit),
    getInitialState: (0, $hfHPa.default)($676d00abfb59f2ab$var$FILTER_RESULTS_CONFIG),
    preload: (0, $dzPNh.preload)
};
const $676d00abfb59f2ab$var$ASSIGNED_TO_ME_CONFIG = {
    predeterminedJql: 'assignee = currentUser() AND statusCategory != 3 ORDER BY priority DESC, created ASC',
    defaultSortPrefs: {
        field: 'priority',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.assigned-to-me.view'
};
const $676d00abfb59f2ab$export$652d5a9cc2c18d2e = {
    componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, $dzPNh.IssueTableGadgetView), $676d00abfb59f2ab$var$ASSIGNED_TO_ME_CONFIG),
    componentEdit: $676d00abfb59f2ab$var$componentEditWithAdditionalState((0, $2egG3.AssignedToMeGadgetEdit), $676d00abfb59f2ab$var$ASSIGNED_TO_ME_CONFIG),
    getInitialState: (0, $hfHPa.default)($676d00abfb59f2ab$var$ASSIGNED_TO_ME_CONFIG),
    preload: (0, $dzPNh.preload)
};
const $676d00abfb59f2ab$var$ISSUES_IN_PROGRESS_CONFIG = {
    predeterminedJql: 'status = "In Progress" AND statusCategory != Done AND assignee = currentUser() ORDER BY priority DESC, created ASC',
    defaultSortPrefs: {
        field: 'priority',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.issues-in-progress.view'
};
const $676d00abfb59f2ab$export$54b46348d1ed5d22 = {
    componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, $dzPNh.IssueTableGadgetView), $676d00abfb59f2ab$var$ISSUES_IN_PROGRESS_CONFIG),
    componentEdit: $676d00abfb59f2ab$var$componentEditWithAdditionalState((0, $kdIR9.IssuesInProgressGadgetEdit), $676d00abfb59f2ab$var$ISSUES_IN_PROGRESS_CONFIG),
    getInitialState: (0, $hfHPa.default)($676d00abfb59f2ab$var$ISSUES_IN_PROGRESS_CONFIG),
    preload: (0, $dzPNh.preload)
};
const $676d00abfb59f2ab$var$VOTED_ISSUES_CONFIG = {
    predeterminedJql: 'issue in votedIssues() AND statusCategory != Done ORDER BY votes DESC',
    predeterminedJqlIncludeResolved: 'issue in votedIssues() ORDER BY votes DESC',
    defaultSortPrefs: {
        field: 'votes',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.voted-issues.view'
};
const $676d00abfb59f2ab$export$ea96ce30d34ce354 = {
    componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, $dzPNh.IssueTableGadgetView), $676d00abfb59f2ab$var$VOTED_ISSUES_CONFIG),
    componentEdit: $676d00abfb59f2ab$var$componentEditWithAdditionalState((0, $9KhHm.VotedIssuesGadgetEdit), $676d00abfb59f2ab$var$VOTED_ISSUES_CONFIG),
    getInitialState: (0, $hfHPa.default)($676d00abfb59f2ab$var$VOTED_ISSUES_CONFIG),
    preload: (0, $dzPNh.preload)
};
const $676d00abfb59f2ab$var$WATCHED_ISSUES_CONFIG = {
    predeterminedJql: 'issue in watchedIssues() AND statusCategory != Done ORDER BY watchers DESC',
    predeterminedJqlIncludeResolved: 'issue in watchedIssues() ORDER BY watchers DESC',
    defaultSortPrefs: {
        field: 'watchers',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.watched-issues.view'
};
const $676d00abfb59f2ab$export$5109728db227eae = {
    componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, $dzPNh.IssueTableGadgetView), $676d00abfb59f2ab$var$WATCHED_ISSUES_CONFIG),
    componentEdit: $676d00abfb59f2ab$var$componentEditWithAdditionalState((0, $5ALJk.WatchedIssuesGadgetEdit), $676d00abfb59f2ab$var$WATCHED_ISSUES_CONFIG),
    getInitialState: (0, $hfHPa.default)($676d00abfb59f2ab$var$WATCHED_ISSUES_CONFIG),
    preload: (0, $dzPNh.preload)
};

});
parcelRegister("2egG3", function(module, exports) {

$parcel$export(module.exports, "AssignedToMeGadgetEdit", () => $91d75e80303bba8c$export$3ae3568d16dc8f35);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $834mM = parcelRequire("834mM");

var $kxZPA = parcelRequire("kxZPA");

const $91d75e80303bba8c$var$LazyAssignedToMeGadgetEdit = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("8cDOu")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/assigned-to-me/edit/main.tsx"
});
const $91d75e80303bba8c$export$3ae3568d16dc8f35 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "assigned-to-me-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $834mM.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91d75e80303bba8c$var$LazyAssignedToMeGadgetEdit, props));
const { preload: $91d75e80303bba8c$export$513ccb98c53b8039 } = $91d75e80303bba8c$var$LazyAssignedToMeGadgetEdit;

});
parcelRegister("834mM", function(module, exports) {

$parcel$export(module.exports, "FilterResultsEditSkeleton", () => $92b82de956011a8a$export$e10d91ce257e7374);
/* filter-results-edit.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $ewt3o = parcelRequire("ewt3o");
const $92b82de956011a8a$var$customCssStyles = null;
const $92b82de956011a8a$var$FILTER_RESULTS_EDIT_ESTIMATED_HEIGHT = '698px';
const $92b82de956011a8a$export$e10d91ce257e7374 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ewt3o))),
        containerStyles: {
            height: $92b82de956011a8a$var$FILTER_RESULTS_EDIT_ESTIMATED_HEIGHT
        },
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("ewt3o", function(module, exports) {
module.exports = new URL("filter-results-edit-skeleton.tpl.783fb7b7.svg", import.meta.url).toString();

});


parcelRegister("8cDOu", function(module, exports) {

let $5f8e53cff17ee891$var$load = (parcelRequire("28QjX"))(4);


module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $5f8e53cff17ee891$var$load("czifk"),
            $5f8e53cff17ee891$var$load("kvRbA"),
            $5f8e53cff17ee891$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $5f8e53cff17ee891$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $5f8e53cff17ee891$var$load("cTJTG"),
            $5f8e53cff17ee891$var$load("l253H"),
            $5f8e53cff17ee891$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $5f8e53cff17ee891$var$load("4Qxp7")
        ]);
    }),
    $5f8e53cff17ee891$var$load("kNFvF"),
    $5f8e53cff17ee891$var$load("ffQaD"),
    $5f8e53cff17ee891$var$load("kvRbA"),
    $5f8e53cff17ee891$var$load("fliVL"),
    $5f8e53cff17ee891$var$load("g7OWt")
]).then(()=>parcelRequire('1SEAb'));

});


parcelRegister("eZ5lN", function(module, exports) {

$parcel$export(module.exports, "FilterResultsGadgetEdit", () => $fa7c1c640e166488$export$6dfceca003c43832);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $834mM = parcelRequire("834mM");

var $kxZPA = parcelRequire("kxZPA");

const $fa7c1c640e166488$var$LazyFilterResultsGadgetEdit = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("lSAye")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/filter-results/edit/main.tsx"
});
const $fa7c1c640e166488$export$6dfceca003c43832 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "filter-results-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $834mM.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fa7c1c640e166488$var$LazyFilterResultsGadgetEdit, props));
const { preload: $fa7c1c640e166488$export$513ccb98c53b8039 } = $fa7c1c640e166488$var$LazyFilterResultsGadgetEdit;

});
parcelRegister("lSAye", function(module, exports) {

let $fedafe6d0d940b1f$var$load = (parcelRequire("28QjX"))(4);


module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $fedafe6d0d940b1f$var$load("czifk"),
            $fedafe6d0d940b1f$var$load("kvRbA"),
            $fedafe6d0d940b1f$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $fedafe6d0d940b1f$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $fedafe6d0d940b1f$var$load("cTJTG"),
            $fedafe6d0d940b1f$var$load("l253H"),
            $fedafe6d0d940b1f$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $fedafe6d0d940b1f$var$load("4Qxp7")
        ]);
    }),
    $fedafe6d0d940b1f$var$load("kNFvF"),
    $fedafe6d0d940b1f$var$load("ffQaD"),
    $fedafe6d0d940b1f$var$load("kvRbA"),
    $fedafe6d0d940b1f$var$load("fliVL"),
    $fedafe6d0d940b1f$var$load("1kIEc")
]).then(()=>parcelRequire('eKgKX'));

});


parcelRegister("kdIR9", function(module, exports) {

$parcel$export(module.exports, "IssuesInProgressGadgetEdit", () => $04f85077310bce7f$export$199fec410a0f70a2);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $834mM = parcelRequire("834mM");

var $kxZPA = parcelRequire("kxZPA");

const $04f85077310bce7f$var$LazyIssuesInProgressGadgetEdit = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("2LhHo")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/issues-in-progress/edit/main.tsx"
});
const $04f85077310bce7f$export$199fec410a0f70a2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issues-in-progress-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $834mM.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04f85077310bce7f$var$LazyIssuesInProgressGadgetEdit, props));
const { preload: $04f85077310bce7f$export$513ccb98c53b8039 } = $04f85077310bce7f$var$LazyIssuesInProgressGadgetEdit;

});
parcelRegister("2LhHo", function(module, exports) {

let $202db3311bbe820a$var$load = (parcelRequire("28QjX"))(4);


module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $202db3311bbe820a$var$load("czifk"),
            $202db3311bbe820a$var$load("kvRbA"),
            $202db3311bbe820a$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $202db3311bbe820a$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $202db3311bbe820a$var$load("cTJTG"),
            $202db3311bbe820a$var$load("l253H"),
            $202db3311bbe820a$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $202db3311bbe820a$var$load("4Qxp7")
        ]);
    }),
    $202db3311bbe820a$var$load("kNFvF"),
    $202db3311bbe820a$var$load("ffQaD"),
    $202db3311bbe820a$var$load("kvRbA"),
    $202db3311bbe820a$var$load("fliVL"),
    $202db3311bbe820a$var$load("hgF8H")
]).then(()=>parcelRequire('dk51x'));

});


parcelRegister("dzPNh", function(module, exports) {

$parcel$export(module.exports, "IssueTableGadgetView", () => $0c0c24e495111ec5$export$da0765a3c10e16a3);
$parcel$export(module.exports, "preload", () => $0c0c24e495111ec5$export$513ccb98c53b8039);

var $5uXOq = parcelRequire("5uXOq");

var $JIPqS = parcelRequire("JIPqS");

var $lfTZh = parcelRequire("lfTZh");

var $dNZVN = parcelRequire("dNZVN");

var $kxZPA = parcelRequire("kxZPA");

const $0c0c24e495111ec5$var$LazyIssueTableGadgetView = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("hiG4Q")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/view/main.tsx"
});
const $0c0c24e495111ec5$export$da0765a3c10e16a3 = ({ customSkeletonHeightInPx: customSkeletonHeightInPx, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "filter-results-gadget-view",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dNZVN.FilterResultsIssueTableSkeleton), {
            height: `${customSkeletonHeightInPx ?? (0, $JIPqS.GADGET_DEFAULT_HEIGHT)}px`
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0c0c24e495111ec5$var$LazyIssueTableGadgetView, {
        customSkeletonHeightInPx: customSkeletonHeightInPx,
        ...props
    }));
const { preload: $0c0c24e495111ec5$export$513ccb98c53b8039 } = $0c0c24e495111ec5$var$LazyIssueTableGadgetView;

});
parcelRegister("dNZVN", function(module, exports) {

$parcel$export(module.exports, "FilterResultsIssueTableSkeleton", () => $a73c71eae267b518$export$35d754053deeac73);
/* filter-results-issue-table.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $iMQ64 = parcelRequire("iMQ64");
const $a73c71eae267b518$var$customCssStyles = null;
const $a73c71eae267b518$export$35d754053deeac73 = ({ height: height })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iMQ64))),
        containerStyles: {
            height: height
        },
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("iMQ64", function(module, exports) {
module.exports = new URL("filter-results-issue-table-skeleton.tpl.a502204a.svg", import.meta.url).toString();

});


parcelRegister("hiG4Q", function(module, exports) {

let $c984c1bfa0a86f44$var$load = (parcelRequire("28QjX"))(4);


module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $c984c1bfa0a86f44$var$load("czifk"),
            $c984c1bfa0a86f44$var$load("kvRbA"),
            $c984c1bfa0a86f44$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $c984c1bfa0a86f44$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $c984c1bfa0a86f44$var$load("cTJTG"),
            $c984c1bfa0a86f44$var$load("l253H"),
            $c984c1bfa0a86f44$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $c984c1bfa0a86f44$var$load("4Qxp7")
        ]);
    }),
    $c984c1bfa0a86f44$var$load("kNFvF"),
    $c984c1bfa0a86f44$var$load("ffQaD"),
    $c984c1bfa0a86f44$var$load("kvRbA"),
    $c984c1bfa0a86f44$var$load("fliVL"),
    $c984c1bfa0a86f44$var$load("6rSuF")
]).then(()=>parcelRequire('dfMo9'));

});


parcelRegister("9KhHm", function(module, exports) {

$parcel$export(module.exports, "VotedIssuesGadgetEdit", () => $0ca7bf6a0d6f5346$export$7650b85a7a54914);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $834mM = parcelRequire("834mM");

var $kxZPA = parcelRequire("kxZPA");

const $0ca7bf6a0d6f5346$var$LazyVotedIssuesGadgetEdit = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("d6hM2")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/voted-issues/edit/main.tsx"
});
const $0ca7bf6a0d6f5346$export$7650b85a7a54914 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "voted-issues-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $834mM.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ca7bf6a0d6f5346$var$LazyVotedIssuesGadgetEdit, props));
const { preload: $0ca7bf6a0d6f5346$export$513ccb98c53b8039 } = $0ca7bf6a0d6f5346$var$LazyVotedIssuesGadgetEdit;

});
parcelRegister("d6hM2", function(module, exports) {

let $98999f6aa9a6962c$var$load = (parcelRequire("28QjX"))(4);


module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $98999f6aa9a6962c$var$load("czifk"),
            $98999f6aa9a6962c$var$load("kvRbA"),
            $98999f6aa9a6962c$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $98999f6aa9a6962c$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $98999f6aa9a6962c$var$load("cTJTG"),
            $98999f6aa9a6962c$var$load("l253H"),
            $98999f6aa9a6962c$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $98999f6aa9a6962c$var$load("4Qxp7")
        ]);
    }),
    $98999f6aa9a6962c$var$load("kNFvF"),
    $98999f6aa9a6962c$var$load("ffQaD"),
    $98999f6aa9a6962c$var$load("kvRbA"),
    $98999f6aa9a6962c$var$load("fliVL"),
    $98999f6aa9a6962c$var$load("eDCzE")
]).then(()=>parcelRequire('irHWu'));

});


parcelRegister("5ALJk", function(module, exports) {

$parcel$export(module.exports, "WatchedIssuesGadgetEdit", () => $278dbe55a7acf378$export$a53864bd0bf8a85f);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $834mM = parcelRequire("834mM");

var $kxZPA = parcelRequire("kxZPA");

const $278dbe55a7acf378$var$LazyWatchedIssuesGadgetEdit = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("9bVqf")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/watched-issues/edit/main.tsx"
});
const $278dbe55a7acf378$export$a53864bd0bf8a85f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "watched-issues-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $834mM.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($278dbe55a7acf378$var$LazyWatchedIssuesGadgetEdit, props));
const { preload: $278dbe55a7acf378$export$513ccb98c53b8039 } = $278dbe55a7acf378$var$LazyWatchedIssuesGadgetEdit;

});
parcelRegister("9bVqf", function(module, exports) {

let $6b11af03c38c7eb7$var$load = (parcelRequire("28QjX"))(4);


module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $6b11af03c38c7eb7$var$load("czifk"),
            $6b11af03c38c7eb7$var$load("kvRbA"),
            $6b11af03c38c7eb7$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $6b11af03c38c7eb7$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $6b11af03c38c7eb7$var$load("cTJTG"),
            $6b11af03c38c7eb7$var$load("l253H"),
            $6b11af03c38c7eb7$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $6b11af03c38c7eb7$var$load("4Qxp7")
        ]);
    }),
    $6b11af03c38c7eb7$var$load("kNFvF"),
    $6b11af03c38c7eb7$var$load("ffQaD"),
    $6b11af03c38c7eb7$var$load("kvRbA"),
    $6b11af03c38c7eb7$var$load("fliVL"),
    $6b11af03c38c7eb7$var$load("6LqWP")
]).then(()=>parcelRequire('iLll9'));

});


parcelRegister("hfHPa", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f27ae6f4005fc53$export$2e2bcd8739ae039);

var $fJpBG = parcelRequire("fJpBG");

var $lgZ6q = parcelRequire("lgZ6q");

var $8rq2P = parcelRequire("8rq2P");

var $jyMtv = parcelRequire("jyMtv");
const $9f27ae6f4005fc53$var$createGetInitialState = ({ predeterminedJql: predeterminedJql, predeterminedJqlIncludeResolved: predeterminedJqlIncludeResolved, defaultSortPrefs: defaultSortPrefs, testId: testId })=>async (resourceContext, userPrefs)=>{
        if (resourceContext?.tenantContext == null) throw new Error('Tenant context is not available');
        const { cloudId: cloudId, activationId: activationId } = resourceContext.tenantContext;
        const validUserPrefs = (0, $jyMtv.transformToValidUserPrefs)((0, $fJpBG.decodeUserPreferences)(userPrefs));
        if (validUserPrefs.filterId === undefined && predeterminedJql === undefined && predeterminedJqlIncludeResolved === undefined) throw new Error('FilterId or JQL has to be available to be able to load the gadget initial state');
        const sortPrefs = (()=>{
            if (validUserPrefs.sortField) return {
                sortField: validUserPrefs.sortField,
                sortDirection: validUserPrefs.sortDirection
            };
            if (defaultSortPrefs) return {
                sortField: defaultSortPrefs.field,
                sortDirection: defaultSortPrefs.direction
            };
        })();
        const includeResolved = validUserPrefs.showResolved;
        const jql = includeResolved ? predeterminedJqlIncludeResolved : predeterminedJql;
        const queryReference = await (0, $8rq2P.loadQueryWithUserPrefs)({
            ...validUserPrefs,
            ...sortPrefs
        }, (0, $lgZ6q.default), cloudId, activationId, 'store-and-network', jql);
        return {
            queryReference: queryReference,
            predeterminedJql: predeterminedJql,
            defaultSortPrefs: defaultSortPrefs,
            testId: testId
        };
    };
var $9f27ae6f4005fc53$export$2e2bcd8739ae039 = $9f27ae6f4005fc53$var$createGetInitialState;

});
parcelRegister("fJpBG", function(module, exports) {

$parcel$export(module.exports, "getUserPreferences", () => $a6145919a3771254$export$ae3f5fa351e2f57a);
$parcel$export(module.exports, "decodeUserPreferences", () => $a6145919a3771254$export$ebdfc6c2778ef8e2);

var $7f4tk = parcelRequire("7f4tk");
const $a6145919a3771254$var$isBooleanString = (str)=>[
        'true',
        'false'
    ].includes(str.toLowerCase().trim());
const $a6145919a3771254$var$stringToBoolean = (str)=>str.toLowerCase().trim() === 'true';
const $a6145919a3771254$export$ae3f5fa351e2f57a = (action)=>(0, $7f4tk.default)(action);
const $a6145919a3771254$export$ebdfc6c2778ef8e2 = (userPreferences = [])=>userPreferences.reduce((output, { value: value, name: name })=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...output,
            [name]: $a6145919a3771254$var$isBooleanString(value) ? $a6145919a3771254$var$stringToBoolean(value) : value
        }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});

});

parcelRegister("lgZ6q", function(module, exports) {

$parcel$export(module.exports, "default", () => $328d775330990290$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1e2f2c01b3a62de3e7d3b67dce66d469>>
 * @relayHash 3353135b42f128ad1ffde1c4f4a2d0f2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a655e3d570ec215074d9a5976c7e468db5725d1ca55bc578e50bd7806c8ef3d3

var $fjldt = parcelRequire("fjldt");

var $gY76A = parcelRequire("gY76A");

var $5oQtH = parcelRequire("5oQtH");

var $5ykrX = parcelRequire("5ykrX");

var $ggSVP = parcelRequire("ggSVP");

var $knfEI = parcelRequire("knfEI");

var $5qm7M = parcelRequire("5qm7M");

var $l8ssf = parcelRequire("l8ssf");

var $dttgK = parcelRequire("dttgK");

var $adKYy = parcelRequire("adKYy");

var $iLxt4 = parcelRequire("iLxt4");

var $hBvdF = parcelRequire("hBvdF");
const $328d775330990290$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsContext"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterAri"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isNotFilterFetch"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldSetsById"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v14 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v15 = {
        "kind": "ScalarField",
        "name": "key"
    }, v16 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v17 = {
        "kind": "ScalarField",
        "name": "id"
    }, v18 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v19 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v20 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v21 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v20 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v22 = {
        "kind": "InlineFragment",
        "selections": [
            v19 /*: any*/ ,
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v21 /*: any*/ ,
                    v17 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v23 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v24 = {
        "kind": "ScalarField",
        "name": "name"
    }, v25 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v26 = {
        "kind": "Variable",
        "name": "fieldSetIds",
        "variableName": "fieldSetIds"
    }, v27 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "amountOfColumns"
    }, v28 = {
        "kind": "ScalarField",
        "name": "type"
    }, v29 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v30 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isJiraIssueField"
    }, v31 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraAffectedServiceConnection",
                "kind": "LinkedField",
                "name": "selectedAffectedServicesConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAffectedServiceEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraAffectedService",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "serviceId"
                                    },
                                    v24 /*: any*/ ,
                                    v17 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraAffectedServicesField"
    }, v32 = {
        "kind": "ScalarField",
        "name": "value"
    }, v33 = [
        v32 /*: any*/ ,
        v17 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v34 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v35 = {
        "kind": "ClientExtension",
        "selections": [
            v34 /*: any*/ 
        ]
    }, v36 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v37 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v38 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v39 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v40 = {
        "kind": "ScalarField",
        "name": "text"
    }, v41 = {
        "kind": "InlineFragment",
        "selections": [
            v40 /*: any*/ ,
            v24 /*: any*/ ,
            v35 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v42 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v43 = [
        v42 /*: any*/ 
    ], v44 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v17 /*: any*/ 
        ]
    }, v45 = [
        v44 /*: any*/ 
    ], v46 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v47 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v17 /*: any*/ ,
            v32 /*: any*/ 
        ]
    }, v48 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v49 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v50 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v51 = {
        "kind": "ClientExtension",
        "selections": [
            v25 /*: any*/ 
        ]
    }, v52 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v24 /*: any*/ ,
                    {
                        "concreteType": "JiraCascadingOption",
                        "kind": "LinkedField",
                        "name": "cascadingOption",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "parentOptionValue",
                                "plural": false,
                                "selections": v33 /*: any*/ 
                            },
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "childOptionValue",
                                "plural": false,
                                "selections": v33 /*: any*/ 
                            }
                        ]
                    },
                    v35 /*: any*/ 
                ],
                "type": "JiraCascadingSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v24 /*: any*/ ,
                    {
                        "args": v36 /*: any*/ ,
                        "concreteType": "JiraComponentConnection",
                        "kind": "LinkedField",
                        "name": "selectedComponentsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraComponentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraComponent",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v37 /*: any*/ ,
                                            v38 /*: any*/ ,
                                            v17 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ],
                        "storageKey": "selectedComponentsConnection(first:1000)"
                    },
                    v35 /*: any*/ 
                ],
                "type": "JiraComponentsField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v39 /*: any*/ ,
                    v24 /*: any*/ ,
                    v35 /*: any*/ 
                ],
                "type": "JiraDateTimePickerField"
            },
            v41 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraCommentSummary",
                        "kind": "LinkedField",
                        "name": "commentSummary",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "canAddComment"
                            },
                            v42 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraCommentSummaryField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v24 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "uri"
                    },
                    v35 /*: any*/ 
                ],
                "type": "JiraUrlField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v24 /*: any*/ ,
                    {
                        "concreteType": "JiraOptionConnection",
                        "kind": "LinkedField",
                        "name": "fieldOptions",
                        "plural": false,
                        "selections": v43 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "fieldOption",
                        "plural": false,
                        "selections": [
                            v32 /*: any*/ ,
                            {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": v45 /*: any*/ 
                            },
                            {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": v45 /*: any*/ 
                            },
                            v17 /*: any*/ ,
                            v46 /*: any*/ 
                        ]
                    },
                    v35 /*: any*/ 
                ],
                "type": "JiraSingleSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v24 /*: any*/ ,
                    {
                        "concreteType": "JiraOptionConnection",
                        "kind": "LinkedField",
                        "name": "selectedOptions",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraOptionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraOption",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v17 /*: any*/ ,
                                            v32 /*: any*/ ,
                                            v46 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v35 /*: any*/ 
                ],
                "type": "JiraMultipleSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v24 /*: any*/ ,
                    {
                        "concreteType": "JiraOptionConnection",
                        "kind": "LinkedField",
                        "name": "selectedOptions",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraOptionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    v47 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    v35 /*: any*/ 
                ],
                "type": "JiraCheckboxesField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v24 /*: any*/ ,
                    {
                        "concreteType": "JiraUserConnection",
                        "kind": "LinkedField",
                        "name": "selectedUsersConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraUserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v18 /*: any*/ ,
                                            v48 /*: any*/ ,
                                            v24 /*: any*/ ,
                                            v49 /*: any*/ ,
                                            v17 /*: any*/ ,
                                            v50 /*: any*/ ,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "email"
                                                    }
                                                ],
                                                "type": "AtlassianAccountUser"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v35 /*: any*/ 
                ],
                "type": "JiraMultipleSelectUserPickerField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v24 /*: any*/ ,
                    {
                        "concreteType": "JiraTeamView",
                        "kind": "LinkedField",
                        "name": "selectedTeam",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "jiraSuppliedId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "jiraSuppliedName"
                            }
                        ]
                    },
                    v35 /*: any*/ 
                ],
                "type": "JiraTeamViewField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "issue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraTimeTrackingField",
                                "kind": "LinkedField",
                                "name": "timeTrackingField",
                                "plural": false,
                                "selections": [
                                    v17 /*: any*/ ,
                                    {
                                        "concreteType": "JiraEstimate",
                                        "kind": "LinkedField",
                                        "name": "originalEstimate",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "timeInSeconds"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraTimeTrackingSettings",
                                        "kind": "LinkedField",
                                        "name": "timeTrackingSettings",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "workingHoursPerDay"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "workingDaysPerWeek"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "defaultFormat"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "defaultUnit"
                                            }
                                        ]
                                    },
                                    v19 /*: any*/ ,
                                    v24 /*: any*/ ,
                                    v28 /*: any*/ ,
                                    v35 /*: any*/ 
                                ]
                            },
                            v17 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraOriginalTimeEstimateField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v24 /*: any*/ ,
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "selectedOption",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "label",
                                "kind": "ScalarField",
                                "name": "value"
                            },
                            v17 /*: any*/ ,
                            v37 /*: any*/ 
                        ]
                    },
                    v35 /*: any*/ 
                ],
                "type": "JiraRadioSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v24 /*: any*/ ,
                    {
                        "args": v36 /*: any*/ ,
                        "concreteType": "JiraVersionConnection",
                        "kind": "LinkedField",
                        "name": "selectedVersionsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraVersionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v17 /*: any*/ ,
                                            v24 /*: any*/ ,
                                            v37 /*: any*/ ,
                                            v38 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "versionId"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "storageKey": "selectedVersionsConnection(first:1000)"
                    },
                    v35 /*: any*/ 
                ],
                "type": "JiraMultipleVersionPickerField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v24 /*: any*/ ,
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "issue",
                        "plural": false,
                        "selections": [
                            v17 /*: any*/ 
                        ]
                    },
                    {
                        "args": v36 /*: any*/ ,
                        "concreteType": "JiraGoalConnection",
                        "kind": "LinkedField",
                        "name": "selectedGoals",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraGoalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraGoal",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v17 /*: any*/ ,
                                            v15 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            v51 /*: any*/ 
                        ],
                        "storageKey": "selectedGoals(first:1000)"
                    },
                    {
                        "kind": "ClientExtension",
                        "selections": [
                            v25 /*: any*/ ,
                            v34 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraGoalsField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v24 /*: any*/ ,
                    {
                        "args": v36 /*: any*/ ,
                        "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                        "kind": "LinkedField",
                        "name": "confluenceRemoteIssueLinks",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraConfluenceRemoteIssueLink",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v17 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "href"
                                            }
                                        ]
                                    }
                                ]
                            },
                            v42 /*: any*/ 
                        ],
                        "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                    },
                    v35 /*: any*/ 
                ],
                "type": "JiraConfluenceRemoteIssueLinksField"
            }
        ]
    }, v53 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCmdbObjectConnection",
                "kind": "LinkedField",
                "name": "selectedCmdbObjectsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraCmdbObjectEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraCmdbObject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "objectId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "label"
                                    },
                                    {
                                        "concreteType": "JiraCmdbAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraCmdbMediaClientConfig",
                                                "kind": "LinkedField",
                                                "name": "mediaClientConfig",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "clientId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "fileId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaBaseUrl"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaJwtToken"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "url48"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "message"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraCMDBField"
    }, v54 = [
        v24 /*: any*/ ,
        v17 /*: any*/ 
    ], v55 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "componentsOld",
                        "concreteType": "JiraComponentConnection",
                        "kind": "LinkedField",
                        "name": "selectedComponentsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraComponentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraComponent",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": v54 /*: any*/ 
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "JiraComponentsField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v40 /*: any*/ 
                ],
                "type": "JiraSingleLineTextField"
            }
        ]
    }, v56 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v57 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "date"
            },
            v24 /*: any*/ ,
            v56 /*: any*/ ,
            v35 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v58 = {
        "kind": "InlineFragment",
        "selections": [
            v39 /*: any*/ 
        ],
        "type": "JiraDateTimePickerField"
    }, v59 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraEpic",
                "kind": "LinkedField",
                "name": "epic",
                "plural": false,
                "selections": [
                    v15 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "summary"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    },
                    v17 /*: any*/ 
                ]
            }
        ],
        "type": "JiraEpicLinkField"
    }, v60 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "renderedFieldHtml"
            }
        ],
        "type": "JiraFallbackField"
    }, v61 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatusCategory",
                "kind": "LinkedField",
                "name": "statusCategory",
                "plural": false,
                "selections": [
                    v24 /*: any*/ ,
                    v20 /*: any*/ ,
                    v17 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusCategoryField"
    }, v62 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v24 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusId"
                    },
                    v21 /*: any*/ ,
                    v17 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v63 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": v36 /*: any*/ ,
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v24 /*: any*/ ,
                                    v44 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    v42 /*: any*/ 
                ],
                "storageKey": "selectedLabelsConnection(first:1000)"
            },
            v24 /*: any*/ ,
            v35 /*: any*/ 
        ],
        "type": "JiraLabelsField"
    }, v64 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "small"
                            }
                        ]
                    },
                    v24 /*: any*/ ,
                    v17 /*: any*/ 
                ]
            }
        ],
        "type": "JiraIssueTypeField"
    }, v65 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v40 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v66 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v44 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v67 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v68 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v67 /*: any*/ ,
                    v24 /*: any*/ ,
                    v17 /*: any*/ 
                ]
            },
            v17 /*: any*/ 
        ]
    }, v69 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v70 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                    v15 /*: any*/ ,
                    v65 /*: any*/ ,
                    v17 /*: any*/ 
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "parentIssue",
                        "plural": false,
                        "selections": [
                            v15 /*: any*/ ,
                            v66 /*: any*/ ,
                            v68 /*: any*/ ,
                            v65 /*: any*/ ,
                            v17 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "parentIssue",
                        "plural": false,
                        "selections": [
                            v15 /*: any*/ ,
                            v66 /*: any*/ ,
                            v68 /*: any*/ ,
                            v65 /*: any*/ ,
                            v17 /*: any*/ ,
                            v16 /*: any*/ ,
                            v69 /*: any*/ ,
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "ids",
                                        "value": [
                                            "summary",
                                            "issuetype",
                                            "status"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fieldsById",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v18 /*: any*/ ,
                                                    v17 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v19 /*: any*/ ,
                                                            v40 /*: any*/ 
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v19 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "issueTypeId"
                                                                    },
                                                                    v24 /*: any*/ ,
                                                                    v67 /*: any*/ ,
                                                                    v23 /*: any*/ ,
                                                                    v17 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    v22 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                            }
                        ]
                    },
                    v24 /*: any*/ ,
                    v35 /*: any*/ 
                ]
            }
        ],
        "type": "JiraParentIssueField"
    }, v71 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v24 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "iconUrl"
                    },
                    v17 /*: any*/ 
                ]
            },
            v24 /*: any*/ ,
            v35 /*: any*/ 
        ],
        "type": "JiraPriorityField"
    }, v72 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    v24 /*: any*/ ,
                    v15 /*: any*/ ,
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "large"
                            }
                        ]
                    },
                    v17 /*: any*/ 
                ]
            }
        ],
        "type": "JiraProjectField"
    }, v73 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraResolution",
                "kind": "LinkedField",
                "name": "resolution",
                "plural": false,
                "selections": v54 /*: any*/ 
            }
        ],
        "type": "JiraResolutionField"
    }, v74 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraSprintConnection",
                "kind": "LinkedField",
                "name": "selectedSprintsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSprintEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v17 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "sprintId"
                                    },
                                    v24 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "state"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "endDate"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            v24 /*: any*/ ,
            v35 /*: any*/ 
        ],
        "type": "JiraSprintField"
    }, v75 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v18 /*: any*/ ,
                    v48 /*: any*/ ,
                    v49 /*: any*/ ,
                    v24 /*: any*/ ,
                    v17 /*: any*/ ,
                    v50 /*: any*/ 
                ]
            },
            v24 /*: any*/ ,
            v56 /*: any*/ ,
            v35 /*: any*/ 
        ],
        "type": "JiraSingleSelectUserPickerField"
    }, v76 = {
        "kind": "InlineFragment",
        "selections": [
            v24 /*: any*/ ,
            {
                "args": v36 /*: any*/ ,
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v54 /*: any*/ 
                            }
                        ]
                    }
                ],
                "storageKey": "selectedVersionsConnection(first:1000)"
            }
        ],
        "type": "JiraMultipleVersionPickerField"
    }, v77 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraRichText",
                "kind": "LinkedField",
                "name": "richText",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraADF",
                        "kind": "LinkedField",
                        "name": "adfValue",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "json"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraRichTextField"
    }, v78 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraServiceManagementRequestType",
                "kind": "LinkedField",
                "name": "requestType",
                "plural": false,
                "selections": [
                    v24 /*: any*/ ,
                    v67 /*: any*/ ,
                    v17 /*: any*/ 
                ]
            }
        ],
        "type": "JiraServiceManagementRequestTypeField"
    }, v79 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1
                    }
                ],
                "concreteType": "JiraIssueLinkConnection",
                "kind": "LinkedField",
                "name": "issueLinkConnection",
                "plural": false,
                "selections": [
                    v42 /*: any*/ ,
                    {
                        "concreteType": "JiraIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "issue",
                                        "plural": false,
                                        "selections": [
                                            v69 /*: any*/ ,
                                            v15 /*: any*/ ,
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "ids",
                                                        "value": [
                                                            "statusCategory"
                                                        ]
                                                    }
                                                ],
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldsById",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v18 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v21 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraStatusCategoryField"
                                                                    },
                                                                    v17 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                            },
                                            v17 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "relationName"
                                    },
                                    v17 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "issueLinkConnection(first:1)"
            }
        ],
        "type": "JiraIssueLinkField"
    }, v80 = {
        "kind": "ScalarField",
        "name": "number"
    }, v81 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraNumberFieldFormatConfig",
                "kind": "LinkedField",
                "name": "formatConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "formatStyle"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "formatUnit"
                    }
                ]
            }
        ]
    }, v82 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isStoryPointField"
            },
            v80 /*: any*/ ,
            v24 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    v80 /*: any*/ ,
                    v81 /*: any*/ 
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v80 /*: any*/ ,
                    v24 /*: any*/ ,
                    v81 /*: any*/ ,
                    v35 /*: any*/ 
                ]
            },
            v35 /*: any*/ 
        ],
        "type": "JiraNumberField"
    }, v83 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v24 /*: any*/ ,
                    {
                        "concreteType": "JiraGroupConnection",
                        "kind": "LinkedField",
                        "name": "selectedGroupsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraGroupEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraGroup",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v17 /*: any*/ ,
                                            v24 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "groupId"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v35 /*: any*/ 
                ],
                "type": "JiraMultipleGroupPickerField"
            }
        ]
    }, v84 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraFlag",
                        "kind": "LinkedField",
                        "name": "flag",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFlagged"
                            }
                        ]
                    }
                ],
                "type": "JiraFlagField"
            }
        ]
    }, v85 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraWatch",
                        "kind": "LinkedField",
                        "name": "watch",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "count"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "isWatching"
                            }
                        ]
                    }
                ],
                "type": "JiraWatchesField"
            }
        ]
    }, v86 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": v43 /*: any*/ 
    }, v87 = [
        {
            "concreteType": "JiraIssueFieldSetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v28 /*: any*/ ,
                        v29 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                v28 /*: any*/ ,
                                                v30 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                v31 /*: any*/ ,
                                                v52 /*: any*/ ,
                                                v53 /*: any*/ ,
                                                v55 /*: any*/ ,
                                                v57 /*: any*/ ,
                                                v58 /*: any*/ ,
                                                v59 /*: any*/ ,
                                                v60 /*: any*/ ,
                                                v41 /*: any*/ ,
                                                v61 /*: any*/ ,
                                                v62 /*: any*/ ,
                                                v63 /*: any*/ ,
                                                v64 /*: any*/ ,
                                                v70 /*: any*/ ,
                                                v71 /*: any*/ ,
                                                v72 /*: any*/ ,
                                                v73 /*: any*/ ,
                                                v74 /*: any*/ ,
                                                v75 /*: any*/ ,
                                                v76 /*: any*/ ,
                                                v77 /*: any*/ ,
                                                v78 /*: any*/ ,
                                                v79 /*: any*/ ,
                                                v82 /*: any*/ ,
                                                v83 /*: any*/ ,
                                                v84 /*: any*/ ,
                                                v85 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v86 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ], v88 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v89 = [
        {
            "kind": "ScalarField",
            "name": "cursor"
        },
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        },
        {
            "kind": "ScalarField",
            "name": "isCurrent"
        }
    ], v90 = {
        "kind": "ScalarField",
        "name": "displayName"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueTableViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "issueTableView_reactIssueTableGadgets"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v13 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v12 /*: any*/ ,
                v5 /*: any*/ ,
                v0 /*: any*/ ,
                v8 /*: any*/ ,
                v6 /*: any*/ ,
                v9 /*: any*/ ,
                v7 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "issueTableViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "after",
                                    "variableName": "after"
                                },
                                v14 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "fieldSetsInput",
                                    "variableName": "fieldSetsInput"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "first",
                                    "variableName": "first"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "issueSearchInput",
                                    "variableName": "issueSearchInput"
                                }
                            ],
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearchStable",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isResolved"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "ids",
                                                            "value": [
                                                                "status"
                                                            ]
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueFieldConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldsById",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v18 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v17 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldsById(ids:[\"status\"])"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canBeExported"
                                                },
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v23 /*: any*/ ,
                                                                v17 /*: any*/ 
                                                            ]
                                                        },
                                                        v17 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v24 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isHighlightedIssueRow"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "condition": "shouldQueryFieldSetsById",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "args": [
                                                                        v26 /*: any*/ ,
                                                                        v27 /*: any*/ 
                                                                    ],
                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldSetsById",
                                                                    "plural": false,
                                                                    "selections": v87 /*: any*/ 
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "shouldQueryFieldSetsById",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "context",
                                                                            "variableName": "fieldSetsContext"
                                                                        },
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "filterId",
                                                                            "variableName": "filterId"
                                                                        },
                                                                        v27 /*: any*/ ,
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "namespace",
                                                                            "variableName": "namespace"
                                                                        },
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "viewId",
                                                                            "variableName": "viewId"
                                                                        }
                                                                    ],
                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldSetsForIssueSearchView",
                                                                    "plural": false,
                                                                    "selections": v87 /*: any*/ 
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v18 /*: any*/ ,
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 500
                                                }
                                            ],
                                            "concreteType": "JiraIssueFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                v29 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fields",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v18 /*: any*/ ,
                                                                                        v19 /*: any*/ ,
                                                                                        v28 /*: any*/ ,
                                                                                        v30 /*: any*/ ,
                                                                                        v17 /*: any*/ ,
                                                                                        v31 /*: any*/ ,
                                                                                        v52 /*: any*/ ,
                                                                                        v53 /*: any*/ ,
                                                                                        v55 /*: any*/ ,
                                                                                        v57 /*: any*/ ,
                                                                                        v58 /*: any*/ ,
                                                                                        v59 /*: any*/ ,
                                                                                        v60 /*: any*/ ,
                                                                                        v41 /*: any*/ ,
                                                                                        v61 /*: any*/ ,
                                                                                        v62 /*: any*/ ,
                                                                                        v63 /*: any*/ ,
                                                                                        v64 /*: any*/ ,
                                                                                        v70 /*: any*/ ,
                                                                                        v71 /*: any*/ ,
                                                                                        v72 /*: any*/ ,
                                                                                        v73 /*: any*/ ,
                                                                                        v74 /*: any*/ ,
                                                                                        v75 /*: any*/ ,
                                                                                        v76 /*: any*/ ,
                                                                                        v77 /*: any*/ ,
                                                                                        v78 /*: any*/ ,
                                                                                        v79 /*: any*/ ,
                                                                                        v82 /*: any*/ ,
                                                                                        v83 /*: any*/ ,
                                                                                        v84 /*: any*/ ,
                                                                                        v85 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "selectedOptions",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                v47 /*: any*/ ,
                                                                                                                v51 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraCheckboxesField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fieldOption",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v46 /*: any*/ ,
                                                                                                        v17 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraSingleSelectField"
                                                                                        },
                                                                                        v51 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v86 /*: any*/ 
                                                                    ]
                                                                },
                                                                v51 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "fieldSets(first:500)"
                                        },
                                        v51 /*: any*/ 
                                    ]
                                },
                                v88 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "totalIssueSearchResultCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isCappingIssueSearchResult"
                                },
                                {
                                    "concreteType": "JiraIssueNavigatorPageInfo",
                                    "kind": "LinkedField",
                                    "name": "issueNavigatorPageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "firstIssuePosition"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "lastIssuePosition"
                                        }
                                    ]
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "maxCursors",
                                            "value": 7
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "pageSize",
                                            "variableName": "first"
                                        }
                                    ],
                                    "concreteType": "JiraPageCursors",
                                    "kind": "LinkedField",
                                    "name": "pageCursors",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "first",
                                            "plural": false,
                                            "selections": v89 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "around",
                                            "plural": true,
                                            "selections": v89 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "last",
                                            "plural": false,
                                            "selections": v89 /*: any*/ 
                                        }
                                    ]
                                },
                                v51 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                v14 /*: any*/ ,
                                v26 /*: any*/ 
                            ],
                            "concreteType": "JiraIssueSearchFieldSetConnection",
                            "kind": "LinkedField",
                            "name": "fieldSetsById",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueSearchFieldSet",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v29 /*: any*/ ,
                                                v28 /*: any*/ ,
                                                v90 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jqlTerm"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isSortable"
                                                },
                                                {
                                                    "concreteType": "JiraFieldSetPreferences",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSetPreferences",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "width"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldMetadataConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsMetadata",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueSearchMetadataField",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "canBeConfigured"
                                                                                },
                                                                                v19 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isPlaceHolderField"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraFieldType",
                                                    "kind": "LinkedField",
                                                    "name": "fieldType",
                                                    "plural": false,
                                                    "selections": [
                                                        v90 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v42 /*: any*/ ,
                                v51 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "isNotFilterFetch",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "filterAri"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        v18 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v88 /*: any*/ ,
                                        v17 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a655e3d570ec215074d9a5976c7e468db5725d1ca55bc578e50bd7806c8ef3d3",
            "metadata": {},
            "name": "issueTableViewQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": (0, $5oQtH.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $dttgK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $adKYy.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $fjldt.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": (0, $iLxt4.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $l8ssf.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": (0, $5ykrX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $ggSVP.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $knfEI.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $gY76A.default)
            }
        }
    };
}();
$328d775330990290$var$node.hash = "b9be546215dff0bc5951b61ed28bf1f5";
var $328d775330990290$export$2e2bcd8739ae039 = $328d775330990290$var$node;

});

parcelRegister("8rq2P", function(module, exports) {

$parcel$export(module.exports, "loadQueryWithUserPrefs", () => $3de2b9db429d32f1$export$700e212b8b5c678f);

var $8Uumt = parcelRequire("8Uumt");

var $5yJb9 = parcelRequire("5yJb9");

var $kipqU = parcelRequire("kipqU");

var $2mSjU = parcelRequire("2mSjU");
async function $3de2b9db429d32f1$export$700e212b8b5c678f({ filterId: filterId, columnNames: columnNames, num: num, sortField: sortField, sortDirection: sortDirection }, query, cloudId, activationId, fetchPolicy = 'store-or-network', jql) {
    const { variables: variables } = await (0, $2mSjU.transformToVariables)({
        userPrefs: {
            filterId: filterId,
            columnNames: columnNames,
            num: num,
            sortField: sortField,
            sortDirection: sortDirection
        },
        cloudId: cloudId,
        activationId: activationId,
        jql: jql
    });
    const queryReference = (0, $8Uumt.loadQuery)((0, $5yJb9.default)(), query, variables, {
        fetchPolicy: fetchPolicy
    });
    if (false && queryReference.id != null) await (0, $kipqU.QueryPromisesMap).get(queryReference.id);
    return queryReference;
}

});
parcelRegister("2mSjU", function(module, exports) {

$parcel$export(module.exports, "transformToVariables", () => $1eea58ad38e5fdd1$export$a5cefa50115212b3);

var $6oLWS = parcelRequire("6oLWS");

var $czfFt = parcelRequire("czfFt");

var $t3Q07 = parcelRequire("t3Q07");

var $796ok = parcelRequire("796ok");



const $1eea58ad38e5fdd1$export$a5cefa50115212b3 = async ({ userPrefs: userPrefs, cloudId: cloudId, activationId: activationId, jql: jql, fetchIssueTableJqlFields: fetchIssueTableJqlFields })=>{
    const { filterId: filterId, columnNames: columnNames, num: num, sortField: sortField, sortDirection: sortDirection, showResolved: showResolved } = userPrefs;
    const filterAri = !jql && filterId ? (0, $6oLWS.JiraFilterAri).create({
        filterId: filterId,
        siteId: cloudId,
        activationId: activationId
    }).toString() : '';
    const variables = {
        cloudId: cloudId,
        issueSearchInput: {
            ...jql ? {
                jql: jql
            } : {
                filterId: filterId
            }
        },
        after: null,
        first: num,
        fieldSetIds: columnNames,
        amountOfColumns: (0, $czfFt.MAX_COLUMNS),
        shouldQueryFieldSetsById: true,
        fieldSetsInput: {
            fieldSetIds: columnNames
        },
        isNotFilterFetch: !filterAri,
        filterAri: filterAri
    };
    let fieldToJqlTermMap = new Map();
    if (!sortField || !sortDirection || ![
        'ASC',
        'DESC'
    ].includes(sortDirection)) return {
        variables: variables,
        fieldToJqlTermMap: fieldToJqlTermMap
    };
    let jqlToModify = jql;
    if (fetchIssueTableJqlFields && !jqlToModify && filterAri) {
        const result = await fetchIssueTableJqlFields(filterAri, variables.fieldSetIds, cloudId);
        fieldToJqlTermMap = result.fieldToJqlTermMap;
        jqlToModify = result.searchJql;
    }
    if (!jqlToModify) return {
        variables: variables,
        fieldToJqlTermMap: fieldToJqlTermMap
    };
    // This pulls in over 600KB of code, and if it's not deferred it's eagerly loaded as
    // part of the main jira-spa route map
    const [{ JqlUtils: JqlUtils }, { default: removeFieldClauseFromJql }, { default: findClauseInAst }] = await Promise.all([
        (parcelRequire("lEsjw")),
        (parcelRequire("60ZTe")),
        (parcelRequire("j4Vmz"))
    ]);
    const jqlUtils = new JqlUtils();
    const jqlTermForSortField = (0, $796ok.getJqlTermForField)(sortField, fieldToJqlTermMap);
    const modifiedJql = jqlUtils.jql(jqlToModify);
    const oldPrimarySortField = modifiedJql.getPrimarySortField();
    if (oldPrimarySortField) {
        // if the sort field in original filter jql is using alias, we need to pass all possible aliases in
        // so that jqlUtils knows to replace it instead of append it as a new field
        const aliases = (0, $t3Q07.getAliasesForField)(jqlTermForSortField, fieldToJqlTermMap);
        // Sometimes, oldPrimarySortField from the JQL has
        // quotations around it which we should include
        const inclusiveAliases = Array.from(new Set([
            ...aliases,
            oldPrimarySortField
        ]));
        modifiedJql.setPrimarySortField(jqlTermForSortField, sortDirection, inclusiveAliases);
    } else modifiedJql.setPrimarySortField(jqlTermForSortField, sortDirection, []);
    let finalJql = modifiedJql.jqlString;
    if (showResolved) {
        const jast = modifiedJql.jast;
        if (jast) {
            const statusClause = findClauseInAst(jast, 'statusCategory');
            if (statusClause) finalJql = removeFieldClauseFromJql(jast, statusClause);
        }
    }
    return {
        variables: {
            ...variables,
            issueSearchInput: {
                jql: finalJql
            }
        },
        fieldToJqlTermMap: fieldToJqlTermMap
    };
};

});
parcelRegister("czfFt", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $7f8ee02f08da8eac$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $7f8ee02f08da8eac$export$d57b6b390e78d90f);
$parcel$export(module.exports, "SORT_ASC", () => $7f8ee02f08da8eac$export$88956207daf9a17e);
$parcel$export(module.exports, "SORT_DESC", () => $7f8ee02f08da8eac$export$bc14f97913aaf2a);
$parcel$export(module.exports, "SORT_NONE", () => $7f8ee02f08da8eac$export$9c424bf3e8ffe64e);
$parcel$export(module.exports, "MODIFY_COLUMNS", () => $7f8ee02f08da8eac$export$1f921c78ce6d243c);
$parcel$export(module.exports, "REORDER_COLUMNS", () => $7f8ee02f08da8eac$export$83371d6c41a974aa);
$parcel$export(module.exports, "RESTORE_COLUMNS", () => $7f8ee02f08da8eac$export$3bfe53b79fc4f6ed);
$parcel$export(module.exports, "MOVE_COLUMN_FIRST", () => $7f8ee02f08da8eac$export$957d455bb65919d8);
$parcel$export(module.exports, "MOVE_COLUMN_LEFT", () => $7f8ee02f08da8eac$export$2082861c970802b0);
$parcel$export(module.exports, "MOVE_COLUMN_RIGHT", () => $7f8ee02f08da8eac$export$21847d308b0769ad);
$parcel$export(module.exports, "MOVE_COLUMN_LAST", () => $7f8ee02f08da8eac$export$c32913bc261af82d);
$parcel$export(module.exports, "BORDER_WIDTH", () => $7f8ee02f08da8eac$export$e2bd4c1faded7921);
$parcel$export(module.exports, "HEADER_HEIGHT", () => $7f8ee02f08da8eac$export$cdb7fd9d999c7168);
$parcel$export(module.exports, "ROW_HEIGHT", () => $7f8ee02f08da8eac$export$88e6c5bab2ff80e8);
$parcel$export(module.exports, "COLUMN_ID_MEATBALL_MENU", () => $7f8ee02f08da8eac$export$de4c02b525d877fa);
$parcel$export(module.exports, "COLUMN_ID_EXPAND_BUTTON", () => $7f8ee02f08da8eac$export$c3266da279aa6b84);
$parcel$export(module.exports, "COLUMN_ID_CHECKBOX", () => $7f8ee02f08da8eac$export$66b2a4a5f67468ac);
$parcel$export(module.exports, "COLUMN_ID_INTERNAL_COLUMN", () => $7f8ee02f08da8eac$export$b4e9105b7f5f1b0f);
$parcel$export(module.exports, "ACTION_COLUMNS", () => $7f8ee02f08da8eac$export$3dbdc5c16825be4d);
$parcel$export(module.exports, "EXPAND_BUTTON_WIDTH", () => $7f8ee02f08da8eac$export$a1c171a82c45d53f);
$parcel$export(module.exports, "CREATE_CHILD_BUTTON_WIDTH", () => $7f8ee02f08da8eac$export$43ff8c492b8a2e1b);
$parcel$export(module.exports, "EXPAND_CELL_PADDING", () => $7f8ee02f08da8eac$export$9c5dd6078b37aac2);
$parcel$export(module.exports, "DEPTH_WIDTH", () => $7f8ee02f08da8eac$export$a8273d7d48e89fce);
$parcel$export(module.exports, "MAX_COLUMNS", () => $7f8ee02f08da8eac$export$7ec4af037f372df4);
$parcel$export(module.exports, "CHILD_QUERY_PAGE_SIZE", () => $7f8ee02f08da8eac$export$d2372dfbd4e91a11);
$parcel$export(module.exports, "COLUMN_TYPE_PARENT_LINK", () => $7f8ee02f08da8eac$export$1adf7afff96bbf16);
$parcel$export(module.exports, "MINIMUM_COLUMN_WIDTH_COMPACT", () => $7f8ee02f08da8eac$export$10016003aa27fa67);
$parcel$export(module.exports, "MINIMUM_COLUMN_WIDTH", () => $7f8ee02f08da8eac$export$5575b9e0ed3ff59f);
$parcel$export(module.exports, "DEFAULT_COLUMN_WIDTH", () => $7f8ee02f08da8eac$export$7c3f559e2ca95fa);
$parcel$export(module.exports, "MAXIMUM_COLUMN_WIDTH", () => $7f8ee02f08da8eac$export$e1a42c2fefb5af25);
$parcel$export(module.exports, "SINGLE_LINE_ROW_HEIGHT_MINIMUM_COLUMN_WIDTH", () => $7f8ee02f08da8eac$export$54fb99171fb48426);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_LONG", () => $7f8ee02f08da8eac$export$bfe09a9186b98f8f);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_SHORT", () => $7f8ee02f08da8eac$export$f2540f34b796306d);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_SUMMARY", () => $7f8ee02f08da8eac$export$954afb0fcf5a326);
$parcel$export(module.exports, "COLUMN_OPERATION_REORDER", () => $7f8ee02f08da8eac$export$93758649595b2d58);
$parcel$export(module.exports, "COLUMN_OPERATION_RESIZE", () => $7f8ee02f08da8eac$export$cad8c6a0b6e78898);
$parcel$export(module.exports, "INSERT_COLUMN_BUTTON_Y_OFFSET", () => $7f8ee02f08da8eac$export$5252387dc65db584);
$parcel$export(module.exports, "COLUMN_RESIZE_HANDLE_FULL_HEIGHT", () => $7f8ee02f08da8eac$export$754b76ac8fa63350);
$parcel$export(module.exports, "COLUMN_RESIZE_HANDLE_HEADER_ONLY", () => $7f8ee02f08da8eac$export$fa5c7dad7ee16383);
$parcel$export(module.exports, "ROW_OPERATION_REORDER", () => $7f8ee02f08da8eac$export$4e8abe16cd1126dd);
$parcel$export(module.exports, "DENSITY_COMPACT", () => $7f8ee02f08da8eac$export$6c0a5a77457ca62);
$parcel$export(module.exports, "DENSITY_FULL", () => $7f8ee02f08da8eac$export$119d8ab9a5bc4b2);
$parcel$export(module.exports, "LAZY_EDITABILITY_LOADER_CONTAINER_SCOPE", () => $7f8ee02f08da8eac$export$9ef77944c441ad07);
$parcel$export(module.exports, "LAZY_MEDIA_VIEW_CONTEXT_LOADER_CONTAINER_SCOPE", () => $7f8ee02f08da8eac$export$c1f680390b97c9e1);
$parcel$export(module.exports, "CHILD_ITEMS_EXPERIENCE", () => $7f8ee02f08da8eac$export$e03155205bf92428);
$parcel$export(module.exports, "CHILD_ITEMS_LOAD_MORE_EXPERIENCE", () => $7f8ee02f08da8eac$export$311c64c0d94dcdf3);
$parcel$export(module.exports, "GROUPED_ITEMS_EXPERIENCE", () => $7f8ee02f08da8eac$export$f5d215df3c6473e9);
$parcel$export(module.exports, "GROUPED_LOAD_MORE_EXPERIENCE", () => $7f8ee02f08da8eac$export$b4fd503bf7cccacd);
$parcel$export(module.exports, "INLINE_ISSUE_CREATE_EXPERIENCE", () => $7f8ee02f08da8eac$export$70f80a241e016093);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $7f8ee02f08da8eac$export$f7109619a5e9e0d6);
$parcel$export(module.exports, "MAKE_CHILD", () => $7f8ee02f08da8eac$export$5eb61e3ff74a4f58);
$parcel$export(module.exports, "REORDER_ABOVE", () => $7f8ee02f08da8eac$export$9213b5774112217f);
$parcel$export(module.exports, "REORDER_BELOW", () => $7f8ee02f08da8eac$export$118b06a03e2c672f);
$parcel$export(module.exports, "SUBTASK_HIERARCHY_LEVEL", () => $7f8ee02f08da8eac$export$5b388ccfa29be01);
$parcel$export(module.exports, "COLUMN_PICKER_CONFIGURATION_CONTAINER", () => $7f8ee02f08da8eac$export$f6d7582f33b86010);
$parcel$export(module.exports, "COLUMN_PICKER_ADD_COLUMN_CONTAINER", () => $7f8ee02f08da8eac$export$f92486d03c064eac);
$parcel$export(module.exports, "MAX_LINE_WRAP_OLD", () => $7f8ee02f08da8eac$export$139bffb2a576e8c0);
$parcel$export(module.exports, "MAX_LINE_WRAP_NEW", () => $7f8ee02f08da8eac$export$3b696b0ac06c2cc4);
$parcel$export(module.exports, "HIGHLIGHT_LINGER_DURATION_MS", () => $7f8ee02f08da8eac$export$6ba5aaedfd1b5319);
$parcel$export(module.exports, "SORT_A_TO_Z", () => $7f8ee02f08da8eac$export$1bc2edb2aa5e8282);
$parcel$export(module.exports, "SORT_Z_TO_A", () => $7f8ee02f08da8eac$export$c7b524b6c48f8273);
$parcel$export(module.exports, "SORT_LOWEST_TO_HIGHEST", () => $7f8ee02f08da8eac$export$9c60c93d5e95e80f);
$parcel$export(module.exports, "SORT_HIGHEST_TO_LOWEST", () => $7f8ee02f08da8eac$export$476f4bdd6eba4fb2);
$parcel$export(module.exports, "SORT_OLDEST_TO_NEWEST", () => $7f8ee02f08da8eac$export$fbcac9f513cf13f4);
$parcel$export(module.exports, "SORT_NEWEST_TO_OLDEST", () => $7f8ee02f08da8eac$export$d3c0241ce8ae9a73);

var $65VLO = parcelRequire("65VLO");
const $7f8ee02f08da8eac$export$b8b9d90f9e5bd72b = 'jiraNativeIssueTable';
const $7f8ee02f08da8eac$export$d57b6b390e78d90f = 'empanada';
const $7f8ee02f08da8eac$export$88956207daf9a17e = 'ASC';
const $7f8ee02f08da8eac$export$bc14f97913aaf2a = 'DESC';
const $7f8ee02f08da8eac$export$9c424bf3e8ffe64e = 'NONE';
const $7f8ee02f08da8eac$export$1f921c78ce6d243c = 'MODIFY_COLUMNS';
const $7f8ee02f08da8eac$export$83371d6c41a974aa = 'REORDER_COLUMNS';
const $7f8ee02f08da8eac$export$3bfe53b79fc4f6ed = 'RESTORE_COLUMNS';
const $7f8ee02f08da8eac$export$957d455bb65919d8 = 'MOVE_COLUMN_FIRST';
const $7f8ee02f08da8eac$export$2082861c970802b0 = 'MOVE_COLUMN_LEFT';
const $7f8ee02f08da8eac$export$21847d308b0769ad = 'MOVE_COLUMN_RIGHT';
const $7f8ee02f08da8eac$export$c32913bc261af82d = 'MOVE_COLUMN_LAST';
const $7f8ee02f08da8eac$export$e2bd4c1faded7921 = '1px';
const $7f8ee02f08da8eac$export$cdb7fd9d999c7168 = 40;
const $7f8ee02f08da8eac$export$88e6c5bab2ff80e8 = 40;
const $7f8ee02f08da8eac$export$de4c02b525d877fa = '__issuetable_internal_meatball';
const $7f8ee02f08da8eac$export$c3266da279aa6b84 = '__issuetable_internal_expand_button';
const $7f8ee02f08da8eac$export$66b2a4a5f67468ac = '__issuetable_internal_checkbox';
const $7f8ee02f08da8eac$export$b4e9105b7f5f1b0f = '__issuetable_internal';
const $7f8ee02f08da8eac$export$3dbdc5c16825be4d = [
    $7f8ee02f08da8eac$export$c3266da279aa6b84,
    $7f8ee02f08da8eac$export$de4c02b525d877fa,
    $7f8ee02f08da8eac$export$66b2a4a5f67468ac,
    (0, $65VLO.COLUMN_ID_MERGED_COLUMN)
];
const $7f8ee02f08da8eac$export$a1c171a82c45d53f = 24;
const $7f8ee02f08da8eac$export$43ff8c492b8a2e1b = 24;
const $7f8ee02f08da8eac$export$9c5dd6078b37aac2 = 16;
const $7f8ee02f08da8eac$export$a8273d7d48e89fce = 24;
const $7f8ee02f08da8eac$export$7ec4af037f372df4 = 500;
const $7f8ee02f08da8eac$export$d2372dfbd4e91a11 = 50;
const $7f8ee02f08da8eac$export$ce9e2d7c178a9557 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $7f8ee02f08da8eac$export$1adf7afff96bbf16 = 'com.atlassian.jpo:jpo-custom-field-parent';
const $7f8ee02f08da8eac$export$c1d348661674e922 = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $7f8ee02f08da8eac$export$67082d449d5ec91 = 'com.atlassian.servicedesk:sd-request-feedback';
const $7f8ee02f08da8eac$export$145a4a20f394acf9 = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
const $7f8ee02f08da8eac$export$55628b4c44d1522a = 'NATURAL_LANGUAGE_TO_JQL';
const $7f8ee02f08da8eac$export$10016003aa27fa67 = 40; // 2 x 8px cell padding + 24px icon size
const $7f8ee02f08da8eac$export$5575b9e0ed3ff59f = 69; // 2 x 8px cell padding + 2 x 24px icon size + 4px gap + 1px border
const $7f8ee02f08da8eac$export$7c3f559e2ca95fa = 170;
const $7f8ee02f08da8eac$export$e1a42c2fefb5af25 = 999;
const $7f8ee02f08da8eac$export$54fb99171fb48426 = 80;
const $7f8ee02f08da8eac$export$a194aa0e243a27f9 = 156;
const $7f8ee02f08da8eac$export$87a3548b97ce2540 = 136;
const $7f8ee02f08da8eac$export$d182a35496b19fb4 = 112;
const $7f8ee02f08da8eac$export$4fd6711c21931f5b = 116;
const $7f8ee02f08da8eac$export$9b72110b9a7c0a39 = 102;
const $7f8ee02f08da8eac$export$54c15048528650a8 = 84;
const $7f8ee02f08da8eac$export$7ed05c26fe24a805 = 200;
const $7f8ee02f08da8eac$export$bfe09a9186b98f8f = 400;
const $7f8ee02f08da8eac$export$f2540f34b796306d = 300;
const $7f8ee02f08da8eac$export$954afb0fcf5a326 = 450;
const $7f8ee02f08da8eac$export$93758649595b2d58 = 'reorder';
const $7f8ee02f08da8eac$export$cad8c6a0b6e78898 = 'resize';
const $7f8ee02f08da8eac$export$5252387dc65db584 = -16;
const $7f8ee02f08da8eac$export$754b76ac8fa63350 = 'FULL_HEIGHT';
const $7f8ee02f08da8eac$export$fa5c7dad7ee16383 = 'HEADER_ONLY';
const $7f8ee02f08da8eac$export$4e8abe16cd1126dd = 'rowReorder';
const $7f8ee02f08da8eac$export$6c0a5a77457ca62 = 'COMPACT';
const $7f8ee02f08da8eac$export$119d8ab9a5bc4b2 = 'FULL';
const $7f8ee02f08da8eac$export$9ef77944c441ad07 = 'LAZY_EDITABILITY_LOADER_CONTAINER_SCOPE';
const $7f8ee02f08da8eac$export$c1f680390b97c9e1 = 'LAZY_MEDIA_VIEW_CONTEXT_LOADER_CONTAINER_SCOPE';
const $7f8ee02f08da8eac$export$e03155205bf92428 = 'loadChildItems';
const $7f8ee02f08da8eac$export$311c64c0d94dcdf3 = 'loadMoreChildItems';
const $7f8ee02f08da8eac$export$f5d215df3c6473e9 = 'loadGroupChildren';
const $7f8ee02f08da8eac$export$b4fd503bf7cccacd = 'loadMoreGroupedItems';
const $7f8ee02f08da8eac$export$70f80a241e016093 = 'createIssue';
const $7f8ee02f08da8eac$export$f7109619a5e9e0d6 = 'jira-native-issue-table';
const $7f8ee02f08da8eac$export$5eb61e3ff74a4f58 = 'make-child';
const $7f8ee02f08da8eac$export$9213b5774112217f = 'reorder-above';
const $7f8ee02f08da8eac$export$118b06a03e2c672f = 'reorder-below';
const $7f8ee02f08da8eac$export$5b388ccfa29be01 = -1;
const $7f8ee02f08da8eac$export$f6d7582f33b86010 = 'COLUMN_PICKER_CONFIGURATION_CONTAINER';
const $7f8ee02f08da8eac$export$f92486d03c064eac = 'COLUMN_PICKER_ADD_COLUMN_CONTAINER';
const $7f8ee02f08da8eac$export$139bffb2a576e8c0 = 2;
const $7f8ee02f08da8eac$export$3b696b0ac06c2cc4 = 1;
const $7f8ee02f08da8eac$export$6ba5aaedfd1b5319 = 2000;
const $7f8ee02f08da8eac$export$1bc2edb2aa5e8282 = 'a_to_z';
const $7f8ee02f08da8eac$export$c7b524b6c48f8273 = 'z_to_a';
const $7f8ee02f08da8eac$export$9c60c93d5e95e80f = 'lowest_to_highest';
const $7f8ee02f08da8eac$export$476f4bdd6eba4fb2 = 'highest_to_lowest';
const $7f8ee02f08da8eac$export$fbcac9f513cf13f4 = 'oldest_to_newest';
const $7f8ee02f08da8eac$export$d3c0241ce8ae9a73 = 'newest_to_oldest';

});
parcelRegister("65VLO", function(module, exports) {

$parcel$export(module.exports, "KNOWN_COLUMN_TYPES", () => $1fec13ea3747c865$export$bbc2e8c301f97f97);
$parcel$export(module.exports, "COLUMN_ID_EXPAND_BUTTON", () => $1fec13ea3747c865$export$c3266da279aa6b84);
$parcel$export(module.exports, "COLUMN_ID_CHECKBOX", () => $1fec13ea3747c865$export$66b2a4a5f67468ac);
$parcel$export(module.exports, "COLUMN_ID_MERGED_COLUMN", () => $1fec13ea3747c865$export$3237751348c4f1b);
$parcel$export(module.exports, "MERGED_COLUMN_IDS", () => $1fec13ea3747c865$export$70f30e260ec270f2);
$parcel$export(module.exports, "MERGED_COLUMN_DEFAULT_WIDTH", () => $1fec13ea3747c865$export$6aa1d347deb86ef3);
const $1fec13ea3747c865$export$bbc2e8c301f97f97 = {
    ASSIGNEE: 'assignee',
    CHECKBOX: '__issuetable_internal_checkbox',
    CHECKBOX_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes',
    DESCRIPTION: 'description',
    ENVIRONMENT: 'environment',
    EXPAND_BUTTON: '__issuetable_internal_expand_button',
    ISSUE_KEY: 'issuekey',
    ISSUE_OPERATIONS: '__issuetable_internal_meatball',
    STATUS: 'status',
    SUMMARY: 'summary',
    ISSUE_TYPE: 'issuetype',
    RESOLUTION: 'resolution',
    PARENT: 'parent',
    LABELS: 'labels',
    COMPONENTS: 'components',
    FIX_VERSIONS: 'fixVersions',
    STATUS_CATEGORY: 'statusCategory',
    PROJECT: 'project',
    READ_ONLY: 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield',
    SPRINT: 'com.pyxis.greenhopper.jira:gh-sprint',
    TEXT: 'com.atlassian.jira.plugin.system.customfieldtypes:textfield',
    EPIC_LINK: 'com.pyxis.greenhopper.jira:gh-epic-link',
    CREATED: 'created',
    RESOLUTION_DATE: 'resolutiondate',
    TEXT_AREA: 'com.atlassian.jira.plugin.system.customfieldtypes:textarea',
    UPDATED: 'updated',
    DUE_DATE: 'duedate',
    REPORTER: 'reporter',
    CREATOR: 'creator',
    PRIORITY: 'priority',
    AFFECTS_VERSIONS: 'versions',
    REQUEST_TYPE: 'com.atlassian.servicedesk:vp-origin',
    NUMBER: 'com.atlassian.jira.plugin.system.customfieldtypes:float',
    STORY_POINT_ESTIMATE: 'com.pyxis.greenhopper.jira:jsw-story-points',
    USER_PICKER: 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker',
    CUSTOM_LABELS: 'com.atlassian.jira.plugin.system.customfieldtypes:labels',
    DATE_TIME: 'com.atlassian.jira.plugin.system.customfieldtypes:datetime',
    URL: 'com.atlassian.jira.plugin.system.customfieldtypes:url',
    SINGLE_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:select',
    MULTI_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect',
    MULTI_USER_PICKER: 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker',
    MERGED_COLUMN: '__issuetable_internal_merged_column',
    TEAM: 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team',
    ORIGINAL_ESTIMATE: 'timeoriginalestimate',
    GOALS: 'com.atlassian.jira.plugin.system.customfieldtypes:goals',
    CASCADING_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect',
    CONFLUENCE_PAGES: 'confluenceRemoteIssueLinks',
    PEOPLE: 'com.atlassian.jira.plugin.system.customfieldtypes:people',
    DATE_PICKER: 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker'
};
const $1fec13ea3747c865$export$de4c02b525d877fa = '__issuetable_internal_meatball';
const $1fec13ea3747c865$export$c3266da279aa6b84 = '__issuetable_internal_expand_button';
const $1fec13ea3747c865$export$66b2a4a5f67468ac = '__issuetable_internal_checkbox';
const $1fec13ea3747c865$export$3237751348c4f1b = '__issuetable_internal_merged_column';
const $1fec13ea3747c865$export$72f66561203b705c = [
    $1fec13ea3747c865$export$bbc2e8c301f97f97.ISSUE_TYPE,
    $1fec13ea3747c865$export$bbc2e8c301f97f97.ISSUE_KEY,
    $1fec13ea3747c865$export$bbc2e8c301f97f97.SUMMARY
];
const $1fec13ea3747c865$export$70f30e260ec270f2 = [
    'issuetype',
    'issuekey',
    'summary'
];
const $1fec13ea3747c865$export$6aa1d347deb86ef3 = 64; // 24 * 2 (two icons) + 8*2 (horizontal padding)

});


parcelRegister("t3Q07", function(module, exports) {

$parcel$export(module.exports, "getAliasesForField", () => $a3816529ae558e1d$export$94d69942fbe58a01);
const $a3816529ae558e1d$export$94d69942fbe58a01 = (field, fieldToJqlTermMap)=>{
    // provided field could be a field id, name, an alias, or a jql term
    let term = fieldToJqlTermMap.get(field);
    if (term === undefined) {
        // it may be a jql term itself
        // filter is still an experiment feature in Iterator so we do old school looping
        for (const keyValuePair of fieldToJqlTermMap.entries())if (keyValuePair[1] === field) {
            term = keyValuePair[1];
            break;
        }
    }
    if (term === undefined) return [];
    // we do a reverse look-up to find any other keys of this jql term, they can all be used in a jql
    const set = new Set();
    set.add(term);
    for (const keyValuePair of fieldToJqlTermMap.entries())if (keyValuePair[1] === term) set.add(keyValuePair[0]);
    return Array.from(set);
};

});

parcelRegister("796ok", function(module, exports) {

$parcel$export(module.exports, "getJqlTermForField", () => $ad837b869bddcad8$export$ef4e8b2c9bc7bd4d);

var $bCU3R = parcelRequire("bCU3R");
const $ad837b869bddcad8$export$ef4e8b2c9bc7bd4d = (field, fieldToJqlTermMap)=>{
    const convertedField = (0, $bCU3R.convertFieldToJqlTerm)(field);
    const jqlTermForField = fieldToJqlTermMap.get(convertedField) ?? convertedField;
    return jqlTermForField;
};

});
parcelRegister("bCU3R", function(module, exports) {

$parcel$export(module.exports, "convertFieldToJqlTerm", () => $1e1011370a3a12e2$export$29f734dc2c61ea9d);
const $1e1011370a3a12e2$export$29f734dc2c61ea9d = (fieldName)=>{
    // custom fields are indexed by their ids and only work with JQL when referenced as such `cf[id]`.
    // fieldName match regex for customfield_<number> exactly
    // legacy gadget may have it stored as customfield_<number> in user prefs
    if (/^customfield_\d+$/.test(fieldName)) {
        const customFieldId = fieldName.split('customfield_')[1];
        return `cf[${customFieldId}]`;
    }
    return fieldName;
};

});


parcelRegister("lEsjw", function(module, exports) {

let $fc334bf5644f80c4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fc334bf5644f80c4$var$load("i8Zoh").then(()=>parcelRequire('aWG9Z'));

});

parcelRegister("60ZTe", function(module, exports) {

let $4612c03314737910$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4612c03314737910$var$load("4EmhV").then(()=>parcelRequire('eWn4R'));

});

parcelRegister("j4Vmz", function(module, exports) {

let $de3ae31f5334659f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $de3ae31f5334659f$var$load("fEFRC").then(()=>parcelRequire('ajrrh'));

});



parcelRegister("jyMtv", function(module, exports) {

$parcel$export(module.exports, "transformToValidUserPrefs", () => $8cfaebab7e294873$export$e9345b021afd3cc3);

var $hwva3 = parcelRequire("hwva3");

var $Z4X9T = parcelRequire("Z4X9T");

var $hCluT = parcelRequire("hCluT");
const $8cfaebab7e294873$export$e9345b021afd3cc3 = (rawUserPrefs)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const pageSize = parseInt(rawUserPrefs.num, 10);
    const fieldSetIds = (0, $hwva3.convertUserPrefsToColumnNames)(rawUserPrefs.columnNames);
    const stringifiedFilterId = `${rawUserPrefs.filterId}`;
    const { sortDirection: sortDirection, sortField: sortField } = (0, $Z4X9T.getSortFieldAndDirection)(rawUserPrefs.sortBy);
    const showResolved = !!rawUserPrefs.showResolved;
    return {
        filterId: (0, $hCluT.isFilterId)(stringifiedFilterId) ? stringifiedFilterId : undefined,
        columnNames: fieldSetIds,
        num: !Number.isNaN(pageSize) ? pageSize : 10,
        sortDirection: sortDirection,
        sortField: sortField,
        showResolved: showResolved
    };
};

});
parcelRegister("hwva3", function(module, exports) {

$parcel$export(module.exports, "convertUserPrefsToColumnNames", () => $ffa5f3be2fc11704$export$6e5cdc232ebb20cf);

var $JIPqS = parcelRequire("JIPqS");

const $ffa5f3be2fc11704$export$6e5cdc232ebb20cf = (columns)=>typeof columns === 'string' && columns !== '' && columns !== '--Default--' ? columns.split((0, $e997f85ca70fa8bf$export$a3d4af30107c4f4d)).map((col)=>col.replaceAll((0, $e997f85ca70fa8bf$export$952287cc7aef3a4c), (0, $e997f85ca70fa8bf$export$a3d4af30107c4f4d))) : (0, $JIPqS.ISSUE_SEARCH_DEFAULT_COLUMNS);

});
const $e997f85ca70fa8bf$export$dd03181e30c7d559 = 5;
const $e997f85ca70fa8bf$export$a3d4af30107c4f4d = '|';
const $e997f85ca70fa8bf$export$952287cc7aef3a4c = '%7C';


parcelRegister("Z4X9T", function(module, exports) {

$parcel$export(module.exports, "getSortFieldAndDirection", () => $834bd6f85e4a1e0d$export$e535bb2dfaa4d10b);
const $834bd6f85e4a1e0d$export$e535bb2dfaa4d10b = (sortByFromUserPrefs)=>{
    const [sortField, sortDirection] = typeof sortByFromUserPrefs === 'string' ? sortByFromUserPrefs.split(':') : [];
    if (!sortField || sortDirection !== 'ASC' && sortDirection !== 'DESC') return {};
    return {
        sortField: sortField,
        sortDirection: sortDirection
    };
};

});

parcelRegister("hCluT", function(module, exports) {

$parcel$export(module.exports, "isFilterId", () => $39fbd6b125bd3cbf$export$23be85030bd58047);
// this is copied from NIN https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/jira/src/packages/issue-navigator/actions/common/src/utils/filters/index.tsx?at=abdc1df97c8cee2475285ab25c47a938ce99d65a
const $39fbd6b125bd3cbf$export$23be85030bd58047 = (value)=>value !== undefined && /^-?\d+$/.test(value);

});




parcelRegister("26UOd", function(module, exports) {

$parcel$export(module.exports, "REACT_KEY", () => $c373d1a6bf5d7ef6$export$e0e89108956f58f6);
// React gadget keys
const $c373d1a6bf5d7ef6$export$c8ae0b83405368ed = 'react/filter-results';
const $c373d1a6bf5d7ef6$var$REACT_KEY_ASSIGNED_TO_ME = 'react/assigned-to-me';
const $c373d1a6bf5d7ef6$var$REACT_KEY_ISSUES_IN_PROGRESS = 'react/issues-in-progress';
const $c373d1a6bf5d7ef6$var$REACT_KEY_VOTED_ISSUES = 'react/voted-issues';
const $c373d1a6bf5d7ef6$var$REACT_KEY_WATCHED_ISSUES = 'react/watched-issues';
const $c373d1a6bf5d7ef6$var$REACT_KEY_CUSTOM_REPORT = 'react/custom-report';
const $c373d1a6bf5d7ef6$export$e0e89108956f58f6 = {
    FILTER_RESULTS: $c373d1a6bf5d7ef6$export$c8ae0b83405368ed,
    ASSIGNED_TO_ME: $c373d1a6bf5d7ef6$var$REACT_KEY_ASSIGNED_TO_ME,
    ISSUES_IN_PROGRESS: $c373d1a6bf5d7ef6$var$REACT_KEY_ISSUES_IN_PROGRESS,
    VOTED_ISSUES: $c373d1a6bf5d7ef6$var$REACT_KEY_VOTED_ISSUES,
    WATCHED_ISSUES: $c373d1a6bf5d7ef6$var$REACT_KEY_WATCHED_ISSUES,
    CUSTOM_REPORT: $c373d1a6bf5d7ef6$var$REACT_KEY_CUSTOM_REPORT
};

});




parcelRegister("aVFmC", function(module, exports) {

$parcel$export(module.exports, "default", () => $31463ce0406b73cb$export$2e2bcd8739ae039);

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$31463ce0406b73cb$export$2e2bcd8739ae039 = async ()=>(0, $eusud.performGetRequest)('/rest/config/1.0/directoryitems.json');

});

parcelRegister("3Zhqx", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1c788e303134293$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $5IKQ6 = parcelRequire("5IKQ6");

var $kspzT = parcelRequire("kspzT");

var $3Yd87 = parcelRequire("3Yd87");

var $kGR9w = parcelRequire("kGR9w");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b1c788e303134293$export$2e2bcd8739ae039 = (maybePrevData, sharedValue)=>({ isPrefetch: isPrefetch }, spaContext)=>{
        if (!sharedValue || sharedValue instanceof Error) throw new (0, $3Yd87.SharedValueAggregateError)({
            sharedValue: sharedValue,
            isPrefetch: isPrefetch,
            name: 'AMD modules resource'
        });
        return (async ()=>{
            const { reactGadgets: nextGadgets } = sharedValue;
            const prev = maybePrevData != null && !(maybePrevData instanceof Error) && maybePrevData.reactGadgetsState || {};
            const persistedGadgets = nextGadgets.filter(({ id: id })=>!!prev[id]);
            const gadgetsToLoad = nextGadgets.filter((gadget)=>{
                // componentEdit will be optional in the future, although currently types say that it's required
                const isConfigurable = !!(0, $kspzT.default)[gadget.reactKey].componentEdit;
                const isUnconfigured = isConfigurable && !(0, $5IKQ6.isGadgetConfigured)(gadget.userPrefs);
                return !prev[gadget.id] && !isUnconfigured;
            });
            const skippedGadgets = nextGadgets.filter((gadget)=>!prev[gadget.id] && !gadgetsToLoad.some(({ id: id })=>id === gadget.id));
            const reactGadgetsState = {
                ...Object.fromEntries(persistedGadgets.map(({ id: id })=>[
                        id,
                        prev[id]
                    ])),
                ...Object.fromEntries(skippedGadgets.map(({ id: id })=>[
                        id,
                        {}
                    ])),
                ...await (0, $kGR9w.loadReactGadgets)(gadgetsToLoad, spaContext)
            };
            return {
                sharedValue: sharedValue,
                reactGadgetsState: reactGadgetsState
            };
        })();
    };

});
parcelRegister("5IKQ6", function(module, exports) {

$parcel$export(module.exports, "isGadgetConfigured", () => $ce7e823be599a5b0$export$b625fae487818738);
const $ce7e823be599a5b0$export$b625fae487818738 = (userPrefs)=>userPrefs?.fields.some(({ name: name, value: value })=>name === 'isConfigured' && value === 'true') ?? false;

});

parcelRegister("kGR9w", function(module, exports) {

$parcel$export(module.exports, "loadReactGadgets", () => $ae0204181dcaff49$export$7e1a3455761184a2);
// eslint-disable-next-line jira/import-whitelist

var $kspzT = parcelRequire("kspzT");
const $ae0204181dcaff49$var$preloadGadgetBundles = (reactKeys)=>reactKeys.forEach((reactKey)=>{
        (0, $kspzT.default)[reactKey].preload();
    });
const $ae0204181dcaff49$export$7e1a3455761184a2 = async (gadgets, spaContext)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const distinctReactKeys = [
        ...new Set(gadgets.map((gadget)=>gadget.reactKey))
    ];
    $ae0204181dcaff49$var$preloadGadgetBundles(distinctReactKeys);
    return Object.fromEntries(await Promise.all(gadgets.map(({ id: id, reactKey: reactKey, userPrefs: userPrefs })=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $kspzT.default)[reactKey]?.getInitialState(spaContext, userPrefs?.fields || []).then((state)=>[
                id,
                state
            ], (error)=>[
                id,
                error
            ]))));
};

});



parcelRegister("gCJaT", function(module, exports) {

$parcel$export(module.exports, "dashboardEditRoute", () => $28f71741a95efd1f$export$b6e00d2cd7369fbd);
const $28f71741a95efd1f$export$b6e00d2cd7369fbd = {
    name: 'dashboard-edit',
    path: '/jira/dashboards/:dashboardId(\\d+)/edit',
    query: [
        'maximized?'
    ],
    exact: true
};

});

parcelRegister("irlpm", function(module, exports) {

$parcel$export(module.exports, "dashboardEditEntryPoint", () => $c73267a50536209c$export$eb39305ec6fcebf1);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $c73267a50536209c$export$eb39305ec6fcebf1 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("lKV68")), {
        moduleId: "4d5a5b34"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("lKV68", function(module, exports) {

let $fd6a2f5584ddebf2$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $fd6a2f5584ddebf2$var$load("ffQaD"),
    $fd6a2f5584ddebf2$var$load("kvRbA"),
    $fd6a2f5584ddebf2$var$load("5yNG7")
]).then(()=>parcelRequire('7AfLj'));

});


parcelRegister("fT58V", function(module, exports) {

$parcel$export(module.exports, "nav4SidebarContentCoreEntryPoint", () => $b83318e39ccb6f4a$export$c5a39ebd1638fa7);

var $2OeZv = parcelRequire("2OeZv");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $b83318e39ccb6f4a$export$c5a39ebd1638fa7 = (0, $fEDBv.createEntryPoint)({
    // sidebar is critical to rendering the initial view of a page
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>Promise.resolve((parcelRequire("gyZtn"))).then(({ SidebarContentForEntryPoint: SidebarContentForEntryPoint })=>SidebarContentForEntryPoint), {
        moduleId: "4c2c284d"
    }),
    // Result matches the generics of the async component's EntryPointProps
    // except for TComponentProps which is derived from `root`
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getPreloadProps (params) {
        const { context: context, tenantContext: tenantContext, entryPoints: entryPoints = {}, isAppsExpanded: isAppsExpanded, isFiltersExpanded: isFiltersExpanded, isPlansExpanded: isPlansExpanded, isProjectsExpanded: isProjectsExpanded, isOperationsExpanded: isOperationsExpanded, isOverviewsExpanded: isOverviewsExpanded } = params;
        // The two parameters have been injected by the theme setter, and should
        // not be here. Setting them naively just to be able to use the sidebar entryPoint again.
        const projectAri = '';
        const projectKey = context.match.params.projectKey || '';
        return {
            // Queries your async component uses
            queries: {
                nav4SidebarContentCore: {
                    // generated .graphql
                    parameters: (0, $2OeZv.default),
                    // variables for your query
                    variables: {
                        cloudId: tenantContext.cloudId,
                        isAppsExpanded: isAppsExpanded,
                        isFiltersExpanded: isFiltersExpanded,
                        isPlansExpanded: isPlansExpanded,
                        isProjectsExpanded: isProjectsExpanded,
                        isOperationsExpanded: isOperationsExpanded,
                        isOverviewsExpanded: isOverviewsExpanded,
                        projectAri: projectAri,
                        projectKey: projectKey,
                        entityAriProjects: `ari:cloud:jira:${tenantContext.cloudId}:navigation-settings/activation/${tenantContext.activationId}/projects`,
                        ownerAri: tenantContext.atlassianAccountId && `ari:cloud:identity::user/${tenantContext.atlassianAccountId}`
                    },
                    // fetch options
                    options: {
                        fetchPolicy: 'store-and-network'
                    }
                }
            },
            entryPoints: entryPoints
        };
    }
});

});

parcelRegister("ernoj", function(module, exports) {

$parcel$export(module.exports, "dashboardResources", () => $92d1f2722b27ff5d$export$50d95db618f58349);
$parcel$export(module.exports, "LazyDashboardView", () => $92d1f2722b27ff5d$export$c3bf98706b62de2b);
$parcel$export(module.exports, "LazyDashboardViewEmbed", () => $92d1f2722b27ff5d$export$94d85118d282a15);
$parcel$export(module.exports, "LazySystemDashboardEdit", () => $92d1f2722b27ff5d$export$c8d59d34c3e8f345);
$parcel$export(module.exports, "DashboardViewEmbedPage", () => $92d1f2722b27ff5d$export$86d9f777f9d4e312);
$parcel$export(module.exports, "SystemDashboardEditPage", () => $92d1f2722b27ff5d$export$dcd19a888f8c85c);

var $5uXOq = parcelRequire("5uXOq");

var $gh1hi = parcelRequire("gh1hi");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");
const $92d1f2722b27ff5d$export$50d95db618f58349 = ()=>[
        (0, $gh1hi.dashboardConfigAndWRMResource),
        (0, $gh1hi.dashboardAMDModulesResource),
        (0, $gh1hi.dashboardReactGadgetsResource),
        (0, $gh1hi.dashboardForgeResource)
    ];

const $92d1f2722b27ff5d$export$c3bf98706b62de2b = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("4C60q"))), {
    moduleId: "./src/packages/global-pages/dashboard/view/src/index.tsx"
});

const $92d1f2722b27ff5d$export$94d85118d282a15 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("4KQT7"))), {
    moduleId: "./src/packages/global-pages/dashboard/view-embed/src/index.tsx"
});

const $92d1f2722b27ff5d$export$c8d59d34c3e8f345 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("bBdB0"))), {
    moduleId: "./src/packages/spa-apps/dashboard/system-dashboard-edit/src/index.tsx"
});
const $92d1f2722b27ff5d$export$86d9f777f9d4e312 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $92d1f2722b27ff5d$export$94d85118d282a15,
        pageId: "dashboard",
        shouldShowSpinner: true
    });
const $92d1f2722b27ff5d$export$dcd19a888f8c85c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $92d1f2722b27ff5d$export$c8d59d34c3e8f345,
        pageId: "system-dashboard-edit",
        shouldShowSpinner: false
    });

});
parcelRegister("4C60q", function(module, exports) {

let $35bf5ea926444dc5$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $35bf5ea926444dc5$var$load("ffQaD"),
    $35bf5ea926444dc5$var$load("kvRbA"),
    $35bf5ea926444dc5$var$load("iv5Bz")
]).then(()=>parcelRequire('iqENN'));

});

parcelRegister("4KQT7", function(module, exports) {

let $37647bc60766f0a1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $37647bc60766f0a1$var$load("eCOxy").then(()=>parcelRequire('9aF4A'));

});

parcelRegister("bBdB0", function(module, exports) {

let $871db24493e19a8f$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $871db24493e19a8f$var$load("ffQaD"),
    $871db24493e19a8f$var$load("kvRbA"),
    $871db24493e19a8f$var$load("47Wf2")
]).then(()=>parcelRequire('3VYlm'));

});



parcelRegister("56moC", function(module, exports) {

$parcel$export(module.exports, "dashboardRouteEntry", () => $1603466baea9815f$export$9fbbaafb58999ac3);

var $ffza4 = parcelRequire("ffza4");


var $e2ctp = parcelRequire("e2ctp");

var $gmpjq = parcelRequire("gmpjq");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $fP8Ju = parcelRequire("fP8Ju");

var $4n0Oi = parcelRequire("4n0Oi");

var $ernoj = parcelRequire("ernoj");
const $1603466baea9815f$export$9fbbaafb58999ac3 = (0, $7NszV.createEntry)((0, $fP8Ju.dashboardRoute), ()=>({
        group: 'dashboard',
        component: (0, $4n0Oi.DashboardRedirect),
        layout: (0, $gmpjq.homepageLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $ernoj.dashboardResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ernoj.LazyDashboardView)
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
        },
        isRedirect: true,
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("gmpjq", function(module, exports) {

$parcel$export(module.exports, "homepageLayout", () => $226ab3e64821f6b2$export$5b7fb151d60504c);

var $iqZds = parcelRequire("iqZds");

var $2BrOV = parcelRequire("2BrOV");

var $aPfsS = parcelRequire("aPfsS");
const $226ab3e64821f6b2$export$5b7fb151d60504c = (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), {
    // both of the components are wrapped with componentWithCondition
    globalComponents: [
        (0, $iqZds.AsyncTransitionHomeRenderer),
        (0, $iqZds.AsyncWelcomeModalRenderer)
    ]
});

});
parcelRegister("iqZds", function(module, exports) {

$parcel$export(module.exports, "AsyncTransitionHomeRenderer", () => $d1122e3218429f7d$export$cb38f5a820347580);
$parcel$export(module.exports, "AsyncWelcomeModalRenderer", () => $d1122e3218429f7d$export$9cda67d6c86d7b98);
$parcel$export(module.exports, "eocChangeboardingLayout", () => $d1122e3218429f7d$export$b8fa7ac7019001bb);

var $aPfsS = parcelRequire("aPfsS");

var $kxZPA = parcelRequire("kxZPA");

var $cSD7y = parcelRequire("cSD7y");

const $d1122e3218429f7d$export$cb38f5a820347580 = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("hUE2l")).then((module)=>module.TransitionHomeRenderer), {
    ssr: false,
    moduleId: "./src/packages/eoc/changeboarding/src/ui/transition-home/main.tsx"
});
$d1122e3218429f7d$export$cb38f5a820347580.displayName = 'AsyncTransitionHomeRenderer';

const $d1122e3218429f7d$export$9cda67d6c86d7b98 = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("kyxXX")).then((module)=>module.WelcomeModalRenderer), {
    ssr: false,
    moduleId: "./src/packages/eoc/changeboarding/src/ui/wizard/main.tsx"
});
$d1122e3218429f7d$export$9cda67d6c86d7b98.displayName = 'AsyncWelcomeModalRenderer';

const $d1122e3218429f7d$export$913f5a2340406083 = (0, $cSD7y.componentWithFG)('operations-migration-hub-jira', // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("civVw")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/ops-settings-layout/src/ui/right-sidebars/index.tsx"
}), ()=>null);
$d1122e3218429f7d$export$913f5a2340406083.displayName = 'MigrationHubRightSidebar';

const $d1122e3218429f7d$export$6d7715b12d3ad17b = (0, $cSD7y.componentWithFG)('operations-migration-hub-jira', // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("dgrxE")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/ops-settings-layout/src/ui/onboarding/index.tsx"
}), ()=>null);
$d1122e3218429f7d$export$6d7715b12d3ad17b.displayName = 'MigrationHubOnboarding';
const $d1122e3218429f7d$export$b8fa7ac7019001bb = (0, $aPfsS.createLayout)({
    get globalComponents () {
        return [
            $d1122e3218429f7d$export$cb38f5a820347580,
            $d1122e3218429f7d$export$9cda67d6c86d7b98,
            $d1122e3218429f7d$export$6d7715b12d3ad17b
        ];
    },
    rightSidebars: [
        $d1122e3218429f7d$export$913f5a2340406083
    ]
});

});
parcelRegister("hUE2l", function(module, exports) {

let $d0a6b91d1557d0c5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d0a6b91d1557d0c5$var$load("blXNs").then(()=>parcelRequire('dsKht'));

});

parcelRegister("kyxXX", function(module, exports) {

let $ef715495206cdb29$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ef715495206cdb29$var$load("iCaFG").then(()=>parcelRequire('cKcai'));

});

parcelRegister("civVw", function(module, exports) {

let $8f3fee7c36a0f8c3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8f3fee7c36a0f8c3$var$load("1tohs").then(()=>parcelRequire('eb0cf'));

});

parcelRegister("dgrxE", function(module, exports) {

let $9a8222329de6024a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9a8222329de6024a$var$load("hZQ0p").then(()=>parcelRequire('kdZEd'));

});



parcelRegister("fP8Ju", function(module, exports) {

$parcel$export(module.exports, "dashboardRoute", () => $91c4527accb41ff2$export$3bf0ecb39349b6ef);
const $91c4527accb41ff2$export$3bf0ecb39349b6ef = {
    name: 'dashboard',
    path: '/secure/Dashboard.jspa'
};

});

parcelRegister("4n0Oi", function(module, exports) {

$parcel$export(module.exports, "DashboardRedirect", () => $55d04275d2bcfadf$export$da833ddcffcc38ba);

var $5uXOq = parcelRequire("5uXOq");

var $6jY6G = parcelRequire("6jY6G");

var $ds5qV = parcelRequire("ds5qV");

var $9VXkC = parcelRequire("9VXkC");
var $doZTA = parcelRequire("doZTA");
const $55d04275d2bcfadf$export$da833ddcffcc38ba = ()=>{
    const [{ query: query, location: { hash: hash } }] = (0, $doZTA.useRouter)();
    const { path: path } = (0, $6jY6G.useRouteByName)('dashboard-view') ?? {};
    if (path == null) throw new Error('Dashboard view route not found');
    const { selectPageId: id } = query;
    const idParam = /^\d+$/.test(id) ? id : 'last-visited';
    const generatedPath = (0, $9VXkC.generatePath)(path, {
        dashboardId: idParam
    });
    const maximizedId = hash.match(/.*\/(?<id>\d+)/)?.groups?.id ?? null;
    const pathWithQuery = maximizedId !== null ? `${generatedPath}?maximized=${maximizedId}` : generatedPath;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: pathWithQuery,
        persistSearchParams: false
    });
};

});


parcelRegister("hfMX7", function(module, exports) {

$parcel$export(module.exports, "dashboardViewEmbedRouteEntry", () => $67a8397fa114200d$export$73a377380ff671af);

var $Xtn30 = parcelRequire("Xtn30");


var $e2ctp = parcelRequire("e2ctp");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $2Ql51 = parcelRequire("2Ql51");

var $joJjt = parcelRequire("joJjt");

var $ernoj = parcelRequire("ernoj");
const $67a8397fa114200d$export$73a377380ff671af = (0, $7NszV.createEntry)((0, $joJjt.dashboardViewEmbedRoute), ()=>({
        group: 'dashboard',
        component: (0, $ernoj.DashboardViewEmbedPage),
        layout: (0, $aPfsS.createLayout)({
            globalComponents: [
                (0, $Xtn30.DashboardBackgroundScripts)
            ],
            isChromeless: true
        }),
        resources: [
            (0, $2Ql51.themePreferenceResource),
            ...(0, $ernoj.dashboardResources)()
        ],
        forPaint: [
            (0, $ernoj.LazyDashboardViewEmbed)
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
        },
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("joJjt", function(module, exports) {

$parcel$export(module.exports, "dashboardViewEmbedRoute", () => $47f4f3f379b59c3e$export$258b5e3f294617d2);
const $47f4f3f379b59c3e$export$258b5e3f294617d2 = {
    name: 'dashboard-view-embed',
    path: '/jira/dashboards/:dashboardId(\\d+)/embed',
    query: [],
    exact: true
};

});


parcelRegister("1zhx7", function(module, exports) {

$parcel$export(module.exports, "dashboardViewRouteEntry", () => $c891244b3388b2f7$export$18226b6422149926);

var $j6woB = parcelRequire("j6woB");


var $e2ctp = parcelRequire("e2ctp");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $3RJkv = parcelRequire("3RJkv");

var $5gOBf = parcelRequire("5gOBf");

var $7NAzY = parcelRequire("7NAzY");

var $lkFvK = parcelRequire("lkFvK");

var $fT58V = parcelRequire("fT58V");

var $h4rc7 = parcelRequire("h4rc7");

var $ernoj = parcelRequire("ernoj");
const $c891244b3388b2f7$export$18226b6422149926 = (0, $7NszV.createEntry)((0, $5gOBf.dashboardViewRoute), ()=>({
        group: 'dashboard',
        entryPoint: ()=>$c891244b3388b2f7$var$pageEntryPoint,
        layout: (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), (0, $j6woB.dashboardBackgroundScriptsLayout)),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).DASHBOARDS,
            sidebarId: (0, $lmyls.SIDEBAR_ID).CONTENT
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $ernoj.dashboardResources)()
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
        },
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY),
        ufoName: 'dashboard'
    }));
const $c891244b3388b2f7$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7NAzY.dashboardViewEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).DASHBOARDS,
    leftSidebar: {
        sidebar: (0, $fT58V.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            dashboards: {
                entryPoint: (0, $h4rc7.nav4DashboardsContentEntryPoint)
            }
        }
    }
});

});
parcelRegister("5gOBf", function(module, exports) {

$parcel$export(module.exports, "dashboardViewRoute", () => $1aac2fbaf8a5979b$export$24f1b2ff97b9d3e6);
const $1aac2fbaf8a5979b$export$24f1b2ff97b9d3e6 = {
    name: 'dashboard-view',
    path: '/jira/dashboards/:dashboardId(\\d+|last-visited)',
    query: [
        'maximized?'
    ],
    exact: true
};

});

parcelRegister("7NAzY", function(module, exports) {

$parcel$export(module.exports, "dashboardViewEntryPoint", () => $eb6de38ddcb43951$export$acd33fbfe610d0e6);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $eb6de38ddcb43951$export$acd33fbfe610d0e6 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("4C60q")), {
        moduleId: "2821e152"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});


parcelRegister("dxMNj", function(module, exports) {

$parcel$export(module.exports, "dashboardWallboardRouteEntry", () => $ae18a94b5423e69e$export$6009dd8e88f1a7de);

var $Xtn30 = parcelRequire("Xtn30");


var $e2ctp = parcelRequire("e2ctp");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $2Ql51 = parcelRequire("2Ql51");

var $TJQd9 = parcelRequire("TJQd9");

var $lkFvK = parcelRequire("lkFvK");

var $8RtQf = parcelRequire("8RtQf");

var $ernoj = parcelRequire("ernoj");
const $ae18a94b5423e69e$export$6009dd8e88f1a7de = (0, $7NszV.createEntry)((0, $TJQd9.dashboardWallboardRoute), ()=>({
        group: 'dashboard',
        entryPoint: ()=>$ae18a94b5423e69e$var$dashboardWallboardPageEntryPoint,
        layout: (0, $aPfsS.createLayout)({
            globalComponents: [
                (0, $Xtn30.DashboardBackgroundScripts)
            ],
            // we don't want nav bar and right panel etc to appear in wallboard, so we use chromeless mode
            isChromeless: true
        }),
        resources: [
            (0, $2Ql51.themePreferenceResource),
            ...(0, $ernoj.dashboardResources)()
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
        },
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));
const $ae18a94b5423e69e$var$dashboardWallboardPageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $8RtQf.dashboardWallboardEntryPoint)
});

});
parcelRegister("TJQd9", function(module, exports) {

$parcel$export(module.exports, "dashboardWallboardRoute", () => $59e2472cc6b14119$export$eaa33c953ab9ca63);
const $59e2472cc6b14119$export$eaa33c953ab9ca63 = {
    name: 'dashboard-wallboard',
    path: '/jira/dashboards/wallboard',
    query: [
        'dashboardId',
        'cyclePeriod?',
        'transitionFx?',
        'random?'
    ],
    exact: true
};

});

parcelRegister("8RtQf", function(module, exports) {

$parcel$export(module.exports, "dashboardWallboardEntryPoint", () => $a0f9d35bbcc604c1$export$99f21964c00b61ef);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $a0f9d35bbcc604c1$export$99f21964c00b61ef = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("4K6Jh")), {
        moduleId: "b10917db"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("4K6Jh", function(module, exports) {

let $3740ada07419c85c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3740ada07419c85c$var$load("jrM9n").then(()=>parcelRequire('7ykDM'));

});



parcelRegister("eTL4x", function(module, exports) {

$parcel$export(module.exports, "selectedDashboardRouteEntry", () => $4fedf6a5f46c9101$export$ac09a8d3ecbafc5);

var $ffza4 = parcelRequire("ffza4");


var $e2ctp = parcelRequire("e2ctp");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $a1i1S = parcelRequire("a1i1S");

var $4n0Oi = parcelRequire("4n0Oi");

var $ernoj = parcelRequire("ernoj");
const $4fedf6a5f46c9101$export$ac09a8d3ecbafc5 = (0, $7NszV.createEntry)((0, $a1i1S.selectedDashboardRoute), ()=>({
        group: 'dashboard',
        component: (0, $4n0Oi.DashboardRedirect),
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).DASHBOARDS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $ernoj.dashboardResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ernoj.LazyDashboardView)
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
        },
        isRedirect: true,
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("a1i1S", function(module, exports) {

$parcel$export(module.exports, "selectedDashboardRoute", () => $f6e234b8f82fcbbd$export$b32070ee9554c3fb);
const $f6e234b8f82fcbbd$export$b32070ee9554c3fb = {
    name: 'dashboard-selected',
    path: '/secure/Dashboard.jspa',
    query: [
        'selectPageId'
    ]
};

});


parcelRegister("3av4N", function(module, exports) {

$parcel$export(module.exports, "systemDashboardEditRouteEntry", () => $29daafdf917937bc$export$15f76f1b0d2d671);

var $ffza4 = parcelRequire("ffza4");

var $j6woB = parcelRequire("j6woB");

var $e2ctp = parcelRequire("e2ctp");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $gh1hi = parcelRequire("gh1hi");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $3Zw20 = parcelRequire("3Zw20");

var $ernoj = parcelRequire("ernoj");
const $29daafdf917937bc$export$15f76f1b0d2d671 = (0, $7NszV.createEntry)((0, $3Zw20.systemDashboardEditRoute), ()=>({
        group: 'dashboard',
        component: (0, $ernoj.SystemDashboardEditPage),
        layout: (0, $aPfsS.composeLayouts)((0, $ibkIl.globalSettingsLayout), (0, $j6woB.dashboardBackgroundScriptsLayout)),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            // IMPORTANT - SSR requires wrm resource must come first
            ...(0, $ernoj.dashboardResources)(),
            (0, $gh1hi.gadgetDirectoryResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ernoj.LazySystemDashboardEdit)
        ],
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("3Zw20", function(module, exports) {

$parcel$export(module.exports, "systemDashboardEditRoute", () => $81fa712f0fcff9b5$export$7367fb465296c7dd);
const $81fa712f0fcff9b5$export$7367fb465296c7dd = {
    name: 'system-dashboard-edit',
    path: '/secure/admin/EditDefaultDashboard(!default)?.jspa',
    query: [
        'maximized?'
    ]
};

});


parcelRegister("hwgIz", function(module, exports) {

$parcel$export(module.exports, "devopsConnectedProjectRouteEntry", () => $b6b724158556afe3$export$ae258fb8ec2c1f86);

var $ffza4 = parcelRequire("ffza4");

var $6e4Kt = parcelRequire("6e4Kt");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $cK8ht = parcelRequire("cK8ht");

var $6IcGP = parcelRequire("6IcGP");
const $b6b724158556afe3$export$ae258fb8ec2c1f86 = (0, $7NszV.createEntry)((0, $cK8ht.devopsConnectedProjectRoute), ()=>({
        group: 'devops',
        ufoName: 'devops.connected-project',
        component: (0, $6IcGP.default),
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6IcGP.LazyDevopsConnectedProject)
        ]
    }));

});
parcelRegister("cK8ht", function(module, exports) {

$parcel$export(module.exports, "devopsConnectedProjectRoute", () => $52511ff99217f467$export$91257312631802bc);
const $52511ff99217f467$export$91257312631802bc = {
    name: 'devops-connected-project',
    path: '/jira/devops/connected-project'
};

});

parcelRegister("6IcGP", function(module, exports) {

$parcel$export(module.exports, "LazyDevopsConnectedProject", () => $31d281e7968db385$export$dcd3d20b0038b35c);
$parcel$export(module.exports, "default", () => $31d281e7968db385$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $31d281e7968db385$export$dcd3d20b0038b35c = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("1ezgG"))), {
    moduleId: "./src/packages/spa-apps/devops-connected-project/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$31d281e7968db385$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $31d281e7968db385$export$dcd3d20b0038b35c,
        pageId: "devops-connected-project",
        shouldShowSpinner: true
    });

});
parcelRegister("1ezgG", function(module, exports) {

let $0e6274c5f01ce0d0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0e6274c5f01ce0d0$var$load("cVZIB").then(()=>parcelRequire('kGKHk'));

});



parcelRegister("3ss0y", function(module, exports) {

$parcel$export(module.exports, "boardsDirectoryRedirectRouteEntry", () => $819db157557bdd41$export$2a34d21ecf479c40);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $bPjHb = parcelRequire("bPjHb");

var $3RJkv = parcelRequire("3RJkv");

var $6tsdD = parcelRequire("6tsdD");

var $ds5qV = parcelRequire("ds5qV");

var $cFtGt = parcelRequire("cFtGt");

var $6Ja6c = parcelRequire("6Ja6c");
const $819db157557bdd41$var$BoardsDirectoryRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: "/jira/boards"
    });
const $819db157557bdd41$export$2a34d21ecf479c40 = (0, $7NszV.createEntry)((0, $6tsdD.boardsDirectoryRedirectRoute), ()=>({
        group: 'directories',
        component: $819db157557bdd41$var$BoardsDirectoryRedirect,
        skeleton: (0, $cFtGt.BoardsDirectorySkeleton),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bPjHb.boardsDirectoryResource)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6Ja6c.LazyBoardsDirectory)
        ],
        isRedirect: true
    }));

});
parcelRegister("bPjHb", function(module, exports) {

$parcel$export(module.exports, "boardsDirectoryResource", () => $817f387e86427323$export$2646f173fa2c14f2);

var $kbVA4 = parcelRequire("kbVA4");

var $2M1hQ = parcelRequire("2M1hQ");


const $817f387e86427323$export$2646f173fa2c14f2 = (0, $2M1hQ.createResource)({
    type: (0, $ee6731a28d0b2341$export$87526c4bd9c78abc),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("dO46Z")),
    maxAge: (0, $kbVA4.MIN_MAX_AGE)
});

});
const $ee6731a28d0b2341$export$87526c4bd9c78abc = 'BOARDS_DIRECTORY';

parcelRegister("dO46Z", function(module, exports) {

let $a0d3225d41019c94$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a0d3225d41019c94$var$load("7H3O2").then(()=>parcelRequire('goVIR'));

});


parcelRegister("6tsdD", function(module, exports) {

$parcel$export(module.exports, "boardsDirectoryRedirectRoute", () => $de45f7ff4b8bd3d7$export$a4fba1ebd6ba91ee);
const $de45f7ff4b8bd3d7$export$a4fba1ebd6ba91ee = {
    name: 'boards-directory-redirect',
    path: '/secure/ManageRapidViews.jspa'
};

});

parcelRegister("cFtGt", function(module, exports) {

$parcel$export(module.exports, "BoardsDirectorySkeleton", () => $4855316d4f3a3ac5$export$8194d6e87709f042);
$parcel$export(module.exports, "DashboardsDirectorySkeleton", () => $4855316d4f3a3ac5$export$75ef2bfed3801fb1);
$parcel$export(module.exports, "FiltersDirectorySkeleton", () => $4855316d4f3a3ac5$export$e76f94817327da1);
$parcel$export(module.exports, "ProjectsDirectorySkeleton", () => $4855316d4f3a3ac5$export$d94befb0e231760c);
$parcel$export(module.exports, "PlansDirectorySkeleton", () => $4855316d4f3a3ac5$export$6cd26a09efd6d158);

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $1UbEn = parcelRequire("1UbEn");

var $gd6BN = parcelRequire("gd6BN");

var $eKB9J = parcelRequire("eKB9J");

var $lnW2o = parcelRequire("lnW2o");
const $4855316d4f3a3ac5$export$8194d6e87709f042 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1UbEn)))
    });
const $4855316d4f3a3ac5$export$75ef2bfed3801fb1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gd6BN)))
    });
const $4855316d4f3a3ac5$export$e76f94817327da1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eKB9J)))
    });
const $4855316d4f3a3ac5$export$d94befb0e231760c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lnW2o)))
    });
const $4855316d4f3a3ac5$export$6cd26a09efd6d158 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lnW2o)))
    });

});
parcelRegister("1UbEn", function(module, exports) {
module.exports = new URL("boards-directory-app-skeleton.tpl.e4de30a4.svg", import.meta.url).toString();

});

parcelRegister("gd6BN", function(module, exports) {
module.exports = new URL("dashboards-directory-app-skeleton.tpl.eb730072.svg", import.meta.url).toString();

});

parcelRegister("eKB9J", function(module, exports) {
module.exports = new URL("filters-directory-app-skeleton.tpl.6583ea61.svg", import.meta.url).toString();

});

parcelRegister("lnW2o", function(module, exports) {
module.exports = new URL("projects-directory-app-skeleton.tpl.a21368f6.svg", import.meta.url).toString();

});


parcelRegister("6Ja6c", function(module, exports) {

$parcel$export(module.exports, "LazyBoardsDirectory", () => $63ac430661b12a63$export$2826049ae45f4cd);

var $7yO8g = parcelRequire("7yO8g");

var $kxZPA = parcelRequire("kxZPA");

const $63ac430661b12a63$export$2826049ae45f4cd = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("2v2yL"))), {
    moduleId: "./src/packages/spa-apps/directories/boards/src/index.tsx"
});

});
parcelRegister("2v2yL", function(module, exports) {

let $1d2076511bf45ba6$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1d2076511bf45ba6$var$load("ffQaD"),
    $1d2076511bf45ba6$var$load("kvRbA"),
    $1d2076511bf45ba6$var$load("9PdWC")
]).then(()=>parcelRequire('3geiu'));

});



parcelRegister("bNtXI", function(module, exports) {

$parcel$export(module.exports, "boardsDirectoryRouteEntry", () => $bb811a13740c7cf1$export$e78b34c999194638);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $bPjHb = parcelRequire("bPjHb");

var $3RJkv = parcelRequire("3RJkv");

var $jP33S = parcelRequire("jP33S");

var $cFtGt = parcelRequire("cFtGt");

var $5j7Th = parcelRequire("5j7Th");

var $6Ja6c = parcelRequire("6Ja6c");
const $bb811a13740c7cf1$var$BoardsDirectoryComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $6Ja6c.LazyBoardsDirectory),
        pageId: "boards-directory",
        shouldShowSpinner: false
    });
const $bb811a13740c7cf1$export$e78b34c999194638 = (0, $7NszV.createEntry)((0, $jP33S.boardsDirectoryRoute), ()=>({
        group: 'directories',
        component: $bb811a13740c7cf1$var$BoardsDirectoryComponent,
        skeleton: (0, $cFtGt.BoardsDirectorySkeleton),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bPjHb.boardsDirectoryResource)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6Ja6c.LazyBoardsDirectory)
        ]
    }));

});
parcelRegister("jP33S", function(module, exports) {

$parcel$export(module.exports, "boardsDirectoryRoute", () => $3c2c0ea0e55873e8$export$f0fc6f4e8be87e85);
const $3c2c0ea0e55873e8$export$f0fc6f4e8be87e85 = {
    name: 'boards-directory',
    path: '/jira/boards'
};

});


parcelRegister("aNsRz", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryRedirectRouteEntry", () => $3848740eee1bab7b$export$8dae8091f8e43b97);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $4yCf0 = parcelRequire("4yCf0");

var $3RJkv = parcelRequire("3RJkv");

var $2XHRw = parcelRequire("2XHRw");

var $ds5qV = parcelRequire("ds5qV");

var $cFtGt = parcelRequire("cFtGt");

var $aZoVa = parcelRequire("aZoVa");
const $3848740eee1bab7b$var$DashboardsDirectoryRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: "/jira/dashboards"
    });
const $3848740eee1bab7b$export$8dae8091f8e43b97 = (0, $7NszV.createEntry)((0, $2XHRw.dashboardsDirectoryRedirectRoute), ()=>({
        group: 'directories',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $4yCf0.dashboardsDirectoryResource)
        ],
        component: !false ? $3848740eee1bab7b$var$DashboardsDirectoryRedirect : (0, $aZoVa.DashboardsDirectoryComponent),
        skeleton: (0, $cFtGt.DashboardsDirectorySkeleton),
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).DASHBOARDS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aZoVa.LazyDashboardsDirectory)
        ],
        isRedirect: true
    }));

});
parcelRegister("4yCf0", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryResource", () => $c9ec3cc3b6c0608d$export$1cf6c7815471c2a2);

var $kbVA4 = parcelRequire("kbVA4");

var $2M1hQ = parcelRequire("2M1hQ");
const $c9ec3cc3b6c0608d$var$RESOURCE_TYPE_DASHBOARDS_DIRECTORY = 'DASHBOARDS_DIRECTORY';

const $c9ec3cc3b6c0608d$export$1cf6c7815471c2a2 = (0, $2M1hQ.createResource)({
    type: $c9ec3cc3b6c0608d$var$RESOURCE_TYPE_DASHBOARDS_DIRECTORY,
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("1bD1s")),
    maxAge: (0, $kbVA4.MIN_MAX_AGE)
});

});
parcelRegister("1bD1s", function(module, exports) {

let $0dd51695df5cd3c5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0dd51695df5cd3c5$var$load("dxnac").then(()=>parcelRequire('ciD6c'));

});


parcelRegister("2XHRw", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryRedirectRoute", () => $55fec75e9850e3c3$export$b96f6fb3c35a6fe5);
const $55fec75e9850e3c3$export$b96f6fb3c35a6fe5 = {
    name: 'dashboards-directory-secure',
    path: '/secure/ConfigurePortalPages(!default.jspa|.jspa)'
};

});

parcelRegister("aZoVa", function(module, exports) {

$parcel$export(module.exports, "LazyDashboardsDirectory", () => $cd7e3d13d091ccad$export$f2f3fd22cd37e121);
$parcel$export(module.exports, "DashboardsDirectoryComponent", () => $cd7e3d13d091ccad$export$1cc6cc01050e1215);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $cd7e3d13d091ccad$export$f2f3fd22cd37e121 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("iB9lT"))), {
    moduleId: "./src/packages/spa-apps/directories/dashboards/src/index.tsx"
});
const $cd7e3d13d091ccad$export$1cc6cc01050e1215 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cd7e3d13d091ccad$export$f2f3fd22cd37e121,
        pageId: "dashboards-directory",
        shouldShowSpinner: false
    });

});
parcelRegister("iB9lT", function(module, exports) {

let $d8a2efd3b9af836d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d8a2efd3b9af836d$var$load("ffQaD"),
    $d8a2efd3b9af836d$var$load("kvRbA"),
    $d8a2efd3b9af836d$var$load("l4XNP")
]).then(()=>parcelRequire('76rrf'));

});



parcelRegister("cmvi5", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryRouteEntry", () => $bc6135fca4882261$export$748e329bd0c282a);

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $4yCf0 = parcelRequire("4yCf0");

var $3RJkv = parcelRequire("3RJkv");

var $dDmlh = parcelRequire("dDmlh");

var $cFtGt = parcelRequire("cFtGt");

var $lkFvK = parcelRequire("lkFvK");

var $fT58V = parcelRequire("fT58V");

var $h4rc7 = parcelRequire("h4rc7");

var $keYV7 = parcelRequire("keYV7");
const $bc6135fca4882261$export$748e329bd0c282a = (0, $7NszV.createEntry)((0, $dDmlh.dashboardsDirectoryRoute), ()=>({
        group: 'directories',
        entryPoint: ()=>$bc6135fca4882261$var$pageEntryPoint,
        skeleton: (0, $cFtGt.DashboardsDirectorySkeleton),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $4yCf0.dashboardsDirectoryResource)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).DASHBOARDS,
            sidebarId: (0, $lmyls.SIDEBAR_ID).CONTENT
        }
    }));
// Page entrypoint, referred to above...
const $bc6135fca4882261$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $keYV7.dashboardDirectoryEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).DASHBOARDS,
    leftSidebar: {
        sidebar: (0, $fT58V.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            dashboards: {
                entryPoint: (0, $h4rc7.nav4DashboardsContentEntryPoint)
            }
        }
    }
});

});
parcelRegister("keYV7", function(module, exports) {

$parcel$export(module.exports, "dashboardDirectoryEntryPoint", () => $483e18a450676181$export$3325d832741ebeb3);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $483e18a450676181$export$3325d832741ebeb3 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("iB9lT")), {
        moduleId: "933882c8"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});


parcelRegister("8fgeg", function(module, exports) {

$parcel$export(module.exports, "filtersDirectoryRedirectRouteEntry", () => $03e59a293d347a10$export$41fb3f2a3e68c7c3);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $dRl24 = parcelRequire("dRl24");

var $3RJkv = parcelRequire("3RJkv");

var $hCC3D = parcelRequire("hCC3D");

var $cFtGt = parcelRequire("cFtGt");

var $7RZwy = parcelRequire("7RZwy");
const $03e59a293d347a10$export$41fb3f2a3e68c7c3 = (0, $7NszV.createEntry)((0, $hCC3D.filtersDirectoryRedirectRoute), ()=>({
        group: 'directories',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $dRl24.filtersDirectoryResource)
        ],
        component: !false ? (0, $7RZwy.FiltersDirectoryRedirect) : (0, $7RZwy.FiltersDirectoryComponent),
        skeleton: (0, $cFtGt.FiltersDirectorySkeleton),
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).FILTERS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7RZwy.LazyFiltersDirectory)
        ],
        isRedirect: true
    }));

});
parcelRegister("dRl24", function(module, exports) {

$parcel$export(module.exports, "filtersDirectoryResource", () => $8b127055fac893b8$export$53f99086c62225b6);

var $kbVA4 = parcelRequire("kbVA4");

var $2M1hQ = parcelRequire("2M1hQ");


const $8b127055fac893b8$export$53f99086c62225b6 = (0, $2M1hQ.createResource)({
    type: (0, $6d3ffd6df613c846$export$79e191bf6cb15284),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("gwwXN")),
    maxAge: (0, $kbVA4.MIN_MAX_AGE)
});

});
const $6d3ffd6df613c846$export$79e191bf6cb15284 = 'FILTERS_DIRECTORY';

parcelRegister("gwwXN", function(module, exports) {

let $c0793457758a80b3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c0793457758a80b3$var$load("bg0Y0").then(()=>parcelRequire('cK9UE'));

});


parcelRegister("hCC3D", function(module, exports) {

$parcel$export(module.exports, "filtersDirectoryRedirectRoute", () => $2881371d3e73fb66$export$f4f86e1ddc30a625);
const $2881371d3e73fb66$export$f4f86e1ddc30a625 = {
    name: 'filters-directory-redirect',
    path: '/ManageFilters.jspa'
};

});

parcelRegister("7RZwy", function(module, exports) {

$parcel$export(module.exports, "FiltersDirectoryRedirect", () => $37b0d6d8034450f5$export$c56e739d3bb1fe19);
$parcel$export(module.exports, "LazyFiltersDirectory", () => $37b0d6d8034450f5$export$cc133cd5c6f1b69d);
$parcel$export(module.exports, "FiltersDirectoryComponent", () => $37b0d6d8034450f5$export$e5d735e83dacb7c7);

var $5uXOq = parcelRequire("5uXOq");

var $ds5qV = parcelRequire("ds5qV");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");
const $37b0d6d8034450f5$export$c56e739d3bb1fe19 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: "/jira/filters"
    });

const $37b0d6d8034450f5$export$cc133cd5c6f1b69d = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("1lQ3O"))), {
    moduleId: "./src/packages/spa-apps/directories/filters/src/index.tsx"
});
const $37b0d6d8034450f5$export$e5d735e83dacb7c7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $37b0d6d8034450f5$export$cc133cd5c6f1b69d,
        pageId: "filters-directory",
        shouldShowSpinner: false
    });

});
parcelRegister("1lQ3O", function(module, exports) {

let $0fc022bf18d9971f$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0fc022bf18d9971f$var$load("kNFvF"),
    $0fc022bf18d9971f$var$load("76n7a"),
    $0fc022bf18d9971f$var$load("l253H"),
    $0fc022bf18d9971f$var$load("ffQaD"),
    $0fc022bf18d9971f$var$load("kvRbA"),
    $0fc022bf18d9971f$var$load("a0X6H")
]).then(()=>parcelRequire('3Zqmb'));

});



parcelRegister("f7gaE", function(module, exports) {

$parcel$export(module.exports, "filtersDirectoryRouteEntry", () => $3947322b61fcc480$export$ca77bc660994f51f);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $dRl24 = parcelRequire("dRl24");

var $3RJkv = parcelRequire("3RJkv");

var $b6S3k = parcelRequire("b6S3k");

var $cFtGt = parcelRequire("cFtGt");

var $7RZwy = parcelRequire("7RZwy");
const $3947322b61fcc480$export$ca77bc660994f51f = (0, $7NszV.createEntry)((0, $b6S3k.filtersDirectoryRoute), ()=>({
        group: 'directories',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $dRl24.filtersDirectoryResource)
        ],
        component: (0, $7RZwy.FiltersDirectoryComponent),
        skeleton: (0, $cFtGt.FiltersDirectorySkeleton),
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).FILTERS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7RZwy.LazyFiltersDirectory)
        ]
    }));

});

parcelRegister("pRrpu", function(module, exports) {

$parcel$export(module.exports, "manageProjectsDirectoryRouteEntry", () => $e28e6d3f170e3052$export$d5b1a46987369ee4);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $4jMkc = parcelRequire("4jMkc");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $fsqMg = parcelRequire("fsqMg");

var $cFtGt = parcelRequire("cFtGt");

var $5j7Th = parcelRequire("5j7Th");

var $fbnvY = parcelRequire("fbnvY");

var $fhRbA = parcelRequire("fhRbA");

var $jL5x9 = parcelRequire("jL5x9");
const $e28e6d3f170e3052$var$LazyAdminProjectsDirectory = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhRbA.LazyProjectsDirectory), {
        isAdminProjectDirectoryRoute: true
    });
const $e28e6d3f170e3052$var$ProjectsDirectoryManageComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e28e6d3f170e3052$var$LazyAdminProjectsDirectory,
        pageId: "projects-directory-manage-v3",
        shouldShowSpinner: false
    });
const $e28e6d3f170e3052$export$d5b1a46987369ee4 = (0, $7NszV.createEntry)((0, $fsqMg.manageProjectsDirectoryRoute), ()=>({
        group: 'directories',
        component: $e28e6d3f170e3052$var$ProjectsDirectoryManageComponent,
        skeleton: (0, $cFtGt.ProjectsDirectorySkeleton),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
            sidebar: (0, $4jMkc.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $fbnvY.adminProjectDirectoryResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fhRbA.LazyProjectsDirectory)
        ],
        ufoName: 'projects-directory-v3-manage',
        entryPoint () {
            return 0, $jL5x9.ProjectsDirectoryPageEntryPoint;
        }
    }));

});
parcelRegister("fsqMg", function(module, exports) {

$parcel$export(module.exports, "manageProjectsDirectoryRoute", () => $3dd7670289805d41$export$281a4490a0f8fb4c);
const $3dd7670289805d41$export$281a4490a0f8fb4c = {
    name: 'projects-directory-manage',
    path: '/jira/settings/projects/manage'
};

});

parcelRegister("fbnvY", function(module, exports) {

$parcel$export(module.exports, "adminProjectDirectoryResources", () => $9521a93df7bbe3a1$export$1b29db6307155621);

var $atU1t = parcelRequire("atU1t");

var $hW253 = parcelRequire("hW253");
const $9521a93df7bbe3a1$export$1b29db6307155621 = ()=>[
        (0, $atU1t.navigationSidebarGlobalResource),
        (0, $hW253.projectsDirectoryPageResource)
    ];

});
parcelRegister("hW253", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryPageResource", () => $4c805bc331263d5b$export$aabb201a7f7100c5);
/* eslint-disable jira/import-whitelist */ 
var $8Uumt = parcelRequire("8Uumt");

var $gkT9B = parcelRequire("gkT9B");

var $8pIiT = parcelRequire("8pIiT");

var $5yJb9 = parcelRequire("5yJb9");

var $kipqU = parcelRequire("kipqU");

var $ao2h1 = parcelRequire("ao2h1");

var $lVQ0r = parcelRequire("lVQ0r");

var $2M1hQ = parcelRequire("2M1hQ");

const $4c805bc331263d5b$export$aabb201a7f7100c5 = (0, $2M1hQ.createResource)({
    type: `${(0, $ao2h1.RELAY_RESOURCE_TYPE)}_${(0, $ce818d5819645fe8$export$2150caade62dc875)}`,
    getKey: ()=>'projects-directory-relay',
    // @ts-expect-error - might return null
    getData: async ({ query: query, route: route }, { tenantContext: tenantContext })=>{
        const { cloudId: cloudId, isAnonymous: isAnonymous } = tenantContext;
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should temporally disable anonymous SSR until
        // the underlying auth issues have been fixed. Duplo team will push the real fix later.
        if (false && isAnonymous) return null;
        const queryReference = (0, $8Uumt.loadQuery)((0, $5yJb9.default)(), (0, $lVQ0r.default), {
            cloudId: tenantContext.cloudId,
            filter: (0, $8pIiT.mapQueryToFilter)((0, $gkT9B.filterInitialState), {
                cloudId: cloudId,
                query: (0, $8pIiT.sanitizeLegacyQuery)(query),
                aliases: (0, $gkT9B.filterAliasMap)
            }),
            first: query?.page ? (0, $gkT9B.DEFAULT_LIMIT) * (parseInt(query.page, 10) || 1) : (0, $gkT9B.DEFAULT_LIMIT),
            last: (0, $gkT9B.DEFAULT_LIMIT),
            isAdminSettingsContext: route.name === 'projects-directory-manage',
            isAnonymous: isAnonymous
        }, {
            fetchPolicy: 'network-only'
        });
        if (false && queryReference.id != null) await (0, $kipqU.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    }
});

});
parcelRegister("gkT9B", function(module, exports) {

$parcel$export(module.exports, "TableColumns", () => $4e4ac97bc1b1894b$export$b0e68791ad9c52df);
$parcel$export(module.exports, "SortableColumns", () => $4e4ac97bc1b1894b$export$f9e740ef44a4c43a);
$parcel$export(module.exports, "FilterFields", () => $4e4ac97bc1b1894b$export$e38c2fbdcbc20613);
$parcel$export(module.exports, "filterAliasMap", () => $4e4ac97bc1b1894b$export$5bc0ad9873e5cd89);
$parcel$export(module.exports, "filterInitialState", () => $4e4ac97bc1b1894b$export$fcb7b3e474e67781);
$parcel$export(module.exports, "DEFAULT_LIMIT", () => $4e4ac97bc1b1894b$export$ebc5ec3267fbcf57);
$parcel$export(module.exports, "PROJECTS_DIRECTORY_EXPERIENCE", () => $4e4ac97bc1b1894b$export$7c1bd7128901e2c4);
$parcel$export(module.exports, "MANAGE_PROJECTS_DIRECTORY_EXPERIENCE", () => $4e4ac97bc1b1894b$export$72fb94bf1b8ec849);
// eslint-disable-next-line jira/import-whitelist

var $7OwSg = parcelRequire("7OwSg");
const $4e4ac97bc1b1894b$export$b0e68791ad9c52df = {
    Favourites: 'favourite',
    Key: 'key',
    Name: 'name',
    Type: 'type',
    Lead: 'lead',
    Category: 'category',
    LastIssueUpdate: 'last_issue_updated_time',
    Url: 'url',
    Action: 'actions'
};
const $4e4ac97bc1b1894b$export$f9e740ef44a4c43a = [
    $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Favourites,
    $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Key,
    $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Name,
    $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Lead,
    $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Category,
    $4e4ac97bc1b1894b$export$b0e68791ad9c52df.LastIssueUpdate
];
const $4e4ac97bc1b1894b$export$e38c2fbdcbc20613 = {
    Keyword: 'keyword',
    ProjectType: 'types',
    ProjectTypeLabel: 'ProjectTypeLabel',
    ProjectCategoryId: 'projectCategoryId',
    ProjectCategoryLabel: 'projectCategoryLabel',
    ...(0, $7OwSg.DefaultFilterFields)
};
const $4e4ac97bc1b1894b$export$5bc0ad9873e5cd89 = {
    contains: $4e4ac97bc1b1894b$export$e38c2fbdcbc20613.Keyword,
    selectedProjectType: $4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectType,
    selectedCategory: $4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectCategoryId
};
const $4e4ac97bc1b1894b$export$fcb7b3e474e67781 = {
    [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.Keyword]: '',
    [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectType]: '',
    [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectTypeLabel]: '',
    [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectCategoryId]: '',
    [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectCategoryLabel]: '',
    [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.SortOrder]: 'ASC',
    [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.SortKey]: $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Name,
    [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.Page]: '1'
};
const $4e4ac97bc1b1894b$export$ebc5ec3267fbcf57 = 25;
const $4e4ac97bc1b1894b$export$7c1bd7128901e2c4 = 'viewProjectsDirectoryV3';
const $4e4ac97bc1b1894b$export$72fb94bf1b8ec849 = 'viewManageProjectsDirectoryV3';

});
parcelRegister("7OwSg", function(module, exports) {

$parcel$export(module.exports, "DefaultFilterFields", () => $30cd11272c627f6b$export$7ecdd4b6ae40e139);
$parcel$export(module.exports, "createUseFilter", () => $30cd11272c627f6b$export$ef79d9c1dcb09f8f);

var $ebyGx = parcelRequire("ebyGx");

var $jcw0u = parcelRequire("jcw0u");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $30cd11272c627f6b$export$7ecdd4b6ae40e139 = {
    // sorting
    SortOrder: 'sortOrder',
    SortKey: 'sortKey',
    // pagination
    Page: 'page'
};
const $30cd11272c627f6b$export$ef79d9c1dcb09f8f = (storeName, { getInitialState: getInitialState })=>{
    const actions = {
        updateFilter: (nameOrFilter, value)=>({ setState: setState, getState: getState }, { onUpdate: onUpdate })=>{
                const newFilter = typeof nameOrFilter === 'object' ? nameOrFilter : {
                    [nameOrFilter]: value
                };
                setState({
                    ...getState(),
                    [$30cd11272c627f6b$export$7ecdd4b6ae40e139.Page]: 1,
                    ...newFilter
                });
                onUpdate(getState());
            },
        forceUpdate: ()=>({ getState: getState }, { onUpdate: onUpdate })=>onUpdate(getState())
    };
    const Store = (0, $iXqE5.createStore)({
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        initialState: {},
        actions: actions,
        name: storeName
    });
    const useFilter = (0, $3sQ5x.createHook)(Store);
    const useScopedFilter = (0, $3sQ5x.createHook)(Store, {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        selector: (state, name)=>state[name]
    });
    const FilterContainer = (0, $gg7kZ.createContainer)(Store, {
        onInit: ()=>({ setState: setState })=>{
                try {
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    const routeQuery = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(window.location.search);
                    setState(getInitialState({
                        routeQuery: routeQuery
                    }));
                } catch (error) {
                    (0, $jcw0u.default)({
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        error: error,
                        meta: {
                            id: 'createUseFilter',
                            packageName: 'jiraDirectoryBaseV3',
                            teamName: 'jira-cosmos'
                        }
                    });
                }
            },
        // reset initial state on unmount
        onCleanup: ()=>({ setState: setState })=>setState(getInitialState({
                    routeQuery: {}
                }))
    });
    return {
        useFilter: useFilter,
        useScopedFilter: useScopedFilter,
        FilterContainer: FilterContainer
    };
};

});


parcelRegister("8pIiT", function(module, exports) {

$parcel$export(module.exports, "sanitizeLegacyQuery", () => $ddc7efe5cefc2e09$export$b6d5141c3209bd35);
$parcel$export(module.exports, "mapQueryToFilter", () => $ddc7efe5cefc2e09$export$2274cd5f35844a96);

var $4R6GH = parcelRequire("4R6GH");

var $h29WZ = parcelRequire("h29WZ");

var $7a3e8 = parcelRequire("7a3e8");

var $2vSU6 = parcelRequire("2vSU6");

var $dZhZb = parcelRequire("dZhZb");

var $dXq4S = parcelRequire("dXq4S");

var $gkT9B = parcelRequire("gkT9B");
const $ddc7efe5cefc2e09$var$LEGACY_ALL_VALUE = 'all';
const $ddc7efe5cefc2e09$export$b6d5141c3209bd35 = (query)=>({
        ...query,
        selectedProjectType: query.selectedProjectType === $ddc7efe5cefc2e09$var$LEGACY_ALL_VALUE ? (0, $gkT9B.filterInitialState)[(0, $gkT9B.FilterFields).ProjectType] : query.selectedProjectType,
        selectedCategory: query.selectedCategory === $ddc7efe5cefc2e09$var$LEGACY_ALL_VALUE ? (0, $gkT9B.filterInitialState)[(0, $gkT9B.FilterFields).ProjectCategoryId] : query.selectedCategory
    });
const $ddc7efe5cefc2e09$export$2274cd5f35844a96 = (filter, { cloudId: cloudId, query: query, aliases: aliases })=>{
    const variables = {};
    const { [(0, $gkT9B.FilterFields).Keyword]: keyword, [(0, $gkT9B.FilterFields).ProjectCategoryId]: projectCategoryId, [(0, $gkT9B.FilterFields).ProjectType]: types, [(0, $gkT9B.FilterFields).SortOrder]: sortOrder, [(0, $gkT9B.FilterFields).SortKey]: sortKey } = aliases && query ? (0, $dZhZb.matchAliases)(filter, query, aliases) : filter; // eslint-disable-line @typescript-eslint/consistent-type-assertions
    if (keyword) variables.keyword = keyword;
    if (projectCategoryId) {
        const isAlreadyAri = (0, $4R6GH.fg)('camptasks-1102-enable-atlassian-ari-projects') ? (0, $h29WZ.AnyAri).check(projectCategoryId) : (0, $dXq4S.isAri)(projectCategoryId);
        if (isAlreadyAri) variables.projectCategoryId = projectCategoryId;
        else variables.projectCategoryId = (0, $4R6GH.fg)('camptasks-1102-enable-atlassian-ari-projects') ? (0, $7a3e8.JiraProjectCategoryAri).create({
            projectCategoryId: projectCategoryId,
            siteId: cloudId
        }).toString() : (0, $dXq4S.createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'project-category',
            resourceId: projectCategoryId
        });
    }
    if (sortKey || sortOrder) {
        const sortByValue = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        sortKey && (0, $gkT9B.SortableColumns).includes(sortKey) ? sortKey : (0, $gkT9B.filterInitialState)[(0, $gkT9B.FilterFields).SortKey];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        variables.sortBy = {
            order: [
                'ASC',
                'DESC'
            ].includes(sortOrder) ? sortOrder : (0, $gkT9B.filterInitialState)[(0, $gkT9B.FilterFields).SortOrder],
            sortBy: sortByValue.toUpperCase()
        };
    }
    if (types && typeof types === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    variables.types = types.split(',') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .filter((type)=>(0, $2vSU6.PROJECT_TYPES).includes(type)).map((type)=>type.toUpperCase());
    return variables;
};

});
parcelRegister("7a3e8", function(module, exports) {

$parcel$export(module.exports, "JiraProjectCategoryAri", () => $536bf865a32ac7bf$export$da484aad24207e3d);

var $g0RIi = parcelRequire("g0RIi");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/project-category/manifest.ts
var $536bf865a32ac7bf$var$jiraProjectCategoryAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $g0RIi.JiraProjectCategoryAriResourceOwner),
    resourceType: (0, $g0RIi.JiraProjectCategoryAriResourceType),
    resourceIdSlug: "{projectCategoryId}",
    resourceIdSegmentFormats: {
        projectCategoryId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/project-category/index.ts
var $536bf865a32ac7bf$export$da484aad24207e3d = class _JiraProjectCategoryAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._projectCategoryId = opts.resourceIdSegmentValues.projectCategoryId;
    }
    get siteId() {
        return this._siteId;
    }
    get projectCategoryId() {
        return this._projectCategoryId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $536bf865a32ac7bf$var$jiraProjectCategoryAriStaticOpts.qualifier,
            platformQualifier: $536bf865a32ac7bf$var$jiraProjectCategoryAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $536bf865a32ac7bf$var$jiraProjectCategoryAriStaticOpts.resourceOwner,
            resourceType: $536bf865a32ac7bf$var$jiraProjectCategoryAriStaticOpts.resourceType,
            resourceId: `${opts.projectCategoryId}`,
            resourceIdSegmentValues: {
                projectCategoryId: opts.projectCategoryId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $536bf865a32ac7bf$var$jiraProjectCategoryAriStaticOpts);
        return new _JiraProjectCategoryAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $536bf865a32ac7bf$var$jiraProjectCategoryAriStaticOpts);
        return new _JiraProjectCategoryAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectCategoryId: this.projectCategoryId
        };
    }
};

});
parcelRegister("g0RIi", function(module, exports) {

$parcel$export(module.exports, "JiraProjectCategoryAriResourceOwner", () => $ba864fca2e893f55$export$b4df372413a623f1);
$parcel$export(module.exports, "JiraProjectCategoryAriResourceType", () => $ba864fca2e893f55$export$51b6f2a645c9e23a);
// src/jira/project-category/types.ts
var $ba864fca2e893f55$export$b4df372413a623f1 = "jira", $ba864fca2e893f55$export$51b6f2a645c9e23a = "project-category";

});


parcelRegister("dZhZb", function(module, exports) {

$parcel$export(module.exports, "matchAliases", () => $e41b5d91b7cfd8ce$export$55f686d7a3507dbe);
$parcel$export(module.exports, "serializeSelectOptions", () => $e41b5d91b7cfd8ce$export$74a705e0bee1565b);
$parcel$export(module.exports, "serializeSelectOptionsLabel", () => $e41b5d91b7cfd8ce$export$eed751fcc55ddadd);
$parcel$export(module.exports, "matchValueToSelectOptions", () => $e41b5d91b7cfd8ce$export$17e142fa55464467);

var $ggSx2 = parcelRequire("ggSx2");

var $cuHs1 = parcelRequire("cuHs1");
const $e41b5d91b7cfd8ce$export$55f686d7a3507dbe = (filterState, query, aliases)=>Object.keys(query).reduce((filter, key)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const alias = aliases[key];
        const queryValue = query[key];
        const hasInitialValue = filter[key] !== undefined;
        // override default filter value with query params
        if (hasInitialValue && queryValue) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
            filter[key] = queryValue;
            return filter;
        }
        // if there's no alias and no query param for it return default filter
        if (!alias || !queryValue) return filter;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
        filter[alias] = queryValue;
        return filter;
    }, {
        ...filterState
    });
const $e41b5d91b7cfd8ce$export$40bf1812f0f07002 = (data, aliases)=>{
    const invertedAliases = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))(aliases);
    return (0, (/*@__PURE__*/$parcel$interopDefault($cuHs1)))(data, (_, key)=>invertedAliases[key] || key);
};
const $e41b5d91b7cfd8ce$export$74a705e0bee1565b = (options)=>options.map((v)=>v.value).join(',');
const $e41b5d91b7cfd8ce$export$eed751fcc55ddadd = (options)=>options.map((v)=>v.label).join(',');
const $e41b5d91b7cfd8ce$export$17e142fa55464467 = (value, options)=>value ? value.split(',').map((val)=>options.find((option)=>option.value === val)).filter(Boolean) : [];

});
parcelRegister("ggSx2", function(module, exports) {

var $cxSdl = parcelRequire("cxSdl");

var $fxKlj = parcelRequire("fxKlj");

var $etyzk = parcelRequire("etyzk");
/** Used for built-in method references. */ var $bd8870e21c3833a0$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $bd8870e21c3833a0$var$nativeObjectToString = $bd8870e21c3833a0$var$objectProto.toString;
/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */ var $bd8870e21c3833a0$var$invert = $fxKlj(function(result, value, key) {
    if (value != null && typeof value.toString != 'function') value = $bd8870e21c3833a0$var$nativeObjectToString.call(value);
    result[value] = key;
}, $cxSdl($etyzk));
module.exports = $bd8870e21c3833a0$var$invert;

});
parcelRegister("fxKlj", function(module, exports) {

var $d1nCg = parcelRequire("d1nCg");
/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */ function $b50de2cb57eb155c$var$createInverter(setter, toIteratee) {
    return function(object, iteratee) {
        return $d1nCg(object, setter, toIteratee(iteratee), {});
    };
}
module.exports = $b50de2cb57eb155c$var$createInverter;

});
parcelRegister("d1nCg", function(module, exports) {

var $hDnyx = parcelRequire("hDnyx");
/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */ function $97adb007e27dc709$var$baseInverter(object, setter, iteratee, accumulator) {
    $hDnyx(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
    });
    return accumulator;
}
module.exports = $97adb007e27dc709$var$baseInverter;

});



parcelRegister("cuHs1", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $hDnyx = parcelRequire("hDnyx");

var $bxDef = parcelRequire("bxDef");
/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */ function $0258ef72e36fbfcb$var$mapKeys(object, iteratee) {
    var result = {};
    iteratee = $bxDef(iteratee, 3);
    $hDnyx(object, function(value, key, object) {
        $1m3dq(result, iteratee(value, key, object), value);
    });
    return result;
}
module.exports = $0258ef72e36fbfcb$var$mapKeys;

});



parcelRegister("lVQ0r", function(module, exports) {

$parcel$export(module.exports, "default", () => $0264f0fee7e7a1be$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4f241df3a6ea0e25359d8080940f5802>>
 * @relayHash 9748961340a0877dad06569907936559
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID da04654402c040cfb1a5731e6742c8a699abdddac45bfc2bc9c768547f13bcf3

var $eiowN = parcelRequire("eiowN");
const $0264f0fee7e7a1be$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAdminSettingsContext"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAnonymous"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "isAnonymous",
            "variableName": "isAnonymous"
        }
    ], v7 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v8 = {
        "alias": "canBrowseProjects",
        "args": [
            v7 /*: any*/ ,
            {
                "kind": "Literal",
                "name": "type",
                "value": "BROWSE_PROJECTS"
            }
        ],
        "concreteType": "JiraPermission",
        "kind": "LinkedField",
        "name": "permission",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasPermission"
            }
        ]
    }, v9 = [
        v7 /*: any*/ 
    ], v10 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ], v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = {
        "kind": "ScalarField",
        "name": "name"
    }, v13 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v14 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "key"
    }, v16 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v17 = {
        "kind": "ScalarField",
        "name": "totalCount"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "pageLayout_projectsDirectoryLayout_RootQuery",
            "selections": [
                {
                    "args": v6 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "header_projectsDirectoryV3"
                },
                {
                    "args": v6 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "refinementBar_projectsDirectoryV3_Filters"
                },
                {
                    "args": v6 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "projectsList_projectsDirectoryV3_rootQueryRef"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isAdminSettingsContext",
                            "variableName": "isAdminSettingsContext"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "pageLayout_projectsDirectoryV3_ProjectDirectoryLayout"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "emptyView_projectsDirectoryV3"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "noPermissionViews_projectsDirectoryV3"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "pageLayout_projectsDirectoryLayout_RootQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "canCreateProject",
                            "args": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "CREATE_PROJECT"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "canPerform"
                        },
                        {
                            "args": v9 /*: any*/ ,
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        },
                        {
                            "args": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "filter",
                                    "variableName": "filter"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "first",
                                    "variableName": "first"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "last",
                                    "variableName": "last"
                                }
                            ],
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": "canViewIssue",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "VIEW_ISSUES"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": v10 /*: any*/ ,
                                                    "storageKey": "action(type:\"VIEW_ISSUES\")"
                                                },
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraFavouriteValue",
                                                    "kind": "LinkedField",
                                                    "name": "favouriteValue",
                                                    "plural": false,
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                v15 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraAvatar",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "medium"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectStyle"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "navigationMetadata",
                                                    "plural": false,
                                                    "selections": [
                                                        v16 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "boardId"
                                                                },
                                                                v11 /*: any*/ 
                                                            ],
                                                            "type": "JiraSoftwareProjectNavigationMetadata"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "queueId"
                                                                }
                                                            ],
                                                            "type": "JiraServiceManagementProjectNavigationMetadata"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectType"
                                                },
                                                {
                                                    "concreteType": "JiraProjectCategory",
                                                    "kind": "LinkedField",
                                                    "name": "category",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "lead",
                                                    "plural": false,
                                                    "selections": [
                                                        v16 /*: any*/ ,
                                                        {
                                                            "kind": "TypeDiscriminator",
                                                            "abstractKey": "__isUser"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "accountId"
                                                        },
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "picture"
                                                        },
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "condition": "isAdminSettingsContext",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "alias": "lastUpdatedToolTipDate",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "format",
                                                                    "value": "COMPLETE_DATETIME_FORMAT"
                                                                }
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "lastUpdatedFormatted",
                                                            "storageKey": "lastUpdatedFormatted(format:\"COMPLETE_DATETIME_FORMAT\")"
                                                        },
                                                        {
                                                            "alias": "lastUpdatedDisplayDate",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "format",
                                                                    "value": "RELATIVE"
                                                                }
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "lastUpdatedFormatted",
                                                            "storageKey": "lastUpdatedFormatted(format:\"RELATIVE\")"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectUrl"
                                                },
                                                {
                                                    "alias": "canViewProjectConfig",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "VIEW_PROJECT_CONFIG"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": v10 /*: any*/ ,
                                                    "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
                                                },
                                                {
                                                    "alias": "jiraProjectType",
                                                    "kind": "ScalarField",
                                                    "name": "projectType"
                                                },
                                                {
                                                    "alias": "jiraProjectName",
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v17 /*: any*/ ,
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isHasTotal"
                                }
                            ]
                        },
                        {
                            "alias": "canContactAdmin",
                            "args": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": "jira.show.contact.administrators.form"
                                }
                            ],
                            "concreteType": "JiraApplicationProperty",
                            "kind": "LinkedField",
                            "name": "applicationPropertiesByKey",
                            "plural": true,
                            "selections": [
                                v15 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                },
                                v11 /*: any*/ 
                            ]
                        },
                        v8 /*: any*/ ,
                        {
                            "condition": "isAnonymous",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v9 /*: any*/ ,
                                    "concreteType": "JiraUserPreferences",
                                    "kind": "LinkedField",
                                    "name": "userPreferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectListRightPanelState"
                                        },
                                        v14 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "sidebarExperimentTemplates",
                                    "args": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "experimentKey",
                                            "value": "sidebarExperiment"
                                        }
                                    ],
                                    "concreteType": "JiraProjectListViewTemplateConnection",
                                    "kind": "LinkedField",
                                    "name": "projectListViewTemplates",
                                    "plural": false,
                                    "selections": [
                                        v17 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v9 /*: any*/ ,
                                    "concreteType": "JiraProjectCategoryConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjectCategories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectCategoryEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v16 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isAnonymous",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v9 /*: any*/ ,
                                    "concreteType": "JiraProjectCategoryConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjectCategories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectCategoryEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraProjectCategory",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v9 /*: any*/ ,
                            "concreteType": "JiraProjectTypeDetailsConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjectTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectTypeDetailsEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectTypeDetails",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "da04654402c040cfb1a5731e6742c8a699abdddac45bfc2bc9c768547f13bcf3",
            "metadata": {},
            "name": "pageLayout_projectsDirectoryLayout_RootQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0264f0fee7e7a1be$var$node.hash = "0383d6b00b0ae0222d704297e4fe4e64";
(0, $eiowN.PreloadableQueryRegistry).set($0264f0fee7e7a1be$var$node.params.id, $0264f0fee7e7a1be$var$node);
var $0264f0fee7e7a1be$export$2e2bcd8739ae039 = $0264f0fee7e7a1be$var$node;

});

const $ce818d5819645fe8$export$2150caade62dc875 = 'PROJECTS_DIRECTORY_RELAY';



parcelRegister("fhRbA", function(module, exports) {

$parcel$export(module.exports, "LazyProjectsDirectory", () => $a4d64259d3b4962d$export$f9ee24127b8e4a7f);

var $7yO8g = parcelRequire("7yO8g");

var $kxZPA = parcelRequire("kxZPA");

const $a4d64259d3b4962d$export$f9ee24127b8e4a7f = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("7u2Nb"))), {
    moduleId: "./src/packages/spa-apps/directories/projects-v3/src/index.tsx"
});

});
parcelRegister("7u2Nb", function(module, exports) {

let $572d803cd92ab725$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $572d803cd92ab725$var$load("ffQaD"),
    $572d803cd92ab725$var$load("kvRbA"),
    $572d803cd92ab725$var$load("9HCEh")
]).then(()=>parcelRequire('eBOH6'));

});


parcelRegister("jL5x9", function(module, exports) {

$parcel$export(module.exports, "ProjectsDirectoryPageEntryPoint", () => $46b7b7dce12367bc$export$f4985310f86f98fc);

var $lkFvK = parcelRequire("lkFvK");

var $3obFW = parcelRequire("3obFW");

var $lmyls = parcelRequire("lmyls");

var $7wpGh = parcelRequire("7wpGh");

var $6raju = parcelRequire("6raju");
const $46b7b7dce12367bc$export$f4985310f86f98fc = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7wpGh.projectsDirectoryEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    rightSidebar: (0, $3obFW.RecommendationsInProjectListEntryPoint),
    rightSidebarFallback: (0, $6raju.ProjectListSidebarSkeleton)
});

});
parcelRegister("3obFW", function(module, exports) {

$parcel$export(module.exports, "RecommendationsInProjectListEntryPoint", () => $64f90d2bc5407ac6$export$8baad7954c0e6b8c);

var $5uP7K = parcelRequire("5uP7K");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $64f90d2bc5407ac6$export$8baad7954c0e6b8c = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("d6b47")), {
        moduleId: "3a12ca77"
    }),
    getPreloadProps: (extraProps)=>({
            extraProps: extraProps,
            queries: {
                templatesQueryRef: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $5uP7K.default,
                    variables: {
                        cloudId: extraProps.tenantContext.cloudId,
                        isAnonymous: extraProps.tenantContext.isAnonymous
                    }
                }
            }
        })
});

});
parcelRegister("5uP7K", function(module, exports) {

$parcel$export(module.exports, "default", () => $73a724a7681d68cc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2096812634ac4db7102f111552f3cac0>>
 * @relayHash 33d5cb864464856bfba034ce11494a6a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a8abf8f0db8118c80c104d263cb9b57c8ed6264d060a8d429ffbcaa08ff96694
const $73a724a7681d68cc$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a8abf8f0db8118c80c104d263cb9b57c8ed6264d060a8d429ffbcaa08ff96694",
        "metadata": {},
        "name": "src_projectsDirectoryTemplatesSidebar_RecommendationsInProjectListQuery",
        "operationKind": "query",
        "text": null
    }
};
var $73a724a7681d68cc$export$2e2bcd8739ae039 = $73a724a7681d68cc$var$node;

});

parcelRegister("d6b47", function(module, exports) {

let $98946b3d8cf00690$var$load = (parcelRequire("28QjX"))(4);
module.exports = $98946b3d8cf00690$var$load("fiVNq").then(()=>parcelRequire('hT4Zj'));

});


parcelRegister("7wpGh", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryEntryPoint", () => $94d9041756c0d8ee$export$80225215a10b2688);

var $4R6GH = parcelRequire("4R6GH");

var $h29WZ = parcelRequire("h29WZ");

var $7a3e8 = parcelRequire("7a3e8");

var $dXq4S = parcelRequire("dXq4S");

var $9M2wg = parcelRequire("9M2wg");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");
const $94d9041756c0d8ee$var$DEFAULT_LIMIT = 25;
const $94d9041756c0d8ee$var$PROJECTS_DIRECTORY_MANAGE = 'projects-directory-manage';
const $94d9041756c0d8ee$var$DefaultFilterFields = {
    // sorting
    SortOrder: 'sortOrder',
    SortKey: 'sortKey',
    // pagination
    Page: 'page'
};
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $94d9041756c0d8ee$var$TableColumns = /*#__PURE__*/ function(TableColumns) {
    TableColumns["Favourites"] = "favourites";
    TableColumns["Key"] = "key";
    TableColumns["Name"] = "name";
    TableColumns["Type"] = "type";
    TableColumns["Lead"] = "lead";
    TableColumns["Category"] = "category";
    TableColumns["LastIssueUpdate"] = "last_issue_updated_time";
    TableColumns["Url"] = "url";
    TableColumns["Action"] = "actions";
    return TableColumns;
}($94d9041756c0d8ee$var$TableColumns || {});
const $94d9041756c0d8ee$var$SortableColumns = [
    "key",
    "name",
    "lead",
    "category",
    "last_issue_updated_time"
];
const $94d9041756c0d8ee$var$FilterFields = {
    Keyword: 'keyword',
    ProjectType: 'types',
    ProjectCategoryId: 'projectCategoryId',
    ...$94d9041756c0d8ee$var$DefaultFilterFields
};
const $94d9041756c0d8ee$var$filterAliasMap = {
    contains: $94d9041756c0d8ee$var$FilterFields.Keyword,
    selectedProjectType: $94d9041756c0d8ee$var$FilterFields.ProjectType,
    selectedCategory: $94d9041756c0d8ee$var$FilterFields.ProjectCategoryId
};
const $94d9041756c0d8ee$var$filterInitialState = {
    [$94d9041756c0d8ee$var$FilterFields.Keyword]: '',
    [$94d9041756c0d8ee$var$FilterFields.ProjectType]: '',
    [$94d9041756c0d8ee$var$FilterFields.ProjectCategoryId]: '',
    [$94d9041756c0d8ee$var$FilterFields.SortOrder]: 'ASC',
    [$94d9041756c0d8ee$var$FilterFields.SortKey]: "name",
    [$94d9041756c0d8ee$var$FilterFields.Page]: '1'
};
const $94d9041756c0d8ee$var$LEGACY_ALL_VALUE = 'all';
const $94d9041756c0d8ee$var$sanitizeLegacyQuery = (query = {})=>({
        ...query,
        selectedProjectType: query.selectedProjectType === $94d9041756c0d8ee$var$LEGACY_ALL_VALUE ? $94d9041756c0d8ee$var$filterInitialState[$94d9041756c0d8ee$var$FilterFields.ProjectType] : query.selectedProjectType,
        selectedCategory: query.selectedCategory === $94d9041756c0d8ee$var$LEGACY_ALL_VALUE ? $94d9041756c0d8ee$var$filterInitialState[$94d9041756c0d8ee$var$FilterFields.ProjectCategoryId] : query.selectedCategory
    });
const $94d9041756c0d8ee$var$matchAliases = (filterState, query, aliases)=>Object.keys(query).reduce((filter, key)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const alias = aliases[key];
        const queryValue = query[key];
        const hasInitialValue = filter[key] !== undefined;
        // override default filter value with query params
        if (hasInitialValue && queryValue) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
            filter[key] = queryValue;
            return filter;
        }
        // if there's no alias and no query param for it return default filter
        if (!alias || !queryValue) return filter;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
        filter[alias] = queryValue;
        return filter;
    }, {
        ...filterState
    });
const $94d9041756c0d8ee$var$CORE_PROJECT = 'business';
const $94d9041756c0d8ee$var$SOFTWARE_PROJECT = 'software';
const $94d9041756c0d8ee$var$SERVICE_DESK_PROJECT = 'service_desk';
const $94d9041756c0d8ee$var$PRODUCT_DISCOVERY_PROJECT = 'product_discovery';
const $94d9041756c0d8ee$var$PROJECT_TYPES = [
    $94d9041756c0d8ee$var$CORE_PROJECT,
    $94d9041756c0d8ee$var$SOFTWARE_PROJECT,
    $94d9041756c0d8ee$var$SERVICE_DESK_PROJECT,
    $94d9041756c0d8ee$var$PRODUCT_DISCOVERY_PROJECT
];
const $94d9041756c0d8ee$var$mapQueryToFilter = (filter, { cloudId: cloudId, query: query, aliases: aliases })=>{
    const variables = {};
    const { [$94d9041756c0d8ee$var$FilterFields.Keyword]: keyword, [$94d9041756c0d8ee$var$FilterFields.ProjectCategoryId]: projectCategoryId, [$94d9041756c0d8ee$var$FilterFields.ProjectType]: types, [$94d9041756c0d8ee$var$FilterFields.SortOrder]: sortOrder, [$94d9041756c0d8ee$var$FilterFields.SortKey]: sortKey } = aliases && query ? $94d9041756c0d8ee$var$matchAliases(filter, query, aliases) : filter;
    if (keyword) variables.keyword = keyword;
    if (projectCategoryId) {
        const isAlreadyAri = (0, $4R6GH.fg)('camptasks-1102-enable-atlassian-ari-projects') ? (0, $h29WZ.AnyAri).check(projectCategoryId) : (0, $dXq4S.isAri)(projectCategoryId);
        if (isAlreadyAri) variables.projectCategoryId = projectCategoryId;
        else variables.projectCategoryId = (0, $4R6GH.fg)('camptasks-1102-enable-atlassian-ari-projects') ? (0, $7a3e8.JiraProjectCategoryAri).create({
            projectCategoryId: projectCategoryId,
            siteId: cloudId
        }).toString() : (0, $dXq4S.createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'project-category',
            resourceId: projectCategoryId
        });
    }
    if (sortKey || sortOrder) {
        const sortByValue = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        sortKey && $94d9041756c0d8ee$var$SortableColumns.includes(sortKey) ? sortKey : $94d9041756c0d8ee$var$filterInitialState[$94d9041756c0d8ee$var$FilterFields.SortKey];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        variables.sortBy = {
            order: [
                'ASC',
                'DESC'
            ].includes(sortOrder) ? sortOrder : $94d9041756c0d8ee$var$filterInitialState[$94d9041756c0d8ee$var$FilterFields.SortOrder],
            sortBy: sortByValue.toUpperCase()
        };
    }
    if (types && typeof types === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    variables.types = types.split(',') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .filter((type)=>$94d9041756c0d8ee$var$PROJECT_TYPES.includes(type)).map((type)=>type.toUpperCase());
    return variables;
};

const $94d9041756c0d8ee$export$80225215a10b2688 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("grweM")), {
        moduleId: "b77224b3"
    }),
    getPreloadProps ({ context: { query: query, route: route }, tenantContext: tenantContext }) {
        const { cloudId: cloudId, isAnonymous: isAnonymous } = tenantContext;
        const extraProps = {
            isAdminProjectDirectoryRoute: route.name === $94d9041756c0d8ee$var$PROJECTS_DIRECTORY_MANAGE
        };
        if (false && isAnonymous) return {
            extraProps: extraProps
        };
        return {
            queries: {
                projectsDirectoryPage: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: (0, $9M2wg.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        filter: $94d9041756c0d8ee$var$mapQueryToFilter($94d9041756c0d8ee$var$filterInitialState, {
                            cloudId: cloudId,
                            query: $94d9041756c0d8ee$var$sanitizeLegacyQuery(query),
                            aliases: $94d9041756c0d8ee$var$filterAliasMap
                        }),
                        first: query?.page ? $94d9041756c0d8ee$var$DEFAULT_LIMIT * (parseInt(query.page, 10) || 1) : $94d9041756c0d8ee$var$DEFAULT_LIMIT,
                        last: $94d9041756c0d8ee$var$DEFAULT_LIMIT,
                        isAdminSettingsContext: route.name === $94d9041756c0d8ee$var$PROJECTS_DIRECTORY_MANAGE,
                        isAnonymous: isAnonymous
                    }
                }
            },
            extraProps: extraProps
        };
    }
});

});
parcelRegister("9M2wg", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2863fb0305ba6a4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<23a6e9e3efd53029f1bd2f15dafcc83f>>
 * @relayHash 9748961340a0877dad06569907936559
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID da04654402c040cfb1a5731e6742c8a699abdddac45bfc2bc9c768547f13bcf3
const $a2863fb0305ba6a4$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "da04654402c040cfb1a5731e6742c8a699abdddac45bfc2bc9c768547f13bcf3",
        "metadata": {},
        "name": "pageLayout_projectsDirectoryLayout_RootQuery",
        "operationKind": "query",
        "text": null
    }
};
var $a2863fb0305ba6a4$export$2e2bcd8739ae039 = $a2863fb0305ba6a4$var$node;

});

parcelRegister("grweM", function(module, exports) {

let $bf882ca2f5801382$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $bf882ca2f5801382$var$load("ffQaD"),
    $bf882ca2f5801382$var$load("kvRbA"),
    $bf882ca2f5801382$var$load("jj5e4")
]).then(()=>parcelRequire('j3Lmi'));

});


parcelRegister("6raju", function(module, exports) {

$parcel$export(module.exports, "ProjectListSidebarSkeleton", () => $be14de1be79b27e3$export$808c25bcc6102427);
/* ProjectListSidebarSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $6bUD4 = parcelRequire("6bUD4");
const $be14de1be79b27e3$var$customCssStyles = null;
const $be14de1be79b27e3$var$sidebarCssStyles = null;
const $be14de1be79b27e3$export$808c25bcc6102427 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_4t3i1osq _1bsb1gwv _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _t6vdt94y _1p3lnqa1 _5wramuej _bfhkvuon _vchhusvi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6bUD4))),
        className: (0, $bwpsq.default)([
            "_t6vdidpf _hr4jidpf"
        ])
    }));

});
parcelRegister("6bUD4", function(module, exports) {
module.exports = new URL("project-list-sidebar-app-skeleton.tpl.35da4e26.svg", import.meta.url).toString();

});




parcelRegister("cmIyb", function(module, exports) {

$parcel$export(module.exports, "plansDirectoryRouteEntry", () => $d1aaabcb7e27c9a6$export$4f9df77811fbdc1f);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $8jQu6 = parcelRequire("8jQu6");

var $cFtGt = parcelRequire("cFtGt");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $d1aaabcb7e27c9a6$var$LazyPlansDirectory = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("f4PsM"))), {
    moduleId: "./src/packages/spa-apps/directories/plans/src/index.tsx"
});
const $d1aaabcb7e27c9a6$var$PlansDirectoryComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d1aaabcb7e27c9a6$var$LazyPlansDirectory,
        pageId: "plans-directory",
        shouldShowSpinner: false
    });
const $d1aaabcb7e27c9a6$export$4f9df77811fbdc1f = (0, $7NszV.createEntry)((0, $8jQu6.plansDirectoryRoute), ()=>({
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental'),
        group: 'directories',
        component: $d1aaabcb7e27c9a6$var$PlansDirectoryComponent,
        skeleton: (0, $cFtGt.PlansDirectorySkeleton),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PLANS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $d1aaabcb7e27c9a6$var$LazyPlansDirectory
        ]
    }));

});
parcelRegister("f4PsM", function(module, exports) {

let $02d525c72e1a1521$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $02d525c72e1a1521$var$load("ffQaD"),
    $02d525c72e1a1521$var$load("kvRbA"),
    $02d525c72e1a1521$var$load("czLNO")
]).then(()=>parcelRequire('flZBd'));

});


parcelRegister("fQyGL", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryLegacyPathRedirectRouteEntry", () => $8f20c76692c396ce$export$78ff5b5f42b9de4);

var $ffza4 = parcelRequire("ffza4");

var $gmpjq = parcelRequire("gmpjq");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $hW253 = parcelRequire("hW253");

var $gUy1M = parcelRequire("gUy1M");

var $cFtGt = parcelRequire("cFtGt");

var $1ryl1 = parcelRequire("1ryl1");

var $fhRbA = parcelRequire("fhRbA");
const $8f20c76692c396ce$export$78ff5b5f42b9de4 = (0, $7NszV.createEntry)((0, $gUy1M.projectsDirectoryLegacyPathRedirectRoute), ()=>({
        group: 'directories',
        component: (0, $1ryl1.ProjectsDirectoryRedirect),
        skeleton: (0, $cFtGt.ProjectsDirectorySkeleton),
        isRedirect: true,
        layout: (0, $gmpjq.homepageLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $hW253.projectsDirectoryPageResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fhRbA.LazyProjectsDirectory)
        ]
    }));

});
parcelRegister("gUy1M", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryLegacyPathRedirectRoute", () => $6002c1f8d9c23c57$export$c713f57300a82898);
const $6002c1f8d9c23c57$export$c713f57300a82898 = {
    name: 'projects-directory-legacy-path-spa-redirect',
    path: '/secure/BrowseProjects.jspa'
};

});

parcelRegister("1ryl1", function(module, exports) {

$parcel$export(module.exports, "ProjectsDirectoryRedirect", () => $3ba92fb58534b205$export$b68dd6112a931c10);

var $5uXOq = parcelRequire("5uXOq");

var $ds5qV = parcelRequire("ds5qV");
const $3ba92fb58534b205$export$b68dd6112a931c10 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: "/jira/projects"
    });

});


parcelRegister("ifEj3", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryManageRedirectRouteEntry", () => $b468f39f7a3e39f4$export$c3c347e60b82f074);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $4jMkc = parcelRequire("4jMkc");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $jQdhH = parcelRequire("jQdhH");

var $cFtGt = parcelRequire("cFtGt");

var $k3MnQ = parcelRequire("k3MnQ");

var $fbnvY = parcelRequire("fbnvY");

var $fhRbA = parcelRequire("fhRbA");
const $b468f39f7a3e39f4$export$c3c347e60b82f074 = (0, $7NszV.createEntry)((0, $jQdhH.projectsDirectoryManageRedirectRoute), ()=>({
        component: (0, $k3MnQ.ProjectsDirectoryManageRedirect),
        skeleton: (0, $cFtGt.ProjectsDirectorySkeleton),
        isRedirect: true,
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebar: (0, $4jMkc.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $fbnvY.adminProjectDirectoryResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fhRbA.LazyProjectsDirectory)
        ]
    }));

});
parcelRegister("jQdhH", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryManageRedirectRoute", () => $9ef5b86eaaaceda7$export$dbd3b6c012e8b6dc);
const $9ef5b86eaaaceda7$export$dbd3b6c012e8b6dc = {
    name: 'projects-directory-manage-redirect',
    path: '/secure/project/ViewProjects.jspa'
};

});

parcelRegister("k3MnQ", function(module, exports) {

$parcel$export(module.exports, "ProjectsDirectoryManageRedirect", () => $0582a6018d790f50$export$74316a0a4963952b);

var $5uXOq = parcelRequire("5uXOq");

var $ds5qV = parcelRequire("ds5qV");
const $0582a6018d790f50$export$74316a0a4963952b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: "/jira/settings/projects/manage"
    });

});


parcelRegister("4CGuj", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryManageRootRedirectRouteEntry", () => $e677bebc1d8715eb$export$3f6ec3224d4c9da);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $4jMkc = parcelRequire("4jMkc");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $g8syc = parcelRequire("g8syc");

var $cFtGt = parcelRequire("cFtGt");

var $k3MnQ = parcelRequire("k3MnQ");

var $fbnvY = parcelRequire("fbnvY");

var $fhRbA = parcelRequire("fhRbA");
const $e677bebc1d8715eb$export$3f6ec3224d4c9da = (0, $7NszV.createEntry)((0, $g8syc.projectsDirectoryManageRootRedirectRoute), ()=>({
        component: (0, $k3MnQ.ProjectsDirectoryManageRedirect),
        skeleton: (0, $cFtGt.ProjectsDirectorySkeleton),
        isRedirect: true,
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebar: (0, $4jMkc.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $fbnvY.adminProjectDirectoryResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fhRbA.LazyProjectsDirectory)
        ]
    }));

});
parcelRegister("g8syc", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryManageRootRedirectRoute", () => $45b46e5e0a379e06$export$4531e3b2e25fad23);
const $45b46e5e0a379e06$export$4531e3b2e25fad23 = {
    name: 'projects-directory-manage-root-redirect',
    path: '/jira/settings/projects',
    exact: true
};

});


parcelRegister("6VvYi", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryRedirectRouteEntry", () => $66b2e7de35cd3e39$export$8d9d65bb59f2354e);

var $ffza4 = parcelRequire("ffza4");

var $gmpjq = parcelRequire("gmpjq");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $hW253 = parcelRequire("hW253");

var $1k12N = parcelRequire("1k12N");

var $cFtGt = parcelRequire("cFtGt");

var $1ryl1 = parcelRequire("1ryl1");

var $fhRbA = parcelRequire("fhRbA");
const $66b2e7de35cd3e39$export$8d9d65bb59f2354e = (0, $7NszV.createEntry)((0, $1k12N.projectsDirectoryRedirectRoute), ()=>({
        group: 'directories',
        component: (0, $1ryl1.ProjectsDirectoryRedirect),
        skeleton: (0, $cFtGt.ProjectsDirectorySkeleton),
        isRedirect: true,
        layout: (0, $gmpjq.homepageLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $hW253.projectsDirectoryPageResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fhRbA.LazyProjectsDirectory)
        ]
    }));

});
parcelRegister("1k12N", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryRedirectRoute", () => $529d55d6a6980bfb$export$d44f1be3782f0fde);
const $529d55d6a6980bfb$export$d44f1be3782f0fde = {
    name: 'projects-directory-redirect',
    path: '/projects',
    exact: true
};

});


parcelRegister("dSrOC", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryRouteEntry", () => $00e4719282b1ae8b$export$79292a834772288c);

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $foR3E = parcelRequire("foR3E");

var $cFtGt = parcelRequire("cFtGt");

var $jL5x9 = parcelRequire("jL5x9");
const $00e4719282b1ae8b$export$79292a834772288c = (0, $7NszV.createEntry)((0, $foR3E.projectsDirectoryRoute), ()=>({
        group: 'directories',
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental-projects'),
        entryPoint () {
            return 0, $jL5x9.ProjectsDirectoryPageEntryPoint;
        },
        skeleton: (0, $cFtGt.ProjectsDirectorySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        ufoName: 'projects-directory-v3'
    }));

});

parcelRegister("dTkCg", function(module, exports) {

$parcel$export(module.exports, "secureFiltersDirectoryRedirectRouteEntry", () => $d55bc420bfc42a32$export$c2ec350ee9e78717);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $dRl24 = parcelRequire("dRl24");

var $3RJkv = parcelRequire("3RJkv");

var $ba16k = parcelRequire("ba16k");

var $cFtGt = parcelRequire("cFtGt");

var $7RZwy = parcelRequire("7RZwy");
const $d55bc420bfc42a32$export$c2ec350ee9e78717 = (0, $7NszV.createEntry)((0, $ba16k.secureFiltersDirectoryRedirectRoute), ()=>({
        group: 'directories',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $dRl24.filtersDirectoryResource)
        ],
        component: !false ? (0, $7RZwy.FiltersDirectoryRedirect) : (0, $7RZwy.FiltersDirectoryComponent),
        skeleton: (0, $cFtGt.FiltersDirectorySkeleton),
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).FILTERS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7RZwy.LazyFiltersDirectory)
        ],
        isRedirect: true
    }));

});
parcelRegister("ba16k", function(module, exports) {

$parcel$export(module.exports, "secureFiltersDirectoryRedirectRoute", () => $6cb8f0f1ec2e6905$export$50796f2aecd63181);
const $6cb8f0f1ec2e6905$export$50796f2aecd63181 = {
    name: 'filters-directory-secure-redirect',
    path: '/secure/ManageFilters.jspa'
};

});


parcelRegister("hs0Ni", function(module, exports) {

$parcel$export(module.exports, "eocAlertIssueSyncingCreateRouteEntry", () => $1afcecac57b51b7c$export$92f4b6644eb6cb88);

var $6YWw1 = parcelRequire("6YWw1");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $1GLKn = parcelRequire("1GLKn");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

var $jh1uq = parcelRequire("jh1uq");

var $3dgEU = parcelRequire("3dgEU");

var $a5NQf = parcelRequire("a5NQf");
const $1afcecac57b51b7c$var$getNavigationSpecifications = ()=>{
    return ((0, $4R6GH.fg)('operations_nav4_remaining_items_old_navigation_fix') ? (0, $3HwlS.getWillShowNav4)() : true) && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $1afcecac57b51b7c$export$92f4b6644eb6cb88 = (0, $7NszV.createEntry)((0, $1GLKn.eocAlertIssueSyncingCreateRoute), ()=>({
        group: 'eoc',
        component: (0, $jh1uq.AlertIssueSync),
        slot: (0, $3dgEU.AlertIssueSyncCreate),
        basePath: '/jira/settings/products/ops',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $6YWw1.resources).configuredSyncsResource,
            (0, $6YWw1.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$1afcecac57b51b7c$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a5NQf.LazyAlertIssueSync)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a5NQf.LazyAlertIssueSync)
        ]
    }));

});
parcelRegister("6YWw1", function(module, exports) {

$parcel$export(module.exports, "resources", () => $89b6fb9884e4755e$export$bc99aaabaf7b70a7);

var $7fV7n = parcelRequire("7fV7n");

var $1YfAT = parcelRequire("1YfAT");

var $7J53H = parcelRequire("7J53H");

var $eyLtQ = parcelRequire("eyLtQ");
const $89b6fb9884e4755e$export$bc99aaabaf7b70a7 = {
    configuredSyncsResource: $7fV7n.configuredSyncsResource,
    userAccessRightsResource: $eyLtQ.userAccessRightsResource,
    getTeamResource: $7J53H.getTeamResource,
    isCurrentSiteSyncEnabledResource: $1YfAT.isCurrentSiteSyncEnabledResource
};

});
parcelRegister("7fV7n", function(module, exports) {

$parcel$export(module.exports, "configuredSyncsResource", () => $780664dfd818f1ba$export$333c290f4a1ec41c);

var $2M1hQ = parcelRequire("2M1hQ");

var $l116g = parcelRequire("l116g");

var $fCcRT = parcelRequire("fCcRT");
const $780664dfd818f1ba$export$333c290f4a1ec41c = (0, $2M1hQ.createResource)({
    type: 'configuredSyncsResource',
    getKey: ({ query: query, match: match })=>{
        const teamId = match.params.teamId ?? query['teamId'];
        const keyword = query['keyword'];
        const type = query['type'];
        const page = query['page'] || '1';
        const status = query['status'];
        return (0, $l116g.UrlHelper)('configuredSyncsResource', {
            page: page,
            keyword: keyword,
            type: type,
            status: status,
            teamId: teamId
        });
    },
    getData: (routerContext)=>(0, $fCcRT.default).getSyncs(routerContext.query, routerContext.match.params.teamId),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("l116g", function(module, exports) {

$parcel$export(module.exports, "UrlHelper", () => $2539490b962657de$export$bacbc496e850c0a4);
const $2539490b962657de$export$bacbc496e850c0a4 = (path, params = {})=>{
    // https://github.com/microsoft/TypeScript/issues/16655
    const q = Object.entries(params).map(([k, v])=>v !== '' && !!v || v === false ? [
            k,
            v.toString()
        ] : undefined).filter((v)=>!!v);
    const qs = new URLSearchParams(q).toString();
    return `${path}${qs ? `?${qs}` : ''}`;
};

});

parcelRegister("fCcRT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4cc94b3364931bb$export$2e2bcd8739ae039);

var $j74qU = parcelRequire("j74qU");

var $l116g = parcelRequire("l116g");

const $a4cc94b3364931bb$var$getSyncs = async (query, pathParamTeamId)=>{
    const page = parseInt(query['page']) || 1;
    const offset = (page - 1) * (0, $85d01ad7b2541e2c$export$31ecae7225aecec6);
    const queryParams = query ? {
        teamId: pathParamTeamId ?? query.teamId,
        type: query.type,
        keyword: query.keyword,
        status: query.status
    } : {};
    return (0, $j74qU.eocFetch)((0, $l116g.UrlHelper)('/v1/entity-sync/unified', {
        ...queryParams,
        offset: offset.toString(),
        limit: (0, $85d01ad7b2541e2c$export$31ecae7225aecec6)
    })).then((response)=>({
            data: response.data.integrations,
            pageCount: Math.ceil(response.data.count / (0, $85d01ad7b2541e2c$export$31ecae7225aecec6)),
            itemCount: response.data.count
        }));
};
const $a4cc94b3364931bb$var$patchSync = async (syncId, syncType, body, teamId)=>(0, $j74qU.eocFetch)((0, $l116g.UrlHelper)(`/v1/entity-sync/unified/${syncId}`, {
        type: syncType,
        teamId: teamId
    }), {
        method: 'PATCH',
        body: body
    }).then((response)=>response.data);
const $a4cc94b3364931bb$var$deleteSync = async (syncId, syncType, teamId)=>(0, $j74qU.eocFetch)((0, $l116g.UrlHelper)(`/v1/entity-sync/unified/${syncId}`, {
        type: syncType,
        teamId: teamId
    }), {
        method: 'DELETE',
        responseType: 'headers'
    });
var $a4cc94b3364931bb$export$2e2bcd8739ae039 = {
    getSyncs: $a4cc94b3364931bb$var$getSyncs,
    patchSync: $a4cc94b3364931bb$var$patchSync,
    deleteSync: $a4cc94b3364931bb$var$deleteSync
};

});
const $85d01ad7b2541e2c$export$31ecae7225aecec6 = 20;



parcelRegister("1YfAT", function(module, exports) {

$parcel$export(module.exports, "isCurrentSiteSyncEnabledResource", () => $53dacb41f1b977c2$export$94465df791bf80);

var $2M1hQ = parcelRequire("2M1hQ");

var $9d6Ve = parcelRequire("9d6Ve");
const $53dacb41f1b977c2$export$94465df791bf80 = (0, $2M1hQ.createResource)({
    type: 'isCurrentSiteSyncEnabledResource',
    getKey: ()=>`isCurrentSiteSyncEnabledResource`,
    getData: (0, $9d6Ve.getIsCurrentSiteSyncEnabled),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("9d6Ve", function(module, exports) {

$parcel$export(module.exports, "getIsCurrentSiteSyncEnabled", () => $84b302591901e719$export$93fc09e39edf63d0);

var $j74qU = parcelRequire("j74qU");
const $84b302591901e719$export$93fc09e39edf63d0 = ()=>(0, $j74qU.eocFetch)(`/v1/entity-sync/is-current-site-enabled`).then((response)=>response.data.enabled);

});


parcelRegister("7J53H", function(module, exports) {

$parcel$export(module.exports, "getTeamResource", () => $3559e86ca19d1712$export$50271c9e7f21f10e);

var $2M1hQ = parcelRequire("2M1hQ");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $7n8Dv = parcelRequire("7n8Dv");
const $3559e86ca19d1712$export$50271c9e7f21f10e = (0, $2M1hQ.createResource)({
    type: 'getSyncTeamResource',
    getKey: (routerContext)=>`getSyncTeamResource#${routerContext.match.params?.teamId}`,
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $hmVmJ.assert)(!!teamId, new (0, $dH6Pi.AssertionError)('getTeamResource', 'teamId should be set to fetch the team'));
        const result = await (0, $7n8Dv.getTeam)(teamId);
        return result ?? null;
    },
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("7n8Dv", function(module, exports) {

$parcel$export(module.exports, "getTeam", () => $5f911005aed87c97$export$491fe77f22ab2b51);

var $j74qU = parcelRequire("j74qU");
const $5f911005aed87c97$export$491fe77f22ab2b51 = (teamId)=>(0, $j74qU.eocFetch)(`/v1/alerts/responders/names`, {
        method: 'POST',
        body: {
            responders: [
                {
                    id: teamId,
                    type: 'team'
                }
            ]
        }
    }).then((response)=>response.values.filter((responder)=>!responder.deleted).at(0));

});


parcelRegister("eyLtQ", function(module, exports) {

$parcel$export(module.exports, "userAccessRightsResource", () => $85ca4565e2692c52$export$69ddc7cc64ae9a02);

var $2M1hQ = parcelRequire("2M1hQ");

var $3mt67 = parcelRequire("3mt67");
const $85ca4565e2692c52$export$69ddc7cc64ae9a02 = (0, $2M1hQ.createResource)({
    type: 'userAccessRightsResource',
    getKey: ()=>'userAccessRightsResource',
    getData: (routerContext)=>(0, $3mt67.getUserRights)(routerContext.match.params.teamId),
    maxAge: 600000,
    isBrowserOnly: true
});

});
parcelRegister("3mt67", function(module, exports) {

$parcel$export(module.exports, "getUserRights", () => $565f7a833d907135$export$84e2ed279bc4e64e);

var $j74qU = parcelRequire("j74qU");

var $l116g = parcelRequire("l116g");
const $565f7a833d907135$export$84e2ed279bc4e64e = (teamId)=>{
    return (0, $j74qU.eocFetch)((0, $l116g.UrlHelper)(`/v1/entity-sync/unified/rights`, {
        teamId: teamId
    })).then((response)=>response.data.userAccessRights);
};

});



parcelRegister("1GLKn", function(module, exports) {

$parcel$export(module.exports, "eocAlertIssueSyncingCreateRoute", () => $cfb9010ddff8a27d$export$f271eef5f9ec6602);
const $cfb9010ddff8a27d$export$f271eef5f9ec6602 = {
    name: 'eoc-alert-issue-syncing-create',
    path: '/jira/settings/products/ops/syncs/create',
    exact: true
};

});

parcelRegister("hUyS9", function(module, exports) {

$parcel$export(module.exports, "LazyHorizontalOperationsConfigurationNav", () => $3b531790406897bf$export$aea682543f08e131);
$parcel$export(module.exports, "AsyncHorizontalOperationsConfigurationNav", () => $3b531790406897bf$export$1f7a0efe3746ea0d);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $3b531790406897bf$export$aea682543f08e131 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("hS33m")).then(({ HorizontalOperationsConfiguration: HorizontalOperationsConfiguration })=>HorizontalOperationsConfiguration), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/horizontal-nav-operations-configuration/src/ui/index.tsx"
});
const $3b531790406897bf$export$1f7a0efe3746ea0d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jira-operations-configurations-horizontal-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "asyncHorizontalOperationsConfigurationNav",
        packageName: "jiraOperationsConfigurationsHorizontalNav",
        fallback: "flag",
        teamName: "50cent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3b531790406897bf$export$aea682543f08e131, null)));

});
parcelRegister("hS33m", function(module, exports) {

let $d029d9177e9da62e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d029d9177e9da62e$var$load("9MqkJ").then(()=>parcelRequire('8WIBW'));

});


parcelRegister("jh1uq", function(module, exports) {

$parcel$export(module.exports, "AlertIssueSync", () => $7deb342e59ce2af6$export$5a4922ba79d730f4);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $a5NQf = parcelRequire("a5NQf");
const $7deb342e59ce2af6$export$5a4922ba79d730f4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $a5NQf.LazyAlertIssueSync),
        pageId: "async-jira-eoc-alert-issue-syncing",
        shouldShowSpinner: true
    });

});
parcelRegister("a5NQf", function(module, exports) {

$parcel$export(module.exports, "LazyAlertIssueSync", () => $d2634f336818750c$export$dbbcce89c7be1e71);
$parcel$export(module.exports, "LazyAlertIssueSyncCreate", () => $d2634f336818750c$export$ff3e9ed7471eebce);
$parcel$export(module.exports, "LazyAlertIssueSyncDetail", () => $d2634f336818750c$export$75137a2a583918e2);

var $kxZPA = parcelRequire("kxZPA");

const $d2634f336818750c$export$dbbcce89c7be1e71 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("5Esgo")).then((module)=>module.AlertIssueSync), {
    moduleId: "./src/packages/eoc/eoc-alert-issue-syncing/src/index.tsx"
});

const $d2634f336818750c$export$ff3e9ed7471eebce = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("5Esgo")).then((module)=>module.AlertIssueSyncCreate), {
    moduleId: "./src/packages/eoc/eoc-alert-issue-syncing/src/index.tsx"
});

const $d2634f336818750c$export$75137a2a583918e2 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("5Esgo")).then((module)=>module.AlertIssueSyncDetail), {
    moduleId: "./src/packages/eoc/eoc-alert-issue-syncing/src/index.tsx"
});

});
parcelRegister("5Esgo", function(module, exports) {

let $41d69cb5765bc78b$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $41d69cb5765bc78b$var$load("ffQaD"),
    $41d69cb5765bc78b$var$load("kvRbA"),
    $41d69cb5765bc78b$var$load("9WAxB")
]).then(()=>parcelRequire('gAySz'));

});



parcelRegister("3dgEU", function(module, exports) {

$parcel$export(module.exports, "AlertIssueSyncCreate", () => $8b1bb3d27124393c$export$a26f24c49385cf3a);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $a5NQf = parcelRequire("a5NQf");
const $8b1bb3d27124393c$export$a26f24c49385cf3a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $a5NQf.LazyAlertIssueSyncCreate),
        pageId: "async-jira-eoc-alert-issue-syncing",
        shouldShowSpinner: true
    });

});


parcelRegister("8m0RN", function(module, exports) {

$parcel$export(module.exports, "eocAlertIssueSyncingDetailRouteEntry", () => $ea4b5ca423fc7b5e$export$7e604b22ae6e7c1e);

var $6YWw1 = parcelRequire("6YWw1");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $8cx1L = parcelRequire("8cx1L");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

var $jh1uq = parcelRequire("jh1uq");

var $fzxhM = parcelRequire("fzxhM");

var $a5NQf = parcelRequire("a5NQf");
const $ea4b5ca423fc7b5e$var$getNavigationSpecifications = ()=>{
    return ((0, $4R6GH.fg)('operations_nav4_remaining_items_old_navigation_fix') ? (0, $3HwlS.getWillShowNav4)() : true) && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $ea4b5ca423fc7b5e$export$7e604b22ae6e7c1e = (0, $7NszV.createEntry)((0, $8cx1L.eocAlertIssueSyncingDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $jh1uq.AlertIssueSync),
        slot: (0, $fzxhM.AlertIssueSyncDetail),
        basePath: '/jira/settings/products/ops',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $6YWw1.resources).configuredSyncsResource,
            (0, $6YWw1.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$ea4b5ca423fc7b5e$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a5NQf.LazyAlertIssueSync)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a5NQf.LazyAlertIssueSync)
        ]
    }));

});
parcelRegister("8cx1L", function(module, exports) {

$parcel$export(module.exports, "eocAlertIssueSyncingDetailRoute", () => $2a3279be22ec7e63$export$f1b4093ef603b98d);
const $2a3279be22ec7e63$export$f1b4093ef603b98d = {
    name: 'eoc-alert-issue-syncing-detail',
    path: '/jira/settings/products/ops/syncs/:syncId',
    exact: true
};

});

parcelRegister("fzxhM", function(module, exports) {

$parcel$export(module.exports, "AlertIssueSyncDetail", () => $f855872703199c2e$export$c21f2a7e1aa801a7);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $a5NQf = parcelRequire("a5NQf");
const $f855872703199c2e$export$c21f2a7e1aa801a7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $a5NQf.LazyAlertIssueSyncDetail),
        pageId: "async-jira-eoc-alert-issue-syncing",
        shouldShowSpinner: true
    });

});


parcelRegister("dt3ZS", function(module, exports) {

$parcel$export(module.exports, "eocAlertIssueSyncingRouteEntry", () => $4abc338af93c95e0$export$c63d0942ec0f93c);

var $6YWw1 = parcelRequire("6YWw1");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $eZXFU = parcelRequire("eZXFU");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $hIYBE = parcelRequire("hIYBE");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

var $a5NQf = parcelRequire("a5NQf");

var $jh1uq = parcelRequire("jh1uq");
const $4abc338af93c95e0$var$getNavigationSpecifications = ()=>{
    return ((0, $4R6GH.fg)('operations_nav4_remaining_items_old_navigation_fix') ? (0, $3HwlS.getWillShowNav4)() : true) && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $4abc338af93c95e0$export$c63d0942ec0f93c = (0, $7NszV.createEntry)((0, $hIYBE.eocAlertIssueSyncingRoute), ()=>({
        group: 'eoc',
        component: (0, $jh1uq.AlertIssueSync),
        slot: null,
        basePath: '/jira/settings/products/ops',
        layout: (0, $eZXFU.opsSettingsLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $6YWw1.resources).configuredSyncsResource,
            (0, $6YWw1.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$4abc338af93c95e0$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a5NQf.LazyAlertIssueSync)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a5NQf.LazyAlertIssueSync)
        ]
    }));

});
parcelRegister("eZXFU", function(module, exports) {

$parcel$export(module.exports, "opsSettingsLayout", () => $bb0ecde8d2515afe$export$96d5e7da242cacf9);
$parcel$export(module.exports, "opsMigrationHubLayout", () => $bb0ecde8d2515afe$export$d4e92309ebd00b0f);
$parcel$export(module.exports, "opsNotificationsLayout", () => $bb0ecde8d2515afe$export$5714bc9520dbc6cf);

var $aPfsS = parcelRequire("aPfsS");

var $kxZPA = parcelRequire("kxZPA");

var $cSD7y = parcelRequire("cSD7y");

var $ibkIl = parcelRequire("ibkIl");

var $2BrOV = parcelRequire("2BrOV");

const $bb0ecde8d2515afe$export$f61c80ac3b95bc7d = (0, $cSD7y.componentWithFG)('operations-migration-hub-jira', // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("civVw")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/ops-settings-layout/src/ui/right-sidebars/index.tsx"
}), ()=>null);
$bb0ecde8d2515afe$export$f61c80ac3b95bc7d.displayName = 'RightSidebars';

const $bb0ecde8d2515afe$export$70238cd3868b67c9 = (0, $cSD7y.componentWithFG)('operations-migration-hub-jira', // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("dgrxE")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/ops-settings-layout/src/ui/onboarding/index.tsx"
}), ()=>null);
$bb0ecde8d2515afe$export$70238cd3868b67c9.displayName = 'Onboarding';
const $bb0ecde8d2515afe$export$96d5e7da242cacf9 = (0, $aPfsS.composeLayouts)((0, $ibkIl.globalSettingsLayout), {
    get globalComponents () {
        return [
            $bb0ecde8d2515afe$export$70238cd3868b67c9
        ];
    },
    rightSidebars: [
        $bb0ecde8d2515afe$export$f61c80ac3b95bc7d
    ]
});
const $bb0ecde8d2515afe$export$d4e92309ebd00b0f = (0, $aPfsS.createLayout)({
    get globalComponents () {
        return [
            $bb0ecde8d2515afe$export$70238cd3868b67c9
        ];
    },
    rightSidebars: [
        $bb0ecde8d2515afe$export$f61c80ac3b95bc7d
    ]
});
const $bb0ecde8d2515afe$export$5714bc9520dbc6cf = (0, $aPfsS.composeLayouts)((0, $2BrOV.globalLayout), {
    get globalComponents () {
        return [
            $bb0ecde8d2515afe$export$70238cd3868b67c9
        ];
    },
    rightSidebars: [
        $bb0ecde8d2515afe$export$f61c80ac3b95bc7d
    ]
});

});

parcelRegister("hIYBE", function(module, exports) {

$parcel$export(module.exports, "eocAlertIssueSyncingRoute", () => $8f63b88635f620d8$export$73d6a0dc298aae15);
const $8f63b88635f620d8$export$73d6a0dc298aae15 = {
    name: 'eoc-alert-issue-syncing',
    path: '/jira/settings/products/ops/syncs',
    exact: true
};

});


parcelRegister("i27Sx", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertIssueSyncingCreateRouteEntry", () => $529c88752df4ac9c$export$8c07dc381591dc69);

var $6YWw1 = parcelRequire("6YWw1");

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $4rSQD = parcelRequire("4rSQD");

var $jh1uq = parcelRequire("jh1uq");

var $3dgEU = parcelRequire("3dgEU");

var $a5NQf = parcelRequire("a5NQf");
const $529c88752df4ac9c$export$8c07dc381591dc69 = (0, $7NszV.createEntry)((0, $4rSQD.eocTeamAlertIssueSyncingCreateRoute), ()=>({
        group: 'eoc',
        component: (0, $jh1uq.AlertIssueSync),
        layout: (0, $h3Ix2.opsTeamLayout),
        slot: (0, $3dgEU.AlertIssueSyncCreate),
        basePath: '/jira/ops/teams',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $2r8fH.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $6YWw1.resources).configuredSyncsResource,
            (0, $6YWw1.resources).userAccessRightsResource,
            (0, $6YWw1.resources).getTeamResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a5NQf.LazyAlertIssueSync),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("2r8fH", function(module, exports) {

$parcel$export(module.exports, "teamResource", () => $77662e91dfb33ae6$export$87453d709b90ccdf);
$parcel$export(module.exports, "sidebarRightsResource", () => $77662e91dfb33ae6$export$3b3b9a5b0eddde66);
$parcel$export(module.exports, "resources", () => $77662e91dfb33ae6$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $5iPTg = parcelRequire("5iPTg");
const $77662e91dfb33ae6$export$87453d709b90ccdf = (0, $2M1hQ.createResource)({
    type: 'teamResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `team-dashboard/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $hmVmJ.assert)(!!teamId, new (0, $dH6Pi.AssertionError)('teamSidebarResource', 'teamId should be set to fetch team-dashboard'));
        return (0, $5iPTg.getTeamByIdEndpoint)(teamId).catch((e)=>{
            e.skipSentry = true;
            throw e;
        });
    },
    maxAge: 300000,
    isBrowserOnly: true
});
const $77662e91dfb33ae6$export$3b3b9a5b0eddde66 = (0, $2M1hQ.createResource)({
    type: 'sidebarRightsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `team-dashboard/${teamId ?? ''}/sidebar-rights`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $hmVmJ.assert)(!!teamId, new (0, $dH6Pi.AssertionError)('teamSidebarResource', 'teamId should be set to fetch sidebar rights'));
        return (0, $5iPTg.getSidebarRightsEndpoint)(teamId).catch((e)=>{
            e.skipSentry = true;
            throw e;
        });
    },
    isBrowserOnly: true,
    maxAge: Infinity
});
const $77662e91dfb33ae6$export$bc99aaabaf7b70a7 = ()=>[
        $77662e91dfb33ae6$export$87453d709b90ccdf,
        $77662e91dfb33ae6$export$3b3b9a5b0eddde66
    ];

});
parcelRegister("5iPTg", function(module, exports) {

$parcel$export(module.exports, "getTeamByIdEndpoint", () => $03a26ab2fa346c2e$export$bcb25b347f39b3f3);
$parcel$export(module.exports, "getSidebarRightsEndpoint", () => $03a26ab2fa346c2e$export$6f1f62156c62eb91);

var $j74qU = parcelRequire("j74qU");
const $03a26ab2fa346c2e$export$bcb25b347f39b3f3 = (teamId)=>(0, $j74qU.eocFetch)(`/v1/teams/${teamId}?includeImageUrls=true`);
const $03a26ab2fa346c2e$export$6f1f62156c62eb91 = (teamId)=>{
    return (0, $j74qU.eocFetch)(`/v1/teams/${teamId}/menu-rights`);
};

});


parcelRegister("3Dk1Z", function(module, exports) {

$parcel$export(module.exports, "LazyTeamDashboardSidebar", () => $d15151561c6a9349$export$a1b7c53ff39475a6);
$parcel$export(module.exports, "default", () => $d15151561c6a9349$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

const $d15151561c6a9349$export$a1b7c53ff39475a6 = (0, $kxZPA.lazyForPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("f6Yqt")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/eoc-team-dashboard/src/index.tsx"
});
const $d15151561c6a9349$var$TeamDashboardSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "eocTeamDashboard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d15151561c6a9349$export$a1b7c53ff39475a6, null));
$d15151561c6a9349$var$TeamDashboardSidebar.displayName = 'TeamDashboardSidebar';
var $d15151561c6a9349$export$2e2bcd8739ae039 = $d15151561c6a9349$var$TeamDashboardSidebar;

});
parcelRegister("f6Yqt", function(module, exports) {

let $b00649e58234d29a$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $b00649e58234d29a$var$load("ffQaD"),
    $b00649e58234d29a$var$load("kvRbA"),
    $b00649e58234d29a$var$load("jMJzP")
]).then(()=>parcelRequire('hMnGK'));

});


parcelRegister("bh0Pj", function(module, exports) {

$parcel$export(module.exports, "LazyHorizontalOperationsNav", () => $79488f04c14a3737$export$409c821653bbc63b);
$parcel$export(module.exports, "LazyHorizontalOperationsOverviewNav", () => $79488f04c14a3737$export$82108adf6887e32e);
$parcel$export(module.exports, "AsyncHorizontalOperationsNav", () => $79488f04c14a3737$export$1eb785f071697cc5);
$parcel$export(module.exports, "AsyncHorizontalOperationsOverviewNav", () => $79488f04c14a3737$export$27e50c09ebb514f);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $79488f04c14a3737$export$409c821653bbc63b = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("7pzgA")).then(({ HorizontalOperationsNav: HorizontalOperationsNav })=>HorizontalOperationsNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/horizontal-nav-operations/src/ui/index.tsx"
});

const $79488f04c14a3737$export$82108adf6887e32e = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("7pzgA")).then(({ OverviewNav: OverviewNav })=>OverviewNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/horizontal-nav-operations/src/ui/index.tsx"
});
const $79488f04c14a3737$export$1eb785f071697cc5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-operations-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "asyncHorizontalOperationsNav",
        packageName: "jiraOperationsHorizontalNav",
        fallback: "flag",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($79488f04c14a3737$export$409c821653bbc63b, null)));
const $79488f04c14a3737$export$27e50c09ebb514f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-operations-overview-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "asyncHorizontalOperationsOverviewNav",
        packageName: "jiraOperationsHorizontalNav",
        fallback: "flag",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($79488f04c14a3737$export$82108adf6887e32e, null)));

});
parcelRegister("7pzgA", function(module, exports) {

let $5656396291d2cf5a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5656396291d2cf5a$var$load("fkutI").then(()=>parcelRequire('kQ8Dl'));

});


parcelRegister("h3Ix2", function(module, exports) {

$parcel$export(module.exports, "opsTeamLayout", () => $687f5bad65d17575$export$53dd27149810df73);

var $aPfsS = parcelRequire("aPfsS");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $687f5bad65d17575$var$RightSidebars = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("bZQnm")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/ops-team-layout/src/ui/right-sidebars/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $687f5bad65d17575$var$Onboarding = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("lIfla")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/ops-team-layout/src/ui/onboarding/index.tsx"
});
const $687f5bad65d17575$export$53dd27149810df73 = (0, $aPfsS.createLayout)({
    get globalComponents () {
        return [
            $687f5bad65d17575$var$Onboarding
        ];
    },
    rightSidebars: [
        $687f5bad65d17575$var$RightSidebars
    ]
});

});
parcelRegister("bZQnm", function(module, exports) {

let $8bbe04f4a42e0584$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8bbe04f4a42e0584$var$load("9CYYI").then(()=>parcelRequire('c3FF8'));

});

parcelRegister("lIfla", function(module, exports) {

let $fce99b55901c06fa$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fce99b55901c06fa$var$load("1Ol4g").then(()=>parcelRequire('dSHkM'));

});


parcelRegister("4rSQD", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertIssueSyncingCreateRoute", () => $daedb7d5520453e5$export$915ef1948fe4650a);
const $daedb7d5520453e5$export$915ef1948fe4650a = {
    name: 'eoc-team-alert-issue-syncing-create',
    path: '/jira/ops/teams/:teamId/syncs/create',
    exact: true
};

});


parcelRegister("qjJTn", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertIssueSyncingDetailRouteEntry", () => $a162d438dc34f2e2$export$6298ff494c460e75);

var $6YWw1 = parcelRequire("6YWw1");

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $6DLNJ = parcelRequire("6DLNJ");

var $fzxhM = parcelRequire("fzxhM");

var $jh1uq = parcelRequire("jh1uq");

var $a5NQf = parcelRequire("a5NQf");
const $a162d438dc34f2e2$export$6298ff494c460e75 = (0, $7NszV.createEntry)((0, $6DLNJ.eocTeamAlertIssueSyncingDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $jh1uq.AlertIssueSync),
        layout: (0, $h3Ix2.opsTeamLayout),
        slot: (0, $fzxhM.AlertIssueSyncDetail),
        basePath: '/jira/ops/teams',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $2r8fH.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $6YWw1.resources).configuredSyncsResource,
            (0, $6YWw1.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a5NQf.LazyAlertIssueSync),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("6DLNJ", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertIssueSyncingDetailRoute", () => $19f7daafdc2ca993$export$e91535fc2137c3b);
const $19f7daafdc2ca993$export$e91535fc2137c3b = {
    name: 'eoc-team-alert-issue-syncing-detail',
    path: '/jira/ops/teams/:teamId/syncs/:syncId',
    exact: true
};

});


parcelRegister("5xt55", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertIssueSyncingRouteEntry", () => $4357b8f4ed10df63$export$be342a3401146aae);

var $6YWw1 = parcelRequire("6YWw1");

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $f8agQ = parcelRequire("f8agQ");

var $jh1uq = parcelRequire("jh1uq");

var $a5NQf = parcelRequire("a5NQf");
const $4357b8f4ed10df63$export$be342a3401146aae = (0, $7NszV.createEntry)((0, $f8agQ.eocTeamAlertIssueSyncingRoute), ()=>({
        group: 'eoc',
        component: (0, $jh1uq.AlertIssueSync),
        layout: (0, $h3Ix2.opsTeamLayout),
        slot: null,
        basePath: '/jira/ops/teams',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $2r8fH.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $6YWw1.resources).configuredSyncsResource,
            (0, $6YWw1.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $a5NQf.LazyAlertIssueSync),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("f8agQ", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertIssueSyncingRoute", () => $4b9c202f143c618b$export$37ea7624561cbb89);
const $4b9c202f143c618b$export$37ea7624561cbb89 = {
    name: 'eoc-team-alert-issue-syncing',
    path: '/jira/ops/teams/:teamId/syncs',
    exact: true
};

});


parcelRegister("GJOha", function(module, exports) {

$parcel$export(module.exports, "eocApiKeyManagementRouteEntry", () => $e19c93c774607b0f$export$e18a6be3d2ffad71);

var $2T8SP = parcelRequire("2T8SP");

var $ffza4 = parcelRequire("ffza4");

var $eZXFU = parcelRequire("eZXFU");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $eum5y = parcelRequire("eum5y");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $7s8Fa = parcelRequire("7s8Fa");

var $gZxlv = parcelRequire("gZxlv");
const $e19c93c774607b0f$var$getNavigationSpecifications = ()=>{
    return (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('operations_nav4_remaining_items_api_key_management') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $e19c93c774607b0f$export$e18a6be3d2ffad71 = (0, $7NszV.createEntry)((0, $eum5y.eocApiKeyManagementRoute), ()=>({
        group: 'eoc',
        component: (0, $gZxlv.default),
        layout: (0, $eZXFU.opsSettingsLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$e19c93c774607b0f$var$getNavigationSpecifications()
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $2T8SP.resources)()
        ],
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items_api_key_management') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gZxlv.LazyApiKeyManagement)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gZxlv.LazyApiKeyManagement)
        ]
    }));

});
parcelRegister("2T8SP", function(module, exports) {

$parcel$export(module.exports, "apiKeysResource", () => $78235b6a5aa26e7e$export$a98d5421eda11f29);
$parcel$export(module.exports, "resources", () => $78235b6a5aa26e7e$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");
parcelRequire("jxRF2");
var $ldKOT = parcelRequire("ldKOT");

var $3do1I = parcelRequire("3do1I");
const $78235b6a5aa26e7e$export$a98d5421eda11f29 = (0, $2M1hQ.createResource)({
    type: 'api-key-management',
    getKey: ()=>'api-key-management',
    getData: async ({ dependencies: dependencies })=>{
        const data = await dependencies[(0, $ldKOT.eocUserResource).type]?.promise;
        return (0, $3do1I.fetchKeys)(data.accountId);
    },
    isBrowserOnly: true,
    maxCache: 0,
    maxAge: 0,
    depends: [
        (0, $ldKOT.eocUserResource).type
    ]
});
const $78235b6a5aa26e7e$export$bc99aaabaf7b70a7 = ()=>[
        (0, $ldKOT.eocUserResource),
        $78235b6a5aa26e7e$export$a98d5421eda11f29
    ];

});
parcelRegister("jxRF2", function(module, exports) {

$parcel$export(module.exports, "eocCommonResources", () => $9675469e92ce170a$export$8977bbbf2f7167d2);
$parcel$export(module.exports, "eocUserResource", () => (parcelRequire("ldKOT")).eocUserResource);

var $ldKOT = parcelRequire("ldKOT");
const $9675469e92ce170a$export$8977bbbf2f7167d2 = ()=>[
        (0, $ldKOT.eocUserResource)
    ];

});
parcelRegister("ldKOT", function(module, exports) {

$parcel$export(module.exports, "eocUserResource", () => $0e22e6fd8475b5e0$export$3a08a0bdeef86956);

var $2M1hQ = parcelRequire("2M1hQ");

var $jonVZ = parcelRequire("jonVZ");
const $0e22e6fd8475b5e0$export$3a08a0bdeef86956 = (0, $2M1hQ.createResource)({
    type: 'create-user-resource',
    getKey: ()=>'create-user-resource',
    getData: async ()=>(0, $jonVZ.fetchJsmUserInfo)(),
    maxAge: Infinity,
    isBrowserOnly: true
});

});
parcelRegister("jonVZ", function(module, exports) {

$parcel$export(module.exports, "fetchJsmUserInfo", () => $189024051479d227$export$7d750310098b5a7);

var $j74qU = parcelRequire("j74qU");
var $030R0 = parcelRequire("030R0");
const $189024051479d227$var$JSM_BASE_URL = '/rest/api/3/myself';
const $189024051479d227$export$7d750310098b5a7 = ()=>{
    return (0, $j74qU.eocFetch)($189024051479d227$var$JSM_BASE_URL, {
        exactUrl: true,
        errorTransformer: (0, $030R0.jsmErrorTransformer)
    });
};

});



parcelRegister("3do1I", function(module, exports) {

$parcel$export(module.exports, "fetchKeys", () => $064b2b209b19aeee$export$a0d93e1b78b8e70b);
$parcel$export(module.exports, "deleteApiKey", () => $064b2b209b19aeee$export$d2f8649a375a4113);

var $j74qU = parcelRequire("j74qU");
const $064b2b209b19aeee$export$a0d93e1b78b8e70b = async (accountId)=>{
    return (0, $j74qU.eocFetch)('/api-keys/web?accountId=' + accountId);
};
const $064b2b209b19aeee$export$d2f8649a375a4113 = async (key, accountId)=>{
    return (0, $j74qU.eocFetch)(`/api-keys/web?apiKey=${key}&accountId=${accountId}`, {
        method: 'DELETE'
    });
};

});


parcelRegister("eum5y", function(module, exports) {

$parcel$export(module.exports, "eocApiKeyManagementRoute", () => $3dba976dd77ba6a7$export$84985159d5695f4d);
const $3dba976dd77ba6a7$export$84985159d5695f4d = {
    name: 'eoc-api-key-management',
    path: '/jira/settings/products/ops/api-key-management',
    exact: true
};

});

parcelRegister("gZxlv", function(module, exports) {

$parcel$export(module.exports, "LazyApiKeyManagement", () => $eddc6a8c98318a70$export$6ae4b26c31b1b0d2);
$parcel$export(module.exports, "default", () => $eddc6a8c98318a70$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $eddc6a8c98318a70$export$6ae4b26c31b1b0d2 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("aA2bD")), {
    moduleId: "./src/packages/eoc/api-key-management/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$eddc6a8c98318a70$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $eddc6a8c98318a70$export$6ae4b26c31b1b0d2,
        pageId: "async-jira-eoc-api-key-management",
        shouldShowSpinner: false
    });

});
parcelRegister("aA2bD", function(module, exports) {

let $7b3ef66142419a7e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7b3ef66142419a7e$var$load("lueQq").then(()=>parcelRequire('95iLR'));

});



parcelRegister("hDU7Y", function(module, exports) {

$parcel$export(module.exports, "eocAssignCustomRolesRouteEntry", () => $34e2a1a3b5a525df$export$c51a4ee3e3f1b270);

var $jqlWU = parcelRequire("jqlWU");

var $ffza4 = parcelRequire("ffza4");

var $eZXFU = parcelRequire("eZXFU");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $2ClIR = parcelRequire("2ClIR");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

var $9Zb2K = parcelRequire("9Zb2K");
const $34e2a1a3b5a525df$var$getNavigationSpecifications = ()=>{
    return ((0, $4R6GH.fg)('operations_nav4_remaining_items_old_navigation_fix') ? (0, $3HwlS.getWillShowNav4)() : true) && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $34e2a1a3b5a525df$export$c51a4ee3e3f1b270 = (0, $7NszV.createEntry)((0, $2ClIR.eocAssignCustomRolesRoute), ()=>({
        group: 'eoc',
        component: (0, $9Zb2K.default),
        layout: (0, $eZXFU.opsSettingsLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$34e2a1a3b5a525df$var$getNavigationSpecifications()
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $jqlWU.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $9Zb2K.LazyAssignCustomRoles)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $9Zb2K.LazyAssignCustomRoles)
        ]
    }));

});
parcelRegister("jqlWU", function(module, exports) {

$parcel$export(module.exports, "rolesResource", () => $662177b4cdfd6303$export$52e29d5915d5f674);
$parcel$export(module.exports, "resources", () => $662177b4cdfd6303$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $c4XwU = parcelRequire("c4XwU");
const $662177b4cdfd6303$export$52e29d5915d5f674 = (0, $2M1hQ.createResource)({
    type: 'rolesResource',
    getKey: ()=>'rolesResource',
    getData: (0, $c4XwU.getRolesEndpoint),
    isBrowserOnly: true
});
const $662177b4cdfd6303$export$bc99aaabaf7b70a7 = ()=>[
        $662177b4cdfd6303$export$52e29d5915d5f674
    ];

});
parcelRegister("c4XwU", function(module, exports) {

$parcel$export(module.exports, "getUsersEndpoint", () => $3d7f15d2403fdf59$export$d372f7d69e481dba);
$parcel$export(module.exports, "getFilteredUsersEndpoint", () => $3d7f15d2403fdf59$export$d8f86d9603f031c0);
$parcel$export(module.exports, "getRolesEndpoint", () => $3d7f15d2403fdf59$export$7d0bc1a3c689fc74);
$parcel$export(module.exports, "updateRoleOfUserEndpoint", () => $3d7f15d2403fdf59$export$a0b296dc0259976f);

var $j74qU = parcelRequire("j74qU");

var $3m952 = parcelRequire("3m952");
const $3d7f15d2403fdf59$export$d372f7d69e481dba = ({ lastEvaluatedToken: lastEvaluatedToken, limit: limit, queryKey: queryKey })=>{
    const [_, query] = queryKey;
    let url = new (0, $3m952.URLBuilder)(`/v1/users/search`).withQueryParam('limit', limit).withQueryParam('query', query).withQueryParam('cursor', lastEvaluatedToken).build();
    return (0, $j74qU.eocFetch)(url);
};
const $3d7f15d2403fdf59$export$d8f86d9603f031c0 = ({ lastEvaluatedToken: lastEvaluatedToken, limit: limit, queryKey: queryKey })=>{
    const [_, ...filters] = queryKey;
    if (filters.length === 0) return Promise.resolve({
        lastEvaluatedToken: '',
        values: []
    });
    return (0, $j74qU.eocFetch)('/v1/users/roles/filter', {
        method: 'POST',
        body: {
            limit: limit,
            roles: filters,
            offset: lastEvaluatedToken || 0
        }
    });
};
const $3d7f15d2403fdf59$export$7d0bc1a3c689fc74 = ()=>{
    return (0, $j74qU.eocFetch)('/v1/users/roles');
};
const $3d7f15d2403fdf59$export$a0b296dc0259976f = ({ roleId: roleId, accountId: accountId })=>{
    return (0, $j74qU.eocFetch)(`/v1/users/roles/assign`, {
        method: 'PATCH',
        body: {
            accountId: accountId,
            roleId: roleId
        }
    });
};

});
parcelRegister("3m952", function(module, exports) {

$parcel$export(module.exports, "URLBuilder", () => $3c9748f3251c69d7$export$61d2e8db329a11f8);
class $3c9748f3251c69d7$export$61d2e8db329a11f8 {
    constructor(url){
        this.url = url;
        this.params = {};
    }
    withQueryParam(key, value) {
        this.params[key] = value;
        return this;
    }
    build() {
        const filteredParams = Object.entries(this.params).filter(([, value])=>value !== undefined && value !== null && value !== '').map(([key, value])=>[
                key,
                value && value.toString()
            ]);
        const queryInstance = new URLSearchParams(filteredParams);
        const queryParams = queryInstance.toString();
        if (queryParams === '') return `${this.url}`;
        if (queryParams) return `${this.url}?${queryParams}`;
        return this.url;
    }
}

});



parcelRegister("2ClIR", function(module, exports) {

$parcel$export(module.exports, "eocAssignCustomRolesRoute", () => $fee4692ea74fc971$export$79c37191a61ac94b);
const $fee4692ea74fc971$export$79c37191a61ac94b = {
    name: 'eoc-assign-custom-roles',
    path: '/jira/settings/products/ops/role-assignment',
    exact: true
};

});

parcelRegister("9Zb2K", function(module, exports) {

$parcel$export(module.exports, "LazyAssignCustomRoles", () => $cbc95c821be59e53$export$fb6bafef9453a357);
$parcel$export(module.exports, "default", () => $cbc95c821be59e53$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $cbc95c821be59e53$export$fb6bafef9453a357 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("iXql0")), {
    moduleId: "./src/packages/eoc/assign-custom-roles/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cbc95c821be59e53$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cbc95c821be59e53$export$fb6bafef9453a357,
        pageId: "async-eoc-assign-custom-roles",
        shouldShowSpinner: false
    });

});
parcelRegister("iXql0", function(module, exports) {

let $dcd22ad258b9a946$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dcd22ad258b9a946$var$load("4gFRu").then(()=>parcelRequire('i3AK8'));

});



parcelRegister("dHqTd", function(module, exports) {

$parcel$export(module.exports, "eocAutomationsRouteEntry", () => $dd0ff3cccea414a4$export$6ff606556e19e12);

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $cIZ9i = parcelRequire("cIZ9i");

var $12Bno = parcelRequire("12Bno");
const $dd0ff3cccea414a4$export$6ff606556e19e12 = (0, $7NszV.createEntry)((0, $cIZ9i.eocAutomationsRoute), ()=>({
        group: 'eoc',
        component: (0, $12Bno.default),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $2r8fH.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $12Bno.LazyOpsTeamAutomation),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("cIZ9i", function(module, exports) {

$parcel$export(module.exports, "eocAutomationsRoute", () => $0aa16b205f7e3033$export$4a84eb4d8d37c9d4);
const $0aa16b205f7e3033$export$4a84eb4d8d37c9d4 = {
    name: 'eoc-automations',
    path: '/jira/ops/teams/:teamId/automations',
    exact: true
};

});

parcelRegister("12Bno", function(module, exports) {

$parcel$export(module.exports, "LazyOpsTeamAutomation", () => $1cf116b0539aa5be$export$903a0a44cc0933c5);
$parcel$export(module.exports, "default", () => $1cf116b0539aa5be$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $1cf116b0539aa5be$export$903a0a44cc0933c5 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("dYPlk")), {
    moduleId: "./src/packages/spa-apps/ops-team-scope-automation/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1cf116b0539aa5be$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $1cf116b0539aa5be$export$903a0a44cc0933c5,
        pageId: "ops-team-automation",
        shouldShowSpinner: true
    });

});
parcelRegister("dYPlk", function(module, exports) {

let $a2d8b49cc094aa76$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a2d8b49cc094aa76$var$load("as200").then(()=>parcelRequire('j6Qxa'));

});



parcelRegister("9KhdI", function(module, exports) {

$parcel$export(module.exports, "eocCustomRolesRouteEntry", () => $98b5efb8026932b2$export$9c9bab95d425eb6f);

var $7ygGB = parcelRequire("7ygGB");

var $ffza4 = parcelRequire("ffza4");

var $eZXFU = parcelRequire("eZXFU");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $7WUUX = parcelRequire("7WUUX");

var $4R6GH = parcelRequire("4R6GH");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

var $7vwGd = parcelRequire("7vwGd");
const $98b5efb8026932b2$var$getNavigationSpecifications = ()=>{
    return ((0, $4R6GH.fg)('operations_nav4_remaining_items_old_navigation_fix') ? (0, $3HwlS.getWillShowNav4)() : true) && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $98b5efb8026932b2$export$9c9bab95d425eb6f = (0, $7NszV.createEntry)((0, $7WUUX.eocCustomRolesRoute), ()=>({
        group: 'eoc',
        component: (0, $7vwGd.default),
        layout: (0, $eZXFU.opsSettingsLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$98b5efb8026932b2$var$getNavigationSpecifications()
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $7ygGB.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7vwGd.LazyCustomRoles)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7vwGd.LazyCustomRoles)
        ]
    }));

});
parcelRegister("7ygGB", function(module, exports) {

$parcel$export(module.exports, "customRolesResource", () => $010682625a4b0c54$export$7140716a1b1b8e7a);
$parcel$export(module.exports, "resources", () => $010682625a4b0c54$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $hnjQD = parcelRequire("hnjQD");
const $010682625a4b0c54$export$7140716a1b1b8e7a = (0, $2M1hQ.createResource)({
    type: 'rolesResource',
    getKey: ()=>'rolesResource',
    getData: (0, $hnjQD.getCustomRolesListEndpoint),
    isBrowserOnly: true
});
const $010682625a4b0c54$export$bc99aaabaf7b70a7 = ()=>[
        $010682625a4b0c54$export$7140716a1b1b8e7a
    ];

});
parcelRegister("hnjQD", function(module, exports) {

$parcel$export(module.exports, "getPermissionsEndpoint", () => $32ca3dc706b725ff$export$f97b589720c51ce1);
$parcel$export(module.exports, "createCustomRoleEndpoint", () => $32ca3dc706b725ff$export$5a7187e04c844900);
$parcel$export(module.exports, "editCustomRoleEndpoint", () => $32ca3dc706b725ff$export$304735a80b86192e);
$parcel$export(module.exports, "deleteCustomRoleEndpoint", () => $32ca3dc706b725ff$export$e12995ccad013f65);
$parcel$export(module.exports, "getCustomRolesListEndpoint", () => $32ca3dc706b725ff$export$3619edac53aa59fd);

var $j74qU = parcelRequire("j74qU");
const $32ca3dc706b725ff$export$f97b589720c51ce1 = ()=>(0, $j74qU.eocFetch)(`/v1/users/permissions`);
const $32ca3dc706b725ff$export$5a7187e04c844900 = (newCustomRole)=>(0, $j74qU.eocFetch)(`/v1/users/roles`, {
        method: 'POST',
        body: newCustomRole
    });
const $32ca3dc706b725ff$export$304735a80b86192e = (updatedCustomRole)=>{
    const { id: id } = updatedCustomRole;
    return (0, $j74qU.eocFetch)(`/v1/users/roles/${id}`, {
        method: 'PATCH',
        body: updatedCustomRole
    });
};
const $32ca3dc706b725ff$export$e12995ccad013f65 = (id)=>{
    return (0, $j74qU.eocFetch)(`/v1/users/roles/${id}`, {
        method: 'DELETE'
    });
};
const $32ca3dc706b725ff$export$3619edac53aa59fd = ()=>(0, $j74qU.eocFetch)(`/v1/users/roles`);

});


parcelRegister("7WUUX", function(module, exports) {

$parcel$export(module.exports, "eocCustomRolesRoute", () => $550a6202cdc3f9f3$export$3213a7325ca9911);
const $550a6202cdc3f9f3$export$3213a7325ca9911 = {
    name: 'eoc-custom-roles',
    path: '/jira/settings/products/ops/roles',
    exact: true
};

});

parcelRegister("7vwGd", function(module, exports) {

$parcel$export(module.exports, "LazyCustomRoles", () => $ae4b2d4dc59e70bc$export$78ed54710f55f948);
$parcel$export(module.exports, "default", () => $ae4b2d4dc59e70bc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $ae4b2d4dc59e70bc$export$78ed54710f55f948 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("HcDqV")), {
    moduleId: "./src/packages/eoc/custom-roles/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ae4b2d4dc59e70bc$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ae4b2d4dc59e70bc$export$78ed54710f55f948,
        pageId: "async-eoc-custom-roles",
        shouldShowSpinner: false
    });

});
parcelRegister("HcDqV", function(module, exports) {

let $081dd151b7d5390b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $081dd151b7d5390b$var$load("hxcwJ").then(()=>parcelRequire('WACar'));

});



parcelRegister("7LUIt", function(module, exports) {

$parcel$export(module.exports, "eocGlobalAlertListRouteEntry", () => $0edb022327e9a2a9$export$851a659e50436cff);

var $8C32n = parcelRequire("8C32n");

var $ffza4 = parcelRequire("ffza4");

var $iqZds = parcelRequire("iqZds");

var $lmyls = parcelRequire("lmyls");

var $gLQQv = parcelRequire("gLQQv");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $lUaB2 = parcelRequire("lUaB2");

var $lFFGs = parcelRequire("lFFGs");
const $0edb022327e9a2a9$export$851a659e50436cff = (0, $7NszV.createEntry)((0, $lUaB2.eocGlobalAlertListRoute), ()=>({
        group: 'eoc',
        component: (0, $lFFGs.AlertListComponent),
        layout: (0, $iqZds.eocChangeboardingLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $8C32n.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).HOME,
            sidebar: (0, $gLQQv.AsyncSidebarEocGlobalAlerts)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $lFFGs.LazyAlertList),
            (0, $gLQQv.LazyGlobalAlertsSidebar)
        ]
    }));

});
parcelRegister("8C32n", function(module, exports) {

$parcel$export(module.exports, "resources", () => $400eb496bca9e6a6$export$bc99aaabaf7b70a7);

var $dsMLc = parcelRequire("dsMLc");

var $jxRF2 = parcelRequire("jxRF2");

var $gQ8M0 = parcelRequire("gQ8M0");

var $oacWJ = parcelRequire("oacWJ");

var $dqLIo = parcelRequire("dqLIo");
const $400eb496bca9e6a6$export$bc99aaabaf7b70a7 = ()=>[
        (0, $dqLIo.uiPreferencesResource),
        (0, $oacWJ.savedSearchesResource),
        (0, $gQ8M0.compressionRatioResource),
        (0, $dsMLc.alertGroupingStateResource),
        ...(0, $jxRF2.eocCommonResources)()
    ];

});
parcelRegister("dsMLc", function(module, exports) {

$parcel$export(module.exports, "alertGroupingStateResource", () => $8d54a3aea4bd3982$export$722cc8285202ce44);

var $2M1hQ = parcelRequire("2M1hQ");

var $chLms = parcelRequire("chLms");
const $8d54a3aea4bd3982$var$emptyAlertGroupingState = {
    isEnabled: false,
    reason: null
};
const $8d54a3aea4bd3982$export$722cc8285202ce44 = (0, $2M1hQ.createResource)({
    type: 'alertGroupingStateResource',
    getKey: ()=>'alertGroupingStateResource',
    getData: async ()=>{
        try {
            const response = await (0, $chLms.getGroupFeatureStatus)();
            return response;
        } catch (e) {
            // Exception handling and to return emptyState
            return $8d54a3aea4bd3982$var$emptyAlertGroupingState;
        }
    },
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("chLms", function(module, exports) {

$parcel$export(module.exports, "getGroupFeatureStatus", () => $b2722648a50141bc$export$48deee62d9dfb365);

var $R6fxx = parcelRequire("R6fxx");

var $1Dhlz = parcelRequire("1Dhlz");

var $j74qU = parcelRequire("j74qU");
const $b2722648a50141bc$export$48deee62d9dfb365 = ()=>{
    const url = new (0, $1Dhlz.URLBuilder)((0, $R6fxx.withAIOpsDomainPrefix)('/v1/aiops/feature-state')).withQueryParam('featureName', 'alert-grouping').build();
    return (0, $j74qU.eocFetch)(url, {
        exactUrl: true
    });
};

});
parcelRegister("R6fxx", function(module, exports) {

$parcel$export(module.exports, "withAIOpsDomainPrefix", () => $4f10eb10adc69486$export$81c70e0016508593);

var $030R0 = parcelRequire("030R0");
const $4f10eb10adc69486$export$81c70e0016508593 = (input)=>{
    const cloudId = (0, $030R0.getMeta)('ajs-cloud-id');
    if (cloudId) return `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input;
    return input;
};

});

parcelRegister("1Dhlz", function(module, exports) {

$parcel$export(module.exports, "URLBuilder", () => $3d24b3de45ba1bce$export$61d2e8db329a11f8);
class $3d24b3de45ba1bce$export$61d2e8db329a11f8 {
    constructor(url){
        this.url = url;
        this.params = {};
    }
    withQueryParam(key, value) {
        this.params[key] = value;
        return this;
    }
    build() {
        const filteredParams = Object.entries(this.params).filter(([, value])=>value !== undefined && value !== null && value !== '');
        const queryInstance = new URLSearchParams(filteredParams);
        const queryParams = queryInstance.toString();
        if (queryParams) return `${this.url}?${queryParams}`;
        return this.url;
    }
}

});



parcelRegister("gQ8M0", function(module, exports) {

$parcel$export(module.exports, "compressionRatioResource", () => $e8d6c20659375806$export$8c912e73f758af2);

var $2M1hQ = parcelRequire("2M1hQ");

var $5AHJS = parcelRequire("5AHJS");
const $e8d6c20659375806$var$emptyCompressionBanner = {
    compressionRatio: 0,
    uniqueGroupCount: 0,
    rollingWindow: 0
};
const $e8d6c20659375806$export$8c912e73f758af2 = (0, $2M1hQ.createResource)({
    type: 'compressionRatioResource',
    getKey: ()=>'compressionRatioResource',
    getData: async ()=>{
        try {
            const response = await (0, $5AHJS.getCompressionRatio)();
            return response;
        } catch (e) {
            return $e8d6c20659375806$var$emptyCompressionBanner;
        }
    },
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("5AHJS", function(module, exports) {

$parcel$export(module.exports, "getCompressionRatio", () => $c815f27666ee738a$export$4991457f359db4f7);

var $j74qU = parcelRequire("j74qU");

var $1Z10l = parcelRequire("1Z10l");
const $c815f27666ee738a$export$4991457f359db4f7 = ()=>{
    return (0, $j74qU.eocFetch)((0, $1Z10l.withAIOpsDomainPrefix)('/v1/alert-insights/compression-ratio'), {
        exactUrl: true
    });
};

});


parcelRegister("oacWJ", function(module, exports) {

$parcel$export(module.exports, "savedSearchesResource", () => $2aab5bfe07b93543$export$d915b849e6dd786b);

var $2M1hQ = parcelRequire("2M1hQ");

var $6IJKZ = parcelRequire("6IJKZ");
const $2aab5bfe07b93543$export$d915b849e6dd786b = (0, $2M1hQ.createResource)({
    type: 'savedSearchesResource',
    getKey: ()=>'savedSearchesResource',
    getData: ()=>(0, $6IJKZ.getSavedSearchesEndpoint)(),
    maxAge: 300000,
    isBrowserOnly: true
});

});

parcelRegister("dqLIo", function(module, exports) {

$parcel$export(module.exports, "uiPreferencesResource", () => $f86ed58750791981$export$4e143f0fe4b2e025);

var $2M1hQ = parcelRequire("2M1hQ");

var $fY9nC = parcelRequire("fY9nC");
const $f86ed58750791981$export$4e143f0fe4b2e025 = (0, $2M1hQ.createResource)({
    type: 'uiPreferencesResource',
    getKey: ()=>'uiPreferencesResource',
    getData: ()=>(0, $fY9nC.getUiPreferencesEndpoint)(),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("fY9nC", function(module, exports) {

$parcel$export(module.exports, "getUiPreferencesEndpoint", () => $838fb476cee34593$export$afa4854419ed2fc8);
$parcel$export(module.exports, "updateUiPreferencesEndpoint", () => $838fb476cee34593$export$4990793476d8f783);

var $j74qU = parcelRequire("j74qU");
const $838fb476cee34593$export$afa4854419ed2fc8 = ()=>{
    return (0, $j74qU.eocFetch)('/v1/alerts/ui-preferences');
};
const $838fb476cee34593$export$4990793476d8f783 = (data)=>{
    return (0, $j74qU.eocFetch)('/v1/alerts/ui-preferences', {
        method: 'PATCH',
        body: data
    });
};

});



parcelRegister("gLQQv", function(module, exports) {

$parcel$export(module.exports, "LazyGlobalAlertsSidebar", () => $423d186a1838bb07$export$674fd99c08c90491);
$parcel$export(module.exports, "AsyncSidebarEocGlobalAlerts", () => $423d186a1838bb07$export$a1c034c1031e8711);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $kxZPA = parcelRequire("kxZPA");

const $423d186a1838bb07$export$674fd99c08c90491 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("69BST")).then((bundle)=>bundle), {
    moduleId: "./src/packages/navigation-apps/sidebar/eoc-global-alerts/src/index.tsx"
});
const $423d186a1838bb07$export$a1c034c1031e8711 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "eocGlobalAlerts"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($423d186a1838bb07$export$674fd99c08c90491, null));

});
parcelRegister("69BST", function(module, exports) {

let $47b0f8600a6fc5f3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $47b0f8600a6fc5f3$var$load("ffQaD"),
    $47b0f8600a6fc5f3$var$load("kvRbA"),
    $47b0f8600a6fc5f3$var$load("kWm96")
]).then(()=>parcelRequire('2kjD7'));

});


parcelRegister("lFFGs", function(module, exports) {

$parcel$export(module.exports, "LazyAlertList", () => $a8d77694d1ebf81f$export$f4aafff31d950b6c);
$parcel$export(module.exports, "AlertListComponent", () => $a8d77694d1ebf81f$export$9333bfa567c9c31);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $a8d77694d1ebf81f$export$f4aafff31d950b6c = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("9m0hg")), {
    moduleId: "./src/packages/eoc/alert-list/src/ui/index.tsx"
});
const $a8d77694d1ebf81f$export$9333bfa567c9c31 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $a8d77694d1ebf81f$export$f4aafff31d950b6c,
        pageId: "async-jira-eoc-alert-list",
        shouldShowSpinner: false
    });

});
parcelRegister("9m0hg", function(module, exports) {

let $6cf6623e4f48d5a7$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6cf6623e4f48d5a7$var$load("ffQaD"),
    $6cf6623e4f48d5a7$var$load("kvRbA"),
    $6cf6623e4f48d5a7$var$load("fliVL"),
    $6cf6623e4f48d5a7$var$load("76n7a"),
    $6cf6623e4f48d5a7$var$load("l253H"),
    $6cf6623e4f48d5a7$var$load("h31HI")
]).then(()=>parcelRequire('cHlJB'));

});



parcelRegister("3EMmS", function(module, exports) {

$parcel$export(module.exports, "eocGlobalAlertsDetailRouteEntry", () => $ffa726838ac9512f$export$bcb93d8198d511b9);

var $en1L8 = parcelRequire("en1L8");

var $8C32n = parcelRequire("8C32n");

var $i5qMw = parcelRequire("i5qMw");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $gLQQv = parcelRequire("gLQQv");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $lOzKo = parcelRequire("lOzKo");

var $4R6GH = parcelRequire("4R6GH");

var $gNStA = parcelRequire("gNStA");

var $lFFGs = parcelRequire("lFFGs");
const $ffa726838ac9512f$export$bcb93d8198d511b9 = (0, $7NszV.createEntry)((0, $lOzKo.eocGlobalAlertsDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $lFFGs.AlertListComponent),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $8C32n.resources)(),
            ...(0, $en1L8.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('automation_discoverability_in_jsm'), (0, $i5qMw.getAutomationDiscoveryDismissResource))
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).HOME,
            sidebar: (0, $gLQQv.AsyncSidebarEocGlobalAlerts)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $lFFGs.LazyAlertList),
            (0, $gLQQv.LazyGlobalAlertsSidebar)
        ]
    }));

});
parcelRegister("en1L8", function(module, exports) {

$parcel$export(module.exports, "alertDetailResource", () => $0fd209d54dcee973$export$f918335771807ac4);
$parcel$export(module.exports, "logTypesResource", () => $0fd209d54dcee973$export$f9c57ab4d5f63686);
$parcel$export(module.exports, "entityRelationTypesResource", () => $0fd209d54dcee973$export$a5515392cb45b9f8);
$parcel$export(module.exports, "responderStatesResource", () => $0fd209d54dcee973$export$c3b70747662e5932);
$parcel$export(module.exports, "resources", () => $0fd209d54dcee973$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $6CZ6k = parcelRequire("6CZ6k");

var $VSDnB = parcelRequire("VSDnB");

var $4EUyI = parcelRequire("4EUyI");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $jxRF2 = parcelRequire("jxRF2");

var $iCk5l = parcelRequire("iCk5l");

var $4sBoT = parcelRequire("4sBoT");
const $0fd209d54dcee973$var$ALERT_DETAIL_RESOURCE_TYPE = 'alertDetailResource';
const $0fd209d54dcee973$export$f918335771807ac4 = (0, $2M1hQ.createResource)({
    type: $0fd209d54dcee973$var$ALERT_DETAIL_RESOURCE_TYPE,
    getKey: (routerContext)=>`alertDetailResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const alertId = routerContext.match.params?.id;
        (0, $hmVmJ.assert)(!!alertId, new (0, $dH6Pi.AssertionError)('alertDetailResource', 'alertId should be set to fetch alert-detail'));
        return (0, $4sBoT.getAlertDetail)(alertId);
    },
    isBrowserOnly: true
});
const $0fd209d54dcee973$export$f9c57ab4d5f63686 = (0, $2M1hQ.createResource)({
    type: 'logTypesResource',
    getKey: (routerContext)=>`logTypesResource#${routerContext.match.params.id}`,
    getData: async ()=>{
        return (0, $4sBoT.getAlertLogTypesEndpoint)();
    },
    isBrowserOnly: true
});
const $0fd209d54dcee973$export$a5515392cb45b9f8 = (0, $2M1hQ.createResource)({
    type: 'entityRelationTypesResource',
    getKey: (routerContext)=>`entityRelationTypesResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const alertId = routerContext.match.params?.id;
        const dependencies = routerContext.dependencies;
        (0, $hmVmJ.assert)(!!alertId, new (0, $dH6Pi.AssertionError)('alertDetaentityRelationTypesResourceilResource', 'alertId should be set to fetch alert-detail'));
        // if id on the url is not a valid uuid and flag is on then wait for alertDetailResource to resolve for getting id of the alert instead of tinyId
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($6CZ6k)))(alertId) && (0, $VSDnB.fg)('alert_detail_convert_tiny_id_to_alert_id')) {
            const { id: id } = await (0, $iCk5l.consumeDependency)(dependencies, $0fd209d54dcee973$var$ALERT_DETAIL_RESOURCE_TYPE);
            return (0, $4sBoT.getEntityRelationTypesEndpoint)(id);
        }
        return (0, $4sBoT.getEntityRelationTypesEndpoint)(alertId);
    },
    depends: [
        $0fd209d54dcee973$var$ALERT_DETAIL_RESOURCE_TYPE
    ],
    isBrowserOnly: true
});
const $0fd209d54dcee973$export$c3b70747662e5932 = (0, $2M1hQ.createResource)({
    type: 'responderStatesResource',
    getKey: (routerContext)=>`responderStatesResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const alertId = routerContext.match.params?.id;
        const dependencies = routerContext.dependencies;
        (0, $hmVmJ.assert)(!!alertId, new (0, $dH6Pi.AssertionError)('alertDetaentityRelationTypesResourceilResource', 'alertId should be set to fetch alert-detail'));
        // if id on the url is not a valid uuid and flag is on then wait for alertDetailResource to resolve for getting id of the alert instead of tinyId
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($6CZ6k)))(alertId) && (0, $VSDnB.fg)('alert_detail_convert_tiny_id_to_alert_id')) {
            const { id: id } = await (0, $iCk5l.consumeDependency)(dependencies, $0fd209d54dcee973$var$ALERT_DETAIL_RESOURCE_TYPE);
            return (0, $4sBoT.getResponderStatesEndpoint)(id);
        }
        return (0, $4sBoT.getResponderStatesEndpoint)(alertId);
    },
    depends: [
        $0fd209d54dcee973$var$ALERT_DETAIL_RESOURCE_TYPE
    ],
    isBrowserOnly: true
});
const $0fd209d54dcee973$export$bc99aaabaf7b70a7 = ()=>[
        $0fd209d54dcee973$export$f918335771807ac4,
        $0fd209d54dcee973$export$f9c57ab4d5f63686,
        $0fd209d54dcee973$export$c3b70747662e5932,
        $0fd209d54dcee973$export$a5515392cb45b9f8,
        (0, $4EUyI.relatedAlertGroupResource),
        ...(0, $jxRF2.eocCommonResources)()
    ];

});
parcelRegister("4EUyI", function(module, exports) {

$parcel$export(module.exports, "relatedAlertGroupResource", () => $ba8a2335e3265c9e$export$35df14c9f0cfb113);

var $2M1hQ = parcelRequire("2M1hQ");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $3jET5 = parcelRequire("3jET5");
const $ba8a2335e3265c9e$export$35df14c9f0cfb113 = (0, $2M1hQ.createResource)({
    type: 'relatedAlertGroupResource',
    getKey: (routerContext)=>`relatedAlertGroupResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const alertId = routerContext.match.params?.id;
        (0, $hmVmJ.assert)(!!alertId, new (0, $dH6Pi.AssertionError)('relatedAlertGroupResource', 'alertId should be set to fetch related alert-groups'));
        return (0, $3jET5.getRelatedAlertGroup)(alertId);
    },
    isBrowserOnly: true
});

});
parcelRegister("3jET5", function(module, exports) {

$parcel$export(module.exports, "getRelatedAlertGroup", () => $0f60bd06765f80ba$export$665e34f20aad273a);

var $j74qU = parcelRequire("j74qU");

var $4ttsA = parcelRequire("4ttsA");
const $0f60bd06765f80ba$export$665e34f20aad273a = (alertId)=>(0, $j74qU.eocFetch)((0, $4ttsA.withAIOpsDomainPrefix)(`/v1/group-insights/get-group-of-alert?alertId=${alertId}`), {
        exactUrl: true
    });

});
parcelRegister("4ttsA", function(module, exports) {

$parcel$export(module.exports, "withAIOpsDomainPrefix", () => $8fd10dbbabf74295$export$81c70e0016508593);

var $030R0 = parcelRequire("030R0");
const $8fd10dbbabf74295$export$81c70e0016508593 = (input)=>{
    const cloudId = (0, $030R0.getMeta)('ajs-cloud-id');
    if (cloudId) return `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input;
    return input;
};

});



parcelRegister("iCk5l", function(module, exports) {

$parcel$export(module.exports, "consumeDependency", () => $05390e87704874e0$export$a973ef9e17a326f);
async function $05390e87704874e0$export$a973ef9e17a326f(dependencies, key) {
    // There is an inflight request, the response is source of truth
    if (dependencies[key]?.loading) return dependencies[key]?.promise;
    if (dependencies[key]?.error) // Our dependency errored out the last time it ran, we don't have the data
    throw dependencies[key]?.error;
    // Last response is what we want
    return dependencies[key]?.data;
}

});

parcelRegister("4sBoT", function(module, exports) {

$parcel$export(module.exports, "getAlertDetail", () => $440b6c9ebfdc99cb$export$436b6d88c1865c54);
$parcel$export(module.exports, "getAlertLogTypesEndpoint", () => $440b6c9ebfdc99cb$export$97200f7e7a7d1479);
$parcel$export(module.exports, "getResponderStatesEndpoint", () => $440b6c9ebfdc99cb$export$498d1a9ea659d430);
$parcel$export(module.exports, "getEntityRelationTypesEndpoint", () => $440b6c9ebfdc99cb$export$8f96130abdd7549d);

var $j74qU = parcelRequire("j74qU");
const $440b6c9ebfdc99cb$export$436b6d88c1865c54 = (alertId)=>(0, $j74qU.eocFetch)(`/v1/alerts/${alertId}`);
const $440b6c9ebfdc99cb$export$97200f7e7a7d1479 = ()=>(0, $j74qU.eocFetch)(`/v1/alerts/logs/types`);
const $440b6c9ebfdc99cb$export$498d1a9ea659d430 = (alertId)=>(0, $j74qU.eocFetch)(`/v1/alerts/${alertId}/responder-states`);
const $440b6c9ebfdc99cb$export$8f96130abdd7549d = (alertId)=>(0, $j74qU.eocFetch)(`/v1/alerts/${alertId}/entity-relations/relation-types`).then((res)=>({
            relationTypes: res.relationTypes.sort((a, b)=>a.label.localeCompare(b.label))
        }));

});


parcelRegister("i5qMw", function(module, exports) {

$parcel$export(module.exports, "getAutomationDiscoveryDismissResource", () => $e60dab4293b0384b$export$3e9b930ef3c80543);

var $2M1hQ = parcelRequire("2M1hQ");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

const $e60dab4293b0384b$var$PROPERTY_KEY = 'jira.user.issue.automation-discoverability.panel.state';
const $e60dab4293b0384b$export$3e9b930ef3c80543 = (0, $2M1hQ.createResource)({
    type: 'getAutomationDiscoveryDismiss',
    getKey: ()=>'getAutomationDiscoveryDismiss',
    getData: async ()=>{
        try {
            const res = await (0, $eusud.performGetRequest)(`/rest/api/3/mypreferences?key=${$e60dab4293b0384b$var$PROPERTY_KEY}`);
            return res;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef)) return null;
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'getDismissData',
                    teamName: 'ITOps Phantom',
                    packageName: 'jiraEocAutomationDiscovery'
                }
            });
            throw error;
        }
    },
    maxAge: 300000
});

});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;


parcelRegister("lOzKo", function(module, exports) {

$parcel$export(module.exports, "eocGlobalAlertsDetailRoute", () => $e176fbe640598c13$export$d87948ea641004e2);
const $e176fbe640598c13$export$d87948ea641004e2 = {
    name: 'eoc-global-alert-detail',
    path: '/jira/ops/alerts/:id',
    exact: true
};

});


parcelRegister("6q1hh", function(module, exports) {

$parcel$export(module.exports, "eocGlobalAlertListRedirectRouteEntry", () => $43b8d5dd0744ff60$export$4fc438c20edc8a6f);

var $8C32n = parcelRequire("8C32n");

var $ffza4 = parcelRequire("ffza4");

var $iqZds = parcelRequire("iqZds");

var $lmyls = parcelRequire("lmyls");

var $gLQQv = parcelRequire("gLQQv");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $gKpDb = parcelRequire("gKpDb");

var $lFFGs = parcelRequire("lFFGs");
const $43b8d5dd0744ff60$export$4fc438c20edc8a6f = (0, $7NszV.createEntry)((0, $gKpDb.eocGlobalAlertListRedirectRoute), ()=>({
        group: 'eoc',
        component: (0, $lFFGs.AlertListComponent),
        layout: (0, $iqZds.eocChangeboardingLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $8C32n.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).HOME,
            sidebar: (0, $gLQQv.AsyncSidebarEocGlobalAlerts)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $lFFGs.LazyAlertList),
            (0, $gLQQv.LazyGlobalAlertsSidebar)
        ]
    }));

});
parcelRegister("gKpDb", function(module, exports) {

$parcel$export(module.exports, "eocGlobalAlertListRedirectRoute", () => $672bce5b0854416a$export$491d479dc37383e9);
const $672bce5b0854416a$export$491d479dc37383e9 = {
    name: 'eoc-global-alerts-redirect',
    path: '/jira/ops',
    exact: true
};

});


parcelRegister("q3duL", function(module, exports) {

$parcel$export(module.exports, "globalEscalationsRouteEntry", () => $ef2506bfe64688a1$export$adde4536d8e5f94c);

var $5uXOq = parcelRequire("5uXOq");

var $cM724 = parcelRequire("cM724");

var $ffza4 = parcelRequire("ffza4");

var $eZXFU = parcelRequire("eZXFU");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $6yAvP = parcelRequire("6yAvP");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ef2506bfe64688a1$var$LazyGlobalEscalations = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("btLVG")).then((module)=>module.GlobalEscalationsPage), {
    moduleId: "./src/packages/eoc/global-escalations/src/index.tsx"
});
const $ef2506bfe64688a1$var$GlobalEscalationsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ef2506bfe64688a1$var$LazyGlobalEscalations,
        pageId: "async-jira-eoc-global-escalations",
        shouldShowSpinner: false
    });
const $ef2506bfe64688a1$var$getNavigationSpecifications = ()=>{
    return ((0, $4R6GH.fg)('operations_nav4_remaining_items_old_navigation_fix') ? (0, $3HwlS.getWillShowNav4)() : true) && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $ef2506bfe64688a1$export$adde4536d8e5f94c = (0, $7NszV.createEntry)((0, $6yAvP.globalEscalationsRoute), ()=>({
        group: 'eoc',
        component: $ef2506bfe64688a1$var$GlobalEscalationsComponent,
        layout: (0, $eZXFU.opsSettingsLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $cM724.globalEscalationsListInfoResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$ef2506bfe64688a1$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            $ef2506bfe64688a1$var$LazyGlobalEscalations
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            $ef2506bfe64688a1$var$LazyGlobalEscalations
        ]
    }));

});
parcelRegister("cM724", function(module, exports) {

$parcel$export(module.exports, "globalEscalationsListInfoResource", () => $a2d6726b104ac899$export$bffddc002dadaf3a);

var $2M1hQ = parcelRequire("2M1hQ");

var $2dbE7 = parcelRequire("2dbE7");
const $a2d6726b104ac899$export$bffddc002dadaf3a = (0, $2M1hQ.createResource)({
    type: 'globalEscalationsListInfoResource',
    getKey: ()=>'globalEscalationsListInfoResource',
    getData: (0, $2dbE7.getListInfo),
    isBrowserOnly: true
});

});
parcelRegister("2dbE7", function(module, exports) {

$parcel$export(module.exports, "getEscalations", () => $9fcebef6d9f6d876$export$300727380b60aeb4);
$parcel$export(module.exports, "getListInfo", () => $9fcebef6d9f6d876$export$bdc8fe7d9cd263b);

var $j74qU = parcelRequire("j74qU");
const $9fcebef6d9f6d876$export$300727380b60aeb4 = ({ lastEvaluatedToken: lastEvaluatedToken, queryKey: queryKey })=>{
    const [, filtersString] = queryKey;
    const filters = JSON.parse(filtersString);
    const params = new URLSearchParams({
        ...filters,
        lastEvaluatedToken: lastEvaluatedToken
    });
    return (0, $j74qU.eocFetch)(`/v1/escalations/search?${params.toString()}`);
};
const $9fcebef6d9f6d876$export$bdc8fe7d9cd263b = ()=>{
    return (0, $j74qU.eocFetch)('/v1/escalations/list-info');
};

});


parcelRegister("6yAvP", function(module, exports) {

$parcel$export(module.exports, "globalEscalationsRoute", () => $b256c068fa7916da$export$9ed12f6fa845edfb);
const $b256c068fa7916da$export$9ed12f6fa845edfb = {
    name: 'eoc-global-escalations',
    path: '/jira/settings/products/ops/escalation-policies',
    exact: true
};

});

parcelRegister("btLVG", function(module, exports) {

let $85b794e5096951ac$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $85b794e5096951ac$var$load("ffQaD"),
    $85b794e5096951ac$var$load("kvRbA"),
    $85b794e5096951ac$var$load("dMGRJ")
]).then(()=>parcelRequire('dLkuj'));

});


parcelRegister("4Ykyz", function(module, exports) {

$parcel$export(module.exports, "eocGlobalGroupDetailRouteEntry", () => $08aebbbf84aea52e$export$66928ab349190059);

var $8C32n = parcelRequire("8C32n");

var $eYyoJ = parcelRequire("eYyoJ");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $gLQQv = parcelRequire("gLQQv");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $7eLbt = parcelRequire("7eLbt");

var $lgLgL = parcelRequire("lgLgL");
const $08aebbbf84aea52e$export$66928ab349190059 = (0, $7NszV.createEntry)((0, $7eLbt.eocGlobalGroupDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $lgLgL.default),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $eYyoJ.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $8C32n.resources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).HOME,
            sidebar: (0, $gLQQv.AsyncSidebarEocGlobalAlerts)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $lgLgL.LazyGroupDetail),
            (0, $gLQQv.LazyGlobalAlertsSidebar)
        ]
    }));

});
parcelRegister("eYyoJ", function(module, exports) {

$parcel$export(module.exports, "groupHeaderResource", () => $3cd6727337445c45$export$e6ba56f6b67069c8);
$parcel$export(module.exports, "aiSuggestionsResource", () => $3cd6727337445c45$export$94675faef1d4568b);
$parcel$export(module.exports, "resources", () => $3cd6727337445c45$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $2LFOe = parcelRequire("2LFOe");
const $3cd6727337445c45$export$e6ba56f6b67069c8 = (0, $2M1hQ.createResource)({
    type: 'groupHeaderResource',
    getKey: (routerContext)=>`groupHeaderResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const groupId = routerContext.match.params?.id;
        (0, $hmVmJ.assert)(!!groupId, new (0, $dH6Pi.AssertionError)('groupHeaderResource', 'groupId should be set to fetch group-detail-header'));
        return (0, $2LFOe.getHeaderDetails)(groupId);
    },
    isBrowserOnly: true
});
const $3cd6727337445c45$export$94675faef1d4568b = (0, $2M1hQ.createResource)({
    type: 'aiSuggestionsResource',
    getKey: (routerContext)=>`aiSuggestionsResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        const groupId = routerContext.match.params?.id;
        (0, $hmVmJ.assert)(!!groupId, new (0, $dH6Pi.AssertionError)('aiSuggestionsResource', 'groupId should be set to fetch ai-suggestions for any group'));
        return (0, $2LFOe.getAISuggestions)(groupId);
    },
    isBrowserOnly: true
});
const $3cd6727337445c45$export$bc99aaabaf7b70a7 = ()=>[
        $3cd6727337445c45$export$e6ba56f6b67069c8,
        $3cd6727337445c45$export$94675faef1d4568b
    ];

});
parcelRegister("2LFOe", function(module, exports) {

$parcel$export(module.exports, "getHeaderDetails", () => $1301a416506333ce$export$c0f2e4bfcbff05d1);
$parcel$export(module.exports, "getAISuggestions", () => $1301a416506333ce$export$34bb7a15a54039a5);
$parcel$export(module.exports, "addGroupAssignee", () => $1301a416506333ce$export$bd5bdebdb6d9abb);
$parcel$export(module.exports, "actionOnGroup", () => $1301a416506333ce$export$5353a5d2604523c0);
$parcel$export(module.exports, "getAlertCountForGroupAction", () => $1301a416506333ce$export$b47efb0a9602f0c8);

var $j74qU = parcelRequire("j74qU");

var $iZjKh = parcelRequire("iZjKh");
const $1301a416506333ce$export$c0f2e4bfcbff05d1 = (groupId)=>(0, $j74qU.eocFetch)((0, $iZjKh.withAIOpsPrefix)(`/v1/group-insights/${groupId}`), {
        exactUrl: true
    });
const $1301a416506333ce$export$34bb7a15a54039a5 = (groupId)=>(0, $j74qU.eocFetch)((0, $iZjKh.withAIOpsPrefix)(`/v1/group-insights/getSimilar/${groupId}`), {
        exactUrl: true
    });
const $1301a416506333ce$export$bd5bdebdb6d9abb = (groupId, assigneeId)=>(0, $j74qU.eocFetch)((0, $iZjKh.withAIOpsPrefix)(`/v1/group-insights/${groupId}/add-assignee/${assigneeId}`), {
        method: 'PUT',
        exactUrl: true
    });
const $1301a416506333ce$export$5353a5d2604523c0 = (groupId, action, payload = {})=>{
    return (0, $j74qU.eocFetch)((0, $iZjKh.withAIOpsPrefix)(`/v1/alert-insights/bulk-action`), {
        method: 'PUT',
        exactUrl: true,
        body: {
            groupId: groupId,
            actionType: action,
            ...payload
        }
    });
};
const $1301a416506333ce$export$b47efb0a9602f0c8 = (groupId, action)=>{
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.set('actionType', action);
    urlSearchParams.set('groupId', groupId);
    return (0, $j74qU.eocFetch)((0, $iZjKh.withAIOpsPrefix)(`/v1/alert-insights/check-all-action?${urlSearchParams}`), {
        exactUrl: true
    });
};

});
parcelRegister("iZjKh", function(module, exports) {

$parcel$export(module.exports, "withAIOpsPrefix", () => $1bb9bc334d3aa5dc$export$5ad74397753c99a2);
$parcel$export(module.exports, "formatTimezone", () => $1bb9bc334d3aa5dc$export$26da7aa151b6684c);

var $h3SpW = parcelRequire("h3SpW");

var $ecVqv = parcelRequire("ecVqv");

var $030R0 = parcelRequire("030R0");
const $1bb9bc334d3aa5dc$export$5ad74397753c99a2 = (input)=>{
    const cloudId = (0, $030R0.getMeta)('ajs-cloud-id');
    if (cloudId) return `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input;
    return input;
};
function $1bb9bc334d3aa5dc$export$9e555a50010549c1(timezone) {
    const splittedTz = timezone.split('/');
    // EST || EST5EDT
    if (splittedTz.length === 0) return splittedTz;
    // Europe/Amsterdam || Europe/Isle_of_Man || America/North_Dakota/New_Salem
    if (splittedTz.length > 0) {
        const areaName = splittedTz[splittedTz.length - 1];
        return areaName.replace(/_/g, ' ');
    }
    return timezone;
}
function $1bb9bc334d3aa5dc$export$26da7aa151b6684c(timezone) {
    const timeZone = timezone ?? (0, $ecVqv.guessUserTimeZone)();
    return (0, $h3SpW.default)(new Date(), timeZone, `z '${$1bb9bc334d3aa5dc$export$9e555a50010549c1(timeZone)}'`);
}

});
parcelRegister("h3SpW", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6bceda90e48606f$export$2e2bcd8739ae039);

var $fwbX5 = parcelRequire("fwbX5");

var $20Ydt = parcelRequire("20Ydt");

var $fUZDr = parcelRequire("fUZDr");
function $c6bceda90e48606f$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($fwbX5)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $20Ydt.default)((0, $fUZDr.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("20Ydt", function(module, exports) {

$parcel$export(module.exports, "default", () => $177a4a9326781e30$export$2e2bcd8739ae039);

var $aR9Qf = parcelRequire("aR9Qf");

var $7NnjV = parcelRequire("7NnjV");

var $65qJO = parcelRequire("65qJO");
var $177a4a9326781e30$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $177a4a9326781e30$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($177a4a9326781e30$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $65qJO.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $7NnjV.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aR9Qf)))(dirtyDate, formatStr, options);
}

});
parcelRegister("7NnjV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5acf32f87aff2000$export$2e2bcd8739ae039);

var $gbKiI = parcelRequire("gbKiI");

var $atfNs = parcelRequire("atfNs");
var $5acf32f87aff2000$var$MILLISECONDS_IN_MINUTE = 60000;
var $5acf32f87aff2000$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $5acf32f87aff2000$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $5acf32f87aff2000$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $5acf32f87aff2000$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $5acf32f87aff2000$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $5acf32f87aff2000$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $5acf32f87aff2000$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $5acf32f87aff2000$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $5acf32f87aff2000$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $5acf32f87aff2000$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $5acf32f87aff2000$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $5acf32f87aff2000$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $gbKiI.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $gbKiI.default)('long', date, options);
        }
    }
};
function $5acf32f87aff2000$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $atfNs.default)(timeZone, originalDate, true) / $5acf32f87aff2000$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $5acf32f87aff2000$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $5acf32f87aff2000$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $5acf32f87aff2000$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $5acf32f87aff2000$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $5acf32f87aff2000$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $5acf32f87aff2000$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $5acf32f87aff2000$var$formatTimezone(offset, dirtyDelimeter);
}
function $5acf32f87aff2000$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $5acf32f87aff2000$var$addLeadingZeros(minutes, 2);
}
var $5acf32f87aff2000$export$2e2bcd8739ae039 = $5acf32f87aff2000$var$formatters;

});
parcelRegister("gbKiI", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc9196c8c3afb37a$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $bc9196c8c3afb37a$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $bc9196c8c3afb37a$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $bc9196c8c3afb37a$var$partsTimeZone(dtf, date) : $bc9196c8c3afb37a$var$hackyTimeZone(dtf, date);
}
function $bc9196c8c3afb37a$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $bc9196c8c3afb37a$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $bc9196c8c3afb37a$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("atfNs", function(module, exports) {

$parcel$export(module.exports, "default", () => $79f8ddb775209bef$export$2e2bcd8739ae039);

var $5ffLt = parcelRequire("5ffLt");

var $iVDyo = parcelRequire("iVDyo");
var $79f8ddb775209bef$var$MILLISECONDS_IN_HOUR = 3600000;
var $79f8ddb775209bef$var$MILLISECONDS_IN_MINUTE = 60000;
var $79f8ddb775209bef$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $79f8ddb775209bef$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $79f8ddb775209bef$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $79f8ddb775209bef$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$79f8ddb775209bef$var$validateTimezone(hours)) return NaN;
        return -(hours * $79f8ddb775209bef$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $79f8ddb775209bef$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$79f8ddb775209bef$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $79f8ddb775209bef$var$MILLISECONDS_IN_HOUR + minutes * $79f8ddb775209bef$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($79f8ddb775209bef$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $79f8ddb775209bef$var$toUtcDate(date);
        var offset = $79f8ddb775209bef$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $79f8ddb775209bef$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $79f8ddb775209bef$var$toUtcDate(date) {
    return (0, $iVDyo.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $79f8ddb775209bef$var$calcOffset(date, timezoneString) {
    var tokens = (0, $5ffLt.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $iVDyo.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $79f8ddb775209bef$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $79f8ddb775209bef$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $79f8ddb775209bef$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $79f8ddb775209bef$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $79f8ddb775209bef$var$validIANATimezoneCache = {};
function $79f8ddb775209bef$var$isValidTimezoneIANAString(timeZoneString) {
    if ($79f8ddb775209bef$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $79f8ddb775209bef$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("5ffLt", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d1a95017a15ed18$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $3d1a95017a15ed18$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $3d1a95017a15ed18$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $3d1a95017a15ed18$var$partsOffset(dtf, date) : $3d1a95017a15ed18$var$hackyOffset(dtf, date);
}
var $3d1a95017a15ed18$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $3d1a95017a15ed18$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $3d1a95017a15ed18$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $3d1a95017a15ed18$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $3d1a95017a15ed18$var$dtfCache = {};
function $3d1a95017a15ed18$var$getDateTimeFormat(timeZone) {
    if (!$3d1a95017a15ed18$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $3d1a95017a15ed18$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $3d1a95017a15ed18$var$dtfCache[timeZone];
}

});

parcelRegister("iVDyo", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc7c3b6f62152086$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $dc7c3b6f62152086$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("65qJO", function(module, exports) {

$parcel$export(module.exports, "default", () => $46e7f34b08b7ff56$export$2e2bcd8739ae039);

var $aSksP = parcelRequire("aSksP");

var $jGQTC = parcelRequire("jGQTC");

var $atfNs = parcelRequire("atfNs");

var $dB2sE = parcelRequire("dB2sE");
var $46e7f34b08b7ff56$var$MILLISECONDS_IN_HOUR = 3600000;
var $46e7f34b08b7ff56$var$MILLISECONDS_IN_MINUTE = 60000;
var $46e7f34b08b7ff56$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $46e7f34b08b7ff56$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $dB2sE.default)
};
function $46e7f34b08b7ff56$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $46e7f34b08b7ff56$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($aSksP)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $46e7f34b08b7ff56$var$splitDateString(argument);
    var parseYearResult = $46e7f34b08b7ff56$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $46e7f34b08b7ff56$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $46e7f34b08b7ff56$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $atfNs.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $46e7f34b08b7ff56$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $46e7f34b08b7ff56$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $46e7f34b08b7ff56$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $46e7f34b08b7ff56$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $46e7f34b08b7ff56$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $46e7f34b08b7ff56$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $46e7f34b08b7ff56$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $46e7f34b08b7ff56$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $46e7f34b08b7ff56$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $46e7f34b08b7ff56$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $46e7f34b08b7ff56$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$46e7f34b08b7ff56$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $46e7f34b08b7ff56$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$46e7f34b08b7ff56$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $46e7f34b08b7ff56$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$46e7f34b08b7ff56$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $46e7f34b08b7ff56$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$46e7f34b08b7ff56$var$validateWeekDate(year, week)) return new Date(NaN);
        return $46e7f34b08b7ff56$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $46e7f34b08b7ff56$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$46e7f34b08b7ff56$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $46e7f34b08b7ff56$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $46e7f34b08b7ff56$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $46e7f34b08b7ff56$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$46e7f34b08b7ff56$var$validateTime(hours)) return NaN;
        return hours % 24 * $46e7f34b08b7ff56$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $46e7f34b08b7ff56$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$46e7f34b08b7ff56$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $46e7f34b08b7ff56$var$MILLISECONDS_IN_HOUR + minutes * $46e7f34b08b7ff56$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $46e7f34b08b7ff56$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$46e7f34b08b7ff56$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $46e7f34b08b7ff56$var$MILLISECONDS_IN_HOUR + minutes * $46e7f34b08b7ff56$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $46e7f34b08b7ff56$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $46e7f34b08b7ff56$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $46e7f34b08b7ff56$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $46e7f34b08b7ff56$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $46e7f34b08b7ff56$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $46e7f34b08b7ff56$var$isLeapYearIndex(year);
        if (isLeapYear && date > $46e7f34b08b7ff56$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $46e7f34b08b7ff56$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $46e7f34b08b7ff56$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $46e7f34b08b7ff56$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $46e7f34b08b7ff56$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $46e7f34b08b7ff56$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("dB2sE", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e60a3c6941934b2$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $9e60a3c6941934b2$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $9e60a3c6941934b2$export$2e2bcd8739ae039 = $9e60a3c6941934b2$var$tzPattern;

});



parcelRegister("fUZDr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b96be56ec1d1e59c$export$2e2bcd8739ae039);

var $atfNs = parcelRequire("atfNs");

var $65qJO = parcelRequire("65qJO");
function $b96be56ec1d1e59c$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $65qJO.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $atfNs.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});


parcelRegister("ecVqv", function(module, exports) {

$parcel$export(module.exports, "guessUserTimeZone", () => $2b4a394b314b1777$export$6fd096fe0456f5b);
$parcel$export(module.exports, "formatDate", () => $2b4a394b314b1777$export$3ae94a2503e890a1);
$parcel$export(module.exports, "getDefaultTimes", () => $2b4a394b314b1777$export$951e947e785c998d);

var $3r0F8 = parcelRequire("3r0F8");
function $2b4a394b314b1777$export$6fd096fe0456f5b() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
function $2b4a394b314b1777$export$3ae94a2503e890a1(date, timezone = $2b4a394b314b1777$export$6fd096fe0456f5b(), format = 'PP p') {
    return (0, $3r0F8.default)(new Date(date), timezone, format);
}
const $2b4a394b314b1777$export$951e947e785c998d = ()=>{
    return [
        ...Array(24).keys()
    ].map((time)=>{
        let newTime = time.toString();
        if (newTime.length === 1) newTime = `0${time}`;
        return [
            `${newTime}:00`,
            `${newTime}:30`
        ];
    }).flatMap((time)=>time);
};

});
parcelRegister("3r0F8", function(module, exports) {

$parcel$export(module.exports, "default", () => $2804684888b12a97$export$2e2bcd8739ae039);

var $fwbX5 = parcelRequire("fwbX5");

var $3Qy0g = parcelRequire("3Qy0g");

var $6AseU = parcelRequire("6AseU");
function $2804684888b12a97$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($fwbX5)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $3Qy0g.default)((0, $6AseU.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("3Qy0g", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cd09abfa6c4a431$export$2e2bcd8739ae039);

var $aR9Qf = parcelRequire("aR9Qf");

var $lSiV5 = parcelRequire("lSiV5");

var $fzXH2 = parcelRequire("fzXH2");
var $2cd09abfa6c4a431$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $2cd09abfa6c4a431$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($2cd09abfa6c4a431$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $fzXH2.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $lSiV5.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aR9Qf)))(dirtyDate, formatStr, options);
}

});
parcelRegister("lSiV5", function(module, exports) {

$parcel$export(module.exports, "default", () => $fecd51332a1c1e9e$export$2e2bcd8739ae039);

var $3flYX = parcelRequire("3flYX");

var $fVXeF = parcelRequire("fVXeF");
var $fecd51332a1c1e9e$var$MILLISECONDS_IN_MINUTE = 60000;
var $fecd51332a1c1e9e$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $fecd51332a1c1e9e$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $fecd51332a1c1e9e$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $fecd51332a1c1e9e$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $fecd51332a1c1e9e$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $fecd51332a1c1e9e$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $fecd51332a1c1e9e$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $fecd51332a1c1e9e$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $fecd51332a1c1e9e$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $fecd51332a1c1e9e$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $fecd51332a1c1e9e$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $fecd51332a1c1e9e$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $3flYX.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $3flYX.default)('long', date, options);
        }
    }
};
function $fecd51332a1c1e9e$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $fVXeF.default)(timeZone, originalDate, true) / $fecd51332a1c1e9e$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $fecd51332a1c1e9e$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $fecd51332a1c1e9e$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $fecd51332a1c1e9e$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $fecd51332a1c1e9e$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $fecd51332a1c1e9e$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $fecd51332a1c1e9e$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $fecd51332a1c1e9e$var$formatTimezone(offset, dirtyDelimeter);
}
function $fecd51332a1c1e9e$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $fecd51332a1c1e9e$var$addLeadingZeros(minutes, 2);
}
var $fecd51332a1c1e9e$export$2e2bcd8739ae039 = $fecd51332a1c1e9e$var$formatters;

});
parcelRegister("3flYX", function(module, exports) {

$parcel$export(module.exports, "default", () => $25d3d3067975e358$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $25d3d3067975e358$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $25d3d3067975e358$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $25d3d3067975e358$var$partsTimeZone(dtf, date) : $25d3d3067975e358$var$hackyTimeZone(dtf, date);
}
function $25d3d3067975e358$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $25d3d3067975e358$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $25d3d3067975e358$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("fVXeF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b99a20d10e092648$export$2e2bcd8739ae039);

var $fiX0E = parcelRequire("fiX0E");

var $iNdur = parcelRequire("iNdur");
var $b99a20d10e092648$var$MILLISECONDS_IN_HOUR = 3600000;
var $b99a20d10e092648$var$MILLISECONDS_IN_MINUTE = 60000;
var $b99a20d10e092648$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $b99a20d10e092648$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $b99a20d10e092648$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $b99a20d10e092648$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$b99a20d10e092648$var$validateTimezone(hours)) return NaN;
        return -(hours * $b99a20d10e092648$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $b99a20d10e092648$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$b99a20d10e092648$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $b99a20d10e092648$var$MILLISECONDS_IN_HOUR + minutes * $b99a20d10e092648$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($b99a20d10e092648$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $b99a20d10e092648$var$toUtcDate(date);
        var offset = $b99a20d10e092648$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $b99a20d10e092648$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $b99a20d10e092648$var$toUtcDate(date) {
    return (0, $iNdur.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $b99a20d10e092648$var$calcOffset(date, timezoneString) {
    var tokens = (0, $fiX0E.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $iNdur.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $b99a20d10e092648$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $b99a20d10e092648$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $b99a20d10e092648$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $b99a20d10e092648$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $b99a20d10e092648$var$validIANATimezoneCache = {};
function $b99a20d10e092648$var$isValidTimezoneIANAString(timeZoneString) {
    if ($b99a20d10e092648$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $b99a20d10e092648$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("fiX0E", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2464f81a8ba230e$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $b2464f81a8ba230e$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $b2464f81a8ba230e$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $b2464f81a8ba230e$var$partsOffset(dtf, date) : $b2464f81a8ba230e$var$hackyOffset(dtf, date);
}
var $b2464f81a8ba230e$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $b2464f81a8ba230e$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $b2464f81a8ba230e$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $b2464f81a8ba230e$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $b2464f81a8ba230e$var$dtfCache = {};
function $b2464f81a8ba230e$var$getDateTimeFormat(timeZone) {
    if (!$b2464f81a8ba230e$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $b2464f81a8ba230e$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $b2464f81a8ba230e$var$dtfCache[timeZone];
}

});

parcelRegister("iNdur", function(module, exports) {

$parcel$export(module.exports, "default", () => $dae74471898019fc$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $dae74471898019fc$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("fzXH2", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5786db9ce2d798f$export$2e2bcd8739ae039);

var $aSksP = parcelRequire("aSksP");

var $jGQTC = parcelRequire("jGQTC");

var $fVXeF = parcelRequire("fVXeF");

var $ZIcI6 = parcelRequire("ZIcI6");
var $b5786db9ce2d798f$var$MILLISECONDS_IN_HOUR = 3600000;
var $b5786db9ce2d798f$var$MILLISECONDS_IN_MINUTE = 60000;
var $b5786db9ce2d798f$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $b5786db9ce2d798f$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $ZIcI6.default)
};
function $b5786db9ce2d798f$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $b5786db9ce2d798f$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($aSksP)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $b5786db9ce2d798f$var$splitDateString(argument);
    var parseYearResult = $b5786db9ce2d798f$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $b5786db9ce2d798f$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $b5786db9ce2d798f$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $fVXeF.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $b5786db9ce2d798f$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $b5786db9ce2d798f$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $b5786db9ce2d798f$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $b5786db9ce2d798f$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $b5786db9ce2d798f$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $b5786db9ce2d798f$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $b5786db9ce2d798f$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $b5786db9ce2d798f$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $b5786db9ce2d798f$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $b5786db9ce2d798f$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $b5786db9ce2d798f$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$b5786db9ce2d798f$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $b5786db9ce2d798f$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$b5786db9ce2d798f$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $b5786db9ce2d798f$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$b5786db9ce2d798f$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $b5786db9ce2d798f$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$b5786db9ce2d798f$var$validateWeekDate(year, week)) return new Date(NaN);
        return $b5786db9ce2d798f$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $b5786db9ce2d798f$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$b5786db9ce2d798f$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $b5786db9ce2d798f$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $b5786db9ce2d798f$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $b5786db9ce2d798f$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$b5786db9ce2d798f$var$validateTime(hours)) return NaN;
        return hours % 24 * $b5786db9ce2d798f$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $b5786db9ce2d798f$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$b5786db9ce2d798f$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $b5786db9ce2d798f$var$MILLISECONDS_IN_HOUR + minutes * $b5786db9ce2d798f$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $b5786db9ce2d798f$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$b5786db9ce2d798f$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $b5786db9ce2d798f$var$MILLISECONDS_IN_HOUR + minutes * $b5786db9ce2d798f$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $b5786db9ce2d798f$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $b5786db9ce2d798f$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $b5786db9ce2d798f$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $b5786db9ce2d798f$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $b5786db9ce2d798f$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $b5786db9ce2d798f$var$isLeapYearIndex(year);
        if (isLeapYear && date > $b5786db9ce2d798f$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $b5786db9ce2d798f$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $b5786db9ce2d798f$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $b5786db9ce2d798f$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $b5786db9ce2d798f$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $b5786db9ce2d798f$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("ZIcI6", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b97fc9d54a6e804$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $0b97fc9d54a6e804$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $0b97fc9d54a6e804$export$2e2bcd8739ae039 = $0b97fc9d54a6e804$var$tzPattern;

});



parcelRegister("6AseU", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cbc02a5e123715e$export$2e2bcd8739ae039);

var $fVXeF = parcelRequire("fVXeF");

var $fzXH2 = parcelRequire("fzXH2");
function $4cbc02a5e123715e$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $fzXH2.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $fVXeF.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});






parcelRegister("7eLbt", function(module, exports) {

$parcel$export(module.exports, "eocGlobalGroupDetailRoute", () => $c40ab0d9ba386fc6$export$e6569aff8dfd4c1d);
const $c40ab0d9ba386fc6$export$e6569aff8dfd4c1d = {
    name: 'eoc-global-group-detail',
    path: '/jira/ops/group-detail/:id',
    exact: true
};

});

parcelRegister("lgLgL", function(module, exports) {

$parcel$export(module.exports, "LazyGroupDetail", () => $009be0886fa71d74$export$8d4b3992eb19d436);
$parcel$export(module.exports, "default", () => $009be0886fa71d74$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $009be0886fa71d74$export$8d4b3992eb19d436 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("339DM")), {
    moduleId: "./src/packages/eoc/group-detail/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$009be0886fa71d74$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $009be0886fa71d74$export$8d4b3992eb19d436,
        pageId: "async-jira-eoc-group-detail",
        shouldShowSpinner: false
    });

});
parcelRegister("339DM", function(module, exports) {

let $2389215c621cd69c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2389215c621cd69c$var$load("ffQaD"),
    $2389215c621cd69c$var$load("kvRbA"),
    $2389215c621cd69c$var$load("fliVL"),
    $2389215c621cd69c$var$load("76n7a"),
    $2389215c621cd69c$var$load("l253H"),
    $2389215c621cd69c$var$load("i4mUU")
]).then(()=>parcelRequire('9kpiP'));

});



parcelRegister("dYoht", function(module, exports) {

$parcel$export(module.exports, "eocTeamGroupDetailRouteEntry", () => $7742cad3c3e8631c$export$2b25520e20820251);

var $8C32n = parcelRequire("8C32n");

var $eYyoJ = parcelRequire("eYyoJ");

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $81IxY = parcelRequire("81IxY");

var $lgLgL = parcelRequire("lgLgL");
const $7742cad3c3e8631c$export$2b25520e20820251 = (0, $7NszV.createEntry)((0, $81IxY.eocTeamGroupDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $lgLgL.default),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $2r8fH.resources)(),
            ...(0, $eYyoJ.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $8C32n.resources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $lgLgL.LazyGroupDetail),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("81IxY", function(module, exports) {

$parcel$export(module.exports, "eocTeamGroupDetailRoute", () => $c70e4aa8d21accf9$export$aa8cf61e94739f21);
const $c70e4aa8d21accf9$export$aa8cf61e94739f21 = {
    name: 'eoc-team-group-detail',
    path: '/jira/ops/teams/:teamId/group-detail/:id',
    exact: true
};

});


parcelRegister("75Ues", function(module, exports) {

$parcel$export(module.exports, "eocHeartbeatsRouteEntry", () => $b7a7f1ceb2ac2c2a$export$2c2d6115c4280a08);

var $90XDC = parcelRequire("90XDC");

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $6tmb0 = parcelRequire("6tmb0");

var $jxkxr = parcelRequire("jxkxr");
const $b7a7f1ceb2ac2c2a$export$2c2d6115c4280a08 = (0, $7NszV.createEntry)((0, $6tmb0.eocHeartbeatsRoute), ()=>({
        group: 'eoc',
        component: (0, $jxkxr.HeartbeatsComponent),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $90XDC.resources)(),
            ...(0, $2r8fH.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jxkxr.LazyHeartbeats),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("90XDC", function(module, exports) {

$parcel$export(module.exports, "heartbeatsResource", () => $ba57cdfcb9409883$export$dd38e2aa5cfda9c9);
$parcel$export(module.exports, "heartbeatsUserRightsResource", () => $ba57cdfcb9409883$export$b5d9a0bcdfa848ce);
$parcel$export(module.exports, "resources", () => $ba57cdfcb9409883$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $6dFjI = parcelRequire("6dFjI");
const $ba57cdfcb9409883$export$dd38e2aa5cfda9c9 = (0, $2M1hQ.createResource)({
    type: 'heartbeatsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `heartbeats/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return (0, $6dFjI.getHeartbeatsEndpoint)(teamId);
    },
    isBrowserOnly: true
});
const $ba57cdfcb9409883$export$b5d9a0bcdfa848ce = (0, $2M1hQ.createResource)({
    type: 'heartbeatsUserRightsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `heartbeats-user-rights/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return (0, $6dFjI.getHeartbeatsUserRights)(teamId);
    },
    isBrowserOnly: true
});
const $ba57cdfcb9409883$export$bc99aaabaf7b70a7 = ()=>[
        $ba57cdfcb9409883$export$dd38e2aa5cfda9c9,
        $ba57cdfcb9409883$export$b5d9a0bcdfa848ce
    ];

});
parcelRegister("6dFjI", function(module, exports) {

$parcel$export(module.exports, "getHeartbeatsEndpoint", () => $9fd5e861ed04ddb5$export$c322dad372dcb08b);
$parcel$export(module.exports, "validateHeartbeatNameEndpoint", () => $9fd5e861ed04ddb5$export$676f6aee59f124b0);
$parcel$export(module.exports, "createHeartbeatEndpoint", () => $9fd5e861ed04ddb5$export$891ea85cc6973b32);
$parcel$export(module.exports, "updateHeartbeatEndpoint", () => $9fd5e861ed04ddb5$export$7311481b59e02e06);
$parcel$export(module.exports, "switchHeartbeatEndpoint", () => $9fd5e861ed04ddb5$export$5df993f1c74d7e8e);
$parcel$export(module.exports, "deleteHeartbeatEndpoint", () => $9fd5e861ed04ddb5$export$716e365975fc2cd1);
$parcel$export(module.exports, "getHeartbeatsUserRights", () => $9fd5e861ed04ddb5$export$26eaca11f3b4e506);
$parcel$export(module.exports, "updateAutoCreationEndpoint", () => $9fd5e861ed04ddb5$export$38097aade6a3b234);

var $j74qU = parcelRequire("j74qU");

var $5AXpX = parcelRequire("5AXpX");
const $9fd5e861ed04ddb5$export$c322dad372dcb08b = (teamId)=>(0, $j74qU.eocFetch)((0, $5AXpX.generateBaseUrl)(teamId), {
        method: 'GET'
    });
const $9fd5e861ed04ddb5$export$676f6aee59f124b0 = (heartbeatName, teamId)=>(0, $j74qU.eocFetch)(`${(0, $5AXpX.generateBaseUrl)(teamId)}/validateEmail?heartbeatName=${encodeURIComponent(heartbeatName)}`, {
        method: 'GET',
        responseType: 'headers'
    });
const $9fd5e861ed04ddb5$export$891ea85cc6973b32 = (heartbeat, teamId)=>(0, $j74qU.eocFetch)((0, $5AXpX.generateBaseUrl)(teamId), {
        method: 'POST',
        body: heartbeat
    });
const $9fd5e861ed04ddb5$export$7311481b59e02e06 = (heartbeat, teamId)=>(0, $j74qU.eocFetch)((0, $5AXpX.generateBaseUrl)(teamId), {
        method: 'PUT',
        body: heartbeat
    });
const $9fd5e861ed04ddb5$export$5df993f1c74d7e8e = (enable, name, teamId)=>(0, $j74qU.eocFetch)(`${(0, $5AXpX.generateBaseUrl)(teamId)}/enable?enabled=${enable}&name=${encodeURIComponent(name)}`, {
        method: 'PATCH'
    });
const $9fd5e861ed04ddb5$export$716e365975fc2cd1 = (name, teamId)=>(0, $j74qU.eocFetch)(`${(0, $5AXpX.generateBaseUrl)(teamId)}?name=${encodeURIComponent(name)}`, {
        method: 'DELETE',
        responseType: 'headers'
    });
const $9fd5e861ed04ddb5$export$26eaca11f3b4e506 = (teamId)=>{
    return (0, $j74qU.eocFetch)(`${(0, $5AXpX.generateBaseUrl)(teamId)}/rights`);
};
const $9fd5e861ed04ddb5$export$38097aade6a3b234 = (teamId, autoCreateEnabled)=>(0, $j74qU.eocFetch)(`${(0, $5AXpX.generateBaseUrl)(teamId)}/updateHeartbeatAutoCreation?autoCreateEnabled=${autoCreateEnabled}`, {
        method: 'POST',
        responseType: 'headers'
    });

});
parcelRegister("5AXpX", function(module, exports) {

$parcel$export(module.exports, "getMaxAvailableEpoch", () => $9de5e8fd83468bcc$export$1eaa8fc6df8a5dac);
$parcel$export(module.exports, "generateBaseUrl", () => $9de5e8fd83468bcc$export$25e86c63685d7e40);

var $awLan = parcelRequire("awLan");
const $9de5e8fd83468bcc$export$1eaa8fc6df8a5dac = ()=>{
    const today = new Date();
    const futureDate = new Date();
    futureDate.setFullYear(today.getFullYear() * (0, $awLan.MAX_INTERVAL_TIME_YEARS));
    const epochTime = futureDate.getTime();
    return epochTime;
};
const $9de5e8fd83468bcc$export$25e86c63685d7e40 = (teamId)=>{
    return teamId ? `/v1/teams/${teamId}/heartbeats` : '/v1/heartbeats';
};

});
parcelRegister("awLan", function(module, exports) {

$parcel$export(module.exports, "MAX_INTERVAL_TIME_YEARS", () => $a03a59daffb82f94$export$c3f9ae43b3ab397c);
$parcel$export(module.exports, "MIN_DATE_SHOWN_EPOCH", () => $a03a59daffb82f94$export$f081f690fcb957ce);
$parcel$export(module.exports, "SPOTLIGHT_NAMES", () => $a03a59daffb82f94$export$a7c923252528b255);
const $a03a59daffb82f94$export$c3f9ae43b3ab397c = 5;
const $a03a59daffb82f94$export$f081f690fcb957ce = 946677600;
const $a03a59daffb82f94$export$a7c923252528b255 = {
    actions: 'eoc-heartbeats_actions'
};

});




parcelRegister("6tmb0", function(module, exports) {

$parcel$export(module.exports, "eocHeartbeatsRoute", () => $99f0aed6abda0a94$export$71bd833dcb7bd1e9);
const $99f0aed6abda0a94$export$71bd833dcb7bd1e9 = {
    name: 'eoc-heartbeats',
    path: '/jira/ops/teams/:teamId/heartbeats',
    exact: true
};

});

parcelRegister("jxkxr", function(module, exports) {

$parcel$export(module.exports, "LazyHeartbeats", () => $e4872049cbc66669$export$93c9586b023b5aa3);
$parcel$export(module.exports, "HeartbeatsComponent", () => $e4872049cbc66669$export$43c2d87bd51ba6ac);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $e4872049cbc66669$export$93c9586b023b5aa3 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("tKNMQ")), {
    moduleId: "./src/packages/eoc/heartbeats/src/index.tsx"
});
const $e4872049cbc66669$export$43c2d87bd51ba6ac = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e4872049cbc66669$export$93c9586b023b5aa3,
        pageId: "async-jira-eoc-heartbeats",
        shouldShowSpinner: false
    });

});
parcelRegister("tKNMQ", function(module, exports) {

let $05970373df817cd2$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $05970373df817cd2$var$load("ffQaD"),
    $05970373df817cd2$var$load("kvRbA"),
    $05970373df817cd2$var$load("bnWkb")
]).then(()=>parcelRequire('4uAlQ'));

});



parcelRegister("4Yh3B", function(module, exports) {

$parcel$export(module.exports, "eocGlobalHeartbeatsRouteEntry", () => $17d1dcee95d05254$export$2d7875aa465a7757);

var $90XDC = parcelRequire("90XDC");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $70VNh = parcelRequire("70VNh");

var $eZXFU = parcelRequire("eZXFU");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

var $jxkxr = parcelRequire("jxkxr");
const $17d1dcee95d05254$var$getNavigationSpecifications = ()=>{
    return ((0, $4R6GH.fg)('operations_nav4_remaining_items_old_navigation_fix') ? (0, $3HwlS.getWillShowNav4)() : true) && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $17d1dcee95d05254$export$2d7875aa465a7757 = (0, $7NszV.createEntry)((0, $70VNh.eocGlobalHeartbeatsRoute), ()=>({
        group: 'eoc',
        component: (0, $jxkxr.HeartbeatsComponent),
        layout: (0, $eZXFU.opsSettingsLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $90XDC.resources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$17d1dcee95d05254$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jxkxr.LazyHeartbeats)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jxkxr.LazyHeartbeats)
        ]
    }));

});
parcelRegister("70VNh", function(module, exports) {

$parcel$export(module.exports, "eocGlobalHeartbeatsRoute", () => $efe21b9fcd2adca8$export$48568054c59facbb);
const $efe21b9fcd2adca8$export$48568054c59facbb = {
    name: 'eoc-global-heartbeats',
    path: '/jira/settings/products/ops/heartbeats',
    exact: true
};

});


parcelRegister("4iFpq", function(module, exports) {

$parcel$export(module.exports, "globalIncomingCallDetailRouteEntry", () => $91ad9944e0af1355$export$39f40714591c98c0);

var $5uXOq = parcelRequire("5uXOq");

var $4C2Pb = parcelRequire("4C2Pb");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $1oUsV = parcelRequire("1oUsV");

var $5j7Th = parcelRequire("5j7Th");

var $hHoID = parcelRequire("hHoID");
const $91ad9944e0af1355$var$IncomingCallDetail = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $hHoID.LazyIncomingCallDetail),
        pageId: "async-jira-eoc-incoming-call-detail",
        shouldShowSpinner: false
    });
const $91ad9944e0af1355$export$39f40714591c98c0 = (0, $7NszV.createEntry)((0, $1oUsV.globalIncomingCallDetailRoute), ()=>({
        group: 'eoc',
        component: $91ad9944e0af1355$var$IncomingCallDetail,
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $4C2Pb.detailResources)()
        ],
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hHoID.LazyIncomingCall)
        ]
    }));

});
parcelRegister("4C2Pb", function(module, exports) {

$parcel$export(module.exports, "listResources", () => $e9a4d4d3026c87cf$export$c83d9fd41123ab31);
$parcel$export(module.exports, "detailResources", () => $e9a4d4d3026c87cf$export$63630293105c0f4e);

var $ffEPd = parcelRequire("ffEPd");

var $3zzQS = parcelRequire("3zzQS");
const $e9a4d4d3026c87cf$export$c83d9fd41123ab31 = ()=>[
        (0, $3zzQS.listResource)
    ];
const $e9a4d4d3026c87cf$export$63630293105c0f4e = ()=>[
        (0, $ffEPd.detailResource)
    ];

});
parcelRegister("ffEPd", function(module, exports) {

$parcel$export(module.exports, "detailResource", () => $d2ad11d314356b50$export$13d78d45f8054f1e);

var $2M1hQ = parcelRequire("2M1hQ");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $bKopM = parcelRequire("bKopM");
const $d2ad11d314356b50$export$13d78d45f8054f1e = (0, $2M1hQ.createResource)({
    type: 'getDetailResource',
    getKey: ()=>'getDetailResource',
    getData: async (routerContext)=>{
        const id = routerContext.match.params?.id;
        (0, $hmVmJ.assert)(!!id, new (0, $dH6Pi.AssertionError)('detailResource', 'id should be set to fetch incoming call detail'));
        return (0, $bKopM.getDetail)(id);
    },
    isBrowserOnly: true
});

});
parcelRegister("bKopM", function(module, exports) {

$parcel$export(module.exports, "getDetail", () => $3e9eec2aa2136224$export$d6c3faeb2ce9d297);

var $j74qU = parcelRequire("j74qU");

var $7PepW = parcelRequire("7PepW");
const $3e9eec2aa2136224$export$d6c3faeb2ce9d297 = (id)=>{
    const endpoint = `${(0, $7PepW.urls).incomingCall.detail.url(id)}`;
    return (0, $j74qU.eocFetch)(endpoint);
};

});
parcelRegister("7PepW", function(module, exports) {

$parcel$export(module.exports, "urls", () => $5edaa37a3b09374b$export$bcae9ba627f604b6);
const $5edaa37a3b09374b$export$bcae9ba627f604b6 = Object.freeze({
    incomingCall: {
        url: ()=>`/v1/incoming-call`,
        detail: {
            url: (incomingCallId = ':incomingCallId')=>`${$5edaa37a3b09374b$export$bcae9ba627f604b6.incomingCall.url()}/${incomingCallId}`
        }
    }
});

});



parcelRegister("3zzQS", function(module, exports) {

$parcel$export(module.exports, "listResource", () => $c316e599070576e5$export$5ee018e9baf9d633);

var $eURsm = parcelRequire("eURsm");

var $9FZzU = parcelRequire("9FZzU");
const $c316e599070576e5$export$5ee018e9baf9d633 = (0, $eURsm.createPaginatedResource)({
    type: 'getListResource',
    getKey: ()=>'getListResource',
    getData: ()=>(0, $9FZzU.getList),
    isBrowserOnly: true
});

});
parcelRegister("eURsm", function(module, exports) {

$parcel$export(module.exports, "createPaginatedResource", () => $9723334731b55493$export$561b032e4d26d1e8);

var $2M1hQ = parcelRequire("2M1hQ");
const $9723334731b55493$export$561b032e4d26d1e8 = ({ getData: getData, getKey: getKey, ...arg })=>{
    return (0, $2M1hQ.createResource)({
        ...arg,
        getKey: (routerContext, customContext)=>{
            const { query: query } = routerContext;
            const page = query['page'] || '1';
            const key = `${getKey(routerContext, customContext)}#${page}`;
            return key;
        },
        getData: (routerContext, customContext)=>{
            const { query: query } = routerContext;
            const page = parseInt(query['page']) || 1;
            return getData(routerContext, customContext)({
                page: page
            });
        }
    });
};

});

parcelRegister("9FZzU", function(module, exports) {

$parcel$export(module.exports, "getList", () => $3bbdbabf459bda32$export$73fffd6dda5144e);
$parcel$export(module.exports, "addIncomingCall", () => $3bbdbabf459bda32$export$cdae09ff00c893b2);

var $j74qU = parcelRequire("j74qU");

var $7PepW = parcelRequire("7PepW");
const $3bbdbabf459bda32$export$73fffd6dda5144e = ({ page: page })=>{
    const limit = 20;
    const offset = (page - 1) * limit;
    const params = new URLSearchParams({
        offset: `${offset}`,
        limit: `${limit}`,
        sortBy: 'name',
        sort: 'asc'
    });
    const endpoint = `${(0, $7PepW.urls).incomingCall.url()}?${params.toString()}`;
    return (0, $j74qU.eocFetch)(endpoint).then(({ data: data, count: count })=>{
        return {
            data: data,
            count: Math.ceil(count / limit)
        };
    });
};
const $3bbdbabf459bda32$export$cdae09ff00c893b2 = (params)=>{
    return (0, $j74qU.eocFetch)((0, $7PepW.urls).incomingCall.url(), {
        method: 'POST',
        body: params
    });
};

});



parcelRegister("1oUsV", function(module, exports) {

$parcel$export(module.exports, "globalIncomingCallDetailRoute", () => $f3c8c21142f35b35$export$10f19333da6ac52c);
const $f3c8c21142f35b35$export$10f19333da6ac52c = {
    name: 'eoc-incoming-call-detail',
    path: '/jira/settings/products/ops/incoming-call/:id',
    exact: true
};

});

parcelRegister("hHoID", function(module, exports) {

$parcel$export(module.exports, "LazyIncomingCall", () => $304419cc9d82ded9$export$d76e6607b7e88a7b);
$parcel$export(module.exports, "LazyIncomingCallDetail", () => $304419cc9d82ded9$export$1c56f2b1fdd5d724);

var $kxZPA = parcelRequire("kxZPA");

const $304419cc9d82ded9$export$d76e6607b7e88a7b = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("gYZW6")).then((module)=>module.IncomingCallPage), {
    moduleId: "./src/packages/eoc/incoming-call/src/index.tsx"
});

const $304419cc9d82ded9$export$1c56f2b1fdd5d724 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("gYZW6")).then((module)=>module.IncomingCallDetailPage), {
    moduleId: "./src/packages/eoc/incoming-call/src/index.tsx"
});

});
parcelRegister("gYZW6", function(module, exports) {

let $c5d24b26b83ea2c2$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c5d24b26b83ea2c2$var$load("ffQaD"),
    $c5d24b26b83ea2c2$var$load("kvRbA"),
    $c5d24b26b83ea2c2$var$load("5NUjK")
]).then(()=>parcelRequire('8oycJ'));

});



parcelRegister("kvJxs", function(module, exports) {

$parcel$export(module.exports, "globalIncomingCallRouteEntry", () => $06d17d7f82b9f72c$export$bf8ccc758901febd);

var $5uXOq = parcelRequire("5uXOq");

var $4C2Pb = parcelRequire("4C2Pb");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $eZXFU = parcelRequire("eZXFU");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $jWsFA = parcelRequire("jWsFA");

var $5j7Th = parcelRequire("5j7Th");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

var $hHoID = parcelRequire("hHoID");
const $06d17d7f82b9f72c$var$IncomingCall = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $hHoID.LazyIncomingCall),
        pageId: "async-jira-eoc-incoming-call",
        shouldShowSpinner: false
    });
const $06d17d7f82b9f72c$var$getNavigationSpecifications = ()=>{
    return ((0, $4R6GH.fg)('operations_nav4_remaining_items_old_navigation_fix') ? (0, $3HwlS.getWillShowNav4)() : true) && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $06d17d7f82b9f72c$export$bf8ccc758901febd = (0, $7NszV.createEntry)((0, $jWsFA.globalIncomingCallRoute), ()=>({
        group: 'eoc',
        component: $06d17d7f82b9f72c$var$IncomingCall,
        layout: (0, $eZXFU.opsSettingsLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $4C2Pb.listResources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$06d17d7f82b9f72c$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hHoID.LazyIncomingCall)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hHoID.LazyIncomingCall)
        ]
    }));

});
parcelRegister("jWsFA", function(module, exports) {

$parcel$export(module.exports, "globalIncomingCallRoute", () => $6e436edec71d75e1$export$8dd2e8adca05d8a3);
const $6e436edec71d75e1$export$8dd2e8adca05d8a3 = {
    name: 'eoc-incoming-call',
    path: '/jira/settings/products/ops/incoming-call',
    exact: true
};

});


parcelRegister("kxvlX", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationCreateRouteEntry", () => $675ac2c2cf4991e7$export$62eef9a2917f041f);

var $g9g6m = parcelRequire("g9g6m");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $iojZc = parcelRequire("iojZc");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

var $jNNfq = parcelRequire("jNNfq");

var $2PI2S = parcelRequire("2PI2S");

var $kEMby = parcelRequire("kEMby");
const $675ac2c2cf4991e7$var$getNavigationSpecifications = ()=>{
    return ((0, $4R6GH.fg)('operations_nav4_remaining_items_old_navigation_fix') ? (0, $3HwlS.getWillShowNav4)() : true) && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $675ac2c2cf4991e7$export$62eef9a2917f041f = (0, $7NszV.createEntry)((0, $iojZc.globalIntegrationCreateRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/settings/products/ops',
        component: (0, $jNNfq.IntegrationAutomation),
        slot: (0, $2PI2S.IntegrationCreate),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $g9g6m.resources).configuredIntegrationsResource,
            (0, $g9g6m.resources).integrationListResource,
            (0, $g9g6m.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$675ac2c2cf4991e7$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation)
        ]
    }));

});
parcelRegister("g9g6m", function(module, exports) {

$parcel$export(module.exports, "resources", () => $97e7bbf09fde8a26$export$bc99aaabaf7b70a7);

var $5WVG8 = parcelRequire("5WVG8");

var $hVeqx = parcelRequire("hVeqx");

var $h4DSB = parcelRequire("h4DSB");
const $97e7bbf09fde8a26$export$bc99aaabaf7b70a7 = {
    configuredIntegrationsResource: $5WVG8.configuredIntegrationsResource,
    integrationListResource: $hVeqx.integrationListResource,
    userAccessRightsResource: $h4DSB.userAccessRightsResource
};

});
parcelRegister("5WVG8", function(module, exports) {

$parcel$export(module.exports, "configuredIntegrationsResource", () => $83d54f0caf3b9996$export$4136019b80be5917);

var $2M1hQ = parcelRequire("2M1hQ");

var $6nRK2 = parcelRequire("6nRK2");

var $7suNB = parcelRequire("7suNB");

const $83d54f0caf3b9996$export$4136019b80be5917 = (0, $2M1hQ.createResource)({
    type: 'configuredIntegrationsResource',
    getKey: ({ query: query, match: match })=>{
        const teamId = match.params.teamId ?? query['teamId'];
        const group = query['group'];
        const keyword = query['keyword'];
        const status = query['status'];
        const page = query['page'] || '1';
        return (0, $6nRK2.UrlHelper)((0, $cf8709d20bdba1b1$export$bc7daa294a7c75e4), {
            [(0, $cf8709d20bdba1b1$export$d26137cf824a9e53)]: page,
            [(0, $cf8709d20bdba1b1$export$299579ccbdd63cbc)]: keyword,
            [(0, $cf8709d20bdba1b1$export$d7415cfdee4bffc8)]: group,
            [(0, $cf8709d20bdba1b1$export$ce2c93e90dda8613)]: status,
            [(0, $cf8709d20bdba1b1$export$4e0ddb4dc97eb573)]: teamId
        });
    },
    getData: (routerContext)=>(0, $7suNB.default).getIntegrations(routerContext.query, routerContext.match.params.teamId),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("6nRK2", function(module, exports) {

$parcel$export(module.exports, "UrlHelper", () => $15b449f9b21b0a2a$export$bacbc496e850c0a4);
const $15b449f9b21b0a2a$export$bacbc496e850c0a4 = (path, params = {})=>{
    // https://github.com/microsoft/TypeScript/issues/16655
    const q = Object.entries(params).map(([k, v])=>v !== '' && !!v || v === false ? [
            k,
            v.toString()
        ] : undefined).filter((v)=>!!v);
    // Using %2C in URLs causes bugs in AngularJS, so we need to replace it with comma
    const qs = new URLSearchParams(q).toString().replace(/%2C/g, ',');
    return `${path}${qs ? `?${qs}` : ''}`;
};

});

parcelRegister("7suNB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6c9b0fd99b09a25$export$2e2bcd8739ae039);

var $j74qU = parcelRequire("j74qU");

var $6nRK2 = parcelRequire("6nRK2");

const $f6c9b0fd99b09a25$var$getIntegrations = async (query, pathParamTeamId)=>{
    const page = parseInt(query['page']) || 1;
    const offset = (page - 1) * (0, $38fc251fc66fc98a$export$31ecae7225aecec6);
    const queryParams = query ? {
        teamId: pathParamTeamId ?? query.teamId,
        group: query.group,
        keyword: query.keyword,
        status: query.status
    } : {};
    return (0, $j74qU.eocFetch)((0, $6nRK2.UrlHelper)('/v3/integrations/unified', {
        ...queryParams,
        offset: offset.toString(),
        limit: (0, $38fc251fc66fc98a$export$31ecae7225aecec6)
    })).then((response)=>({
            data: response.data.integrations,
            pageCount: Math.ceil(response.data.count / (0, $38fc251fc66fc98a$export$31ecae7225aecec6)),
            itemCount: response.data.count,
            platformTeamId: response.data.platformTeamId
        }));
};
const $f6c9b0fd99b09a25$var$patchIntegration = async (integrationId, integrationType, body, teamId)=>(0, $j74qU.eocFetch)((0, $6nRK2.UrlHelper)(`/v3/integrations/unified/${integrationId}`, {
        type: integrationType,
        teamId: teamId
    }), {
        method: 'PATCH',
        body: body
    }).then((response)=>response.data);
const $f6c9b0fd99b09a25$var$deleteIntegration = async (integrationId, integrationType, teamId)=>(0, $j74qU.eocFetch)((0, $6nRK2.UrlHelper)(`/v3/integrations/unified/${integrationId}`, {
        type: integrationType,
        teamId: teamId
    }), {
        method: 'DELETE',
        responseType: 'headers'
    });
var $f6c9b0fd99b09a25$export$2e2bcd8739ae039 = {
    getIntegrations: $f6c9b0fd99b09a25$var$getIntegrations,
    patchIntegration: $f6c9b0fd99b09a25$var$patchIntegration,
    deleteIntegration: $f6c9b0fd99b09a25$var$deleteIntegration
};

});
const $38fc251fc66fc98a$export$31ecae7225aecec6 = 20;


const $cf8709d20bdba1b1$export$bc7daa294a7c75e4 = 'configuredIntegrationsResource';
const $cf8709d20bdba1b1$export$d26137cf824a9e53 = 'page';
const $cf8709d20bdba1b1$export$299579ccbdd63cbc = 'keyword';
const $cf8709d20bdba1b1$export$d7415cfdee4bffc8 = 'group';
const $cf8709d20bdba1b1$export$ce2c93e90dda8613 = 'status';
const $cf8709d20bdba1b1$export$4e0ddb4dc97eb573 = 'teamId';


parcelRegister("hVeqx", function(module, exports) {

$parcel$export(module.exports, "integrationListResource", () => $d497f8a5feefb0d5$export$f60a40a11a6e0ee4);

var $2M1hQ = parcelRequire("2M1hQ");

var $jYQAI = parcelRequire("jYQAI");
const $d497f8a5feefb0d5$export$f60a40a11a6e0ee4 = (0, $2M1hQ.createResource)({
    type: 'integrationListResource',
    getKey: ({ query: query })=>{
        const group = query['group'];
        const keyword = query['keyword'];
        return `integrationListResource?group=${group}&keyword=${keyword}`;
    },
    getData: async (routerContext)=>await (0, $jYQAI.default).getIntegrationList(routerContext.query, routerContext.match.params.teamId),
    maxAge: 300000,
    isBrowserOnly: true
});

});
parcelRegister("jYQAI", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e286a884592e027$export$2e2bcd8739ae039);

var $j74qU = parcelRequire("j74qU");

var $6nRK2 = parcelRequire("6nRK2");
const $1e286a884592e027$var$getIntegrationList = (query, teamId)=>{
    const { keyword: keyword, group: group } = query ?? {};
    return (0, $j74qU.eocFetch)((0, $6nRK2.UrlHelper)(`/v3/integrations/unified/supported-integrations`, {
        keyword: keyword,
        group: group,
        teamId: teamId
    })).then((response)=>{
        const { labels: labels, availableGroups: availableGroups, allTypes: allTypes, platformTeamId: platformTeamId } = response.data;
        return {
            labels: labels,
            availableGroups: availableGroups,
            allTypes: allTypes,
            platformTeamId: platformTeamId
        };
    });
};
const $1e286a884592e027$var$getIntegrationTypes = (integrationType, teamId)=>(0, $j74qU.eocFetch)((0, $6nRK2.UrlHelper)(`/v3/integrations/unified/${integrationType}/types`, {
        teamId: teamId
    })).then((response)=>response.data.map((integrationType)=>({
                ...integrationType,
                value: integrationType.type,
                label: integrationType.displayName
            })));
var $1e286a884592e027$export$2e2bcd8739ae039 = {
    getIntegrationList: $1e286a884592e027$var$getIntegrationList,
    getIntegrationTypes: $1e286a884592e027$var$getIntegrationTypes
};

});


parcelRegister("h4DSB", function(module, exports) {

$parcel$export(module.exports, "userAccessRightsResource", () => $955f19580ff30efa$export$69ddc7cc64ae9a02);

var $2M1hQ = parcelRequire("2M1hQ");

var $ifvD2 = parcelRequire("ifvD2");
const $955f19580ff30efa$export$69ddc7cc64ae9a02 = (0, $2M1hQ.createResource)({
    type: 'userAccessRightsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params.teamId;
        return `userAccessRightsResource#${!!teamId ? teamId : ''}`;
    },
    getData: (routerContext)=>(0, $ifvD2.getUserRights)(routerContext.match.params.teamId),
    maxAge: 3600000,
    isBrowserOnly: true
});

});
parcelRegister("ifvD2", function(module, exports) {

$parcel$export(module.exports, "getUserRights", () => $82efdac2c3d222dc$export$84e2ed279bc4e64e);

var $j74qU = parcelRequire("j74qU");

var $6nRK2 = parcelRequire("6nRK2");
const $82efdac2c3d222dc$export$84e2ed279bc4e64e = (teamId)=>{
    return (0, $j74qU.eocFetch)((0, $6nRK2.UrlHelper)(`/v3/integrations/unified/rights`, {
        teamId: teamId
    })).then((response)=>response.data);
};

});



parcelRegister("iojZc", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationCreateRoute", () => $9976afa23f08aee0$export$bb272d36e3c3b7c1);
const $9976afa23f08aee0$export$bb272d36e3c3b7c1 = {
    name: 'eoc-integration-create',
    path: '/jira/settings/products/ops/integrations/create/:type',
    exact: true
};

});

parcelRegister("jNNfq", function(module, exports) {

$parcel$export(module.exports, "IntegrationAutomation", () => $3543a714bb5eb15f$export$434c3e2269913ac0);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kEMby = parcelRequire("kEMby");
const $3543a714bb5eb15f$export$434c3e2269913ac0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $kEMby.LazyIntegrationAutomation),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });

});
parcelRegister("kEMby", function(module, exports) {

$parcel$export(module.exports, "LazyIntegrationAutomation", () => $bd50af419902000e$export$68c40afda0287b61);
$parcel$export(module.exports, "LazyIntegrationDetail", () => $bd50af419902000e$export$fd7f60e3df94c902);
$parcel$export(module.exports, "LazyIntegrationCreate", () => $bd50af419902000e$export$aa9358ade7cb53ee);
$parcel$export(module.exports, "LazyIntegrationList", () => $bd50af419902000e$export$993132b847f26efa);
$parcel$export(module.exports, "LazyIntegrationLog", () => $bd50af419902000e$export$b02ef932401d95fc);

var $kxZPA = parcelRequire("kxZPA");

const $bd50af419902000e$export$68c40afda0287b61 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("2Lsjb")).then((module)=>module.IntegrationAutomation), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

const $bd50af419902000e$export$fd7f60e3df94c902 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("2Lsjb")).then((module)=>module.IntegrationDetail), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

const $bd50af419902000e$export$aa9358ade7cb53ee = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("2Lsjb")).then((module)=>module.IntegrationCreate), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

const $bd50af419902000e$export$993132b847f26efa = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("2Lsjb")).then((module)=>module.IntegrationList), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

const $bd50af419902000e$export$b02ef932401d95fc = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("2Lsjb")).then((module)=>module.IntegrationLog), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

});
parcelRegister("2Lsjb", function(module, exports) {

let $2035ee0662388660$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2035ee0662388660$var$load("ffQaD"),
    $2035ee0662388660$var$load("kvRbA"),
    $2035ee0662388660$var$load("76n7a"),
    $2035ee0662388660$var$load("l253H"),
    $2035ee0662388660$var$load("4btFi")
]).then(()=>parcelRequire('5QWfc'));

});



parcelRegister("2PI2S", function(module, exports) {

$parcel$export(module.exports, "IntegrationCreate", () => $1b0aeecb6549cd04$export$5cb14595364f02c);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kEMby = parcelRequire("kEMby");
const $1b0aeecb6549cd04$export$5cb14595364f02c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $kEMby.LazyIntegrationCreate),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });

});


parcelRegister("0e4yJ", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationDetailRouteEntry", () => $127c0a8b66d1f657$export$b66abbccbf93e9ad);

var $g9g6m = parcelRequire("g9g6m");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $80hVz = parcelRequire("80hVz");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

var $jNNfq = parcelRequire("jNNfq");

var $7ifqF = parcelRequire("7ifqF");

var $kEMby = parcelRequire("kEMby");
const $127c0a8b66d1f657$var$getNavigationSpecifications = ()=>{
    return ((0, $4R6GH.fg)('operations_nav4_remaining_items_old_navigation_fix') ? (0, $3HwlS.getWillShowNav4)() : true) && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $127c0a8b66d1f657$export$b66abbccbf93e9ad = (0, $7NszV.createEntry)((0, $80hVz.globalIntegrationDetailRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/settings/products/ops',
        component: (0, $jNNfq.IntegrationAutomation),
        slot: (0, $7ifqF.IntegrationDetail),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $g9g6m.resources).configuredIntegrationsResource,
            (0, $g9g6m.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$127c0a8b66d1f657$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation)
        ]
    }));

});
parcelRegister("80hVz", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationDetailRoute", () => $5333a62eb0093759$export$f826f15073eda98);
const $5333a62eb0093759$export$f826f15073eda98 = {
    name: 'eoc-integration-detail',
    path: '/jira/settings/products/ops/integrations/:type/:integrationId',
    exact: true
};

});

parcelRegister("7ifqF", function(module, exports) {

$parcel$export(module.exports, "IntegrationDetail", () => $73ab5160c11e08af$export$8bb99f196e0be5b6);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kEMby = parcelRequire("kEMby");
const $73ab5160c11e08af$export$8bb99f196e0be5b6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $kEMby.LazyIntegrationDetail),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });

});


parcelRegister("4mhUQ", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationListRouteEntry", () => $ed52be46c53ae197$export$790602da39f8af00);

var $g9g6m = parcelRequire("g9g6m");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $hNbjv = parcelRequire("hNbjv");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

var $jNNfq = parcelRequire("jNNfq");

var $3cv8c = parcelRequire("3cv8c");

var $kEMby = parcelRequire("kEMby");
const $ed52be46c53ae197$var$getNavigationSpecifications = ()=>{
    return ((0, $4R6GH.fg)('operations_nav4_remaining_items_old_navigation_fix') ? (0, $3HwlS.getWillShowNav4)() : true) && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $ed52be46c53ae197$export$790602da39f8af00 = (0, $7NszV.createEntry)((0, $hNbjv.globalIntegrationListRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/settings/products/ops',
        component: (0, $jNNfq.IntegrationAutomation),
        slot: (0, $3cv8c.IntegrationList),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $g9g6m.resources).integrationListResource,
            (0, $g9g6m.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$ed52be46c53ae197$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation)
        ]
    }));

});
parcelRegister("hNbjv", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationListRoute", () => $acf744aa66a83413$export$270e16f240db883b);
const $acf744aa66a83413$export$270e16f240db883b = {
    name: 'eoc-integration-list',
    path: '/jira/settings/products/ops/integrations/list',
    exact: true
};

});

parcelRegister("3cv8c", function(module, exports) {

$parcel$export(module.exports, "IntegrationList", () => $e524b7820b9b172f$export$955768269b79c203);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kEMby = parcelRequire("kEMby");
const $e524b7820b9b172f$export$955768269b79c203 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $kEMby.LazyIntegrationList),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });

});


parcelRegister("lcAQi", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationLogRouteEntry", () => $6535404a8c018f23$export$d30f51d0f351bd8a);

var $c4Buu = parcelRequire("c4Buu");

var $g9g6m = parcelRequire("g9g6m");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $7GYMz = parcelRequire("7GYMz");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

var $jNNfq = parcelRequire("jNNfq");

var $5pZel = parcelRequire("5pZel");

var $kEMby = parcelRequire("kEMby");
const $6535404a8c018f23$var$getNavigationSpecifications = ()=>{
    return ((0, $4R6GH.fg)('operations_nav4_remaining_items_old_navigation_fix') ? (0, $3HwlS.getWillShowNav4)() : true) && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $6535404a8c018f23$export$d30f51d0f351bd8a = (0, $7NszV.createEntry)((0, $7GYMz.globalIntegrationLogRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/settings/products/ops',
        component: (0, $jNNfq.IntegrationAutomation),
        slot: (0, $5pZel.IntegrationLog),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $c4Buu.resources)(),
            (0, $g9g6m.resources).configuredIntegrationsResource,
            (0, $g9g6m.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$6535404a8c018f23$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation)
        ]
    }));

});
parcelRegister("c4Buu", function(module, exports) {

$parcel$export(module.exports, "resources", () => $6eed7288156ead59$export$bc99aaabaf7b70a7);
$parcel$export(module.exports, "downloadResources", () => $6eed7288156ead59$export$8571305c82629fe4);

var $jxRF2 = parcelRequire("jxRF2");

var $k5TFj = parcelRequire("k5TFj");

var $8qZNT = parcelRequire("8qZNT");

var $lCbSp = parcelRequire("lCbSp");
const $6eed7288156ead59$export$bc99aaabaf7b70a7 = ()=>[
        (0, $lCbSp.uiSettingsResource),
        (0, $8qZNT.logsResource),
        ...(0, $jxRF2.eocCommonResources)()
    ];
const $6eed7288156ead59$export$8571305c82629fe4 = ()=>[
        (0, $k5TFj.downloadAuditLogsResource),
        ...(0, $jxRF2.eocCommonResources)()
    ];

});
parcelRegister("k5TFj", function(module, exports) {

$parcel$export(module.exports, "downloadAuditLogsResource", () => $62049603e7f7b61b$export$304da75014b88b78);

var $2M1hQ = parcelRequire("2M1hQ");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $kg5A9 = parcelRequire("kg5A9");
const $62049603e7f7b61b$export$304da75014b88b78 = (0, $2M1hQ.createResource)({
    type: 'download-audit-logs-resource',
    getKey: ()=>'download-audit-logs-resource',
    getData: async (routerContext)=>{
        const uniqueKey = routerContext.match.params.exportUniqueKey;
        (0, $hmVmJ.assert)(!!uniqueKey, new (0, $dH6Pi.AssertionError)('downloadAuditLogs resource', 'uniqueKey must be defined'));
        return (0, $kg5A9.fetchDownloadLinkEndpoint)(uniqueKey);
    },
    maxAge: 0,
    isBrowserOnly: true
});

});
parcelRegister("kg5A9", function(module, exports) {

$parcel$export(module.exports, "fetchDownloadLinkEndpoint", () => $7bc9ff634e8ba041$export$c8df7e5942ba1d96);

var $j74qU = parcelRequire("j74qU");
const $7bc9ff634e8ba041$export$c8df7e5942ba1d96 = async (exportUniqueKey)=>{
    return (0, $j74qU.eocFetch)(`/v1/logs/export/${exportUniqueKey}/download`, {
        responseType: 'text'
    });
};

});


parcelRegister("8qZNT", function(module, exports) {

$parcel$export(module.exports, "logsResource", () => $37d900392ed354d4$export$fd88b4310d3f52ff);

var $2M1hQ = parcelRequire("2M1hQ");

var $kWKaa = parcelRequire("kWKaa");
const $37d900392ed354d4$export$fd88b4310d3f52ff = (0, $2M1hQ.createResource)({
    type: 'ui-get-logs',
    getKey: (routerContext)=>{
        const integrationId = routerContext.match.params.integrationId;
        const urlParam = new URLSearchParams();
        Object.entries(routerContext.query).forEach(([key, value])=>{
            if (value) urlParam.set(key, value);
        });
        return !!integrationId ? `integration-${integrationId}-logs#${urlParam.toString()}` : `ui-get-logs#${urlParam.toString()}`;
    },
    getData: async (routerContext)=>{
        return (0, $kWKaa.fetchLogs)({
            fromUnit: routerContext.query?.fromUnit,
            fromValue: routerContext.query?.fromValue,
            startTimestamp: routerContext.query?.startTimestamp,
            endTimestamp: routerContext.query?.endTimestamp,
            eventCategories: routerContext.query?.eventCategories,
            levels: routerContext.query?.levels,
            size: routerContext.query?.size ?? 30,
            insertedAt: routerContext.query?.insertedAt,
            searchString: routerContext.query?.searchString,
            pageDirection: routerContext.query?.pageDirection ?? 'NEXT',
            integrationId: routerContext.match.params.integrationId
        });
    },
    maxAge: 60000,
    isBrowserOnly: true
});

});
parcelRegister("kWKaa", function(module, exports) {

$parcel$export(module.exports, "fetchLogs", () => $ccc9d84c3a4ba264$export$b9fcc8145a518db4);

var $j74qU = parcelRequire("j74qU");

var $7sija = parcelRequire("7sija");
const $ccc9d84c3a4ba264$export$b9fcc8145a518db4 = async (params)=>{
    const urlParams = (0, $7sija.generateLogParams)(params);
    return (0, $j74qU.eocFetch)('/v1/logs/search?' + urlParams.toString()).then((response)=>(0, $7sija.postProcessLogsSearch)(urlParams, response));
};

});
parcelRegister("7sija", function(module, exports) {

$parcel$export(module.exports, "isValidTimePeriodFormat", () => $102956f839e5f725$export$2214112898027187);
$parcel$export(module.exports, "getBetweenErrorMessage", () => $102956f839e5f725$export$b29a6f1d6d345720);
$parcel$export(module.exports, "isValidBetweenInput", () => $102956f839e5f725$export$7b619dd534dac336);
$parcel$export(module.exports, "isInvalidDateValue", () => $102956f839e5f725$export$f18cd4bc58b99a27);
$parcel$export(module.exports, "checkQueryIncludesValue", () => $102956f839e5f725$export$792d5c0a6d15a15e);
$parcel$export(module.exports, "parseGroupOptionQuery", () => $102956f839e5f725$export$f344cca10df5ca13);
$parcel$export(module.exports, "parseOptionQuery", () => $102956f839e5f725$export$100c2d7fc380fbfa);
$parcel$export(module.exports, "collectQueryParamsFromOptions", () => $102956f839e5f725$export$4db9080fab1bce85);
$parcel$export(module.exports, "calculateTimeBetween", () => $102956f839e5f725$export$42dac873831f0e2);
$parcel$export(module.exports, "generateLogParams", () => $102956f839e5f725$export$85293a2f3995ddcc);
$parcel$export(module.exports, "fromUnitConverter", () => $102956f839e5f725$export$ae02811946c03a4b);
$parcel$export(module.exports, "createBaseQuery", () => $102956f839e5f725$export$9a8301702bf003c4);
$parcel$export(module.exports, "calculateNewStartAndEndTimestamp", () => $102956f839e5f725$export$b06db0f8b326b929);
$parcel$export(module.exports, "isDetailsSectionEmpty", () => $102956f839e5f725$export$74cb10c4b9924e49);
$parcel$export(module.exports, "generateParamsForOneMonthInterval", () => $102956f839e5f725$export$130612b33e678a37);
$parcel$export(module.exports, "calculateWidthAccordingToLevel", () => $102956f839e5f725$export$e083dc64e00e053b);
$parcel$export(module.exports, "getSourceStringFromUrl", () => $102956f839e5f725$export$c6631e198cf7c0f4);
$parcel$export(module.exports, "makeMarkup", () => $102956f839e5f725$export$59302306c6f78677);
$parcel$export(module.exports, "postProcessLogsSearch", () => $102956f839e5f725$export$9a858fe3837c0be0);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $grR0x = parcelRequire("grR0x");

var $jj52j = parcelRequire("jj52j");

var $jovBr = parcelRequire("jovBr");

var $eZDAP = parcelRequire("eZDAP");

var $gn1v9 = parcelRequire("gn1v9");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $dS3PR = parcelRequire("dS3PR");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $2VsTe = parcelRequire("2VsTe");

var $0yCO3 = parcelRequire("0yCO3");

var $hu2ZI = parcelRequire("hu2ZI");

var $9Pdtb = parcelRequire("9Pdtb");
// jira-frontend/src/packages/jql-builder-basic-datetime/src/ui/utils/time-functions.tsx
const $102956f839e5f725$var$isNumeric = (value)=>/^\d+$/.test(value);
const $102956f839e5f725$export$2214112898027187 = (timeDigits, timeUnit)=>{
    return timeDigits === '' || timeDigits !== undefined && $102956f839e5f725$var$isNumeric(timeDigits) && parseInt(timeDigits, 10) > -1 && (0, $0yCO3.RANGE_OPTIONS).includes(timeUnit);
};
const $102956f839e5f725$export$b29a6f1d6d345720 = (intl, value)=>{
    if (!value?.startDate && !value?.endDate) return intl.formatMessage((0, $9Pdtb.default).validationMessageAtLeastOneValue);
    if (value?.startDate && value?.endDate && new Date(value?.startDate) > new Date(value?.endDate)) return intl.formatMessage((0, $9Pdtb.default).validationMessageBeforeGreaterThanAfter);
    if (value && (value?.startDate !== '' && !(0, $jovBr.default)(new Date(value?.startDate)) || value?.endDate !== '' && !(0, $jovBr.default)(new Date(value?.endDate)))) return intl.formatMessage((0, $9Pdtb.default).validationMessageInvalidDateFormat);
    return undefined;
};
const $102956f839e5f725$export$7b619dd534dac336 = (value)=>{
    if (!value?.startDate && !value?.endDate) return false;
    if (value?.startDate && value?.endDate && new Date(value?.startDate) > new Date(value?.endDate)) return false;
    if (value && (value?.startDate !== '' && !(0, $jovBr.default)(new Date(value?.startDate)) || value?.endDate !== '' && !(0, $jovBr.default)(new Date(value?.endDate)))) return false;
    return true;
};
const $102956f839e5f725$export$f18cd4bc58b99a27 = (value)=>{
    return !(0, $jovBr.default)((0, $eZDAP.default)(value)) && value !== '';
};
const $102956f839e5f725$export$760bb1b75585fb94 = (value)=>{
    return value.map((event)=>event.value).join(',');
};
const $102956f839e5f725$export$792d5c0a6d15a15e = (query, value)=>{
    return query?.includes(value.toString()) ?? false;
};
const $102956f839e5f725$export$f344cca10df5ca13 = (query, options)=>{
    if (!query) return [];
    const labels = [];
    options.map((option)=>{
        option.options.map((item)=>labels.push(item));
    });
    return labels.filter(({ value: value })=>$102956f839e5f725$export$792d5c0a6d15a15e(query, value));
};
const $102956f839e5f725$export$100c2d7fc380fbfa = (query, options)=>{
    if (!query) return [];
    return options.filter((label)=>query.includes(label.value.toString()));
};
const $102956f839e5f725$export$422789958d8174dd = (unit)=>(0, $0yCO3.RANGE_OPTIONS).includes(unit);
const $102956f839e5f725$export$4db9080fab1bce85 = (options)=>{
    return options.map((option)=>option.value).join(',');
};
const $102956f839e5f725$var$isTimeQueryParamsValid = (params)=>{
    if (params.has('startTimestamp') && params.has('endTimestamp')) return true;
    else if (params.has('fromUnit') && params.has('fromValue')) return true;
    return false;
};
const $102956f839e5f725$export$42dac873831f0e2 = (params)=>{
    const now = new Date();
    if (!params.get('startTimestamp') && !params.get('endTimestamp') && params.get('fromUnit') && params.get('fromValue')) {
        const parsedFromValue = parseInt(params.get('fromValue') ?? '1');
        switch(params.get('fromUnit')){
            case 'HOUR':
                params.set('endTimestamp', (now.getTime() * (0, $hu2ZI.NANOSECONDS_IN_MILLISECOND)).toString());
                params.set('startTimestamp', ((0, $gn1v9.default)(now, {
                    hours: parsedFromValue
                }).getTime() * (0, $hu2ZI.NANOSECONDS_IN_MILLISECOND)).toString());
                break;
            case 'DAY':
                params.set('endTimestamp', (now.getTime() * (0, $hu2ZI.NANOSECONDS_IN_MILLISECOND)).toString());
                params.set('startTimestamp', ((0, $gn1v9.default)(now, {
                    days: parsedFromValue
                }).getTime() * (0, $hu2ZI.NANOSECONDS_IN_MILLISECOND)).toString());
                break;
            case 'WEEK':
                params.set('endTimestamp', (now.getTime() * (0, $hu2ZI.NANOSECONDS_IN_MILLISECOND)).toString());
                params.set('startTimestamp', ((0, $gn1v9.default)(now, {
                    weeks: parsedFromValue
                }).getTime() * (0, $hu2ZI.NANOSECONDS_IN_MILLISECOND)).toString());
                break;
            case 'MONTH':
                params.set('endTimestamp', (now.getTime() * (0, $hu2ZI.NANOSECONDS_IN_MILLISECOND)).toString());
                params.set('startTimestamp', ((0, $gn1v9.default)(now, {
                    months: parsedFromValue
                }).getTime() * (0, $hu2ZI.NANOSECONDS_IN_MILLISECOND)).toString());
                break;
        }
        params.delete('fromUnit');
        params.delete('fromValue');
    }
    return params;
};
const $102956f839e5f725$export$85293a2f3995ddcc = (params)=>{
    const urlParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value])=>{
        if (value) urlParams.append(key, decodeURI(value));
    });
    if (!$102956f839e5f725$var$isTimeQueryParamsValid(urlParams)) {
        // Remove time parameters if exists since they were not matched.
        urlParams.delete('fromUnit');
        urlParams.delete('fromValue');
        urlParams.delete('startTimestamp');
        urlParams.delete('endTimestamp');
        urlParams.append('fromUnit', 'DAY');
        urlParams.append('fromValue', '1');
    }
    return $102956f839e5f725$export$42dac873831f0e2(urlParams);
};
const $102956f839e5f725$var$calculateTimeDifference = (startDate, endDate)=>{
    const minutesDiff = (0, $grR0x.default)(endDate, startDate);
    if (minutesDiff < 60) return {
        hours: 1,
        days: 0,
        weeks: 0,
        months: 0,
        years: 0
    };
    const hoursDiff = minutesDiff / 60;
    const daysDiff = minutesDiff / 60 / 24;
    const weeksDiff = minutesDiff / 60 / 24 / 7;
    const monthsDiff = minutesDiff / 60 / 24 / 7 / 4;
    return {
        hours: hoursDiff > 0 ? Math.floor(hoursDiff) : 0,
        days: daysDiff > 0 ? Math.floor(daysDiff) : 0,
        weeks: weeksDiff > 0 ? Math.floor(weeksDiff) : 0,
        months: monthsDiff > 0 ? Math.floor(monthsDiff) : 0
    };
};
const $102956f839e5f725$export$ae02811946c03a4b = (startDate, endDate)=>{
    const parsedStartDate = (0, $eZDAP.default)(startDate);
    const parsedEndDate = (0, $eZDAP.default)(endDate);
    const timeDifference = $102956f839e5f725$var$calculateTimeDifference(parsedStartDate, parsedEndDate);
    if (timeDifference.months > 0) return {
        timeUnit: 'MONTH',
        timeDigits: timeDifference.months.toString()
    };
    else if (timeDifference.weeks > 0) return {
        timeUnit: 'WEEK',
        timeDigits: timeDifference.weeks.toString()
    };
    else if (timeDifference.days > 0) return {
        timeUnit: 'DAY',
        timeDigits: timeDifference.days.toString()
    };
    else return {
        timeUnit: 'HOUR',
        timeDigits: timeDifference.hours.toString()
    };
};
const $102956f839e5f725$export$9a8301702bf003c4 = (query)=>{
    let searchQuery = {};
    if (query.searchString) searchQuery = {
        ...searchQuery,
        searchString: query.searchString
    };
    if (query.startTimestamp && query.endTimestamp) searchQuery = {
        ...searchQuery,
        startTimestamp: query.startTimestamp,
        endTimestamp: query.endTimestamp
    };
    if (query.timeType) searchQuery = {
        ...searchQuery,
        timeType: query.timeType
    };
    if (query.eventCategories) searchQuery = {
        ...searchQuery,
        eventCategories: query.eventCategories
    };
    if (query.levels) searchQuery = {
        ...searchQuery,
        levels: query.levels
    };
    if (query.size) searchQuery = {
        ...searchQuery,
        size: query.size
    };
    return searchQuery;
};
function $102956f839e5f725$export$b06db0f8b326b929(startTimestamp, endTimestamp) {
    const startDateIntValue = parseInt(startTimestamp) / (0, $hu2ZI.NANOSECONDS_IN_MILLISECOND);
    const endDateIntValue = parseInt(endTimestamp) / (0, $hu2ZI.NANOSECONDS_IN_MILLISECOND);
    const { timeDigits: fromValue, timeUnit: fromUnit } = $102956f839e5f725$export$ae02811946c03a4b((0, $jj52j.default)(startDateIntValue), (0, $jj52j.default)(endDateIntValue));
    const params = $102956f839e5f725$export$42dac873831f0e2(new URLSearchParams({
        fromValue: fromValue,
        fromUnit: fromUnit
    }));
    const startTimestampParams = params.get('startTimestamp');
    const endTimestampParams = params.get('endTimestamp');
    (0, $hmVmJ.assert)(!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(startTimestampParams) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(endTimestampParams), new (0, $dH6Pi.AssertionError)('calculateNewStartAndEndTimestamp', 'startTimestamp and endTimestamp should not be null'));
    return {
        startTimestamp: startTimestampParams,
        endTimestamp: endTimestampParams
    };
}
const $102956f839e5f725$export$74cb10c4b9924e49 = (importantField, raw, isImportantFieldEmpty)=>{
    if (!importantField || !raw) return true;
    const parsedImportantField = JSON.parse(importantField);
    const parsedRaw = JSON.parse(raw);
    return ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(parsedImportantField) || isImportantFieldEmpty === true) && (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(parsedRaw);
};
const $102956f839e5f725$export$130612b33e678a37 = ()=>{
    const params = $102956f839e5f725$export$42dac873831f0e2(new URLSearchParams({
        fromUnit: 'MONTH',
        fromValue: '1'
    }));
    const startDate = params.get('startTimestamp');
    const endDate = params.get('endTimestamp');
    (0, $hmVmJ.assert)(!!startDate && !!endDate, new (0, $dH6Pi.AssertionError)('generateParamsForOneMonthInterval', 'startTimestamp and endDate should not be null'));
    return {
        dateTimeValue: {
            startDate: startDate,
            endDate: endDate
        },
        timeType: (0, $2VsTe.TimeRadioOptions).WITHIN_THE_LAST
    };
};
const $102956f839e5f725$export$e083dc64e00e053b = (level)=>{
    const BASE_OFFSET = 18;
    return `${(0, $hu2ZI.DETAIL_ITEM_BASE_WIDTH) - level * BASE_OFFSET}px`;
};
const $102956f839e5f725$export$c6631e198cf7c0f4 = (search)=>{
    const splittedSearch = search.split(/source=/i);
    if (splittedSearch.length > 1) return decodeURIComponent(splittedSearch[1]);
    return '';
};
function $102956f839e5f725$export$59302306c6f78677(fragment, key) {
    const { nodeName: nodeName, nodeType: nodeType, childNodes: childNodes, textContent: textContent } = fragment;
    if (nodeType === Node.TEXT_NODE) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: textContent
    }, key);
    const children = [];
    childNodes.forEach((childNode, i)=>{
        const markup = $102956f839e5f725$export$59302306c6f78677(childNode, String(i));
        if (markup) children.push(markup);
    });
    switch(nodeName){
        case 'B':
            return /*#__PURE__*/ (0, $2OMIu.jsx)("b", {
                children: children
            }, key);
        case 'I':
            return /*#__PURE__*/ (0, $2OMIu.jsx)("i", {
                children: children
            }, key);
        case 'STRONG':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                weight: "bold",
                children: children
            }, key);
        case 'EM':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                as: "em",
                children: children
            }, key);
        case 'CODE':
            // eslint-disable-next-line @atlaskit/design-system/no-html-code
            return /*#__PURE__*/ (0, $2OMIu.jsx)("code", {
                children: children
            }, key);
    }
    if (children.length === 1) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: children[0]
    }, key);
    if (children.length) return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        children: children
    }, key);
    return null;
}
const $102956f839e5f725$export$9a858fe3837c0be0 = (urlParams, response)=>{
    if (urlParams.get('startTimestamp') && urlParams.get('endTimestamp')) return {
        ...response,
        data: {
            ...response.data,
            pagination: {
                ...response.data.pagination,
                calcStartDate: urlParams.get('startTimestamp'),
                calcEndDate: urlParams.get('endTimestamp')
            }
        }
    };
    return response;
};

});
parcelRegister("2VsTe", function(module, exports) {

$parcel$export(module.exports, "TimeRadioOptions", () => $4e8f12ca8572dc61$export$ff1338756af30600);
var $4e8f12ca8572dc61$export$ff1338756af30600 = /*#__PURE__*/ function(TimeRadioOptions) {
    TimeRadioOptions["WITHIN_THE_LAST"] = "withinTheLast";
    TimeRadioOptions["BETWEEN"] = "between";
    return TimeRadioOptions;
}({});

});

parcelRegister("0yCO3", function(module, exports) {

$parcel$export(module.exports, "RANGE_OPTIONS", () => $928210b867587e62$export$a0f3448347834e6b);
const $928210b867587e62$export$a0f3448347834e6b = [
    'HOUR',
    'DAY',
    'WEEK',
    'MONTH'
];

});

parcelRegister("hu2ZI", function(module, exports) {

$parcel$export(module.exports, "PAGE_SIZE_QUERY_PARAM", () => $96911fb41d45d626$export$4b254bc84a71033a);
$parcel$export(module.exports, "NANOSECONDS_IN_MILLISECOND", () => $96911fb41d45d626$export$753f41e31eccb6d7);
$parcel$export(module.exports, "getHeaderWidths", () => $96911fb41d45d626$export$8aa6dbdb947f7df1);
$parcel$export(module.exports, "DETAIL_ITEM_BASE_WIDTH", () => $96911fb41d45d626$export$1220f90483bde21);
const $96911fb41d45d626$export$4b254bc84a71033a = 'size';
const $96911fb41d45d626$export$753f41e31eccb6d7 = 1000000;
const $96911fb41d45d626$export$8aa6dbdb947f7df1 = (params)=>{
    const { DATE_HEADER_WIDTH: DATE_HEADER_WIDTH, CATEGORY_HEADER_WIDTH: CATEGORY_HEADER_WIDTH, TYPE_HEADER_WIDTH: TYPE_HEADER_WIDTH } = params.showEventCategoryField ? {
        // Widths for audit logs page
        DATE_HEADER_WIDTH: 16,
        CATEGORY_HEADER_WIDTH: 16,
        TYPE_HEADER_WIDTH: 10
    } : {
        // Widths for integration-specific log page
        DATE_HEADER_WIDTH: 14,
        CATEGORY_HEADER_WIDTH: 0,
        TYPE_HEADER_WIDTH: 12
    };
    const columnsToShow = [
        DATE_HEADER_WIDTH,
        CATEGORY_HEADER_WIDTH,
        TYPE_HEADER_WIDTH
    ];
    let sum = 0;
    columnsToShow.forEach((width)=>{
        sum += width;
    });
    return {
        DATE_HEADER_WIDTH: `${DATE_HEADER_WIDTH}%`,
        CATEGORY_HEADER_WIDTH: `${CATEGORY_HEADER_WIDTH}%`,
        TYPE_HEADER_WIDTH: `${TYPE_HEADER_WIDTH}%`,
        CHANGE_SUMMARY_HEADER_WIDTH: `${100 - sum}%`
    };
};
const $96911fb41d45d626$export$1220f90483bde21 = 250;

});

parcelRegister("9Pdtb", function(module, exports) {

$parcel$export(module.exports, "default", () => $8183616acbf6d3e8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $8183616acbf6d3e8$var$messages = (0, $7VHMR.defineMessages)({
    validationMessageBeforeGreaterThanAfter: {
        id: `eoc.customer-logs.common.utils.validation-message-before-greater-than-after.no-translate`,
        defaultMessage: 'Specify a valid time range.',
        description: 'Message displayed to the user when the Before date used is greater than the after date while specifying dates'
    },
    validationMessageInvalidDateFormat: {
        id: `eoc.customer-logs.common.utils.validation-message-invalid-date-format.no-translate`,
        defaultMessage: 'Invalid date format.',
        description: 'Invalid date format.'
    },
    validationMessageAtLeastOneValue: {
        id: `eoc.customer-logs.common.utils.validation-message-at-least-one-value.no-translate`,
        defaultMessage: 'Select at least one value.',
        description: 'Message displayed to the user when there is no selected before and end date together'
    }
});
var $8183616acbf6d3e8$export$2e2bcd8739ae039 = $8183616acbf6d3e8$var$messages;

});




parcelRegister("lCbSp", function(module, exports) {

$parcel$export(module.exports, "uiSettingsResource", () => $efebb20f6ad5236b$export$f2b33518cf31cd40);

var $2M1hQ = parcelRequire("2M1hQ");

var $7xYVv = parcelRequire("7xYVv");
const $efebb20f6ad5236b$export$f2b33518cf31cd40 = (0, $2M1hQ.createResource)({
    type: 'ui-settings-resource',
    getKey: ()=>'ui-settings-resource',
    getData: async ()=>(0, $7xYVv.fetchUiSettingsEndpoint)(),
    maxAge: Infinity,
    isBrowserOnly: true
});

});
parcelRegister("7xYVv", function(module, exports) {

$parcel$export(module.exports, "fetchUiSettingsEndpoint", () => $7bc4e87c807af8e2$export$ea2f12bcbdce2020);

var $j74qU = parcelRequire("j74qU");
const $7bc4e87c807af8e2$export$ea2f12bcbdce2020 = async ()=>{
    return (0, $j74qU.eocFetch)('/v1/logs');
};

});



parcelRegister("7GYMz", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationLogRoute", () => $69ab4fb51e1e7924$export$71884dc820e415fc);
const $69ab4fb51e1e7924$export$71884dc820e415fc = {
    name: 'eoc-integration-log',
    path: '/jira/settings/products/ops/integrations/:type/:integrationId/logs',
    exact: true
};

});

parcelRegister("5pZel", function(module, exports) {

$parcel$export(module.exports, "IntegrationLog", () => $62766cc40b0fef68$export$b545b4a4c4cee016);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kEMby = parcelRequire("kEMby");
const $62766cc40b0fef68$export$b545b4a4c4cee016 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $kEMby.LazyIntegrationLog),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });

});


parcelRegister("68ycU", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationsRouteEntry", () => $42b9c62ef769e46b$export$6e5cd6656076550f);

var $g9g6m = parcelRequire("g9g6m");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $eZXFU = parcelRequire("eZXFU");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $aVb3A = parcelRequire("aVb3A");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

var $kEMby = parcelRequire("kEMby");

var $jNNfq = parcelRequire("jNNfq");
const $42b9c62ef769e46b$var$getNavigationSpecifications = ()=>{
    return ((0, $4R6GH.fg)('operations_nav4_remaining_items_old_navigation_fix') ? (0, $3HwlS.getWillShowNav4)() : true) && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $42b9c62ef769e46b$export$6e5cd6656076550f = (0, $7NszV.createEntry)((0, $aVb3A.globalIntegrationsRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/settings/products/ops',
        component: (0, $jNNfq.IntegrationAutomation),
        slot: null,
        layout: (0, $eZXFU.opsSettingsLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $g9g6m.resources).configuredIntegrationsResource,
            (0, $g9g6m.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$42b9c62ef769e46b$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation)
        ]
    }));

});
parcelRegister("aVb3A", function(module, exports) {

$parcel$export(module.exports, "globalIntegrationsRoute", () => $0fed354e3cd747e8$export$e196ff2390a1ec56);
const $0fed354e3cd747e8$export$e196ff2390a1ec56 = {
    name: 'eoc-integrations',
    path: '/jira/settings/products/ops/integrations',
    exact: true
};

});


parcelRegister("4BuRo", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationCreateRouteEntry", () => $46e74e6464e445dd$export$83aea99d18750f08);

var $g9g6m = parcelRequire("g9g6m");

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $lxIQB = parcelRequire("lxIQB");

var $jNNfq = parcelRequire("jNNfq");

var $2PI2S = parcelRequire("2PI2S");

var $kEMby = parcelRequire("kEMby");
const $46e74e6464e445dd$export$83aea99d18750f08 = (0, $7NszV.createEntry)((0, $lxIQB.teamIntegrationCreateRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/ops/teams',
        component: (0, $jNNfq.IntegrationAutomation),
        layout: (0, $h3Ix2.opsTeamLayout),
        slot: (0, $2PI2S.IntegrationCreate),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $2r8fH.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $g9g6m.resources).configuredIntegrationsResource,
            (0, $g9g6m.resources).integrationListResource,
            (0, $g9g6m.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("lxIQB", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationCreateRoute", () => $ae27079a91acfd42$export$a2ec7da6c43acbbf);
const $ae27079a91acfd42$export$a2ec7da6c43acbbf = {
    name: 'eoc-team-integration-create',
    path: '/jira/ops/teams/:teamId/integrations/create/:type',
    exact: true
};

});


parcelRegister("6SWMv", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationDetailRouteEntry", () => $cd5c132b5b5151e0$export$7e0b6b79953422c1);

var $g9g6m = parcelRequire("g9g6m");

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $8C1ee = parcelRequire("8C1ee");

var $jNNfq = parcelRequire("jNNfq");

var $7ifqF = parcelRequire("7ifqF");

var $kEMby = parcelRequire("kEMby");
const $cd5c132b5b5151e0$export$7e0b6b79953422c1 = (0, $7NszV.createEntry)((0, $8C1ee.teamIntegrationDetailRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/ops/teams',
        component: (0, $jNNfq.IntegrationAutomation),
        layout: (0, $h3Ix2.opsTeamLayout),
        slot: (0, $7ifqF.IntegrationDetail),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $2r8fH.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $g9g6m.resources).configuredIntegrationsResource,
            (0, $g9g6m.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("8C1ee", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationDetailRoute", () => $de1d1f48c94d5c8d$export$72169399df792b7c);
const $de1d1f48c94d5c8d$export$72169399df792b7c = {
    name: 'eoc-team-integration-detail',
    path: '/jira/ops/teams/:teamId/integrations/:type/:integrationId',
    exact: true
};

});


parcelRegister("jFY66", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationListRouteEntry", () => $d817aeb7fccbfd68$export$52ee366e7b51f38d);

var $g9g6m = parcelRequire("g9g6m");

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $2EBRZ = parcelRequire("2EBRZ");

var $jNNfq = parcelRequire("jNNfq");

var $3cv8c = parcelRequire("3cv8c");

var $kEMby = parcelRequire("kEMby");
const $d817aeb7fccbfd68$export$52ee366e7b51f38d = (0, $7NszV.createEntry)((0, $2EBRZ.teamIntegrationListRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/ops/teams',
        component: (0, $jNNfq.IntegrationAutomation),
        layout: (0, $h3Ix2.opsTeamLayout),
        slot: (0, $3cv8c.IntegrationList),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $2r8fH.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $g9g6m.resources).integrationListResource,
            (0, $g9g6m.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("2EBRZ", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationListRoute", () => $8e217314970bb735$export$b8218f375778e6d7);
const $8e217314970bb735$export$b8218f375778e6d7 = {
    name: 'eoc-team-integration-list',
    path: '/jira/ops/teams/:teamId/integrations/list',
    exact: true
};

});


parcelRegister("jPXYO", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationLogRouteEntry", () => $77c62c16bb189e65$export$d5e169223d2a5d1d);

var $c4Buu = parcelRequire("c4Buu");

var $g9g6m = parcelRequire("g9g6m");

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $80ouD = parcelRequire("80ouD");

var $jNNfq = parcelRequire("jNNfq");

var $5pZel = parcelRequire("5pZel");

var $kEMby = parcelRequire("kEMby");
const $77c62c16bb189e65$export$d5e169223d2a5d1d = (0, $7NszV.createEntry)((0, $80ouD.teamIntegrationLogRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/ops/teams',
        component: (0, $jNNfq.IntegrationAutomation),
        slot: (0, $5pZel.IntegrationLog),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $2r8fH.resources)(),
            ...(0, $c4Buu.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $g9g6m.resources).configuredIntegrationsResource,
            (0, $g9g6m.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("80ouD", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationLogRoute", () => $d7b8bbfd81270213$export$ca02d7b2c7df3d60);
const $d7b8bbfd81270213$export$ca02d7b2c7df3d60 = {
    name: 'eoc-team-integration-log',
    path: '/jira/ops/teams/:teamId/integrations/:type/:integrationId/logs',
    exact: true
};

});


parcelRegister("ktYro", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationsRouteEntry", () => $97fc56f25f58996b$export$ded9494f81dd2a4d);

var $g9g6m = parcelRequire("g9g6m");

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $1ZFOA = parcelRequire("1ZFOA");

var $jNNfq = parcelRequire("jNNfq");

var $kEMby = parcelRequire("kEMby");
const $97fc56f25f58996b$export$ded9494f81dd2a4d = (0, $7NszV.createEntry)((0, $1ZFOA.teamIntegrationsRoute), ()=>({
        group: 'eoc',
        basePath: '/jira/ops/teams',
        component: (0, $jNNfq.IntegrationAutomation),
        layout: (0, $h3Ix2.opsTeamLayout),
        slot: null,
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $2r8fH.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $g9g6m.resources).configuredIntegrationsResource,
            (0, $g9g6m.resources).userAccessRightsResource
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kEMby.LazyIntegrationAutomation),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("1ZFOA", function(module, exports) {

$parcel$export(module.exports, "teamIntegrationsRoute", () => $78efd1de67032a37$export$400ead354c81dee3);
const $78efd1de67032a37$export$400ead354c81dee3 = {
    name: 'eoc-team-integrations',
    path: '/jira/ops/teams/:teamId/integrations',
    exact: true
};

});


parcelRegister("5H5Rm", function(module, exports) {

$parcel$export(module.exports, "eocGlobalMaintenanceRouteEntry", () => $e5934255c94fc385$export$ce2a5648c28a5b48);

var $iBsI0 = parcelRequire("iBsI0");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $eZXFU = parcelRequire("eZXFU");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $fGpPl = parcelRequire("fGpPl");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

var $bEKnP = parcelRequire("bEKnP");
const $e5934255c94fc385$var$getNavigationSpecifications = ()=>{
    return ((0, $4R6GH.fg)('operations_nav4_remaining_items_old_navigation_fix') ? (0, $3HwlS.getWillShowNav4)() : true) && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $e5934255c94fc385$export$ce2a5648c28a5b48 = (0, $7NszV.createEntry)((0, $fGpPl.eocGlobalMaintenanceRoute), ()=>({
        group: 'eoc',
        component: (0, $bEKnP.MaintenanceComponent),
        layout: (0, $eZXFU.opsSettingsLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $iBsI0.resources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$e5934255c94fc385$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bEKnP.LazyMaintenance)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bEKnP.LazyMaintenance)
        ]
    }));

});
parcelRegister("iBsI0", function(module, exports) {

$parcel$export(module.exports, "maintenanceResource", () => $b472cee8aa78ea18$export$5486c78261efb2c3);
$parcel$export(module.exports, "maintenanceUserRightsResource", () => $b472cee8aa78ea18$export$e4c92d8948e3625);
$parcel$export(module.exports, "resources", () => $b472cee8aa78ea18$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $jxRF2 = parcelRequire("jxRF2");

var $czDcW = parcelRequire("czDcW");
const $b472cee8aa78ea18$export$5486c78261efb2c3 = (0, $2M1hQ.createResource)({
    type: 'maintenanceResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `maintenance/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return (0, $czDcW.getMaintenance)(teamId);
    },
    isBrowserOnly: true
});
const $b472cee8aa78ea18$export$e4c92d8948e3625 = (0, $2M1hQ.createResource)({
    type: 'maintenanceUserRightsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `maintenance-user-rights/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return (0, $czDcW.getMaintenanceUserRights)(teamId);
    },
    isBrowserOnly: true
});
const $b472cee8aa78ea18$export$bc99aaabaf7b70a7 = ()=>[
        ...(0, $jxRF2.eocCommonResources)(),
        $b472cee8aa78ea18$export$5486c78261efb2c3,
        $b472cee8aa78ea18$export$e4c92d8948e3625
    ];

});
parcelRegister("czDcW", function(module, exports) {

$parcel$export(module.exports, "getMaintenance", () => $b4a2c16b626eeb32$export$9cc878e1852c5ee1);
$parcel$export(module.exports, "deleteMaintenance", () => $b4a2c16b626eeb32$export$f64242288df38e86);
$parcel$export(module.exports, "cancelMaintenance", () => $b4a2c16b626eeb32$export$2d4a5362bda1b3c1);
$parcel$export(module.exports, "changeDateAndTime", () => $b4a2c16b626eeb32$export$2162fcbd04e23a3d);
$parcel$export(module.exports, "getMaintenanceUserRights", () => $b4a2c16b626eeb32$export$60048f3b7e7bf9b9);
$parcel$export(module.exports, "createMaintenance", () => $b4a2c16b626eeb32$export$602dd976bd963418);
$parcel$export(module.exports, "updateMaintenance", () => $b4a2c16b626eeb32$export$fa55cd063e1b15c2);

var $j74qU = parcelRequire("j74qU");
const $b4a2c16b626eeb32$export$9cc878e1852c5ee1 = (teamId)=>{
    return (0, $j74qU.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances`);
};
const $b4a2c16b626eeb32$export$f64242288df38e86 = (teamId, id)=>{
    return (0, $j74qU.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}`, {
        method: 'DELETE',
        responseType: 'headers'
    });
};
const $b4a2c16b626eeb32$export$2d4a5362bda1b3c1 = (teamId, id)=>{
    return (0, $j74qU.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}/cancel`, {
        method: 'PATCH'
    });
};
const $b4a2c16b626eeb32$export$2162fcbd04e23a3d = (teamId, id, endDate)=>{
    return (0, $j74qU.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}/updateEndDate`, {
        method: 'PATCH',
        body: {
            endDate: endDate
        }
    });
};
const $b4a2c16b626eeb32$export$60048f3b7e7bf9b9 = (teamId)=>{
    return (0, $j74qU.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/rights`);
};
const $b4a2c16b626eeb32$export$602dd976bd963418 = (payload, teamId)=>{
    const url = teamId ? `/v1/teams/${teamId}/maintenances` : '/v1/maintenances';
    return (0, $j74qU.eocFetch)(url, {
        method: 'POST',
        body: payload
    });
};
const $b4a2c16b626eeb32$export$fa55cd063e1b15c2 = (payload, id, teamId)=>{
    const url = teamId ? `/v1/teams/${teamId}/maintenances/${id}` : `/v1/maintenances/${id}`;
    return (0, $j74qU.eocFetch)(url, {
        method: 'PUT',
        body: payload
    });
};

});


parcelRegister("fGpPl", function(module, exports) {

$parcel$export(module.exports, "eocGlobalMaintenanceRoute", () => $665baa85f1a3583a$export$e0665f23a759e78f);
const $665baa85f1a3583a$export$e0665f23a759e78f = {
    name: 'eoc-global-maintenance',
    path: '/jira/settings/products/ops/maintenance',
    exact: true
};

});

parcelRegister("bEKnP", function(module, exports) {

$parcel$export(module.exports, "LazyMaintenance", () => $31bca194426a79fa$export$c5c7dc53d976edee);
$parcel$export(module.exports, "MaintenanceComponent", () => $31bca194426a79fa$export$76d7c25f72022339);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $31bca194426a79fa$export$c5c7dc53d976edee = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("jWWmq")), {
    moduleId: "./src/packages/eoc/maintenance/src/index.tsx"
});
const $31bca194426a79fa$export$76d7c25f72022339 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $31bca194426a79fa$export$c5c7dc53d976edee,
        pageId: "async-jira-eoc-maintenance",
        shouldShowSpinner: false
    });

});
parcelRegister("jWWmq", function(module, exports) {

let $e860b44bdacc397b$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e860b44bdacc397b$var$load("ffQaD"),
    $e860b44bdacc397b$var$load("kvRbA"),
    $e860b44bdacc397b$var$load("74MxY")
]).then(()=>parcelRequire('iqyJK'));

});



parcelRegister("jAB8i", function(module, exports) {

$parcel$export(module.exports, "eocMaintenanceRouteEntry", () => $e4663459434822fe$export$e9c59d0d6bfec8a3);

var $iBsI0 = parcelRequire("iBsI0");

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $9sQfT = parcelRequire("9sQfT");

var $bEKnP = parcelRequire("bEKnP");
const $e4663459434822fe$export$e9c59d0d6bfec8a3 = (0, $7NszV.createEntry)((0, $9sQfT.eocMaintenanceRoute), ()=>({
        group: 'eoc',
        component: (0, $bEKnP.MaintenanceComponent),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $iBsI0.resources)(),
            ...(0, $2r8fH.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bEKnP.LazyMaintenance),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("9sQfT", function(module, exports) {

$parcel$export(module.exports, "eocMaintenanceRoute", () => $e19afc32053c9ada$export$7523f600b27b1b54);
const $e19afc32053c9ada$export$7523f600b27b1b54 = {
    name: 'eoc-maintenance',
    path: '/jira/ops/teams/:teamId/maintenance',
    exact: true
};

});


parcelRegister("5KvQp", function(module, exports) {

$parcel$export(module.exports, "eocOnCallRedirectRouteEntry", () => $665cd44900aa1f78$export$c5c49f69c4fe1ea6);

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $fMGN8 = parcelRequire("fMGN8");

var $fLXNK = parcelRequire("fLXNK");
const $665cd44900aa1f78$export$c5c49f69c4fe1ea6 = (0, $7NszV.createEntry)((0, $fMGN8.eocOnCallRedirectRoute), ()=>({
        group: 'eoc',
        component: (0, $fLXNK.OnCallRedirect),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $2r8fH.resources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ],
        isRedirect: true
    }));

});
parcelRegister("fMGN8", function(module, exports) {

$parcel$export(module.exports, "eocOnCallRedirectRoute", () => $d0ffab051a4939b4$export$d725ece0e087d522);
const $d0ffab051a4939b4$export$d725ece0e087d522 = {
    name: 'eoc-on-call-redirect',
    path: '/jira/ops/teams/:teamId',
    exact: true
};

});

parcelRegister("fLXNK", function(module, exports) {

$parcel$export(module.exports, "OnCallRedirect", () => $da08681b2a2ed397$export$659b7ce11c160b32);
$parcel$export(module.exports, "LazyOnCall", () => $da08681b2a2ed397$export$772095aa22362f73);
$parcel$export(module.exports, "default", () => $da08681b2a2ed397$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $7tQej = parcelRequire("7tQej");
var $doZTA = parcelRequire("doZTA");
const $da08681b2a2ed397$export$659b7ce11c160b32 = ()=>{
    const [routeContext] = (0, $doZTA.useRouter)();
    const redirectionUrl = `${routeContext.location.pathname}/on-call`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: redirectionUrl
    });
};

const $da08681b2a2ed397$export$772095aa22362f73 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("eYDuU")), {
    moduleId: "./src/packages/eoc/on-call/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$da08681b2a2ed397$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $da08681b2a2ed397$export$772095aa22362f73,
        pageId: "async-jira-eoc-on-call",
        shouldShowSpinner: false
    });

});
parcelRegister("eYDuU", function(module, exports) {

let $ae754ea71b30ade3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ae754ea71b30ade3$var$load("ffQaD"),
    $ae754ea71b30ade3$var$load("kvRbA"),
    $ae754ea71b30ade3$var$load("76n7a"),
    $ae754ea71b30ade3$var$load("l253H"),
    $ae754ea71b30ade3$var$load("fLvpH")
]).then(()=>parcelRequire('38rnw'));

});



parcelRegister("3Yng9", function(module, exports) {

$parcel$export(module.exports, "eocOnCallRouteEntry", () => $3f27e199fbc412b1$export$ac245212b12db871);

var $iufIe = parcelRequire("iufIe");

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $5ozXn = parcelRequire("5ozXn");

var $fLXNK = parcelRequire("fLXNK");
const $3f27e199fbc412b1$export$ac245212b12db871 = (0, $7NszV.createEntry)((0, $5ozXn.eocOnCallRoute), ()=>({
        group: 'eoc',
        component: (0, $fLXNK.default),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $2r8fH.resources)(),
            ...(0, $iufIe.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fLXNK.LazyOnCall),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("iufIe", function(module, exports) {

$parcel$export(module.exports, "getTeamResource", () => $e31238735315794c$export$50271c9e7f21f10e);
$parcel$export(module.exports, "resources", () => $e31238735315794c$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $8SpRt = parcelRequire("8SpRt");

var $6RRyp = parcelRequire("6RRyp");

var $4Igwk = parcelRequire("4Igwk");
const $e31238735315794c$export$50271c9e7f21f10e = (0, $2M1hQ.createResource)({
    type: 'getTeamResource',
    getKey: ()=>'getTeamResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $hmVmJ.assert)(!!teamId, new (0, $dH6Pi.AssertionError)('getTeamResource', 'teamId should be set to fetch on-call'));
        return (0, $4Igwk.getTeam)(teamId);
    },
    isBrowserOnly: true
});
const $e31238735315794c$export$bc99aaabaf7b70a7 = ()=>[
        ...(0, $6RRyp.resources),
        (0, $8SpRt.routingRulesResource),
        $e31238735315794c$export$50271c9e7f21f10e
    ];

});
parcelRegister("8SpRt", function(module, exports) {

$parcel$export(module.exports, "routingRulesResource", () => $8308d404e93181e1$export$7f38c73dca88500e);

var $2M1hQ = parcelRequire("2M1hQ");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $eQugF = parcelRequire("eQugF");
const $8308d404e93181e1$export$7f38c73dca88500e = (0, $2M1hQ.createResource)({
    type: 'routingRulesResource',
    getKey: ()=>'routingRulesResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $hmVmJ.assert)(!!teamId, new (0, $dH6Pi.AssertionError)('routingRulesResource', 'teamId should be set to fetch routing-rules'));
        return (0, $eQugF.getRoutingRules)(teamId);
    },
    isBrowserOnly: true
});

});
parcelRegister("eQugF", function(module, exports) {

$parcel$export(module.exports, "getRoutingRules", () => $2cc350f95d05e13d$export$425c24c86196521);

var $j74qU = parcelRequire("j74qU");
const $2cc350f95d05e13d$export$425c24c86196521 = (teamId)=>(0, $j74qU.eocFetch)(`/v1/teams/${teamId}/routing-rules`);

});


parcelRegister("6RRyp", function(module, exports) {

$parcel$export(module.exports, "getSchedulesResource", () => $00ff222f7fbbe6c1$export$6b2b3e2a53cc13e2);
$parcel$export(module.exports, "getUiPreferencesResource", () => $00ff222f7fbbe6c1$export$5c6454d866055bdd);
$parcel$export(module.exports, "getScheduleRightsResource", () => $00ff222f7fbbe6c1$export$9d9ecb8586783931);
$parcel$export(module.exports, "getScheduleTimeTemplatesResource", () => $00ff222f7fbbe6c1$export$90251855f07c54b4);
$parcel$export(module.exports, "resources", () => $00ff222f7fbbe6c1$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $jxRF2 = parcelRequire("jxRF2");

var $dmLt8 = parcelRequire("dmLt8");

var $1IQ7I = parcelRequire("1IQ7I");

var $6CGrT = parcelRequire("6CGrT");

var $6bC8A = parcelRequire("6bC8A");

var $6FjDf = parcelRequire("6FjDf");

var $c0fyU = parcelRequire("c0fyU");
const $00ff222f7fbbe6c1$export$6b2b3e2a53cc13e2 = (0, $2M1hQ.createResource)({
    type: 'getSchedulesResource',
    getKey: ()=>'getSchedulesResource',
    isBrowserOnly: true,
    getData: async (routerExtendedContext)=>(0, $6bC8A.endpoints).getScheduleList((0, $1IQ7I.getTeamIdFromContext)(routerExtendedContext))
});
const $00ff222f7fbbe6c1$export$5c6454d866055bdd = (0, $2M1hQ.createResource)({
    type: 'getSchedulePreferencesResource',
    getKey: ()=>'getSchedulePreferencesResource',
    isBrowserOnly: true,
    getData: async (routerExtendedContext)=>(0, $6FjDf.endpoints).getUiPreferences((0, $1IQ7I.getTeamIdFromContext)(routerExtendedContext))
});
const $00ff222f7fbbe6c1$export$9d9ecb8586783931 = (0, $2M1hQ.createResource)({
    type: 'getScheduleRightsResource',
    getKey: ()=>'getScheduleRightsResource',
    isBrowserOnly: true,
    getData: async (routerExtendedContext)=>(0, $c0fyU.endpoints).getScheduleRights((0, $1IQ7I.getTeamIdFromContext)(routerExtendedContext))
});
const $00ff222f7fbbe6c1$export$90251855f07c54b4 = (0, $2M1hQ.createResource)({
    type: 'getScheduleTimeTemplatesResource',
    getKey: ()=>'getScheduleTimeTemplatesResourceurce',
    isBrowserOnly: true,
    getData: async ()=>(0, $6CGrT.endpoints).getScheduleTimeTemplates()
});
const $00ff222f7fbbe6c1$export$bc99aaabaf7b70a7 = [
    $00ff222f7fbbe6c1$export$6b2b3e2a53cc13e2,
    $00ff222f7fbbe6c1$export$5c6454d866055bdd,
    $00ff222f7fbbe6c1$export$9d9ecb8586783931,
    $00ff222f7fbbe6c1$export$90251855f07c54b4,
    ...(0, $dmLt8.resources),
    ...(0, $jxRF2.eocCommonResources)()
];

});
parcelRegister("dmLt8", function(module, exports) {

$parcel$export(module.exports, "getTimezonesResource", () => $6776e3cf1d2006c9$export$7524ea9fda8149c6);
$parcel$export(module.exports, "getTimeTemplatesResource", () => $6776e3cf1d2006c9$export$f045bbf39b81240d);
$parcel$export(module.exports, "resources", () => $6776e3cf1d2006c9$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $8EQhZ = parcelRequire("8EQhZ");
const $6776e3cf1d2006c9$export$7524ea9fda8149c6 = (0, $2M1hQ.createResource)({
    type: 'getEocTimezonesResource',
    getKey: ()=>'getEocTimezonesResource',
    isBrowserOnly: true,
    getData: async ()=>(0, $8EQhZ.endpoints).getTimezones()
});
const $6776e3cf1d2006c9$export$f045bbf39b81240d = (0, $2M1hQ.createResource)({
    type: 'getEocTimeTemplatesResource',
    getKey: ()=>'getEocTimeTemplatesResource',
    isBrowserOnly: true,
    getData: async ()=>(0, $8EQhZ.endpoints).getTimeTemplates()
});
const $6776e3cf1d2006c9$export$bc99aaabaf7b70a7 = [
    $6776e3cf1d2006c9$export$7524ea9fda8149c6
];

});
parcelRegister("8EQhZ", function(module, exports) {

$parcel$export(module.exports, "endpoints", () => $6f3fefc2f4704aa0$export$3a2536d80ecc00e7);

var $j74qU = parcelRequire("j74qU");

var $lVRaA = parcelRequire("lVRaA");
const $6f3fefc2f4704aa0$var$getTimezones = async ()=>{
    const response = await (0, $j74qU.eocFetch)((0, $lVRaA.urls).customers.timezones.url(), {
        method: 'GET'
    });
    const adjusted = response.timezones.map((timezone)=>({
            ...timezone,
            offset: timezone.offset * 60000,
            currentOffset: timezone.currentOffset * 60000
        }));
    return {
        ...response,
        timezones: adjusted
    };
};
const $6f3fefc2f4704aa0$var$getTimeTemplates = ()=>{
    return (0, $j74qU.eocFetch)((0, $lVRaA.urls).schedules.timeTemplates.rotation.url(), {
        method: 'GET'
    });
};
const $6f3fefc2f4704aa0$export$3a2536d80ecc00e7 = {
    getTimezones: $6f3fefc2f4704aa0$var$getTimezones,
    getTimeTemplates: $6f3fefc2f4704aa0$var$getTimeTemplates
};

});
parcelRegister("lVRaA", function(module, exports) {

$parcel$export(module.exports, "urls", () => $e7a5202f26785602$export$bcae9ba627f604b6);
const $e7a5202f26785602$export$bcae9ba627f604b6 = Object.freeze({
    alerts: {
        responders: {
            names: {
                url: ()=>'/v1/alerts/responders/names'
            },
            autoComplete: {
                url: ()=>'/v1/alerts/responders/auto-complete'
            },
            suggested: {
                url: ()=>'/v1/alerts/responders/suggested'
            }
        }
    },
    schedules: {
        url: ()=>`/v1/schedules`,
        scheduleId: {
            url: ({ scheduleId: scheduleId } = {
                scheduleId: ':scheduleId'
            })=>`/v1/schedules/${scheduleId}`,
            clone: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/clone`
            },
            name: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/name`
            },
            timezone: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/timezone`
            },
            enable: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/enable`
            },
            disable: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/disable`
            },
            webCalendarUrl: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/web-calendar-url`
            },
            timeline: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/timeline`
            },
            overrides: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/overrides`,
                alias: {
                    url: ({ scheduleId: scheduleId, alias: alias } = {
                        scheduleId: ':scheduleId',
                        alias: ':alias'
                    })=>`/v1/schedules/${scheduleId}/overrides/${alias}`
                },
                bulk: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/overrides/bulk`
                }
            },
            rotations: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/rotations`,
                rotationId: {
                    url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                        scheduleId: ':scheduleId',
                        rotationId: ':rotationId'
                    })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}`,
                    order: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/order`
                    },
                    name: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/name`
                    }
                }
            }
        },
        user: {
            webCalendarUrl: {
                url: ()=>`/v1/schedules/user/web-calendar-url`
            }
        },
        timeTemplates: {
            rotation: {
                url: ()=>'/v1/schedules/time-templates/rotation'
            }
        }
    },
    customers: {
        timezones: {
            url: ()=>'/v1/customers/timezones'
        }
    }
});

});



parcelRegister("1IQ7I", function(module, exports) {

$parcel$export(module.exports, "getTeamIdFromContext", () => $0269d115dae63a78$export$3ea727bebc3792bb);

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $lCzwW = parcelRequire("lCzwW");
const $0269d115dae63a78$export$3ea727bebc3792bb = (routerContext)=>{
    const teamId = (0, $lCzwW.getSafe)(()=>routerContext.match.params.teamId, null);
    (0, $hmVmJ.assert)(!(0, $lCzwW.isEmpty)(teamId), new (0, $dH6Pi.AssertionError)('eoc-schedule', 'teamId in routerContext is not defined'));
    return teamId;
};

});
parcelRegister("lCzwW", function(module, exports) {

$parcel$export(module.exports, "getSafe", () => $cb4f511f313ca560$export$fedb900c0ea4e699);
$parcel$export(module.exports, "isEmpty", () => $cb4f511f313ca560$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "isNullOrUndefined", () => $cb4f511f313ca560$export$bedb7023a7733221);
$parcel$export(module.exports, "noLeadingOrTrailingSpaces", () => $cb4f511f313ca560$export$5fc068d42db64a99);

var $jkGAf = parcelRequire("jkGAf");
const $cb4f511f313ca560$export$fedb900c0ea4e699 = (fn, defaultValue)=>{
    try {
        return fn();
    } catch  {
        return defaultValue;
    }
};
const $cb4f511f313ca560$export$dd1bc94b04021eeb = (input)=>{
    if (input !== 0 && input !== false && !input) return true;
    if (!(input instanceof Date) && typeof input === 'object' && Object.keys(input).length === 0) return true;
    return false;
};
const $cb4f511f313ca560$export$bedb7023a7733221 = (input)=>{
    return input === null || input === undefined;
};
const $cb4f511f313ca560$export$5fc068d42db64a99 = (message)=>({ formatMessage: formatMessage })=>(value)=>{
            if (typeof value === 'string' && (value.startsWith(' ') || value.endsWith(' '))) return message ?? formatMessage((0, $jkGAf.messages).nameSpaceValidationError);
        };

});
parcelRegister("jkGAf", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1ca05faf5e97d101$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $1ca05faf5e97d101$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    /*
   Misc common messages
  */ noOne: {
        id: 'eoc-schedule.common.no-one',
        defaultMessage: 'No one',
        description: 'Name of the user whose type is no-one.'
    },
    error: {
        id: 'eoc-schedule.common.error',
        defaultMessage: 'Error',
        description: 'Just simple error message.'
    },
    tryAgain: {
        id: 'eoc-schedule.common.try-again',
        defaultMessage: 'Try again',
        description: 'Try again message when an error occurs.'
    },
    cancel: {
        id: 'eoc-schedule.common.cancel',
        defaultMessage: 'Cancel',
        description: 'A cancel button.'
    },
    confirm: {
        id: 'eoc-schedule.common.confirm',
        defaultMessage: 'Confirm',
        description: 'A confirm button.'
    },
    addOverride: {
        id: 'eoc-schedule.common.add-override',
        defaultMessage: 'Add override',
        description: 'Adding override for a period item.'
    },
    overrideButton: {
        id: 'eoc-schedule.common.override',
        defaultMessage: 'Override',
        description: 'A override button.'
    },
    saveButton: {
        id: 'eoc-schedule.common.save',
        defaultMessage: 'Save',
        description: 'A save button.'
    },
    edit: {
        id: 'eoc-schedule.common.edit',
        defaultMessage: 'Edit',
        description: 'Button for editing schedule.'
    },
    turnOff: {
        id: 'eoc-schedule.common.turn-off',
        defaultMessage: 'Turn off',
        description: 'Button for turn-offing schedule.'
    },
    turnOn: {
        id: 'eoc-schedule.common.turn-on',
        defaultMessage: 'Turn on',
        description: 'Button for turn-on schedule.'
    },
    delete: {
        id: 'eoc-schedule.common.delete',
        defaultMessage: 'Delete',
        description: 'Button for deleting schedule or rotation.'
    },
    duplicate: {
        id: 'eoc-schedule.common.duplicate',
        defaultMessage: 'Duplicate',
        description: 'Button for duplicating schedule or rotation.'
    },
    remove: {
        id: 'eoc-schedule.common.remove',
        defaultMessage: 'Remove',
        description: 'Button for removing participant.'
    },
    start: {
        id: 'eoc-schedule.common.start',
        defaultMessage: 'Start',
        description: 'Label for start time and date.'
    },
    end: {
        id: 'eoc-schedule.common.end',
        defaultMessage: 'End',
        description: 'Label for end time and date.'
    },
    startTime: {
        id: 'eoc-schedule.common.start-time',
        defaultMessage: 'Start time',
        description: 'Label for start time and date.'
    },
    endTime: {
        id: 'eoc-schedule.common.end-time',
        defaultMessage: 'End time',
        description: 'Label for end time and date.'
    },
    startDate: {
        id: 'eoc-schedule.common.start-date',
        defaultMessage: 'Start date',
        description: 'Label for start time and date.'
    },
    endDate: {
        id: 'eoc-schedule.common.end-date',
        defaultMessage: 'End date',
        description: 'Label for end time and date.'
    },
    team: {
        id: 'eoc-schedule.common.team',
        defaultMessage: 'Team',
        description: 'Label that indicates responder is of type: Team'
    },
    escalation: {
        id: 'eoc-schedule.common.escalation',
        defaultMessage: 'Escalation',
        description: 'Label that indicates responder is of type: Escalation'
    },
    schedule: {
        id: 'eoc-schedule.common.schedule',
        defaultMessage: 'Schedule',
        description: 'Label that indicates responder is of type: Schedule'
    },
    selectionCount: {
        id: 'eoc-schedule.common.selection-count',
        defaultMessage: '{count} shifts selected',
        description: 'Indicates how many shifts are selected for override.'
    },
    quickOverrideTitle: {
        id: 'eoc-schedule.common.quick-override-title',
        defaultMessage: 'Override',
        description: 'Title for quick override card.'
    },
    search: {
        id: 'eoc-schedule.common.search',
        defaultMessage: 'Search',
        description: 'Label of search icon that shown inside search participant field'
    },
    replaceWith: {
        id: 'eoc-schedule.common.replace-with',
        defaultMessage: 'Replace with',
        description: 'A button for opening popup for replacing a participant.'
    },
    participants: {
        id: 'eoc-schedule.common.participants',
        defaultMessage: 'Participants',
        description: 'Label for participants.'
    },
    addParticipants: {
        id: 'eoc-schedule.common.add-participants',
        defaultMessage: 'Add people, teams, and escalation policies',
        description: 'Placeholder text for auto complete field for participants (responders).'
    },
    select: {
        id: 'eoc-schedule.common.select',
        defaultMessage: 'Select',
        description: 'Label that indicates selecting.'
    },
    teamDeleted: {
        id: 'eoc-schedule.common.team-deleted',
        defaultMessage: 'Team deleted',
        description: 'Fallback responder name that suggest team is deleted.'
    },
    deletedSchedule: {
        id: 'eoc-schedule.common.deleted-schedule',
        defaultMessage: 'Deleted schedule',
        description: 'Fallback responder name that suggest schedule is deleted.'
    },
    deletedEscalation: {
        id: 'eoc-schedule.common.deleted-escalation',
        defaultMessage: 'Deleted escalation',
        description: 'Fallback responder name that suggest escalation is deleted.'
    },
    formerUser: {
        id: 'eoc-schedule.common.former-user',
        defaultMessage: 'Former user',
        description: 'Fallback responder name that suggest user is deactivated or deleted.'
    },
    discard: {
        id: 'eoc-schedule.common.discard',
        defaultMessage: 'Discard',
        description: 'Button for discarding.'
    },
    confirmProceed: {
        id: 'eoc-schedule.common.confirm-proceed',
        defaultMessage: 'Are you sure to proceed?',
        description: 'A confirmation for proceeding.'
    },
    /*
   Common validation related messages
  */ required: {
        id: 'eoc-schedule.common.required',
        defaultMessage: 'This field is required.',
        description: 'A text that informs users that field should be filled.'
    },
    noSpaceAtEndOrStart: {
        id: 'eoc-schedule.common.no-space-at-end-or-start',
        defaultMessage: 'Field cannot contain spaces at start or end.',
        description: 'A text that informs users that field cannot start or end with spaces.'
    },
    maxLength: {
        id: 'eoc-schedule.common.max-length',
        defaultMessage: 'Field cannot be longer than {max} characters.',
        description: 'A text that informs users that field should be shorter than certain length.'
    },
    maxValue: {
        id: 'eoc-schedule.common.max-value',
        defaultMessage: 'Field should be less than {max}.',
        description: 'A text that informs users that field should be less than certain value.'
    },
    minValue: {
        id: 'eoc-schedule.common.min-value',
        defaultMessage: 'Enter digit 1 or more.',
        description: 'This sentence instructs the user to input a numeric value of at least 1 digit or greater.'
    },
    timePast: {
        id: 'eoc-schedule.common.time-past',
        defaultMessage: 'Time should be later than current time.',
        description: 'Validation error that indicates time values is in past.'
    },
    startLaterEnd: {
        id: 'eoc-schedule.common.start-later-end',
        defaultMessage: 'Start time should be earlier than the end time.',
        description: 'Validation error that indicates start time is later than the end time.'
    },
    endEarlierStart: {
        id: 'eoc-schedule.common.end-earlier-start',
        defaultMessage: 'End time should be later than the start time.',
        description: 'Validation error that indicates end time is earlier than the start time.'
    },
    startEndSame: {
        id: 'eoc-schedule.common.start-end-same',
        defaultMessage: 'Start and end time cannot be same.',
        description: 'Validation error that indicates start and end time should be different.'
    },
    thirtyMinuteInterval: {
        id: 'eoc-schedule.common.thirty-minute-intervals',
        defaultMessage: 'Time should be defined as 30 minute intervals.',
        description: 'Validation error that indicates time can be in 30 minutes intervals.'
    },
    nameSpaceValidationError: {
        id: 'eoc-schedule.common.name-space-validation-error',
        defaultMessage: 'The name cannot start or end with a space.',
        description: 'Error message for name validation when it starts or ends with a space'
    }
});

});



parcelRegister("6CGrT", function(module, exports) {

$parcel$export(module.exports, "endpoints", () => $fe0104c8713239aa$export$3a2536d80ecc00e7);

var $j74qU = parcelRequire("j74qU");

var $cB5Mt = parcelRequire("cB5Mt");
const $fe0104c8713239aa$var$orderRotation = ({ scheduleId: scheduleId, after: after, rotationId: rotationId })=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).schedules.scheduleId.rotations.rotationId.order.url({
        rotationId: rotationId,
        scheduleId: scheduleId
    }), {
        method: 'PATCH',
        body: {
            after: after
        }
    });
};
const $fe0104c8713239aa$var$getRotation = ({ scheduleId: scheduleId, rotationId: rotationId })=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).schedules.scheduleId.rotations.rotationId.url({
        scheduleId: scheduleId,
        rotationId: rotationId
    }), {
        method: 'GET'
    });
};
const $fe0104c8713239aa$var$deleteRotation = ({ scheduleId: scheduleId, rotationId: rotationId })=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).schedules.scheduleId.rotations.rotationId.url({
        scheduleId: scheduleId,
        rotationId: rotationId
    }), {
        method: 'DELETE'
    });
};
const $fe0104c8713239aa$var$addRotation = ({ name: name, responders: responders, restrictions: restrictions, rotationType: rotationType, hasEndTime: hasEndTime, rotationPeriod: rotationPeriod, scheduleId: scheduleId, timeTemplateId: timeTemplateId, timingType: timingType, startTimeRaw: startTimeRaw, endTimeRaw: endTimeRaw })=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).schedules.scheduleId.rotations.url({
        scheduleId: scheduleId
    }), {
        method: 'POST',
        body: {
            name: name,
            responders: responders,
            restrictions: restrictions,
            rotationType: rotationType,
            timeTemplateId: timeTemplateId,
            timingType: timingType,
            rotationPeriod: rotationPeriod,
            startTimeRaw: startTimeRaw,
            endTimeRaw: endTimeRaw,
            hasEndTime: hasEndTime
        }
    });
};
const $fe0104c8713239aa$var$editRotation = ({ id: id, name: name, responders: responders, restrictions: restrictions, rotationType: rotationType, rotationPeriod: rotationPeriod, hasEndTime: hasEndTime, timingType: timingType, scheduleId: scheduleId, timeTemplateId: timeTemplateId, startTimeRaw: startTimeRaw, endTimeRaw: endTimeRaw })=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).schedules.scheduleId.rotations.rotationId.url({
        scheduleId: scheduleId,
        rotationId: id
    }), {
        method: 'PUT',
        body: {
            id: id,
            name: name,
            responders: responders,
            restrictions: restrictions,
            rotationType: rotationType,
            rotationPeriod: rotationPeriod,
            timeTemplateId: timeTemplateId,
            timingType: timingType,
            startTimeRaw: startTimeRaw,
            endTimeRaw: endTimeRaw,
            hasEndTime: hasEndTime
        }
    });
};
const $fe0104c8713239aa$var$getScheduleTimeTemplates = ()=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).schedules.timeTemplates.rotation.url(), {
        method: 'GET'
    });
};
const $fe0104c8713239aa$export$3a2536d80ecc00e7 = {
    deleteRotation: $fe0104c8713239aa$var$deleteRotation,
    getRotation: $fe0104c8713239aa$var$getRotation,
    orderRotation: $fe0104c8713239aa$var$orderRotation,
    addRotation: $fe0104c8713239aa$var$addRotation,
    editRotation: $fe0104c8713239aa$var$editRotation,
    getScheduleTimeTemplates: $fe0104c8713239aa$var$getScheduleTimeTemplates
};

});
parcelRegister("cB5Mt", function(module, exports) {

$parcel$export(module.exports, "urls", () => $09cb24bcb900cd8c$export$bcae9ba627f604b6);
const $09cb24bcb900cd8c$export$bcae9ba627f604b6 = Object.freeze({
    alerts: {
        responders: {
            names: {
                url: ()=>'/v1/alerts/responders/names'
            },
            autoComplete: {
                url: ()=>'/v1/alerts/responders/auto-complete'
            }
        }
    },
    schedules: {
        url: ()=>`/v1/schedules`,
        teams: {
            teamId: {
                url: ({ teamId: teamId } = {
                    teamId: ':teamId'
                })=>`/v1/schedules/teams/${teamId}`,
                rights: {
                    url: ({ teamId: teamId } = {
                        teamId: ':teamId'
                    })=>`/v1/schedules/teams/${teamId}/rights`
                }
            }
        },
        scheduleId: {
            url: ({ scheduleId: scheduleId } = {
                scheduleId: ':scheduleId'
            })=>`/v1/schedules/${scheduleId}`,
            clone: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/clone`
            },
            name: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/name`
            },
            timezone: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/timezone`
            },
            enable: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/enable`
            },
            disable: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/disable`
            },
            webCalendarUrl: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/web-calendar-url`
            },
            timeline: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/timeline`
            },
            overrides: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/overrides`,
                alias: {
                    url: ({ scheduleId: scheduleId, alias: alias } = {
                        scheduleId: ':scheduleId',
                        alias: ':alias'
                    })=>`/v1/schedules/${scheduleId}/overrides/${alias}`
                },
                bulk: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/overrides/bulk`
                }
            },
            rotations: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/rotations`,
                rotationId: {
                    url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                        scheduleId: ':scheduleId',
                        rotationId: ':rotationId'
                    })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}`,
                    order: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/order`
                    },
                    name: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/name`
                    }
                }
            }
        },
        timeTemplates: {
            rotation: {
                url: ()=>'/v1/schedules/time-templates/rotation'
            }
        }
    },
    customers: {
        timezones: {
            url: ()=>'/v1/customers/timezones'
        }
    },
    uiPreference: {
        schedule: {
            team: {
                teamId: {
                    url: ({ teamId: teamId } = {
                        teamId: ':teamId'
                    })=>`/v1/users/ui-preference/schedule/team/${teamId}`
                }
            }
        }
    },
    onboarding: {
        completeTask: {
            url: ()=>'/v1/onboarding/complete-task'
        }
    }
});

});


parcelRegister("6bC8A", function(module, exports) {

$parcel$export(module.exports, "endpoints", () => $94e539ffc0ded8a5$export$3a2536d80ecc00e7);

var $j74qU = parcelRequire("j74qU");

var $cB5Mt = parcelRequire("cB5Mt");
const $94e539ffc0ded8a5$var$getScheduleList = (teamId)=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).schedules.teams.teamId.url({
        teamId: teamId
    }));
};
const $94e539ffc0ded8a5$var$updateSchedule = ({ scheduleId: scheduleId, description: description, name: name, enabled: enabled, timezone: timezone })=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).schedules.scheduleId.url({
        scheduleId: scheduleId
    }), {
        method: 'PATCH',
        body: {
            description: description,
            name: name,
            enabled: enabled,
            timezone: timezone
        }
    });
};
const $94e539ffc0ded8a5$var$deleteSchedule = ({ scheduleId: scheduleId })=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).schedules.scheduleId.url({
        scheduleId: scheduleId
    }), {
        method: 'DELETE'
    });
};
const $94e539ffc0ded8a5$export$3a2536d80ecc00e7 = {
    deleteSchedule: $94e539ffc0ded8a5$var$deleteSchedule,
    getScheduleList: $94e539ffc0ded8a5$var$getScheduleList,
    updateSchedule: $94e539ffc0ded8a5$var$updateSchedule
};

});

parcelRegister("6FjDf", function(module, exports) {

$parcel$export(module.exports, "endpoints", () => $4c5802ac60e7f752$export$3a2536d80ecc00e7);

var $j74qU = parcelRequire("j74qU");

var $cB5Mt = parcelRequire("cB5Mt");
const $4c5802ac60e7f752$var$getUiPreferences = (teamId)=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).uiPreference.schedule.team.teamId.url({
        teamId: teamId
    }));
};
const $4c5802ac60e7f752$var$updateUiPreferences = ({ teamId: teamId, key: key, value: value })=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).uiPreference.schedule.team.teamId.url({
        teamId: teamId
    }), {
        method: 'PATCH',
        body: {
            [key]: value
        }
    });
};
const $4c5802ac60e7f752$export$3a2536d80ecc00e7 = {
    getUiPreferences: $4c5802ac60e7f752$var$getUiPreferences,
    updateUiPreferences: $4c5802ac60e7f752$var$updateUiPreferences
};

});

parcelRegister("c0fyU", function(module, exports) {

$parcel$export(module.exports, "endpoints", () => $7066040345150142$export$3a2536d80ecc00e7);

var $j74qU = parcelRequire("j74qU");

var $cB5Mt = parcelRequire("cB5Mt");
const $7066040345150142$var$getScheduleRights = (teamId)=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).schedules.teams.teamId.rights.url({
        teamId: teamId
    }));
};
const $7066040345150142$var$createSchedule = ({ description: description, name: name, teamId: teamId, timezone: timezone })=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).schedules.url(), {
        method: 'POST',
        body: {
            description: description,
            name: name,
            teamId: teamId,
            timezone: timezone,
            // Created schedules are enabled by default
            enabled: true
        }
    });
};
const $7066040345150142$var$cloneSchedule = ({ description: description, name: name, enabled: enabled, timezone: timezone, teamId: teamId, scheduleId: scheduleId })=>{
    return (0, $j74qU.eocFetch)((0, $cB5Mt.urls).schedules.scheduleId.clone.url({
        scheduleId: scheduleId
    }), {
        method: 'POST',
        body: {
            description: description,
            name: name,
            enabled: enabled,
            timezone: timezone,
            teamId: teamId
        }
    });
};
const $7066040345150142$export$3a2536d80ecc00e7 = {
    createSchedule: $7066040345150142$var$createSchedule,
    getScheduleRights: $7066040345150142$var$getScheduleRights,
    cloneSchedule: $7066040345150142$var$cloneSchedule
};

});


parcelRegister("4Igwk", function(module, exports) {

$parcel$export(module.exports, "getTeam", () => $54c26d3a47aeeed9$export$491fe77f22ab2b51);

var $j74qU = parcelRequire("j74qU");
const $54c26d3a47aeeed9$export$491fe77f22ab2b51 = (teamId)=>(0, $j74qU.eocFetch)(`/v1/alerts/responders/names`, {
        method: 'POST',
        body: {
            responders: [
                {
                    id: teamId,
                    type: 'team'
                }
            ]
        }
    });

});


parcelRegister("5ozXn", function(module, exports) {

$parcel$export(module.exports, "eocOnCallRoute", () => $deb5dca00817980c$export$5eaa466ae8a4d7d3);
const $deb5dca00817980c$export$5eaa466ae8a4d7d3 = {
    name: 'eoc-on-call',
    path: '/jira/ops/teams/:teamId/on-call',
    exact: true
};

});


parcelRegister("2B61u", function(module, exports) {

$parcel$export(module.exports, "eocOverviewAllTeamsRouteEntry", () => $da84e8a7a2986788$export$842d7c81068bb64e);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $bh0Pj = parcelRequire("bh0Pj");

var $7NszV = parcelRequire("7NszV");

var $5OcAv = parcelRequire("5OcAv");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $6QP4T = parcelRequire("6QP4T");

var $jxRF2 = parcelRequire("jxRF2");

var $gNStA = parcelRequire("gNStA");

var $4R6GH = parcelRequire("4R6GH");

var $9FJ7w = parcelRequire("9FJ7w");
const $da84e8a7a2986788$export$842d7c81068bb64e = (0, $7NszV.createEntry)((0, $6QP4T.eocOverviewAllTeamsRoute), ()=>({
        group: 'eoc',
        component: (0, $9FJ7w.EocOverviewAllTeamsComponent),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $5OcAv.getTeamsResource),
            ...(0, $jxRF2.eocCommonResources)().map((resource)=>(0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('your_work_page_operation_widgets_changes'), resource))
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).HOME,
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsOverviewNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bh0Pj.LazyHorizontalOperationsOverviewNav),
            (0, $9FJ7w.LazyOverviewAllTeamsPage)
        ]
    }));

});
parcelRegister("5OcAv", function(module, exports) {

$parcel$export(module.exports, "getTeamsResource", () => $221e2d1c864e815a$export$27d854bd39923fc7);
// eslint-disable-next-line jira/import-whitelist

var $9qm0o = parcelRequire("9qm0o");
var $8NtOA = parcelRequire("8NtOA");

var $4R6GH = parcelRequire("4R6GH");

var $2M1hQ = parcelRequire("2M1hQ");

var $3H5ry = parcelRequire("3H5ry");

const $221e2d1c864e815a$export$27d854bd39923fc7 = (0, $2M1hQ.createResource)({
    type: (0, $8NtOA.getTeamsResource).type,
    getKey: (0, $8NtOA.getTeamsResource).getKey,
    getData: async ({ dependencies: dependencies }, { tenantContext: { atlassianAccountId: atlassianAccountId, isSiteAdmin: isSiteAdmin, isAdmin: isAdmin } })=>{
        if (!atlassianAccountId) return null;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const tenantInfo = await dependencies[0, $5a94e356f9d5e220$export$25ee35b01de9d734]?.promise;
        const isOpsAdmin = (0, $3H5ry.checkIsOpsAdmin)(tenantInfo);
        const shouldSeeAllTeams = (0, $4R6GH.fg)('operations-tenant-info-endpoint-update') ? isSiteAdmin || isAdmin || isOpsAdmin : isSiteAdmin || isAdmin;
        return (0, $9qm0o.getTeams)({
            queryParams: {
                accountId: !shouldSeeAllTeams ? atlassianAccountId : undefined,
                showAvatar: true,
                ...(0, $4R6GH.fg)('display_eoc_managed_teams_with_verified_marks') && {
                    includeTeamExternalDetails: true
                }
            }
        });
    },
    isBrowserOnly: true,
    maxAge: 0,
    depends: [
        (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
    ]
});

});
parcelRegister("9qm0o", function(module, exports) {

$parcel$export(module.exports, "getTeams", () => $66ba5008bb81f78a$export$5a622455e94bac3);

var $j74qU = parcelRequire("j74qU");
const $66ba5008bb81f78a$export$5a622455e94bac3 = ({ url: url, queryParams: queryParams })=>{
    const params = new URLSearchParams();
    if (queryParams.keyword) params.append('keyword', queryParams.keyword);
    if (queryParams.size) params.append('size', queryParams.size.toString());
    if (queryParams.offset) params.append('offset', queryParams.offset.toString());
    if (queryParams.accountId) params.append('memberId', queryParams.accountId);
    if (queryParams.showAvatar) params.append('showAvatar', String(queryParams.showAvatar));
    if (queryParams.includeTeamExternalDetails) params.append('includeTeamExternalDetails', String(queryParams.includeTeamExternalDetails));
    if (url) return (0, $j74qU.eocFetch)(`${url}${params.toString() ? `?${params.toString()}` : ''}`, {
        exactUrl: true
    });
    return (0, $j74qU.eocFetch)(`/v1/teams${params.toString() ? `?${params.toString()}` : ''}`);
};

});

parcelRegister("8NtOA", function(module, exports) {

$parcel$export(module.exports, "getTeamsResource", () => $61e1720e70cf825e$export$27d854bd39923fc7);

var $2M1hQ = parcelRequire("2M1hQ");

var $9qm0o = parcelRequire("9qm0o");
const $61e1720e70cf825e$export$27d854bd39923fc7 = (0, $2M1hQ.createResource)({
    type: 'getTeamsResource',
    getKey: ()=>'overview',
    getData: async ()=>{
        throw new Error('getData of getTeamsResource is not implemented in platform package, you should do it in your product');
    },
    isBrowserOnly: true
});

});

const $5a94e356f9d5e220$export$25ee35b01de9d734 = 'EOC_TENANT';


parcelRegister("6QP4T", function(module, exports) {

$parcel$export(module.exports, "eocOverviewAllTeamsRoute", () => $0f11196ea10bf082$export$dbe53627482b9f0f);
const $0f11196ea10bf082$export$dbe53627482b9f0f = {
    name: 'eoc-overview-all-teams',
    path: '/jira/ops/overview/teams',
    exact: true
};

});

parcelRegister("9FJ7w", function(module, exports) {

$parcel$export(module.exports, "LazyOverviewPage", () => $9dfc49c8c344cd92$export$c7c96cc8d6e9a8f1);
$parcel$export(module.exports, "LazyOverviewAllTeamsPage", () => $9dfc49c8c344cd92$export$9a22ecad8322834e);
$parcel$export(module.exports, "EocOverviewComponent", () => $9dfc49c8c344cd92$export$b22309f0ee469d5c);
$parcel$export(module.exports, "EocOverviewAllTeamsComponent", () => $9dfc49c8c344cd92$export$2713003ebbdbb975);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $9dfc49c8c344cd92$export$c7c96cc8d6e9a8f1 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("6C0jk")).then((m)=>m.OverviewPage), {
    moduleId: "./src/packages/eoc/overview/src/ui/overview-page/index.tsx"
});

const $9dfc49c8c344cd92$export$9a22ecad8322834e = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("2HwSR")).then((m)=>m.AllTeamsPage), {
    moduleId: "./src/packages/eoc/overview/src/ui/all-teams-page/index.tsx"
});
const $9dfc49c8c344cd92$export$b22309f0ee469d5c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9dfc49c8c344cd92$export$c7c96cc8d6e9a8f1,
        pageId: "async-jira-eoc-overview",
        shouldShowSpinner: false
    });
const $9dfc49c8c344cd92$export$2713003ebbdbb975 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9dfc49c8c344cd92$export$9a22ecad8322834e,
        pageId: "async-jira-eoc-overview-all-teams",
        shouldShowSpinner: false
    });

});
parcelRegister("6C0jk", function(module, exports) {

let $4d068860403e602a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4d068860403e602a$var$load("6ff4v").then(()=>parcelRequire('hTI3Y'));

});

parcelRegister("2HwSR", function(module, exports) {

let $1f791af300a0ec47$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1f791af300a0ec47$var$load("ffQaD"),
    $1f791af300a0ec47$var$load("kvRbA"),
    $1f791af300a0ec47$var$load("bkLVV")
]).then(()=>parcelRequire('jMqXq'));

});



parcelRegister("e04XT", function(module, exports) {

$parcel$export(module.exports, "eocOverviewRouteEntry", () => $df54ba0aea7ee8de$export$f1a859c727c30be4);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $bh0Pj = parcelRequire("bh0Pj");

var $7NszV = parcelRequire("7NszV");

var $5OcAv = parcelRequire("5OcAv");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $bDEHF = parcelRequire("bDEHF");

var $eZXFU = parcelRequire("eZXFU");

var $jxRF2 = parcelRequire("jxRF2");

var $gNStA = parcelRequire("gNStA");

var $4R6GH = parcelRequire("4R6GH");

var $9FJ7w = parcelRequire("9FJ7w");
const $df54ba0aea7ee8de$export$f1a859c727c30be4 = (0, $7NszV.createEntry)((0, $bDEHF.eocOverviewRoute), ()=>({
        group: 'eoc',
        component: (0, $9FJ7w.EocOverviewComponent),
        layout: (0, $eZXFU.opsMigrationHubLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $5OcAv.getTeamsResource),
            ...(0, $jxRF2.eocCommonResources)().map((resource)=>(0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('your_work_page_operation_widgets_changes'), resource))
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).HOME,
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsOverviewNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bh0Pj.LazyHorizontalOperationsOverviewNav),
            (0, $9FJ7w.LazyOverviewPage)
        ]
    }));

});
parcelRegister("bDEHF", function(module, exports) {

$parcel$export(module.exports, "eocOverviewRoute", () => $82d2d783c671586e$export$cb929d46451a5c12);
const $82d2d783c671586e$export$cb929d46451a5c12 = {
    name: 'eoc-overview',
    path: '/jira/ops/overview',
    exact: true
};

});


parcelRegister("hGFnn", function(module, exports) {

$parcel$export(module.exports, "eocPermissionsRouteEntry", () => $b9f5341ba0d7de14$export$c2ced436a30c60dc);

var $j4Jjv = parcelRequire("j4Jjv");

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $1N8g8 = parcelRequire("1N8g8");

var $haBWo = parcelRequire("haBWo");
const $b9f5341ba0d7de14$export$c2ced436a30c60dc = (0, $7NszV.createEntry)((0, $1N8g8.eocPermissionsRoute), ()=>({
        group: 'eoc',
        component: (0, $haBWo.default),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // pageAccessResource should be defined before memberRolesResources since they depend on it
            (0, $j4Jjv.pageAccessResource),
            ...(0, $j4Jjv.resources)(),
            ...(0, $2r8fH.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $haBWo.LazyMemberRoles),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("j4Jjv", function(module, exports) {

$parcel$export(module.exports, "pageAccessResource", () => $0ef99385700ea410$export$b0d36f8262140e35);
$parcel$export(module.exports, "memberRolesResource", () => $0ef99385700ea410$export$5c4885c1f1a535b);
$parcel$export(module.exports, "getTeamResource", () => $0ef99385700ea410$export$50271c9e7f21f10e);
$parcel$export(module.exports, "customTeamRolesResource", () => $0ef99385700ea410$export$ed1eb48699cf7893);
$parcel$export(module.exports, "resources", () => $0ef99385700ea410$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $VSDnB = parcelRequire("VSDnB");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $cN8Qq = parcelRequire("cN8Qq");
const $0ef99385700ea410$var$mapStatus = (status, userAccessLevel)=>{
    if (userAccessLevel === 'INTERNAL_INACTIVE') return 'suspended';
    if (status === 'REQUEST_ACCESS' || status === 'DENIED_REQUEST_EXISTS' || status === 'FORBIDDEN' || status === 'DIRECT_ACCESS') return 'invite';
    if (status === 'ACCESS_EXISTS') return 'member';
    if (status === 'PENDING_REQUEST_EXISTS') return 'pending';
    if (status === '' || status === undefined) return 'member';
    return 'invite';
};
const $0ef99385700ea410$var$checkPageAccessRightsOnRouteDependency = async (dependencies)=>{
    let isAuthorizedToSeeMemberRolesPage = false;
    if (dependencies[$0ef99385700ea410$var$PAGE_ACCESS_RESOURCE_TYPE]) {
        const data = await dependencies[$0ef99385700ea410$var$PAGE_ACCESS_RESOURCE_TYPE].promise;
        isAuthorizedToSeeMemberRolesPage = data?.productOrTeamAdmin;
    }
    return isAuthorizedToSeeMemberRolesPage;
};
const $0ef99385700ea410$var$getMembersPaginated = async (teamId)=>{
    let hasNextPage = true;
    let endCursor = '';
    let members = [];
    while(hasNextPage && endCursor !== null){
        const gqlResponse = await (0, $cN8Qq.getMembers)(teamId, endCursor);
        endCursor = gqlResponse.data.team?.teamV2?.members.pageInfo.endCursor ?? '';
        hasNextPage = gqlResponse.data.team?.teamV2?.members.pageInfo.hasNextPage ?? false;
        const newMembers = gqlResponse.data.team?.teamV2?.members.edges.map((edge)=>edge.node.member);
        if (newMembers) members = [
            ...members,
            ...newMembers
        ];
    }
    return members;
};
const $0ef99385700ea410$var$PAGE_ACCESS_RESOURCE_TYPE = 'pageAccessResource';
const $0ef99385700ea410$export$b0d36f8262140e35 = (0, $2M1hQ.createResource)({
    type: $0ef99385700ea410$var$PAGE_ACCESS_RESOURCE_TYPE,
    getKey: ()=>'pageAccessResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $hmVmJ.assert)(!!teamId, new (0, $dH6Pi.AssertionError)('pageAccessResource', 'teamId should be set to fetch page access'));
        return (0, $cN8Qq.getMemberRolesPageAccess)(teamId);
    },
    isBrowserOnly: true
});
const $0ef99385700ea410$export$5c4885c1f1a535b = (0, $2M1hQ.createResource)({
    type: 'memberRolesResource',
    getKey: ()=>'memberRolesResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        const dependencies = routerContext.dependencies;
        (0, $hmVmJ.assert)(!!teamId, new (0, $dH6Pi.AssertionError)('memberRolesResource', 'teamId should be set to fetch member-roles'));
        const isAuthorizedToSeeMemberRolesPage = await $0ef99385700ea410$var$checkPageAccessRightsOnRouteDependency(dependencies);
        if (!isAuthorizedToSeeMemberRolesPage) return null;
        let members;
        if ((0, $VSDnB.fg)('member-roles-graphql-paginaton')) members = await $0ef99385700ea410$var$getMembersPaginated(teamId);
        else {
            const gqlResponse = await (0, $cN8Qq.getMembersOld)(teamId);
            members = gqlResponse?.data.team?.teamV2?.members.edges.map((edge)=>edge.node.member) || [];
        }
        const memberRoleResponse = await (0, $cN8Qq.getRoleAndJSMLicenseInfoEndpoint)({
            platformTeamId: teamId,
            accountIds: members.map((member)=>member.accountId)
        });
        const teamMembers = members.map((user)=>{
            const userWithRole = memberRoleResponse.teamMembers.find((userWithRole)=>userWithRole.accountId === user.accountId);
            return {
                ...user,
                role: userWithRole?.roleId || 'user',
                jsmLicense: userWithRole?.jsmLicense || false,
                jiraAdmin: userWithRole?.jiraAdmin || false,
                invitationStatus: 'member'
            };
        });
        const membersWithoutJSMLicense = teamMembers.filter((teamMembers)=>!teamMembers.jsmLicense);
        if (!membersWithoutJSMLicense.length) return teamMembers;
        const accountIds = membersWithoutJSMLicense.map((member)=>member.accountId).join(',');
        try {
            const { embeddedValue: embeddedValue } = await (0, $cN8Qq.getJSMInvitationStatusInfoEndpoint)({
                accountIds: accountIds
            });
            return teamMembers.map((user)=>{
                const userWithInvitationStatus = embeddedValue.find((userWithInvitationStatus)=>userWithInvitationStatus.accountId === user.accountId);
                return {
                    ...user,
                    invitationStatus: $0ef99385700ea410$var$mapStatus(userWithInvitationStatus?.accessMode, userWithInvitationStatus?.userAccessLevel)
                };
            });
        } catch  {
            return teamMembers;
        }
    },
    isBrowserOnly: true,
    depends: [
        $0ef99385700ea410$var$PAGE_ACCESS_RESOURCE_TYPE
    ]
});
const $0ef99385700ea410$export$50271c9e7f21f10e = (0, $2M1hQ.createResource)({
    type: 'getTeamResource',
    getKey: ()=>'getTeamResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        (0, $hmVmJ.assert)(!!teamId, new (0, $dH6Pi.AssertionError)('getTeamResource', 'teamId should be set to fetch team info on member roles'));
        return (0, $cN8Qq.getTeam)(teamId);
    },
    isBrowserOnly: true
});
const $0ef99385700ea410$export$ed1eb48699cf7893 = (0, $2M1hQ.createResource)({
    type: 'customTeamRolesResource',
    getKey: ()=>'customRolesResource',
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        const dependencies = routerContext.dependencies;
        (0, $hmVmJ.assert)(!!teamId, new (0, $dH6Pi.AssertionError)('customTeamRolesResource', 'teamId should be set to fetch custom-team-roles'));
        const isAuthorizedToSeeMemberRolesPage = await $0ef99385700ea410$var$checkPageAccessRightsOnRouteDependency(dependencies);
        if (!isAuthorizedToSeeMemberRolesPage) return null;
        return (0, $cN8Qq.getCustomTeamRolesEndpoint)(teamId);
    },
    isBrowserOnly: true,
    depends: [
        $0ef99385700ea410$var$PAGE_ACCESS_RESOURCE_TYPE
    ]
});
const $0ef99385700ea410$export$bc99aaabaf7b70a7 = ()=>[
        $0ef99385700ea410$export$5c4885c1f1a535b,
        $0ef99385700ea410$export$50271c9e7f21f10e,
        $0ef99385700ea410$export$ed1eb48699cf7893
    ];

});
parcelRegister("cN8Qq", function(module, exports) {

$parcel$export(module.exports, "getMembersOld", () => $33127c313f2bb6a1$export$dc7a9fe3089fc26e);
$parcel$export(module.exports, "getMembers", () => $33127c313f2bb6a1$export$f4931e6f9feb30c5);
$parcel$export(module.exports, "getMemberRolesPageAccess", () => $33127c313f2bb6a1$export$95d4c4e762437fdd);
$parcel$export(module.exports, "getRoleAndJSMLicenseInfoEndpoint", () => $33127c313f2bb6a1$export$38ab389cb64a5000);
$parcel$export(module.exports, "getJSMInvitationStatusInfoEndpoint", () => $33127c313f2bb6a1$export$fd43007da8683026);
$parcel$export(module.exports, "getTeam", () => $33127c313f2bb6a1$export$491fe77f22ab2b51);
$parcel$export(module.exports, "getCustomTeamRolesEndpoint", () => $33127c313f2bb6a1$export$ebfa293eb1ef42f5);

var $VSDnB = parcelRequire("VSDnB");

var $j74qU = parcelRequire("j74qU");
var $030R0 = parcelRequire("030R0");
const $33127c313f2bb6a1$var$operationName = 'memberRolesTeamMembersQuery';
const $33127c313f2bb6a1$var$getMembersParams = (after)=>{
    const firstParam = (0, $VSDnB.fg)('platform_increase_limit_of_members_query') ? 'first: 300' : 'first: 100';
    const afterParam = after ? `, after: "${after}"` : '';
    return `(${firstParam}${afterParam})`;
};
const $33127c313f2bb6a1$export$dc7a9fe3089fc26e = (teamId)=>{
    const queryUrl = '/gateway/api/graphql';
    const teamAri = `ari:cloud:identity::team/${teamId}`;
    const siteId = (0, $030R0.getMeta)('ajs-cloud-id');
    const membersQueryV2 = `query memberRolesTeamMembersQuery($teamId: ID!, $siteId: String!) {
		team {
			teamV2 (id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
				id
				members ${(0, $VSDnB.fg)('platform_increase_limit_of_members_query') ? '(first: 300)' : ''}{
					edges {
						cursor
						node {
							member  {
								... on AtlassianAccountUser {
									email
								}
								name
								picture
								accountId
								accountStatus
							}
							state
							role
						}
					}
				}
			}
		}
	}
	`;
    return (0, $j74qU.eocFetch)(queryUrl, {
        method: 'POST',
        body: JSON.stringify({
            operationName: $33127c313f2bb6a1$var$operationName,
            query: membersQueryV2,
            variables: {
                teamId: teamAri,
                siteId: siteId
            }
        }),
        headers: {
            'Content-Type': 'application/json',
            'X-ExperimentalApi': 'teams-beta, team-members-beta'
        },
        exactUrl: true
    });
};
const $33127c313f2bb6a1$export$f4931e6f9feb30c5 = (teamId, after)=>{
    const queryUrl = '/gateway/api/graphql';
    const teamAri = `ari:cloud:identity::team/${teamId}`;
    const siteId = (0, $030R0.getMeta)('ajs-cloud-id');
    const membersQueryV2 = `query memberRolesTeamMembersQuery($teamId: ID!, $siteId: String!) {
		team {
			teamV2 (id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
				id
				members ${$33127c313f2bb6a1$var$getMembersParams(after)}{
					edges {
						cursor
						node {
							member  {
								... on AtlassianAccountUser {
									email
								}
								name
								picture
								accountId
								accountStatus
							}
							state
							role
						}
					}
					pageInfo {
						endCursor
						hasNextPage
					}
				}
			}
		}
	}
	`;
    return (0, $j74qU.eocFetch)(queryUrl, {
        method: 'POST',
        body: JSON.stringify({
            operationName: $33127c313f2bb6a1$var$operationName,
            query: membersQueryV2,
            variables: {
                teamId: teamAri,
                siteId: siteId
            }
        }),
        headers: {
            'Content-Type': 'application/json',
            'X-ExperimentalApi': 'teams-beta, team-members-beta'
        },
        exactUrl: true
    });
};
const $33127c313f2bb6a1$export$95d4c4e762437fdd = (teamId)=>(0, $j74qU.eocFetch)(`/v1/teams/members/member-roles-page-access?platformTeamId=${teamId}`);
const $33127c313f2bb6a1$export$38ab389cb64a5000 = ({ platformTeamId: platformTeamId, accountIds: accountIds })=>(0, $j74qU.eocFetch)(`/v1/teams/members`, {
        method: 'POST',
        body: {
            platformTeamId: platformTeamId,
            accountIds: accountIds
        }
    });
const $33127c313f2bb6a1$export$fd43007da8683026 = ({ accountIds: accountIds })=>(0, $j74qU.eocFetch)(`/v1/users/access-request-capabilities?accountIds=${accountIds}`, {
        method: 'GET'
    });
const $33127c313f2bb6a1$export$491fe77f22ab2b51 = (teamId)=>(0, $j74qU.eocFetch)(`/v1/alerts/responders/names`, {
        method: 'POST',
        body: {
            responders: [
                {
                    id: teamId,
                    type: 'team'
                }
            ]
        }
    });
const $33127c313f2bb6a1$export$ebfa293eb1ef42f5 = (platformTeamId)=>(0, $j74qU.eocFetch)(`/v1/teams/${platformTeamId}/roles`);

});


parcelRegister("1N8g8", function(module, exports) {

$parcel$export(module.exports, "eocPermissionsRoute", () => $a690bc071b9eec32$export$8e6afd724de3be6e);
const $a690bc071b9eec32$export$8e6afd724de3be6e = {
    name: 'eoc-permissions',
    path: '/jira/ops/teams/:teamId/settings',
    exact: true
};

});

parcelRegister("haBWo", function(module, exports) {

$parcel$export(module.exports, "LazyMemberRoles", () => $54e18f7965bed61c$export$27b4fb95241ab47);
$parcel$export(module.exports, "default", () => $54e18f7965bed61c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $54e18f7965bed61c$export$27b4fb95241ab47 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("bJDjw")), {
    moduleId: "./src/packages/eoc/member-roles/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$54e18f7965bed61c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $54e18f7965bed61c$export$27b4fb95241ab47,
        pageId: "async-jira-eoc-member-roles",
        shouldShowSpinner: false
    });

});
parcelRegister("bJDjw", function(module, exports) {

let $88b2649ac3677211$var$load = (parcelRequire("28QjX"))(4);
module.exports = $88b2649ac3677211$var$load("kBdWD").then(()=>parcelRequire('6Zxu7'));

});



parcelRegister("iTGOF", function(module, exports) {

$parcel$export(module.exports, "alertPoliciesRouteEntry", () => $1722f4808fc919d6$export$eb1e2324ca2031e2);

var $f4VN0 = parcelRequire("f4VN0");

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $ep3S0 = parcelRequire("ep3S0");

var $jyzx5 = parcelRequire("jyzx5");
const $1722f4808fc919d6$export$eb1e2324ca2031e2 = (0, $7NszV.createEntry)((0, $ep3S0.alertPoliciesRoute), ()=>({
        group: 'eoc',
        component: (0, $jyzx5.AlertPoliciesComponent),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $f4VN0.resources)(),
            ...(0, $2r8fH.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jyzx5.LazyAlertPolicies),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("f4VN0", function(module, exports) {

$parcel$export(module.exports, "teamPolicyResource", () => $f22ff5b7b8e8fefe$export$10d7fa513f08ef83);
$parcel$export(module.exports, "notificationPolicyResource", () => $f22ff5b7b8e8fefe$export$6d5f23d9118ad678);
$parcel$export(module.exports, "globalPolicyResource", () => $f22ff5b7b8e8fefe$export$7aed80da979a5112);
$parcel$export(module.exports, "resources", () => $f22ff5b7b8e8fefe$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $11dmp = parcelRequire("11dmp");
const $f22ff5b7b8e8fefe$export$10d7fa513f08ef83 = (0, $2M1hQ.createResource)({
    type: 'teamPolicyResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `team-policy/${teamId ?? ''}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        // if there is no teamId, this means that we are on the global policy page.
        // so we can return null directly, instead of sending fetch request.
        if (!teamId) return null;
        return (0, $11dmp.getTeamPolicies)(teamId);
    },
    isBrowserOnly: true
});
const $f22ff5b7b8e8fefe$export$6d5f23d9118ad678 = (0, $2M1hQ.createResource)({
    type: 'notificationPolicyResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return `notification-policy/${teamId}`;
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        if (!teamId) return;
        return (0, $11dmp.getNotificationPolicies)(teamId);
    },
    isBrowserOnly: true
});
const $f22ff5b7b8e8fefe$export$7aed80da979a5112 = (0, $2M1hQ.createResource)({
    type: 'globalPolicyResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        if (teamId) return `global-policy/${teamId}`;
        return 'global-policy';
    },
    getData: async (routerContext)=>{
        const teamId = routerContext.match.params?.teamId;
        return (0, $11dmp.getGlobalPolicies)(teamId);
    },
    isBrowserOnly: true
});
const $f22ff5b7b8e8fefe$export$4cb385c2db8b1e99 = (0, $2M1hQ.createResource)({
    type: 'policyMaintenanceRightsResource',
    getKey: ()=>'policy-maintenance-rights-resource',
    getData: async ()=>{
        return (0, $11dmp.getPolicyMaintenanceRights)();
    },
    isBrowserOnly: true
});
const $f22ff5b7b8e8fefe$export$bc99aaabaf7b70a7 = ()=>[
        $f22ff5b7b8e8fefe$export$10d7fa513f08ef83,
        $f22ff5b7b8e8fefe$export$7aed80da979a5112,
        $f22ff5b7b8e8fefe$export$4cb385c2db8b1e99,
        $f22ff5b7b8e8fefe$export$6d5f23d9118ad678
    ];

});
parcelRegister("11dmp", function(module, exports) {

$parcel$export(module.exports, "getTeamPolicies", () => $970bb189ad752795$export$fead0944caa1c797);
$parcel$export(module.exports, "getGlobalPolicies", () => $970bb189ad752795$export$17fc7fbef061a8c3);
$parcel$export(module.exports, "getNotificationPolicies", () => $970bb189ad752795$export$342525d9423e55ad);
$parcel$export(module.exports, "getPolicyMaintenanceRights", () => $970bb189ad752795$export$f630cbf5586dce0a);
$parcel$export(module.exports, "updateUIPreferenceEndpoint", () => $970bb189ad752795$export$6a437b43ab11275d);
$parcel$export(module.exports, "changePolicyOrderEndpoint", () => $970bb189ad752795$export$57186d786c96b52a);
$parcel$export(module.exports, "enablePolicyEndpoint", () => $970bb189ad752795$export$6fecd226d8e55346);
$parcel$export(module.exports, "disablePolicyEndpoint", () => $970bb189ad752795$export$8c0cd218e00b7d9b);
$parcel$export(module.exports, "deletePolicyEndpoint", () => $970bb189ad752795$export$f9feac6c1dcc516f);
$parcel$export(module.exports, "createPolicyEndpoint", () => $970bb189ad752795$export$b0108c51b962e788);
$parcel$export(module.exports, "updatePolicyEndpoint", () => $970bb189ad752795$export$8eabce250a2dd205);

var $j74qU = parcelRequire("j74qU");
const $970bb189ad752795$export$fead0944caa1c797 = (teamId)=>{
    return (0, $j74qU.eocFetch)(`/v1/teams/${teamId}/policies?type=alert`);
};
const $970bb189ad752795$export$17fc7fbef061a8c3 = (teamId)=>{
    if (teamId) return (0, $j74qU.eocFetch)(`/v1/alerts/policies?preferredUITeamId=${teamId}`);
    return (0, $j74qU.eocFetch)(`/v1/alerts/policies`);
};
const $970bb189ad752795$export$342525d9423e55ad = (teamId)=>{
    return (0, $j74qU.eocFetch)(`/v1/teams/${teamId}/policies?type=notification`);
};
const $970bb189ad752795$export$f630cbf5586dce0a = ()=>{
    return (0, $j74qU.eocFetch)(`/v1/alerts/ui-preferences/policy-maintenance-rights`);
};
const $970bb189ad752795$export$6a437b43ab11275d = ({ teamId: teamId, ...payload })=>{
    let url = `/v1/alerts/ui-preferences/policies`;
    if (teamId) url = `${url}?teamId=${teamId}`;
    return (0, $j74qU.eocFetch)(url, {
        method: 'PATCH',
        body: payload,
        responseType: 'headers'
    });
};
const $970bb189ad752795$export$57186d786c96b52a = (payload)=>{
    return (0, $j74qU.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}/order`, {
        method: 'PATCH',
        body: {
            after: payload.after
        },
        responseType: 'headers'
    });
};
const $970bb189ad752795$export$6fecd226d8e55346 = (payload)=>{
    return (0, $j74qU.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}/enable`, {
        method: 'POST',
        responseType: 'headers'
    });
};
const $970bb189ad752795$export$8c0cd218e00b7d9b = (payload)=>{
    return (0, $j74qU.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}/disable`, {
        method: 'POST',
        responseType: 'headers'
    });
};
const $970bb189ad752795$export$f9feac6c1dcc516f = (payload)=>{
    return (0, $j74qU.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}`, {
        method: 'DELETE',
        responseType: 'headers'
    });
};
const $970bb189ad752795$export$b0108c51b962e788 = (payload)=>{
    return (0, $j74qU.eocFetch)(`/v1/teams/${payload.teamId}/policies`, {
        method: 'POST',
        body: payload
    });
};
const $970bb189ad752795$export$8eabce250a2dd205 = (payload)=>{
    return (0, $j74qU.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}`, {
        method: 'PUT',
        body: payload
    });
};

});


parcelRegister("ep3S0", function(module, exports) {

$parcel$export(module.exports, "alertPoliciesRoute", () => $5c0bbcca2f2afa78$export$eab7ea9e54b67f16);
const $5c0bbcca2f2afa78$export$eab7ea9e54b67f16 = {
    name: 'eoc-team-policies',
    path: '/jira/ops/teams/:teamId/policies',
    exact: true
};

});

parcelRegister("jyzx5", function(module, exports) {

$parcel$export(module.exports, "LazyAlertPolicies", () => $d64c9c110834b4a3$export$3079046c31ee50f7);
$parcel$export(module.exports, "AlertPoliciesComponent", () => $d64c9c110834b4a3$export$882bdfb7e45bd440);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $d64c9c110834b4a3$export$3079046c31ee50f7 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("9h0j1")), {
    moduleId: "./src/packages/eoc/policies/src/index.tsx"
});
const $d64c9c110834b4a3$export$882bdfb7e45bd440 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d64c9c110834b4a3$export$3079046c31ee50f7,
        pageId: "async-jira-eoc-alert-policies",
        shouldShowSpinner: false
    });

});
parcelRegister("9h0j1", function(module, exports) {

let $6c05f0530dadc81c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6c05f0530dadc81c$var$load("ffQaD"),
    $6c05f0530dadc81c$var$load("kvRbA"),
    $6c05f0530dadc81c$var$load("jl4Ih")
]).then(()=>parcelRequire('3IgJn'));

});



parcelRegister("adI0E", function(module, exports) {

$parcel$export(module.exports, "globalPoliciesRouteEntry", () => $26e6da78b3e43e9c$export$2ee2f43d380cc210);

var $f4VN0 = parcelRequire("f4VN0");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $eZXFU = parcelRequire("eZXFU");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $1OKmH = parcelRequire("1OKmH");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

var $jyzx5 = parcelRequire("jyzx5");
const $26e6da78b3e43e9c$var$getNavigationSpecifications = ()=>{
    return ((0, $4R6GH.fg)('operations_nav4_remaining_items_old_navigation_fix') ? (0, $3HwlS.getWillShowNav4)() : true) && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $26e6da78b3e43e9c$export$2ee2f43d380cc210 = (0, $7NszV.createEntry)((0, $1OKmH.globalPoliciesRoute), ()=>({
        group: 'eoc',
        component: (0, $jyzx5.AlertPoliciesComponent),
        layout: (0, $eZXFU.opsSettingsLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $f4VN0.resources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$26e6da78b3e43e9c$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jyzx5.LazyAlertPolicies)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jyzx5.LazyAlertPolicies)
        ]
    }));

});
parcelRegister("1OKmH", function(module, exports) {

$parcel$export(module.exports, "globalPoliciesRoute", () => $a0dbfcfca37c6909$export$4eb24a8e860a3df7);
const $a0dbfcfca37c6909$export$4eb24a8e860a3df7 = {
    name: 'eoc-policies',
    path: '/jira/settings/products/ops/policies',
    exact: true
};

});


parcelRegister("dQtRM", function(module, exports) {

$parcel$export(module.exports, "eocGlobalReportsHomePageNav4RouteEntry", () => $d53f4be60f857b27$export$193586b163d4afae);

var $dY89w = parcelRequire("dY89w");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $70Icy = parcelRequire("70Icy");

var $eZXFU = parcelRequire("eZXFU");

var $5GbXG = parcelRequire("5GbXG");
const $d53f4be60f857b27$export$193586b163d4afae = (0, $7NszV.createEntry)((0, $70Icy.eocGlobalReportsHomePageNav4Route), ()=>({
        group: 'eoc',
        component: (0, $5GbXG.OpsReportsRedirect),
        layout: (0, $eZXFU.opsMigrationHubLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $dY89w.resources)(),
            (0, $dY89w.opsReportsPermissionResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default)
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5GbXG.LazyOpsReportsRedirect),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("dY89w", function(module, exports) {

$parcel$export(module.exports, "opsReportsResource", () => $adcf91cb99206588$export$8498311fc7a4ab48);
$parcel$export(module.exports, "opsReportsPermissionResource", () => $adcf91cb99206588$export$c432f280d76e2acf);
$parcel$export(module.exports, "resources", () => $adcf91cb99206588$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $5oSMF = parcelRequire("5oSMF");

var $QF2yk = parcelRequire("QF2yk");
const $adcf91cb99206588$export$8498311fc7a4ab48 = (0, $2M1hQ.createResource)({
    type: 'opsReportsResource',
    getKey: ()=>'opsReportsResource',
    getData: async ()=>{
        const settings = await (0, $QF2yk.getReportSettings)();
        const api = (0, $QF2yk.getDashboards);
        return {
            settings: settings,
            dashboards: settings.showReportingMaintenance ? null : await api()
        };
    },
    maxAge: Infinity,
    isBrowserOnly: true
});
const $adcf91cb99206588$export$c432f280d76e2acf = (0, $2M1hQ.createResource)({
    type: 'opsReportsPermissionResource',
    getKey: ({ match: match })=>{
        return `opsReportsPermissionResource-${match.params?.teamId}`;
    },
    getData: async (routerContext)=>{
        const isTeamDashboard = (0, $5oSMF.isTeamReportsUrl)(routerContext.match.url);
        const teamId = routerContext.match.params?.teamId;
        (0, $hmVmJ.assert)(!isTeamDashboard || !!teamId, new (0, $dH6Pi.AssertionError)('opsReportsPermissionResource', 'teamId should be set to fetch reports permissions on TeamDashboard page'));
        return (0, $QF2yk.getReportRights)(teamId);
    },
    isBrowserOnly: true,
    maxAge: Infinity
});
const $adcf91cb99206588$export$bc99aaabaf7b70a7 = ()=>[
        $adcf91cb99206588$export$8498311fc7a4ab48,
        $adcf91cb99206588$export$c432f280d76e2acf
    ];

});
parcelRegister("5oSMF", function(module, exports) {

$parcel$export(module.exports, "withReportingPrefix", () => $8aa539155af4c630$export$c0f073d636267c44);
$parcel$export(module.exports, "isTeamReportsUrl", () => $8aa539155af4c630$export$f923ac475871fcad);

var $030R0 = parcelRequire("030R0");
function $8aa539155af4c630$export$c0f073d636267c44(input) {
    // If current env is not opsgenie, we will add cloud id to base url of request.
    if (window.__OG__) return '/webapi' + input;
    const cloudId = (0, $030R0.getMeta)('ajs-cloud-id');
    if (cloudId) return `/gateway/api/jsm/ops/reporting/cloudId/${cloudId}/api` + input;
    return input;
}
const $8aa539155af4c630$export$f923ac475871fcad = (pathName)=>pathName.startsWith('/jira/ops/teams/');

});

parcelRegister("QF2yk", function(module, exports) {

$parcel$export(module.exports, "getDashboards", () => $de64900aae3821f4$export$8e4b6d6c4fec08f3);
$parcel$export(module.exports, "getReportSettings", () => $de64900aae3821f4$export$9114b8a872caf5d8);
$parcel$export(module.exports, "getSsoEmbedUrlEndpoint", () => $de64900aae3821f4$export$8384a95746267bd8);
$parcel$export(module.exports, "getReportRights", () => $de64900aae3821f4$export$f4a61c3c8c619f12);
$parcel$export(module.exports, "getAVPEmbedTokens", () => $de64900aae3821f4$export$fb46892f83504a42);

var $j74qU = parcelRequire("j74qU");

var $5oSMF = parcelRequire("5oSMF");

var $7IcT2 = parcelRequire("7IcT2");
const $de64900aae3821f4$export$8e4b6d6c4fec08f3 = ()=>(0, $j74qU.eocFetch)((0, $5oSMF.withReportingPrefix)('/v5/reports/dashboards'), {
        exactUrl: true,
        errorTransformer: $7IcT2.opsReportsErrorTransformer
    });
const $de64900aae3821f4$export$e69121e90ce0231b = ()=>(0, $j74qU.eocFetch)((0, $5oSMF.withReportingPrefix)('/v3/reports/dashboards'), {
        exactUrl: true,
        errorTransformer: $7IcT2.opsReportsErrorTransformer
    });
const $de64900aae3821f4$export$9114b8a872caf5d8 = ()=>(0, $j74qU.eocFetch)((0, $5oSMF.withReportingPrefix)('/v3/reports/index'), {
        exactUrl: true,
        errorTransformer: $7IcT2.opsReportsErrorTransformer
    });
const $de64900aae3821f4$export$8384a95746267bd8 = (isDarkMode, dashboardId, teamId)=>{
    const queryParam = teamId ? {
        theme: isDarkMode ? 'DarkMode' : '',
        dashboardId: dashboardId,
        teamId: teamId,
        // Adding time as queryParam to avoid browser caching
        // Should ideally be handled by "Cache-Control" header from server
        _: Date.now().toString()
    } : {
        theme: isDarkMode ? 'DarkMode' : '',
        dashboardId: dashboardId,
        _: Date.now().toString()
    };
    const url = `/v3/reports/dashboard?${new URLSearchParams(queryParam).toString()}`;
    return (0, $j74qU.eocFetch)((0, $5oSMF.withReportingPrefix)(url), {
        exactUrl: true,
        errorTransformer: $7IcT2.opsReportsErrorTransformer
    });
};
const $de64900aae3821f4$export$f4a61c3c8c619f12 = (teamId)=>{
    let url = '/v3/reports/rights';
    if (teamId) url += `?teamId=${teamId}`;
    return (0, $j74qU.eocFetch)((0, $5oSMF.withReportingPrefix)(url), {
        exactUrl: true,
        errorTransformer: $7IcT2.opsReportsErrorTransformer
    });
};
const $de64900aae3821f4$export$fb46892f83504a42 = (dashboardId, teamId)=>{
    let url = '/v3/reports/embed-token';
    return (0, $j74qU.eocFetch)((0, $5oSMF.withReportingPrefix)(url), {
        exactUrl: true,
        method: 'POST',
        body: {
            dashboardId: dashboardId,
            teamId: teamId
        },
        errorTransformer: $7IcT2.opsReportsErrorTransformer
    });
};

});
parcelRegister("7IcT2", function(module, exports) {

$parcel$export(module.exports, "opsReportsErrorTransformer", () => $726849c36404771c$export$b170750bd4489531);

var $aI12f = parcelRequire("aI12f");
const $726849c36404771c$var$mediaTypeRegex = /(^application\/json$)|(^application\/json([\s\t]?;.+?)*([\s\t]?;[\s\t]?charset=(("utf-8")|(utf-8)|("ISO-8859-1")|(ISO-8859-1))))/i;
const $726849c36404771c$export$b170750bd4489531 = (e)=>{
    if ((0, $aI12f.isHTTPError)(e)) {
        const contentType = e.response.headers.get('Content-Type');
        // The content type is application/json, and it is highly likely utf-8 encoded
        if (contentType && $726849c36404771c$var$mediaTypeRegex.test(contentType)) return e.response.json().then((data)=>new (0, $aI12f.StreamedHTTPError)(e, data, data.message));
        // For anything else, try to interpret it as utf8 text as best effort.
        return e.response.text().then((message)=>new (0, $aI12f.StreamedHTTPError)(e, message, message));
    }
    return e;
};

});



parcelRegister("70Icy", function(module, exports) {

$parcel$export(module.exports, "eocGlobalReportsHomePageNav4Route", () => $a80c4e46a4046a66$export$e7c62a288f7d3a11);
const $a80c4e46a4046a66$export$e7c62a288f7d3a11 = {
    name: 'eoc-global-reports',
    path: '/jira/ops/reports',
    exact: true
};

});

parcelRegister("5GbXG", function(module, exports) {

$parcel$export(module.exports, "LazyOpsReports", () => $cba1f7031d59cee6$export$2404f0e35deca592);
$parcel$export(module.exports, "LazyOpsReportsRedirect", () => $cba1f7031d59cee6$export$d33ea1a773b744e);
$parcel$export(module.exports, "LazyGlobalOpsReports", () => $cba1f7031d59cee6$export$66850ec5549adba6);
$parcel$export(module.exports, "LazyOpsReportsUnsubscribe", () => $cba1f7031d59cee6$export$5fd77c3bbfb22cbd);
$parcel$export(module.exports, "OpsReportsRedirect", () => $cba1f7031d59cee6$export$22253dbadb46d0cf);
$parcel$export(module.exports, "GlobalOpsReports", () => $cba1f7031d59cee6$export$648ddf2d1f8b1c3f);
$parcel$export(module.exports, "OpsReports", () => $cba1f7031d59cee6$export$87e6a54b4f5dc91e);
$parcel$export(module.exports, "OpsReportsUnsubscribe", () => $cba1f7031d59cee6$export$7f366d77015c286f);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $cba1f7031d59cee6$export$2404f0e35deca592 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("bGrc6")), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $cba1f7031d59cee6$export$d33ea1a773b744e = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("bGrc6")).then((exportedMembers)=>exportedMembers.OpsReportsRedirect), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $cba1f7031d59cee6$export$66850ec5549adba6 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("bGrc6")).then((exportedMembers)=>exportedMembers.GlobalOpsReports), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $cba1f7031d59cee6$export$5fd77c3bbfb22cbd = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("bGrc6")).then((exportedMembers)=>exportedMembers.OpsReportsUnsubscribe), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});
const $cba1f7031d59cee6$export$22253dbadb46d0cf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cba1f7031d59cee6$export$d33ea1a773b744e,
        pageId: "async-jira-eoc-ops-reports-redirect",
        shouldShowSpinner: false
    });
const $cba1f7031d59cee6$export$648ddf2d1f8b1c3f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cba1f7031d59cee6$export$66850ec5549adba6,
        pageId: "async-jira-eoc-global-ops-reports",
        shouldShowSpinner: false
    });
const $cba1f7031d59cee6$export$87e6a54b4f5dc91e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cba1f7031d59cee6$export$2404f0e35deca592,
        pageId: "async-jira-eoc-ops-reports",
        shouldShowSpinner: false
    });
const $cba1f7031d59cee6$export$7f366d77015c286f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cba1f7031d59cee6$export$5fd77c3bbfb22cbd,
        pageId: "async-jira-eoc-ops-reports-unsubscribe",
        shouldShowSpinner: false
    });

});
parcelRegister("bGrc6", function(module, exports) {

let $8818b62b17c4b703$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("31Bp2"), 4)),
    $8818b62b17c4b703$var$load("ffQaD"),
    $8818b62b17c4b703$var$load("kvRbA"),
    $8818b62b17c4b703$var$load("76n7a"),
    $8818b62b17c4b703$var$load("l253H"),
    $8818b62b17c4b703$var$load("hMePY")
]).then(()=>parcelRequire('eHCOd'));

});



parcelRegister("iDxTp", function(module, exports) {

$parcel$export(module.exports, "eocGlobalReportsNav4RouteEntry", () => $1fb5a93b84172f00$export$90a73fe101848dd);

var $dY89w = parcelRequire("dY89w");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $7ABBf = parcelRequire("7ABBf");

var $5GbXG = parcelRequire("5GbXG");
const $1fb5a93b84172f00$export$90a73fe101848dd = (0, $7NszV.createEntry)((0, $7ABBf.eocGlobalReportsNav4Route), ()=>({
        group: 'eoc',
        component: (0, $5GbXG.GlobalOpsReports),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $dY89w.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).HOME
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5GbXG.LazyGlobalOpsReports)
        ]
    }));

});
parcelRegister("7ABBf", function(module, exports) {

$parcel$export(module.exports, "eocGlobalReportsNav4Route", () => $4c6718ca5b31c262$export$2344cc35fd2eff4e);
const $4c6718ca5b31c262$export$2344cc35fd2eff4e = {
    name: 'eoc-global-report-dashboard',
    path: '/jira/ops/reports/:dashboardId',
    exact: true
};

});


parcelRegister("bAN0d", function(module, exports) {

$parcel$export(module.exports, "eocReportsTeamRedirectRouteEntry", () => $8d76deaec1999545$export$c5606e8eeca32c0f);

var $dY89w = parcelRequire("dY89w");

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $8mgka = parcelRequire("8mgka");

var $5GbXG = parcelRequire("5GbXG");
const $8d76deaec1999545$export$c5606e8eeca32c0f = (0, $7NszV.createEntry)((0, $8mgka.eocReportsTeamRedirectRoute), ()=>({
        group: 'eoc',
        component: (0, $5GbXG.OpsReportsRedirect),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $2r8fH.resources)(),
            ...(0, $dY89w.resources)(),
            (0, $dY89w.opsReportsPermissionResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5GbXG.LazyOpsReportsRedirect),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("8mgka", function(module, exports) {

$parcel$export(module.exports, "eocReportsTeamRedirectRoute", () => $4180c49ce19c4186$export$26b0a544e6502d55);
const $4180c49ce19c4186$export$26b0a544e6502d55 = {
    name: 'eoc-reports',
    path: '/jira/ops/teams/:teamId/reports',
    exact: true
};

});


parcelRegister("cLm5J", function(module, exports) {

$parcel$export(module.exports, "eocReportsTeamRouteEntry", () => $7f20eb6c54fad956$export$cd1c1a81e516fec5);

var $dY89w = parcelRequire("dY89w");

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $bSLd2 = parcelRequire("bSLd2");

var $5GbXG = parcelRequire("5GbXG");
const $7f20eb6c54fad956$export$cd1c1a81e516fec5 = (0, $7NszV.createEntry)((0, $bSLd2.eocReportsTeamRoute), ()=>({
        group: 'eoc',
        component: (0, $5GbXG.OpsReports),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $2r8fH.resources)(),
            ...(0, $dY89w.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5GbXG.LazyOpsReports),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("bSLd2", function(module, exports) {

$parcel$export(module.exports, "eocReportsTeamRoute", () => $ffd6c3cc5b5e020a$export$c9e0796615c034f3);
const $ffd6c3cc5b5e020a$export$c9e0796615c034f3 = {
    name: 'eoc-reports-team',
    path: '/jira/ops/teams/:teamId/reports/:dashboardId',
    exact: true
};

});


parcelRegister("dbAmH", function(module, exports) {

$parcel$export(module.exports, "eocReportsUnsubscribeRouteEntry", () => $a7106536ac902eff$export$6e8d112a548528b5);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $gEF2C = parcelRequire("gEF2C");

var $5GbXG = parcelRequire("5GbXG");
const $a7106536ac902eff$export$6e8d112a548528b5 = (0, $7NszV.createEntry)((0, $gEF2C.eocReportsUnsubscribeRoute), ()=>({
        group: 'eoc',
        component: (0, $5GbXG.OpsReportsUnsubscribe),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5GbXG.LazyOpsReportsUnsubscribe)
        ]
    }));

});
parcelRegister("gEF2C", function(module, exports) {

$parcel$export(module.exports, "eocReportsUnsubscribeRoute", () => $491397448b2426d8$export$72cde899ee974e6e);
const $491397448b2426d8$export$72cde899ee974e6e = {
    name: 'eoc-reports-unsubscribe',
    path: '/jira/ops/reports/unsubscribe/:templateId/:subscriptionId',
    exact: true
};

});


parcelRegister("4Xzif", function(module, exports) {

$parcel$export(module.exports, "roleBasedNotificationDetailRouteEntry", () => $29aaea7e1c593cdc$export$565325825b04cec6);

var $hZVks = parcelRequire("hZVks");

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $8CqQS = parcelRequire("8CqQS");

var $7OghT = parcelRequire("7OghT");

var $k3GMp = parcelRequire("k3GMp");
const $29aaea7e1c593cdc$export$565325825b04cec6 = (0, $7NszV.createEntry)((0, $8CqQS.roleBasedNotificationDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $7OghT.RoleBasedNotificationsComponent),
        layout: (0, $ibkIl.globalSettingsLayout),
        slot: (0, $k3GMp.RoleBasedNotificationDetail),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $hZVks.resources)[0],
            (0, $hZVks.resources)[1],
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        forPaint: [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7OghT.LazyRoleBasedNotifications)
        ]
    }));

});
parcelRegister("hZVks", function(module, exports) {

$parcel$export(module.exports, "roleBasedNotificationsResource", () => $a9efe5455286a2a7$export$9a716bf20d804ec3);
$parcel$export(module.exports, "notificationDetailResource", () => $a9efe5455286a2a7$export$8ad8a0a20fd0ed5a);
$parcel$export(module.exports, "resources", () => $a9efe5455286a2a7$export$bc99aaabaf7b70a7);

var $2M1hQ = parcelRequire("2M1hQ");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $5V1Ip = parcelRequire("5V1Ip");
const $a9efe5455286a2a7$export$9a716bf20d804ec3 = (0, $2M1hQ.createResource)({
    type: 'roleBasedNotificationsResource',
    getKey: ()=>'roleBasedNotificationsResource',
    getData: (0, $5V1Ip.getRoleBasedNotificationsEndpoint),
    isBrowserOnly: true,
    maxAge: 300000
});
const $a9efe5455286a2a7$export$8ad8a0a20fd0ed5a = (0, $2M1hQ.createResource)({
    type: 'notificationDetailResource',
    getKey: ({ match: match })=>{
        const settingId = match.params['id'];
        return `notificationDetailResource-id=${settingId}`;
    },
    getData: ({ match: match })=>{
        const settingId = match.params['id'];
        (0, $hmVmJ.assert)(!!settingId, new (0, $dH6Pi.AssertionError)('notificationDetailResource', 'settingId is required'));
        return (0, $5V1Ip.getRoleBasedNotificationDetailEndpoint)(settingId);
    },
    isBrowserOnly: true
});
const $a9efe5455286a2a7$export$bc99aaabaf7b70a7 = [
    $a9efe5455286a2a7$export$9a716bf20d804ec3,
    $a9efe5455286a2a7$export$8ad8a0a20fd0ed5a
];

});
parcelRegister("5V1Ip", function(module, exports) {

$parcel$export(module.exports, "getRoleBasedNotificationsEndpoint", () => $c1906554d85d7a30$export$db67dfe9fe98cd49);
$parcel$export(module.exports, "getRoleBasedNotificationDetailEndpoint", () => $c1906554d85d7a30$export$5522446e6d3ee73);

var $j74qU = parcelRequire("j74qU");
const $c1906554d85d7a30$export$db67dfe9fe98cd49 = ()=>(0, $j74qU.eocFetch)(`/v1/role-based-notifications`);
const $c1906554d85d7a30$export$5522446e6d3ee73 = (settingId)=>(0, $j74qU.eocFetch)(`/v1/role-based-notifications/${settingId}`);

});


parcelRegister("8CqQS", function(module, exports) {

$parcel$export(module.exports, "roleBasedNotificationDetailRoute", () => $8ff922c499db0d93$export$10ec812f053317c9);
const $8ff922c499db0d93$export$10ec812f053317c9 = {
    name: 'eoc-role-based-notifications-detail',
    path: '/jira/settings/products/ops/role-based-notifications/:id',
    exact: true
};

});

parcelRegister("7OghT", function(module, exports) {

$parcel$export(module.exports, "LazyRoleBasedNotifications", () => $1190c1dcb9a75d0f$export$15a244aba8f3b406);
$parcel$export(module.exports, "RoleBasedNotificationsComponent", () => $1190c1dcb9a75d0f$export$8994be6f8ad6a04a);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $1190c1dcb9a75d0f$export$15a244aba8f3b406 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("ksHZF")).then((module)=>module.RoleBasedNotificationsPage), {
    moduleId: "./src/packages/eoc/role-based-notifications/src/index.tsx"
});
const $1190c1dcb9a75d0f$export$8994be6f8ad6a04a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $1190c1dcb9a75d0f$export$15a244aba8f3b406,
        pageId: "async-jira-eoc-role-based-notifications",
        shouldShowSpinner: false
    });

});
parcelRegister("ksHZF", function(module, exports) {

let $ee588c5de5ed242d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ee588c5de5ed242d$var$load("ffQaD"),
    $ee588c5de5ed242d$var$load("kvRbA"),
    $ee588c5de5ed242d$var$load("kNFvF"),
    $ee588c5de5ed242d$var$load("kToIa")
]).then(()=>parcelRequire('2ddPE'));

});


parcelRegister("k3GMp", function(module, exports) {

$parcel$export(module.exports, "RoleBasedNotificationDetail", () => $89e521226d6aac78$export$445112c3a1089cc5);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $89e521226d6aac78$export$5211e5a7ed694f98 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("ksHZF")).then((module)=>module.RoleBasedNotificationDetail), {
    moduleId: "./src/packages/eoc/role-based-notifications/src/index.tsx"
});
const $89e521226d6aac78$export$445112c3a1089cc5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $89e521226d6aac78$export$5211e5a7ed694f98,
        pageId: "async-jira-eoc-role-based-notifications",
        shouldShowSpinner: false
    });

});


parcelRegister("7mf3n", function(module, exports) {

$parcel$export(module.exports, "roleBasedNotificationsRouteEntry", () => $fec308ab1c0618bc$export$60de9875bb8ef1d6);

var $hZVks = parcelRequire("hZVks");

var $ffza4 = parcelRequire("ffza4");

var $eZXFU = parcelRequire("eZXFU");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $2bQB3 = parcelRequire("2bQB3");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

var $7OghT = parcelRequire("7OghT");
const $fec308ab1c0618bc$var$getNavigationSpecifications = ()=>{
    return ((0, $4R6GH.fg)('operations_nav4_remaining_items_old_navigation_fix') ? (0, $3HwlS.getWillShowNav4)() : true) && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $fec308ab1c0618bc$export$60de9875bb8ef1d6 = (0, $7NszV.createEntry)((0, $2bQB3.roleBasedNotificationsRoute), ()=>({
        group: 'eoc',
        component: (0, $7OghT.RoleBasedNotificationsComponent),
        layout: (0, $eZXFU.opsSettingsLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $hZVks.resources)[0],
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$fec308ab1c0618bc$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7OghT.LazyRoleBasedNotifications)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7OghT.LazyRoleBasedNotifications)
        ]
    }));

});
parcelRegister("2bQB3", function(module, exports) {

$parcel$export(module.exports, "roleBasedNotificationsRoute", () => $2188ae80315aaff9$export$5a10092825ee32e4);
const $2188ae80315aaff9$export$5a10092825ee32e4 = {
    name: 'eoc-role-based-notifications',
    path: '/jira/settings/products/ops/role-based-notifications',
    exact: true
};

});


parcelRegister("jPcas", function(module, exports) {

$parcel$export(module.exports, "eocScheduleGlobalRouteEntry", () => $8a8ca7bd84166494$export$831e8756cdaae4ba);

var $5uXOq = parcelRequire("5uXOq");

var $9AeZq = parcelRequire("9AeZq");

var $ffza4 = parcelRequire("ffza4");

var $eZXFU = parcelRequire("eZXFU");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $4ft8f = parcelRequire("4ft8f");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8a8ca7bd84166494$var$LazyScheduleGlobalPage = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("k2zD9")).then((m)=>m.ScheduleGlobalPage), {
    moduleId: "./src/packages/eoc/schedule-global/src/ui/index.tsx"
});
const $8a8ca7bd84166494$var$EocScheduleGlobalComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8a8ca7bd84166494$var$LazyScheduleGlobalPage,
        pageId: "async-jira-eoc-schedule-global",
        shouldShowSpinner: false
    });
const $8a8ca7bd84166494$var$getNavigationSpecifications = ()=>{
    return ((0, $4R6GH.fg)('operations_nav4_remaining_items_old_navigation_fix') ? (0, $3HwlS.getWillShowNav4)() : true) && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $8a8ca7bd84166494$export$831e8756cdaae4ba = (0, $7NszV.createEntry)((0, $4ft8f.eocScheduleGlobalRoute), ()=>({
        group: 'eoc',
        component: $8a8ca7bd84166494$var$EocScheduleGlobalComponent,
        layout: (0, $eZXFU.opsSettingsLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $9AeZq.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$8a8ca7bd84166494$var$getNavigationSpecifications()
        },
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            $8a8ca7bd84166494$var$LazyScheduleGlobalPage
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            $8a8ca7bd84166494$var$LazyScheduleGlobalPage
        ]
    }));

});
parcelRegister("9AeZq", function(module, exports) {

$parcel$export(module.exports, "resources", () => $3fd272a65e76c31a$export$bc99aaabaf7b70a7);

var $jxRF2 = parcelRequire("jxRF2");

var $dmLt8 = parcelRequire("dmLt8");
const $3fd272a65e76c31a$export$bc99aaabaf7b70a7 = ()=>[
        (0, $dmLt8.getTimezonesResource),
        (0, $dmLt8.getTimeTemplatesResource),
        ...(0, $jxRF2.eocCommonResources)()
    ];

});

parcelRegister("4ft8f", function(module, exports) {

$parcel$export(module.exports, "eocScheduleGlobalRoute", () => $9844eccd8c34fec5$export$10454dc485142eb6);
const $9844eccd8c34fec5$export$10454dc485142eb6 = {
    name: 'eoc-schedules',
    path: '/jira/settings/products/ops/schedules',
    exact: true
};

});

parcelRegister("k2zD9", function(module, exports) {

let $e96fa20a86511590$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e96fa20a86511590$var$load("ffQaD"),
    $e96fa20a86511590$var$load("kvRbA"),
    $e96fa20a86511590$var$load("lN09y")
]).then(()=>parcelRequire('94AYi'));

});


parcelRegister("k7VEf", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertDetailRouteEntry", () => $0f8c358fa6dbfa33$export$94aaa7006da9d63a);

var $en1L8 = parcelRequire("en1L8");

var $8C32n = parcelRequire("8C32n");

var $2r8fH = parcelRequire("2r8fH");

var $i5qMw = parcelRequire("i5qMw");

var $4R6GH = parcelRequire("4R6GH");

var $gNStA = parcelRequire("gNStA");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $fnZCh = parcelRequire("fnZCh");

var $cgOQ8 = parcelRequire("cgOQ8");
const $0f8c358fa6dbfa33$export$94aaa7006da9d63a = (0, $7NszV.createEntry)((0, $fnZCh.eocTeamAlertDetailRoute), ()=>({
        group: 'eoc',
        component: (0, $cgOQ8.default),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $2r8fH.resources)(),
            ...(0, $8C32n.resources)(),
            ...(0, $en1L8.resources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('automation_discoverability_in_jsm'), (0, $i5qMw.getAutomationDiscoveryDismissResource))
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cgOQ8.LazyAlertList),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("cgOQ8", function(module, exports) {

$parcel$export(module.exports, "LazyAlertList", () => $c4eca2f6e4b2f333$export$f4aafff31d950b6c);
$parcel$export(module.exports, "default", () => $c4eca2f6e4b2f333$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $c4eca2f6e4b2f333$export$f4aafff31d950b6c = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("9m0hg")), {
    moduleId: "./src/packages/eoc/alert-list/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c4eca2f6e4b2f333$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $c4eca2f6e4b2f333$export$f4aafff31d950b6c,
        pageId: "async-jira-eoc-alert-list",
        shouldShowSpinner: false
    });

});


parcelRegister("4yINJ", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertListRouteEntry", () => $f23486e21e430737$export$de37dab3b3ed8e5c);

var $8C32n = parcelRequire("8C32n");

var $2r8fH = parcelRequire("2r8fH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $3Dk1Z = parcelRequire("3Dk1Z");

var $bh0Pj = parcelRequire("bh0Pj");

var $h3Ix2 = parcelRequire("h3Ix2");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $fH1HX = parcelRequire("fH1HX");

var $cgOQ8 = parcelRequire("cgOQ8");
const $f23486e21e430737$export$de37dab3b3ed8e5c = (0, $7NszV.createEntry)((0, $fH1HX.eocTeamAlertListRoute), ()=>({
        group: 'eoc',
        component: (0, $cgOQ8.default),
        layout: (0, $h3Ix2.opsTeamLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $2r8fH.resources)(),
            ...(0, $8C32n.resources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $3Dk1Z.default),
            horizontal: (0, $bh0Pj.AsyncHorizontalOperationsNav),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $bh0Pj.LazyHorizontalOperationsNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cgOQ8.LazyAlertList),
            (0, $3Dk1Z.LazyTeamDashboardSidebar)
        ]
    }));

});
parcelRegister("fH1HX", function(module, exports) {

$parcel$export(module.exports, "eocTeamAlertListRoute", () => $f402982842ecbfd0$export$94efd60f23d97aa5);
const $f402982842ecbfd0$export$94efd60f23d97aa5 = {
    name: 'eoc-team-alerts',
    path: '/jira/ops/teams/:teamId/alerts',
    exact: true
};

});


parcelRegister("bubms", function(module, exports) {

$parcel$export(module.exports, "eocTeamCustomerLogsDownloadRouteEntry", () => $aca15c3cadc5a7fe$export$d2ce6f09ef8aa840);

var $c4Buu = parcelRequire("c4Buu");

var $ibkIl = parcelRequire("ibkIl");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $6ZSdP = parcelRequire("6ZSdP");

var $8OJXJ = parcelRequire("8OJXJ");
const $aca15c3cadc5a7fe$export$d2ce6f09ef8aa840 = (0, $7NszV.createEntry)((0, $6ZSdP.eocTeamCustomerLogsDownloadRoute), ()=>({
        group: 'eoc',
        component: (0, $8OJXJ.CustomerLogsDownloadPage),
        layout: (0, $ibkIl.globalSettingsLayout),
        resources: [
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $c4Buu.downloadResources)()
        ],
        forPaint: [
            (0, $8OJXJ.LazyCustomerLogsDownLoad)
        ]
    }));

});
parcelRegister("6ZSdP", function(module, exports) {

$parcel$export(module.exports, "eocTeamCustomerLogsDownloadRoute", () => $e73c1ac5cb6acb9d$export$678856ccddc0bc05);
const $e73c1ac5cb6acb9d$export$678856ccddc0bc05 = {
    name: 'eoc-team-customer-logs-download',
    path: '/jira/settings/products/ops/jira-service-management-audit-logs/download/:exportUniqueKey',
    exact: true
};

});

parcelRegister("8OJXJ", function(module, exports) {

$parcel$export(module.exports, "LazyCustomerLogs", () => $ff16a0c6b99cd2b6$export$6e30e25faf4f6dce);
$parcel$export(module.exports, "LazyCustomerLogsDownLoad", () => $ff16a0c6b99cd2b6$export$898c7cb3b28a6104);
$parcel$export(module.exports, "default", () => $ff16a0c6b99cd2b6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "CustomerLogsDownloadPage", () => $ff16a0c6b99cd2b6$export$a5786cf859b7b457);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $ff16a0c6b99cd2b6$export$6e30e25faf4f6dce = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("fFuGa")), {
    moduleId: "./src/packages/eoc/customer-logs/src/index.tsx"
});

const $ff16a0c6b99cd2b6$export$898c7cb3b28a6104 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("fFuGa")).then(({ CustomerLogsDownloadPage: CustomerLogsDownloadPage })=>CustomerLogsDownloadPage), {
    moduleId: "./src/packages/eoc/customer-logs/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ff16a0c6b99cd2b6$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ff16a0c6b99cd2b6$export$6e30e25faf4f6dce,
        pageId: "async-jira-eoc-customer-logs",
        shouldShowSpinner: false
    });
const $ff16a0c6b99cd2b6$export$a5786cf859b7b457 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ff16a0c6b99cd2b6$export$898c7cb3b28a6104,
        pageId: "async-jira-eoc-customer-logs-download",
        shouldShowSpinner: false
    });

});
parcelRegister("fFuGa", function(module, exports) {

let $b6827b92a9d2471b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b6827b92a9d2471b$var$load("8kKGn").then(()=>parcelRequire('ecO2s'));

});



parcelRegister("fOrUU", function(module, exports) {

$parcel$export(module.exports, "eocTeamCustomerLogsRouteEntry", () => $82450f458637cd82$export$42ca979ec2919b23);

var $c4Buu = parcelRequire("c4Buu");

var $ffza4 = parcelRequire("ffza4");

var $eZXFU = parcelRequire("eZXFU");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $3HwlS = parcelRequire("3HwlS");

var $dlUF2 = parcelRequire("dlUF2");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $8OJXJ = parcelRequire("8OJXJ");
const $82450f458637cd82$var$getNavigationSpecifications = ()=>{
    return ((0, $4R6GH.fg)('operations_nav4_remaining_items_old_navigation_fix') ? (0, $3HwlS.getWillShowNav4)() : true) && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $82450f458637cd82$export$42ca979ec2919b23 = (0, $7NszV.createEntry)((0, $dlUF2.eocTeamCustomerLogsRoute), ()=>({
        group: 'eoc',
        component: (0, $8OJXJ.default),
        layout: (0, $eZXFU.opsSettingsLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$82450f458637cd82$var$getNavigationSpecifications()
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $c4Buu.resources)()
        ],
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8OJXJ.LazyCustomerLogs)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8OJXJ.LazyCustomerLogs)
        ]
    }));

});
parcelRegister("dlUF2", function(module, exports) {

$parcel$export(module.exports, "eocTeamCustomerLogsRoute", () => $3689be50764be7f7$export$4b517044f5f7830d);
const $3689be50764be7f7$export$4b517044f5f7830d = {
    name: 'eoc-team-customer-logs',
    path: '/jira/settings/products/ops/jira-service-management-audit-logs',
    exact: true
};

});


parcelRegister("g6Mf9", function(module, exports) {

$parcel$export(module.exports, "unlockOperationsRouteEntry", () => $10f9f9ad449ec307$export$c058f4d1c0667ce1);

var $ffza4 = parcelRequire("ffza4");

var $iqZds = parcelRequire("iqZds");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $l1EdH = parcelRequire("l1EdH");

var $3RJkv = parcelRequire("3RJkv");

var $1Mqbh = parcelRequire("1Mqbh");

var $3E8Yw = parcelRequire("3E8Yw");
const $10f9f9ad449ec307$export$c058f4d1c0667ce1 = (0, $7NszV.createEntry)((0, $1Mqbh.unlockOperationsRoute), ()=>({
        group: 'eoc',
        layout: (0, $iqZds.eocChangeboardingLayout),
        component: (0, $3E8Yw.default),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $l1EdH.resources)()
        ],
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3E8Yw.LazyUnlockOperations)
        ]
    }));

});
parcelRegister("l1EdH", function(module, exports) {

$parcel$export(module.exports, "resources", () => $05907c872dfc2fcc$export$bc99aaabaf7b70a7);

var $ieJ0b = parcelRequire("ieJ0b");

const $05907c872dfc2fcc$export$bc99aaabaf7b70a7 = ()=>[
        (0, $ieJ0b.transitioningDetailsResource)
    ];

});
parcelRegister("ieJ0b", function(module, exports) {

$parcel$export(module.exports, "transitioningDetailsResource", () => $86a5b96e0cefda11$export$850d76e0c9ffbdeb);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");
const $86a5b96e0cefda11$export$7985153d37586c9a = (cloudId)=>(0, $eusud.performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/customers/transitioning-details`).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getTransitioningDetails',
                packageName: 'jiraRouterResourcesEocUnlockOperations',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
const $86a5b96e0cefda11$export$850d76e0c9ffbdeb = (0, $2M1hQ.createResource)({
    type: 'EOC_UNLOCK_OPERATIONS',
    getKey: ()=>'eoc-unlock-operations',
    getData: async (_, { tenantContext: { cloudId: cloudId } })=>$86a5b96e0cefda11$export$7985153d37586c9a(cloudId),
    maxAge: 0,
    isBrowserOnly: true
});

});


parcelRegister("1Mqbh", function(module, exports) {

$parcel$export(module.exports, "unlockOperationsRoute", () => $03066cf43774e262$export$30306de7e00bc5a2);
const $03066cf43774e262$export$30306de7e00bc5a2 = {
    name: 'eoc-unlock-operations',
    path: '/jira/settings/products/ops/unlock',
    exact: true
};

});

parcelRegister("3E8Yw", function(module, exports) {

$parcel$export(module.exports, "LazyUnlockOperations", () => $c4c082612871271f$export$55e4754d556d072);
$parcel$export(module.exports, "default", () => $c4c082612871271f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $c4c082612871271f$export$55e4754d556d072 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("jBT4K")), {
    moduleId: "./src/packages/eoc/unlock-operations/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c4c082612871271f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $c4c082612871271f$export$55e4754d556d072,
        pageId: "eoc-products-unlock-operations",
        shouldShowSpinner: false
    });

});
parcelRegister("jBT4K", function(module, exports) {

let $e46c31e2abf1d1a6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e46c31e2abf1d1a6$var$load("4gJkh").then(()=>parcelRequire('1lA3p'));

});



parcelRegister("9bLSq", function(module, exports) {

$parcel$export(module.exports, "eocUserNotificationsRouteEntry", () => $7f3a610ac409efab$export$15b42089d01e5917);

var $8ytTF = parcelRequire("8ytTF");

var $gk6PH = parcelRequire("gk6PH");

var $1Xcuw = parcelRequire("1Xcuw");

var $ffza4 = parcelRequire("ffza4");

var $eZXFU = parcelRequire("eZXFU");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $4o9PX = parcelRequire("4o9PX");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

var $bHVtu = parcelRequire("bHVtu");
const $7f3a610ac409efab$var$getNavigationSpecifications = ()=>{
    return ((0, $4R6GH.fg)('operations_nav4_remaining_items_old_navigation_fix') ? (0, $3HwlS.getWillShowNav4)() : true) && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $7f3a610ac409efab$export$15b42089d01e5917 = (0, $7NszV.createEntry)((0, $4o9PX.eocUserNotificationsRoute), ()=>({
        group: 'eoc',
        component: (0, $bHVtu.default),
        layout: (0, $eZXFU.opsSettingsLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$7f3a610ac409efab$var$getNavigationSpecifications()
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $8ytTF.createContactsResource)(),
            (0, $1Xcuw.createNotificationPreferencesResource)(),
            (0, $gk6PH.createMuteResource)(),
            (0, $gk6PH.createQuietHoursResource)(),
            (0, $1Xcuw.createForwardingRulesResource)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bHVtu.LazyUserNotifications)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bHVtu.LazyUserNotifications)
        ]
    }));

});
parcelRegister("8ytTF", function(module, exports) {

$parcel$export(module.exports, "createContactsResource", () => $3c33a8a96991f1a3$export$b9ca444b0be3df97);
$parcel$export(module.exports, "contactsResource", () => $3c33a8a96991f1a3$export$54a06d876c95357d);

var $2M1hQ = parcelRequire("2M1hQ");

var $VSDnB = parcelRequire("VSDnB");

var $4UHgN = parcelRequire("4UHgN");
const $3c33a8a96991f1a3$export$b9ca444b0be3df97 = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'contactsResource',
        getKey: ()=>'contactsResource',
        getData: async ({ dependencies: dependencies, match: match })=>{
            const targetAccountId = (0, $VSDnB.fg)('jsm_admin_access_user_notification_settings') ? match.params?.targetAccountId : undefined;
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            const data = await (0, $4UHgN.getContacts)(targetAccountId);
            return data.contacts;
        },
        isBrowserOnly: true,
        depends: depends
    });
const $3c33a8a96991f1a3$export$54a06d876c95357d = $3c33a8a96991f1a3$export$b9ca444b0be3df97();

});
parcelRegister("4UHgN", function(module, exports) {

$parcel$export(module.exports, "getContacts", () => $dee84df670092829$export$70ff9d70e43e8f10);
$parcel$export(module.exports, "addContactEndpoint", () => $dee84df670092829$export$bd596455bda1cd66);
$parcel$export(module.exports, "orderContactEndpoint", () => $dee84df670092829$export$77f16e7683ad08d6);
$parcel$export(module.exports, "updateContactStatusEndpoint", () => $dee84df670092829$export$d50cab05338f8080);
$parcel$export(module.exports, "deleteContactEndpoint", () => $dee84df670092829$export$59eb3ff38e4cd944);
$parcel$export(module.exports, "editContactEndpoint", () => $dee84df670092829$export$3f8035f77e3aeb9d);
$parcel$export(module.exports, "sendVerificationCodeEndpoint", () => $dee84df670092829$export$74e1bdc56dc32826);
$parcel$export(module.exports, "checkVerificationCodeEndpoint", () => $dee84df670092829$export$fbe80b8d857094de);

var $j74qU = parcelRequire("j74qU");

var $1qSGt = parcelRequire("1qSGt");
const $dee84df670092829$export$70ff9d70e43e8f10 = (targetAccountId)=>(0, $j74qU.eocFetch)(`/v1/users/contact${(0, $1qSGt.getTargetAccountIdSuffix)(targetAccountId)}`);
const $dee84df670092829$export$bd596455bda1cd66 = (newAddress, method, targetAccountId)=>{
    return (0, $j74qU.eocFetch)(`/v1/users/contact${(0, $1qSGt.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'POST',
        body: {
            address: newAddress,
            method: method.toLowerCase()
        }
    });
};
const $dee84df670092829$export$77f16e7683ad08d6 = (contactId, after, targetAccountId)=>{
    return (0, $j74qU.eocFetch)(`/v1/users/contact/order${(0, $1qSGt.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'PATCH',
        body: {
            contactId: contactId,
            after: after
        }
    });
};
const $dee84df670092829$export$d50cab05338f8080 = (status)=>{
    return status ? $dee84df670092829$var$enableContactEndpoint : $dee84df670092829$var$disableContactEndpoint;
};
const $dee84df670092829$var$enableContactEndpoint = (contactId, targetAccountId)=>{
    return (0, $j74qU.eocFetch)(`/v1/users/contact/state/enabled${(0, $1qSGt.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'PATCH',
        body: {
            contactId: contactId
        }
    });
};
const $dee84df670092829$var$disableContactEndpoint = (contactId, targetAccountId)=>{
    return (0, $j74qU.eocFetch)(`/v1/users/contact/state/disabled${(0, $1qSGt.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'PATCH',
        body: {
            contactId: contactId
        }
    });
};
const $dee84df670092829$export$59eb3ff38e4cd944 = (contactId, targetAccountId)=>{
    return (0, $j74qU.eocFetch)(`/v1/users/contact${(0, $1qSGt.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'DELETE',
        body: {
            contactId: contactId
        },
        responseType: 'headers'
    });
};
const $dee84df670092829$export$3f8035f77e3aeb9d = (contactId, newAddress, targetAccountId)=>{
    return (0, $j74qU.eocFetch)(`/v1/users/contact${(0, $1qSGt.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'PATCH',
        body: {
            contactId: contactId,
            address: newAddress
        }
    });
};
const $dee84df670092829$export$74e1bdc56dc32826 = (phoneNumber, method, targetAccountId)=>{
    return (0, $j74qU.eocFetch)(`/v1/users/contact/verification${(0, $1qSGt.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'POST',
        body: {
            phoneNumber: phoneNumber,
            method: method.toLowerCase()
        }
    });
};
const $dee84df670092829$export$fbe80b8d857094de = (phoneNumber, code, targetAccountId)=>{
    return (0, $j74qU.eocFetch)(`/v1/users/contact/verification/check${(0, $1qSGt.getTargetAccountIdSuffix)(targetAccountId)}`, {
        method: 'POST',
        body: {
            phoneNumber: phoneNumber,
            code: code
        },
        responseType: 'headers'
    });
};

});
parcelRegister("1qSGt", function(module, exports) {

$parcel$export(module.exports, "calculateRemainingMinutesAndSeconds", () => $69e2e00ba5affada$export$d3f650aeadf07bf8);
$parcel$export(module.exports, "getTargetAccountIdSuffix", () => $69e2e00ba5affada$export$f538d5c43127966b);

var $VSDnB = parcelRequire("VSDnB");
const $69e2e00ba5affada$export$d3f650aeadf07bf8 = (countDown)=>{
    const minutes = Math.floor(countDown % 3600000 / 60000);
    const seconds = Math.floor(countDown % 60000 / 1000);
    return [
        minutes < 0 ? 0 : minutes,
        seconds < 0 ? 0 : seconds
    ];
};
const $69e2e00ba5affada$export$f538d5c43127966b = (targetAccountId)=>{
    if ((0, $VSDnB.fg)('jsm_admin_access_user_notification_settings')) return targetAccountId ? `?targetAccountId=${targetAccountId}` : '';
    return '';
};

});



parcelRegister("gk6PH", function(module, exports) {

$parcel$export(module.exports, "createMuteResource", () => $63d22459d7da235f$export$c849cfac68bc6e80);
$parcel$export(module.exports, "createQuietHoursResource", () => $63d22459d7da235f$export$efc5e8690061f9cc);
$parcel$export(module.exports, "muteResource", () => $63d22459d7da235f$export$3c4c16a7c2620c29);
$parcel$export(module.exports, "quietHoursResource", () => $63d22459d7da235f$export$9b33012bd34cc225);

var $2M1hQ = parcelRequire("2M1hQ");

var $cSvuU = parcelRequire("cSvuU");
const $63d22459d7da235f$export$c849cfac68bc6e80 = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'muteResource',
        getKey: ()=>'muteResource',
        getData: ({ dependencies: dependencies, match: match })=>{
            const targetAccountId = match.params?.targetAccountId;
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $cSvuU.getMuteDetail)(targetAccountId);
        },
        isBrowserOnly: true,
        depends: depends
    });
const $63d22459d7da235f$export$efc5e8690061f9cc = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'quietHoursResource',
        getKey: ()=>'quietHoursResource',
        getData: ({ dependencies: dependencies, match: match })=>{
            const targetAccountId = match.params?.targetAccountId;
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $cSvuU.getQuietHoursDetail)(targetAccountId);
        },
        isBrowserOnly: true,
        depends: depends
    });
const $63d22459d7da235f$export$3c4c16a7c2620c29 = $63d22459d7da235f$export$c849cfac68bc6e80();
const $63d22459d7da235f$export$9b33012bd34cc225 = $63d22459d7da235f$export$efc5e8690061f9cc();

});
parcelRegister("cSvuU", function(module, exports) {

$parcel$export(module.exports, "getMuteDetail", () => $6e548a208bc1f9bf$export$80a4e62998a806a6);
$parcel$export(module.exports, "getQuietHoursDetail", () => $6e548a208bc1f9bf$export$44a94c74f358d02f);

var $j74qU = parcelRequire("j74qU");

var $j9fdm = parcelRequire("j9fdm");
const $6e548a208bc1f9bf$export$80a4e62998a806a6 = (targetAccountId)=>(0, $j74qU.eocFetch)(`/v1/users/notifications/mute${(0, $j9fdm.getTargetAccountIdSuffix)(targetAccountId)}`);
const $6e548a208bc1f9bf$export$44a94c74f358d02f = (targetAccountId)=>(0, $j74qU.eocFetch)(`/v1/users/quiet-hours/details${(0, $j9fdm.getTargetAccountIdSuffix)(targetAccountId)}`);

});
parcelRegister("j9fdm", function(module, exports) {

$parcel$export(module.exports, "getTargetAccountIdSuffix", () => $a80d378b5e253b9e$export$f538d5c43127966b);

var $VSDnB = parcelRequire("VSDnB");
const $a80d378b5e253b9e$export$f538d5c43127966b = (targetAccountId)=>{
    if ((0, $VSDnB.fg)('jsm_admin_access_user_notification_settings')) return targetAccountId ? `?targetAccountId=${targetAccountId}` : '';
    return '';
};

});



parcelRegister("1Xcuw", function(module, exports) {

$parcel$export(module.exports, "createNotificationPreferencesResource", () => $adb36d8860d29889$export$731980bd233a4797);
$parcel$export(module.exports, "createForwardingRulesResource", () => $adb36d8860d29889$export$5314dca65b4e5888);

var $2M1hQ = parcelRequire("2M1hQ");
parcelRequire("jxRF2");
var $ldKOT = parcelRequire("ldKOT");

var $4wOw1 = parcelRequire("4wOw1");
const $adb36d8860d29889$export$731980bd233a4797 = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'notificationPreferencesResource',
        getKey: ()=>'notificationPreferencesResource',
        getData: ({ dependencies: dependencies, match: match })=>{
            const targetAccountId = match.params?.targetAccountId;
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $4wOw1.getNotificationPreferences)(targetAccountId);
        },
        isBrowserOnly: true,
        depends: depends
    });
const $adb36d8860d29889$export$5314dca65b4e5888 = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'forwardingRulesResource',
        getKey: ()=>'forwardingRulesResource',
        getData: ({ dependencies: dependencies, match: match })=>{
            const targetAccountId = match.params?.targetAccountId;
            const isConsolidated = checkConsolidationOnRouteDependency ? // This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
            checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $4wOw1.getForwardingRules)(targetAccountId).then(({ values: values })=>values);
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("4wOw1", function(module, exports) {

$parcel$export(module.exports, "getNotificationPreferences", () => $05fff912cf0441ba$export$60e139c3026f21bc);
$parcel$export(module.exports, "getForwardingRules", () => $05fff912cf0441ba$export$2161af98e3d645a5);

var $j74qU = parcelRequire("j74qU");

var $1iPXg = parcelRequire("1iPXg");
const $05fff912cf0441ba$export$60e139c3026f21bc = (targetAccountId)=>(0, $j74qU.eocFetch)(`/v1/users/notification-preferences${(0, $1iPXg.getTargetAccountIdSuffix)(targetAccountId)}`);
const $05fff912cf0441ba$export$2161af98e3d645a5 = (targetAccountId)=>(0, $j74qU.eocFetch)(`/v1/alerts/notifications/forwarding-rules${(0, $1iPXg.getTargetAccountIdSuffix)(targetAccountId)}`);

});
parcelRegister("1iPXg", function(module, exports) {

$parcel$export(module.exports, "getOperationName", () => $b24aa276f68665dd$export$41bca9dc6871dd4e);
$parcel$export(module.exports, "getMatchType", () => $b24aa276f68665dd$export$a8ea0fb63186ef7e);
$parcel$export(module.exports, "formatRestriction", () => $b24aa276f68665dd$export$99bcc87a197977ea);
$parcel$export(module.exports, "getAvailableRuleTypeOptions", () => $b24aa276f68665dd$export$c5259662f509f23f);
$parcel$export(module.exports, "getDefaultTimeOptions", () => $b24aa276f68665dd$export$318d0e67e244d7ff);
$parcel$export(module.exports, "getTargetAccountIdSuffix", () => $b24aa276f68665dd$export$f538d5c43127966b);

var $gwejS = parcelRequire("gwejS");

var $k7m40 = parcelRequire("k7m40");

var $f2F4g = parcelRequire("f2F4g");

var $1GF3c = parcelRequire("1GF3c");

var $VSDnB = parcelRequire("VSDnB");

var $9U82y = parcelRequire("9U82y");

var $7K1zJ = parcelRequire("7K1zJ");

var $1zwqa = parcelRequire("1zwqa");
const $b24aa276f68665dd$export$41bca9dc6871dd4e = (id)=>{
    const operation = (0, $9U82y.OPERATIONS).find((operation)=>operation.id === id);
    return operation?.name;
};
const $b24aa276f68665dd$export$a8ea0fb63186ef7e = (conditionMatchType)=>{
    switch(conditionMatchType){
        case 1:
            return 'match-any-condition';
        case 2:
            return 'match-all-conditions';
        default:
            return 'match-all';
    }
};
const $b24aa276f68665dd$export$5f84d4e06c0693c4 = ()=>{
    const firstDOW = (0, $1GF3c.default)(new Date(), {
        weekStartsOn: 0
    });
    const weekDays = Array.from(Array(7)).map((e, i)=>({
            label: (0, $k7m40.default)((0, $gwejS.default)(firstDOW, i), 'EEEE'),
            value: i % 7 + 1
        }));
    return weekDays;
};
const $b24aa276f68665dd$export$99bcc87a197977ea = (timeInterval)=>{
    const days = $b24aa276f68665dd$export$5f84d4e06c0693c4();
    const startDay = days.find((day)=>day.value === timeInterval.startDay);
    const endDay = days.find((day)=>day.value === timeInterval.endDay);
    const startTime = (0, $k7m40.default)((0, $f2F4g.default)(new Date(), {
        hours: timeInterval.startHour,
        minutes: timeInterval.startMinute
    }), 'p');
    const endTime = (0, $k7m40.default)((0, $f2F4g.default)(new Date(), {
        hours: timeInterval.endHour,
        minutes: timeInterval.endMinute
    }), 'p');
    if (startDay && endDay) {
        const formattedTime = `${startDay.label} ${startTime} - ${endDay.label} ${endTime}`;
        return formattedTime;
    }
    const formattedTime = `${startTime} - ${endTime}`;
    return formattedTime;
};
const $b24aa276f68665dd$export$c5259662f509f23f = (formatMessage)=>{
    return Object.keys((0, $7K1zJ.AVAILABLE_RULE_TYPES)).filter((v)=>isNaN(Number(v))).map((key)=>({
            label: formatMessage((0, $1zwqa.default)[key]),
            value: key
        }));
};
const $b24aa276f68665dd$export$318d0e67e244d7ff = ()=>{
    return [
        ...Array(24).keys()
    ].map((time)=>{
        let newTime = time.toString();
        if (newTime.length === 1) newTime = `0${time}`;
        return [
            `${newTime}:00`,
            `${newTime}:30`
        ];
    }).flatMap((time)=>time);
};
const $b24aa276f68665dd$export$f538d5c43127966b = (targetAccountId)=>{
    if ((0, $VSDnB.fg)('jsm_admin_access_user_notification_settings')) return targetAccountId ? `?targetAccountId=${targetAccountId}` : '';
    return '';
};

});
parcelRegister("9U82y", function(module, exports) {

$parcel$export(module.exports, "DATE_FORMAT", () => $5c6a6e22fa30e50d$export$45c85543ba71221d);
$parcel$export(module.exports, "TIME_FORMAT", () => $5c6a6e22fa30e50d$export$c4e1e4e065ff5bd8);
$parcel$export(module.exports, "DATETIME_FORMAT", () => $5c6a6e22fa30e50d$export$ae1dc8cbcf481d8e);
$parcel$export(module.exports, "OPERATIONS", () => $5c6a6e22fa30e50d$export$98ff4de2f070152d);
$parcel$export(module.exports, "SPOTLIGHT_NAMES", () => $5c6a6e22fa30e50d$export$a7c923252528b255);
$parcel$export(module.exports, "defaultTimes", () => $5c6a6e22fa30e50d$export$b42ffb9f09b1861b);
$parcel$export(module.exports, "supportArticles", () => $5c6a6e22fa30e50d$export$f4b848c2437238f9);

var $7K1zJ = parcelRequire("7K1zJ");
const $5c6a6e22fa30e50d$export$45c85543ba71221d = 'dd/MM/yyyy';
const $5c6a6e22fa30e50d$export$c4e1e4e065ff5bd8 = 'h:mm aaa';
const $5c6a6e22fa30e50d$export$ae1dc8cbcf481d8e = `${$5c6a6e22fa30e50d$export$45c85543ba71221d}; ${$5c6a6e22fa30e50d$export$c4e1e4e065ff5bd8}`;
const $5c6a6e22fa30e50d$export$98ff4de2f070152d = [
    {
        order: 0,
        id: (0, $7K1zJ.OperationIds).Matches,
        name: (0, $7K1zJ.Operation).Matches
    },
    {
        order: 1,
        id: (0, $7K1zJ.OperationIds).Equals,
        name: (0, $7K1zJ.Operation).Equals
    },
    {
        order: 2,
        id: (0, $7K1zJ.OperationIds).Contains,
        name: (0, $7K1zJ.Operation).Contains
    },
    {
        order: 3,
        id: (0, $7K1zJ.OperationIds).StartsWith,
        name: (0, $7K1zJ.Operation).StartsWith
    },
    {
        order: 4,
        id: (0, $7K1zJ.OperationIds).EndsWith,
        name: (0, $7K1zJ.Operation).EndsWith
    },
    {
        order: 5,
        id: (0, $7K1zJ.OperationIds).ContainsKey,
        name: (0, $7K1zJ.Operation).ContainsKey
    },
    {
        order: 6,
        id: (0, $7K1zJ.OperationIds).ContainsValue,
        name: (0, $7K1zJ.Operation).ContainsValue
    },
    {
        order: 7,
        id: (0, $7K1zJ.OperationIds).GreaterThan,
        name: (0, $7K1zJ.Operation).GreaterThan
    },
    {
        order: 8,
        id: (0, $7K1zJ.OperationIds).LessThan,
        name: (0, $7K1zJ.Operation).LessThan
    },
    {
        order: 9,
        id: (0, $7K1zJ.OperationIds).IsEmpty,
        name: (0, $7K1zJ.Operation).IsEmpty
    },
    {
        order: 10,
        id: (0, $7K1zJ.OperationIds).EqualsIgnoreWhitespace,
        name: (0, $7K1zJ.Operation).EqualsIgnoreWhitespace
    }
];
const $5c6a6e22fa30e50d$export$a7c923252528b255 = {
    dndTitle: 'eoc-notifications_dnd_title',
    rulesTitle: 'eoc-notifications_rules_title',
    forwardingRulesTitle: 'eoc-notifications_forwarding_rules_title'
};
const $5c6a6e22fa30e50d$export$b42ffb9f09b1861b = [
    ...Array(24).keys()
].map((time)=>{
    let newTime = time.toString();
    if (newTime.length === 1) newTime = `0${time}`;
    return [
        `${newTime}:00`,
        `${newTime}:30`
    ];
}).flatMap((time)=>time);
const $5c6a6e22fa30e50d$export$f4b848c2437238f9 = {
    setUpRoleBasedNotifications: {
        jsm: 'https://support.atlassian.com/jira-service-management-cloud/docs/set-up-role-based-notifications/',
        compass: 'https://compass-ops-help.atlassian.net/wiki/spaces/OPERATIONS/pages/112066569/Set+up+role-based+notifications/'
    },
    setUpSmsAndVoice: {
        jsm: 'https://support.atlassian.com/jira-service-management-cloud/docs/set-up-sms-and-voice-notifications/#Contact-information',
        compass: 'https://compass-ops-help.atlassian.net/wiki/spaces/OPERATIONS/pages/11404235/Set+up+SMS+and+voice+notifications#Contact-information'
    },
    setUpNotificationPreferences: {
        jsm: 'https://support.atlassian.com/jira-service-management-cloud/docs/set-up-notification-preferences',
        compass: 'https://compass-ops-help.atlassian.net/wiki/spaces/OPERATIONS/pages/11469955/Set+up+notification+preferences'
    },
    notificationForwardingRules: {
        jsm: 'https://support.atlassian.com/jira-service-management-cloud/docs/add-notification-forwarding-rules',
        compass: 'https://compass-ops-help.atlassian.net/wiki/spaces/OPERATIONS/pages/11404196/Add+notification+forwarding+rules'
    }
};

});
parcelRegister("7K1zJ", function(module, exports) {

$parcel$export(module.exports, "AVAILABLE_RULE_TYPES", () => $22fbd560e3500848$export$a4958d8d5a6aee21);
$parcel$export(module.exports, "OperationIds", () => $22fbd560e3500848$export$9e369e35ea3634d7);
$parcel$export(module.exports, "ReverseOperations", () => $22fbd560e3500848$export$e722854e5571abe4);
$parcel$export(module.exports, "MatchConditionType", () => $22fbd560e3500848$export$dab128282aa7aeee);
$parcel$export(module.exports, "Operation", () => $22fbd560e3500848$export$ab5aad00225c5662);
var $22fbd560e3500848$export$a4958d8d5a6aee21 = /*#__PURE__*/ function(AVAILABLE_RULE_TYPES) {
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["New Alert"] = 0] = "New Alert";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Schedule Start"] = 3] = "Schedule Start";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Schedule End"] = 7] = "Schedule End";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Incoming Call Routing"] = 8] = "Incoming Call Routing";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Acknowledged Alert"] = 1] = "Acknowledged Alert";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Closed Alert"] = 2] = "Closed Alert";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Assigned Alert"] = 5] = "Assigned Alert";
    AVAILABLE_RULE_TYPES[AVAILABLE_RULE_TYPES["Add Note"] = 6] = "Add Note";
    return AVAILABLE_RULE_TYPES;
}({});
var $22fbd560e3500848$export$9e369e35ea3634d7 = /*#__PURE__*/ function(OperationIds) {
    OperationIds[OperationIds["Matches"] = 0] = "Matches";
    OperationIds[OperationIds["Contains"] = 1] = "Contains";
    OperationIds[OperationIds["StartsWith"] = 3] = "StartsWith";
    OperationIds[OperationIds["EndsWith"] = 4] = "EndsWith";
    OperationIds[OperationIds["Equals"] = 5] = "Equals";
    OperationIds[OperationIds["ContainsKey"] = 6] = "ContainsKey";
    OperationIds[OperationIds["ContainsValue"] = 7] = "ContainsValue";
    OperationIds[OperationIds["GreaterThan"] = 8] = "GreaterThan";
    OperationIds[OperationIds["LessThan"] = 9] = "LessThan";
    OperationIds[OperationIds["IsEmpty"] = 10] = "IsEmpty";
    OperationIds[OperationIds["EqualsIgnoreWhitespace"] = 11] = "EqualsIgnoreWhitespace";
    return OperationIds;
}({});
var $22fbd560e3500848$export$e722854e5571abe4 = /*#__PURE__*/ function(ReverseOperations) {
    ReverseOperations[ReverseOperations["matches"] = 0] = "matches";
    ReverseOperations[ReverseOperations["contains"] = 1] = "contains";
    ReverseOperations[ReverseOperations["starts-with"] = 3] = "starts-with";
    ReverseOperations[ReverseOperations["ends-with"] = 4] = "ends-with";
    ReverseOperations[ReverseOperations["equals"] = 5] = "equals";
    ReverseOperations[ReverseOperations["contains-key"] = 6] = "contains-key";
    ReverseOperations[ReverseOperations["contains-value"] = 7] = "contains-value";
    ReverseOperations[ReverseOperations["greater-than"] = 8] = "greater-than";
    ReverseOperations[ReverseOperations["less-than"] = 9] = "less-than";
    ReverseOperations[ReverseOperations["is-empty"] = 10] = "is-empty";
    ReverseOperations[ReverseOperations["equals-ignore-whitespace"] = 11] = "equals-ignore-whitespace";
    return ReverseOperations;
}({});
var $22fbd560e3500848$export$dab128282aa7aeee = /*#__PURE__*/ function(MatchConditionType) {
    MatchConditionType[MatchConditionType["match-all"] = 0] = "match-all";
    MatchConditionType[MatchConditionType["match-any-condition"] = 1] = "match-any-condition";
    MatchConditionType[MatchConditionType["match-all-conditions"] = 2] = "match-all-conditions";
    return MatchConditionType;
}({});
var $22fbd560e3500848$export$ab5aad00225c5662 = /*#__PURE__*/ function(Operation) {
    Operation["Matches"] = "matches";
    Operation["Contains"] = "contains";
    Operation["StartsWith"] = "starts-with";
    Operation["EndsWith"] = "ends-with";
    Operation["Equals"] = "equals";
    Operation["ContainsKey"] = "contains-key";
    Operation["ContainsValue"] = "contains-value";
    Operation["GreaterThan"] = "greater-than";
    Operation["LessThan"] = "less-than";
    Operation["IsEmpty"] = "is-empty";
    Operation["EqualsIgnoreWhitespace"] = "equals-ignore-whitespace";
    return Operation;
}({});

});


parcelRegister("1zwqa", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6fe15d7c66ba072$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $b6fe15d7c66ba072$var$messages = (0, $7VHMR.defineMessages)({
    addIcon: {
        id: 'eoc.notifications.rules.add-icon.no-translate',
        defaultMessage: 'Add rule',
        description: 'Button label to indicate it is used for adding a new notification rule.'
    },
    'New Alert': {
        id: 'eoc.notifications.ui.notifications.new-alert.no-translate',
        defaultMessage: 'New alert',
        description: 'The title of new alert notifications'
    },
    'Schedule Start': {
        id: 'eoc.notifications.ui.notifications.schedule-start.no-translate',
        defaultMessage: 'Schedule start',
        description: 'The title of schedule start notifications'
    },
    'Schedule End': {
        id: 'eoc.notifications.ui.notifications.schedule-end.no-translate',
        defaultMessage: 'Schedule end',
        description: 'The title of schedule end notifications'
    },
    'Acknowledged Alert': {
        id: 'eoc.notifications.ui.notifications.acknowledged-alert.no-translate',
        defaultMessage: 'Acknowledged alert',
        description: 'The title of acknowledged alert notifications'
    },
    'Closed Alert': {
        id: 'eoc.notifications.ui.notifications.closed-alert.no-translate',
        defaultMessage: 'Closed alert',
        description: 'The title of closed alert notifications'
    },
    'Assigned Alert': {
        id: 'eoc.notifications.ui.notifications.assigned-alert.no-translate',
        defaultMessage: 'Assigned alert',
        description: 'The title of assigned alert notifications'
    },
    'Add Note': {
        id: 'eoc.notifications.ui.notifications.add-note.no-translate',
        defaultMessage: 'Add note',
        description: 'The title of add note notifications'
    },
    'Incoming Call Routing': {
        id: 'eoc.notifications.ui.notifications.incoming-call-routing.no-translate',
        defaultMessage: 'Incoming Call Routing',
        description: 'The title of incoming call rounting notifications'
    },
    addButtonTooltip: {
        id: 'eoc.notifications.common.ui.notification-section.add-button-tooltip.non-final',
        defaultMessage: "A role-based notification is in effect, so adding more rules isn\u2019t possible.",
        description: 'The message to be shown when user tries to add a rule but there is a role-based notification'
    }
});
var $b6fe15d7c66ba072$export$2e2bcd8739ae039 = $b6fe15d7c66ba072$var$messages;

});




parcelRegister("4o9PX", function(module, exports) {

$parcel$export(module.exports, "eocUserNotificationsRoute", () => $65aa2d34a770a788$export$f7a15352c90f8063);
const $65aa2d34a770a788$export$f7a15352c90f8063 = {
    name: 'eoc-user-notifications',
    path: '/jira/settings/products/ops/role-assignment/notifications/:targetAccountId',
    exact: true
};

});

parcelRegister("bHVtu", function(module, exports) {

$parcel$export(module.exports, "LazyUserNotifications", () => $9464b60ca4af723d$export$a510b3cfe09fad0d);
$parcel$export(module.exports, "default", () => $9464b60ca4af723d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $9464b60ca4af723d$export$a510b3cfe09fad0d = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("fnLBM")), {
    ssr: false,
    moduleId: "./src/packages/eoc/user-notifications/src/index.tsx"
});
const $9464b60ca4af723d$var$LazyUserNotificationsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9464b60ca4af723d$export$a510b3cfe09fad0d,
        pageId: "async-eoc-user-notifications",
        shouldShowSpinner: false
    });
var $9464b60ca4af723d$export$2e2bcd8739ae039 = $9464b60ca4af723d$var$LazyUserNotificationsPage;

});
parcelRegister("fnLBM", function(module, exports) {

let $b32def00c740af9b$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $b32def00c740af9b$var$load("ffQaD"),
    $b32def00c740af9b$var$load("kvRbA"),
    $b32def00c740af9b$var$load("76n7a"),
    $b32def00c740af9b$var$load("l253H"),
    $b32def00c740af9b$var$load("3HmhJ")
]).then(()=>parcelRequire('gqBoQ'));

});



parcelRegister("V3Ey7", function(module, exports) {

$parcel$export(module.exports, "whoIsOnCallRouteEntry", () => $b83a8bf24279056f$export$fee33ca9661e49dd);

var $vla3y = parcelRequire("vla3y");

var $ffza4 = parcelRequire("ffza4");

var $iqZds = parcelRequire("iqZds");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $9Nrj8 = parcelRequire("9Nrj8");

var $hAT18 = parcelRequire("hAT18");
const $b83a8bf24279056f$var$getWhoIsOnCallResources = ()=>(0, $vla3y.resources);
const $b83a8bf24279056f$export$fee33ca9661e49dd = (0, $7NszV.createEntry)((0, $9Nrj8.whoIsOnCallRoute), ()=>({
        group: 'eoc',
        layout: (0, $iqZds.eocChangeboardingLayout),
        component: (0, $hAT18.WhoIsOnCallComponent),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...$b83a8bf24279056f$var$getWhoIsOnCallResources()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hAT18.LazyWhoIsOnCall)
        ]
    }));

});
parcelRegister("vla3y", function(module, exports) {

$parcel$export(module.exports, "myTeamsResource", () => $21f951fdce1763c0$export$602f373f7fdaccc1);
$parcel$export(module.exports, "statusResource", () => $21f951fdce1763c0$export$8f57164cc67fb360);
$parcel$export(module.exports, "userTimelineResource", () => $21f951fdce1763c0$export$35b906dc2329cdc6);
$parcel$export(module.exports, "schedulesResource", () => $21f951fdce1763c0$export$f9574b51fbc36dc3);
$parcel$export(module.exports, "resources", () => $21f951fdce1763c0$export$bc99aaabaf7b70a7);
$parcel$export(module.exports, "widgetResources", () => $21f951fdce1763c0$export$bce3244764eac6e6);
$parcel$export(module.exports, "createMyTeamsResource", () => (parcelRequire("kCVY8")).createMyTeamsResource);
$parcel$export(module.exports, "createStatusResource", () => (parcelRequire("5IZS8")).createStatusResource);
$parcel$export(module.exports, "createUserTimelineResource", () => (parcelRequire("izTEw")).createUserTimelineResource);
$parcel$export(module.exports, "createSchedulesResource", () => (parcelRequire("dlTDC")).createSchedulesResource);
parcelRequire("jxRF2");
var $ldKOT = parcelRequire("ldKOT");

var $kCVY8 = parcelRequire("kCVY8");

var $jfpRV = parcelRequire("jfpRV");

var $dlTDC = parcelRequire("dlTDC");

var $5IZS8 = parcelRequire("5IZS8");

var $izTEw = parcelRequire("izTEw");
const $21f951fdce1763c0$export$602f373f7fdaccc1 = (0, $kCVY8.createMyTeamsResource)();
const $21f951fdce1763c0$export$f363fac02afee7a4 = (0, $jfpRV.createOpsTeamsResource)();
const $21f951fdce1763c0$export$8f57164cc67fb360 = (0, $5IZS8.createStatusResource)();
const $21f951fdce1763c0$export$35b906dc2329cdc6 = (0, $izTEw.createUserTimelineResource)();
const $21f951fdce1763c0$export$f9574b51fbc36dc3 = (0, $dlTDC.createSchedulesResource)();
const $21f951fdce1763c0$export$bc99aaabaf7b70a7 = [
    (0, $ldKOT.eocUserResource),
    (0, $kCVY8.createMyTeamsResource)(),
    (0, $5IZS8.createStatusResource)(),
    (0, $jfpRV.createOpsTeamsResource)()
];
const $21f951fdce1763c0$export$bce3244764eac6e6 = [
    ()=>(0, $ldKOT.eocUserResource),
    (callback, depends)=>(0, $kCVY8.createMyTeamsResource)(callback, depends),
    (callback, depends)=>(0, $5IZS8.createStatusResource)(callback, depends),
    (callback, depends)=>(0, $izTEw.createUserTimelineResource)(callback, depends),
    (callback, depends)=>(0, $dlTDC.createSchedulesResource)(callback, depends)
];

});
parcelRegister("kCVY8", function(module, exports) {

$parcel$export(module.exports, "createMyTeamsResource", () => $cad624fc2ff7cfd6$export$bf86fb90d0661bcb);

var $2M1hQ = parcelRequire("2M1hQ");

var $6OdRW = parcelRequire("6OdRW");
const $cad624fc2ff7cfd6$export$bf86fb90d0661bcb = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'myTeamsResource',
        getKey: ()=>'myTeamsResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $6OdRW.getMyTeamsEndpoint)();
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("6OdRW", function(module, exports) {

$parcel$export(module.exports, "getMyTeamsEndpoint", () => $8d7771bc195a7eba$export$abe46da7d1f191a7);

var $j74qU = parcelRequire("j74qU");
const $8d7771bc195a7eba$export$abe46da7d1f191a7 = ()=>{
    return (0, $j74qU.eocFetch)(`/v1/alerts/responders/suggested`);
};

});


parcelRegister("jfpRV", function(module, exports) {

$parcel$export(module.exports, "createOpsTeamsResource", () => $8fdf339b714e66ed$export$99505a9d792f516c);

var $2M1hQ = parcelRequire("2M1hQ");

var $6LUYW = parcelRequire("6LUYW");
const $8fdf339b714e66ed$export$99505a9d792f516c = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'opsTeamsResource',
        getKey: ()=>'opsTeamsResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $6LUYW.getOpsTeamsEndpoint)().then((response)=>{
                return response.values;
            });
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("6LUYW", function(module, exports) {

$parcel$export(module.exports, "getOpsTeamsEndpoint", () => $da0ecde7fda1bab3$export$7498ba30158c16cd);

var $j74qU = parcelRequire("j74qU");

var $68pYM = parcelRequire("68pYM");
const $da0ecde7fda1bab3$export$7498ba30158c16cd = ()=>{
    return (0, $j74qU.eocFetch)((0, $68pYM.urls).teams.url());
};

});
parcelRegister("68pYM", function(module, exports) {

$parcel$export(module.exports, "urls", () => $d4c8bf52c3691263$export$bcae9ba627f604b6);
$parcel$export(module.exports, "SPOTLIGHT_NAMES", () => $d4c8bf52c3691263$export$a7c923252528b255);
$parcel$export(module.exports, "SPOTLIGHT_TOURS", () => $d4c8bf52c3691263$export$38c46ed7a5bc80a0);
$parcel$export(module.exports, "WhoIsOnCallHandler", () => $d4c8bf52c3691263$export$1e7191618d5d4548);
$parcel$export(module.exports, "WhoIsOnCallWidgetHandler", () => $d4c8bf52c3691263$export$d05bbb1ada0e07c4);
const $d4c8bf52c3691263$export$bcae9ba627f604b6 = Object.freeze({
    schedules: {
        url: ()=>`/v1/schedules`,
        user: {
            url: ()=>`${$d4c8bf52c3691263$export$bcae9ba627f604b6.schedules.url()}/user`,
            timeline: {
                url: ()=>`${$d4c8bf52c3691263$export$bcae9ba627f604b6.schedules.user.url()}/timeline`,
                export: {
                    url: ()=>`${$d4c8bf52c3691263$export$bcae9ba627f604b6.schedules.user.timeline.url()}/export`
                }
            },
            userId: {
                url: ({ userId: userId } = {
                    userId: ':userId'
                })=>`${$d4c8bf52c3691263$export$bcae9ba627f604b6.schedules.user.url()}/${userId}`
            }
        },
        onCalls: {
            url: ()=>`${$d4c8bf52c3691263$export$bcae9ba627f604b6.schedules.url()}/on-calls`
        },
        scheduleId: {
            url: ({ scheduleId: scheduleId } = {
                scheduleId: ':scheduleId'
            })=>`${$d4c8bf52c3691263$export$bcae9ba627f604b6.schedules.url()}/${scheduleId}`,
            timeline: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`${$d4c8bf52c3691263$export$bcae9ba627f604b6.schedules.scheduleId.url({
                        scheduleId: scheduleId
                    })}/timeline`
            }
        }
    },
    wioc: {
        status: {
            url: ()=>`${$d4c8bf52c3691263$export$bcae9ba627f604b6.schedules.url()}/user/on-calls`
        }
    },
    teams: {
        url: ()=>`/v1/teams`
    }
});
const $d4c8bf52c3691263$export$a7c923252528b255 = {
    firstOverlappingPeriod: 'eoc-who-is-on-call_first_overlapping_period'
};
const $d4c8bf52c3691263$export$38c46ed7a5bc80a0 = {
    overlappingPeriod: 'eoc-who-is-on-call-overlapping-period'
};
class $d4c8bf52c3691263$export$1e7191618d5d4548 {
    handler(message, context) {
        throw new Error('Not implemented');
    }
}
class $d4c8bf52c3691263$export$d05bbb1ada0e07c4 {
    handler(message, context) {
        throw new Error('Not implemented');
    }
}

});



parcelRegister("dlTDC", function(module, exports) {

$parcel$export(module.exports, "createSchedulesResource", () => $10cde28570610d7a$export$b5e65ca3f82b01c5);

var $2M1hQ = parcelRequire("2M1hQ");

var $ajrLe = parcelRequire("ajrLe");
const $10cde28570610d7a$export$b5e65ca3f82b01c5 = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'schedulesResource',
        getKey: ()=>'schedulesResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $ajrLe.getSchedulesEndpoint)();
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("ajrLe", function(module, exports) {

$parcel$export(module.exports, "getSchedulesEndpoint", () => $1a931852d60ab07d$export$e8e940098db1b988);

var $j74qU = parcelRequire("j74qU");

var $68pYM = parcelRequire("68pYM");
const $1a931852d60ab07d$export$e8e940098db1b988 = ()=>{
    return (0, $j74qU.eocFetch)(`${(0, $68pYM.urls).schedules.onCalls.url()}`);
};

});


parcelRegister("5IZS8", function(module, exports) {

$parcel$export(module.exports, "createStatusResource", () => $c6e09a482698443b$export$3d1c353e2693418c);

var $2M1hQ = parcelRequire("2M1hQ");

var $iyzC0 = parcelRequire("iyzC0");

var $41Gqg = parcelRequire("41Gqg");
const $c6e09a482698443b$export$3d1c353e2693418c = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'statusResource',
        getKey: ()=>'statusResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $iyzC0.getStatus)().then((0, $41Gqg.transformStatusResponse));
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("iyzC0", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $d83203ae0be7e9b4$export$b70265791d2079d4);

var $j74qU = parcelRequire("j74qU");

var $68pYM = parcelRequire("68pYM");
const $d83203ae0be7e9b4$export$b70265791d2079d4 = ()=>{
    return (0, $j74qU.eocFetch)((0, $68pYM.urls).wioc.status.url(), {
        method: 'GET'
    });
};

});

parcelRegister("41Gqg", function(module, exports) {

$parcel$export(module.exports, "transformStatusResponse", () => $8a21b756a892d7eb$export$44a749c89534e42c);
const $8a21b756a892d7eb$export$44a749c89534e42c = ({ currentTimeUtcMillis: currentTimeUtcMillis, onCallUntilUtcMillis: onCallUntilUtcMillis, onCallUntilOffsetMillis: onCallUntilOffsetMillis, isCurrentOnCall: isCurrentOnCall, isParticipantOfAnyRotation: isParticipantOfAnyRotation, nextOnCallEndUtcMillis: nextOnCallEndUtcMillis, nextOnCallEndOffsetMillis: nextOnCallEndOffsetMillis, nextOnCallStartUtcMillis: nextOnCallStartUtcMillis, nextOnCallStartOffsetMillis: nextOnCallStartOffsetMillis })=>{
    return {
        currentDate: currentTimeUtcMillis,
        currentShiftEnd: onCallUntilUtcMillis,
        currentShiftEndOffset: onCallUntilOffsetMillis,
        isOnCall: isCurrentOnCall,
        isParticipantOfAnyRotation: isParticipantOfAnyRotation,
        nextEndDate: nextOnCallEndUtcMillis,
        nextEndOffset: nextOnCallEndOffsetMillis,
        nextStartDate: nextOnCallStartUtcMillis,
        nextStartOffset: nextOnCallStartOffsetMillis
    };
};

});


parcelRegister("izTEw", function(module, exports) {

$parcel$export(module.exports, "createUserTimelineResource", () => $3f4c51b6b015af14$export$a479dcc35c33def1);

var $2M1hQ = parcelRequire("2M1hQ");
parcelRequire("jxRF2");
var $ldKOT = parcelRequire("ldKOT");

var $5rGi1 = parcelRequire("5rGi1");
const $3f4c51b6b015af14$export$a479dcc35c33def1 = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'userTimelineResource',
        getKey: ()=>'userTimelineResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            const data = await dependencies[(0, $ldKOT.eocUserResource).type]?.promise;
            // Since depends API types are not exported it's impossible to infer types,
            // thus we have to use casting
            const accountId = data?.accountId;
            const timezone = data?.timeZone;
            if (!accountId || !timezone) return null;
            return (0, $5rGi1.getWidgetTimeline)(accountId);
        },
        isBrowserOnly: true,
        depends: [
            ...depends ? depends : [],
            (0, $ldKOT.eocUserResource).type
        ]
    });

});
parcelRegister("5rGi1", function(module, exports) {

$parcel$export(module.exports, "getWidgetTimeline", () => $2c4955dde7aaf4da$export$bd80cae08a85b1f0);

var $eYLkf = parcelRequire("eYLkf");

var $j74qU = parcelRequire("j74qU");

var $68pYM = parcelRequire("68pYM");

var $8PqA1 = parcelRequire("8PqA1");
const $2c4955dde7aaf4da$export$bd80cae08a85b1f0 = (accountId)=>{
    const formattedCurrent = (0, $eYLkf.default)(new Date(), 'UTC', "yyyy-MM-dd'T'HH:mm:ss.SSSXX");
    const urlParams = new URLSearchParams({
        currentDate: formattedCurrent,
        accountId: accountId,
        mode: 'timeline',
        timelineType: '6'
    });
    return (0, $j74qU.eocFetch)(`${(0, $68pYM.urls).schedules.user.timeline.url()}?${urlParams.toString()}`, {
        method: 'GET'
    }).then((0, $8PqA1.transformUserTimelineResponse));
};

});
parcelRegister("eYLkf", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae7b6125506491b3$export$2e2bcd8739ae039);

var $fwbX5 = parcelRequire("fwbX5");

var $iwG2X = parcelRequire("iwG2X");

var $jAT0D = parcelRequire("jAT0D");
function $ae7b6125506491b3$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($fwbX5)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $iwG2X.default)((0, $jAT0D.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("iwG2X", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7cbd4ba80af9369$export$2e2bcd8739ae039);

var $aR9Qf = parcelRequire("aR9Qf");

var $dBimx = parcelRequire("dBimx");

var $gUUmE = parcelRequire("gUUmE");
var $d7cbd4ba80af9369$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $d7cbd4ba80af9369$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($d7cbd4ba80af9369$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $gUUmE.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $dBimx.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aR9Qf)))(dirtyDate, formatStr, options);
}

});
parcelRegister("dBimx", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e6cf97ea11d4595$export$2e2bcd8739ae039);

var $kbEJb = parcelRequire("kbEJb");

var $i6fIb = parcelRequire("i6fIb");
var $9e6cf97ea11d4595$var$MILLISECONDS_IN_MINUTE = 60000;
var $9e6cf97ea11d4595$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $9e6cf97ea11d4595$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $9e6cf97ea11d4595$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $9e6cf97ea11d4595$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $9e6cf97ea11d4595$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $9e6cf97ea11d4595$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $9e6cf97ea11d4595$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $9e6cf97ea11d4595$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $9e6cf97ea11d4595$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $9e6cf97ea11d4595$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $9e6cf97ea11d4595$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $9e6cf97ea11d4595$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $kbEJb.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $kbEJb.default)('long', date, options);
        }
    }
};
function $9e6cf97ea11d4595$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $i6fIb.default)(timeZone, originalDate, true) / $9e6cf97ea11d4595$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $9e6cf97ea11d4595$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $9e6cf97ea11d4595$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $9e6cf97ea11d4595$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $9e6cf97ea11d4595$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $9e6cf97ea11d4595$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $9e6cf97ea11d4595$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $9e6cf97ea11d4595$var$formatTimezone(offset, dirtyDelimeter);
}
function $9e6cf97ea11d4595$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $9e6cf97ea11d4595$var$addLeadingZeros(minutes, 2);
}
var $9e6cf97ea11d4595$export$2e2bcd8739ae039 = $9e6cf97ea11d4595$var$formatters;

});
parcelRegister("kbEJb", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb246d6cdcaaeca4$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $eb246d6cdcaaeca4$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $eb246d6cdcaaeca4$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $eb246d6cdcaaeca4$var$partsTimeZone(dtf, date) : $eb246d6cdcaaeca4$var$hackyTimeZone(dtf, date);
}
function $eb246d6cdcaaeca4$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $eb246d6cdcaaeca4$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $eb246d6cdcaaeca4$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("i6fIb", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2d4f98f2ab6c303$export$2e2bcd8739ae039);

var $hb3mZ = parcelRequire("hb3mZ");

var $e86X7 = parcelRequire("e86X7");
var $d2d4f98f2ab6c303$var$MILLISECONDS_IN_HOUR = 3600000;
var $d2d4f98f2ab6c303$var$MILLISECONDS_IN_MINUTE = 60000;
var $d2d4f98f2ab6c303$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $d2d4f98f2ab6c303$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $d2d4f98f2ab6c303$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $d2d4f98f2ab6c303$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$d2d4f98f2ab6c303$var$validateTimezone(hours)) return NaN;
        return -(hours * $d2d4f98f2ab6c303$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $d2d4f98f2ab6c303$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$d2d4f98f2ab6c303$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $d2d4f98f2ab6c303$var$MILLISECONDS_IN_HOUR + minutes * $d2d4f98f2ab6c303$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($d2d4f98f2ab6c303$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $d2d4f98f2ab6c303$var$toUtcDate(date);
        var offset = $d2d4f98f2ab6c303$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $d2d4f98f2ab6c303$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $d2d4f98f2ab6c303$var$toUtcDate(date) {
    return (0, $e86X7.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $d2d4f98f2ab6c303$var$calcOffset(date, timezoneString) {
    var tokens = (0, $hb3mZ.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $e86X7.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $d2d4f98f2ab6c303$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $d2d4f98f2ab6c303$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $d2d4f98f2ab6c303$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $d2d4f98f2ab6c303$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $d2d4f98f2ab6c303$var$validIANATimezoneCache = {};
function $d2d4f98f2ab6c303$var$isValidTimezoneIANAString(timeZoneString) {
    if ($d2d4f98f2ab6c303$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $d2d4f98f2ab6c303$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("hb3mZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c81613eb8d87ac5c$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $c81613eb8d87ac5c$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $c81613eb8d87ac5c$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $c81613eb8d87ac5c$var$partsOffset(dtf, date) : $c81613eb8d87ac5c$var$hackyOffset(dtf, date);
}
var $c81613eb8d87ac5c$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $c81613eb8d87ac5c$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $c81613eb8d87ac5c$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $c81613eb8d87ac5c$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $c81613eb8d87ac5c$var$dtfCache = {};
function $c81613eb8d87ac5c$var$getDateTimeFormat(timeZone) {
    if (!$c81613eb8d87ac5c$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $c81613eb8d87ac5c$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $c81613eb8d87ac5c$var$dtfCache[timeZone];
}

});

parcelRegister("e86X7", function(module, exports) {

$parcel$export(module.exports, "default", () => $a49734b25d97733d$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $a49734b25d97733d$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("gUUmE", function(module, exports) {

$parcel$export(module.exports, "default", () => $c50d991cbda2c596$export$2e2bcd8739ae039);

var $aSksP = parcelRequire("aSksP");

var $jGQTC = parcelRequire("jGQTC");

var $i6fIb = parcelRequire("i6fIb");

var $crHgC = parcelRequire("crHgC");
var $c50d991cbda2c596$var$MILLISECONDS_IN_HOUR = 3600000;
var $c50d991cbda2c596$var$MILLISECONDS_IN_MINUTE = 60000;
var $c50d991cbda2c596$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $c50d991cbda2c596$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $crHgC.default)
};
function $c50d991cbda2c596$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $c50d991cbda2c596$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($aSksP)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $c50d991cbda2c596$var$splitDateString(argument);
    var parseYearResult = $c50d991cbda2c596$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $c50d991cbda2c596$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $c50d991cbda2c596$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $i6fIb.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $c50d991cbda2c596$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $c50d991cbda2c596$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $c50d991cbda2c596$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $c50d991cbda2c596$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $c50d991cbda2c596$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $c50d991cbda2c596$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $c50d991cbda2c596$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $c50d991cbda2c596$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $c50d991cbda2c596$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $c50d991cbda2c596$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $c50d991cbda2c596$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$c50d991cbda2c596$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $c50d991cbda2c596$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$c50d991cbda2c596$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $c50d991cbda2c596$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$c50d991cbda2c596$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $c50d991cbda2c596$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$c50d991cbda2c596$var$validateWeekDate(year, week)) return new Date(NaN);
        return $c50d991cbda2c596$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $c50d991cbda2c596$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$c50d991cbda2c596$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $c50d991cbda2c596$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $c50d991cbda2c596$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $c50d991cbda2c596$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$c50d991cbda2c596$var$validateTime(hours)) return NaN;
        return hours % 24 * $c50d991cbda2c596$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $c50d991cbda2c596$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$c50d991cbda2c596$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $c50d991cbda2c596$var$MILLISECONDS_IN_HOUR + minutes * $c50d991cbda2c596$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $c50d991cbda2c596$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$c50d991cbda2c596$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $c50d991cbda2c596$var$MILLISECONDS_IN_HOUR + minutes * $c50d991cbda2c596$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $c50d991cbda2c596$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $c50d991cbda2c596$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $c50d991cbda2c596$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $c50d991cbda2c596$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $c50d991cbda2c596$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $c50d991cbda2c596$var$isLeapYearIndex(year);
        if (isLeapYear && date > $c50d991cbda2c596$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $c50d991cbda2c596$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $c50d991cbda2c596$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $c50d991cbda2c596$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $c50d991cbda2c596$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $c50d991cbda2c596$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("crHgC", function(module, exports) {

$parcel$export(module.exports, "default", () => $90f991911d90bed8$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $90f991911d90bed8$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $90f991911d90bed8$export$2e2bcd8739ae039 = $90f991911d90bed8$var$tzPattern;

});



parcelRegister("jAT0D", function(module, exports) {

$parcel$export(module.exports, "default", () => $e43c0cd241603813$export$2e2bcd8739ae039);

var $i6fIb = parcelRequire("i6fIb");

var $gUUmE = parcelRequire("gUUmE");
function $e43c0cd241603813$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $gUUmE.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $i6fIb.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});


parcelRegister("8PqA1", function(module, exports) {

$parcel$export(module.exports, "transformUserTimelineResponse", () => $8a23480b7911491d$export$78049913b79774a2);

var $hz3Fg = parcelRequire("hz3Fg");
const $8a23480b7911491d$export$78049913b79774a2 = ({ startTimeUtcMillis: startTimeUtcMillis, endTimeUtcMillis: endTimeUtcMillis, startOffsetMillis: startOffsetMillis, endOffsetMillis: endOffsetMillis, utcTimeOffsetMillis: utcTimeOffsetMillis, currentTime: currentTime, periods: periods, ...data })=>{
    return {
        startEpoch: startTimeUtcMillis,
        endEpoch: endTimeUtcMillis,
        nowEpoch: currentTime,
        startOffset: startOffsetMillis,
        endOffset: endOffsetMillis,
        nowOffset: utcTimeOffsetMillis,
        data: {
            ...data,
            periods: periods.map((0, $hz3Fg.fromMergedPeriodResponseToClusterPeriod))
        }
    };
};

});
parcelRegister("hz3Fg", function(module, exports) {

$parcel$export(module.exports, "fromMergedPeriodResponseToClusterPeriod", () => $0fe8fc9a353d2f1e$export$9b0bac75f135bd57);
const $0fe8fc9a353d2f1e$export$9b0bac75f135bd57 = (mergedPeriodResponse)=>{
    const { startTimeUtcMillis: startTimeUtcMillis, endTimeUtcMillis: endTimeUtcMillis, isTrueStartTime: isTrueStartTime, isTrueEndTime: isTrueEndTime, periodStartOffsetMillis: periodStartOffsetMillis, periodEndOffsetMillis: periodEndOffsetMillis, overlappingPeriods: overlappingPeriods } = mergedPeriodResponse;
    const clusterPeriod = {
        id: `${startTimeUtcMillis}-${endTimeUtcMillis}`,
        startEpoch: startTimeUtcMillis,
        endEpoch: endTimeUtcMillis,
        isTrueStartTime: isTrueStartTime,
        isTrueEndTime: isTrueEndTime,
        startOffset: periodStartOffsetMillis,
        endOffset: periodEndOffsetMillis,
        overlaps: overlappingPeriods.map($0fe8fc9a353d2f1e$var$fromOverlappingPeriodResponseToOverlappingPeriod)
    };
    return clusterPeriod;
};
const $0fe8fc9a353d2f1e$var$fromOverlappingPeriodResponseToOverlappingPeriod = (overlappingPeriodResponse)=>{
    const { startTimeUtcMillis: startTimeUtcMillis, endTimeUtcMillis: endTimeUtcMillis, periodStartOffsetMillis: periodStartOffsetMillis, periodEndOffsetMillis: periodEndOffsetMillis, overlappingRotations: overlappingRotations, isTrueStartTime: isTrueStartTime, isTrueEndTime: isTrueEndTime } = overlappingPeriodResponse;
    const overlappingPeriod = {
        id: `${startTimeUtcMillis}-${endTimeUtcMillis}`,
        startEpoch: startTimeUtcMillis,
        endEpoch: endTimeUtcMillis,
        startOffset: periodStartOffsetMillis,
        endOffset: periodEndOffsetMillis,
        overlaps: overlappingRotations,
        isTrueStartTime: isTrueStartTime,
        isTrueEndTime: isTrueEndTime
    };
    return overlappingPeriod;
};

});





parcelRegister("9Nrj8", function(module, exports) {

$parcel$export(module.exports, "whoIsOnCallRoute", () => $44bb0c0960b12c42$export$26b06efd7311586b);
const $44bb0c0960b12c42$export$26b06efd7311586b = {
    name: 'eoc-who-is-on-call',
    path: '/jira/ops/who-is-on-call',
    exact: true
};

});

parcelRegister("hAT18", function(module, exports) {

$parcel$export(module.exports, "LazyWhoIsOnCall", () => $31a5e09bb5444d16$export$7b03e7437c5d4f77);
$parcel$export(module.exports, "WhoIsOnCallComponent", () => $31a5e09bb5444d16$export$51430a0cf6ef3c09);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $31a5e09bb5444d16$export$7b03e7437c5d4f77 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("dR5Iv")), {
    moduleId: "./src/packages/eoc/who-is-on-call/src/ui/index.tsx"
});
const $31a5e09bb5444d16$export$51430a0cf6ef3c09 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $31a5e09bb5444d16$export$7b03e7437c5d4f77,
        pageId: "async-jira-eoc-who-is-on-call",
        shouldShowSpinner: false
    });

});
parcelRegister("dR5Iv", function(module, exports) {

let $a164a8d892af66a7$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a164a8d892af66a7$var$load("ffQaD"),
    $a164a8d892af66a7$var$load("kvRbA"),
    $a164a8d892af66a7$var$load("5fUB7")
]).then(()=>parcelRequire('eV5T9'));

});



parcelRegister("01Za6", function(module, exports) {

$parcel$export(module.exports, "errorsNotFoundRouteEntry", () => $083d2dc437d8c2ec$export$c4c012a49b465e94);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $5lsNZ = parcelRequire("5lsNZ");

var $7gROc = parcelRequire("7gROc");
const $083d2dc437d8c2ec$export$c4c012a49b465e94 = (0, $7NszV.createEntry)((0, $7gROc.errorsNotFoundRoute), ()=>({
        group: 'errors',
        component: (0, $5lsNZ.default),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5lsNZ.LazyNotFoundErrorPage)
        ]
    }));

});
parcelRegister("7gROc", function(module, exports) {

$parcel$export(module.exports, "errorsNotFoundRoute", () => $24256311e2794309$export$465fa01c0f3a0551);
const $24256311e2794309$export$465fa01c0f3a0551 = {
    name: 'errors-not-found',
    path: '/jira/:projectType(software|servicedesk|core)'
};

});


parcelRegister("5fBQK", function(module, exports) {

$parcel$export(module.exports, "forgeAdminRouteEntry", () => $3cf9bea8e2a94905$export$9e57f00c65d37e11);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $iHiHz = parcelRequire("iHiHz");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $4PkbN = parcelRequire("4PkbN");

var $hIGzE = parcelRequire("hIGzE");
const $3cf9bea8e2a94905$export$9e57f00c65d37e11 = (0, $7NszV.createEntry)((0, $4PkbN.forgeAdminRoute), ()=>({
        component: (0, $hIGzE.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $iHiHz.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $5bkvv.getNavigationSidebarGlobalSettingsResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hIGzE.LazyForgeAdminPage)
        ]
    }));

});
parcelRegister("4PkbN", function(module, exports) {

$parcel$export(module.exports, "forgeAdminRoute", () => $cc2d93b85ec603e1$export$157f97e6454c2a9f);
const $cc2d93b85ec603e1$export$157f97e6454c2a9f = {
    name: 'forge-spa-admin',
    path: '/jira/settings/apps/:appId/:envId/:route?'
};

});

parcelRegister("hIGzE", function(module, exports) {

$parcel$export(module.exports, "LazyForgeAdminPage", () => $bef31a55bb1643fb$export$66ee65dcd4a6458d);
$parcel$export(module.exports, "default", () => $bef31a55bb1643fb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $bef31a55bb1643fb$export$66ee65dcd4a6458d = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("2xK19")), {
    moduleId: "./src/packages/spa-apps/forge/admin/src/index.tsx"
});
const $bef31a55bb1643fb$export$c9e5f500ef472147 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $bef31a55bb1643fb$export$66ee65dcd4a6458d,
        pageId: "forge-spa-admin",
        shouldShowSpinner: true
    });
var $bef31a55bb1643fb$export$2e2bcd8739ae039 = $bef31a55bb1643fb$export$c9e5f500ef472147;

});
parcelRegister("2xK19", function(module, exports) {

let $1da25bf3641c2f21$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1da25bf3641c2f21$var$load("aONsY").then(()=>parcelRequire('bqE5a'));

});



parcelRegister("hxYI0", function(module, exports) {

$parcel$export(module.exports, "forgeAdminSettingsRouteEntry", () => $10e343bd77fe2c43$export$ea8439aa1b4afbb2);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $iHiHz = parcelRequire("iHiHz");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $7OevD = parcelRequire("7OevD");

var $hIGzE = parcelRequire("hIGzE");
const $10e343bd77fe2c43$export$ea8439aa1b4afbb2 = (0, $7NszV.createEntry)((0, $7OevD.forgeAdminSettingsRoute), ()=>({
        component: (0, $hIGzE.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $iHiHz.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $5bkvv.getNavigationSidebarGlobalSettingsResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hIGzE.LazyForgeAdminPage)
        ]
    }));

});
parcelRegister("7OevD", function(module, exports) {

$parcel$export(module.exports, "forgeAdminSettingsRoute", () => $48618cc01d3d4f81$export$392534a80a0b9b11);
const $48618cc01d3d4f81$export$392534a80a0b9b11 = {
    name: 'forge-spa-admin-settings',
    path: '/jira/settings/apps/:settingsType(configure|get-started)/:appId/:envId/:route?'
};

});


parcelRegister("dzSy7", function(module, exports) {

$parcel$export(module.exports, "forgeFieldContextualConfigurationRouteEntry", () => $f15b9bbe688647f5$export$425186ecf36e93c);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $2YqLE = parcelRequire("2YqLE");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $92r5p = parcelRequire("92r5p");

var $6bHdH = parcelRequire("6bHdH");
const $f15b9bbe688647f5$export$425186ecf36e93c = (0, $7NszV.createEntry)((0, $92r5p.forgeFieldContextualConfigurationRoute), ()=>({
        component: (0, $6bHdH.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $5bkvv.forgeCustomFieldTypeResource),
            (0, $2YqLE.fieldContextConfigPageResource),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6bHdH.LazyForgeFieldContextConfigPage)
        ]
    }));

});
parcelRegister("2YqLE", function(module, exports) {

$parcel$export(module.exports, "fieldContextConfigPageResource", () => $2520f99c62492240$export$686a607053a18611);

var $2M1hQ = parcelRequire("2M1hQ");


const $2520f99c62492240$export$686a607053a18611 = (0, $2M1hQ.createResource)({
    type: (0, $714c31c1c770eaf3$export$4b80522d38222ad),
    getKey: ()=>'data',
    getDataLoader: ()=>(parcelRequire("8wzdC")),
    maxAge: 5000
});

});
const $714c31c1c770eaf3$export$4b80522d38222ad = 'FORGE_FIELD_CONTEXTUAL_CONFIG';

parcelRegister("8wzdC", function(module, exports) {

let $634ca19688bf6fd4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $634ca19688bf6fd4$var$load("ay5JG").then(()=>parcelRequire('ei6Pl'));

});


parcelRegister("92r5p", function(module, exports) {

$parcel$export(module.exports, "forgeFieldContextualConfigurationRoute", () => $5ea48a875d63d03b$export$2ee4468dd8e9636f);
const $5ea48a875d63d03b$export$2ee4468dd8e9636f = {
    name: 'forge-spa-field-context-config',
    path: '/jira/settings/issues/field/:fieldId/context/:contextId/configure/app'
};

});

parcelRegister("6bHdH", function(module, exports) {

$parcel$export(module.exports, "LazyForgeFieldContextConfigPage", () => $b96b1546635e7c38$export$c53e206c7fd6fb76);
$parcel$export(module.exports, "default", () => $b96b1546635e7c38$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $b96b1546635e7c38$export$c53e206c7fd6fb76 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("8tCqq")), {
    moduleId: "./src/packages/spa-apps/forge/field-contextual-config/src/index.tsx"
});
const $b96b1546635e7c38$export$50bd0baee0b2f946 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $b96b1546635e7c38$export$c53e206c7fd6fb76,
        pageId: "forge-spa-field-context-config",
        shouldShowSpinner: true
    });
var $b96b1546635e7c38$export$2e2bcd8739ae039 = $b96b1546635e7c38$export$50bd0baee0b2f946;

});
parcelRegister("8tCqq", function(module, exports) {

let $62bed69cd7704a2b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $62bed69cd7704a2b$var$load("ifDe8").then(()=>parcelRequire('jBnrF'));

});



parcelRegister("eKguf", function(module, exports) {

$parcel$export(module.exports, "forgeGlobalRouteEntry", () => $7633f07341519228$export$68b00eede5bc25e6);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $iFaFr = parcelRequire("iFaFr");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $3RJkv = parcelRequire("3RJkv");

var $ic1pa = parcelRequire("ic1pa");

var $aRZh7 = parcelRequire("aRZh7");
const $7633f07341519228$export$68b00eede5bc25e6 = (0, $7NszV.createEntry)((0, $ic1pa.forgeGlobalRoute), ()=>({
        component: (0, $aRZh7.default),
        layout: (0, $aPfsS.createLayout)(),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).ADDONS,
            sidebar: (0, $iFaFr.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $5bkvv.getNavigationForgeGlobalPageResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aRZh7.LazyForgeGlobalPage)
        ]
    }));

});
parcelRegister("ic1pa", function(module, exports) {

$parcel$export(module.exports, "forgeGlobalRoute", () => $7d160aadc36293c5$export$4146dba061d1c72d);
const $7d160aadc36293c5$export$4146dba061d1c72d = {
    name: 'forge-spa-global',
    path: '/jira/apps/:appId/:envId/:route?'
};

});

parcelRegister("aRZh7", function(module, exports) {

$parcel$export(module.exports, "LazyForgeGlobalPage", () => $8f6029962fb4c5dc$export$332293feb5cffd72);
$parcel$export(module.exports, "default", () => $8f6029962fb4c5dc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $8f6029962fb4c5dc$export$332293feb5cffd72 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("7CuZc")), {
    moduleId: "./src/packages/spa-apps/forge/global/src/index.tsx"
});
const $8f6029962fb4c5dc$export$4c36a7b018e5e5cc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8f6029962fb4c5dc$export$332293feb5cffd72,
        pageId: "forge-spa-global",
        shouldShowSpinner: true
    });
var $8f6029962fb4c5dc$export$2e2bcd8739ae039 = $8f6029962fb4c5dc$export$4c36a7b018e5e5cc;

});
parcelRegister("7CuZc", function(module, exports) {

let $58c41e3992c24ee6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $58c41e3992c24ee6$var$load("8BF7S").then(()=>parcelRequire('eZUti'));

});



parcelRegister("7vXQn", function(module, exports) {

$parcel$export(module.exports, "forgePersonalSettingsRouteEntry", () => $20637ca5596c888a$export$bcf4a0e471a2493d);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $cRWZh = parcelRequire("cRWZh");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $jApsb = parcelRequire("jApsb");

var $jaNrZ = parcelRequire("jaNrZ");
const $20637ca5596c888a$export$bcf4a0e471a2493d = (0, $7NszV.createEntry)((0, $jApsb.forgePersonalSettingsRoute), ()=>({
        component: (0, $jaNrZ.default),
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PERSONAL_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PROFILE,
            sidebar: (0, $cRWZh.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $5bkvv.getNavigationForgePersonalSettingsPageResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jaNrZ.LazyForgePersonalSettingsPage)
        ]
    }));

});
parcelRegister("cRWZh", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fc6117fdc2ce1b9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

const $8fc6117fdc2ce1b9$var$LazyPersonalSettingsSidebar = (0, $kxZPA.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("kHYph")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/personal-settings/src/index.tsx"
});
const $8fc6117fdc2ce1b9$var$PersonalSettingsSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "personalSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8fc6117fdc2ce1b9$var$LazyPersonalSettingsSidebar, null));
var $8fc6117fdc2ce1b9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($8fc6117fdc2ce1b9$var$PersonalSettingsSidebar);

});
parcelRegister("kHYph", function(module, exports) {

let $f136ae4b96463a36$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f136ae4b96463a36$var$load("i4r9Y").then(()=>parcelRequire('6re9h'));

});


parcelRegister("jApsb", function(module, exports) {

$parcel$export(module.exports, "forgePersonalSettingsRoute", () => $911d3aa14cf2fd85$export$8cf022892f01dc88);
const $911d3aa14cf2fd85$export$8cf022892f01dc88 = {
    name: 'forge-spa-personal-settings',
    path: '/jira/settings/personal/apps/:appId/:envId/:route?'
};

});

parcelRegister("jaNrZ", function(module, exports) {

$parcel$export(module.exports, "LazyForgePersonalSettingsPage", () => $407ba70330fa3fc8$export$984c6340ff981792);
$parcel$export(module.exports, "default", () => $407ba70330fa3fc8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $407ba70330fa3fc8$export$984c6340ff981792 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("dljoE")), {
    moduleId: "./src/packages/spa-apps/forge/personal-settings/src/index.tsx"
});
const $407ba70330fa3fc8$export$fb659fde7fa91075 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $407ba70330fa3fc8$export$984c6340ff981792,
        pageId: "forge-spa-personal-settings",
        shouldShowSpinner: true
    });
var $407ba70330fa3fc8$export$2e2bcd8739ae039 = $407ba70330fa3fc8$export$fb659fde7fa91075;

});
parcelRegister("dljoE", function(module, exports) {

let $9b6c484a70c5bb12$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9b6c484a70c5bb12$var$load("rlx05").then(()=>parcelRequire('arSLF'));

});



parcelRegister("kCn5T", function(module, exports) {

$parcel$export(module.exports, "forgeProjectRouteEntry", () => $284a2dce5bdef34f$export$1ed77617605af86d);

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $7GnDe = parcelRequire("7GnDe");

var $lgVu5 = parcelRequire("lgVu5");

var $ioJTL = parcelRequire("ioJTL");
const $284a2dce5bdef34f$export$1ed77617605af86d = (0, $7NszV.createEntry)((0, $lgVu5.forgeProjectRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            ...(0, $fpjJX.getServiceDeskSharedNavigationSingleResources)(),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $dxCvy.projectContextResourceWithCache),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>(0, $ioJTL.forgeProjectPageEntrypoint)
    }));

});
parcelRegister("lgVu5", function(module, exports) {

$parcel$export(module.exports, "forgeProjectRoute", () => $d3c18f0b3608cdac$export$998d01fc8f4c3224);
const $d3c18f0b3608cdac$export$998d01fc8f4c3224 = {
    name: 'forge-spa-project',
    path: '/jira/:projectType(software|software/c|core)/projects/:projectKey/apps/:appId/:envId/:route?'
};

});

parcelRegister("ioJTL", function(module, exports) {

$parcel$export(module.exports, "forgeProjectPageEntrypoint", () => $495262f31d81d9db$export$74e6ff15060a7efe);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $jVVdt = parcelRequire("jVVdt");

var $fo6b8 = parcelRequire("fo6b8");
const $495262f31d81d9db$export$74e6ff15060a7efe = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $jVVdt.forgeProjectEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("jVVdt", function(module, exports) {

$parcel$export(module.exports, "forgeProjectEntrypoint", () => $8e3be2a67cce3f64$export$109bb60f5ed960e9);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $8e3be2a67cce3f64$export$109bb60f5ed960e9 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("eNWYY")), {
        moduleId: "a42399f5"
    }),
    getPreloadProps: ({ context: context })=>({
            extraProps: {
                match: context.match
            }
        })
});

});
parcelRegister("eNWYY", function(module, exports) {

let $ac7364f8ec17c62b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ac7364f8ec17c62b$var$load("i5Vmg").then(()=>parcelRequire('kGkpN'));

});




parcelRegister("WsHyA", function(module, exports) {

$parcel$export(module.exports, "communicationsStakeholdersRouteEntry", () => $0c26f5691a26ccb6$export$c12bfa7616ac8400);

var $7NszV = parcelRequire("7NszV");

var $b1A6d = parcelRequire("b1A6d");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $3RJkv = parcelRequire("3RJkv");

var $9Cm8h = parcelRequire("9Cm8h");
const $0c26f5691a26ccb6$export$c12bfa7616ac8400 = (0, $7NszV.createEntry)((0, $b1A6d.communicationsStakeholdersRoute), ()=>({
        group: 'communications',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).COMMUNICATIONS,
            sidebar: (0, $h0bZU.default)
        },
        entryPoint: ()=>{
            return (0, $4R6GH.fg)('communications_stakeholder_management_platform') ? (0, $9Cm8h.stakeholdersPageEntrypoint) : undefined;
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ]
    }));

});
parcelRegister("b1A6d", function(module, exports) {

$parcel$export(module.exports, "communicationsStakeholdersRoute", () => $11c611984f2cf923$export$9933513623f14d7f);
const $11c611984f2cf923$export$9933513623f14d7f = {
    name: 'communications-stakeholders',
    path: '/jira/communications/stakeholders'
};

});

parcelRegister("9Cm8h", function(module, exports) {

$parcel$export(module.exports, "stakeholdersPageEntrypoint", () => $90fde8fc5b5b7285$export$24a5b3c3e5dd381e);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $b7Mlo = parcelRequire("b7Mlo");

var $1FKpj = parcelRequire("1FKpj");
const $90fde8fc5b5b7285$export$24a5b3c3e5dd381e = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1FKpj.communicationsStakeholdersEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).COMMUNICATIONS,
    horizontalNavigation: (0, $b7Mlo.communicationsHorizontalNavEntrypoint)
});

});
parcelRegister("b7Mlo", function(module, exports) {

$parcel$export(module.exports, "communicationsHorizontalNavEntrypoint", () => $958a24865685d839$export$6862ea61ceda83f3);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $958a24865685d839$export$6862ea61ceda83f3 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("fMQLh")).then((module)=>module.HorizontalCommunicationsNav), {
        moduleId: "a456392a",
        moduleName: "HorizontalCommunicationsNav"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("fMQLh", function(module, exports) {

let $b7e44411498c3d60$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b7e44411498c3d60$var$load("jGfUS").then(()=>parcelRequire('hGhnx'));

});


parcelRegister("1FKpj", function(module, exports) {

$parcel$export(module.exports, "communicationsStakeholdersEntrypoint", () => $12f1ec05d448ac20$export$2be0008a269b55af);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $aOzLh = parcelRequire("aOzLh");

const $12f1ec05d448ac20$export$2be0008a269b55af = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(0, $aOzLh.clientSideOnly)((parcelRequire("iSYTf")).then((module)=>module.StakeholdersPage)), {
        moduleId: "52ac92a7",
        moduleName: "StakeholdersPage"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("aOzLh", function(module, exports) {

$parcel$export(module.exports, "clientSideOnly", () => $eb01c57105fa1f36$export$7fda87e5e6d5a8d1);
const $eb01c57105fa1f36$export$7fda87e5e6d5a8d1 = (x)=>x;

});

parcelRegister("iSYTf", function(module, exports) {

let $dbfc80a8f86aa076$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dbfc80a8f86aa076$var$load("65tRw").then(()=>parcelRequire('dqLEV'));

});




parcelRegister("3GuHG", function(module, exports) {

$parcel$export(module.exports, "communicationsStakeholderGroupsRouteEntry", () => $dbb187174829db9f$export$f0dd910016653be3);

var $7NszV = parcelRequire("7NszV");

var $5U3St = parcelRequire("5U3St");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $3RJkv = parcelRequire("3RJkv");

var $i831U = parcelRequire("i831U");
const $dbb187174829db9f$export$f0dd910016653be3 = (0, $7NszV.createEntry)((0, $5U3St.communicationsStakeholderGroupsRoute), ()=>({
        group: 'communications',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).COMMUNICATIONS,
            sidebar: (0, $h0bZU.default)
        },
        entryPoint: ()=>{
            return (0, $4R6GH.fg)('communications_stakeholder_management_platform') ? (0, $i831U.stakeholderGroupsPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ]
    }));

});
parcelRegister("5U3St", function(module, exports) {

$parcel$export(module.exports, "communicationsStakeholderGroupsRoute", () => $4d0bd8ab67b79e5f$export$87043fcbf23f0119);
const $4d0bd8ab67b79e5f$export$87043fcbf23f0119 = {
    name: 'communications-stakeholder-groups',
    path: '/jira/communications/stakeholder-groups'
};

});

parcelRegister("i831U", function(module, exports) {

$parcel$export(module.exports, "stakeholderGroupsPageEntryPoint", () => $2935279ec52ff1e0$export$838bd3c623ceac0);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $b7Mlo = parcelRequire("b7Mlo");

var $dvt8F = parcelRequire("dvt8F");
const $2935279ec52ff1e0$export$838bd3c623ceac0 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $dvt8F.communicationsStakeholderGroupsEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).COMMUNICATIONS,
    horizontalNavigation: (0, $b7Mlo.communicationsHorizontalNavEntrypoint)
});

});
parcelRegister("dvt8F", function(module, exports) {

$parcel$export(module.exports, "communicationsStakeholderGroupsEntrypoint", () => $7b64302e0313e9f1$export$df18143715531ee1);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $7b64302e0313e9f1$export$df18143715531ee1 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("9EVc7")).then((module)=>module.StakeholderGroupsPage), {
        moduleId: "90ba51b1",
        moduleName: "StakeholderGroupsPage"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9EVc7", function(module, exports) {

let $70843720d7dec518$var$load = (parcelRequire("28QjX"))(4);
module.exports = $70843720d7dec518$var$load("6GplY").then(()=>parcelRequire('9J6zQ'));

});




parcelRegister("90Rrp", function(module, exports) {

$parcel$export(module.exports, "forgeProjectServicedeskRouteEntry", () => $4f02896c605dcb0b$export$6732bea56e68d0b4);

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $7GnDe = parcelRequire("7GnDe");

var $8RflP = parcelRequire("8RflP");

var $7IrJ6 = parcelRequire("7IrJ6");
const $4f02896c605dcb0b$export$6732bea56e68d0b4 = (0, $7NszV.createEntry)((0, $8RflP.forgeProjectServicedeskRoute), ()=>({
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSharedNavigationSingleResources)(),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $dxCvy.projectContextResourceWithCache),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>(0, $7IrJ6.forgeProjectServicedeskPageEntrypoint)
    }));

});
parcelRegister("8RflP", function(module, exports) {

$parcel$export(module.exports, "forgeProjectServicedeskRoute", () => $e62a10d9c09b490c$export$8b83928f9f21e11);
const $e62a10d9c09b490c$export$8b83928f9f21e11 = {
    name: 'forge-spa-project-servicedesk',
    path: '/jira/:projectType(servicedesk)/projects/:projectKey/apps/:appId/:envId/:route?'
};

});

parcelRegister("7IrJ6", function(module, exports) {

$parcel$export(module.exports, "forgeProjectServicedeskPageEntrypoint", () => $c277f8b7f3958697$export$eae71fd9c3e0166a);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $jVVdt = parcelRequire("jVVdt");
const $c277f8b7f3958697$export$eae71fd9c3e0166a = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $jVVdt.forgeProjectEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});


parcelRegister("86qmt", function(module, exports) {

$parcel$export(module.exports, "forgeServicedeskQueueRouteEntry", () => $03b194d7d6d82e68$export$1486fc4f85c1237);

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $levwO = parcelRequire("levwO");

var $6Z2mh = parcelRequire("6Z2mh");

var $9mZwV = parcelRequire("9mZwV");
const $03b194d7d6d82e68$export$1486fc4f85c1237 = (0, $7NszV.createEntry)((0, $levwO.forgeServicedeskQueueRoute), ()=>({
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>(0, $9mZwV.forgeServiceDeskQueuePageEntrypoint)
    }));

});
parcelRegister("levwO", function(module, exports) {

$parcel$export(module.exports, "forgeServicedeskQueueRoute", () => $019035708a3fcd5d$export$b77275b989ab42a6);
const $019035708a3fcd5d$export$b77275b989ab42a6 = {
    name: 'forge-spa-servicedesk-queue',
    path: '/jira/servicedesk/projects/:projectKey/queues/apps/:appId/:envId/:route?'
};

});

parcelRegister("9mZwV", function(module, exports) {

$parcel$export(module.exports, "forgeServiceDeskQueuePageEntrypoint", () => $ebb310d709581894$export$e50db2ee9d53508e);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $5buAb = parcelRequire("5buAb");
const $ebb310d709581894$export$e50db2ee9d53508e = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $5buAb.forgeServiceDeskEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("5buAb", function(module, exports) {

$parcel$export(module.exports, "forgeServiceDeskEntrypoint", () => $599bf9ac9bda7f22$export$5f56161124a4cb21);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $599bf9ac9bda7f22$export$5f56161124a4cb21 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("hy8ml")), {
        moduleId: "70dc4c33"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("hy8ml", function(module, exports) {

let $cc6c18a358d94fa6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cc6c18a358d94fa6$var$load("g5aO0").then(()=>parcelRequire('6Ue2s'));

});




parcelRegister("hxK6L", function(module, exports) {

$parcel$export(module.exports, "globalMailSettingsRouteEntry", () => $fc43fd37745c00e2$export$5e1236665a530df4);

var $ffza4 = parcelRequire("ffza4");

var $bwLf9 = parcelRequire("bwLf9");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $bzD24 = parcelRequire("bzD24");

var $euIkX = parcelRequire("euIkX");

var $21A4f = parcelRequire("21A4f");
const $fc43fd37745c00e2$export$5e1236665a530df4 = (0, $7NszV.createEntry)((0, $bzD24.globalMailSettingsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.global-mail-settings',
        component: (0, $bwLf9.default)(()=>true, (0, $21A4f.default), (0, $euIkX.default)),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $21A4f.LazyGlobalMailSettings)
        ]
    }));

});
parcelRegister("bwLf9", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7ec252b6b084884$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
var /**
 * @deprecated this does not support useRef and is being moved into a new package.
 * Use @atlassian/jira-feature-flagging-utils and componentWithCondition instead.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$a7ec252b6b084884$export$2e2bcd8739ae039 = (conditionGetter, ComponentTrue, ComponentFalse)=>{
    const ComponentWithCondition = (props)=>// @ts-expect-error - TS2322 - Type 'P' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<P> & RefAttributes<any> & { children?: ReactNode; }'. | TS2322 - Type 'P' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<P> & RefAttributes<any> & { children?: ReactNode; }'.
        conditionGetter() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ComponentTrue, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ComponentFalse, props);
    if (conditionGetter.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${conditionGetter.name}]`;
    // @ts-expect-error - TS2322 - Type '{ (props: P): JSX.Element; displayName: string; }' is not assignable to type 'AbstractComponent<P, any>'.
    return ComponentWithCondition;
};

});

parcelRegister("bzD24", function(module, exports) {

$parcel$export(module.exports, "globalMailSettingsRoute", () => $b88e0402aff618ba$export$e69b84daf70501b3);
const $b88e0402aff618ba$export$e69b84daf70501b3 = {
    name: 'global-mail-settings',
    path: '/secure/admin/global-mail-settings',
    exact: true
};

});

parcelRegister("euIkX", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a0afe23818eb6ed$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3mK2k = parcelRequire("3mK2k");
var /** This exists to be used as a route since the redirect as a route and redirect as a component
 * have different props, and flow complains. */ // @ts-expect-error - Type '{}' is missing the following properties from type 'Pick<Omit<Omit<RouteContext & { flagService: FlagService; createAnalyticsEvent: (arg1: { action: string; }) => UIAnalyticsEvent; }, keyof WithAnalyticsEventsProps> & RefAttributes<...>, "flagService">, keyof RouteContext | keyof RefAttributes<...>>': location, query, route, match, action
// eslint-disable-next-line jira/import/no-anonymous-default-export
$1a0afe23818eb6ed$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3mK2k.default), null);

});
parcelRegister("3mK2k", function(module, exports) {

$parcel$export(module.exports, "default", () => $1513009dd97e8af4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $cb25w = parcelRequire("cb25w");

var $dMnMc = parcelRequire("dMnMc");

var $2YZCu = parcelRequire("2YZCu");

var $34Vv8 = parcelRequire("34Vv8");

var $j8DrX = parcelRequire("j8DrX");

var $8zOmE = parcelRequire("8zOmE");

var $1bQGJ = parcelRequire("1bQGJ");

var $eNf8a = parcelRequire("eNf8a");

var $4R6GH = parcelRequire("4R6GH");

var $883db = parcelRequire("883db");
const $1513009dd97e8af4$var$THRESHOLD = 30000;
const $1513009dd97e8af4$var$getScopeType = (scope)=>{
    switch(scope.identifierType){
        case 'boardId':
            return 'board';
        case 'projectId':
        case 'projectKey':
            return scope.pageType === 'settings' ? 'projectSettings' : 'project';
        default:
            return '';
    }
};
const $1513009dd97e8af4$var$sessionStorageProvider = (0, $eNf8a.createSessionStorageProvider)('', false);
class $1513009dd97e8af4$export$836fe1ef2cfde075 extends (0, $5uXOq.Component) {
    componentDidMount() {
        // eslint-disable-next-line jira/react-magnetic-di/no-unneeded
        (0, $gKZoD.di)(sessionStorage, $1513009dd97e8af4$var$sessionStorageProvider, window);
        const { location: { pathname: pathname, search: search }, flagService: flagService, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        const redirectPathname = pathname.startsWith('//') ? pathname.substr(1) : pathname;
        const lastRedirectTime = (0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? Number($1513009dd97e8af4$var$sessionStorageProvider.get(redirectPathname)) : Number(sessionStorage.getItem(redirectPathname));
        if (!lastRedirectTime) (0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $1513009dd97e8af4$var$sessionStorageProvider.set(redirectPathname, Date.now().toString()) : sessionStorage.setItem(redirectPathname, Date.now().toString());
        else if (Date.now() - lastRedirectTime < $1513009dd97e8af4$var$THRESHOLD) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const scopeData = (0, $dMnMc.default)(window.location.href, (0, $j8DrX.default));
            const scope = $1513009dd97e8af4$var$getScopeType(scopeData);
            (0, $2YZCu.default).safeErrorWithoutCustomerData('redirect-loop.error', 'Redirect error caused by invalid url', {
                scope: scope
            });
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
                action: 'entered'
            }), 'redirect-loop entered', 'endeavour.spa.redirect-loop', {
                scope: scope
            });
            flagService.showFlag((0, $883db.errorFlag)());
            (0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $1513009dd97e8af4$var$sessionStorageProvider.remove(redirectPathname) : sessionStorage.removeItem(redirectPathname);
            return;
        } else (0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $1513009dd97e8af4$var$sessionStorageProvider.remove(redirectPathname) : sessionStorage.removeItem(redirectPathname);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.assign(redirectPathname + search);
    }
    render() {
        return null;
    }
}
var // @ts-expect-error - TS2345 - Argument of type 'ForwardRefExoticComponent<Pick<WithAnalyticsEventsProps, never> & RefAttributes<any>>' is not assignable to parameter of type 'ComponentType<{ flagService: FlagService; }>'. | TS2345 - Argument of type 'typeof RedirectToLegacyRouting' is not assignable to parameter of type '(((props: WithAnalyticsEventsProps) => ReactElement<any, string | ((props: any) => ReactElement<any, any> | null) | (new (props: any) => Component<any, any, any>)> | null) & typeof RedirectToLegacyRouting) | ((new (props: WithAnalyticsEventsProps) => Component<...>) & typeof RedirectToLegacyRouting)'.
$1513009dd97e8af4$export$2e2bcd8739ae039 = (0, $1bQGJ.withRouter)((0, $34Vv8.default)((0, $cb25w.default)()($1513009dd97e8af4$export$836fe1ef2cfde075)));

});
parcelRegister("dMnMc", function(module, exports) {

$parcel$export(module.exports, "getBoardId", () => $fe24052863a91d57$export$557c2f222778cea6);
$parcel$export(module.exports, "default", () => $fe24052863a91d57$export$2e2bcd8739ae039);

var $aZsz6 = parcelRequire("aZsz6");

var $95bh0 = parcelRequire("95bh0");

var $556I0 = parcelRequire("556I0");

var $5PyNy = parcelRequire("5PyNy");

var $79s9E = parcelRequire("79s9E");
const $fe24052863a91d57$var$projectScopeDataMap = {
    routes: [
        // Query string
        /[&?]projectKey=(\w+)/i,
        // Service desk, business and some software
        /\/projects\/(\w+)/i,
        // Issue page (not root)
        /\/browse\/(\w+)-\d+\??((?!(filter=|jql=)).)*$/i,
        // Project settings
        /\/plugins\/servlet\/project-config\/(\w+)/i,
        // Service Desk project settings
        /\/servicedesk\/admin\/(\w+)/i,
        // Browse project
        /\/browse\/(\w+)\/?(\?.*)?$/i
    ],
    meta: [
        // Software
        'ghx-project-key',
        // Settings
        'projectKey',
        // Reports
        'ajs-project-key'
    ]
};
const $fe24052863a91d57$var$getProjectId = (url)=>{
    const projectIdRoutes = [
        // Query string - reports
        /[&?]selectedProjectId=(\w+)/i,
        // Query string - edit project, delete project
        /[&?]pid=(\w+)/i,
        // Query string - release notes
        /[&?]projectId=(\w+)/i,
        // Query string - connect items
        /[&?]project\.id=(\w+)/i
    ];
    return projectIdRoutes.reduce((foundId, route)=>{
        if (foundId) return foundId;
        const match = url.match(route);
        if (match != null) {
            const [, projectId] = match;
            if (projectId) return projectId;
        }
        return null;
    }, null);
};
/**
 * Extracts certain data out of the URL that is required by other data providers.
 */ const $fe24052863a91d57$var$getProjectKey = (url, getMeta)=>{
    let projectKey = null;
    $fe24052863a91d57$var$projectScopeDataMap.meta.forEach((tagName)=>{
        const value = getMeta(tagName);
        if (value && projectKey == null) projectKey = value;
    });
    $fe24052863a91d57$var$projectScopeDataMap.routes.forEach((route)=>{
        const match = url.match(route);
        if (match != null && projectKey == null) [, projectKey] = match;
    });
    return projectKey || undefined;
};
const $fe24052863a91d57$export$557c2f222778cea6 = (url)=>{
    try {
        const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(url, true);
        let boardId = parsed.query ? parsed.query.rapidView : null;
        if (boardId == null) {
            const match = url.match(/\/boards\/(\d+)/i);
            boardId = match ? match[1] : null;
        }
        return boardId;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        return null;
    }
};
const $fe24052863a91d57$var$isProjectSettingsConnectRoute = ({ getMeta: getMeta, url: url })=>getMeta('ajs-in-admin-mode') === 'true' && (0, $556I0.default).some((regex)=>regex.test(url)) || (0, $5PyNy.default).some((regex)=>regex.test(url));
const $fe24052863a91d57$var$isProjectPage = ({ getMeta: getMeta, projectId: projectId, projectKey: projectKey, url: url })=>{
    // Project routes that have a project id in the URL
    const isProject = ()=>{
        const routes = [
            /\/secure\/ConfigureReport(!default)?\.jspa.+selectedProjectId/i,
            /\/secure\/project\/(DeleteProject|EditProject)!default\.jspa.+pid/i,
            /\/secure\/ReleaseNote.jspa.+projectId/i,
            /\/secure\/ConfigureReleaseNote.jspa.+projectId/i
        ];
        return $fe24052863a91d57$var$isProjectSettingsConnectRoute({
            getMeta: getMeta,
            url: url
        }) || routes.some((regex)=>regex.test(url));
    };
    return projectKey || projectId && isProject();
};
const $fe24052863a91d57$var$isProjectSettingsPage = ({ getMeta: getMeta, url: url })=>(0, $79s9E.default).some((route)=>url.match(route)) || $fe24052863a91d57$var$isProjectSettingsConnectRoute({
        getMeta: getMeta,
        url: url
    });
const $fe24052863a91d57$var$getProjectPageType = (getMeta, url)=>{
    if ($fe24052863a91d57$var$isProjectSettingsPage({
        getMeta: getMeta,
        url: url
    })) return 'settings';
    const decorator = getMeta('decorator');
    const isSettings = getMeta('is-settings-page') === 'true';
    return decorator === 'admin' || decorator === 'atl.admin' || isSettings ? 'settings' : undefined;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fe24052863a91d57$export$2e2bcd8739ae039 = (url, getMeta)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const extractedData = {};
    const boardId = $fe24052863a91d57$export$557c2f222778cea6(url);
    if (boardId) extractedData.boardId = boardId;
    const projectKey = url.includes('/plugins/servlet/ac/') || url.includes('/settings/projects/') ? undefined : $fe24052863a91d57$var$getProjectKey(url, getMeta);
    if (projectKey) extractedData.projectKey = projectKey;
    const projectId = $fe24052863a91d57$var$getProjectId(url);
    if (projectId) extractedData.projectId = projectId;
    const isProject = $fe24052863a91d57$var$isProjectPage({
        getMeta: getMeta,
        projectId: projectId,
        projectKey: projectKey,
        url: url
    });
    extractedData.pageType = isProject ? $fe24052863a91d57$var$getProjectPageType(getMeta, url) : undefined;
    const identifier = (0, $95bh0.getScopeIdentifier)({
        boardId: boardId,
        projectKey: projectKey,
        projectId: isProject ? projectId : null
    });
    // This gets around a flow inexact type error
    return {
        ...extractedData,
        ...identifier
    };
};

});
parcelRegister("556I0", function(module, exports) {

$parcel$export(module.exports, "default", () => $2aff61bbf8b5a2cf$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $2aff61bbf8b5a2cf$export$2e2bcd8739ae039 = [
    // Regex groups: addonKey, pageKey
    /\/plugins\/servlet\/ac\/(.+)\/([^?\s]+)/i
];

});

parcelRegister("5PyNy", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d489e15712c5e17$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $5d489e15712c5e17$export$2e2bcd8739ae039 = [
    /\/plugins\/servlet\/ac\/com\.xpandit\.plugins\.jiraxporter\/jira-xporter-manage-project/i,
    /\/plugins\/servlet\/ac\/com\.xpandit\.plugins\.xray\/xray-project-settings-all/i
];

});

parcelRegister("79s9E", function(module, exports) {

$parcel$export(module.exports, "default", () => $efe7a2022eaf0f59$export$2e2bcd8739ae039);

var $5PyNy = parcelRequire("5PyNy");
const $efe7a2022eaf0f59$var$commonClassicProjectSettingsRoutes = [
    /\/plugins\/servlet\/project-config/i,
    /\/jira\/software\/c\/projects\/.+\/settings\/code/i,
    /\/jira\/software\/c\/projects\/.+\/settings\/deployments/i,
    /\/plugins\/servlet\/project-config\/.+\/administer-components/i,
    /\/plugins\/servlet\/project-config\/.+\/administer-versions/i,
    /\/plugins\/servlet\/project-config\/.+\/fields/i,
    /\/plugins\/servlet\/project-config\/.+\/issuesecurity/i,
    /\/plugins\/servlet\/project-config\/.+\/issuetypes/i,
    /\/plugins\/servlet\/project-config\/.+\/notifications/i,
    /\/plugins\/servlet\/project-config\/.+\/permissions/i,
    /\/plugins\/servlet\/project-config\/.+\/screens/i,
    /\/plugins\/servlet\/project-config\/.+\/workflows/i,
    /\/project\/DeleteProject!default\.jspa/i,
    /\/secure\/project\/EditProject!default\.jspa/i,
    // Collectors
    /\/secure\/AddCollector/i,
    /\/secure\/InsertCollectorHelp/i,
    /\/ViewCollector!default\.jspa\?projectKey=/i,
    /\/ViewCollectors!default\.jspa\?projectKey=/i,
    // Development tools
    /\/secure\/ConfigureDevStatus.jspa\?projectKey=/i,
    // Hipchat
    /\/InstallHipChat\.jspa\?projectKey=/i,
    /\/secure\/ConfigureHipChat\.jspa\?projectKey=(.+)/i,
    // Forge
    /\/jira\/software\/c\/projects\/.+\/settings\/apps\/([a-z0-9-]+)\/([a-z0-9-]+)(\/*)?/i
];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$efe7a2022eaf0f59$export$2e2bcd8739ae039 = [
    ...$efe7a2022eaf0f59$var$commonClassicProjectSettingsRoutes,
    /\/plugins\/servlet\/project-config\/.+\/issuelayout/i,
    ...(0, $5PyNy.default),
    // Service Desk project settings
    /\/servicedesk\/admin\/(\w+)/i,
    // SPA settings
    /\/projects\/\w+\/settings(\/\w+)*/i
];

});


parcelRegister("883db", function(module, exports) {

$parcel$export(module.exports, "errorFlag", () => $d8474afc40da2ee0$export$b9a7f1ebeaa76953);

var $dGrvr = parcelRequire("dGrvr");
const $d8474afc40da2ee0$export$b9a7f1ebeaa76953 = ()=>({
        type: 'error',
        title: (0, $dGrvr.messages).title,
        description: (0, $dGrvr.messages).description,
        messageId: 'spa-apps-common.redirect.legacy-routing.flags.flag.error.error-flag',
        messageType: 'transactional',
        actions: [
            {
                content: (0, $dGrvr.messages).goHome,
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                onClick: ()=>window.location.assign('/')
            }
        ]
    });

});
parcelRegister("dGrvr", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1d710f8117ed7a9a$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $1d710f8117ed7a9a$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        "id": "redirect.legacy-routing.flags.error.title",
        "defaultMessage": "We can't find the page you're looking for"
    },
    description: {
        "id": "redirect.legacy-routing.flags.error.description",
        "defaultMessage": "Check your spelling in the address bar. Or, try opening this site's home page to search or browse for the content."
    },
    goHome: {
        "id": "redirect.legacy-routing.flags.error.go-home",
        "defaultMessage": "Go to the homepage"
    }
});

});




parcelRegister("21A4f", function(module, exports) {

$parcel$export(module.exports, "LazyGlobalMailSettings", () => $cc4123579e370fa7$export$a133d90b2004a90e);
$parcel$export(module.exports, "default", () => $cc4123579e370fa7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $cc4123579e370fa7$export$a133d90b2004a90e = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("cCkD4"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/global-mail-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cc4123579e370fa7$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cc4123579e370fa7$export$a133d90b2004a90e,
        pageId: "global-mail-settings",
        shouldShowSpinner: false
    });

});
parcelRegister("cCkD4", function(module, exports) {

let $92f909288307c9ef$var$load = (parcelRequire("28QjX"))(4);
module.exports = $92f909288307c9ef$var$load("4QcTa").then(()=>parcelRequire('7ROZZ'));

});



parcelRegister("9jp5b", function(module, exports) {

$parcel$export(module.exports, "globalSettingsCustomFieldsRouteEntry", () => $8b3a43559c4bd90e$export$d83c2e469d070766);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $cpdjw = parcelRequire("cpdjw");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $hESSV = parcelRequire("hESSV");

var $5pSYQ = parcelRequire("5pSYQ");

var $eUwrd = parcelRequire("eUwrd");
const $8b3a43559c4bd90e$export$d83c2e469d070766 = (0, $7NszV.createEntry)((0, $hESSV.globalSettingsCustomFieldsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.custom-fields-directory',
        component: (0, $eUwrd.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $cpdjw.customFieldsDirectoryResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $eUwrd.LazyCustomFieldsDirectoryAdmin)
        ]
    }));

});
parcelRegister("cpdjw", function(module, exports) {

$parcel$export(module.exports, "customFieldsDirectoryResource", () => $dcd1379dc352c4e2$export$3d783f106e15b01a);

var $2M1hQ = parcelRequire("2M1hQ");


const $dcd1379dc352c4e2$export$3d783f106e15b01a = (0, $2M1hQ.createResource)({
    type: (0, $d558514bbbbc39cd$export$f237bae095c310e7),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("hLxGe"))
});

});
const $d558514bbbbc39cd$export$f237bae095c310e7 = 'CUSTOM_FIELDS_DIRECTORY';

parcelRegister("hLxGe", function(module, exports) {

let $cef0f3a07e538fdc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cef0f3a07e538fdc$var$load("hh76d").then(()=>parcelRequire('fFz2g'));

});


parcelRegister("hESSV", function(module, exports) {

$parcel$export(module.exports, "globalSettingsCustomFieldsRoute", () => $a19ed616896ad98a$export$45e7d93edcc9507f);
const $a19ed616896ad98a$export$45e7d93edcc9507f = {
    name: 'global-settings-issues-custom-fields-view',
    path: '/secure/admin/ViewCustomFields(!default)?.jspa'
};

});

parcelRegister("eUwrd", function(module, exports) {

$parcel$export(module.exports, "LazyCustomFieldsDirectoryAdmin", () => $0183f6c188d0635c$export$55a5c16f39a046af);
$parcel$export(module.exports, "default", () => $0183f6c188d0635c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $0183f6c188d0635c$export$55a5c16f39a046af = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("dq3cz"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/custom-fields-directory/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0183f6c188d0635c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $0183f6c188d0635c$export$55a5c16f39a046af,
        pageId: "admin-pages-custom-fields-directory",
        shouldShowSpinner: true
    });

});
parcelRegister("dq3cz", function(module, exports) {

let $9c502fdcfb880c92$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9c502fdcfb880c92$var$load("ffQaD"),
    $9c502fdcfb880c92$var$load("kvRbA"),
    $9c502fdcfb880c92$var$load("fliVL"),
    $9c502fdcfb880c92$var$load("cjvBE")
]).then(()=>parcelRequire('4ZT30'));

});



parcelRegister("427L2", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesExplicitFieldAssociationRouteEntry", () => $654498d18bc8ccd3$export$5519b86c9ea602e1);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $gB79g = parcelRequire("gB79g");

var $aYyVm = parcelRequire("aYyVm");
const $654498d18bc8ccd3$export$5519b86c9ea602e1 = (0, $7NszV.createEntry)((0, $gB79g.globalSettingsIssuesExplicitFieldAssociationRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        component: (0, $aYyVm.LazyExplicitFieldsProjectListPage),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aYyVm.LazyExplicitFieldsProjectListPromise)
        ]
    }));

});
parcelRegister("gB79g", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesExplicitFieldAssociationRoute", () => $7a11591dcb8250ae$export$4f2c2d125c2b811a);
const $7a11591dcb8250ae$export$4f2c2d125c2b811a = {
    name: 'global-settings-issues-explicit-field-association-project-list',
    path: '/jira/settings/issues/explicit-field-association'
};

});

parcelRegister("aYyVm", function(module, exports) {

$parcel$export(module.exports, "LazyExplicitFieldsProjectListPromise", () => $95736e1c9d4aba6e$export$7b11685155ada84d);
$parcel$export(module.exports, "LazyExplicitFieldsProjectListPage", () => $95736e1c9d4aba6e$export$e81c180c4f4833e);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $95736e1c9d4aba6e$export$7b11685155ada84d = (0, $kxZPA.lazyForPaint)(()=>{
    return (0, $7yO8g.markAsProductBundleReady)((parcelRequire("bAABf")).then((bundle)=>bundle.ExplicitFieldAssociationProjectListApp));
}, {
    moduleId: "./src/packages/admin-pages/explicit-field-association/project-list/src/index.tsx"
});
const $95736e1c9d4aba6e$export$e81c180c4f4833e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $95736e1c9d4aba6e$export$7b11685155ada84d,
        pageId: "jira-admin-pages-explicit-field-association-project-list",
        shouldShowSpinner: true
    });

});
parcelRegister("bAABf", function(module, exports) {

let $86ff727378f88636$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $86ff727378f88636$var$load("ffQaD"),
    $86ff727378f88636$var$load("kvRbA"),
    $86ff727378f88636$var$load("kVX56"),
    $86ff727378f88636$var$load("76n7a"),
    $86ff727378f88636$var$load("l253H"),
    $86ff727378f88636$var$load("90dS7")
]).then(()=>parcelRequire('61Yus'));

});



parcelRegister("dRexn", function(module, exports) {

$parcel$export(module.exports, "globalSettingsLegacyFieldLayoutRouteEntry", () => $f3a2596a31c9bceb$export$49998c6229ab8099);

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $5LAK1 = parcelRequire("5LAK1");

var $dqRj0 = parcelRequire("dqRj0");
const $f3a2596a31c9bceb$export$49998c6229ab8099 = (0, $7NszV.createEntry)((0, $5LAK1.globalSettingsLegacyFieldLayoutRoute), ()=>({
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        component: (0, $dqRj0.LazyLegacyFieldLayoutPage),
        forPaint: [
            (0, $dqRj0.LazyLegacyFieldLayoutPromise)
        ]
    }));

});
parcelRegister("5LAK1", function(module, exports) {

$parcel$export(module.exports, "globalSettingsLegacyFieldLayoutRoute", () => $9095ae31098f1586$export$82fa992cdfa20fb5);
const $9095ae31098f1586$export$82fa992cdfa20fb5 = {
    name: 'global-settings-issues-legacy-field-layout',
    path: '/jira/settings/issues/field-configuration/:fieldLayoutId'
};

});

parcelRegister("dqRj0", function(module, exports) {

$parcel$export(module.exports, "LazyLegacyFieldLayoutPromise", () => $cbf369bc67d9494e$export$8b5ab888f8df499);
$parcel$export(module.exports, "LazyLegacyFieldLayoutPage", () => $cbf369bc67d9494e$export$676ecf497a280cfa);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $cbf369bc67d9494e$export$8b5ab888f8df499 = (0, $kxZPA.lazyForPaint)(()=>{
    return (0, $7yO8g.markAsProductBundleReady)((parcelRequire("5TIyC")).then((bundle)=>bundle.LegacyFieldLayoutApp));
}, {
    moduleId: "./src/packages/admin-pages/legacy-field-layout/src/index.tsx"
});
const $cbf369bc67d9494e$export$676ecf497a280cfa = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cbf369bc67d9494e$export$8b5ab888f8df499,
        pageId: "jira-admin-pages-legacy-field-layout",
        shouldShowSpinner: true
    });

});
parcelRegister("5TIyC", function(module, exports) {

let $44b4a6fa0796c7b4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $44b4a6fa0796c7b4$var$load("5sYR0").then(()=>parcelRequire('dENL7'));

});



parcelRegister("6pwY1", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioConversationReviewRouteEntry", () => $c952d5f6c83845ad$export$8fa9ba2d9a9de6f8);

var $ffza4 = parcelRequire("ffza4");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $e2ctp = parcelRequire("e2ctp");

var $7NszV = parcelRequire("7NszV");

var $6Z2mh = parcelRequire("6Z2mh");

var $iReeE = parcelRequire("iReeE");

var $lDcQw = parcelRequire("lDcQw");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $kgvfG = parcelRequire("kgvfG");

var $6gWZ1 = parcelRequire("6gWZ1");
const $c952d5f6c83845ad$var$getConversationReviewResources = ()=>(0, $lDcQw.resources).conversationReview;
const $c952d5f6c83845ad$export$8fa9ba2d9a9de6f8 = (0, $7NszV.createEntry)((0, $iReeE.helpCenterSettingsAgentStudioConversationReviewRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.agent-studio.conversation-review',
        entryPoint () {
            if (!(0, $4R6GH.fg)('enable_support_center_agent_studio_page')) return undefined;
            return 0, $kgvfG.csmAgentConversationReviewPageEntryPoint;
        },
        component: (0, $cSD7y.componentWithFG)('enable_support_center_agent_studio_page', (0, $kgvfG.AgentStudioConversationReview), (0, $5lsNZ.default)),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: (0, $6gWZ1.agentStudioNavigation),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            ...$c952d5f6c83845ad$var$getConversationReviewResources()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kgvfG.LazyAgentStudioConversationReviewPage)
        ],
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("iReeE", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioConversationReviewRoute", () => $51d40744c6e2396f$export$6d3fd8c6a2cde9ea);
const $51d40744c6e2396f$export$6d3fd8c6a2cde9ea = {
    name: 'helpcenter-settings-agent-studio-conversation-review',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/agent/review/:conversationId?',
    exact: true
};

});

parcelRegister("lDcQw", function(module, exports) {

$parcel$export(module.exports, "resources", () => $fe134765bf28c322$export$bc99aaabaf7b70a7);

var $d1dY0 = parcelRequire("d1dY0");
// packages/ai-mate/csm-conversation-review/src/ui/index.tsx
const $fe134765bf28c322$var$conversationRouteNameAndPathFields = {
    name: 'conversationReview',
    path: '/:conversationId?'
};
const $fe134765bf28c322$export$bc99aaabaf7b70a7 = {
    conversationReview: [
        (0, $d1dY0.conversationsResource),
        (0, $d1dY0.messagesResource)
    ]
};

});
parcelRegister("d1dY0", function(module, exports) {

$parcel$export(module.exports, "conversationsResource", () => $4587c71a5878019f$export$666da16fe604f76a);
$parcel$export(module.exports, "messagesResource", () => $4587c71a5878019f$export$e5eacbe7ea3678fe);

var $2M1hQ = parcelRequire("2M1hQ");

var $3gU0O = parcelRequire("3gU0O");

var $614ON = parcelRequire("614ON");

var $8JLfK = parcelRequire("8JLfK");

var $g8NKZ = parcelRequire("g8NKZ");

var $VSDnB = parcelRequire("VSDnB");
const $4587c71a5878019f$export$666da16fe604f76a = (0, $2M1hQ.createResource)({
    type: 'CONVERSATIONS',
    getKey: (ctx)=>`conversations-${(0, $614ON.serialiseFiltersQueryToSearchParams)((0, $614ON.getFiltersQuery)(ctx.query)).toString()}-${ctx.query.csmAiHubId}`,
    getData: async (ctx)=>{
        const headers = (0, $3gU0O.createHeaders)();
        const queryString = (0, $614ON.serialiseFiltersQueryToSearchParams)((0, $614ON.getFiltersQuery)(ctx.query));
        const containerBasedApiEnabled = (0, $VSDnB.fg)('csm_ai_use_container_ari_for_conversations');
        const baseUrl = containerBasedApiEnabled ? `${0, $8JLfK.API_GATEWAY_BASE_URL}/assist/csm/v2/reporting/${ctx.query.csmAiHubId}/conversations` : `${0, $8JLfK.API_GATEWAY_BASE_URL}/assist/csm/v2/reporting/conversations`;
        return fetch(`${baseUrl}?${queryString}`, {
            method: 'GET',
            headers: headers
        }).then((response)=>response.json()).then((data)=>{
            const conversations = data.items.filter((0, $g8NKZ.isNotExcludedOwner));
            const error = 'errorMessage' in data ? data : undefined;
            return {
                conversations: conversations,
                hasNext: data.hasNext || false,
                // V2 only
                cursor: data.cursor,
                error: error
            };
        });
    },
    isBrowserOnly: true
});
const $4587c71a5878019f$export$e5eacbe7ea3678fe = (0, $2M1hQ.createResource)({
    type: 'CONVERSATION_MESSAGES',
    getKey: ({ match: match })=>`conversation-messages-${match.params.conversationId}`,
    getData: async ({ match: match })=>{
        const conversationId = match.params.conversationId;
        if (!conversationId) return {
            messages: [],
            error: {
                errorMessage: 'No conversationId provided',
                errors: [
                    'Missing conversationId'
                ],
                statusCode: 400
            }
        };
        const headers = (0, $3gU0O.createHeaders)();
        return fetch(`${(0, $8JLfK.API_GATEWAY_BASE_URL)}/assist/csm/v2/reporting/conversations/${match.params.conversationId}/messages`, {
            method: 'GET',
            headers: headers
        }).then((response)=>response.json()).then((data)=>{
            const conversation = data.conversation;
            const messages = data.messages;
            const error = 'errorMessage' in data ? data : undefined;
            return {
                conversation: conversation,
                messages: messages,
                error: error
            };
        });
    },
    isBrowserOnly: true
});

});
parcelRegister("3gU0O", function(module, exports) {

$parcel$export(module.exports, "CLOUD_ID_HEADER", () => $e3a1955c3fa05404$export$220635283667d336);
$parcel$export(module.exports, "createHeaders", () => $e3a1955c3fa05404$export$197579c449ddabf4);
$parcel$export(module.exports, "getRequestHeadersForAnnotation", () => $e3a1955c3fa05404$export$61dc7354b71f29a6);
const $e3a1955c3fa05404$var$PRODUCT_HEADER = 'x-product';
const $e3a1955c3fa05404$var$EXPERIENCE_ID_HEADER = 'x-experience-id';
const $e3a1955c3fa05404$export$220635283667d336 = 'x-cloudid';
// Hardcode this for now for the MVP
const $e3a1955c3fa05404$var$CONFLUENCE_PRODUCT = 'confluence';
const $e3a1955c3fa05404$var$CSM_AI_EXPERIENCE_ID = 'csm-ai';
function $e3a1955c3fa05404$export$197579c449ddabf4(init) {
    return new Headers({
        [$e3a1955c3fa05404$var$PRODUCT_HEADER]: $e3a1955c3fa05404$var$CONFLUENCE_PRODUCT,
        [$e3a1955c3fa05404$var$EXPERIENCE_ID_HEADER]: $e3a1955c3fa05404$var$CSM_AI_EXPERIENCE_ID,
        ...init || {}
    });
}
function $e3a1955c3fa05404$export$61dc7354b71f29a6(cloudId) {
    const headers = $e3a1955c3fa05404$export$197579c449ddabf4({
        ...cloudId ? {
            [$e3a1955c3fa05404$export$220635283667d336]: cloudId
        } : {},
        'Content-Type': 'application/json'
    });
    return headers;
}

});

parcelRegister("614ON", function(module, exports) {

$parcel$export(module.exports, "BUILT_IN_FILTERS_BY_PARAM", () => $5d8ecb3a54f2cf91$export$f0b7684dd99bf7f2);
$parcel$export(module.exports, "isValidDateQueryValue", () => $5d8ecb3a54f2cf91$export$5e471de6d5eefc41);
$parcel$export(module.exports, "isFilterField", () => $5d8ecb3a54f2cf91$export$d8a98f7533d78e24);
$parcel$export(module.exports, "serialiseFiltersQueryToSearchParams", () => $5d8ecb3a54f2cf91$export$4966dc62d022f1b7);
$parcel$export(module.exports, "getFiltersQuery", () => $5d8ecb3a54f2cf91$export$ada173b2ef64ad5d);

var $8QpSo = parcelRequire("8QpSo");

var $17krc = parcelRequire("17krc");
const $5d8ecb3a54f2cf91$var$SUPPORTED_FILTER_TYPES = [
    'string',
    'enum',
    'number',
    'boolean',
    'date'
];
const $5d8ecb3a54f2cf91$export$f0b7684dd99bf7f2 = {
    type: {
        label: 'Conversation type',
        param: 'type',
        type: 'enum',
        options: [
            {
                label: 'Test',
                value: 'test'
            },
            {
                label: 'Real',
                value: 'real'
            },
            {
                label: 'Imported',
                value: 'imported'
            }
        ]
    },
    reviewStatus: {
        label: 'Conversation',
        param: 'reviewStatus',
        type: 'enum',
        options: [
            {
                label: 'Good conversation',
                value: 'good'
            },
            {
                label: 'Bad conversation',
                value: 'bad'
            },
            {
                label: 'Not review',
                value: 'not-reviewed'
            }
        ]
    },
    messageReviewStatus: {
        label: 'Response',
        param: 'messageReviewStatus',
        type: 'enum',
        options: [
            {
                label: 'Reviewed',
                value: 'reviewed'
            },
            {
                label: 'Not reviewed',
                value: 'not-reviewed'
            }
        ]
    },
    lastUpdated: {
        label: 'Last updated',
        param: 'lastUpdated',
        type: 'date'
    },
    feedback: {
        label: 'Customer feedback',
        param: 'feedback',
        type: 'enum',
        options: [
            {
                label: 'Good response',
                value: 'good'
            },
            {
                label: 'Bad response',
                value: 'bad'
            }
        ]
    },
    tags: {
        label: 'Review tags',
        param: 'tags',
        type: 'enum',
        options: [
            (0, $17krc.accuracyTagsGroup),
            (0, $17krc.languageTagsGroup),
            (0, $17krc.problemTagsGroup)
        ]
    }
};
const $5d8ecb3a54f2cf91$export$3060295572f39fc0 = Object.values($5d8ecb3a54f2cf91$export$f0b7684dd99bf7f2);
const $5d8ecb3a54f2cf91$export$7be404e211e7c3aa = new Map($5d8ecb3a54f2cf91$export$3060295572f39fc0.map((filter)=>[
        filter.param,
        filter
    ]));
const $5d8ecb3a54f2cf91$export$5e471de6d5eefc41 = (value)=>{
    if (typeof value === 'string') return [
        'today',
        'yesterday',
        'past7Days',
        'past30Days'
    ].includes(value);
    if (typeof value === 'object' && value) {
        if ('to' in value && 'from' in value) return [
            'string',
            'undefined'
        ].includes(typeof value.to) && [
            'string',
            'undefined'
        ].includes(typeof value.from);
        if ('to' in value) return [
            'string',
            'undefined'
        ].includes(typeof value.to);
        if ('from' in value) return [
            'string',
            'undefined'
        ].includes(typeof value.from);
    }
    return false;
};
const $5d8ecb3a54f2cf91$var$BUILT_IN_FILTER_QUERY_PARAMS = $5d8ecb3a54f2cf91$export$3060295572f39fc0.map(({ param: param })=>param);
const $5d8ecb3a54f2cf91$export$53c0ae385683a670 = (param)=>{
    return $5d8ecb3a54f2cf91$var$BUILT_IN_FILTER_QUERY_PARAMS.some((x)=>x === param);
};
const $5d8ecb3a54f2cf91$export$d8a98f7533d78e24 = (param)=>{
    return $5d8ecb3a54f2cf91$export$53c0ae385683a670(param);
};
const $5d8ecb3a54f2cf91$var$QUERY_STRING_PARSERS = {
    string: (value)=>value,
    number: (value)=>isNaN(Number(value)) ? undefined : Number(value),
    boolean: (value)=>[
            'true',
            'false'
        ].some((v)=>v === value) ? value : undefined,
    enum: (value)=>value.split(','),
    date: (value)=>{
        const betweenMatch = value.match(/^between\.(\d{4}-\d{2}-\d{2}(?:T.*Z)?)?\.(\d{4}-\d{2}-\d{2}(?:T.*Z)?)?$/);
        if (betweenMatch) {
            const [, a, b] = betweenMatch ?? [];
            const from = Boolean(a) ? a : undefined;
            const to = Boolean(b) ? b : undefined;
            return {
                from: from,
                to: to
            };
        }
        const fromToMatch = value.match(/^(from|to)\.(\d{4}-\d{2}-\d{2}(?:T.*Z)?)$/);
        if (fromToMatch) {
            const [, operation, date] = fromToMatch ?? [];
            return operation === 'from' ? {
                from: date
            } : {
                to: date
            };
        }
        if ($5d8ecb3a54f2cf91$export$5e471de6d5eefc41(value)) return value;
    }
};
const $5d8ecb3a54f2cf91$var$startOfDate = (date)=>{
    const newDate = new Date(date);
    newDate.setHours(0, 0, 0, 0);
    return newDate;
};
const $5d8ecb3a54f2cf91$var$normaliseDateString = (date, endOfDate)=>{
    const isDateOnlyString = /^\d{4}-\d{2}-\d{2}$/.test(date);
    if (!isDateOnlyString) return new Date(date);
    const d = new Date(date);
    if (!endOfDate) d.setHours(0, 0, 0, 0);
    else d.setHours(23, 59, 59, 999);
    return d;
};
const $5d8ecb3a54f2cf91$export$2ca7fe1ffae7d4ec = {
    type: (value)=>[
            [
                'conversationType',
                String(value)
            ]
        ],
    lastUpdated: (value)=>{
        if (typeof value === 'string') switch(value){
            case 'today':
                return [
                    [
                        'updatedAfter',
                        $5d8ecb3a54f2cf91$var$startOfDate(new Date()).toISOString()
                    ]
                ];
            case 'yesterday':
                return [
                    [
                        'updatedAfter',
                        $5d8ecb3a54f2cf91$var$startOfDate(new Date(new Date().setDate(new Date().getDate() - 1))).toISOString()
                    ],
                    [
                        'updatedBefore',
                        $5d8ecb3a54f2cf91$var$startOfDate(new Date(new Date().setDate(new Date().getDate() - 0))).toISOString()
                    ]
                ];
            case 'past7Days':
                return [
                    [
                        'updatedAfter',
                        $5d8ecb3a54f2cf91$var$startOfDate(new Date(new Date().setDate(new Date().getDate() - 7))).toISOString()
                    ]
                ];
            case 'past30Days':
                return [
                    [
                        'updatedAfter',
                        $5d8ecb3a54f2cf91$var$startOfDate(new Date(new Date().setDate(new Date().getDate() - 30))).toISOString()
                    ]
                ];
        }
        if (typeof value === 'object') {
            if ('from' in value && 'to' in value && value.from && value.to) return [
                [
                    'updatedAfter',
                    $5d8ecb3a54f2cf91$var$normaliseDateString(value.from).toISOString()
                ],
                [
                    'updatedBefore',
                    $5d8ecb3a54f2cf91$var$normaliseDateString(value.to, true).toISOString()
                ]
            ];
            if ('from' in value && value.from) return [
                [
                    'updatedAfter',
                    $5d8ecb3a54f2cf91$var$normaliseDateString(value.from).toISOString()
                ]
            ];
            if ('to' in value && value.to) return [
                [
                    'updatedBefore',
                    $5d8ecb3a54f2cf91$var$normaliseDateString(value.to).toISOString()
                ]
            ];
        }
        return [];
    },
    feedback: (value)=>[
            [
                'customerFeedback',
                String(value)
            ]
        ],
    reviewStatus: (value)=>[
            [
                'conversationReviewStatus',
                String(value)
            ]
        ],
    messageReviewStatus: (value)=>[
            [
                'messageReviewStatus',
                String(value)
            ]
        ],
    tags: (value)=>[
            [
                'annotatedLabels',
                String(value)
            ]
        ]
};
const $5d8ecb3a54f2cf91$export$49da2961ae0c0fca = {
    ...$5d8ecb3a54f2cf91$export$2ca7fe1ffae7d4ec,
    lastUpdated: (value)=>{
        if (typeof value === 'string') switch(value){
            case 'today':
                return [
                    [
                        'lastMessageTimestampAfter',
                        $5d8ecb3a54f2cf91$var$startOfDate(new Date()).toISOString()
                    ]
                ];
            case 'yesterday':
                return [
                    [
                        'lastMessageTimestampAfter',
                        $5d8ecb3a54f2cf91$var$startOfDate(new Date(new Date().setDate(new Date().getDate() - 1))).toISOString()
                    ],
                    [
                        'lastMessageTimestampBefore',
                        $5d8ecb3a54f2cf91$var$startOfDate(new Date(new Date().setDate(new Date().getDate() - 0))).toISOString()
                    ]
                ];
            case 'past7Days':
                return [
                    [
                        'lastMessageTimestampAfter',
                        $5d8ecb3a54f2cf91$var$startOfDate(new Date(new Date().setDate(new Date().getDate() - 7))).toISOString()
                    ]
                ];
            case 'past30Days':
                return [
                    [
                        'lastMessageTimestampAfter',
                        $5d8ecb3a54f2cf91$var$startOfDate(new Date(new Date().setDate(new Date().getDate() - 30))).toISOString()
                    ]
                ];
        }
        if (typeof value === 'object') {
            if ('from' in value && 'to' in value && value.from && value.to) return [
                [
                    'lastMessageTimestampAfter',
                    $5d8ecb3a54f2cf91$var$normaliseDateString(value.from).toISOString()
                ],
                [
                    'lastMessageTimestampBefore',
                    $5d8ecb3a54f2cf91$var$normaliseDateString(value.to, true).toISOString()
                ]
            ];
            if ('from' in value && value.from) return [
                [
                    'lastMessageTimestampAfter',
                    $5d8ecb3a54f2cf91$var$normaliseDateString(value.from).toISOString()
                ]
            ];
            if ('to' in value && value.to) return [
                [
                    'lastMessageTimestampBefore',
                    $5d8ecb3a54f2cf91$var$normaliseDateString(value.to).toISOString()
                ]
            ];
        }
        return [];
    }
};
const $5d8ecb3a54f2cf91$export$4966dc62d022f1b7 = (0, $8QpSo.default)((query)=>{
    return Object.entries(query).reduce((searchParams, [param, value])=>{
        const filters = $5d8ecb3a54f2cf91$export$7be404e211e7c3aa;
        const filter = filters.get(param);
        if (!filter || typeof value === 'undefined') return searchParams;
        const serialisers = $5d8ecb3a54f2cf91$export$49da2961ae0c0fca;
        const serialiser = serialisers[filter.param];
        if (filter.param in serialisers) {
            const params = serialiser(value);
            params.forEach(([key, value])=>{
                searchParams.append(key, value);
            });
            return searchParams;
        }
        return searchParams;
    }, new URLSearchParams());
});
const $5d8ecb3a54f2cf91$export$ada173b2ef64ad5d = (0, $8QpSo.default)((query)=>{
    const filters = $5d8ecb3a54f2cf91$export$7be404e211e7c3aa;
    return Object.entries(query).reduce((acc, [param, value])=>{
        if (!$5d8ecb3a54f2cf91$export$d8a98f7533d78e24(param)) return acc;
        const filter = filters.get(param);
        if (!filter) return acc;
        try {
            const parsedValue = $5d8ecb3a54f2cf91$var$QUERY_STRING_PARSERS[filter.type](value);
            return {
                ...acc,
                [param]: parsedValue
            };
        } catch (err) {
            return acc;
        }
    }, {});
});

});
parcelRegister("17krc", function(module, exports) {

$parcel$export(module.exports, "accuracyTagsGroup", () => $1c6e3e443781646c$export$f592d323cd45fe0b);
$parcel$export(module.exports, "languageTagsGroup", () => $1c6e3e443781646c$export$bd57e646b9ca4d6);
$parcel$export(module.exports, "problemTagsGroup", () => $1c6e3e443781646c$export$f12ac532d5145c52);
const $1c6e3e443781646c$export$40b86a6296d7a6cc = [
    {
        label: 'Accurate',
        value: 'accurate'
    },
    {
        label: 'Not accurate',
        value: 'not-accurate'
    }
];
const $1c6e3e443781646c$export$f592d323cd45fe0b = {
    label: 'Accuracy',
    options: $1c6e3e443781646c$export$40b86a6296d7a6cc
};
const $1c6e3e443781646c$export$f1009b3c58b25589 = [
    {
        label: 'Easy to understand',
        value: 'easy-to-understand'
    },
    {
        label: 'Hard to understand',
        value: 'hard-to-understand'
    },
    {
        label: 'Concise',
        value: 'concise'
    },
    {
        label: 'Verbose',
        value: 'verbose'
    },
    {
        label: 'Grammatical errors',
        value: 'grammatical-errors'
    },
    {
        label: 'Formatting errors',
        value: 'formatting-errors'
    },
    {
        label: 'Incorrect tone',
        value: 'incorrect-tone'
    }
];
const $1c6e3e443781646c$export$bd57e646b9ca4d6 = {
    label: 'Language',
    options: $1c6e3e443781646c$export$f1009b3c58b25589
};
const $1c6e3e443781646c$export$ea5f6f7f4df4b955 = [
    {
        label: 'Vague question',
        value: 'vaque-question'
    },
    {
        label: 'Irrelevant answer',
        value: 'irrelevant-answer'
    },
    {
        label: 'Human required',
        value: 'human-required'
    },
    {
        label: 'Content not retrieved',
        value: 'content-not-retrieved'
    },
    {
        label: 'Missing links',
        value: 'missing-links'
    },
    {
        label: 'Incorrect source',
        value: 'incorrect-source'
    }
];
const $1c6e3e443781646c$export$f12ac532d5145c52 = {
    label: 'Problems',
    options: $1c6e3e443781646c$export$ea5f6f7f4df4b955
};

});


parcelRegister("8JLfK", function(module, exports) {

$parcel$export(module.exports, "API_GATEWAY_BASE_URL", () => $b6313a29e003fab0$export$d9629d145ee9933b);
const $b6313a29e003fab0$export$d9629d145ee9933b = '/gateway/api';
function $b6313a29e003fab0$export$23da1d24a38b0bde() {
    const hostname = window.location.hostname;
    return hostname.includes('localhost') || hostname.includes('.stg.internal.atlassian') || hostname.includes('.stg.atlassian');
}

});

parcelRegister("g8NKZ", function(module, exports) {

$parcel$export(module.exports, "isNotExcludedOwner", () => $566d186f00e19b13$export$f4707ebc2561f73d);
// Users who's conversations should be excluded from the list
const $566d186f00e19b13$export$9112ec7e6c72159b = [
    // Staging test bot
    'ari:cloud:identity::user/61c2c7a390cfd2007154ede7',
    // Prod test bot - 'cst-e2e-test-bot
    'ari:cloud:identity::user/61bc6c272f24e70068bf462a'
];
const $566d186f00e19b13$export$f4707ebc2561f73d = (c)=>{
    return !$566d186f00e19b13$export$9112ec7e6c72159b.includes(c.owner);
};

});



parcelRegister("kgvfG", function(module, exports) {

$parcel$export(module.exports, "LazyAgentStudioOverviewPage", () => $90b72030babf7447$export$5fa375047554c75c);
$parcel$export(module.exports, "AgentStudioOverviewPage", () => $90b72030babf7447$export$3c32337b9e9c89e5);
$parcel$export(module.exports, "LazyAgentStudioConversationReviewPage", () => $90b72030babf7447$export$e5bd431cce56c023);
$parcel$export(module.exports, "AgentStudioConversationReview", () => $90b72030babf7447$export$ba343ba7cdb4cca4);
$parcel$export(module.exports, "LazyAgentStudioSimulatorPage", () => $90b72030babf7447$export$89ec1205a5fbfa5a);
$parcel$export(module.exports, "AgentStudioSimulatorComponent", () => $90b72030babf7447$export$974fe2862709837d);
$parcel$export(module.exports, "LazyAgentStudioActionsPage", () => $90b72030babf7447$export$f1d6621241cd5379);
$parcel$export(module.exports, "AgentStudioActionsComponent", () => $90b72030babf7447$export$27f9057c3758bdae);
$parcel$export(module.exports, "csmAgentOverviewPageEntryPoint", () => $90b72030babf7447$export$64672a53ea64d95b);
$parcel$export(module.exports, "agentStudioKnowledgePageEntryPoint", () => $90b72030babf7447$export$a9cf3691889e3b8);
$parcel$export(module.exports, "csmAgentHandoffPageEntryPoint", () => $90b72030babf7447$export$822a9de2df799668);
$parcel$export(module.exports, "csmAgentConversationReviewPageEntryPoint", () => $90b72030babf7447$export$14c5ab081cdbeb0d);
$parcel$export(module.exports, "csmAgentChatSimulatorPageEntryPoint", () => $90b72030babf7447$export$dc40d5702a9b03f3);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $lEnZH = parcelRequire("lEnZH");

var $7Di6X = parcelRequire("7Di6X");

var $96DTa = parcelRequire("96DTa");

var $9UI5x = parcelRequire("9UI5x");

var $9RDhp = parcelRequire("9RDhp");

const $90b72030babf7447$export$5fa375047554c75c = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("2HSON")).then((module)=>module.AgentOverview)), {
    moduleId: "./src/packages/spa-apps/help-center-settings/agent-studio/src/ui/overview/index.tsx"
});
const $90b72030babf7447$export$3c32337b9e9c89e5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $90b72030babf7447$export$5fa375047554c75c,
        pageId: "help-center-settings-agent-studio-overview",
        shouldShowSpinner: true
    });

const $90b72030babf7447$export$e5bd431cce56c023 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("cW76i"))), {
    moduleId: "./src/packages/spa-apps/help-center-settings/agent-studio/src/ui/conversation-review/index.tsx"
});
const $90b72030babf7447$export$ba343ba7cdb4cca4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $90b72030babf7447$export$e5bd431cce56c023,
        pageId: "help-center-settings-agent-studio-conversation-review",
        shouldShowSpinner: true
    });

const $90b72030babf7447$export$89ec1205a5fbfa5a = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("5EFdG"))), {
    moduleId: "./src/packages/spa-apps/help-center-settings/agent-studio/src/ui/chat-simulator/index.tsx"
});
const $90b72030babf7447$export$974fe2862709837d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $90b72030babf7447$export$89ec1205a5fbfa5a,
        pageId: "help-center-settings-agent-studio-chat-simulator",
        shouldShowSpinner: false
    });

const $90b72030babf7447$export$f1d6621241cd5379 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("d6PBk"))), {
    moduleId: "./src/packages/spa-apps/help-center-settings/agent-studio/src/ui/actions/index.tsx"
});
const $90b72030babf7447$export$27f9057c3758bdae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $90b72030babf7447$export$f1d6621241cd5379,
        pageId: "help-center-settings-agent-studio-chat-actions",
        shouldShowSpinner: false
    });
const $90b72030babf7447$export$64672a53ea64d95b = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7Di6X.csmAgentOverviewEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});
const $90b72030babf7447$export$a9cf3691889e3b8 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $lEnZH.helpCenterSettingsAgentStudioKnowledgeAppEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});
const $90b72030babf7447$export$822a9de2df799668 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $9UI5x.helpCenterSettingsAgentStudioHandoffEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});
const $90b72030babf7447$export$14c5ab081cdbeb0d = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $9RDhp.csmAgentConversationReviewEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});
const $90b72030babf7447$export$dc40d5702a9b03f3 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $96DTa.csmAgentChatSimulatorEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("lEnZH", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioKnowledgeAppEntryPoint", () => $189f4d55daa7ac84$export$9436eec1eefc1701);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $8c96j = parcelRequire("8c96j");

const $189f4d55daa7ac84$export$9436eec1eefc1701 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("5IyQG")), {
        moduleId: "4b9cc39b"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $8c96j.default),
                    variables: {
                        helpCenterAri: `ari:cloud:help::help-center/${tenantContext.activationId}/${context.match.params.helpCenterId}`
                    }
                }
            }
        })
});

});
parcelRegister("8c96j", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cca371066bfa50a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7975a004da92a606996f012c39a7bd74>>
 * @relayHash 7517a65583faed70dbfad33ebebfb7fe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7062c3ecfa368283782ea4badae1efec4d13b76b7bd2fb2d781f242160bd2237
const $9cca371066bfa50a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "InlineFragment",
        "selections": [
            v2 /*: any*/ 
        ],
        "type": "CsmAiAgent"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "knowledgeConfig_agentIdentityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "agent",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "CsmAiHub"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "knowledgeConfig_agentIdentityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "agent",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v3 /*: any*/ 
                                    ]
                                },
                                v2 /*: any*/ 
                            ],
                            "type": "CsmAiHub"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7062c3ecfa368283782ea4badae1efec4d13b76b7bd2fb2d781f242160bd2237",
            "metadata": {},
            "name": "knowledgeConfig_agentIdentityQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9cca371066bfa50a$var$node.hash = "0b997c6ab7fcf5ad5b42793b2c9d9bc6";
var $9cca371066bfa50a$export$2e2bcd8739ae039 = $9cca371066bfa50a$var$node;

});

parcelRegister("5IyQG", function(module, exports) {

let $429c180796f49c72$var$load = (parcelRequire("28QjX"))(4);
module.exports = $429c180796f49c72$var$load("gMlYq").then(()=>parcelRequire('kYkWF'));

});


parcelRegister("7Di6X", function(module, exports) {

$parcel$export(module.exports, "csmAgentOverviewEntryPoint", () => $3280ffbb5b52c908$export$50a5fd926c9d7bb4);

var $36uSG = parcelRequire("36uSG");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $3280ffbb5b52c908$export$50a5fd926c9d7bb4 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("2HSON")).then((module)=>module.AgentOverview), {
        moduleId: "a5f961b3"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $36uSG.default),
                    variables: {
                        helpCenterAri: `ari:cloud:help::help-center/${tenantContext.activationId}/${context.match.params.helpCenterId}`
                    }
                }
            }
        })
});

});
parcelRegister("36uSG", function(module, exports) {

$parcel$export(module.exports, "default", () => $9aad833e24a70a01$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<95da339cb012f96ec20febdec96d2484>>
 * @relayHash b2c29c3713e9bb4a323b8c17631a839d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9159055d2982d57eb684f7a6fcf95942a5df5264ec27612680ad83db3bce0573
const $9aad833e24a70a01$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "overview_agentIdentityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "agent",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "agentIdentity_AtlassianCsmAgentIdentity"
                                        }
                                    ]
                                }
                            ],
                            "type": "CsmAiHub"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "overview_agentIdentityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "agent",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "companyName"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "companyDescription"
                                                },
                                                {
                                                    "concreteType": "CsmAiAgentTone",
                                                    "kind": "LinkedField",
                                                    "name": "tone",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "type"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "greetingMessage"
                                                }
                                            ],
                                            "type": "CsmAiAgent"
                                        }
                                    ]
                                },
                                v3 /*: any*/ 
                            ],
                            "type": "CsmAiHub"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9159055d2982d57eb684f7a6fcf95942a5df5264ec27612680ad83db3bce0573",
            "metadata": {},
            "name": "overview_agentIdentityQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9aad833e24a70a01$var$node.hash = "ad2118276853b2acba85a665b99d4060";
var $9aad833e24a70a01$export$2e2bcd8739ae039 = $9aad833e24a70a01$var$node;

});

parcelRegister("2HSON", function(module, exports) {

let $1f8a1eb2bd77646c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1f8a1eb2bd77646c$var$load("fFCZv").then(()=>parcelRequire('5SMTp'));

});


parcelRegister("96DTa", function(module, exports) {

$parcel$export(module.exports, "csmAgentChatSimulatorEntryPoint", () => $8d086789a796e4fd$export$e3fcb8d4e80081b0);

var $4737k = parcelRequire("4737k");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $8d086789a796e4fd$export$e3fcb8d4e80081b0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("5EFdG")), {
        moduleId: "e930d9dc"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $4737k.default),
                    variables: {
                        helpCenterAri: `ari:cloud:help::help-center/${tenantContext.activationId}/${context.match.params.helpCenterId}`
                    }
                }
            }
        })
});

});
parcelRegister("4737k", function(module, exports) {

$parcel$export(module.exports, "default", () => $15ffe817581ead86$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fe98323d8ba25bee0cdc2d21b347b37c>>
 * @relayHash 6ec40e2940a58d5987f8d0d2565b653b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8b009d3de84f25c5f42694160edf048b5c7d1d61a085303179c1eec4658087cc
const $15ffe817581ead86$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "greetingMessage"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "chatSimulator_agentIdentityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "agent",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "CsmAiAgentConversationStarter",
                                                    "kind": "LinkedField",
                                                    "name": "conversationStarters",
                                                    "plural": true,
                                                    "selections": [
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "CsmAiAgent"
                                        }
                                    ]
                                }
                            ],
                            "type": "CsmAiHub"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "chatSimulator_agentIdentityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "agent",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "CsmAiAgentConversationStarter",
                                                    "kind": "LinkedField",
                                                    "name": "conversationStarters",
                                                    "plural": true,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v2 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "CsmAiAgent"
                                        }
                                    ]
                                }
                            ],
                            "type": "CsmAiHub"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8b009d3de84f25c5f42694160edf048b5c7d1d61a085303179c1eec4658087cc",
            "metadata": {},
            "name": "chatSimulator_agentIdentityQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$15ffe817581ead86$var$node.hash = "db75ee797c497b47b6a05c1132ca4fc4";
var $15ffe817581ead86$export$2e2bcd8739ae039 = $15ffe817581ead86$var$node;

});

parcelRegister("5EFdG", function(module, exports) {

let $41e0a992d6efeee0$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $41e0a992d6efeee0$var$load("ffQaD"),
    $41e0a992d6efeee0$var$load("kvRbA"),
    $41e0a992d6efeee0$var$load("kNFvF"),
    $41e0a992d6efeee0$var$load("fliVL"),
    $41e0a992d6efeee0$var$load("lng2q")
]).then(()=>parcelRequire('e2jOc'));

});


parcelRegister("9UI5x", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioHandoffEntryPoint", () => $51bbfcf593383423$export$443ff355bdadb1d7);

var $exxeF = parcelRequire("exxeF");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $51bbfcf593383423$export$443ff355bdadb1d7 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("fyfLl")), {
        moduleId: "7048febb"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $exxeF.default),
                    variables: {
                        helpCenterAri: `ari:cloud:help::help-center/${tenantContext.activationId}/${context.match.params.helpCenterId}`
                    }
                }
            }
        })
});

});
parcelRegister("exxeF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3156665af3d70ae$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2285d0d1f88cc563f1f2b92458f234a4>>
 * @relayHash bd6dbc5adaecf4efb9df56ffa90d58d8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fe6e73323e192b86de137616515efbe5a7e7b42f6550cdb18ddd026aa7f938d5
const $b3156665af3d70ae$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "handoffConfig_csmAiHubQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "kind": "LinkedField",
                        "name": "csmAi_getAiHubByHelpCenterAri",
                        "plural": false,
                        "selections": [
                            v2 /*: any*/ ,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "configuration_AtlassianCsmHandoffConfig"
                                    }
                                ],
                                "type": "CsmAiHub"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "csmAi_getAiHubByHelpCenterAri"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "handoffConfig_csmAiHubQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "handoffConfigs",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "type"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "enabled"
                                                },
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "connectorConfiguration",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "message"
                                                                }
                                                            ],
                                                            "type": "CsmAiMessageHandoff"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "CsmAiHandoffConfig"
                                        }
                                    ]
                                },
                                v3 /*: any*/ 
                            ],
                            "type": "CsmAiHub"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fe6e73323e192b86de137616515efbe5a7e7b42f6550cdb18ddd026aa7f938d5",
            "metadata": {},
            "name": "handoffConfig_csmAiHubQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b3156665af3d70ae$var$node.hash = "841642ca04c73dc56596f8461c555698";
var $b3156665af3d70ae$export$2e2bcd8739ae039 = $b3156665af3d70ae$var$node;

});

parcelRegister("fyfLl", function(module, exports) {

let $b526421f9fd337e0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b526421f9fd337e0$var$load("ZhH5c").then(()=>parcelRequire('lgJzj'));

});


parcelRegister("9RDhp", function(module, exports) {

$parcel$export(module.exports, "csmAgentConversationReviewEntryPoint", () => $cb7f36ce49502e4e$export$d1ea95606ab7ac2e);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $2SViv = parcelRequire("2SViv");

const $cb7f36ce49502e4e$export$d1ea95606ab7ac2e = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("cW76i")), {
        moduleId: "b29d9436"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $2SViv.default),
                    variables: {
                        helpCenterAri: `ari:cloud:help::help-center/${tenantContext.activationId}/${context.match.params.helpCenterId}`
                    }
                }
            }
        })
});

});
parcelRegister("2SViv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4c902db3cd67e1b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1d293c5fa575e282b09e51ccabc0fea4>>
 * @relayHash 5d73a886053db0c3167810d478cac2ef
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 95c94140fecba78cb87b8cfc0cf42eaf05d1a58960bd94f0b354baf1030acfc9
const $f4c902db3cd67e1b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v2 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ],
        "type": "CsmAiHub"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "conversationReview_agentIdentityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "conversationReview_agentIdentityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getAiHubByHelpCenterAri",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "95c94140fecba78cb87b8cfc0cf42eaf05d1a58960bd94f0b354baf1030acfc9",
            "metadata": {},
            "name": "conversationReview_agentIdentityQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f4c902db3cd67e1b$var$node.hash = "340a20f2d50cc5f77582b00676ed5abb";
var $f4c902db3cd67e1b$export$2e2bcd8739ae039 = $f4c902db3cd67e1b$var$node;

});

parcelRegister("cW76i", function(module, exports) {

let $96b068dae05f0139$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $96b068dae05f0139$var$load("fliVL"),
    $96b068dae05f0139$var$load("iCIYt")
]).then(()=>parcelRequire('iC69g'));

});


parcelRegister("d6PBk", function(module, exports) {

let $98b3dcc76b3acba9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $98b3dcc76b3acba9$var$load("7BW98").then(()=>parcelRequire('eJnmn'));

});


parcelRegister("6gWZ1", function(module, exports) {

$parcel$export(module.exports, "navigation", () => $3831f5d0598d36f4$export$428e7c787d57587d);
$parcel$export(module.exports, "agentStudioNavigation", () => $3831f5d0598d36f4$export$c198b13d4a0b8cea);

var $lmyls = parcelRequire("lmyls");

var $65ItF = parcelRequire("65ItF");

var $fBTqh = parcelRequire("fBTqh");

var $cSD7y = parcelRequire("cSD7y");
const $3831f5d0598d36f4$export$428e7c787d57587d = {
    sidebarId: (0, $lmyls.SIDEBAR_ID).HELP_CENTER_SETTINGS,
    menuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS,
    sidebar: (0, $fBTqh.default)
};
const $3831f5d0598d36f4$export$c198b13d4a0b8cea = {
    sidebarId: (0, $lmyls.SIDEBAR_ID).HELP_CENTER_SETTINGS,
    menuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS,
    sidebar: (0, $fBTqh.default),
    horizontal: (0, $cSD7y.componentWithFG)('enable_support_center_agent_studio_page', (0, $65ItF.AsyncSupportCenterHorizontalNav), ()=>null)
};

});
parcelRegister("65ItF", function(module, exports) {

$parcel$export(module.exports, "AsyncSupportCenterHorizontalNav", () => $bc8ad4b74f43add3$export$123fcd6868b7ea3f);

var $5uXOq = parcelRequire("5uXOq");

var $hYRTO = parcelRequire("hYRTO");

var $kxZPA = parcelRequire("kxZPA");

const $bc8ad4b74f43add3$var$LazyHorizontalSupportCenterNav = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("cu6av")).then(({ HorizontalNav: HorizontalNav })=>HorizontalNav), {
    moduleId: "./src/packages/spa-apps/help-center-settings/agent-studio/src/ui/horizontal-nav/main.tsx"
});
const $bc8ad4b74f43add3$export$123fcd6868b7ea3f = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYRTO.default), {
        name: "help-center-settings-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bc8ad4b74f43add3$var$LazyHorizontalSupportCenterNav, null));
};

});
parcelRegister("cu6av", function(module, exports) {

let $916d124dcfaec395$var$load = (parcelRequire("28QjX"))(4);
module.exports = $916d124dcfaec395$var$load("9G7s9").then(()=>parcelRequire('70kLi'));

});


parcelRegister("fBTqh", function(module, exports) {

$parcel$export(module.exports, "default", () => $43189553e9fc21a2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

const $43189553e9fc21a2$export$ea77f88c1b841127 = (0, $kxZPA.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("kmi2q")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/help-center-settings/src/index.tsx"
});
const $43189553e9fc21a2$var$HelpCenterSettingsSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "servicedeskProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($43189553e9fc21a2$export$ea77f88c1b841127, null)));
$43189553e9fc21a2$var$HelpCenterSettingsSidebar.displayName = 'HelpCenterSettingsSidebar';
var $43189553e9fc21a2$export$2e2bcd8739ae039 = $43189553e9fc21a2$var$HelpCenterSettingsSidebar;

});
parcelRegister("kmi2q", function(module, exports) {

let $ed23dab9fe014cab$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ed23dab9fe014cab$var$load("afUJz").then(()=>parcelRequire('5NHpB'));

});




parcelRegister("gQABM", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioHandoffRouteEntry", () => $0537c5be2e29ef16$export$df69744b9adaa993);

var $4R6GH = parcelRequire("4R6GH");

var $e2ctp = parcelRequire("e2ctp");

var $5lsNZ = parcelRequire("5lsNZ");

var $fpjJX = parcelRequire("fpjJX");

var $7NszV = parcelRequire("7NszV");

var $6Z2mh = parcelRequire("6Z2mh");

var $58uk4 = parcelRequire("58uk4");

var $6gWZ1 = parcelRequire("6gWZ1");

var $kgvfG = parcelRequire("kgvfG");
const $0537c5be2e29ef16$export$df69744b9adaa993 = (0, $7NszV.createEntry)((0, $58uk4.helpCenterSettingsAgentStudioHandoffRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.agent-studio-handoff',
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('csm_ai_agent_builder_handoff') ? (0, $kgvfG.csmAgentHandoffPageEntryPoint) : undefined;
        },
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: (0, $6gWZ1.agentStudioNavigation),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ],
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("58uk4", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioHandoffRoute", () => $0fed46fe26c2e78b$export$d23d0e34831b4de5);
const $0fed46fe26c2e78b$export$d23d0e34831b4de5 = {
    name: 'helpcenter-settings-agent-studio-handoff',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/agent/handoff',
    exact: true
};

});


parcelRegister("9sgxL", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioKnowledgeRouteEntry", () => $34dc2eb2639959d6$export$6d22d206a282d6a9);

var $4R6GH = parcelRequire("4R6GH");

var $e2ctp = parcelRequire("e2ctp");

var $5lsNZ = parcelRequire("5lsNZ");

var $fpjJX = parcelRequire("fpjJX");

var $7NszV = parcelRequire("7NszV");

var $6Z2mh = parcelRequire("6Z2mh");

var $fCFMo = parcelRequire("fCFMo");

var $gLUA7 = parcelRequire("gLUA7");

var $6gWZ1 = parcelRequire("6gWZ1");

var $kgvfG = parcelRequire("kgvfG");
const $34dc2eb2639959d6$export$6d22d206a282d6a9 = (0, $7NszV.createEntry)((0, $gLUA7.helpCenterSettingsAgentStudioKnowledgeRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.agent-studio-knowledge',
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('enable_support_center_agent_studio_page') ? (0, $kgvfG.agentStudioKnowledgePageEntryPoint) : undefined;
        },
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: (0, $6gWZ1.agentStudioNavigation),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $fCFMo.knowledgeSourcesResource)
        ],
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("fCFMo", function(module, exports) {

$parcel$export(module.exports, "knowledgeSourcesResource", () => $d492004289a23794$export$98ae61e83ea268b1);

var $2M1hQ = parcelRequire("2M1hQ");
const $d492004289a23794$var$TWENTY_FOUR_HOURS_IN_MS = 86400000;

const $d492004289a23794$export$98ae61e83ea268b1 = (0, $2M1hQ.createResource)({
    type: 'CSM_AGENT_CONFIGURATION_KNOWLEDGE_SOURCES',
    getKey: (routerContext)=>`knowledge-sources-${routerContext.query.agentId}`,
    getData: (routerContext)=>(parcelRequire("3v17H")).then((module)=>module.default(routerContext.query.agentId)),
    maxAge: $d492004289a23794$var$TWENTY_FOUR_HOURS_IN_MS,
    isBrowserOnly: true
});

});
parcelRegister("3v17H", function(module, exports) {

let $28c523662ab125a0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $28c523662ab125a0$var$load("lzESI").then(()=>parcelRequire('hScnq'));

});


parcelRegister("gLUA7", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioKnowledgeRoute", () => $d0a24339f6e35337$export$f1df26b41169b43);
const $d0a24339f6e35337$export$f1df26b41169b43 = {
    name: 'helpcenter-settings-agent-studio-knowledge',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/agent/knowledge',
    exact: true
};

});


parcelRegister("8wIny", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioChatSimulatorRouteEntry", () => $ad87a7ca26339056$export$c4240053c0a5eb9c);

var $ffza4 = parcelRequire("ffza4");

var $e2ctp = parcelRequire("e2ctp");

var $5lsNZ = parcelRequire("5lsNZ");

var $fpjJX = parcelRequire("fpjJX");

var $7NszV = parcelRequire("7NszV");

var $6Z2mh = parcelRequire("6Z2mh");

var $9MsoF = parcelRequire("9MsoF");

var $cSD7y = parcelRequire("cSD7y");

var $jZ7nW = parcelRequire("jZ7nW");

var $4R6GH = parcelRequire("4R6GH");

var $6gWZ1 = parcelRequire("6gWZ1");

var $kgvfG = parcelRequire("kgvfG");
const $ad87a7ca26339056$export$c4240053c0a5eb9c = (0, $7NszV.createEntry)((0, $9MsoF.helpCenterSettingsAgentStudioChatSimulatorRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.agent-studio-chat-simulator',
        entryPoint () {
            if (!(0, $4R6GH.fg)('enable_support_center_agent_studio_page')) return undefined;
            return 0, $kgvfG.csmAgentChatSimulatorPageEntryPoint;
        },
        component: (0, $cSD7y.componentWithFG)('enable_support_center_agent_studio_page', (0, $kgvfG.AgentStudioSimulatorComponent), (0, $5lsNZ.default)),
        skeleton: (0, $jZ7nW.ChatSimulatorLoadingState),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: (0, $6gWZ1.agentStudioNavigation),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kgvfG.LazyAgentStudioSimulatorPage)
        ],
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("9MsoF", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioChatSimulatorRoute", () => $6d8e604aaf253ef7$export$426c3d828fdab50e);
const $6d8e604aaf253ef7$export$426c3d828fdab50e = {
    name: 'helpcenter-settings-agent-studio-chat-simulator',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/agent/simulator',
    exact: true
};

});

parcelRegister("jZ7nW", function(module, exports) {

$parcel$export(module.exports, "ChatSimulatorLoadingState", () => $27a7b26a19620204$export$3966fd37f06836dd);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $bgrar = parcelRequire("bgrar");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $1DVhQ = parcelRequire("1DVhQ");
const $27a7b26a19620204$var$gridStyles = (0, $8CUq3.xcss)({
    height: '920px'
});
const $27a7b26a19620204$var$leftSidebarStyles = (0, $8CUq3.xcss)({
    height: '100%',
    paddingBottom: 'space.0'
});
const $27a7b26a19620204$var$mainContentStyles = (0, $8CUq3.xcss)({
    height: '100%'
});
const $27a7b26a19620204$var$chatSectionStyles = (0, $8CUq3.xcss)({
    height: '100%',
    width: '100%',
    paddingTop: 'space.100',
    paddingBottom: 'space.0',
    paddingInline: 'space.200',
    overflow: 'auto',
    maxWidth: 'min(800px, 50vw)',
    marginInline: 'auto'
});
const $27a7b26a19620204$var$conversationListStyle = (0, $8CUq3.xcss)({
    padding: 'space.300'
});
const $27a7b26a19620204$export$3966fd37f06836dd = ()=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bgrar.default), {
        xcss: $27a7b26a19620204$var$gridStyles,
        rowGap: "space.200",
        columnGap: "space.0",
        templateColumns: "360px 1fr",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
                alignBlock: "start",
                xcss: $27a7b26a19620204$var$leftSidebarStyles,
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                        padding: "space.300",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                            isShimmering: true,
                            width: "100%",
                            height: "32px",
                            borderRadius: 3
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
                        space: "space.100",
                        xcss: $27a7b26a19620204$var$conversationListStyle,
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                                isShimmering: true,
                                width: "100%",
                                height: "36px",
                                borderRadius: 3
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                                isShimmering: true,
                                width: "100%",
                                height: "36px",
                                borderRadius: 3
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                                isShimmering: true,
                                width: "100%",
                                height: "36px",
                                borderRadius: 3
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                                isShimmering: true,
                                width: "100%",
                                height: "36px",
                                borderRadius: 3
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
                xcss: $27a7b26a19620204$var$mainContentStyles,
                spread: "space-between",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                        padding: "space.300",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                            isShimmering: true,
                            width: "50%",
                            height: "32px",
                            borderRadius: 0
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
                        xcss: $27a7b26a19620204$var$chatSectionStyles,
                        alignBlock: "end",
                        space: "space.200",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                                isShimmering: true,
                                width: "440px",
                                height: "120px",
                                borderRadius: 2
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
                                space: "space.050",
                                alignInline: "end",
                                children: [
                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                                        isShimmering: true,
                                        width: "240px",
                                        height: "32px",
                                        borderRadius: 8
                                    }),
                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                                        isShimmering: true,
                                        width: "320px",
                                        height: "32px",
                                        borderRadius: 8
                                    }),
                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                                        isShimmering: true,
                                        width: "180px",
                                        height: "32px",
                                        borderRadius: 8
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
                                space: "space.100",
                                children: [
                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                                        isShimmering: true,
                                        width: "100%",
                                        height: "84px",
                                        borderRadius: 8
                                    }),
                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1DVhQ.default), {
                                        isShimmering: true,
                                        width: "100%",
                                        height: "40px",
                                        borderRadius: 0
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });

});


parcelRegister("2krv1", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioActionsRouteEntry", () => $3d7af2fe877a2988$export$47cbfd555c8570c0);

var $ffza4 = parcelRequire("ffza4");

var $e2ctp = parcelRequire("e2ctp");

var $5lsNZ = parcelRequire("5lsNZ");

var $fpjJX = parcelRequire("fpjJX");

var $7NszV = parcelRequire("7NszV");

var $6Z2mh = parcelRequire("6Z2mh");

var $gFEDq = parcelRequire("gFEDq");

var $cSD7y = parcelRequire("cSD7y");

var $6gWZ1 = parcelRequire("6gWZ1");

var $kgvfG = parcelRequire("kgvfG");
const $3d7af2fe877a2988$export$47cbfd555c8570c0 = (0, $7NszV.createEntry)((0, $gFEDq.helpCenterSettingsAgentStudioActionsRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.agent-studio-actions',
        component: (0, $cSD7y.componentWithFG)('csm-actions-framework-visibility', (0, $kgvfG.AgentStudioActionsComponent), (0, $5lsNZ.default)),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: (0, $6gWZ1.agentStudioNavigation),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kgvfG.LazyAgentStudioActionsPage)
        ],
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("gFEDq", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioActionsRoute", () => $f90b0e5d1a951de0$export$5cfc987a071755e7);
const $f90b0e5d1a951de0$export$5cfc987a071755e7 = {
    name: 'helpcenter-settings-agent-studio-actions',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/agent/actions',
    exact: true
};

});


parcelRegister("alZMU", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioRouteEntry", () => $331ec935012c0277$export$5328c10e46075e4d);

var $4R6GH = parcelRequire("4R6GH");

var $ffza4 = parcelRequire("ffza4");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $6Z2mh = parcelRequire("6Z2mh");

var $e2ctp = parcelRequire("e2ctp");

var $7NszV = parcelRequire("7NszV");

var $k2Bg0 = parcelRequire("k2Bg0");

var $cSD7y = parcelRequire("cSD7y");

var $kgvfG = parcelRequire("kgvfG");

var $6gWZ1 = parcelRequire("6gWZ1");
const $331ec935012c0277$export$5328c10e46075e4d = (0, $7NszV.createEntry)((0, $k2Bg0.helpCenterSettingsAgentStudioRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.agent-studio',
        // For either return undefined scenario, it will fallback to the component config below
        entryPoint () {
            if (!(0, $4R6GH.fg)('enable_support_center_agent_studio_page')) return undefined;
            return 0, $kgvfG.csmAgentOverviewPageEntryPoint;
        },
        component: (0, $cSD7y.componentWithFG)('enable_support_center_agent_studio_page', (0, $kgvfG.AgentStudioOverviewPage), (0, $5lsNZ.default)),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: (0, $6gWZ1.agentStudioNavigation),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kgvfG.LazyAgentStudioOverviewPage)
        ],
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("k2Bg0", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAgentStudioRoute", () => $22c785b6be90cb91$export$b8b0efb16984db50);
const $22c785b6be90cb91$export$b8b0efb16984db50 = {
    name: 'helpcenter-settings-agent-studio',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/agent',
    exact: true
};

});


parcelRegister("6u3qv", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsArticlesRouteEntry", () => $32bcb1fc70286108$export$dcf98310ab461eb0);

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $9kAH1 = parcelRequire("9kAH1");

var $6Z2mh = parcelRequire("6Z2mh");

var $6gWZ1 = parcelRequire("6gWZ1");

var $8N6gO = parcelRequire("8N6gO");
const $32bcb1fc70286108$export$dcf98310ab461eb0 = (0, $7NszV.createEntry)((0, $9kAH1.helpCenterSettingsArticlesRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.articles',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('enable_articles_page_csm') ? (0, $8N6gO.helpCenterSettingArticlesAppPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("9kAH1", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsArticlesRoute", () => $412bb66633bbef70$export$6445613754b0db30);
const $412bb66633bbef70$export$6445613754b0db30 = {
    name: 'helpcenter-settings-articles',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/articles',
    exact: true
};

});

parcelRegister("8N6gO", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingArticlesAppPageEntryPoint", () => $9b45af5968e8d332$export$5f683051fd990adb);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $630bL = parcelRequire("630bL");
const $9b45af5968e8d332$export$5f683051fd990adb = (0, $lkFvK.createPageEntryPoint)({
    main: $630bL.HelpCenterSettingsArticlesAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("630bL", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsArticlesAppEntryPoint", () => $ba27834c1284a762$export$ba888b162abf6368);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $ba27834c1284a762$export$ba888b162abf6368 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("329Po")), {
        moduleId: "8c0e0839"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("329Po", function(module, exports) {

let $23592ea20e3d5c82$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $23592ea20e3d5c82$var$load("ffQaD"),
    $23592ea20e3d5c82$var$load("kvRbA"),
    $23592ea20e3d5c82$var$load("bpRYe")
]).then(()=>parcelRequire('eFox7'));

});




parcelRegister("j2SDi", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsArticlesViewArticleRouteEntry", () => $88e0a8f5dda84f20$export$d14f4c2b666bbb54);

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $6zrpv = parcelRequire("6zrpv");

var $6Z2mh = parcelRequire("6Z2mh");

var $6gWZ1 = parcelRequire("6gWZ1");

var $3Ap7x = parcelRequire("3Ap7x");
const $88e0a8f5dda84f20$export$d14f4c2b666bbb54 = (0, $7NszV.createEntry)((0, $6zrpv.helpCenterSettingsArticlesViewArticleRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.articles-view-article',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('enable_articles_page_csm') ? (0, $3Ap7x.helpCenterSettingViewArticleAppPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("6zrpv", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsArticlesViewArticleRoute", () => $2f69465d47479faa$export$c5c6fbcb1f26b87b);
const $2f69465d47479faa$export$c5c6fbcb1f26b87b = {
    name: 'helpcenter-settings-articles-view-article',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/articles/:articleId',
    exact: true
};

});

parcelRegister("3Ap7x", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingViewArticleAppPageEntryPoint", () => $aeb454237a95509d$export$7f08ea9d5c2912ad);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $ji0Vr = parcelRequire("ji0Vr");
const $aeb454237a95509d$export$7f08ea9d5c2912ad = (0, $lkFvK.createPageEntryPoint)({
    main: $ji0Vr.HelpCenterSettingsArticlesViewArticleAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("ji0Vr", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsArticlesViewArticleAppEntryPoint", () => $96a8b60127af2d58$export$31df33b35c5b2ee);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $96a8b60127af2d58$export$31df33b35c5b2ee = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("BRbGT")), {
        moduleId: "6cb514e3"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("BRbGT", function(module, exports) {

let $071cb6c1f6814196$var$load = (parcelRequire("28QjX"))(4);
module.exports = $071cb6c1f6814196$var$load("98lbG").then(()=>parcelRequire('1yKGc'));

});




parcelRegister("e48vl", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsCreateArticleRouteEntry", () => $57dff6ea3b7a57a0$export$882f07b6a7d364c7);

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $1huwb = parcelRequire("1huwb");

var $6Z2mh = parcelRequire("6Z2mh");

var $6gWZ1 = parcelRequire("6gWZ1");

var $flVeW = parcelRequire("flVeW");
const $57dff6ea3b7a57a0$export$882f07b6a7d364c7 = (0, $7NszV.createEntry)((0, $1huwb.helpCenterSettingsCreateArticleRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.create-article',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('enable_articles_page_csm') ? (0, $flVeW.helpCenterSettingCreateArticleAppPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("1huwb", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsCreateArticleRoute", () => $7549b70b1a3f48a6$export$6f4350070b3391d2);
const $7549b70b1a3f48a6$export$6f4350070b3391d2 = {
    name: 'helpcenter-settings-create-article',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/articles/:articleId/space/:spaceKey/edit',
    query: [
        'draftShareId?',
        'topicId?'
    ]
};

});

parcelRegister("flVeW", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingCreateArticleAppPageEntryPoint", () => $e1fa58280d3204d3$export$2dedebb94d500afa);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $ljlmd = parcelRequire("ljlmd");
const $e1fa58280d3204d3$export$2dedebb94d500afa = (0, $lkFvK.createPageEntryPoint)({
    main: $ljlmd.HelpCenterSettingsCreateArticleAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("ljlmd", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsCreateArticleAppEntryPoint", () => $fd79767a8e638019$export$dd82613d258b9120);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $fd79767a8e638019$export$dd82613d258b9120 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("9VL1r")), {
        moduleId: "d6a89104"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("9VL1r", function(module, exports) {

let $73ade9902fe061b1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $73ade9902fe061b1$var$load("16C5P").then(()=>parcelRequire('iDGEe'));

});




parcelRegister("jSJ1v", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsCustomerAccessRouteEntry", () => $1e207cd846476f87$export$5cfeb28cf3c43d24);

var $ffza4 = parcelRequire("ffza4");

var $cSD7y = parcelRequire("cSD7y");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $hyajn = parcelRequire("hyajn");

var $6Z2mh = parcelRequire("6Z2mh");

var $6gWZ1 = parcelRequire("6gWZ1");

var $7aOCJ = parcelRequire("7aOCJ");
const $1e207cd846476f87$export$5cfeb28cf3c43d24 = (0, $7NszV.createEntry)((0, $hyajn.helpCenterSettingsCustomerAccessRoute), ()=>({
        perfMetricKey: 'help-center-settings.customer-access',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $cSD7y.componentWithFG)('jcs_master_flag', (0, $7aOCJ.HelpCenterSettingsCustomerAccess), (0, $5lsNZ.default)),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7aOCJ.LazyHelpCenterSettingsCustomerAccess)
        ],
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("hyajn", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsCustomerAccessRoute", () => $956ef53bef7f74b8$export$5adf9b8f07e4dd7b);
const $956ef53bef7f74b8$export$5adf9b8f07e4dd7b = {
    name: 'helpcenter-settings-customer-access',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/customer-access'
};

});

parcelRegister("7aOCJ", function(module, exports) {

$parcel$export(module.exports, "LazyHelpCenterSettingsCustomerAccess", () => $c2a27ef145addce1$export$2c331ddbdb6fb4ef);
$parcel$export(module.exports, "HelpCenterSettingsCustomerAccess", () => $c2a27ef145addce1$export$ab643bb246877df);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $c2a27ef145addce1$export$2c331ddbdb6fb4ef = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("912hJ"))), {
    moduleId: "./src/packages/spa-apps/help-center-settings/customer-access/src/index.tsx"
});
const $c2a27ef145addce1$export$ab643bb246877df = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $c2a27ef145addce1$export$2c331ddbdb6fb4ef,
        pageId: "help-center-settings-customer-access",
        shouldShowSpinner: true
    });

});
parcelRegister("912hJ", function(module, exports) {

let $6905faccb26fbfa3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6905faccb26fbfa3$var$load("76n7a"),
    $6905faccb26fbfa3$var$load("l253H"),
    $6905faccb26fbfa3$var$load("bfO34")
]).then(()=>parcelRequire('lQS7P'));

});



parcelRegister("fdHNd", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsCustomerNotificationsRouteEntry", () => $7e976989bafafd81$export$4e4f38417d267cf6);

var $ffza4 = parcelRequire("ffza4");

var $cSD7y = parcelRequire("cSD7y");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $6cuak = parcelRequire("6cuak");

var $6Z2mh = parcelRequire("6Z2mh");

var $6gWZ1 = parcelRequire("6gWZ1");

var $jp5Vz = parcelRequire("jp5Vz");
const $7e976989bafafd81$export$4e4f38417d267cf6 = (0, $7NszV.createEntry)((0, $6cuak.helpCenterSettingsCustomerNotificationsRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.customer-notifications',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $cSD7y.componentWithFG)('jcs_master_flag', (0, $jp5Vz.HelpCenterSettingsCustomerNotifications), (0, $5lsNZ.default)),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jp5Vz.LazyHelpCenterSettingsCustomerNotifications)
        ],
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("6cuak", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsCustomerNotificationsRoute", () => $e11b5b1fd2c66498$export$88fcb9acf40a0827);
const $e11b5b1fd2c66498$export$88fcb9acf40a0827 = {
    name: 'helpcenter-settings-customer-notifications',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/customer-notifications'
};

});

parcelRegister("jp5Vz", function(module, exports) {

$parcel$export(module.exports, "LazyHelpCenterSettingsCustomerNotifications", () => $ce252471da0db8c1$export$b2b6550dec008a98);
$parcel$export(module.exports, "HelpCenterSettingsCustomerNotifications", () => $ce252471da0db8c1$export$2f2f18f57014444a);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $ce252471da0db8c1$export$b2b6550dec008a98 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("lQYjh"))), {
    moduleId: "./src/packages/spa-apps/help-center-settings/customer-notifications/src/index.tsx"
});
const $ce252471da0db8c1$export$2f2f18f57014444a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ce252471da0db8c1$export$b2b6550dec008a98,
        pageId: "help-center-settings-customer-notifications",
        shouldShowSpinner: true
    });

});
parcelRegister("lQYjh", function(module, exports) {

let $041b0d5d42d050e9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $041b0d5d42d050e9$var$load("fopkd").then(()=>parcelRequire('7QYfj'));

});



parcelRegister("guURi", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsDetailsRouteEntry", () => $0315c5537179bf15$export$a9c03c3c37251dd3);

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $hTsNV = parcelRequire("hTsNV");

var $6Z2mh = parcelRequire("6Z2mh");

var $6gWZ1 = parcelRequire("6gWZ1");

var $gD7KY = parcelRequire("gD7KY");
const $0315c5537179bf15$export$a9c03c3c37251dd3 = (0, $7NszV.createEntry)((0, $hTsNV.helpCenterSettingsDetailsRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.details',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('jcs_master_flag') ? (0, $gD7KY.helpCenterSettingDetailsAppPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("hTsNV", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsDetailsRoute", () => $c84b441b3d2b2a1a$export$f54c1546ddea019b);
const $c84b441b3d2b2a1a$export$f54c1546ddea019b = {
    name: 'helpcenter-settings-details',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/details',
    exact: true
};

});

parcelRegister("gD7KY", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingDetailsAppPageEntryPoint", () => $145a2f3e4b766427$export$c52cb026d0dc8ed7);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $16x51 = parcelRequire("16x51");
const $145a2f3e4b766427$export$c52cb026d0dc8ed7 = (0, $lkFvK.createPageEntryPoint)({
    main: $16x51.helpCenterSettingDetailsAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("16x51", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingDetailsAppEntryPoint", () => $f508c84d71030ec3$export$519ec4ef3722cb47);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $26seq = parcelRequire("26seq");

const $f508c84d71030ec3$export$519ec4ef3722cb47 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("drPd0")), {
        moduleId: "e9a696a2"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                serviceHubDetailsQuery: {
                    parameters: $26seq.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("26seq", function(module, exports) {

$parcel$export(module.exports, "default", () => $5995ee8670b27cd9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<067fa7fbcebd00e597b347ca915f6034>>
 * @relayHash fd0d1d5dce03064b407037920fb2720b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e73190d907fbed87beb0dcedf5843143674119a51c7aba6c42a0159b955a42d1
const $5995ee8670b27cd9$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e73190d907fbed87beb0dcedf5843143674119a51c7aba6c42a0159b955a42d1",
        "metadata": {},
        "name": "uiServiceHubDetailsPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $5995ee8670b27cd9$export$2e2bcd8739ae039 = $5995ee8670b27cd9$var$node;

});

parcelRegister("drPd0", function(module, exports) {

let $9ca584fbfa6d9ae5$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9ca584fbfa6d9ae5$var$load("76n7a"),
    $9ca584fbfa6d9ae5$var$load("l253H"),
    $9ca584fbfa6d9ae5$var$load("hKY0Y")
]).then(()=>parcelRequire('kGNbu'));

});




parcelRegister("6RCDC", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsEmailRouteEntry", () => $a5ff5d25549b46ce$export$f95717dac47e4db3);

var $ffza4 = parcelRequire("ffza4");

var $cSD7y = parcelRequire("cSD7y");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $9wcYQ = parcelRequire("9wcYQ");

var $6Z2mh = parcelRequire("6Z2mh");

var $6gWZ1 = parcelRequire("6gWZ1");

var $lUb7T = parcelRequire("lUb7T");
const $a5ff5d25549b46ce$export$f95717dac47e4db3 = (0, $7NszV.createEntry)((0, $9wcYQ.helpCenterSettingsEmailRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.email',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $cSD7y.componentWithFG)('jcs_master_flag', (0, $lUb7T.HelpCenterSettingsEmail), (0, $5lsNZ.default)),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $lUb7T.LazyHelpCenterSettingsEmail)
        ],
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("9wcYQ", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsEmailRoute", () => $1e498e8ebd1ddcd1$export$4515288a48c62087);
const $1e498e8ebd1ddcd1$export$4515288a48c62087 = {
    name: 'helpcenter-settings-email',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/email',
    exact: true
};

});

parcelRegister("lUb7T", function(module, exports) {

$parcel$export(module.exports, "LazyHelpCenterSettingsEmail", () => $6353b69d503ce9ba$export$e090cd3a62343249);
$parcel$export(module.exports, "HelpCenterSettingsEmail", () => $6353b69d503ce9ba$export$962f20e752738967);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $6353b69d503ce9ba$export$e090cd3a62343249 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("6RxGO")), {
    moduleId: "./src/packages/spa-apps/help-center-settings/email/src/index.tsx"
});
const $6353b69d503ce9ba$export$962f20e752738967 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $6353b69d503ce9ba$export$e090cd3a62343249,
        pageId: "help-center-settings-email",
        shouldShowSpinner: true
    });

});
parcelRegister("6RxGO", function(module, exports) {

let $4ff1d3600367ae5d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4ff1d3600367ae5d$var$load("d036g").then(()=>parcelRequire('7r8zn'));

});



parcelRegister("avQ9D", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsSupportWebsiteRouteEntry", () => $bdc73697774975eb$export$59cfd0dfcd1b4311);

var $6Z2mh = parcelRequire("6Z2mh");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $aQelL = parcelRequire("aQelL");

var $lmyls = parcelRequire("lmyls");

var $fBTqh = parcelRequire("fBTqh");

var $hVOfU = parcelRequire("hVOfU");

var $4R6GH = parcelRequire("4R6GH");

var $6gj7h = parcelRequire("6gj7h");
const $bdc73697774975eb$export$59cfd0dfcd1b4311 = (0, $7NszV.createEntry)((0, $aQelL.helpCenterSettingsSupportWebsiteRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'customer-service.support-website',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).HELP_CENTER_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS,
            sidebar: (0, $fBTqh.default),
            horizontal: (0, $4R6GH.fg)('csm_contact_us_rte') ? undefined : (0, $hVOfU.AsyncSupportWebsiteNav)
        },
        component: (0, $5lsNZ.default),
        entryPoint: ()=>{
            if (!(0, $4R6GH.fg)('enable_support_site_details_csm')) return undefined;
            return (0, $4R6GH.fg)('csm_contact_us_rte') ? (0, $6gj7h.HelpCenterSettingsSupportWebsiteEntryPointWithHorizontalNavigation) : (0, $6gj7h.HelpCenterSettingsSupportWebsiteEntryPoint);
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)()
        ]
    }));

});
parcelRegister("aQelL", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsSupportWebsiteRoute", () => $fc3d051dfa242c89$export$c59ea9b870a0e809);
const $fc3d051dfa242c89$export$c59ea9b870a0e809 = {
    name: 'helpcenter-settings-support-website-details',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/support-website',
    exact: true
};

});

parcelRegister("hVOfU", function(module, exports) {

$parcel$export(module.exports, "AsyncSupportWebsiteNav", () => $fe8481e5cfa634b6$export$8887f9c4b5829b78);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $fe8481e5cfa634b6$var$LazySupportWebsiteNav = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("jQPWD")).then(({ SupportWebsiteNavOld: SupportWebsiteNavOld })=>SupportWebsiteNavOld), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-csm/support-website/src/ui/index.tsx"
});
const $fe8481e5cfa634b6$export$8887f9c4b5829b78 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-csm-support-site-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fe8481e5cfa634b6$var$LazySupportWebsiteNav, null));

});
parcelRegister("jQPWD", function(module, exports) {

let $e73b2ac9594cc767$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e73b2ac9594cc767$var$load("9aARs").then(()=>parcelRequire('9fzxT'));

});


parcelRegister("6gj7h", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsSupportWebsiteEntryPoint", () => $a1985909a25e76e4$export$91f75c485220b109);
$parcel$export(module.exports, "HelpCenterSettingsSupportWebsiteEntryPointWithHorizontalNavigation", () => $a1985909a25e76e4$export$4811316770750d89);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $eiTxd = parcelRequire("eiTxd");

var $k4AVk = parcelRequire("k4AVk");
const $a1985909a25e76e4$export$91f75c485220b109 = (0, $lkFvK.createPageEntryPoint)({
    main: $eiTxd.HelpCenterSettingsSupportWebsiteAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});
const $a1985909a25e76e4$export$4811316770750d89 = (0, $lkFvK.createPageEntryPoint)({
    main: $eiTxd.HelpCenterSettingsSupportWebsiteAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS,
    horizontalNavigation: (0, $k4AVk.horizontalNavigationCsmSupportWebsiteEntryPoint)
});

});
parcelRegister("eiTxd", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsSupportWebsiteAppEntryPoint", () => $fccdb49574d19a8f$export$43c72a7c514122ed);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $fccdb49574d19a8f$export$43c72a7c514122ed = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("ixqp3")), {
        moduleId: "6e5d67aa"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("ixqp3", function(module, exports) {

let $d7efca2b2bb68971$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d7efca2b2bb68971$var$load("1NYHB").then(()=>parcelRequire('hPBOL'));

});


parcelRegister("k4AVk", function(module, exports) {

$parcel$export(module.exports, "horizontalNavigationCsmSupportWebsiteEntryPoint", () => $25afd3bee76e68c6$export$2ba426f18e0d22f5);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $6M0GP = parcelRequire("6M0GP");

const $25afd3bee76e68c6$export$2ba426f18e0d22f5 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("l15Wx")), {
        moduleId: "b4f1b5e4"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        return {
            queries: {
                mainHorizontalNavCsmSupportWebsiteQuery: {
                    parameters: $6M0GP.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("6M0GP", function(module, exports) {

$parcel$export(module.exports, "default", () => $eec8ee5685901ecf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<254d867d38ac2047e1b355de64e44419>>
 * @relayHash 74a6ed725a3c21301a8a9e20260043d1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e56b17fc47959b40a696bb4d93e1ad9907e79c351376c9594868dd91b2bd2a9d
const $eec8ee5685901ecf$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e56b17fc47959b40a696bb4d93e1ad9907e79c351376c9594868dd91b2bd2a9d",
        "metadata": {},
        "name": "mainHorizontalNavCsmSupportWebsiteQuery",
        "operationKind": "query",
        "text": null
    }
};
var $eec8ee5685901ecf$export$2e2bcd8739ae039 = $eec8ee5685901ecf$var$node;

});

parcelRegister("l15Wx", function(module, exports) {

let $f4ce4d2b906c23c1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f4ce4d2b906c23c1$var$load("jo9Ab").then(()=>parcelRequire('hc56P'));

});




parcelRegister("f7vKZ", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsSupportWebsiteOverviewRouteEntry", () => $032e280ea85bb67e$export$eb728930eecb0b42);

var $4R6GH = parcelRequire("4R6GH");

var $6Z2mh = parcelRequire("6Z2mh");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $69WMA = parcelRequire("69WMA");

var $fBTqh = parcelRequire("fBTqh");

var $lmyls = parcelRequire("lmyls");

var $hVOfU = parcelRequire("hVOfU");

var $cfV2M = parcelRequire("cfV2M");
const $032e280ea85bb67e$export$eb728930eecb0b42 = (0, $7NszV.createEntry)((0, $69WMA.helpCenterSettingsSupportWebsiteOverviewRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'customer-service.support-website.overview',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).HELP_CENTER_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS,
            sidebar: (0, $fBTqh.default),
            horizontal: (0, $4R6GH.fg)('csm_contact_us_rte') ? undefined : (0, $hVOfU.AsyncSupportWebsiteNav)
        },
        component: (0, $5lsNZ.default),
        entryPoint: ()=>{
            if (!(0, $4R6GH.fg)('enable_support_site_details_csm')) return undefined;
            return (0, $4R6GH.fg)('csm_contact_us_rte') ? (0, $cfV2M.HelpCenterSettingsSupportWebsiteOverviewAppEntryPointWithHorizontalNavigation) : (0, $cfV2M.HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint);
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)()
        ]
    }));

});
parcelRegister("69WMA", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsSupportWebsiteOverviewRoute", () => $8aa73486df339929$export$64e95782b19caeac);
const $8aa73486df339929$export$64e95782b19caeac = {
    name: 'helpcenter-settings-support-website-details-overview',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/support-website/overview',
    exact: true
};

});

parcelRegister("cfV2M", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint", () => $5c12c4d46de7a315$export$780fd78388c1f1d1);
$parcel$export(module.exports, "HelpCenterSettingsSupportWebsiteOverviewAppEntryPointWithHorizontalNavigation", () => $5c12c4d46de7a315$export$23f7867fc61415d6);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $5Xswi = parcelRequire("5Xswi");

var $k4AVk = parcelRequire("k4AVk");
const $5c12c4d46de7a315$export$780fd78388c1f1d1 = (0, $lkFvK.createPageEntryPoint)({
    main: $5Xswi.HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});
const $5c12c4d46de7a315$export$23f7867fc61415d6 = (0, $lkFvK.createPageEntryPoint)({
    main: $5Xswi.HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS,
    horizontalNavigation: (0, $k4AVk.horizontalNavigationCsmSupportWebsiteEntryPoint)
});

});
parcelRegister("5Xswi", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint", () => $71148ffb5b8df6c9$export$780fd78388c1f1d1);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $65dSj = parcelRequire("65dSj");

const $71148ffb5b8df6c9$export$780fd78388c1f1d1 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("1ivka")), {
        moduleId: "d27a8c99"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                serviceHubDetailsQuery: {
                    parameters: $65dSj.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("65dSj", function(module, exports) {

$parcel$export(module.exports, "default", () => $739483af15ac3c69$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<086fc8a80466dbab70300b14e65169cd>>
 * @relayHash 97f7e29b9656db740fc7b8aa0a23f4d6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 00edac7f68a877717beb0b54982122a8afa0dbc0016892d64c3d13228d7c8fb7
const $739483af15ac3c69$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "00edac7f68a877717beb0b54982122a8afa0dbc0016892d64c3d13228d7c8fb7",
        "metadata": {},
        "name": "uiSupportWebsiteOverviewServiceHubPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $739483af15ac3c69$export$2e2bcd8739ae039 = $739483af15ac3c69$var$node;

});

parcelRegister("1ivka", function(module, exports) {

let $0f1fc53760638aa8$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0f1fc53760638aa8$var$load("76n7a"),
    $0f1fc53760638aa8$var$load("l253H"),
    $0f1fc53760638aa8$var$load("cBrt7")
]).then(()=>parcelRequire('kqMbh'));

});




parcelRegister("k826a", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsSupportWebsitePagesRouteEntry", () => $9bc8c8ad2937179a$export$5077ff1d96b93d83);

var $6Z2mh = parcelRequire("6Z2mh");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $h8xmH = parcelRequire("h8xmH");

var $fBTqh = parcelRequire("fBTqh");

var $lmyls = parcelRequire("lmyls");

var $hVOfU = parcelRequire("hVOfU");

var $4R6GH = parcelRequire("4R6GH");

var $fwLOb = parcelRequire("fwLOb");
const $9bc8c8ad2937179a$export$5077ff1d96b93d83 = (0, $7NszV.createEntry)((0, $h8xmH.helpCenterSettingsSupportWebsitePagesRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'customer-service.support-website.pages',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).HELP_CENTER_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS,
            sidebar: (0, $fBTqh.default),
            horizontal: (0, $4R6GH.fg)('csm_contact_us_rte') ? undefined : (0, $hVOfU.AsyncSupportWebsiteNav)
        },
        component: (0, $5lsNZ.default),
        entryPoint: ()=>{
            if (!(0, $4R6GH.fg)('enable_custom_pages_csm')) return undefined;
            return (0, $4R6GH.fg)('csm_contact_us_rte') ? (0, $fwLOb.HelpCenterSettingsSupportWebsitePagesAppEntryPointWithHorizontalNavigation) : (0, $fwLOb.HelpCenterSettingsSupportWebsitePagesAppEntryPoint);
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)()
        ]
    }));

});
parcelRegister("h8xmH", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsSupportWebsitePagesRoute", () => $4b2f69811d8f88b2$export$a6eefe359f3d3ade);
const $4b2f69811d8f88b2$export$a6eefe359f3d3ade = {
    name: 'helpcenter-settings-support-website-details-pages',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/support-website/pages',
    exact: true
};

});

parcelRegister("fwLOb", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsSupportWebsitePagesAppEntryPoint", () => $ba2e92bb63ab8578$export$7d51b2b14ae8000f);
$parcel$export(module.exports, "HelpCenterSettingsSupportWebsitePagesAppEntryPointWithHorizontalNavigation", () => $ba2e92bb63ab8578$export$e27663b14f44038e);

var $lkFvK = parcelRequire("lkFvK");

var $k4AVk = parcelRequire("k4AVk");

var $lmyls = parcelRequire("lmyls");

var $ezcM4 = parcelRequire("ezcM4");
const $ba2e92bb63ab8578$export$7d51b2b14ae8000f = (0, $lkFvK.createPageEntryPoint)({
    main: $ezcM4.HelpCenterSettingsSupportWebsitePagesAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});
const $ba2e92bb63ab8578$export$e27663b14f44038e = (0, $lkFvK.createPageEntryPoint)({
    main: $ezcM4.HelpCenterSettingsSupportWebsitePagesAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS,
    horizontalNavigation: (0, $k4AVk.horizontalNavigationCsmSupportWebsiteEntryPoint)
});

});
parcelRegister("ezcM4", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsSupportWebsitePagesAppEntryPoint", () => $fa9b1e599393909a$export$7d51b2b14ae8000f);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $kHuGF = parcelRequire("kHuGF");

const $fa9b1e599393909a$export$7d51b2b14ae8000f = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("5LPHo")), {
        moduleId: "c9581695"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                customPagesQuery: {
                    parameters: $kHuGF.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterARI: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
                        NUMBER_OF_PAGES_INITIAL_FETCH: 300
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("kHuGF", function(module, exports) {

$parcel$export(module.exports, "default", () => $82b3287921674b82$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fc6702d6d5b729b362f762d15d7d7323>>
 * @relayHash 3fb15375f0c81d09baad81021f24d532
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 298c60ba3b0de24944a6dc739efc5011d413a8237106a9bd71fdeeea48f62fc4
const $82b3287921674b82$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "298c60ba3b0de24944a6dc739efc5011d413a8237106a9bd71fdeeea48f62fc4",
        "metadata": {
            "connection": [
                {
                    "count": "NUMBER_OF_PAGES_INITIAL_FETCH",
                    "cursor": null,
                    "direction": "forward",
                    "path": [
                        "helpCenter",
                        "helpCenterPages"
                    ]
                }
            ]
        },
        "name": "uiSupportWebsiteCustomPagesQuery",
        "operationKind": "query",
        "text": null
    }
};
var $82b3287921674b82$export$2e2bcd8739ae039 = $82b3287921674b82$var$node;

});

parcelRegister("5LPHo", function(module, exports) {

let $433971d9306a7800$var$load = (parcelRequire("28QjX"))(4);
module.exports = $433971d9306a7800$var$load("3sPkw").then(()=>parcelRequire('lDMA6'));

});




parcelRegister("9aEQn", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsFormEditRouteEntry", () => $dca661aacd919783$export$1750cfcab794a07d);

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $fCXWg = parcelRequire("fCXWg");

var $5lsNZ = parcelRequire("5lsNZ");

var $fmqJw = parcelRequire("fmqJw");

var $6Z2mh = parcelRequire("6Z2mh");

var $6gWZ1 = parcelRequire("6gWZ1");

var $7VD4g = parcelRequire("7VD4g");
const $dca661aacd919783$export$1750cfcab794a07d = (0, $7NszV.createEntry)((0, $fmqJw.helpCenterSettingsFormEditRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.form-edit',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('jcs_master_flag') ? (0, $7VD4g.helpCenterSettingFormEditAppPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $fCXWg.formEditJirafieldsResource)
        ]
    }));

});
parcelRegister("fCXWg", function(module, exports) {

$parcel$export(module.exports, "formEditJirafieldsResource", () => $0b2fb9f25d526504$export$ca58e1498fd1ff3e);
$parcel$export(module.exports, "useFormEditJirafields", () => $0b2fb9f25d526504$export$8a76fadb956ce203);

var $dK8AG = parcelRequire("dK8AG");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

const $0b2fb9f25d526504$var$getDataLoader = ()=>(parcelRequire("2P1yL"));
const $0b2fb9f25d526504$export$ca58e1498fd1ff3e = (0, $2M1hQ.createResource)({
    type: 'HELP_CENTER_FORM_EDIT_JIRAFIELDS_RESOURCE',
    getKey: ({ match: match })=>(0, $dK8AG.getProjectKeyOrId)(match),
    getDataLoader: $0b2fb9f25d526504$var$getDataLoader,
    isBrowserOnly: true
});
const $0b2fb9f25d526504$export$8a76fadb956ce203 = ()=>(0, $2YP9W.useResource)($0b2fb9f25d526504$export$ca58e1498fd1ff3e);

});
parcelRegister("2P1yL", function(module, exports) {

let $20e18de93309751e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $20e18de93309751e$var$load("lELr1").then(()=>parcelRequire('5Kre9'));

});


parcelRegister("fmqJw", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsFormEditRoute", () => $76127e6b6297617e$export$31bd3e10c42460dc);
const $76127e6b6297617e$export$31bd3e10c42460dc = {
    exact: true,
    name: 'helpcenter-settings-form-edit',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/forms/:formId'
};

});

parcelRegister("7VD4g", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingFormEditAppPageEntryPoint", () => $73a7c9331a7a621d$export$2792cba2387cbc5c);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $aXX0d = parcelRequire("aXX0d");
const $73a7c9331a7a621d$export$2792cba2387cbc5c = (0, $lkFvK.createPageEntryPoint)({
    main: $aXX0d.helpCenterSettingFormEditAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("aXX0d", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingFormEditAppEntryPoint", () => $dcaafae9dc3cdb4f$export$262512d610e494f8);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $jVPFz = parcelRequire("jVPFz");

const $dcaafae9dc3cdb4f$export$262512d610e494f8 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("hNYOp")), {
        moduleId: "d82eb4d8"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId, formId: formId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                uiFormEditRoutingQuery: {
                    parameters: $jVPFz.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
                        templateFormAri: `ari:cloud:jira-customer-service::template-form/activation/${activationId}/${formId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("jVPFz", function(module, exports) {

$parcel$export(module.exports, "default", () => $05a055aee7ffa295$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e08557ab552bf44df293cd7626377d57>>
 * @relayHash 25cf59f5b03aae972cf632dae9685f3c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7dd46115cf70ad94d508dc1c7421a44d4cff3f62c44724b51e2c900cb6cfe9d3
const $05a055aee7ffa295$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "7dd46115cf70ad94d508dc1c7421a44d4cff3f62c44724b51e2c900cb6cfe9d3",
        "metadata": {},
        "name": "uiFormEditRoutingQuery",
        "operationKind": "query",
        "text": null
    }
};
var $05a055aee7ffa295$export$2e2bcd8739ae039 = $05a055aee7ffa295$var$node;

});

parcelRegister("hNYOp", function(module, exports) {

let $cf662f446745e979$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cf662f446745e979$var$load("8NSzi").then(()=>parcelRequire('3XNgZ'));

});




parcelRegister("gZQLD", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsFormsRouteEntry", () => $752d7b6fe60c2c67$export$9a67aaae787c9f40);

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $Z9uTe = parcelRequire("Z9uTe");

var $6Z2mh = parcelRequire("6Z2mh");

var $6gWZ1 = parcelRequire("6gWZ1");

var $uu31h = parcelRequire("uu31h");
const $752d7b6fe60c2c67$export$9a67aaae787c9f40 = (0, $7NszV.createEntry)((0, $Z9uTe.helpCenterSettingsFormsRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.forms',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('jcs_master_flag') ? (0, $uu31h.helpCenterSettingFormsAppPageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ]
    }));

});
parcelRegister("Z9uTe", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsFormsRoute", () => $a0406c9ab9debc78$export$45b14c3ed47b2b3a);
const $a0406c9ab9debc78$export$45b14c3ed47b2b3a = {
    exact: true,
    name: 'helpcenter-settings-forms',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/forms'
};

});

parcelRegister("uu31h", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingFormsAppPageEntryPoint", () => $cf39360ee106b7b5$export$b50d944f3be2457f);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $UvMAc = parcelRequire("UvMAc");
const $cf39360ee106b7b5$export$b50d944f3be2457f = (0, $lkFvK.createPageEntryPoint)({
    main: $UvMAc.helpCenterSettingFormsAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("UvMAc", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingFormsAppEntryPoint", () => $dbea87a49a7edd6e$export$ce8253ab16579f12);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $gqaus = parcelRequire("gqaus");

const $dbea87a49a7edd6e$export$ce8253ab16579f12 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("c3cNm")), {
        moduleId: "c7a4dbb9"
    }),
    getPreloadProps: ({ context: { match: { params: { helpCenterId: helpCenterId } } }, tenantContext: { cloudId: cloudId, activationId: activationId } })=>({
            queries: {
                uiFormsQuery: {
                    parameters: $gqaus.default,
                    variables: {
                        cloudId: cloudId,
                        helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("gqaus", function(module, exports) {

$parcel$export(module.exports, "default", () => $22259d546684fabe$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<84b049be8f3a777ce173b3c8cca04631>>
 * @relayHash 0a68a91abafc7c22614c8b72a0a3f13b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0ae63b4dd317fe8ffc05de4c48bb50926299366f1b898d6a5e04aae8b233cac4
const $22259d546684fabe$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "0ae63b4dd317fe8ffc05de4c48bb50926299366f1b898d6a5e04aae8b233cac4",
        "metadata": {},
        "name": "uiFormsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $22259d546684fabe$export$2e2bcd8739ae039 = $22259d546684fabe$var$node;

});

parcelRegister("c3cNm", function(module, exports) {

let $8c5fb0b0a5e7b0e1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8c5fb0b0a5e7b0e1$var$load("jJS8Y").then(()=>parcelRequire('a6kDH'));

});




parcelRegister("kzcqd", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsKbRouteEntry", () => $55fac3162ba94854$export$caf568619a621961);

var $ffza4 = parcelRequire("ffza4");

var $cSD7y = parcelRequire("cSD7y");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $dZu6u = parcelRequire("dZu6u");

var $6Z2mh = parcelRequire("6Z2mh");

var $6gWZ1 = parcelRequire("6gWZ1");

var $81LME = parcelRequire("81LME");
const $55fac3162ba94854$export$caf568619a621961 = (0, $7NszV.createEntry)((0, $dZu6u.helpCenterSettingsKbRoute), ()=>({
        group: 'helpcenter-settings',
        perfMetricKey: 'help-center-settings.kb',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: $6gWZ1.navigation,
        component: (0, $cSD7y.componentWithFG)('jcs_master_flag', (0, $81LME.HelpCenterSettingsKnowledgeBase), (0, $5lsNZ.default)),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $81LME.LazyHelpCenterSettingsKnowledgeBase)
        ],
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            // TODO: https://jplat.jira.atlassian.cloud/browse/BERRY-2884
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ]
    }));

});
parcelRegister("dZu6u", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsKbRoute", () => $643da700cdb365a5$export$8a784299dc7faaff);
const $643da700cdb365a5$export$8a784299dc7faaff = {
    name: 'helpcenter-settings-kb',
    path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/kb',
    exact: true
};

});

parcelRegister("81LME", function(module, exports) {

$parcel$export(module.exports, "LazyHelpCenterSettingsKnowledgeBase", () => $d84b744908886ed8$export$92983043c677b1b1);
$parcel$export(module.exports, "HelpCenterSettingsKnowledgeBase", () => $d84b744908886ed8$export$c1d58cf9dc0a2ed3);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $d84b744908886ed8$export$92983043c677b1b1 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("jzAOh"))), {
    moduleId: "./src/packages/spa-apps/help-center-settings/knowledge-settings/src/index.tsx"
});
const $d84b744908886ed8$export$c1d58cf9dc0a2ed3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d84b744908886ed8$export$92983043c677b1b1,
        pageId: "help-center-settings-knowledge-base",
        shouldShowSpinner: true
    });

});
parcelRegister("jzAOh", function(module, exports) {

let $e3fdd6e7116660c3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e3fdd6e7116660c3$var$load("ffQaD"),
    $e3fdd6e7116660c3$var$load("kvRbA"),
    $e3fdd6e7116660c3$var$load("bVssC")
]).then(()=>parcelRequire('5bGBK'));

});



parcelRegister("lDuCa", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsServiceHubsRouteEntry", () => $17f669f9f746c53b$export$4afd756ea4d2cf7e);

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $5lsNZ = parcelRequire("5lsNZ");

var $3Y5jq = parcelRequire("3Y5jq");

var $85NOq = parcelRequire("85NOq");
const $17f669f9f746c53b$export$4afd756ea4d2cf7e = (0, $7NszV.createEntry)((0, $3Y5jq.helpCenterSettingsServiceHubsRoute), ()=>({
        group: 'customer-service',
        perfMetricKey: 'customer-service.service-hubs',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
        },
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('jcs_master_flag') ? (0, $85NOq.helpCenterSettingsServiceHubsRoutePageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ]
    }));

});
parcelRegister("3Y5jq", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsServiceHubsRoute", () => $ce6844775f881a62$export$16970f28ba5bfb66);
const $ce6844775f881a62$export$16970f28ba5bfb66 = {
    exact: true,
    name: 'customer-service-helpcenter',
    path: '/jira/helpcenter'
};

});

parcelRegister("85NOq", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsServiceHubsRoutePageEntryPoint", () => $ba28558a5bb4c0c7$export$3c1cef4845013f95);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $1yeSy = parcelRequire("1yeSy");
const $ba28558a5bb4c0c7$export$3c1cef4845013f95 = (0, $lkFvK.createPageEntryPoint)({
    main: $1yeSy.helpCenterSettingsServiceHubsAppEntryPoint,
    // TODO update to right menu id
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("1yeSy", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsServiceHubsAppEntryPoint", () => $0978151941bc8303$export$68ab0caf884fe346);

var $enqBA = parcelRequire("enqBA");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");
const $0978151941bc8303$var$NUMBER_OF_HELP_CENTERS_INITIAL_FETCH = 20;
const $0978151941bc8303$var$SORT_ORDER = 'CREATED_DATE_DESCENDING';

const $0978151941bc8303$export$68ab0caf884fe346 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("edxWT")), {
        moduleId: "c447b568"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        return {
            queries: {
                serviceHubsQuery: {
                    parameters: $enqBA.default,
                    variables: {
                        cloudId: cloudId,
                        workspaceAri: `ari:cloud:jira:${cloudId}:workspace/${activationId}`,
                        SORT_ORDER: $0978151941bc8303$var$SORT_ORDER,
                        NUMBER_OF_HELP_CENTERS_INITIAL_FETCH: $0978151941bc8303$var$NUMBER_OF_HELP_CENTERS_INITIAL_FETCH
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("enqBA", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3b56a15c10c4b45$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2bfa82f2d0823efdab8d51258393ace5>>
 * @relayHash 3e3a69d2c99a9c3c9ec567802fc52640
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3e0356e42e96d3adde2f74f099ff3e06573fc979ecc8bc591691d4221d6efc41
const $e3b56a15c10c4b45$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "3e0356e42e96d3adde2f74f099ff3e06573fc979ecc8bc591691d4221d6efc41",
        "metadata": {},
        "name": "srcCustomerServiceServiceHubsPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $e3b56a15c10c4b45$export$2e2bcd8739ae039 = $e3b56a15c10c4b45$var$node;

});

parcelRegister("edxWT", function(module, exports) {

let $a59c9d21500cfe92$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a59c9d21500cfe92$var$load("76n7a"),
    $a59c9d21500cfe92$var$load("l253H"),
    $a59c9d21500cfe92$var$load("dDk2I")
]).then(()=>parcelRequire('c7EOd'));

});




parcelRegister("duVOn", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsNotFoundRouteEntry", () => $16b9b96eb3704d99$export$2dced3f6d0a4894);

var $7NszV = parcelRequire("7NszV");

var $65gi0 = parcelRequire("65gi0");

var $6NkHq = parcelRequire("6NkHq");
const $16b9b96eb3704d99$export$2dced3f6d0a4894 = (0, $7NszV.createEntry)((0, $65gi0.helpCenterSettingsNotFoundRoute), ()=>({
        group: 'customer-service',
        component: (0, $6NkHq.NotFound)
    }));

});
parcelRegister("65gi0", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsNotFoundRoute", () => $a438def0ee4651b3$export$b6bc9dd96e9608e7);
const $a438def0ee4651b3$export$b6bc9dd96e9608e7 = {
    exact: false,
    name: 'customer-service-not-found',
    path: '/jira/helpcenter/:any'
};

});

parcelRegister("6NkHq", function(module, exports) {

$parcel$export(module.exports, "NotFound", () => $7f8c6894e16771dc$export$271f9f08425019c7);

var $5uXOq = parcelRequire("5uXOq");

var $beRD7 = parcelRequire("beRD7");

var $lODMY = parcelRequire("lODMY");

var $jcw0u = parcelRequire("jcw0u");
const $7f8c6894e16771dc$var$useLocation = (0, $lODMY.createRouterSelector)(({ location: location })=>location.pathname);
const $7f8c6894e16771dc$export$271f9f08425019c7 = ()=>{
    const pathname = $7f8c6894e16771dc$var$useLocation();
    (0, $5uXOq.useEffect)(()=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'serviceHubPageNotFound',
                packageName: 'jiraServicedeskCustomerServiceServiceHubs',
                teamName: 'boysenberry'
            },
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                pathname: pathname
            }
        });
    }, [
        pathname
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $beRD7.NotFoundErrorPageAsync), null);
};

});


parcelRegister("lVyEk", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAnalyticsRouteEntry", () => $ea9995db41d502d1$export$13d5cfdc3231d970);

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $5lsNZ = parcelRequire("5lsNZ");

var $6LApU = parcelRequire("6LApU");

var $6HgQO = parcelRequire("6HgQO");
const $ea9995db41d502d1$export$13d5cfdc3231d970 = (0, $7NszV.createEntry)((0, $6LApU.helpCenterSettingsAnalyticsRoute), ()=>({
        group: 'customer-service',
        perfMetricKey: 'customer-service.analytics',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
        },
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('jcs-analytics-page') ? (0, $6HgQO.helpCenterSettingsAnalyticsRoutePageEntryPoint) : undefined;
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ]
    }));

});
parcelRegister("6LApU", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAnalyticsRoute", () => $02d8dbaff147f01e$export$1487d4661960397f);
const $02d8dbaff147f01e$export$1487d4661960397f = {
    exact: true,
    name: 'customer-service-helpcenter-analytics',
    path: '/jira/helpcenter/analytics'
};

});

parcelRegister("6HgQO", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAnalyticsRoutePageEntryPoint", () => $44f12967ed405696$export$cb0b3a882806ef6e);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $6aw3i = parcelRequire("6aw3i");
const $44f12967ed405696$export$cb0b3a882806ef6e = (0, $lkFvK.createPageEntryPoint)({
    main: $6aw3i.helpCenterSettingsAnalyticsAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).HELP_CENTER_SETTINGS
});

});
parcelRegister("6aw3i", function(module, exports) {

$parcel$export(module.exports, "helpCenterSettingsAnalyticsAppEntryPoint", () => $0e5696f7f2194583$export$fa405dadb950b4a6);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $0e5696f7f2194583$export$fa405dadb950b4a6 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        if (!false) return (parcelRequire("beJM2"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "19032ae8"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("beJM2", function(module, exports) {

let $82e4823b046e7544$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $82e4823b046e7544$var$load("ffQaD"),
    $82e4823b046e7544$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("1Fg4H"), 4)),
    $82e4823b046e7544$var$load("fliVL"),
    $82e4823b046e7544$var$load("76n7a"),
    $82e4823b046e7544$var$load("l253H"),
    $82e4823b046e7544$var$load("8xMJk")
]).then(()=>parcelRequire('h1w7n'));

});




parcelRegister("h82Z7", function(module, exports) {

$parcel$export(module.exports, "homeOnboardingRedirectRouteEntry", () => $5e597886ba168534$export$2740cfaa979353b9);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $cHNCn = parcelRequire("cHNCn");

var $dzpo2 = parcelRequire("dzpo2");
const $5e597886ba168534$export$2740cfaa979353b9 = (0, $7NszV.createEntry)((0, $cHNCn.homeOnboardingRedirectRoute), ()=>({
        group: 'home',
        component: (0, $dzpo2.default),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        isRedirect: true,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("cHNCn", function(module, exports) {

$parcel$export(module.exports, "homeOnboardingRedirectRoute", () => $fc7d4480067c689f$export$2eaffde3ad991b33);
const $fc7d4480067c689f$export$2eaffde3ad991b33 = {
    name: 'home-onboarding-redirect',
    path: '/jira/your-work-onboarding',
    exact: true
};

});

parcelRegister("dzpo2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff7a191a114ce3ba$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5oFIy = parcelRequire("5oFIy");

var $lVJAU = parcelRequire("lVJAU");
/**
 * This component will cause an SPA transition (and overwrite of current history) to Your work or the Projects directory
 * depending on whether nav-v3, Your work's deep dive cards, and the JSW onboarding flows in Your work are enabled.
 */ const $ff7a191a114ce3ba$var$JiraHomeOnboardingRedirect = ()=>{
    const { replace: replace } = (0, $lVJAU.useRouterActions)();
    replace('/jira/your-work');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
        eventName: "JiraHomeOnboardingRedirect loaded",
        componentName: "JiraHomeOnboardingRedirect",
        attributes: {
            isRedirectionEnabled: true
        }
    });
};
var $ff7a191a114ce3ba$export$2e2bcd8739ae039 = $ff7a191a114ce3ba$var$JiraHomeOnboardingRedirect;

});


parcelRegister("9qXuz", function(module, exports) {

$parcel$export(module.exports, "homeRedirectRouteEntry", () => $f8b2ddb194f05043$export$5379c026da4201e6);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $7R6xY = parcelRequire("7R6xY");

var $crx5O = parcelRequire("crx5O");
const $f8b2ddb194f05043$export$5379c026da4201e6 = (0, $7NszV.createEntry)((0, $7R6xY.homeRedirectRoute), ()=>({
        group: 'home',
        component: (0, $crx5O.default),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        isRedirect: true,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("7R6xY", function(module, exports) {

$parcel$export(module.exports, "homeRedirectRoute", () => $d39d4562915d89ec$export$f7a252c9d61f8f94);
const $d39d4562915d89ec$export$f7a252c9d61f8f94 = {
    name: 'home-redirect',
    path: '/jira',
    exact: true
};

});

parcelRegister("crx5O", function(module, exports) {

$parcel$export(module.exports, "default", () => $92d7d72ca8393409$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dXRYE = parcelRequire("dXRYE");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$92d7d72ca8393409$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dXRYE.default), null);

});
parcelRegister("dXRYE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5a49877dbf7e167$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $2YZCu = parcelRequire("2YZCu");

var $9vlEn = parcelRequire("9vlEn");

var $7tQej = parcelRequire("7tQej");
var $2YP9W = parcelRequire("2YP9W");

const $e5a49877dbf7e167$var$JiraBaseRedirectWrapper = ()=>{
    (0, $gKZoD.di)(window);
    const { data: data, loading: loading } = (0, $2YP9W.useResource)((0, $9vlEn.userHomepageResource));
    (0, $5uXOq.useEffect)(()=>{
        if (!loading && data == null) (0, $2YZCu.default).safeInfoWithoutCustomerData((0, $2791311ae97b7f0a$export$25a759e49d5049db), 'userHomepage data is null');
    }, [
        loading,
        data
    ]);
    if (loading) return null;
    // redirect to monolith to handle "/jira" route if homepageData is null (should not happen)
    if (data == null) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.replace('/jira');
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: data.homepagePreference
    });
};
var $e5a49877dbf7e167$export$2e2bcd8739ae039 = $e5a49877dbf7e167$var$JiraBaseRedirectWrapper;

});
const $2791311ae97b7f0a$export$25a759e49d5049db = 'spa-apps.common.redirect.jira-base-routing';




parcelRegister("9MSQj", function(module, exports) {

$parcel$export(module.exports, "softwareIncidentsNextGenRouteEntry", () => $1e3d0627cbc31b1a$export$fd29243dbe4103);

var $e4eHl = parcelRequire("e4eHl");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $jAXrH = parcelRequire("jAXrH");

var $9LHPC = parcelRequire("9LHPC");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $hb1PV = parcelRequire("hb1PV");

var $BrpCW = parcelRequire("BrpCW");
const $1e3d0627cbc31b1a$export$fd29243dbe4103 = (0, $7NszV.createEntry)((0, $jAXrH.softwareIncidentsNextGenRoute), ()=>({
        group: 'software',
        entryPoint () {
            return (0, $4R6GH.fg)('corex_operandi_incidents_page_in_jira') ? (0, $hb1PV.entryPoint) : (0, $BrpCW.entryPointDeprecated);
        },
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        skeleton: (0, $9LHPC.IncidentsPageSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource),
            (0, $7GnDe.incidentsInitialPageChecksResource),
            (0, $7GnDe.incidentsCustomFieldIdResource)
        ],
        meta: {
            reporting: {
                id: 'software-incidents',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-incidents'),
                teamName: 'operandi'
            }
        },
        ufoName: 'software-incidents'
    }));

});
parcelRegister("jAXrH", function(module, exports) {

$parcel$export(module.exports, "softwareIncidentsNextGenRoute", () => $cf2d0aff779a466b$export$12e1ca6c7cfdfd49);
const $cf2d0aff779a466b$export$12e1ca6c7cfdfd49 = {
    name: 'software-incidents',
    path: '/jira/software/projects/:projectKey/incidents'
};

});

parcelRegister("9LHPC", function(module, exports) {

$parcel$export(module.exports, "IncidentsPageSkeleton", () => $cc84120449e592c1$export$3105d59d9ca899bd);
$parcel$export(module.exports, "IncidentsTableSkeleton", () => $cc84120449e592c1$export$7092b8ea63ebf9be);
/* IncidentsPageSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $c5GCJ = parcelRequire("c5GCJ");

var $6Hwnc = parcelRequire("6Hwnc");
const $cc84120449e592c1$var$incidentsPageSkeletonStyles = null;
const $cc84120449e592c1$var$incidentsTableSkeletonStyles = null;
const $cc84120449e592c1$export$3105d59d9ca899bd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "skeletons.ui.incidents-page.app-skeleton-image-incidents-page",
        className: (0, $bwpsq.default)([
            "_1bsb1x27 _4t3i1osq _ca0q1ejb _19bv1jfw _u5f31jfw _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c5GCJ)))
    }));
const $cc84120449e592c1$export$7092b8ea63ebf9be = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "skeletons.ui.incidents-page.app-skeleton-image-incidents-table",
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6Hwnc)))
    }));

});
parcelRegister("c5GCJ", function(module, exports) {
module.exports = new URL("incidents-page-app-skeleton.tpl.5b656159.svg", import.meta.url).toString();

});

parcelRegister("6Hwnc", function(module, exports) {
module.exports = new URL("incidents-page-table-skeleton.tpl.e8f337f1.svg", import.meta.url).toString();

});


parcelRegister("hb1PV", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $3b4ebee292145bb5$export$6333901e831d7af0);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $5En1O = parcelRequire("5En1O");

var $fo6b8 = parcelRequire("fo6b8");
const $3b4ebee292145bb5$export$6333901e831d7af0 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $5En1O.incidentsPageEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("5En1O", function(module, exports) {

$parcel$export(module.exports, "incidentsPageEntryPoint", () => $b9fe885d02827a63$export$a59477eea6e8cd7f);

var $2T5vx = parcelRequire("2T5vx");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");
const $b9fe885d02827a63$var$AriGraphSortOrderInput = {
    ASC: 'ASC',
    DESC: 'DESC'
};
const $b9fe885d02827a63$var$QUERY_PARAM_SEARCH = 'search';
const $b9fe885d02827a63$var$QUERY_PARAM_PRIORITY = 'priority';
const $b9fe885d02827a63$var$QUERY_PARAM_AFFECTED_SERVICE = 'affected-service';
const $b9fe885d02827a63$var$QUERY_PARAM_STATUS = 'status';
const $b9fe885d02827a63$var$QUERY_PARAM_SORT_BY = 'sortBy';
const $b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER = 'sortOrder';
const $b9fe885d02827a63$var$STATUS_SORT_KEY = 'status';
const $b9fe885d02827a63$var$CREATED_SORT_KEY = 'created';
const $b9fe885d02827a63$var$PRIORITY_SORT_KEY = 'priority';
const $b9fe885d02827a63$var$SUMMARY_SORT_KEY = 'key';
const $b9fe885d02827a63$var$ASC_SORT_KEY = 'ASC';
const $b9fe885d02827a63$var$DESC_SORT_KEY = 'DESC';
function $b9fe885d02827a63$var$notEmpty(value) {
    return Boolean(value);
}
const $b9fe885d02827a63$var$isPriority = $b9fe885d02827a63$var$notEmpty;
const $b9fe885d02827a63$var$isStatus = (val)=>val === 'resolved' || val === 'open';
const $b9fe885d02827a63$var$isSortBy = (val)=>val === $b9fe885d02827a63$var$STATUS_SORT_KEY || val === $b9fe885d02827a63$var$CREATED_SORT_KEY || val === $b9fe885d02827a63$var$PRIORITY_SORT_KEY || val === $b9fe885d02827a63$var$SUMMARY_SORT_KEY;
const $b9fe885d02827a63$var$isSortOrder = (val)=>val === $b9fe885d02827a63$var$ASC_SORT_KEY || val === $b9fe885d02827a63$var$DESC_SORT_KEY;
const $b9fe885d02827a63$var$isAffectedService = $b9fe885d02827a63$var$notEmpty;
function $b9fe885d02827a63$var$parseParameter(parameter, parameterValidationFn) {
    return parameter == null ? undefined : parameter.split(',').map((str)=>str.trim()).filter(parameterValidationFn);
}
const $b9fe885d02827a63$var$parseQueryParams = (paramsRaw)=>{
    const result = {
        [$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY]: paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY] && $b9fe885d02827a63$var$isSortBy(paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY]) ? paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY] : $b9fe885d02827a63$var$CREATED_SORT_KEY,
        [$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER]: paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER] && $b9fe885d02827a63$var$isSortOrder(paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER]) ? paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER] : $b9fe885d02827a63$var$DESC_SORT_KEY
    };
    result[$b9fe885d02827a63$var$QUERY_PARAM_AFFECTED_SERVICE] = $b9fe885d02827a63$var$parseParameter(paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_AFFECTED_SERVICE], $b9fe885d02827a63$var$isAffectedService);
    result[$b9fe885d02827a63$var$QUERY_PARAM_STATUS] = $b9fe885d02827a63$var$parseParameter(paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_STATUS], $b9fe885d02827a63$var$isStatus);
    result[$b9fe885d02827a63$var$QUERY_PARAM_SEARCH] = paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SEARCH] ?? undefined;
    result[$b9fe885d02827a63$var$QUERY_PARAM_PRIORITY] = $b9fe885d02827a63$var$parseParameter(paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_PRIORITY], $b9fe885d02827a63$var$isPriority);
    return result;
};
const $b9fe885d02827a63$var$getFilterValue = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
values)=>({
        ...values.length > 0 ? {
            is: values
        } : {}
    });
const $b9fe885d02827a63$var$parseStatusToFilterValues = (status)=>status.flatMap((stat)=>{
        switch(stat){
            case 'open':
                return [
                    'NEW',
                    'INDETERMINATE'
                ];
            case 'resolved':
                return [
                    'DONE'
                ];
            default:
                return [
                    'UNDEFINED'
                ];
        }
    });
const $b9fe885d02827a63$var$getGqlFiltersFromQueryParams = (parsedQueryParams)=>({
        and: [
            {
                to_status: $b9fe885d02827a63$var$getFilterValue($b9fe885d02827a63$var$parseStatusToFilterValues(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_STATUS] ?? [])),
                to_priority: $b9fe885d02827a63$var$getFilterValue(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_PRIORITY] ?? []),
                to_affectedServiceAris: $b9fe885d02827a63$var$getFilterValue(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_AFFECTED_SERVICE] ?? [])
            }
        ]
    });
const $b9fe885d02827a63$var$parseSortDirection = (maybeDirection, defaultValue)=>{
    switch(maybeDirection?.toUpperCase()){
        case $b9fe885d02827a63$var$AriGraphSortOrderInput.ASC.toUpperCase():
            return $b9fe885d02827a63$var$AriGraphSortOrderInput.ASC;
        case $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC.toUpperCase():
            return $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC;
        default:
            return defaultValue;
    }
};
const $b9fe885d02827a63$var$getSortValue = (sortOrder)=>({
        priority: 2,
        direction: $b9fe885d02827a63$var$parseSortDirection(sortOrder, $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC)
    });
// Added Inverse sort fn as data in AGS is indexed in reverse order for priority
const $b9fe885d02827a63$var$parseInverseSortDirection = (maybeDirection, defaultValue)=>{
    switch(maybeDirection?.toUpperCase()){
        case $b9fe885d02827a63$var$AriGraphSortOrderInput.ASC.toUpperCase():
            return $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC;
        case $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC.toUpperCase():
            return $b9fe885d02827a63$var$AriGraphSortOrderInput.ASC;
        default:
            return defaultValue;
    }
};
const $b9fe885d02827a63$var$getInverseSortValue = (sortOrder)=>({
        priority: 2,
        direction: $b9fe885d02827a63$var$parseInverseSortDirection(sortOrder, $b9fe885d02827a63$var$AriGraphSortOrderInput.ASC)
    });
const $b9fe885d02827a63$var$getGraphStoreSortFromQueryParams = (parsedQueryParams)=>({
        lastModified: {
            priority: 1,
            direction: $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC
        },
        ...$b9fe885d02827a63$var$STATUS_SORT_KEY === parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY] ? {
            to_status: $b9fe885d02827a63$var$getSortValue(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER])
        } : {},
        ...$b9fe885d02827a63$var$PRIORITY_SORT_KEY === parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY] ? {
            to_priority: $b9fe885d02827a63$var$getInverseSortValue(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER])
        } : {},
        ...$b9fe885d02827a63$var$CREATED_SORT_KEY === parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY] ? {
            createdAt: $b9fe885d02827a63$var$getSortValue(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER])
        } : {}
    });

const $b9fe885d02827a63$export$a59477eea6e8cd7f = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("lMrpD")).then((mod)=>mod.IncidentsPageWrapper), {
        moduleId: "5b8b4ff7"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId }, context: context })=>({
            queries: {
                incidentPageData: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $2T5vx.default,
                    variables: {
                        incidentPageSize: 30,
                        servicePageSize: 30,
                        cloudId: cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        filter: $b9fe885d02827a63$var$getGqlFiltersFromQueryParams($b9fe885d02827a63$var$parseQueryParams(context.query)),
                        sort: $b9fe885d02827a63$var$getGraphStoreSortFromQueryParams($b9fe885d02827a63$var$parseQueryParams(context.query)),
                        siteAri: `ari:cloud:jira::site/${cloudId}`
                    }
                }
            }
        })
});

});
parcelRegister("2T5vx", function(module, exports) {

$parcel$export(module.exports, "default", () => $58f54a3a0d651497$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<535af53561736a2d836fc81ae5b4bf2f>>
 * @relayHash ab315f9ffdcbe8bd8ba7b5de061e5649
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 46b09365c92c616fad0f3bc4329e6d2421389f9a3a81cc6bcfaa80c14a330137
const $58f54a3a0d651497$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "46b09365c92c616fad0f3bc4329e6d2421389f9a3a81cc6bcfaa80c14a330137",
        "metadata": {
            "connection": [
                {
                    "count": "servicePageSize",
                    "cursor": "after",
                    "direction": "forward",
                    "path": [
                        "jira",
                        "jiraProjectByKey",
                        "linkedOperationsComponentsByProject"
                    ]
                }
            ]
        },
        "name": "srcIncidentsPageInternalQuery",
        "operationKind": "query",
        "text": null
    }
};
var $58f54a3a0d651497$export$2e2bcd8739ae039 = $58f54a3a0d651497$var$node;

});

parcelRegister("lMrpD", function(module, exports) {

let $fdb358306daa83eb$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $fdb358306daa83eb$var$load("ffQaD"),
    $fdb358306daa83eb$var$load("kvRbA"),
    $fdb358306daa83eb$var$load("fCQQy")
]).then(()=>parcelRequire('cwNeR'));

});



parcelRegister("BrpCW", function(module, exports) {

$parcel$export(module.exports, "entryPointDeprecated", () => $b39c17e33fa0794a$export$821fec5ea5acc81d);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $eXpsd = parcelRequire("eXpsd");

var $fo6b8 = parcelRequire("fo6b8");
const $b39c17e33fa0794a$export$821fec5ea5acc81d = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $eXpsd.incidentsPageEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("eXpsd", function(module, exports) {

$parcel$export(module.exports, "incidentsPageEntryPoint", () => $b93c8ec26a3d236d$export$a59477eea6e8cd7f);

var $d23s9 = parcelRequire("d23s9");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $b93c8ec26a3d236d$export$a59477eea6e8cd7f = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("01s5Y")).then((mod)=>mod.IncidentsPageLinkedServicesWrapper), {
        moduleId: "d6132459"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId }, context: context })=>({
            queries: {
                incidentPageData: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $d23s9.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: context.match.params.projectKey ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("d23s9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2978738121ef6b5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7699704d0995bbdc63133dc84290d5de>>
 * @relayHash bf929c95e6738104436e6a3b1e6f48cd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8822ca061f1e1e9e11103925231d8d61251ca06c569e9da069f1b3faa1183aaf
const $d2978738121ef6b5$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "8822ca061f1e1e9e11103925231d8d61251ca06c569e9da069f1b3faa1183aaf",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": [
                        "jira",
                        "jiraProjectByKey",
                        "associatedComponents"
                    ]
                }
            ]
        },
        "name": "srcIncidentsLinkedServicesQuery",
        "operationKind": "query",
        "text": null
    }
};
var $d2978738121ef6b5$export$2e2bcd8739ae039 = $d2978738121ef6b5$var$node;

});

parcelRegister("01s5Y", function(module, exports) {

let $0045e33e605c1197$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0045e33e605c1197$var$load("ffQaD"),
    $0045e33e605c1197$var$load("kvRbA"),
    $0045e33e605c1197$var$load("7xTyk")
]).then(()=>parcelRequire('8c2Ir'));

});




parcelRegister("3HGg1", function(module, exports) {

$parcel$export(module.exports, "issueCreateEmbedRouteEntry", () => $f0855c0baf74da48$export$abd0bbe95839baf7);

var $5uXOq = parcelRequire("5uXOq");

var $6e4Kt = parcelRequire("6e4Kt");

var $7NszV = parcelRequire("7NszV");

var $2Ql51 = parcelRequire("2Ql51");

var $ell37 = parcelRequire("ell37");

var $9NiTW = parcelRequire("9NiTW");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");
const $f0855c0baf74da48$var$handleEmbedLinkClick = (e)=>{
    const eventTarget = e.target;
    // this is used for handling all the button clicks inside the iframe to open the new link in a new tab
    // as this view is mainly used an embed view inside an iframe.
    if (eventTarget && eventTarget instanceof HTMLAnchorElement && eventTarget.target !== '_blank') // link
    eventTarget.target = '_blank';
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f0855c0baf74da48$var$LazyIssueCreateEmbed = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("04Nyd")), {
    ssr: false,
    moduleId: "./src/packages/issue-create/issue-create-embed/src/index.tsx"
});
const $f0855c0baf74da48$var$IssueCreateEmbedLazy = ()=>{
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('click', $f0855c0baf74da48$var$handleEmbedLinkClick, true);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('click', $f0855c0baf74da48$var$handleEmbedLinkClick);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9NiTW.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f0855c0baf74da48$var$LazyIssueCreateEmbed,
        pageId: "spa-apps/issue-create-embed",
        shouldShowSpinner: true
    }));
};
const $f0855c0baf74da48$export$abd0bbe95839baf7 = (0, $7NszV.createEntry)((0, $ell37.issueCreateEmbedRoute), ()=>({
        group: 'issue',
        component: $f0855c0baf74da48$var$IssueCreateEmbedLazy,
        resources: [
            (0, $2Ql51.themePreferenceResource)
        ],
        layout: (0, $6e4Kt.chromelessLayout),
        forPaint: [
            $f0855c0baf74da48$var$LazyIssueCreateEmbed
        ]
    }));

});
parcelRegister("ell37", function(module, exports) {

$parcel$export(module.exports, "issueCreateEmbedRoute", () => $fcce99f65e838928$export$c155f4de16b62110);
const $fcce99f65e838928$export$c155f4de16b62110 = {
    name: 'issue-create-embed',
    path: '/jira/issues/create/embed'
};

});

parcelRegister("9NiTW", function(module, exports) {

$parcel$export(module.exports, "checkAuthentication", () => $ad297a7f2ce81084$export$b8dbb7d6029c5413);
$parcel$export(module.exports, "AuthenticationCheck", () => $ad297a7f2ce81084$export$e9b9096e887386fe);

var $5uXOq = parcelRequire("5uXOq");

var $9OXo1 = parcelRequire("9OXo1");

var $38Y30 = parcelRequire("38Y30");
const $ad297a7f2ce81084$export$b8dbb7d6029c5413 = (tenantContext)=>Boolean(tenantContext.atlassianAccountId);
const $ad297a7f2ce81084$export$e9b9096e887386fe = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        if ($ad297a7f2ce81084$export$b8dbb7d6029c5413(tenantContext)) return children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38Y30.RedirectToLoginPage), null);
    });

});

parcelRegister("04Nyd", function(module, exports) {

let $00e6cf97bc5c8f5d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $00e6cf97bc5c8f5d$var$load("3yAl4"),
    $00e6cf97bc5c8f5d$var$load("kNFvF"),
    $00e6cf97bc5c8f5d$var$load("ffQaD"),
    $00e6cf97bc5c8f5d$var$load("kvRbA"),
    $00e6cf97bc5c8f5d$var$load("fliVL"),
    $00e6cf97bc5c8f5d$var$load("76n7a"),
    $00e6cf97bc5c8f5d$var$load("l253H"),
    $00e6cf97bc5c8f5d$var$load("6PtIC")
]).then(()=>parcelRequire('5tdjr'));

});


parcelRegister("hkNW0", function(module, exports) {

$parcel$export(module.exports, "browseIssueEmbedRouteEntry", () => $c08486eb8ed505d7$export$e275b3ca0c6ccb5e);


var $6e4Kt = parcelRequire("6e4Kt");

var $e2ctp = parcelRequire("e2ctp");

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $8ZUng = parcelRequire("8ZUng");

var $9XjL6 = parcelRequire("9XjL6");

var $3RJkv = parcelRequire("3RJkv");

var $2Ql51 = parcelRequire("2Ql51");

var $fjoQ1 = parcelRequire("fjoQ1");

var $gRzZD = parcelRequire("gRzZD");

var $lb0Dk = parcelRequire("lb0Dk");

var $lAGdd = parcelRequire("lAGdd");

var $gNStA = parcelRequire("gNStA");

var $7bHMy = parcelRequire("7bHMy");

var $2dmpO = parcelRequire("2dmpO");
const $c08486eb8ed505d7$export$e275b3ca0c6ccb5e = (0, $7NszV.createEntry)((0, $fjoQ1.browseIssueEmbedRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'issue',
        preloadOptions: {
            earlyChunks: [
                'issue-app-early-entry'
            ]
        },
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY),
        component: (0, $2dmpO.IssueEmbedComponent),
        skeleton: (0, $lb0Dk.IssueViewSkeleton),
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            ...(0, $3RJkv.getModernIssueTransitionResources)(),
            ...(0, $2dmpO.getUnusedEmbedRouteResources)(),
            (0, $9XjL6.issueGiraDataResource),
            ...(0, $2dmpO.removeNonCritialGiraCallFromCriticalPath)(),
            (0, $2dmpO.conditionalForgeResource),
            (0, $8ZUng.issueViewRelayResource),
            (0, $gRzZD.workspaceResource),
            (0, $2Ql51.themePreferenceResource),
            (0, $2dmpO.conditionalSmartRepliesOptInStatusResources),
            (0, $lAGdd.aiContextPanelResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jira-project-isglobalcomponent-route-resource'), (0, $7bHMy.projectGlobalComponentsResource))
        ],
        forPaint: [
            (0, $2dmpO.LazyIssuePage)
        ],
        ufoName: 'issue-view-embed',
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$ef94a84e2990361c)
        },
        bifrost: {
            bifrostGroup: 'issue-view',
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-entries/src/browseIssueEmbedRouteEntry.tsx',
                whichExportToUse: 'browseIssueEmbedRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-issue-view.json'
        }
    }));

});
parcelRegister("8ZUng", function(module, exports) {

$parcel$export(module.exports, "issueViewRelayResource", () => $e05b8d0e5bf08042$export$55131006e6699c0a);
$parcel$export(module.exports, "useIssueViewRelayRouteResource", () => $e05b8d0e5bf08042$export$252bdba8c8e5f066);

var $hnYwO = parcelRequire("hnYwO");

var $k3PbQ = parcelRequire("k3PbQ");

var $6yLM4 = parcelRequire("6yLM4");

var $ao2h1 = parcelRequire("ao2h1");

var $la3vp = parcelRequire("la3vp");

var $2Yhep = parcelRequire("2Yhep");

var $gNStA = parcelRequire("gNStA");


var $6s1PB = parcelRequire("6s1PB");

var $5XgeZ = parcelRequire("5XgeZ");
const $e05b8d0e5bf08042$export$55131006e6699c0a = (0, $gNStA.browserOnlyResourceWithCondition)(()=>{
    if (0, $cdb023d06c7f62fa$export$19d68f5aa485d903) // not "browser only" if FF is on
    return !(0, $6s1PB.expVal)('issue_view_ssr_perf_m2', 'isEnabled', false);
    return true;
}, (0, $5XgeZ.createRelayResourceDeprecated)({
    type: 'ISSUE_RELAY_DATA',
    isBrowserOnly: true,
    captureErrors: true,
    captureTraceIds: !false,
    getQuery: (routerContext, { tenantContext: { cloudId: cloudId } })=>{
        const { match: match } = routerContext;
        const issueKey = (0, $2Yhep.getIssueKey)(match);
        const siteAri = (0, $hnYwO.JiraSiteAri).create({
            siteId: cloudId
        }).toString();
        const projectKey = issueKey ? (0, $k3PbQ.extractProjectKey)(issueKey) : '';
        const queryVariables = {
            cloudId: cloudId,
            issueKey: issueKey || '',
            projectKey: projectKey,
            siteAri: siteAri
        };
        return {
            parameters: (0, $la3vp.default),
            variables: {
                ...queryVariables,
                ...(0, $6yLM4.getMainIssueViewAggQueryVariables)(issueKey)
            },
            // Pass over the variables that actually would trigger a reload when they are changed=
            keyVariables: {
                ...queryVariables,
                ...(0, $6yLM4.getMainIssueViewAggQueryFeatureFlagVariables)()
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
}));
const $e05b8d0e5bf08042$export$252bdba8c8e5f066 = (options)=>(0, $ao2h1.useRelayResource)($e05b8d0e5bf08042$export$55131006e6699c0a, options);

});
parcelRegister("hnYwO", function(module, exports) {

$parcel$export(module.exports, "JiraSiteAri", () => $ca83894601a84634$export$6c0f81f222d09301);

var $gQC3n = parcelRequire("gQC3n");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/site/manifest.ts
var $ca83894601a84634$var$jiraSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $gQC3n.JiraSiteAriResourceOwner),
    resourceType: (0, $gQC3n.JiraSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/jira/site/index.ts
var $ca83894601a84634$export$6c0f81f222d09301 = class _JiraSiteAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.resourceIdSegmentValues.siteId;
    }
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $ca83894601a84634$var$jiraSiteAriStaticOpts.qualifier,
            platformQualifier: $ca83894601a84634$var$jiraSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $ca83894601a84634$var$jiraSiteAriStaticOpts.resourceOwner,
            resourceType: $ca83894601a84634$var$jiraSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $ca83894601a84634$var$jiraSiteAriStaticOpts);
        return new _JiraSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $ca83894601a84634$var$jiraSiteAriStaticOpts);
        return new _JiraSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
};

});
parcelRegister("gQC3n", function(module, exports) {

$parcel$export(module.exports, "JiraSiteAriResourceOwner", () => $032a4e897fcecef5$export$b7d590981b504412);
$parcel$export(module.exports, "JiraSiteAriResourceType", () => $032a4e897fcecef5$export$886165a991f21644);
// src/jira/site/types.ts
var $032a4e897fcecef5$export$b7d590981b504412 = "jira", $032a4e897fcecef5$export$886165a991f21644 = "site";

});


parcelRegister("6yLM4", function(module, exports) {

$parcel$export(module.exports, "getMainIssueViewAggQueryFeatureFlagVariables", () => $bbb83ac7c9853fc8$export$3dd406718c5846c6);
$parcel$export(module.exports, "getMainIssueViewAggQueryVariables", () => $bbb83ac7c9853fc8$export$5896c8dc13246fe2);
/**
 * @fileOverview
 * All variables that get passed in to the mainIssueAggQuery are defined here.
 * The abstraction is necessary because there are multiple call paths to mainIssueAggQuery,
 * so having a single source of truth for the variables eliminates a vector for
 * bugs and inconsistencies when they are invoked.
 *
 * This file will be removed (and therefore the need for the linting exemption) once we reduce
 * the number of discrete call paths for mainIssueAggQuery to one. That work will be done in
 * https://jira.atlassian.com/browse/JIV-19486.
 *
 * Sorry, Tom.
 *
 * <3 Daz
 */ /* eslint-disable jira/ff/inline-usage */ 
var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $5CSGy = parcelRequire("5CSGy");


var $ldyPw = parcelRequire("ldyPw");

var $lpLR9 = parcelRequire("lpLR9");

var $j8DrX = parcelRequire("j8DrX");

var $la3vp = parcelRequire("la3vp");

var $k2DRb = parcelRequire("k2DRb");

var $6tI1D = parcelRequire("6tI1D");
const $bbb83ac7c9853fc8$export$623cfa88de62fcd = ()=>{
    const providerVariables = (0, $la3vp.default)?.params?.providedVariables ?? {};
    return Object.entries(providerVariables).reduce((acc, [key, provider])=>{
        acc[key] = provider.get();
        return acc;
    }, {});
};
const $bbb83ac7c9853fc8$export$3dd406718c5846c6 = ()=>({
        isCompassComponentsEnabled: true,
        issueViewRelayConfigurationUrlFlag: (0, $4R6GH.fg)('jiv-replace-configuration-button-in-context-panel'),
        jsmSentimentCustomFieldFlag: true,
        isJPDPanelEnabled: (0, $4R6GH.fg)('jpd_idea_panel_in_issue_view'),
        isDiscoverIdeasRelayMigrationEnabled: (0, $4R6GH.fg)('discover_ideas_relay_migration'),
        issueViewRelayPriorityFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-priority'),
        issueViewRelayNumberFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-number'),
        issueViewRelayAttachmentsFlag: (0, $4R6GH.fg)('relay-migration-issue-view-attachments-'),
        issueViewRelayResolutionFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-resolution'),
        issueViewRelayParentFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-header-and-parent'),
        issueViewRelayMetadataFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-metadata'),
        issueViewDesignsPanelFlag: (0, $6s1PB.expVal)('collapsed_designs_panel', 'isCollapsedDesignsPanelEnabled', false),
        issueViewDesignsPanelProvidersFlag: (0, $4R6GH.fg)('only_show_designs_panel_with_design_providers'),
        isJPDDeliveryLinkTypeFilteringEnabled: (0, $4R6GH.fg)('jpd_idea_panel_in_issue_view'),
        issueViewRemoveCheckboxSelectFieldOptionsFlag: (0, $4R6GH.fg)('remove_issue_field_options_main_query'),
        issueViewRelaySummaryFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-summary'),
        issueViewRelayColorFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-color'),
        issueViewRelayHeaders: (0, $4R6GH.fg)('relay-migration-issue-header-and-parent'),
        issueViewRelayTimeTrackingFieldFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-time-tracking'),
        issueViewRemoveRadioSelectFieldOptionsFlag: (0, $4R6GH.fg)('relay-migration-issue-fields-radio'),
        customFieldConfigurationFlag: (0, $4R6GH.fg)('issue_view_field_config_edit'),
        isPinFieldConfigurabilityEnabled: true,
        jcsFlag: (0, $4R6GH.fg)('jcs_master_flag'),
        issueViewSmartRepliesSettingsFlag: (0, $4R6GH.fg)('smart-replies-system-setting') ?? false,
        isProactiveCommentSummaryPreferenceEnabled: (0, $4R6GH.fg)('proactive_comment_summary_feature_toggle'),
        crossflowBannerDismissedInAggFlag: (0, $4R6GH.fg)('jiv-19897-move-user-prefs-to-mainissueagg'),
        dateFieldsMessageEnabled: (0, $6s1PB.expValEquals)('jsw_start_and_due_dates', 'cohort', 'variation'),
        chinEmbedQueryToAgg: (0, $4R6GH.fg)('issue-jiv-19838-chin-api-lookup-through-issue-key'),
        issueViewActivityLayoutFieldEnabled: (0, $6s1PB.expVal)('issue-view-side-panel-activity', 'isActivityInSidePanel', false),
        issueViewCollapsibleSectionsFieldEnabled: (0, $6s1PB.expVal)('collapsible_sections_in_issue_view', 'isCollapsibleSectionsEnabled', false),
        issueViewUserPreferredLayoutFieldEnabled: (0, $6s1PB.expVal)('wide_issue_layout_in_issue_view', 'is_enabled', false),
        issueViewDetailsPanelFieldsReorderingEnabled: (0, $6s1PB.expVal)('issue_view_field_reordering_in_context_panel', 'isReorderingFieldsEnabled', false),
        userThemePrefsInAggEnabled: (0, $4R6GH.fg)('custom-nav-theme-preferences-to-mainissueagg'),
        issueViewRedactionExperience: // eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4R6GH.fg)('enable_redaction_support_in_jira_issue_view') && (0, $4R6GH.fg)('jiv-replace-configuration-button-in-context-panel') && (0, $4R6GH.fg)('relay-migration-issue-header-and-parent'),
        issueViewCoverExperimentEnabled: (0, $6s1PB.expVal)('cover-image-issue-view-experiment', 'isSharedCoverEnabled', false) || (0, $6s1PB.expVal)('cover-image-issue-view-experiment', 'isMiddleCoverEnabled', false),
        isPlaybooksEnabled: (0, $4R6GH.fg)('playbook_in_jsm_ga'),
        isPlaybooksEnabledForSpecificType: (0, $4R6GH.fg)('playbook_visibility_in_service_request'),
        assignToMeUserPreloaded: (0, $4R6GH.fg)('assign-to-me-user-preloaded-in-issue-view'),
        isAutomationDiscoverabilityEnabled: (0, $4R6GH.fg)('automation_discoverability_in_jsm'),
        issueViewCodePlannerPanelEnabled: (0, $4R6GH.fg)('devai-code-planner-issue-view-panel'),
        issueViewChildIssuesPanelPerformance: (0, $6s1PB.expVal)('jira-issue-view-chin-m2-performance', 'isIssueSearchAPIEnabled', false),
        mentionedConfluencePageLinksV2PaginationFlag: // eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4R6GH.fg)('jsw_issue_view_placeholder_template_v2') && (0, $4R6GH.fg)('jiv-19125-fetch-remote-links-in-interactive-query'),
        mentionedConfluencePageLinksPaginationFlag: !(0, $4R6GH.fg)('jsw_issue_view_placeholder_template_v2') && (0, $4R6GH.fg)('jiv-19125-fetch-remote-links-in-interactive-query'),
        linkedWorkItemsTableEnabled: (0, $4R6GH.fg)('jira-linked-work-items-table-kill-switch'),
        issueViewCommentAvatarFlag: (0, $4R6GH.fg)('relay-avatar-iv-llc-comments'),
        excludeRedundantNavigationMetadata: (0, $4R6GH.fg)('jiv-20833-remove-navmeta-when-not-needed'),
        issueViewSlackSyncInfoEnabled: (0, $4R6GH.fg)('jira_issue_view_show_slack_sync_info')
    });
// JIV-19906: retrieve query string from URL -- only expected to be used by client side code
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $bbb83ac7c9853fc8$var$getURLFromWindow = ()=>new URL(window.location.href);
const $bbb83ac7c9853fc8$export$5896c8dc13246fe2 = (issueKey, url = $bbb83ac7c9853fc8$var$getURLFromWindow())=>({
        ...$bbb83ac7c9853fc8$export$623cfa88de62fcd(),
        ...$bbb83ac7c9853fc8$export$3dd406718c5846c6(),
        ...(0, $4R6GH.fg)('jiv-19906-fix-targered-permalink-on-server') ? $bbb83ac7c9853fc8$export$e2c3bddbfc195841(url) : $bbb83ac7c9853fc8$export$afa6e4ae995b8926(),
        ...$bbb83ac7c9853fc8$var$getStorageBannerVariables(),
        ...$bbb83ac7c9853fc8$var$getIssueSearchForChildIssueQueryVariables(issueKey),
        ...$bbb83ac7c9853fc8$var$getForgeSpecificVariables(),
        ...$bbb83ac7c9853fc8$var$getIsFromSoftwareCalendarOrTimelineViewQueryVariables(),
        ...$bbb83ac7c9853fc8$var$getLinkedIssuesTableQueryVariables(issueKey)
    });
const $bbb83ac7c9853fc8$var$getIsFromSoftwareCalendarOrTimelineViewQueryVariables = ()=>{
    if ((0, $6s1PB.expValEquals)('jsw_start_and_due_dates', 'cohort', 'variation')) {
        if (typeof window !== 'undefined') {
            const pathname = window.location.pathname;
            const pattern = /^\/jira\/software(?:\/c)?\/projects\/[^/]+\/boards\/\d+\/(calendar|timeline)$/;
            return {
                isInTimelineOrCalendarView: pattern.test(pathname)
            };
        }
    }
    return {
        isInTimelineOrCalendarView: false
    };
};
const $bbb83ac7c9853fc8$var$getChildIssuesFieldIdsQueryVariables = ()=>{
    /**
	 * Default fields we're fetching in child issues:
	 * - issuetype: Used to separate base-level and subtasks in epics (see `jira-issue-view-child-issues-panel-merge-subtasks`)
	 */ const childIssuesFieldIds = [
        'issuetype'
    ];
    // If we're not fetching the "Include subtasks" timetracking data through Relay
    // include it in `mainIssueAggQuery` so it can be derived from Redux
    if (!(0, $4R6GH.fg)('relay-migration-edit-worklog')) childIssuesFieldIds.push('timetracking');
    // If we're not fetching the progress summary status data through Relay,
    // include it in `mainIssueAggQuery` so it can be derived from Redux
    if (!(0, $4R6GH.fg)('issue-jiv-20335-relay-progress-summary')) childIssuesFieldIds.push('status');
    // Include unused fields
    if (!(0, $6s1PB.expVal)('jira-issue-view-chin-m2-performance', 'isIssueSearchAPIEnabled', false)) childIssuesFieldIds.push('assignee', 'created', 'priority', 'summary', 'updated');
    return childIssuesFieldIds;
};
const $bbb83ac7c9853fc8$var$getIssueSearchForChildIssueQueryVariables = (issueKey)=>({
        // will have to put jql order by rank later
        issueSearchInput: {
            childIssuesInput: {
                parentIssueKey: issueKey || ''
            }
        },
        amountOfColumns: 500,
        namespace: 'CHILD_ISSUE_PANEL',
        fieldSetIds: [],
        shouldQueryFieldSetsById: false,
        fieldSetsInput: {
            viewInput: {
                namespace: 'CHILD_ISSUE_PANEL',
                context: {
                    issueContext: {
                        issueKey: issueKey
                    }
                }
            }
        },
        fieldSetsContext: {
            issueContext: {
                issueKey: issueKey
            }
        },
        filterId: null,
        viewId: null,
        childIssuesFieldIds: $bbb83ac7c9853fc8$var$getChildIssuesFieldIdsQueryVariables()
    });
const $bbb83ac7c9853fc8$var$getLinkedIssuesTableQueryVariables = (issueKey)=>({
        linkedIssuesSearchInput: {
            jql: `issue in linkedIssues(${issueKey})`
        }
    });
const $bbb83ac7c9853fc8$export$afa6e4ae995b8926 = ()=>{
    const commentTargetId = (0, $6tI1D.getPermalinkId)((0, $6tI1D.COMMENTS)) || null;
    return {
        commentTargetId: commentTargetId,
        hasCommentTargetId: !!commentTargetId
    };
};
const $bbb83ac7c9853fc8$export$e2c3bddbfc195841 = (url)=>{
    let commentTargetId = null;
    if ((0, $4R6GH.fg)('jiv-19906-fix-targered-permalink-on-server')) commentTargetId = (0, $6tI1D.getPermalinkIdFromURL)((0, $6tI1D.COMMENTS), url);
    else commentTargetId = (0, $6tI1D.getPermalinkId)((0, $6tI1D.COMMENTS));
    return {
        commentTargetId: commentTargetId,
        hasCommentTargetId: !!commentTargetId
    };
};
const $bbb83ac7c9853fc8$var$getStorageBannerVariables = ()=>({
        issueViewStorageLimitsBannerFlag: (0, $lpLR9.default)((0, $j8DrX.default)).software === (0, $ldyPw.FREE_EDITION) && (0, $4R6GH.fg)('move_storage_banner_data_fetch_to_main_issue_agg'),
        offeringKey: (0, $5CSGy.getProductOfferingKeyOrThrow)((0, $c06e1abca7c13910$export$1346c9aa3cbb477d), (0, $ldyPw.STANDARD_EDITION)),
        productKey: (0, $c06e1abca7c13910$export$1346c9aa3cbb477d)
    });
const $bbb83ac7c9853fc8$var$getForgeSpecificVariables = ()=>{
    return {
        forgeInMainIssueAggFlag: (0, $4R6GH.fg)('move_forge_data_fetch_to_main_issue_agg'),
        forgeTypes: (0, $4R6GH.fg)('move_forge_data_fetch_to_main_issue_agg') ? [
            (0, $k2DRb.ISSUE_ACTION_MODULE),
            (0, $k2DRb.ISSUE_GLANCE_MODULE),
            (0, $k2DRb.ISSUE_CONTEXT_MODULE),
            (0, $k2DRb.ISSUE_PANEL_MODULE),
            (0, $k2DRb.ISSUE_ACTIVITY_MODULE),
            (0, $k2DRb.CUSTOM_FIELD_MODULE),
            (0, $k2DRb.CUSTOM_FIELD_TYPE_MODULE),
            (0, $k2DRb.ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE),
            (0, $k2DRb.UI_MODIFICATIONS_MODULE)
        ] : [],
        includeUserAccessForge: (0, $4R6GH.fg)('forge_query_include_user_access'),
        includeUserAccessEnabledForge: (0, $4R6GH.fg)('forge_query_include_user_access_enabled')
    };
};

});
parcelRegister("5CSGy", function(module, exports) {

$parcel$export(module.exports, "getProductOfferingKeyForProject", () => $75290a6120824a25$export$3ad43d25ded909ee);
$parcel$export(module.exports, "getProductOfferingKeyOrThrow", () => $75290a6120824a25$export$92c311d982d129d5);


var $1laI5 = parcelRequire("1laI5");
// Please don't use access these directly, try to implement these using common platform types such as below
const $75290a6120824a25$var$JSW_PRODUCT_OFFERING_KEYS = {
    FREE_EDITION: 'de2887c9-8a55-41d5-b5cf-ad6a5589ebed',
    STANDARD_EDITION: 'a70b5cbb-1ae1-4003-8f4a-9001a4a50526',
    PREMIUM_EDITION: '6dd805b4-da75-4374-a7a7-cf0b12f7ea07',
    UNLICENSED: null
};
const $75290a6120824a25$var$JPD_PRODUCT_OFFERING_KEYS = {
    FREE_EDITION: 'd843dd9e-23c5-4d27-af44-5009d568cb6e',
    STANDARD_EDITION: '35b9268e-66e2-45fb-81d3-dacd1e31831a',
    PREMIUM_EDITION: 'f0b24ca7-c3d8-4cac-b5ed-60f4152d4dcd',
    UNLICENSED: null
};
const $75290a6120824a25$var$JSM_PRODUCT_OFFERING_KEYS = {
    FREE_EDITION: '24656f1f-5c14-45ea-88ea-142b9c633661',
    STANDARD_EDITION: '99bcbf6c-4fff-4a45-8303-a854e7fbd17c',
    PREMIUM_EDITION: '0c6683b4-4633-4673-beca-690d171de6a5',
    UNLICENSED: null
};
const $75290a6120824a25$export$581b2a05d59c1826 = (applicationKey, applicationEdition)=>{
    switch(applicationKey){
        case 0, $c06e1abca7c13910$export$1346c9aa3cbb477d:
            return $75290a6120824a25$var$JSW_PRODUCT_OFFERING_KEYS[applicationEdition];
        case 0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61:
            return $75290a6120824a25$var$JSM_PRODUCT_OFFERING_KEYS[applicationEdition];
        case 0, $c06e1abca7c13910$export$202f50ee62667e32:
            return $75290a6120824a25$var$JPD_PRODUCT_OFFERING_KEYS[applicationEdition];
        // can support more products if implemented in future
        default:
            return null;
    }
};
const $75290a6120824a25$export$3ad43d25ded909ee = (project, edition)=>{
    const application = (0, $1laI5.projectToApplicationKey)(project);
    const offeringKey = $75290a6120824a25$export$581b2a05d59c1826(application, edition);
    if (offeringKey === null) throw new Error(`Missing offering key for: ${application} ${edition}`);
    return offeringKey;
};
const $75290a6120824a25$export$92c311d982d129d5 = (applicationKey, applicationEdition)=>{
    const offeringKey = $75290a6120824a25$export$581b2a05d59c1826(applicationKey, applicationEdition);
    if (offeringKey === null) throw new Error(`Missing offering key for: ${applicationKey} ${applicationEdition}`);
    return offeringKey;
};

});
const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';


parcelRegister("la3vp", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d1e3365ed212162$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f540c4c3b17f9c15fc4b7ba8419709eb>>
 * @relayHash 6f8c2964314d72f0c4e9873daf86cb2f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 40babb0ad27fb0ba56c15f6d7139d85e03c3ad3fcfb3b0ad17ceeac69721244e

var $beHGE = parcelRequire("beHGE");

var $fjldt = parcelRequire("fjldt");

var $gY76A = parcelRequire("gY76A");

var $5oQtH = parcelRequire("5oQtH");

var $5ykrX = parcelRequire("5ykrX");

var $ggSVP = parcelRequire("ggSVP");

var $iMyvd = parcelRequire("iMyvd");

var $2pNN7 = parcelRequire("2pNN7");

var $5FIjM = parcelRequire("5FIjM");

var $knfEI = parcelRequire("knfEI");

var $5qm7M = parcelRequire("5qm7M");

var $l8ssf = parcelRequire("l8ssf");

var $dttgK = parcelRequire("dttgK");

var $adKYy = parcelRequire("adKYy");

var $eq0sU = parcelRequire("eq0sU");

var $iLxt4 = parcelRequire("iLxt4");

var $ju8GE = parcelRequire("ju8GE");

var $5YQLv = parcelRequire("5YQLv");

var $hBTVA = parcelRequire("hBTVA");

var $9OzGv = parcelRequire("9OzGv");

var $h6nNu = parcelRequire("h6nNu");

var $5pSyb = parcelRequire("5pSyb");

var $cKVMM = parcelRequire("cKVMM");

var $5mEVc = parcelRequire("5mEVc");

var $ef20f = parcelRequire("ef20f");

var $84KW9 = parcelRequire("84KW9");

var $kT0rw = parcelRequire("kT0rw");

var $d6bux = parcelRequire("d6bux");

var $hjJTo = parcelRequire("hjJTo");

var $krohK = parcelRequire("krohK");

var $6NR1m = parcelRequire("6NR1m");

var $3E2yq = parcelRequire("3E2yq");

var $fmbEw = parcelRequire("fmbEw");

var $hSNvs = parcelRequire("hSNvs");

var $jwLjt = parcelRequire("jwLjt");

var $8Y9hN = parcelRequire("8Y9hN");

var $ejqaS = parcelRequire("ejqaS");

var $eXeEx = parcelRequire("eXeEx");

var $hBvdF = parcelRequire("hBvdF");
const $7d1e3365ed212162$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "40babb0ad27fb0ba56c15f6d7139d85e03c3ad3fcfb3b0ad17ceeac69721244e",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "forward",
                    "path": [
                        "jira",
                        "issueByKey",
                        "attachments"
                    ]
                }
            ]
        },
        "name": "mainIssueAggQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationconfigurationurlrelayprovider": (0, $5YQLv.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewredactionexperiencerelayprovider": (0, $5FIjM.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldstimetrackingperfrelayprovider": (0, $jwLjt.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscustomfieldconfigrelayprovider": (0, $h6nNu.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsparent": (0, $d6bux.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldstimetrackingrelayprovider": (0, $8Y9hN.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscheckboxselectrelayprovider": (0, $9OzGv.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsoriginalestimaterelayprovider": (0, $kT0rw.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsgrouppickerrelayprovider": (0, $5pSyb.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsmultigrouppickerrelayprovider": (0, $84KW9.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsradioselectrelayprovider": (0, $hjJTo.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsrichtextrelayprovider": (0, $6NR1m.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsassigneerelayprovider": (0, $hBTVA.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $knfEI.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsheaderactionsrelayprovider": (0, $cKVMM.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldswatchersrelayprovider": (0, $eXeEx.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldssecuritylevelrelayprovider": (0, $3E2yq.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsvotesrelayprovider": (0, $ejqaS.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsissuerestrictionsrelayprovider": (0, $5mEVc.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcconcealitemsintomeatballmenuexperimentrelayprovidertsx": (0, $beHGE.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsissuetypeswitcherrelayprovider": (0, $ef20f.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsresolutionrelayprovider": (0, $krohK.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsstatusrelayprovider": (0, $hSNvs.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsstatuspanelrelayprovider": (0, $fmbEw.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrconeeventimprovementsenabledrelayprovider": (0, $ju8GE.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider": (0, $iMyvd.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcmagma3191renderchinskeletoninssrrelayprovider": (0, $eq0sU.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchinm2performanceisissuesearchapienabledrelayprovider": (0, $2pNN7.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": (0, $5oQtH.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $dttgK.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $adKYy.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $fjldt.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": (0, $iLxt4.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $l8ssf.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": (0, $5ykrX.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $ggSVP.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $gY76A.default)
        }
    }
};
var $7d1e3365ed212162$export$2e2bcd8739ae039 = $7d1e3365ed212162$var$node;

});
parcelRegister("beHGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e77216947a3d05a6$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $e77216947a3d05a6$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('conceal_items_in_meatball_menu_ga_fg');
    }
};

});

parcelRegister("iMyvd", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccd515d7ae24a1bd$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $ccd515d7ae24a1bd$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jira-issue-view-child-issues-panel-realtime-update');
    }
};

});

parcelRegister("2pNN7", function(module, exports) {

$parcel$export(module.exports, "default", () => $c317a5429c553fb0$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");
var $c317a5429c553fb0$export$2e2bcd8739ae039 = {
    get () {
        return (0, $6s1PB.expVal)('jira-issue-view-chin-m2-performance', 'isIssueSearchAPIEnabled', false);
    }
};

});

parcelRegister("5FIjM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c20c48eec5732675$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $c20c48eec5732675$export$2e2bcd8739ae039 = {
    get () {
        return(// eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4R6GH.fg)('enable_redaction_support_in_jira_issue_view') && (0, $4R6GH.fg)('jiv-replace-configuration-button-in-context-panel') && (0, $4R6GH.fg)('relay-migration-issue-header-and-parent'));
    }
};

});

parcelRegister("eq0sU", function(module, exports) {

$parcel$export(module.exports, "default", () => $475f45f039da3c7a$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $475f45f039da3c7a$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('magma-3191-render-chin-skeleton-in-ssr');
    }
};

});

parcelRegister("ju8GE", function(module, exports) {

$parcel$export(module.exports, "default", () => $f22f95d64a2848da$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $f22f95d64a2848da$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('one_event_improvements_1');
    }
};

});

parcelRegister("5YQLv", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cc7b1249165c5cc$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $8cc7b1249165c5cc$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jiv-replace-configuration-button-in-context-panel');
    }
};

});

parcelRegister("hBTVA", function(module, exports) {

$parcel$export(module.exports, "default", () => $317518afb86d429d$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $317518afb86d429d$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-assignee-fg');
    }
};

});

parcelRegister("9OzGv", function(module, exports) {

$parcel$export(module.exports, "default", () => $68a7d680b4f7aa31$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $68a7d680b4f7aa31$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-checkbox-select');
    }
};

});

parcelRegister("h6nNu", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ea05c28112074d6$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
const $4ea05c28112074d6$var$isIssueViewFieldConfigEditEnabled = {
    get () {
        return (0, $4R6GH.fg)('issue_view_field_config_edit');
    }
};
var $4ea05c28112074d6$export$2e2bcd8739ae039 = $4ea05c28112074d6$var$isIssueViewFieldConfigEditEnabled;

});

parcelRegister("5pSyb", function(module, exports) {

$parcel$export(module.exports, "default", () => $46b71e3be8dfea7a$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $46b71e3be8dfea7a$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-group-picker-sg');
    }
};

});

parcelRegister("cKVMM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7153ac791d0f4b40$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $7153ac791d0f4b40$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-header-and-parent');
    }
};

});

parcelRegister("5mEVc", function(module, exports) {

$parcel$export(module.exports, "default", () => $dba981d8b012adb8$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $dba981d8b012adb8$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-header-and-parent');
    }
};

});

parcelRegister("ef20f", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dac75eea754d44b$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $5dac75eea754d44b$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-header-and-parent');
    }
};

});

parcelRegister("84KW9", function(module, exports) {

$parcel$export(module.exports, "default", () => $78c1aa824cd21c11$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $78c1aa824cd21c11$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-multi-group-picker-fg');
    }
};

});

parcelRegister("kT0rw", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cdff8c37120a188$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $4cdff8c37120a188$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-original-estimate');
    }
};

});

parcelRegister("d6bux", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d9e6f2a33f8172f$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4d9e6f2a33f8172f$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-header-and-parent');
    }
};

});

parcelRegister("hjJTo", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8a929bbaac9d588$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $c8a929bbaac9d588$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-radio');
    }
};

});

parcelRegister("krohK", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ee92d752c596813$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $7ee92d752c596813$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-resolution');
    }
};

});

parcelRegister("6NR1m", function(module, exports) {

$parcel$export(module.exports, "default", () => $851058f7192cd7ee$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $851058f7192cd7ee$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-multi-line-text-fg');
    }
};

});

parcelRegister("3E2yq", function(module, exports) {

$parcel$export(module.exports, "default", () => $847675c0acc8db9e$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $847675c0acc8db9e$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-header-and-parent');
    }
};

});

parcelRegister("fmbEw", function(module, exports) {

$parcel$export(module.exports, "default", () => $afb9a48dda30cc33$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $afb9a48dda30cc33$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-resolution') || (0, $4R6GH.fg)('relay-migration-issue-fields-status');
    }
};

});

parcelRegister("hSNvs", function(module, exports) {

$parcel$export(module.exports, "default", () => $efddcea96d8714d0$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $efddcea96d8714d0$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-status');
    }
};

});

parcelRegister("jwLjt", function(module, exports) {

$parcel$export(module.exports, "default", () => $90a9c0c588d04c5e$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $90a9c0c588d04c5e$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-time-tracking-perf');
    }
};

});

parcelRegister("8Y9hN", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb6d2edf34e99bba$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $4R6GH = parcelRequire("4R6GH");
var $eb6d2edf34e99bba$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-fields-time-tracking');
    }
};

});

parcelRegister("ejqaS", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7323747132cbc58$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $c7323747132cbc58$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-header-and-parent');
    }
};

});

parcelRegister("eXeEx", function(module, exports) {

$parcel$export(module.exports, "default", () => $acfad9d58e7d968c$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $acfad9d58e7d968c$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('relay-migration-issue-header-and-parent');
    }
};

});


parcelRegister("6tI1D", function(module, exports) {

$parcel$export(module.exports, "PermalinkType", () => $ac458c74e4b12b29$export$b18d061fc042df1a);
$parcel$export(module.exports, "COMMENTS", () => $ac458c74e4b12b29$export$4cab9dfa8fc858f4);
$parcel$export(module.exports, "WORKLOG", () => $ac458c74e4b12b29$export$df36fc05622c402);
$parcel$export(module.exports, "getAllUrlParams", () => $ac458c74e4b12b29$export$dca91ad250f6b082);
$parcel$export(module.exports, "getPermalinkId", () => $ac458c74e4b12b29$export$bf42dbba4c31080e);
$parcel$export(module.exports, "getPermalinkIdFromURL", () => $ac458c74e4b12b29$export$87557f913748dcff);

var $gKZoD = parcelRequire("gKZoD");

var $2YZCu = parcelRequire("2YZCu");
const $ac458c74e4b12b29$export$b18d061fc042df1a = {
    COMMENTS: 'focusedCommentId',
    WORKLOG: 'focusedWorklogId'
};
const $ac458c74e4b12b29$export$4cab9dfa8fc858f4 = 'COMMENTS';
const $ac458c74e4b12b29$export$df36fc05622c402 = 'WORKLOG';
/**
 * @deprecated this function is unsafe for using on server side code due to `window` object usage
 */ const $ac458c74e4b12b29$export$dca91ad250f6b082 = ()=>{
    (0, $gKZoD.di)(window);
    // get query string from  window
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let queryString = window.location.search.slice(1);
    // we'll store the parameters here
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const obj = {};
    // if query string exists
    if (queryString) {
        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split('#')[0];
        // split our query string into its component parts
        const arr = queryString.split('&');
        for(let i = 0; i < arr.length; i += 1){
            // separate the keys and the values
            const a = arr[i].split('=');
            // set parameter name and value (use 'true' if empty)
            const paramName = a[0];
            try {
                const paramValue = typeof a[1] === 'undefined' ? true : decodeURIComponent(a[1]);
                obj[paramName] = paramValue;
            } catch (error) {
                (0, $2YZCu.default).safeErrorWithoutCustomerData('getAllUrlParams', `Malformed value was obtained from the query string for ${paramName}`);
            }
        }
    }
    return obj;
};
const $ac458c74e4b12b29$export$bf42dbba4c31080e = (targetPermalinkType)=>{
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly COMMENTS: "focusedCommentId"; readonly WORKLOG: "focusedWorklogId"; }'.
    if (!$ac458c74e4b12b29$export$b18d061fc042df1a[targetPermalinkType]) return null;
    const urlParams = $ac458c74e4b12b29$export$dca91ad250f6b082();
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly COMMENTS: "focusedCommentId"; readonly WORKLOG: "focusedWorklogId"; }'.
    return urlParams[$ac458c74e4b12b29$export$b18d061fc042df1a[targetPermalinkType]];
};
const $ac458c74e4b12b29$export$87557f913748dcff = (targetPermalinkType, url)=>{
    const queryParamKey = $ac458c74e4b12b29$export$b18d061fc042df1a[targetPermalinkType];
    if (!queryParamKey) return null;
    return url.searchParams.get(queryParamKey);
};

});


parcelRegister("2Yhep", function(module, exports) {

$parcel$export(module.exports, "getIssueKey", () => $05d1e79edcc0dc56$export$4a030f6192bebe03);
const $05d1e79edcc0dc56$export$4a030f6192bebe03 = (match)=>{
    const fromMatch = match && match.params && match.params.issueKey !== undefined && match.params.issueKey !== null ? match.params.issueKey : null;
    return fromMatch;
};

});

// This constant will be true on entry-fs (modern SSR) bundles and false on jira-fe-gateway (legacy SSR) and client bundles
const $cdb023d06c7f62fa$export$19d68f5aa485d903 = false;

parcelRegister("5XgeZ", function(module, exports) {

$parcel$export(module.exports, "withResourceEarlyData", () => $36d3fb93786ec5e2$export$22da5fb8c8200986);
$parcel$export(module.exports, "createRelayResourceDeprecated", () => $36d3fb93786ec5e2$export$2e279339bedcd427);

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");

var $x9xyg = parcelRequire("x9xyg");

var $5yJb9 = parcelRequire("5yJb9");

var $5a0Nh = parcelRequire("5a0Nh");

var $kipqU = parcelRequire("kipqU");

var $2M1hQ = parcelRequire("2M1hQ");

var $5Wobd = parcelRequire("5Wobd");
const $36d3fb93786ec5e2$export$5664a170ac5a9781 = 5000;
const $36d3fb93786ec5e2$export$22da5fb8c8200986 = ({ type: type, getData: next, getDataLoader: getDataLoader, ...rest })=>{
    const getData = (...args)=>{
        performance.mark(`issueViewEarlyScripts:${type}:withResourceEarlyData:called`);
        if (!false && type in window) {
            // @ts-expect-error - Element implicitly has an 'any' type because index expression is not of type 'number'
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any, jira/jira-ssr/no-unchecked-globals-usage
            const promise = window[type];
            // @ts-expect-error - Element implicitly has an 'any' type because index expression is not of type 'number'
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            delete window[type];
            getDataLoader && promise.then(getDataLoader);
            return promise;
        }
        if (getDataLoader) return getDataLoader().then(({ default: getDataPromise })=>getDataPromise(...args));
        return next && next(...args);
    };
    return {
        ...rest,
        type: type,
        getData: getData
    };
};
const $36d3fb93786ec5e2$export$c6c8c12c0f1d8e54 = 'RELAY_RESOURCE_TYPE';
const $36d3fb93786ec5e2$var$createRelayResourceImpl = ({ type: type, isBrowserOnly: isBrowserOnly, getQuery: getQuery, loadParameters: loadParameters, captureErrors: captureErrors = false, captureTraceIds: captureTraceIds = false })=>(0, $2M1hQ.createResource)({
        type: `${$36d3fb93786ec5e2$export$c6c8c12c0f1d8e54}_${type}`,
        getKey: (routerContext, customContext)=>{
            const { parameters: preloadableRequest, variables: queryVariables, keyVariables: keyVariables } = getQuery(routerContext, customContext);
            // There are some variables that we don't want to trigger a reload even if they are changed, by default use 'variables', or you can also pass over
            // specific keyVariables that will trigger the reload
            const variables = keyVariables || queryVariables;
            // When providing an async query via `loadParameters` instead of getQuery's config, the query ID is not known upfront and so cannot be contributed to the resource key
            if (!preloadableRequest) return JSON.stringify(variables || {});
            let queryId;
            let params;
            if ('kind' in preloadableRequest && preloadableRequest.kind === 'PreloadableConcreteRequest') {
                ({ params: params } = preloadableRequest);
                ({ id: queryId } = params);
            } else {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                const graphQlTaggedNode = preloadableRequest;
                const request = (0, $eiowN.getRequest)(graphQlTaggedNode);
                params = request.params;
                queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
            }
            return `${String(queryId)}${JSON.stringify(variables || {})}`;
        },
        getData: async (routerContext, customContext)=>{
            const measureName = `relay_resource_get_data:${type}`;
            const startMark = `relay_resource_get_data:${type}:start`;
            const endMark = `relay_resource_get_data:${type}:end`;
            (0, $x9xyg.setMark)(startMark);
            const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, customContext);
            // We either have a sync query or an async one from loadParameters. Never neither
            // This is enforced by 2 aliases of this method having different types, but Typescript cannot infer that neatly, so we cast away the nullable case.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const query = parameters ?? await loadParameters?.();
            // loadQuery returns not a Promise, but Observable.
            // Resource waits until query Observable is completed and returns a queryReference
            // later queryReference could be used by usePreloadedQuery
            const queryReference = (0, $x9xyg.measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $8Uumt.loadQuery)((0, $5yJb9.default)(), query, variables || {}, options));
            if (false && queryReference.id != null) await (0, $kipqU.QueryPromisesMap).get(queryReference.id);
            if (queryReference.id != null) (0, $kipqU.QueryPromisesMap).get(queryReference.id)?.then(()=>{
                (0, $x9xyg.setMark)(endMark);
                (0, $x9xyg.setMeasure)(measureName, startMark, endMark);
            });
            /**
			 * We want to store HTTP codes from fetch response so that we can use it to report SLA correctly.
			 * (Unfortunately errors thrown by relay client validation doesn't include HTTP codes at the moment, so we have to store it ourselves)
			 * Starting to capture errors here ensures we capture errors for the early fetch of the query on initial page load,
			 * as well as subsequent fetches made by route transitions between spa-apps.
			 */ if (captureErrors) (0, $5a0Nh.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
            if (captureTraceIds) (0, $5Wobd.startCapturingTraceIds)(queryReference.name);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return queryReference;
        },
        maxAge: 0,
        isBrowserOnly: isBrowserOnly
    });
const $36d3fb93786ec5e2$export$2e279339bedcd427 = $36d3fb93786ec5e2$var$createRelayResourceImpl;

});


parcelRegister("9XjL6", function(module, exports) {

$parcel$export(module.exports, "issueGiraDataResource", () => $94d751405759debc$export$37badecd288c49f4);

var $2Yhep = parcelRequire("2Yhep");

var $2M1hQ = parcelRequire("2M1hQ");

var $gNStA = parcelRequire("gNStA");


var $6s1PB = parcelRequire("6s1PB");

var $5XgeZ = parcelRequire("5XgeZ");

var $1UEZY = parcelRequire("1UEZY");
const $94d751405759debc$export$37badecd288c49f4 = (0, $gNStA.browserOnlyResourceWithCondition)(()=>{
    if (0, $cdb023d06c7f62fa$export$19d68f5aa485d903) // not "browser only" if FF is on
    return !(0, $6s1PB.expVal)('issue_view_ssr_perf_m2', 'isEnabled', false);
    return true;
}, // eslint-disable-next-line @typescript-eslint/no-explicit-any
(0, $2M1hQ.createResource)((0, $5XgeZ.withResourceEarlyData)({
    type: 'ISSUE_GIRA_DATA',
    getKey: ({ match: match })=>{
        const issueKey = (0, $2Yhep.getIssueKey)(match);
        return issueKey || '';
    },
    getData: (...args)=>(0, $1UEZY.default)(...args),
    isBrowserOnly: true
})));

});
parcelRegister("1UEZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $48e4146cd1317713$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $ePyEO = parcelRequire("ePyEO");

var $iR3GG = parcelRequire("iR3GG");

var $2Yhep = parcelRequire("2Yhep");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$48e4146cd1317713$export$2e2bcd8739ae039 = async ({ match: match }, { tenantContext: tenantContext })=>{
    const issueKey = (0, $2Yhep.getIssueKey)(match);
    if (!issueKey) return null;
    try {
        const { baseUrl: baseUrl } = tenantContext;
        const data = await (0, $ePyEO.default)(baseUrl, issueKey);
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $iR3GG.createResourceError)({
            component: 'spa.view.routes.issue-view.gira.getData',
            message: 'An error was thrown while prefetching issue gira data',
            name: 'ResourceError'
        }, error);
    }
};

});
parcelRegister("ePyEO", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef212fbaef309294$export$2e2bcd8739ae039);

var $dGrdR = parcelRequire("dGrdR");

var $k3PbQ = parcelRequire("k3PbQ");

var $fqpdr = parcelRequire("fqpdr");

var $9kbEN = parcelRequire("9kbEN");

var $iBOrg = parcelRequire("iBOrg");
const $ef212fbaef309294$var$ISSUE_GIRA_DATA = 'issue-gira-data';
const $ef212fbaef309294$var$timeToFetchIssueGiraDataMetric = (0, $dGrdR.metrics).custom({
    key: $ef212fbaef309294$var$ISSUE_GIRA_DATA
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ef212fbaef309294$export$2e2bcd8739ae039 = async (baseUrl, issueKey)=>{
    const projectKey = (0, $k3PbQ.extractProjectKey)(issueKey);
    const variables = {
        issueKey: issueKey,
        projectKey: projectKey
    };
    const payload = {
        query: (0, $fqpdr.buildIssueQuery)(),
        variables: variables,
        operationName: (0, $fqpdr.ISSUE_VIEW_INTERACTIVE_QUERY)
    };
    if ((0, $9kbEN.isInSample)()) $ef212fbaef309294$var$timeToFetchIssueGiraDataMetric.start();
    try {
        const response = await (0, $iBOrg.getClient)(baseUrl).query(payload);
        // Best-effort attempt to provide `issueId` and is not guaranteed
        const issueId = response.data?.viewIssue?.issueId;
        $ef212fbaef309294$var$timeToFetchIssueGiraDataMetric.stop({
            customData: issueId ? {
                issueId: issueId
            } : null
        });
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // Cancel the metric and re-throw the error
        $ef212fbaef309294$var$timeToFetchIssueGiraDataMetric.cancel();
        throw error;
    }
};

});
parcelRegister("fqpdr", function(module, exports) {

$parcel$export(module.exports, "ISSUE_VIEW_INTERACTIVE_QUERY", () => $3789cf83eed10ddd$export$1780a132c0453fee);
$parcel$export(module.exports, "getGiraUrl", () => $3789cf83eed10ddd$export$aefb19023b2eda55);
$parcel$export(module.exports, "getJiraQueryEcosystemFirstSeenOnIssueView", () => $3789cf83eed10ddd$export$79eba9bf6dc9960d);
$parcel$export(module.exports, "buildIssueQuery", () => $3789cf83eed10ddd$export$222ae9aca08830f0);
$parcel$export(module.exports, "getGiraRequestOptions", () => $3789cf83eed10ddd$export$e1542dc7ff749de8);
/**
 * ╔═══════════════╗
 * ║ !!IMPORTANT!! ║
 * ╚═══════════════╝
 * Please do not use statsig feature gating in this file.
 * Read https://hello.atlassian.net/wiki/spaces/JIE/pages/2858513117/Blockers+for+Statsig+in+the+issue-view
 * for why and to follow the fix.
 */ 
var $96nmc = parcelRequire("96nmc");

var $EJMEI = parcelRequire("EJMEI");

var $8TkIN = parcelRequire("8TkIN");

var $e2Vt6 = parcelRequire("e2Vt6");

var $92ECu = parcelRequire("92ECu");

var $6QL4r = parcelRequire("6QL4r");

var $5Pqa3 = parcelRequire("5Pqa3");

var $b1RJj = parcelRequire("b1RJj");

var $1HCMp = parcelRequire("1HCMp");

var $8JI9I = parcelRequire("8JI9I");

var $kNriQ = parcelRequire("kNriQ");

var $cRP2d = parcelRequire("cRP2d");
const $3789cf83eed10ddd$var$CREATED_ORDER_DESCENDING = '-created';
const $3789cf83eed10ddd$export$1780a132c0453fee = 'issueViewInteractiveQuery';
const $3789cf83eed10ddd$export$aefb19023b2eda55 = (_baseUrl, operation)=>`/rest/gira/1/${(0, $96nmc.appendOperationQuery)(operation)}`;
// JIV-19906: retrieve query string from URL -- only expected to be used by client side code
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $3789cf83eed10ddd$var$getURLFromWindow = ()=>new URL(window.location.href);
const $3789cf83eed10ddd$var$viewIssueQuery = (url = $3789cf83eed10ddd$var$getURLFromWindow())=>`
    viewIssue(issueKey: $issueKey) {
        canCreateSubTask
        canExportIssue
        ${/**
					 * THIS QUERY ONLY FETCHES TOTAL COUNT OF COMMENTS
					 * For all other comment related data, use AGG endpoints
					 * Note: When activity sorting feature is enabled, we do not
					 * want to fetch with sort order passed through; we should defer
					 * to the saved sort order in the backend to return the correct
					 * sort order
					 */ (0, $EJMEI.default)({
        maxResults: (0, $92ECu.NUM_INITIAL_COMMENTS_TO_LOAD),
        startAt: 0,
        orderBy: $3789cf83eed10ddd$var$CREATED_ORDER_DESCENDING,
        commentAmount: Math.floor((0, $92ECu.NUM_INITIAL_COMMENTS_TO_LOAD)),
        url: url
    })}
        ${/**
					 * Note: When activity sorting feature is enabled, we do not
					 * want to fetch with sort order passed through; we should defer
					 * to the saved sort order in the backend to return the correct
					 * sort order
					 */ (0, $cRP2d.default)({
        startAt: 0,
        worklogAmount: Math.floor((0, $92ECu.NUM_INITIAL_WORKLOGS_TO_LOAD)),
        url: url
    })}
        ${(0, $e2Vt6.getEcosystemQuery)()}
        ${(0, $8TkIN.getContentPanelsQuery)()}
        ${(0, $e2Vt6.getLegacyRightWebPanelsQuery)()}
        totalAttachmentsCount
        ${(0, $5Pqa3.getContainersByTypeQuery)()}
        ${(0, $kNriQ.getRemoteLinksQuery)()}
    }
`;
const $3789cf83eed10ddd$export$79eba9bf6dc9960d = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
    }
`;
const $3789cf83eed10ddd$export$58eaa2ae4a5a410a = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
        hasAdministerPermission: hasGlobalPermission(key: ADMINISTER)
        hasUserPickerPermission: hasGlobalPermission(key: USER_PICKER)
    }
`;
const $3789cf83eed10ddd$export$222ae9aca08830f0 = (url)=>`
query ${$3789cf83eed10ddd$export$1780a132c0453fee}($issueKey: String!, $projectKey: String)  {
        ${$3789cf83eed10ddd$export$58eaa2ae4a5a410a()}
        ${(0, $b1RJj.default)()}
        ${$3789cf83eed10ddd$var$viewIssueQuery(url)}
        ${(0, $6QL4r.getJiraSettingsQuery)()}
        ${(0, $1HCMp.default)()}
        ${(0, $8JI9I.default)()}
    }

`;
const $3789cf83eed10ddd$export$e1542dc7ff749de8 = (issueKey, projectKey, url)=>{
    const payload = {
        operationName: $3789cf83eed10ddd$export$1780a132c0453fee,
        query: $3789cf83eed10ddd$export$222ae9aca08830f0(url),
        variables: {
            issueKey: issueKey,
            projectKey: projectKey
        }
    };
    return {
        method: 'POST',
        body: JSON.stringify(payload)
    };
};

});
parcelRegister("96nmc", function(module, exports) {

$parcel$export(module.exports, "appendOperationQuery", () => $8119dcf59ebfcad5$export$69694c3add0f6058);
const $8119dcf59ebfcad5$export$69694c3add0f6058 = (operation)=>operation ? `?operation=${operation}` : '';

});

parcelRegister("EJMEI", function(module, exports) {

$parcel$export(module.exports, "default", () => $01ae9b8d951a6992$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");

var $6tI1D = parcelRequire("6tI1D");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$01ae9b8d951a6992$export$2e2bcd8739ae039 = ({ maxResults: maxResults, startAt: startAt, orderBy: orderBy, commentAmount: commentAmount, url: url })=>{
    const commentPermalinkId = url && (0, $4R6GH.fg)('jiv-19906-fix-targered-permalink-on-server') ? (0, $6tI1D.getPermalinkIdFromURL)((0, $6tI1D.COMMENTS), url) : (0, $6tI1D.getPermalinkId)((0, $6tI1D.COMMENTS));
    const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
    const commentParameter = commentPermalinkId !== null && commentPermalinkId !== undefined ? `, commentId: ${commentPermalinkId}` : '';
    const commentAmountParameter = commentParameter !== '' && commentAmount !== null && commentAmount !== undefined ? `, commentAmount: ${commentAmount}` : '';
    const maxResultsParameter = commentParameter === '' && maxResults !== null && maxResults !== undefined ? `, maxResults: ${maxResults}` : '';
    return `
        comments (first: ${startAt}${maxResultsParameter}${orderByParameter}${commentParameter}${commentAmountParameter}) {
            totalCount
        }
    `;
};

});

parcelRegister("8TkIN", function(module, exports) {

$parcel$export(module.exports, "getContentPanelsQuery", () => $09fdc8c72c341092$export$e6f14eac549b679d);
const $09fdc8c72c341092$var$getContentPanelNode = ()=>`
    name
    addonKey
    moduleKey
    options
    iconUrl
    tooltip
    type
    isShownByDefault
    wasManuallyAddedToIssue
`;
const $09fdc8c72c341092$var$getContentPanelsConnectionQuery = ()=>`
    contentPanels {
        edges {
            node {
                ${$09fdc8c72c341092$var$getContentPanelNode()}
            }
        }
    }
`;
const $09fdc8c72c341092$var$getLegacyContentPanelsConnectionQuery = ()=>`
    legacyContentPanels {
        edges {
            node {
                ${$09fdc8c72c341092$var$getContentPanelNode()}
            }
        }
    }
`;
const $09fdc8c72c341092$export$e6f14eac549b679d = ()=>`
    ${$09fdc8c72c341092$var$getContentPanelsConnectionQuery()}
    ${$09fdc8c72c341092$var$getLegacyContentPanelsConnectionQuery()}
    hasCustomisedContentPanels
`;

});

parcelRegister("e2Vt6", function(module, exports) {

$parcel$export(module.exports, "getEcosystemQuery", () => $1771eed42c62eeca$export$edefef8c65e08bd2);
$parcel$export(module.exports, "getLegacyRightWebPanelsQuery", () => $1771eed42c62eeca$export$92c9a3dc7076af51);
const $1771eed42c62eeca$var$getForgeQuery = ()=>`forge {
        panels {
          id
          instances {
            id
            collapsed
            added
          }
        }
      }`;
const $1771eed42c62eeca$export$edefef8c65e08bd2 = ()=>`
    ecosystem {
      activityPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
      }
      contextPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
        icon {
          url
        }
        content
        status
        type
      }
      ${$1771eed42c62eeca$var$getForgeQuery()}
    }
`;
const $1771eed42c62eeca$export$92c9a3dc7076af51 = ()=>`
        legacyRightWebPanels {
          edges {
            node {
              name
              status
              addonKey
              moduleKey
              options
              content
            }
          }
        }
      `;

});

parcelRegister("92ECu", function(module, exports) {

$parcel$export(module.exports, "NUM_INITIAL_COMMENTS_TO_LOAD", () => $9387aa2a419a55f9$export$c46d621c29194aa4);
$parcel$export(module.exports, "NUM_INITIAL_WORKLOGS_TO_LOAD", () => $9387aa2a419a55f9$export$b2e398ce246f55b3);
$parcel$export(module.exports, "gqlTagGira", () => $9387aa2a419a55f9$export$aeae6fc40846cf9f);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports














const $9387aa2a419a55f9$export$c46d621c29194aa4 = 5;
const $9387aa2a419a55f9$export$304a6c004edb30d8 = '-created';
const $9387aa2a419a55f9$export$b2e398ce246f55b3 = 5;
const $9387aa2a419a55f9$export$1c36ecc9afd61c73 = '-started';
const $9387aa2a419a55f9$export$aeae6fc40846cf9f = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};

});

parcelRegister("6QL4r", function(module, exports) {

$parcel$export(module.exports, "getJiraSettingsQuery", () => $10470e592ba8e782$export$191f50c0f86b85ec);
const $10470e592ba8e782$export$e302502f14e3f203 = ()=>`
          timeTracking {
            isTimeTrackingEnabled
            hoursPerDay
            daysPerWeek
            defaultUnit
            format
          }
    `;
const $10470e592ba8e782$export$65e7d3d1915962da = ()=>`
          subtasks {
            enabled
          }
    `;
const $10470e592ba8e782$export$191f50c0f86b85ec = ()=>`
    jiraSettings {
      newIssueViewTransitionSettings {
        shouldDelayChangeboarding
        newIssueViewTransitionLockingStatus
     }
    }
`;

});

parcelRegister("5Pqa3", function(module, exports) {

$parcel$export(module.exports, "getContainersByTypeQuery", () => $85e2f5a62f1697d1$export$63131b2831854cc);

var $e5wyW = parcelRequire("e5wyW");

var $4R6GH = parcelRequire("4R6GH");
const $85e2f5a62f1697d1$export$e30f32dd3fd26efd = ()=>`
containersByType(input:{systemContainerTypes: [CONTENT, PRIMARY, SECONDARY, REQUEST_PORTAL], supportDefaultTab: true}) {
__typename
... on JiraIssueItemContainers {
containers {
  containerType
  items {
    nodes {
      type: __typename
      ... on JiraIssueItemFieldItem {
        fieldItemId        
      }
      ... on JiraIssueItemPanelItem {
        panelItemId
      }
      ... on JiraIssueItemTabContainer {
        name
        tabContainerId              
        items {
          nodes {
            type: __typename
            ... on JiraIssueItemFieldItem {
              fieldItemId
            }
          }
        }
      }
    }
  }
}
}
}
`;
const $85e2f5a62f1697d1$export$842411c0b98baa9c = ()=>`
containersByType(input:{systemContainerTypes: [CONTENT, PRIMARY, SECONDARY, REQUEST_PORTAL, CUSTOMER_CONTEXT], supportDefaultTab: true}) {
__typename
... on JiraIssueItemContainers {
containers {
  containerType
  items {
    nodes {
      type: __typename
      ... on JiraIssueItemFieldItem {
        fieldItemId        
      }
      ... on JiraIssueItemPanelItem {
        panelItemId
      }
      ... on JiraIssueItemTabContainer {
        name
        tabContainerId              
        items {
          nodes {
            type: __typename
            ... on JiraIssueItemFieldItem {
              fieldItemId
            }
          }
        }
      }
    }
  }
}
}
}
`;
const $85e2f5a62f1697d1$export$63131b2831854cc = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jcs_master_flag'), $85e2f5a62f1697d1$export$842411c0b98baa9c, $85e2f5a62f1697d1$export$e30f32dd3fd26efd);

});

parcelRegister("b1RJj", function(module, exports) {

$parcel$export(module.exports, "default", () => $42429f0fa15c54ae$export$2e2bcd8739ae039);

var $9wuCE = parcelRequire("9wuCE");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$42429f0fa15c54ae$export$2e2bcd8739ae039 = ()=>`mediaContext(issueKey: $issueKey) {
    userToken {
      token
      id
      issueId
      tokenDurationInMins
    }
    uploadToken {
      __typename
      ... on MediaUploadToken {
        endpointUrl
        token
        targetCollection
        tokenDurationInMins
        clientId
      }
      ... on FailedMediaUploadToken {
        error
      }
    }
    readToken(maxTokenLength: ${(0, $9wuCE.getMaxTokenLength)()}) {
      clientId
      endpointUrl
      tokensWithFiles {
        files {
          issueId
          attachmentId
          attachmentMediaApiId
        }
        token
      }
      tokenLifespanInSeconds
    }
  }`;

});
parcelRegister("9wuCE", function(module, exports) {

$parcel$export(module.exports, "getMaxTokenLength", () => $ebb491dcc11e8362$export$e40f2acaf1a50b00);
// Low enough such that it shouldn't cause problems for non-IE11 browsers, and high
// enough such that it shouldn't be encountered in practice very often.
const $ebb491dcc11e8362$var$nonIE11MaxTokenLength = 2 ** 16;
const $ebb491dcc11e8362$export$e40f2acaf1a50b00 = ()=>$ebb491dcc11e8362$var$nonIE11MaxTokenLength;

});


parcelRegister("1HCMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ea17df757c74c46$export$2e2bcd8739ae039);
// A list of all keys of permissions that this transformer supports.
const $0ea17df757c74c46$export$9fc40cb6f3529ef = ()=>[
        'ADMINISTER_PROJECTS',
        'ASSIGN_ISSUES',
        'EDIT_ISSUES',
        'SCHEDULE_ISSUES',
        'ADD_COMMENTS',
        'DELETE_ALL_COMMENTS',
        'DELETE_OWN_COMMENTS',
        'EDIT_ALL_COMMENTS',
        'EDIT_OWN_COMMENTS',
        'CREATE_ISSUES',
        'DELETE_ISSUES',
        'MOVE_ISSUES',
        'MODIFY_REPORTER',
        'CREATE_ATTACHMENTS',
        'DELETE_ALL_ATTACHMENTS',
        'DELETE_OWN_ATTACHMENTS',
        'WORK_ON_ISSUES',
        'ASSIGNABLE_USER',
        'LINK_ISSUES',
        'VIEW_VOTERS_AND_WATCHERS',
        'MANAGE_WATCHERS',
        'EDIT_ALL_WORKLOGS',
        'EDIT_OWN_WORKLOGS',
        'DELETE_ALL_WORKLOGS',
        'DELETE_OWN_WORKLOGS',
        'VIEW_DEV_TOOLS',
        'SERVICEDESK_AGENT',
        'RESOLVE_ISSUES',
        'CLONE_ISSUE',
        'ARCHIVE_ISSUES',
        'UNARCHIVE_ISSUES'
    ];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0ea17df757c74c46$export$2e2bcd8739ae039 = ()=>`

    permissions(issueKey:$issueKey, keys:["${$0ea17df757c74c46$export$9fc40cb6f3529ef().join('","')}"]) {
        key
        havePermission
    }
`;

});

parcelRegister("8JI9I", function(module, exports) {

$parcel$export(module.exports, "default", () => $2232e63ddd04bbb1$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $2232e63ddd04bbb1$export$2e2bcd8739ae039 = ()=>`
    project(projectKey: $projectKey) {
        id
        newIssueViewLockedIn
        issueTypes {
            id
            name
            iconUrl
            subtask
        }
    }
`;

});

parcelRegister("kNriQ", function(module, exports) {

$parcel$export(module.exports, "getRemoteLinksQuery", () => $e19ca26272d1dd4d$export$6bbc6b72b0b57f25);

var $4R6GH = parcelRequire("4R6GH");
const $e19ca26272d1dd4d$var$getRemoteLinkedIssuesPreviewFragment = ()=>`
    id
    issueId
    globalId
    href
    applicationType
    applicationName
    relationship
    title
`;
const $e19ca26272d1dd4d$var$getAssociatedIssueFragment = ()=>`
    issueId
    issueKey {
        stringValue
    }
    summary {
        textValue
    }
    status {
        statusCategoryId
        name
        statusId
    }
    priority {
        iconUrl
        name
    }
    issueType {
        iconUrl
        name
    }
    assignee {
        userValue
        {
            displayName
            avatarUrl
        }
    }
   isResolved
`;
const $e19ca26272d1dd4d$var$getRemoteLinkedIssuesDetailsFragment = ()=>`
    ... on AssociatedIssueWrapper {
        associatedIssue {
            ${$e19ca26272d1dd4d$var$getAssociatedIssueFragment()}
        }
    }
    ... on FailedRemoteIssue {
        error
        repairLink { href }
    }
`;
const $e19ca26272d1dd4d$var$getRemoteLinkedIssuesFragment = ()=>`
    remoteLinkedIssues {
        preview {
            ${$e19ca26272d1dd4d$var$getRemoteLinkedIssuesPreviewFragment()}
        }
        details {
            ${$e19ca26272d1dd4d$var$getRemoteLinkedIssuesDetailsFragment()}
        }
    }
`;
const $e19ca26272d1dd4d$var$getWebLinksFragment = ()=>`
    webLinks(allowThirdParties: true, orderBy: "-id") {
        linkCount
        links {
            id
            href
            linkText
            iconUrl
            summary
            resolved
            relationship
            applicationName
            applicationType
        }
    }
`;
const $e19ca26272d1dd4d$var$getRemoteLinksQueryNew = ()=>`
    remoteLinks {
        isLinkingEnabled
        confluencePages {
            linkedPages {
				pageCount
				pages {
					... on ConfluencePage {
						id
						globalId
						href
						title
						type
					}
					... on FailedRemoteLink {
						id
						error
						link {
							id
							globalId
							href
						}
						repairLink { href }
					}
				}
            }
        }
        ${$e19ca26272d1dd4d$var$getWebLinksFragment()}
        ${$e19ca26272d1dd4d$var$getRemoteLinkedIssuesFragment()}
    }
`;
const $e19ca26272d1dd4d$var$getRemoteLinksQueryOld = ()=>`
    remoteLinks {
        isLinkingEnabled
        remoteLinkedIssues {
            preview {
                id
                issueId
                globalId
                href
                applicationType
                applicationName
                relationship
                title
            }
        }
    }
`;
const $e19ca26272d1dd4d$export$6bbc6b72b0b57f25 = ()=>(0, $4R6GH.fg)('jiv-19125-fetch-remote-links-in-interactive-query') ? $e19ca26272d1dd4d$var$getRemoteLinksQueryNew() : $e19ca26272d1dd4d$var$getRemoteLinksQueryOld();

});

parcelRegister("cRP2d", function(module, exports) {

$parcel$export(module.exports, "default", () => $354b7c85b873ab44$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");

var $6tI1D = parcelRequire("6tI1D");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$354b7c85b873ab44$export$2e2bcd8739ae039 = ({ startAt: startAt, orderBy: orderBy, worklogAmount: worklogAmount, url: url })=>{
    const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
    const worklogPermalinkId = url && (0, $4R6GH.fg)('jiv-19906-fix-targered-permalink-on-server') ? (0, $6tI1D.getPermalinkIdFromURL)((0, $6tI1D.WORKLOG), url) : (0, $6tI1D.getPermalinkId)((0, $6tI1D.WORKLOG));
    if (worklogPermalinkId === null || worklogPermalinkId === undefined) return '';
    const worklogParameter = `, worklogId: ${worklogPermalinkId}`;
    const worklogAmountParameter = worklogAmount !== null && worklogAmount !== undefined ? `, worklogAmount: ${worklogAmount}` : '';
    return `
        worklogs (startAt: ${startAt}${orderByParameter}${worklogParameter}${worklogAmountParameter}) {
            nodes {
                id
                author {
                    accountId
                    displayName
                    avatarUrl
                }
                updateAuthor {
                    accountId
                    displayName
                    avatarUrl
                }
                created
                started
                updated
                comment
                timeSpent
                timeSpentSeconds
            }
            totalCount
            startIndex
        }
    `;
};

});


parcelRegister("9kbEN", function(module, exports) {

$parcel$export(module.exports, "isInSample", () => $b9c2013a86366ec0$export$a994c91d08ead5ff);

const $b9c2013a86366ec0$export$a994c91d08ead5ff = (sampleRate = (0, $670519621927ccc4$export$9fc1f2d681a9e609))=>Math.random() <= 1 / sampleRate;

});
/**
 * Sample rates are defined as the inverse.
 * e.g. a sample rate of 100 = 1 in 100 events are sent.
 */ const $670519621927ccc4$export$9fc1f2d681a9e609 = 100; // 1%


parcelRegister("iBOrg", function(module, exports) {

$parcel$export(module.exports, "getClient", () => $3d6ab2890da8f9df$export$6bb76d6eba7e258c);

var $7f4tk = parcelRequire("7f4tk");

var $fqpdr = parcelRequire("fqpdr");
const $3d6ab2890da8f9df$var$makeFetchClient = (baseUrl)=>({
        query: ({ query: query, variables: variables, signal: signal, operationName: operationName })=>(0, $7f4tk.default)((0, $fqpdr.getGiraUrl)(baseUrl, operationName), {
                method: 'POST',
                body: JSON.stringify({
                    query: query,
                    variables: variables,
                    operationName: operationName
                }),
                signal: signal
            })
    });
let $3d6ab2890da8f9df$var$client;
const $3d6ab2890da8f9df$export$6bb76d6eba7e258c = (baseUrl)=>{
    if (!$3d6ab2890da8f9df$var$client) $3d6ab2890da8f9df$var$client = $3d6ab2890da8f9df$var$makeFetchClient(baseUrl);
    return $3d6ab2890da8f9df$var$client;
};

});




parcelRegister("fjoQ1", function(module, exports) {

$parcel$export(module.exports, "browseIssueEmbedRoute", () => $1c5f13cdd9ba8bf4$export$240aeec71c480594);
const $1c5f13cdd9ba8bf4$export$240aeec71c480594 = {
    name: 'issue-embed',
    path: '/browse/:issueKey(\\w+-\\d+)/embed'
};

});

parcelRegister("lb0Dk", function(module, exports) {

$parcel$export(module.exports, "IssueViewSkeleton", () => $bf9ca492e3d15685$export$49addbcdecb6e6ff);
/* IssueViewSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $iMqhh = parcelRequire("iMqhh");

var $4R6GH = parcelRequire("4R6GH");

var $hCy6k = parcelRequire("hCy6k");

var $3441h = parcelRequire("3441h");
const $bf9ca492e3d15685$var$fullpageStyles = null;
const $bf9ca492e3d15685$var$modalStyles = null;
const $bf9ca492e3d15685$var$customSpacingStylesWithIncreasedWidth = null;
const $bf9ca492e3d15685$var$customSpacingStylesWithDefaultWidth = null;
const $bf9ca492e3d15685$export$49addbcdecb6e6ff = ({ isEmbedView: isEmbedView, isModalView: isModalView })=>{
    // same as getIssueContainerMaxWidth
    const customCss = [
        (0, $4R6GH.fg)('jracloud-75406-remove-excessive-padding-from-side') ? $bf9ca492e3d15685$var$customSpacingStylesWithIncreasedWidth : $bf9ca492e3d15685$var$customSpacingStylesWithDefaultWidth,
        isEmbedView !== true && isModalView !== true ? $bf9ca492e3d15685$var$fullpageStyles : null,
        isModalView === true ? $bf9ca492e3d15685$var$modalStyles : null
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iMqhh.CompactModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3441h))),
        className: (0, $bwpsq.default)([
            (0, $4R6GH.fg)('jracloud-75406-remove-excessive-padding-from-side') ? "_p12f107j _19pkze3t _2hwx1wug _otyrze3t _18u01wug _t6vdxy5q _hr4jxy5q _11y7uu9g _l82tpxbi _j7o0pxbi" : "_p12f1ypn _19pkze3t _2hwx1wug _otyrze3t _18u01wug _t6vdxy5q _hr4jxy5q _11y7uu9g _l82tpxbi _j7o0pxbi",
            isEmbedView !== true && isModalView !== true && "_uwhk1ejb",
            isModalView === true && "_19pk10j7"
        ])
    }));
};

});
parcelRegister("iMqhh", function(module, exports) {

$parcel$export(module.exports, "CompactModeContext", () => $db79d17d45755de5$export$37eeac5cc5245b18);
$parcel$export(module.exports, "CompactModeProvider", () => $db79d17d45755de5$export$10cf42790e523b8e);
$parcel$export(module.exports, "CompactModeConsumer", () => $db79d17d45755de5$export$20feb77b5b617e44);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");


var $8kj45 = parcelRequire("8kj45");

var $doZTA = parcelRequire("doZTA");

var $k1L82 = parcelRequire("k1L82");

var $hhMVP = parcelRequire("hhMVP");
const $db79d17d45755de5$export$37eeac5cc5245b18 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
const { Provider: $db79d17d45755de5$var$Provider, Consumer: $db79d17d45755de5$var$Consumer } = $db79d17d45755de5$export$37eeac5cc5245b18;
const $db79d17d45755de5$export$55a90a8e865a39b5 = 700;
const $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY = `(max-width: ${$db79d17d45755de5$export$55a90a8e865a39b5}px)`;
const $db79d17d45755de5$export$ddd398a95f85cd75 = 850;
const $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY_SIDE_PANEL = `(max-width: ${$db79d17d45755de5$export$ddd398a95f85cd75}px)`;
/**
 * A utility hook which returns a key based on the route
 */ function $db79d17d45755de5$var$useRouteKey() {
    const [routeState] = (0, $doZTA.useRouter)();
    const { match: { path: path, params: params } } = routeState;
    // handle case where JSM doesn't have an issueKey on their route
    const hasIssueKey = params?.issueKey !== undefined;
    return `${path}${hasIssueKey ? '/hasIssueKey' : ''}`;
}
const $db79d17d45755de5$export$10cf42790e523b8e = ({ children: children })=>{
    const key = $db79d17d45755de5$var$useRouteKey();
    (0, $hhMVP.invalidateCacheIfRouteChanged)(key);
    let defaultState = (0, $hhMVP.getCachedIsCompactValue)(key);
    // in case there is no state change triggered
    if (defaultState === undefined) {
        defaultState = (0, $7093eea63dce9286$export$ee15e0cd1efafcb4);
        (0, $hhMVP.setCachedIsCompactValue)(defaultState, key);
    }
    const { isInDiscussionLayoutExperiment: isInDiscussionLayoutExperiment } = (0, $k1L82.useUserPreferredWorkItemLayout)();
    const query = isInDiscussionLayoutExperiment ? $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY_SIDE_PANEL : $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY;
    const [isCompact, setIsCompact] = (0, $5uXOq.useState)(defaultState);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db79d17d45755de5$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8kj45.ContainerQueryObserver), {
        query: query,
        onChange: (state)=>{
            (0, $hhMVP.setCachedIsCompactValue)(state, key);
            setIsCompact(state);
        },
        defaultState: defaultState
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db79d17d45755de5$var$Provider, {
        value: isCompact
    }, children));
};
const $db79d17d45755de5$export$20feb77b5b617e44 = $db79d17d45755de5$var$Consumer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $db79d17d45755de5$var$StyledWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
const $7093eea63dce9286$export$ee15e0cd1efafcb4 = false;

parcelRegister("8kj45", function(module, exports) {

$parcel$export(module.exports, "ContainerQueryObserver", () => $ed10e3c030ea0408$export$e9574287678b8467);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

const $ed10e3c030ea0408$var$QueryContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
let $ed10e3c030ea0408$var$currentIdSeed = 0;
function $ed10e3c030ea0408$var$generateAttributeValue() {
    return `indicator-span-${$ed10e3c030ea0408$var$currentIdSeed++}`;
}
function $ed10e3c030ea0408$export$e9574287678b8467({ children: children, query: query, onChange: onChange, defaultState: defaultState = (0, $7093eea63dce9286$export$ee15e0cd1efafcb4) }) {
    const [active, setActive] = (0, $5uXOq.useState)(defaultState);
    const handleQueryStatusChange = (0, $5uXOq.useCallback)((isContainerQueryActive)=>{
        onChange?.(isContainerQueryActive);
        setActive(isContainerQueryActive);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$QueryContext.Provider, {
        value: active
    }, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$IntersectionIndicator, {
        query: query,
        notifyIntersectionStatusChanged: handleQueryStatusChange
    }), children);
}
function $ed10e3c030ea0408$export$b66a67697973e01() {
    const currentState = (0, $5uXOq.useContext)($ed10e3c030ea0408$var$QueryContext);
    if (currentState === undefined) throw new Error('The component must be wrapped in a ContainerQueryObserver to use useContainerQueryState');
    return currentState;
}
function $ed10e3c030ea0408$var$IntersectionIndicator({ notifyIntersectionStatusChanged: handleChange, query: query }) {
    const attributeValue = (0, $5uXOq.useMemo)(()=>$ed10e3c030ea0408$var$generateAttributeValue(), []);
    const spanRef = (0, $5uXOq.useRef)(null);
    const containerRef = (0, $5uXOq.useRef)(null);
    const currentState = $ed10e3c030ea0408$export$b66a67697973e01();
    (0, $5uXOq.useLayoutEffect)(()=>{
        const queryStatusChangedCallback = (entries)=>{
            // This means that the parent container is either empty or loading, we should not notify of any change in this case.
            if (!containerRef.current || containerRef.current.clientWidth === 0) return;
            if (entries.length > 0) {
                // only ever going to be one entry max
                const isContainerQueryActive = entries[0].isIntersecting;
                if (isContainerQueryActive !== currentState) handleChange(isContainerQueryActive);
            }
        };
        const intersectionObserver = new IntersectionObserver(queryStatusChangedCallback);
        const spanElement = spanRef.current;
        spanElement && intersectionObserver.observe(spanElement);
        return ()=>{
            spanElement && intersectionObserver.unobserve(spanElement);
            intersectionObserver.disconnect();
        };
    }, [
        currentState,
        handleChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$ContainerToBeQueried, {
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", {
        type: "text/css"
    }, `
                    [data-container-query-indicator-id="${attributeValue}"] {
                        display: none;
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100vh;
                        pointer-events: none;
                    }
                    @container ${query} {
                        [data-container-query-indicator-id="${attributeValue}"] {
                            display: inherit;
                        }
                    }`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        ref: spanRef,
        "data-container-query-indicator-id": attributeValue
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ed10e3c030ea0408$var$ContainerToBeQueried = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1if8 _lcxvglyw _154iidpf _7ccakre2",
            __cmplp.className
        ])
    });
});

});

parcelRegister("k1L82", function(module, exports) {

$parcel$export(module.exports, "useIssueLayoutContainers", () => $725285d3420dc4d6$export$d146dfa0384f99a3);
$parcel$export(module.exports, "useLayoutContainerByType", () => $725285d3420dc4d6$export$5f49a43487b268);
$parcel$export(module.exports, "useIssueLayoutGlance", () => $725285d3420dc4d6$export$fd7f0cc3d2b405e6);
$parcel$export(module.exports, "useIssueLayoutContextPanel", () => $725285d3420dc4d6$export$5962da0433486667);
$parcel$export(module.exports, "useUserPreferredWorkItemLayout", () => $725285d3420dc4d6$export$9889eea62fdfa091);
$parcel$export(module.exports, "useIssueLayoutActions", () => $725285d3420dc4d6$export$1e5e9fc877a47cd9);

var $5uXOq = parcelRequire("5uXOq");

var $egBua = parcelRequire("egBua");

var $6s1PB = parcelRequire("6s1PB");

var $eNNkf = parcelRequire("eNNkf");

var $2gCtH = parcelRequire("2gCtH");


var $93Yeu = parcelRequire("93Yeu");

var $4R6GH = parcelRequire("4R6GH");

var $2vSU6 = parcelRequire("2vSU6");

var $2YZCu = parcelRequire("2YZCu");

var $bCdIp = parcelRequire("bCdIp");

var $kI4MM = parcelRequire("kI4MM");

var $cNJ33 = parcelRequire("cNJ33");
const $725285d3420dc4d6$export$d146dfa0384f99a3 = (issueKey)=>{
    const [containers] = (0, $kI4MM.useIssueLayoutContainersStore)(issueKey);
    return [
        containers
    ];
};
const $725285d3420dc4d6$export$5f49a43487b268 = (issueKey, type)=>{
    const [containers] = (0, $kI4MM.useIssueLayoutContainersStore)(issueKey);
    const container = containers.find((innerContainer)=>innerContainer.containerType === type);
    // Forge app with UI Modifications module can hide selected fields using
    // UI modifications Field API. We are removing them here from the layout fields
    const fieldsHiddenByUim = (0, $egBua.useEnabledHiddenFields)();
    return [
        (0, $cNJ33.filterOutItemsWithProvidedIds)(container?.items.nodes ?? [], fieldsHiddenByUim)
    ];
};
const $725285d3420dc4d6$export$fd7f0cc3d2b405e6 = (issueKey)=>{
    const [glance] = (0, $kI4MM.useIssueLayoutGlanceStore)(issueKey);
    return [
        glance
    ];
};
const $725285d3420dc4d6$export$5962da0433486667 = (issueKey)=>{
    const [contextPanel] = (0, $kI4MM.useIssueLayoutContextPanelStore)(issueKey);
    return [
        contextPanel
    ];
};
const $725285d3420dc4d6$export$9889eea62fdfa091 = ()=>{
    try {
        if (!(0, $4R6GH.fg)('issue-view-side-panel-activity-kill-switch')) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        /* eslint-disable react-hooks/rules-of-hooks */ const issueKey = (0, $2gCtH.useIssueKey)();
        const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
        const projectType = (0, $93Yeu.useProjectType)(projectKey);
        const isFullIssueView = (0, $2gCtH.useIsFullPageIssueView)();
        const isMobile = (0, $bCdIp.default)();
        const isSoftwareOrBusiness = projectType === (0, $2vSU6.SOFTWARE_PROJECT) || projectType === (0, $2vSU6.CORE_PROJECT);
        const isInWideLayoutExperiment = !isMobile && isSoftwareOrBusiness && isFullIssueView && (0, $6s1PB.expVal)('wide_issue_layout_in_issue_view', 'is_enabled', false);
        const isInDiscussionLayoutExperiment = !isMobile && isSoftwareOrBusiness && isFullIssueView && (0, $6s1PB.expVal)('issue-view-side-panel-activity', 'isActivityInSidePanel', false);
        const [deprecatedUserPreferredLayout] = (0, $eNNkf.useUserPreferencesValue)((0, $31848aa9a0db89de$export$2cf981c493d79a21));
        const [userPreferredLayout] = (0, $eNNkf.useUserPreferencesValue)((0, $31848aa9a0db89de$export$39aaf586c7ee5202));
        const userLayoutType = isInWideLayoutExperiment && userPreferredLayout && typeof userPreferredLayout === 'string' ? JSON.parse(userPreferredLayout)?.layoutType : null;
        /* eslint-enable react-hooks/rules-of-hooks */ const userSelectedLayout = isInWideLayoutExperiment // Use new value if wide layout experiment is enabled
         ? userLayoutType : deprecatedUserPreferredLayout;
        // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
        // but we keep it to avoid making too many changes in the codebase
        const isActivityInVerticalSidePanel = isInDiscussionLayoutExperiment && (userSelectedLayout === 'VERTICAL' || userSelectedLayout === 'DISCUSSION');
        return {
            isInDiscussionLayoutExperiment: Boolean(isInDiscussionLayoutExperiment),
            isInWideLayoutExperiment: Boolean(isInWideLayoutExperiment),
            // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
            // but we keep it to avoid making too many changes in the codebase
            isActivityInVerticalSidePanel: Boolean(isActivityInVerticalSidePanel),
            userPreferredLayout: userSelectedLayout
        };
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('issue-view-layout.services.main', `Error in useUserPreferredWorkItemLayout : ${error}`);
        return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
    }
};
const $725285d3420dc4d6$export$1e5e9fc877a47cd9 = ()=>{
    const [, actions] = (0, $kI4MM.useIssueLayoutActionsStore)();
    const setIssueViewContainersLayout = (0, $5uXOq.useCallback)((issueKey, containersByType)=>{
        actions.setIssueViewContainersLayout(issueKey, containersByType);
    }, [
        actions
    ]);
    const setIssueViewLayoutGlance = (0, $5uXOq.useCallback)((issueKey, glance)=>{
        actions.setIssueViewLayoutGlance(issueKey, glance);
    }, [
        actions
    ]);
    const setIssueViewLayoutContextPanel = (0, $5uXOq.useCallback)((issueKey, newContextPanel)=>{
        actions.setIssueViewLayoutContextPanel(issueKey, newContextPanel);
    }, [
        actions
    ]);
    return [
        null,
        {
            setIssueViewContainersLayout: setIssueViewContainersLayout,
            setIssueViewLayoutGlance: setIssueViewLayoutGlance,
            setIssueViewLayoutContextPanel: setIssueViewLayoutContextPanel
        }
    ];
};

});
parcelRegister("egBua", function(module, exports) {

$parcel$export(module.exports, "useEnabledHiddenFields", () => $ea65d07999c73532$export$bb6c2b9159c3f32b);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $jrwZp = parcelRequire("jrwZp");

var $eoznE = parcelRequire("eoznE");
const $ea65d07999c73532$export$bb6c2b9159c3f32b = ()=>{
    (0, $gKZoD.di)((0, $jrwZp.useAdjustmentsEnabled), (0, $eoznE.useHiddenFields));
    const adjustmentsAreEnabled = (0, $jrwZp.useAdjustmentsEnabled)();
    const hiddenFields = (0, $eoznE.useHiddenFields)();
    return (0, $5uXOq.useMemo)(()=>{
        if (!adjustmentsAreEnabled) return [];
        return hiddenFields;
    }, [
        adjustmentsAreEnabled,
        hiddenFields
    ]);
};

});
parcelRegister("jrwZp", function(module, exports) {

$parcel$export(module.exports, "store", () => $db4845f733e81d44$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustmentsEnabled", () => $db4845f733e81d44$export$358ad850b2f6d6fe);
$parcel$export(module.exports, "useAdjustmentsContextActions", () => $db4845f733e81d44$export$4f2729981f4b81d2);
$parcel$export(module.exports, "UiModificationContextContainer", () => $db4845f733e81d44$export$5eb9c167b683d125);

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
const $db4845f733e81d44$var$initialState = {
    shouldUiModificationsLoad: 'unknown',
    hasFinishedLoading: false,
    adjustmentsAreEnabled: false,
    uiModificationsConsentStatus: {}
};
const $db4845f733e81d44$export$e324594224ef24da = {
    resetAdjustmentContext: ()=>({ setState: setState })=>{
            setState($db4845f733e81d44$var$initialState);
        },
    setShouldUiModificationsLoad: (status)=>({ setState: setState })=>{
            setState({
                shouldUiModificationsLoad: status
            });
        },
    setHasFinishedLoading: (hasFinishedLoading)=>({ setState: setState })=>{
            setState({
                hasFinishedLoading: hasFinishedLoading
            });
        },
    setAdjustmentsAreEnabled: (enabled)=>({ setState: setState })=>{
            setState({
                adjustmentsAreEnabled: enabled
            });
        },
    setUIModificationsConsentStatus: ({ appId: appId, status: status })=>({ setState: setState, getState: getState })=>{
            const currentConsentState = getState().uiModificationsConsentStatus;
            setState({
                uiModificationsConsentStatus: {
                    ...currentConsentState,
                    [appId]: status
                }
            });
        }
};
const $db4845f733e81d44$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'issue-adjustments-context',
    initialState: $db4845f733e81d44$var$initialState,
    actions: $db4845f733e81d44$export$e324594224ef24da
});
const $db4845f733e81d44$export$a12f82a132dee079 = (0, $3sQ5x.createHook)($db4845f733e81d44$export$6f57813fe9f31bf9);
const $db4845f733e81d44$export$358ad850b2f6d6fe = (0, $3sQ5x.createStateHook)($db4845f733e81d44$export$6f57813fe9f31bf9, {
    selector: (state)=>state.adjustmentsAreEnabled
});
const $db4845f733e81d44$export$4f2729981f4b81d2 = (0, $3sQ5x.createActionsHook)($db4845f733e81d44$export$6f57813fe9f31bf9);
const $db4845f733e81d44$export$5eb9c167b683d125 = (0, $gg7kZ.createContainer)($db4845f733e81d44$export$6f57813fe9f31bf9, {
    displayName: 'UiModificationContextContainer'
});

});

parcelRegister("eoznE", function(module, exports) {

$parcel$export(module.exports, "useHiddenFields", () => $8c7bafd209de1659$export$de6fdc67c945e596);

var $6dDSs = parcelRequire("6dDSs");
var $3sQ5x = parcelRequire("3sQ5x");

var $1YewZ = parcelRequire("1YewZ");
const $8c7bafd209de1659$var$selectHiddenFields = (0, $6dDSs.createSelector)((state)=>state.formData, (state)=>state.appliedChanges, (formData, appliedChanges)=>{
    if (formData === null) return [];
    return Object.entries(formData).filter(([fieldId, field])=>appliedChanges?.[fieldId]?.isVisible !== undefined ? !appliedChanges[fieldId].isVisible : !field.isVisible).map(([fieldId])=>fieldId);
});
const $8c7bafd209de1659$export$de6fdc67c945e596 = (0, $3sQ5x.createStateHook)((0, $1YewZ.store), {
    selector: $8c7bafd209de1659$var$selectHiddenFields
});

});
parcelRegister("1YewZ", function(module, exports) {

$parcel$export(module.exports, "store", () => $cf6a6312e4141eb7$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustedField", () => $cf6a6312e4141eb7$export$df4b0714e8177e0e);
$parcel$export(module.exports, "useIssueAdjustmentsActions", () => $cf6a6312e4141eb7$export$cb9a014ec14556d8);
$parcel$export(module.exports, "useAdjustedScreenTabs", () => $cf6a6312e4141eb7$export$677b3e34bd14c681);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $3whHg = parcelRequire("3whHg");

var $hyCnL = parcelRequire("hyCnL");

var $boEP0 = parcelRequire("boEP0");

var $2NMWZ = parcelRequire("2NMWZ");

var $d30F5 = parcelRequire("d30F5");

var $8e24q = parcelRequire("8e24q");

var $cTj8m = parcelRequire("cTj8m");

var $i4uue = parcelRequire("i4uue");

var $3iUv8 = parcelRequire("3iUv8");

var $b8ZsE = parcelRequire("b8ZsE");

var $jDMtG = parcelRequire("jDMtG");

var $l0b2q = parcelRequire("l0b2q");

var $4MJXd = parcelRequire("4MJXd");

var $gHQFd = parcelRequire("gHQFd");

var $7JtDe = parcelRequire("7JtDe");
const $cf6a6312e4141eb7$var$name = 'issue-adjustments';
const $cf6a6312e4141eb7$export$d4c72bab9d6cc13a = {
    formData: null,
    screenTabs: null,
    appliedChanges: null,
    error: null,
    registeredFieldsDeprecated: {},
    registeredFields: {},
    triggerFieldInitializationKey: 0,
    // Selector checks if this is not equal 0 in the useFieldReady
    numberOfSupportedFields: 0,
    internalFormMetadata: {},
    viewType: null,
    experienceDataIsLoading: false,
    lastProcessedChange: null,
    fieldsInitialization: {
        startTime: null,
        timeoutId: undefined,
        status: 'notStarted'
    },
    appliedChangesHistory: {},
    appsErrors: {},
    notification: null
};
// triggerFieldInitializationKey, viewType and numberOfSupportedFields should not be reset on project or issue type change
const { triggerFieldInitializationKey: $cf6a6312e4141eb7$var$triggerFieldInitializationKey, viewType: $cf6a6312e4141eb7$var$scopedViewType, numberOfSupportedFields: $cf6a6312e4141eb7$var$numberOfSupportedFields, ...$cf6a6312e4141eb7$var$stateForResetAllFields } = $cf6a6312e4141eb7$export$d4c72bab9d6cc13a;
const $cf6a6312e4141eb7$export$e324594224ef24da = {
    triggerFieldInitialization: ()=>({ getState: getState, setState: setState })=>{
            setState({
                triggerFieldInitializationKey: getState().triggerFieldInitializationKey + 1
            });
        },
    processChange: $b8ZsE.processChange,
    setFieldValue: $l0b2q.setFieldValue,
    initializeField: $8e24q.initializeField,
    initializeFields: $8e24q.initializeFields,
    startFieldsInitialisationTimeout: $d30F5.startFieldsInitialisationTimeout,
    successFieldsInitalisation: $d30F5.successFieldsInitalisation,
    registerFields: $jDMtG.registerFields,
    unregisterFields: $jDMtG.unregisterFields,
    updateFields: $gHQFd.updateFields,
    clearAppliedValue: (fieldId)=>({ setState: setState, getState: getState })=>{
            const previousState = getState().appliedChanges || {};
            if (previousState[fieldId]) {
                const { value: value, ...otherFieldChanges } = previousState[fieldId];
                setState({
                    appliedChanges: {
                        ...previousState,
                        [fieldId]: otherFieldChanges
                    }
                });
            }
        },
    resetAllFields: ()=>({ setState: setState, getState: getState })=>{
            // Clear the fieldsInitialization timeout to avoid potetianl side effects.
            clearTimeout(getState().fieldsInitialization.timeoutId);
            setState($cf6a6312e4141eb7$var$stateForResetAllFields);
        },
    setError: $2NMWZ.setError,
    resetError: $2NMWZ.resetError,
    setNumberOfSupportedFields: (numberOfAllSupportedFields)=>({ setState: setState })=>{
            setState({
                numberOfSupportedFields: numberOfAllSupportedFields
            });
        },
    /**
	 * This is used to block onInit for specific case like Issue View background refresh loading.
	 */ setExperienceDataIsLoading: (experienceDataIsLoading)=>({ setState: setState })=>{
            setState({
                experienceDataIsLoading: experienceDataIsLoading
            });
        },
    setAppErrors: $3whHg.setAppErrors,
    resetAppErrors: $3whHg.resetAppErrors,
    addAppsErrors: $3whHg.addAppsErrors,
    initializeNoScreenTab: $cTj8m.initializeNoScreenTab,
    initializeScreenTabs: $i4uue.initializeScreenTabs,
    updateScreenTabs: $7JtDe.updateScreenTabs,
    updateActiveScreenTab: $4MJXd.updateActiveScreenTab,
    detectAppliedChangesConflicts: $hyCnL.detectAppliedChangesConflicts,
    collectScreenTabsAppliedChangesHistory: $boEP0.collectScreenTabsAppliedChangesHistory,
    collectFieldsAppliedChangesHistory: $boEP0.collectFieldsAppliedChangesHistory,
    setNotification: $3iUv8.setNotification,
    resetNotification: $3iUv8.resetNotification
};
const $cf6a6312e4141eb7$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: $cf6a6312e4141eb7$var$name,
    initialState: $cf6a6312e4141eb7$export$d4c72bab9d6cc13a,
    actions: $cf6a6312e4141eb7$export$e324594224ef24da
});
const $cf6a6312e4141eb7$export$37792a602e748c08 = (0, $3sQ5x.createHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9);
const $cf6a6312e4141eb7$var$stableEmptyFieldFromIframe = {};
const $cf6a6312e4141eb7$export$c76e674a29843e21 = (0, $3sQ5x.createHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9, {
    selector: (state)=>state.appliedChanges
});
const $cf6a6312e4141eb7$export$df4b0714e8177e0e = (0, $3sQ5x.createHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9, {
    selector: (state, fieldId)=>state.appliedChanges?.[fieldId] || $cf6a6312e4141eb7$var$stableEmptyFieldFromIframe
});
const $cf6a6312e4141eb7$export$cb9a014ec14556d8 = (0, $3sQ5x.createActionsHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9);
const $cf6a6312e4141eb7$export$677b3e34bd14c681 = (0, $3sQ5x.createHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9, {
    selector: (state)=>state.screenTabs
});

});
parcelRegister("3whHg", function(module, exports) {

$parcel$export(module.exports, "setAppErrors", () => $87bccf3deeafaa75$export$7054e2f8e68cf0dd);
$parcel$export(module.exports, "addAppsErrors", () => $87bccf3deeafaa75$export$903d525e420c7d00);
$parcel$export(module.exports, "resetAppErrors", () => $87bccf3deeafaa75$export$24c821207687a907);
const $87bccf3deeafaa75$export$7054e2f8e68cf0dd = ({ errors: errors, appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: errors
            }
        });
    };
const $87bccf3deeafaa75$export$903d525e420c7d00 = ({ errors: errors })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        const appsErrors = Object.entries(errors).reduce((acc, [appId, appErrors])=>{
            acc[appId] = [
                ...acc[appId] ?? [],
                ...appErrors
            ];
            return acc;
        }, {
            ...previousState
        });
        setState({
            appsErrors: appsErrors
        });
    };
const $87bccf3deeafaa75$export$24c821207687a907 = ({ appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: null
            }
        });
    };

});

parcelRegister("hyCnL", function(module, exports) {

$parcel$export(module.exports, "detectAppliedChangesConflicts", () => $4c0b86f075c0ff6b$export$90d94f20d157e756);

var $gKZoD = parcelRequire("gKZoD");

var $2jyqu = parcelRequire("2jyqu");


var $3whHg = parcelRequire("3whHg");

var $3iUv8 = parcelRequire("3iUv8");

var $lLAXK = parcelRequire("lLAXK");
const $4c0b86f075c0ff6b$var$HISTORY_LOG_TTL = 60000;
/**
 * Tidies up applied changes history by removing old entries by TTL.
 * It keeps the current changeId in history.
 */ const $4c0b86f075c0ff6b$var$tidyUpAppliedChangesHistory = (appliedChangesHistory, changeId)=>Object.fromEntries(Object.entries(appliedChangesHistory).filter(([existingChangeId, history])=>{
        return Date.now() - history.createdAt <= $4c0b86f075c0ff6b$var$HISTORY_LOG_TTL || existingChangeId === changeId;
    }));
const $4c0b86f075c0ff6b$export$90d94f20d157e756 = ({ appId: appId, changeId: changeId })=>({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        (0, $gKZoD.di)((0, $2jyqu.fireOperationalEvent));
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        const tidyAppliedChangesHistory = $4c0b86f075c0ff6b$var$tidyUpAppliedChangesHistory(appliedChangesHistory, changeId);
        setState({
            appliedChangesHistory: tidyAppliedChangesHistory
        });
        const appliedChangesHistoryChangeId = tidyAppliedChangesHistory[changeId];
        const newChanges = appliedChangesHistoryChangeId?.apps[appId];
        if (!appliedChangesHistoryChangeId || !newChanges || // No need to run conflicts checks for the first item in history
        Object.keys(appliedChangesHistoryChangeId.apps).length <= 1) return;
        const lifecycleHook = changeId === (0, $19ec31e354320eb2$export$415cc1afa6445f90) ? 'onInit' : 'onChange';
        const { appErrorsMap: appErrorsMap, conflicts: conflicts } = (0, $lLAXK.collectConflicts)({
            appliedChangesHistory: appliedChangesHistoryChangeId.apps,
            newChanges: newChanges,
            appIdOfNewChanges: appId,
            lifecycleHook: lifecycleHook
        });
        if (conflicts.length) {
            (0, $2jyqu.fireOperationalEvent)(createAnalyticsEvent, {
                action: 'conflicted',
                actionSubject: 'jiraUiModifications.appliedChangesHistory',
                attributes: {
                    conflictsCount: conflicts.length,
                    conflicts: conflicts,
                    conflictedApps: Object.keys(appErrorsMap),
                    viewType: viewType
                }
            });
            dispatch((0, $3whHg.addAppsErrors)({
                errors: appErrorsMap
            }));
            dispatch((0, $3iUv8.setNotification)({
                type: 'MULTIPLE_APPS_CONFLICTS'
            }));
        }
    };

});
parcelRegister("2jyqu", function(module, exports) {

$parcel$export(module.exports, "fireOperationalEvent", () => $9253211b05747618$export$a1fb57756f0de62b);

var $gB4mS = parcelRequire("gB4mS");


const $9253211b05747618$export$a1fb57756f0de62b = (createAnalyticsEvent, eventPayload)=>{
    (0, $gB4mS.default)((0, $aded369bac156944$export$8280e5c6104c5b40))({
        ...eventPayload,
        analyticsType: (0, $6e65040b988c460f$export$12346a674644c156)
    })(createAnalyticsEvent);
};

});
const $6e65040b988c460f$export$f636b5b56f1d624a = 'Screen';
const $6e65040b988c460f$export$9d2de6eebf7462b5 = 'Drawer';
const $6e65040b988c460f$export$1171103ea9083ffa = 'Modal';
const $6e65040b988c460f$export$cae2783c9279926 = 'InlineDialog';
const $6e65040b988c460f$export$d1123261ca8831d2 = 'Dropdown';
const $6e65040b988c460f$export$a1562d08625f5d7e = 'UI';
const $6e65040b988c460f$export$947dac6c72b26f81 = 'TRACK';
const $6e65040b988c460f$export$f1d537d508d2945a = 'SCREEN';
const $6e65040b988c460f$export$12346a674644c156 = 'OPERATIONAL';
const $6e65040b988c460f$export$2ceccf177fae277c = 'analyticsBridge';

const $aded369bac156944$export$8280e5c6104c5b40 = 'ui-modifications';


const $19ec31e354320eb2$export$415cc1afa6445f90 = 'onInitChangeId';
const $19ec31e354320eb2$export$811b7f067a43b422 = 'jira:uiModifications';

parcelRegister("3iUv8", function(module, exports) {

$parcel$export(module.exports, "setNotification", () => $547ed651019edc98$export$b9c5e783593ff01d);
$parcel$export(module.exports, "resetNotification", () => $547ed651019edc98$export$caafa3945f199bc7);
const $547ed651019edc98$export$b9c5e783593ff01d = (notificationProperties)=>({ setState: setState })=>{
        setState({
            notification: {
                type: notificationProperties.type
            }
        });
    };
const $547ed651019edc98$export$caafa3945f199bc7 = ()=>({ setState: setState })=>{
        setState({
            notification: null
        });
    };

});

parcelRegister("lLAXK", function(module, exports) {

$parcel$export(module.exports, "collectConflicts", () => $5d47c6c300e4a9ca$export$a06103ec99e4e394);

var $fr1K2 = parcelRequire("fr1K2");


var $bCvSM = parcelRequire("bCvSM");

const $5d47c6c300e4a9ca$var$MESSAGE_SUFFIX = 'Modifications have been applied, but it may lead to inconsistency for the user.';
const $5d47c6c300e4a9ca$var$mapToAppErrors = ({ conflicts: conflicts, lifecycleHook: lifecycleHook })=>{
    const appErrors = conflicts.map((change)=>{
        if (change.type === (0, $78805f0b93715186$export$f674b7a3bbd94b5)) return {
            type: (0, $ca611ff348f89182$export$2a3fdceaae2188d5),
            cause: (0, $ca611ff348f89182$export$877da1000325f8b5),
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified screen tabs in the '${lifecycleHook}' at the same trigger. ${$5d47c6c300e4a9ca$var$MESSAGE_SUFFIX}`
        };
        const { fieldId: fieldId, fieldType: fieldType, property: property } = change;
        const method = (0, $bCvSM.mapFieldPropertyToApiMethod)(property);
        return {
            type: (0, $ca611ff348f89182$export$2a3fdceaae2188d5),
            cause: (0, $ca611ff348f89182$export$e4ac32edd5da2ee7),
            fieldId: fieldId,
            fieldType: fieldType,
            method: method,
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified the same field: '${fieldId}' by its method: '${method}' in the '${lifecycleHook}' at the same trigger. ${$5d47c6c300e4a9ca$var$MESSAGE_SUFFIX}`
        };
    });
    return appErrors;
};
const $5d47c6c300e4a9ca$export$a06103ec99e4e394 = ({ appliedChangesHistory: appliedChangesHistory, newChanges: newChanges, appIdOfNewChanges: appIdOfNewChanges, lifecycleHook: lifecycleHook })=>{
    return Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(appliedChangesHistory, appIdOfNewChanges)).reduce((acc, [appId, previousChanges])=>{
        const previousChangesKeys = Object.keys(previousChanges);
        // Compares previous changes with new changes keys
        const conflicts = Object.entries(newChanges).filter(([changeKey, _])=>previousChangesKeys.includes(changeKey)).map(([_, change])=>({
                ...change,
                lifecycleHook: lifecycleHook,
                appIds: [
                    appId,
                    appIdOfNewChanges
                ]
            }));
        acc.conflicts.push(...conflicts);
        // Maps conflicts to app errors
        const appErrors = $5d47c6c300e4a9ca$var$mapToAppErrors({
            conflicts: conflicts,
            lifecycleHook: lifecycleHook
        });
        if (appErrors.length > 0) {
            acc.appErrorsMap[appId] = appErrors;
            // App errors for `appIdOfNewChanges` may already exists from the previous iteration.
            // We need to merge them to avoid overwriting and keep all errors.
            acc.appErrorsMap[appIdOfNewChanges] = [
                ...acc.appErrorsMap[appIdOfNewChanges] ?? [],
                ...appErrors
            ];
        }
        return acc;
    }, {
        appErrorsMap: {},
        conflicts: []
    });
};

});
const $ca611ff348f89182$export$fd26696d109785a0 = 'SCREENTABS_VALIDATION_FAILED';
const $ca611ff348f89182$export$d1996cb46a690190 = 'FIELD_VALIDATION_FAILED';
const $ca611ff348f89182$export$8042247b663edbcc = 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD';
const $ca611ff348f89182$export$2a3fdceaae2188d5 = 'MULTIPLE_APPS_CONFLICT';
const $ca611ff348f89182$export$e4ac32edd5da2ee7 = 'FIELD';
const $ca611ff348f89182$export$877da1000325f8b5 = 'SCREENTABS';

parcelRegister("bCvSM", function(module, exports) {

$parcel$export(module.exports, "mapFieldPropertyToApiMethod", () => $b1dea33557091402$export$e1cc7da28a1c4bb7);
const $b1dea33557091402$var$SET_NAME_METHOD = 'setName';
const $b1dea33557091402$var$SET_DESCRIPTION_METHOD = 'setDescription';
const $b1dea33557091402$var$SET_VISIBLE_METHOD = 'setVisible';
const $b1dea33557091402$var$SET_READ_ONLY_METHOD = 'setReadOnly';
const $b1dea33557091402$var$SET_VALUE_METHOD = 'setValue';
const $b1dea33557091402$var$SET_REQUIRED_METHOD = 'setRequired';
const $b1dea33557091402$var$SET_OPTIONS_VISIBILITY_METHOD = 'setOptionsVisibility';
const $b1dea33557091402$export$8325709d137b2606 = {
    fieldName: $b1dea33557091402$var$SET_NAME_METHOD,
    description: $b1dea33557091402$var$SET_DESCRIPTION_METHOD,
    isVisible: $b1dea33557091402$var$SET_VISIBLE_METHOD,
    isReadOnly: $b1dea33557091402$var$SET_READ_ONLY_METHOD,
    value: $b1dea33557091402$var$SET_VALUE_METHOD,
    isRequired: $b1dea33557091402$var$SET_REQUIRED_METHOD,
    optionsVisibility: $b1dea33557091402$var$SET_OPTIONS_VISIBILITY_METHOD
};
const $b1dea33557091402$export$e1cc7da28a1c4bb7 = (fieldProperty)=>{
    const method = $b1dea33557091402$export$8325709d137b2606[fieldProperty];
    if (!method) throw new Error(`No method found for field property: ${fieldProperty}`);
    return method;
};

});

const $78805f0b93715186$export$f674b7a3bbd94b5 = 'SCREEN_TABS';
const $78805f0b93715186$export$4a9f236a0db33834 = 'FIELD';



parcelRegister("boEP0", function(module, exports) {

$parcel$export(module.exports, "collectScreenTabsAppliedChangesHistory", () => $f5288ff27f25fb7e$export$1d2b7abeeea36239);
$parcel$export(module.exports, "collectFieldsAppliedChangesHistory", () => $f5288ff27f25fb7e$export$7d0f534e5b16dcc9);


var $3vp6H = parcelRequire("3vp6H");
const $f5288ff27f25fb7e$var$prepareAppliedChangesHistoryForSingleChange = ({ currentAppliedChangesHistory: currentAppliedChangesHistory, appId: appId, changeId: changeId, newSingleAppChange: newSingleAppChange })=>{
    const appliedChangesHistoryChangeId = currentAppliedChangesHistory[changeId] ?? {};
    const appliedChangesHistoryChangeIdApp = appliedChangesHistoryChangeId.apps?.[appId] ?? {};
    return {
        ...currentAppliedChangesHistory,
        [changeId]: {
            apps: {
                ...appliedChangesHistoryChangeId.apps,
                [appId]: {
                    ...appliedChangesHistoryChangeIdApp,
                    ...newSingleAppChange
                }
            },
            createdAt: appliedChangesHistoryChangeId.createdAt ?? Date.now()
        }
    };
};
const $f5288ff27f25fb7e$export$1d2b7abeeea36239 = ({ appId: appId, changeId: changeId, screenTabs: screenTabs })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        if (!screenTabs.length) return;
        const newAppliedChangesHistory = $f5288ff27f25fb7e$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: {
                tabs: {
                    type: (0, $78805f0b93715186$export$f674b7a3bbd94b5)
                }
            }
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };
const $f5288ff27f25fb7e$export$7d0f534e5b16dcc9 = ({ appId: appId, changeId: changeId, fieldsChanges: fieldsChanges })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory, internalFormMetadata: internalFormMetadata } = getState();
        const singleAppChange = (0, $3vp6H.normalizeFieldsAppliedChangesForHistory)({
            fieldsChanges: fieldsChanges,
            internalFormMetadata: internalFormMetadata
        });
        const newAppliedChangesHistory = $f5288ff27f25fb7e$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: singleAppChange
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };

});
parcelRegister("3vp6H", function(module, exports) {

$parcel$export(module.exports, "normalizeFieldsAppliedChangesForHistory", () => $23bcfa1804fc8fad$export$8a23b3e9a1749620);

const $23bcfa1804fc8fad$var$normalizeFieldForHistory = (fieldId, fieldChanges, fieldMetadata)=>{
    // Can't type Object.keys in a better way
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(fieldChanges).reduce((acc, property)=>{
        const normalizedKey = `${fieldId}|${property}`;
        acc[normalizedKey] = {
            fieldId: fieldId,
            fieldType: fieldMetadata.fieldType,
            property: property,
            type: (0, $78805f0b93715186$export$4a9f236a0db33834)
        };
        return acc;
    }, {});
};
const $23bcfa1804fc8fad$export$8a23b3e9a1749620 = ({ fieldsChanges: fieldsChanges, internalFormMetadata: internalFormMetadata })=>{
    return Object.entries(fieldsChanges).reduce((acc, [fieldId, fieldChanges])=>{
        const fieldMetadata = internalFormMetadata[fieldId];
        if (!fieldMetadata) return acc;
        const normalizedFieldHistory = $23bcfa1804fc8fad$var$normalizeFieldForHistory(fieldId, fieldChanges, fieldMetadata);
        Object.assign(acc, normalizedFieldHistory);
        return acc;
    }, {});
};

});


parcelRegister("2NMWZ", function(module, exports) {

$parcel$export(module.exports, "setError", () => $13e2b126ca97f7fe$export$b8d0bb2aa0adefe5);
$parcel$export(module.exports, "resetError", () => $13e2b126ca97f7fe$export$7e5930c6217b1d4e);
const $13e2b126ca97f7fe$export$b8d0bb2aa0adefe5 = (errorProperties)=>({ setState: setState })=>{
        setState({
            error: {
                errorCode: errorProperties.errorCode,
                fieldName: errorProperties.fieldName
            }
        });
    };
const $13e2b126ca97f7fe$export$7e5930c6217b1d4e = ()=>({ setState: setState })=>{
        setState({
            error: null
        });
    };

});

parcelRegister("d30F5", function(module, exports) {

$parcel$export(module.exports, "startFieldsInitialisationTimeout", () => $e08f4de833312075$export$2c0f020b89dfa30b);
$parcel$export(module.exports, "successFieldsInitalisation", () => $e08f4de833312075$export$cf768a695e83eefa);

var $gKZoD = parcelRequire("gKZoD");

var $2jyqu = parcelRequire("2jyqu");

var $1FDIy = parcelRequire("1FDIy");

var $2NMWZ = parcelRequire("2NMWZ");
const $e08f4de833312075$var$getTimeout = ()=>50000;
const $e08f4de833312075$var$getFieldsInitializationTime = (startTime)=>startTime !== null ? performance.now() - startTime : null;
const $e08f4de833312075$var$isFieldInitialisationComplete = (status)=>status === 'success' || status === 'timedOut';
const $e08f4de833312075$export$2c0f020b89dfa30b = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { fieldsInitialization: fieldsInitialization } = getState();
        if (fieldsInitialization.timeoutId === undefined && fieldsInitialization.status === 'notStarted') {
            const timeoutId = setTimeout(()=>dispatch($e08f4de833312075$export$8ce83a9201590a5e({
                    createAnalyticsEvent: createAnalyticsEvent
                })), $e08f4de833312075$var$getTimeout());
            setState({
                fieldsInitialization: {
                    startTime: performance.now(),
                    timeoutId: timeoutId,
                    status: 'inProgress'
                }
            });
        }
    };
const $e08f4de833312075$export$8ce83a9201590a5e = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gKZoD.di)((0, $2jyqu.fireOperationalEvent));
        const { formData: formData, experienceDataIsLoading: experienceDataIsLoading, numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { startTime: startTime, status: status } = fieldsInitialization;
        if ($e08f4de833312075$var$isFieldInitialisationComplete(status) || (0, $1FDIy.selectReadyPublicDataForOnInit)(getState(), {
            viewType: viewType
        }) !== null) return;
        dispatch((0, $2NMWZ.setError)({
            errorCode: 'ON_INIT_FIELDS_INITIALIZATION_TIMEOUT'
        }));
        (0, $2jyqu.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'timedOut',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                configuredTimeout: $e08f4de833312075$var$getTimeout(),
                fieldsInitializationTime: $e08f4de833312075$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: Object.keys(formData ?? {}).length,
                experienceDataIsLoading: experienceDataIsLoading,
                supportedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'timedOut'
            }
        });
    };
const $e08f4de833312075$export$cf768a695e83eefa = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        (0, $gKZoD.di)((0, $2jyqu.fireOperationalEvent));
        const { status: status } = getState().fieldsInitialization;
        if ($e08f4de833312075$var$isFieldInitialisationComplete(status)) return;
        const { numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { timeoutId: timeoutId, startTime: startTime } = fieldsInitialization;
        clearTimeout(timeoutId);
        (0, $2jyqu.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                fieldsInitializationTime: $e08f4de833312075$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'success'
            }
        });
    };

});
parcelRegister("1FDIy", function(module, exports) {

$parcel$export(module.exports, "selectReadyPublicDataForOnInit", () => $9ea7c26aba3c4975$export$4cadeedb8c3f31f7);

var $6dDSs = parcelRequire("6dDSs");
const $9ea7c26aba3c4975$export$4cadeedb8c3f31f7 = (0, $6dDSs.createSelector)((state)=>state.formData, (state)=>state.numberOfSupportedFields, (state)=>state.screenTabs, (state)=>state.experienceDataIsLoading, (formData, numberOfSupportedFields, screenTabsData, experienceDataIsLoading)=>{
    if (formData !== null && screenTabsData !== null && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return {
        formData: formData,
        screenTabsData: screenTabsData
    };
    return null;
});

});


parcelRegister("8e24q", function(module, exports) {

$parcel$export(module.exports, "initializeField", () => $c1b779e01c06a231$export$6b51e123e61a9615);
$parcel$export(module.exports, "initializeFields", () => $c1b779e01c06a231$export$4a6b4707110b0552);

var $iLSUx = parcelRequire("iLSUx");
const $c1b779e01c06a231$export$6b51e123e61a9615 = ({ field: field, metadata: metadata })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData = {} } = getState();
        const fieldMetadata = {
            allowedValues: field.allowedValues,
            isReadOnlyBySystem: field.isReadOnly,
            isRequiredBySystem: field.isRequired,
            fieldRenderer: metadata?.fieldRenderer,
            fieldType: field.fieldType
        };
        const publicValue = (0, $iLSUx.mapFieldValueFromInternalToPublic)({
            fieldMetadata: fieldMetadata,
            internalFieldValue: field.value,
            fieldType: field.fieldType,
            viewType: viewType
        });
        setState({
            formData: {
                ...formData,
                [field.fieldId]: {
                    fieldId: field.fieldId,
                    fieldName: field.fieldName,
                    description: field.description,
                    isVisible: field.isVisible,
                    fieldType: field.fieldType,
                    isReadOnly: field.isReadOnly,
                    isRequired: field.isRequired,
                    value: publicValue,
                    optionsVisibility: undefined
                }
            },
            internalFormMetadata: {
                ...internalFormMetadata,
                [field.fieldId]: fieldMetadata
            }
        });
    };
const $c1b779e01c06a231$export$4a6b4707110b0552 = (fields)=>({ setState: setState }, { viewType: viewType })=>{
        const { formData: formData, internalFormMetadata: internalFormMetadata } = fields.reduce((acc, { field: field, metadata: metadata })=>{
            const fieldMetadata = {
                allowedValues: field.allowedValues,
                isReadOnlyBySystem: field.isReadOnly,
                isRequiredBySystem: field.isRequired,
                fieldRenderer: metadata?.fieldRenderer,
                fieldType: field.fieldType
            };
            const publicValue = (0, $iLSUx.mapFieldValueFromInternalToPublic)({
                fieldMetadata: fieldMetadata,
                internalFieldValue: field.value,
                fieldType: field.fieldType,
                viewType: viewType
            });
            acc.formData[field.fieldId] = {
                fieldId: field.fieldId,
                fieldName: field.fieldName,
                description: field.description,
                isVisible: field.isVisible,
                fieldType: field.fieldType,
                isReadOnly: field.isReadOnly,
                isRequired: field.isRequired,
                value: publicValue,
                optionsVisibility: undefined
            };
            acc.internalFormMetadata[field.fieldId] = fieldMetadata;
            return acc;
        }, {
            internalFormMetadata: {},
            formData: {}
        });
        setState({
            formData: formData,
            internalFormMetadata: internalFormMetadata,
            numberOfSupportedFields: fields.length
        });
    };

});
parcelRegister("iLSUx", function(module, exports) {

$parcel$export(module.exports, "mapFieldValueFromInternalToPublic", () => $4854c3676fce92c1$export$50806045b617d116);

var $gKZoD = parcelRequire("gKZoD");

var $cmmj3 = parcelRequire("cmmj3");

var $gL80q = parcelRequire("gL80q");
const $4854c3676fce92c1$export$50806045b617d116 = ({ fieldMetadata: fieldMetadata, internalFieldValue: internalFieldValue, fieldType: fieldType, viewType: viewType })=>{
    (0, $gKZoD.di)((0, $cmmj3.fireErrorAnalytics), (0, $gL80q.getSupportedFieldConfiguration));
    if (fieldMetadata === undefined) throw new Error('Attempt to set value for the uninitialized field');
    let value = internalFieldValue;
    try {
        const valueTransformer = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType)?.internalToPublicTransformers.value;
        if (valueTransformer) /**
			 * We trust that the internal field data is in the correct shape.
			 * Data that is in the incorrect shape will result in error events
			 * being logged for further investigation. In this error case we will
			 * pass `null` as the value to unblock onInit for the apps
			 *
			 * The `fieldRenderer` passed to the `valueTransformer` is used only for
			 * rich text fields and will be `undefined` for most of the executions
			 */ value = valueTransformer(internalFieldValue, fieldMetadata?.fieldRenderer);
    } catch (error) {
        value = null;
        (0, $cmmj3.fireErrorAnalytics)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return value;
};

});
parcelRegister("cmmj3", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalytics", () => $1359a69054531aa4$export$a27c21aa3ed8f0f1);

var $1nF7O = parcelRequire("1nF7O");

var $z11xo = parcelRequire("z11xo");
const $1359a69054531aa4$export$1bee4e6be783dd26 = (message)=>message.replaceAll(/\w+@[\w.]+/gi, '***@***');
const $1359a69054531aa4$export$a27c21aa3ed8f0f1 = ({ error: error, id: id, viewType: viewType, attributes: attributes = {}, event: event })=>{
    const errorType = (0, $z11xo.getErrorType)(error);
    const packageName = `${viewType}jiraUiModifications`;
    (0, $1nF7O.fireErrorAnalytics)({
        event: event,
        meta: {
            id: id,
            packageName: packageName,
            teamName: 'unbox'
        },
        error: error,
        attributes: {
            errorType: errorType,
            errorMessage: typeof error.message === 'string' ? $1359a69054531aa4$export$1bee4e6be783dd26(error.message) : error.message,
            ...attributes
        }
    });
};

});
parcelRegister("z11xo", function(module, exports) {

$parcel$export(module.exports, "getErrorType", () => $df5192e881ed2750$export$e19f9f08a6d79fd2);

var $3HlI9 = parcelRequire("3HlI9");
const $df5192e881ed2750$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504'
};
const $df5192e881ed2750$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $df5192e881ed2750$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $df5192e881ed2750$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $df5192e881ed2750$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $df5192e881ed2750$export$89a175d4190df42e = 'Invoke value functions failed:';
const $df5192e881ed2750$export$215c097832f3122d = 'AGG_UNDERLYING_SERVICE_TIMEOUT';
const $df5192e881ed2750$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $df5192e881ed2750$var$BAD_REQUEST = 400;
const $df5192e881ed2750$var$REQUEST_TIMEOUT = 408;
const $df5192e881ed2750$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if (typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed',
        'Cannot find module'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $df5192e881ed2750$export$e19f9f08a6d79fd2 = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
    if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $df5192e881ed2750$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $df5192e881ed2750$export$23de3198bfe70090;
    // Add here errors related to a broken app configuration/manifest
    if (message.startsWith('Function definition is invalid.')) return 'APP_DEV_ERROR';
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($df5192e881ed2750$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const aggUnderlyingServiceTimeoutRegex = new RegExp('The underlying service call timed out', 'i');
    if (aggUnderlyingServiceTimeoutRegex.test(message)) return $df5192e881ed2750$export$215c097832f3122d;
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($df5192e881ed2750$export$89a175d4190df42e, 'i');
    /**
	 * In case when we get bad request(400) from the BE it should be treated as an app error as there
	 * are many ways to fail the value function
	 */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === $df5192e881ed2750$var$BAD_REQUEST;
    /**
	 * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
	 * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
	 */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === $df5192e881ed2750$var$REQUEST_TIMEOUT;
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    /*
	 * 	Whole message:
	 *	Fetching formatted value after edit failed: FetchError: Fetch call failed with status code: 429
	 */ const valueFunctionEditRateLimitedRegex = new RegExp('Fetch call failed with status code: 429', 'i');
    /*
	 * 	Whole message:
	 *	Invoke value functions failed: Error server response: 429
	 */ const valueFunctionInvokeRateLimitedRegex = new RegExp('Error server response: 429', 'i');
    if (valueFunctionEditRateLimitedRegex.test(message) || valueFunctionInvokeRateLimitedRegex.test(message)) return $df5192e881ed2750$export$7a1bd8c001e7e9c;
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($df5192e881ed2750$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    const entry = Object.entries($df5192e881ed2750$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $3HlI9.isClientFetchError)(error)) return $df5192e881ed2750$export$f52aa41ccd776f01;
    if (error != null && 'statusCode' in error && error.statusCode === 429) return 'RATE_LIMITING';
    return 'OTHER';
};

});
parcelRegister("3HlI9", function(module, exports) {

$parcel$export(module.exports, "isClientFetchError", () => $cbf82ad04131c769$export$2e7adc44463c3f4f);
// Copied from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Exclude client connectivity and HTTP client network errors as a SLO failure
// e.g. during quick SPA transition when a network call haven't finished yet,
// or when the user's internet connection drops out.
const $cbf82ad04131c769$export$c748438cec453c9f = [
    '... is not valid JSON',
    'server with the specified hostname could not be found',
    'cannot parse response',
    'connection failure',
    'Failed to fetch',
    'in JSON at position 0',
    'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
    'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'Syntax or http error',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted',
    'Unable to fetch manifest',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'dynamically imported module',
    'Importing a module script failed'
];
const $cbf82ad04131c769$export$3876cb851aa46193 = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $cbf82ad04131c769$var$isClientFetchErrorMessage = (message)=>Boolean(message) && $cbf82ad04131c769$export$c748438cec453c9f.some((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
const $cbf82ad04131c769$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($cbf82ad04131c769$export$3876cb851aa46193.includes(error.name) || $cbf82ad04131c769$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($cbf82ad04131c769$export$3876cb851aa46193.includes(error.cause.name) || $cbf82ad04131c769$var$isClientFetchErrorMessage(error.cause.message)));

});



parcelRegister("gL80q", function(module, exports) {

$parcel$export(module.exports, "getSupportedFieldConfiguration", () => $968cd36658e5c86e$export$8fc8d6775f1842b8);
$parcel$export(module.exports, "isFieldTypeSupported", () => $968cd36658e5c86e$export$b47920a5dd99844f);
$parcel$export(module.exports, "getConsentMessage", () => $968cd36658e5c86e$export$20eabd2b3ada6bf3);
$parcel$export(module.exports, "isExecutionContextSupported", () => $968cd36658e5c86e$export$b768d6a95f7a930);
$parcel$export(module.exports, "getAnalytics", () => $968cd36658e5c86e$export$b0297573c90085aa);
$parcel$export(module.exports, "isTriggerPointSupported", () => $968cd36658e5c86e$export$ef45e4471aa21b27);

var $cmmj3 = parcelRequire("cmmj3");

var $3OTqu = parcelRequire("3OTqu");
const $968cd36658e5c86e$var$isKeyOf = (key, object)=>object[key] !== undefined;
const $968cd36658e5c86e$var$getConfigurationByViewType = ({ viewType: viewType })=>{
    const viewConfiguration = (0, $3OTqu.getViewConfiguration)(viewType);
    if (!viewConfiguration) throw new Error(`Unsupported view type ${viewType} in getConfigurationByViewType.`);
    return viewConfiguration;
};
function $968cd36658e5c86e$export$8fc8d6775f1842b8(viewType, fieldType) {
    const fieldsConfiguration = $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldsConfiguration();
    if (!$968cd36658e5c86e$var$isKeyOf(fieldType, fieldsConfiguration)) {
        (0, $cmmj3.fireErrorAnalytics)({
            error: new Error('Unsupported field type.'),
            id: 'getSupportedFieldConfiguration',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
        return undefined;
    }
    return fieldsConfiguration[fieldType];
}
const $968cd36658e5c86e$export$e4330d77fd93d1de = (viewType)=>$968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldTypes();
function $968cd36658e5c86e$export$b47920a5dd99844f(viewType, fieldType) {
    return fieldType !== undefined && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $968cd36658e5c86e$export$e4330d77fd93d1de(viewType).includes(fieldType);
}
function $968cd36658e5c86e$export$20eabd2b3ada6bf3(viewType) {
    return $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getConsentMessage();
}
function $968cd36658e5c86e$export$b768d6a95f7a930(context) {
    return $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: context.viewType
    }).isExecutionContextSupported({
        context: context
    });
}
function $968cd36658e5c86e$export$b0297573c90085aa(viewType) {
    return $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getAnalytics();
}
function $968cd36658e5c86e$export$c0728caa743a409e(viewType) {
    return $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedTriggerPointsConfiguration();
}
const $968cd36658e5c86e$export$ef45e4471aa21b27 = (viewType, triggerPoint)=>triggerPoint !== undefined && $968cd36658e5c86e$export$c0728caa743a409e(viewType).has(triggerPoint);

});
parcelRegister("3OTqu", function(module, exports) {

$parcel$export(module.exports, "getViewConfiguration", () => $b8beb3418915829f$export$176b6e68da08ffa2);
$parcel$export(module.exports, "useLoadViewConfiguration", () => $b8beb3418915829f$export$f0022a21ccd1f6be);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");
const $b8beb3418915829f$var$VIEW_CONFIGURATIONS = new Map();
const $b8beb3418915829f$export$cda1ad403b37fe70 = (viewType, configuration)=>{
    if (!$b8beb3418915829f$var$VIEW_CONFIGURATIONS.has(viewType)) $b8beb3418915829f$var$VIEW_CONFIGURATIONS.set(viewType, configuration);
};
const $b8beb3418915829f$export$176b6e68da08ffa2 = (viewType)=>$b8beb3418915829f$var$VIEW_CONFIGURATIONS.get(viewType);
const $b8beb3418915829f$export$e8091eff40c4f16e = ()=>{
    $b8beb3418915829f$var$VIEW_CONFIGURATIONS.clear();
};
const $b8beb3418915829f$export$f0022a21ccd1f6be = (viewType, configurationClass)=>{
    (0, $gKZoD.di)($b8beb3418915829f$export$cda1ad403b37fe70);
    /**
	 * Uses useState to load view configuration on component mount, before rendering.
	 */ (0, $5uXOq.useState)(()=>{
        $b8beb3418915829f$export$cda1ad403b37fe70(viewType, new configurationClass());
    });
};

});




parcelRegister("cTj8m", function(module, exports) {

$parcel$export(module.exports, "initializeNoScreenTab", () => $b87f070d69e40149$export$93459ad9bfd6c380);
const $b87f070d69e40149$export$93459ad9bfd6c380 = ()=>({ setState: setState })=>{
        setState({
            screenTabs: []
        });
    };

});

parcelRegister("i4uue", function(module, exports) {

$parcel$export(module.exports, "initializeScreenTabs", () => $559bbe3e01414de7$export$7f7be235f64f029b);
const $559bbe3e01414de7$export$7f7be235f64f029b = ({ tabs: tabs, selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: internalScreenTabs } = getState();
        const previouslySelected = internalScreenTabs?.findIndex((tab)=>tab.isActive);
        setState({
            screenTabs: tabs.map(({ id: id }, index)=>({
                    id: id,
                    isVisible: true,
                    isActive: index === selected || index === previouslySelected
                }))
        });
    };

});

parcelRegister("b8ZsE", function(module, exports) {

$parcel$export(module.exports, "processChange", () => $926b03f8c2e312a1$export$352dfcce04d66748);

var $3ZT8o = parcelRequire("3ZT8o");

var $gKZoD = parcelRequire("gKZoD");

var $gL80q = parcelRequire("gL80q");

var $l6AQO = parcelRequire("l6AQO");
const $926b03f8c2e312a1$export$352dfcce04d66748 = ({ fieldId: fieldId, fieldValue: fieldValue, eventType: eventType })=>({ setState: setState, getState: getState }, { viewType: viewType })=>{
        (0, $gKZoD.di)((0, (/*@__PURE__*/$parcel$interopDefault($3ZT8o))));
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        const fieldType = internalFormMetadata[fieldId]?.fieldType;
        if (!fieldType) return;
        const emitChangeOn = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType)?.emitChangeOn;
        if (emitChangeOn !== eventType) return;
        const nextFormData = (0, $l6AQO.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        /**
		 * setTimeout justification - we need to delay the state update to the next tick to avoid batched updates.
		 * Otherwise, UIM app may not be notified about every single change.
		 */ setTimeout(()=>{
            const changeId = (0, (/*@__PURE__*/$parcel$interopDefault($3ZT8o)))();
            setState({
                lastProcessedChange: {
                    fieldId: fieldId,
                    changeId: changeId
                },
                formData: nextFormData
            });
        }, 0);
    };

});
parcelRegister("3ZT8o", function(module, exports) {

var $jJVtR = parcelRequire("jJVtR");
/** Used to generate unique IDs. */ var $2e91d6202798e8a1$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $2e91d6202798e8a1$var$uniqueId(prefix) {
    var id = ++$2e91d6202798e8a1$var$idCounter;
    return $jJVtR(prefix) + id;
}
module.exports = $2e91d6202798e8a1$var$uniqueId;

});

parcelRegister("l6AQO", function(module, exports) {

$parcel$export(module.exports, "calculateNextFormValue", () => $2b658e9f553d1ad3$export$25441a03bb8f1cb0);

var $ajpes = parcelRequire("ajpes");

var $iLSUx = parcelRequire("iLSUx");
const $2b658e9f553d1ad3$export$25441a03bb8f1cb0 = ({ internalFormMetadata: internalFormMetadata, formData: formData, fieldId: fieldId, fieldValue: fieldValue, fieldType: fieldType, viewType: viewType })=>{
    if (formData === null) return null;
    let newPublicValue;
    try {
        newPublicValue = (0, $iLSUx.mapFieldValueFromInternalToPublic)({
            fieldMetadata: internalFormMetadata[fieldId],
            internalFieldValue: fieldValue,
            fieldType: fieldType,
            viewType: viewType
        });
    } catch (e) {
        return null;
    }
    const currentPublicValue = formData[fieldId]?.value;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(newPublicValue, currentPublicValue)) return null;
    return {
        ...formData,
        [fieldId]: {
            ...formData[fieldId],
            value: newPublicValue
        }
    };
};

});


parcelRegister("jDMtG", function(module, exports) {

$parcel$export(module.exports, "registerFields", () => $5e78d8ed1ee13321$export$d4eb181b231cf88d);
$parcel$export(module.exports, "unregisterFields", () => $5e78d8ed1ee13321$export$1ca69a85bb7273de);

var $fr1K2 = parcelRequire("fr1K2");

var $kGsr8 = parcelRequire("kGsr8");
const $5e78d8ed1ee13321$export$d4eb181b231cf88d = ({ changeId: changeId, fieldsToBeRegistered: fieldsToBeRegistered, appId: appId })=>({ setState: setState, getState: getState })=>{
        if (!Array.isArray(fieldsToBeRegistered)) return;
        const { registeredFields: registeredFields } = getState();
        const appFields = registeredFields[appId] ?? {};
        const appChangeIdFields = appFields[changeId] ?? [];
        const nextRegisteredFields = {
            ...registeredFields,
            [appId]: {
                ...appFields,
                [changeId]: (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))([
                    ...appChangeIdFields,
                    ...fieldsToBeRegistered
                ])
            }
        };
        setState({
            registeredFields: nextRegisteredFields
        });
    };
const $5e78d8ed1ee13321$export$1ca69a85bb7273de = ({ changeId: changeId, appId: appId })=>({ setState: setState, getState: getState })=>{
        const { registeredFields: registeredFields } = getState();
        const registeredAppFields = registeredFields[appId] ?? {};
        const nextRegisteredAppFields = (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(registeredAppFields, changeId);
        setState({
            registeredFields: {
                ...registeredFields,
                [appId]: nextRegisteredAppFields
            }
        });
    };

});

parcelRegister("l0b2q", function(module, exports) {

$parcel$export(module.exports, "setFieldValue", () => $da1080104d423ca2$export$6556d46d2662453c);

var $l6AQO = parcelRequire("l6AQO");
const $da1080104d423ca2$export$6556d46d2662453c = ({ fieldId: fieldId, fieldType: fieldType, fieldValue: fieldValue })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        /**
		 * We can set new field value only if the field was initialized.
		 * This checks the field metedata that indicates the successfull initialization.
		 */ if (!internalFormMetadata[fieldId]) return;
        const nextFormData = (0, $l6AQO.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        setState({
            formData: nextFormData
        });
    };

});

parcelRegister("4MJXd", function(module, exports) {

$parcel$export(module.exports, "updateActiveScreenTab", () => $104b1b4dd763f6ee$export$21363496760d39cd);
const $104b1b4dd763f6ee$export$21363496760d39cd = ({ selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: screenTabs } = getState();
        if (screenTabs) setState({
            screenTabs: screenTabs.map((tab, index)=>({
                    ...tab,
                    isActive: index === selected
                }))
        });
    };

});

parcelRegister("gHQFd", function(module, exports) {

$parcel$export(module.exports, "updateFields", () => $069ce0e12537855c$export$cceae62fd4d1ef0a);

var $gccSB = parcelRequire("gccSB");

var $gKZoD = parcelRequire("gKZoD");

var $2jyqu = parcelRequire("2jyqu");


var $ajglJ = parcelRequire("ajglJ");

var $dA2NP = parcelRequire("dA2NP");

var $fKje4 = parcelRequire("fKje4");

var $dwG9p = parcelRequire("dwG9p");

var $dRfi6 = parcelRequire("dRfi6");

var $3whHg = parcelRequire("3whHg");

var $boEP0 = parcelRequire("boEP0");

var $hzAKL = parcelRequire("hzAKL");
const $069ce0e12537855c$export$cceae62fd4d1ef0a = ({ changeId: changeId, fieldsChanges: fieldsChanges, lookupDataFromApi: lookupDataFromApi, tenantContext: tenantContext, executionContext: executionContext, environment: environment, appId: appId, intl: intl, createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gKZoD.di)((0, $boEP0.collectFieldsAppliedChangesHistory));
        const appliedChanges = getState().appliedChanges ?? {};
        const formData = getState().formData ?? {};
        const { internalFormMetadata: internalFormMetadata, registeredFields: registeredFields } = getState();
        const { changesToApply: changesToApply, incomingFormData: incomingFormData, errorsByField: errorsByField, newAppliedChangesPublic: newAppliedChangesPublic } = await Object.keys(fieldsChanges).reduce(async (acc, fieldId)=>{
            // Do not update fields that are not inside initialized data.
            // Validates if the field that comes from Iframe is supported
            // - because we add to formData only the supported ones.
            const fieldData = formData[fieldId];
            const internalMetadata = internalFormMetadata[fieldId];
            const fieldIsRegistered = (0, $dA2NP.fieldWasRegistered)(registeredFields, changeId, fieldId, appId);
            // Only registered field Ids can be updated.
            if (!fieldIsRegistered || !fieldData) {
                const { fieldType: fieldType } = fieldData ?? {};
                dispatch((0, $3whHg.addAppsErrors)({
                    errors: {
                        [appId]: [
                            {
                                fieldType: fieldType,
                                fieldId: fieldId,
                                type: 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD',
                                message: 'Application tried to apply changes to unregistered field'
                            }
                        ]
                    }
                }));
                (0, $2jyqu.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'unregisteredField',
                    actionSubject: 'jiraUiModifications.applyChanges',
                    attributes: {
                        message: 'Attempt to apply changes to a field that was not registered',
                        fieldId: fieldId,
                        viewType: viewType
                    }
                });
                return acc;
            }
            const lookupData = {
                [(0, $80e7f3d73b333b84$export$a1cacdcf198da901)]: internalMetadata.allowedValues,
                [(0, $80e7f3d73b333b84$export$3a106242c8f57ac2)]: lookupDataFromApi[0, $80e7f3d73b333b84$export$3a106242c8f57ac2]
            };
            // It updates properties in each field to avoid removing unchanged props for
            // selected field by another app or another onChange update.
            // Only supported properties are allowed.
            const supportedFieldChanges = await (0, $hzAKL.transformFieldChangesToInternalShape)({
                fieldType: fieldData.fieldType,
                fieldId: fieldId,
                fieldFromIframe: fieldsChanges?.[fieldId],
                lookupData: lookupData,
                viewType: viewType,
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                intl: intl
            });
            if (supportedFieldChanges.isValid === false) {
                (await acc).errorsByField[fieldId] = supportedFieldChanges.errors;
                return acc;
            }
            // It converts changes to 'public' format to update the formData
            const publicShapeChanges = (0, $dRfi6.transformFieldToIframe)(supportedFieldChanges.data, viewType, fieldData.fieldType, lookupData, fieldsChanges?.[fieldId], internalMetadata);
            const transformedFieldChanges = (0, $fKje4.mapFieldPropertyNamesToInternal)(supportedFieldChanges.data, viewType, fieldData.fieldType);
            const combinedChangesToApply = {
                ...appliedChanges[fieldId],
                ...transformedFieldChanges
            };
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(combinedChangesToApply)) {
                (await acc).newAppliedChangesPublic[fieldId] = publicShapeChanges;
                (await acc).changesToApply[fieldId] = combinedChangesToApply;
                (await acc).incomingFormData[fieldId] = {
                    ...formData[fieldId],
                    ...publicShapeChanges
                };
            }
            return acc;
        }, Promise.resolve({
            changesToApply: {
                ...appliedChanges
            },
            incomingFormData: {
                ...formData
            },
            newAppliedChangesPublic: {},
            errorsByField: {}
        }));
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(errorsByField)) throw new (0, $ajglJ.UiModificationsFieldsValidationError)('Transformation failed', {
            errors: (0, $dwG9p.prepareErrorsArray)(errorsByField)
        });
        setState({
            appliedChanges: changesToApply,
            formData: incomingFormData
        });
        dispatch((0, $boEP0.collectFieldsAppliedChangesHistory)({
            appId: appId,
            changeId: changeId,
            fieldsChanges: newAppliedChangesPublic
        }));
    };

});
const $80e7f3d73b333b84$export$a1cacdcf198da901 = 'LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY';
const $80e7f3d73b333b84$export$3a106242c8f57ac2 = 'LOOKUP_SOURCE_USERS_ASYNC_DATA';
const $80e7f3d73b333b84$export$f5d5f6bb902f1027 = '-1';
const $80e7f3d73b333b84$export$106087dcfd4fb129 = 100;

parcelRegister("ajglJ", function(module, exports) {

$parcel$export(module.exports, "UiModificationsFieldsValidationError", () => $907938b0f57574ed$export$9e8b5e552e255163);

var $2jqAp = parcelRequire("2jqAp");
class $907938b0f57574ed$export$9e8b5e552e255163 extends (0, $2jqAp.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'fields', cause);
    }
}

});
parcelRegister("2jqAp", function(module, exports) {

$parcel$export(module.exports, "UiModificationsValidationError", () => $b8ce6491bf34e535$export$6e8165c81a6a65df);
class $b8ce6491bf34e535$export$6e8165c81a6a65df extends Error {
    constructor(message, attributes, validationErrorType, cause){
        super(message, cause);
        this.attributes = attributes;
        this.validationErrorType = validationErrorType;
    }
}

});


parcelRegister("dA2NP", function(module, exports) {

$parcel$export(module.exports, "fieldWasRegistered", () => $aff4a3261c4c9b6e$export$fbe9157c12cb4e7b);
const $aff4a3261c4c9b6e$export$fbe9157c12cb4e7b = (registeredFields, changeId, fieldId, appId)=>!!registeredFields[appId]?.[changeId]?.includes(fieldId);

});

parcelRegister("fKje4", function(module, exports) {

$parcel$export(module.exports, "mapFieldPropertyNamesToInternal", () => $620a721e65ec1dbe$export$460820f27643954e);

var $gL80q = parcelRequire("gL80q");
const $620a721e65ec1dbe$export$460820f27643954e = (properties, viewType, fieldType)=>{
    const fieldConfiguration = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType);
    const propertyMapping = fieldConfiguration?.propertyMapping;
    if (!propertyMapping) return properties;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(properties).reduce((acc, propertyName)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const propertyMappingValue = propertyMapping[propertyName];
        acc[propertyMappingValue ?? propertyName] = properties[propertyName];
        return acc;
    }, {});
};

});

parcelRegister("dwG9p", function(module, exports) {

$parcel$export(module.exports, "prepareErrorsArray", () => $8d92968018d86237$export$e1fce51bc5be90b7);
const $8d92968018d86237$export$e1fce51bc5be90b7 = (errorsById)=>Object.values(errorsById).flat();

});

parcelRegister("dRfi6", function(module, exports) {

$parcel$export(module.exports, "transformFieldToIframe", () => $cc6b08557666e682$export$aa453854f74fab);

var $cmmj3 = parcelRequire("cmmj3");

var $gL80q = parcelRequire("gL80q");
const $cc6b08557666e682$export$aa453854f74fab = (fieldChanges, viewType, fieldType, lookupData, fieldFromIframe, fieldMetadata)=>{
    const fieldConfiguration = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldInternalToPublicTransformers = fieldConfiguration?.internalToPublicTransformers;
    const publicShapeField = {
        ...fieldChanges
    };
    if (publicShapeField.value !== undefined && fieldInternalToPublicTransformers?.value) try {
        publicShapeField.value = fieldInternalToPublicTransformers?.value(fieldChanges.value, fieldMetadata.fieldRenderer);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $cmmj3.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    if (fieldFromIframe.optionsVisibility !== undefined && fieldInternalToPublicTransformers?.optionsVisibility) try {
        const lookupSource = fieldConfiguration?.lookupSource;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - lookupData is not types on CI somehow
        const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
        publicShapeField.optionsVisibility = fieldInternalToPublicTransformers?.optionsVisibility(fieldFromIframe.optionsVisibility, lookupValues);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $cmmj3.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicOptionsVisibilityTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return publicShapeField;
};

});

parcelRegister("hzAKL", function(module, exports) {

$parcel$export(module.exports, "transformFieldChangesToInternalShape", () => $422557008e0dbc71$export$d14f85c01e334a1);

var $gccSB = parcelRequire("gccSB");

var $gKZoD = parcelRequire("gKZoD");

var $7NDId = parcelRequire("7NDId");

var $gL80q = parcelRequire("gL80q");


var $bCvSM = parcelRequire("bCvSM");

var $2J6IF = parcelRequire("2J6IF");

var $hwDyF = parcelRequire("hwDyF");
const $422557008e0dbc71$export$d14f85c01e334a1 = async ({ fieldType: fieldType, fieldId: fieldId, fieldFromIframe: fieldFromIframe, lookupData: lookupData, viewType: viewType, tenantContext: tenantContext, executionContext: executionContext, environment: environment, intl: intl })=>{
    (0, $gKZoD.di)((0, $gL80q.getSupportedFieldConfiguration));
    const fieldConfiguration = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldTransformers = fieldConfiguration?.publicToInternalTransformers;
    const fieldValidators = fieldConfiguration?.publicShapeValidators;
    if (!fieldFromIframe || !fieldTransformers || !fieldValidators) return {
        ...(0, $2J6IF.VALID_RESULT),
        data: {}
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const validatorsArray = Object.keys(fieldValidators);
    const lookupSource = fieldConfiguration?.lookupSource;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - lookupData is not types on CI somehow
    const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
    const fieldTransformationResults = await Promise.all(validatorsArray.map(async (propertyName)=>{
        if (!Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName)) return 0, $2J6IF.VALID_RESULT;
        const propertyValue = fieldFromIframe[propertyName];
        const transformer = fieldTransformers[propertyName];
        const fieldContext = {
            fieldId: fieldId
        };
        // We need to catch lookup values discrepancies and react accordingly
        // to how we react to validation errors - throw an error
        // if the set value wasn't found in the array of lookupValues
        try {
            const data = transformer ? await transformer(propertyValue, lookupValues, {
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                fieldContext: fieldContext,
                intl: intl
            }) : propertyValue;
            return {
                isValid: true,
                data: {
                    [propertyName]: data
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            // FieldValueLookupError will be thrown from the transformer
            // when the lookup value wasn't found
            if (err instanceof (0, $7NDId.FieldValueLookupError)) {
                // For single value fields its straightforward to just pass
                // the faulty propertyValue into error message,
                // but for multi value fields we should find out the faulty values from the array
                // thats why we should propagate the faulty values as a comma separated string
                // by using the error's message
                const faultyValue = err.message || propertyValue;
                return {
                    isValid: false,
                    error: {
                        fieldId: fieldId,
                        fieldType: fieldType,
                        type: (0, $ca611ff348f89182$export$d1996cb46a690190),
                        method: (0, $bCvSM.mapFieldPropertyToApiMethod)(propertyName),
                        message: `Invalid IDs provided: ${faultyValue}`
                    }
                };
            }
            throw err;
        }
    }));
    const invalidTransformationResults = (0, $hwDyF.filterInvalidResults)(fieldTransformationResults);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(invalidTransformationResults)) return {
        isValid: false,
        errors: invalidTransformationResults.map((result)=>result.error)
    };
    return (0, $hwDyF.mapValidResultsToFieldInternalShape)(fieldTransformationResults);
};

});
parcelRegister("7NDId", function(module, exports) {

$parcel$export(module.exports, "FieldValueLookupError", () => $64626586c22c486e$export$73c2f0689b6c4a5a);
class $64626586c22c486e$export$73c2f0689b6c4a5a extends Error {
}

});

parcelRegister("2J6IF", function(module, exports) {

$parcel$export(module.exports, "VALID_RESULT", () => $5fbccb776f84792e$export$ee79e3ab53b8db79);
const $5fbccb776f84792e$export$ee79e3ab53b8db79 = {
    isValid: true
};

});

parcelRegister("hwDyF", function(module, exports) {

$parcel$export(module.exports, "mapValidResultsToFieldInternalShape", () => $e8aa8431ce8b786b$export$a60dd8f1b025f23d);
$parcel$export(module.exports, "filterInvalidResults", () => $e8aa8431ce8b786b$export$ddd005554aecd409);
const $e8aa8431ce8b786b$export$a60dd8f1b025f23d = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === true && Object.prototype.hasOwnProperty.call(result, 'data')) acc.data = {
            ...acc.data,
            ...result.data
        };
        return acc;
    }, {
        isValid: true,
        data: {}
    });
const $e8aa8431ce8b786b$export$ddd005554aecd409 = (validationResults)=>validationResults.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);

});



parcelRegister("7JtDe", function(module, exports) {

$parcel$export(module.exports, "updateScreenTabs", () => $c6c7124cbfc0022b$export$131c67fd312b8a11);

var $gKZoD = parcelRequire("gKZoD");

var $iUvwD = parcelRequire("iUvwD");

var $50ech = parcelRequire("50ech");

var $boEP0 = parcelRequire("boEP0");

var $iiEdL = parcelRequire("iiEdL");
const $c6c7124cbfc0022b$export$131c67fd312b8a11 = ({ screenTabsChanges: screenTabsFromIframe, changeId: changeId, appId: appId })=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        (0, $gKZoD.di)((0, $boEP0.collectScreenTabsAppliedChangesHistory), (0, $iiEdL.getScreenTabsPublicToInternalValidationErrors));
        const { screenTabs: internalScreenTabs } = getState();
        // If screenTabsFromIframe is empty it means that the app does not provide srceenTabs changes.
        if (Array.isArray(screenTabsFromIframe) && !screenTabsFromIframe.length) return;
        if (internalScreenTabs && (0, $iiEdL.screenTabsPublicToInternalValidator)(internalScreenTabs, screenTabsFromIframe)) {
            const newScreenTabs = (0, $iiEdL.screenTabsPublicToInternalTransformer)(internalScreenTabs, screenTabsFromIframe);
            setState({
                screenTabs: newScreenTabs
            });
            dispatch((0, $boEP0.collectScreenTabsAppliedChangesHistory)({
                appId: appId,
                changeId: changeId,
                screenTabs: newScreenTabs
            }));
        } else throw new (0, $iUvwD.UiModificationsScreenTabsValidationError)('Transformation failed', {
            errors: (0, $iiEdL.getScreenTabsPublicToInternalValidationErrors)(internalScreenTabs, screenTabsFromIframe).map((0, $50ech.toScreenTabsValidationError))
        });
    };

});
parcelRegister("iUvwD", function(module, exports) {

$parcel$export(module.exports, "UiModificationsScreenTabsValidationError", () => $2febbf39fb2cebbc$export$faf1f1824ee0a136);

var $2jqAp = parcelRequire("2jqAp");
class $2febbf39fb2cebbc$export$faf1f1824ee0a136 extends (0, $2jqAp.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'screenTabs', cause);
    }
}

});

parcelRegister("50ech", function(module, exports) {

$parcel$export(module.exports, "toScreenTabsValidationError", () => $32af3bb8fe161d39$export$b2675440ade984fb);

const $32af3bb8fe161d39$export$b2675440ade984fb = (message)=>({
        message: message,
        type: (0, $ca611ff348f89182$export$fd26696d109785a0)
    });

});

parcelRegister("iiEdL", function(module, exports) {

$parcel$export(module.exports, "screenTabsPublicToInternalTransformer", () => $5d43d6affeb19d8a$export$9ca9b35e7b6a8bbc);
$parcel$export(module.exports, "screenTabsPublicToInternalValidator", () => $5d43d6affeb19d8a$export$e7a91e7e430e691a);
$parcel$export(module.exports, "getScreenTabsPublicToInternalValidationErrors", () => $5d43d6affeb19d8a$export$62d63af83dac7315);
const $5d43d6affeb19d8a$export$582443c7ead02173 = (value)=>typeof value === 'string' && value !== '';
const $5d43d6affeb19d8a$var$isValidScreenTabId = (internalScreenTabs, id)=>$5d43d6affeb19d8a$export$582443c7ead02173(id) && internalScreenTabs.find((tab)=>tab.id === id) !== undefined;
const $5d43d6affeb19d8a$var$isValidScreenTabIsActive = (isActive)=>typeof isActive === 'boolean' || typeof isActive === 'undefined';
const $5d43d6affeb19d8a$var$isValidScreenTabIsVisible = (isVisible)=>typeof isVisible === 'boolean' || typeof isVisible === 'undefined';
const $5d43d6affeb19d8a$var$isValidScreenTabData = (internalScreenTabs, { id: id, isVisible: isVisible, isActive: isActive })=>$5d43d6affeb19d8a$var$isValidScreenTabId(internalScreenTabs, id) && $5d43d6affeb19d8a$var$isValidScreenTabIsVisible(isVisible) && $5d43d6affeb19d8a$var$isValidScreenTabIsActive(isActive);
const $5d43d6affeb19d8a$var$countNumberOfActiveScreenTabs = (acc, { isActive: isActive })=>{
    if ($5d43d6affeb19d8a$var$isValidScreenTabIsActive(isActive) && isActive) return acc + 1;
    return acc;
};
const $5d43d6affeb19d8a$var$countNumberOfHiddenActiveScreenTabs = (acc, { isActive: isActive, isVisible: isVisible })=>{
    if ($5d43d6affeb19d8a$var$isValidScreenTabIsActive(isActive) && isActive && $5d43d6affeb19d8a$var$isValidScreenTabIsVisible(isVisible) && !isVisible) return acc + 1;
    return acc;
};
const $5d43d6affeb19d8a$export$9ca9b35e7b6a8bbc = (internalScreenTabs, screenTabsFromApp)=>{
    let numberOfActiveScreenTabs = 0;
    const internalActiveScreenTabIndex = internalScreenTabs.findIndex((tab)=>tab.isActive === true);
    const screenTabsInternalUpdated = internalScreenTabs.map((screenTabInternal)=>{
        const screenTabFromApp = screenTabsFromApp.find((tab)=>tab.id === screenTabInternal.id);
        if (!screenTabFromApp) return screenTabInternal;
        numberOfActiveScreenTabs += screenTabFromApp.isActive === true ? 1 : 0;
        return {
            id: screenTabInternal.id,
            isVisible: screenTabFromApp.isVisible ?? true,
            isActive: screenTabFromApp.isActive
        };
    });
    // if no active tab is specified. default to the first
    if (numberOfActiveScreenTabs === 0 && internalActiveScreenTabIndex === -1 && typeof screenTabsInternalUpdated[0]?.isActive !== 'undefined') screenTabsInternalUpdated[0].isActive = true;
    return screenTabsInternalUpdated;
};
const $5d43d6affeb19d8a$export$e7a91e7e430e691a = (internalScreenTabs, screenTabsFromApp)=>{
    if (!Array.isArray(screenTabsFromApp)) return false;
    const screenTabsFromAppFiltered = screenTabsFromApp.filter((data)=>$5d43d6affeb19d8a$var$isValidScreenTabData(internalScreenTabs, data));
    const numberOfActiveScreenTabs = screenTabsFromApp.reduce($5d43d6affeb19d8a$var$countNumberOfActiveScreenTabs, 0);
    const numberOfHiddenActiveScreenTabs = screenTabsFromApp.reduce($5d43d6affeb19d8a$var$countNumberOfHiddenActiveScreenTabs, 0);
    return numberOfActiveScreenTabs <= 1 && screenTabsFromApp.length === screenTabsFromAppFiltered.length && numberOfHiddenActiveScreenTabs === 0;
};
const $5d43d6affeb19d8a$export$62d63af83dac7315 = (internalScreenTabs, screenTabsFromApp)=>{
    if (!internalScreenTabs) return [
        'There are no screen tabs in the current view.'
    ];
    if (!Array.isArray(screenTabsFromApp)) return [
        'Your app must return screen tabs as an array.'
    ];
    const errors = [];
    if (screenTabsFromApp.reduce($5d43d6affeb19d8a$var$countNumberOfActiveScreenTabs, 0) > 1) errors.push('Only one screen tab can be in focus.');
    if (screenTabsFromApp.reduce($5d43d6affeb19d8a$var$countNumberOfHiddenActiveScreenTabs, 0) > 0) errors.push("You can't hide a screen tab that's currently in focus.");
    return errors;
};

});





parcelRegister("eNNkf", function(module, exports) {

$parcel$export(module.exports, "useUserPreferencesValue", () => $5092328ed6a09c60$export$8bd3660b16415efd);
$parcel$export(module.exports, "useUserPreferencesActions", () => $5092328ed6a09c60$export$eefe4b2985e8203e);

var $5uXOq = parcelRequire("5uXOq");

var $hLEug = parcelRequire("hLEug");

var $12pgs = parcelRequire("12pgs");
const $5092328ed6a09c60$export$8bd3660b16415efd = (userPreferenceKey)=>{
    const baseUrl = '';
    const [value, { setUserPreferenceValue: setUserPreferenceValue, deleteUserPreferenceValue: deleteUserPreferenceValue }] = (0, $hLEug.useUserPreferencesStoreValue)(userPreferenceKey);
    /**
	 * persist: boolean - if true, save the value to the server ,else just update the local state and return a promise with the new value
	 */ const setValue = (0, $5uXOq.useCallback)((newValue, persist = true)=>{
        setUserPreferenceValue(userPreferenceKey, newValue);
        if (!persist) return Promise.resolve(newValue);
        return (0, $12pgs.saveUserPreferenceValue)(baseUrl, userPreferenceKey, newValue);
    }, [
        baseUrl,
        setUserPreferenceValue,
        userPreferenceKey
    ]);
    const deleteValue = (0, $5uXOq.useCallback)(()=>{
        deleteUserPreferenceValue(userPreferenceKey);
        return (0, $12pgs.removeUserPreferenceValue)(baseUrl, userPreferenceKey);
    }, [
        baseUrl,
        deleteUserPreferenceValue,
        userPreferenceKey
    ]);
    const setUserPreferences = (0, $5uXOq.useMemo)(()=>({
            setValue: setValue,
            deleteValue: deleteValue
        }), [
        setValue,
        deleteValue
    ]);
    return [
        value,
        setUserPreferences
    ];
};
const $5092328ed6a09c60$export$eefe4b2985e8203e = ()=>{
    const baseUrl = '';
    const [, actions] = (0, $hLEug.useUserPreferencesStoreActions)();
    const userPreferenceActions = (0, $5uXOq.useMemo)(()=>{
        const setUserPreferenceValue = (userPreferenceKey, value)=>{
            actions.setUserPreferenceValue(userPreferenceKey, value);
            (0, $12pgs.saveUserPreferenceValue)(baseUrl, userPreferenceKey, value);
        };
        const deleteUserPreferenceValue = (userPreferenceKey)=>{
            actions.deleteUserPreferenceValue(userPreferenceKey);
            (0, $12pgs.removeUserPreferenceValue)(baseUrl, userPreferenceKey);
        };
        const setUserPreferences = (userPreferences)=>{
            userPreferences && Object.keys(userPreferences).length !== 0 && actions.setUserPreferences(userPreferences);
        };
        return {
            setUserPreferenceValue: setUserPreferenceValue,
            setUserPreferences: setUserPreferences,
            deleteUserPreferenceValue: deleteUserPreferenceValue,
            getUserPreferenceValue: actions.getUserPreferenceValue
        };
    }, [
        actions,
        baseUrl
    ]);
    return [
        null,
        userPreferenceActions
    ];
};

});
parcelRegister("hLEug", function(module, exports) {

$parcel$export(module.exports, "useUserPreferencesStoreValue", () => $f08ba98a3f2bdde2$export$46e7eeb2fc34fab8);
$parcel$export(module.exports, "useUserPreferencesStoreActions", () => $f08ba98a3f2bdde2$export$4d156074562bac9a);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $djdK3 = parcelRequire("djdK3");
const $f08ba98a3f2bdde2$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'user-preferences',
    initialState: {
        preferences: {}
    },
    actions: $djdK3.actions
});
const $f08ba98a3f2bdde2$var$getUserPreference = (state, userPreferenceKey)=>state.preferences[userPreferenceKey];
const $f08ba98a3f2bdde2$export$46e7eeb2fc34fab8 = (0, $3sQ5x.createHook)($f08ba98a3f2bdde2$export$6f57813fe9f31bf9, {
    selector: $f08ba98a3f2bdde2$var$getUserPreference
});
const $f08ba98a3f2bdde2$export$4d156074562bac9a = (0, $3sQ5x.createHook)($f08ba98a3f2bdde2$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("djdK3", function(module, exports) {

$parcel$export(module.exports, "actions", () => $5c68f1b920b8984c$export$e324594224ef24da);
const $5c68f1b920b8984c$var$setUserPreferenceValue = (key, value)=>({ setState: setState, getState: getState })=>{
        setState({
            preferences: {
                ...getState().preferences,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [key]: value
            }
        });
    };
const $5c68f1b920b8984c$var$deleteUserPreferenceValue = (key)=>({ setState: setState, getState: getState })=>{
        const { [key]: _, ...preferences } = getState().preferences;
        setState({
            preferences: preferences
        });
    };
const $5c68f1b920b8984c$var$setUserPreferences = (state)=>({ setState: setState })=>{
        setState({
            preferences: state
        });
    };
const $5c68f1b920b8984c$export$df0a4f67b9888111 = (key)=>({ getState: getState })=>{
        const { preferences: preferences } = getState();
        return preferences[key];
    };
const $5c68f1b920b8984c$export$e324594224ef24da = {
    setUserPreferenceValue: $5c68f1b920b8984c$var$setUserPreferenceValue,
    deleteUserPreferenceValue: $5c68f1b920b8984c$var$deleteUserPreferenceValue,
    setUserPreferences: $5c68f1b920b8984c$var$setUserPreferences,
    getUserPreferenceValue: $5c68f1b920b8984c$export$df0a4f67b9888111
};

});


parcelRegister("12pgs", function(module, exports) {

$parcel$export(module.exports, "saveUserPreferenceValue", () => $0dfd1081a7a72732$export$bebe1b9e9f4cbf16);
$parcel$export(module.exports, "removeUserPreferenceValue", () => $0dfd1081a7a72732$export$a60a810760d07867);

var $eusud = parcelRequire("eusud");
const $0dfd1081a7a72732$export$bebe1b9e9f4cbf16 = async (baseUrl, userPreferenceKey, value)=>(0, $eusud.performPutRequest)(`${baseUrl}/rest/api/2/mypreferences?key=${userPreferenceKey}`, {
        body: value
    });
const $0dfd1081a7a72732$export$a60a810760d07867 = async (baseUrl, userPreferenceKey)=>(0, $eusud.performDeleteRequest)(`${baseUrl}/rest/api/2/mypreferences?key=${userPreferenceKey}`);

});


const $31848aa9a0db89de$export$a763454c55d057f2 = 'jira.user.issue.clickthrough-banner.lastinteracted';
const $31848aa9a0db89de$export$8c6b5c30f78ab338 = 'jira.user.issue.changeboarding.lastinteracted';
const $31848aa9a0db89de$export$5530d4ea250d4125 = 'jira.user.issue.attachment.view';
const $31848aa9a0db89de$export$a274dca8eb47fc4a = 'jira.user.issue.sidebar.resize-ratio';
const $31848aa9a0db89de$export$4c9f7f9f8a4000e1 = 'jira.user.issue.filter.hide-done-subtasks';
const $31848aa9a0db89de$export$2cf981c493d79a21 = 'jira.user.issue.details.activity-layout-setting';
const $31848aa9a0db89de$export$39aaf586c7ee5202 = 'jira.user.issue.user-preferred-layouts';
const $31848aa9a0db89de$export$25f5ee1223725a65 = 'jira.user.issue.comment-summaries.enabled';
const $31848aa9a0db89de$export$4936b1621439c095 = 'jira.user.issue.details.details-panel-fields-order';
const $31848aa9a0db89de$export$1a08240e14f65aa = 'jira.user.issue.collapsible-sections-state';
const $31848aa9a0db89de$export$32a0b5eafccd5141 = 'jira.user.issue.comment-slack-flag.dismissed';

parcelRegister("kI4MM", function(module, exports) {

$parcel$export(module.exports, "useIssueLayoutContainersStore", () => $189406269e224200$export$5c4a1f63cea7b5b3);
$parcel$export(module.exports, "useIssueLayoutGlanceStore", () => $189406269e224200$export$769bbe2bda9a43ce);
$parcel$export(module.exports, "useIssueLayoutContextPanelStore", () => $189406269e224200$export$3aa9017e11451546);
$parcel$export(module.exports, "useIssueLayoutActionsStore", () => $189406269e224200$export$5513f3c310d101f5);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $kjjoM = parcelRequire("kjjoM");
const $189406269e224200$var$getIssueViewLayoutContainers = (state, issueKey)=>state[String(issueKey)]?.containers || [];
const $189406269e224200$var$getIssueViewLayoutGlance = (state, issueKey)=>state[String(issueKey)]?.glance;
const $189406269e224200$var$getIssueViewLayoutContextPanel = (state, issueKey)=>state[String(issueKey)]?.contextPanel;
const $189406269e224200$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'issue-view-layout-service',
    initialState: {},
    actions: $kjjoM
});
const $189406269e224200$export$5c4a1f63cea7b5b3 = (0, $3sQ5x.createHook)($189406269e224200$export$6f57813fe9f31bf9, {
    selector: $189406269e224200$var$getIssueViewLayoutContainers
});
const $189406269e224200$export$769bbe2bda9a43ce = (0, $3sQ5x.createHook)($189406269e224200$export$6f57813fe9f31bf9, {
    selector: $189406269e224200$var$getIssueViewLayoutGlance
});
const $189406269e224200$export$3aa9017e11451546 = (0, $3sQ5x.createHook)($189406269e224200$export$6f57813fe9f31bf9, {
    selector: $189406269e224200$var$getIssueViewLayoutContextPanel
});
const $189406269e224200$export$5513f3c310d101f5 = (0, $3sQ5x.createHook)($189406269e224200$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("kjjoM", function(module, exports) {

$parcel$export(module.exports, "setIssueViewContainersLayout", () => $09c52f32f4231bd8$export$e956c64a7167b73a);
$parcel$export(module.exports, "setIssueViewLayoutGlance", () => $09c52f32f4231bd8$export$6a9b24c2efe66bb7);
$parcel$export(module.exports, "setIssueViewLayoutContextPanel", () => $09c52f32f4231bd8$export$9a04e4b958ebc410);
const $09c52f32f4231bd8$export$e956c64a7167b73a = (issueKey, containersByType)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                containers: containersByType?.containers || []
            }
        });
    };
const $09c52f32f4231bd8$export$6a9b24c2efe66bb7 = (issueKey, glance)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                glance: glance
            }
        });
    };
const $09c52f32f4231bd8$export$9a04e4b958ebc410 = (issueKey, contextPanel)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                contextPanel: contextPanel
            }
        });
    };

});


parcelRegister("cNJ33", function(module, exports) {

$parcel$export(module.exports, "getLayoutItemId", () => $0c6b6ff40aad7732$export$fec1c0749fa149f4);
$parcel$export(module.exports, "filterOutItemsWithProvidedIds", () => $0c6b6ff40aad7732$export$355607dae809ec65);

var $41gqO = parcelRequire("41gqO");
const $0c6b6ff40aad7732$export$fec1c0749fa149f4 = (layoutItem)=>{
    switch(layoutItem.type){
        case (0, $41gqO.layoutContainerItemTypes).field:
            return layoutItem.fieldItemId;
        case (0, $41gqO.layoutContainerItemTypes).panel:
            return layoutItem.panelItemId;
        case (0, $41gqO.layoutContainerItemTypes).tab:
            return layoutItem.tabContainerId;
        default:
            return layoutItem.id;
    }
};
const $0c6b6ff40aad7732$export$355607dae809ec65 = (items, idsToBeFilteredOut)=>{
    const filteredOutIdsSet = new Set(idsToBeFilteredOut);
    return items// Filter out items with the provided Ids
    .filter((item)=>!filteredOutIdsSet.has($0c6b6ff40aad7732$export$fec1c0749fa149f4(item)))// Filter out items with the provided Ids nested in the container tab items
    .map((item)=>{
        if (item.type === (0, $41gqO.layoutContainerItemTypes).tab && item.items?.nodes) return {
            ...item,
            items: {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                nodes: $0c6b6ff40aad7732$export$355607dae809ec65(item.items.nodes, idsToBeFilteredOut)
            }
        };
        return item;
    });
};

});
parcelRegister("41gqO", function(module, exports) {

$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $b08b2795aecf222d$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $b08b2795aecf222d$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $b08b2795aecf222d$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "FORGE_CONTEXT_TYPE", () => $b08b2795aecf222d$export$be8e68fb1aed253e);
$parcel$export(module.exports, "CONTEXT_AREA", () => $b08b2795aecf222d$export$7bf561e6ab380ea1);
$parcel$export(module.exports, "CONTENT_AREA", () => $b08b2795aecf222d$export$f42c11634d75863e);
$parcel$export(module.exports, "CONTENT_REQUEST_AREA", () => $b08b2795aecf222d$export$b38842736b6dbc1d);
$parcel$export(module.exports, "REACT_KEY_SUMMARY", () => $b08b2795aecf222d$export$605c43f1b33ab69);
$parcel$export(module.exports, "CUSTOM_ITEM_TYPE", () => $b08b2795aecf222d$export$e655b77b9efe622f);
$parcel$export(module.exports, "layoutContainerItemTypes", () => $b08b2795aecf222d$export$5507f31126c8b283);
$parcel$export(module.exports, "isLayoutContainerTabItem", () => $b08b2795aecf222d$export$ad3536b13febb432);
const $b08b2795aecf222d$export$99ad62164189f781 = 'ecosystemGlance';
const $b08b2795aecf222d$export$7719ef6e9283671 = 'forgeGlance';
const $b08b2795aecf222d$export$bfebea5ce2e1887a = 'ecosystemContext';
const $b08b2795aecf222d$export$be8e68fb1aed253e = 'forgeContext';
const $b08b2795aecf222d$export$7bf561e6ab380ea1 = 'context';
const $b08b2795aecf222d$export$f42c11634d75863e = 'content';
const $b08b2795aecf222d$export$b38842736b6dbc1d = 'content-request';
const $b08b2795aecf222d$export$bc9fa2d93b5fabae = 'FIELD';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$STATUS_TYPE = 'STATUS';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$TAB_TYPE = 'TAB';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$PANEL_TYPE = 'PANEL';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$ECOSYSTEM_TYPE = 'ECOSYSTEM';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$FORGE_TYPE = 'FORGE';
const $b08b2795aecf222d$export$605c43f1b33ab69 = 'SUMMARY';
const $b08b2795aecf222d$export$e655b77b9efe622f = 'CustomItem';
const $b08b2795aecf222d$export$5cf403de05e9bea = 'FieldSectionItem';
const $b08b2795aecf222d$export$30f7f9a86f182492 = 'TabLayout';
const $b08b2795aecf222d$export$196e597ad9a97f7a = 'PanelSectionItem';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$ECOSYSTEM_SECTION_ITEM = 'EcosystemSectionItem';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$FORGE_SECTION_ITEM = 'ForgeSectionItem';
const $b08b2795aecf222d$export$5507f31126c8b283 = {
    field: 'JiraIssueItemFieldItem',
    panel: 'JiraIssueItemPanelItem',
    tab: 'JiraIssueItemTabContainer'
};
const $b08b2795aecf222d$export$ad3536b13febb432 = (node)=>node.type === $b08b2795aecf222d$export$5507f31126c8b283.tab;

});



parcelRegister("hhMVP", function(module, exports) {

$parcel$export(module.exports, "getCachedIsCompactValue", () => $cd61c7d28b4f2500$export$c47621d55d10906c);
$parcel$export(module.exports, "setCachedIsCompactValue", () => $cd61c7d28b4f2500$export$568b2dd75c2027b4);
$parcel$export(module.exports, "invalidateCacheIfRouteChanged", () => $cd61c7d28b4f2500$export$a81477a3594bcaab);
// Cleared on window refresh, unique to each window
const $cd61c7d28b4f2500$var$cachedIsCompactValues = {};
let $cd61c7d28b4f2500$var$previousRouteKey;
function $cd61c7d28b4f2500$export$c47621d55d10906c(key) {
    return $cd61c7d28b4f2500$var$cachedIsCompactValues[key];
}
function $cd61c7d28b4f2500$export$568b2dd75c2027b4(isCompactValue, key) {
    $cd61c7d28b4f2500$var$cachedIsCompactValues[key] = isCompactValue;
}
function $cd61c7d28b4f2500$export$a81477a3594bcaab(currentRouteKey) {
    // If we navigate away from the route we can't assume that the cached value will stay valid when we come back
    if (currentRouteKey !== $cd61c7d28b4f2500$var$previousRouteKey) {
        $cd61c7d28b4f2500$var$previousRouteKey = currentRouteKey;
        delete $cd61c7d28b4f2500$var$cachedIsCompactValues[$cd61c7d28b4f2500$var$previousRouteKey];
    }
}

});


parcelRegister("3441h", function(module, exports) {
module.exports = new URL("issue-app-skeleton.tpl.e425fdce.svg", import.meta.url).toString();

});


parcelRegister("lAGdd", function(module, exports) {

$parcel$export(module.exports, "aiContextPanelResource", () => $f43677b290bdf8ab$export$8f6224974184ed8d);

var $2M1hQ = parcelRequire("2M1hQ");

var $4R6GH = parcelRequire("4R6GH");


var $3RV1W = parcelRequire("3RV1W");

var $1b0RC = parcelRequire("1b0RC");

var $l9pCw = parcelRequire("l9pCw");

var $3kPby = parcelRequire("3kPby");

var $70Yef = parcelRequire("70Yef");
const $f43677b290bdf8ab$var$SUPPORTED_PRACTICES = new Set([
    (0, $b78738e839898752$export$a364d86306d4a6d4),
    (0, $b78738e839898752$export$31ffe79c2b019cf)
]);
const $f43677b290bdf8ab$export$8f6224974184ed8d = (0, $2M1hQ.createResource)({
    type: 'AI-CONTEXT-PANEL-RESOURCE-TYPE',
    getKey: ({ match: match })=>{
        const issueKey = match.params.issueKey || '';
        return `aiContextPanelResource-${issueKey}`;
    },
    getData: async (routerDataContext, resourceStoreContext)=>{
        const { skipChecks: skipChecks, issueKey: issueKey } = routerDataContext.match.params;
        let { issueId: issueId, practice: practice, projectId: projectId } = routerDataContext.match.params;
        const { cloudId: cloudId, locale: locale } = resourceStoreContext.tenantContext;
        if (!issueKey) return null;
        if (skipChecks !== '1') {
            // The suggestions panel is available only on service-desk.
            // Hence filtering them out to reduce the number of calls to AGG and features APIs
            if (!(0, $3RV1W.checkLicense)(resourceStoreContext.tenantContext, 'servicedesk') || !(0, $4R6GH.fg)('jsm_issue_view_ai_context')) return null;
            const issueDetails = await (0, $3kPby.getIssueDetails)(issueKey, cloudId, (0, $4R6GH.fg)('context_panel_state_in_issue_details'));
            const isAIEnabled = issueDetails.isAIEnabled;
            issueId = issueDetails.issueId;
            projectId = issueDetails.projectId;
            practice = issueDetails.practice;
            if (!isAIEnabled || !$f43677b290bdf8ab$var$SUPPORTED_PRACTICES.has(practice)) return null;
            let isAIContextPanelDisabled;
            if ((0, $4R6GH.fg)('context_panel_state_in_issue_details')) isAIContextPanelDisabled = !issueDetails.isAiContextFeatureEnabled;
            else {
                const featureState = await (0, $70Yef.getFeatureState)(routerDataContext, resourceStoreContext);
                isAIContextPanelDisabled = featureState?.['jsm-ai-context']?.status === (0, $b78738e839898752$export$8cd212c10b4124d2);
            }
            if (isAIContextPanelDisabled) return null;
        }
        if (!issueId) throw new Error('AI context service panel resource cannot be loaded without an issueId');
        if (practice === (0, $b78738e839898752$export$a364d86306d4a6d4)) return (0, $1b0RC.getServiceSuggestionData)(issueId, cloudId);
        if (practice === (0, $b78738e839898752$export$31ffe79c2b019cf) && (0, $4R6GH.fg)('jsm_issue_view_ai_context_ops')) {
            if (!projectId) throw new Error('AI context ops panel resource cannot be loaded without a projectId');
            return (0, $l9pCw.getIncidentSuggestionEndpoint)({
                cloudId: cloudId,
                issueId: issueId,
                projectId: projectId,
                locale: locale
            });
        }
        return null;
    },
    maxAge: 0,
    isBrowserOnly: true
});

});
const $b78738e839898752$export$b45a36df7873757 = 'alerts';
const $b78738e839898752$export$a7952c5a5c371ddd = 'oncall';
const $b78738e839898752$export$de0bca182bc46c7f = 'services';
const $b78738e839898752$export$ed849d1eb34423e5 = 'similarIssues';
const $b78738e839898752$export$d4a1ed8524773042 = 'sentiment-analysis';
const $b78738e839898752$export$46f600f4680e5fd0 = 'jsm-ai-context';
const $b78738e839898752$export$3d2ce10d3ca55e3c = 'automaticallySetRequestType';
const $b78738e839898752$export$cae2404f62c0f4d7 = 'change-management';
const $b78738e839898752$export$31ffe79c2b019cf = 'incident-management';
const $b78738e839898752$export$3a20074cc38cbf69 = 'problem-management';
const $b78738e839898752$export$a364d86306d4a6d4 = 'service-request';
const $b78738e839898752$export$71f1a79e03f525 = 'post-incident-review';
const $b78738e839898752$export$6860c7a26d6d6d35 = 'csm-customer-context';
const $b78738e839898752$export$7c5ee80fcb40e9d3 = 'developer-escalation';
const $b78738e839898752$export$28fc94ee6c61f632 = 'products-and-entitlements';
const $b78738e839898752$export$93b42272f76473c9 = 'jsm-views';
const $b78738e839898752$export$1eb399d8c2d53748 = 'jsm-board';
const $b78738e839898752$export$abbcecf25bfa1e87 = 'jsm-calendar';
const $b78738e839898752$export$891877b4a4d60ea2 = 'jsm-project-summary';
const $b78738e839898752$export$34136c6420474672 = 'journey-builder';
const $b78738e839898752$export$66ede2c1de447f8f = 'developer-escalation';
const $b78738e839898752$export$1ee9c534405b9b35 = 'playbooks';
const $b78738e839898752$export$ac0832132e8992d7 = 'automation-discoverability';
const $b78738e839898752$export$fc77e86331b0e2c7 = 'jcs-customer-support-escalation';
const $b78738e839898752$export$e927a5d1b72f0b68 = 'ENABLED';
const $b78738e839898752$export$8cd212c10b4124d2 = 'DISABLED';

parcelRegister("3RV1W", function(module, exports) {

$parcel$export(module.exports, "checkLicense", () => $6334356fa938c5d8$export$fe2591be8b7e59ce);
$parcel$export(module.exports, "LicenseCheck", () => $6334356fa938c5d8$export$944be0b3bf2a6feb);

var $5uXOq = parcelRequire("5uXOq");

var $9OXo1 = parcelRequire("9OXo1");
const $6334356fa938c5d8$var$appPermissionMapper = {
    software: 'hasSoftwareAccess',
    servicedesk: 'hasServiceDeskAccess',
    customerservice: 'hasCustomerServiceAccess'
};
const $6334356fa938c5d8$export$fe2591be8b7e59ce = (tenantContext, type)=>Boolean(tenantContext.appPermissions && tenantContext.appPermissions[$6334356fa938c5d8$var$appPermissionMapper[type]]);
const $6334356fa938c5d8$export$944be0b3bf2a6feb = ({ children: children, type: type })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        const result = $6334356fa938c5d8$export$fe2591be8b7e59ce(tenantContext, type);
        return children({
            result: result
        });
    });

});

parcelRegister("1b0RC", function(module, exports) {

$parcel$export(module.exports, "getServiceSuggestionData", () => $ea3750099e69bfcf$export$afab700af9f021de);

var $eusud = parcelRequire("eusud");

var $4R6GH = parcelRequire("4R6GH");

var $9pxAu = parcelRequire("9pxAu");

var $jgbuq = parcelRequire("jgbuq");
const $ea3750099e69bfcf$export$d8192485ee52671b = (issueId)=>`/gateway/api/firebolt/1/context-panel/${issueId}`;
const $ea3750099e69bfcf$export$afab700af9f021de = (issueId, cloudId)=>{
    if ((0, $4R6GH.fg)('context-panel-graphql-migration')) return (0, $jgbuq.getContextPanelSuggestions)(cloudId, issueId);
    const url = $ea3750099e69bfcf$export$d8192485ee52671b(issueId);
    return (0, $eusud.performGetRequest)(url).then((0, $9pxAu.transformData));
};

});
parcelRegister("9pxAu", function(module, exports) {

$parcel$export(module.exports, "transformContent", () => $2284df78f056e7a3$export$b7cb80c25ebba28e);
$parcel$export(module.exports, "parseAdf", () => $2284df78f056e7a3$export$5659c60045974de9);
$parcel$export(module.exports, "transformData", () => $2284df78f056e7a3$export$3ceb62baab058c6b);
const $2284df78f056e7a3$export$b7cb80c25ebba28e = (content)=>{
    return {
        title: $2284df78f056e7a3$export$5659c60045974de9(content.title),
        description: $2284df78f056e7a3$export$5659c60045974de9(content.description)
    };
};
const $2284df78f056e7a3$export$3ceb62baab058c6b = (data)=>({
        type: 'ServicePanelSuggestions',
        summary: $2284df78f056e7a3$export$5659c60045974de9(data.summary),
        reporterDetails: $2284df78f056e7a3$export$5659c60045974de9(data.reporterDetails),
        nextSteps: $2284df78f056e7a3$export$5659c60045974de9(data.nextSteps),
        suggestedEscalation: $2284df78f056e7a3$export$5659c60045974de9(data.suggestedEscalation),
        suggestedActions: data.suggestedActions ? data.suggestedActions.map((action)=>{
            switch(action.type){
                case 'priority':
                    return {
                        type: action.type,
                        context: {
                            ...action.context,
                            suggestion: action.context.suggestion
                        },
                        content: $2284df78f056e7a3$export$b7cb80c25ebba28e(action.content)
                    };
                case 'comment':
                    return {
                        type: action.type,
                        context: {
                            ...action.context,
                            suggestion: action.context.suggestion
                        },
                        content: $2284df78f056e7a3$export$b7cb80c25ebba28e(action.content)
                    };
                case 'assignee':
                default:
                    return {
                        type: action.type,
                        context: {
                            ...action.context,
                            suggestion: action.context.suggestion
                        },
                        content: $2284df78f056e7a3$export$b7cb80c25ebba28e(action.content)
                    };
            }
        }) : []
    });
const $2284df78f056e7a3$export$5659c60045974de9 = (adfString)=>{
    if (!adfString) return null;
    try {
        return JSON.parse(adfString);
    } catch (_error) {
        return null;
    }
};

});

parcelRegister("jgbuq", function(module, exports) {

$parcel$export(module.exports, "getContextPanelSuggestions", () => $614a29b5470e1123$export$715f8fbc08922943);

var $jBcqv = parcelRequire("jBcqv");

var $8Uumt = parcelRequire("8Uumt");

var $5yJb9 = parcelRequire("5yJb9");

var $5Wobd = parcelRequire("5Wobd");

var $8dJMO = parcelRequire("8dJMO");
const $614a29b5470e1123$var$OPERATION_NAME = 'graphqlContextPanelQuery';
const $614a29b5470e1123$var$contextPanelQuery = (0, $jBcqv.default);
const $614a29b5470e1123$export$715f8fbc08922943 = async (cloudId, issueId)=>{
    (0, $5Wobd.startCapturingTraceIds)($614a29b5470e1123$var$OPERATION_NAME);
    const graphQLResponse = await (0, $8Uumt.fetchQuery)((0, $5yJb9.default)(), $614a29b5470e1123$var$contextPanelQuery, {
        cloudId: cloudId,
        issueId: issueId
    }).toPromise().then((data)=>{
        const traceIds = (0, $5Wobd.getTraceIds)($614a29b5470e1123$var$OPERATION_NAME);
        return (0, $8dJMO.handleGraphQLresponse)(data, traceIds);
    }).catch((error)=>{
        const traceIds = (0, $5Wobd.getTraceIds)($614a29b5470e1123$var$OPERATION_NAME);
        return (0, $8dJMO.handleGraphQLError)(error, traceIds);
    }).finally(()=>{
        (0, $5Wobd.stopCapturingTraceIds)($614a29b5470e1123$var$OPERATION_NAME);
    });
    return graphQLResponse;
};

});
parcelRegister("jBcqv", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d8b2900debf159$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5f0514ae71f1cf87f13cf8b0cfb91670>>
 * @relayHash 09eec7021c360a9e38eb37c79037a670
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 77775bf11db6efc1fca1104f7ef4a5ee6a7b9bb9595edbe6f9140d71e16dfcdb
const $86d8b2900debf159$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "issueId",
            "variableName": "issueId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "summary"
            },
            {
                "kind": "ScalarField",
                "name": "nextSteps"
            },
            {
                "kind": "ScalarField",
                "name": "reporterDetails"
            },
            {
                "kind": "ScalarField",
                "name": "suggestedEscalation"
            },
            {
                "concreteType": "AgentAISuggestAction",
                "kind": "LinkedField",
                "name": "suggestedActions",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "concreteType": "AgentAISuggestedActionContent",
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "title"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "description"
                            }
                        ]
                    },
                    {
                        "concreteType": "AgentAISuggestedActionContext",
                        "kind": "LinkedField",
                        "name": "context",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "fieldId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "suggestion"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "AgentAIContextPanelResponse"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v6 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "graphqlContextPanelQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "agentAI_contextPanel",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "graphqlContextPanelQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "agentAI_contextPanel",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "77775bf11db6efc1fca1104f7ef4a5ee6a7b9bb9595edbe6f9140d71e16dfcdb",
            "metadata": {},
            "name": "graphqlContextPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$86d8b2900debf159$var$node.hash = "a36eec22cb8eb04047a693d0800f10c6";
var $86d8b2900debf159$export$2e2bcd8739ae039 = $86d8b2900debf159$var$node;

});

parcelRegister("8dJMO", function(module, exports) {

$parcel$export(module.exports, "handleGraphQLresponse", () => $6716e474dac9243a$export$f09fdc2e4ab145a5);
$parcel$export(module.exports, "handleGraphQLError", () => $6716e474dac9243a$export$3af48ada790caea5);
/* eslint-disable jira/import-whitelist */ 
var $dO0aE = parcelRequire("dO0aE");

var $9pxAu = parcelRequire("9pxAu");
const $6716e474dac9243a$export$716425a07890b235 = (graphQLResponse, traceIds)=>{
    const data = graphQLResponse?.agentAI_contextPanel?.__typename === 'AgentAIContextPanelResponse' ? graphQLResponse?.agentAI_contextPanel : null;
    return {
        type: 'ServicePanelSuggestions',
        traceIds: traceIds,
        summary: (0, $9pxAu.parseAdf)(data?.summary),
        reporterDetails: (0, $9pxAu.parseAdf)(data?.reporterDetails),
        nextSteps: (0, $9pxAu.parseAdf)(data?.nextSteps),
        suggestedEscalation: (0, $9pxAu.parseAdf)(data?.suggestedEscalation),
        suggestedActions: data?.suggestedActions ? data?.suggestedActions?.map((action)=>({
                type: action.type,
                context: {
                    ...action.context,
                    suggestion: action.context?.suggestion
                },
                content: (0, $9pxAu.transformContent)(action?.content)
            })) : []
    };
};
const $6716e474dac9243a$export$f09fdc2e4ab145a5 = (graphQLResponse, traceIds)=>{
    const responseType = graphQLResponse?.agentAI_contextPanel?.__typename;
    if (responseType === 'AgentAIContextPanelResponse') return $6716e474dac9243a$export$716425a07890b235(graphQLResponse, traceIds);
    if (responseType === 'QueryError') {
        const errorMessage = graphQLResponse?.agentAI_contextPanel?.message ?? 'Unknown error';
        const errorStatus = graphQLResponse?.agentAI_contextPanel?.extensions?.[0]?.statusCode ?? 500;
        throw new (0, $dO0aE.FetchError)(errorStatus, `Error processing graphQL query: ${errorMessage}`, traceIds?.[0]);
    }
    throw new (0, $dO0aE.FetchError)(500, 'Failed to fetch data from AGG', traceIds?.[0]);
};
const $6716e474dac9243a$export$3af48ada790caea5 = (error, traceIds)=>{
    throw new (0, $dO0aE.FetchError)(500, `Failed to fetch data from AGG : ${error?.message}`, traceIds?.[0]);
};

});



parcelRegister("l9pCw", function(module, exports) {

$parcel$export(module.exports, "getIncidentSuggestionEndpoint", () => $b39b696aeaf00873$export$32b63803a24bceaa);

var $7f4tk = parcelRequire("7f4tk");

var $4R6GH = parcelRequire("4R6GH");

var $1p8cH = parcelRequire("1p8cH");
const $b39b696aeaf00873$export$db19de3f154d9918 = ({ cloudId: cloudId, issueId: issueId, projectId: projectId, locale: locale })=>`/gateway/api/jsm/aiops/cloudId/${cloudId}/api/v1/incident-suggestion/${issueId}?projectId=${projectId}&locale=${locale}
`;
const $b39b696aeaf00873$export$32b63803a24bceaa = (reqParams)=>{
    const url = $b39b696aeaf00873$export$db19de3f154d9918(reqParams);
    return (0, $7f4tk.default)(url, {
        method: 'GET'
    }).then((0, $4R6GH.fg)('aiops_incident_suggestion_v2') ? (0, $1p8cH.transformResponseV2) : (0, $1p8cH.transformResponse));
};

});
parcelRegister("1p8cH", function(module, exports) {

$parcel$export(module.exports, "transformResponse", () => $e2c7d231fb0d2d58$export$3361e9be8093ddcc);
$parcel$export(module.exports, "transformResponseV2", () => $e2c7d231fb0d2d58$export$deb8fcf4bacae588);
// Resource doesn't allow imports of getEmptyADF();
const $e2c7d231fb0d2d58$var$EMPTY_DOCUMENT = {
    version: 1,
    type: 'doc',
    content: []
};
const $e2c7d231fb0d2d58$var$parseToADF = (adfString)=>{
    try {
        return JSON.parse(adfString);
    } catch (error) {
        return $e2c7d231fb0d2d58$var$EMPTY_DOCUMENT;
    }
};
const $e2c7d231fb0d2d58$var$transformContent = (content)=>{
    return {
        title: $e2c7d231fb0d2d58$var$parseToADF(content.title),
        description: $e2c7d231fb0d2d58$var$parseToADF(content.description)
    };
};
const $e2c7d231fb0d2d58$var$transformMultipleSectionContent = (content)=>{
    return {
        title: $e2c7d231fb0d2d58$var$parseToADF(content.title),
        description: $e2c7d231fb0d2d58$var$parseToADF(content.description),
        descriptionList: content.descriptionList ? content.descriptionList.map((suggestion)=>({
                id: suggestion.id,
                description: $e2c7d231fb0d2d58$var$parseToADF(suggestion.description)
            })) : []
    };
};
const $e2c7d231fb0d2d58$var$exhaustiveCheck = (_)=>null;
const $e2c7d231fb0d2d58$export$3361e9be8093ddcc = (response)=>{
    return {
        type: 'OpsPanelSuggestions',
        incidentSummary: {
            ...response.incidentSummary.content,
            description: $e2c7d231fb0d2d58$var$parseToADF(response.incidentSummary.content.description)
        },
        probableRCA: response.probableRCA?.content ? {
            ...response.probableRCA.content,
            description: $e2c7d231fb0d2d58$var$parseToADF(response.probableRCA.content.description)
        } : null,
        suggestedActions: response.suggestedActions.map((action)=>{
            switch(action.type){
                case 'SEVERITY':
                    return {
                        ...action,
                        context: {
                            ...action.context,
                            suggestion: {
                                ...action.context.suggestion,
                                value: action.context.suggestion.name
                            }
                        },
                        content: $e2c7d231fb0d2d58$var$transformContent(action.content)
                    };
                case 'AFFECTED_SERVICES':
                    return {
                        ...action,
                        context: {
                            ...action.context,
                            suggestion: action.context.suggestion.map((service)=>({
                                    id: service.id,
                                    name: service.name,
                                    data: service
                                }))
                        },
                        content: $e2c7d231fb0d2d58$var$transformContent(action.content)
                    };
                case 'PROBLEM_TICKET':
                case 'MAJOR_INCIDENT':
                case 'PRIORITY':
                case 'RESPONDERS':
                case 'RCA_WITH_AUTOMATION':
                    return {
                        ...action,
                        content: $e2c7d231fb0d2d58$var$transformContent(action.content)
                    };
                default:
                    return $e2c7d231fb0d2d58$var$exhaustiveCheck(action);
            }
        }).filter(Boolean)
    };
};
const $e2c7d231fb0d2d58$export$deb8fcf4bacae588 = (response)=>{
    return {
        type: 'OpsPanelSuggestions',
        incidentSummary: {
            ...response.incidentSummary.content,
            description: $e2c7d231fb0d2d58$var$parseToADF(response.incidentSummary.content.description)
        },
        probableRCA: response.probableRCA?.content ? {
            ...response.probableRCA.content,
            description: $e2c7d231fb0d2d58$var$parseToADF(response.probableRCA.content.description)
        } : null,
        suggestedActions: response.suggestedActions.map((action)=>{
            switch(action.type){
                case 'SEVERITY':
                    return {
                        ...action,
                        context: {
                            ...action.context,
                            suggestion: {
                                ...action.context.suggestion,
                                value: action.context.suggestion.name
                            }
                        },
                        content: $e2c7d231fb0d2d58$var$transformContent(action.content)
                    };
                case 'AFFECTED_SERVICES':
                    return {
                        ...action,
                        context: {
                            ...action.context,
                            suggestion: action.context.suggestion.map((service)=>({
                                    id: service.id,
                                    name: service.name,
                                    data: service
                                }))
                        },
                        content: $e2c7d231fb0d2d58$var$transformMultipleSectionContent(action.content)
                    };
                case 'PROBLEM_TICKET':
                    return {
                        ...action,
                        context: action.context,
                        content: $e2c7d231fb0d2d58$var$transformContent(action.content)
                    };
                case 'MAJOR_INCIDENT':
                    return {
                        ...action,
                        context: action.context,
                        content: $e2c7d231fb0d2d58$var$transformContent(action.content)
                    };
                case 'PRIORITY':
                    return {
                        ...action,
                        context: action.context,
                        content: $e2c7d231fb0d2d58$var$transformContent(action.content)
                    };
                case 'RESPONDERS':
                    return {
                        ...action,
                        context: action.context,
                        content: $e2c7d231fb0d2d58$var$transformMultipleSectionContent(action.content)
                    };
                case 'RCA_WITH_AUTOMATION':
                    return {
                        ...action,
                        content: $e2c7d231fb0d2d58$var$transformContent(action.content)
                    };
                case 'ASSIGNEE':
                    return {
                        ...action,
                        context: action.context,
                        content: $e2c7d231fb0d2d58$var$transformMultipleSectionContent(action.content)
                    };
                default:
                    return $e2c7d231fb0d2d58$var$exhaustiveCheck(action);
            }
        }).filter(Boolean)
    };
};

});


parcelRegister("3kPby", function(module, exports) {

$parcel$export(module.exports, "getIssueDetails", () => $c64e867b4dbdc4a9$export$da0733c355d205d6);

var $4ytlu = parcelRequire("4ytlu");

var $8Uumt = parcelRequire("8Uumt");

var $5yJb9 = parcelRequire("5yJb9");

var $dGrdR = parcelRequire("dGrdR");
const $c64e867b4dbdc4a9$var$ISSUE_DETAILS_AGG_METRIC = 'context-panel-issue-details-agg';
const $c64e867b4dbdc4a9$var$issueDetailsAggMetric = (0, $dGrdR.metrics).custom({
    key: $c64e867b4dbdc4a9$var$ISSUE_DETAILS_AGG_METRIC
});
const $c64e867b4dbdc4a9$export$da0733c355d205d6 = async (issueKey, cloudId, includeContextPanelState = false)=>{
    $c64e867b4dbdc4a9$var$issueDetailsAggMetric.start();
    const issueDetails = await (0, $8Uumt.fetchQuery)((0, $5yJb9.default)(), (0, $4ytlu.default), {
        issueKey: issueKey,
        cloudId: cloudId,
        includeContextPanelState: includeContextPanelState
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise().then((data)=>{
        $c64e867b4dbdc4a9$var$issueDetailsAggMetric.stop();
        return data;
    }).catch((e)=>{
        $c64e867b4dbdc4a9$var$issueDetailsAggMetric.cancel();
        throw e;
    });
    return {
        issueId: issueDetails?.jira?.issueByKey?.issueId ?? undefined,
        practice: issueDetails?.jira?.issueByKey?.fieldByIdOrAlias?.text ?? undefined,
        projectId: issueDetails?.jira?.issueByKey?.projectField?.project?.projectId ?? undefined,
        isAIEnabled: issueDetails?.jira?.issueByKey?.projectField?.project?.isAIEnabled ?? undefined,
        ...includeContextPanelState && {
            isAiContextFeatureEnabled: issueDetails?.jira?.issueByKey?.projectField?.project?.isAiContextFeatureEnabled ?? undefined
        }
    };
};

});
parcelRegister("4ytlu", function(module, exports) {

$parcel$export(module.exports, "default", () => $84805cad546fc546$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<97b1ac959a33600e23b69a5ece8a9862>>
 * @relayHash f0aba673194e9058619abb300a99e877
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4deac53f2aeea0fe5f4fcf151ec1117fd3c5e9ae76d076f740f109cf10a9df74
const $84805cad546fc546$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeContextPanelState"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "issueKey"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v5 = [
        {
            "kind": "Literal",
            "name": "idOrAlias",
            "value": "servicedesk-practices"
        }
    ], v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "text"
            }
        ],
        "type": "JiraSingleLineTextField"
    }, v7 = {
        "kind": "ScalarField",
        "name": "isAIEnabled"
    }, v8 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v9 = {
        "condition": "includeContextPanelState",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isAiContextFeatureEnabled"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueDetailsForAIContextPanelQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "args": v5 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "fieldByIdOrAlias",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ 
                                    ],
                                    "storageKey": "fieldByIdOrAlias(idOrAlias:\"servicedesk-practices\")"
                                },
                                {
                                    "concreteType": "JiraProjectField",
                                    "kind": "LinkedField",
                                    "name": "projectField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "issueDetailsForAIContextPanelQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "args": v5 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "fieldByIdOrAlias",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ],
                                    "storageKey": "fieldByIdOrAlias(idOrAlias:\"servicedesk-practices\")"
                                },
                                {
                                    "concreteType": "JiraProjectField",
                                    "kind": "LinkedField",
                                    "name": "projectField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ 
                                            ]
                                        },
                                        v10 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4deac53f2aeea0fe5f4fcf151ec1117fd3c5e9ae76d076f740f109cf10a9df74",
            "metadata": {},
            "name": "issueDetailsForAIContextPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$84805cad546fc546$var$node.hash = "31378fdb45b287b152e0f480c90e621a";
var $84805cad546fc546$export$2e2bcd8739ae039 = $84805cad546fc546$var$node;

});


parcelRegister("70Yef", function(module, exports) {

$parcel$export(module.exports, "getFeatureState", () => $8817fa0932717f4c$export$c8c54cead17ad7fa);
// eslint-disable-next-line jira/import-whitelist

var $dGrdR = parcelRequire("dGrdR");

var $frQmB = parcelRequire("frQmB");
const $8817fa0932717f4c$var$FEATURE_STATE_METRIC = 'context-panel-feature-states';
const $8817fa0932717f4c$var$featureStateMetric = (0, $dGrdR.metrics).custom({
    key: $8817fa0932717f4c$var$FEATURE_STATE_METRIC
});
const $8817fa0932717f4c$export$c8c54cead17ad7fa = (routerDataContext, resourceStoreContext)=>{
    $8817fa0932717f4c$var$featureStateMetric.start();
    return (0, $frQmB.featuresResource)(routerDataContext, resourceStoreContext)?.then((data)=>{
        $8817fa0932717f4c$var$featureStateMetric.stop();
        return data;
    }).catch((e)=>{
        $8817fa0932717f4c$var$featureStateMetric.cancel();
        throw e;
    });
};

});
parcelRegister("frQmB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "transformRestData", () => $3a8e348215e4bd89$export$40da6ae06b8b332e);
$parcel$export(module.exports, "featuresResource", () => $3a8e348215e4bd89$export$16f81cc9da2c6c47);
$parcel$export(module.exports, "default", () => $3a8e348215e4bd89$export$2e2bcd8739ae039);

var $9XE6b = parcelRequire("9XE6b");

var $x9xyg = parcelRequire("x9xyg");

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $8PRuf = parcelRequire("8PRuf");

var $iR3GG = parcelRequire("iR3GG");

var $1nb22 = parcelRequire("1nb22");

var $9NiTW = parcelRequire("9NiTW");
const $3a8e348215e4bd89$export$40da6ae06b8b332e = (data)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    data.reduce((acc, { feature: feature, status: status, editable: editable })=>Object.assign(acc, {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [feature]: {
                status: status,
                editable: editable
            }
        }), {});
const $3a8e348215e4bd89$var$getFeatures = async (baseUrl, projectKey)=>{
    try {
        const data = await (0, $7f4tk.default)(`${baseUrl}/rest/servicedesk/1/servicedesk/${projectKey}/features`);
        (0, $x9xyg.setMark)((0, $8PRuf.prefetchApiReadyMark));
        return $3a8e348215e4bd89$export$40da6ae06b8b332e(data);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jiraServicedeskPracticeFeaturesResource', error);
        (0, $jcw0u.default)({
            meta: {
                id: 'jiraServicedeskPracticeFeaturesResource',
                packageName: 'jiraSpa'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $3a8e348215e4bd89$export$16f81cc9da2c6c47 = ({ match: match, query: query }, { tenantContext: tenantContext })=>{
    const { params: params } = match;
    if (!(0, $9NiTW.checkAuthentication)(tenantContext)) throw (0, $iR3GG.createResourceError)({
        component: 'spa.view.routes.servicedesk.features.getData',
        message: 'Current user is not authenticated',
        name: 'AuthenticationError',
        skipSentry: true
    });
    // projectKey from url path or issueKey
    const projectKey = (0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(params, 'issueKey', '')?.split('-')[0];
    if (projectKey == null) return null;
    return $3a8e348215e4bd89$var$getFeatures(tenantContext.baseUrl, projectKey);
};
var $3a8e348215e4bd89$export$2e2bcd8739ae039 = $3a8e348215e4bd89$export$16f81cc9da2c6c47;

});



parcelRegister("7bHMy", function(module, exports) {

$parcel$export(module.exports, "projectGlobalComponentsResource", () => $3744a548180a29bd$export$d2cb7067a31cf873);

var $2M1hQ = parcelRequire("2M1hQ");

var $1nb22 = parcelRequire("1nb22");

var $jSMJu = parcelRequire("jSMJu");
const $3744a548180a29bd$export$be79e0677801e96e = 'PROJECT_GLOBAL_COMPONENTS';
const $3744a548180a29bd$export$d2cb7067a31cf873 = (0, $2M1hQ.createResource)({
    type: $3744a548180a29bd$export$be79e0677801e96e,
    getKey: (matchedRoute)=>(0, $1nb22.getProjectIdOrKey)(matchedRoute.match, matchedRoute.query),
    getData: (...args)=>(0, $jSMJu.getData)(...args)
});

});
parcelRegister("jSMJu", function(module, exports) {

$parcel$export(module.exports, "getData", () => $1db0f1fd3df49120$export$7a171f172be0782e);

var $1nb22 = parcelRequire("1nb22");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $1db0f1fd3df49120$export$7a171f172be0782e = async (matchedRoute, _)=>{
    const projectIdOrKey = (0, $1nb22.getProjectIdOrKey)(matchedRoute.match, matchedRoute.query);
    if (projectIdOrKey == null || projectIdOrKey === '') return null;
    return $1db0f1fd3df49120$export$1db3503600a1638e(projectIdOrKey);
};
const $1db0f1fd3df49120$var$GLOBAL_COMPONENTS_PROPERTY_KEY = 'jira.global.components';
// Default projectKey regex, source: https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-api/src/main/java/com/atlassian/jira/util/JiraKeyUtils.java#421
const $1db0f1fd3df49120$var$PROJECT_KEY_REGEX = /^[A-Z][A-Z]+$/;
const $1db0f1fd3df49120$var$url = (projectIdOrKey, entityKey)=>`/rest/api/3/project/${projectIdOrKey}/properties/${entityKey}`;
const $1db0f1fd3df49120$var$getProjectId = async (projectKey)=>{
    const project = await (0, $eusud.performGetRequest)(`/rest/api/3/project/${projectKey}`);
    return project?.id;
};
const $1db0f1fd3df49120$export$1db3503600a1638e = async (projectKey)=>{
    try {
        let endpoint;
        if (!$1db0f1fd3df49120$var$PROJECT_KEY_REGEX.test(projectKey)) {
            // We need to fetch the project id here because some users have malformed project keys that are not compatible with the project properties endpoint
            const projectId = await $1db0f1fd3df49120$var$getProjectId(projectKey);
            if (!projectId) return {
                key: $1db0f1fd3df49120$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
                value: null
            };
            endpoint = $1db0f1fd3df49120$var$url(projectId, $1db0f1fd3df49120$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        } else endpoint = $1db0f1fd3df49120$var$url(projectKey, $1db0f1fd3df49120$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        return await (0, $eusud.performGetRequest)(endpoint);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // The endpoint returns 404 if the project property is not set, but we don't treat it as an
        // actual error
        if (error.statusCode === 404) return {
            key: $1db0f1fd3df49120$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
            value: null
        };
        (0, $jcw0u.default)({
            meta: {
                id: 'getGlobalComponentsProperty',
                packageName: 'jiraCompassCommon',
                teamName: 'compass-lodestone'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                projectKey: projectKey
            }
        });
        throw error;
    }
};

});


parcelRegister("2dmpO", function(module, exports) {

$parcel$export(module.exports, "conditionalSmartRepliesOptInStatusResources", () => $f8439f5067be62dd$export$3cb736b345649d9b);
$parcel$export(module.exports, "conditionalForgeResource", () => $f8439f5067be62dd$export$64ecc3d62be6b4bf);
$parcel$export(module.exports, "getUnusedRouteResources", () => $f8439f5067be62dd$export$a8ad2004cacc1137);
$parcel$export(module.exports, "removeNonCritialGiraCallFromCriticalPath", () => $f8439f5067be62dd$export$b398e8f4bdfdca6);
$parcel$export(module.exports, "getUnusedEmbedRouteResources", () => $f8439f5067be62dd$export$5776b3711dd897da);
$parcel$export(module.exports, "LazyIssuePage", () => $f8439f5067be62dd$export$3e1d7c9fee0b1f1a);
$parcel$export(module.exports, "IssueComponent", () => $f8439f5067be62dd$export$c1a868ace2f38803);
$parcel$export(module.exports, "IssueEmbedComponent", () => $f8439f5067be62dd$export$ef02bcc0eb1d9ded);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $1FeCu = parcelRequire("1FeCu");

var $7DqiA = parcelRequire("7DqiA");

var $93Yeu = parcelRequire("93Yeu");

var $dAfqg = parcelRequire("dAfqg");

var $lNicp = parcelRequire("lNicp");

var $l2N2a = parcelRequire("l2N2a");

var $bmvW5 = parcelRequire("bmvW5");

var $eqN9Q = parcelRequire("eqN9Q");

var $jdjBW = parcelRequire("jdjBW");

var $1WlLE = parcelRequire("1WlLE");

var $gNStA = parcelRequire("gNStA");

var $lGGIs = parcelRequire("lGGIs");

var $5j7Th = parcelRequire("5j7Th");

var $5CPDv = parcelRequire("5CPDv");

var $kxZPA = parcelRequire("kxZPA");

var $7tQej = parcelRequire("7tQej");
var $bmKPg = parcelRequire("bmKPg");

var $lCj8l = parcelRequire("lCj8l");
const $f8439f5067be62dd$export$3cb736b345649d9b = (0, $gNStA.resourceWithCondition2)(()=>!(0, $4R6GH.fg)('smart-replies-system-setting'), (0, $1FeCu.smartRepliesOptInStatusResources));
const $f8439f5067be62dd$export$64ecc3d62be6b4bf = (0, $gNStA.resourceWithCondition2)(()=>!(0, $4R6GH.fg)('move_forge_data_fetch_to_main_issue_agg'), (0, $5CPDv.issueForgeDataResource));
const $f8439f5067be62dd$export$a8ad2004cacc1137 = ()=>(0, $4R6GH.fg)('issue_view_remove_unused_route_resources') ? [] : [
        (0, $jdjBW.issueMediaUserAuthResource),
        (0, $bmvW5.issueMediaReadPermissionResource),
        (0, $eqN9Q.issueMediaUploadPermissionResource)
    ];
const $f8439f5067be62dd$export$b398e8f4bdfdca6 = ()=>(0, $4R6GH.fg)('move_iv_noncriticalgiraquery_out_of_critical_path') ? [] : [
        (0, $lCj8l.issueGiraNonCriticalDataResource)
    ];
const $f8439f5067be62dd$export$5776b3711dd897da = ()=>(0, $4R6GH.fg)('issue_view_remove_unused_route_resources') ? // eslint-disable-next-line camelcase
    [
        (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource)
    ] : [
        ...(0, $lNicp.getBusinessProjectResources)(),
        (0, $1WlLE.queuesNavigationItems),
        (0, $jdjBW.issueMediaUserAuthResource),
        (0, $bmvW5.issueMediaReadPermissionResource),
        (0, $eqN9Q.issueMediaUploadPermissionResource)
    ];

const $f8439f5067be62dd$export$3e1d7c9fee0b1f1a = (0, $kxZPA.lazyForPaint)(()=>(0, $lGGIs.markAsBentoBundleReady)(// chunk name here MUST be kept in sync with TempLazyIssuePageWithSsrAlwaysDisabled below
    (parcelRequire("kJXED"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/issue/src/index.tsx"
});
const $f8439f5067be62dd$export$c1a868ace2f38803 = ()=>{
    const { data: data } = (0, $dAfqg.useProjectContext)();
    const [issueKey] = (0, $bmKPg.usePathParam)('issueKey');
    const pageId = 'spa-issue';
    const [projectKey, issueSuffix] = issueKey !== undefined ? issueKey.split('-') : [];
    let actualIssueKey = issueKey;
    if (data?.projectKey && data.projectKey !== projectKey) actualIssueKey = `${data.projectKey}-${issueSuffix}`;
    // special handling for product discovery (=== Polaris) project issues. During the experimental phase of
    // the polaris idea view (product-specific issue view), we will redirect to a polaris-specific issue view
    // page here instead of bento.
    // this will only happen for issues of this specific project type, and only if the switchover FF is enabled
    if (!false && data?.projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT) && data?.projectKey !== undefined && actualIssueKey !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/jira/polaris/projects/${data.projectKey}/ideas?selectedIssue=${actualIssueKey}`
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f8439f5067be62dd$export$3e1d7c9fee0b1f1a,
        pageId: pageId,
        shouldShowSpinner: false
    });
};
const $f8439f5067be62dd$export$ef02bcc0eb1d9ded = ()=>{
    const [issueKey] = (0, $bmKPg.usePathParam)('issueKey');
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey || '');
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const projectId = (0, $93Yeu.useProjectId)(projectKey);
    // Special handling for product discovery (=== Polaris) project issues in embed mode.
    // We have to redirect to Polaris issue embed view instead of loading Jira issue view.
    if (projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT) && projectKey !== undefined && projectId !== undefined && issueKey !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/secure/JiraProductDiscoveryEmbedded.jspa?projectId=${projectId}&projectKey=${projectKey}&issueKey=${issueKey}`
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7DqiA.EmbedModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f8439f5067be62dd$export$c1a868ace2f38803, null));
};

});
parcelRegister("1FeCu", function(module, exports) {

$parcel$export(module.exports, "smartRepliesOptInStatusResources", () => $420bb98aaad6bbf4$export$d9a3116994d66cfc);
$parcel$export(module.exports, "useSmartRepliesPreferencesResources", () => $420bb98aaad6bbf4$export$8d607fdbd07ed6ca);

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

var $aHuqL = parcelRequire("aHuqL");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

const $420bb98aaad6bbf4$export$d9a3116994d66cfc = (0, $2M1hQ.createResource)({
    type: (0, $258f696a148ea88e$export$ea895d05049da93c),
    getKey: ()=>(0, $258f696a148ea88e$export$92a8ee31fa2d5df3),
    getData: async ()=>{
        let smartRepliesOptInStatus = null;
        try {
            smartRepliesOptInStatus = await (0, $aHuqL.userPreferenceAPI).get((0, $258f696a148ea88e$export$92a8ee31fa2d5df3));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode !== 404) (0, $2YZCu.default).safeErrorWithoutCustomerData((0, $258f696a148ea88e$export$92a8ee31fa2d5df3), (0, $258f696a148ea88e$export$b8b9d90f9e5bd72b), error);
            (0, $jcw0u.default)({
                meta: {
                    id: 'smartRepliesOptInStatusResources',
                    packageName: (0, $258f696a148ea88e$export$b8b9d90f9e5bd72b),
                    teamName: 'jira-warepil'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            smartRepliesOptInStatus: smartRepliesOptInStatus
        };
    },
    maxAge: Number.MAX_VALUE
});
const $420bb98aaad6bbf4$export$8d607fdbd07ed6ca = ()=>{
    const { data: data, refresh: refresh, loading: loading } = (0, $2YP9W.useResource)($420bb98aaad6bbf4$export$d9a3116994d66cfc);
    return {
        isSmartRepliesPreferenceEnabled: data?.smartRepliesOptInStatus?.isEnabled ?? true,
        loading: loading,
        refreshData: refresh
    };
};

});
const $258f696a148ea88e$export$92a8ee31fa2d5df3 = 'jira.user.smart_replies_feature.status';
const $258f696a148ea88e$export$ea895d05049da93c = 'RESOURCE_TYPE_ISSUE_SMART_REPLIES_STATUS';
const $258f696a148ea88e$export$b8b9d90f9e5bd72b = 'jiraIssueSmartRepliesPreferences';


parcelRegister("bmvW5", function(module, exports) {

$parcel$export(module.exports, "issueMediaReadPermissionResource", () => $2368cab4ab12a1eb$export$3b5744f70b49a5c4);

var $2M1hQ = parcelRequire("2M1hQ");

var $5XgeZ = parcelRequire("5XgeZ");
const $2368cab4ab12a1eb$export$3b5744f70b49a5c4 = (0, $2M1hQ.createResource)((0, $5XgeZ.withResourceEarlyData)({
    type: 'ISSUE_MEDIA_READ_PERM',
    getKey: ({ match: match })=>match && match.params && match.params.issueKey !== undefined && match.params.issueKey !== null ? match.params.issueKey : '',
    getData: ()=>null,
    isBrowserOnly: true
}));

});

parcelRegister("eqN9Q", function(module, exports) {

$parcel$export(module.exports, "issueMediaUploadPermissionResource", () => $018bbab5966993b0$export$80c2a5c658bd9e1e);

var $2Yhep = parcelRequire("2Yhep");

var $2M1hQ = parcelRequire("2M1hQ");

var $5XgeZ = parcelRequire("5XgeZ");
const $018bbab5966993b0$export$80c2a5c658bd9e1e = (0, $2M1hQ.createResource)((0, $5XgeZ.withResourceEarlyData)({
    type: 'ISSUE_MEDIA_UPLOAD_PERM',
    getKey: ({ match: match })=>{
        const issueKey = (0, $2Yhep.getIssueKey)(match);
        return issueKey || '';
    },
    getData: ()=>null,
    isBrowserOnly: true
}));

});

parcelRegister("jdjBW", function(module, exports) {

$parcel$export(module.exports, "issueMediaUserAuthResource", () => $c6e148d80f21d036$export$48db4eb29e9be72c);

var $2Yhep = parcelRequire("2Yhep");

var $2M1hQ = parcelRequire("2M1hQ");

var $5XgeZ = parcelRequire("5XgeZ");
const $c6e148d80f21d036$export$48db4eb29e9be72c = (0, $2M1hQ.createResource)((0, $5XgeZ.withResourceEarlyData)({
    type: 'ISSUE_MEDIA_USER_AUTH',
    getKey: ({ match: match })=>{
        const issueKey = (0, $2Yhep.getIssueKey)(match);
        return issueKey || '';
    },
    getData: ()=>null,
    isBrowserOnly: true
}));

});

parcelRegister("5CPDv", function(module, exports) {

$parcel$export(module.exports, "issueForgeDataResource", () => $82acf7aa3865e452$export$e28b79684fb81535);

var $2Yhep = parcelRequire("2Yhep");

var $2M1hQ = parcelRequire("2M1hQ");


var $gNStA = parcelRequire("gNStA");

var $6s1PB = parcelRequire("6s1PB");

var $jj8CY = parcelRequire("jj8CY");
const $82acf7aa3865e452$export$e28b79684fb81535 = (0, $gNStA.browserOnlyResourceWithCondition)(()=>{
    if (0, $cdb023d06c7f62fa$export$19d68f5aa485d903) // not "browser only" if FF is on
    return !(0, $6s1PB.expVal)('issue_view_ssr_perf_m2', 'isEnabled', false);
    return true;
}, // eslint-disable-next-line @typescript-eslint/no-explicit-any
(0, $2M1hQ.createResource)({
    type: 'ISSUE_FORGE_DATA',
    getKey: ({ match: match })=>{
        const issueKey = (0, $2Yhep.getIssueKey)(match);
        return issueKey || '';
    },
    getData: (...args)=>(0, $jj8CY.default)(...args),
    isBrowserOnly: true
}));

});
parcelRegister("jj8CY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a39eb6eca9b1263$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $hpuF5 = parcelRequire("hpuF5");

var $iR3GG = parcelRequire("iR3GG");

var $2Yhep = parcelRequire("2Yhep");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3a39eb6eca9b1263$export$2e2bcd8739ae039 = async ({ match: match }, { tenantContext: tenantContext })=>{
    const issueKey = (0, $2Yhep.getIssueKey)(match);
    if (!issueKey) return null;
    try {
        const { cloudId: cloudId, isAnonymous: isAnonymous } = tenantContext;
        const data = await (0, $hpuF5.fetchIssueForgeData)(cloudId, issueKey, isAnonymous);
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $iR3GG.createResourceError)({
            component: 'spa.view.routes.issue-view.forge.getData',
            message: 'An error was thrown while prefetching issue Forge data',
            name: 'ResourceError'
        }, error);
    }
};

});
parcelRegister("hpuF5", function(module, exports) {

$parcel$export(module.exports, "fetchIssueForgeData", () => $b0a1cdd28321d25a$export$44da8345d9ceca61);

var $k2DRb = parcelRequire("k2DRb");

var $5cmSg = parcelRequire("5cmSg");

var $iVaKa = parcelRequire("iVaKa");

var $7kNct = parcelRequire("7kNct");
const $b0a1cdd28321d25a$export$7c6ea4184129ef74 = (result, type)=>result.find((extensions)=>extensions.some((extension)=>extension.type === type)) || [];
const $b0a1cdd28321d25a$export$44da8345d9ceca61 = async (cloudId, issueKey, isAnonymous)=>{
    const extensions = await (0, $iVaKa.fetchModules)({
        cloudId: cloudId,
        isAnonymous: isAnonymous,
        types: [
            (0, $k2DRb.ISSUE_ACTION_MODULE),
            (0, $k2DRb.ISSUE_GLANCE_MODULE),
            (0, $k2DRb.ISSUE_CONTEXT_MODULE),
            (0, $k2DRb.ISSUE_PANEL_MODULE),
            (0, $k2DRb.ISSUE_ACTIVITY_MODULE),
            (0, $k2DRb.CUSTOM_FIELD_MODULE),
            (0, $k2DRb.CUSTOM_FIELD_TYPE_MODULE),
            (0, $k2DRb.ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE)
        ],
        context: {
            issueKey: issueKey
        },
        includeHidden: true,
        includeScopes: true,
        source: (0, $k2DRb.SOURCE_ISSUE_VIEW)
    });
    const getFilteredExtensions = (filterFn)=>({
            issueAction: extensions[0, $k2DRb.ISSUE_ACTION_MODULE].filter(filterFn),
            issueGlance: extensions[0, $k2DRb.ISSUE_GLANCE_MODULE].filter(filterFn),
            issueContext: extensions[0, $k2DRb.ISSUE_CONTEXT_MODULE].filter(filterFn),
            issuePanel: extensions[0, $k2DRb.ISSUE_PANEL_MODULE].filter(filterFn),
            issueActivity: extensions[0, $k2DRb.ISSUE_ACTIVITY_MODULE].filter(filterFn),
            customField: extensions[0, $k2DRb.CUSTOM_FIELD_MODULE].filter(filterFn),
            customFieldType: extensions[0, $k2DRb.CUSTOM_FIELD_TYPE_MODULE].filter(filterFn),
            issueViewBackgroundScript: extensions[0, $k2DRb.ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE].filter(filterFn)
        });
    const mappedResult = {
        ...getFilteredExtensions((extension)=>!(0, $5cmSg.isExtensionHiddenByAppAccessRules)(extension)),
        blockedExtensions: {
            ...getFilteredExtensions((extension)=>(0, $5cmSg.isExtensionHiddenByAppAccessRules)(extension))
        }
    };
    return (0, $7kNct.dedupeContextAndGlance)(mappedResult);
};

});
parcelRegister("7kNct", function(module, exports) {

$parcel$export(module.exports, "dedupeContextAndGlance", () => $4e352c29f229bbb8$export$17503ba1adfac304);
const $4e352c29f229bbb8$export$17503ba1adfac304 = (forgeData)=>{
    const contextInstallationIds = new Set(forgeData.issueContext?.map(({ installationId: installationId })=>installationId));
    const newGlanceItems = forgeData.issueGlance.filter(({ installationId: installationId })=>!contextInstallationIds.has(installationId));
    return {
        ...forgeData,
        issueGlance: newGlanceItems
    };
};

});




parcelRegister("lCj8l", function(module, exports) {

$parcel$export(module.exports, "issueGiraNonCriticalDataResource", () => $74422abbcf73f635$export$2d81f7bddf10f49e);

var $2Yhep = parcelRequire("2Yhep");

var $2M1hQ = parcelRequire("2M1hQ");

var $5XgeZ = parcelRequire("5XgeZ");

var $cvOMs = parcelRequire("cvOMs");
const $74422abbcf73f635$export$2d81f7bddf10f49e = (0, $2M1hQ.createResource)((0, $5XgeZ.withResourceEarlyData)({
    type: 'ISSUE_GIRA_NON_CRITICAL_DATA',
    getKey: ({ match: match })=>{
        const issueKey = (0, $2Yhep.getIssueKey)(match);
        return issueKey || '';
    },
    getData: (...args)=>(0, $cvOMs.default)(...args),
    isBrowserOnly: true
}));

});
parcelRegister("cvOMs", function(module, exports) {

$parcel$export(module.exports, "default", () => $07364a38d1410c3f$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $1O6Hj = parcelRequire("1O6Hj");

var $iR3GG = parcelRequire("iR3GG");

var $2Yhep = parcelRequire("2Yhep");

var $4R6GH = parcelRequire("4R6GH");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$07364a38d1410c3f$export$2e2bcd8739ae039 = async ({ match: match }, _)=>{
    const issueKey = (0, $2Yhep.getIssueKey)(match);
    if (!issueKey || (0, $4R6GH.fg)('move_iv_noncriticalgiraquery_out_of_critical_path')) return null;
    try {
        const data = await (0, $1O6Hj.fetchIssueGiraNonCriticalData)(issueKey);
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $iR3GG.createResourceError)({
            component: 'spa.view.routes.issue-view.gira-non-critical.getData',
            message: 'An error was thrown while prefetching issue gira non critical data',
            name: 'ResourceError'
        }, error);
    }
};

});
parcelRegister("1O6Hj", function(module, exports) {

$parcel$export(module.exports, "nonCriticalGiraQueryExperienceTracking", () => $6bf108f87308d37b$export$f382deefb24f95ae);
$parcel$export(module.exports, "fetchIssueGiraNonCriticalData", () => $6bf108f87308d37b$export$58a9221a6c5306db);

var $jJZqs = parcelRequire("jJZqs");

var $c6dax = parcelRequire("c6dax");

var $gXz4p = parcelRequire("gXz4p");

var $iBOrg = parcelRequire("iBOrg");
const $6bf108f87308d37b$var$nonCriticalGiraQueryExperienceDescription = ({ wasExperienceSuccessful: wasExperienceSuccessful, errorMessage: errorMessage, traceId: traceId, isEarlyFetch: isEarlyFetch })=>{
    const errorMessageItem = errorMessage != null ? {
        errorMessage: errorMessage
    } : {};
    const traceIdItem = traceId != null ? {
        traceId: traceId
    } : {};
    return {
        experience: isEarlyFetch ? 'issueEarlyFetchNonCriticalGiraQuery' : 'issueNonCriticalGiraQuery',
        wasExperienceSuccesful: wasExperienceSuccessful,
        analyticsSource: `Issue View ${isEarlyFetch ? 'Early Fetch ' : ''}Non Critical Gira Query`,
        additionalAttributes: {
            method: 'GET',
            ...errorMessageItem,
            ...traceIdItem
        },
        application: null,
        edition: null
    };
};
const $6bf108f87308d37b$export$f382deefb24f95ae = ({ wasExperienceSuccessful: wasExperienceSuccessful, isEarlyFetch: isEarlyFetch, error: error })=>{
    (0, $gXz4p.sendExperienceAnalytics)($6bf108f87308d37b$var$nonCriticalGiraQueryExperienceDescription({
        wasExperienceSuccessful: wasExperienceSuccessful,
        ...error instanceof (0, $jJZqs.default) && error.message != null ? {
            errorMessage: error.message
        } : {},
        ...error instanceof (0, $jJZqs.default) && error.traceId != null ? {
            traceId: error.traceId
        } : {},
        isEarlyFetch: isEarlyFetch
    }));
};
const $6bf108f87308d37b$export$58a9221a6c5306db = async (issueKey)=>{
    const variables = {
        issueKey: issueKey
    };
    const payload = {
        query: (0, $c6dax.buildNonCriticalGiraQuery)(),
        variables: variables,
        operationName: (0, $c6dax.ISSUE_VIEW_NON_CRITICAL_GIRA_QUERY)
    };
    try {
        const response = await (0, $iBOrg.getClient)('').query(payload);
        $6bf108f87308d37b$export$f382deefb24f95ae({
            wasExperienceSuccessful: true,
            isEarlyFetch: false
        });
        return response;
    } catch (error) {
        $6bf108f87308d37b$export$f382deefb24f95ae({
            wasExperienceSuccessful: false,
            isEarlyFetch: false,
            error: error instanceof (0, $jJZqs.default) ? error : undefined
        });
        throw error;
    }
};

});
parcelRegister("c6dax", function(module, exports) {

$parcel$export(module.exports, "ISSUE_VIEW_NON_CRITICAL_GIRA_QUERY", () => $b74efd74d6a135cc$export$857f1602ca5b9d99);
$parcel$export(module.exports, "buildNonCriticalGiraQuery", () => $b74efd74d6a135cc$export$df3c3aa9d6d3f431);
$parcel$export(module.exports, "getNonCriticalGiraQueryRequestOptions", () => $b74efd74d6a135cc$export$555194bfc9159fa3);

var $jzVvW = parcelRequire("jzVvW");
const $b74efd74d6a135cc$export$857f1602ca5b9d99 = 'issueViewNonCriticalGiraQuery';
const $b74efd74d6a135cc$export$df3c3aa9d6d3f431 = ()=>`
query ${$b74efd74d6a135cc$export$857f1602ca5b9d99}($issueKey: String!) {
    viewIssue(issueKey: $issueKey) {
        ${(0, $jzVvW.getEcosystemQuery)()}
        deletableAttachmentsCount
    }
}`;
const $b74efd74d6a135cc$export$555194bfc9159fa3 = (issueKey)=>({
        method: 'POST',
        body: JSON.stringify({
            operationName: $b74efd74d6a135cc$export$857f1602ca5b9d99,
            query: $b74efd74d6a135cc$export$df3c3aa9d6d3f431(),
            variables: {
                issueKey: issueKey
            }
        })
    });

});
parcelRegister("jzVvW", function(module, exports) {

$parcel$export(module.exports, "getEcosystemQuery", () => $8b485783ca3ced28$export$edefef8c65e08bd2);
const $8b485783ca3ced28$export$edefef8c65e08bd2 = ()=>`
  ecosystem {
    operations {
      name
      url: href
      tooltip
      styleClass
    }
    backgroundScripts {
      iframe {
        addonKey
        moduleKey
        options
      }
      shouldReloadOnRefresh
    }
  }
`;

});


parcelRegister("gXz4p", function(module, exports) {

$parcel$export(module.exports, "sendExperienceAnalytics", () => $b28eb6b892a8c2f7$export$4a95ada1b8228562);

var $1UikQ = parcelRequire("1UikQ");

var $gSA3s = parcelRequire("gSA3s");

var $hh0bW = parcelRequire("hh0bW");

var $j8DrX = parcelRequire("j8DrX");

var $4R6GH = parcelRequire("4R6GH");
const $b28eb6b892a8c2f7$var$isSynthetic = ()=>(0, $j8DrX.default)('ajs-is-synthetic') === 'true';
const $b28eb6b892a8c2f7$var$shouldAddConnectivityAttribute = (experienceDescription)=>{
    // Return false if feature flag is off
    if (!(0, $4R6GH.fg)('thor_refine_taskfail_offline_failed_events')) return false;
    // Return false if not a taskFail action
    if (experienceDescription.wasExperienceSuccesful) return false;
    const isKnownExperience = [
        'transitionIssue',
        'getTransitions',
        'startWatching',
        'stopWatching'
    ].includes(experienceDescription.experience);
    // Return false if not a known experience
    if (!isKnownExperience) return false;
    const hasStatusCode = !!experienceDescription.additionalAttributes?.statusCode;
    // Return false if status code is present
    return !hasStatusCode;
};
function $b28eb6b892a8c2f7$export$4a95ada1b8228562(experienceDescription) {
    const additionalContext = {};
    const shard = (0, $j8DrX.default)('ajs-shard');
    const region = (0, $j8DrX.default)('ajs-region');
    Object.assign(additionalContext, {
        shard: shard,
        region: region
    });
    const enabledFeatureFlags = Object.fromEntries([
        ...(0, $gSA3s.allFeatureFlagsAccessed)
    ].filter(([, value])=>value));
    Object.assign(additionalContext, {
        enabledFeatureFlags: enabledFeatureFlags
    });
    if ($b28eb6b892a8c2f7$var$shouldAddConnectivityAttribute(experienceDescription)) {
        const isOnline = typeof globalThis.window !== 'undefined' && globalThis.window?.navigator?.onLine;
        Object.assign(additionalContext, {
            isOnline: isOnline
        });
    }
    const synthetics = {
        additionalAttributes: {
            synthetic: $b28eb6b892a8c2f7$var$isSynthetic(),
            ...additionalContext
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(experienceDescription, synthetics);
    (0, $hh0bW.default)(experienceDescription);
}

});






parcelRegister("1B0QU", function(module, exports) {

$parcel$export(module.exports, "browseIssueRouteEntry", () => $a10da1f1a9bba803$export$cef770e7c16cfcc);

var $ffza4 = parcelRequire("ffza4");


var $e2ctp = parcelRequire("e2ctp");

var $4R6GH = parcelRequire("4R6GH");

var $gyYxw = parcelRequire("gyYxw");

var $g5RGc = parcelRequire("g5RGc");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $8ZUng = parcelRequire("8ZUng");

var $9XjL6 = parcelRequire("9XjL6");

var $3RJkv = parcelRequire("3RJkv");

var $1aAOt = parcelRequire("1aAOt");

var $dxCvy = parcelRequire("dxCvy");

var $1WlLE = parcelRequire("1WlLE");

var $7GnDe = parcelRequire("7GnDe");

var $fw7Rx = parcelRequire("fw7Rx");

var $gRzZD = parcelRequire("gRzZD");

var $lb0Dk = parcelRequire("lb0Dk");

var $lAGdd = parcelRequire("lAGdd");

var $gNStA = parcelRequire("gNStA");

var $7bHMy = parcelRequire("7bHMy");

var $2dmpO = parcelRequire("2dmpO");
const $a10da1f1a9bba803$var$resourcesOld = ()=>[
        ...(0, $lNicp.getBusinessProjectResources)(),
        ...(0, $3RJkv.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $7GnDe.incidentExperimentTraitResourceOnNav3Only),
        (0, $dxCvy.projectContextResource),
        (0, $5bkvv.forgeProjectModuleResourceOnNav3Only),
        (0, $iEUaw.staticSidebarShortcutsResource),
        (0, $ggg5j.staticProjectSidebarNavigationResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $1aAOt.getOfferingCatalogueFeaturesResource)(),
        ...(0, $2dmpO.getUnusedRouteResources)(),
        (0, $9XjL6.issueGiraDataResource),
        ...(0, $2dmpO.removeNonCritialGiraCallFromCriticalPath)(),
        (0, $2dmpO.conditionalForgeResource),
        (0, $8ZUng.issueViewRelayResource),
        (0, $1WlLE.queuesNavigationItems),
        (0, $gRzZD.workspaceResource),
        (0, $bHhiy.getConsolidationStateResource)(),
        (0, $2dmpO.conditionalSmartRepliesOptInStatusResources),
        (0, $lAGdd.aiContextPanelResource),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jira-project-isglobalcomponent-route-resource'), (0, $7bHMy.projectGlobalComponentsResource))
    ];
// jfp-magma-3491-reorder-issue-view-route-resources - These resources have been re-ordered. We have a theory that moving the more expensive ones to be first in the list makes them faster in SSR, there some small overhead that compounds over the 30 odd requests that happens.
// Longest poles at the moment are issueViewRelayResource and issueGiraDataResource, so we have moved them to the top of the list.
const $a10da1f1a9bba803$var$resourcesNew = ()=>[
        (0, $8ZUng.issueViewRelayResource),
        (0, $9XjL6.issueGiraDataResource),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        ...(0, $3RJkv.getNavigationResources)(),
        ...(0, $lNicp.getBusinessProjectResources)(),
        (0, $7GnDe.incidentExperimentTraitResourceOnNav3Only),
        (0, $dxCvy.projectContextResource),
        (0, $5bkvv.forgeProjectModuleResourceOnNav3Only),
        (0, $iEUaw.staticSidebarShortcutsResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        (0, $ggg5j.staticProjectSidebarNavigationResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only),
        ...(0, $1aAOt.getOfferingCatalogueFeaturesResource)(),
        ...(0, $2dmpO.getUnusedRouteResources)(),
        ...(0, $2dmpO.removeNonCritialGiraCallFromCriticalPath)(),
        (0, $2dmpO.conditionalForgeResource),
        (0, $1WlLE.queuesNavigationItems),
        (0, $gRzZD.workspaceResource),
        (0, $bHhiy.getConsolidationStateResource)(),
        (0, $2dmpO.conditionalSmartRepliesOptInStatusResources),
        (0, $lAGdd.aiContextPanelResource),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jira-project-isglobalcomponent-route-resource'), (0, $7bHMy.projectGlobalComponentsResource))
    ];
const $a10da1f1a9bba803$export$cef770e7c16cfcc = (0, $7NszV.createEntry)((0, $fw7Rx.browseIssueRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'issue',
        isHydrateRootEnabled: (0, $4R6GH.fg)('jfp-magma-issue-view-full-page-hydrate-root'),
        preloadOptions: {
            earlyChunks: [
                'issue-app-early-entry'
            ]
        },
        earlyAssets: (0, $e2ctp.NORMAL_EARLY_ASSET_STRATEGY),
        component: (0, $2dmpO.IssueComponent),
        skeleton: (0, $lb0Dk.IssueViewSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $gyYxw.genericProjectLayout), (0, $g5RGc.fullPageIssuePreloadLayout)),
        navigation: {
            sidebar: (0, $hBv66.genericProjectSidebars),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba)
        },
        resources: (0, $4R6GH.fg)('jfp-magma-3491-reorder-issue-view-route-resources') ? $a10da1f1a9bba803$var$resourcesNew() : $a10da1f1a9bba803$var$resourcesOld(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $2dmpO.LazyIssuePage)
        ],
        ufoName: 'issue-view',
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$ef94a84e2990361c)
        },
        bifrost: {
            bifrostGroup: 'issue-view',
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-entries/src/browseIssueRouteEntry.tsx',
                whichExportToUse: 'browseIssueRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-issue-view.json'
        }
    }));

});
parcelRegister("1aAOt", function(module, exports) {

$parcel$export(module.exports, "getOfferingCatalogueFeaturesResource", () => $3095ecb31c5b9ef2$export$d08a9fee651d30b2);

var $2M1hQ = parcelRequire("2M1hQ");


const $3095ecb31c5b9ef2$var$getDataLoader = ()=>(parcelRequire("gDJIx"));
const $3095ecb31c5b9ef2$export$ec991c565cf31550 = (0, $2M1hQ.createResource)({
    type: (0, $2e493fb3532188a0$export$23978b67a6b2068f),
    getKey: ()=>'state',
    getDataLoader: $3095ecb31c5b9ef2$var$getDataLoader,
    maxAge: 1800000
});
const $3095ecb31c5b9ef2$export$d08a9fee651d30b2 = ()=>[];

});
const $2e493fb3532188a0$export$23978b67a6b2068f = 'RESOURCE_TYPE_OFFERING_CATALOGUE_FEATURES';

parcelRegister("gDJIx", function(module, exports) {

let $c1d3c05a0654045c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c1d3c05a0654045c$var$load("60ISK").then(()=>parcelRequire('8OVUQ'));

});


parcelRegister("fw7Rx", function(module, exports) {

$parcel$export(module.exports, "browseIssueRoute", () => $b546ef0893c1765d$export$2c9c7e50a88e588b);
const $b546ef0893c1765d$export$2c9c7e50a88e588b = {
    name: 'issue',
    path: '/browse/:issueKey(\\w+-\\d+)(.*)?',
    query: [
        'filter?!=(.*)',
        'jql?!=(.*)'
    ]
};

});


parcelRegister("6HuHg", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorBrowseIssueRedirectRouteEntry", () => $87a1c7411057f7f3$export$30f8c1a53605b10b);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $53W5y = parcelRequire("53W5y");

var $1gXMV = parcelRequire("1gXMV");


var $8irO5 = parcelRequire("8irO5");

var $96TVI = parcelRequire("96TVI");

var $3uU6P = parcelRequire("3uU6P");

var $gGOoR = parcelRequire("gGOoR");

var $b8f12 = parcelRequire("b8f12");
const $87a1c7411057f7f3$export$30f8c1a53605b10b = (0, $7NszV.createEntry)((0, $53W5y.globalIssueNavigatorBrowseIssueRedirectRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$d0ad1160bb95ce50),
            reporting: (0, $3uU6P.getRouteReporting)()
        },
        component: (0, $gGOoR.default),
        skeleton: (0, $1gXMV.GlobalIssueNavigatorSkeleton),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $b8f12.LazyGlobalIssueNavigator)
        ],
        ufoName: 'global-issue-navigator-jfe',
        navigation: (0, $8irO5.getCommonGlobalNavigation)(),
        resources: [
            ...(0, $96TVI.getCommonGlobalResources)()
        ],
        layout: (0, $2BrOV.globalLayout)
    }));

});
parcelRegister("53W5y", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorBrowseIssueRedirectRoute", () => $2ca0ba87b3cf3506$export$34695dccebecc6bc);
const $2ca0ba87b3cf3506$export$34695dccebecc6bc = {
    name: 'global-issue-navigator-browse-issue-redirect',
    path: '/browse/:issueKey?',
    query: [
        'jql|filter'
    ]
};

});

parcelRegister("1gXMV", function(module, exports) {

$parcel$export(module.exports, "GlobalIssueNavigatorSkeleton", () => $c87e28c0f4513050$export$51681996374b2585);
/* global-app.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $QBpyl = parcelRequire("QBpyl");
const $c87e28c0f4513050$var$customCssStyles = null;
const $c87e28c0f4513050$export$51681996374b2585 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($QBpyl))),
        className: (0, $bwpsq.default)([
            "_2zz1zwfg _slt8zwfg _1od57vkz"
        ])
    });

});
parcelRegister("QBpyl", function(module, exports) {
module.exports = new URL("global-issue-navigator-skeleton.tpl.b1bf4b99.svg", import.meta.url).toString();

});


parcelRegister("8irO5", function(module, exports) {

$parcel$export(module.exports, "getCommonGlobalNavigation", () => $bc5e7fba327b7679$export$2f31f4f387017d83);

var $cSD7y = parcelRequire("cSD7y");

var $lmyls = parcelRequire("lmyls");

var $8Wi6S = parcelRequire("8Wi6S");
const $bc5e7fba327b7679$export$2f31f4f387017d83 = ()=>({
        menuId: (0, $lmyls.MENU_ID).FILTERS,
        sidebar: (0, $cSD7y.componentWithFG)('make_nav3_sidebar_lazyforpaint', (0, $8Wi6S.AsyncForPaintSidebarFiltersGlobal), (0, $8Wi6S.AsyncSidebarFiltersGlobal))
    });

});
parcelRegister("8Wi6S", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c9fa7b304f828b3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "AsyncSidebarFiltersGlobal", () => $7c9fa7b304f828b3$export$1af88ebe65f50e73);
$parcel$export(module.exports, "AsyncForPaintSidebarFiltersGlobal", () => $7c9fa7b304f828b3$export$7655c90db6341aa6);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

// Legacy GIN Sidebar
const $7c9fa7b304f828b3$var$LazySidebarFiltersLegacy = (0, $kxZPA.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("3hMyV")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/filters/src/index.tsx"
});
const $7c9fa7b304f828b3$var$AsyncSidebarFiltersLegacy = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "filters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c9fa7b304f828b3$var$LazySidebarFiltersLegacy, null)));
var $7c9fa7b304f828b3$export$2e2bcd8739ae039 = $7c9fa7b304f828b3$var$AsyncSidebarFiltersLegacy;

// Global-scope NIN sidebar
const $7c9fa7b304f828b3$var$LazyAfterPaintSidebarFiltersGlobal = (0, $kxZPA.lazyAfterPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    // using direct path instead of `index` because webpack will combine multiple chunks from same file
    return (parcelRequire("hzPjy")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle.SidebarFiltersGlobal;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/filters/src/ui/global-scope/index.tsx"
});

const $7c9fa7b304f828b3$var$LazyForPaintSidebarFiltersGlobal = (0, $kxZPA.lazyForPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    // using direct path instead of `index` because webpack will combine multiple chunks from same file
    // eslint-disable-next-line jira/import/webpack-magic-comment-entries
    return (parcelRequire("hzPjy")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle.SidebarFiltersGlobal;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/filters/src/ui/global-scope/index.tsx"
});
const $7c9fa7b304f828b3$export$1af88ebe65f50e73 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "filters-global"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c9fa7b304f828b3$var$LazyAfterPaintSidebarFiltersGlobal, null)));
const $7c9fa7b304f828b3$export$7655c90db6341aa6 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "filters-global"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c9fa7b304f828b3$var$LazyForPaintSidebarFiltersGlobal, null)));

});
parcelRegister("3hMyV", function(module, exports) {

let $2648a11bd10abe27$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2648a11bd10abe27$var$load("ffQaD"),
    $2648a11bd10abe27$var$load("kvRbA"),
    $2648a11bd10abe27$var$load("f324T")
]).then(()=>parcelRequire('7T8w9'));

});

parcelRegister("hzPjy", function(module, exports) {

let $ccbd828b2651a9b2$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ccbd828b2651a9b2$var$load("ffQaD"),
    $ccbd828b2651a9b2$var$load("kvRbA"),
    $ccbd828b2651a9b2$var$load("1QDPs")
]).then(()=>parcelRequire('hcPI1'));

});



parcelRegister("96TVI", function(module, exports) {

$parcel$export(module.exports, "getCommonGlobalResources", () => $546bc7982ebbd30d$export$343e92405307cf8d);

var $4R6GH = parcelRequire("4R6GH");

var $96w9D = parcelRequire("96w9D");

var $8CVvd = parcelRequire("8CVvd");

var $bATyw = parcelRequire("bATyw");

var $89kiv = parcelRequire("89kiv");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $gNStA = parcelRequire("gNStA");

var $lAGdd = parcelRequire("lAGdd");
const $546bc7982ebbd30d$export$343e92405307cf8d = ()=>[
        (0, $89kiv.issueNavigatorRelayResource),
        (0, $89kiv.issueNavigatorFilterRelayResource),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('nin_request_hydrate_query_earlier'), (0, $89kiv.issueNavigatorHydrationRelayResource)),
        ...(0, $3RJkv.getNavigationResources)(),
        (0, $atU1t.navigationSidebarGlobalResource),
        (0, $bATyw.isNinGlobalScopeEnrolmentEnabledResource),
        (0, $gNStA.resourceWithCondition2)((0, $8CVvd.getWillShowNav3), (0, $96w9D.sidebarFiltersGlobalResource)),
        (0, $lAGdd.aiContextPanelResource)
    ];

});
parcelRegister("96w9D", function(module, exports) {

$parcel$export(module.exports, "sidebarFiltersGlobalResource", () => $4afb52221e3a3f09$export$7e0b804085f0470d);

var $ao2h1 = parcelRequire("ao2h1");

var $gBXKh = parcelRequire("gBXKh");

var $6YG83 = parcelRequire("6YG83");
const $4afb52221e3a3f09$export$7e0b804085f0470d = (0, $6YG83.withGiraAggAnonSsrFix)((0, $ao2h1.createRelayResource)({
    type: 'NAVIGATION_SIDEBAR_FILTERS_GLOBAL',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $gBXKh.default),
            variables: {
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
}));

});
parcelRegister("gBXKh", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0f1ab872360a786$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4654bfdfd3e20081cf96674156c0485e>>
 * @relayHash b167c3924c240111eb2c04f5138be112
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 488e4e7ceb05d5d63726635de6bb578e2d4b52a4643ab9ca4393d1579b8d07f0

var $7vXy9 = parcelRequire("7vXy9");
const $a0f1ab872360a786$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v6 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            }
        ],
        "type": "JiraCustomFilter"
    }, v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "starredFiltersList_navigationAppsSidebarCommon"
                            },
                            {
                                "args": v2 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "systemFilters_navigationAppsSidebarFilters_SystemFiltersSection"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "isFavourite",
                                    "value": false
                                }
                            ],
                            "concreteType": "JiraSystemFilterConnection",
                            "kind": "LinkedField",
                            "name": "systemFilters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSystemFilterEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSystemFilter",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ],
                                                    "type": "JiraFilter",
                                                    "abstractKey": "__isJiraFilter"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "favouriteFilters",
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": {
                                                    "order": "DESC"
                                                },
                                                "type": "FILTER"
                                            }
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 15
                                        }
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v8 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v4 /*: any*/ 
                                                            ],
                                                            "type": "Node",
                                                            "abstractKey": "__isNode"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "favouriteFiltersOld",
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraFilterConnection",
                                    "kind": "LinkedField",
                                    "name": "favouriteFilters",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFilterEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "TypeDiscriminator",
                                                            "abstractKey": "__isJiraFilter"
                                                        },
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "488e4e7ceb05d5d63726635de6bb578e2d4b52a4643ab9ca4393d1579b8d07f0",
            "metadata": {},
            "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider": (0, $7vXy9.default)
            }
        }
    };
}();
$a0f1ab872360a786$var$node.hash = "b5467e25277d67ce676aa25dd3a16377";
var $a0f1ab872360a786$export$2e2bcd8739ae039 = $a0f1ab872360a786$var$node;

});
parcelRegister("7vXy9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ac90445fe2bfbc0$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $3ac90445fe2bfbc0$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('add_limit_to_nav3_starred_filter_sidebar');
    }
};

});



parcelRegister("bATyw", function(module, exports) {

$parcel$export(module.exports, "isNinGlobalScopeEnrolmentEnabledResource", () => $a818348721ae6866$export$3f6390b4131d761b);

var $2M1hQ = parcelRequire("2M1hQ");

const $a818348721ae6866$var$getDataLoader = ()=>(parcelRequire("jyZ5j"));
const $a818348721ae6866$export$3f6390b4131d761b = (0, $2M1hQ.createResource)({
    type: 'NIN_GLOBAL_SCOPE_ENROLMENT_RESOURCE',
    getKey: ()=>'ninGlobalScopeEnrolment',
    getDataLoader: $a818348721ae6866$var$getDataLoader
});

});
parcelRegister("jyZ5j", function(module, exports) {

let $e3e0936d37a0ceb5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e3e0936d37a0ceb5$var$load("7etJl").then(()=>parcelRequire('dIecw'));

});


parcelRegister("89kiv", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorRelayResource", () => $93f22f98fd07bff0$export$b4096f516fb93159);
$parcel$export(module.exports, "issueNavigatorFilterRelayResource", () => $93f22f98fd07bff0$export$44ca3a0b25f38d83);
$parcel$export(module.exports, "issueNavigatorHydrationRelayResource", () => $93f22f98fd07bff0$export$967ef0cfbd1cc946);
/* eslint-disable jira/import-whitelist */ 
var $8Uumt = parcelRequire("8Uumt");

var $6oLWS = parcelRequire("6oLWS");

var $6s1PB = parcelRequire("6s1PB");

var $9Nvh7 = parcelRequire("9Nvh7");

var $6UAdF = parcelRequire("6UAdF");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $dXq4S = parcelRequire("dXq4S");

var $5yJb9 = parcelRequire("5yJb9");

var $kipqU = parcelRequire("kipqU");

var $ao2h1 = parcelRequire("ao2h1");

var $16Yit = parcelRequire("16Yit");

var $kvekU = parcelRequire("kvekU");

var $hTvlq = parcelRequire("hTvlq");

var $2M1hQ = parcelRequire("2M1hQ");

var $4R6GH = parcelRequire("4R6GH");

var $5cSAN = parcelRequire("5cSAN");

var $5bSAg = parcelRequire("5bSAg");

var $aBKbA = parcelRequire("aBKbA");
const $93f22f98fd07bff0$export$b4096f516fb93159 = (0, $2M1hQ.createResource)({
    type: `${(0, $ao2h1.RELAY_RESOURCE_TYPE)}_${(0, $5bSAg.RESOURCE_TYPE_ISSUE_NAVIGATOR_RELAY)}`,
    getKey: ()=>'issue-navigator-relay',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        const { projectKey: projectKey, issueKey: issueKey, jql: jqlParam, defaultJql: defaultJql, filter: filter } = (0, $aBKbA.getParams)(routerContext);
        const jqlOrFilterId = (0, $aBKbA.getJqlOrFilterId)(defaultJql, jqlParam, filter, projectKey);
        const maxIssuesPerPage = (0, $6UAdF.getMaxIssuesPerPage)();
        const chromelessRoute = (0, $aBKbA.isChromelessRoute)(routerContext) && (0, $4R6GH.fg)('jira_nin_smart_link');
        let viewId;
        const filterId = Boolean(filter) && (0, $9Nvh7.isCustomFilter)(filter) ? filter : null;
        if (chromelessRoute && (0, $4R6GH.fg)('jira_nin_smart_link')) // Explicitly load list view for chromeless (i.e. embed) routes
        viewId = filterId ? (0, $eJ0Zs.convertFilterIdToIssueNavigatorId)(filterId) : 'list_default';
        const viewConfigInput = projectKey !== undefined && projectKey !== null ? {
            viewInput: {
                namespace: (0, $6UAdF.ISSUE_SEARCH_NAMESPACE)
            }
        } : {
            staticViewInput: {
                isHierarchyEnabled: false,
                isGroupingEnabled: false,
                isHideDoneEnabled: false
            }
        };
        const staticViewInput = projectKey === undefined || projectKey === null ? {
            isHierarchyEnabled: false,
            isGroupingEnabled: false,
            isHideDoneEnabled: false
        } : undefined;
        let viewQueryInput;
        if ((0, $4R6GH.fg)('saved_list_view_technical_changes')) viewQueryInput = projectKey == null ? {
            viewAri: (0, $5cSAN.createViewAri)({
                activationId: tenantContext.activationId,
                cloudId: tenantContext.cloudId
            })
        } : {
            projectKeyAndItemIdQuery: {
                cloudId: tenantContext.cloudId,
                projectKey: projectKey,
                itemId: routerContext.match.params.itemId ?? ''
            }
        };
        let operationScope;
        if (projectKey !== undefined && projectKey !== null) operationScope = (0, $4R6GH.fg)('refactor_nin_to_jira_view_schema') ? (0, $6UAdF.NIN_PROJECT_SCHEMA_REFACTOR_OPERATION_SCOPE) : (0, $6UAdF.NIN_PROJECT_OPERATION_SCOPE);
        else operationScope = (0, $4R6GH.fg)('refactor_nin_to_jira_view_schema') ? (0, $6UAdF.NIN_GLOBAL_SCHEMA_REFACTOR_OPERATION_SCOPE) : (0, $6UAdF.NIN_GLOBAL_OPERATION_SCOPE);
        const variables = {
            cloudId: tenantContext.cloudId,
            first: issueKey == null ? maxIssuesPerPage : null,
            issueSearchInput: jqlOrFilterId,
            namespace: (0, $6UAdF.ISSUE_SEARCH_NAMESPACE),
            fieldSetsInput: {
                viewInput: {
                    namespace: (0, $6UAdF.ISSUE_SEARCH_NAMESPACE),
                    filterId: filterId,
                    viewId: viewId
                }
            },
            after: null,
            options: {
                issueKey: issueKey
            },
            fieldSetIds: [],
            shouldQueryFieldSetsById: false,
            filterId: filterId,
            amountOfColumns: (0, $6UAdF.MAX_AMOUNT_OF_COLUMNS),
            shouldQueryHasChildren: projectKey !== null && projectKey !== undefined && (0, $6s1PB.expVal)('jsc_m2_hierarchy', 'isHierarchyEnabled', false),
            ...(0, $4R6GH.fg)('jsc_nin_operation_scope_fe') && {
                scope: {
                    operationScope: operationScope
                }
            },
            ...(0, $6s1PB.expVal)('jsc_m2_hierarchy', 'isHierarchyEnabled', false) && {
                viewConfigInput: viewConfigInput
            },
            ...(0, $4R6GH.fg)('refactor_nin_to_jira_view_schema') && {
                staticViewInput: staticViewInput
            },
            ...(0, $4R6GH.fg)('saved_list_view_technical_changes') && {
                viewQueryInput: viewQueryInput
            },
            atlassianIntelligenceProductFeature: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $6UAdF.NATURAL_LANGUAGE_TO_JQL),
            projectKey: projectKey ?? '',
            shouldQueryProject: Boolean(projectKey) && ((0, $6s1PB.expVal)('jira_list_realtime_updates_with_queue', 'isEnabled', false) || (0, $6s1PB.expVal)('jsc_m2_hierarchy', 'isHierarchyEnabled', false) || (0, $4R6GH.fg)('saved_list_view_technical_changes')),
            groupBy: null,
            ...(0, $4R6GH.fg)('jira_inline_field_config_gate') && {
                fieldSetsScope: {
                    operationScope: operationScope,
                    projectKey: projectKey
                }
            },
            viewId: viewId
        };
        const queryReference = (0, $8Uumt.loadQuery)((0, $5yJb9.default)(), (0, $hTvlq.default), variables, {
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        });
        if (false && queryReference.id != null) await (0, $kipqU.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});
const $93f22f98fd07bff0$export$44ca3a0b25f38d83 = (0, $2M1hQ.createResource)({
    type: `${(0, $ao2h1.RELAY_RESOURCE_TYPE)}_${(0, $5bSAg.RESOURCE_TYPE_ISSUE_NAVIGATOR_FILTER_RELAY)}`,
    getKey: ()=>'issue-navigator-filter-relay',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        const { filter: filter } = (0, $aBKbA.getParams)(routerContext);
        const includeFilter = Boolean(filter) && (0, $9Nvh7.isFilterId)(filter);
        const variables = {
            includeFilter: includeFilter,
            filterAri: includeFilter ? (0, $dXq4S.createAri)({
                resourceOwner: 'jira',
                cloudId: tenantContext.cloudId,
                resourceType: 'filter',
                resourceId: filter,
                activationId: tenantContext.activationId
            }) : ''
        };
        const options = {
            fetchPolicy: includeFilter ? 'network-only' : 'store-only'
        };
        const queryReference = (0, $8Uumt.loadQuery)((0, $5yJb9.default)(), (0, $kvekU.default), variables, options);
        if (false && queryReference.id != null) await (0, $kipqU.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});
const $93f22f98fd07bff0$export$967ef0cfbd1cc946 = (0, $2M1hQ.createResource)({
    type: `${(0, $ao2h1.RELAY_RESOURCE_TYPE)}_${(0, $5bSAg.RESOURCE_TYPE_ISSUE_NAVIGATOR_HYDRATION_RELAY)}`,
    getKey: ()=>'issue-navigator-hydration-relay',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        const { projectKey: projectKey, jql: jqlParam, defaultJql: defaultJql, filter: filter } = (0, $aBKbA.getParams)(routerContext);
        const jqlOrFilterId = (0, $aBKbA.getJqlOrFilterId)(defaultJql, jqlParam, filter, projectKey);
        // eslint-disable-next-line jira/ff/inline-usage
        const variables = {
            accountId: tenantContext.atlassianAccountId ?? '',
            cloudId: tenantContext.cloudId,
            includeUser: true,
            includeJira: true,
            isFilter: 'filterId' in jqlOrFilterId,
            jql: 'jql' in jqlOrFilterId && jqlOrFilterId.jql || '',
            filterAri: 'filterId' in jqlOrFilterId && (0, $6oLWS.JiraFilterAri).create({
                siteId: tenantContext.cloudId,
                filterId: filter,
                activationId: tenantContext.activationId
            }).toString() || '',
            viewContext: null,
            isPlanReleaseFeatureToggleEnabled: (0, $4R6GH.fg)('simple-plans-m2-release-feature-toggle')
        };
        const queryReference = (0, $8Uumt.loadQuery)((0, $5yJb9.default)(), (0, $16Yit.default), variables, {
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        });
        if (false && queryReference.id != null) await (0, $kipqU.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0,
    isBrowserOnly: true
});

});
parcelRegister("9Nvh7", function(module, exports) {

$parcel$export(module.exports, "isCustomFilter", () => $08e78f523b28c02b$export$31180e7f1db565e5);
$parcel$export(module.exports, "isFilterId", () => $08e78f523b28c02b$export$23be85030bd58047);
const $08e78f523b28c02b$export$31180e7f1db565e5 = (filterId)=>/^\d+$/.test(filterId);
const $08e78f523b28c02b$export$887fa95a5a5cf197 = (filterId)=>/^-\d+$/.test(filterId);
const $08e78f523b28c02b$export$23be85030bd58047 = (value)=>value !== undefined && /^-?\d+$/.test(value);

});

parcelRegister("6UAdF", function(module, exports) {

$parcel$export(module.exports, "sortDirections", () => $8e65b6d66c73d810$export$73034536b9adc928);
$parcel$export(module.exports, "FilterTypes", () => $8e65b6d66c73d810$export$ad2e3f13451a5d44);
$parcel$export(module.exports, "SearchInputTypes", () => $8e65b6d66c73d810$export$75a31bc7c097ba4b);
$parcel$export(module.exports, "views", () => $8e65b6d66c73d810$export$d0079916fe6800ac);
$parcel$export(module.exports, "defaultOrderFields", () => $8e65b6d66c73d810$export$2bd49f8f262d7cbb);
$parcel$export(module.exports, "ISSUE_SEARCH_NAMESPACE", () => $8e65b6d66c73d810$export$de2495608df10495);
$parcel$export(module.exports, "DEFAULT_ORDER_FIELD", () => $8e65b6d66c73d810$export$393cb330f31d305c);
$parcel$export(module.exports, "DEFAULT_SORT_DIRECTION", () => $8e65b6d66c73d810$export$8ea18fa9e35fdf25);
$parcel$export(module.exports, "DEFAULT_VIEW_ID", () => $8e65b6d66c73d810$export$500b5c379b5c7f2e);
$parcel$export(module.exports, "MAX_ISSUES_PER_PAGE", () => $8e65b6d66c73d810$export$f88f58d1a4b2078b);
$parcel$export(module.exports, "getMaxIssuesPerPage", () => $8e65b6d66c73d810$export$8c67ad1f64ab5a9c);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $8e65b6d66c73d810$export$f7109619a5e9e0d6);
$parcel$export(module.exports, "PACKAGE_NAME", () => $8e65b6d66c73d810$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $8e65b6d66c73d810$export$d57b6b390e78d90f);
$parcel$export(module.exports, "EXPERIENCE_NAME", () => $8e65b6d66c73d810$export$52919046b94109dc);
$parcel$export(module.exports, "GROUPED_LIST_EXPERIENCE_ID", () => $8e65b6d66c73d810$export$88890124f795113d);
$parcel$export(module.exports, "ANALYTICS_LIST_VIEW_SOURCE_NAME", () => $8e65b6d66c73d810$export$81d9767bc5c1549e);
$parcel$export(module.exports, "ANALYTICS_DETAIL_VIEW_SOURCE_NAME", () => $8e65b6d66c73d810$export$524ae4278a57eea2);
$parcel$export(module.exports, "MAX_AMOUNT_OF_COLUMNS", () => $8e65b6d66c73d810$export$608eeb3a32afef02);
$parcel$export(module.exports, "COLUMN_TYPE_EPIC_LINK", () => $8e65b6d66c73d810$export$ce9e2d7c178a9557);
$parcel$export(module.exports, "COLUMN_TYPE_PARENT_LINK", () => $8e65b6d66c73d810$export$1adf7afff96bbf16);
$parcel$export(module.exports, "NATURAL_LANGUAGE_TO_JQL", () => $8e65b6d66c73d810$export$55628b4c44d1522a);
$parcel$export(module.exports, "NIN_PROJECT_OPERATION_SCOPE", () => $8e65b6d66c73d810$export$fae6afe554014a45);
$parcel$export(module.exports, "NIN_GLOBAL_OPERATION_SCOPE", () => $8e65b6d66c73d810$export$39ec48f092f3ea90);
$parcel$export(module.exports, "NIN_PROJECT_SCHEMA_REFACTOR_OPERATION_SCOPE", () => $8e65b6d66c73d810$export$c61855af3c5e591e);
$parcel$export(module.exports, "NIN_GLOBAL_SCHEMA_REFACTOR_OPERATION_SCOPE", () => $8e65b6d66c73d810$export$11e11b807529f9a8);
$parcel$export(module.exports, "NIN_PROJECT_SHADOW_REQUEST_OPERATION_SCOPE", () => $8e65b6d66c73d810$export$2c213b805a8379cf);
$parcel$export(module.exports, "NIN_SIDEBAR_SCOPE", () => $8e65b6d66c73d810$export$adc96a79a4445d56);
$parcel$export(module.exports, "ISSUE_NAVIGATOR_SIDEBAR_ID", () => $8e65b6d66c73d810$export$6c35abbca3056365);
$parcel$export(module.exports, "ALL_COLUMNS_ID", () => $8e65b6d66c73d810$export$eb85a4c9b5d9ce7b);
$parcel$export(module.exports, "supportedOrderFields", () => $8e65b6d66c73d810$export$3630aa1c4c69277f);
$parcel$export(module.exports, "getSupportedFieldForAlias", () => $8e65b6d66c73d810$export$eaadab3243bf458);
$parcel$export(module.exports, "isJiraIssueSearchViewMetadata", () => $8e65b6d66c73d810$export$f40fffea1f8469ac);
$parcel$export(module.exports, "isJiraSpreadsheetView", () => $8e65b6d66c73d810$export$2627fa464eafde69);

var $czfFt = parcelRequire("czfFt");
const $8e65b6d66c73d810$export$73034536b9adc928 = {
    ASC: 'ASC',
    DESC: 'DESC',
    NONE: 'NONE'
};
const $8e65b6d66c73d810$export$ad2e3f13451a5d44 = {
    ID: 'filterId',
    JQL: 'filterJql'
};
const $8e65b6d66c73d810$export$75a31bc7c097ba4b = {
    JQL: 'jql',
    FILTER: 'filter',
    FILTER_AND_JQL: 'filterAndJql'
};
const $8e65b6d66c73d810$export$d0079916fe6800ac = {
    list: 'list-view',
    detail: 'split-view'
};
const $8e65b6d66c73d810$export$2bd49f8f262d7cbb = {
    created: 'created',
    lastviewed: 'lastviewed',
    updated: 'updated'
};
const $8e65b6d66c73d810$export$de2495608df10495 = 'ISSUE_NAVIGATOR';
const $8e65b6d66c73d810$export$393cb330f31d305c = $8e65b6d66c73d810$export$2bd49f8f262d7cbb.created;
const $8e65b6d66c73d810$export$8ea18fa9e35fdf25 = $8e65b6d66c73d810$export$73034536b9adc928.DESC;
const $8e65b6d66c73d810$export$500b5c379b5c7f2e = 'list_default';
const $8e65b6d66c73d810$export$f88f58d1a4b2078b = 50;
const $8e65b6d66c73d810$export$8c67ad1f64ab5a9c = ()=>$8e65b6d66c73d810$export$f88f58d1a4b2078b;
const $8e65b6d66c73d810$export$f7109619a5e9e0d6 = 'issue-navigator-next';
const $8e65b6d66c73d810$export$b8b9d90f9e5bd72b = 'jiraIssueNavigator';
const $8e65b6d66c73d810$export$d57b6b390e78d90f = 'empanada';
const $8e65b6d66c73d810$export$52919046b94109dc = 'showPinIssueList';
const $8e65b6d66c73d810$export$88890124f795113d = 'groupedList';
const $8e65b6d66c73d810$export$81d9767bc5c1549e = 'issueNavigatorListView';
const $8e65b6d66c73d810$export$524ae4278a57eea2 = 'issueNavigatorDetailView';
const $8e65b6d66c73d810$export$af225181779390f4 = 'list_default';
const $8e65b6d66c73d810$export$608eeb3a32afef02 = (0, $czfFt.MAX_COLUMNS);
const $8e65b6d66c73d810$export$ce9e2d7c178a9557 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $8e65b6d66c73d810$export$1adf7afff96bbf16 = 'com.atlassian.jpo:jpo-custom-field-parent';
const $8e65b6d66c73d810$export$55628b4c44d1522a = 'NATURAL_LANGUAGE_TO_JQL';
const $8e65b6d66c73d810$export$fae6afe554014a45 = 'NIN_PROJECT';
const $8e65b6d66c73d810$export$39ec48f092f3ea90 = 'NIN_GLOBAL';
const $8e65b6d66c73d810$export$c61855af3c5e591e = 'NIN_PROJECT_SCHEMA_REFACTOR';
const $8e65b6d66c73d810$export$11e11b807529f9a8 = 'NIN_GLOBAL_SCHEMA_REFACTOR';
const $8e65b6d66c73d810$export$2c213b805a8379cf = 'NIN_PROJECT_SHADOW_REQUEST';
const $8e65b6d66c73d810$export$adc96a79a4445d56 = 'NIN_SIDEBAR';
const $8e65b6d66c73d810$export$6c35abbca3056365 = 'IssueNavigator';
const $8e65b6d66c73d810$export$eb85a4c9b5d9ce7b = 'all-columns';
const $8e65b6d66c73d810$export$3630aa1c4c69277f = {
    created: {
        jqlTerm: 'created',
        fieldType: 'created',
        aliases: []
    },
    key: {
        jqlTerm: 'key',
        fieldType: 'issuekey',
        aliases: [
            'issuekey'
        ]
    },
    lastviewed: {
        jqlTerm: 'lastviewed',
        fieldType: 'lastviewed',
        aliases: []
    },
    priority: {
        jqlTerm: 'priority',
        fieldType: 'priority',
        aliases: []
    },
    resolved: {
        jqlTerm: 'resolved',
        fieldType: 'resolutiondate',
        aliases: []
    },
    status: {
        jqlTerm: 'status',
        fieldType: 'status',
        aliases: []
    },
    updated: {
        jqlTerm: 'updated',
        fieldType: 'updated',
        aliases: []
    },
    issuetype: {
        jqlTerm: 'issuetype',
        fieldType: 'issuetype',
        aliases: [
            'type'
        ]
    },
    assignee: {
        jqlTerm: 'assignee',
        fieldType: 'assignee',
        aliases: []
    },
    duedate: {
        jqlTerm: 'duedate',
        fieldType: 'duedate',
        aliases: []
    },
    reporter: {
        jqlTerm: 'reporter',
        fieldType: 'reporter',
        aliases: []
    },
    summary: {
        jqlTerm: 'summary',
        fieldType: 'summary',
        aliases: []
    }
};
const $8e65b6d66c73d810$export$eaadab3243bf458 = (alias)=>Object.keys($8e65b6d66c73d810$export$3630aa1c4c69277f).find((key)=>$8e65b6d66c73d810$export$3630aa1c4c69277f[key]?.aliases.includes(alias));
const $8e65b6d66c73d810$export$f40fffea1f8469ac = (data)=>[
        'JiraIssueSearchView',
        'JiraDetailedView',
        'JiraListView',
        'JiraGroupedListView'
    ].includes(data.__typename);
const $8e65b6d66c73d810$export$2627fa464eafde69 = (data)=>[
        'JiraListView',
        'JiraGroupedListView'
    ].includes(data.__typename);

});

parcelRegister("eJ0Zs", function(module, exports) {

$parcel$export(module.exports, "createRememoizeSelector", () => $945e9d040796364e$export$982d75deeca693ef);
$parcel$export(module.exports, "isNormalClick", () => $945e9d040796364e$export$729f3684d5c2b9b9);
$parcel$export(module.exports, "isNonNullish", () => $945e9d040796364e$export$70573498ee17fe1d);
$parcel$export(module.exports, "parseIssueNavigatorViewIdOrDefault", () => $945e9d040796364e$export$ad0c80ba9128e83a);
$parcel$export(module.exports, "isFilterViewId", () => $945e9d040796364e$export$194f1a1e890054c9);
$parcel$export(module.exports, "convertToIssueNavigatorId", () => $945e9d040796364e$export$6ce707b3eccb341d);
$parcel$export(module.exports, "convertToView", () => $945e9d040796364e$export$95ef66082092aa68);
$parcel$export(module.exports, "convertFilterIdToIssueNavigatorId", () => $945e9d040796364e$export$ec4f6e9ea23bb55d);
$parcel$export(module.exports, "exclusiveGroupResultsOrIssueResultsFragment", () => $945e9d040796364e$export$1dde85fc919cd8db);

var $dGvGJ = parcelRequire("dGvGJ");

var $6UAdF = parcelRequire("6UAdF");
const $945e9d040796364e$export$982d75deeca693ef = (0, $dGvGJ.createSelectorCreator)((0, $dGvGJ.defaultMemoize), // @ts-expect-error - TS2339 - Property '_rememoize' does not exist on type 'T'. | TS2339 - Property '_rememoize' does not exist on type 'T'.
(a, b)=>a._rememoize === b._rememoize);
const $945e9d040796364e$export$729f3684d5c2b9b9 = (e)=>!(e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
function $945e9d040796364e$var$isPossibleValueEntry(entry) {
    return typeof entry[1] === 'string' || typeof entry[1] === 'number' || Array.isArray(entry[1]) && entry[1].length > 0;
}
const $945e9d040796364e$export$20fba0bc14771b28 = (state)=>{
    const definedEntries = Object.entries(state).filter($945e9d040796364e$var$isPossibleValueEntry);
    return definedEntries.map((entry)=>({
            key: entry[0],
            value: Array.isArray(entry[1]) ? entry[1].map((values)=>values.value) : entry[1]
        }));
};
const $945e9d040796364e$export$6256478a5735e738 = (state)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(state).reduce((acc, key)=>{
        const value = state[key];
        if (key === 'search') {
            if (typeof value !== 'string') throw new Error('Unexpected non-string literal for search.');
            acc[key] = value;
        } else if (Array.isArray(value)) acc[key] = value.map((values)=>values.value);
        else if (typeof value === 'string' || typeof value === 'undefined') acc[key] = value || [];
        else acc[key] = value;
        return acc;
    }, {});
const $945e9d040796364e$export$28dade55d1b3964b = (viewId)=>viewId === 'detail' ? (0, $6UAdF.views).detail : (0, $6UAdF.views).list;
const $945e9d040796364e$export$587f73d78d2a7579 = (viewMode)=>viewMode === (0, $6UAdF.views).detail ? 'detail' : 'list_default';
const $945e9d040796364e$export$5786a571e562003d = (viewMode)=>viewMode === (0, $6UAdF.views).detail ? 'DETAIL' : 'LIST';
function $945e9d040796364e$export$70573498ee17fe1d(value) {
    return value != null;
}
const $945e9d040796364e$export$ad0c80ba9128e83a = (viewId, defaultValue = 'list_default')=>{
    if (!viewId) return defaultValue;
    switch(viewId){
        case 'list_default':
            return 'list_default';
        case 'list_system':
            return 'list_system';
        case 'detail':
            return 'detail';
        default:
            if ($945e9d040796364e$export$194f1a1e890054c9(viewId)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return viewId;
            return defaultValue;
    }
};
const $945e9d040796364e$export$194f1a1e890054c9 = (viewId)=>/^list_filter_\d+$/.test(viewId);
const $945e9d040796364e$export$6ce707b3eccb341d = (view)=>view === (0, $6UAdF.views).detail ? 'detail' : 'list_default';
const $945e9d040796364e$export$95ef66082092aa68 = (issueNavigatorViewId)=>issueNavigatorViewId === 'detail' ? (0, $6UAdF.views).detail : (0, $6UAdF.views).list;
const $945e9d040796364e$export$ec4f6e9ea23bb55d = (filterId)=>{
    if (typeof filterId === 'number') return `list_filter_${filterId}`;
    const filterIdInt = Number(filterId);
    if (Number.isNaN(filterIdInt)) throw new Error('filterId is invalid');
    return `list_filter_${filterIdInt}`;
};
function $945e9d040796364e$export$1dde85fc919cd8db({ groupResults: groupResults, issueResults: issueResults }) {
    if (issueResults) return {
        groupResults: null,
        issueResults: issueResults
    };
    if (groupResults) return {
        groupResults: groupResults,
        issueResults: null
    };
    return null;
}

});

parcelRegister("kvekU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d76682723f87707c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1c0dc4a342f4ce5786fbe069292419e8>>
 * @relayHash 4722fbdc72716192181bb0830d738d17
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b9373e4d70177ba3d0d672c65e67a2165b4a0d774802f56dbef66239dd52c8e5
const $d76682723f87707c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeFilter"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "main_FilterQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_filterQuery"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "main_FilterQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "includeFilter",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "filterAri"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isJiraFilter"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEditable"
                                                }
                                            ],
                                            "type": "JiraCustomFilter"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "filterId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isFavourite"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b9373e4d70177ba3d0d672c65e67a2165b4a0d774802f56dbef66239dd52c8e5",
            "metadata": {},
            "name": "main_FilterQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d76682723f87707c$var$node.hash = "181bb07a6bafd05a2033750384a06766";
var $d76682723f87707c$export$2e2bcd8739ae039 = $d76682723f87707c$var$node;

});

parcelRegister("hTvlq", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff9dfb30fc1873c4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dd4804d90c66dc273e7773242a9f1678>>
 * @relayHash a3f2d72ebd50b43cf2241f114e41873c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 38eff953d5dc19b03e72c037d9f32dea3993ff719f8d7d1d780dac76ea6d62a5

var $bqIzm = parcelRequire("bqIzm");

var $fjldt = parcelRequire("fjldt");

var $gY76A = parcelRequire("gY76A");

var $5oQtH = parcelRequire("5oQtH");

var $1q6lK = parcelRequire("1q6lK");

var $5ykrX = parcelRequire("5ykrX");

var $1xxk0 = parcelRequire("1xxk0");

var $c5npJ = parcelRequire("c5npJ");

var $ggSVP = parcelRequire("ggSVP");

var $5Bxi4 = parcelRequire("5Bxi4");

var $k3PJZ = parcelRequire("k3PJZ");

var $knfEI = parcelRequire("knfEI");

var $5qm7M = parcelRequire("5qm7M");

var $l8ssf = parcelRequire("l8ssf");

var $5wdbf = parcelRequire("5wdbf");

var $dttgK = parcelRequire("dttgK");

var $adKYy = parcelRequire("adKYy");

var $iLxt4 = parcelRequire("iLxt4");

var $hBvdF = parcelRequire("hBvdF");
const $ff9dfb30fc1873c4$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "atlassianIntelligenceProductFeature"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsContext"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsScope"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "groupBy"
    }, v12 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isPaginating"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v17 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v18 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v19 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldSetsById"
    }, v20 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "shouldQueryHasChildren"
    }, v21 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryProject"
    }, v22 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "staticViewInput"
    }, v23 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewConfigInput"
    }, v24 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v25 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewQueryInput"
    }, v26 = {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
    }, v27 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v28 = [
        v27 /*: any*/ 
    ], v29 = [
        v27 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v30 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v31 = {
        "kind": "ClientExtension",
        "selections": [
            v30 /*: any*/ 
        ]
    }, v32 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "feature",
                    "variableName": "atlassianIntelligenceProductFeature"
                }
            ],
            "kind": "ObjectValue",
            "name": "atlassianIntelligenceProductFeatureInput"
        },
        v27 /*: any*/ 
    ], v33 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v34 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v35 = {
        "kind": "Variable",
        "name": "before",
        "variableName": "before"
    }, v36 = {
        "kind": "Variable",
        "name": "fieldSetsInput",
        "variableName": "fieldSetsInput"
    }, v37 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v38 = {
        "kind": "Variable",
        "name": "issueSearchInput",
        "variableName": "issueSearchInput"
    }, v39 = {
        "kind": "Variable",
        "name": "last",
        "variableName": "last"
    }, v40 = {
        "kind": "Variable",
        "name": "options",
        "variableName": "options"
    }, v41 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v42 = {
        "kind": "Variable",
        "name": "viewConfigInput",
        "variableName": "viewConfigInput"
    }, v43 = [
        v34 /*: any*/ ,
        v35 /*: any*/ ,
        v27 /*: any*/ ,
        v36 /*: any*/ ,
        v37 /*: any*/ ,
        v38 /*: any*/ ,
        v39 /*: any*/ ,
        v40 /*: any*/ ,
        v41 /*: any*/ ,
        v42 /*: any*/ 
    ], v44 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v45 = {
        "kind": "ScalarField",
        "name": "id"
    }, v46 = {
        "kind": "ScalarField",
        "name": "key"
    }, v47 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v48 = {
        "kind": "ScalarField",
        "name": "isResolved"
    }, v49 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v50 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v51 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v50 /*: any*/ ,
            v45 /*: any*/ 
        ]
    }, v52 = {
        "kind": "InlineFragment",
        "selections": [
            v49 /*: any*/ ,
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v51 /*: any*/ ,
                    v45 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v53 = {
        "args": [
            {
                "kind": "Literal",
                "name": "ids",
                "value": [
                    "status"
                ]
            }
        ],
        "concreteType": "JiraIssueFieldConnection",
        "kind": "LinkedField",
        "name": "fieldsById",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v33 /*: any*/ ,
                            v52 /*: any*/ ,
                            v45 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "storageKey": "fieldsById(ids:[\"status\"])"
    }, v54 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v55 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v54 /*: any*/ ,
                    v45 /*: any*/ 
                ]
            },
            v45 /*: any*/ 
        ]
    }, v56 = {
        "kind": "ScalarField",
        "name": "name"
    }, v57 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraIssueTypeField",
                "kind": "LinkedField",
                "name": "issueTypeField",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueType",
                        "kind": "LinkedField",
                        "name": "issueType",
                        "plural": false,
                        "selections": [
                            v56 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v58 = {
        "kind": "ClientExtension",
        "selections": [
            v30 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "isHighlightedIssueRow"
            }
        ]
    }, v59 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "amountOfColumns"
    }, v60 = {
        "kind": "ScalarField",
        "name": "type"
    }, v61 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v62 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isJiraIssueField"
    }, v63 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraAffectedServiceConnection",
                "kind": "LinkedField",
                "name": "selectedAffectedServicesConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAffectedServiceEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraAffectedService",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "serviceId"
                                    },
                                    v56 /*: any*/ ,
                                    v45 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraAffectedServicesField"
    }, v64 = {
        "kind": "ScalarField",
        "name": "value"
    }, v65 = [
        v64 /*: any*/ ,
        v45 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v66 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v67 = {
        "kind": "ClientExtension",
        "selections": [
            v66 /*: any*/ 
        ]
    }, v68 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v69 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v70 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v71 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v72 = {
        "kind": "ScalarField",
        "name": "text"
    }, v73 = {
        "kind": "InlineFragment",
        "selections": [
            v72 /*: any*/ ,
            v56 /*: any*/ ,
            v67 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v74 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v75 = [
        v74 /*: any*/ 
    ], v76 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v45 /*: any*/ 
        ]
    }, v77 = [
        v76 /*: any*/ 
    ], v78 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v79 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v45 /*: any*/ ,
            v64 /*: any*/ 
        ]
    }, v80 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v81 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v82 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v83 = [
        v45 /*: any*/ 
    ], v84 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v56 /*: any*/ ,
                    {
                        "concreteType": "JiraCascadingOption",
                        "kind": "LinkedField",
                        "name": "cascadingOption",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "parentOptionValue",
                                "plural": false,
                                "selections": v65 /*: any*/ 
                            },
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "childOptionValue",
                                "plural": false,
                                "selections": v65 /*: any*/ 
                            }
                        ]
                    },
                    v67 /*: any*/ 
                ],
                "type": "JiraCascadingSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v56 /*: any*/ ,
                    {
                        "args": v68 /*: any*/ ,
                        "concreteType": "JiraComponentConnection",
                        "kind": "LinkedField",
                        "name": "selectedComponentsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraComponentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraComponent",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v69 /*: any*/ ,
                                            v70 /*: any*/ ,
                                            v45 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ],
                        "storageKey": "selectedComponentsConnection(first:1000)"
                    },
                    v67 /*: any*/ 
                ],
                "type": "JiraComponentsField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v71 /*: any*/ ,
                    v56 /*: any*/ ,
                    v67 /*: any*/ 
                ],
                "type": "JiraDateTimePickerField"
            },
            v73 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraCommentSummary",
                        "kind": "LinkedField",
                        "name": "commentSummary",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "canAddComment"
                            },
                            v74 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraCommentSummaryField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v56 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "uri"
                    },
                    v67 /*: any*/ 
                ],
                "type": "JiraUrlField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v56 /*: any*/ ,
                    {
                        "concreteType": "JiraOptionConnection",
                        "kind": "LinkedField",
                        "name": "fieldOptions",
                        "plural": false,
                        "selections": v75 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "fieldOption",
                        "plural": false,
                        "selections": [
                            v64 /*: any*/ ,
                            {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": v77 /*: any*/ 
                            },
                            {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": v77 /*: any*/ 
                            },
                            v45 /*: any*/ ,
                            v78 /*: any*/ 
                        ]
                    },
                    v67 /*: any*/ 
                ],
                "type": "JiraSingleSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v56 /*: any*/ ,
                    {
                        "concreteType": "JiraOptionConnection",
                        "kind": "LinkedField",
                        "name": "selectedOptions",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraOptionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraOption",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v45 /*: any*/ ,
                                            v64 /*: any*/ ,
                                            v78 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v67 /*: any*/ 
                ],
                "type": "JiraMultipleSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v56 /*: any*/ ,
                    {
                        "concreteType": "JiraOptionConnection",
                        "kind": "LinkedField",
                        "name": "selectedOptions",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraOptionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    v79 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    v67 /*: any*/ 
                ],
                "type": "JiraCheckboxesField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v56 /*: any*/ ,
                    {
                        "concreteType": "JiraUserConnection",
                        "kind": "LinkedField",
                        "name": "selectedUsersConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraUserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v33 /*: any*/ ,
                                            v80 /*: any*/ ,
                                            v56 /*: any*/ ,
                                            v81 /*: any*/ ,
                                            v45 /*: any*/ ,
                                            v82 /*: any*/ ,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "email"
                                                    }
                                                ],
                                                "type": "AtlassianAccountUser"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v67 /*: any*/ 
                ],
                "type": "JiraMultipleSelectUserPickerField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v56 /*: any*/ ,
                    {
                        "concreteType": "JiraTeamView",
                        "kind": "LinkedField",
                        "name": "selectedTeam",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "jiraSuppliedId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "jiraSuppliedName"
                            }
                        ]
                    },
                    v67 /*: any*/ 
                ],
                "type": "JiraTeamViewField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "issue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraTimeTrackingField",
                                "kind": "LinkedField",
                                "name": "timeTrackingField",
                                "plural": false,
                                "selections": [
                                    v45 /*: any*/ ,
                                    {
                                        "concreteType": "JiraEstimate",
                                        "kind": "LinkedField",
                                        "name": "originalEstimate",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "timeInSeconds"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraTimeTrackingSettings",
                                        "kind": "LinkedField",
                                        "name": "timeTrackingSettings",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "workingHoursPerDay"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "workingDaysPerWeek"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "defaultFormat"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "defaultUnit"
                                            }
                                        ]
                                    },
                                    v49 /*: any*/ ,
                                    v56 /*: any*/ ,
                                    v60 /*: any*/ ,
                                    v67 /*: any*/ 
                                ]
                            },
                            v45 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraOriginalTimeEstimateField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v56 /*: any*/ ,
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "selectedOption",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "label",
                                "kind": "ScalarField",
                                "name": "value"
                            },
                            v45 /*: any*/ ,
                            v69 /*: any*/ 
                        ]
                    },
                    v67 /*: any*/ 
                ],
                "type": "JiraRadioSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v56 /*: any*/ ,
                    {
                        "args": v68 /*: any*/ ,
                        "concreteType": "JiraVersionConnection",
                        "kind": "LinkedField",
                        "name": "selectedVersionsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraVersionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v45 /*: any*/ ,
                                            v56 /*: any*/ ,
                                            v69 /*: any*/ ,
                                            v70 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "versionId"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "storageKey": "selectedVersionsConnection(first:1000)"
                    },
                    v67 /*: any*/ 
                ],
                "type": "JiraMultipleVersionPickerField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v56 /*: any*/ ,
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "issue",
                        "plural": false,
                        "selections": v83 /*: any*/ 
                    },
                    {
                        "args": v68 /*: any*/ ,
                        "concreteType": "JiraGoalConnection",
                        "kind": "LinkedField",
                        "name": "selectedGoals",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraGoalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraGoal",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v45 /*: any*/ ,
                                            v46 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            v31 /*: any*/ 
                        ],
                        "storageKey": "selectedGoals(first:1000)"
                    },
                    {
                        "kind": "ClientExtension",
                        "selections": [
                            v30 /*: any*/ ,
                            v66 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraGoalsField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v56 /*: any*/ ,
                    {
                        "args": v68 /*: any*/ ,
                        "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                        "kind": "LinkedField",
                        "name": "confluenceRemoteIssueLinks",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraConfluenceRemoteIssueLink",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v45 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "href"
                                            }
                                        ]
                                    }
                                ]
                            },
                            v74 /*: any*/ 
                        ],
                        "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                    },
                    v67 /*: any*/ 
                ],
                "type": "JiraConfluenceRemoteIssueLinksField"
            }
        ]
    }, v85 = {
        "kind": "ScalarField",
        "name": "message"
    }, v86 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCmdbObjectConnection",
                "kind": "LinkedField",
                "name": "selectedCmdbObjectsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraCmdbObjectEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraCmdbObject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "objectId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "label"
                                    },
                                    {
                                        "concreteType": "JiraCmdbAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraCmdbMediaClientConfig",
                                                "kind": "LinkedField",
                                                "name": "mediaClientConfig",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "clientId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "fileId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaBaseUrl"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaJwtToken"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "url48"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": [
                            v85 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "JiraCMDBField"
    }, v87 = [
        v56 /*: any*/ ,
        v45 /*: any*/ 
    ], v88 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "componentsOld",
                        "concreteType": "JiraComponentConnection",
                        "kind": "LinkedField",
                        "name": "selectedComponentsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraComponentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraComponent",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": v87 /*: any*/ 
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "JiraComponentsField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v72 /*: any*/ 
                ],
                "type": "JiraSingleLineTextField"
            }
        ]
    }, v89 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v90 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "date"
            },
            v56 /*: any*/ ,
            v89 /*: any*/ ,
            v67 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v91 = {
        "kind": "InlineFragment",
        "selections": [
            v71 /*: any*/ 
        ],
        "type": "JiraDateTimePickerField"
    }, v92 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v93 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraEpic",
                "kind": "LinkedField",
                "name": "epic",
                "plural": false,
                "selections": [
                    v46 /*: any*/ ,
                    v92 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    },
                    v45 /*: any*/ 
                ]
            }
        ],
        "type": "JiraEpicLinkField"
    }, v94 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "renderedFieldHtml"
            }
        ],
        "type": "JiraFallbackField"
    }, v95 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatusCategory",
                "kind": "LinkedField",
                "name": "statusCategory",
                "plural": false,
                "selections": [
                    v56 /*: any*/ ,
                    v50 /*: any*/ ,
                    v45 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusCategoryField"
    }, v96 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v56 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusId"
                    },
                    v51 /*: any*/ ,
                    v45 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v97 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": v68 /*: any*/ ,
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v56 /*: any*/ ,
                                    v76 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    v74 /*: any*/ 
                ],
                "storageKey": "selectedLabelsConnection(first:1000)"
            },
            v56 /*: any*/ ,
            v67 /*: any*/ 
        ],
        "type": "JiraLabelsField"
    }, v98 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v99 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v98 /*: any*/ ,
                    v56 /*: any*/ ,
                    v45 /*: any*/ 
                ]
            }
        ],
        "type": "JiraIssueTypeField"
    }, v100 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v72 /*: any*/ ,
            v45 /*: any*/ 
        ]
    }, v101 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v76 /*: any*/ ,
            v45 /*: any*/ 
        ]
    }, v102 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v103 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v102 /*: any*/ ,
                    v56 /*: any*/ ,
                    v45 /*: any*/ 
                ]
            },
            v45 /*: any*/ 
        ]
    }, v104 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v105 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                    v46 /*: any*/ ,
                    v100 /*: any*/ ,
                    v45 /*: any*/ 
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "parentIssue",
                        "plural": false,
                        "selections": [
                            v46 /*: any*/ ,
                            v101 /*: any*/ ,
                            v103 /*: any*/ ,
                            v100 /*: any*/ ,
                            v45 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "parentIssue",
                        "plural": false,
                        "selections": [
                            v46 /*: any*/ ,
                            v101 /*: any*/ ,
                            v103 /*: any*/ ,
                            v100 /*: any*/ ,
                            v45 /*: any*/ ,
                            v47 /*: any*/ ,
                            v104 /*: any*/ ,
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "ids",
                                        "value": [
                                            "summary",
                                            "issuetype",
                                            "status"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fieldsById",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v33 /*: any*/ ,
                                                    v45 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v49 /*: any*/ ,
                                                            v72 /*: any*/ 
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v49 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "issueTypeId"
                                                                    },
                                                                    v56 /*: any*/ ,
                                                                    v102 /*: any*/ ,
                                                                    v54 /*: any*/ ,
                                                                    v45 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    v52 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                            }
                        ]
                    },
                    v56 /*: any*/ ,
                    v67 /*: any*/ 
                ]
            }
        ],
        "type": "JiraParentIssueField"
    }, v106 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v107 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v56 /*: any*/ ,
                    v106 /*: any*/ ,
                    v45 /*: any*/ 
                ]
            },
            v56 /*: any*/ ,
            v67 /*: any*/ 
        ],
        "type": "JiraPriorityField"
    }, v108 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    v56 /*: any*/ ,
                    v46 /*: any*/ ,
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "large"
                            }
                        ]
                    },
                    v45 /*: any*/ 
                ]
            }
        ],
        "type": "JiraProjectField"
    }, v109 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraResolution",
                "kind": "LinkedField",
                "name": "resolution",
                "plural": false,
                "selections": v87 /*: any*/ 
            }
        ],
        "type": "JiraResolutionField"
    }, v110 = [
        v45 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "sprintId"
        },
        v56 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "state"
        },
        {
            "kind": "ScalarField",
            "name": "endDate"
        }
    ], v111 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraSprintConnection",
                "kind": "LinkedField",
                "name": "selectedSprintsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSprintEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v110 /*: any*/ 
                            }
                        ]
                    }
                ]
            },
            v56 /*: any*/ ,
            v67 /*: any*/ 
        ],
        "type": "JiraSprintField"
    }, v112 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v33 /*: any*/ ,
                    v80 /*: any*/ ,
                    v81 /*: any*/ ,
                    v56 /*: any*/ ,
                    v45 /*: any*/ ,
                    v82 /*: any*/ 
                ]
            },
            v56 /*: any*/ ,
            v89 /*: any*/ ,
            v67 /*: any*/ 
        ],
        "type": "JiraSingleSelectUserPickerField"
    }, v113 = {
        "kind": "InlineFragment",
        "selections": [
            v56 /*: any*/ ,
            {
                "args": v68 /*: any*/ ,
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v87 /*: any*/ 
                            }
                        ]
                    }
                ],
                "storageKey": "selectedVersionsConnection(first:1000)"
            }
        ],
        "type": "JiraMultipleVersionPickerField"
    }, v114 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraRichText",
                "kind": "LinkedField",
                "name": "richText",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraADF",
                        "kind": "LinkedField",
                        "name": "adfValue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraAdfToConvertedPlainText",
                                "kind": "LinkedField",
                                "name": "convertedPlainText",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "plainText"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraRichTextField"
    }, v115 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraServiceManagementRequestType",
                "kind": "LinkedField",
                "name": "requestType",
                "plural": false,
                "selections": [
                    v56 /*: any*/ ,
                    v102 /*: any*/ ,
                    v45 /*: any*/ 
                ]
            }
        ],
        "type": "JiraServiceManagementRequestTypeField"
    }, v116 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1
                    }
                ],
                "concreteType": "JiraIssueLinkConnection",
                "kind": "LinkedField",
                "name": "issueLinkConnection",
                "plural": false,
                "selections": [
                    v74 /*: any*/ ,
                    {
                        "concreteType": "JiraIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "issue",
                                        "plural": false,
                                        "selections": [
                                            v104 /*: any*/ ,
                                            v46 /*: any*/ ,
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "ids",
                                                        "value": [
                                                            "statusCategory"
                                                        ]
                                                    }
                                                ],
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldsById",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v33 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v51 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraStatusCategoryField"
                                                                    },
                                                                    v45 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                            },
                                            v45 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "relationName"
                                    },
                                    v45 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "issueLinkConnection(first:1)"
            }
        ],
        "type": "JiraIssueLinkField"
    }, v117 = {
        "kind": "ScalarField",
        "name": "number"
    }, v118 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraNumberFieldFormatConfig",
                "kind": "LinkedField",
                "name": "formatConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "formatStyle"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "formatUnit"
                    }
                ]
            }
        ]
    }, v119 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isStoryPointField"
            },
            v117 /*: any*/ ,
            v56 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    v117 /*: any*/ ,
                    v118 /*: any*/ 
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v117 /*: any*/ ,
                    v56 /*: any*/ ,
                    v118 /*: any*/ ,
                    v67 /*: any*/ 
                ]
            },
            v67 /*: any*/ 
        ],
        "type": "JiraNumberField"
    }, v120 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v56 /*: any*/ ,
                    {
                        "concreteType": "JiraGroupConnection",
                        "kind": "LinkedField",
                        "name": "selectedGroupsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraGroupEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraGroup",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v45 /*: any*/ ,
                                            v56 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "groupId"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v67 /*: any*/ 
                ],
                "type": "JiraMultipleGroupPickerField"
            }
        ]
    }, v121 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraFlag",
                        "kind": "LinkedField",
                        "name": "flag",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFlagged"
                            }
                        ]
                    }
                ],
                "type": "JiraFlagField"
            }
        ]
    }, v122 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraWatch",
                        "kind": "LinkedField",
                        "name": "watch",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "count"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "isWatching"
                            }
                        ]
                    }
                ],
                "type": "JiraWatchesField"
            }
        ]
    }, v123 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": v75 /*: any*/ 
    }, v124 = [
        {
            "concreteType": "JiraIssueFieldSetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v60 /*: any*/ ,
                        v61 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v33 /*: any*/ ,
                                                v49 /*: any*/ ,
                                                v60 /*: any*/ ,
                                                v62 /*: any*/ ,
                                                v45 /*: any*/ ,
                                                v63 /*: any*/ ,
                                                v84 /*: any*/ ,
                                                v86 /*: any*/ ,
                                                v88 /*: any*/ ,
                                                v90 /*: any*/ ,
                                                v91 /*: any*/ ,
                                                v93 /*: any*/ ,
                                                v94 /*: any*/ ,
                                                v73 /*: any*/ ,
                                                v95 /*: any*/ ,
                                                v96 /*: any*/ ,
                                                v97 /*: any*/ ,
                                                v99 /*: any*/ ,
                                                v105 /*: any*/ ,
                                                v107 /*: any*/ ,
                                                v108 /*: any*/ ,
                                                v109 /*: any*/ ,
                                                v111 /*: any*/ ,
                                                v112 /*: any*/ ,
                                                v113 /*: any*/ ,
                                                v114 /*: any*/ ,
                                                v115 /*: any*/ ,
                                                v116 /*: any*/ ,
                                                v119 /*: any*/ ,
                                                v120 /*: any*/ ,
                                                v121 /*: any*/ ,
                                                v122 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v123 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ], v125 = {
        "kind": "Variable",
        "name": "filterId",
        "variableName": "filterId"
    }, v126 = {
        "kind": "Variable",
        "name": "namespace",
        "variableName": "namespace"
    }, v127 = {
        "kind": "Variable",
        "name": "viewId",
        "variableName": "viewId"
    }, v128 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            {
                "condition": "shouldQueryFieldSetsById",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "fieldSetIds",
                                "variableName": "fieldSetIds"
                            },
                            v59 /*: any*/ 
                        ],
                        "concreteType": "JiraIssueFieldSetConnection",
                        "kind": "LinkedField",
                        "name": "fieldSetsById",
                        "plural": false,
                        "selections": v124 /*: any*/ 
                    }
                ]
            },
            {
                "condition": "shouldQueryFieldSetsById",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "context",
                                "variableName": "fieldSetsContext"
                            },
                            v125 /*: any*/ ,
                            v59 /*: any*/ ,
                            v126 /*: any*/ ,
                            v127 /*: any*/ 
                        ],
                        "concreteType": "JiraIssueFieldSetConnection",
                        "kind": "LinkedField",
                        "name": "fieldSetsForIssueSearchView",
                        "plural": false,
                        "selections": v124 /*: any*/ 
                    }
                ]
            }
        ]
    }, v129 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v33 /*: any*/ ,
            v45 /*: any*/ ,
            v46 /*: any*/ ,
            v47 /*: any*/ ,
            v48 /*: any*/ ,
            v53 /*: any*/ ,
            v55 /*: any*/ ,
            v57 /*: any*/ ,
            v58 /*: any*/ ,
            v128 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v92 /*: any*/ ,
                    {
                        "concreteType": "JiraIssueTypeField",
                        "kind": "LinkedField",
                        "name": "issueTypeField",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueType",
                                "plural": false,
                                "selections": [
                                    v98 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v130 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v131 = {
        "args": v130 /*: any*/ ,
        "concreteType": "JiraIssueFieldSetConnection",
        "kind": "LinkedField",
        "name": "fieldSets",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v60 /*: any*/ ,
                            v61 /*: any*/ ,
                            {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v33 /*: any*/ ,
                                                    v49 /*: any*/ ,
                                                    v60 /*: any*/ ,
                                                    v62 /*: any*/ ,
                                                    v45 /*: any*/ ,
                                                    v63 /*: any*/ ,
                                                    v84 /*: any*/ ,
                                                    v86 /*: any*/ ,
                                                    v88 /*: any*/ ,
                                                    v90 /*: any*/ ,
                                                    v91 /*: any*/ ,
                                                    v93 /*: any*/ ,
                                                    v94 /*: any*/ ,
                                                    v73 /*: any*/ ,
                                                    v95 /*: any*/ ,
                                                    v96 /*: any*/ ,
                                                    v97 /*: any*/ ,
                                                    v99 /*: any*/ ,
                                                    v105 /*: any*/ ,
                                                    v107 /*: any*/ ,
                                                    v108 /*: any*/ ,
                                                    v109 /*: any*/ ,
                                                    v111 /*: any*/ ,
                                                    v112 /*: any*/ ,
                                                    v113 /*: any*/ ,
                                                    v114 /*: any*/ ,
                                                    v115 /*: any*/ ,
                                                    v116 /*: any*/ ,
                                                    v119 /*: any*/ ,
                                                    v120 /*: any*/ ,
                                                    v121 /*: any*/ ,
                                                    v122 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraOptionConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedOptions",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraOptionEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v79 /*: any*/ ,
                                                                            v31 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraCheckboxesField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraOption",
                                                                "kind": "LinkedField",
                                                                "name": "fieldOption",
                                                                "plural": false,
                                                                "selections": [
                                                                    v78 /*: any*/ ,
                                                                    v45 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraSingleSelectField"
                                                    },
                                                    v31 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    },
                                    v123 /*: any*/ 
                                ]
                            },
                            v31 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "storageKey": "fieldSets(first:500)"
    }, v132 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v133 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v134 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            v132 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "startCursor"
            },
            v133 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "hasPreviousPage"
            }
        ]
    }, v135 = {
        "concreteType": "JiraIssueNavigatorPageInfo",
        "kind": "LinkedField",
        "name": "issueNavigatorPageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "firstIssuePosition"
            },
            {
                "kind": "ScalarField",
                "name": "lastIssuePosition"
            }
        ]
    }, v136 = {
        "kind": "ScalarField",
        "name": "pageNumber"
    }, v137 = {
        "kind": "ScalarField",
        "name": "isCurrent"
    }, v138 = [
        v136 /*: any*/ ,
        v44 /*: any*/ ,
        v137 /*: any*/ 
    ], v139 = {
        "args": [
            {
                "kind": "Literal",
                "name": "maxCursors",
                "value": 7
            }
        ],
        "concreteType": "JiraPageCursors",
        "kind": "LinkedField",
        "name": "pageCursors",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "around",
                "plural": true,
                "selections": v138 /*: any*/ 
            },
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "last",
                "plural": false,
                "selections": v138 /*: any*/ 
            },
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "first",
                "plural": false,
                "selections": [
                    v44 /*: any*/ ,
                    v136 /*: any*/ ,
                    v137 /*: any*/ 
                ]
            }
        ],
        "storageKey": "pageCursors(maxCursors:7)"
    }, v140 = {
        "kind": "ScalarField",
        "name": "totalIssueSearchResultCount"
    }, v141 = {
        "kind": "LinkedField",
        "name": "issueSearchError",
        "plural": false,
        "selections": [
            v33 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "messages"
                    }
                ],
                "type": "JiraInvalidJqlError"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v85 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "errorType"
                    }
                ],
                "type": "JiraInvalidSyntaxError"
            }
        ]
    }, v142 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v143 = {
        "kind": "ScalarField",
        "name": "isCappingIssueSearchResult"
    }, v144 = [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                v44 /*: any*/ ,
                v129 /*: any*/ ,
                v33 /*: any*/ ,
                v131 /*: any*/ ,
                {
                    "condition": "shouldQueryHasChildren",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "items": [
                                        {
                                            "kind": "Variable",
                                            "name": "filterByProjectKeys.0",
                                            "variableName": "projectKey"
                                        }
                                    ],
                                    "kind": "ListValue",
                                    "name": "filterByProjectKeys"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "hasChildren"
                        },
                        {
                            "args": [
                                v26 /*: any*/ 
                            ],
                            "kind": "ScalarField",
                            "name": "canHaveChildIssues"
                        }
                    ]
                },
                v31 /*: any*/ 
            ]
        },
        v134 /*: any*/ ,
        v135 /*: any*/ ,
        v139 /*: any*/ ,
        v140 /*: any*/ ,
        v141 /*: any*/ ,
        v142 /*: any*/ ,
        v143 /*: any*/ ,
        v31 /*: any*/ 
    ], v145 = [
        "issueSearchInput"
    ], v146 = {
        "kind": "ScalarField",
        "name": "viewId"
    }, v147 = {
        "kind": "Variable",
        "name": "staticViewInput",
        "variableName": "staticViewInput"
    }, v148 = [
        v147 /*: any*/ 
    ], v149 = {
        "kind": "ScalarField",
        "name": "hideDone"
    }, v150 = {
        "args": v148 /*: any*/ ,
        "concreteType": "JiraIssueSearchViewConfigSettings",
        "kind": "LinkedField",
        "name": "viewConfigSettings",
        "plural": false,
        "selections": [
            v149 /*: any*/ 
        ]
    }, v151 = {
        "kind": "ScalarField",
        "name": "isHierarchyEnabled"
    }, v152 = {
        "kind": "ScalarField",
        "name": "hasDefaultFieldSets"
    }, v153 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "fieldSetSelectedState": "SELECTED"
            }
        },
        v59 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "fieldSetsScope"
        }
    ], v154 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v155 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v156 = {
        "kind": "ScalarField",
        "name": "isSortable"
    }, v157 = {
        "concreteType": "JiraFieldSetPreferences",
        "kind": "LinkedField",
        "name": "fieldSetPreferences",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "width"
            }
        ]
    }, v158 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraIssueSearchFieldMetadataConnection",
                "kind": "LinkedField",
                "name": "fieldsMetadata",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueSearchFieldMetadataEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueSearchMetadataField",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "canBeConfigured"
                                    },
                                    v49 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v159 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isPlaceHolderField"
            }
        ]
    }, v160 = {
        "concreteType": "JiraFieldType",
        "kind": "LinkedField",
        "name": "fieldType",
        "plural": false,
        "selections": [
            v154 /*: any*/ 
        ]
    }, v161 = {
        "kind": "ScalarField",
        "name": "canEnableHierarchy"
    }, v162 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isSortedByGlobalRankOnly"
            }
        ]
    }, v163 = {
        "kind": "Variable",
        "name": "groupBy",
        "variableName": "groupBy"
    }, v164 = [
        v163 /*: any*/ ,
        v38 /*: any*/ ,
        v147 /*: any*/ 
    ], v165 = {
        "concreteType": "JiraSpreadsheetGroupByConfig",
        "kind": "LinkedField",
        "name": "groupByConfig",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraField",
                "kind": "LinkedField",
                "name": "groupByField",
                "plural": false,
                "selections": [
                    v49 /*: any*/ ,
                    v45 /*: any*/ 
                ]
            }
        ]
    }, v166 = {
        "kind": "ScalarField",
        "name": "isGroupingEnabled"
    }, v167 = {
        "kind": "ScalarField",
        "name": "canEnableGrouping"
    }, v168 = [
        v151 /*: any*/ ,
        v161 /*: any*/ ,
        v166 /*: any*/ ,
        v167 /*: any*/ 
    ], v169 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": v164 /*: any*/ ,
                "concreteType": "JiraIssueSearchViewConfigSettings",
                "kind": "LinkedField",
                "name": "viewSettings",
                "plural": false,
                "selections": v168 /*: any*/ 
            }
        ],
        "type": "JiraSpreadsheetView",
        "abstractKey": "__isJiraSpreadsheetView"
    }, v170 = [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "args": v164 /*: any*/ ,
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "canPublishViewConfig"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isViewConfigModified"
                        }
                    ]
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        }
    ], v171 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": v170 /*: any*/ ,
                "type": "JiraIssueSearchViewMetadata",
                "abstractKey": "__isJiraIssueSearchViewMetadata"
            }
        ]
    }, v172 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v33 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "statusCode"
            }
        ]
    }, v173 = [
        v172 /*: any*/ ,
        v85 /*: any*/ 
    ], v174 = [
        v34 /*: any*/ ,
        v35 /*: any*/ ,
        v36 /*: any*/ ,
        v37 /*: any*/ ,
        v38 /*: any*/ ,
        v39 /*: any*/ ,
        v40 /*: any*/ ,
        v41 /*: any*/ 
    ], v175 = [
        v34 /*: any*/ ,
        v35 /*: any*/ ,
        v37 /*: any*/ ,
        v163 /*: any*/ ,
        v38 /*: any*/ ,
        v39 /*: any*/ ,
        v41 /*: any*/ 
    ], v176 = {
        "kind": "ScalarField",
        "name": "fieldType"
    }, v177 = {
        "kind": "LinkedField",
        "name": "fieldValue",
        "plural": false,
        "selections": [
            v33 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraPriority",
                        "kind": "LinkedField",
                        "name": "priority",
                        "plural": false,
                        "selections": [
                            v45 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "priorityId"
                            },
                            v56 /*: any*/ ,
                            v106 /*: any*/ 
                        ]
                    },
                    v154 /*: any*/ 
                ],
                "type": "JiraJqlPriorityFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v33 /*: any*/ ,
                            v45 /*: any*/ ,
                            v80 /*: any*/ ,
                            v56 /*: any*/ ,
                            v81 /*: any*/ 
                        ]
                    },
                    v154 /*: any*/ 
                ],
                "type": "JiraJqlUserFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraStatus",
                        "kind": "LinkedField",
                        "name": "status",
                        "plural": false,
                        "selections": [
                            v45 /*: any*/ ,
                            v56 /*: any*/ ,
                            {
                                "concreteType": "JiraStatusCategory",
                                "kind": "LinkedField",
                                "name": "statusCategory",
                                "plural": false,
                                "selections": [
                                    v45 /*: any*/ ,
                                    v50 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    v154 /*: any*/ ,
                    v51 /*: any*/ 
                ],
                "type": "JiraJqlStatusFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v117 /*: any*/ 
                ],
                "type": "JiraJqlNumberFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "option",
                        "plural": false,
                        "selections": [
                            v45 /*: any*/ ,
                            v78 /*: any*/ ,
                            v64 /*: any*/ ,
                            v76 /*: any*/ 
                        ]
                    },
                    v154 /*: any*/ 
                ],
                "type": "JiraJqlOptionFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraSprint",
                        "kind": "LinkedField",
                        "name": "sprint",
                        "plural": false,
                        "selections": v110 /*: any*/ 
                    },
                    v154 /*: any*/ 
                ],
                "type": "JiraJqlSprintFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraGoal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                            v45 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "status"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "score"
                            }
                        ]
                    },
                    v154 /*: any*/ 
                ],
                "type": "JiraJqlGoalsFieldValue"
            }
        ]
    }, v178 = {
        "kind": "ScalarField",
        "name": "issueCount"
    }, v179 = [
        v36 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        }
    ], v180 = [
        v34 /*: any*/ ,
        v35 /*: any*/ ,
        v36 /*: any*/ ,
        v37 /*: any*/ ,
        v38 /*: any*/ ,
        v39 /*: any*/ ,
        v40 /*: any*/ ,
        v41 /*: any*/ ,
        v42 /*: any*/ 
    ], v181 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                v25 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_IssueNavigatorQuery",
            "selections": [
                {
                    "args": [
                        v26 /*: any*/ ,
                        {
                            "items": [
                                {
                                    "kind": "Variable",
                                    "name": "projectKeys.0",
                                    "variableName": "projectKey"
                                }
                            ],
                            "kind": "ListValue",
                            "name": "projectKeys"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_issueQuery"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v28 /*: any*/ ,
                            "concreteType": "JiraUserPreferences",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "main_issueNavigator_IssueNavigator_userPreferences"
                                }
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_IssueNavigator_jira"
                        },
                        {
                            "condition": "shouldQueryProject",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v29 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "main_issueNavigator_IssueNavigatorUI_project"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "issueSearch_issueNavigatorProject"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v13 /*: any*/ ,
                v10 /*: any*/ ,
                v14 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v15 /*: any*/ ,
                v24 /*: any*/ ,
                v16 /*: any*/ ,
                v7 /*: any*/ ,
                v9 /*: any*/ ,
                v5 /*: any*/ ,
                v19 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v6 /*: any*/ ,
                v17 /*: any*/ ,
                v21 /*: any*/ ,
                v12 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ ,
                v18 /*: any*/ ,
                v11 /*: any*/ ,
                v20 /*: any*/ ,
                v8 /*: any*/ ,
                v25 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistcheckissuecreatepermissionsrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "main_IssueNavigatorQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v28 /*: any*/ ,
                            "concreteType": "JiraUserPreferences",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "jqlBuilderSearchMode"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isNaturalLanguageSpotlightTourEnabled"
                                },
                                v31 /*: any*/ 
                            ]
                        },
                        {
                            "args": v32 /*: any*/ ,
                            "kind": "ScalarField",
                            "name": "shouldShowAtlassianIntelligence"
                        },
                        {
                            "args": v32 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "atlassianIntelligenceAction",
                            "plural": false,
                            "selections": [
                                v33 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isAccessible"
                                        }
                                    ],
                                    "type": "JiraAccessAtlassianIntelligenceFeature"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "link"
                                        }
                                    ],
                                    "type": "JiraEnableAtlassianIntelligenceDeepLink"
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v43 /*: any*/ ,
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issueSearch",
                                    "plural": false,
                                    "selections": v144 /*: any*/ 
                                },
                                {
                                    "args": v43 /*: any*/ ,
                                    "filters": v145 /*: any*/ ,
                                    "handle": "connection",
                                    "key": "IssueNavigatorIssueSearchPagination__issueSearch",
                                    "kind": "LinkedHandle",
                                    "name": "issueSearch"
                                },
                                {
                                    "args": [
                                        v27 /*: any*/ ,
                                        v125 /*: any*/ ,
                                        v38 /*: any*/ ,
                                        v126 /*: any*/ ,
                                        v127 /*: any*/ 
                                    ],
                                    "kind": "LinkedField",
                                    "name": "issueSearchViewResult",
                                    "plural": false,
                                    "selections": [
                                        v33 /*: any*/ ,
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isJiraIssueSearchViewResult"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v146 /*: any*/ ,
                                                v150 /*: any*/ ,
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "args": v148 /*: any*/ ,
                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                            "kind": "LinkedField",
                                                            "name": "viewConfigSettings",
                                                            "plural": false,
                                                            "selections": [
                                                                v151 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v45 /*: any*/ ,
                                                        v152 /*: any*/ ,
                                                        {
                                                            "args": v153 /*: any*/ ,
                                                            "concreteType": "JiraIssueSearchFieldSetConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldSets",
                                                            "plural": false,
                                                            "selections": [
                                                                v74 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueSearchFieldSet",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v61 /*: any*/ ,
                                                                                v60 /*: any*/ ,
                                                                                v154 /*: any*/ ,
                                                                                v155 /*: any*/ ,
                                                                                v156 /*: any*/ ,
                                                                                v157 /*: any*/ ,
                                                                                v158 /*: any*/ ,
                                                                                v159 /*: any*/ ,
                                                                                v160 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v31 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "args": v148 /*: any*/ ,
                                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                                            "kind": "LinkedField",
                                                                            "name": "viewConfigSettings",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v161 /*: any*/ ,
                                                                                v162 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraIssueSearchView"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "args": v164 /*: any*/ ,
                                                                    "concreteType": "JiraIssueSearchViewConfigSettings",
                                                                    "kind": "LinkedField",
                                                                    "name": "viewSettings",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v161 /*: any*/ ,
                                                                        v165 /*: any*/ ,
                                                                        v151 /*: any*/ ,
                                                                        v149 /*: any*/ ,
                                                                        v162 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraSpreadsheetView",
                                                            "abstractKey": "__isJiraSpreadsheetView"
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "TypeDiscriminator",
                                                                    "abstractKey": "__isJiraIssueSearchViewMetadata"
                                                                },
                                                                v45 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "args": v148 /*: any*/ ,
                                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                                            "kind": "LinkedField",
                                                                            "name": "viewConfigSettings",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v161 /*: any*/ ,
                                                                                v166 /*: any*/ ,
                                                                                v167 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraIssueSearchView"
                                                                },
                                                                v169 /*: any*/ 
                                                            ]
                                                        },
                                                        v31 /*: any*/ ,
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": v170 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "JiraIssueSearchViewMetadata",
                                                    "abstractKey": "__isJiraIssueSearchViewMetadata"
                                                },
                                                v171 /*: any*/ 
                                            ],
                                            "type": "JiraIssueSearchView"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v85 /*: any*/ ,
                                                v172 /*: any*/ 
                                            ],
                                            "type": "QueryError"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v83 /*: any*/ ,
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        v27 /*: any*/ ,
                                        v125 /*: any*/ ,
                                        v38 /*: any*/ ,
                                        v126 /*: any*/ ,
                                        {
                                            "kind": "Variable",
                                            "name": "viewConfigInput",
                                            "variableName": "staticViewInput"
                                        },
                                        v127 /*: any*/ ,
                                        {
                                            "kind": "Variable",
                                            "name": "viewQueryInput",
                                            "variableName": "viewQueryInput"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "jiraIssueSearchView",
                                    "plural": false,
                                    "selections": [
                                        v33 /*: any*/ ,
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isJiraView"
                                        },
                                        {
                                            "concreteType": "QueryError",
                                            "kind": "LinkedField",
                                            "name": "error",
                                            "plural": false,
                                            "selections": v173 /*: any*/ 
                                        },
                                        v45 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v146 /*: any*/ ,
                                                {
                                                    "args": v153 /*: any*/ ,
                                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v61 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraIssueSearchViewMetadata",
                                            "abstractKey": "__isJiraIssueSearchViewMetadata"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "args": v164 /*: any*/ ,
                                                    "concreteType": "JiraIssueSearchViewConfigSettings",
                                                    "kind": "LinkedField",
                                                    "name": "viewSettings",
                                                    "plural": false,
                                                    "selections": [
                                                        v166 /*: any*/ ,
                                                        v167 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraSpreadsheetGroupByConfig",
                                                            "kind": "LinkedField",
                                                            "name": "groupByConfig",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraField",
                                                                    "kind": "LinkedField",
                                                                    "name": "groupByField",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v49 /*: any*/ ,
                                                                        v45 /*: any*/ ,
                                                                        v56 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "typeKey"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v151 /*: any*/ ,
                                                        v149 /*: any*/ 
                                                    ]
                                                },
                                                v142 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "filterId"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v152 /*: any*/ ,
                                                        {
                                                            "args": v153 /*: any*/ ,
                                                            "concreteType": "JiraIssueSearchFieldSetConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldSets",
                                                            "plural": false,
                                                            "selections": [
                                                                v74 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueSearchFieldSet",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v60 /*: any*/ ,
                                                                                v154 /*: any*/ ,
                                                                                v155 /*: any*/ ,
                                                                                v156 /*: any*/ ,
                                                                                v157 /*: any*/ ,
                                                                                v160 /*: any*/ ,
                                                                                v158 /*: any*/ ,
                                                                                v159 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v31 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "args": v148 /*: any*/ ,
                                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                                            "kind": "LinkedField",
                                                                            "name": "viewConfigSettings",
                                                                            "plural": false,
                                                                            "selections": v168 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "JiraIssueSearchView"
                                                                },
                                                                v169 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v150 /*: any*/ ,
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "args": v148 /*: any*/ ,
                                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                                            "kind": "LinkedField",
                                                                            "name": "viewConfigSettings",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v151 /*: any*/ ,
                                                                                v161 /*: any*/ ,
                                                                                v149 /*: any*/ ,
                                                                                v162 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraIssueSearchView"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "args": v164 /*: any*/ ,
                                                                    "concreteType": "JiraIssueSearchViewConfigSettings",
                                                                    "kind": "LinkedField",
                                                                    "name": "viewSettings",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v149 /*: any*/ ,
                                                                        v161 /*: any*/ ,
                                                                        v165 /*: any*/ ,
                                                                        v151 /*: any*/ ,
                                                                        v162 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraSpreadsheetView",
                                                            "abstractKey": "__isJiraSpreadsheetView"
                                                        },
                                                        v31 /*: any*/ 
                                                    ],
                                                    "type": "JiraIssueSearchViewMetadata",
                                                    "abstractKey": "__isJiraIssueSearchViewMetadata"
                                                },
                                                v171 /*: any*/ 
                                            ],
                                            "type": "JiraSpreadsheetView",
                                            "abstractKey": "__isJiraSpreadsheetView"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "args": v174 /*: any*/ ,
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                v44 /*: any*/ ,
                                                                v129 /*: any*/ ,
                                                                v33 /*: any*/ ,
                                                                v131 /*: any*/ ,
                                                                v31 /*: any*/ 
                                                            ]
                                                        },
                                                        v134 /*: any*/ ,
                                                        v135 /*: any*/ ,
                                                        v139 /*: any*/ ,
                                                        v140 /*: any*/ ,
                                                        v141 /*: any*/ ,
                                                        v142 /*: any*/ ,
                                                        v143 /*: any*/ ,
                                                        v31 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "args": v174 /*: any*/ ,
                                                    "filters": v145 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "IssueNavigatorDetailedViewPagination__issues",
                                                    "kind": "LinkedHandle",
                                                    "name": "issues"
                                                }
                                            ],
                                            "type": "JiraDetailedView"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "args": v175 /*: any*/ ,
                                                    "concreteType": "JiraSpreadsheetGroupConnection",
                                                    "kind": "LinkedField",
                                                    "name": "groups",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraSpreadsheetGroupEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                v44 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraSpreadsheetGroup",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v33 /*: any*/ ,
                                                                        v45 /*: any*/ ,
                                                                        v142 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v176 /*: any*/ ,
                                                                        v177 /*: any*/ ,
                                                                        v178 /*: any*/ 
                                                                    ]
                                                                },
                                                                v33 /*: any*/ 
                                                            ]
                                                        },
                                                        v134 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "groupByField"
                                                        },
                                                        v142 /*: any*/ ,
                                                        {
                                                            "concreteType": "QueryError",
                                                            "kind": "LinkedField",
                                                            "name": "errors",
                                                            "plural": true,
                                                            "selections": v173 /*: any*/ 
                                                        },
                                                        {
                                                            "condition": "isPaginating",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSpreadsheetGroup",
                                                                    "kind": "LinkedField",
                                                                    "name": "firstGroup",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v45 /*: any*/ ,
                                                                        {
                                                                            "args": v179 /*: any*/ ,
                                                                            "concreteType": "JiraIssueConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "issues",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v33 /*: any*/ ,
                                                                                        v44 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraIssue",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v33 /*: any*/ ,
                                                                                                v45 /*: any*/ ,
                                                                                                v46 /*: any*/ ,
                                                                                                v47 /*: any*/ ,
                                                                                                v48 /*: any*/ ,
                                                                                                v53 /*: any*/ ,
                                                                                                v55 /*: any*/ ,
                                                                                                v57 /*: any*/ ,
                                                                                                v58 /*: any*/ ,
                                                                                                v128 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "args": v130 /*: any*/ ,
                                                                                            "concreteType": "JiraIssueFieldSetConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "fieldSets",
                                                                                            "plural": false,
                                                                                            "selections": v124 /*: any*/ ,
                                                                                            "storageKey": "fieldSets(first:500)"
                                                                                        },
                                                                                        v31 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "PageInfo",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "pageInfo",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v132 /*: any*/ ,
                                                                                        v133 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v140 /*: any*/ ,
                                                                                v143 /*: any*/ ,
                                                                                v31 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "args": v179 /*: any*/ ,
                                                                            "filters": [
                                                                                "fieldSetsInput"
                                                                            ],
                                                                            "handle": "connection",
                                                                            "key": "firstGroupSection_nativeIssueTable__issues",
                                                                            "kind": "LinkedHandle",
                                                                            "name": "issues"
                                                                        },
                                                                        v142 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v176 /*: any*/ ,
                                                                        v177 /*: any*/ ,
                                                                        v178 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v31 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "args": v175 /*: any*/ ,
                                                    "filters": v145 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "IssueNavigatorGroupedListViewPagination__groups",
                                                    "kind": "LinkedHandle",
                                                    "name": "groups"
                                                }
                                            ],
                                            "type": "JiraGroupedListView"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "args": v180 /*: any*/ ,
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": v144 /*: any*/ 
                                                },
                                                {
                                                    "args": v180 /*: any*/ ,
                                                    "filters": v145 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "IssueNavigatorListViewPagination__issues",
                                                    "kind": "LinkedHandle",
                                                    "name": "issues"
                                                }
                                            ],
                                            "type": "JiraListView"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v28 /*: any*/ ,
                                    "concreteType": "JiraJqlFieldWithAliases",
                                    "kind": "LinkedField",
                                    "name": "rankField",
                                    "plural": false,
                                    "selections": [
                                        v155 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "shouldQueryProject",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v29 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        v46 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectType"
                                        },
                                        v45 /*: any*/ ,
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "alias": "editIssues",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "EDIT_ISSUES"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": v181 /*: any*/ ,
                                                    "storageKey": "action(type:\"EDIT_ISSUES\")"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistcheckissuecreatepermissionsrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "alias": "createIssues",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "CREATE_ISSUES"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": v181 /*: any*/ ,
                                                    "storageKey": "action(type:\"CREATE_ISSUES\")"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "38eff953d5dc19b03e72c037d9f32dea3993ff719f8d7d1d780dac76ea6d62a5",
            "metadata": {},
            "name": "main_IssueNavigatorQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider": (0, $1q6lK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider": (0, $bqIzm.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": (0, $k3PJZ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": (0, $5oQtH.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $dttgK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $adKYy.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $fjldt.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": (0, $iLxt4.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $l8ssf.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": (0, $5ykrX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $ggSVP.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $knfEI.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider": (0, $1xxk0.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider": (0, $5wdbf.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $gY76A.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistcheckissuecreatepermissionsrelayprovider": (0, $5Bxi4.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider": (0, $c5npJ.default)
            }
        }
    };
}();
$ff9dfb30fc1873c4$var$node.hash = "6dc0a4b2ca0d834605bf564f2d4efc5c";
var $ff9dfb30fc1873c4$export$2e2bcd8739ae039 = $ff9dfb30fc1873c4$var$node;

});
parcelRegister("bqIzm", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d9218d128e87a96$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");
const $9d9218d128e87a96$export$8777089b74f8b497 = {
    get () {
        return (0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false);
    }
};
var $9d9218d128e87a96$export$2e2bcd8739ae039 = $9d9218d128e87a96$export$8777089b74f8b497;

});

parcelRegister("1q6lK", function(module, exports) {

$parcel$export(module.exports, "default", () => $181eac5504cd1c95$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $181eac5504cd1c95$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('refactor_nin_to_jira_view_schema');
    }
};

});

parcelRegister("1xxk0", function(module, exports) {

$parcel$export(module.exports, "default", () => $55ba50657e25f3ba$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");
var $55ba50657e25f3ba$export$2e2bcd8739ae039 = {
    get () {
        return (0, $6s1PB.expVal)('saved_list_view', 'isEnabled', false);
    }
};

});

parcelRegister("c5npJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a21ee23f5837435$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $2a21ee23f5837435$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('saved_list_view_technical_changes');
    }
};

});

parcelRegister("5wdbf", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cc50bf0ec4f935f$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");
const $4cc50bf0ec4f935f$var$JscIssueRankingRelayProvider = {
    get () {
        return (0, $6s1PB.expVal)('jsc_list_reranking', 'isRerankingEnabled', false);
    }
};
var $4cc50bf0ec4f935f$export$2e2bcd8739ae039 = $4cc50bf0ec4f935f$var$JscIssueRankingRelayProvider;

});


parcelRegister("5cSAN", function(module, exports) {

$parcel$export(module.exports, "createViewAri", () => $ac366cc9f2edba1b$export$8e9e81ca81fb9409);

var $cGvzG = parcelRequire("cGvzG");

var $fY39E = parcelRequire("fY39E");

var $koeKL = parcelRequire("koeKL");

var $lODMY = parcelRequire("lODMY");
const $ac366cc9f2edba1b$var$useViewItemId = (0, $lODMY.createRouterSelector)((state)=>state.match?.params?.itemId);
const $ac366cc9f2edba1b$export$8e9e81ca81fb9409 = ({ activationId: activationId, cloudId: cloudId, layout: layout, projectId: projectId, viewItemId: viewItemId })=>{
    const layoutPart = layout ? `/layout/${layout}` : '';
    if (projectId) {
        const viewItemIdPart = viewItemId ? `/${viewItemId}` : '';
        return (0, $cGvzG.JiraViewAri).create({
            activationId: activationId,
            scopeId: `${projectId}/issues${viewItemIdPart}${layoutPart}`,
            scopeType: 'project',
            siteId: cloudId
        }).toString();
    }
    return (0, $cGvzG.JiraViewAri).create({
        activationId: activationId,
        scopeId: `issue-navigator${layoutPart}`,
        scopeType: 'global',
        siteId: cloudId
    }).toString();
};
const $ac366cc9f2edba1b$export$b6b78fb187396ce9 = ({ layout: layout, projectId: projectId })=>{
    const activationId = (0, $fY39E.useActivationId)();
    const cloudId = (0, $koeKL.useCloudId)();
    const viewItemId = $ac366cc9f2edba1b$var$useViewItemId();
    return $ac366cc9f2edba1b$export$8e9e81ca81fb9409({
        activationId: activationId,
        cloudId: cloudId,
        layout: layout,
        projectId: projectId,
        viewItemId: viewItemId
    });
};

});
parcelRegister("cGvzG", function(module, exports) {

$parcel$export(module.exports, "JiraViewAri", () => $93c1e64ca07778c1$export$259cce321cdbcc);

var $frfhC = parcelRequire("frfhC");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/view/manifest.ts
var $93c1e64ca07778c1$var$jiraViewAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $frfhC.JiraViewAriResourceOwner),
    resourceType: (0, $frfhC.JiraViewAriResourceType),
    resourceIdSlug: "activation/{activationId}/{scopeType}/{scopeId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        scopeType: /(global|project|board)/,
        // eslint-disable-line no-useless-escape
        scopeId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/view/index.ts
var $93c1e64ca07778c1$export$259cce321cdbcc = class _JiraViewAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._scopeType = opts.resourceIdSegmentValues.scopeType, this._scopeId = opts.resourceIdSegmentValues.scopeId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get scopeType() {
        return this._scopeType;
    }
    get scopeId() {
        return this._scopeId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $93c1e64ca07778c1$var$jiraViewAriStaticOpts.qualifier,
            platformQualifier: $93c1e64ca07778c1$var$jiraViewAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $93c1e64ca07778c1$var$jiraViewAriStaticOpts.resourceOwner,
            resourceType: $93c1e64ca07778c1$var$jiraViewAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.scopeType}/${opts.scopeId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                scopeType: opts.scopeType,
                scopeId: opts.scopeId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $93c1e64ca07778c1$var$jiraViewAriStaticOpts);
        return new _JiraViewAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $93c1e64ca07778c1$var$jiraViewAriStaticOpts);
        return new _JiraViewAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            scopeType: this.scopeType,
            scopeId: this.scopeId
        };
    }
};

});
parcelRegister("frfhC", function(module, exports) {

$parcel$export(module.exports, "JiraViewAriResourceOwner", () => $b3d53b90426675a7$export$c63cbf12e88f62b6);
$parcel$export(module.exports, "JiraViewAriResourceType", () => $b3d53b90426675a7$export$4b456bf9436bd47e);
// src/jira/view/types.ts
var $b3d53b90426675a7$export$c63cbf12e88f62b6 = "jira", $b3d53b90426675a7$export$4b456bf9436bd47e = "view";

});



parcelRegister("5bSAg", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_RELAY", () => $2134dee38b024167$export$c300d3b7f3dc697d);
$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_FILTER_RELAY", () => $2134dee38b024167$export$b99d8b4e19091835);
$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_HYDRATION_RELAY", () => $2134dee38b024167$export$1b65799bbeba8a33);
$parcel$export(module.exports, "defaultOrderFields", () => $2134dee38b024167$export$2bd49f8f262d7cbb);
$parcel$export(module.exports, "sortDirections", () => $2134dee38b024167$export$73034536b9adc928);
const $2134dee38b024167$export$c300d3b7f3dc697d = 'ISSUE_NAVIGATOR_RELAY';
const $2134dee38b024167$export$b99d8b4e19091835 = 'ISSUE_NAVIGATOR_FILTER_RELAY';
const $2134dee38b024167$export$1b65799bbeba8a33 = 'ISSUE_NAVIGATOR_HYDRATION_RELAY';
const $2134dee38b024167$export$2bd49f8f262d7cbb = {
    created: 'created',
    lastviewed: 'lastviewed',
    updated: 'updated'
};
const $2134dee38b024167$export$73034536b9adc928 = {
    ASC: 'ASC',
    DESC: 'DESC',
    NONE: 'NONE'
};

});

parcelRegister("aBKbA", function(module, exports) {

$parcel$export(module.exports, "getDefaultJqlGin", () => $b87185164056f069$export$8780b1523384f42d);
$parcel$export(module.exports, "getParams", () => $b87185164056f069$export$ec161d740909e39d);
$parcel$export(module.exports, "getJqlOrFilterId", () => $b87185164056f069$export$b968a035fc2aa57b);
$parcel$export(module.exports, "isChromelessRoute", () => $b87185164056f069$export$cc6019019381b4fd);
/* eslint-disable jira/import-whitelist */ 
var $9Nvh7 = parcelRequire("9Nvh7");

var $g5X3G = parcelRequire("g5X3G");

var $h2eGN = parcelRequire("h2eGN");

var $5bSAg = parcelRequire("5bSAg");
const $b87185164056f069$export$8780b1523384f42d = ()=>`ORDER BY ${(0, $5bSAg.defaultOrderFields).created} ${(0, $5bSAg.sortDirections).DESC}`;
const $b87185164056f069$export$ec161d740909e39d = ({ match: { params: params }, query: query })=>{
    const { projectKey: projectKey, issueKey: issueKey } = params;
    const { filter: filter, jql: jql } = query;
    // Default JQL when no relevant query parameter is set
    const defaultJql = projectKey !== null && projectKey !== undefined ? (0, $h2eGN.getDefaultJql)((0, $g5X3G.toProjectKey)(projectKey)) : $b87185164056f069$export$8780b1523384f42d();
    return {
        page: 1,
        jql: jql,
        issueKey: issueKey,
        projectKey: projectKey,
        filter: filter,
        defaultJql: defaultJql
    };
};
const $b87185164056f069$export$b968a035fc2aa57b = (defaultJql, jqlParam, filter, projectKey)=>{
    // If JQL param has been defined (even if it's empty) we should use it
    if (typeof jqlParam === 'string') return {
        jql: jqlParam
    };
    // If filter is non-empty then use the filter parameter
    if (typeof filter === 'string' && filter !== '') {
        if ((0, $9Nvh7.isFilterId)(filter)) return {
            filterId: filter
        };
        const filterJql = projectKey !== null && projectKey !== undefined ? (0, $h2eGN.mapFilterToJql)(projectKey, filter) : undefined;
        if (filterJql !== undefined) return {
            jql: filterJql
        };
    }
    // Fallback to the default JQL if neither JQL or valid filter parameters have been provided.
    return {
        jql: defaultJql
    };
};
const $b87185164056f069$export$cc6019019381b4fd = ({ route: route })=>{
    return route.layout?.isChromeless ?? false;
};

});
parcelRegister("h2eGN", function(module, exports) {

$parcel$export(module.exports, "isFilterKey", () => $0c6318e867c8ff1b$export$2cad587bb603edda);
$parcel$export(module.exports, "mapFilterToJql", () => $0c6318e867c8ff1b$export$1d71dda738f608f);
$parcel$export(module.exports, "getDefaultJql", () => $0c6318e867c8ff1b$export$346d50fe8350b1d0);
$parcel$export(module.exports, "getUrlPrefix", () => $0c6318e867c8ff1b$export$821d4141d135e0d0);

var $ebyGx = parcelRequire("ebyGx");

var $6UAdF = parcelRequire("6UAdF");

var $h2Dp1 = parcelRequire("h2Dp1");
const $0c6318e867c8ff1b$export$2cad587bb603edda = (filter)=>typeof filter === 'string' && filter in (0, $h2Dp1.Filters);
const $0c6318e867c8ff1b$export$1d71dda738f608f = (projectKey, filter)=>{
    if (!$0c6318e867c8ff1b$export$2cad587bb603edda(filter)) return undefined;
    const clauses = [
        `project = "${projectKey}"`
    ];
    let order = (0, $6UAdF.DEFAULT_ORDER_FIELD);
    const direction = (0, $6UAdF.DEFAULT_SORT_DIRECTION);
    switch((0, $h2Dp1.Filters)[filter]){
        case (0, $h2Dp1.Filters).myopenissues:
            clauses.push('assignee IN (currentUser())');
            clauses.push(`statusCategory IN (${(0, $h2Dp1.StatusCategoryValues).TO_DO}, ${(0, $h2Dp1.StatusCategoryValues).IN_PROGRESS})`);
            break;
        case (0, $h2Dp1.Filters).reportedbyme:
            clauses.push('reporter IN (currentUser())');
            break;
        case (0, $h2Dp1.Filters).allopenissues:
            clauses.push(`statusCategory IN (${(0, $h2Dp1.StatusCategoryValues).TO_DO}, ${(0, $h2Dp1.StatusCategoryValues).IN_PROGRESS})`);
            order = (0, $6UAdF.defaultOrderFields).updated;
            break;
        case (0, $h2Dp1.Filters).doneissues:
            clauses.push(`statusCategory = ${(0, $h2Dp1.StatusCategoryValues).DONE}`);
            break;
        case (0, $h2Dp1.Filters).recentlyviewed:
            order = (0, $6UAdF.defaultOrderFields).lastviewed;
            break;
        case (0, $h2Dp1.Filters).resolvedrecently:
            clauses.push('resolved >= -1w');
            order = (0, $6UAdF.defaultOrderFields).updated;
            break;
        case (0, $h2Dp1.Filters).updatedrecently:
            order = (0, $6UAdF.defaultOrderFields).updated;
            break;
        case (0, $h2Dp1.Filters).allissues:
            order = (0, $6UAdF.defaultOrderFields).created;
            break;
        default:
    }
    return `${clauses.join(' AND ')} ORDER BY ${order} ${direction}`.trim();
};
const $0c6318e867c8ff1b$export$346d50fe8350b1d0 = (projectKey)=>`project = "${projectKey}" ORDER BY ${0, $6UAdF.DEFAULT_ORDER_FIELD} ${0, $6UAdF.DEFAULT_SORT_DIRECTION}`;
const $0c6318e867c8ff1b$export$e5b4f9d05e643346 = (search, match)=>({
        ...(0, $ebyGx.parse)(search),
        ...match && match.params
    });
const $0c6318e867c8ff1b$export$821d4141d135e0d0 = (url)=>{
    const match = url.match(/^(.*)\/projects.*$/);
    return (match && match[1]) ?? '';
};

});
parcelRegister("h2Dp1", function(module, exports) {

$parcel$export(module.exports, "Filters", () => $cc363d6a082b1433$export$92a576f896a9bf72);
$parcel$export(module.exports, "StatusCategoryValues", () => $cc363d6a082b1433$export$72d6e2acce8f36fd);
const $cc363d6a082b1433$export$92a576f896a9bf72 = {
    myopenissues: Symbol('myopenissues'),
    reportedbyme: Symbol('reportedbyme'),
    allopenissues: Symbol('allopenissues'),
    doneissues: Symbol('doneissues'),
    recentlyviewed: Symbol('recentlyviewed'),
    resolvedrecently: Symbol('resolvedrecently'),
    updatedrecently: Symbol('updatedrecently'),
    allissues: Symbol('allissues')
};
const $cc363d6a082b1433$export$72d6e2acce8f36fd = {
    TO_DO: '"To Do"',
    DONE: '"Done"',
    IN_PROGRESS: '"In Progress"'
};

});





parcelRegister("3uU6P", function(module, exports) {

$parcel$export(module.exports, "getRouteReporting", () => $96adb79ea93c1c80$export$1300cb25a03c28fe);
const $96adb79ea93c1c80$export$1300cb25a03c28fe = ()=>({
        id: 'issue-navigator',
        packageName: 'issueNavigator',
        teamName: 'empanada'
    });

});

parcelRegister("gGOoR", function(module, exports) {

$parcel$export(module.exports, "default", () => $265d2c27687434ef$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ds5qV = parcelRequire("ds5qV");

var $doZTA = parcelRequire("doZTA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$265d2c27687434ef$export$2e2bcd8739ae039 = ()=>{
    const [{ match: match }] = (0, $doZTA.useRouter)();
    const issueKey = match.params.issueKey ?? '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: `/issues/${issueKey}`
    });
};

});

parcelRegister("b8f12", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorGinRedirectPageEntryPoint", () => $b7591135658477a3$export$f0e4197c4e8c99ac);
$parcel$export(module.exports, "issueNavigatorPageEntryPoint", () => $b7591135658477a3$export$b75ca1c5551bc52f);
$parcel$export(module.exports, "issueNavigatorWithoutHorizontalNavPageEntryPoint", () => $b7591135658477a3$export$ebe022658b1c5d7a);
$parcel$export(module.exports, "issueNavigatorPinRedirectPageEntryPoint", () => $b7591135658477a3$export$a90e8f2ed95763c3);
$parcel$export(module.exports, "issueNavigatorEmbedPageEntryPoint", () => $b7591135658477a3$export$650aa18210eea5a8);
$parcel$export(module.exports, "LazyGlobalIssueNavigator", () => $b7591135658477a3$export$8ff267588532c2ce);

var $kxZPA = parcelRequire("kxZPA");

var $3K3m0 = parcelRequire("3K3m0");

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");

var $lkFvK = parcelRequire("lkFvK");

var $5VqRy = parcelRequire("5VqRy");

var $mH8xj = parcelRequire("mH8xj");

var $4Exdo = parcelRequire("4Exdo");
const $b7591135658477a3$export$f0e4197c4e8c99ac = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $4Exdo.globalIssueNavigatorGinRedirectEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).FILTERS
});
const $b7591135658477a3$export$b75ca1c5551bc52f = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $3K3m0.issueNavigatorEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $b7591135658477a3$export$ebe022658b1c5d7a = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $3K3m0.issueNavigatorEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $b7591135658477a3$export$a90e8f2ed95763c3 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $mH8xj.issueNavigatorPinRedirectEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $b7591135658477a3$export$650aa18210eea5a8 = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $5VqRy.issueNavigatorEmbedEntrypoint)
});

const $b7591135658477a3$export$8ff267588532c2ce = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("i1dk1")), {
    moduleId: "./src/packages/spa-apps/issue-navigator/global-issue-navigator/src/index.tsx"
});

});
parcelRegister("3K3m0", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorEntrypoint", () => $a876be73045a44c8$export$4ec136b0c737540b);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $5T6bY = parcelRequire("5T6bY");

var $4R6GH = parcelRequire("4R6GH");

var $EVQo4 = parcelRequire("EVQo4");

var $6s1PB = parcelRequire("6s1PB");

const $a876be73045a44c8$export$4ec136b0c737540b = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("31zcH")), {
        moduleId: "7afd1266",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (entryPointParams)=>{
        const issueKey = (0, $4R6GH.fg)('slv-4_migrate_nin_selected_issue_route') ? entryPointParams?.context?.match?.query?.selectedIssue : entryPointParams?.context?.match?.params?.issueKey;
        const projectKey = (0, $4R6GH.fg)('conditional-formatting-new-list-targeting-gate') ? entryPointParams?.context?.match?.params?.projectKey : undefined;
        const { cloudId: cloudId } = (0, $4R6GH.fg)('conditional-formatting-new-list-targeting-gate') ? entryPointParams.tenantContext : {
            cloudId: undefined
        };
        let preloadProps = {};
        // exclude nativeIssueTableEntryPoint from preloading on the issue route
        if (!issueKey) preloadProps = {
            entryPoints: {
                nativeIssueTableEntryPoint: {
                    entryPoint: (0, $5T6bY.nativeIssueTableEntryPoint),
                    entryPointParams: entryPointParams
                }
            }
        };
        if (projectKey && (0, $6s1PB.expValEquals)('conditional_formatting_in_new_list', 'isEnabled', true, false)) preloadProps = {
            ...preloadProps,
            queries: {
                formatRulesQuery: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: (0, $EVQo4.default),
                    variables: {
                        cloudId: cloudId,
                        first: 50,
                        projectKey: projectKey
                    }
                }
            }
        };
        return preloadProps;
    }
});

});
parcelRegister("5T6bY", function(module, exports) {

$parcel$export(module.exports, "nativeIssueTableEntryPoint", () => $b9fa91d89cda3ec1$export$df35b18d762f614);

var $fEDBv = parcelRequire("fEDBv");

var $2OZhN = parcelRequire("2OZhN");

const $b9fa91d89cda3ec1$export$df35b18d762f614 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("9W0tU")).then((module)=>module.NativeIssueTableEntryPoint), {
        moduleId: "b6718107",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9W0tU", function(module, exports) {

let $73b9e76e676d3829$var$load = (parcelRequire("28QjX"))(4);


module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $73b9e76e676d3829$var$load("czifk"),
            $73b9e76e676d3829$var$load("kvRbA"),
            $73b9e76e676d3829$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $73b9e76e676d3829$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $73b9e76e676d3829$var$load("cTJTG"),
            $73b9e76e676d3829$var$load("l253H"),
            $73b9e76e676d3829$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $73b9e76e676d3829$var$load("4Qxp7")
        ]);
    }),
    $73b9e76e676d3829$var$load("ffQaD"),
    $73b9e76e676d3829$var$load("kvRbA"),
    $73b9e76e676d3829$var$load("fliVL"),
    $73b9e76e676d3829$var$load("kNFvF"),
    $73b9e76e676d3829$var$load("kQN3l")
]).then(()=>parcelRequire('bPcgy'));

});


parcelRegister("31zcH", function(module, exports) {

let $233cc5d5afc9bab6$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $233cc5d5afc9bab6$var$load("ffQaD"),
    $233cc5d5afc9bab6$var$load("kvRbA"),
    $233cc5d5afc9bab6$var$load("kNFvF"),
    $233cc5d5afc9bab6$var$load("i5vpK")
]).then(()=>parcelRequire('f6FZF'));

});


parcelRegister("5VqRy", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorEmbedEntrypoint", () => $2c9d817c5420d6c2$export$407d940f927eac56);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $5T6bY = parcelRequire("5T6bY");

const $2c9d817c5420d6c2$export$407d940f927eac56 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("6sq29")), {
        moduleId: "9aa91f84",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (entryPointParams)=>{
        return {
            entryPoints: {
                nativeIssueTableEntryPoint: {
                    entryPoint: (0, $5T6bY.nativeIssueTableEntryPoint),
                    entryPointParams: entryPointParams
                }
            }
        };
    }
});

});
parcelRegister("6sq29", function(module, exports) {

let $4b398d5d0abb828c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $4b398d5d0abb828c$var$load("ffQaD"),
    $4b398d5d0abb828c$var$load("kvRbA"),
    $4b398d5d0abb828c$var$load("kNFvF"),
    $4b398d5d0abb828c$var$load("lUgg5")
]).then(()=>parcelRequire('gDIMg'));

});


parcelRegister("mH8xj", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorPinRedirectEntrypoint", () => $5f84d963532ff7c4$export$cc17cd3f65b3828f);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $5f84d963532ff7c4$export$cc17cd3f65b3828f = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("8U0li")), {
        moduleId: "8d4a4d33"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8U0li", function(module, exports) {

let $67b3d1b6bdf864b1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $67b3d1b6bdf864b1$var$load("bdUIz").then(()=>parcelRequire('kF7iq'));

});


parcelRegister("4Exdo", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorGinRedirectEntrypoint", () => $45c50752d19052f1$export$3185a5139b079ec0);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $h9kbL = parcelRequire("h9kbL");

var $5T6bY = parcelRequire("5T6bY");

const $45c50752d19052f1$export$3185a5139b079ec0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("cgz0a")), {
        moduleId: "e648b5f0",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (entryPointParams)=>{
        const issueKey = entryPointParams?.context?.match?.params?.issueKey;
        return {
            entryPoints: {
                globalIssueNavigatorEntryPoint: {
                    entryPoint: (0, $h9kbL.globalIssueNavigatorEntryPoint),
                    entryPointParams: entryPointParams
                },
                ...!issueKey ? {
                    nativeIssueTableEntryPoint: {
                        entryPoint: (0, $5T6bY.nativeIssueTableEntryPoint),
                        entryPointParams: entryPointParams
                    }
                } : {}
            }
        };
    }
});

});
parcelRegister("h9kbL", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorEntryPoint", () => $9cbef7a45f505720$export$79ac0647e40ae809);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $9cbef7a45f505720$export$79ac0647e40ae809 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("i1dk1")).then((module)=>module.GlobalIssueNavigatorSPAEntryPoint), {
        moduleId: "c478d9ce"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("i1dk1", function(module, exports) {

let $d1e2a7716a07edec$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d1e2a7716a07edec$var$load("ffQaD"),
    $d1e2a7716a07edec$var$load("kvRbA"),
    $d1e2a7716a07edec$var$load("kNFvF"),
    $d1e2a7716a07edec$var$load("94Pxn")
]).then(()=>parcelRequire('68kUi'));

});


parcelRegister("cgz0a", function(module, exports) {

let $8ee2214921824dab$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8ee2214921824dab$var$load("hu7f4").then(()=>parcelRequire('5XrRK'));

});




parcelRegister("4nXyN", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorGlobalJiraRouteEntry", () => $a09e1f9770441a11$export$8925c79a030fdfe8);

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $fwSmZ = parcelRequire("fwSmZ");

var $1gXMV = parcelRequire("1gXMV");


var $8irO5 = parcelRequire("8irO5");

var $96TVI = parcelRequire("96TVI");

var $3uU6P = parcelRequire("3uU6P");

var $b8f12 = parcelRequire("b8f12");
const $a09e1f9770441a11$export$8925c79a030fdfe8 = (0, $7NszV.createEntry)((0, $fwSmZ.issueNavigatorGlobalJiraRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$d0ad1160bb95ce50),
            reporting: (0, $3uU6P.getRouteReporting)()
        },
        skeleton: (0, $1gXMV.GlobalIssueNavigatorSkeleton),
        ufoName: 'global-issue-navigator-jfe',
        navigation: (0, $8irO5.getCommonGlobalNavigation)(),
        resources: [
            ...(0, $96TVI.getCommonGlobalResources)()
        ],
        layout: (0, $2BrOV.globalLayout),
        // We want to opt out of concurrent mode for all NIN routes https://hello.atlassian.net/wiki/x/wTRfDAE
        // But allow for users with empanada-concurrent-incremental gate enabled to continue testing it
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental') && !(0, $4R6GH.fg)('empanada-concurrent-incremental'),
        entryPoint: ()=>(0, $b8f12.globalIssueNavigatorGinRedirectPageEntryPoint)
    }));

});
parcelRegister("fwSmZ", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorGlobalJiraRoute", () => $f141385b640afc92$export$286b1d26dcbbce9e);
const $f141385b640afc92$export$286b1d26dcbbce9e = {
    name: 'global-issue-navigator',
    path: '/jira/issues/:issueKey?'
};

});


parcelRegister("jrl3R", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorGlobalRouteEntry", () => $25e6f63d1902d36e$export$3e58fe44312b4093);

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $ddy4Q = parcelRequire("ddy4Q");

var $1gXMV = parcelRequire("1gXMV");


var $8irO5 = parcelRequire("8irO5");

var $96TVI = parcelRequire("96TVI");

var $3uU6P = parcelRequire("3uU6P");

var $b8f12 = parcelRequire("b8f12");
const $25e6f63d1902d36e$export$3e58fe44312b4093 = (0, $7NszV.createEntry)((0, $ddy4Q.issueNavigatorGlobalRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$d0ad1160bb95ce50),
            reporting: (0, $3uU6P.getRouteReporting)()
        },
        skeleton: (0, $1gXMV.GlobalIssueNavigatorSkeleton),
        ufoName: 'global-issue-navigator-jfe',
        navigation: (0, $8irO5.getCommonGlobalNavigation)(),
        resources: [
            ...(0, $96TVI.getCommonGlobalResources)()
        ],
        layout: (0, $2BrOV.globalLayout),
        // We want to opt out of concurrent mode for all NIN routes https://hello.atlassian.net/wiki/x/wTRfDAE
        // But allow for users with empanada-concurrent-incremental gate enabled to continue testing it
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental') && !(0, $4R6GH.fg)('empanada-concurrent-incremental'),
        isHydrateRootEnabled: (0, $4R6GH.fg)('nin-full-page-hydrate-root'),
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-navigator-entries/src/issueNavigatorGlobalRouteEntry.tsx',
                whichExportToUse: 'issueNavigatorGlobalRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-issue-navigator.json',
            // An increase from 1.2s default to 1.5s will comfortably cater for P95 of issue search requests
            // For more insights into this decision, see https://jplat.atlassian.net/browse/EM-9249
            fetchTimeout: (0, $4R6GH.fg)('increase_server_fetch_timeouts_for_nin_bifrost') ? 1500 : undefined
        },
        entryPoint: ()=>(0, $b8f12.globalIssueNavigatorGinRedirectPageEntryPoint)
    }));

});
parcelRegister("ddy4Q", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorGlobalRoute", () => $5ec8272afbf68925$export$928d3577bbe9e124);
const $5ec8272afbf68925$export$928d3577bbe9e124 = {
    name: 'global-issue-navigator',
    // Remove the issueKey path param when cleaning up slv-4_migrate_nin_selected_issue_route
    path: '/issues/:issueKey?',
    query: [
        'selectedIssue?'
    ]
};

});


parcelRegister("3B53X", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectBusinessRouteEntry", () => $99398975b82221bf$export$ce258b07e4b7eb8c);

var $5f2bR = parcelRequire("5f2bR");

var $4R6GH = parcelRequire("4R6GH");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $eGOUS = parcelRequire("eGOUS");

var $lHYIV = parcelRequire("lHYIV");


var $arJNO = parcelRequire("arJNO");

var $3uU6P = parcelRequire("3uU6P");

var $b8f12 = parcelRequire("b8f12");
const $99398975b82221bf$export$ce258b07e4b7eb8c = (0, $7NszV.createEntry)((0, $eGOUS.issueNavigatorProjectBusinessRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$d0ad1160bb95ce50),
            reporting: (0, $3uU6P.getRouteReporting)()
        },
        skeleton: (0, $lHYIV.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira)
        },
        resources: [
            ...(0, $arJNO.getCommonProjectResources)()
        ],
        layout: (0, $aPfsS.createLayout)((0, $gyYxw.genericProjectLayout)),
        // We want to opt out of concurrent mode for all NIN routes https://hello.atlassian.net/wiki/x/wTRfDAE
        // But allow for users with empanada-concurrent-incremental gate enabled to continue testing it
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental') && !(0, $4R6GH.fg)('empanada-concurrent-incremental'),
        entryPoint: ()=>(0, $b8f12.issueNavigatorPageEntryPoint)
    }));

});
parcelRegister("eGOUS", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectBusinessRoute", () => $dd2aac8c1b4464da$export$3219766aa1a42d18);
const $dd2aac8c1b4464da$export$3219766aa1a42d18 = {
    name: 'issue-navigator-core',
    // Remove the issueKey path param when cleaning up slv-4_migrate_nin_selected_issue_route
    path: '/jira/core/projects/:projectKey/issues/:issueKey?',
    query: [
        'selectedIssue?'
    ]
};

});

parcelRegister("lHYIV", function(module, exports) {

$parcel$export(module.exports, "ProjectIssueNavigatorSkeleton", () => $8afa09f5da2bc6b1$export$112138f5f732a994);
/* project-app.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3HwlS = parcelRequire("3HwlS");

var $hCy6k = parcelRequire("hCy6k");

var $fqNKR = parcelRequire("fqNKR");

var $l06VQ = parcelRequire("l06VQ");
const $8afa09f5da2bc6b1$var$customCssStyles = null;
const $8afa09f5da2bc6b1$export$112138f5f732a994 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, $3HwlS.getWillShowNav4)() ? (0, (/*@__PURE__*/$parcel$interopDefault($fqNKR))) : (0, (/*@__PURE__*/$parcel$interopDefault($l06VQ))),
        className: (0, $bwpsq.default)([
            "_2zz1zwfg _slt8zwfg _1od57vkz"
        ])
    });

});
parcelRegister("fqNKR", function(module, exports) {
module.exports = new URL("project-issue-navigator-nav4-skeleton.tpl.0c4c4250.svg", import.meta.url).toString();

});

parcelRegister("l06VQ", function(module, exports) {
module.exports = new URL("project-issue-navigator-skeleton.tpl.2a1718d8.svg", import.meta.url).toString();

});


parcelRegister("arJNO", function(module, exports) {

$parcel$export(module.exports, "getCommonProjectResources", () => $bb08e11d903a04ff$export$6236a7417086ea8d);

var $4R6GH = parcelRequire("4R6GH");

var $5bkvv = parcelRequire("5bkvv");

var $1b36n = parcelRequire("1b36n");

var $a3OKn = parcelRequire("a3OKn");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $lNicp = parcelRequire("lNicp");

var $bATyw = parcelRequire("bATyw");

var $89kiv = parcelRequire("89kiv");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $gNStA = parcelRequire("gNStA");

var $lAGdd = parcelRequire("lAGdd");
const $bb08e11d903a04ff$export$6236a7417086ea8d = ()=>[
        (0, $89kiv.issueNavigatorRelayResource),
        (0, $89kiv.issueNavigatorFilterRelayResource),
        (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('nin_request_hydrate_query_earlier'), (0, $89kiv.issueNavigatorHydrationRelayResource)),
        ...(0, $3RJkv.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $7GnDe.incidentExperimentTraitResource),
        (0, $dxCvy.projectContextResource),
        (0, $5bkvv.forgeProjectModuleResource),
        (0, $iEUaw.staticSidebarShortcutsResource),
        (0, $ggg5j.staticProjectSidebarNavigationResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $lNicp.getBusinessProjectResources)(),
        (0, $a3OKn.sidebarProjectIssuesResource),
        (0, $bATyw.isNinGlobalScopeEnrolmentEnabledResource),
        // this resource is also used by the nav4 sidebar for JSM project's 'issues and filters'
        // src/packages/navigation-apps/sidebar-nav4/jsm-project-menu/src/ui/project-menu/issues-and-filters/default-filters/index.tsx
        (0, $1b36n.staticSidebarDefaultPINFiltersResource),
        (0, $lAGdd.aiContextPanelResource)
    ];

});
parcelRegister("1b36n", function(module, exports) {

$parcel$export(module.exports, "staticSidebarDefaultPINFiltersResource", () => $f0c33588b62c7651$export$d3efe54a881807bf);

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");

var $elyZV = parcelRequire("elyZV");
const $f0c33588b62c7651$export$d3efe54a881807bf = (0, $2M1hQ.createResource)({
    type: 'JIRA_PROJECT_DEFAULT_PIN_FILTERS_NAV_DATA',
    getKey: ({ match: match, query: query })=>{
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(match, query);
        return projectKey || 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(match, query);
        if (projectKey == null) return null;
        return (0, $elyZV.fetchDefaultPINFiltersNavData)(projectKey);
    },
    maxAge: 300000
});

});
parcelRegister("elyZV", function(module, exports) {

$parcel$export(module.exports, "fetchDefaultPINFiltersNavData", () => $88433d457c0f5220$export$268c1bcb44a0ddd3);

var $eusud = parcelRequire("eusud");
const $88433d457c0f5220$var$extractNavIds = (result)=>new Set((result['com.atlassian.jira.jira-projects-issue-navigator:generic-filters'] || []).map((filterNavItem)=>filterNavItem.id));
const $88433d457c0f5220$export$268c1bcb44a0ddd3 = async (projectKey)=>{
    if (projectKey == null) throw new Error('invalid project id or key');
    const result = await (0, $eusud.performGetRequest)(`/rest/filters/1.0/filters?projectKey=${projectKey}`);
    const filterNavIds = $88433d457c0f5220$var$extractNavIds(result);
    return {
        hasMyOpenIssues: filterNavIds.has('myopenissues'),
        hasReportedByMe: filterNavIds.has('reportedbyme'),
        hasAllIssues: filterNavIds.has('allissues'),
        hasAllOpenIssues: filterNavIds.has('allopenissues'),
        hasDoneIssues: filterNavIds.has('doneissues'),
        hasViewedRecently: filterNavIds.has('recentlyviewed'),
        hasCreatedRecently: filterNavIds.has('addedrecently'),
        hasResolvedRecently: filterNavIds.has('resolvedrecently'),
        hasUpdatedRecently: filterNavIds.has('updatedrecently')
    };
};

});


parcelRegister("a3OKn", function(module, exports) {

$parcel$export(module.exports, "sidebarProjectIssuesResource", () => $b491cf2963738bcf$export$be31dd7adcfd2297);

var $ao2h1 = parcelRequire("ao2h1");

var $59JDz = parcelRequire("59JDz");

var $6YG83 = parcelRequire("6YG83");
const $b491cf2963738bcf$export$be31dd7adcfd2297 = (0, $6YG83.withGiraAggAnonSsrFix)((0, $ao2h1.createRelayResource)({
    type: 'NAVIGATION_SIDEBAR_STARRED_FILTERS',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $59JDz.default),
            variables: {
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
}));

});
parcelRegister("59JDz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bc7247f574fad09$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<02638f2e8727b45498d5facc19a78e14>>
 * @relayHash 976837d13abb9b9131601925549fb05e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f420a549079d5a65e8a18d3584aa82b524d2287758061372f8331701919dd3f9

var $7vXy9 = parcelRequire("7vXy9");
const $6bc7247f574fad09$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v6 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            }
        ],
        "type": "JiraCustomFilter"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "starredFiltersList_navigationAppsSidebarCommon"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "favouriteFilters",
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": {
                                                    "order": "DESC"
                                                },
                                                "type": "FILTER"
                                            }
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 15
                                        }
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v8 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v9 /*: any*/ 
                                                            ],
                                                            "type": "Node",
                                                            "abstractKey": "__isNode"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "favouriteFiltersOld",
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraFilterConnection",
                                    "kind": "LinkedField",
                                    "name": "favouriteFilters",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFilterEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "TypeDiscriminator",
                                                            "abstractKey": "__isJiraFilter"
                                                        },
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f420a549079d5a65e8a18d3584aa82b524d2287758061372f8331701919dd3f9",
            "metadata": {},
            "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider": (0, $7vXy9.default)
            }
        }
    };
}();
$6bc7247f574fad09$var$node.hash = "86a313b9769c9a6a731e02bed044f4d2";
var $6bc7247f574fad09$export$2e2bcd8739ae039 = $6bc7247f574fad09$var$node;

});




parcelRegister("bvhAI", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectBusinessEmbedRouteEntry", () => $25993f18ac5a79c6$export$2b29f9b6033583e1);

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $bG4N3 = parcelRequire("bG4N3");


var $8SwBk = parcelRequire("8SwBk");

var $6e4Kt = parcelRequire("6e4Kt");

var $6LsQE = parcelRequire("6LsQE");

var $arJNO = parcelRequire("arJNO");

var $3uU6P = parcelRequire("3uU6P");

var $b8f12 = parcelRequire("b8f12");
const $25993f18ac5a79c6$export$2b29f9b6033583e1 = (0, $7NszV.createEntry)((0, $bG4N3.issueNavigatorProjectBusinessEmbedRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$d0ad1160bb95ce50),
            reporting: (0, $3uU6P.getRouteReporting)()
        },
        skeleton: (0, $8SwBk.EmbedIssueNavigatorSkeleton),
        resources: [
            ...(0, $arJNO.getCommonProjectResources)()
        ],
        layout: (0, $6e4Kt.chromelessLayout),
        // We want to opt out of concurrent mode for all NIN routes https://hello.atlassian.net/wiki/x/wTRfDAE
        // But allow for users with empanada-concurrent-incremental gate enabled to continue testing it
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental') && !(0, $4R6GH.fg)('empanada-concurrent-incremental'),
        entryPoint: ()=>(0, $4R6GH.fg)('jira_nin_smart_link') ? (0, $b8f12.issueNavigatorEmbedPageEntryPoint) : (0, $6LsQE.notFoundPageEntrypoint)
    }));

});
parcelRegister("bG4N3", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectBusinessEmbedRoute", () => $c6cd917aee22ec45$export$a59f4bdf8be89f93);
const $c6cd917aee22ec45$export$a59f4bdf8be89f93 = {
    name: 'issue-navigator-core-embed',
    path: '/jira/core/projects/:projectKey/issues/embed'
};

});

parcelRegister("8SwBk", function(module, exports) {

$parcel$export(module.exports, "EmbedIssueNavigatorSkeleton", () => $9d3d268015ae6173$export$1b1eaa2e48fda507);
/* embed-app.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $7TslS = parcelRequire("7TslS");
const $9d3d268015ae6173$var$customCssStyles = null;
const $9d3d268015ae6173$export$1b1eaa2e48fda507 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7TslS))),
        className: (0, $bwpsq.default)([
            "_2zz1zwfg _slt8zwfg _1od57vkz"
        ])
    });

});
parcelRegister("7TslS", function(module, exports) {
module.exports = new URL("embed-issue-navigator-skeleton.tpl.616c25ab.svg", import.meta.url).toString();

});



parcelRegister("glkO2", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectClassicRouteEntry", () => $41789f7b84696902$export$88d5f4117ce3d0fb);

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $eL7Ve = parcelRequire("eL7Ve");

var $lHYIV = parcelRequire("lHYIV");

var $5f2bR = parcelRequire("5f2bR");


var $arJNO = parcelRequire("arJNO");

var $3uU6P = parcelRequire("3uU6P");

var $b8f12 = parcelRequire("b8f12");
const $41789f7b84696902$export$88d5f4117ce3d0fb = (0, $7NszV.createEntry)((0, $eL7Ve.issueNavigatorProjectClassicRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$d0ad1160bb95ce50),
            reporting: (0, $3uU6P.getRouteReporting)()
        },
        skeleton: (0, $lHYIV.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $cSD7y.componentWithFG)('make_nav3_sidebar_lazyforpaint', (0, $9s3j1.ForPaintClassicSoftwareProjectSidebar), (0, $9s3j1.default)),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $arJNO.getCommonProjectResources)()
        ],
        layout: (0, $aPfsS.createLayout)((0, $gyYxw.genericProjectLayout)),
        // We want to opt out of concurrent mode for all NIN routes https://hello.atlassian.net/wiki/x/wTRfDAE
        // But allow for users with empanada-concurrent-incremental gate enabled to continue testing it
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental') && !(0, $4R6GH.fg)('empanada-concurrent-incremental'),
        isHydrateRootEnabled: (0, $4R6GH.fg)('nin-full-page-hydrate-root'),
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-issue-navigator-entries/src/issueNavigatorProjectClassicRouteEntry.tsx',
                whichExportToUse: 'issueNavigatorProjectClassicRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-issue-navigator.json',
            // An increase from 1.2s default to 1.5s will comfortably cater for P95 of issue search requests
            // For more insights into this decision, see https://jplat.atlassian.net/browse/EM-9249
            fetchTimeout: (0, $4R6GH.fg)('increase_server_fetch_timeouts_for_nin_bifrost') ? 1500 : undefined
        },
        entryPoint: ()=>(0, $b8f12.issueNavigatorPageEntryPoint)
    }));

});
parcelRegister("eL7Ve", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectClassicRoute", () => $97f612a83fdbbb6d$export$8e7b74b6169d59ca);
const $97f612a83fdbbb6d$export$8e7b74b6169d59ca = {
    name: 'issue-navigator-classic',
    // Remove the issueKey path param when cleaning up slv-4_migrate_nin_selected_issue_route
    path: '/jira/software/c/projects/:projectKey/issues/:issueKey?',
    query: [
        'selectedIssue?'
    ]
};

});


parcelRegister("anGpc", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectClassicEmbedRouteEntry", () => $e5189f36edabee3f$export$e77148aa19091842);

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $8nAP5 = parcelRequire("8nAP5");

var $8SwBk = parcelRequire("8SwBk");

var $6e4Kt = parcelRequire("6e4Kt");


var $6LsQE = parcelRequire("6LsQE");

var $arJNO = parcelRequire("arJNO");

var $b8f12 = parcelRequire("b8f12");

var $3uU6P = parcelRequire("3uU6P");
const $e5189f36edabee3f$export$e77148aa19091842 = (0, $7NszV.createEntry)((0, $8nAP5.issueNavigatorProjectClassicEmbedRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$d0ad1160bb95ce50),
            reporting: (0, $3uU6P.getRouteReporting)()
        },
        skeleton: (0, $8SwBk.EmbedIssueNavigatorSkeleton),
        resources: [
            ...(0, $arJNO.getCommonProjectResources)()
        ],
        layout: (0, $6e4Kt.chromelessLayout),
        // We want to opt out of concurrent mode for all NIN routes https://hello.atlassian.net/wiki/x/wTRfDAE
        // But allow for users with empanada-concurrent-incremental gate enabled to continue testing it
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental') && !(0, $4R6GH.fg)('empanada-concurrent-incremental'),
        isHydrateRootEnabled: (0, $4R6GH.fg)('nin-full-page-hydrate-root'),
        entryPoint: ()=>(0, $4R6GH.fg)('jira_nin_smart_link') ? (0, $b8f12.issueNavigatorEmbedPageEntryPoint) : (0, $6LsQE.notFoundPageEntrypoint)
    }));

});
parcelRegister("8nAP5", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectClassicEmbedRoute", () => $1e630657526162a5$export$1062bd8aa98d7bd1);
const $1e630657526162a5$export$1062bd8aa98d7bd1 = {
    name: 'issue-navigator-classic-embed',
    path: '/jira/software/c/projects/:projectKey/issues/embed'
};

});


parcelRegister("04Vlk", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectServicedeskRouteEntry", () => $20147c9440522c21$export$b779296ccb8ca1a8);

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $1WlLE = parcelRequire("1WlLE");

var $imKA4 = parcelRequire("imKA4");

var $6Z2mh = parcelRequire("6Z2mh");

var $lHYIV = parcelRequire("lHYIV");


var $arJNO = parcelRequire("arJNO");

var $3uU6P = parcelRequire("3uU6P");

var $b8f12 = parcelRequire("b8f12");
const $20147c9440522c21$export$b779296ccb8ca1a8 = (0, $7NszV.createEntry)((0, $imKA4.issueNavigatorProjectServicedeskRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$d0ad1160bb95ce50),
            reporting: (0, $3uU6P.getRouteReporting)()
        },
        skeleton: (0, $lHYIV.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $cSD7y.componentWithFG)('make_nav3_sidebar_lazyforpaint', (0, $h0bZU.ForPaintServicedeskSidebar), (0, $h0bZU.default))
        },
        resources: [
            ...(0, $arJNO.getCommonProjectResources)(),
            (0, $1WlLE.queuesNavigationItems),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        layout: (0, $6Z2mh.serviceProjectLayout),
        // We want to opt out of concurrent mode for all NIN routes https://hello.atlassian.net/wiki/x/wTRfDAE
        // But allow for users with empanada-concurrent-incremental gate enabled to continue testing it
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental') && !(0, $4R6GH.fg)('empanada-concurrent-incremental'),
        entryPoint: ()=>(0, $b8f12.issueNavigatorWithoutHorizontalNavPageEntryPoint)
    }));

});
parcelRegister("imKA4", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectServicedeskRoute", () => $708b2863e92ba0fb$export$e3495d64f36ba27c);
const $708b2863e92ba0fb$export$e3495d64f36ba27c = {
    name: 'servicedesk-issues',
    // Remove the issueKey path param when cleaning up slv-4_migrate_nin_selected_issue_route
    path: '/jira/servicedesk/projects/:projectKey/issues/:issueKey?',
    query: [
        'selectedIssue?'
    ]
};

});


parcelRegister("flsjf", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectSoftwareRouteEntry", () => $a82ae7782e05cd6a$export$2a50f64378877c9d);

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $5vzYC = parcelRequire("5vzYC");

var $lHYIV = parcelRequire("lHYIV");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");


var $arJNO = parcelRequire("arJNO");

var $3uU6P = parcelRequire("3uU6P");

var $b8f12 = parcelRequire("b8f12");
const $a82ae7782e05cd6a$export$2a50f64378877c9d = (0, $7NszV.createEntry)((0, $5vzYC.issueNavigatorProjectSoftwareRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$d0ad1160bb95ce50),
            reporting: (0, $3uU6P.getRouteReporting)()
        },
        skeleton: (0, $lHYIV.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $cSD7y.componentWithFG)('make_nav3_sidebar_lazyforpaint', (0, $koWFd.ForPaintSoftwareProjectSidebar), (0, $koWFd.default)),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $arJNO.getCommonProjectResources)()
        ],
        layout: (0, $aPfsS.createLayout)((0, $e7bC3.softwareProjectLayoutNoOnboarding)),
        // We want to opt out of concurrent mode for all NIN routes https://hello.atlassian.net/wiki/x/wTRfDAE
        // But allow for users with empanada-concurrent-incremental gate enabled to continue testing it
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental') && !(0, $4R6GH.fg)('empanada-concurrent-incremental'),
        entryPoint: ()=>(0, $b8f12.issueNavigatorPageEntryPoint)
    }));

});
parcelRegister("5vzYC", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectSoftwareRoute", () => $4a5b2c25740c19d3$export$b8bd410115307d80);
const $4a5b2c25740c19d3$export$b8bd410115307d80 = {
    name: 'software-issue-navigator',
    // Remove the issueKey path param when cleaning up slv-4_migrate_nin_selected_issue_route
    path: '/jira/software/projects/:projectKey/issues/:issueKey?',
    query: [
        'selectedIssue?'
    ]
};

});


parcelRegister("aI01j", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectSoftwareEmbedRouteEntry", () => $8c2cd4169c434551$export$e87ead168f851b66);

var $7NszV = parcelRequire("7NszV");

var $aw4Mv = parcelRequire("aw4Mv");

var $6e4Kt = parcelRequire("6e4Kt");

var $bHhiy = parcelRequire("bHhiy");

var $8SwBk = parcelRequire("8SwBk");


var $4R6GH = parcelRequire("4R6GH");

var $6LsQE = parcelRequire("6LsQE");

var $arJNO = parcelRequire("arJNO");

var $b8f12 = parcelRequire("b8f12");

var $3uU6P = parcelRequire("3uU6P");
const $8c2cd4169c434551$export$e87ead168f851b66 = (0, $7NszV.createEntry)((0, $aw4Mv.issueNavigatorProjectSoftwareEmbedRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$d0ad1160bb95ce50),
            reporting: (0, $3uU6P.getRouteReporting)()
        },
        skeleton: (0, $8SwBk.EmbedIssueNavigatorSkeleton),
        resources: [
            ...(0, $arJNO.getCommonProjectResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        layout: (0, $6e4Kt.chromelessLayout),
        entryPoint: ()=>(0, $4R6GH.fg)('jira_nin_smart_link') ? (0, $b8f12.issueNavigatorEmbedPageEntryPoint) : (0, $6LsQE.notFoundPageEntrypoint)
    }));

});
parcelRegister("aw4Mv", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorProjectSoftwareEmbedRoute", () => $46a13e12b1e055fa$export$ab4385f7ae539901);
const $46a13e12b1e055fa$export$ab4385f7ae539901 = {
    name: 'software-issue-navigator-embed',
    path: '/jira/software/projects/:projectKey/issues/embed'
};

});


parcelRegister("4Aamz", function(module, exports) {

$parcel$export(module.exports, "projectIssueNavigatorRouteEntry", () => $1d391d147db0115e$export$d6b778af15db7d3);

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $bHhiy = parcelRequire("bHhiy");

var $f9Gea = parcelRequire("f9Gea");

var $lHYIV = parcelRequire("lHYIV");


var $arJNO = parcelRequire("arJNO");

var $3uU6P = parcelRequire("3uU6P");

var $b8f12 = parcelRequire("b8f12");
const $1d391d147db0115e$export$d6b778af15db7d3 = (0, $7NszV.createEntry)((0, $f9Gea.projectIssueNavigatorRoute), ()=>({
        group: 'issue-navigator',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$d0ad1160bb95ce50),
            reporting: (0, $3uU6P.getRouteReporting)()
        },
        skeleton: (0, $lHYIV.ProjectIssueNavigatorSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $arJNO.getCommonProjectResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        layout: (0, $aPfsS.createLayout)((0, $gyYxw.genericProjectLayout)),
        entryPoint: ()=>(0, $b8f12.issueNavigatorPinRedirectPageEntryPoint)
    }));

});
parcelRegister("f9Gea", function(module, exports) {

$parcel$export(module.exports, "projectIssueNavigatorRoute", () => $2de97b1bab3baedd$export$126b16ec65343bf);
const $2de97b1bab3baedd$export$126b16ec65343bf = {
    name: 'issue-navigator',
    path: '/projects/:projectKey/issues/:issueKey?'
};

});


parcelRegister("1hbMK", function(module, exports) {

$parcel$export(module.exports, "jiraHomeRouteEntry", () => $056174761f438866$export$578dcb61ac3cb57a);

var $5uXOq = parcelRequire("5uXOq");

var $vla3y = parcelRequire("vla3y");

var $biCWj = parcelRequire("biCWj");

var $ffza4 = parcelRequire("ffza4");

var $3H5ry = parcelRequire("3H5ry");

var $4R6GH = parcelRequire("4R6GH");

var $l9RBL = parcelRequire("l9RBL");

var $gmpjq = parcelRequire("gmpjq");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");


var $bHhiy = parcelRequire("bHhiy");

var $aILzD = parcelRequire("aILzD");

var $gSttA = parcelRequire("gSttA");

var $3RJkv = parcelRequire("3RJkv");

var $dIHnK = parcelRequire("dIHnK");

var $5pSYQ = parcelRequire("5pSYQ");

var $gNStA = parcelRequire("gNStA");

var $7mjY3 = parcelRequire("7mjY3");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $6s1PB = parcelRequire("6s1PB");
const $056174761f438866$var$conditionalPostOfficeJiraYourWorkResource = (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('post_office_ssr_jira_your_work_enabled'), (0, $5pSYQ.postOfficeJiraYourWorkResource));
const $056174761f438866$var$conditionalJiraHomeWorkSuggestionsIsDeveloperResource = (0, $gNStA.resourceWithCondition2)(()=>(0, $6s1PB.expVal)('jira-your-work-work-suggestions-tab-experiment', 'isEnabled', false), (0, $gSttA.jiraHomeWorkSuggestionsIsDeveloperResource));

const $056174761f438866$var$LazyJiraHomePage = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("94zvX"))), {
    moduleId: "./src/packages/spa-apps/jira-home/src/index.tsx"
});
const $056174761f438866$var$checkConsolidationOnRouteDependency = async (dependencies)=>{
    const data = await dependencies[0, $5a94e356f9d5e220$export$25ee35b01de9d734].promise;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $3H5ry.checkShouldUseJSM)(data);
};
const $056174761f438866$var$JiraHomeComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $056174761f438866$var$LazyJiraHomePage,
        pageId: "jira-home",
        shouldShowSpinner: false
    });
const $056174761f438866$export$578dcb61ac3cb57a = (0, $7NszV.createEntry)((0, $dIHnK.jiraHomeRoute), ()=>({
        group: 'home',
        ufoName: 'jira-home',
        component: $056174761f438866$var$JiraHomeComponent,
        skeleton: (0, $7mjY3.YourWorkSkeleton),
        layout: (0, $gmpjq.homepageLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).HOME
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $aILzD.jiraHomeResourceWithCache),
            (0, $l9RBL.jiraHomePageRightSidePanelResource),
            $056174761f438866$var$conditionalPostOfficeJiraYourWorkResource,
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $vla3y.widgetResources).map((resourceCreator)=>resourceCreator($056174761f438866$var$checkConsolidationOnRouteDependency, [
                    (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
                ])),
            ...(0, $biCWj.widgetResources).map((resourceCreator)=>(0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('your_work_page_operation_widgets_changes'), resourceCreator($056174761f438866$var$checkConsolidationOnRouteDependency, [
                    (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
                ]))),
            $056174761f438866$var$conditionalJiraHomeWorkSuggestionsIsDeveloperResource
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $056174761f438866$var$LazyJiraHomePage
        ]
    }));

});
parcelRegister("biCWj", function(module, exports) {

$parcel$export(module.exports, "openAlertsResource", () => $a9a9236debbf4a7e$export$fb6d91a24bfaa074);
$parcel$export(module.exports, "ackedAlertsResource", () => $a9a9236debbf4a7e$export$3917a9639b1be557);
$parcel$export(module.exports, "snoozedAlertsResource", () => $a9a9236debbf4a7e$export$f62d237df457042d);
$parcel$export(module.exports, "widgetResources", () => $a9a9236debbf4a7e$export$bce3244764eac6e6);

var $2M1hQ = parcelRequire("2M1hQ");

var $4wMKp = parcelRequire("4wMKp");

var $ddwld = parcelRequire("ddwld");
const $a9a9236debbf4a7e$export$e5eb8aade1d4272a = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'openAlertsResource',
        getKey: ()=>'openAlertsResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $ddwld.fetchAlerts)({
                searchParams: {
                    query: (0, $4wMKp.PredefinedQueries).MY_OPEN_ALERTS,
                    limit: 3
                }
            });
        },
        isBrowserOnly: true,
        depends: depends
    });
const $a9a9236debbf4a7e$export$66760ff81022525f = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'ackedAlertsResource',
        getKey: ()=>'ackedAlertsResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $ddwld.fetchAlerts)({
                searchParams: {
                    query: (0, $4wMKp.PredefinedQueries).MY_ACKED_ALERTS,
                    limit: 3
                }
            });
        },
        isBrowserOnly: true,
        depends: depends
    });
const $a9a9236debbf4a7e$export$73c7fe1d8124595f = (checkConsolidationOnRouteDependency, depends)=>(0, $2M1hQ.createResource)({
        type: 'snoozedAlertsResource',
        getKey: ()=>'snoozedAlertsResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $ddwld.fetchAlerts)({
                searchParams: {
                    query: (0, $4wMKp.PredefinedQueries).MY_SNOOZED_ALERTS,
                    limit: 3
                }
            });
        },
        isBrowserOnly: true,
        depends: depends
    });
const $a9a9236debbf4a7e$export$fb6d91a24bfaa074 = $a9a9236debbf4a7e$export$e5eb8aade1d4272a();
const $a9a9236debbf4a7e$export$3917a9639b1be557 = $a9a9236debbf4a7e$export$66760ff81022525f();
const $a9a9236debbf4a7e$export$f62d237df457042d = $a9a9236debbf4a7e$export$73c7fe1d8124595f();
const $a9a9236debbf4a7e$export$bce3244764eac6e6 = [
    (callback, depends)=>$a9a9236debbf4a7e$export$e5eb8aade1d4272a(callback, depends),
    (callback, depends)=>$a9a9236debbf4a7e$export$66760ff81022525f(callback, depends),
    (callback, depends)=>$a9a9236debbf4a7e$export$73c7fe1d8124595f(callback, depends)
];

});
parcelRegister("4wMKp", function(module, exports) {

$parcel$export(module.exports, "ALERTS_STORE_NAME", () => $53bef7e86dc9eace$export$6793992c0b67d9c9);
$parcel$export(module.exports, "PredefinedQueries", () => $53bef7e86dc9eace$export$ed6721f2880ce367);
$parcel$export(module.exports, "initialState", () => $53bef7e86dc9eace$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "baseState", () => $53bef7e86dc9eace$export$a2290b0841306a43);
$parcel$export(module.exports, "GLOBAL_ALERTS_ROUTE_NAME", () => $53bef7e86dc9eace$export$ba93b3de87c980dc);
$parcel$export(module.exports, "GLOBAL_ALERT_DETAIL_ROUTE_NAME", () => $53bef7e86dc9eace$export$1881423041ad1b5c);
const $53bef7e86dc9eace$export$6793992c0b67d9c9 = 'navigation-alerts-store';
const $53bef7e86dc9eace$var$ONLY_MY_SELECTOR_QUERY = '(acknowledgedBy: me OR owner: me OR responders: me)';
const $53bef7e86dc9eace$export$ed6721f2880ce367 = {
    MY_OPEN_ALERTS: `status: open AND acknowledged: false AND snoozed: false AND ${$53bef7e86dc9eace$var$ONLY_MY_SELECTOR_QUERY}`,
    MY_ACKED_ALERTS: `status: open AND acknowledged: true AND ${$53bef7e86dc9eace$var$ONLY_MY_SELECTOR_QUERY}`,
    MY_SNOOZED_ALERTS: `status: open AND acknowledged: false AND snoozed: true AND ${$53bef7e86dc9eace$var$ONLY_MY_SELECTOR_QUERY}`
};
const $53bef7e86dc9eace$export$d4c72bab9d6cc13a = {};
const $53bef7e86dc9eace$export$a2290b0841306a43 = {
    items: null,
    isFetching: false,
    fetchError: null,
    hasFetchedOnce: false,
    hasSuccessOnce: false,
    totalCount: 0
};
const $53bef7e86dc9eace$export$ba93b3de87c980dc = 'eoc-global-alerts';
const $53bef7e86dc9eace$export$1881423041ad1b5c = 'eoc-global-alert-detail';

});

parcelRegister("ddwld", function(module, exports) {

$parcel$export(module.exports, "fetchAlerts", () => $dc9d47a55900ee18$export$f7b1e2075b3da718);

var $j74qU = parcelRequire("j74qU");
const $dc9d47a55900ee18$export$f7b1e2075b3da718 = async ({ searchParams: searchParams })=>{
    const params = new URLSearchParams(searchParams ?? {});
    return (0, $j74qU.eocFetch)(`/v1/alerts/?${params.toString()}`);
};

});


parcelRegister("l9RBL", function(module, exports) {

$parcel$export(module.exports, "jiraHomePageRightSidePanelResource", () => $eed57b2562d325e4$export$9cba342d9ec5384d);

var $ao2h1 = parcelRequire("ao2h1");

var $a4BhB = parcelRequire("a4BhB");

var $jKXj9 = parcelRequire("jKXj9");
const $eed57b2562d325e4$var$isBroadcastWidgetEnabled = ()=>false;
const $eed57b2562d325e4$export$9cba342d9ec5384d = (0, $ao2h1.createRelayResource)({
    type: (0, $jKXj9.JIRA_HOME_PAGE_RIGHT_SIDE_PANEL),
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $a4BhB.default),
            variables: {
                cloudId: tenantContext.cloudId,
                broadcastWidgetEnabled: $eed57b2562d325e4$var$isBroadcastWidgetEnabled()
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("a4BhB", function(module, exports) {

$parcel$export(module.exports, "default", () => $616ef8e6ff77d43c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3d73a7099a9295c02951eb57579b7d93>>
 * @relayHash a7e48eaea1f1087c0622f1648327271d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d1e74aae483d14f57577f9505f3c4efaab555f7aa6ddfb379804496ec3f405f1
const $616ef8e6ff77d43c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "broadcastWidgetEnabled"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_rightSidePanel_RootQuery",
            "selections": [
                {
                    "condition": "broadcastWidgetEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "main_homeBroadcastWidget_Widget"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "main_rightSidePanel_RootQuery",
            "selections": [
                {
                    "condition": "broadcastWidgetEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudId",
                                            "variableName": "cloudId"
                                        }
                                    ],
                                    "concreteType": "JiraUserBroadcastMessageConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraUserBroadcastMessages",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraUserBroadcastMessageEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraUserBroadcastMessage",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "shouldDisplay"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d1e74aae483d14f57577f9505f3c4efaab555f7aa6ddfb379804496ec3f405f1",
            "metadata": {},
            "name": "main_rightSidePanel_RootQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$616ef8e6ff77d43c$var$node.hash = "174d1e9e3edb60b5684e0806b3d7342e";
var $616ef8e6ff77d43c$export$2e2bcd8739ae039 = $616ef8e6ff77d43c$var$node;

});

parcelRegister("jKXj9", function(module, exports) {

$parcel$export(module.exports, "RIGHT_PANEL_WIDTH", () => $64d3bec226f7ff92$export$750459958906793);
$parcel$export(module.exports, "RIGHT_SIDE_PANEL_EXPERIENCE", () => $64d3bec226f7ff92$export$2eb41e47cfa429b7);
$parcel$export(module.exports, "JIRA_HOME_PAGE_RIGHT_SIDE_PANEL", () => $64d3bec226f7ff92$export$6c783d91630ece21);

var $gwIPs = parcelRequire("gwIPs");
const $64d3bec226f7ff92$export$750459958906793 = (0, $gwIPs.gridSize) * 49;
const $64d3bec226f7ff92$export$2eb41e47cfa429b7 = {
    experience: 'jiraHomeRightSidePanel',
    experienceId: undefined,
    analyticsSource: 'jira-home'
};
const $64d3bec226f7ff92$export$6c783d91630ece21 = 'JIRA_HOME_PAGE_RIGHT_SIDE_PANEL';

});


parcelRegister("aILzD", function(module, exports) {

$parcel$export(module.exports, "jiraHomeResourceWithCache", () => $9f71890db935ba06$export$1da15dc2d924240c);

var $2M1hQ = parcelRequire("2M1hQ");


const $9f71890db935ba06$export$1da15dc2d924240c = (0, $2M1hQ.createResource)({
    type: (0, $dac9c443ac5dd9ad$export$e79da7e0d9d1c1f2),
    getKey: ()=>'jira-home',
    getDataLoader: ()=>(parcelRequire("2oLex")),
    maxAge: Infinity
});

});
const $dac9c443ac5dd9ad$export$e79da7e0d9d1c1f2 = 'JIRA_HOME';

parcelRegister("2oLex", function(module, exports) {

let $1bf2763e367ce5ff$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1bf2763e367ce5ff$var$load("xbbNO").then(()=>parcelRequire('fvAUD'));

});


parcelRegister("gSttA", function(module, exports) {

$parcel$export(module.exports, "jiraHomeWorkSuggestionsIsDeveloperResource", () => $bbd3e0c5dee753c9$export$420b5969a526b86f);

var $ao2h1 = parcelRequire("ao2h1");

var $i7jMq = parcelRequire("i7jMq");

var $ef5Xn = parcelRequire("ef5Xn");

var $4Pf62 = parcelRequire("4Pf62");
const $bbd3e0c5dee753c9$export$420b5969a526b86f = (0, $ao2h1.createRelayResource)({
    type: 'JIRA_HOME_WORK_SUGGESTIONS_IS_DEVELOPER',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $i7jMq.default),
            variables: {
                cloudId: tenantContext.cloudId,
                isSoftwareLicensed: tenantContext.licensedProducts[(0, $4Pf62.LICENSED_PRODUCTS).JIRA_SOFTWARE] && tenantContext.licenseStates?.software === (0, $ef5Xn.LICENSE_STATE_ACTIVE)
            }
        })
});

});
parcelRegister("i7jMq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1a456774fd54599$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9af3482c29caafe3c266b9a94e6bf614>>
 * @relayHash 33a398085fffc1c8c240023b01b17ecb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6531092ed29d33046fe36572f33533c333d5d1c7642ce67bd8f17687b4e69ba1
const $a1a456774fd54599$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isSoftwareLicensed"
        }
    ], v1 = [
        {
            "condition": "isSoftwareLicensed",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "concreteType": "WorkSuggestions",
                    "kind": "LinkedField",
                    "name": "workSuggestions",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "concreteType": "WorkSuggestionsUserProfile",
                            "kind": "LinkedField",
                            "name": "userProfileByCloudId",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "persona"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "JiraHomeWithWorkSuggestionsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "JiraHomeWithWorkSuggestionsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "6531092ed29d33046fe36572f33533c333d5d1c7642ce67bd8f17687b4e69ba1",
            "metadata": {},
            "name": "JiraHomeWithWorkSuggestionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a1a456774fd54599$var$node.hash = "2ffc84c440c4cba253c916b64a96af89";
var $a1a456774fd54599$export$2e2bcd8739ae039 = $a1a456774fd54599$var$node;

});


parcelRegister("7mjY3", function(module, exports) {

$parcel$export(module.exports, "YourWorkSkeleton", () => $305c0c711ea600ba$export$62cf62fa23284b71);
$parcel$export(module.exports, "YourWorkItemListSkeleton", () => $305c0c711ea600ba$export$31cebe1052db844);

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $l3Kuc = parcelRequire("l3Kuc");

var $dnZyp = parcelRequire("dnZyp");
const $305c0c711ea600ba$export$62cf62fa23284b71 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($l3Kuc)))
    });
const $305c0c711ea600ba$export$31cebe1052db844 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dnZyp))),
        containerStyles: {
            maxHeight: '30em'
        }
    });

});
parcelRegister("l3Kuc", function(module, exports) {
module.exports = new URL("your-work-app-skeleton.tpl.14d150b5.svg", import.meta.url).toString();

});

parcelRegister("dnZyp", function(module, exports) {
module.exports = new URL("your-work-itemlist-skeleton.tpl.e9027f83.svg", import.meta.url).toString();

});


parcelRegister("94zvX", function(module, exports) {

let $69b009392e82b6d0$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $69b009392e82b6d0$var$load("ffQaD"),
    $69b009392e82b6d0$var$load("kvRbA"),
    $69b009392e82b6d0$var$load("bEf6f")
]).then(()=>parcelRequire('jyj7M'));

});


parcelRegister("c2KPY", function(module, exports) {

$parcel$export(module.exports, "jiraSearchRouteEntry", () => $06085f80d69fe841$export$76b74d5744e69817);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $cg1lV = parcelRequire("cg1lV");

var $7kiuE = parcelRequire("7kiuE");

var $5ZrME = parcelRequire("5ZrME");
const $06085f80d69fe841$export$76b74d5744e69817 = (0, $7NszV.createEntry)((0, $cg1lV.jiraSearchRoute), ()=>({
        group: 'redirects',
        component: (0, $7kiuE.JiraSearchRedirect),
        isRedirect: true,
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $5ZrME.jiraSearchResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("cg1lV", function(module, exports) {

$parcel$export(module.exports, "jiraSearchRoute", () => $e3d75d351326e47a$export$a3a93dcf611b611a);
const $e3d75d351326e47a$export$a3a93dcf611b611a = {
    name: 'jira-search',
    path: '/jira/search',
    exact: true
};

});

parcelRegister("7kiuE", function(module, exports) {

$parcel$export(module.exports, "JiraSearchRedirect", () => $c1df58920245e964$export$ee180957879b33ac);

var $5uXOq = parcelRequire("5uXOq");

var $lb0Dk = parcelRequire("lb0Dk");

var $7tQej = parcelRequire("7tQej");
var $2YP9W = parcelRequire("2YP9W");

var $lFlWg = parcelRequire("lFlWg");

var $5ZrME = parcelRequire("5ZrME");
const $c1df58920245e964$export$ee180957879b33ac = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)((0, $5ZrME.jiraSearchResource));
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lb0Dk.IssueViewSkeleton), null);
    if (error || !data?.url) // handle api error state
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lFlWg.QuickSearchToGlobalIssueNavigatorRedirect), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: data.url,
        push: false
    });
};

});
parcelRegister("lFlWg", function(module, exports) {

$parcel$export(module.exports, "QuickSearchToGlobalIssueNavigatorRedirect", () => $2bd6861b4d276506$export$968c2900ae111000);

var $5uXOq = parcelRequire("5uXOq");

var $6jY6G = parcelRequire("6jY6G");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $bATyw = parcelRequire("bATyw");

var $7tQej = parcelRequire("7tQej");
var $ieDtd = parcelRequire("ieDtd");
var $2YP9W = parcelRequire("2YP9W");
const $2bd6861b4d276506$export$968c2900ae111000 = ({ Redirect: Redirect = (0, $7tQej.Redirect), fireScreenAnalytics: fireScreenAnalytics = (0, $8zOmE.fireScreenAnalytics), useAnalyticsEvents: useAnalyticsEvents = (0, $2NMNM.useAnalyticsEvents), useCurrentRoute: useCurrentRoute = (0, $6jY6G.useCurrentRoute), useQueryParam: useQueryParam = (0, $ieDtd.useQueryParam) })=>{
    const route = useCurrentRoute();
    const [searchString] = useQueryParam('searchString');
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const { data: isNinEnabled } = (0, $2YP9W.useResource)((0, $bATyw.isNinGlobalScopeEnrolmentEnabledResource));
    (0, $5uXOq.useEffect)(()=>{
        if (!route) return;
        const screenEvent = createAnalyticsEvent({
            screenName: 'quickSearchRedirect',
            attributes: {
                type: route.name
            }
        });
        fireScreenAnalytics(screenEvent);
    }, [
        createAnalyticsEvent,
        fireScreenAnalytics,
        route
    ]);
    let jql;
    if (isNinEnabled) jql = searchString != null ? `textfields ~ "${searchString}"` : 'ORDER BY created DESC';
    else jql = searchString != null ? `text ~ "${searchString}"` : 'order by created DESC';
    const redirectUrl = `/issues/?jql=${encodeURIComponent(jql)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Redirect, {
        to: redirectUrl
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2bd6861b4d276506$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2bd6861b4d276506$export$968c2900ae111000, null);

});

parcelRegister("5ZrME", function(module, exports) {

$parcel$export(module.exports, "jiraSearchResource", () => $c763bb61845622fe$export$d23832be0ebf8a93);

var $ebyGx = parcelRequire("ebyGx");

var $7f4tk = parcelRequire("7f4tk");

var $2M1hQ = parcelRequire("2M1hQ");
const $c763bb61845622fe$export$486bd66a4d919be7 = 'RESOURCE_TYPE_JIRA_SEARCH';
const $c763bb61845622fe$export$d23832be0ebf8a93 = (0, $2M1hQ.createResource)({
    type: $c763bb61845622fe$export$486bd66a4d919be7,
    getKey: ()=>'search',
    getData: ({ query: query }, { tenantContext: tenantContext })=>{
        const { atlassianAccountId: atlassianAccountId } = tenantContext;
        if (!atlassianAccountId || !query?.searchString) return null;
        const queryStr = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
            searchString: query.searchString
        });
        return (0, $7f4tk.default)(`/rest/navigation/4/quicksearch?${queryStr}`);
    },
    isBrowserOnly: true
});

});



parcelRegister("ghGCX", function(module, exports) {

$parcel$export(module.exports, "legacyRedirectRouteEntry", () => $c46fefae40525649$export$27f123cb9320355);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $7v7WP = parcelRequire("7v7WP");

var $3mK2k = parcelRequire("3mK2k");
// @ts-expect-error - Type '{}' is missing the following properties from type 'Pick<Omit<Omit<RouteContext & { flagService: FlagService; createAnalyticsEvent: (arg1: { action: string; }) => UIAnalyticsEvent; }, keyof WithAnalyticsEventsProps> & RefAttributes<...>, "flagService">, keyof RouteContext | keyof RefAttributes<...>>': query, location, route, match, action
const $c46fefae40525649$var$RedirectComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3mK2k.default), null);
const $c46fefae40525649$export$27f123cb9320355 = (0, $7NszV.createEntry)((0, $7v7WP.legacyRedirectRoute), ()=>({
        component: $c46fefae40525649$var$RedirectComponent,
        layout: (0, $2BrOV.globalLayout),
        resources: [],
        isRedirect: true,
        canTransitionIn: ()=>false,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("7v7WP", function(module, exports) {

$parcel$export(module.exports, "legacyRedirectRoute", () => $5ce80937ea4d4231$export$176ff76c3ba7c4ce);
const $5ce80937ea4d4231$export$176ff76c3ba7c4ce = {
    path: '',
    name: 'legacy-redirect',
    exact: false
};

});


parcelRegister("7MpwB", function(module, exports) {

$parcel$export(module.exports, "loginEmbedRouteEntry", () => $cd382e3a47206865$export$faa46f8c5e1f06d3);

var $5uXOq = parcelRequire("5uXOq");

var $6e4Kt = parcelRequire("6e4Kt");

var $7NszV = parcelRequire("7NszV");

var $hA0Yo = parcelRequire("hA0Yo");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $cd382e3a47206865$var$LazyLoginEmbed = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("87y4U")), {
    moduleId: "./src/packages/spa-apps/login-embed/src/index.tsx"
});
const $cd382e3a47206865$var$LoginEmbed = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cd382e3a47206865$var$LazyLoginEmbed,
        pageId: "spa-apps/login-embed",
        shouldShowSpinner: true
    });
const $cd382e3a47206865$export$faa46f8c5e1f06d3 = (0, $7NszV.createEntry)((0, $hA0Yo.loginEmbedRoute), ()=>({
        group: 'errors',
        component: $cd382e3a47206865$var$LoginEmbed,
        layout: (0, $6e4Kt.chromelessLayout)
    }));

});
parcelRegister("hA0Yo", function(module, exports) {

$parcel$export(module.exports, "loginEmbedRoute", () => $288f4f9c77816594$export$9efae7a8e8e69866);
const $288f4f9c77816594$export$9efae7a8e8e69866 = {
    name: 'login-embed',
    path: '/jira-login/embed'
};

});

parcelRegister("87y4U", function(module, exports) {

let $5e99696055545d45$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5e99696055545d45$var$load("96g6X").then(()=>parcelRequire('8LbPV'));

});


parcelRegister("lLZ8x", function(module, exports) {

$parcel$export(module.exports, "appRequestsRouteEntry", () => $3506fc2f26a58302$export$423a1c80bb2f8b9a);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $iHiHz = parcelRequire("iHiHz");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $dCM35 = parcelRequire("dCM35");

var $10giJ = parcelRequire("10giJ");
const $3506fc2f26a58302$export$423a1c80bb2f8b9a = (0, $7NszV.createEntry)((0, $dCM35.appRequestsRoute), ()=>({
        group: 'marketplace',
        component: (0, $10giJ.MarketplaceComponent),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).ADDONS,
            sidebar: (0, $iHiHz.default)
        },
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $5bkvv.getNavigationSidebarGlobalSettingsResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $10giJ.LazyMarketplace)
        ],
        ufoName: 'embedded-marketplace'
    }));

});
parcelRegister("dCM35", function(module, exports) {

$parcel$export(module.exports, "appRequestsRoute", () => $03b80971c24766dc$export$df12e2a94e0a971b);
const $03b80971c24766dc$export$df12e2a94e0a971b = {
    name: 'marketplace-app-requests',
    path: '/jira/marketplace/manage/app-requests'
};

});

parcelRegister("10giJ", function(module, exports) {

$parcel$export(module.exports, "LazyMarketplace", () => $32349631214f0add$export$5919da4c9ee4707e);
$parcel$export(module.exports, "MarketplaceComponent", () => $32349631214f0add$export$f0d733b7012e9031);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $32349631214f0add$export$5919da4c9ee4707e = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("5fcnQ"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/marketplace/src/index.tsx"
});
const $32349631214f0add$export$f0d733b7012e9031 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $32349631214f0add$export$5919da4c9ee4707e,
        pageId: "marketplace",
        shouldShowSpinner: true
    });

});
parcelRegister("5fcnQ", function(module, exports) {

let $3d17f59809faeaa0$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $3d17f59809faeaa0$var$load("ffQaD"),
    $3d17f59809faeaa0$var$load("kvRbA"),
    $3d17f59809faeaa0$var$load("75upj")
]).then(()=>parcelRequire('lA7ML'));

});



parcelRegister("g5rwu", function(module, exports) {

$parcel$export(module.exports, "findAppsRouteEntry", () => $202f2f6ea16fcbde$export$422f564c9c56a4f8);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $iHiHz = parcelRequire("iHiHz");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $8Lquf = parcelRequire("8Lquf");

var $10giJ = parcelRequire("10giJ");
const $202f2f6ea16fcbde$export$422f564c9c56a4f8 = (0, $7NszV.createEntry)((0, $8Lquf.findAppsRoute), ()=>({
        group: 'marketplace',
        component: (0, $10giJ.MarketplaceComponent),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).ADDONS,
            sidebar: (0, $iHiHz.default)
        },
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $5bkvv.getNavigationSidebarGlobalSettingsResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $10giJ.LazyMarketplace)
        ],
        ufoName: 'embedded-marketplace'
    }));

});
parcelRegister("8Lquf", function(module, exports) {

$parcel$export(module.exports, "findAppsRoute", () => $a326557081fe34cb$export$e264ef643451c60a);
const $a326557081fe34cb$export$e264ef643451c60a = {
    name: 'marketplace-index',
    path: '/jira/marketplace'
};

});


parcelRegister("1XAMa", function(module, exports) {

$parcel$export(module.exports, "promotionsRouteEntry", () => $2e7db6c4b913404f$export$875d88a44b1ff74c);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $iHiHz = parcelRequire("iHiHz");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $jcvAd = parcelRequire("jcvAd");

var $10giJ = parcelRequire("10giJ");
const $2e7db6c4b913404f$export$875d88a44b1ff74c = (0, $7NszV.createEntry)((0, $jcvAd.promotionsRoute), ()=>({
        group: 'marketplace',
        component: (0, $10giJ.MarketplaceComponent),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).ADDONS,
            sidebar: (0, $iHiHz.default)
        },
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $5bkvv.getNavigationSidebarGlobalSettingsResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $10giJ.LazyMarketplace)
        ],
        ufoName: 'embedded-marketplace'
    }));

});
parcelRegister("jcvAd", function(module, exports) {

$parcel$export(module.exports, "promotionsRoute", () => $bc8d892f5d9c1f9e$export$45df65bfacbf9a2a);
const $bc8d892f5d9c1f9e$export$45df65bfacbf9a2a = {
    name: 'marketplace-promotions',
    path: '/jira/marketplace/manage/promotions'
};

});


parcelRegister("1kSIj", function(module, exports) {

$parcel$export(module.exports, "softwareCodeRouteEntry", () => $0271d7bff18c22c8$export$eac18b7aea4cb524);

var $ffza4 = parcelRequire("ffza4");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $iZ82x = parcelRequire("iZ82x");

var $7GnDe = parcelRequire("7GnDe");

var $5lsNZ = parcelRequire("5lsNZ");

var $lzTbm = parcelRequire("lzTbm");

var $kfztd = parcelRequire("kfztd");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $4R6GH = parcelRequire("4R6GH");

var $6LsQE = parcelRequire("6LsQE");

var $dOE01 = parcelRequire("dOE01");

var $cD5C5 = parcelRequire("cD5C5");
const $0271d7bff18c22c8$var$getHorizontalNavResource = ()=>(0, $4R6GH.fg)('entrypoint_migration_for_software_code') ? [] : [
        (0, $7uLIV.horizontalNavJiraResource)
    ];
const $0271d7bff18c22c8$export$eac18b7aea4cb524 = (0, $7NszV.createEntry)((0, $lzTbm.softwareCodeRoute), ()=>({
        group: 'software',
        component: (0, $7XYc4.componentWithCondition)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $dOE01.CodePageNextGen)),
        layout: (0, $e7bC3.softwareProjectLayoutCode),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            ...$0271d7bff18c22c8$var$getHorizontalNavResource(),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $iZ82x.codePageResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $dOE01.LazyCode)
        ],
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('entrypoint_migration_for_software_code')) return (0, $kfztd.isDevopsFeatureDisabledInFedRamp)() ? (0, $6LsQE.notFoundPageEntrypoint) : (0, $cD5C5.softwareCodeNextGenPageEntrypoint);
            return undefined;
        },
        ufoName: 'next-gen-code'
    }));

});
parcelRegister("7uLIV", function(module, exports) {

$parcel$export(module.exports, "horizontalNavJiraResource", () => $1769860a1d0fe224$export$faeb8c89315e20da);

var $ao2h1 = parcelRequire("ao2h1");

var $ivm9B = parcelRequire("ivm9B");

var $kV9ss = parcelRequire("kV9ss");

var $1nb22 = parcelRequire("1nb22");

var $3HwlS = parcelRequire("3HwlS");

var $ktofH = parcelRequire("ktofH");

var $gNStA = parcelRequire("gNStA");

var $6YG83 = parcelRequire("6YG83");
const $1769860a1d0fe224$export$71eec30d9db46a56 = ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
    const boardId = match.params.boardId;
    let { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    projectKey = projectKey ?? '';
    projectId = projectId ?? '';
    const projectIdOrKey = projectId || projectKey;
    const isTMPBoardRoute = boardId ? match.url.includes('/software/projects/') : false;
    const boardAri = boardId ? `ari:cloud:jira-software:${cloudId}:board/${boardId}` : '';
    const projectAri = projectId ? (0, $kV9ss.JiraProjectAri).create({
        siteId: cloudId,
        projectId: projectId
    }).toString() : '';
    let containerNavigationInput;
    if (isTMPBoardRoute) containerNavigationInput = projectAri ? {
        scopeId: boardAri
    } : {
        projectKeyQuery: {
            cloudId: cloudId,
            projectKey: projectKey
        }
    };
    else containerNavigationInput = boardAri || projectAri ? {
        scopeId: boardAri || projectAri
    } : {
        projectKeyQuery: {
            cloudId: cloudId,
            projectKey: projectKey
        }
    };
    return {
        options: {
            fetchPolicy: 'store-and-network'
        },
        parameters: (0, $ivm9B.default),
        variables: {
            cloudId: cloudId,
            projectIdOrKey: projectIdOrKey,
            withProject: Boolean(projectIdOrKey),
            boardId: boardAri,
            withBoard: Boolean(boardAri),
            containerNavigationInput: containerNavigationInput,
            isTMPBoardRoute: isTMPBoardRoute,
            first: (0, $ktofH.NAVIGATION_ITEMS_PAGE_SIZE)
        }
    };
};
const $1769860a1d0fe224$var$horizontalNavJiraResourceActual = (0, $6YG83.withGiraAggAnonSsrFix)((0, $ao2h1.createRelayResource)({
    type: 'HORIZONTAL_NAVIGATION_JIRA_QUERY',
    getQuery: $1769860a1d0fe224$export$71eec30d9db46a56
}));
const $1769860a1d0fe224$export$faeb8c89315e20da = (0, $gNStA.resourceWithCondition2)(()=>(0, $3HwlS.getWillShowNav4)(), $1769860a1d0fe224$var$horizontalNavJiraResourceActual);

});
parcelRegister("ivm9B", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e7cee9907baeab7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c4d8d8c026c136fa9ab0ad3ab3d08284>>
 * @relayHash 4319343e2b2a12f2cc6a6eebd766613c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6821c9bddb2120bb80e0d9c544583b48888446dacdacf3040322204379ee9c0a

var $58v9Y = parcelRequire("58v9Y");

var $i536Z = parcelRequire("i536Z");

var $9pmwJ = parcelRequire("9pmwJ");

var $eiowN = parcelRequire("eiowN");
const $5e7cee9907baeab7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerNavigationInput"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTMPBoardRoute"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIdOrKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "withBoard"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "withProject"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "url"
    }, v11 = {
        "kind": "ScalarField",
        "name": "label"
    }, v12 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v13 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v14 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v15 = [
        {
            "kind": "ScalarField",
            "name": "message"
        },
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v8 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                }
            ]
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            v9 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v18 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v19 = {
        "kind": "ScalarField",
        "name": "boardId"
    }, v20 = {
        "kind": "ScalarField",
        "name": "name"
    }, v21 = {
        "kind": "ScalarField",
        "name": "boardType"
    }, v22 = {
        "concreteType": "JiraFavouriteValue",
        "kind": "LinkedField",
        "name": "favouriteValue",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isFavourite"
            },
            v9 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "HorizontalNavJiraInnerQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "JiraHorizontalNavigationContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v7 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "HorizontalNavJiraInnerQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "input",
                                    "variableName": "containerNavigationInput"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "containerNavigation",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraContainerNavigationResult"
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopeId"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "first",
                                                    "variableName": "first"
                                                }
                                            ],
                                            "concreteType": "JiraNavigationItemConnection",
                                            "kind": "LinkedField",
                                            "name": "navigationItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraNavigationItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isDefault"
                                                                },
                                                                v10 /*: any*/ ,
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "typeKey"
                                                                },
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "kind": "TypeDiscriminator",
                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canRename"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canRemove"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canSetAsDefault"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "appId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraAppSection",
                                                                            "kind": "LinkedField",
                                                                            "name": "sections",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "links",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v10 /*: any*/ ,
                                                                                        v11 /*: any*/ ,
                                                                                        v12 /*: any*/ ,
                                                                                        v13 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v11 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v12 /*: any*/ ,
                                                                        v13 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "envLabel"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v14 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraNavigationItem",
                                                                            "abstractKey": "__isJiraNavigationItem"
                                                                        }
                                                                    ],
                                                                    "type": "JiraAppNavigationItem"
                                                                },
                                                                v14 /*: any*/ 
                                                            ]
                                                        },
                                                        v8 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "errors",
                                                    "plural": true,
                                                    "selections": v15 /*: any*/ 
                                                }
                                            ]
                                        },
                                        v16 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopeUrl"
                                        }
                                    ],
                                    "type": "JiraContainerNavigation"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v15 /*: any*/ ,
                                    "type": "QueryError"
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                v18 /*: any*/ 
                            ],
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        },
                        {
                            "condition": "withBoard",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "hasWithBoard",
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "boardId"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "jiraBoard",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v19 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v22 /*: any*/ ,
                                                v14 /*: any*/ 
                                            ],
                                            "type": "JiraBoard"
                                        },
                                        v17 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "withProject",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v18 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "idOrKey",
                                    "variableName": "projectIdOrKey"
                                }
                            ],
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jira_projectByIdOrKey",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "large"
                                        }
                                    ]
                                },
                                {
                                    "alias": "canEditProjectConfig",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "EDIT_PROJECT_CONFIG"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "canPerform"
                                        }
                                    ],
                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                },
                                v20 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectStyle"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "softwareBoardCount"
                                },
                                v9 /*: any*/ ,
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphStoreSimplifiedTeamConnectedToContainerInverseConnection",
                                                    "kind": "LinkedField",
                                                    "name": "teamsConnected",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "totalCount"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "isTMPBoardRoute",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "alias": "projectKey",
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "mostRecentlyViewedBoard",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v14 /*: any*/ 
                                                    ],
                                                    "type": "JiraBoard"
                                                },
                                                v17 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isLiveTemplate"
                                        }
                                    ]
                                },
                                v14 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6821c9bddb2120bb80e0d9c544583b48888446dacdacf3040322204379ee9c0a",
            "metadata": {},
            "name": "HorizontalNavJiraInnerQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider": (0, $58v9Y.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider": (0, $9pmwJ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider": (0, $i536Z.default)
            }
        }
    };
}();
$5e7cee9907baeab7$var$node.hash = "cfedd5347d81ca2f36fa810c25c638f4";
(0, $eiowN.PreloadableQueryRegistry).set($5e7cee9907baeab7$var$node.params.id, $5e7cee9907baeab7$var$node);
var $5e7cee9907baeab7$export$2e2bcd8739ae039 = $5e7cee9907baeab7$var$node;

});


parcelRegister("iZ82x", function(module, exports) {

$parcel$export(module.exports, "codePageResource", () => $06e9ff5230710b90$export$642ce64cf3689406);

var $ao2h1 = parcelRequire("ao2h1");

var $euUUL = parcelRequire("euUUL");

var $6mT2K = parcelRequire("6mT2K");

let $06e9ff5230710b90$var$numPullRequestsToFetch = 0;
const $06e9ff5230710b90$export$642ce64cf3689406 = (0, $ao2h1.createRelayResource)({
    type: (0, $96625f88cf395132$export$94a43d2ac55ac375),
    getQuery ({ match: { params: params }, query: query, route: { name: name } }, { tenantContext: { cloudId: cloudId } }) {
        const isCodeRoute = name === 'software-code' || name === 'software-code-classic';
        // Set numPullRequestsToFetch on initial call only and not on every query param change
        if (!$06e9ff5230710b90$var$numPullRequestsToFetch && isCodeRoute) $06e9ff5230710b90$var$numPullRequestsToFetch = (0, $6mT2K.getNumPullRequestsToFetch)(query);
        // Reset numPullRequestsToFetch when navigating away from the code page
        if (!isCodeRoute) $06e9ff5230710b90$var$numPullRequestsToFetch = 0;
        return {
            parameters: (0, $euUUL.default),
            options: {
                fetchPolicy: 'store-and-network'
            },
            variables: {
                cloudId: cloudId,
                projectKey: params.projectKey ?? '',
                pullRequestsUpdatedFrom: (0, $6mT2K.getPullRequestsUpdatedFromDate)(),
                numPullRequestsToFetch: $06e9ff5230710b90$var$numPullRequestsToFetch,
                siteAri: `ari:cloud:jira::site/${cloudId}`
            }
        };
    }
});

});
parcelRegister("euUUL", function(module, exports) {

$parcel$export(module.exports, "default", () => $1914e75096664626$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9e4d6b6379280bbf391f7e2d315a8c2a>>
 * @relayHash 389fdeea048c66525e3cec717b045093
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 065a174c5747d32e4ac04da08516b772ae16f6995b07756d19cd3af74fa4c4bb
const $1914e75096664626$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "numPullRequestsToFetch"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pullRequestsUpdatedFrom"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "siteAri"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "siteAri"
        },
        {
            "kind": "Literal",
            "name": "providerTypes",
            "value": [
                "DEV_INFO"
            ]
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v9 = [
        v8 /*: any*/ 
    ], v10 = {
        "kind": "ScalarField",
        "name": "status"
    }, v11 = {
        "concreteType": "JiraConfigStateConnection",
        "kind": "LinkedField",
        "name": "config",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraConfigState",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "appId"
                    },
                    v10 /*: any*/ 
                ]
            }
        ]
    }, v12 = [
        v11 /*: any*/ 
    ], v13 = [
        v7 /*: any*/ 
    ], v14 = [
        {
            "kind": "Literal",
            "name": "appId",
            "value": "bitbucket"
        },
        v8 /*: any*/ 
    ], v15 = [
        v8 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v16 = [
        {
            "kind": "Literal",
            "name": "sort",
            "value": {
                "lastModified": {
                    "direction": "DESC",
                    "priority": 1
                }
            }
        }
    ], v17 = {
        "kind": "ScalarField",
        "name": "id"
    }, v18 = [
        v11 /*: any*/ ,
        v17 /*: any*/ 
    ], v19 = {
        "kind": "ScalarField",
        "name": "lastUpdated"
    }, v20 = {
        "kind": "ScalarField",
        "name": "url"
    }, v21 = [
        v17 /*: any*/ 
    ], v22 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v23 = [
        v7 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "accountId"
        },
        v6 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "picture"
        },
        v17 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainCodeInJiraUpdatedQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "DevOps",
                        "kind": "LinkedField",
                        "name": "devOps",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "DevOpsProviders",
                                    "kind": "LinkedField",
                                    "name": "providers",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "DevOpsDevInfoProvider",
                                            "kind": "LinkedField",
                                            "name": "devInfoProviders",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "args": v9 /*: any*/ ,
                                                    "concreteType": "JiraAppConfigState",
                                                    "kind": "LinkedField",
                                                    "name": "configState",
                                                    "plural": false,
                                                    "selections": v12 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "devOps.providers"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "devOps"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v9 /*: any*/ ,
                        "concreteType": "CodeInJira",
                        "kind": "LinkedField",
                        "name": "codeInJira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "CodeInJiraUserConfiguration",
                                    "kind": "LinkedField",
                                    "name": "userConfiguration",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CodeInJiraBitbucketWorkspace",
                                                "kind": "LinkedField",
                                                "name": "ownedBitbucketWorkspaces",
                                                "plural": true,
                                                "selections": v13 /*: any*/ 
                                            },
                                            "action": "THROW",
                                            "path": "codeInJira.userConfiguration.ownedBitbucketWorkspaces"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "codeInJira.userConfiguration"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "codeInJira"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraDevOpsQuery",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v14 /*: any*/ ,
                                    "concreteType": "JiraAppConfigState",
                                    "kind": "LinkedField",
                                    "name": "configState",
                                    "plural": false,
                                    "selections": v12 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "args": v15 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v16 /*: any*/ ,
                                    "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoConnection",
                                    "kind": "LinkedField",
                                    "name": "repositories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v13 /*: any*/ 
                                        }
                                    ],
                                    "storageKey": "repositories(sort:{\"lastModified\":{\"direction\":\"DESC\",\"priority\":1}})"
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "FragmentSpread",
                    "name": "main_softwareCodePage_MainPage"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "main_softwareCodePage_Header"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "main_softwareCodePage_ConnectionPage"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainCodeInJiraUpdatedQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "DevOpsProviders",
                            "kind": "LinkedField",
                            "name": "providers",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "DevOpsDevInfoProvider",
                                    "kind": "LinkedField",
                                    "name": "devInfoProviders",
                                    "plural": true,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "args": v9 /*: any*/ ,
                                            "concreteType": "JiraAppConfigState",
                                            "kind": "LinkedField",
                                            "name": "configState",
                                            "plural": false,
                                            "selections": v18 /*: any*/ 
                                        },
                                        v17 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "homeUrl"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "namespace"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "CodeInJira",
                    "kind": "LinkedField",
                    "name": "codeInJira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "CodeInJiraUserConfiguration",
                            "kind": "LinkedField",
                            "name": "userConfiguration",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CodeInJiraBitbucketWorkspace",
                                    "kind": "LinkedField",
                                    "name": "ownedBitbucketWorkspaces",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "uuid"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "slug"
                                        },
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraDevOpsQuery",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v14 /*: any*/ ,
                                    "concreteType": "JiraAppConfigState",
                                    "kind": "LinkedField",
                                    "name": "configState",
                                    "plural": false,
                                    "selections": v18 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "args": v15 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v16 /*: any*/ ,
                                    "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoConnection",
                                    "kind": "LinkedField",
                                    "name": "repositories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v17 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "providerId"
                                                                },
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "avatarUrl"
                                                                },
                                                                v20 /*: any*/ 
                                                            ],
                                                            "type": "DevOpsRepository"
                                                        },
                                                        v22 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "repositories(sort:{\"lastModified\":{\"direction\":\"DESC\",\"priority\":1}})"
                                },
                                v17 /*: any*/ ,
                                {
                                    "args": [
                                        {
                                            "fields": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "updatedFrom",
                                                    "variableName": "pullRequestsUpdatedFrom"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "filter"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "first",
                                            "variableName": "numPullRequestsToFetch"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "sort",
                                            "value": {
                                                "lastUpdatedSortDirection": "DESC"
                                            }
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "project-associated-pr"
                                        }
                                    ],
                                    "concreteType": "AriGraphRelationshipConnection",
                                    "kind": "LinkedField",
                                    "name": "devOpsEntityRelationships",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "AriGraphRelationshipEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationship",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationshipNode",
                                                            "kind": "LinkedField",
                                                            "name": "to",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v10 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "repositoryName"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "repositoryId"
                                                                                },
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "author",
                                                                                    "plural": false,
                                                                                    "selections": v23 /*: any*/ 
                                                                                },
                                                                                {
                                                                                    "concreteType": "DevOpsReviewer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "reviewers",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": v23 /*: any*/ 
                                                                                        },
                                                                                        v7 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "approvalStatus"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "userId"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "title"
                                                                                },
                                                                                v17 /*: any*/ ,
                                                                                v19 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "commentCount"
                                                                                },
                                                                                v20 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "DevOpsBranchInfo",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "destinationBranch",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        v20 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "pullRequestInternalId"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "repositoryUrl"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "authorId"
                                                                                }
                                                                            ],
                                                                            "type": "DevOpsPullRequestDetails"
                                                                        },
                                                                        v22 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "DevOpsFeatureFlag"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "DevOpsOperationsComponentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "DevOpsOperationsIncidentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "DevOpsOperationsPostIncidentReviewDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "DevOpsRepository"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "DevOpsSecurityVulnerabilityDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "JiraAutodevJob"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "JiraConfluenceRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "JiraCustomRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "JiraIssueRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v21 /*: any*/ ,
                                                                            "type": "JiraWebRemoteIssueLink"
                                                                        }
                                                                    ]
                                                                },
                                                                v17 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "065a174c5747d32e4ac04da08516b772ae16f6995b07756d19cd3af74fa4c4bb",
            "metadata": {},
            "name": "mainCodeInJiraUpdatedQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1914e75096664626$var$node.hash = "e7b0f6a6904c8a1f0dcd2b6cc16ebe99";
var $1914e75096664626$export$2e2bcd8739ae039 = $1914e75096664626$var$node;

});

parcelRegister("6mT2K", function(module, exports) {

$parcel$export(module.exports, "isBitbucketProvider", () => $e46b745b21c77b2f$export$1f508885be28c4e);
$parcel$export(module.exports, "codeErrorBoundaryAttributes", () => $e46b745b21c77b2f$export$ea10bb8bdf2072e5);
$parcel$export(module.exports, "toSanitizedUrl", () => $e46b745b21c77b2f$export$36fdccbdcd093523);
$parcel$export(module.exports, "useIsOverflowWidth", () => $e46b745b21c77b2f$export$2dcd60313c8d761b);
$parcel$export(module.exports, "getPullRequestsUpdatedFromDate", () => $e46b745b21c77b2f$export$3784bdf6b4807521);
$parcel$export(module.exports, "getNumPullRequestsToFetch", () => $e46b745b21c77b2f$export$a837c7c9c7670570);

var $5uXOq = parcelRequire("5uXOq");

var $5kchp = parcelRequire("5kchp");

var $it1wb = parcelRequire("it1wb");
var $gn1v9 = parcelRequire("gn1v9");

var $eY2eW = parcelRequire("eY2eW");

var $1tSBh = parcelRequire("1tSBh");
const $e46b745b21c77b2f$export$36ebc9cd52c6b517 = (repository)=>repository === (0, $1tSBh.RepositoryTypes).REPO_BITBUCKET;
const $e46b745b21c77b2f$export$1f508885be28c4e = (providerId)=>providerId === (0, $eY2eW.VcsProviderIds).BITBUCKET || providerId === (0, $eY2eW.DataDepotProviderIds).BITBUCKET_PROD || providerId === (0, $eY2eW.DataDepotProviderIds).BITBUCKET_STG;
const $e46b745b21c77b2f$var$shouldCountToReliability = (error)=>{
    const okayErrors = [
        ...(0, $eY2eW.nonCriticalGqlErrors),
        ...(0, $eY2eW.nonReliabilityCriticalErrors)
    ];
    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"HTTP status [403] while retrieving Bitbucket repository." | "HTTP status [404] while retrieving Bitbucket repository." | "Failed to retrieve Bitbucket repository because the user wasn't authorized." | "HTTP status [429] while retrieving Bitbucket repository." | "The user does not have 'View Development Tools' permi...'.
    return !okayErrors.includes(error.message);
};
const $e46b745b21c77b2f$export$ea10bb8bdf2072e5 = (error)=>{
    if (error instanceof Error) return {
        countToReliability: $e46b745b21c77b2f$var$shouldCountToReliability(error)
    };
    return {
        countToReliability: true
    };
};
const $e46b745b21c77b2f$export$36fdccbdcd093523 = (url)=>(0, $5kchp.sanitizeUrl)(url);
const $e46b745b21c77b2f$export$2dcd60313c8d761b = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
ref, callback)=>{
    const [isOverflow, setIsOverflow] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useLayoutEffect)(()=>{
        const { current: current } = ref;
        const trigger = ()=>{
            const hasOverflow = current.scrollWidth > current.clientWidth;
            setIsOverflow(hasOverflow);
            if (callback) callback(hasOverflow);
        };
        if (current) {
            if ('ResizeObserver' in window) new ResizeObserver(trigger).observe(current);
            trigger();
        }
    }, [
        callback,
        ref
    ]);
    return isOverflow;
};
const $e46b745b21c77b2f$export$3784bdf6b4807521 = ()=>(0, $it1wb.default)((0, $gn1v9.default)(new Date(), {
        days: (0, $eY2eW.PULL_REQUESTS_UPDATED_FROM_NUMBER_OF_DAYS)
    })).toISOString();
const $e46b745b21c77b2f$export$a837c7c9c7670570 = (queryParams)=>{
    const hasFilterOrSortQueryParam = Object.entries(queryParams).some(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ([key, value])=>(0, $eY2eW.queryParamsToWatch).includes(key) && value !== '');
    return hasFilterOrSortQueryParam ? (0, $eY2eW.MAX_NUMBER_OF_PULL_REQUESTS_TO_QUERY) : (0, $eY2eW.PULL_REQUESTS_TABLE_PAGE_SIZE);
};

});
parcelRegister("5kchp", function(module, exports) {
'use strict';
var $3e0858899f98084b$var$invalidPrototcolRegex = /^(%20|\s)*(javascript|data)/im;
var $3e0858899f98084b$var$ctrlCharactersRegex = /[^\x20-\x7E]/gmi;
var $3e0858899f98084b$var$urlSchemeRegex = /^([^:]+):/gm;
var $3e0858899f98084b$var$relativeFirstCharacters = [
    '.',
    '/'
];
function $3e0858899f98084b$var$isRelativeUrl(url) {
    return $3e0858899f98084b$var$relativeFirstCharacters.indexOf(url[0]) > -1;
}
function $3e0858899f98084b$var$sanitizeUrl(url) {
    if (!url) return 'about:blank';
    var urlScheme, urlSchemeParseResults;
    var sanitizedUrl = url.replace($3e0858899f98084b$var$ctrlCharactersRegex, '');
    if ($3e0858899f98084b$var$isRelativeUrl(sanitizedUrl)) return sanitizedUrl;
    urlSchemeParseResults = sanitizedUrl.match($3e0858899f98084b$var$urlSchemeRegex);
    if (!urlSchemeParseResults) return 'about:blank';
    urlScheme = urlSchemeParseResults[0];
    if ($3e0858899f98084b$var$invalidPrototcolRegex.test(urlScheme)) return 'about:blank';
    return sanitizedUrl;
}
module.exports = {
    sanitizeUrl: $3e0858899f98084b$var$sanitizeUrl
};

});

parcelRegister("eY2eW", function(module, exports) {

$parcel$export(module.exports, "nonCriticalGqlErrors", () => $a2f3556545768e94$export$4b1abe4db5ed7515);
$parcel$export(module.exports, "nonReliabilityCriticalErrors", () => $a2f3556545768e94$export$687544614e0812da);
$parcel$export(module.exports, "MAX_NUMBER_OF_PULL_REQUESTS_TO_QUERY", () => $a2f3556545768e94$export$f84c6b6609a3dd30);
$parcel$export(module.exports, "PULL_REQUESTS_TABLE_PAGE_SIZE", () => $a2f3556545768e94$export$ea15b38f3901f518);
$parcel$export(module.exports, "PULL_REQUESTS_UPDATED_FROM_NUMBER_OF_DAYS", () => $a2f3556545768e94$export$2b8b0a4489f9147b);
$parcel$export(module.exports, "COLLAPSIBLE_REGION_ID", () => $a2f3556545768e94$export$3b8f88133d28aaa6);
$parcel$export(module.exports, "REPOSITORIES_HEADER_ID", () => $a2f3556545768e94$export$256a9f141103f328);
$parcel$export(module.exports, "COLLAPSIBLE_REGION_DESCRIPTION_ID", () => $a2f3556545768e94$export$b0d4e90e40369b80);
$parcel$export(module.exports, "featureIdToHelpMap", () => $a2f3556545768e94$export$1de4eaccc23a8747);
$parcel$export(module.exports, "FILTER_CONTAINER_TEST_ID", () => $a2f3556545768e94$export$5c00a6bedc2037c8);
$parcel$export(module.exports, "NO_RESULTS_CLEAR_FILTERS_BUTTON_TEST_ID", () => $a2f3556545768e94$export$f70ce14ba902adcb);
$parcel$export(module.exports, "PULL_REQUESTS_TABLE_TEST_ID", () => $a2f3556545768e94$export$19381ed4387aa05b);
$parcel$export(module.exports, "PULL_REQUESTS_DYNAMIC_TABLE_TEST_ID", () => $a2f3556545768e94$export$f3e116f999d4c5c1);
$parcel$export(module.exports, "PULL_REQUESTS_EMPTY_STATE_TEST_ID", () => $a2f3556545768e94$export$c28f1cd40ae0394c);
$parcel$export(module.exports, "SUMMARY_CELL_TEST_ID", () => $a2f3556545768e94$export$f69d7aa9c5e17d55);
$parcel$export(module.exports, "SUMMARY_CELL_TITLE_LINK_TEST_ID", () => $a2f3556545768e94$export$4ed9a8a7faf641f);
$parcel$export(module.exports, "SUMMARY_CELL_TARGET_BRANCH_LINK_TEST_ID", () => $a2f3556545768e94$export$c5322e755fd1028d);
$parcel$export(module.exports, "SUMMARY_CELL_REPOSITORY_LINK_TEST_ID", () => $a2f3556545768e94$export$72fcd104fde041d6);
$parcel$export(module.exports, "REVIEWERS_CELL_TEST_ID", () => $a2f3556545768e94$export$d8f600a480a9c2d4);
$parcel$export(module.exports, "STATUS_CELL_TEST_ID", () => $a2f3556545768e94$export$9d9ab707c4e446cc);
$parcel$export(module.exports, "COMMENTS_CELL_TEST_ID", () => $a2f3556545768e94$export$4da3056fdbfaf111);
$parcel$export(module.exports, "LAST_UPDATED_CELL_TEST_ID", () => $a2f3556545768e94$export$e1134688b6a1032);
$parcel$export(module.exports, "PULL_REQUESTS_ERROR_STATE_TEST_ID", () => $a2f3556545768e94$export$143249aa50321d51);
$parcel$export(module.exports, "REPOSITORIES_ERROR_STATE_TEST_ID", () => $a2f3556545768e94$export$a46febdd3fe90de0);
$parcel$export(module.exports, "IMPROVED_SCM_CONFIG_SCREEN_ERROR_TEST_ID", () => $a2f3556545768e94$export$333db4cac7ee017);
$parcel$export(module.exports, "IMPROVE_READY_TO_CONNECT_EMPTY_STATE_TEST_ID", () => $a2f3556545768e94$export$5cbae081959768bd);
$parcel$export(module.exports, "REPOSITORIES_FILTER_BUTTON_TEST_ID", () => $a2f3556545768e94$export$4939c117ba49bc9e);
$parcel$export(module.exports, "AUTHOR_FILTER_BUTTON_TEST_ID", () => $a2f3556545768e94$export$5a92d7579dac6294);
$parcel$export(module.exports, "REVIEWERS_FILTER_BUTTON_TEST_ID", () => $a2f3556545768e94$export$a77ea162c15f0290);
$parcel$export(module.exports, "STATUS_FILTER_BUTTON_TEST_ID", () => $a2f3556545768e94$export$b7477204cae64b46);
$parcel$export(module.exports, "QUERY_PARAM_SUMMARY", () => $a2f3556545768e94$export$39983b6fb040a5eb);
$parcel$export(module.exports, "QUERY_PARAM_AUTHORS", () => $a2f3556545768e94$export$3d96f5f9ccd35be6);
$parcel$export(module.exports, "QUERY_PARAM_REVIEWERS", () => $a2f3556545768e94$export$8a8927c29ab32b10);
$parcel$export(module.exports, "QUERY_PARAM_STATUS", () => $a2f3556545768e94$export$3e8168848b996f7);
$parcel$export(module.exports, "QUERY_PARAM_REPOSITORIES", () => $a2f3556545768e94$export$4adc519ba40b72a6);
$parcel$export(module.exports, "QUERY_PARAM_SORT_KEY", () => $a2f3556545768e94$export$6da773286c35ef41);
$parcel$export(module.exports, "QUERY_PARAM_SORT_ORDER", () => $a2f3556545768e94$export$810a1f7ed2facfcb);
$parcel$export(module.exports, "queryParamsToWatch", () => $a2f3556545768e94$export$ba75fb5089c0eb0b);
$parcel$export(module.exports, "VcsProviderIds", () => $a2f3556545768e94$export$7d5c3d28df5f438a);
$parcel$export(module.exports, "DataDepotProviderIds", () => $a2f3556545768e94$export$7912a169c18abe9d);
$parcel$export(module.exports, "FEEDBACK_COLLECTOR_LOCATION", () => $a2f3556545768e94$export$74189cec821240a6);
$parcel$export(module.exports, "eligibleForConfigurationScreenStatuses", () => $a2f3556545768e94$export$3f3fc252f5066c72);
$parcel$export(module.exports, "notEligibleForConfigurationScreenStatuses", () => $a2f3556545768e94$export$9ce5b1bba5f17875);
$parcel$export(module.exports, "CODE_TAB_NAMESPACE", () => $a2f3556545768e94$export$f3873cacb48e85d4);
$parcel$export(module.exports, "LOCAL_STORAGE_GO_TO_DEVELOPMENT_KEY", () => $a2f3556545768e94$export$e9ce282f5e635322);
$parcel$export(module.exports, "CODE_TAB_MIGRATION_ANALYTICS", () => $a2f3556545768e94$export$49902d80a065c2d5);
const $a2f3556545768e94$export$4b1abe4db5ed7515 = [
    'HTTP status [403] while retrieving Bitbucket repository.',
    'HTTP status [404] while retrieving Bitbucket repository.',
    "Failed to retrieve Bitbucket repository because the user wasn't authorized."
];
const $a2f3556545768e94$export$687544614e0812da = [
    'HTTP status [429] while retrieving Bitbucket repository.',
    "The user does not have 'View Development Tools' permission for the Jira project or the project does not exist",
    'The user does not have admin permission for the site, Jira, project or the project does not exist.',
    'Unable to get providers when contacting Jira due to 401 Unauthorized'
];
const $a2f3556545768e94$export$7527a73da794030d = "var(--ds-shadow-overflow, 0px 0px 8px #091E4228, 0px 0px 1px #091E421e)";
const $a2f3556545768e94$export$2ecfdc24b216c295 = "var(--ds-shadow-overflow, 0px 0px 8px #091E4228, 0px 0px 1px #091E421e)"; // we use  in package.json file, so box-shadow here must be a value, cannot use elevation
const $a2f3556545768e94$export$f84c6b6609a3dd30 = 1000;
const $a2f3556545768e94$export$ea15b38f3901f518 = 12;
const $a2f3556545768e94$export$2b8b0a4489f9147b = 30;
const $a2f3556545768e94$export$3b8f88133d28aaa6 = 'collapsible-repository-list';
const $a2f3556545768e94$export$256a9f141103f328 = 'repository-list-header';
const $a2f3556545768e94$export$b0d4e90e40369b80 = 'repository-list-description';
const $a2f3556545768e94$export$1de4eaccc23a8747 = {
    'repository-list.pull-requests.empty-state': {
        helpArticleId: '5WUm7jlQnN9aiw9KOp1Ks1',
        href: 'https://support.atlassian.com/jira-software-cloud/docs/view-development-information-for-an-issue/'
    },
    'repository-list.pull-requests.description': {
        helpArticleId: '5WUm7jlQnN9aiw9KOp1Ks1',
        href: 'https://support.atlassian.com/jira-software-cloud/docs/view-development-information-for-an-issue/'
    }
};
const $a2f3556545768e94$export$5c00a6bedc2037c8 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.filter-container';
const $a2f3556545768e94$export$f70ce14ba902adcb = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filtered-table.pull-request-table.no-results.clearfiltersbutton';
const $a2f3556545768e94$export$19381ed4387aa05b = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.pull-requests-table';
const $a2f3556545768e94$export$f3e116f999d4c5c1 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.pull-requests-table.dynamic-table';
const $a2f3556545768e94$export$c28f1cd40ae0394c = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.pull-requests-empty-state';
const $a2f3556545768e94$export$f69d7aa9c5e17d55 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filtered-table.pull-request-table.summary-cell';
const $a2f3556545768e94$export$4ed9a8a7faf641f = `${$a2f3556545768e94$export$f69d7aa9c5e17d55}.title-link`;
const $a2f3556545768e94$export$c5322e755fd1028d = `${$a2f3556545768e94$export$f69d7aa9c5e17d55}.target-branch-link`;
const $a2f3556545768e94$export$72fcd104fde041d6 = `${$a2f3556545768e94$export$f69d7aa9c5e17d55}.repository-link`;
const $a2f3556545768e94$export$d8f600a480a9c2d4 = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.reviewers-cell';
const $a2f3556545768e94$export$9d9ab707c4e446cc = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.status-cell';
const $a2f3556545768e94$export$4da3056fdbfaf111 = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.comments-cell';
const $a2f3556545768e94$export$e1134688b6a1032 = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.last-updated-cell';
const $a2f3556545768e94$export$143249aa50321d51 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-error-state';
const $a2f3556545768e94$export$a46febdd3fe90de0 = 'software-code-page.ui.pages.main-page.repositories.repository-error-state';
const $a2f3556545768e94$export$333db4cac7ee017 = 'software-code-page.ui.pages.improved-configure-step-error-state';
const $a2f3556545768e94$export$5cbae081959768bd = 'software-code-page.ui.pages.ready-to-connect-empty-state-error-state';
const $a2f3556545768e94$export$4939c117ba49bc9e = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.repository-filter.filter-button';
const $a2f3556545768e94$export$5a92d7579dac6294 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.author-filter.filter-button';
const $a2f3556545768e94$export$a77ea162c15f0290 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.reviewers-filter.filter-button';
const $a2f3556545768e94$export$b7477204cae64b46 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.status-filter.filter-button';
const $a2f3556545768e94$export$39983b6fb040a5eb = 'summaryFilter';
const $a2f3556545768e94$export$3d96f5f9ccd35be6 = 'authorsFilter';
const $a2f3556545768e94$export$8a8927c29ab32b10 = 'reviewersFilter';
const $a2f3556545768e94$export$3e8168848b996f7 = 'statusFilter';
const $a2f3556545768e94$export$4adc519ba40b72a6 = 'repositoriesFilter';
const $a2f3556545768e94$export$6da773286c35ef41 = 'sortKey';
const $a2f3556545768e94$export$810a1f7ed2facfcb = 'sortOrder';
const $a2f3556545768e94$export$ba75fb5089c0eb0b = [
    $a2f3556545768e94$export$39983b6fb040a5eb,
    $a2f3556545768e94$export$3d96f5f9ccd35be6,
    $a2f3556545768e94$export$8a8927c29ab32b10,
    $a2f3556545768e94$export$3e8168848b996f7,
    $a2f3556545768e94$export$4adc519ba40b72a6,
    $a2f3556545768e94$export$6da773286c35ef41,
    $a2f3556545768e94$export$810a1f7ed2facfcb
];
const $a2f3556545768e94$export$7d5c3d28df5f438a = {
    BITBUCKET: 'bitbucket'
};
const $a2f3556545768e94$export$7912a169c18abe9d = {
    BITBUCKET_PROD: 'kRiZ7boFApjBINFF1L7wPrCa4iF8O6R9',
    BITBUCKET_STG: 'cOwtZiBfejjJAryJH0WPb1otsa4HrI1N',
    GITHUB_PROD: 'com.github.integration.production',
    GITHUB_STG: 'com.github.integration.staging'
};
const $a2f3556545768e94$export$74189cec821240a6 = 'jsw.code.page.header';
const $a2f3556545768e94$export$3f3fc252f5066c72 = [
    'NOT_CONFIGURED',
    'NOT_SET',
    'PARTIALLY_CONFIGURED'
];
const $a2f3556545768e94$export$9ce5b1bba5f17875 = [
    'CONFIGURED',
    'PROVIDER_ACTION_CONFIGURED',
    'PROVIDER_ACTION_NOT_CONFIGURED'
];
const $a2f3556545768e94$export$f3873cacb48e85d4 = 'jira-software-code-tab';
const $a2f3556545768e94$export$e9ce282f5e635322 = 'clickedGoToDevelopment';
const $a2f3556545768e94$export$49902d80a065c2d5 = 'jiraCodePageMigrationModal';

});

parcelRegister("1tSBh", function(module, exports) {

$parcel$export(module.exports, "numberToTimestamp", () => $dbe340acf3f0dbdc$export$9a7be8324d19a048);
$parcel$export(module.exports, "toProjectAri", () => $dbe340acf3f0dbdc$export$9429718a5f74f761);
$parcel$export(module.exports, "RepositoryTypes", () => $dbe340acf3f0dbdc$export$b5ab924fb433d9ea);
/**
 * Opaque types
 */ const $dbe340acf3f0dbdc$export$9a7be8324d19a048 = (time)=>{
    if (time < 0) throw new Error(`Trying to case invalid number(${time}) to Timestamp opaque type`);
    return time;
};
const $dbe340acf3f0dbdc$export$9429718a5f74f761 = (cloudId, projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`;
const $dbe340acf3f0dbdc$export$b5ab924fb433d9ea = {
    REPO_BITBUCKET: 'REPO_BITBUCKET',
    REPO_GITHUB: 'REPO_GITHUB',
    REPO_GITLAB: 'REPO_GITLAB'
};
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $dbe340acf3f0dbdc$var$VcsProviderNamespaces = {
    CLASSIC: 'classic',
    OAUTH: 'oauth',
    BITBUCKET: 'bitbucket'
};

});


const $96625f88cf395132$export$94a43d2ac55ac375 = 'SOFTWARE_CODE';


parcelRegister("lzTbm", function(module, exports) {

$parcel$export(module.exports, "softwareCodeRoute", () => $29efee39c2e259e2$export$9d24fc75b0f1d9a0);
const $29efee39c2e259e2$export$9d24fc75b0f1d9a0 = {
    name: 'software-code',
    path: '/jira/software/projects/:projectKey/code'
};

});

parcelRegister("kfztd", function(module, exports) {

$parcel$export(module.exports, "isDevopsFeatureDisabledInFedRamp", () => $064393a36b21cb6e$export$18bfef4995ec57b7);

var $c04PQ = parcelRequire("c04PQ");
const $064393a36b21cb6e$export$18bfef4995ec57b7 = ()=>(0, $c04PQ.isFedRamp)();

});

parcelRegister("dOE01", function(module, exports) {

$parcel$export(module.exports, "LazyCode", () => $1829bbce77409b44$export$4beafd9dbad29bff);
$parcel$export(module.exports, "CodePageNextGen", () => $1829bbce77409b44$export$d9e8184332f86b53);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $bzM7d = parcelRequire("bzM7d");

const $1829bbce77409b44$export$4beafd9dbad29bff = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("jG7sy"))), {
    moduleId: "./src/packages/spa-apps/code/src/ui/index-old.tsx"
});
const $1829bbce77409b44$export$d9e8184332f86b53 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $1829bbce77409b44$export$4beafd9dbad29bff,
        pageId: `next-gen-code-${(0, $bzM7d.getBoardId)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });

});
parcelRegister("bzM7d", function(module, exports) {

$parcel$export(module.exports, "getBoardId", () => $8d5a6727ab17b6ba$export$557c2f222778cea6);

var $ebyGx = parcelRequire("ebyGx");
const $8d5a6727ab17b6ba$export$557c2f222778cea6 = ({ location: location, match: match })=>{
    if (match && match.params.boardId) return match.params.boardId;
    const { rapidView: rapidView } = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(location.search);
    return rapidView;
};

});

parcelRegister("jG7sy", function(module, exports) {

let $e537b9df6b85c9f4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e537b9df6b85c9f4$var$load("ioZNk").then(()=>parcelRequire('fd2lp'));

});


parcelRegister("cD5C5", function(module, exports) {

$parcel$export(module.exports, "softwareCodeNextGenPageEntrypoint", () => $e02d9e74ba3f4d5c$export$bba7318d4079a95);

var $5mvmF = parcelRequire("5mvmF");

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");

var $lkFvK = parcelRequire("lkFvK");
const $e02d9e74ba3f4d5c$export$bba7318d4079a95 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $5mvmF.softwareCodeEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("5mvmF", function(module, exports) {

$parcel$export(module.exports, "softwareCodeEntrypoint", () => $91f5d21e8db2487a$export$7dbaba2b508f1f10);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $91f5d21e8db2487a$export$7dbaba2b508f1f10 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("3GkOe")), {
        moduleId: "ba9a9980"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3GkOe", function(module, exports) {

let $2ae56f994f708324$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2ae56f994f708324$var$load("eXTT6").then(()=>parcelRequire('2kLjA'));

});




parcelRegister("dBV2a", function(module, exports) {

$parcel$export(module.exports, "softwareNextgenRedirectRouteEntry", () => $8e109be01fe8b384$export$e328d22412aeb5cf);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $i4mNf = parcelRequire("i4mNf");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $7tQej = parcelRequire("7tQej");

var $kxZPA = parcelRequire("kxZPA");

var $7yO8g = parcelRequire("7yO8g");

var $21yN6 = parcelRequire("21yN6");
const $8e109be01fe8b384$var$SoftwareNextgenRedirectComponent = ({ location: location })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: (0, $21yN6.pickNextGenView)(location)
    });

const $8e109be01fe8b384$var$LazyBoardPage = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("cfMm6"))), {
    moduleId: "./src/packages/spa-apps/next-gen-board/src/index.tsx"
});
const $8e109be01fe8b384$export$e328d22412aeb5cf = (0, $7NszV.createEntry)((0, $i4mNf.softwareNextgenRedirectRoute), ()=>({
        group: 'software',
        component: $8e109be01fe8b384$var$SoftwareNextgenRedirectComponent,
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $8e109be01fe8b384$var$LazyBoardPage
        ]
    }));

});
parcelRegister("fKmub", function(module, exports) {

$parcel$export(module.exports, "LazyIssueApp", () => $43c3852afc527b13$export$8c70dcc4643464f8);

var $kxZPA = parcelRequire("kxZPA");

const $43c3852afc527b13$export$8c70dcc4643464f8 = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("eLfPy")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});

});

parcelRegister("i4mNf", function(module, exports) {

$parcel$export(module.exports, "softwareNextgenRedirectRoute", () => $ddb4f261ae7c214b$export$6072946fe7f2d45a);
const $ddb4f261ae7c214b$export$6072946fe7f2d45a = {
    name: 'software-nextgen-redirect',
    path: '/secure/NextGen.jspa'
};

});

parcelRegister("21yN6", function(module, exports) {

$parcel$export(module.exports, "pickNextGenView", () => $4ad36038fa160dbe$export$8c47088cd9b527ba);

var $ebyGx = parcelRequire("ebyGx");
const $4ad36038fa160dbe$var$PLAN = 'planning';
const $4ad36038fa160dbe$var$REPORTING = 'reporting';
const $4ad36038fa160dbe$var$REPORTS = 'reports';
const $4ad36038fa160dbe$var$constructUrlForView = (url, view, searchResult)=>{
    if (view.startsWith($4ad36038fa160dbe$var$PLAN)) return `${url}/backlog`;
    if (view.startsWith($4ad36038fa160dbe$var$REPORTING) || view.startsWith($4ad36038fa160dbe$var$REPORTS)) {
        if (searchResult.report) return `${url}/reports/${searchResult.report}`;
        return `${url}/reports`;
    }
    return url;
};
const $4ad36038fa160dbe$var$KNOWN_KEYS = [
    'rapidView',
    'projectKey',
    'view',
    'report'
];
const $4ad36038fa160dbe$var$forwardUnknownQueryParams = (url, queryParams)=>{
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(Object.entries(queryParams).filter(([k])=>!$4ad36038fa160dbe$var$KNOWN_KEYS.includes(k)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((result, [k, v])=>({
            [k]: v,
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result
        }), {}));
    if (query) return `${url}?${query}`;
    return url;
};
const $4ad36038fa160dbe$export$8c47088cd9b527ba = (location)=>{
    const searchResult = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(location.search);
    const url = `/jira/software/projects/${searchResult.projectKey}/boards/${searchResult.rapidView}`;
    if (searchResult.view) return $4ad36038fa160dbe$var$forwardUnknownQueryParams($4ad36038fa160dbe$var$constructUrlForView(url, searchResult.view, searchResult), searchResult);
    return $4ad36038fa160dbe$var$forwardUnknownQueryParams(url, searchResult);
};

});

parcelRegister("cfMm6", function(module, exports) {

let $8ebc65271530ea0e$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $8ebc65271530ea0e$var$load("kVX56"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("5uTaB"), 4)),
    $8ebc65271530ea0e$var$load("ffQaD"),
    $8ebc65271530ea0e$var$load("kvRbA"),
    $8ebc65271530ea0e$var$load("76n7a"),
    $8ebc65271530ea0e$var$load("l253H"),
    $8ebc65271530ea0e$var$load("kNFvF"),
    $8ebc65271530ea0e$var$load("c4Xsx")
]).then(()=>parcelRequire('dnhKp'));

});


parcelRegister("ickyX", function(module, exports) {

$parcel$export(module.exports, "softwareReportsBurndownRouteEntry", () => $0b40776c7df01e72$export$c54d6c6781ad5beb);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $89ZnT = parcelRequire("89ZnT");

var $e7bC3 = parcelRequire("e7bC3");

var $4GBKo = parcelRequire("4GBKo");

var $bekEk = parcelRequire("bekEk");
const $0b40776c7df01e72$export$c54d6c6781ad5beb = (0, $7NszV.createEntry)((0, $89ZnT.softwareReportsBurndownRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.burndown-chart',
        entryPoint: ()=>(0, $bekEk.BurnDownReportPageEntrypoint),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $4GBKo.getTMPReportsCommonResource)()
        ]
    }));

});
parcelRegister("89ZnT", function(module, exports) {

$parcel$export(module.exports, "softwareReportsBurndownRoute", () => $07e07ef6a15f8aed$export$e0d8c26cb1430ae4);
const $07e07ef6a15f8aed$export$e0d8c26cb1430ae4 = {
    name: 'software-reports-burndown',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/burndown'
};

});

parcelRegister("4GBKo", function(module, exports) {

$parcel$export(module.exports, "getTMPReportsCommonResource", () => $e8677532a1aaea76$export$f234446c23dc22a);

var $48Ij3 = parcelRequire("48Ij3");

var $gcI3W = parcelRequire("gcI3W");

var $4Bwc0 = parcelRequire("4Bwc0");
const $e8677532a1aaea76$export$8cb713295e6b7204 = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $e8677532a1aaea76$export$f234446c23dc22a = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $48Ij3.staticSidebarJSWReportsResource)
    ];

});
parcelRegister("48Ij3", function(module, exports) {

$parcel$export(module.exports, "staticSidebarJSWReportsResource", () => $d94d5098764be5f8$export$5910307042ab3f6f);

var $8YTna = parcelRequire("8YTna");

var $2M1hQ = parcelRequire("2M1hQ");

var $7xeIG = parcelRequire("7xeIG");
const $d94d5098764be5f8$export$5910307042ab3f6f = (0, $2M1hQ.createResource)({
    type: 'JIRA_SOFTWARE_REPORTS',
    getKey: ({ match: match, query: query })=>{
        const boardId = (0, $8YTna.getBoardId)(match, query);
        return boardId ? `board-${boardId}` : 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const boardId = (0, $8YTna.getBoardId)(match, query);
        if (boardId == null) return null;
        const response = await (0, $7xeIG.fetchJSWReports)(boardId);
        return response?.reports;
    },
    maxAge: 300000
});

});
parcelRegister("7xeIG", function(module, exports) {

$parcel$export(module.exports, "fetchJSWReports", () => $61400f9195fc4c28$export$a93a577d6971da2c);

var $eusud = parcelRequire("eusud");
const $61400f9195fc4c28$export$a93a577d6971da2c = (boardId)=>{
    if (boardId == null) throw new Error('invalid boardId');
    return (0, $eusud.performGetRequest)(`/rest/agile/latest/board/${boardId}/reports`);
};

});


parcelRegister("4Bwc0", function(module, exports) {

$parcel$export(module.exports, "devOpsReportPreconditionResource", () => $5073d432665dfcf8$export$96cb0eae1b3413f4);
$parcel$export(module.exports, "useDevOpsReportPreconditionResource", () => $5073d432665dfcf8$export$e9adc6103e9ed514);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


const $5073d432665dfcf8$export$96cb0eae1b3413f4 = (0, $2M1hQ.createResource)({
    type: (0, $16165c7eb855363c$export$14c5ce449424c281),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("l1hQB")),
    maxAge: 60000
});
const $5073d432665dfcf8$export$e9adc6103e9ed514 = ()=>(0, $2YP9W.useResource)($5073d432665dfcf8$export$96cb0eae1b3413f4);

});
const $16165c7eb855363c$export$14c5ce449424c281 = 'SOFTWARE_CYCLE_TIME_REPORT_PRECONDITION';
const $16165c7eb855363c$export$28dc7a217425f1a9 = 'VIEW_DEV_TOOLS';
const $16165c7eb855363c$export$a03e1c9d464f9477 = 'VIEW_AGGREGATED_DATA';

parcelRegister("l1hQB", function(module, exports) {

let $f4d7891c32d51cd3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f4d7891c32d51cd3$var$load("dT7Bp").then(()=>parcelRequire('5aldt'));

});



parcelRegister("bekEk", function(module, exports) {

$parcel$export(module.exports, "BurnDownReportPageEntrypoint", () => $51e496184ed5259a$export$4cba13cb70183e0e);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $i9CHX = parcelRequire("i9CHX");
const $51e496184ed5259a$export$4cba13cb70183e0e = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $i9CHX.burnDownReportEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("i9CHX", function(module, exports) {

$parcel$export(module.exports, "burnDownReportEntrypoint", () => $851cca1e4d3acad5$export$ca10f29d444e87e0);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $851cca1e4d3acad5$export$ca10f29d444e87e0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("9nVzW")), {
        moduleId: "24e2d8d6"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9nVzW", function(module, exports) {

let $6d52ecf47c61aafe$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6d52ecf47c61aafe$var$load("ffQaD"),
    $6d52ecf47c61aafe$var$load("kvRbA"),
    $6d52ecf47c61aafe$var$load("6PbDg")
]).then(()=>parcelRequire('68CUZ'));

});




parcelRegister("cQer4", function(module, exports) {

$parcel$export(module.exports, "softwareReportsBurnupRouteEntry", () => $5e67b01b927c6e1e$export$e53193d8a7e7d068);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $hlvYO = parcelRequire("hlvYO");

var $e7bC3 = parcelRequire("e7bC3");

var $4GBKo = parcelRequire("4GBKo");

var $c3kjm = parcelRequire("c3kjm");
const $5e67b01b927c6e1e$export$e53193d8a7e7d068 = (0, $7NszV.createEntry)((0, $hlvYO.softwareReportsBurnupRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.burnup-chart',
        entryPoint: ()=>(0, $c3kjm.BurnUpReportPageEntrypoint),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $4GBKo.getTMPReportsCommonResource)()
        ]
    }));

});
parcelRegister("hlvYO", function(module, exports) {

$parcel$export(module.exports, "softwareReportsBurnupRoute", () => $7e7ef0af528823d4$export$5b818a6914ca8376);
const $7e7ef0af528823d4$export$5b818a6914ca8376 = {
    name: 'software-reports-burnup',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/burnup'
};

});

parcelRegister("c3kjm", function(module, exports) {

$parcel$export(module.exports, "BurnUpReportPageEntrypoint", () => $2f0cf451fae61f8d$export$5901b46abc65034e);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $30BHv = parcelRequire("30BHv");
const $2f0cf451fae61f8d$export$5901b46abc65034e = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $30BHv.burnUpReportEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("30BHv", function(module, exports) {

$parcel$export(module.exports, "burnUpReportEntrypoint", () => $d72ad05161bd39f0$export$dfec2f14e71954f6);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $d72ad05161bd39f0$export$dfec2f14e71954f6 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("juvbk")), {
        moduleId: "a1ebcc2d"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("juvbk", function(module, exports) {

let $e30901b1ca931e6a$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e30901b1ca931e6a$var$load("ffQaD"),
    $e30901b1ca931e6a$var$load("kvRbA"),
    $e30901b1ca931e6a$var$load("do7nn")
]).then(()=>parcelRequire('e2Cll'));

});




parcelRegister("eL5iv", function(module, exports) {

$parcel$export(module.exports, "softwareReportsControlRouteEntry", () => $c03e5ec50f5b41d2$export$3cb9570ca242f2a2);

var $e4eHl = parcelRequire("e4eHl");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $dL9sv = parcelRequire("dL9sv");

var $6LsQE = parcelRequire("6LsQE");

var $kfztd = parcelRequire("kfztd");

var $e7bC3 = parcelRequire("e7bC3");

var $4GBKo = parcelRequire("4GBKo");

var $9XjvH = parcelRequire("9XjvH");
const $c03e5ec50f5b41d2$export$3cb9570ca242f2a2 = (0, $7NszV.createEntry)((0, $dL9sv.softwareReportsControlRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.control-chart',
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $4GBKo.getTMPReportsCommonResource)()
        ],
        entryPoint: ()=>!(0, $4R6GH.fg)('jsw_enable_avp_control_chart') || (0, $kfztd.isDevopsFeatureDisabledInFedRamp)() ? (0, $6LsQE.notFoundPageEntrypoint) : (0, $9XjvH.softwareReportsControlPageEntrypoint),
        meta: {
            reporting: {
                id: 'software-reports-control',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-reports-control'),
                teamName: 'helios-reports'
            }
        }
    }));

});
parcelRegister("dL9sv", function(module, exports) {

$parcel$export(module.exports, "softwareReportsControlRoute", () => $5f561127b557eb0e$export$8c91815cd4b1c078);
const $5f561127b557eb0e$export$8c91815cd4b1c078 = {
    name: 'software-reports-control',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/control'
};

});

parcelRegister("9XjvH", function(module, exports) {

$parcel$export(module.exports, "softwareReportsControlPageEntrypoint", () => $a8fc70484e9dc624$export$a35d50a33df2f6d5);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $1UEHs = parcelRequire("1UEHs");
const $a8fc70484e9dc624$export$a35d50a33df2f6d5 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1UEHs.softwareReportsControlEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("1UEHs", function(module, exports) {

$parcel$export(module.exports, "softwareReportsControlEntrypoint", () => $0b50ae414867ca7f$export$240870c8f3915828);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $0b50ae414867ca7f$export$240870c8f3915828 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("68c7N")), {
        moduleId: "00c05b16"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("68c7N", function(module, exports) {

let $476ce528bb7b743b$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $476ce528bb7b743b$var$load("ffQaD"),
    $476ce528bb7b743b$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("jfbWR"), 4)),
    $476ce528bb7b743b$var$load("fliVL"),
    $476ce528bb7b743b$var$load("76n7a"),
    $476ce528bb7b743b$var$load("l253H"),
    $476ce528bb7b743b$var$load("44AFW")
]).then(()=>parcelRequire('fXW64'));

});




parcelRegister("7MlOX", function(module, exports) {

$parcel$export(module.exports, "softwareReportsCumulativeRouteEntry", () => $940a759ddc17038b$export$7ace4d0363d78b41);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $7QybL = parcelRequire("7QybL");

var $e7bC3 = parcelRequire("e7bC3");

var $4GBKo = parcelRequire("4GBKo");

var $5v1XH = parcelRequire("5v1XH");
const $940a759ddc17038b$export$7ace4d0363d78b41 = (0, $7NszV.createEntry)((0, $7QybL.softwareReportsCumulativeRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.cumulative-flow-diagram',
        entryPoint: ()=>(0, $5v1XH.CumulativeReportPageEntrypoint),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $4GBKo.getTMPReportsCommonResource)()
        ]
    }));

});
parcelRegister("7QybL", function(module, exports) {

$parcel$export(module.exports, "softwareReportsCumulativeRoute", () => $63045e7bbaab9903$export$3c48ddd40d00b0d2);
const $63045e7bbaab9903$export$3c48ddd40d00b0d2 = {
    name: 'software-reports-cumulative',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/cumulative'
};

});

parcelRegister("5v1XH", function(module, exports) {

$parcel$export(module.exports, "CumulativeReportPageEntrypoint", () => $d11158d5657ed65b$export$2f3ad380ae691fb5);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $7D9Jw = parcelRequire("7D9Jw");
const $d11158d5657ed65b$export$2f3ad380ae691fb5 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7D9Jw.cumulativeReportEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("7D9Jw", function(module, exports) {

$parcel$export(module.exports, "cumulativeReportEntrypoint", () => $d56a1e4bf358cfa4$export$f01a8d84f5a47478);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $d56a1e4bf358cfa4$export$f01a8d84f5a47478 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("6bltS")), {
        moduleId: "d640aef5"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("6bltS", function(module, exports) {

let $48046ecbdd5bac6c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $48046ecbdd5bac6c$var$load("ffQaD"),
    $48046ecbdd5bac6c$var$load("kvRbA"),
    $48046ecbdd5bac6c$var$load("kd1UR")
]).then(()=>parcelRequire('ejLY3'));

});




parcelRegister("jK6bT", function(module, exports) {

$parcel$export(module.exports, "softwareReportsCycleTimeRouteEntry", () => $80a71bce0783e42d$export$8aee4b14556485d5);

var $e4eHl = parcelRequire("e4eHl");

var $lmyls = parcelRequire("lmyls");

var $6LsQE = parcelRequire("6LsQE");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $2GkDw = parcelRequire("2GkDw");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $iftoH = parcelRequire("iftoH");

var $kfztd = parcelRequire("kfztd");

var $e7bC3 = parcelRequire("e7bC3");

var $4GBKo = parcelRequire("4GBKo");

var $g0ZNl = parcelRequire("g0ZNl");
const $80a71bce0783e42d$export$8aee4b14556485d5 = (0, $7NszV.createEntry)((0, $iftoH.softwareReportsCycleTimeRoute), ()=>({
        group: 'software',
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $4GBKo.getTMPReportsCommonResource)(),
            (0, $2GkDw.devOpsProviderResource)
        ],
        entryPoint: ()=>{
            if ((0, $kfztd.isDevopsFeatureDisabledInFedRamp)()) return 0, $6LsQE.notFoundPageEntrypoint;
            return 0, $g0ZNl.cycleTimeReportPageEntrypoint;
        },
        meta: {
            reporting: {
                id: 'software-reports-cycle-time',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-reports-cycle-time'),
                teamName: 'fusion-solaris'
            }
        }
    }));

});
parcelRegister("2GkDw", function(module, exports) {

$parcel$export(module.exports, "devOpsProviderResource", () => $3640b01f63c1fd17$export$19e58e21b24ae0d8);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


const $3640b01f63c1fd17$export$19e58e21b24ae0d8 = (0, $2M1hQ.createResource)({
    type: (0, $e9cf201ab81d4288$export$5f92e516f4b78544),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("5PDRl")),
    maxAge: 60000
});
const $3640b01f63c1fd17$export$b80f5852c41a5ca8 = ()=>(0, $2YP9W.useResource)($3640b01f63c1fd17$export$19e58e21b24ae0d8);

});
const $e9cf201ab81d4288$export$5f92e516f4b78544 = 'SOFTWARE_DEVOPS_PROVIDERS';
const $e9cf201ab81d4288$export$d7f081d6dd0e72fc = 'bitbucket';
const $e9cf201ab81d4288$export$832d1d859726f915 = 'kRiZ7boFApjBINFF1L7wPrCa4iF8O6R9';
const $e9cf201ab81d4288$export$5007979ef33118fc = 'cOwtZiBfejjJAryJH0WPb1otsa4HrI1N';

parcelRegister("5PDRl", function(module, exports) {

let $43f0a26567ddd7ef$var$load = (parcelRequire("28QjX"))(4);
module.exports = $43f0a26567ddd7ef$var$load("kPLWf").then(()=>parcelRequire('2MQ7j'));

});


parcelRegister("iftoH", function(module, exports) {

$parcel$export(module.exports, "softwareReportsCycleTimeRoute", () => $36696e97e70723ad$export$c777bb8f2591081);
const $36696e97e70723ad$export$c777bb8f2591081 = {
    name: 'software-reports-cycle-time',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/cycle-time'
};

});

parcelRegister("g0ZNl", function(module, exports) {

$parcel$export(module.exports, "cycleTimeReportPageEntrypoint", () => $494bd3c8d60b6ff9$export$465717d84afb3d8f);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $4i2WV = parcelRequire("4i2WV");
const $494bd3c8d60b6ff9$export$465717d84afb3d8f = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $4i2WV.cycleTimeReportEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("4i2WV", function(module, exports) {

$parcel$export(module.exports, "cycleTimeReportEntrypoint", () => $922dd77a7bbacdbf$export$a4c2e42865ef5d9d);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $922dd77a7bbacdbf$export$a4c2e42865ef5d9d = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("7FlYI")), {
        moduleId: "4e89963f"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("7FlYI", function(module, exports) {

let $594d692e6e801339$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $594d692e6e801339$var$load("ffQaD"),
    $594d692e6e801339$var$load("kvRbA"),
    $594d692e6e801339$var$load("1VPQt")
]).then(()=>parcelRequire('5Y2tv'));

});




parcelRegister("hvbE3", function(module, exports) {

$parcel$export(module.exports, "softwareReportsDeploymentFrequencyRouteEntry", () => $9fed6c189f0eedfa$export$c87b25c0997e584d);

var $e4eHl = parcelRequire("e4eHl");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $2GkDw = parcelRequire("2GkDw");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $avQc9 = parcelRequire("avQc9");

var $c04PQ = parcelRequire("c04PQ");

var $e7bC3 = parcelRequire("e7bC3");

var $6LsQE = parcelRequire("6LsQE");

var $4GBKo = parcelRequire("4GBKo");

var $eSx59 = parcelRequire("eSx59");
const $9fed6c189f0eedfa$export$c87b25c0997e584d = (0, $7NszV.createEntry)((0, $avQc9.softwareReportsDeploymentFrequencyRoute), ()=>({
        group: 'software',
        entryPoint: ()=>{
            if ((0, $c04PQ.isFedRamp)()) return 0, $6LsQE.notFoundPageEntrypoint;
            return 0, $eSx59.DeploymentFrequencyPageEntrypoint;
        },
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $4GBKo.getTMPReportsCommonResource)(),
            (0, $2GkDw.devOpsProviderResource)
        ],
        meta: {
            reporting: {
                id: 'software-reports-deployment-frequency',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-reports-deployment-frequency'),
                teamName: 'fusion-solaris'
            }
        }
    }));

});
parcelRegister("avQc9", function(module, exports) {

$parcel$export(module.exports, "softwareReportsDeploymentFrequencyRoute", () => $b876fc8448289e46$export$bbf45ab0423b990);
const $b876fc8448289e46$export$bbf45ab0423b990 = {
    name: 'software-reports-deployment-frequency',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/deployment-frequency'
};

});

parcelRegister("eSx59", function(module, exports) {

$parcel$export(module.exports, "DeploymentFrequencyPageEntrypoint", () => $2f62bb5293f966a6$export$76cc51683254a696);

var $lkFvK = parcelRequire("lkFvK");

var $1tqza = parcelRequire("1tqza");

var $lmyls = parcelRequire("lmyls");
const $2f62bb5293f966a6$export$76cc51683254a696 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1tqza.deploymentFrequencyReportEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("1tqza", function(module, exports) {

$parcel$export(module.exports, "deploymentFrequencyReportEntrypoint", () => $6dfbb47575bd8c68$export$7377438ce2792970);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $6dfbb47575bd8c68$export$7377438ce2792970 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("aQ265")), {
        moduleId: "1be0b680"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("aQ265", function(module, exports) {

let $7e4063293b45b766$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $7e4063293b45b766$var$load("ffQaD"),
    $7e4063293b45b766$var$load("kvRbA"),
    $7e4063293b45b766$var$load("7NpBF")
]).then(()=>parcelRequire('77FPb'));

});




parcelRegister("glwG4", function(module, exports) {

$parcel$export(module.exports, "softwareReportsRouteEntry", () => $e48b30544edfb83d$export$2eee2f4f773d5b1f);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $gTLbY = parcelRequire("gTLbY");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $4GBKo = parcelRequire("4GBKo");

var $kgB1V = parcelRequire("kgB1V");
const $e48b30544edfb83d$export$2eee2f4f773d5b1f = (0, $7NszV.createEntry)((0, $gTLbY.softwareReportsRoute), ()=>({
        group: 'software',
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $4GBKo.getTMPReportsCommonResource)()
        ],
        entryPoint: ()=>(0, $kgB1V.reportsOverviewPageEntrypoint),
        ufoName: 'software-reports.overview'
    }));

});
parcelRegister("gTLbY", function(module, exports) {

$parcel$export(module.exports, "softwareReportsRoute", () => $ccee26b223b96f27$export$5bf75a5d8c554930);
const $ccee26b223b96f27$export$5bf75a5d8c554930 = {
    name: 'software-reports',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports'
};

});

parcelRegister("kgB1V", function(module, exports) {

$parcel$export(module.exports, "reportsOverviewPageEntrypoint", () => $5b9a94bde6be5ad0$export$d9a1db2306b376e2);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");

var $1oBct = parcelRequire("1oBct");
const $5b9a94bde6be5ad0$export$d9a1db2306b376e2 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1oBct.reportsOverviewEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("1oBct", function(module, exports) {

$parcel$export(module.exports, "reportsOverviewEntrypoint", () => $cc66006bf6e013de$export$bb9acba529741f89);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $cc66006bf6e013de$export$bb9acba529741f89 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("a1v2H")), {
        moduleId: "6be6e255"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("a1v2H", function(module, exports) {

let $74c213cb941470e8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $74c213cb941470e8$var$load("a9VRT").then(()=>parcelRequire('iZwfI'));

});




parcelRegister("lcFGc", function(module, exports) {

$parcel$export(module.exports, "softwareReportsVelocityRouteEntry", () => $c4602ac6f12b6703$export$7d814f4300d0e318);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $hui9h = parcelRequire("hui9h");

var $e7bC3 = parcelRequire("e7bC3");

var $4GBKo = parcelRequire("4GBKo");

var $fzG6k = parcelRequire("fzG6k");
const $c4602ac6f12b6703$export$7d814f4300d0e318 = (0, $7NszV.createEntry)((0, $hui9h.softwareReportsVelocityRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.velocity-report',
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $4GBKo.getTMPReportsCommonResource)()
        ],
        entryPoint: ()=>(0, $fzG6k.velocityReportPageEntrypoint)
    }));

});
parcelRegister("hui9h", function(module, exports) {

$parcel$export(module.exports, "softwareReportsVelocityRoute", () => $e44f6dc6707a4fed$export$cde83a6497756848);
const $e44f6dc6707a4fed$export$cde83a6497756848 = {
    name: 'software-reports-velocity',
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/velocity'
};

});

parcelRegister("fzG6k", function(module, exports) {

$parcel$export(module.exports, "velocityReportPageEntrypoint", () => $29d7a4515738ef63$export$571ee01f62e186c8);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $kMjGT = parcelRequire("kMjGT");
const $29d7a4515738ef63$export$571ee01f62e186c8 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $kMjGT.velocityReportEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("kMjGT", function(module, exports) {

$parcel$export(module.exports, "velocityReportEntrypoint", () => $9e6b346357d67309$export$6f6bc731b8a9d27);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $9e6b346357d67309$export$6f6bc731b8a9d27 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("gFDgs")), {
        moduleId: "3ce1c0b2"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("gFDgs", function(module, exports) {

let $c22eeec209d0774a$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c22eeec209d0774a$var$load("ffQaD"),
    $c22eeec209d0774a$var$load("kvRbA"),
    $c22eeec209d0774a$var$load("eJHxk")
]).then(()=>parcelRequire('59dUe'));

});




parcelRegister("056cU", function(module, exports) {

$parcel$export(module.exports, "softwareRoadmapRedirectRouteEntry", () => $ea7885e348916216$export$4180bde2c4464aed);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $ffza4 = parcelRequire("ffza4");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $itBA5 = parcelRequire("itBA5");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $7tQej = parcelRequire("7tQej");

var $kotYl = parcelRequire("kotYl");
const $ea7885e348916216$var$SoftwareTimelineLegacyRedirect = ({ query: query })=>{
    const { projectKey: projectKey, rapidView: rapidView, ...restQuery } = query;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: {
            pathname: `/jira/software/projects/${projectKey}/boards/${rapidView}/timeline`,
            hash: '',
            search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(restQuery)
        }
    });
};
const $ea7885e348916216$export$4180bde2c4464aed = (0, $7NszV.createEntry)((0, $itBA5.softwareRoadmapRedirectRoute), ()=>({
        group: 'software',
        component: $ea7885e348916216$var$SoftwareTimelineLegacyRedirect,
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kotYl.LazyNextGenRoadmap)
        ]
    }));

});
parcelRegister("itBA5", function(module, exports) {

$parcel$export(module.exports, "softwareRoadmapRedirectRoute", () => $e9307309e9fea835$export$866215abd09c0f4d);
const $e9307309e9fea835$export$866215abd09c0f4d = {
    name: 'software-roadmap-redirect',
    path: '/secure/Roadmap.jspa'
};

});

parcelRegister("kotYl", function(module, exports) {

$parcel$export(module.exports, "LazyNextGenRoadmap", () => $fadca415ac9d888e$export$1339c847cf4ab57);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $fadca415ac9d888e$export$1339c847cf4ab57 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("293Nh"))), {
    moduleId: "./src/packages/spa-apps/roadmap/src/view/next-gen/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fadca415ac9d888e$export$2e2bcd8739ae039 = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $fadca415ac9d888e$export$1339c847cf4ab57,
        pageId: `next-gen-roadmap-${match.params.boardId || ''}`,
        shouldShowSpinner: false
    });

});
parcelRegister("293Nh", function(module, exports) {

let $18ff5d6af99fb269$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $18ff5d6af99fb269$var$load("ffQaD"),
    $18ff5d6af99fb269$var$load("kvRbA"),
    $18ff5d6af99fb269$var$load("dwsGM")
]).then(()=>parcelRequire('9ImcE'));

});



parcelRegister("6p9ik", function(module, exports) {

$parcel$export(module.exports, "opsgenieScheduleRedirectRouteEntry", () => $330664ff34aced93$export$75f0bcae97d54ba0);

var $ffza4 = parcelRequire("ffza4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $gr6ab = parcelRequire("gr6ab");

var $fyMYi = parcelRequire("fyMYi");
const $330664ff34aced93$export$75f0bcae97d54ba0 = (0, $7NszV.createEntry)((0, $gr6ab.opsgenieScheduleRedirectRoute), ()=>({
        group: 'components',
        component: !false ? (0, $fyMYi.OpsgenieScheduleRedirect) : (0, $fyMYi.default),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fyMYi.LazyOpsGenieSchedule)
        ],
        isRedirect: true
    }));

});
parcelRegister("gr6ab", function(module, exports) {

$parcel$export(module.exports, "opsgenieScheduleRedirectRoute", () => $65ae7cc3298d4e34$export$5d29dbb36868dff4);
const $65ae7cc3298d4e34$export$5d29dbb36868dff4 = {
    name: 'opsgenie-schedule-redirect',
    path: '/projects/:projectKey',
    query: [
        'selectedItem=com.atlassian.jira.jira-projects-plugin:opsgenie-schedule-page'
    ]
};

});

parcelRegister("fyMYi", function(module, exports) {

$parcel$export(module.exports, "LazyOpsGenieSchedule", () => $aa55fbc557add2b7$export$3a9c3ff70731bdd6);
$parcel$export(module.exports, "OpsgenieScheduleRedirect", () => $aa55fbc557add2b7$export$6ffd640c3062d976);
$parcel$export(module.exports, "default", () => $aa55fbc557add2b7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $dRTnK = parcelRequire("dRTnK");

const $aa55fbc557add2b7$export$3a9c3ff70731bdd6 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("clgde"))), {
    moduleId: "./src/packages/spa-apps/project/opsgenie-schedule/src/index.tsx"
});
const $aa55fbc557add2b7$export$6ffd640c3062d976 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dRTnK.RedirectToProjectType), {
        page: "/on-call-schedule"
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$aa55fbc557add2b7$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $aa55fbc557add2b7$export$3a9c3ff70731bdd6,
        pageId: "opsgenie-schedule",
        shouldShowSpinner: true
    });

});
parcelRegister("dRTnK", function(module, exports) {

$parcel$export(module.exports, "RedirectToProjectType", () => $f4de23917d090f8e$export$8a3df560509448b8);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dxCvy = parcelRequire("dxCvy");

var $bVDE5 = parcelRequire("bVDE5");

var $7tQej = parcelRequire("7tQej");
var $2YP9W = parcelRequire("2YP9W");
var $doZTA = parcelRequire("doZTA");
const $f4de23917d090f8e$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $7tQej.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $8zOmE.fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, $2NMNM.useAnalyticsEvents), useResource: useResource = (0, $2YP9W.useResource), useRouter: useRouter = (0, $doZTA.useRouter), useSpaStateTransition: useSpaStateTransition = (0, $bVDE5.useSpaStateTransition) })=>{
    const [{ match: match, query: query, route: route }] = useRouter();
    const { data: data } = useResource((0, $dxCvy.projectContextResource));
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
    (0, $5uXOq.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $2vSU6.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $2vSU6.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};

});

parcelRegister("clgde", function(module, exports) {

let $8fc405a4f222cb9b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8fc405a4f222cb9b$var$load("km7JB").then(()=>parcelRequire('dz9Sq'));

});



parcelRegister("SvIen", function(module, exports) {

$parcel$export(module.exports, "opsgenieScheduleRouteEntry", () => $54b4aa3079c12c39$export$f128c1c4a1f0d631);

var $e4eHl = parcelRequire("e4eHl");

var $ffza4 = parcelRequire("ffza4");

var $7XYc4 = parcelRequire("7XYc4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $5lsNZ = parcelRequire("5lsNZ");

var $lco6K = parcelRequire("lco6K");

var $kfztd = parcelRequire("kfztd");

var $5f2bR = parcelRequire("5f2bR");

var $fyMYi = parcelRequire("fyMYi");
const $54b4aa3079c12c39$export$f128c1c4a1f0d631 = (0, $7NszV.createEntry)((0, $lco6K.opsgenieScheduleRoute), ()=>({
        group: 'components',
        ufoName: 'project-opsgenie-schedule',
        component: (0, $7XYc4.componentWithCondition)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $fyMYi.default)),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: [
                (0, $koWFd.default),
                (0, $9s3j1.default)
            ],
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fyMYi.LazyOpsGenieSchedule)
        ],
        meta: {
            reporting: {
                id: 'opsgenie-schedule',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('opsgenie-schedule'),
                teamName: 'fusion-solaris'
            }
        }
    }));

});
parcelRegister("lco6K", function(module, exports) {

$parcel$export(module.exports, "opsgenieScheduleRoute", () => $3d5ce45adc18efc0$export$534a7ac096cb1da2);
const $3d5ce45adc18efc0$export$534a7ac096cb1da2 = {
    name: 'opsgenie-schedule',
    path: '/jira/:projectType(software|software/c)/projects/:projectKey/on-call-schedule'
};

});


parcelRegister("frn0U", function(module, exports) {

$parcel$export(module.exports, "peopleProfilesRouteEntry", () => $ec3623cf53188008$export$219b6cc00b2f91a0);

var $6s1PB = parcelRequire("6s1PB");

var $2BrOV = parcelRequire("2BrOV");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $5UHoB = parcelRequire("5UHoB");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $fDWVs = parcelRequire("fDWVs");

var $6Z2mh = parcelRequire("6Z2mh");

var $7HAuv = parcelRequire("7HAuv");
const $ec3623cf53188008$var$peopleProfilesPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7HAuv.peopleProfilesEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PEOPLE
});
const $ec3623cf53188008$export$219b6cc00b2f91a0 = (0, $7NszV.createEntry)((0, $fDWVs.peopleProfilesRoute), ()=>({
        group: 'people-profiles',
        layout: (0, $5UHoB.layoutWithCondition)(()=>(0, $6s1PB.expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation'), (0, $6Z2mh.rightSidebarsLayout), (0, $2BrOV.globalLayout)),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        ufoName: 'people-profiles',
        entryPoint: ()=>$ec3623cf53188008$var$peopleProfilesPageEntrypoint
    }));

});
parcelRegister("5UHoB", function(module, exports) {

$parcel$export(module.exports, "layoutWithCondition", () => $201222bac9c3aac5$export$c5db53e93ba35c0f);
const $201222bac9c3aac5$export$c5db53e93ba35c0f = (conditionGetter, itemTrue, itemFalse)=>({
        get isChromeless () {
            return conditionGetter() ? itemTrue.isChromeless : itemFalse.isChromeless;
        },
        get globalComponents () {
            return conditionGetter() ? itemTrue.globalComponents : itemFalse.globalComponents;
        },
        get rightSidebars () {
            return conditionGetter() ? itemTrue.rightSidebars : itemFalse.rightSidebars;
        }
    });

});

parcelRegister("7HAuv", function(module, exports) {

$parcel$export(module.exports, "peopleProfilesEntrypoint", () => $4e67e105bb4b4bfb$export$26daeb77c71acf79);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $4e67e105bb4b4bfb$export$26daeb77c71acf79 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        if (!false) return (parcelRequire("aPDfm"));
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "871dfc54"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("aPDfm", function(module, exports) {

let $7e2d1c5e141e1b33$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $7e2d1c5e141e1b33$var$load("ffQaD"),
    $7e2d1c5e141e1b33$var$load("kvRbA"),
    $7e2d1c5e141e1b33$var$load("kVX56"),
    $7e2d1c5e141e1b33$var$load("7mIf9"),
    $7e2d1c5e141e1b33$var$load("jXweD"),
    $7e2d1c5e141e1b33$var$load("fliVL"),
    $7e2d1c5e141e1b33$var$load("ieefZ")
]).then(()=>parcelRequire('3sora'));

});



parcelRegister("fH16o", function(module, exports) {

$parcel$export(module.exports, "generalPersonalSettingsRouteEntry", () => $c84e53d16eb519d5$export$e8b7e9281fc3db35);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $cRWZh = parcelRequire("cRWZh");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $7ziML = parcelRequire("7ziML");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $4XFHO = parcelRequire("4XFHO");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $c84e53d16eb519d5$var$LazyGeneralPersonalSettings = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("6SrH0"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/personal-settings/general/src/index.tsx"
});
const $c84e53d16eb519d5$var$GeneralPersonalSettingsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $c84e53d16eb519d5$var$LazyGeneralPersonalSettings,
        pageId: "personal-settings-general",
        shouldShowSpinner: true
    });
const $c84e53d16eb519d5$export$e8b7e9281fc3db35 = (0, $7NszV.createEntry)((0, $7ziML.generalPersonalSettingsRoute), ()=>({
        group: 'personal-settings',
        component: $c84e53d16eb519d5$var$GeneralPersonalSettingsComponent,
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PERSONAL_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PROFILE,
            sidebar: (0, $cRWZh.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $4XFHO.getLabsResources)(),
            ...(0, $5bkvv.getNavigationForgePersonalSettingsPageResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $c84e53d16eb519d5$var$LazyGeneralPersonalSettings
        ]
    }));

});
parcelRegister("4XFHO", function(module, exports) {

$parcel$export(module.exports, "getLabsResources", () => $0f10f97c7a06e4e8$export$18345571aa12a367);

var $c04PQ = parcelRequire("c04PQ");

var $eOlBz = parcelRequire("eOlBz");

var $ipmBb = parcelRequire("ipmBb");

var $gNStA = parcelRequire("gNStA");
const $0f10f97c7a06e4e8$export$18345571aa12a367 = ()=>[
        (0, $eOlBz.newIssueViewTransitionLockInStatusResource),
        (0, $gNStA.resourceWithCondition2)(()=>!(0, $c04PQ.isFedRamp)(), (0, $ipmBb.nextBestTaskFeatureResource))
    ];

});
parcelRegister("ipmBb", function(module, exports) {

$parcel$export(module.exports, "nextBestTaskFeatureResource", () => $b97b42683de1c9b3$export$5d472f7d515300ca);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");

const $b97b42683de1c9b3$export$5d472f7d515300ca = (0, $2M1hQ.createResource)({
    type: (0, $167b031bfd6a6b6e$export$6f0555de4f60e84e),
    getKey: ()=>(0, $167b031bfd6a6b6e$export$7e7d7930e22ba39f),
    getData: async ()=>{
        try {
            return await (0, $eusud.performGetRequest)(`/rest/api/3/mypreferences?key=${(0, $167b031bfd6a6b6e$export$b94951a11282ae6a)}`);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const initialValueNeverSet = error.statusCode === 404;
            if (initialValueNeverSet) /**
				 * If the user has never set the preference, we auto enroll them and set the initial value to true.
				 */ return {
                hasUserOptedIn: true
            };
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: (0, $167b031bfd6a6b6e$export$7f111648ca05f056),
                    packageName: (0, $167b031bfd6a6b6e$export$b8b9d90f9e5bd72b)
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        /* on error return false,
		 * this ensures if user is in the experiment cohort but later opted out, they don't revert to having the feature enabled */ return {
            hasUserOptedIn: false
        };
    },
    maxAge: Number.MAX_VALUE
});

});
const $167b031bfd6a6b6e$export$6f0555de4f60e84e = 'RESOURCE_TYPE_NEXT_BEST_TASK_FEATURE';
const $167b031bfd6a6b6e$export$7e7d7930e22ba39f = 'nbt-opt-in-resource-key'; // value is global for user
const $167b031bfd6a6b6e$export$b94951a11282ae6a = 'next-best-task-feature';
const $167b031bfd6a6b6e$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesNextBestTask';
const $167b031bfd6a6b6e$export$7f111648ca05f056 = 'useResource.fetchNextBestTaskOptInPreference';



parcelRegister("6SrH0", function(module, exports) {

let $501d446920821a1a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $501d446920821a1a$var$load("jlJ8d").then(()=>parcelRequire('6keru'));

});


parcelRegister("5YggO", function(module, exports) {

$parcel$export(module.exports, "notificationsPersonalSettingsRouteEntry", () => $6f6984c8da820d1e$export$640c1b3b96c9032e);

var $5uXOq = parcelRequire("5uXOq");

var $lkFvK = parcelRequire("lkFvK");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $cRWZh = parcelRequire("cRWZh");

var $1C2yb = parcelRequire("1C2yb");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $d1xZH = parcelRequire("d1xZH");

var $ds5qV = parcelRequire("ds5qV");

var $a94gn = parcelRequire("a94gn");

var $h1H2H = parcelRequire("h1H2H");
const $6f6984c8da820d1e$var$personalSettingsNotificationsEntryPointPage = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $h1H2H.personalSettingsNotificationsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).NOTIFICATIONS
});
const $6f6984c8da820d1e$export$640c1b3b96c9032e = (0, $7NszV.createEntry)((0, $d1xZH.notificationsPersonalSettingsRoute), ()=>({
        group: 'personal-settings',
        skeleton: (0, $a94gn.PersonalSettingsNotificationsAppSkeleton),
        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
                to: (0, $1C2yb.getNotificationsPersonalSettingsPath)()
            }),
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PERSONAL_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PROFILE,
            sidebar: (0, $cRWZh.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $5bkvv.getNavigationForgePersonalSettingsPageResources)()
        ],
        pageId: 'personal-settings-notifications',
        entryPoint () {
            return $6f6984c8da820d1e$var$personalSettingsNotificationsEntryPointPage;
        }
    }));

});
parcelRegister("a94gn", function(module, exports) {

$parcel$export(module.exports, "PersonalSettingsNotificationsAppSkeleton", () => $e165273754ebea11$export$b542eb2d3193b983);
$parcel$export(module.exports, "PersonalSettingsNotificationsGlobalTableSkeleton", () => $e165273754ebea11$export$d58f6bbbc1838cb2);
$parcel$export(module.exports, "ProjectNotificationAccordionSkeleton", () => $e165273754ebea11$export$8cb773cb6fc17338);
/* PersonalSettingsNotificationsAppSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hCy6k = parcelRequire("hCy6k");

var $8JjKV = parcelRequire("8JjKV");

var $6kNmt = parcelRequire("6kNmt");

var $lBT69 = parcelRequire("lBT69");

var $7Vzvx = parcelRequire("7Vzvx");
const $e165273754ebea11$var$maxWidthCssStyles = null;
const $e165273754ebea11$var$customCssStyles = null;
const $e165273754ebea11$export$b542eb2d3193b983 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lBT69))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f8stt"
        ])
    });
const $e165273754ebea11$export$d58f6bbbc1838cb2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e165273754ebea11$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8JjKV))),
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    }));
const $e165273754ebea11$export$46fc11a564484c9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e165273754ebea11$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6kNmt))),
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    }));
const $e165273754ebea11$export$8cb773cb6fc17338 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e165273754ebea11$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7Vzvx))),
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e165273754ebea11$var$SkeletonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_c71ldgin _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8JjKV", function(module, exports) {
module.exports = new URL("global-table-skeleton-with-projects.tpl.5a5d24b9.svg", import.meta.url).toString();

});

parcelRegister("6kNmt", function(module, exports) {
module.exports = new URL("mimetype-skeleton.tpl.8b750352.svg", import.meta.url).toString();

});

parcelRegister("lBT69", function(module, exports) {
module.exports = new URL("personal-settings-notifications-app-skeleton-with-projects.tpl.d18b3c58.svg", import.meta.url).toString();

});

parcelRegister("7Vzvx", function(module, exports) {
module.exports = new URL("project-accordion-skeleton.tpl.cee2df62.svg", import.meta.url).toString();

});


parcelRegister("h1H2H", function(module, exports) {

$parcel$export(module.exports, "personalSettingsNotificationsEntryPoint", () => $0e73b796ef7555dc$export$44d710abd316d1f1);

var $7P45F = parcelRequire("7P45F");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $0e73b796ef7555dc$export$44d710abd316d1f1 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("lKoxX")), {
        moduleId: "fe0c927e"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            // Queries your async component uses
            queries: {
                pageAndProject: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $7P45F.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectIds: context.query?.projectIds ? context.query.projectIds.split(',') : []
                    }
                }
            },
            // Optional - Anything extra you wish to pass to your component
            // Something from `EntryPointParams` for example
            extraProps: {
                accountId: tenantContext.atlassianAccountId
            }
        })
});

});
parcelRegister("7P45F", function(module, exports) {

$parcel$export(module.exports, "default", () => $49af4b582b9c7470$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<65f7487bbf2166c21de5aefdce342ece>>
 * @relayHash 0ace672294c09b398fb8d4f0e7526c83
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b7fd514c01c704c310af24b4bec2490f86683eb6f578c5e61833c2151685f3ba

var $jA1kf = parcelRequire("jA1kf");
const $49af4b582b9c7470$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = [
        v1 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "xsmall"
                }
            ]
        }
    ], v6 = [
        {
            "kind": "ScalarField",
            "name": "channel"
        },
        {
            "kind": "ScalarField",
            "name": "isEnabled"
        },
        {
            "kind": "ScalarField",
            "name": "isEditable"
        }
    ], v7 = [
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "concreteType": "JiraNotificationChannel",
            "kind": "LinkedField",
            "name": "emailChannel",
            "plural": false,
            "selections": v6 /*: any*/ 
        },
        {
            "concreteType": "JiraNotificationChannel",
            "kind": "LinkedField",
            "name": "inProductChannel",
            "plural": false,
            "selections": v6 /*: any*/ 
        },
        {
            "kind": "ScalarField",
            "name": "category"
        }
    ], v8 = {
        "concreteType": "JiraNotificationPreferences",
        "kind": "LinkedField",
        "name": "preferences",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueAssigned",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueUpdated",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueDeleted",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "commentCreated",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "commentEdited",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "commentDeleted",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueCreated",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueMoved",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "mentionsCombined",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "worklogCombined",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "miscellaneousIssueEventCombined",
                "plural": false,
                "selections": v7 /*: any*/ 
            }
        ]
    }, v9 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ui_NotificationsPageAndProjectQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "projectNotificationsConfig_personalSettingsNotificationsConfigTable_projects"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraNotificationGlobalPreference",
                                    "kind": "LinkedField",
                                    "name": "notificationGlobalPreference",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "globalNotificationsConfigTable_personalSettingsNotificationsConfigTable_GlobalNotificationConfigTableNew"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraNotificationOptions",
                                                "kind": "LinkedField",
                                                "name": "options",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "notificationPreferencesOptionsWrapper_personalSettingsPreferenceFields_NotificationPreferencesOptions"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.notificationGlobalPreference.options"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.notificationGlobalPreference"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "ui_NotificationsPageAndProjectQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraNotificationProjectPreferenceConnection",
                            "kind": "LinkedField",
                            "name": "allNotificationProjectPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectNotificationPreferenceEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNotificationProjectPreferences",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": v5 /*: any*/ 
                                                },
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalCount"
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                v9 /*: any*/ 
                            ]
                        },
                        {
                            "args": v3 /*: any*/ ,
                            "filters": [
                                "cloudId"
                            ],
                            "handle": "connection",
                            "key": "projects_allNotificationProjectPreferences",
                            "kind": "LinkedHandle",
                            "name": "allNotificationProjectPreferences"
                        },
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraNotificationGlobalPreference",
                            "kind": "LinkedField",
                            "name": "notificationGlobalPreference",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraNotificationOptions",
                                    "kind": "LinkedField",
                                    "name": "options",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEmailNotificationEnabled"
                                        },
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "notifyWhenRoleAssigneeEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "notifyWhenRoleReporterEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "notifyOwnChangesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "batchWindow"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "dailyBatchLocalTime"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "emailMimeType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEmailMimeTypeEditable"
                                        }
                                    ]
                                },
                                v8 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "allJiraProjectsForModal",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "notificationConfigurationState": "DEFAULT",
                                        "sortBy": {
                                            "sortBy": "NAME"
                                        }
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 5
                                }
                            ],
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b7fd514c01c704c310af24b4bec2490f86683eb6f578c5e61833c2151685f3ba",
            "metadata": {},
            "name": "ui_NotificationsPageAndProjectQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider": (0, $jA1kf.default)
            }
        }
    };
}();
$49af4b582b9c7470$var$node.hash = "b001322577b49b90b0c0e44082f4b2b8";
var $49af4b582b9c7470$export$2e2bcd8739ae039 = $49af4b582b9c7470$var$node;

});
parcelRegister("jA1kf", function(module, exports) {

$parcel$export(module.exports, "default", () => $349f2b9cab96c314$export$2e2bcd8739ae039);
var $349f2b9cab96c314$export$2e2bcd8739ae039 = {
    get () {
        return true;
    }
};

});


parcelRegister("lKoxX", function(module, exports) {

let $fd50ef569156e377$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fd50ef569156e377$var$load("17nZz").then(()=>parcelRequire('4DJNq'));

});



parcelRegister("g3kqr", function(module, exports) {

$parcel$export(module.exports, "opsNotificationsPersonalSettingsRouteEntry", () => $cb843413a571a269$export$407513e3bdb49efe);

var $5uXOq = parcelRequire("5uXOq");

var $8ytTF = parcelRequire("8ytTF");

var $gk6PH = parcelRequire("gk6PH");

var $1Xcuw = parcelRequire("1Xcuw");parcelRequire("jxRF2");
var $ldKOT = parcelRequire("ldKOT");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $cRWZh = parcelRequire("cRWZh");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $8tZGz = parcelRequire("8tZGz");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $eZXFU = parcelRequire("eZXFU");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $cb843413a571a269$var$LazyOpsNotificationsPersonalSettings = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("1cOkR"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/personal-settings/ops-notifications/src/index.tsx"
});
const $cb843413a571a269$var$OpsNotificationsPersonalSettingsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cb843413a571a269$var$LazyOpsNotificationsPersonalSettings,
        pageId: "personal-settings-notifications",
        shouldShowSpinner: true
    });
const $cb843413a571a269$export$407513e3bdb49efe = (0, $7NszV.createEntry)((0, $8tZGz.opsNotificationsPersonalSettingsRoute), ()=>({
        group: 'personal-settings',
        component: $cb843413a571a269$var$OpsNotificationsPersonalSettingsComponent,
        layout: (0, $eZXFU.opsNotificationsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PERSONAL_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PROFILE,
            sidebar: (0, $cRWZh.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $8ytTF.createContactsResource)(),
            (0, $1Xcuw.createNotificationPreferencesResource)(),
            (0, $ldKOT.eocUserResource),
            (0, $gk6PH.createMuteResource)(),
            (0, $gk6PH.createQuietHoursResource)(),
            (0, $1Xcuw.createForwardingRulesResource)(),
            ...(0, $5bkvv.getNavigationForgePersonalSettingsPageResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $cb843413a571a269$var$LazyOpsNotificationsPersonalSettings
        ]
    }));

});
parcelRegister("8tZGz", function(module, exports) {

$parcel$export(module.exports, "opsNotificationsPersonalSettingsRoute", () => $84075aa9af41e0be$export$68ebdd4eccb7b383);
const $84075aa9af41e0be$export$68ebdd4eccb7b383 = {
    name: 'personal-settings-ops-notifications',
    path: '/jira/settings/personal/alert-notifications'
};

});

parcelRegister("1cOkR", function(module, exports) {

let $0e0df507dd5a0fbe$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0e0df507dd5a0fbe$var$load("ffQaD"),
    $0e0df507dd5a0fbe$var$load("kvRbA"),
    $0e0df507dd5a0fbe$var$load("76n7a"),
    $0e0df507dd5a0fbe$var$load("l253H"),
    $0e0df507dd5a0fbe$var$load("8svwN")
]).then(()=>parcelRequire('aV66n'));

});


parcelRegister("d4tTc", function(module, exports) {

$parcel$export(module.exports, "digestsNotificationsPersonalSettingsRouteEntry", () => $c698e0e2618894a9$export$6ff00ce079beb0ed);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $cRWZh = parcelRequire("cRWZh");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $b5ISR = parcelRequire("b5ISR");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $c698e0e2618894a9$var$LazyDigestsNotificationsPersonalSettings = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("6iV1I"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/personal-settings/digests-notifications/src/index.tsx"
});
const $c698e0e2618894a9$var$DigestsNotificationsPersonalSettingsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $c698e0e2618894a9$var$LazyDigestsNotificationsPersonalSettings,
        pageId: "personal-settings-notifications",
        shouldShowSpinner: true
    });
const $c698e0e2618894a9$export$6ff00ce079beb0ed = (0, $7NszV.createEntry)((0, $b5ISR.digestsNotificationsPersonalSettingsRoute), ()=>({
        group: 'personal-settings',
        component: $c698e0e2618894a9$var$DigestsNotificationsPersonalSettingsComponent,
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PERSONAL_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PROFILE,
            sidebar: (0, $cRWZh.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $c698e0e2618894a9$var$LazyDigestsNotificationsPersonalSettings
        ]
    }));

});
parcelRegister("b5ISR", function(module, exports) {

$parcel$export(module.exports, "digestsNotificationsPersonalSettingsRoute", () => $8043a136b458bb05$export$36b31d006b9456a1);
const $8043a136b458bb05$export$36b31d006b9456a1 = {
    name: 'personal-settings-digests',
    path: '/jira/settings/personal/digests'
};

});

parcelRegister("6iV1I", function(module, exports) {

let $4970a8d3588a7c4a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4970a8d3588a7c4a$var$load("hgbUB").then(()=>parcelRequire('erUXM'));

});


parcelRegister("lPLcB", function(module, exports) {

$parcel$export(module.exports, "personalSettingsRouteEntry", () => $4a98174db89ed9a9$export$89646e32fa7698db);

var $5uXOq = parcelRequire("5uXOq");

var $8ytTF = parcelRequire("8ytTF");

var $gk6PH = parcelRequire("gk6PH");

var $1Xcuw = parcelRequire("1Xcuw");parcelRequire("jxRF2");
var $ldKOT = parcelRequire("ldKOT");

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $1C2yb = parcelRequire("1C2yb");

var $7NszV = parcelRequire("7NszV");


var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $bCvq0 = parcelRequire("bCvq0");

var $ds5qV = parcelRequire("ds5qV");

var $7yO8g = parcelRequire("7yO8g");

var $kxZPA = parcelRequire("kxZPA");

var $9wNN8 = parcelRequire("9wNN8");

var $4XFHO = parcelRequire("4XFHO");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4a98174db89ed9a9$var$LazyLegacyPersonalSettings = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hXqvZ"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/personal-settings-legacy/src/index.tsx"
});
const $4a98174db89ed9a9$export$89646e32fa7698db = (0, $7NszV.createEntry)((0, $bCvq0.personalSettingsRoute), ()=>({
        group: 'personal-settings',
        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
                to: (0, $1C2yb.GENERAL_PERSONAL_SETTINGS_PATH)
            }),
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).PERSONAL_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PROFILE
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $8ytTF.createContactsResource)((0, $9wNN8.checkConsolidationOnRouteDependency), [
                (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
            ]),
            (0, $1Xcuw.createNotificationPreferencesResource)((0, $9wNN8.checkConsolidationOnRouteDependency), [
                (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
            ]),
            (0, $ldKOT.eocUserResource),
            (0, $gk6PH.createMuteResource)((0, $9wNN8.checkConsolidationOnRouteDependency), [
                (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
            ]),
            (0, $gk6PH.createQuietHoursResource)((0, $9wNN8.checkConsolidationOnRouteDependency), [
                (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
            ]),
            (0, $1Xcuw.createForwardingRulesResource)((0, $9wNN8.checkConsolidationOnRouteDependency), [
                (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
            ]),
            ...(0, $5bkvv.getNavigationForgePersonalSettingsPageResources)(),
            ...(0, $4XFHO.getLabsResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $4a98174db89ed9a9$var$LazyLegacyPersonalSettings
        ]
    }));

});
parcelRegister("bCvq0", function(module, exports) {

$parcel$export(module.exports, "personalSettingsRoute", () => $03113dbc73778b4c$export$176d0935b95c75e8);
const $03113dbc73778b4c$export$176d0935b95c75e8 = {
    name: 'personal-settings',
    path: '/secure/ViewPersonalSettings.jspa'
};

});

parcelRegister("9wNN8", function(module, exports) {

$parcel$export(module.exports, "checkConsolidationOnRouteDependency", () => $d103219a16ecaa90$export$ac86a769188afd33);

var $3H5ry = parcelRequire("3H5ry");

const $d103219a16ecaa90$export$ac86a769188afd33 = (dependencies)=>{
    const { data: data } = dependencies[0, $5a94e356f9d5e220$export$25ee35b01de9d734];
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $3H5ry.checkShouldUseJSM)(data);
};

});

parcelRegister("hXqvZ", function(module, exports) {

let $d12c83a70732e3f9$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d12c83a70732e3f9$var$load("kVX56"),
    $d12c83a70732e3f9$var$load("4lvCC")
]).then(()=>parcelRequire('3hooO'));

});


parcelRegister("3L1EU", function(module, exports) {

$parcel$export(module.exports, "polarisCollectionsRouteEntry", () => $4aedad13e1b8926d$export$a034dc25c21d1029);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $1bDWO = parcelRequire("1bDWO");

var $iI3aS = parcelRequire("iI3aS");
const $4aedad13e1b8926d$export$a034dc25c21d1029 = (0, $7NszV.createEntry)((0, $1bDWO.polarisCollectionsRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'polaris',
        ufoName: 'jpd.collections',
        component: (0, $iI3aS.default),
        layout: (0, $2BrOV.globalLayout),
        canTransitionIn: ()=>{
            // default is no-refresh
            return true;
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $iI3aS.LazyCollectionsPage)
        ]
    }));

});
parcelRegister("1bDWO", function(module, exports) {

$parcel$export(module.exports, "polarisCollectionsRoute", () => $31434a8eaec0208e$export$d415b74f78a5f159);
const $31434a8eaec0208e$export$d415b74f78a5f159 = {
    name: 'polaris-collections',
    path: '/jira/polaris/roadmaps/:collectionUUID?/:section?/:resource?',
    query: [
        'projects?',
        'owners?'
    ],
    exact: true
};

});

parcelRegister("iI3aS", function(module, exports) {

$parcel$export(module.exports, "LazyCollectionsPage", () => $1bfc7c5d195e4066$export$f7960e7dbd7e5265);
$parcel$export(module.exports, "default", () => $1bfc7c5d195e4066$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dWQF5 = parcelRequire("dWQF5");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $9OXo1 = parcelRequire("9OXo1");

var $kxZPA = parcelRequire("kxZPA");

var $7tQej = parcelRequire("7tQej");

const $1bfc7c5d195e4066$export$f7960e7dbd7e5265 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("aZQSW"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris/collections/src/index.tsx"
});
const $1bfc7c5d195e4066$var$useJpdLicensed = ()=>{
    const context = (0, $9OXo1.useTenantContext)();
    return context.licensedProducts['jira-product-discovery'];
};
const $1bfc7c5d195e4066$export$3bba33442c4150b1 = ()=>{
    const jpdLicensed = $1bfc7c5d195e4066$var$useJpdLicensed();
    const crossProjectViewsEnabled = (0, $dWQF5.useIsCrossProjectViewsEnabled)();
    if (!jpdLicensed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: "/jira/polaris/unlicensed"
    });
    if (!crossProjectViewsEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: "/jira"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $1bfc7c5d195e4066$export$f7960e7dbd7e5265,
        pageId: "async-polaris-collections",
        shouldShowSpinner: false
    });
};
var $1bfc7c5d195e4066$export$2e2bcd8739ae039 = $1bfc7c5d195e4066$export$3bba33442c4150b1;

});
parcelRegister("aZQSW", function(module, exports) {

let $80189fc0c148230e$var$load = (parcelRequire("28QjX"))(4);


module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $80189fc0c148230e$var$load("cTJTG"),
            $80189fc0c148230e$var$load("l253H"),
            $80189fc0c148230e$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $80189fc0c148230e$var$load("4Qxp7")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $80189fc0c148230e$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $80189fc0c148230e$var$load("7B2gt")
        ]);
    }),
    $80189fc0c148230e$var$load("7mIf9"),
    $80189fc0c148230e$var$load("jXweD"),
    $80189fc0c148230e$var$load("76n7a"),
    $80189fc0c148230e$var$load("l253H"),
    $80189fc0c148230e$var$load("ffQaD"),
    $80189fc0c148230e$var$load("kvRbA"),
    $80189fc0c148230e$var$load("fliVL"),
    $80189fc0c148230e$var$load("lOpCK")
]).then(()=>parcelRequire('jaSwr'));

});



parcelRegister("g5olQ", function(module, exports) {

$parcel$export(module.exports, "polarisIdeasRouteEntry", () => $a75ffafad7078936$export$26631f98f007b2d2);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $eviST = parcelRequire("eviST");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $1Yu63 = parcelRequire("1Yu63");

var $hO84v = parcelRequire("hO84v");
const $a75ffafad7078936$export$26631f98f007b2d2 = (0, $7NszV.createEntry)((0, $1Yu63.polarisIdeasRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'polaris',
        ufoName: 'jpd.project',
        layout: (0, $eviST.polarisProjectLayout),
        canTransitionIn: ()=>true,
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint () {
            return 0, $hO84v.ideasPageEntryPoint;
        },
        preloadOptions: {
            earlyChunks: [
                'jpd-ideas-early-entry'
            ]
        }
    }));

});
parcelRegister("eviST", function(module, exports) {

$parcel$export(module.exports, "polarisProjectLayout", () => $501e6cef37d28e94$export$d5273c1a2e2fe212);

var $1Du13 = parcelRequire("1Du13");

var $aPfsS = parcelRequire("aPfsS");
const $501e6cef37d28e94$export$d5273c1a2e2fe212 = (0, $aPfsS.composeLayouts)((0, $1Du13.projectLayout));

});

parcelRegister("1Yu63", function(module, exports) {

$parcel$export(module.exports, "polarisIdeasRoute", () => $3378a983c17fef3f$export$54c333cd4ed2d70e);
const $3378a983c17fef3f$export$54c333cd4ed2d70e = {
    name: 'polaris-ideas',
    path: '/jira/polaris/projects/:projectKey/ideas/:section?/:resource?',
    query: [
        'selectedIssue?',
        'issueViewLayout?'
    ],
    exact: true
};

});

parcelRegister("hO84v", function(module, exports) {

$parcel$export(module.exports, "ideasPageEntryPoint", () => $9c1678c5da04bd73$export$aa9a00411f9c3e39);

var $lmyls = parcelRequire("lmyls");

var $lkFvK = parcelRequire("lkFvK");

var $jVaQG = parcelRequire("jVaQG");
const $9c1678c5da04bd73$export$aa9a00411f9c3e39 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $jVaQG.ideasEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("jVaQG", function(module, exports) {

$parcel$export(module.exports, "ideasEntryPoint", () => $5c23c7623190e5b0$export$ffc470fa0659ba16);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $5c23c7623190e5b0$export$ffc470fa0659ba16 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("kfdlF")), {
        moduleId: "3b89e133"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("kfdlF", function(module, exports) {

let $ebcf9014254c95db$var$load = (parcelRequire("28QjX"))(4);


module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $ebcf9014254c95db$var$load("cTJTG"),
            $ebcf9014254c95db$var$load("l253H"),
            $ebcf9014254c95db$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $ebcf9014254c95db$var$load("4Qxp7")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $ebcf9014254c95db$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $ebcf9014254c95db$var$load("7B2gt")
        ]);
    }),
    $ebcf9014254c95db$var$load("7mIf9"),
    $ebcf9014254c95db$var$load("jXweD"),
    $ebcf9014254c95db$var$load("76n7a"),
    $ebcf9014254c95db$var$load("l253H"),
    $ebcf9014254c95db$var$load("ffQaD"),
    $ebcf9014254c95db$var$load("kvRbA"),
    $ebcf9014254c95db$var$load("fliVL"),
    $ebcf9014254c95db$var$load("biBC0")
]).then(()=>parcelRequire('glCkY'));

});




parcelRegister("ecUH3", function(module, exports) {

$parcel$export(module.exports, "polarisOnboardingRouteEntry", () => $9a1e9d5292b9a0dc$export$a297a71cb150e2af);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $aFVvc = parcelRequire("aFVvc");

var $brgR1 = parcelRequire("brgR1");

var $dQc5Q = parcelRequire("dQc5Q");
const $9a1e9d5292b9a0dc$export$a297a71cb150e2af = (0, $7NszV.createEntry)((0, $brgR1.polarisOnboardingRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'polaris',
        component: (0, $dQc5Q.default),
        layout: (0, $2BrOV.globalLayout),
        canTransitionIn: ()=>true,
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $aFVvc.projectCreatePermissionsResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $dQc5Q.LazyOnboardingPage)
        ]
    }));

});
parcelRegister("brgR1", function(module, exports) {

$parcel$export(module.exports, "polarisOnboardingRoute", () => $d7e18a0721187b3f$export$6696e9deb45fe980);
const $d7e18a0721187b3f$export$6696e9deb45fe980 = {
    name: 'polaris-onboarding',
    path: '/welcome/discovery',
    exact: true
};

});

parcelRegister("dQc5Q", function(module, exports) {

$parcel$export(module.exports, "LazyOnboardingPage", () => $ff87f692d7c58a17$export$13889cc3ce0d5a93);
$parcel$export(module.exports, "default", () => $ff87f692d7c58a17$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $ff87f692d7c58a17$export$13889cc3ce0d5a93 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("j3mJn"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris/onboarding/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ff87f692d7c58a17$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ff87f692d7c58a17$export$13889cc3ce0d5a93,
        pageId: "async-polaris-onboarding",
        shouldShowSpinner: false
    });

});
parcelRegister("j3mJn", function(module, exports) {

let $ddefedff4c6cb88e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ddefedff4c6cb88e$var$load("giy0q").then(()=>parcelRequire('2PQGe'));

});



parcelRegister("6okEU", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsAccessRouteEntry", () => $23f05070dbae84f0$export$9c0f51630c25c3d);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $jUKSc = parcelRequire("jUKSc");

var $4csue = parcelRequire("4csue");
const $23f05070dbae84f0$export$9c0f51630c25c3d = (0, $7NszV.createEntry)((0, $jUKSc.polarisSettingsAccessRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'global-settings',
        component: (0, $4csue.AccessSettingsPage),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4csue.LazyAccessSettingsPage)
        ]
    }));

});
parcelRegister("jUKSc", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsAccessRoute", () => $5cb169f7c1c57d8b$export$bfdcdf76e802d67d);
const $5cb169f7c1c57d8b$export$bfdcdf76e802d67d = {
    name: 'polaris-settings-access',
    path: '/jira/settings/products/jira-product-discovery/access',
    exact: true
};

});

parcelRegister("4csue", function(module, exports) {

$parcel$export(module.exports, "LazyAccessSettingsPage", () => $ff4634525ed299f8$export$b66ea0dcd38af7f0);
$parcel$export(module.exports, "AccessSettingsPage", () => $ff4634525ed299f8$export$d46497fe68b0853c);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $ff4634525ed299f8$export$b66ea0dcd38af7f0 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("c7uoK"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris/settings-access/src/index.tsx"
});
const $ff4634525ed299f8$export$d46497fe68b0853c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ff4634525ed299f8$export$b66ea0dcd38af7f0,
        pageId: "async-polaris-settings-access",
        shouldShowSpinner: false
    });

});
parcelRegister("c7uoK", function(module, exports) {

let $8d2db7e78fb03a36$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8d2db7e78fb03a36$var$load("25TW9").then(()=>parcelRequire('ab4oe'));

});



parcelRegister("6ElYx", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsViewBlueprintsRouteEntry", () => $e66c079ef35da565$export$3a434d3b47ab1779);

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $4R6GH = parcelRequire("4R6GH");

var $5lsNZ = parcelRequire("5lsNZ");

var $3RJkv = parcelRequire("3RJkv");

var $cn2EV = parcelRequire("cn2EV");

var $g1n0t = parcelRequire("g1n0t");
const $e66c079ef35da565$export$3a434d3b47ab1779 = (0, $7NszV.createEntry)((0, $cn2EV.polarisSettingsViewBlueprintsRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'global-settings',
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        component: (0, $5lsNZ.default),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        entryPoint () {
            return (0, $4R6GH.fg)('jpd-view-templates-sample-project') ? (0, $g1n0t.polarisProductViewBlueprintsSettingsPageEntryPoint) : undefined;
        }
    }));

});
parcelRegister("cn2EV", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsViewBlueprintsRoute", () => $edb522df64f463be$export$8a86f742c99c33c);
const $edb522df64f463be$export$8a86f742c99c33c = {
    name: 'polaris-settings-view-blueprints',
    path: '/jira/settings/products/jira-product-discovery/view-blueprints',
    exact: true
};

});

parcelRegister("g1n0t", function(module, exports) {

$parcel$export(module.exports, "polarisProductViewBlueprintsSettingsPageEntryPoint", () => $dab74faa23cd301e$export$b38d612b8eddc59a);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $a8Qvh = parcelRequire("a8Qvh");
const $dab74faa23cd301e$export$b38d612b8eddc59a = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $a8Qvh.polarisProductViewBlueprintsSettingsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).SETTINGS
});

});
parcelRegister("a8Qvh", function(module, exports) {

$parcel$export(module.exports, "polarisProductViewBlueprintsSettingsEntryPoint", () => $423dbee6f0d25e86$export$39c56d81a6a3e673);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $423dbee6f0d25e86$export$39c56d81a6a3e673 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("eXAgS")), {
        moduleId: "a9a1a8f1",
        moduleName: "PolarisViewBlueprintsSettingsPage"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("eXAgS", function(module, exports) {

let $ae42b61112ce48db$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ae42b61112ce48db$var$load("df3Va").then(()=>parcelRequire('lWvfd'));

});




parcelRegister("9YDUs", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsGlobalFieldsRouteEntry", () => $8b674ae9037c6c90$export$e29465c661741392);

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $ieDqa = parcelRequire("ieDqa");

var $6gpmn = parcelRequire("6gpmn");
const $8b674ae9037c6c90$export$e29465c661741392 = (0, $7NszV.createEntry)((0, $ieDqa.polarisSettingsGlobalFieldsRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'global-settings',
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        entryPoint () {
            return 0, $6gpmn.polarisProductGlobalFieldsSettingsPageEntryPoint;
        }
    }));

});
parcelRegister("ieDqa", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsGlobalFieldsRoute", () => $1d178fd38105ca54$export$d1d77b6a84982ab8);
const $1d178fd38105ca54$export$d1d77b6a84982ab8 = {
    name: 'polaris-settings-global-fields',
    path: '/jira/settings/products/jira-product-discovery/global-fields',
    exact: true
};

});

parcelRegister("6gpmn", function(module, exports) {

$parcel$export(module.exports, "polarisProductGlobalFieldsSettingsPageEntryPoint", () => $dd5db072b96b7a9a$export$c682ebcd2290352f);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $gZZ5s = parcelRequire("gZZ5s");
const $dd5db072b96b7a9a$export$c682ebcd2290352f = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $gZZ5s.polarisProductGlobalFieldsSettingsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).SETTINGS
});

});
parcelRegister("gZZ5s", function(module, exports) {

$parcel$export(module.exports, "polarisProductGlobalFieldsSettingsEntryPoint", () => $7946c690dff6c696$export$f2f24531058bc251);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $7946c690dff6c696$export$f2f24531058bc251 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("lBv9x")), {
        moduleId: "fead11bc"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lBv9x", function(module, exports) {

let $fba537fefc1d203d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fba537fefc1d203d$var$load("dYILR").then(()=>parcelRequire('b26tT'));

});




parcelRegister("gAq9g", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsEarlyAccessFeaturesRouteEntry", () => $bf181a7631938891$export$986710683a071056);

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $6HnX2 = parcelRequire("6HnX2");

var $9EMQz = parcelRequire("9EMQz");
const $bf181a7631938891$export$986710683a071056 = (0, $7NszV.createEntry)((0, $6HnX2.polarisSettingsEarlyAccessFeaturesRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'global-settings',
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        entryPoint () {
            return 0, $9EMQz.polarisProductEAPSettingsPageEntryPoint;
        }
    }));

});
parcelRegister("6HnX2", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsEarlyAccessFeaturesRoute", () => $33928478759c7483$export$19bd38107b2ac64b);
const $33928478759c7483$export$19bd38107b2ac64b = {
    name: 'polaris-settings-early-access-features',
    path: '/jira/settings/products/jira-product-discovery/early-access-features',
    exact: true
};

});

parcelRegister("9EMQz", function(module, exports) {

$parcel$export(module.exports, "polarisProductEAPSettingsPageEntryPoint", () => $b121880695e6f137$export$1bd9d2b1f32dc9ee);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $7fx7L = parcelRequire("7fx7L");
const $b121880695e6f137$export$1bd9d2b1f32dc9ee = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7fx7L.polarisProductEAPSettingsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).SETTINGS
});

});
parcelRegister("7fx7L", function(module, exports) {

$parcel$export(module.exports, "polarisProductEAPSettingsEntryPoint", () => $cd1239aae9aba238$export$92df711874ab564a);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $cd1239aae9aba238$export$92df711874ab564a = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("163GN")), {
        moduleId: "e4e16138"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("163GN", function(module, exports) {

let $0cc93697834eba9b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0cc93697834eba9b$var$load("kNl59").then(()=>parcelRequire('exNFO'));

});




parcelRegister("64Fhf", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsFinancialYearRouteEntry", () => $674b4f295352d23a$export$f84465c46e6f4e58);

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $hWe39 = parcelRequire("hWe39");

var $eUjyB = parcelRequire("eUjyB");
const $674b4f295352d23a$export$f84465c46e6f4e58 = (0, $7NszV.createEntry)((0, $hWe39.polarisSettingsFinancialYearRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'global-settings',
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        entryPoint () {
            return 0, $eUjyB.polarisProductFinancialYearSettingsPageEntryPoint;
        }
    }));

});
parcelRegister("hWe39", function(module, exports) {

$parcel$export(module.exports, "polarisSettingsFinancialYearRoute", () => $24110e0dc48b99ee$export$cc594a4ccce25300);
const $24110e0dc48b99ee$export$cc594a4ccce25300 = {
    name: 'polaris-settings-financial-year',
    path: '/jira/settings/products/jira-product-discovery/financial-year',
    exact: true
};

});

parcelRegister("eUjyB", function(module, exports) {

$parcel$export(module.exports, "polarisProductFinancialYearSettingsPageEntryPoint", () => $54953d335cd55907$export$b1c132cd756e9b86);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $4vOBH = parcelRequire("4vOBH");
const $54953d335cd55907$export$b1c132cd756e9b86 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $4vOBH.polarisProductFinancialYearSettingsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).SETTINGS
});

});
parcelRegister("4vOBH", function(module, exports) {

$parcel$export(module.exports, "polarisProductFinancialYearSettingsEntryPoint", () => $b962cb3dff43d6f8$export$2e0ef763d6b208ea);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $b962cb3dff43d6f8$export$2e0ef763d6b208ea = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("6UnRY")), {
        moduleId: "47bc544f"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("6UnRY", function(module, exports) {

let $507a7d07925f38dc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $507a7d07925f38dc$var$load("aeyGa").then(()=>parcelRequire('cqP15'));

});




parcelRegister("h3JFI", function(module, exports) {

$parcel$export(module.exports, "polarisUnlicensedRouteEntry", () => $ed78a6ddbb53401e$export$f975154b9b0ce777);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $aFVvc = parcelRequire("aFVvc");

var $aBsar = parcelRequire("aBsar");

var $5gkML = parcelRequire("5gkML");
const $ed78a6ddbb53401e$export$f975154b9b0ce777 = (0, $7NszV.createEntry)((0, $aBsar.polarisUnlicensedRoute), ()=>({
        isStrictModeEnabled: false,
        group: 'polaris',
        component: (0, $5gkML.default),
        layout: (0, $2BrOV.globalLayout),
        canTransitionIn: ()=>true,
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $aFVvc.projectCreatePermissionsResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5gkML.LazyUnlicensedPage)
        ]
    }));

});
parcelRegister("aBsar", function(module, exports) {

$parcel$export(module.exports, "polarisUnlicensedRoute", () => $451d03603cca57ae$export$32b1bc71501d2751);
const $451d03603cca57ae$export$32b1bc71501d2751 = {
    name: 'polaris-unlicensed',
    path: '/jira/polaris/unlicensed',
    exact: true
};

});

parcelRegister("5gkML", function(module, exports) {

$parcel$export(module.exports, "LazyUnlicensedPage", () => $14579de685a40428$export$394984ca86b38b8f);
$parcel$export(module.exports, "default", () => $14579de685a40428$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $14579de685a40428$export$394984ca86b38b8f = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("gPXeU"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris/unlicensed/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$14579de685a40428$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $14579de685a40428$export$394984ca86b38b8f,
        pageId: "async-polaris-unlicensed",
        shouldShowSpinner: false
    });

});
parcelRegister("gPXeU", function(module, exports) {

let $c41f5c821fd0788b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c41f5c821fd0788b$var$load("jiGTm").then(()=>parcelRequire('5KpQH'));

});



parcelRegister("tdrXl", function(module, exports) {

$parcel$export(module.exports, "productsJsmChatopsAndVideosToolsRouteEntry", () => $4e0ccc70ab88c05a$export$8b55e723205ec5f3);

var $c04PQ = parcelRequire("c04PQ");

var $ffza4 = parcelRequire("ffza4");

var $7XYc4 = parcelRequire("7XYc4");

var $eZXFU = parcelRequire("eZXFU");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $5lsNZ = parcelRequire("5lsNZ");

var $1pjne = parcelRequire("1pjne");

var $2Fj5v = parcelRequire("2Fj5v");

var $hUyS9 = parcelRequire("hUyS9");

var $4R6GH = parcelRequire("4R6GH");

var $7s8Fa = parcelRequire("7s8Fa");

var $3HwlS = parcelRequire("3HwlS");

var $j78rb = parcelRequire("j78rb");
const $4e0ccc70ab88c05a$var$getNavigationSpecifications = ()=>{
    return ((0, $4R6GH.fg)('operations_nav4_remaining_items_old_navigation_fix') ? (0, $3HwlS.getWillShowNav4)() : true) && (0, $4R6GH.fg)('operations_nav4_remaining_items') ? {
        sidebarId: (0, $lmyls.SIDEBAR_ID).OPERATIONS_GENERAL_CONFIGURATION
    } : {
        sidebar: (0, $2Fj5v.default),
        horizontal: (0, $hUyS9.AsyncHorizontalOperationsConfigurationNav),
        onlyShowHorizontalOnNav4: true
    };
};
const $4e0ccc70ab88c05a$export$8b55e723205ec5f3 = (0, $7NszV.createEntry)((0, $1pjne.productsJsmChatopsAndVideosToolsRoute), ()=>({
        group: 'global-settings',
        component: (0, $7XYc4.componentWithCondition)((0, $c04PQ.isFedRamp), (0, $5lsNZ.default), (0, $j78rb.default)),
        layout: (0, $eZXFU.opsSettingsLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            ...$4e0ccc70ab88c05a$var$getNavigationSpecifications()
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: (0, $4R6GH.fg)('operations_nav4_remaining_items') ? [
            (0, $7s8Fa.LazySidebarContent),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $j78rb.LazyProductsJsmChatopsAndVideoTools)
        ] : [
            (0, $hUyS9.LazyHorizontalOperationsConfigurationNav),
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $j78rb.LazyProductsJsmChatopsAndVideoTools)
        ]
    }));

});
parcelRegister("1pjne", function(module, exports) {

$parcel$export(module.exports, "productsJsmChatopsAndVideosToolsRoute", () => $233b8dbf88e7279c$export$7c663ddc097df1e8);
const $233b8dbf88e7279c$export$7c663ddc097df1e8 = {
    name: 'products-jsm-chatops-and-videos-tools',
    path: '/jira/settings/products/ops/jira-service-management-chatops-and-video-tools',
    exact: true
};

});

parcelRegister("j78rb", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmChatopsAndVideoTools", () => $2b1085a0fa643a34$export$1b7f55251df02fe9);
$parcel$export(module.exports, "default", () => $2b1085a0fa643a34$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $2b1085a0fa643a34$export$1b7f55251df02fe9 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("2R1L8"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-chatops-and-video-tools/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2b1085a0fa643a34$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2b1085a0fa643a34$export$1b7f55251df02fe9,
        pageId: "products-jsm-chatops-and-video-tools",
        shouldShowSpinner: false
    });

});
parcelRegister("2R1L8", function(module, exports) {

let $2141e55d8b3f38b9$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2141e55d8b3f38b9$var$load("ffQaD"),
    $2141e55d8b3f38b9$var$load("kvRbA"),
    $2141e55d8b3f38b9$var$load("3r0o4")
]).then(()=>parcelRequire('1H43T'));

});



parcelRegister("5EloX", function(module, exports) {

$parcel$export(module.exports, "productsJsmComplianceRouteEntry", () => $a7108b06ea361a14$export$9cc9423a3967333b);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $fRFcK = parcelRequire("fRFcK");

var $9WIUh = parcelRequire("9WIUh");
const $a7108b06ea361a14$export$9cc9423a3967333b = (0, $7NszV.createEntry)((0, $fRFcK.productsJsmComplianceRoute), ()=>({
        group: 'global-settings',
        component: (0, $9WIUh.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $9WIUh.LazyProductsJsmCompliance)
        ],
        ufoName: 'admin.jsm-compliance'
    }));

});
parcelRegister("fRFcK", function(module, exports) {

$parcel$export(module.exports, "productsJsmComplianceRoute", () => $7de4aa1c0a8e9753$export$6196bf08f64419da);
const $7de4aa1c0a8e9753$export$6196bf08f64419da = {
    name: 'products-jsm-compliance',
    path: '/jira/settings/products/jira-service-management-compliance',
    exact: true
};

});

parcelRegister("9WIUh", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmCompliance", () => $62ef4b19010ca280$export$159d8c0e1862cd2b);
$parcel$export(module.exports, "default", () => $62ef4b19010ca280$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $62ef4b19010ca280$export$159d8c0e1862cd2b = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("9nrbj"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-compliance/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$62ef4b19010ca280$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $62ef4b19010ca280$export$159d8c0e1862cd2b,
        pageId: "products-jsm-compliance",
        shouldShowSpinner: false
    });

});
parcelRegister("9nrbj", function(module, exports) {

let $6d3b58b5db244739$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6d3b58b5db244739$var$load("l8CKv").then(()=>parcelRequire('dxuco'));

});



parcelRegister("7p4oW", function(module, exports) {

$parcel$export(module.exports, "productsJsmConfigurationRouteEntry", () => $7c5012e44416fb27$export$461f2b06a7a914db);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $eMdJp = parcelRequire("eMdJp");

var $eKojW = parcelRequire("eKojW");
const $7c5012e44416fb27$export$461f2b06a7a914db = (0, $7NszV.createEntry)((0, $eMdJp.productsJsmConfigurationRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-configuration',
        component: (0, $eKojW.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $eKojW.LazyProductsJsmConfiguration)
        ]
    }));

});
parcelRegister("eMdJp", function(module, exports) {

$parcel$export(module.exports, "productsJsmConfigurationRoute", () => $7d2ff473ef6296e1$export$2ad48fbde4743a97);
const $7d2ff473ef6296e1$export$2ad48fbde4743a97 = {
    name: 'products-jsm-configuration',
    path: '/jira/settings/products/jira-service-management-configuration',
    exact: true
};

});

parcelRegister("eKojW", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmConfiguration", () => $2e07bdac6faf88fe$export$aa3f3d5ca376f305);
$parcel$export(module.exports, "default", () => $2e07bdac6faf88fe$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $2e07bdac6faf88fe$export$aa3f3d5ca376f305 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("jUHjS"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-configuration/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2e07bdac6faf88fe$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2e07bdac6faf88fe$export$aa3f3d5ca376f305,
        pageId: "products-jsm-configuration",
        shouldShowSpinner: false
    });

});
parcelRegister("jUHjS", function(module, exports) {

let $e7f4d9ac9e1ca305$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e7f4d9ac9e1ca305$var$load("6G6wt").then(()=>parcelRequire('14xmF'));

});



parcelRegister("GIsnE", function(module, exports) {

$parcel$export(module.exports, "productsJsmEmailRequestsRouteEntry", () => $4b72522d0ef4aab5$export$3f8d7424a47f4dd);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $3jDL8 = parcelRequire("3jDL8");

var $HR4Qz = parcelRequire("HR4Qz");
const $4b72522d0ef4aab5$export$3f8d7424a47f4dd = (0, $7NszV.createEntry)((0, $3jDL8.productsJsmEmailRequestsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-email-requests',
        component: (0, $HR4Qz.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $HR4Qz.LazyProductsJsmEmailRequests)
        ]
    }));

});
parcelRegister("3jDL8", function(module, exports) {

$parcel$export(module.exports, "productsJsmEmailRequestsRoute", () => $7687bd61dacb24e9$export$6288bb6ea42acf0c);
const $7687bd61dacb24e9$export$6288bb6ea42acf0c = {
    name: 'products-jsm-email-requests',
    path: '/jira/settings/products/jira-service-management-email-requests',
    exact: true
};

});

parcelRegister("HR4Qz", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmEmailRequests", () => $f8c99b7a302373fc$export$4c9d90d0caf04d67);
$parcel$export(module.exports, "default", () => $f8c99b7a302373fc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $f8c99b7a302373fc$export$4c9d90d0caf04d67 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("kJWpr"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/product-jsm-email-requests/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f8c99b7a302373fc$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f8c99b7a302373fc$export$4c9d90d0caf04d67,
        pageId: "products-jsm-email-requests",
        shouldShowSpinner: false
    });

});
parcelRegister("kJWpr", function(module, exports) {

let $f195517e7611b843$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f195517e7611b843$var$load("gbPTO").then(()=>parcelRequire('c81zX'));

});



parcelRegister("MSc9t", function(module, exports) {

$parcel$export(module.exports, "productsJsmFeatureUsageRouteEntry", () => $fc79a196d6d127dc$export$80a3e4dda2dcd1a4);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $lkQ6W = parcelRequire("lkQ6W");

var $gRzZD = parcelRequire("gRzZD");

var $3FCb0 = parcelRequire("3FCb0");
const $fc79a196d6d127dc$export$80a3e4dda2dcd1a4 = (0, $7NszV.createEntry)((0, $lkQ6W.productsJsmFeatureUsageRoute), ()=>({
        group: 'global-settings',
        component: (0, $3FCb0.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $gRzZD.workspaceResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3FCb0.LazyProductsJsmFeatureUsage)
        ]
    }));

});
parcelRegister("lkQ6W", function(module, exports) {

$parcel$export(module.exports, "productsJsmFeatureUsageRoute", () => $dcb61f2507bdacb1$export$f98dec539fffaa15);
const $dcb61f2507bdacb1$export$f98dec539fffaa15 = {
    name: 'products-jsm-feature-usage',
    path: '/jira/settings/products/servicedesk/feature-usage',
    exact: true
};

});

parcelRegister("3FCb0", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmFeatureUsage", () => $48028ef535c008c9$export$5ad1c1e822bd5d34);
$parcel$export(module.exports, "default", () => $48028ef535c008c9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $48028ef535c008c9$export$5ad1c1e822bd5d34 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("iSAKy"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-feature-usage/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$48028ef535c008c9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $48028ef535c008c9$export$5ad1c1e822bd5d34,
        pageId: "products-jsm-feature-usage",
        shouldShowSpinner: false
    });

});
parcelRegister("iSAKy", function(module, exports) {

let $dbe9c6e03093f114$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dbe9c6e03093f114$var$load("96INv").then(()=>parcelRequire('g4KKw'));

});



parcelRegister("bpbCg", function(module, exports) {

$parcel$export(module.exports, "productsJsmGlobalOpsReportsRedirectRouteEntry", () => $5f3f997c6af1c603$export$289cc03f2eacd57a);

var $dY89w = parcelRequire("dY89w");

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $adTVI = parcelRequire("adTVI");

var $4HfNx = parcelRequire("4HfNx");
const $5f3f997c6af1c603$export$289cc03f2eacd57a = (0, $7NszV.createEntry)((0, $adTVI.productsJsmGlobalOpsReportsRedirectRoute), ()=>({
        group: 'global-settings',
        component: (0, $4HfNx.OpsReportsRedirect),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $dY89w.resources)(),
            (0, $dY89w.opsReportsPermissionResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4HfNx.LazyGlobalOpsReports)
        ]
    }));

});
parcelRegister("adTVI", function(module, exports) {

$parcel$export(module.exports, "productsJsmGlobalOpsReportsRedirectRoute", () => $3e538dded475ec91$export$c6d42e4b4a63248d);
const $3e538dded475ec91$export$c6d42e4b4a63248d = {
    name: 'products-jsm-global-ops-reports',
    path: '/jira/settings/products/ops/reports',
    exact: true
};

});

parcelRegister("4HfNx", function(module, exports) {

$parcel$export(module.exports, "LazyOpsReportsRedirect", () => $59dec6d88aab4fac$export$d33ea1a773b744e);
$parcel$export(module.exports, "LazyGlobalOpsReports", () => $59dec6d88aab4fac$export$66850ec5549adba6);
$parcel$export(module.exports, "OpsReportsRedirect", () => $59dec6d88aab4fac$export$22253dbadb46d0cf);
$parcel$export(module.exports, "GlobalOpsReports", () => $59dec6d88aab4fac$export$648ddf2d1f8b1c3f);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $59dec6d88aab4fac$export$2404f0e35deca592 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("bGrc6")), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $59dec6d88aab4fac$export$d33ea1a773b744e = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("bGrc6")).then((exportedMembers)=>exportedMembers.OpsReportsRedirect), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $59dec6d88aab4fac$export$66850ec5549adba6 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("bGrc6")).then((exportedMembers)=>exportedMembers.GlobalOpsReports), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});
const $59dec6d88aab4fac$export$22253dbadb46d0cf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $59dec6d88aab4fac$export$d33ea1a773b744e,
        pageId: "async-jira-eoc-ops-reports-redirect",
        shouldShowSpinner: false
    });
const $59dec6d88aab4fac$export$648ddf2d1f8b1c3f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $59dec6d88aab4fac$export$66850ec5549adba6,
        pageId: "async-jira-eoc-global-ops-reports",
        shouldShowSpinner: false
    });
const $59dec6d88aab4fac$export$87e6a54b4f5dc91e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $59dec6d88aab4fac$export$2404f0e35deca592,
        pageId: "async-jira-eoc-ops-reports",
        shouldShowSpinner: false
    });

});


parcelRegister("5X0aC", function(module, exports) {

$parcel$export(module.exports, "productsJsmGlobalOpsReportsRouteEntry", () => $61761389ad3b32bd$export$6a7fc41fb2523290);

var $dY89w = parcelRequire("dY89w");

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dDcek = parcelRequire("dDcek");

var $4HfNx = parcelRequire("4HfNx");
const $61761389ad3b32bd$export$6a7fc41fb2523290 = (0, $7NszV.createEntry)((0, $dDcek.productsJsmGlobalOpsReportsRoute), ()=>({
        group: 'global-settings',
        component: (0, $4HfNx.GlobalOpsReports),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            ...(0, $dY89w.resources)(),
            (0, $dY89w.opsReportsPermissionResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4HfNx.LazyOpsReportsRedirect)
        ]
    }));

});
parcelRegister("dDcek", function(module, exports) {

$parcel$export(module.exports, "productsJsmGlobalOpsReportsRoute", () => $126ddc8c4a59a59a$export$d92d66762943b115);
const $126ddc8c4a59a59a$export$d92d66762943b115 = {
    name: 'products-jsm-global-ops-reports',
    path: '/jira/settings/products/ops/reports/:dashboardId',
    exact: true
};

});


parcelRegister("fkWQj", function(module, exports) {

$parcel$export(module.exports, "productsJsmIncidentManagementToolsRouteEntry", () => $954e97d3acac763c$export$773f8e3318be1dd5);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $8PUrK = parcelRequire("8PUrK");

var $6MP9S = parcelRequire("6MP9S");
const $954e97d3acac763c$export$773f8e3318be1dd5 = (0, $7NszV.createEntry)((0, $8PUrK.productsJsmIncidentManagementToolsRoute), ()=>({
        group: 'global-settings',
        component: (0, $6MP9S.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6MP9S.LazyProductsJsmIncidentManagementTools)
        ]
    }));

});
parcelRegister("8PUrK", function(module, exports) {

$parcel$export(module.exports, "productsJsmIncidentManagementToolsRoute", () => $1d5dbffa04bebbb5$export$da6d538ddabade32);
const $1d5dbffa04bebbb5$export$da6d538ddabade32 = {
    name: 'products-jsm-incident-management-tools',
    path: '/jira/settings/products/jira-service-management-incident-management-tools',
    exact: true
};

});

parcelRegister("6MP9S", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmIncidentManagementTools", () => $63d70171d6cec69e$export$f541eb9b8f00bfaf);
$parcel$export(module.exports, "default", () => $63d70171d6cec69e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $63d70171d6cec69e$export$f541eb9b8f00bfaf = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("5kREt"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-incident-management-tools/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$63d70171d6cec69e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $63d70171d6cec69e$export$f541eb9b8f00bfaf,
        pageId: "products-jsm-incident-management-tools",
        shouldShowSpinner: false
    });

});
parcelRegister("5kREt", function(module, exports) {

let $3e2870243a225055$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $3e2870243a225055$var$load("ffQaD"),
    $3e2870243a225055$var$load("kvRbA"),
    $3e2870243a225055$var$load("4sTC2")
]).then(()=>parcelRequire('joBQW'));

});



parcelRegister("7NO6v", function(module, exports) {

$parcel$export(module.exports, "productsJsmKbPermissionsRouteEntry", () => $b6759abef36b3efc$export$717e134eb971b450);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $2EpSF = parcelRequire("2EpSF");

var $knyuK = parcelRequire("knyuK");
const $b6759abef36b3efc$export$717e134eb971b450 = (0, $7NszV.createEntry)((0, $2EpSF.productsJsmKbPermissionsRoute), ()=>({
        group: 'global-settings',
        component: (0, $knyuK.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $knyuK.LazyProductsJsmKbPermissions)
        ]
    }));

});
parcelRegister("2EpSF", function(module, exports) {

$parcel$export(module.exports, "productsJsmKbPermissionsRoute", () => $a35de718c16ba9da$export$339486410c7a783f);
const $a35de718c16ba9da$export$339486410c7a783f = {
    name: 'products-jsm-kb-permissions',
    path: '/jira/settings/products/jira-service-management-knowledge-base-permissions',
    exact: true
};

});

parcelRegister("knyuK", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmKbPermissions", () => $724367026054fd0c$export$a3e7bdc5dbf2d47e);
$parcel$export(module.exports, "default", () => $724367026054fd0c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $724367026054fd0c$export$a3e7bdc5dbf2d47e = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("lXBBw"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/product-jsm-kb-permissions/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$724367026054fd0c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $724367026054fd0c$export$a3e7bdc5dbf2d47e,
        pageId: "products-jsm-kb-permissions",
        shouldShowSpinner: false
    });

});
parcelRegister("lXBBw", function(module, exports) {

let $ffcc4714b4e68449$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ffcc4714b4e68449$var$load("1CHnf").then(()=>parcelRequire('glk23'));

});



parcelRegister("gtJvE", function(module, exports) {

$parcel$export(module.exports, "productsJsmOrganizationsDetailsRouteEntry", () => $d5f0f03722be4af7$export$f7b6cda88404733e);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $38BXB = parcelRequire("38BXB");

var $7CBZS = parcelRequire("7CBZS");

var $6nu63 = parcelRequire("6nu63");

var $esddG = parcelRequire("esddG");

var $3RJkv = parcelRequire("3RJkv");

var $zsl89 = parcelRequire("zsl89");

var $5JNlT = parcelRequire("5JNlT");
const $d5f0f03722be4af7$export$f7b6cda88404733e = (0, $7NszV.createEntry)((0, $zsl89.productsJsmOrganizationsDetailsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-organization-page-list',
        isRedirect: false,
        component: (0, $5JNlT.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $7CBZS.productsJsmOrganizationDetailsResource),
            (0, $6nu63.productsJsmOrganizationMembersResource),
            (0, $esddG.productsJsmOrganizationListResource),
            (0, $38BXB.jsmEmailDomainsListResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5JNlT.LazyProductsJsmOrganizationDetails)
        ]
    }));

});
parcelRegister("38BXB", function(module, exports) {

$parcel$export(module.exports, "jsmEmailDomainsListResource", () => $02fee81a891a3dc1$export$8e956348e5d47a3c);

var $2M1hQ = parcelRequire("2M1hQ");


const $02fee81a891a3dc1$export$8e956348e5d47a3c = (0, $2M1hQ.createResource)({
    type: (0, $fb7ceb315fdf5327$export$2bde433b962efbdd),
    getKey: ()=>'email-domains-list',
    isBrowserOnly: true,
    getDataLoader: ()=>(parcelRequire("j5LfK"))
});

});
const $fb7ceb315fdf5327$export$2bde433b962efbdd = 'JSM_EMAIL_DOMAINS_LIST';

parcelRegister("j5LfK", function(module, exports) {

let $de63236826e70e65$var$load = (parcelRequire("28QjX"))(4);
module.exports = $de63236826e70e65$var$load("lgmw4").then(()=>parcelRequire('bHzRo'));

});


parcelRegister("7CBZS", function(module, exports) {

$parcel$export(module.exports, "productsJsmOrganizationDetailsResource", () => $d8ebe0a210bfc926$export$ccda79811a15bf5);

var $2M1hQ = parcelRequire("2M1hQ");


const $d8ebe0a210bfc926$export$ccda79811a15bf5 = (0, $2M1hQ.createResource)({
    type: (0, $1b34d67fee3735c4$export$52408f1a0f23569a),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("k2P4E"))
});

});
const $1b34d67fee3735c4$export$52408f1a0f23569a = 'RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_DETAILS';

parcelRegister("k2P4E", function(module, exports) {

let $e97b9cc8281cbe40$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e97b9cc8281cbe40$var$load("hgZNC").then(()=>parcelRequire('dXKCD'));

});


parcelRegister("6nu63", function(module, exports) {

$parcel$export(module.exports, "productsJsmOrganizationMembersResource", () => $36d00fa173b898da$export$65c7941bd3e14d00);

var $2M1hQ = parcelRequire("2M1hQ");

const $36d00fa173b898da$var$TEN_SECONDS_IN_MILLIS = 10000;

const $36d00fa173b898da$export$65c7941bd3e14d00 = (0, $2M1hQ.createResource)({
    type: (0, $b3f9f4e37cbce264$export$d3eec3e4b4eac6ac),
    getKey: (routerContext)=>`OrganizationMembers-${routerContext.match.params.organizationId}-${routerContext.query.page}-${routerContext.query.query}`,
    getDataLoader: ()=>(parcelRequire("8hc5o")),
    maxAge: $36d00fa173b898da$var$TEN_SECONDS_IN_MILLIS
});

});
const $b3f9f4e37cbce264$export$d3eec3e4b4eac6ac = 'PRODUCT_JSM_ORGANIZATION_MEMBERS';

parcelRegister("8hc5o", function(module, exports) {

let $6069494a2248820b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6069494a2248820b$var$load("kl1ZQ").then(()=>parcelRequire('kx7O4'));

});


parcelRegister("esddG", function(module, exports) {

$parcel$export(module.exports, "productsJsmOrganizationListResource", () => $ad899c035903db82$export$3e38a27ad406d7f7);

var $2M1hQ = parcelRequire("2M1hQ");

const $ad899c035903db82$var$TEN_SECONDS_IN_MILLIS = 10000;

const $ad899c035903db82$export$3e38a27ad406d7f7 = (0, $2M1hQ.createResource)({
    type: (0, $5073c414a8292ea0$export$50de2841b08b875f),
    getKey: (routerContext)=>routerContext.query.page,
    getDataLoader: ()=>(parcelRequire("75Ymv")),
    maxAge: $ad899c035903db82$var$TEN_SECONDS_IN_MILLIS
});

});
const $5073c414a8292ea0$export$50de2841b08b875f = 'RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_LIST';

parcelRegister("75Ymv", function(module, exports) {

let $52a7d2a883c6cb65$var$load = (parcelRequire("28QjX"))(4);
module.exports = $52a7d2a883c6cb65$var$load("3nXj2").then(()=>parcelRequire('v9BTs'));

});


parcelRegister("zsl89", function(module, exports) {

$parcel$export(module.exports, "productsJsmOrganizationsDetailsRoute", () => $a0ada8abfade1bcc$export$bc61991d01535831);
const $a0ada8abfade1bcc$export$bc61991d01535831 = {
    name: 'products-jsm-organizations',
    path: '/jira/settings/products/servicedesk/organizations/:organizationId',
    exact: true
};

});

parcelRegister("5JNlT", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmOrganizationDetails", () => $2542e7a566ffd224$export$ff149ceefa65ab70);
$parcel$export(module.exports, "default", () => $2542e7a566ffd224$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $2542e7a566ffd224$export$ff149ceefa65ab70 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("6pF2p"))), {
    moduleId: "./src/packages/admin-pages/products-jsm-organization-details/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2542e7a566ffd224$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2542e7a566ffd224$export$ff149ceefa65ab70,
        pageId: "products-jsm-organization-details",
        shouldShowSpinner: true
    });

});
parcelRegister("6pF2p", function(module, exports) {

let $4ab4e925131487f0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4ab4e925131487f0$var$load("ePo15").then(()=>parcelRequire('dgpeW'));

});



parcelRegister("hMqu9", function(module, exports) {

$parcel$export(module.exports, "productsJsmOrganizationsRouteEntry", () => $5dc17715cd6fddea$export$34d843946d3894aa);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $esddG = parcelRequire("esddG");

var $3RJkv = parcelRequire("3RJkv");

var $d6Cjb = parcelRequire("d6Cjb");

var $ckuB6 = parcelRequire("ckuB6");
const $5dc17715cd6fddea$export$34d843946d3894aa = (0, $7NszV.createEntry)((0, $d6Cjb.productsJsmOrganizationsRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsm-organization-page-list',
        isRedirect: false,
        component: (0, $ckuB6.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $esddG.productsJsmOrganizationListResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ckuB6.LazyProductsJsmOrganizations)
        ]
    }));

});
parcelRegister("d6Cjb", function(module, exports) {

$parcel$export(module.exports, "productsJsmOrganizationsRoute", () => $aff64887f4e5e03c$export$512fa30726e0049d);
const $aff64887f4e5e03c$export$512fa30726e0049d = {
    name: 'products-jsm-organizations',
    path: '/jira/settings/products/servicedesk/organizations',
    exact: true
};

});

parcelRegister("ckuB6", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJsmOrganizations", () => $34fecedc618348fb$export$410bec6e06fd4723);
$parcel$export(module.exports, "default", () => $34fecedc618348fb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $34fecedc618348fb$export$410bec6e06fd4723 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("679xe"))), {
    moduleId: "./src/packages/admin-pages/products-jsm-organizations-list/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$34fecedc618348fb$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $34fecedc618348fb$export$410bec6e06fd4723,
        pageId: "products-jsm-organizations-list",
        shouldShowSpinner: true
    });

});
parcelRegister("679xe", function(module, exports) {

let $473acaf8e5582b0c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $473acaf8e5582b0c$var$load("aUS8e").then(()=>parcelRequire('hfcIv'));

});



parcelRegister("7YRoH", function(module, exports) {

$parcel$export(module.exports, "productsJswConfigurationRouteEntry", () => $1733bfec88a8a7ea$export$2f65b1ec4ed05f91);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $hwXlc = parcelRequire("hwXlc");

var $8dDE8 = parcelRequire("8dDE8");

var $esWmF = parcelRequire("esWmF");
const $1733bfec88a8a7ea$export$2f65b1ec4ed05f91 = (0, $7NszV.createEntry)((0, $8dDE8.productsJswConfigurationRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsw-configuration',
        component: (0, $esWmF.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $hwXlc.productsJswConfigurationResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $esWmF.LazyProductsJswConfiguration)
        ]
    }));

});
parcelRegister("hwXlc", function(module, exports) {

$parcel$export(module.exports, "productsJswConfigurationResource", () => $3248841597f2b624$export$b6a5741c2b47fb17);

var $2M1hQ = parcelRequire("2M1hQ");


const $3248841597f2b624$export$b6a5741c2b47fb17 = (0, $2M1hQ.createResource)({
    type: (0, $8b1aa0975152cf4f$export$73be8e1edd21e2d),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("7k2tt"))
});

});
const $8b1aa0975152cf4f$export$73be8e1edd21e2d = 'RESOURCE_TYPE_PRODUCT_JSW_CONFIGURATION';

parcelRegister("7k2tt", function(module, exports) {

let $554c51ff613acde0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $554c51ff613acde0$var$load("2oxTp").then(()=>parcelRequire('bX4Lv'));

});


parcelRegister("8dDE8", function(module, exports) {

$parcel$export(module.exports, "productsJswConfigurationRoute", () => $ac36f76001e1c678$export$decdad53ba9b97af);
const $ac36f76001e1c678$export$decdad53ba9b97af = {
    name: 'products-jsw-configuration',
    path: '/jira/settings/products/jira-software-configuration',
    exact: true
};

});

parcelRegister("esWmF", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJswConfiguration", () => $90ae9e1263695143$export$f9a32397033f9ced);
$parcel$export(module.exports, "default", () => $90ae9e1263695143$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $90ae9e1263695143$export$f9a32397033f9ced = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("gb28O"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsw-configuration/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$90ae9e1263695143$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $90ae9e1263695143$export$f9a32397033f9ced,
        pageId: "products-jsw-configuration",
        shouldShowSpinner: false
    });

});
parcelRegister("gb28O", function(module, exports) {

let $bc6f55996da8f3c1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bc6f55996da8f3c1$var$load("3KjvI").then(()=>parcelRequire('1eYnA'));

});



parcelRegister("i0b8q", function(module, exports) {

$parcel$export(module.exports, "productsJswStorageManagementRouteEntry", () => $ebdca188f3705262$export$c62ca2d3fcc552a5);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $1vQWT = parcelRequire("1vQWT");

var $ab5pe = parcelRequire("ab5pe");

var $bARgN = parcelRequire("bARgN");
const $ebdca188f3705262$export$c62ca2d3fcc552a5 = (0, $7NszV.createEntry)((0, $ab5pe.productsJswStorageManagementRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.jsw-configuration.storage-management',
        component: (0, $bARgN.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)(),
            (0, $1vQWT.productsJswStorageManagementResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bARgN.LazyProductsJswStorageManagement)
        ]
    }));

});
parcelRegister("1vQWT", function(module, exports) {

$parcel$export(module.exports, "productsJswStorageManagementResource", () => $20cc0f4a1ad53cba$export$2cd668845b3478bd);

var $2M1hQ = parcelRequire("2M1hQ");


const $20cc0f4a1ad53cba$export$2cd668845b3478bd = (0, $2M1hQ.createResource)({
    type: (0, $593b84e85768ae60$export$1ac222647be3baf8),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("8LYAU"))
});

});
const $593b84e85768ae60$export$1ac222647be3baf8 = 'RESOURCE_TYPE_PRODUCT_JSW_STORAGE_MANAGEMENT';

parcelRegister("8LYAU", function(module, exports) {

let $6631b74bfab4a972$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6631b74bfab4a972$var$load("axIcs").then(()=>parcelRequire('a5z0r'));

});


parcelRegister("ab5pe", function(module, exports) {

$parcel$export(module.exports, "productsJswStorageManagementRoute", () => $7e2088c789cd548c$export$18f0044f00cc3996);
const $7e2088c789cd548c$export$18f0044f00cc3996 = {
    name: 'products-jsw-storage-management',
    path: '/jira/settings/products/jira-software-configuration/storage-management',
    exact: true
};

});

parcelRegister("bARgN", function(module, exports) {

$parcel$export(module.exports, "LazyProductsJswStorageManagement", () => $bad793b8f28a1de3$export$a4f5e12ce817cbb8);
$parcel$export(module.exports, "default", () => $bad793b8f28a1de3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $bad793b8f28a1de3$export$a4f5e12ce817cbb8 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("c04D9"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsw-storage-management/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bad793b8f28a1de3$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $bad793b8f28a1de3$export$a4f5e12ce817cbb8,
        pageId: "products-jsw-storage-management",
        shouldShowSpinner: true
    });

});
parcelRegister("c04D9", function(module, exports) {

let $8bc913a5930976c3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $8bc913a5930976c3$var$load("fliVL"),
    $8bc913a5930976c3$var$load("181PN")
]).then(()=>parcelRequire('2i4Yq'));

});



parcelRegister("jKCJe", function(module, exports) {

$parcel$export(module.exports, "proformaExportRouteEntry", () => $6ada90d55b94e879$export$27be010fc1b30f6c);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $gXbcB = parcelRequire("gXbcB");

var $6dVUC = parcelRequire("6dVUC");
const $6ada90d55b94e879$export$27be010fc1b30f6c = (0, $7NszV.createEntry)((0, $gXbcB.proformaExportRoute), ()=>({
        group: 'proforma',
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        component: (0, $6dVUC.default),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6dVUC.LazyProformaExport)
        ]
    }));

});
parcelRegister("gXbcB", function(module, exports) {

$parcel$export(module.exports, "proformaExportRoute", () => $e9663b2cd0ceb8c1$export$5130d152b1cda229);
const $e9663b2cd0ceb8c1$export$5130d152b1cda229 = {
    name: 'proforma-export',
    path: '/jira/forms/export',
    exact: true
};

});

parcelRegister("6dVUC", function(module, exports) {

$parcel$export(module.exports, "LazyProformaExport", () => $f012061ea42d3cc1$export$5e0d802a5d865352);
$parcel$export(module.exports, "default", () => $f012061ea42d3cc1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $f012061ea42d3cc1$export$5e0d802a5d865352 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("22cFk")), {
    moduleId: "./src/packages/spa-apps/proforma-export/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f012061ea42d3cc1$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f012061ea42d3cc1$export$5e0d802a5d865352,
        pageId: "proforma-export",
        shouldShowSpinner: true
    });

});
parcelRegister("22cFk", function(module, exports) {

let $17b597cdea5f1540$var$load = (parcelRequire("28QjX"))(4);
module.exports = $17b597cdea5f1540$var$load("9eOiG").then(()=>parcelRequire('dtDoN'));

});



parcelRegister("iJIU8", function(module, exports) {

$parcel$export(module.exports, "proformaIssueFormsGeneralRouteEntry", () => $8d5b2002b38c1828$export$90d7a2fe9ba3bc11);

var $ffza4 = parcelRequire("ffza4");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $jErk8 = parcelRequire("jErk8");

var $5cTgp = parcelRequire("5cTgp");
const $8d5b2002b38c1828$export$90d7a2fe9ba3bc11 = (0, $7NszV.createEntry)((0, $jErk8.proformaIssueFormsGeneralRoute), ()=>({
        group: 'proforma',
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        component: (0, $5cTgp.default),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5cTgp.LazyProformaIssueFormsGeneral)
        ],
        perfMetricKey: 'issue-forms-general'
    }));

});
parcelRegister("jErk8", function(module, exports) {

$parcel$export(module.exports, "proformaIssueFormsGeneralRoute", () => $6484903254af07fd$export$5e0c19066a4c3806);
const $6484903254af07fd$export$5e0c19066a4c3806 = {
    name: 'proforma-issue-forms-general',
    path: '/jira/forms/create',
    exact: true
};

});

parcelRegister("5cTgp", function(module, exports) {

$parcel$export(module.exports, "LazyProformaIssueFormsGeneral", () => $06427390ad9a129c$export$7c16b09eb95f1c5d);
$parcel$export(module.exports, "default", () => $06427390ad9a129c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $06427390ad9a129c$export$7c16b09eb95f1c5d = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("5xdPl")), {
    moduleId: "./src/packages/spa-apps/proforma-issue-forms-general/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$06427390ad9a129c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $06427390ad9a129c$export$7c16b09eb95f1c5d,
        pageId: "proforma-issue-forms-general",
        shouldShowSpinner: true
    });

});
parcelRegister("5xdPl", function(module, exports) {

let $407ac299691e5d96$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $407ac299691e5d96$var$load("76n7a"),
    $407ac299691e5d96$var$load("l253H"),
    $407ac299691e5d96$var$load("58s7b")
]).then(()=>parcelRequire('28Pju'));

});



parcelRegister("d6K18", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProformaIssueFormsDirectEmbedRouteEntry", () => $93eb6540105b9307$export$99ff9a6f448db95c);

var $6e4Kt = parcelRequire("6e4Kt");

var $7NszV = parcelRequire("7NszV");

var $dxCvy = parcelRequire("dxCvy");

var $gtobw = parcelRequire("gtobw");

var $edJLT = parcelRequire("edJLT");
const $93eb6540105b9307$export$99ff9a6f448db95c = (0, $7NszV.createEntry)((0, $gtobw.classicBusinessProformaIssueFormsDirectEmbedRoute), ()=>({
        group: 'classic-business',
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            (0, $dxCvy.projectContextResource)
        ],
        component: (0, $edJLT.default),
        forPaint: [
            (0, $edJLT.LazyProformaIssueFormsDirectEmbed)
        ],
        perfMetricKey: 'issue-forms-direct-embed'
    }));

});
parcelRegister("gtobw", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProformaIssueFormsDirectEmbedRoute", () => $221926f6dc9630e3$export$92c0120052644a60);
const $221926f6dc9630e3$export$92c0120052644a60 = {
    name: 'classic-business-proforma-issue-forms-direct-embed',
    path: '/jira/core/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?/embed',
    exact: true
};

});

parcelRegister("edJLT", function(module, exports) {

$parcel$export(module.exports, "LazyProformaIssueFormsDirectEmbed", () => $321227a7cf9935db$export$22681210aaeb910f);
$parcel$export(module.exports, "default", () => $321227a7cf9935db$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $321227a7cf9935db$export$22681210aaeb910f = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("8yRRM")), {
    moduleId: "./src/packages/spa-apps/proforma-issue-forms-direct-embed/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$321227a7cf9935db$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $321227a7cf9935db$export$22681210aaeb910f,
        pageId: "proforma-issue-forms-direct-embed",
        shouldShowSpinner: true
    });

});
parcelRegister("8yRRM", function(module, exports) {

let $63bb487a59f60267$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $63bb487a59f60267$var$load("76n7a"),
    $63bb487a59f60267$var$load("l253H"),
    $63bb487a59f60267$var$load("3HzNK")
]).then(()=>parcelRequire('4RuJw'));

});



parcelRegister("lIfPP", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProformaIssueFormsDirectRouteEntry", () => $f6035edc22ca57c1$export$8aa48763ac761f64);

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $dxCvy = parcelRequire("dxCvy");

var $e3tm3 = parcelRequire("e3tm3");

var $6VQ64 = parcelRequire("6VQ64");
const $f6035edc22ca57c1$export$8aa48763ac761f64 = (0, $7NszV.createEntry)((0, $e3tm3.classicBusinessProformaIssueFormsDirectRoute), ()=>({
        group: 'classic-business',
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            (0, $dxCvy.projectContextResource)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        entryPoint: ()=>(0, $6VQ64.proformaIssueFormsDirectPageEntryPoint),
        perfMetricKey: 'issue-forms-direct'
    }));

});
parcelRegister("e3tm3", function(module, exports) {

$parcel$export(module.exports, "classicBusinessProformaIssueFormsDirectRoute", () => $2adcae99a9770e81$export$97a413d49241d03b);
const $2adcae99a9770e81$export$97a413d49241d03b = {
    name: 'classic-business-proforma-issue-forms-direct',
    path: '/jira/core/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?',
    exact: true
};

});

parcelRegister("6VQ64", function(module, exports) {

$parcel$export(module.exports, "proformaIssueFormsDirectPageEntryPoint", () => $33e9f81a484baab5$export$dc0bb5719ae7aab4);

var $1aJjB = parcelRequire("1aJjB");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");
const $33e9f81a484baab5$export$dc0bb5719ae7aab4 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1aJjB.proformaIssueFormsDirectEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("1aJjB", function(module, exports) {

$parcel$export(module.exports, "proformaIssueFormsDirectEntryPoint", () => $47ed6b158c55f88b$export$2a51bba458da5928);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $47ed6b158c55f88b$export$2a51bba458da5928 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("84CrK")), {
        moduleId: "3047b51f"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("84CrK", function(module, exports) {

let $5e0c851fb68ad494$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $5e0c851fb68ad494$var$load("76n7a"),
    $5e0c851fb68ad494$var$load("l253H"),
    $5e0c851fb68ad494$var$load("309Ge")
]).then(()=>parcelRequire('izbAs'));

});




parcelRegister("1rMUU", function(module, exports) {

$parcel$export(module.exports, "servicedeskProformaIssueFormsDirectEmbedRouteEntry", () => $240624c6c03e7472$export$2792607788ca81db);

var $6e4Kt = parcelRequire("6e4Kt");

var $7NszV = parcelRequire("7NszV");

var $dxCvy = parcelRequire("dxCvy");

var $chOdK = parcelRequire("chOdK");

var $edJLT = parcelRequire("edJLT");
const $240624c6c03e7472$export$2792607788ca81db = (0, $7NszV.createEntry)((0, $chOdK.servicedeskProformaIssueFormsDirectEmbedRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            (0, $dxCvy.projectContextResource)
        ],
        component: (0, $edJLT.default),
        forPaint: [
            (0, $edJLT.LazyProformaIssueFormsDirectEmbed)
        ],
        perfMetricKey: 'issue-forms-direct-embed'
    }));

});
parcelRegister("chOdK", function(module, exports) {

$parcel$export(module.exports, "servicedeskProformaIssueFormsDirectEmbedRoute", () => $920134fe3a6eefea$export$bf24763c9fc04bde);
const $920134fe3a6eefea$export$bf24763c9fc04bde = {
    name: 'servicedesk-proforma-issue-forms-direct-embed',
    path: '/jira/servicedesk/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?/embed',
    exact: true
};

});


parcelRegister("36qRE", function(module, exports) {

$parcel$export(module.exports, "servicedeskProformaIssueFormsDirectRouteEntry", () => $6c7c317c40c5c36f$export$f249c6e19ad4181e);

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $dxCvy = parcelRequire("dxCvy");

var $lPvHo = parcelRequire("lPvHo");

var $6Z2mh = parcelRequire("6Z2mh");

var $6VQ64 = parcelRequire("6VQ64");
const $6c7c317c40c5c36f$export$f249c6e19ad4181e = (0, $7NszV.createEntry)((0, $lPvHo.servicedeskProformaIssueFormsDirectRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            (0, $dxCvy.projectContextResource)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        entryPoint: ()=>(0, $6VQ64.proformaIssueFormsDirectPageEntryPoint),
        perfMetricKey: 'issue-forms-direct'
    }));

});
parcelRegister("lPvHo", function(module, exports) {

$parcel$export(module.exports, "servicedeskProformaIssueFormsDirectRoute", () => $2c9a39a116b2202b$export$9b51b0994bb4b8f0);
const $2c9a39a116b2202b$export$9b51b0994bb4b8f0 = {
    name: 'servicedesk-proforma-issue-forms-direct',
    path: '/jira/servicedesk/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?',
    exact: true
};

});


parcelRegister("2LfmF", function(module, exports) {

$parcel$export(module.exports, "softwareProformaIssueFormsDirectEmbedRouteEntry", () => $035b18afb2a6d438$export$6df3cef5dab31b3b);

var $6e4Kt = parcelRequire("6e4Kt");

var $7NszV = parcelRequire("7NszV");

var $dxCvy = parcelRequire("dxCvy");

var $6WV7L = parcelRequire("6WV7L");

var $edJLT = parcelRequire("edJLT");
const $035b18afb2a6d438$export$6df3cef5dab31b3b = (0, $7NszV.createEntry)((0, $6WV7L.softwareProformaIssueFormsDirectEmbedRoute), ()=>({
        group: 'software',
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            (0, $dxCvy.projectContextResource)
        ],
        component: (0, $edJLT.default),
        forPaint: [
            (0, $edJLT.LazyProformaIssueFormsDirectEmbed)
        ],
        perfMetricKey: 'issue-forms-direct-embed'
    }));

});
parcelRegister("6WV7L", function(module, exports) {

$parcel$export(module.exports, "softwareProformaIssueFormsDirectEmbedRoute", () => $1f48b8cd07e58720$export$6d1b944aeb758fdb);
const $1f48b8cd07e58720$export$6d1b944aeb758fdb = {
    name: 'software-proforma-issue-forms-direct-embed',
    path: '/jira/software/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?/embed',
    exact: true
};

});


parcelRegister("gzdNI", function(module, exports) {

$parcel$export(module.exports, "softwareProformaIssueFormsDirectRouteEntry", () => $d039f624036d1510$export$552db754a91368f3);

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $dxCvy = parcelRequire("dxCvy");

var $cLf5Y = parcelRequire("cLf5Y");

var $e7bC3 = parcelRequire("e7bC3");

var $6VQ64 = parcelRequire("6VQ64");
const $d039f624036d1510$export$552db754a91368f3 = (0, $7NszV.createEntry)((0, $cLf5Y.softwareProformaIssueFormsDirectRoute), ()=>({
        group: 'software',
        layout: (0, $e7bC3.softwareProjectLayout),
        resources: [
            (0, $dxCvy.projectContextResource)
        ],
        entryPoint: ()=>(0, $6VQ64.proformaIssueFormsDirectPageEntryPoint),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        perfMetricKey: 'issue-forms-direct'
    }));

});
parcelRegister("cLf5Y", function(module, exports) {

$parcel$export(module.exports, "softwareProformaIssueFormsDirectRoute", () => $8a64da0a8be5ef24$export$69db7046ead228b9);
const $8a64da0a8be5ef24$export$69db7046ead228b9 = {
    name: 'software-proforma-issue-forms-direct',
    path: '/jira/software/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?',
    exact: true
};

});


parcelRegister("64qpc", function(module, exports) {

$parcel$export(module.exports, "projectComponentsRedirectRouteEntry", () => $4b7fc303ce7a2a17$export$b498607b4440c4ef);

var $ffza4 = parcelRequire("ffza4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $xNRJ9 = parcelRequire("xNRJ9");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $9Qrwv = parcelRequire("9Qrwv");

var $holgx = parcelRequire("holgx");
const $4b7fc303ce7a2a17$export$b498607b4440c4ef = (0, $7NszV.createEntry)((0, $9Qrwv.projectComponentsRedirectRoute), ()=>({
        group: 'components',
        component: !false ? (0, $holgx.ComponentsRedirect) : undefined,
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource),
            (0, $xNRJ9.projectsComponentsResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ],
        isRedirect: true
    }));

});
parcelRegister("xNRJ9", function(module, exports) {

$parcel$export(module.exports, "projectsComponentsResource", () => $e6f1f6e8951a4819$export$557cc3eff8939b3);

var $kbVA4 = parcelRequire("kbVA4");

var $2M1hQ = parcelRequire("2M1hQ");


const $e6f1f6e8951a4819$export$557cc3eff8939b3 = (0, $2M1hQ.createResource)({
    type: (0, $7f7620b307267b7d$export$ae1b86a8daeb387d),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("iPV1q")),
    maxAge: (0, $kbVA4.MIN_MAX_AGE)
});

});
const $7f7620b307267b7d$export$ae1b86a8daeb387d = 'PROJECTS_COMPONENTS';

parcelRegister("iPV1q", function(module, exports) {

let $db6938cd551a96f9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $db6938cd551a96f9$var$load("76u5F").then(()=>parcelRequire('77Eyd'));

});


parcelRegister("9Qrwv", function(module, exports) {

$parcel$export(module.exports, "projectComponentsRedirectRoute", () => $ca17ca5646521c59$export$d370abe25253fa1b);

var $jhtWp = parcelRequire("jhtWp");
const $ca17ca5646521c59$export$d370abe25253fa1b = {
    name: 'project-components-redirect',
    path: '/projects/:projectKey',
    query: (0, $jhtWp.PROJECTS_COMPONENTS_QUERY_PARAMS)
};

});
parcelRegister("jhtWp", function(module, exports) {

$parcel$export(module.exports, "PROJECTS_COMPONENTS_QUERY_PARAMS", () => $650eb9307abab3e5$export$1d7a0c194c3e83f2);
const $650eb9307abab3e5$export$1d7a0c194c3e83f2 = [
    'selectedItem=com.atlassian.jira.jira-projects-plugin:components-page'
];

});


parcelRegister("holgx", function(module, exports) {

$parcel$export(module.exports, "ComponentsRedirect", () => $15d396b2dbadf93f$export$9cf9ae84482ff18e);

var $5uXOq = parcelRequire("5uXOq");

var $aZsz6 = parcelRequire("aZsz6");

var $6XreI = parcelRequire("6XreI");
const $15d396b2dbadf93f$export$9cf9ae84482ff18e = ()=>{
    const page = (_, { selectedItem: selectedItem, ...rest })=>{
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
        const querystring = (0, $aZsz6.qs).stringify(rest, true);
        return `/components${querystring}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6XreI.RedirectToProjectType), {
        page: page
    });
};

});
parcelRegister("6XreI", function(module, exports) {

$parcel$export(module.exports, "RedirectToProjectType", () => $d19b3848ac7d27f0$export$8a3df560509448b8);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dxCvy = parcelRequire("dxCvy");

var $bVDE5 = parcelRequire("bVDE5");

var $7tQej = parcelRequire("7tQej");
var $2YP9W = parcelRequire("2YP9W");
var $doZTA = parcelRequire("doZTA");
const $d19b3848ac7d27f0$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $7tQej.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $8zOmE.fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, $2NMNM.useAnalyticsEvents), useResource: useResource = (0, $2YP9W.useResource), useRouter: useRouter = (0, $doZTA.useRouter), useSpaStateTransition: useSpaStateTransition = (0, $bVDE5.useSpaStateTransition) })=>{
    const [{ match: match, query: query, route: route }] = useRouter();
    const { data: data } = useResource((0, $dxCvy.projectContextResource));
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
    (0, $5uXOq.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $2vSU6.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $2vSU6.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};

});



parcelRegister("87aC7", function(module, exports) {

$parcel$export(module.exports, "projectComponentsRouteEntry", () => $97d73743db912d34$export$e60f53ff5ae626cd);

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $xNRJ9 = parcelRequire("xNRJ9");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $59Kn5 = parcelRequire("59Kn5");

var $lkFvK = parcelRequire("lkFvK");

var $fo6b8 = parcelRequire("fo6b8");

var $7JEuc = parcelRequire("7JEuc");
const $97d73743db912d34$var$projectComponentsPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7JEuc.projectComponentsEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $97d73743db912d34$export$e60f53ff5ae626cd = (0, $7NszV.createEntry)((0, $59Kn5.projectComponentsRoute), ()=>({
        group: 'components',
        ufoName: 'project-components-view',
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource),
            (0, $xNRJ9.projectsComponentsResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$97d73743db912d34$var$projectComponentsPageEntryPoint
    }));

});
parcelRegister("59Kn5", function(module, exports) {

$parcel$export(module.exports, "projectComponentsRoute", () => $c0c0fb35b16dfdd1$export$f76189bea494b0b8);
const $c0c0fb35b16dfdd1$export$f76189bea494b0b8 = {
    name: 'project-components',
    path: '/jira/:projectType(software|software/c|servicedesk|core)/projects/:projectKey/components'
};

});

parcelRegister("7JEuc", function(module, exports) {

$parcel$export(module.exports, "projectComponentsEntrypoint", () => $ba5b4d8c4394f047$export$d90db228c6acd520);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $ba5b4d8c4394f047$export$d90db228c6acd520 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("eRz9R")), {
        moduleId: "f6db472c"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("eRz9R", function(module, exports) {

let $ad214999af906df1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ad214999af906df1$var$load("ffQaD"),
    $ad214999af906df1$var$load("kvRbA"),
    $ad214999af906df1$var$load("fliVL"),
    $ad214999af906df1$var$load("b2kYj")
]).then(()=>parcelRequire('2NjcZ'));

});



parcelRegister("hPrN5", function(module, exports) {

$parcel$export(module.exports, "projectNotFoundRouteEntry", () => $292badf40134cb3e$export$beae48175e3016b8);

var $lkFvK = parcelRequire("lkFvK");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $frKbc = parcelRequire("frKbc");

var $T9TsM = parcelRequire("T9TsM");
const $292badf40134cb3e$var$projectNotFoundPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $T9TsM.projectNotFoundEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $292badf40134cb3e$export$beae48175e3016b8 = (0, $7NszV.createEntry)((0, $frKbc.projectNotFoundRoute), ()=>({
        group: 'errors',
        entryPoint () {
            return $292badf40134cb3e$var$projectNotFoundPageEntryPoint;
        },
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        pageId: 'project-not-found-page-id'
    }));

});
parcelRegister("frKbc", function(module, exports) {

$parcel$export(module.exports, "projectNotFoundRoute", () => $5f4b2f1efa38e84e$export$ad23ddca45852d02);
const $5f4b2f1efa38e84e$export$ad23ddca45852d02 = {
    name: 'project-not-found',
    path: '/jira/:projectType(software|servicedesk|core|polaris)/projects/not-found',
    exact: true
};

});

parcelRegister("T9TsM", function(module, exports) {

$parcel$export(module.exports, "projectNotFoundEntryPoint", () => $ad3635ddd4e67df5$export$6ffa2f426ba3b25a);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $ad3635ddd4e67df5$export$6ffa2f426ba3b25a = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("03Taw")), {
        moduleId: "51ed29c5"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("03Taw", function(module, exports) {

let $00bb134f62f91f02$var$load = (parcelRequire("28QjX"))(4);
module.exports = $00bb134f62f91f02$var$load("ifylz").then(()=>parcelRequire('L9JRT'));

});



parcelRegister("kKEWZ", function(module, exports) {

$parcel$export(module.exports, "projectPagesLegacyRouteEntry", () => $5b3bb769f5acfa20$export$5788c5f8c4e440b1);

var $ffza4 = parcelRequire("ffza4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $4U4Td = parcelRequire("4U4Td");

var $9V7O8 = parcelRequire("9V7O8");
const $5b3bb769f5acfa20$export$5788c5f8c4e440b1 = (0, $7NszV.createEntry)((0, $4U4Td.projectPagesLegacyRoute), ()=>({
        group: 'components',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        component: !false ? (0, $9V7O8.PagesRedirect) : (0, $9V7O8.default),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $9V7O8.LazyProjectPages)
        ],
        isRedirect: true
    }));

});
parcelRegister("4U4Td", function(module, exports) {

$parcel$export(module.exports, "projectPagesLegacyRoute", () => $25092ed805d69948$export$a82cbb9b9c689c40);
const $25092ed805d69948$export$a82cbb9b9c689c40 = {
    name: 'project-pages-legacy',
    path: '/projects/:projectKey',
    query: [
        'selectedItem=com.atlassian.jira.jira-projects-plugin:project-pages-page'
    ]
};

});

parcelRegister("9V7O8", function(module, exports) {

$parcel$export(module.exports, "LazyProjectPages", () => $4be66c9d92628f7f$export$c2115a649411f570);
$parcel$export(module.exports, "PagesRedirect", () => $4be66c9d92628f7f$export$7c3b1828ada63555);
$parcel$export(module.exports, "default", () => $4be66c9d92628f7f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $3jbwx = parcelRequire("3jbwx");

const $4be66c9d92628f7f$export$c2115a649411f570 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("gnvTd"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/project/pages/src/index.tsx"
});
const $4be66c9d92628f7f$export$7c3b1828ada63555 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3jbwx.RedirectToProjectType), {
        page: "/pages"
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4be66c9d92628f7f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $4be66c9d92628f7f$export$c2115a649411f570,
        pageId: "project-pages",
        shouldShowSpinner: false
    });

});
parcelRegister("3jbwx", function(module, exports) {

$parcel$export(module.exports, "RedirectToProjectType", () => $b1c3ef54235a025d$export$8a3df560509448b8);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dxCvy = parcelRequire("dxCvy");

var $bVDE5 = parcelRequire("bVDE5");

var $7tQej = parcelRequire("7tQej");
var $2YP9W = parcelRequire("2YP9W");
var $doZTA = parcelRequire("doZTA");
const $b1c3ef54235a025d$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $7tQej.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $8zOmE.fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, $2NMNM.useAnalyticsEvents), useResource: useResource = (0, $2YP9W.useResource), useRouter: useRouter = (0, $doZTA.useRouter), useSpaStateTransition: useSpaStateTransition = (0, $bVDE5.useSpaStateTransition) })=>{
    const [{ match: match, query: query, route: route }] = useRouter();
    const { data: data } = useResource((0, $dxCvy.projectContextResource));
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
    (0, $5uXOq.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $2vSU6.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $2vSU6.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};

});

parcelRegister("gnvTd", function(module, exports) {

let $bec787f016102870$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $bec787f016102870$var$load("76n7a"),
    $bec787f016102870$var$load("l253H"),
    $bec787f016102870$var$load("eXPra")
]).then(()=>parcelRequire('8nMC7'));

});



parcelRegister("ljItG", function(module, exports) {

$parcel$export(module.exports, "projectPagesRouteEntry", () => $ec177ab479977ba2$export$babf32528ef518e9);

var $ffza4 = parcelRequire("ffza4");

var $7XYc4 = parcelRequire("7XYc4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $5lsNZ = parcelRequire("5lsNZ");

var $gTBUm = parcelRequire("gTBUm");

var $kfztd = parcelRequire("kfztd");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");

var $9V7O8 = parcelRequire("9V7O8");
const $ec177ab479977ba2$export$babf32528ef518e9 = (0, $7NszV.createEntry)((0, $gTBUm.projectPagesRoute), ()=>({
        group: 'components',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingM2Enabled)(), (0, $9V5k0.projectThemeResource))
        ],
        component: (0, $7XYc4.componentWithCondition)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $9V7O8.default)),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $9V7O8.LazyProjectPages)
        ]
    }));

});
parcelRegister("gTBUm", function(module, exports) {

$parcel$export(module.exports, "projectPagesRoute", () => $b32f9068985446b1$export$54a218ca6d1c056a);
const $b32f9068985446b1$export$54a218ca6d1c056a = {
    name: 'project-pages',
    path: '/jira/:projectType(software|software/c|servicedesk)/projects/:projectKey/pages'
};

});


parcelRegister("6JQwt", function(module, exports) {

$parcel$export(module.exports, "projectSettingsComponentsRouteEntry", () => $ad71816b701c4a98$export$72497f4e39dd0df4);

var $ffza4 = parcelRequire("ffza4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $xNRJ9 = parcelRequire("xNRJ9");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $cQsSp = parcelRequire("cQsSp");

var $cSUZZ = parcelRequire("cSUZZ");

var $d83t6 = parcelRequire("d83t6");
const $ad71816b701c4a98$export$72497f4e39dd0df4 = (0, $7NszV.createEntry)((0, $cQsSp.projectSettingsComponentsRoute), ()=>({
        group: 'components',
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $dxCvy.projectContextResource),
            (0, $xNRJ9.projectsComponentsResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        component: (0, $d83t6.default),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $d83t6.LazyProjectComponentsSettings)
        ]
    }));

});
parcelRegister("cQsSp", function(module, exports) {

$parcel$export(module.exports, "projectSettingsComponentsRoute", () => $d6034f5b9e9794c0$export$79cbce13eeecd53);
const $d6034f5b9e9794c0$export$79cbce13eeecd53 = {
    name: 'project-settings-components',
    path: '/plugins/servlet/project-config/:projectKey/administer-components'
};

});

parcelRegister("d83t6", function(module, exports) {

$parcel$export(module.exports, "LazyProjectComponentsSettings", () => $2794979f407c5b17$export$bb69d8c36391123);
$parcel$export(module.exports, "default", () => $2794979f407c5b17$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $aZsz6 = parcelRequire("aZsz6");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $a25Ol = parcelRequire("a25Ol");

const $2794979f407c5b17$export$bb69d8c36391123 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("eRz9R"))), {
    moduleId: "./src/packages/spa-apps/project/components/src/index.tsx"
});
const $2794979f407c5b17$export$60cfbcd781a48d01 = ()=>{
    const page = (_, { selectedItem: selectedItem, ...rest })=>{
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
        const querystring = (0, $aZsz6.qs).stringify(rest, true);
        return `/settings/components${querystring}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a25Ol.RedirectToProjectType), {
        page: page
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2794979f407c5b17$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2794979f407c5b17$export$bb69d8c36391123,
        pageId: "project-settings-components",
        shouldShowSpinner: true
    });

});
parcelRegister("a25Ol", function(module, exports) {

$parcel$export(module.exports, "RedirectToProjectType", () => $55786e10b01ad2e7$export$8a3df560509448b8);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dxCvy = parcelRequire("dxCvy");

var $bVDE5 = parcelRequire("bVDE5");

var $7tQej = parcelRequire("7tQej");
var $2YP9W = parcelRequire("2YP9W");
var $doZTA = parcelRequire("doZTA");
const $55786e10b01ad2e7$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $7tQej.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $8zOmE.fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, $2NMNM.useAnalyticsEvents), useResource: useResource = (0, $2YP9W.useResource), useRouter: useRouter = (0, $doZTA.useRouter), useSpaStateTransition: useSpaStateTransition = (0, $bVDE5.useSpaStateTransition) })=>{
    const [{ match: match, query: query, route: route }] = useRouter();
    const { data: data } = useResource((0, $dxCvy.projectContextResource));
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
    (0, $5uXOq.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $2vSU6.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $2vSU6.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};

});



parcelRegister("dRm2C", function(module, exports) {

$parcel$export(module.exports, "projectSettingsVersionsRouteEntry", () => $1aa15c245eff2860$export$4791201b4877aa5d);

var $ffza4 = parcelRequire("ffza4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $bC7QJ = parcelRequire("bC7QJ");

var $7GnDe = parcelRequire("7GnDe");

var $cXVqt = parcelRequire("cXVqt");

var $cSUZZ = parcelRequire("cSUZZ");

var $af7CK = parcelRequire("af7CK");
const $1aa15c245eff2860$export$4791201b4877aa5d = (0, $7NszV.createEntry)((0, $cXVqt.projectSettingsVersionsRoute), ()=>({
        group: 'components',
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $dxCvy.projectContextResource),
            (0, $bC7QJ.projectVersionsRelayResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        component: (0, $af7CK.RelayVersions),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $af7CK.LazyRelayProjectVersions)
        ]
    }));

});
parcelRegister("bC7QJ", function(module, exports) {

$parcel$export(module.exports, "projectVersionsRelayResource", () => $d194483d3a062e97$export$7e8aa1360f86345c);
/* eslint-disable jira/import-whitelist */ 
var $8Uumt = parcelRequire("8Uumt");


var $e8T8A = parcelRequire("e8T8A");

var $5yJb9 = parcelRequire("5yJb9");

var $kipqU = parcelRequire("kipqU");

var $ao2h1 = parcelRequire("ao2h1");

var $lqMPx = parcelRequire("lqMPx");

var $2M1hQ = parcelRequire("2M1hQ");

var $4R6GH = parcelRequire("4R6GH");

const $d194483d3a062e97$export$7e8aa1360f86345c = (0, $2M1hQ.createResource)({
    type: `${(0, $ao2h1.RELAY_RESOURCE_TYPE)}_${(0, $92b865e141ed2a4f$export$59aa73792ad9507a)}`,
    getKey: ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        return `project-version-query-relay-${projectKey}`;
    },
    // @ts-expect-error - might return null
    getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const queryReference = (0, $8Uumt.loadQuery)((0, $5yJb9.default)(), (0, $lqMPx.default), {
            initialLoadCount: 20,
            cloudId: tenantContext.cloudId,
            projectKey: match.params.projectKey,
            filter: (0, $e8T8A.transformStatusFromParam)(query[0, $6868fc0fce0c2912$export$3e8168848b996f7]),
            searchString: query[0, $6868fc0fce0c2912$export$a181206198b7f50c] || '',
            sortBy: {
                sortByField: (0, $e8T8A.transformSortFieldFromParam)(query[0, $6868fc0fce0c2912$export$a3482d3a8df0e725]),
                order: (0, $e8T8A.transformSortOrderFromParam)(query[0, $6868fc0fce0c2912$export$71089821f361e881])
            },
            isManageVersionsPermissionEnabled: (0, $4R6GH.fg)('vmc-11-manage-versions-permission')
        }, {
            fetchPolicy: 'store-or-network'
        });
        if (false && queryReference.id != null) await (0, $kipqU.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});

});
const $6868fc0fce0c2912$export$a181206198b7f50c = 'contains';
const $6868fc0fce0c2912$export$3e8168848b996f7 = 'status';
const $6868fc0fce0c2912$export$71089821f361e881 = 'orderDirection';
const $6868fc0fce0c2912$export$a3482d3a8df0e725 = 'orderField';
const $6868fc0fce0c2912$export$3c5e605ca7ade9f2 = 'NAME';
const $6868fc0fce0c2912$export$50241fe906e4f94e = 'RELEASE_DATE';
const $6868fc0fce0c2912$export$99a467bcc22b8df9 = 'START_DATE';
const $6868fc0fce0c2912$export$d44826c816b5619b = 'DESCRIPTION';
const $6868fc0fce0c2912$export$34694f8d8b23ee2a = 'SEQUENCE';
const $6868fc0fce0c2912$export$cb638d1fae624fbf = 20;
const $6868fc0fce0c2912$export$bbcbc202f2dfa28c = 3;
const $6868fc0fce0c2912$export$b983f2cb1f658a55 = 'RELEASED';
const $6868fc0fce0c2912$export$cb459d726a8530a5 = 'UNRELEASED';
const $6868fc0fce0c2912$export$c936349447a77fe0 = 'ARCHIVED';
const $6868fc0fce0c2912$export$c5ed97509d0e2aaf = 'projectVersions';

parcelRegister("e8T8A", function(module, exports) {

$parcel$export(module.exports, "transformStatusFromParam", () => $b959dd84148d7436$export$5760f9690301cdb);
$parcel$export(module.exports, "transformStatusToParam", () => $b959dd84148d7436$export$46595832dd863016);
$parcel$export(module.exports, "transformSortOrderFromParam", () => $b959dd84148d7436$export$1945e6d2f31e09e6);
$parcel$export(module.exports, "transformSortFieldFromParam", () => $b959dd84148d7436$export$f842a0d1846d319d);
$parcel$export(module.exports, "transformStatusToDropdownSelection", () => $b959dd84148d7436$export$7dad705635760cfe);
$parcel$export(module.exports, "getUpdatedDisplayedStatuses", () => $b959dd84148d7436$export$ce4c948ba1d53df4);
$parcel$export(module.exports, "getFormattedVersionDate", () => $b959dd84148d7436$export$5a6eeb16be7dd21d);


var $1O7Kb = parcelRequire("1O7Kb");

var $brjCS = parcelRequire("brjCS");

const $b959dd84148d7436$export$5760f9690301cdb = (input)=>{
    switch(input){
        case 'no-filter':
            return [
                (0, $brjCS.RELEASED),
                (0, $brjCS.UNRELEASED),
                (0, $brjCS.ARCHIVED)
            ];
        case 'all':
            return [
                (0, $brjCS.RELEASED),
                (0, $brjCS.UNRELEASED),
                (0, $brjCS.ARCHIVED)
            ];
        default:
            {
                const params = (input || '').split('-');
                const result = [
                    ...params.includes('released') ? [
                        (0, $brjCS.RELEASED)
                    ] : [],
                    ...params.includes('unreleased') ? [
                        (0, $brjCS.UNRELEASED)
                    ] : [],
                    ...params.includes('archived') ? [
                        (0, $brjCS.ARCHIVED)
                    ] : []
                ];
                return result.length ? result : [
                    (0, $brjCS.UNRELEASED)
                ];
            }
    }
};
const $b959dd84148d7436$export$46595832dd863016 = (input)=>{
    if (input) {
        if (input.length === 0) return 'no-filter';
        if (input.length > 2) return 'all';
        return [
            input.includes((0, $brjCS.RELEASED)) && [
                'released'
            ],
            input.includes((0, $brjCS.UNRELEASED)) && [
                'unreleased'
            ],
            input.includes((0, $brjCS.ARCHIVED)) && [
                'archived'
            ]
        ].filter(Boolean).join('-');
    }
    return undefined;
};
const $b959dd84148d7436$export$1945e6d2f31e09e6 = (input)=>{
    switch(input){
        case 'ASC':
            return 0, $2a9e000a443b1a95$export$1dee026a19752d6b;
        case 'DESC':
            return 0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65;
        default:
            return 0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65;
    }
};
const $b959dd84148d7436$export$f842a0d1846d319d = (input)=>{
    switch(input){
        case 'NAME':
            return 0, $6868fc0fce0c2912$export$3c5e605ca7ade9f2;
        case 'RELEASEDATE':
            return 0, $6868fc0fce0c2912$export$50241fe906e4f94e;
        case 'STARTDATE':
            return 0, $6868fc0fce0c2912$export$99a467bcc22b8df9;
        case 'DESCRIPTION':
            return 0, $6868fc0fce0c2912$export$d44826c816b5619b;
        case 'SEQUENCE':
            return 0, $6868fc0fce0c2912$export$34694f8d8b23ee2a;
        default:
            return 0, $6868fc0fce0c2912$export$34694f8d8b23ee2a;
    }
};
const $b959dd84148d7436$export$7dad705635760cfe = (input)=>{
    switch(input){
        case 'no-filter':
            return [];
        case 'all':
            return [
                (0, $brjCS.RELEASED),
                (0, $brjCS.UNRELEASED),
                (0, $brjCS.ARCHIVED)
            ];
        default:
            {
                const params = (input || '').split('-');
                const result = [
                    ...params.includes('released') ? [
                        (0, $brjCS.RELEASED)
                    ] : [],
                    ...params.includes('unreleased') ? [
                        (0, $brjCS.UNRELEASED)
                    ] : [],
                    ...params.includes('archived') ? [
                        (0, $brjCS.ARCHIVED)
                    ] : []
                ];
                return result.length ? result : [
                    (0, $brjCS.UNRELEASED)
                ];
            }
    }
};
const $b959dd84148d7436$export$ce4c948ba1d53df4 = (displayedStatuses, selectedStatuses, newStatus)=>{
    // Handle the case when a status is selected after deselection of all in dropdown where versions in all statuses are displayed despite empty selection & deselecting a status from a full selection.
    if (displayedStatuses.length === (0, $6868fc0fce0c2912$export$bbcbc202f2dfa28c)) {
        if (!selectedStatuses.length) return [
            newStatus
        ];
        return displayedStatuses.filter((status)=>status !== newStatus);
    }
    return displayedStatuses.includes(newStatus) ? displayedStatuses.filter((item)=>item !== newStatus) : [
        ...displayedStatuses,
        newStatus
    ];
};
const $b959dd84148d7436$export$5a6eeb16be7dd21d = (versionDate, formatDate)=>versionDate != null ? formatDate(new Date(versionDate), {
        timeZone: (0, $1O7Kb.VERSION_DATE_FORMAT_OPTION).timeZone,
        dateStyle: 'long'
    }) : '';

});
parcelRegister("1O7Kb", function(module, exports) {

$parcel$export(module.exports, "VERSION_DATE_FORMAT_OPTION", () => $db4b27c65287280e$export$d54c0d576c2caef5);
// Used to format date string from the server to display version start date and release date
// Server only stores date without any time information such as 2023-12-31
// Use this WHENEVER displaying version start date and release date.
// If you respect local timezone without this constant, there will be a bug that will display one day early date in negative timezones.
// https://jira.atlassian.com/browse/JSWCLOUD-22316
const $db4b27c65287280e$export$d54c0d576c2caef5 = {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC'
};

});

parcelRegister("brjCS", function(module, exports) {

$parcel$export(module.exports, "RELEASED", () => $96a1491cb0f9d4eb$export$b983f2cb1f658a55);
$parcel$export(module.exports, "UNRELEASED", () => $96a1491cb0f9d4eb$export$cb459d726a8530a5);
$parcel$export(module.exports, "ARCHIVED", () => $96a1491cb0f9d4eb$export$c936349447a77fe0);
const $96a1491cb0f9d4eb$export$b983f2cb1f658a55 = 'RELEASED';
const $96a1491cb0f9d4eb$export$cb459d726a8530a5 = 'UNRELEASED';
const $96a1491cb0f9d4eb$export$c936349447a77fe0 = 'ARCHIVED';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$96a1491cb0f9d4eb$export$2e2bcd8739ae039 = [
    $96a1491cb0f9d4eb$export$b983f2cb1f658a55,
    $96a1491cb0f9d4eb$export$cb459d726a8530a5,
    $96a1491cb0f9d4eb$export$c936349447a77fe0
];

});


parcelRegister("lqMPx", function(module, exports) {

$parcel$export(module.exports, "default", () => $08cc25b93689af36$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<be6ae44fd11772903154fa2ff10aa6ce>>
 * @relayHash f6deebf30059f6281cb9bf02e6322b7d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a175b6c61bf13924cb07158ed38861f8913923419e12aad6abdd2052a17b0395
const $08cc25b93689af36$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "initialLoadCount"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isManageVersionsPermissionEnabled"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "key"
    }, v11 = {
        "alias": "jiraProjectType",
        "kind": "ScalarField",
        "name": "projectType"
    }, v12 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "MANAGE_VERSIONS"
        }
    ], v13 = {
        "kind": "ScalarField",
        "name": "canPerform"
    }, v14 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v15 = {
        "kind": "Variable",
        "name": "searchString",
        "variableName": "searchString"
    }, v16 = {
        "kind": "Variable",
        "name": "sortBy",
        "variableName": "sortBy"
    }, v17 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v18 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v19 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v20 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v21 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v22 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "initialLoadCount"
    }, v23 = [
        v14 /*: any*/ ,
        v22 /*: any*/ ,
        v15 /*: any*/ ,
        v16 /*: any*/ 
    ], v24 = {
        "kind": "ScalarField",
        "name": "id"
    }, v25 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v26 = [
        v25 /*: any*/ 
    ], v27 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": "DONE"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiProjectVersionsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v8 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.projectId"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v9 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.name"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v10 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.key"
                                        },
                                        v11 /*: any*/ ,
                                        {
                                            "condition": "isManageVersionsPermissionEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "alias": "canEditVersions",
                                                    "args": v12 /*: any*/ ,
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v13 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "jira.jiraProjectByKey.canEditVersions.canPerform"
                                                        }
                                                    ],
                                                    "storageKey": "action(type:\"MANAGE_VERSIONS\")"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "alias": "versions",
                                                "args": [
                                                    v14 /*: any*/ ,
                                                    v15 /*: any*/ ,
                                                    v16 /*: any*/ 
                                                ],
                                                "concreteType": "JiraVersionConnection",
                                                "kind": "LinkedField",
                                                "name": "__uiProject__versions_connection",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraVersionEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            v17 /*: any*/ ,
                                                            v18 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraVersion",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v17 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "QueryError",
                                                        "kind": "LinkedField",
                                                        "name": "errors",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "extensions",
                                                                "plural": true,
                                                                "selections": [
                                                                    v19 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    v20 /*: any*/ ,
                                                    v21 /*: any*/ 
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.versions"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "args": [
                        v14 /*: any*/ ,
                        v22 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "isManageVersionsPermissionEnabled",
                            "variableName": "isManageVersionsPermissionEnabled"
                        },
                        v15 /*: any*/ ,
                        v16 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "table_projectVersions"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "uiProjectVersionsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                {
                                    "condition": "isManageVersionsPermissionEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "canEditVersions",
                                            "args": v12 /*: any*/ ,
                                            "concreteType": "JiraProjectAction",
                                            "kind": "LinkedField",
                                            "name": "action",
                                            "plural": false,
                                            "selections": [
                                                v13 /*: any*/ 
                                            ],
                                            "storageKey": "action(type:\"MANAGE_VERSIONS\")"
                                        }
                                    ]
                                },
                                {
                                    "args": v23 /*: any*/ ,
                                    "concreteType": "JiraVersionConnection",
                                    "kind": "LinkedField",
                                    "name": "versions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraVersion",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v24 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "status"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "startDate"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "releaseDate"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "overdue"
                                                        },
                                                        {
                                                            "alias": "allIssues",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "filter",
                                                                    "value": "ALL"
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v26 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"ALL\")"
                                                        },
                                                        {
                                                            "alias": "doneIssues",
                                                            "args": v27 /*: any*/ ,
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v26 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"DONE\")"
                                                        },
                                                        {
                                                            "alias": "done",
                                                            "args": v27 /*: any*/ ,
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v26 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"DONE\")"
                                                        },
                                                        {
                                                            "alias": "inProgress",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "filter",
                                                                    "value": "IN_PROGRESS"
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v26 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"IN_PROGRESS\")"
                                                        },
                                                        {
                                                            "alias": "toDo",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "filter",
                                                                    "value": "TODO"
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v26 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"TODO\")"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "versionId"
                                                        },
                                                        v9 /*: any*/ ,
                                                        v21 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "QueryError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v19 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        v25 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v23 /*: any*/ ,
                                    "filters": [
                                        "filter",
                                        "searchString",
                                        "sortBy"
                                    ],
                                    "handle": "connection",
                                    "key": "uiProject__versions",
                                    "kind": "LinkedHandle",
                                    "name": "versions"
                                },
                                v24 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a175b6c61bf13924cb07158ed38861f8913923419e12aad6abdd2052a17b0395",
            "metadata": {
                "connection": [
                    {
                        "count": "initialLoadCount",
                        "cursor": null,
                        "direction": "forward",
                        "path": [
                            "jira",
                            "jiraProjectByKey",
                            "versions"
                        ]
                    }
                ]
            },
            "name": "uiProjectVersionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$08cc25b93689af36$var$node.hash = "d200347d20dfa0c568d719d21b96cc62";
var $08cc25b93689af36$export$2e2bcd8739ae039 = $08cc25b93689af36$var$node;

});

const $92b865e141ed2a4f$export$59aa73792ad9507a = 'PROJECT_VERSIONS';


parcelRegister("cXVqt", function(module, exports) {

$parcel$export(module.exports, "projectSettingsVersionsRoute", () => $b9ce459589c7232c$export$cc9450e5d7579b99);
const $b9ce459589c7232c$export$cc9450e5d7579b99 = {
    name: 'project-settings-versions',
    path: '/plugins/servlet/project-config/:projectKey/administer-versions'
};

});

parcelRegister("af7CK", function(module, exports) {

$parcel$export(module.exports, "LazyRelayProjectVersions", () => $4b5729de9815f9dc$export$9036da4fa9f7a66f);
$parcel$export(module.exports, "RelayVersions", () => $4b5729de9815f9dc$export$9aff7dab80671d9);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $4b5729de9815f9dc$export$9036da4fa9f7a66f = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("9HXr2"))), {
    moduleId: "./src/packages/spa-apps/project/relay-versions/src/index.tsx"
});
const $4b5729de9815f9dc$export$9aff7dab80671d9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $4b5729de9815f9dc$export$9036da4fa9f7a66f,
        pageId: "relay-project-versions",
        shouldShowSpinner: false
    });

});
parcelRegister("9HXr2", function(module, exports) {

let $71163bc214002fdb$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $71163bc214002fdb$var$load("ffQaD"),
    $71163bc214002fdb$var$load("kvRbA"),
    $71163bc214002fdb$var$load("gq5gC")
]).then(()=>parcelRequire('5E2pR'));

});



parcelRegister("1Ps9S", function(module, exports) {

$parcel$export(module.exports, "projectsRedirectRouteEntry", () => $c72266bbdc090734$export$56f9921db324f30);

var $ffza4 = parcelRequire("ffza4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $7MCPm = parcelRequire("7MCPm");

var $2iuKi = parcelRequire("2iuKi");
const $c72266bbdc090734$export$56f9921db324f30 = (0, $7NszV.createEntry)((0, $2iuKi.projectsRedirectRoute), ()=>({
        group: 'redirects',
        isRedirect: true,
        component: (0, $7MCPm.RedirectToLastVisitedProjectPage),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("2iuKi", function(module, exports) {

$parcel$export(module.exports, "projectsRedirectRoute", () => $3aa0370b36d3207d$export$e6bc3ea427ddafb8);
const $3aa0370b36d3207d$export$e6bc3ea427ddafb8 = {
    name: 'projects-redirect',
    path: '/projects/:projectKey',
    query: [
        'selectedItem!=(.+)'
    ],
    exact: true
};

});


parcelRegister("bRRmd", function(module, exports) {

$parcel$export(module.exports, "projectVersionsRouteEntry", () => $3890e3ec7715d603$export$982bc443ef89cc3f);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $bC7QJ = parcelRequire("bC7QJ");

var $7GnDe = parcelRequire("7GnDe");

var $1G6pd = parcelRequire("1G6pd");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $3890e3ec7715d603$var$LazyRelayProjectVersions = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("9HXr2"))), {
    moduleId: "./src/packages/spa-apps/project/relay-versions/src/index.tsx"
});
const $3890e3ec7715d603$var$RelayVersions = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3890e3ec7715d603$var$LazyRelayProjectVersions,
        pageId: "relay-project-versions",
        shouldShowSpinner: false
    });
const $3890e3ec7715d603$export$982bc443ef89cc3f = (0, $7NszV.createEntry)((0, $1G6pd.projectVersionsRoute), ()=>({
        group: 'components',
        resources: [
            ...(0, $lNicp.getBusinessProjectResources)(),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $bC7QJ.projectVersionsRelayResource)
        ],
        component: $3890e3ec7715d603$var$RelayVersions,
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $3890e3ec7715d603$var$LazyRelayProjectVersions
        ]
    }));

});
parcelRegister("1G6pd", function(module, exports) {

$parcel$export(module.exports, "projectVersionsRoute", () => $4cfeade459489896$export$fb5516756c3eba40);

var $kMGqE = parcelRequire("kMGqE");
const $4cfeade459489896$export$fb5516756c3eba40 = {
    name: 'project-versions',
    path: '/projects/:projectKey',
    query: (0, $kMGqE.PROJECTS_VERSIONS_QUERY_PARAMS)
};

});
parcelRegister("kMGqE", function(module, exports) {

$parcel$export(module.exports, "PROJECTS_VERSIONS_QUERY_PARAMS", () => $91224398be5e0171$export$ad46185437bb571a);
const $91224398be5e0171$export$ad46185437bb571a = [
    'selectedItem=com.atlassian.jira.jira-projects-plugin:release-page'
];

});



parcelRegister("jr7ke", function(module, exports) {

$parcel$export(module.exports, "sandboxBundlerRouteEntry", () => $4ca2e5796b93a363$export$71497b88db8291d0);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $cSD7y = parcelRequire("cSD7y");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $5lsNZ = parcelRequire("5lsNZ");

var $3LHrF = parcelRequire("3LHrF");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $4ca2e5796b93a363$var$LazySandboxBundlerPage = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("6v9Qq"))), {
    moduleId: "./src/packages/spa-apps/sandbox/bundler/src/index.tsx"
});
const $4ca2e5796b93a363$var$SandboxBundler = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $4ca2e5796b93a363$var$LazySandboxBundlerPage,
        pageId: "sandbox-bundler",
        shouldShowSpinner: true
    });
const $4ca2e5796b93a363$export$71497b88db8291d0 = (0, $7NszV.createEntry)((0, $3LHrF.sandboxBundlerRoute), ()=>({
        group: 'sandbox',
        component: (0, $cSD7y.componentWithFG)('conditional_import_sandbox', $4ca2e5796b93a363$var$SandboxBundler, (0, $5lsNZ.default)),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $4ca2e5796b93a363$var$LazySandboxBundlerPage
        ],
        ufoName: 'sandbox-bundler'
    }));

});
parcelRegister("3LHrF", function(module, exports) {

$parcel$export(module.exports, "sandboxBundlerRoute", () => $2919d66f60e8ebb6$export$3891624aac454ec2);
const $2919d66f60e8ebb6$export$3891624aac454ec2 = {
    name: 'sandbox-bundler',
    path: '/jira/software/sandbox/bundler',
    exact: true
};

});

parcelRegister("6v9Qq", function(module, exports) {

let $4bbd4645ad5b0baf$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("avM1e"))('test_conditional_imports', function() {
        return Promise.all([
            (parcelRequire("avM1e"))('some_feature_gate_that_doesnt_exist', function() {
                return Promise.all([
                    $4bbd4645ad5b0baf$var$load("diclD")
                ]);
            }, function() {
                return Promise.all([
                    $4bbd4645ad5b0baf$var$load("jx2kw")
                ]);
            }),
            $4bbd4645ad5b0baf$var$load("dLcOq")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("avM1e"))('some_feature_gate_that_doesnt_exist', function() {
                return Promise.all([
                    $4bbd4645ad5b0baf$var$load("diclD")
                ]);
            }, function() {
                return Promise.all([
                    $4bbd4645ad5b0baf$var$load("jx2kw")
                ]);
            }),
            $4bbd4645ad5b0baf$var$load("fhdtB")
        ]);
    }),
    $4bbd4645ad5b0baf$var$load("ipbtI")
]).then(()=>parcelRequire('jsr3R'));

});


parcelRegister("gtcNN", function(module, exports) {

$parcel$export(module.exports, "sandboxBundlerBifrostRLLRouteEntry", () => $37a8de44636c635e$export$e0dd38ef6ff677e7);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $cSD7y = parcelRequire("cSD7y");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $5lsNZ = parcelRequire("5lsNZ");

var $8v2Rt = parcelRequire("8v2Rt");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $37a8de44636c635e$var$LazySandboxBundlerPage = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("6v9Qq"))), {
    moduleId: "./src/packages/spa-apps/sandbox/bundler/src/index.tsx"
});
const $37a8de44636c635e$var$SandboxBundler = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $37a8de44636c635e$var$LazySandboxBundlerPage,
        pageId: "sandbox-bundler-bifrost",
        shouldShowSpinner: true
    });
const $37a8de44636c635e$export$e0dd38ef6ff677e7 = (0, $7NszV.createEntry)((0, $8v2Rt.sandboxBundlerBifrostRLLRoute), ()=>({
        group: 'sandbox',
        component: (0, $cSD7y.componentWithFG)('conditional_import_sandbox_bifrost', $37a8de44636c635e$var$SandboxBundler, (0, $5lsNZ.default)),
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $37a8de44636c635e$var$LazySandboxBundlerPage
        ],
        ufoName: 'sandbox-bundler',
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-sandbox-entries/src/sandboxBundlerBifrostRLLRouteEntry.tsx',
                whichExportToUse: 'sandboxBundlerBifrostRLLRouteEntry'
            },
            enabled: false
        }
    }));

});
parcelRegister("8v2Rt", function(module, exports) {

$parcel$export(module.exports, "sandboxBundlerBifrostRLLRoute", () => $d64f6dbc3099be3d$export$c21fd836e6493cee);
const $d64f6dbc3099be3d$export$c21fd836e6493cee = {
    name: 'sandbox-bundler-bifrost-rll',
    path: '/jira/software/sandbox/bundler-bifrost/rll',
    exact: true
};

});


parcelRegister("gMkpP", function(module, exports) {

$parcel$export(module.exports, "sandboxBundlerBifrostEntrypointsRouteEntry", () => $b93ec6a6f2bfa33b$export$95bd68c4f26980ed);

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $lkFvK = parcelRequire("lkFvK");

var $3RJkv = parcelRequire("3RJkv");

var $4R6GH = parcelRequire("4R6GH");

var $6LsQE = parcelRequire("6LsQE");

var $c6VcK = parcelRequire("c6VcK");

var $lmyls = parcelRequire("lmyls");

var $1a10w = parcelRequire("1a10w");
const $b93ec6a6f2bfa33b$var$sandboxBundlerBifrostPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1a10w.sandboxBundlerBifrostEntryPoint),
    // using PROJECTS as a placeholder
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $b93ec6a6f2bfa33b$export$95bd68c4f26980ed = (0, $7NszV.createEntry)((0, $c6VcK.sandboxBundlerBifrostEntrypointsRoute), ()=>({
        group: 'sandbox',
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        ufoName: 'sandbox-bundler',
        entryPoint: ()=>(0, $4R6GH.fg)('conditional_import_sandbox_bifrost') ? $b93ec6a6f2bfa33b$var$sandboxBundlerBifrostPageEntryPoint : (0, $6LsQE.notFoundPageEntrypoint),
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-sandbox-entries/src/sandboxBundlerBifrostEntrypointsRouteEntry.tsx',
                whichExportToUse: 'sandboxBundlerBifrostEntrypointsRouteEntry'
            },
            enabled: false
        }
    }));

});
parcelRegister("c6VcK", function(module, exports) {

$parcel$export(module.exports, "sandboxBundlerBifrostEntrypointsRoute", () => $7e324bc9b2d883b2$export$1e4fe7eb44ddb2fd);
const $7e324bc9b2d883b2$export$1e4fe7eb44ddb2fd = {
    name: 'sandbox-bundler-bifrost-entrypoints',
    path: '/jira/software/sandbox/bundler-bifrost/entrypoints',
    exact: true
};

});

parcelRegister("1a10w", function(module, exports) {

$parcel$export(module.exports, "sandboxBundlerBifrostEntryPoint", () => $a22d3ee72805761a$export$e6bb5cf1b802d157);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $a22d3ee72805761a$export$e6bb5cf1b802d157 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("6v9Qq")), {
        moduleId: "ce1b1bd6"
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("8VY8F", function(module, exports) {

$parcel$export(module.exports, "sandboxRelayEchoPageUsingRLLRouteEntry", () => $665d41b0efb6bf2c$export$3981404cc747e85);

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $eGfyu = parcelRequire("eGfyu");

var $9ALh1 = parcelRequire("9ALh1");

var $lmyls = parcelRequire("lmyls");

var $5f2bR = parcelRequire("5f2bR");

var $5wazW = parcelRequire("5wazW");

var $3o2V7 = parcelRequire("3o2V7");
const $665d41b0efb6bf2c$export$3981404cc747e85 = (0, $7NszV.createEntry)((0, $eGfyu.sandboxRelayEchoPageUsingRLLRoute), ()=>({
        group: 'sandbox',
        layout: (0, $2BrOV.globalLayout),
        skeleton: (0, $3o2V7.Skeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        component: (0, $9ALh1.AsyncSandboxEchoPage),
        lazyForPaint: [
            (0, $9ALh1.AsyncSandboxEchoPage)
        ],
        resources: [
            (0, $5wazW.sandboxEchoPageRelayResource)
        ],
        ufoName: 'sandbox-relay-echo',
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-sandbox-entries/src/sandboxRelayEchoPageUsingRLLRouteEntry.tsx',
                whichExportToUse: 'sandboxRelayEchoPageUsingRLLRouteEntry'
            },
            // WARNING: setting this to `true` will cause us to build & deploy the route to bifrost+tesseract instances worldwide, which is quite expensive!
            // enabled: true,
            manifestName: 'jira-spa-sandboxdemo.json'
        }
    }));

});
parcelRegister("eGfyu", function(module, exports) {

$parcel$export(module.exports, "sandboxRelayEchoPageUsingRLLRoute", () => $60296d8f40ca6e26$export$382892be07e8f9fc);
const $60296d8f40ca6e26$export$382892be07e8f9fc = {
    name: 'sandbox-relay-defer-echo',
    path: '/jira/software/sandbox/relay/echo',
    exact: true
};

});

parcelRegister("9ALh1", function(module, exports) {

$parcel$export(module.exports, "AsyncSandboxEchoPage", () => $3807a6a16c88bb0d$export$3e76bcb04553d279);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $kxZPA = parcelRequire("kxZPA");

var $ao2h1 = parcelRequire("ao2h1");

var $7yO8g = parcelRequire("7yO8g");

var $7k9VK = parcelRequire("7k9VK");

var $lfTZh = parcelRequire("lfTZh");

var $5wazW = parcelRequire("5wazW");

const $3807a6a16c88bb0d$export$cc4c54c1ebe3736c = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("8Zcgn"))), {
    moduleId: "./src/packages/spa-apps/sandbox/relay/src/ui/SandboxEchoPage.tsx"
});
const $3807a6a16c88bb0d$export$131119b9314343c7 = ()=>{
    const [queryReference, loadQuery] = (0, $8Uumt.useQueryLoader)((0, $7k9VK.default));
    if (queryReference == null) {
        loadQuery({
            cloudId: '7088b486-bbf4-4e1f-9195-412bfac4be28',
            enableDefer: true,
            skipLongQuery: true
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("small", null, "Triggering query...");
    }
    const props = {
        queries: {
            pageQueryRef: queryReference
        },
        props: {},
        extraProps: {},
        entryPoints: {}
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("small", null, "Self-starting sandbox echo page"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "self-starting-sandbox-echo-page",
        fallback: "Loading echo page..."
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3807a6a16c88bb0d$export$cc4c54c1ebe3736c, props)));
};
const $3807a6a16c88bb0d$export$3e76bcb04553d279 = ()=>{
    const { queryReference: queryReference } = (0, $ao2h1.useRelayResource)((0, $5wazW.sandboxEchoPageRelayResource));
    const props = queryReference ? {
        queries: {
            pageQueryRef: queryReference
        },
        props: {},
        extraProps: {},
        entryPoints: {}
    } : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("small", null, "Async sandbox echo page"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-sandbox-echo-page",
        fallback: "Loading echo page..."
    }, props && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3807a6a16c88bb0d$export$cc4c54c1ebe3736c, props)));
};

});
parcelRegister("7k9VK", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c6e216d80813cf2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f43786c95d21554e6525e62ba3fbbd95>>
 * @relayHash 34217eab0f370d5568f7c0ae333e556f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1b22a744e4afb7fe2f6980e1e86b1c0648005cad43d16555b8e2f7003e74dec9
const $1c6e216d80813cf2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "enableDefer"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skipLongQuery"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "alias": "criticalMessage",
        "args": v2 /*: any*/ ,
        "kind": "ScalarField",
        "name": "echo"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SandboxEchoPageQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            v3 /*: any*/ ,
                            {
                                "kind": "Defer",
                                "selections": [
                                    {
                                        "args": v2 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "SandboxEchoDefer1"
                                    }
                                ]
                            },
                            {
                                "kind": "Defer",
                                "selections": [
                                    {
                                        "args": v2 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "SandboxEchoDefer2"
                                    }
                                ]
                            },
                            {
                                "kind": "Defer",
                                "selections": [
                                    {
                                        "args": [
                                            v1 /*: any*/ ,
                                            {
                                                "kind": "Variable",
                                                "name": "enableDefer",
                                                "variableName": "enableDefer"
                                            }
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "SandboxEchoDefer3"
                                    }
                                ]
                            },
                            {
                                "condition": "skipLongQuery",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "kind": "Defer",
                                        "selections": [
                                            {
                                                "args": v2 /*: any*/ ,
                                                "kind": "FragmentSpread",
                                                "name": "SandboxEchoVeryLongQuery"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SandboxEchoPageQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "if": "enableDefer",
                            "kind": "Defer",
                            "label": "SandboxEchoPageQuery$defer$SandboxEchoDefer1_PVNZy",
                            "selections": [
                                {
                                    "alias": "defer1",
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "where",
                                            "value": {
                                                "delayMs": 500
                                            }
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "echo"
                                }
                            ]
                        },
                        {
                            "if": "enableDefer",
                            "kind": "Defer",
                            "label": "SandboxEchoPageQuery$defer$SandboxEchoDefer2_PVNZy",
                            "selections": [
                                {
                                    "alias": "defer2",
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "where",
                                            "value": {
                                                "delayMs": 700
                                            }
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "echo"
                                }
                            ]
                        },
                        {
                            "if": "enableDefer",
                            "kind": "Defer",
                            "label": "SandboxEchoPageQuery$defer$SandboxEchoDefer3_1jcU60",
                            "selections": [
                                {
                                    "alias": "defer3",
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "where",
                                            "value": {
                                                "delayMs": 900
                                            }
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "echo"
                                },
                                {
                                    "if": "enableDefer",
                                    "kind": "Defer",
                                    "label": "SandboxEchoDefer3$defer$SandboxEchoNestedDefer_PVNZy",
                                    "selections": [
                                        {
                                            "alias": "nestedImmediate",
                                            "args": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "where",
                                                    "value": {
                                                        "delayMs": 1
                                                    }
                                                }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "echo"
                                        },
                                        {
                                            "alias": "nestedDefer1",
                                            "args": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "where",
                                                    "value": {
                                                        "delayMs": 600
                                                    }
                                                }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "echo"
                                        },
                                        {
                                            "alias": "nestedDefer2",
                                            "args": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "where",
                                                    "value": {
                                                        "delayMs": 1600
                                                    }
                                                }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "echo"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "skipLongQuery",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "if": "enableDefer",
                                    "kind": "Defer",
                                    "label": "SandboxEchoPageQuery$defer$SandboxEchoVeryLongQuery_PVNZy",
                                    "selections": [
                                        {
                                            "alias": "wasItWorthTheWait",
                                            "args": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "where",
                                                    "value": {
                                                        "delayMs": 5000
                                                    }
                                                }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "echo"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1b22a744e4afb7fe2f6980e1e86b1c0648005cad43d16555b8e2f7003e74dec9",
            "metadata": {},
            "name": "SandboxEchoPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1c6e216d80813cf2$var$node.hash = "6c4aa6e81890a1b652ce97e525a243a3";
var $1c6e216d80813cf2$export$2e2bcd8739ae039 = $1c6e216d80813cf2$var$node;

});

parcelRegister("5wazW", function(module, exports) {

$parcel$export(module.exports, "sandboxEchoPageRelayResource", () => $82d02f97ad4a2283$export$1d94b7b81d2cfb0c);
/* eslint-disable jira/import-whitelist */ 
var $8Uumt = parcelRequire("8Uumt");

var $2M1hQ = parcelRequire("2M1hQ");

var $7k9VK = parcelRequire("7k9VK");

var $5yJb9 = parcelRequire("5yJb9");

var $kipqU = parcelRequire("kipqU");

var $ao2h1 = parcelRequire("ao2h1");
const $82d02f97ad4a2283$export$1d94b7b81d2cfb0c = (0, $2M1hQ.createResource)({
    type: `${(0, $ao2h1.RELAY_RESOURCE_TYPE)}_SANDBOX_RELAY_DEFER_ECHO`,
    getKey: ()=>'sandbox-relay-defer-echo',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        // Bail if the request opted out of SSR rendering
        if (false && 'ssr' in routerContext.query && routerContext.query.ssr === 'false') return null;
        const variables = {
            cloudId: tenantContext.cloudId,
            enableDefer: Boolean('defer' in routerContext.query ? routerContext.query.defer === 'true' : true),
            skipLongQuery: Boolean('skipLong' in routerContext.query ? routerContext.query.skipLong === 'true' : true)
        };
        const options = {
            fetchPolicy: 'store-and-network'
        };
        const queryReference = (0, $8Uumt.loadQuery)((0, $5yJb9.default)(), (0, $7k9VK.default), variables, options);
        if (false && queryReference.id != null) await (0, $kipqU.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});

});

parcelRegister("8Zcgn", function(module, exports) {

let $68ad887692b4acfe$var$load = (parcelRequire("28QjX"))(4);
module.exports = $68ad887692b4acfe$var$load("8Dzgf").then(()=>parcelRequire('7K1UW'));

});


parcelRegister("3o2V7", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $2b395e940acc9b2a$export$8f31e4c4a37b8e9c);

var $5uXOq = parcelRequire("5uXOq");
const $2b395e940acc9b2a$export$8f31e4c4a37b8e9c = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, "Loading the sandbox page...");
};

});


parcelRegister("aApqk", function(module, exports) {

$parcel$export(module.exports, "sandboxRelayJiraPageRouteEntry", () => $7d2751a4782f2f1e$export$c19004b7e7b87ab0);

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $e7ZQf = parcelRequire("e7ZQf");

var $fNyQe = parcelRequire("fNyQe");

var $6LsQE = parcelRequire("6LsQE");

var $4R6GH = parcelRequire("4R6GH");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");
const $7d2751a4782f2f1e$var$sandboxRelayJiraPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $fNyQe.sandboxJiraPageEntryPoint),
    // using PROJECTS as a placeholder
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $7d2751a4782f2f1e$export$c19004b7e7b87ab0 = (0, $7NszV.createEntry)((0, $e7ZQf.sandboxRelayJiraPageRoute), ()=>({
        group: 'sandbox',
        entryPoint: ()=>(0, $4R6GH.fg)('jfp-magma-support-defer') ? $7d2751a4782f2f1e$var$sandboxRelayJiraPageEntryPoint : (0, $6LsQE.notFoundPageEntrypoint),
        layout: (0, $2BrOV.globalLayout),
        resources: [],
        ufoName: 'sandbox-relay-jirasearch',
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-sandbox-entries/src/sandboxRelayJiraPageRouteEntry.tsx',
                whichExportToUse: 'sandboxRelayJiraPageRouteEntry'
            },
            // WARNING: setting this to `true` will cause us to build & deploy the route to bifrost+tesseract instances worldwide, which is quite expensive!
            // enabled: true,
            manifestName: 'jira-spa-sandboxdemo.json'
        }
    }));

});
parcelRegister("e7ZQf", function(module, exports) {

$parcel$export(module.exports, "sandboxRelayJiraPageRoute", () => $1aba9d02c092354f$export$71a894fccabfdcfa);
const $1aba9d02c092354f$export$71a894fccabfdcfa = {
    name: 'sandbox-relay-defer-jira',
    path: '/jira/software/sandbox/relay/jirasearch',
    exact: true
};

});

parcelRegister("fNyQe", function(module, exports) {

$parcel$export(module.exports, "sandboxJiraPageEntryPoint", () => $4ca571dfa319a590$export$d56ccd62431eaba5);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $gE4Gq = parcelRequire("gE4Gq");

const $4ca571dfa319a590$export$d56ccd62431eaba5 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("juM28")), {
        moduleId: "ea0eea54",
        moduleName: "SandboxJiraPage"
    }),
    getPreloadProps: ({ tenantContext: tenantContext, context: context })=>{
        return {
            queries: {
                pageQueryRef: {
                    parameters: (0, $gE4Gq.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        enableDefer: Boolean('defer' in context.query ? context.query.defer === 'true' : true)
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        };
    }
});

});
parcelRegister("gE4Gq", function(module, exports) {

$parcel$export(module.exports, "default", () => $441fd2aafa7117c0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<79cda9a8a207ac397a141bd7897c3537>>
 * @relayHash 3037c8cb08fdd5bd0f2bb8885e4a147b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0191f3cabe6c9edb534f4c87d64645dbe943dea580fe1d42d0e0f5e9710d4ff4
const $441fd2aafa7117c0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "enableDefer"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SandboxJiraPageQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "SandboxJiraCriticalData"
                            },
                            {
                                "kind": "Defer",
                                "selections": [
                                    {
                                        "args": v2 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "SandboxJiraUserPreferences"
                                    }
                                ]
                            },
                            {
                                "kind": "Defer",
                                "selections": [
                                    {
                                        "args": v2 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "SandboxJiraAiStuff"
                                    }
                                ]
                            },
                            {
                                "kind": "Defer",
                                "selections": [
                                    {
                                        "args": [
                                            v1 /*: any*/ ,
                                            {
                                                "kind": "Variable",
                                                "name": "enableDefer",
                                                "variableName": "enableDefer"
                                            }
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "SandboxJiraIssueSearch"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SandboxJiraPageQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "ScalarField",
                            "name": "childIssuesLimit"
                        },
                        {
                            "if": "enableDefer",
                            "kind": "Defer",
                            "label": "SandboxJiraPageQuery$defer$SandboxJiraUserPreferences_PVNZy",
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraUserPreferences",
                                    "kind": "LinkedField",
                                    "name": "userPreferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isIssueViewCrossFlowBannerDismissed"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isCustomNavBarThemeFlagDismissed"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "if": "enableDefer",
                            "kind": "Defer",
                            "label": "SandboxJiraPageQuery$defer$SandboxJiraAiStuff_PVNZy",
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "atlassianIntelligenceProductFeatureInput",
                                            "value": {
                                                "product": "JIRA_SOFTWARE"
                                            }
                                        },
                                        v1 /*: any*/ 
                                    ],
                                    "kind": "ScalarField",
                                    "name": "shouldShowAtlassianIntelligence"
                                },
                                {
                                    "args": v2 /*: any*/ ,
                                    "kind": "ScalarField",
                                    "name": "isRovoEnabled"
                                }
                            ]
                        },
                        {
                            "if": "enableDefer",
                            "kind": "Defer",
                            "label": "SandboxJiraPageQuery$defer$SandboxJiraIssueSearch_1jcU60",
                            "selections": [
                                {
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 10
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "issueSearchInput",
                                            "value": {
                                                "jql": "ORDER BY created DESC"
                                            }
                                        }
                                    ],
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issueSearch",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                },
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        {
                                                            "concreteType": "JiraSingleLineTextField",
                                                            "kind": "LinkedField",
                                                            "name": "summaryField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "text"
                                                                },
                                                                v3 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "idsOrAliases",
                                                                    "value": [
                                                                        "assignee",
                                                                        "reporter",
                                                                        "status"
                                                                    ]
                                                                }
                                                            ],
                                                            "kind": "LinkedField",
                                                            "name": "fieldsByIdOrAlias",
                                                            "plural": true,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v3 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "if": "enableDefer",
                                                                    "kind": "Defer",
                                                                    "label": "SandboxJiraIssueWithDeferCard$defer$SandboxJiraIssueFieldEditability",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "TypeDiscriminator",
                                                                            "abstractKey": "__isJiraIssueField"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isEditableInIssueView"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "user",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v4 /*: any*/ ,
                                                                                v3 /*: any*/ ,
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraStatus",
                                                                            "kind": "LinkedField",
                                                                            "name": "status",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v3 /*: any*/ ,
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraStatusField"
                                                                }
                                                            ],
                                                            "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"assignee\",\"reporter\",\"status\"])"
                                                        },
                                                        v3 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "startCursor"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0191f3cabe6c9edb534f4c87d64645dbe943dea580fe1d42d0e0f5e9710d4ff4",
            "metadata": {},
            "name": "SandboxJiraPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$441fd2aafa7117c0$var$node.hash = "1a8ba1e200e80a9f80ac57367382ae4b";
var $441fd2aafa7117c0$export$2e2bcd8739ae039 = $441fd2aafa7117c0$var$node;

});

parcelRegister("juM28", function(module, exports) {

let $e316141e7d14ac53$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e316141e7d14ac53$var$load("5FdsD").then(()=>parcelRequire('fVUS8'));

});



parcelRegister("6mo9H", function(module, exports) {

$parcel$export(module.exports, "jsmBoardRouteEntry", () => $bbc84ec66ce4b2fd$export$44cb11fe4ca053f8);

var $ffza4 = parcelRequire("ffza4");

var $6hJYB = parcelRequire("6hJYB");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $f5kpo = parcelRequire("f5kpo");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $f7Y15 = parcelRequire("f7Y15");

var $gNStA = parcelRequire("gNStA");

var $kk6FJ = parcelRequire("kk6FJ");

var $6Z2mh = parcelRequire("6Z2mh");

var $hWAe2 = parcelRequire("hWAe2");

var $lfnsv = parcelRequire("lfnsv");

var $lJ1FP = parcelRequire("lJ1FP");

var $4R6GH = parcelRequire("4R6GH");

var $dCThw = parcelRequire("dCThw");
const $bbc84ec66ce4b2fd$export$44cb11fe4ca053f8 = (0, $7NszV.createEntry)((0, $kk6FJ.jsmBoardRoute), ()=>({
        group: 'servicedesk',
        component: (0, $dCThw.ServicedeskBoard),
        layout: (0, $6Z2mh.serviceProjectLayout),
        skeleton: (0, $hWAe2.ClassicBoardSkeleton),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $dCThw.LazyServicedeskBoard),
            (0, $dCThw.LazyServicedeskLegacyBoardSettings),
            (0, $dCThw.LazyBoardSettings)
        ],
        perfMetricKey: 'servicedesk-boards-load',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $6hJYB.AsyncViewsNav)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>!false, (0, $f7Y15.uifBoardResource)),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_configuration_migration'), (0, $lJ1FP.getEditModelResource)()),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_configuration_migration'), (0, $lfnsv.getBoardDetailsResource)()),
            (0, $dxCvy.projectContextResource)
        ]
    }));

});
parcelRegister("6hJYB", function(module, exports) {

$parcel$export(module.exports, "AsyncViewsNav", () => $7a169ab056601f38$export$b43adc74b6a33bde);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $7a169ab056601f38$var$LazyViewsNav = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("hmeBm")).then(({ ViewsBaseNav: ViewsBaseNav })=>ViewsBaseNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/views/src/ui/index.tsx"
});
const $7a169ab056601f38$export$b43adc74b6a33bde = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-jsm-views-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7a169ab056601f38$var$LazyViewsNav, null));

});
parcelRegister("hmeBm", function(module, exports) {

let $ca2fd14e0c4b2e8e$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ca2fd14e0c4b2e8e$var$load("ffQaD"),
    $ca2fd14e0c4b2e8e$var$load("kvRbA"),
    $ca2fd14e0c4b2e8e$var$load("cygJy")
]).then(()=>parcelRequire('l1Z7j'));

});


parcelRegister("hWAe2", function(module, exports) {

$parcel$export(module.exports, "ClassicBoardSkeleton", () => $845fd4f51bb92262$export$631611c5fdf027d5);
/* ClassicBoardSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $i1CIU = parcelRequire("i1CIU");
const $845fd4f51bb92262$var$customCssStyles = null;
const $845fd4f51bb92262$export$631611c5fdf027d5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($i1CIU))),
        className: (0, $bwpsq.default)([
            "_2zz1idpf"
        ])
    });

});
parcelRegister("i1CIU", function(module, exports) {
module.exports = new URL("classic-board-app-skeleton.tpl.bf1c26f5.svg", import.meta.url).toString();

});


parcelRegister("dCThw", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskBoard", () => $2b6a3552fb449509$export$bb5ed4e7838cf30c);
$parcel$export(module.exports, "LazyBoardSettings", () => $2b6a3552fb449509$export$45bb2963a11a5163);
$parcel$export(module.exports, "LazyServicedeskLegacyBoardSettings", () => $2b6a3552fb449509$export$6828c4b2d0ff0d5d);
$parcel$export(module.exports, "ServicedeskBoard", () => $2b6a3552fb449509$export$f058c0d1561d67f3);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $7tQej = parcelRequire("7tQej");

var $4R6GH = parcelRequire("4R6GH");

const $2b6a3552fb449509$export$bb5ed4e7838cf30c = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("fWFUP"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/board/src/index.tsx"
});

const $2b6a3552fb449509$export$45bb2963a11a5163 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("kTRMin")).then((module)=>module.ServicedeskBoardSettingsAppLayout)), {
    moduleId: "./src/packages/spa-apps/servicedesk/board-settings/src/ui/index.tsx"
});

const $2b6a3552fb449509$export$6828c4b2d0ff0d5d = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("1DU5s"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/legacy-board-settings/src/index.tsx"
});
const $2b6a3552fb449509$export$f058c0d1561d67f3 = (props)=>{
    const { route: route, query: query } = props;
    if (route.name !== 'servicedesk-boards') return null;
    const allowedConfigurations = [
        'columns',
        'filter',
        'quickFilters',
        'swimlanes',
        'cardColors',
        'cardLayout',
        'dateFields'
    ];
    if (query.config && !allowedConfigurations.includes(query.config) && !(0, $4R6GH.fg)('jsm_views_configuration_migration')) {
        const { config: config, ...restQuery } = query;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: {
                pathname: props.location.pathname,
                hash: '',
                search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
                    ...restQuery,
                    config: 'columns'
                })
            }
        });
    }
    return query.config ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $4R6GH.fg)('jsm_views_configuration_migration') ? $2b6a3552fb449509$export$45bb2963a11a5163 : $2b6a3552fb449509$export$6828c4b2d0ff0d5d,
        pageId: (0, $4R6GH.fg)('jsm_views_configuration_migration') ? 'spa-apps/servicedesk/boards/board-settings' : 'spa-apps/servicedesk/boards/legacy-board-settings',
        shouldShowSpinner: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2b6a3552fb449509$export$bb5ed4e7838cf30c,
        pageId: "spa-apps/servicedesk/boards/board",
        shouldShowSpinner: true
    });
};

});
parcelRegister("fWFUP", function(module, exports) {

let $b9bcc95fa24a46b2$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $b9bcc95fa24a46b2$var$load("kNFvF"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("4lPfp"), 4)),
    $b9bcc95fa24a46b2$var$load("ffQaD"),
    $b9bcc95fa24a46b2$var$load("kvRbA"),
    $b9bcc95fa24a46b2$var$load("76n7a"),
    $b9bcc95fa24a46b2$var$load("l253H"),
    $b9bcc95fa24a46b2$var$load("dH1Ru")
]).then(()=>parcelRequire('fnC5S'));

});

parcelRegister("kTRMin", function(module, exports) {

let $f372a8e1731a1a89$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f372a8e1731a1a89$var$load("kNFvF"),
    $f372a8e1731a1a89$var$load("ffQaD"),
    $f372a8e1731a1a89$var$load("kvRbA"),
    $f372a8e1731a1a89$var$load("45MRb")
]).then(()=>parcelRequire('as6Z6'));

});

parcelRegister("1DU5s", function(module, exports) {

let $1324f0b2e2f8d66a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1324f0b2e2f8d66a$var$load("2CgvA").then(()=>parcelRequire('lWiJj'));

});



parcelRegister("cJoBA", function(module, exports) {

$parcel$export(module.exports, "servicedeskCalendarRouteEntry", () => $3ce1b2936d5b40e0$export$301bfcedbd0983b7);

var $4R6GH = parcelRequire("4R6GH");

var $6hJYB = parcelRequire("6hJYB");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $jYeNO = parcelRequire("jYeNO");

var $f7Y15 = parcelRequire("f7Y15");

var $gNStA = parcelRequire("gNStA");

var $4pwUQ = parcelRequire("4pwUQ");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $6Y2I3 = parcelRequire("6Y2I3");

var $f1mpQ = parcelRequire("f1mpQ");
const $3ce1b2936d5b40e0$export$301bfcedbd0983b7 = (0, $7NszV.createEntry)((0, $4pwUQ.servicedeskCalendarRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'jsm-calendar',
        component: ()=>null,
        skeleton: (0, $6Y2I3.ClassicCalendarSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $6hJYB.AsyncViewsNav)
        },
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $jYeNO.getCalendarFilterFieldsResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsd_shield_weekly_view_fast_follow') && !false, (0, $f7Y15.uifBoardResource))
        ],
        entryPoint: ()=>(0, $f1mpQ.calendarPageEntryPoint),
        meta: {
            reporting: {
                id: 'calendar',
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).CALENDAR),
                teamName: 'jsd-shield'
            }
        }
    }));

});
parcelRegister("4pwUQ", function(module, exports) {

$parcel$export(module.exports, "servicedeskCalendarRoute", () => $72d318e197b1c24c$export$28a386a00670c893);
const $72d318e197b1c24c$export$28a386a00670c893 = {
    name: 'servicedesk-calendar',
    path: '/jira/servicedesk/projects/:projectKey/boards/:boardId/calendar',
    exact: true
};

});

parcelRegister("e9YVH", function(module, exports) {

$parcel$export(module.exports, "APP_NAMES", () => $26ff993b947c317f$export$4116f3d0d9d6bed7);
$parcel$export(module.exports, "toPackageName", () => $26ff993b947c317f$export$f31a652635bd75fe);
const $26ff993b947c317f$export$4116f3d0d9d6bed7 = {
    ACCOUNTS: 'servicedesk.accounts',
    APP_DISCOVERY: 'servicedesk.app-discovery',
    ATLASSIAN_ANALYTICS: 'servicedesk.atlassian-analytics',
    AUTOMATION_EDIT_RULE: 'servicedesk.automation.edit-rule',
    AUTOMATION_SUMMARY: 'servicedesk.automation.summary',
    AUTOMATION_VIEW_LOG: 'servicedesk.automation.view-log',
    BOARD: 'servicedesk.board',
    BOARD_SETTINGS: 'servicedesk.board-settings',
    CALENDAR: 'servicedesk.calendar',
    PROJECT_SUMMARY: 'servicedesk.project-summary',
    CHANGE_CALENDAR: 'servicedesk.change-calendar',
    CHANGE_MANAGEMENT_SETTINGS: 'servicedesk.change-management.settings',
    CREATE_PROJECT: 'servicedesk.create-project',
    CSAT_CONFIG: 'servicedesk.csat-configuration',
    CUSTOMER_PERMISSIONS: 'servicedesk.customer-permissions',
    CONTACTS: 'servicedesk.contacts',
    CUSTOMERS: 'servicedesk.customers',
    CUSTOMER_DETAILS: 'servicedesk.customer-details',
    CUSTOMER_SERVICE_ESCALATIONS: 'servicedesk.customer-service-escalations',
    CUSTOMER_SERVICE_PRODUCTS: 'servicedesk.customer-service-products',
    CUSTOMER_SERVICE_HELP_CENTER: 'servicedesk.customer-service-help-center',
    INVITE_TEAM_DIALOG: 'servicedesk.invite-team-dialog',
    ISSUE_SCHEDULE_CHANGE: 'servicedesk.issue.schedule-change',
    ITSM_FEATURES_SETTINGS: 'servicedesk.itsm-features.settings',
    ITSM_OVERVIEW_SETTINGS: 'servicedesk.itsm-overview.settings',
    ITSM_SAMPLE_SPACE: 'servicedesk.itsm-sample-space',
    JOURNEYS: 'servicedesk.journeys',
    JOURNEY_CONFIG: 'servicedesk.journey-config',
    GETTING_STARTED_PAGE: 'servicedesk.getting-started-page',
    KB_BROWSE_ARTICLES: 'servicedesk.knowledge-base.browse-articles',
    KB_CATEGORY: 'servicedesk.knowledge-base.category',
    KB_DRAFTS: 'servicedesk.knowledge-base.drafts',
    KB_BROWSE_CATEGORIES: 'servicedesk.knowledge-base.browse-categories',
    KB_SUGGESTED_ARTICLES: 'servicedesk.knowledge-base.suggested-articles',
    KB_EMBED_EDITOR: 'servicedesk.knowledge-article.embed-editor',
    KB_LANDING: 'servicedesk.knowledge-base.landing',
    KB_REPORTS_REQUESTS: 'servicedesk.kb-requests.reports',
    KB_SEARCH: 'servicedesk.knowledge-base.search',
    KB_SETTINGS: 'servicedesk.knowledge.settings',
    KB_SETUP: 'servicedesk.knowledge-base.setup',
    KB_VIEW_ARTICLE: 'servicedesk.knowledge-base.view-article',
    ORGANIZATION: 'servicedesk.organization',
    ORGANIZATIONS: 'servicedesk.organizations',
    ORGANIZATION_DETAILS: 'servicedesk.organization-details',
    PORTAL_SETTINGS: 'servicedesk.portal-settings',
    QUEUES_AGENT_VIEW: 'servicedesk.queues.agent-view',
    QUEUES_EDIT_VIEW: 'servicedesk.queues.edit-view',
    QUEUES_MAIN: 'servicedesk.queues.main',
    REPORTS_CUSTOM: 'servicedesk.reports.custom',
    REPORTS_CUSTOM_CREATE: 'servicedesk.reports.custom-create',
    REPORTS_CUSTOM_EDIT: 'servicedesk.reports.custom-edit',
    REPORTS_HOME_PAGE: 'servicedesk.reports.home-page',
    REPORTS_SATISFACTION: 'servicedesk.reports.satisfaction',
    REPORTS_WORKLOAD: 'servicedesk.reports.workload',
    REQUEST_TYPES_CONFIG: 'servicedesk.request-types-config',
    REQUEST_TYPE_FIELDS: 'servicedesk.request-type-fields',
    SLA_SETTINGS: 'servicedesk.sla-settings',
    VIRTUAL_AGENT_BROWSE_CONVERSATIONS: 'servicedesk.virtual-agent.browse-conversations',
    VIRTUAL_AGENT_BROWSE_INTENTS: 'servicedesk.virtual-agent.browse-intents',
    VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS: 'servicedesk.virtual-agent.browse-standard-flows',
    VIRTUAL_AGENT_LANDING: 'servicedesk.virtual-agent.landing',
    VIRTUAL_AGENT_SETTINGS: 'servicedesk.virtual-agent.settings',
    VIRTUAL_AGENT_VIEW_INTENT: 'servicedesk.virtual-agent.view-intent',
    VIRTUAL_AGENT_VIEW_STANDARD_FLOW: 'servicedesk.virtual-agent.view-standard-flow',
    VIRTUAL_AGENT_AI_ANSWERS: 'servicedesk.virtual-agent.ai-answers',
    VIRTUAL_AGENT_PERFORMANCE: 'servicedesk.virtual-agent.performance',
    PRACTICE_CONFIG_MODULE: 'servicedesk.practice-config-module',
    CREATE_SERVICE_MODAL: 'servicedesk.create-service-modal',
    UPDATE_SERVICE_MODAL: 'servicedesk.update-service-modal',
    LANGUAGE_SETTINGS: 'servicedesk.language-settings',
    LINKED_ALERTS_MODAL: 'servicedesk.link-alerts-modal',
    INSIGHT_ASSETS_REPORTS: 'servicedesk.insight-cmdb-assets_reports',
    INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT: 'servicedesk.insight-cmdb-assets_reports_default_redirect',
    INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE: 'servicedesk.insight-cmdb-assets_reports_unsubscribe',
    INSIGHT_OBJECT_VIEW: 'servicedesk.insight-cmdb-object',
    INSIGHT_OBJECT_SCHEMA: 'servicedesk.insight-cmdb-object-schema',
    INSIGHT_OBJECT_SCHEMA_CONFIGURATION: 'servicedesk.insight-cmdb-object-schema-configuration',
    INSIGHT_OBJECT_TYPE_CONFIGURATION: 'servicedesk.insight-object-type-configuration',
    INSIGHT_GLOBAL_CONFIGURATION: 'servicedesk.insight-cmdb-global-configuration',
    INSIGHT_LANDING_PAGE: 'servicedesk.insight-cmdb-landing-page',
    CUSTOMER_NOTIFICATIONS_MAIN_VIEW: 'servicedesk.customer-notifications-settings.main-view',
    CUSTOMER_NOTIFICATIONS_INVITE_CUSTOMER_VIEW: 'servicedesk.customer-notifications-settings.invite-customer-view',
    CUSTOMER_NOTIFICATIONS_RULE_VIEW: 'servicedesk.customer-notifications-settings.rule-view',
    CUSTOMER_NOTIFICATIONS_TEMPLATE_VIEW: 'servicedesk.customer-notifications-settings.template-view',
    CUSTOMER_NOTIFICATIONS_UNKNOWN_VIEW: 'servicedesk.customer-notifications-settings.unknown-view',
    SERVICES_WITHOUT_PROJECT_VIEW: 'servicedesk.services-without-project-view',
    SERVICE_DETAIL_WITHOUT_PROJECT_VIEW: 'servicedesk.service-detail-without-project-view',
    WIDGET_SETTINGS: 'servicedesk.widget-settings',
    ASSETS_APP_SEARCH_RESULTS: 'assets-app.search-results-page',
    ASSETS_APP_DATA_MANAGER_GETTING_STARTED_PAGE: 'assets-app.data-manager.getting-started-page',
    ASSETS_APP_DATA_MANAGER_OBJECT_CLASSES_PAGE: 'assets-app.data-manager.object-classes-page'
};
// To match the FE error analytics pipeline convention
const $26ff993b947c317f$var$ANALYTICS_PACKAGE_NAMES = {
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.ACCOUNTS]: 'servicedeskAccounts',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.APP_DISCOVERY]: 'serviceDeskAppDiscovery',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.ATLASSIAN_ANALYTICS]: 'serviceDeskAtlassianAnalytics',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.AUTOMATION_EDIT_RULE]: 'servicedeskAutomationEditView',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.AUTOMATION_SUMMARY]: 'servicedeskAutomationEditRule',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.AUTOMATION_VIEW_LOG]: 'servicedeskAutomationViewLog',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.BOARD]: 'servicedeskBoard',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.BOARD_SETTINGS]: 'servicedeskBoardSettings',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CALENDAR]: 'servicedeskCalendar',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.PROJECT_SUMMARY]: 'servicedeskProjectSummary',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CHANGE_CALENDAR]: 'servicedeskChangeCalendar',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CHANGE_MANAGEMENT_SETTINGS]: 'servicedeskChangeManagementSettings',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CREATE_PROJECT]: 'servicedeskCreateProject',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CSAT_CONFIG]: 'servicedeskCsatConfig',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CONTACTS]: 'servicedeskContacts',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_PERMISSIONS]: 'servicedeskCustomerPermissions',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMERS]: 'servicedeskCustomers',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_DETAILS]: 'servicedeskCustomerDetails',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_SERVICE_ESCALATIONS]: 'servicedeskCustomerServiceEscalations',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_SERVICE_PRODUCTS]: 'servicedeskCustomerServiceProducts',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_SERVICE_HELP_CENTER]: 'servicedeskCustomerServiceHelpCenter',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.INVITE_TEAM_DIALOG]: 'servicedeskInviteTeamDialog',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.ISSUE_SCHEDULE_CHANGE]: 'servicedeskIssueScheduleChange',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.ITSM_FEATURES_SETTINGS]: 'servicedeskItsmFeaturesSettings',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.ITSM_OVERVIEW_SETTINGS]: 'servicedeskItsmOverviewSettings',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.ITSM_SAMPLE_SPACE]: 'servicedeskItsmSampleSpace',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.JOURNEYS]: 'servicedeskJourneys',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.JOURNEY_CONFIG]: 'servicedeskJourneyConfig',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_BROWSE_ARTICLES]: 'servicedeskKnowledgeBaseBrowseArticles',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_BROWSE_CATEGORIES]: 'servicedeskKnowledgeBaseBrowseCategories',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_CATEGORY]: 'servicedeskKnowledgeBaseCategory',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_DRAFTS]: 'servicedeskKnowledgeBaseDrafts',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_SUGGESTED_ARTICLES]: 'servicedeskKnowledgeBaseSuggestedArticles',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_EMBED_EDITOR]: 'servicedeskKnowledgeBaseEmbedEditor',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_LANDING]: 'servicedeskKnowledgeBaseLanding',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_REPORTS_REQUESTS]: 'servicedeskKbRequestsReports',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_SEARCH]: 'servicedeskKnowledgeBaseSearch',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_SETTINGS]: 'servicedeskKnowledgeSettings',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_SETUP]: 'servicedeskKnowledgeBaseSetup',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_VIEW_ARTICLE]: 'servicedeskKnowledgeBaseViewArticle',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.LANGUAGE_SETTINGS]: 'servicedeskLanguageSettingsTranslations',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.ORGANIZATION]: 'servicedeskOrganization',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.ORGANIZATIONS]: 'servicedeskOrganizations',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.ORGANIZATION_DETAILS]: 'servicedeskOrganizationDetails',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.PORTAL_SETTINGS]: 'servicedeskPortalSettings',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.QUEUES_AGENT_VIEW]: 'servicedeskQueuesAgentView',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.QUEUES_EDIT_VIEW]: 'servicedeskQueuesEditView',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.QUEUES_MAIN]: 'servicedeskQueuesMain',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_CUSTOM]: 'servicedeskReportsCustom',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_CUSTOM_CREATE]: 'servicedeskReportsCustomCreate',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_CUSTOM_EDIT]: 'servicedeskReportsCustomEdit',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_HOME_PAGE]: 'servicedeskReportsHomePage',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_SATISFACTION]: 'servicedeskReportsSatisfaction',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_WORKLOAD]: 'servicedeskReportsWorkload',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.REQUEST_TYPES_CONFIG]: 'servicedeskRequestTypesConfig',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.REQUEST_TYPE_FIELDS]: 'servicedeskRequestTypeFields',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.SLA_SETTINGS]: 'servicedeskSlaSettings',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_BROWSE_CONVERSATIONS]: 'servicedeskVirtualAgentBrowseConversations',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_BROWSE_INTENTS]: 'servicedeskVirtualAgentBrowseIntents',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS]: 'servicedeskVirtualAgentBrowseStandardFlows',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_LANDING]: 'servicedeskVirtualAgentLanding',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_SETTINGS]: 'servicedeskVirtualAgentSettings',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_VIEW_INTENT]: 'servicedeskVirtualAgentViewIntent',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_VIEW_STANDARD_FLOW]: 'servicedeskVirtualAgentViewStandardFlow',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_AI_ANSWERS]: 'servicedeskVirtualAgentAiAnswers',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_PERFORMANCE]: 'servicedeskVirtualAgentPerformance',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.PRACTICE_CONFIG_MODULE]: 'servicedeskPracticeConfigModule',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CREATE_SERVICE_MODAL]: 'servicedeskCreateServiceModal',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.UPDATE_SERVICE_MODAL]: 'servicedeskUpdateServiceModal',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.LINKED_ALERTS_MODAL]: 'servicedeskLinkAlertsModal',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_REPORTS]: 'servicedeskAssetsReports',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT]: 'servicedeskAssetsReportsDefaultRedirect',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE]: 'servicedeskAssetsReportsUnsubscribe',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_VIEW]: 'servicedeskObjectView',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_SCHEMA]: 'servicedeskObjectSchema',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_SCHEMA_CONFIGURATION]: 'servicedeskObjectSchemaConfiguration',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_TYPE_CONFIGURATION]: 'servicedeskObjectTypeConfiguration',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_GLOBAL_CONFIGURATION]: 'servicedeskInsightGlobalConfiguration',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_LANDING_PAGE]: 'servicedeskInsightLandingPage',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_MAIN_VIEW]: 'servicedeskCustomerNotificationsMainView',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_INVITE_CUSTOMER_VIEW]: 'servicedeskCustomerNotificationsInviteCustomerView',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_RULE_VIEW]: 'servicedeskCustomerNotificationsRuleView',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_TEMPLATE_VIEW]: 'servicedeskCustomerNotificationsTemplateView',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_UNKNOWN_VIEW]: 'servicedeskCustomerNotificationsUnknownView',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.GETTING_STARTED_PAGE]: 'servicedeskGettingStartedPage',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.SERVICES_WITHOUT_PROJECT_VIEW]: 'servicedeskServicesWithoutProjectView',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.SERVICE_DETAIL_WITHOUT_PROJECT_VIEW]: 'servicedeskServiceDetailWithoutProjectView',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.WIDGET_SETTINGS]: 'servicedeskWidgetSettings',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.ASSETS_APP_SEARCH_RESULTS]: 'assetsAppSearchResultsPage',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.ASSETS_APP_DATA_MANAGER_GETTING_STARTED_PAGE]: 'assetsAppDataManagerGettingStartedPage',
    [$26ff993b947c317f$export$4116f3d0d9d6bed7.ASSETS_APP_DATA_MANAGER_OBJECT_CLASSES_PAGE]: 'assetsAppDataManagerObjectClassesPage'
};
const $26ff993b947c317f$export$f31a652635bd75fe = (appName)=>$26ff993b947c317f$var$ANALYTICS_PACKAGE_NAMES[appName];

});

parcelRegister("6Y2I3", function(module, exports) {

$parcel$export(module.exports, "ClassicCalendarSkeleton", () => $69a8eba95a06a473$export$49d3670908a8d8fe);

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $rQ9b9 = parcelRequire("rQ9b9");
const $69a8eba95a06a473$export$49d3670908a8d8fe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($rQ9b9)))
    });

});
parcelRegister("rQ9b9", function(module, exports) {
module.exports = new URL("classic-calendar-skeleton.tpl.3dcfde16.svg", import.meta.url).toString();

});


parcelRegister("f1mpQ", function(module, exports) {

$parcel$export(module.exports, "calendarPageEntryPoint", () => $c3ff53bf28ecf1c9$export$eda0c2fb67f7d7e7);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $faaUu = parcelRequire("faaUu");
const $c3ff53bf28ecf1c9$export$eda0c2fb67f7d7e7 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $faaUu.calendarEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("faaUu", function(module, exports) {

$parcel$export(module.exports, "calendarEntryPoint", () => $d491739a1b7483c1$export$19cf4b398f638dc6);

var $4R6GH = parcelRequire("4R6GH");

var $7JhZX = parcelRequire("7JhZX");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");
// This is the key used to store the calendar filters in the local storage
const $d491739a1b7483c1$var$ISSUE_SEARCH_INPUT_STORAGE_KEY = 'calendar-issue-search-input';
// This is the key used to store the calendar view settings in the local storage
const $d491739a1b7483c1$var$VIEW_SETTINGS_STORAGE_KEY = 'calendar-view-settings';
/**
 * Default Day Starts At Time in Calendar View Settings
 */ const $d491739a1b7483c1$var$DEFAULT_DAY_STARTS_AT = '09:00 AM';
function $d491739a1b7483c1$var$toBoardAri({ siteId: siteId, boardId: boardId }) {
    return `ari:cloud:jira-software:${siteId}:board/${boardId}`;
}
function $d491739a1b7483c1$var$toMidnightUTCString(date) {
    const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return new Date(utcMilliseconds).toISOString();
}
function $d491739a1b7483c1$var$toDate(date) {
    if (!date) return new Date();
    try {
        const _date = new Date(date);
        return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
    } catch (e) {
        return new Date();
    }
}
function $d491739a1b7483c1$var$createScope({ context: context, tenantContext: tenantContext }, viewId) {
    const { cloudId: cloudId } = tenantContext;
    return {
        type: 'board',
        boardId: $d491739a1b7483c1$var$toBoardAri({
            siteId: cloudId,
            boardId: String(context.match.params.boardId)
        }),
        projectKeys: (0, $4R6GH.fg)('fix_jsm_calendar_scope_issue') ? [] : [
            String(context.match.params.projectKey)
        ],
        viewId: viewId
    };
}
function $d491739a1b7483c1$var$buildScopeInput({ tenantContext: tenantContext }, scope) {
    const { cloudId: cloudId } = tenantContext;
    return {
        ids: [
            scope.boardId
        ],
        projectKeys: {
            cloudId: cloudId,
            keys: scope.projectKeys
        }
    };
}
function $d491739a1b7483c1$var$toViewMode(mode) {
    switch(mode){
        case 'week':
            return 'WEEK';
        case 'day':
            return 'DAY';
        default:
            return 'MONTH';
    }
}
function $d491739a1b7483c1$var$toWeekStart(weekStart) {
    switch(weekStart){
        case 'monday':
            return 'MONDAY';
        case 'saturday':
            return 'SATURDAY';
        default:
            return 'SUNDAY';
    }
}
function $d491739a1b7483c1$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField, viewId: viewId }) {
    return {
        date: $d491739a1b7483c1$var$toMidnightUTCString(selectedDate),
        mode: $d491739a1b7483c1$var$toViewMode(viewRange),
        weekStart: $d491739a1b7483c1$var$toWeekStart(weekStartsOn),
        ...(0, $4R6GH.fg)('jira_calendar_load_more_pagination') ? {
            startDateField: startDateField,
            endDateField: endDateField
        } : {},
        viewId: viewId
    };
}
function $d491739a1b7483c1$var$buildStorageKey({ cloudId: cloudId, activationId: activationId, boardId: boardId, featureKey: featureKey }) {
    const viewId = $d491739a1b7483c1$var$buildViewId({
        cloudId: cloudId,
        activationId: activationId,
        boardId: boardId
    });
    const LOCALSTORAGE_KEY_PREFIX = 'persist:calendar';
    return `${LOCALSTORAGE_KEY_PREFIX}/view/${viewId}/${featureKey}`;
}
function $d491739a1b7483c1$var$getStorageValue(storageKey) {
    // window check is needed because this code is also executed on the SSR
    if (typeof window !== 'undefined') return localStorage?.getItem(storageKey) || '';
    return '';
}
function $d491739a1b7483c1$var$buildIssuesSearchInput(storageKey) {
    return {
        additionalFilterQuery: $d491739a1b7483c1$var$getStorageValue(storageKey) || ''
    };
}
function $d491739a1b7483c1$var$buildUnscheduledIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $d491739a1b7483c1$var$buildVersionsSearchInput() {
    return {
        versionStatuses: [
            'RELEASED',
            'UNRELEASED'
        ]
    };
}
function $d491739a1b7483c1$var$buildSprintsSearchInput() {
    return {
        sprintStates: [
            'ACTIVE',
            'FUTURE',
            'CLOSED'
        ]
    };
}
function $d491739a1b7483c1$var$buildViewId({ cloudId: cloudId, activationId: activationId, boardId: boardId }) {
    // https://developer.atlassian.com/platform/atlassian-resource-identifier/resource-owners/registry/#ati%3Acloud%3Ajira%3Aview
    return `ari:cloud:jira:${cloudId}:view/activation/${activationId}/board/${boardId}`;
}

const $d491739a1b7483c1$export$19cf4b398f638dc6 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("7Tm3Z")), {
        moduleId: "7a55ad65"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        const { cloudId: cloudId, activationId: activationId } = tenantContext;
        const { date: date } = context.query;
        const selectedDate = $d491739a1b7483c1$var$toDate(date);
        const { boardId: boardId, projectKey: projectKey } = context.match.params;
        if (!boardId || !projectKey) throw new Error('boardId and projectKey must be provided.');
        const viewId = $d491739a1b7483c1$var$buildViewId({
            cloudId: cloudId,
            activationId: activationId,
            boardId: boardId
        });
        const scope = $d491739a1b7483c1$var$createScope(entryPointRouteParams, viewId || '');
        const storageKeyForIssueSearchInput = $d491739a1b7483c1$var$buildStorageKey({
            cloudId: cloudId,
            activationId: activationId,
            boardId: boardId,
            featureKey: $d491739a1b7483c1$var$ISSUE_SEARCH_INPUT_STORAGE_KEY
        });
        const storageKeyForViewSettings = $d491739a1b7483c1$var$buildStorageKey({
            cloudId: cloudId,
            activationId: activationId,
            boardId: boardId,
            featureKey: $d491739a1b7483c1$var$VIEW_SETTINGS_STORAGE_KEY
        });
        const defaultViewRange = 'month';
        const storedConfig = $d491739a1b7483c1$var$getStorageValue(storageKeyForViewSettings);
        const viewSettingsConfig = storedConfig ? JSON.parse(storedConfig) : {
            viewRange: defaultViewRange,
            weekStartsOn: null,
            dayStartsAt: $d491739a1b7483c1$var$DEFAULT_DAY_STARTS_AT,
            showWeekends: false,
            showIssueKey: true,
            showIn24HourClock: false,
            colorBy: 'status'
        };
        const viewRange = (0, $4R6GH.fg)('jsd_shield_jsm_calendar_weekly_view') ? viewSettingsConfig.viewRange ?? 'month' : 'month';
        const weekStartsOn = viewSettingsConfig.weekStartsOn ?? 'sunday';
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const colorBy = viewSettingsConfig.colorBy ?? 'status';
        const startDateField = 'startdate';
        const endDateField = 'duedate';
        const issueEventFields = {
            startDateField: startDateField,
            endDateField: endDateField
        };
        const issuesSearchInput = $d491739a1b7483c1$var$buildIssuesSearchInput(storageKeyForIssueSearchInput);
        return {
            queries: {
                calendarData: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $7JhZX.default,
                    variables: {
                        cloudId: cloudId,
                        scopeInput: $d491739a1b7483c1$var$buildScopeInput(entryPointRouteParams, scope),
                        configurationInput: $d491739a1b7483c1$var$buildConfigurationInput({
                            selectedDate: selectedDate,
                            viewRange: viewRange,
                            weekStartsOn: weekStartsOn,
                            startDateField: startDateField,
                            endDateField: endDateField,
                            viewId: viewId
                        }),
                        issuesPageSize: (0, $4R6GH.fg)('jira_calendar_lazy_load') ? 200 : 50,
                        issuesSearchInput: issuesSearchInput,
                        unscheduledIssuesSearchInput: $d491739a1b7483c1$var$buildUnscheduledIssuesSearchInput(),
                        versionsSearchInput: $d491739a1b7483c1$var$buildVersionsSearchInput(),
                        sprintsSearchInput: $d491739a1b7483c1$var$buildSprintsSearchInput(),
                        skipSprintSearch: false,
                        viewId: viewId,
                        ...(0, $4R6GH.fg)('jsd_shield_jsm_calendar_weekly_view') && {
                            skipFieldConfig: false
                        },
                        schedulePermissionsEnabled: (0, $4R6GH.fg)('calendar_schedule_issue_permissions_check'),
                        pageLoadMoreEnabled: (0, $4R6GH.fg)('jira_calendar_load_more_pagination'),
                        skipVersionsV1Search: (0, $4R6GH.fg)('plan-calendar-versions-v2-adoption'),
                        skipVersionsV2Search: !(0, $4R6GH.fg)('plan-calendar-versions-v2-adoption'),
                        includeRecurrenceIndicator: false,
                        pageLoadMoreEnabledViewSettings: (0, $4R6GH.fg)('jira_calendar_load_more_pagination_view_settings')
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                scope: scope,
                selectedDate: selectedDate,
                viewRange: viewRange,
                weekStartsOn: weekStartsOn,
                dayStartsAt: viewSettingsConfig.dayStartsAt,
                issueEventFields: issueEventFields,
                projectKey: projectKey,
                storageKeyForViewSettings: storageKeyForViewSettings,
                storageKeyForIssueSearchInput: storageKeyForIssueSearchInput,
                showWeekends: viewSettingsConfig.showWeekends,
                showIssueKey: viewSettingsConfig.showIssueKey,
                showIn24HourClock: viewSettingsConfig.showIn24HourClock,
                colorBy: colorBy
            }
        };
    }
});

});
parcelRegister("7Tm3Z", function(module, exports) {

let $5beec8cde0000d46$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $5beec8cde0000d46$var$load("ffQaD"),
    $5beec8cde0000d46$var$load("kvRbA"),
    $5beec8cde0000d46$var$load("76n7a"),
    $5beec8cde0000d46$var$load("l253H"),
    $5beec8cde0000d46$var$load("l4zsJ")
]).then(()=>parcelRequire('2hdB5'));

});




parcelRegister("SBgrM", function(module, exports) {

$parcel$export(module.exports, "servicedeskChangeCalendarRouteEntry", () => $76cc3b1301a661ae$export$de5b915e23c7ce7d);

var $ffza4 = parcelRequire("ffza4");

var $1cxvE = parcelRequire("1cxvE");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $2pT4g = parcelRequire("2pT4g");

var $fpjJX = parcelRequire("fpjJX");

var $J5M3r = parcelRequire("J5M3r");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $cOMjN = parcelRequire("cOMjN");
const $76cc3b1301a661ae$export$de5b915e23c7ce7d = (0, $7NszV.createEntry)((0, $J5M3r.servicedeskChangeCalendarRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.change-calendar',
        component: (0, $cOMjN.default),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $1cxvE.AsyncJSMOperationsHorizontalNav),
            onlyShowHorizontalOnNav4: true
        },
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $2pT4g.jsmRepackagingBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cOMjN.LazyChangeCalendar),
            (0, $1cxvE.LazyJSMOperationsHorizontalNav)
        ],
        meta: {
            reporting: {
                id: 'changeCalendar',
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).CHANGE_CALENDAR),
                teamName: 'jenga'
            }
        }
    }));

});
parcelRegister("1cxvE", function(module, exports) {

$parcel$export(module.exports, "LazyJSMOperationsHorizontalNav", () => $f4b0e9313c9342f0$export$d9802671a2b1aa20);
$parcel$export(module.exports, "AsyncJSMOperationsHorizontalNav", () => $f4b0e9313c9342f0$export$d4493569f106c71);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $f4b0e9313c9342f0$export$d9802671a2b1aa20 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("b3C4T")).then(({ JSMOperationsHorizontalNav: JSMOperationsHorizontalNav })=>JSMOperationsHorizontalNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/operations/src/ui/index.tsx"
});
const $f4b0e9313c9342f0$export$d4493569f106c71 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-operations-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "asyncHorizontalOperationsNav",
        packageName: "jiraHorizontalNavJsmOperations",
        fallback: "flag",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f4b0e9313c9342f0$export$d9802671a2b1aa20, null)));

});
parcelRegister("b3C4T", function(module, exports) {

let $80cd8306d305c2e2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $80cd8306d305c2e2$var$load("dFn17").then(()=>parcelRequire('6vvjk'));

});


parcelRegister("2pT4g", function(module, exports) {

$parcel$export(module.exports, "jsmRepackagingBannerResource", () => $f325ae4fdb8711ab$export$760ca885f96dacb6);
$parcel$export(module.exports, "useJsmRepackagingBannerResource", () => $f325ae4fdb8711ab$export$f1444ccc5653a5cb);

var $5uXOq = parcelRequire("5uXOq");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $daiqe = parcelRequire("daiqe");

const $f325ae4fdb8711ab$var$getDataLoader = ()=>(parcelRequire("eIMF3"));
const $f325ae4fdb8711ab$export$760ca885f96dacb6 = (0, $2M1hQ.createResource)({
    type: 'JSM_REPACKAGING_BANNER',
    getKey: ()=>'JSM_REPACKAGING_BANNER',
    getDataLoader: $f325ae4fdb8711ab$var$getDataLoader,
    maxAge: false ? 0 : Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});
const $f325ae4fdb8711ab$export$f1444ccc5653a5cb = (workCategory, accountId)=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)($f325ae4fdb8711ab$export$760ca885f96dacb6);
    (0, $5uXOq.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        refresh,
        error
    ]);
    return (0, $5uXOq.useMemo)(()=>{
        if (error || loading || !data || !accountId) return {
            show: false
        };
        const { bannerMeta: bannerMeta, bannerDismissState: bannerDismissState } = data;
        const workCategoryDismissState = bannerDismissState?.[workCategory];
        if (!bannerMeta.show || !(bannerMeta.type === 'info' || bannerMeta.type === 'warning')) return {
            show: false
        };
        if (!workCategoryDismissState) return {
            ...bannerDismissState,
            ...bannerMeta,
            refresh: refresh
        };
        if (workCategoryDismissState.packagingChangeDate !== bannerMeta.data.packagingChangeDate) {
            (0, $daiqe.deleteBannerDismissState)({
                accountId: accountId
            });
            return {
                ...bannerMeta,
                refresh: refresh
            };
        }
        if (workCategoryDismissState.bannerHiddenUntil > Date.now()) return {
            show: false
        };
        return {
            ...bannerMeta,
            ...bannerDismissState,
            refresh: refresh
        };
    }, [
        data,
        loading,
        error,
        workCategory,
        accountId,
        refresh
    ]);
};

});
parcelRegister("daiqe", function(module, exports) {

$parcel$export(module.exports, "deleteBannerDismissState", () => $00907b0f6d0c25ed$export$e21bb99d98e8c8b4);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
async function $00907b0f6d0c25ed$export$e21bb99d98e8c8b4({ accountId: accountId }) {
    try {
        await (0, $eusud.performDeleteRequest)(`/rest/api/3/user/properties/jsm-repackaging-banners-dismiss-state?accountId=${accountId}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // https://data-portal.internal.atlassian.com/analytics/registry/71209
        (0, $jcw0u.default)({
            meta: {
                id: 'deleteBannerDismissState',
                packageName: 'jiraRouterResourcesJsmRepackagingBanner',
                teamName: 'jenga'
            },
            error: error
        });
    }
}

});

parcelRegister("eIMF3", function(module, exports) {

let $ab7aebd15e8ab99b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ab7aebd15e8ab99b$var$load("eX1fm").then(()=>parcelRequire('iKQCz'));

});


parcelRegister("J5M3r", function(module, exports) {

$parcel$export(module.exports, "servicedeskChangeCalendarRoute", () => $927ba64566bdbc92$export$3dbc16ae422c469);
const $927ba64566bdbc92$export$3dbc16ae422c469 = {
    name: 'servicedesk-change-calendar',
    path: '/jira/servicedesk/projects/:projectKey/change-calendar',
    exact: true
};

});

parcelRegister("cOMjN", function(module, exports) {

$parcel$export(module.exports, "LazyChangeCalendar", () => $f705f6e0ca7ffaf5$export$a6cec2d1c2e631eb);
$parcel$export(module.exports, "default", () => $f705f6e0ca7ffaf5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $f705f6e0ca7ffaf5$export$a6cec2d1c2e631eb = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("aPuR5"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/change-calendar/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f705f6e0ca7ffaf5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f705f6e0ca7ffaf5$export$a6cec2d1c2e631eb,
        pageId: "spa-apps/servicedesk/change-calendar",
        shouldShowSpinner: true
    });

});
parcelRegister("aPuR5", function(module, exports) {

let $7e2699fd6923be32$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7e2699fd6923be32$var$load("kSNuI").then(()=>parcelRequire('4cmmO'));

});



parcelRegister("7kGnZ", function(module, exports) {

$parcel$export(module.exports, "assetsRouteEntry", () => $b03272cc541907e2$export$7069f3fb497264f1);

var $7NszV = parcelRequire("7NszV");

var $hPMcq = parcelRequire("hPMcq");

var $55ZOZ = parcelRequire("55ZOZ");

var $lkFvK = parcelRequire("lkFvK");

var $kVDZN = parcelRequire("kVDZN");

var $k7I8D = parcelRequire("k7I8D");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");
const $b03272cc541907e2$var$assetsPageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $kVDZN.landingPageEntryPoint)
});
const $b03272cc541907e2$export$7069f3fb497264f1 = (0, $7NszV.createEntry)((0, $hPMcq.assetsRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        entryPoint: ()=>$b03272cc541907e2$var$assetsPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-landing-page',
        resources: (0, $55ZOZ.getAssetsAppResources)(),
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-landing-page'
    }));

});
parcelRegister("hPMcq", function(module, exports) {

$parcel$export(module.exports, "assetsRoute", () => $59be8ada95f8c1d8$export$70dab2ea29192797);
const $59be8ada95f8c1d8$export$70dab2ea29192797 = {
    name: 'assets',
    path: '/jira/assets',
    exact: true
};

});

parcelRegister("55ZOZ", function(module, exports) {

$parcel$export(module.exports, "getCmdbResources", () => $15b640a3daddca1e$export$850433b0663023b8);
$parcel$export(module.exports, "getAssetsAppResources", () => $15b640a3daddca1e$export$70fc9421fb71e080);

var $3RJkv = parcelRequire("3RJkv");

var $fpjJX = parcelRequire("fpjJX");

var $2eyDn = parcelRequire("2eyDn");

var $gRzZD = parcelRequire("gRzZD");

var $2Ql51 = parcelRequire("2Ql51");

var $kkNtb = parcelRequire("kkNtb");
function $15b640a3daddca1e$export$850433b0663023b8() {
    return [
        ...(0, $3RJkv.getNavigationResources)(),
        ...(0, $fpjJX.getServicedeskPageContextResources)(),
        (0, $gRzZD.workspaceResource)
    ];
}
function $15b640a3daddca1e$export$70fc9421fb71e080() {
    return [
        (0, $2Ql51.themePreferenceResource),
        (0, $kkNtb.rovoEntitlementResource),
        (0, $gRzZD.workspaceResource),
        (0, $2eyDn.consentBannerUserPreferencesResource)
    ];
}

});

parcelRegister("kVDZN", function(module, exports) {

$parcel$export(module.exports, "landingPageEntryPoint", () => $0cae44565e643672$export$36d88a15c123c06);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $0cae44565e643672$export$36d88a15c123c06 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        if (!false) return (parcelRequire("8W8bB"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "60961f22"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8W8bB", function(module, exports) {

let $681a171ce746c50d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $681a171ce746c50d$var$load("ffQaD"),
    $681a171ce746c50d$var$load("kvRbA"),
    $681a171ce746c50d$var$load("h4TlC")
]).then(()=>parcelRequire('9imjS'));

});


parcelRegister("k7I8D", function(module, exports) {

$parcel$export(module.exports, "LazyAssetsLayout", () => $5490b4e7bbb569d8$export$6d4ed5b3aae01b61);
$parcel$export(module.exports, "AssetsLayout", () => $5490b4e7bbb569d8$export$fc69c032e8242676);

var $5uXOq = parcelRequire("5uXOq");

var $kxZPA = parcelRequire("kxZPA");

var $lfTZh = parcelRequire("lfTZh");

const $5490b4e7bbb569d8$export$6d4ed5b3aae01b61 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("8IFMV")).then((module)=>module.AssetsLayout), {
    ssr: false,
    moduleId: "./src/packages/assets-app/layout/src/ui/index.tsx"
});
const $5490b4e7bbb569d8$export$fc69c032e8242676 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "assets-layout-async"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5490b4e7bbb569d8$export$6d4ed5b3aae01b61, null, children));

});
parcelRegister("8IFMV", function(module, exports) {

let $6592d905537620d7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6592d905537620d7$var$load("4cY42").then(()=>parcelRequire('c2H7b'));

});


parcelRegister("7iyOx", function(module, exports) {

$parcel$export(module.exports, "AssetsPageConfigContainer", () => $084a169938ff8f74$export$68a74d1b39f069c5);

var $5uXOq = parcelRequire("5uXOq");

var $kxZPA = parcelRequire("kxZPA");

var $lfTZh = parcelRequire("lfTZh");

const $084a169938ff8f74$export$606469064c062fcd = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("7MPot")).then((module)=>module.PageConfigContainer), {
    ssr: false,
    moduleId: "./src/packages/assets-app/page-config-container/src/ui/index.tsx"
});
const $084a169938ff8f74$export$68a74d1b39f069c5 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "assets-page-config-container-async"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($084a169938ff8f74$export$606469064c062fcd, null, children));

});
parcelRegister("7MPot", function(module, exports) {

let $5ab4e1d83cdfc002$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5ab4e1d83cdfc002$var$load("9rnnk").then(()=>parcelRequire('iHQhD'));

});



parcelRegister("6fdEz", function(module, exports) {

$parcel$export(module.exports, "assetsReportsRouteEntry", () => $36ddac7deaedb3c0$export$dabfe6668c5a0cc4);

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $jAA3i = parcelRequire("jAA3i");

var $e9YVH = parcelRequire("e9YVH");

var $lO0iE = parcelRequire("lO0iE");

var $lkFvK = parcelRequire("lkFvK");

var $k7I8D = parcelRequire("k7I8D");

var $55ZOZ = parcelRequire("55ZOZ");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");
const $36ddac7deaedb3c0$var$assetsReportsPageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $lO0iE.assetsReportsNav4HomeEntryPoint)
});
const $36ddac7deaedb3c0$export$dabfe6668c5a0cc4 = (0, $7NszV.createEntry)((0, $jAA3i.assetsReportsRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        entryPoint: ()=>$36ddac7deaedb3c0$var$assetsReportsPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-assets-reports-home-page',
        resources: [
            ...(0, $55ZOZ.getAssetsAppResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT),
                teamName: 'ITSM SAGA'
            }
        }
    }));

});
parcelRegister("jAA3i", function(module, exports) {

$parcel$export(module.exports, "assetsReportsRoute", () => $6707851ae8c25753$export$b123ccf7df3854f4);
const $6707851ae8c25753$export$b123ccf7df3854f4 = {
    name: 'assets-reports-default-redirect',
    path: '/jira/assets/reports',
    exact: true
};

});

parcelRegister("lO0iE", function(module, exports) {

$parcel$export(module.exports, "assetsReportsNav4HomeEntryPoint", () => $4ebd26cccf0a7e53$export$1a891b207b85b219);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $4ebd26cccf0a7e53$export$1a891b207b85b219 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        if (!false) return (parcelRequire("hNS7X")).then((module)=>module.AssetsReportsNav4HomePage);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "cd1143ba"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("hNS7X", function(module, exports) {

let $cf60ffda39f93f6d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cf60ffda39f93f6d$var$load("8asWZ").then(()=>parcelRequire('je9tT'));

});



parcelRegister("8WMR9", function(module, exports) {

$parcel$export(module.exports, "assetsReportsTemplateRouteEntry", () => $e1d23f4ef8c5f349$export$c69d6dbd8091ce7b);

var $lmyls = parcelRequire("lmyls");

var $72NwO = parcelRequire("72NwO");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $21dDm = parcelRequire("21dDm");

var $e9YVH = parcelRequire("e9YVH");

var $ceEFi = parcelRequire("ceEFi");

var $55ZOZ = parcelRequire("55ZOZ");

var $k7I8D = parcelRequire("k7I8D");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");
const $e1d23f4ef8c5f349$export$c69d6dbd8091ce7b = (0, $7NszV.createEntry)((0, $21dDm.assetsReportsTemplateRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        component: (0, $ceEFi.AssetsReports),
        resources: [
            ...(0, $55ZOZ.getAssetsAppResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout),
            (0, $ceEFi.LazyServicedeskCmdbAssetsReports)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $72NwO.default)
        },
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS),
                teamName: 'ITSM SAGA'
            }
        },
        perfMetricKey: 'service-management.insight-cmdb.load-assets-reports-template'
    }));

});
parcelRegister("72NwO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d99ccdcd3c9cebe4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZQxE = parcelRequire("dZQxE");

var $gbGmI = parcelRequire("gbGmI");

var $kxZPA = parcelRequire("kxZPA");

const $d99ccdcd3c9cebe4$export$2260a0528570f8da = (0, $kxZPA.lazyForPaint)(()=>{
    (0, $gbGmI.setPerformanceMarkLoadStart)();
    return (parcelRequire("7rR64")).then((bundle)=>{
        (0, $gbGmI.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/assets-reports/src/index.tsx"
});
const $d99ccdcd3c9cebe4$var$AssetsReportsSidebar = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZQxE.SidebarBoundary), {
        id: "assets-reports-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d99ccdcd3c9cebe4$export$2260a0528570f8da, null)));
$d99ccdcd3c9cebe4$var$AssetsReportsSidebar.displayName = 'AssetsReportsSidebar';
var $d99ccdcd3c9cebe4$export$2e2bcd8739ae039 = $d99ccdcd3c9cebe4$var$AssetsReportsSidebar;

});
parcelRegister("7rR64", function(module, exports) {

let $56c43df7141f5b77$var$load = (parcelRequire("28QjX"))(4);
module.exports = $56c43df7141f5b77$var$load("kdcHi").then(()=>parcelRequire('ejeJy'));

});


parcelRegister("21dDm", function(module, exports) {

$parcel$export(module.exports, "assetsReportsTemplateRoute", () => $101c0306a4a55493$export$4255578ec14d83bb);
const $101c0306a4a55493$export$4255578ec14d83bb = {
    name: 'assets-reports',
    path: '/jira/assets/reports/:templateId',
    exact: true
};

});

parcelRegister("ceEFi", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCmdbAssetsReports", () => $2e02aa1a19501df5$export$9f75cdfdfe8c8aaa);
$parcel$export(module.exports, "LazyServicedeskCmdbDefaultReportsRedirect", () => $2e02aa1a19501df5$export$2534c3e9f8e70d0d);
$parcel$export(module.exports, "LazyServicedeskCmdbAssetsReportsUnsubscribe", () => $2e02aa1a19501df5$export$dec85f15dd805ac4);
$parcel$export(module.exports, "LazyServicedeskCmdbAssetsReportsNav4HomePage", () => $2e02aa1a19501df5$export$c56cfef9aa68df09);
$parcel$export(module.exports, "AssetsReports", () => $2e02aa1a19501df5$export$d45b40d40442434);
$parcel$export(module.exports, "AssetsReportsUnsubscribe", () => $2e02aa1a19501df5$export$541b39e6d5be07df);
$parcel$export(module.exports, "AssetsReportingDefaultRedirect", () => $2e02aa1a19501df5$export$4155da54bfeacf74);
$parcel$export(module.exports, "AssetsReportsNav4HomePage", () => $2e02aa1a19501df5$export$9d28551695f98cae);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $2e02aa1a19501df5$export$9f75cdfdfe8c8aaa = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("ejdED")).then((exportedMembers)=>exportedMembers.CmdbAssetsReports), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports/src/index.tsx"
});

const $2e02aa1a19501df5$export$2534c3e9f8e70d0d = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("ejdED")).then((exportedMembers)=>exportedMembers.CmdbDefaultReportsRedirect), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports/src/index.tsx"
});

const $2e02aa1a19501df5$export$dec85f15dd805ac4 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("8Sjf3")), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports-unsubscribe/src/index.tsx"
});

const $2e02aa1a19501df5$export$c56cfef9aa68df09 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("ejdED")).then((exportedMembers)=>exportedMembers.CmdbAssetsReportsNav4HomePage), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports/src/index.tsx"
});
const $2e02aa1a19501df5$export$d45b40d40442434 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2e02aa1a19501df5$export$9f75cdfdfe8c8aaa,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports",
        shouldShowSpinner: true
    });
const $2e02aa1a19501df5$export$541b39e6d5be07df = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2e02aa1a19501df5$export$dec85f15dd805ac4,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports-unsubscribe",
        shouldShowSpinner: true
    });
const $2e02aa1a19501df5$export$4155da54bfeacf74 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2e02aa1a19501df5$export$2534c3e9f8e70d0d,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports-default-redirect",
        shouldShowSpinner: true
    });
const $2e02aa1a19501df5$export$9d28551695f98cae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2e02aa1a19501df5$export$c56cfef9aa68df09,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports-home-page",
        shouldShowSpinner: true
    });

});
parcelRegister("ejdED", function(module, exports) {

let $a6ad6e87ddd953fa$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("g7sKJ"), 4)),
    $a6ad6e87ddd953fa$var$load("ffQaD"),
    $a6ad6e87ddd953fa$var$load("kvRbA"),
    $a6ad6e87ddd953fa$var$load("76n7a"),
    $a6ad6e87ddd953fa$var$load("l253H"),
    $a6ad6e87ddd953fa$var$load("jzNjh")
]).then(()=>parcelRequire('7Jr0E'));

});

parcelRegister("8Sjf3", function(module, exports) {

let $67624ae9329df433$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    $67624ae9329df433$var$load("ffQaD"),
    $67624ae9329df433$var$load("kvRbA"),
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("6RlRv"), 4)),
    $67624ae9329df433$var$load("76n7a"),
    $67624ae9329df433$var$load("l253H"),
    $67624ae9329df433$var$load("2W1TX")
]).then(()=>parcelRequire('imnQf'));

});



parcelRegister("hSl7U", function(module, exports) {

$parcel$export(module.exports, "assetsReportsUnsubscribeRouteEntry", () => $ffecce251ff34805$export$25e4df4267166d6b);

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $dSJJZ = parcelRequire("dSJJZ");

var $e9YVH = parcelRequire("e9YVH");

var $l50mM = parcelRequire("l50mM");

var $lkFvK = parcelRequire("lkFvK");

var $55ZOZ = parcelRequire("55ZOZ");

var $k7I8D = parcelRequire("k7I8D");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");
const $ffecce251ff34805$var$assetsReportsUnsubscribePageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $l50mM.assetsReportsUnsubscribeEntryPoint)
});
const $ffecce251ff34805$export$25e4df4267166d6b = (0, $7NszV.createEntry)((0, $dSJJZ.assetsReportsUnsubscribeRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        entryPoint: ()=>$ffecce251ff34805$var$assetsReportsUnsubscribePageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-assets-reports-unsubscribe',
        resources: [
            ...(0, $55ZOZ.getAssetsAppResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE),
                teamName: 'ITSM SAGA'
            }
        }
    }));

});
parcelRegister("dSJJZ", function(module, exports) {

$parcel$export(module.exports, "assetsReportsUnsubscribeRoute", () => $ff6ca822a7d33e3c$export$2b543c10e2c9e843);
const $ff6ca822a7d33e3c$export$2b543c10e2c9e843 = {
    name: 'assets-reports-unsubscribe',
    path: '/jira/assets/reports/unsubscribe/:templateId/:subscriptionId',
    exact: true
};

});

parcelRegister("l50mM", function(module, exports) {

$parcel$export(module.exports, "assetsReportsUnsubscribeEntryPoint", () => $1972442ea7884b36$export$d827c87e65bb6e47);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $1972442ea7884b36$export$d827c87e65bb6e47 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        if (!false) return (parcelRequire("8Sjf3"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "fe8b4981"
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("9F4ID", function(module, exports) {

$parcel$export(module.exports, "assetsSchemaRouteEntry", () => $28393bd3192d9d9e$export$92c5054123a75324);

var $7NszV = parcelRequire("7NszV");

var $k4Xe9 = parcelRequire("k4Xe9");

var $55ZOZ = parcelRequire("55ZOZ");

var $2iVq4 = parcelRequire("2iVq4");

var $bQHge = parcelRequire("bQHge");

var $lkFvK = parcelRequire("lkFvK");

var $k7I8D = parcelRequire("k7I8D");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");
const $28393bd3192d9d9e$var$assetsSchemaPageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $bQHge.assetsSchemaEntryPoint)
});
const $28393bd3192d9d9e$export$92c5054123a75324 = (0, $7NszV.createEntry)((0, $k4Xe9.assetsSchemaRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        component: (0, $2iVq4.ObjectSchemaV2),
        entryPoint: ()=>$28393bd3192d9d9e$var$assetsSchemaPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-object-schema',
        resources: (0, $55ZOZ.getAssetsAppResources)(),
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout)
        ],
        perfMetricKey: 'service-management.insight-cmdb.load-schema-page'
    }));

});
parcelRegister("k4Xe9", function(module, exports) {

$parcel$export(module.exports, "assetsSchemaRoute", () => $edb3724412b3283d$export$9515b8d2f9c8b12d);
const $edb3724412b3283d$export$9515b8d2f9c8b12d = {
    name: 'assets-schema',
    path: '/jira/assets/object-schema/:objectSchemaId'
};

});

parcelRegister("2iVq4", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCmdbObjectSchemaV2", () => $3c1950a2c10ba0ce$export$1e50d5a65ac4f5fc);
$parcel$export(module.exports, "ObjectSchemaV2", () => $3c1950a2c10ba0ce$export$f90a4f33c79fd86e);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $3c1950a2c10ba0ce$export$1e50d5a65ac4f5fc = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("7K7HE")), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-object-schema-v2/src/index.tsx"
});
const $3c1950a2c10ba0ce$export$f90a4f33c79fd86e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3c1950a2c10ba0ce$export$1e50d5a65ac4f5fc,
        pageId: "spa-apps/servicedesk/insight/cmdb-object-schema",
        shouldShowSpinner: true
    });
var $3c1950a2c10ba0ce$export$2e2bcd8739ae039 = $3c1950a2c10ba0ce$export$f90a4f33c79fd86e;

});
parcelRegister("7K7HE", function(module, exports) {

let $5a32cdee8aee2363$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $5a32cdee8aee2363$var$load("kNFvF"),
    $5a32cdee8aee2363$var$load("76n7a"),
    $5a32cdee8aee2363$var$load("l253H"),
    $5a32cdee8aee2363$var$load("5fSss")
]).then(()=>parcelRequire('ciybC'));

});


parcelRegister("bQHge", function(module, exports) {

$parcel$export(module.exports, "assetsSchemaEntryPoint", () => $42b8401f19d7a816$export$bbb96f529694d699);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $42b8401f19d7a816$export$bbb96f529694d699 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        if (!false) return (parcelRequire("7K7HE"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "a9175d64"
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("9CT95", function(module, exports) {

$parcel$export(module.exports, "assetsObjectTypeConfigurationRouteEntry", () => $90a106b2f6138f39$export$28b088de21f264eb);

var $7NszV = parcelRequire("7NszV");

var $8OvOy = parcelRequire("8OvOy");

var $e9YVH = parcelRequire("e9YVH");

var $55ZOZ = parcelRequire("55ZOZ");

var $2U2qS = parcelRequire("2U2qS");

var $lkFvK = parcelRequire("lkFvK");

var $k7I8D = parcelRequire("k7I8D");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");
const $90a106b2f6138f39$var$assetsObjectTypeSettingsPageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $2U2qS.assetsObjectTypeSettingsEntryPoint)
});
const $90a106b2f6138f39$export$28b088de21f264eb = (0, $7NszV.createEntry)((0, $8OvOy.assetsObjectTypeConfigurationRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        entryPoint: ()=>$90a106b2f6138f39$var$assetsObjectTypeSettingsPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-configure-object-type',
        resources: (0, $55ZOZ.getAssetsAppResources)(),
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION),
                teamName: 'aurum'
            }
        },
        ufoName: 'service-management.insight-cmdb-object-type-configuration'
    }));

});
parcelRegister("8OvOy", function(module, exports) {

$parcel$export(module.exports, "assetsObjectTypeConfigurationRoute", () => $7219951fe88b4de4$export$fe5957039840ffd3);
const $7219951fe88b4de4$export$fe5957039840ffd3 = {
    name: 'assets-object-type-configuration',
    path: '/jira/assets/configure/object-type/:objectTypeId'
};

});

parcelRegister("2U2qS", function(module, exports) {

$parcel$export(module.exports, "assetsObjectTypeSettingsEntryPoint", () => $b38a85b0472f579f$export$fab2e471b162aafc);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $b38a85b0472f579f$export$fab2e471b162aafc = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("dbln9")), {
        moduleId: "b4d985ee"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("dbln9", function(module, exports) {

let $998ce18f60966d15$var$load = (parcelRequire("28QjX"))(4);
module.exports = $998ce18f60966d15$var$load("fNTa5").then(()=>parcelRequire('2lY4S'));

});



parcelRegister("gktyQ", function(module, exports) {

$parcel$export(module.exports, "assetsConfigurationRouteEntry", () => $fcbf97b2b57b87ef$export$1c86de5db8ff2b58);

var $7NszV = parcelRequire("7NszV");

var $9EXi9 = parcelRequire("9EXi9");

var $e9YVH = parcelRequire("e9YVH");

var $55ZOZ = parcelRequire("55ZOZ");

var $lkFvK = parcelRequire("lkFvK");

var $bdXN2 = parcelRequire("bdXN2");

var $k7I8D = parcelRequire("k7I8D");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");
const $fcbf97b2b57b87ef$var$globalConfigurePageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $bdXN2.assetsGlobalSettingsEntryPoint)
});
const $fcbf97b2b57b87ef$export$1c86de5db8ff2b58 = (0, $7NszV.createEntry)((0, $9EXi9.assetsConfigurationRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        ufoName: 'servicedesk-cmdb-assets-configure',
        entryPoint: ()=>$fcbf97b2b57b87ef$var$globalConfigurePageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-configure',
        resources: (0, $55ZOZ.getAssetsAppResources)(),
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-global-config-page',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION),
                teamName: 'aurum'
            }
        }
    }));

});
parcelRegister("9EXi9", function(module, exports) {

$parcel$export(module.exports, "assetsConfigurationRoute", () => $f9206ce977f9b0fa$export$266d00c8001d32ab);
const $f9206ce977f9b0fa$export$266d00c8001d32ab = {
    name: 'assets-configure',
    path: '/jira/assets/configure/global'
};

});

parcelRegister("bdXN2", function(module, exports) {

$parcel$export(module.exports, "assetsGlobalSettingsEntryPoint", () => $d81197ab248aed96$export$2b083e0274144f1b);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $d81197ab248aed96$export$2b083e0274144f1b = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        if (!false) return (parcelRequire("lTD03"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "b65d2969"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lTD03", function(module, exports) {

let $ff0cfc930876c515$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ff0cfc930876c515$var$load("dHjHz").then(()=>parcelRequire('cB0p5'));

});



parcelRegister("elyxq", function(module, exports) {

$parcel$export(module.exports, "assetsSchemaConfigurationRouteEntry", () => $c609df68fdefe1cd$export$6c9c29c3048f2e2c);

var $7NszV = parcelRequire("7NszV");

var $6j0IA = parcelRequire("6j0IA");

var $cNynZ = parcelRequire("cNynZ");

var $e9YVH = parcelRequire("e9YVH");

var $55ZOZ = parcelRequire("55ZOZ");

var $6acMA = parcelRequire("6acMA");

var $lkFvK = parcelRequire("lkFvK");

var $k7I8D = parcelRequire("k7I8D");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");
const $c609df68fdefe1cd$var$assetsSchemaSettingsPageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $6acMA.assetsSchemaSettingsEntryPoint)
});
const $c609df68fdefe1cd$export$6c9c29c3048f2e2c = (0, $7NszV.createEntry)((0, $cNynZ.assetsSchemaConfigurationRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        entryPoint: ()=>$c609df68fdefe1cd$var$assetsSchemaSettingsPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-object-schema-configuration',
        resources: [
            ...(0, $55ZOZ.getAssetsAppResources)(),
            (0, $6j0IA.serviceDeskAssetsImportTypeForgeDataResource)
        ],
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-object-schema-config',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
                teamName: 'krispy-krew'
            }
        }
    }));

});
parcelRegister("6j0IA", function(module, exports) {

$parcel$export(module.exports, "serviceDeskAssetsImportTypeForgeDataResource", () => $f0c74bdf86d6b898$export$58d2462746e91c7d);

var $2M1hQ = parcelRequire("2M1hQ");

const $f0c74bdf86d6b898$var$getDataLoader = ()=>(parcelRequire("888RZ"));
const $f0c74bdf86d6b898$export$58d2462746e91c7d = (0, $2M1hQ.createResource)({
    type: 'ASSETS_IMPORT_TYPE_FORGE_DATA',
    getKey: ()=>'extensions',
    getDataLoader: $f0c74bdf86d6b898$var$getDataLoader,
    maxAge: Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});

});
parcelRegister("888RZ", function(module, exports) {

let $5eb5f3744fff0520$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5eb5f3744fff0520$var$load("2FiSC").then(()=>parcelRequire('jwVSb'));

});


parcelRegister("cNynZ", function(module, exports) {

$parcel$export(module.exports, "assetsSchemaConfigurationRoute", () => $a7e42f61407bcdca$export$f27e51e1e8d78f80);
const $a7e42f61407bcdca$export$f27e51e1e8d78f80 = {
    name: 'assets-schema-configuration',
    path: '/jira/assets/configure/object-schema/:objectSchemaId'
};

});

parcelRegister("6acMA", function(module, exports) {

$parcel$export(module.exports, "assetsSchemaSettingsEntryPoint", () => $f8bbd3389b616628$export$b012e15a5f6394fc);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $f8bbd3389b616628$export$b012e15a5f6394fc = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        if (!false) return (parcelRequire("byrcV"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "c93bb7f3"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("byrcV", function(module, exports) {

let $8697f98c2d506ec9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8697f98c2d506ec9$var$load("bfS0F").then(()=>parcelRequire('hEchH'));

});



parcelRegister("3T2Ye", function(module, exports) {

$parcel$export(module.exports, "assetsObjectRouteEntry", () => $615c397cb5d7287d$export$17871a1fbc6e31db);

var $7NszV = parcelRequire("7NszV");

var $8naTI = parcelRequire("8naTI");

var $1KCrA = parcelRequire("1KCrA");

var $55ZOZ = parcelRequire("55ZOZ");

var $9jDQB = parcelRequire("9jDQB");

var $lkFvK = parcelRequire("lkFvK");

var $k7I8D = parcelRequire("k7I8D");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");
const $615c397cb5d7287d$var$assetsObjectPageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $9jDQB.assetsObjectViewEntryPoint)
});
const $615c397cb5d7287d$export$17871a1fbc6e31db = (0, $7NszV.createEntry)((0, $1KCrA.assetsObjectRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        entryPoint: ()=>$615c397cb5d7287d$var$assetsObjectPageEntryPoint,
        pageId: ()=>'spa-apps/servicedesk/insight/cmdb-object-v2',
        resources: [
            ...(0, $55ZOZ.getAssetsAppResources)(),
            (0, $8naTI.insightObjectResource)
        ],
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout)
        ],
        perfMetricKey: 'service-management.insight-cmdb.object-view-page-load',
        ufoName: 'service-management.insight-cmdb.object-view-page-load'
    }));

});
parcelRegister("8naTI", function(module, exports) {

$parcel$export(module.exports, "insightObjectResource", () => $2ad42c3dacc09c9e$export$215464c8085c5e35);

var $2M1hQ = parcelRequire("2M1hQ");

var $7JHOP = parcelRequire("7JHOP");
const $2ad42c3dacc09c9e$var$RESOURCE_TYPE_SERVICEDESK_INSIGHT_OBJECT = 'SERVICEDESK_INSIGHT_OBJECT';
const $2ad42c3dacc09c9e$export$215464c8085c5e35 = (0, $2M1hQ.createResource)({
    type: $2ad42c3dacc09c9e$var$RESOURCE_TYPE_SERVICEDESK_INSIGHT_OBJECT,
    getKey: ({ match: match })=>match.params.objectId || '',
    getData: $7JHOP.default,
    isBrowserOnly: true
});

});
parcelRegister("7JHOP", function(module, exports) {

$parcel$export(module.exports, "default", () => $07f064c629fd32ba$export$2e2bcd8739ae039);

var $x9xyg = parcelRequire("x9xyg");

var $2YZCu = parcelRequire("2YZCu");

var $xJtdX = parcelRequire("xJtdX");

var $7f4tk = parcelRequire("7f4tk");

var $8PRuf = parcelRequire("8PRuf");

var $iR3GG = parcelRequire("iR3GG");

var $eJOOa = parcelRequire("eJOOa");

var $ahEft = parcelRequire("ahEft");

var $9NiTW = parcelRequire("9NiTW");
const $07f064c629fd32ba$var$fetchInsightObjectDetails = async (routeDataContext, routerContext)=>{
    try {
        const { match: { params: params } } = routeDataContext;
        const { objectId: objectId } = params;
        if (objectId == null) return null;
        const workspaceId = await (0, $ahEft.default)(routeDataContext, routerContext);
        if (workspaceId == null) return null;
        const data = await (0, $7f4tk.default)((0, $eJOOa.getCmdbObjectByIdUrl)(workspaceId, objectId));
        (0, $x9xyg.setMark)((0, $8PRuf.prefetchApiReadyMark));
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jiraServicedeskInsightObjectResource', error);
        (0, $xJtdX.fireCmdbErrorAnalytics)({
            meta: {
                id: 'jiraServicedeskInsightObjectResource',
                packageName: 'jiraSpa'
            },
            error: error
        });
        throw error;
    }
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$07f064c629fd32ba$export$2e2bcd8739ae039 = async (routeDataContext, routerContext)=>{
    const { tenantContext: tenantContext } = routerContext;
    // Early exit on these cases and return a valid response. We don't want to flood sentry.
    if (!(0, $9NiTW.checkAuthentication)(tenantContext)) throw (0, $iR3GG.createResourceError)({
        component: 'spa.view.routes.servicedesk.cmdb-object.getData',
        message: 'Current user is not authenticated',
        name: 'AuthenticationError',
        skipSentry: true
    });
    return $07f064c629fd32ba$var$fetchInsightObjectDetails(routeDataContext, routerContext);
};

});
parcelRegister("eJOOa", function(module, exports) {

$parcel$export(module.exports, "getCmdbObjectByIdUrl", () => $bba7f62e646e53a7$export$d33c3e25476d091d);
$parcel$export(module.exports, "getCmdbObjectByIdUrlWithoutQueryParams", () => $bba7f62e646e53a7$export$6ef8997552257871);
$parcel$export(module.exports, "getCmdbObjectByIdActivityUrl", () => $bba7f62e646e53a7$export$20c207abffb62450);
$parcel$export(module.exports, "getCmdbObjectByIdAvatarUrl", () => $bba7f62e646e53a7$export$31df868d16d545f8);
$parcel$export(module.exports, "getCmdbObjectByIdReferenceInfoUrl", () => $bba7f62e646e53a7$export$5044a1e9fc201773);
$parcel$export(module.exports, "getCmdbObjectCloneByIdUrl", () => $bba7f62e646e53a7$export$d7f6dc1d4f622458);
$parcel$export(module.exports, "getCmdbObjectCreateUrl", () => $bba7f62e646e53a7$export$9cdc19e8944d38cf);
$parcel$export(module.exports, "getCmdbObjectNavlistUrl", () => $bba7f62e646e53a7$export$bf9c534c2cd21829);
$parcel$export(module.exports, "getCmdbObjectNavlistQueryLanguageUrl", () => $bba7f62e646e53a7$export$b35334340ee827fa);
$parcel$export(module.exports, "getCmdbObjectRecentUrl", () => $bba7f62e646e53a7$export$a0a7c6f22bebdef0);
$parcel$export(module.exports, "getCmdbObjectQueryLanguageTotalCountUrl", () => $bba7f62e646e53a7$export$ee74f95a469c4433);
$parcel$export(module.exports, "getCmdbObjectQueryLanguageUrl", () => $bba7f62e646e53a7$export$84a34ee3f18e226);
$parcel$export(module.exports, "getCmdbAsyncObjectExportUrl", () => $bba7f62e646e53a7$export$878b627ac685384e);
$parcel$export(module.exports, "getCmdbAsyncBulkQrCodeUrl", () => $bba7f62e646e53a7$export$8eb3a6b36886db0);
$parcel$export(module.exports, "getCmdbAsyncBulkDeleteUrl", () => $bba7f62e646e53a7$export$b02201bcaeb75291);
$parcel$export(module.exports, "getCmdbAsyncBulkEditUrl", () => $bba7f62e646e53a7$export$f4d68a6f0e3217b5);

var $ebyGx = parcelRequire("ebyGx");

var $klJ8b = parcelRequire("klJ8b");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/object
 */ const $bba7f62e646e53a7$var$getCmdbObjectUrl = (workspaceId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/object`;
const $bba7f62e646e53a7$export$d33c3e25476d091d = (workspaceId, objectId, includeExtendedInfo = false)=>{
    const path = $bba7f62e646e53a7$export$6ef8997552257871(workspaceId, objectId);
    if (!includeExtendedInfo) return `${path}?${(0, $ebyGx.stringify)({
        includeExtendedInfo: includeExtendedInfo
    })}`;
    return path;
};
const $bba7f62e646e53a7$export$6ef8997552257871 = (workspaceId, objectId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/${objectId}`;
const $bba7f62e646e53a7$export$20c207abffb62450 = (workspaceId, objectId, queryParams)=>`${$bba7f62e646e53a7$export$6ef8997552257871(workspaceId, objectId)}/activity?${(0, $ebyGx.stringify)(queryParams)}`;
const $bba7f62e646e53a7$export$31df868d16d545f8 = (workspaceId, objectId)=>`${$bba7f62e646e53a7$export$6ef8997552257871(workspaceId, objectId)}/avatar`;
const $bba7f62e646e53a7$export$5044a1e9fc201773 = (workspaceId, objectId)=>`${$bba7f62e646e53a7$export$6ef8997552257871(workspaceId, objectId)}/referenceinfo`;
const $bba7f62e646e53a7$export$d7f6dc1d4f622458 = (workspaceId, objectId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/clone/${objectId}`;
const $bba7f62e646e53a7$export$9cdc19e8944d38cf = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/create`;
const $bba7f62e646e53a7$export$bf9c534c2cd21829 = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/navlist`;
const $bba7f62e646e53a7$export$b35334340ee827fa = (workspaceId)=>`${$bba7f62e646e53a7$export$bf9c534c2cd21829(workspaceId)}/aql`;
const $bba7f62e646e53a7$export$a0a7c6f22bebdef0 = (workspaceId, queryParams)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/recent?${(0, $ebyGx.stringify)(queryParams)}`;
const $bba7f62e646e53a7$export$ee74f95a469c4433 = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/aql/totalcount`;
const $bba7f62e646e53a7$export$1016ae73c04d9079 = (workspaceId, queryParams)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/search?${(0, $ebyGx.stringify)(queryParams)}`;
const $bba7f62e646e53a7$export$cb41514f2508b033 = (workspaceId, queryParams)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/searchbyattributes?${(0, $ebyGx.stringify)(queryParams)}`;
const $bba7f62e646e53a7$export$84a34ee3f18e226 = (workspaceId, queryParams)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/aql?${(0, $ebyGx.stringify)(queryParams)}`;
const $bba7f62e646e53a7$export$878b627ac685384e = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/bulkexport`;
const $bba7f62e646e53a7$export$8eb3a6b36886db0 = (workspaceId, queryParams)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/bulkqrcode?${(0, $ebyGx.stringify)(queryParams)}`;
const $bba7f62e646e53a7$export$b02201bcaeb75291 = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/bulkdelete`;
const $bba7f62e646e53a7$export$f4d68a6f0e3217b5 = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/bulkedit`;

});



parcelRegister("1KCrA", function(module, exports) {

$parcel$export(module.exports, "assetsObjectRoute", () => $f53da45d067bd137$export$8f0b5215230b6dd1);
const $f53da45d067bd137$export$8f0b5215230b6dd1 = {
    name: 'assets-object',
    path: '/jira/assets/object/:objectId'
};

});

parcelRegister("9jDQB", function(module, exports) {

$parcel$export(module.exports, "assetsObjectViewEntryPoint", () => $24c507f8dd2d8705$export$4311ec530d21ec36);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $24c507f8dd2d8705$export$4311ec530d21ec36 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        if (!false) return (parcelRequire("cbcUT"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "5026c489"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("cbcUT", function(module, exports) {

let $8de0881d0422dbce$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $8de0881d0422dbce$var$load("kNFvF"),
    $8de0881d0422dbce$var$load("fliVL"),
    $8de0881d0422dbce$var$load("76n7a"),
    $8de0881d0422dbce$var$load("l253H"),
    $8de0881d0422dbce$var$load("bmBxo")
]).then(()=>parcelRequire('8V2Yz'));

});



parcelRegister("cVgRQ", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsGlobalConfigurationRouteEntry", () => $faac49f10a71388a$export$6755c90e62150ca0);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $92pmL = parcelRequire("92pmL");

var $e9YVH = parcelRequire("e9YVH");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $gXGYk = parcelRequire("gXGYk");

var $aP5Tt = parcelRequire("aP5Tt");
const $faac49f10a71388a$export$6755c90e62150ca0 = (0, $7NszV.createEntry)((0, $92pmL.servicedeskCmdbAssetsGlobalConfigurationRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        ufoName: 'servicedesk-cmdb-assets-configure',
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $gXGYk.default),
        resources: (0, $55ZOZ.getCmdbResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gXGYk.LazyServicedeskCmdbGlobalConfigure)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-global-config-page',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION),
                teamName: 'aurum'
            }
        }
    }));

});
parcelRegister("92pmL", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsGlobalConfigurationRoute", () => $d7e386cd256d5aa1$export$b28679181cd68abd);
const $d7e386cd256d5aa1$export$b28679181cd68abd = {
    name: 'servicedesk-cmdb-configure',
    path: '/jira/servicedesk/assets/configure/global'
};

});

parcelRegister("gXGYk", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCmdbGlobalConfigure", () => $faa956883f49da96$export$b80bd807bad3fd0a);
$parcel$export(module.exports, "default", () => $faa956883f49da96$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $faa956883f49da96$export$b80bd807bad3fd0a = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("lTD03")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-configure-v2/src/index.tsx"
});
const $faa956883f49da96$var$GlobalConfigure = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $faa956883f49da96$export$b80bd807bad3fd0a,
        pageId: "spa-apps/servicedesk/insight/cmdb-configure",
        shouldShowSpinner: true
    });
var $faa956883f49da96$export$2e2bcd8739ae039 = $faa956883f49da96$var$GlobalConfigure;

});

parcelRegister("aP5Tt", function(module, exports) {

$parcel$export(module.exports, "AssetsAppRedirect", () => $8bbdf2dde395c922$export$5d5d166a9477289f);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $7tQej = parcelRequire("7tQej");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $blEB6 = parcelRequire("blEB6");
const $8bbdf2dde395c922$export$5d5d166a9477289f = ({ match: match, query: query })=>{
    const pattern = /\/jira\/servicedesk\/(assets|insight)/;
    let redirectionUrl = match.url.replace(pattern, (0, $blEB6.ASSETS_APP_ROUTE_PREFIX));
    if (Object.keys(query).length > 0) redirectionUrl += `?${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(query)}`;
    const analyticsAttributes = {
        matchedRoute: match.path
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "assetsAppRedirect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: redirectionUrl,
        push: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: analyticsAttributes
    }));
};

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';



parcelRegister("8XfJX", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsObjectRouteEntry", () => $3695f420dde24db1$export$ed571153b6c25586);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $8naTI = parcelRequire("8naTI");

var $gyaGI = parcelRequire("gyaGI");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $8lolW = parcelRequire("8lolW");

var $aP5Tt = parcelRequire("aP5Tt");
const $3695f420dde24db1$export$ed571153b6c25586 = (0, $7NszV.createEntry)((0, $gyaGI.servicedeskCmdbAssetsObjectRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $8lolW.InsightCmdbObjectViewV2),
        resources: [
            ...(0, $55ZOZ.getCmdbResources)(),
            (0, $8naTI.insightObjectResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8lolW.LazyServicedeskCmdbObjectV2)
        ],
        perfMetricKey: 'service-management.insight-cmdb.object-view-page-load',
        ufoName: 'service-management.insight-cmdb.object-view-page-load'
    }));

});
parcelRegister("gyaGI", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsObjectRoute", () => $2c9190d0f388a73b$export$bf02944216c526ff);
const $2c9190d0f388a73b$export$bf02944216c526ff = {
    name: 'servicedesk-cmdb-object',
    path: '/jira/servicedesk/assets/object/:objectId'
};

});

parcelRegister("8lolW", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCmdbObjectV2", () => $3afd4c2d86bdef54$export$411c1981ced22249);
$parcel$export(module.exports, "InsightCmdbObjectViewV2", () => $3afd4c2d86bdef54$export$3c208f927c6178ee);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $3afd4c2d86bdef54$export$411c1981ced22249 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("cbcUT")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-object-v2/src/index.tsx"
});
const $3afd4c2d86bdef54$export$3c208f927c6178ee = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3afd4c2d86bdef54$export$411c1981ced22249,
        pageId: "spa-apps/servicedesk/insight/cmdb-object-v2",
        shouldShowSpinner: true
    });
var $3afd4c2d86bdef54$export$2e2bcd8739ae039 = $3afd4c2d86bdef54$export$3c208f927c6178ee;

});


parcelRegister("5o5UE", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsObjectSchemaConfigurationRouteEntry", () => $1bf397a941deb833$export$ce7f2af5016c6aa9);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $6j0IA = parcelRequire("6j0IA");

var $9kM4D = parcelRequire("9kM4D");

var $e9YVH = parcelRequire("e9YVH");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $2vrwM = parcelRequire("2vrwM");

var $aP5Tt = parcelRequire("aP5Tt");
const $1bf397a941deb833$export$ce7f2af5016c6aa9 = (0, $7NszV.createEntry)((0, $9kM4D.servicedeskCmdbAssetsObjectSchemaConfigurationRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $2vrwM.default),
        resources: [
            ...(0, $55ZOZ.getCmdbResources)(),
            (0, $6j0IA.serviceDeskAssetsImportTypeForgeDataResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $2vrwM.LazyServicedeskCmdbObjectSchemaConfiguration)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-object-schema-config',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
                teamName: 'krispy-krew'
            }
        }
    }));

});
parcelRegister("9kM4D", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsObjectSchemaConfigurationRoute", () => $3076563cb1feeec0$export$b4a150d67181752);
const $3076563cb1feeec0$export$b4a150d67181752 = {
    name: 'servicedesk-cmdb-object-schema-configuration',
    path: '/jira/servicedesk/assets/configure/object-schema/:objectSchemaId'
};

});

parcelRegister("2vrwM", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCmdbObjectSchemaConfiguration", () => $af13a504c251f159$export$8305a1bc1c5bee45);
$parcel$export(module.exports, "default", () => $af13a504c251f159$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $af13a504c251f159$export$8305a1bc1c5bee45 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("byrcV")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-object-schema-configuration/src/index.tsx"
});
const $af13a504c251f159$var$ObjectSchemaConfiguration = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $af13a504c251f159$export$8305a1bc1c5bee45,
        pageId: "spa-apps/servicedesk/insight/cmdb-object-schema-configuration",
        shouldShowSpinner: true
    });
var $af13a504c251f159$export$2e2bcd8739ae039 = $af13a504c251f159$var$ObjectSchemaConfiguration;

});


parcelRegister("2OBp2", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsObjectSchemaRouteEntry", () => $8d7a97c0aebbdbdc$export$d9dc7083d0a34d11);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $3W4zD = parcelRequire("3W4zD");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $2iVq4 = parcelRequire("2iVq4");

var $aP5Tt = parcelRequire("aP5Tt");
const $8d7a97c0aebbdbdc$export$d9dc7083d0a34d11 = (0, $7NszV.createEntry)((0, $3W4zD.servicedeskCmdbAssetsObjectSchemaRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $2iVq4.ObjectSchemaV2),
        resources: (0, $55ZOZ.getCmdbResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $2iVq4.LazyServicedeskCmdbObjectSchemaV2)
        ],
        perfMetricKey: 'service-management.insight-cmdb.load-schema-page'
    }));

});
parcelRegister("3W4zD", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsObjectSchemaRoute", () => $7cc0a4e0da040e16$export$6f86804eb594cd29);
const $7cc0a4e0da040e16$export$6f86804eb594cd29 = {
    name: 'servicedesk-cmdb-object-schema',
    path: '/jira/servicedesk/assets/object-schema/:objectSchemaId'
};

});


parcelRegister("29XA4", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsObjectTypeConfigurationRouteEntry", () => $271b67f72308a1a9$export$d45b927987c92c0e);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $VSMJU = parcelRequire("VSMJU");

var $e9YVH = parcelRequire("e9YVH");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $b93Zs = parcelRequire("b93Zs");

var $aP5Tt = parcelRequire("aP5Tt");
const $271b67f72308a1a9$export$d45b927987c92c0e = (0, $7NszV.createEntry)((0, $VSMJU.servicedeskCmdbAssetsObjectTypeConfigurationRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $b93Zs.default),
        resources: (0, $55ZOZ.getCmdbResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $b93Zs.LazyServicedeskCmdbConfigureObjectType)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION),
                teamName: 'aurum'
            }
        },
        ufoName: 'service-management.insight-cmdb-object-type-configuration'
    }));

});
parcelRegister("VSMJU", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsObjectTypeConfigurationRoute", () => $f41e677a77064268$export$73b901e16d5e5a02);
const $f41e677a77064268$export$73b901e16d5e5a02 = {
    name: 'servicedesk-cmdb-object-type-configuration',
    path: '/jira/servicedesk/assets/configure/object-type/:objectTypeId'
};

});

parcelRegister("b93Zs", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCmdbConfigureObjectType", () => $14de2d11a3985015$export$926956539e1f72ba);
$parcel$export(module.exports, "default", () => $14de2d11a3985015$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $14de2d11a3985015$export$926956539e1f72ba = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("dbln9")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-configure-object-type/src/index.tsx"
});
const $14de2d11a3985015$var$InsightConfigureObjectType = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $14de2d11a3985015$export$926956539e1f72ba,
        pageId: "spa-apps/servicedesk/insight/cmdb-configure-object-type",
        shouldShowSpinner: true
    });
var $14de2d11a3985015$export$2e2bcd8739ae039 = $14de2d11a3985015$var$InsightConfigureObjectType;

});


parcelRegister("aNc7A", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsReportsRouteEntry", () => $b2f990f1e1876908$export$2621677b40f03d6c);

var $ffza4 = parcelRequire("ffza4");

var $7XYc4 = parcelRequire("7XYc4");

var $3HwlS = parcelRequire("3HwlS");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $fpjJX = parcelRequire("fpjJX");

var $zCmTp = parcelRequire("zCmTp");

var $e9YVH = parcelRequire("e9YVH");

var $gRzZD = parcelRequire("gRzZD");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $ceEFi = parcelRequire("ceEFi");

var $aP5Tt = parcelRequire("aP5Tt");
const $b2f990f1e1876908$export$2621677b40f03d6c = (0, $7NszV.createEntry)((0, $zCmTp.servicedeskCmdbAssetsReportsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), (0, $ceEFi.AssetsReportsNav4HomePage), (0, $ceEFi.AssetsReportingDefaultRedirect)),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $gRzZD.workspaceResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ceEFi.LazyServicedeskCmdbDefaultReportsRedirect),
            (0, $ceEFi.LazyServicedeskCmdbAssetsReportsNav4HomePage)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT),
                teamName: 'ITSM SAGA'
            }
        }
    }));

});
parcelRegister("zCmTp", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsReportsRoute", () => $5c3155ab36693f37$export$a075d8b7c4c55c41);
const $5c3155ab36693f37$export$a075d8b7c4c55c41 = {
    name: 'servicedesk-cmdb-assets-reports-default-redirect',
    path: '/jira/servicedesk/assets/reports',
    exact: true
};

});


parcelRegister("4e4nJ", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsReportsTemplateRouteEntry", () => $8f1e557acbc4fa67$export$51d27be4bd1db6ce);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $72NwO = parcelRequire("72NwO");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $fpjJX = parcelRequire("fpjJX");

var $3b83Z = parcelRequire("3b83Z");

var $e9YVH = parcelRequire("e9YVH");

var $gRzZD = parcelRequire("gRzZD");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $ceEFi = parcelRequire("ceEFi");

var $aP5Tt = parcelRequire("aP5Tt");
const $8f1e557acbc4fa67$export$51d27be4bd1db6ce = (0, $7NszV.createEntry)((0, $3b83Z.servicedeskCmdbAssetsReportsTemplateRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $ceEFi.AssetsReports),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $gRzZD.workspaceResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ceEFi.LazyServicedeskCmdbAssetsReports)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PEOPLE,
            sidebar: (0, $72NwO.default)
        },
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS),
                teamName: 'ITSM SAGA'
            }
        },
        perfMetricKey: 'service-management.insight-cmdb.load-assets-reports-template'
    }));

});
parcelRegister("3b83Z", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsReportsTemplateRoute", () => $a647cdc489d0614a$export$9482cb7f11a7730);
const $a647cdc489d0614a$export$9482cb7f11a7730 = {
    name: 'servicedesk-cmdb-assets-reports',
    path: '/jira/servicedesk/assets/reports/:templateId',
    exact: true
};

});


parcelRegister("5nU8P", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsReportsUnsubscribeRouteEntry", () => $3f95abeddff727cc$export$5842852f274cd739);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $fpjJX = parcelRequire("fpjJX");

var $nQffI = parcelRequire("nQffI");

var $e9YVH = parcelRequire("e9YVH");

var $gRzZD = parcelRequire("gRzZD");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $ceEFi = parcelRequire("ceEFi");

var $aP5Tt = parcelRequire("aP5Tt");
const $3f95abeddff727cc$export$5842852f274cd739 = (0, $7NszV.createEntry)((0, $nQffI.servicedeskCmdbAssetsReportsUnsubscribeRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $ceEFi.AssetsReportsUnsubscribe),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $gRzZD.workspaceResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ceEFi.LazyServicedeskCmdbAssetsReportsUnsubscribe)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE),
                teamName: 'ITSM SAGA'
            }
        }
    }));

});
parcelRegister("nQffI", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsReportsUnsubscribeRoute", () => $8ce2bb095b9742dc$export$66ab60d374e8e458);
const $8ce2bb095b9742dc$export$66ab60d374e8e458 = {
    name: 'servicedesk-cmdb-assets-reports-unsubscribe',
    path: '/jira/servicedesk/assets/reports/unsubscribe/:templateId/:subscriptionId',
    exact: true
};

});


parcelRegister("kHVIE", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsSchemasRouteEntry", () => $bd164bb7c160f180$export$70a75f8d403c935a);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $6t4Wv = parcelRequire("6t4Wv");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $ia3qM = parcelRequire("ia3qM");

var $aP5Tt = parcelRequire("aP5Tt");
const $bd164bb7c160f180$export$70a75f8d403c935a = (0, $7NszV.createEntry)((0, $6t4Wv.servicedeskCmdbAssetsSchemasRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $ia3qM.default),
        resources: (0, $55ZOZ.getCmdbResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ia3qM.LazyServicedeskCmdbLandingPage)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-landing-page'
    }));

});
parcelRegister("6t4Wv", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbAssetsSchemasRoute", () => $1096c786552e99d7$export$118f7c2ddb756e80);
const $1096c786552e99d7$export$118f7c2ddb756e80 = {
    name: 'servicedesk-cmdb-assets',
    path: '/jira/servicedesk/assets',
    exact: true
};

});

parcelRegister("ia3qM", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCmdbLandingPage", () => $3371db153f9530b2$export$f6c79e6ff37913ee);
$parcel$export(module.exports, "default", () => $3371db153f9530b2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $3371db153f9530b2$export$f6c79e6ff37913ee = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("8W8bB")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-landing-page/src/index.tsx"
});
const $3371db153f9530b2$var$LandingPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3371db153f9530b2$export$f6c79e6ff37913ee,
        pageId: "spa-apps/servicedesk/insight/cmdb-landing-page",
        shouldShowSpinner: true
    });
var $3371db153f9530b2$export$2e2bcd8739ae039 = $3371db153f9530b2$var$LandingPage;

});


parcelRegister("eHeAh", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightConfigureGlobalRouteEntry", () => $c572a1f6d205e72b$export$69b479583cd0d13f);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $h8gJx = parcelRequire("h8gJx");

var $e9YVH = parcelRequire("e9YVH");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $gXGYk = parcelRequire("gXGYk");

var $aP5Tt = parcelRequire("aP5Tt");
const $c572a1f6d205e72b$export$69b479583cd0d13f = (0, $7NszV.createEntry)((0, $h8gJx.servicedeskCmdbInsightConfigureGlobalRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        ufoName: 'servicedesk-cmdb-insight-configure-global',
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $gXGYk.default),
        resources: (0, $55ZOZ.getCmdbResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gXGYk.LazyServicedeskCmdbGlobalConfigure)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-global-config-page',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION),
                teamName: 'aurum'
            }
        }
    }));

});
parcelRegister("h8gJx", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightConfigureGlobalRoute", () => $ba065f4b091a02af$export$96e5da52356f214c);
const $ba065f4b091a02af$export$96e5da52356f214c = {
    name: 'servicedesk-cmdb-configure',
    path: '/jira/servicedesk/insight/configure/global'
};

});


parcelRegister("9R3is", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightConfigureRouteEntry", () => $495bba4b83c4abb8$export$277a55a31c82cf0e);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $8xYq7 = parcelRequire("8xYq7");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $ac6Qh = parcelRequire("ac6Qh");

var $aP5Tt = parcelRequire("aP5Tt");
const $495bba4b83c4abb8$export$277a55a31c82cf0e = (0, $7NszV.createEntry)((0, $8xYq7.servicedeskCmdbInsightConfigureRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        ufoName: 'servicedesk-cmdb-insight-configure',
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $ac6Qh.default),
        resources: (0, $55ZOZ.getCmdbResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ac6Qh.LazyServicedeskCmdbConfigure)
        ]
    }));

});
parcelRegister("8xYq7", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightConfigureRoute", () => $b3ba64550401680b$export$e960ab4fcd3e80b6);
const $b3ba64550401680b$export$e960ab4fcd3e80b6 = {
    name: 'servicedesk-cmdb-configure',
    path: '/jira/servicedesk/insight/configure'
};

});

parcelRegister("ac6Qh", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCmdbConfigure", () => $9872d73b74d97014$export$8075d4042713bf6d);
$parcel$export(module.exports, "default", () => $9872d73b74d97014$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $9872d73b74d97014$export$8075d4042713bf6d = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("f8jjU")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-configure/src/index.tsx"
});
const $9872d73b74d97014$var$InsightConfigure = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9872d73b74d97014$export$8075d4042713bf6d,
        pageId: "spa-apps/servicedesk/insight/cmdb-configure",
        shouldShowSpinner: true
    });
var $9872d73b74d97014$export$2e2bcd8739ae039 = $9872d73b74d97014$var$InsightConfigure;

});
parcelRegister("f8jjU", function(module, exports) {

let $b04696f2c542b95e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b04696f2c542b95e$var$load("kmeQV").then(()=>parcelRequire('cKWhs'));

});



parcelRegister("lKkaY", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightObject4RouteEntry", () => $20b7f48df08d140e$export$95574c3333e559d3);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $8naTI = parcelRequire("8naTI");

var $dODCf = parcelRequire("dODCf");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $8lolW = parcelRequire("8lolW");

var $aP5Tt = parcelRequire("aP5Tt");
const $20b7f48df08d140e$export$95574c3333e559d3 = (0, $7NszV.createEntry)((0, $dODCf.servicedeskCmdbInsightObject4Route), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $8lolW.InsightCmdbObjectViewV2),
        resources: [
            ...(0, $55ZOZ.getCmdbResources)(),
            (0, $8naTI.insightObjectResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8lolW.LazyServicedeskCmdbObjectV2)
        ],
        perfMetricKey: 'service-management.insight-cmdb.object-view-page-load',
        ufoName: 'service-management.insight-cmdb.object-view-page-load'
    }));

});
parcelRegister("dODCf", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightObject4Route", () => $fa024efc61833843$export$223f5bacfd3d39fd);
const $fa024efc61833843$export$223f5bacfd3d39fd = {
    name: 'servicedesk-cmdb-object',
    path: '/jira/servicedesk/insight/assets/:objectId'
};

});


parcelRegister("brWuf", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightObjectSchemaConfigurationRouteEntry", () => $dc805604e47f30ff$export$261e9b5115dfbb0a);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $6tshd = parcelRequire("6tshd");

var $e9YVH = parcelRequire("e9YVH");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $2vrwM = parcelRequire("2vrwM");

var $aP5Tt = parcelRequire("aP5Tt");
const $dc805604e47f30ff$export$261e9b5115dfbb0a = (0, $7NszV.createEntry)((0, $6tshd.servicedeskCmdbInsightObjectSchemaConfigurationRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $2vrwM.default),
        resources: (0, $55ZOZ.getCmdbResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $2vrwM.LazyServicedeskCmdbObjectSchemaConfiguration)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-object-schema-config',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
                teamName: 'krispy-krew'
            }
        }
    }));

});
parcelRegister("6tshd", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightObjectSchemaConfigurationRoute", () => $0be30b09ce65a175$export$f6b688a8729943b3);
const $0be30b09ce65a175$export$f6b688a8729943b3 = {
    name: 'servicedesk-cmdb-object-schema-configuration',
    path: '/jira/servicedesk/insight/configure/object-schema/:objectSchemaId'
};

});


parcelRegister("iXsus", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightObjectSchemaRouteEntry", () => $390b0c9138642138$export$192b200c13b0b76a);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $S3PTJ = parcelRequire("S3PTJ");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $2iVq4 = parcelRequire("2iVq4");

var $aP5Tt = parcelRequire("aP5Tt");
const $390b0c9138642138$export$192b200c13b0b76a = (0, $7NszV.createEntry)((0, $S3PTJ.servicedeskCmdbInsightObjectSchemaRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $2iVq4.ObjectSchemaV2),
        resources: (0, $55ZOZ.getCmdbResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $2iVq4.LazyServicedeskCmdbObjectSchemaV2)
        ],
        perfMetricKey: 'service-management.insight-cmdb.load-schema-page'
    }));

});
parcelRegister("S3PTJ", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightObjectSchemaRoute", () => $0050a642a1c533ba$export$fcde60ded71d4ae6);
const $0050a642a1c533ba$export$fcde60ded71d4ae6 = {
    name: 'servicedesk-cmdb-object-schema',
    path: '/jira/servicedesk/insight/object-schemas/:objectSchemaId'
};

});


parcelRegister("xwXfC", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightObjectTypeConfigurationRouteEntry", () => $0a9518d238b0ac1f$export$de4ab140a5dbd984);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $kA9Q5 = parcelRequire("kA9Q5");

var $e9YVH = parcelRequire("e9YVH");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $b93Zs = parcelRequire("b93Zs");

var $aP5Tt = parcelRequire("aP5Tt");
const $0a9518d238b0ac1f$export$de4ab140a5dbd984 = (0, $7NszV.createEntry)((0, $kA9Q5.servicedeskCmdbInsightObjectTypeConfigurationRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $b93Zs.default),
        resources: (0, $55ZOZ.getCmdbResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $b93Zs.LazyServicedeskCmdbConfigureObjectType)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION),
                teamName: 'aurum'
            }
        }
    }));

});
parcelRegister("kA9Q5", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightObjectTypeConfigurationRoute", () => $de5e134e813298dc$export$12e89d5d79d59785);
const $de5e134e813298dc$export$12e89d5d79d59785 = {
    name: 'servicedesk-cmdb-object-type-configuration',
    path: '/jira/servicedesk/insight/configure/object-type/:objectTypeId'
};

});


parcelRegister("3lpLH", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightRouteEntry", () => $a395bb20c6d1e9c8$export$3befca4eb012b818);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $cx6sj = parcelRequire("cx6sj");

var $4R6GH = parcelRequire("4R6GH");

var $2BrOV = parcelRequire("2BrOV");

var $lmyls = parcelRequire("lmyls");

var $55ZOZ = parcelRequire("55ZOZ");

var $ia3qM = parcelRequire("ia3qM");

var $aP5Tt = parcelRequire("aP5Tt");
const $a395bb20c6d1e9c8$export$3befca4eb012b818 = (0, $7NszV.createEntry)((0, $cx6sj.servicedeskCmdbInsightRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).INSIGHT
        },
        component: (0, $4R6GH.fg)('assets_as_an_app_v2') ? (0, $aP5Tt.AssetsAppRedirect) : (0, $ia3qM.default),
        resources: (0, $55ZOZ.getCmdbResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ia3qM.LazyServicedeskCmdbLandingPage)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-landing-page'
    }));

});
parcelRegister("cx6sj", function(module, exports) {

$parcel$export(module.exports, "servicedeskCmdbInsightRoute", () => $638ad863a15aceaf$export$1efada07b7203f2d);
const $638ad863a15aceaf$export$1efada07b7203f2d = {
    name: 'servicedesk-cmdb-insight',
    path: '/jira/servicedesk/insight',
    exact: true
};

});


parcelRegister("kNZj9", function(module, exports) {

$parcel$export(module.exports, "servicedeskCreateProjectRouteEntry", () => $3e592ff21679cec3$export$ac25abe07ac3f570);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $h2JLJ = parcelRequire("h2JLJ");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $3e592ff21679cec3$var$LazyServiceDeskCreateProject = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("eKFEL")), {
    moduleId: "./src/packages/spa-apps/servicedesk/create-project/src/index.tsx"
});
const $3e592ff21679cec3$var$ServiceDeskCreateProject = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3e592ff21679cec3$var$LazyServiceDeskCreateProject,
        pageId: "spa-apps/servicedesk/create-project",
        shouldShowSpinner: true
    });
const $3e592ff21679cec3$export$ac25abe07ac3f570 = (0, $7NszV.createEntry)((0, $h2JLJ.servicedeskCreateProjectRoute), ()=>({
        group: 'servicedesk',
        isRedirect: true,
        component: $3e592ff21679cec3$var$ServiceDeskCreateProject,
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $3e592ff21679cec3$var$LazyServiceDeskCreateProject
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).CREATE_PROJECT,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).CREATE_PROJECT),
                teamName: 'itops-mithril'
            }
        }
    }));

});
parcelRegister("h2JLJ", function(module, exports) {

$parcel$export(module.exports, "servicedeskCreateProjectRoute", () => $834f9b43560f1ccb$export$1f409a894343952a);
const $834f9b43560f1ccb$export$1f409a894343952a = {
    name: 'servicedesk-create-project',
    path: '/jira/servicedesk/create-project',
    exact: true
};

});

parcelRegister("eKFEL", function(module, exports) {

let $abd5acb09c5cc1e8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $abd5acb09c5cc1e8$var$load("9CSBV").then(()=>parcelRequire('3hX8x'));

});


parcelRegister("aw22a", function(module, exports) {

$parcel$export(module.exports, "customerServiceEscalationsRouteEntry", () => $e27fdc04f14a6641$export$36a7c374f4474cc1);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $e4B7v = parcelRequire("e4B7v");

var $7fRd9 = parcelRequire("7fRd9");

var $ffa20 = parcelRequire("ffa20");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $e27fdc04f14a6641$var$LazyServicedeskCustomerServiceEscalations = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("kBVAb"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/customer-service-escalations/src/index.tsx"
});
const $e27fdc04f14a6641$var$ServicedeskCustomerServiceEscalations = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e27fdc04f14a6641$var$LazyServicedeskCustomerServiceEscalations,
        pageId: "spa-apps/servicedesk/customer-service-escalations",
        shouldShowSpinner: true
    });
const $e27fdc04f14a6641$export$36a7c374f4474cc1 = (0, $7NszV.createEntry)((0, $ffa20.customerServiceEscalationsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $e4B7v.componentFilterResource),
            (0, $7fRd9.priorityFilterResource)
        ],
        component: $e27fdc04f14a6641$var$ServicedeskCustomerServiceEscalations,
        perfMetricKey: 'jsm-customer-service-escalations-component-load',
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $e27fdc04f14a6641$var$LazyServicedeskCustomerServiceEscalations
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).CUSTOMER_SERVICE_ESCALATIONS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).CUSTOMER_SERVICE_ESCALATIONS),
                teamName: 'boysenberry'
            }
        }
    }));

});
parcelRegister("e4B7v", function(module, exports) {

$parcel$export(module.exports, "componentFilterResource", () => $ff0131666c555211$export$306e389909032632);
$parcel$export(module.exports, "useComponentFilterResource", () => $ff0131666c555211$export$e13868d6ab2288af);

var $dK8AG = parcelRequire("dK8AG");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

const $ff0131666c555211$var$getDataLoader = ()=>(parcelRequire("jW76F"));
const $ff0131666c555211$export$306e389909032632 = (0, $2M1hQ.createResource)({
    type: 'ESCALATIONS_COMPONENT_FILTER_RESOURCE',
    getKey: ({ match: match })=>(0, $dK8AG.getProjectKeyOrId)(match),
    getDataLoader: $ff0131666c555211$var$getDataLoader
});
const $ff0131666c555211$export$e13868d6ab2288af = ()=>(0, $2YP9W.useResource)($ff0131666c555211$export$306e389909032632);

});
parcelRegister("jW76F", function(module, exports) {

let $e838f24c0ec53c56$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e838f24c0ec53c56$var$load("hAfcl").then(()=>parcelRequire('hXg9m'));

});


parcelRegister("7fRd9", function(module, exports) {

$parcel$export(module.exports, "priorityFilterResource", () => $1ec7e880e057744a$export$ca03c5f9fc44703e);
$parcel$export(module.exports, "usePriorityFilterResource", () => $1ec7e880e057744a$export$3654f46b6bb12558);

var $4R6GH = parcelRequire("4R6GH");

var $dK8AG = parcelRequire("dK8AG");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

const $1ec7e880e057744a$var$getDataLoader = ()=>(parcelRequire("1ekaZ"));
const $1ec7e880e057744a$export$ca03c5f9fc44703e = (0, $2M1hQ.createResource)({
    type: 'ESCALATIONS_PRIORITY_FILTER_RESOURCE',
    getKey: ({ match: match })=>(0, $dK8AG.getProjectKeyOrId)(match),
    getDataLoader: $1ec7e880e057744a$var$getDataLoader
});
const $1ec7e880e057744a$export$3654f46b6bb12558 = ()=>(0, $2YP9W.useResource)((0, $4R6GH.fg)('jcs_master_flag') ? $1ec7e880e057744a$export$ca03c5f9fc44703e : (0, $2M1hQ.createResource)({
        type: 'ESCALATIONS_PRIORITY_FILTER_RESOURCE',
        getKey: ({ match: match })=>(0, $dK8AG.getProjectKeyOrId)(match),
        getDataLoader: $1ec7e880e057744a$var$getDataLoader
    }));

});
parcelRegister("1ekaZ", function(module, exports) {

let $0e56bfd88db62396$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0e56bfd88db62396$var$load("hybUM").then(()=>parcelRequire('ejgJG'));

});


parcelRegister("ffa20", function(module, exports) {

$parcel$export(module.exports, "customerServiceEscalationsRoute", () => $ee1b6a45151c9b49$export$51e84b36f828d9ff);
const $ee1b6a45151c9b49$export$51e84b36f828d9ff = {
    name: 'servicedesk-customer-service-escalations',
    path: '/jira/servicedesk/projects/:projectKey/escalations',
    exact: true
};

});

parcelRegister("kBVAb", function(module, exports) {

let $f013ee0e8b9a9d06$var$load = (parcelRequire("28QjX"))(4);

module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $f013ee0e8b9a9d06$var$load("czifk"),
            $f013ee0e8b9a9d06$var$load("kvRbA"),
            $f013ee0e8b9a9d06$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $f013ee0e8b9a9d06$var$load("kcs34")
        ]);
    }),
    $f013ee0e8b9a9d06$var$load("ffQaD"),
    $f013ee0e8b9a9d06$var$load("kvRbA"),
    $f013ee0e8b9a9d06$var$load("76n7a"),
    $f013ee0e8b9a9d06$var$load("l253H"),
    $f013ee0e8b9a9d06$var$load("aDLsT")
]).then(()=>parcelRequire('81cgT'));

});


parcelRegister("yVbxa", function(module, exports) {

$parcel$export(module.exports, "customerServiceProductsRouteEntry", () => $d306aa8b938adbc6$export$8e015e39dbc90d0b);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $cEOhb = parcelRequire("cEOhb");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $7yABM = parcelRequire("7yABM");

var $fqFCk = parcelRequire("fqFCk");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $d306aa8b938adbc6$var$LazyServicedeskCustomerServiceProducts = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("52OW4"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/customer-service-products/src/index.tsx"
});
const $d306aa8b938adbc6$var$ServicedeskCustomerServiceProducts = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d306aa8b938adbc6$var$LazyServicedeskCustomerServiceProducts,
        pageId: "spa-apps/servicedesk/customer-service-products",
        shouldShowSpinner: true
    });
const $d306aa8b938adbc6$export$8e015e39dbc90d0b = (0, $7NszV.createEntry)((0, $fqFCk.customerServiceProductsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $cEOhb.AsyncDirectoryNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $7yABM.customerServiceProductsQueryResource)
        ],
        component: $d306aa8b938adbc6$var$ServicedeskCustomerServiceProducts,
        perfMetricKey: 'jsm-customer-service-products-component-load',
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $d306aa8b938adbc6$var$LazyServicedeskCustomerServiceProducts
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).CUSTOMER_SERVICE_PRODUCTS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).CUSTOMER_SERVICE_PRODUCTS),
                teamName: 'boysenberry'
            }
        }
    }));

});
parcelRegister("cEOhb", function(module, exports) {

$parcel$export(module.exports, "AsyncDirectoryNav", () => $c28aa1a42d481780$export$a237f415539577a5);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


const $c28aa1a42d481780$var$LazyDirectoryNav = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("9imGM")).then(({ DirectoryHorizontalNav: DirectoryHorizontalNav })=>DirectoryHorizontalNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/directory/src/ui/index.tsx"
});
const $c28aa1a42d481780$export$a237f415539577a5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-jsm-directory-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c28aa1a42d481780$var$LazyDirectoryNav, null));

});
parcelRegister("9imGM", function(module, exports) {

let $6c476509377e6757$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6c476509377e6757$var$load("cctvZ").then(()=>parcelRequire('emSF0'));

});


parcelRegister("7yABM", function(module, exports) {

$parcel$export(module.exports, "PRODUCTS_PAGE_SIZE", () => $cbdcceb1886ba86d$export$9e59a0b3e9d74a99);
$parcel$export(module.exports, "customerServiceProductsQueryResource", () => $cbdcceb1886ba86d$export$f9257217f5333b1a);

var $ao2h1 = parcelRequire("ao2h1");

var $aPLvO = parcelRequire("aPLvO");
const $cbdcceb1886ba86d$export$9e59a0b3e9d74a99 = 50;
const $cbdcceb1886ba86d$export$f9257217f5333b1a = (0, $ao2h1.createRelayResource)({
    type: 'CUSTOMER_SERVICE_PRODUCTS_QUERY',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $aPLvO.default),
            variables: {
                cloudId: tenantContext.cloudId,
                first: $cbdcceb1886ba86d$export$9e59a0b3e9d74a99
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("aPLvO", function(module, exports) {

$parcel$export(module.exports, "default", () => $06c174000e8c134e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4df781c51f5dfbc32b76735c59bb33af>>
 * @relayHash 081a2dfa9c4407c84bf8d024899e92b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bb8d4ae9602322e43ac61cf45c886f9ecad88afb1aaa237fd8615ea59abb7c16
const $06c174000e8c134e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v3 = [
        v2 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "srcCustomerServiceProductsQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "productsPage_servicedeskCustomerServiceProducts"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "srcCustomerServiceProductsQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ 
                    ],
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "CustomerServiceProductConnection",
                            "kind": "LinkedField",
                            "name": "productConnections",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CustomerServiceProductEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "CustomerServiceProduct",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "entitlementsCount"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__id"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v3 /*: any*/ ,
                            "handle": "connection",
                            "key": "customerServiceProducts_productConnections",
                            "kind": "LinkedHandle",
                            "name": "productConnections"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bb8d4ae9602322e43ac61cf45c886f9ecad88afb1aaa237fd8615ea59abb7c16",
            "metadata": {},
            "name": "srcCustomerServiceProductsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$06c174000e8c134e$var$node.hash = "3c49696a6cdc337af280ec80f957ea89";
var $06c174000e8c134e$export$2e2bcd8739ae039 = $06c174000e8c134e$var$node;

});


parcelRegister("fqFCk", function(module, exports) {

$parcel$export(module.exports, "customerServiceProductsRoute", () => $ecb0fd0317e4b818$export$73e241aabf4c9c58);
const $ecb0fd0317e4b818$export$73e241aabf4c9c58 = {
    name: 'servicedesk-customer-service-products',
    path: '/jira/servicedesk/projects/:projectKey/products',
    exact: true
};

});

parcelRegister("52OW4", function(module, exports) {

let $3ac4a66e6600a746$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $3ac4a66e6600a746$var$load("ffQaD"),
    $3ac4a66e6600a746$var$load("kvRbA"),
    $3ac4a66e6600a746$var$load("76n7a"),
    $3ac4a66e6600a746$var$load("l253H"),
    $3ac4a66e6600a746$var$load("884YO")
]).then(()=>parcelRequire('fSKfx'));

});


parcelRegister("dCGUp", function(module, exports) {

$parcel$export(module.exports, "servicedeskCustomerDetailsRouteEntry", () => $742f9da2fde448d1$export$97ee6e9bb7f7bd31);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $fcMlY = parcelRequire("fcMlY");

var $4lqmX = parcelRequire("4lqmX");

var $9BHIm = parcelRequire("9BHIm");

var $e9YVH = parcelRequire("e9YVH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6Z2mh = parcelRequire("6Z2mh");

var $ctGuD = parcelRequire("ctGuD");
const $742f9da2fde448d1$export$97ee6e9bb7f7bd31 = (0, $7NszV.createEntry)((0, $9BHIm.servicedeskCustomerDetailsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        component: (0, $ctGuD.ServicedeskCustomerDetails),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ctGuD.LazyServicedeskCustomerDetails)
        ],
        perfMetricKey: 'jsm-customer-details-component-load',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).CUSTOMER_DETAILS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).CUSTOMER_DETAILS),
                teamName: 'boysenberry'
            }
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $fcMlY.entitlementsCustomerQueryResource),
            (0, $4lqmX.uiCustomerDetailsPageQueryResource)
        ]
    }));

});
parcelRegister("fcMlY", function(module, exports) {

$parcel$export(module.exports, "entitlementsCustomerQueryResource", () => $b3b86d13796012d4$export$78737979422d6907);

var $ao2h1 = parcelRequire("ao2h1");

var $3KdBC = parcelRequire("3KdBC");
const $b3b86d13796012d4$export$78737979422d6907 = (0, $ao2h1.createRelayResource)({
    type: 'ENTITLEMENTS_CUSTOMER_QUERY',
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $3KdBC.default),
            variables: {
                accountId: String(match.params.customerId),
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("3KdBC", function(module, exports) {

$parcel$export(module.exports, "default", () => $234ef4e6f5c8b134$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2d711ace41d650be975013cf5a90d182>>
 * @relayHash 2d56ae07e9224712e6cbeb1d40c0d517
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b6e68492e4403956991e93b2bec1552e11424884520f6d91d362bfb3f950af38
const $234ef4e6f5c8b134$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "accountId"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v9 = [
        v7 /*: any*/ ,
        v6 /*: any*/ 
    ], v10 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "entitlementsCustomerQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v2 /*: any*/ ,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "CustomerServiceProductConnection",
                                    "kind": "LinkedField",
                                    "name": "productConnections",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CustomerServiceProductEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "CustomerServiceProduct",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v4 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "customerService.productConnections.edges"
                                        }
                                    ],
                                    "storageKey": "productConnections(first:1)"
                                },
                                "action": "THROW",
                                "path": "customerService.productConnections"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v5 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "individualByAccountId",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v7 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "customerService.individualByAccountId.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "CustomerServiceEntitlement",
                                                        "kind": "LinkedField",
                                                        "name": "entitlementList",
                                                        "plural": true,
                                                        "selections": [
                                                            v7 /*: any*/ ,
                                                            {
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "includeEntityTypeName",
                                                                        "value": true
                                                                    }
                                                                ],
                                                                "kind": "FragmentSpread",
                                                                "name": "entitlement_servicedeskCustomerServiceEntitlementsCard"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "customerService.individualByAccountId.entitlementList"
                                                },
                                                v8 /*: any*/ 
                                            ],
                                            "type": "CustomerServiceIndividual"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "throwOnQueryError_servicedeskCustomerServiceCommon"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "customerService.individualByAccountId"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "customerService"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "entitlementsCustomerQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "CustomerServiceProductConnection",
                            "kind": "LinkedField",
                            "name": "productConnections",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CustomerServiceProductEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "CustomerServiceProduct",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "productConnections(first:1)"
                        },
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "individualByAccountId",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "concreteType": "CustomerServiceEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlementList",
                                            "plural": true,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "concreteType": "CustomerServiceProduct",
                                                    "kind": "LinkedField",
                                                    "name": "product",
                                                    "plural": false,
                                                    "selections": v9 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "entity",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v9 /*: any*/ ,
                                                            "type": "CustomerServiceOrganization"
                                                        },
                                                        v10 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ],
                                    "type": "CustomerServiceIndividual"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "errorType"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                v10 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b6e68492e4403956991e93b2bec1552e11424884520f6d91d362bfb3f950af38",
            "metadata": {},
            "name": "entitlementsCustomerQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$234ef4e6f5c8b134$var$node.hash = "52b18fa6e520ef1142f20ddded30f5ba";
var $234ef4e6f5c8b134$export$2e2bcd8739ae039 = $234ef4e6f5c8b134$var$node;

});


parcelRegister("4lqmX", function(module, exports) {

$parcel$export(module.exports, "uiCustomerDetailsPageQueryResource", () => $bb7f2c1b84275683$export$d766b4bd7ad23814);

var $ao2h1 = parcelRequire("ao2h1");

var $bvCOc = parcelRequire("bvCOc");
const $bb7f2c1b84275683$export$d766b4bd7ad23814 = (0, $ao2h1.createRelayResource)({
    type: 'UI_CUSTOMER_DETAILS_PAGE_QUERY',
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $bvCOc.default),
            variables: {
                accountId: String(match.params.customerId),
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("bvCOc", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb866aea27d5a9be$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<feb4ddb92be08c0d717024aa5a8194a8>>
 * @relayHash 368df621eebbab5cb9e1cf9ceded10d2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4c922c068178abaa255d12a88a8254e5b236724d396e47df3f3461e152127536
const $eb866aea27d5a9be$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "4c922c068178abaa255d12a88a8254e5b236724d396e47df3f3461e152127536",
        "metadata": {},
        "name": "uiCustomerDetailsPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $eb866aea27d5a9be$export$2e2bcd8739ae039 = $eb866aea27d5a9be$var$node;

});


parcelRegister("9BHIm", function(module, exports) {

$parcel$export(module.exports, "servicedeskCustomerDetailsRoute", () => $42ea45afdbe6f2e0$export$42c0f04d04ecd1f8);
const $42ea45afdbe6f2e0$export$42c0f04d04ecd1f8 = {
    name: 'servicedesk-customer-details',
    path: '/jira/servicedesk/projects/:projectKey/customers/:customerId',
    exact: true
};

});

parcelRegister("ctGuD", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskCustomersV2", () => $11e345ce4933debe$export$864b519a4059ac6b);
$parcel$export(module.exports, "LazyServicedeskCustomerDetails", () => $11e345ce4933debe$export$6c5749ec31de847d);
$parcel$export(module.exports, "ServicedeskCustomerDetails", () => $11e345ce4933debe$export$2412523c0e3657cc);
$parcel$export(module.exports, "ServiceDeskCustomersV2", () => $11e345ce4933debe$export$ac54d7814cf71dd);
$parcel$export(module.exports, "ServiceDeskContacts", () => $11e345ce4933debe$export$db9de32a8b149a29);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $11e345ce4933debe$export$864b519a4059ac6b = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("eFK6g"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/customers-v2/src/index.tsx"
});

const $11e345ce4933debe$export$55118fe902ecc07a = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("cLmWW")), {
    moduleId: "./src/packages/spa-apps/servicedesk/contacts/src/index.tsx"
});

const $11e345ce4933debe$export$6c5749ec31de847d = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hNzkQ"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/customer-details/src/index.tsx"
});
const $11e345ce4933debe$export$2412523c0e3657cc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $11e345ce4933debe$export$6c5749ec31de847d,
        pageId: "spa-apps/servicedesk/customer-details",
        shouldShowSpinner: true
    });
const $11e345ce4933debe$export$ac54d7814cf71dd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $11e345ce4933debe$export$864b519a4059ac6b,
        pageId: "spa-apps/servicedesk/customers-v2",
        shouldShowSpinner: true
    });
const $11e345ce4933debe$export$db9de32a8b149a29 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $11e345ce4933debe$export$55118fe902ecc07a,
        pageId: "spa-apps/servicedesk/contacts",
        shouldShowSpinner: true
    });

});
parcelRegister("eFK6g", function(module, exports) {

let $aae8a78a9a177f70$var$load = (parcelRequire("28QjX"))(4);
module.exports = $aae8a78a9a177f70$var$load("e2nBc").then(()=>parcelRequire('dKNUD'));

});

parcelRegister("cLmWW", function(module, exports) {

let $94abad250520b856$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $94abad250520b856$var$load("ffQaD"),
    $94abad250520b856$var$load("kvRbA"),
    $94abad250520b856$var$load("76n7a"),
    $94abad250520b856$var$load("l253H"),
    $94abad250520b856$var$load("uP0oQ")
]).then(()=>parcelRequire('2XE2f'));

});

parcelRegister("hNzkQ", function(module, exports) {

let $cf526c1faabd291a$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $cf526c1faabd291a$var$load("ffQaD"),
    $cf526c1faabd291a$var$load("kvRbA"),
    $cf526c1faabd291a$var$load("76n7a"),
    $cf526c1faabd291a$var$load("l253H"),
    $cf526c1faabd291a$var$load("b4axw")
]).then(()=>parcelRequire('eRp4S'));

});



parcelRegister("4KLVz", function(module, exports) {

$parcel$export(module.exports, "servicedeskCustomersV2RouteEntry", () => $499fff83668d7b3b$export$e1fa279356610d18);

var $ffza4 = parcelRequire("ffza4");

var $cEOhb = parcelRequire("cEOhb");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $eAdnc = parcelRequire("eAdnc");

var $cSD7y = parcelRequire("cSD7y");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6Z2mh = parcelRequire("6Z2mh");

var $ctGuD = parcelRequire("ctGuD");
const $499fff83668d7b3b$export$e1fa279356610d18 = (0, $7NszV.createEntry)((0, $eAdnc.servicedeskCustomersV2Route), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        component: (0, $cSD7y.componentWithFG)('jsm_customers_directory_page_for_all', (0, $ctGuD.ServiceDeskContacts), (0, $ctGuD.ServiceDeskCustomersV2)),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ctGuD.LazyServicedeskCustomersV2)
        ],
        perfMetricKey: 'jsm-customers-component-load',
        ufoName: 'jsm-customers-component-load',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $cEOhb.AsyncDirectoryNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        }
    }));

});
parcelRegister("eAdnc", function(module, exports) {

$parcel$export(module.exports, "servicedeskCustomersV2Route", () => $3bc65f8e809f9f4e$export$89e9e350610ee31e);
const $3bc65f8e809f9f4e$export$89e9e350610ee31e = {
    name: 'servicedesk-customers-v2',
    path: '/jira/servicedesk/projects/:projectKey/customers',
    exact: true
};

});


parcelRegister("j0BAb", function(module, exports) {

$parcel$export(module.exports, "projectServiceDeskRouteEntry", () => $3053f9214c133ac3$export$8810bfd4f6a0eb22);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $7MCPm = parcelRequire("7MCPm");

var $ludxj = parcelRequire("ludxj");

var $6Z2mh = parcelRequire("6Z2mh");
const $3053f9214c133ac3$export$8810bfd4f6a0eb22 = (0, $7NszV.createEntry)((0, $ludxj.projectServiceDeskRoute), ()=>({
        group: 'servicedesk',
        isRedirect: true,
        component: (0, $7MCPm.RedirectToLastVisitedProjectPage),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});

parcelRegister("lYrmE", function(module, exports) {

$parcel$export(module.exports, "servicedeskGettingStartedRouteEntry", () => $1512d8f7329a67e2$export$e4e0491275df7c2d);

var $lkFvK = parcelRequire("lkFvK");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $ggg5j = parcelRequire("ggg5j");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $k8jl5 = parcelRequire("k8jl5");

var $5lsNZ = parcelRequire("5lsNZ");

var $5nEM1 = parcelRequire("5nEM1");

var $6Z2mh = parcelRequire("6Z2mh");

var $jm3iE = parcelRequire("jm3iE");

var $d1gXy = parcelRequire("d1gXy");
const $1512d8f7329a67e2$var$gettingStartedPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $d1gXy.gettingStartedEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $1512d8f7329a67e2$export$e4e0491275df7c2d = (0, $7NszV.createEntry)((0, $5nEM1.servicedeskGettingStartedRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        perfMetricKey: 'servicedesk-getting-started-page-load',
        skeleton: (0, $jm3iE.GettingStartedPageSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $k8jl5.servicedeskIssueTypesResource)
        ],
        entryPoint () {
            return (0, $4R6GH.fg)('gsp_production_rollout') ? $1512d8f7329a67e2$var$gettingStartedPageEntryPoint : undefined;
        },
        component: (0, $5lsNZ.default)
    }));

});
parcelRegister("k8jl5", function(module, exports) {

$parcel$export(module.exports, "servicedeskIssueTypesResource", () => $8b723afc89fdf36c$export$191ce50629f40dbe);

var $2M1hQ = parcelRequire("2M1hQ");


const $8b723afc89fdf36c$var$getDataLoader = ()=>(parcelRequire("8Yxr9"));
const $8b723afc89fdf36c$export$191ce50629f40dbe = (0, $2M1hQ.createResource)({
    type: (0, $30e9f90f7be7696a$export$1ed713fe52212251),
    getKey: ({ match: { params: params } })=>params.projectKey || '',
    getDataLoader: $8b723afc89fdf36c$var$getDataLoader
});

});
const $30e9f90f7be7696a$export$1ed713fe52212251 = 'SERVICEDESK_ISSUE_TYPES';

parcelRegister("8Yxr9", function(module, exports) {

let $688ddd2e977b64e1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $688ddd2e977b64e1$var$load("kVX56"),
    $688ddd2e977b64e1$var$load("bSrZ5")
]).then(()=>parcelRequire('lWPKX'));

});


parcelRegister("5nEM1", function(module, exports) {

$parcel$export(module.exports, "servicedeskGettingStartedRoute", () => $eed17dbc1c65d2ba$export$165249c1c8f2e713);
const $eed17dbc1c65d2ba$export$165249c1c8f2e713 = {
    name: 'servicedesk-getting-started-page',
    path: '/jira/servicedesk/projects/:projectKey/getting-started',
    exact: true
};

});

parcelRegister("jm3iE", function(module, exports) {

$parcel$export(module.exports, "GettingStartedPageSkeleton", () => $562ac3cd506226fa$export$525669daa9599ec);
/* GettingStartedPageSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $eGwD4 = parcelRequire("eGwD4");
const $562ac3cd506226fa$var$customCssStyles = null;
const $562ac3cd506226fa$export$525669daa9599ec = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eGwD4))),
        className: (0, $bwpsq.default)([
            "_rcuj1wug _o81c1wug _1l6u1wug _149m1wug _701wukw8 _9qarbrur"
        ])
    });

});
parcelRegister("eGwD4", function(module, exports) {
module.exports = new URL("getting-started-page-app-skeleton.tpl.b9c0d034.svg", import.meta.url).toString();

});


parcelRegister("d1gXy", function(module, exports) {

$parcel$export(module.exports, "gettingStartedEntryPoint", () => $7b51534336e501eb$export$a91a58d8bb93ad8e);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $7b51534336e501eb$export$a91a58d8bb93ad8e = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("gDRgW")), {
        moduleId: "99c912b0"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("gDRgW", function(module, exports) {

let $c1d99c9d462a1d65$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c1d99c9d462a1d65$var$load("fliVL"),
    $c1d99c9d462a1d65$var$load("3o8b3")
]).then(()=>parcelRequire('8Xvm1'));

});



parcelRegister("awOZa", function(module, exports) {

$parcel$export(module.exports, "servicedeskItsmSampleSpaceRouteEntry", () => $e773d085694b29f0$export$61ad481262acd4e6);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $kEEAb = parcelRequire("kEEAb");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $e773d085694b29f0$var$LazyItsmSampleSpace = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("5sy8Z")), {
    moduleId: "./src/packages/spa-apps/servicedesk/itsm-sample-space/src/index.tsx"
});
const $e773d085694b29f0$var$ItsmSampleSpace = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e773d085694b29f0$var$LazyItsmSampleSpace,
        pageId: "spa-apps/servicedesk/itsm-sample-space",
        shouldShowSpinner: true
    });
const $e773d085694b29f0$export$61ad481262acd4e6 = (0, $7NszV.createEntry)((0, $kEEAb.servicedeskItsmSampleSpaceRoute), ()=>({
        group: 'servicedesk',
        isRedirect: true,
        component: $e773d085694b29f0$var$ItsmSampleSpace,
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $e773d085694b29f0$var$LazyItsmSampleSpace
        ],
        perfMetricKey: 'jsm-sample-space-landing-page',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).ITSM_SAMPLE_SPACE,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).ITSM_SAMPLE_SPACE),
                teamName: 'itops-mithril'
            }
        }
    }));

});
parcelRegister("kEEAb", function(module, exports) {

$parcel$export(module.exports, "servicedeskItsmSampleSpaceRoute", () => $d8477253737ee5ba$export$5bc288fedb880892);
const $d8477253737ee5ba$export$5bc288fedb880892 = {
    name: 'servicedesk-itsm-sample-space',
    path: '/jira/servicedesk/itsm-sample-space',
    exact: true
};

});

parcelRegister("5sy8Z", function(module, exports) {

let $3f9a0d8c19c06851$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3f9a0d8c19c06851$var$load("2sbnI").then(()=>parcelRequire('5eXru'));

});


parcelRegister("eoIQt", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubAllArticlesRouteEntry", () => $a340d83cd9968ce2$export$5b55251966102ec);

var $ffza4 = parcelRequire("ffza4");

var $jIAHH = parcelRequire("jIAHH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $2qMD5 = parcelRequire("2qMD5");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $fThMI = parcelRequire("fThMI");

var $bbBli = parcelRequire("bbBli");
const $a340d83cd9968ce2$export$5b55251966102ec = (0, $7NszV.createEntry)((0, $2qMD5.knowledgeHubAllArticlesRoute), ()=>({
        group: 'servicedesk',
        component: (0, $bbBli.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $jIAHH.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bbBli.LazyServicedeskKnowledgeHubBrowseAllArticles)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_BROWSE_ARTICLES,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_BROWSE_ARTICLES),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("jIAHH", function(module, exports) {

$parcel$export(module.exports, "AsyncKbNav", () => $22359123c06ce2f3$export$223f755b7799fe02);

var $5uXOq = parcelRequire("5uXOq");

var $hYRTO = parcelRequire("hYRTO");

var $b71gk = parcelRequire("b71gk");

var $kxZPA = parcelRequire("kxZPA");

const $22359123c06ce2f3$var$LazyKbNav = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("cPLH9")).then(({ KnowledgeBaseNav: KnowledgeBaseNav })=>KnowledgeBaseNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/knowledge-base/src/ui/index.tsx"
});
const $22359123c06ce2f3$export$223f755b7799fe02 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "horizontal-jsm-kb-nav",
        packageName: "jira-horizontal-nav-jsm-knowledge-base"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYRTO.default), {
        name: "horizontal-jsm-kb-nav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($22359123c06ce2f3$var$LazyKbNav, null)));
};

});
parcelRegister("cPLH9", function(module, exports) {

let $957f3eac6085a22a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $957f3eac6085a22a$var$load("1uDyI").then(()=>parcelRequire('gaKUF'));

});


parcelRegister("2qMD5", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubAllArticlesRoute", () => $0168703d3ad589b1$export$20e57a83f181da7b);
const $0168703d3ad589b1$export$20e57a83f181da7b = {
    name: 'knowledge-hub-all-articles',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/browse/page/:pageId'
};

});

parcelRegister("fThMI", function(module, exports) {

$parcel$export(module.exports, "getKnowledgeHubResources", () => $885fe963549c17bc$export$5421e48e728c449f);

var $bjZiV = parcelRequire("bjZiV");

var $fpjJX = parcelRequire("fpjJX");
const $885fe963549c17bc$export$5421e48e728c449f = ()=>[
        ...(0, $fpjJX.getServicedeskPageContextResources)(),
        (0, $bjZiV.kbConfluenceContextResource)
    ];

});

parcelRegister("bbBli", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKnowledgeHubBrowseAllArticles", () => $7877fae2c22be3a0$export$c73ba7e80a805fb2);
$parcel$export(module.exports, "default", () => $7877fae2c22be3a0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $7877fae2c22be3a0$export$c73ba7e80a805fb2 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("3nAwU"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-browse-all-articles/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7877fae2c22be3a0$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $7877fae2c22be3a0$export$c73ba7e80a805fb2,
        pageId: "spa-apps/servicedesk/knowledge-hub/browse-all-articles",
        shouldShowSpinner: true
    });

});
parcelRegister("3nAwU", function(module, exports) {

let $275fdb286b88be0d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $275fdb286b88be0d$var$load("ffQaD"),
    $275fdb286b88be0d$var$load("kvRbA"),
    $275fdb286b88be0d$var$load("fliVL"),
    $275fdb286b88be0d$var$load("blv8l")
]).then(()=>parcelRequire('4uyp4'));

});



parcelRegister("kTgg2", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubArticleEmbedEditorRouteEntry", () => $a9203ca39324e16d$export$513e093ef937dc06);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $lBeuR = parcelRequire("lBeuR");

var $6Z2mh = parcelRequire("6Z2mh");

var $fThMI = parcelRequire("fThMI");

var $aNjVS = parcelRequire("aNjVS");
const $a9203ca39324e16d$export$513e093ef937dc06 = (0, $7NszV.createEntry)((0, $lBeuR.knowledgeHubArticleEmbedEditorRoute), ()=>({
        group: 'servicedesk',
        component: (0, $aNjVS.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aNjVS.LazyServiceDeskKnowledgeArticleEmbedEditor)
        ],
        perfMetricKey: 'service-management.knowledge.ep-editor'
    }));

});
parcelRegister("lBeuR", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubArticleEmbedEditorRoute", () => $e0250c214f5345c0$export$bd512c426b095693);
const $e0250c214f5345c0$export$bd512c426b095693 = {
    name: 'kb-article-embed-editor',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/space/:spaceKey/articles/:articleId/edit',
    query: [
        'draftShareId?',
        'topicId?'
    ]
};

});

parcelRegister("aNjVS", function(module, exports) {

$parcel$export(module.exports, "LazyServiceDeskKnowledgeArticleEmbedEditor", () => $398a28a595927246$export$35c6d2a033ef4c42);
$parcel$export(module.exports, "default", () => $398a28a595927246$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $398a28a595927246$export$35c6d2a033ef4c42 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("4o4Nf"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-article-embed-editor/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$398a28a595927246$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $398a28a595927246$export$35c6d2a033ef4c42,
        pageId: "knowledge-article-embed-editor",
        shouldShowSpinner: true
    });

});
parcelRegister("4o4Nf", function(module, exports) {

let $331d1f3196a75a77$var$load = (parcelRequire("28QjX"))(4);
module.exports = $331d1f3196a75a77$var$load("5D8Fc").then(()=>parcelRequire('l54tv'));

});



parcelRegister("agsO7", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubArticleInCategoryRouteEntry", () => $def4faef06d1a61c$export$a67199ebb12b0f7f);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $4BJB2 = parcelRequire("4BJB2");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $fThMI = parcelRequire("fThMI");

var $809cs = parcelRequire("809cs");
const $def4faef06d1a61c$export$a67199ebb12b0f7f = (0, $7NszV.createEntry)((0, $4BJB2.knowledgeHubArticleInCategoryRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.knowledge.article',
        component: (0, $809cs.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $809cs.LazyServicedeskKnowledgeHubViewArticle)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_VIEW_ARTICLE,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_VIEW_ARTICLE),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("4BJB2", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubArticleInCategoryRoute", () => $cafdb26099846497$export$3afe8482ce820835);
const $cafdb26099846497$export$3afe8482ce820835 = {
    name: 'knowledge-hub-article-in-category',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId/articles/:articleId'
};

});

parcelRegister("809cs", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKnowledgeHubViewArticle", () => $8c5dbaffda117c43$export$efd0ec49853aa81);
$parcel$export(module.exports, "default", () => $8c5dbaffda117c43$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $8c5dbaffda117c43$export$efd0ec49853aa81 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("8D4Zf"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-view-article/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8c5dbaffda117c43$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8c5dbaffda117c43$export$efd0ec49853aa81,
        pageId: "spa-apps/servicedesk/knowledge-hub/view-article",
        shouldShowSpinner: true
    });

});
parcelRegister("8D4Zf", function(module, exports) {

let $6485d5848d0fa743$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6485d5848d0fa743$var$load("75vrF").then(()=>parcelRequire('MNfxH'));

});



parcelRegister("9y8sW", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubBrowseAllArticlesRouteEntry", () => $4c224bc59177653b$export$de40c949b963d9e);

var $ffza4 = parcelRequire("ffza4");

var $jIAHH = parcelRequire("jIAHH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $coVHe = parcelRequire("coVHe");

var $gNStA = parcelRequire("gNStA");

var $9D0RM = parcelRequire("9D0RM");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $c04PQ = parcelRequire("c04PQ");

var $fThMI = parcelRequire("fThMI");

var $bbBli = parcelRequire("bbBli");
const $4c224bc59177653b$export$de40c949b963d9e = (0, $7NszV.createEntry)((0, $9D0RM.knowledgeHubBrowseAllArticlesRoute), ()=>({
        group: 'servicedesk',
        component: (0, $bbBli.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $jIAHH.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>!(0, $c04PQ.isFedRamp)(), (0, $coVHe.virtualAgentKnowledgebaseTouchpointResource))
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bbBli.LazyServicedeskKnowledgeHubBrowseAllArticles)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_BROWSE_ARTICLES,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_BROWSE_ARTICLES),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("coVHe", function(module, exports) {

$parcel$export(module.exports, "virtualAgentKnowledgebaseTouchpointResource", () => $b5eb4da6bb86684f$export$1b798e6122168cca);

var $4R6GH = parcelRequire("4R6GH");

var $ao2h1 = parcelRequire("ao2h1");

var $eCMpj = parcelRequire("eCMpj");
const $b5eb4da6bb86684f$export$1b798e6122168cca = (0, $ao2h1.createRelayResource)({
    type: 'SERVICEDESK_VIRTUAL_AGENT_KNOWLEDGE_BASE_TOUCHPOINT',
    isBrowserOnly: true,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $eCMpj.default),
            variables: {
                cloudId: tenantContext.cloudId,
                key: match.params.projectKey || '',
                checkForAiEnabledFF: (0, $4R6GH.fg)('require_ai_enabled_for_jsm_virtual_agent')
            }
        })
});

});
parcelRegister("eCMpj", function(module, exports) {

$parcel$export(module.exports, "default", () => $0111b96d105a115c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d286ede3f2edeee466a0bd65055c253b>>
 * @relayHash 7555a82a51148c607a64f1ab7402dfed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a066b2d28ec980806bb63d852e0abfc11a1a1a5c90904f798db2d9030dc7252b
const $0111b96d105a115c$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a066b2d28ec980806bb63d852e0abfc11a1a1a5c90904f798db2d9030dc7252b",
        "metadata": {},
        "name": "mainVirtualServiceAgentCtaCardQuery",
        "operationKind": "query",
        "text": null
    }
};
var $0111b96d105a115c$export$2e2bcd8739ae039 = $0111b96d105a115c$var$node;

});


parcelRegister("9D0RM", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubBrowseAllArticlesRoute", () => $ef3c5487d473c383$export$c8e99e3434791c0e);
const $ef3c5487d473c383$export$c8e99e3434791c0e = {
    name: 'knowledge-hub-browse-all-articles',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/articles',
    exact: true
};

});


parcelRegister("825dq", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubBrowseAllCategoriesRouteEntry", () => $578b57d26acf701a$export$dd6c99863524ee59);

var $ffza4 = parcelRequire("ffza4");

var $jIAHH = parcelRequire("jIAHH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $90PHJ = parcelRequire("90PHJ");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $fThMI = parcelRequire("fThMI");

var $fDsbI = parcelRequire("fDsbI");
const $578b57d26acf701a$export$dd6c99863524ee59 = (0, $7NszV.createEntry)((0, $90PHJ.knowledgeHubBrowseAllCategoriesRoute), ()=>({
        group: 'servicedesk',
        component: (0, $fDsbI.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $jIAHH.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fDsbI.LazyServicedeskKnowledgeHubBrowseAllCategories)
        ],
        perfMetricKey: 'service-management.kb-categories',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_BROWSE_CATEGORIES,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_BROWSE_CATEGORIES),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("90PHJ", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubBrowseAllCategoriesRoute", () => $74299e4842369ef4$export$256f841794b3f077);
const $74299e4842369ef4$export$256f841794b3f077 = {
    name: 'knowledge-hub-browse-all-categories',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/categories',
    exact: true
};

});

parcelRegister("fDsbI", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKnowledgeHubBrowseAllCategories", () => $0ed31e41bd08d12a$export$a488cba75f18ade8);
$parcel$export(module.exports, "default", () => $0ed31e41bd08d12a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $0ed31e41bd08d12a$export$a488cba75f18ade8 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("5Nh1B"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-browse-all-categories/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0ed31e41bd08d12a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $0ed31e41bd08d12a$export$a488cba75f18ade8,
        pageId: "spa-apps/servicedesk/knowledge-hub/browse-all-categories",
        shouldShowSpinner: true
    });

});
parcelRegister("5Nh1B", function(module, exports) {

let $437ebc236310cfdb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $437ebc236310cfdb$var$load("7HMQe").then(()=>parcelRequire('dseQM'));

});



parcelRegister("h8swE", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubBrowseViewArticleRouteEntry", () => $4bb5aab980a1ec0f$export$abb9cdffbf5c943b);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $8p1m6 = parcelRequire("8p1m6");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $fThMI = parcelRequire("fThMI");

var $809cs = parcelRequire("809cs");
const $4bb5aab980a1ec0f$export$abb9cdffbf5c943b = (0, $7NszV.createEntry)((0, $8p1m6.knowledgeHubBrowseViewArticleRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.knowledge.article',
        component: (0, $809cs.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $809cs.LazyServicedeskKnowledgeHubViewArticle)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_VIEW_ARTICLE,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_VIEW_ARTICLE),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("8p1m6", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubBrowseViewArticleRoute", () => $43d5800a4cfdec2f$export$ef8a9ec2979d1b10);
const $43d5800a4cfdec2f$export$ef8a9ec2979d1b10 = {
    name: 'knowledge-hub-browse-view-article',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/articles/:articleId'
};

});


parcelRegister("gGQIR", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubCategoryPageRouteEntry", () => $298d9707a87dc987$export$464b24032c2aeb02);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $8WB8S = parcelRequire("8WB8S");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $fThMI = parcelRequire("fThMI");

var $7EGTo = parcelRequire("7EGTo");
const $298d9707a87dc987$export$464b24032c2aeb02 = (0, $7NszV.createEntry)((0, $8WB8S.knowledgeHubCategoryPageRoute), ()=>({
        group: 'servicedesk',
        component: (0, $7EGTo.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7EGTo.LazyServicedeskKnowledgeHubCategory)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_CATEGORY,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_CATEGORY),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("8WB8S", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubCategoryPageRoute", () => $4f0b06054e994db5$export$79fb48a07e43639a);
const $4f0b06054e994db5$export$79fb48a07e43639a = {
    name: 'knowledge-hub-category-page',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId/browse/page/:pageId'
};

});

parcelRegister("7EGTo", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKnowledgeHubCategory", () => $cbedf43cff0d751d$export$c01a896b8d33aa9c);
$parcel$export(module.exports, "default", () => $cbedf43cff0d751d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $cbedf43cff0d751d$export$c01a896b8d33aa9c = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("d5eX1"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-category/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cbedf43cff0d751d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cbedf43cff0d751d$export$c01a896b8d33aa9c,
        pageId: "spa-apps/servicedesk/knowledge-hub/category",
        shouldShowSpinner: true
    });

});
parcelRegister("d5eX1", function(module, exports) {

let $986756eebe73f0f7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $986756eebe73f0f7$var$load("4oq8D").then(()=>parcelRequire('lE3ki'));

});



parcelRegister("01hnS", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubCategoryRouteEntry", () => $2e1862f21e7b949b$export$416d7b87b4f3205e);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $k4nQf = parcelRequire("k4nQf");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $fThMI = parcelRequire("fThMI");

var $7EGTo = parcelRequire("7EGTo");
const $2e1862f21e7b949b$export$416d7b87b4f3205e = (0, $7NszV.createEntry)((0, $k4nQf.knowledgeHubCategoryRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.knowledge.category',
        component: (0, $7EGTo.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7EGTo.LazyServicedeskKnowledgeHubCategory)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_CATEGORY,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_CATEGORY),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("k4nQf", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubCategoryRoute", () => $874cf8128fc31da0$export$69ed5b0214ea6ee5);
const $874cf8128fc31da0$export$69ed5b0214ea6ee5 = {
    name: 'knowledge-hub-category',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId'
};

});


parcelRegister("8jDeK", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubDraftsRouteEntry", () => $9ba3413d02e7079e$export$4da743c0d13c2cfc);

var $ffza4 = parcelRequire("ffza4");

var $jIAHH = parcelRequire("jIAHH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $bltfg = parcelRequire("bltfg");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $fThMI = parcelRequire("fThMI");

var $2KDj2 = parcelRequire("2KDj2");
const $9ba3413d02e7079e$export$4da743c0d13c2cfc = (0, $7NszV.createEntry)((0, $bltfg.knowledgeHubDraftsRoute), ()=>({
        group: 'servicedesk',
        component: (0, $2KDj2.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $jIAHH.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $2KDj2.LazyServicedeskKnowledgeHubDrafts)
        ],
        perfMetricKey: 'service-management.kb-drafts',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_DRAFTS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_DRAFTS),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("bltfg", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubDraftsRoute", () => $9a661013d8f5290f$export$670f3b59aa55b7ae);
const $9a661013d8f5290f$export$670f3b59aa55b7ae = {
    name: 'knowledge-hub-drafts',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/drafts',
    exact: true
};

});

parcelRegister("2KDj2", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKnowledgeHubDrafts", () => $e2e95eba21898c94$export$53decb9d1eb60aed);
$parcel$export(module.exports, "default", () => $e2e95eba21898c94$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $e2e95eba21898c94$export$53decb9d1eb60aed = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("cxABR"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-drafts/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e2e95eba21898c94$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e2e95eba21898c94$export$53decb9d1eb60aed,
        pageId: "spa-apps/servicedesk/knowledge-hub/drafts",
        shouldShowSpinner: true
    });

});
parcelRegister("cxABR", function(module, exports) {

let $9214f70393226531$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9214f70393226531$var$load("fliVL"),
    $9214f70393226531$var$load("2BkWv")
]).then(()=>parcelRequire('kl4T5'));

});



parcelRegister("64Uyh", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubLandingRouteEntry", () => $cd1258ca8f7bcdbf$export$671687d85e096e5b);

var $ffza4 = parcelRequire("ffza4");

var $jIAHH = parcelRequire("jIAHH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $bMJcR = parcelRequire("bMJcR");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $fThMI = parcelRequire("fThMI");

var $fWD3P = parcelRequire("fWD3P");
const $cd1258ca8f7bcdbf$export$671687d85e096e5b = (0, $7NszV.createEntry)((0, $bMJcR.knowledgeHubLandingRoute), ()=>({
        group: 'servicedesk',
        component: (0, $fWD3P.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $jIAHH.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fWD3P.LazyServicedeskKnowledgeHubLanding)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_LANDING,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_LANDING),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("bMJcR", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubLandingRoute", () => $5a3037062b8f539c$export$239eaf6a202e0f54);
const $5a3037062b8f539c$export$239eaf6a202e0f54 = {
    name: 'knowledge-hub-landing',
    path: '/jira/servicedesk/projects/:projectKey/knowledge',
    exact: true
};

});

parcelRegister("fWD3P", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKnowledgeHubLanding", () => $f59132c22330e6a8$export$f1266a588cfc310b);
$parcel$export(module.exports, "default", () => $f59132c22330e6a8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $f59132c22330e6a8$export$f1266a588cfc310b = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("1Zkwy")), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-landing/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f59132c22330e6a8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f59132c22330e6a8$export$f1266a588cfc310b,
        pageId: "spa-apps/servicedesk/knowledge-hub/landing-page",
        shouldShowSpinner: true
    });

});
parcelRegister("1Zkwy", function(module, exports) {

let $172b689f35489cc1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $172b689f35489cc1$var$load("fg7LP").then(()=>parcelRequire('baJ3W'));

});



parcelRegister("1T4J3", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubSearchRouteEntry", () => $1f2e00b6e54dbec2$export$49337a3cc2431ae5);

var $ffza4 = parcelRequire("ffza4");

var $jIAHH = parcelRequire("jIAHH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $5PTSS = parcelRequire("5PTSS");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $fThMI = parcelRequire("fThMI");

var $809cs = parcelRequire("809cs");
const $1f2e00b6e54dbec2$export$49337a3cc2431ae5 = (0, $7NszV.createEntry)((0, $5PTSS.knowledgeHubSearchRoute), ()=>({
        group: 'servicedesk',
        component: (0, $809cs.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $jIAHH.AsyncKbNav),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $809cs.LazyServicedeskKnowledgeHubViewArticle)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_VIEW_ARTICLE,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_VIEW_ARTICLE),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("5PTSS", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubSearchRoute", () => $27dc0fd67ac82331$export$a47c36fb081b544d);
const $27dc0fd67ac82331$export$a47c36fb081b544d = {
    name: 'knowledge-hub-search',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/search/articles/:articleId'
};

});


parcelRegister("8hATp", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubSetupRouteEntry", () => $fa00eaf494d4bfab$export$b220f8194ee7c231);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $5jG9Z = parcelRequire("5jG9Z");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $fThMI = parcelRequire("fThMI");

var $1iNof = parcelRequire("1iNof");
const $fa00eaf494d4bfab$export$b220f8194ee7c231 = (0, $7NszV.createEntry)((0, $5jG9Z.knowledgeHubSetupRoute), ()=>({
        group: 'servicedesk',
        component: (0, $1iNof.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $1iNof.LazyServicedeskKnowledgeHubSetup)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_SETUP,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_SETUP),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("5jG9Z", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubSetupRoute", () => $598bde1f568a466c$export$f20770545704547d);
const $598bde1f568a466c$export$f20770545704547d = {
    name: 'knowledge-hub-setup',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/setup'
};

});

parcelRegister("1iNof", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKnowledgeHubSetup", () => $4cd10b3eae0d5ed2$export$6c08040d2dc71e43);
$parcel$export(module.exports, "default", () => $4cd10b3eae0d5ed2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $4cd10b3eae0d5ed2$export$6c08040d2dc71e43 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("3KWG5")), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-setup/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4cd10b3eae0d5ed2$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $4cd10b3eae0d5ed2$export$6c08040d2dc71e43,
        pageId: "spa-apps/servicedesk/knowledge-hub/setup",
        shouldShowSpinner: true
    });

});
parcelRegister("3KWG5", function(module, exports) {

let $2bc32f300c741c0f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2bc32f300c741c0f$var$load("4raVQ").then(()=>parcelRequire('gBJGI'));

});



parcelRegister("lrPAp", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubSuggestedArticlesRouteEntry", () => $0632a084fe67a48e$export$6a7974939bde7d37);

var $ffza4 = parcelRequire("ffza4");

var $jIAHH = parcelRequire("jIAHH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $kO4Z1 = parcelRequire("kO4Z1");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $fThMI = parcelRequire("fThMI");

var $hnJOJ = parcelRequire("hnJOJ");
const $0632a084fe67a48e$export$6a7974939bde7d37 = (0, $7NszV.createEntry)((0, $kO4Z1.knowledgeHubSuggestedArticlesRoute), ()=>({
        group: 'servicedesk',
        component: (0, $hnJOJ.ServiceDeskKnowledgeHubSuggestedArticles),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $jIAHH.AsyncKbNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fThMI.getKnowledgeHubResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hnJOJ.LazyServicedeskKnowledgeHubSuggestedArticles)
        ],
        perfMetricKey: 'service-management.kb-suggested-articles',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).KB_SUGGESTED_ARTICLES,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).KB_SUGGESTED_ARTICLES),
                teamName: 'jsm-nebula'
            }
        }
    }));

});
parcelRegister("kO4Z1", function(module, exports) {

$parcel$export(module.exports, "knowledgeHubSuggestedArticlesRoute", () => $8f32a5b26dce9533$export$54edf5cef1c6b21b);
const $8f32a5b26dce9533$export$54edf5cef1c6b21b = {
    name: 'knowledge-hub-suggested-topics',
    path: '/jira/servicedesk/projects/:projectKey/knowledge/suggested-topics',
    exact: true
};

});

parcelRegister("hnJOJ", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKnowledgeHubSuggestedArticles", () => $70c4d3c688caba8c$export$aee7d96c2ee4c388);
$parcel$export(module.exports, "ServiceDeskKnowledgeHubSuggestedArticles", () => $70c4d3c688caba8c$export$ee4623542ebd573e);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $2WqFA = parcelRequire("2WqFA");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $70c4d3c688caba8c$export$aee7d96c2ee4c388 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("5lY7i"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-suggested-articles/src/index.tsx"
});
const $70c4d3c688caba8c$export$ee4623542ebd573e = ()=>{
    const { data: isAdminHubAIEnabled, loading: loading, error: error, fetchAIEnablement: fetchAIEnablement } = (0, $2WqFA.default)('jira-servicedesk');
    const showSuggestedTopics = !loading && !error && isAdminHubAIEnabled && (0, $4R6GH.fg)('jsm-suggested-articles-in-kb');
    (0, $5uXOq.useEffect)(()=>{
        (0, $4R6GH.fg)('jsm-suggested-articles-in-kb') && fetchAIEnablement();
    }, [
        fetchAIEnablement
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, showSuggestedTopics && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $70c4d3c688caba8c$export$aee7d96c2ee4c388,
        pageId: "spa-apps/servicedesk/knowledge-hub/suggested-articles",
        shouldShowSpinner: true
    }));
};

});
parcelRegister("2WqFA", function(module, exports) {

$parcel$export(module.exports, "default", () => $18bf020f3f366501$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $29jfS = parcelRequire("29jfS");
const $18bf020f3f366501$var$useIsAdminHubAIEnabled = (jiraProduct, version)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isAdminHubAiToggleEnabled, setIsAdminHubAiToggleEnabled] = (0, $5uXOq.useState)(null);
    const [loading, setLoading] = (0, $5uXOq.useState)(true);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const fetchData = (0, $5uXOq.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        try {
            const response = await (0, $29jfS.fetchAiEnablement)(jiraProduct, version);
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchAiEnablementStatus succeeded');
            setIsAdminHubAiToggleEnabled(response.isEnabled);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setError(err);
            (0, $jcw0u.default)({
                error: err,
                meta: {
                    id: 'fetchAiEnablementStatus failed'
                }
            });
        } finally{
            setLoading(false);
        }
    }, [
        createAnalyticsEvent,
        jiraProduct,
        version
    ]);
    return {
        data: isAdminHubAiToggleEnabled,
        loading: loading,
        error: error,
        fetchAIEnablement: fetchData
    };
};
var $18bf020f3f366501$export$2e2bcd8739ae039 = $18bf020f3f366501$var$useIsAdminHubAIEnabled;

});
parcelRegister("29jfS", function(module, exports) {

$parcel$export(module.exports, "fetchAiEnablement", () => $f8e2a461a4c2e420$export$ad4105850d0ce824);

var $7f4tk = parcelRequire("7f4tk");
const $f8e2a461a4c2e420$export$2171a423b572256a = (jiraProduct, version = '1')=>`/rest/api/${version}/aiconfig/ai-enabled/${jiraProduct}`;
const $f8e2a461a4c2e420$export$ad4105850d0ce824 = (jiraProduct, version = '1')=>{
    const url = $f8e2a461a4c2e420$export$2171a423b572256a(jiraProduct, version);
    return (0, $7f4tk.default)(url, {
        method: 'GET'
    });
};

});


parcelRegister("5lY7i", function(module, exports) {

let $3e5d8bd6ae283e17$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3e5d8bd6ae283e17$var$load("hNNyi").then(()=>parcelRequire('hY7nq'));

});



parcelRegister("ZVu1m", function(module, exports) {

$parcel$export(module.exports, "notificationLogsRouteEntry", () => $8c16ad2f5cbcb35f$export$20ab3a955246df95);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $joRT8 = parcelRequire("joRT8");

var $6Z2mh = parcelRequire("6Z2mh");

var $1RPRU = parcelRequire("1RPRU");
const $8c16ad2f5cbcb35f$export$20ab3a955246df95 = (0, $7NszV.createEntry)((0, $joRT8.notificationLogsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        component: (0, $1RPRU.NotificationLogs),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $1RPRU.LazyNotificationLogs)
        ],
        perfMetricKey: 'jsm-notification-logs-component-load'
    }));

});
parcelRegister("joRT8", function(module, exports) {

$parcel$export(module.exports, "notificationLogsRoute", () => $7c61830ec505ffc9$export$c947c80f138bc137);
const $7c61830ec505ffc9$export$c947c80f138bc137 = {
    name: 'notification-logs',
    path: '/jira/servicedesk/projects/:projectKey/notification-logs',
    exact: true
};

});

parcelRegister("1RPRU", function(module, exports) {

$parcel$export(module.exports, "LazyNotificationLogs", () => $ce165317fbb6ef87$export$69cba5247233f8bc);
$parcel$export(module.exports, "NotificationLogs", () => $ce165317fbb6ef87$export$1139895a5af7252e);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $ce165317fbb6ef87$export$69cba5247233f8bc = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("iGIpL"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/notification-logs/src/index.tsx"
});
const $ce165317fbb6ef87$export$1139895a5af7252e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ce165317fbb6ef87$export$69cba5247233f8bc,
        pageId: "spa-apps/servicedesk/notification-logs",
        shouldShowSpinner: true
    });

});
parcelRegister("iGIpL", function(module, exports) {

let $d9ae9a059e4be563$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d9ae9a059e4be563$var$load("g0ZxT").then(()=>parcelRequire('9feT0'));

});



parcelRegister("l1PfI", function(module, exports) {

$parcel$export(module.exports, "servicedeskOncallScheduleRouteEntry", () => $010b24cf318456cc$export$36994f6fd22da90e);

var $ffza4 = parcelRequire("ffza4");

var $1cxvE = parcelRequire("1cxvE");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $9kQCa = parcelRequire("9kQCa");

var $6Z2mh = parcelRequire("6Z2mh");

var $cysbi = parcelRequire("cysbi");
const $010b24cf318456cc$export$36994f6fd22da90e = (0, $7NszV.createEntry)((0, $9kQCa.servicedeskOncallScheduleRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.on-call-schedule',
        component: (0, $cysbi.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $1cxvE.AsyncJSMOperationsHorizontalNav),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cysbi.LazyServicedeskOpsgenieSchedule),
            (0, $1cxvE.LazyJSMOperationsHorizontalNav)
        ]
    }));

});
parcelRegister("9kQCa", function(module, exports) {

$parcel$export(module.exports, "servicedeskOncallScheduleRoute", () => $993b636c10d5f63c$export$740e6e5e982b48a9);
const $993b636c10d5f63c$export$740e6e5e982b48a9 = {
    name: 'servicedesk-oncall-schedule',
    path: '/jira/servicedesk/projects/:projectKey/on-call-schedule',
    exact: true
};

});

parcelRegister("cysbi", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskOpsgenieSchedule", () => $816d970487a82139$export$e8392650fdcd92d5);
$parcel$export(module.exports, "default", () => $816d970487a82139$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $816d970487a82139$export$e8392650fdcd92d5 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("f2nGu")), {
    moduleId: "./src/packages/spa-apps/servicedesk/opsgenie-schedule/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$816d970487a82139$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $816d970487a82139$export$e8392650fdcd92d5,
        pageId: "spa-apps/servicedesk/opsgenie-schedule",
        shouldShowSpinner: true
    });

});
parcelRegister("f2nGu", function(module, exports) {

let $af296a271e0eedf7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $af296a271e0eedf7$var$load("9yISX").then(()=>parcelRequire('gjKCT'));

});



parcelRegister("iuWOh", function(module, exports) {

$parcel$export(module.exports, "servicedeskOrganizationV2RouteEntry", () => $5928d6539d724a6d$export$1b6ea96c35c2472c);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $38BXB = parcelRequire("38BXB");

var $7CBZS = parcelRequire("7CBZS");

var $fpjJX = parcelRequire("fpjJX");

var $6x0wo = parcelRequire("6x0wo");

var $hlsv9 = parcelRequire("hlsv9");

var $6Z2mh = parcelRequire("6Z2mh");

var $6gtea = parcelRequire("6gtea");
const $5928d6539d724a6d$export$1b6ea96c35c2472c = (0, $7NszV.createEntry)((0, $hlsv9.servicedeskOrganizationV2Route), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $6x0wo.serviceDeskOrganizationPanelForgeDataResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $7CBZS.productsJsmOrganizationDetailsResource),
            (0, $38BXB.jsmEmailDomainsListResource)
        ],
        component: (0, $6gtea.ServiceDeskOrganizationV2),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6gtea.LazyServicedeskOrganizationV2)
        ],
        perfMetricKey: 'jsm-organizations-component-load'
    }));

});
parcelRegister("6x0wo", function(module, exports) {

$parcel$export(module.exports, "serviceDeskOrganizationPanelForgeDataResource", () => $8bc812ed070bb2a3$export$f3c46a19f3594363);

var $2M1hQ = parcelRequire("2M1hQ");


const $8bc812ed070bb2a3$var$getDataLoader = ()=>(parcelRequire("626yv"));
const $8bc812ed070bb2a3$export$f3c46a19f3594363 = (0, $2M1hQ.createResource)({
    type: (0, $b6a87c89b0762905$export$66d6e1e05866ee2f),
    getKey: ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        return `extension-${projectKey}`;
    },
    getDataLoader: $8bc812ed070bb2a3$var$getDataLoader,
    maxAge: Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});

});
const $b6a87c89b0762905$export$66d6e1e05866ee2f = 'ORGANIZATION_PANEL_FORGE_DATA';

parcelRegister("626yv", function(module, exports) {

let $464803ca0825c621$var$load = (parcelRequire("28QjX"))(4);
module.exports = $464803ca0825c621$var$load("2OoNF").then(()=>parcelRequire('emXcY'));

});


parcelRegister("hlsv9", function(module, exports) {

$parcel$export(module.exports, "servicedeskOrganizationV2Route", () => $0e8ebef5d5d75a55$export$7f878f9aeac61f1e);
const $0e8ebef5d5d75a55$export$7f878f9aeac61f1e = {
    name: 'servicedesk-organization_v2',
    path: '/jira/servicedesk/projects/:projectKey/organization/:organizationId',
    exact: true
};

});

parcelRegister("6gtea", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskOrganizationV2", () => $f3c20d8fbb399193$export$1c7fcdb58f42db03);
$parcel$export(module.exports, "ServiceDeskOrganizationV2", () => $f3c20d8fbb399193$export$5f69663d85db303d);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $f3c20d8fbb399193$export$1c7fcdb58f42db03 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hvTTb"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/organization-v2/src/index.tsx"
});
const $f3c20d8fbb399193$export$5f69663d85db303d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f3c20d8fbb399193$export$1c7fcdb58f42db03,
        pageId: "spa-apps/servicedesk/organization-v2",
        shouldShowSpinner: true
    });

});
parcelRegister("hvTTb", function(module, exports) {

let $cc00af5014bd89de$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cc00af5014bd89de$var$load("15ucL").then(()=>parcelRequire('3BhTj'));

});



parcelRegister("cvYE5", function(module, exports) {

$parcel$export(module.exports, "servicedeskOrganizationDetailsRouteEntry", () => $a8b4c58f96e42722$export$a9452a74fdc4d74f);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $38BXB = parcelRequire("38BXB");

var $7CBZS = parcelRequire("7CBZS");

var $8XgXN = parcelRequire("8XgXN");

var $iTeMQ = parcelRequire("iTeMQ");

var $5tVaj = parcelRequire("5tVaj");

var $e9YVH = parcelRequire("e9YVH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6Z2mh = parcelRequire("6Z2mh");

var $rKFLU = parcelRequire("rKFLU");
const $a8b4c58f96e42722$export$a9452a74fdc4d74f = (0, $7NszV.createEntry)((0, $5tVaj.servicedeskOrganizationDetailsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        component: (0, $rKFLU.ServicedeskOrganizationDetails),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $rKFLU.LazyServicedeskOrganizationDetails)
        ],
        perfMetricKey: 'jsm-organization-details-component-load',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).ORGANIZATION_DETAILS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).ORGANIZATION_DETAILS),
                teamName: 'boysenberry'
            }
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $8XgXN.entitlementsOrganizationQueryResource),
            (0, $iTeMQ.uiOrganizationDetailsPageQueryResource),
            (0, $7CBZS.productsJsmOrganizationDetailsResource),
            (0, $38BXB.jsmEmailDomainsListResource)
        ]
    }));

});
parcelRegister("8XgXN", function(module, exports) {

$parcel$export(module.exports, "entitlementsOrganizationQueryResource", () => $275795ce1e7f33fe$export$fead08d66d56688e);

var $ao2h1 = parcelRequire("ao2h1");

var $9NGHY = parcelRequire("9NGHY");
const $275795ce1e7f33fe$export$fead08d66d56688e = (0, $ao2h1.createRelayResource)({
    type: 'ENTITLEMENTS_ORGANIZATION_QUERY',
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $9NGHY.default),
            variables: {
                organizationId: String(match.params.organizationId),
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("9NGHY", function(module, exports) {

$parcel$export(module.exports, "default", () => $42e659babe89c8d5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5505d7bd1e485943d52683e3e287125b>>
 * @relayHash 4fd7c02cf85ce43ff1f3b2c2885428f1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 01a04225033d1c240e60c2831c34cc958b17cd0c6be52ce6b65c5484adb41a6f
const $42e659babe89c8d5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "organizationId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "organizationId",
            "variableName": "organizationId"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entitlementsOrganizationQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "CustomerServiceProductConnection",
                                    "kind": "LinkedField",
                                    "name": "productConnections",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CustomerServiceProductEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "CustomerServiceProduct",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v3 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "customerService.productConnections.edges"
                                        }
                                    ],
                                    "storageKey": "productConnections(first:1)"
                                },
                                "action": "THROW",
                                "path": "customerService.productConnections"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v4 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "organizationByOrganizationId",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v6 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "customerService.organizationByOrganizationId.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "CustomerServiceEntitlement",
                                                        "kind": "LinkedField",
                                                        "name": "entitlementList",
                                                        "plural": true,
                                                        "selections": [
                                                            v6 /*: any*/ ,
                                                            {
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "includeEntityTypeName",
                                                                        "value": false
                                                                    }
                                                                ],
                                                                "kind": "FragmentSpread",
                                                                "name": "entitlement_servicedeskCustomerServiceEntitlementsCard"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "customerService.organizationByOrganizationId.entitlementList"
                                                },
                                                v7 /*: any*/ 
                                            ],
                                            "type": "CustomerServiceOrganization"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "throwOnQueryError_servicedeskCustomerServiceCommon"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "customerService.organizationByOrganizationId"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "customerService"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entitlementsOrganizationQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "CustomerServiceProductConnection",
                            "kind": "LinkedField",
                            "name": "productConnections",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CustomerServiceProductEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "CustomerServiceProduct",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "productConnections(first:1)"
                        },
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "organizationByOrganizationId",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "concreteType": "CustomerServiceEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlementList",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "CustomerServiceProduct",
                                                    "kind": "LinkedField",
                                                    "name": "product",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v7 /*: any*/ 
                                    ],
                                    "type": "CustomerServiceOrganization"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "errorType"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "01a04225033d1c240e60c2831c34cc958b17cd0c6be52ce6b65c5484adb41a6f",
            "metadata": {},
            "name": "entitlementsOrganizationQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$42e659babe89c8d5$var$node.hash = "c2dbf2a99cb38657b66de75f23707712";
var $42e659babe89c8d5$export$2e2bcd8739ae039 = $42e659babe89c8d5$var$node;

});


parcelRegister("iTeMQ", function(module, exports) {

$parcel$export(module.exports, "uiOrganizationDetailsPageQueryResource", () => $6f42d74340bbf820$export$ab65064827d1831d);

var $ao2h1 = parcelRequire("ao2h1");

var $hpIsM = parcelRequire("hpIsM");
const $6f42d74340bbf820$export$ab65064827d1831d = (0, $ao2h1.createRelayResource)({
    type: 'UI_ORGANIZATION_DETAILS_PAGE_QUERY',
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $hpIsM.default),
            variables: {
                organizationId: String(match.params.organizationId),
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("hpIsM", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc8caf12ab702db6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<08164275d7c73aca9297baa3da2d3967>>
 * @relayHash 572d7a60b6cd2c2d7190bee47f74e0e0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8425025856dcdb524ab8c9068e976910d1b94e9aab4d880ce4e0939990c08edf
const $bc8caf12ab702db6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "organizationId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "organizationId",
            "variableName": "organizationId"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "identifier"
    }, v8 = {
        "kind": "ScalarField",
        "name": "message"
    }, v9 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v3 /*: any*/ ,
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "errorType"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "uiOrganizationDetailsPageQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "organizationByOrganizationId",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "details",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "customDetailsSidebar_servicedeskCustomerServiceCustomDetailsSidebar_Inner"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "CustomerServiceOrganization"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "throwOnQueryError_servicedeskCustomerServiceCommon"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "customerService.organizationByOrganizationId"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "customerService"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "uiOrganizationDetailsPageQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "organizationByOrganizationId",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "details",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isCustomerServiceCustomDetailValuesQueryResult"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "CustomerServiceCustomDetailValue",
                                                            "kind": "LinkedField",
                                                            "name": "results",
                                                            "plural": true,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canEdit"
                                                                },
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "values"
                                                                },
                                                                {
                                                                    "concreteType": "CustomerServiceCustomDetailType",
                                                                    "kind": "LinkedField",
                                                                    "name": "type",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "options"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "CustomerServiceCustomDetailConfigMetadata",
                                                                    "kind": "LinkedField",
                                                                    "name": "config",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "CustomerServiceCustomAttributeStyleConfiguration",
                                                                            "kind": "LinkedField",
                                                                            "name": "styleConfiguration",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "CustomerServiceCustomAttributeOptionsStyleConfiguration",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "options",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "optionValue"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "CustomerServiceCustomAttributeOptionStyle",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "style",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "backgroundColour"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "CustomerServiceCustomDetailValues"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ],
                                                    "type": "QueryError"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "CustomerServiceOrganization"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8425025856dcdb524ab8c9068e976910d1b94e9aab4d880ce4e0939990c08edf",
            "metadata": {},
            "name": "uiOrganizationDetailsPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$bc8caf12ab702db6$var$node.hash = "8781f4b4eca174196d95ee737ccdc3aa";
var $bc8caf12ab702db6$export$2e2bcd8739ae039 = $bc8caf12ab702db6$var$node;

});


parcelRegister("5tVaj", function(module, exports) {

$parcel$export(module.exports, "servicedeskOrganizationDetailsRoute", () => $beffe8b6a9e6d0f2$export$eacc4723293cbc36);
const $beffe8b6a9e6d0f2$export$eacc4723293cbc36 = {
    name: 'servicedesk-organization-details',
    path: '/jira/servicedesk/projects/:projectKey/organizations/:organizationId',
    exact: true
};

});

parcelRegister("rKFLU", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskOrganizations", () => $b9e14ed4e63c050e$export$b40b4bfa472057b9);
$parcel$export(module.exports, "ServiceDeskOrganizations", () => $b9e14ed4e63c050e$export$4abec67d7b34dda2);
$parcel$export(module.exports, "LazyServicedeskOrganizationDetails", () => $b9e14ed4e63c050e$export$4a01866152e4a375);
$parcel$export(module.exports, "ServicedeskOrganizationDetails", () => $b9e14ed4e63c050e$export$709be875ca0a7ead);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $b9e14ed4e63c050e$export$b40b4bfa472057b9 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("gnciN"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/organizations/src/index.tsx"
});
const $b9e14ed4e63c050e$export$4abec67d7b34dda2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $b9e14ed4e63c050e$export$b40b4bfa472057b9,
        pageId: "spa-apps/servicedesk/organizations",
        shouldShowSpinner: true
    });

const $b9e14ed4e63c050e$export$4a01866152e4a375 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("9OwFC"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/organization-details/src/index.tsx"
});
const $b9e14ed4e63c050e$export$709be875ca0a7ead = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $b9e14ed4e63c050e$export$4a01866152e4a375,
        pageId: "spa-apps/servicedesk/organization-details",
        shouldShowSpinner: true
    });

});
parcelRegister("gnciN", function(module, exports) {

let $beb8564198e1bf2a$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $beb8564198e1bf2a$var$load("ffQaD"),
    $beb8564198e1bf2a$var$load("kvRbA"),
    $beb8564198e1bf2a$var$load("76n7a"),
    $beb8564198e1bf2a$var$load("l253H"),
    $beb8564198e1bf2a$var$load("6j8cP")
]).then(()=>parcelRequire('e2tYQ'));

});

parcelRegister("9OwFC", function(module, exports) {

let $72522033f5741814$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $72522033f5741814$var$load("ffQaD"),
    $72522033f5741814$var$load("kvRbA"),
    $72522033f5741814$var$load("76n7a"),
    $72522033f5741814$var$load("l253H"),
    $72522033f5741814$var$load("iz2YA")
]).then(()=>parcelRequire('9LQpe'));

});



parcelRegister("2cpS3", function(module, exports) {

$parcel$export(module.exports, "servicedeskOrganizationsRouteEntry", () => $51233e7b4d73b144$export$cf20fe731144ca3b);

var $ffza4 = parcelRequire("ffza4");

var $cEOhb = parcelRequire("cEOhb");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bkElt = parcelRequire("bkElt");

var $e9YVH = parcelRequire("e9YVH");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6Z2mh = parcelRequire("6Z2mh");

var $rKFLU = parcelRequire("rKFLU");
const $51233e7b4d73b144$export$cf20fe731144ca3b = (0, $7NszV.createEntry)((0, $bkElt.servicedeskOrganizationsRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        component: (0, $rKFLU.ServiceDeskOrganizations),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $rKFLU.LazyServicedeskOrganizations)
        ],
        perfMetricKey: 'jsm-organizations-component-load',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $cEOhb.AsyncDirectoryNav),
            // TODO: Remove this during jira_nav4 cleanup
            onlyShowHorizontalOnNav4: true
        },
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).ORGANIZATIONS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).ORGANIZATIONS),
                teamName: 'boysenberry'
            }
        }
    }));

});
parcelRegister("bkElt", function(module, exports) {

$parcel$export(module.exports, "servicedeskOrganizationsRoute", () => $3df03e0958f7e9c7$export$d4a712c5bc3c3434);
const $3df03e0958f7e9c7$export$d4a712c5bc3c3434 = {
    name: 'servicedesk-organizations',
    path: '/jira/servicedesk/projects/:projectKey/organizations',
    exact: true
};

});


parcelRegister("c0JOH", function(module, exports) {

$parcel$export(module.exports, "servicedeskProjectSummaryRouteEntry", () => $2c8ef8f8c8b8bea4$export$a24d68fcf82b16bb);

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $5wuQF = parcelRequire("5wuQF");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $5xviT = parcelRequire("5xviT");

var $dWyPA = parcelRequire("dWyPA");

var $iZ8qR = parcelRequire("iZ8qR");
const $2c8ef8f8c8b8bea4$export$a24d68fcf82b16bb = (0, $7NszV.createEntry)((0, $5wuQF.servicedeskProjectSummaryRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'jsm.project-summary',
        component: (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jsm-project-summary'), ()=>null, (0, $5lsNZ.default)),
        skeleton: (0, $5xviT.ProjectSummarySkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $dWyPA.getProjectSummaryFilterFieldsResource)()
        ],
        entryPoint: ()=>(0, $4R6GH.fg)('jsm-project-summary') ? (0, $iZ8qR.projectSummaryPageEntryPoint) : undefined,
        meta: {
            reporting: {
                id: 'project-summary',
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).PROJECT_SUMMARY),
                teamName: 'jsd-shield'
            }
        }
    }));

});
parcelRegister("5wuQF", function(module, exports) {

$parcel$export(module.exports, "servicedeskProjectSummaryRoute", () => $4ba559112e9c0332$export$a23b752ff24027ae);
const $4ba559112e9c0332$export$a23b752ff24027ae = {
    path: '/jira/servicedesk/projects/:projectKey/summary',
    name: 'servicedesk-project-summary'
};

});

parcelRegister("5xviT", function(module, exports) {

$parcel$export(module.exports, "ProjectSummarySkeleton", () => $d1cb7759e14ba32c$export$93a223cf4712c63d);

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $atIlz = parcelRequire("atIlz");
const $d1cb7759e14ba32c$export$93a223cf4712c63d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($atIlz)))
    });

});
parcelRegister("atIlz", function(module, exports) {
module.exports = new URL("project-summary-skeleton.tpl.f2232e71.svg", import.meta.url).toString();

});


parcelRegister("dWyPA", function(module, exports) {

$parcel$export(module.exports, "getProjectSummaryFilterFieldsResource", () => $742db2d29900c944$export$efafab65f8d3c3b6);
$parcel$export(module.exports, "useGetProjectSummaryFilterFields", () => $742db2d29900c944$export$e6baafb2e3d74187);
$parcel$export(module.exports, "useRequestTypeJqlTerm", () => $742db2d29900c944$export$1bb1552d41afd41f);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $fZneA = parcelRequire("fZneA");

var $eusud = parcelRequire("eusud");

var $4R6GH = parcelRequire("4R6GH");

var $1nb22 = parcelRequire("1nb22");

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");



var $18LUv = parcelRequire("18LUv");
const $742db2d29900c944$var$RESOURCE_NAME = 'projectSummaryFilterFieldResource';
const $742db2d29900c944$export$6f0555de4f60e84e = 'RESOURCE_TYPE_JSM_PROJECT_SUMMARY_FILTERS';
const $742db2d29900c944$var$REQUEST_TYPE_FILTER_TYPE = 'com.atlassian.servicedesk:vp-origin';
const $742db2d29900c944$var$REQUEST_TYPE_FILTER_SEARCH_TEMPLATE = 'com.atlassian.servicedesk:vp-origin-searcher';
const $742db2d29900c944$var$PRIORITY_FILTER_TYPE = 'priority';
const $742db2d29900c944$var$PRIORITY_FILTER_SEARCH_TEMPLATE = 'priority';
const $742db2d29900c944$var$CREATED_FILTER_TYPE = 'created';
const $742db2d29900c944$var$CREATED_FILTER_SEARCH_TEMPLATE = 'created';
const $742db2d29900c944$var$reportError = ({ error: error, id: id })=>(0, $jcw0u.default)({
        error: error,
        sendToPrivacyUnsafeSplunk: true,
        meta: {
            id: id ? `${$742db2d29900c944$var$RESOURCE_NAME}.${id}` : $742db2d29900c944$var$RESOURCE_NAME,
            packageName: (0, $1067b0e29a05cd94$export$b8b9d90f9e5bd72b),
            teamName: (0, $1067b0e29a05cd94$export$d57b6b390e78d90f)
        }
    });
const $742db2d29900c944$var$fetchFields = [
    'request type',
    'priority',
    'created'
];
const $742db2d29900c944$var$fetchFilterFieldsOld = async (cloudId, jqlContext)=>{
    try {
        const responses = await Promise.all($742db2d29900c944$var$fetchFields.map((searchString)=>(0, $eusud.performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: (0, $9f7e041fbe104d81$export$2b91517d6d5b4365),
                    variables: {
                        cloudId: cloudId,
                        contextFieldsFilter: {
                            searchString: searchString
                        },
                        jqlContext: jqlContext
                    }
                }),
                headers: {
                    'content-type': 'application/json',
                    'X-ExperimentalApi': 'JiraJqlBuilder'
                }
            })));
        const tryGetField = ({ data: data, name: name, type: type, searchTemplate: searchTemplate, displayName: displayName })=>{
            const edges = data?.jira?.jqlBuilder?.fields?.edges;
            const field = edges?.find((edge)=>edge?.node?.type === type && edge?.node?.searchTemplate?.key === searchTemplate)?.node;
            if (!field && !(0, $4R6GH.fg)('jsm_project_summary_rt_filtering_fix')) $742db2d29900c944$var$reportError({
                error: new Error(`Unable to prefetch ${name}`)
            });
            return field ? {
                ...field,
                searchTemplate: field.searchTemplate.key,
                fieldType: field.type,
                displayName: displayName ?? field.displayName
            } : undefined;
        };
        return {
            requestTypeField: tryGetField({
                data: responses[0].data,
                name: 'request type',
                type: $742db2d29900c944$var$REQUEST_TYPE_FILTER_TYPE,
                searchTemplate: $742db2d29900c944$var$REQUEST_TYPE_FILTER_SEARCH_TEMPLATE
            }),
            priorityField: tryGetField({
                data: responses[1].data,
                name: 'priority',
                type: $742db2d29900c944$var$PRIORITY_FILTER_TYPE,
                searchTemplate: $742db2d29900c944$var$PRIORITY_FILTER_SEARCH_TEMPLATE
            }),
            createdField: tryGetField({
                data: responses[2].data,
                name: 'created',
                type: $742db2d29900c944$var$CREATED_FILTER_TYPE,
                searchTemplate: $742db2d29900c944$var$CREATED_FILTER_SEARCH_TEMPLATE
            })
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!(0, $fZneA.isHttpClientErrorResponse)(error)) $742db2d29900c944$var$reportError({
            error: error,
            id: (0, $4R6GH.fg)('jsm_project_summary_rt_filtering_fix') ? 'fetchFields' : undefined
        });
        return {
            requestTypeField: undefined,
            priorityField: undefined,
            createdField: undefined
        };
    }
};
const $742db2d29900c944$var$fetchFilterFields = async (cloudId, jqlContext)=>{
    try {
        const response = await (0, $eusud.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $9f7e041fbe104d81$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId,
                    contextFieldsFilter: (0, $4R6GH.fg)('corecap_3780_fix_rt_fetching_issue') ? {
                        jqlTerms: [
                            (0, $1067b0e29a05cd94$export$2c388650eabddf5e),
                            (0, $1067b0e29a05cd94$export$2fcf90614ee15858),
                            (0, $1067b0e29a05cd94$export$43482ff574598f59)
                        ]
                    } : {
                        searchString: 'request type'
                    },
                    jqlContext: jqlContext
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'JiraJqlBuilder'
            }
        });
        const tryGetField = ({ data: data, name: name, type: type, searchTemplate: searchTemplate, displayName: displayName })=>{
            const edges = data?.jira?.jqlBuilder?.fields?.edges;
            const field = edges?.find((edge)=>edge?.node?.type === type && edge?.node?.searchTemplate?.key === searchTemplate)?.node;
            if (!field && !(0, $4R6GH.fg)('jsm_project_summary_rt_filtering_fix')) $742db2d29900c944$var$reportError({
                error: new Error(`Unable to prefetch ${name}`)
            });
            return field ? {
                ...field,
                searchTemplate: field.searchTemplate.key,
                fieldType: field.type,
                displayName: displayName ?? field.displayName
            } : undefined;
        };
        return {
            requestTypeField: tryGetField({
                data: response.data,
                name: 'request type',
                type: $742db2d29900c944$var$REQUEST_TYPE_FILTER_TYPE,
                searchTemplate: $742db2d29900c944$var$REQUEST_TYPE_FILTER_SEARCH_TEMPLATE
            })
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!(0, $fZneA.isHttpClientErrorResponse)(error)) $742db2d29900c944$var$reportError({
            error: error,
            id: (0, $4R6GH.fg)('jsm_project_summary_rt_filtering_fix') ? 'fetchFields' : undefined
        });
        return {
            requestTypeField: undefined
        };
    }
};
const $742db2d29900c944$var$getProjectKeyOrId = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $742db2d29900c944$var$filterFieldsResource = (0, $2M1hQ.createResource)({
    type: $742db2d29900c944$export$6f0555de4f60e84e,
    getKey: ({ match: match, query: query })=>$742db2d29900c944$export$6f0555de4f60e84e + $742db2d29900c944$var$getProjectKeyOrId(match, query),
    getData: ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
        const jqlContext = `project = '${$742db2d29900c944$var$getProjectKeyOrId(match, query)}'`;
        return (0, $4R6GH.fg)('improve_performance_on_jsm_project_summary_filter') ? $742db2d29900c944$var$fetchFilterFields(cloudId, jqlContext) : $742db2d29900c944$var$fetchFilterFieldsOld(cloudId, jqlContext);
    },
    maxAge: Infinity
});
const $742db2d29900c944$export$efafab65f8d3c3b6 = ()=>(0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_project_summary_filters') || (0, $4R6GH.fg)('jsm_project_summary_rt_filtering_fix'), $742db2d29900c944$var$filterFieldsResource);
const $742db2d29900c944$export$e6baafb2e3d74187 = ()=>{
    const { data: filterResource } = (0, $2YP9W.useResource)($742db2d29900c944$var$filterFieldsResource);
    const useFilterFields = (0, $5uXOq.useMemo)(()=>({ requestTypeField: requestTypeField = filterResource?.requestTypeField, requestTypeDisplayName: requestTypeDisplayName, priorityDisplayName: priorityDisplayName, createdDisplayName: createdDisplayName })=>{
            return [
                ...requestTypeField ? [
                    {
                        ...requestTypeField,
                        ...requestTypeDisplayName && {
                            displayName: requestTypeDisplayName
                        }
                    }
                ] : [],
                'status',
                'assignee',
                {
                    ...(0, $18LUv.priorityField),
                    ...priorityDisplayName && {
                        displayName: priorityDisplayName
                    }
                },
                {
                    ...(0, $18LUv.createdField),
                    ...createdDisplayName && {
                        displayName: createdDisplayName
                    }
                }
            ];
        }, [
        filterResource
    ]);
    const useFilterFieldsOld = (0, $5uXOq.useMemo)(()=>({ requestTypeField: requestTypeField = filterResource?.requestTypeField, requestTypeDisplayName: requestTypeDisplayName, priorityDisplayName: priorityDisplayName, createdDisplayName: createdDisplayName })=>{
            const priorityField = filterResource?.priorityField;
            const createdField = filterResource?.createdField;
            return [
                ...requestTypeField ? [
                    {
                        ...requestTypeField,
                        ...requestTypeDisplayName && {
                            displayName: requestTypeDisplayName
                        }
                    }
                ] : [],
                'status',
                'assignee',
                ...priorityField ? [
                    {
                        ...priorityField,
                        ...priorityDisplayName && {
                            displayName: priorityDisplayName
                        }
                    }
                ] : [],
                ...createdField ? [
                    {
                        ...createdField,
                        ...createdDisplayName && {
                            displayName: createdDisplayName
                        }
                    }
                ] : []
            ];
        }, [
        filterResource
    ]);
    return (0, $4R6GH.fg)('improve_performance_on_jsm_project_summary_filter') ? useFilterFields : useFilterFieldsOld;
};
const $742db2d29900c944$export$1bb1552d41afd41f = ({ jqlTerm: jqlTerm })=>{
    const { data: filterResource, loading: loading } = (0, $2YP9W.useResource)($742db2d29900c944$var$filterFieldsResource);
    const term = jqlTerm ?? filterResource?.requestTypeField?.jqlTerm;
    const hasError = !loading && !term;
    (0, $5uXOq.useEffect)(()=>{
        if (hasError) $742db2d29900c944$var$reportError({
            error: new Error('Error while getting request type jql term.'),
            id: 'rtJqlTerm'
        });
    }, [
        hasError
    ]);
    return term;
};

});
const $1067b0e29a05cd94$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesServicedeskProjectSummary';
const $1067b0e29a05cd94$export$d57b6b390e78d90f = 'jsd-shield';
const $1067b0e29a05cd94$export$2c388650eabddf5e = 'request type';
const $1067b0e29a05cd94$export$2fcf90614ee15858 = 'service desk origin';
const $1067b0e29a05cd94$export$43482ff574598f59 = 'cf[10010]';

const $9f7e041fbe104d81$export$2b91517d6d5b4365 = `
query findFieldQuery($cloudId: ID!, $contextFieldsFilter: JiraJQLContextFieldsFilter!, $jqlContext: String!) {
  jira {
    jqlBuilder(cloudId: $cloudId) {
        fields(jqlContextFieldsFilter: $contextFieldsFilter, jqlContext: $jqlContext) {
          ... on JiraJqlFieldConnection {
            __typename
            edges {
              node {
                jqlTerm
                displayName
                type
                searchTemplate {
                  key
                }
                operators
              }
            }
          }
          ... on QueryError {
            __typename
          }
        }
      }
  }
}
`;

parcelRegister("18LUv", function(module, exports) {

$parcel$export(module.exports, "createdField", () => $2aef1f8837d7645c$export$2ea2ca384f1938b4);
$parcel$export(module.exports, "priorityField", () => $2aef1f8837d7645c$export$da5b63bb5f06c4fb);
/* eslint-disable @typescript-eslint/consistent-type-assertions */ const $2aef1f8837d7645c$export$2ea2ca384f1938b4 = {
    displayName: 'Created',
    fieldType: 'created',
    jqlTerm: 'created',
    operators: [
        'LESS_THAN_OR_EQUAL',
        'GREATER_THAN_OR_EQUAL',
        'NOT_IN',
        'IS_NOT',
        'LESS_THAN',
        'GREATER_THAN',
        'EQUALS',
        'IS',
        'IN',
        'NOT_EQUALS'
    ],
    searchTemplate: 'created',
    type: 'created'
};
const $2aef1f8837d7645c$export$da5b63bb5f06c4fb = {
    displayName: 'Priority',
    fieldType: 'priority',
    jqlTerm: 'priority',
    operators: [
        'GREATER_THAN_OR_EQUAL',
        'LESS_THAN',
        'GREATER_THAN',
        'WAS_NOT',
        'IS',
        'IN',
        'CHANGED',
        'LESS_THAN_OR_EQUAL',
        'NOT_IN',
        'IS_NOT',
        'WAS_NOT_IN',
        'EQUALS',
        'WAS_IN',
        'WAS',
        'NOT_EQUALS'
    ],
    searchTemplate: 'priority',
    type: 'priority'
};

});


parcelRegister("iZ8qR", function(module, exports) {

$parcel$export(module.exports, "projectSummaryPageEntryPoint", () => $cfa42f0318b6392e$export$ae7c241893e7dab9);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $fmaTw = parcelRequire("fmaTw");
const $cfa42f0318b6392e$export$ae7c241893e7dab9 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $fmaTw.projectSummaryEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("fmaTw", function(module, exports) {

$parcel$export(module.exports, "projectSummaryEntryPoint", () => $15ffffad92965566$export$95a2fe4e495efca5);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $15ffffad92965566$export$95a2fe4e495efca5 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("dpbCV")), {
        moduleId: "ac794fd1"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("dpbCV", function(module, exports) {

let $9c26a0fd0a316f52$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9c26a0fd0a316f52$var$load("ffQaD"),
    $9c26a0fd0a316f52$var$load("kvRbA"),
    $9c26a0fd0a316f52$var$load("lBgV9")
]).then(()=>parcelRequire('i6ZtS'));

});




parcelRegister("iYfXI", function(module, exports) {

$parcel$export(module.exports, "customPracticeQueueRouteEntry", () => $aa74409e2ad842d4$export$b43128c9b5db2a5e);

var $ffza4 = parcelRequire("ffza4");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $jlOGG = parcelRequire("jlOGG");

var $bHhiy = parcelRequire("bHhiy");

var $2pT4g = parcelRequire("2pT4g");

var $fpjJX = parcelRequire("fpjJX");

var $urQ6o = parcelRequire("urQ6o");

var $6Z2mh = parcelRequire("6Z2mh");

var $iTSIT = parcelRequire("iTSIT");

var $lBKJK = parcelRequire("lBKJK");

var $4R6GH = parcelRequire("4R6GH");

var $gNStA = parcelRequire("gNStA");

var $lAGdd = parcelRequire("lAGdd");

var $faj7G = parcelRequire("faj7G");

var $gLKd7 = parcelRequire("gLKd7");
const $aa74409e2ad842d4$export$b43128c9b5db2a5e = (0, $7NszV.createEntry)((0, $urQ6o.customPracticeQueueRoute), ()=>({
        group: 'servicedesk',
        component: (0, $faj7G.CustomQueueRouteComponent),
        layout: (0, $aPfsS.composeLayouts)((0, $6Z2mh.serviceProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        skeleton: (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $gLKd7.QueueLoadingSkeleton) : undefined,
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $lBKJK.AsyncHorizontalNavQueue) : undefined
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            ...(0, $fpjJX.getKnowledgeBaseResources)(),
            ...(0, $fpjJX.getInsightResources)(),
            ...(0, $fpjJX.getIssueListSsrResource)(),
            (0, $jlOGG.newIssueViewLockInStatusResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $2pT4g.jsmRepackagingBannerResource),
            (0, $lAGdd.aiContextPanelResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $iTSIT.horizontalNavQueueResource))
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $faj7G.LazyServicedeskQueuesAgentAndIssueView)
        ]
    }));

});
parcelRegister("jlOGG", function(module, exports) {

$parcel$export(module.exports, "newIssueViewLockInStatusResource", () => $951713022fad9069$export$647de7516d081bd8);
$parcel$export(module.exports, "useNewIssueViewLockInStatus", () => $951713022fad9069$export$d8ba398930f2f5f);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $1odlY = parcelRequire("1odlY");

const $951713022fad9069$export$647de7516d081bd8 = (0, $2M1hQ.createResource)({
    type: (0, $1odlY.RESOURCE_TYPE_PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS),
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("aHjmk")),
    maxAge: Number.MAX_VALUE
});
const $951713022fad9069$export$d8ba398930f2f5f = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)($951713022fad9069$export$647de7516d081bd8);
    return {
        loading: loading,
        error: error,
        newIssueViewLockedIn: data && data.newIssueViewLockedIn
    };
};

});
parcelRegister("aHjmk", function(module, exports) {

let $7c9cefe0eb7d20fc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7c9cefe0eb7d20fc$var$load("bzwfz").then(()=>parcelRequire('7JV09'));

});


parcelRegister("iTSIT", function(module, exports) {

$parcel$export(module.exports, "horizontalNavQueueResource", () => $0eded50aa7688d41$export$896712202052ca56);

var $ao2h1 = parcelRequire("ao2h1");

var $4Wr19 = parcelRequire("4Wr19");

var $9AmTW = parcelRequire("9AmTW");

var $1nb22 = parcelRequire("1nb22");

var $ktofH = parcelRequire("ktofH");

var $6YG83 = parcelRequire("6YG83");
const $0eded50aa7688d41$export$71eec30d9db46a56 = ({ match: match, query: query }, { tenantContext: { activationId: activationId, cloudId: cloudId } })=>{
    const queueId = match.params.queueId;
    let { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
    projectKey = projectKey ?? '';
    projectId = projectId ?? '';
    const projectIdOrKey = projectId || projectKey;
    const queueAri = queueId ? (0, $9AmTW.JiraServicedeskQueueAri).create({
        siteId: cloudId,
        queueId: queueId || '',
        activationId: activationId
    }).toString() : '';
    const containerNavigationInput = queueAri ? {
        scopeId: queueAri
    } : {
        projectKeyQuery: {
            cloudId: cloudId,
            projectKey: projectKey
        }
    };
    return {
        options: {
            fetchPolicy: 'store-and-network'
        },
        parameters: $4Wr19.default,
        variables: {
            cloudId: cloudId,
            projectIdOrKey: projectIdOrKey,
            containerNavigationInput: containerNavigationInput,
            first: (0, $ktofH.NAVIGATION_ITEMS_PAGE_SIZE)
        }
    };
};
const $0eded50aa7688d41$export$896712202052ca56 = (0, $6YG83.withGiraAggAnonSsrFix)((0, $ao2h1.createRelayResource)({
    type: 'HORIZONTAL_NAVIGATION_QUEUE_QUERY',
    getQuery: $0eded50aa7688d41$export$71eec30d9db46a56
}));

});
parcelRegister("4Wr19", function(module, exports) {

$parcel$export(module.exports, "default", () => $e49ea8e372e3d9cf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6c8059f14a3201b31e0652bd91e511bc>>
 * @relayHash ad9b22c18ca56c0cec6bb77e087f1a60
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5a6395a2023b01b4b8728b98901f39635c74a467c84cd540ba5af518baccad2
const $e49ea8e372e3d9cf$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "b5a6395a2023b01b4b8728b98901f39635c74a467c84cd540ba5af518baccad2",
        "metadata": {},
        "name": "HorizontalNavQueueInnerQuery",
        "operationKind": "query",
        "text": null
    }
};
var $e49ea8e372e3d9cf$export$2e2bcd8739ae039 = $e49ea8e372e3d9cf$var$node;

});


parcelRegister("lBKJK", function(module, exports) {

$parcel$export(module.exports, "AsyncHorizontalNavQueue", () => $08dafd9591b0689d$export$5f20c7610c638983);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $3HwlS = parcelRequire("3HwlS");

var $5NiYd = parcelRequire("5NiYd");

var $urQ6o = parcelRequire("urQ6o");

var $ayogX = parcelRequire("ayogX");

var $6jY6G = parcelRequire("6jY6G");

var $bmKPg = parcelRequire("bmKPg");

const $08dafd9591b0689d$var$LazyHorizontalNavQueue = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("6D49R")).then((HorizontalNavQueue)=>HorizontalNavQueue), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/queue/src/ui/HorizontalNavQueue.tsx"
});
const $08dafd9591b0689d$export$5f20c7610c638983 = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const [issueKey] = (0, $bmKPg.usePathParam)('issueKey');
    const isIssueView = route.name === (0, $ayogX.customIssueRoute).name || route.name === (0, $urQ6o.customPracticeQueueRoute).name && issueKey;
    const content = !isIssueView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "horizontal-nav-queue",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5NiYd.HorizontalNavSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08dafd9591b0689d$var$LazyHorizontalNavQueue, null));
    return (0, $3HwlS.getWillShowNav4)() ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $08dafd9591b0689d$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $08dafd9591b0689d$var$styles
    }, content));
};
const $08dafd9591b0689d$var$containerStyles = (0, $8CUq3.xcss)({
    position: 'relative'
});
const $08dafd9591b0689d$var$styles = (0, $8CUq3.xcss)({
    position: 'absolute',
    width: '100%'
});

});
parcelRegister("ayogX", function(module, exports) {

$parcel$export(module.exports, "customIssueRoute", () => $2e7fd15e22956eb6$export$2c4bc3091ab58cd0);
const $2e7fd15e22956eb6$export$2c4bc3091ab58cd0 = {
    name: 'servicedesk-queues-custom-issue-detail',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/:issueKey',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});

parcelRegister("6D49R", function(module, exports) {

let $4d399c466a75b2e7$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $4d399c466a75b2e7$var$load("ffQaD"),
    $4d399c466a75b2e7$var$load("kvRbA"),
    $4d399c466a75b2e7$var$load("7ODMs")
]).then(()=>parcelRequire('jjRnc'));

});


parcelRegister("faj7G", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesAgentAndIssueView", () => $a3b6d4fb9a4ea620$export$6f01bfb6fc18a06e);
$parcel$export(module.exports, "CustomQueueRouteComponent", () => $a3b6d4fb9a4ea620$export$59d555419fbaa611);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $4R6GH = parcelRequire("4R6GH");

var $7yO8g = parcelRequire("7yO8g");

const $a3b6d4fb9a4ea620$export$6f01bfb6fc18a06e = (0, $kxZPA.lazyForPaint)(()=>{
    return (0, $7yO8g.markAsProductBundleReady)((parcelRequire("9RNLH")));
}, {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-agent-and-issue-view/src/index.tsx"
});
const $a3b6d4fb9a4ea620$export$59d555419fbaa611 = ({ match: match })=>{
    const queueId = match.params && match.params.queueId || '';
    const issueKey = match.params && match.params.issueKey || '';
    const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $a3b6d4fb9a4ea620$export$6f01bfb6fc18a06e,
        pageId: `spa-apps/servicedesk/queues/${queueId}/${issueKey}/${oldIssueView}`,
        shouldShowSpinner: !(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag')
    });
};

});
parcelRegister("9RNLH", function(module, exports) {

let $72efab44b1f093a5$var$load = (parcelRequire("28QjX"))(4);

module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $72efab44b1f093a5$var$load("czifk"),
            $72efab44b1f093a5$var$load("kvRbA"),
            $72efab44b1f093a5$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $72efab44b1f093a5$var$load("kcs34")
        ]);
    }),
    $72efab44b1f093a5$var$load("kNFvF"),
    $72efab44b1f093a5$var$load("kVX56"),
    $72efab44b1f093a5$var$load("76n7a"),
    $72efab44b1f093a5$var$load("l253H"),
    $72efab44b1f093a5$var$load("ffQaD"),
    $72efab44b1f093a5$var$load("kvRbA"),
    $72efab44b1f093a5$var$load("1tAfd")
]).then(()=>parcelRequire('6o1Xn'));

});


parcelRegister("gLKd7", function(module, exports) {

$parcel$export(module.exports, "QueueLoadingSkeleton", () => $1e5417896a058f9f$export$d20068523efc567f);

var $5uXOq = parcelRequire("5uXOq");

var $hoJVU = parcelRequire("hoJVU");

var $kb4zh = parcelRequire("kb4zh");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");
const $1e5417896a058f9f$export$d20068523efc567f = ()=>{
    return (0, $3HwlS.getWillShowNav4)() && !(0, $4R6GH.fg)('jsm_fix_queue_issue_view_navigate_back_state') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hoJVU.QueueNav3StylingPatchContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null));
};

});
parcelRegister("hoJVU", function(module, exports) {

$parcel$export(module.exports, "useStylingPatch", () => $a9c2b57f46f9d18e$export$ed35078f707ec860);
$parcel$export(module.exports, "QueueNav3StylingPatchContainer", () => $a9c2b57f46f9d18e$export$9cbbe53228ab978f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3HwlS = parcelRequire("3HwlS");

var $4R6GH = parcelRequire("4R6GH");

var $6jY6G = parcelRequire("6jY6G");

var $bmKPg = parcelRequire("bmKPg");

var $7M8Tn = parcelRequire("7M8Tn");

var $urQ6o = parcelRequire("urQ6o");

var $1D031 = parcelRequire("1D031");

var $24BFc = parcelRequire("24BFc");

var $g0YQu = parcelRequire("g0YQu");

var $lVOJN = parcelRequire("lVOJN");

var $ayogX = parcelRequire("ayogX");
const $a9c2b57f46f9d18e$var$SEGMENT_KEY = 'queues-agent-view-top-layout-nav3';
const $a9c2b57f46f9d18e$export$ed35078f707ec860 = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    const [issueKey] = (0, $bmKPg.usePathParam)('issueKey');
    if (!(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag')) return {
        shouldUseStylingPatch: false,
        isNav3QueueIssueViewRoute: false
    };
    const isNav3QueueRouteOld = !(0, $3HwlS.getWillShowNav4)() && (route.name === (0, $7M8Tn.customQueueRoute).name || route.name === (0, $urQ6o.customPracticeQueueRoute).name && !issueKey);
    const isNav3QueueRouteNew = !(0, $3HwlS.getWillShowNav4)() && (route.name === (0, $7M8Tn.customQueueRoute).name || route.name === (0, $urQ6o.customPracticeQueueRoute).name || // Only the Nav3 Queue content and Nav3 Category Queue content are wrapped with QueueNav3StylingPatchContainer.
    // The routes where we should doing this wrapping are queue route, category queue route and issue view route
    // The reason why we are also need to wrap the Queue content on issue view route is because we want to avoid re-rendering.
    // ----------------------------------------------------------------------------------------------------------
    // Inside the QueueNav3StylingPatchContainer (below), we will avoid putting the height on issue view route (because of this scroll problem).
    // This will not trigger the re-rendering because the DOM structure isn’t changed.
    route.name === (0, $ayogX.customIssueRoute).name);
    // customIssueRoute is issue view route for custom queue
    // while customPracticeQueueRoute contains route for both practice queue agent view and practice queue issue view, we need to check issueKey to determine if it's issue view route
    const isNav3QueueIssueViewRoute = !(0, $3HwlS.getWillShowNav4)() && (route.name === (0, $ayogX.customIssueRoute).name || route.name === (0, $urQ6o.customPracticeQueueRoute).name && !!issueKey);
    const isNav3QueueRoute = (0, $4R6GH.fg)('jsm_fix_queue_issue_view_navigate_back_state') ? isNav3QueueRouteNew : isNav3QueueRouteOld;
    const isNav3BoardRoute = !(0, $3HwlS.getWillShowNav4)() && (route.name === (0, $24BFc.customQueueBoardRoute).name || route.name === (0, $1D031.customPracticeQueueBoardRoute).name);
    const isNav3CalendarRoute = !(0, $3HwlS.getWillShowNav4)() && (route.name === (0, $g0YQu.customQueueCalendarRoute).name || route.name === (0, $lVOJN.customPracticeQueueCalendarRoute).name);
    return {
        shouldUseStylingPatch: isNav3QueueRoute || isNav3BoardRoute || isNav3CalendarRoute,
        isNav3QueueIssueViewRoute: isNav3QueueIssueViewRoute
    };
};
const $a9c2b57f46f9d18e$export$9cbbe53228ab978f = ({ children: children })=>{
    const { shouldUseStylingPatch: shouldUseStylingPatch, isNav3QueueIssueViewRoute: isNav3QueueIssueViewRoute } = $a9c2b57f46f9d18e$export$ed35078f707ec860();
    if (shouldUseStylingPatch || !(0, $4R6GH.fg)('jsm_fix_queue_issue_view_navigate_back_state')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-vc": (0, $4R6GH.fg)('further_improve_vc90_performence_of_queues_page') ? `${$a9c2b57f46f9d18e$var$SEGMENT_KEY}${false ? '-ssr' : ''}` : undefined,
        "data-ssr-placeholder": false && (0, $4R6GH.fg)('further_improve_vc90_performence_of_queues_page') ? $a9c2b57f46f9d18e$var$SEGMENT_KEY : undefined,
        "data-ssr-placeholder-replace": false || !(0, $4R6GH.fg)('further_improve_vc90_performence_of_queues_page') ? undefined : $a9c2b57f46f9d18e$var$SEGMENT_KEY,
        "data-testid": "horizontal-nav-queue.controllers.styling-patch.queue-nav-3-styling-patch-container",
        className: (0, $bwpsq.default)([
            !isNav3QueueIssueViewRoute && "_ca0q1h05 _vchhusvi _1e0c1txw _2lx21bp4 _4t3i1osq"
        ])
    }, children);
    return children;
};
const $a9c2b57f46f9d18e$var$nav3PaddingStyles = null;

});
parcelRegister("1D031", function(module, exports) {

$parcel$export(module.exports, "customPracticeQueueBoardRoute", () => $63187d5cb553d47e$export$47ae519519dbd803);
const $63187d5cb553d47e$export$47ae519519dbd803 = {
    name: 'servicedesk-queues-practice-custom-board',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/board/:boardId',
    exact: true
};

});

parcelRegister("24BFc", function(module, exports) {

$parcel$export(module.exports, "customQueueBoardRoute", () => $3c41cbb682d42029$export$5407961894c40126);
const $3c41cbb682d42029$export$5407961894c40126 = {
    name: 'servicedesk-queues-custom-board',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/board/:boardId',
    exact: true
};

});

parcelRegister("g0YQu", function(module, exports) {

$parcel$export(module.exports, "customQueueCalendarRoute", () => $d63e361e6becb774$export$82a97d9fba2cfa9a);
const $d63e361e6becb774$export$82a97d9fba2cfa9a = {
    name: 'servicedesk-queues-custom-calendar',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/calendar/:boardId',
    exact: true
};

});

parcelRegister("lVOJN", function(module, exports) {

$parcel$export(module.exports, "customPracticeQueueCalendarRoute", () => $6fd1b54b722592ef$export$5a0e47b0abcf7c2f);
const $6fd1b54b722592ef$export$5a0e47b0abcf7c2f = {
    name: 'servicedesk-queues-practice-custom-calendar',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/calendar/:boardId',
    exact: true
};

});




parcelRegister("dAmDY", function(module, exports) {

$parcel$export(module.exports, "customPracticeQueueBoardRouteEntry", () => $0081c4c1a88ea88d$export$7b0b0691f8b766cf);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $5lsNZ = parcelRequire("5lsNZ");

var $1D031 = parcelRequire("1D031");

var $fpjJX = parcelRequire("fpjJX");

var $6Z2mh = parcelRequire("6Z2mh");

var $4R6GH = parcelRequire("4R6GH");

var $bHhiy = parcelRequire("bHhiy");

var $f5kpo = parcelRequire("f5kpo");

var $f7Y15 = parcelRequire("f7Y15");

var $gNStA = parcelRequire("gNStA");

var $iTSIT = parcelRequire("iTSIT");

var $3HwlS = parcelRequire("3HwlS");

var $lBKJK = parcelRequire("lBKJK");

var $dkQIn = parcelRequire("dkQIn");
const $0081c4c1a88ea88d$export$7b0b0691f8b766cf = (0, $7NszV.createEntry)((0, $1D031.customPracticeQueueBoardRoute), ()=>({
        group: 'servicedesk',
        component: (0, $5lsNZ.default),
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag')) return (0, $3HwlS.getWillShowNav4)() ? (0, $dkQIn.boardPageEntryPoint) : (0, $dkQIn.boardPageNav3EntryPoint);
            return undefined;
        },
        layout: (0, $6Z2mh.serviceProjectLayout),
        skeleton: (0, $dkQIn.BoardSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: // eslint-disable-next-line jira/ff/no-preconditioning
            (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') && !(0, $3HwlS.getWillShowNav4)() ? (0, $lBKJK.AsyncHorizontalNavQueue) : undefined
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>!false, (0, $f7Y15.uifBoardResource)),
            (0, $gNStA.resourceWithCondition2)(()=>!(0, $3HwlS.getWillShowNav4)(), (0, $iTSIT.horizontalNavQueueResource))
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("dkQIn", function(module, exports) {

$parcel$export(module.exports, "boardPageNav3EntryPoint", () => $d0693ec64fdd7e2b$export$ae25ae5278cbd6a1);
$parcel$export(module.exports, "boardPageEntryPoint", () => $d0693ec64fdd7e2b$export$552f44bed039f041);
$parcel$export(module.exports, "BoardSkeleton", () => $d0693ec64fdd7e2b$export$325f821722dfa572);

var $5uXOq = parcelRequire("5uXOq");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $4R6GH = parcelRequire("4R6GH");

var $4E7Hx = parcelRequire("4E7Hx");

var $2iSWJ = parcelRequire("2iSWJ");

var $hWAe2 = parcelRequire("hWAe2");

var $hoJVU = parcelRequire("hoJVU");

var $3HwlS = parcelRequire("3HwlS");
const $d0693ec64fdd7e2b$export$ae25ae5278cbd6a1 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $2iSWJ.boardEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $d0693ec64fdd7e2b$export$552f44bed039f041 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $2iSWJ.boardEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $4E7Hx.horizontalNavQueueEntrypoint)
});
const $d0693ec64fdd7e2b$export$325f821722dfa572 = ()=>(0, $3HwlS.getWillShowNav4)() && !(0, $4R6GH.fg)('jsm_fix_queue_issue_view_navigate_back_state') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hWAe2.ClassicBoardSkeleton), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hoJVU.QueueNav3StylingPatchContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hWAe2.ClassicBoardSkeleton), null));

});
parcelRegister("4E7Hx", function(module, exports) {

$parcel$export(module.exports, "horizontalNavQueueEntrypoint", () => $67dd0a42e98143fe$export$df9ea493099a3cc4);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $4Wr19 = parcelRequire("4Wr19");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $9AmTW = parcelRequire("9AmTW");

var $1nb22 = parcelRequire("1nb22");

var $ktofH = parcelRequire("ktofH");

const $67dd0a42e98143fe$export$df9ea493099a3cc4 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("7p7ap")), {
        moduleId: "664171c5",
        moduleName: "HorizontalNavQueueInner"
    }),
    getPreloadProps: ({ context: { match: match, query: query }, tenantContext: { activationId: activationId, cloudId: cloudId } })=>{
        const queueId = match.params.queueId;
        let { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        projectKey = projectKey ?? '';
        projectId = projectId ?? '';
        const projectIdOrKey = projectId || projectKey;
        const queueAri = queueId ? (0, $9AmTW.JiraServicedeskQueueAri).create({
            siteId: cloudId,
            queueId: queueId || '',
            activationId: activationId
        }).toString() : '';
        const containerNavigationInput = queueAri ? {
            scopeId: queueAri
        } : {
            projectKeyQuery: {
                cloudId: cloudId,
                projectKey: projectKey
            }
        };
        return {
            queries: {
                horizontalNavQueueQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $4Wr19.default,
                    variables: {
                        cloudId: cloudId,
                        projectIdOrKey: projectIdOrKey,
                        containerNavigationInput: containerNavigationInput,
                        first: (0, $ktofH.NAVIGATION_ITEMS_PAGE_SIZE)
                    }
                }
            }
        };
    }
});

});
parcelRegister("7p7ap", function(module, exports) {

let $56406d63abcfcbf8$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $56406d63abcfcbf8$var$load("ffQaD"),
    $56406d63abcfcbf8$var$load("kvRbA"),
    $56406d63abcfcbf8$var$load("8lm5x")
]).then(()=>parcelRequire('ftqx5'));

});


parcelRegister("2iSWJ", function(module, exports) {

$parcel$export(module.exports, "boardEntryPoint", () => $d117236cb308f3eb$export$937ca5a4cdc1a12e);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $d117236cb308f3eb$export$937ca5a4cdc1a12e = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("fWFUP")), {
        moduleId: "286ebff8"
    }),
    getPreloadProps: ()=>({})
});

});



parcelRegister("3MI0Z", function(module, exports) {

$parcel$export(module.exports, "customPracticeQueueCalendarRouteEntry", () => $ece609b32152a098$export$8e8d88d3af02e6f7);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $5lsNZ = parcelRequire("5lsNZ");

var $lVOJN = parcelRequire("lVOJN");

var $fpjJX = parcelRequire("fpjJX");

var $6Z2mh = parcelRequire("6Z2mh");

var $bHhiy = parcelRequire("bHhiy");

var $f7Y15 = parcelRequire("f7Y15");

var $jYeNO = parcelRequire("jYeNO");

var $iTSIT = parcelRequire("iTSIT");

var $4R6GH = parcelRequire("4R6GH");

var $gNStA = parcelRequire("gNStA");

var $3HwlS = parcelRequire("3HwlS");

var $lBKJK = parcelRequire("lBKJK");

var $dPV2J = parcelRequire("dPV2J");
const $ece609b32152a098$export$8e8d88d3af02e6f7 = (0, $7NszV.createEntry)((0, $lVOJN.customPracticeQueueCalendarRoute), ()=>({
        group: 'servicedesk',
        component: (0, $5lsNZ.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: // eslint-disable-next-line jira/ff/no-preconditioning
            (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') && !(0, $3HwlS.getWillShowNav4)() ? (0, $lBKJK.AsyncHorizontalNavQueue) : undefined
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ],
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag')) return (0, $3HwlS.getWillShowNav4)() ? (0, $dPV2J.calendarPageEntryPoint) : (0, $dPV2J.calendarPageNav3EntryPoint);
            return undefined;
        },
        skeleton: (0, $dPV2J.CalendarSkeleton),
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $jYeNO.getCalendarFilterFieldsResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>!(0, $3HwlS.getWillShowNav4)(), (0, $iTSIT.horizontalNavQueueResource)),
            (0, $gNStA.resourceWithCondition2)(()=>!false, (0, $f7Y15.uifBoardResource))
        ]
    }));

});
parcelRegister("dPV2J", function(module, exports) {

$parcel$export(module.exports, "calendarPageNav3EntryPoint", () => $348976a96cbb6eb5$export$4dc8c8e2c977ed01);
$parcel$export(module.exports, "calendarPageEntryPoint", () => $348976a96cbb6eb5$export$eda0c2fb67f7d7e7);
$parcel$export(module.exports, "CalendarSkeleton", () => $348976a96cbb6eb5$export$ebc7c47cc535837e);

var $5uXOq = parcelRequire("5uXOq");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $4R6GH = parcelRequire("4R6GH");

var $faaUu = parcelRequire("faaUu");

var $4E7Hx = parcelRequire("4E7Hx");

var $hoJVU = parcelRequire("hoJVU");

var $6Y2I3 = parcelRequire("6Y2I3");

var $3HwlS = parcelRequire("3HwlS");
const $348976a96cbb6eb5$export$4dc8c8e2c977ed01 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $faaUu.calendarEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $348976a96cbb6eb5$export$eda0c2fb67f7d7e7 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $faaUu.calendarEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $4E7Hx.horizontalNavQueueEntrypoint)
});
const $348976a96cbb6eb5$export$ebc7c47cc535837e = ()=>(0, $3HwlS.getWillShowNav4)() && !(0, $4R6GH.fg)('jsm_fix_queue_issue_view_navigate_back_state') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Y2I3.ClassicCalendarSkeleton), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hoJVU.QueueNav3StylingPatchContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Y2I3.ClassicCalendarSkeleton), null));

});


parcelRegister("8brgy", function(module, exports) {

$parcel$export(module.exports, "customQueueRouteEntry", () => $9125770532ebae88$export$54a295e04e6cea33);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $7M8Tn = parcelRequire("7M8Tn");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $aPfsS = parcelRequire("aPfsS");

var $jlOGG = parcelRequire("jlOGG");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $iTSIT = parcelRequire("iTSIT");

var $lBKJK = parcelRequire("lBKJK");

var $4R6GH = parcelRequire("4R6GH");

var $gNStA = parcelRequire("gNStA");

var $aNLeB = parcelRequire("aNLeB");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $6lAw8 = parcelRequire("6lAw8");

var $faj7G = parcelRequire("faj7G");

var $gLKd7 = parcelRequire("gLKd7");
const $9125770532ebae88$export$54a295e04e6cea33 = (0, $7NszV.createEntry)((0, $7M8Tn.customQueueRoute), ()=>({
        layout: (0, $aPfsS.composeLayouts)((0, $6Z2mh.serviceProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $lBKJK.AsyncHorizontalNavQueue) : undefined
        },
        skeleton: (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $gLKd7.QueueLoadingSkeleton) : undefined,
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            ...(0, $fpjJX.getInsightResources)(),
            ...(0, $fpjJX.getIssueListSsrResource)(),
            (0, $jlOGG.newIssueViewLockInStatusResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $aNLeB.servicedeskIsItsmProjectResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $iTSIT.horizontalNavQueueResource))
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        group: 'servicedesk',
        // It is important to keep this component consistent across the two routes so
        // that React doesn't unmount it when switching between the routes and the
        // full state is kept so that scroll position and loaded data is kept when
        // going back from issue details to the queues page.
        component: (0, $faj7G.CustomQueueRouteComponent),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $faj7G.LazyServicedeskQueuesAgentAndIssueView),
            (0, $6lAw8.LazyForPaintServicedeskSidebar)
        ]
    }));

});

parcelRegister("3kqBW", function(module, exports) {

$parcel$export(module.exports, "customQueueBoardRouteEntry", () => $5785385fb89d88cf$export$f94102e9d0a3b113);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $5lsNZ = parcelRequire("5lsNZ");

var $fpjJX = parcelRequire("fpjJX");

var $24BFc = parcelRequire("24BFc");

var $6Z2mh = parcelRequire("6Z2mh");

var $4R6GH = parcelRequire("4R6GH");

var $bHhiy = parcelRequire("bHhiy");

var $f5kpo = parcelRequire("f5kpo");

var $f7Y15 = parcelRequire("f7Y15");

var $gNStA = parcelRequire("gNStA");

var $iTSIT = parcelRequire("iTSIT");

var $3HwlS = parcelRequire("3HwlS");

var $lBKJK = parcelRequire("lBKJK");

var $dkQIn = parcelRequire("dkQIn");
const $5785385fb89d88cf$export$f94102e9d0a3b113 = (0, $7NszV.createEntry)((0, $24BFc.customQueueBoardRoute), ()=>({
        group: 'servicedesk',
        component: (0, $5lsNZ.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag')) return (0, $3HwlS.getWillShowNav4)() ? (0, $dkQIn.boardPageEntryPoint) : (0, $dkQIn.boardPageNav3EntryPoint);
            return undefined;
        },
        skeleton: (0, $dkQIn.BoardSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: // eslint-disable-next-line jira/ff/no-preconditioning
            (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') && !(0, $3HwlS.getWillShowNav4)() ? (0, $lBKJK.AsyncHorizontalNavQueue) : undefined
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ],
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>!false, (0, $f7Y15.uifBoardResource)),
            (0, $gNStA.resourceWithCondition2)(()=>!(0, $3HwlS.getWillShowNav4)(), (0, $iTSIT.horizontalNavQueueResource))
        ]
    }));

});

parcelRegister("79qCU", function(module, exports) {

$parcel$export(module.exports, "customQueueCalendarRouteEntry", () => $2a2221e4bb7d64f1$export$a6aaa9129c24f852);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $5lsNZ = parcelRequire("5lsNZ");

var $fpjJX = parcelRequire("fpjJX");

var $g0YQu = parcelRequire("g0YQu");

var $6Z2mh = parcelRequire("6Z2mh");

var $bHhiy = parcelRequire("bHhiy");

var $f7Y15 = parcelRequire("f7Y15");

var $jYeNO = parcelRequire("jYeNO");

var $4R6GH = parcelRequire("4R6GH");

var $gNStA = parcelRequire("gNStA");

var $iTSIT = parcelRequire("iTSIT");

var $3HwlS = parcelRequire("3HwlS");

var $lBKJK = parcelRequire("lBKJK");

var $dPV2J = parcelRequire("dPV2J");
const $2a2221e4bb7d64f1$export$a6aaa9129c24f852 = (0, $7NszV.createEntry)((0, $g0YQu.customQueueCalendarRoute), ()=>({
        group: 'servicedesk',
        component: (0, $5lsNZ.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: // eslint-disable-next-line jira/ff/no-preconditioning
            (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') && !(0, $3HwlS.getWillShowNav4)() ? (0, $lBKJK.AsyncHorizontalNavQueue) : undefined
        },
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag')) return (0, $3HwlS.getWillShowNav4)() ? (0, $dPV2J.calendarPageEntryPoint) : (0, $dPV2J.calendarPageNav3EntryPoint);
            return undefined;
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ],
        skeleton: (0, $dPV2J.CalendarSkeleton),
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $jYeNO.getCalendarFilterFieldsResource)(),
            (0, $gNStA.resourceWithCondition2)(()=>!(0, $3HwlS.getWillShowNav4)(), (0, $iTSIT.horizontalNavQueueResource)),
            (0, $gNStA.resourceWithCondition2)(()=>!false, (0, $f7Y15.uifBoardResource))
        ]
    }));

});

parcelRegister("lYzgn", function(module, exports) {

$parcel$export(module.exports, "customIssueRouteEntry", () => $75b822e8abf02245$export$3813414450b75758);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $ayogX = parcelRequire("ayogX");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $aPfsS = parcelRequire("aPfsS");

var $jlOGG = parcelRequire("jlOGG");

var $bHhiy = parcelRequire("bHhiy");

var $lBKJK = parcelRequire("lBKJK");

var $4R6GH = parcelRequire("4R6GH");

var $fpjJX = parcelRequire("fpjJX");

var $aNLeB = parcelRequire("aNLeB");

var $6Z2mh = parcelRequire("6Z2mh");

var $lAGdd = parcelRequire("lAGdd");

var $faj7G = parcelRequire("faj7G");

var $gLKd7 = parcelRequire("gLKd7");
const $75b822e8abf02245$export$3813414450b75758 = (0, $7NszV.createEntry)((0, $ayogX.customIssueRoute), ()=>({
        layout: (0, $aPfsS.composeLayouts)((0, $6Z2mh.serviceProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            // Keep this consistent with the one in customQueueRouteEntry.tsx, so it won't rerender the queue agent view component
            // when navigating between queues and issues.
            // Rereder could cause problem:
            // 1. Issue view will lose issue navigator component
            // 2. When navigating back to queue, the queue will lose the scroll position.
            horizontal: (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $lBKJK.AsyncHorizontalNavQueue) : undefined
        },
        skeleton: (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $gLKd7.QueueLoadingSkeleton) : undefined,
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            ...(0, $fpjJX.getInsightResources)(),
            ...(0, $fpjJX.getIssueListSsrResource)(),
            (0, $jlOGG.newIssueViewLockInStatusResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $aNLeB.servicedeskIsItsmProjectResource),
            (0, $lAGdd.aiContextPanelResource)
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        group: 'servicedesk',
        // It is important to keep this component consistent across the two routes so
        // that React doesn't unmount it when switching between the routes and the
        // full state is kept so that scroll position and loaded data is kept when
        // going back from issue details to the queues page.
        component: (0, $faj7G.CustomQueueRouteComponent),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $faj7G.LazyServicedeskQueuesAgentAndIssueView)
        ]
    }));

});

parcelRegister("6YHWn", function(module, exports) {

$parcel$export(module.exports, "servicedeskIssueRouteEntry", () => $d0c44cd76c7c1b24$export$a4bd7206a6659ad3);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $hwnr9 = parcelRequire("hwnr9");

var $6Z2mh = parcelRequire("6Z2mh");

var $lAGdd = parcelRequire("lAGdd");

var $eyZxr = parcelRequire("eyZxr");
const $d0c44cd76c7c1b24$export$a4bd7206a6659ad3 = (0, $7NszV.createEntry)((0, $hwnr9.servicedeskIssueRoute), ()=>({
        group: 'servicedesk',
        component: (0, $eyZxr.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            ...(0, $fpjJX.getKnowledgeBaseResources)(),
            ...(0, $fpjJX.getInsightResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $lAGdd.aiContextPanelResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $eyZxr.LazyServicedeskQueuesIssueViewRedirect)
        ]
    }));

});
parcelRegister("hwnr9", function(module, exports) {

$parcel$export(module.exports, "servicedeskIssueRoute", () => $1bb6cc8a72a7dc88$export$e146d4ae5415aa9);
const $1bb6cc8a72a7dc88$export$e146d4ae5415aa9 = {
    name: 'servicedesk-issue',
    path: '/jira/servicedesk/projects/:projectKey/issue/:issueKey',
    exact: true
};

});

parcelRegister("eyZxr", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesIssueViewRedirect", () => $3e1702b77575d903$export$52593b5917c5e179);
$parcel$export(module.exports, "default", () => $3e1702b77575d903$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $3e1702b77575d903$export$52593b5917c5e179 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("hMRL4")), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-issue-view-redirect/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3e1702b77575d903$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3e1702b77575d903$export$52593b5917c5e179,
        pageId: "spa-apps/servicedesk/queues/issue-view-redirect",
        shouldShowSpinner: true
    });

});
parcelRegister("hMRL4", function(module, exports) {

let $cf309ea21c0191ca$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cf309ea21c0191ca$var$load("2l5lq").then(()=>parcelRequire('blyWx'));

});



parcelRegister("aAIWh", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeEditRouteEntry", () => $b2af11fd25aabf4a$export$5d9efd0f838d30a1);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $aDAYL = parcelRequire("aDAYL");

var $6Z2mh = parcelRequire("6Z2mh");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $4kils = parcelRequire("4kils");

var $a3285 = parcelRequire("a3285");

var $iRITI = parcelRequire("iRITI");
const $b2af11fd25aabf4a$export$5d9efd0f838d30a1 = (0, $7NszV.createEntry)((0, $aDAYL.servicedeskPracticeEditRoute), ()=>({
        group: 'servicedesk',
        component: (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $a3285.ServicedeskQueuesConfig), (0, $4kils.default)),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            ...(0, $fpjJX.getIssueListSsrResource)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $fpjJX.getQueueConfigResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $a3285.LazyServicedeskQueuesConfig) : (0, $4kils.LazyServicedeskQueuesEditView)
        ],
        pageId: ({ query: query, match: match })=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? `spa-apps/servicedesk/queues/views-config/${query.config}` : `spa-apps/servicedesk/queues/edit/${match.params && match.params.queueId || ''}`,
        entryPoint () {
            return (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $iRITI.serviceDeskQueuesConfigPageEntryPoint) : undefined;
        }
    }));

});
parcelRegister("aDAYL", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeEditRoute", () => $c23ca6ea0acd72bb$export$dfaa99f66db1aa2);
const $c23ca6ea0acd72bb$export$dfaa99f66db1aa2 = {
    name: 'servicedesk-practice-edit',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/edit',
    exact: true,
    query: [
        'config?'
    ]
};

});

parcelRegister("4kils", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesEditView", () => $deaadf08ad128234$export$5bb02347e0261e6a);
$parcel$export(module.exports, "default", () => $deaadf08ad128234$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $deaadf08ad128234$export$5bb02347e0261e6a = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("td7mn"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-edit-view/src/index.tsx"
});
var /**
 * @deprecated Remove this when fsm_views_inside_queues_-_main_flag is cleaned up
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$deaadf08ad128234$export$2e2bcd8739ae039 = ({ match: match })=>{
    const queueId = match.params && match.params.queueId || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $deaadf08ad128234$export$5bb02347e0261e6a,
        pageId: `spa-apps/servicedesk/queues/edit/${queueId}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("td7mn", function(module, exports) {

let $057ce2739f0e4e01$var$load = (parcelRequire("28QjX"))(4);

module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $057ce2739f0e4e01$var$load("czifk"),
            $057ce2739f0e4e01$var$load("kvRbA"),
            $057ce2739f0e4e01$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $057ce2739f0e4e01$var$load("kcs34")
        ]);
    }),
    $057ce2739f0e4e01$var$load("ffQaD"),
    $057ce2739f0e4e01$var$load("kvRbA"),
    $057ce2739f0e4e01$var$load("8IAs5")
]).then(()=>parcelRequire('3r23L'));

});


parcelRegister("a3285", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesConfig", () => $262e81f2d9d70ac4$export$8bc01f18d5db1178);
$parcel$export(module.exports, "ServicedeskQueuesConfig", () => $262e81f2d9d70ac4$export$ac10b7696844d33);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $7tQej = parcelRequire("7tQej");

const $262e81f2d9d70ac4$export$8bc01f18d5db1178 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("gJHbn")), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-config/src/index.tsx"
});
const $262e81f2d9d70ac4$export$ac10b7696844d33 = (props)=>{
    const { query: query } = props;
    // If URL is from edit queue, then redirect to the new URL with config query param
    if (!query.config) {
        const { config: config, ...restQuery } = query;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: {
                pathname: `${props.location.pathname}`,
                hash: '',
                search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
                    ...restQuery,
                    config: 'queueConfig'
                })
            }
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $262e81f2d9d70ac4$export$8bc01f18d5db1178,
        pageId: `spa-apps/servicedesk/queues/config/${query.config}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("gJHbn", function(module, exports) {

let $c2f2587632eb5e0a$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c2f2587632eb5e0a$var$load("kNFvF"),
    $c2f2587632eb5e0a$var$load("ffQaD"),
    $c2f2587632eb5e0a$var$load("kvRbA"),
    $c2f2587632eb5e0a$var$load("fZ3Mx")
]).then(()=>parcelRequire('bgMER'));

});


parcelRegister("iRITI", function(module, exports) {

$parcel$export(module.exports, "serviceDeskQueuesConfigPageEntryPoint", () => $34887bb49cd0d1b5$export$2a7296eb9b68414);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $cZYKf = parcelRequire("cZYKf");
const $34887bb49cd0d1b5$export$2a7296eb9b68414 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $cZYKf.queuesConfigEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("cZYKf", function(module, exports) {

$parcel$export(module.exports, "queuesConfigEntrypoint", () => $4ca55b3219138116$export$bc016338e2032123);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $9AmTW = parcelRequire("9AmTW");

var $1nb22 = parcelRequire("1nb22");

var $ktofH = parcelRequire("ktofH");

var $cmFS1 = parcelRequire("cmFS1");

const $4ca55b3219138116$export$bc016338e2032123 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        return (parcelRequire("gJHbn"));
    }, {
        moduleId: "2bb3c6f1"
    }),
    getPreloadProps: ({ context: { match: match, query: query, route: route }, tenantContext: { activationId: activationId, cloudId: cloudId } })=>{
        const queueId = match.params.queueId;
        let { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(match, query);
        projectKey = projectKey ?? '';
        const queueAri = queueId ? (0, $9AmTW.JiraServicedeskQueueAri).create({
            siteId: cloudId,
            queueId: queueId || '',
            activationId: activationId
        }).toString() : '';
        const input = queueAri ? {
            scopeId: queueAri
        } : {
            projectKeyQuery: {
                cloudId: cloudId,
                projectKey: projectKey
            }
        };
        return {
            queries: {
                mainSettingsNavigationQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $cmFS1.default),
                    variables: {
                        input: input,
                        first: (0, $ktofH.NAVIGATION_ITEMS_PAGE_SIZE)
                    }
                }
            },
            extraProps: {
                query: query,
                match: match,
                route: route
            }
        };
    }
});

});
parcelRegister("cmFS1", function(module, exports) {

$parcel$export(module.exports, "default", () => $30f039e31305dc75$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<46e2694401dd0296d6732a14558ad98c>>
 * @relayHash dfd06866fddd95df7034205febe8eb4e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9b239a41299b531cf29a09d8abbeb2cf530d1715b2ea22ad115bc7f31e5f68f9
const $30f039e31305dc75$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "typeKey"
    }, v6 = {
        "kind": "ScalarField",
        "name": "message"
    }, v7 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v8 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v7 /*: any*/ 
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = [
        v6 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v3 /*: any*/ ,
                v7 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainSettingsNavigationQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "containerNavigation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "args": v4 /*: any*/ ,
                                                    "concreteType": "JiraNavigationItemConnection",
                                                    "kind": "LinkedField",
                                                    "name": "navigationItems",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "JiraNavigationItemEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        "action": "THROW",
                                                                        "path": "jira.containerNavigation.navigationItems.edges.node"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "THROW",
                                                            "path": "jira.containerNavigation.navigationItems.edges"
                                                        },
                                                        {
                                                            "concreteType": "QueryError",
                                                            "kind": "LinkedField",
                                                            "name": "errors",
                                                            "plural": true,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v8 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraContainerNavigation"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.containerNavigation"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainSettingsNavigationQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "containerNavigation",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v4 /*: any*/ ,
                                            "concreteType": "JiraNavigationItemConnection",
                                            "kind": "LinkedField",
                                            "name": "navigationItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraNavigationItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                v9 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "errors",
                                                    "plural": true,
                                                    "selections": v10 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraContainerNavigation"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v10 /*: any*/ ,
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9b239a41299b531cf29a09d8abbeb2cf530d1715b2ea22ad115bc7f31e5f68f9",
            "metadata": {},
            "name": "mainSettingsNavigationQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$30f039e31305dc75$var$node.hash = "a86c2910ccbf2af4328e8f1d666e319c";
var $30f039e31305dc75$export$2e2bcd8739ae039 = $30f039e31305dc75$var$node;

});




parcelRegister("5fOtJ", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeIssueRouteEntry", () => $c4ae805410394011$export$ff51f5ad948cb987);

var $ffza4 = parcelRequire("ffza4");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $jlOGG = parcelRequire("jlOGG");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6yPAx = parcelRequire("6yPAx");

var $6Z2mh = parcelRequire("6Z2mh");

var $lAGdd = parcelRequire("lAGdd");

var $i1TcK = parcelRequire("i1TcK");
const $c4ae805410394011$export$ff51f5ad948cb987 = (0, $7NszV.createEntry)((0, $6yPAx.servicedeskPracticeIssueRoute), ()=>({
        group: 'servicedesk',
        component: (0, $i1TcK.default),
        layout: (0, $aPfsS.composeLayouts)((0, $6Z2mh.serviceProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)()),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            ...(0, $fpjJX.getKnowledgeBaseResources)(),
            ...(0, $fpjJX.getInsightResources)(),
            (0, $jlOGG.newIssueViewLockInStatusResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $lAGdd.aiContextPanelResource)
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $i1TcK.LazyServicedeskQueuesIssueView)
        ]
    }));

});
parcelRegister("6yPAx", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeIssueRoute", () => $b7f41b661071cdd5$export$38a6ee0f22e74bf3);
const $b7f41b661071cdd5$export$38a6ee0f22e74bf3 = {
    name: 'servicedesk-practice-issue',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/issue/:issueKey',
    exact: true
};

});

parcelRegister("i1TcK", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesIssueView", () => $e8099257b5d2aca0$export$164f2dfdd8dc056b);
$parcel$export(module.exports, "default", () => $e8099257b5d2aca0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $e8099257b5d2aca0$export$164f2dfdd8dc056b = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("c7Zmd")), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk/queues-issue-view/src/index.tsx"
});
var /**
 * Constructs a URL path for navigating to a specific issue view within a service desk queue, incorporating optional parameters for issue identification and view customization.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$e8099257b5d2aca0$export$2e2bcd8739ae039 = ({ match: match })=>{
    const issueKey = `/${match.params && match.params.issueKey || ''}`;
    const queueId = `/${match.params && match.params.queueId || ''}`;
    const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e8099257b5d2aca0$export$164f2dfdd8dc056b,
        pageId: `spa-apps/servicedesk/queues/issue${queueId}${issueKey}${oldIssueView}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("c7Zmd", function(module, exports) {

let $8d45bbc35f4d8b78$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $8d45bbc35f4d8b78$var$load("kNFvF"),
    $8d45bbc35f4d8b78$var$load("kVX56"),
    $8d45bbc35f4d8b78$var$load("76n7a"),
    $8d45bbc35f4d8b78$var$load("l253H"),
    $8d45bbc35f4d8b78$var$load("3EDTs")
]).then(()=>parcelRequire('6qBzG'));

});



parcelRegister("gfz2f", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeLandingRouteEntry", () => $8be1362ae286a3b1$export$881d545af6c177f1);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $gclwh = parcelRequire("gclwh");

var $6Z2mh = parcelRequire("6Z2mh");

var $erVva = parcelRequire("erVva");
const $8be1362ae286a3b1$export$881d545af6c177f1 = (0, $7NszV.createEntry)((0, $gclwh.servicedeskPracticeLandingRoute), ()=>({
        group: 'servicedesk',
        isRedirect: true,
        component: (0, $erVva.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $erVva.LazyServicedeskQueuesLanding)
        ]
    }));

});
parcelRegister("gclwh", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeLandingRoute", () => $3ecb8d0a4bfa59d9$export$3c859c71be33b36c);
const $3ecb8d0a4bfa59d9$export$3c859c71be33b36c = {
    name: 'servicedesk-practice-landing',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/(custom)?',
    exact: true
};

});

parcelRegister("erVva", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesLanding", () => $33ab495a6069d0db$export$bdf522692228bb6f);
$parcel$export(module.exports, "default", () => $33ab495a6069d0db$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $33ab495a6069d0db$export$bdf522692228bb6f = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("drKLr")), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-landing/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$33ab495a6069d0db$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $33ab495a6069d0db$export$bdf522692228bb6f,
        pageId: "spa-apps/servicedesk/queues/landing",
        shouldShowSpinner: true
    });

});
parcelRegister("drKLr", function(module, exports) {

let $9ca2125fbe8ad034$var$load = (parcelRequire("28QjX"))(4);

module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $9ca2125fbe8ad034$var$load("czifk"),
            $9ca2125fbe8ad034$var$load("kvRbA"),
            $9ca2125fbe8ad034$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $9ca2125fbe8ad034$var$load("kcs34")
        ]);
    }),
    $9ca2125fbe8ad034$var$load("ffQaD"),
    $9ca2125fbe8ad034$var$load("kvRbA"),
    $9ca2125fbe8ad034$var$load("slTJc")
]).then(()=>parcelRequire('5ou2F'));

});



parcelRegister("gfW60", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeManageViewRouteEntry", () => $1a1c1c43e66f85e4$export$4e1b0df2a8fcae78);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $kxe3F = parcelRequire("kxe3F");

var $6Z2mh = parcelRequire("6Z2mh");

var $57W6j = parcelRequire("57W6j");
const $1a1c1c43e66f85e4$export$4e1b0df2a8fcae78 = (0, $7NszV.createEntry)((0, $kxe3F.servicedeskPracticeManageViewRoute), ()=>({
        group: 'servicedesk',
        component: (0, $57W6j.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: (0, $fpjJX.getQueuesResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $57W6j.LazyServicedeskQueuesManageView)
        ]
    }));

});
parcelRegister("kxe3F", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeManageViewRoute", () => $bf1a5a194b52ef2d$export$125e0ab662806584);
const $bf1a5a194b52ef2d$export$125e0ab662806584 = {
    name: 'servicedesk-practice-manage-view',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/queue-settings',
    exact: true
};

});

parcelRegister("57W6j", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesManageView", () => $ad9d634f0cdcf391$export$9f1e189198f08c4a);
$parcel$export(module.exports, "default", () => $ad9d634f0cdcf391$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $ad9d634f0cdcf391$export$9f1e189198f08c4a = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("kJOSZ"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-manage-view/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ad9d634f0cdcf391$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ad9d634f0cdcf391$export$9f1e189198f08c4a,
        pageId: "spa-apps/servicedesk/queues/manage",
        shouldShowSpinner: true
    });

});
parcelRegister("kJOSZ", function(module, exports) {

let $f18f7b82fe2d0e32$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f18f7b82fe2d0e32$var$load("dutL0").then(()=>parcelRequire('htw0K'));

});



parcelRegister("h51Kg", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeNewRouteEntry", () => $149e7521aa5247f3$export$50a04ec00cb8039);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $UrzEQ = parcelRequire("UrzEQ");

var $6Z2mh = parcelRequire("6Z2mh");

var $hw6fm = parcelRequire("hw6fm");
const $149e7521aa5247f3$export$50a04ec00cb8039 = (0, $7NszV.createEntry)((0, $UrzEQ.servicedeskPracticeNewRoute), ()=>({
        group: 'servicedesk',
        component: (0, $hw6fm.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hw6fm.LazyServicedeskQueuesCreateView)
        ]
    }));

});
parcelRegister("UrzEQ", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeNewRoute", () => $e5aa77a45094c512$export$8595a5452f93a1fd);
const $e5aa77a45094c512$export$8595a5452f93a1fd = {
    name: 'servicedesk-practice-new',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/new',
    query: [
        'parentId?'
    ],
    exact: true
};

});

parcelRegister("hw6fm", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesCreateView", () => $093d629913ef6b8e$export$c050b699bf9e3e40);
$parcel$export(module.exports, "default", () => $093d629913ef6b8e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $093d629913ef6b8e$export$c050b699bf9e3e40 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("huGt6"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-create-view/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$093d629913ef6b8e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $093d629913ef6b8e$export$c050b699bf9e3e40,
        pageId: "spa-apps/servicedesk/queues/create",
        shouldShowSpinner: true
    });

});
parcelRegister("huGt6", function(module, exports) {

let $cbc62e5fa4c48a25$var$load = (parcelRequire("28QjX"))(4);

module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $cbc62e5fa4c48a25$var$load("czifk"),
            $cbc62e5fa4c48a25$var$load("kvRbA"),
            $cbc62e5fa4c48a25$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $cbc62e5fa4c48a25$var$load("kcs34")
        ]);
    }),
    $cbc62e5fa4c48a25$var$load("ffQaD"),
    $cbc62e5fa4c48a25$var$load("kvRbA"),
    $cbc62e5fa4c48a25$var$load("9QDg8")
]).then(()=>parcelRequire('aQuyJ'));

});



parcelRegister("rsO8k", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesAddonRouteEntry", () => $59596f7c053ae5d7$export$23a16f20b48235b3);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $95l0v = parcelRequire("95l0v");

var $6Z2mh = parcelRequire("6Z2mh");

var $laAgE = parcelRequire("laAgE");
const $59596f7c053ae5d7$export$23a16f20b48235b3 = (0, $7NszV.createEntry)((0, $95l0v.servicedeskQueuesAddonRoute), ()=>({
        group: 'servicedesk',
        component: (0, $laAgE.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $laAgE.LazyServicedeskQueuesAddonView)
        ]
    }));

});
parcelRegister("95l0v", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesAddonRoute", () => $4884cbac3a1d9cc0$export$1465f05b88a63f13);
const $4884cbac3a1d9cc0$export$1465f05b88a63f13 = {
    name: 'servicedesk-queues-addon',
    path: '/jira/servicedesk/projects/:projectKey/queues/addon/:addonKey',
    exact: true
};

});

parcelRegister("laAgE", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesAddonView", () => $6cc059f7849819d9$export$451a7cce84b6b1e6);
$parcel$export(module.exports, "default", () => $6cc059f7849819d9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $6cc059f7849819d9$export$451a7cce84b6b1e6 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("2N6MT")), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-addon-view/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6cc059f7849819d9$export$2e2bcd8739ae039 = ({ match: match })=>{
    const addonKey = match.params && match.params.addonKey || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $6cc059f7849819d9$export$451a7cce84b6b1e6,
        pageId: `spa-apps/servicedesk/queues/addon/${addonKey}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("2N6MT", function(module, exports) {

let $20856c461c6807b2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $20856c461c6807b2$var$load("cQS1H").then(()=>parcelRequire('jFMLI'));

});



parcelRegister("5JkxV", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesEditRouteEntry", () => $ce3daf0233f73856$export$ae7b71ac953d95bf);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $7n6p5 = parcelRequire("7n6p5");

var $6Z2mh = parcelRequire("6Z2mh");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $4kils = parcelRequire("4kils");

var $a3285 = parcelRequire("a3285");

var $iRITI = parcelRequire("iRITI");
const $ce3daf0233f73856$export$ae7b71ac953d95bf = (0, $7NszV.createEntry)((0, $7n6p5.servicedeskQueuesEditRoute), ()=>({
        group: 'servicedesk',
        component: (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $a3285.ServicedeskQueuesConfig), (0, $4kils.default)),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $fpjJX.getIssueListSsrResource)(),
            ...(0, $fpjJX.getQueueConfigResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $a3285.LazyServicedeskQueuesConfig) : (0, $4kils.LazyServicedeskQueuesEditView)
        ],
        ufoName: 'service-management.queues.edit',
        pageId: ({ query: query, match: match })=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? `spa-apps/servicedesk/queues/views-config/${query.config}` : `spa-apps/servicedesk/queues/edit/${match.params && match.params.queueId || ''}`,
        entryPoint () {
            return (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $iRITI.serviceDeskQueuesConfigPageEntryPoint) : undefined;
        }
    }));

});
parcelRegister("7n6p5", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesEditRoute", () => $f9047204629cbf40$export$f8fd3a1f8c33aff8);
const $f9047204629cbf40$export$f8fd3a1f8c33aff8 = {
    name: 'servicedesk-queues-edit',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/edit',
    exact: true,
    query: [
        'config?'
    ]
};

});


parcelRegister("jIBei", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesIssueRouteEntry", () => $af2173f32f306a68$export$2e4931acac9270fc);

var $ffza4 = parcelRequire("ffza4");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $jlOGG = parcelRequire("jlOGG");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $3lD6Q = parcelRequire("3lD6Q");

var $6Z2mh = parcelRequire("6Z2mh");

var $lAGdd = parcelRequire("lAGdd");

var $i1TcK = parcelRequire("i1TcK");
const $af2173f32f306a68$export$2e4931acac9270fc = (0, $7NszV.createEntry)((0, $3lD6Q.servicedeskQueuesIssueRoute), ()=>({
        group: 'servicedesk',
        component: (0, $i1TcK.default),
        layout: (0, $aPfsS.composeLayouts)((0, $6Z2mh.serviceProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            ...(0, $fpjJX.getKnowledgeBaseResources)(),
            ...(0, $fpjJX.getInsightResources)(),
            (0, $jlOGG.newIssueViewLockInStatusResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $lAGdd.aiContextPanelResource)
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $i1TcK.LazyServicedeskQueuesIssueView)
        ]
    }));

});
parcelRegister("3lD6Q", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesIssueRoute", () => $e8668889c15b3639$export$52a24b9cf42d208b);
const $e8668889c15b3639$export$52a24b9cf42d208b = {
    name: 'servicedesk-queues-issue',
    path: '/jira/servicedesk/projects/:projectKey/queues/issue/:issueKey',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});


parcelRegister("3oSi6", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesLandingRouteEntry", () => $725a0b4233bb029f$export$4242a81237c45c7d);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $jlOGG = parcelRequire("jlOGG");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $50cHa = parcelRequire("50cHa");

var $6Z2mh = parcelRequire("6Z2mh");

var $erVva = parcelRequire("erVva");
const $725a0b4233bb029f$export$4242a81237c45c7d = (0, $7NszV.createEntry)((0, $50cHa.servicedeskQueuesLandingRoute), ()=>({
        group: 'servicedesk',
        isRedirect: true,
        component: (0, $erVva.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $jlOGG.newIssueViewLockInStatusResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $erVva.LazyServicedeskQueuesLanding)
        ]
    }));

});
parcelRegister("50cHa", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesLandingRoute", () => $c48a2414491b1ed8$export$52b4c044e4929ebc);
const $c48a2414491b1ed8$export$52b4c044e4929ebc = {
    name: 'servicedesk-queues-landing',
    // Supporting optional /default for legacy backwards compatability
    path: '/jira/servicedesk/projects/:projectKey/queues/(default|custom)?',
    exact: true
};

});


parcelRegister("96BnX", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesManageViewRouteEntry", () => $4edb93f2b23424ca$export$7e9e2984a94a07b0);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $68aAJ = parcelRequire("68aAJ");

var $6Z2mh = parcelRequire("6Z2mh");

var $57W6j = parcelRequire("57W6j");
const $4edb93f2b23424ca$export$7e9e2984a94a07b0 = (0, $7NszV.createEntry)((0, $68aAJ.servicedeskQueuesManageViewRoute), ()=>({
        group: 'servicedesk',
        component: (0, $57W6j.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: (0, $fpjJX.getQueuesResources)(),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $57W6j.LazyServicedeskQueuesManageView)
        ]
    }));

});
parcelRegister("68aAJ", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesManageViewRoute", () => $d770d83963ac1c36$export$7f30d40b906894c5);
const $d770d83963ac1c36$export$7f30d40b906894c5 = {
    name: 'servicedesk-queues-manage-view',
    path: '/jira/servicedesk/projects/:projectKey/queues/queue-settings',
    exact: true
};

});


parcelRegister("fP1EY", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesNewRouteEntry", () => $43b55289272bfd02$export$9f7cc3294b3141b1);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6x8s4 = parcelRequire("6x8s4");

var $6Z2mh = parcelRequire("6Z2mh");

var $hw6fm = parcelRequire("hw6fm");
const $43b55289272bfd02$export$9f7cc3294b3141b1 = (0, $7NszV.createEntry)((0, $6x8s4.servicedeskQueuesNewRoute), ()=>({
        group: 'servicedesk',
        component: (0, $hw6fm.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hw6fm.LazyServicedeskQueuesCreateView)
        ],
        ufoName: 'service-management.queues.new'
    }));

});
parcelRegister("6x8s4", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesNewRoute", () => $52cd0fc2ec934503$export$c1908994722d1e73);
const $52cd0fc2ec934503$export$c1908994722d1e73 = {
    name: 'servicedesk-queues-new',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/new',
    query: [
        'parentId?'
    ],
    exact: true
};

});


parcelRegister("lzLcy", function(module, exports) {

$parcel$export(module.exports, "servicedeskAtlassianAnalyticsRouteEntry", () => $f87b1ab4700345c2$export$94d6674b63b9d647);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $hejqw = parcelRequire("hejqw");

var $fpjJX = parcelRequire("fpjJX");

var $cb8ep = parcelRequire("cb8ep");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $cm4j2 = parcelRequire("cm4j2");
const $f87b1ab4700345c2$export$94d6674b63b9d647 = (0, $7NszV.createEntry)((0, $cb8ep.servicedeskAtlassianAnalyticsRoute), ()=>({
        group: 'servicedesk',
        component: (0, $cm4j2.AtlassianAnalytics),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $hejqw.servicedeskAtlassianAnalyticsResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cm4j2.LazyAtlassianAnalytics)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).ATLASSIAN_ANALYTICS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).ATLASSIAN_ANALYTICS),
                teamName: 'ITSM Saga'
            }
        }
    }));

});
parcelRegister("hejqw", function(module, exports) {

$parcel$export(module.exports, "servicedeskAtlassianAnalyticsResource", () => $ccd9a1a485573887$export$eb2deca89cf3fb61);

var $2M1hQ = parcelRequire("2M1hQ");


const $ccd9a1a485573887$var$getDataLoader = ()=>(parcelRequire("hnsP6"));
const $ccd9a1a485573887$export$eb2deca89cf3fb61 = (0, $2M1hQ.createResource)({
    type: (0, $125270e59037c004$export$73cf43fb073ce577),
    getKey: ()=>'atlassian analytics',
    getDataLoader: $ccd9a1a485573887$var$getDataLoader,
    isBrowserOnly: true
});

});
const $125270e59037c004$export$73cf43fb073ce577 = 'SERVICEDESK_ATLASSIAN_ANALYTICS';

parcelRegister("hnsP6", function(module, exports) {

let $ca6af156226db1a1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ca6af156226db1a1$var$load("l4osd").then(()=>parcelRequire('ghpmF'));

});


parcelRegister("cb8ep", function(module, exports) {

$parcel$export(module.exports, "servicedeskAtlassianAnalyticsRoute", () => $9a654d65b63de676$export$399ef3a2d4288bba);
const $9a654d65b63de676$export$399ef3a2d4288bba = {
    name: 'servicedesk-atlassian-analytics',
    path: '/jira/servicedesk/projects/:projectKey/reports/atlassian-analytics',
    exact: true
};

});

parcelRegister("cm4j2", function(module, exports) {

$parcel$export(module.exports, "LazyAtlassianAnalytics", () => $8afe4cbad132cc61$export$78ffe2f6530d45d1);
$parcel$export(module.exports, "AtlassianAnalytics", () => $8afe4cbad132cc61$export$6d23a188bb96b7ab);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $8afe4cbad132cc61$export$78ffe2f6530d45d1 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("5E9AQ"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/atlassian-analytics/src/index.tsx"
});
const $8afe4cbad132cc61$export$6d23a188bb96b7ab = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8afe4cbad132cc61$export$78ffe2f6530d45d1,
        pageId: "spa-apps/servicedesk/atlassian-analytics",
        shouldShowSpinner: true
    });

});
parcelRegister("5E9AQ", function(module, exports) {

let $41c82132d94ec2ec$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $41c82132d94ec2ec$var$load("ffQaD"),
    $41c82132d94ec2ec$var$load("kvRbA"),
    $41c82132d94ec2ec$var$load("9j2sf")
]).then(()=>parcelRequire('hUapH'));

});



parcelRegister("kZgpC", function(module, exports) {

$parcel$export(module.exports, "servicedeskKbRequestsReports2RouteEntry", () => $aba9a99d9cdea566$export$c4c0806ea684088);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $3ZP7Q = parcelRequire("3ZP7Q");

var $6Z2mh = parcelRequire("6Z2mh");

var $cVTuT = parcelRequire("cVTuT");
const $aba9a99d9cdea566$export$c4c0806ea684088 = (0, $7NszV.createEntry)((0, $3ZP7Q.servicedeskKbRequestsReports2Route), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.kb-requests',
        component: (0, $cVTuT.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cVTuT.LazyServicedeskKbRequestsReports)
        ]
    }));

});
parcelRegister("3ZP7Q", function(module, exports) {

$parcel$export(module.exports, "servicedeskKbRequestsReports2Route", () => $abd055c66022393b$export$276e2ed89304d21c);
const $abd055c66022393b$export$276e2ed89304d21c = {
    name: 'servicedesk-kb-requests-reports',
    path: '/jira/servicedesk/projects/:projectKey/reports/:reportId(kb-requests-resolved|kb-requests-deflected)'
};

});

parcelRegister("cVTuT", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskKbRequestsReports", () => $12e91a60aa9991e2$export$f86e12b111395ad);
$parcel$export(module.exports, "default", () => $12e91a60aa9991e2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $12e91a60aa9991e2$export$f86e12b111395ad = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("cHieW"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/kb-requests-reports/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$12e91a60aa9991e2$export$2e2bcd8739ae039 = ({ match: match })=>{
    const reportType = match.params.reportType || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $12e91a60aa9991e2$export$f86e12b111395ad,
        pageId: `spa-apps/servicedesk/reports/${reportType}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("cHieW", function(module, exports) {

let $93e7a6408ec26dea$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $93e7a6408ec26dea$var$load("ffQaD"),
    $93e7a6408ec26dea$var$load("kvRbA"),
    $93e7a6408ec26dea$var$load("94NOo")
]).then(()=>parcelRequire('exkzN'));

});



parcelRegister("auP5Z", function(module, exports) {

$parcel$export(module.exports, "servicedeskKbRequestsReportsIssueRouteEntry", () => $7f9fdb3f5341d83e$export$280a79a8f002dd58);

var $ffza4 = parcelRequire("ffza4");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $jlOGG = parcelRequire("jlOGG");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $8O7zJ = parcelRequire("8O7zJ");

var $6Z2mh = parcelRequire("6Z2mh");

var $lAGdd = parcelRequire("lAGdd");

var $1hJVy = parcelRequire("1hJVy");
const $7f9fdb3f5341d83e$export$280a79a8f002dd58 = (0, $7NszV.createEntry)((0, $8O7zJ.servicedeskKbRequestsReportsIssueRoute), ()=>({
        group: 'servicedesk',
        component: (0, $1hJVy.default),
        layout: (0, $aPfsS.composeLayouts)((0, $6Z2mh.serviceProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)()),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $jlOGG.newIssueViewLockInStatusResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $lAGdd.aiContextPanelResource)
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $1hJVy.LazyServicedeskReportsIssueView)
        ],
        ufoName: 'service-management.reports.issue'
    }));

});
parcelRegister("8O7zJ", function(module, exports) {

$parcel$export(module.exports, "servicedeskKbRequestsReportsIssueRoute", () => $8f89a0ced56a7cae$export$296aa46068d40f43);
const $8f89a0ced56a7cae$export$296aa46068d40f43 = {
    name: 'servicedesk-kb-requests-reports-time-scale-issue',
    path: '/jira/servicedesk/projects/:projectKey/reports/:reportId(kb-requests-resolved|kb-requests-deflected)/timescale/:timescaleId/:issueKey',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});

parcelRegister("1hJVy", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskReportsIssueView", () => $7281c34e15a34d51$export$c2f0d3c59c9d3bf3);
$parcel$export(module.exports, "default", () => $7281c34e15a34d51$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $7281c34e15a34d51$export$c2f0d3c59c9d3bf3 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("lxYCP")), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-issue-view/src/index.tsx"
});
var /**
 * Dynamically constructs and renders a lazy-loaded page tailored to specific Servicedesk report views. By leveraging URL parameters such as issue key and timescale ID, it enhances user navigation within the Servicedesk environment by directly accommodating varied user inquiries and historical data perspectives.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$7281c34e15a34d51$export$2e2bcd8739ae039 = ({ match: match })=>{
    const issueKey = `/${match.params && match.params.issueKey || ''}`;
    const timescaleId = `/${match.params && match.params.timescaleId || ''}`;
    const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $7281c34e15a34d51$export$c2f0d3c59c9d3bf3,
        pageId: `spa-apps/servicedesk/reports/issue${issueKey}${timescaleId}${oldIssueView}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("lxYCP", function(module, exports) {

let $fafbb4f0ed50f21f$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $fafbb4f0ed50f21f$var$load("kNFvF"),
    $fafbb4f0ed50f21f$var$load("kVX56"),
    $fafbb4f0ed50f21f$var$load("76n7a"),
    $fafbb4f0ed50f21f$var$load("l253H"),
    $fafbb4f0ed50f21f$var$load("lUXnl")
]).then(()=>parcelRequire('kXHaM'));

});



parcelRegister("6un8I", function(module, exports) {

$parcel$export(module.exports, "servicedeskKbRequestsReportsTimeScaleRouteEntry", () => $bb1d631cc0a3bc8b$export$1c6b1e308d58ca8b);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $cKqlJ = parcelRequire("cKqlJ");

var $6Z2mh = parcelRequire("6Z2mh");

var $cVTuT = parcelRequire("cVTuT");
const $bb1d631cc0a3bc8b$export$1c6b1e308d58ca8b = (0, $7NszV.createEntry)((0, $cKqlJ.servicedeskKbRequestsReportsTimeScaleRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.kb-requests',
        component: (0, $cVTuT.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cVTuT.LazyServicedeskKbRequestsReports)
        ]
    }));

});
parcelRegister("cKqlJ", function(module, exports) {

$parcel$export(module.exports, "servicedeskKbRequestsReportsTimeScaleRoute", () => $7032eddc67e65c51$export$1585b6f8f1838e19);
const $7032eddc67e65c51$export$1585b6f8f1838e19 = {
    name: 'servicedesk-kb-requests-reports-time-scale',
    path: '/jira/servicedesk/projects/:projectKey/reports/:reportId(kb-requests-resolved|kb-requests-deflected)/timescale/:timescaleId'
};

});


parcelRegister("c97hk", function(module, exports) {

$parcel$export(module.exports, "servicedeskReports1RouteEntry", () => $28c558427771b7f4$export$8055c8b2162cf5bd);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");

var $3HwlS = parcelRequire("3HwlS");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $cJTRV = parcelRequire("cJTRV");

var $6Z2mh = parcelRequire("6Z2mh");

var $7tQej = parcelRequire("7tQej");


var $IT9I6 = parcelRequire("IT9I6");

var $4QhHa = parcelRequire("4QhHa");
const $28c558427771b7f4$var$DefaultReportsRedirect = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/jira/servicedesk/projects/${String(match.params.projectKey)}${(0, $d37b1fd9e7afc201$export$ddc580d759168f88)}`
    });
const $28c558427771b7f4$export$8055c8b2162cf5bd = (0, $7NszV.createEntry)((0, $cJTRV.servicedeskReports1Route), ()=>({
        group: 'servicedesk',
        component: (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), (0, $4QhHa.default), $28c558427771b7f4$var$DefaultReportsRedirect),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $IT9I6.getReportsWithKbResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4QhHa.LazyServicedeskReportsHomePage)
        ]
    }));

});
parcelRegister("cJTRV", function(module, exports) {

$parcel$export(module.exports, "servicedeskReports1Route", () => $ddba74d9a05765e5$export$f5adfd681a4e85ad);
const $ddba74d9a05765e5$export$f5adfd681a4e85ad = {
    name: 'servicedesk-reports',
    path: '/jira/servicedesk/projects/:projectKey/reports',
    exact: true
};

});

const $d37b1fd9e7afc201$export$e4c007d05145b8c2 = '/reports/all-rating';
const $d37b1fd9e7afc201$export$ddc580d759168f88 = '/reports/workload';
const $d37b1fd9e7afc201$export$13bdc187fca9c33e = '/reports';

parcelRegister("IT9I6", function(module, exports) {

$parcel$export(module.exports, "getReportsWithKbResources", () => $fbd9e6ca0682c0bc$export$1a63e9cdf8268e40);

var $bjZiV = parcelRequire("bjZiV");

var $fpjJX = parcelRequire("fpjJX");
const $fbd9e6ca0682c0bc$export$1a63e9cdf8268e40 = ()=>[
        ...(0, $fpjJX.getServicedeskPageContextResources)(),
        (0, $bjZiV.kbConfluenceContextResource)
    ];

});

parcelRegister("4QhHa", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskReportsHomePage", () => $2636e09e0764ad56$export$121b9cfb2b001a53);
$parcel$export(module.exports, "default", () => $2636e09e0764ad56$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");


const $2636e09e0764ad56$export$121b9cfb2b001a53 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("iPowq"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-home-page/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2636e09e0764ad56$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2636e09e0764ad56$export$121b9cfb2b001a53,
        pageId: `spa-apps/servicedesk${(0, $d37b1fd9e7afc201$export$13bdc187fca9c33e)}}`,
        shouldShowSpinner: true
    });

});
parcelRegister("iPowq", function(module, exports) {

let $db5002f63be16b11$var$load = (parcelRequire("28QjX"))(4);
module.exports = $db5002f63be16b11$var$load("lP9Ot").then(()=>parcelRequire('i1BaA'));

});



parcelRegister("7sSEm", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustom4RouteEntry", () => $bc9f120c03f314db$export$5ef62fad7280cd08);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $2cp29 = parcelRequire("2cp29");

var $6Z2mh = parcelRequire("6Z2mh");

var $3FrpL = parcelRequire("3FrpL");
const $bc9f120c03f314db$export$5ef62fad7280cd08 = (0, $7NszV.createEntry)((0, $2cp29.servicedeskReportsCustom4Route), ()=>({
        group: 'servicedesk',
        component: (0, $3FrpL.default),
        perfMetricKey: 'service-management.reports.custom',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3FrpL.LazyServicedeskReportsCustom)
        ],
        ufoName: 'service-management-custom-reports'
    }));

});
parcelRegister("2cp29", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustom4Route", () => $47b22144a185fe3a$export$39325072940fb58c);
const $47b22144a185fe3a$export$39325072940fb58c = {
    name: 'servicedesk-reports-custom',
    path: '/jira/servicedesk/projects/:projectKey/reports/custom/:reportId'
};

});

parcelRegister("3FrpL", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskReportsCustom", () => $940ea7d208fcfce4$export$3ec5c3d7729889b9);
$parcel$export(module.exports, "default", () => $940ea7d208fcfce4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $940ea7d208fcfce4$export$3ec5c3d7729889b9 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("dIOmK"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-custom/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$940ea7d208fcfce4$export$2e2bcd8739ae039 = ({ match: match })=>{
    const reportType = match.params.reportType || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $940ea7d208fcfce4$export$3ec5c3d7729889b9,
        pageId: `spa-apps/servicedesk/reports/${reportType}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("dIOmK", function(module, exports) {

let $9fd6740cb20cd1f5$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9fd6740cb20cd1f5$var$load("ffQaD"),
    $9fd6740cb20cd1f5$var$load("kvRbA"),
    $9fd6740cb20cd1f5$var$load("hLTt5")
]).then(()=>parcelRequire('gIY6j'));

});



parcelRegister("eaXgt", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustomCreateRouteEntry", () => $2cf0babd3b9237c1$export$b806d1abc9172b6d);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $17wjD = parcelRequire("17wjD");

var $6Z2mh = parcelRequire("6Z2mh");

var $3I9YI = parcelRequire("3I9YI");
const $2cf0babd3b9237c1$export$b806d1abc9172b6d = (0, $7NszV.createEntry)((0, $17wjD.servicedeskReportsCustomCreateRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.custom-create',
        component: (0, $3I9YI.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3I9YI.LazyServicedeskReportsCustomCreate)
        ]
    }));

});
parcelRegister("17wjD", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustomCreateRoute", () => $c5c6b7b61be9d580$export$333e623d5eb41af0);
const $c5c6b7b61be9d580$export$333e623d5eb41af0 = {
    name: 'servicedesk-reports-custom-create',
    path: '/jira/servicedesk/projects/:projectKey/reports/custom/new'
};

});

parcelRegister("3I9YI", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskReportsCustomCreate", () => $0aaa6fdfa8d01159$export$821b8201b24f8b7d);
$parcel$export(module.exports, "default", () => $0aaa6fdfa8d01159$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $0aaa6fdfa8d01159$export$821b8201b24f8b7d = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("3oiDL"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-custom-create/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0aaa6fdfa8d01159$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $0aaa6fdfa8d01159$export$821b8201b24f8b7d,
        pageId: "spa-apps/servicedesk/reports/custom/create",
        shouldShowSpinner: true
    });

});
parcelRegister("3oiDL", function(module, exports) {

let $278212941c954458$var$load = (parcelRequire("28QjX"))(4);
module.exports = $278212941c954458$var$load("jIVQO").then(()=>parcelRequire('bYkUJ'));

});



parcelRegister("moUwl", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustomEditRouteEntry", () => $79d751c5c6540b74$export$c4c3dcf824e7036e);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $b3EQX = parcelRequire("b3EQX");

var $6Z2mh = parcelRequire("6Z2mh");

var $gnyZS = parcelRequire("gnyZS");
const $79d751c5c6540b74$export$c4c3dcf824e7036e = (0, $7NszV.createEntry)((0, $b3EQX.servicedeskReportsCustomEditRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.custom-edit-view',
        component: (0, $gnyZS.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gnyZS.LazyServicedeskReportsCustomEdit)
        ]
    }));

});
parcelRegister("b3EQX", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustomEditRoute", () => $175ba21e4ba52ddb$export$3b6b3105a9ef9b83);
const $175ba21e4ba52ddb$export$3b6b3105a9ef9b83 = {
    name: 'servicedesk-reports-custom-edit',
    path: '/jira/servicedesk/projects/:projectKey/reports/custom/:reportId/edit'
};

});

parcelRegister("gnyZS", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskReportsCustomEdit", () => $db3dd114755c3f65$export$53def03ace9a6c5b);
$parcel$export(module.exports, "default", () => $db3dd114755c3f65$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $db3dd114755c3f65$export$53def03ace9a6c5b = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("1oIgh"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-custom-edit/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$db3dd114755c3f65$export$2e2bcd8739ae039 = ({ match: match })=>{
    const { reportId: reportId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $db3dd114755c3f65$export$53def03ace9a6c5b,
        pageId: `spa-apps/servicedesk/reports/custom/${reportId || ''}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("1oIgh", function(module, exports) {

let $104a5dc6eb4d6b0b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $104a5dc6eb4d6b0b$var$load("4ynxu").then(()=>parcelRequire('cOaoL'));

});



parcelRegister("7D3Yv", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustomIssueRouteEntry", () => $db3c4c23d5eb6125$export$222c6398b69dbc6d);

var $ffza4 = parcelRequire("ffza4");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $jlOGG = parcelRequire("jlOGG");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $7QuMl = parcelRequire("7QuMl");

var $6Z2mh = parcelRequire("6Z2mh");

var $lAGdd = parcelRequire("lAGdd");

var $1hJVy = parcelRequire("1hJVy");
const $db3c4c23d5eb6125$export$222c6398b69dbc6d = (0, $7NszV.createEntry)((0, $7QuMl.servicedeskReportsCustomIssueRoute), ()=>({
        group: 'servicedesk',
        component: (0, $1hJVy.default),
        layout: (0, $aPfsS.composeLayouts)((0, $6Z2mh.serviceProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)()),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $jlOGG.newIssueViewLockInStatusResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $lAGdd.aiContextPanelResource)
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $1hJVy.LazyServicedeskReportsIssueView)
        ],
        ufoName: 'service-management.reports.issue'
    }));

});
parcelRegister("7QuMl", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustomIssueRoute", () => $3e79cb7a6fb28a4d$export$1cfe539c854438e8);
const $3e79cb7a6fb28a4d$export$1cfe539c854438e8 = {
    name: 'servicedesk-reports-custom-time-scale-issue',
    path: '/jira/servicedesk/projects/:projectKey/reports/custom/:reportId/timescale/:timescaleId/:issueKey',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});


parcelRegister("dgneZ", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustomTimeScaleRouteEntry", () => $422e88992a614b49$export$508d5e1a59322a54);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $jBB4F = parcelRequire("jBB4F");

var $6Z2mh = parcelRequire("6Z2mh");

var $3FrpL = parcelRequire("3FrpL");
const $422e88992a614b49$export$508d5e1a59322a54 = (0, $7NszV.createEntry)((0, $jBB4F.servicedeskReportsCustomTimeScaleRoute), ()=>({
        group: 'servicedesk',
        component: (0, $3FrpL.default),
        perfMetricKey: 'service-management.reports.custom',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3FrpL.LazyServicedeskReportsCustom)
        ],
        ufoName: 'service-management-custom-reports'
    }));

});
parcelRegister("jBB4F", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsCustomTimeScaleRoute", () => $3a492ac932fcb1b3$export$eae9a65fe3f035ef);
const $3a492ac932fcb1b3$export$eae9a65fe3f035ef = {
    name: 'servicedesk-reports-custom-time-scale',
    path: '/jira/servicedesk/projects/:projectKey/reports/custom/:reportId/timescale/:timescaleId'
};

});


parcelRegister("hRN7l", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsSatisfaction2RouteEntry", () => $eebc12aca0cec40e$export$d6fb66bfd4a40ef);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $bsSH9 = parcelRequire("bsSH9");

var $6Z2mh = parcelRequire("6Z2mh");

var $8Xwpi = parcelRequire("8Xwpi");
const $eebc12aca0cec40e$export$d6fb66bfd4a40ef = (0, $7NszV.createEntry)((0, $bsSH9.servicedeskReportsSatisfaction2Route), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.satisfaction',
        component: (0, $8Xwpi.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8Xwpi.LazyServicedeskReportsSatisfaction)
        ]
    }));

});
parcelRegister("bsSH9", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsSatisfaction2Route", () => $15dedc31928a1123$export$22fd25b495033fdf);
const $15dedc31928a1123$export$22fd25b495033fdf = {
    name: 'servicedesk-reports-satisfaction',
    path: '/jira/servicedesk/projects/:projectKey/reports/all-rating'
};

});

parcelRegister("8Xwpi", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskReportsSatisfaction", () => $66f1c14673116eb8$export$8edc7b9d922cd22f);
$parcel$export(module.exports, "default", () => $66f1c14673116eb8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");


const $66f1c14673116eb8$export$8edc7b9d922cd22f = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("kCuJl"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-satisfaction/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$66f1c14673116eb8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $66f1c14673116eb8$export$8edc7b9d922cd22f,
        pageId: `spa-apps/servicedesk${(0, $d37b1fd9e7afc201$export$e4c007d05145b8c2)}}`,
        shouldShowSpinner: true
    });

});
parcelRegister("kCuJl", function(module, exports) {

let $f02f31a67700b899$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f02f31a67700b899$var$load("ffQaD"),
    $f02f31a67700b899$var$load("kvRbA"),
    $f02f31a67700b899$var$load("1lERf")
]).then(()=>parcelRequire('hLsyG'));

});



parcelRegister("cU5zd", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsSatisfactionIssueRouteEntry", () => $28e15c46fa77f0cb$export$6b98300c0f2ab048);

var $ffza4 = parcelRequire("ffza4");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $jlOGG = parcelRequire("jlOGG");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $i69aA = parcelRequire("i69aA");

var $6Z2mh = parcelRequire("6Z2mh");

var $lAGdd = parcelRequire("lAGdd");

var $1hJVy = parcelRequire("1hJVy");
const $28e15c46fa77f0cb$export$6b98300c0f2ab048 = (0, $7NszV.createEntry)((0, $i69aA.servicedeskReportsSatisfactionIssueRoute), ()=>({
        group: 'servicedesk',
        component: (0, $1hJVy.default),
        layout: (0, $aPfsS.composeLayouts)((0, $6Z2mh.serviceProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)()),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $jlOGG.newIssueViewLockInStatusResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $lAGdd.aiContextPanelResource)
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $1hJVy.LazyServicedeskReportsIssueView)
        ],
        ufoName: 'service-management.reports.issue'
    }));

});
parcelRegister("i69aA", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsSatisfactionIssueRoute", () => $c513c6729e01b870$export$da606765550c7e7);
const $c513c6729e01b870$export$da606765550c7e7 = {
    name: 'servicedesk-reports-satisfaction-time-scale-issue',
    path: '/jira/servicedesk/projects/:projectKey/reports/all-rating/timescale/:timescaleId/:issueKey',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});


parcelRegister("fSktp", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsSatisfactionTimeScaleRouteEntry", () => $460b54aef192ce9f$export$8d7026b8c74a8be8);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $lH1vR = parcelRequire("lH1vR");

var $6Z2mh = parcelRequire("6Z2mh");

var $8Xwpi = parcelRequire("8Xwpi");
const $460b54aef192ce9f$export$8d7026b8c74a8be8 = (0, $7NszV.createEntry)((0, $lH1vR.servicedeskReportsSatisfactionTimeScaleRoute), ()=>({
        group: 'servicedesk',
        perfMetricKey: 'service-management.reports.satisfaction',
        component: (0, $8Xwpi.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8Xwpi.LazyServicedeskReportsSatisfaction)
        ]
    }));

});
parcelRegister("lH1vR", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsSatisfactionTimeScaleRoute", () => $51118689f933b851$export$64ae70b2d6b34c4e);
const $51118689f933b851$export$64ae70b2d6b34c4e = {
    name: 'servicedesk-reports-satisfaction-time-scale',
    path: '/jira/servicedesk/projects/:projectKey/reports/all-rating/timescale/:timescaleId'
};

});


parcelRegister("5TKdO", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsTypeRouteEntry", () => $2e5063c16517b80e$export$bc47b2df6d39fd3f);

var $ffza4 = parcelRequire("ffza4");

var $g5RGc = parcelRequire("g5RGc");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $jlOGG = parcelRequire("jlOGG");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $iYmop = parcelRequire("iYmop");

var $6Z2mh = parcelRequire("6Z2mh");

var $lAGdd = parcelRequire("lAGdd");

var $IT9I6 = parcelRequire("IT9I6");

var $6Hx2y = parcelRequire("6Hx2y");
const $2e5063c16517b80e$export$bc47b2df6d39fd3f = (0, $7NszV.createEntry)((0, $iYmop.servicedeskReportsTypeRoute), ()=>({
        group: 'servicedesk',
        component: (0, $6Hx2y.default),
        layout: (0, $aPfsS.composeLayouts)((0, $6Z2mh.serviceProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $IT9I6.getReportsWithKbResources)(),
            (0, $jlOGG.newIssueViewLockInStatusResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $lAGdd.aiContextPanelResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6Hx2y.LazyServicedeskReports)
        ]
    }));

});
parcelRegister("iYmop", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsTypeRoute", () => $48dd2701ffbb9a85$export$b955ac7f09c5dbb);
const $48dd2701ffbb9a85$export$b955ac7f09c5dbb = {
    name: 'servicedesk-reports-type',
    path: '/jira/servicedesk/projects/:projectKey/reports/:reportType/:reportId?/:reportsAction?/:timescaleId?/:issueKey?',
    query: [
        'oldIssueView?'
    ]
};

});

parcelRegister("6Hx2y", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskReports", () => $7131a1cafe24fb0a$export$75e043cf7a4e3661);
$parcel$export(module.exports, "default", () => $7131a1cafe24fb0a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $7131a1cafe24fb0a$export$75e043cf7a4e3661 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("7ndIc")), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports/src/index.tsx"
});
var /**
 * Dynamically loads the ServicedeskReports component, enhancing user experience by using deferred loading with a visual feedback.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$7131a1cafe24fb0a$export$2e2bcd8739ae039 = ({ match: match })=>{
    const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $7131a1cafe24fb0a$export$75e043cf7a4e3661,
        pageId: `spa-apps/servicedesk/reports/${match ? match.url : ''}${oldIssueView}`,
        shouldShowSpinner: true
    });
};

});
parcelRegister("7ndIc", function(module, exports) {

let $55e5514740be4e4d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $55e5514740be4e4d$var$load("3hBpW").then(()=>parcelRequire('dp6PR'));

});



parcelRegister("4zSYf", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsWorkloadRouteEntry", () => $6d0123422454b447$export$793ba749f18b4dd4);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $f55k4 = parcelRequire("f55k4");

var $6Z2mh = parcelRequire("6Z2mh");

var $iYH8s = parcelRequire("iYH8s");
const $6d0123422454b447$export$793ba749f18b4dd4 = (0, $7NszV.createEntry)((0, $f55k4.servicedeskReportsWorkloadRoute), ()=>({
        group: 'servicedesk',
        component: (0, $iYH8s.default),
        perfMetricKey: 'service-management.reports.workload',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $iYH8s.LazyServicedeskReportsWorkload)
        ]
    }));

});
parcelRegister("f55k4", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsWorkloadRoute", () => $339f526b78d38fe7$export$ce9b409ccf53e93c);
const $339f526b78d38fe7$export$ce9b409ccf53e93c = {
    name: 'servicedesk-reports-workload',
    path: '/jira/servicedesk/projects/:projectKey/reports/workload',
    exact: true
};

});

parcelRegister("iYH8s", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskReportsWorkload", () => $d985dd949edfaeac$export$e805fb47fdcd991);
$parcel$export(module.exports, "default", () => $d985dd949edfaeac$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");


const $d985dd949edfaeac$export$e805fb47fdcd991 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("lMSlP"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-workload/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d985dd949edfaeac$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d985dd949edfaeac$export$e805fb47fdcd991,
        pageId: `spa-apps/servicedesk${(0, $d37b1fd9e7afc201$export$ddc580d759168f88)}}`,
        shouldShowSpinner: true
    });

});
parcelRegister("lMSlP", function(module, exports) {

let $fdc83da7c215a866$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fdc83da7c215a866$var$load("ifHTD").then(()=>parcelRequire('bQ0Tt'));

});



parcelRegister("j175z", function(module, exports) {

$parcel$export(module.exports, "servicedeskServiceDetailsRouteEntry", () => $9ea7b1d46a5382bf$export$48af7c0b8f21929b);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $fPesd = parcelRequire("fPesd");

var $6Z2mh = parcelRequire("6Z2mh");

var $eGEo2 = parcelRequire("eGEo2");
const $9ea7b1d46a5382bf$export$48af7c0b8f21929b = (0, $7NszV.createEntry)((0, $fPesd.servicedeskServiceDetailsRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.service-details',
        component: (0, $eGEo2.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $eGEo2.LazyServicedeskServiceDetailsWithProjectContext)
        ]
    }));

});
parcelRegister("fPesd", function(module, exports) {

$parcel$export(module.exports, "servicedeskServiceDetailsRoute", () => $338c1e6694a650ce$export$fe5fe00b6d5eab87);
const $338c1e6694a650ce$export$fe5fe00b6d5eab87 = {
    name: 'servicedesk-service-details',
    path: '/jira/servicedesk/projects/:projectKey/services/:serviceAri'
};

});

parcelRegister("eGEo2", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskServiceDetailsWithProjectContext", () => $b6f27b3727e127d8$export$b154597f29589502);
$parcel$export(module.exports, "default", () => $b6f27b3727e127d8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $b6f27b3727e127d8$export$b154597f29589502 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("dkHUu"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/service-details-with-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b6f27b3727e127d8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $b6f27b3727e127d8$export$b154597f29589502,
        pageId: "spa-apps/servicedesk/service-details",
        shouldShowSpinner: true
    });

});
parcelRegister("dkHUu", function(module, exports) {

let $9b4f3440a9c9eddd$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9b4f3440a9c9eddd$var$load("fliVL"),
    $9b4f3440a9c9eddd$var$load("jNxcv")
]).then(()=>parcelRequire('cIaZn'));

});



parcelRegister("gQWOR", function(module, exports) {

$parcel$export(module.exports, "serviceDeskServiceDetailsWithoutProjectRouteEntry", () => $90fd21cadf51bf65$export$de2e645f69483ce);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $kew7L = parcelRequire("kew7L");

var $3jBnk = parcelRequire("3jBnk");
const $90fd21cadf51bf65$export$de2e645f69483ce = (0, $7NszV.createEntry)((0, $kew7L.serviceDeskServiceDetailsWithoutProjectRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.service-details-without-project',
        component: (0, $3jBnk.default),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3jBnk.LazyServicedeskServiceDetailsWithoutProjectContext)
        ],
        meta: {
            reporting: {
                id: 'servicedesk-service-details-without-project',
                packageName: 'jiraSpaAppsServicedeskServiceDetailsWithoutProjectContext"',
                teamName: 'Falcons'
            }
        }
    }));

});
parcelRegister("kew7L", function(module, exports) {

$parcel$export(module.exports, "serviceDeskServiceDetailsWithoutProjectRoute", () => $35fa5222e37aa796$export$25e1d58db18a7c8b);
const $35fa5222e37aa796$export$25e1d58db18a7c8b = {
    name: 'servicedesk-service-details-without-project',
    path: '/jira/servicedesk/services/:serviceAri'
};

});

parcelRegister("3jBnk", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskServiceDetailsWithoutProjectContext", () => $0bd916f0e88ab362$export$ba1931edde0ce20c);
$parcel$export(module.exports, "default", () => $0bd916f0e88ab362$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $0bd916f0e88ab362$export$ba1931edde0ce20c = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("7hJmX"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/service-details-without-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0bd916f0e88ab362$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $0bd916f0e88ab362$export$ba1931edde0ce20c,
        pageId: "spa-apps/servicedesk/service-details",
        shouldShowSpinner: true
    });

});
parcelRegister("7hJmX", function(module, exports) {

let $54dd505097c05b44$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $54dd505097c05b44$var$load("fliVL"),
    $54dd505097c05b44$var$load("jDV3A")
]).then(()=>parcelRequire('bWPI8'));

});



parcelRegister("zaQdk", function(module, exports) {

$parcel$export(module.exports, "servicedeskServiceModalEditRouteEntry", () => $92695f6b0e89b9c4$export$5698449b623d4af);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $hxTrJ = parcelRequire("hxTrJ");

var $6Z2mh = parcelRequire("6Z2mh");

var $3URFK = parcelRequire("3URFK");
const $92695f6b0e89b9c4$export$5698449b623d4af = (0, $7NszV.createEntry)((0, $hxTrJ.servicedeskServiceModalEditRoute), ()=>({
        group: 'servicedesk',
        component: (0, $3URFK.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3URFK.LazyServiceUpdateModalWithProjectContext)
        ]
    }));

});
parcelRegister("hxTrJ", function(module, exports) {

$parcel$export(module.exports, "servicedeskServiceModalEditRoute", () => $6a799f5afeb5f72a$export$319fbbab5eb49cbf);
const $6a799f5afeb5f72a$export$319fbbab5eb49cbf = {
    name: 'servicedesk-service-modal-edit',
    path: '/jira/servicedesk/service-modal/:serviceAri'
};

});

parcelRegister("3URFK", function(module, exports) {

$parcel$export(module.exports, "LazyServiceUpdateModalWithProjectContext", () => $ca64a28173fa79b9$export$8984aadca7e15d1);
$parcel$export(module.exports, "default", () => $ca64a28173fa79b9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $ca64a28173fa79b9$export$8984aadca7e15d1 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("c3P55")), {
    moduleId: "./src/packages/spa-apps/servicedesk/service-update-modal-without-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ca64a28173fa79b9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ca64a28173fa79b9$export$8984aadca7e15d1,
        pageId: "spa-apps/servicedesk/service-update-modal",
        shouldShowSpinner: true
    });

});
parcelRegister("c3P55", function(module, exports) {

let $8c7d637e2cd3fd73$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8c7d637e2cd3fd73$var$load("e222C").then(()=>parcelRequire('9LJAj'));

});



parcelRegister("4UU5H", function(module, exports) {

$parcel$export(module.exports, "servicedeskServiceModalNewRouteEntry", () => $42345241d55d66da$export$75c24699abe8e616);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $ch9Xu = parcelRequire("ch9Xu");

var $6Z2mh = parcelRequire("6Z2mh");

var $cUmrA = parcelRequire("cUmrA");
const $42345241d55d66da$export$75c24699abe8e616 = (0, $7NszV.createEntry)((0, $ch9Xu.servicedeskServiceModalNewRoute), ()=>({
        group: 'servicedesk',
        component: (0, $cUmrA.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cUmrA.LazyServiceCreateModalWithProjectContext)
        ]
    }));

});
parcelRegister("ch9Xu", function(module, exports) {

$parcel$export(module.exports, "servicedeskServiceModalNewRoute", () => $feeac99aa6e6a420$export$5b5ea97286af2784);
const $feeac99aa6e6a420$export$5b5ea97286af2784 = {
    name: 'servicedesk-service-modal-new',
    path: '/jira/servicedesk/service-modal',
    exact: true
};

});

parcelRegister("cUmrA", function(module, exports) {

$parcel$export(module.exports, "LazyServiceCreateModalWithProjectContext", () => $cd397b20b9604e50$export$7f4092c8e7b7d3ec);
$parcel$export(module.exports, "default", () => $cd397b20b9604e50$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $cd397b20b9604e50$export$7f4092c8e7b7d3ec = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("g4Ihb")), {
    moduleId: "./src/packages/spa-apps/servicedesk/service-create-modal-without-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cd397b20b9604e50$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $cd397b20b9604e50$export$7f4092c8e7b7d3ec,
        pageId: "spa-apps/servicedesk/service-create-modal",
        shouldShowSpinner: true
    });

});
parcelRegister("g4Ihb", function(module, exports) {

let $bb3f5d66fa136562$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bb3f5d66fa136562$var$load("jPaud").then(()=>parcelRequire('jBLt3'));

});



parcelRegister("izdjx", function(module, exports) {

$parcel$export(module.exports, "servicedeskServicesRouteEntry", () => $2498bd7e181dd343$export$5df203501090bc7f);

var $ffza4 = parcelRequire("ffza4");

var $1cxvE = parcelRequire("1cxvE");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $dePjO = parcelRequire("dePjO");

var $6Z2mh = parcelRequire("6Z2mh");

var $gLrf3 = parcelRequire("gLrf3");
const $2498bd7e181dd343$export$5df203501090bc7f = (0, $7NszV.createEntry)((0, $dePjO.servicedeskServicesRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.services',
        component: (0, $gLrf3.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            horizontal: (0, $1cxvE.AsyncJSMOperationsHorizontalNav),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $1cxvE.LazyJSMOperationsHorizontalNav),
            (0, $gLrf3.LazyServicedeskServicesWithProjectContext)
        ]
    }));

});
parcelRegister("dePjO", function(module, exports) {

$parcel$export(module.exports, "servicedeskServicesRoute", () => $93e32423b61f9abd$export$4a800381bda6d53c);
const $93e32423b61f9abd$export$4a800381bda6d53c = {
    name: 'servicedesk-services',
    path: '/jira/servicedesk/projects/:projectKey/services',
    exact: true
};

});

parcelRegister("gLrf3", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskServicesWithProjectContext", () => $6f003aeaf484cf06$export$4aa60213b3477cf6);
$parcel$export(module.exports, "default", () => $6f003aeaf484cf06$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $6f003aeaf484cf06$export$4aa60213b3477cf6 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("ajRNX")), {
    moduleId: "./src/packages/spa-apps/servicedesk/services-with-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6f003aeaf484cf06$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $6f003aeaf484cf06$export$4aa60213b3477cf6,
        pageId: "spa-apps/servicedesk/services",
        shouldShowSpinner: true
    });

});
parcelRegister("ajRNX", function(module, exports) {

let $78356a38b1a12cb0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $78356a38b1a12cb0$var$load("d6j4K").then(()=>parcelRequire('6MNnt'));

});



parcelRegister("eWSeK", function(module, exports) {

$parcel$export(module.exports, "serviceDeskServicesWithoutProjectRouteEntry", () => $48a572bbef08816c$export$7031f96c25be5e14);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $ddcmX = parcelRequire("ddcmX");

var $7zD3e = parcelRequire("7zD3e");
const $48a572bbef08816c$export$7031f96c25be5e14 = (0, $7NszV.createEntry)((0, $ddcmX.serviceDeskServicesWithoutProjectRoute), ()=>({
        group: 'servicedesk',
        ufoName: 'service-management.services-without-project',
        component: (0, $7zD3e.default),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $7zD3e.LazyServicedeskServicesWithoutProjectContext)
        ],
        meta: {
            reporting: {
                id: 'servicedesk-services-without-project',
                packageName: 'jiraSpaAppsServicedeskServicesWithoutProjectContext"',
                teamName: 'Falcons'
            }
        }
    }));

});
parcelRegister("ddcmX", function(module, exports) {

$parcel$export(module.exports, "serviceDeskServicesWithoutProjectRoute", () => $1c8a671593efdd17$export$3210e7c54c21be97);
const $1c8a671593efdd17$export$3210e7c54c21be97 = {
    name: 'servicedesk-services-without-project',
    path: '/jira/servicedesk/services',
    exact: true
};

});

parcelRegister("7zD3e", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskServicesWithoutProjectContext", () => $be661d3f8fec3b0f$export$fc385e1392a8e28);
$parcel$export(module.exports, "default", () => $be661d3f8fec3b0f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $be661d3f8fec3b0f$export$fc385e1392a8e28 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("dXUPN")), {
    moduleId: "./src/packages/spa-apps/servicedesk/services-without-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$be661d3f8fec3b0f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $be661d3f8fec3b0f$export$fc385e1392a8e28,
        pageId: "spa-apps/servicedesk/services",
        shouldShowSpinner: true
    });

});
parcelRegister("dXUPN", function(module, exports) {

let $a2acdf30f3724a8b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a2acdf30f3724a8b$var$load("2WlWD").then(()=>parcelRequire('1QgiZ'));

});



parcelRegister("16Svt", function(module, exports) {

$parcel$export(module.exports, "settingsAutomationRouteEntry", () => $2c9e65dfb42014f0$export$4df9f9dcaf8565c9);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $ii08q = parcelRequire("ii08q");

var $5pSYQ = parcelRequire("5pSYQ");

var $fMK33 = parcelRequire("fMK33");
const $2c9e65dfb42014f0$export$4df9f9dcaf8565c9 = (0, $7NszV.createEntry)((0, $ii08q.settingsAutomationRoute), ()=>({
        group: 'global-settings',
        component: (0, $fMK33.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $fMK33.LazyGlobalAutomation)
        ]
    }));

});
parcelRegister("ii08q", function(module, exports) {

$parcel$export(module.exports, "settingsAutomationRoute", () => $21b53826ac35bfbd$export$b314ab31b2da625b);
const $21b53826ac35bfbd$export$b314ab31b2da625b = {
    name: 'global-automation',
    path: '/jira/settings/automation',
    exact: true
};

});

parcelRegister("fMK33", function(module, exports) {

$parcel$export(module.exports, "LazyGlobalAutomation", () => $e4cf560ebe587071$export$4189991a2992b828);
$parcel$export(module.exports, "default", () => $e4cf560ebe587071$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $aZsz6 = parcelRequire("aZsz6");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $i9k4m = parcelRequire("i9k4m");

const $e4cf560ebe587071$export$4189991a2992b828 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("fF6eq"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/automation/src/index.tsx"
});
const $e4cf560ebe587071$export$7c85ddcd4f0a813f = ()=>{
    const page = (_, { selectedItem: selectedItem, ...rest })=>{
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
        const querystring = (0, $aZsz6.qs).stringify(rest, true);
        return `/automation${querystring}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i9k4m.RedirectToProjectType), {
        page: page
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e4cf560ebe587071$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e4cf560ebe587071$export$4189991a2992b828,
        pageId: "global-automation",
        shouldShowSpinner: false
    });

});
parcelRegister("i9k4m", function(module, exports) {

$parcel$export(module.exports, "RedirectToProjectType", () => $5f4113c49e08a927$export$8a3df560509448b8);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dxCvy = parcelRequire("dxCvy");

var $bVDE5 = parcelRequire("bVDE5");

var $7tQej = parcelRequire("7tQej");
var $2YP9W = parcelRequire("2YP9W");
var $doZTA = parcelRequire("doZTA");
const $5f4113c49e08a927$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $7tQej.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $8zOmE.fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, $2NMNM.useAnalyticsEvents), useResource: useResource = (0, $2YP9W.useResource), useRouter: useRouter = (0, $doZTA.useRouter), useSpaStateTransition: useSpaStateTransition = (0, $bVDE5.useSpaStateTransition) })=>{
    const [{ match: match, query: query, route: route }] = useRouter();
    const { data: data } = useResource((0, $dxCvy.projectContextResource));
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
    (0, $5uXOq.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $2vSU6.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $2vSU6.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};

});

parcelRegister("fF6eq", function(module, exports) {

let $b66f84dae9f17679$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b66f84dae9f17679$var$load("dyp0t").then(()=>parcelRequire('b0ztm'));

});



parcelRegister("7m5aN", function(module, exports) {

$parcel$export(module.exports, "settingsCmdbFieldConfigRouteEntry", () => $89fe0e9a025a7c8e$export$c68a412f25295511);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $kAymX = parcelRequire("kAymX");

var $gRzZD = parcelRequire("gRzZD");

var $5Td0i = parcelRequire("5Td0i");
const $89fe0e9a025a7c8e$export$c68a412f25295511 = (0, $7NszV.createEntry)((0, $kAymX.settingsCmdbFieldConfigRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.cmdb-field-config',
        component: (0, $5Td0i.AsyncCmdbFieldConfigPage),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $gRzZD.workspaceResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5Td0i.LazyCMDBFieldConfigAdmin)
        ]
    }));

});
parcelRegister("kAymX", function(module, exports) {

$parcel$export(module.exports, "settingsCmdbFieldConfigRoute", () => $db5ba62dbec4de6f$export$5097bfaa68f86ca6);
const $db5ba62dbec4de6f$export$5097bfaa68f86ca6 = {
    name: 'global-settings-issues-cmdb-field-config',
    path: '/secure/admin/CmdbObjectFieldConfiguration'
};

});

parcelRegister("5Td0i", function(module, exports) {

$parcel$export(module.exports, "LazyCMDBFieldConfigAdmin", () => $03d0290def261ead$export$ccc6da5137e23637);
$parcel$export(module.exports, "AsyncCmdbFieldConfigPage", () => $03d0290def261ead$export$8dfbe255f554ebab);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $03d0290def261ead$export$ccc6da5137e23637 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hYKAo"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/cmdb-field-config/src/index.tsx"
});
const $03d0290def261ead$export$8dfbe255f554ebab = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $03d0290def261ead$export$ccc6da5137e23637,
        pageId: "admin-pages-cmdb-field-config",
        shouldShowSpinner: true
    });

});
parcelRegister("hYKAo", function(module, exports) {

let $d16c2d48b4643d57$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d16c2d48b4643d57$var$load("23hZk").then(()=>parcelRequire('gXCe1'));

});



parcelRegister("kDimk", function(module, exports) {

$parcel$export(module.exports, "settingsOauthCredentialsRouteEntry", () => $360b9bb3a5e4b35a$export$d1c67ceb7c5e2d6a);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $iHiHz = parcelRequire("iHiHz");

var $7NszV = parcelRequire("7NszV");

var $ldGiq = parcelRequire("ldGiq");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $9Z37w = parcelRequire("9Z37w");

var $jTwes = parcelRequire("jTwes");
const $360b9bb3a5e4b35a$export$d1c67ceb7c5e2d6a = (0, $7NszV.createEntry)((0, $9Z37w.settingsOauthCredentialsRoute), ()=>({
        group: 'global-settings',
        component: (0, $jTwes.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $iHiHz.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $5bkvv.getNavigationSidebarGlobalSettingsResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $ldGiq.adminOauthCredentialsResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jTwes.LazyOAuthCredentialsAdmin)
        ],
        ufoName: 'admin.oauth-credentials'
    }));

});
parcelRegister("ldGiq", function(module, exports) {

$parcel$export(module.exports, "adminOauthCredentialsResource", () => $b7e65fd0b40325af$export$870d7919c1ca4482);

var $2M1hQ = parcelRequire("2M1hQ");
const $b7e65fd0b40325af$var$RESOURCE_TYPE_ADMIN_OAUTH_CREDENTIALS = 'ADMIN_OAUTH_CREDENTIALS';

const $b7e65fd0b40325af$export$870d7919c1ca4482 = (0, $2M1hQ.createResource)({
    type: $b7e65fd0b40325af$var$RESOURCE_TYPE_ADMIN_OAUTH_CREDENTIALS,
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("9ztLD"))
});

});
parcelRegister("9ztLD", function(module, exports) {

let $6f7e79204086cfdc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6f7e79204086cfdc$var$load("2MJAU").then(()=>parcelRequire('8EYbC'));

});


parcelRegister("9Z37w", function(module, exports) {

$parcel$export(module.exports, "settingsOauthCredentialsRoute", () => $79dbadc9937eefab$export$c0ee28def7ef8783);
const $79dbadc9937eefab$export$c0ee28def7ef8783 = {
    name: 'admin-oauth-credentials',
    path: '/secure/admin/oauth-credentials'
};

});

parcelRegister("jTwes", function(module, exports) {

$parcel$export(module.exports, "LazyOAuthCredentialsAdmin", () => $a25b27e0ebd790aa$export$101baa25055633e8);
$parcel$export(module.exports, "default", () => $a25b27e0ebd790aa$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $a25b27e0ebd790aa$export$101baa25055633e8 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("3h5VU"))), {
    moduleId: "./src/packages/spa-apps/admin-oauth-credentials/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a25b27e0ebd790aa$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $a25b27e0ebd790aa$export$101baa25055633e8,
        pageId: "admin-oauth-credentials",
        shouldShowSpinner: true
    });

});
parcelRegister("3h5VU", function(module, exports) {

let $26278fd3973058d3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $26278fd3973058d3$var$load("jkFsZ").then(()=>parcelRequire('imW3j'));

});



parcelRegister("fQCGk", function(module, exports) {

$parcel$export(module.exports, "softwareBacklogEmbedRouteEntry", () => $bec4451dd2be6ad0$export$7cd14dee22609378);


var $4R6GH = parcelRequire("4R6GH");

var $fKmub = parcelRequire("fKmub");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $3RJkv = parcelRequire("3RJkv");

var $bAB30 = parcelRequire("bAB30");

var $9SRRO = parcelRequire("9SRRO");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $2Ql51 = parcelRequire("2Ql51");

var $78yv1 = parcelRequire("78yv1");

var $1jxD5 = parcelRequire("1jxD5");

var $gNStA = parcelRequire("gNStA");

var $hKGEW = parcelRequire("hKGEW");
const $bec4451dd2be6ad0$export$7cd14dee22609378 = (0, $7NszV.createEntry)((0, $78yv1.softwareBacklogEmbedRoute), ()=>({
        group: 'software',
        component: (0, $hKGEW.BacklogPage),
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental-backlog'),
        layout: (0, $aPfsS.createLayout)({
            isChromeless: true
        }),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $bAB30.backlogResource),
            (0, $9SRRO.customFiltersResource),
            (0, $5bkvv.forgeBacklogModuleResource),
            (0, $5bkvv.forgeSprintModuleResource),
            (0, $2Ql51.themePreferenceResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('crocs-load_ai_enablement_in_backlog_router'), (0, $1jxD5.aiEntitlementResource))
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $hKGEW.LazyBacklogPage)
        ],
        ufoName: 'next-gen-backlog-embed',
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$c17f34c425972af1)
        }
    }));

});
parcelRegister("bAB30", function(module, exports) {

$parcel$export(module.exports, "backlogResource", () => $d3029439c7d3b0b0$export$31d171ba71468137);

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");


const $d3029439c7d3b0b0$export$31d171ba71468137 = (0, $gNStA.browserOnlyResourceWithCondition)(()=>false, (0, $2M1hQ.createResource)({
    type: (0, $fe839261f35d1611$export$a0ef589381533a7c),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("7osjY")),
    // SSR doesn't care about this and we can't check FFs here because its not in the render path
    maxAge: 3600000
}));

});
const $fe839261f35d1611$export$faa68b3df5415bcb = 'NEXTGEN_BACKLOG_CUSTOM_FILTERS';
const $fe839261f35d1611$export$a0ef589381533a7c = 'NEXTGEN_BACKLOG';

parcelRegister("7osjY", function(module, exports) {

let $5620be4b0c5ec4eb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5620be4b0c5ec4eb$var$load("dHucG").then(()=>parcelRequire('lq5RB'));

});


parcelRegister("9SRRO", function(module, exports) {

$parcel$export(module.exports, "customFiltersResource", () => $87093d7252240507$export$3e390340716755de);

var $dXq4S = parcelRequire("dXq4S");

var $ao2h1 = parcelRequire("ao2h1");

var $aYacW = parcelRequire("aYacW");

var $gNStA = parcelRequire("gNStA");

const $87093d7252240507$export$3e390340716755de = (0, $gNStA.browserOnlyResourceWithCondition)(()=>false, (0, $ao2h1.createRelayResource)({
    type: (0, $fe839261f35d1611$export$faa68b3df5415bcb),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $aYacW.default),
            variables: {
                boardId: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    captureErrors: true
}));

});
parcelRegister("aYacW", function(module, exports) {

$parcel$export(module.exports, "default", () => $16318ecaa49178e6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<066895e3c0e872466470887b4350609b>>
 * @relayHash 8bb4d5e3e502ca70e90f4e1bb2f1614f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 494a9992c544e6be8f44d8b97ba70f29edc0d248b0153079b00cda817f4f7082
const $16318ecaa49178e6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "viewBacklogCustomFiltersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "customFilter_softwareFilters_CustomFilterRelay"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "viewBacklogCustomFiltersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "CustomFilter",
                            "kind": "LinkedField",
                            "name": "customFilters",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        },
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "494a9992c544e6be8f44d8b97ba70f29edc0d248b0153079b00cda817f4f7082",
            "metadata": {},
            "name": "viewBacklogCustomFiltersQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$16318ecaa49178e6$var$node.hash = "071c255f9696fe84a9c3982d42cfa5c0";
var $16318ecaa49178e6$export$2e2bcd8739ae039 = $16318ecaa49178e6$var$node;

});


parcelRegister("78yv1", function(module, exports) {

$parcel$export(module.exports, "softwareBacklogEmbedRoute", () => $58a7d1c6d58c26bf$export$bc022a39c42aba2f);
const $58a7d1c6d58c26bf$export$bc022a39c42aba2f = {
    name: 'software-backlog-embed',
    path: '/jira/software/projects/:projectKey/boards/:boardId/backlog/embed',
    exact: true
};

});

parcelRegister("1jxD5", function(module, exports) {

$parcel$export(module.exports, "aiEntitlementResource", () => $f1ad36205823a0c5$export$1d7e36ec4890154f);
$parcel$export(module.exports, "useAiEntitlementResource", () => $f1ad36205823a0c5$export$58958385d85a6e72);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $e7VcZ = parcelRequire("e7VcZ");
const $f1ad36205823a0c5$var$RESOURCE_TYPE_AI_ENTITLEMENT = 'AI_ENTITLEMENT';
const $f1ad36205823a0c5$export$1d7e36ec4890154f = (0, $2M1hQ.createResource)({
    type: $f1ad36205823a0c5$var$RESOURCE_TYPE_AI_ENTITLEMENT,
    getKey: ()=>$f1ad36205823a0c5$var$RESOURCE_TYPE_AI_ENTITLEMENT,
    getData: ()=>(0, $e7VcZ.fetchAiEnablement)(),
    maxAge: 3600000
});
const $f1ad36205823a0c5$export$58958385d85a6e72 = ()=>(0, $2YP9W.useResource)($f1ad36205823a0c5$export$1d7e36ec4890154f);

});
parcelRegister("e7VcZ", function(module, exports) {

$parcel$export(module.exports, "fetchAiEnablement", () => $d2a02eb2068290e1$export$ad4105850d0ce824);

var $7f4tk = parcelRequire("7f4tk");
const $d2a02eb2068290e1$var$JIRA_SOFTWARE_AI_ENABLED_URL = '/rest/api/1/aiconfig/ai-enabled/jira-software';
const $d2a02eb2068290e1$export$ad4105850d0ce824 = async ()=>{
    // We could check for other jira products / confluence when we need to
    // Not doing that right now as it adds complexity & we need software only now
    // See `@atlassian/jira-platform-react-hooks-use-is-admin-hub-ai-enabled`
    const entitlementData = {
        isAiEnabledForJiraSoftware: null
    };
    try {
        const response = await (0, $7f4tk.default)($d2a02eb2068290e1$var$JIRA_SOFTWARE_AI_ENABLED_URL, {
            method: 'GET'
        });
        entitlementData.isAiEnabledForJiraSoftware = response.isEnabled;
    } catch (_) {
        entitlementData.isAiEnabledForJiraSoftware = null;
    }
    return entitlementData;
};

});


parcelRegister("hKGEW", function(module, exports) {

$parcel$export(module.exports, "LazyBacklogPage", () => $6275b1ced1324b76$export$edb4b8cf67d7d767);
$parcel$export(module.exports, "BacklogPage", () => $6275b1ced1324b76$export$471ffbe87b75af04);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $d3645 = parcelRequire("d3645");

const $6275b1ced1324b76$export$edb4b8cf67d7d767 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("l95JT"))), {
    moduleId: "./src/packages/spa-apps/next-gen-backlog/src/index.tsx"
});
const $6275b1ced1324b76$export$471ffbe87b75af04 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $6275b1ced1324b76$export$edb4b8cf67d7d767,
        pageId: `next-gen-backlog-${(0, $d3645.getBoardId)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });

});
parcelRegister("d3645", function(module, exports) {

$parcel$export(module.exports, "getBoardId", () => $8f60ec15db3f7d28$export$557c2f222778cea6);

var $ebyGx = parcelRequire("ebyGx");
const $8f60ec15db3f7d28$export$557c2f222778cea6 = ({ location: location, match: match })=>{
    if (match && match.params.boardId) return match.params.boardId;
    const { rapidView: rapidView } = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(location.search);
    return rapidView;
};

});

parcelRegister("l95JT", function(module, exports) {

let $f64ee3e90fca369b$var$load = (parcelRequire("28QjX"))(4);


module.exports = Promise.all([
    (parcelRequire("avM1e"))('jsw-backlog-main-component-refactor', function() {
        return Promise.all([
            $f64ee3e90fca369b$var$load("gWxOK"),
            $f64ee3e90fca369b$var$load("l253H"),
            $f64ee3e90fca369b$var$load("76n7a"),
            $f64ee3e90fca369b$var$load("kvRbA"),
            $f64ee3e90fca369b$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $f64ee3e90fca369b$var$load("IPRH2"),
            $f64ee3e90fca369b$var$load("l253H"),
            $f64ee3e90fca369b$var$load("76n7a"),
            $f64ee3e90fca369b$var$load("kvRbA"),
            $f64ee3e90fca369b$var$load("ffQaD")
        ]);
    }),
    (parcelRequire("avM1e"))('jsw-backlog-main-component-refactor', function() {
        return Promise.all([
            $f64ee3e90fca369b$var$load("gWxOK"),
            $f64ee3e90fca369b$var$load("l253H"),
            $f64ee3e90fca369b$var$load("76n7a"),
            $f64ee3e90fca369b$var$load("kvRbA"),
            $f64ee3e90fca369b$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $f64ee3e90fca369b$var$load("IPRH2"),
            $f64ee3e90fca369b$var$load("l253H"),
            $f64ee3e90fca369b$var$load("76n7a"),
            $f64ee3e90fca369b$var$load("kvRbA"),
            $f64ee3e90fca369b$var$load("ffQaD")
        ]);
    }),
    $f64ee3e90fca369b$var$load("kNFvF"),
    $f64ee3e90fca369b$var$load("ghmPk")
]).then(()=>parcelRequire('1Xeln'));

});



parcelRegister("1EVpW", function(module, exports) {

$parcel$export(module.exports, "softwareBacklogRouteEntry", () => $73cbd5374edd4b4f$export$a5f8ba02d2755510);


var $4R6GH = parcelRequire("4R6GH");

var $5f2bR = parcelRequire("5f2bR");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $3RJkv = parcelRequire("3RJkv");

var $bAB30 = parcelRequire("bAB30");

var $9SRRO = parcelRequire("9SRRO");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $fTg4y = parcelRequire("fTg4y");

var $i8JTM = parcelRequire("i8JTM");

var $e7bC3 = parcelRequire("e7bC3");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");

var $1jxD5 = parcelRequire("1jxD5");

var $6ypBw = parcelRequire("6ypBw");
const $73cbd5374edd4b4f$export$a5f8ba02d2755510 = (0, $7NszV.createEntry)((0, $fTg4y.softwareBacklogRoute), ()=>({
        group: 'software',
        skeleton: (0, $i8JTM.NextGenBacklogSkeleton),
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental-backlog'),
        layout: (0, $aPfsS.composeLayouts)((0, $e7bC3.softwareProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true,
            sidebarId: (0, $4R6GH.fg)('jfp-magma-fix-nav4-sidebar-client-api-call') ? (0, $lmyls.SIDEBAR_ID).CONTENT : undefined
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)({
                isUsingSidebarEntrypoint: (0, $4R6GH.fg)('jfp-magma-fix-nav4-sidebar-client-api-call')
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3Only),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResourceOnNav3Only),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $bAB30.backlogResource),
            (0, $9SRRO.customFiltersResource),
            (0, $5bkvv.forgeBacklogModuleResource),
            (0, $5bkvv.forgeSprintModuleResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource)),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('crocs-load_ai_enablement_in_backlog_router'), (0, $1jxD5.aiEntitlementResource))
        ],
        preloadOptions: {
            earlyChunks: [
                'software-backlog-early-entry'
            ]
        },
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        ufoName: 'next-gen-backlog',
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$c17f34c425972af1)
        },
        entryPoint: ()=>(0, $6ypBw.backlogPageEntrypoint)
    }));

});
parcelRegister("fTg4y", function(module, exports) {

$parcel$export(module.exports, "softwareBacklogRoute", () => $bb895b75440d1fb3$export$fb454ec14936c0ab);
const $bb895b75440d1fb3$export$fb454ec14936c0ab = {
    name: 'software-backlog',
    path: '/jira/software/projects/:projectKey/boards/:boardId/backlog'
};

});

parcelRegister("i8JTM", function(module, exports) {

$parcel$export(module.exports, "NextGenBacklogSkeleton", () => $de21fa38a510bb6d$export$33cd465913cf178f);
/* NextGenBacklogSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7XYc4 = parcelRequire("7XYc4");

var $dCm1o = parcelRequire("dCm1o");

var $hCy6k = parcelRequire("hCy6k");

var $5Pi2v = parcelRequire("5Pi2v");
const $de21fa38a510bb6d$export$433c2e8574f2e911 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5Pi2v)))
    });
const $de21fa38a510bb6d$export$88189b56881f213e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($de21fa38a510bb6d$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5Pi2v)))
    }));
const $de21fa38a510bb6d$var$BacklogSkeleton = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $de21fa38a510bb6d$export$88189b56881f213e, $de21fa38a510bb6d$export$433c2e8574f2e911);
const $de21fa38a510bb6d$export$33cd465913cf178f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", false ? {
        'data-ssr-placeholder': 'software-backlog-skeleton'
    } : {
        'data-ssr-placeholder-replace': 'software-backlog-skeleton'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($de21fa38a510bb6d$var$BacklogSkeleton, null));
// Adding this wrapper to override the border width from AppSkeletonImage
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $de21fa38a510bb6d$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1bgi _1xpi1tcg _1sbz1tcg _1cpn1tcg _13xs1tcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5Pi2v", function(module, exports) {
module.exports = new URL("next-gen-backlog-app-skeleton.tpl.28e29051.svg", import.meta.url).toString();

});


parcelRegister("6ypBw", function(module, exports) {

$parcel$export(module.exports, "backlogPageEntrypoint", () => $095a4b5c220745ce$export$1ccf08591607897d);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");

var $fT58V = parcelRequire("fT58V");

var $krpZe = parcelRequire("krpZe");

var $6avBT = parcelRequire("6avBT");
const $095a4b5c220745ce$export$1ccf08591607897d = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $6avBT.nextGenBacklogEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $fT58V.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $krpZe.nav4ProjectsContentEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("6avBT", function(module, exports) {

$parcel$export(module.exports, "nextGenBacklogEntryPoint", () => $bb040829e080170c$export$377b23d5a7dc4052);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $bb040829e080170c$export$377b23d5a7dc4052 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("l95JT")), {
        moduleId: "20e1173f"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});



parcelRegister("azyVo", function(module, exports) {

$parcel$export(module.exports, "softwareBoardEmbedRouteEntry", () => $8db4a1001ea28148$export$ff8632c8a0f5d984);


var $4R6GH = parcelRequire("4R6GH");

var $fKmub = parcelRequire("fKmub");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $5qQ9I = parcelRequire("5qQ9I");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $2Ql51 = parcelRequire("2Ql51");

var $eeXsz = parcelRequire("eeXsz");

var $4IqZT = parcelRequire("4IqZT");

var $aRjc0 = parcelRequire("aRjc0");

var $2QA6X = parcelRequire("2QA6X");

var $itbWq = parcelRequire("itbWq");

var $kirSA = parcelRequire("kirSA");
const $8db4a1001ea28148$export$ff8632c8a0f5d984 = (0, $7NszV.createEntry)((0, $eeXsz.softwareBoardEmbedRoute), ()=>({
        group: 'software',
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental-board'),
        layout: (0, $aPfsS.createLayout)({
            isChromeless: true
        }),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $4IqZT.conditionalBoardNBTOptInResource),
            (0, $2QA6X.conditionalBoardResource),
            (0, $aRjc0.conditionalBoardRelayResource),
            (0, $5qQ9I.boardFilterRefinementResource),
            (0, $itbWq.conditionalCustomFiltersResource),
            (0, $2Ql51.themePreferenceResource),
            (0, $5bkvv.forgeBoardModuleResource)
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        entryPoint: ()=>(0, $kirSA.softwareBoardPageEntrypoint),
        ufoName: 'next-gen-board-embed',
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$f364828958cffad0)
        }
    }));

});
parcelRegister("5qQ9I", function(module, exports) {

$parcel$export(module.exports, "boardResource", () => $21d99b29ea940c83$export$286b76e0f2661cfb);
$parcel$export(module.exports, "customFiltersResource", () => $21d99b29ea940c83$export$3e390340716755de);
$parcel$export(module.exports, "boardFilterRefinementResource", () => $21d99b29ea940c83$export$283d16e3e02421f0);
$parcel$export(module.exports, "boardRelayResource", () => $21d99b29ea940c83$export$81ac23db76b1f935);
// eslint-disable-next-line jira/import-whitelist -- Unclear how to change the config whilst we transition to flat config

var $6s1PB = parcelRequire("6s1PB");

var $dXq4S = parcelRequire("dXq4S");

var $ao2h1 = parcelRequire("ao2h1");

var $6mTNg = parcelRequire("6mTNg");

var $9fgCw = parcelRequire("9fgCw");

var $ke2kk = parcelRequire("ke2kk");

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");


const $21d99b29ea940c83$export$286b76e0f2661cfb = (0, $gNStA.browserOnlyResourceWithCondition)(()=>false, (0, $2M1hQ.createResource)({
    type: (0, $a00fc8fb83f2948a$export$a38ac7339e3f31db),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("dhimE")),
    // SSR doesn't care about this and we can't check FFs here because its not in the render path
    maxAge: 3600000
}));
const $21d99b29ea940c83$export$3e390340716755de = (0, $gNStA.browserOnlyResourceWithCondition)(()=>false, (0, $ao2h1.createRelayResource)({
    type: (0, $a00fc8fb83f2948a$export$b48bcc76a0105016),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $9fgCw.default),
            variables: {
                boardId: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
}));
const $21d99b29ea940c83$export$283d16e3e02421f0 = (0, $gNStA.resourceWithCondition2)(()=>(0, $6s1PB.expVal)('filter_refinement_in_tmp_board', 'isEnabled', false), (0, $ao2h1.createRelayResource)({
    type: (0, $a00fc8fb83f2948a$export$339da8fd7fc0a8e9),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $ke2kk.default),
            variables: {
                cloudId: tenantContext.cloudId,
                boardId: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                }),
                filterRefinementScope: {
                    board: {
                        boardId: Number(match.params.boardId)
                    }
                }
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isBrowserOnly: true
}));
const $21d99b29ea940c83$export$81ac23db76b1f935 = (0, $gNStA.browserOnlyResourceWithCondition)(()=>false, (0, $ao2h1.createRelayResource)({
    type: (0, $a00fc8fb83f2948a$export$5cef388780439aec),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $6mTNg.default),
            variables: {
                boardId: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
}));

});
parcelRegister("6mTNg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddc6b6eeb5cc2255$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<916f92cb49153da25a6abe2a4d651185>>
 * @relayHash 1b45667561f9430ea4e961757485983b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ab366f74068bb048193650cda464a839daec6f71dd9d1e7ee8874e9f9959ba67
const $ddc6b6eeb5cc2255$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "ab366f74068bb048193650cda464a839daec6f71dd9d1e7ee8874e9f9959ba67",
        "metadata": {},
        "name": "boardWithRouterRelayQuery",
        "operationKind": "query",
        "text": null
    }
};
var $ddc6b6eeb5cc2255$export$2e2bcd8739ae039 = $ddc6b6eeb5cc2255$var$node;

});

parcelRegister("9fgCw", function(module, exports) {

$parcel$export(module.exports, "default", () => $59a4f75157ae0306$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3e40c06e874adef0395c5788a7d119a9>>
 * @relayHash fa277d121f8f09e75035802d7ede6889
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a079984b25df71d288de249187cdd59463b205124f1a0a13756db6b3207ef56b
const $59a4f75157ae0306$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a079984b25df71d288de249187cdd59463b205124f1a0a13756db6b3207ef56b",
        "metadata": {},
        "name": "viewBoardCustomFiltersQuery",
        "operationKind": "query",
        "text": null
    }
};
var $59a4f75157ae0306$export$2e2bcd8739ae039 = $59a4f75157ae0306$var$node;

});

parcelRegister("ke2kk", function(module, exports) {

$parcel$export(module.exports, "default", () => $32c6ecabe578696e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b2791ce93d3a0a0e17fee486ad965601>>
 * @relayHash 5c749d389bf268ee9226560ad568adcf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9283dbd6d43bd23893ba0d1fb905c533d07635b370710c93db0ea67cb8b41e06
const $32c6ecabe578696e$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "9283dbd6d43bd23893ba0d1fb905c533d07635b370710c93db0ea67cb8b41e06",
        "metadata": {},
        "name": "boardFilterRefinementQuery",
        "operationKind": "query",
        "text": null
    }
};
var $32c6ecabe578696e$export$2e2bcd8739ae039 = $32c6ecabe578696e$var$node;

});

const $a00fc8fb83f2948a$export$a38ac7339e3f31db = 'NEXTGEN_BOARD';
const $a00fc8fb83f2948a$export$b48bcc76a0105016 = 'NEXTGEN_BOARD_CUSTOM_FILTERS';
const $a00fc8fb83f2948a$export$5cef388780439aec = 'NEXTGEN_BOARD_RELAY';
const $a00fc8fb83f2948a$export$339da8fd7fc0a8e9 = 'NEXTGEN_BOARD_FILTER_REFINEMENT';

parcelRegister("dhimE", function(module, exports) {

let $9aab1baa202b1068$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9aab1baa202b1068$var$load("kVX56"),
    $9aab1baa202b1068$var$load("j6VPG")
]).then(()=>parcelRequire('11pNz'));

});


parcelRegister("eeXsz", function(module, exports) {

$parcel$export(module.exports, "softwareBoardEmbedRoute", () => $f06c20d996c477e6$export$f55626b64e3fcb4f);
const $f06c20d996c477e6$export$f55626b64e3fcb4f = {
    name: 'software-boards-embed',
    exact: true,
    path: '/jira/software/projects/:projectKey/boards/:boardId/embed'
};

});

parcelRegister("4IqZT", function(module, exports) {

$parcel$export(module.exports, "conditionalBoardNBTOptInResource", () => $e8f5fec2c725aeaf$export$3cdaa13b878c3c59);

var $c04PQ = parcelRequire("c04PQ");

var $ipmBb = parcelRequire("ipmBb");

var $gNStA = parcelRequire("gNStA");
const $e8f5fec2c725aeaf$export$3cdaa13b878c3c59 = (0, $gNStA.resourceWithCondition2)(()=>!(0, $c04PQ.isFedRamp)(), (0, $ipmBb.nextBestTaskFeatureResource));

});

parcelRegister("aRjc0", function(module, exports) {

$parcel$export(module.exports, "conditionalBoardRelayResource", () => $170e9c5fe0076e7e$export$ce009bf1a33fb264);

var $4R6GH = parcelRequire("4R6GH");

var $5qQ9I = parcelRequire("5qQ9I");

var $gNStA = parcelRequire("gNStA");
const $170e9c5fe0076e7e$export$ce009bf1a33fb264 = (0, $gNStA.resourceWithCondition)(()=>(0, $4R6GH.fg)('critical_board_query_with_relay'), (0, $5qQ9I.boardRelayResource));

});

parcelRegister("2QA6X", function(module, exports) {

$parcel$export(module.exports, "conditionalBoardResource", () => $ea9cac4f36af465b$export$2ba7dfd4089a1a57);

var $4R6GH = parcelRequire("4R6GH");

var $5qQ9I = parcelRequire("5qQ9I");

var $gNStA = parcelRequire("gNStA");
const $ea9cac4f36af465b$export$2ba7dfd4089a1a57 = (0, $gNStA.resourceWithCondition)(()=>!(0, $4R6GH.fg)('critical_board_query_with_relay'), (0, $5qQ9I.boardResource));

});

parcelRegister("itbWq", function(module, exports) {

$parcel$export(module.exports, "conditionalCustomFiltersResource", () => $1121c6a3d058cc47$export$ad9ac1bd5f72148c);

var $6s1PB = parcelRequire("6s1PB");

var $5qQ9I = parcelRequire("5qQ9I");

var $gNStA = parcelRequire("gNStA");
const $1121c6a3d058cc47$export$ad9ac1bd5f72148c = (0, $gNStA.resourceWithCondition2)(()=>!(0, $6s1PB.expVal)('filter_refinement_in_tmp_board', 'isEnabled', false), (0, $5qQ9I.customFiltersResource));

});

parcelRegister("kirSA", function(module, exports) {

$parcel$export(module.exports, "softwareBoardPageEntrypoint", () => $371682d9ceaef2cd$export$89009c28cae628ae);

var $lkFvK = parcelRequire("lkFvK");

var $fo6b8 = parcelRequire("fo6b8");

var $7rNZV = parcelRequire("7rNZV");

var $lmyls = parcelRequire("lmyls");
const $371682d9ceaef2cd$export$89009c28cae628ae = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7rNZV.nextGenBoardEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("7rNZV", function(module, exports) {

$parcel$export(module.exports, "nextGenBoardEntryPoint", () => $c106d875c43f76b2$export$bb3c6f02a735f848);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $c106d875c43f76b2$export$bb3c6f02a735f848 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("cfMm6")), {
        moduleId: "5be6be56"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});



parcelRegister("7wXr4", function(module, exports) {

$parcel$export(module.exports, "softwareBoardRouteEntry", () => $bc83504262104385$export$2964ea1cdd5afa39);


var $4R6GH = parcelRequire("4R6GH");

var $5f2bR = parcelRequire("5f2bR");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $5qQ9I = parcelRequire("5qQ9I");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $7wTzh = parcelRequire("7wTzh");

var $11dfA = parcelRequire("11dfA");

var $gNStA = parcelRequire("gNStA");

var $e7bC3 = parcelRequire("e7bC3");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");

var $4IqZT = parcelRequire("4IqZT");

var $aRjc0 = parcelRequire("aRjc0");

var $2QA6X = parcelRequire("2QA6X");

var $itbWq = parcelRequire("itbWq");

var $kirSA = parcelRequire("kirSA");
const $bc83504262104385$export$2964ea1cdd5afa39 = (0, $7NszV.createEntry)((0, $7wTzh.softwareBoardRoute), ()=>({
        group: 'software',
        skeleton: (0, $11dfA.NextGenBoardSkeleton),
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental-board'),
        layout: (0, $aPfsS.composeLayouts)((0, $e7bC3.softwareProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3Only),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResourceOnNav3Only),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $2QA6X.conditionalBoardResource),
            (0, $itbWq.conditionalCustomFiltersResource),
            (0, $5qQ9I.boardFilterRefinementResource),
            (0, $aRjc0.conditionalBoardRelayResource),
            (0, $4IqZT.conditionalBoardNBTOptInResource),
            (0, $5bkvv.forgeBoardModuleResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource))
        ],
        preloadOptions: {
            earlyChunks: [
                'software-board-early-entry'
            ]
        },
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        entryPoint: ()=>(0, $kirSA.softwareBoardPageEntrypoint),
        ufoName: 'next-gen-board',
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$f364828958cffad0)
        }
    }));

});
parcelRegister("11dfA", function(module, exports) {

$parcel$export(module.exports, "NextGenBoardSkeleton", () => $b1638a290dc4da1e$export$25a9d0fbcb127c90);
/* NextGenBoardSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $kNTTx = parcelRequire("kNTTx");
const $b1638a290dc4da1e$var$customCssStyles = null;
const $b1638a290dc4da1e$export$25a9d0fbcb127c90 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kNTTx))),
        className: (0, $bwpsq.default)([
            "_2zz1idpf"
        ])
    });

});
parcelRegister("kNTTx", function(module, exports) {
module.exports = new URL("next-gen-board-app-skeleton.tpl.d10f8ca5.svg", import.meta.url).toString();

});



parcelRegister("kutfD", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarEmbedRouteEntry", () => $99cba918a9dd41cf$export$24fc07c22f0d06);

var $6e4Kt = parcelRequire("6e4Kt");

var $4R6GH = parcelRequire("4R6GH");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $7NszV = parcelRequire("7NszV");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $2Ql51 = parcelRequire("2Ql51");

var $1oC4O = parcelRequire("1oC4O");

var $kZOse = parcelRequire("kZOse");

var $4p1Sa = parcelRequire("4p1Sa");
const $99cba918a9dd41cf$export$24fc07c22f0d06 = (0, $7NszV.createEntry)((0, $1oC4O.softwareCalendarEmbedRoute), ()=>({
        group: 'software',
        skeleton: (0, $kZOse.CalendarEmbedSkeleton),
        component: (0, $kZOse.CalendarEmbedSkeleton),
        entryPoint () {
            if (false) return undefined;
            return 0, $4p1Sa.calendarRouteEntry;
        },
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $2Ql51.themePreferenceResource)
        ],
        ufoName: 'next-gen-calendar-embed',
        EXPERIMENTAL__shouldReload: (0, $4R6GH.fg)('jira_fix_calendar_suspending_when_switching_months') ? ({ context: context, prevContext: prevContext })=>{
            return context.match.url !== prevContext.match.url;
        } : undefined
    }));

});
parcelRegister("1oC4O", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarEmbedRoute", () => $e9efd1396eb47ddd$export$b55c4d4efb097c1c);
const $e9efd1396eb47ddd$export$b55c4d4efb097c1c = {
    name: 'software-calendar-embed',
    path: '/jira/software/projects/:projectKey/boards/:boardId/calendar/embed',
    query: [
        'date?'
    ]
};

});

parcelRegister("4p1Sa", function(module, exports) {

$parcel$export(module.exports, "calendarRouteEntry", () => $a85dcaa61158a1a3$export$d154630e8966be91);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $dQ4vn = parcelRequire("dQ4vn");

var $fo6b8 = parcelRequire("fo6b8");
const $a85dcaa61158a1a3$export$d154630e8966be91 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $dQ4vn.calendarEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("dQ4vn", function(module, exports) {

$parcel$export(module.exports, "calendarEntryPoint", () => $d8251bf369abb7ad$export$19cf4b398f638dc6);

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $7JhZX = parcelRequire("7JhZX");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");
const $d8251bf369abb7ad$var$SETTINGS_STORAGE_KEY = 'calendar:settings:software';
function $d8251bf369abb7ad$var$getViewSettings(key) {
    try {
        const serializedValue = globalThis.localStorage?.getItem(key);
        return serializedValue !== null ? JSON.parse(serializedValue) : undefined;
    } catch  {
        return undefined;
    }
}
function $d8251bf369abb7ad$var$toBoardAri({ siteId: siteId, boardId: boardId }) {
    return `ari:cloud:jira-software:${siteId}:board/${boardId}`;
}
function $d8251bf369abb7ad$var$toMidnightUTCString(date) {
    const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return new Date(utcMilliseconds).toISOString();
}
function $d8251bf369abb7ad$var$toDate(date) {
    if (!date) return new Date();
    try {
        const _date = new Date(date);
        return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
    } catch (e) {
        return new Date();
    }
}
/* Given the current constraints that prevent importing route name constants into the entrypoint,
we are re-defining these constants here in order to perform a route name check.
Consider breaking this entrypoint per route to avoid these types of checks and dependencies. */ const $d8251bf369abb7ad$var$SOFTWARE_CALENDAR = 'software-calendar';
const $d8251bf369abb7ad$var$SOFTWARE_CALENDAR_EMBED = 'software-calendar-embed';
const $d8251bf369abb7ad$var$TEAM_MANAGED_CALENDAR_ROUTES = [
    $d8251bf369abb7ad$var$SOFTWARE_CALENDAR,
    $d8251bf369abb7ad$var$SOFTWARE_CALENDAR_EMBED
];
function $d8251bf369abb7ad$var$createScope({ context: context, tenantContext: tenantContext }) {
    const { cloudId: cloudId } = tenantContext;
    const isTMP = $d8251bf369abb7ad$var$TEAM_MANAGED_CALENDAR_ROUTES.includes(context.route.name);
    return {
        type: 'board',
        boardId: $d8251bf369abb7ad$var$toBoardAri({
            siteId: cloudId,
            boardId: String(context.match.params.boardId)
        }),
        projectKeys: isTMP ? [
            String(context.match.params.projectKey)
        ] : []
    };
}
function $d8251bf369abb7ad$var$buildScopeInput({ tenantContext: tenantContext }, scope) {
    const { cloudId: cloudId } = tenantContext;
    const scopeInput = {
        ids: [
            scope.boardId
        ]
    };
    if ((0, $4R6GH.fg)('jira_calendar_load_more_pagination') || scope.projectKeys && scope.projectKeys.length > 0) return {
        ...scopeInput,
        projectKeys: {
            cloudId: cloudId,
            keys: scope.projectKeys
        }
    };
    return scopeInput;
}
function $d8251bf369abb7ad$var$toViewMode(mode) {
    switch(mode){
        case 'week':
            return 'WEEK';
        case 'day':
            return 'DAY';
        default:
            return 'MONTH';
    }
}
function $d8251bf369abb7ad$var$toWeekStart(weekStart) {
    switch(weekStart){
        case 'monday':
            return 'MONDAY';
        case 'saturday':
            return 'SATURDAY';
        default:
            return 'SUNDAY';
    }
}
function $d8251bf369abb7ad$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField }) {
    return {
        date: $d8251bf369abb7ad$var$toMidnightUTCString(selectedDate),
        mode: $d8251bf369abb7ad$var$toViewMode(viewRange),
        weekStart: $d8251bf369abb7ad$var$toWeekStart(weekStartsOn),
        startDateField: startDateField,
        endDateField: endDateField,
        viewId: null
    };
}
function $d8251bf369abb7ad$var$buildIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $d8251bf369abb7ad$var$buildUnscheduledIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $d8251bf369abb7ad$var$buildVersionsSearchInput() {
    return {
        versionStatuses: [
            'RELEASED',
            'UNRELEASED'
        ]
    };
}
function $d8251bf369abb7ad$var$buildSprintsSearchInput() {
    return {
        sprintStates: [
            'ACTIVE',
            'FUTURE',
            'CLOSED'
        ]
    };
}

const $d8251bf369abb7ad$export$19cf4b398f638dc6 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("hLauq")), {
        moduleId: "57ee20a5"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        const { cloudId: cloudId } = tenantContext;
        const scope = $d8251bf369abb7ad$var$createScope(entryPointRouteParams);
        const { date: date } = context.query;
        const selectedDate = $d8251bf369abb7ad$var$toDate(date);
        const boardId = String(context.match.params.boardId);
        const settings = (0, $4R6GH.fg)('jira_calendar_load_more_pagination') ? $d8251bf369abb7ad$var$getViewSettings($d8251bf369abb7ad$var$SETTINGS_STORAGE_KEY) : undefined;
        const viewRange = 'month';
        const weekStartsOn = (0, $4R6GH.fg)('jira_calendar_load_more_pagination') ? settings?.weekStartsOn ?? 'sunday' : 'sunday';
        const startDateField = 'startdate';
        const endDateField = 'duedate';
        const issueEventFields = {
            startDateField: startDateField,
            endDateField: endDateField
        };
        return {
            queries: {
                calendarData: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $7JhZX.default,
                    variables: {
                        cloudId: cloudId,
                        scopeInput: $d8251bf369abb7ad$var$buildScopeInput(entryPointRouteParams, scope),
                        configurationInput: $d8251bf369abb7ad$var$buildConfigurationInput({
                            selectedDate: selectedDate,
                            viewRange: viewRange,
                            weekStartsOn: weekStartsOn,
                            startDateField: startDateField,
                            endDateField: endDateField
                        }),
                        issuesPageSize: (0, $4R6GH.fg)('jira_calendar_lazy_load') ? 200 : 50,
                        issuesSearchInput: $d8251bf369abb7ad$var$buildIssuesSearchInput(),
                        unscheduledIssuesSearchInput: $d8251bf369abb7ad$var$buildUnscheduledIssuesSearchInput(),
                        versionsSearchInput: $d8251bf369abb7ad$var$buildVersionsSearchInput(),
                        sprintsSearchInput: $d8251bf369abb7ad$var$buildSprintsSearchInput(),
                        includeRecurrenceIndicator: (0, $6s1PB.expValEquals)('jira-recur-single-work-item-on-schedule', 'isRecurrenceCalendarViewEnabled', true),
                        skipSprintSearch: false,
                        viewId: null,
                        schedulePermissionsEnabled: (0, $4R6GH.fg)('calendar_schedule_issue_permissions_check'),
                        pageLoadMoreEnabled: (0, $4R6GH.fg)('jira_calendar_load_more_pagination'),
                        skipVersionsV1Search: (0, $4R6GH.fg)('plan-calendar-versions-v2-adoption'),
                        skipVersionsV2Search: !(0, $4R6GH.fg)('plan-calendar-versions-v2-adoption'),
                        pageLoadMoreEnabledViewSettings: (0, $4R6GH.fg)('jira_calendar_load_more_pagination_view_settings')
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                scope: scope,
                selectedDate: selectedDate,
                viewRange: viewRange,
                weekStartsOn: weekStartsOn,
                issueEventFields: issueEventFields,
                boardId: boardId,
                hasRecurrenceItemIndicator: (0, $6s1PB.expValEquals)('jira-recur-single-work-item-on-schedule', 'isRecurrenceCalendarViewEnabled', true)
            }
        };
    }
});

});
parcelRegister("hLauq", function(module, exports) {

let $cedef683fe3d6740$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $cedef683fe3d6740$var$load("ffQaD"),
    $cedef683fe3d6740$var$load("kvRbA"),
    $cedef683fe3d6740$var$load("76n7a"),
    $cedef683fe3d6740$var$load("l253H"),
    $cedef683fe3d6740$var$load("f4bCw")
]).then(()=>parcelRequire('71XRW'));

});




parcelRegister("2z6Z2", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarRouteEntry", () => $31f17a935a7b6ad5$export$83b1b9036cc7961a);

var $ffza4 = parcelRequire("ffza4");

var $4R6GH = parcelRequire("4R6GH");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $582IH = parcelRequire("582IH");

var $kZOse = parcelRequire("kZOse");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");

var $4p1Sa = parcelRequire("4p1Sa");
const $31f17a935a7b6ad5$export$83b1b9036cc7961a = (0, $7NszV.createEntry)((0, $582IH.softwareCalendarRoute), ()=>({
        group: 'software',
        skeleton: (0, $kZOse.CalendarSkeleton),
        component: (0, $kZOse.CalendarSkeleton),
        entryPoint () {
            if (false) return undefined;
            return 0, $4p1Sa.calendarRouteEntry;
        },
        layout: (0, $aPfsS.composeLayouts)((0, $e7bC3.softwareProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource))
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ],
        ufoName: 'next-gen-calendar',
        EXPERIMENTAL__shouldReload: (0, $4R6GH.fg)('jira_fix_calendar_suspending_when_switching_months') ? ({ context: context, prevContext: prevContext })=>{
            return context.match.url !== prevContext.match.url;
        } : undefined
    }));

});
parcelRegister("582IH", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarRoute", () => $8d2c5695d9358265$export$d6730f103a4ad844);
const $8d2c5695d9358265$export$d6730f103a4ad844 = {
    name: 'software-calendar',
    path: '/jira/software/projects/:projectKey/boards/:boardId/calendar',
    query: [
        'date?'
    ]
};

});


parcelRegister("jvZP3", function(module, exports) {

$parcel$export(module.exports, "softwareDeploymentsNextGenRouteEntry", () => $fae05ab45ce767cc$export$7e5ccb20ad8e1612);

var $e4eHl = parcelRequire("e4eHl");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $b4koY = parcelRequire("b4koY");

var $7GnDe = parcelRequire("7GnDe");

var $3V85G = parcelRequire("3V85G");

var $kfztd = parcelRequire("kfztd");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $6LsQE = parcelRequire("6LsQE");

var $jBfl2 = parcelRequire("jBfl2");
const $fae05ab45ce767cc$export$7e5ccb20ad8e1612 = (0, $7NszV.createEntry)((0, $3V85G.softwareDeploymentsNextGenRoute), ()=>({
        group: 'software',
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $b4koY.deploymentPreconditionRelayResource),
            (0, $dxCvy.projectContextResource)
        ],
        entryPoint: ()=>(0, $kfztd.isDevopsFeatureDisabledInFedRamp)() ? (0, $6LsQE.notFoundPageEntrypoint) : (0, $jBfl2.softwareDeploymentsPageEntrypoint),
        meta: {
            reporting: {
                id: 'software-deployments',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-deployments'),
                teamName: 'fusion-solaris'
            }
        }
    }));

});
parcelRegister("b4koY", function(module, exports) {

$parcel$export(module.exports, "deploymentPreconditionRelayResource", () => $b79457e490ba4467$export$50e4eedb9e6127c8);

var $ao2h1 = parcelRequire("ao2h1");

var $ajgeO = parcelRequire("ajgeO");

var $2M1hQ = parcelRequire("2M1hQ");


const $b79457e490ba4467$export$a1c09d7f7318f85c = (0, $2M1hQ.createResource)({
    type: (0, $c47c39dbdbc02648$export$2171160371fac588),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("kpWNE")),
    maxAge: 60000
});
const $b79457e490ba4467$export$50e4eedb9e6127c8 = (0, $ao2h1.createRelayResource)({
    type: (0, $c47c39dbdbc02648$export$a969d0487e348031),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $ajgeO.default),
            variables: {
                cloudId: tenantContext.cloudId,
                projectKey: String(match.params.projectKey)
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("ajgeO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0f41d4aeb9b6b93$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<946bfee09c64f3e6ddd3c9cbab07a461>>
 * @relayHash ea273678a5c985c0053babf0f185662a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0b497951b118068d82bb77e253f1fcb758c4dde1aa7f8eb01bf559f5961522f2
const $e0f41d4aeb9b6b93$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }
    ], v1 = {
        "args": [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "projectKey",
                "variableName": "projectKey"
            }
        ],
        "kind": "ScalarField",
        "name": "deploymentsFeaturePreconditionByProjectKey"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "uiDeploymentsFeaturePreconditionQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v1 /*: any*/ ,
                                "action": "THROW",
                                "path": "jira.deploymentsFeaturePreconditionByProjectKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "uiDeploymentsFeaturePreconditionQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "0b497951b118068d82bb77e253f1fcb758c4dde1aa7f8eb01bf559f5961522f2",
            "metadata": {},
            "name": "uiDeploymentsFeaturePreconditionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e0f41d4aeb9b6b93$var$node.hash = "3337e3d6b76da02b643c63aacd15b239";
var $e0f41d4aeb9b6b93$export$2e2bcd8739ae039 = $e0f41d4aeb9b6b93$var$node;

});

const $c47c39dbdbc02648$export$2171160371fac588 = 'SOFTWARE_DEPLOYMENTS_PRECONDITION';
const $c47c39dbdbc02648$export$a969d0487e348031 = 'SOFTWARE_DEPLOYMENTS_PRECONDITION_RELAY';

parcelRegister("kpWNE", function(module, exports) {

let $edd3c0dba462d599$var$load = (parcelRequire("28QjX"))(4);
module.exports = $edd3c0dba462d599$var$load("l3NOh").then(()=>parcelRequire('96xO4'));

});


parcelRegister("3V85G", function(module, exports) {

$parcel$export(module.exports, "softwareDeploymentsNextGenRoute", () => $80f4392aa55fd172$export$4b0939825a323ea5);
const $80f4392aa55fd172$export$4b0939825a323ea5 = {
    name: 'software-deployments',
    path: '/jira/software/projects/:projectKey/deployments'
};

});

parcelRegister("jBfl2", function(module, exports) {

$parcel$export(module.exports, "softwareDeploymentsPageEntrypoint", () => $ced3b63436800171$export$44d7744645dea53c);

var $lkFvK = parcelRequire("lkFvK");

var $fo6b8 = parcelRequire("fo6b8");

var $lmyls = parcelRequire("lmyls");

var $4f7Zu = parcelRequire("4f7Zu");
const $ced3b63436800171$export$44d7744645dea53c = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $4f7Zu.softwareDeploymentsEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("4f7Zu", function(module, exports) {

$parcel$export(module.exports, "softwareDeploymentsEntrypoint", () => $1d95bd1b138a4f0c$export$c51c7780e55a0186);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $1d95bd1b138a4f0c$export$c51c7780e55a0186 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("4Djls")), {
        moduleId: "12d277d5"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4Djls", function(module, exports) {

let $35f9cf74ea5ba4c9$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $35f9cf74ea5ba4c9$var$load("76n7a"),
    $35f9cf74ea5ba4c9$var$load("l253H"),
    $35f9cf74ea5ba4c9$var$load("ffQaD"),
    $35f9cf74ea5ba4c9$var$load("kvRbA"),
    $35f9cf74ea5ba4c9$var$load("4cCGA")
]).then(()=>parcelRequire('5EQGR'));

});




parcelRegister("03taV", function(module, exports) {

$parcel$export(module.exports, "softwareFormBuilderRouteEntry", () => $21f43a00ab4a505f$export$e8dede7671fad23d);

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $3HwlS = parcelRequire("3HwlS");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $l2N2a = parcelRequire("l2N2a");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $6LsQE = parcelRequire("6LsQE");

var $hGNg4 = parcelRequire("hGNg4");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $evEd2 = parcelRequire("evEd2");

var $fo6b8 = parcelRequire("fo6b8");

var $lkFvK = parcelRequire("lkFvK");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");
const $21f43a00ab4a505f$var$formBuilderPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $evEd2.formBuilderEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $21f43a00ab4a505f$export$e8dede7671fad23d = (0, $7NszV.createEntry)((0, $hGNg4.softwareFormBuilderRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-form-builder',
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), (0, $5f2bR.AsyncHorizontalNavJira), ()=>null)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingM2Enabled)(), (0, $9V5k0.projectThemeResource))
        ],
        entryPoint: ()=>{
            return (0, $6s1PB.expVal)('forms_for_jsw_experiment', 'isEnabled', false) ? $21f43a00ab4a505f$var$formBuilderPageEntrypoint : (0, $6LsQE.notFoundPageEntrypoint);
        }
    }));

});
parcelRegister("hGNg4", function(module, exports) {

$parcel$export(module.exports, "softwareFormBuilderRoute", () => $2ce33b6906a0aad5$export$c5589046ee2a390d);
const $2ce33b6906a0aad5$export$c5589046ee2a390d = {
    name: 'software-form-builder',
    path: '/jira/software/projects/:projectKey/form/:formId/builder',
    exact: true
};

});

parcelRegister("evEd2", function(module, exports) {

$parcel$export(module.exports, "formBuilderEntrypoint", () => $169d3b5f1d6377cd$export$6d3c9fa7232f412c);

var $kTta5 = parcelRequire("kTta5");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $169d3b5f1d6377cd$export$6d3c9fa7232f412c = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("cqTQA")), {
        moduleId: "a7e5ed4a"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                formBuilderQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $kTta5.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("kTta5", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e840d497ba3b73a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cd13e4f001483f4b52003ed8bc472792>>
 * @relayHash e8f0191fa153f065f7266afab384a46c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 165f5de6118450a4d0cf4ac24900ba8099a89412eebcbf8f5dee46032eb83e21
const $0e840d497ba3b73a$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "165f5de6118450a4d0cf4ac24900ba8099a89412eebcbf8f5dee46032eb83e21",
        "metadata": {},
        "name": "src_jiraSoftwareFormBuilderQuery",
        "operationKind": "query",
        "text": null
    }
};
var $0e840d497ba3b73a$export$2e2bcd8739ae039 = $0e840d497ba3b73a$var$node;

});

parcelRegister("cqTQA", function(module, exports) {

let $90d33bd6a7dc5d65$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $90d33bd6a7dc5d65$var$load("ffQaD"),
    $90d33bd6a7dc5d65$var$load("kvRbA"),
    $90d33bd6a7dc5d65$var$load("72F6c")
]).then(()=>parcelRequire('jM2sL'));

});



parcelRegister("6KvsG", function(module, exports) {

$parcel$export(module.exports, "softwareFormRouteEntry", () => $eae74982fc8ba226$export$563e3b39911993a0);

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $3HwlS = parcelRequire("3HwlS");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $l2N2a = parcelRequire("l2N2a");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $6LsQE = parcelRequire("6LsQE");

var $4kqDP = parcelRequire("4kqDP");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $eeYjL = parcelRequire("eeYjL");

var $fo6b8 = parcelRequire("fo6b8");

var $lkFvK = parcelRequire("lkFvK");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");
const $eae74982fc8ba226$var$formPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $eeYjL.formEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $eae74982fc8ba226$export$563e3b39911993a0 = (0, $7NszV.createEntry)((0, $4kqDP.softwareFormRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-form',
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), (0, $5f2bR.AsyncHorizontalNavJira), ()=>null),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingM2Enabled)(), (0, $9V5k0.projectThemeResource))
        ],
        entryPoint: ()=>{
            return (0, $6s1PB.expVal)('forms_for_jsw_experiment', 'isEnabled', false) ? $eae74982fc8ba226$var$formPageEntrypoint : (0, $6LsQE.notFoundPageEntrypoint);
        }
    }));

});
parcelRegister("4kqDP", function(module, exports) {

$parcel$export(module.exports, "softwareFormRoute", () => $fca3b9cc3ce6bbb8$export$a46217d369231a5);
const $fca3b9cc3ce6bbb8$export$a46217d369231a5 = {
    name: 'software-form',
    path: '/jira/software/projects/:projectKey/form',
    exact: true
};

});

parcelRegister("eeYjL", function(module, exports) {

$parcel$export(module.exports, "formEntrypoint", () => $2a299b0a5731b934$export$b931eb60522f687a);

var $czWfL = parcelRequire("czWfL");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $2a299b0a5731b934$export$b931eb60522f687a = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("93DVW")), {
        moduleId: "34421974"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                formQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $czWfL.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("czWfL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4080ec7d5d2fb7c3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3232935a5b9879fc4ee86b3cbc2c9c83>>
 * @relayHash 499a6633134d808842c9e8cd05fbcda0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 10cd467b6a17d91893094678f3292542a4270c9ce4e2a820600612d50bb642b5
const $4080ec7d5d2fb7c3$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "10cd467b6a17d91893094678f3292542a4270c9ce4e2a820600612d50bb642b5",
        "metadata": {},
        "name": "src_jiraSoftwareFormQuery",
        "operationKind": "query",
        "text": null
    }
};
var $4080ec7d5d2fb7c3$export$2e2bcd8739ae039 = $4080ec7d5d2fb7c3$var$node;

});

parcelRegister("93DVW", function(module, exports) {

let $69835ed2a93bafc1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $69835ed2a93bafc1$var$load("2eoES").then(()=>parcelRequire('jqjLM'));

});



parcelRegister("kg7GL", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitEmbedRouteEntry", () => $82aac62e73960caa$export$ac2e374edf86801f);

var $6e4Kt = parcelRequire("6e4Kt");

var $7NszV = parcelRequire("7NszV");

var $l2N2a = parcelRequire("l2N2a");

var $6LsQE = parcelRequire("6LsQE");

var $7G821 = parcelRequire("7G821");

var $4R6GH = parcelRequire("4R6GH");

var $a1Eek = parcelRequire("a1Eek");

var $lkFvK = parcelRequire("lkFvK");
const $82aac62e73960caa$var$formSubmitEmbedPageEntrypoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $a1Eek.formSubmitEmbedEntrypoint)
});
const $82aac62e73960caa$export$ac2e374edf86801f = (0, $7NszV.createEntry)((0, $7G821.softwareFormSubmitEmbedRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-form-submit-embed',
        layout: (0, $6e4Kt.chromelessLayout),
        // eslint-disable-next-line camelcase
        resources: [
            (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource)
        ],
        entryPoint: ()=>{
            return (0, $4R6GH.fg)('jsw_forms_embed') ? $82aac62e73960caa$var$formSubmitEmbedPageEntrypoint : (0, $6LsQE.notFoundPageEntrypoint);
        }
    }));

});
parcelRegister("7G821", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitEmbedRoute", () => $fae57e01e4ce41f8$export$2bee26f083dc2946);
const $fae57e01e4ce41f8$export$2bee26f083dc2946 = {
    name: 'software-form-submit-embed',
    path: '/jira/software/projects/:projectKey/form/:formId/embed',
    exact: true
};

});

parcelRegister("a1Eek", function(module, exports) {

$parcel$export(module.exports, "formSubmitEmbedEntrypoint", () => $8db17a4483c62517$export$4c748d8ca82fc24);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $8db17a4483c62517$export$4c748d8ca82fc24 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("lNZYJ")), {
        moduleId: "d6417f2e"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lNZYJ", function(module, exports) {

let $fdfe4036c8c877be$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $fdfe4036c8c877be$var$load("ffQaD"),
    $fdfe4036c8c877be$var$load("kvRbA"),
    $fdfe4036c8c877be$var$load("7Gdm3")
]).then(()=>parcelRequire('91Ac2'));

});



parcelRegister("i0tax", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitRouteEntry", () => $b1634ae98fc90f0b$export$752724866670c36);

var $6e4Kt = parcelRequire("6e4Kt");

var $6s1PB = parcelRequire("6s1PB");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $7NszV = parcelRequire("7NszV");

var $l2N2a = parcelRequire("l2N2a");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $6LsQE = parcelRequire("6LsQE");

var $lHSmT = parcelRequire("lHSmT");

var $6FnT3 = parcelRequire("6FnT3");

var $lkFvK = parcelRequire("lkFvK");
const $b1634ae98fc90f0b$var$formSubmitPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $6FnT3.formSubmitEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $b1634ae98fc90f0b$export$752724866670c36 = (0, $7NszV.createEntry)((0, $lHSmT.softwareFormSubmitRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-form-submit',
        layout: (0, $6e4Kt.chromelessLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource)
        ],
        entryPoint: ()=>{
            return (0, $6s1PB.expVal)('forms_for_jsw_experiment', 'isEnabled', false) ? $b1634ae98fc90f0b$var$formSubmitPageEntrypoint : (0, $6LsQE.notFoundPageEntrypoint);
        }
    }));

});
parcelRegister("lHSmT", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitRoute", () => $a6eb0d1c3eac1f7e$export$75b28ee1c7f02f00);
const $a6eb0d1c3eac1f7e$export$75b28ee1c7f02f00 = {
    name: 'software-form-submit',
    path: '/jira/software/projects/:projectKey/form/:formId',
    exact: true
};

});

parcelRegister("6FnT3", function(module, exports) {

$parcel$export(module.exports, "formSubmitEntrypoint", () => $385f1a5bd4b1bf72$export$d33b8db02e0a0cb5);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $385f1a5bd4b1bf72$export$d33b8db02e0a0cb5 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("e7T7G")), {
        moduleId: "3c821c06"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("e7T7G", function(module, exports) {

let $a48c7a604ee17dcd$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a48c7a604ee17dcd$var$load("ffQaD"),
    $a48c7a604ee17dcd$var$load("kvRbA"),
    $a48c7a604ee17dcd$var$load("fInOz")
]).then(()=>parcelRequire('6SZAm'));

});



parcelRegister("aviVh", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitPublicRouteEntry", () => $640c017209c8df68$export$70893a47a5c041fd);

var $7NszV = parcelRequire("7NszV");

var $6LsQE = parcelRequire("6LsQE");

var $6s1PB = parcelRequire("6s1PB");

var $8SevG = parcelRequire("8SevG");

var $6e4Kt = parcelRequire("6e4Kt");

var $eRU3k = parcelRequire("eRU3k");

var $2Ql51 = parcelRequire("2Ql51");
const $640c017209c8df68$export$70893a47a5c041fd = (0, $7NszV.createEntry)((0, $8SevG.softwareFormSubmitPublicRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-form-submit-public',
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            (0, $2Ql51.themePreferenceResource)
        ],
        entryPoint: ()=>{
            return (0, $6s1PB.expVal)('jira_forms_public_access_experiment', 'isEnabled', 'false') ? (0, $eRU3k.formSubmitPageEntrypoint) : (0, $6LsQE.notFoundPageEntrypoint);
        }
    }));

});
parcelRegister("8SevG", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitPublicRoute", () => $796526da1cff6a97$export$d238522bd96fb720);
const $796526da1cff6a97$export$d238522bd96fb720 = {
    name: 'software-form-submit-public',
    path: '/jira/software/form/:formUuid',
    exact: true
};

});


parcelRegister("dl9zj", function(module, exports) {

$parcel$export(module.exports, "softwareGoalsRouteEntry", () => $db50753f4b92496b$export$d3fcc412edfa2068);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $9ltJc = parcelRequire("9ltJc");

var $5f2bR = parcelRequire("5f2bR");

var $x6sAR = parcelRequire("x6sAR");
const $db50753f4b92496b$export$d3fcc412edfa2068 = (0, $7NszV.createEntry)((0, $9ltJc.softwareGoalsRoute), ()=>({
        group: 'software',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $x6sAR.softwareGoalsPageEntrypoint)
    }));

});
parcelRegister("9ltJc", function(module, exports) {

$parcel$export(module.exports, "softwareGoalsRoute", () => $7d61fd42ce40e603$export$2328fed7ebee3cce);
const $7d61fd42ce40e603$export$2328fed7ebee3cce = {
    name: 'software-goals',
    exact: true,
    path: '/jira/software/projects/:projectKey/goals'
};

});

parcelRegister("x6sAR", function(module, exports) {

$parcel$export(module.exports, "softwareGoalsPageEntrypoint", () => $f4f250cf13a0bcf2$export$6c63903b420029c0);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");

var $gz6uQ = parcelRequire("gz6uQ");
const $f4f250cf13a0bcf2$export$6c63903b420029c0 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $gz6uQ.softwareGoalsEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("gz6uQ", function(module, exports) {

$parcel$export(module.exports, "softwareGoalsEntrypoint", () => $6005f5d27d54b399$export$a75f86449cc34a72);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $6005f5d27d54b399$export$a75f86449cc34a72 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("bsowf")), {
        moduleId: "a5f3007b"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("bsowf", function(module, exports) {

let $85755438750c9306$var$load = (parcelRequire("28QjX"))(4);
module.exports = $85755438750c9306$var$load("lCGb1").then(()=>parcelRequire('lrWy4'));

});




parcelRegister("3gU47", function(module, exports) {

$parcel$export(module.exports, "softwareInboxNextGenRouteEntry", () => $d466539a61f9c01e$export$22d61f7936797fc0);

var $e4eHl = parcelRequire("e4eHl");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $cSD7y = parcelRequire("cSD7y");

var $cwQst = parcelRequire("cwQst");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $15eSh = parcelRequire("15eSh");

var $6LsQE = parcelRequire("6LsQE");

var $arJNO = parcelRequire("arJNO");

var $8RACJ = parcelRequire("8RACJ");
const $d466539a61f9c01e$export$22d61f7936797fc0 = (0, $7NszV.createEntry)((0, $cwQst.softwareInboxNextGenRoute), ()=>({
        group: 'software',
        meta: {
            reporting: {
                id: 'software-inbox-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-inbox-classic'),
                teamName: 'boysenberry'
            }
        },
        skeleton: (0, $15eSh.InboxViewTableSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $cSD7y.componentWithFG)('make_nav3_sidebar_lazyforpaint', (0, $koWFd.ForPaintSoftwareProjectSidebar), (0, $koWFd.default)),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $arJNO.getCommonProjectResources)()
        ],
        layout: (0, $aPfsS.createLayout)((0, $e7bC3.softwareProjectLayoutNoOnboarding)),
        // We want to opt out of concurrent mode for all NIN routes https://hello.atlassian.net/wiki/x/wTRfDAE
        // But allow for users with empanada-concurrent-incremental gate enabled to continue testing it
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental') && !(0, $4R6GH.fg)('empanada-concurrent-incremental'),
        entryPoint: ()=>(0, $4R6GH.fg)('jcs_developer_escalations') ? (0, $8RACJ.inboxPageEntryPoint) : (0, $6LsQE.notFoundPageEntrypoint)
    }));

});
parcelRegister("cwQst", function(module, exports) {

$parcel$export(module.exports, "softwareInboxNextGenRoute", () => $cd2c848c671bcda5$export$e44454ed868d0941);
const $cd2c848c671bcda5$export$e44454ed868d0941 = {
    name: 'inbox',
    path: '/jira/software/projects/:projectKey/inbox/:issueKey?'
};

});

parcelRegister("15eSh", function(module, exports) {

$parcel$export(module.exports, "InboxViewTableSkeleton", () => $3523ca2f02bd8f32$export$24aae43683500596);
/* InboxViewTableSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $5kmCE = parcelRequire("5kmCE");
const $3523ca2f02bd8f32$var$customCssStyles = null;
const $3523ca2f02bd8f32$var$containerStyles = {
    height: '448px'
};
const $3523ca2f02bd8f32$export$24aae43683500596 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5kmCE))),
        containerStyles: $3523ca2f02bd8f32$var$containerStyles,
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("5kmCE", function(module, exports) {
module.exports = new URL("inbox-view-table-skeleton.tpl.3e3d3620.svg", import.meta.url).toString();

});


parcelRegister("8RACJ", function(module, exports) {

$parcel$export(module.exports, "inboxPageEntryPoint", () => $3d431b841140962e$export$6da9e4ae87b73009);

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");

var $lkFvK = parcelRequire("lkFvK");

var $c0j7k = parcelRequire("c0j7k");
const $3d431b841140962e$export$6da9e4ae87b73009 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $c0j7k.customerServiceInboxPageEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("c0j7k", function(module, exports) {

$parcel$export(module.exports, "customerServiceInboxPageEntrypoint", () => $30c38ea6fc569c0d$export$bf72eb0f567836ce);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $30c38ea6fc569c0d$export$bf72eb0f567836ce = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("6DN6j")), {
        moduleId: "9cc840e3"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("6DN6j", function(module, exports) {

let $4d5c78f95b74c06e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4d5c78f95b74c06e$var$load("dcueU").then(()=>parcelRequire('fLjxR'));

});




parcelRegister("iQsfj", function(module, exports) {

$parcel$export(module.exports, "softwareInboxClassicRouteEntry", () => $f05204c4b21c61d2$export$ca6aeb36a7b6211d);

var $e4eHl = parcelRequire("e4eHl");

var $c309A = parcelRequire("c309A");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $15eSh = parcelRequire("15eSh");

var $5f2bR = parcelRequire("5f2bR");

var $6LsQE = parcelRequire("6LsQE");

var $arJNO = parcelRequire("arJNO");

var $8RACJ = parcelRequire("8RACJ");
const $f05204c4b21c61d2$export$ca6aeb36a7b6211d = (0, $7NszV.createEntry)((0, $c309A.softwareInboxClassicRoute), ()=>({
        group: 'classic-software',
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            reporting: {
                id: 'software-inbox-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-inbox-classic'),
                teamName: 'boysenberry'
            }
        },
        skeleton: (0, $15eSh.InboxViewTableSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $cSD7y.componentWithFG)('make_nav3_sidebar_lazyforpaint', (0, $9s3j1.ForPaintClassicSoftwareProjectSidebar), (0, $9s3j1.default)),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $arJNO.getCommonProjectResources)()
        ],
        layout: (0, $aPfsS.createLayout)((0, $gyYxw.genericProjectLayout)),
        // We want to opt out of concurrent mode for all NIN routes https://hello.atlassian.net/wiki/x/wTRfDAE
        // But allow for users with empanada-concurrent-incremental gate enabled to continue testing it
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental') && !(0, $4R6GH.fg)('empanada-concurrent-incremental'),
        entryPoint: ()=>(0, $4R6GH.fg)('jcs_developer_escalations') ? (0, $8RACJ.inboxPageEntryPoint) : (0, $6LsQE.notFoundPageEntrypoint)
    }));

});
parcelRegister("c309A", function(module, exports) {

$parcel$export(module.exports, "softwareInboxClassicRoute", () => $a0a29968a08b5849$export$a3612f128eff4e3c);
const $a0a29968a08b5849$export$a3612f128eff4e3c = {
    name: 'inbox-classic',
    path: '/jira/software/c/projects/:projectKey/inbox/:issueKey?'
};

});


parcelRegister("8Yag1", function(module, exports) {

$parcel$export(module.exports, "softwareListEmbedRouteEntry", () => $6b0e66505ae13519$export$1099e0e49394fa9a);

var $6e4Kt = parcelRequire("6e4Kt");

var $lkFvK = parcelRequire("lkFvK");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $f85YZ = parcelRequire("f85YZ");

var $cf2qA = parcelRequire("cf2qA");

var $cv6Sw = parcelRequire("cv6Sw");

var $aGBe9 = parcelRequire("aGBe9");
const $6b0e66505ae13519$var$listEmbedPageEntrypoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $cv6Sw.listEmbedEntryPoint)
});
const $6b0e66505ae13519$export$1099e0e49394fa9a = (0, $7NszV.createEntry)((0, $f85YZ.softwareListEmbedRoute), ()=>({
        group: 'software',
        skeleton: (0, $cf2qA.ListEmbedSkeleton),
        entryPoint () {
            return $6b0e66505ae13519$var$listEmbedPageEntrypoint;
        },
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $aGBe9.getListProjectResources)()
        ],
        ufoName: 'next-gen-list-embed'
    }));

});
parcelRegister("f85YZ", function(module, exports) {

$parcel$export(module.exports, "softwareListEmbedRoute", () => $7b234b63625cf68c$export$70dd8df584442004);
const $7b234b63625cf68c$export$70dd8df584442004 = {
    name: 'software-list-embed',
    path: '/jira/software/projects/:projectKey/list/embed'
};

});

parcelRegister("cf2qA", function(module, exports) {

$parcel$export(module.exports, "ListSkeleton", () => $6a76608e47ef62ca$export$cbc3335f7a517046);
$parcel$export(module.exports, "ListEmbedSkeleton", () => $6a76608e47ef62ca$export$2638f1c98fe91c13);

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $aZ2R7 = parcelRequire("aZ2R7");

var $9vURY = parcelRequire("9vURY");
const $6a76608e47ef62ca$export$cbc3335f7a517046 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aZ2R7)))
    });
const $6a76608e47ef62ca$export$2638f1c98fe91c13 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9vURY)))
    });

});
parcelRegister("aZ2R7", function(module, exports) {
module.exports = new URL("list-app-skeleton.tpl.82508714.svg", import.meta.url).toString();

});

parcelRegister("9vURY", function(module, exports) {
module.exports = new URL("list-embed-app-skeleton.tpl.de94c811.svg", import.meta.url).toString();

});


parcelRegister("cv6Sw", function(module, exports) {

$parcel$export(module.exports, "listEmbedEntryPoint", () => $ac51f9a325b99a16$export$519bb55e1612f243);

var $EVQo4 = parcelRequire("EVQo4");

var $dMRP9 = parcelRequire("dMRP9");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");
const $ac51f9a325b99a16$var$FORMAT_RULES_FIRST = 20;

const $ac51f9a325b99a16$export$519bb55e1612f243 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("ddD3f")), {
        moduleId: "5ed7fb43"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                listEmbedQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $dMRP9.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                formattingRulesQuery: {
                    parameters: (0, $EVQo4.default),
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        first: $ac51f9a325b99a16$var$FORMAT_RULES_FIRST
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        };
    }
});

});
parcelRegister("dMRP9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b295f91ae484cb56$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<834fddde735677817bb414d426c4ffa7>>
 * @relayHash b1d5bddbd0778f4be3f4876e1525e6f4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 661dfc8e2a4d3163499a24e3bae8c13315e369090fa8e455d22560e15a9e00f4
const $b295f91ae484cb56$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "661dfc8e2a4d3163499a24e3bae8c13315e369090fa8e455d22560e15a9e00f4",
        "metadata": {},
        "name": "src_jiraSoftwareListEmbedQuery",
        "operationKind": "query",
        "text": null
    }
};
var $b295f91ae484cb56$export$2e2bcd8739ae039 = $b295f91ae484cb56$var$node;

});

parcelRegister("ddD3f", function(module, exports) {

let $99fac80d3d31c6be$var$load = (parcelRequire("28QjX"))(4);


module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $99fac80d3d31c6be$var$load("cTJTG"),
            $99fac80d3d31c6be$var$load("l253H"),
            $99fac80d3d31c6be$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $99fac80d3d31c6be$var$load("4Qxp7")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $99fac80d3d31c6be$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $99fac80d3d31c6be$var$load("7B2gt")
        ]);
    }),
    $99fac80d3d31c6be$var$load("ffQaD"),
    $99fac80d3d31c6be$var$load("kvRbA"),
    $99fac80d3d31c6be$var$load("3EILy")
]).then(()=>parcelRequire('6xPmp'));

});


parcelRegister("aGBe9", function(module, exports) {

$parcel$export(module.exports, "getListProjectResources", () => $5ae376cbaf33854f$export$7bd00eef349a268a);

var $g4ZHz = parcelRequire("g4ZHz");

var $iNzEe = parcelRequire("iNzEe");

var $l2N2a = parcelRequire("l2N2a");

var $aFVvc = parcelRequire("aFVvc");
const $5ae376cbaf33854f$export$7bd00eef349a268a = ()=>[
        (0, $aFVvc.projectCreatePermissionsResource),
        (0, $iNzEe.navigationResource),
        // eslint-disable-next-line camelcase
        (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource),
        (0, $g4ZHz.fieldsResource)
    ];

});


parcelRegister("2toxI", function(module, exports) {

$parcel$export(module.exports, "softwareListRouteEntry", () => $47240db4975f79b0$export$f30a66efa682bf2d);

var $lkFvK = parcelRequire("lkFvK");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $6L6XQ = parcelRequire("6L6XQ");

var $cf2qA = parcelRequire("cf2qA");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $3FuB0 = parcelRequire("3FuB0");

var $fo6b8 = parcelRequire("fo6b8");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");

var $aGBe9 = parcelRequire("aGBe9");
const $47240db4975f79b0$var$listPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $3FuB0.listEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $47240db4975f79b0$export$f30a66efa682bf2d = (0, $7NszV.createEntry)((0, $6L6XQ.softwareListRoute), ()=>({
        group: 'software',
        skeleton: (0, $cf2qA.ListSkeleton),
        entryPoint () {
            return $47240db4975f79b0$var$listPageEntrypoint;
        },
        layout: (0, $aPfsS.composeLayouts)((0, $e7bC3.softwareProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $aGBe9.getListProjectResources)(),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource))
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        ufoName: 'next-gen-list'
    }));

});
parcelRegister("6L6XQ", function(module, exports) {

$parcel$export(module.exports, "softwareListRoute", () => $da08ebba917aac54$export$f3a5b1b732315e13);
const $da08ebba917aac54$export$f3a5b1b732315e13 = {
    name: 'software-list',
    path: '/jira/software/projects/:projectKey/list'
};

});

parcelRegister("3FuB0", function(module, exports) {

$parcel$export(module.exports, "listEntryPoint", () => $093e9fa498e2d713$export$6be4f10150ff6073);

var $EVQo4 = parcelRequire("EVQo4");

var $eV4yn = parcelRequire("eV4yn");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");
const $093e9fa498e2d713$var$FORMAT_RULES_FIRST = 20;

const $093e9fa498e2d713$export$6be4f10150ff6073 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("fCwBm")), {
        moduleId: "a7ba8596"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                listQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $eV4yn.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                formattingRulesQuery: {
                    parameters: (0, $EVQo4.default),
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        first: $093e9fa498e2d713$var$FORMAT_RULES_FIRST
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        };
    }
});

});
parcelRegister("eV4yn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1285db29ce222e8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9589819072a0d79deedb3286a1ad0e09>>
 * @relayHash 7ca7a7e73175fabcafbcca8378817432
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e63ab64e310db9403bb03770e66a53a6920f135e0096a5f8f31a3ac88d170c0b
const $a1285db29ce222e8$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e63ab64e310db9403bb03770e66a53a6920f135e0096a5f8f31a3ac88d170c0b",
        "metadata": {},
        "name": "src_jiraSoftwareListQuery",
        "operationKind": "query",
        "text": null
    }
};
var $a1285db29ce222e8$export$2e2bcd8739ae039 = $a1285db29ce222e8$var$node;

});

parcelRegister("fCwBm", function(module, exports) {

let $b5f3b19b7d70b203$var$load = (parcelRequire("28QjX"))(4);


module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $b5f3b19b7d70b203$var$load("cTJTG"),
            $b5f3b19b7d70b203$var$load("l253H"),
            $b5f3b19b7d70b203$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $b5f3b19b7d70b203$var$load("4Qxp7")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $b5f3b19b7d70b203$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $b5f3b19b7d70b203$var$load("7B2gt")
        ]);
    }),
    $b5f3b19b7d70b203$var$load("ffQaD"),
    $b5f3b19b7d70b203$var$load("kvRbA"),
    $b5f3b19b7d70b203$var$load("dbP3D")
]).then(()=>parcelRequire('ycm07'));

});



parcelRegister("5xsFH", function(module, exports) {

$parcel$export(module.exports, "softwareOnboardingRouteEntry", () => $048906688afed449$export$bb72a943d2340466);

var $4R6GH = parcelRequire("4R6GH");

var $6e4Kt = parcelRequire("6e4Kt");

var $7NszV = parcelRequire("7NszV");

var $c4yut = parcelRequire("c4yut");

var $2Ql51 = parcelRequire("2Ql51");

var $5TcuB = parcelRequire("5TcuB");

var $aFVvc = parcelRequire("aFVvc");

var $gNStA = parcelRequire("gNStA");

var $h9FIc = parcelRequire("h9FIc");
const $048906688afed449$export$bb72a943d2340466 = (0, $7NszV.createEntry)((0, $5TcuB.softwareOnboardingRoute), ()=>({
        group: 'software',
        component: (0, $h9FIc.SoftwareOnboardingPage),
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            (0, $c4yut.jswOnboardingResource),
            (0, $2Ql51.themePreferenceResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('onboarding_get_create_project_permission'), (0, $aFVvc.projectCreatePermissionsResource))
        ],
        forPaint: [
            (0, $h9FIc.LazySoftwareOnboardingPage)
        ],
        canTransitionIn: ()=>false
    }));

});
parcelRegister("c4yut", function(module, exports) {

$parcel$export(module.exports, "jswOnboardingResource", () => $1ebe6dd05980f4f8$export$be21a2d8a350a80);
$parcel$export(module.exports, "useJswOnboardingResource", () => $1ebe6dd05980f4f8$export$83f546a45ad58d0a);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


const $1ebe6dd05980f4f8$export$be21a2d8a350a80 = (0, $2M1hQ.createResource)({
    type: (0, $156934826e437e4d$export$692203fca66f4d77),
    getKey: ()=>'jsw_onboarding',
    getDataLoader: ()=>(parcelRequire("jp7dw"))
});
const $1ebe6dd05980f4f8$export$83f546a45ad58d0a = ()=>(0, $2YP9W.useResource)($1ebe6dd05980f4f8$export$be21a2d8a350a80);

});
const $156934826e437e4d$export$692203fca66f4d77 = 'RESOURCE_TYPE_SOFTWARE_ONBOARDING';

parcelRegister("jp7dw", function(module, exports) {

let $e205f348c47e9213$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e205f348c47e9213$var$load("4y5P7").then(()=>parcelRequire('4W57j'));

});


parcelRegister("5TcuB", function(module, exports) {

$parcel$export(module.exports, "softwareOnboardingRoute", () => $38b80aa1ac78feb2$export$5e6c92d2f34c1e48);
const $38b80aa1ac78feb2$export$5e6c92d2f34c1e48 = {
    name: 'software-onboarding',
    path: '/welcome/software',
    exact: true
};

});

parcelRegister("h9FIc", function(module, exports) {

$parcel$export(module.exports, "LazySoftwareOnboardingPage", () => $9d1d716191d31716$export$31e9f06d3389e445);
$parcel$export(module.exports, "SoftwareOnboardingPage", () => $9d1d716191d31716$export$ee768d69c6e3a8bd);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $9d1d716191d31716$export$31e9f06d3389e445 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("04bhT"))), {
    moduleId: "./src/packages/spa-apps/software/onboarding/src/index.tsx"
});
const $9d1d716191d31716$export$ee768d69c6e3a8bd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9d1d716191d31716$export$31e9f06d3389e445,
        pageId: "software-onboarding",
        shouldShowSpinner: false
    });

});
parcelRegister("04bhT", function(module, exports) {

let $00c9215854ae9d60$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $00c9215854ae9d60$var$load("ffQaD"),
    $00c9215854ae9d60$var$load("kvRbA"),
    $00c9215854ae9d60$var$load("76n7a"),
    $00c9215854ae9d60$var$load("l253H"),
    $00c9215854ae9d60$var$load("hCQAW")
]).then(()=>parcelRequire('iCmWy'));

});



parcelRegister("eFYGV", function(module, exports) {

$parcel$export(module.exports, "softwarePeriscopeNextGenRouteEntry", () => $e85cebcb4685b0b3$export$7db4d910357a4d89);

var $e4eHl = parcelRequire("e4eHl");

var $c04PQ = parcelRequire("c04PQ");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $ajKFd = parcelRequire("ajKFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $8VZpl = parcelRequire("8VZpl");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $6LsQE = parcelRequire("6LsQE");

var $kkNtb = parcelRequire("kkNtb");

var $iXbZm = parcelRequire("iXbZm");
const $e85cebcb4685b0b3$export$7db4d910357a4d89 = (0, $7NszV.createEntry)((0, $8VZpl.softwarePeriscopeNextGenRoute), ()=>({
        group: 'software',
        skeleton: (0, $ajKFd.Skeleton),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource),
            (0, $kkNtb.rovoEntitlementResource)
        ],
        entryPoint: ()=>{
            return (0, $c04PQ.isFedRamp)() ? (0, $6LsQE.notFoundPageEntrypoint) : (0, $iXbZm.periscopeEntryPoint);
        },
        meta: {
            reporting: {
                id: 'software-periscope',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-periscope'),
                teamName: 'nova'
            }
        }
    }));

});
parcelRegister("ajKFd", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $b9eb4b3f312b449f$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "InsightsSkeleton", () => $b9eb4b3f312b449f$export$dd0b74c715df3275);
$parcel$export(module.exports, "SuggestionsSkeleton", () => $b9eb4b3f312b449f$export$91f27b306afd627b);
$parcel$export(module.exports, "WorkItemsSkeleton", () => $b9eb4b3f312b449f$export$1660f3159b79b22b);
$parcel$export(module.exports, "WorkItemsVulnTabSkeleton", () => $b9eb4b3f312b449f$export$5aea7d4ed03d6ea6);
$parcel$export(module.exports, "WorkItemsDeploymentTabSkeleton", () => $b9eb4b3f312b449f$export$ff38ee81427877e9);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $gUTyu = parcelRequire("gUTyu");

var $29cNf = parcelRequire("29cNf");
const $b9eb4b3f312b449f$export$8f31e4c4a37b8e9c = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $b9eb4b3f312b449f$var$MainContainerStyles,
        "data-testId": "software-periscope-periscope-page.ui.loading",
        "aria-label": formatMessage((0, $29cNf.default).label),
        gap: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $b9eb4b3f312b449f$var$leftColumnStyles,
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b9eb4b3f312b449f$var$InsightsContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gUTyu.PeriscopeInsightsSkeleton), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b9eb4b3f312b449f$var$WorkItemsContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gUTyu.PeriscopeWorkItemsSkeleton), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $b9eb4b3f312b449f$var$rightColumnStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b9eb4b3f312b449f$var$SuggestionsContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gUTyu.PeriscopeSuggestionsSkeleton), null))));
};
const $b9eb4b3f312b449f$export$dd0b74c715df3275 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b9eb4b3f312b449f$var$InsightsContainerStyles,
        "data-testId": "software-periscope-periscope-page.insights-ui.loading",
        "aria-label": formatMessage((0, $29cNf.default).insightsLabel),
        paddingBlockEnd: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gUTyu.PeriscopeInsightsSkeleton), null));
};
const $b9eb4b3f312b449f$export$91f27b306afd627b = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b9eb4b3f312b449f$var$SuggestionsContainerStyles,
        "data-testId": "software-periscope-periscope-page.suggestions-ui.loading",
        "aria-label": formatMessage((0, $29cNf.default).suggestionsLabel),
        paddingBlockEnd: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gUTyu.PeriscopeSuggestionsSkeleton), null));
};
const $b9eb4b3f312b449f$export$1660f3159b79b22b = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b9eb4b3f312b449f$var$WorkItemsContainerStyles,
        "aria-label": formatMessage((0, $29cNf.default).workItemsLabel),
        paddingBlockEnd: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gUTyu.PeriscopeWorkItemsSkeleton), null));
};
const $b9eb4b3f312b449f$export$5aea7d4ed03d6ea6 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b9eb4b3f312b449f$var$WorkItemsVulnTabContainerStyles,
        "aria-label": formatMessage((0, $29cNf.default).workItemsVulnTabLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gUTyu.DevelopmentPageWorkItemsVulnTabSkeleton), null));
};
const $b9eb4b3f312b449f$export$ff38ee81427877e9 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b9eb4b3f312b449f$var$WorkItemsContainerStyles,
        "aria-label": formatMessage((0, $29cNf.default).workItemsDeploymentTabLabel),
        paddingBlockEnd: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gUTyu.DevelopmentPageWorkItemsDeploymentTabSkeleton), null));
};
const $b9eb4b3f312b449f$var$MainContainerStyles = (0, $8CUq3.xcss)({
    width: '100%',
    height: '100%',
    display: 'flex',
    boxSizing: 'border-box',
    overflow: 'hidden'
});
const $b9eb4b3f312b449f$var$leftColumnStyles = (0, $8CUq3.xcss)({
    flex: '2 1 0'
});
const $b9eb4b3f312b449f$var$rightColumnStyles = (0, $8CUq3.xcss)({
    flex: '1 1 0'
});
const $b9eb4b3f312b449f$var$SuggestionsContainerStyles = (0, $8CUq3.xcss)({
    width: '100%',
    overflow: 'hidden',
    height: '650px',
    boxSizing: 'border-box'
});
const $b9eb4b3f312b449f$var$InsightsContainerStyles = (0, $8CUq3.xcss)({
    overflow: 'hidden',
    width: '100%',
    height: '385px',
    boxSizing: 'border-box'
});
const $b9eb4b3f312b449f$var$WorkItemsContainerStyles = (0, $8CUq3.xcss)({
    width: '100%',
    height: '600px',
    boxSizing: 'border-box',
    overflow: 'hidden'
});
const $b9eb4b3f312b449f$var$WorkItemsVulnTabContainerStyles = (0, $8CUq3.xcss)({
    width: '100%',
    height: '420px',
    boxSizing: 'border-box',
    overflow: 'hidden'
});

});
parcelRegister("gUTyu", function(module, exports) {

$parcel$export(module.exports, "PeriscopeSuggestionsSkeleton", () => $c6fead338751845c$export$176dfe4c14771136);
$parcel$export(module.exports, "PeriscopeInsightsSkeleton", () => $c6fead338751845c$export$afb44f298901be44);
$parcel$export(module.exports, "PeriscopeWorkItemsSkeleton", () => $c6fead338751845c$export$298a6b6a251923c2);
$parcel$export(module.exports, "DevelopmentPageWorkItemsVulnTabSkeleton", () => $c6fead338751845c$export$8940e0b80e4066d6);
$parcel$export(module.exports, "DevelopmentPageWorkItemsDeploymentTabSkeleton", () => $c6fead338751845c$export$2f5ed71a7df2d4e6);
$parcel$export(module.exports, "DevelopmentPageCodeAgentsTabSkeleton", () => $c6fead338751845c$export$e3f7fac0f7e53296);
/* PeriscopeSuggestionsSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $gwNZG = parcelRequire("gwNZG");

var $2geDY = parcelRequire("2geDY");

var $iWMaH = parcelRequire("iWMaH");

var $4BkIC = parcelRequire("4BkIC");

var $7wKMl = parcelRequire("7wKMl");

var $eb9Zy = parcelRequire("eb9Zy");

var $fIBLw = parcelRequire("fIBLw");

var $kqIMZ = parcelRequire("kqIMZ");
const $c6fead338751845c$var$PeriscopePageSkeletonStyles = null;
const $c6fead338751845c$export$4aecc030c4d69f74 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.app-skeleton-image-periscope-page-new",
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4BkIC)))
    }));
const $c6fead338751845c$export$176dfe4c14771136 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.app-suggestions-skeleton",
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7wKMl)))
    }));
const $c6fead338751845c$export$afb44f298901be44 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.app-insights-skeleton",
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2geDY)))
    }));
const $c6fead338751845c$export$298a6b6a251923c2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fIBLw)))
    }));
const $c6fead338751845c$export$8940e0b80e4066d6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eb9Zy)))
    }));
const $c6fead338751845c$export$2f5ed71a7df2d4e6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gwNZG)))
    }));
const $c6fead338751845c$export$e70f5fa3451855e2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.app-on-call-panel-skeleton",
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iWMaH)))
    }));
const $c6fead338751845c$export$e3f7fac0f7e53296 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.code-agents-tab-skeleton",
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kqIMZ)))
    }));

});
parcelRegister("gwNZG", function(module, exports) {
module.exports = new URL("deployment-tab-skeleton.tpl.6442d1f9.svg", import.meta.url).toString();

});

parcelRegister("2geDY", function(module, exports) {
module.exports = new URL("insights.tpl.c29b665e.svg", import.meta.url).toString();

});

parcelRegister("iWMaH", function(module, exports) {
module.exports = new URL("on-call-panel-skeleton.tpl.d7139b03.svg", import.meta.url).toString();

});

parcelRegister("4BkIC", function(module, exports) {
module.exports = new URL("periscope-page-full-layout.tpl.762dcdba.svg", import.meta.url).toString();

});

parcelRegister("7wKMl", function(module, exports) {
module.exports = new URL("suggestions.tpl.52cb06d0.svg", import.meta.url).toString();

});

parcelRegister("eb9Zy", function(module, exports) {
module.exports = new URL("vuln-tab-skeleton.tpl.1a18ea24.svg", import.meta.url).toString();

});

parcelRegister("fIBLw", function(module, exports) {
module.exports = new URL("work-items.tpl.4ee9e4f3.svg", import.meta.url).toString();

});

parcelRegister("kqIMZ", function(module, exports) {
module.exports = new URL("code-agents-tab-skeleton.tpl.874ad579.svg", import.meta.url).toString();

});


parcelRegister("29cNf", function(module, exports) {

$parcel$export(module.exports, "default", () => $34a050fcfbf5d355$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $34a050fcfbf5d355$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "periscope.skeleton.label",
        "defaultMessage": "Loading"
    },
    suggestionsLabel: {
        "id": "periscope.suggestions-skeleton.label",
        "defaultMessage": "Suggestions loading"
    },
    insightsLabel: {
        "id": "periscope.insights-skeleton.label",
        "defaultMessage": "Developer insights loading"
    },
    workItemsLabel: {
        "id": "periscope.work-items-skeleton.work-items-label",
        "defaultMessage": "Work items loading"
    },
    workItemsVulnTabLabel: {
        "id": "periscope.work-items-skeleton.work-items-vuln-tab-label",
        "defaultMessage": "Work items vulnerability tab loading"
    },
    workItemsDeploymentTabLabel: {
        "id": "periscope.work-items-skeleton.work-items-deployment-tab-label",
        "defaultMessage": "Work items deployment tab loading"
    },
    onCallPanelLabel: {
        "id": "periscope.on-call-skeleton.label",
        "defaultMessage": "On call panel loading"
    }
});

});


parcelRegister("8VZpl", function(module, exports) {

$parcel$export(module.exports, "softwarePeriscopeNextGenRoute", () => $4e58e490b9dd84b4$export$9d0f329211395c25);
const $4e58e490b9dd84b4$export$9d0f329211395c25 = {
    name: 'software-periscope',
    path: '/jira/software/projects/:projectKey/development'
};

});

parcelRegister("iXbZm", function(module, exports) {

$parcel$export(module.exports, "periscopeEntryPoint", () => $db17fefaaacf4384$export$5a8cf468a1d46d4);

var $egcs2 = parcelRequire("egcs2");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");
const $db17fefaaacf4384$export$5a8cf468a1d46d4 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $egcs2.periscopeEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("egcs2", function(module, exports) {

$parcel$export(module.exports, "periscopeEntrypoint", () => $6795745322f5a74e$export$89ba9048c6fd23c6);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $6795745322f5a74e$export$89ba9048c6fd23c6 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("4KVXE")), {
        moduleId: "11456a6c"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4KVXE", function(module, exports) {

let $37686b31bf936db4$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $37686b31bf936db4$var$load("ffQaD"),
    $37686b31bf936db4$var$load("kvRbA"),
    $37686b31bf936db4$var$load("fliVL"),
    $37686b31bf936db4$var$load("9wX7U")
]).then(()=>parcelRequire('k9ngM'));

});




parcelRegister("kxlGk", function(module, exports) {

$parcel$export(module.exports, "softwareRoadmapRouteEntry", () => $f92b7b046a2bd572$export$c1d875e34d537389);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $jsFU4 = parcelRequire("jsFU4");

var $7GnDe = parcelRequire("7GnDe");

var $gwIeN = parcelRequire("gwIeN");

var $8STJR = parcelRequire("8STJR");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $7tQej = parcelRequire("7tQej");

var $4R6GH = parcelRequire("4R6GH");

var $9SSv2 = parcelRequire("9SSv2");
const $f92b7b046a2bd572$var$getConditionalResources = ()=>(0, $4R6GH.fg)('optimise_timeline_routes') ? [
        (0, $5bkvv.forgeProjectModuleResourceOnNav3Only),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only)
    ] : [
        (0, $5bkvv.forgeProjectModuleResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
    ];
const $f92b7b046a2bd572$var$SoftwareTimelineRedirect = ({ match: { params: { projectKey: projectKey, boardId: boardId } }, query: query })=>{
    const queryParams = new URLSearchParams(query).toString();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: {
            pathname: `/jira/software/projects/${String(projectKey)}/boards/${String(boardId)}/timeline`,
            hash: '',
            search: queryParams
        }
    });
};
const $f92b7b046a2bd572$export$c1d875e34d537389 = (0, $7NszV.createEntry)((0, $gwIeN.softwareRoadmapRoute), ()=>({
        group: 'software',
        component: $f92b7b046a2bd572$var$SoftwareTimelineRedirect,
        skeleton: (0, $8STJR.RoadmapSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $4R6GH.fg)('optimise_timeline_routes') ? (0, $e7bC3.softwareProjectLayoutCode) : (0, $e7bC3.softwareProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            ...$f92b7b046a2bd572$var$getConditionalResources(),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $jsFU4.nextGenRoadmapResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-roadmap-early-entry'
            ]
        },
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $9SSv2.LazyNextGenRoadmap)
        ],
        ufoName: 'next-gen-roadmap'
    }));

});
parcelRegister("jsFU4", function(module, exports) {

$parcel$export(module.exports, "nextGenRoadmapResource", () => $0b5ed5206b5a609e$export$2750f87d68dfb02a);

var $2M1hQ = parcelRequire("2M1hQ");


const $0b5ed5206b5a609e$export$2750f87d68dfb02a = (0, $2M1hQ.createResource)({
    type: (0, $87d7efe6336d8b83$export$75dfa03544a19422),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("9QR9m")),
    // SSR doesn't care about this and we can't check FFs here because its not in the render path
    maxAge: 3600000,
    isBrowserOnly: true
});

});
const $87d7efe6336d8b83$export$75dfa03544a19422 = 'ROADMAP';
const $87d7efe6336d8b83$export$e3b1cd17bd82de3d = 'CLASSIC_ROADMAP';
const $87d7efe6336d8b83$export$e905b9170ecbb599 = 'BOARD_CONTEXT_ROADMAP_SETTINGS';

parcelRegister("9QR9m", function(module, exports) {

let $72c232e3722805ed$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $72c232e3722805ed$var$load("kVX56"),
    $72c232e3722805ed$var$load("hjzlf")
]).then(()=>parcelRequire('d0ZST'));

});


parcelRegister("gwIeN", function(module, exports) {

$parcel$export(module.exports, "softwareRoadmapRoute", () => $d2651e8c2584e2bd$export$a4a573c36fc75b30);
const $d2651e8c2584e2bd$export$a4a573c36fc75b30 = {
    name: 'software-roadmap',
    path: '/jira/software/projects/:projectKey/boards/:boardId/roadmap'
};

});

parcelRegister("8STJR", function(module, exports) {

$parcel$export(module.exports, "RoadmapSkeleton", () => $e0f5f5cb925a5d1c$export$66a1e8bb48359566);
/* RoadmapSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7XYc4 = parcelRequire("7XYc4");

var $3HwlS = parcelRequire("3HwlS");

var $dCm1o = parcelRequire("dCm1o");

var $hCy6k = parcelRequire("hCy6k");

var $j8gGL = parcelRequire("j8gGL");

var $5KBZJ = parcelRequire("5KBZJ");
const $e0f5f5cb925a5d1c$var$customCssStyles = null;
const $e0f5f5cb925a5d1c$export$66a1e8bb48359566 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e0f5f5cb925a5d1c$var$AppSkeletonImageContainer, null, (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($j8gGL))),
        className: (0, $bwpsq.default)([
            "_2zz1idpf"
        ])
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5KBZJ))),
        className: (0, $bwpsq.default)([
            "_2zz1idpf"
        ])
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $e0f5f5cb925a5d1c$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1bgi _1xpi1tcg _1sbz1tcg _1cpn1tcg _13xs1tcg",
            __cmplp.className
        ])
    });
});
const $e0f5f5cb925a5d1c$var$AppSkeletonImageContainer = (0, $7XYc4.componentWithCondition)(()=>(0, $dCm1o.isVisualRefreshEnabled)(), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e0f5f5cb925a5d1c$var$Wrapper, null, children), (0, $5uXOq.Fragment));

});
parcelRegister("j8gGL", function(module, exports) {
module.exports = new URL("roadmap-app-skeleton-nav-refresh.tpl.ce6eb42e.svg", import.meta.url).toString();

});

parcelRegister("5KBZJ", function(module, exports) {
module.exports = new URL("roadmap-app-skeleton.tpl.a54a882d.svg", import.meta.url).toString();

});


parcelRegister("9SSv2", function(module, exports) {

$parcel$export(module.exports, "LazyNextGenRoadmap", () => $fba9adf99f1ad42b$export$1339c847cf4ab57);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $fba9adf99f1ad42b$export$1339c847cf4ab57 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("293Nh"))), {
    moduleId: "./src/packages/spa-apps/roadmap/src/view/next-gen/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fba9adf99f1ad42b$export$2e2bcd8739ae039 = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $fba9adf99f1ad42b$export$1339c847cf4ab57,
        pageId: `next-gen-roadmap-${match.params.boardId || ''}`,
        shouldShowSpinner: false
    });

});


parcelRegister("cyZLC", function(module, exports) {

$parcel$export(module.exports, "softwareSecurityNextGenRouteEntry", () => $9f02076ad45b829a$export$a8dcfae475505e7a);

var $e4eHl = parcelRequire("e4eHl");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $en8e6 = parcelRequire("en8e6");

var $d1QwJ = parcelRequire("d1QwJ");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $6LsQE = parcelRequire("6LsQE");

var $crK2h = parcelRequire("crK2h");

var $7AM4I = parcelRequire("7AM4I");
const $9f02076ad45b829a$export$a8dcfae475505e7a = (0, $7NszV.createEntry)((0, $d1QwJ.softwareSecurityNextGenRoute), ()=>({
        group: 'software',
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        ufoName: 'software-security-combined',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource),
            (0, $en8e6.securityPageResource)
        ],
        meta: {
            reporting: {
                id: 'software-security',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-security'),
                teamName: 'fusion-isotopes'
            }
        },
        entryPoint: ()=>(0, $crK2h.isSecurityPageEnabled)() ? (0, $7AM4I.securityPageEntrypoint) : (0, $6LsQE.notFoundPageEntrypoint)
    }));

});
parcelRegister("en8e6", function(module, exports) {

$parcel$export(module.exports, "securityPageResource", () => $ae0f760fa9a80a3f$export$2c5e3c161b8fe98);

var $dXq4S = parcelRequire("dXq4S");

var $ao2h1 = parcelRequire("ao2h1");

var $1UBcC = parcelRequire("1UBcC");

var $ac0bf = parcelRequire("ac0bf");

const $ae0f760fa9a80a3f$var$getNumberOfVulnerabilitiesToFetch = ()=>40;
const $ae0f760fa9a80a3f$var$getNumberOfSecurityContainersToFetch = ()=>100;
let $ae0f760fa9a80a3f$var$filters;
const $ae0f760fa9a80a3f$export$2c5e3c161b8fe98 = (0, $ao2h1.createRelayResource)({
    type: (0, $0a72320b8bc3a1aa$export$f24db22c3c834cb1),
    getQuery ({ match: { params: params }, query: query, route: { name: name } }, { tenantContext: { cloudId: cloudId, activationId: activationId } }) {
        const isSecRoute = name === 'software-security' || name === 'software-security-classic';
        // Set filters on initial call only and not on every query param change
        if (!$ae0f760fa9a80a3f$var$filters && isSecRoute) {
            const connectionAri = (0, $dXq4S.createAri)({
                resourceOwner: 'jira',
                resourceType: 'security-container',
                cloudId: cloudId,
                activationId: activationId,
                resourceId: ''
            });
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            $ae0f760fa9a80a3f$var$filters = (0, $ac0bf.getGqlFiltersFromQueryParams)(query, connectionAri);
        }
        // Reset filters when navigating away from the security page
        if (!isSecRoute) $ae0f760fa9a80a3f$var$filters = undefined;
        return {
            parameters: (0, $1UBcC.default),
            options: {
                fetchPolicy: 'store-and-network'
            },
            variables: {
                cloudAri: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira',
                    resourceType: 'site',
                    resourceId: cloudId
                }),
                cloudId: cloudId,
                projectKey: params.projectKey ?? '',
                numberOfVulnsToFetch: $ae0f760fa9a80a3f$var$getNumberOfVulnerabilitiesToFetch(),
                getContainers: false,
                numberOfContainersToFetch: $ae0f760fa9a80a3f$var$getNumberOfSecurityContainersToFetch(),
                filter: $ae0f760fa9a80a3f$var$filters
            }
        };
    }
});

});
parcelRegister("1UBcC", function(module, exports) {

$parcel$export(module.exports, "default", () => $511d4548ae93769f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<19ba314b5ea84907b5a40f68508fe69c>>
 * @relayHash f0a618cf7ed72db97753081c0b97da4a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5198f24476f61b6137708d014e1bf17fc048a7251fb5049c31fda1aacc83f1ab
const $511d4548ae93769f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "getContainers"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "numberOfContainersToFetch"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "numberOfVulnsToFetch"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v8 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v9 = {
        "kind": "ScalarField",
        "name": "totalLinkedSecurityContainerCount"
    }, v10 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "numberOfContainersToFetch"
        }
    ], v11 = {
        "kind": "ScalarField",
        "name": "providerId"
    }, v12 = [
        v11 /*: any*/ 
    ], v13 = {
        "kind": "InlineFragment",
        "selections": v12 /*: any*/ ,
        "type": "ThirdPartySecurityContainer"
    }, v14 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v15 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "numberOfVulnsToFetch"
    }, v16 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "and": {
                    "lastUpdated": {
                        "sort": {
                            "order": "ASC",
                            "priority": 1
                        }
                    }
                }
            }
        },
        v15 /*: any*/ 
    ], v17 = {
        "kind": "ScalarField",
        "name": "id"
    }, v18 = {
        "kind": "ScalarField",
        "name": "name"
    }, v19 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v20 = {
        "concreteType": "DevOps",
        "kind": "LinkedField",
        "name": "devOps",
        "plural": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "id",
                        "variableName": "cloudAri"
                    },
                    {
                        "kind": "Literal",
                        "name": "providerTypes",
                        "value": [
                            "SECURITY"
                        ]
                    }
                ],
                "concreteType": "DevOpsProviders",
                "kind": "LinkedField",
                "name": "providers",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "DevOpsSecurityProvider",
                        "kind": "LinkedField",
                        "name": "securityProviders",
                        "plural": true,
                        "selections": [
                            v17 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "appInstallationId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "logoUrl"
                            },
                            v18 /*: any*/ ,
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 100
                                    }
                                ],
                                "concreteType": "AriGraphRelationshipConnection",
                                "kind": "LinkedField",
                                "name": "linkedWorkspaces",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "AriGraphRelationship",
                                        "kind": "LinkedField",
                                        "name": "nodes",
                                        "plural": true,
                                        "selections": [
                                            v19 /*: any*/ 
                                        ]
                                    }
                                ],
                                "storageKey": "linkedWorkspaces(first:100)"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v21 = [
        v17 /*: any*/ 
    ], v22 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v23 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsFeatureFlag"
    }, v24 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsOperationsComponentDetails"
    }, v25 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsOperationsIncidentDetails"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsOperationsPostIncidentReviewDetails"
    }, v27 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsPullRequestDetails"
    }, v28 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsRepository"
    }, v29 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsSecurityVulnerabilityDetails"
    }, v30 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "JiraAutodevJob"
    }, v31 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "JiraConfluenceRemoteIssueLink"
    }, v32 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "JiraCustomRemoteIssueLink"
    }, v33 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "JiraIssueRemoteIssueLink"
    }, v34 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "JiraWebRemoteIssueLink"
    }, v35 = [
        v8 /*: any*/ ,
        v15 /*: any*/ 
    ], v36 = {
        "kind": "ScalarField",
        "name": "url"
    }, v37 = {
        "kind": "ScalarField",
        "name": "key"
    }, v38 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v39 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainSecurityInJiraQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v7 /*: any*/ ,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": [
                                            v8 /*: any*/ ,
                                            {
                                                "kind": "Variable",
                                                "name": "getContainers",
                                                "variableName": "getContainers"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "numberOfContainersToFetch",
                                                "variableName": "numberOfContainersToFetch"
                                            }
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "main_softwareSecurityPage_MainPage"
                                    },
                                    v9 /*: any*/ ,
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v10 /*: any*/ ,
                                            "concreteType": "AriGraphRelationshipConnection",
                                            "kind": "LinkedField",
                                            "name": "linkedSecurityContainers",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationshipEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationship",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "AriGraphRelationshipNode",
                                                                    "kind": "LinkedField",
                                                                    "name": "to",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "condition": "getContainers",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "data",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v13 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v14 /*: any*/ 
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.jiraProjectByKey.linkedSecurityContainers"
                                    },
                                    {
                                        "alias": "linkedVulnsForAnalytics",
                                        "args": v16 /*: any*/ ,
                                        "concreteType": "GraphJiraVulnerabilityConnection",
                                        "kind": "LinkedField",
                                        "name": "linkedSecurityVulnerabilitiesByProject",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "GraphJiraVulnerabilityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "GraphJiraVulnerability",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "condition": "getContainers",
                                                                "kind": "Condition",
                                                                "passingValue": true,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                                        "kind": "LinkedField",
                                                                        "name": "vulnerability",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "ThirdPartySecurityContainer",
                                                                                "kind": "LinkedField",
                                                                                "name": "securityContainer",
                                                                                "plural": false,
                                                                                "selections": v12 /*: any*/ 
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.jiraProjectByKey"
                        }
                    ]
                },
                v20 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v6 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainSecurityInJiraQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v17 /*: any*/ ,
                                {
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "AriGraphRelationshipConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedSecurityContainers",
                                    "plural": false,
                                    "selections": [
                                        v14 /*: any*/ ,
                                        {
                                            "concreteType": "AriGraphRelationshipEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationship",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationshipNode",
                                                            "kind": "LinkedField",
                                                            "name": "to",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "condition": "getContainers",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v19 /*: any*/ ,
                                                                                v13 /*: any*/ ,
                                                                                v22 /*: any*/ ,
                                                                                v23 /*: any*/ ,
                                                                                v24 /*: any*/ ,
                                                                                v25 /*: any*/ ,
                                                                                v26 /*: any*/ ,
                                                                                v27 /*: any*/ ,
                                                                                v28 /*: any*/ ,
                                                                                v29 /*: any*/ ,
                                                                                v30 /*: any*/ ,
                                                                                v31 /*: any*/ ,
                                                                                v32 /*: any*/ ,
                                                                                v33 /*: any*/ ,
                                                                                v34 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v17 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": [
                                        v8 /*: any*/ 
                                    ],
                                    "kind": "ScalarField",
                                    "name": "totalLinkedSecurityVulnerabilityCount"
                                },
                                {
                                    "args": v35 /*: any*/ ,
                                    "concreteType": "GraphJiraVulnerabilityConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedSecurityVulnerabilitiesByProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphJiraVulnerabilityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphJiraVulnerability",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                            "kind": "LinkedField",
                                                            "name": "vulnerability",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "title"
                                                                },
                                                                {
                                                                    "condition": "getContainers",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ThirdPartySecurityContainer",
                                                                            "kind": "LinkedField",
                                                                            "name": "securityContainer",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v17 /*: any*/ ,
                                                                                v18 /*: any*/ ,
                                                                                v36 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "DevOpsSecurityVulnerabilityIdentifier",
                                                                    "kind": "LinkedField",
                                                                    "name": "identifiers",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "displayName"
                                                                        },
                                                                        v36 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "DevOpsSecurityVulnerabilityAdditionalInfo",
                                                                    "kind": "LinkedField",
                                                                    "name": "additionalInfo",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "content"
                                                                        },
                                                                        v36 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "status"
                                                                },
                                                                {
                                                                    "concreteType": "AriGraphRelationshipConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "linkedJiraIssues",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "AriGraphRelationship",
                                                                            "kind": "LinkedField",
                                                                            "name": "nodes",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "AriGraphRelationshipNode",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "to",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v17 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "data",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v19 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": [
                                                                                                                {
                                                                                                                    "kind": "Literal",
                                                                                                                    "name": "idsOrAliases",
                                                                                                                    "value": [
                                                                                                                        "summary",
                                                                                                                        "assignee",
                                                                                                                        "status",
                                                                                                                        "issuetype"
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldsByIdOrAlias",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                v19 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraStatus",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "status",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                v17 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "statusCategory",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v37 /*: any*/ ,
                                                                                                                                        v17 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraStatusField"
                                                                                                                },
                                                                                                                v17 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "fieldId"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "text"
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "user",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "picture"
                                                                                                                                },
                                                                                                                                v17 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "avatar",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "small"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v17 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraIssueTypeField"
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "issueId"
                                                                                                        },
                                                                                                        v37 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "webUrl"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssue"
                                                                                                },
                                                                                                v22 /*: any*/ ,
                                                                                                v23 /*: any*/ ,
                                                                                                v24 /*: any*/ ,
                                                                                                v25 /*: any*/ ,
                                                                                                v26 /*: any*/ ,
                                                                                                v27 /*: any*/ ,
                                                                                                v28 /*: any*/ ,
                                                                                                v29 /*: any*/ ,
                                                                                                v30 /*: any*/ ,
                                                                                                v31 /*: any*/ ,
                                                                                                v32 /*: any*/ ,
                                                                                                v33 /*: any*/ ,
                                                                                                v34 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v14 /*: any*/ 
                                                                    ]
                                                                },
                                                                v17 /*: any*/ ,
                                                                v36 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "introducedDate"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "providerVulnerabilityId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "securityContainerId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "severity"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "description"
                                                                }
                                                            ]
                                                        },
                                                        v17 /*: any*/ ,
                                                        v19 /*: any*/ 
                                                    ]
                                                },
                                                v38 /*: any*/ 
                                            ]
                                        },
                                        v39 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v35 /*: any*/ ,
                                    "filters": [
                                        "filter"
                                    ],
                                    "handle": "connection",
                                    "key": "security__linkedSecurityVulnerabilitiesByProject",
                                    "kind": "LinkedHandle",
                                    "name": "linkedSecurityVulnerabilitiesByProject"
                                },
                                {
                                    "alias": "projectHaveVulnerabilityCheck",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1
                                        }
                                    ],
                                    "concreteType": "GraphJiraVulnerabilityConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedSecurityVulnerabilitiesByProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphJiraVulnerabilityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphJiraVulnerability",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                            "kind": "LinkedField",
                                                            "name": "vulnerability",
                                                            "plural": false,
                                                            "selections": [
                                                                v19 /*: any*/ ,
                                                                v17 /*: any*/ 
                                                            ]
                                                        },
                                                        v17 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "linkedSecurityVulnerabilitiesByProject(first:1)"
                                },
                                {
                                    "alias": "linkedVulnsForAnalytics",
                                    "args": v16 /*: any*/ ,
                                    "concreteType": "GraphJiraVulnerabilityConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedSecurityVulnerabilitiesByProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphJiraVulnerabilityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphJiraVulnerability",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "condition": "getContainers",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                                    "kind": "LinkedField",
                                                                    "name": "vulnerability",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ThirdPartySecurityContainer",
                                                                            "kind": "LinkedField",
                                                                            "name": "securityContainer",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v11 /*: any*/ ,
                                                                                v17 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v17 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v17 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "getContainers",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": v10 /*: any*/ ,
                                            "concreteType": "AriGraphRelationshipConnection",
                                            "kind": "LinkedField",
                                            "name": "linkedSecurityContainers",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationshipEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationship",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "AriGraphRelationshipNode",
                                                                    "kind": "LinkedField",
                                                                    "name": "to",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v19 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v18 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "icon"
                                                                                        },
                                                                                        v36 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "providerName"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "lastUpdated"
                                                                                        },
                                                                                        v14 /*: any*/ ,
                                                                                        v17 /*: any*/ 
                                                                                    ],
                                                                                    "type": "ThirdPartySecurityContainer"
                                                                                },
                                                                                v22 /*: any*/ ,
                                                                                v23 /*: any*/ ,
                                                                                v24 /*: any*/ ,
                                                                                v25 /*: any*/ ,
                                                                                v26 /*: any*/ ,
                                                                                v27 /*: any*/ ,
                                                                                v28 /*: any*/ ,
                                                                                v29 /*: any*/ ,
                                                                                v30 /*: any*/ ,
                                                                                v31 /*: any*/ ,
                                                                                v32 /*: any*/ ,
                                                                                v33 /*: any*/ ,
                                                                                v34 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v19 /*: any*/ 
                                                            ]
                                                        },
                                                        v38 /*: any*/ 
                                                    ]
                                                },
                                                v39 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v10 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "security__linkedSecurityContainers",
                                            "kind": "LinkedHandle",
                                            "name": "linkedSecurityContainers"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v20 /*: any*/ 
            ]
        },
        "params": {
            "id": "5198f24476f61b6137708d014e1bf17fc048a7251fb5049c31fda1aacc83f1ab",
            "metadata": {},
            "name": "mainSecurityInJiraQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$511d4548ae93769f$var$node.hash = "e0029e5d1d9e6e62c9b62d69cc3a9f72";
var $511d4548ae93769f$export$2e2bcd8739ae039 = $511d4548ae93769f$var$node;

});

parcelRegister("ac0bf", function(module, exports) {

$parcel$export(module.exports, "getGqlFiltersFromQueryParams", () => $526907709998fa0b$export$2af359d48d48e5f1);

var $5eeaw = parcelRequire("5eeaw");

var $3zFAD = parcelRequire("3zFAD");

var $3o4IF = parcelRequire("3o4IF");
const $526907709998fa0b$var$getFilterValue = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
values, fieldStortKey, sortKey = (0, $3zFAD.initialVulnerabilityTableOptions).sortKey, sortOrder = (0, $3zFAD.initialVulnerabilityTableOptions).sortOrder)=>({
        ...values.length > 0 ? {
            values: values
        } : {},
        ...sortKey === fieldStortKey && {
            sort: {
                priority: 2,
                order: (0, $3o4IF.parseSortDirection)(sortOrder, (0, $5eeaw.AriGraphSortOrderInput).DESC)
            }
        }
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $526907709998fa0b$var$getOrDefault = (input, defaultArray)=>input.length ? input : defaultArray;
const $526907709998fa0b$export$2af359d48d48e5f1 = (queryParams, connectionAri)=>{
    const containerValues = $526907709998fa0b$var$getOrDefault((0, $3o4IF.connectionQueryParamToFilter)(queryParams[0, $3zFAD.QUERY_PARAM_CONTAINER], connectionAri).filter(Boolean), (0, $3zFAD.initialVulnerabilityTableOptions).connectionFilter);
    const statusQueryParams = (0, $3o4IF.arrayQueryParamToFilter)(queryParams[0, $3zFAD.QUERY_PARAM_VULN_STATUS]);
    return {
        and: [
            {
                lastUpdated: {
                    sort: {
                        priority: 1,
                        order: (0, $5eeaw.AriGraphSortOrderInput).DESC
                    }
                },
                to_severity: $526907709998fa0b$var$getFilterValue($526907709998fa0b$var$getOrDefault((0, $3o4IF.arrayQueryParamToFilter)(queryParams[0, $3zFAD.QUERY_PARAM_SEVERITY]).map((0, $3o4IF.parseSeverity)).filter(Boolean), (0, $3zFAD.initialVulnerabilityTableOptions).severityFilter), 'severity', queryParams[0, $3zFAD.QUERY_PARAM_SORT_KEY], queryParams[0, $3zFAD.QUERY_PARAM_SORT_ORDER]),
                to_status: $526907709998fa0b$var$getFilterValue(statusQueryParams.includes((0, $3zFAD.NO_FILTER_VULN_STATUS)) ? [] : $526907709998fa0b$var$getOrDefault(statusQueryParams.map((0, $3o4IF.parseStatus)).filter(Boolean), (0, $3zFAD.initialVulnerabilityTableOptions).statusFilter), 'status', queryParams[0, $3zFAD.QUERY_PARAM_SORT_KEY], queryParams[0, $3zFAD.QUERY_PARAM_SORT_ORDER]),
                createdAt: {
                    ...queryParams[0, $3zFAD.QUERY_PARAM_SORT_KEY] === 'introduced' && {
                        sort: {
                            priority: 2,
                            order: (0, $3o4IF.parseSortDirection)(queryParams[0, $3zFAD.QUERY_PARAM_SORT_ORDER], (0, $5eeaw.AriGraphSortOrderInput).DESC)
                        }
                    }
                },
                to_container: {
                    containerAri: {
                        value: {
                            ...containerValues.length > 0 ? {
                                values: containerValues
                            } : {}
                        }
                    }
                }
            }
        ]
    };
};

});
parcelRegister("5eeaw", function(module, exports) {

$parcel$export(module.exports, "AriGraphSortOrderInput", () => $f98addb8b52ad07a$export$3b69903df4cd6048);
const $f98addb8b52ad07a$export$3b69903df4cd6048 = {
    ASC: 'ASC',
    DESC: 'DESC'
};

});

parcelRegister("3zFAD", function(module, exports) {

$parcel$export(module.exports, "QUERY_PARAM_SEARCH", () => $d1be2b44eb126533$export$a181206198b7f50c);
$parcel$export(module.exports, "QUERY_PARAM_CONTAINER", () => $d1be2b44eb126533$export$3873b20ffa21b004);
$parcel$export(module.exports, "QUERY_PARAM_SEVERITY", () => $d1be2b44eb126533$export$af01a3d59250f3d3);
$parcel$export(module.exports, "QUERY_PARAM_VULN_STATUS", () => $d1be2b44eb126533$export$c315695f017955dc);
$parcel$export(module.exports, "QUERY_PARAM_ISSUE_STATUS", () => $d1be2b44eb126533$export$2e69a24fe65d4109);
$parcel$export(module.exports, "QUERY_PARAM_SORT_KEY", () => $d1be2b44eb126533$export$6da773286c35ef41);
$parcel$export(module.exports, "QUERY_PARAM_SORT_ORDER", () => $d1be2b44eb126533$export$810a1f7ed2facfcb);
$parcel$export(module.exports, "NO_FILTER_VULN_STATUS", () => $d1be2b44eb126533$export$d8115099d465de4c);
$parcel$export(module.exports, "initialVulnerabilityTableOptions", () => $d1be2b44eb126533$export$e9b4ea84d666c490);
const $d1be2b44eb126533$export$a181206198b7f50c = 'search';
const $d1be2b44eb126533$export$3873b20ffa21b004 = 'container';
const $d1be2b44eb126533$export$af01a3d59250f3d3 = 'severity';
const $d1be2b44eb126533$export$c315695f017955dc = 'vulnerabilityStatus';
const $d1be2b44eb126533$export$2e69a24fe65d4109 = 'issueStatus';
const $d1be2b44eb126533$export$6da773286c35ef41 = 'sortKey';
const $d1be2b44eb126533$export$810a1f7ed2facfcb = 'sortOrder';
const $d1be2b44eb126533$export$d8115099d465de4c = 'NO-FILTERS';
const $d1be2b44eb126533$var$initialVulnerabilityTableFilters = {
    searchFilter: '',
    connectionFilter: [],
    severityFilter: [],
    statusFilter: [
        'OPEN'
    ],
    jiraIssueStatusFilter: []
};
const $d1be2b44eb126533$export$e9b4ea84d666c490 = {
    sortKey: 'severity',
    sortOrder: 'DESC',
    ...$d1be2b44eb126533$var$initialVulnerabilityTableFilters
};

});

parcelRegister("3o4IF", function(module, exports) {

$parcel$export(module.exports, "arrayQueryParamToFilter", () => $dbe4482e2428caff$export$7500862c6689a767);
$parcel$export(module.exports, "arrayFilterToQueryParam", () => $dbe4482e2428caff$export$b0dee3c5bfc7249e);
$parcel$export(module.exports, "connectionFilterToQueryParam", () => $dbe4482e2428caff$export$a6950ca4fdc8498f);
$parcel$export(module.exports, "connectionQueryParamToFilter", () => $dbe4482e2428caff$export$1040034504af5b41);
$parcel$export(module.exports, "parseSeverity", () => $dbe4482e2428caff$export$3551b8a2cbdb5162);
$parcel$export(module.exports, "parseStatus", () => $dbe4482e2428caff$export$2188844eb84f7f06);
$parcel$export(module.exports, "parseSortDirection", () => $dbe4482e2428caff$export$85cf5c73b48a482e);

var $chc6P = parcelRequire("chc6P");

var $80afZ = parcelRequire("80afZ");

var $5eeaw = parcelRequire("5eeaw");

var $i3r1A = parcelRequire("i3r1A");
const $dbe4482e2428caff$var$DELIMITER = ',';
const $dbe4482e2428caff$var$ENCODED_DELIMITER = encodeURIComponent($dbe4482e2428caff$var$DELIMITER);
// We encode the delimiter to protect the values from containing
// the same character that delimits the list.
// e.g.
// env names = ["prod,east", "prod,west"] -> "prod,east,prod,west"
const $dbe4482e2428caff$var$encodeDelimiter = (input)=>{
    const regex = new RegExp($dbe4482e2428caff$var$DELIMITER, 'g');
    return input.replace(regex, $dbe4482e2428caff$var$ENCODED_DELIMITER);
};
const $dbe4482e2428caff$var$decodeDelimiter = (input)=>{
    const regex = new RegExp($dbe4482e2428caff$var$ENCODED_DELIMITER, 'g');
    return input.replace(regex, $dbe4482e2428caff$var$DELIMITER);
};
const $dbe4482e2428caff$export$7500862c6689a767 = (queryParamString)=>queryParamString?.split($dbe4482e2428caff$var$DELIMITER)?.map($dbe4482e2428caff$var$decodeDelimiter) ?? [];
const $dbe4482e2428caff$export$b0dee3c5bfc7249e = (filterArray)=>{
    if (filterArray.length === 0) return undefined;
    return filterArray.map((entity)=>$dbe4482e2428caff$var$encodeDelimiter(entity)).join($dbe4482e2428caff$var$DELIMITER);
};
const $dbe4482e2428caff$export$a6950ca4fdc8498f = (connectionArray)=>{
    if (connectionArray.length === 0) return undefined;
    const groupedConnectionsByAppKey = connectionArray.reduce((acc, connection)=>{
        const [, , , , securityParts] = connection.split(':');
        const [, , , appKey, ...containerId] = securityParts.split('/');
        if (!acc[appKey]) acc[appKey] = [];
        acc[appKey].push(containerId.join('/'));
        return acc;
    }, {});
    return JSON.stringify(groupedConnectionsByAppKey);
};
const $dbe4482e2428caff$export$1040034504af5b41 = (queryParamString, connectionAri)=>{
    if (!queryParamString) return [];
    const groupedConnectionsByAppKey = JSON.parse(queryParamString);
    return (0, (/*@__PURE__*/$parcel$interopDefault($chc6P)))(groupedConnectionsByAppKey, (containerIds, appKey)=>(0, (/*@__PURE__*/$parcel$interopDefault($80afZ)))(containerIds, (containerId)=>`${connectionAri}${appKey}/${containerId}`));
};
const $dbe4482e2428caff$export$3551b8a2cbdb5162 = (maybeSeverity)=>{
    switch(maybeSeverity?.toUpperCase()){
        case (0, $i3r1A.VulnerabilitySeverityEnums).CRITICAL.toUpperCase():
            return (0, $i3r1A.VulnerabilitySeverityEnums).CRITICAL;
        case (0, $i3r1A.VulnerabilitySeverityEnums).HIGH.toUpperCase():
            return (0, $i3r1A.VulnerabilitySeverityEnums).HIGH;
        case (0, $i3r1A.VulnerabilitySeverityEnums).LOW.toUpperCase():
            return (0, $i3r1A.VulnerabilitySeverityEnums).LOW;
        case (0, $i3r1A.VulnerabilitySeverityEnums).MEDIUM.toUpperCase():
            return (0, $i3r1A.VulnerabilitySeverityEnums).MEDIUM;
        case (0, $i3r1A.VulnerabilitySeverityEnums).UNKNOWN.toUpperCase():
            return (0, $i3r1A.VulnerabilitySeverityEnums).UNKNOWN;
        default:
            return undefined;
    }
};
const $dbe4482e2428caff$export$2188844eb84f7f06 = (maybeStatus)=>{
    switch(maybeStatus?.toUpperCase()){
        case (0, $i3r1A.VulnerabilityStatusEnums).OPEN.toUpperCase():
            return (0, $i3r1A.VulnerabilityStatusEnums).OPEN;
        case (0, $i3r1A.VulnerabilityStatusEnums).UNKNOWN.toUpperCase():
            return (0, $i3r1A.VulnerabilityStatusEnums).UNKNOWN;
        case (0, $i3r1A.VulnerabilityStatusEnums).CLOSED.toUpperCase():
            return (0, $i3r1A.VulnerabilityStatusEnums).CLOSED;
        case (0, $i3r1A.VulnerabilityStatusEnums).IGNORED.toUpperCase():
            return (0, $i3r1A.VulnerabilityStatusEnums).IGNORED;
        default:
            return undefined;
    }
};
const $dbe4482e2428caff$export$85cf5c73b48a482e = (maybeDirection, defaultValue)=>{
    switch(maybeDirection?.toUpperCase()){
        case (0, $5eeaw.AriGraphSortOrderInput).ASC.toUpperCase():
            return (0, $5eeaw.AriGraphSortOrderInput).ASC;
        case (0, $5eeaw.AriGraphSortOrderInput).DESC.toUpperCase():
            return (0, $5eeaw.AriGraphSortOrderInput).DESC;
        default:
            return defaultValue;
    }
};

});
parcelRegister("chc6P", function(module, exports) {

var $ekcP3 = parcelRequire("ekcP3");

var $80afZ = parcelRequire("80afZ");
/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $8f007734a6a4d9ac$var$flatMap(collection, iteratee) {
    return $ekcP3($80afZ(collection, iteratee), 1);
}
module.exports = $8f007734a6a4d9ac$var$flatMap;

});
parcelRegister("80afZ", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");

var $bxDef = parcelRequire("bxDef");

var $jXnVG = parcelRequire("jXnVG");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $5d3647a04b83e8d6$var$map(collection, iteratee) {
    var func = $8LQ84(collection) ? $1nIHN : $jXnVG;
    return func(collection, $bxDef(iteratee, 3));
}
module.exports = $5d3647a04b83e8d6$var$map;

});


parcelRegister("i3r1A", function(module, exports) {

$parcel$export(module.exports, "VulnerabilitySeverityEnums", () => $e40f3ad586d15bb3$export$c1a102938d8dc10);
$parcel$export(module.exports, "VulnerabilityStatusEnums", () => $e40f3ad586d15bb3$export$2d6749bded378262);
const $e40f3ad586d15bb3$export$c1a102938d8dc10 = {
    CRITICAL: 'CRITICAL',
    HIGH: 'HIGH',
    LOW: 'LOW',
    MEDIUM: 'MEDIUM',
    UNKNOWN: 'UNKNOWN'
};
const $e40f3ad586d15bb3$export$2d6749bded378262 = {
    CLOSED: 'CLOSED',
    IGNORED: 'IGNORED',
    OPEN: 'OPEN',
    UNKNOWN: 'UNKNOWN'
};
const $e40f3ad586d15bb3$var$VulnerabilityTypeEnums = {
    DAST: 'DAST',
    SAST: 'SAST',
    SCA: 'SCA',
    UNKNOWN: 'UNKNOWN'
};

});



const $0a72320b8bc3a1aa$export$f24db22c3c834cb1 = 'SOFTWARE_SECURITY';


parcelRegister("d1QwJ", function(module, exports) {

$parcel$export(module.exports, "softwareSecurityNextGenRoute", () => $38bba03addfade00$export$a2aed78ebacc3233);
const $38bba03addfade00$export$a2aed78ebacc3233 = {
    name: 'software-security',
    path: '/jira/software/projects/:projectKey/security'
};

});

parcelRegister("crK2h", function(module, exports) {

$parcel$export(module.exports, "isSecurityPageEnabled", () => $36196b3bd8f08294$export$f99b2868577ed515);

var $4R6GH = parcelRequire("4R6GH");

var $kfztd = parcelRequire("kfztd");
const $36196b3bd8f08294$export$f99b2868577ed515 = ()=>!(0, $kfztd.isDevopsFeatureDisabledInFedRamp)() && (0, $4R6GH.fg)('isotopes-security-page-in-jira-enabled-v2');

});

parcelRegister("7AM4I", function(module, exports) {

$parcel$export(module.exports, "securityPageEntrypoint", () => $3090928057015737$export$5f2f9dbf41e3e769);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $kyG7f = parcelRequire("kyG7f");

var $fo6b8 = parcelRequire("fo6b8");
const $3090928057015737$export$5f2f9dbf41e3e769 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $kyG7f.securityEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("kyG7f", function(module, exports) {

$parcel$export(module.exports, "securityEntrypoint", () => $9ed435daf1131762$export$63f7fc80f88b035a);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $9ed435daf1131762$export$63f7fc80f88b035a = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("hCQIy")), {
        moduleId: "c02ceeea"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("hCQIy", function(module, exports) {

let $cd4ee0eb0f4059bd$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $cd4ee0eb0f4059bd$var$load("ffQaD"),
    $cd4ee0eb0f4059bd$var$load("kvRbA"),
    $cd4ee0eb0f4059bd$var$load("5nKJ0")
]).then(()=>parcelRequire('9J8Ay'));

});




parcelRegister("9EGBH", function(module, exports) {

$parcel$export(module.exports, "softwareSummaryRouteEntry", () => $68cc040c529fc630$export$a2560b0baf928c49);

var $e4eHl = parcelRequire("e4eHl");

var $ffza4 = parcelRequire("ffza4");

var $lkFvK = parcelRequire("lkFvK");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $5lsNZ = parcelRequire("5lsNZ");

var $7P9Hl = parcelRequire("7P9Hl");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $1wsDh = parcelRequire("1wsDh");

var $fo6b8 = parcelRequire("fo6b8");

var $4R6GH = parcelRequire("4R6GH");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");

var $f3iuv = parcelRequire("f3iuv");
/**
 * @deprecated delete when cleaning up project_summary_page_entry_point_migration
 */ const $68cc040c529fc630$var$getHorizontalNavResources = ()=>(0, $4R6GH.fg)('project_summary_page_entry_point_migration') ? [] : [
        (0, $7uLIV.horizontalNavJiraResource)
    ];
const $68cc040c529fc630$var$summarySoftwarePageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1wsDh.summarySoftwareEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $68cc040c529fc630$export$a2560b0baf928c49 = (0, $7NszV.createEntry)((0, $7P9Hl.softwareSummaryRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-summary',
        component: (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expVal)('helios_summary_page_experiment', 'isEnabled', false), (0, $f3iuv.SummaryPage), (0, $5lsNZ.default)),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            /// delete when cleaning up project_summary_page_entry_point_migration
            ...$68cc040c529fc630$var$getHorizontalNavResources(),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource))
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $f3iuv.LazySummaryView)
        ],
        meta: {
            reporting: {
                id: 'software-summary',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-summary'),
                teamName: 'Helios - Reports'
            }
        },
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('project_summary_page_entry_point_migration')) return $68cc040c529fc630$var$summarySoftwarePageEntrypoint;
        }
    }));

});
parcelRegister("7P9Hl", function(module, exports) {

$parcel$export(module.exports, "softwareSummaryRoute", () => $cff79d22061504ff$export$c6629202e90df62a);
const $cff79d22061504ff$export$c6629202e90df62a = {
    name: 'software-summary',
    path: '/jira/software/projects/:projectKey/summary'
};

});

parcelRegister("1wsDh", function(module, exports) {

$parcel$export(module.exports, "summarySoftwareEntrypoint", () => $be62f623caf39bbf$export$6c7cf31fcbd213b8);

var $6qQRa = parcelRequire("6qQRa");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $be62f623caf39bbf$export$6c7cf31fcbd213b8 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("2W5Lj")), {
        moduleId: "078ea488"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                summaryQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $6qQRa.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("6qQRa", function(module, exports) {

$parcel$export(module.exports, "default", () => $84891a6ef49bdd23$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2c0776ec3e9f6a74e53887f11a831651>>
 * @relayHash 51efb3864f270fc508c3c4676be5d9f6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8b8af805c4172b0ed36c74fe68563d0a938d57e1cf91158c7fa6cbe92c6dc022
const $84891a6ef49bdd23$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "8b8af805c4172b0ed36c74fe68563d0a938d57e1cf91158c7fa6cbe92c6dc022",
        "metadata": {},
        "name": "src_jiraSummarySoftwareQuery",
        "operationKind": "query",
        "text": null
    }
};
var $84891a6ef49bdd23$export$2e2bcd8739ae039 = $84891a6ef49bdd23$var$node;

});

parcelRegister("2W5Lj", function(module, exports) {

let $223577cd02d27ccb$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $223577cd02d27ccb$var$load("fliVL"),
    $223577cd02d27ccb$var$load("d8OKj")
]).then(()=>parcelRequire('l0bjd'));

});


parcelRegister("f3iuv", function(module, exports) {

$parcel$export(module.exports, "LazySummaryView", () => $d82700466a756427$export$68c09444cc6f2843);
$parcel$export(module.exports, "SummaryPage", () => $d82700466a756427$export$893608e1a22999b9);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $d82700466a756427$export$68c09444cc6f2843 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("8OGnU")), {
    moduleId: "./src/packages/spa-apps/software/summary/src/index.tsx"
});
const $d82700466a756427$export$893608e1a22999b9 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d82700466a756427$export$68c09444cc6f2843,
        pageId: "software-summary",
        shouldShowSpinner: true
    });
};

});
parcelRegister("8OGnU", function(module, exports) {

let $66b3def4969ccd6c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $66b3def4969ccd6c$var$load("fliVL"),
    $66b3def4969ccd6c$var$load("6kvkI")
]).then(()=>parcelRequire('iPGiI'));

});



parcelRegister("45nsl", function(module, exports) {

$parcel$export(module.exports, "softwareSummaryEmbedRouteEntry", () => $68cfbfd8adbf1577$export$d0dcb1130082d8e);

var $e4eHl = parcelRequire("e4eHl");

var $6e4Kt = parcelRequire("6e4Kt");

var $7NszV = parcelRequire("7NszV");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $5lsNZ = parcelRequire("5lsNZ");

var $czTBf = parcelRequire("czTBf");

var $5bkvv = parcelRequire("5bkvv");

var $dxCvy = parcelRequire("dxCvy");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $9Hxle = parcelRequire("9Hxle");

var $4R6GH = parcelRequire("4R6GH");

var $lkFvK = parcelRequire("lkFvK");

var $jEWyg = parcelRequire("jEWyg");
const $68cfbfd8adbf1577$var$summarySoftwareEmbedPageEntrypoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $9Hxle.summarySoftwareEmbedEntrypoint)
});
const $68cfbfd8adbf1577$export$d0dcb1130082d8e = (0, $7NszV.createEntry)((0, $czTBf.softwareSummaryEmbedRoute), ()=>({
        group: 'software',
        ufoName: 'next-gen-summary-embed',
        component: (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expVal)('jsw-summary-page-embed-smart-link-experiment', 'isEnabled', false), (0, $jEWyg.SummaryEmbedPage), (0, $5lsNZ.default)),
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource)
        ],
        forPaint: [
            (0, $jEWyg.LazySummaryEmbedView)
        ],
        meta: {
            reporting: {
                id: 'software-summary-embed',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-summary-embed'),
                teamName: 'Helios - Reports'
            }
        },
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('project_summary_page_entry_point_migration')) return $68cfbfd8adbf1577$var$summarySoftwareEmbedPageEntrypoint;
        }
    }));

});
parcelRegister("czTBf", function(module, exports) {

$parcel$export(module.exports, "softwareSummaryEmbedRoute", () => $47c531ece2da49b6$export$11863f01f5694529);
const $47c531ece2da49b6$export$11863f01f5694529 = {
    name: 'software-summary-embed',
    path: '/jira/software/projects/:projectKey/summary/embed'
};

});

parcelRegister("9Hxle", function(module, exports) {

$parcel$export(module.exports, "summarySoftwareEmbedEntrypoint", () => $dceaf7b32f2cb59b$export$4eeb5d2e0e9b94b6);

var $31XuO = parcelRequire("31XuO");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $dceaf7b32f2cb59b$export$4eeb5d2e0e9b94b6 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("001bi")), {
        moduleId: "192c966d"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                summaryQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $31XuO.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("31XuO", function(module, exports) {

$parcel$export(module.exports, "default", () => $48d77923a7d779ad$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<28aa849ce641b8c8bef67b5f178b9188>>
 * @relayHash 886a8ebe0b7faaa17276f23a1313cc2e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ec953cd8f672124749ec67356940dfd48e2bc1b926c2f3ce46d963fbecdceed3
const $48d77923a7d779ad$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "ec953cd8f672124749ec67356940dfd48e2bc1b926c2f3ce46d963fbecdceed3",
        "metadata": {},
        "name": "src_jiraSummarySoftwareEmbedQuery",
        "operationKind": "query",
        "text": null
    }
};
var $48d77923a7d779ad$export$2e2bcd8739ae039 = $48d77923a7d779ad$var$node;

});

parcelRegister("001bi", function(module, exports) {

let $0000eabf280b4585$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0000eabf280b4585$var$load("fliVL"),
    $0000eabf280b4585$var$load("6DaVr")
]).then(()=>parcelRequire('3aj3b'));

});


parcelRegister("jEWyg", function(module, exports) {

$parcel$export(module.exports, "LazySummaryEmbedView", () => $e2492c3e1d27fc60$export$f3f4cdbc1967d695);
$parcel$export(module.exports, "SummaryEmbedPage", () => $e2492c3e1d27fc60$export$f811b1e7f401bfca);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $e2492c3e1d27fc60$export$f3f4cdbc1967d695 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("5ZfiK")), {
    moduleId: "./src/packages/spa-apps/software/summary-embed/src/index.tsx"
});
const $e2492c3e1d27fc60$export$f811b1e7f401bfca = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e2492c3e1d27fc60$export$f3f4cdbc1967d695,
        pageId: "software-summary-embed",
        shouldShowSpinner: true
    });
};

});
parcelRegister("5ZfiK", function(module, exports) {

let $45be84c9cde8da39$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $45be84c9cde8da39$var$load("fliVL"),
    $45be84c9cde8da39$var$load("eDKGL")
]).then(()=>parcelRequire('ipup0'));

});



parcelRegister("jejF3", function(module, exports) {

$parcel$export(module.exports, "softwareTimelineRouteEntry", () => $e9207ae3efc3becd$export$ace6a996c7e99f3);

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $jsFU4 = parcelRequire("jsFU4");

var $7GnDe = parcelRequire("7GnDe");

var $3gei1 = parcelRequire("3gei1");

var $8STJR = parcelRequire("8STJR");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");

var $4R6GH = parcelRequire("4R6GH");

var $fAhgR = parcelRequire("fAhgR");
const $e9207ae3efc3becd$var$getConditionalResources = ()=>(0, $4R6GH.fg)('optimise_timeline_routes') ? [
        (0, $5bkvv.forgeProjectModuleResourceOnNav3Only),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only)
    ] : [
        (0, $5bkvv.forgeProjectModuleResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
    ];
const $e9207ae3efc3becd$export$ace6a996c7e99f3 = (0, $7NszV.createEntry)((0, $3gei1.softwareTimelineRoute), ()=>({
        group: 'software',
        skeleton: (0, $8STJR.RoadmapSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $4R6GH.fg)('optimise_timeline_routes') ? (0, $e7bC3.softwareProjectLayoutCode) : (0, $e7bC3.softwareProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
            (0, $dxCvy.projectContextResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            ...$e9207ae3efc3becd$var$getConditionalResources(),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $jsFU4.nextGenRoadmapResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource))
        ],
        preloadOptions: {
            earlyChunks: [
                'software-roadmap-early-entry'
            ]
        },
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        entryPoint: ()=>(0, $fAhgR.softwareTimelinePageEntrypoint),
        ufoName: 'next-gen-roadmap'
    }));

});
parcelRegister("3gei1", function(module, exports) {

$parcel$export(module.exports, "softwareTimelineRoute", () => $2ea9397ffa8c64ef$export$d25dafcda96d5af9);
const $2ea9397ffa8c64ef$export$d25dafcda96d5af9 = {
    name: 'software-timeline',
    path: '/jira/software/projects/:projectKey/boards/:boardId/timeline'
};

});

parcelRegister("fAhgR", function(module, exports) {

$parcel$export(module.exports, "softwareTimelinePageEntrypoint", () => $faefef5a329d510c$export$3315ee4fac32ee8);

var $lkFvK = parcelRequire("lkFvK");

var $fo6b8 = parcelRequire("fo6b8");

var $lmyls = parcelRequire("lmyls");

var $fT58V = parcelRequire("fT58V");

var $krpZe = parcelRequire("krpZe");

var $7lSbA = parcelRequire("7lSbA");
const $faefef5a329d510c$export$3315ee4fac32ee8 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7lSbA.softwareTimelineEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $fT58V.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $krpZe.nav4ProjectsContentEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("7lSbA", function(module, exports) {

$parcel$export(module.exports, "softwareTimelineEntrypoint", () => $db07900879e9590e$export$85a905c235ac34bb);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $db07900879e9590e$export$85a905c235ac34bb = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("293Nh")), {
        moduleId: "7e6b0610"
    }),
    getPreloadProps: ()=>({})
});

});



parcelRegister("eKEYN", function(module, exports) {

$parcel$export(module.exports, "softwareVersionDetailEmbedRouteEntry", () => $f99c918791c41018$export$83102a6097008c79);

var $e4eHl = parcelRequire("e4eHl");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $kt0pG = parcelRequire("kt0pG");

var $4gudm = parcelRequire("4gudm");

var $bQc17 = parcelRequire("bQc17");

var $jchNA = parcelRequire("jchNA");
const $f99c918791c41018$export$83102a6097008c79 = (0, $7NszV.createEntry)((0, $4gudm.softwareVersionDetailEmbedRoute), ()=>({
        group: 'software',
        ufoName: 'software.version-details-page-embed',
        component: (0, $jchNA.VersionDetailPage),
        skeleton: (0, $bQc17.VersionDetailSkeleton),
        canTransitionIn: ()=>true,
        layout: (0, $aPfsS.createLayout)({
            isChromeless: true
        }),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $kt0pG.versionDetailsRelayResourceCustom),
            (0, $dxCvy.projectContextResource)
        ],
        forPaint: [
            (0, $jchNA.LazyVersionDetail)
        ],
        meta: {
            reporting: {
                id: 'software-version-detail-embed',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-version-detail-embed'),
                teamName: 'nova'
            }
        }
    }));

});
parcelRegister("kt0pG", function(module, exports) {

$parcel$export(module.exports, "versionDetailsRelayResourceCustom", () => $57dfad429d4f47cb$export$c56c5b19da4d0fd1);
/* eslint-disable jira/import-whitelist */ 
var $8Uumt = parcelRequire("8Uumt");

var $dXq4S = parcelRequire("dXq4S");

var $5yJb9 = parcelRequire("5yJb9");

var $kipqU = parcelRequire("kipqU");

var $ao2h1 = parcelRequire("ao2h1");

var $dvgjB = parcelRequire("dvgjB");

var $kfztd = parcelRequire("kfztd");

var $20fNh = parcelRequire("20fNh");

var $9NiTW = parcelRequire("9NiTW");

var $2M1hQ = parcelRequire("2M1hQ");

const $57dfad429d4f47cb$export$c56c5b19da4d0fd1 = (0, $2M1hQ.createResource)({
    type: `${(0, $ao2h1.RELAY_RESOURCE_TYPE)}_${(0, $afc34106ac722f11$export$9fe575a15a87a796)}`,
    // Deliberately returning the static key, not to rerun query by resource, as different key returns null queryReference shortly while the query is running, when filter query parameter is changed,
    // which is believed to be a bug in react-resource-router part, but we don't know the reason yet.
    // Context: https://atlassian.slack.com/archives/CFLN3FEF8/p1680495188086669
    // Due to the same bug, issue navigator team is doing the similar technique: src/packages/routes/src/ui/spa/issue-navigator/resources/index.tsx
    getKey: ({ match: match })=>{
        const { versionId: versionId } = match.params;
        const parsedVersionId = String(versionId ?? '').replace(/\D/g, '');
        return `jsw-releases-version-details-main-query-relay-${parsedVersionId}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { versionId: versionId } = match.params;
        const { filters: filters, sortBy: sortBy } = (0, $20fNh.toVersionIssuesGraphQLVariables)(query);
        const parsedVersionId = String(versionId ?? '').replace(/\D/g, '');
        const variables = {
            cloudAri: (0, $dXq4S.createAri)({
                resourceOwner: 'jira',
                resourceType: 'site',
                resourceId: tenantContext.cloudId
            }),
            versionAri: (0, $dXq4S.createAri)({
                resourceOwner: 'jira',
                cloudId: tenantContext.cloudId,
                resourceType: 'version/activation',
                resourceId: String(`${tenantContext.activationId}/${parsedVersionId}`)
            }),
            sortBy: sortBy,
            filters: filters,
            skip: !(0, $9NiTW.checkAuthentication)(tenantContext) || parsedVersionId.length === 0,
            isDevopsFeatureDisabledInFedRamp: (0, $kfztd.isDevopsFeatureDisabledInFedRamp)(),
            shouldIncludeDevOpsFieldsViaAgs: !(0, $kfztd.isDevopsFeatureDisabledInFedRamp)()
        };
        const queryReference = (0, $8Uumt.loadQuery)((0, $5yJb9.default)(), (0, $dvgjB.default), variables, {
            fetchPolicy: 'store-or-network'
        });
        if (false && queryReference.id != null) await (0, $kipqU.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});

});
parcelRegister("dvgjB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ecc7304dc73fa0e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bf23a345422fae2de0fc195dfee8d350>>
 * @relayHash 3c2963a896f9ac591f5fb2936c1ded83
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 351c38d4204be4347504920dc67489a9b231b37872183d43398f22a7a61e6236
const $8ecc7304dc73fa0e$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "351c38d4204be4347504920dc67489a9b231b37872183d43398f22a7a61e6236",
        "metadata": {},
        "name": "uiVersionDetailsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $8ecc7304dc73fa0e$export$2e2bcd8739ae039 = $8ecc7304dc73fa0e$var$node;

});

parcelRegister("20fNh", function(module, exports) {

$parcel$export(module.exports, "toVersionIssuesGraphQLVariables", () => $3e331943907e0f7c$export$72df1c7780b3e8e2);
$parcel$export(module.exports, "useVersionIssuesGraphQLVariables", () => $3e331943907e0f7c$export$3d12d3ffbce57135);

var $3hGWp = parcelRequire("3hGWp");


var $jPgXx = parcelRequire("jPgXx");

var $3dG8c = parcelRequire("3dG8c");
const $3e331943907e0f7c$var$accountIdToAriStr = (accountIds)=>{
    if (accountIds == null) return null;
    return accountIds.map((accountId)=>accountId === 'UNASSIGNED' ? null : `ari:cloud:identity::user/${accountId}`);
};
const $3e331943907e0f7c$export$72df1c7780b3e8e2 = (queryParams)=>{
    const parsedQueryParams = (0, $3dG8c.parseQueryParams)(queryParams);
    return {
        filters: {
            searchStr: parsedQueryParams[0, $5d187be87424268f$export$e39925d10cebc0b] ?? null,
            epicIds: parsedQueryParams[0, $5d187be87424268f$export$b98a7875ddbefaac] ?? null,
            statusCategories: parsedQueryParams[0, $5d187be87424268f$export$c307007520232013] != null ? parsedQueryParams[0, $5d187be87424268f$export$c307007520232013].filter((0, $jPgXx.isVersionStatusCategory)) : null,
            warningCategories: parsedQueryParams[0, $5d187be87424268f$export$2552faed9df6a2cd] ?? null,
            assigneeAccountIds: $3e331943907e0f7c$var$accountIdToAriStr(parsedQueryParams[0, $5d187be87424268f$export$f78d8c81fcad32a2])
        },
        sortBy: {
            sortByField: parsedQueryParams[0, $5d187be87424268f$export$13d5b2891ca65cd6] ?? 'CREATED',
            order: parsedQueryParams[0, $5d187be87424268f$export$810a1f7ed2facfcb] ?? 'ASC'
        }
    };
};
const $3e331943907e0f7c$export$3d12d3ffbce57135 = ()=>{
    const [queryParams] = (0, $3hGWp.useQueryParams)((0, $5d187be87424268f$export$e39925d10cebc0b), (0, $5d187be87424268f$export$b98a7875ddbefaac), (0, $5d187be87424268f$export$c307007520232013), (0, $5d187be87424268f$export$2552faed9df6a2cd), (0, $5d187be87424268f$export$f78d8c81fcad32a2), (0, $5d187be87424268f$export$13d5b2891ca65cd6), (0, $5d187be87424268f$export$810a1f7ed2facfcb));
    return $3e331943907e0f7c$export$72df1c7780b3e8e2(queryParams);
};

});
parcelRegister("3hGWp", function(module, exports) {

$parcel$export(module.exports, "useQueryParams", () => $afd0e0a12e1f2496$export$b37ee0d76c6d2fbc);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $hGgHi = parcelRequire("hGgHi");

var $9xWGk = parcelRequire("9xWGk");

var $ebyGx = parcelRequire("ebyGx");

var $doZTA = parcelRequire("doZTA");
const $afd0e0a12e1f2496$export$b37ee0d76c6d2fbc = (...queryParamsToWatch)=>{
    const [{ location: { pathname: pathname }, query: query }, { push: push, replace: replace }] = (0, $doZTA.useRouter)();
    const queryParamsRef = (0, $5uXOq.useRef)({});
    const parsedQueryParams = (0, $5uXOq.useMemo)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newQueryParams = queryParamsToWatch.reduce((accumulator, currentValue)=>{
            accumulator[currentValue] = query[currentValue] || undefined;
            return accumulator;
        }, {});
        // update cache only when one of requested params actually changed
        // otherwise return cached value to avoid changing return object reference
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(queryParamsRef.current, newQueryParams)) queryParamsRef.current = newQueryParams;
        return queryParamsRef.current;
    }, [
        query,
        queryParamsToWatch
    ]);
    const setQueryParams = (0, $5uXOq.useCallback)((newQueryParams, options)=>{
        const parsedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))({
            ...query,
            ...newQueryParams
        }, (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value));
        const { updateType: updateType, ...stringifyOptions } = options ?? {};
        // @ts-expect-error - TS2559 - Type '{ sort?: false | ((a: string, b: string) => number) | undefined; }' has no properties in common with type 'StringifyOptions'.
        const strSearch = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(parsedSearch, stringifyOptions);
        const url = pathname + (strSearch !== '' ? `?${strSearch}` : '');
        updateType === 'replace' ? replace(url) : push(url);
    }, [
        pathname,
        push,
        replace,
        query
    ]);
    return [
        parsedQueryParams,
        setQueryParams
    ];
};

});

const $5d187be87424268f$export$e39925d10cebc0b = 'text';
const $5d187be87424268f$export$b98a7875ddbefaac = 'epics';
const $5d187be87424268f$export$c307007520232013 = 'statusCategory';
const $5d187be87424268f$export$2552faed9df6a2cd = 'warnings';
const $5d187be87424268f$export$f78d8c81fcad32a2 = 'assignee';
const $5d187be87424268f$export$13d5b2891ca65cd6 = 'sortBy';
const $5d187be87424268f$export$810a1f7ed2facfcb = 'sortOrder';

parcelRegister("jPgXx", function(module, exports) {

$parcel$export(module.exports, "isWarningsFilterValue", () => $1bd9df170beee33d$export$5c25bcf27380084);
$parcel$export(module.exports, "toWarningsFilterValue", () => $1bd9df170beee33d$export$ac3017cd78edb8a1);
$parcel$export(module.exports, "isVersionStatusCategory", () => $1bd9df170beee33d$export$3af93bbba0d4241a);
$parcel$export(module.exports, "isSortBy", () => $1bd9df170beee33d$export$472650e4cbd40b70);
$parcel$export(module.exports, "isSortOrder", () => $1bd9df170beee33d$export$dfece8cb679d32a3);

var $gULOk = parcelRequire("gULOk");
const $1bd9df170beee33d$export$5c25bcf27380084 = (val)=>val === 'OPEN_PULL_REQUEST' || val === 'UNREVIEWED_CODE' || val === 'FAILING_BUILD' || val === 'OPEN_REVIEW';
const $1bd9df170beee33d$export$ac3017cd78edb8a1 = (statusCategoryFromQueryParam)=>statusCategoryFromQueryParam.filter($1bd9df170beee33d$export$5c25bcf27380084);
const $1bd9df170beee33d$export$3af93bbba0d4241a = (val)=>val === (0, $gULOk.TODO) || val === (0, $gULOk.IN_PROGRESS) || val === (0, $gULOk.DONE);
const $1bd9df170beee33d$export$472650e4cbd40b70 = (val)=>val === 'ASSIGNEE' || val === 'CREATED' || val === 'KEY' || val === 'PRIORITY' || val === 'STATUS' || val === 'TYPE';
const $1bd9df170beee33d$export$dfece8cb679d32a3 = (val)=>val === 'ASC' || val === 'DESC';

});
parcelRegister("gULOk", function(module, exports) {

$parcel$export(module.exports, "UNDEFINED", () => $e77315bf13f8b83b$export$6db089fe7b26f5b6);
$parcel$export(module.exports, "TODO", () => $e77315bf13f8b83b$export$aa456a5030160740);
$parcel$export(module.exports, "IN_PROGRESS", () => $e77315bf13f8b83b$export$5a9ac66c2785cc13);
$parcel$export(module.exports, "DONE", () => $e77315bf13f8b83b$export$71efb3495f6084f2);
$parcel$export(module.exports, "STATUS_CATEGORIES", () => $e77315bf13f8b83b$export$d9119300f9d9a815);
$parcel$export(module.exports, "StatusCategoryTypes", () => $e77315bf13f8b83b$export$5d42a08d46cffe7);
$parcel$export(module.exports, "StatusCategoryIds", () => $e77315bf13f8b83b$export$3f42f49c284d5b58);
$parcel$export(module.exports, "statusCategoryKeys", () => $e77315bf13f8b83b$export$f3f919dc0f56d9eb);
$parcel$export(module.exports, "statusCategoryForId", () => $e77315bf13f8b83b$export$3e9e3002956ff4fb);
$parcel$export(module.exports, "categoryIdForStatusCategory", () => $e77315bf13f8b83b$export$7b16b0022aac2d46);
$parcel$export(module.exports, "isValidStatusCategoryKey", () => $e77315bf13f8b83b$export$d928f247c903643a);
const $e77315bf13f8b83b$export$6db089fe7b26f5b6 = 'UNDEFINED';
const $e77315bf13f8b83b$export$aa456a5030160740 = 'TODO';
const $e77315bf13f8b83b$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
const $e77315bf13f8b83b$export$71efb3495f6084f2 = 'DONE';
const $e77315bf13f8b83b$export$d9119300f9d9a815 = [
    $e77315bf13f8b83b$export$6db089fe7b26f5b6,
    $e77315bf13f8b83b$export$aa456a5030160740,
    $e77315bf13f8b83b$export$5a9ac66c2785cc13,
    $e77315bf13f8b83b$export$71efb3495f6084f2
];
const $e77315bf13f8b83b$var$statusCategories = [
    {
        id: '1',
        statusCategory: $e77315bf13f8b83b$export$6db089fe7b26f5b6
    },
    {
        id: '2',
        statusCategory: $e77315bf13f8b83b$export$aa456a5030160740
    },
    {
        id: '4',
        statusCategory: $e77315bf13f8b83b$export$5a9ac66c2785cc13
    },
    {
        id: '3',
        statusCategory: $e77315bf13f8b83b$export$71efb3495f6084f2
    }
];
const $e77315bf13f8b83b$export$5d42a08d46cffe7 = Object.freeze({
    NEW: 'new',
    INDETERMINATE: 'indeterminate',
    DONE: 'done',
    UNDEFINED: 'undefined'
});
const $e77315bf13f8b83b$export$3f42f49c284d5b58 = Object.freeze({
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.UNDEFINED]: 1,
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.NEW]: 2,
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.DONE]: 3,
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.INDETERMINATE]: 4
});
const $e77315bf13f8b83b$export$f3f919dc0f56d9eb = Object.values($e77315bf13f8b83b$export$5d42a08d46cffe7);
const $e77315bf13f8b83b$export$3e9e3002956ff4fb = (statusCategoryId)=>{
    const value = $e77315bf13f8b83b$var$statusCategories.find((sc)=>sc.id === String(statusCategoryId));
    return value ? value.statusCategory : $e77315bf13f8b83b$export$6db089fe7b26f5b6;
};
const $e77315bf13f8b83b$export$7b16b0022aac2d46 = (statusCategory)=>{
    const value = $e77315bf13f8b83b$var$statusCategories.find((sc)=>sc.statusCategory === statusCategory);
    return Number(value ? value.id : '1');
};
const $e77315bf13f8b83b$export$d928f247c903643a = (key)=>$e77315bf13f8b83b$export$f3f919dc0f56d9eb.some((statusCategoryKey)=>statusCategoryKey === key);

});


parcelRegister("3dG8c", function(module, exports) {

$parcel$export(module.exports, "isAnyFilterApplied", () => $89761db99e7e0304$export$e6b3ec1d09429da8);
$parcel$export(module.exports, "parseQueryParams", () => $89761db99e7e0304$export$67c4cee80a3410cd);

var $g5X3G = parcelRequire("g5X3G");


var $jPgXx = parcelRequire("jPgXx");
const $89761db99e7e0304$export$e6b3ec1d09429da8 = (parsedQueryParams)=>parsedQueryParams[0, $5d187be87424268f$export$e39925d10cebc0b] != null && parsedQueryParams[0, $5d187be87424268f$export$e39925d10cebc0b].length > 0 || parsedQueryParams[0, $5d187be87424268f$export$b98a7875ddbefaac] != null && parsedQueryParams[0, $5d187be87424268f$export$b98a7875ddbefaac].length > 0 || parsedQueryParams[0, $5d187be87424268f$export$c307007520232013] != null && parsedQueryParams[0, $5d187be87424268f$export$c307007520232013].length > 0 || parsedQueryParams[0, $5d187be87424268f$export$2552faed9df6a2cd] != null && parsedQueryParams[0, $5d187be87424268f$export$2552faed9df6a2cd].length > 0 || parsedQueryParams[0, $5d187be87424268f$export$f78d8c81fcad32a2] != null && parsedQueryParams[0, $5d187be87424268f$export$f78d8c81fcad32a2].length > 0;
const $89761db99e7e0304$export$2a2e94972ab280d4 = (paramValue)=>paramValue == null ? undefined : paramValue.split(',').map((str)=>str.trim()).map((0, $g5X3G.toIssueId));
const $89761db99e7e0304$export$fb136b568c6d78b5 = (paramValue)=>paramValue == null ? undefined : paramValue.split(',').map((str)=>str.trim()).filter((0, $jPgXx.isVersionStatusCategory));
const $89761db99e7e0304$export$5cb324c621ca24e8 = (paramValue)=>paramValue == null ? undefined : (0, $jPgXx.toWarningsFilterValue)(paramValue.split(',').map((str)=>str.trim()));
const $89761db99e7e0304$export$6c8eda0352c7cf5 = (paramValue)=>paramValue == null ? undefined : paramValue.split(',').map((str)=>(0, $g5X3G.toAccountId)(str.trim()));
const $89761db99e7e0304$export$67c4cee80a3410cd = (paramsRaw)=>{
    const result = {};
    result[0, $5d187be87424268f$export$e39925d10cebc0b] = paramsRaw[0, $5d187be87424268f$export$e39925d10cebc0b];
    result[0, $5d187be87424268f$export$b98a7875ddbefaac] = $89761db99e7e0304$export$2a2e94972ab280d4(paramsRaw[0, $5d187be87424268f$export$b98a7875ddbefaac]);
    result[0, $5d187be87424268f$export$c307007520232013] = $89761db99e7e0304$export$fb136b568c6d78b5(paramsRaw[0, $5d187be87424268f$export$c307007520232013]);
    result[0, $5d187be87424268f$export$2552faed9df6a2cd] = $89761db99e7e0304$export$5cb324c621ca24e8(paramsRaw[0, $5d187be87424268f$export$2552faed9df6a2cd]);
    result[0, $5d187be87424268f$export$f78d8c81fcad32a2] = $89761db99e7e0304$export$6c8eda0352c7cf5(paramsRaw[0, $5d187be87424268f$export$f78d8c81fcad32a2]);
    result[0, $5d187be87424268f$export$13d5b2891ca65cd6] = paramsRaw[0, $5d187be87424268f$export$13d5b2891ca65cd6] && (0, $jPgXx.isSortBy)(paramsRaw[0, $5d187be87424268f$export$13d5b2891ca65cd6]) ? paramsRaw[0, $5d187be87424268f$export$13d5b2891ca65cd6] : 'CREATED';
    result[0, $5d187be87424268f$export$810a1f7ed2facfcb] = paramsRaw[0, $5d187be87424268f$export$810a1f7ed2facfcb] && (0, $jPgXx.isSortOrder)(paramsRaw[0, $5d187be87424268f$export$810a1f7ed2facfcb]) ? paramsRaw[0, $5d187be87424268f$export$810a1f7ed2facfcb] : 'ASC';
    return result;
};

});


const $afc34106ac722f11$export$9fe575a15a87a796 = 'PROJECTS_VERSION_DETAILS';


parcelRegister("4gudm", function(module, exports) {

$parcel$export(module.exports, "softwareVersionDetailEmbedRoute", () => $901ac67e36c3672e$export$78d11017d9c9ed74);
const $901ac67e36c3672e$export$78d11017d9c9ed74 = {
    name: 'software-version-detail-embed',
    path: '/projects/:projectKey/versions/:versionId/tab/:tab/embed',
    exact: true
};

});

parcelRegister("bQc17", function(module, exports) {

$parcel$export(module.exports, "VersionDetailSkeleton", () => $d1c9f0513946a9ed$export$b3661a594ba34350);

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $bFJAH = parcelRequire("bFJAH");
const $d1c9f0513946a9ed$export$b3661a594ba34350 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bFJAH)))
    });

});
parcelRegister("bFJAH", function(module, exports) {
module.exports = new URL("version-detail-skeleton.tpl.c4c4fc18.svg", import.meta.url).toString();

});


parcelRegister("jchNA", function(module, exports) {

$parcel$export(module.exports, "LazyVersionDetail", () => $5cbf8f752618c8e3$export$2d31f5f47e6584e0);
$parcel$export(module.exports, "VersionDetailPage", () => $5cbf8f752618c8e3$export$231cc5186b991031);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $5cbf8f752618c8e3$export$2d31f5f47e6584e0 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("enUYc"))), {
    moduleId: "./src/packages/spa-apps/version-detail/src/index.tsx"
});
const $5cbf8f752618c8e3$export$231cc5186b991031 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $5cbf8f752618c8e3$export$2d31f5f47e6584e0,
        pageId: "version-detail",
        shouldShowSpinner: false
    });

});
parcelRegister("enUYc", function(module, exports) {

let $a78f67bbab7b7150$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a78f67bbab7b7150$var$load("ffQaD"),
    $a78f67bbab7b7150$var$load("kvRbA"),
    $a78f67bbab7b7150$var$load("gN4dl")
]).then(()=>parcelRequire('2WNCY'));

});



parcelRegister("fwjnc", function(module, exports) {

$parcel$export(module.exports, "softwareVersionDetailLegacyRedirectRouteEntry", () => $d779d838fb39524b$export$f29aafdff734071c);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $1ZoQ4 = parcelRequire("1ZoQ4");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $jchNA = parcelRequire("jchNA");

var $3eNdg = parcelRequire("3eNdg");
const $d779d838fb39524b$export$f29aafdff734071c = (0, $7NszV.createEntry)((0, $1ZoQ4.softwareVersionDetailLegacyRedirectRoute), ()=>({
        group: 'software',
        component: (0, $3eNdg.VersionDetailPageLegacyRedirect),
        canTransitionIn: ()=>true,
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: [
                (0, $koWFd.default),
                (0, $9s3j1.default)
            ],
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jchNA.LazyVersionDetail)
        ]
    }));

});
parcelRegister("1ZoQ4", function(module, exports) {

$parcel$export(module.exports, "softwareVersionDetailLegacyRedirectRoute", () => $29228b2ecd57a3f4$export$3fc8dbcec208bca0);
const $29228b2ecd57a3f4$export$3fc8dbcec208bca0 = {
    name: 'software-version-detail-legacy-redirect',
    path: '/browse/:projectKey/fixforversion/:versionId'
};

});

parcelRegister("3eNdg", function(module, exports) {

$parcel$export(module.exports, "VersionDetailPageLegacyRedirect", () => $b28890d7be7b5f20$export$8524eef1a0d9339);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
const $b28890d7be7b5f20$export$8524eef1a0d9339 = ({ match: { params: { projectKey: projectKey, versionId: versionId, tab: tab } } })=>{
    // This should never happen as if it wasn't matched, this won't be rendered unless someone re-used this component in a wrong route.
    if (projectKey == null || versionId == null) throw Error('projectKey or versionId not found in match object of RouteContext');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/projects/${projectKey}/versions/${versionId}/tab/${tab != null ? tab : 'release-report-all-issues'}`
    });
};

});


parcelRegister("1KC4N", function(module, exports) {

$parcel$export(module.exports, "softwareVersionDetailNoTabPathRedirectRouteEntry", () => $91cff4b09df91d45$export$28d16aae32969765);

var $ffza4 = parcelRequire("ffza4");

var $5f2bR = parcelRequire("5f2bR");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $aLgIl = parcelRequire("aLgIl");

var $e7bC3 = parcelRequire("e7bC3");

var $jchNA = parcelRequire("jchNA");

var $3eNdg = parcelRequire("3eNdg");
const $91cff4b09df91d45$export$28d16aae32969765 = (0, $7NszV.createEntry)((0, $aLgIl.softwareVersionDetailNoTabPathRedirectRoute), ()=>({
        group: 'software',
        component: (0, $3eNdg.VersionDetailPageLegacyRedirect),
        canTransitionIn: ()=>true,
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: [
                (0, $koWFd.default),
                (0, $9s3j1.default)
            ],
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jchNA.LazyVersionDetail)
        ]
    }));

});
parcelRegister("aLgIl", function(module, exports) {

$parcel$export(module.exports, "softwareVersionDetailNoTabPathRedirectRoute", () => $bfff597194375de5$export$f22288f2d2f1b9ea);
const $bfff597194375de5$export$f22288f2d2f1b9ea = {
    name: 'software-version-detail-no-tab-path',
    path: '/projects/:projectKey/versions/:versionId'
};

});


parcelRegister("7ApVe", function(module, exports) {

$parcel$export(module.exports, "softwareVersionDetailRouteEntry", () => $0034963e375ba907$export$c97dabcfe9d495fa);

var $e4eHl = parcelRequire("e4eHl");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $kt0pG = parcelRequire("kt0pG");

var $12flw = parcelRequire("12flw");

var $bQc17 = parcelRequire("bQc17");

var $e7bC3 = parcelRequire("e7bC3");

var $jchNA = parcelRequire("jchNA");
const $0034963e375ba907$export$c97dabcfe9d495fa = (0, $7NszV.createEntry)((0, $12flw.softwareVersionDetailRoute), ()=>({
        group: 'software',
        ufoName: 'software.version-details-page',
        component: (0, $jchNA.VersionDetailPage),
        skeleton: (0, $bQc17.VersionDetailSkeleton),
        canTransitionIn: ()=>true,
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: [
                (0, $koWFd.default),
                (0, $9s3j1.default)
            ]
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $kt0pG.versionDetailsRelayResourceCustom),
            (0, $dxCvy.projectContextResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jchNA.LazyVersionDetail)
        ],
        meta: {
            reporting: {
                id: 'software-version-detail',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-version-detail'),
                teamName: 'nova'
            }
        }
    }));

});
parcelRegister("12flw", function(module, exports) {

$parcel$export(module.exports, "softwareVersionDetailRoute", () => $da1ceb4f01a49a44$export$eb3633614d0521b0);
const $da1ceb4f01a49a44$export$eb3633614d0521b0 = {
    name: 'software-version-detail',
    path: '/projects/:projectKey/versions/:versionId/tab/:tab'
};

});


parcelRegister("2vUs2", function(module, exports) {

$parcel$export(module.exports, "trashProjectsDirectoryRedirectRouteEntry", () => $c7ed25d526b7ed1b$export$8ea64bac0a832a5c);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $4jMkc = parcelRequire("4jMkc");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $71tTP = parcelRequire("71tTP");

var $aphUL = parcelRequire("aphUL");

var $8gSP9 = parcelRequire("8gSP9");
const $c7ed25d526b7ed1b$export$8ea64bac0a832a5c = (0, $7NszV.createEntry)((0, $71tTP.trashProjectsDirectoryRedirectRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.trashed-projects',
        component: (0, $aphUL.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $4jMkc.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8gSP9.LazyTrashedProjectsAdmin)
        ],
        isRedirect: true
    }));

});
parcelRegister("71tTP", function(module, exports) {

$parcel$export(module.exports, "trashProjectsDirectoryRedirectRoute", () => $99acde7d7c12a8d4$export$6eafffd4489b3d4);
const $99acde7d7c12a8d4$export$6eafffd4489b3d4 = {
    name: 'trash-projects-directory',
    path: '/secure/projects/trash',
    exact: true
};

});

parcelRegister("aphUL", function(module, exports) {

$parcel$export(module.exports, "default", () => $70186afa73ef93b4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $7tQej = parcelRequire("7tQej");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$70186afa73ef93b4$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "projectsTrashRedirect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: "/jira/settings/projects/trash"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null));

});

parcelRegister("8gSP9", function(module, exports) {

$parcel$export(module.exports, "LazyTrashedProjectsAdmin", () => $67a748fd05680154$export$dd65a8ee0a9ac24f);
$parcel$export(module.exports, "default", () => $67a748fd05680154$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $67a748fd05680154$export$dd65a8ee0a9ac24f = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("aOxV4"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/trashed-projects/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$67a748fd05680154$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $67a748fd05680154$export$dd65a8ee0a9ac24f,
        pageId: "trashed-projects",
        shouldShowSpinner: true
    });

});
parcelRegister("aOxV4", function(module, exports) {

let $7df8e29d423193d3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $7df8e29d423193d3$var$load("fliVL"),
    $7df8e29d423193d3$var$load("kMQbY")
]).then(()=>parcelRequire('lYlbz'));

});



parcelRegister("bCHhM", function(module, exports) {

$parcel$export(module.exports, "trashProjectsDirectoryRouteEntry", () => $dc548005383aa0ca$export$27d1f352c2f7acae);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $4jMkc = parcelRequire("4jMkc");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $6K0J9 = parcelRequire("6K0J9");

var $8gSP9 = parcelRequire("8gSP9");
const $dc548005383aa0ca$export$27d1f352c2f7acae = (0, $7NszV.createEntry)((0, $6K0J9.trashProjectsDirectoryRoute), ()=>({
        group: 'global-settings',
        ufoName: 'admin.trashed-projects',
        component: (0, $8gSP9.default),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $4jMkc.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8gSP9.LazyTrashedProjectsAdmin)
        ]
    }));

});
parcelRegister("6K0J9", function(module, exports) {

$parcel$export(module.exports, "trashProjectsDirectoryRoute", () => $78ccf5c0c15f3843$export$74ec9fecd42fa96e);
const $78ccf5c0c15f3843$export$74ec9fecd42fa96e = {
    name: 'trash-projects-directory',
    path: '/jira/settings/projects/trash',
    exact: true
};

});


parcelRegister("hjvN4", function(module, exports) {

$parcel$export(module.exports, "userSegmentationRouteEntry", () => $929524b967f2ea63$export$2af76482b576a135);

var $6e4Kt = parcelRequire("6e4Kt");

var $7NszV = parcelRequire("7NszV");

var $gRaVl = parcelRequire("gRaVl");

var $1z26X = parcelRequire("1z26X");
const $929524b967f2ea63$export$2af76482b576a135 = (0, $7NszV.createEntry)((0, $gRaVl.userSegmentationRoute), ()=>({
        ufoName: 'user-segmentation',
        component: (0, $1z26X.UserSegmentation),
        layout: (0, $6e4Kt.chromelessLayout),
        forPaint: [
            (0, $1z26X.LazyUserSegmentation)
        ]
    }));

});
parcelRegister("gRaVl", function(module, exports) {

$parcel$export(module.exports, "userSegmentationRoute", () => $875097219108c022$export$b0b13170cadf6395);
const $875097219108c022$export$b0b13170cadf6395 = {
    name: 'user-segmentation',
    path: '/jira/get-started',
    exact: true
};

});

parcelRegister("1z26X", function(module, exports) {

$parcel$export(module.exports, "LazyUserSegmentation", () => $16f27a0ded4f6683$export$bf9c9e0729c919f5);
$parcel$export(module.exports, "UserSegmentation", () => $16f27a0ded4f6683$export$15f8c5ccbb9c7ec3);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $16f27a0ded4f6683$export$bf9c9e0729c919f5 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("dx6XQ"))), {
    moduleId: "./src/packages/user-segmentation/src/index.tsx"
});
const $16f27a0ded4f6683$export$15f8c5ccbb9c7ec3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $16f27a0ded4f6683$export$bf9c9e0729c919f5,
        pageId: "user-segmentation",
        shouldShowSpinner: true
    });

});
parcelRegister("dx6XQ", function(module, exports) {

let $9da3c25d8bbd13cc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9da3c25d8bbd13cc$var$load("9wrqo").then(()=>parcelRequire('jL0w0'));

});



parcelRegister("03CAy", function(module, exports) {

$parcel$export(module.exports, "softwareRoadmapClassicRouteEntry", () => $12d0c514ddf21fe0$export$17cff822dd3757db);

var $7NszV = parcelRequire("7NszV");

var $i1Lhe = parcelRequire("i1Lhe");

var $8STJR = parcelRequire("8STJR");

var $aPfsS = parcelRequire("aPfsS");

var $e7bC3 = parcelRequire("e7bC3");

var $g5RGc = parcelRequire("g5RGc");

var $lmyls = parcelRequire("lmyls");

var $9s3j1 = parcelRequire("9s3j1");

var $5f2bR = parcelRequire("5f2bR");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $7uLIV = parcelRequire("7uLIV");

var $hJAri = parcelRequire("hJAri");

var $fKmub = parcelRequire("fKmub");

var $ffza4 = parcelRequire("ffza4");

var $4R6GH = parcelRequire("4R6GH");

var $c7uCQ = parcelRequire("c7uCQ");

var $j0EJB = parcelRequire("j0EJB");
const $12d0c514ddf21fe0$var$getConditionalResources = ()=>(0, $4R6GH.fg)('optimise_timeline_routes') ? [
        (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
        (0, $5bkvv.forgeProjectModuleResourceOnNav3Only),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only)
    ] : [
        (0, $7GnDe.incidentExperimentTraitResource),
        (0, $5bkvv.forgeProjectModuleResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
    ];
const $12d0c514ddf21fe0$export$17cff822dd3757db = (0, $7NszV.createEntry)((0, $i1Lhe.softwareRoadmapClassicRoute), ()=>({
        group: 'classic-software',
        component: (0, $c7uCQ.TimelineRedirect),
        skeleton: (0, $8STJR.RoadmapSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $4R6GH.fg)('optimise_timeline_routes') ? (0, $e7bC3.softwareProjectLayoutCode) : (0, $e7bC3.classicSoftwareProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            ...$12d0c514ddf21fe0$var$getConditionalResources(),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $hJAri.classicRoadmapResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-roadmap-early-entry'
            ]
        },
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $j0EJB.LazyRoadmapViewClassic)
        ],
        ufoName: 'classic-roadmap'
    }));

});
parcelRegister("i1Lhe", function(module, exports) {

$parcel$export(module.exports, "softwareRoadmapClassicRoute", () => $6e5bb4d1423afb31$export$79089e2853f04197);
const $6e5bb4d1423afb31$export$79089e2853f04197 = {
    name: 'software-roadmap-classic',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/roadmap'
};

});

parcelRegister("hJAri", function(module, exports) {

$parcel$export(module.exports, "classicRoadmapResource", () => $b200b290d50f82d3$export$e755913caca1ab8e);

var $2M1hQ = parcelRequire("2M1hQ");


const $b200b290d50f82d3$export$e755913caca1ab8e = (0, $2M1hQ.createResource)({
    type: (0, $87d7efe6336d8b83$export$e3b1cd17bd82de3d),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("l3C4Q")),
    isBrowserOnly: true
});

});
parcelRegister("l3C4Q", function(module, exports) {

let $f5476a1747973580$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f5476a1747973580$var$load("jUUh4").then(()=>parcelRequire('g52eJ'));

});


parcelRegister("c7uCQ", function(module, exports) {

$parcel$export(module.exports, "TimelineRedirect", () => $02623e8fca40b314$export$c70b8d9ef0c891b2);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
var $doZTA = parcelRequire("doZTA");
const $02623e8fca40b314$export$c70b8d9ef0c891b2 = ()=>{
    const [{ query: query, match: match }] = (0, $doZTA.useRouter)();
    const queryParams = new URLSearchParams(query).toString();
    const { projectKey: projectKey, boardId: boardId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: {
            pathname: `/jira/software/c/projects/${String(projectKey)}/boards/${String(boardId)}/timeline`,
            hash: '',
            search: queryParams
        }
    });
};

});

parcelRegister("j0EJB", function(module, exports) {

$parcel$export(module.exports, "LazyRoadmapViewClassic", () => $d9daa971618d7f64$export$84165bb08bf42eef);
$parcel$export(module.exports, "default", () => $d9daa971618d7f64$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $d9daa971618d7f64$export$84165bb08bf42eef = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("H7eYx"))), {
    moduleId: "./src/packages/spa-apps/roadmap/src/view/classic/index-old.tsx"
});
var /** @deprecated Use entrypoint roadmapViewClassicPageEntrypoint */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$d9daa971618d7f64$export$2e2bcd8739ae039 = ({ match: match })=>{
    const { boardId: boardId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d9daa971618d7f64$export$84165bb08bf42eef,
        pageId: `classic-roadmap-${boardId || ''}`,
        shouldShowSpinner: false
    });
};

});
parcelRegister("H7eYx", function(module, exports) {

let $0819a21649ec2fe7$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0819a21649ec2fe7$var$load("ffQaD"),
    $0819a21649ec2fe7$var$load("kvRbA"),
    $0819a21649ec2fe7$var$load("5VVGu")
]).then(()=>parcelRequire('cVHeR'));

});



parcelRegister("heIfC", function(module, exports) {

$parcel$export(module.exports, "softwareTimelineClassicRouteEntry", () => $bac13144920c2c2e$export$a822ee67d4c66296);

var $7NszV = parcelRequire("7NszV");

var $ie7vB = parcelRequire("ie7vB");

var $8STJR = parcelRequire("8STJR");

var $aPfsS = parcelRequire("aPfsS");

var $e7bC3 = parcelRequire("e7bC3");

var $g5RGc = parcelRequire("g5RGc");

var $lmyls = parcelRequire("lmyls");

var $9s3j1 = parcelRequire("9s3j1");

var $5f2bR = parcelRequire("5f2bR");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $7uLIV = parcelRequire("7uLIV");

var $hJAri = parcelRequire("hJAri");

var $fKmub = parcelRequire("fKmub");

var $ffza4 = parcelRequire("ffza4");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");

var $4R6GH = parcelRequire("4R6GH");

var $j0EJB = parcelRequire("j0EJB");

var $jK0PE = parcelRequire("jK0PE");
/** @deprecated remove when cleaning up 'jira-timeline-classic-route-entrypoint-migration' */ const $bac13144920c2c2e$var$getHorizontalNavResource = ()=>(0, $4R6GH.fg)('jira-timeline-classic-route-entrypoint-migration') ? [] : [
        (0, $7uLIV.horizontalNavJiraResource)
    ];
const $bac13144920c2c2e$var$getConditionalResources = ()=>(0, $4R6GH.fg)('optimise_timeline_routes') ? [
        (0, $7GnDe.incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes),
        (0, $5bkvv.forgeProjectModuleResourceOnNav3Only),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only)
    ] : [
        (0, $7GnDe.incidentExperimentTraitResource),
        (0, $5bkvv.forgeProjectModuleResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
    ];
const $bac13144920c2c2e$export$a822ee67d4c66296 = (0, $7NszV.createEntry)((0, $ie7vB.softwareTimelineClassicRoute), ()=>({
        group: 'classic-software',
        component: (0, $4R6GH.fg)('jira-timeline-classic-route-entrypoint-migration') ? undefined : (0, $j0EJB.default),
        skeleton: (0, $8STJR.RoadmapSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $4R6GH.fg)('optimise_timeline_routes') ? (0, $e7bC3.softwareProjectLayoutCode) : (0, $e7bC3.classicSoftwareProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            ...$bac13144920c2c2e$var$getConditionalResources(),
            ...$bac13144920c2c2e$var$getHorizontalNavResource(),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $hJAri.classicRoadmapResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource))
        ],
        preloadOptions: {
            earlyChunks: [
                'software-roadmap-early-entry'
            ]
        },
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: (0, $4R6GH.fg)('jira-timeline-classic-route-entrypoint-migration') ? undefined : [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $j0EJB.LazyRoadmapViewClassic)
        ],
        ufoName: 'classic-roadmap',
        entryPoint: ()=>(0, $4R6GH.fg)('jira-timeline-classic-route-entrypoint-migration') ? (0, $jK0PE.roadmapViewClassicPageEntrypoint) : undefined
    }));

});
parcelRegister("ie7vB", function(module, exports) {

$parcel$export(module.exports, "softwareTimelineClassicRoute", () => $9063b50694a4a155$export$ce5173f7e8fa932b);
const $9063b50694a4a155$export$ce5173f7e8fa932b = {
    name: 'software-timeline-classic',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/timeline'
};

});

parcelRegister("jK0PE", function(module, exports) {

$parcel$export(module.exports, "roadmapViewClassicPageEntrypoint", () => $636a0aa010a33fb5$export$af2674d32463682f);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $9uS0k = parcelRequire("9uS0k");

var $fo6b8 = parcelRequire("fo6b8");
const $636a0aa010a33fb5$export$af2674d32463682f = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $9uS0k.roadmapViewClassicEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("9uS0k", function(module, exports) {

$parcel$export(module.exports, "roadmapViewClassicEntrypoint", () => $ec06132eb53a85c8$export$583357f75b3be3a7);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $ec06132eb53a85c8$export$583357f75b3be3a7 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("jKSKD")), {
        moduleId: "7a5c4192"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("jKSKD", function(module, exports) {

let $e61cc8a663fd59b1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e61cc8a663fd59b1$var$load("ffQaD"),
    $e61cc8a663fd59b1$var$load("kvRbA"),
    $e61cc8a663fd59b1$var$load("iMOIp")
]).then(()=>parcelRequire('9PBZj'));

});




parcelRegister("cjFCA", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardSettingsRouteEntry", () => $8a9bcce270c68b7d$export$4e7891e9bba3f679);

var $c04PQ = parcelRequire("c04PQ");

var $7NszV = parcelRequire("7NszV");

var $hWAe2 = parcelRequire("hWAe2");

var $i8Lv4 = parcelRequire("i8Lv4");

var $gyYxw = parcelRequire("gyYxw");

var $dxCvy = parcelRequire("dxCvy");

var $3RJkv = parcelRequire("3RJkv");

var $f5kpo = parcelRequire("f5kpo");

var $lfnsv = parcelRequire("lfnsv");

var $7GnDe = parcelRequire("7GnDe");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $lJ1FP = parcelRequire("lJ1FP");

var $gNStA = parcelRequire("gNStA");

var $f7Y15 = parcelRequire("f7Y15");

var $ipmBb = parcelRequire("ipmBb");


var $lmyls = parcelRequire("lmyls");

var $4R6GH = parcelRequire("4R6GH");

var $9s3j1 = parcelRequire("9s3j1");

var $e3Qmo = parcelRequire("e3Qmo");
const $8a9bcce270c68b7d$export$4e7891e9bba3f679 = (0, $7NszV.createEntry)((0, $i8Lv4.classicSoftwareBoardSettingsRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-board',
        skeleton: (0, $hWAe2.ClassicBoardSkeleton),
        entryPoint: ()=>(0, $e3Qmo.boardSettingsPageEntryPoint),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.ForPaintClassicSoftwareProjectSidebar),
            sidebarId: (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route') ? (0, $lmyls.SIDEBAR_ID).BOARD_SETTINGS : undefined
        },
        layout: (0, $gyYxw.genericProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            (0, $gNStA.resourceWithCondition2)((0, $f5kpo.shouldLoadUIFBoardResources), (0, $f7Y15.uifBoardResource)),
            // Load the NBT resource if we opt-in UIF, not fedRamp is enabled
            (0, $gNStA.resourceWithCondition2)(()=>(0, $f5kpo.shouldLoadUIFBoardResources)() && !(0, $c04PQ.isFedRamp)(), (0, $ipmBb.nextBestTaskFeatureResource)),
            (0, $lJ1FP.getEditModelResource)(),
            (0, $lfnsv.getBoardDetailsResource)(),
            (0, $5bkvv.forgeBoardModuleResource)
        ],
        meta: {
            // Inline this statement instead of creating a (circular) dependency by importing
            // { classicBoardCapability } from '@atlassian/jira-router-routes-software-classic-board-entries/src/common/constants.tsx';
            capability: !false ? (0, $281cbd47ba46dd7d$export$664edf77d4c76110) : (0, $281cbd47ba46dd7d$export$fc5f182fc9019b1c)
        }
    }));

});
parcelRegister("i8Lv4", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardSettingsRoute", () => $4143597146033f93$export$c055a8844d0d2f5e);
const $4143597146033f93$export$c055a8844d0d2f5e = {
    name: 'rapidboard-board-settings',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/settings/:config',
    query: [
        'from-backlog?'
    ]
};

});

parcelRegister("e3Qmo", function(module, exports) {

$parcel$export(module.exports, "boardSettingsPageEntryPoint", () => $385924313962f5aa$export$e92abb48a4e0c94d);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $eoZWh = parcelRequire("eoZWh");

var $edhw8 = parcelRequire("edhw8");
const $385924313962f5aa$export$e92abb48a4e0c94d = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $edhw8.classicBoardSettingsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $eoZWh.nav4SidebarSettingsBoardEntryPoint)
    }
});

});
parcelRegister("eoZWh", function(module, exports) {

$parcel$export(module.exports, "nav4SidebarSettingsBoardEntryPoint", () => $8560ff5804cb640b$export$f4cb88eb97cbdc30);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $8560ff5804cb640b$export$f4cb88eb97cbdc30 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("frghh")), {
        moduleId: "98fd14bc"
    }),
    getPreloadProps () {
        return {};
    }
});

});
parcelRegister("frghh", function(module, exports) {

let $b3d6010dd8748286$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b3d6010dd8748286$var$load("4jRj5").then(()=>parcelRequire('gNcDN'));

});


parcelRegister("edhw8", function(module, exports) {

$parcel$export(module.exports, "classicBoardSettingsEntryPoint", () => $78b5eed4719a6123$export$fd11e3f2f113ef67);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $78b5eed4719a6123$export$fd11e3f2f113ef67 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("fDF3V")).then(({ BoardSettingsSwitcher: BoardSettingsSwitcher })=>BoardSettingsSwitcher), {
        moduleId: "59af2752",
        moduleName: "BoardSettingsSwitcher"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("fDF3V", function(module, exports) {

let $b62a59a561886e69$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $b62a59a561886e69$var$load("kNFvF"),
    $b62a59a561886e69$var$load("ffQaD"),
    $b62a59a561886e69$var$load("kvRbA"),
    $b62a59a561886e69$var$load("eXKO6")
]).then(()=>parcelRequire('9tGl0'));

});




parcelRegister("hu1w9", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardSettingsInsightsRapidboardBacklogRouteEntry", () => $bfec0a4fc8785ec0$export$9bcdab5e8a786007);

var $g87MG = parcelRequire("g87MG");

var $ffza4 = parcelRequire("ffza4");


var $e2ctp = parcelRequire("e2ctp");

var $gyYxw = parcelRequire("gyYxw");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $lfnsv = parcelRequire("lfnsv");

var $f5kpo = parcelRequire("f5kpo");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $gwlQU = parcelRequire("gwlQU");

var $16Z5s = parcelRequire("16Z5s");

var $i8JTM = parcelRequire("i8JTM");

var $5f2bR = parcelRequire("5f2bR");

var $ltiRJ = parcelRequire("ltiRJ");
const $bfec0a4fc8785ec0$export$9bcdab5e8a786007 = (0, $7NszV.createEntry)((0, $gwlQU.classicSoftwareBoardSettingsInsightsRapidboardBacklogRoute), ()=>({
        group: 'classic-software',
        ufoName: 'rapidboard-backlog-insights',
        component: (0, $ltiRJ.InsightsSettingsRedirect),
        skeleton: (0, $i8JTM.NextGenBacklogSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $gyYxw.genericProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue',
                    'view=planning'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            (0, $g87MG.issueHierarchyPageResource),
            (0, $lfnsv.getBoardDetailsResource)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $16Z5s.LazyRapidBoard),
            (0, $16Z5s.LazyRapidBoardApps),
            (0, $16Z5s.LazyRapidBoardDataApiResource),
            (0, $16Z5s.LazyRapidBoardConfigApiResource),
            (0, $16Z5s.LazyRapidBoardWrmBundleResource),
            (0, $16Z5s.LazyRapidBoardResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$93104dc4eba58ba4)
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("gwlQU", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardSettingsInsightsRapidboardBacklogRoute", () => $8b16a5460c1e898c$export$e43f33a0c1ae830c);
const $8b16a5460c1e898c$export$e43f33a0c1ae830c = {
    name: 'rapidboard-backlog',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog',
    query: [
        'config=insightsConfig'
    ]
};

});

parcelRegister("16Z5s", function(module, exports) {

$parcel$export(module.exports, "UIFBoardSpa", () => $21fca9455db40549$export$2164de18d39af313);
$parcel$export(module.exports, "RapidBoardSpaPage", () => $21fca9455db40549$export$4ceb6cf2934825b2);
$parcel$export(module.exports, "LazyRapidBoard", () => $21fca9455db40549$export$9de09057ba255cc4);
$parcel$export(module.exports, "LazyRapidBoardWrmBundleResource", () => $21fca9455db40549$export$bcb5bb6438a46dcb);
$parcel$export(module.exports, "LazyRapidBoardDataApiResource", () => $21fca9455db40549$export$d4640ceb9bdd4b4);
$parcel$export(module.exports, "LazyRapidBoardConfigApiResource", () => $21fca9455db40549$export$c96c36c0cbfb2c16);
$parcel$export(module.exports, "LazyRapidBoardResource", () => $21fca9455db40549$export$2ad64ed8eb98d9e);
$parcel$export(module.exports, "LazyRapidBoardApps", () => $21fca9455db40549$export$4a8825f3e310b97);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $21fca9455db40549$export$2164de18d39af313 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("cfMm6")), {
    moduleId: "./src/packages/spa-apps/next-gen-board/src/index.tsx"
});

const $21fca9455db40549$export$bcc6315cf211edab = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("l95JT")), {
    moduleId: "./src/packages/spa-apps/next-gen-backlog/src/index.tsx"
});

const $21fca9455db40549$export$a1c59527bd5131cc = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("knjvb")).then((module)=>module.BoardConfigSwitcher), {
    moduleId: "./src/packages/router-routes/software/classic/board-settings/switcher/src/index.tsx"
});
const $21fca9455db40549$export$4ceb6cf2934825b2 = (props)=>{
    const { route: route, query: query, match: match } = props;
    const basePageId = route && route.name || 'rapid-board';
    const chartParam = query.chart ? `-${query.chart}` : '';
    const boardId = query.rapidView ?? match.params.boardId;
    const pageId = `${basePageId}-${boardId}${chartParam}`;
    if ([
        'rapidboard-board',
        'rapidboard-board-embed',
        'rapidboard-user-board'
    ].includes(route.name) && !query.config) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $21fca9455db40549$export$2164de18d39af313,
        pageId: pageId,
        shouldShowSpinner: false
    });
    if ([
        'rapidboard-backlog',
        'rapidboard-user-backlog',
        'rapidboard-backlog-embed'
    ].includes(route.name) && !query.config) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $21fca9455db40549$export$bcc6315cf211edab,
        pageId: pageId,
        shouldShowSpinner: false
    });
    if ([
        'rapidboard-backlog',
        'rapidboard-user-backlog',
        'rapidboard-board',
        'rapidboard-board-embed',
        'rapidboard-user-board',
        'rapidboard-backlog-embed'
    ].includes(route.name) && query.config && (0, $4R6GH.fg)('simplified-boards-milestone-2_07hbk')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $21fca9455db40549$export$a1c59527bd5131cc,
        pageId: pageId,
        shouldShowSpinner: false
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $21fca9455db40549$export$9de09057ba255cc4,
        pageId: pageId,
        shouldShowSpinner: false
    });
};

const $21fca9455db40549$export$9de09057ba255cc4 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("lKkfh")), {
    moduleId: "./src/packages/spa-apps/rapid-board/src/index-old.tsx"
});

const $21fca9455db40549$export$bcb5bb6438a46dcb = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("4ntFd")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/wrm-bundle/get-data/index.tsx"
});

const $21fca9455db40549$export$d4640ceb9bdd4b4 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("66t2H")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/data-api/get-data/index.tsx"
});

const $21fca9455db40549$export$c96c36c0cbfb2c16 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("6Pdur")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/config-api/get-data/index.tsx"
});

const $21fca9455db40549$export$2ad64ed8eb98d9e = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("3B60s")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/rapidboard-resource/get-data/index.tsx"
});

const $21fca9455db40549$export$4a8825f3e310b97 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("kkF9E")), {
    moduleId: "./src/packages/entry-rapid-board-wrm-apps/src/index.tsx"
});

});
parcelRegister("knjvb", function(module, exports) {

let $ed551549e7f4251a$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ed551549e7f4251a$var$load("ffQaD"),
    $ed551549e7f4251a$var$load("kvRbA"),
    $ed551549e7f4251a$var$load("kNFvF"),
    $ed551549e7f4251a$var$load("hgzhX")
]).then(()=>parcelRequire('iYOPQ'));

});

parcelRegister("lKkfh", function(module, exports) {

let $fd4d9930697459b4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fd4d9930697459b4$var$load("AD9h4").then(()=>parcelRequire('43ajl'));

});

parcelRegister("kkF9E", function(module, exports) {

let $ecd5995b77052de6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ecd5995b77052de6$var$load("7s1Qm").then(()=>parcelRequire('73mZu'));

});


parcelRegister("ltiRJ", function(module, exports) {

$parcel$export(module.exports, "InsightsSettingsRedirect", () => $018a8accd0bb9a64$export$f7bc2c5799e41684);

var $ibA3M = parcelRequire("ibA3M");

var $ieDtd = parcelRequire("ieDtd");
const $018a8accd0bb9a64$export$f7bc2c5799e41684 = ()=>{
    const { setSelectedConfigTab: setSelectedConfigTab } = (0, $ibA3M.useSelectedConfigTab)();
    const [, setConfigParam] = (0, $ieDtd.useQueryParam)('config');
    setSelectedConfigTab('filter');
    setConfigParam('filter');
    return null;
};

});
parcelRegister("ibA3M", function(module, exports) {

$parcel$export(module.exports, "useSelectedConfigTab", () => $a2554898b8aa72da$export$9b386f1a3e61b385);

var $bSSG7 = parcelRequire("bSSG7");

var $4R6GH = parcelRequire("4R6GH");
const $a2554898b8aa72da$export$9b386f1a3e61b385 = ()=>{
    const storageProvider = (0, $bSSG7.createLocalStorageProvider)('', false);
    const SELECTED_CONFIG_TAB_KEY = 'selectedConfigTab';
    const getSelectedConfigTab = ()=>{
        if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) return storageProvider.get(SELECTED_CONFIG_TAB_KEY) || '';
        return localStorage.getItem(SELECTED_CONFIG_TAB_KEY) || '';
    };
    const setSelectedConfigTab = (newConfigTab)=>{
        if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) storageProvider.set(SELECTED_CONFIG_TAB_KEY, `"${newConfigTab}"`);
        else localStorage.setItem(SELECTED_CONFIG_TAB_KEY, `"${newConfigTab}"`);
    };
    return {
        getSelectedConfigTab: getSelectedConfigTab,
        setSelectedConfigTab: setSelectedConfigTab
    };
};

});



parcelRegister("akFeA", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardSettingsInsightsRapidboardBoardRouteEntry", () => $f91dfbe36c62931f$export$d4cb7b5fe9faae5e);

var $g87MG = parcelRequire("g87MG");

var $ffza4 = parcelRequire("ffza4");


var $e2ctp = parcelRequire("e2ctp");

var $gyYxw = parcelRequire("gyYxw");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $lfnsv = parcelRequire("lfnsv");

var $f5kpo = parcelRequire("f5kpo");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $9Hi5X = parcelRequire("9Hi5X");

var $16Z5s = parcelRequire("16Z5s");

var $hWAe2 = parcelRequire("hWAe2");

var $5f2bR = parcelRequire("5f2bR");

var $ltiRJ = parcelRequire("ltiRJ");
const $f91dfbe36c62931f$export$d4cb7b5fe9faae5e = (0, $7NszV.createEntry)((0, $9Hi5X.classicSoftwareBoardSettingsInsightsRapidboardBoardRoute), ()=>({
        group: 'classic-software',
        ufoName: 'rapidboard-board-insights',
        component: (0, $ltiRJ.InsightsSettingsRedirect),
        skeleton: (0, $hWAe2.ClassicBoardSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $gyYxw.genericProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue',
                    'view=detail'
                ]
            },
            {
                query: [
                    'selectedIssue',
                    'modal=detail'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            (0, $g87MG.issueHierarchyPageResource),
            (0, $lfnsv.getBoardDetailsResource)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $16Z5s.LazyRapidBoard),
            (0, $16Z5s.LazyRapidBoardApps),
            (0, $16Z5s.LazyRapidBoardDataApiResource),
            (0, $16Z5s.LazyRapidBoardConfigApiResource),
            (0, $16Z5s.LazyRapidBoardWrmBundleResource),
            (0, $16Z5s.LazyRapidBoardResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$fc5f182fc9019b1c)
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("9Hi5X", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardSettingsInsightsRapidboardBoardRoute", () => $048f30bef65f82e7$export$8c2f936709b987ac);
const $048f30bef65f82e7$export$8c2f936709b987ac = {
    name: 'rapidboard-board',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId',
    query: [
        'config=insightsConfig'
    ]
};

});


parcelRegister("djlm6", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarClassicEmbedRouteEntry", () => $dcd6d1616221fb9c$export$6a544072729c1964);

var $7NszV = parcelRequire("7NszV");

var $apHIk = parcelRequire("apHIk");

var $kZOse = parcelRequire("kZOse");

var $6e4Kt = parcelRequire("6e4Kt");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $2Ql51 = parcelRequire("2Ql51");

var $4R6GH = parcelRequire("4R6GH");

var $eQnNj = parcelRequire("eQnNj");
const $dcd6d1616221fb9c$export$6a544072729c1964 = (0, $7NszV.createEntry)((0, $apHIk.softwareCalendarClassicEmbedRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $kZOse.CalendarEmbedSkeleton),
        component: (0, $kZOse.CalendarEmbedSkeleton),
        entryPoint () {
            if (false) return undefined;
            return 0, $eQnNj.softwareCalendarRouteEntry;
        },
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $2Ql51.themePreferenceResource)
        ],
        ufoName: 'classic-calendar-embed',
        EXPERIMENTAL__shouldReload: (0, $4R6GH.fg)('jira_fix_calendar_suspending_when_switching_months') ? ({ context: context, prevContext: prevContext })=>{
            return context.match.url !== prevContext.match.url;
        } : undefined
    }));

});
parcelRegister("apHIk", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarClassicEmbedRoute", () => $4565df2ae20b6eec$export$ced2612fe5124ff8);
const $4565df2ae20b6eec$export$ced2612fe5124ff8 = {
    name: 'software-calendar-classic-embed',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/calendar/embed',
    query: [
        'date?'
    ]
};

});

parcelRegister("eQnNj", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarRouteEntry", () => $24d3258934ab0fe5$export$83b1b9036cc7961a);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $dQ4vn = parcelRequire("dQ4vn");

var $fo6b8 = parcelRequire("fo6b8");
const $24d3258934ab0fe5$export$83b1b9036cc7961a = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $dQ4vn.calendarEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});


parcelRegister("3J8Cl", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarClassicRouteEntry", () => $784ebb96624ec7cf$export$17ea82bdc641d5ce);

var $7NszV = parcelRequire("7NszV");

var $4R6GH = parcelRequire("4R6GH");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $501Vn = parcelRequire("501Vn");

var $kZOse = parcelRequire("kZOse");

var $aPfsS = parcelRequire("aPfsS");

var $e7bC3 = parcelRequire("e7bC3");

var $g5RGc = parcelRequire("g5RGc");

var $lmyls = parcelRequire("lmyls");

var $9s3j1 = parcelRequire("9s3j1");

var $5f2bR = parcelRequire("5f2bR");

var $3RJkv = parcelRequire("3RJkv");

var $fKmub = parcelRequire("fKmub");

var $ffza4 = parcelRequire("ffza4");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");

var $eQnNj = parcelRequire("eQnNj");
const $784ebb96624ec7cf$export$17ea82bdc641d5ce = (0, $7NszV.createEntry)((0, $501Vn.softwareCalendarClassicRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $kZOse.CalendarSkeleton),
        component: (0, $kZOse.CalendarSkeleton),
        entryPoint () {
            if (false) return undefined;
            return 0, $eQnNj.softwareCalendarRouteEntry;
        },
        layout: (0, $aPfsS.composeLayouts)((0, $e7bC3.classicSoftwareProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource))
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ],
        ufoName: 'classic-calendar',
        EXPERIMENTAL__shouldReload: (0, $4R6GH.fg)('jira_fix_calendar_suspending_when_switching_months') ? ({ context: context, prevContext: prevContext })=>{
            return context.match.url !== prevContext.match.url;
        } : undefined
    }));

});
parcelRegister("501Vn", function(module, exports) {

$parcel$export(module.exports, "softwareCalendarClassicRoute", () => $ad58dc33708a3879$export$f2c3b99639d54eb8);
const $ad58dc33708a3879$export$f2c3b99639d54eb8 = {
    name: 'software-calendar-classic',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/calendar',
    query: [
        'date?'
    ]
};

});


parcelRegister("bhft0", function(module, exports) {

$parcel$export(module.exports, "softwareListEmbedClassicRouteEntry", () => $c10c597b1bd946e9$export$bdb096e193b6e97b);

var $7NszV = parcelRequire("7NszV");

var $1SjdQ = parcelRequire("1SjdQ");

var $cf2qA = parcelRequire("cf2qA");

var $6e4Kt = parcelRequire("6e4Kt");

var $aFVvc = parcelRequire("aFVvc");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $g4ZHz = parcelRequire("g4ZHz");

var $fKmub = parcelRequire("fKmub");

var $iNzEe = parcelRequire("iNzEe");

var $l2N2a = parcelRequire("l2N2a");

var $7KruY = parcelRequire("7KruY");
const $c10c597b1bd946e9$export$bdb096e193b6e97b = (0, $7NszV.createEntry)((0, $1SjdQ.softwareListEmbedClassicRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $cf2qA.ListEmbedSkeleton),
        entryPoint () {
            return 0, $7KruY.softwareListEmbedRouteEntry;
        },
        layout: (0, $6e4Kt.chromelessLayout),
        // TODO: This is a copy of getProjectViewResources, but it has been copied in order to expand getNavigationSidebarProjectResource
        resources: [
            // the below 5 resources are copied from getBusinessProjectResources
            // they should be feature flagged and removed when it is safe to do so or
            // moved out of business packages
            // start getBusinessProjectResources
            (0, $aFVvc.projectCreatePermissionsResource),
            (0, $iNzEe.navigationResource),
            // eslint-disable-next-line camelcase
            (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            // end getBusinessProjectResources
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $g4ZHz.fieldsResource)
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        ufoName: 'classic-list-embed'
    }));

});
parcelRegister("1SjdQ", function(module, exports) {

$parcel$export(module.exports, "softwareListEmbedClassicRoute", () => $6541879b6a0ea94d$export$de5fcecec40b3c98);
const $6541879b6a0ea94d$export$de5fcecec40b3c98 = {
    name: 'software-list-classic-embed',
    path: '/jira/software/c/projects/:projectKey/list/embed'
};

});

parcelRegister("7KruY", function(module, exports) {

$parcel$export(module.exports, "softwareListRouteEntry", () => $2190319388c8e440$export$f30a66efa682bf2d);
$parcel$export(module.exports, "softwareListEmbedRouteEntry", () => $2190319388c8e440$export$1099e0e49394fa9a);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $cv6Sw = parcelRequire("cv6Sw");

var $fo6b8 = parcelRequire("fo6b8");

var $3FuB0 = parcelRequire("3FuB0");
const $2190319388c8e440$export$f30a66efa682bf2d = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $3FuB0.listEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $2190319388c8e440$export$1099e0e49394fa9a = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $cv6Sw.listEmbedEntryPoint)
});

});


parcelRegister("6FBN4", function(module, exports) {

$parcel$export(module.exports, "softwareListClassicRouteEntry", () => $9d676290a188f14d$export$4e2a0a97feb715a5);

var $7NszV = parcelRequire("7NszV");

var $cf2qA = parcelRequire("cf2qA");

var $aPfsS = parcelRequire("aPfsS");

var $e7bC3 = parcelRequire("e7bC3");

var $g5RGc = parcelRequire("g5RGc");

var $lmyls = parcelRequire("lmyls");

var $9s3j1 = parcelRequire("9s3j1");

var $2J9Xf = parcelRequire("2J9Xf");

var $5f2bR = parcelRequire("5f2bR");

var $aFVvc = parcelRequire("aFVvc");

var $iNzEe = parcelRequire("iNzEe");

var $l2N2a = parcelRequire("l2N2a");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $g4ZHz = parcelRequire("g4ZHz");

var $fKmub = parcelRequire("fKmub");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");

var $7KruY = parcelRequire("7KruY");
const $9d676290a188f14d$export$4e2a0a97feb715a5 = (0, $7NszV.createEntry)((0, $2J9Xf.softwareListClassicRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $cf2qA.ListSkeleton),
        entryPoint () {
            return 0, $7KruY.softwareListRouteEntry;
        },
        layout: (0, $aPfsS.composeLayouts)((0, $e7bC3.classicSoftwareProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        // TODO: This is a copy of getProjectViewResources, but it has been copied in order to replace
        //  with .
        resources: [
            // the below 5 resources are copied from getBusinessProjectResources
            // they should be feature flagged and removed when it is safe to do so or
            // moved out of business packages
            // start getBusinessProjectResources
            (0, $aFVvc.projectCreatePermissionsResource),
            (0, $iNzEe.navigationResource),
            // eslint-disable-next-line camelcase
            (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            // end getBusinessProjectResources
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $g4ZHz.fieldsResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource))
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        ufoName: 'classic-list'
    }));

});
parcelRegister("2J9Xf", function(module, exports) {

$parcel$export(module.exports, "softwareListClassicRoute", () => $cb27ddbacbb22539$export$1bf758507ca6b2);
const $cb27ddbacbb22539$export$1bf758507ca6b2 = {
    name: 'software-list-classic',
    path: '/jira/software/c/projects/:projectKey/list'
};

});


parcelRegister("1iYkP", function(module, exports) {

$parcel$export(module.exports, "rapidboardReportRouteEntry", () => $6946c90a7efbc538$export$745f1d5a2458a2d9);

var $7NszV = parcelRequire("7NszV");

var $hwrCN = parcelRequire("hwrCN");

var $16Z5s = parcelRequire("16Z5s");

var $7o1kb = parcelRequire("7o1kb");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $f5kpo = parcelRequire("f5kpo");

var $fKmub = parcelRequire("fKmub");

var $ffza4 = parcelRequire("ffza4");

var $e2ctp = parcelRequire("e2ctp");

var $yxwH0 = parcelRequire("yxwH0");

var $kJSiQ = parcelRequire("kJSiQ");
const $6946c90a7efbc538$export$745f1d5a2458a2d9 = (0, $7NszV.createEntry)((0, $hwrCN.rapidboardReportRoute), ()=>({
        group: 'classic-software',
        component: (0, $16Z5s.RapidBoardSpaPage),
        skeleton: (0, $7o1kb.ClassicReportSkeleton),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            ...(0, $yxwH0.getReportsCommonResource)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $16Z5s.LazyRapidBoard),
            (0, $16Z5s.LazyRapidBoardApps)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        ufoName: 'classic-report',
        entryPoint: ()=>(0, $kJSiQ.reportPageEntrypoint)
    }));

});
parcelRegister("hwrCN", function(module, exports) {

$parcel$export(module.exports, "rapidboardReportRoute", () => $090be05d28e65948$export$d37f637b09fb9fda);
const $090be05d28e65948$export$d37f637b09fb9fda = {
    name: 'rapidboard-report',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/:chartView'
};

});

parcelRegister("7o1kb", function(module, exports) {

$parcel$export(module.exports, "ClassicReportSkeleton", () => $61f1e37e5e1946ad$export$d7667341f4db3b8d);

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $g5liH = parcelRequire("g5liH");
const $61f1e37e5e1946ad$export$d7667341f4db3b8d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($g5liH)))
    });

});
parcelRegister("g5liH", function(module, exports) {
module.exports = new URL("classic-report-app-skeleton.tpl.1daae66d.svg", import.meta.url).toString();

});


parcelRegister("yxwH0", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $c75fcd785e66868e$export$8cb713295e6b7204);
$parcel$export(module.exports, "getTMPReportsCommonResource", () => $c75fcd785e66868e$export$f234446c23dc22a);

var $48Ij3 = parcelRequire("48Ij3");

var $gcI3W = parcelRequire("gcI3W");

var $4Bwc0 = parcelRequire("4Bwc0");
const $c75fcd785e66868e$export$8cb713295e6b7204 = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $c75fcd785e66868e$export$f234446c23dc22a = ()=>[
        (0, $4Bwc0.devOpsReportPreconditionResource),
        (0, $gcI3W.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $48Ij3.staticSidebarJSWReportsResource)
    ];

});

parcelRegister("kJSiQ", function(module, exports) {

$parcel$export(module.exports, "reportPageEntrypoint", () => $d52c4fa019e81654$export$73cecf7395943edd);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $3MyKR = parcelRequire("3MyKR");
const $d52c4fa019e81654$export$73cecf7395943edd = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $3MyKR.rapidBoardEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("3MyKR", function(module, exports) {

$parcel$export(module.exports, "rapidBoardEntryPoint", () => $366384de5193f3a2$export$15991360ec37fcaf);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $366384de5193f3a2$export$15991360ec37fcaf = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("kb1Oq")), {
        moduleId: "4d7ce9a3"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("kb1Oq", function(module, exports) {

let $eb063d987cfe43b1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eb063d987cfe43b1$var$load("ecERA").then(()=>parcelRequire('Gk4RP'));

});




parcelRegister("CY8KI", function(module, exports) {

$parcel$export(module.exports, "softwareReportsOverviewRouteEntry", () => $1f4532d2aef48985$export$705071d2eca06bf9);

var $7NszV = parcelRequire("7NszV");

var $lmyls = parcelRequire("lmyls");

var $4R6GH = parcelRequire("4R6GH");

var $9s3j1 = parcelRequire("9s3j1");

var $6rHGg = parcelRequire("6rHGg");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $5f2bR = parcelRequire("5f2bR");

var $lkFvK = parcelRequire("lkFvK");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $e7bC3 = parcelRequire("e7bC3");

var $dxCvy = parcelRequire("dxCvy");

var $fh5Sl = parcelRequire("fh5Sl");

var $fo6b8 = parcelRequire("fo6b8");

var $38FLy = parcelRequire("38FLy");
const $1f4532d2aef48985$var$reportsOverviewPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $fh5Sl.reportsOverviewPageEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $1f4532d2aef48985$export$705071d2eca06bf9 = (0, $7NszV.createEntry)((0, $6rHGg.softwareReportsOverviewRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $38FLy.ReportsOverviewSkeleton),
        entryPoint () {
            return (0, $4R6GH.fg)('reports-overview-page-migration') ? $1f4532d2aef48985$var$reportsOverviewPageEntryPoint : undefined;
        },
        layout: (0, $e7bC3.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        ufoName: 'reports-overview'
    }));

});
parcelRegister("6rHGg", function(module, exports) {

$parcel$export(module.exports, "softwareReportsOverviewRoute", () => $70946eef546cad35$export$f38928477442c9cf);
const $70946eef546cad35$export$f38928477442c9cf = {
    name: 'software-reports',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports'
};

});

parcelRegister("38FLy", function(module, exports) {

$parcel$export(module.exports, "ReportsOverviewSkeleton", () => $b7f1d5ad6a664668$export$c70e702bcad58c36);
/* ReportsOverviewSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $kkMO6 = parcelRequire("kkMO6");
const $b7f1d5ad6a664668$var$containerStyles = {
    maxWidth: '100%'
};
const $b7f1d5ad6a664668$var$customCssStyles = null;
const $b7f1d5ad6a664668$export$c70e702bcad58c36 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kkMO6))),
        containerStyles: $b7f1d5ad6a664668$var$containerStyles,
        className: (0, $bwpsq.default)([
            "_2zz1idpf"
        ])
    });

});
parcelRegister("kkMO6", function(module, exports) {
module.exports = new URL("report-categories-skeleton.tpl.5b53a8d3.svg", import.meta.url).toString();

});



parcelRegister("3Jvzv", function(module, exports) {

$parcel$export(module.exports, "softwareReportsOverviewBoardlessRouteEntry", () => $9c5660c793001eba$export$1341f3a3578e9e4);

var $7NszV = parcelRequire("7NszV");

var $lmyls = parcelRequire("lmyls");

var $4R6GH = parcelRequire("4R6GH");

var $9s3j1 = parcelRequire("9s3j1");

var $e5NqW = parcelRequire("e5NqW");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $5f2bR = parcelRequire("5f2bR");

var $lkFvK = parcelRequire("lkFvK");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $48Ij3 = parcelRequire("48Ij3");

var $e7bC3 = parcelRequire("e7bC3");

var $dxCvy = parcelRequire("dxCvy");

var $fh5Sl = parcelRequire("fh5Sl");

var $fo6b8 = parcelRequire("fo6b8");

var $38FLy = parcelRequire("38FLy");
const $9c5660c793001eba$var$reportsOverviewPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $fh5Sl.reportsOverviewPageEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $9c5660c793001eba$export$1341f3a3578e9e4 = (0, $7NszV.createEntry)((0, $e5NqW.softwareReportsOverviewBoardlessRoute), ()=>({
        group: 'software-reports-boardless',
        skeleton: (0, $38FLy.ReportsOverviewSkeleton),
        entryPoint () {
            return (0, $4R6GH.fg)('reports-overview-page-migration') ? $9c5660c793001eba$var$reportsOverviewPageEntryPoint : undefined;
        },
        layout: (0, $e7bC3.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $48Ij3.staticSidebarJSWReportsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        ufoName: 'reports-overview'
    }));

});
parcelRegister("e5NqW", function(module, exports) {

$parcel$export(module.exports, "softwareReportsOverviewBoardlessRoute", () => $ec5168f42eb9ffe8$export$e2f371bced79a0e4);
const $ec5168f42eb9ffe8$export$e2f371bced79a0e4 = {
    name: 'software-reports-boardless',
    path: '/jira/software/c/projects/:projectKey/reports',
    exact: true
};

});


parcelRegister("kYzjv", function(module, exports) {

$parcel$export(module.exports, "softwareReportsCycleTimeClassicRouteEntry", () => $8d790787867c06bf$export$1bbbe71c256ed1d0);

var $e4eHl = parcelRequire("e4eHl");

var $7NszV = parcelRequire("7NszV");

var $3vbFU = parcelRequire("3vbFU");

var $7XYc4 = parcelRequire("7XYc4");

var $kfztd = parcelRequire("kfztd");

var $5lsNZ = parcelRequire("5lsNZ");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $2GkDw = parcelRequire("2GkDw");

var $ffza4 = parcelRequire("ffza4");

var $c04PQ = parcelRequire("c04PQ");

var $4R6GH = parcelRequire("4R6GH");

var $6LsQE = parcelRequire("6LsQE");

var $gxiIi = parcelRequire("gxiIi");

var $yxwH0 = parcelRequire("yxwH0");

var $89cBA = parcelRequire("89cBA");
const $8d790787867c06bf$export$1bbbe71c256ed1d0 = (0, $7NszV.createEntry)((0, $3vbFU.softwareReportsCycleTimeClassicRoute), ()=>({
        group: 'classic-software',
        component: (0, $7XYc4.componentWithCondition)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $gxiIi.CycleTimeReportClassic)),
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('entrypoint_migration_reports_cycle_time_classic')) {
                if ((0, $c04PQ.isFedRamp)()) return 0, $6LsQE.notFoundPageEntrypoint;
                return 0, $89cBA.cycleTimeReportClassicPageEntrypoint;
            }
            return undefined;
        },
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $yxwH0.getReportsCommonResource)(),
            (0, $2GkDw.devOpsProviderResource)
        ],
        afterPaint: [
            (0, $gxiIi.LazyCycleTimeReport)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gxiIi.LazyCycleTimeReport)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            reporting: {
                id: 'software-reports-cycle-time-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-reports-cycle-time-classic'),
                teamName: 'fusion-solaris'
            }
        }
    }));

});
parcelRegister("3vbFU", function(module, exports) {

$parcel$export(module.exports, "softwareReportsCycleTimeClassicRoute", () => $06112c4b48f06dba$export$1e5e610e11119ea7);
const $06112c4b48f06dba$export$1e5e610e11119ea7 = {
    name: 'software-reports-cycle-time-classic',
    path: '/jira/software/c/projects/:projectKey/reports/cycle-time',
    exact: true
};

});

parcelRegister("gxiIi", function(module, exports) {

$parcel$export(module.exports, "LazyCycleTimeReport", () => $670577022d2fb7b4$export$956f830ed027f1fb);
$parcel$export(module.exports, "CycleTimeReportClassic", () => $670577022d2fb7b4$export$237924ba64065cc3);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $670577022d2fb7b4$export$956f830ed027f1fb = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("bdsFD")), {
    moduleId: "./src/packages/spa-apps/cycle-time-report/src/ui/index-old.tsx"
});
const $670577022d2fb7b4$export$e16ce0656a74a015 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $670577022d2fb7b4$export$956f830ed027f1fb,
        pageId: "cycleTimeReportNextGen",
        shouldShowSpinner: true
    });
const $670577022d2fb7b4$export$237924ba64065cc3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $670577022d2fb7b4$export$956f830ed027f1fb,
        pageId: "cycleTimeReportClassic",
        shouldShowSpinner: true
    });

});
parcelRegister("bdsFD", function(module, exports) {

let $82a725ff3612589c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $82a725ff3612589c$var$load("ffQaD"),
    $82a725ff3612589c$var$load("kvRbA"),
    $82a725ff3612589c$var$load("lN50H")
]).then(()=>parcelRequire('2DLxB'));

});


parcelRegister("89cBA", function(module, exports) {

$parcel$export(module.exports, "cycleTimeReportClassicPageEntrypoint", () => $f19a24813079175a$export$2dba7a1bad1f01b2);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $4i2WV = parcelRequire("4i2WV");
const $f19a24813079175a$export$2dba7a1bad1f01b2 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $4i2WV.cycleTimeReportEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});


parcelRegister("lHzMh", function(module, exports) {

$parcel$export(module.exports, "softwareReportsCycleTimeClassicBoardRouteEntry", () => $5825ca5195a81fcb$export$9c40eb459ce6a0bc);

var $e4eHl = parcelRequire("e4eHl");

var $7NszV = parcelRequire("7NszV");

var $7AHcB = parcelRequire("7AHcB");

var $7XYc4 = parcelRequire("7XYc4");

var $kfztd = parcelRequire("kfztd");

var $5lsNZ = parcelRequire("5lsNZ");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $2GkDw = parcelRequire("2GkDw");

var $ffza4 = parcelRequire("ffza4");

var $c04PQ = parcelRequire("c04PQ");

var $4R6GH = parcelRequire("4R6GH");

var $6LsQE = parcelRequire("6LsQE");

var $gxiIi = parcelRequire("gxiIi");

var $yxwH0 = parcelRequire("yxwH0");

var $89cBA = parcelRequire("89cBA");
const $5825ca5195a81fcb$export$9c40eb459ce6a0bc = (0, $7NszV.createEntry)((0, $7AHcB.softwareReportsCycleTimeClassicBoardRoute), ()=>({
        group: 'classic-software',
        component: (0, $7XYc4.componentWithCondition)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $gxiIi.CycleTimeReportClassic)),
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('entrypoint_migration_reports_cycle_time_classic')) {
                if ((0, $c04PQ.isFedRamp)()) return 0, $6LsQE.notFoundPageEntrypoint;
                return 0, $89cBA.cycleTimeReportClassicPageEntrypoint;
            }
            return undefined;
        },
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $yxwH0.getReportsCommonResource)(),
            (0, $2GkDw.devOpsProviderResource)
        ],
        afterPaint: [
            (0, $gxiIi.LazyCycleTimeReport)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gxiIi.LazyCycleTimeReport)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            reporting: {
                id: 'software-reports-cycle-time-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-reports-cycle-time-classic'),
                teamName: 'fusion-solaris'
            }
        }
    }));

});
parcelRegister("7AHcB", function(module, exports) {

$parcel$export(module.exports, "softwareReportsCycleTimeClassicBoardRoute", () => $49ddf385f7fbe750$export$12423e360eb5fa9d);
const $49ddf385f7fbe750$export$12423e360eb5fa9d = {
    name: 'software-reports-cycle-time-classic-board',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/cycle-time',
    exact: true
};

});


parcelRegister("711QI", function(module, exports) {

$parcel$export(module.exports, "softwareFormBuilderClassicRouteEntry", () => $b4fa37ff3bdeb6f7$export$96aa488380334044);

var $7NszV = parcelRequire("7NszV");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $3OSHM = parcelRequire("3OSHM");

var $6s1PB = parcelRequire("6s1PB");

var $evEd2 = parcelRequire("evEd2");

var $fo6b8 = parcelRequire("fo6b8");

var $e7bC3 = parcelRequire("e7bC3");

var $9s3j1 = parcelRequire("9s3j1");

var $lkFvK = parcelRequire("lkFvK");

var $3HwlS = parcelRequire("3HwlS");

var $6LsQE = parcelRequire("6LsQE");

var $5f2bR = parcelRequire("5f2bR");

var $l2N2a = parcelRequire("l2N2a");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");
const $b4fa37ff3bdeb6f7$var$formBuilderPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $evEd2.formBuilderEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $b4fa37ff3bdeb6f7$export$96aa488380334044 = (0, $7NszV.createEntry)((0, $3OSHM.softwareFormBuilderClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-form-builder',
        layout: (0, $e7bC3.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), (0, $5f2bR.AsyncHorizontalNavJira), ()=>null)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingM2Enabled)(), (0, $9V5k0.projectThemeResource))
        ],
        entryPoint: ()=>{
            return (0, $6s1PB.expVal)('forms_for_jsw_experiment', 'isEnabled', false) ? $b4fa37ff3bdeb6f7$var$formBuilderPageEntrypoint : (0, $6LsQE.notFoundPageEntrypoint);
        }
    }));

});
parcelRegister("3OSHM", function(module, exports) {

$parcel$export(module.exports, "softwareFormBuilderClassicRoute", () => $9ede72c8b3eb717b$export$f6cfee0232aa1e);
const $9ede72c8b3eb717b$export$f6cfee0232aa1e = {
    name: 'software-form-builder-classic',
    path: '/jira/software/c/projects/:projectKey/form/:formId/builder',
    exact: true
};

});


parcelRegister("gcVUu", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitClassicRouteEntry", () => $331e128c3f179847$export$a7c8812838762453);

var $7NszV = parcelRequire("7NszV");

var $lmyls = parcelRequire("lmyls");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $6LsQE = parcelRequire("6LsQE");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $6FnT3 = parcelRequire("6FnT3");

var $lkFvK = parcelRequire("lkFvK");

var $6s1PB = parcelRequire("6s1PB");

var $l2N2a = parcelRequire("l2N2a");

var $1Fd2h = parcelRequire("1Fd2h");

var $6e4Kt = parcelRequire("6e4Kt");
const $331e128c3f179847$var$formSubmitPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $6FnT3.formSubmitEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $331e128c3f179847$export$a7c8812838762453 = (0, $7NszV.createEntry)((0, $1Fd2h.softwareFormSubmitClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-form-submit',
        layout: (0, $6e4Kt.chromelessLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource)
        ],
        entryPoint: ()=>{
            return (0, $6s1PB.expVal)('forms_for_jsw_experiment', 'isEnabled', false) ? $331e128c3f179847$var$formSubmitPageEntrypoint : (0, $6LsQE.notFoundPageEntrypoint);
        }
    }));

});
parcelRegister("1Fd2h", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitClassicRoute", () => $dcbb2b95e9b9bd2e$export$91d6851bf27349);
const $dcbb2b95e9b9bd2e$export$91d6851bf27349 = {
    name: 'software-form-submit-classic',
    path: '/jira/software/c/projects/:projectKey/form/:formId',
    exact: true
};

});


parcelRegister("dG6DF", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitEmbedClassicRouteEntry", () => $cca7fa509b94a5ef$export$ffc85d68201bbe35);

var $7NszV = parcelRequire("7NszV");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $6LsQE = parcelRequire("6LsQE");

var $l2N2a = parcelRequire("l2N2a");

var $6e4Kt = parcelRequire("6e4Kt");

var $cQaX2 = parcelRequire("cQaX2");

var $a1Eek = parcelRequire("a1Eek");

var $lkFvK = parcelRequire("lkFvK");
const $cca7fa509b94a5ef$var$formSubmitEmbedPageEntrypoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $a1Eek.formSubmitEmbedEntrypoint)
});
const $cca7fa509b94a5ef$export$ffc85d68201bbe35 = (0, $7NszV.createEntry)((0, $cQaX2.softwareFormSubmitEmbedClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-form-submit-embed',
        layout: (0, $6e4Kt.chromelessLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        // eslint-disable-next-line camelcase
        resources: [
            (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource)
        ],
        entryPoint: ()=>{
            return (0, $4R6GH.fg)('jsw_forms_embed') ? $cca7fa509b94a5ef$var$formSubmitEmbedPageEntrypoint : (0, $6LsQE.notFoundPageEntrypoint);
        }
    }));

});
parcelRegister("cQaX2", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitEmbedClassicRoute", () => $7149a36cf3eab9d7$export$812703a022333f7c);
const $7149a36cf3eab9d7$export$812703a022333f7c = {
    name: 'software-form-submit-classic-embed',
    path: '/jira/software/c/projects/:projectKey/form/:formId/embed',
    exact: true
};

});


parcelRegister("efYyQ", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitClassicPublicRouteEntry", () => $0622f0c75a643879$export$df7e146d38db5cc0);

var $7NszV = parcelRequire("7NszV");

var $6LsQE = parcelRequire("6LsQE");

var $6s1PB = parcelRequire("6s1PB");

var $1AQOY = parcelRequire("1AQOY");

var $2Ql51 = parcelRequire("2Ql51");

var $6e4Kt = parcelRequire("6e4Kt");

var $eRU3k = parcelRequire("eRU3k");
const $0622f0c75a643879$export$df7e146d38db5cc0 = (0, $7NszV.createEntry)((0, $1AQOY.softwareFormSubmitClassicPublicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-form-submit-public',
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            (0, $2Ql51.themePreferenceResource)
        ],
        entryPoint: ()=>(0, $6s1PB.expVal)('jira_forms_public_access_experiment', 'isEnabled', 'false') ? (0, $eRU3k.formSubmitPageEntrypoint) : (0, $6LsQE.notFoundPageEntrypoint)
    }));

});
parcelRegister("1AQOY", function(module, exports) {

$parcel$export(module.exports, "softwareFormSubmitClassicPublicRoute", () => $3e5868f8d7166868$export$c66ba06e288dec3f);
const $3e5868f8d7166868$export$c66ba06e288dec3f = {
    name: 'software-form-submit-classic-public',
    path: '/jira/software/c/form/:formUuid',
    exact: true
};

});


parcelRegister("kQjkp", function(module, exports) {

$parcel$export(module.exports, "softwareFormClassicRouteEntry", () => $d20dbf7f22bf9ac8$export$4bb0f20ad6471148);

var $7NszV = parcelRequire("7NszV");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $fo6b8 = parcelRequire("fo6b8");

var $6s1PB = parcelRequire("6s1PB");

var $l2N2a = parcelRequire("l2N2a");

var $iwW4Z = parcelRequire("iwW4Z");

var $6LsQE = parcelRequire("6LsQE");

var $eeYjL = parcelRequire("eeYjL");

var $lkFvK = parcelRequire("lkFvK");

var $e7bC3 = parcelRequire("e7bC3");

var $9s3j1 = parcelRequire("9s3j1");

var $3HwlS = parcelRequire("3HwlS");

var $5f2bR = parcelRequire("5f2bR");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");
const $d20dbf7f22bf9ac8$var$formPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $eeYjL.formEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $d20dbf7f22bf9ac8$export$4bb0f20ad6471148 = (0, $7NszV.createEntry)((0, $iwW4Z.softwareFormClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-form',
        layout: (0, $e7bC3.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), (0, $5f2bR.AsyncHorizontalNavJira), ()=>null)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            // eslint-disable-next-line camelcase
            (0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingM2Enabled)(), (0, $9V5k0.projectThemeResource))
        ],
        entryPoint: ()=>{
            return (0, $6s1PB.expVal)('forms_for_jsw_experiment', 'isEnabled', false) ? $d20dbf7f22bf9ac8$var$formPageEntrypoint : (0, $6LsQE.notFoundPageEntrypoint);
        }
    }));

});
parcelRegister("iwW4Z", function(module, exports) {

$parcel$export(module.exports, "softwareFormClassicRoute", () => $3b49c520878b4671$export$ae560ee5b676193d);
const $3b49c520878b4671$export$ae560ee5b676193d = {
    name: 'software-form-classic',
    path: '/jira/software/c/projects/:projectKey/form',
    exact: true
};

});


parcelRegister("1IhKQ", function(module, exports) {

$parcel$export(module.exports, "softwareGoalsClassicRouteEntry", () => $1b0cb05431f8ca29$export$58d10390fc181fcf);

var $7NszV = parcelRequire("7NszV");

var $lmyls = parcelRequire("lmyls");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $9s3j1 = parcelRequire("9s3j1");

var $5f2bR = parcelRequire("5f2bR");

var $e1lSQ = parcelRequire("e1lSQ");

var $6XlJT = parcelRequire("6XlJT");
const $1b0cb05431f8ca29$export$58d10390fc181fcf = (0, $7NszV.createEntry)((0, $e1lSQ.softwareGoalsClassicRoute), ()=>({
        group: 'classic-software',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $6XlJT.softwareGoalsClassicPageEntrypoint)
    }));

});
parcelRegister("e1lSQ", function(module, exports) {

$parcel$export(module.exports, "softwareGoalsClassicRoute", () => $9ec0c22df6343cfe$export$d12f3924cf53b545);
const $9ec0c22df6343cfe$export$d12f3924cf53b545 = {
    name: 'software-goals-classic',
    path: '/jira/software/c/projects/:projectKey/goals'
};

});

parcelRegister("6XlJT", function(module, exports) {

$parcel$export(module.exports, "softwareGoalsClassicPageEntrypoint", () => $4a23aaa7a1201d94$export$6c6f7e606a16292);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");

var $gz6uQ = parcelRequire("gz6uQ");
const $4a23aaa7a1201d94$export$6c6f7e606a16292 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $gz6uQ.softwareGoalsEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});


parcelRegister("iwgxt", function(module, exports) {

$parcel$export(module.exports, "softwareSummaryClassicRouteEntry", () => $ab4cacd7ed3eca70$export$f81c7c178a9483e8);

var $7NszV = parcelRequire("7NszV");

var $lmyls = parcelRequire("lmyls");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $7uLIV = parcelRequire("7uLIV");

var $9s3j1 = parcelRequire("9s3j1");

var $5f2bR = parcelRequire("5f2bR");

var $4E1mJ = parcelRequire("4E1mJ");

var $7XYc4 = parcelRequire("7XYc4");

var $6s1PB = parcelRequire("6s1PB");

var $f3iuv = parcelRequire("f3iuv");

var $5lsNZ = parcelRequire("5lsNZ");

var $e7bC3 = parcelRequire("e7bC3");

var $ffza4 = parcelRequire("ffza4");

var $1wsDh = parcelRequire("1wsDh");

var $fo6b8 = parcelRequire("fo6b8");

var $4R6GH = parcelRequire("4R6GH");

var $lkFvK = parcelRequire("lkFvK");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");
const $ab4cacd7ed3eca70$var$summarySoftwarePageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1wsDh.summarySoftwareEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
/**
 * @deprecated delete when cleaning up project_summary_page_entry_point_migration
 */ const $ab4cacd7ed3eca70$var$getHorizontalNavResources = ()=>(0, $4R6GH.fg)('project_summary_page_entry_point_migration') ? [] : [
        (0, $7uLIV.horizontalNavJiraResource)
    ];
const $ab4cacd7ed3eca70$export$f81c7c178a9483e8 = (0, $7NszV.createEntry)((0, $4E1mJ.softwareSummaryClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-summary',
        component: (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expVal)('helios_summary_page_experiment', 'isEnabled', false), (0, $f3iuv.SummaryPage), (0, $5lsNZ.default)),
        layout: (0, $e7bC3.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // delete when cleaning up project_summary_page_entry_point_migration
            ...$ab4cacd7ed3eca70$var$getHorizontalNavResources(),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource))
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $f3iuv.LazySummaryView)
        ],
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('project_summary_page_entry_point_migration')) return $ab4cacd7ed3eca70$var$summarySoftwarePageEntrypoint;
        }
    }));

});
parcelRegister("4E1mJ", function(module, exports) {

$parcel$export(module.exports, "softwareSummaryClassicRoute", () => $b668e7dcab7792ea$export$b5046fccf399983f);
const $b668e7dcab7792ea$export$b5046fccf399983f = {
    name: 'software-summary-classic',
    path: '/jira/software/c/projects/:projectKey/summary'
};

});


parcelRegister("e99fJ", function(module, exports) {

$parcel$export(module.exports, "softwareSummaryEmbedClassicRouteEntry", () => $ee0193265f7cd493$export$1dc5e581d8ca39ac);

var $7NszV = parcelRequire("7NszV");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $8zMZd = parcelRequire("8zMZd");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $jEWyg = parcelRequire("jEWyg");

var $5lsNZ = parcelRequire("5lsNZ");

var $6e4Kt = parcelRequire("6e4Kt");

var $9Hxle = parcelRequire("9Hxle");

var $4R6GH = parcelRequire("4R6GH");

var $lkFvK = parcelRequire("lkFvK");
const $ee0193265f7cd493$var$summarySoftwareEmbedPageEntrypoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $9Hxle.summarySoftwareEmbedEntrypoint)
});
const $ee0193265f7cd493$export$1dc5e581d8ca39ac = (0, $7NszV.createEntry)((0, $8zMZd.softwareSummaryEmbedClassicRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-summary',
        component: (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expVal)('jsw-summary-page-embed-smart-link-experiment', 'isEnabled', false), (0, $jEWyg.SummaryEmbedPage), (0, $5lsNZ.default)),
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource)
        ],
        forPaint: [
            (0, $jEWyg.LazySummaryEmbedView)
        ],
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('project_summary_page_entry_point_migration')) return $ee0193265f7cd493$var$summarySoftwareEmbedPageEntrypoint;
        }
    }));

});
parcelRegister("8zMZd", function(module, exports) {

$parcel$export(module.exports, "softwareSummaryEmbedClassicRoute", () => $f4e6d1316b36f71d$export$7fa3d3891ccec782);
const $f4e6d1316b36f71d$export$7fa3d3891ccec782 = {
    name: 'software-summary-classic-embed',
    path: '/jira/software/c/projects/:projectKey/summary/embed'
};

});


parcelRegister("hUUCw", function(module, exports) {

$parcel$export(module.exports, "softwareClassicProformaIssueFormsDirectRouteEntry", () => $d4fc432d647b5f41$export$8fd8b0cbd2b8730d);

var $7NszV = parcelRequire("7NszV");

var $lmyls = parcelRequire("lmyls");

var $bQgMC = parcelRequire("bQgMC");

var $e7bC3 = parcelRequire("e7bC3");

var $dxCvy = parcelRequire("dxCvy");

var $13pw2 = parcelRequire("13pw2");
const $d4fc432d647b5f41$export$8fd8b0cbd2b8730d = (0, $7NszV.createEntry)((0, $bQgMC.softwareClassicProformaIssueFormsDirectRoute), ()=>({
        group: 'classic-software',
        layout: (0, $e7bC3.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        resources: [
            (0, $dxCvy.projectContextResource)
        ],
        entryPoint: ()=>(0, $13pw2.proformaIssueFormsDirectPageEntryPoint),
        perfMetricKey: 'issue-forms-direct'
    }));

});
parcelRegister("bQgMC", function(module, exports) {

$parcel$export(module.exports, "softwareClassicProformaIssueFormsDirectRoute", () => $a29107263e83fc90$export$92f34907c6bf7007);
const $a29107263e83fc90$export$92f34907c6bf7007 = {
    name: 'classic-software-proforma-issue-forms-direct',
    path: '/jira/software/c/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?',
    exact: true
};

});

parcelRegister("13pw2", function(module, exports) {

$parcel$export(module.exports, "proformaIssueFormsDirectPageEntryPoint", () => $480a54898b863a19$export$dc0bb5719ae7aab4);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $1aJjB = parcelRequire("1aJjB");
const $480a54898b863a19$export$dc0bb5719ae7aab4 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1aJjB.proformaIssueFormsDirectEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});


parcelRegister("knZRG", function(module, exports) {

$parcel$export(module.exports, "softwareClassicProformaIssueFormsDirectEmbedRouteEntry", () => $e9a0be7e929de3ec$export$fdc2679a6c96e9fa);

var $7NszV = parcelRequire("7NszV");

var $dxCvy = parcelRequire("dxCvy");

var $kHaoU = parcelRequire("kHaoU");

var $6e4Kt = parcelRequire("6e4Kt");

var $33P3A = parcelRequire("33P3A");
const $e9a0be7e929de3ec$export$fdc2679a6c96e9fa = (0, $7NszV.createEntry)((0, $kHaoU.softwareClassicProformaIssueFormsDirectEmbedRoute), ()=>({
        group: 'classic-software',
        component: (0, $33P3A.default),
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            (0, $dxCvy.projectContextResource)
        ],
        forPaint: [
            (0, $33P3A.LazyProformaIssueFormsDirectEmbed)
        ],
        perfMetricKey: 'issue-forms-direct-embed'
    }));

});
parcelRegister("kHaoU", function(module, exports) {

$parcel$export(module.exports, "softwareClassicProformaIssueFormsDirectEmbedRoute", () => $e5452599d7d96b18$export$16987cdd084cceba);
const $e5452599d7d96b18$export$16987cdd084cceba = {
    name: 'classic-software-proforma-issue-forms-direct-embed',
    path: '/jira/software/c/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?/embed',
    exact: true
};

});

parcelRegister("33P3A", function(module, exports) {

$parcel$export(module.exports, "LazyProformaIssueFormsDirectEmbed", () => $a96f990777917c84$export$22681210aaeb910f);
$parcel$export(module.exports, "default", () => $a96f990777917c84$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $a96f990777917c84$export$22681210aaeb910f = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("8yRRM")), {
    moduleId: "./src/packages/spa-apps/proforma-issue-forms-direct-embed/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a96f990777917c84$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $a96f990777917c84$export$22681210aaeb910f,
        pageId: "proforma-issue-forms-direct-embed",
        shouldShowSpinner: true
    });

});


parcelRegister("7dbQR", function(module, exports) {

$parcel$export(module.exports, "softwareReportsDeploymentFrequencyClassicRouteEntry", () => $ec1385d68692f12b$export$e5eaafb1fb588922);

var $e4eHl = parcelRequire("e4eHl");

var $7NszV = parcelRequire("7NszV");

var $7XYc4 = parcelRequire("7XYc4");

var $5lsNZ = parcelRequire("5lsNZ");

var $lmyls = parcelRequire("lmyls");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $ffza4 = parcelRequire("ffza4");

var $7OCOC = parcelRequire("7OCOC");

var $kfztd = parcelRequire("kfztd");

var $gyYxw = parcelRequire("gyYxw");

var $hBv66 = parcelRequire("hBv66");

var $2GkDw = parcelRequire("2GkDw");

var $4R6GH = parcelRequire("4R6GH");

var $c04PQ = parcelRequire("c04PQ");

var $6LsQE = parcelRequire("6LsQE");

var $9Ye18 = parcelRequire("9Ye18");

var $yxwH0 = parcelRequire("yxwH0");

var $3woHG = parcelRequire("3woHG");
const $ec1385d68692f12b$export$e5eaafb1fb588922 = (0, $7NszV.createEntry)((0, $7OCOC.softwareReportsDeploymentFrequencyClassicRoute), ()=>({
        group: 'classic-software',
        component: (0, $7XYc4.componentWithCondition)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $9Ye18.DeploymentFrequencyReportClassic)),
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('entrypoint-reports-deployment-frequency-classic')) {
                if ((0, $c04PQ.isFedRamp)()) return 0, $6LsQE.notFoundPageEntrypoint;
                return 0, $3woHG.deploymentFrequencyReportPageEntrypoint;
            }
            return undefined;
        },
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $yxwH0.getReportsCommonResource)(),
            (0, $2GkDw.devOpsProviderResource)
        ],
        afterPaint: [
            (0, $9Ye18.LazyDeploymentFrequencyReport)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $9Ye18.LazyDeploymentFrequencyReport)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            reporting: {
                id: 'software-reports-deployment-frequency-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-reports-deployment-frequency-classic'),
                teamName: 'fusion-solaris'
            }
        }
    }));

});
parcelRegister("7OCOC", function(module, exports) {

$parcel$export(module.exports, "softwareReportsDeploymentFrequencyClassicRoute", () => $8904c68da8a25316$export$312c410cb3b49afe);
const $8904c68da8a25316$export$312c410cb3b49afe = {
    name: 'software-reports-deployment-frequency-classic',
    path: '/jira/software/c/projects/:projectKey/reports/deployment-frequency',
    exact: true
};

});

parcelRegister("9Ye18", function(module, exports) {

$parcel$export(module.exports, "LazyDeploymentFrequencyReport", () => $e228059a3ddd4015$export$5113b2b19ec1fb53);
$parcel$export(module.exports, "DeploymentFrequencyReportClassic", () => $e228059a3ddd4015$export$655707e8ae1053d3);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $e228059a3ddd4015$export$5113b2b19ec1fb53 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("hCJmk")), {
    moduleId: "./src/packages/spa-apps/deployment-frequency-report/src/index.tsx"
});
const $e228059a3ddd4015$export$e2db9c7426cdb53 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e228059a3ddd4015$export$5113b2b19ec1fb53,
        pageId: "deploymentFrequencyReportNextGen",
        shouldShowSpinner: true
    });
const $e228059a3ddd4015$export$655707e8ae1053d3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e228059a3ddd4015$export$5113b2b19ec1fb53,
        pageId: "deploymentFrequencyReportClassic",
        shouldShowSpinner: true
    });

});
parcelRegister("hCJmk", function(module, exports) {

let $cd492bae4e126e45$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $cd492bae4e126e45$var$load("ffQaD"),
    $cd492bae4e126e45$var$load("kvRbA"),
    $cd492bae4e126e45$var$load("jzecC")
]).then(()=>parcelRequire('6pwND'));

});


parcelRegister("3woHG", function(module, exports) {

$parcel$export(module.exports, "deploymentFrequencyReportPageEntrypoint", () => $edf6d9a26482ed8b$export$2a837f21eaa534d9);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $1tqza = parcelRequire("1tqza");
const $edf6d9a26482ed8b$export$2a837f21eaa534d9 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $1tqza.deploymentFrequencyReportEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});


parcelRegister("jbAAG", function(module, exports) {

$parcel$export(module.exports, "softwareReportsDeploymentFrequencyClassicBoardRouteEntry", () => $c8c352b6ab54773f$export$e0c7b9ad9dd8b956);

var $e4eHl = parcelRequire("e4eHl");

var $7NszV = parcelRequire("7NszV");

var $7XYc4 = parcelRequire("7XYc4");

var $5lsNZ = parcelRequire("5lsNZ");

var $lmyls = parcelRequire("lmyls");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $ffza4 = parcelRequire("ffza4");

var $jc0kT = parcelRequire("jc0kT");

var $kfztd = parcelRequire("kfztd");

var $gyYxw = parcelRequire("gyYxw");

var $hBv66 = parcelRequire("hBv66");

var $2GkDw = parcelRequire("2GkDw");

var $4R6GH = parcelRequire("4R6GH");

var $c04PQ = parcelRequire("c04PQ");

var $6LsQE = parcelRequire("6LsQE");

var $9Ye18 = parcelRequire("9Ye18");

var $yxwH0 = parcelRequire("yxwH0");

var $3woHG = parcelRequire("3woHG");
const $c8c352b6ab54773f$export$e0c7b9ad9dd8b956 = (0, $7NszV.createEntry)((0, $jc0kT.softwareReportsDeploymentFrequencyClassicBoardRoute), ()=>({
        group: 'classic-software',
        component: (0, $7XYc4.componentWithCondition)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $9Ye18.DeploymentFrequencyReportClassic)),
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('entrypoint-reports-deployment-frequency-classic')) {
                if ((0, $c04PQ.isFedRamp)()) return 0, $6LsQE.notFoundPageEntrypoint;
                return 0, $3woHG.deploymentFrequencyReportPageEntrypoint;
            }
            return undefined;
        },
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $yxwH0.getReportsCommonResource)(),
            (0, $2GkDw.devOpsProviderResource)
        ],
        afterPaint: [
            (0, $9Ye18.LazyDeploymentFrequencyReport)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $9Ye18.LazyDeploymentFrequencyReport)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            reporting: {
                id: 'software-reports-deployment-frequency-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-reports-deployment-frequency-classic'),
                teamName: 'fusion-solaris'
            }
        }
    }));

});
parcelRegister("jc0kT", function(module, exports) {

$parcel$export(module.exports, "softwareReportsDeploymentFrequencyClassicBoardRoute", () => $a139294269da1f90$export$56d4754499615215);
const $a139294269da1f90$export$56d4754499615215 = {
    name: 'software-reports-deployment-frequency-classic-board',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/deployment-frequency',
    exact: true
};

});


parcelRegister("58Cy7", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBacklogRouteEntry", () => $80af0d16c3f293f2$export$568101ebd359b606);

var $7NszV = parcelRequire("7NszV");

var $2H7GR = parcelRequire("2H7GR");

var $16Z5s = parcelRequire("16Z5s");

var $i8JTM = parcelRequire("i8JTM");

var $4R6GH = parcelRequire("4R6GH");

var $aPfsS = parcelRequire("aPfsS");

var $gyYxw = parcelRequire("gyYxw");

var $g5RGc = parcelRequire("g5RGc");

var $lmyls = parcelRequire("lmyls");

var $5f2bR = parcelRequire("5f2bR");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $3HwlS = parcelRequire("3HwlS");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $7uLIV = parcelRequire("7uLIV");

var $f5kpo = parcelRequire("f5kpo");

var $lJ1FP = parcelRequire("lJ1FP");

var $lfnsv = parcelRequire("lfnsv");

var $fKmub = parcelRequire("fKmub");

var $ffza4 = parcelRequire("ffza4");

var $e2ctp = parcelRequire("e2ctp");

var $9s3j1 = parcelRequire("9s3j1");

var $gNStA = parcelRequire("gNStA");

var $9V5k0 = parcelRequire("9V5k0");

var $lmBAt = parcelRequire("lmBAt");

var $1jxD5 = parcelRequire("1jxD5");

var $4xgA9 = parcelRequire("4xgA9");

var $9u12M = parcelRequire("9u12M");

var $3NItL = parcelRequire("3NItL");
/**
 * @deprecated delete when cleaning up blu-5799-jira-software-board-entrypoint-route
 */ const $80af0d16c3f293f2$var$getHorizontalNavResources = ()=>(0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route') ? [] : [
        (0, $7uLIV.horizontalNavJiraResource)
    ];
const $80af0d16c3f293f2$export$568101ebd359b606 = (0, $7NszV.createEntry)((0, $2H7GR.classicSoftwareBacklogRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-backlog',
        component: (0, $16Z5s.RapidBoardSpaPage),
        skeleton: (0, $i8JTM.NextGenBacklogSkeleton),
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental-backlog'),
        layout: (0, $aPfsS.composeLayouts)((0, $gyYxw.genericProjectLayout), (0, $g5RGc.pageLoadIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ], 'SIDEBAR')),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.ForPaintClassicSoftwareProjectSidebar),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true,
            sidebarId: (0, $4R6GH.fg)('blu-7261-change-blu-5799-to-support-nav3') ? (0, $lmyls.SIDEBAR_ID).CONTENT : undefined
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)({
                isUsingSidebarEntrypoint: // eslint-disable-next-line jira/ff/no-preconditioning
                ((0, $4R6GH.fg)('blu-7261-change-blu-5799-to-support-nav3') || (0, $3HwlS.getWillShowNav4)()) && (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route') && (0, $4R6GH.fg)('jfp-magma-fix-nav4-sidebar-client-api-call')
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // delete when cleaning up blu-5799-jira-software-board-entrypoint-route
            ...$80af0d16c3f293f2$var$getHorizontalNavResources(),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getUIFBacklogDataResource)(),
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            (0, $lJ1FP.getEditModelResource)(),
            (0, $lfnsv.getBoardDetailsResource)(),
            (0, $5bkvv.forgeBacklogModuleResource),
            (0, $5bkvv.forgeSprintModuleResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource)),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('crocs-load_ai_enablement_in_backlog_router'), (0, $1jxD5.aiEntitlementResource))
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3NItL.LazyBacklogPage)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-cmp-backlog-early-entry'
            ]
        },
        meta: {
            capability: (0, $9u12M.classicBacklogCapability)
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-classic-backlog-entries/src/classicSoftwareBacklogRouteEntry.tsx',
                whichExportToUse: 'classicSoftwareBacklogRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-software-backlog.json'
        },
        entryPoint: ()=>((0, $4R6GH.fg)('blu-7261-change-blu-5799-to-support-nav3') || (0, $3HwlS.getWillShowNav4)()) && (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route') ? (0, $4xgA9.classicBacklogPageEntryPoint) : undefined
    }));

});
parcelRegister("2H7GR", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBacklogRoute", () => $fe6107d28b9a7842$export$9bfa3c0dded1688f);
const $fe6107d28b9a7842$export$9bfa3c0dded1688f = {
    name: 'rapidboard-backlog',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog'
};

});

parcelRegister("4xgA9", function(module, exports) {

$parcel$export(module.exports, "classicBacklogPageEntryPoint", () => $0d6e17d6eb5b0d6b$export$e07cd4fec395c8db);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $6avBT = parcelRequire("6avBT");

var $dwZUI = parcelRequire("dwZUI");

var $fT58V = parcelRequire("fT58V");

var $krpZe = parcelRequire("krpZe");

var $fo6b8 = parcelRequire("fo6b8");
const $0d6e17d6eb5b0d6b$export$e07cd4fec395c8db = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $6avBT.nextGenBacklogEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $fT58V.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $krpZe.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $dwZUI.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});

parcelRegister("9u12M", function(module, exports) {

$parcel$export(module.exports, "classicBacklogCapability", () => $552e03b9f8528211$export$10a7bb102137d92b);

const $552e03b9f8528211$export$10a7bb102137d92b = !false ? (0, $281cbd47ba46dd7d$export$571692eec8a399e1) : (0, $281cbd47ba46dd7d$export$93104dc4eba58ba4);

});

parcelRegister("3NItL", function(module, exports) {

$parcel$export(module.exports, "LazyBacklogPage", () => $bc74f9ecc918272d$export$edb4b8cf67d7d767);

var $kxZPA = parcelRequire("kxZPA");

var $7yO8g = parcelRequire("7yO8g");

const $bc74f9ecc918272d$export$edb4b8cf67d7d767 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("l95JT"))), {
    moduleId: "./src/packages/spa-apps/next-gen-backlog/src/index.tsx"
});

});


parcelRegister("2XQq2", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBacklogEmbedRouteEntry", () => $f735d13d6cf6b150$export$1a7368427cd23b33);

var $7NszV = parcelRequire("7NszV");

var $iGbXw = parcelRequire("iGbXw");

var $4R6GH = parcelRequire("4R6GH");

var $16Z5s = parcelRequire("16Z5s");

var $6e4Kt = parcelRequire("6e4Kt");

var $f5kpo = parcelRequire("f5kpo");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $lJ1FP = parcelRequire("lJ1FP");

var $lfnsv = parcelRequire("lfnsv");

var $2Ql51 = parcelRequire("2Ql51");

var $fKmub = parcelRequire("fKmub");

var $e2ctp = parcelRequire("e2ctp");

var $3RJkv = parcelRequire("3RJkv");

var $1jxD5 = parcelRequire("1jxD5");

var $gNStA = parcelRequire("gNStA");

var $3NItL = parcelRequire("3NItL");

var $9u12M = parcelRequire("9u12M");
const $f735d13d6cf6b150$export$1a7368427cd23b33 = (0, $7NszV.createEntry)((0, $iGbXw.classicSoftwareBacklogEmbedRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-backlog-embed',
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental-backlog'),
        component: (0, $16Z5s.RapidBoardSpaPage),
        layout: (0, $6e4Kt.chromelessLayout),
        resources: [
            ...(0, $f5kpo.getUIFBacklogDataResource)(),
            ...(0, $f5kpo.getRapidboardResources)(),
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $f5kpo.getRapidBoardDataResource)(),
            (0, $lJ1FP.getEditModelResource)(),
            (0, $lfnsv.getBoardDetailsResource)(),
            (0, $5bkvv.forgeBacklogModuleResource),
            (0, $5bkvv.forgeSprintModuleResource),
            (0, $2Ql51.themePreferenceResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $4R6GH.fg)('crocs-load_ai_enablement_in_backlog_router'), (0, $1jxD5.aiEntitlementResource))
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $3NItL.LazyBacklogPage)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-cmp-backlog-early-entry'
            ]
        },
        meta: {
            capability: (0, $9u12M.classicBacklogCapability)
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("iGbXw", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBacklogEmbedRoute", () => $100ce1fd940d8aba$export$e6776ef8123b7136);
const $100ce1fd940d8aba$export$e6776ef8123b7136 = {
    name: 'rapidboard-backlog-embed',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog/embed'
};

});


parcelRegister("4t69d", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardRouteEntry", () => $d579a749ad862761$export$f2cd114cf8ab53aa);

var $c04PQ = parcelRequire("c04PQ");

var $ffza4 = parcelRequire("ffza4");

var $e2ctp = parcelRequire("e2ctp");

var $4R6GH = parcelRequire("4R6GH");

var $gyYxw = parcelRequire("gyYxw");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $lfnsv = parcelRequire("lfnsv");

var $lJ1FP = parcelRequire("lJ1FP");

var $f5kpo = parcelRequire("f5kpo");

var $3RJkv = parcelRequire("3RJkv");

var $ipmBb = parcelRequire("ipmBb");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $f7Y15 = parcelRequire("f7Y15");

var $gNStA = parcelRequire("gNStA");

var $lB6pS = parcelRequire("lB6pS");

var $16Z5s = parcelRequire("16Z5s");

var $edJtc = parcelRequire("edJtc");

var $dEJQ9 = parcelRequire("dEJQ9");

var $hWAe2 = parcelRequire("hWAe2");

var $5f2bR = parcelRequire("5f2bR");

var $9V5k0 = parcelRequire("9V5k0");

var $3HwlS = parcelRequire("3HwlS");

var $lmBAt = parcelRequire("lmBAt");

var $5QYL3 = parcelRequire("5QYL3");

var $aSO4t = parcelRequire("aSO4t");
/**
 * Ordinarily it would be inadvisable to evaluate something like this in
 * a static route, as this could lead to inconsistent behaviour between
 * the server and the browser.
 *
 * In this case it is necessary and safe because:
 * 1) There are two versions of the board that share the same route
 *    and we can only tell them apart at runtime. When the old version
 *    is eventually removed, this should be cleaned up.
 * 2) No requests for board data are made on the server, so even
 *    if the value is incorrect on the server it won't be utilised
 * */ const $d579a749ad862761$var$getLayout = ()=>{
    let viewMode = 'DEFAULT';
    if ((0, $dEJQ9.isLocalStorageAvailable)()) viewMode = (0, $edJtc.getViewModeFromLocalStorage)();
    return (0, $aPfsS.composeLayouts)((0, $gyYxw.genericProjectLayout), (0, $g5RGc.pageLoadIssuePreloadLayoutBuilder)([
        {
            query: [
                'selectedIssue'
            ]
        }
    ], viewMode));
};
/**
 * @deprecated delete when cleaning up blu-5799-jira-software-board-entrypoint-route
 */ const $d579a749ad862761$var$getHorizontalNavResources = ()=>(0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route') ? [] : [
        (0, $7uLIV.horizontalNavJiraResource)
    ];
const $d579a749ad862761$export$f2cd114cf8ab53aa = (0, $7NszV.createEntry)((0, $lB6pS.classicSoftwareBoardRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-board',
        component: (0, $16Z5s.RapidBoardSpaPage),
        skeleton: (0, $hWAe2.ClassicBoardSkeleton),
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental-board'),
        layout: $d579a749ad862761$var$getLayout(),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.ForPaintClassicSoftwareProjectSidebar),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true,
            sidebarId: (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route') ? (0, $lmyls.SIDEBAR_ID).CONTENT : undefined
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)({
                isUsingSidebarEntrypoint: // eslint-disable-next-line jira/ff/no-preconditioning
                ((0, $4R6GH.fg)('blu-7261-change-blu-5799-to-support-nav3') || (0, $3HwlS.getWillShowNav4)()) && (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route') && (0, $4R6GH.fg)('jfp-magma-fix-nav4-sidebar-client-api-call')
            }),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // delete when cleaning up blu-5799-jira-software-board-entrypoint-route
            ...$d579a749ad862761$var$getHorizontalNavResources(),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            (0, $gNStA.resourceWithCondition2)((0, $f5kpo.shouldLoadUIFBoardResources), (0, $f7Y15.uifBoardResource)),
            // Load the NBT resource if we opt-in UIF, not fedRamp is enabled
            (0, $gNStA.resourceWithCondition2)(()=>(0, $f5kpo.shouldLoadUIFBoardResources)() && !(0, $c04PQ.isFedRamp)(), (0, $ipmBb.nextBestTaskFeatureResource)),
            (0, $lJ1FP.getEditModelResource)(),
            (0, $lfnsv.getBoardDetailsResource)(),
            (0, $5bkvv.forgeBoardModuleResource),
            (0, $gNStA.resourceWithCondition2)(()=>(0, $lmBAt.getIsSoftwareThemingEnabled)(), (0, $9V5k0.projectThemeResource))
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $16Z5s.UIFBoardSpa)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-cmp-board-early-entry'
            ]
        },
        meta: {
            capability: (0, $5QYL3.classicBoardCapability)
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-software-classic-board-entries/src/classicSoftwareBoardRouteEntry.tsx',
                whichExportToUse: 'classicSoftwareBoardRouteEntry'
            },
            enabled: true,
            manifestName: 'jira-spa-software-board.json'
        },
        entryPoint: ()=>((0, $4R6GH.fg)('blu-7261-change-blu-5799-to-support-nav3') || (0, $3HwlS.getWillShowNav4)()) && (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route') ? (0, $aSO4t.classicBoardPageEntryPoint) : undefined
    }));

});
parcelRegister("5QYL3", function(module, exports) {

$parcel$export(module.exports, "classicBoardCapability", () => $72ffa11e3a10b500$export$a6d9a03b76d2193b);

const $72ffa11e3a10b500$export$a6d9a03b76d2193b = !false ? (0, $281cbd47ba46dd7d$export$664edf77d4c76110) : (0, $281cbd47ba46dd7d$export$fc5f182fc9019b1c);

});

parcelRegister("aSO4t", function(module, exports) {

$parcel$export(module.exports, "classicBoardPageEntryPoint", () => $4fe96d7ad77574d7$export$b7ca8af848cd7993);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $7rNZV = parcelRequire("7rNZV");

var $dwZUI = parcelRequire("dwZUI");

var $fT58V = parcelRequire("fT58V");

var $krpZe = parcelRequire("krpZe");

var $fo6b8 = parcelRequire("fo6b8");
const $4fe96d7ad77574d7$export$b7ca8af848cd7993 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7rNZV.nextGenBoardEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    leftSidebar: {
        sidebar: (0, $fT58V.nav4SidebarContentCoreEntryPoint),
        entryPoints: {
            projects: {
                entryPoint: (0, $krpZe.nav4ProjectsContentEntryPoint)
            },
            boards: {
                entryPoint: (0, $dwZUI.nav4JSWProjectEntryPoint)
            }
        },
        isProjectsExpanded: true
    },
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});


parcelRegister("e1cjg", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardEmbedRouteEntry", () => $eac56df495f9e28b$export$b5558b683e9c45a4);

var $c04PQ = parcelRequire("c04PQ");

var $4R6GH = parcelRequire("4R6GH");

var $fKmub = parcelRequire("fKmub");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $7NszV = parcelRequire("7NszV");

var $lfnsv = parcelRequire("lfnsv");

var $lJ1FP = parcelRequire("lJ1FP");

var $f5kpo = parcelRequire("f5kpo");

var $3RJkv = parcelRequire("3RJkv");

var $ipmBb = parcelRequire("ipmBb");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $2Ql51 = parcelRequire("2Ql51");

var $f7Y15 = parcelRequire("f7Y15");

var $gNStA = parcelRequire("gNStA");

var $fEr2a = parcelRequire("fEr2a");

var $16Z5s = parcelRequire("16Z5s");

var $aPfsS = parcelRequire("aPfsS");

var $5QYL3 = parcelRequire("5QYL3");
const $eac56df495f9e28b$export$b5558b683e9c45a4 = (0, $7NszV.createEntry)((0, $fEr2a.classicSoftwareBoardEmbedRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-board-embed',
        component: (0, $16Z5s.RapidBoardSpaPage),
        shouldOptOutConcurrentMode: (0, $4R6GH.fg)('jira-concurrent-incremental-board'),
        layout: (0, $aPfsS.createLayout)({
            isChromeless: true
        }),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            (0, $gNStA.resourceWithCondition2)((0, $f5kpo.shouldLoadUIFBoardResources), (0, $f7Y15.uifBoardResource)),
            // Load the NBT resource if we opt-in UIF, not fedRamp is enabled
            (0, $gNStA.resourceWithCondition2)(()=>(0, $f5kpo.shouldLoadUIFBoardResources)() && !(0, $c04PQ.isFedRamp)(), (0, $ipmBb.nextBestTaskFeatureResource)),
            (0, $lJ1FP.getEditModelResource)(),
            (0, $lfnsv.getBoardDetailsResource)(),
            (0, $2Ql51.themePreferenceResource),
            (0, $5bkvv.forgeBoardModuleResource)
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $16Z5s.UIFBoardSpa)
        ],
        meta: {
            capability: (0, $5QYL3.classicBoardCapability)
        }
    }));

});
parcelRegister("fEr2a", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardEmbedRoute", () => $4d20da2caca0ff94$export$122afcef7dfd252);
const $4d20da2caca0ff94$export$122afcef7dfd252 = {
    name: 'rapidboard-board-embed',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/embed'
};

});


parcelRegister("4XUsE", function(module, exports) {

$parcel$export(module.exports, "rapidboardUserBacklogRouteEntry", () => $5ef9e40cccee388d$export$ccde3c1d7a857b27);

var $7NszV = parcelRequire("7NszV");

var $f5kpo = parcelRequire("f5kpo");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $lJ1FP = parcelRequire("lJ1FP");

var $lfnsv = parcelRequire("lfnsv");

var $fKmub = parcelRequire("fKmub");

var $e2ctp = parcelRequire("e2ctp");

var $csqnl = parcelRequire("csqnl");

var $i8JTM = parcelRequire("i8JTM");

var $aPfsS = parcelRequire("aPfsS");

var $gyYxw = parcelRequire("gyYxw");

var $g5RGc = parcelRequire("g5RGc");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $5f2bR = parcelRequire("5f2bR");

var $3RJkv = parcelRequire("3RJkv");

var $7qieH = parcelRequire("7qieH");

var $2h7lp = parcelRequire("2h7lp");
const $5ef9e40cccee388d$export$ccde3c1d7a857b27 = (0, $7NszV.createEntry)((0, $csqnl.rapidboardUserBacklogRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $i8JTM.NextGenBacklogSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $gyYxw.genericProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getUIFBacklogDataResource)(),
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            ...(0, $3RJkv.getUserBoardNavigationResources)(),
            (0, $lJ1FP.getEditModelResource)(),
            (0, $lfnsv.getBoardDetailsResource)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        entryPoint: ()=>(0, $2h7lp.backlogPageEntrypoint),
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: (0, $7qieH.classicBacklogCapability)
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("csqnl", function(module, exports) {

$parcel$export(module.exports, "rapidboardUserBacklogRoute", () => $710a0fc51c857594$export$79c2d9718e914f91);
const $710a0fc51c857594$export$79c2d9718e914f91 = {
    name: 'rapidboard-user-backlog',
    path: '/jira/people/:accountId/boards/:boardId/backlog'
};

});

parcelRegister("7qieH", function(module, exports) {

$parcel$export(module.exports, "classicBacklogCapability", () => $8c35ce65b592afc5$export$10a7bb102137d92b);

const $8c35ce65b592afc5$export$10a7bb102137d92b = !false ? (0, $281cbd47ba46dd7d$export$571692eec8a399e1) : (0, $281cbd47ba46dd7d$export$93104dc4eba58ba4);

});

parcelRegister("2h7lp", function(module, exports) {

$parcel$export(module.exports, "backlogPageEntrypoint", () => $89c165261f1ffe48$export$1ccf08591607897d);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");

var $6avBT = parcelRequire("6avBT");
const $89c165261f1ffe48$export$1ccf08591607897d = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $6avBT.nextGenBacklogEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});


parcelRegister("jqbKy", function(module, exports) {

$parcel$export(module.exports, "userBoardVelocityRouteEntry", () => $7546dfa7baced42b$export$ba0f726701b9e407);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $gyYxw = parcelRequire("gyYxw");

var $9itNB = parcelRequire("9itNB");

var $jD7nj = parcelRequire("jD7nj");
const $7546dfa7baced42b$export$ba0f726701b9e407 = (0, $7NszV.createEntry)((0, $9itNB.userBoardVelocityRoute), ()=>({
        group: 'classic-software',
        ufoName: 'software-reports.velocity-report-cmp',
        component: (0, $jD7nj.default),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getUserBoardNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jD7nj.LazyNextGenVelocityReport)
        ]
    }));

});
parcelRegister("9itNB", function(module, exports) {

$parcel$export(module.exports, "userBoardVelocityRoute", () => $75bc02f5d3dae3fa$export$57431a0e4f3a32e8);
const $75bc02f5d3dae3fa$export$57431a0e4f3a32e8 = {
    name: 'software-reports-velocity-user-board',
    path: '/jira/people/:accountId/boards/:boardId/reports/velocity'
};

});

parcelRegister("jD7nj", function(module, exports) {

$parcel$export(module.exports, "LazyNextGenVelocityReport", () => $e8c07d5c9da9c49a$export$a2ca519c668b2f72);
$parcel$export(module.exports, "default", () => $e8c07d5c9da9c49a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $bzM7d = parcelRequire("bzM7d");

const $e8c07d5c9da9c49a$export$a2ca519c668b2f72 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("dTtei"))), {
    moduleId: "./src/packages/spa-apps/next-gen-reports/velocity/src/index-old.tsx"
});
var /** @deprecated delete file after all usages have been migrated to use entry points */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$e8c07d5c9da9c49a$export$2e2bcd8739ae039 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e8c07d5c9da9c49a$export$a2ca519c668b2f72,
        pageId: `next-gen-reports-velocity-${(0, $bzM7d.getBoardId)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });

});
parcelRegister("dTtei", function(module, exports) {

let $a1d715d063dea9cf$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a1d715d063dea9cf$var$load("ffQaD"),
    $a1d715d063dea9cf$var$load("kvRbA"),
    $a1d715d063dea9cf$var$load("kBBcG")
]).then(()=>parcelRequire('fRLfA'));

});



parcelRegister("e7GI8", function(module, exports) {

$parcel$export(module.exports, "rapidboardUserReportsOverviewRouteEntry", () => $2b4f7b178bf7d762$export$721c38d3152f9625);

var $7NszV = parcelRequire("7NszV");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $8OTYY = parcelRequire("8OTYY");

var $gyYxw = parcelRequire("gyYxw");

var $5f2bR = parcelRequire("5f2bR");

var $lkFvK = parcelRequire("lkFvK");

var $hBv66 = parcelRequire("hBv66");

var $f5kpo = parcelRequire("f5kpo");

var $fo6b8 = parcelRequire("fo6b8");

var $7GnDe = parcelRequire("7GnDe");

var $3RJkv = parcelRequire("3RJkv");

var $fh5Sl = parcelRequire("fh5Sl");
const $2b4f7b178bf7d762$var$reportsOverviewPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $fh5Sl.reportsOverviewPageEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});
const $2b4f7b178bf7d762$export$721c38d3152f9625 = (0, $7NszV.createEntry)((0, $8OTYY.rapidboardUserReportsOverviewRoute), ()=>({
        group: 'classic-software',
        entryPoint () {
            return (0, $4R6GH.fg)('reports-overview-page-migration') ? $2b4f7b178bf7d762$var$reportsOverviewPageEntryPoint : undefined;
        },
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            ...(0, $3RJkv.getUserBoardNavigationResources)(),
            ...(0, $f5kpo.getRapidboardResources)()
        ],
        ufoName: 'reports-overview'
    }));

});
parcelRegister("8OTYY", function(module, exports) {

$parcel$export(module.exports, "rapidboardUserReportsOverviewRoute", () => $bd6a1ad5f3384924$export$6101ec4dca41c740);
const $bd6a1ad5f3384924$export$6101ec4dca41c740 = {
    name: 'rapidboard-user-reports-overview',
    path: '/jira/people/:accountId/boards/:boardId/reports'
};

});


parcelRegister("bbDvZ", function(module, exports) {

$parcel$export(module.exports, "rapidboardUserReportRouteEntry", () => $aba9ebd89ef67057$export$374d78dc1cde7b56);

var $7NszV = parcelRequire("7NszV");

var $f5kpo = parcelRequire("f5kpo");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $fKmub = parcelRequire("fKmub");

var $e2ctp = parcelRequire("e2ctp");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $3RJkv = parcelRequire("3RJkv");

var $jMZEA = parcelRequire("jMZEA");

var $7o1kb = parcelRequire("7o1kb");

var $yxwH0 = parcelRequire("yxwH0");

var $kJSiQ = parcelRequire("kJSiQ");
const $aba9ebd89ef67057$export$374d78dc1cde7b56 = (0, $7NszV.createEntry)((0, $jMZEA.rapidboardUserReportRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $7o1kb.ClassicReportSkeleton),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            ...(0, $yxwH0.getReportsCommonResource)(),
            ...(0, $3RJkv.getUserBoardNavigationResources)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        entryPoint: ()=>(0, $kJSiQ.reportPageEntrypoint),
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("jMZEA", function(module, exports) {

$parcel$export(module.exports, "rapidboardUserReportRoute", () => $2f9ddde12b93dadf$export$7b85bca17717def6);
const $2f9ddde12b93dadf$export$7b85bca17717def6 = {
    name: 'rapidboard-user-report',
    path: '/jira/people/:accountId/boards/:boardId/reports/:chartView'
};

});


parcelRegister("dR9Nr", function(module, exports) {

$parcel$export(module.exports, "userBoardRouteEntry", () => $9a056980ad2b7a75$export$cde4dacc737dc0f1);

var $e2ctp = parcelRequire("e2ctp");

var $gyYxw = parcelRequire("gyYxw");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $lfnsv = parcelRequire("lfnsv");

var $lJ1FP = parcelRequire("lJ1FP");

var $f5kpo = parcelRequire("f5kpo");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $f7Y15 = parcelRequire("f7Y15");

var $gNStA = parcelRequire("gNStA");

var $lyCs2 = parcelRequire("lyCs2");

var $hWAe2 = parcelRequire("hWAe2");

var $5f2bR = parcelRequire("5f2bR");

var $49YhR = parcelRequire("49YhR");
const $9a056980ad2b7a75$export$cde4dacc737dc0f1 = (0, $7NszV.createEntry)((0, $lyCs2.userBoardRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $hWAe2.ClassicBoardSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $gyYxw.genericProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue',
                    'view=detail'
                ]
            },
            {
                query: [
                    'selectedIssue',
                    'modal=detail'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            ...(0, $3RJkv.getUserBoardNavigationResources)(),
            (0, $gNStA.resourceWithCondition2)((0, $f5kpo.shouldLoadUIFBoardResources), (0, $f7Y15.uifBoardResource)),
            (0, $lJ1FP.getEditModelResource)(),
            (0, $lfnsv.getBoardDetailsResource)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-cmp-board-early-entry'
            ]
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        entryPoint: ()=>(0, $49YhR.userBoardPageEntrypoint)
    }));

});
parcelRegister("49YhR", function(module, exports) {

$parcel$export(module.exports, "userBoardPageEntrypoint", () => $a86c946afa6dbbff$export$606f36f7912a11ef);

var $lkFvK = parcelRequire("lkFvK");

var $fo6b8 = parcelRequire("fo6b8");

var $7rNZV = parcelRequire("7rNZV");

var $lmyls = parcelRequire("lmyls");
const $a86c946afa6dbbff$export$606f36f7912a11ef = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7rNZV.nextGenBoardEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});


parcelRegister("goreX", function(module, exports) {

$parcel$export(module.exports, "userBoardSettingsRouteEntry", () => $00cdba91b5f0dbcb$export$f8e56ba3f544195d);

var $gyYxw = parcelRequire("gyYxw");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $7NszV = parcelRequire("7NszV");

var $lfnsv = parcelRequire("lfnsv");

var $lJ1FP = parcelRequire("lJ1FP");

var $f5kpo = parcelRequire("f5kpo");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $f7Y15 = parcelRequire("f7Y15");

var $gNStA = parcelRequire("gNStA");

var $2aqtf = parcelRequire("2aqtf");

var $hWAe2 = parcelRequire("hWAe2");

var $e3Qmo = parcelRequire("e3Qmo");

var $lmyls = parcelRequire("lmyls");

var $4R6GH = parcelRequire("4R6GH");

var $hBv66 = parcelRequire("hBv66");

var $7uLIV = parcelRequire("7uLIV");
const $00cdba91b5f0dbcb$export$f8e56ba3f544195d = (0, $7NszV.createEntry)((0, $2aqtf.userBoardSettingsRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-board',
        skeleton: (0, $hWAe2.ClassicBoardSkeleton),
        entryPoint: ()=>(0, $e3Qmo.boardSettingsPageEntryPoint),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars),
            sidebarId: (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route') ? (0, $lmyls.SIDEBAR_ID).BOARD_SETTINGS : undefined
        },
        layout: (0, $gyYxw.genericProjectLayout),
        // This list is based on the resources needed by ./userBoardRouteEntry.tsx
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            ...(0, $3RJkv.getUserBoardNavigationResources)(),
            (0, $gNStA.resourceWithCondition2)((0, $f5kpo.shouldLoadUIFBoardResources), (0, $f7Y15.uifBoardResource)),
            (0, $lJ1FP.getEditModelResource)(),
            (0, $lfnsv.getBoardDetailsResource)()
        ]
    }));

});
parcelRegister("2aqtf", function(module, exports) {

$parcel$export(module.exports, "userBoardSettingsRoute", () => $439048221d4c78c5$export$a6e04dfbb956c677);
const $439048221d4c78c5$export$a6e04dfbb956c677 = {
    name: 'rapidboard-user-board-settings',
    path: '/jira/people/:accountId/boards/:boardId/settings/:config',
    query: [
        'from-backlog?'
    ]
};

});


parcelRegister("3eN7Y", function(module, exports) {

$parcel$export(module.exports, "userBoardViewNotFoundRouteEntry", () => $6b06d90b3814210b$export$a2bfa34d08651f6d);

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $dxCvy = parcelRequire("dxCvy");

var $3RJkv = parcelRequire("3RJkv");

var $7GnDe = parcelRequire("7GnDe");

var $dnp0v = parcelRequire("dnp0v");

var $5f2bR = parcelRequire("5f2bR");

var $hhqrL = parcelRequire("hhqrL");
const $6b06d90b3814210b$export$a2bfa34d08651f6d = (0, $7NszV.createEntry)((0, $dnp0v.userBoardViewNotFoundRoute), ()=>({
        group: 'classic-software',
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $hhqrL.boardViewNotFoundPageEntrypoint)
    }));

});
parcelRegister("dnp0v", function(module, exports) {

$parcel$export(module.exports, "userBoardViewNotFoundRoute", () => $41341d667544a268$export$ad6b96e14e735ed7);
const $41341d667544a268$export$ad6b96e14e735ed7 = {
    name: 'rapidboard-user-board-view-not-found',
    path: '/jira/people/:accountId/boards/:boardId/not-found'
};

});

parcelRegister("hhqrL", function(module, exports) {

$parcel$export(module.exports, "boardViewNotFoundPageEntrypoint", () => $c49d7c07685117d8$export$7f51979492148d53);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $8cOrT = parcelRequire("8cOrT");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");

const $c49d7c07685117d8$var$main = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("j6L5g")), {
        moduleId: "83a02129",
        moduleName: "BoardViewNotFound"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const boardId = context.match.params.boardId;
        if (boardId == null) throw new Error('Board id missing');
        return {
            queries: {
                mainQuery: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $8cOrT.default,
                    variables: {
                        boardId: `ari:cloud:jira-software:${cloudId}:board/${boardId}`
                    }
                }
            }
        };
    }
});
const $c49d7c07685117d8$export$7f51979492148d53 = (0, $lkFvK.createPageEntryPoint)({
    main: $c49d7c07685117d8$var$main,
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("8cOrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9e82953f4eddfcb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<39b4c2382e9edb79ca18ee82cc3dcb5e>>
 * @relayHash c015acb85644d3bee5c8b2cb145b1d66
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 082161233dbd381be9ed014242444b47bd21443811aada3c5cc8c3c2e46e7c51
const $a9e82953f4eddfcb$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "082161233dbd381be9ed014242444b47bd21443811aada3c5cc8c3c2e46e7c51",
        "metadata": {},
        "name": "BoardViewNotFoundQuery",
        "operationKind": "query",
        "text": null
    }
};
var $a9e82953f4eddfcb$export$2e2bcd8739ae039 = $a9e82953f4eddfcb$var$node;

});

parcelRegister("j6L5g", function(module, exports) {

let $de9319c29aedad61$var$load = (parcelRequire("28QjX"))(4);
module.exports = $de9319c29aedad61$var$load("gM5js").then(()=>parcelRequire('bICXK'));

});



parcelRegister("aA0rC", function(module, exports) {

$parcel$export(module.exports, "rapidboardBacklog1RouteEntry", () => $1bf0295d0982658a$export$ee2385c1acba53f2);

var $7NszV = parcelRequire("7NszV");

var $16Z5s = parcelRequire("16Z5s");

var $f5kpo = parcelRequire("f5kpo");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $fKmub = parcelRequire("fKmub");

var $e2ctp = parcelRequire("e2ctp");

var $i8JTM = parcelRequire("i8JTM");

var $aPfsS = parcelRequire("aPfsS");

var $gyYxw = parcelRequire("gyYxw");

var $g5RGc = parcelRequire("g5RGc");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $5f2bR = parcelRequire("5f2bR");

var $3RJkv = parcelRequire("3RJkv");

var $7uLIV = parcelRequire("7uLIV");

var $ffza4 = parcelRequire("ffza4");

var $3Lsjg = parcelRequire("3Lsjg");

const $1bf0295d0982658a$export$ee2385c1acba53f2 = (0, $7NszV.createEntry)((0, $3Lsjg.rapidboardBacklog1Route), ()=>({
        group: 'classic-software',
        ufoName: 'classic-backlog',
        component: (0, $16Z5s.RapidBoardSpaPage),
        skeleton: (0, $i8JTM.NextGenBacklogSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $gyYxw.genericProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue',
                    'view=planning'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            ...(0, $3RJkv.getUserBoardNavigationResources)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $16Z5s.LazyRapidBoard),
            (0, $16Z5s.LazyRapidBoardApps)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$93104dc4eba58ba4)
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("3Lsjg", function(module, exports) {

$parcel$export(module.exports, "rapidboardBacklog1Route", () => $af1c8b7df470b6b1$export$ff874528b0b33a61);
const $af1c8b7df470b6b1$export$ff874528b0b33a61 = {
    name: 'rapidboard-backlog',
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView',
        'view=(planning|planning.nodetail)'
    ]
};

});


parcelRegister("jss6V", function(module, exports) {

$parcel$export(module.exports, "rapidboardReport1RouteEntry", () => $231e2e3fd736b80c$export$7e8c0a9f6d68837);

var $7NszV = parcelRequire("7NszV");

var $16Z5s = parcelRequire("16Z5s");

var $f5kpo = parcelRequire("f5kpo");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $fKmub = parcelRequire("fKmub");

var $e2ctp = parcelRequire("e2ctp");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $3RJkv = parcelRequire("3RJkv");

var $7uLIV = parcelRequire("7uLIV");

var $ffza4 = parcelRequire("ffza4");

var $fIEje = parcelRequire("fIEje");

var $7o1kb = parcelRequire("7o1kb");

var $yxwH0 = parcelRequire("yxwH0");
const $231e2e3fd736b80c$export$7e8c0a9f6d68837 = (0, $7NszV.createEntry)((0, $fIEje.rapidboardReport1Route), ()=>({
        group: 'classic-software',
        component: (0, $16Z5s.RapidBoardSpaPage),
        skeleton: (0, $7o1kb.ClassicReportSkeleton),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            ...(0, $yxwH0.getReportsCommonResource)(),
            ...(0, $3RJkv.getUserBoardNavigationResources)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $16Z5s.LazyRapidBoard),
            (0, $16Z5s.LazyRapidBoardApps)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        ufoName: 'classic-report'
    }));

});
parcelRegister("fIEje", function(module, exports) {

$parcel$export(module.exports, "rapidboardReport1Route", () => $0732a35485277820$export$d27f9ad2fc277ff9);
const $0732a35485277820$export$d27f9ad2fc277ff9 = {
    name: 'rapidboard-report',
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView',
        'view=reporting',
        'chart'
    ]
};

});


parcelRegister("6B4GJ", function(module, exports) {

$parcel$export(module.exports, "softwareCodeClassicRouteEntry", () => $7aa05f37015fe3d2$export$6acfada96c85cfaa);

var $7NszV = parcelRequire("7NszV");

var $7GnDe = parcelRequire("7GnDe");

var $dxCvy = parcelRequire("dxCvy");

var $5bkvv = parcelRequire("5bkvv");

var $iEUaw = parcelRequire("iEUaw");

var $ggg5j = parcelRequire("ggg5j");

var $6zFAI = parcelRequire("6zFAI");

var $lmyls = parcelRequire("lmyls");

var $5f2bR = parcelRequire("5f2bR");

var $3RJkv = parcelRequire("3RJkv");

var $7uLIV = parcelRequire("7uLIV");

var $ffza4 = parcelRequire("ffza4");

var $cu9WL = parcelRequire("cu9WL");

var $iZ82x = parcelRequire("iZ82x");

var $7XYc4 = parcelRequire("7XYc4");

var $kfztd = parcelRequire("kfztd");

var $5lsNZ = parcelRequire("5lsNZ");

var $e7bC3 = parcelRequire("e7bC3");

var $9s3j1 = parcelRequire("9s3j1");

var $4R6GH = parcelRequire("4R6GH");

var $6LsQE = parcelRequire("6LsQE");

var $brJ9B = parcelRequire("brJ9B");

var $6Kmkr = parcelRequire("6Kmkr");
const $7aa05f37015fe3d2$var$getHorizontalNavResource = ()=>(0, $4R6GH.fg)('entrypoint_migration_for_software_code') ? [] : [
        (0, $7uLIV.horizontalNavJiraResource)
    ];
const $7aa05f37015fe3d2$export$6acfada96c85cfaa = (0, $7NszV.createEntry)((0, $cu9WL.softwareCodeClassicRoute), ()=>({
        group: 'classic-software',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            ...$7aa05f37015fe3d2$var$getHorizontalNavResource(),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $iZ82x.codePageResource)
        ],
        component: (0, $7XYc4.componentWithCondition)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $6Kmkr.CodePageClassic)),
        layout: (0, $e7bC3.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6Kmkr.LazyCode)
        ],
        entryPoint: ()=>{
            if ((0, $4R6GH.fg)('entrypoint_migration_for_software_code')) return (0, $kfztd.isDevopsFeatureDisabledInFedRamp)() ? (0, $6LsQE.notFoundPageEntrypoint) : (0, $brJ9B.softwareCodeClassicPageEntrypoint);
            return undefined;
        }
    }));

});
parcelRegister("cu9WL", function(module, exports) {

$parcel$export(module.exports, "softwareCodeClassicRoute", () => $7462b5ebecb54ef7$export$d92cd77785d00ff);
const $7462b5ebecb54ef7$export$d92cd77785d00ff = {
    name: 'software-code-classic',
    path: '/jira/software/c/projects/:projectKey/code'
};

});

parcelRegister("brJ9B", function(module, exports) {

$parcel$export(module.exports, "softwareCodeClassicPageEntrypoint", () => $6049b4a08957accb$export$10463031c8017b);

var $5mvmF = parcelRequire("5mvmF");

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");

var $lkFvK = parcelRequire("lkFvK");
const $6049b4a08957accb$export$10463031c8017b = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $5mvmF.softwareCodeEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});

parcelRegister("6Kmkr", function(module, exports) {

$parcel$export(module.exports, "LazyCode", () => $bd64eb30d91f5f71$export$4beafd9dbad29bff);
$parcel$export(module.exports, "CodePageClassic", () => $bd64eb30d91f5f71$export$95e2389b7ca7ccf2);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $iS0yP = parcelRequire("iS0yP");

const $bd64eb30d91f5f71$export$4beafd9dbad29bff = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("jG7sy"))), {
    moduleId: "./src/packages/spa-apps/code/src/ui/index-old.tsx"
});
const $bd64eb30d91f5f71$export$95e2389b7ca7ccf2 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $bd64eb30d91f5f71$export$4beafd9dbad29bff,
        pageId: `classic-code-${(0, $iS0yP.getBoardId)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });

});
parcelRegister("iS0yP", function(module, exports) {

$parcel$export(module.exports, "getBoardId", () => $12fea879e07c880e$export$557c2f222778cea6);

var $ebyGx = parcelRequire("ebyGx");
const $12fea879e07c880e$export$557c2f222778cea6 = ({ location: location, match: match })=>{
    if (match && match.params.boardId) return match.params.boardId;
    const { rapidView: rapidView } = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(location.search);
    return rapidView;
};

});



parcelRegister("fMbaV", function(module, exports) {

$parcel$export(module.exports, "softwareSecurityClassicRouteEntry", () => $24f436c9befc4f10$export$8acfebad16c9d6f2);

var $e4eHl = parcelRequire("e4eHl");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $en8e6 = parcelRequire("en8e6");

var $g5C5j = parcelRequire("g5C5j");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $6LsQE = parcelRequire("6LsQE");

var $crK2h = parcelRequire("crK2h");

var $7AM4I = parcelRequire("7AM4I");
const $24f436c9befc4f10$export$8acfebad16c9d6f2 = (0, $7NszV.createEntry)((0, $g5C5j.softwareSecurityClassicRoute), ()=>({
        group: 'classic-software',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource),
            (0, $en8e6.securityPageResource)
        ],
        ufoName: 'software-security-combined',
        layout: (0, $e7bC3.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        meta: {
            reporting: {
                id: 'software-security-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-security-classic'),
                teamName: 'fusion-isotopes'
            }
        },
        entryPoint: ()=>(0, $crK2h.isSecurityPageEnabled)() ? (0, $7AM4I.securityPageEntrypoint) : (0, $6LsQE.notFoundPageEntrypoint)
    }));

});
parcelRegister("g5C5j", function(module, exports) {

$parcel$export(module.exports, "softwareSecurityClassicRoute", () => $c527ab87b834a4bd$export$b7285748f1151353);
const $c527ab87b834a4bd$export$b7285748f1151353 = {
    name: 'software-security-classic',
    path: '/jira/software/c/projects/:projectKey/security'
};

});


parcelRegister("bi9fZ", function(module, exports) {

$parcel$export(module.exports, "softwareDeploymentsClassicRouteEntry", () => $3da78177932dfa66$export$dcf1f9ba660dedf6);

var $e4eHl = parcelRequire("e4eHl");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $b4koY = parcelRequire("b4koY");

var $7GnDe = parcelRequire("7GnDe");

var $lKmRI = parcelRequire("lKmRI");

var $kfztd = parcelRequire("kfztd");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $6LsQE = parcelRequire("6LsQE");

var $jBfl2 = parcelRequire("jBfl2");
const $3da78177932dfa66$export$dcf1f9ba660dedf6 = (0, $7NszV.createEntry)((0, $lKmRI.softwareDeploymentsClassicRoute), ()=>({
        group: 'classic-software',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $b4koY.deploymentPreconditionRelayResource),
            (0, $dxCvy.projectContextResource)
        ],
        layout: (0, $e7bC3.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        entryPoint: ()=>(0, $kfztd.isDevopsFeatureDisabledInFedRamp)() ? (0, $6LsQE.notFoundPageEntrypoint) : (0, $jBfl2.softwareDeploymentsPageEntrypoint),
        meta: {
            reporting: {
                id: 'software-deployments-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-deployments-classic'),
                teamName: 'fusion-solaris'
            }
        }
    }));

});
parcelRegister("lKmRI", function(module, exports) {

$parcel$export(module.exports, "softwareDeploymentsClassicRoute", () => $d186f38c5f1ffe01$export$485e4a7b82f29d70);
const $d186f38c5f1ffe01$export$485e4a7b82f29d70 = {
    name: 'software-deployments-classic',
    path: '/jira/software/c/projects/:projectKey/deployments'
};

});


parcelRegister("7Db7a", function(module, exports) {

$parcel$export(module.exports, "softwarePeriscopeClassicRouteEntry", () => $12f7aae3d37ddd7e$export$d7d49c1a51b3c0a9);

var $e4eHl = parcelRequire("e4eHl");

var $c04PQ = parcelRequire("c04PQ");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $ajKFd = parcelRequire("ajKFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $dOiL8 = parcelRequire("dOiL8");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $6LsQE = parcelRequire("6LsQE");

var $kkNtb = parcelRequire("kkNtb");

var $iXbZm = parcelRequire("iXbZm");
const $12f7aae3d37ddd7e$export$d7d49c1a51b3c0a9 = (0, $7NszV.createEntry)((0, $dOiL8.softwarePeriscopeClassicRoute), ()=>({
        group: 'classic-software',
        skeleton: (0, $ajKFd.Skeleton),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource),
            (0, $kkNtb.rovoEntitlementResource)
        ],
        layout: (0, $e7bC3.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        entryPoint: ()=>{
            return (0, $c04PQ.isFedRamp)() ? (0, $6LsQE.notFoundPageEntrypoint) : (0, $iXbZm.periscopeEntryPoint);
        },
        meta: {
            reporting: {
                id: 'software-periscope-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-periscope-classic'),
                teamName: 'nova'
            }
        }
    }));

});
parcelRegister("dOiL8", function(module, exports) {

$parcel$export(module.exports, "softwarePeriscopeClassicRoute", () => $6b68b587bba860e4$export$cb5cec74f302b3c6);
const $6b68b587bba860e4$export$cb5cec74f302b3c6 = {
    name: 'software-periscope-classic',
    path: '/jira/software/c/projects/:projectKey/development'
};

});


parcelRegister("hjVS0", function(module, exports) {

$parcel$export(module.exports, "rapidboardLastVisitedProjectRedirectRouteEntry", () => $09ab131c9331c58d$export$420f86cfd239da4d);

var $7NszV = parcelRequire("7NszV");

var $gyYxw = parcelRequire("gyYxw");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $5f2bR = parcelRequire("5f2bR");

var $3RJkv = parcelRequire("3RJkv");

var $ffza4 = parcelRequire("ffza4");

var $Th6Kd = parcelRequire("Th6Kd");

var $7MCPm = parcelRequire("7MCPm");
const $09ab131c9331c58d$export$420f86cfd239da4d = (0, $7NszV.createEntry)((0, $Th6Kd.rapidboardLastVisitedProjectRedirectRoute), ()=>({
        group: 'classic-software',
        component: (0, $7MCPm.RedirectToLastVisitedProjectPage),
        layout: (0, $gyYxw.genericProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        isRedirect: true,
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("Th6Kd", function(module, exports) {

$parcel$export(module.exports, "rapidboardLastVisitedProjectRedirectRoute", () => $848732acccd8706d$export$991b1be164057e91);
const $848732acccd8706d$export$991b1be164057e91 = {
    name: 'rapidboard-last-visited-project-redirect',
    path: '/secure/RapidBoard.jspa',
    query: [
        'projectKey'
    ],
    __unsafeOrder: 1
};

});


parcelRegister("aAF0I", function(module, exports) {

$parcel$export(module.exports, "projectDirectoryRedirectRouteEntry", () => $a32e24e3142418a0$export$f1f04e35fd5f4283);

var $5uXOq = parcelRequire("5uXOq");

var $7NszV = parcelRequire("7NszV");

var $lmyls = parcelRequire("lmyls");

var $3RJkv = parcelRequire("3RJkv");

var $ffza4 = parcelRequire("ffza4");

var $3JE1m = parcelRequire("3JE1m");

var $ds5qV = parcelRequire("ds5qV");

var $2BrOV = parcelRequire("2BrOV");
const $a32e24e3142418a0$var$ProjectsDirectoryRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: "/jira/projects"
    });
const $a32e24e3142418a0$export$f1f04e35fd5f4283 = (0, $7NszV.createEntry)((0, $3JE1m.projectDirectoryRedirectRoute), ()=>({
        group: 'classic-software',
        component: $a32e24e3142418a0$var$ProjectsDirectoryRedirect,
        layout: (0, $2BrOV.globalLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS
        },
        isRedirect: true,
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("3JE1m", function(module, exports) {

$parcel$export(module.exports, "projectDirectoryRedirectRoute", () => $0939314fcba99a8c$export$3913c8bee519225c);
const $0939314fcba99a8c$export$3913c8bee519225c = {
    name: 'project-directory-redirect',
    path: '/secure/RapidBoard.jspa'
};

});


parcelRegister("4Mj46", function(module, exports) {

$parcel$export(module.exports, "softwareIncidentsClassicRouteEntry", () => $dedf0d7500ec9709$export$c7d98bfe75274932);

var $e4eHl = parcelRequire("e4eHl");

var $4R6GH = parcelRequire("4R6GH");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $eIvCa = parcelRequire("eIvCa");

var $9LHPC = parcelRequire("9LHPC");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $hb1PV = parcelRequire("hb1PV");

var $BrpCW = parcelRequire("BrpCW");
const $dedf0d7500ec9709$export$c7d98bfe75274932 = (0, $7NszV.createEntry)((0, $eIvCa.softwareIncidentsClassicRoute), ()=>({
        group: 'classic-software',
        entryPoint () {
            return (0, $4R6GH.fg)('corex_operandi_incidents_page_in_jira') ? (0, $hb1PV.entryPoint) : (0, $BrpCW.entryPointDeprecated);
        },
        layout: (0, $e7bC3.classicSoftwareProjectLayout),
        skeleton: (0, $9LHPC.IncidentsPageSkeleton),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $dxCvy.projectContextResource),
            (0, $7GnDe.incidentsInitialPageChecksResource),
            (0, $7GnDe.incidentsCustomFieldIdResource)
        ],
        meta: {
            reporting: {
                id: 'software-incidents-classic',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('software-incidents-classic'),
                teamName: 'operandi'
            }
        },
        ufoName: 'software-incidents'
    }));

});
parcelRegister("eIvCa", function(module, exports) {

$parcel$export(module.exports, "softwareIncidentsClassicRoute", () => $a586f286b7619cb0$export$3356a7870a2717f4);
const $a586f286b7619cb0$export$3356a7870a2717f4 = {
    name: 'software-incidents-classic',
    path: '/jira/software/c/projects/:projectKey/incidents'
};

});


parcelRegister("3I1TD", function(module, exports) {

$parcel$export(module.exports, "softwareViewNotFoundRouteEntry", () => $4bb0af0452a6f272$export$7dab5fe9ccb76142);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $l0Xu9 = parcelRequire("l0Xu9");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $1g8oF = parcelRequire("1g8oF");
const $4bb0af0452a6f272$export$7dab5fe9ccb76142 = (0, $7NszV.createEntry)((0, $l0Xu9.softwareViewNotFoundRoute), ()=>({
        group: 'software',
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $1g8oF.projectViewNotFoundPageEntrypoint)
    }));

});
parcelRegister("l0Xu9", function(module, exports) {

$parcel$export(module.exports, "softwareViewNotFoundRoute", () => $649408f22dcc013c$export$d72ea457f192511a);
const $649408f22dcc013c$export$d72ea457f192511a = {
    name: 'software-view-not-found',
    exact: true,
    path: '/jira/software/projects/:projectKey/not-found'
};

});


parcelRegister("41tjC", function(module, exports) {

$parcel$export(module.exports, "softwareViewNotFoundClassicRouteEntry", () => $96e70f692796dc17$export$191700cbad42b1f0);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $lkW1m = parcelRequire("lkW1m");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $1g8oF = parcelRequire("1g8oF");
const $96e70f692796dc17$export$191700cbad42b1f0 = (0, $7NszV.createEntry)((0, $lkW1m.softwareViewNotFoundClassicRoute), ()=>({
        group: 'software',
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $1g8oF.projectViewNotFoundPageEntrypoint)
    }));

});
parcelRegister("lkW1m", function(module, exports) {

$parcel$export(module.exports, "softwareViewNotFoundClassicRoute", () => $6d8d781058e4749c$export$7d9d54603ab2405d);
const $6d8d781058e4749c$export$7d9d54603ab2405d = {
    name: 'software-view-not-found-classic',
    exact: true,
    path: '/jira/software/c/projects/:projectKey/not-found'
};

});


parcelRegister("eAw5v", function(module, exports) {

$parcel$export(module.exports, "softwareBoardViewNotFoundRouteEntry", () => $ed8d1bfb27dbc181$export$70fda0ba037c81ca);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $aqDWp = parcelRequire("aqDWp");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $hhqrL = parcelRequire("hhqrL");
const $ed8d1bfb27dbc181$export$70fda0ba037c81ca = (0, $7NszV.createEntry)((0, $aqDWp.softwareBoardViewNotFoundRoute), ()=>({
        group: 'software',
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $hhqrL.boardViewNotFoundPageEntrypoint)
    }));

});
parcelRegister("aqDWp", function(module, exports) {

$parcel$export(module.exports, "softwareBoardViewNotFoundRoute", () => $d9228dcc50b0d701$export$4c5eaffb9e70d071);
const $d9228dcc50b0d701$export$4c5eaffb9e70d071 = {
    name: 'software-board-view-not-found',
    exact: true,
    path: '/jira/software/projects/:projectKey/boards/:boardId/not-found'
};

});


parcelRegister("wwgc5", function(module, exports) {

$parcel$export(module.exports, "softwareBoardViewNotFoundClassicRouteEntry", () => $58fb43be4cabcab8$export$bdd0e204be6866cd);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $4mEI2 = parcelRequire("4mEI2");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $hhqrL = parcelRequire("hhqrL");
const $58fb43be4cabcab8$export$bdd0e204be6866cd = (0, $7NszV.createEntry)((0, $4mEI2.softwareBoardViewNotFoundClassicRoute), ()=>({
        group: 'software',
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource)
        ],
        entryPoint: ()=>(0, $hhqrL.boardViewNotFoundPageEntrypoint)
    }));

});
parcelRegister("4mEI2", function(module, exports) {

$parcel$export(module.exports, "softwareBoardViewNotFoundClassicRoute", () => $09300f0330e984d8$export$b31cf885abe93fbf);
const $09300f0330e984d8$export$b31cf885abe93fbf = {
    name: 'software-board-view-not-found-classic',
    exact: true,
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/not-found'
};

});


parcelRegister("iz3gR", function(module, exports) {

$parcel$export(module.exports, "legacyRapidBoardRouteEntry", () => $bc93178a086d6ff3$export$4a5b9e48e40676ad);

var $ffza4 = parcelRequire("ffza4");


var $e2ctp = parcelRequire("e2ctp");

var $gyYxw = parcelRequire("gyYxw");

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $7uLIV = parcelRequire("7uLIV");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $f5kpo = parcelRequire("f5kpo");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $kNWOS = parcelRequire("kNWOS");

var $16Z5s = parcelRequire("16Z5s");

var $hWAe2 = parcelRequire("hWAe2");

var $5f2bR = parcelRequire("5f2bR");
const $bc93178a086d6ff3$export$4a5b9e48e40676ad = (0, $7NszV.createEntry)((0, $kNWOS.legacyRapidBoardRoute), ()=>({
        group: 'classic-software',
        ufoName: 'classic-board',
        component: (0, $16Z5s.RapidBoardSpaPage),
        skeleton: (0, $hWAe2.ClassicBoardSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $gyYxw.genericProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue',
                    'view=detail'
                ]
            },
            {
                query: [
                    'selectedIssue',
                    'modal=detail'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.classicBoardSidebars),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7uLIV.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $f5kpo.getRapidboardResources)(),
            (0, $f5kpo.getRapidBoardDataResource)(),
            ...(0, $3RJkv.getUserBoardNavigationResources)()
        ],
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $16Z5s.LazyRapidBoard),
            (0, $16Z5s.LazyRapidBoardApps)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$fc5f182fc9019b1c)
        },
        earlyAssets: (0, $e2ctp.AGGRESSIVE_EARLY_ASSET_STRATEGY)
    }));

});
parcelRegister("kNWOS", function(module, exports) {

$parcel$export(module.exports, "legacyRapidBoardRoute", () => $454db19224248ed1$export$2bc0c59cefa2bd5e);
const $454db19224248ed1$export$2bc0c59cefa2bd5e = {
    name: 'rapidboard-board',
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView'
    ],
    __unsafeOrder: -1
};

});


parcelRegister("icwb1", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAccessRedirectRouteEntry", () => $b190785db05a7599$export$36e1851c22975fc0);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $jtZ32 = parcelRequire("jtZ32");

var $7tQej = parcelRequire("7tQej");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

var $8sFwL = parcelRequire("8sFwL");
const $b190785db05a7599$export$36e1851c22975fc0 = (0, $7NszV.createEntry)((0, $jtZ32.projectSettingsCoreAccessRedirectRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
                to: `/jira/core/projects/${String(match.params.projectKey)}/settings/access`,
                push: false
            }),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8sFwL.LazyPeopleSettings)
        ]
    }));

});
parcelRegister("jtZ32", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAccessRedirectRoute", () => $cb26bde1d38666aa$export$59e3323ba0cc224a);
const $cb26bde1d38666aa$export$59e3323ba0cc224a = {
    name: 'project-settings-core-access-redirect',
    path: '/jira/core/projects/:projectKey/settings/people',
    exact: true
};

});

parcelRegister("gTwsg", function(module, exports) {

$parcel$export(module.exports, "getNavigationSidebarProjectSettingsResource", () => $0cec9bd54a67f5ed$export$808691f5a412afa3);

var $5bkvv = parcelRequire("5bkvv");

var $loy04 = parcelRequire("loy04");

var $kJQXA = parcelRequire("kJQXA");

var $eOlBz = parcelRequire("eOlBz");

var $dxCvy = parcelRequire("dxCvy");
const $0cec9bd54a67f5ed$export$808691f5a412afa3 = ()=>[
        (0, $eOlBz.newIssueViewTransitionLockInStatusResource),
        (0, $kJQXA.navigationSidebarAutomationLegacyEnabledResource),
        (0, $dxCvy.projectContextResourceWithCache),
        (0, $5bkvv.forgeProjectSettingsModuleResource),
        (0, $loy04.staticProjectSettingsSidebarConnectAddonsNavigationResource)
    ];

});

parcelRegister("8sFwL", function(module, exports) {

$parcel$export(module.exports, "LazyPeopleSettings", () => $8dc1ced653e243b7$export$7eee4f97b7a1273);

var $7yO8g = parcelRequire("7yO8g");

var $kxZPA = parcelRequire("kxZPA");

const $8dc1ced653e243b7$export$7eee4f97b7a1273 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("8pwbR"))), {
    moduleId: "./src/packages/spa-apps/project-settings/people/src/index.tsx"
});

});
parcelRegister("8pwbR", function(module, exports) {

let $61f9a0e0c3257818$var$load = (parcelRequire("28QjX"))(4);
module.exports = $61f9a0e0c3257818$var$load("g4hzh").then(()=>parcelRequire('7N8D9'));

});



parcelRegister("egxSq", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAccessRouteEntry", () => $c0cf9eb9a1189c3e$export$8188648c76953df0);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $l2Ko4 = parcelRequire("l2Ko4");

var $jaAyo = parcelRequire("jaAyo");

var $5j7Th = parcelRequire("5j7Th");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

var $8sFwL = parcelRequire("8sFwL");
const $c0cf9eb9a1189c3e$var$Access = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: (0, $8sFwL.LazyPeopleSettings),
        pageId: "project-settings-people",
        shouldShowSpinner: false
    });
const $c0cf9eb9a1189c3e$export$8188648c76953df0 = (0, $7NszV.createEntry)((0, $l2Ko4.projectSettingsCoreAccessRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $c0cf9eb9a1189c3e$var$Access,
        skeleton: (0, $jaAyo.ProjectSettingsAccessSkeleton),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8sFwL.LazyPeopleSettings)
        ],
        ufoName: 'project-settings.access'
    }));

});
parcelRegister("l2Ko4", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAccessRoute", () => $213a8c0a4e177f13$export$fe93051d5b7385a1);
const $213a8c0a4e177f13$export$fe93051d5b7385a1 = {
    name: 'project-settings-core-access',
    path: '/jira/core/projects/:projectKey/settings/access',
    exact: true
};

});

parcelRegister("jaAyo", function(module, exports) {

$parcel$export(module.exports, "ProjectSettingsAccessSkeleton", () => $e950186edd3e49fd$export$e6cc5ccd52c7fd63);
$parcel$export(module.exports, "ProjectSettingsDetailsSkeleton", () => $e950186edd3e49fd$export$bd7fd4005b84aec9);
$parcel$export(module.exports, "ProjectSettingsFeaturesSkeleton", () => $e950186edd3e49fd$export$ec1cdd0c8335373c);
/* ProjectSettingsFeaturesSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $4C3Cb = parcelRequire("4C3Cb");

var $fU8cb = parcelRequire("fU8cb");

var $8n9dD = parcelRequire("8n9dD");
const $e950186edd3e49fd$var$customCssStyles = null;
const $e950186edd3e49fd$var$listOnlyStyles = null;
const $e950186edd3e49fd$export$e6cc5ccd52c7fd63 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4C3Cb))),
        className: (0, $bwpsq.default)([
            "_19pkze3t _2hwx1wug _otyrze3t _18u01wug _p12f1qe4 _11y7oza4"
        ])
    });
const $e950186edd3e49fd$export$bd7fd4005b84aec9 = ({ isListOnly: isListOnly = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fU8cb))),
        className: (0, $bwpsq.default)([
            isListOnly ? "_1wgmglyw _rcuj1bdq" : "_19pkze3t _2hwx1wug _otyrze3t _18u01wug _p12f1qe4 _11y7oza4"
        ])
    });
const $e950186edd3e49fd$export$ec1cdd0c8335373c = ({ isListOnly: isListOnly = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8n9dD))),
        className: (0, $bwpsq.default)([
            isListOnly ? "_1wgmglyw _rcuj1bdq" : "_19pkze3t _2hwx1wug _otyrze3t _18u01wug _p12f1qe4 _11y7oza4"
        ])
    });

});
parcelRegister("4C3Cb", function(module, exports) {
module.exports = new URL("project-settings-access-app-skeleton.tpl.21bb94b1.svg", import.meta.url).toString();

});

parcelRegister("fU8cb", function(module, exports) {
module.exports = new URL("project-settings-details-app-skeleton.tpl.c4ebc2fd.svg", import.meta.url).toString();

});

parcelRegister("8n9dD", function(module, exports) {
module.exports = new URL("project-settings-features-app-skeleton.tpl.b8e7f249.svg", import.meta.url).toString();

});



parcelRegister("lhZGg", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreApprovalsRouteEntry", () => $391f453756ba70b6$export$728033a86ab68014);

var $18N1t = parcelRequire("18N1t");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $hIjSj = parcelRequire("hIjSj");

var $ljyNx = parcelRequire("ljyNx");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");
const $391f453756ba70b6$var$approvalsProjectSettingsPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $ljyNx.approvalsProjectSettingsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $391f453756ba70b6$export$728033a86ab68014 = (0, $7NszV.createEntry)((0, $hIjSj.projectSettingsCoreApprovalsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        entryPoint () {
            return $391f453756ba70b6$var$approvalsProjectSettingsPageEntryPoint;
        },
        ufoName: 'project-settings-approvals-core'
    }));

});
parcelRegister("hIjSj", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreApprovalsRoute", () => $2c78c142a4e64bf0$export$ba11c8f378a2c121);
const $2c78c142a4e64bf0$export$ba11c8f378a2c121 = {
    name: 'project-settings-core-approvals',
    path: '/jira/core/projects/:projectKey/settings/approvals',
    exact: true
};

});

parcelRegister("ljyNx", function(module, exports) {

$parcel$export(module.exports, "approvalsProjectSettingsEntryPoint", () => $d1b68aa40690ad89$export$1389a6ddf34f642e);

var $bDrsD = parcelRequire("bDrsD");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $d1b68aa40690ad89$export$1389a6ddf34f642e = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("fGoju")), {
        moduleId: "83e2f2c2"
    }),
    getPreloadProps: ({ context: context, tenantContext: { cloudId: cloudId } })=>{
        const projectKey = context.match.params.projectKey;
        if (projectKey == null) throw new Error('Project key missing');
        return {
            queries: {
                approvalsSettingsQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $bDrsD.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        };
    }
});

});
parcelRegister("bDrsD", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ed220cf4f93fbf5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d871f3ede49d545d142f76fc4cdb7b72>>
 * @relayHash c1a8c3336b76570b82a8688f17264c3b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 270763b3ff0773a74aedea0d0dc622ebea8eee56eab0c89b0657cf49632cc53f
const $9ed220cf4f93fbf5$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "270763b3ff0773a74aedea0d0dc622ebea8eee56eab0c89b0657cf49632cc53f",
        "metadata": {},
        "name": "src_jiraBusinessApprovalsSettingsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $9ed220cf4f93fbf5$export$2e2bcd8739ae039 = $9ed220cf4f93fbf5$var$node;

});

parcelRegister("fGoju", function(module, exports) {

let $b6ada35dd488d0c8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b6ada35dd488d0c8$var$load("irD3p").then(()=>parcelRequire('8gPdF'));

});



parcelRegister("jr5gb", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAppsFieldsRouteEntry", () => $6edc0d1d8bb5be4d$export$7870a0b1630a504e);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $9qIcj = parcelRequire("9qIcj");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

const $6edc0d1d8bb5be4d$var$LazyConnectAppControlsSettings = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("1j8hG"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-app-controls/src/index.tsx"
});
const $6edc0d1d8bb5be4d$var$ConnectAppControlsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $6edc0d1d8bb5be4d$var$LazyConnectAppControlsSettings,
        pageId: "project-settings-connect-app-controls",
        shouldShowSpinner: false
    });
const $6edc0d1d8bb5be4d$export$7870a0b1630a504e = (0, $7NszV.createEntry)((0, $9qIcj.projectSettingsCoreAppsFieldsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $6edc0d1d8bb5be4d$var$ConnectAppControlsPage,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $6edc0d1d8bb5be4d$var$LazyConnectAppControlsSettings
        ]
    }));

});
parcelRegister("9qIcj", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAppsFieldsRoute", () => $68a47d7164ebf1d3$export$1c7e75ffaa491922);
const $68a47d7164ebf1d3$export$1c7e75ffaa491922 = {
    name: 'project-settings-core-apps-fields',
    path: '/jira/core/projects/:projectKey/settings/apps/app-fields',
    exact: true
};

});

parcelRegister("1j8hG", function(module, exports) {

let $0f3dfdda988fa97f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0f3dfdda988fa97f$var$load("hXzjm").then(()=>parcelRequire('kO3mB'));

});


parcelRegister("7lZOe", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAppsRouteEntry", () => $af106c0091889a1f$export$c038a2892f34f1a9);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $hZjdc = parcelRequire("hZjdc");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

const $af106c0091889a1f$var$LazyConnectAppsSettings = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("flIAq"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-apps/src/index.tsx"
});
const $af106c0091889a1f$var$ConnectAppsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $af106c0091889a1f$var$LazyConnectAppsSettings,
        pageId: "project-settings-connect-apps",
        shouldShowSpinner: false
    });
const $af106c0091889a1f$export$c038a2892f34f1a9 = (0, $7NszV.createEntry)((0, $hZjdc.projectSettingsCoreAppsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $af106c0091889a1f$var$ConnectAppsPage,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $af106c0091889a1f$var$LazyConnectAppsSettings
        ]
    }));

});
parcelRegister("hZjdc", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAppsRoute", () => $7add52f5911a831e$export$c7ac65fb0bbe767f);
const $7add52f5911a831e$export$c7ac65fb0bbe767f = {
    name: 'project-settings-core-apps',
    path: '/jira/core/projects/:projectKey/settings/apps/:appId?',
    exact: true
};

});

parcelRegister("flIAq", function(module, exports) {

let $b2cb671febd63ce2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b2cb671febd63ce2$var$load("eJV9X").then(()=>parcelRequire('79qwo'));

});


parcelRegister("9rVvQ", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAutomationRouteEntry", () => $1becf8cdf357266c$export$a244870e56f5c9a3);

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $bCPFV = parcelRequire("bCPFV");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

var $eBc8i = parcelRequire("eBc8i");
const $1becf8cdf357266c$export$a244870e56f5c9a3 = (0, $7NszV.createEntry)((0, $bCPFV.projectSettingsCoreAutomationRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: (0, $eBc8i.AutomationLazyPage),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $eBc8i.LazyProjectSettingsJiraAutomation)
        ],
        ufoName: 'project-settings-automation-core'
    }));

});
parcelRegister("bCPFV", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAutomationRoute", () => $7024005c59ef8f32$export$65a4d727336c49f4);
const $7024005c59ef8f32$export$65a4d727336c49f4 = {
    name: 'project-settings-core-automation',
    path: '/jira/core/projects/:projectKey/settings/automation'
};

});

parcelRegister("eBc8i", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsJiraAutomation", () => $d9e4cec5af9ce718$export$dea5ad7e8eac12ae);
$parcel$export(module.exports, "AutomationLazyPage", () => $d9e4cec5af9ce718$export$88eebe21cecb82db);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $d9e4cec5af9ce718$export$dea5ad7e8eac12ae = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("3Dp46")), {
    moduleId: "./src/packages/spa-apps/project-settings/jira-automation/src/index.tsx"
});
const $d9e4cec5af9ce718$export$88eebe21cecb82db = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d9e4cec5af9ce718$export$dea5ad7e8eac12ae,
        pageId: "project-settings-jira-automation",
        shouldShowSpinner: true
    });

});
parcelRegister("3Dp46", function(module, exports) {

let $2a58750af25485f1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2a58750af25485f1$var$load("4KSkX").then(()=>parcelRequire('ieTY5'));

});



parcelRegister("au6vg", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAutomationV2RouteEntry", () => $d7c59ae6b2241667$export$a2c8a6767edeeaed);

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $dJG0f = parcelRequire("dJG0f");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

var $eBc8i = parcelRequire("eBc8i");
const $d7c59ae6b2241667$export$a2c8a6767edeeaed = (0, $7NszV.createEntry)((0, $dJG0f.projectSettingsCoreAutomationV2Route), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: (0, $eBc8i.AutomationLazyPage),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $eBc8i.LazyProjectSettingsJiraAutomation)
        ]
    }));

});
parcelRegister("dJG0f", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreAutomationV2Route", () => $e31b6bde721f5bf5$export$5437af2650f645e0);
const $e31b6bde721f5bf5$export$5437af2650f645e0 = {
    name: 'project-settings-core-automation',
    path: '/jira/core/projects/:projectKey/settings/automate'
};

});


parcelRegister("cLamq", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreDataClassificationsRouteEntry", () => $60f4334670e39dba$export$cf5194c476e8bcdb);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $brYsn = parcelRequire("brYsn");

var $jaAyo = parcelRequire("jaAyo");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

const $60f4334670e39dba$var$LazyDataClassificationsSettings = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("foQoc"))), {
    moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
});
const $60f4334670e39dba$var$DataClassifications = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $60f4334670e39dba$var$LazyDataClassificationsSettings,
        pageId: "project-settings-data-classifications",
        shouldShowSpinner: false
    });
const $60f4334670e39dba$export$cf5194c476e8bcdb = (0, $7NszV.createEntry)((0, $brYsn.projectSettingsCoreDataClassificationsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $60f4334670e39dba$var$DataClassifications,
        skeleton: (0, $jaAyo.ProjectSettingsDetailsSkeleton),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("brYsn", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreDataClassificationsRoute", () => $46bd61981cdecbb8$export$7aae1006c82a79c0);
const $46bd61981cdecbb8$export$7aae1006c82a79c0 = {
    name: 'project-settings-core-data-classifications',
    path: '/jira/core/projects/:projectKey/settings/data-classifications',
    exact: true
};

});


parcelRegister("2vHPs", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreDefaultRedirectRouteEntry", () => $72042ad67933f70e$export$df1c02c3f28b7a95);

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $1IH8G = parcelRequire("1IH8G");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

var $7dO7c = parcelRequire("7dO7c");
const $72042ad67933f70e$export$df1c02c3f28b7a95 = (0, $7NszV.createEntry)((0, $1IH8G.projectSettingsCoreDefaultRedirectRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: (0, $7dO7c.ProjectSettingsRedirect),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("1IH8G", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreDefaultRedirectRoute", () => $5a27ba0a68240f95$export$322fe16ec991f12);
const $5a27ba0a68240f95$export$322fe16ec991f12 = {
    name: 'project-settings-core-redirect',
    path: '/jira/core/projects/:projectKey/settings'
};

});

parcelRegister("7dO7c", function(module, exports) {

$parcel$export(module.exports, "ProjectSettingsRedirect", () => $646d86edb6dba940$export$72130cf40a3c3778);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $1J3t1 = parcelRequire("1J3t1");

var $7tQej = parcelRequire("7tQej");
const $646d86edb6dba940$export$72130cf40a3c3778 = ({ match: match })=>{
    const { data: data } = (0, $1J3t1.useJiraWorkmanagementProjectNavigation)();
    const { projectKey: projectKey } = match.params;
    if (data?.permissionInfo?.isAdmin || data?.permissionInfo?.isSiteAdmin || data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/jira/core/projects/${String(projectKey)}/settings/details`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_WORKFLOW === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/workflows`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_ISSUE_LAYOUT === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/issuelayout`
    });
    if ((0, $4R6GH.fg)('vmc-11-manage-versions-permission')) {
        if (data?.permissionInfo?.projectPermissionsQueried?.MANAGE_VERSIONS === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: `/plugins/servlet/project-config/${String(projectKey)}/administer-versions`
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/jira/core/projects/${String(match.params.projectKey)}/settings/details`
    });
};

});


parcelRegister("hztdR", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreDetailsRouteEntry", () => $f65156aa09643d37$export$438a330ccc1e7a91);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $3yAjF = parcelRequire("3yAjF");

var $jaAyo = parcelRequire("jaAyo");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

const $f65156aa09643d37$var$LazyDetailsSettings = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("eC5lK"))), {
    moduleId: "./src/packages/spa-apps/project-settings/details/src/index.tsx"
});
const $f65156aa09643d37$var$Details = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f65156aa09643d37$var$LazyDetailsSettings,
        pageId: "project-settings-details",
        shouldShowSpinner: false
    });
const $f65156aa09643d37$export$438a330ccc1e7a91 = (0, $7NszV.createEntry)((0, $3yAjF.projectSettingsCoreDetailsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $f65156aa09643d37$var$Details,
        skeleton: (0, $jaAyo.ProjectSettingsDetailsSkeleton),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $f65156aa09643d37$var$LazyDetailsSettings
        ]
    }));

});
parcelRegister("3yAjF", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreDetailsRoute", () => $5d63f1af39ccfc34$export$14535b40530c8690);
const $5d63f1af39ccfc34$export$14535b40530c8690 = {
    name: 'project-settings-core-details',
    path: '/jira/core/projects/:projectKey/settings/details',
    exact: true
};

});

parcelRegister("eC5lK", function(module, exports) {

let $aa38c3a1bc44c6e8$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $aa38c3a1bc44c6e8$var$load("76n7a"),
    $aa38c3a1bc44c6e8$var$load("l253H"),
    $aa38c3a1bc44c6e8$var$load("ffQaD"),
    $aa38c3a1bc44c6e8$var$load("kvRbA"),
    $aa38c3a1bc44c6e8$var$load("fliVL"),
    $aa38c3a1bc44c6e8$var$load("hnI4x")
]).then(()=>parcelRequire('9vEjY'));

});


parcelRegister("6cSNh", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreFieldsRouteEntry", () => $3dfc1ebecbfe533b$export$8d8dff75124dcebc);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $e7C7O = parcelRequire("e7C7O");

var $5lsNZ = parcelRequire("5lsNZ");

var $9BCCu = parcelRequire("9BCCu");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $cSUZZ = parcelRequire("cSUZZ");

var $6s1PB = parcelRequire("6s1PB");

var $gTwsg = parcelRequire("gTwsg");
const $3dfc1ebecbfe533b$var$isEfaExperimentExposed = ()=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('efa_and_project_fields_page_for_tmp');
    return expConfig.get('isEnabled', false);
};

const $3dfc1ebecbfe533b$var$LazyFieldsSettings = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("cqfV9"))), {
    moduleId: "./src/packages/spa-apps/project-settings/fields/src/index.tsx"
});
const $3dfc1ebecbfe533b$var$FieldsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3dfc1ebecbfe533b$var$LazyFieldsSettings,
        pageId: "project-settings-fields",
        shouldShowSpinner: true
    });
const $3dfc1ebecbfe533b$export$8d8dff75124dcebc = (0, $7NszV.createEntry)((0, $9BCCu.projectSettingsCoreFieldsRoute), ()=>({
        group: 'project-settings-core',
        ufoName: 'project-settings.fields.jwm-tmp',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            (0, $e7C7O.fieldSettingsRelayResource)
        ],
        component: (0, $7XYc4.componentWithCondition)($3dfc1ebecbfe533b$var$isEfaExperimentExposed, $3dfc1ebecbfe533b$var$FieldsPage, (0, $5lsNZ.default)),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $3dfc1ebecbfe533b$var$LazyFieldsSettings
        ]
    }));

});
parcelRegister("e7C7O", function(module, exports) {

$parcel$export(module.exports, "fieldSettingsRelayResource", () => $424e18beff0a1aec$export$68b4e700e00bad7a);

var $ao2h1 = parcelRequire("ao2h1");

var $gF6UW = parcelRequire("gF6UW");

var $1nb22 = parcelRequire("1nb22");
const $424e18beff0a1aec$var$RESOURCE_TYPE_PROJECT_SETTINGS_FIELDS = 'PROJECT_SETTINGS_FIELDS';
const $424e18beff0a1aec$export$68b4e700e00bad7a = (0, $ao2h1.createRelayResource)({
    type: $424e18beff0a1aec$var$RESOURCE_TYPE_PROJECT_SETTINGS_FIELDS,
    getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(match, query);
        return {
            parameters: (0, $gF6UW.default),
            variables: {
                projectKey: projectKey ?? '',
                cloudId: tenantContext.cloudId ?? ''
            },
            options: {
                fetchPolicy: 'network-only'
            }
        };
    }
});

});
parcelRegister("gF6UW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e41b4fca86430f4d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<05c2ceb52cd1ed84e13689ed63e69001>>
 * @relayHash 6c7f26d58ea6593573f3760a28de2bfc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2c33954f8f2e7776db58884e5fc077e131895e94a43a41a979ac2999e017194c

var $2OU2m = parcelRequire("2OU2m");

var $3iWRf = parcelRequire("3iWRf");

var $fqBML = parcelRequire("fqBML");

var $eiowN = parcelRequire("eiowN");
const $e41b4fca86430f4d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v2 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v3 = [
        v2 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "isExplicitFieldAssociationsEnabled"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "key"
    }, v10 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 30
        }
    ], v11 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiFieldsPageQuery",
            "selections": [
                {
                    "args": [
                        v2 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "projectKey",
                            "variableName": "projectKey"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "fieldsTable_projectFields"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "FragmentSpread",
                                    "name": "pageHeader_projectFields_Header"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisprojectfieldsgafastfollowsgateenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationuienabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "uiFieldsPageQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                },
                                {
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v9 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "optionsPerFieldLimit"
                                },
                                {
                                    "concreteType": "JiraFieldTypeGroupConnection",
                                    "kind": "LinkedField",
                                    "name": "projectFieldTypeGroups",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFieldTypeGroupEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFieldTypeGroup",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "displayName"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraProjectWithIssueTypeIds",
                                    "kind": "LinkedField",
                                    "name": "projectWithVisibleIssueTypeIds",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v10 /*: any*/ ,
                                            "concreteType": "JiraFieldAssociationWithIssueTypesConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldAssociationWithIssueTypes",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFieldAssociationWithIssueTypesEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraFieldAssociationWithIssueTypes",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraField",
                                                                    "kind": "LinkedField",
                                                                    "name": "field",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "fieldId"
                                                                        },
                                                                        v8 /*: any*/ ,
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "scope"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "typeName"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "description"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "typeKey"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "hasMissingConfiguration"
                                                                },
                                                                {
                                                                    "concreteType": "JiraIssueTypeConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypes",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueTypeEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v5 /*: any*/ ,
                                                                                        v6 /*: any*/ ,
                                                                                        v8 /*: any*/ ,
                                                                                        v7 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraFieldOperation",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldOperation",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canRemove"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canDelete"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canAssociateInSettings"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canEdit"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canModifyOptions"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraFieldOptionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldOptions",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraFieldOptionEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraFieldOption",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "optionId"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "parentOptionId"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "value"
                                                                                        },
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraColor",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "color",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "colorKey"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isFieldLocked"
                                                                },
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationuienabledrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldFormatConfig",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v11 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "formatStyle"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "formatUnit"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "formatDecimals"
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraNumberFieldFormatConfig"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "fieldAssociationWithIssueTypes(first:30)"
                                        },
                                        {
                                            "args": v10 /*: any*/ ,
                                            "filters": [
                                                "input"
                                            ],
                                            "handle": "connection",
                                            "key": "fieldsTable_fieldAssociationWithIssueTypes",
                                            "kind": "LinkedHandle",
                                            "name": "fieldAssociationWithIssueTypes"
                                        }
                                    ]
                                },
                                v8 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisprojectfieldsgafastfollowsgateenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectScopedFieldsPerProjectLimit"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectScopedFieldsCount"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2c33954f8f2e7776db58884e5fc077e131895e94a43a41a979ac2999e017194c",
            "metadata": {},
            "name": "uiFieldsPageQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisprojectfieldsgafastfollowsgateenabledrelayprovider": (0, $2OU2m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationuienabledrelayprovider": (0, $3iWRf.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolourfulsingleselectfieldsexperimentrelayprovider": (0, $fqBML.default)
            }
        }
    };
}();
$e41b4fca86430f4d$var$node.hash = "b0872e3059548632993c06522c7f5584";
(0, $eiowN.PreloadableQueryRegistry).set($e41b4fca86430f4d$var$node.params.id, $e41b4fca86430f4d$var$node);
var $e41b4fca86430f4d$export$2e2bcd8739ae039 = $e41b4fca86430f4d$var$node;

});
parcelRegister("2OU2m", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7b19278c2ec7204$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
const $e7b19278c2ec7204$var$isProjectFieldsGaFastFollowsEnabled = {
    get () {
        return (0, $4R6GH.fg)('project_fields_page_for_tmp_-_ga_fast_follows');
    }
};
var $e7b19278c2ec7204$export$2e2bcd8739ae039 = $e7b19278c2ec7204$var$isProjectFieldsGaFastFollowsEnabled;

});

parcelRegister("3iWRf", function(module, exports) {

$parcel$export(module.exports, "default", () => $b077dd0bcb571945$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $b077dd0bcb571945$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('frontier-currency-field-d1');
    }
};

});

parcelRegister("fqBML", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c0d9a50b10efb8d$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");
var $0c0d9a50b10efb8d$export$2e2bcd8739ae039 = {
    get () {
        return (0, $6s1PB.expVal)('thor_colourful_single_select_milestone2_experiment', 'isColorfulSingleSelectEnabled', false) && (0, $6s1PB.expVal)('thor_colourful_single_select_fields_experiment', 'isColorfulSingleSelectEnabled', false);
    }
};

});



parcelRegister("9BCCu", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreFieldsRoute", () => $03614f84baa4becb$export$7c4ee74641923239);
const $03614f84baa4becb$export$7c4ee74641923239 = {
    name: 'project-settings-core-fields',
    path: '/jira/core/projects/:projectKey/settings/fields',
    exact: true
};

});

parcelRegister("cqfV9", function(module, exports) {

let $90b4434558a8f4ff$var$load = (parcelRequire("28QjX"))(4);
module.exports = $90b4434558a8f4ff$var$load("4eTRc").then(()=>parcelRequire('aRrWI'));

});


parcelRegister("lIPtt", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreForgeAppsRouteEntry", () => $81842dc02c80a297$export$1006fd9f5f02b1c2);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $kXEQj = parcelRequire("kXEQj");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

const $81842dc02c80a297$var$LazyForgeProjectSettingsPage = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("bZbyt")), {
    moduleId: "./src/packages/spa-apps/forge/project-settings/src/index.tsx"
});
const $81842dc02c80a297$var$ForgeProjectSettingsPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $81842dc02c80a297$var$LazyForgeProjectSettingsPage,
        pageId: "forge-spa-project-settings",
        shouldShowSpinner: true
    });
const $81842dc02c80a297$export$1006fd9f5f02b1c2 = (0, $7NszV.createEntry)((0, $kXEQj.projectSettingsCoreForgeAppsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $81842dc02c80a297$var$ForgeProjectSettingsPage,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $81842dc02c80a297$var$LazyForgeProjectSettingsPage
        ]
    }));

});
parcelRegister("kXEQj", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreForgeAppsRoute", () => $ffe7ed90d4a26759$export$b34160f55b6104e9);
const $ffe7ed90d4a26759$export$b34160f55b6104e9 = {
    name: 'project-settings-core-forge-apps',
    path: '/jira/core/projects/:projectKey/settings/apps/:appId/:envId/:route?'
};

});

parcelRegister("bZbyt", function(module, exports) {

let $8b9e5aca48265423$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8b9e5aca48265423$var$load("bfSAg").then(()=>parcelRequire('ln9R3'));

});


parcelRegister("cWKD0", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreIssueTypesRouteEntry", () => $dfd719394f285715$export$95ecbacf0120fcfd);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $cXAV1 = parcelRequire("cXAV1");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

const $dfd719394f285715$var$LazyIssueTypeSettings = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("7a4qW"))), {
    moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
});
const $dfd719394f285715$var$IssueTypePage = ({ match: match })=>{
    const { issueTypeId: issueTypeId } = match.params;
    // unique pageId need to be set so that ApdexProvider would properly reset all the performance marks when switching between issue types
    const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $dfd719394f285715$var$LazyIssueTypeSettings,
        pageId: pageId,
        shouldShowSpinner: false
    });
};
const $dfd719394f285715$export$95ecbacf0120fcfd = (0, $7NszV.createEntry)((0, $cXAV1.projectSettingsCoreIssueTypesRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $dfd719394f285715$var$IssueTypePage,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $dfd719394f285715$var$LazyIssueTypeSettings
        ]
    }));

});
parcelRegister("cXAV1", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreIssueTypesRoute", () => $9890a5b2bae88b9c$export$c3a32433c580b9ff);
const $9890a5b2bae88b9c$export$c3a32433c580b9ff = {
    name: 'project-settings-core-issuetypes',
    path: '/jira/core/projects/:projectKey/settings/issuetypes/:issueTypeId?',
    exact: true
};

});


parcelRegister("d0eOH", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreIssueTypesWorkflowRouteEntry", () => $73a52ccb6b02557a$export$1dfd4811b9065dd6);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $Tp0iK = parcelRequire("Tp0iK");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

const $73a52ccb6b02557a$var$LazyWorkflowNavigationSettings = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hodsj"))), {
    moduleId: "./src/packages/spa-apps/project-settings/workflow-navigation/src/index.tsx"
});
const $73a52ccb6b02557a$var$WorkflowNavigationPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $73a52ccb6b02557a$var$LazyWorkflowNavigationSettings,
        pageId: "project-settings-workflow-navigation",
        shouldShowSpinner: false
    });
const $73a52ccb6b02557a$export$1dfd4811b9065dd6 = (0, $7NszV.createEntry)((0, $Tp0iK.projectSettingsCoreIssueTypesWorkflowRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $73a52ccb6b02557a$var$WorkflowNavigationPage,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $73a52ccb6b02557a$var$LazyWorkflowNavigationSettings
        ]
    }));

});
parcelRegister("Tp0iK", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreIssueTypesWorkflowRoute", () => $5c1b1d7296dcb1b9$export$9e79ee307216071b);
const $5c1b1d7296dcb1b9$export$9e79ee307216071b = {
    name: 'project-settings-core-issuetypes-workflow',
    path: '/jira/core/projects/:projectKey/settings/issuetypes/:issueTypeId/:initialSection(workflow)',
    exact: true
};

});

parcelRegister("hodsj", function(module, exports) {

let $ca8f1d9690562020$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ca8f1d9690562020$var$load("kNFvF"),
    $ca8f1d9690562020$var$load("76n7a"),
    $ca8f1d9690562020$var$load("l253H"),
    $ca8f1d9690562020$var$load("JZq07")
]).then(()=>parcelRequire('fEx2J'));

});


parcelRegister("bxg3m", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreNotificationsEmailRouteEntry", () => $c698ffcb86d9bd83$export$da36a1671d868927);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $6IsiM = parcelRequire("6IsiM");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

const $c698ffcb86d9bd83$var$LazyProjectSettingsNotificationEmail = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hLnUL"))), {
    moduleId: "./src/packages/spa-apps/project-settings/notification-email/src/index.tsx"
});
const $c698ffcb86d9bd83$var$EmailNotifications = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $c698ffcb86d9bd83$var$LazyProjectSettingsNotificationEmail,
        pageId: "project-settings-email-notifications",
        shouldShowSpinner: true
    });
const $c698ffcb86d9bd83$export$da36a1671d868927 = (0, $7NszV.createEntry)((0, $6IsiM.projectSettingsCoreNotificationsEmailRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $c698ffcb86d9bd83$var$EmailNotifications,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $c698ffcb86d9bd83$var$LazyProjectSettingsNotificationEmail
        ]
    }));

});
parcelRegister("6IsiM", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreNotificationsEmailRoute", () => $91d0b5fe7c793948$export$b546589f1b048dc);
const $91d0b5fe7c793948$export$b546589f1b048dc = {
    name: 'project-settings-core-notifications-notification-email',
    path: '/jira/core/projects/:projectKey/settings/notifications/notification-email',
    exact: true
};

});

parcelRegister("hLnUL", function(module, exports) {

let $cee9606302ec1388$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cee9606302ec1388$var$load("OBAxr").then(()=>parcelRequire('d6iMp'));

});


parcelRegister("e6Vbw", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreNotificationsIssueLogsRouteEntry", () => $4c1c7acc90dd4d09$export$e562140c482cb0c);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $cpVGO = parcelRequire("cpVGO");

var $femMW = parcelRequire("femMW");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");
const $4c1c7acc90dd4d09$var$emailNotificationsLogEntryPointPage = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $femMW.notificationsIssueLogsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

const $4c1c7acc90dd4d09$var$LazyNotificationsIssueLogs = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("5Q8bv"))), {
    moduleId: "./src/packages/spa-apps/project-settings/software-notifications-issue-logs/src/index.tsx"
});
const $4c1c7acc90dd4d09$var$NotificationsIssueLogs = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $4c1c7acc90dd4d09$var$LazyNotificationsIssueLogs,
        pageId: "project-settings-software-notifications-issue-logs",
        shouldShowSpinner: false
    });
const $4c1c7acc90dd4d09$export$e562140c482cb0c = (0, $7NszV.createEntry)((0, $cpVGO.projectSettingsCoreNotificationsIssueLogsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $4c1c7acc90dd4d09$var$NotificationsIssueLogs,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $4c1c7acc90dd4d09$var$LazyNotificationsIssueLogs
        ],
        entryPoint () {
            return $4c1c7acc90dd4d09$var$emailNotificationsLogEntryPointPage;
        }
    }));

});
parcelRegister("cpVGO", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreNotificationsIssueLogsRoute", () => $1ebe41c3d3a19553$export$56a8a0b88329b044);
const $1ebe41c3d3a19553$export$56a8a0b88329b044 = {
    name: 'project-settings-core-notifications-issue-logs',
    path: '/jira/core/projects/:projectKey/settings/notifications/issue-logs',
    exact: true
};

});

parcelRegister("femMW", function(module, exports) {

$parcel$export(module.exports, "notificationsIssueLogsEntryPoint", () => $6adcc3494d7c3774$export$97bbdefcbe0571ac);

var $9Cf70 = parcelRequire("9Cf70");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $6adcc3494d7c3774$export$97bbdefcbe0571ac = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        if (!false) return (parcelRequire("5Q8bv"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "b2136a4d"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                notificationLogs: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $9Cf70.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectId: Number(context?.query?.projectId ?? 0),
                        notificationType: 'INTERNAL_NOTIFICATION_ISSUE'
                    }
                }
            },
            extraProps: {
                accountId: tenantContext.atlassianAccountId,
                cloudId: tenantContext.cloudId,
                projectIds: context?.query?.projectId,
                projectKey: context?.match.params.projectKey
            }
        })
});

});
parcelRegister("9Cf70", function(module, exports) {

$parcel$export(module.exports, "default", () => $baebbc2289a2b843$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a829922c4d7e91622e88a1e75ca9c0ed>>
 * @relayHash ed735b233bfe7d6a34f4765ef97f56e9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 28e1d1e9657c726eca51c9d02a4b718874ec12653eea9e5bfcfef82047676924
const $baebbc2289a2b843$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "28e1d1e9657c726eca51c9d02a4b718874ec12653eea9e5bfcfef82047676924",
        "metadata": {},
        "name": "uiIssueNotificationLogsPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $baebbc2289a2b843$export$2e2bcd8739ae039 = $baebbc2289a2b843$var$node;

});

parcelRegister("5Q8bv", function(module, exports) {

let $4408285df5e2c7dd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4408285df5e2c7dd$var$load("bY8qa").then(()=>parcelRequire('6ZR0a'));

});



parcelRegister("7LwJB", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreNotificationsRouteEntry", () => $221f77694f7c3501$export$ed481b03aa858542);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $oHytR = parcelRequire("oHytR");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

const $221f77694f7c3501$var$LazyNotificationsSettings = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("fhvdd"))), {
    moduleId: "./src/packages/spa-apps/project-settings/software-notifications/src/index.tsx"
});
const $221f77694f7c3501$var$Notifications = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $221f77694f7c3501$var$LazyNotificationsSettings,
        pageId: "project-settings-software-notifications",
        shouldShowSpinner: false
    });
const $221f77694f7c3501$export$ed481b03aa858542 = (0, $7NszV.createEntry)((0, $oHytR.projectSettingsCoreNotificationsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $221f77694f7c3501$var$Notifications,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $221f77694f7c3501$var$LazyNotificationsSettings
        ]
    }));

});
parcelRegister("oHytR", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreNotificationsRoute", () => $3cc89fad893f0f33$export$a1ee80066685b98d);
const $3cc89fad893f0f33$export$a1ee80066685b98d = {
    name: 'project-settings-core-notifications',
    path: '/jira/core/projects/:projectKey/settings/notifications',
    exact: true
};

});

parcelRegister("fhvdd", function(module, exports) {

let $b200a7a119c4bd46$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b200a7a119c4bd46$var$load("cmtly").then(()=>parcelRequire('giI7i'));

});


parcelRegister("66HfJ", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreProformaJiraFormBuilderRouteEntry", () => $58b256108db01248$export$46d6b55ebf21ccc);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $1y7ot = parcelRequire("1y7ot");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

const $58b256108db01248$var$LazyProjectSettingsProformaJiraFormBuilder = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("7R9RB")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-jira-form-builder/src/index.tsx"
});
const $58b256108db01248$var$ProformaJiraFormBuilder = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $58b256108db01248$var$LazyProjectSettingsProformaJiraFormBuilder,
        pageId: "project-settings-proforma-jira-form-builder",
        shouldShowSpinner: true
    });
const $58b256108db01248$export$46d6b55ebf21ccc = (0, $7NszV.createEntry)((0, $1y7ot.projectSettingsCoreProformaJiraFormBuilderRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $58b256108db01248$var$ProformaJiraFormBuilder,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $58b256108db01248$var$LazyProjectSettingsProformaJiraFormBuilder
        ],
        perfMetricKey: 'form-builder'
    }));

});
parcelRegister("1y7ot", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreProformaJiraFormBuilderRoute", () => $bffeb81c48a88921$export$4e7ce7e6ced0f291);
const $bffeb81c48a88921$export$4e7ce7e6ced0f291 = {
    name: 'project-settings-core-proforma-jira-form-builder',
    path: '/jira/core/projects/:projectKey/settings/forms/form/:templateFormId/edit',
    exact: true
};

});

parcelRegister("7R9RB", function(module, exports) {

let $0179e3a69349e757$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0179e3a69349e757$var$load("ffQaD"),
    $0179e3a69349e757$var$load("kvRbA"),
    $0179e3a69349e757$var$load("fliVL"),
    $0179e3a69349e757$var$load("76n7a"),
    $0179e3a69349e757$var$load("l253H"),
    $0179e3a69349e757$var$load("gT4kI")
]).then(()=>parcelRequire('1XLXC'));

});


parcelRegister("aDZxG", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreProformaProjectFormsRouteEntry", () => $76ec485f5ce6229b$export$5e9e27f116094fdf);

var $5uXOq = parcelRequire("5uXOq");

var $ffza4 = parcelRequire("ffza4");

var $18N1t = parcelRequire("18N1t");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $dmKXV = parcelRequire("dmKXV");

var $7NszV = parcelRequire("7NszV");

var $lNicp = parcelRequire("lNicp");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $dcOuP = parcelRequire("dcOuP");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $cSUZZ = parcelRequire("cSUZZ");

var $gTwsg = parcelRequire("gTwsg");

const $76ec485f5ce6229b$var$LazyProjectSettingsProformaProjectForms = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("cShK4")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-project-forms/src/index.tsx"
});
const $76ec485f5ce6229b$var$ProformaProjectForms = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $76ec485f5ce6229b$var$LazyProjectSettingsProformaProjectForms,
        pageId: "project-settings-proforma-project-forms",
        shouldShowSpinner: true
    });
const $76ec485f5ce6229b$export$5e9e27f116094fdf = (0, $7NszV.createEntry)((0, $dcOuP.projectSettingsCoreProformaProjectFormsRoute), ()=>({
        group: 'project-settings-core',
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            // delete when cleaning up getWillShowNav4
            sidebar: (0, $dmKXV.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        layout: (0, $18N1t.coreProjectLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gTwsg.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $lNicp.getBusinessProjectResources)(),
            (0, $cSUZZ.licenseDetailsResource_DEPRECATED_DO_NOT_USE)
        ],
        component: $76ec485f5ce6229b$var$ProformaProjectForms,
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            $76ec485f5ce6229b$var$LazyProjectSettingsProformaProjectForms
        ],
        perfMetricKey: 'forms-settings'
    }));

});
parcelRegister("dcOuP", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreProformaProjectFormsRoute", () => $ca16757f7d5a6f92$export$57fe8c5107a9c0de);
const $ca16757f7d5a6f92$export$57fe8c5107a9c0de = {
    name: 'project-settings-core-proforma-project-forms',
    path: '/jira/core/projects/:projectKey/settings/forms',
    exact: true
};

});

parcelRegister("cShK4", function(module, exports) {

let $95f84a629d0d3b75$var$load = (parcelRequire("28QjX"))(4);
module.exports = $95f84a629d0d3b75$var$load("9xKEM").then(()=>parcelRequire('ciDU2'));

});


parcelRegister("anDMO", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsDetailsRouteEntry", () => $0d63a1f004a7576a$export$9391a147c94081db);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $cubqk = parcelRequire("cubqk");

var $jaAyo = parcelRequire("jaAyo");

var $e7bC3 = parcelRequire("e7bC3");

var $cYgMq = parcelRequire("cYgMq");
const $0d63a1f004a7576a$export$9391a147c94081db = (0, $7NszV.createEntry)((0, $cubqk.classicProjectSettingsDetailsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $cYgMq.default),
        skeleton: (0, $jaAyo.ProjectSettingsDetailsSkeleton),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $dxCvy.projectContextResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cYgMq.LazyDetailsSettings)
        ]
    }));

});
parcelRegister("cubqk", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsDetailsRoute", () => $1e07e61b794dca8d$export$37e0dbac44df25b9);
const $1e07e61b794dca8d$export$37e0dbac44df25b9 = {
    name: 'classic-software-details',
    path: '/jira/software/c/projects/:projectKey/settings/details',
    exact: true
};

});

parcelRegister("cYgMq", function(module, exports) {

$parcel$export(module.exports, "LazyDetailsSettings", () => $5dcf6caa5da05571$export$6f16b5efddd5c646);
$parcel$export(module.exports, "default", () => $5dcf6caa5da05571$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $5dcf6caa5da05571$export$6f16b5efddd5c646 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("eC5lK"))), {
    moduleId: "./src/packages/spa-apps/project-settings/details/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5dcf6caa5da05571$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $5dcf6caa5da05571$export$6f16b5efddd5c646,
        pageId: "project-settings-details",
        shouldShowSpinner: false
    });

});


parcelRegister("dYbYB", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsFeaturesRouteEntry", () => $f08d62940ca05012$export$b623393adc25556a);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $bzimk = parcelRequire("bzimk");

var $jaAyo = parcelRequire("jaAyo");

var $e7bC3 = parcelRequire("e7bC3");

var $4glor = parcelRequire("4glor");
const $f08d62940ca05012$export$b623393adc25556a = (0, $7NszV.createEntry)((0, $bzimk.classicProjectSettingsFeaturesRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'classic-features-page',
        component: (0, $4glor.ClassicFeaturesPage),
        skeleton: (0, $jaAyo.ProjectSettingsFeaturesSkeleton),
        layout: (0, $e7bC3.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $dxCvy.projectContextResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4glor.LazySoftwareClassicFeatures)
        ]
    }));

});
parcelRegister("bzimk", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsFeaturesRoute", () => $a3d30ca18dd07505$export$d4bf23ba6f4199d7);
const $a3d30ca18dd07505$export$d4bf23ba6f4199d7 = {
    name: 'classic-software-features',
    path: '/jira/software/c/projects/:projectKey/settings/features',
    exact: true
};

});

parcelRegister("4glor", function(module, exports) {

$parcel$export(module.exports, "LazySoftwareClassicFeatures", () => $70eea33e6c09b198$export$79fe16f960f3d89f);
$parcel$export(module.exports, "ClassicFeaturesPage", () => $70eea33e6c09b198$export$8e6f565615e921dd);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $70eea33e6c09b198$export$79fe16f960f3d89f = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("cnRkx"))), {
    moduleId: "./src/packages/spa-apps/project-settings/classic-features/src/index.tsx"
});
const $70eea33e6c09b198$export$8e6f565615e921dd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $70eea33e6c09b198$export$79fe16f960f3d89f,
        pageId: "classic-features",
        shouldShowSpinner: true
    });

});
parcelRegister("cnRkx", function(module, exports) {

let $9041004cdb0bb96e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9041004cdb0bb96e$var$load("aRqGl").then(()=>parcelRequire('hX1AL'));

});



parcelRegister("ffFBX", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsOpsgenieRouteEntry", () => $2bd54c69eb3061ae$export$17e7416abefe91dc);

var $ffza4 = parcelRequire("ffza4");

var $bwLf9 = parcelRequire("bwLf9");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $5lsNZ = parcelRequire("5lsNZ");

var $dcC1k = parcelRequire("dcC1k");

var $kfztd = parcelRequire("kfztd");

var $e7bC3 = parcelRequire("e7bC3");

var $1KQBW = parcelRequire("1KQBW");
const $2bd54c69eb3061ae$export$17e7416abefe91dc = (0, $7NszV.createEntry)((0, $dcC1k.classicProjectSettingsOpsgenieRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $bwLf9.default)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $1KQBW.default)),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $dxCvy.projectContextResource)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $1KQBW.LazyLinkOpsgeniePage)
        ],
        ufoName: 'project-settings.link-opsgenie'
    }));

});
parcelRegister("dcC1k", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsOpsgenieRoute", () => $f327483ffca6ed25$export$4e4a4b8762b611);
const $f327483ffca6ed25$export$4e4a4b8762b611 = {
    name: 'classic-software-link-opsgenie',
    path: '/jira/software/c/projects/:projectKey/settings/opsgenie',
    exact: true
};

});

parcelRegister("1KQBW", function(module, exports) {

$parcel$export(module.exports, "LazyLinkOpsgeniePage", () => $dab3ab2feb1de470$export$ca5dba69148b337);
$parcel$export(module.exports, "default", () => $dab3ab2feb1de470$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $dab3ab2feb1de470$export$ca5dba69148b337 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("bn3jD")), {
    moduleId: "./src/packages/spa-apps/project-settings/link-opsgenie/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$dab3ab2feb1de470$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $dab3ab2feb1de470$export$ca5dba69148b337,
        pageId: "link-opsgenie-page",
        shouldShowSpinner: false
    });

});
parcelRegister("bn3jD", function(module, exports) {

let $84746a230ea5fc68$var$load = (parcelRequire("28QjX"))(4);
module.exports = $84746a230ea5fc68$var$load("4BlES").then(()=>parcelRequire('7AMRE'));

});



parcelRegister("1IKX7", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsSoftwareNotificationsIssueLogsRouteEntry", () => $ced985b0a8859572$export$cdc4e64211a34457);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $5dFt2 = parcelRequire("5dFt2");

var $e7bC3 = parcelRequire("e7bC3");

var $14B4q = parcelRequire("14B4q");
const $ced985b0a8859572$export$cdc4e64211a34457 = (0, $7NszV.createEntry)((0, $5dFt2.classicProjectSettingsSoftwareNotificationsIssueLogsRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.classic-issue-logs-page',
        component: (0, $14B4q.SoftwareNotificationsIssueLogs),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $dxCvy.projectContextResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $14B4q.LazySoftwareNotificationsIssueLogs)
        ],
        entryPoint () {
            return 0, $14B4q.emailNotificationsLogEntryPointPage;
        }
    }));

});
parcelRegister("5dFt2", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsSoftwareNotificationsIssueLogsRoute", () => $631b97d030b0c8f3$export$5e2e0a895d6a14bd);
const $631b97d030b0c8f3$export$5e2e0a895d6a14bd = {
    name: 'classic-software-notifications-issue-logs',
    path: '/jira/software/c/projects/:projectKey/settings/notifications/issue-logs',
    query: [
        'projectId'
    ]
};

});

parcelRegister("14B4q", function(module, exports) {

$parcel$export(module.exports, "emailNotificationsLogEntryPointPage", () => $e5cbde6b3cad4f8b$export$cd8964bea0e3c2);
$parcel$export(module.exports, "LazySoftwareNotificationsIssueLogs", () => $e5cbde6b3cad4f8b$export$6960a46ebd209756);
$parcel$export(module.exports, "SoftwareNotificationsIssueLogs", () => $e5cbde6b3cad4f8b$export$4b75df09cc5b4e8e);

var $5uXOq = parcelRequire("5uXOq");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $femMW = parcelRequire("femMW");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");
const $e5cbde6b3cad4f8b$export$cd8964bea0e3c2 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $femMW.notificationsIssueLogsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

const $e5cbde6b3cad4f8b$export$6960a46ebd209756 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("5Q8bv"))), {
    moduleId: "./src/packages/spa-apps/project-settings/software-notifications-issue-logs/src/index.tsx"
});
const $e5cbde6b3cad4f8b$export$4b75df09cc5b4e8e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e5cbde6b3cad4f8b$export$6960a46ebd209756,
        pageId: "project-settings-software-notifications-issue-logs",
        shouldShowSpinner: false
    });

});


parcelRegister("1K27j", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsSoftwareProformaEditFormsRouteEntry", () => $7a878339e2d71181$export$e730b13555ff0c60);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $gSRO9 = parcelRequire("gSRO9");

var $e7bC3 = parcelRequire("e7bC3");

var $1XdKx = parcelRequire("1XdKx");

var $8JnjW = parcelRequire("8JnjW");
const $7a878339e2d71181$export$e730b13555ff0c60 = (0, $7NszV.createEntry)((0, $gSRO9.classicProjectSettingsSoftwareProformaEditFormsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $8JnjW.default),
        layout: (0, $e7bC3.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8JnjW.LazyProjectSettingsProformaJiraFormBuilder)
        ]
    }));

});
parcelRegister("gSRO9", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsSoftwareProformaEditFormsRoute", () => $db0151a276af1837$export$811ace4fee984f0e);
const $db0151a276af1837$export$811ace4fee984f0e = {
    name: 'project-settings-software-proforma-edit-forms',
    path: '/jira/software/c/projects/:projectKey/settings/forms/form/:templateFormId/edit',
    exact: true
};

});

parcelRegister("1XdKx", function(module, exports) {

$parcel$export(module.exports, "SOFTWARE_PRODUCT", () => $3caec8e095a44ec5$export$2954328f6207617a);
$parcel$export(module.exports, "getSettingsNavigationResources", () => $3caec8e095a44ec5$export$586756e5c0542a50);
$parcel$export(module.exports, "RedirectForSettings", () => $3caec8e095a44ec5$export$fb15a6ba8980fdac);
$parcel$export(module.exports, "RedirectForSettingsForClassicProject", () => $3caec8e095a44ec5$export$f9befa0a4925b36d);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $1J3t1 = parcelRequire("1J3t1");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $7tQej = parcelRequire("7tQej");
const $3caec8e095a44ec5$export$2954328f6207617a = 'software';
const $3caec8e095a44ec5$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $3caec8e095a44ec5$export$586756e5c0542a50 = ()=>{
    return [
        ...(0, $3RJkv.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $7GnDe.incidentExperimentTraitResource),
        (0, $dxCvy.projectContextResource),
        (0, $5bkvv.forgeProjectModuleResource),
        (0, $iEUaw.staticSidebarShortcutsResource),
        (0, $ggg5j.staticProjectSidebarNavigationResource),
        (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)()
    ];
};
const $3caec8e095a44ec5$export$fb15a6ba8980fdac = ({ match: match })=>{
    const { data: data } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    const { projectKey: projectKey } = match.params;
    if (data?.permissionInfo?.isAdmin || data?.permissionInfo?.isSiteAdmin || data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/jira/software/projects/${String(match.params.projectKey)}/settings/details`
    });
    // the next three if branches do not make a lot of sense for TMP as you always a project admin in TMP
    // however a wrong link is generated by the nav4 navbar for CMP projects which matches to this redirect logic
    // ex: "/jira/software/projects/JSWCMP1/settings"
    // instead it should be "/jira/software/c/projects/JSWCMP1/settings"
    // which matches to CMP redirect logic defined in RedirectForSettingsForClassicProject
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_WORKFLOW === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/workflows`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_ISSUE_LAYOUT === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/issuelayout`
    });
    if ((0, $4R6GH.fg)('vmc-11-manage-versions-permission')) {
        if (data?.permissionInfo?.projectPermissionsQueried?.MANAGE_VERSIONS === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: `/plugins/servlet/project-config/${String(projectKey)}/administer-versions`
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/jira/software/projects/${String(match.params.projectKey)}/settings/details`
    });
};
const $3caec8e095a44ec5$export$f9befa0a4925b36d = ({ match: match })=>{
    const { data: data } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    const { projectKey: projectKey } = match.params;
    if (data?.permissionInfo?.isAdmin || data?.permissionInfo?.isSiteAdmin || data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/jira/software/c/projects/${String(projectKey)}/settings/details`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_WORKFLOW === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/workflows`
    });
    if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_ISSUE_LAYOUT === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/plugins/servlet/project-config/${String(projectKey)}/issuelayout`
    });
    if ((0, $4R6GH.fg)('vmc-11-manage-versions-permission')) {
        if (data?.permissionInfo?.projectPermissionsQueried?.MANAGE_VERSIONS === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: `/plugins/servlet/project-config/${String(projectKey)}/administer-versions`
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/jira/software/c/projects/${String(projectKey)}/settings/details`
    });
};

});

parcelRegister("8JnjW", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsProformaJiraFormBuilder", () => $c3a9ed7dcac6be32$export$a7d63246a10aedd);
$parcel$export(module.exports, "default", () => $c3a9ed7dcac6be32$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $c3a9ed7dcac6be32$export$a7d63246a10aedd = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("7R9RB")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-jira-form-builder/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c3a9ed7dcac6be32$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $c3a9ed7dcac6be32$export$a7d63246a10aedd,
        pageId: "project-settings-proforma-jira-form-builder",
        shouldShowSpinner: true
    });

});


parcelRegister("8DQ40", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsSoftwareProformaFormsRouteEntry", () => $c13f5ba4ed49c128$export$5e67ac6f50ae37e1);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $epiJW = parcelRequire("epiJW");

var $e7bC3 = parcelRequire("e7bC3");

var $1XdKx = parcelRequire("1XdKx");

var $gyEpf = parcelRequire("gyEpf");
const $c13f5ba4ed49c128$export$5e67ac6f50ae37e1 = (0, $7NszV.createEntry)((0, $epiJW.classicProjectSettingsSoftwareProformaFormsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $gyEpf.default),
        layout: (0, $e7bC3.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gyEpf.LazyProjectSettingsProformaProjectForms)
        ]
    }));

});
parcelRegister("epiJW", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsSoftwareProformaFormsRoute", () => $7b818f933be215b1$export$2313ca001d58ab27);
const $7b818f933be215b1$export$2313ca001d58ab27 = {
    name: 'project-settings-software-proforma-project-forms',
    path: '/jira/software/c/projects/:projectKey/settings/forms',
    exact: true
};

});

parcelRegister("gyEpf", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsProformaProjectForms", () => $97406b66ba2de080$export$38414b624a749cec);
$parcel$export(module.exports, "default", () => $97406b66ba2de080$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $97406b66ba2de080$export$38414b624a749cec = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("cShK4")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-project-forms/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$97406b66ba2de080$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $97406b66ba2de080$export$38414b624a749cec,
        pageId: "project-settings-proforma-project-forms",
        shouldShowSpinner: true
    });

});


parcelRegister("hdWS0", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsSoftwareRedirectRouteEntry", () => $5fe7bdc999ce9cdf$export$3c7d008bbb14e2b);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $7OjcI = parcelRequire("7OjcI");

var $e7bC3 = parcelRequire("e7bC3");

var $1XdKx = parcelRequire("1XdKx");
const $5fe7bdc999ce9cdf$export$3c7d008bbb14e2b = (0, $7NszV.createEntry)((0, $7OjcI.classicProjectSettingsSoftwareRedirectRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $1XdKx.RedirectForSettingsForClassicProject),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("7OjcI", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsSoftwareRedirectRoute", () => $eb74524e076aae09$export$99b695c2b8299b5a);
const $eb74524e076aae09$export$99b695c2b8299b5a = {
    // the following route should be non-exact, it will handle "index" and "404" cases
    name: 'classic-software-redirect',
    path: '/jira/software/c/projects/:projectKey/settings'
};

});


parcelRegister("9MTKv", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsToolchainRouteEntry", () => $42ebeced13391ae5$export$1fe479c54f4d7684);

var $ffza4 = parcelRequire("ffza4");

var $bwLf9 = parcelRequire("bwLf9");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $35Wvp = parcelRequire("35Wvp");

var $7GnDe = parcelRequire("7GnDe");

var $5lsNZ = parcelRequire("5lsNZ");

var $gTGp2 = parcelRequire("gTGp2");

var $kfztd = parcelRequire("kfztd");

var $e7bC3 = parcelRequire("e7bC3");

var $aA5DA = parcelRequire("aA5DA");
const $42ebeced13391ae5$export$1fe479c54f4d7684 = (0, $7NszV.createEntry)((0, $gTGp2.classicProjectSettingsToolchainRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $bwLf9.default)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $aA5DA.default)),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $dxCvy.projectContextResource),
            (0, $35Wvp.projectSettingsToolchainResource)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aA5DA.LazyDevOpsConnectionsSettings)
        ],
        ufoName: 'project-settings.devops-connections'
    }));

});
parcelRegister("35Wvp", function(module, exports) {

$parcel$export(module.exports, "projectSettingsToolchainResource", () => $ed037648996bd812$export$182dfe2bc7c28567);

var $ao2h1 = parcelRequire("ao2h1");

var $avVgl = parcelRequire("avVgl");
const $ed037648996bd812$export$b8927fea69d9f414 = 'PROJECT_SETTINGS_TOOLCHAIN';
const $ed037648996bd812$export$182dfe2bc7c28567 = (0, $ao2h1.createRelayResource)({
    type: $ed037648996bd812$export$b8927fea69d9f414,
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $avVgl.default),
            variables: {
                cloudId: tenantContext?.cloudId || ''
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("avVgl", function(module, exports) {

$parcel$export(module.exports, "default", () => $5afd24d8f370d3e2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a2c9dc099d3b7d79cd74bd591996a945>>
 * @relayHash f5bf042c501578b47d326c7288427026
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2fc1f152f5ebcdcb577d22b928c317e308c8daf161c302627c4f00951b909409
const $5afd24d8f370d3e2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "concreteType": "DvcsQuery",
            "kind": "LinkedField",
            "name": "dvcs",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1
                        }
                    ],
                    "concreteType": "DvcsBitbucketWorkspaceConnection",
                    "kind": "LinkedField",
                    "name": "bitbucketWorkspacesLinkedToSite",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "DvcsBitbucketWorkspaceEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ui_projectSettingsToolchainQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ui_projectSettingsToolchainQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "2fc1f152f5ebcdcb577d22b928c317e308c8daf161c302627c4f00951b909409",
            "metadata": {},
            "name": "ui_projectSettingsToolchainQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5afd24d8f370d3e2$var$node.hash = "190735208b3c7baafbfc3c1808fa801b";
var $5afd24d8f370d3e2$export$2e2bcd8739ae039 = $5afd24d8f370d3e2$var$node;

});


parcelRegister("gTGp2", function(module, exports) {

$parcel$export(module.exports, "classicProjectSettingsToolchainRoute", () => $8d33965caf47a037$export$7dbc23deac9553d4);
const $8d33965caf47a037$export$7dbc23deac9553d4 = {
    name: 'project-settings-software-toolchain-company-managed',
    path: '/jira/software/c/projects/:projectKey/settings/toolchain',
    exact: true
};

});

parcelRegister("aA5DA", function(module, exports) {

$parcel$export(module.exports, "LazyDevOpsConnectionsSettings", () => $11c79a07a4ec83b8$export$9d468faf674a5201);
$parcel$export(module.exports, "default", () => $11c79a07a4ec83b8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $11c79a07a4ec83b8$export$9d468faf674a5201 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("l0MM7")), {
    moduleId: "./src/packages/spa-apps/project-settings/connections/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$11c79a07a4ec83b8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $11c79a07a4ec83b8$export$9d468faf674a5201,
        pageId: "devops-connections-settings",
        shouldShowSpinner: false
    });

});
parcelRegister("l0MM7", function(module, exports) {

let $f4bf6ecbe8054cbc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f4bf6ecbe8054cbc$var$load("jyibG").then(()=>parcelRequire('a0GzC'));

});



parcelRegister("d2uL5", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesNoteConfigRouteEntry", () => $212dfb46ac85d619$export$836428e7b33b6c6c);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $j3hwR = parcelRequire("j3hwR");

var $e7bC3 = parcelRequire("e7bC3");

var $9PHNK = parcelRequire("9PHNK");
const $212dfb46ac85d619$export$836428e7b33b6c6c = (0, $7NszV.createEntry)((0, $j3hwR.legacyProjectReleasesNoteConfigRoute), ()=>({
        group: 'project-settings-software',
        resources: [
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        component: (0, $9PHNK.LegacyFrontendReleaseNoteRedirect),
        layout: (0, $e7bC3.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("j3hwR", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesNoteConfigRoute", () => $1e459e992a50ef9a$export$a9509017cabb1e30);
const $1e459e992a50ef9a$export$a9509017cabb1e30 = {
    name: 'legacy-project-releases-note-config',
    path: '/secure/ConfigureReleaseNote.jspa',
    query: [
        'projectId',
        'version'
    ]
};

});

parcelRegister("9PHNK", function(module, exports) {

$parcel$export(module.exports, "BoardSettingsRedirectToCSM", () => $3fda9f3e07781c4c$export$ccce5315da25c53e);
$parcel$export(module.exports, "RoadmapSettingsRedirectToTimelineSettings", () => $3fda9f3e07781c4c$export$eaa324972a212c18);
$parcel$export(module.exports, "SpaReleaseNoteRedirectToVersionDetails", () => $3fda9f3e07781c4c$export$52fa4fd8ca9baab5);
$parcel$export(module.exports, "LegacyFrontendReleaseNoteRedirect", () => $3fda9f3e07781c4c$export$dee47264404d89a0);
$parcel$export(module.exports, "getUFOName", () => $3fda9f3e07781c4c$export$759ec9adbd19c936);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $b5AbL = parcelRequire("b5AbL");

var $7tQej = parcelRequire("7tQej");
const $3fda9f3e07781c4c$export$ccce5315da25c53e = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/jira/software/projects/${String(match.params.projectKey)}/settings/boards/${String(match.params.boardId)}/columns`,
        push: false
    });
const $3fda9f3e07781c4c$export$eaa324972a212c18 = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/jira/software/projects/${String(match.params.projectKey)}/settings/boards/${String(match.params.boardId)}/timeline`,
        push: false
    });
const $3fda9f3e07781c4c$export$52fa4fd8ca9baab5 = ({ query: query })=>{
    const { version: versionId } = query;
    const { loading: loading, error: error, projectKey: projectKey } = (0, $b5AbL.useProjectKeyByProjectResource)();
    if (loading === false && error) return null;
    if (loading) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: {
            pathname: `/projects/${projectKey}/versions/${versionId}/tab/release-report-all-issues`,
            hash: '',
            search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
                isReleaseNoteModalOpen: true
            })
        }
    });
};
const $3fda9f3e07781c4c$export$dee47264404d89a0 = ({ query: query })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: {
            pathname: '/secure/ReleaseNote.jspa',
            hash: '',
            search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
                ...query,
                isRedirectedFromLegacy: true
            })
        }
    });
const $3fda9f3e07781c4c$var$ufoNamesMap = {
    'project-settings-software-issuetypes': 'project-settings.issue-type.jsw-tmp',
    'project-settings-servicedesk-issuetypes': 'project-settings.issue-type.jsm-tmp'
};
const $3fda9f3e07781c4c$export$759ec9adbd19c936 = (name)=>$3fda9f3e07781c4c$var$ufoNamesMap[name] || name;

});
parcelRegister("b5AbL", function(module, exports) {

$parcel$export(module.exports, "useProjectKeyByProjectResource", () => $347c2a822ae60413$export$899fd1c46031ece8);

var $jcw0u = parcelRequire("jcw0u");

var $2YP9W = parcelRequire("2YP9W");

var $dxCvy = parcelRequire("dxCvy");
const $347c2a822ae60413$export$899fd1c46031ece8 = (teamName)=>{
    const { data: data, error: resourceError, loading: loading } = (0, $2YP9W.useResource)((0, $dxCvy.projectContextResource));
    if (resourceError && data == null) {
        const isErrorErrorType = resourceError instanceof Error;
        const error = isErrorErrorType ? resourceError : new Error(`projectContextResource returned error resourceError: ${JSON.stringify(resourceError)}, loading: ${loading}, data: null`);
        (0, $jcw0u.default)({
            meta: {
                id: 'useResourceProjectContext',
                packageName: 'jiraRouterResourcesProjectContext',
                teamName: teamName ?? 'magma'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            loading: false,
            error: error,
            projectKey: null
        };
    }
    if (loading) return {
        loading: true,
        error: null,
        projectKey: null
    };
    // This case never happens by type definition, which you can't even mock test data for this case due to type definition. But if you don't check this, TS is not happy
    if (data == null) return {
        loading: false,
        error: new Error('projectContextResource returned data=null when loading false'),
        projectKey: null
    };
    return {
        loading: false,
        projectKey: data.projectKey,
        error: null
    };
};

});



parcelRegister("2ubrr", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesNoteRouteEntry", () => $a8cc91e8c082e291$export$781dd53d465d270d);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $9xZTT = parcelRequire("9xZTT");

var $e7bC3 = parcelRequire("e7bC3");

var $9PHNK = parcelRequire("9PHNK");
const $a8cc91e8c082e291$export$781dd53d465d270d = (0, $7NszV.createEntry)((0, $9xZTT.legacyProjectReleasesNoteRoute), ()=>({
        group: 'project-settings-software',
        resources: [
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        component: (0, $9PHNK.LegacyFrontendReleaseNoteRedirect),
        layout: (0, $e7bC3.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("9xZTT", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesNoteRoute", () => $6ea4b44e61fd0227$export$6ef734887b6da0c8);
const $6ea4b44e61fd0227$export$6ef734887b6da0c8 = {
    name: 'legacy-project-releases-note',
    path: '/jira/secure/ReleaseNote.jspa',
    query: [
        'projectId',
        'version'
    ]
};

});


parcelRegister("d7mi1", function(module, exports) {

$parcel$export(module.exports, "projectSettingsAutomationCRouteEntry", () => $93ddc77854479226$export$8a6c5a399335fa16);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $jTltG = parcelRequire("jTltG");

var $e7bC3 = parcelRequire("e7bC3");

var $kdqX9 = parcelRequire("kdqX9");
const $93ddc77854479226$export$8a6c5a399335fa16 = (0, $7NszV.createEntry)((0, $jTltG.projectSettingsAutomationCRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings-automation-c',
        component: (0, $kdqX9.default),
        layout: (0, $e7bC3.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $dxCvy.projectContextResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kdqX9.LazyProjectSettingsJiraAutomation)
        ]
    }));

});
parcelRegister("jTltG", function(module, exports) {

$parcel$export(module.exports, "projectSettingsAutomationCRoute", () => $c472df0c8cbe0617$export$5337cc16f271a9cf);
const $c472df0c8cbe0617$export$5337cc16f271a9cf = {
    name: 'project-settings-automation',
    path: '/jira/software/c/projects/:projectKey/settings/automate'
};

});

parcelRegister("kdqX9", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsJiraAutomation", () => $4700cd79d99e02ea$export$dea5ad7e8eac12ae);
$parcel$export(module.exports, "default", () => $4700cd79d99e02ea$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $4700cd79d99e02ea$export$dea5ad7e8eac12ae = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("3Dp46")), {
    moduleId: "./src/packages/spa-apps/project-settings/jira-automation/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4700cd79d99e02ea$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $4700cd79d99e02ea$export$dea5ad7e8eac12ae,
        pageId: "project-settings-jira-automation",
        shouldShowSpinner: true
    });

});


parcelRegister("5HfC7", function(module, exports) {

$parcel$export(module.exports, "projectSettingsAutomationRouteEntry", () => $4db68a59886d705c$export$a34f85c5b69f2c2f);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $33SkB = parcelRequire("33SkB");

var $e7bC3 = parcelRequire("e7bC3");

var $kdqX9 = parcelRequire("kdqX9");

var $1XdKx = parcelRequire("1XdKx");
const $4db68a59886d705c$export$a34f85c5b69f2c2f = (0, $7NszV.createEntry)((0, $33SkB.projectSettingsAutomationRoute), ()=>({
        group: 'project-settings-software',
        ufoName: `project-settings-automation-${0, $1XdKx.SOFTWARE_PRODUCT}`,
        component: (0, $kdqX9.default),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kdqX9.LazyProjectSettingsJiraAutomation)
        ]
    }));

});
parcelRegister("33SkB", function(module, exports) {

$parcel$export(module.exports, "projectSettingsAutomationRoute", () => $ccabe492276f268a$export$7809aa084868deea);
const $ccabe492276f268a$export$7809aa084868deea = {
    name: 'project-settings-automation',
    path: '/jira/software/projects/:projectKey/settings/automate'
};

});


parcelRegister("7QAza", function(module, exports) {

$parcel$export(module.exports, "projectSettingsForgeAppsNextgenRouteEntry", () => $0239e22c8f9a631b$export$872a0285d27dfa47);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $kvHR2 = parcelRequire("kvHR2");

var $e7bC3 = parcelRequire("e7bC3");

var $dBDdA = parcelRequire("dBDdA");

var $1XdKx = parcelRequire("1XdKx");
const $0239e22c8f9a631b$export$872a0285d27dfa47 = (0, $7NszV.createEntry)((0, $kvHR2.projectSettingsForgeAppsNextgenRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $dBDdA.default),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)(),
            ...(0, $dBDdA.forgeProjectSettingsPageResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $dBDdA.LazyForgeProjectSettingsPage)
        ]
    }));

});
parcelRegister("kvHR2", function(module, exports) {

$parcel$export(module.exports, "projectSettingsForgeAppsNextgenRoute", () => $c8db0ba1a5916a92$export$8559c4a0b692890e);
const $c8db0ba1a5916a92$export$8559c4a0b692890e = {
    name: 'project-settings-software-apps-forge',
    path: '/jira/software/projects/:projectKey/settings/apps/:appId/:envId/:route?'
};

});

parcelRegister("dBDdA", function(module, exports) {

$parcel$export(module.exports, "LazyForgeProjectSettingsPage", () => $fa6a5556191902b5$export$ef66d3f49a9953d8);
$parcel$export(module.exports, "forgeProjectSettingsPageResources", () => $fa6a5556191902b5$export$33d85a1b2211b38);
$parcel$export(module.exports, "default", () => $fa6a5556191902b5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5bkvv = parcelRequire("5bkvv");

var $dxCvy = parcelRequire("dxCvy");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $fa6a5556191902b5$export$ef66d3f49a9953d8 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("bZbyt")), {
    moduleId: "./src/packages/spa-apps/forge/project-settings/src/index.tsx"
});
const $fa6a5556191902b5$export$33d85a1b2211b38 = ()=>[
        (0, $dxCvy.projectContextResourceWithCache),
        (0, $5bkvv.forgeProjectSettingsModuleResource)
    ];
const $fa6a5556191902b5$export$b943f48844c671a5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $fa6a5556191902b5$export$ef66d3f49a9953d8,
        pageId: "forge-spa-project-settings",
        shouldShowSpinner: true
    });
var $fa6a5556191902b5$export$2e2bcd8739ae039 = $fa6a5556191902b5$export$b943f48844c671a5;

});


parcelRegister("5MiVl", function(module, exports) {

$parcel$export(module.exports, "projectSettingsForgeAppsRouteEntry", () => $9bf506152004886d$export$54d0d8466c8b40dc);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $iSJL6 = parcelRequire("iSJL6");

var $e7bC3 = parcelRequire("e7bC3");

var $dBDdA = parcelRequire("dBDdA");
const $9bf506152004886d$export$54d0d8466c8b40dc = (0, $7NszV.createEntry)((0, $iSJL6.projectSettingsForgeAppsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $dBDdA.default),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $dBDdA.forgeProjectSettingsPageResources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $dBDdA.LazyForgeProjectSettingsPage)
        ]
    }));

});
parcelRegister("iSJL6", function(module, exports) {

$parcel$export(module.exports, "projectSettingsForgeAppsRoute", () => $dbb37015acdc19c0$export$f74a0b1be9d5b9f6);
const $dbb37015acdc19c0$export$f74a0b1be9d5b9f6 = {
    name: 'project-settings-software-forge-apps',
    path: '/jira/software/c/projects/:projectKey/settings/apps/:appId/:envId/:route?'
};

});


parcelRegister("ee5pi", function(module, exports) {

$parcel$export(module.exports, "projectSettingsOpsgenieRouteEntry", () => $d6930e98cb7e7363$export$4b4bfb4318f5a98e);

var $ffza4 = parcelRequire("ffza4");

var $bwLf9 = parcelRequire("bwLf9");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $5lsNZ = parcelRequire("5lsNZ");

var $a8P7Z = parcelRequire("a8P7Z");

var $kfztd = parcelRequire("kfztd");

var $e7bC3 = parcelRequire("e7bC3");

var $1KQBW = parcelRequire("1KQBW");

var $1XdKx = parcelRequire("1XdKx");
const $d6930e98cb7e7363$export$4b4bfb4318f5a98e = (0, $7NszV.createEntry)((0, $a8P7Z.projectSettingsOpsgenieRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $bwLf9.default)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $1KQBW.default)),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $1KQBW.LazyLinkOpsgeniePage)
        ],
        ufoName: 'project-settings.link-opsgenie'
    }));

});
parcelRegister("a8P7Z", function(module, exports) {

$parcel$export(module.exports, "projectSettingsOpsgenieRoute", () => $6ef9ba56e8ee2329$export$c7039de5a4b78802);
const $6ef9ba56e8ee2329$export$c7039de5a4b78802 = {
    name: 'project-settings-software-link-opsgenie',
    path: '/jira/software/projects/:projectKey/settings/opsgenie',
    exact: true
};

});


parcelRegister("3SReJ", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAccessRedirectRouteEntry", () => $ba86f21f622e78fc$export$99415df4033272f);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $9X7Hu = parcelRequire("9X7Hu");

var $e7bC3 = parcelRequire("e7bC3");

var $8ODWq = parcelRequire("8ODWq");

var $1XdKx = parcelRequire("1XdKx");
const $ba86f21f622e78fc$export$99415df4033272f = (0, $7NszV.createEntry)((0, $9X7Hu.projectSettingsSoftwareAccessRedirectRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $8ODWq.peopleAccessRedirect)(`/jira/${(0, $1XdKx.SOFTWARE_PRODUCT)}`),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8ODWq.LazyPeopleSettings)
        ]
    }));

});
parcelRegister("9X7Hu", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAccessRedirectRoute", () => $82c1f2665cb2cc20$export$55335c81a2be4654);
const $82c1f2665cb2cc20$export$55335c81a2be4654 = {
    name: 'project-settings-software-access-redirect',
    path: '/jira/software/projects/:projectKey/settings/people',
    exact: true
};

});

parcelRegister("8ODWq", function(module, exports) {

$parcel$export(module.exports, "LazyPeopleSettings", () => $3671536b80f548b9$export$7eee4f97b7a1273);
$parcel$export(module.exports, "peopleAccessRedirect", () => $3671536b80f548b9$export$45346ed2aa24e3f3);
$parcel$export(module.exports, "default", () => $3671536b80f548b9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $7tQej = parcelRequire("7tQej");

const $3671536b80f548b9$export$7eee4f97b7a1273 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("8pwbR"))), {
    moduleId: "./src/packages/spa-apps/project-settings/people/src/index.tsx"
});
const $3671536b80f548b9$var$PeopleAccessRedirectInner = ({ match: match, basePath: basePath })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `${basePath}/projects/${String(match.params.projectKey)}/settings/access`,
        push: false
    });
const $3671536b80f548b9$export$45346ed2aa24e3f3 = (basePath)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3671536b80f548b9$var$PeopleAccessRedirectInner, {
            match: match,
            basePath: basePath
        });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3671536b80f548b9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3671536b80f548b9$export$7eee4f97b7a1273,
        pageId: "project-settings-people",
        shouldShowSpinner: false
    });

});


parcelRegister("aLuho", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAccessRouteEntry", () => $298f52c63e8d86c3$export$a5ead9d0de14b14b);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $lJe4p = parcelRequire("lJe4p");

var $jaAyo = parcelRequire("jaAyo");

var $e7bC3 = parcelRequire("e7bC3");

var $8ODWq = parcelRequire("8ODWq");

var $1XdKx = parcelRequire("1XdKx");
const $298f52c63e8d86c3$export$a5ead9d0de14b14b = (0, $7NszV.createEntry)((0, $lJe4p.projectSettingsSoftwareAccessRoute), ()=>({
        group: 'project-settings-software',
        skeleton: (0, $jaAyo.ProjectSettingsAccessSkeleton),
        component: (0, $8ODWq.default),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8ODWq.LazyPeopleSettings)
        ],
        ufoName: 'project-settings.access'
    }));

});
parcelRegister("lJe4p", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAccessRoute", () => $b825fa291dbed4f2$export$db689602f90567d8);
const $b825fa291dbed4f2$export$db689602f90567d8 = {
    name: 'project-settings-software-access',
    path: '/jira/software/projects/:projectKey/settings/access',
    exact: true
};

});


parcelRegister("3YX4q", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAppsFieldsRouteEntry", () => $0c75b4b7b48f7f91$export$78d9c4be1503dd23);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $d6jlO = parcelRequire("d6jlO");

var $e7bC3 = parcelRequire("e7bC3");

var $5GDQc = parcelRequire("5GDQc");

var $1XdKx = parcelRequire("1XdKx");
const $0c75b4b7b48f7f91$export$78d9c4be1503dd23 = (0, $7NszV.createEntry)((0, $d6jlO.projectSettingsSoftwareAppsFieldsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $5GDQc.default),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5GDQc.LazyConnectAppControlsSettings)
        ]
    }));

});
parcelRegister("d6jlO", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAppsFieldsRoute", () => $d1b04e5d85adc782$export$333c94a9ec1a1535);
const $d1b04e5d85adc782$export$333c94a9ec1a1535 = {
    name: 'project-settings-software-apps-fields',
    path: '/jira/software/projects/:projectKey/settings/apps/app-fields',
    exact: true
};

});

parcelRegister("5GDQc", function(module, exports) {

$parcel$export(module.exports, "LazyConnectAppControlsSettings", () => $c49a5a5e07aed0ac$export$246ec9cdadd2a163);
$parcel$export(module.exports, "default", () => $c49a5a5e07aed0ac$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $dAfqg = parcelRequire("dAfqg");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $7tQej = parcelRequire("7tQej");

var $looJs = parcelRequire("looJs");

const $c49a5a5e07aed0ac$export$246ec9cdadd2a163 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("1j8hG"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-app-controls/src/index.tsx"
});
const $c49a5a5e07aed0ac$var$ConnectAppsRedirectInner = ({ match: match, basePath: basePath })=>{
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const shouldRedirect = projectContext != null && projectContext.simplified && projectContext.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
    return shouldRedirect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `${basePath}/projects/${String(match.params.projectKey)}/settings/apps/app-fields`,
        push: false
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $looJs.default), null);
};
const $c49a5a5e07aed0ac$export$cc3414a2d9daf70d = (basePath)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c49a5a5e07aed0ac$var$ConnectAppsRedirectInner, {
            match: match,
            basePath: basePath
        });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c49a5a5e07aed0ac$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $c49a5a5e07aed0ac$export$246ec9cdadd2a163,
        pageId: "project-settings-connect-app-controls",
        shouldShowSpinner: false
    });

});
parcelRegister("looJs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab1da42a9104ecee$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $ab1da42a9104ecee$export$fa3bc297af95f169 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("3cuPS"))), {
    moduleId: "./src/packages/spa-apps/project-settings/app-discovery-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ab1da42a9104ecee$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $ab1da42a9104ecee$export$fa3bc297af95f169,
        pageId: "project-settings-app-discovery-settings",
        shouldShowSpinner: false
    });

});
parcelRegister("3cuPS", function(module, exports) {

let $254a696a14cd40fc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $254a696a14cd40fc$var$load("koyH0").then(()=>parcelRequire('jgXd4'));

});




parcelRegister("kEFGH", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAppsRouteEntry", () => $0ed53dac2f0a0ceb$export$290fcdffa80c48ce);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $g44Z8 = parcelRequire("g44Z8");

var $e7bC3 = parcelRequire("e7bC3");

var $jwbRB = parcelRequire("jwbRB");

var $1XdKx = parcelRequire("1XdKx");
const $0ed53dac2f0a0ceb$export$290fcdffa80c48ce = (0, $7NszV.createEntry)((0, $g44Z8.projectSettingsSoftwareAppsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $jwbRB.default),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $jwbRB.LazyConnectAppsSettings)
        ]
    }));

});
parcelRegister("g44Z8", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAppsRoute", () => $2fe06dc3c4459510$export$aece357f5f434121);
const $2fe06dc3c4459510$export$aece357f5f434121 = {
    name: 'project-settings-software-apps',
    path: '/jira/software/projects/:projectKey/settings/apps/:appId?',
    exact: true
};

});

parcelRegister("jwbRB", function(module, exports) {

$parcel$export(module.exports, "LazyConnectAppsSettings", () => $0d3ebe2f9030fc49$export$3633e017e520a1c2);
$parcel$export(module.exports, "default", () => $0d3ebe2f9030fc49$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $0d3ebe2f9030fc49$export$3633e017e520a1c2 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("flIAq"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-apps/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0d3ebe2f9030fc49$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $0d3ebe2f9030fc49$export$3633e017e520a1c2,
        pageId: "project-settings-connect-apps",
        shouldShowSpinner: false
    });

});


parcelRegister("kwWQ0", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAutomationRouteEntry", () => $5d7bd87a7c840c7a$export$fb1f0477184046c5);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $lecb5 = parcelRequire("lecb5");

var $e7bC3 = parcelRequire("e7bC3");

var $kdqX9 = parcelRequire("kdqX9");

var $1XdKx = parcelRequire("1XdKx");
const $5d7bd87a7c840c7a$export$fb1f0477184046c5 = (0, $7NszV.createEntry)((0, $lecb5.projectSettingsSoftwareAutomationRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $kdqX9.default),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kdqX9.LazyProjectSettingsJiraAutomation)
        ]
    }));

});
parcelRegister("lecb5", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareAutomationRoute", () => $fc9d7be9739092f6$export$4d430aeb28b702f8);
const $fc9d7be9739092f6$export$4d430aeb28b702f8 = {
    name: 'project-settings-software-automation',
    path: '/jira/software/projects/:projectKey/settings/automation',
    exact: true
};

});


parcelRegister("7F7I9", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsCardRouteEntry", () => $f60e688753874fc2$export$ca616a5516b2e16d);

var $ffza4 = parcelRequire("ffza4");

var $1xZqw = parcelRequire("1xZqw");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $63xkH = parcelRequire("63xkH");

var $e7bC3 = parcelRequire("e7bC3");

var $1XdKx = parcelRequire("1XdKx");

var $lN3Iw = parcelRequire("lN3Iw");
const $f60e688753874fc2$export$ca616a5516b2e16d = (0, $7NszV.createEntry)((0, $63xkH.projectSettingsSoftwareBoardsCardRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'board-settings-apps.card-cover-settings-page.page.load',
        component: (0, $lN3Iw.default),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)(),
            (0, $1xZqw.cardCoverImageResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $lN3Iw.LazyCard)
        ]
    }));

});
parcelRegister("1xZqw", function(module, exports) {

$parcel$export(module.exports, "cardCoverImageResource", () => $0fcabd2255a2311c$export$f37f52e28126ce75);

var $dXq4S = parcelRequire("dXq4S");

var $ao2h1 = parcelRequire("ao2h1");

var $eQDse = parcelRequire("eQDse");

const $0fcabd2255a2311c$export$f37f52e28126ce75 = (0, $ao2h1.createRelayResource)({
    type: (0, $b9b0da783aed9042$export$d9d248919fbd0611),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $eQDse.default),
            variables: {
                boardId: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("eQDse", function(module, exports) {

$parcel$export(module.exports, "default", () => $19be575ffa3b6370$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<18030b1362ffffdd2f24b83852b88efd>>
 * @relayHash b790d69589aa0ef2a06a10dc57fc6bfc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4216a4fc24eb7ed0390f1effcdb5558af09a70f95660a0c572ae4b531ddc98fc
const $19be575ffa3b6370$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "cardCoverSettingsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "SoftwareBoard",
                                    "kind": "LinkedField",
                                    "name": "board",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "toggle_boardSettingsCard_CardCoverToggle"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "cardPreview_boardSettingsCard"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.board"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "cardCoverSettingsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SoftwareBoard",
                            "kind": "LinkedField",
                            "name": "board",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CardMediaConfig",
                                    "kind": "LinkedField",
                                    "name": "cardMedia",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "enabled"
                                        }
                                    ]
                                },
                                v2 /*: any*/ 
                            ]
                        },
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "4216a4fc24eb7ed0390f1effcdb5558af09a70f95660a0c572ae4b531ddc98fc",
            "metadata": {},
            "name": "cardCoverSettingsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$19be575ffa3b6370$var$node.hash = "eb3068eeffbe9ec2fb99186c54005ea6";
var $19be575ffa3b6370$export$2e2bcd8739ae039 = $19be575ffa3b6370$var$node;

});

const $b9b0da783aed9042$export$d9d248919fbd0611 = 'BOARD_CONTEXT_CARD_COVER_SETTINGS';


parcelRegister("63xkH", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsCardRoute", () => $fd58dce0fef4a2da$export$d3f185a361401db7);
const $fd58dce0fef4a2da$export$d3f185a361401db7 = {
    name: 'project-settings-software-boards-card',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId/card',
    exact: true
};

});

parcelRegister("lN3Iw", function(module, exports) {

$parcel$export(module.exports, "LazyCard", () => $4bec2fc264f66dc5$export$40ff283c032abbc4);
$parcel$export(module.exports, "default", () => $4bec2fc264f66dc5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $4bec2fc264f66dc5$export$40ff283c032abbc4 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("3YP1H")), {
    moduleId: "./src/packages/spa-apps/project-settings/board-settings/card/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4bec2fc264f66dc5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $4bec2fc264f66dc5$export$40ff283c032abbc4,
        pageId: "board-settings-card",
        shouldShowSpinner: false
    });

});
parcelRegister("3YP1H", function(module, exports) {

let $2e5e8e7a6b33af0b$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("1u6BA"), 4)),
    $2e5e8e7a6b33af0b$var$load("jP6Yz")
]).then(()=>parcelRequire('dgQTq'));

});



parcelRegister("2OQWG", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsCsmRouteEntry", () => $5614131c72bf5418$export$7a31e42733ba05a0);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $g6Dtv = parcelRequire("g6Dtv");

var $e7bC3 = parcelRequire("e7bC3");

var $dtjqc = parcelRequire("dtjqc");

var $1XdKx = parcelRequire("1XdKx");
const $5614131c72bf5418$export$7a31e42733ba05a0 = (0, $7NszV.createEntry)((0, $g6Dtv.projectSettingsSoftwareBoardsCsmRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'software.next-gen.boards.column-status-mapping.page.load',
        component: (0, $dtjqc.default),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $dtjqc.LazyCsmSettings)
        ]
    }));

});
parcelRegister("g6Dtv", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsCsmRoute", () => $e2028f4601d0a4d1$export$88e68eb447e3db49);
const $e2028f4601d0a4d1$export$88e68eb447e3db49 = {
    name: 'project-settings-software-boards-csm',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId/columns',
    exact: true
};

});

parcelRegister("dtjqc", function(module, exports) {

$parcel$export(module.exports, "LazyCsmSettings", () => $f25068ef108ee62d$export$de293ea44d0410ca);
$parcel$export(module.exports, "default", () => $f25068ef108ee62d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $f25068ef108ee62d$export$de293ea44d0410ca = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("g7Tgx"))), {
    moduleId: "./src/packages/spa-apps/project-settings/csm/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f25068ef108ee62d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f25068ef108ee62d$export$de293ea44d0410ca,
        pageId: "project-settings-csm",
        shouldShowSpinner: false
    });

});
parcelRegister("g7Tgx", function(module, exports) {

let $bbd82b708ca71c19$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("8OpWG"), 4)),
    $bbd82b708ca71c19$var$load("4YWoA")
]).then(()=>parcelRequire('jFUmz'));

});



parcelRegister("4eRSO", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsCustomFiltersRouteEntry", () => $e8af9bf5c835f1d8$export$6332ad3e1d8d721);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $cD3jo = parcelRequire("cD3jo");

var $7NszV = parcelRequire("7NszV");

var $VF0KL = parcelRequire("VF0KL");

var $e7bC3 = parcelRequire("e7bC3");

var $gqIYW = parcelRequire("gqIYW");

var $1XdKx = parcelRequire("1XdKx");
const $e8af9bf5c835f1d8$export$6332ad3e1d8d721 = (0, $7NszV.createEntry)((0, $VF0KL.projectSettingsSoftwareBoardsCustomFiltersRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.custom-filters',
        component: (0, $gqIYW.default),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)(),
            (0, $cD3jo.customFiltersResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gqIYW.LazyCustomFiltersSettings)
        ]
    }));

});
parcelRegister("cD3jo", function(module, exports) {

$parcel$export(module.exports, "customFiltersResource", () => $ca950ad823e84673$export$3e390340716755de);

var $dXq4S = parcelRequire("dXq4S");

var $ao2h1 = parcelRequire("ao2h1");

var $WcCM5 = parcelRequire("WcCM5");

const $ca950ad823e84673$export$3e390340716755de = (0, $ao2h1.createRelayResource)({
    type: (0, $ad903674eb868bde$export$5917fd27c14066cd),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $WcCM5.default),
            variables: {
                boardId: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("WcCM5", function(module, exports) {

$parcel$export(module.exports, "default", () => $5edc411e6b038299$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6c655bf5d42bc04990088e48dc6b757f>>
 * @relayHash 82ae1b9c2b4e7b31e211094a4e3f4f3f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c990befb5021511de9b1550aa7300067f8d87644e0d370c3754283355de50686
const $5edc411e6b038299$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "customFiltersQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "CustomFilter",
                                    "kind": "LinkedField",
                                    "name": "customFilters",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "card_projectSettingsCustomFilters_customFilterFragmentRef"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.customFilters"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "card_projectSettingsCustomFilters_boardScopeFragmentRef"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "expandedCard_projectSettingsCustomFilters_boardScopeFragmentRef"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "customFiltersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "CustomFilter",
                            "kind": "LinkedField",
                            "name": "customFilters",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "concreteType": "FilterQuery",
                                    "kind": "LinkedField",
                                    "name": "filterQuery",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "sanitisedJql"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "errors"
                                        }
                                    ]
                                },
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        },
                        v3 /*: any*/ ,
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "c990befb5021511de9b1550aa7300067f8d87644e0d370c3754283355de50686",
            "metadata": {},
            "name": "customFiltersQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5edc411e6b038299$var$node.hash = "2c5c0d030a87f3820766a2a896d71275";
var $5edc411e6b038299$export$2e2bcd8739ae039 = $5edc411e6b038299$var$node;

});

const $ad903674eb868bde$export$5917fd27c14066cd = 'NEXTGEN_PROJECT_SETTINGS_CUSTOM_FILTERS';


parcelRegister("VF0KL", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsCustomFiltersRoute", () => $0d2b719554e610ba$export$9bc9b345958a301c);
const $0d2b719554e610ba$export$9bc9b345958a301c = {
    name: 'project-settings-software-boards-custom-filters',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId/custom-filters',
    exact: true
};

});

parcelRegister("gqIYW", function(module, exports) {

$parcel$export(module.exports, "LazyCustomFiltersSettings", () => $26928850e3bfb37f$export$7e21d36a9d4548e6);
$parcel$export(module.exports, "default", () => $26928850e3bfb37f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $26928850e3bfb37f$export$7e21d36a9d4548e6 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("dGbYE")), {
    moduleId: "./src/packages/spa-apps/project-settings/custom-filters/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$26928850e3bfb37f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $26928850e3bfb37f$export$7e21d36a9d4548e6,
        pageId: "project-settings-custom-filters",
        shouldShowSpinner: true
    });

});
parcelRegister("dGbYE", function(module, exports) {

let $9f587d0b03c0baec$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9f587d0b03c0baec$var$load("1QfoG").then(()=>parcelRequire('keIpy'));

});



parcelRegister("b9Dpn", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsRedirectRouteEntry", () => $966af26f7fec7c46$export$cb6169207ddfd1b2);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $dieXh = parcelRequire("dieXh");

var $e7bC3 = parcelRequire("e7bC3");

var $9PHNK = parcelRequire("9PHNK");

var $1XdKx = parcelRequire("1XdKx");
const $966af26f7fec7c46$export$cb6169207ddfd1b2 = (0, $7NszV.createEntry)((0, $dieXh.projectSettingsSoftwareBoardsRedirectRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $9PHNK.BoardSettingsRedirectToCSM),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        isRedirect: true,
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("dieXh", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsRedirectRoute", () => $31cf97a1a4a84207$export$989ca67485551616);
const $31cf97a1a4a84207$export$989ca67485551616 = {
    name: 'project-settings-software-boards-redirect',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId',
    exact: true
};

});


parcelRegister("eitw0", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsRoadmapRouteEntry", () => $6d01f44cfcf07c9a$export$6d5eadd440c430f5);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $2FXLN = parcelRequire("2FXLN");

var $1V8vh = parcelRequire("1V8vh");

var $e7bC3 = parcelRequire("e7bC3");

var $9PHNK = parcelRequire("9PHNK");

var $1XdKx = parcelRequire("1XdKx");

var $aXcNG = parcelRequire("aXcNG");
const $6d01f44cfcf07c9a$export$6d5eadd440c430f5 = (0, $7NszV.createEntry)((0, $1V8vh.projectSettingsSoftwareBoardsRoadmapRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $9PHNK.RoadmapSettingsRedirectToTimelineSettings),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)(),
            (0, $2FXLN.roadmapSettingsResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aXcNG.LazyRoadmap)
        ]
    }));

});
parcelRegister("2FXLN", function(module, exports) {

$parcel$export(module.exports, "roadmapSettingsResource", () => $265fc06fbb6443a3$export$7901a008bd73bf46);

var $dXq4S = parcelRequire("dXq4S");

var $ao2h1 = parcelRequire("ao2h1");

var $6VnEZ = parcelRequire("6VnEZ");

const $265fc06fbb6443a3$export$7901a008bd73bf46 = (0, $ao2h1.createRelayResource)({
    type: (0, $87d7efe6336d8b83$export$e905b9170ecbb599),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>{
        const { cloudId: cloudId } = tenantContext;
        return {
            parameters: (0, $6VnEZ.default),
            variables: {
                sourceAri: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                }),
                locationAri: undefined
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
});

});
parcelRegister("6VnEZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a28994bc59c1b6c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<549802b43e67112dd5fba3309099c2de>>
 * @relayHash 19ad9a547bce255c35adc444386a03af
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6603bfc1272bd596fb67b3022210270e42d5bfb54ab2cf66470e7e5a8934ba80
const $4a28994bc59c1b6c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locationAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "locationARI",
            "variableName": "locationAri"
        },
        {
            "kind": "Variable",
            "name": "sourceARI",
            "variableName": "sourceAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "isSprintsFeatureEnabled"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "roadmapSettingsQuery",
            "selections": [
                {
                    "concreteType": "RoadmapsQuery",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "RoadmapDetails",
                            "kind": "LinkedField",
                            "name": "roadmapForSource",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "RoadmapConfiguration",
                                        "kind": "LinkedField",
                                        "name": "roadmapConfiguration",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "RoadmapBoardConfiguration",
                                                    "kind": "LinkedField",
                                                    "name": "boardConfiguration",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "childIssuesSchedulingToggle_boardSettingsRoadmap"
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "childIssuesSchedulingPreview_boardSettingsRoadmap"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "roadmaps.roadmapForSource.roadmapConfiguration.boardConfiguration"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "roadmaps.roadmapForSource.roadmapConfiguration"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "roadmapSettingsQuery",
            "selections": [
                {
                    "concreteType": "RoadmapsQuery",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "RoadmapDetails",
                            "kind": "LinkedField",
                            "name": "roadmapForSource",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "RoadmapConfiguration",
                                    "kind": "LinkedField",
                                    "name": "roadmapConfiguration",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "RoadmapBoardConfiguration",
                                            "kind": "LinkedField",
                                            "name": "boardConfiguration",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isChildIssuePlanningEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "childIssuePlanningMode"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6603bfc1272bd596fb67b3022210270e42d5bfb54ab2cf66470e7e5a8934ba80",
            "metadata": {},
            "name": "roadmapSettingsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4a28994bc59c1b6c$var$node.hash = "31c20159daaa03716587a1ccbe27ab14";
var $4a28994bc59c1b6c$export$2e2bcd8739ae039 = $4a28994bc59c1b6c$var$node;

});


parcelRegister("1V8vh", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsRoadmapRoute", () => $a1437557f2047801$export$17ccdaa366ec26b8);
const $a1437557f2047801$export$17ccdaa366ec26b8 = {
    name: 'project-settings-software-boards-roadmap',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId/roadmap',
    exact: true
};

});

parcelRegister("aXcNG", function(module, exports) {

$parcel$export(module.exports, "LazyRoadmap", () => $50cd29d3245ccefc$export$8eca5454e72ee961);
$parcel$export(module.exports, "default", () => $50cd29d3245ccefc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $50cd29d3245ccefc$export$8eca5454e72ee961 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("JMguM")), {
    moduleId: "./src/packages/spa-apps/project-settings/board-settings/roadmap/src/index.tsx"
});
const $50cd29d3245ccefc$var$AsyncProjectSettingsRoadmap = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "project-settings.roadmap",
        teamName: "chronos",
        attributes: {
            isSynthetic: (0, $4R6GH.fg)('is_synthetic_tenant') || (0, $j8DrX.default)('ajs-is-synthetic') === 'true'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $50cd29d3245ccefc$export$8eca5454e72ee961,
        pageId: "board-settings-roadmap",
        shouldShowSpinner: false
    }));
var $50cd29d3245ccefc$export$2e2bcd8739ae039 = $50cd29d3245ccefc$var$AsyncProjectSettingsRoadmap;

});
parcelRegister("JMguM", function(module, exports) {

let $0899a484be15b455$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0899a484be15b455$var$load("aEr6V").then(()=>parcelRequire('5d39M'));

});



parcelRegister("14ooS", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsTimelineRouteEntry", () => $aeb3431f883d58ca$export$cc224b8b7595975b);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $2FXLN = parcelRequire("2FXLN");

var $at8lb = parcelRequire("at8lb");

var $e7bC3 = parcelRequire("e7bC3");

var $1XdKx = parcelRequire("1XdKx");

var $aXcNG = parcelRequire("aXcNG");
const $aeb3431f883d58ca$export$cc224b8b7595975b = (0, $7NszV.createEntry)((0, $at8lb.projectSettingsSoftwareBoardsTimelineRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'board-settings-apps.roadmap-settings-page.page.load',
        component: (0, $aXcNG.default),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)(),
            (0, $2FXLN.roadmapSettingsResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aXcNG.LazyRoadmap)
        ]
    }));

});
parcelRegister("at8lb", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareBoardsTimelineRoute", () => $cc4b8dfb5f37c2a0$export$e116d6b2a5f71426);
const $cc4b8dfb5f37c2a0$export$e116d6b2a5f71426 = {
    name: 'project-settings-software-boards-timeline',
    path: '/jira/software/projects/:projectKey/settings/boards/:boardId/timeline',
    exact: true
};

});


parcelRegister("lWR9T", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareDataClassificationsRouteEntry", () => $fb225e359b3a3445$export$cc932462de184b27);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $flo0i = parcelRequire("flo0i");

var $jaAyo = parcelRequire("jaAyo");

var $e7bC3 = parcelRequire("e7bC3");

var $ejqjx = parcelRequire("ejqjx");

var $1XdKx = parcelRequire("1XdKx");
const $fb225e359b3a3445$export$cc932462de184b27 = (0, $7NszV.createEntry)((0, $flo0i.projectSettingsSoftwareDataClassificationsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $ejqjx.default),
        skeleton: (0, $jaAyo.ProjectSettingsDetailsSkeleton),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ejqjx.LazyDataClassificationsSettings)
        ]
    })); /**
 * Contains all software settings routes using the new url format `jira/:product/projects/:projectKey/settings`.
 */ 

});
parcelRegister("flo0i", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareDataClassificationsRoute", () => $09578e3175fbd546$export$af525a8f93b72cc7);
const $09578e3175fbd546$export$af525a8f93b72cc7 = {
    name: 'project-settings-software-data-classifications',
    path: '/jira/software/projects/:projectKey/settings/data-classifications',
    exact: true
};

});

parcelRegister("ejqjx", function(module, exports) {

$parcel$export(module.exports, "LazyDataClassificationsSettings", () => $81cf21747f4c944d$export$b8abcf8aa8f4df56);
$parcel$export(module.exports, "default", () => $81cf21747f4c944d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $81cf21747f4c944d$export$b8abcf8aa8f4df56 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("foQoc"))), {
    moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$81cf21747f4c944d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $81cf21747f4c944d$export$b8abcf8aa8f4df56,
        pageId: "project-settings-data-classifications",
        shouldShowSpinner: false
    });

});


parcelRegister("6DlqX", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareDetailsRouteEntry", () => $a903695c1ce96a1b$export$8440d3384846d9b8);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $a1v1W = parcelRequire("a1v1W");

var $jaAyo = parcelRequire("jaAyo");

var $e7bC3 = parcelRequire("e7bC3");

var $cYgMq = parcelRequire("cYgMq");

var $1XdKx = parcelRequire("1XdKx");
const $a903695c1ce96a1b$export$8440d3384846d9b8 = (0, $7NszV.createEntry)((0, $a1v1W.projectSettingsSoftwareDetailsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $cYgMq.default),
        skeleton: (0, $jaAyo.ProjectSettingsDetailsSkeleton),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cYgMq.LazyDetailsSettings)
        ]
    }));

});
parcelRegister("a1v1W", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareDetailsRoute", () => $6754d8275b08745c$export$8760347e2b0955eb);
const $6754d8275b08745c$export$8760347e2b0955eb = {
    name: 'project-settings-software-details',
    path: '/jira/software/projects/:projectKey/settings/details',
    exact: true
};

});


parcelRegister("jCfr4", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareFieldsRouteEntry", () => $2b9364818ff70bc7$export$e6b200b5a1ce3063);

var $ffza4 = parcelRequire("ffza4");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $e7C7O = parcelRequire("e7C7O");

var $5lsNZ = parcelRequire("5lsNZ");

var $eUAWy = parcelRequire("eUAWy");

var $e7bC3 = parcelRequire("e7bC3");

var $6s1PB = parcelRequire("6s1PB");

var $kwZwx = parcelRequire("kwZwx");

var $1XdKx = parcelRequire("1XdKx");
const $2b9364818ff70bc7$var$isEfaExperimentExposed = ()=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('efa_and_project_fields_page_for_tmp');
    return expConfig.get('isEnabled', false);
};
const $2b9364818ff70bc7$export$e6b200b5a1ce3063 = (0, $7NszV.createEntry)((0, $eUAWy.projectSettingsSoftwareFieldsRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.fields.jsw-tmp',
        component: (0, $7XYc4.componentWithCondition)($2b9364818ff70bc7$var$isEfaExperimentExposed, (0, $kwZwx.default), (0, $5lsNZ.default)),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)(),
            (0, $e7C7O.fieldSettingsRelayResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kwZwx.LazyFieldsSettings)
        ]
    }));

});
parcelRegister("eUAWy", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareFieldsRoute", () => $507c3ff044231698$export$1ab9d3299fbc789b);
const $507c3ff044231698$export$1ab9d3299fbc789b = {
    name: 'project-settings-software-fields',
    path: '/jira/software/projects/:projectKey/settings/fields',
    exact: true
};

});

parcelRegister("kwZwx", function(module, exports) {

$parcel$export(module.exports, "LazyFieldsSettings", () => $628b742891e4f718$export$e309780f520d125a);
$parcel$export(module.exports, "default", () => $628b742891e4f718$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $628b742891e4f718$export$e309780f520d125a = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("cqfV9"))), {
    moduleId: "./src/packages/spa-apps/project-settings/fields/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$628b742891e4f718$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $628b742891e4f718$export$e309780f520d125a,
        pageId: "project-settings-fields",
        shouldShowSpinner: true
    });

});


parcelRegister("kRn5i", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareIssuetypesRouteEntry", () => $a62547b317f1890b$export$84a9a2dce32d93aa);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $7Uj8H = parcelRequire("7Uj8H");

var $e7bC3 = parcelRequire("e7bC3");

var $9PHNK = parcelRequire("9PHNK");

var $6UFDl = parcelRequire("6UFDl");

var $1XdKx = parcelRequire("1XdKx");
const $a62547b317f1890b$export$84a9a2dce32d93aa = (0, $7NszV.createEntry)((0, $7Uj8H.projectSettingsSoftwareIssuetypesRoute), ()=>({
        group: 'project-settings-software',
        ufoName: (0, $9PHNK.getUFOName)('project-settings-software-issuetypes'),
        component: (0, $6UFDl.default),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6UFDl.LazyIssueTypeSettings)
        ]
    }));

});
parcelRegister("7Uj8H", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareIssuetypesRoute", () => $1344929ef12856ff$export$7f26edefe51efc38);
const $1344929ef12856ff$export$7f26edefe51efc38 = {
    name: 'project-settings-software-issuetypes',
    path: '/jira/software/projects/:projectKey/settings/issuetypes/:issueTypeId?',
    exact: true
};

});

parcelRegister("6UFDl", function(module, exports) {

$parcel$export(module.exports, "LazyIssueTypeSettings", () => $8f1b2ea450c47b3b$export$36dcfb52d47cb93a);
$parcel$export(module.exports, "default", () => $8f1b2ea450c47b3b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $8f1b2ea450c47b3b$export$36dcfb52d47cb93a = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("7a4qW"))), {
    moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8f1b2ea450c47b3b$export$2e2bcd8739ae039 = ({ match: match })=>{
    const { issueTypeId: issueTypeId } = match.params;
    // unique pageId need to be set so that ApdexProvider would properly reset all the performance marks when switching between issue types
    const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8f1b2ea450c47b3b$export$36dcfb52d47cb93a,
        pageId: pageId,
        shouldShowSpinner: false
    });
};

});


parcelRegister("3NIY8", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareIssuetypesWorkflowRouteEntry", () => $991168ab4a6e6879$export$58ca33ed538911cb);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $9QOPa = parcelRequire("9QOPa");

var $e7bC3 = parcelRequire("e7bC3");

var $6UFDl = parcelRequire("6UFDl");

var $1XdKx = parcelRequire("1XdKx");

var $cNuJO = parcelRequire("cNuJO");
const $991168ab4a6e6879$export$58ca33ed538911cb = (0, $7NszV.createEntry)((0, $9QOPa.projectSettingsSoftwareIssuetypesWorkflowRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $cNuJO.default),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6UFDl.LazyIssueTypeSettings)
        ]
    }));

});
parcelRegister("9QOPa", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareIssuetypesWorkflowRoute", () => $2d01183c61a2983c$export$de010d824a551ec);
const $2d01183c61a2983c$export$de010d824a551ec = {
    name: 'project-settings-software-issuetypes-workflow',
    path: '/jira/software/projects/:projectKey/settings/issuetypes/:issueTypeId/:initialSection(workflow)',
    exact: true
};

});

parcelRegister("cNuJO", function(module, exports) {

$parcel$export(module.exports, "default", () => $48f5bfd32d483aba$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $48f5bfd32d483aba$export$cb608e3696682e76 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hodsj"))), {
    moduleId: "./src/packages/spa-apps/project-settings/workflow-navigation/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$48f5bfd32d483aba$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $48f5bfd32d483aba$export$cb608e3696682e76,
        pageId: "project-settings-workflow-navigation",
        shouldShowSpinner: false
    });

});


parcelRegister("fjYA2", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNextGenFeaturesRouteEntry", () => $71f1d776dd1bcb90$export$81067f5196099c81);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $hJYLH = parcelRequire("hJYLH");

var $jaAyo = parcelRequire("jaAyo");

var $e7bC3 = parcelRequire("e7bC3");

var $eNw6s = parcelRequire("eNw6s");

var $1XdKx = parcelRequire("1XdKx");
const $71f1d776dd1bcb90$export$81067f5196099c81 = (0, $7NszV.createEntry)((0, $hJYLH.projectSettingsSoftwareNextGenFeaturesRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.next-gen-features',
        component: (0, $eNw6s.default),
        skeleton: (0, $jaAyo.ProjectSettingsFeaturesSkeleton),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $eNw6s.LazyFeaturesSettings)
        ]
    }));

});
parcelRegister("hJYLH", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNextGenFeaturesRoute", () => $78ec600058c356ce$export$12c7a1737b594a28);
const $78ec600058c356ce$export$12c7a1737b594a28 = {
    name: 'project-settings-software-next-gen-features',
    path: '/jira/software/projects/:projectKey/settings/features',
    exact: true
};

});

parcelRegister("eNw6s", function(module, exports) {

$parcel$export(module.exports, "LazyFeaturesSettings", () => $4e545f86ddd60f53$export$da4d608b99858bfc);
$parcel$export(module.exports, "default", () => $4e545f86ddd60f53$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $4e545f86ddd60f53$export$da4d608b99858bfc = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("jgiOL"))), {
    moduleId: "./src/packages/spa-apps/project-settings/next-gen-features/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4e545f86ddd60f53$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $4e545f86ddd60f53$export$da4d608b99858bfc,
        pageId: "project-settings-next-gen-features",
        shouldShowSpinner: false
    });

});
parcelRegister("jgiOL", function(module, exports) {

let $e05e1bc168e3a744$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e05e1bc168e3a744$var$load("zWsTk").then(()=>parcelRequire('2MwfB'));

});



parcelRegister("qdq3O", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNotificationEmailCRouteEntry", () => $70f72ce01753856b$export$9bb08b8e1b39d15f);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $iqUDj = parcelRequire("iqUDj");

var $jaAyo = parcelRequire("jaAyo");

var $e7bC3 = parcelRequire("e7bC3");

var $9T2qH = parcelRequire("9T2qH");

var $4glor = parcelRequire("4glor");
const $70f72ce01753856b$export$9bb08b8e1b39d15f = (0, $7NszV.createEntry)((0, $iqUDj.projectSettingsSoftwareNotificationEmailCRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $9T2qH.default),
        skeleton: (0, $jaAyo.ProjectSettingsFeaturesSkeleton),
        layout: (0, $e7bC3.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $dxCvy.projectContextResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4glor.LazySoftwareClassicFeatures),
            (0, $9T2qH.LazyProjectSettingsNotificationEmail)
        ]
    }));

});
parcelRegister("iqUDj", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNotificationEmailCRoute", () => $660f0733dcb91b32$export$dda91725b6c4a039);
const $660f0733dcb91b32$export$dda91725b6c4a039 = {
    name: 'project-settings-software-notifications-notification-email',
    path: '/jira/software/c/projects/:projectKey/settings/notifications/notification-email',
    exact: true
};

});

parcelRegister("9T2qH", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsNotificationEmail", () => $6e8f6f53c599ad60$export$ea7d73c94d9369f4);
$parcel$export(module.exports, "default", () => $6e8f6f53c599ad60$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $6e8f6f53c599ad60$export$ea7d73c94d9369f4 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hLnUL"))), {
    moduleId: "./src/packages/spa-apps/project-settings/notification-email/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6e8f6f53c599ad60$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $6e8f6f53c599ad60$export$ea7d73c94d9369f4,
        pageId: "project-settings-email-notifications",
        shouldShowSpinner: true
    });

});


parcelRegister("aY70k", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNotificationEmailRouteEntry", () => $96e097b23221938d$export$8a17783c300fca11);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $dXGLS = parcelRequire("dXGLS");

var $jaAyo = parcelRequire("jaAyo");

var $e7bC3 = parcelRequire("e7bC3");

var $1XdKx = parcelRequire("1XdKx");
const $96e097b23221938d$export$8a17783c300fca11 = (0, $7NszV.createEntry)((0, $dXGLS.projectSettingsSoftwareNotificationEmailRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $1XdKx.RedirectForSettings),
        skeleton: (0, $jaAyo.ProjectSettingsFeaturesSkeleton),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("dXGLS", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNotificationEmailRoute", () => $427d02b02ceb584b$export$d4ed083331cb6e00);
const $427d02b02ceb584b$export$d4ed083331cb6e00 = {
    name: 'project-settings-software-notifications-notification-email',
    path: '/jira/software/projects/:projectKey/settings/notifications/notification-email',
    exact: true
};

});


parcelRegister("2wF9u", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNotificationsIssueLogsRouteEntry", () => $c50f7899cb2834ba$export$9c37d834dfe46ebf);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $be8d4 = parcelRequire("be8d4");

var $e7bC3 = parcelRequire("e7bC3");

var $1XdKx = parcelRequire("1XdKx");

var $14B4q = parcelRequire("14B4q");
const $c50f7899cb2834ba$export$9c37d834dfe46ebf = (0, $7NszV.createEntry)((0, $be8d4.projectSettingsSoftwareNotificationsIssueLogsRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.software.notifications.issue-logs',
        component: (0, $14B4q.SoftwareNotificationsIssueLogs),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $14B4q.LazySoftwareNotificationsIssueLogs)
        ],
        entryPoint () {
            return 0, $14B4q.emailNotificationsLogEntryPointPage;
        }
    }));

});
parcelRegister("be8d4", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNotificationsIssueLogsRoute", () => $2685d8d8e87c6306$export$ff4977f79c273b29);
const $2685d8d8e87c6306$export$ff4977f79c273b29 = {
    name: 'project-settings-software-notifications-issue-logs',
    path: '/jira/software/projects/:projectKey/settings/notifications/issue-logs',
    exact: true
};

});


parcelRegister("feDOq", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNotificationsRouteEntry", () => $d6aa89f0f35f02a8$export$1c340fa0c9022252);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $567rt = parcelRequire("567rt");

var $e7bC3 = parcelRequire("e7bC3");

var $1XdKx = parcelRequire("1XdKx");

var $8Z6ZD = parcelRequire("8Z6ZD");
const $d6aa89f0f35f02a8$export$1c340fa0c9022252 = (0, $7NszV.createEntry)((0, $567rt.projectSettingsSoftwareNotificationsRoute), ()=>({
        group: 'project-settings-software',
        ufoName: 'project-settings.software.notifications',
        component: (0, $8Z6ZD.default),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8Z6ZD.LazySoftwareNotificationsSettings)
        ]
    }));

});
parcelRegister("567rt", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareNotificationsRoute", () => $93d386ac6f219e91$export$c1d1892d6c07135a);
const $93d386ac6f219e91$export$c1d1892d6c07135a = {
    name: 'project-settings-software-notifications',
    path: '/jira/software/projects/:projectKey/settings/notifications',
    exact: true
};

});

parcelRegister("8Z6ZD", function(module, exports) {

$parcel$export(module.exports, "LazySoftwareNotificationsSettings", () => $576f902bdb908a77$export$69a64a29d67ca160);
$parcel$export(module.exports, "default", () => $576f902bdb908a77$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $576f902bdb908a77$export$69a64a29d67ca160 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("fhvdd"))), {
    moduleId: "./src/packages/spa-apps/project-settings/software-notifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$576f902bdb908a77$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $576f902bdb908a77$export$69a64a29d67ca160,
        pageId: "project-settings-software-notifications",
        shouldShowSpinner: false
    });

});


parcelRegister("cqk4B", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareProformaJiraFormBuilderRouteEntry", () => $219ec4fb78eddcea$export$5606059eca31e30);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $hDUMP = parcelRequire("hDUMP");

var $e7bC3 = parcelRequire("e7bC3");

var $1XdKx = parcelRequire("1XdKx");

var $8JnjW = parcelRequire("8JnjW");
const $219ec4fb78eddcea$export$5606059eca31e30 = (0, $7NszV.createEntry)((0, $hDUMP.projectSettingsSoftwareProformaJiraFormBuilderRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $8JnjW.default),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $8JnjW.LazyProjectSettingsProformaJiraFormBuilder)
        ],
        perfMetricKey: 'form-builder'
    }));

});
parcelRegister("hDUMP", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareProformaJiraFormBuilderRoute", () => $b09cc9a715d5f75a$export$cf33294d9d90a855);
const $b09cc9a715d5f75a$export$cf33294d9d90a855 = {
    name: 'project-settings-software-proforma-jira-form-builder',
    path: '/jira/software/projects/:projectKey/settings/forms/form/:templateFormId/edit',
    exact: true
};

});


parcelRegister("d66ag", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareProformaProjectFormsRouteEntry", () => $1f2ddc69ff9bd153$export$ea77a3e974b26072);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $f5WPG = parcelRequire("f5WPG");

var $e7bC3 = parcelRequire("e7bC3");

var $1XdKx = parcelRequire("1XdKx");

var $gyEpf = parcelRequire("gyEpf");
const $1f2ddc69ff9bd153$export$ea77a3e974b26072 = (0, $7NszV.createEntry)((0, $f5WPG.projectSettingsSoftwareProformaProjectFormsRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $gyEpf.default),
        layout: (0, $e7bC3.softwareProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gyEpf.LazyProjectSettingsProformaProjectForms)
        ],
        perfMetricKey: 'forms-settings'
    }));

});
parcelRegister("f5WPG", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareProformaProjectFormsRoute", () => $f94052f77c0e6bf4$export$750dec948cc98062);
const $f94052f77c0e6bf4$export$750dec948cc98062 = {
    name: 'project-settings-software-proforma-project-forms',
    path: '/jira/software/projects/:projectKey/settings/forms',
    exact: true
};

});


parcelRegister("84EwA", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareRedirectRouteEntry", () => $156cde955bd90b23$export$e5caf0892d6025c9);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $c8fK3 = parcelRequire("c8fK3");

var $e7bC3 = parcelRequire("e7bC3");

var $1XdKx = parcelRequire("1XdKx");
const $156cde955bd90b23$export$e5caf0892d6025c9 = (0, $7NszV.createEntry)((0, $c8fK3.projectSettingsSoftwareRedirectRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $1XdKx.RedirectForSettings),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("c8fK3", function(module, exports) {

$parcel$export(module.exports, "projectSettingsSoftwareRedirectRoute", () => $4fd256cbd670956d$export$168cc8ed4398c230);
const $4fd256cbd670956d$export$168cc8ed4398c230 = {
    // the following route should be non-exact, it will handle "index" and "404" cases
    name: 'project-settings-software-redirect',
    path: '/jira/software/projects/:projectKey/settings'
};

});


parcelRegister("7dYbE", function(module, exports) {

$parcel$export(module.exports, "projectSettingsToolchainRouteEntry", () => $eb246e0ef2b2c1c3$export$dd97d29f96b25d09);

var $ffza4 = parcelRequire("ffza4");

var $bwLf9 = parcelRequire("bwLf9");

var $lmyls = parcelRequire("lmyls");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $35Wvp = parcelRequire("35Wvp");

var $5lsNZ = parcelRequire("5lsNZ");

var $6eLkt = parcelRequire("6eLkt");

var $kfztd = parcelRequire("kfztd");

var $e7bC3 = parcelRequire("e7bC3");

var $aA5DA = parcelRequire("aA5DA");

var $1XdKx = parcelRequire("1XdKx");
const $eb246e0ef2b2c1c3$export$dd97d29f96b25d09 = (0, $7NszV.createEntry)((0, $6eLkt.projectSettingsToolchainRoute), ()=>({
        group: 'project-settings-software',
        component: (0, $bwLf9.default)((0, $kfztd.isDevopsFeatureDisabledInFedRamp), (0, $5lsNZ.default), (0, $aA5DA.default)),
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $1XdKx.getSettingsNavigationResources)(),
            (0, $35Wvp.projectSettingsToolchainResource)
        ],
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aA5DA.LazyDevOpsConnectionsSettings)
        ],
        ufoName: 'project-settings.devops-connections'
    }));

});
parcelRegister("6eLkt", function(module, exports) {

$parcel$export(module.exports, "projectSettingsToolchainRoute", () => $f16500562a276728$export$e3e3877ec9c5e840);
const $f16500562a276728$export$e3e3877ec9c5e840 = {
    name: 'project-settings-software-toolchain-team-managed',
    path: '/jira/software/projects/:projectKey/settings/toolchain',
    exact: true
};

});


parcelRegister("ghTLp", function(module, exports) {

$parcel$export(module.exports, "softwareReleaseNotesRouteEntry", () => $6dee187be32572f9$export$543aad2020051ecb);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $hBv66 = parcelRequire("hBv66");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $9URQe = parcelRequire("9URQe");

var $e7bC3 = parcelRequire("e7bC3");

var $9PHNK = parcelRequire("9PHNK");
const $6dee187be32572f9$export$543aad2020051ecb = (0, $7NszV.createEntry)((0, $9URQe.softwareReleaseNotesRoute), ()=>({
        group: 'project-settings-software',
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3RJkv.getNavigationSidebarProjectSettingsResource)(),
            (0, $dxCvy.projectContextResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        component: (0, $9PHNK.SpaReleaseNoteRedirectToVersionDetails),
        layout: (0, $e7bC3.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $hBv66.genericProjectSidebars),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("9URQe", function(module, exports) {

$parcel$export(module.exports, "softwareReleaseNotesRoute", () => $45e41e5c15f76352$export$a0223091962262d4);
const $45e41e5c15f76352$export$a0223091962262d4 = {
    name: 'software-release-notes',
    path: '/secure/ReleaseNote.jspa',
    query: [
        'projectId'
    ]
};

});


parcelRegister("jjqkz", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskClassicAppsRouteEntry", () => $626e75f8ec29a06e$export$aba71c4218b643ad);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $4P4Lq = parcelRequire("4P4Lq");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $hKH9R = parcelRequire("hKH9R");

var $j9RuP = parcelRequire("j9RuP");

var $01LdL = parcelRequire("01LdL");
const $626e75f8ec29a06e$export$aba71c4218b643ad = (0, $7NszV.createEntry)((0, $4P4Lq.projectSettingsServicedeskClassicAppsRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.app-discovery',
        component: (0, $j9RuP.ConnectAppsRedirect)(`/jira/${(0, $01LdL.SERVICE_DESK_PRODUCT)}`),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        isRedirect: true,
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hKH9R.LazyAppDiscoverySettings)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).APP_DISCOVERY,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).APP_DISCOVERY),
                teamName: 'it-solutions-hermes'
            }
        }
    }));

});
parcelRegister("hKH9R", function(module, exports) {

$parcel$export(module.exports, "LazyAppDiscoverySettings", () => $d7e52a3e5f45b58f$export$fa3bc297af95f169);
$parcel$export(module.exports, "default", () => $d7e52a3e5f45b58f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $d7e52a3e5f45b58f$export$fa3bc297af95f169 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("3cuPS"))), {
    moduleId: "./src/packages/spa-apps/project-settings/app-discovery-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d7e52a3e5f45b58f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d7e52a3e5f45b58f$export$fa3bc297af95f169,
        pageId: "project-settings-app-discovery-settings",
        shouldShowSpinner: false
    });

});

parcelRegister("j9RuP", function(module, exports) {

$parcel$export(module.exports, "LazyConnectAppControlsSettings", () => $3f52008d1cdfa258$export$246ec9cdadd2a163);
$parcel$export(module.exports, "ConnectAppsRedirect", () => $3f52008d1cdfa258$export$cc3414a2d9daf70d);
$parcel$export(module.exports, "default", () => $3f52008d1cdfa258$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $dAfqg = parcelRequire("dAfqg");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $7tQej = parcelRequire("7tQej");

var $hKH9R = parcelRequire("hKH9R");

const $3f52008d1cdfa258$export$246ec9cdadd2a163 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("1j8hG"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-app-controls/src/index.tsx"
});
const $3f52008d1cdfa258$var$ConnectAppsRedirectInner = ({ match: match, basePath: basePath })=>{
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const shouldRedirect = projectContext != null && projectContext.simplified && projectContext.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
    return shouldRedirect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `${basePath}/projects/${String(match.params.projectKey)}/settings/apps/app-fields`,
        push: false
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hKH9R.default), null);
};
const $3f52008d1cdfa258$export$cc3414a2d9daf70d = (basePath)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3f52008d1cdfa258$var$ConnectAppsRedirectInner, {
            match: match,
            basePath: basePath
        });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3f52008d1cdfa258$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3f52008d1cdfa258$export$246ec9cdadd2a163,
        pageId: "project-settings-connect-app-controls",
        shouldShowSpinner: false
    });

});

parcelRegister("01LdL", function(module, exports) {

$parcel$export(module.exports, "SERVICE_DESK_PRODUCT", () => $a51e57eb3887507b$export$5575497f0592ee94);
$parcel$export(module.exports, "defaultRedirectForSettings", () => $a51e57eb3887507b$export$c9b0516439c55d7a);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
const $a51e57eb3887507b$export$5575497f0592ee94 = 'servicedesk';
const $a51e57eb3887507b$export$c9b0516439c55d7a = (product)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: `/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`
        });

});


parcelRegister("7xqQs", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskDetailsRouteEntry", () => $ec64aa09583181df$export$6b37ff6fd616f383);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $7T78N = parcelRequire("7T78N");

var $6Z2mh = parcelRequire("6Z2mh");

var $jaAyo = parcelRequire("jaAyo");

var $bYT90 = parcelRequire("bYT90");
const $ec64aa09583181df$export$6b37ff6fd616f383 = (0, $7NszV.createEntry)((0, $7T78N.projectSettingsServicedeskDetailsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $bYT90.default),
        skeleton: (0, $jaAyo.ProjectSettingsDetailsSkeleton),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bYT90.LazyDetailsSettings)
        ]
    }));

});
parcelRegister("7T78N", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskDetailsRoute", () => $68e7499c720861f2$export$23583c23687c31c7);
const $68e7499c720861f2$export$23583c23687c31c7 = {
    name: 'project-settings-servicedesk-details',
    // /settings/details
    path: '/jira/servicedesk/projects/:projectKey/settings/details',
    exact: true
};

});

parcelRegister("bYT90", function(module, exports) {

$parcel$export(module.exports, "LazyDetailsSettings", () => $3746e6592757d8dd$export$6f16b5efddd5c646);
$parcel$export(module.exports, "default", () => $3746e6592757d8dd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $3746e6592757d8dd$export$6f16b5efddd5c646 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("eC5lK"))), {
    moduleId: "./src/packages/spa-apps/project-settings/details/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3746e6592757d8dd$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3746e6592757d8dd$export$6f16b5efddd5c646,
        pageId: "project-settings-details",
        shouldShowSpinner: false
    });

});


parcelRegister("peO7W", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskFieldsRouteEntry", () => $3c9b84b0d48a58a6$export$8a5eabbb292c5b39);

var $ffza4 = parcelRequire("ffza4");

var $7XYc4 = parcelRequire("7XYc4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $e7C7O = parcelRequire("e7C7O");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $coidL = parcelRequire("coidL");

var $6Z2mh = parcelRequire("6Z2mh");

var $6s1PB = parcelRequire("6s1PB");

var $3sOmz = parcelRequire("3sOmz");
const $3c9b84b0d48a58a6$var$isEfaExperimentExposed = ()=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('efa_and_project_fields_page_for_tmp');
    return expConfig.get('isEnabled', false);
};
const $3c9b84b0d48a58a6$export$8a5eabbb292c5b39 = (0, $7NszV.createEntry)((0, $coidL.projectSettingsServicedeskFieldsRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'project-settings.fields.jsm-tmp',
        component: (0, $7XYc4.componentWithCondition)($3c9b84b0d48a58a6$var$isEfaExperimentExposed, (0, $3sOmz.default), (0, $5lsNZ.default)),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $e7C7O.fieldSettingsRelayResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3sOmz.LazyFieldsSettings)
        ]
    }));

});
parcelRegister("3sOmz", function(module, exports) {

$parcel$export(module.exports, "LazyFieldsSettings", () => $c77ac9be273e47d5$export$e309780f520d125a);
$parcel$export(module.exports, "default", () => $c77ac9be273e47d5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $c77ac9be273e47d5$export$e309780f520d125a = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("cqfV9"))), {
    moduleId: "./src/packages/spa-apps/project-settings/fields/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c77ac9be273e47d5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $c77ac9be273e47d5$export$e309780f520d125a,
        pageId: "project-settings-fields",
        shouldShowSpinner: true
    });

});


parcelRegister("f1JiD", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskIssuetypesRouteEntry", () => $0936f5888a81e879$export$cf4a5eaa3cb7522f);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6EgCy = parcelRequire("6EgCy");

var $6Z2mh = parcelRequire("6Z2mh");

var $5EbkJ = parcelRequire("5EbkJ");

var $cDJku = parcelRequire("cDJku");
const $0936f5888a81e879$export$cf4a5eaa3cb7522f = (0, $7NszV.createEntry)((0, $6EgCy.projectSettingsServicedeskIssuetypesRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: (0, $cDJku.getUFOName)('project-settings-servicedesk-issuetypes'),
        component: (0, $5EbkJ.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5EbkJ.LazyIssueTypeSettings)
        ]
    }));

});
parcelRegister("5EbkJ", function(module, exports) {

$parcel$export(module.exports, "LazyIssueTypeSettings", () => $9d365377dbe2cbf1$export$36dcfb52d47cb93a);
$parcel$export(module.exports, "default", () => $9d365377dbe2cbf1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $9d365377dbe2cbf1$export$36dcfb52d47cb93a = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("7a4qW"))), {
    moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9d365377dbe2cbf1$export$2e2bcd8739ae039 = ({ match: match })=>{
    const { issueTypeId: issueTypeId } = match.params;
    // unique pageId need to be set so that ApdexProvider would properly reset all the performance marks when switching between issue types
    const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9d365377dbe2cbf1$export$36dcfb52d47cb93a,
        pageId: pageId,
        shouldShowSpinner: false
    });
};

});

parcelRegister("cDJku", function(module, exports) {

$parcel$export(module.exports, "getUFOName", () => $3eab64ae9fcc418e$export$759ec9adbd19c936);
const $3eab64ae9fcc418e$var$ufoNamesMap = {
    'project-settings-software-issuetypes': 'project-settings.issue-type.jsw-tmp',
    'project-settings-servicedesk-issuetypes': 'project-settings.issue-type.jsm-tmp'
};
const $3eab64ae9fcc418e$export$759ec9adbd19c936 = (name)=>$3eab64ae9fcc418e$var$ufoNamesMap[name] || name;

});


parcelRegister("138gn", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskIssuetypesWorkflowRouteEntry", () => $f2cb7e5eb7db4222$export$a6c573e3904e9dbd);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $63HTu = parcelRequire("63HTu");

var $6Z2mh = parcelRequire("6Z2mh");

var $5EbkJ = parcelRequire("5EbkJ");

var $3i9aq = parcelRequire("3i9aq");
const $f2cb7e5eb7db4222$export$a6c573e3904e9dbd = (0, $7NszV.createEntry)((0, $63HTu.projectSettingsServicedeskIssuetypesWorkflowRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $3i9aq.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5EbkJ.LazyIssueTypeSettings)
        ]
    }));

});
parcelRegister("63HTu", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskIssuetypesWorkflowRoute", () => $c901967b54883cb1$export$959cd36cc49d3b76);
const $c901967b54883cb1$export$959cd36cc49d3b76 = {
    name: 'project-settings-servicedesk-issuetypes-workflow',
    path: '/jira/servicedesk/projects/:projectKey/settings/issuetypes/:issueTypeId/:initialSection(workflow)',
    exact: true
};

});

parcelRegister("3i9aq", function(module, exports) {

$parcel$export(module.exports, "default", () => $55da4849dbdf5d52$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $55da4849dbdf5d52$export$cb608e3696682e76 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hodsj"))), {
    moduleId: "./src/packages/spa-apps/project-settings/workflow-navigation/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$55da4849dbdf5d52$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $55da4849dbdf5d52$export$cb608e3696682e76,
        pageId: "project-settings-workflow-navigation",
        shouldShowSpinner: false
    });

});


parcelRegister("fCX78", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskProformaJiraFormBuilderRouteEntry", () => $ce34267499de75f9$export$f7bbe7fb3eeb9258);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $CiTFA = parcelRequire("CiTFA");

var $6Z2mh = parcelRequire("6Z2mh");

var $aPBt5 = parcelRequire("aPBt5");
const $ce34267499de75f9$export$f7bbe7fb3eeb9258 = (0, $7NszV.createEntry)((0, $CiTFA.projectSettingsServicedeskProformaJiraFormBuilderRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $aPBt5.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aPBt5.LazyProjectSettingsProformaJiraFormBuilder)
        ],
        perfMetricKey: 'form-builder'
    }));

});
parcelRegister("CiTFA", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskProformaJiraFormBuilderRoute", () => $1fa17d3fd833408f$export$f2a7862c8cde472d);
const $1fa17d3fd833408f$export$f2a7862c8cde472d = {
    name: 'project-settings-servicedesk-proforma-jira-form-builder',
    path: '/jira/servicedesk/projects/:projectKey/settings/forms/form/:templateFormId/edit',
    exact: true
};

});

parcelRegister("aPBt5", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsProformaJiraFormBuilder", () => $5cc0224f486155a9$export$a7d63246a10aedd);
$parcel$export(module.exports, "default", () => $5cc0224f486155a9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $5cc0224f486155a9$export$a7d63246a10aedd = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("7R9RB")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-jira-form-builder/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5cc0224f486155a9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $5cc0224f486155a9$export$a7d63246a10aedd,
        pageId: "project-settings-proforma-jira-form-builder",
        shouldShowSpinner: true
    });

});


parcelRegister("6NqDk", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskProformaProjectFormsRouteEntry", () => $83fcac200820df4d$export$f0d9fbaec8a9f2a);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $59iBR = parcelRequire("59iBR");

var $6Z2mh = parcelRequire("6Z2mh");

var $6RowE = parcelRequire("6RowE");
const $83fcac200820df4d$export$f0d9fbaec8a9f2a = (0, $7NszV.createEntry)((0, $59iBR.projectSettingsServicedeskProformaProjectFormsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $6RowE.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6RowE.LazyProjectSettingsProformaProjectForms)
        ],
        perfMetricKey: 'forms-settings'
    }));

});
parcelRegister("6RowE", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsProformaProjectForms", () => $7c82c5f708d0cd7e$export$38414b624a749cec);
$parcel$export(module.exports, "default", () => $7c82c5f708d0cd7e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $7c82c5f708d0cd7e$export$38414b624a749cec = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("cShK4")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-project-forms/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7c82c5f708d0cd7e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $7c82c5f708d0cd7e$export$38414b624a749cec,
        pageId: "project-settings-proforma-project-forms",
        shouldShowSpinner: true
    });

});


parcelRegister("hWZAC", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAccessRedirectRouteEntry", () => $fe3c44b562f5a007$export$7a0e75d9ac8038aa);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $kDaRO = parcelRequire("kDaRO");

var $6Z2mh = parcelRequire("6Z2mh");

var $p09kb = parcelRequire("p09kb");

var $01LdL = parcelRequire("01LdL");
const $fe3c44b562f5a007$export$7a0e75d9ac8038aa = (0, $7NszV.createEntry)((0, $kDaRO.projectSettingsServicedeskAccessRedirectRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $p09kb.peopleAccessRedirect)(`/jira/${(0, $01LdL.SERVICE_DESK_PRODUCT)}`),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $p09kb.LazyPeopleSettings)
        ]
    }));

});
parcelRegister("kDaRO", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAccessRedirectRoute", () => $8669efd5b368806c$export$115667ee60b1ec74);
const $8669efd5b368806c$export$115667ee60b1ec74 = {
    name: 'project-settings-servicedesk-access-redirect',
    path: '/jira/servicedesk/projects/:projectKey/settings/people',
    exact: true
};

});

parcelRegister("p09kb", function(module, exports) {

$parcel$export(module.exports, "LazyPeopleSettings", () => $3a1472a535e1ea00$export$7eee4f97b7a1273);
$parcel$export(module.exports, "peopleAccessRedirect", () => $3a1472a535e1ea00$export$45346ed2aa24e3f3);
$parcel$export(module.exports, "default", () => $3a1472a535e1ea00$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $7tQej = parcelRequire("7tQej");

const $3a1472a535e1ea00$export$7eee4f97b7a1273 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("8pwbR"))), {
    moduleId: "./src/packages/spa-apps/project-settings/people/src/index.tsx"
});
const $3a1472a535e1ea00$var$PeopleAccessRedirectInner = ({ match: match, basePath: basePath })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `${basePath}/projects/${String(match.params.projectKey)}/settings/access`,
        push: false
    });
const $3a1472a535e1ea00$export$45346ed2aa24e3f3 = (basePath)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3a1472a535e1ea00$var$PeopleAccessRedirectInner, {
            match: match,
            basePath: basePath
        });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3a1472a535e1ea00$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $3a1472a535e1ea00$export$7eee4f97b7a1273,
        pageId: "project-settings-people",
        shouldShowSpinner: false
    });

});


parcelRegister("2kXpo", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAccessRouteEntry", () => $87f6949fc1184ba3$export$f7b56f6d0437146d);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $cAtSX = parcelRequire("cAtSX");

var $6Z2mh = parcelRequire("6Z2mh");

var $jaAyo = parcelRequire("jaAyo");

var $p09kb = parcelRequire("p09kb");
const $87f6949fc1184ba3$export$f7b56f6d0437146d = (0, $7NszV.createEntry)((0, $cAtSX.projectSettingsServicedeskAccessRoute), ()=>({
        group: 'project-settings-servicedesk',
        skeleton: (0, $jaAyo.ProjectSettingsAccessSkeleton),
        component: (0, $p09kb.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $p09kb.LazyPeopleSettings)
        ],
        ufoName: 'project-settings.access'
    }));

});

parcelRegister("fhlje", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAppsFieldsRouteEntry", () => $82144ad3cdad7a53$export$12f064da36fbd279);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $g49yz = parcelRequire("g49yz");

var $6Z2mh = parcelRequire("6Z2mh");

var $j9RuP = parcelRequire("j9RuP");
const $82144ad3cdad7a53$export$12f064da36fbd279 = (0, $7NszV.createEntry)((0, $g49yz.projectSettingsServicedeskAppsFieldsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $j9RuP.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $j9RuP.LazyConnectAppControlsSettings)
        ]
    }));

});

parcelRegister("8to5X", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAppsRouteEntry", () => $0879ee567efffa41$export$d637c59982b0d896);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $fRJeY = parcelRequire("fRJeY");

var $6Z2mh = parcelRequire("6Z2mh");

var $cp0du = parcelRequire("cp0du");
const $0879ee567efffa41$export$d637c59982b0d896 = (0, $7NszV.createEntry)((0, $fRJeY.projectSettingsServicedeskAppsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $cp0du.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cp0du.LazyConnectAppsSettings)
        ]
    }));

});
parcelRegister("fRJeY", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAppsRoute", () => $d868c77dc879347a$export$ccc91c475c403d1a);
const $d868c77dc879347a$export$ccc91c475c403d1a = {
    name: 'project-settings-servicedesk-apps',
    path: '/jira/servicedesk/projects/:projectKey/settings/apps/:appId?',
    exact: true
};

});

parcelRegister("cp0du", function(module, exports) {

$parcel$export(module.exports, "LazyConnectAppsSettings", () => $841a04425f045e7e$export$3633e017e520a1c2);
$parcel$export(module.exports, "default", () => $841a04425f045e7e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $841a04425f045e7e$export$3633e017e520a1c2 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("flIAq"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-apps/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$841a04425f045e7e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $841a04425f045e7e$export$3633e017e520a1c2,
        pageId: "project-settings-connect-apps",
        shouldShowSpinner: false
    });

});


parcelRegister("7B6VF", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationRouteEntry", () => $033d001835d92f56$export$7a0b8ca27efc7201);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $7HDop = parcelRequire("7HDop");

var $6Z2mh = parcelRequire("6Z2mh");

var $01Poo = parcelRequire("01Poo");

var $01LdL = parcelRequire("01LdL");
const $033d001835d92f56$export$7a0b8ca27efc7201 = (0, $7NszV.createEntry)((0, $7HDop.projectSettingsServicedeskAutomationRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: `project-settings-automation-${0, $01LdL.SERVICE_DESK_PRODUCT}`,
        component: (0, $01Poo.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $01Poo.LazyProjectSettingsJiraAutomation)
        ]
    }));

});
parcelRegister("01Poo", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsJiraAutomation", () => $f62e804ec9c6d7ed$export$dea5ad7e8eac12ae);
$parcel$export(module.exports, "default", () => $f62e804ec9c6d7ed$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $f62e804ec9c6d7ed$export$dea5ad7e8eac12ae = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("3Dp46")), {
    moduleId: "./src/packages/spa-apps/project-settings/jira-automation/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f62e804ec9c6d7ed$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $f62e804ec9c6d7ed$export$dea5ad7e8eac12ae,
        pageId: "project-settings-jira-automation",
        shouldShowSpinner: true
    });

});


parcelRegister("dyGLN", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskDataClassificationsRouteEntry", () => $245c81b9a56de56f$export$5cea2172fd288382);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $jqtuR = parcelRequire("jqtuR");

var $6Z2mh = parcelRequire("6Z2mh");

var $jaAyo = parcelRequire("jaAyo");

var $6h9hV = parcelRequire("6h9hV");
const $245c81b9a56de56f$export$5cea2172fd288382 = (0, $7NszV.createEntry)((0, $jqtuR.projectSettingsServicedeskDataClassificationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $6h9hV.default),
        skeleton: (0, $jaAyo.ProjectSettingsDetailsSkeleton),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $6h9hV.LazyDataClassificationsSettings)
        ]
    }));

});
parcelRegister("jqtuR", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskDataClassificationsRoute", () => $42b53ec38758c5f7$export$ec4d4f6583272cd);
const $42b53ec38758c5f7$export$ec4d4f6583272cd = {
    name: 'project-settings-servicedesk-data-classifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/data-classifications',
    exact: true
};

});

parcelRegister("6h9hV", function(module, exports) {

$parcel$export(module.exports, "LazyDataClassificationsSettings", () => $953aed1c2ae3d2f5$export$b8abcf8aa8f4df56);
$parcel$export(module.exports, "default", () => $953aed1c2ae3d2f5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $953aed1c2ae3d2f5$export$b8abcf8aa8f4df56 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("foQoc"))), {
    moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$953aed1c2ae3d2f5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $953aed1c2ae3d2f5$export$b8abcf8aa8f4df56,
        pageId: "project-settings-data-classifications",
        shouldShowSpinner: false
    });

});


parcelRegister("gwCoT", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskItsmFeaturesRouteEntry", () => $8c26b195513d6c20$export$40ca23d1e05da300);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6sNnq = parcelRequire("6sNnq");

var $jP54v = parcelRequire("jP54v");

var $6Z2mh = parcelRequire("6Z2mh");

var $bz1sy = parcelRequire("bz1sy");
const $8c26b195513d6c20$export$40ca23d1e05da300 = (0, $7NszV.createEntry)((0, $jP54v.projectSettingsServicedeskItsmFeaturesRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'jsm-features-settings',
        component: (0, $bz1sy.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $6sNnq.featuresResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bz1sy.LazyProjectSettingsServiceDeskItsmFeatures)
        ],
        perfMetricKey: 'jsm-features-settings'
    }));

});
parcelRegister("jP54v", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskItsmFeaturesRoute", () => $444365caa1de116d$export$e60ffa2990540464);
const $444365caa1de116d$export$e60ffa2990540464 = {
    name: 'project-settings-servicedesk-itsm-features',
    path: '/jira/servicedesk/projects/:projectKey/settings/itsm-features',
    exact: true
};

});

parcelRegister("bz1sy", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskItsmFeatures", () => $402e11ff5e131d95$export$562be1021beb9882);
$parcel$export(module.exports, "default", () => $402e11ff5e131d95$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $402e11ff5e131d95$export$562be1021beb9882 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("k759J"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-itsm-features/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$402e11ff5e131d95$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $402e11ff5e131d95$export$562be1021beb9882,
        pageId: "project-settings-itsm-features",
        shouldShowSpinner: true
    });

});
parcelRegister("k759J", function(module, exports) {

let $ea4875f0b72a5716$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ea4875f0b72a5716$var$load("3aFI2").then(()=>parcelRequire('dWAhE'));

});



parcelRegister("bbdey", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsInternalNotificationsRouteEntry", () => $d5bc60012ecbb2c8$export$4a15f2c244cd196c);

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $2CYtL = parcelRequire("2CYtL");

var $6Z2mh = parcelRequire("6Z2mh");

var $f8FqB = parcelRequire("f8FqB");

var $e8N9g = parcelRequire("e8N9g");

var $jNJyR = parcelRequire("jNJyR");
const $d5bc60012ecbb2c8$export$4a15f2c244cd196c = (0, $7NszV.createEntry)((0, $2CYtL.projectSettingsServicedeskNotificationsInternalNotificationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.internal-notifications',
        component: (0, $e8N9g.serviceDeskInternalNotificationsNextGenRedirect),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jNJyR.LazyProjectSettingsServiceDeskInternalNotifications),
            (0, $f8FqB.LazyInternalNotificationSettingsPage)
        ]
    }));

});
parcelRegister("f8FqB", function(module, exports) {

$parcel$export(module.exports, "LazyInternalNotificationSettingsPage", () => $c99d86239fe70688$export$501979bd6d492c43);

var $kxZPA = parcelRequire("kxZPA");

const $c99d86239fe70688$export$501979bd6d492c43 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("1R31W")), {
    moduleId: "./src/packages/servicedesk/notification-internal/src/ui/index.tsx"
});

});
parcelRegister("1R31W", function(module, exports) {

let $159d17766285f7f8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $159d17766285f7f8$var$load("2oZWs").then(()=>parcelRequire('ZHF20'));

});


parcelRegister("e8N9g", function(module, exports) {

$parcel$export(module.exports, "serviceDeskInternalNotificationsNextGenRedirect", () => $68a880eb92a707c3$export$49625f83fe7ecc69);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
const $68a880eb92a707c3$export$49625f83fe7ecc69 = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/internal-notifications`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: url
    });
};

});

parcelRegister("jNJyR", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskInternalNotifications", () => $1956b65a2446b925$export$9c9d293dc6de29d0);
$parcel$export(module.exports, "default", () => $1956b65a2446b925$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $1956b65a2446b925$export$9c9d293dc6de29d0 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("4izHY"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-internal-notifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1956b65a2446b925$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $1956b65a2446b925$export$9c9d293dc6de29d0,
        pageId: "project-settings-internal-notifications",
        shouldShowSpinner: true
    });

});
parcelRegister("4izHY", function(module, exports) {

let $32148ac1c0860cb0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $32148ac1c0860cb0$var$load("bJipY").then(()=>parcelRequire('apjAt'));

});



parcelRegister("drVWM", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskInternalNotificationsNextGenRouteEntry", () => $a5004afda5310874$export$dfcd097af0ecd961);

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $h6YNW = parcelRequire("h6YNW");

var $6Z2mh = parcelRequire("6Z2mh");

var $f8FqB = parcelRequire("f8FqB");

var $jNJyR = parcelRequire("jNJyR");
const $a5004afda5310874$export$dfcd097af0ecd961 = (0, $7NszV.createEntry)((0, $h6YNW.projectSettingsServicedeskInternalNotificationsNextGenRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.internal-notifications',
        component: (0, $jNJyR.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $jNJyR.LazyProjectSettingsServiceDeskInternalNotifications),
            (0, $f8FqB.LazyInternalNotificationSettingsPage)
        ]
    }));

});

parcelRegister("t2WaR", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsNotificationEmailRouteEntry", () => $fc3eddb4351c27ae$export$cc1164e0e5db595);

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $buwAo = parcelRequire("buwAo");

var $6Z2mh = parcelRequire("6Z2mh");

var $6T6BC = parcelRequire("6T6BC");

var $k1jvb = parcelRequire("k1jvb");
const $fc3eddb4351c27ae$export$cc1164e0e5db595 = (0, $7NszV.createEntry)((0, $buwAo.projectSettingsServicedeskNotificationsNotificationEmailRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $k1jvb.ServiceDeskNotificationEmailNextGenRedirect),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $6T6BC.LazyProjectSettingsNotificationEmail)
        ]
    }));

});
parcelRegister("6T6BC", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsNotificationEmail", () => $6229d9dc67e508de$export$ea7d73c94d9369f4);
$parcel$export(module.exports, "default", () => $6229d9dc67e508de$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $6229d9dc67e508de$export$ea7d73c94d9369f4 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hLnUL"))), {
    moduleId: "./src/packages/spa-apps/project-settings/notification-email/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6229d9dc67e508de$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $6229d9dc67e508de$export$ea7d73c94d9369f4,
        pageId: "project-settings-email-notifications",
        shouldShowSpinner: true
    });

});

parcelRegister("k1jvb", function(module, exports) {

$parcel$export(module.exports, "ServiceDeskNotificationEmailNextGenRedirect", () => $060e0b1586db8e82$export$735e58642f560ddc);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
const $060e0b1586db8e82$export$735e58642f560ddc = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/notification-email`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: url
    });
};

});


parcelRegister("72XXS", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsEmailRouteEntry", () => $fd4b138cf89ddc30$export$ec0ead95e321b800);

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $9ujoJ = parcelRequire("9ujoJ");

var $6Z2mh = parcelRequire("6Z2mh");

var $6T6BC = parcelRequire("6T6BC");
const $fd4b138cf89ddc30$export$ec0ead95e321b800 = (0, $7NszV.createEntry)((0, $9ujoJ.projectSettingsServicedeskNotificationsEmailRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $6T6BC.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $6T6BC.LazyProjectSettingsNotificationEmail)
        ]
    }));

});

parcelRegister("yVmHw", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsRouteEntry", () => $a804e86b2cf06d23$export$20923f853e06d781);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $9D90J = parcelRequire("9D90J");

var $6Z2mh = parcelRequire("6Z2mh");

var $hJD3V = parcelRequire("hJD3V");
const $a804e86b2cf06d23$export$20923f853e06d781 = (0, $7NszV.createEntry)((0, $9D90J.projectSettingsServicedeskNotificationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $hJD3V.notificationsRedirect)('customer-notifications'),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("9D90J", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsRoute", () => $f83be005a8f713dd$export$dbc53740e1d7ff79);
const $f83be005a8f713dd$export$dbc53740e1d7ff79 = {
    name: 'project-settings-servicedesk-notifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/notifications',
    exact: true
};

});

parcelRegister("hJD3V", function(module, exports) {

$parcel$export(module.exports, "notificationsRedirect", () => $d3615143cfedd2aa$export$59144dd4441639fa);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $02Psx = parcelRequire("02Psx");

var $7tQej = parcelRequire("7tQej");
const $d3615143cfedd2aa$export$59144dd4441639fa = (pageUrlFragment)=>({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = projectKey !== null && projectKey !== undefined ? `${(0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), projectKey)}/notifications/${pageUrlFragment}` : `/projects/${String(projectKey)}/settings/notifications/${pageUrlFragment}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: url,
            push: false
        });
    };

});


parcelRegister("ljDIh", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLanguageKeyRouteEntry", () => $2ca289138c55c124$export$db3a99044f906462);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $e4oBS = parcelRequire("e4oBS");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $k7tsS = parcelRequire("k7tsS");

var $lAfKa = parcelRequire("lAfKa");
const $2ca289138c55c124$export$db3a99044f906462 = (0, $7NszV.createEntry)((0, $e4oBS.projectSettingsServicedeskLanguageKeyRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.translations',
        component: (0, $lAfKa.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $k7tsS.languageTranslationsResource),
            (0, $k7tsS.outgoingEmailStateModelResource)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).LANGUAGE_SETTINGS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).LANGUAGE_SETTINGS),
                teamName: 'jsm-banana'
            }
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $lAfKa.LazyProjectSettingsServiceDeskLanguageTranslations)
        ],
        perfMetricKey: 'jsm-language-translations'
    }));

});
parcelRegister("e4oBS", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLanguageKeyRoute", () => $8a798ea346394d71$export$194a3f27b07aafec);
const $8a798ea346394d71$export$194a3f27b07aafec = {
    name: 'project-settings-servicedesk-language-key',
    path: '/jira/servicedesk/projects/:projectKey/settings/language/:languageKey/:sidebarItemKey?'
};

});

parcelRegister("k7tsS", function(module, exports) {

$parcel$export(module.exports, "languageTranslationsResource", () => $ffad7a39054feef3$export$f51887e33895eab9);
$parcel$export(module.exports, "outgoingEmailStateModelResource", () => $ffad7a39054feef3$export$c460156a7e6b85b2);

var $2M1hQ = parcelRequire("2M1hQ");
const $ffad7a39054feef3$export$9f529be3aeae01ea = 'JSM Language Translations';
const $ffad7a39054feef3$export$ecd381e388e8c56f = "Language Support Customer Notification's Outgoing Email State";

const $ffad7a39054feef3$export$f51887e33895eab9 = (0, $2M1hQ.createResource)({
    type: 'Language Translations',
    getKey: ({ match: { params: { projectKey: projectKey, languageKey: languageKey } } })=>`${$ffad7a39054feef3$export$9f529be3aeae01ea}-${projectKey}-${languageKey}`,
    getDataLoader: ()=>(parcelRequire("knz5P")),
    maxAge: Infinity
});

const $ffad7a39054feef3$export$c460156a7e6b85b2 = (0, $2M1hQ.createResource)({
    type: 'Outgoing Email State Model',
    getKey: ()=>`${$ffad7a39054feef3$export$ecd381e388e8c56f}`,
    getDataLoader: ()=>(parcelRequire("3VjNS")),
    maxAge: Infinity
});

});
parcelRegister("knz5P", function(module, exports) {

let $ed612d6393858c1f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ed612d6393858c1f$var$load("5fBDT").then(()=>parcelRequire('3m5cp'));

});

parcelRegister("3VjNS", function(module, exports) {

let $2db60e7fc388debe$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2db60e7fc388debe$var$load("l1iwu").then(()=>parcelRequire('49aS0'));

});


parcelRegister("lAfKa", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskLanguageTranslations", () => $818bcbaaddc8bfd3$export$c029d3f514c7b3e0);
$parcel$export(module.exports, "default", () => $818bcbaaddc8bfd3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $818bcbaaddc8bfd3$export$c029d3f514c7b3e0 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("c2QNW")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-language-translations/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$818bcbaaddc8bfd3$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $818bcbaaddc8bfd3$export$c029d3f514c7b3e0,
        pageId: "project-settings-language-translations",
        shouldShowSpinner: true
    });

});
parcelRegister("c2QNW", function(module, exports) {

let $8c4ea1ca82de4f8e$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $8c4ea1ca82de4f8e$var$load("ffQaD"),
    $8c4ea1ca82de4f8e$var$load("kvRbA"),
    $8c4ea1ca82de4f8e$var$load("fliVL"),
    $8c4ea1ca82de4f8e$var$load("bu4VX")
]).then(()=>parcelRequire('kG5x5'));

});



parcelRegister("lAnjX", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLanguageRouteEntry", () => $bffa1bbc0966d026$export$576b048795cbefad);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $jZ1W8 = parcelRequire("jZ1W8");

var $6Z2mh = parcelRequire("6Z2mh");

var $6xGbx = parcelRequire("6xGbx");

var $lAfKa = parcelRequire("lAfKa");
const $bffa1bbc0966d026$export$576b048795cbefad = (0, $7NszV.createEntry)((0, $jZ1W8.projectSettingsServicedeskLanguageRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.languages',
        component: (0, $6xGbx.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $lAfKa.LazyProjectSettingsServiceDeskLanguageTranslations)
        ]
    }));

});
parcelRegister("jZ1W8", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLanguageRoute", () => $171e592762201788$export$99b0bbae92462ac2);
const $171e592762201788$export$99b0bbae92462ac2 = {
    name: 'project-settings-servicedesk-language',
    path: '/jira/servicedesk/projects/:projectKey/settings/language',
    exact: true
};

});

parcelRegister("6xGbx", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c45ee4ab52677ce$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $4c45ee4ab52677ce$export$213b8279037c9d98 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("23tIB"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-language-support/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4c45ee4ab52677ce$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $4c45ee4ab52677ce$export$213b8279037c9d98,
        pageId: "project-settings-language-support",
        shouldShowSpinner: true
    });

});
parcelRegister("23tIB", function(module, exports) {

let $17f2ea03d8409eca$var$load = (parcelRequire("28QjX"))(4);
module.exports = $17f2ea03d8409eca$var$load("chbbZ").then(()=>parcelRequire('4yiYq'));

});



parcelRegister("cONlw", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsPermissionsNextGenRouteEntry", () => $4964340980955d47$export$65a2b00cdeff4516);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $10cgn = parcelRequire("10cgn");

var $8pE1n = parcelRequire("8pE1n");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $tQ1zW = parcelRequire("tQ1zW");

var $aZDos = parcelRequire("aZDos");
const $4964340980955d47$export$65a2b00cdeff4516 = (0, $7NszV.createEntry)((0, $8pE1n.projectSettingsServicedeskChannelsPermissionsNextGenRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $tQ1zW.customerPermissionsRedirect),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $dxCvy.projectContextResource),
            (0, $10cgn.customerPermissionsPageDataResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aZDos.LazyProjectSettingsServiceDeskCustomerPermissions)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).CUSTOMER_PERMISSIONS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).CUSTOMER_PERMISSIONS),
                teamName: 'jsd-flux-capacitors'
            }
        },
        perfMetricKey: 'jsm-customer-permissions'
    }));

});
parcelRegister("10cgn", function(module, exports) {

$parcel$export(module.exports, "customerPermissionsPageDataResource", () => $35508436fc3abfb3$export$ae3446385906310c);

var $2M1hQ = parcelRequire("2M1hQ");


const $35508436fc3abfb3$export$ae3446385906310c = (0, $2M1hQ.createResource)({
    type: (0, $9cf87aec7862b8b9$export$34a89f9aaa677bb5),
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("hzRiC")),
    maxAge: Infinity
});

});
const $9cf87aec7862b8b9$export$34a89f9aaa677bb5 = 'CUSTOMER_PERMISSIONS';

parcelRegister("hzRiC", function(module, exports) {

let $ccbf0cb0b6a46451$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ccbf0cb0b6a46451$var$load("heNxp").then(()=>parcelRequire('i9zBn'));

});


parcelRegister("tQ1zW", function(module, exports) {

$parcel$export(module.exports, "customerPermissionsRedirect", () => $467404e10c7e501f$export$59eedcca37dbbafd);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
const $467404e10c7e501f$export$59eedcca37dbbafd = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/customer-permissions`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: url
    });
};

});

parcelRegister("aZDos", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskCustomerPermissions", () => $8d9798e9d24a9632$export$5367e40a24f0bd54);
$parcel$export(module.exports, "default", () => $8d9798e9d24a9632$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $8d9798e9d24a9632$export$5367e40a24f0bd54 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("be2DK"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-customer-permissions/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8d9798e9d24a9632$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8d9798e9d24a9632$export$5367e40a24f0bd54,
        pageId: "project-settings-customer-permissions",
        shouldShowSpinner: true
    });

});
parcelRegister("be2DK", function(module, exports) {

let $82c30cc87147dc95$var$load = (parcelRequire("28QjX"))(4);
module.exports = $82c30cc87147dc95$var$load("iAFWW").then(()=>parcelRequire('3eQYY'));

});



parcelRegister("28AFT", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskCustomerPermissionsRouteEntry", () => $35c7869995fcce58$export$ed034e5245184767);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $10cgn = parcelRequire("10cgn");

var $fdCkK = parcelRequire("fdCkK");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $aZDos = parcelRequire("aZDos");
const $35c7869995fcce58$export$ed034e5245184767 = (0, $7NszV.createEntry)((0, $fdCkK.projectSettingsServicedeskCustomerPermissionsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $aZDos.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $dxCvy.projectContextResource),
            (0, $10cgn.customerPermissionsPageDataResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aZDos.LazyProjectSettingsServiceDeskCustomerPermissions)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).CUSTOMER_PERMISSIONS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).CUSTOMER_PERMISSIONS),
                teamName: 'jsd-flux-capacitors'
            }
        },
        perfMetricKey: 'jsm-customer-permissions'
    }));

});

parcelRegister("gsEXA", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsEmailNextGenRouteEntry", () => $61a4779d190eed13$export$b4590bec09451e4c);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $hOElL = parcelRequire("hOElL");

var $6Z2mh = parcelRequire("6Z2mh");

var $vzOOJ = parcelRequire("vzOOJ");

var $3VKX1 = parcelRequire("3VKX1");
const $61a4779d190eed13$export$b4590bec09451e4c = (0, $7NszV.createEntry)((0, $hOElL.projectSettingsServicedeskChannelsEmailNextGenRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $vzOOJ.serviceDeskEmailNextGenRedirect),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3VKX1.LazyProjectSettingsServiceDeskEmail)
        ]
    }));

});
parcelRegister("hOElL", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsEmailNextGenRoute", () => $a6fdffc3a6348da0$export$89c7bf2bac1464c2);
const $a6fdffc3a6348da0$export$89c7bf2bac1464c2 = {
    name: 'project-settings-servicedesk-channels-email-next-gen',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/email',
    exact: true
};

});

parcelRegister("vzOOJ", function(module, exports) {

$parcel$export(module.exports, "serviceDeskEmailNextGenRedirect", () => $f10a7d047f1802a3$export$86c8da903fb97c4f);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
const $f10a7d047f1802a3$export$86c8da903fb97c4f = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/email`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: url
    });
};

});

parcelRegister("3VKX1", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskEmail", () => $881ebeec1a2867ea$export$66d0c668045080de);
$parcel$export(module.exports, "default", () => $881ebeec1a2867ea$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kKHTt = parcelRequire("kKHTt");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $881ebeec1a2867ea$export$66d0c668045080de = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("bA78Z")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-email/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$881ebeec1a2867ea$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kKHTt.HelpCenterSettingsRedirect), {
        page: "email"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $881ebeec1a2867ea$export$66d0c668045080de,
        pageId: "project-settings-email",
        shouldShowSpinner: true
    }));

});
parcelRegister("kKHTt", function(module, exports) {

$parcel$export(module.exports, "HelpCenterSettingsRedirect", () => $ebd0dfae741c0d7b$export$a24ec33acfeae48d);

var $k9rcv = parcelRequire("k9rcv");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ds5qV = parcelRequire("ds5qV");

var $lODMY = parcelRequire("lODMY");

var $dAfqg = parcelRequire("dAfqg");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $fY39E = parcelRequire("fY39E");

var $koeKL = parcelRequire("koeKL");

var $7XYc4 = parcelRequire("7XYc4");

var $ahChO = parcelRequire("ahChO");

var $4R6GH = parcelRequire("4R6GH");

var $2vSU6 = parcelRequire("2vSU6");

var $aTz47 = parcelRequire("aTz47");

var $jEJ7g = parcelRequire("jEJ7g");

var $8WSu7 = parcelRequire("8WSu7");

var $jagxb = parcelRequire("jagxb");
const $ebd0dfae741c0d7b$export$c224e724e933fbea = (page, pathname)=>{
    if (page === 'customer-notifications') {
        const customerNotificationsPage = pathname.split('/settings/customer-notifications')[1];
        if (customerNotificationsPage === '/template') return 'customer-notifications-template';
        if (customerNotificationsPage === '/account-notification/invite-customer') return 'customer-notifications-invite-customer';
        if (/rule\/\d+/.test(customerNotificationsPage)) return 'customer-notifications-rule';
    }
    return page;
};
const $ebd0dfae741c0d7b$export$2d1034e371a567c6 = (page, pathname, helpCenterId)=>{
    switch(page){
        case 'kb':
            return (0, $8WSu7.getSettingsPath)(pathname.replace('/confluence-kb', '/kb'), true, helpCenterId);
        default:
            return (0, $8WSu7.getSettingsPath)(pathname, true, helpCenterId);
    }
};
const $ebd0dfae741c0d7b$var$useLocation = (0, $lODMY.createRouterSelector)((state)=>state.location);
const $ebd0dfae741c0d7b$export$b90b599f4b180ba = ({ page: page, children: children })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const useLocationOld = (0, $lODMY.createRouterSelector)((state)=>state.location);
    const location = useLocationOld();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const isJCS = (0, $jEJ7g.useIsJCSProjectType)(projectContext?.projectType);
    (0, $5uXOq.useEffect)(()=>{
        if (isJCS && !(0, $aTz47.isHelpCenterSettingsPath)()) {
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectSettingsToHelpCenterSettings redirected', {
                page: $ebd0dfae741c0d7b$export$c224e724e933fbea(page, location.pathname)
            });
            showFlag({
                messageId: 'servicedesk-customer-service-common.ui.help-center-settings-redirect.show-flag.error',
                messageType: 'transactional',
                type: 'error',
                title: formatMessage((0, $jagxb.default).errorTitle),
                description: formatMessage((0, $4R6GH.fg)('jcs_project_type_m3') ? (0, $jagxb.default).description : (0, $jagxb.default).errorDescription),
                isAutoDismiss: true
            });
        }
    }, [
        createAnalyticsEvent,
        formatMessage,
        isJCS,
        location.pathname,
        page,
        showFlag
    ]);
    if (isJCS && !(0, $aTz47.isHelpCenterSettingsPath)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: "/jira/helpcenter"
    });
    return children;
};
const $ebd0dfae741c0d7b$export$4e0587d8c8738b4d = ({ page: page, children: children })=>{
    const location = $ebd0dfae741c0d7b$var$useLocation();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const isJCS = projectContext?.projectType === (0, $2vSU6.CUSTOMER_SERVICE_PROJECT);
    (0, $5uXOq.useEffect)(()=>{
        if (isJCS && !(0, $aTz47.isHelpCenterSettingsPath)()) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectSettingsToHelpCenterSettings redirected', {
            page: $ebd0dfae741c0d7b$export$c224e724e933fbea(page, location.pathname)
        });
    }, [
        createAnalyticsEvent,
        isJCS,
        location.pathname,
        page
    ]);
    if (isJCS && !(0, $aTz47.isHelpCenterSettingsPath)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ebd0dfae741c0d7b$export$b65700afa6ae3ae9, {
        page: page,
        pathname: location.pathname,
        projectId: projectContext.projectId
    });
    return children;
};
const $ebd0dfae741c0d7b$export$b65700afa6ae3ae9 = ({ page: page, pathname: pathname, projectId: projectId })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const activationId = (0, $fY39E.useActivationId)();
    const cloudId = (0, $koeKL.useCloudId)();
    const jiraProjectAri = `ari:cloud:jira:${cloudId}:project/${projectId}`;
    const jiraWorkspaceAri = `ari:cloud:jira:${cloudId}:workspace/${activationId}`;
    const { helpCenter: { helpCenterByHoistedProjectIdRouted: helpCenter } } = (0, $8Uumt.useLazyLoadQuery)((0, $k9rcv.default), {
        cloudId: cloudId,
        jiraProjectAri: jiraProjectAri,
        jiraWorkspaceAri: jiraWorkspaceAri
    });
    if (helpCenter.__typename !== 'HelpCenter') {
        showFlag({
            messageId: 'servicedesk-customer-service-common.ui.help-center-settings-redirect.show-flag.error.1',
            messageType: 'transactional',
            type: 'error',
            title: formatMessage((0, $jagxb.default).errorTitle),
            description: formatMessage((0, $jagxb.default).errorDescription),
            isAutoDismiss: true
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
            to: "/jira/helpcenter"
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ds5qV.ScreenRedirect), {
        to: $ebd0dfae741c0d7b$export$2d1034e371a567c6(page, pathname, (0, $ahChO.HelpHelpCenterAri).parse(helpCenter.id).helpCenterId),
        persistSearchParams: true
    });
};
const $ebd0dfae741c0d7b$export$a24ec33acfeae48d = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jcs_project_type_m3'), $ebd0dfae741c0d7b$export$4e0587d8c8738b4d, $ebd0dfae741c0d7b$export$b90b599f4b180ba);

});
parcelRegister("k9rcv", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3d97065ff4628c3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5a71e1d1b1dbf7cb82e4e714dfd62b93>>
 * @relayHash e13196a4072c1e05f1d5cb92fe604cee
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d94a9943ce2554eb8cf7db62a3d014b0ef4ffb159df3aec135c71cb712c22610
const $e3d97065ff4628c3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jiraProjectAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jiraWorkspaceAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "projectAri",
            "variableName": "jiraProjectAri"
        },
        {
            "kind": "Variable",
            "name": "workspaceAri",
            "variableName": "jiraWorkspaceAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "ScalarField",
            "name": "id"
        }
    ], v5 = {
        "kind": "InlineFragment",
        "selections": v4 /*: any*/ ,
        "type": "HelpCenter"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "helpCenterSettingsRedirectQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "HelpCenterQueryApi",
                        "kind": "LinkedField",
                        "name": "helpCenter",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "helpCenterByHoistedProjectIdRouted",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "helpCenter.helpCenterByHoistedProjectIdRouted"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "helpCenter"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "helpCenterSettingsRedirectQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterByHoistedProjectIdRouted",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": v4 /*: any*/ ,
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d94a9943ce2554eb8cf7db62a3d014b0ef4ffb159df3aec135c71cb712c22610",
            "metadata": {},
            "name": "helpCenterSettingsRedirectQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e3d97065ff4628c3$var$node.hash = "87969f8d9448b730bb329d59f60087f6";
var $e3d97065ff4628c3$export$2e2bcd8739ae039 = $e3d97065ff4628c3$var$node;

});

parcelRegister("ahChO", function(module, exports) {

$parcel$export(module.exports, "HelpHelpCenterAri", () => $77c930c30f742077$export$a75f3c98d930b258);

var $2DmWN = parcelRequire("2DmWN");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/help/help-center/manifest.ts
var $77c930c30f742077$var$helpHelpCenterAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $2DmWN.HelpHelpCenterAriResourceOwner),
    resourceType: (0, $2DmWN.HelpHelpCenterAriResourceType),
    resourceIdSlug: "{activationId}/{helpCenterId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        helpCenterId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/help/help-center/index.ts
var $77c930c30f742077$export$a75f3c98d930b258 = class _HelpHelpCenterAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._activationId = opts.resourceIdSegmentValues.activationId, this._helpCenterId = opts.resourceIdSegmentValues.helpCenterId;
    }
    get activationId() {
        return this._activationId;
    }
    get helpCenterId() {
        return this._helpCenterId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $77c930c30f742077$var$helpHelpCenterAriStaticOpts.qualifier,
            platformQualifier: $77c930c30f742077$var$helpHelpCenterAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $77c930c30f742077$var$helpHelpCenterAriStaticOpts.resourceOwner,
            resourceType: $77c930c30f742077$var$helpHelpCenterAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}/${opts.helpCenterId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                helpCenterId: opts.helpCenterId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $77c930c30f742077$var$helpHelpCenterAriStaticOpts);
        return new _HelpHelpCenterAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $77c930c30f742077$var$helpHelpCenterAriStaticOpts);
        return new _HelpHelpCenterAri(opts);
    }
    getVariables() {
        return {
            activationId: this.activationId,
            helpCenterId: this.helpCenterId
        };
    }
};

});
parcelRegister("2DmWN", function(module, exports) {

$parcel$export(module.exports, "HelpHelpCenterAriResourceOwner", () => $1eb1062b37145e8a$export$a4af98a27b4568ee);
$parcel$export(module.exports, "HelpHelpCenterAriResourceType", () => $1eb1062b37145e8a$export$f6271ed6947e9084);
// src/help/help-center/types.ts
var $1eb1062b37145e8a$export$a4af98a27b4568ee = "help", $1eb1062b37145e8a$export$f6271ed6947e9084 = "help-center";

});


parcelRegister("aTz47", function(module, exports) {

$parcel$export(module.exports, "isHelpCenterSettingsPath", () => $1e0d45f36b27f85a$export$bf8b98b87d485657);
$parcel$export(module.exports, "getHelpCenterUUIDFromPath", () => $1e0d45f36b27f85a$export$73a9fbfd9155f593);

var $gKZoD = parcelRequire("gKZoD");

var $4R6GH = parcelRequire("4R6GH");
const $1e0d45f36b27f85a$export$bf8b98b87d485657 = ()=>{
    (0, $gKZoD.di)(window);
    if (!(0, $4R6GH.fg)('jcs_master_flag')) return false;
    if (!false) return window.location.pathname.includes('jira/helpcenter/');
    return false;
};
const $1e0d45f36b27f85a$export$73a9fbfd9155f593 = ()=>{
    (0, $gKZoD.di)(window);
    if (!$1e0d45f36b27f85a$export$bf8b98b87d485657()) return '';
    if (!false) return window.location.pathname.match(/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}/)?.[0];
    return '';
};

});

parcelRegister("jEJ7g", function(module, exports) {

$parcel$export(module.exports, "useAsyncIsJCS", () => $db67bf04078e8532$export$3894a8f24b665478);
$parcel$export(module.exports, "isJCSProjectType", () => $db67bf04078e8532$export$25e1541dd4631818);
$parcel$export(module.exports, "useIsJCSProjectType", () => $db67bf04078e8532$export$b78b0f34fdacd97a);
$parcel$export(module.exports, "isJCSTemplate", () => $db67bf04078e8532$export$afee907b7a66ef2b);

var $e5wyW = parcelRequire("e5wyW");

var $4R6GH = parcelRequire("4R6GH");

var $O4MMs = parcelRequire("O4MMs");

var $2vSU6 = parcelRequire("2vSU6");
const $db67bf04078e8532$var$useIsJCSProjectTypeFallback = (projectType, isAsync)=>{
    const isJCS = $db67bf04078e8532$export$3894a8f24b665478();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return isAsync ? isJCS : Boolean(isJCS);
};
const $db67bf04078e8532$export$25e1541dd4631818 = (projectType)=>projectType === (0, $2vSU6.CUSTOMER_SERVICE_PROJECT) && (0, $4R6GH.fg)('jcs_project_type_m3');
const $db67bf04078e8532$export$4b74a6f22da4a0d2 = (projectType)=>projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) || $db67bf04078e8532$export$25e1541dd4631818(projectType);
const $db67bf04078e8532$export$b78b0f34fdacd97a = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jcs_project_type_m3'), $db67bf04078e8532$export$25e1541dd4631818, $db67bf04078e8532$var$useIsJCSProjectTypeFallback);
//
//  M2 helpers, deprecated
// ---------------------
const $db67bf04078e8532$var$useIsJCSUnderFF = ()=>{
    const { 'initial.project.template.name': initialProjectTemplate } = (0, $O4MMs.useProjectProperties)([
        'initial.project.template.name'
    ]);
    return initialProjectTemplate === 'com.atlassian.jcs:customer-service-management';
};
const $db67bf04078e8532$export$927b5354181b3adf = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jcs_master_flag'), $db67bf04078e8532$var$useIsJCSUnderFF, ()=>false);
// Undefined can be used to check if project properties has been resolved or not
const $db67bf04078e8532$var$useAsyncIsJCSUnderFF = ()=>{
    const { 'initial.project.template.name': initialProjectTemplate } = (0, $O4MMs.useProjectProperties)([
        'initial.project.template.name'
    ]);
    return initialProjectTemplate ? initialProjectTemplate === 'com.atlassian.jcs:customer-service-management' : undefined;
};
const $db67bf04078e8532$export$3894a8f24b665478 = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jcs_master_flag'), $db67bf04078e8532$var$useAsyncIsJCSUnderFF, ()=>false);
const $db67bf04078e8532$var$isJCSTemplateUnderFF = (template)=>template === 'com.atlassian.jcs:customer-service-management';
const $db67bf04078e8532$var$isJCSTemplateFallback = (template)=>false;
const $db67bf04078e8532$export$afee907b7a66ef2b = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jcs_master_flag'), $db67bf04078e8532$var$isJCSTemplateUnderFF, $db67bf04078e8532$var$isJCSTemplateFallback);

});
parcelRegister("O4MMs", function(module, exports) {

$parcel$export(module.exports, "useProjectProperties", () => $eccdf8f1b49d4032$export$58be98885c2d686a);

var $5uXOq = parcelRequire("5uXOq");

var $74ySO = parcelRequire("74ySO");

var $ajpes = parcelRequire("ajpes");

var $4f8Oj = parcelRequire("4f8Oj");

var $lpwtK = parcelRequire("lpwtK");

var $1XJ20 = parcelRequire("1XJ20");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $dYZ0w = parcelRequire("dYZ0w");
const $eccdf8f1b49d4032$export$d4c72bab9d6cc13a = {};
const $eccdf8f1b49d4032$var$Store = (0, $iXqE5.createStore)({
    name: 'project-properties',
    initialState: $eccdf8f1b49d4032$export$d4c72bab9d6cc13a,
    actions: $dYZ0w.actions
});
const $eccdf8f1b49d4032$export$eebf791068e870dd = (0, $3sQ5x.createHook)($eccdf8f1b49d4032$var$Store);
const $eccdf8f1b49d4032$export$58be98885c2d686a = (propertyKeys, projectIdOverride)=>{
    const { data: data } = (0, $lpwtK.useProject)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const projectId = projectIdOverride !== undefined ? projectIdOverride : data?.id && `${data.id}`;
    const [state, { get: get }] = $eccdf8f1b49d4032$export$eebf791068e870dd();
    const prevPropertyKeys = (0, $1XJ20.usePrevious)(propertyKeys);
    (0, $5uXOq.useEffect)(()=>{
        if (projectId === undefined) (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jiraProjectPropertiesServices undefinedProjectId');
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(propertyKeys, prevPropertyKeys) && !projectIdOverride) return;
        if (projectId) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        get(projectId, propertyKeys);
    }, [
        projectId,
        propertyKeys,
        prevPropertyKeys,
        get,
        createAnalyticsEvent,
        projectIdOverride
    ]);
    return projectId !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($4f8Oj)))(state[projectId], (_, key)=>(0, (/*@__PURE__*/$parcel$interopDefault($74ySO)))(propertyKeys, key)) : {};
};

});
parcelRegister("74ySO", function(module, exports) {

var $2wwA6 = parcelRequire("2wwA6");

var $hTJwX = parcelRequire("hTJwX");

var $agVdz = parcelRequire("agVdz");

var $kPZpS = parcelRequire("kPZpS");

var $dMEgP = parcelRequire("dMEgP");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5263f72d78aeaf9c$var$nativeMax = Math.max;
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function $5263f72d78aeaf9c$var$includes(collection, value, fromIndex, guard) {
    collection = $hTJwX(collection) ? collection : $dMEgP(collection);
    fromIndex = fromIndex && !guard ? $kPZpS(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = $5263f72d78aeaf9c$var$nativeMax(length + fromIndex, 0);
    return $agVdz(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && $2wwA6(collection, value, fromIndex) > -1;
}
module.exports = $5263f72d78aeaf9c$var$includes;

});

parcelRegister("dYZ0w", function(module, exports) {

$parcel$export(module.exports, "actions", () => $d36e01b4b5883936$export$e324594224ef24da);

var $9Tr6m = parcelRequire("9Tr6m");
const $d36e01b4b5883936$export$e324594224ef24da = {
    get: $9Tr6m.get
};

});
parcelRegister("9Tr6m", function(module, exports) {

$parcel$export(module.exports, "get", () => $52dc90cc0afc52f4$export$3988ae62b71be9a3);

var $k8IPx = parcelRequire("k8IPx");

var $cjFoH = parcelRequire("cjFoH");

var $66FNL = parcelRequire("66FNL");

var $fUPWG = parcelRequire("fUPWG");
const $52dc90cc0afc52f4$export$3988ae62b71be9a3 = (projectId, properties)=>({ getState: getState, setState: setState })=>{
        const currentProperties = getState()[projectId] || {};
        const missingProperties = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(properties, (0, (/*@__PURE__*/$parcel$interopDefault($66FNL)))(currentProperties));
        missingProperties.length && (0, $fUPWG.default)({
            baseUrl: '',
            projectId: projectId,
            properties: missingProperties
        }).then((fetchedProperties)=>{
            const latestProperties = getState()[projectId] || {};
            setState({
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [projectId]: {
                    ...latestProperties,
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    ...missingProperties.reduce((result, name)=>{
                        const reducedResult = result;
                        const fetchedProperty = fetchedProperties[name];
                        // `undefined` inside state means that property was never requested.
                        // If value returned for the property is `undefined`, we will set it to `null`,
                        // to differentiate it from the unrequested state. Otherwise, returned value will be set.
                        reducedResult[name] = (0, (/*@__PURE__*/$parcel$interopDefault($cjFoH)))(fetchedProperty) ? null : fetchedProperty;
                        return reducedResult;
                    }, {})
                }
            });
        });
    };

});
parcelRegister("fUPWG", function(module, exports) {

$parcel$export(module.exports, "default", () => $573d8b462e0e2ec6$export$2e2bcd8739ae039);

var $1sYcL = parcelRequire("1sYcL");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$573d8b462e0e2ec6$export$2e2bcd8739ae039 = async ({ baseUrl: baseUrl, projectId: projectId, properties: properties })=>{
    const { project: project } = await (0, $1sYcL.get)(baseUrl, {
        projectId: projectId,
        projectProperties: properties,
        consumerMeta: {
            id: 'remoteGet',
            packageName: 'jiraProjectPropertiesServices',
            teamName: 'jsd-shield'
        }
    });
    return project;
};

});





parcelRegister("8WSu7", function(module, exports) {

$parcel$export(module.exports, "getSettingsPath", () => $b4b4e7a1fd793539$export$67417cd3aaee582d);
const $b4b4e7a1fd793539$export$67417cd3aaee582d = (path, isJCS, helpCenterId)=>{
    if (!helpCenterId) return isJCS ? path.replace('/jira/servicedesk/', '/jira/helpcenter/') : path;
    return path.replace('/jira/servicedesk/', '/jira/helpcenter/').replace('/settings', `/settings/${helpCenterId}`);
};

});

parcelRegister("jagxb", function(module, exports) {

$parcel$export(module.exports, "default", () => $a36eb1fdbec95bf4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a36eb1fdbec95bf4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "servicedesk-customer-service-common.help-center-settings-redirect.error-title",
        "defaultMessage": "This page has been moved"
    },
    errorDescription: {
        "id": "servicedesk-customer-service-common.help-center-settings-redirect.error-description",
        "defaultMessage": "You can find the page you\u2019re looking for in a service hub."
    },
    description: {
        "id": "servicedesk-customer-service-common.help-center-settings-redirect.description",
        "defaultMessage": "You can find the page you\u2019re looking for in a customer hub."
    }
});

});


parcelRegister("bA78Z", function(module, exports) {

let $86e8992988938ca9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $86e8992988938ca9$var$load("e6ONP").then(()=>parcelRequire('gu2ky'));

});



parcelRegister("g3Gvc", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskEmailRouteEntry", () => $0634a6ceff42062d$export$676e8af036d3e9c1);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $i62iX = parcelRequire("i62iX");

var $6Z2mh = parcelRequire("6Z2mh");

var $3VKX1 = parcelRequire("3VKX1");
const $0634a6ceff42062d$export$676e8af036d3e9c1 = (0, $7NszV.createEntry)((0, $i62iX.projectSettingsServicedeskEmailRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.settings.email-channels',
        component: (0, $3VKX1.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3VKX1.LazyProjectSettingsServiceDeskEmail)
        ]
    }));

});

parcelRegister("dseRA", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskPortalSettingsRouteEntry", () => $68ffccdafeca70f6$export$2f07a0943f4553c4);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $bveQD = parcelRequire("bveQD");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $34BDN = parcelRequire("34BDN");
const $68ffccdafeca70f6$export$2f07a0943f4553c4 = (0, $7NszV.createEntry)((0, $bveQD.projectSettingsServicedeskPortalSettingsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $34BDN.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $34BDN.LazyProjectSettingsServiceDeskClassicPortalSettings)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).PORTAL_SETTINGS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).PORTAL_SETTINGS),
                teamName: 'jsd-shield'
            }
        }
    }));

});
parcelRegister("34BDN", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskClassicPortalSettings", () => $2f67c1468e19aedd$export$eb662b618d6247be);
$parcel$export(module.exports, "default", () => $2f67c1468e19aedd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $2f67c1468e19aedd$export$eb662b618d6247be = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("9H24X"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-classic-portal-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2f67c1468e19aedd$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2f67c1468e19aedd$export$eb662b618d6247be,
        pageId: "project-settings-classic-portal-settings",
        shouldShowSpinner: true
    });

});
parcelRegister("9H24X", function(module, exports) {

let $70e9be059c49d1cc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $70e9be059c49d1cc$var$load("3gaLt").then(()=>parcelRequire('giHe4'));

});



parcelRegister("627LR", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsPortalRouteEntry", () => $631bf1a02812ef78$export$7b7294b50c70e50c);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $8CwPO = parcelRequire("8CwPO");

var $cfj3a = parcelRequire("cfj3a");

var $6Z2mh = parcelRequire("6Z2mh");

var $c0aPe = parcelRequire("c0aPe");
const $631bf1a02812ef78$export$7b7294b50c70e50c = (0, $7NszV.createEntry)((0, $cfj3a.projectSettingsServicedeskChannelsPortalRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $c0aPe.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $dxCvy.projectContextResource),
            (0, $8CwPO.portalSettingsContextResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $c0aPe.LazyProjectSettingsServiceDeskPortalSettings)
        ]
    }));

});
parcelRegister("8CwPO", function(module, exports) {

$parcel$export(module.exports, "portalSettingsContextResource", () => $9dfc351c3ebf85b6$export$4a3e29f235f3320c);

var $2M1hQ = parcelRequire("2M1hQ");
const $9dfc351c3ebf85b6$var$RESOURCE_TYPE_PORTAL_SETTINGS_CONTEXT = 'PORTAL_SETTINGS_CONTEXT';

const $9dfc351c3ebf85b6$export$4a3e29f235f3320c = (0, $2M1hQ.createResource)({
    type: $9dfc351c3ebf85b6$var$RESOURCE_TYPE_PORTAL_SETTINGS_CONTEXT,
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("90J7n"))
});

});
parcelRegister("90J7n", function(module, exports) {

let $68f71ca28af557ef$var$load = (parcelRequire("28QjX"))(4);
module.exports = $68f71ca28af557ef$var$load("kpoiF").then(()=>parcelRequire('7wy1U'));

});


parcelRegister("c0aPe", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskPortalSettings", () => $9da321ff59a70829$export$fdbd4b1e5ae0e422);
$parcel$export(module.exports, "default", () => $9da321ff59a70829$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $9da321ff59a70829$export$fdbd4b1e5ae0e422 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("c9Bia")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-portal-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9da321ff59a70829$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9da321ff59a70829$export$fdbd4b1e5ae0e422,
        pageId: "project-settings-portal-settings",
        shouldShowSpinner: true
    });

});
parcelRegister("c9Bia", function(module, exports) {

let $8d9340b8ccdabff9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8d9340b8ccdabff9$var$load("iBebQ").then(()=>parcelRequire('jQFbr'));

});



parcelRegister("3wbIE", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskExternalLinksRouteEntry", () => $95680d22988b2454$export$ca80e1d474f774d4);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $6sNnq = parcelRequire("6sNnq");

var $eObGp = parcelRequire("eObGp");

var $6Z2mh = parcelRequire("6Z2mh");

var $aV9OB = parcelRequire("aV9OB");
const $95680d22988b2454$export$ca80e1d474f774d4 = (0, $7NszV.createEntry)((0, $eObGp.projectSettingsServicedeskExternalLinksRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $aV9OB.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $dxCvy.projectContextResource),
            (0, $6sNnq.featuresResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $aV9OB.LazyProjectSettingsServiceDeskExternalLinks)
        ],
        perfMetricKey: 'jsm-external-resources'
    }));

});
parcelRegister("aV9OB", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskExternalLinks", () => $15bcce9a01d18cfd$export$28482a53859ec466);
$parcel$export(module.exports, "default", () => $15bcce9a01d18cfd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $15bcce9a01d18cfd$export$28482a53859ec466 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("fMLOq"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-external-links/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$15bcce9a01d18cfd$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $15bcce9a01d18cfd$export$28482a53859ec466,
        pageId: "project-settings-external-links",
        shouldShowSpinner: true
    });

});
parcelRegister("fMLOq", function(module, exports) {

let $b7e06d383c642301$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b7e06d383c642301$var$load("cdxh0").then(()=>parcelRequire('7iBoV'));

});



parcelRegister("1XqXD", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsWidgetRouteEntry", () => $a95971dddf0af763$export$dcfc82c90a86b038);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $d9ukL = parcelRequire("d9ukL");

var $6Z2mh = parcelRequire("6Z2mh");

var $b0cvA = parcelRequire("b0cvA");

var $b2cnG = parcelRequire("b2cnG");
const $a95971dddf0af763$export$dcfc82c90a86b038 = (0, $7NszV.createEntry)((0, $d9ukL.projectSettingsServicedeskChannelsWidgetRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $b0cvA.widgetsNextGenRedirect),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $b2cnG.LazyProjectSettingsServiceDeskWidgetSettings)
        ]
    }));

});
parcelRegister("b0cvA", function(module, exports) {

$parcel$export(module.exports, "widgetsNextGenRedirect", () => $1ae3adbbf5c00734$export$8ba256148f9b998f);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
const $1ae3adbbf5c00734$export$8ba256148f9b998f = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/widget`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: url
    });
};

});

parcelRegister("b2cnG", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskWidgetSettings", () => $bf4d9e5ccdf213aa$export$216a049c4d917b0);
$parcel$export(module.exports, "default", () => $bf4d9e5ccdf213aa$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $bf4d9e5ccdf213aa$export$216a049c4d917b0 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("2EBYc")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-widget-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bf4d9e5ccdf213aa$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $bf4d9e5ccdf213aa$export$216a049c4d917b0,
        pageId: "project-settings-widget-settings",
        shouldShowSpinner: true
    });

});
parcelRegister("2EBYc", function(module, exports) {

let $1eecc537e4997e50$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1eecc537e4997e50$var$load("67JWT").then(()=>parcelRequire('dO6p9'));

});



parcelRegister("dDzIU", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskWidgetRouteEntry", () => $a1253eff07e9815b$export$d86db47c21552ca);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $8qmAq = parcelRequire("8qmAq");

var $6Z2mh = parcelRequire("6Z2mh");

var $b2cnG = parcelRequire("b2cnG");
const $a1253eff07e9815b$export$d86db47c21552ca = (0, $7NszV.createEntry)((0, $8qmAq.projectSettingsServicedeskWidgetRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $b2cnG.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $b2cnG.LazyProjectSettingsServiceDeskWidgetSettings)
        ]
    }));

});

parcelRegister("1aB8Z", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChangeManagementRouteEntry", () => $518452e4098d607c$export$a8eaf3cca1d5d936);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $gmE3I = parcelRequire("gmE3I");

var $2pT4g = parcelRequire("2pT4g");

var $fpjJX = parcelRequire("fpjJX");

var $cAofY = parcelRequire("cAofY");

var $6sNnq = parcelRequire("6sNnq");

var $aBfqj = parcelRequire("aBfqj");

var $6Z2mh = parcelRequire("6Z2mh");

var $ejiWA = parcelRequire("ejiWA");

var $eHnlx = parcelRequire("eHnlx");
const $518452e4098d607c$export$a8eaf3cca1d5d936 = (0, $7NszV.createEntry)((0, $aBfqj.projectSettingsServicedeskChangeManagementRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'service-management.change-management-settings',
        component: (0, $eHnlx.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $cAofY.serviceDeskContextResource),
            (0, $ejiWA.changeManagementSettingsProjectConfigurationResource),
            (0, $gmE3I.jsmChangeManagementSettingsGitLabGatingResource),
            (0, $6sNnq.featuresResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $2pT4g.jsmRepackagingBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $eHnlx.LazyProjectSettingsServiceDeskChangeManagement)
        ]
    }));

});
parcelRegister("gmE3I", function(module, exports) {

$parcel$export(module.exports, "jsmChangeManagementSettingsGitLabGatingResource", () => $ff8ead4f49d1e745$export$315b6278d34861b4);
$parcel$export(module.exports, "useGitLabGatingResource", () => $ff8ead4f49d1e745$export$dd3715dce02ee460);

var $5uXOq = parcelRequire("5uXOq");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

const $ff8ead4f49d1e745$var$getDataLoader = ()=>(parcelRequire("doiMC"));
const $ff8ead4f49d1e745$export$315b6278d34861b4 = (0, $2M1hQ.createResource)({
    type: 'JSM_CHANGE_MANAGEMENT_SETTINGS_GITLAB_GATING_RESOURCE',
    getKey: ()=>'JSM_CHANGE_MANAGEMENT_SETTINGS_GITLAB_GATING_RESOURCE',
    getDataLoader: $ff8ead4f49d1e745$var$getDataLoader,
    maxAge: false ? 0 : Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});
const $ff8ead4f49d1e745$export$dd3715dce02ee460 = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)($ff8ead4f49d1e745$export$315b6278d34861b4);
    (0, $5uXOq.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        error,
        refresh
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            data: data?.data,
            pending: loading,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: data?.error || error
        }), [
        data,
        loading,
        error
    ]);
};

});
parcelRegister("doiMC", function(module, exports) {

let $9bfc163791b99137$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9bfc163791b99137$var$load("5O1mG").then(()=>parcelRequire('4y3Yq'));

});


parcelRegister("ejiWA", function(module, exports) {

$parcel$export(module.exports, "changeManagementSettingsProjectConfigurationResource", () => $53ebb72294d46a1c$export$2413ba18ec38282d);
// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router

var $2M1hQ = parcelRequire("2M1hQ");
const $53ebb72294d46a1c$export$c0636b6062501e0b = 'CHANGE_MANAGEMENT_SETTINGS_PROJECT_CONFIG';

const $53ebb72294d46a1c$var$getDataLoader = ()=>(parcelRequire("kcL6g"));
const $53ebb72294d46a1c$var$getKey = ({ match: match })=>typeof match.params.projectKey === 'string' ? match.params.projectKey : '';
const $53ebb72294d46a1c$export$2413ba18ec38282d = (0, $2M1hQ.createResource)({
    type: $53ebb72294d46a1c$export$c0636b6062501e0b,
    getKey: $53ebb72294d46a1c$var$getKey,
    getDataLoader: $53ebb72294d46a1c$var$getDataLoader,
    maxAge: Infinity
});

});
parcelRegister("kcL6g", function(module, exports) {

let $eb5976b3f3b83ea1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eb5976b3f3b83ea1$var$load("cI1fz").then(()=>parcelRequire('k9qTQ'));

});


parcelRegister("eHnlx", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskChangeManagement", () => $8fbb06494113daae$export$e674d93688e620b3);
$parcel$export(module.exports, "default", () => $8fbb06494113daae$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $8fbb06494113daae$export$e674d93688e620b3 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("72Bld"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-change-management-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8fbb06494113daae$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8fbb06494113daae$export$e674d93688e620b3,
        pageId: "project-settings-change-management",
        shouldShowSpinner: true
    });

});
parcelRegister("72Bld", function(module, exports) {

let $5205af8025952c50$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5205af8025952c50$var$load("fBBnQ").then(()=>parcelRequire('eh7Vf'));

});



parcelRegister("3M4hq", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskIncidentManagementRouteEntry", () => $959537c21f89ae37$export$95a73b5db67dd70a);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $cAofY = parcelRequire("cAofY");

var $jHXos = parcelRequire("jHXos");

var $6Z2mh = parcelRequire("6Z2mh");

var $3uo46 = parcelRequire("3uo46");
const $959537c21f89ae37$export$95a73b5db67dd70a = (0, $7NszV.createEntry)((0, $jHXos.projectSettingsServicedeskIncidentManagementRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $3uo46.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $cAofY.serviceDeskContextResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $3uo46.LazyProjectSettingsServiceDeskIncidentManagement)
        ]
    }));

});
parcelRegister("3uo46", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskIncidentManagement", () => $74652d26314b4bbc$export$7796b6d080b8c187);
$parcel$export(module.exports, "default", () => $74652d26314b4bbc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $74652d26314b4bbc$export$7796b6d080b8c187 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("83npX"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-incident-management-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$74652d26314b4bbc$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $74652d26314b4bbc$export$7796b6d080b8c187,
        pageId: "project-settings-incident-management",
        shouldShowSpinner: true
    });

});
parcelRegister("83npX", function(module, exports) {

let $5dd0c4ce28f934ad$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $5dd0c4ce28f934ad$var$load("ffQaD"),
    $5dd0c4ce28f934ad$var$load("kvRbA"),
    $5dd0c4ce28f934ad$var$load("fliVL"),
    $5dd0c4ce28f934ad$var$load("ijYee")
]).then(()=>parcelRequire('gZiIg'));

});



parcelRegister("a2PeW", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsChatRouteEntry", () => $7d42d939b28a59ca$export$aa27d235fc2eedf6);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $9wUes = parcelRequire("9wUes");

var $6Z2mh = parcelRequire("6Z2mh");

var $6ybDD = parcelRequire("6ybDD");

var $5qwUl = parcelRequire("5qwUl");
const $7d42d939b28a59ca$export$aa27d235fc2eedf6 = (0, $7NszV.createEntry)((0, $9wUes.projectSettingsServicedeskChannelsChatRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $6ybDD.serviceDeskChatNextGenRedirect),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5qwUl.LazyProjectSettingsServiceDeskChatSettings)
        ]
    }));

});
parcelRegister("6ybDD", function(module, exports) {

$parcel$export(module.exports, "serviceDeskChatNextGenRedirect", () => $7c240e4106c097e5$export$22c86ddb04b1359a);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
const $7c240e4106c097e5$export$22c86ddb04b1359a = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/chat`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: url
    });
};

});

parcelRegister("5qwUl", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskChatSettings", () => $955f7623ed5daf83$export$971347f9ac02f862);
$parcel$export(module.exports, "default", () => $955f7623ed5daf83$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $955f7623ed5daf83$export$971347f9ac02f862 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("6sGNP")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-chat-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$955f7623ed5daf83$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $955f7623ed5daf83$export$971347f9ac02f862,
        pageId: "project-settings-widget-settings",
        shouldShowSpinner: true
    });

});
parcelRegister("6sGNP", function(module, exports) {

let $4b468f56fb4ec068$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4b468f56fb4ec068$var$load("8FOl8").then(()=>parcelRequire('k9vj7'));

});



parcelRegister("gXApH", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChatRouteEntry", () => $30ca084fd423718b$export$f030ac1baa84c682);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $2I1zE = parcelRequire("2I1zE");

var $6Z2mh = parcelRequire("6Z2mh");

var $5qwUl = parcelRequire("5qwUl");
const $30ca084fd423718b$export$f030ac1baa84c682 = (0, $7NszV.createEntry)((0, $2I1zE.projectSettingsServicedeskChatRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $5qwUl.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5qwUl.LazyProjectSettingsServiceDeskChatSettings)
        ]
    }));

});

parcelRegister("amBHA", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsRouteEntry", () => $e62176a0302c26c4$export$2d20001d3350adbc);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $2a84P = parcelRequire("2a84P");

var $6Z2mh = parcelRequire("6Z2mh");

var $3egqP = parcelRequire("3egqP");
const $e62176a0302c26c4$export$2d20001d3350adbc = (0, $7NszV.createEntry)((0, $2a84P.projectSettingsServicedeskChannelsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $3egqP.channelsRedirect)('customer-permissions'),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("2a84P", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsRoute", () => $a400bd3af4bd9318$export$36e4210554830c2f);
const $a400bd3af4bd9318$export$36e4210554830c2f = {
    name: 'project-settings-servicedesk-channels',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels',
    exact: true
};

});

parcelRegister("3egqP", function(module, exports) {

$parcel$export(module.exports, "channelsRedirect", () => $73d598aaa606ce09$export$c7e6c0ac0abe2336);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $02Psx = parcelRequire("02Psx");

var $7tQej = parcelRequire("7tQej");
const $73d598aaa606ce09$export$c7e6c0ac0abe2336 = (pageUrlFragment)=>({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = `${(0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), String(projectKey))}/channels/${pageUrlFragment}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: url,
            push: false
        });
    };

});


parcelRegister("6agOS", function(module, exports) {

$parcel$export(module.exports, "servicedeskSlaSettingsRouteEntry", () => $4a495883d616d596$export$472949ed4e9ddfb0);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $4wBwP = parcelRequire("4wBwP");

var $hewRX = parcelRequire("hewRX");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $1CEnL = parcelRequire("1CEnL");
const $4a495883d616d596$export$472949ed4e9ddfb0 = (0, $7NszV.createEntry)((0, $hewRX.servicedeskSlaSettingsRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).SLA_SETTINGS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).SLA_SETTINGS),
                teamName: 'bumblebee'
            }
        },
        perfMetricKey: 'jsm-sla-settings',
        component: (0, $1CEnL.ServiceDeskSlaSettings),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $dxCvy.projectContextResource),
            (0, $4wBwP.slaMetricsDataResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $1CEnL.LazyProjectSettingsServiceDeskSlaSettings)
        ]
    }));

});
parcelRegister("4wBwP", function(module, exports) {

$parcel$export(module.exports, "slaMetricsDataResource", () => $5bd842d236781a2e$export$6cdfca3e816e9661);

var $2M1hQ = parcelRequire("2M1hQ");
const $5bd842d236781a2e$export$c5fa03c9ad8df0e2 = 'SLA_METRICS';

const $5bd842d236781a2e$export$6cdfca3e816e9661 = (0, $2M1hQ.createResource)({
    type: $5bd842d236781a2e$export$c5fa03c9ad8df0e2,
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("gvBbS")),
    maxAge: Infinity
});

});
parcelRegister("gvBbS", function(module, exports) {

let $c04c63e219cbeaca$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c04c63e219cbeaca$var$load("liBrI").then(()=>parcelRequire('dxWU3'));

});


parcelRegister("1CEnL", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskSlaSettings", () => $45b508c287c9b763$export$a6694c07cb5be8c1);
$parcel$export(module.exports, "ServiceDeskSlaSettings", () => $45b508c287c9b763$export$c56fde3803c5a1a3);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $l8ruj = parcelRequire("l8ruj");

var $kxZPA = parcelRequire("kxZPA");

const $45b508c287c9b763$export$a6694c07cb5be8c1 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("gpWu5"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-sla-settings/src/index.tsx"
});
const $45b508c287c9b763$export$c56fde3803c5a1a3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "project-settings-service-desk-sla-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $45b508c287c9b763$export$a6694c07cb5be8c1,
        pageId: "project-settings-service-desk-sla-settings",
        shouldShowSpinner: true
    }));

});
parcelRegister("gpWu5", function(module, exports) {

let $bf3c58e0ca6ca6b8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bf3c58e0ca6ca6b8$var$load("39wLT").then(()=>parcelRequire('1rjw0'));

});



parcelRegister("7fwfr", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskFeedbackRouteEntry", () => $e67580ab8b50900d$export$5c0731470c0dc065);

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6z8e6 = parcelRequire("6z8e6");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $7Txnp = parcelRequire("7Txnp");

var $7zcmB = parcelRequire("7zcmB");
const $e67580ab8b50900d$export$5c0731470c0dc065 = (0, $7NszV.createEntry)((0, $6z8e6.projectSettingsServicedeskFeedbackRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $7zcmB.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $7zcmB.LazyProjectSettingsServiceDeskFeedbackSettings),
            (0, $7Txnp.LazyCsatSettingsPage)
        ],
        perfMetricKey: 'jsm-feedback-settings',
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).CSAT_CONFIG,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).CSAT_CONFIG),
                teamName: 'jsm-request-intake'
            }
        }
    }));

});
parcelRegister("7Txnp", function(module, exports) {

$parcel$export(module.exports, "LoadingComponent", () => $42f73bbf4237dc1b$export$7db30d367db7d20a);
$parcel$export(module.exports, "LazyCsatSettingsPage", () => $42f73bbf4237dc1b$export$32eb62914bae0e84);
/* async.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");

var $kxZPA = parcelRequire("kxZPA");
const $42f73bbf4237dc1b$export$7db30d367db7d20a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($42f73bbf4237dc1b$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "large"
    }));

const $42f73bbf4237dc1b$export$32eb62914bae0e84 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("91zvd")), {
    moduleId: "./src/packages/servicedesk/csat/src/index.tsx"
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $42f73bbf4237dc1b$var$SpinnerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i68cl",
            __cmplp.className
        ])
    });
});

});
parcelRegister("91zvd", function(module, exports) {

let $691fbf17fd30d01e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $691fbf17fd30d01e$var$load("8bdOt").then(()=>parcelRequire('hX8BJ'));

});


parcelRegister("7zcmB", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskFeedbackSettings", () => $4b8db06fa1ed7bd1$export$ff54bec6c7cb7d47);
$parcel$export(module.exports, "default", () => $4b8db06fa1ed7bd1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");
const $4b8db06fa1ed7bd1$export$3fac45fa34d00981 = 'project/service-desk/settings/index';
const $4b8db06fa1ed7bd1$export$1aa47348ef6dbdda = 'project/service-desk/settings';

const $4b8db06fa1ed7bd1$export$ff54bec6c7cb7d47 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("90tUm")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-feedback-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4b8db06fa1ed7bd1$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $4b8db06fa1ed7bd1$export$ff54bec6c7cb7d47,
        pageId: "project-settings-feedback-settings",
        shouldShowSpinner: true
    });

});
parcelRegister("90tUm", function(module, exports) {

let $68eb5040a1e7ed9e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $68eb5040a1e7ed9e$var$load("1ierf").then(()=>parcelRequire('d3uR0'));

});



parcelRegister("gUdrp", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskForgeAppsRouteEntry", () => $b86b6dad0a03dbe6$export$58e3b68d22b7a42b);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $8L6oT = parcelRequire("8L6oT");

var $6Z2mh = parcelRequire("6Z2mh");

var $5bkvv = parcelRequire("5bkvv");

var $dxCvy = parcelRequire("dxCvy");

var $bUhjF = parcelRequire("bUhjF");
const $b86b6dad0a03dbe6$export$58e3b68d22b7a42b = (0, $7NszV.createEntry)((0, $8L6oT.projectSettingsServicedeskForgeAppsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $bUhjF.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $dxCvy.projectContextResourceWithCache),
            (0, $5bkvv.forgeProjectSettingsModuleResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bUhjF.LazyForgeProjectSettingsPage)
        ]
    }));

});
parcelRegister("8L6oT", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskForgeAppsRoute", () => $b9987e58af4bd5dd$export$10bafd1256118bb8);
const $b9987e58af4bd5dd$export$10bafd1256118bb8 = {
    name: 'project-settings-servicedesk-forge-apps',
    path: '/jira/servicedesk/projects/:projectKey/settings/apps/:appId/:envId/:route?'
};

});

parcelRegister("bUhjF", function(module, exports) {

$parcel$export(module.exports, "LazyForgeProjectSettingsPage", () => $d4e28d950e086fee$export$ef66d3f49a9953d8);
$parcel$export(module.exports, "default", () => $d4e28d950e086fee$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $d4e28d950e086fee$export$ef66d3f49a9953d8 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("bZbyt")), {
    moduleId: "./src/packages/spa-apps/forge/project-settings/src/index.tsx"
});
const $d4e28d950e086fee$export$b943f48844c671a5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d4e28d950e086fee$export$ef66d3f49a9953d8,
        pageId: "forge-spa-project-settings",
        shouldShowSpinner: true
    });
var $d4e28d950e086fee$export$2e2bcd8739ae039 = $d4e28d950e086fee$export$b943f48844c671a5;

});


parcelRegister("bERWs", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskRedirectRouteEntry", () => $1c4a2f62f943cd86$export$a0279fafdeb78607);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");


var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $bYwAR = parcelRequire("bYwAR");

var $6Z2mh = parcelRequire("6Z2mh");

var $01LdL = parcelRequire("01LdL");
const $1c4a2f62f943cd86$export$a0279fafdeb78607 = (0, $7NszV.createEntry)((0, $bYwAR.projectSettingsServicedeskRedirectRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $01LdL.defaultRedirectForSettings)((0, $01LdL.SERVICE_DESK_PRODUCT)),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ]
    }));

});
parcelRegister("bYwAR", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskRedirectRoute", () => $dd2a76b3e525b3b0$export$3fbe0a89e4d1e816);
const $dd2a76b3e525b3b0$export$3fbe0a89e4d1e816 = {
    name: 'project-settings-servicedesk-redirect',
    path: '/jira/servicedesk/projects/:projectKey/settings'
};

});


parcelRegister("80PF8", function(module, exports) {

$parcel$export(module.exports, "servicedeskPlaybooksListRouteEntry", () => $ccdff8c69ba43bde$export$19177b8fa44e5e4d);

var $e4eHl = parcelRequire("e4eHl");

var $4R6GH = parcelRequire("4R6GH");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $8YZBz = parcelRequire("8YZBz");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $lk01G = parcelRequire("lk01G");

var $lkFvK = parcelRequire("lkFvK");

var $jom1z = parcelRequire("jom1z");

var $6LsQE = parcelRequire("6LsQE");

var $c04PQ = parcelRequire("c04PQ");
const $ccdff8c69ba43bde$var$listEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $lk01G.default),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $ccdff8c69ba43bde$export$19177b8fa44e5e4d = (0, $7NszV.createEntry)((0, $8YZBz.servicedeskPlaybooksListRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $4R6GH.fg)('playbooks-in-jsm')) {
                if ((0, $c04PQ.isFedRamp)() && (0, $4R6GH.fg)('playbooks_disable_for_fedramp')) return 0, $6LsQE.notFoundPageEntrypoint;
                return $ccdff8c69ba43bde$var$listEntryPoint;
            }
            return undefined;
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $jom1z.playbooksListRequestTypesResource)
        ],
        meta: {
            reporting: {
                id: 'project-settings.playbooks.admin-list-view',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('project-settings-playbooks-list'),
                teamName: 'ITOps Phantom'
            }
        },
        component: (0, $5lsNZ.default),
        ufoName: 'playbook-list'
    }));

});
parcelRegister("8YZBz", function(module, exports) {

$parcel$export(module.exports, "servicedeskPlaybooksListRoute", () => $39cfce4bc27a2e92$export$cbed08b5b0671f5f);
const $39cfce4bc27a2e92$export$cbed08b5b0671f5f = {
    name: 'project-settings-playbooks-list',
    path: '/jira/servicedesk/projects/:projectKey/settings/playbooks',
    exact: true
};

});

parcelRegister("lk01G", function(module, exports) {

$parcel$export(module.exports, "default", () => $787278c10397c75e$export$2e2bcd8739ae039);

var $8fDOc = parcelRequire("8fDOc");

var $6YEEX = parcelRequire("6YEEX");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore Argument of type '{ root: ...; getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => any; }' is not assignable to parameter of type 'never'
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $787278c10397c75e$var$playbookListViewEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        if (!false) return (parcelRequire("kKaI7"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "a498670b"
    }),
    // This has been causing build errors in unrelated code. Broadening type to fix build.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const { projectKey: projectKey } = context.match.params;
        const { tab: tab = 'list', name: name = '' } = context.query;
        if (!projectKey) throw new Error('projectKey is required');
        // In case where tab is logs, we need to load the logs entry point
        // For other cases, fallback to the list entry point. This matches the current logic in the UI component.
        const entryPoints = tab === 'logs' ? {
            preloadedPlaybookLogsEntryPoint: {
                entryPoint: (0, $6YEEX.playbookLogsEntryPoint),
                entryPointParams: {
                    cloudId: tenantContext.cloudId,
                    projectKey: projectKey,
                    first: 20,
                    filter: name ? {
                        name: name
                    } : null
                }
            }
        } : {
            preloadedPlaybookListEntryPoint: {
                entryPoint: (0, $8fDOc.playbookListEntryPoint),
                entryPointParams: {
                    cloudId: tenantContext.cloudId,
                    projectKey: projectKey,
                    first: 20,
                    filter: name ? {
                        name: name
                    } : null
                }
            }
        };
        return {
            extraProps: {
                accountId: tenantContext.atlassianAccountId,
                cloudId: tenantContext.cloudId,
                projectId: context.query.projectId,
                projectKey: context.match.params.projectKey
            },
            entryPoints: entryPoints
        };
    }
});
var $787278c10397c75e$export$2e2bcd8739ae039 = $787278c10397c75e$var$playbookListViewEntryPoint;

});
parcelRegister("8fDOc", function(module, exports) {

$parcel$export(module.exports, "playbookListEntryPoint", () => $d77fb854f7f8e8b8$export$d7be5d3b24f1d526);

var $k1Mbn = parcelRequire("k1Mbn");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $d77fb854f7f8e8b8$export$d7be5d3b24f1d526 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("4xpNC")).then((module)=>module.PlaybookList), {
        moduleId: "3f3b7cb0",
        moduleName: "PlaybookList"
    }),
    getPreloadProps: (variables)=>{
        return {
            queries: {
                PlaybookListQuery: {
                    parameters: (0, $k1Mbn.default),
                    variables: variables
                }
            }
        };
    }
});

});
parcelRegister("k1Mbn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0a57d88af1f6396$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b88c7d8959d92c99cd3826a502e76334>>
 * @relayHash b47669aaa2d26c840c41f7ffe677fdee
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 77aaea5c8216b45b296be33aff153112c51d2e91c98685f982b9ea3d4088d4e6
const $a0a57d88af1f6396$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "77aaea5c8216b45b296be33aff153112c51d2e91c98685f982b9ea3d4088d4e6",
        "metadata": {},
        "name": "PlaybookListQuery",
        "operationKind": "query",
        "text": null
    }
};
var $a0a57d88af1f6396$export$2e2bcd8739ae039 = $a0a57d88af1f6396$var$node;

});

parcelRegister("4xpNC", function(module, exports) {

let $34de41ac7ad35f10$var$load = (parcelRequire("28QjX"))(4);
module.exports = $34de41ac7ad35f10$var$load("9gFtJ").then(()=>parcelRequire('hM1vX'));

});


parcelRegister("6YEEX", function(module, exports) {

$parcel$export(module.exports, "playbookLogsEntryPoint", () => $60633bec6dffe3a8$export$7ebe0f850472ea07);

var $2OZhN = parcelRequire("2OZhN");

var $YWlMy = parcelRequire("YWlMy");

var $fEDBv = parcelRequire("fEDBv");

const $60633bec6dffe3a8$export$7ebe0f850472ea07 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("5mg8u")), {
        moduleId: "c3ca80f1",
        moduleName: "PlaybookLogs"
    }),
    getPreloadProps: (variables)=>({
            queries: {
                PlaybookLogsQuery: {
                    parameters: (0, $YWlMy.default),
                    variables: variables
                }
            }
        })
});

});
parcelRegister("YWlMy", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcd4a200ecef7c9e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eac6514e594c2e6e8979a745c7d9215c>>
 * @relayHash c40005688009ad578d2262abe92dfdd6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 42292b23d4d61a2a7e987006bd56b1edc64641483aaf6e59202fb8e13a1830da
const $fcd4a200ecef7c9e$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "42292b23d4d61a2a7e987006bd56b1edc64641483aaf6e59202fb8e13a1830da",
        "metadata": {},
        "name": "PlaybookLogsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $fcd4a200ecef7c9e$export$2e2bcd8739ae039 = $fcd4a200ecef7c9e$var$node;

});

parcelRegister("5mg8u", function(module, exports) {

let $3e6b860fc8b7aed4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3e6b860fc8b7aed4$var$load("diW3e").then(()=>parcelRequire('baehV'));

});


parcelRegister("kKaI7", function(module, exports) {

let $f1a0696bff22865f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f1a0696bff22865f$var$load("dAVQn").then(()=>parcelRequire('6o22p'));

});


parcelRegister("jom1z", function(module, exports) {

$parcel$export(module.exports, "playbooksListRequestTypesResource", () => $4640323ec09a801b$export$43f774aa05fabd18);

var $2M1hQ = parcelRequire("2M1hQ");


var $jthxb = parcelRequire("jthxb");

var $eusud = parcelRequire("eusud");
const $4640323ec09a801b$export$43f774aa05fabd18 = (0, $2M1hQ.createResource)({
    type: 'PLAYBOOKS-LIST-REQUEST-TYPES-RESOURCE-TYPE',
    getKey: ({ match: match })=>{
        const projectKey = match.params.projectKey;
        return `playbooksListRequestTypesResource-${projectKey}`;
    },
    getData: async ({ dependencies: dependencies })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { projectId: projectId } = await (0, $jthxb.consumeDependency)(dependencies, (0, $0f463a88567f1621$export$80a60a092d9ab81));
        return (0, $eusud.performGetRequest)($4640323ec09a801b$var$getRequestTypesUrl(projectId)).then((response)=>response.ticketTypes);
    },
    maxAge: 300000,
    depends: [
        (0, $0f463a88567f1621$export$80a60a092d9ab81)
    ]
});
const $4640323ec09a801b$var$getRequestTypesUrl = (projectId)=>`/rest/servicedesk/1/servicedesk/${projectId}/request-types`;

});


parcelRegister("2r2Gu", function(module, exports) {

$parcel$export(module.exports, "servicedeskPlaybooksEditRouteEntry", () => $bdbdec3ce8186cd4$export$abfa8cd64fabd80e);

var $e4eHl = parcelRequire("e4eHl");

var $c04PQ = parcelRequire("c04PQ");

var $h0bZU = parcelRequire("h0bZU");

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $5lsNZ = parcelRequire("5lsNZ");

var $7GkYX = parcelRequire("7GkYX");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $lusKj = parcelRequire("lusKj");

var $lkFvK = parcelRequire("lkFvK");

var $f6cRY = parcelRequire("f6cRY");

var $6LsQE = parcelRequire("6LsQE");
const $bdbdec3ce8186cd4$var$editEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $lusKj.default),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $bdbdec3ce8186cd4$export$abfa8cd64fabd80e = (0, $7NszV.createEntry)((0, $7GkYX.servicedeskPlaybooksEditRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $4R6GH.fg)('playbooks-in-jsm')) {
                if ((0, $c04PQ.isFedRamp)() && (0, $4R6GH.fg)('playbooks_disable_for_fedramp')) return 0, $6LsQE.notFoundPageEntrypoint;
                return $bdbdec3ce8186cd4$var$editEntryPoint;
            }
            return undefined;
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: 'project-settings.playbooks.admin-edit-view',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('project-settings-playbooks-edit'),
                teamName: 'ITOps Phantom'
            }
        },
        component: (0, $5lsNZ.default),
        ufoName: 'playbook-edit',
        skeleton: (0, $f6cRY.PlaybookEditSkeleton)
    }));

});
parcelRegister("7GkYX", function(module, exports) {

$parcel$export(module.exports, "servicedeskPlaybooksEditRoute", () => $f6a9df88dc0097bb$export$5920ce3a2ccf6e2b);
const $f6a9df88dc0097bb$export$5920ce3a2ccf6e2b = {
    name: 'project-settings-playbooks-edit',
    path: '/jira/servicedesk/projects/:projectKey/settings/playbooks/:playbookId',
    exact: true
};

});

parcelRegister("lusKj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c46caae51932151$export$2e2bcd8739ae039);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $l5Wv9 = parcelRequire("l5Wv9");

var $4R6GH = parcelRequire("4R6GH");

/**
 * NOTE - Please update src/packages/playbooks/edit-screen/src/entrypoint.tsx
 * as that is used in integration test and ideally both should be same except queries
 */ const $7c46caae51932151$var$playbookEditViewEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        if (!false) return (parcelRequire("fPf2x"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "15e5be42"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const { projectKey: projectKey, playbookId: playbookId = '' } = context.match.params;
        const { fromPlaybookId: fromPlaybookId = '' } = context.query;
        if (!projectKey) throw new Error('projectKey is required');
        const { cloudId: cloudId, activationId: activationId } = tenantContext;
        const isNewPlaybook = !!playbookId?.includes($7c46caae51932151$var$NEW_PLAYBOOK_IDENTIFIER);
        const callablePlaybookId = $7c46caae51932151$var$getPlaybookId(playbookId, fromPlaybookId);
        const playbookAri = $7c46caae51932151$var$toPlaybookAri({
            siteId: cloudId,
            activationId: activationId,
            playbookId: callablePlaybookId
        });
        const isNewPlaybookCheck = (0, $4R6GH.fg)('playbook_duplicate_feature') ? isNewPlaybook && !fromPlaybookId : isNewPlaybook;
        if (isNewPlaybookCheck) // This is complete new playbook creation
        return {
            extraProps: {
                playbookAri: playbookAri,
                isNew: true,
                variant: 'new'
            }
        };
        return {
            queries: {
                PlaybookDetailQuery: {
                    parameters: (0, $l5Wv9.default),
                    variables: {
                        playbookAri: playbookAri
                    }
                }
            },
            extraProps: {
                playbookAri: playbookAri,
                isNew: false,
                variant: isNewPlaybook && !!fromPlaybookId ? 'copy' : 'edit'
            }
        };
    }
});
var $7c46caae51932151$export$2e2bcd8739ae039 = $7c46caae51932151$var$playbookEditViewEntryPoint;
function $7c46caae51932151$var$toPlaybookAri({ siteId: siteId, activationId: activationId, playbookId: playbookId }) {
    return `ari:cloud:jira:${siteId}:playbook/activation/${activationId}/${playbookId}`;
}
const $7c46caae51932151$var$getPlaybookId = (playbookId, fromPlaybookId)=>{
    if ((0, $4R6GH.fg)('playbook_duplicate_feature')) {
        if (fromPlaybookId) return fromPlaybookId;
        return playbookId || '';
    }
    return playbookId || '';
};
const $7c46caae51932151$var$NEW_PLAYBOOK_IDENTIFIER = '_new_';

});
parcelRegister("l5Wv9", function(module, exports) {

$parcel$export(module.exports, "default", () => $1650a5e016addfe6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<41924ccb303b5d3b27264e56cf9a5101>>
 * @relayHash f01b0a348049b3c26499af7159f898e3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c6e9a099b5fe0bed228db70dab296511e1b1c69247c364583be4f0735cc57708
const $1650a5e016addfe6$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "c6e9a099b5fe0bed228db70dab296511e1b1c69247c364583be4f0735cc57708",
        "metadata": {},
        "name": "PlaybookDetailQuery",
        "operationKind": "query",
        "text": null
    }
};
var $1650a5e016addfe6$export$2e2bcd8739ae039 = $1650a5e016addfe6$var$node;

});

parcelRegister("fPf2x", function(module, exports) {

let $b857490d1b9f4970$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $b857490d1b9f4970$var$load("ffQaD"),
    $b857490d1b9f4970$var$load("kvRbA"),
    $b857490d1b9f4970$var$load("fliVL"),
    $b857490d1b9f4970$var$load("4qmB9")
]).then(()=>parcelRequire('79e1o'));

});


parcelRegister("f6cRY", function(module, exports) {

$parcel$export(module.exports, "PlaybookEditSkeleton", () => $da382d4ceac0982f$export$8e181e27312cd7a4);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $1GGwS = parcelRequire("1GGwS");

var $1DVhQ = parcelRequire("1DVhQ");

var $cS37j = parcelRequire("cS37j");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $7Kysn = parcelRequire("7Kysn");
const $da382d4ceac0982f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    returnToList: {
        "id": "playbooks-edit-screen.playbook-item.skeleton.return-to-list",
        "defaultMessage": "Return to list"
    }
});
const $da382d4ceac0982f$export$8e181e27312cd7a4 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [playbookListLink] = (0, $7Kysn.useReturnToListUrl)();
    const actions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.100",
        direction: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1GGwS.default), {
        appearance: "subtle",
        href: playbookListLink
    }, formatMessage($da382d4ceac0982f$export$defe85febe8b728c.returnToList)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        xcss: $da382d4ceac0982f$var$containerStyle,
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), {
        actions: actions,
        disableTitleStyles: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.300",
        direction: "row",
        justifyContent: "space-between",
        xcss: $da382d4ceac0982f$var$contentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        xcss: $da382d4ceac0982f$var$stepCards,
        alignBlock: "start",
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        height: "52px",
        width: "100%",
        isShimmering: true,
        borderRadius: "8px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        height: "52px",
        width: "100%",
        isShimmering: true,
        borderRadius: "8px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $da382d4ceac0982f$var$addButton,
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        height: "40px",
        width: "40px",
        isShimmering: true,
        borderRadius: "40px"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $da382d4ceac0982f$var$detailStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        height: "520px",
        width: "100%",
        isShimmering: true,
        borderRadius: "8px"
    }))));
};
const $da382d4ceac0982f$var$containerStyle = (0, $8CUq3.xcss)({
    backgroundColor: 'elevation.surface.sunken',
    paddingLeft: 'space.300',
    paddingRight: 'space.500',
    height: '100vh'
});
const $da382d4ceac0982f$var$detailStyle = (0, $8CUq3.xcss)({
    maxWidth: '800px',
    minWidth: '440px',
    width: '45%'
});
const $da382d4ceac0982f$var$contentStyles = (0, $8CUq3.xcss)({
    width: '100%',
    paddingTop: 'space.400'
});
const $da382d4ceac0982f$var$stepCards = (0, $8CUq3.xcss)({
    flexGrow: 0,
    flexShrink: 1,
    flexBasis: '30%',
    maxWidth: '600px'
});
const $da382d4ceac0982f$var$addButton = (0, $8CUq3.xcss)({
    height: '52px'
});

});
parcelRegister("cS37j", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a15efb09f101ecb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $57MwZ = parcelRequire("57MwZ");
const $2a15efb09f101ecb$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $57MwZ.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2a15efb09f101ecb$var$ActionsWrapper, null, actions) : null
    });
var $2a15efb09f101ecb$export$2e2bcd8739ae039 = $2a15efb09f101ecb$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a15efb09f101ecb$var$ActionsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("57MwZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9694e728fd1ea060$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eeGIy = parcelRequire("eeGIy");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $9694e728fd1ea060$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eeGIy.OuterWrapper), {
        children: [
            breadcrumbs,
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eeGIy.TitleWrapper), {
                truncateTitle: truncateTitle,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eeGIy.TitleContainer), {
                        truncateTitle: truncateTitle,
                        children: disableTitleStyles ? children : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eeGIy.StyledTitleWrapper), {
                            ref: innerRef,
                            truncateTitle: truncateTitle,
                            id: id,
                            testId: testId,
                            children: children
                        })
                    }),
                    actions && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eeGIy.ActionsWrapper), {
                        children: actions
                    })
                ]
            }),
            bottomBar && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eeGIy.BottomBarWrapper), {
                children: [
                    " ",
                    bottomBar,
                    " "
                ]
            })
        ]
    });
};
var $9694e728fd1ea060$export$2e2bcd8739ae039 = $9694e728fd1ea060$var$PageHeader;

});
parcelRegister("eeGIy", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $0c196d37a4e8266c$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $0c196d37a4e8266c$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $0c196d37a4e8266c$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $0c196d37a4e8266c$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $0c196d37a4e8266c$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $0c196d37a4e8266c$export$6330225854c30dc);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
const $0c196d37a4e8266c$var$styles = {
    bottomBar: "_1pfhpxbi"
};
const $0c196d37a4e8266c$var$truncateStyles = null;
const $0c196d37a4e8266c$var$outerStyles = null;
const $0c196d37a4e8266c$var$titleStyles = null;
const $0c196d37a4e8266c$var$titleWrapperStyles = null;
const $0c196d37a4e8266c$var$titleWrapperTruncateStyles = null;
const $0c196d37a4e8266c$var$titleContainerStyles = null;
const $0c196d37a4e8266c$var$actionStyles = null;
const $0c196d37a4e8266c$var$titleContainerTruncateStyles = null;
const $0c196d37a4e8266c$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_6rthpxbi _1pfh1ejb _12l2idpf _ahbqidpf"
        ]),
        children: children
    });
};
const $0c196d37a4e8266c$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("h1", {
        ref: ref,
        tabIndex: -1,
        id: id,
        "data-testid": testId && `${testId}--title`,
        className: (0, $bwpsq.default)([
            "_11c8nf1z _12ji1r31 _1qu2glyw _12y31o36 _syaz1fxt _1dyz4jg8 _1pfhidpf",
            truncateTitle && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ]),
        children: children
    });
});
const $0c196d37a4e8266c$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1y6m _1n261g80",
            truncateTitle && "_1n261q9c"
        ]),
        children: children
    });
};
const $0c196d37a4e8266c$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug _1ul9idpf _p12f1osq _6rthu2gc",
            truncateTitle && "_1o9zkb7n"
        ]),
        children: children
    });
};
const $0c196d37a4e8266c$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _p12f1osq _6rthu2gc _ahbq1wug _bozgxy5q _o5721q9c"
        ]),
        children: children
    });
};
const $0c196d37a4e8266c$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $0c196d37a4e8266c$var$styles.bottomBar,
        children: children
    });
};

});



parcelRegister("7Kysn", function(module, exports) {

$parcel$export(module.exports, "getStepData", () => $d5ec6522606d2f57$export$f1427121561aecf8);
$parcel$export(module.exports, "isStep", () => $d5ec6522606d2f57$export$21684750287da054);
$parcel$export(module.exports, "useIsNewPlaybook", () => $d5ec6522606d2f57$export$d761c1032826f7f);
$parcel$export(module.exports, "getJiraPlaybookIdFromARI", () => $d5ec6522606d2f57$export$191a8b6475837449);
$parcel$export(module.exports, "useReturnToListUrl", () => $d5ec6522606d2f57$export$565f39f00aacdb73);
$parcel$export(module.exports, "getIsDescriptionEmpty", () => $d5ec6522606d2f57$export$f11d072d2cef989a);
$parcel$export(module.exports, "getStepsOrder", () => $d5ec6522606d2f57$export$812421dcb7983dd1);
$parcel$export(module.exports, "getStepsDetail", () => $d5ec6522606d2f57$export$aa46de8dc426f402);

var $kz2lw = parcelRequire("kz2lw");

var $gB22t = parcelRequire("gB22t");

var $bmKPg = parcelRequire("bmKPg");

var $6c7e8 = parcelRequire("6c7e8");

var $iMvey = parcelRequire("iMvey");
const $d5ec6522606d2f57$export$f1427121561aecf8 = (id, name, type, index)=>{
    return {
        stepId: id,
        name: name,
        index: index,
        type: type
    };
};
const $d5ec6522606d2f57$export$21684750287da054 = (data)=>{
    if (data) {
        const { type: type } = data;
        return type === 'INSTRUCTIONAL_RULE' || type === 'AUTOMATION_RULE';
    }
    return false;
};
const $d5ec6522606d2f57$export$cf6e5a5e05d437ad = (cloudId, activationId, playbookId)=>{
    return (0, $gB22t.JiraPlaybookAri).create({
        siteId: cloudId,
        activationId: activationId,
        playbookId: playbookId
    }).toString();
};
const $d5ec6522606d2f57$export$d761c1032826f7f = ()=>{
    const [playbookId = ''] = (0, $bmKPg.usePathParam)('playbookId');
    return playbookId.includes((0, $iMvey.NEW_PLAYBOOK_IDENTIFIER));
};
const $d5ec6522606d2f57$export$191a8b6475837449 = (playbookAri)=>{
    return (0, $gB22t.JiraPlaybookAri).parse(playbookAri).playbookId;
};
const $d5ec6522606d2f57$export$565f39f00aacdb73 = ()=>{
    const [projectKey = ''] = (0, $bmKPg.usePathParam)('projectKey');
    const playbookListLink = (0, $6c7e8.getProjectSettingsPageUrl)(projectKey, 'playbooks');
    return [
        playbookListLink
    ];
};
const $d5ec6522606d2f57$export$f11d072d2cef989a = (description)=>{
    if (description && Object.keys(description).length > 0) return JSON.stringify(description) === JSON.stringify((0, $kz2lw.getEmptyADF)());
    return true;
};
const $d5ec6522606d2f57$export$812421dcb7983dd1 = (data)=>{
    return data.map((step)=>step.stepId);
};
const $d5ec6522606d2f57$export$aa46de8dc426f402 = (data)=>{
    const acc = {};
    data.forEach((step)=>{
        acc[step.stepId] = step;
    });
    return acc;
};

});
parcelRegister("kz2lw", function(module, exports) {

$parcel$export(module.exports, "getEmptyADF", () => $06167b6274ea84aa$export$d109ab46c9575565);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $ebjue = parcelRequire("ebjue");
const $06167b6274ea84aa$export$d109ab46c9575565 = ()=>({
        type: 'doc',
        version: 1,
        content: []
    });

});
parcelRegister("ebjue", function(module, exports) {

$parcel$export(module.exports, "isEmpty", () => $9e55b7d6fded4629$export$dd1bc94b04021eeb);
const $9e55b7d6fded4629$export$dd1bc94b04021eeb = (node)=>!node?.content?.length;

});


parcelRegister("gB22t", function(module, exports) {

$parcel$export(module.exports, "JiraPlaybookAri", () => $c151aeecb99aa7ff$export$2b27259a6ef92c74);

var $cyZcy = parcelRequire("cyZcy");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/playbook/manifest.ts
var $c151aeecb99aa7ff$var$jiraPlaybookAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $cyZcy.JiraPlaybookAriResourceOwner),
    resourceType: (0, $cyZcy.JiraPlaybookAriResourceType),
    resourceIdSlug: "activation/{activationId}/{playbookId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        playbookId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/jira/playbook/index.ts
var $c151aeecb99aa7ff$export$2b27259a6ef92c74 = class _JiraPlaybookAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._playbookId = opts.resourceIdSegmentValues.playbookId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get playbookId() {
        return this._playbookId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $c151aeecb99aa7ff$var$jiraPlaybookAriStaticOpts.qualifier,
            platformQualifier: $c151aeecb99aa7ff$var$jiraPlaybookAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $c151aeecb99aa7ff$var$jiraPlaybookAriStaticOpts.resourceOwner,
            resourceType: $c151aeecb99aa7ff$var$jiraPlaybookAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.playbookId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                playbookId: opts.playbookId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $c151aeecb99aa7ff$var$jiraPlaybookAriStaticOpts);
        return new _JiraPlaybookAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $c151aeecb99aa7ff$var$jiraPlaybookAriStaticOpts);
        return new _JiraPlaybookAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            playbookId: this.playbookId
        };
    }
};

});
parcelRegister("cyZcy", function(module, exports) {

$parcel$export(module.exports, "JiraPlaybookAriResourceOwner", () => $9258225fc0ac187a$export$91235105b4a9ebd9);
$parcel$export(module.exports, "JiraPlaybookAriResourceType", () => $9258225fc0ac187a$export$5af5bf4e6f11326f);
// src/jira/playbook/types.ts
var $9258225fc0ac187a$export$91235105b4a9ebd9 = "jira", $9258225fc0ac187a$export$5af5bf4e6f11326f = "playbook";

});


parcelRegister("6c7e8", function(module, exports) {

$parcel$export(module.exports, "getProjectUrl", () => $19354c1d34ccf1a2$export$951b86b8e730b952);
$parcel$export(module.exports, "getRequestTypesUrl", () => $19354c1d34ccf1a2$export$9d7c743b509e267);
$parcel$export(module.exports, "getChangeRequestTypesUrl", () => $19354c1d34ccf1a2$export$6096ac65eb900914);
$parcel$export(module.exports, "getProjectSettingsPageUrl", () => $19354c1d34ccf1a2$export$75ee62cffcd82d96);
$parcel$export(module.exports, "getProjectSettingsUrl", () => $19354c1d34ccf1a2$export$a497c8f8c3782075);
$parcel$export(module.exports, "getWorkflowSettingsUrl", () => $19354c1d34ccf1a2$export$c2a8139910ee6c);
$parcel$export(module.exports, "getJsmChangeEditionUrl", () => $19354c1d34ccf1a2$export$b87292f363462760);
$parcel$export(module.exports, "getUserManagementUrl", () => $19354c1d34ccf1a2$export$13f39b40814e5f3e);

var $2vSU6 = parcelRequire("2vSU6");

var $02Psx = parcelRequire("02Psx");

var $l3Iek = parcelRequire("l3Iek");

var $cmEH1 = parcelRequire("cmEH1");

var $2iuKi = parcelRequire("2iuKi");

var $9VXkC = parcelRequire("9VXkC");
const $19354c1d34ccf1a2$export$951b86b8e730b952 = (projectKey)=>(0, $9VXkC.generatePath)((0, $2iuKi.projectsRedirectRoute).path, {
        projectKey: projectKey
    });
const $19354c1d34ccf1a2$var$getNextgenIssueTypesUrl = (projectKey, issueTypeId)=>(0, $02Psx.getNextgenSettingsIssueTypesUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), projectKey, issueTypeId);
const $19354c1d34ccf1a2$export$9d7c743b509e267 = (projectKey, isSimplified = false)=>isSimplified ? $19354c1d34ccf1a2$var$getNextgenIssueTypesUrl(projectKey) : (0, $9VXkC.generatePath)((0, $cmEH1.projectSettingsServicedeskTicketTypesConfigRoute).path, {
        projectKey: projectKey
    });
const $19354c1d34ccf1a2$export$6096ac65eb900914 = (projectKey, isSimplified = false)=>isSimplified ? $19354c1d34ccf1a2$var$getNextgenIssueTypesUrl(projectKey) : `${$19354c1d34ccf1a2$export$9d7c743b509e267(projectKey, isSimplified)}/category/changes`;
const $19354c1d34ccf1a2$export$75ee62cffcd82d96 = (projectKey, relativeUrl)=>`/jira/servicedesk/projects/${projectKey}/settings/${relativeUrl}`;
const $19354c1d34ccf1a2$export$a497c8f8c3782075 = (projectKey, isSimplified = false)=>{
    const classicSettingsUrl = `/plugins/servlet/project-config/${projectKey}`;
    return isSimplified ? $19354c1d34ccf1a2$var$getNextgenIssueTypesUrl(projectKey) : classicSettingsUrl;
};
const $19354c1d34ccf1a2$export$c2a8139910ee6c = (projectKey, issueTypeId, isSimplified = false)=>{
    if (!issueTypeId) return isSimplified ? $19354c1d34ccf1a2$var$getNextgenIssueTypesUrl(projectKey) : (0, $9VXkC.generatePath)((0, $l3Iek.legacyProjectSettingsWorkflowsRoute).path, {
        projectKey: projectKey
    });
    return isSimplified ? $19354c1d34ccf1a2$var$getNextgenIssueTypesUrl(projectKey, issueTypeId) : `/plugins/servlet/project-config/${projectKey}/issuetypes/${issueTypeId}/workflow`;
};
const $19354c1d34ccf1a2$export$b87292f363462760 = ()=>'/admin/billing/applications/change-edition/jira-servicedesk.ondemand';
const $19354c1d34ccf1a2$export$13f39b40814e5f3e = ()=>'/admin/users?referrerName=JIRA';

});
parcelRegister("l3Iek", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsWorkflowsRoute", () => $31816b9f42bcb36a$export$b03606cedffdadf6);
const $31816b9f42bcb36a$export$b03606cedffdadf6 = {
    name: 'legacy-project-settings-workflows',
    path: '/plugins/servlet/project-config/:projectKey/workflows'
};

});


parcelRegister("iMvey", function(module, exports) {

$parcel$export(module.exports, "DragState", () => $a810461a6c4da09f$export$4e38e1908f8d60cc);
$parcel$export(module.exports, "DETAILS_QUERY_PARAM_VALUE", () => $a810461a6c4da09f$export$4ff6caac8d343661);
$parcel$export(module.exports, "STEP_QUERY_PARAM", () => $a810461a6c4da09f$export$10d60ba8ee33b6cd);
$parcel$export(module.exports, "NEW_PLAYBOOK_IDENTIFIER", () => $a810461a6c4da09f$export$ddc22677c31f7347);
$parcel$export(module.exports, "NEW_STEP_IDENTIFIER", () => $a810461a6c4da09f$export$a1049a464ef7c857);
const $a810461a6c4da09f$export$4e38e1908f8d60cc = {
    IDLE: 'idle',
    PREVIEW: 'preview',
    DRAGGING: 'dragging'
};
const $a810461a6c4da09f$export$4ff6caac8d343661 = 'details';
const $a810461a6c4da09f$export$10d60ba8ee33b6cd = 'step';
const $a810461a6c4da09f$export$ddc22677c31f7347 = '_new_';
const $a810461a6c4da09f$export$a1049a464ef7c857 = '_new_';

});




parcelRegister("hRMW9", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationEditRuleRouteEntry", () => $e2d087af8b87ec7f$export$568d8653c06c756e);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $7qLRc = parcelRequire("7qLRc");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $2sKYo = parcelRequire("2sKYo");
const $e2d087af8b87ec7f$export$568d8653c06c756e = (0, $7NszV.createEntry)((0, $7qLRc.projectSettingsServicedeskAutomationEditRuleRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        ufoName: 'service-management.automation.edit-rule',
        component: (0, $2sKYo.default),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $2sKYo.LazyProjectSettingsServiceDeskAutomationEditRule)
        ]
    }));

});
parcelRegister("7qLRc", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationEditRuleRoute", () => $eafa82ab5994f857$export$9f1e5391e2d6f95);
const $eafa82ab5994f857$export$9f1e5391e2d6f95 = {
    name: 'project-settings-servicedesk-automation-edit-rule',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation/ruleset/:ruleId'
};

});

parcelRegister("2sKYo", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationEditRule", () => $0645e13982e9c11f$export$c1c9a68738a9ab36);
$parcel$export(module.exports, "default", () => $0645e13982e9c11f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $0645e13982e9c11f$export$c1c9a68738a9ab36 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("k03nb")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-edit-rule/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0645e13982e9c11f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $0645e13982e9c11f$export$c1c9a68738a9ab36,
        pageId: "project-settings-automation-edit-rule",
        shouldShowSpinner: true
    });

});
parcelRegister("k03nb", function(module, exports) {

let $e8f66c8b4bac468d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e8f66c8b4bac468d$var$load("gYGtb").then(()=>parcelRequire('44UJy'));

});



parcelRegister("9eiXm", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationCopyRuleRouteEntry", () => $051ebb61cb8e5385$export$1cfe280529d4ebf8);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $86FuT = parcelRequire("86FuT");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $9zLHs = parcelRequire("9zLHs");
const $051ebb61cb8e5385$export$1cfe280529d4ebf8 = (0, $7NszV.createEntry)((0, $86FuT.projectSettingsServicedeskAutomationCopyRuleRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        ufoName: 'service-management.automation.copy-rule',
        component: (0, $9zLHs.default),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $9zLHs.LazyProjectSettingsServiceDeskAutomationCopyRule)
        ]
    }));

});
parcelRegister("86FuT", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationCopyRuleRoute", () => $01244213b237aa9a$export$9aa8ef0c982cee2f);
const $01244213b237aa9a$export$9aa8ef0c982cee2f = {
    name: 'project-settings-servicedesk-automation-copy-rule',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation/copy/:ruleId'
};

});

parcelRegister("9zLHs", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationCopyRule", () => $10ca54f4f21ea64a$export$4a3b5f6370555dbc);
$parcel$export(module.exports, "default", () => $10ca54f4f21ea64a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $10ca54f4f21ea64a$export$4a3b5f6370555dbc = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("1335S")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-copy-rule/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$10ca54f4f21ea64a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $10ca54f4f21ea64a$export$4a3b5f6370555dbc,
        pageId: "project-settings-automation-copy-rule",
        shouldShowSpinner: true
    });

});
parcelRegister("1335S", function(module, exports) {

let $0c38789e27e47d14$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0c38789e27e47d14$var$load("107sG").then(()=>parcelRequire('9Qg7T'));

});



parcelRegister("D5QBq", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationCreateRouteEntry", () => $89415bba0f887370$export$f1e32463088d9246);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $ivLNh = parcelRequire("ivLNh");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $cNpXW = parcelRequire("cNpXW");
const $89415bba0f887370$export$f1e32463088d9246 = (0, $7NszV.createEntry)((0, $ivLNh.projectSettingsServicedeskAutomationCreateRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        ufoName: 'service-management.automation.create-rule',
        component: (0, $cNpXW.default),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $cNpXW.LazyProjectSettingsServiceDeskAutomationCreateRule)
        ]
    }));

});
parcelRegister("ivLNh", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationCreateRoute", () => $50f5a58676cb66d1$export$6f20ce2991881c20);
const $50f5a58676cb66d1$export$6f20ce2991881c20 = {
    name: 'project-settings-servicedesk-automation-create',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation/blueprint/:blueprintKey'
};

});

parcelRegister("cNpXW", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationCreateRule", () => $2a5fc816810cf307$export$5b197b51eb5ad982);
$parcel$export(module.exports, "default", () => $2a5fc816810cf307$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $2a5fc816810cf307$export$5b197b51eb5ad982 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("2zzKJ")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-create-rule/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2a5fc816810cf307$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $2a5fc816810cf307$export$5b197b51eb5ad982,
        pageId: "project-settings-automation-create-rule",
        shouldShowSpinner: true
    });

});
parcelRegister("2zzKJ", function(module, exports) {

let $1dfa956995b4b83d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1dfa956995b4b83d$var$load("9F4Mz").then(()=>parcelRequire('7uVkM'));

});



parcelRegister("4eKYR", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationViewLogRouteEntry", () => $6d458a597bcccee8$export$ddc45b708634b66);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $edDQg = parcelRequire("edDQg");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $i7FI3 = parcelRequire("i7FI3");
const $6d458a597bcccee8$export$ddc45b708634b66 = (0, $7NszV.createEntry)((0, $edDQg.projectSettingsServicedeskAutomationViewLogRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        ufoName: 'service-management.automation.log',
        component: (0, $i7FI3.default),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $i7FI3.LazyProjectSettingsServiceDeskAutomationViewLog)
        ]
    }));

});
parcelRegister("edDQg", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationViewLogRoute", () => $3068172667b89342$export$ea3acd3ad4eb7d38);
const $3068172667b89342$export$ea3acd3ad4eb7d38 = {
    name: 'project-settings-servicedesk-automation-view-log',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation/log/:ruleId'
};

});

parcelRegister("i7FI3", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationViewLog", () => $6f8757b068912193$export$db6c5cdbc65b2b4a);
$parcel$export(module.exports, "default", () => $6f8757b068912193$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $6f8757b068912193$export$db6c5cdbc65b2b4a = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("6TZ72")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-view-log/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6f8757b068912193$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $6f8757b068912193$export$db6c5cdbc65b2b4a,
        pageId: "project-settings-automation-view-log",
        shouldShowSpinner: true
    });

});
parcelRegister("6TZ72", function(module, exports) {

let $506748cc098237ca$var$load = (parcelRequire("28QjX"))(4);
module.exports = $506748cc098237ca$var$load("1vnBX").then(()=>parcelRequire('5jbPW'));

});



parcelRegister("5W0wg", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationSummaryRouteEntry", () => $54707b820bd59983$export$4d6e0242b09fef3b);

var $ffza4 = parcelRequire("ffza4");

var $7NszV = parcelRequire("7NszV");

var $jowOt = parcelRequire("jowOt");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $5G6Zw = parcelRequire("5G6Zw");
const $54707b820bd59983$export$4d6e0242b09fef3b = (0, $7NszV.createEntry)((0, $jowOt.projectSettingsServicedeskAutomationSummaryRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        ufoName: 'service-management.automation.summary',
        component: (0, $5G6Zw.default),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $5G6Zw.LazyProjectSettingsServiceDeskAutomationSummary)
        ]
    }));

});
parcelRegister("jowOt", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationSummaryRoute", () => $634728c55a499ff5$export$165d82a2618e4d99);
const $634728c55a499ff5$export$165d82a2618e4d99 = {
    name: 'project-settings-servicedesk-automation-summary',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation'
};

});

parcelRegister("5G6Zw", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationSummary", () => $8a03171b9122a104$export$2fc8c3fcbb365b89);
$parcel$export(module.exports, "default", () => $8a03171b9122a104$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $8a03171b9122a104$export$2fc8c3fcbb365b89 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("lHXN9")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-summary/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8a03171b9122a104$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8a03171b9122a104$export$2fc8c3fcbb365b89,
        pageId: "project-settings-automation-summary",
        shouldShowSpinner: true
    });

});
parcelRegister("lHXN9", function(module, exports) {

let $fcdbfe847ce1afc4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fcdbfe847ce1afc4$var$load("e3XdD").then(()=>parcelRequire('6kXBX'));

});



parcelRegister("aQ85T", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectCreateRouteEntry", () => $4e9c4987ebea2357$export$fc7d1f3302418153);

var $7NszV = parcelRequire("7NszV");

var $gzxoX = parcelRequire("gzxoX");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6g6uF = parcelRequire("6g6uF");
const $4e9c4987ebea2357$export$fc7d1f3302418153 = (0, $7NszV.createEntry)((0, $gzxoX.projectSettingsServicedeskLegacyAutomationRedirectCreateRoute), ()=>({
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [],
        component: (0, $6g6uF.automationRedirect)('create')
    }));

});
parcelRegister("gzxoX", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectCreateRoute", () => $180ffea8026c8f05$export$c2a59dbe6d23efd4);
const $180ffea8026c8f05$export$c2a59dbe6d23efd4 = {
    name: 'project-settings-servicedesk-automation-redirect-create',
    path: '/projects/:projectKey/settings/automation/blueprint/:blueprintKey'
};

});

parcelRegister("6g6uF", function(module, exports) {

$parcel$export(module.exports, "automationRedirect", () => $69d1eaf61634b750$export$d6674bfa636b8090);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $02Psx = parcelRequire("02Psx");

var $g5X3G = parcelRequire("g5X3G");

var $7tQej = parcelRequire("7tQej");
const $69d1eaf61634b750$var$newAutomationUrl = (baseUrl, { match: match }, pageType)=>{
    const { projectKey: projectKey } = match.params;
    if (pageType === 'edit') {
        const { ruleId: ruleId } = match.params;
        return `${(0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), String(projectKey))}/automation/ruleset/${ruleId || ''}`;
    }
    if (pageType === 'copy') {
        const { ruleId: ruleId } = match.params;
        return `${(0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), String(projectKey))}/automation/copy/${ruleId || ''}`;
    }
    if (pageType === 'viewlog') {
        const { ruleId: ruleId } = match.params;
        return `${(0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), String(projectKey))}/automation/log/${ruleId || ''}`;
    }
    if (pageType === 'create') {
        const { blueprintKey: blueprintKey } = match.params;
        return `${(0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), String(projectKey))}/automation/blueprint/${blueprintKey || ''}`;
    }
    return `${(0, $02Psx.getNextgenSettingsUrl)((0, $2vSU6.SERVICE_DESK_PROJECT), String(projectKey))}/automation`;
};
const $69d1eaf61634b750$export$d6674bfa636b8090 = (pageType)=>(routeContext)=>{
        // use empty string instead of actual baseUrl as router redirect handles it internally
        const emptyBaseUrl = (0, $g5X3G.toBaseUrl)('');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: $69d1eaf61634b750$var$newAutomationUrl(emptyBaseUrl, routeContext, pageType),
            push: false
        });
    };

});


parcelRegister("6kvQ5", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectEditRouteEntry", () => $d4b71d1e99902d1e$export$cf95450a3eafe8ff);

var $7NszV = parcelRequire("7NszV");

var $zrLzB = parcelRequire("zrLzB");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6g6uF = parcelRequire("6g6uF");
const $d4b71d1e99902d1e$export$cf95450a3eafe8ff = (0, $7NszV.createEntry)((0, $zrLzB.projectSettingsServicedeskLegacyAutomationRedirectEditRoute), ()=>({
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [],
        component: (0, $6g6uF.automationRedirect)('edit')
    }));

});
parcelRegister("zrLzB", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectEditRoute", () => $7a29d6d898ef792a$export$f61e79c14e9bc0a1);
const $7a29d6d898ef792a$export$f61e79c14e9bc0a1 = {
    name: 'project-settings-servicedesk-automation-redirect-edit',
    path: '/projects/:projectKey/settings/automation/ruleset/:ruleId'
};

});


parcelRegister("bCnWj", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectCopyRouteEntry", () => $9834f5e7c0df5412$export$dd52be928c274980);

var $7NszV = parcelRequire("7NszV");

var $bM51X = parcelRequire("bM51X");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6g6uF = parcelRequire("6g6uF");
const $9834f5e7c0df5412$export$dd52be928c274980 = (0, $7NszV.createEntry)((0, $bM51X.projectSettingsServicedeskLegacyAutomationRedirectCopyRoute), ()=>({
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [],
        component: (0, $6g6uF.automationRedirect)('copy')
    }));

});
parcelRegister("bM51X", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectCopyRoute", () => $60a67b19cd763b2f$export$869afe63d0e077be);
const $60a67b19cd763b2f$export$869afe63d0e077be = {
    name: 'project-settings-servicedesk-automation-redirect-copy',
    path: '/projects/:projectKey/settings/automation/copy/:ruleId'
};

});


parcelRegister("kci7Q", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectViewLogRouteEntry", () => $d28565c3ab2c87a7$export$f0eaafcdee9dfa31);

var $7NszV = parcelRequire("7NszV");

var $7wX2j = parcelRequire("7wX2j");

var $lmyls = parcelRequire("lmyls");

var $6Z2mh = parcelRequire("6Z2mh");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6g6uF = parcelRequire("6g6uF");
const $d28565c3ab2c87a7$export$f0eaafcdee9dfa31 = (0, $7NszV.createEntry)((0, $7wX2j.projectSettingsServicedeskLegacyAutomationRedirectViewLogRoute), ()=>({
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [],
        component: (0, $6g6uF.automationRedirect)('viewlog')
    }));

});
parcelRegister("7wX2j", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectViewLogRoute", () => $5e0bbde66fde5bf7$export$e6e772830a33ba0b);
const $5e0bbde66fde5bf7$export$e6e772830a33ba0b = {
    name: 'project-settings-servicedesk-automation-redirect-viewlog',
    path: '/projects/:projectKey/settings/automation/log/:ruleId'
};

});


parcelRegister("9Dd5o", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectSummaryRouteEntry", () => $c179245528a3d6e0$export$d6873ef17e5a0ea5);

var $7NszV = parcelRequire("7NszV");

var $1N14b = parcelRequire("1N14b");

var $6Z2mh = parcelRequire("6Z2mh");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6g6uF = parcelRequire("6g6uF");
const $c179245528a3d6e0$export$d6873ef17e5a0ea5 = (0, $7NszV.createEntry)((0, $1N14b.projectSettingsServicedeskLegacyAutomationRedirectSummaryRoute), ()=>({
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [],
        component: (0, $6g6uF.automationRedirect)('summary')
    }));

});
parcelRegister("1N14b", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskLegacyAutomationRedirectSummaryRoute", () => $4fd4ba182f3de844$export$fdd432d4e600f9);
const $4fd4ba182f3de844$export$fdd432d4e600f9 = {
    name: 'project-settings-servicedesk-automation-redirect-summary',
    path: '/projects/:projectKey/settings/automation/'
};

});


parcelRegister("h4Pr8", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskCustomerNotificationsRouteEntry", () => $90cce0d970ed183f$export$5a4abc64d2a82698);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $1XuFh = parcelRequire("1XuFh");

var $6Z2mh = parcelRequire("6Z2mh");

var $hASB6 = parcelRequire("hASB6");
const $90cce0d970ed183f$export$5a4abc64d2a82698 = (0, $7NszV.createEntry)((0, $1XuFh.projectSettingsServicedeskCustomerNotificationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $hASB6.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hASB6.LazyProjectSettingsServiceDeskCustomerNotifications)
        ]
    }));

});
parcelRegister("hASB6", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskCustomerNotifications", () => $6081b8204512e323$export$c763ea321ade5f68);
$parcel$export(module.exports, "default", () => $6081b8204512e323$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kKHTt = parcelRequire("kKHTt");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $6081b8204512e323$export$c763ea321ade5f68 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("7rpJm")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-customer-notifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6081b8204512e323$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kKHTt.HelpCenterSettingsRedirect), {
        page: "customer-notifications"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $6081b8204512e323$export$c763ea321ade5f68,
        pageId: "project-settings-customer-notifications",
        shouldShowSpinner: true
    }));

});
parcelRegister("7rpJm", function(module, exports) {

let $56af039c638807c6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $56af039c638807c6$var$load("denwG").then(()=>parcelRequire('jp5Rx'));

});



parcelRegister("5XbrB", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsCustomerNotificationsRouteEntry", () => $d08875f655bb322d$export$b4d122e49516c10d);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $3BQ4q = parcelRequire("3BQ4q");

var $6Z2mh = parcelRequire("6Z2mh");

var $kFrbC = parcelRequire("kFrbC");

var $hASB6 = parcelRequire("hASB6");
const $d08875f655bb322d$export$b4d122e49516c10d = (0, $7NszV.createEntry)((0, $3BQ4q.projectSettingsServicedeskNotificationsCustomerNotificationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $kFrbC.ServiceDeskCustomerNotificationsNextGenRedirect),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $hASB6.LazyProjectSettingsServiceDeskCustomerNotifications)
        ]
    }));

});
parcelRegister("kFrbC", function(module, exports) {

$parcel$export(module.exports, "ServiceDeskCustomerNotificationsNextGenRedirect", () => $aa137e884608085b$export$8249a46a710af6da);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
const $aa137e884608085b$export$8249a46a710af6da = ({ match: match })=>{
    const { projectKey: projectKey } = match.params;
    const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/customer-notifications`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: url
    });
};

});


parcelRegister("1ods3", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskJourneysRouteEntry", () => $b1d24e5a00ab7abb$export$6c014a8c741bf222);

var $e4eHl = parcelRequire("e4eHl");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $2j3DA = parcelRequire("2j3DA");

var $6Z2mh = parcelRequire("6Z2mh");

var $4R6GH = parcelRequire("4R6GH");

var $g2OFQ = parcelRequire("g2OFQ");
const $b1d24e5a00ab7abb$export$6c014a8c741bf222 = (0, $7NszV.createEntry)((0, $2j3DA.projectSettingsServicedeskJourneysRoute), ()=>({
        group: 'project-settings-servicedesk',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        meta: {
            reporting: {
                id: 'jsm.journey-builder.journeys-list',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('journeys-list'),
                teamName: 'JSM Getting Started'
            }
        },
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ],
        perfMetricKey: 'jsm-journeys',
        entryPoint: ()=>(0, $4R6GH.fg)('jsm-journey-builder') ? (0, $g2OFQ.journeysPageEntryPoint) : undefined
    }));

});
parcelRegister("2j3DA", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskJourneysRoute", () => $705088c1cf32c92a$export$627d71a1dd7a9593);
const $705088c1cf32c92a$export$627d71a1dd7a9593 = {
    name: 'project-settings-servicedesk-journeys',
    path: '/jira/servicedesk/projects/:projectKey/settings/journeys',
    exact: true
};

});

parcelRegister("g2OFQ", function(module, exports) {

$parcel$export(module.exports, "journeysPageEntryPoint", () => $afecb2c38eb0ad75$export$3b90f0eb27bdd52f);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $bbmu4 = parcelRequire("bbmu4");
const $afecb2c38eb0ad75$export$3b90f0eb27bdd52f = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $bbmu4.journeysEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("bbmu4", function(module, exports) {

$parcel$export(module.exports, "journeysEntryPoint", () => $1cbf56bd5b792bd0$export$4ded7f93dbe6eb63);

var $8FYy8 = parcelRequire("8FYy8");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $4R6GH = parcelRequire("4R6GH");

const $1cbf56bd5b792bd0$export$4ded7f93dbe6eb63 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        if (!false) return (parcelRequire("v9NCl"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "ab11e2ef",
        moduleName: "JourneysPage"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                journeysPageQueryRef: {
                    parameters: $8FYy8.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey || '',
                        isFGEnabled: (0, $4R6GH.fg)('journey_builder_support_versioning')
                    },
                    options: {
                        fetchPolicy: 'store-and-network'
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        })
});

});
parcelRegister("8FYy8", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dab8bc029613fb5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<83a2d8b891919354b4a371e0d3b595de>>
 * @relayHash 3354cc4202d42c6c5ace34b7d2c7f774
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0c55cb735663043e184d5adef47ee8599cdf2febd8c3e6ce1d01460696ef3aa4
const $0dab8bc029613fb5$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "0c55cb735663043e184d5adef47ee8599cdf2febd8c3e6ce1d01460696ef3aa4",
        "metadata": {},
        "name": "JourneysPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $0dab8bc029613fb5$export$2e2bcd8739ae039 = $0dab8bc029613fb5$var$node;

});

parcelRegister("v9NCl", function(module, exports) {

let $05da7f4c56a24140$var$load = (parcelRequire("28QjX"))(4);
module.exports = $05da7f4c56a24140$var$load("17vDF").then(()=>parcelRequire('iSwlg'));

});




parcelRegister("gpVZm", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskJourneyConfigurationRouteEntry", () => $d346a4266360b0ae$export$7475316a4561dd76);

var $e4eHl = parcelRequire("e4eHl");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $gyJ1H = parcelRequire("gyJ1H");

var $6Z2mh = parcelRequire("6Z2mh");

var $4R6GH = parcelRequire("4R6GH");

var $8LFLY = parcelRequire("8LFLY");
const $d346a4266360b0ae$export$7475316a4561dd76 = (0, $7NszV.createEntry)((0, $gyJ1H.projectSettingsServicedeskJourneyConfigurationRoute), ()=>({
        group: 'project-settings-servicedesk',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        meta: {
            reporting: {
                id: 'jsm.journey-builder.journey-config',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('journey-config'),
                teamName: 'JSM Getting Started'
            }
        },
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ],
        perfMetricKey: 'jsm-journey-configuration',
        entryPoint: ()=>(0, $4R6GH.fg)('jsm-journey-builder') ? (0, $8LFLY.journeyConfigPageEntryPoint) : undefined
    }));

});
parcelRegister("gyJ1H", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskJourneyConfigurationRoute", () => $9a0c0a603e702cf3$export$9013e78604bfadb0);
const $9a0c0a603e702cf3$export$9013e78604bfadb0 = {
    name: 'project-settings-servicedesk-journey-configuration',
    path: '/jira/servicedesk/projects/:projectKey/settings/journeys/:journeyId',
    exact: true
};

});

parcelRegister("8LFLY", function(module, exports) {

$parcel$export(module.exports, "journeyConfigPageEntryPoint", () => $e2e16678033c3122$export$35537410b0bf07ea);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $3HGnZ = parcelRequire("3HGnZ");
const $e2e16678033c3122$export$35537410b0bf07ea = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $3HGnZ.journeyConfigEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("3HGnZ", function(module, exports) {

$parcel$export(module.exports, "journeyConfigEntryPoint", () => $1dfcd84f3f61c84b$export$26f82de7820f0c3);

var $lyoHt = parcelRequire("lyoHt");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $1dfcd84f3f61c84b$export$26f82de7820f0c3 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        if (!false) return (parcelRequire("kVsKg"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "6bffb775",
        moduleName: "JourneyConfigurationPage"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        return {
            queries: {
                jiraJourneyConfiguration: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $lyoHt.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey || '',
                        journeyId: context.match.params.journeyId ?? '',
                        isEditing: context.match.path?.includes('journeys/:journeyId/edit')
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        };
    }
});

});
parcelRegister("lyoHt", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c24657e8d4ddd13$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5e15018685f0f8fc431c1a054a937962>>
 * @relayHash 1aed146137e3e58f4e905eaa4f891748
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cf4ac78d97f3f9a7ba35ca6fa278e16eb0076188cba5c0c55eff9a4dd7ab76a1
const $5c24657e8d4ddd13$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "cf4ac78d97f3f9a7ba35ca6fa278e16eb0076188cba5c0c55eff9a4dd7ab76a1",
        "metadata": {},
        "name": "JourneyConfigurationPageQuery",
        "operationKind": "query",
        "text": null
    }
};
var $5c24657e8d4ddd13$export$2e2bcd8739ae039 = $5c24657e8d4ddd13$var$node;

});

parcelRegister("kVsKg", function(module, exports) {

let $f3bf6dbb28656de2$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f3bf6dbb28656de2$var$load("ffQaD"),
    $f3bf6dbb28656de2$var$load("kvRbA"),
    $f3bf6dbb28656de2$var$load("9gF6b")
]).then(()=>parcelRequire('aG5pa'));

});




parcelRegister("i8buc", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskJourneyConfigurationEditRouteEntry", () => $c37fb91c4e26e536$export$5cbb0a0098e65c64);

var $e4eHl = parcelRequire("e4eHl");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $fpjJX = parcelRequire("fpjJX");

var $2ki4m = parcelRequire("2ki4m");

var $6Z2mh = parcelRequire("6Z2mh");

var $4R6GH = parcelRequire("4R6GH");

var $2pLla = parcelRequire("2pLla");
const $c37fb91c4e26e536$export$5cbb0a0098e65c64 = (0, $7NszV.createEntry)((0, $2ki4m.projectSettingsServicedeskJourneyConfigurationEditRoute), ()=>({
        group: 'project-settings-servicedesk',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        meta: {
            reporting: {
                id: 'jsm.journey-builder.journey-config',
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))('journey-config'),
                teamName: 'JSM Getting Started'
            }
        },
        layout: (0, $6Z2mh.serviceProjectLayout),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)()
        ],
        perfMetricKey: 'jsm-journey-configuration-edit',
        entryPoint: ()=>(0, $4R6GH.fg)('journey_builder_support_versioning') ? (0, $2pLla.journeyConfigEditPageEntryPoint) : undefined
    }));

});
parcelRegister("2ki4m", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskJourneyConfigurationEditRoute", () => $5908f0de6ed8a95e$export$f80f582ef54900c6);
const $5908f0de6ed8a95e$export$f80f582ef54900c6 = {
    name: 'project-settings-servicedesk-journey-configuration-edit',
    path: '/jira/servicedesk/projects/:projectKey/settings/journeys/:journeyId/edit',
    exact: true
};

});

parcelRegister("2pLla", function(module, exports) {

$parcel$export(module.exports, "journeyConfigEditPageEntryPoint", () => $fdfad37cd3d1b2d6$export$7388ef888b9170a7);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $3HGnZ = parcelRequire("3HGnZ");
const $fdfad37cd3d1b2d6$export$7388ef888b9170a7 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $3HGnZ.journeyConfigEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});


parcelRegister("hqIff", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskKbRouteEntry", () => $f4ec187fc157720c$export$d43e914d37d059b8);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $2m3cT = parcelRequire("2m3cT");

var $6Z2mh = parcelRequire("6Z2mh");

var $gw09t = parcelRequire("gw09t");
const $f4ec187fc157720c$export$d43e914d37d059b8 = (0, $7NszV.createEntry)((0, $2m3cT.projectSettingsServicedeskKbRoute), ()=>({
        group: 'project-settings-servicedesk',
        perfMetricKey: 'service-management.kb-settings',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        component: (0, $gw09t.ServiceDeskKnowledgeBaseV2),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gw09t.LazyProjectSettingsServiceDeskKnowledgeBaseV2)
        ],
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ]
    }));

});
parcelRegister("gw09t", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskKnowledgeBaseV2", () => $0bf88a8d63415148$export$7c7186fdd8c56428);
$parcel$export(module.exports, "ServiceDeskKnowledgeBaseV2", () => $0bf88a8d63415148$export$6d92735e249274bb);

var $5uXOq = parcelRequire("5uXOq");

var $kKHTt = parcelRequire("kKHTt");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");
const $0bf88a8d63415148$export$3fac45fa34d00981 = 'project/service-desk/settings/index';
const $0bf88a8d63415148$export$1aa47348ef6dbdda = 'project/service-desk/settings';

const $0bf88a8d63415148$export$583a442626bd3345 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("8h2hP")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-knowledge-base/src/index.tsx"
});

const $0bf88a8d63415148$export$7c7186fdd8c56428 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("iR667"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-settings/src/index.tsx"
});
const $0bf88a8d63415148$export$6d92735e249274bb = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kKHTt.HelpCenterSettingsRedirect), {
        page: "kb"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $0bf88a8d63415148$export$7c7186fdd8c56428,
        pageId: "project-settings-knowledge-base",
        shouldShowSpinner: true
    }));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0bf88a8d63415148$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $0bf88a8d63415148$export$583a442626bd3345,
        pageId: "project-settings-knowledge-base",
        shouldShowSpinner: true
    });

});
parcelRegister("8h2hP", function(module, exports) {

let $6061af51954aa4ba$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6061af51954aa4ba$var$load("3uUSO").then(()=>parcelRequire('2fak7'));

});

parcelRegister("iR667", function(module, exports) {

let $dba1e81c3a2f2f23$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $dba1e81c3a2f2f23$var$load("ffQaD"),
    $dba1e81c3a2f2f23$var$load("kvRbA"),
    $dba1e81c3a2f2f23$var$load("iDhNV")
]).then(()=>parcelRequire('gCbsh'));

});



parcelRegister("1Y5eu", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskUnassignedTicketTypeFieldsRouteEntry", () => $d537ae27f4e9ad4c$export$515ee5ae44539ca4);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $eUvlM = parcelRequire("eUvlM");

var $iWVTz = parcelRequire("iWVTz");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $bO6K2 = parcelRequire("bO6K2");
const $d537ae27f4e9ad4c$export$515ee5ae44539ca4 = (0, $7NszV.createEntry)((0, $iWVTz.projectSettingsServicedeskUnassignedTicketTypeFieldsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $bO6K2.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $eUvlM.servicedeskPracticesResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bO6K2.LazyProjectSettingsServiceDeskTicketTypeFields)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).REQUEST_TYPE_FIELDS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).REQUEST_TYPE_FIELDS),
                teamName: 'jsd-shield'
            }
        },
        ufoName: 'project-settings-servicedesk-ticket-type-fields'
    }));

});
parcelRegister("iWVTz", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskUnassignedTicketTypeFieldsRoute", () => $0ce9ec8fbf444bc7$export$f7a986e844a111a6);
const $0ce9ec8fbf444bc7$export$f7a986e844a111a6 = {
    exact: true,
    name: 'project-settings-servicedesk-unassigned-ticket-type-fields',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/unassigned/request-type/:requestTypeId/:tabKey?'
};

});

parcelRegister("bO6K2", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskTicketTypeFields", () => $e9f2572a89172526$export$471040ce01e559fc);
$parcel$export(module.exports, "default", () => $e9f2572a89172526$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kKHTt = parcelRequire("kKHTt");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $e9f2572a89172526$export$471040ce01e559fc = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("bfWUt")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-ticket-type-fields/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e9f2572a89172526$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kKHTt.HelpCenterSettingsRedirect), {
        page: "ticket-type-fields"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e9f2572a89172526$export$471040ce01e559fc,
        pageId: "project-settings-ticket-type-fields",
        shouldShowSpinner: true
    }));

});
parcelRegister("bfWUt", function(module, exports) {

let $831ecaaf536bca50$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $831ecaaf536bca50$var$load("ffQaD"),
    $831ecaaf536bca50$var$load("kvRbA"),
    $831ecaaf536bca50$var$load("blL1z")
]).then(()=>parcelRequire('73hU9'));

});



parcelRegister("kkXdG", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskItsmTicketTypeFieldsRouteEntry", () => $2aef83b11784cadf$export$49692fb0973d60ca);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $eUvlM = parcelRequire("eUvlM");

var $gfgJe = parcelRequire("gfgJe");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $bO6K2 = parcelRequire("bO6K2");
const $2aef83b11784cadf$export$49692fb0973d60ca = (0, $7NszV.createEntry)((0, $gfgJe.projectSettingsServicedeskItsmTicketTypeFieldsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $bO6K2.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $eUvlM.servicedeskPracticesResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bO6K2.LazyProjectSettingsServiceDeskTicketTypeFields)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).REQUEST_TYPE_FIELDS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).REQUEST_TYPE_FIELDS),
                teamName: 'jsd-shield'
            }
        },
        ufoName: 'project-settings-servicedesk-ticket-type-fields'
    }));

});
parcelRegister("gfgJe", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskItsmTicketTypeFieldsRoute", () => $e91beb008e9026ec$export$1af0541fcb95547b);
const $e91beb008e9026ec$export$1af0541fcb95547b = {
    exact: true,
    name: 'project-settings-servicedesk-itsm-ticket-type-fields',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/category/:practice/request-type/:requestTypeId/:tabKey?'
};

});


parcelRegister("gPxpf", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskTicketTypeFieldsRouteEntry", () => $4fa5116a5c8fa3c1$export$30951c6038a30ec4);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $eUvlM = parcelRequire("eUvlM");

var $7mt6L = parcelRequire("7mt6L");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $bO6K2 = parcelRequire("bO6K2");
const $4fa5116a5c8fa3c1$export$30951c6038a30ec4 = (0, $7NszV.createEntry)((0, $7mt6L.projectSettingsServicedeskTicketTypeFieldsRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $bO6K2.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $eUvlM.servicedeskPracticesResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $bO6K2.LazyProjectSettingsServiceDeskTicketTypeFields)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).REQUEST_TYPE_FIELDS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).REQUEST_TYPE_FIELDS),
                teamName: 'jsd-shield'
            }
        },
        ufoName: 'project-settings-servicedesk-ticket-type-fields'
    }));

});
parcelRegister("7mt6L", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskTicketTypeFieldsRoute", () => $28fb213ff0720fc3$export$6c99c477ef7583ba);
const $28fb213ff0720fc3$export$6c99c477ef7583ba = {
    exact: true,
    name: 'project-settings-servicedesk-ticket-type-fields',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/request-type/:requestTypeId/:tabKey?'
};

});


parcelRegister("3FG4O", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskUnassignedTicketTypesConfigRouteEntry", () => $13309764c6efb114$export$6ba31a548ab77c4);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $2pT4g = parcelRequire("2pT4g");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $k8jl5 = parcelRequire("k8jl5");

var $1cpsA = parcelRequire("1cpsA");

var $eUvlM = parcelRequire("eUvlM");

var $6sNnq = parcelRequire("6sNnq");

var $9xhY2 = parcelRequire("9xhY2");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $dEPxR = parcelRequire("dEPxR");

var $lkFvK = parcelRequire("lkFvK");

var $4stgq = parcelRequire("4stgq");
const $13309764c6efb114$var$projectSettingsServicedeskUnassignedTicketTypesConfigPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $dEPxR.TicketTypesConfigEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $13309764c6efb114$export$6ba31a548ab77c4 = (0, $7NszV.createEntry)((0, $9xhY2.projectSettingsServicedeskUnassignedTicketTypesConfigRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $4stgq.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $dxCvy.projectContextResource),
            (0, $eUvlM.servicedeskPracticesResource),
            (0, $k8jl5.servicedeskIssueTypesResource),
            (0, $1cpsA.servicedeskPortalGroupsResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $2pT4g.jsmRepackagingBannerResource),
            (0, $6sNnq.featuresResource)
        ],
        entryPoint () {
            return $13309764c6efb114$var$projectSettingsServicedeskUnassignedTicketTypesConfigPageEntrypoint;
        },
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4stgq.LazyProjectSettingsServiceDeskTicketTypesConfig)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).REQUEST_TYPES_CONFIG,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).REQUEST_TYPES_CONFIG),
                teamName: 'jsd-shield'
            }
        },
        perfMetricKey: 'jsm-request-types-configuration',
        ufoName: 'jsm-request-types-configuration'
    }));

});
parcelRegister("1cpsA", function(module, exports) {

$parcel$export(module.exports, "servicedeskPortalGroupsResource", () => $2ddee7630453f9bc$export$c7fb28234b909b2f);

var $2M1hQ = parcelRequire("2M1hQ");


const $2ddee7630453f9bc$var$getDataLoader = ()=>(parcelRequire("646f9"));
const $2ddee7630453f9bc$var$ONE_DAY_IN_MILLIS = 86400000;
const $2ddee7630453f9bc$export$c7fb28234b909b2f = (0, $2M1hQ.createResource)({
    type: (0, $1e9c4adda1725c92$export$4160f2c498fcd32e),
    getKey: ({ match: { params: params } })=>params.projectKey || '',
    getDataLoader: $2ddee7630453f9bc$var$getDataLoader,
    maxAge: $2ddee7630453f9bc$var$ONE_DAY_IN_MILLIS
});

});
const $1e9c4adda1725c92$export$4160f2c498fcd32e = 'SERVICEDESK_PORTAL_GROUPS';

parcelRegister("646f9", function(module, exports) {

let $46a7f59c7223f675$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $46a7f59c7223f675$var$load("kVX56"),
    $46a7f59c7223f675$var$load("9IaT8")
]).then(()=>parcelRequire('7sMSo'));

});


parcelRegister("dEPxR", function(module, exports) {

$parcel$export(module.exports, "TicketTypesConfigEntrypoint", () => $67e2a135ba1dfc6c$export$85bc484c6bab022d);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $jfTHL = parcelRequire("jfTHL");

const $67e2a135ba1dfc6c$export$85bc484c6bab022d = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("3X95c")), {
        moduleId: "d08c0344"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const cloudId = tenantContext.cloudId;
        const projectKey = context.match.params.projectKey;
        if (!projectKey) throw new Error('Project key is required');
        return {
            entryPoints: {
                requestTypeTableEntrypoint: {
                    entryPoint: (0, $jfTHL.requestTypeTableEntrypoint),
                    entryPointParams: {
                        projectKey: projectKey,
                        cloudId: cloudId
                    }
                }
            }
        };
    }
});

});
parcelRegister("jfTHL", function(module, exports) {

$parcel$export(module.exports, "requestTypeTableEntrypoint", () => $c5ac394482ac63fe$export$ecbf0c880decd2ac);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $2K2rC = parcelRequire("2K2rC");

const $c5ac394482ac63fe$export$ecbf0c880decd2ac = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("lntVi")).then((module)=>module.RequestTypesTable), {
        moduleId: "44a9b8a6"
    }),
    getPreloadProps: ({ projectKey: projectKey, cloudId: cloudId })=>{
        return {
            queries: {
                tableSettings: {
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    },
                    parameters: $2K2rC.default,
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("2K2rC", function(module, exports) {

$parcel$export(module.exports, "default", () => $32bd8aa55825b96f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ce045fc0dd46722872f41c70f570f768>>
 * @relayHash 989e1263c7e39eb54ef3504b593961dc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bc2fb1d6504af1e571c063410348f23ce17651af7eb3f1921b9b1483b8d48cc8
const $32bd8aa55825b96f$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "bc2fb1d6504af1e571c063410348f23ce17651af7eb3f1921b9b1483b8d48cc8",
        "metadata": {},
        "name": "table_RequestTypesTableQuery",
        "operationKind": "query",
        "text": null
    }
};
var $32bd8aa55825b96f$export$2e2bcd8739ae039 = $32bd8aa55825b96f$var$node;

});

parcelRegister("lntVi", function(module, exports) {

let $f902f50dc9cd0caa$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f902f50dc9cd0caa$var$load("h8elz").then(()=>parcelRequire('hBNKS'));

});


parcelRegister("3X95c", function(module, exports) {

let $2e0ded7395bfdfd4$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2e0ded7395bfdfd4$var$load("ffQaD"),
    $2e0ded7395bfdfd4$var$load("kvRbA"),
    $2e0ded7395bfdfd4$var$load("5uHcO")
]).then(()=>parcelRequire('aFE6U'));

});


parcelRegister("4stgq", function(module, exports) {

$parcel$export(module.exports, "LazyProjectSettingsServiceDeskTicketTypesConfig", () => $d4145a6e3aeb3bbb$export$c26e63f8b7d3b52c);
$parcel$export(module.exports, "default", () => $d4145a6e3aeb3bbb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kKHTt = parcelRequire("kKHTt");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $d4145a6e3aeb3bbb$export$c26e63f8b7d3b52c = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("eu1S5")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-ticket-types-config/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d4145a6e3aeb3bbb$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kKHTt.HelpCenterSettingsRedirect), {
        page: "ticket-types-config"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $d4145a6e3aeb3bbb$export$c26e63f8b7d3b52c,
        pageId: "project-settings-ticket-types-config",
        shouldShowSpinner: true
    }));

});
parcelRegister("eu1S5", function(module, exports) {

let $a8b551a15d0aa522$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a8b551a15d0aa522$var$load("ffQaD"),
    $a8b551a15d0aa522$var$load("kvRbA"),
    $a8b551a15d0aa522$var$load("6mGQj")
]).then(()=>parcelRequire('7wKb0'));

});



parcelRegister("bl8cB", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskItsmTicketTypesConfigRouteEntry", () => $1761f8f0b85b3339$export$9f40815b933b51ba);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $2pT4g = parcelRequire("2pT4g");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $k8jl5 = parcelRequire("k8jl5");

var $1cpsA = parcelRequire("1cpsA");

var $eUvlM = parcelRequire("eUvlM");

var $6sNnq = parcelRequire("6sNnq");

var $j9HCv = parcelRequire("j9HCv");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $dEPxR = parcelRequire("dEPxR");

var $lkFvK = parcelRequire("lkFvK");

var $4stgq = parcelRequire("4stgq");
const $1761f8f0b85b3339$var$projectSettingsServicedeskItsmTicketTypesConfigPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $dEPxR.TicketTypesConfigEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $1761f8f0b85b3339$export$9f40815b933b51ba = (0, $7NszV.createEntry)((0, $j9HCv.projectSettingsServicedeskItsmTicketTypesConfigRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $4stgq.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            return $1761f8f0b85b3339$var$projectSettingsServicedeskItsmTicketTypesConfigPageEntrypoint;
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $dxCvy.projectContextResource),
            (0, $eUvlM.servicedeskPracticesResource),
            (0, $k8jl5.servicedeskIssueTypesResource),
            (0, $1cpsA.servicedeskPortalGroupsResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $2pT4g.jsmRepackagingBannerResource),
            (0, $6sNnq.featuresResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4stgq.LazyProjectSettingsServiceDeskTicketTypesConfig)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).REQUEST_TYPES_CONFIG,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).REQUEST_TYPES_CONFIG),
                teamName: 'jsd-shield'
            }
        },
        perfMetricKey: 'jsm-request-types-configuration',
        ufoName: 'jsm-request-types-configuration'
    }));

});
parcelRegister("j9HCv", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskItsmTicketTypesConfigRoute", () => $6ecc0aee1a9cf675$export$52596d9b432829c);
const $6ecc0aee1a9cf675$export$52596d9b432829c = {
    exact: true,
    name: 'project-settings-servicedesk-itsm-ticket-types-config',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/category/:practice'
};

});


parcelRegister("fLbia", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskTicketTypesConfigRouteEntry", () => $0acca3ff344e5eeb$export$bcc0bb7cf7f75a0f);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $2pT4g = parcelRequire("2pT4g");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $k8jl5 = parcelRequire("k8jl5");

var $1cpsA = parcelRequire("1cpsA");

var $eUvlM = parcelRequire("eUvlM");

var $6sNnq = parcelRequire("6sNnq");

var $cmEH1 = parcelRequire("cmEH1");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $dEPxR = parcelRequire("dEPxR");

var $lkFvK = parcelRequire("lkFvK");

var $4stgq = parcelRequire("4stgq");
const $0acca3ff344e5eeb$var$projectSettingsServicedeskTicketTypesConfigPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $dEPxR.TicketTypesConfigEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $0acca3ff344e5eeb$export$bcc0bb7cf7f75a0f = (0, $7NszV.createEntry)((0, $cmEH1.projectSettingsServicedeskTicketTypesConfigRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $4stgq.default),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $dxCvy.projectContextResource),
            (0, $eUvlM.servicedeskPracticesResource),
            (0, $k8jl5.servicedeskIssueTypesResource),
            (0, $1cpsA.servicedeskPortalGroupsResource),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $2pT4g.jsmRepackagingBannerResource),
            (0, $6sNnq.featuresResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $4stgq.LazyProjectSettingsServiceDeskTicketTypesConfig)
        ],
        entryPoint () {
            return $0acca3ff344e5eeb$var$projectSettingsServicedeskTicketTypesConfigPageEntrypoint;
        },
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).REQUEST_TYPES_CONFIG,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).REQUEST_TYPES_CONFIG),
                teamName: 'jsd-shield'
            }
        },
        perfMetricKey: 'jsm-request-types-configuration',
        ufoName: 'jsm-request-types-configuration'
    }));

});

parcelRegister("ceMKm", function(module, exports) {

$parcel$export(module.exports, "landingPageRouteEntry", () => $6f350a9dc34d5147$export$8ccc5b384e778bac);

var $c04PQ = parcelRequire("c04PQ");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $iXFkh = parcelRequire("iXFkh");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $7pflU = parcelRequire("7pflU");

var $lkFvK = parcelRequire("lkFvK");

var $8cTxW = parcelRequire("8cTxW");

var $k6R7C = parcelRequire("k6R7C");
const $6f350a9dc34d5147$var$landingPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $8cTxW.landingEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $6f350a9dc34d5147$export$8ccc5b384e778bac = (0, $7NszV.createEntry)((0, $iXFkh.landingPageRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $c04PQ.isFedRamp)()) return undefined;
            return $6f350a9dc34d5147$var$landingPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $k6R7C.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $7pflU.VirtualAgentLandingSkeleton),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_SETTINGS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_SETTINGS),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("iXFkh", function(module, exports) {

$parcel$export(module.exports, "landingPageRoute", () => $f5084469ecd7a21e$export$8c051c399fd812a5);
const $f5084469ecd7a21e$export$8c051c399fd812a5 = {
    // We name this virtualagentonboarding without the "-" as otherwise it would trigger
    // the nesting stack, which we don't want for onboarding
    name: 'project-settings-servicedesk-virtualagentonboarding',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent'
};

});

parcelRegister("7pflU", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentLandingSkeleton", () => $450c0f05e134cd5f$export$f4b71d7b732df8a7);
/* VirtualAgentLandingSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $azvva = parcelRequire("azvva");
const $450c0f05e134cd5f$var$customStyles = null;
const $450c0f05e134cd5f$export$f4b71d7b732df8a7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($azvva))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("azvva", function(module, exports) {
module.exports = new URL("virtual-agent-landing-app-skeleton.tpl.e8a7897b.svg", import.meta.url).toString();

});


parcelRegister("8cTxW", function(module, exports) {

$parcel$export(module.exports, "landingEntryPoint", () => $0f9dae747ed8bf8a$export$ad927ca7512a3a01);

var $9uqwu = parcelRequire("9uqwu");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");
const $0f9dae747ed8bf8a$var$DEFAULT_TIME_RANGE_MS = 604800000; // 7 days
const $0f9dae747ed8bf8a$var$formatFetchDate = (date)=>date.toISOString().substring(0, 10); // has to be truncated for proper caching in SSR

const $0f9dae747ed8bf8a$export$ad927ca7512a3a01 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        if (!false) return (parcelRequire("ar6kv"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "06d84010"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $9uqwu.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        startDate: $0f9dae747ed8bf8a$var$formatFetchDate(new Date(Date.now() - $0f9dae747ed8bf8a$var$DEFAULT_TIME_RANGE_MS)),
                        endDate: $0f9dae747ed8bf8a$var$formatFetchDate(new Date())
                    }
                }
            }
        })
});

});
parcelRegister("9uqwu", function(module, exports) {

$parcel$export(module.exports, "default", () => $588c29ffd4ee84e7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3ad5f824f7a4aacfcb7d5503f063fc47>>
 * @relayHash c2e12c872f6ff6665eafec5dac8ef69f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c95160025f205e36476cc4d69969984651c89a4264ad5e36807776313ceea0ba

var $7oHmH = parcelRequire("7oHmH");

var $gnNIl = parcelRequire("gnNIl");

var $5INZt = parcelRequire("5INZt");
const $588c29ffd4ee84e7$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "c95160025f205e36476cc4d69969984651c89a4264ad5e36807776313ceea0ba",
        "metadata": {},
        "name": "srcVirtualAgentLandingQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvastatusheaderrelayprovider": (0, $gnNIl.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcvsaadoptionstage1relayprovider": (0, $5INZt.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $7oHmH.default)
        }
    }
};
var $588c29ffd4ee84e7$export$2e2bcd8739ae039 = $588c29ffd4ee84e7$var$node;

});
parcelRegister("gnNIl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1a08e53932eeb60$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $f1a08e53932eeb60$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jsm_va_status_header');
    }
};

});

parcelRegister("5INZt", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3d53b1d56e94103$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
const $b3d53b1d56e94103$var$RelayProvider = {
    get () {
        return (0, $4R6GH.fg)('vsa-adoption-stage-1');
    }
};
var $b3d53b1d56e94103$export$2e2bcd8739ae039 = $b3d53b1d56e94103$var$RelayProvider;

});


parcelRegister("ar6kv", function(module, exports) {

let $799155f580cf3354$var$load = (parcelRequire("28QjX"))(4);
module.exports = $799155f580cf3354$var$load("9eM0F").then(()=>parcelRequire('52WYW'));

});


parcelRegister("k6R7C", function(module, exports) {

$parcel$export(module.exports, "FedRAMPFallbackRedirectToProjectSettings", () => $91741b5f92b89992$export$3b12aad1f47d85f8);

var $3AXtK = parcelRequire("3AXtK");
const $91741b5f92b89992$export$3b12aad1f47d85f8 = (0, $3AXtK.defaultRedirectForSettings)((0, $3AXtK.SERVICE_DESK_PRODUCT));

});
parcelRegister("3AXtK", function(module, exports) {

$parcel$export(module.exports, "SERVICE_DESK_PRODUCT", () => $a6392627f74f3006$export$5575497f0592ee94);
$parcel$export(module.exports, "defaultRedirectForSettings", () => $a6392627f74f3006$export$c9b0516439c55d7a);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
const $a6392627f74f3006$export$5575497f0592ee94 = 'servicedesk';
const $a6392627f74f3006$export$c9b0516439c55d7a = (product)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: `/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`
        });

});



parcelRegister("UuOK7", function(module, exports) {

$parcel$export(module.exports, "aiAnswersRouteEntry", () => $6c5c5fc65aabbb89$export$7aab6c3a99455d30);

var $c04PQ = parcelRequire("c04PQ");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $e9zsZ = parcelRequire("e9zsZ");

var $aGFv5 = parcelRequire("aGFv5");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $9PZqh = parcelRequire("9PZqh");

var $mOeIa = parcelRequire("mOeIa");

var $lkFvK = parcelRequire("lkFvK");

var $k6R7C = parcelRequire("k6R7C");
const $6c5c5fc65aabbb89$var$aiAnswersPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $mOeIa.aiAnswersEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $6c5c5fc65aabbb89$export$7aab6c3a99455d30 = (0, $7NszV.createEntry)((0, $aGFv5.aiAnswersRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $c04PQ.isFedRamp)()) return undefined;
            return $6c5c5fc65aabbb89$var$aiAnswersPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $k6R7C.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $9PZqh.VirtualAgentAiAnswersSkeleton),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            (0, $e9zsZ.servicedeskVirtualAgentAiAnswersKbResource)
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_AI_ANSWERS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_AI_ANSWERS),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("e9zsZ", function(module, exports) {

$parcel$export(module.exports, "servicedeskVirtualAgentAiAnswersKbResource", () => $adb9f25d3efd6c0f$export$6aecd43ca01da0d9);

var $2M1hQ = parcelRequire("2M1hQ");

const $adb9f25d3efd6c0f$var$getDataLoader = ()=>(parcelRequire("dQRfZ"));
const $adb9f25d3efd6c0f$export$6aecd43ca01da0d9 = (0, $2M1hQ.createResource)({
    type: 'SERVICEDESK_VIRTUAL_AGENT_AI_ANSWERS_KB_RESOURCE',
    getKey: ({ match: { params: params } })=>params.projectKey || '',
    getDataLoader: $adb9f25d3efd6c0f$var$getDataLoader,
    isBrowserOnly: true
});

});
parcelRegister("dQRfZ", function(module, exports) {

let $a1597164afd006a2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a1597164afd006a2$var$load("jAYFl").then(()=>parcelRequire('cJzMU'));

});


parcelRegister("aGFv5", function(module, exports) {

$parcel$export(module.exports, "aiAnswersRoute", () => $945f4c839611ad80$export$57dc115194d72385);
const $945f4c839611ad80$export$57dc115194d72385 = {
    name: 'project-settings-servicedesk-virtualagent-ai-answers',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/ai-answers'
};

});

parcelRegister("9PZqh", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentAiAnswersSkeleton", () => $72ea56917d7c23c3$export$5fe1280883d32350);
/* VirtualAgentAiAnswersSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $hKurF = parcelRequire("hKurF");
const $72ea56917d7c23c3$var$customCssStyles = null;
const $72ea56917d7c23c3$export$5fe1280883d32350 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hKurF))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("hKurF", function(module, exports) {
module.exports = new URL("virtual-agent-ai-answers-app-skeleton.tpl.283eb0a3.svg", import.meta.url).toString();

});


parcelRegister("mOeIa", function(module, exports) {

$parcel$export(module.exports, "aiAnswersEntryPoint", () => $a4434f7c7bc24d2f$export$5dcf9a7e1076ac6);

var $dBV63 = parcelRequire("dBV63");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $a4434f7c7bc24d2f$export$5dcf9a7e1076ac6 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        if (!false) return (parcelRequire("eR4kL"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "b474af7a"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $dBV63.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("dBV63", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b39bedd89e67c64$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<228f2239cbae33d00d8e63897f96750c>>
 * @relayHash b317a486cf818716fa955809174baed6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID aecb078bb42ac99789f2aa91d508e1d81d4288e8ceb828b1c9f3c03242f8f76f

var $7oHmH = parcelRequire("7oHmH");

var $eiowN = parcelRequire("eiowN");
const $8b39bedd89e67c64$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v2 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v3 = [
        v2 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = [
        v2 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = [
        v8 /*: any*/ 
    ], v10 = [
        {
            "kind": "ScalarField",
            "name": "isAiEnabledInAdminHub"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "srcVirtualAgentAiAnswersQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "virtualAgentPageWrapper_servicedeskSettingsVirtualAgentCommon_projectRef"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "virtualAgentConfiguration",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "ui_servicedeskSettingsVirtualAgentAiAnswers_VirtualAgentAiAnswers_virtualAgentConfiguration"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ui_servicedeskSettingsVirtualAgentAiAnswers_VirtualAgentAiAnswers_jiraProjectRef"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "VirtualAgentQueryApi",
                        "kind": "LinkedField",
                        "name": "virtualAgent",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "VirtualAgentFeatures",
                                    "kind": "LinkedField",
                                    "name": "virtualAgentEntitlements",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ui_servicedeskSettingsVirtualAgentAiAnswers_VirtualAgentAiAnswers_virtualAgentFeatures"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "virtualAgent.virtualAgentEntitlements"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "virtualAgent"
                },
                {
                    "args": v7 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "virtualAgentPageWrapper_servicedeskSettingsVirtualAgentCommon_featuresRef"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "srcVirtualAgentAiAnswersQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "virtualAgentConfiguration",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isAiResponsesEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "defaultJiraRequestTypeId"
                                                }
                                            ],
                                            "type": "VirtualAgentConfiguration"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v9 /*: any*/ ,
                                            "type": "VirtualAgentQueryError"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v9 /*: any*/ ,
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                },
                                v4 /*: any*/ ,
                                {
                                    "args": v7 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "knowledgeBaseArticlesCount",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "count"
                                                }
                                            ],
                                            "type": "KnowledgeBaseArticleCountSource"
                                        }
                                    ]
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "VirtualAgentQueryApi",
                    "kind": "LinkedField",
                    "name": "virtualAgent",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "VirtualAgentFeatures",
                            "kind": "LinkedField",
                            "name": "virtualAgentEntitlements",
                            "plural": false,
                            "selections": v10 /*: any*/ 
                        }
                    ]
                },
                {
                    "concreteType": "VirtualAgentQueryApi",
                    "kind": "LinkedField",
                    "name": "virtualAgent",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "VirtualAgentFeatures",
                            "kind": "LinkedField",
                            "name": "virtualAgentEntitlements",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isVirtualAgentAvailable"
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": v10 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "aecb078bb42ac99789f2aa91d508e1d81d4288e8ceb828b1c9f3c03242f8f76f",
            "metadata": {},
            "name": "srcVirtualAgentAiAnswersQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $7oHmH.default)
            }
        }
    };
}();
$8b39bedd89e67c64$var$node.hash = "19529bb28005c693e530427ab6ca9cc6";
(0, $eiowN.PreloadableQueryRegistry).set($8b39bedd89e67c64$var$node.params.id, $8b39bedd89e67c64$var$node);
var $8b39bedd89e67c64$export$2e2bcd8739ae039 = $8b39bedd89e67c64$var$node;

});

parcelRegister("eR4kL", function(module, exports) {

let $ad09608848544a8f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ad09608848544a8f$var$load("cz9Ah").then(()=>parcelRequire('64AA8'));

});



parcelRegister("eAlzO", function(module, exports) {

$parcel$export(module.exports, "browseConversationsRouteEntry", () => $88c89130df57850c$export$b81210c1c5fc2e86);

var $c04PQ = parcelRequire("c04PQ");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $gvZrS = parcelRequire("gvZrS");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $cOR6Z = parcelRequire("cOR6Z");

var $2IBFQ = parcelRequire("2IBFQ");

var $lkFvK = parcelRequire("lkFvK");

var $k6R7C = parcelRequire("k6R7C");
const $88c89130df57850c$var$browseConversationsPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $2IBFQ.browseConversationsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $88c89130df57850c$export$b81210c1c5fc2e86 = (0, $7NszV.createEntry)((0, $gvZrS.browseConversationsRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $c04PQ.isFedRamp)()) return undefined;
            return $88c89130df57850c$var$browseConversationsPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $k6R7C.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $cOR6Z.VirtualAgentBrowseConversationsSkeleton),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_BROWSE_CONVERSATIONS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_BROWSE_CONVERSATIONS),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("gvZrS", function(module, exports) {

$parcel$export(module.exports, "browseConversationsRoute", () => $3541a643aa509b4d$export$c8ff4cf64e5540ec);
const $3541a643aa509b4d$export$c8ff4cf64e5540ec = {
    name: 'project-settings-servicedesk-virtualagent-browseconversations',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/conversations'
};

});

parcelRegister("cOR6Z", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentBrowseConversationsSkeleton", () => $93c172d4ef4f57d3$export$4a6267fad85ca589);
/* VirtualAgentBrowseConversationsSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $94zcy = parcelRequire("94zcy");
const $93c172d4ef4f57d3$var$customStyles = null;
const $93c172d4ef4f57d3$export$4a6267fad85ca589 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($94zcy))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("94zcy", function(module, exports) {
module.exports = new URL("virtual-agent-browse-conversations-app-skeleton.tpl.9f030add.svg", import.meta.url).toString();

});


parcelRegister("2IBFQ", function(module, exports) {

$parcel$export(module.exports, "browseConversationsEntryPoint", () => $d5456be03cb88be5$export$38549013d5d5a440);

var $iAqTc = parcelRequire("iAqTc");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");
const $d5456be03cb88be5$var$DEFAULT_RANGE_DAYS = 14;

const $d5456be03cb88be5$export$38549013d5d5a440 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        if (!false) return (parcelRequire("774VO"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "1bf85952"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const end = new Date();
        const start = new Date(end);
        start.setDate(start.getDate() - $d5456be03cb88be5$var$DEFAULT_RANGE_DAYS);
        return {
            extraProps: {
                initialDateRange: {
                    start: start,
                    end: end
                }
            },
            queries: {
                page: {
                    parameters: (0, $iAqTc.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey?.toUpperCase() ?? '',
                        startDate: start.toISOString(),
                        endDate: end.toISOString()
                    }
                }
            }
        };
    }
});

});
parcelRegister("iAqTc", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a4522a333dd4135$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<283ed4f377b201f98d14321a82b83de5>>
 * @relayHash 02e143cfdd95667a01d51463a678a48c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 19a45252d433996c267e9e919b0907677c72d7ab779a1d8cf1a338ce162c39ae

var $d4rfp = parcelRequire("d4rfp");

var $7oHmH = parcelRequire("7oHmH");
const $6a4522a333dd4135$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "19a45252d433996c267e9e919b0907677c72d7ab779a1d8cf1a338ce162c39ae",
        "metadata": {},
        "name": "srcVirtualAgentBrowseConversationsQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcisconversationfilterenabledrelayprovider": (0, $d4rfp.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $7oHmH.default)
        }
    }
};
var $6a4522a333dd4135$export$2e2bcd8739ae039 = $6a4522a333dd4135$var$node;

});
parcelRegister("d4rfp", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b78ba3d71d6b015$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $2b78ba3d71d6b015$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('expose_channels_on_va_conversation_history');
    }
};

});


parcelRegister("774VO", function(module, exports) {

let $52dd031c98259e0c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $52dd031c98259e0c$var$load("cJYN0").then(()=>parcelRequire('azR8x'));

});



parcelRegister("3KtPD", function(module, exports) {

$parcel$export(module.exports, "browseIntentsRouteEntry", () => $4f05bc6eb45d46da$export$da5f3658bd3ecdde);

var $c04PQ = parcelRequire("c04PQ");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6oHoX = parcelRequire("6oHoX");

var $e9YVH = parcelRequire("e9YVH");

var $lgNzP = parcelRequire("lgNzP");

var $aAhML = parcelRequire("aAhML");

var $lkFvK = parcelRequire("lkFvK");

var $cNMs5 = parcelRequire("cNMs5");

var $k6R7C = parcelRequire("k6R7C");
const $4f05bc6eb45d46da$var$browseIntentsPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $cNMs5.browseIntentsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $4f05bc6eb45d46da$export$da5f3658bd3ecdde = (0, $7NszV.createEntry)((0, $6oHoX.browseIntentsRoute), ()=>({
        group: 'project-settings-servicedesk',
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $c04PQ.isFedRamp)()) return undefined;
            return $4f05bc6eb45d46da$var$browseIntentsPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $k6R7C.FedRAMPFallbackRedirectToProjectSettings),
        layout: (0, $lgNzP.browseIntentsLayout),
        skeleton: (0, $aAhML.VirtualAgentBrowseIntentsSkeleton),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_BROWSE_INTENTS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_BROWSE_INTENTS),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("6oHoX", function(module, exports) {

$parcel$export(module.exports, "browseIntentsRoute", () => $2004c35d63b7590d$export$3e227412713bc57f);
const $2004c35d63b7590d$export$3e227412713bc57f = {
    name: 'project-settings-servicedesk-virtualagent-browse-intents',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/intents'
};

});

parcelRegister("lgNzP", function(module, exports) {

$parcel$export(module.exports, "browseIntentsLayout", () => $3f16128d6d3a9eb8$export$6659f41b213bad05);

var $2vSU6 = parcelRequire("2vSU6");

var $aPfsS = parcelRequire("aPfsS");

var $6Z2mh = parcelRequire("6Z2mh");

var $epSYp = parcelRequire("epSYp");
// TODO Remove this whenever all service project route paths are no longer ambiguous
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3f16128d6d3a9eb8$var$withServiceProjectContext = (Component)=>(0, $aPfsS.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $2vSU6.SERVICE_DESK_PROJECT)
        }
    });
const $3f16128d6d3a9eb8$export$6659f41b213bad05 = (0, $aPfsS.composeLayouts)((0, $6Z2mh.serviceProjectLayout), {
    rightSidebars: [
        $3f16128d6d3a9eb8$var$withServiceProjectContext((0, $epSYp.default))
    ]
});

});
parcelRegister("epSYp", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdb5ff159e084339$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $hsmeR = parcelRequire("hsmeR");

var $dAfqg = parcelRequire("dAfqg");

var $iwtyI = parcelRequire("iwtyI");

var $av9sZ = parcelRequire("av9sZ");

var $Y6PAl = parcelRequire("Y6PAl");

var $koeKL = parcelRequire("koeKL");

var $4R6GH = parcelRequire("4R6GH");
const $cdb5ff159e084339$var$runtimeProps = {};
const $cdb5ff159e084339$export$36ad24b9ac79bdc8 = ()=>{
    const rightSidebarCurrentState = (0, $hsmeR.useActiveRightSidebarState)();
    const panelId = rightSidebarCurrentState?.panelId ?? '';
    const cloudId = (0, $koeKL.useCloudId)();
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            key: projectContextData?.projectKey ?? '',
            isHideIntentDiscoveryWhenVaNotConfiguredEnabled: (0, $4R6GH.fg)('hide_intent_discovery_copy_when_va_not_configured')
        }), [
        cloudId,
        projectContextData
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $iwtyI.virtualAgentCreateIntentTemplateSidebarEntryPoint), entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (panelId === 'intentTemplate') entryPointActions.load();
        else entryPointActions.unload();
    }, [
        entryPointActions,
        panelId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "createIntentTemplatesSidebar",
        packageName: "jiraServicedeskSettingsVirtualAgentCreateIntentTemplates",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Y6PAl.VirtualAgentIntentTemplateSidebarSkeleton), null),
        errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cdb5ff159e084339$var$SideBarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $av9sZ.ErrorDisplay), {
                refetch: ()=>window.location.reload()
            })),
        runtimeProps: $cdb5ff159e084339$var$runtimeProps
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $cdb5ff159e084339$var$SideBarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1kl7udwz _1e0c1txw _2lx21bp4 _bfhk1bhr _vchhusvi _1p57u2gc _4t3i1osq _18m91wug",
            __cmplp.className
        ])
    });
});
var $cdb5ff159e084339$export$2e2bcd8739ae039 = $cdb5ff159e084339$export$36ad24b9ac79bdc8;

});
parcelRegister("iwtyI", function(module, exports) {

$parcel$export(module.exports, "virtualAgentCreateIntentTemplateSidebarEntryPoint", () => $6713c6429155461a$export$2b1d9dc27ee42f8f);

var $aHrkz = parcelRequire("aHrkz");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $6713c6429155461a$export$2b1d9dc27ee42f8f = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("eFhzq")), {
        moduleId: "a4e9afeb"
    }),
    getPreloadProps: ({ cloudId: cloudId, key: key, isHideIntentDiscoveryWhenVaNotConfiguredEnabled: isHideIntentDiscoveryWhenVaNotConfiguredEnabled })=>({
            queries: {
                intentTemplateQueryReference: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: (0, $aHrkz.default),
                    variables: {
                        cloudId: cloudId,
                        key: key,
                        isHideIntentDiscoveryWhenVaNotConfiguredEnabled: isHideIntentDiscoveryWhenVaNotConfiguredEnabled
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        })
});

});
parcelRegister("aHrkz", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2036dd19a3f68c8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<68ca1ff3c625c48e3b3f34fcd3122e1a>>
 * @relayHash c3ecae5efac1725022957b3584c6748a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d816bb1396041500986a655dbca037f2dba1138371158641897ea361c6ff7286
const $e2036dd19a3f68c8$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "d816bb1396041500986a655dbca037f2dba1138371158641897ea361c6ff7286",
        "metadata": {},
        "name": "uiVirtualAgentIntentTemplatesQuery",
        "operationKind": "query",
        "text": null
    }
};
var $e2036dd19a3f68c8$export$2e2bcd8739ae039 = $e2036dd19a3f68c8$var$node;

});

parcelRegister("eFhzq", function(module, exports) {

let $aad28621c1d0e796$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $aad28621c1d0e796$var$load("fliVL"),
    $aad28621c1d0e796$var$load("5jwWH")
]).then(()=>parcelRequire('dMvBS'));

});


parcelRegister("av9sZ", function(module, exports) {

$parcel$export(module.exports, "ErrorDisplay", () => $09828373404eee09$export$d56b0569bceb92ae);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $hTEpF = parcelRequire("hTEpF");

var $7q5TP = parcelRequire("7q5TP");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $2zwTA = parcelRequire("2zwTA");
const $09828373404eee09$export$d56b0569bceb92ae = ({ refetch: refetch })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: formatMessage((0, $2zwTA.default).errorDisplayHeading),
        description: formatMessage((0, $2zwTA.default).errorDisplayDescription),
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $7q5TP.default)),
        imageWidth: 160,
        maxImageHeight: 220,
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            onClick: refetch,
            appearance: "link"
        }, formatMessage((0, $2zwTA.default).reloadNowButtonText))
    });
};

});
parcelRegister("iVgQf", function(module, exports) {

$parcel$export(module.exports, "getAkEmptyStateRenderImageFn", () => $7affac5c7e698fc8$export$ebf64b9217c1b2a3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $4Bpvs = parcelRequire("4Bpvs");
function $7affac5c7e698fc8$export$ebf64b9217c1b2a3(JiraIllustration = (0, $4Bpvs.default)) {
    return ({ maxImageWidth: // we strictly follow EmptyState's defaults
    maxImageWidth = 160, maxImageHeight: maxImageHeight = 160, imageWidth: imageWidth, imageHeight: imageHeight })=>{
        // This wrapper emulates EmptyState's private "HeaderImage" styling
        // @see platform/packages/design-system/empty-state/src/empty-state.tsx
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
        const Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
                ...__cmplp,
                style: {
                    ...__cmpls,
                    "--_yv3y2x": (0, $lD23V.default)(maxImageWidth, "px"),
                    "--_nq7wev": (0, $lD23V.default)(maxImageHeight, "px")
                },
                ref: __cmplr,
                className: (0, $bwpsq.default)([
                    "_1e0c1ule _p12f1x6a _c71lc3ce _19pkidpf _2hwx1wug _otyr1ejb _18u01wug",
                    __cmplp.className
                ])
            });
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(JiraIllustration, {
            alt: "",
            role: "presentation",
            width: imageWidth || 'auto',
            height: imageHeight || 'auto'
        }));
    };
}

});
parcelRegister("4Bpvs", function(module, exports) {

$parcel$export(module.exports, "default", () => $029e22a35a3f42f7$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("gZXfK")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("ieXL6")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = tgxxcm73mk6phg9ttfj3rvpf
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/tgxxcm73mk6phg9ttfj3rvpf

var $dCLgq = parcelRequire("dCLgq");

var $ieXL6 = parcelRequire("ieXL6");

var $gZXfK = parcelRequire("gZXfK");
const $029e22a35a3f42f7$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($gZXfK)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($ieXL6))
});
var $029e22a35a3f42f7$export$2e2bcd8739ae039 = $029e22a35a3f42f7$var$Illustration;
// for advanced use only
const $029e22a35a3f42f7$export$a179c88182cb9d56 = [
    0,
    0,
    235,
    210
];

});
parcelRegister("ieXL6", function(module, exports) {
module.exports = new URL("generic-empty-state-darkmode.27f5dcf1.svg", import.meta.url).toString();

});

parcelRegister("gZXfK", function(module, exports) {
module.exports = new URL("generic-empty-state.1b007192.svg", import.meta.url).toString();

});



parcelRegister("2zwTA", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2ecc7c5e37557c1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b2ecc7c5e37557c1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorDisplayHeading: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.error-display-heading",
        "defaultMessage": "We couldn\u2019t load intent templates"
    },
    errorDisplayDescription: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.error-display-description",
        "defaultMessage": "Wait a moment and then try reloading."
    },
    reloadNowButtonText: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.reload-now-button-text",
        "defaultMessage": "Reload"
    }
});

});


parcelRegister("Y6PAl", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentIntentTemplateSidebarSkeleton", () => $61dfebc80ff570f9$export$fa68b26760d5b66f);
/* VirtualAgentIntentTemplateSidebarSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $o7aiq = parcelRequire("o7aiq");
const $61dfebc80ff570f9$var$customCssStyles = null;
const $61dfebc80ff570f9$export$fa68b26760d5b66f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($o7aiq))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("o7aiq", function(module, exports) {
module.exports = new URL("virtual-agent-intent-template-sidebar-app-skeleton.tpl.e2ff8557.svg", import.meta.url).toString();

});




parcelRegister("aAhML", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentBrowseIntentsSkeleton", () => $47ee42028be217a3$export$444026e4d4f156e4);
$parcel$export(module.exports, "VirtualAgentIntentsTableSkeleton", () => $47ee42028be217a3$export$9dca41144a6398d2);
$parcel$export(module.exports, "VirtualAgentStatisticsSkeleton", () => $47ee42028be217a3$export$538762e63d6466fe);
/* VirtualAgentStatisticsSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $03lq1 = parcelRequire("03lq1");

var $drZ5P = parcelRequire("drZ5P");

var $aT0Jx = parcelRequire("aT0Jx");
const $47ee42028be217a3$var$customCssStyles = null;
const $47ee42028be217a3$export$444026e4d4f156e4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($03lq1))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });
const $47ee42028be217a3$export$9dca41144a6398d2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($drZ5P))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });
const $47ee42028be217a3$export$538762e63d6466fe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aT0Jx))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("03lq1", function(module, exports) {
module.exports = new URL("virtual-agent-browse-intents-app-skeleton.tpl.1eeb33c1.svg", import.meta.url).toString();

});

parcelRegister("drZ5P", function(module, exports) {
module.exports = new URL("virtual-agent-intents-table-app-skeleton.tpl.e28c55f7.svg", import.meta.url).toString();

});

parcelRegister("aT0Jx", function(module, exports) {
module.exports = new URL("virtual-agent-virtual-agent-statistics-app-skeleton.tpl.19ee5056.svg", import.meta.url).toString();

});


parcelRegister("cNMs5", function(module, exports) {

$parcel$export(module.exports, "browseIntentsEntryPoint", () => $0c1a3d6ae6de7f87$export$f19c213ae2d7940f);

var $2VZl9 = parcelRequire("2VZl9");

var $ae5pE = parcelRequire("ae5pE");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");
// When changing the default time range, make sure to also update jira/src/packages/servicedesk/virtual-agent/intents/browse-intents/src/ui/index.tsx
const $0c1a3d6ae6de7f87$var$DEFAULT_TIME_RANGE_MS = 604800000; // 7 days
const $0c1a3d6ae6de7f87$var$formatFetchDate = (date)=>date.toISOString().substring(0, 10);

const $0c1a3d6ae6de7f87$export$f19c213ae2d7940f = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        if (!false) return (parcelRequire("81aUU"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "85089c8d"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $2VZl9.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? ''
                    }
                },
                statistics: {
                    parameters: (0, $ae5pE.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        startDate: $0c1a3d6ae6de7f87$var$formatFetchDate(new Date(Date.now() - $0c1a3d6ae6de7f87$var$DEFAULT_TIME_RANGE_MS)),
                        endDate: $0c1a3d6ae6de7f87$var$formatFetchDate(new Date())
                    }
                }
            }
        })
});

});
parcelRegister("2VZl9", function(module, exports) {

$parcel$export(module.exports, "default", () => $84af76b2b1eda3ac$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7105edf9aae2aeef1c7b59025bb3dc43>>
 * @relayHash 4bac1615e82872f14af087aea0c24eec
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9c78a8df256cb6fcc8ae46128e3f3df44276e163eaf33d34c44bae27d3f029f9

var $7oHmH = parcelRequire("7oHmH");
const $84af76b2b1eda3ac$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "9c78a8df256cb6fcc8ae46128e3f3df44276e163eaf33d34c44bae27d3f029f9",
        "metadata": {},
        "name": "srcVirtualAgentBrowseIntentsQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $7oHmH.default)
        }
    }
};
var $84af76b2b1eda3ac$export$2e2bcd8739ae039 = $84af76b2b1eda3ac$var$node;

});

parcelRegister("ae5pE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3c21345417f9f8e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<395921d3b6d5df1359bfb1e69525039b>>
 * @relayHash 69cb5f9caba0c34421b46432dab7aab3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8abb8537c761c00bfeea5c6b03b1f395a0c5ed38f2ec729a915f7f365f5a2fe2

var $2LxWa = parcelRequire("2LxWa");
const $d3c21345417f9f8e$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "8abb8537c761c00bfeea5c6b03b1f395a0c5ed38f2ec729a915f7f365f5a2fe2",
        "metadata": {},
        "name": "srcVirtualAgentBrowseIntentsStatisticsQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaenableperformancepagerelayprovider": (0, $2LxWa.default)
        }
    }
};
var $d3c21345417f9f8e$export$2e2bcd8739ae039 = $d3c21345417f9f8e$var$node;

});
parcelRegister("2LxWa", function(module, exports) {

$parcel$export(module.exports, "default", () => $5892cca023449b49$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $5892cca023449b49$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jsm_va_enable_performance_page');
    }
};

});


parcelRegister("81aUU", function(module, exports) {

let $5d66e297400a54e2$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $5d66e297400a54e2$var$load("ffQaD"),
    $5d66e297400a54e2$var$load("kvRbA"),
    $5d66e297400a54e2$var$load("54Upu")
]).then(()=>parcelRequire('9r2hQ'));

});



parcelRegister("h3WYk", function(module, exports) {

$parcel$export(module.exports, "browseStandardFlowsRouteEntry", () => $f631f32c4725afe5$export$6a572c5bc9ffe9da);

var $c04PQ = parcelRequire("c04PQ");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $1r8X1 = parcelRequire("1r8X1");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $dhfPL = parcelRequire("dhfPL");

var $8HI9m = parcelRequire("8HI9m");

var $lkFvK = parcelRequire("lkFvK");

var $k6R7C = parcelRequire("k6R7C");
const $f631f32c4725afe5$var$browseStandardFlowsPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $8HI9m.browseStandardFlowsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $f631f32c4725afe5$export$6a572c5bc9ffe9da = (0, $7NszV.createEntry)((0, $1r8X1.browseStandardFlowsRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $c04PQ.isFedRamp)()) return undefined;
            return $f631f32c4725afe5$var$browseStandardFlowsPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $k6R7C.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $dhfPL.VirtualAgentBrowseStandardFlowsSkeleton),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("1r8X1", function(module, exports) {

$parcel$export(module.exports, "browseStandardFlowsRoute", () => $929ca13d8a48533c$export$fd091ba8fa858397);
const $929ca13d8a48533c$export$fd091ba8fa858397 = {
    name: 'project-settings-servicedesk-virtualagent-standard-flows',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/standard-flows'
};

});

parcelRegister("dhfPL", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentBrowseStandardFlowsSkeleton", () => $42ac2f7c560a8df6$export$c2bd83dd149452bd);
/* VirtualAgentBrowseStandardFlowsSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $l6Vlb = parcelRequire("l6Vlb");
const $42ac2f7c560a8df6$var$customCssStyles = null;
const $42ac2f7c560a8df6$export$c2bd83dd149452bd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($l6Vlb))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("l6Vlb", function(module, exports) {
module.exports = new URL("virtual-agent-browse-standard-flows-app-skeleton.tpl.51e6e95a.svg", import.meta.url).toString();

});


parcelRegister("8HI9m", function(module, exports) {

$parcel$export(module.exports, "browseStandardFlowsEntryPoint", () => $32e48f8946c41f01$export$f7de8593c7455f1);

var $iARRY = parcelRequire("iARRY");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $32e48f8946c41f01$export$f7de8593c7455f1 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        if (!false) return (parcelRequire("csU99"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "c2d13204"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $iARRY.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey?.toUpperCase() ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("iARRY", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e33e127e8847987$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<33233bbde56426b21cb0cf7548a863c8>>
 * @relayHash 8658a1d9e0b503030f122af7546f7fa3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b2740e61056af93841794a91099e9b96903f93d7fe50bb2475c769a63f9f5288

var $7oHmH = parcelRequire("7oHmH");
const $4e33e127e8847987$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "b2740e61056af93841794a91099e9b96903f93d7fe50bb2475c769a63f9f5288",
        "metadata": {},
        "name": "srcVirtualAgentBrowseStandardFlowsQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $7oHmH.default)
        }
    }
};
var $4e33e127e8847987$export$2e2bcd8739ae039 = $4e33e127e8847987$var$node;

});

parcelRegister("csU99", function(module, exports) {

let $9133a720fb97f7fc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9133a720fb97f7fc$var$load("afT8l").then(()=>parcelRequire('exMWS'));

});



parcelRegister("gjuAo", function(module, exports) {

$parcel$export(module.exports, "performanceRouteEntry", () => $8e362f7bda5bcefa$export$3f75a1735cbe5a04);

var $c04PQ = parcelRequire("c04PQ");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $eIj3W = parcelRequire("eIj3W");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $lkFvK = parcelRequire("lkFvK");

var $9aT1E = parcelRequire("9aT1E");

var $k6R7C = parcelRequire("k6R7C");
const $8e362f7bda5bcefa$var$performancePageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $9aT1E.performanceEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $8e362f7bda5bcefa$export$3f75a1735cbe5a04 = (0, $7NszV.createEntry)((0, $eIj3W.performanceRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $c04PQ.isFedRamp)()) return undefined;
            return $8e362f7bda5bcefa$var$performancePageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $k6R7C.FedRAMPFallbackRedirectToProjectSettings),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_PERFORMANCE,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_PERFORMANCE),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("eIj3W", function(module, exports) {

$parcel$export(module.exports, "performanceRoute", () => $a08dee66d983407c$export$d867623f05adedb3);
const $a08dee66d983407c$export$d867623f05adedb3 = {
    name: 'project-settings-servicedesk-virtualagent-performance',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/performance'
};

});

parcelRegister("9aT1E", function(module, exports) {

$parcel$export(module.exports, "performanceEntryPoint", () => $94968a7dbb3de852$export$52b48527e9315b46);

var $jvgzC = parcelRequire("jvgzC");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");
const $94968a7dbb3de852$var$DEFAULT_TIME_RANGE_MS = 604800000; // 7 days
const $94968a7dbb3de852$var$formatFetchDate = (date)=>date.toISOString().substring(0, 10); // has to be truncated for proper caching in SSR

const $94968a7dbb3de852$export$52b48527e9315b46 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        if (!false) return (parcelRequire("jp4pR"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "25efd1aa"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $jvgzC.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey?.toUpperCase() ?? '',
                        startDate: $94968a7dbb3de852$var$formatFetchDate(new Date(Date.now() - $94968a7dbb3de852$var$DEFAULT_TIME_RANGE_MS)),
                        endDate: $94968a7dbb3de852$var$formatFetchDate(new Date())
                    }
                }
            }
        })
});

});
parcelRegister("jvgzC", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c3ef32003964182$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<76721ba6a3573d4ac3a4c72bcf24cbe6>>
 * @relayHash d2dd4e499cfb1a7bc701404004535b12
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b2b4bda1a29f259ba4baad02fe02da8212f7e68bc8f498de77f8f7d360ae16a7

var $7oHmH = parcelRequire("7oHmH");

var $gnNIl = parcelRequire("gnNIl");

var $5INZt = parcelRequire("5INZt");
const $7c3ef32003964182$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "b2b4bda1a29f259ba4baad02fe02da8212f7e68bc8f498de77f8f7d360ae16a7",
        "metadata": {},
        "name": "srcVirtualAgentPerformanceQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvastatusheaderrelayprovider": (0, $gnNIl.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcvsaadoptionstage1relayprovider": (0, $5INZt.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $7oHmH.default)
        }
    }
};
var $7c3ef32003964182$export$2e2bcd8739ae039 = $7c3ef32003964182$var$node;

});

parcelRegister("jp4pR", function(module, exports) {

let $e203c717226b2324$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e203c717226b2324$var$load("3X7oq").then(()=>parcelRequire('6G1GD'));

});



parcelRegister("9z1Wd", function(module, exports) {

$parcel$export(module.exports, "settingsRouteEntry", () => $1a59cf2a3db44036$export$1d28e19560927106);

var $c04PQ = parcelRequire("c04PQ");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $H5kLJ = parcelRequire("H5kLJ");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $7g2py = parcelRequire("7g2py");

var $lkFvK = parcelRequire("lkFvK");

var $7j28R = parcelRequire("7j28R");

var $k6R7C = parcelRequire("k6R7C");
const $1a59cf2a3db44036$var$settingsPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7j28R.settingsEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $1a59cf2a3db44036$export$1d28e19560927106 = (0, $7NszV.createEntry)((0, $H5kLJ.settingsRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $c04PQ.isFedRamp)()) return undefined;
            return $1a59cf2a3db44036$var$settingsPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $k6R7C.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $7g2py.VirtualAgentSettingsSkeleton),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_SETTINGS,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_SETTINGS),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("H5kLJ", function(module, exports) {

$parcel$export(module.exports, "settingsRoute", () => $b642a35d67793caf$export$847a7c378c11c645);
const $b642a35d67793caf$export$847a7c378c11c645 = {
    name: 'project-settings-servicedesk-virtualagent-settings',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/settings/:tab(basic|channels)?'
};

});

parcelRegister("7g2py", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentSettingsSkeleton", () => $d88dc21ec5f90208$export$429c43ddcb09c14c);
/* VirtualAgentSettingsSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $6mG7P = parcelRequire("6mG7P");
const $d88dc21ec5f90208$var$customCssStyles = null;
const $d88dc21ec5f90208$export$429c43ddcb09c14c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6mG7P))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("6mG7P", function(module, exports) {
module.exports = new URL("virtual-agent-settings-app-skeleton.tpl.1a9c03fe.svg", import.meta.url).toString();

});


parcelRegister("7j28R", function(module, exports) {

$parcel$export(module.exports, "settingsEntryPoint", () => $a9827913d0401124$export$d34e7816b7ac181a);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $1I4lD = parcelRequire("1I4lD");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $aOzLh = parcelRequire("aOzLh");

const $a9827913d0401124$export$d34e7816b7ac181a = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(0, $aOzLh.clientSideOnly)((parcelRequire("e5yLU"))), {
        moduleId: "ed4de71b"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $1I4lD.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey?.toUpperCase() ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("1I4lD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a14dfc5f3ce71c58$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6a8b54dff6bd67d9f566bb4eac1d257a>>
 * @relayHash 7189bee0c97cc09b10f8e1589368c2de
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 392629a596a95c19575393c3c0047883914bb7cb4d8de01d923e7684c2f31d13

var $y2RTb = parcelRequire("y2RTb");

var $7oHmH = parcelRequire("7oHmH");

var $gnNIl = parcelRequire("gnNIl");
const $a14dfc5f3ce71c58$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "392629a596a95c19575393c3c0047883914bb7cb4d8de01d923e7684c2f31d13",
        "metadata": {},
        "name": "srcVirtualAgentSettingsQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaenableaianswerspagerelayprovider": (0, $y2RTb.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvastatusheaderrelayprovider": (0, $gnNIl.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $7oHmH.default)
        }
    }
};
var $a14dfc5f3ce71c58$export$2e2bcd8739ae039 = $a14dfc5f3ce71c58$var$node;

});
parcelRegister("y2RTb", function(module, exports) {

$parcel$export(module.exports, "default", () => $610656e9d6041bd2$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $610656e9d6041bd2$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jsm_va_enable_ai_answers_page');
    }
};

});


parcelRegister("e5yLU", function(module, exports) {

let $a41c8144c3124c57$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a41c8144c3124c57$var$load("atgSj").then(()=>parcelRequire('byLJY'));

});



parcelRegister("6fHM1", function(module, exports) {

$parcel$export(module.exports, "viewIntentRouteEntry", () => $29a776b5b5594505$export$e693459ab8454027);

var $c04PQ = parcelRequire("c04PQ");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $88KkK = parcelRequire("88KkK");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $l4VHA = parcelRequire("l4VHA");

var $lSSsm = parcelRequire("lSSsm");

var $lkFvK = parcelRequire("lkFvK");

var $k6R7C = parcelRequire("k6R7C");
const $29a776b5b5594505$var$viewIntentPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $lSSsm.viewIntentEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $29a776b5b5594505$export$e693459ab8454027 = (0, $7NszV.createEntry)((0, $88KkK.viewIntentRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $c04PQ.isFedRamp)()) return undefined;
            return $29a776b5b5594505$var$viewIntentPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $k6R7C.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $l4VHA.VirtualAgentViewIntentSkeleton),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_VIEW_INTENT,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_VIEW_INTENT),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("88KkK", function(module, exports) {

$parcel$export(module.exports, "viewIntentRoute", () => $aecf60273505ed2c$export$bf8131fb060d0e73);
const $aecf60273505ed2c$export$bf8131fb060d0e73 = {
    name: 'project-settings-servicedesk-virtualagent-view-intent',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/intents/:intentId/:tab(flow|training|settings)?'
};

});

parcelRegister("l4VHA", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentViewIntentSkeleton", () => $3817d32b8c9a6704$export$72b20c10a0f18a2f);
/* VirtualAgentViewIntentSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $jJwsA = parcelRequire("jJwsA");
const $3817d32b8c9a6704$var$customCssStyles = null;
const $3817d32b8c9a6704$export$72b20c10a0f18a2f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jJwsA))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("jJwsA", function(module, exports) {
module.exports = new URL("virtual-agent-view-intent-app-skeleton.tpl.5dd31cbb.svg", import.meta.url).toString();

});


parcelRegister("lSSsm", function(module, exports) {

$parcel$export(module.exports, "viewIntentEntryPoint", () => $ac6810a67c998d50$export$f51df662bd71ce39);

var $iD8EQ = parcelRequire("iD8EQ");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $ac6810a67c998d50$export$f51df662bd71ce39 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        if (!false) return (parcelRequire("4rg7F"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "bc04de30"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $iD8EQ.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        intentId: context.match.params.intentId ?? ''
                    }
                }
            }
        })
});

});
parcelRegister("iD8EQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $45ed8bfdfee83271$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dedde06316e2afe5acc862762a93f4dd>>
 * @relayHash cb914e8d2219b7f49741872ae7f6d037
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a770411d52534005c4d94e2f61c74a98ed117522669e7af7701400ccbf2323f3

var $7oHmH = parcelRequire("7oHmH");
const $45ed8bfdfee83271$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a770411d52534005c4d94e2f61c74a98ed117522669e7af7701400ccbf2323f3",
        "metadata": {},
        "name": "srcVirtualAgentViewIntentQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $7oHmH.default)
        }
    }
};
var $45ed8bfdfee83271$export$2e2bcd8739ae039 = $45ed8bfdfee83271$var$node;

});

parcelRegister("4rg7F", function(module, exports) {

let $33b630acf5d0cc15$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $33b630acf5d0cc15$var$load("ffQaD"),
    $33b630acf5d0cc15$var$load("kvRbA"),
    $33b630acf5d0cc15$var$load("lMMew")
]).then(()=>parcelRequire('01RYz'));

});



parcelRegister("1GAqb", function(module, exports) {

$parcel$export(module.exports, "viewStandardFlowRouteEntry", () => $af4aef3a07273742$export$84dc2dfc944b0434);

var $c04PQ = parcelRequire("c04PQ");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $iU5fA = parcelRequire("iU5fA");

var $6Z2mh = parcelRequire("6Z2mh");

var $e9YVH = parcelRequire("e9YVH");

var $blYux = parcelRequire("blYux");

var $lkFvK = parcelRequire("lkFvK");

var $hFluH = parcelRequire("hFluH");

var $k6R7C = parcelRequire("k6R7C");
const $af4aef3a07273742$var$viewStandardFlowPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $hFluH.viewStandardFlowEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $af4aef3a07273742$export$84dc2dfc944b0434 = (0, $7NszV.createEntry)((0, $iU5fA.viewStandardFlowRoute), ()=>({
        group: 'project-settings-servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        entryPoint () {
            if ((0, $c04PQ.isFedRamp)()) return undefined;
            return $af4aef3a07273742$var$viewStandardFlowPageEntryPoint;
        },
        // this is only used when entryPoint() returns undefined, which is only the case in FedRAMP
        component: (0, $k6R7C.FedRAMPFallbackRedirectToProjectSettings),
        skeleton: (0, $blYux.VirtualAgentViewStandardFlowSkeleton),
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_VIEW_STANDARD_FLOW,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).VIRTUAL_AGENT_VIEW_STANDARD_FLOW),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }));

});
parcelRegister("iU5fA", function(module, exports) {

$parcel$export(module.exports, "viewStandardFlowRoute", () => $f47ba2070dd83bf9$export$c74dca8be49046ea);
const $f47ba2070dd83bf9$export$c74dca8be49046ea = {
    name: 'project-settings-servicedesk-virtualagent-view-standard-flow',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/standard-flows/:flowId/:tab(flow|settings)?'
};

});

parcelRegister("blYux", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentViewStandardFlowSkeleton", () => $cedc5dbef30f009d$export$c6d3f04e6931e3f6);
/* VirtualAgentViewStandardFlowSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $aVKJK = parcelRequire("aVKJK");
const $cedc5dbef30f009d$var$customCssStyles = null;
const $cedc5dbef30f009d$export$c6d3f04e6931e3f6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aVKJK))),
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("aVKJK", function(module, exports) {
module.exports = new URL("virtual-agent-view-standard-flow-app-skeleton.tpl.ec3b149b.svg", import.meta.url).toString();

});


parcelRegister("hFluH", function(module, exports) {

$parcel$export(module.exports, "viewStandardFlowEntryPoint", () => $8d05ca45dd1a7906$export$4fd7bf09308d4abd);

var $3sOht = parcelRequire("3sOht");

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $4R6GH = parcelRequire("4R6GH");

const $8d05ca45dd1a7906$export$4fd7bf09308d4abd = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        if (!false) return (parcelRequire("7SWG3"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "8e1cdfbd"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $3sOht.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        flowId: context.match.params.flowId ?? '',
                        offerEscalationEnabled: (0, $4R6GH.fg)('toggle_offer_escalation_standard_flow_feature') ?? false
                    }
                }
            }
        })
});

});
parcelRegister("3sOht", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bc956e6a804d466$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c672df7540026746c518fc6252bb9853>>
 * @relayHash 03d60ddb2ab7e66f9166484b433a6391
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID edf50ab9067bb9d2788c9b405debcf23a384aa2eb6e7a5692942760f437f397f

var $7oHmH = parcelRequire("7oHmH");
const $1bc956e6a804d466$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "edf50ab9067bb9d2788c9b405debcf23a384aa2eb6e7a5692942760f437f397f",
        "metadata": {},
        "name": "srcVirtualAgentViewStandardFlowQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $7oHmH.default)
        }
    }
};
var $1bc956e6a804d466$export$2e2bcd8739ae039 = $1bc956e6a804d466$var$node;

});

parcelRegister("7SWG3", function(module, exports) {

let $5bdb179eddb8ee92$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5bdb179eddb8ee92$var$load("gZKid").then(()=>parcelRequire('16gIP'));

});



parcelRegister("2ytxj", function(module, exports) {

$parcel$export(module.exports, "servicedeskWorkflowConfigRouteEntry", () => $37624069b0a267c0$export$212f7f79630d5adc);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $dxCvy = parcelRequire("dxCvy");

var $fpjJX = parcelRequire("fpjJX");

var $043ka = parcelRequire("043ka");

var $6Z2mh = parcelRequire("6Z2mh");

var $j3pH1 = parcelRequire("j3pH1");
const $37624069b0a267c0$var$workflowSchemeConfigPageEntrypoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $j3pH1.workflowSchemeConfigEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $37624069b0a267c0$export$212f7f79630d5adc = (0, $7NszV.createEntry)((0, $043ka.servicedeskWorkflowConfigRoute), ()=>({
        group: 'project-settings-servicedesk',
        entryPoint () {
            return $37624069b0a267c0$var$workflowSchemeConfigPageEntrypoint;
        },
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $dxCvy.projectContextResource)
        ],
        meta: {
            reporting: {
                id: 'project-settings.workflow-scheme-config',
                packageName: 'projectSettingsWorkflowSchemeConfig',
                teamName: 'jsd-shield'
            }
        },
        ufoName: 'project-settings-workflow-scheme-config'
    }));

});
parcelRegister("j3pH1", function(module, exports) {

$parcel$export(module.exports, "workflowSchemeConfigEntrypoint", () => $5e46ff6da5ce3455$export$12ccdf1d30de8ac);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $5e46ff6da5ce3455$export$12ccdf1d30de8ac = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        if (!false) return (parcelRequire("gvqVA"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "6be3e66b"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("gvqVA", function(module, exports) {

let $c0446de3009672ee$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c0446de3009672ee$var$load("8Zr88").then(()=>parcelRequire('3STzC'));

});



parcelRegister("7PtTb", function(module, exports) {

$parcel$export(module.exports, "softwareStaffingRouteEntry", () => $12bd43395964fa40$export$71a3a4cc27cbe00a);

var $g5RGc = parcelRequire("g5RGc");

var $fKmub = parcelRequire("fKmub");

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $koWFd = parcelRequire("koWFd");

var $7NszV = parcelRequire("7NszV");

var $aPfsS = parcelRequire("aPfsS");

var $3RJkv = parcelRequire("3RJkv");

var $6LsQE = parcelRequire("6LsQE");

var $dxCvy = parcelRequire("dxCvy");

var $jsFU4 = parcelRequire("jsFU4");

var $7GnDe = parcelRequire("7GnDe");

var $3svbL = parcelRequire("3svbL");

var $8STJR = parcelRequire("8STJR");

var $5f2bR = parcelRequire("5f2bR");

var $e7bC3 = parcelRequire("e7bC3");

var $4R6GH = parcelRequire("4R6GH");

var $1fXOB = parcelRequire("1fXOB");
const $12bd43395964fa40$export$71a3a4cc27cbe00a = (0, $7NszV.createEntry)((0, $3svbL.softwareStaffingRoute), ()=>({
        group: 'software',
        skeleton: (0, $8STJR.RoadmapSkeleton),
        layout: (0, $aPfsS.composeLayouts)((0, $e7bC3.softwareProjectLayout), (0, $g5RGc.embeddedIssuePreloadLayoutBuilder)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $koWFd.default),
            horizontal: (0, $5f2bR.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $jsFU4.nextGenRoadmapResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-roadmap-early-entry'
            ]
        },
        afterPaint: [
            (0, $fKmub.LazyIssueApp)
        ],
        entryPoint: ()=>(0, $4R6GH.fg)('staffing') ? (0, $1fXOB.staffingRouteEntrypoint) : (0, $6LsQE.notFoundPageEntrypoint),
        ufoName: 'next-gen-roadmap'
    }));

});
parcelRegister("3svbL", function(module, exports) {

$parcel$export(module.exports, "softwareStaffingRoute", () => $9bf480f2b06baa65$export$aa817709e0cb3b6d);
const $9bf480f2b06baa65$export$aa817709e0cb3b6d = {
    name: 'software-staffing',
    path: '/jira/software/projects/:projectKey/boards/:boardId/staffing',
    query: [
        'issueKey?'
    ]
};

});

parcelRegister("1fXOB", function(module, exports) {

$parcel$export(module.exports, "staffingRouteEntrypoint", () => $d9c937c27ede0b49$export$3a16ef365bcb8560);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $fo6b8 = parcelRequire("fo6b8");

var $ewQz2 = parcelRequire("ewQz2");
const $d9c937c27ede0b49$export$3a16ef365bcb8560 = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $ewQz2.staffingEntrypoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $fo6b8.jiraHorizontalNavEntrypoint)
});

});
parcelRegister("ewQz2", function(module, exports) {

$parcel$export(module.exports, "staffingEntrypoint", () => $1f62c1dd3ab84c1d$export$94a659cc78d2756a);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $1f62c1dd3ab84c1d$export$94a659cc78d2756a = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("7ON9V")), {
        moduleId: "39c7d120"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("7ON9V", function(module, exports) {

let $5b1355dddafe200a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5b1355dddafe200a$var$load("8Yg3F").then(()=>parcelRequire('g02gC'));

});




parcelRegister("8E1dI", function(module, exports) {

$parcel$export(module.exports, "cmpVelocityRouteEntry", () => $a27db4496b15726e$export$93315233fc25c1b4);

var $lmyls = parcelRequire("lmyls");

var $5bkvv = parcelRequire("5bkvv");

var $6zFAI = parcelRequire("6zFAI");

var $ggg5j = parcelRequire("ggg5j");

var $iEUaw = parcelRequire("iEUaw");

var $9s3j1 = parcelRequire("9s3j1");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $dxCvy = parcelRequire("dxCvy");

var $7GnDe = parcelRequire("7GnDe");

var $e7bC3 = parcelRequire("e7bC3");

var $jicqv = parcelRequire("jicqv");

var $fzG6k = parcelRequire("fzG6k");

var $yxwH0 = parcelRequire("yxwH0");
const $a27db4496b15726e$export$93315233fc25c1b4 = (0, $7NszV.createEntry)((0, $jicqv.cmpVelocityRoute), ()=>({
        group: 'software',
        ufoName: 'software-reports.velocity-report-cmp',
        layout: (0, $e7bC3.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $9s3j1.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $7GnDe.incidentExperimentTraitResource),
            (0, $dxCvy.projectContextResource),
            (0, $5bkvv.forgeProjectModuleResource),
            (0, $iEUaw.staticSidebarShortcutsResource),
            (0, $ggg5j.staticProjectSidebarNavigationResource),
            (0, $6zFAI.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $yxwH0.getTMPReportsCommonResource)()
        ],
        entryPoint: ()=>(0, $fzG6k.velocityReportPageEntrypoint)
    }));

});
parcelRegister("jicqv", function(module, exports) {

$parcel$export(module.exports, "cmpVelocityRoute", () => $a8cb7576e7ece3aa$export$1dfb0bd517ec7a8b);
const $a8cb7576e7ece3aa$export$1dfb0bd517ec7a8b = {
    name: 'software-reports-velocity-cmp',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/velocity'
};

});


parcelRegister("2yO8h", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesViewsConfigRouteEntry", () => $3766b33f9d299552$export$a5000d326f347afb);

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $bfOrv = parcelRequire("bfOrv");

var $6Z2mh = parcelRequire("6Z2mh");

var $dxCvy = parcelRequire("dxCvy");

var $4R6GH = parcelRequire("4R6GH");

var $5lsNZ = parcelRequire("5lsNZ");

var $ffza4 = parcelRequire("ffza4");

var $7XYc4 = parcelRequire("7XYc4");

var $lJ1FP = parcelRequire("lJ1FP");

var $iRITI = parcelRequire("iRITI");

var $e3Tce = parcelRequire("e3Tce");
const $3766b33f9d299552$export$a5000d326f347afb = (0, $7NszV.createEntry)((0, $bfOrv.servicedeskQueuesViewsConfigRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            ...(0, $fpjJX.getQueueViewConfigResource)(),
            (0, $lJ1FP.getEditModelResource)(),
            (0, $dxCvy.projectContextResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $e3Tce.LazyServicedeskQueuesViewsConfig)
        ],
        ufoName: 'service-management.views.config',
        component: (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $e3Tce.ServicedeskQueuesViewsConfig), (0, $5lsNZ.default)),
        pageId: ({ query: query, match: match })=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? `spa-apps/servicedesk/queues/views-config/${query.config}` : `spa-apps/servicedesk/queues/edit/${match.params && match.params.queueId || ''}`,
        entryPoint () {
            return (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $iRITI.serviceDeskQueuesConfigPageEntryPoint) : undefined;
        }
    }));

});
parcelRegister("bfOrv", function(module, exports) {

$parcel$export(module.exports, "servicedeskQueuesViewsConfigRoute", () => $a336f3ec9a74ea1c$export$eea17b09d67a7980);
const $a336f3ec9a74ea1c$export$eea17b09d67a7980 = {
    name: 'servicedesk-queues-views-config',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/edit/:boardId',
    query: [
        'config?'
    ],
    exact: true
};

});

parcelRegister("e3Tce", function(module, exports) {

$parcel$export(module.exports, "LazyServicedeskQueuesViewsConfig", () => $6daef49d48ee6ffb$export$12b9e920fc614605);
$parcel$export(module.exports, "ServicedeskQueuesViewsConfig", () => $6daef49d48ee6ffb$export$666845896df029ad);

var $5uXOq = parcelRequire("5uXOq");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $6daef49d48ee6ffb$export$12b9e920fc614605 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("gJHbn")), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-config/src/index.tsx"
});
const $6daef49d48ee6ffb$export$666845896df029ad = (props)=>{
    const { query: query } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $6daef49d48ee6ffb$export$12b9e920fc614605,
        pageId: `spa-apps/servicedesk/queues/views-config/${query.config}`,
        shouldShowSpinner: true
    });
};

});


parcelRegister("fEAJ2", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeViewsConfigRouteEntry", () => $f8d8209f3e843316$export$101c882abd4d051);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $SqPVy = parcelRequire("SqPVy");

var $6Z2mh = parcelRequire("6Z2mh");

var $dxCvy = parcelRequire("dxCvy");

var $4R6GH = parcelRequire("4R6GH");

var $5lsNZ = parcelRequire("5lsNZ");

var $7XYc4 = parcelRequire("7XYc4");

var $iRITI = parcelRequire("iRITI");

var $e3Tce = parcelRequire("e3Tce");
const $f8d8209f3e843316$export$101c882abd4d051 = (0, $7NszV.createEntry)((0, $SqPVy.servicedeskPracticeViewsConfigRoute), ()=>({
        group: 'servicedesk',
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default)
        },
        resources: [
            ...(0, $fpjJX.getQueuesResources)(),
            (0, $bHhiy.getConsolidationStateResource)(),
            ...(0, $fpjJX.getServiceDeskNavigationResources)(),
            ...(0, $fpjJX.getServicedeskPageContextResources)(),
            ...(0, $fpjJX.getQueueViewConfigResource)(),
            (0, $dxCvy.projectContextResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $e3Tce.LazyServicedeskQueuesViewsConfig)
        ],
        ufoName: 'service-management.views.config',
        component: (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag'), (0, $e3Tce.ServicedeskQueuesViewsConfig), (0, $5lsNZ.default)),
        pageId: ({ query: query, match: match })=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? `spa-apps/servicedesk/queues/views-config/${query.config}` : `spa-apps/servicedesk/queues/edit/${match.params && match.params.queueId || ''}`,
        entryPoint () {
            return (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $iRITI.serviceDeskQueuesConfigPageEntryPoint) : undefined;
        }
    }));

});
parcelRegister("SqPVy", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticeViewsConfigRoute", () => $7e4dd55084659e58$export$e8e807e90d20fe7b);
const $7e4dd55084659e58$export$e8e807e90d20fe7b = {
    name: 'servicedesk-practice-views-config',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/edit/:boardId',
    query: [
        'config'
    ],
    exact: true
};

});


parcelRegister("18W8Q", function(module, exports) {

$parcel$export(module.exports, "assetsSearchRouteEntry", () => $0e927da2b693a3df$export$2a3cf8cc5b9b7e6);

var $7NszV = parcelRequire("7NszV");

var $55ZOZ = parcelRequire("55ZOZ");

var $lkFvK = parcelRequire("lkFvK");

var $k7I8D = parcelRequire("k7I8D");

var $2NDia = parcelRequire("2NDia");

var $ck92c = parcelRequire("ck92c");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");
const $0e927da2b693a3df$var$assetsSearchPageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $ck92c.assetsSearchEntryPoint)
});
const $0e927da2b693a3df$export$2a3cf8cc5b9b7e6 = (0, $7NszV.createEntry)((0, $2NDia.assetsSearchRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        entryPoint: ()=>$0e927da2b693a3df$var$assetsSearchPageEntryPoint,
        resources: (0, $55ZOZ.getAssetsAppResources)(),
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout)
        ],
        perfMetricKey: 'assets-app.interact-with-search-page'
    }));

});
parcelRegister("2NDia", function(module, exports) {

$parcel$export(module.exports, "assetsSearchRoute", () => $a566f1c309df793b$export$6d41f99fb1a055c0);
const $a566f1c309df793b$export$6d41f99fb1a055c0 = {
    name: 'assets-search-results',
    path: '/jira/assets/search',
    exact: true
};

});

parcelRegister("ck92c", function(module, exports) {

$parcel$export(module.exports, "assetsSearchEntryPoint", () => $e8212bc60c70e700$export$5752b60b3fc851fc);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $e8212bc60c70e700$export$5752b60b3fc851fc = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        if (!false) return (parcelRequire("dgjY0")).then((module)=>module.AssetsAppSearchEntrypointWrapper);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve(()=>null);
    }, {
        moduleId: "49468062"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("dgjY0", function(module, exports) {

let $9a7c41fe3f95e532$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9a7c41fe3f95e532$var$load("ffQaD"),
    $9a7c41fe3f95e532$var$load("kvRbA"),
    $9a7c41fe3f95e532$var$load("kVX56"),
    $9a7c41fe3f95e532$var$load("7mIf9"),
    $9a7c41fe3f95e532$var$load("jXweD"),
    $9a7c41fe3f95e532$var$load("fliVL"),
    $9a7c41fe3f95e532$var$load("3lea0")
]).then(()=>parcelRequire('afJlR'));

});



parcelRegister("4VMm4", function(module, exports) {

$parcel$export(module.exports, "rovoSearchRouteEntry", () => $e32aede527302f76$export$64c44018a429a3ed);

var $5uXOq = parcelRequire("5uXOq");

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $3RJkv = parcelRequire("3RJkv");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

var $5cBfM = parcelRequire("5cBfM");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e32aede527302f76$var$LazyRovoSearchPage = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("jDSk9"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/rovo-search/src/index.tsx"
});
const $e32aede527302f76$var$RovoSearchPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $e32aede527302f76$var$LazyRovoSearchPage,
        pageId: "rovo-search",
        shouldShowSpinner: false
    });
const $e32aede527302f76$export$64c44018a429a3ed = (0, $7NszV.createEntry)((0, $5cBfM.rovoSearchRoute), ()=>({
        group: 'search',
        component: $e32aede527302f76$var$RovoSearchPage,
        isRedirect: false,
        layout: (0, $2BrOV.globalLayout),
        resources: [
            ...(0, $3RJkv.getNavigationResources)()
        ],
        forPaint: [
            $e32aede527302f76$var$LazyRovoSearchPage
        ]
    }));

});
parcelRegister("5cBfM", function(module, exports) {

$parcel$export(module.exports, "rovoSearchRoute", () => $361c5d3a5eacaef4$export$c45b7c601eb1ba93);
const $361c5d3a5eacaef4$export$c45b7c601eb1ba93 = {
    name: 'jira-rovo-search',
    path: '/jira/cross-product-search',
    exact: true
};

});

parcelRegister("jDSk9", function(module, exports) {

let $e4cbcc79e86ff9ff$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e4cbcc79e86ff9ff$var$load("ffQaD"),
    $e4cbcc79e86ff9ff$var$load("kvRbA"),
    $e4cbcc79e86ff9ff$var$load("kVX56"),
    $e4cbcc79e86ff9ff$var$load("7mIf9"),
    $e4cbcc79e86ff9ff$var$load("jXweD"),
    $e4cbcc79e86ff9ff$var$load("fliVL"),
    $e4cbcc79e86ff9ff$var$load("kSSEk")
]).then(()=>parcelRequire('4CIoa'));

});


parcelRegister("bFlFq", function(module, exports) {

$parcel$export(module.exports, "piEditIssueEmbedRouteEntry", () => $68977f9133eef8e0$export$54fd859765926fb);

var $5uXOq = parcelRequire("5uXOq");

var $7NszV = parcelRequire("7NszV");

var $gFxdE = parcelRequire("gFxdE");

var $9NiTW = parcelRequire("9NiTW");

var $5j7Th = parcelRequire("5j7Th");

var $6e4Kt = parcelRequire("6e4Kt");

var $2Ql51 = parcelRequire("2Ql51");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $68977f9133eef8e0$var$LazyPIEditIssueEmbed = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("4XLTG")).then((module)=>module.EditIssueEmbed), {
    ssr: false,
    moduleId: "./src/packages/growth/gmail-embed/src/ui/edit-issue/index.tsx"
});
const $68977f9133eef8e0$var$PIIssueEditEmbedLazy = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9NiTW.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $68977f9133eef8e0$var$LazyPIEditIssueEmbed,
        pageId: "spa-apps/pi-issue-edit-embed",
        shouldShowSpinner: true
    }));
};
const $68977f9133eef8e0$export$54fd859765926fb = (0, $7NszV.createEntry)((0, $gFxdE.piEditIssueEmbedRoute), ()=>({
        group: 'issue',
        component: $68977f9133eef8e0$var$PIIssueEditEmbedLazy,
        resources: [
            (0, $2Ql51.themePreferenceResource)
        ],
        layout: (0, $6e4Kt.chromelessLayout),
        forPaint: [
            $68977f9133eef8e0$var$LazyPIEditIssueEmbed
        ]
    }));

});
parcelRegister("gFxdE", function(module, exports) {

$parcel$export(module.exports, "piEditIssueEmbedRoute", () => $4be1968bc1e8e50c$export$963ebe9ee36e7e80);
const $4be1968bc1e8e50c$export$963ebe9ee36e7e80 = {
    name: 'pi-issue-edit-embed',
    path: '/jira/issues/edit/pi/embed'
};

});

parcelRegister("4XLTG", function(module, exports) {

let $39d1d37fde99e60b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $39d1d37fde99e60b$var$load("aZPed").then(()=>parcelRequire('cINTo'));

});


parcelRegister("eyDhF", function(module, exports) {

$parcel$export(module.exports, "piCreateIssueEmbedRouteEntry", () => $9f70c0379ebea475$export$7f9ffa2e2d102ba);

var $5uXOq = parcelRequire("5uXOq");

var $7NszV = parcelRequire("7NszV");

var $9NiTW = parcelRequire("9NiTW");

var $5j7Th = parcelRequire("5j7Th");

var $6e4Kt = parcelRequire("6e4Kt");

var $2Ql51 = parcelRequire("2Ql51");

var $4tkZW = parcelRequire("4tkZW");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9f70c0379ebea475$var$LazyPICreateIssueEmbed = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("1zu3V")).then((module)=>module.CreateIssueEmbed), {
    ssr: false,
    moduleId: "./src/packages/growth/gmail-embed/src/ui/create-issue/index.tsx"
});
const $9f70c0379ebea475$var$PIIssueCreateEmbedLazy = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9NiTW.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $9f70c0379ebea475$var$LazyPICreateIssueEmbed,
        pageId: "spa-apps/pi-issue-create-embed",
        shouldShowSpinner: true
    }));
};
const $9f70c0379ebea475$export$7f9ffa2e2d102ba = (0, $7NszV.createEntry)((0, $4tkZW.piCreateIssueEmbedRoute), ()=>({
        group: 'issue',
        component: $9f70c0379ebea475$var$PIIssueCreateEmbedLazy,
        resources: [
            (0, $2Ql51.themePreferenceResource)
        ],
        layout: (0, $6e4Kt.chromelessLayout),
        forPaint: [
            $9f70c0379ebea475$var$LazyPICreateIssueEmbed
        ]
    }));

});
parcelRegister("4tkZW", function(module, exports) {

$parcel$export(module.exports, "piCreateIssueEmbedRoute", () => $194e64041acf2c20$export$e38c7e6f5c65691b);
const $194e64041acf2c20$export$e38c7e6f5c65691b = {
    name: 'pi-issue-create-embed',
    path: '/jira/issues/create/pi/embed'
};

});

parcelRegister("1zu3V", function(module, exports) {

let $1250611323aac497$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1250611323aac497$var$load("6p1JY").then(()=>parcelRequire('1iOv0'));

});


parcelRegister("lkwO5", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCustomerServiceFeaturesRouteEntry", () => $a15bf8b76e7abde8$export$e17f02db5d9c0485);

var $9MntO = parcelRequire("9MntO");

var $4R6GH = parcelRequire("4R6GH");

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $6sNnq = parcelRequire("6sNnq");

var $5lsNZ = parcelRequire("5lsNZ");

var $6Z2mh = parcelRequire("6Z2mh");

var $cnvpg = parcelRequire("cnvpg");
const $a15bf8b76e7abde8$export$e17f02db5d9c0485 = (0, $7NszV.createEntry)((0, $9MntO.projectSettingsCustomerServiceFeaturesRoute), ()=>({
        group: 'project-settings-servicedesk',
        ufoName: 'jcs-project-settings.features',
        component: (0, $5lsNZ.default),
        entryPoint () {
            return (0, $4R6GH.fg)('berry-5039-jcs-features-page') ? (0, $cnvpg.projectSettingFeaturesAppPageEntryPoint) : undefined;
        },
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $6sNnq.featuresResource),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ],
        perfMetricKey: 'jcs-project-settings.features'
    }));

});
parcelRegister("9MntO", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCustomerServiceFeaturesRoute", () => $ad71d4ac3cd19ffa$export$5498201d2eacd40d);
const $ad71d4ac3cd19ffa$export$5498201d2eacd40d = {
    name: 'project-settings-customer-service-features',
    path: '/jira/servicedesk/projects/:projectKey/settings/features',
    exact: true
};

});

parcelRegister("cnvpg", function(module, exports) {

$parcel$export(module.exports, "projectSettingFeaturesAppPageEntryPoint", () => $6330397aa7ca9f96$export$f5b640657f5a50a3);

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $c5TMF = parcelRequire("c5TMF");
const $6330397aa7ca9f96$export$f5b640657f5a50a3 = (0, $lkFvK.createPageEntryPoint)({
    main: $c5TMF.projectSettingFeaturesAppEntryPoint,
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});

});
parcelRegister("c5TMF", function(module, exports) {

$parcel$export(module.exports, "projectSettingFeaturesAppEntryPoint", () => $60cea261eed7da95$export$83a2217e7eee641e);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $60cea261eed7da95$export$83a2217e7eee641e = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("kUYn8")), {
        moduleId: "92e8308d"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("kUYn8", function(module, exports) {

let $f3a7de42328eec2c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f3a7de42328eec2c$var$load("ly14Q").then(()=>parcelRequire('bMF5U'));

});




parcelRegister("3Ro2a", function(module, exports) {

$parcel$export(module.exports, "applinksExtraAuthHealthcheckRouteEntry", () => $cbeddb358fe83012$export$cd4854d613a2c404);

var $jwnr0 = parcelRequire("jwnr0");

var $3A9DP = parcelRequire("3A9DP");

var $ffza4 = parcelRequire("ffza4");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $cOg46 = parcelRequire("cOg46");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $5lsNZ = parcelRequire("5lsNZ");

var $5pSYQ = parcelRequire("5pSYQ");
const $cbeddb358fe83012$export$cd4854d613a2c404 = (0, $7NszV.createEntry)((0, $3A9DP.applinksExtraAuthHealthcheckRoute), ()=>({
        group: 'global-settings',
        ufoName: 'applinks-extra-auth-healthcheck',
        component: (0, $cSD7y.componentWithFG)('applinks-789-extra-auth-healthcheck-frontend', (0, $jwnr0.default), (0, $5lsNZ.default)),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $cOg46.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        canTransitionIn: ()=>(0, $4R6GH.fg)('applinks-789-extra-auth-healthcheck-frontend'),
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation)
        ],
        meta: {
            reporting: {
                id: 'Applinks',
                packageName: 'jiraAdminPagesApplinks',
                teamName: 'olympus'
            }
        }
    }));

});
parcelRegister("jwnr0", function(module, exports) {

$parcel$export(module.exports, "default", () => $e07161e92ae94550$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZw8H = parcelRequire("dZw8H");

var $l8ruj = parcelRequire("l8ruj");

var $9NiTW = parcelRequire("9NiTW");

var $lJ7oK = parcelRequire("lJ7oK");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e07161e92ae94550$var$HealthcheckPage = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "applinks-extra-auth-healthcheck-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9NiTW.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lJ7oK.default), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null)));
var $e07161e92ae94550$export$2e2bcd8739ae039 = $e07161e92ae94550$var$HealthcheckPage;

});
parcelRegister("lJ7oK", function(module, exports) {

$parcel$export(module.exports, "default", () => $a46c08b21138da0f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1bQGJ = parcelRequire("1bQGJ");

var $2YZCu = parcelRequire("2YZCu");

var $ismUQ = parcelRequire("ismUQ");


var $jJPaN = parcelRequire("jJPaN");
const $a46c08b21138da0f$export$7955d5fe058be414 = ()=>{
    const [healthcheck, setHealthcheck] = (0, $5uXOq.useState)(null);
    (0, $5uXOq.useEffect)(()=>{
        (0, $ismUQ.getHealthcheck)().then((data)=>{
            setHealthcheck(data);
        }).catch((err)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData((0, $3afa7e74a551cd1c$export$25a759e49d5049db), 'Failed to fetch healthcheck data', err);
            setHealthcheck(null);
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jJPaN.default), {
        healthcheck: healthcheck
    });
};
var $a46c08b21138da0f$export$2e2bcd8739ae039 = (0, $1bQGJ.withRouter)($a46c08b21138da0f$export$7955d5fe058be414);

});
parcelRegister("ismUQ", function(module, exports) {

$parcel$export(module.exports, "getHealthcheck", () => $b7c49ceb2b91f3bc$export$47b0be97eea80dc5);

var $7f4tk = parcelRequire("7f4tk");
const $b7c49ceb2b91f3bc$export$47b0be97eea80dc5 = ()=>(0, $7f4tk.default)('/rest/applinks/latest/applicationlink/extraAuth/healthcheck');

});

const $3afa7e74a551cd1c$export$25a759e49d5049db = 'applinks.extra-auth.healthcheck';

parcelRegister("jJPaN", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fe5bef83d0b878b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $7CMCs = parcelRequire("7CMCs");

var $6imks = parcelRequire("6imks");

var $426ZA = parcelRequire("426ZA");
const $0fe5bef83d0b878b$var$HealthcheckPageContents = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "applinks-extra-auth-healthcheck-page",
        teamName: "olympus",
        packageName: "applinksExtraAuthHealthcheckPage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200",
        xcss: $0fe5bef83d0b878b$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $426ZA.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.800"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6imks.default), {
        title: "Prerequisites",
        description: "Ensure that the following prerequisites are met before beginning the setup process.",
        healthcheckEntries: props.healthcheck?.healthcheckPreconditions ?? null
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6imks.default), {
        title: "OAuth 2.0 Provider Configuration",
        description: "Extra Authentication uses an external OAuth 2.0 provider, shared by all products within your organization. The provider must be configured correctly before Application Links can be created.",
        healthcheckEntries: props.healthcheck?.healthcheckEntries ?? null
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6imks.default), {
        title: "Applink Status",
        description: "Once the authentication provider is configured, you can now create Application Links. All links configured to use Extra Authentication for this site are displayed below.",
        healthcheckEntries: props.healthcheck?.healthcheckStatuses ?? null
    })))));
};
var $0fe5bef83d0b878b$export$2e2bcd8739ae039 = $0fe5bef83d0b878b$var$HealthcheckPageContents;
const $0fe5bef83d0b878b$var$styles = (0, $8CUq3.xcss)({
    padding: 'space.200'
});

});
parcelRegister("6imks", function(module, exports) {

$parcel$export(module.exports, "default", () => $12bdc979066f02a9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $2iqNv = parcelRequire("2iqNv");
var $6o3Pm = parcelRequire("6o3Pm");
var $8L11u = parcelRequire("8L11u");
var $4klZJ = parcelRequire("4klZJ");
var $bJ8bc = parcelRequire("bJ8bc");
var $ciNvy = parcelRequire("ciNvy");

var $b0JGA = parcelRequire("b0JGA");

var $hI6SY = parcelRequire("hI6SY");

var $cuJs9 = parcelRequire("cuJs9");

var $l1N8i = parcelRequire("l1N8i");

var $bmSXq = parcelRequire("bmSXq");
const $12bdc979066f02a9$var$HealthcheckIcon = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.status.statusType === 'SUCCESS' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b0JGA))), {
        color: "var(--ds-icon-success, #22A06B)",
        label: "Success"
    }), props.status.statusType === 'FAILURE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hI6SY))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "Unsuccessful"
    }), props.status.statusType === 'NOT_TRIED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cuJs9))), {
        color: "var(--ds-icon, #44546F)",
        label: "Not Tried"
    }));
};
const $12bdc979066f02a9$var$getColorFromStatus = (status)=>{
    if (status.statusType === 'NOT_TRIED') return 'color.text.disabled';
    return 'color.text';
};
const $12bdc979066f02a9$var$HealthcheckTitle = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: $12bdc979066f02a9$var$getColorFromStatus(props.status)
    }, props.name);
};
const $12bdc979066f02a9$var$HealthcheckComment = (props)=>{
    const message = 'message' in props.status ? props.status.message : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: $12bdc979066f02a9$var$getColorFromStatus(props.status)
    }, message);
};
const $12bdc979066f02a9$var$convertToArray = (healthcheckEntries)=>{
    const wrapWithItem = (id, content, hasChildren, children)=>{
        return {
            id: id,
            content: content,
            hasChildren: hasChildren,
            children: children
        };
    };
    return healthcheckEntries.map((entry, index)=>{
        return wrapWithItem(`entry-${index}`, entry, false);
    });
};
const $12bdc979066f02a9$var$HealthcheckTable = (props)=>{
    const healthcheckItems = props.healthcheckEntries ? $12bdc979066f02a9$var$convertToArray(props.healthcheckEntries) : undefined; // Loading state
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "medium"
    }, props.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, props.description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6o3Pm.default), {
        label: "Healthcheck Table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4klZJ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8L11u.default), {
        width: "100px"
    }, "Status"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8L11u.default), {
        width: "50%"
    }, "Item"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8L11u.default), {
        width: "50%"
    }, "Details")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ciNvy.default), {
        items: healthcheckItems,
        render: (item)=>{
            const { content: content } = item;
            const row = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bJ8bc.default), {
                key: item.id,
                itemId: item.id,
                hasChildren: item.hasChildren
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2iqNv.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12bdc979066f02a9$var$HealthcheckIcon, content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2iqNv.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12bdc979066f02a9$var$HealthcheckTitle, content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2iqNv.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12bdc979066f02a9$var$HealthcheckComment, content)));
            if (content.status.statusType === 'FAILURE') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, row, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bJ8bc.default), {
                key: `${item.id}-suggested-action`,
                itemId: `${item.id}-suggested-action`,
                hasChildren: false
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $12bdc979066f02a9$var$suggestedActionCellStyles,
                role: "cell"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bmSXq.default), {
                error: `Step "${content.name}" failed due to reason: "${content.status.message}".`,
                action: content.suggestedAction ?? null,
                link: content.suggestedActionLink ?? null
            }))));
            return row;
        }
    })));
};
var $12bdc979066f02a9$export$2e2bcd8739ae039 = $12bdc979066f02a9$var$HealthcheckTable;
const $12bdc979066f02a9$var$suggestedActionCellStyles = (0, $8CUq3.xcss)({
    width: '100%',
    padding: 'space.200'
});

});
parcelRegister("2iqNv", function(module, exports) {

$parcel$export(module.exports, "default", () => $92bd75f432ed306e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7GpC8 = parcelRequire("7GpC8");

var $j4H2b = parcelRequire("j4H2b");

var $4FjHP = parcelRequire("4FjHP");
const $92bd75f432ed306e$var$CellComponent = ({ children: children, singleLine: singleLine, indentLevel: indentLevel, width: width, className: className, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $7GpC8.default), {
        indent: indentLevel ? `calc(${"var(--ds-space-300, 25px)"} * ${indentLevel})` : undefined,
        width: width,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j4H2b.default), {
            isSingleLine: singleLine,
            children: children
        })
    });
const $92bd75f432ed306e$var$Cell = (0, $4FjHP.default)($92bd75f432ed306e$var$CellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$92bd75f432ed306e$export$2e2bcd8739ae039 = $92bd75f432ed306e$var$Cell;

});
parcelRegister("7GpC8", function(module, exports) {

$parcel$export(module.exports, "default", () => $10bc859ac0cd4c5d$export$2e2bcd8739ae039);
/* common-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $10bc859ac0cd4c5d$var$commonStyles = null;
/**
 * __Common cell__
 */ const $10bc859ac0cd4c5d$var$CommonCell = ({ indent: indent, width: width, className: className, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "gridcell",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_1yt413wy _11c82smr _1e0c1txw _vchhusvi _1tke1ylp _kqswh2mm _4cvr1h6o _syaz1fxt _ct361wug _1nmz1hna",
            className
        ]),
        ...props,
        style: {
            '--indent': indent,
            width: width
        }
    });
var $10bc859ac0cd4c5d$export$2e2bcd8739ae039 = $10bc859ac0cd4c5d$var$CommonCell;

});

parcelRegister("j4H2b", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dc1ffb24ef9838b$export$2e2bcd8739ae039);
/* overflow-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $3dc1ffb24ef9838b$var$overflowContainerStyles = null;
/**
 * __Overflow container__
 */ const $3dc1ffb24ef9838b$var$OverflowContainer = ({ isSingleLine: isSingleLine, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props,
        className: (0, $bwpsq.default)([
            isSingleLine && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ])
    });
var $3dc1ffb24ef9838b$export$2e2bcd8739ae039 = $3dc1ffb24ef9838b$var$OverflowContainer;

});

parcelRegister("4FjHP", function(module, exports) {

$parcel$export(module.exports, "default", () => $b855ad5734447a55$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $d2azQ = parcelRequire("d2azQ");
function $b855ad5734447a55$export$2e2bcd8739ae039(Cell) {
    return (props)=>{
        const { setColumnWidth: setColumnWidth, getColumnWidth: getColumnWidth } = (0, $5uXOq.useContext)((0, $d2azQ.TableTreeContext));
        const { width: width, columnIndex: columnIndex, ...other } = props;
        (0, $5uXOq.useEffect)(()=>{
            if (width !== undefined && columnIndex !== undefined) setColumnWidth(columnIndex, width);
        }, [
            width,
            columnIndex,
            setColumnWidth
        ]);
        let columnWidth;
        if (width !== null && width !== undefined) columnWidth = width;
        else if (columnIndex !== undefined) columnWidth = getColumnWidth(columnIndex);
        return /*#__PURE__*/ (0, $2OMIu.jsx)(Cell, {
            width: columnWidth,
            ...other
        });
    };
}

});
parcelRegister("d2azQ", function(module, exports) {

$parcel$export(module.exports, "TableTreeContext", () => $f9c36597fac53fcf$export$662c2d348d8b71af);

var $5uXOq = parcelRequire("5uXOq");
const $f9c36597fac53fcf$export$662c2d348d8b71af = /*#__PURE__*/ (0, $5uXOq.createContext)({
    setColumnWidth: ()=>{},
    getColumnWidth: ()=>null
});

});



parcelRegister("6o3Pm", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3356b60828ab4f6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2iqNv = parcelRequire("2iqNv");

var $8L11u = parcelRequire("8L11u");

var $4klZJ = parcelRequire("4klZJ");

var $d2azQ = parcelRequire("d2azQ");

var $bJ8bc = parcelRequire("bJ8bc");

var $ciNvy = parcelRequire("ciNvy");
const $d3356b60828ab4f6$var$emptyColumnWidths = [];
function $d3356b60828ab4f6$var$TableTree({ children: children, columns: columns, columnWidths: defaultColumnWidths = $d3356b60828ab4f6$var$emptyColumnWidths, headers: headers, shouldExpandOnClick: shouldExpandOnClick, items: items, mainColumnForExpandCollapseLabel: mainColumnForExpandCollapseLabel, label: label, referencedLabel: referencedLabel }) {
    const [columnWidths, setColumnWidths] = (0, $5uXOq.useState)(defaultColumnWidths);
    const setColumnWidth = (0, $5uXOq.useCallback)((columnIndex, width)=>{
        if (width === columnWidths[columnIndex]) return;
        setColumnWidths((columnWidths)=>{
            const newColumnWidths = [
                ...columnWidths
            ];
            newColumnWidths[columnIndex] = width;
            return newColumnWidths;
        });
    }, [
        columnWidths
    ]);
    const getColumnWidth = (0, $5uXOq.useCallback)((columnIndex)=>{
        return columnWidths[columnIndex] || null;
    }, [
        columnWidths
    ]);
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            setColumnWidth: setColumnWidth,
            getColumnWidth: getColumnWidth
        }), [
        setColumnWidth,
        getColumnWidth
    ]);
    const heads = headers && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4klZJ.default), {
        children: headers.map((header, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $8L11u.default), {
                columnIndex: index,
                width: columnWidths[index],
                children: header
            }, index))
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d2azQ.TableTreeContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            role: "treegrid",
            "aria-readonly": true,
            "aria-label": label,
            "aria-labelledby": referencedLabel,
            children: [
                heads,
                columns && items && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ciNvy.default), {
                    items: items,
                    render: ({ id: id, children: children, content: content })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $bJ8bc.default), {
                            itemId: id,
                            items: children,
                            hasChildren: !!children && children.length > 0,
                            shouldExpandOnClick: shouldExpandOnClick,
                            mainColumnForExpandCollapseLabel: mainColumnForExpandCollapseLabel,
                            children: columns.map((CellContent, index)=>{
                                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2iqNv.default), {
                                    columnIndex: index,
                                    width: columnWidths[index],
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(CellContent, {
                                        ...content
                                    })
                                }, `cell-${index}`);
                            })
                        })
                }),
                children
            ]
        })
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d3356b60828ab4f6$export$2e2bcd8739ae039 = $d3356b60828ab4f6$var$TableTree;

});
parcelRegister("8L11u", function(module, exports) {

$parcel$export(module.exports, "default", () => $dff9faceee2cad8f$export$2e2bcd8739ae039);
/* header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7GpC8 = parcelRequire("7GpC8");

var $4FjHP = parcelRequire("4FjHP");
const $dff9faceee2cad8f$var$headerStyles = null;
const $dff9faceee2cad8f$var$HeaderComponent = ({ width: width, children: children, onClick: onClick, id: id, role: role = 'columnheader' })=>{
    // TODO: Determine whether proper `th` elements can be used instead of
    // roles (DSP-11588)
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7GpC8.default), {
        role: role,
        width: width,
        id: id,
        onClick: onClick,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _syaz1n3s _k48pmoej"
        ]),
        children: children
    });
};
const $dff9faceee2cad8f$var$Header = (0, $4FjHP.default)($dff9faceee2cad8f$var$HeaderComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$dff9faceee2cad8f$export$2e2bcd8739ae039 = $dff9faceee2cad8f$var$Header;

});

parcelRegister("4klZJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $541b343154ef9600$export$2e2bcd8739ae039);
/* headers.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
/* eslint-disable @repo/internal/react/no-clone-element */ const $541b343154ef9600$var$containerStyles = null;
/**
 * __Headers__
 *
 * Headers component for advanced composition of data, allowing custom data structures.
 *
 * - [Examples](https://atlassian.design/components/table-tree/examples#advanced)
 * - [Code](https://atlassian.design/components/table-tree/code#headers-props)
 */ const $541b343154ef9600$var$Headers = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "row",
        className: (0, $bwpsq.default)([
            "_179r17qy _1e0c1txw"
        ]),
        children: (0, $5uXOq.Children).map(children, (header, index)=>/*#__PURE__*/ (0, $5uXOq.cloneElement)(header, {
                key: index,
                columnIndex: index
            }))
    });
var $541b343154ef9600$export$2e2bcd8739ae039 = $541b343154ef9600$var$Headers;

});

parcelRegister("bJ8bc", function(module, exports) {

$parcel$export(module.exports, "default", () => $66a5e6ea936beeef$export$2e2bcd8739ae039);
/* row.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $aaC5W = parcelRequire("aaC5W");

var $bToof = parcelRequire("bToof");

var $hwWh4 = parcelRequire("hwWh4");
const $66a5e6ea936beeef$var$treeRowClickableStyles = null;
const $66a5e6ea936beeef$var$getExtendedLabel = (cellContent, cellIndex, mainColumnForExpandCollapseLabel)=>{
    /**
   * First condition - when we pass data via `items` property in `<TableTree />`
   * Second condition - when we pass data via `<Rows />` as children in `<TableTree />`.
   */ if (cellContent.hasOwnProperty('props')) return cellContent?.props[mainColumnForExpandCollapseLabel?.toLowerCase()];
    else if (cellIndex === mainColumnForExpandCollapseLabel) return cellContent;
    return undefined;
};
function $66a5e6ea936beeef$var$Row({ shouldExpandOnClick: shouldExpandOnClick, hasChildren: hasChildren, depth: depth, renderChildren: renderChildren, isDefaultExpanded: isDefaultExpanded, data: data, onExpand: providedOnExpand, onCollapse: providedOnCollapse, mainColumnForExpandCollapseLabel: mainColumnForExpandCollapseLabel, expandLabel: expandLabel, collapseLabel: collapseLabel, itemId: itemId, children: children, isExpanded: isProvidedExpanded }) {
    const [isExpandedState, setIsExpandedState] = (0, $5uXOq.useState)(isDefaultExpanded || false);
    (0, $5uXOq.useEffect)(()=>{
        if (isProvidedExpanded === undefined && isDefaultExpanded !== undefined) setIsExpandedState(isDefaultExpanded);
    }, [
        isDefaultExpanded,
        isProvidedExpanded
    ]);
    const onExpand = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (value)=>providedOnExpand && providedOnExpand(value),
        action: 'expanded',
        actionSubject: 'tableTree',
        componentName: 'row',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onCollapse = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (value)=>providedOnCollapse && providedOnCollapse(value),
        action: 'collapsed',
        actionSubject: 'tableTree',
        componentName: 'row',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    }); /**
       * This ensures a user won't trigger a click event and expand the accordion
       * when making a text selection.
       */ 
    const onClickHandler = (e)=>{
        const selection = window.getSelection()?.toString() || '';
        if (selection?.length === 0) onExpandToggle();
    };
    const onExpandStateChange = (isExpanded)=>{
        if (data) {
            if (isExpanded && onExpand) onExpand(data);
            else if (!isExpanded && onCollapse) onCollapse(data);
        }
    };
    const onExpandToggle = ()=>{
        if (isProvidedExpanded !== undefined) onExpandStateChange(!isProvidedExpanded);
        else setIsExpandedState((prevState)=>{
            onExpandStateChange(!prevState);
            return !prevState;
        });
    };
    const renderCell = (cell, cellIndex)=>{
        const isFirstCell = cellIndex === 0;
        const indentLevel = isFirstCell ? depth : 0;
        let cellContent = cell.props.children || [];
        const extendedLabel = $66a5e6ea936beeef$var$getExtendedLabel(cellContent, cellIndex, mainColumnForExpandCollapseLabel);
        if (isFirstCell && hasChildren) cellContent = [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bToof.default), {
                expandLabel: expandLabel,
                collapseLabel: collapseLabel,
                extendedLabel: extendedLabel,
                isExpanded: isProvidedExpanded !== undefined ? isProvidedExpanded : isExpandedState,
                onExpandToggle: onExpandToggle,
                ariaControls: !!itemId ? (0, $aaC5W.default)(itemId) : undefined,
                rowId: !!itemId ? itemId : ''
            }, "chevron")
        ].concat(cellContent);
         // eslint-disable-next-line @repo/internal/react/no-clone-element
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(cell, {
            key: cellIndex,
            columnIndex: cellIndex,
            indentLevel: indentLevel
        }, cellContent);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hwWh4.TreeRowContainer), {
                onClick: hasChildren && shouldExpandOnClick ? onClickHandler : undefined,
                "aria-expanded": hasChildren ? isExpandedState : undefined,
                "aria-level": depth ? depth : undefined,
                className: (0, $bwpsq.default)([
                    hasChildren && shouldExpandOnClick && "_80omtlke"
                ]),
                children: (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children, (cell, index)=>renderCell(cell, index))
            }),
            hasChildren && (isProvidedExpanded !== undefined ? isProvidedExpanded : isExpandedState) && renderChildren && renderChildren()
        ]
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$66a5e6ea936beeef$export$2e2bcd8739ae039 = $66a5e6ea936beeef$var$Row;

});
parcelRegister("aaC5W", function(module, exports) {

$parcel$export(module.exports, "default", () => $004643d57fa9d692$export$2e2bcd8739ae039);
function $004643d57fa9d692$export$2e2bcd8739ae039(id) {
    return `tabletreeitem-${id}`.replace(/[^-_a-zA-Z0-9]/g, '');
}

});

parcelRegister("bToof", function(module, exports) {

$parcel$export(module.exports, "default", () => $8907d8a97de1d2f1$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/consistent-props-definitions */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $eGmKJ = parcelRequire("eGmKJ");

var $c8Oei = parcelRequire("c8Oei");

var $hWZau = parcelRequire("hWZau");

var $hwWh4 = parcelRequire("hwWh4");
/**
 * Internal chevron component.
 */ const $8907d8a97de1d2f1$var$Chevron = ({ isExpanded: isExpanded, ariaControls: ariaControls, collapseLabel: collapseLabel = 'Collapse', expandLabel: expandLabel = 'Expand', rowId: rowId, extendedLabel: extendedLabel, onExpandToggle: onExpandToggle = (0, $eGmKJ.default) })=>{
    const getLabel = (defaultLabel)=>extendedLabel ? `${defaultLabel} ${extendedLabel} row` : `${defaultLabel} row ${rowId}`;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hwWh4.ChevronContainer), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
            appearance: "subtle",
            onClick: onExpandToggle,
            spacing: "compact",
            icon: isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))) : (0, (/*@__PURE__*/$parcel$interopDefault($hWZau))),
            "aria-controls": isExpanded ? ariaControls : undefined,
            label: isExpanded ? getLabel(collapseLabel) : getLabel(expandLabel)
        })
    });
};
var $8907d8a97de1d2f1$export$2e2bcd8739ae039 = $8907d8a97de1d2f1$var$Chevron;

});
parcelRegister("hwWh4", function(module, exports) {

$parcel$export(module.exports, "TreeRowContainer", () => $95c9625625cd9bb5$export$802d2031792f9e4);
$parcel$export(module.exports, "ChevronContainer", () => $95c9625625cd9bb5$export$f25bd028f55b3d30);
$parcel$export(module.exports, "LoaderItemContainer", () => $95c9625625cd9bb5$export$94ae573de7227397);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $95c9625625cd9bb5$var$treeRowContainerStyles = null;
const $95c9625625cd9bb5$export$802d2031792f9e4 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "row",
        ...props,
        className: (0, $bwpsq.default)([
            "_179r1l7n _1e0c1txw"
        ])
    });
const $95c9625625cd9bb5$var$commonCellElementStyles = null;
const $95c9625625cd9bb5$var$commonChevronContainerStyles = null;
const $95c9625625cd9bb5$export$f25bd028f55b3d30 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswstnw _4cvr1h6o _ahbqf2s7",
            "_1pfhj39m"
        ])
    });
const $95c9625625cd9bb5$var$loadingItemContainerStyles = null;
const $95c9625625cd9bb5$var$paddingLeftStyles = null;
const $95c9625625cd9bb5$export$94ae573de7227397 = ({ isRoot: isRoot, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswstnw _4cvr1h6o _ahbqf2s7",
            "_1bsb1osq",
            isRoot && "_bozg1ssb"
        ])
    });

});



parcelRegister("ciNvy", function(module, exports) {

$parcel$export(module.exports, "default", () => $762c24e6d842b023$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ephf8 = parcelRequire("ephf8");
function $762c24e6d842b023$var$Rows({ items: items, render: render, loadingLabel: loadingLabel = 'Loading' }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "rowgroup",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ephf8.default), {
            items: items,
            loadingLabel: loadingLabel,
            render: render
        })
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$762c24e6d842b023$export$2e2bcd8739ae039 = $762c24e6d842b023$var$Rows;

});
parcelRegister("ephf8", function(module, exports) {

$parcel$export(module.exports, "default", () => $8669f6c312abfec5$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gru3E = parcelRequire("gru3E");

var $cvRdN = parcelRequire("cvRdN");
function $8669f6c312abfec5$var$Items({ depth: depth = 0, items: items, loadingLabel: loadingLabel, render: render }) {
    const [isLoaderShown, setIsLoaderShown] = (0, $5uXOq.useState)(false);
    const handleLoaderComplete = ()=>setIsLoaderShown(false);
    return !items || isLoaderShown ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cvRdN.default), {
        isCompleting: !!(items && items.length),
        onComplete: handleLoaderComplete,
        depth: depth + 1,
        loadingLabel: loadingLabel
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: items.map((data)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $gru3E.default), {
                data: data,
                depth: depth + 1,
                render: render,
                loadingLabel: loadingLabel
            }, data.id))
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8669f6c312abfec5$export$2e2bcd8739ae039 = $8669f6c312abfec5$var$Items;

});
parcelRegister("gru3E", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e08717fdca9a271$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-clone-element */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $aaC5W = parcelRequire("aaC5W");

var $ephf8 = parcelRequire("ephf8");
/**
 * __Item__
 * Internal item component.
 */ function $3e08717fdca9a271$var$Item({ depth: depth = 0, data: data, render: render, loadingLabel: loadingLabel }) {
    const renderedRow = render(data);
    if (!renderedRow) return null;
    // itemId exists on RowProps, but not on RowsProps
    const itemId = 'itemId' in renderedRow.props ? renderedRow.props.itemId : undefined;
    const items = renderedRow.props.items;
    return /*#__PURE__*/ (0, $5uXOq.cloneElement)(renderedRow, {
        depth: depth,
        data: data,
        loadingLabel: loadingLabel,
        renderChildren: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                id: !!itemId ? (0, $aaC5W.default)(itemId) : undefined,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ephf8.default), {
                    depth: depth,
                    items: items,
                    render: render,
                    loadingLabel: loadingLabel
                })
            })
    });
}
var $3e08717fdca9a271$export$2e2bcd8739ae039 = $3e08717fdca9a271$var$Item;

});

parcelRegister("cvRdN", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b92a4bcbfea61f3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");

var $7GpC8 = parcelRequire("7GpC8");

var $hwWh4 = parcelRequire("hwWh4");
const $9b92a4bcbfea61f3$var$LoaderItem = ({ depth: depth = 1, loadingLabel: loadingLabel, isCompleting: isCompleting, onComplete: onComplete })=>{
    const [phase, setPhase] = (0, $5uXOq.useState)('loading');
    (0, $5uXOq.useEffect)(()=>{
        if (phase === 'loading' && isCompleting) setPhase(()=>{
            onComplete();
            return 'complete';
        });
    }, [
        isCompleting,
        onComplete,
        phase
    ]);
    return phase === 'loading' ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hwWh4.TreeRowContainer), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7GpC8.default), {
            indent: `calc(${"var(--ds-space-300, 25px)"} * ${depth})`,
            width: "100%",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hwWh4.LoaderItemContainer), {
                isRoot: depth === 1,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
                    size: "small",
                    testId: "table-tree-spinner",
                    label: loadingLabel
                })
            })
        })
    }) : null;
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9b92a4bcbfea61f3$export$2e2bcd8739ae039 = $9b92a4bcbfea61f3$var$LoaderItem;

});




parcelRegister("cuJs9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8514ab409cdd1786faf0e15acb24fff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $918b8b64efc9a190$var$_react = $918b8b64efc9a190$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $918b8b64efc9a190$var$_baseNew = $918b8b64efc9a190$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $918b8b64efc9a190$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TaskToDo".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for to-do task status. Used in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $918b8b64efc9a190$var$TaskToDoIcon = (props)=>/*#__PURE__*/ $918b8b64efc9a190$var$_react.default.createElement($918b8b64efc9a190$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.028 1.5H8V0h.034c1.957.008 3.75.72 5.135 1.894L12.2 3.04A6.47 6.47 0 0 0 8.03 1.5m-2.278.4a6.52 6.52 0 0 0-3.395 2.875l-1.302-.746A8.02 8.02 0 0 1 5.23.493zM14.5 8a6.47 6.47 0 0 0-.856-3.227l1.301-.745A7.97 7.97 0 0 1 16 8q0 .727-.126 1.42l-1.476-.264A6.6 6.6 0 0 0 14.5 8M1.593 6.895A6.6 6.6 0 0 0 1.5 8c0 1.194.321 2.31.882 3.27l-1.296.757A7.97 7.97 0 0 1 0 8q.001-.694.115-1.358zm8.605 7.224a6.52 6.52 0 0 0 3.419-2.845l1.295.757a8.02 8.02 0 0 1-4.208 3.5zm-6.344-1.113A6.47 6.47 0 0 0 8 14.5V16a7.97 7.97 0 0 1-5.104-1.84z" clip-rule="evenodd"/>`
    }, props));
$918b8b64efc9a190$var$TaskToDoIcon.displayName = 'TaskToDoIcon';
var $918b8b64efc9a190$var$_default = module.exports.default = $918b8b64efc9a190$var$TaskToDoIcon;

});

parcelRegister("bmSXq", function(module, exports) {

$parcel$export(module.exports, "default", () => $2146cc344dbb357b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $92Z2l = parcelRequire("92Z2l");
var $ctz0s = parcelRequire("ctz0s");

var $414Wj = parcelRequire("414Wj");
var $dS3PR = parcelRequire("dS3PR");
const $2146cc344dbb357b$var$HealthcheckSuggestedAction = (props)=>{
    const actions = props.link ? [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctz0s.default), {
            key: "action",
            href: props.link.link
        }, props.link.name)
    ] : [];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        title: "Step Failed",
        appearance: "error",
        actions: actions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $414Wj.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), null, props.error), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), null, props.action))));
};
var $2146cc344dbb357b$export$2e2bcd8739ae039 = $2146cc344dbb357b$var$HealthcheckSuggestedAction;

});
parcelRegister("92Z2l", function(module, exports) {

$parcel$export(module.exports, "default", () => $a97355a0cc6aeb06$export$2e2bcd8739ae039);
/* section-message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
var $414Wj = parcelRequire("414Wj");

var $3HeRx = parcelRequire("3HeRx");
const $a97355a0cc6aeb06$var$sectionMessageStyles = {
    container: "_2rkoglpi _1nmz1hna",
    bleed: "_1mou1i6y _1e0c1txw",
    content: "_11c82smr _syaz1fxt",
    actionsContainer: "_11c82smr"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $a97355a0cc6aeb06$var$SectionMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, testId: testId }, ref) {
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $3HeRx.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment ? actions.props.children : actions;
    const actionsArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(actionElements);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "section",
        backgroundColor: $a97355a0cc6aeb06$var$appearanceMap[appearance],
        padding: "space.200",
        testId: testId,
        ref: ref,
        xcss: $a97355a0cc6aeb06$var$sectionMessageStyles.container,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            space: "space.200",
            alignBlock: "stretch",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    xcss: $a97355a0cc6aeb06$var$sectionMessageStyles.bleed,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                        size: "medium",
                        primaryColor: primaryColor,
                        secondaryColor: secondaryColor,
                        // props for new icon
                        LEGACY_size: "medium",
                        color: primaryColor,
                        spacing: "spacious"
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
                    space: "space.100",
                    testId: testId && `${testId}--content`,
                    children: [
                        !!title && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                            as: "h2",
                            size: "small",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            xcss: $a97355a0cc6aeb06$var$sectionMessageStyles.content,
                            children: children
                        }),
                        actionsArray.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                            shouldWrap: true,
                            testId: testId && `${testId}--actions`,
                            separator: "\xb7",
                            space: "space.100",
                            rowSpace: "space.0",
                            // Only use a list role if more than one action is present
                            role: actionsArray.length > 1 ? 'list' : undefined,
                            xcss: (0, $VSDnB.fg)('platform_ads_explicit_font_styles') && $a97355a0cc6aeb06$var$sectionMessageStyles.actionsContainer,
                            children: actionsArray.map((action, id)=>// Only use a listitem role if more than one action is present
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                                    role: actionsArray.length > 1 ? 'listitem' : undefined,
                                    children: action
                                }, id))
                        })
                    ]
                })
            ]
        })
    });
});
const $a97355a0cc6aeb06$var$appearanceMap = {
    information: 'color.background.information',
    warning: 'color.background.warning',
    error: 'color.background.danger',
    success: 'color.background.success',
    discovery: 'color.background.discovery'
};
$a97355a0cc6aeb06$var$SectionMessage.displayName = 'SectionMessage';
var $a97355a0cc6aeb06$export$2e2bcd8739ae039 = $a97355a0cc6aeb06$var$SectionMessage;

});
parcelRegister("3HeRx", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", () => $d1d7dced94bb00f5$export$e9b82d2e21ac0c1f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dD7Zc = parcelRequire("dD7Zc");

var $1jWct = parcelRequire("1jWct");

var $dg0Fl = parcelRequire("dg0Fl");

var $c2i4s = parcelRequire("c2i4s");

var $bU3PY = parcelRequire("bU3PY");

const $d1d7dced94bb00f5$var$appearanceIconSchema = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1jWct))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $829f609a65d26a98$export$8d9596b529bbb9cf)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$874739ea9e379ab6)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $829f609a65d26a98$export$8a6341c32b6a3ee6)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$6fa04827ac68a4fb)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $829f609a65d26a98$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dg0Fl))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$export$147899de772240ec)})`
    }
};
function $d1d7dced94bb00f5$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $d1d7dced94bb00f5$var$appearanceIconSchema[appearance] || $d1d7dced94bb00f5$var$appearanceIconSchema.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, $2OMIu.jsx)(appearanceIconStyles.Icon, {
            LEGACY_size: size,
            color: primaryColor,
            spacing: "spacious",
            LEGACY_primaryColor: primaryColor,
            LEGACY_secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});


parcelRegister("ctz0s", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e844da07d79ea04$export$2e2bcd8739ae039);
/* section-message-action.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $5McnS = parcelRequire("5McnS");
var $MHKc7 = parcelRequire("MHKc7");
var $3Lty3 = parcelRequire("3Lty3");
const $2e844da07d79ea04$var$styles = {
    common: "_11c82smr _syaz14q2 _k48p1wq8 _30l314q2 _9h8h16c2",
    anchor: "_1053w7te _9oik18uv _1bnx8stv _jf4cnqa1 _n0fxw7te _1vhvg3x0",
    pressable: "_bfhk1w7a _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik18uv _1bnx8stv _jf4cnqa1"
};
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ const $2e844da07d79ea04$var$SectionMessageAction = /*#__PURE__*/ (0, $5uXOq.memo)(function SectionMessageAction({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent }) {
    if (!linkComponent && (0, $VSDnB.fg)('platform_section_message_action_migration')) {
        if (href) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5McnS.default), {
            testId: testId,
            onClick: onClick,
            href: href,
            xcss: (0, $3JT92.cx)($2e844da07d79ea04$var$styles.common, $2e844da07d79ea04$var$styles.anchor),
            children: children
        });
        if (onClick) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
            testId: testId,
            onClick: onClick,
            xcss: (0, $3JT92.cx)($2e844da07d79ea04$var$styles.common, $2e844da07d79ea04$var$styles.pressable),
            children: children
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            as: "span",
            testId: testId,
            children: children
        });
    }
    return onClick || href ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined,
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
});
var $2e844da07d79ea04$export$2e2bcd8739ae039 = $2e844da07d79ea04$var$SectionMessageAction;

});



parcelRegister("426ZA", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ae4fabdb7582137$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $414Wj = parcelRequire("414Wj");
var $dS3PR = parcelRequire("dS3PR");
const $5ae4fabdb7582137$var$HealthcheckHeader = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $414Wj.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "large"
    }, "Extra Auth Healthcheck"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), null, "Status of Extra Authenticated Application Links for your Jira Cloud site.")));
};
var $5ae4fabdb7582137$export$2e2bcd8739ae039 = $5ae4fabdb7582137$var$HealthcheckHeader;

});




parcelRegister("3A9DP", function(module, exports) {

$parcel$export(module.exports, "applinksExtraAuthHealthcheckRoute", () => $1566be2cb38c0d94$export$c92684a6af97ae19);
const $1566be2cb38c0d94$export$c92684a6af97ae19 = {
    name: 'global-settings-products-applinks-extra-auth',
    path: '/jira/settings/applinks/extra-auth/healthcheck',
    exact: true
};

});


parcelRegister("b952b", function(module, exports) {

$parcel$export(module.exports, "globalSettingsOptimizeFieldConfigurationSchemeRouteEntry", () => $f4756476c75bffa3$export$b98ced4649f55b1c);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $l8mjk = parcelRequire("l8mjk");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $5lsNZ = parcelRequire("5lsNZ");

var $5pSYQ = parcelRequire("5pSYQ");

var $ehkRy = parcelRequire("ehkRy");
const $f4756476c75bffa3$export$b98ced4649f55b1c = (0, $7NszV.createEntry)((0, $l8mjk.globalSettingsOptimizeFieldConfigurationSchemeRoute), ()=>({
        group: 'global-settings',
        component: (0, $cSD7y.componentWithFG)('field_streamlining_ui', (0, $ehkRy.OptimizeFieldConfigurationSchemePage), (0, $5lsNZ.default)),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        canTransitionIn: ()=>(0, $4R6GH.fg)('field_streamlining_ui'),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $ehkRy.LazyOptimizeFieldConfigurationSchemePagePage)
        ]
    }));

});
parcelRegister("l8mjk", function(module, exports) {

$parcel$export(module.exports, "globalSettingsOptimizeFieldConfigurationSchemeRoute", () => $1cad7dbb66344a48$export$3da73e59758744eb);
const $1cad7dbb66344a48$export$3da73e59758744eb = {
    name: 'global-settings-optimize-field-configuration-scheme-view',
    path: '/jira/settings/issues/field-configuration-schemes/:fieldConfigurationSchemeId/optimize'
};

});

parcelRegister("ehkRy", function(module, exports) {

$parcel$export(module.exports, "LazyOptimizeFieldConfigurationSchemePagePage", () => $38dfff5e6a0cdd15$export$bd8509501da10c3);
$parcel$export(module.exports, "OptimizeFieldConfigurationSchemePage", () => $38dfff5e6a0cdd15$export$7cd55863572c1f3a);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $38dfff5e6a0cdd15$export$bd8509501da10c3 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("5AwDH"))), {
    ssr: false,
    moduleId: "./src/packages/site-optimizer/optimize-field-configuration-scheme-page/src/index.tsx"
});
const $38dfff5e6a0cdd15$export$7cd55863572c1f3a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $38dfff5e6a0cdd15$export$bd8509501da10c3,
        pageId: "jira-admin-pages-optimize-field-configuration-scheme-page",
        shouldShowSpinner: true
    });

});
parcelRegister("5AwDH", function(module, exports) {

let $4119a20296b4f499$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4119a20296b4f499$var$load("5w8u2").then(()=>parcelRequire('hHp0Z'));

});



parcelRegister("aZXhs", function(module, exports) {

$parcel$export(module.exports, "globalSettingsOptimizeWorkTypeSchemeRouteEntry", () => $1f1412c4c9101f48$export$bae97ca0b9dd2ea2);

var $ffza4 = parcelRequire("ffza4");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $7NszV = parcelRequire("7NszV");

var $atU1t = parcelRequire("atU1t");

var $3RJkv = parcelRequire("3RJkv");

var $hRCOF = parcelRequire("hRCOF");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $5lsNZ = parcelRequire("5lsNZ");

var $5pSYQ = parcelRequire("5pSYQ");

var $kWXll = parcelRequire("kWXll");
const $1f1412c4c9101f48$export$bae97ca0b9dd2ea2 = (0, $7NszV.createEntry)((0, $hRCOF.globalSettingsOptimizeWorkTypeSchemeRoute), ()=>({
        group: 'global-settings',
        component: (0, $cSD7y.componentWithFG)('optimize_issue_type_scheme_page', (0, $kWXll.OptimizeWorkTypeSchemePage), (0, $5lsNZ.default)),
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        canTransitionIn: ()=>(0, $4R6GH.fg)('optimize_issue_type_scheme_page'),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $kWXll.LazyOptimizeWorkTypeSchemePagePage)
        ]
    }));

});
parcelRegister("hRCOF", function(module, exports) {

$parcel$export(module.exports, "globalSettingsOptimizeWorkTypeSchemeRoute", () => $7ac34df36e8a0c4b$export$c0e227e20c671f81);
const $7ac34df36e8a0c4b$export$c0e227e20c671f81 = {
    name: 'global-settings-optimize-work-type-scheme-view',
    path: '/jira/settings/issues/issue-type-schemes/:workTypeSchemeId/optimize'
};

});

parcelRegister("kWXll", function(module, exports) {

$parcel$export(module.exports, "LazyOptimizeWorkTypeSchemePagePage", () => $8e37869c3b270f55$export$267fd3967a05d273);
$parcel$export(module.exports, "OptimizeWorkTypeSchemePage", () => $8e37869c3b270f55$export$ba894e00aa169b3b);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $8e37869c3b270f55$export$267fd3967a05d273 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("hNmmc"))), {
    ssr: false,
    moduleId: "./src/packages/site-optimizer/optimize-work-type-scheme-page/src/index.tsx"
});
const $8e37869c3b270f55$export$ba894e00aa169b3b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $8e37869c3b270f55$export$267fd3967a05d273,
        pageId: "jira-admin-pages-optimize-work-type-scheme-page",
        shouldShowSpinner: true
    });

});
parcelRegister("hNmmc", function(module, exports) {

let $cf485aee5b8d7b8b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cf485aee5b8d7b8b$var$load("jZswI").then(()=>parcelRequire('gIjWg'));

});



parcelRegister("69iY3", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldConfigurationSchemesRouteEntry", () => $4d2835303e962147$export$46fc796086760207);

var $7NszV = parcelRequire("7NszV");

var $d4Sjz = parcelRequire("d4Sjz");

var $ibkIl = parcelRequire("ibkIl");

var $lmyls = parcelRequire("lmyls");

var $78U7j = parcelRequire("78U7j");

var $4R6GH = parcelRequire("4R6GH");

var $3RJkv = parcelRequire("3RJkv");

var $atU1t = parcelRequire("atU1t");

var $5pSYQ = parcelRequire("5pSYQ");

var $lkFvK = parcelRequire("lkFvK");

var $hYZqE = parcelRequire("hYZqE");
const $4d2835303e962147$var$pageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $hYZqE.globalAdminFieldConfigurationSchemesEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).SETTINGS
});
const $4d2835303e962147$export$46fc796086760207 = (0, $7NszV.createEntry)((0, $d4Sjz.globalSettingsIssueFieldConfigurationSchemesRoute), ()=>({
        group: 'global-settings',
        ufoName: 'global-admin.issues.field-configuration-schemes',
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebar: (0, $78U7j.default)
        },
        canTransitionIn: ()=>(0, $4R6GH.fg)('jira_efa_for_cmp_m2'),
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            (0, $atU1t.navigationSidebarGlobalResource),
            (0, $5pSYQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>{
            if (!(0, $4R6GH.fg)('jira_efa_for_cmp_m2')) return undefined;
            return $4d2835303e962147$var$pageEntryPoint;
        },
        meta: {
            reporting: {
                packageName: 'jiraAdminPagesFieldConfigurationSchemes',
                id: 'globalSettingsIssueFieldConfigurationSchemes',
                teamName: 'Yamato'
            }
        }
    }));

});
parcelRegister("d4Sjz", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueFieldConfigurationSchemesRoute", () => $8375b3a32756f9f4$export$bbb23801a4589091);
const $8375b3a32756f9f4$export$bbb23801a4589091 = {
    name: 'global-settings-issues-field-configuration-schemes',
    path: '/jira/settings/issues/field-configuration-schemes',
    exact: true
};

});

parcelRegister("hYZqE", function(module, exports) {

$parcel$export(module.exports, "globalAdminFieldConfigurationSchemesEntryPoint", () => $950bddd33bf3b539$export$e6a385c0b09caa1f);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

var $ea5Bw = parcelRequire("ea5Bw");

const $950bddd33bf3b539$export$e6a385c0b09caa1f = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("jEZtL")), {
        moduleId: "d5c921f3"
    }),
    getPreloadProps: ({ tenantContext: tenantContext })=>({
            queries: {
                pageQueryRef: {
                    parameters: (0, $ea5Bw.default),
                    variables: {
                        cloudId: tenantContext.cloudId
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        })
});

});
parcelRegister("ea5Bw", function(module, exports) {

$parcel$export(module.exports, "default", () => $af768739f7be23ae$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<54282f7b5aee88517f7d47a584b0941c>>
 * @relayHash 52309547e55b39b8ebca1abe76437e05
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9b511e08c69cd7827cb9cb410af68fa13d59c8373bcb7be3b8a5fd68f9304993

var $eiowN = parcelRequire("eiowN");
const $af768739f7be23ae$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "srcFieldConfigurationSchemesQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "ui_adminPagesFieldConfigurationSchemes_FieldConfigurationSchemesPage"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "srcFieldConfigurationSchemesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "concreteType": "JiraHomePage",
                            "kind": "LinkedField",
                            "name": "userHomePage",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "link"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9b511e08c69cd7827cb9cb410af68fa13d59c8373bcb7be3b8a5fd68f9304993",
            "metadata": {},
            "name": "srcFieldConfigurationSchemesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$af768739f7be23ae$var$node.hash = "789159df1c4fe4cca65de23212d77454";
(0, $eiowN.PreloadableQueryRegistry).set($af768739f7be23ae$var$node.params.id, $af768739f7be23ae$var$node);
var $af768739f7be23ae$export$2e2bcd8739ae039 = $af768739f7be23ae$var$node;

});

parcelRegister("jEZtL", function(module, exports) {

let $e501713450f03f71$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e501713450f03f71$var$load("ci0xn").then(()=>parcelRequire('1Cv5i'));

});



parcelRegister("ca1Zm", function(module, exports) {

$parcel$export(module.exports, "assetsDataManagerGettingStartedRouteEntry", () => $4bc06d3ca24631bd$export$d9a1c48acd35cf03);

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $5lsNZ = parcelRequire("5lsNZ");

var $2eDbE = parcelRequire("2eDbE");

var $lkFvK = parcelRequire("lkFvK");

var $4X5MI = parcelRequire("4X5MI");

var $e9YVH = parcelRequire("e9YVH");

var $55ZOZ = parcelRequire("55ZOZ");

var $k7I8D = parcelRequire("k7I8D");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");
const $4bc06d3ca24631bd$var$assetsDataManagerGettingStartedPageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $4X5MI.assetsDataManagerGettingStartedEntryPoint)
});
const $4bc06d3ca24631bd$export$d9a1c48acd35cf03 = (0, $7NszV.createEntry)((0, $2eDbE.assetsDataManagerGettingStartedRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        perfMetricKey: 'assets-data-manager-getting-started',
        pageId: ()=>'spa-apps/assets-data-manager-getting-started',
        resources: (0, $55ZOZ.getAssetsAppResources)(),
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout)
        ],
        entryPoint () {
            return (0, $4R6GH.fg)('assets_data_manager_jira_spa') ? $4bc06d3ca24631bd$var$assetsDataManagerGettingStartedPageEntryPoint : undefined;
        },
        component: (0, $4R6GH.fg)('assets_data_manager_jira_spa') ? undefined : (0, $5lsNZ.default),
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).ASSETS_APP_DATA_MANAGER_GETTING_STARTED_PAGE,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).ASSETS_APP_DATA_MANAGER_GETTING_STARTED_PAGE),
                teamName: 'Aurum'
            }
        }
    }));

});
parcelRegister("2eDbE", function(module, exports) {

$parcel$export(module.exports, "assetsDataManagerGettingStartedRoute", () => $11e34d6ea6d371f6$export$82de2af972f327f8);
const $11e34d6ea6d371f6$export$82de2af972f327f8 = {
    name: 'assets-data-manager-getting-started',
    path: '/jira/assets/data-manager/getting-started',
    exact: true
};

});

parcelRegister("4X5MI", function(module, exports) {

$parcel$export(module.exports, "assetsDataManagerGettingStartedEntryPoint", () => $68099fa38484b838$export$4f270d89a19b2303);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $68099fa38484b838$export$4f270d89a19b2303 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("f2A9T")), {
        moduleId: "69964d1d"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("f2A9T", function(module, exports) {

let $af33173bd4b4ec92$var$load = (parcelRequire("28QjX"))(4);
module.exports = $af33173bd4b4ec92$var$load("g7uLf").then(()=>parcelRequire('6Ctkw'));

});



parcelRegister("6GNmk", function(module, exports) {

$parcel$export(module.exports, "assetsDataManagerObjectClassesRouteEntry", () => $36898c05fc75c8c5$export$21baed265eb8be15);

var $4R6GH = parcelRequire("4R6GH");

var $7NszV = parcelRequire("7NszV");

var $5lsNZ = parcelRequire("5lsNZ");

var $6HFp1 = parcelRequire("6HFp1");

var $lkFvK = parcelRequire("lkFvK");

var $e9YVH = parcelRequire("e9YVH");

var $55ZOZ = parcelRequire("55ZOZ");

var $k7I8D = parcelRequire("k7I8D");

var $7iyOx = parcelRequire("7iyOx");

var $kb4zh = parcelRequire("kb4zh");

var $gijLr = parcelRequire("gijLr");
const $36898c05fc75c8c5$var$assetsDataManagerObjectClassesPageEntryPoint = (0, $lkFvK.createChromelessEntryPoint)({
    main: (0, $gijLr.assetsDataManagerObjectClassesEntryPoint)
});
const $36898c05fc75c8c5$export$21baed265eb8be15 = (0, $7NszV.createEntry)((0, $6HFp1.assetsDataManagerObjectClassesRoute), ()=>({
        group: 'assets',
        LayoutOverrideComponent: (0, $k7I8D.AssetsLayout),
        PageConfigContainerOverride: (0, $7iyOx.AssetsPageConfigContainer),
        skeleton: (0, $kb4zh.default),
        perfMetricKey: 'assets-data-manager-object-classes',
        pageId: ()=>'spa-apps/assets-data-manager-object-classes',
        resources: (0, $55ZOZ.getAssetsAppResources)(),
        forPaint: [
            (0, $k7I8D.LazyAssetsLayout)
        ],
        entryPoint () {
            return (0, $4R6GH.fg)('assets_data_manager_jira_spa') ? $36898c05fc75c8c5$var$assetsDataManagerObjectClassesPageEntryPoint : undefined;
        },
        component: (0, $4R6GH.fg)('assets_data_manager_jira_spa') ? undefined : (0, $5lsNZ.default),
        meta: {
            reporting: {
                id: (0, $e9YVH.APP_NAMES).ASSETS_APP_DATA_MANAGER_OBJECT_CLASSES_PAGE,
                packageName: (0, $e9YVH.toPackageName)((0, $e9YVH.APP_NAMES).ASSETS_APP_DATA_MANAGER_OBJECT_CLASSES_PAGE),
                teamName: 'Aurum'
            }
        }
    }));

});
parcelRegister("6HFp1", function(module, exports) {

$parcel$export(module.exports, "assetsDataManagerObjectClassesRoute", () => $3a9992b78f22acb9$export$efbc59a0b92a1a13);
const $3a9992b78f22acb9$export$efbc59a0b92a1a13 = {
    name: 'assets-data-manager-object-classes',
    path: '/jira/assets/data-manager/object-classes',
    exact: true
};

});

parcelRegister("gijLr", function(module, exports) {

$parcel$export(module.exports, "assetsDataManagerObjectClassesEntryPoint", () => $ae68c8884650ca59$export$c1881c035be68200);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $ae68c8884650ca59$export$c1881c035be68200 = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>{
        if (!false) return (parcelRequire("1oH3z"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve(()=>null);
    }, {
        moduleId: "1ab370bf"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("1oH3z", function(module, exports) {

let $10496e7e140c3aba$var$load = (parcelRequire("28QjX"))(4);
module.exports = $10496e7e140c3aba$var$load("7adsU").then(()=>parcelRequire('94tLu'));

});



parcelRegister("734Wz", function(module, exports) {

$parcel$export(module.exports, "productsOnboardingHubRouteEntry", () => $5a685cdbfad9fada$export$114fd427e3931043);

var $7NszV = parcelRequire("7NszV");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");

var $2Fj5v = parcelRequire("2Fj5v");

var $ibkIl = parcelRequire("ibkIl");

var $7Vazp = parcelRequire("7Vazp");

var $4R6GH = parcelRequire("4R6GH");

var $gFyNY = parcelRequire("gFyNY");

var $3RJkv = parcelRequire("3RJkv");
const $5a685cdbfad9fada$var$productsOnboardingHubEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $7Vazp.onboardingHubEntryPoint),
    topNavigationMenuId: (0, $lmyls.MENU_ID).SETTINGS
});
const $5a685cdbfad9fada$export$114fd427e3931043 = (0, $7NszV.createEntry)((0, $gFyNY.productsOnboardingHubRoute), ()=>({
        group: 'global-settings',
        entryPoint () {
            return (0, $4R6GH.fg)('jira-onboarding-hub-gate') ? $5a685cdbfad9fada$var$productsOnboardingHubEntryPoint : undefined;
        },
        layout: (0, $ibkIl.globalSettingsLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).SETTINGS,
            sidebarId: (0, $lmyls.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $2Fj5v.default)
        },
        resources: [
            ...(0, $3RJkv.getNavigationResources)(),
            ...(0, $3RJkv.getNavigationSidebarProductsSettingResource)()
        ]
    }));

});
parcelRegister("7Vazp", function(module, exports) {

$parcel$export(module.exports, "onboardingHubEntryPoint", () => $46a5e3e23f370ef8$export$fbab93125af0feae);

var $2OZhN = parcelRequire("2OZhN");

var $fEDBv = parcelRequire("fEDBv");

const $46a5e3e23f370ef8$export$fbab93125af0feae = (0, $fEDBv.createEntryPoint)({
    root: (0, $2OZhN.JSResourceForUserVisible)(()=>(parcelRequire("943K6")).then((module)=>module.OnboardingHubPage), {
        moduleId: "4a678f18"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("943K6", function(module, exports) {

let $699763faab9cf871$var$load = (parcelRequire("28QjX"))(4);
module.exports = $699763faab9cf871$var$load("aksCE").then(()=>parcelRequire('8eArQ'));

});


parcelRegister("gFyNY", function(module, exports) {

$parcel$export(module.exports, "productsOnboardingHubRoute", () => $46c877b8c621eeec$export$6a9e8ece249577cc);
const $46c877b8c621eeec$export$6a9e8ece249577cc = {
    name: 'products-onboarding-hub',
    path: '/jira/settings/products/onboarding'
};

});



parcelRegister("aWB2j", function(module, exports) {

$parcel$export(module.exports, "getCodegenSpaRoutes", () => $ce88d0fae79c280a$export$f800556856b3f5dc);
/*
 * This file is generated. Do not modify manually
 * If you are adding or deleting a route, please run "yarn dev routes:generate-route-assets"
 * to re-generate this SPA route map and RouteName/RouteGroup types then commit the changes.
 * @generated SignedSource<<c4232c80ca5065a06c4e26fafa0c16a5>>
 * @codegen-command: yarn dev routes:generate-route-map --filter spa
 */ 
var $UuOK7 = parcelRequire("UuOK7");

var $iTGOF = parcelRequire("iTGOF");

var $3Ro2a = parcelRequire("3Ro2a");

var $lLZ8x = parcelRequire("lLZ8x");

var $hHcn9 = parcelRequire("hHcn9");

var $vDjHk = parcelRequire("vDjHk");

var $9CxHM = parcelRequire("9CxHM");

var $eaKG5 = parcelRequire("eaKG5");

var $9wv3p = parcelRequire("9wv3p");

var $6DvyY = parcelRequire("6DvyY");

var $lGElM = parcelRequire("lGElM");

var $3bc6l = parcelRequire("3bc6l");

var $fpGzf = parcelRequire("fpGzf");

var $aVGYm = parcelRequire("aVGYm");

var $2DH60 = parcelRequire("2DH60");

var $7gypr = parcelRequire("7gypr");

var $cwKGx = parcelRequire("cwKGx");

var $jZMnM = parcelRequire("jZMnM");

var $dfdSu = parcelRequire("dfdSu");

var $ieqGd = parcelRequire("ieqGd");

var $JQ5Vt = parcelRequire("JQ5Vt");

var $eOPb5 = parcelRequire("eOPb5");

var $a5XVU = parcelRequire("a5XVU");

var $lUhpq = parcelRequire("lUhpq");

var $gktyQ = parcelRequire("gktyQ");

var $ca1Zm = parcelRequire("ca1Zm");

var $6GNmk = parcelRequire("6GNmk");

var $3T2Ye = parcelRequire("3T2Ye");

var $9CT95 = parcelRequire("9CT95");

var $6fdEz = parcelRequire("6fdEz");

var $8WMR9 = parcelRequire("8WMR9");

var $hSl7U = parcelRequire("hSl7U");

var $7kGnZ = parcelRequire("7kGnZ");

var $elyxq = parcelRequire("elyxq");

var $9F4ID = parcelRequire("9F4ID");

var $18W8Q = parcelRequire("18W8Q");

var $3ss0y = parcelRequire("3ss0y");

var $bNtXI = parcelRequire("bNtXI");

var $eAlzO = parcelRequire("eAlzO");

var $3KtPD = parcelRequire("3KtPD");

var $hkNW0 = parcelRequire("hkNW0");

var $1B0QU = parcelRequire("1B0QU");

var $igqAf = parcelRequire("igqAf");

var $h3WYk = parcelRequire("h3WYk");

var $dUuHj = parcelRequire("dUuHj");

var $eiK9n = parcelRequire("eiK9n");

var $4KinX = parcelRequire("4KinX");

var $d6K18 = parcelRequire("d6K18");

var $lIfPP = parcelRequire("lIfPP");

var $6IB0N = parcelRequire("6IB0N");

var $1sFpf = parcelRequire("1sFpf");

var $a2wNz = parcelRequire("a2wNz");

var $eghTD = parcelRequire("eghTD");

var $huQRU = parcelRequire("huQRU");

var $ajYJ1 = parcelRequire("ajYJ1");

var $47CVY = parcelRequire("47CVY");

var $hfeIi = parcelRequire("hfeIi");

var $hF0nU = parcelRequire("hF0nU");

var $ejDmq = parcelRequire("ejDmq");

var $difFp = parcelRequire("difFp");

var $anDMO = parcelRequire("anDMO");

var $dYbYB = parcelRequire("dYbYB");

var $dH2Tp = parcelRequire("dH2Tp");

var $ffFBX = parcelRequire("ffFBX");

var $1IKX7 = parcelRequire("1IKX7");

var $1K27j = parcelRequire("1K27j");

var $8DQ40 = parcelRequire("8DQ40");

var $hdWS0 = parcelRequire("hdWS0");

var $9MTKv = parcelRequire("9MTKv");

var $2XQq2 = parcelRequire("2XQq2");

var $58Cy7 = parcelRequire("58Cy7");

var $e1cjg = parcelRequire("e1cjg");

var $4t69d = parcelRequire("4t69d");

var $hu1w9 = parcelRequire("hu1w9");

var $akFeA = parcelRequire("akFeA");

var $cjFCA = parcelRequire("cjFCA");

var $8E1dI = parcelRequire("8E1dI");

var $3GuHG = parcelRequire("3GuHG");

var $WsHyA = parcelRequire("WsHyA");

var $6xRe5 = parcelRequire("6xRe5");

var $5eLaE = parcelRequire("5eLaE");

var $gnGkU = parcelRequire("gnGkU");

var $c74Xp = parcelRequire("c74Xp");

var $4Zw1h = parcelRequire("4Zw1h");

var $dqjth = parcelRequire("dqjth");

var $aw22a = parcelRequire("aw22a");

var $yVbxa = parcelRequire("yVbxa");

var $lYzgn = parcelRequire("lYzgn");

var $dAmDY = parcelRequire("dAmDY");

var $3MI0Z = parcelRequire("3MI0Z");

var $iYfXI = parcelRequire("iYfXI");

var $3kqBW = parcelRequire("3kqBW");

var $79qCU = parcelRequire("79qCU");

var $8brgy = parcelRequire("8brgy");

var $2fNbh = parcelRequire("2fNbh");

var $56moC = parcelRequire("56moC");

var $aNsRz = parcelRequire("aNsRz");

var $cmvi5 = parcelRequire("cmvi5");

var $hfMX7 = parcelRequire("hfMX7");

var $1zhx7 = parcelRequire("1zhx7");

var $dxMNj = parcelRequire("dxMNj");

var $hwgIz = parcelRequire("hwgIz");

var $d4tTc = parcelRequire("d4tTc");

var $Dkaoj = parcelRequire("Dkaoj");

var $hs0Ni = parcelRequire("hs0Ni");

var $8m0RN = parcelRequire("8m0RN");

var $dt3ZS = parcelRequire("dt3ZS");

var $GJOha = parcelRequire("GJOha");

var $hDU7Y = parcelRequire("hDU7Y");

var $dHqTd = parcelRequire("dHqTd");

var $9KhdI = parcelRequire("9KhdI");

var $6q1hh = parcelRequire("6q1hh");

var $7LUIt = parcelRequire("7LUIt");

var $3EMmS = parcelRequire("3EMmS");

var $4Ykyz = parcelRequire("4Ykyz");

var $4Yh3B = parcelRequire("4Yh3B");

var $5H5Rm = parcelRequire("5H5Rm");

var $dQtRM = parcelRequire("dQtRM");

var $iDxTp = parcelRequire("iDxTp");

var $75Ues = parcelRequire("75Ues");

var $jAB8i = parcelRequire("jAB8i");

var $5KvQp = parcelRequire("5KvQp");

var $3Yng9 = parcelRequire("3Yng9");

var $2B61u = parcelRequire("2B61u");

var $e04XT = parcelRequire("e04XT");

var $hGFnn = parcelRequire("hGFnn");

var $bAN0d = parcelRequire("bAN0d");

var $cLm5J = parcelRequire("cLm5J");

var $dbAmH = parcelRequire("dbAmH");

var $jPcas = parcelRequire("jPcas");

var $k7VEf = parcelRequire("k7VEf");

var $i27Sx = parcelRequire("i27Sx");

var $qjJTn = parcelRequire("qjJTn");

var $5xt55 = parcelRequire("5xt55");

var $4yINJ = parcelRequire("4yINJ");

var $bubms = parcelRequire("bubms");

var $fOrUU = parcelRequire("fOrUU");

var $dYoht = parcelRequire("dYoht");

var $9bLSq = parcelRequire("9bLSq");

var $01Za6 = parcelRequire("01Za6");

var $fMVEG = parcelRequire("fMVEG");

var $8fgeg = parcelRequire("8fgeg");

var $f7gaE = parcelRequire("f7gaE");

var $g5rwu = parcelRequire("g5rwu");

var $5fBQK = parcelRequire("5fBQK");

var $hxYI0 = parcelRequire("hxYI0");

var $dzSy7 = parcelRequire("dzSy7");

var $eKguf = parcelRequire("eKguf");

var $7vXQn = parcelRequire("7vXQn");

var $kCn5T = parcelRequire("kCn5T");

var $90Rrp = parcelRequire("90Rrp");

var $86qmt = parcelRequire("86qmt");

var $fH16o = parcelRequire("fH16o");

var $q3duL = parcelRequire("q3duL");

var $4iFpq = parcelRequire("4iFpq");

var $kvJxs = parcelRequire("kvJxs");

var $kxvlX = parcelRequire("kxvlX");

var $0e4yJ = parcelRequire("0e4yJ");

var $4mhUQ = parcelRequire("4mhUQ");

var $lcAQi = parcelRequire("lcAQi");

var $68ycU = parcelRequire("68ycU");

var $6HuHg = parcelRequire("6HuHg");

var $hxK6L = parcelRequire("hxK6L");

var $adI0E = parcelRequire("adI0E");

var $aNke7 = parcelRequire("aNke7");

var $9jp5b = parcelRequire("9jp5b");

var $1mByb = parcelRequire("1mByb");

var $izUuJ = parcelRequire("izUuJ");

var $4BdYV = parcelRequire("4BdYV");

var $69iY3 = parcelRequire("69iY3");

var $ipR0U = parcelRequire("ipR0U");

var $jovMq = parcelRequire("jovMq");

var $2UvYl = parcelRequire("2UvYl");

var $laDqO = parcelRequire("laDqO");

var $2pvey = parcelRequire("2pvey");

var $427L2 = parcelRequire("427L2");

var $jWVY2 = parcelRequire("jWVY2");

var $gCfQs = parcelRequire("gCfQs");

var $81ZCL = parcelRequire("81ZCL");

var $lgfw1 = parcelRequire("lgfw1");

var $4x45G = parcelRequire("4x45G");

var $a4nP2 = parcelRequire("a4nP2");

var $dtLGm = parcelRequire("dtLGm");

var $f6OBR = parcelRequire("f6OBR");

var $dRexn = parcelRequire("dRexn");

var $b952b = parcelRequire("b952b");

var $aZXhs = parcelRequire("aZXhs");

var $ktEDA = parcelRequire("ktEDA");

var $caoz4 = parcelRequire("caoz4");

var $5BlCA = parcelRequire("5BlCA");

var $3Hflx = parcelRequire("3Hflx");

var $bUOZo = parcelRequire("bUOZo");

var $bC98V = parcelRequire("bC98V");

var $ew7DI = parcelRequire("ew7DI");

var $dTwSZ = parcelRequire("dTwSZ");

var $hH7Cb = parcelRequire("hH7Cb");

var $2krv1 = parcelRequire("2krv1");

var $8wIny = parcelRequire("8wIny");

var $6pwY1 = parcelRequire("6pwY1");

var $gQABM = parcelRequire("gQABM");

var $9sgxL = parcelRequire("9sgxL");

var $alZMU = parcelRequire("alZMU");

var $lVyEk = parcelRequire("lVyEk");

var $6u3qv = parcelRequire("6u3qv");

var $j2SDi = parcelRequire("j2SDi");

var $e48vl = parcelRequire("e48vl");

var $jSJ1v = parcelRequire("jSJ1v");

var $fdHNd = parcelRequire("fdHNd");

var $guURi = parcelRequire("guURi");

var $6RCDC = parcelRequire("6RCDC");

var $9aEQn = parcelRequire("9aEQn");

var $gZQLD = parcelRequire("gZQLD");

var $kzcqd = parcelRequire("kzcqd");

var $duVOn = parcelRequire("duVOn");

var $lDuCa = parcelRequire("lDuCa");

var $f7vKZ = parcelRequire("f7vKZ");

var $k826a = parcelRequire("k826a");

var $avQ9D = parcelRequire("avQ9D");

var $h82Z7 = parcelRequire("h82Z7");

var $9qXuz = parcelRequire("9qXuz");

var $3HGg1 = parcelRequire("3HGg1");

var $4nXyN = parcelRequire("4nXyN");

var $jrl3R = parcelRequire("jrl3R");

var $bvhAI = parcelRequire("bvhAI");

var $3B53X = parcelRequire("3B53X");

var $anGpc = parcelRequire("anGpc");

var $glkO2 = parcelRequire("glkO2");

var $04Vlk = parcelRequire("04Vlk");

var $aI01j = parcelRequire("aI01j");

var $flsjf = parcelRequire("flsjf");

var $gm7fA = parcelRequire("gm7fA");

var $8gEiV = parcelRequire("8gEiV");

var $gbj7F = parcelRequire("gbj7F");

var $dhiyM = parcelRequire("dhiyM");

var $21AP4 = parcelRequire("21AP4");

var $infHq = parcelRequire("infHq");

var $9yqzH = parcelRequire("9yqzH");

var $gxVJf = parcelRequire("gxVJf");

var $c1v6Y = parcelRequire("c1v6Y");

var $bZEI9 = parcelRequire("bZEI9");

var $ilKWG = parcelRequire("ilKWG");

var $1EihZ = parcelRequire("1EihZ");

var $2IdR0 = parcelRequire("2IdR0");

var $cZPPs = parcelRequire("cZPPs");

var $frUin = parcelRequire("frUin");

var $1hbMK = parcelRequire("1hbMK");

var $c2KPY = parcelRequire("c2KPY");

var $6mo9H = parcelRequire("6mo9H");

var $eoIQt = parcelRequire("eoIQt");

var $kTgg2 = parcelRequire("kTgg2");

var $agsO7 = parcelRequire("agsO7");

var $9y8sW = parcelRequire("9y8sW");

var $825dq = parcelRequire("825dq");

var $h8swE = parcelRequire("h8swE");

var $gGQIR = parcelRequire("gGQIR");

var $01hnS = parcelRequire("01hnS");

var $8jDeK = parcelRequire("8jDeK");

var $64Uyh = parcelRequire("64Uyh");

var $1T4J3 = parcelRequire("1T4J3");

var $8hATp = parcelRequire("8hATp");

var $lrPAp = parcelRequire("lrPAp");

var $ceMKm = parcelRequire("ceMKm");

var $43Rln = parcelRequire("43Rln");

var $6Z4jF = parcelRequire("6Z4jF");

var $d2uL5 = parcelRequire("d2uL5");

var $2ubrr = parcelRequire("2ubrr");

var $iz3gR = parcelRequire("iz3gR");

var $ghGCX = parcelRequire("ghGCX");

var $7MpwB = parcelRequire("7MpwB");

var $pRrpu = parcelRequire("pRrpu");

var $ZVu1m = parcelRequire("ZVu1m");

var $5YggO = parcelRequire("5YggO");

var $6p9ik = parcelRequire("6p9ik");

var $SvIen = parcelRequire("SvIen");

var $g3kqr = parcelRequire("g3kqr");

var $frn0U = parcelRequire("frn0U");

var $gjuAo = parcelRequire("gjuAo");

var $lPLcB = parcelRequire("lPLcB");

var $eyDhF = parcelRequire("eyDhF");

var $bFlFq = parcelRequire("bFlFq");

var $eLT92 = parcelRequire("eLT92");

var $5nA0V = parcelRequire("5nA0V");

var $bQ0RK = parcelRequire("bQ0RK");

var $cgOe5 = parcelRequire("cgOe5");

var $2d9QY = parcelRequire("2d9QY");

var $jj70V = parcelRequire("jj70V");

var $cmIyb = parcelRequire("cmIyb");

var $4AqA1 = parcelRequire("4AqA1");

var $5qx9W = parcelRequire("5qx9W");

var $5dqn2 = parcelRequire("5dqn2");

var $3L1EU = parcelRequire("3L1EU");

var $g5olQ = parcelRequire("g5olQ");

var $ecUH3 = parcelRequire("ecUH3");

var $6okEU = parcelRequire("6okEU");

var $gAq9g = parcelRequire("gAq9g");

var $64Fhf = parcelRequire("64Fhf");

var $9YDUs = parcelRequire("9YDUs");

var $6ElYx = parcelRequire("6ElYx");

var $h3JFI = parcelRequire("h3JFI");

var $5uMDF = parcelRequire("5uMDF");

var $3RvJ0 = parcelRequire("3RvJ0");

var $3rBGh = parcelRequire("3rBGh");

var $tdrXl = parcelRequire("tdrXl");

var $5EloX = parcelRequire("5EloX");

var $7p4oW = parcelRequire("7p4oW");

var $4PsEV = parcelRequire("4PsEV");

var $GIsnE = parcelRequire("GIsnE");

var $MSc9t = parcelRequire("MSc9t");

var $bpbCg = parcelRequire("bpbCg");

var $5X0aC = parcelRequire("5X0aC");

var $fkWQj = parcelRequire("fkWQj");

var $7NO6v = parcelRequire("7NO6v");

var $gtJvE = parcelRequire("gtJvE");

var $hMqu9 = parcelRequire("hMqu9");

var $7YRoH = parcelRequire("7YRoH");

var $i0b8q = parcelRequire("i0b8q");

var $734Wz = parcelRequire("734Wz");

var $jKCJe = parcelRequire("jKCJe");

var $iJIU8 = parcelRequire("iJIU8");

var $64qpc = parcelRequire("64qpc");

var $87aC7 = parcelRequire("87aC7");

var $aAF0I = parcelRequire("aAF0I");

var $4Aamz = parcelRequire("4Aamz");

var $hPrN5 = parcelRequire("hPrN5");

var $kKEWZ = parcelRequire("kKEWZ");

var $ljItG = parcelRequire("ljItG");

var $fQyGL = parcelRequire("fQyGL");

var $ifEj3 = parcelRequire("ifEj3");

var $4CGuj = parcelRequire("4CGuj");

var $6VvYi = parcelRequire("6VvYi");

var $dSrOC = parcelRequire("dSrOC");

var $j0BAb = parcelRequire("j0BAb");

var $d7mi1 = parcelRequire("d7mi1");

var $5HfC7 = parcelRequire("5HfC7");

var $6JQwt = parcelRequire("6JQwt");

var $icwb1 = parcelRequire("icwb1");

var $egxSq = parcelRequire("egxSq");

var $lhZGg = parcelRequire("lhZGg");

var $jr5gb = parcelRequire("jr5gb");

var $7lZOe = parcelRequire("7lZOe");

var $9rVvQ = parcelRequire("9rVvQ");

var $au6vg = parcelRequire("au6vg");

var $cLamq = parcelRequire("cLamq");

var $2vHPs = parcelRequire("2vHPs");

var $hztdR = parcelRequire("hztdR");

var $6cSNh = parcelRequire("6cSNh");

var $lIPtt = parcelRequire("lIPtt");

var $cWKD0 = parcelRequire("cWKD0");

var $d0eOH = parcelRequire("d0eOH");

var $bxg3m = parcelRequire("bxg3m");

var $e6Vbw = parcelRequire("e6Vbw");

var $7LwJB = parcelRequire("7LwJB");

var $66HfJ = parcelRequire("66HfJ");

var $aDZxG = parcelRequire("aDZxG");

var $lkwO5 = parcelRequire("lkwO5");

var $7QAza = parcelRequire("7QAza");

var $5MiVl = parcelRequire("5MiVl");

var $ee5pi = parcelRequire("ee5pi");

var $hWZAC = parcelRequire("hWZAC");

var $2kXpo = parcelRequire("2kXpo");

var $fhlje = parcelRequire("fhlje");

var $8to5X = parcelRequire("8to5X");

var $9eiXm = parcelRequire("9eiXm");

var $D5QBq = parcelRequire("D5QBq");

var $hRMW9 = parcelRequire("hRMW9");

var $7B6VF = parcelRequire("7B6VF");

var $5W0wg = parcelRequire("5W0wg");

var $4eKYR = parcelRequire("4eKYR");

var $1aB8Z = parcelRequire("1aB8Z");

var $a2PeW = parcelRequire("a2PeW");

var $gsEXA = parcelRequire("gsEXA");

var $cONlw = parcelRequire("cONlw");

var $627LR = parcelRequire("627LR");

var $amBHA = parcelRequire("amBHA");

var $1XqXD = parcelRequire("1XqXD");

var $gXApH = parcelRequire("gXApH");

var $jjqkz = parcelRequire("jjqkz");

var $h4Pr8 = parcelRequire("h4Pr8");

var $28AFT = parcelRequire("28AFT");

var $dyGLN = parcelRequire("dyGLN");

var $7xqQs = parcelRequire("7xqQs");

var $g3Gvc = parcelRequire("g3Gvc");

var $3wbIE = parcelRequire("3wbIE");

var $7fwfr = parcelRequire("7fwfr");

var $peO7W = parcelRequire("peO7W");

var $gUdrp = parcelRequire("gUdrp");

var $3M4hq = parcelRequire("3M4hq");

var $drVWM = parcelRequire("drVWM");

var $f1JiD = parcelRequire("f1JiD");

var $138gn = parcelRequire("138gn");

var $gwCoT = parcelRequire("gwCoT");

var $kkXdG = parcelRequire("kkXdG");

var $bl8cB = parcelRequire("bl8cB");

var $i8buc = parcelRequire("i8buc");

var $gpVZm = parcelRequire("gpVZm");

var $1ods3 = parcelRequire("1ods3");

var $hqIff = parcelRequire("hqIff");

var $ljDIh = parcelRequire("ljDIh");

var $lAnjX = parcelRequire("lAnjX");

var $bCnWj = parcelRequire("bCnWj");

var $aQ85T = parcelRequire("aQ85T");

var $6kvQ5 = parcelRequire("6kvQ5");

var $9Dd5o = parcelRequire("9Dd5o");

var $kci7Q = parcelRequire("kci7Q");

var $5XbrB = parcelRequire("5XbrB");

var $72XXS = parcelRequire("72XXS");

var $bbdey = parcelRequire("bbdey");

var $t2WaR = parcelRequire("t2WaR");

var $yVmHw = parcelRequire("yVmHw");

var $26BGc = parcelRequire("26BGc");

var $dseRA = parcelRequire("dseRA");

var $fCX78 = parcelRequire("fCX78");

var $6NqDk = parcelRequire("6NqDk");

var $bERWs = parcelRequire("bERWs");

var $gPxpf = parcelRequire("gPxpf");

var $fLbia = parcelRequire("fLbia");

var $1Y5eu = parcelRequire("1Y5eu");

var $3FG4O = parcelRequire("3FG4O");

var $dDzIU = parcelRequire("dDzIU");

var $3SReJ = parcelRequire("3SReJ");

var $aLuho = parcelRequire("aLuho");

var $3YX4q = parcelRequire("3YX4q");

var $kEFGH = parcelRequire("kEFGH");

var $kwWQ0 = parcelRequire("kwWQ0");

var $7F7I9 = parcelRequire("7F7I9");

var $2OQWG = parcelRequire("2OQWG");

var $4eRSO = parcelRequire("4eRSO");

var $b9Dpn = parcelRequire("b9Dpn");

var $eitw0 = parcelRequire("eitw0");

var $14ooS = parcelRequire("14ooS");

var $lWR9T = parcelRequire("lWR9T");

var $6DlqX = parcelRequire("6DlqX");

var $jCfr4 = parcelRequire("jCfr4");

var $kRn5i = parcelRequire("kRn5i");

var $3NIY8 = parcelRequire("3NIY8");

var $fjYA2 = parcelRequire("fjYA2");

var $qdq3O = parcelRequire("qdq3O");

var $aY70k = parcelRequire("aY70k");

var $2wF9u = parcelRequire("2wF9u");

var $feDOq = parcelRequire("feDOq");

var $cqk4B = parcelRequire("cqk4B");

var $d66ag = parcelRequire("d66ag");

var $84EwA = parcelRequire("84EwA");

var $7dYbE = parcelRequire("7dYbE");

var $dRm2C = parcelRequire("dRm2C");

var $1Ps9S = parcelRequire("1Ps9S");

var $bRRmd = parcelRequire("bRRmd");

var $1XAMa = parcelRequire("1XAMa");

var $aA0rC = parcelRequire("aA0rC");

var $hjVS0 = parcelRequire("hjVS0");

var $jss6V = parcelRequire("jss6V");

var $1iYkP = parcelRequire("1iYkP");

var $4XUsE = parcelRequire("4XUsE");

var $bbDvZ = parcelRequire("bbDvZ");

var $e7GI8 = parcelRequire("e7GI8");

var $4Xzif = parcelRequire("4Xzif");

var $7mf3n = parcelRequire("7mf3n");

var $4VMm4 = parcelRequire("4VMm4");

var $gMkpP = parcelRequire("gMkpP");

var $gtcNN = parcelRequire("gtcNN");

var $jr7ke = parcelRequire("jr7ke");

var $hhRES = parcelRequire("hhRES");

var $8VY8F = parcelRequire("8VY8F");

var $aApqk = parcelRequire("aApqk");

var $dTkCg = parcelRequire("dTkCg");

var $eTL4x = parcelRequire("eTL4x");

var $lzLcy = parcelRequire("lzLcy");

var $cJoBA = parcelRequire("cJoBA");

var $SBgrM = parcelRequire("SBgrM");

var $cVgRQ = parcelRequire("cVgRQ");

var $8XfJX = parcelRequire("8XfJX");

var $5o5UE = parcelRequire("5o5UE");

var $2OBp2 = parcelRequire("2OBp2");

var $29XA4 = parcelRequire("29XA4");

var $aNc7A = parcelRequire("aNc7A");

var $4e4nJ = parcelRequire("4e4nJ");

var $5nU8P = parcelRequire("5nU8P");

var $kHVIE = parcelRequire("kHVIE");

var $eHeAh = parcelRequire("eHeAh");

var $9R3is = parcelRequire("9R3is");

var $lKkaY = parcelRequire("lKkaY");

var $brWuf = parcelRequire("brWuf");

var $iXsus = parcelRequire("iXsus");

var $xwXfC = parcelRequire("xwXfC");

var $3lpLH = parcelRequire("3lpLH");

var $iLmKH = parcelRequire("iLmKH");

var $kNZj9 = parcelRequire("kNZj9");

var $dCGUp = parcelRequire("dCGUp");

var $4KLVz = parcelRequire("4KLVz");

var $lYrmE = parcelRequire("lYrmE");

var $6YHWn = parcelRequire("6YHWn");

var $awOZa = parcelRequire("awOZa");

var $kZgpC = parcelRequire("kZgpC");

var $auP5Z = parcelRequire("auP5Z");

var $6un8I = parcelRequire("6un8I");

var $l1PfI = parcelRequire("l1PfI");

var $cvYE5 = parcelRequire("cvYE5");

var $2cpS3 = parcelRequire("2cpS3");

var $iuWOh = parcelRequire("iuWOh");

var $2r2Gu = parcelRequire("2r2Gu");

var $80PF8 = parcelRequire("80PF8");

var $aAIWh = parcelRequire("aAIWh");

var $5fOtJ = parcelRequire("5fOtJ");

var $gfz2f = parcelRequire("gfz2f");

var $gfW60 = parcelRequire("gfW60");

var $h51Kg = parcelRequire("h51Kg");

var $fEAJ2 = parcelRequire("fEAJ2");

var $1rMUU = parcelRequire("1rMUU");

var $36qRE = parcelRequire("36qRE");

var $c0JOH = parcelRequire("c0JOH");

var $rsO8k = parcelRequire("rsO8k");

var $5JkxV = parcelRequire("5JkxV");

var $jIBei = parcelRequire("jIBei");

var $3oSi6 = parcelRequire("3oSi6");

var $96BnX = parcelRequire("96BnX");

var $fP1EY = parcelRequire("fP1EY");

var $2yO8h = parcelRequire("2yO8h");

var $c97hk = parcelRequire("c97hk");

var $7sSEm = parcelRequire("7sSEm");

var $eaXgt = parcelRequire("eaXgt");

var $moUwl = parcelRequire("moUwl");

var $7D3Yv = parcelRequire("7D3Yv");

var $dgneZ = parcelRequire("dgneZ");

var $hRN7l = parcelRequire("hRN7l");

var $cU5zd = parcelRequire("cU5zd");

var $fSktp = parcelRequire("fSktp");

var $5TKdO = parcelRequire("5TKdO");

var $4zSYf = parcelRequire("4zSYf");

var $j175z = parcelRequire("j175z");

var $gQWOR = parcelRequire("gQWOR");

var $zaQdk = parcelRequire("zaQdk");

var $4UU5H = parcelRequire("4UU5H");

var $izdjx = parcelRequire("izdjx");

var $eWSeK = parcelRequire("eWSeK");

var $6agOS = parcelRequire("6agOS");

var $2ytxj = parcelRequire("2ytxj");

var $16Svt = parcelRequire("16Svt");

var $7m5aN = parcelRequire("7m5aN");

var $kDimk = parcelRequire("kDimk");

var $9z1Wd = parcelRequire("9z1Wd");

var $2FVZu = parcelRequire("2FVZu");

var $fQCGk = parcelRequire("fQCGk");

var $1EVpW = parcelRequire("1EVpW");

var $azyVo = parcelRequire("azyVo");

var $7wXr4 = parcelRequire("7wXr4");

var $wwgc5 = parcelRequire("wwgc5");

var $eAw5v = parcelRequire("eAw5v");

var $djlm6 = parcelRequire("djlm6");

var $3J8Cl = parcelRequire("3J8Cl");

var $kutfD = parcelRequire("kutfD");

var $2z6Z2 = parcelRequire("2z6Z2");

var $knZRG = parcelRequire("knZRG");

var $hUUCw = parcelRequire("hUUCw");

var $6B4GJ = parcelRequire("6B4GJ");

var $1kSIj = parcelRequire("1kSIj");

var $bi9fZ = parcelRequire("bi9fZ");

var $jvZP3 = parcelRequire("jvZP3");

var $711QI = parcelRequire("711QI");

var $03taV = parcelRequire("03taV");

var $kQjkp = parcelRequire("kQjkp");

var $6KvsG = parcelRequire("6KvsG");

var $efYyQ = parcelRequire("efYyQ");

var $gcVUu = parcelRequire("gcVUu");

var $dG6DF = parcelRequire("dG6DF");

var $kg7GL = parcelRequire("kg7GL");

var $aviVh = parcelRequire("aviVh");

var $i0tax = parcelRequire("i0tax");

var $1IhKQ = parcelRequire("1IhKQ");

var $dl9zj = parcelRequire("dl9zj");

var $iQsfj = parcelRequire("iQsfj");

var $3gU47 = parcelRequire("3gU47");

var $4Mj46 = parcelRequire("4Mj46");

var $9MSQj = parcelRequire("9MSQj");

var $6FBN4 = parcelRequire("6FBN4");

var $bhft0 = parcelRequire("bhft0");

var $8Yag1 = parcelRequire("8Yag1");

var $2toxI = parcelRequire("2toxI");

var $dBV2a = parcelRequire("dBV2a");

var $5xsFH = parcelRequire("5xsFH");

var $7Db7a = parcelRequire("7Db7a");

var $eFYGV = parcelRequire("eFYGV");

var $lGnoq = parcelRequire("lGnoq");

var $6cMQO = parcelRequire("6cMQO");

var $lxXtu = parcelRequire("lxXtu");

var $2l6sh = parcelRequire("2l6sh");

var $1C9Ha = parcelRequire("1C9Ha");

var $cChHY = parcelRequire("cChHY");

var $1oew5 = parcelRequire("1oew5");

var $d1sI7 = parcelRequire("d1sI7");

var $gksya = parcelRequire("gksya");

var $l0UsI = parcelRequire("l0UsI");

var $bdHl5 = parcelRequire("bdHl5");

var $5hvg3 = parcelRequire("5hvg3");

var $6oWts = parcelRequire("6oWts");

var $76RJj = parcelRequire("76RJj");

var $ikfu9 = parcelRequire("ikfu9");

var $g7fao = parcelRequire("g7fao");

var $8s6qp = parcelRequire("8s6qp");

var $qruNQ = parcelRequire("qruNQ");

var $4chTT = parcelRequire("4chTT");

var $2LfmF = parcelRequire("2LfmF");

var $gzdNI = parcelRequire("gzdNI");

var $ghTLp = parcelRequire("ghTLp");

var $ickyX = parcelRequire("ickyX");

var $cQer4 = parcelRequire("cQer4");

var $eL5iv = parcelRequire("eL5iv");

var $7MlOX = parcelRequire("7MlOX");

var $lHzMh = parcelRequire("lHzMh");

var $kYzjv = parcelRequire("kYzjv");

var $jK6bT = parcelRequire("jK6bT");

var $jbAAG = parcelRequire("jbAAG");

var $7dbQR = parcelRequire("7dbQR");

var $hvbE3 = parcelRequire("hvbE3");

var $3Jvzv = parcelRequire("3Jvzv");

var $CY8KI = parcelRequire("CY8KI");

var $glwG4 = parcelRequire("glwG4");

var $lcFGc = parcelRequire("lcFGc");

var $03CAy = parcelRequire("03CAy");

var $056cU = parcelRequire("056cU");

var $kxlGk = parcelRequire("kxlGk");

var $fMbaV = parcelRequire("fMbaV");

var $cyZLC = parcelRequire("cyZLC");

var $7PtTb = parcelRequire("7PtTb");

var $iwgxt = parcelRequire("iwgxt");

var $e99fJ = parcelRequire("e99fJ");

var $45nsl = parcelRequire("45nsl");

var $9EGBH = parcelRequire("9EGBH");

var $heIfC = parcelRequire("heIfC");

var $jejF3 = parcelRequire("jejF3");

var $eKEYN = parcelRequire("eKEYN");

var $fwjnc = parcelRequire("fwjnc");

var $1KC4N = parcelRequire("1KC4N");

var $7ApVe = parcelRequire("7ApVe");

var $41tjC = parcelRequire("41tjC");

var $3I1TD = parcelRequire("3I1TD");

var $h0ilo = parcelRequire("h0ilo");

var $k1TyW = parcelRequire("k1TyW");

var $3av4N = parcelRequire("3av4N");

var $4BuRo = parcelRequire("4BuRo");

var $6SWMv = parcelRequire("6SWMv");

var $jFY66 = parcelRequire("jFY66");

var $jPXYO = parcelRequire("jPXYO");

var $ktYro = parcelRequire("ktYro");

var $7UDCM = parcelRequire("7UDCM");

var $hDCtq = parcelRequire("hDCtq");

var $2vUs2 = parcelRequire("2vUs2");

var $bCHhM = parcelRequire("bCHhM");

var $g6Mf9 = parcelRequire("g6Mf9");

var $dR9Nr = parcelRequire("dR9Nr");

var $goreX = parcelRequire("goreX");

var $jqbKy = parcelRequire("jqbKy");

var $3eN7Y = parcelRequire("3eN7Y");

var $hjvN4 = parcelRequire("hjvN4");

var $6fHM1 = parcelRequire("6fHM1");

var $1GAqb = parcelRequire("1GAqb");

var $V3Ey7 = parcelRequire("V3Ey7");
const $ce88d0fae79c280a$export$f800556856b3f5dc = ()=>[
        (0, $UuOK7.aiAnswersRouteEntry),
        (0, $iTGOF.alertPoliciesRouteEntry),
        (0, $3Ro2a.applinksExtraAuthHealthcheckRouteEntry),
        (0, $lLZ8x.appRequestsRouteEntry),
        (0, $hHcn9.archivedIssuesRedirectRouteEntry),
        (0, $vDjHk.archivedPlansRouteEntry),
        (0, $9CxHM.archivedProjectDirectLinkRouteEntry),
        (0, $eaKG5.archivedProjectsDirectoryRouteEntry),
        (0, $9wv3p.archivedWorkItemsJsmRouteEntry),
        (0, $6DvyY.archivedWorkItemsJswCompanyRouteEntry),
        (0, $lGElM.archivedWorkItemsJswRouteEntry),
        (0, $3bc6l.archivedWorkItemsJwmRouteEntry),
        (0, $fpGzf.arjCalendarEmbedRouteEntry),
        (0, $aVGYm.arjDependenciesEmbedRouteEntry),
        (0, $2DH60.arjIncrementEmbedRouteEntry),
        (0, $7gypr.arjSettingsDependenciesLegacyRedirectRouteEntry),
        (0, $cwKGx.arjSettingsDependenciesRouteEntry),
        (0, $jZMnM.arjSettingsFinancialYearPageRouteEntry),
        (0, $dfdSu.arjSettingsLoadingLimitsLegacyRedirectRouteEntry),
        (0, $ieqGd.arjSettingsLoadingLimitsRouteEntry),
        (0, $JQ5Vt.arjSettingsPermissionsRouteEntry),
        (0, $eOPb5.arjSettingsPermissionsRouteLegacyRedirectRouteEntry),
        (0, $a5XVU.arjSummaryEmbedRouteEntry),
        (0, $lUhpq.arjTimelineEmbedRouteEntry),
        (0, $gktyQ.assetsConfigurationRouteEntry),
        (0, $ca1Zm.assetsDataManagerGettingStartedRouteEntry),
        (0, $6GNmk.assetsDataManagerObjectClassesRouteEntry),
        (0, $3T2Ye.assetsObjectRouteEntry),
        (0, $9CT95.assetsObjectTypeConfigurationRouteEntry),
        (0, $6fdEz.assetsReportsRouteEntry),
        (0, $8WMR9.assetsReportsTemplateRouteEntry),
        (0, $hSl7U.assetsReportsUnsubscribeRouteEntry),
        (0, $7kGnZ.assetsRouteEntry),
        (0, $elyxq.assetsSchemaConfigurationRouteEntry),
        (0, $9F4ID.assetsSchemaRouteEntry),
        (0, $18W8Q.assetsSearchRouteEntry),
        (0, $3ss0y.boardsDirectoryRedirectRouteEntry),
        (0, $bNtXI.boardsDirectoryRouteEntry),
        (0, $eAlzO.browseConversationsRouteEntry),
        (0, $3KtPD.browseIntentsRouteEntry),
        (0, $hkNW0.browseIssueEmbedRouteEntry),
        (0, $1B0QU.browseIssueRouteEntry),
        (0, $igqAf.browseProjectRedirectRouteEntry),
        (0, $h3WYk.browseStandardFlowsRouteEntry),
        (0, $dUuHj.classicBusinessOverviewCalendarRouteEntry),
        (0, $eiK9n.classicBusinessOverviewSummaryRouteEntry),
        (0, $4KinX.classicBusinessOverviewTimelineRouteEntry),
        (0, $d6K18.classicBusinessProformaIssueFormsDirectEmbedRouteEntry),
        (0, $lIfPP.classicBusinessProformaIssueFormsDirectRouteEntry),
        (0, $6IB0N.classicBusinessProjectApprovalsRouteEntry),
        (0, $1sFpf.classicBusinessProjectFormBuilderRouteEntry),
        (0, $a2wNz.classicBusinessProjectFormRouteEntry),
        (0, $eghTD.classicBusinessProjectFormSubmitEmbedRouteEntry),
        (0, $huQRU.classicBusinessProjectFormSubmitPublicRouteEntry),
        (0, $ajYJ1.classicBusinessProjectFormSubmitRouteEntry),
        (0, $47CVY.classicBusinessProjectPagesRouteEntry),
        (0, $hfeIi.classicBusinessProjectSampleOnboardingRouteEntry),
        (0, $hF0nU.classicBusinessProjectShortcutRouteEntry),
        (0, $ejDmq.classicBusinessProjectViewNotFoundRouteEntry),
        (0, $difFp.classicProjectSettingsDataClassificationsRouteEntry),
        (0, $anDMO.classicProjectSettingsDetailsRouteEntry),
        (0, $dYbYB.classicProjectSettingsFeaturesRouteEntry),
        (0, $dH2Tp.classicProjectSettingsIssueLayoutRouteEntry),
        (0, $ffFBX.classicProjectSettingsOpsgenieRouteEntry),
        (0, $1IKX7.classicProjectSettingsSoftwareNotificationsIssueLogsRouteEntry),
        (0, $1K27j.classicProjectSettingsSoftwareProformaEditFormsRouteEntry),
        (0, $8DQ40.classicProjectSettingsSoftwareProformaFormsRouteEntry),
        (0, $hdWS0.classicProjectSettingsSoftwareRedirectRouteEntry),
        (0, $9MTKv.classicProjectSettingsToolchainRouteEntry),
        (0, $2XQq2.classicSoftwareBacklogEmbedRouteEntry),
        (0, $58Cy7.classicSoftwareBacklogRouteEntry),
        (0, $e1cjg.classicSoftwareBoardEmbedRouteEntry),
        (0, $4t69d.classicSoftwareBoardRouteEntry),
        (0, $hu1w9.classicSoftwareBoardSettingsInsightsRapidboardBacklogRouteEntry),
        (0, $akFeA.classicSoftwareBoardSettingsInsightsRapidboardBoardRouteEntry),
        (0, $cjFCA.classicSoftwareBoardSettingsRouteEntry),
        (0, $8E1dI.cmpVelocityRouteEntry),
        (0, $3GuHG.communicationsStakeholderGroupsRouteEntry),
        (0, $WsHyA.communicationsStakeholdersRouteEntry),
        (0, $6xRe5.compassProductSettingsRouteEntry),
        (0, $5eLaE.connectGeneralInvalidRouteEntry),
        (0, $gnGkU.connectGeneralRouteEntry),
        (0, $c74Xp.connectGeneralServiceDeskProjectRouteEntry),
        (0, $4Zw1h.connectProjectRouteEntry),
        (0, $dqjth.createProjectRouteEntry),
        (0, $aw22a.customerServiceEscalationsRouteEntry),
        (0, $yVbxa.customerServiceProductsRouteEntry),
        (0, $lYzgn.customIssueRouteEntry),
        (0, $dAmDY.customPracticeQueueBoardRouteEntry),
        (0, $3MI0Z.customPracticeQueueCalendarRouteEntry),
        (0, $iYfXI.customPracticeQueueRouteEntry),
        (0, $3kqBW.customQueueBoardRouteEntry),
        (0, $79qCU.customQueueCalendarRouteEntry),
        (0, $8brgy.customQueueRouteEntry),
        (0, $2fNbh.dashboardEditRouteEntry),
        (0, $56moC.dashboardRouteEntry),
        (0, $aNsRz.dashboardsDirectoryRedirectRouteEntry),
        (0, $cmvi5.dashboardsDirectoryRouteEntry),
        (0, $hfMX7.dashboardViewEmbedRouteEntry),
        (0, $1zhx7.dashboardViewRouteEntry),
        (0, $dxMNj.dashboardWallboardRouteEntry),
        (0, $hwgIz.devopsConnectedProjectRouteEntry),
        (0, $d4tTc.digestsNotificationsPersonalSettingsRouteEntry),
        (0, $Dkaoj.emailNotificationsLogAccessRouteEntry),
        (0, $hs0Ni.eocAlertIssueSyncingCreateRouteEntry),
        (0, $8m0RN.eocAlertIssueSyncingDetailRouteEntry),
        (0, $dt3ZS.eocAlertIssueSyncingRouteEntry),
        (0, $GJOha.eocApiKeyManagementRouteEntry),
        (0, $hDU7Y.eocAssignCustomRolesRouteEntry),
        (0, $dHqTd.eocAutomationsRouteEntry),
        (0, $9KhdI.eocCustomRolesRouteEntry),
        (0, $6q1hh.eocGlobalAlertListRedirectRouteEntry),
        (0, $7LUIt.eocGlobalAlertListRouteEntry),
        (0, $3EMmS.eocGlobalAlertsDetailRouteEntry),
        (0, $4Ykyz.eocGlobalGroupDetailRouteEntry),
        (0, $4Yh3B.eocGlobalHeartbeatsRouteEntry),
        (0, $5H5Rm.eocGlobalMaintenanceRouteEntry),
        (0, $dQtRM.eocGlobalReportsHomePageNav4RouteEntry),
        (0, $iDxTp.eocGlobalReportsNav4RouteEntry),
        (0, $75Ues.eocHeartbeatsRouteEntry),
        (0, $jAB8i.eocMaintenanceRouteEntry),
        (0, $5KvQp.eocOnCallRedirectRouteEntry),
        (0, $3Yng9.eocOnCallRouteEntry),
        (0, $2B61u.eocOverviewAllTeamsRouteEntry),
        (0, $e04XT.eocOverviewRouteEntry),
        (0, $hGFnn.eocPermissionsRouteEntry),
        (0, $bAN0d.eocReportsTeamRedirectRouteEntry),
        (0, $cLm5J.eocReportsTeamRouteEntry),
        (0, $dbAmH.eocReportsUnsubscribeRouteEntry),
        (0, $jPcas.eocScheduleGlobalRouteEntry),
        (0, $k7VEf.eocTeamAlertDetailRouteEntry),
        (0, $i27Sx.eocTeamAlertIssueSyncingCreateRouteEntry),
        (0, $qjJTn.eocTeamAlertIssueSyncingDetailRouteEntry),
        (0, $5xt55.eocTeamAlertIssueSyncingRouteEntry),
        (0, $4yINJ.eocTeamAlertListRouteEntry),
        (0, $bubms.eocTeamCustomerLogsDownloadRouteEntry),
        (0, $fOrUU.eocTeamCustomerLogsRouteEntry),
        (0, $dYoht.eocTeamGroupDetailRouteEntry),
        (0, $9bLSq.eocUserNotificationsRouteEntry),
        (0, $01Za6.errorsNotFoundRouteEntry),
        (0, $fMVEG.externalImportRouteEntry),
        (0, $8fgeg.filtersDirectoryRedirectRouteEntry),
        (0, $f7gaE.filtersDirectoryRouteEntry),
        (0, $g5rwu.findAppsRouteEntry),
        (0, $5fBQK.forgeAdminRouteEntry),
        (0, $hxYI0.forgeAdminSettingsRouteEntry),
        (0, $dzSy7.forgeFieldContextualConfigurationRouteEntry),
        (0, $eKguf.forgeGlobalRouteEntry),
        (0, $7vXQn.forgePersonalSettingsRouteEntry),
        (0, $kCn5T.forgeProjectRouteEntry),
        (0, $90Rrp.forgeProjectServicedeskRouteEntry),
        (0, $86qmt.forgeServicedeskQueueRouteEntry),
        (0, $fH16o.generalPersonalSettingsRouteEntry),
        (0, $q3duL.globalEscalationsRouteEntry),
        (0, $4iFpq.globalIncomingCallDetailRouteEntry),
        (0, $kvJxs.globalIncomingCallRouteEntry),
        (0, $kxvlX.globalIntegrationCreateRouteEntry),
        (0, $0e4yJ.globalIntegrationDetailRouteEntry),
        (0, $4mhUQ.globalIntegrationListRouteEntry),
        (0, $lcAQi.globalIntegrationLogRouteEntry),
        (0, $68ycU.globalIntegrationsRouteEntry),
        (0, $6HuHg.globalIssueNavigatorBrowseIssueRedirectRouteEntry),
        (0, $hxK6L.globalMailSettingsRouteEntry),
        (0, $adI0E.globalPoliciesRouteEntry),
        (0, $aNke7.globalSettingsContactAdministratorRouteEntry),
        (0, $9jp5b.globalSettingsCustomFieldsRouteEntry),
        (0, $1mByb.globalSettingsEditPermissionSchemesRouteEntry),
        (0, $izUuJ.globalSettingsFormDataConnectionsRouteEntry),
        (0, $4BdYV.globalSettingsGlobalPermissionsRouteEntry),
        (0, $69iY3.globalSettingsIssueFieldConfigurationSchemesRouteEntry),
        (0, $ipR0U.globalSettingsIssueFieldSchemesRouteEntry),
        (0, $jovMq.globalSettingsIssueFieldScreensRouteEntry),
        (0, $2UvYl.globalSettingsIssueFieldsManagementRouteEntry),
        (0, $laDqO.globalSettingsIssueHierarchyRedirectRouteEntry),
        (0, $2pvey.globalSettingsIssueHierarchyRouteEntry),
        (0, $427L2.globalSettingsIssuesExplicitFieldAssociationRouteEntry),
        (0, $jWVY2.globalSettingsIssuesNewIssueSearchRouteEntry),
        (0, $gCfQs.globalSettingsIssuesPrioritiesRouteEntry),
        (0, $81ZCL.globalSettingsIssuesPrioritySchemesRouteEntry),
        (0, $lgfw1.globalSettingsIssueTypesRouteEntry),
        (0, $4x45G.globalSettingsIssueTypesSchemesRouteEntry),
        (0, $a4nP2.globalSettingsIssueTypesScreenSchemesRouteEntry),
        (0, $dtLGm.globalSettingsIssueWorkflow1RouteEntry),
        (0, $f6OBR.globalSettingsIssueWorkflowEditRouteEntry),
        (0, $dRexn.globalSettingsLegacyFieldLayoutRouteEntry),
        (0, $b952b.globalSettingsOptimizeFieldConfigurationSchemeRouteEntry),
        (0, $aZXhs.globalSettingsOptimizeWorkTypeSchemeRouteEntry),
        (0, $ktEDA.globalSettingsPerformanceCustomFieldRouteEntry),
        (0, $caoz4.globalSettingsPerformanceIssueArchivalRouteEntry),
        (0, $5BlCA.globalSettingsPerformanceMetricDetailRouteEntry),
        (0, $3Hflx.globalSettingsPerformanceOverviewRouteEntry),
        (0, $bUOZo.globalSettingsPerformanceProjectCleanupRouteEntry),
        (0, $bC98V.globalSettingsPerformanceProjectRoleActorRouteEntry),
        (0, $ew7DI.globalSettingsPermissionSchemesRouteEntry),
        (0, $dTwSZ.globalSettingsSystemBulkMailRouteEntry),
        (0, $hH7Cb.globalSettingsSystemUiAnnouncementBannerRouteEntry),
        (0, $2krv1.helpCenterSettingsAgentStudioActionsRouteEntry),
        (0, $8wIny.helpCenterSettingsAgentStudioChatSimulatorRouteEntry),
        (0, $6pwY1.helpCenterSettingsAgentStudioConversationReviewRouteEntry),
        (0, $gQABM.helpCenterSettingsAgentStudioHandoffRouteEntry),
        (0, $9sgxL.helpCenterSettingsAgentStudioKnowledgeRouteEntry),
        (0, $alZMU.helpCenterSettingsAgentStudioRouteEntry),
        (0, $lVyEk.helpCenterSettingsAnalyticsRouteEntry),
        (0, $6u3qv.helpCenterSettingsArticlesRouteEntry),
        (0, $j2SDi.helpCenterSettingsArticlesViewArticleRouteEntry),
        (0, $e48vl.helpCenterSettingsCreateArticleRouteEntry),
        (0, $jSJ1v.helpCenterSettingsCustomerAccessRouteEntry),
        (0, $fdHNd.helpCenterSettingsCustomerNotificationsRouteEntry),
        (0, $guURi.helpCenterSettingsDetailsRouteEntry),
        (0, $6RCDC.helpCenterSettingsEmailRouteEntry),
        (0, $9aEQn.helpCenterSettingsFormEditRouteEntry),
        (0, $gZQLD.helpCenterSettingsFormsRouteEntry),
        (0, $kzcqd.helpCenterSettingsKbRouteEntry),
        (0, $duVOn.helpCenterSettingsNotFoundRouteEntry),
        (0, $lDuCa.helpCenterSettingsServiceHubsRouteEntry),
        (0, $f7vKZ.helpCenterSettingsSupportWebsiteOverviewRouteEntry),
        (0, $k826a.helpCenterSettingsSupportWebsitePagesRouteEntry),
        (0, $avQ9D.helpCenterSettingsSupportWebsiteRouteEntry),
        (0, $h82Z7.homeOnboardingRedirectRouteEntry),
        (0, $9qXuz.homeRedirectRouteEntry),
        (0, $3HGg1.issueCreateEmbedRouteEntry),
        (0, $4nXyN.issueNavigatorGlobalJiraRouteEntry),
        (0, $jrl3R.issueNavigatorGlobalRouteEntry),
        (0, $bvhAI.issueNavigatorProjectBusinessEmbedRouteEntry),
        (0, $3B53X.issueNavigatorProjectBusinessRouteEntry),
        (0, $anGpc.issueNavigatorProjectClassicEmbedRouteEntry),
        (0, $glkO2.issueNavigatorProjectClassicRouteEntry),
        (0, $04Vlk.issueNavigatorProjectServicedeskRouteEntry),
        (0, $aI01j.issueNavigatorProjectSoftwareEmbedRouteEntry),
        (0, $flsjf.issueNavigatorProjectSoftwareRouteEntry),
        (0, $gm7fA.jiraBusinessAttachmentsRouteEntry),
        (0, $8gEiV.jiraBusinessBoardCustomEmbedRouteEntry),
        (0, $gbj7F.jiraBusinessBoardEmbedRouteEntry),
        (0, $dhiyM.jiraBusinessBoardRouteEntry),
        (0, $21AP4.jiraBusinessCalendarEmbedRouteEntry),
        (0, $infHq.jiraBusinessCalendarRouteEntry),
        (0, $9yqzH.jiraBusinessListEmbedRouteEntry),
        (0, $gxVJf.jiraBusinessListRouteEntry),
        (0, $c1v6Y.jiraBusinessOverviewRedirectRouteEntry),
        (0, $bZEI9.jiraBusinessProjectRedirectRouteEntry),
        (0, $ilKWG.jiraBusinessReportsOverviewRouteEntry),
        (0, $1EihZ.jiraBusinessSummaryEmbedRouteEntry),
        (0, $2IdR0.jiraBusinessSummaryRouteEntry),
        (0, $cZPPs.jiraBusinessTimelineEmbedRouteEntry),
        (0, $frUin.jiraBusinessTimelineRouteEntry),
        (0, $1hbMK.jiraHomeRouteEntry),
        (0, $c2KPY.jiraSearchRouteEntry),
        (0, $6mo9H.jsmBoardRouteEntry),
        (0, $eoIQt.knowledgeHubAllArticlesRouteEntry),
        (0, $kTgg2.knowledgeHubArticleEmbedEditorRouteEntry),
        (0, $agsO7.knowledgeHubArticleInCategoryRouteEntry),
        (0, $9y8sW.knowledgeHubBrowseAllArticlesRouteEntry),
        (0, $825dq.knowledgeHubBrowseAllCategoriesRouteEntry),
        (0, $h8swE.knowledgeHubBrowseViewArticleRouteEntry),
        (0, $gGQIR.knowledgeHubCategoryPageRouteEntry),
        (0, $01hnS.knowledgeHubCategoryRouteEntry),
        (0, $8jDeK.knowledgeHubDraftsRouteEntry),
        (0, $64Uyh.knowledgeHubLandingRouteEntry),
        (0, $1T4J3.knowledgeHubSearchRouteEntry),
        (0, $8hATp.knowledgeHubSetupRouteEntry),
        (0, $lrPAp.knowledgeHubSuggestedArticlesRouteEntry),
        (0, $ceMKm.landingPageRouteEntry),
        (0, $43Rln.legacyPlanPageRedirectRouteEntry),
        (0, $6Z4jF.legacyPlanReportPageRedirectRouteEntry),
        (0, $d2uL5.legacyProjectReleasesNoteConfigRouteEntry),
        (0, $2ubrr.legacyProjectReleasesNoteRouteEntry),
        (0, $iz3gR.legacyRapidBoardRouteEntry),
        (0, $ghGCX.legacyRedirectRouteEntry),
        (0, $7MpwB.loginEmbedRouteEntry),
        (0, $pRrpu.manageProjectsDirectoryRouteEntry),
        (0, $ZVu1m.notificationLogsRouteEntry),
        (0, $5YggO.notificationsPersonalSettingsRouteEntry),
        (0, $6p9ik.opsgenieScheduleRedirectRouteEntry),
        (0, $SvIen.opsgenieScheduleRouteEntry),
        (0, $g3kqr.opsNotificationsPersonalSettingsRouteEntry),
        (0, $frn0U.peopleProfilesRouteEntry),
        (0, $gjuAo.performanceRouteEntry),
        (0, $lPLcB.personalSettingsRouteEntry),
        (0, $eyDhF.piCreateIssueEmbedRouteEntry),
        (0, $bFlFq.piEditIssueEmbedRouteEntry),
        (0, $eLT92.planExportPageRouteEntry),
        (0, $5nA0V.planIncrementRouteEntry),
        (0, $bQ0RK.planIncrementsRouteEntry),
        (0, $cgOe5.planPageRouteEntry),
        (0, $2d9QY.planPageWithoutScenarioIdRouteEntry),
        (0, $jj70V.planReportPageRouteEntry),
        (0, $cmIyb.plansDirectoryRouteEntry),
        (0, $4AqA1.planSetupPageRouteEntry),
        (0, $5qx9W.planUpsellRouteEntry),
        (0, $5dqn2.planViewNotFoundRouteEntry),
        (0, $3L1EU.polarisCollectionsRouteEntry),
        (0, $g5olQ.polarisIdeasRouteEntry),
        (0, $ecUH3.polarisOnboardingRouteEntry),
        (0, $6okEU.polarisSettingsAccessRouteEntry),
        (0, $gAq9g.polarisSettingsEarlyAccessFeaturesRouteEntry),
        (0, $64Fhf.polarisSettingsFinancialYearRouteEntry),
        (0, $9YDUs.polarisSettingsGlobalFieldsRouteEntry),
        (0, $6ElYx.polarisSettingsViewBlueprintsRouteEntry),
        (0, $h3JFI.polarisUnlicensedRouteEntry),
        (0, $5uMDF.productsJcsCustomerAccessRouteEntry),
        (0, $3RvJ0.productsJcsFormFieldsRouteEntry),
        (0, $3rBGh.productsJsmAuthenticationSettingsRouteEntry),
        (0, $tdrXl.productsJsmChatopsAndVideosToolsRouteEntry),
        (0, $5EloX.productsJsmComplianceRouteEntry),
        (0, $7p4oW.productsJsmConfigurationRouteEntry),
        (0, $4PsEV.productsJsmCustomerAccessRouteEntry),
        (0, $GIsnE.productsJsmEmailRequestsRouteEntry),
        (0, $MSc9t.productsJsmFeatureUsageRouteEntry),
        (0, $bpbCg.productsJsmGlobalOpsReportsRedirectRouteEntry),
        (0, $5X0aC.productsJsmGlobalOpsReportsRouteEntry),
        (0, $fkWQj.productsJsmIncidentManagementToolsRouteEntry),
        (0, $7NO6v.productsJsmKbPermissionsRouteEntry),
        (0, $gtJvE.productsJsmOrganizationsDetailsRouteEntry),
        (0, $hMqu9.productsJsmOrganizationsRouteEntry),
        (0, $7YRoH.productsJswConfigurationRouteEntry),
        (0, $i0b8q.productsJswStorageManagementRouteEntry),
        (0, $734Wz.productsOnboardingHubRouteEntry),
        (0, $jKCJe.proformaExportRouteEntry),
        (0, $iJIU8.proformaIssueFormsGeneralRouteEntry),
        (0, $64qpc.projectComponentsRedirectRouteEntry),
        (0, $87aC7.projectComponentsRouteEntry),
        (0, $aAF0I.projectDirectoryRedirectRouteEntry),
        (0, $4Aamz.projectIssueNavigatorRouteEntry),
        (0, $hPrN5.projectNotFoundRouteEntry),
        (0, $kKEWZ.projectPagesLegacyRouteEntry),
        (0, $ljItG.projectPagesRouteEntry),
        (0, $fQyGL.projectsDirectoryLegacyPathRedirectRouteEntry),
        (0, $ifEj3.projectsDirectoryManageRedirectRouteEntry),
        (0, $4CGuj.projectsDirectoryManageRootRedirectRouteEntry),
        (0, $6VvYi.projectsDirectoryRedirectRouteEntry),
        (0, $dSrOC.projectsDirectoryRouteEntry),
        (0, $j0BAb.projectServiceDeskRouteEntry),
        (0, $d7mi1.projectSettingsAutomationCRouteEntry),
        (0, $5HfC7.projectSettingsAutomationRouteEntry),
        (0, $6JQwt.projectSettingsComponentsRouteEntry),
        (0, $icwb1.projectSettingsCoreAccessRedirectRouteEntry),
        (0, $egxSq.projectSettingsCoreAccessRouteEntry),
        (0, $lhZGg.projectSettingsCoreApprovalsRouteEntry),
        (0, $jr5gb.projectSettingsCoreAppsFieldsRouteEntry),
        (0, $7lZOe.projectSettingsCoreAppsRouteEntry),
        (0, $9rVvQ.projectSettingsCoreAutomationRouteEntry),
        (0, $au6vg.projectSettingsCoreAutomationV2RouteEntry),
        (0, $cLamq.projectSettingsCoreDataClassificationsRouteEntry),
        (0, $2vHPs.projectSettingsCoreDefaultRedirectRouteEntry),
        (0, $hztdR.projectSettingsCoreDetailsRouteEntry),
        (0, $6cSNh.projectSettingsCoreFieldsRouteEntry),
        (0, $lIPtt.projectSettingsCoreForgeAppsRouteEntry),
        (0, $cWKD0.projectSettingsCoreIssueTypesRouteEntry),
        (0, $d0eOH.projectSettingsCoreIssueTypesWorkflowRouteEntry),
        (0, $bxg3m.projectSettingsCoreNotificationsEmailRouteEntry),
        (0, $e6Vbw.projectSettingsCoreNotificationsIssueLogsRouteEntry),
        (0, $7LwJB.projectSettingsCoreNotificationsRouteEntry),
        (0, $66HfJ.projectSettingsCoreProformaJiraFormBuilderRouteEntry),
        (0, $aDZxG.projectSettingsCoreProformaProjectFormsRouteEntry),
        (0, $lkwO5.projectSettingsCustomerServiceFeaturesRouteEntry),
        (0, $7QAza.projectSettingsForgeAppsNextgenRouteEntry),
        (0, $5MiVl.projectSettingsForgeAppsRouteEntry),
        (0, $ee5pi.projectSettingsOpsgenieRouteEntry),
        (0, $hWZAC.projectSettingsServicedeskAccessRedirectRouteEntry),
        (0, $2kXpo.projectSettingsServicedeskAccessRouteEntry),
        (0, $fhlje.projectSettingsServicedeskAppsFieldsRouteEntry),
        (0, $8to5X.projectSettingsServicedeskAppsRouteEntry),
        (0, $9eiXm.projectSettingsServicedeskAutomationCopyRuleRouteEntry),
        (0, $D5QBq.projectSettingsServicedeskAutomationCreateRouteEntry),
        (0, $hRMW9.projectSettingsServicedeskAutomationEditRuleRouteEntry),
        (0, $7B6VF.projectSettingsServicedeskAutomationRouteEntry),
        (0, $5W0wg.projectSettingsServicedeskAutomationSummaryRouteEntry),
        (0, $4eKYR.projectSettingsServicedeskAutomationViewLogRouteEntry),
        (0, $1aB8Z.projectSettingsServicedeskChangeManagementRouteEntry),
        (0, $a2PeW.projectSettingsServicedeskChannelsChatRouteEntry),
        (0, $gsEXA.projectSettingsServicedeskChannelsEmailNextGenRouteEntry),
        (0, $cONlw.projectSettingsServicedeskChannelsPermissionsNextGenRouteEntry),
        (0, $627LR.projectSettingsServicedeskChannelsPortalRouteEntry),
        (0, $amBHA.projectSettingsServicedeskChannelsRouteEntry),
        (0, $1XqXD.projectSettingsServicedeskChannelsWidgetRouteEntry),
        (0, $gXApH.projectSettingsServicedeskChatRouteEntry),
        (0, $jjqkz.projectSettingsServicedeskClassicAppsRouteEntry),
        (0, $h4Pr8.projectSettingsServicedeskCustomerNotificationsRouteEntry),
        (0, $28AFT.projectSettingsServicedeskCustomerPermissionsRouteEntry),
        (0, $dyGLN.projectSettingsServicedeskDataClassificationsRouteEntry),
        (0, $7xqQs.projectSettingsServicedeskDetailsRouteEntry),
        (0, $g3Gvc.projectSettingsServicedeskEmailRouteEntry),
        (0, $3wbIE.projectSettingsServicedeskExternalLinksRouteEntry),
        (0, $7fwfr.projectSettingsServicedeskFeedbackRouteEntry),
        (0, $peO7W.projectSettingsServicedeskFieldsRouteEntry),
        (0, $gUdrp.projectSettingsServicedeskForgeAppsRouteEntry),
        (0, $3M4hq.projectSettingsServicedeskIncidentManagementRouteEntry),
        (0, $drVWM.projectSettingsServicedeskInternalNotificationsNextGenRouteEntry),
        (0, $f1JiD.projectSettingsServicedeskIssuetypesRouteEntry),
        (0, $138gn.projectSettingsServicedeskIssuetypesWorkflowRouteEntry),
        (0, $gwCoT.projectSettingsServicedeskItsmFeaturesRouteEntry),
        (0, $kkXdG.projectSettingsServicedeskItsmTicketTypeFieldsRouteEntry),
        (0, $bl8cB.projectSettingsServicedeskItsmTicketTypesConfigRouteEntry),
        (0, $i8buc.projectSettingsServicedeskJourneyConfigurationEditRouteEntry),
        (0, $gpVZm.projectSettingsServicedeskJourneyConfigurationRouteEntry),
        (0, $1ods3.projectSettingsServicedeskJourneysRouteEntry),
        (0, $hqIff.projectSettingsServicedeskKbRouteEntry),
        (0, $ljDIh.projectSettingsServicedeskLanguageKeyRouteEntry),
        (0, $lAnjX.projectSettingsServicedeskLanguageRouteEntry),
        (0, $bCnWj.projectSettingsServicedeskLegacyAutomationRedirectCopyRouteEntry),
        (0, $aQ85T.projectSettingsServicedeskLegacyAutomationRedirectCreateRouteEntry),
        (0, $6kvQ5.projectSettingsServicedeskLegacyAutomationRedirectEditRouteEntry),
        (0, $9Dd5o.projectSettingsServicedeskLegacyAutomationRedirectSummaryRouteEntry),
        (0, $kci7Q.projectSettingsServicedeskLegacyAutomationRedirectViewLogRouteEntry),
        (0, $5XbrB.projectSettingsServicedeskNotificationsCustomerNotificationsRouteEntry),
        (0, $72XXS.projectSettingsServicedeskNotificationsEmailRouteEntry),
        (0, $bbdey.projectSettingsServicedeskNotificationsInternalNotificationsRouteEntry),
        (0, $t2WaR.projectSettingsServicedeskNotificationsNotificationEmailRouteEntry),
        (0, $yVmHw.projectSettingsServicedeskNotificationsRouteEntry),
        (0, $26BGc.projectSettingsServicedeskOverviewRouteEntry),
        (0, $dseRA.projectSettingsServicedeskPortalSettingsRouteEntry),
        (0, $fCX78.projectSettingsServicedeskProformaJiraFormBuilderRouteEntry),
        (0, $6NqDk.projectSettingsServicedeskProformaProjectFormsRouteEntry),
        (0, $bERWs.projectSettingsServicedeskRedirectRouteEntry),
        (0, $gPxpf.projectSettingsServicedeskTicketTypeFieldsRouteEntry),
        (0, $fLbia.projectSettingsServicedeskTicketTypesConfigRouteEntry),
        (0, $1Y5eu.projectSettingsServicedeskUnassignedTicketTypeFieldsRouteEntry),
        (0, $3FG4O.projectSettingsServicedeskUnassignedTicketTypesConfigRouteEntry),
        (0, $dDzIU.projectSettingsServicedeskWidgetRouteEntry),
        (0, $3SReJ.projectSettingsSoftwareAccessRedirectRouteEntry),
        (0, $aLuho.projectSettingsSoftwareAccessRouteEntry),
        (0, $3YX4q.projectSettingsSoftwareAppsFieldsRouteEntry),
        (0, $kEFGH.projectSettingsSoftwareAppsRouteEntry),
        (0, $kwWQ0.projectSettingsSoftwareAutomationRouteEntry),
        (0, $7F7I9.projectSettingsSoftwareBoardsCardRouteEntry),
        (0, $2OQWG.projectSettingsSoftwareBoardsCsmRouteEntry),
        (0, $4eRSO.projectSettingsSoftwareBoardsCustomFiltersRouteEntry),
        (0, $b9Dpn.projectSettingsSoftwareBoardsRedirectRouteEntry),
        (0, $eitw0.projectSettingsSoftwareBoardsRoadmapRouteEntry),
        (0, $14ooS.projectSettingsSoftwareBoardsTimelineRouteEntry),
        (0, $lWR9T.projectSettingsSoftwareDataClassificationsRouteEntry),
        (0, $6DlqX.projectSettingsSoftwareDetailsRouteEntry),
        (0, $jCfr4.projectSettingsSoftwareFieldsRouteEntry),
        (0, $kRn5i.projectSettingsSoftwareIssuetypesRouteEntry),
        (0, $3NIY8.projectSettingsSoftwareIssuetypesWorkflowRouteEntry),
        (0, $fjYA2.projectSettingsSoftwareNextGenFeaturesRouteEntry),
        (0, $qdq3O.projectSettingsSoftwareNotificationEmailCRouteEntry),
        (0, $aY70k.projectSettingsSoftwareNotificationEmailRouteEntry),
        (0, $2wF9u.projectSettingsSoftwareNotificationsIssueLogsRouteEntry),
        (0, $feDOq.projectSettingsSoftwareNotificationsRouteEntry),
        (0, $cqk4B.projectSettingsSoftwareProformaJiraFormBuilderRouteEntry),
        (0, $d66ag.projectSettingsSoftwareProformaProjectFormsRouteEntry),
        (0, $84EwA.projectSettingsSoftwareRedirectRouteEntry),
        (0, $7dYbE.projectSettingsToolchainRouteEntry),
        (0, $dRm2C.projectSettingsVersionsRouteEntry),
        (0, $1Ps9S.projectsRedirectRouteEntry),
        (0, $bRRmd.projectVersionsRouteEntry),
        (0, $1XAMa.promotionsRouteEntry),
        (0, $aA0rC.rapidboardBacklog1RouteEntry),
        (0, $hjVS0.rapidboardLastVisitedProjectRedirectRouteEntry),
        (0, $jss6V.rapidboardReport1RouteEntry),
        (0, $1iYkP.rapidboardReportRouteEntry),
        (0, $4XUsE.rapidboardUserBacklogRouteEntry),
        (0, $bbDvZ.rapidboardUserReportRouteEntry),
        (0, $e7GI8.rapidboardUserReportsOverviewRouteEntry),
        (0, $4Xzif.roleBasedNotificationDetailRouteEntry),
        (0, $7mf3n.roleBasedNotificationsRouteEntry),
        (0, $4VMm4.rovoSearchRouteEntry),
        (0, $gMkpP.sandboxBundlerBifrostEntrypointsRouteEntry),
        (0, $gtcNN.sandboxBundlerBifrostRLLRouteEntry),
        (0, $jr7ke.sandboxBundlerRouteEntry),
        (0, $hhRES.sandboxRelayEchoPageUsingEntryPointRouteEntry),
        (0, $8VY8F.sandboxRelayEchoPageUsingRLLRouteEntry),
        (0, $aApqk.sandboxRelayJiraPageRouteEntry),
        (0, $dTkCg.secureFiltersDirectoryRedirectRouteEntry),
        (0, $eTL4x.selectedDashboardRouteEntry),
        (0, $lzLcy.servicedeskAtlassianAnalyticsRouteEntry),
        (0, $cJoBA.servicedeskCalendarRouteEntry),
        (0, $SBgrM.servicedeskChangeCalendarRouteEntry),
        (0, $cVgRQ.servicedeskCmdbAssetsGlobalConfigurationRouteEntry),
        (0, $8XfJX.servicedeskCmdbAssetsObjectRouteEntry),
        (0, $5o5UE.servicedeskCmdbAssetsObjectSchemaConfigurationRouteEntry),
        (0, $2OBp2.servicedeskCmdbAssetsObjectSchemaRouteEntry),
        (0, $29XA4.servicedeskCmdbAssetsObjectTypeConfigurationRouteEntry),
        (0, $aNc7A.servicedeskCmdbAssetsReportsRouteEntry),
        (0, $4e4nJ.servicedeskCmdbAssetsReportsTemplateRouteEntry),
        (0, $5nU8P.servicedeskCmdbAssetsReportsUnsubscribeRouteEntry),
        (0, $kHVIE.servicedeskCmdbAssetsSchemasRouteEntry),
        (0, $eHeAh.servicedeskCmdbInsightConfigureGlobalRouteEntry),
        (0, $9R3is.servicedeskCmdbInsightConfigureRouteEntry),
        (0, $lKkaY.servicedeskCmdbInsightObject4RouteEntry),
        (0, $brWuf.servicedeskCmdbInsightObjectSchemaConfigurationRouteEntry),
        (0, $iXsus.servicedeskCmdbInsightObjectSchemaRouteEntry),
        (0, $xwXfC.servicedeskCmdbInsightObjectTypeConfigurationRouteEntry),
        (0, $3lpLH.servicedeskCmdbInsightRouteEntry),
        (0, $iLmKH.servicedeskConnectProjectRouteEntry),
        (0, $kNZj9.servicedeskCreateProjectRouteEntry),
        (0, $dCGUp.servicedeskCustomerDetailsRouteEntry),
        (0, $4KLVz.servicedeskCustomersV2RouteEntry),
        (0, $lYrmE.servicedeskGettingStartedRouteEntry),
        (0, $6YHWn.servicedeskIssueRouteEntry),
        (0, $awOZa.servicedeskItsmSampleSpaceRouteEntry),
        (0, $kZgpC.servicedeskKbRequestsReports2RouteEntry),
        (0, $auP5Z.servicedeskKbRequestsReportsIssueRouteEntry),
        (0, $6un8I.servicedeskKbRequestsReportsTimeScaleRouteEntry),
        (0, $l1PfI.servicedeskOncallScheduleRouteEntry),
        (0, $cvYE5.servicedeskOrganizationDetailsRouteEntry),
        (0, $2cpS3.servicedeskOrganizationsRouteEntry),
        (0, $iuWOh.servicedeskOrganizationV2RouteEntry),
        (0, $2r2Gu.servicedeskPlaybooksEditRouteEntry),
        (0, $80PF8.servicedeskPlaybooksListRouteEntry),
        (0, $aAIWh.servicedeskPracticeEditRouteEntry),
        (0, $5fOtJ.servicedeskPracticeIssueRouteEntry),
        (0, $gfz2f.servicedeskPracticeLandingRouteEntry),
        (0, $gfW60.servicedeskPracticeManageViewRouteEntry),
        (0, $h51Kg.servicedeskPracticeNewRouteEntry),
        (0, $fEAJ2.servicedeskPracticeViewsConfigRouteEntry),
        (0, $1rMUU.servicedeskProformaIssueFormsDirectEmbedRouteEntry),
        (0, $36qRE.servicedeskProformaIssueFormsDirectRouteEntry),
        (0, $c0JOH.servicedeskProjectSummaryRouteEntry),
        (0, $rsO8k.servicedeskQueuesAddonRouteEntry),
        (0, $5JkxV.servicedeskQueuesEditRouteEntry),
        (0, $jIBei.servicedeskQueuesIssueRouteEntry),
        (0, $3oSi6.servicedeskQueuesLandingRouteEntry),
        (0, $96BnX.servicedeskQueuesManageViewRouteEntry),
        (0, $fP1EY.servicedeskQueuesNewRouteEntry),
        (0, $2yO8h.servicedeskQueuesViewsConfigRouteEntry),
        (0, $c97hk.servicedeskReports1RouteEntry),
        (0, $7sSEm.servicedeskReportsCustom4RouteEntry),
        (0, $eaXgt.servicedeskReportsCustomCreateRouteEntry),
        (0, $moUwl.servicedeskReportsCustomEditRouteEntry),
        (0, $7D3Yv.servicedeskReportsCustomIssueRouteEntry),
        (0, $dgneZ.servicedeskReportsCustomTimeScaleRouteEntry),
        (0, $hRN7l.servicedeskReportsSatisfaction2RouteEntry),
        (0, $cU5zd.servicedeskReportsSatisfactionIssueRouteEntry),
        (0, $fSktp.servicedeskReportsSatisfactionTimeScaleRouteEntry),
        (0, $5TKdO.servicedeskReportsTypeRouteEntry),
        (0, $4zSYf.servicedeskReportsWorkloadRouteEntry),
        (0, $j175z.servicedeskServiceDetailsRouteEntry),
        (0, $gQWOR.serviceDeskServiceDetailsWithoutProjectRouteEntry),
        (0, $zaQdk.servicedeskServiceModalEditRouteEntry),
        (0, $4UU5H.servicedeskServiceModalNewRouteEntry),
        (0, $izdjx.servicedeskServicesRouteEntry),
        (0, $eWSeK.serviceDeskServicesWithoutProjectRouteEntry),
        (0, $6agOS.servicedeskSlaSettingsRouteEntry),
        (0, $2ytxj.servicedeskWorkflowConfigRouteEntry),
        (0, $16Svt.settingsAutomationRouteEntry),
        (0, $7m5aN.settingsCmdbFieldConfigRouteEntry),
        (0, $kDimk.settingsOauthCredentialsRouteEntry),
        (0, $9z1Wd.settingsRouteEntry),
        (0, $2FVZu.softwareAdvancedRoadmapsGettingStartedRedirectRouteEntry),
        (0, $fQCGk.softwareBacklogEmbedRouteEntry),
        (0, $1EVpW.softwareBacklogRouteEntry),
        (0, $azyVo.softwareBoardEmbedRouteEntry),
        (0, $7wXr4.softwareBoardRouteEntry),
        (0, $wwgc5.softwareBoardViewNotFoundClassicRouteEntry),
        (0, $eAw5v.softwareBoardViewNotFoundRouteEntry),
        (0, $djlm6.softwareCalendarClassicEmbedRouteEntry),
        (0, $3J8Cl.softwareCalendarClassicRouteEntry),
        (0, $kutfD.softwareCalendarEmbedRouteEntry),
        (0, $2z6Z2.softwareCalendarRouteEntry),
        (0, $knZRG.softwareClassicProformaIssueFormsDirectEmbedRouteEntry),
        (0, $hUUCw.softwareClassicProformaIssueFormsDirectRouteEntry),
        (0, $6B4GJ.softwareCodeClassicRouteEntry),
        (0, $1kSIj.softwareCodeRouteEntry),
        (0, $bi9fZ.softwareDeploymentsClassicRouteEntry),
        (0, $jvZP3.softwareDeploymentsNextGenRouteEntry),
        (0, $711QI.softwareFormBuilderClassicRouteEntry),
        (0, $03taV.softwareFormBuilderRouteEntry),
        (0, $kQjkp.softwareFormClassicRouteEntry),
        (0, $6KvsG.softwareFormRouteEntry),
        (0, $efYyQ.softwareFormSubmitClassicPublicRouteEntry),
        (0, $gcVUu.softwareFormSubmitClassicRouteEntry),
        (0, $dG6DF.softwareFormSubmitEmbedClassicRouteEntry),
        (0, $kg7GL.softwareFormSubmitEmbedRouteEntry),
        (0, $aviVh.softwareFormSubmitPublicRouteEntry),
        (0, $i0tax.softwareFormSubmitRouteEntry),
        (0, $1IhKQ.softwareGoalsClassicRouteEntry),
        (0, $dl9zj.softwareGoalsRouteEntry),
        (0, $iQsfj.softwareInboxClassicRouteEntry),
        (0, $3gU47.softwareInboxNextGenRouteEntry),
        (0, $4Mj46.softwareIncidentsClassicRouteEntry),
        (0, $9MSQj.softwareIncidentsNextGenRouteEntry),
        (0, $6FBN4.softwareListClassicRouteEntry),
        (0, $bhft0.softwareListEmbedClassicRouteEntry),
        (0, $8Yag1.softwareListEmbedRouteEntry),
        (0, $2toxI.softwareListRouteEntry),
        (0, $dBV2a.softwareNextgenRedirectRouteEntry),
        (0, $5xsFH.softwareOnboardingRouteEntry),
        (0, $7Db7a.softwarePeriscopeClassicRouteEntry),
        (0, $eFYGV.softwarePeriscopeNextGenRouteEntry),
        (0, $lGnoq.softwarePlanCalendarRouteEntry),
        (0, $6cMQO.softwarePlanDependenciesRouteEntry),
        (0, $lxXtu.softwarePlanReleasesRouteEntry),
        (0, $2l6sh.softwarePlanSettingsAutoSchedulerRouteEntry),
        (0, $1C9Ha.softwarePlanSettingsCustomFieldsRouteEntry),
        (0, $cChHY.softwarePlanSettingsExclusionRulesRouteEntry),
        (0, $1oew5.softwarePlanSettingsFeaturesRouteEntry),
        (0, $d1sI7.softwarePlanSettingsFindYourIssueRouteEntry),
        (0, $gksya.softwarePlanSettingsIssueSourcesRouteEntry),
        (0, $l0UsI.softwarePlanSettingsPermissionsRouteEntry),
        (0, $bdHl5.softwarePlanSettingsPlanInfoRouteEntry),
        (0, $5hvg3.softwarePlanSettingsProgramBoardsRouteEntry),
        (0, $6oWts.softwarePlanSettingsRemovedIssuesRouteEntry),
        (0, $76RJj.softwarePlanSettingsSavedViewsRouteEntry),
        (0, $ikfu9.softwarePlanSettingsScenariosRouteEntry),
        (0, $g7fao.softwarePlanSettingsSchedulingRouteEntry),
        (0, $8s6qp.softwarePlanSummaryRouteEntry),
        (0, $qruNQ.softwarePlanTeamsRouteEntry),
        (0, $4chTT.softwarePlanTimelineRouteEntry),
        (0, $2LfmF.softwareProformaIssueFormsDirectEmbedRouteEntry),
        (0, $gzdNI.softwareProformaIssueFormsDirectRouteEntry),
        (0, $ghTLp.softwareReleaseNotesRouteEntry),
        (0, $ickyX.softwareReportsBurndownRouteEntry),
        (0, $cQer4.softwareReportsBurnupRouteEntry),
        (0, $eL5iv.softwareReportsControlRouteEntry),
        (0, $7MlOX.softwareReportsCumulativeRouteEntry),
        (0, $lHzMh.softwareReportsCycleTimeClassicBoardRouteEntry),
        (0, $kYzjv.softwareReportsCycleTimeClassicRouteEntry),
        (0, $jK6bT.softwareReportsCycleTimeRouteEntry),
        (0, $jbAAG.softwareReportsDeploymentFrequencyClassicBoardRouteEntry),
        (0, $7dbQR.softwareReportsDeploymentFrequencyClassicRouteEntry),
        (0, $hvbE3.softwareReportsDeploymentFrequencyRouteEntry),
        (0, $3Jvzv.softwareReportsOverviewBoardlessRouteEntry),
        (0, $CY8KI.softwareReportsOverviewRouteEntry),
        (0, $glwG4.softwareReportsRouteEntry),
        (0, $lcFGc.softwareReportsVelocityRouteEntry),
        (0, $03CAy.softwareRoadmapClassicRouteEntry),
        (0, $056cU.softwareRoadmapRedirectRouteEntry),
        (0, $kxlGk.softwareRoadmapRouteEntry),
        (0, $fMbaV.softwareSecurityClassicRouteEntry),
        (0, $cyZLC.softwareSecurityNextGenRouteEntry),
        (0, $7PtTb.softwareStaffingRouteEntry),
        (0, $iwgxt.softwareSummaryClassicRouteEntry),
        (0, $e99fJ.softwareSummaryEmbedClassicRouteEntry),
        (0, $45nsl.softwareSummaryEmbedRouteEntry),
        (0, $9EGBH.softwareSummaryRouteEntry),
        (0, $heIfC.softwareTimelineClassicRouteEntry),
        (0, $jejF3.softwareTimelineRouteEntry),
        (0, $eKEYN.softwareVersionDetailEmbedRouteEntry),
        (0, $fwjnc.softwareVersionDetailLegacyRedirectRouteEntry),
        (0, $1KC4N.softwareVersionDetailNoTabPathRedirectRouteEntry),
        (0, $7ApVe.softwareVersionDetailRouteEntry),
        (0, $41tjC.softwareViewNotFoundClassicRouteEntry),
        (0, $3I1TD.softwareViewNotFoundRouteEntry),
        (0, $h0ilo.systemConfigurationRedirectRouteEntry),
        (0, $k1TyW.systemConfigurationRouteEntry),
        (0, $3av4N.systemDashboardEditRouteEntry),
        (0, $4BuRo.teamIntegrationCreateRouteEntry),
        (0, $6SWMv.teamIntegrationDetailRouteEntry),
        (0, $jFY66.teamIntegrationListRouteEntry),
        (0, $jPXYO.teamIntegrationLogRouteEntry),
        (0, $ktYro.teamIntegrationsRouteEntry),
        (0, $7UDCM.trashedPlanDirectLinkRouteEntry),
        (0, $hDCtq.trashPlansRouteEntry),
        (0, $2vUs2.trashProjectsDirectoryRedirectRouteEntry),
        (0, $bCHhM.trashProjectsDirectoryRouteEntry),
        (0, $g6Mf9.unlockOperationsRouteEntry),
        (0, $dR9Nr.userBoardRouteEntry),
        (0, $goreX.userBoardSettingsRouteEntry),
        (0, $jqbKy.userBoardVelocityRouteEntry),
        (0, $3eN7Y.userBoardViewNotFoundRouteEntry),
        (0, $hjvN4.userSegmentationRouteEntry),
        (0, $6fHM1.viewIntentRouteEntry),
        (0, $1GAqb.viewStandardFlowRouteEntry),
        (0, $V3Ey7.whoIsOnCallRouteEntry)
    ];

});
parcelRegister("26BGc", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskOverviewRouteEntry", () => $574f0a122beb6abc$export$1f0cb137e600941a);

var $ffza4 = parcelRequire("ffza4");

var $lmyls = parcelRequire("lmyls");

var $h0bZU = parcelRequire("h0bZU");

var $7NszV = parcelRequire("7NszV");

var $bHhiy = parcelRequire("bHhiy");

var $fpjJX = parcelRequire("fpjJX");

var $8q8ki = parcelRequire("8q8ki");

var $6Z2mh = parcelRequire("6Z2mh");

var $gC5Yv = parcelRequire("gC5Yv");
const $574f0a122beb6abc$export$1f0cb137e600941a = (0, $7NszV.createEntry)((0, $8q8ki.projectSettingsServicedeskOverviewRoute), ()=>({
        group: 'project-settings-servicedesk',
        component: (0, $gC5Yv.AsyncOverviewSetting),
        layout: (0, $6Z2mh.serviceProjectLayout),
        navigation: {
            menuId: (0, $lmyls.MENU_ID).PROJECTS,
            sidebar: (0, $h0bZU.default),
            sidebarId: (0, $lmyls.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $fpjJX.getServiceDeskSettingsResources)(),
            (0, $bHhiy.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $ffza4.LazyAtlassianNavigation),
            (0, $gC5Yv.LazyOverviewSettings)
        ]
    }));

});
parcelRegister("8q8ki", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskOverviewRoute", () => $f9e896d4d174d698$export$b4043f1a1b914130);
const $f9e896d4d174d698$export$b4043f1a1b914130 = {
    name: 'project-settings-servicedesk-overview',
    // /settings/overview
    path: '/jira/servicedesk/projects/:projectKey/settings/overview',
    exact: true
};

});

parcelRegister("gC5Yv", function(module, exports) {

$parcel$export(module.exports, "LazyOverviewSettings", () => $6294d9bbdecd1714$export$ce469ceb4c68a932);
$parcel$export(module.exports, "AsyncOverviewSetting", () => $6294d9bbdecd1714$export$92888ae2bbb25072);

var $5uXOq = parcelRequire("5uXOq");

var $7yO8g = parcelRequire("7yO8g");

var $5j7Th = parcelRequire("5j7Th");

var $kxZPA = parcelRequire("kxZPA");

const $6294d9bbdecd1714$export$ce469ceb4c68a932 = (0, $kxZPA.lazyForPaint)(()=>(0, $7yO8g.markAsProductBundleReady)((parcelRequire("6crUx"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-overview/src/ui/index.tsx"
});
const $6294d9bbdecd1714$export$92888ae2bbb25072 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5j7Th.LazyPage), {
        Page: $6294d9bbdecd1714$export$ce469ceb4c68a932,
        pageId: "project-settings-overview",
        shouldShowSpinner: false
    });

});
parcelRegister("6crUx", function(module, exports) {

let $48398391760346c7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $48398391760346c7$var$load("fCic7").then(()=>parcelRequire('5F05h'));

});



parcelRegister("hhRES", function(module, exports) {

$parcel$export(module.exports, "sandboxRelayEchoPageUsingEntryPointRouteEntry", () => $23ef7703ae4d22af$export$38fc3637f21e26b2);

var $2BrOV = parcelRequire("2BrOV");

var $7NszV = parcelRequire("7NszV");

var $jra4q = parcelRequire("jra4q");

var $9CSXQ = parcelRequire("9CSXQ");

var $6LsQE = parcelRequire("6LsQE");

var $4R6GH = parcelRequire("4R6GH");

var $lkFvK = parcelRequire("lkFvK");

var $lmyls = parcelRequire("lmyls");
const $23ef7703ae4d22af$var$sandboxRelayEchoPageEntryPoint = (0, $lkFvK.createPageEntryPoint)({
    main: (0, $9CSXQ.sandboxEchoPageEntryPoint),
    // using PROJECTS as a placeholder
    topNavigationMenuId: (0, $lmyls.MENU_ID).PROJECTS
});
const $23ef7703ae4d22af$export$38fc3637f21e26b2 = (0, $7NszV.createEntry)((0, $jra4q.sandboxRelayEchoPageUsingEntryPointRoute), ()=>({
        group: 'sandbox',
        entryPoint: ()=>(0, $4R6GH.fg)('jfp-magma-support-defer') ? $23ef7703ae4d22af$var$sandboxRelayEchoPageEntryPoint : (0, $6LsQE.notFoundPageEntrypoint),
        layout: (0, $2BrOV.globalLayout),
        resources: [],
        ufoName: 'sandbox-relay-echo',
        bifrost: {
            bundling: {
                packageName: '@atlassian/jira-router-routes-sandbox-entries/src/sandboxRelayEchoPageUsingEntryPointRouteEntry.tsx',
                whichExportToUse: 'sandboxRelayEchoPageUsingEntryPointRouteEntry'
            },
            // WARNING: setting this to `true` will cause us to build & deploy the route to bifrost+tesseract instances worldwide, which is quite expensive!
            // enabled: true,
            manifestName: 'jira-spa-sandboxdemo.json'
        }
    }));

});
parcelRegister("jra4q", function(module, exports) {

$parcel$export(module.exports, "sandboxRelayEchoPageUsingEntryPointRoute", () => $d9c9711d719842a6$export$eaecd670f9df9fd6);
const $d9c9711d719842a6$export$eaecd670f9df9fd6 = {
    name: 'sandbox-relay-defer-echo',
    path: '/jira/software/sandbox/relay/echo',
    exact: true
};

});

parcelRegister("9CSXQ", function(module, exports) {

$parcel$export(module.exports, "sandboxEchoPageEntryPoint", () => $dcf81025a7e62257$export$d3ff1e280a8985f3);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $7k9VK = parcelRequire("7k9VK");

const $dcf81025a7e62257$export$d3ff1e280a8985f3 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("8Zcgn")), {
        moduleId: "73542e71",
        moduleName: "SandboxEchoPage"
    }),
    getPreloadProps: ({ tenantContext: tenantContext, context: routerContext })=>{
        return {
            queries: {
                pageQueryRef: {
                    parameters: (0, $7k9VK.default),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        enableDefer: Boolean('defer' in routerContext.query ? routerContext.query.defer === 'true' : true),
                        skipLongQuery: Boolean('skipLong' in routerContext.query ? routerContext.query.skipLong === 'true' : true)
                    },
                    options: {
                        fetchPolicy: 'store-and-network'
                    }
                }
            }
        };
    }
});

});





//# sourceMappingURL=async-route-map.1c826bb9.js.map
